
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb564"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb564"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.5";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.5" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.5";

});



parcelRegister("5N0ZI", function(module, exports) {

$parcel$export(module.exports, "FormField", () => (parcelRequire("7phmx")).default);
$parcel$export(module.exports, "TextInput", () => (parcelRequire("a7Rbr")).default);
$parcel$export(module.exports, "PhoneInput", () => (parcelRequire("lffTJ")).default);
$parcel$export(module.exports, "NationalIdInput", () => (parcelRequire("Ydgp5")).default);
$parcel$export(module.exports, "NumberInput", () => (parcelRequire("9iIGe")).default);
$parcel$export(module.exports, "MoneyInput", () => (parcelRequire("lkMIV")).default);
$parcel$export(module.exports, "Textarea", () => (parcelRequire("iygI2")).default);
$parcel$export(module.exports, "Select", () => (parcelRequire("fAR2n")).default);
$parcel$export(module.exports, "ToggleGroup", () => (parcelRequire("5Rv3V")).default);
$parcel$export(module.exports, "ChipSelector", () => (parcelRequire("bkKUS")).default);
$parcel$export(module.exports, "CardSelector", () => (parcelRequire("jIDmT")).default);
$parcel$export(module.exports, "SearchInput", () => (parcelRequire("amyVq")).default);
$parcel$export(module.exports, "Checkbox", () => (parcelRequire("9gEOi")).default);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("3GEBR")).default);
$parcel$export(module.exports, "Button", () => (parcelRequire("aJ1FU")).default);
$parcel$export(module.exports, "Badge", () => (parcelRequire("bHjRG")).default);
$parcel$export(module.exports, "Dialog", () => (parcelRequire("4fYdd")).Dialog);
$parcel$export(module.exports, "DialogTrigger", () => (parcelRequire("4fYdd")).DialogTrigger);
$parcel$export(module.exports, "DialogClose", () => (parcelRequire("4fYdd")).DialogClose);
$parcel$export(module.exports, "DialogContent", () => (parcelRequire("4fYdd")).DialogContent);
$parcel$export(module.exports, "DialogHeader", () => (parcelRequire("4fYdd")).DialogHeader);
$parcel$export(module.exports, "DialogBody", () => (parcelRequire("4fYdd")).DialogBody);
$parcel$export(module.exports, "DialogTitle", () => (parcelRequire("4fYdd")).DialogTitle);
$parcel$export(module.exports, "DialogDescription", () => (parcelRequire("4fYdd")).DialogDescription);
$parcel$export(module.exports, "DialogFooter", () => (parcelRequire("4fYdd")).DialogFooter);
$parcel$export(module.exports, "Drawer", () => (parcelRequire("beZBx")).default);
$parcel$export(module.exports, "DrawerHeader", () => (parcelRequire("beZBx")).DrawerHeader);
$parcel$export(module.exports, "DrawerBody", () => (parcelRequire("beZBx")).DrawerBody);
$parcel$export(module.exports, "DrawerFooter", () => (parcelRequire("beZBx")).DrawerFooter);
$parcel$export(module.exports, "BottomSheet", () => (parcelRequire("cZOyb")).default);
$parcel$export(module.exports, "Menu", () => (parcelRequire("bfs4Q")).default);
$parcel$export(module.exports, "TaskOverlay", () => (parcelRequire("gCvEY")).default);
$parcel$export(module.exports, "ToastProvider", () => (parcelRequire("6usBW")).ToastProvider);
$parcel$export(module.exports, "useToast", () => (parcelRequire("6usBW")).useToast);
$parcel$export(module.exports, "Spinner", () => (parcelRequire("hZDga")).Spinner);
$parcel$export(module.exports, "SessionCheck", () => (parcelRequire("fvho4")).SessionCheck);
$parcel$export(module.exports, "SessionError", () => (parcelRequire("fvho4")).SessionError);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("66joL")).default);
$parcel$export(module.exports, "SkeletonRegion", () => (parcelRequire("66joL")).SkeletonRegion);
$parcel$export(module.exports, "SkeletonText", () => (parcelRequire("66joL")).SkeletonText);
$parcel$export(module.exports, "SkeletonAvatar", () => (parcelRequire("66joL")).SkeletonAvatar);
$parcel$export(module.exports, "SkeletonButton", () => (parcelRequire("66joL")).SkeletonButton);
$parcel$export(module.exports, "SkeletonInput", () => (parcelRequire("66joL")).SkeletonInput);
$parcel$export(module.exports, "SkeletonCard", () => (parcelRequire("66joL")).SkeletonCard);
$parcel$export(module.exports, "SkeletonRow", () => (parcelRequire("66joL")).SkeletonRow);
$parcel$export(module.exports, "SkeletonTable", () => (parcelRequire("66joL")).SkeletonTable);
$parcel$export(module.exports, "SkeletonList", () => (parcelRequire("66joL")).SkeletonList);
$parcel$export(module.exports, "SkeletonTabs", () => (parcelRequire("66joL")).SkeletonTabs);
$parcel$export(module.exports, "SkeletonChart", () => (parcelRequire("66joL")).SkeletonChart);
$parcel$export(module.exports, "SkeletonForm", () => (parcelRequire("66joL")).SkeletonForm);
$parcel$export(module.exports, "SkeletonHeader", () => (parcelRequire("66joL")).SkeletonHeader);
$parcel$export(module.exports, "SkeletonFilters", () => (parcelRequire("66joL")).SkeletonFilters);
$parcel$export(module.exports, "SkeletonStats", () => (parcelRequire("66joL")).SkeletonStats);
$parcel$export(module.exports, "EmptyState", () => (parcelRequire("7gSBD")).default);
$parcel$export(module.exports, "Avatar", () => (parcelRequire("7wZCE")).default);
$parcel$export(module.exports, "avatarColor", () => (parcelRequire("7wZCE")).avatarColor);
$parcel$export(module.exports, "Card", () => (parcelRequire("g6X9N")).default);
$parcel$export(module.exports, "StatusBadge", () => (parcelRequire("7h7Jc")).default);
$parcel$export(module.exports, "KpiCard", () => (parcelRequire("lUcdx")).default);
$parcel$export(module.exports, "StatsBar", () => (parcelRequire("fkDNf")).default);
$parcel$export(module.exports, "PageHeader", () => (parcelRequire("kyZIh")).default);
$parcel$export(module.exports, "InnerPageHeader", () => (parcelRequire("jOGbh")).default);
$parcel$export(module.exports, "TopBar", () => (parcelRequire("9TQrL")).default);
$parcel$export(module.exports, "MobileHeader", () => (parcelRequire("dSwFB")).default);
$parcel$export(module.exports, "DayContextCard", () => (parcelRequire("hU4vR")).default);
$parcel$export(module.exports, "DayStatStrip", () => (parcelRequire("aM2JY")).default);
$parcel$export(module.exports, "WeekPickerSheet", () => (parcelRequire("300tQ")).default);
$parcel$export(module.exports, "ChoiceSheet", () => (parcelRequire("gJslC")).default);
$parcel$export(module.exports, "WalkInToggle", () => (parcelRequire("dyHsi")).default);
$parcel$export(module.exports, "BottomNav", () => (parcelRequire("iuHQQ")).default);
$parcel$export(module.exports, "AccountCard", () => (parcelRequire("fHxBh")).default);
$parcel$export(module.exports, "SaveBar", () => (parcelRequire("jbdF9")).default);
$parcel$export(module.exports, "SectionCard", () => (parcelRequire("eJIXW")).default);
$parcel$export(module.exports, "Table", () => (parcelRequire("jFCWB")).default);
$parcel$export(module.exports, "SegmentedControl", () => (parcelRequire("fYgeo")).default);
$parcel$export(module.exports, "Pager", () => (parcelRequire("hILSM")).default);
$parcel$export(module.exports, "ConfirmDialog", () => (parcelRequire("cjPik")).default);
$parcel$export(module.exports, "Alert", () => (parcelRequire("dOauK")).default);
$parcel$export(module.exports, "ErrorState", () => (parcelRequire("2vXUl")).default);
$parcel$export(module.exports, "IconButton", () => (parcelRequire("5MbI8")).default);
$parcel$export(module.exports, "AddTile", () => (parcelRequire("hsrVQ")).default);
$parcel$export(module.exports, "Switch", () => (parcelRequire("cT2Zr")).default);
$parcel$export(module.exports, "CollapsibleSection", () => (parcelRequire("lxEfx")).default);
$parcel$export(module.exports, "PrizeWheel", () => (parcelRequire("fW63i")).default);
$parcel$export(module.exports, "FileDropzone", () => (parcelRequire("jM6yW")).default);
$parcel$export(module.exports, "ImageStackViewer", () => (parcelRequire("bhQd4")).default);
$parcel$export(module.exports, "FilterChip", () => (parcelRequire("h4ZeB")).default);
$parcel$export(module.exports, "Sparkline", () => (parcelRequire("3Amwd")).default);
$parcel$export(module.exports, "TrendChart", () => (parcelRequire("ePaaC")).default);
$parcel$export(module.exports, "TimeRuler", () => (parcelRequire("cPdQE")).default);
$parcel$export(module.exports, "SeriesLane", () => (parcelRequire("kCQwN")).default);
$parcel$export(module.exports, "IntervalBars", () => (parcelRequire("ctU9L")).default);
$parcel$export(module.exports, "EventMarkers", () => (parcelRequire("cLQXb")).default);
$parcel$export(module.exports, "createTimeScale", () => (parcelRequire("cRX9v")).createTimeScale);
$parcel$export(module.exports, "linearTicks", () => (parcelRequire("cRX9v")).linearTicks);
$parcel$export(module.exports, "useMeasuredWidth", () => (parcelRequire("3uzzV")).default);
$parcel$export(module.exports, "useKeyboardInset", () => (parcelRequire("iK5Lj")).default);
$parcel$export(module.exports, "usePublishedHeight", () => (parcelRequire("kLmaN")).default);
$parcel$export(module.exports, "useResponsive", () => (parcelRequire("k27hS")).default);
$parcel$export(module.exports, "ChatBubble", () => (parcelRequire("fOdIP")).default);
$parcel$export(module.exports, "ChatDayDivider", () => (parcelRequire("l0ks6")).default);
$parcel$export(module.exports, "ChatComposer", () => (parcelRequire("jeN3v")).default);
$parcel$export(module.exports, "ChatThread", () => (parcelRequire("kaN2E")).default);
$parcel$export(module.exports, "JalaliDatePicker", () => (parcelRequire("4Qco3")).default);
$parcel$export(module.exports, "DateRangeFilter", () => (parcelRequire("awevB")).default);
$parcel$export(module.exports, "rangeLabelFor", () => (parcelRequire("awevB")).rangeLabelFor);
$parcel$export(module.exports, "ThemeProvider", () => (parcelRequire("1Ssl4")).default);
$parcel$export(module.exports, "useTheme", () => (parcelRequire("1Ssl4")).useTheme);
$parcel$export(module.exports, "cn", () => (parcelRequire("5JYPc")).cn);
$parcel$export(module.exports, "toEnDigits", () => (parcelRequire("5JYPc")).toEnDigits);
$parcel$export(module.exports, "setUiStrings", () => (parcelRequire("ev4PJ")).setUiStrings);
$parcel$export(module.exports, "phone", () => (parcelRequire("5AX1S")));
$parcel$export(module.exports, "nationalId", () => (parcelRequire("3tGMU")));
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/ui — the unified Parsina UI kit for all three web clients
// (doctor, clinic, patient).
//
// Canonical copy: /packages/ui (monorepo root). Each client app receives a
// synced copy at src/shared/ui via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Import everything from the barrel:
//   import { Button, TextInput, useToast } from '@parsina/ui';
// Design tokens live in the sibling package:
//   import { C, CT, statusColors } from '@parsina/tokens';
// ─────────────────────────────────────────────────────────────────────────────
// Form primitives

var $7phmx = parcelRequire("7phmx");

var $a7Rbr = parcelRequire("a7Rbr");

var $lffTJ = parcelRequire("lffTJ");

var $9sT7p = parcelRequire("9sT7p");

var $Ydgp5 = parcelRequire("Ydgp5");

var $9iIGe = parcelRequire("9iIGe");

var $lkMIV = parcelRequire("lkMIV");

var $iygI2 = parcelRequire("iygI2");

var $fAR2n = parcelRequire("fAR2n");

var $5Rv3V = parcelRequire("5Rv3V");

var $bkKUS = parcelRequire("bkKUS");

var $jIDmT = parcelRequire("jIDmT");

var $amyVq = parcelRequire("amyVq");

var $9gEOi = parcelRequire("9gEOi");

var $3GEBR = parcelRequire("3GEBR");

var $aJ1FU = parcelRequire("aJ1FU");

var $bHjRG = parcelRequire("bHjRG");

var $4fYdd = parcelRequire("4fYdd");

var $beZBx = parcelRequire("beZBx");

var $cZOyb = parcelRequire("cZOyb");

var $bfs4Q = parcelRequire("bfs4Q");

var $gCvEY = parcelRequire("gCvEY");

var $6usBW = parcelRequire("6usBW");

var $hZDga = parcelRequire("hZDga");

var $fvho4 = parcelRequire("fvho4");

var $66joL = parcelRequire("66joL");

var $7gSBD = parcelRequire("7gSBD");

var $7wZCE = parcelRequire("7wZCE");

var $2xPWT = parcelRequire("2xPWT");

var $4LQcd = parcelRequire("4LQcd");

var $g6X9N = parcelRequire("g6X9N");

var $7h7Jc = parcelRequire("7h7Jc");

var $lUcdx = parcelRequire("lUcdx");

var $fkDNf = parcelRequire("fkDNf");

var $kyZIh = parcelRequire("kyZIh");

var $jOGbh = parcelRequire("jOGbh");

var $9TQrL = parcelRequire("9TQrL");

var $dSwFB = parcelRequire("dSwFB");

var $hU4vR = parcelRequire("hU4vR");

var $aM2JY = parcelRequire("aM2JY");

var $300tQ = parcelRequire("300tQ");

var $gJslC = parcelRequire("gJslC");

var $dyHsi = parcelRequire("dyHsi");

var $2vdhF = parcelRequire("2vdhF");

var $iuHQQ = parcelRequire("iuHQQ");

var $9y25V = parcelRequire("9y25V");

var $fHxBh = parcelRequire("fHxBh");

var $fh5c7 = parcelRequire("fh5c7");

var $gehDE = parcelRequire("gehDE");

var $jbdF9 = parcelRequire("jbdF9");

var $eJIXW = parcelRequire("eJIXW");

var $jFCWB = parcelRequire("jFCWB");

var $fYgeo = parcelRequire("fYgeo");

var $hILSM = parcelRequire("hILSM");

var $cjPik = parcelRequire("cjPik");

var $dOauK = parcelRequire("dOauK");

var $2vXUl = parcelRequire("2vXUl");

var $2tqZa = parcelRequire("2tqZa");

var $coDoE = parcelRequire("coDoE");

var $fx6O8 = parcelRequire("fx6O8");

var $5MbI8 = parcelRequire("5MbI8");

var $hsrVQ = parcelRequire("hsrVQ");

var $cT2Zr = parcelRequire("cT2Zr");

var $lxEfx = parcelRequire("lxEfx");

var $fW63i = parcelRequire("fW63i");

var $jM6yW = parcelRequire("jM6yW");

var $bhQd4 = parcelRequire("bhQd4");

var $h4ZeB = parcelRequire("h4ZeB");

var $3Amwd = parcelRequire("3Amwd");

var $ePaaC = parcelRequire("ePaaC");

var $cPdQE = parcelRequire("cPdQE");

var $kCQwN = parcelRequire("kCQwN");

var $ctU9L = parcelRequire("ctU9L");

var $cLQXb = parcelRequire("cLQXb");

var $cRX9v = parcelRequire("cRX9v");

var $3uzzV = parcelRequire("3uzzV");

var $iK5Lj = parcelRequire("iK5Lj");

var $drSko = parcelRequire("drSko");

var $kLmaN = parcelRequire("kLmaN");

var $9BgRG = parcelRequire("9BgRG");

var $3EHig = parcelRequire("3EHig");

var $2sptB = parcelRequire("2sptB");

var $k27hS = parcelRequire("k27hS");

var $2u27R = parcelRequire("2u27R");

var $fOdIP = parcelRequire("fOdIP");

var $l0ks6 = parcelRequire("l0ks6");

var $jeN3v = parcelRequire("jeN3v");

var $kaN2E = parcelRequire("kaN2E");

var $4Qco3 = parcelRequire("4Qco3");

var $IZwml = parcelRequire("IZwml");

var $j9AxR = parcelRequire("j9AxR");

var $awevB = parcelRequire("awevB");

var $1Ssl4 = parcelRequire("1Ssl4");

var $5JYPc = parcelRequire("5JYPc");

var $ev4PJ = parcelRequire("ev4PJ");

var $4UJrq = parcelRequire("4UJrq");

var $hlTfq = parcelRequire("hlTfq");

var $lHVFz = parcelRequire("lHVFz");

var $5AX1S = parcelRequire("5AX1S");

var $3tGMU = parcelRequire("3tGMU");

var $eLeza = parcelRequire("eLeza");

});
parcelRegister("7phmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $221000a87dfafb8e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// The field wrapper every kit input renders through — and therefore the one
// place that decides whether this design system produces labelled controls.
//
// It used to draw the label as a `<span>`. That looks identical and is not the
// same thing: a screen reader announcing an unlabelled text box says "edit
// text, blank", `getByLabelText` cannot find the control, and clicking the
// label does not focus the field. §12.3 says all form inputs are labelled
// through `FormField` with a real `<label for>` — this is that.
//
// The association is made here rather than at the call sites, because a rule
// that depends on every caller remembering to pass an `id` is a rule that is
// half-applied within a month. `useId` supplies one, the child's own `id` wins
// if it has one, and the error/helper line is wired as `aria-describedby` so
// the reason a field is red is announced with it.
const $221000a87dfafb8e$var$FormField = ({ label: label, required: required, error: error, helperText: helperText, children: children, className: className, style: style, htmlFor: htmlFor })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const only = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) ? children : null;
    const controlId = htmlFor || only?.props?.id || (only ? `${generatedId}-control` : undefined);
    // Derived from the control's id, not the wrapper's, so a component that owns
    // its own wiring (the inputs that wrap their control in a positioning div)
    // can point at this message without asking for the id back.
    const messageId = (error || helperText) && controlId ? `${controlId}-message` : undefined;
    // `htmlFor` means the caller has already put the id on the real control.
    // Cloning here too would stamp the same id onto its wrapper — two elements,
    // one id, and the label resolves to whichever the browser sees first.
    const control = only && !htmlFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(only, {
        id: controlId,
        // Never clobber a caller's own description — join, so a field that
        // already points at a hint keeps it AND gains the error line.
        'aria-describedby': [
            only.props['aria-describedby'],
            messageId
        ].filter(Boolean).join(' ') || undefined,
        'aria-invalid': only.props['aria-invalid'] ?? (error ? true : undefined)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-1.5', className),
        style: style
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: "text-[11.5px] font-semibold text-[#5a6780] tracking-[0.01em] select-none leading-none"
    }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-destructive ms-1"
    }, "*")), control, error ? // Announced, not merely displayed: §12.3 requires validation errors to
    // reach a screen reader when they appear, and a field whose only signal
    // is a red border tells a non-sighted user nothing at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        role: "alert",
        className: "m-0 text-[11.5px] text-destructive font-medium leading-snug"
    }, error) : helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] text-muted-foreground leading-snug"
    }, helperText) : null);
};
var $221000a87dfafb8e$export$2e2bcd8739ae039 = $221000a87dfafb8e$var$FormField;

});
parcelRegister("5JYPc", function(module, exports) {

$parcel$export(module.exports, "cn", () => $42e05640dae453c1$export$1343a74baacb0543);
$parcel$export(module.exports, "toEnDigits", () => $42e05640dae453c1$export$e6aa7dbb1e28c5bd);

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
function $42e05640dae453c1$export$1343a74baacb0543(...inputs) {
    return (0, $bvcna.twMerge)((0, $9QePP.clsx)(inputs));
}
const $42e05640dae453c1$export$e6aa7dbb1e28c5bd = (str)=>String(str).replace(/[۰-۹]/g, (d)=>d.charCodeAt(0) - 0x06F0).replace(/[٠-٩]/g, (d)=>d.charCodeAt(0) - 0x0660);

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("bvcna", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNamedContainerQuery: $85fc2fe65ff21506$var$isNamedContainerQuery,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $85fc2fe65ff21506$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
module.exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
module.exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
module.exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
module.exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
module.exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
module.exports.twJoin = $85fc2fe65ff21506$var$twJoin;
module.exports.twMerge = $85fc2fe65ff21506$var$twMerge;
module.exports.validators = $85fc2fe65ff21506$var$validators;

});



parcelRegister("a7Rbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $6e2f2bccd0e2a9fb$var$TextInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, type: type = 'text', validate: validate, disabled: disabled = false, maxLength: maxLength, style: style, inputStyle: inputStyle, dir: // Unset: the field inherits the document's direction, which is what lets one
// component render a Persian and an English account. Pass dir="ltr" for a
// phone number, a code or any other Latin-digit run inside an RTL page.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: type,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        maxLength: maxLength,
        dir: dir,
        className: (0, $5JYPc.cn)('w-full h-11 px-3.5 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }));
});
$6e2f2bccd0e2a9fb$var$TextInput.displayName = 'TextInput';
var $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039 = $6e2f2bccd0e2a9fb$var$TextInput;

});

parcelRegister("lffTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f69d84dab43bb31$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $9sT7p = parcelRequire("9sT7p");

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// The one phone field. Everywhere in Parsina a human types a phone number, it types it
// here — a patient at the desk, a staff member being added, a supplier, a clinic line.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHAT IT WRITES, AND WHAT IT SHOWS — they are not the same thing, and that is the
// whole design.
//
//   `onChange` hands back **E.164 and only E.164** — `'+989121234567'`, or `''` while
//   the number is incomplete. Never an event object. The rules live in `lib/phone.js`;
//   this component owns none of them.
//
//   The BOX still shows `09121234567`, and always will. A stored `09121234567` and a
//   stored `+989121234567` render IDENTICALLY, because the draft is seeded through
//   `toNational`. Nothing on any screen changes shape on the day this ships. That is the
//   migration cushion, and it is what lets the wire format change without a coordinated
//   three-app cutover.
//
//   `showTrunk={false}` is the one opt-out: the box shows the number AFTER the dial chip
//   — `9121234567`, `2188000000` — with the trunk `0` off, because the chip already says
//   `+98` and a desk that deletes the zero is told, by the zero coming back, that its
//   edit did nothing. It changes only the SPELLING in the box: the emitted E.164 is the
//   same, a typed `0` still parses (and comes off on blur), and a stored `0…` or `+98…`
//   seeds the same trunkless draft.
//
// Why a bare string rather than the `{ target: { value } }` shim this component used to
// emit: `MoneyInput` already broke that pattern in this kit and states the rule in its
// own header — "Value in and value out are both the BARE ASCII numeric string… onChange
// is handed that string directly, not an event" — and `JalaliDatePicker` does the same.
// Entrenching a fake event in the one component whose output is a MATCHING KEY is the
// wrong direction. The second argument carries the rest: `{ ok, problem, e164, national,
// country, draft }`, for the rare caller that needs the national form or the reason.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE/DRAFT SPLIT — the subtlest thing in this file, and the thing a later
// "simplification" will break.
//
//   - The PARENT owns the canonical value (E.164). The COMPONENT owns the visible draft.
//   - The draft is seeded from the value on mount, and RE-seeded only when the `value`
//     PROP itself changed and the two no longer normalize to the same number. So typing
//     `0912` (parent holds `''`, draft holds `'0912'`, both normalize to `''`) does not
//     wipe the half-typed number; loading a patient re-seeds; a parent reset to `''`
//     clears it; and a parent that round-trips E.164 straight back never disturbs the
//     user's own typing.
//   - It NEVER calls `onChange` on mount or on a `value` prop change. These forms drive
//     `SaveBar` and dirty-tracking, and an emit-on-mount would mark every profile dirty
//     the moment it opened.
//
// Turning this into a plain controlled input wipes half-typed numbers on every keystroke
// — a regression visible only with a parent that round-trips through async state, which
// is why `PhoneInput.test.jsx` drives it from a real Host component.
//
// ═══════════════════════════════════════════════════════════════════════════════
// COUNTRY IS DERIVED, NEVER STORED.
//
// E.164 carries the country code inside the value, so `findByDialCode` recovers the
// picker on load. There is no `country_code` column, proto field or GraphQL field
// anywhere in this platform, and this change adds none: no schema change, no migration.
//
// THE PRESELECTION FOLLOWS THE LOCALE; A STORED NUMBER DOES NOT (PM-0078).
//
// An empty field preselects `countryForLocale(locale)` — Iran under `fa`, Iraq under
// `ar`, a tag's own region where it names one — so "the default is the default locale"
// and a patient from anywhere is one tap or one `+` away. A STORED value is never read
// through that preselection: an E.164 value names its own country, and a value stored
// in NATIONAL spelling (`09121234567`) is read as Iranian, always, because this field
// has only ever written E.164 and every national spelling in the platform's columns
// predates it — and those were Iranian. Read under Iraq, `09121234567` would come back
// as `+9649121234567`, the same digits and a different person.
//
// ═══════════════════════════════════════════════════════════════════════════════
// DIGITS ON SCREEN ARE THE LOCALE'S; DIGITS ON THE WIRE ARE ASCII.
//
// DESIGN_SYSTEM.md §6.4: displayed digit strings — phone included — use the locale's
// digit set "with no per-surface exceptions". This field used to render ASCII always,
// on the argument that a phone number is a KEY; the key is what is EMITTED, and that is
// still ASCII E.164. What changed is only the paint: the draft stays an ASCII string in
// state, and `localize` maps it digit-for-digit on the way to the DOM — the dial chip,
// the box, the default placeholder and the example in an error message alike. The
// mapping is one character to one character, so the caret arithmetic below (which
// counts kept characters in the ASCII draft) is untouched; `compactPhone` already folds
// whatever numerals come back in. `locale` defaults to <html lang>, as in `MoneyInput`.
// ─────────────────────────────────────────────────────────────────────────────
// Copy. The caller's props win; otherwise the kit's own words in `<html lang>`
// (lib/kitCopy.js, DESIGN.md rule 7).
//
// Five problems, not one: "invalid" alone tells nobody which digit to go looking for.
// The example is wrapped in U+2068 FSI … U+2069 PDI so an ASCII number inside a Persian
// sentence isolates itself without any CSS — the same reasoning as rule 8's LTR island,
// applied to a string rather than a box.
// ─────────────────────────────────────────────────────────────────────────────
const $5f69d84dab43bb31$var$isolate = (s)=>`\u2068${s}\u2069`;
const $5f69d84dab43bb31$var$defaultMessages = (locale)=>{
    const copy = (0, $j9AxR.kitCopy)(locale).phone;
    const isolated = (fn)=>(ctx)=>fn({
                ...ctx,
                example: $5f69d84dab43bb31$var$isolate(ctx.example)
            });
    return {
        required: copy.required,
        tooShort: isolated(copy.tooShort),
        tooLong: isolated(copy.tooLong),
        notMobile: isolated(copy.notMobile),
        invalid: copy.invalid
    };
};
/** A `Country`, an iso2 string, or nothing → a `Country`. */ const $5f69d84dab43bb31$var$asCountry = (value, fallback)=>(typeof value === 'string' ? (0, $5AX1S.findByIso2)(value) : value) || fallback;
/** The offered list: `Country` records or iso2 strings, defaulting to the whole catalog. */ function $5f69d84dab43bb31$var$resolveList(countries) {
    if (!Array.isArray(countries) || countries.length === 0) return 0, $5AX1S.COUNTRIES;
    const rows = countries.map((c)=>$5f69d84dab43bb31$var$asCountry(c, undefined)).filter(Boolean);
    return rows.length ? rows : (0, $5AX1S.COUNTRIES);
}
/**
 * What to put in the box for a value that arrived from somewhere else.
 *
 * A number becomes its national form. Anything else is shown AS STORED — and that rule
 * is load-bearing: a phone column in this platform can hold a note («تماس با منشی»), and
 * seeding an unparseable value to `''` would make the stored content vanish from the
 * field the moment the record opened, after which any save would silently wipe it.
 * Showing what is stored, emitting nothing until the user types, and letting the filter
 * strip it on the first keystroke is the honest behaviour.
 *
 * A number whose country is outside the catalog has no national form to render, so its
 * E.164 stands in — the alternative is a blank box over a real stored number.
 */ const $5f69d84dab43bb31$var$seedDraft = (parsed, value, showTrunk = true)=>parsed.ok ? $5f69d84dab43bb31$var$spellNational(parsed, showTrunk) || parsed.e164 : typeof value === 'string' ? value : '';
/**
 * `national` with the country's trunk prefix off — `'09121234567'` → `'9121234567'`.
 * Also used on a country's `example`, which is written in national form too. A string
 * that does not begin with the trunk is returned unchanged: India's example is already
 * trunkless, and a country without a trunk has nothing to take off.
 */ const $5f69d84dab43bb31$var$withoutTrunk = (national, country)=>country?.trunk && national.startsWith(country.trunk) ? national.slice(country.trunk.length) : national;
/** The national form as this field spells it: with its trunk, or without (`showTrunk`). */ const $5f69d84dab43bb31$var$spellNational = (parsed, showTrunk)=>showTrunk ? parsed.national : $5f69d84dab43bb31$var$withoutTrunk(parsed.national, parsed.country);
/**
 * The country a value arriving from STORAGE is read in. Written internationally (`+…`,
 * `00…`) it names its own country and `fallback` only matters for a dial code outside
 * the catalog; written nationally it is Iranian — see "THE PRESELECTION FOLLOWS THE
 * LOCALE" in the header. Typing never goes through here.
 */ const $5f69d84dab43bb31$var$storedCountry = (value, fallback)=>{
    const compact = (0, $5AX1S.compactPhone)(value);
    if (compact === '' || compact.startsWith('+') || compact.startsWith('00')) return fallback;
    return 0, $5AX1S.DEFAULT_COUNTRY;
};
/** The characters `compactPhone` keeps. Counting these is how the caret survives a
 *  separator being filtered out from under it. */ const $5f69d84dab43bb31$var$isKept = (ch)=>ch >= '0' && ch <= '9' || ch === '+';
const $5f69d84dab43bb31$var$countKept = (s)=>(0, $5AX1S.compactPhone)(s).length;
const $5f69d84dab43bb31$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: // Value — E.164 preferred, ANY legacy shape accepted (09…, +98…, 0098…, 98…, 9…,
// Persian/Arabic-Indic/fullwidth digits, separators, invisible marks).
value, onChange: onChange, onBlur: onBlur, // Country — `country` is controlled (pair it with `onCountryChange`),
// `defaultCountry` is the uncontrolled seed, itself defaulting to the locale's
// country (`countryForLocale`). A DEFAULT, never a lock.
country: countryProp, defaultCountry: defaultCountry, onCountryChange: onCountryChange, countries: // Narrow the offered list. Resolving to exactly ONE renders a static dial chip
// instead of a `<select>` — see below.
countries, allowLandline: // Drop the selected country's `nsnPattern` for this field: a supplier's or a
// clinic's number is an office line. Iran only, in practice.
allowLandline = false, showTrunk: // `false` spells the box without the trunk prefix — `9121234567` beside `+98`, not
// `09121234567`. Display only; what is emitted is unchanged. See the header.
showTrunk = true, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, messages: // Copy — each entry `string | (ctx) => string`, ctx = { country, countryName, example }.
messages, label: // Chrome — the same contract as TextInput.
label, countryLabel: countryLabel, required: required, error: externalError, helperText: helperText, disabled: disabled = false, className: // `className` merges onto the bordered SHELL — the element that carries the box,
// and the one a caller sizing this field inside a 170px column means. `style` is
// the FormField's and `inputStyle` the real input's, as in `MoneyInput`.
className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
// §17.2 requires a kit component to forward them, and a past bug was exactly this.
...rest }, ref)=>{
    const kit = (0, $j9AxR.kitCopy)(localeProp).phone;
    if (label === undefined) label = kit.label;
    if (countryLabel === undefined) countryLabel = kit.country;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const caret = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ASCII in state, the locale's numerals in the DOM. See the header.
    const numerals = (0, $hlTfq.numeralsFor)(localeProp || (0, $hlTfq.documentLocale)());
    const localize = (str)=>String(str ?? '').replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const options = $5f69d84dab43bb31$var$resolveList(countries);
    const preselected = defaultCountry !== undefined ? defaultCountry : (0, $5AX1S.countryForLocale)(localeProp);
    const base = $5f69d84dab43bb31$var$asCountry(countryProp !== undefined ? countryProp : preselected, options[0] || (0, $5AX1S.DEFAULT_COUNTRY));
    const shellRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const opts = {
        allowLandline: allowLandline
    };
    const spell = (p)=>$5f69d84dab43bb31$var$spellNational(p, showTrunk);
    const exampleFor = (c)=>showTrunk ? c.example : $5f69d84dab43bb31$var$withoutTrunk(c.example, c);
    // Draft and country live in ONE state object so a re-seed moves both atomically —
    // a load that changes the number and the country must never render half-applied.
    const [own, setOwn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const parsed = (0, $5AX1S.parsePhone)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, base)
        });
        return {
            draft: $5f69d84dab43bb31$var$seedDraft(parsed, value, showTrunk),
            country: parsed.ok ? parsed.country : base
        };
    });
    const country = countryProp !== undefined ? base : own.country;
    const draft = own.draft;
    // Re-seed on a `value` PROP change only. Comparing the normalized forms is what keeps
    // a parent that echoes E.164 back from rewriting what the user is still typing;
    // comparing the raw prop is what still lets a parent clear the field.
    const prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    if (prevValue.current !== value) {
        prevValue.current = value;
        const incoming = (0, $5AX1S.parsePhone)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, country)
        });
        if (incoming.e164 !== (0, $5AX1S.parsePhone)(draft, {
            ...opts,
            country: country
        }).e164) setOwn({
            draft: $5f69d84dab43bb31$var$seedDraft(incoming, value, showTrunk),
            country: incoming.ok ? incoming.country : country
        });
    }
    const parsed = (0, $5AX1S.parsePhone)(draft, {
        ...opts,
        country: country
    });
    // An empty field is never an error unless the caller says it is required. Every other
    // problem is reported as it stands — including for a stored note, which genuinely is
    // not a phone number and is never silently cleared.
    const problem = parsed.problem === 'required' && !required ? null : parsed.problem;
    const copy = {
        ...$5f69d84dab43bb31$var$defaultMessages(localeProp),
        ...messages
    };
    const entry = problem ? copy[problem] : null;
    const internalError = typeof entry === 'function' ? entry({
        country: parsed.country,
        countryName: (0, $5AX1S.countryName)(parsed.country, localeProp),
        example: localize(exampleFor(parsed.country))
    }) : entry || '';
    // On blur only (`touched`), never while typing; an external `error` always wins; and
    // the error is ADVISORY — `onChange` still fires and the value is never cleared.
    const error = externalError || (touched ? internalError : '');
    const emit = (nextDraft, nextCountry)=>{
        const next = (0, $5AX1S.parsePhone)(nextDraft, {
            ...opts,
            country: nextCountry
        });
        onChange?.(next.e164, {
            ...next,
            draft: nextDraft
        });
    };
    const handleChange = (event)=>{
        const el = event.target;
        const raw = el.value;
        // How many KEPT characters sat left of the caret. The filter removes characters, so
        // a separator typed or pasted mid-string shifts every index after it. Copied from
        // `MoneyInput.jsx`, which carries the same loop and the largest caret suite in the
        // kit; the counting is the part that has to be right.
        const keptLeft = $5f69d84dab43bb31$var$countKept(raw.slice(0, el.selectionStart ?? raw.length));
        const compact = (0, $5AX1S.compactPhone)(raw);
        const international = compact.startsWith('+') || compact.startsWith('00');
        // The picker follows an EXPLICITLY international number and nothing else. A bare
        // national number means whatever the selected country says it means, so reading a
        // country out of it would be guessing. An international number whose dial code is
        // not in the catalog leaves the picker where it was — the list is not a gate.
        let nextCountry = country;
        if (international && countryProp === undefined) {
            const claimed = (0, $5AX1S.findByDialCode)(compact.startsWith('+') ? compact.slice(1) : compact.slice(2));
            if (claimed) nextCountry = claimed;
        }
        const next = (0, $5AX1S.parsePhone)(compact, {
            ...opts,
            country: nextCountry
        });
        // What you typed stays on screen — no rewrite under the cursor — with ONE exception:
        // a number written internationally is re-spelled nationally once it resolves,
        // because the dial code is now showing in the chip beside it and printing `+98`
        // twice in one field is not what the user wrote either.
        const nextDraft = international && next.ok && next.national ? spell(next) : compact;
        let pos = 0;
        let seen = 0;
        while(pos < nextDraft.length && seen < keptLeft){
            if ($5f69d84dab43bb31$var$isKept(nextDraft[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        setOwn({
            draft: nextDraft,
            country: nextCountry
        });
        if (nextCountry !== country) onCountryChange?.(nextCountry);
        emit(nextDraft, nextCountry);
    };
    const handleCountry = (picked)=>{
        const next = $5f69d84dab43bb31$var$asCountry(picked, null);
        if (!next) return;
        // An explicit international prefix is rewritten in place; a bare national number is
        // left exactly as typed, because its MEANING changed the moment the country did.
        const compact = (0, $5AX1S.compactPhone)(draft);
        let nextDraft = draft;
        if (compact.startsWith(`+${country.dial}`)) nextDraft = `+${next.dial}${compact.slice(1 + country.dial.length)}`;
        else if (compact.startsWith(`00${country.dial}`)) nextDraft = `00${next.dial}${compact.slice(2 + country.dial.length)}`;
        setOwn({
            draft: nextDraft,
            country: next
        });
        onCountryChange?.(next);
        emit(nextDraft, next);
    };
    const handleBlur = (event)=>{
        setTouched(true);
        // The one moment where moving the caret costs nothing: a number that parses is
        // re-spelled in its national form, which is the field's confirmation that it
        // understood you. The login theme does not do this because a login field is left
        // immediately; a form field that is filled and then revisited is a different
        // surface. No emit — the canonical value has not changed.
        const spelled = parsed.ok ? spell(parsed) : '';
        if (spelled && spelled !== draft) setOwn((s)=>({
                ...s,
                draft: spelled
            }));
        onBlur?.(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (caret.current != null && innerRef.current) {
            innerRef.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const setRefs = (node)=>{
        innerRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    // A list that resolves to exactly one country gets a static chip, not a picker with
    // a single row: no fake choice, no tab stop, and — the practical reason — it is what
    // keeps the whole field inside the 170px and 160px boxes `SetupViews.jsx` wraps it
    // in, and off the ~150px clipping `ProfileSection.jsx` records in its own comment.
    // Every other field gets `CountryPicker`: flag, dial code, a searchable list. The
    // flags are images, never emoji (rule 10) — see that file's header.
    const single = options.length === 1;
    const testid = rest['data-testid'];
    // The error/helper line, JOINED to whatever the caller already pointed the field at —
    // never replacing it. `FormField` is passed `htmlFor`, which tells it this component
    // owns its own aria wiring, so its own join (see FormField) does not run for this
    // field and this is the only place the two ids can meet.
    //
    // Written as one value rather than an attribute before `{...rest}`, because that order
    // means a caller's `aria-describedby` OVERWRITES the message id: the field goes red,
    // and a screen reader reads the caller's hint and never says why. `MoneyInput` already
    // does it this way, for the same reason.
    const describedBy = [
        rest['aria-describedby'],
        error || helperText ? `${controlId}-message` : null
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: (0, $5JYPc.cn)('flex items-center h-11 rounded-lg overflow-hidden bg-white border-[1.5px]', 'transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus-within:shadow-ring-red' : 'border-border focus-within:border-primary focus-within:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        className: "flex items-center w-full h-full [unicode-bidi:isolate]"
    }, single ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 font-sans text-[13.5px] text-muted-foreground select-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.Flag), {
        iso2: country.iso2
    }), localize(`+${country.dial}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.default), {
        value: country,
        // A number pasted from outside the offered list still selects its own
        // country — validation must be right even where the list is narrowed —
        // so the picker always offers the current row, even when not asked for.
        countries: options,
        onSelect: handleCountry,
        locale: localeProp,
        label: countryLabel,
        disabled: disabled,
        anchorRef: shellRef,
        "data-testid": testid ? `${testid}-country` : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "w-px h-5 shrink-0 bg-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-invalid": error ? true : undefined,
        ...rest,
        // A caller's placeholder is an example NUMBER like the default, and the
        // catalogues spell it in ASCII as often as not — so it gets the page's
        // numerals too, rather than being the one Latin run left in the field.
        placeholder: localize(rest.placeholder ?? exampleFor(country)),
        // After `{...rest}`: the joined value is the one that must win, and it
        // already contains the caller's own.
        "aria-describedby": describedBy,
        ref: setRefs,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel",
        value: localize(draft),
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        // The DOM `maxLength={11}` is gone: one attribute cannot express both a
        // national and an international shape, and 11 silently truncated every
        // number written as `+98…`. 20 is a cap no real number reaches after
        // filtering.
        maxLength: 20,
        className: (0, $5JYPc.cn)('flex-1 min-w-0 w-full h-full ps-2.5 pe-3.5 bg-transparent border-0 outline-none', 'font-sans text-[13.5px] text-foreground tracking-[0.5px]', 'disabled:cursor-not-allowed disabled:bg-transparent'),
        style: inputStyle
    }))));
});
$5f69d84dab43bb31$var$PhoneInput.displayName = 'PhoneInput';
var $5f69d84dab43bb31$export$2e2bcd8739ae039 = $5f69d84dab43bb31$var$PhoneInput;

});
parcelRegister("9sT7p", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $7801a9372e554ab2$export$48ea269755562084);
$parcel$export(module.exports, "default", () => $7801a9372e554ab2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $5AX1S = parcelRequire("5AX1S");

var $fMnXH = parcelRequire("fMnXH");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// CountryPicker — the country half of `PhoneInput`: a button showing the flag and the
// dial code, opening a searchable, flagged list (PM-0078).
//
// PORTED from the sign-in theme (`sso/parsina.keycloakify/src/login/components/
// CountryPicker.tsx`, 6c0f939), so a doctor finds their country the same way when
// signing in and when a desk registers them. Same contract: a combobox in the WAI-ARIA
// sense — the search box owns focus and points at the active row with
// `aria-activedescendant`, so a screen reader announces each row as the arrows move.
// Search matches a name in ALL three languages plus the dial code in any digit set: a
// Persian reader may still type "UAE", and «+۹۷۱» must find it.
//
// WHY NOT THE NATIVE <select> THIS REPLACED. It could not show flags — <option> takes no
// markup — and on Chrome/Edge for Windows its open list inherited the transparent face
// and showed blank rows (the theme hit both).
//
// FLAGS ARE IMAGES, NOT EMOJI. DESIGN.md rule 10 still holds: an emoji flag is drawn by
// the OS and Windows draws none. These are the theme's flag-icons, rasterised into
// `lib/flags.js` — a named exception in DESIGN_SYSTEM.md §15.
//
// WHERE THE LIST RENDERS — the one subtle thing here.
//   - On a page: portaled to <body>, `position: fixed`, so the field's own
//     `overflow: hidden` shell and a narrow sidebar card cannot clip it.
//   - Inside a dialog or a sheet (`[role="dialog"]`): portaled INTO that dialog,
//     `position: absolute`. A modal Radix dialog sets `pointer-events: none` on <body>
//     and yanks focus back from anything outside it, so a search box portaled to <body>
//     could never be typed into (JalaliDatePicker documents the same trap, and avoids
//     typing in its popup for that reason). Inside the dialog it is in the focus scope,
//     it is not an outside click, and the kit BottomSheet's Tab trap includes it.
//   z 9999 — the `JalaliDatePicker` popup's rung of DESIGN_SYSTEM.md §9.4: a field's
//   popup must sit above the Dialog (1100) the field is in.
// ─────────────────────────────────────────────────────────────────────────────
const $7801a9372e554ab2$var$Z = 9999;
const $7801a9372e554ab2$var$GAP = 6;
const $7801a9372e554ab2$var$EDGE = 8;
const $7801a9372e554ab2$var$PANEL_WIDTH = 300;
const $7801a9372e554ab2$var$LIST_MAX = 280;
function $7801a9372e554ab2$export$48ea269755562084({ iso2: iso2, size: size = 20 }) {
    const src = (0, $fMnXH.flagUrl)(iso2);
    const box = {
        width: size,
        height: Math.round(size * 3 / 4),
        borderRadius: 2,
        flexShrink: 0 /* a flag's own corner, not a token radius */ 
    };
    if (!src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            ...box,
            display: 'inline-block',
            background: (0, $jTCZr.C).border
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: "",
        "aria-hidden": "true",
        width: box.width,
        height: box.height,
        style: {
            ...box,
            display: 'block',
            objectFit: 'cover',
            boxShadow: `0 0 0 1px ${(0, $jTCZr.C).border}`
        }
    });
}
const $7801a9372e554ab2$var$sameCountry = (a, b)=>a?.iso2 === b?.iso2;
function $7801a9372e554ab2$export$3abcf2ef1ee51ab5({ value: value, onSelect: onSelect, countries: // The offered rows; the selected one is always offered even when narrowed out.
countries = (0, $5AX1S.COUNTRIES), locale: localeProp, label: label, disabled: disabled = false, // Where the panel is measured from — the whole field shell, so the list lines up
// with the box rather than with the 70px button. Defaults to the button.
anchorRef: anchorProp, showDial: // `false` shows the country's two-letter code instead of its dial code — for a
// field whose country is not a phone prefix (NationalIdInput).
showDial = true, 'data-testid': testid }) {
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const copy = (0, $j9AxR.kitCopy)(localeProp).phone;
    const ariaLabel = label ?? copy.country;
    const numerals = (0, $hlTfq.numeralsFor)(locale);
    const localize = (s)=>String(s).replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const rtl = [
        'fa',
        'ar'
    ].includes(String(locale).split('-')[0]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [host, setHost] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const listId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const optionId = (iso2)=>`${listId}-${iso2}`;
    // The locale's own country first (the answer for nearly every user), the rest in the
    // reader's alphabet.
    const ordered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rows = countries.some((c)=>$7801a9372e554ab2$var$sameCountry(c, value)) || !value ? countries : [
            value,
            ...countries
        ];
        const home = (0, $5AX1S.countryForLocale)(locale);
        const collator = new Intl.Collator(locale);
        const first = rows.filter((c)=>$7801a9372e554ab2$var$sameCountry(c, home));
        const rest = rows.filter((c)=>!$7801a9372e554ab2$var$sameCountry(c, home)).sort((a, b)=>collator.compare((0, $5AX1S.countryName)(a, locale), (0, $5AX1S.countryName)(b, locale)));
        return [
            ...first,
            ...rest
        ];
    }, [
        countries,
        value,
        locale
    ]);
    const matches = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const needle = (0, $5AX1S.foldDigits)(query).trim().toLowerCase().replace(/^\+/, '');
        if (!needle) return ordered;
        return ordered.filter((c)=>c.dial.startsWith(needle) || c.iso2.toLowerCase() === needle || [
                c.en,
                c.fa,
                c.ar
            ].some((n)=>n && n.toLowerCase().includes(needle)));
    }, [
        ordered,
        query
    ]);
    const show = ()=>{
        if (disabled) return;
        setQuery('');
        setActive(Math.max(ordered.findIndex((c)=>$7801a9372e554ab2$var$sameCountry(c, value)), 0));
        setOpen(true);
    };
    const hide = (returnFocus)=>{
        setOpen(false);
        if (returnFocus) buttonRef.current?.focus();
    };
    const choose = (country)=>{
        onSelect?.(country);
        hide(true);
    };
    // Place the panel against the anchor — in <body> with fixed coordinates, or inside
    // the enclosing dialog with coordinates relative to it (see the header).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const anchor = anchorProp?.current || buttonRef.current;
        const dialog = anchor?.closest?.('[role="dialog"]') || null;
        setHost(dialog || document.body);
        const place = ()=>{
            const a = (anchorProp?.current || buttonRef.current)?.getBoundingClientRect();
            if (!a) return;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const width = Math.min(Math.max(a.width, $7801a9372e554ab2$var$PANEL_WIDTH), vw - $7801a9372e554ab2$var$EDGE * 2);
            // The button sits at the LEFT of the field in every direction (the phone run is
            // an LTR island), so the panel lines up with the field's left edge.
            const left = Math.min(Math.max($7801a9372e554ab2$var$EDGE, a.left), vw - width - $7801a9372e554ab2$var$EDGE);
            const below = vh - a.bottom - $7801a9372e554ab2$var$EDGE * 2;
            const above = a.top - $7801a9372e554ab2$var$EDGE * 2;
            const up = below < 220 && above > below;
            const listMax = Math.max(120, Math.min($7801a9372e554ab2$var$LIST_MAX, (up ? above : below) - 60));
            const top = up ? null : a.bottom + $7801a9372e554ab2$var$GAP;
            const bottom = up ? a.top - $7801a9372e554ab2$var$GAP : null;
            if (!dialog) {
                setPos({
                    position: 'fixed',
                    left: left,
                    width: width,
                    listMax: listMax,
                    top: top,
                    bottomFromTop: bottom,
                    up: up
                });
                return;
            }
            // Relative to the dialog's padding box, scrolled with its content.
            const d = dialog.getBoundingClientRect();
            const bx = dialog.clientLeft || 0;
            const by = dialog.clientTop || 0;
            setPos({
                position: 'absolute',
                left: left - d.left - bx + dialog.scrollLeft,
                width: width,
                listMax: listMax,
                top: top == null ? null : top - d.top - by + dialog.scrollTop,
                bottomFromTop: bottom == null ? null : bottom - d.top - by + dialog.scrollTop,
                up: up
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorProp
    ]);
    // Focus the search box once the panel exists.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && pos) searchRef.current?.focus({
            preventScroll: true
        });
    }, [
        open,
        pos != null
    ]);
    // Keep the active row in view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const row = matches[active];
        if (row) document.getElementById(optionId(row.iso2))?.scrollIntoView?.({
            block: 'nearest'
        });
    }, [
        open,
        active,
        matches
    ]);
    // A press anywhere else closes it, the way a native list does.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target) || buttonRef.current?.contains(e.target)) return;
            hide(false);
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
        };
    }, [
        open
    ]);
    const onSearchKey = (e)=>{
        const last = matches.length - 1;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setActive((i)=>i >= last ? 0 : i + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setActive((i)=>i <= 0 ? last : i - 1);
                break;
            case 'Home':
                e.preventDefault();
                setActive(0);
                break;
            case 'End':
                e.preventDefault();
                setActive(last);
                break;
            case 'Enter':
                // Never submit the surrounding form from inside the picker.
                e.preventDefault();
                if (matches[active]) choose(matches[active]);
                break;
            case 'Escape':
                // Closes the list, not the dialog or sheet the field sits in.
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent?.stopImmediatePropagation?.();
                hide(true);
                break;
            case 'Tab':
                hide(false);
                break;
            default:
        }
    };
    const onButtonKey = (e)=>{
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            show();
        }
    };
    const activeRow = open ? matches[active] : undefined;
    const country = value || ordered[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: buttonRef,
        disabled: disabled,
        "aria-label": `${ariaLabel}: ${(0, $5AX1S.countryName)(country, locale)}`,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": open ? listId : undefined,
        "data-testid": testid,
        "data-country": country?.iso2,
        onClick: ()=>open ? hide(false) : show(),
        onKeyDown: onButtonKey,
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 bg-transparent border-0 font-sans text-[13.5px] text-muted-foreground cursor-pointer select-none disabled:cursor-not-allowed outline-none focus-visible:bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
        iso2: country?.iso2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, showDial ? localize(`+${country?.dial ?? ''}`) : country?.iso2 ?? ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "12",
        height: "12",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6 9 6 6 6-6"
    }))), open && pos && host && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        "data-jalali-popup": "",
        "data-testid": testid ? `${testid}-panel` : undefined,
        dir: rtl ? 'rtl' : 'ltr',
        style: {
            position: pos.position,
            left: pos.left,
            width: pos.width,
            ...pos.up ? {
                top: pos.bottomFromTop,
                transform: 'translateY(-100%)'
            } : {
                top: pos.top
            },
            zIndex: $7801a9372e554ab2$var$Z,
            background: 'white',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: (0, $jTCZr.SHADOW).floating,
            padding: 6,
            boxSizing: 'border-box',
            pointerEvents: 'auto',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '0 10px',
            height: 40,
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.C).bg,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        style: {
            color: (0, $jTCZr.C).textMuted,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m20 20-3.5-3.5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: searchRef,
        type: "search",
        role: "combobox",
        "aria-expanded": "true",
        "aria-controls": listId,
        "aria-autocomplete": "list",
        "aria-activedescendant": activeRow ? optionId(activeRow.iso2) : undefined,
        "aria-label": copy.countrySearch,
        placeholder: copy.countrySearch,
        autoComplete: "off",
        spellCheck: false,
        value: query,
        "data-testid": testid ? `${testid}-search` : undefined,
        onChange: (e)=>{
            setQuery(e.target.value);
            setActive(0);
        },
        onKeyDown: onSearchKey,
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 0,
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: 13.5,
            color: (0, $jTCZr.C).textPrimary
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: listId,
        role: "listbox",
        "aria-label": ariaLabel,
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            maxHeight: pos.listMax,
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        }
    }, matches.map((c, i)=>{
        const selected = $7801a9372e554ab2$var$sameCountry(c, value);
        const isActive = i === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: c.iso2,
            id: optionId(c.iso2),
            role: "option",
            "aria-selected": selected,
            "data-testid": testid ? `${testid}-option-${c.iso2}` : undefined,
            // mousedown, not click: keeps focus in the search box, so the
            // outside-press handler never sees it.
            onMouseDown: (e)=>{
                e.preventDefault();
                choose(c);
            },
            onMouseMove: ()=>setActive(i),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                minHeight: 40,
                padding: '0 10px',
                borderRadius: (0, $jTCZr.RADIUS).control,
                cursor: 'pointer',
                fontSize: 13.5,
                color: (0, $jTCZr.C).textPrimary,
                background: isActive ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                fontWeight: selected ? 600 : 400
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
            iso2: c.iso2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, (0, $5AX1S.countryName)(c, locale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.C).textMuted,
                unicodeBidi: 'isolate'
            }
        }, localize(`+${c.dial}`)), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "14",
            height: "14",
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.C).navy,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M20 6 9 17l-5-5"
        })));
    }), matches.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        style: {
            padding: '10px',
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted
        }
    }, copy.countryNoMatch))), host));
}
var $7801a9372e554ab2$export$2e2bcd8739ae039 = $7801a9372e554ab2$export$3abcf2ef1ee51ab5;

});
parcelRegister("jTCZr", function(module, exports) {

$parcel$export(module.exports, "C", () => $e7c165fb515b04ea$export$e7094788287c5e9b);
$parcel$export(module.exports, "CT", () => $e7c165fb515b04ea$export$4b57bfb4dade55bd);
$parcel$export(module.exports, "RADIUS", () => $e7c165fb515b04ea$export$2d2c9be8b5b863f);
$parcel$export(module.exports, "SHADOW", () => $e7c165fb515b04ea$export$98b6069deb71e13e);
$parcel$export(module.exports, "SKELETON", () => $e7c165fb515b04ea$export$169e587b68892b4e);
$parcel$export(module.exports, "SCRIM", () => $e7c165fb515b04ea$export$959fb1d648dd9e6c);
$parcel$export(module.exports, "GRADIENT_BRAND", () => $e7c165fb515b04ea$export$7deb2be06092489e);
$parcel$export(module.exports, "GRADIENT_BRAND_DARK", () => $e7c165fb515b04ea$export$4c2e201e0b6dbaa3);
$parcel$export(module.exports, "GRADIENT_SIDEBAR", () => $e7c165fb515b04ea$export$4a4d076b923f4e78);
$parcel$export(module.exports, "CREDIT_LOW", () => $e7c165fb515b04ea$export$18e630330c8bca65);
$parcel$export(module.exports, "creditLevel", () => $e7c165fb515b04ea$export$2e1a2382662bd4ea);
$parcel$export(module.exports, "CREDIT_LEVEL_META", () => $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7);
$parcel$export(module.exports, "creditColor", () => $e7c165fb515b04ea$export$3b48083d65d829ca);
$parcel$export(module.exports, "soft", () => $e7c165fb515b04ea$export$7bce9182245b1545);
$parcel$export(module.exports, "THEME_PRESETS", () => $e7c165fb515b04ea$export$a1d018c6ed60ae4c);
$parcel$export(module.exports, "FONT_SIZES", () => $e7c165fb515b04ea$export$58c32c962db85532);
$parcel$export(module.exports, "DEFAULT_THEME", () => $e7c165fb515b04ea$export$2faeed762aac6741);
$parcel$export(module.exports, "DEFAULT_FONT_SIZE", () => $e7c165fb515b04ea$export$b1461457ea2c1179);
$parcel$export(module.exports, "readStoredAppearance", () => $e7c165fb515b04ea$export$dde01dc24facb6b0);
$parcel$export(module.exports, "applyAppearance", () => $e7c165fb515b04ea$export$48c323151b232e54);
$parcel$export(module.exports, "storeAppearance", () => $e7c165fb515b04ea$export$64464588479aad90);
$parcel$export(module.exports, "statusColors", () => $e7c165fb515b04ea$export$6881c75116d5bd6e);
$parcel$export(module.exports, "chartPalette", () => $e7c165fb515b04ea$export$c7989e6ff0cf1179);
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/tokens — the single source of truth for the Parsina design system.
//
// Canonical copy: /packages/tokens (monorepo root). Each client app receives a
// synced copy at src/shared/tokens via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Three historical token systems (constants/theme.js `C`, constants/unifiedTheme.js
// `CT`, and per-app CSS vars) are collapsed into this module + tokens.css +
// tailwind.preset.js. Prefer Tailwind classes; `C`/`CT` exist for the screens
// still written with inline style objects.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
const $e7c165fb515b04ea$export$e7094788287c5e9b = {
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    red: '#D93025',
    redLight: '#F5E8E7',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    bg: '#f5f7fa',
    card: '#ffffff',
    border: '#eef0f3',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$4b57bfb4dade55bd = {
    // Backgrounds
    bg: '#f5f7fa',
    surface: '#ffffff',
    surface2: '#f3f2f0',
    // Borders
    border: '#eef0f3',
    border2: '#ece9e4',
    // Text
    ink: '#1a2332',
    ink2: '#5a6780',
    mute: '#9aa3b0',
    mute2: '#b0aca3',
    // Accent (teal — logo top hue). Themed; see the note on `C`.
    accent: 'var(--p-teal)',
    accentInk: 'var(--p-navy-dark)',
    accentSoft: 'color-mix(in srgb, var(--p-teal) 12%, transparent)',
    // Good (green)
    good: '#1A9B6C',
    goodInk: '#166534',
    goodSoft: 'rgba(22,163,74,0.12)',
    // Warn (amber)
    warn: '#F59E0B',
    warnInk: '#92400e',
    warnSoft: 'rgba(217,119,6,0.12)',
    // Danger (red)
    danger: '#D93025',
    dangerInk: '#991b1b',
    dangerSoft: 'rgba(220,38,38,0.08)',
    // Legacy aliases (keep older code working)
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    red: '#D93025',
    redLight: '#F5E8E7',
    card: '#ffffff',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $e7c165fb515b04ea$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};
const $e7c165fb515b04ea$export$169e587b68892b4e = {
    base: '#e9ecf1',
    sheen: '#f6f7f9',
    // On a gradient header, the sidebar or a dark canvas: white-alpha blocks.
    onDark: 'rgba(255,255,255,0.14)',
    onDarkSheen: 'rgba(255,255,255,0.26)'
};
const $e7c165fb515b04ea$export$959fb1d648dd9e6c = 'rgba(28,27,24,0.55)';
const $e7c165fb515b04ea$export$7deb2be06092489e = 'var(--gradient-brand)';
const $e7c165fb515b04ea$export$4c2e201e0b6dbaa3 = 'var(--gradient-brand-dark)';
const $e7c165fb515b04ea$export$4a4d076b923f4e78 = 'var(--gradient-sidebar)';
const $e7c165fb515b04ea$export$18e630330c8bca65 = 50;
const $e7c165fb515b04ea$export$63b7f4b4938ce481 = 200;
function $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance) {
    if (balance == null) return null;
    if (balance < $e7c165fb515b04ea$export$18e630330c8bca65) return 'low';
    if (balance < $e7c165fb515b04ea$export$63b7f4b4938ce481) return 'mid';
    return 'ok';
}
const $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7 = {
    low: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.red,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.redLight,
        labelKey: 'credits.level.low',
        shortLabelKey: 'credits.level.lowShort'
    },
    mid: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.amber,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.amberLight,
        labelKey: 'credits.level.mid',
        shortLabelKey: 'credits.level.midShort'
    },
    ok: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.green,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.greenLight,
        labelKey: 'credits.level.ok',
        shortLabelKey: 'credits.level.okShort'
    }
};
function $e7c165fb515b04ea$export$3b48083d65d829ca(balance, fallback = $e7c165fb515b04ea$export$e7094788287c5e9b.textMuted) {
    const level = $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance);
    return level ? $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7[level].color : fallback;
}
const $e7c165fb515b04ea$export$7bce9182245b1545 = (color, alpha = 0.12)=>{
    if (typeof color !== 'string' || !color) return 'transparent';
    const c = color.trim();
    if (c.startsWith('var(') || c.startsWith('color-mix(')) {
        const pct = Math.max(0, Math.min(100, Math.round(alpha * 100)));
        return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
    }
    const h = c.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x)=>x + x).join('') : h;
    const n = parseInt(full, 16);
    if (!/^[0-9a-fA-F]{6}$/.test(full) || Number.isNaN(n)) return c;
    return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${alpha})`;
};
const $e7c165fb515b04ea$export$a1d018c6ed60ae4c = [
    {
        id: 'default',
        get label () {
            return `\u{622}\u{628}\u{6CC} ${(0, $eLeza.brandName)('fa')}`;
        },
        swatch: '#0173BE',
        swatch2: '#00BEB2'
    },
    {
        id: 'teal',
        label: "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
        swatch: '#00A99E',
        swatch2: '#0173BE'
    },
    {
        id: 'ocean',
        label: "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
        swatch: '#0A5C8A',
        swatch2: '#0E8F9E'
    },
    {
        id: 'slate',
        label: "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
        swatch: '#3F5E75',
        swatch2: '#5C8A9E'
    }
];
const $e7c165fb515b04ea$export$7634868d3a6a0a2e = {
    doctor: {
        label: "\u067E\u0646\u0644 \u067E\u0632\u0634\u06A9",
        primary: '#0173BE',
        ink: '#083250'
    },
    clinic: {
        label: "\u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
        primary: '#0A4F8F',
        ink: '#062F57'
    },
    patient: {
        label: "\u067E\u0631\u0648\u0646\u062F\u0647 \u0633\u0644\u0627\u0645\u062A \u0645\u0646",
        primary: '#007C8C',
        ink: '#06363F'
    },
    dentist: {
        label: "\u067E\u0646\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
        primary: '#007D74',
        ink: '#063F3C'
    }
};
function $e7c165fb515b04ea$export$32d6efa0a3310091(panel) {
    const id = $e7c165fb515b04ea$export$7634868d3a6a0a2e[panel];
    if (!id) return $e7c165fb515b04ea$export$a1d018c6ed60ae4c;
    return $e7c165fb515b04ea$export$a1d018c6ed60ae4c.map((t)=>t.id === 'default' ? {
            ...t,
            label: "\u0631\u0646\u06AF \u067E\u0646\u0644",
            swatch: id.primary
        } : t);
}
const $e7c165fb515b04ea$export$58c32c962db85532 = [
    {
        id: 'small',
        label: "\u06A9\u0648\u0686\u06A9"
    },
    {
        id: 'medium',
        label: "\u0645\u062A\u0648\u0633\u0637"
    },
    {
        id: 'large',
        label: "\u0628\u0632\u0631\u06AF"
    }
];
const $e7c165fb515b04ea$export$2faeed762aac6741 = 'default';
const $e7c165fb515b04ea$export$b1461457ea2c1179 = 'medium';
const $e7c165fb515b04ea$export$888c18c43ead4265 = (id)=>$e7c165fb515b04ea$export$a1d018c6ed60ae4c.some((t)=>t.id === id);
const $e7c165fb515b04ea$export$5414ec5c49c0af0f = (id)=>$e7c165fb515b04ea$export$58c32c962db85532.some((f)=>f.id === id);
const $e7c165fb515b04ea$export$ff61b65939f754cc = 'parsina.appearance';
function $e7c165fb515b04ea$export$dde01dc24facb6b0(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        const raw = store?.getItem($e7c165fb515b04ea$export$ff61b65939f754cc);
        const parsed = raw ? JSON.parse(raw) : null;
        return {
            theme: $e7c165fb515b04ea$export$888c18c43ead4265(parsed?.theme) ? parsed.theme : $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(parsed?.fontSize) ? parsed.fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    } catch  {
        // Private mode, quota, or a corrupt value — fall back rather than throw.
        return {
            theme: $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    }
}
function $e7c165fb515b04ea$export$48c323151b232e54({ theme: theme, fontSize: fontSize } = {}, doc) {
    const root = (doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
    if (!root) return {
        theme: $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    const resolved = {
        theme: $e7c165fb515b04ea$export$888c18c43ead4265(theme) ? theme : $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(fontSize) ? fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    root.setAttribute('data-theme', resolved.theme);
    root.setAttribute('data-font-size', resolved.fontSize);
    return resolved;
}
function $e7c165fb515b04ea$export$64464588479aad90(appearance, storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        store?.setItem($e7c165fb515b04ea$export$ff61b65939f754cc, JSON.stringify(appearance));
    } catch  {
    // Persisting the cache is best-effort; the server copy is the real record.
    }
}
const $e7c165fb515b04ea$export$6881c75116d5bd6e = {
    // Appointment lifecycle, in the scheduling service's own vocabulary and with the
    // same Persian labels the clinic day panel uses — the desk and the doctor must not
    // call the same patient two different things.
    scheduled: {
        bg: '#F1F5F9',
        text: '#475569',
        label: "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631"
    },
    arrived: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u062D\u0627\u0636\u0631"
    },
    in_visit: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    },
    completed: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647"
    },
    cancelled: {
        bg: '#FEE2E2',
        text: '#991B1B',
        label: "\u0644\u063A\u0648 \u0634\u062F\u0647"
    },
    // A booked patient who never arrived. Distinct from `cancelled` — nobody
    // cancelled it — and neutral rather than red, because it is a fact about the
    // past, not a problem to act on. The patient app used to fork its own badge
    // for exactly this key (§1.1: missing keys get added here, never re-created
    // locally).
    no_show: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631"
    },
    // ── Patient-originated requests (docs/PATIENT_CLINIC_CARE_CONTEXT_AND_SELF_SERVICE_DESIGN.md §3) ──
    // A patient asked for this slot from the app and the clinic has not answered yet.
    // It HOLDS the slot, so it is a real appointment state and belongs here — amber
    // because it is work waiting on the desk, not a settled fact.
    requested: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9"
    },
    // The clinic declined the request, or it expired unanswered. Terminal and neutral:
    // like `no_show`, it is a fact about the past rather than a problem to act on.
    rejected: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0631\u062F \u0634\u062F\u0647"
    },
    // Patient-record statuses (Patients / PatientDetail screens), a different domain.
    waiting: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631"
    },
    visited: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A \u0634\u062F"
    },
    inprogress: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    }
};
const $e7c165fb515b04ea$export$c7989e6ff0cf1179 = [
    '#0173BE',
    '#00BEB2',
    '#F59E0B',
    '#7C4DBE'
];
const $e7c165fb515b04ea$export$6ee8bfc459aebd80 = {
    acquired: $e7c165fb515b04ea$export$c7989e6ff0cf1179[0],
    converted: $e7c165fb515b04ea$export$c7989e6ff0cf1179[1],
    lost: $e7c165fb515b04ea$export$c7989e6ff0cf1179[2],
    recovered: $e7c165fb515b04ea$export$c7989e6ff0cf1179[3]
};

});
parcelRegister("eLeza", function(module, exports) {

$parcel$export(module.exports, "BRAND_DEFAULTS", () => $abf0c103b4b92127$export$c3e10d2aebbc7f30);
$parcel$export(module.exports, "configureBrandFromEnv", () => $abf0c103b4b92127$export$1c31b0413ff44cf2);
$parcel$export(module.exports, "brand", () => $abf0c103b4b92127$export$96ff94e0adb1d772);
$parcel$export(module.exports, "brandRevision", () => $abf0c103b4b92127$export$57a0b7719e4bc93b);
$parcel$export(module.exports, "isIranMarket", () => $abf0c103b4b92127$export$3cede7c619603eb2);
$parcel$export(module.exports, "brandLocales", () => $abf0c103b4b92127$export$1a326f4d00c1e158);
$parcel$export(module.exports, "brandDefaultLocale", () => $abf0c103b4b92127$export$879824979a5b153a);
$parcel$export(module.exports, "calendarSystem", () => $abf0c103b4b92127$export$a350347e69c4c055);
$parcel$export(module.exports, "brandName", () => $abf0c103b4b92127$export$63a39fc1c580d092);
$parcel$export(module.exports, "brandToken", () => $abf0c103b4b92127$export$6281f283246a2f65);
$parcel$export(module.exports, "PLACEHOLDER", () => $abf0c103b4b92127$export$55fc5ffc49a23c34);
$parcel$export(module.exports, "applyBrandTokens", () => $abf0c103b4b92127$export$1508028e88b5e6ae);
$parcel$export(module.exports, "brandString", () => $abf0c103b4b92127$export$62fa8a9cbf8a9cc6);
// ─────────────────────────────────────────────────────────────────────────────
// The brand — what the product is called, what its credit is called, which
// languages it offers, which calendar it reads and which market it serves — and
// how a deployment replaces it.
//
// THE PROBLEM THIS SOLVES
// One set of images runs as Parsina and as another brand (Proxia first). The
// brand is CONFIGURATION, set by the deployment (docs/rebranding/CONTRACT.md):
// the container writes `BRAND_B64` into env.js, the app decodes it at boot and
// hands it here. Everything that says the name — the catalogues' `{{brand}}`,
// the printed prescription's footer, the video call's window title — and
// everything that is Iranian by default rather than by nature — the calendar,
// the phone field's +98, the national-id rule — asks this module.
//
// WHY A REGISTRY
// The same shape as `setUiStrings` (uiStrings.js) and `configureClinical`
// (clinical/src/host.jsx): module state, set once at boot, readable from plain
// functions — a print builder, a phone parser, a locale resolver — and not only
// from components. It is not reactive: a brand does not change while a page is
// open, so it is configured BEFORE the first render and never again.
//
// THE DEFAULTS ARE THE POINT
// Every default below is the literal the framework shipped before it had a
// brand. An app that never calls `configureBrand` renders exactly what it
// rendered before, byte for byte (clinical/__tests__/brandParity.test.js holds
// the resolved catalogues to that). A deployment that configures a brand
// replaces only the fields it sets; a bad value is dropped with ONE console
// warning and its default kept — a brand must never be the reason a panel does
// not start.
//
// Brand is not market (CONTRACT §1.4). `market: 'intl'` does not rename the
// Iranian rails; it hides them (`isIranMarket()`), at the entry points.
// ─────────────────────────────────────────────────────────────────────────────
const $abf0c103b4b92127$var$deepFreeze = (value)=>{
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach($abf0c103b4b92127$var$deepFreeze);
        Object.freeze(value);
    }
    return value;
};
const $abf0c103b4b92127$export$c3e10d2aebbc7f30 = $abf0c103b4b92127$var$deepFreeze({
    id: 'parsina',
    name: {
        fa: "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        en: 'Parsina',
        ar: 'Parsina'
    },
    tagline: {
        fa: "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u067E\u0632\u0634\u06A9\u06CC",
        en: 'Intelligent Medical Assistant',
        ar: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0637\u0628\u064A \u0627\u0644\u0630\u0643\u064A"
    },
    // The credit's NAME, a label only — `parseh*` identifiers never change.
    // `faEz` is the Persian ezafe form («پارسهٔ کلینیک»): heh + U+0654.
    walletUnit: {
        fa: "\u067E\u0627\u0631\u0633\u0647",
        faEz: "\u067E\u0627\u0631\u0633\u0647\u0654",
        en: 'Parseh',
        ar: "\u0628\u0627\u0631\u0633\u0647"
    },
    // null = the app's own list / default / calendar / market — today's behaviour.
    locales: null,
    defaultLocale: null,
    calendar: null,
    market: null,
    assetPack: null,
    // Per-locale overlay, consulted BEFORE the catalogue: { en: { '<key>': '<text>' } }.
    strings: {}
});
const $abf0c103b4b92127$var$CALENDARS = [
    'jalali',
    'gregory'
];
const $abf0c103b4b92127$var$MARKETS = [
    'ir',
    'intl'
];
const $abf0c103b4b92127$var$SLUG = /^[a-z0-9][a-z0-9-]*$/;
const $abf0c103b4b92127$var$LOCALE_ID = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
let $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({}); // what the deployment set, after sanitising
let $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30; // the defaults with `configured` merged over them
let $abf0c103b4b92127$var$revision = 0;
// One warning per message per session — `brandLocales` runs on every render.
const $abf0c103b4b92127$var$warned = new Set();
function $abf0c103b4b92127$var$warnOnce(message) {
    if ($abf0c103b4b92127$var$warned.has(message)) return;
    $abf0c103b4b92127$var$warned.add(message);
    console.warn(`[brand] ${message}`);
}
const $abf0c103b4b92127$var$isPlainObject = (v)=>v != null && typeof v === 'object' && !Array.isArray(v);
const $abf0c103b4b92127$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
/** `{ fa: '…', en: '…' }` — keeps the entries whose value is a non-empty string. */ function $abf0c103b4b92127$var$sanitizeMap(value, field, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push(`${field} is not an object`);
        return undefined;
    }
    const out = {};
    for (const [key, text] of Object.entries(value))if ($abf0c103b4b92127$var$nonEmpty(text)) out[key] = text;
    else problems.push(`${field}.${key} is not a non-empty string`);
    return out;
}
function $abf0c103b4b92127$var$sanitizeLocales(value, problems) {
    if (!Array.isArray(value) || value.length === 0) {
        problems.push('locales is not a non-empty array');
        return undefined;
    }
    const ids = value.map((id)=>typeof id === 'string' ? id.trim().toLowerCase() : '');
    if (ids.some((id)=>!$abf0c103b4b92127$var$LOCALE_ID.test(id))) {
        problems.push(`locales has an entry that is not a language tag: ${JSON.stringify(value)}`);
        return undefined;
    }
    return [
        ...new Set(ids)
    ];
}
function $abf0c103b4b92127$var$sanitizeStrings(value, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push('strings is not an object');
        return undefined;
    }
    const out = {};
    for (const [locale, table] of Object.entries(value)){
        if (!$abf0c103b4b92127$var$isPlainObject(table)) {
            problems.push(`strings.${locale} is not an object`);
            continue;
        }
        const kept = {};
        for (const [key, text] of Object.entries(table)){
            const ok = typeof text === 'string' || Array.isArray(text) && text.every((item)=>typeof item === 'string');
            if (ok) kept[key] = text;
            else problems.push(`strings.${locale}.${key} is not a string`);
        }
        out[locale.toLowerCase()] = kept;
    }
    return out;
}
/**
 * Raw brand JSON → only the fields that are valid, with every problem noted.
 * Unknown fields are ignored without a word: the same object reaches every
 * runtime (CONTRACT §2) and may carry fields only a service reads.
 */ function $abf0c103b4b92127$var$sanitize(input, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(input)) {
        problems.push('the brand is not a JSON object');
        return {};
    }
    const out = {};
    const scalar = (field, test, normalise = (v)=>v)=>{
        const v = input[field];
        if (v === undefined || v === null) return;
        if (test(v)) out[field] = normalise(v);
        else problems.push(`${field} ${JSON.stringify(v)} is not valid`);
    };
    scalar('id', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('calendar', (v)=>$abf0c103b4b92127$var$CALENDARS.includes(v));
    scalar('market', (v)=>$abf0c103b4b92127$var$MARKETS.includes(v));
    scalar('assetPack', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('defaultLocale', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$LOCALE_ID.test(v.trim().toLowerCase()), (v)=>v.trim().toLowerCase());
    for (const field of [
        'name',
        'tagline',
        'walletUnit'
    ]){
        if (input[field] == null) continue;
        const map = $abf0c103b4b92127$var$sanitizeMap(input[field], field, problems);
        if (map && Object.keys(map).length) out[field] = map;
    }
    if (input.locales != null) {
        const locales = $abf0c103b4b92127$var$sanitizeLocales(input.locales, problems);
        if (locales) out.locales = locales;
    }
    if (input.strings != null) {
        const strings = $abf0c103b4b92127$var$sanitizeStrings(input.strings, problems);
        if (strings) out.strings = strings;
    }
    // A first-visit language the brand does not offer is a contradiction; the
    // list wins, and `brandDefaultLocale` then answers from the list.
    if (out.defaultLocale && out.locales && !out.locales.includes(out.defaultLocale)) {
        problems.push(`defaultLocale "${out.defaultLocale}" is not one of locales`);
        delete out.defaultLocale;
    }
    return out;
}
function $abf0c103b4b92127$export$d9cd1c078c0b61d(word) {
    const w = String(word ?? '');
    if (/ه$/.test(w)) return `${w}\u{654}`;
    if (/[او]$/.test(w)) return `${w}\u{6CC}`;
    return w;
}
function $abf0c103b4b92127$var$merge(clean) {
    const unit = clean.walletUnit || {};
    return $abf0c103b4b92127$var$deepFreeze({
        ...$abf0c103b4b92127$export$c3e10d2aebbc7f30,
        ...clean,
        name: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.name,
            ...clean.name
        },
        tagline: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.tagline,
            ...clean.tagline
        },
        walletUnit: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit,
            ...unit,
            faEz: unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : $abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit.faEz)
        },
        strings: clean.strings || {}
    });
}
function $abf0c103b4b92127$export$9b06eb23289fc34c(partial) {
    $abf0c103b4b92127$var$revision += 1;
    if (partial === null || partial === undefined) {
        $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({});
        $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30;
        return $abf0c103b4b92127$var$resolved;
    }
    const problems = [];
    const clean = $abf0c103b4b92127$var$sanitize(partial, problems);
    if (problems.length) console.warn(`[brand] kept the default for what is not valid: ${problems.join('; ')}`);
    $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze(clean);
    $abf0c103b4b92127$var$resolved = Object.keys(clean).length ? $abf0c103b4b92127$var$merge(clean) : $abf0c103b4b92127$export$c3e10d2aebbc7f30;
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$3f8f5e31744c04b0(b64) {
    try {
        if (typeof atob !== 'function') return undefined;
        const binary = atob(String(b64).replace(/\s+/g, ''));
        const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes));
    } catch  {
        return undefined;
    }
}
function $abf0c103b4b92127$export$1c31b0413ff44cf2(env = typeof window !== 'undefined' ? window.__ENV__ : undefined) {
    const b64 = env?.BRAND_B64;
    if (b64 === undefined || b64 === null || String(b64).trim() === '') return $abf0c103b4b92127$var$resolved;
    const decoded = $abf0c103b4b92127$export$3f8f5e31744c04b0(b64);
    if (decoded === undefined) {
        console.warn("[brand] BRAND_B64 is not base64 of a UTF-8 JSON object \u2014 Parsina defaults kept");
        return $abf0c103b4b92127$export$9b06eb23289fc34c(null);
    }
    return $abf0c103b4b92127$export$9b06eb23289fc34c(decoded);
}
function $abf0c103b4b92127$export$96ff94e0adb1d772() {
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$57a0b7719e4bc93b() {
    return $abf0c103b4b92127$var$revision;
}
function $abf0c103b4b92127$export$3cede7c619603eb2() {
    return $abf0c103b4b92127$var$resolved.market !== 'intl';
}
function $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) {
    const list = Array.isArray(appLocales) ? appLocales : [];
    const allowed = $abf0c103b4b92127$var$resolved.locales;
    if (!allowed) return list;
    const offered = list.filter((id)=>allowed.includes(String(id).toLowerCase()));
    if (offered.length) return offered;
    $abf0c103b4b92127$var$warnOnce(`locales ${JSON.stringify(allowed)} share nothing with this app's ${JSON.stringify(list)} \u{2014} offering the app's`);
    return list;
}
function $abf0c103b4b92127$export$879824979a5b153a(appDefault, appLocales) {
    const offered = appLocales ? $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) : $abf0c103b4b92127$var$resolved.locales;
    const wanted = $abf0c103b4b92127$var$resolved.defaultLocale;
    if (wanted && (!offered || offered.includes(wanted))) return wanted;
    if (!offered || offered.includes(appDefault)) return appDefault;
    return offered[0] ?? appDefault;
}
function $abf0c103b4b92127$export$a350347e69c4c055(appDefault = null) {
    return $abf0c103b4b92127$var$resolved.calendar || appDefault;
}
// ── Text ─────────────────────────────────────────────────────────────────────
/** A per-locale map read for `locale`: exact, then the base language, then English. */ function $abf0c103b4b92127$var$pick(map, locale) {
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    if (map[id] !== undefined) return map[id];
    const base = id.split(/[-_]/)[0];
    if (map[base] !== undefined) return map[base];
    return map.en;
}
/** What the deployment itself set for `field` in `locale`, or undefined. */ const $abf0c103b4b92127$var$configuredIn = (field, locale)=>{
    const map = $abf0c103b4b92127$var$configured[field];
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    return map[id] ?? map[id.split(/[-_]/)[0]];
};
function $abf0c103b4b92127$export$63a39fc1c580d092(locale) {
    return $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale);
}
function $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline) {
    const has = inline !== undefined && inline !== null;
    switch(name){
        case 'brand':
            {
                const set = $abf0c103b4b92127$var$configuredIn('name', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale));
            }
        case 'coin':
            {
                const set = $abf0c103b4b92127$var$configuredIn('walletUnit', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.walletUnit, locale));
            }
        case 'coinEz':
            {
                const unit = $abf0c103b4b92127$var$configured.walletUnit;
                const set = unit && (unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : undefined));
                return set ?? (has ? inline : $abf0c103b4b92127$var$resolved.walletUnit.faEz);
            }
        case 'tagline':
            {
                const set = $abf0c103b4b92127$var$configuredIn('tagline', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.tagline, locale));
            }
        default:
            return undefined;
    }
}
const $abf0c103b4b92127$export$936dfa1128462f2c = Object.freeze([
    'brand',
    'coin',
    'coinEz',
    'tagline'
]);
function $abf0c103b4b92127$export$168e20da34ba5ff3(locale) {
    return {
        brand: $abf0c103b4b92127$export$6281f283246a2f65('brand', locale),
        coin: $abf0c103b4b92127$export$6281f283246a2f65('coin', locale),
        coinEz: $abf0c103b4b92127$export$6281f283246a2f65('coinEz', locale),
        tagline: $abf0c103b4b92127$export$6281f283246a2f65('tagline', locale)
    };
}
const $abf0c103b4b92127$export$55fc5ffc49a23c34 = /\{\{\s*([\w.]+)\s*(?:\|([^{}]*?))?\s*\}\}/g;
function $abf0c103b4b92127$export$1508028e88b5e6ae(text, locale) {
    if (typeof text !== 'string' || text.indexOf('{{') === -1) return text;
    return text.replace($abf0c103b4b92127$export$55fc5ffc49a23c34, (match, name, inline)=>{
        const value = $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline);
        return value === undefined ? match : value;
    });
}
function $abf0c103b4b92127$export$62fa8a9cbf8a9cc6(locale, key) {
    const table = $abf0c103b4b92127$var$resolved.strings;
    const id = String(locale || '').toLowerCase();
    const own = table[id] ?? table[id.split(/[-_]/)[0]];
    if (!own) return undefined;
    return Object.prototype.hasOwnProperty.call(own, key) ? own[key] : undefined;
}

});


parcelRegister("5AX1S", function(module, exports) {

$parcel$export(module.exports, "foldDigits", () => $412e1a8a99c19c1a$export$522be3011864bb18);
$parcel$export(module.exports, "SEPARATORS", () => $412e1a8a99c19c1a$export$bc4e24532d262f45);
$parcel$export(module.exports, "compactPhone", () => $412e1a8a99c19c1a$export$2ae1a93e018170a7);
$parcel$export(module.exports, "COUNTRIES", () => $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
$parcel$export(module.exports, "DEFAULT_COUNTRY", () => $412e1a8a99c19c1a$export$84b76667b0a9e7b4);
$parcel$export(module.exports, "countryForLocale", () => $412e1a8a99c19c1a$export$7684f8e22afec32c);
$parcel$export(module.exports, "findByIso2", () => $412e1a8a99c19c1a$export$586b3eaa727579f5);
$parcel$export(module.exports, "findByDialCode", () => $412e1a8a99c19c1a$export$21894a57509f6ed5);
$parcel$export(module.exports, "countryName", () => $412e1a8a99c19c1a$export$3162e773cd568eb);
$parcel$export(module.exports, "parsePhone", () => $412e1a8a99c19c1a$export$48c6adddc5539199);
$parcel$export(module.exports, "normalizePhone", () => $412e1a8a99c19c1a$export$e9b617754cf28d84);
$parcel$export(module.exports, "isValidPhone", () => $412e1a8a99c19c1a$export$f9c4d85d720ef909);
$parcel$export(module.exports, "toNational", () => $412e1a8a99c19c1a$export$317852993b4735b6);
$parcel$export(module.exports, "forDisplay", () => $412e1a8a99c19c1a$export$1069b069fb83ae5b);
$parcel$export(module.exports, "maskPhone", () => $412e1a8a99c19c1a$export$1f64b92865689d0d);
$parcel$export(module.exports, "lookupVariants", () => $412e1a8a99c19c1a$export$493e0fb9b5aae030);
// Phone numbers, reduced to one canonical form — and read back in whatever form a
// human wants to look at.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE THREE SIBLINGS OF THIS FILE
//
//   microservices/parsina.patientmanagement.microservice/app/domain/phone.py
//       `normalize_phone` — the matching key behind `patients.phone_normalized`.
//       Iran only. Its tests are tests/test_phone.py.
//   sso/parsina.keycloakify/spi/src/main/java/ir/parsinabot/keycloak/phoneotp/PhoneNumbers.java
//       `normalize` / `toNational` / `lookupVariants` / `mask`, inside the Keycloak
//       authenticator. Iran only. Its tests are PhoneNumbersTest.java.
//   sso/parsina.keycloakify/src/login/lib/{countries.ts,phone.ts}
//       The login screen's country-aware picker and E.164 parse. 62 countries,
//       Iran first, "the list is a convenience, never a gate". Its flags are the
//       ones `flags.js` rasterises (PM-0078).
//
// This module is the fourth hand-rolled implementation of the same rules, and it is
// deliberate. Keycloak is a Java process that cannot import Python; the login theme
// cannot `npm install @parsina/framework` (its own `digits.ts` header says why); the
// alembic backfill re-implements the rules in SQL on purpose, because a migration is a
// historical record of what a database was actually given and must not change meaning
// when a source file changes. What holds them together is not a shared module — it is a
// shared CASE TABLE. `PhoneNumbersTest` carries `test_phone.py`'s cases, `test_phone.py`
// carries the migration's, and `ui/lib/phone.test.js` beside this file carries
// `test_phone.py`'s. Adding a country is one row here and one row in `countries.ts`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHY THIS EXISTS AT ALL
//
// A phone number is the only handle joining a walk-in patient record — typed at the
// clinic desk, on paper, in a hurry — to the Keycloak account that person later
// registers with themselves. The two are typed by different people, years apart, in
// whatever form each found natural: the desk's Persian-digit spelling, and
// `+98 912 345 6789` in the signup form. Compared literally they are two different
// strings and the match never happens — which is how a doctor whose realm record held
// `+989199118259` ended up with a SECOND account when a desk typed `09199118259`.
//
// So the canonical form is E.164 — `+`, country code, national significant number, ASCII
// digits and nothing else — and every comparison goes through `normalizePhone`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ONE PROMISE THIS FILE MAKES
//
//   With no options, `normalizePhone` is byte-identical to `phone.py#normalize_phone`
//   and `PhoneNumbers.normalize` for EVERY INPUT — not merely for the rows of
//   tests/test_phone.py — and is idempotent.
//
// "Every input" and "every row of the table" are not the same promise, and the weaker one
// was not enough: 74 real Iranian ranges written as `+9901234567` came back as
// `+9901234567` while both twins answered `+989901234567`, and 61 spellings the twins
// accept (`+0…`, `+00…`, `00<national>`, `+<national>`) were refused outright. Every one
// of those passed a green suite, because none of them was a row in the table.
//
// So the twins' algorithm is not APPROXIMATED here by a catalog that happens to contain
// Iran — it is TRANSCRIBED, in `peelIranianMobile`, and runs before the catalog is
// consulted at all. Everything else — countries, landlines, the picker — is the
// generalisation layered around it, and reaches a string only once the peel has declined
// it. `phone.test.js` executes the two implementations against each other over a
// generated corpus, so the promise is checked rather than asserted.
//
// ═══════════════════════════════════════════════════════════════════════════════
// TWO JOBS, NOT ONE
//
// `compactPhone` is LENIENT and `parsePhone` is STRICT, and the split is on purpose:
//
//   - A FIELD filters what a human may put in a box. Typing a word after a number should
//     make the letters simply not appear — the user watches them not arrive and nothing
//     is "rejected". That is `compactPhone`, and `PhoneInput` is its only real caller.
//   - A CANONICALISER judges a string that arrived from a database, an import or another
//     system, and can afford to refuse: `"09123456789abc"` is not a number with junk on
//     it, it is a string we do not understand, and guessing would be worse than
//     declining. That is `parsePhone`, and everything else calls it.
//
// Every non-field caller wants the second one.
//
// ═══════════════════════════════════════════════════════════════════════════════
// AND A THIRD JOB: READING
//
// DISPLAYING A PHONE IS NOT VALIDATING IT.
//
// `parsePhone`/`normalizePhone`/`isValidPhone`/`toNational` all JUDGE — they are the
// converters, and `''` is a verdict they are entitled to return. A READ SURFACE is not
// entitled to it. The value is already in the column; somebody stored it; a person is
// looking at the screen for it. Showing nothing, or showing `+98…` where a human expects
// `021…`, is the only way a read can fail.
//
// So every read goes through `forDisplay`, which is `toNational` with `allowLandline`
// ALWAYS on and the raw value as its fallback, and which therefore never blanks and never
// refuses. Restricting to mobiles belongs on the INPUT — `PhoneInput`, where a desk is
// still typing — and has no meaning at all on a value already written.
//
// The exports, by which job they do:
//
//   INPUT (lenient, shapes a keystroke)   compactPhone, foldDigits
//   CONVERT/VALIDATE (strict, may refuse) parsePhone, normalizePhone, isValidPhone,
//                                         toNational, lookupVariants
//   READ (never refuses)                  forDisplay, maskPhone
//   CATALOG                               COUNTRIES, DEFAULT_COUNTRY, findByIso2,
//                                         findByDialCode, countryName,
//                                         countryForLocale, SEPARATORS
// The extension is NOT optional here, and the omission was a real break.
//
// The barrel resolves either spelling because a bundler is doing the resolving.
// But this module is imported DIRECTLY by DOM-free logic that runs under Node's
// own ESM resolver — the patient and student apps do exactly that, deliberately,
// so a `node` test environment does not pull raw JSX through the barrel. Node
// does not guess extensions, so `'./money'` failed there with
// ERR_MODULE_NOT_FOUND naming a file that plainly exists.

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
// ─────────────────────────────────────────────────────────────────────────────
// Digits
// ─────────────────────────────────────────────────────────────────────────────
/** Persian U+06F0–U+06F9 — the default on an Iranian keyboard. */ const $412e1a8a99c19c1a$var$FA_ZERO = 0x06f0;
/** Arabic-Indic U+0660–U+0669 — Arabic-locale keyboards and some legacy imports. */ const $412e1a8a99c19c1a$var$AR_ZERO = 0x0660;
/** Fullwidth U+FF10–U+FF19 — emitted by some IME keyboards. */ const $412e1a8a99c19c1a$var$FW_ZERO = 0xff10;
function $412e1a8a99c19c1a$export$522be3011864bb18(raw) {
    if (typeof raw !== 'string') return '';
    let out = '';
    for(let i = 0; i < raw.length; i++){
        const c = raw.charCodeAt(i);
        if (c >= $412e1a8a99c19c1a$var$FA_ZERO && c <= $412e1a8a99c19c1a$var$FA_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FA_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$AR_ZERO && c <= $412e1a8a99c19c1a$var$AR_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$AR_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$FW_ZERO && c <= $412e1a8a99c19c1a$var$FW_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FW_ZERO));
        else out += raw[i];
    }
    return out;
}
const $412e1a8a99c19c1a$export$bc4e24532d262f45 = " 	\r\n\f\v\xa0\u202F\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u205F\u3000\u200B\u200C\u200D\u200E\u200F\u061C\uFEFF-\u2010\u2011\u2012\u2013\u2014\u2015\u2212()[]{}<>._/\\|,;:*#'\"`"; // everything else a desk has been seen to type
const $412e1a8a99c19c1a$var$SEPARATOR_SET = new Set($412e1a8a99c19c1a$export$bc4e24532d262f45.split(''));
const $412e1a8a99c19c1a$var$stripSeparators = (s)=>{
    let out = '';
    for(let i = 0; i < s.length; i++)if (!$412e1a8a99c19c1a$var$SEPARATOR_SET.has(s[i])) out += s[i];
    return out;
};
/**
 * What must remain once decoration is gone: digits, optionally introduced by ONE leading
 * `+`. Anything else — a letter, a second `+`, an interior symbol we did not list — means
 * this string is not a phone number.
 */ const $412e1a8a99c19c1a$var$DIGITS_ONLY = /^\+?[0-9]+$/;
/**
 * The national significant number of an Iranian mobile: ten digits, the first a 9.
 * `phone.py#_IR_MOBILE` character for character (`\d` and `[0-9]` are the same set here,
 * and Iran's catalog row spells the same rule `/^9\d{9}$/`).
 *
 * It is written out separately from that row because the twins' peel below is not a
 * catalog lookup and must not become one — see `peelIranianMobile`.
 */ const $412e1a8a99c19c1a$var$IR_MOBILE = /^9[0-9]{9}$/;
/** E.164 caps the whole number — country code included — at 15 digits. The floor is a
 *  sanity bound, not a standard: no plan in this catalog is shorter. */ const $412e1a8a99c19c1a$var$E164_MIN_DIGITS = 7;
const $412e1a8a99c19c1a$var$E164_MAX_DIGITS = 15;
function $412e1a8a99c19c1a$export$2ae1a93e018170a7(raw) {
    const ascii = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    const prefix = ascii.startsWith('+') ? '+' : '';
    return prefix + ascii.replace(/\D/g, '');
}
const $412e1a8a99c19c1a$export$4d78c43b7fa734a7 = Object.freeze([
    Object.freeze({
        iso2: 'IR',
        dial: '98',
        en: 'Iran',
        fa: "\u0627\u06CC\u0631\u0627\u0646",
        ar: "\u0625\u064A\u0631\u0627\u0646",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        nsnPattern: /^9\d{9}$/,
        example: '09121234567'
    }),
    Object.freeze({
        iso2: 'AF',
        dial: '93',
        en: 'Afghanistan',
        fa: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'DZ',
        dial: '213',
        en: 'Algeria',
        fa: "\u0627\u0644\u062C\u0632\u0627\u06CC\u0631",
        ar: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0551234567'
    }),
    Object.freeze({
        iso2: 'AM',
        dial: '374',
        en: 'Armenia',
        fa: "\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0631\u0645\u064A\u0646\u064A\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 8,
        example: '077123456'
    }),
    Object.freeze({
        iso2: 'AU',
        dial: '61',
        en: 'Australia',
        fa: "\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627",
        ar: "\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0412345678'
    }),
    Object.freeze({
        iso2: 'AT',
        dial: '43',
        en: 'Austria',
        fa: "\u0627\u062A\u0631\u06CC\u0634",
        ar: "\u0627\u0644\u0646\u0645\u0633\u0627",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '06641234567'
    }),
    Object.freeze({
        iso2: 'AZ',
        dial: '994',
        en: 'Azerbaijan',
        fa: "\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646",
        ar: "\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'BH',
        dial: '973',
        en: 'Bahrain',
        fa: "\u0628\u062D\u0631\u06CC\u0646",
        ar: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        nsnMin: 8,
        nsnMax: 8,
        example: '36001234'
    }),
    Object.freeze({
        iso2: 'BE',
        dial: '32',
        en: 'Belgium',
        fa: "\u0628\u0644\u0698\u06CC\u06A9",
        ar: "\u0628\u0644\u062C\u064A\u0643\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0470123456'
    }),
    Object.freeze({
        iso2: 'BR',
        dial: '55',
        en: 'Brazil',
        fa: "\u0628\u0631\u0632\u06CC\u0644",
        ar: "\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 11,
        example: '11912345678'
    }),
    Object.freeze({
        iso2: 'CA',
        dial: '1',
        en: 'Canada',
        fa: "\u06A9\u0627\u0646\u0627\u062F\u0627",
        ar: "\u0643\u0646\u062F\u0627",
        nsnMin: 10,
        nsnMax: 10,
        example: '4165550123'
    }),
    Object.freeze({
        iso2: 'CN',
        dial: '86',
        en: 'China',
        fa: "\u0686\u06CC\u0646",
        ar: "\u0627\u0644\u0635\u064A\u0646",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 12,
        example: '13123456789'
    }),
    Object.freeze({
        iso2: 'CY',
        dial: '357',
        en: 'Cyprus',
        fa: "\u0642\u0628\u0631\u0633",
        ar: "\u0642\u0628\u0631\u0635",
        nsnMin: 8,
        nsnMax: 8,
        example: '96123456'
    }),
    Object.freeze({
        iso2: 'DK',
        dial: '45',
        en: 'Denmark',
        fa: "\u062F\u0627\u0646\u0645\u0627\u0631\u06A9",
        ar: "\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'EG',
        dial: '20',
        en: 'Egypt',
        fa: "\u0645\u0635\u0631",
        ar: "\u0645\u0635\u0631",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '01001234567'
    }),
    Object.freeze({
        iso2: 'FI',
        dial: '358',
        en: 'Finland',
        fa: "\u0641\u0646\u0644\u0627\u0646\u062F",
        ar: "\u0641\u0646\u0644\u0646\u062F\u0627",
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'FR',
        dial: '33',
        en: 'France',
        fa: "\u0641\u0631\u0627\u0646\u0633\u0647",
        ar: "\u0641\u0631\u0646\u0633\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'GE',
        dial: '995',
        en: 'Georgia',
        fa: "\u06AF\u0631\u062C\u0633\u062A\u0627\u0646",
        ar: "\u062C\u0648\u0631\u062C\u064A\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '555123456'
    }),
    Object.freeze({
        iso2: 'DE',
        dial: '49',
        en: 'Germany',
        fa: "\u0622\u0644\u0645\u0627\u0646",
        ar: "\u0623\u0644\u0645\u0627\u0646\u064A\u0627",
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '015112345678'
    }),
    Object.freeze({
        iso2: 'GR',
        dial: '30',
        en: 'Greece',
        fa: "\u06CC\u0648\u0646\u0627\u0646",
        ar: "\u0627\u0644\u064A\u0648\u0646\u0627\u0646",
        nsnMin: 10,
        nsnMax: 10,
        example: '6912345678'
    }),
    Object.freeze({
        iso2: 'HU',
        dial: '36',
        en: 'Hungary',
        fa: "\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646",
        ar: "\u0627\u0644\u0645\u062C\u0631",
        trunk: '06',
        nsnMin: 8,
        nsnMax: 9,
        example: '06201234567'
    }),
    Object.freeze({
        iso2: 'IN',
        dial: '91',
        en: 'India',
        fa: "\u0647\u0646\u062F",
        ar: "\u0627\u0644\u0647\u0646\u062F",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '9812345678'
    }),
    Object.freeze({
        iso2: 'ID',
        dial: '62',
        en: 'Indonesia',
        fa: "\u0627\u0646\u062F\u0648\u0646\u0632\u06CC",
        ar: "\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 12,
        example: '081234567890'
    }),
    Object.freeze({
        iso2: 'IQ',
        dial: '964',
        en: 'Iraq',
        fa: "\u0639\u0631\u0627\u0642",
        ar: "\u0627\u0644\u0639\u0631\u0627\u0642",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '07912345678'
    }),
    Object.freeze({
        iso2: 'IT',
        dial: '39',
        en: 'Italy',
        fa: "\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627",
        ar: "\u0625\u064A\u0637\u0627\u0644\u064A\u0627",
        nsnMin: 6,
        nsnMax: 11,
        example: '3123456789'
    }),
    Object.freeze({
        iso2: 'JP',
        dial: '81',
        en: 'Japan',
        fa: "\u0698\u0627\u067E\u0646",
        ar: "\u0627\u0644\u064A\u0627\u0628\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '09012345678'
    }),
    Object.freeze({
        iso2: 'JO',
        dial: '962',
        en: 'Jordan',
        fa: "\u0627\u0631\u062F\u0646",
        ar: "\u0627\u0644\u0623\u0631\u062F\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0791234567'
    }),
    Object.freeze({
        iso2: 'KZ',
        dial: '7',
        en: 'Kazakhstan',
        fa: "\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646",
        ar: "\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646",
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '87011234567'
    }),
    Object.freeze({
        iso2: 'KW',
        dial: '965',
        en: 'Kuwait',
        fa: "\u06A9\u0648\u06CC\u062A",
        ar: "\u0627\u0644\u0643\u0648\u064A\u062A",
        nsnMin: 8,
        nsnMax: 8,
        example: '50012345'
    }),
    Object.freeze({
        iso2: 'LB',
        dial: '961',
        en: 'Lebanon',
        fa: "\u0644\u0628\u0646\u0627\u0646",
        ar: "\u0644\u0628\u0646\u0627\u0646",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 8,
        example: '03123456'
    }),
    Object.freeze({
        iso2: 'LY',
        dial: '218',
        en: 'Libya',
        fa: "\u0644\u06CC\u0628\u06CC",
        ar: "\u0644\u064A\u0628\u064A\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'MY',
        dial: '60',
        en: 'Malaysia',
        fa: "\u0645\u0627\u0644\u0632\u06CC",
        ar: "\u0645\u0627\u0644\u064A\u0632\u064A\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0123456789'
    }),
    Object.freeze({
        iso2: 'MR',
        dial: '222',
        en: 'Mauritania',
        fa: "\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC",
        ar: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        nsnMin: 8,
        nsnMax: 8,
        example: '22123456'
    }),
    Object.freeze({
        iso2: 'MA',
        dial: '212',
        en: 'Morocco',
        fa: "\u0645\u0631\u0627\u06A9\u0634",
        ar: "\u0627\u0644\u0645\u063A\u0631\u0628",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NL',
        dial: '31',
        en: 'Netherlands',
        fa: "\u0647\u0644\u0646\u062F",
        ar: "\u0647\u0648\u0644\u0646\u062F\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NZ',
        dial: '64',
        en: 'New Zealand',
        fa: "\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F",
        ar: "\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0211234567'
    }),
    Object.freeze({
        iso2: 'NO',
        dial: '47',
        en: 'Norway',
        fa: "\u0646\u0631\u0648\u0698",
        ar: "\u0627\u0644\u0646\u0631\u0648\u064A\u062C",
        nsnMin: 8,
        nsnMax: 8,
        example: '40612345'
    }),
    Object.freeze({
        iso2: 'OM',
        dial: '968',
        en: 'Oman',
        fa: "\u0639\u0645\u0627\u0646",
        ar: "\u0639\u064F\u0645\u0627\u0646",
        nsnMin: 8,
        nsnMax: 8,
        example: '92123456'
    }),
    Object.freeze({
        iso2: 'PK',
        dial: '92',
        en: 'Pakistan',
        fa: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0627\u0643\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '03012345678'
    }),
    Object.freeze({
        iso2: 'PS',
        dial: '970',
        en: 'Palestine',
        fa: "\u0641\u0644\u0633\u0637\u06CC\u0646",
        ar: "\u0641\u0644\u0633\u0637\u064A\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0599123456'
    }),
    Object.freeze({
        iso2: 'PL',
        dial: '48',
        en: 'Poland',
        fa: "\u0644\u0647\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0648\u0644\u0646\u062F\u0627",
        nsnMin: 9,
        nsnMax: 9,
        example: '512345678'
    }),
    Object.freeze({
        iso2: 'QA',
        dial: '974',
        en: 'Qatar',
        fa: "\u0642\u0637\u0631",
        ar: "\u0642\u0637\u0631",
        nsnMin: 8,
        nsnMax: 8,
        example: '33123456'
    }),
    Object.freeze({
        iso2: 'RU',
        dial: '7',
        en: 'Russia',
        fa: "\u0631\u0648\u0633\u06CC\u0647",
        ar: "\u0631\u0648\u0633\u064A\u0627",
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '89123456789'
    }),
    Object.freeze({
        iso2: 'SA',
        dial: '966',
        en: 'Saudi Arabia',
        fa: "\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC",
        ar: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'SG',
        dial: '65',
        en: 'Singapore',
        fa: "\u0633\u0646\u06AF\u0627\u067E\u0648\u0631",
        ar: "\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629",
        nsnMin: 8,
        nsnMax: 8,
        example: '81234567'
    }),
    Object.freeze({
        iso2: 'ZA',
        dial: '27',
        en: 'South Africa',
        fa: "\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC",
        ar: "\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0821234567'
    }),
    Object.freeze({
        iso2: 'ES',
        dial: '34',
        en: 'Spain',
        fa: "\u0627\u0633\u067E\u0627\u0646\u06CC\u0627",
        ar: "\u0625\u0633\u0628\u0627\u0646\u064A\u0627",
        nsnMin: 9,
        nsnMax: 9,
        example: '612345678'
    }),
    Object.freeze({
        iso2: 'SD',
        dial: '249',
        en: 'Sudan',
        fa: "\u0633\u0648\u062F\u0627\u0646",
        ar: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'SE',
        dial: '46',
        en: 'Sweden',
        fa: "\u0633\u0648\u0626\u062F",
        ar: "\u0627\u0644\u0633\u0648\u064A\u062F",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'CH',
        dial: '41',
        en: 'Switzerland',
        fa: "\u0633\u0648\u0626\u06CC\u0633",
        ar: "\u0633\u0648\u064A\u0633\u0631\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0781234567'
    }),
    Object.freeze({
        iso2: 'SY',
        dial: '963',
        en: 'Syria',
        fa: "\u0633\u0648\u0631\u06CC\u0647",
        ar: "\u0633\u0648\u0631\u064A\u0627",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0944567890'
    }),
    Object.freeze({
        iso2: 'TJ',
        dial: '992',
        en: 'Tajikistan',
        fa: "\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646",
        nsnMin: 9,
        nsnMax: 9,
        example: '917123456'
    }),
    Object.freeze({
        iso2: 'TH',
        dial: '66',
        en: 'Thailand',
        fa: "\u062A\u0627\u06CC\u0644\u0646\u062F",
        ar: "\u062A\u0627\u064A\u0644\u0627\u0646\u062F",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0812345678'
    }),
    Object.freeze({
        iso2: 'TN',
        dial: '216',
        en: 'Tunisia',
        fa: "\u062A\u0648\u0646\u0633",
        ar: "\u062A\u0648\u0646\u0633",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'TM',
        dial: '993',
        en: 'Turkmenistan',
        fa: "\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646",
        trunk: '8',
        nsnMin: 8,
        nsnMax: 8,
        example: '65123456'
    }),
    Object.freeze({
        iso2: 'TR',
        dial: '90',
        en: "T\xfcrkiye",
        fa: "\u062A\u0631\u06A9\u06CC\u0647",
        ar: "\u062A\u0631\u0643\u064A\u0627",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '05321234567'
    }),
    Object.freeze({
        iso2: 'UA',
        dial: '380',
        en: 'Ukraine',
        fa: "\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646",
        ar: "\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'AE',
        dial: '971',
        en: 'United Arab Emirates',
        fa: "\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC",
        ar: "\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'GB',
        dial: '44',
        en: 'United Kingdom',
        fa: "\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627",
        ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '07400123456'
    }),
    Object.freeze({
        iso2: 'US',
        dial: '1',
        en: 'United States',
        fa: "\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647",
        ar: "\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        nsnMin: 10,
        nsnMax: 10,
        example: '2025550123'
    }),
    Object.freeze({
        iso2: 'UZ',
        dial: '998',
        en: 'Uzbekistan',
        fa: "\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646",
        nsnMin: 9,
        nsnMax: 9,
        example: '901234567'
    }),
    Object.freeze({
        iso2: 'YE',
        dial: '967',
        en: 'Yemen',
        fa: "\u06CC\u0645\u0646",
        ar: "\u0627\u0644\u064A\u0645\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0712345678'
    })
]);
const $412e1a8a99c19c1a$export$84b76667b0a9e7b4 = $412e1a8a99c19c1a$export$4d78c43b7fa734a7[0];
function $412e1a8a99c19c1a$export$7684f8e22afec32c(locale) {
    const tag = String(locale || (0, $hlTfq.documentLocale)()).replace(/_/g, '-');
    const parts = tag.split('-');
    const region = parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p));
    const byRegion = region ? $412e1a8a99c19c1a$export$586b3eaa727579f5(region) : undefined;
    if (byRegion) return byRegion;
    const language = parts[0].toLowerCase();
    if (language === 'ar' || !(0, $eLeza.isIranMarket)()) return $412e1a8a99c19c1a$export$586b3eaa727579f5('IQ') || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
    return $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
}
function $412e1a8a99c19c1a$export$586b3eaa727579f5(iso2) {
    if (typeof iso2 !== 'string') return undefined;
    const key = iso2.toUpperCase();
    return $412e1a8a99c19c1a$export$4d78c43b7fa734a7.find((c)=>c.iso2 === key);
}
function $412e1a8a99c19c1a$export$21894a57509f6ed5(digits) {
    if (typeof digits !== 'string') return undefined;
    let best;
    for (const country of $412e1a8a99c19c1a$export$4d78c43b7fa734a7){
        if (!digits.startsWith(country.dial)) continue;
        if (best === undefined || country.dial.length > best.dial.length) best = country;
    }
    return best;
}
function $412e1a8a99c19c1a$export$3162e773cd568eb(country, locale) {
    if (!country) return '';
    const tag = locale || (0, $hlTfq.documentLocale)();
    const language = String(tag).split('-')[0];
    if (language === 'fa') return country.fa;
    if (language === 'ar') return country.ar || country.en;
    return country.en;
}
// ─────────────────────────────────────────────────────────────────────────────
// The one parse
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @typedef {'required'|'tooShort'|'tooLong'|'notMobile'|'invalid'} PhoneProblem
 * Why a number was refused. Each one gets its own message: "invalid" alone tells the
 * user nothing about which digit to go looking for.
 */ /**
 * @typedef {Object} PhoneParse
 * @property {boolean} ok
 * @property {string}  e164      `'+989121234567'`, or `''` when `ok` is false.
 * @property {string}  national  `'09121234567'`, or `''` when `ok` is false — and also
 *                               `''` for an accepted number whose country is not in the
 *                               catalog, because there is no national form to render
 *                               without knowing the plan.
 * @property {Country} country   The country the MESSAGE should name: the one the number
 *                               claims where it claimed one, otherwise the selected one.
 * @property {PhoneProblem|null} problem
 */ /**
 * @typedef {Object} PhoneOptions
 * @property {Country|string} [country]        A `Country` record OR an iso2 string
 *                                             (`{ country: 'TR' }`), so no caller has to
 *                                             import the catalog to name a country.
 *                                             Default: Iran.
 * @property {boolean}        [allowLandline]  Drop the country's `nsnPattern`. Iran only,
 *                                             in practice. Default: false.
 */ const $412e1a8a99c19c1a$var$resolveCountry = (c)=>(typeof c === 'string' ? $412e1a8a99c19c1a$export$586b3eaa727579f5(c) : c) || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
/** Does this NSN look like one of `country`'s? Length, plus — where the country declares
 *  one and the caller has not waived it — a shape. */ function $412e1a8a99c19c1a$var$fitsNsn(nsn, country, allowLandline) {
    if (nsn.length < country.nsnMin || nsn.length > country.nsnMax) return false;
    if (allowLandline || country.nsnPattern === undefined) return true;
    return country.nsnPattern.test(nsn);
}
/**
 * Drop a leading trunk prefix — the digits a number wears only when it is dialled INSIDE
 * its own country, and which are never part of the national significant number.
 *
 * **A trunk that begins with `0` comes off unconditionally.** In a plan that HAS a trunk
 * zero, no NSN begins with `0` — the zero IS the trunk, by construction — so keeping it
 * cannot produce a right answer, only one that is wrong by exactly a digit. Length bounds
 * are a check ON the NSN; they were never a way to choose whether to peel. Letting them
 * choose is what made `parsePhone('0218800000', { allowLandline: true })` — a Tehran
 * landline one digit short — answer `+980218800000`: the peeled body is nine digits and
 * misses Iran's 10/10 window, the trunk-kept string is ten and fits it, so the trunk was
 * kept and `judge`, with the mobile pattern waived, passed it on length alone. The number
 * was stored AND redisplayed («00218800000») wrong, stably and silently.
 *
 * **A trunk that is an ordinary digit stays conditional.** Russia's, Kazakhstan's and
 * Turkmenistan's trunk is `8`, and `8121234567` is St Petersburg — a real national number
 * that BEGINS with the trunk digit. There is no structural rule to appeal to, so the
 * heuristic is the best available: peel when the result is a number the country
 * recognises, or when keeping it cannot produce one.
 *
 * The `!fitsNsn(candidate)` half of that heuristic is also what makes a short Russian
 * number report "too short" rather than a shape complaint.
 *
 * ONE helper, used on BOTH branches of `parsePhone`. The live login theme peels the trunk
 * only on the national path, which is why it gets `"+98 0912 345 6789"` and
 * `"00980912 3456789"` wrong — and both of those are rows in tests/test_phone.py, i.e.
 * shapes this platform's data genuinely holds. This is the single rule here that the theme
 * does not yet have; it is filed as a follow-up against parsina.keycloakify. The theme's
 * direction is the safe one (it refuses rather than mis-reads), so the symptom there is a
 * rejected login and never a wrong number.
 *
 * What this function does NOT do is peel a SECOND zero. One trunk comes off; a string
 * wearing two (`+43 0 0664…`) is not a number this module claims to understand, and
 * `judge` refuses it rather than guessing which zero was the trunk — see the guard there.
 */ function $412e1a8a99c19c1a$var$peelTrunk(candidate, country, allowLandline) {
    const trunk = country.trunk;
    if (!trunk || !candidate.startsWith(trunk) || candidate.length <= trunk.length) return candidate;
    const without = candidate.slice(trunk.length);
    if (trunk[0] === '0') return without;
    return $412e1a8a99c19c1a$var$fitsNsn(without, country, allowLandline) || !$412e1a8a99c19c1a$var$fitsNsn(candidate, country, allowLandline) ? without : candidate;
}
/**
 * Iran's rule, exactly as the twins write it: drop a leading `+`, then peel `00`, then
 * the country code `98` when what is left would be too long to be an NSN, then the trunk
 * `0` — and require the remainder to be `9` plus nine digits.
 *
 * A LINEAR PEEL, not a catalog lookup, and the difference is the whole point of this
 * function existing. The peel never asks which country `990…` belongs to, so
 * `+9901234567` is read as the 0990 mobile it is. Asking the catalog instead is how this
 * kit used to answer `+9901234567` where both twins answer `+989901234567`: no row starts
 * with `990`, the number fell through to the generic "some foreign country" accept, and
 * `lookupVariants` then offered ONE spelling. A Keycloak probe in that spelling misses the
 * same person stored as `09901234567`, and the auto-provisioning flow mints a duplicate
 * account — the precise harm this module exists to prevent. Seventy-four live Iranian
 * ranges (0940–0949, 0950–0959, 0960–0962, 0967, 0969, 0970, 0972, 0975–0979, 0990, 0991,
 * 0996, 0997, 0999) were wrong that way.
 *
 * Line for line this is `phone.py#normalize_phone`'s body after its shared prelude, down
 * to the sequential `if`s — they are NOT mutually exclusive there and must not become so
 * here, because `+00989…` wears all three prefixes at once. `phone.test.js` executes this
 * against the real Python over a generated corpus so the two cannot drift silently.
 *
 * @param {string} s  Folded, separator-stripped, already matched against `DIGITS_ONLY`.
 * @returns {string|null}  The ten-digit NSN, or `null` when this is not an Iranian mobile.
 */ function $412e1a8a99c19c1a$var$peelIranianMobile(s) {
    let t = s;
    if (t[0] === '+') t = t.slice(1);
    if (t.startsWith('00')) t = t.slice(2);
    // The `length > 10` guard is what keeps 9812345678 — an ordinary 0981 mobile — from
    // being read as country code 98 followed by an eight-digit stub.
    if (t.startsWith('98') && t.length > 10) t = t.slice(2);
    if (t.startsWith('0')) t = t.slice(1);
    return $412e1a8a99c19c1a$var$IR_MOBILE.test(t) ? t : null;
}
/**
 * The last word on an NSN once the prefixes are off it.
 *
 * The first guard is not a length rule and deliberately runs before the length rules: in a
 * plan whose trunk prefix is a zero, an NSN that still BEGINS with one is not a number
 * this module can read. `peelTrunk` takes exactly one trunk off, so a leading zero here
 * means the string wore its trunk twice (`+43 0 0664 123 4567`, and 94 shapes like it
 * across 17 of the 52 rows). Accepting it was worse than refusing for a reason that has
 * nothing to do with the user's typing: `+430664123456` fed back through this module
 * peels the surviving zero and answers `+43664123456`, so the kit emitted an E.164 it
 * would later read as a DIFFERENT phone — the one thing a matching key may never do. A
 * number cannot be both, and guessing which zero was the trunk would be inventing data,
 * so the answer is `invalid` and the value is refused whole.
 *
 * Italy is the reason this is gated on the trunk rather than written as "no NSN begins
 * with 0": Italian landlines genuinely keep their leading zero (`+39 06 …` is Rome), which
 * is exactly why Italy's row carries no `trunk` at all.
 */ function $412e1a8a99c19c1a$var$judge(nsn, country, allowLandline) {
    const digits = country.dial + nsn;
    const fail = (problem)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (country.trunk && country.trunk[0] === '0' && nsn[0] === '0') return fail('invalid');
    if (nsn.length < country.nsnMin || digits.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
    if (nsn.length > country.nsnMax || digits.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
    if (country.nsnPattern && !allowLandline && !country.nsnPattern.test(nsn)) return fail('notMobile');
    return {
        ok: true,
        e164: `+${digits}`,
        national: (country.trunk || '') + nsn,
        country: country,
        problem: null
    };
}
function $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options = {}) {
    const selected = $412e1a8a99c19c1a$var$resolveCountry(options.country);
    const allowLandline = options.allowLandline === true;
    const fail = (problem, country = selected)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (typeof raw !== 'string') return fail('invalid');
    let s = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    if (s === '') return fail('required');
    if (!$412e1a8a99c19c1a$var$DIGITS_ONLY.test(s)) return fail('invalid');
    // ── The twins ──────────────────────────────────────────────────────────────────
    // `allowLandline` does not switch this off: a landline is not an Iranian mobile, so the
    // peel declines it and the catalog below is what accepts it.
    if (selected.iso2 === 'IR') {
        const nsn = $412e1a8a99c19c1a$var$peelIranianMobile(s);
        if (nsn !== null) // Iran's trunk is `0` and its row is fixed (see COUNTRIES): `0` + NSN is the
        // national spelling, `+98` + NSN the canonical one.
        return {
            ok: true,
            e164: `+98${nsn}`,
            national: `0${nsn}`,
            country: selected,
            problem: null
        };
    }
    // ── The generalisation ─────────────────────────────────────────────────────────
    let international = false;
    if (s[0] === '+') {
        s = s.slice(1);
        international = true;
    }
    if (s.startsWith('00')) {
        s = s.slice(2);
        international = true;
    }
    if (s === '') return fail('required');
    if (international && s[0] !== '0') {
        const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(s);
        if (country === undefined) {
            if (s.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
            if (s.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
            // Accepted, with no national form to offer and the picker left where it was.
            return {
                ok: true,
                e164: `+${s}`,
                national: '',
                country: selected,
                problem: null
            };
        }
        return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(s.slice(country.dial.length), country, allowLandline), country, allowLandline);
    }
    const candidate = s.startsWith(selected.dial) && s.length > selected.nsnMax ? s.slice(selected.dial.length) : s;
    return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(candidate, selected, allowLandline), selected, allowLandline);
}
function $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).e164;
}
function $412e1a8a99c19c1a$export$f9c4d85d720ef909(raw, options) {
    return $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) !== '';
}
function $412e1a8a99c19c1a$export$317852993b4735b6(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).national;
}
function $412e1a8a99c19c1a$export$1069b069fb83ae5b(raw, options) {
    if (typeof raw !== 'string') return '';
    const parsed = $412e1a8a99c19c1a$export$48c6adddc5539199(raw, {
        ...options,
        allowLandline: true
    });
    if (!parsed.ok) return raw;
    // A number from ANOTHER country is shown internationally (PM-0078). A national
    // spelling carries no country, so `07400123456` on a desk in Tehran is dialled as an
    // Iranian number; `+447400123456` cannot be. Compared by dial code, not row, because
    // `+1` resolves to Canada whichever of the two the caller called home.
    const home = $412e1a8a99c19c1a$var$resolveCountry(options?.country);
    if (parsed.country.dial !== home.dial || !parsed.national) return parsed.e164;
    return parsed.national;
}
function $412e1a8a99c19c1a$export$1f64b92865689d0d(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length < 7) return raw;
    return `${raw.slice(0, 5)}***${raw.slice(-3)}`;
}
function $412e1a8a99c19c1a$export$493e0fb9b5aae030(raw, options) {
    const e164 = $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options);
    if (e164 === '') return [];
    const digits = e164.slice(1);
    const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(digits);
    // An accepted number from outside the catalog has no known plan, so there is no trunk
    // prefix to add and no national spelling to guess at. One shape — the only one we
    // could ever have written.
    if (!country) return [
        e164
    ];
    const nsn = digits.slice(country.dial.length);
    const seen = new Set([
        e164,
        digits,
        `00${digits}`,
        ...country.trunk ? [
            country.trunk + nsn
        ] : [],
        nsn
    ]);
    return [
        ...seen
    ];
}

});
parcelRegister("hlTfq", function(module, exports) {

$parcel$export(module.exports, "rialToToman", () => $ca1f40e638c62a9a$export$d3105a4d9be2f59);
$parcel$export(module.exports, "stripAmount", () => $ca1f40e638c62a9a$export$8a2f5adb56df4f49);
$parcel$export(module.exports, "groupAmount", () => $ca1f40e638c62a9a$export$302430bce3371cb8);
$parcel$export(module.exports, "numeralsFor", () => $ca1f40e638c62a9a$export$20975da26e036f6b);
$parcel$export(module.exports, "documentLocale", () => $ca1f40e638c62a9a$export$594d280e896fc02b);
// Money — the one place the toman/rial boundary lives.
//
// Every service, every gRPC message and every GraphQL field in Parsina carries WHOLE
// RIALS. Iranian clinics quote, type and read TOMAN. Ten rials to the toman, and the
// conversion happens here, at the display edge, and nowhere else.
//
// Getting this wrong is not a cosmetic bug. A rial figure printed under a toman label
// reads as ten times the money — a 500,000 ت visit shows as 5,000,000 ت — and a toman
// figure typed into a rial field bills a tenth of what the cashier meant. Both of those
// shipped, in opposite directions, on the same screen.
//
// So: rials cross the wire, toman meets the human. Anything reaching for
// `.toLocaleString()` on a raw rial value is a bug.
//
// A clinic may keep its books in another currency: `currency.js` handles any
// allowed one, and for IRR each of its functions returns exactly what this file's
// does. New code that shows clinic money takes the document's currency and uses it.
// With its extension: phone.js imports this module under Node's own ESM resolver
// (see the note there), and Node does not guess one.

var $eLeza = parcelRequire("eLeza");
const $ca1f40e638c62a9a$export$166519e0fc2d4fb3 = 10;
const $ca1f40e638c62a9a$export$d3105a4d9be2f59 = (rial)=>rial == null || rial === '' || !Number.isFinite(Number(rial)) ? null : Number(rial) / $ca1f40e638c62a9a$export$166519e0fc2d4fb3;
const $ca1f40e638c62a9a$export$496c2c39d7e0791 = (toman)=>{
    const n = Number(String(toman ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * $ca1f40e638c62a9a$export$166519e0fc2d4fb3) : NaN;
};
function $ca1f40e638c62a9a$export$1736ebd23f2adeaf(rial) {
    const t = $ca1f40e638c62a9a$export$d3105a4d9be2f59(rial);
    if (t == null) return "\u2014";
    // Sub-toman precision cannot exist (prices are entered in toman) but a percentage
    // discount can land on a half-toman; show it rather than silently rounding money away.
    return t.toLocaleString('fa-IR', {
        maximumFractionDigits: 1
    });
}
function $ca1f40e638c62a9a$export$cbc4bde7d9461cfb(n) {
    if (n == null || n === '' || !Number.isFinite(Number(n))) return "\u2014";
    return Number(n).toLocaleString('fa-IR');
}
function $ca1f40e638c62a9a$export$3d047decf6215cd7(input) {
    if (input == null || String(input).trim() === '') return NaN;
    return $ca1f40e638c62a9a$export$496c2c39d7e0791($ca1f40e638c62a9a$var$toAsciiDigits(input));
}
// Persian/Arabic-Indic digits → ASCII, so a pasted or typed «۵۰۰۰۰۰» parses.
function $ca1f40e638c62a9a$var$toAsciiDigits(input) {
    return String(input).replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))).replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)));
}
function $ca1f40e638c62a9a$export$8a2f5adb56df4f49(input, allowDecimal = false, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    let raw = String(input ?? '');
    // A locale whose decimal mark is not «.» (Persian uses «٫») would otherwise have
    // it stripped as punctuation, silently turning «۱٫۵» into «۱۵». Grouping marks
    // need no such care — they are non-digits and are meant to go.
    if (allowDecimal && numerals.decimal !== '.') raw = raw.split(numerals.decimal).join('.');
    let s = $ca1f40e638c62a9a$var$toAsciiDigits(raw).replace(allowDecimal ? /[^\d.]/g : /\D/g, '');
    if (allowDecimal) {
        const [intPart, ...rest] = s.split('.');
        if (rest.length) s = `${intPart}.${rest.join('')}`; // collapse extra dots
    }
    return s;
}
function $ca1f40e638c62a9a$export$302430bce3371cb8(value, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    if (value == null || value === '') return '';
    const s = String(value);
    const neg = s.startsWith('-') ? '-' : '';
    const [intPart, ...rest] = (neg ? s.slice(1) : s).split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, numerals.group);
    const out = neg + (rest.length ? `${grouped}${numerals.decimal}${rest.join('')}` : grouped);
    // Only the ASCII digits are remapped; the separators are already the locale's.
    return numerals === $ca1f40e638c62a9a$export$4b87c97d2471ab43 ? out : out.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
}
const $ca1f40e638c62a9a$export$4b87c97d2471ab43 = Object.freeze({
    locale: 'en',
    digits: Object.freeze([
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]),
    group: ',',
    decimal: '.'
});
const $ca1f40e638c62a9a$var$numeralsCache = new Map([
    [
        'en',
        $ca1f40e638c62a9a$export$4b87c97d2471ab43
    ]
]);
function $ca1f40e638c62a9a$export$20975da26e036f6b(locale) {
    const key = locale || 'en';
    const hit = $ca1f40e638c62a9a$var$numeralsCache.get(key);
    if (hit) return hit;
    let resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    try {
        const plain = new Intl.NumberFormat(key, {
            useGrouping: false
        });
        const digits = Array.from({
            length: 10
        }, (_, d)=>plain.format(d));
        // 1000.1 exercises both separators in one pass; a locale missing either
        // (none in practice) falls back to the Latin one rather than to undefined.
        const parts = new Intl.NumberFormat(key, {
            useGrouping: true
        }).formatToParts(1000.1);
        const part = (type, fallback)=>parts.find((p)=>p.type === type)?.value ?? fallback;
        resolved = Object.freeze({
            locale: key,
            digits: Object.freeze(digits),
            group: part('group', ','),
            decimal: part('decimal', '.')
        });
    } catch  {
        // An unsupported or malformed tag is a caller bug, not a reason to stop
        // rendering a price. Latin digits are always readable.
        resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    }
    $ca1f40e638c62a9a$var$numeralsCache.set(key, resolved);
    return resolved;
}
function $ca1f40e638c62a9a$export$594d280e896fc02b(fallback = (0, $eLeza.brandDefaultLocale)('fa')) {
    if (typeof document === 'undefined') return fallback;
    return document.documentElement?.getAttribute('lang') || fallback;
}

});


parcelRegister("fMnXH", function(module, exports) {

$parcel$export(module.exports, "flagUrl", () => $b7cded1008753984$export$a2b8715397522463);
// GENERATED by tools/build-flags.cjs from flag-icons 7.5.0 (MIT, lipis/flag-icons) — do not
// edit by hand. 40×30 PNG (2× the drawn 20×15), base64, one per row of COUNTRIES.
// prettier-ignore
const $b7cded1008753984$var$PNG = {
    IR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////aAAAjn0BcuHLjQEDnVVVuwIHrc3P+9PTvjo72+/f74uKHy5fzqqqU0aOk16+XZwNwAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAr0lEQVR42mNQwgIYBqGgsbFxMhCCgRkQggDDmWPJf8yepZ05lvYmLe9wXlrOmbQ8Bi4uLoYFCxZwcXVvAJFgDgMMcG+fsYEBHczdXn0TXYy7nL2gHF0p51X2gtgJaIK8VzgLfC+ga58+s7ISw6bbriF7MWznuCiLUMjBwcHQ0NDAwcG9AUSCOQwhLiEuri4uYMoVzHZ1YagsDZ0eOrUUTFWWxIaGTw+NZBDEAgahIAAf7Fwe+04+vAAAAABJRU5ErkJggg==',
    AF: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEW/AAAAAAEAmQCAEQCAAADdeHfRRUXLMDDVVlbFFhbhhYTZZWTvvrzppqXDDQ2BDgJ/AJzcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeUlEQVR42mMQBAMRBjAwUgIDhqEmyJlRXoAhOG1aexm6IFvf87oXCWiCMxL2nGbrRBNMrYs5+jwMTbAnO7x02wk0wdCdMamzQ9EEdzXEHuVYjSZYkXYrKq0dTZDr6vTKmAVogpytV3dFTED30ay7d1diBsgDviEXcQB/Wk8LWL2d8wAAAABJRU5ErkJggg==',
    DZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AYjPREDQTWzP87vG5GTP2z9bldopePTN6MjP++/zslaXeTmlERzPytsGQKjOhIQw3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mMQhAMGBBgcgsI39jmgCwpPUlJSd0ATNFXSTPErQxUUDlI1ZGBgc0ARlFQKFmTgcliAImik1CjowJ6Aqv2SkqHgniI0wSZVQcE1SqcdCAti1Y7VIqxOwup4rN7EHiBYg24QRTEAq40s8eFvTBUAAAAASUVORK5CYII=',
    AM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEXZABIAM6DyqACw8tlJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZAEAsY2oJKWMCQFgQAQLMn2UPulzIAAAAASUVORK5CYII=',
    AU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAIv/AgL//Pz/bGyNi8rd3fBUVLEYGJZzc780NKO2str+iIn/JSX/yMjvoaq2g62b1p0wAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+klEQVR42mMwimTg2CjswDDvNAMC2FxqAAly2FxCEsyW1qrYKOy+5pAakiDnG6OQjcLrhFULkAQZWGwubRS+c8kBoqQTLKcEBBuFQSSIx6YEFhSEAxCPQzUBU5AhjQGLIASgmgkCIAM4dM9uFNY97AAT4wgtYGBf9GbLRuGlyqeA1k4AOxFo11TlcyAfLXrzjKE0AqzUhYEBqBHkdxbdwwypKjAjHm6DhNJUZQYOBwYcgBObYNIELIKVMAZ7ARZZjgZMsZRZkW4YglxKSgGYupWU4PphdrMvUlLSglrFFgUVZZ8WpJoJFWRRSoDpiVoKN2oJnLWAi4GaAACk7z96Qd+VoQAAAABJRU5ErkJggg==',
    AT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX////IEC5cagsYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYhrTg8APDLo4As4YakeJ1P9cAAAAASUVORK5CYII=',
    AZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEU/mzUAueTtKTk/nDXuM0P////sKjnxV2Pza3b4qK/2lJz1iZHyanX1ho/6wsb6wcaXspUqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFJJREFUeNpjEMQCGIa0YJISBKjvLlKCAZigytM5vU7ognoxSkolTmiCpZOUlDpXoAluPaSksjTKiQhBrNr1sVmk8nUGppOU1PciOZ7ZGBMMaUEAYGdewLA+W8AAAAAASUVORK5CYII=',
    BH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAJ1BMVEXOESb////SJTjtp6/++Pn1z9T66evmiJLXPU7gaHXPFirQGC3icH2vW5DzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAKUlEQVR42mMQFBSM2cCABoCCgukKWAQFnRuIFMSmPXIBFotGbR95tgMA4tMe9v5fIp8AAAAASUVORK5CYII=',
    BE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXbuwr5hhoAAAH/2QzzGDDlGv6LAAAAAnRSTlPHx/co26IAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAaSURBVHjaY1ACAwVjMBBxAQOGUcFRQVoKAgBG03Gtsi/apQAAAABJRU5ErkJggg==',
    BR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX45QkinkUrSaM+WaXa2RWbubxesjQ9pz20zhyJwChmfrhVaYXGvzGgoku93cV8h2YIpy45AAAACXBIWXMAAC4jAAAuIwF4pT92AAABA0lEQVR42mMQxAIYyBBMccMUlGBgaEcXFHNgYGBJRBUUb2AAAo5CFMEEBt7N1n8YOJEFKxh4jJSUlLZAjQULSjIwXAKKKSk7MEyECQIN5FECgw0MLIVQwQkMDKyhoYuBgroMYGOBgiVAe4+Ghr4LXaSkDWS6gQQlQY65paSkFffUSAnoWoZGQQaQqxkYPoFMXPpK6QADyA9wQS2g6LpgqCBE+yVjJeXFSspxIBXtIItSgIxTRkbKQHFTmEVgJ3ErKyktUlK2Bfof5ngHoOOBZhobb4CEFLI3FxkjeRMaIEbAAHFHDroUBt7d6EGHPZDB0QExEDniJLFEHPYoFhQsJCPZAACz20xO82VhQQAAAABJRU5ErkJggg==',
    CA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXqlY/pk4zplI3////VKx7qkYrjb2fYOCz++fj1y8n87u3zwL3uqqT54N7eVUvlfnalRQo6AAAAA3RSTlPEwsLgduwSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAi0lEQVR42mNwAQIHYzgQAfEZ6C9ouhiL4PJgTMHdIbXBGIJTXFyS0QU7lri4BDejCu49Zu7isvPVXBTBFJcwF5ftLr4ogkdcwKAYWdDiC0SwEpvKVyiC1iUg2q0Z1UnTQXQwmjttgJQf0PEqKIIx2+bEN6MJGhubNWMJJbPFxApagrWrDFAUQwDYdgDA65dwevVm0gAAAABJRU5ErkJggg==',
    CN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXuHCXvJiP//wD0ahj94AX5ow/xRh7vLSL8zAjzXhr+8AL4mxD5swzvIiTwMCL1ehZhA9qiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZklEQVR42mNgwAMYsQluRRdgZmDg3foATVBKgIGBjx1N0MgASLAGoGh2WbTEmYGhNBBFYYaSSgJQP5o9SsqYruHx9wGSbAkogqIF0kDrKxqxuJ5zAoYQbyY2b3Y8wBIemQyjgBoAAEO/DOML4QfFAAAAAElFTkSuQmCC',
    CY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////UdgD07uT7+fXaiCHLzsK9wrPpuXzuyZqvtKLe4NjeljvlrGP027ydpI2Olnz/VpYUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAn0lEQVR42mNgoAMwwBRiLlfAFCtpwFTYsheFq6HEwKC+URxVjaGgiKOgNJpmRUEgkEURuuK+ESQogWxnraMgBFxAEt0IEfLxOYwkWAgRRLXGBCwmg+oZDqCZItvRPch74giGn1mVGSzAzlBDEuR6CqVfIQvOnACmZ2Yh69dPA4mmxS9ACUe9sEnMU+OUUa1iWvY19OUqjPA1TTNgoDsAAH0MH3woys8hAAAAAElFTkSuQmCC',
    DK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAADFBMVEXIEC7////QM0zXUWbL25x8AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJ0lEQVR42mNgAANFQSEGDDDsBZXAwFBQWAkBGASxAEoFsVo0gkMeANYLEN9rIYw3AAAAAElFTkSuQmCC',
    EG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbt4LPm05f279n7+O/q2abz6cvv473gyH/SsUfizYnSsUjUtE7UtE+FUiyCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVR42mNQwgIYhrQgHHAGMGAANtaABAzB5ow2CwxB6+M1mzEEq9es2o4h6Lui6wqGoL+x8RMMQfcWjxIMwWTLydMwBFknGyNcL4gFDGlBAONAN6Idm2N7AAAAAElFTkSuQmCC',
    FI: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAHlBMVEUAL2z////n6/HZ4On19/n2+PrFz933+Prf5eze5OxGbJvuAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAM0lEQVR42mMQBIECBgYGZkE4YACTAUNUUAkEGoCCbEpwwDBUANi1E9AcD/aXAza/D1FBANf4HwFP43uLAAAAAElFTkSuQmCC',
    FR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAJH////hAA/1qq+qqtocVNyOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGklEQVR42mNgAAMWQTAwUgIDhlHBUUFaCgIANE0qMRXTPuoAAAAASUVORK5CYII=',
    GE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAIVBMVEX/////AAD/xMT/6en/KCj/ODj/uLj/aGj/t7f/Nzf/Jye3ao04AAAACXBIWXMAAC4jAAAuIwF4pT92AAAATElEQVR42mNggAJGQUEBBnRAlCBTEUJQXQEqyCGGEGxMgIgxu4o6wwStJoYYYAiaBM4ywK0du0WUOF4QC6Cf4ACFvEkg1pAPoWfIAwBUiRrZ67e50QAAAABJRU5ErkJggg==',
    DE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUAAAH/zAD/AABTrXiPAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    GR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWXudzc5/N0otAvdLlkmMzO3u6JsNdomswWZLFHhMH///8NXq9elMpdk8mvyuWUuNy9t6ayAAAACnRSTlPHx8fH7fnw4O3tua1jCQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFxJREFUeNpj2L1796lVu1EBA+mCEwURAC54axUCYBc8c+bMr1VAwoEBCcBkXyNbRLwg8bbjFWw2RgASAsTFxSU1FEgUKSEAwyosgATB3VgACYKCWAAJtmMFlDkJADpQb8rhqOSNAAAAAElFTkSuQmCC',
    HU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEU4jQDUNRb////UNhf//f0fKhQYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHUlEQVR42mMwxgIYBLGAISPoggUwKGEBQ0Zw2AEAn7AtKfgzYVIAAAAASUVORK5CYII=',
    IN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/////mTMSiAfj4/JjY7hlZbiUlM1bW7TW1uy3t93X1+yVlc1ubrzY2O1gYLVubrvbBsOsAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAQ0lEQVR42mMQxAIYhrQgXsDsGncBQ9DcanExhqDz7EwTDMGI/NOtmIJ7vmEKPp6WaYoheB2bRcwuLgb4Ha2EBQxpQQB5PzXw6CctoQAAAABJRU5ErkJggg==',
    ID: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXnABH///9GPYQdAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mNgGAXkAkEsYFSQGEEARNwT7a82wgIAAAAASUVORK5CYII=',
    IQ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbe7uZsso/n8+2z2MYAej1bqYLO5tqEv6L0+ven0bwrkV5CnG8HfkLIbu0WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNQwgIYhrQg6YCH4QADp9kGVMFlDA0MYS6oglwHMhsYUlAEOaNmrOro5nniEoAkyPa/vLzuBW/5lQvItmQaG5uGshqbGpDqPkEsYEgLAgC7sTrOTPRwzAAAAABJRU5ErkJggg==',
    IT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXOKzf///8Akkaq28HvuLydaqNBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVR42mNQAgNlQTBwYICAUcFRQVoKAgAHkC93JNeyBwAAAABJRU5ErkJggg==',
    JP: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///+8AC3z09u+BTH//v7+/P3WYX3BEjz22+HegpjsuMXUXXrtusb23uTeg5nBEz3t9p09AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mNgoDdg1VoUgC7GkS4oWNaAKsYyWRAILB1QBL0FwWALiuBEiKAkshivIURQGNlUNkEoSEASjIcJliIJKsIEhZAED8IEpbAJyhDSjtUirE7C6niYN+UIBwgk6OwcCAcy9uigOQAAuKIYLYzUZfoAAAAASUVORK5CYII=',
    JO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/AAAAAAH///8AmQD+AAD/QED/srLEAABNAAHEIwBNawD/Dw//6Oj/qKj/KytAcwA4JMd5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAe0lEQVR42n3Puw2AMAwE0GuokJBYgRWyACNQUTJHZqFhBQZiGHBCjH/iqtNTItvIow/mHCFyhF4JnRa0WtHoi1obKmWUii/r1IJIESn1vju1ln4t+i21IUJs0fdo0N9KYnk+c08cRmGM0hoqe1FbRWMFrRE6e9BbwuEt3d6mRppivxM/AAAAAElFTkSuQmCC',
    KZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAq8L/7C19y3mKz3EWsbVNv5VvyIE6uqAjtK1lxYcMrruZ02mz2Vqm1mHM4Err5zn1kEx1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA60lEQVR42mNgwArcvbAIqu3CInj2BhbBTbewCJ7GptJsC5Th4YAQnJwAoTuVNBtgYizWqWCaNT0yXBUmyGVpAabb4gTlIwugghw2EPmpDwUFv2vBlCZPAZuiKigoKJQB9xFYmkUTKCidDhPcfAVkzRKQSuGMpTDHHwESwQrTPwoKimslByAJxv1qihcUnFnwLgFJe18S6/Rs9Wmc5wqQLGIOn1CkllRQXuOA5CSuLa1d7V1LoyxQHO/MkJyerLCoAMWbXCUMng4s09EChIHTisE4AD3oOKL3bMcMZILRgTXisEYx1sSANdlgAQBsEkHVTQYmTgAAAABJRU5ErkJggg==',
    KW: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////zGDAAAAEA2UEAgidRCBEAQRQADgUAwzoVAgWkECABAQIFBQYICAngFizfFiwsWLaJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mPIMMYEDOrOWASV1JqxCCqVYBNUysAmiGEsSBDDWLAgurEQQTRjoYKoxkIFlTYwIAPqCB6gTPACRYKaCwWRAFQwThBTcJYgpqDqQ0xBVAOhgnGCmIKzBDEFVT9iCmIYCBKMxxQTBABu501a6aV2MQAAAABJRU5ErkJggg==',
    LB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX4sLTTr6WhrpH////uFh8CqVFNw4UotmvZ8+UWsF9jypSH1q05vHej4MDA6tTt+fModX5RAAAAA3RSTlPAyNIAJ7wgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVR42mNwwQIYBlYQDhgRTAZjGGivgDPhgvZTQ/MwBM1mVkZ+Rhd8vm169GU0wV9hx1Zlogv2LgsNrZnWjCrYFnpsaWjZZRRB2/CdoaWhYaiCFtdjQkOrV1agCPZEhq06Gpq2G0Vw28rQ0ND0qedQBL+t/REaamyxvRnV8dahoY/RvWmx6t1xeIjAAosJGHZC8KAbfFEMAFLInkrFWlo3AAAAAElFTkSuQmCC',
    LY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAAHnABMjnkYQSiJ7AAoNDQ5BQUJsbG2jo6MkJCW3t7eWlpZ6AAri4uLt7e3///9apKbEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAARElEQVR42mMQxAIYBlbwiAsG8GGgFqgowxTjWsoQGYAuWBvAwLYzAU2wm4Eh498EYgSxasdqEVYnkQmMsQAGJSxgYAUBQNozH9QbWmcAAAAASUVORK5CYII=',
    MY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUBAWXMAADUJib////nh4fibm7wtrbcTk5qVTwrIlX429upBBbyu7v7yQGwjCDitAxVRiJQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAApUlEQVR42mNggANBOGAgILgKDkA8zglgQWM4AHI4/nVgan8/gYFz5gRUQY4bDAwzOjoZGFzggIGB/wMDw7y7L1HN5H3AwNl79wcDQzkcAFUCBfvv/piAYibfBQaGjv8dqCo57wEtm9mA5s5eoCUg55+BA5CH+jpIDBAUM7EI7oYDJO2CWABDGhaAZBKSmUpYAHYzQ7EA7Ga6YAHYzcRqO1YzsQkCAB2DeG8b518IAAAAAElFTkSuQmCC',
    MR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAYjPNKj5mRjn/xAAcbS2goBI9eSaHlhjouwR0jxsQaDDFrgv4wQFchSCwphAscyohwGQSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjklEQVR42mMQxAIYKBRUwgIY8AO2BCyC7AWYYu4V7SWYupst0PSDuMXmICkkwQlAvPM2kOBEEgxhYOD6wL+AgcEVSbASxpiOJHhjAYTm6kUSXPMAQvOdQhJkNYXQwQFIgizN+0HUbwsHZIfmGL91YLlnfAzNP8ZAgO4nV5BgCLrfPaO3TmGgEsAacTRIIQCjVisn0uVIegAAAABJRU5ErkJggg==',
    MA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXBJy1mQi+uLS1uQDClLy5aRjAUWzIyUjEZWjKbMi57PC+NNy83UTF1Py8NXjNWRzBcvfykAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVR42mNgGL6AxQGLIKMAFkH2AgwhztAf/aET0EVXHLbpwrTn7T1Mm5jK0hUwBJmztxlgukiBSYBhZAEA3FMKXRTvT/sAAAAASUVORK5CYII=',
    NL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUhRouuHCj///+QNKGcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mMQxAIYhrSgEhYwtAWHHQAA8cMn2RePrhMAAAAASUVORK5CYII=',
    NZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAJH3JES/++/wCImrklaPQMEnefo+PlbYcOoFpdKWBhKzYYnVCW5e3scfyxc3n4ukbs7NpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVR42mPY9MPYylGs2PhICAMCbH00GSRolfoISXCKiC5QsOLqfk0kQYurm747il0J029GEjQ23/rIUezpo2JjJEElIHAUA5Fg7gEwKQgHIB5nVgMWwTAsKnlmYTMTarulfpyjmF4Y3HZ2kDsvPfV1FLuvHQt05wmQ4NIbDAzn1WK7gD665OrDwLkN5KDjExgY9KOLQX4314tm4IiGmenqAwml89oMHCcZBhhMwCLWuesApiCXNBaVnMsZBhwAAPtnOCIlvtmpAAAAAElFTkSuQmCC',
    NO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAJmTtKTn7ys4fQHf///8EKWb+8vMDntwIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPUlEQVR42mMQBAEhZwYTRUE4YBh+gkogoAYUTFKCAwYXMAAKuiAAgzEYmDIEGyMAA/EAq3asFmF10siIDgBIBDxNHFl+NQAAAABJRU5ErkJggg==',
    OM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXvLSn///8AkCX6ubjHPSjaNSjxQT397ez2gX/4nJrzYV/709LwOTX5sa/7yMf1dXKxEGopAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNgAIFEQRTAwLDgNxemYOf5xZiC7LfLMAR5i8t3b0AX5LIsP9GAob23sgGLRQxrD6ALcj5g4HiAoRIEDhujAIahD1hcUABEMEgJBQxpQQDyzjeG2etjuwAAAABJRU5ErkJggg==',
    PK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUMWQv////J2sg2djUWYBVtm2yyy7FWjFYmayXe6d79/v1+p36dvJz3+veGrYZOh01DlvGiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeklEQVR42mMQBAIFBjQwiAXZGzAFWVIZGDjQBdkmMDBwhzagChY+YGBoE0NTqVjAwPDnpgGKIMtCoCDzBlTtzIIBQMscGNAEEzDdyXJxMRbHJ0o6YApaCU4GckpQBfkEpVK/bwpA8/teIH0VPUCYTwrOacAMOofBHJsAmkIgJ8nEUEMAAAAASUVORK5CYII=',
    PS: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXtLjgAljkAAAD////IMzOWVDiXHST82tzwT1fuNT/4q68qhDlfEhZfbDgqCAr0eoGf0o+MAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeElEQVR42o3OsQ2AMAxEURcpKKDwCqzAJKyQFdiGLViJFViAxImQ8Z0QLp90X5Y840k6CcrIUDJDDBTEQEUIGMaAYQw0DIGOw7a46yg7Q7kY+sCDPvCNdH79fIk+v6q/ZpMipoPge9wwjA3j2DCOK8K4II4L4lj1BvDTQ+3mvvDBAAAAAElFTkSuQmCC',
    PL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXcFDz////vuDXSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    QA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWNGz3////z5ummTGfhw8ytWnPChZiTKEjRpLHZs76ZM1KzZ378+fratcD69fe7dovPfIyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANElEQVR42mMQBAGN7QwoACwoKOOKKSg0fwGm4GUGbNqfJBMpiFU7VouwOgmr40d9NJh9BABnYibF3uZjAAAAAABJRU5ErkJggg==',
    RU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEX////VKx4AOaYLRJEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    SA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUWXTHD1so6dlCUtKC6z8KevKkqa0J6o4pXi2tKgV+JrZdumn+sxbbT4dhjk3Xo7ur50TcyAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVR42mNgGJyAc4Ym97Tq1ZrTlBQS4IJJzme0H04vtIhqiToAF1SWjepwPeIuveqJXQBckM+1OGlXh9M148rrCEH24v/iocqXgo1nxxrABdkqgqdFyV80X5xheAxhkWCwbqPNo2XLj9SZwQVniEQvdOrRm5LTtO8AFhez0SdgmFC5hoKCgrIivi4KmCq5SxUGaeQyAABIGCoBr6ooaAAAAABJRU5ErkJggg==',
    SG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXfAAD////mMzPhDg772NjudXXpS0vkJibrX1/1qKjwh4fznJzjHBz3wMD85OT97OwLMeD+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYklEQVR42mNgIAEwrUzAFNzoxKCALsYtf4DHFV1QUZSdIYkdTXChzNkABpUGVMGJAhwJDKxopm4UZjAAQlTQKMa8lekSmiCLCMMK5uloguwPJ2PxkdWTBAaygSAWMCpIjCAAWLQjMqdY6EMAAAAASUVORK5CYII=',
    ZA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX9/v3+uRUUgE/brRp1pKfd6emZbw1kkTMvIQTrf3j50s8AeEcAAAHhOS0ADIr////nnyzWAAAAC3RSTlPv/eDZxsnBwd7m4E+UGYYAAAAJcEhZcwAALiMAAC4jAXilP3YAAAClSURBVHjaY9i9e1P8r7uogGH37t1b+DkxBXer/l+LKbjb4cNcFEEjkCCasQyC1bsxjGVIFNbGMJbhhKE4hrEMZ44JYhjLcOZMM4axQMEzcGNhACQIN5YBBoCCMGPhACwIMxZVEGYsYUFs2rFZhNVJ2BwP9ybLOyhACpCv7+CCiKDzQwjCDYx7hxDEMBAkiGEgSBDDQJggioFQQVQDIYJoBr579w4AID2uWajS1fMAAAAASUVORK5CYII=',
    ES: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXxvwDOag2qFRvmsgu7YhjStSK1PBfbmQnNhg7UvW23VRPTp6e9oUDAc1fSwrl3SlO5GvFDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mNQwgIYBlZQEAtgwAMMsAkGYxETcfPA1NzSIY4uxlws6DnTHF10ckbePk40MfaLOXn7ZNEcwLE95f/u6gI0wcte/5fZogkyP/ZyW8aHpp012OvWklB0waM2Mw/EBDAQAFiDbvBFMQDs8UAnWwjUdAAAAABJRU5ErkJggg==',
    SD: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmgAAAAH/////AAAAUwAWggBdYgD0BwDS7dKZ15koqijSGwCZPgAAGwH0+/Rdv10nNCULAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdUlEQVR42o3OsQ2AMAxEURekANF4BVZgAqbJHqzEJCyESJwIGd8J4fJJ92XJK56kg6DMDCUzxEBBDFSEgGEMGMZAwxDoOO2Lu44yMpSLoQ886APfSOfXz5fo85v6azYoYjoJvscNw9gwjg3juCKMC+K4II5Vb7xWROdp9YXoAAAAAElFTkSuQmCC',
    SE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX+ywAAUpP1seVEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAG0lEQVR42mMQBAEBBgZGQQRgGCGCAwtGcMgDAE6xGxmZ2zxDAAAAAElFTkSuQmCC',
    CH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEX/////AAD/0ND/YGD/Tk7/9vbc5piHAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVR42mMQxAIYaCkoYmzsiCEoxMCgOECCTkpKqgwMQUpKKkiCBgxQwEw9QawWDazfcUUHrRMDALp+J5UUpHr1AAAAAElFTkSuQmCC',
    SY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8Aej0AAADOESb31tnWM0X99vfbT1/RHTHniJPzwMb76OrvsbjqmKHTKDvfYnCfYG3WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfUlEQVR42mMQxAIYhrQgTuAAIrg3gEgWuOAXEMF7AUT6w8TYOkEkewGInJEAEeOMswh3YDgabBrDwFLa/HQCRPSEcTXQsGBToNHbjXug2jOMQcYVm4MMNm6DCi71BBrH9uYc0Dj2KVFQwWVAyMCygRuoPQsIcQElLGBICwIAQ45Aa03Ys2UAAAAASUVORK5CYII=',
    TJ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////MAAAAZgDibW1uqG7//vv96aH/+ur+8sb74Hv97K3844X+9tf611L722f85I0rCMw5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdklEQVR42mMQxAIYBqGgMRbAAAc8BxgwwCrOCaswBNNYA9LQhFjbQWRFAKrgNYb67wy5qIIMoQzV24EECgBazdGA7gDOCQxsCSASxcyAzn2vZ7Cimdn7LGtZ3g10d9ZlT3uOLsZ+e0XX3gIYzwULYFDCAgahIADpxEPh9dNYsAAAAABJRU5ErkJggg==',
    TH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEWlGTEtKkr09fjV1t1LSWXo09kUPIcoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJUlEQVR42mNgoBcIxQIYlLAASgVdsAAGQSxgyAgaYwE0CTp6AQB3hDElR27URQAAAABJRU5ErkJggg==',
    TN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXnABP////pDyH/9/jybXj0goz1l5/qHC3+7u/uSlf3qK7wXGj71tn84uTsMkL5vMHVD65hAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVR42mNgGLyAfWt0AYbYQkFBKXTRFxIpbo330BQ2JrG7+ssqoAhyiTFsNhQ2TEARLGziFIwQFDRCEdyYwC/oGWIoiSIY6MB8tEBHUARd8FoBD5ogSLt3Cpr2wiY+wwx0i9ikGGYIShgGoDr+4nKmLf4yqI5neCu8NMrwOJrfmZIFBU0V0IOJaYqnwiCOWQCf5x5RzATURwAAAABJRU5ErkJggg==',
    TM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAhD2qQDNyWTaIYzXPMTBLXTuCTTe2ZTHcWS+kcTiYZVlxu5Opg3sznWRtaEfT6t5XcMERAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3klEQVR42mNgYGAutFpYzIAGmC0frXmELsi67lXWUnRBpjN5kUYMDHsZLiBrlzo1TQhIb+BGFixxcSkGqeRGUsosrpkoBBRj4N6AEGSLfPgyCKibgR9ZMDAxMQjEuI9sZubLyCQGBt7bf1EsEiwBWsS7F8VHhYKCmN4UCg0WQhdkU5ISUsImaIShXTg0EkM70HYRTIsqOjqKMARbw0Kb0AXZg+fNC8NQWRqIqZK5oh2LmVhtl6w5g+nNmWvWHMIQPLNm5SQMQa8zk50wBFtcXDCcxNbh4oEp6NLSgqodADs3OvJyxTvoAAAAAElFTkSuQmCC',
    TR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXjChf////lFCDmISzoND/3ubz+8/TqSFL6zc/84+XxhIv1pKnuY2vzlZvvdHvsWGBydz1BAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVR42mNgGFqgemLGYnQxVUHJXVcPoIoxNYo9YGDwQRXkFkwHSTmgCDoKPgBRCvbIggvFFEAUs6VREUIwUBRMMRdOe4AQbJQGUx6CogyYKg+KGWCYyeRpfgDZ9gUgysAF2XZeQXFMdzI1Ci5iYKhB87u2oFjsjg/oIeLbOfXRYI5GAK4SGZ7PHOUxAAAAAElFTkSuQmCC',
    UA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX/1wAAV7hKNkFnAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    AE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAAAH/AAAAcy/////AHAzAAAD/Pz+OQQvYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAH0lEQVR42mMQBAMRJWTAMAwExYyRwXAQFGVAAUNZEADHSDmVngXCtwAAAABJRU5ErkJggg==',
    GB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXIEC7///8BIWnMIj387/Ht7/UTMXTZVmz0zdSgrMfqo6/L0uHigZEwSoVTaZp3iK/3wiHXAAAACXBIWXMAAC4jAAAuIwF4pT92AAABHklEQVR42r2SsUoDQRCGf1nh4EgzxIRAAsJCBAuPA5tgFxQOIU0KO5PiwMrmhCts5aqUB2Kd4DMINkIKfQHb1HmB4AM4M7uLV6R24GD2476f3dlFSceWa9gGDrvS/RQtmCd6acL7yqyQxtT5/oPJLR4JGTQgwOciGhO2aw3wUGSa4+w9bXGAgyyPqJ/DnmqAgyrvLKzdLjngTWC/AstWoAaQwIHKCl2AwLbKDMmXwNDvh+e+UsCEHv9WV74ueUuh379PPlUypdcDhRm+9Jj81TTAg/tzHV27gWzoqIhvBHaol44+BIpsFnc65JoDPmXINU1Q7vx1TGkZLXJsWIln4eJkdTGDynmAJxJQQuXGY+AAA5Ubz0YCoHLzgdWU/QIYAVlPDjvZVgAAAABJRU5ErkJggg==',
    US: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUZL13///+9PUQmOWTtyMrlsrTLaG3DT1bcmJw1SHBLXID14eKKla3Rxs9kc5Krs8T8og+qAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA7ElEQVR42m2QTWoCQRCFH/Sqm8kMXsETFDYkjPiz8QpewSvMFWbZMAlkZNBx6Q96AG8g4gUkkK0iOYPdppMeob63e9R7Vd0Q+BN12h5EdWKGNMcGh2CKbvqQLvX7yIPfUTv4g0XLY73I9Khy8Y+xB6pQOhZdMdXL0ImkfjF92uGIt8yDuBgUAz2zuoTO2HZGqLDFNZhuOw3JbX+deCBlqVIlS1maxou+k9rtueH0mXtcvGcqej5eqCK2h07FitZ7j4vbM+cu3vgQEiShnYL5FTj/x1sMyBnQZsCEge9kzYyBXzRm4DtHDHwnZ94BDlKd9LTrU4QAAAAASUVORK5CYII=',
    UZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmbX///8etTr10NRkdDJSY3wVobsKnbglqMBQucw7scaR1OC24+un3ebe8faAzNvLtHwcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAc0lEQVR42mNgwAFWzyhgYNvQzfUBSYzzOZBgn5DJsQBJkG8CFt2NCQwMtWwXerk2IAkWNjAwcLE3ZLA1IAnyfMCine0kw/EatgO9nMjaGbimJbCxJ5SxF8BFQrEABmMsgEEQCxiMglgd74IFMChhAUNFEAB4jUr4vpG2xQAAAABJRU5ErkJggg==',
    YE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAAHxBgD///8pKSrzLimF/Ry1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHklEQVR42mMQxAIYhoqgCxbAoIQFDG1BYyyAYSgDAMCBL9EnDpIBAAAAAElFTkSuQmCC'
};
function $b7cded1008753984$export$a2b8715397522463(iso2) {
    const b64 = typeof iso2 === 'string' ? $b7cded1008753984$var$PNG[iso2.toUpperCase()] : undefined;
    return b64 ? `data:image/png;base64,${b64}` : undefined;
}

});

parcelRegister("j9AxR", function(module, exports) {

$parcel$export(module.exports, "kitCopy", () => $df1b34b618a72512$export$cddd06f8fa3400df);
// ─────────────────────────────────────────────────────────────────────────────
// The words the kit's components say when the caller did not pass their own.
//
// Rule 7 used to end at "copy arrives as props, with Persian defaults", and in
// practice no app passed all of it: an English clinic desk read «قبلی / بعدی»
// under every paged table, «ذخیره شد» on every save bar and «کد ملی وارد شده
// معتبر نیست» under a field labelled "National ID" — and a few components
// (the date-range filter, the save bar's confirmation, the national-id and
// number checks) had no prop to pass at all. The date picker moved to the page
// language in v0.19.0; this table does the same for everything else.
//
// A prop still wins. When it is absent, the default comes from here, keyed by the
// base language of `<html lang>` (or the component's own `locale` prop) — the
// channel `MoneyInput`, `PhoneInput` and the date picker already read. Adding a
// language is adding an entry; an unknown one reads Persian, as `documentLocale`
// falls back.
//
// Digits inside a default sentence are the caller's: a count passed in is
// rendered as given, so an app that localises its numerals keeps doing so.
// ─────────────────────────────────────────────────────────────────────────────

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
const $df1b34b618a72512$export$6bdac007b5b42036 = {
    fa: {
        pager: {
            prev: "\u0642\u0628\u0644\u06CC",
            next: "\u0628\u0639\u062F\u06CC",
            page: (current, pages)=>`\u{635}\u{641}\u{62D}\u{647} ${current} \u{627}\u{632} ${pages}`
        },
        saveBar: {
            save: "\u0630\u062E\u06CC\u0631\u0647 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A",
            cancel: "\u0644\u063A\u0648",
            saved: "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F"
        },
        search: {
            placeholder: "\u062C\u0633\u062A\u062C\u0648...",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062C\u0633\u062A\u062C\u0648"
        },
        select: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F..."
        },
        confirm: {
            confirm: "\u062A\u0623\u06CC\u06CC\u062F",
            cancel: "\u0627\u0646\u0635\u0631\u0627\u0641"
        },
        errorState: {
            title: "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
        close: "\u0628\u0633\u062A\u0646",
        back: "\u0628\u0627\u0632\u06AF\u0634\u062A",
        slotGrid: {
            label: "\u0633\u0627\u0639\u062A\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0632\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F"
        },
        phone: {
            label: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644",
            country: "\u06A9\u0634\u0648\u0631",
            countrySearch: "\u062C\u0633\u062A\u062C\u0648\u06CC \u06A9\u0634\u0648\u0631 \u06CC\u0627 \u06A9\u062F",
            countryNoMatch: "\u06A9\u0634\u0648\u0631\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
            required: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            tooShort: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{6A9}\u{648}\u{62A}\u{627}\u{647} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{628}\u{644}\u{646}\u{62F} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{627}\u{6CC}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            invalid: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dateRange: {
            title: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
            custom: "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
            from: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
            to: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
            needBoth: "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
        },
        connectivity: {
            offline: "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
            degraded: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            restored: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            busy: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026"
        },
        nationalId: {
            label: "\u06A9\u062F \u0645\u0644\u06CC",
            // A country with no rule of its own (see lib/nationalId.js).
            genericLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u0645\u0644\u06CC",
            country: "\u06A9\u0634\u0648\u0631 \u0635\u0627\u062F\u0631\u06A9\u0646\u0646\u062F\u0647",
            // `n` arrives already in the digits of the language on screen.
            placeholder: (n)=>`${n} \u{631}\u{642}\u{645}`,
            required: "\u06A9\u062F \u0645\u0644\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            incomplete: (n)=>`\u{6A9}\u{62F} \u{645}\u{644}\u{6CC} \u{628}\u{627}\u{6CC}\u{62F} ${n} \u{631}\u{642}\u{645} \u{628}\u{627}\u{634}\u{62F}`,
            tooShort: (n)=>`\u{62F}\u{633}\u{62A}\u{200C}\u{6A9}\u{645} ${n} \u{646}\u{648}\u{6CC}\u{633}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
            invalid: "\u06A9\u062F \u0645\u0644\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A",
            valid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            notValid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dayContext: {
            prevDay: "\u0631\u0648\u0632 \u0642\u0628\u0644",
            nextDay: "\u0631\u0648\u0632 \u0628\u0639\u062F",
            today: "\u0627\u0645\u0631\u0648\u0632",
            backToToday: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            pickDay: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632"
        },
        weekPicker: {
            title: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632",
            thisWeek: "\u0627\u06CC\u0646 \u0647\u0641\u062A\u0647",
            nextWeek: "\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F",
            prevWeek: "\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644",
            fullCalendar: "\u062A\u0642\u0648\u06CC\u0645 \u06A9\u0627\u0645\u0644",
            backToWeek: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0647\u0641\u062A\u0647",
            today: "\u0627\u0645\u0631\u0648\u0632",
            close: "\u0628\u0633\u062A\u0646",
            range: (from, to)=>`${from} \u{62A}\u{627} ${to}`,
            countAria: (n)=>`${n} \u{646}\u{648}\u{628}\u{62A}`
        },
        walkIn: {
            suggested: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F",
            or: "\u06CC\u0627"
        },
        mobileHeader: {
            greeting: "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632 \u0646\u0634\u062F",
            body: "\u0647\u0646\u06AF\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        number: {
            invalid: "\u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u06CC\u0633\u062A",
            min: (n)=>`\u{62D}\u{62F}\u{627}\u{642}\u{644} ${n}`,
            max: (n)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${n}`
        },
        account: {
            topUp: "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
            menu: "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"
        },
        bottomNav: {
            label: "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC"
        },
        files: {
            phases: {
                queued: "\u062F\u0631 \u0635\u0641",
                preparing: "\u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC",
                sending: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026",
                done: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
                failed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            replace: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC",
            drop: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            pick: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644",
            camera: "\u0639\u06A9\u0633 \u06AF\u0631\u0641\u062A\u0646",
            directory: "\u0627\u0646\u062A\u062E\u0627\u0628 \u067E\u0648\u0634\u0647",
            dragging: "\u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F"
        },
        imageStack: {
            frame: (i, n)=>`\u{62A}\u{635}\u{648}\u{6CC}\u{631} ${i} \u{627}\u{632} ${n}`,
            prev: "\u062A\u0635\u0648\u06CC\u0631 \u0642\u0628\u0644\u06CC",
            next: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0639\u062F\u06CC",
            slider: "\u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u0628\u06CC\u0646 \u062A\u0635\u0627\u0648\u06CC\u0631",
            zoomIn: "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
            zoomOut: "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
            reset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
            series: "\u0633\u0631\u06CC\u200C\u0647\u0627",
            presets: "\u062A\u0646\u0638\u06CC\u0645 \u0646\u0645\u0627\u06CC\u0634",
            viewport: "\u0646\u0645\u0627\u06CC \u062A\u0635\u0648\u06CC\u0631",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
            error: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            empty: "\u062A\u0635\u0648\u06CC\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A"
        },
        prizeWheel: {
            label: "\u06AF\u0631\u062F\u0648\u0646\u0647\u0654 \u0634\u0627\u0646\u0633"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    en: {
        pager: {
            prev: 'Previous',
            next: 'Next',
            page: (current, pages)=>`Page ${current} of ${pages}`
        },
        saveBar: {
            save: 'Save changes',
            cancel: 'Cancel',
            saved: 'Saved'
        },
        search: {
            placeholder: "Search\u2026",
            clear: 'Clear search'
        },
        select: {
            placeholder: "Choose\u2026"
        },
        confirm: {
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        errorState: {
            title: 'Not available',
            retry: 'Try again'
        },
        loading: 'Loading',
        close: 'Close',
        back: 'Back',
        slotGrid: {
            label: 'Free times',
            loading: 'Loading free times'
        },
        phone: {
            label: 'Mobile number',
            country: 'Country',
            countrySearch: 'Search country or code',
            countryNoMatch: 'No country found',
            required: 'Enter a mobile number',
            tooShort: (ctx)=>`This ${ctx.countryName} number is too short \u{2014} e.g. ${ctx.example}`,
            tooLong: (ctx)=>`This ${ctx.countryName} number is too long \u{2014} e.g. ${ctx.example}`,
            notMobile: (ctx)=>`That is not a mobile number \u{2014} e.g. ${ctx.example}`,
            invalid: 'That is not a valid number'
        },
        dateRange: {
            title: 'Date range',
            custom: 'Custom range',
            from: 'From',
            to: 'To',
            needBoth: 'Pick both dates to apply'
        },
        connectivity: {
            offline: "You are offline \u2014 changes are not being saved",
            degraded: "Cannot reach the server \u2014 retrying",
            restored: 'Connection restored',
            retry: 'Try again',
            busy: "Checking\u2026"
        },
        nationalId: {
            label: 'National ID',
            genericLabel: 'National ID number',
            country: 'Issuing country',
            placeholder: (n)=>`${n} digits`,
            required: 'Enter the national ID',
            incomplete: (n)=>`A national ID has ${n} digits`,
            tooShort: (n)=>`Enter at least ${n} characters`,
            invalid: 'That national ID is not valid',
            valid: 'National ID is valid',
            notValid: 'National ID is not valid'
        },
        dayContext: {
            prevDay: 'Previous day',
            nextDay: 'Next day',
            today: 'Today',
            backToToday: 'Back to today',
            pickDay: 'Pick a day'
        },
        weekPicker: {
            title: 'Pick a day',
            thisWeek: 'This week',
            nextWeek: 'Next week',
            prevWeek: 'Last week',
            fullCalendar: 'Full calendar',
            backToWeek: 'Back to the week',
            today: 'Today',
            close: 'Close',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} appointments`
        },
        walkIn: {
            suggested: 'Suggested',
            or: 'or'
        },
        mobileHeader: {
            greeting: 'Welcome,',
            clear: 'Clear',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: 'This page did not open',
            body: 'Something went wrong while showing this page.',
            retry: 'Try again'
        },
        number: {
            invalid: 'That is not a valid number',
            min: (n)=>`At least ${n}`,
            max: (n)=>`At most ${n}`
        },
        account: {
            topUp: 'Top up credit',
            menu: 'Account'
        },
        bottomNav: {
            label: 'Main navigation'
        },
        files: {
            phases: {
                queued: 'Queued',
                preparing: 'Preparing',
                sending: "Uploading\u2026",
                done: 'Uploaded',
                failed: 'Not uploaded'
            },
            remove: 'Remove',
            retry: 'Try again',
            replace: 'Replace',
            drop: 'Drop files here or choose them',
            pick: 'Choose files',
            camera: 'Take a photo',
            directory: 'Choose a folder',
            dragging: 'Drop them'
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} of ${n}`,
            prev: 'Previous image',
            next: 'Next image',
            slider: 'Move between images',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            reset: 'Reset view',
            series: 'Series',
            presets: 'Display settings',
            viewport: 'Image view',
            loading: 'Loading image',
            error: 'The image did not load',
            retry: 'Try again',
            empty: 'No image to show'
        },
        prizeWheel: {
            label: 'Prize wheel'
        },
        toman: 'toman'
    },
    ar: {
        pager: {
            prev: "\u0627\u0644\u0633\u0627\u0628\u0642",
            next: "\u0627\u0644\u062A\u0627\u0644\u064A",
            page: (current, pages)=>`\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} ${current} \u{645}\u{646} ${pages}`
        },
        saveBar: {
            save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            cancel: "\u0625\u0644\u063A\u0627\u0621",
            saved: "\u062A\u0645 \u0627\u0644\u062D\u0641\u0638"
        },
        search: {
            placeholder: "\u0628\u062D\u062B...",
            clear: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
        },
        select: {
            placeholder: "\u0627\u062E\u062A\u0631..."
        },
        confirm: {
            confirm: "\u062A\u0623\u0643\u064A\u062F",
            cancel: "\u0625\u0644\u063A\u0627\u0621"
        },
        errorState: {
            title: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
        close: "\u0625\u063A\u0644\u0627\u0642",
        back: "\u0631\u062C\u0648\u0639",
        slotGrid: {
            label: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629"
        },
        phone: {
            label: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            country: "\u0627\u0644\u062F\u0648\u0644\u0629",
            countrySearch: "\u0627\u0628\u062D\u062B \u0639\u0646 \u062F\u0648\u0644\u0629 \u0623\u0648 \u0631\u0645\u0632",
            countryNoMatch: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062F\u0648\u0644\u0629",
            required: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            tooShort: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{642}\u{635}\u{64A}\u{631} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{637}\u{648}\u{64A}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{647}\u{630}\u{627} \u{644}\u{64A}\u{633} \u{631}\u{642}\u{645} \u{62C}\u{648}\u{627}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dateRange: {
            title: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
            custom: "\u0641\u062A\u0631\u0629 \u0645\u062E\u0635\u0635\u0629",
            from: "\u0645\u0646 \u062A\u0627\u0631\u064A\u062E",
            to: "\u0625\u0644\u0649 \u062A\u0627\u0631\u064A\u062E",
            needBoth: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0646 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0641\u062A\u0631\u0629"
        },
        connectivity: {
            offline: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u2014 \u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            degraded: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            restored: "\u0639\u0627\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026"
        },
        nationalId: {
            label: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            genericLabel: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0648\u0637\u0646\u064A\u0629",
            country: "\u0628\u0644\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
            placeholder: (n)=>`${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            required: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            incomplete: (n)=>`\u{627}\u{644}\u{631}\u{642}\u{645} \u{627}\u{644}\u{648}\u{637}\u{646}\u{64A} \u{64A}\u{62A}\u{643}\u{648}\u{651}\u{646} \u{645}\u{646} ${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            tooShort: (n)=>`\u{623}\u{62F}\u{62E}\u{644} ${n} \u{623}\u{62D}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            valid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0635\u0627\u0644\u062D",
            notValid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dayContext: {
            prevDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0633\u0627\u0628\u0642",
            nextDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062A\u0627\u0644\u064A",
            today: "\u0627\u0644\u064A\u0648\u0645",
            backToToday: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            pickDay: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645"
        },
        weekPicker: {
            title: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645",
            thisWeek: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            nextWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0645",
            prevWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0645\u0627\u0636\u064A",
            fullCalendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
            backToWeek: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            today: "\u0627\u0644\u064A\u0648\u0645",
            close: "\u0625\u063A\u0644\u0627\u0642",
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} \u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`
        },
        walkIn: {
            suggested: "\u0645\u0642\u062A\u0631\u062D",
            or: "\u0623\u0648"
        },
        mobileHeader: {
            greeting: "\u0623\u0647\u0644\u0627\u064B\u060C",
            clear: "\u0645\u0633\u062D",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
            body: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        number: {
            invalid: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            min: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{62F}\u{646}\u{649} ${n}`,
            max: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} ${n}`
        },
        account: {
            topUp: "\u0634\u062D\u0646 \u0627\u0644\u0631\u0635\u064A\u062F",
            menu: "\u0627\u0644\u062D\u0633\u0627\u0628"
        },
        bottomNav: {
            label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A"
        },
        files: {
            phases: {
                queued: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                preparing: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0636\u064A\u0631",
                sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
                done: "\u062A\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                failed: "\u0644\u0645 \u064A\u064F\u0631\u0633\u0644"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            replace: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
            drop: "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u062E\u062A\u0631\u0647\u0627",
            pick: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
            camera: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
            directory: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F",
            dragging: "\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627"
        },
        imageStack: {
            frame: (i, n)=>`\u{627}\u{644}\u{635}\u{648}\u{631}\u{629} ${i} \u{645}\u{646} ${n}`,
            prev: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
            next: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
            slider: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0635\u0648\u0631",
            zoomIn: "\u062A\u0643\u0628\u064A\u0631",
            zoomOut: "\u062A\u0635\u063A\u064A\u0631",
            reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0639\u0631\u0636",
            series: "\u0627\u0644\u0633\u0644\u0627\u0633\u0644",
            presets: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0639\u0631\u0636",
            viewport: "\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            error: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631\u0629 \u0644\u0644\u0639\u0631\u0636"
        },
        prizeWheel: {
            label: "\u0639\u062C\u0644\u0629 \u0627\u0644\u062D\u0638"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    }
};
function $df1b34b618a72512$export$cddd06f8fa3400df(locale) {
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    return $df1b34b618a72512$export$6bdac007b5b42036[base] || $df1b34b618a72512$export$6bdac007b5b42036[(0, $eLeza.brandDefaultLocale)('fa')] || $df1b34b618a72512$export$6bdac007b5b42036.fa;
}

});



parcelRegister("Ydgp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dabae5d3309de70$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");

var $hlTfq = parcelRequire("hlTfq");

var $3tGMU = parcelRequire("3tGMU");

var $5AX1S = parcelRequire("5AX1S");

var $9sT7p = parcelRequire("9sT7p");
'use client';
// The one national-id field. Everywhere in Parsina a human types a «کد ملی», it
// types it here — and no screen keeps its own length check or checksum.
//
// What it does that a plain <input> cannot:
//
//   1. **The rules of the issuing COUNTRY.** `country` (ISO alpha-2, default
//      Iran) picks the rule from `lib/nationalId.js`: Iran's ten digits and
//      checksum today, another country's the day its entry is added, a
//      shape-only check for a country with no entry. Language never picks it.
//   2. **The numerals of the language on screen.** Persian digits under `fa`,
//      Arabic-Indic under `ar`, Latin under `en` — whatever keyboard typed them.
//      Resolved by `numeralsFor`, the seam `MoneyInput` uses; nothing here
//      branches on a locale.
//   3. **Anything typed or pasted becomes the code.** Persian, Arabic and
//      full-width digits fold to ASCII; the dashes and spaces of
//      «001-234567-9» are dropped; the caret stays where the typist left it.
//   4. **One verdict, said once.** Required / incomplete / invalid, in the page
//      language, on blur and live from then on (§6.3) — the same verdict
//      `nationalIdProblem` gives the screen on submit.
//
// Value in and value out are both the BARE ASCII code — «0012345679», never
// «۰۰۱۲۳۴۵۶۷۹». Two ways to listen, and they say the same thing:
//
//   onChange({ target: { value, name } }, info)   — event-shaped, so it drops
//                                                    into an existing handler
//   onValueChange(value, info)                    — the bare string
//
// `info` is `{ value, complete, valid, problem, country }`. `onComplete(value)`
// fires when the code becomes complete and acceptable — the moment to look a
// patient up.
//
// WHICH COUNTRY (PM-0076, owner 2026-10-05): a clinic's patients carry the
// national id of the country the CLINIC is in — `defaultCountry`, the clinic's
// stored country — but a clinic also sees patients from elsewhere. A patient form
// passes `allowOtherCountries`, and the field grows a country chip (the phone
// field's flagged, searchable picker) that starts on the clinic's country. Picking
// another country re-reads the typed value under that country's rule and reports
// it through `onCountryChange(iso2)`. `country` makes the choice CONTROLLED (a
// form that stores the issuing country); without it the field keeps its own.
const $6dabae5d3309de70$var$messageFor = (copy, problem, rule, localise)=>{
    if (problem === 'required') return copy.required;
    if (problem === 'incomplete') return rule.minLength === rule.maxLength ? copy.incomplete(localise(String(rule.maxLength))) : copy.tooShort(localise(String(rule.minLength)));
    if (problem === 'invalid') return copy.invalid;
    return '';
};
const $6dabae5d3309de70$var$NationalIdInput = ({ value: value, onChange: onChange, onValueChange: onValueChange, onBlur: onBlur, onComplete: onComplete, // Whose number it is — ISO 3166-1 alpha-2, or a locale tag with a region.
// Controlled when passed; otherwise the field starts on `defaultCountry` (the
// clinic's country; omitted is Iran — outside the Iranian market, the country
// the phone field would preselect: `defaultNationalIdCountry`) and keeps the
// person's own pick.
country: countryProp, defaultCountry: defaultCountry, allowOtherCountries: // Offer the other countries — on every form that registers or edits a PATIENT.
// Off for a field that can only hold one country's number (the doctor's own
// code for an Iranian insurer).
allowOtherCountries = false, onCountryChange: onCountryChange, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, placeholder: placeholder, disabled: disabled = false, showValid: // `false` keeps the field from announcing «معتبر است» — for a dense form where
// the green line would push the row below it.
showValid = true, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name, autoFocus…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const shellRef = (0, $acw62.useRef)(null);
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    // Set by the first blur: from then on the verdict follows every keystroke.
    const [checked, setChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const copy = (0, $j9AxR.kitCopy)(locale).nationalId;
    const numerals = (0, $acw62.useMemo)(()=>(0, $hlTfq.numeralsFor)(locale), [
        locale
    ]);
    const country = countryProp || picked || defaultCountry || (0, $3tGMU.defaultNationalIdCountry)(locale);
    const rule = (0, $3tGMU.nationalIdRule)(country);
    const countryRow = allowOtherCountries ? (0, $5AX1S.findByIso2)(rule.country || country) : null;
    const localise = (ascii)=>ascii.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    // A stored value may arrive in any digits, or as a number; it is read the way
    // typing is.
    const code = rule.normalize(value);
    const problem = code ? rule.check(code) : required ? 'required' : null;
    const isComplete = code.length >= rule.minLength;
    const isValid = rule.verifiable && !!code && problem === null;
    const isInvalid = problem === 'invalid';
    const error = externalError || (checked ? $6dabae5d3309de70$var$messageFor(copy, problem, rule, localise) : '');
    const statusShown = !externalError && rule.verifiable && isComplete && (isValid || isInvalid);
    if (label === undefined) label = rule.country === 'IR' ? copy.label : copy.genericLabel;
    if (placeholder === undefined) placeholder = rule.minLength === rule.maxLength && rule.charset === 'digits' ? copy.placeholder(localise(String(rule.maxLength))) : '';
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const report = (next, nextRule, iso)=>{
        const nextProblem = next ? nextRule.check(next) : required ? 'required' : null;
        const info = {
            value: next,
            complete: next.length >= nextRule.minLength,
            valid: !!next && nextProblem === null,
            problem: nextProblem,
            country: iso
        };
        onChange?.({
            target: {
                value: next,
                name: rest.name
            }
        }, info);
        onValueChange?.(next, info);
        if (info.valid) onComplete?.(next);
    };
    const handleCountry = (row)=>{
        const iso = row?.iso2;
        if (!iso || iso === country) return;
        if (!countryProp) setPicked(iso);
        onCountryChange?.(iso);
        // The same characters, read under the new country's rule — a code typed
        // before the country was picked is kept, not cleared.
        const nextRule = (0, $3tGMU.nationalIdRule)(iso);
        report(nextRule.normalize(value), nextRule, iso);
        ref.current?.focus();
    };
    const handleChange = (e)=>{
        const el = e.target;
        // Digits map one to one, so the caret belongs after as many KEPT characters
        // as sat to its left — a pasted dash or space must not push it along.
        const keptLeft = rule.strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
        const kept = rule.strip(el.value);
        const next = kept.slice(0, rule.maxLength);
        // A keystroke into a code that is already full is refused, the way a native
        // `maxLength` refuses it — otherwise a digit typed mid-code pushes the last
        // one out and silently rewrites the number. (The DOM attribute itself is not
        // used: it truncates a pasted «001-234567-9» before the dashes are dropped.)
        const overflow = code.length === rule.maxLength && kept.length > rule.maxLength;
        if (overflow || next === code) {
            // Nothing to report, so React will not re-render — put the field back by
            // hand, or the refused character stays on screen and the caret jumps.
            const pos = Math.max(0, Math.min(code.length, keptLeft - (kept.length - code.length)));
            el.value = localise(code);
            el.setSelectionRange(pos, pos);
            return;
        }
        caret.current = Math.min(keptLeft, next.length);
        report(next, rule, country);
    };
    const messageId = `${controlId}-message`;
    const validLine = showValid && isValid && !error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: validLine ? '' : helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: "relative [unicode-bidi:isolate]",
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText || validLine ? messageId : undefined,
        "aria-invalid": error ? true : undefined,
        "aria-required": required || undefined,
        autoComplete: "off",
        ...rest,
        ref: ref,
        type: "text",
        inputMode: rule.charset === 'digits' ? 'numeric' : 'text',
        value: localise(code),
        onChange: handleChange,
        onBlur: (e)=>{
            setChecked(true);
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground tracking-[1.5px] tabular-nums', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', // With the country chip the chip owns the start and the ✓/✗ moves to the end.
        countryRow ? 'ps-[84px] pe-10' : 'ps-10 pe-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : statusShown && isValid ? 'border-clinic-green shadow-ring-green' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), countryRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "absolute inset-y-0 start-0 flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.default), {
        value: countryRow,
        onSelect: handleCountry,
        locale: localeProp,
        label: copy.country,
        disabled: disabled,
        anchorRef: shellRef,
        showDial: false,
        "data-testid": rest['data-testid'] ? `${rest['data-testid']}-country` : undefined
    })), statusShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": isValid ? copy.valid : copy.notValid,
        className: (0, $5JYPc.cn)('absolute top-1/2 -translate-y-1/2 flex items-center', countryRow ? 'end-3' : 'start-3', isValid ? 'text-clinic-green' : 'text-destructive')
    }, isValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))), validLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] font-semibold text-clinic-green leading-snug"
    }, copy.valid));
};
var $6dabae5d3309de70$export$2e2bcd8739ae039 = $6dabae5d3309de70$var$NationalIdInput;

});
parcelRegister("3tGMU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NATIONAL_ID_COUNTRY", () => $2885454b73c45d9d$export$db3d38ac1c19b9cc);
$parcel$export(module.exports, "defaultNationalIdCountry", () => $2885454b73c45d9d$export$d285ab09de6b6713);
$parcel$export(module.exports, "GENERIC_RULE", () => $2885454b73c45d9d$export$1700237b484ebbcc);
$parcel$export(module.exports, "NATIONAL_ID_RULES", () => $2885454b73c45d9d$export$92a974607f6f02fc);
$parcel$export(module.exports, "nationalIdRule", () => $2885454b73c45d9d$export$8d56917ba3265ae0);
$parcel$export(module.exports, "normalizeNationalId", () => $2885454b73c45d9d$export$9997440a468738e3);
$parcel$export(module.exports, "nationalIdProblem", () => $2885454b73c45d9d$export$8b1749206e586151);
$parcel$export(module.exports, "isValidNationalId", () => $2885454b73c45d9d$export$89cadb74f28f5ec2);
$parcel$export(module.exports, "repairNationalId", () => $2885454b73c45d9d$export$f198e2644d3eb5b8);
$parcel$export(module.exports, "formatNationalId", () => $2885454b73c45d9d$export$6a9c909dc504d3aa);
// National id — the one place the rules of a national identity number live.
//
// «کد ملی» is Iran's: ten digits, the last a checksum of the nine before it. That
// rule was written down more than once (the input's own private copy, and a copy
// in whichever screen had to validate on submit), which is how a code one screen
// accepts is refused by the next. It is written here once, and `NationalIdInput`
// and every screen read it from here.
//
// Three things are kept apart on purpose:
//
//   - **The COUNTRY decides the rules.** How long the number is, whether it has a
//     checksum, whether letters may appear — a property of who issued it. Each
//     country is one entry in `NATIONAL_ID_RULES`; adding one is adding an entry,
//     and no component branches on a country code. Iran's entry is today's rule,
//     unchanged. A country with no entry gets `GENERIC_RULE`, which checks shape
//     only and therefore never claims a number is VALID — only that it is not
//     obviously malformed.
//   - **The LANGUAGE decides the digits on screen.** «۰۰۱۲۳۴۵۶۷۹» under `fa`,
//     «٠٠١٢٣٤٥٦٧٩» under `ar`, «0012345679» under `en` — resolved by `numeralsFor`,
//     the seam `MoneyInput` already uses. An English-speaking desk in Tehran still
//     enters Iranian codes: language never picks the rule.
//   - **The VALUE is always ASCII.** Localised digits exist only between a
//     component and the DOM. What a form stores, compares, sends and validates is
//     `normalizeNationalId`'s output.

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
const $2885454b73c45d9d$export$db3d38ac1c19b9cc = 'IR';
function $2885454b73c45d9d$export$d285ab09de6b6713(locale) {
    return (0, $eLeza.isIranMarket)() ? $2885454b73c45d9d$export$db3d38ac1c19b9cc : (0, $5AX1S.countryForLocale)(locale).iso2;
}
// ── Iran — «کد ملی» ──────────────────────────────────────────────────────────
// Ten digits. With the digits d0…d9 and S = Σ d[i] × (10 − i) for i = 0…8,
// r = S mod 11; the check digit d9 is r when r < 2, else 11 − r. Ten equal digits
// satisfy the arithmetic («1111111111») and are issued to nobody, so they are
// refused by name.
const $2885454b73c45d9d$var$IR_LENGTH = 10;
function $2885454b73c45d9d$var$iranChecksumHolds(code) {
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += (code.charCodeAt(i) - 48) * (10 - i);
    const rem = sum % 11;
    return code.charCodeAt(9) - 48 === (rem < 2 ? rem : 11 - rem);
}
const $2885454b73c45d9d$var$IR_RULE = Object.freeze({
    country: 'IR',
    // What may be typed — decides the on-screen keyboard and what paste keeps.
    charset: 'digits',
    minLength: $2885454b73c45d9d$var$IR_LENGTH,
    maxLength: $2885454b73c45d9d$var$IR_LENGTH,
    // A rule with a checksum can say a number is VALID; one without can only say
    // it is not malformed, and the field then shows no «معتبر است».
    verifiable: true,
    // `strip` keeps every character the rule allows; `normalize` also cuts at the
    // length. The field needs both — it refuses a keystroke into a full code
    // instead of letting it push the last digit out.
    strip: (raw)=>(0, $5AX1S.foldDigits)(String(raw ?? '')).replace(/\D/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$var$IR_RULE.strip(raw).slice(0, $2885454b73c45d9d$var$IR_LENGTH),
    check (value) {
        if (value.length < $2885454b73c45d9d$var$IR_LENGTH) return 'incomplete';
        if (/^(\d)\1{9}$/.test(value) || !$2885454b73c45d9d$var$iranChecksumHolds(value)) return 'invalid';
        return null;
    },
    // A code kept as a NUMBER somewhere upstream (a spreadsheet import, an integer
    // column) has lost its leading zeros: «0012345679» arrives as «12345679». Codes
    // begin with at most two zeros, so 8 or 9 digits can be restored — and are kept
    // only when the restored code passes the checksum.
    repair (value) {
        if (value.length !== 8 && value.length !== 9) return value;
        const padded = value.padStart($2885454b73c45d9d$var$IR_LENGTH, '0');
        return $2885454b73c45d9d$var$IR_RULE.check(padded) === null ? padded : value;
    }
});
// ── A country with no entry ──────────────────────────────────────────────────
// Latin letters and digits, a plausible length, no checksum. Deliberately loose:
// refusing a real document because its country was never written down here would
// stop a foreign patient being registered at all.
const $2885454b73c45d9d$var$GENERIC_MIN = 5;
const $2885454b73c45d9d$var$GENERIC_MAX = 20;
const $2885454b73c45d9d$export$1700237b484ebbcc = Object.freeze({
    country: null,
    charset: 'alphanumeric',
    minLength: $2885454b73c45d9d$var$GENERIC_MIN,
    maxLength: $2885454b73c45d9d$var$GENERIC_MAX,
    verifiable: false,
    strip: (raw)=>(0, $5AX1S.foldDigits)(String(raw ?? '')).toUpperCase().replace(/[^A-Z0-9]/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$export$1700237b484ebbcc.strip(raw).slice(0, $2885454b73c45d9d$var$GENERIC_MAX),
    check: (value)=>value.length < $2885454b73c45d9d$var$GENERIC_MIN ? 'incomplete' : null,
    repair: (value)=>value
});
const $2885454b73c45d9d$export$92a974607f6f02fc = Object.freeze({
    IR: $2885454b73c45d9d$var$IR_RULE
});
function $2885454b73c45d9d$export$8d56917ba3265ae0(country) {
    const home = (0, $eLeza.isIranMarket)() ? $2885454b73c45d9d$var$IR_RULE : $2885454b73c45d9d$export$1700237b484ebbcc;
    const raw = String(country ?? '').trim();
    if (!raw) return home;
    const parts = raw.split(/[-_]/);
    const region = parts.length > 1 ? parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p)) : /^[A-Z]{2}$/.test(raw) ? raw : null;
    if (!region) return home;
    return $2885454b73c45d9d$export$92a974607f6f02fc[region.toUpperCase()] || $2885454b73c45d9d$export$1700237b484ebbcc;
}
function $2885454b73c45d9d$export$9997440a468738e3(input, country) {
    return $2885454b73c45d9d$export$8d56917ba3265ae0(country).normalize(input);
}
function $2885454b73c45d9d$export$8b1749206e586151(input, { country: country, required: required = false } = {}) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    if (!value) return required ? 'required' : null;
    return rule.check(value);
}
function $2885454b73c45d9d$export$89cadb74f28f5ec2(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    return !!value && rule.check(value) === null;
}
function $2885454b73c45d9d$export$f198e2644d3eb5b8(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    return rule.repair(rule.normalize(input));
}
function $2885454b73c45d9d$export$6a9c909dc504d3aa(input, locale) {
    const ascii = (0, $5AX1S.foldDigits)(String(input ?? '')).trim();
    if (!ascii) return '';
    const { digits: digits } = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    return ascii.replace(/\d/g, (d)=>digits[Number(d)]);
}

});


parcelRegister("9iIGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe0519cb1ec239e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");
'use client';
const $4fe0519cb1ec239e$var$NumberInput = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, unit: unit, min: min, max: max, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const defaultValidate = (v)=>{
        if (!v) return '';
        const n = parseFloat(v);
        const copy = (0, $j9AxR.kitCopy)().number;
        if (isNaN(n)) return copy.invalid;
        if (min !== undefined && n < min) return copy.min(min);
        if (max !== undefined && n > max) return copy.max(max);
        return '';
    };
    const error = externalError || (touched ? internalError : '');
    const handleChange = (e)=>{
        let v = (0, $5JYPc.toEnDigits)(e.target.value).replace(/[^\d.]/g, '');
        const parts = v.split('.');
        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "decimal",
        value: value,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            setInternalError((validate || defaultValidate)(value));
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        dir: "ltr",
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', unit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unit)));
};
var $4fe0519cb1ec239e$export$2e2bcd8739ae039 = $4fe0519cb1ec239e$var$NumberInput;

});

parcelRegister("lkMIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b90d527c31e5b4da$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");

var $lHVFz = parcelRequire("lHVFz");
'use client';
// The one money field. Everywhere in Parsina a human types a price, it types it here.
//
// Three things it does that a plain <input> cannot:
//
//   1. **Thousands separators as you type.** «500000» reads back as «۵۰۰٬۰۰۰».
//      Native <input type="number"> can't render a separator at all (the browser
//      rejects the comma), so this is a text input that DISPLAYS the grouped string
//      and reports the bare numeric one.
//   2. **The numerals of the language on screen.** Persian digits under `fa`, Latin
//      under `en`, each with that locale's own separators — resolved from CLDR, so
//      nothing here branches on a locale id. See `numeralsFor`.
//   3. **The unit, always.** A money field with no unit is how a rial figure ends up
//      read as toman; the label defaults rather than being optional.
//
// Value in and value out are both the BARE ASCII numeric string — «500000», never
// «۵۰۰٬۰۰۰». Localised digits exist only between here and the DOM, so no form, no
// parse and no toman↔rial conversion downstream sees them. onChange is handed that
// string directly, not an event: `onChange={setAmount}`.
//
// It preserves the caret across regrouping: inserting a digit that pushes a new
// separator in would otherwise fling the cursor to the end. We remember how many
// digits sat to the left of the caret and put it back after the same digit once
// React re-renders.
// The default chip. IRR — and no currency at all, which IS IRR — reads the kit's
// localised toman, exactly as before `currency` existed. Any other clinic currency
// reads its short form from the currency table («USD», «KWD»), because a non-IRR
// clinic must never see «تومان» beside its money. Anything that is not a currency
// («پارسه», a percentage) is still the caller's `unitLabel`.
const $b90d527c31e5b4da$var$unitLabelFor = (locale, info)=>info.code === (0, $lHVFz.DEFAULT_CURRENCY) ? (0, $j9AxR.kitCopy)(locale).toman : (0, $lHVFz.unitLabel)(info.code, locale, 'short');
// At most `places` digits after the decimal point. Applied only to a non-IRR
// currency: an IRR field (a toman price, a percentage discount) keeps what it
// always accepted.
function $b90d527c31e5b4da$var$limitFraction(raw, places) {
    const dot = raw.indexOf('.');
    return dot < 0 || raw.length - dot - 1 <= places ? raw : raw.slice(0, dot + 1 + places);
}
const $b90d527c31e5b4da$var$MoneyInput = ({ value: value, onChange: onChange, onBlur: onBlur, currency: // The clinic currency the figure is in. Omitted, blank or 'IRR' is today's toman
// field exactly. Another currency changes the default chip and allows up to its
// fraction digits. It never converts: value in and out stay DISPLAY units (toman,
// dollars), and the call site turns them into minor units with
// `currency.fromDisplay` — see docs/MONEY_INPUT.md §2.4 and §6.3.
currency, // Defaults to false for IRR and true for any other currency.
allowDecimal: allowDecimalProp, unit: // Unit — `unit` is a full node override, `unitLabel` just changes the text.
// `unit={null}` is the deliberate way to render none.
unit, unitLabel: unitLabel, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, validate: validate, placeholder: placeholder, disabled: disabled = false, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const numerals = (0, $acw62.useMemo)(()=>(0, $hlTfq.numeralsFor)(locale), [
        locale
    ]);
    // Throws INVALID_CURRENCY for a code outside the table rather than guessing.
    const info = (0, $lHVFz.currencyInfo)(currency);
    const isIrr = info.code === (0, $lHVFz.DEFAULT_CURRENCY);
    const allowDecimal = allowDecimalProp ?? !isIrr;
    const clean = (text)=>{
        const raw = (0, $hlTfq.stripAmount)(text, allowDecimal, numerals);
        return isIrr || !allowDecimal ? raw : $b90d527c31e5b4da$var$limitFraction(raw, info.maxDisplayDecimals);
    };
    const error = externalError || (touched ? internalError : '');
    const display = (0, $hlTfq.groupAmount)(value ?? '', numerals);
    // `unit === null` means "no unit, I mean it"; `undefined` means "you choose".
    const unitNode = unit !== undefined ? unit : unitLabel ?? $b90d527c31e5b4da$var$unitLabelFor(locale, info);
    const hasUnit = unitNode != null && unitNode !== '';
    // The chip is painted beside the digits, which a screen reader never connects to
    // the field — «۵۰۰٬۰۰۰» alone does not say toman. Describing the input by it is
    // what makes the unit part of the field for a non-sighted reader too. A caller's
    // own `aria-describedby` is kept, not replaced.
    const unitId = `${(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId()}-unit`;
    const describedBy = [
        rest['aria-describedby'],
        hasUnit ? unitId : null
    ].filter(Boolean).join(' ') || undefined;
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const handleChange = (e)=>{
        const el = e.target;
        // How many MEANINGFUL characters sat left of the caret — digits, plus the
        // decimal mark when one is allowed. Counting digits alone parks the caret
        // before a just-typed decimal mark, so «1.5» lands as «1.» + «5» = «15.».
        const keptLeft = (0, $hlTfq.stripAmount)(el.value.slice(0, el.selectionStart ?? el.value.length), allowDecimal, numerals).length;
        const raw = clean(el.value);
        const grouped = (0, $hlTfq.groupAmount)(raw, numerals);
        // Walk the regrouped string until that many are behind us; the separators it
        // inserted are skipped over. `\p{Nd}` rather than an ASCII range: «۵» is a
        // digit too, and an ASCII test flings the caret to the end in Persian.
        const isKept = (ch)=>/\p{Nd}/u.test(ch) || allowDecimal && ch === numerals.decimal;
        let pos = 0, seen = 0;
        while(pos < grouped.length && seen < keptLeft){
            if (isKept(grouped[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        onChange(raw);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: "text",
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        // A number is an LTR run even inside an RTL form — the same rule that
        // keeps phone numbers and codes readable.
        dir: "ltr",
        value: display,
        onChange: handleChange,
        "aria-describedby": describedBy,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', hasUnit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), hasUnit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: unitId,
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unitNode)));
};
var $b90d527c31e5b4da$export$2e2bcd8739ae039 = $b90d527c31e5b4da$var$MoneyInput;

});
parcelRegister("lHVFz", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CURRENCY", () => $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
$parcel$export(module.exports, "isClinicCurrency", () => $fcda591c8cd139a4$export$68d15a182c6bcbf0);
$parcel$export(module.exports, "normalizeCurrency", () => $fcda591c8cd139a4$export$b91dea8e61ccd7ef);
$parcel$export(module.exports, "currencyInfo", () => $fcda591c8cd139a4$export$272b829bb65f9e96);
$parcel$export(module.exports, "toDisplay", () => $fcda591c8cd139a4$export$57a9131fd362a631);
$parcel$export(module.exports, "formatAmount", () => $fcda591c8cd139a4$export$e251d23bea783311);
$parcel$export(module.exports, "unitLabel", () => $fcda591c8cd139a4$export$846d8329e0c3da65);
// ─────────────────────────────────────────────────────────────────────────────
// Currency — clinic money in the currency the clinic keeps its books in.
//
// `money.js` was written for one currency: whole RIALS on the wire, TOMAN in front
// of a human. That stays true for every Iranian clinic, byte for byte. A clinic may
// now keep its books in another currency, and this module is the one place that
// knows what each allowed currency looks like:
//
//   • ON THE WIRE an amount is an integer number of MINOR UNITS of the document's
//     currency — whole rials for IRR (exponent 0, a deliberate override of ISO's 2),
//     cents for USD, fils for KWD. Field names ending in `Rial` keep their names and
//     now mean "minor units of this row's `currency`".
//   • IN FRONT OF A HUMAN an amount is divided by `displayDivisor`. That is NOT
//     10**exponent: IRR's divisor is 10, because an Iranian reads toman.
//   • An EMPTY or ABSENT currency means IRR. That is how an older server, a lagging
//     proto copy or a historical row degrades to today's behaviour.
//   • Amounts in two currencies are never added, compared or charted together.
//     There is no exchange rate anywhere in Parsina: group (`sumByCurrency`) or
//     refuse (`assertSameCurrency` → MIXED_CURRENCY).
//
// For IRR every function here returns exactly what money.js returns today:
// `formatAmount(x, 'IRR')` is `fmtToman(x)`, `toDisplay` is `rialToToman`,
// `fromDisplay` is `tomanToRial` and `parseAmount` is `parseTomanToRial` for every
// input that one accepts. The tests hold each pair against the other.
//
// The table below is the closed allow-list from docs/clinic-currency/CONTRACTS.md
// §1; `currency.cases.json` beside this file is its machine-readable twin, which the
// Python services copy byte for byte. Change one, change the other.
//
// DEPENDENCY-FREE ON PURPOSE: no imports at all, not even money.js. The file must be
// droppable into an older installed framework for local testing, and into any app
// or script, without dragging a module graph along.
// ─────────────────────────────────────────────────────────────────────────────
const $fcda591c8cd139a4$export$c19ece7ea27dcd9e = 'IRR';
function $fcda591c8cd139a4$var$deepFreeze(value) {
    for (const inner of Object.values(value))if (inner && typeof inner === 'object') $fcda591c8cd139a4$var$deepFreeze(inner);
    return Object.freeze(value);
}
const $fcda591c8cd139a4$export$76e9d3e89dba5250 = $fcda591c8cd139a4$var$deepFreeze({
    IRR: {
        code: 'IRR',
        exponent: 0,
        displayDivisor: 10,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 1,
        labels: {
            fa: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            en: {
                long: 'Toman',
                short: 'T'
            },
            ar: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            }
        }
    },
    USD: {
        code: 'USD',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0644\u0627\u0631 \u0622\u0645\u0631\u06CC\u06A9\u0627",
                short: 'USD'
            },
            en: {
                long: 'US dollar',
                short: 'USD'
            },
            ar: {
                long: "\u062F\u0648\u0644\u0627\u0631 \u0623\u0645\u0631\u064A\u0643\u064A",
                short: 'USD'
            }
        }
    },
    EUR: {
        code: 'EUR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u06CC\u0648\u0631\u0648",
                short: 'EUR'
            },
            en: {
                long: 'Euro',
                short: 'EUR'
            },
            ar: {
                long: "\u064A\u0648\u0631\u0648",
                short: 'EUR'
            }
        }
    },
    GBP: {
        code: 'GBP',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u067E\u0648\u0646\u062F \u0627\u0646\u06AF\u0644\u06CC\u0633",
                short: 'GBP'
            },
            en: {
                long: 'Pound sterling',
                short: 'GBP'
            },
            ar: {
                long: "\u062C\u0646\u064A\u0647 \u0625\u0633\u062A\u0631\u0644\u064A\u0646\u064A",
                short: 'GBP'
            }
        }
    },
    CHF: {
        code: 'CHF',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0641\u0631\u0627\u0646\u06A9 \u0633\u0648\u0626\u06CC\u0633",
                short: 'CHF'
            },
            en: {
                long: 'Swiss franc',
                short: 'CHF'
            },
            ar: {
                long: "\u0641\u0631\u0646\u0643 \u0633\u0648\u064A\u0633\u0631\u064A",
                short: 'CHF'
            }
        }
    },
    AED: {
        code: 'AED',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0631\u0647\u0645 \u0627\u0645\u0627\u0631\u0627\u062A",
                short: 'AED'
            },
            en: {
                long: 'UAE dirham',
                short: 'AED'
            },
            ar: {
                long: "\u062F\u0631\u0647\u0645 \u0625\u0645\u0627\u0631\u0627\u062A\u064A",
                short: 'AED'
            }
        }
    },
    SAR: {
        code: 'SAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0633\u0639\u0648\u062F\u06CC",
                short: 'SAR'
            },
            en: {
                long: 'Saudi riyal',
                short: 'SAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A",
                short: 'SAR'
            }
        }
    },
    QAR: {
        code: 'QAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0642\u0637\u0631",
                short: 'QAR'
            },
            en: {
                long: 'Qatari riyal',
                short: 'QAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0642\u0637\u0631\u064A",
                short: 'QAR'
            }
        }
    },
    TRY: {
        code: 'TRY',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0644\u06CC\u0631 \u062A\u0631\u06A9\u06CC\u0647",
                short: 'TRY'
            },
            en: {
                long: 'Turkish lira',
                short: 'TRY'
            },
            ar: {
                long: "\u0644\u064A\u0631\u0629 \u062A\u0631\u0643\u064A\u0629",
                short: 'TRY'
            }
        }
    },
    KWD: {
        code: 'KWD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u06A9\u0648\u06CC\u062A",
                short: 'KWD'
            },
            en: {
                long: 'Kuwaiti dinar',
                short: 'KWD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0643\u0648\u064A\u062A\u064A",
                short: 'KWD'
            }
        }
    },
    BHD: {
        code: 'BHD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0628\u062D\u0631\u06CC\u0646",
                short: 'BHD'
            },
            en: {
                long: 'Bahraini dinar',
                short: 'BHD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0628\u062D\u0631\u064A\u0646\u064A",
                short: 'BHD'
            }
        }
    },
    OMR: {
        code: 'OMR',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0639\u0645\u0627\u0646",
                short: 'OMR'
            },
            en: {
                long: 'Omani rial',
                short: 'OMR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0639\u0645\u0627\u0646\u064A",
                short: 'OMR'
            }
        }
    },
    // Whole dinars: ISO's exponent is 3, but no fils circulate and CLDR prints IQD
    // with no decimals — the same deliberate override as IRR's.
    IQD: {
        code: 'IQD',
        exponent: 0,
        displayDivisor: 1,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 0,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0639\u0631\u0627\u0642",
                short: 'IQD'
            },
            en: {
                long: 'Iraqi dinar',
                short: 'IQD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0639\u0631\u0627\u0642\u064A",
                short: 'IQD'
            }
        }
    }
});
const $fcda591c8cd139a4$export$729c9ac211f2ddda = Object.freeze(Object.keys($fcda591c8cd139a4$export$76e9d3e89dba5250));
function $fcda591c8cd139a4$export$68d15a182c6bcbf0(code) {
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$export$76e9d3e89dba5250, code);
}
function $fcda591c8cd139a4$var$invalidCurrency(code) {
    const shown = typeof code === 'string' ? JSON.stringify(code) : String(code);
    const error = new Error(`Invalid currency ${shown}: expected one of ${$fcda591c8cd139a4$export$729c9ac211f2ddda.join(', ')}`);
    error.name = 'InvalidCurrencyError';
    error.code = 'INVALID_CURRENCY';
    error.currency = code;
    return error;
}
function $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code) {
    if (code == null || code === '') return $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
    if ($fcda591c8cd139a4$export$68d15a182c6bcbf0(code)) return code;
    throw $fcda591c8cd139a4$var$invalidCurrency(code);
}
function $fcda591c8cd139a4$export$272b829bb65f9e96(code) {
    return $fcda591c8cd139a4$export$76e9d3e89dba5250[$fcda591c8cd139a4$export$b91dea8e61ccd7ef(code)];
}
function $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, currency) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return null;
    return Number(amountMinor) / displayDivisor;
}
function $fcda591c8cd139a4$export$22f3da351f420435(displayValue, currency) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const n = Number(String(displayValue ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * displayDivisor) : NaN;
}
// ── Parsing what a human typed ──────────────────────────────────────────────
const $fcda591c8cd139a4$var$PERSIAN_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
const $fcda591c8cd139a4$var$ARABIC_DIGITS = "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669";
function $fcda591c8cd139a4$var$toAsciiDigits(text) {
    return text.replace(/[۰-۹]/g, (d)=>String($fcda591c8cd139a4$var$PERSIAN_DIGITS.indexOf(d))).replace(/[٠-٩]/g, (d)=>String($fcda591c8cd139a4$var$ARABIC_DIGITS.indexOf(d)));
}
// Characters a formatted figure carries that are not part of the number: ICU puts
// an LRM before a Persian negative and an ALM before an Arabic one, and a copy out
// of an RTL page can bring RLM or an isolate along.
const $fcda591c8cd139a4$var$BIDI_MARKS = /[‎‏؜‪-‮⁦-⁩]/g;
const $fcda591c8cd139a4$var$GROUPING = /[,٬\s]/;
const $fcda591c8cd139a4$var$GROUPING_ALL = /[,٬\s]/g;
function $fcda591c8cd139a4$export$b94f7550e5b92f9c(input, currency) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (input == null) return NaN;
    const text = $fcda591c8cd139a4$var$toAsciiDigits(String(input)).replace($fcda591c8cd139a4$var$BIDI_MARKS, '').replace(/−/g, '-').replace(/٫/g, '.').trim();
    if (text === '') return NaN;
    if (info.code === $fcda591c8cd139a4$export$c19ece7ea27dcd9e) {
        const n = Number(text.replace($fcda591c8cd139a4$var$GROUPING_ALL, ''));
        return Number.isFinite(n) ? Math.round(n * info.displayDivisor) : NaN;
    }
    return $fcda591c8cd139a4$var$parseStrict(text, info);
}
function $fcda591c8cd139a4$var$parseStrict(text, { displayDivisor: displayDivisor, maxDisplayDecimals: maxDisplayDecimals }) {
    let body = text;
    let sign = 1;
    if (body[0] === '-' || body[0] === '+') {
        if (body[0] === '-') sign = -1;
        body = body.slice(1).trim();
    }
    const dot = body.indexOf('.');
    const whole = dot < 0 ? body : body.slice(0, dot);
    const fraction = dot < 0 ? '' : body.slice(dot + 1);
    if (!/^\d*$/.test(fraction) || fraction.length > maxDisplayDecimals) return NaN;
    const groups = whole.split($fcda591c8cd139a4$var$GROUPING);
    if (groups.length > 1 && (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some((g)=>!/^\d{3}$/.test(g)))) return NaN;
    const digits = groups.join('');
    if (!/^\d*$/.test(digits) || digits === '' && fraction === '') return NaN;
    // Integer arithmetic: «0.29» must be 29 cents, not 28.999999999999996.
    const scale = 10 ** maxDisplayDecimals;
    const units = Number(digits || '0') * scale + Number(fraction.padEnd(maxDisplayDecimals, '0') || '0');
    const minor = Math.round(units * displayDivisor / scale);
    if (!Number.isSafeInteger(minor)) return NaN;
    return minor === 0 ? 0 : sign * minor;
}
// ── Showing an amount ───────────────────────────────────────────────────────
// The Intl tag per panel language. The numbering system is spelled out for Arabic
// because ICU's bare `ar` now prints Latin digits, while every Parsina panel renders
// Arabic with Arabic-Indic ones (`-nu-arab` in each app's i18n config). `fa-IR` is
// what `fmtToman` has always used.
const $fcda591c8cd139a4$var$INTL_TAGS = {
    fa: 'fa-IR',
    en: 'en-US',
    ar: 'ar-u-nu-arab'
};
/** `en-GB` → `en`; unknown or unset → `fa`, as the kit's `kitCopy` falls back. */ function $fcda591c8cd139a4$var$languageOf(locale) {
    const base = String(locale || 'fa').toLowerCase().split(/[-_]/)[0];
    return Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$var$INTL_TAGS, base) ? base : 'fa';
}
// A formatter per (language, currency). Constructing Intl.NumberFormat is not free
// and amounts render inside list rows.
const $fcda591c8cd139a4$var$numberFormats = new Map();
function $fcda591c8cd139a4$var$numberFormat(language, info) {
    const key = `${language}|${info.code}`;
    let nf = $fcda591c8cd139a4$var$numberFormats.get(key);
    if (!nf) {
        nf = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language], {
            minimumFractionDigits: info.minDisplayDecimals,
            maximumFractionDigits: info.maxDisplayDecimals
        });
        $fcda591c8cd139a4$var$numberFormats.set(key, nf);
    }
    return nf;
}
function $fcda591c8cd139a4$export$e251d23bea783311(amountMinor, currency, { locale: locale = 'fa', unit: unit = 'none', fallback: fallback = "\u2014" } = {}) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const value = $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, info.code);
    if (value == null) return fallback;
    const language = $fcda591c8cd139a4$var$languageOf(locale);
    const text = $fcda591c8cd139a4$var$numberFormat(language, info).format(value);
    if (unit !== 'short' && unit !== 'long') return text;
    return `${text} ${info.labels[language][unit]}`;
}
function $fcda591c8cd139a4$export$846d8329e0c3da65(currency, locale = 'fa', style = 'long') {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    return info.labels[$fcda591c8cd139a4$var$languageOf(locale)][style === 'short' ? 'short' : 'long'];
}
class $fcda591c8cd139a4$export$7cfa96280ebafb15 extends Error {
    constructor(currencies = [], message){
        const list = [
            ...new Set(currencies)
        ];
        super(message || `Amounts in different currencies cannot be combined: ${list.join(', ')}`);
        this.name = 'MixedCurrencyError';
        this.code = 'MIXED_CURRENCY';
        this.currencies = list;
    }
}
function $fcda591c8cd139a4$export$73a0b246a0fd217a(...codes) {
    const seen = [];
    for (const code of codes.flat()){
        const normalized = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code);
        if (!seen.includes(normalized)) seen.push(normalized);
    }
    if (seen.length > 1) throw new $fcda591c8cd139a4$export$7cfa96280ebafb15(seen);
    return seen[0] || $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
}
const $fcda591c8cd139a4$var$picker = (pick, fallbackKey)=>{
    if (typeof pick === 'function') return pick;
    const key = pick ?? fallbackKey;
    return (row)=>row?.[key];
};
function $fcda591c8cd139a4$export$b440d7571b9fe7a6(rows, pickAmount, pickCurrency) {
    const amountOf = $fcda591c8cd139a4$var$picker(pickAmount, 'amount');
    const currencyOf = $fcda591c8cd139a4$var$picker(pickCurrency, 'currency');
    const totals = {};
    for (const row of rows || []){
        const raw = amountOf(row);
        if (raw == null || raw === '') continue;
        const amount = Number(raw);
        if (!Number.isFinite(amount)) continue;
        const code = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(currencyOf(row));
        totals[code] = (totals[code] || 0) + amount;
    }
    return totals;
}

});


parcelRegister("iygI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a45cd6e1b19edd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $26a45cd6e1b19edd$var$Textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, rows: rows = 3, maxLength: maxLength, showCount: showCount = false, validate: validate, disabled: disabled = false, style: style, inputStyle: // `style` dresses the FIELD (label + control + helper); `inputStyle` reaches
// the control itself — the same split `TextInput` already has. It exists for
// the mobile rule that a field's type must be ≥1rem or iOS zooms the page on
// focus (DESIGN-CONCEPT-MOBILE §6), which the 13.5px default is under.
inputStyle, dir: // Unset: inherits the document's direction (§16.3). It defaulted to 'rtl',
// which pinned every note field in the product to RTL whatever the language.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        rows: rows,
        maxLength: maxLength,
        dir: dir,
        className: (0, $5JYPc.cn)('w-full px-3.5 py-3 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none resize-none leading-7', 'transition-[border-color,box-shadow] duration-150', showCount && maxLength && 'pb-6', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }), showCount && maxLength && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute bottom-2 end-3 text-[10.5px] text-muted-foreground pointer-events-none select-none"
    }, (value || '').length, "/", maxLength)));
});
$26a45cd6e1b19edd$var$Textarea.displayName = 'Textarea';
var $26a45cd6e1b19edd$export$2e2bcd8739ae039 = $26a45cd6e1b19edd$var$Textarea;

});

parcelRegister("fAR2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f997edd3d0e9220$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");
'use client';
const $2f997edd3d0e9220$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, options: options = [], placeholder: placeholder, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    if (placeholder === undefined) placeholder = (0, $j9AxR.kitCopy)().select.placeholder;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        disabled: disabled,
        className: (0, $5JYPc.cn)(// Logical padding, and no `dir` of its own: the room for the chevron
        // is on the field's END edge, whichever side that is. It used to be
        // `dir="rtl"` + `pr-3.5 pl-8`, which put a Persian-shaped control
        // inside an English page and the chevron on top of the text.
        'w-full h-11 ps-3.5 pe-8 rounded-lg font-sans text-[13.5px]', 'bg-white border-[1.5px] outline-none appearance-none cursor-pointer', 'transition-[border-color,box-shadow] duration-150', value ? 'text-foreground' : 'text-muted-foreground', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }, placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), options.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    })))));
});
$2f997edd3d0e9220$var$Select.displayName = 'Select';
var $2f997edd3d0e9220$export$2e2bcd8739ae039 = $2f997edd3d0e9220$var$Select;

});

parcelRegister("5Rv3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f8655df02249d5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $YeY8y = parcelRequire("YeY8y");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $43f8655df02249d5$var$ToggleGroup = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($YeY8y.Root, {
        type: "single",
        value: value,
        onValueChange: (v)=>{
            if (!v) return;
            onChange(v);
            setTouched(true);
            if (validate) setInternalError(validate(v) || '');
        },
        disabled: disabled,
        className: (0, $5JYPc.cn)('flex gap-1.5 p-1 rounded-xl bg-[#f4f6f9]', error && 'ring-[1.5px] ring-destructive')
    }, options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($YeY8y.Item, {
            key: opt.value,
            value: opt.value,
            className: (0, $5JYPc.cn)('flex-1 h-[38px] rounded-[9px] font-sans text-[13px]', 'flex items-center justify-center gap-1.5', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=on]:bg-white data-[state=on]:text-navy data-[state=on]:font-bold data-[state=on]:shadow-sm', 'data-[state=off]:bg-transparent data-[state=off]:text-muted-foreground data-[state=off]:font-medium', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[15px]"
        }, opt.icon), opt.label))));
};
var $43f8655df02249d5$export$2e2bcd8739ae039 = $43f8655df02249d5$var$ToggleGroup;

});
parcelRegister("YeY8y", function(module, exports) {

$parcel$export(module.exports, "Root", () => $57c1675cf83b8426$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Item", () => $57c1675cf83b8426$export$6d08773d2e66f8f2);

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $kFbxc = parcelRequire("kFbxc");

var $abA6z = parcelRequire("abA6z");

var $bTgTs = parcelRequire("bTgTs");

var $88UcQ = parcelRequire("88UcQ");

var $5ZQml = parcelRequire("5ZQml");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $jnK0n.createContextScope)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $abA6z.createRovingFocusGroupScope)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $abA6z.createRovingFocusGroupScope)();
var $57c1675cf83b8426$export$af3ec21f6cfb5e30 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
});
$57c1675cf83b8426$export$af3ec21f6cfb5e30.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $88UcQ.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupMultipleProps } = props;
    const [value, setValue] = (0, $88UcQ.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
});
$57c1675cf83b8426$export$af3ec21f6cfb5e30.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $5ZQml.useDirection)(dir);
    const commonProps = {
        role: "group",
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $ayMG0.jsx)($abA6z.Root, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$b453109e13abe10b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $ayMG0.jsx)($abA6z.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
});
$57c1675cf83b8426$export$b453109e13abe10b.displayName = $57c1675cf83b8426$var$ITEM_NAME;
var $57c1675cf83b8426$var$ToggleGroupItemImpl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $bTgTs.Toggle), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
});
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = $57c1675cf83b8426$export$af3ec21f6cfb5e30;
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = $57c1675cf83b8426$export$b453109e13abe10b;

});
parcelRegister("jnK0n", function(module, exports) {

$parcel$export(module.exports, "createContext", () => $45e038b71f97d914$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "createContextScope", () => $45e038b71f97d914$export$50c7b4e9d9f19c1);
// packages/react/context/src/create-context.tsx

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $ayMG0.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $ayMG0.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});

parcelRegister("kFbxc", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $dc7d5df3de21cdcb$export$250ffa63cdc0d034);
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", () => $dc7d5df3de21cdcb$export$6d1a0317bde7de7f);
// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dWoYZ = parcelRequire("dWoYZ");

var $ayMG0 = parcelRequire("ayMG0");
var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $dWoYZ.createSlot)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;

});
parcelRegister("dWoYZ", function(module, exports) {

$parcel$export(module.exports, "createSlot", () => $6830440b411b8a29$export$e88b45bda5c13eb9);
// src/slot.tsx

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $ayMG0 = parcelRequire("ayMG0");
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $6830440b411b8a29$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($6830440b411b8a29$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $6830440b411b8a29$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $6830440b411b8a29$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($acw62.isValidElement(children)) {
            const childrenRef = $6830440b411b8a29$var$getElementRef(children);
            const props2 = $6830440b411b8a29$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $htT6J.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $6830440b411b8a29$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $6830440b411b8a29$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $6830440b411b8a29$export$bf68c29d8281d0f7("Slottable");
function $6830440b411b8a29$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $6830440b411b8a29$var$SLOTTABLE_IDENTIFIER;
}
function $6830440b411b8a29$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $6830440b411b8a29$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

});
parcelRegister("htT6J", function(module, exports) {

$parcel$export(module.exports, "composeRefs", () => $fb3356a19a5676fa$export$43e446d32b3d21af);
$parcel$export(module.exports, "useComposedRefs", () => $fb3356a19a5676fa$export$c7b2cbe3552a0d05);
// packages/react/compose-refs/src/compose-refs.tsx

var $acw62 = parcelRequire("acw62");
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}

});



parcelRegister("abA6z", function(module, exports) {

$parcel$export(module.exports, "createRovingFocusGroupScope", () => $0483c88073bf4923$export$c7109489551a4f4);
$parcel$export(module.exports, "Root", () => $0483c88073bf4923$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Item", () => $0483c88073bf4923$export$6d08773d2e66f8f2);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $9nBzD = parcelRequire("9nBzD");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $88UcQ = parcelRequire("88UcQ");

var $5ZQml = parcelRequire("5ZQml");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $9nBzD.createCollection)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $jnK0n.createContextScope)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$0483c88073bf4923$export$8699f7c8af148338.displayName = $0483c88073bf4923$var$GROUP_NAME;
var $0483c88073bf4923$var$RovingFocusGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const direction = (0, $5ZQml.useDirection)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $88UcQ.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $by19I.useCallbackRef)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $g2NP0.useId)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $acw62.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$0483c88073bf4923$export$ab9df7c53fe8454.displayName = $0483c88073bf4923$var$ITEM_NAME;
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;

});
parcelRegister("2IwC4", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $b4e9a20689651e16$export$b9ecd428b558ff10);
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}

});

parcelRegister("9nBzD", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $a9634733d4b9bce9$export$c74125a8e3af6bb2);

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $htT6J = parcelRequire("htT6J");

var $jOPVO = parcelRequire("jOPVO");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $jOPVO.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $jOPVO.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [collectionElement, setCollectionElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composeRefs = (0, $htT6J.useComposedRefs)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $jOPVO.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $jOPVO.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}

});
parcelRegister("jOPVO", function(module, exports) {

$parcel$export(module.exports, "createSlot", () => $3afaf9d4aa644d4a$export$e88b45bda5c13eb9);
// src/slot.tsx

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $ayMG0 = parcelRequire("ayMG0");
// @__NO_SIDE_EFFECTS__
function $3afaf9d4aa644d4a$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $3afaf9d4aa644d4a$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($3afaf9d4aa644d4a$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $3afaf9d4aa644d4a$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $3afaf9d4aa644d4a$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $3afaf9d4aa644d4a$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($acw62.isValidElement(children)) {
            const childrenRef = $3afaf9d4aa644d4a$var$getElementRef(children);
            const props2 = $3afaf9d4aa644d4a$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $htT6J.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $3afaf9d4aa644d4a$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $3afaf9d4aa644d4a$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $3afaf9d4aa644d4a$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $3afaf9d4aa644d4a$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $3afaf9d4aa644d4a$export$bf68c29d8281d0f7("Slottable");
function $3afaf9d4aa644d4a$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $3afaf9d4aa644d4a$var$SLOTTABLE_IDENTIFIER;
}
function $3afaf9d4aa644d4a$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $3afaf9d4aa644d4a$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

});


parcelRegister("g2NP0", function(module, exports) {

$parcel$export(module.exports, "useId", () => $11885ec535b13ccc$export$f680877a34711e37);
// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $7g00o.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("7g00o", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $b68d88740313b08e$export$e5c5a5f917a5871c);
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};

});


parcelRegister("by19I", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $95d2d9f03fd0d4db$export$25bec8c6f54ee79a);
// packages/react/use-callback-ref/src/use-callback-ref.tsx

var $acw62 = parcelRequire("acw62");
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}

});

parcelRegister("88UcQ", function(module, exports) {

$parcel$export(module.exports, "useControllableState", () => $aef12de5508fd46e$export$6f32135080cb4c3);
// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");

var $c0Rea = parcelRequire("c0Rea");
var $aef12de5508fd46e$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $7g00o.useLayoutEffect);
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $aef12de5508fd46e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $aef12de5508fd46e$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $aef12de5508fd46e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $aef12de5508fd46e$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $aef12de5508fd46e$var$isFunction(value) {
    return typeof value === "function";
}
var $aef12de5508fd46e$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $aef12de5508fd46e$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $c0Rea.useEffectEvent)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $aef12de5508fd46e$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $aef12de5508fd46e$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}

});
parcelRegister("c0Rea", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $07b0b1ce13d5e29f$export$7f54fc3180508a52);
// src/use-effect-event.tsx

var $7g00o = parcelRequire("7g00o");

var $acw62 = parcelRequire("acw62");
var $07b0b1ce13d5e29f$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $07b0b1ce13d5e29f$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $07b0b1ce13d5e29f$export$7f54fc3180508a52(callback) {
    if (typeof $07b0b1ce13d5e29f$var$useReactEffectEvent === "function") return $07b0b1ce13d5e29f$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $07b0b1ce13d5e29f$var$useReactInsertionEffect === "function") $07b0b1ce13d5e29f$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $7g00o.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}

});


parcelRegister("5ZQml", function(module, exports) {

$parcel$export(module.exports, "useDirection", () => $f9ad7d2f57cc5bec$export$b39126d51d94e6f3);
// packages/react/direction/src/direction.tsx

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;

});


parcelRegister("bTgTs", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $62b265af90252982$export$bea8ebba691c5813);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $88UcQ = parcelRequire("88UcQ");

var $kFbxc = parcelRequire("kFbxc");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = $acw62.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $88UcQ.useControllableState)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$62b265af90252982$export$bea8ebba691c5813.displayName = $62b265af90252982$var$NAME;
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;

});



parcelRegister("bkKUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcaca06c97c91379$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $fcaca06c97c91379$var$ChipSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], multi: multi = false, activeColor: activeColor = 'var(--p-navy)', activeBg: activeBg = 'hsl(var(--accent))', validate: validate, disabled: disabled = false, style: style, touch: // `touch` sizes the chips for a finger (2.75rem); `testId` names the row and,
// with each option's `testKey` (else its value), every chip in it; `children`
// follow the chips in the same row — a «more» toggle belongs there.
touch = false, testId: testId, children: children })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const isActive = (v)=>multi ? (value || []).includes(v) : value === v;
    const handleToggle = (optValue)=>{
        if (disabled) return;
        let next;
        if (multi) {
            const arr = value || [];
            next = arr.includes(optValue) ? arr.filter((v)=>v !== optValue) : [
                ...arr,
                optValue
            ];
        } else next = value === optValue ? '' : optValue;
        onChange(next);
        setTouched(true);
        if (validate) setInternalError(validate(next) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap gap-1.5",
        "data-testid": testId
    }, options.map((opt)=>{
        const active = isActive(opt.value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleToggle(opt.value),
            disabled: disabled,
            "aria-pressed": active,
            title: opt.title,
            "data-testid": testId ? `${testId}-${opt.testKey ?? opt.value}` : undefined,
            className: (0, $5JYPc.cn)(touch ? 'min-h-11' : 'h-[34px]', 'px-3.5 rounded-full font-sans text-xs whitespace-nowrap', 'border-[1.5px] transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', error && !active && 'border-destructive', !error && !active && 'border-border text-[#5a6780] font-medium', disabled && 'cursor-not-allowed opacity-50'),
            style: active ? {
                borderColor: activeColor,
                background: activeBg,
                color: activeColor,
                fontWeight: 700
            } : undefined
        }, opt.label);
    }), children));
};
var $fcaca06c97c91379$export$2e2bcd8739ae039 = $fcaca06c97c91379$var$ChipSelector;

});

parcelRegister("jIDmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $995baf94da7c0c12$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $995baf94da7c0c12$var$CardSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], columns: columns = 4, validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const handleSelect = (v)=>{
        if (disabled) return;
        onChange(v);
        setTouched(true);
        if (validate) setInternalError(validate(v) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "grid gap-2",
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
        }
    }, options.map((opt)=>{
        const active = value === opt.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleSelect(opt.value),
            disabled: disabled,
            className: (0, $5JYPc.cn)('py-3.5 px-2 rounded-xl border-[1.5px] text-center font-sans', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', active ? 'border-navy bg-accent text-navy shadow-sm' : error ? 'border-destructive bg-white text-muted-foreground' : 'border-border bg-white text-muted-foreground', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-xl mb-1.5 leading-none"
        }, opt.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('text-[11px] leading-snug', active ? 'font-bold' : 'font-medium')
        }, opt.label));
    })));
};
var $995baf94da7c0c12$export$2e2bcd8739ae039 = $995baf94da7c0c12$var$CardSelector;

});

parcelRegister("amyVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $318ef1f4a903d866$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// A search box is a *labelled control*, and a filter toolbar needs to be
// selectable in tests (§15.1) — so the wrapper takes the rest props
// (`data-testid`, `id`, …) and the input takes the ones that belong to a text
// field (`aria-label`, `onKeyDown`, `name`, `autoFocus`, `disabled`).
// The clear button restores focus to the field: losing focus to <body> after
// clearing is a keyboard dead end.
const $318ef1f4a903d866$var$SearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, placeholder: placeholder, className: className, style: style, inputProps: inputProps, 'aria-label': ariaLabel, onKeyDown: onKeyDown, name: name, id: id, disabled: disabled = false, autoFocus: autoFocus, clearLabel: clearLabel, ...rest }, ref)=>{
    const copy = (0, $j9AxR.kitCopy)().search;
    if (placeholder === undefined) placeholder = copy.placeholder;
    if (clearLabel === undefined) clearLabel = copy.clear;
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The caller's ref wins; the internal one is what the clear button focuses.
    // A search box that a keyboard shortcut cannot focus is a search box the
    // keyboard-first flows (F3, `/`) have to reach by querySelector.
    const setRef = (node)=>{
        inputRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('relative', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "15",
        height: "15",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: setRef,
        type: "search",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        name: name,
        id: id,
        disabled: disabled,
        autoFocus: autoFocus,
        className: (0, $5JYPc.cn)(// min-h-11 (2.75rem), not h-10: this control ships in mobile filter
        // toolbars, where DESIGN-CONCEPT-MOBILE §368 puts the floor at 44px.
        'w-full min-h-11 ps-9 pe-8 rounded-lg font-sans text-[13px] text-foreground', 'bg-white border-[1.5px] border-border outline-none', 'transition-[border-color,box-shadow] duration-150', 'focus:border-primary focus:shadow-ring-navy', 'placeholder:text-muted-foreground', disabled && 'opacity-50 cursor-not-allowed', // The native search affordance would sit on top of our clear button.
        '[&::-webkit-search-cancel-button]:appearance-none'),
        ...inputProps
    }), value && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        onClick: ()=>{
            onChange({
                target: {
                    value: ''
                }
            });
            inputRef.current?.focus();
        },
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 flex p-0.5 rounded text-muted-foreground hover:text-foreground transition-colors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))));
});
$318ef1f4a903d866$var$SearchInput.displayName = 'SearchInput';
var $318ef1f4a903d866$export$2e2bcd8739ae039 = $318ef1f4a903d866$var$SearchInput;

});

parcelRegister("9gEOi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6c6e1277da35de$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4pk8U = parcelRequire("4pk8U");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// `label` takes a node, not just a string: a picker row is a checkbox whose
// label IS the row (name, value, trend), and wrapping it here keeps the whole
// row inside the native <label> hit area instead of re-implementing one.
// `className`/rest land on that <label> so callers can carry the §15.1
// `data-testid` / `data-state` contract without a wrapper element.
const $7a6c6e1277da35de$var$Checkbox = ({ checked: checked, onChange: onChange, label: label, disabled: disabled = false, className: className, labelClassName: labelClassName, style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $5JYPc.cn)('flex items-center gap-2.5 select-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4pk8U.Root, {
        checked: checked,
        onCheckedChange: onChange,
        disabled: disabled,
        className: (0, $5JYPc.cn)('h-[18px] w-[18px] shrink-0 rounded-[5px] border-[1.5px]', 'flex items-center justify-center', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', checked ? 'bg-navy border-navy' : 'bg-white border-border', disabled && 'opacity-50')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4pk8U.Indicator, {
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "11",
        height: "11"
    }, checked === 'indeterminate' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 11h14v2H5z"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })))), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5JYPc.cn)('text-sm font-sans text-foreground', labelClassName)
    }, label));
var $7a6c6e1277da35de$export$2e2bcd8739ae039 = $7a6c6e1277da35de$var$Checkbox;

});
parcelRegister("4pk8U", function(module, exports) {

$parcel$export(module.exports, "Indicator", () => $99e5d66a1fc753c6$export$59aad738f51d1c05);
$parcel$export(module.exports, "Root", () => $99e5d66a1fc753c6$export$48513f6b9f8ce62d);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $2IwC4 = parcelRequire("2IwC4");

var $88UcQ = parcelRequire("88UcQ");

var $ifoNS = parcelRequire("ifoNS");

var $8727j = parcelRequire("8727j");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $jnK0n.createContextScope)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $88UcQ.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $2IwC4.composeEventHandlers)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $2IwC4.composeEventHandlers)(onClick, (event)=>{
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$99e5d66a1fc753c6$export$1386466acbe59ca2.displayName = $99e5d66a1fc753c6$var$TRIGGER_NAME;
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$99e5d66a1fc753c6$export$48513f6b9f8ce62d.displayName = $99e5d66a1fc753c6$var$CHECKBOX_NAME;
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$99e5d66a1fc753c6$export$59aad738f51d1c05.displayName = $99e5d66a1fc753c6$var$INDICATOR_NAME;
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $ifoNS.usePrevious)(checked);
    const controlSize = (0, $8727j.useSize)(control);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$99e5d66a1fc753c6$export$493083511fc9f964.displayName = $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME;
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

});
parcelRegister("ifoNS", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $44b714300f6a50aa$export$5cae361ad82dce8b);
// packages/react/use-previous/src/use-previous.tsx

var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        previous: value
    });
    return $acw62.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}

});

parcelRegister("8727j", function(module, exports) {

$parcel$export(module.exports, "useSize", () => $db5ba6ddde57f255$export$1ab7ae714698c4b8);
// packages/react/use-size/src/use-size.tsx

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}

});

parcelRegister("cTFdF", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $3207c0aa9f229d8f$export$99c2b779aa4e8b8b);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $7g00o = parcelRequire("7g00o");
"use client";
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = (0, $htT6J.useComposedRefs)(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $3207c0aa9f229d8f$export$be92b6f5f03c0fe9 = $3207c0aa9f229d8f$export$99c2b779aa4e8b8b;

});



parcelRegister("3GEBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddccb5e00ce1ba3b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ddccb5e00ce1ba3b$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, label: label, description: description, disabled: disabled = false, id: id, ...rest }) {
    const reactId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rowId = id || reactId;
    const labelId = `${rowId}-label`;
    const descId = description ? `${rowId}-desc` : undefined;
    // The kit styles inline, which cannot express :focus-visible — so the ring is
    // tracked here. Keyed on :focus-visible rather than :focus so a pointer tap
    // does not leave a ring behind, which is the behaviour the pseudo-class
    // exists to give. Setting only outlineColor (as this component did) paints
    // nothing: without an outline-style there is no outline to colour.
    const [focusRing, setFocusRing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            padding: '14px 0',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        id: labelId,
        htmlFor: rowId,
        style: {
            display: 'block',
            fontSize: 14,
            color: (0, $jTCZr.C).textPrimary,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }
    }, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descId,
        style: {
            display: 'block',
            fontSize: 12,
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        id: rowId,
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descId,
        disabled: disabled,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            // `matches` can throw on engines without :focus-visible; a ring on
            // plain focus is a better failure than no ring at all.
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setFocusRing(visible);
        },
        onBlur: ()=>setFocusRing(false),
        style: {
            width: 44,
            height: 24,
            borderRadius: 999,
            flexShrink: 0,
            padding: 0,
            border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
            background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            transition: 'background 0.25s, box-shadow 0.15s',
            outline: 'none',
            boxShadow: focusRing ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.45)}` : 'none'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: 'white',
            transition: 'inset-inline-end 0.25s',
            insetInlineEnd: checked ? 2 : 22,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            pointerEvents: 'none'
        }
    })));
}

});

parcelRegister("aJ1FU", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b6a9e95398564b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9UeUh = parcelRequire("9UeUh");

var $2DiCt = parcelRequire("2DiCt");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $39b6a9e95398564b$export$dca1ee5a936bb312 = (0, $2DiCt.cva)('inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-all duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 select-none', {
    variants: {
        variant: {
            default: 'bg-navy text-white hover:bg-navy-dark active:scale-[0.98]',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 active:scale-[0.98]',
            outline: 'border-[1.5px] border-border bg-white text-foreground hover:bg-muted active:scale-[0.98]',
            ghost: 'bg-transparent text-foreground hover:bg-muted',
            link: 'text-primary underline-offset-4 hover:underline',
            teal: 'bg-clinic-teal text-white hover:opacity-90 active:scale-[0.98]',
            // Tonal primary — a navy-tinted pill for secondary actions that still read
            // as brand (jump-to-today, filter chips) without the weight of a solid fill.
            subtle: 'bg-navy/5 text-navy border-[1.5px] border-navy/20 hover:bg-navy/10 active:scale-[0.98]',
            // A sidebar destination, on the deep-azure gradient rail. Selected state
            // arrives as `data-active="true"` (set it beside `aria-current="page"`),
            // NOT as a className the caller assembles: all four staff shells were
            // writing the same four overrides onto `variant="ghost"`, which §17.1
            // calls a fork of a kit component. The active pill is the brand
            // gradient — the single lit moment on a deliberately teal-free rail.
            nav: 'w-full justify-start font-medium text-white/60 hover:bg-white/10 hover:text-white data-[active=true]:bg-gradient-brand data-[active=true]:text-white data-[active=true]:font-bold data-[active=true]:hover:bg-gradient-brand'
        },
        size: {
            default: 'h-11 px-5 text-[13.5px]',
            sm: 'h-9  px-4 text-xs rounded-md',
            lg: 'h-12 px-7 text-[15px]',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const $39b6a9e95398564b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $9UeUh.Slot) : 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, {
        ref: ref,
        className: (0, $5JYPc.cn)($39b6a9e95398564b$export$dca1ee5a936bb312({
            variant: variant,
            size: size
        }), className),
        ...props
    });
});
$39b6a9e95398564b$export$353f5b6fc5456de1.displayName = 'Button';
var $39b6a9e95398564b$export$2e2bcd8739ae039 = $39b6a9e95398564b$export$353f5b6fc5456de1;

});
parcelRegister("9UeUh", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $cf381de56a25bc52$export$be92b6f5f03c0fe9);
// src/slot.tsx

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $ayMG0 = parcelRequire("ayMG0");
var $cf381de56a25bc52$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $cf381de56a25bc52$var$use = $acw62[" use ".trim().toString()];
function $cf381de56a25bc52$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
function $cf381de56a25bc52$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $cf381de56a25bc52$var$REACT_LAZY_TYPE && "_payload" in element && $cf381de56a25bc52$var$isPromiseLike(element._payload);
}
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $cf381de56a25bc52$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($cf381de56a25bc52$var$isLazyComponent(children) && typeof $cf381de56a25bc52$var$use === "function") children = $cf381de56a25bc52$var$use(children._payload);
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($cf381de56a25bc52$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        if ($cf381de56a25bc52$var$isLazyComponent(children) && typeof $cf381de56a25bc52$var$use === "function") children = $cf381de56a25bc52$var$use(children._payload);
        if ($acw62.isValidElement(children)) {
            const childrenRef = $cf381de56a25bc52$var$getElementRef(children);
            const props2 = $cf381de56a25bc52$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $htT6J.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

});

parcelRegister("2DiCt", function(module, exports) {

$parcel$export(module.exports, "cva", () => $7d867aa0bbfd521e$export$87dc52566e90b739);
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $9QePP = parcelRequire("9QePP");
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $9QePP.clsx);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

});


parcelRegister("bHjRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd0c49a5377bd48$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2DiCt = parcelRequire("2DiCt");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $ddd0c49a5377bd48$export$48443d129636634d = (0, $2DiCt.cva)('inline-flex items-center rounded-full font-sans font-semibold whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-accent text-accent-foreground text-[11px] px-2.5 py-0.5',
            // The three pale chip pairs are CSS variables (tokens.css), not
            // literals. Same pixels; the point is that a theme can reach them —
            // every raw hex left in a component is a future dark-mode bug (§11).
            destructive: 'bg-[var(--chip-danger-bg)]  text-[var(--chip-danger-ink)]  text-[11px] px-2.5 py-0.5',
            success: 'bg-[var(--chip-success-bg)] text-[var(--chip-success-ink)] text-[11px] px-2.5 py-0.5',
            warning: 'bg-[var(--chip-warning-bg)] text-[var(--chip-warning-ink)] text-[11px] px-2.5 py-0.5',
            outline: 'border border-border text-foreground text-[11px] px-2.5 py-0.5',
            // `count` — the ONE unread/tally chip. A solid navy pill, not the pale
            // tint `default` gives: every conversation row in every app was
            // overriding `default` with the same inline `background`/`color` to get
            // this, which is the hand-rolled primitive rule in slow motion.
            // `tabular-nums` keeps «۱» and «۹+» the same width so a live count does
            // not jitter the row, and `min-w-5` keeps a single digit round.
            // The swatch is navy, matching `BottomNav`'s `badgeTone: 'count'` —
            // one colour means "unread" everywhere (see DESIGN.md, Messaging).
            // `var(--p-navy)` rather than the `bg-navy` hex so the chip follows the
            // doctor's accent preset exactly as `C.navy` (which BottomNav uses) does.
            count: 'bg-[var(--p-navy)] text-white text-[11px] font-bold leading-5 min-w-5 justify-center px-1.5 tabular-nums shrink-0'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const $ddd0c49a5377bd48$export$37acb3580601e69a = ({ className: className, variant: variant, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5JYPc.cn)($ddd0c49a5377bd48$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    }, children);
var $ddd0c49a5377bd48$export$2e2bcd8739ae039 = $ddd0c49a5377bd48$export$37acb3580601e69a;

});

parcelRegister("4fYdd", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $ace11be13f1c53cf$export$3ddf2d174ce01153);
$parcel$export(module.exports, "DialogTrigger", () => $ace11be13f1c53cf$export$2e1e1122cf0cba88);
$parcel$export(module.exports, "DialogClose", () => $ace11be13f1c53cf$export$fba2fb7cd781b7ac);
$parcel$export(module.exports, "DialogContent", () => $ace11be13f1c53cf$export$b6d9565de1e068cf);
$parcel$export(module.exports, "DialogHeader", () => $ace11be13f1c53cf$export$742513523b177e3b);
$parcel$export(module.exports, "DialogBody", () => $ace11be13f1c53cf$export$5d20f2c38fcde41f);
$parcel$export(module.exports, "DialogFooter", () => $ace11be13f1c53cf$export$7bbfb2d443473050);
$parcel$export(module.exports, "DialogTitle", () => $ace11be13f1c53cf$export$16f7638e4a34b909);
$parcel$export(module.exports, "DialogDescription", () => $ace11be13f1c53cf$export$94e94c2ec2c954d5);

var $acw62 = parcelRequire("acw62");

var $dBsUf = parcelRequire("dBsUf");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $ace11be13f1c53cf$export$3ddf2d174ce01153 = $dBsUf.Root;
const $ace11be13f1c53cf$export$2e1e1122cf0cba88 = $dBsUf.Trigger;
const $ace11be13f1c53cf$export$fba2fb7cd781b7ac = $dBsUf.Close;
const $ace11be13f1c53cf$export$dad7c95542bacce0 = $dBsUf.Portal;
// ── Overlay z-scale (keep these in sync; see DESIGN.md "Overlay layering") ──
// Drawer 11 < BottomSheet 1000 < Dialog/ConfirmDialog 1100 < Toast / JalaliDatePicker 9999
//
// The dialog layer MUST sit above BottomSheet: a ConfirmDialog is routinely opened from
// inside a sheet (destructive confirms, unsaved-changes guards). At the old z-50 it
// rendered *behind* the sheet while Radix's modal mode set `pointer-events: none` on
// <body> — so the sheet froze with an invisible modal trapping focus, unrecoverable by
// touch. Raising the dialog (rather than lowering the sheet) is the safe direction:
// mobile chrome that must stay under a sheet — the doctor app's MobileBottomNav (z-50)
// and MobileVisitClosureFlow (z-60) — keeps working unchanged.
const $ace11be13f1c53cf$var$Z_DIALOG = 'z-[1100]';
// A dialog is a transition the user asked for, so it animates — but §12.4 of the
// design concept says every transition collapses to instant under
// `prefers-reduced-motion`. Radix drives the animation through `data-state`
// classes, so the opt-out has to be a class too; without it the dialog was the
// one overlay that kept moving for a user who asked it not to.
const $ace11be13f1c53cf$var$MOTION_SAFE = 'motion-reduce:animate-none motion-reduce:transition-none';
const $ace11be13f1c53cf$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Overlay, {
        ref: ref,
        className: (0, $5JYPc.cn)('fixed inset-0 bg-black/45', $ace11be13f1c53cf$var$Z_DIALOG, 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }));
$ace11be13f1c53cf$export$bd1d06c79be19e17.displayName = 'DialogOverlay';
// Floating layers portaled to <body> (e.g. the Jalali calendar popup) live outside the
// dialog's DOM, so Radix would treat interacting with them as an outside click and close
// the dialog mid-pick. Anything inside [data-jalali-popup] is ours, not "outside".
const $ace11be13f1c53cf$var$isInFloatingLayer = (e)=>e.target instanceof Element && e.target.closest('[data-jalali-popup]');
// ── Width ────────────────────────────────────────────────────────────────────
// Four widths rather than a free `className` override, because "how wide is a
// dialog" is a design-system decision: a confirm and a full review surface must
// not each pick their own number. `md` is the historical default, so every
// existing call site keeps its exact width.
const $ace11be13f1c53cf$var$SIZE = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-[52rem]'
};
// ── Layout ───────────────────────────────────────────────────────────────────
// `scroll` (default) is the classic dialog: one padded box that scrolls as a
// whole. `frame` is the surface with its own chrome — a fixed header, a
// scrolling body and a docked footer — which is what a review/receipt overlay
// needs so its primary action never scrolls out of reach. The three slot
// components read the mode from context rather than taking a prop, so a caller
// cannot half-apply it.
const $ace11be13f1c53cf$var$LayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('scroll');
const $ace11be13f1c53cf$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children, showClose: showClose = true, size: size = 'md', layout: layout = 'scroll', ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$dad7c95542bacce0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$bd1d06c79be19e17, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Content, {
        ref: ref,
        onPointerDownOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onFocusOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        className: (0, $5JYPc.cn)('fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', $ace11be13f1c53cf$var$Z_DIALOG, 'w-full bg-white rounded-2xl shadow-modal', $ace11be13f1c53cf$var$SIZE[size] || $ace11be13f1c53cf$var$SIZE.md, layout === 'frame' ? [
            'grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden',
            'max-h-[calc(100vh-3rem)] [@supports(height:1dvh)]:max-h-[calc(100dvh-3rem)]'
        ] : 'max-h-[90vh] overflow-y-auto p-8', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2', 'data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%]', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$var$LayoutContext.Provider, {
        value: layout
    }, children), showClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Close, {
        className: "absolute end-5 top-5 rounded-sm opacity-70 hover:opacity-100 outline-none focus:ring-2 focus:ring-ring transition-opacity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))))));
$ace11be13f1c53cf$export$b6d9565de1e068cf.displayName = 'DialogContent';
const $ace11be13f1c53cf$export$742513523b177e3b = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-1.5', layout === 'frame' ? 'px-5 py-4 border-b border-border' : 'mb-6', className),
        ...props
    });
};
// The scroll region of a `frame` dialog. `overscroll-contain` is what stops a
// flick at the end of the list from scrolling the page behind the dialog.
const $ace11be13f1c53cf$export$5d20f2c38fcde41f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $5JYPc.cn)(layout === 'frame' ? 'overflow-y-auto overscroll-contain p-5' : '', className),
        ...props
    });
});
$ace11be13f1c53cf$export$5d20f2c38fcde41f.displayName = 'DialogBody';
const $ace11be13f1c53cf$export$7bbfb2d443473050 = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex gap-2.5', layout === 'frame' ? 'px-5 py-3 border-t border-border flex-wrap' : 'mt-6', className),
        ...props
    });
};
const $ace11be13f1c53cf$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Title, {
        ref: ref,
        className: (0, $5JYPc.cn)('text-[18px] font-extrabold text-foreground', className),
        ...props
    }));
$ace11be13f1c53cf$export$16f7638e4a34b909.displayName = 'DialogTitle';
const $ace11be13f1c53cf$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Description, {
        ref: ref,
        className: (0, $5JYPc.cn)('text-sm text-muted-foreground leading-6', className),
        ...props
    }));
$ace11be13f1c53cf$export$94e94c2ec2c954d5.displayName = 'DialogDescription';

});
parcelRegister("dBsUf", function(module, exports) {

$parcel$export(module.exports, "Root", () => $eeaeb48e23f662e7$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Trigger", () => $eeaeb48e23f662e7$export$41fb9f06171c75f4);
$parcel$export(module.exports, "Portal", () => $eeaeb48e23f662e7$export$602eac185826482c);
$parcel$export(module.exports, "Overlay", () => $eeaeb48e23f662e7$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "Content", () => $eeaeb48e23f662e7$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Title", () => $eeaeb48e23f662e7$export$f99233281efd08a0);
$parcel$export(module.exports, "Description", () => $eeaeb48e23f662e7$export$393edc798c47379d);
$parcel$export(module.exports, "Close", () => $eeaeb48e23f662e7$export$f39c2d165cd861fe);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $88UcQ = parcelRequire("88UcQ");

var $4yZYB = parcelRequire("4yZYB");

var $kNgwr = parcelRequire("kNgwr");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $fg1c6 = parcelRequire("fg1c6");

var $hPyeV = parcelRequire("hPyeV");

var $6okVC = parcelRequire("6okVC");

var $1iuNh = parcelRequire("1iuNh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $jnK0n.createContextScope)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $g2NP0.useId)(),
        titleId: (0, $g2NP0.useId)(),
        descriptionId: (0, $g2NP0.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $htT6J.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $5nYva.Portal), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$Slot = (0, $1iuNh.createSlot)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $hPyeV.default), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$b6d9565de1e068cf = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$b6d9565de1e068cf.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $6okVC.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $2IwC4.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $2IwC4.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, contentRef);
    (0, $fg1c6.useFocusGuards)();
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kNgwr.FocusScope), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $4yZYB.DismissableLayer), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$94e94c2ec2c954d5.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$fba2fb7cd781b7ac.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
var $eeaeb48e23f662e7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$useWarningContext] = (0, $jnK0n.createContext)($eeaeb48e23f662e7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $eeaeb48e23f662e7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $acw62.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $eeaeb48e23f662e7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $acw62.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
var $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
var $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
var $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
var $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
var $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;

});
parcelRegister("4yZYB", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", () => $30a399657994b369$export$177fb62ff3ec1f22);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $kFbxc = parcelRequire("kFbxc");

var $htT6J = parcelRequire("htT6J");

var $by19I = parcelRequire("by19I");

var $e1oKh = parcelRequire("e1oKh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $30a399657994b369$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $e1oKh.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $2IwC4.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $2IwC4.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $2IwC4.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$30a399657994b369$export$177fb62ff3ec1f22.displayName = $30a399657994b369$var$DISMISSABLE_LAYER_NAME;
var $30a399657994b369$var$BRANCH_NAME = "DismissableLayerBranch";
var $30a399657994b369$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...props,
        ref: composedRefs
    });
});
$30a399657994b369$export$4d5eb2109db14228.displayName = $30a399657994b369$var$BRANCH_NAME;
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $by19I.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $by19I.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $kFbxc.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
var $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
var $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;

});
parcelRegister("e1oKh", function(module, exports) {

$parcel$export(module.exports, "useEscapeKeydown", () => $322b9f9e9e453dd6$export$3a72a57244d6e765);
// packages/react/use-escape-keydown/src/use-escape-keydown.tsx

var $acw62 = parcelRequire("acw62");

var $by19I = parcelRequire("by19I");
function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $by19I.useCallbackRef)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

});


parcelRegister("kNgwr", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $03c48a27777929a8$export$20e40289641fbbb6);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$var$FOCUS_SCOPE_NAME = "FocusScope";
var $03c48a27777929a8$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $by19I.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $by19I.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$03c48a27777929a8$export$20e40289641fbbb6.displayName = $03c48a27777929a8$var$FOCUS_SCOPE_NAME;
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $03c48a27777929a8$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$03c48a27777929a8$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;

});

parcelRegister("5nYva", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $95d053caea9c023a$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kFbxc = parcelRequire("kFbxc");

var $7g00o = parcelRequire("7g00o");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95d053caea9c023a$var$PORTAL_NAME = "Portal";
var $95d053caea9c023a$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $7g00o.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$95d053caea9c023a$export$602eac185826482c.displayName = $95d053caea9c023a$var$PORTAL_NAME;
var $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;

});

parcelRegister("fg1c6", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", () => $264faec0fdf8876a$export$b7ece24a22aeda8c);

var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$count = 0;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $264faec0fdf8876a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $264faec0fdf8876a$var$createFocusGuard());
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $264faec0fdf8876a$var$count--;
        };
    }, []);
}
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}

});

parcelRegister("hPyeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $hphuJ = parcelRequire("hphuJ");

var $1fmze = parcelRequire("1fmze");
var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $hphuJ.RemoveScroll), (0, $7WQrb.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $1fmze.default)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $hphuJ.RemoveScroll).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("hphuJ", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $cac2578984d345ac$export$22940b497e769dee);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $5shKQ = parcelRequire("5shKQ");

var $2DGpc = parcelRequire("2DGpc");

var $lbTxE = parcelRequire("lbTxE");
var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $7WQrb.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2DGpc.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $lbTxE.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $7WQrb.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $5shKQ.fullWidthClassName),
    zeroRight: (0, $5shKQ.zeroRightClassName)
};

});
parcelRegister("5shKQ", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $3f8d56f1a38c65c8$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $3f8d56f1a38c65c8$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $3f8d56f1a38c65c8$export$63d0edf80fea83b1);
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';

});

parcelRegister("2DGpc", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $1ec01e2201501f3d$export$74665b213cb5c4cf);

var $acw62 = parcelRequire("acw62");

var $dtd3m = parcelRequire("dtd3m");

var $uclLN = parcelRequire("uclLN");
var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $uclLN.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $dtd3m.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dtd3m", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9ce81be4473c2c96$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("uclLN", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $05ac61ef45da8ec5$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("lbTxE", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $f6d5b57f3512e73c$export$e27363444bedfeac);

var $iXQwi = parcelRequire("iXQwi");
var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $iXQwi.createSidecarMedium)();

});
parcelRegister("iXQwi", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $dce67a1050af61cf$export$e13ec7dd7a14088d);

var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("1fmze", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e88b28988758ab2$export$2e2bcd8739ae039);

var $hcGtC = parcelRequire("hcGtC");

var $l793C = parcelRequire("l793C");

var $lbTxE = parcelRequire("lbTxE");
var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $hcGtC.exportSidecar)((0, $lbTxE.effectCar), (0, $l793C.RemoveScrollSideCar));

});
parcelRegister("hcGtC", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $7WQrb.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $7WQrb.__assign)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}

});

parcelRegister("l793C", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $f5f147098910888d$export$a09dbff87b5da2d);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
parcelRequire("bFkre");
var $dFfX5 = parcelRequire("dFfX5");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $9x4sU = parcelRequire("9x4sU");

var $epYFP = parcelRequire("epYFP");
var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $kc8mv.styleSingleton))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7WQrb.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $epYFP.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $dFfX5.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("bFkre", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("dFfX5")).RemoveScrollBar);

var $dFfX5 = parcelRequire("dFfX5");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");

});
parcelRegister("dFfX5", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $9f2b7a700f678519$export$9aa43b459c5ae9b9);

var $acw62 = parcelRequire("acw62");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");
var $9f2b7a700f678519$var$Style = (0, $kc8mv.styleSingleton)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $5shKQ.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $5shKQ.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $2ddNe.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

});
parcelRegister("i39OQ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("kc8mv")).styleSingleton);

var $kc8mv = parcelRequire("kc8mv");

var $gjYQD = parcelRequire("gjYQD");

var $fCBo2 = parcelRequire("fCBo2");

});
parcelRegister("kc8mv", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $eb3b6a23a33fb1ba$export$c1248ee86ba532c8);

var $fCBo2 = parcelRequire("fCBo2");
var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $fCBo2.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("fCBo2", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $b5f767dd03f483e5$export$7d7b35c2d250e94c);

var $acw62 = parcelRequire("acw62");

var $gjYQD = parcelRequire("gjYQD");
var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $gjYQD.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("gjYQD", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $be1d9ed5bb532264$export$7c74eec858d5d226);

var $1EetQ = parcelRequire("1EetQ");
function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1EetQ.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("1EetQ", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $1334c25f36aeceaf$export$2b85b721e524d74b);
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("2ddNe", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $19c77eb414ad2a19$export$75f2ca8f029c77f4);
var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("9x4sU", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $6f0aa8d921410141$export$10a6e88623fa9454);
var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("epYFP", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $a7f277057d6643d0$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $a7f277057d6643d0$export$dde0441bd4a6ded8);
var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("6okVC", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $4a7537e072260c10$export$6e33d16126ed003c);
var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});

parcelRegister("1iuNh", function(module, exports) {

$parcel$export(module.exports, "createSlot", () => $3b9695b73ca006f6$export$e88b45bda5c13eb9);
// src/slot.tsx

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $ayMG0 = parcelRequire("ayMG0");
// @__NO_SIDE_EFFECTS__
function $3b9695b73ca006f6$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $3b9695b73ca006f6$var$createSlotClone(ownerName);
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $acw62.Children.toArray(children);
        const slottable = childrenArray.find($3b9695b73ca006f6$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                    return $acw62.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $ayMG0.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $3b9695b73ca006f6$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $3b9695b73ca006f6$export$e88b45bda5c13eb9("Slot");
// @__NO_SIDE_EFFECTS__
function $3b9695b73ca006f6$var$createSlotClone(ownerName) {
    const SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($acw62.isValidElement(children)) {
            const childrenRef = $3b9695b73ca006f6$var$getElementRef(children);
            const props2 = $3b9695b73ca006f6$var$mergeProps(slotProps, children.props);
            if (children.type !== $acw62.Fragment) props2.ref = forwardedRef ? (0, $htT6J.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return $acw62.cloneElement(children, props2);
        }
        return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $3b9695b73ca006f6$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $3b9695b73ca006f6$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $3b9695b73ca006f6$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $3b9695b73ca006f6$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $3b9695b73ca006f6$export$bf68c29d8281d0f7("Slottable");
function $3b9695b73ca006f6$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $3b9695b73ca006f6$var$SLOTTABLE_IDENTIFIER;
}
function $3b9695b73ca006f6$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $3b9695b73ca006f6$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

});



parcelRegister("beZBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $49383ac93d397699$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DrawerHeader", () => $49383ac93d397699$export$bb68d554ded258ea);
$parcel$export(module.exports, "DrawerBody", () => $49383ac93d397699$export$4ed8420cdfcb2b8f);
$parcel$export(module.exports, "DrawerFooter", () => $49383ac93d397699$export$d05a7d25ec5abf06);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $49383ac93d397699$export$2e2bcd8739ae039({ open: open, onClose: onClose, width: width = 400, children: children }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: onClose,
        style: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            // Docks at the inline-END — the side away from the shell's sidebar, so
            // a drawer never covers the navigation it was opened from (§5.2). This
            // was `left: 0`, the inline-end under `rtl` and the inline-START under
            // `ltr`, i.e. straight over an English layout's sidebar.
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            width: width,
            height: '100%',
            background: '#fff',
            // No x-offset: a signed offset points at a physical side, and this
            // panel sits on whichever side the reading direction puts the end on.
            boxShadow: '0 0 24px rgba(0,0,0,0.12)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, children));
}
function $49383ac93d397699$export$bb68d554ded258ea({ title: title, sub: sub, onClose: onClose, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 20px',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 16,
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $jTCZr.C).textMuted,
            marginTop: 2
        }
    }, sub), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 22,
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1,
            padding: '2px 6px'
        }
    }, "\xd7"));
}
function $49383ac93d397699$export$4ed8420cdfcb2b8f({ children: children, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            padding: 20,
            ...style
        }
    }, children);
}
function $49383ac93d397699$export$d05a7d25ec5abf06({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '16px 20px',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            gap: 8,
            flexShrink: 0
        }
    }, children);
}

});

parcelRegister("cZOyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfba7d02b5e7069f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $drSko = parcelRequire("drSko");

var $9BgRG = parcelRequire("9BgRG");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// BottomSheet — mobile-first modal that slides up from the bottom edge.
// Replaces the duplicated ClinicModal implementations in the patient app and
// ad-hoc bottom sheets elsewhere. For desktop-centred dialogs use Dialog.
//
// It is the default overlay for a mobile task or filter set
// (DESIGN-CONCEPT-MOBILE §6); `ConfirmDialog` stays a centered dialog and sits
// ABOVE this one on the z-scale (DESIGN.md, Overlay layering).
//
// ── What makes it phone-grade (v0.10.0) ─────────────────────────────────────
// Every one of these was a defect a phone could reproduce and a desktop could
// not, and each was found in all three apps at once because they all render
// this component:
//
//   dvh, not vh        `85vh` is measured against the LARGEST viewport, so on
//                      iOS Safari with the address bar expanded the sheet was
//                      taller than the screen and its own footer sat under the
//                      toolbar. `100dvh` tracks the live viewport; the `vh`
//                      declaration stays as the fallback for browsers without
//                      it, behind an `@supports` upgrade.
//   the keyboard       `position: fixed` is blind to the software keyboard, so
//                      a focused field's submit button sat *under* the keys.
//                      The sheet sits INSIDE the visible box: the scrim pads by
//                      what the keyboard covers (bottom) and by what the browser
//                      panned past (top), and the ceiling comes down by the
//                      same amount so the sheet's top edge does not move.
//                      (v0.23.3, PM-0108) It used to only shrink its ceiling
//                      while keeping its bottom edge on the LAYOUT viewport —
//                      so on Android Chrome, which paints the keyboard over the
//                      layout viewport (`resizes-visual`), the lower part of
//                      every sheet, footer included, sat under the keys, and
//                      Chrome's attempt to reveal the field panned the visual
//                      viewport so the title bar and the field left through the
//                      top of the screen. The booking sheet on a phone was the
//                      report. Repro: the doctor client's
//                      `e2e/booking.keyboard.mobile.spec.js`.
//   back closes it     the platform back button used to navigate the route
//                      underneath an open sheet, leaving the sheet floating
//                      over a different screen. `useOverlayHistory` puts the
//                      sheet in the history stack (opt out with
//                      `historyIntegration={false}` for a desktop dialog).
//   focus stays in     a modal that leaks focus to the page behind it is not a
//                      modal. Focus moves in on open, Tab cycles inside, and
//                      the previously-focused element gets it back on close.
//   the page is still  without a scroll lock, scrolling past the sheet's end
//                      scrolls the screen behind it — on iOS the page then
//                      rubber-bands and the sheet appears to drift.
//   44px close         the ✕ was 30px, under the 2.75rem minimum (§6).
//   tokens             surfaces, scrim, radius and text now come from the token
//                      layer instead of five literal hexes.
//   rendered at body   (v0.11.4) `position: fixed` and a z-index only mean
//                      what they say inside the ROOT stacking context. A sheet
//                      mounted deep in a screen — inside the scroller of a tab,
//                      say — sat in whatever context its ancestors made: iOS
//                      WebKit composites an overflow scroller and traps fixed
//                      descendants in it, so the sheet was clipped to the
//                      scroller and the screen's own docked bar, later in the
//                      DOM, painted OVER it. Chromium does not do this, which
//                      is why a browser test could not see it. The sheet now
//                      portals to `document.body`, exactly as the kit `Dialog`
//                      does through Radix: where a sheet happens to be mounted
//                      is no longer something a screen has to get right.
//
// Props:
//   open / onClose
//   title      — optional heading
//   footer     — optional docked commit row. §6 says "submit docks bottom", and
//                the sheet's body is a scroll region, so a footer placed in
//                `children` scrolls away exactly when it is needed. This slot
//                sticks to the bottom edge, above the safe-area inset AND above
//                the software keyboard.
//   fullHeight — a tall form (a stepper, a long picker) takes the whole
//                available height instead of hugging its content, so the footer
//                sits at the bottom edge rather than halfway up the screen.
//   snap       — cap the sheet at a fraction of the viewport (0.2–1, default
//                0.85). `snap={1}` with `fullHeight` is a full-screen task.
//   dir        — writing direction. UNSET by default, so the sheet INHERITS the
//                document's. It used to hardcode `dir="rtl"`, which renders
//                backwards in an app that also ships `en`; the three RTL apps
//                set `dir="rtl"` on <html>, so inheriting is identical for them.
//   closeLabel — accessible name of the close button (default «بستن»)
//   maxWidth   — the sheet's cap on a wide viewport
//   historyIntegration — false to opt out of the back-button behaviour
//   portal     — false to render in place instead of at `document.body`. Only
//                for a consumer that deliberately scopes CSS custom properties
//                to a subtree and needs the sheet inside it; the default is the
//                one that is correct on a phone.
//   className / data-testid and any other prop are forwarded to the overlay.
//
// `dir` inherits from `<html>` after the portal, which is what it inherited
// before in every app that sets the direction where the I18N rule says to.
// ─────────────────────────────────────────────────────────────────────────────
// Everything focusable a sheet can realistically contain. `[hidden]` and
// `disabled` are excluded because Tab skips them anyway, and a trap that
// disagrees with the browser about the cycle is worse than no trap.
const $cfba7d02b5e7069f$var$FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cfba7d02b5e7069f$var$PANEL_CLASS = 'parsina-sheet-panel';
// One stylesheet for every sheet on the page, not one per instance: the rules
// are identical and the per-sheet numbers arrive as custom properties.
const $cfba7d02b5e7069f$var$SHEET_CSS = `
  @keyframes parsina-sheet-fade{from{opacity:0}to{opacity:1}}
  @keyframes parsina-sheet-up{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-vh)}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-vh)}
  /* The upgrade. Guarded because a custom property holding an unsupported unit
     is invalid at computed-value time, which would drop max-height entirely. */
  @supports (height: 100dvh){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-dvh)}
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-dvh)}
  }
  @media (prefers-reduced-motion: reduce){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}, .parsina-sheet-scrim{animation:none!important}
  }
`;
function $cfba7d02b5e7069f$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: fullHeight = false, snap: snap = 0.85, dir: dir, closeLabel: closeLabel, maxWidth: maxWidth = 480, historyIntegration: historyIntegration = true, portal: portal = true, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $j9AxR.kitCopy)().close;
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const restoreFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The box the user can see, as insets of the layout viewport (PM-0108).
    const { top: panInset, bottom: keyboardInset } = (0, $drSko.default)();
    // Back / hardware-back closes the sheet and leaves the route alone.
    (0, $9BgRG.default)(open, onClose, {
        enabled: historyIntegration,
        id: testId || 'sheet'
    });
    // Escape + the focus trap. One listener for both: they are the same contract
    // — while this is open, the keyboard belongs to it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const items = [
                ...panel.querySelectorAll($cfba7d02b5e7069f$var$FOCUSABLE)
            ].filter((el)=>el.offsetParent !== null);
            if (items.length === 0) {
                e.preventDefault();
                panel.focus();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            const active = document.activeElement;
            // Wrapping by hand is what keeps focus inside: the browser's own next
            // stop after `last` is the page behind the scrim.
            if (e.shiftKey && (active === first || !panel.contains(active))) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Move focus in on open and hand it back on close. Without the hand-back, a
    // sheet opened from a list left focus on <body>, so the next Tab started from
    // the top of the page instead of from the control that opened it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        restoreFocusRef.current = document.activeElement;
        // After paint, so the panel and its children exist to receive it.
        const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(()=>{
            const panel = panelRef.current;
            if (!panel) return;
            const firstField = panel.querySelector($cfba7d02b5e7069f$var$FOCUSABLE);
            (firstField || panel).focus?.({
                preventScroll: true
            });
        }) : null;
        return ()=>{
            if (raf !== null) cancelAnimationFrame(raf);
            const previous = restoreFocusRef.current;
            restoreFocusRef.current = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) previous.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    // When the visible box changes under an open sheet — the keyboard arriving,
    // the browser panning — the sheet re-lays out, and the field being typed into
    // may now sit below the body's shrunken edge. Bring it back the way a finger
    // would. `nearest` scrolls only the sheet's own scroller: the panel is inside
    // the visible box by construction, so nothing outside it has to move.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || panInset === 0 && keyboardInset === 0) return undefined;
        if (typeof requestAnimationFrame !== 'function') return undefined;
        const raf = requestAnimationFrame(()=>{
            const panel = panelRef.current;
            const active = typeof document === 'undefined' ? null : document.activeElement;
            if (!panel || !active || active === panel || !panel.contains(active)) return;
            if (typeof active.scrollIntoView !== 'function') return;
            active.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        open,
        panInset,
        keyboardInset
    ]);
    // Body scroll lock. Restores the exact previous inline values rather than
    // clearing them, so two stacked sheets do not leave the page unlocked when
    // the inner one closes.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const body = document.body;
        const previous = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscroll: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        // iOS ignores `overflow: hidden` on <body> for touch scrolling; these two
        // are what actually stop the page behind the scrim from moving.
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = previous.overflow;
            body.style.touchAction = previous.touchAction;
            body.style.overscrollBehavior = previous.overscroll;
        };
    }, [
        open
    ]);
    if (!open) return null;
    // `calc()` multiplies a NUMBER by a length, so the snap stays a fraction.
    const cap = Math.min(Math.max(Number(snap) || 0.85, 0.2), 1);
    const tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: dir,
        className: className ? `parsina-sheet-scrim ${className}` : 'parsina-sheet-scrim',
        "data-testid": testId,
        onClick: onClose,
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: (0, $jTCZr.SCRIM),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            // The scrim keeps covering the whole layout viewport (a keyboard frame
            // in flight must never show the page behind); the PANEL is confined to
            // the box the user can see — above the keys, below what was panned past.
            paddingTop: panInset ? `${panInset}px` : undefined,
            paddingBottom: keyboardInset ? `${keyboardInset}px` : undefined,
            animation: 'parsina-sheet-fade 0.2s ease-out'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $cfba7d02b5e7069f$var$SHEET_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        className: $cfba7d02b5e7069f$var$PANEL_CLASS,
        "data-full-height": fullHeight ? '' : undefined,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title || closeLabel,
        tabIndex: -1,
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: '100%',
            maxWidth: maxWidth,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).card,
            borderRadius: `${(0, $jTCZr.RADIUS).hero}px ${(0, $jTCZr.RADIUS).hero}px 0 0`,
            boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
            // The visible box lost `keyboardInset + panInset` pixels, so the
            // ceiling comes down by exactly that: the sheet's TOP edge stays
            // where it was and the content gives up the keyboard's height, rather
            // than the whole sheet jumping. Both units are published; the
            // stylesheet picks.
            '--parsina-sheet-vh': `calc(${cap} * 100vh - ${keyboardInset + panInset}px)`,
            '--parsina-sheet-dvh': `calc(${cap} * 100dvh - ${keyboardInset + panInset}px)`,
            animation: 'parsina-sheet-up 0.25s cubic-bezier(0.4,0,0.2,1)',
            // No `fontFamily` here: the typeface is set once at the app root and
            // inherited (§2.1 — a component-level font declaration is a defect).
            outline: 'none',
            padding: '1rem 1.25rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            marginBottom: title ? '0.75rem' : 0,
            flexShrink: 0
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            margin: 0,
            minWidth: 0
        }
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": closeLabel,
        "data-testid": testId ? `${testId}-close` : undefined,
        style: {
            border: 'none',
            background: (0, $jTCZr.C).bg,
            cursor: 'pointer',
            // §6: 2.75rem is the floor for anything a thumb has to hit. The
            // glyph stays small; the TARGET is what grew.
            width: '2.75rem',
            height: '2.75rem',
            borderRadius: (0, $jTCZr.RADIUS).pill,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 6 6 18M6 6l12 12"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: fullHeight ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            // The sheet is the one scroller while it is open; a flick that
            // reaches its end must not hand the gesture to the page behind it.
            overscrollBehavior: 'contain',
            paddingBottom: footer ? 0 : 'calc(1.25rem + env(safe-area-inset-bottom, 0px))'
        }
    }, children), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            marginTop: '0.75rem',
            marginInline: '-1.25rem',
            padding: '0.625rem 1.25rem',
            paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, footer)));
    // `document` is absent during a Next.js server render; a sheet that is open
    // on the server (rare, but a valid initial state) renders in place there and
    // moves to <body> on the client.
    if (portal && typeof document !== 'undefined') return /*#__PURE__*/ (0, $1u0KT.createPortal)(tree, document.body);
    return tree;
}

});
parcelRegister("drSko", function(module, exports) {

$parcel$export(module.exports, "useVisualViewportInsets", () => $0286d675359db131$export$9ff6616b10aa518d);
$parcel$export(module.exports, "default", () => $0286d675359db131$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $0286d675359db131$export$9ff6616b10aa518d() {
    const [insets, setInsets] = (0, $acw62.useState)({
        top: 0,
        bottom: 0
    });
    (0, $acw62.useEffect)(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            const top = Math.max(0, Math.round(vv.offsetTop));
            // Everything below the visual viewport's bottom edge is covered.
            const bottom = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
            setInsets((prev)=>prev.top === top && prev.bottom === bottom ? prev : {
                    top: top,
                    bottom: bottom
                });
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return insets;
}
var $0286d675359db131$export$2e2bcd8739ae039 = $0286d675359db131$export$9ff6616b10aa518d;

});

parcelRegister("9BgRG", function(module, exports) {

$parcel$export(module.exports, "overlayHistoryDepth", () => $6fd4a6c8c2176e20$export$9452f2c4c9460e1e);
$parcel$export(module.exports, "overlayOwnsPop", () => $6fd4a6c8c2176e20$export$2846246580854e2f);
$parcel$export(module.exports, "default", () => $6fd4a6c8c2176e20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// useOverlayHistory — put an overlay INTO the history stack.
//
// ── The problem ─────────────────────────────────────────────────────────────
// A bottom sheet, a full-screen picker and a closure overlay are all things a
// person opened and expects to be able to *back out of*. On a phone that means
// the hardware back button on Android and the browser's back gesture on iOS —
// neither of which the page can veto. Because no overlay pushed anything onto
// the history stack, pressing back with a sheet open navigated the ROUTE
// UNDERNEATH it: the sheet stayed on screen over a different screen, or the
// person left a half-finished form without ever being asked.
//
// Per-screen fixes for this do not work. Every app that tried one ended up with
// a `popstate` listener per screen, each guessing how many entries to unwind,
// and one of them (the doctor app's visit guard) hardcoded `history.go(-2)` —
// correct only while exactly one anchor exists, and wrong the moment a sheet is
// open on top of it.
//
// ── The rule this implements ────────────────────────────────────────────────
// Opening an overlay pushes ONE history entry tagged with a private token;
// closing it pops that entry. A `popstate` that removes the token is the
// platform saying "close this overlay", so `onClose` runs and nothing else
// happens — the route never changes. Overlays stack: the innermost one owns the
// newest entry, so back closes them one at a time, in order.
//
// The pushed entry deliberately CARRIES THE ROUTER'S OWN STATE FORWARD
// (`...history.state`), which keeps `idx`/`key` identical. React Router reads
// `state.idx` on `popstate` to compute a delta; leaving it untouched makes the
// delta zero, so the router sees the pop and correctly does nothing. Bumping it
// would make the router re-navigate to the same URL with a new key and reset
// screen state that the overlay was sitting on top of.
//
// ── Depth, for guarded routes ───────────────────────────────────────────────
// A route with a leave-guard (an open visit) has to unwind its own anchor PLUS
// whatever overlays are above it. `overlayHistoryDepth()` is that count, so the
// guard says `history.go(-(1 + overlayHistoryDepth()))` rather than a literal.
//
// ── Whose pop is this? (v0.11.5) ────────────────────────────────────────────
// A leave-guard is itself a `popstate` listener, and `popstate` does not say
// what was left — only what was landed on. So a guard that treats every pop
// as "the person is leaving" fires on the pops THIS hook makes: close a sheet
// with the ✕, the scrim or a submit, the cleanup below calls `back()` to drop
// the sheet's entry, and the guard asks «خروج از ویزیت؟» over a screen the
// person never tried to leave. Found on a phone in the doctor app, where every
// sheet on the visit did it.
//
// `overlayOwnsPop()` is the one question a guard needs to ask first. It is
// true in exactly the two cases where a pop is an overlay's business:
//   · an overlay still HOLDS an entry — the platform back is closing it, and
//     the overlay's own listener (registered later, so it runs after the
//     guard's) will handle it;
//   · this hook has just popped its own entry from inside the app. That is
//     announced BEFORE `back()` and consumed by the first reader within a
//     short window, so a `back()` that never produced a pop cannot swallow a
//     real one later.
//
// SSR/jsdom-safe: with no `window.history` it is inert, so a caller can add it
// unconditionally.
// ─────────────────────────────────────────────────────────────────────────────
const $6fd4a6c8c2176e20$var$MARK = 'parsinaOverlay';
let $6fd4a6c8c2176e20$var$sequence = 0;
/** Tokens of the overlays that currently own a history entry, innermost last. */ const $6fd4a6c8c2176e20$var$openTokens = [];
/** When this hook last popped its own entry (ms epoch); 0 when it has not. */ let $6fd4a6c8c2176e20$var$selfPopAt = 0;
// A history traversal completes within a frame or two; the window is only
// there so a `back()` that never produced a pop cannot claim a later one.
const $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS = 1000;
function $6fd4a6c8c2176e20$export$9452f2c4c9460e1e() {
    return $6fd4a6c8c2176e20$var$openTokens.length;
}
function $6fd4a6c8c2176e20$export$2846246580854e2f() {
    if ($6fd4a6c8c2176e20$var$openTokens.length > 0) return true;
    if ($6fd4a6c8c2176e20$var$selfPopAt && Date.now() - $6fd4a6c8c2176e20$var$selfPopAt < $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS) {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
        return true;
    }
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
    return false;
}
function $6fd4a6c8c2176e20$export$b512be9f39899018() {
    $6fd4a6c8c2176e20$var$openTokens.length = 0;
    $6fd4a6c8c2176e20$var$sequence = 0;
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
}
function $6fd4a6c8c2176e20$export$2e2bcd8739ae039(open, onClose, { enabled: enabled = true, id: id } = {}) {
    // `onClose` is almost always an inline arrow, so depending on it would tear
    // the history entry down and rebuild it on every render of the host screen.
    const onCloseRef = (0, $acw62.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open) return undefined;
        if (typeof window === 'undefined' || !window.history?.pushState) return undefined;
        const seq = ++$6fd4a6c8c2176e20$var$sequence;
        const token = `${id || 'overlay'}#${seq}`;
        $6fd4a6c8c2176e20$var$openTokens.push(token);
        // True once the platform has already taken our entry off the stack, so the
        // cleanup below knows not to pop a second time.
        let popped = false;
        // Set by the cleanup; a reclaim scheduled before it must not fire after it.
        let disposed = false;
        let reclaimTimer = null;
        // The URL the entry was claimed on. A pop that lands on a different URL is
        // a navigation (a leave-guard's `go(-n)`), never a refused close.
        const claimedHref = window.location.href;
        const drop = ()=>{
            const at = $6fd4a6c8c2176e20$var$openTokens.indexOf(token);
            if (at !== -1) $6fd4a6c8c2176e20$var$openTokens.splice(at, 1);
        };
        const ours = ()=>window.history.state?.[$6fd4a6c8c2176e20$var$MARK] === token;
        try {
            window.history.pushState({
                ...window.history.state || {},
                [$6fd4a6c8c2176e20$var$MARK]: token
            }, '');
        } catch  {
            // iOS caps pushState calls per interval. An overlay that cannot claim an
            // entry still opens; it just does not intercept back, which is exactly
            // today's behaviour and strictly better than refusing to render.
            drop();
            return undefined;
        }
        // ── A refused close (v0.16.1) ─────────────────────────────────────────────
        // The platform back has ALREADY removed our entry by the time `onClose`
        // runs, and the page cannot veto that. A consumer may still refuse — a dirty
        // form that asks «خروج بدون ذخیره؟» and hears «بمانم», or TaskOverlay's
        // `busy` withholding `onClose` mid-write. Before this, the overlay stayed on
        // screen with no entry, so the NEXT back left the route under it.
        //
        // So one tick after `onClose`: if this effect is still alive (nothing set
        // `open` to false), claim the entry again. An honoured close has cleaned the
        // effect up by then and nothing here runs.
        const reclaim = ()=>{
            reclaimTimer = null;
            if (disposed || !popped || ours()) return;
            if (window.location.href !== claimedHref) return;
            const seqOf = (t)=>Number(t.slice(t.lastIndexOf('#') + 1));
            // Overlays opened DURING the refusal (a confirm sheet) already pushed
            // their entries above where ours belongs. With exactly one, rotate: the
            // top entry becomes ours and theirs is pushed back on top of it.
            const above = $6fd4a6c8c2176e20$var$openTokens.filter((t)=>seqOf(t) > seq);
            const state = window.history.state || {};
            try {
                if (above.length === 0) window.history.pushState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                else if (above.length === 1 && state[$6fd4a6c8c2176e20$var$MARK] === above[0]) {
                    window.history.replaceState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: token
                    }, '');
                    window.history.pushState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: above[0]
                    }, '');
                } else // Two or more inner entries cannot be reordered without a traversal
                // the person would see; leave it as it was rather than misorder them.
                return;
            } catch  {
                return; // the iOS pushState cap — same fallback as the first claim
            }
            const at = above.length ? $6fd4a6c8c2176e20$var$openTokens.indexOf(above[0]) : -1;
            if (at === -1) $6fd4a6c8c2176e20$var$openTokens.push(token);
            else $6fd4a6c8c2176e20$var$openTokens.splice(at, 0, token);
            popped = false;
        };
        const onPop = ()=>{
            // Still ours: something DEEPER popped, and its own hook is handling it.
            if (ours()) return;
            popped = true;
            drop();
            onCloseRef.current?.();
            if (!disposed && reclaimTimer === null) reclaimTimer = setTimeout(reclaim, 0);
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            disposed = true;
            if (reclaimTimer !== null) {
                clearTimeout(reclaimTimer);
                reclaimTimer = null;
            }
            window.removeEventListener('popstate', onPop);
            drop();
            // Closed from inside the app (the ✕, a submit, Escape). Our entry is
            // still on the stack, so remove it — otherwise back would have to be
            // pressed once for the ghost entry and once for the actual route.
            //
            // `ours()` is the guard that makes this safe on unmount-by-navigation: a
            // sheet whose button routed somewhere else no longer owns the top entry,
            // and calling back() there would undo the navigation it just performed.
            if (!popped && ours()) {
                // Announced before the traversal, because the guard's listener will
                // run inside the resulting `popstate` and has no other way to know.
                $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
                try {
                    window.history.back();
                } catch  {
                    $6fd4a6c8c2176e20$var$selfPopAt = 0;
                }
            }
        };
    }, [
        open,
        enabled,
        id
    ]);
}

});


parcelRegister("bfs4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d1958bc1315b40$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Menu — an anchored menu.
//
// PROMOTED from the clinic app's `src/components/common/ClinicMenu.jsx`, which
// had marked itself a promotion candidate: the kit had no menu primitive at any
// version — not a Menu, not a Popover, not a DropdownMenu — so per DESIGN.md
// rule 4 it lived in the app until a second app needed one. `AccountCard` is
// that second need, in all four panels at once.
//
// Not built from `Dialog`: a Dialog is a centred modal and this is an anchored
// menu, so the kit's overlay would be the wrong shape AND the wrong semantics
// (`role="dialog"` where a screen reader needs `role="menu"`).
//
// Portaled to `document.body` so a clipping ancestor cannot cut it off — the
// staff sidebars are fixed-width flex columns with `overflow: hidden`, and an
// anchored child of one is sliced at 260px (or at 68px when collapsed).
//
// LAYERING — z 900. Above every piece of app chrome (the doctor app's mobile
// bottom nav at z-50, its visit-closure flow at z-60) and below every kit
// overlay: BottomSheet 1000, Dialog/ConfirmDialog 1100. That order is the one
// DESIGN.md insists on — a ConfirmDialog raised from inside a menu row (sign
// out, a destructive switch) must render ABOVE the menu, and the fix for that
// ordering is never to lower the dialog. ClinicMenu sat at 11, the Drawer
// level, which was enough for the one trigger it had; 900 is what a menu opened
// from anywhere needs.
//
// Props:
//   open / onClose        — controlled
//   anchorRef             — ref to the trigger; the menu is measured against it
//   placement             — 'bottom' (default) | 'top' | 'auto'. 'auto' opens
//                           downward and flips up when the space below is too
//                           small. A menu at the FOOT of a sidebar wants 'top'.
//   width                 — px (default 300)
//   ariaLabel             — required in practice: the trigger's visible text is
//                           often a person's or a clinic's name, not the menu's
//   children              — the rows; give them role="menuitem"/"menuitemradio"
//   data-testid
// ─────────────────────────────────────────────────────────────────────────────
const $08d1958bc1315b40$var$Z = 900;
const $08d1958bc1315b40$var$GAP = 6; // breathing room between trigger and menu
const $08d1958bc1315b40$var$EDGE = 8; // never touch the viewport edge
const $08d1958bc1315b40$var$MIN_BELOW = 180; // 'auto' flips up below this much room
// Every focusable row, in DOM order. Radio rows come from ClinicSwitcher, plain
// menuitems from AccountCard; `[data-menu-focus]` lets a caller nominate
// something else entirely (ClinicSwitcher's search box).
const $08d1958bc1315b40$var$ROW_SELECTOR = '[data-menu-focus="true"], [role="menuitem"]:not([aria-disabled="true"]), [role="menuitemradio"]:not([aria-disabled="true"])';
function $08d1958bc1315b40$export$d9b273488cd8ce6f({ open: open, onClose: onClose, anchorRef: anchorRef, children: children, ariaLabel: ariaLabel, width: width = 300, placement: placement = 'bottom', 'data-testid': testId = 'menu' }) {
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Position against the trigger. Measured on open and on every resize/scroll,
    // rather than once: the sidebar collapses under a CSS transition, so a
    // position captured at open time is wrong 300ms later.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = anchorRef?.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            // Anchor to the INLINE-START edge in both directions, which is the visual
            // edge the trigger shares with its container in RTL and LTR alike.
            const left = isRtl ? Math.max($08d1958bc1315b40$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $08d1958bc1315b40$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $08d1958bc1315b40$var$EDGE * 2;
            const roomAbove = r.top - $08d1958bc1315b40$var$EDGE * 2;
            const up = placement === 'top' || placement === 'auto' && roomBelow < $08d1958bc1315b40$var$MIN_BELOW && roomAbove > roomBelow;
            const room = up ? roomAbove : roomBelow;
            const maxHeight = Math.min(Math.max(160, room), Math.round(window.innerHeight * 0.6));
            setPos(up ? {
                bottom: Math.max($08d1958bc1315b40$var$EDGE, window.innerHeight - r.top + $08d1958bc1315b40$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $08d1958bc1315b40$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorRef,
        width,
        placement
    ]);
    // Close on an outside press. `mousedown` rather than `click`, so a press that
    // starts outside and ends inside cannot re-open what it just closed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (menuRef.current?.contains(e.target)) return;
            if (anchorRef?.current?.contains(e.target)) return;
            onClose?.();
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, [
        open,
        onClose,
        anchorRef
    ]);
    // Escape closes, arrows walk the rows, Home/End jump. A menu you can open by
    // keyboard but only leave by mouse is a trap.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
            const rows = Array.from(menuRef.current?.querySelectorAll($08d1958bc1315b40$var$ROW_SELECTOR) || []);
            if (!rows.length) return;
            e.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (at + 1) % rows.length : at <= 0 ? rows.length - 1 : at - 1;
            rows[next]?.focus?.();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Focus lands inside on open and returns to the trigger on close — a menu that
    // opens without focus is unreachable by keyboard, and one that drops focus on
    // close strands the caret at the top of the document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            menuRef.current?.querySelector($08d1958bc1315b40$var$ROW_SELECTOR)?.focus?.();
        }, 0);
        const anchor = anchorRef?.current;
        return ()=>{
            window.clearTimeout(t);
            if (anchor && document.contains(anchor)) anchor.focus?.();
        };
    }, [
        open,
        anchorRef
    ]);
    if (!open || !pos) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        role: "menu",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: 'white',
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 18px 48px rgba(15, 34, 51, 0.18)',
            zIndex: $08d1958bc1315b40$var$Z,
            padding: 6,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, children), document.body);
}
var $08d1958bc1315b40$export$2e2bcd8739ae039 = $08d1958bc1315b40$export$d9b273488cd8ce6f;

});

parcelRegister("gCvEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $382b400f7624ec9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $cZOyb = parcelRequire("cZOyb");

var $4fYdd = parcelRequire("4fYdd");

var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// The panel surface both shells paint on. A sticky header has to repaint it, or
// the body shows through as it scrolls under.
const $382b400f7624ec9d$var$OVERLAY_SURFACE = (0, $jTCZr.C).card;
function $382b400f7624ec9d$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, description: description, header: header, footer: footer, children: children, busy: busy = false, size: size = 'md', isMobile: isMobile, historyIntegration: historyIntegration = true, snap: snap = 1, fullHeight: fullHeight = true, closeLabel: closeLabel, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $j9AxR.kitCopy)().close;
    const auto = (0, $k27hS.default)();
    // ── Why this cannot be server-rendered blind ──────────────────────────────
    // WHICH SHELL this is depends on the viewport, and a server does not have
    // one. Rendering the desktop guess and then swapping to a sheet on the client
    // is a hydration mismatch — React discards the tree and re-renders it, and in
    // an app that streams the overlay open from a deep link (`?book=1`) that is a
    // visible flash of the wrong shape.
    //
    // So: when the caller TELLS us the tier we trust it and render on the server
    // like anything else. When it does not, we wait for the client, where the
    // question has an answer. One frame later than ideal, and never wrong.
    const told = isMobile !== undefined;
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(told);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    const mobile = told ? isMobile : auto.isMobile;
    // One guard for every way out, so "can this close right now?" has a single
    // answer rather than one per dismissal path. On the sheet tier a platform back
    // has already popped the sheet's history entry when this refuses; the sheet's
    // `useOverlayHistory` re-claims it one tick later (v0.16.1), so a busy overlay
    // keeps exactly one entry and the next back is delivered to it again.
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (busy) return;
        if (typeof onClose === 'function') onClose();
    }, [
        busy,
        onClose
    ]);
    if (!open || !mounted) return null;
    if (mobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        closeLabel: closeLabel,
        historyIntegration: historyIntegration,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        ...rest
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: $382b400f7624ec9d$var$OVERLAY_SURFACE,
            padding: '0 1.25rem 0.75rem'
        }
    }, header) : null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: size,
        layout: "frame",
        showClose: !busy,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        // Radix would otherwise close on Esc or an outside click mid-write.
        onEscapeKeyDown: (e)=>{
            if (busy) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if (busy) e.preventDefault();
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        dir: "auto"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogDescription), {
        dir: "auto"
    }, description) : null, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            marginTop: '0.75rem'
        }
    }, header) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, children), footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), null, footer) : null));
}

});
parcelRegister("k27hS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e959a5a9c1f6e19d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * useResponsive — is this viewport the MOBILE surface?
 *
 * ≤ 768px is mobile across the whole product (DESIGN-CONCEPT-MOBILE preamble:
 * "everything rendered when `useResponsive()` reports ≤ 768px"). The boundary
 * is inclusive: 768 is mobile, 769 is desktop.
 *
 * It lives in the kit because it is the switch every `X.mobile.jsx` fork is
 * chosen by, and a byte-identical copy already existed in the doctor and the
 * clinic client — the second app needing it is DESIGN.md rule 4's trigger to
 * move it here. It sits beside `useKeyboardInset` and `useMeasuredWidth`: all
 * three are facts about the device's geometry that a whole class of screens
 * depends on.
 *
 * Hardened over the app-local copies in two ways:
 *   • `matchMedia` rather than a `resize` listener, so a rotation or a
 *     window drag fires once at the boundary instead of on every frame;
 *   • an SSR / no-window guard, so importing it in a Next.js server component
 *     or a node-environment test does not throw. It reports DESKTOP there —
 *     the surface with the full content, which is the safe default for a
 *     first paint that has not measured anything yet.
 *
 * @param breakpoint the inclusive mobile ceiling in px (default 768)
 * @returns { isMobile }
 */ const $e959a5a9c1f6e19d$var$query = (breakpoint)=>`(max-width: ${breakpoint}px)`;
const $e959a5a9c1f6e19d$var$read = (breakpoint)=>{
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') return window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint)).matches;
    return window.innerWidth <= breakpoint;
};
function $e959a5a9c1f6e19d$export$2e2bcd8739ae039(breakpoint = 768) {
    const [isMobile, setIsMobile] = (0, $acw62.useState)(()=>$e959a5a9c1f6e19d$var$read(breakpoint));
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        // The state initialiser ran before mount; re-read now in case the viewport
        // is not what it was (hydration, a rotation during boot).
        setIsMobile($e959a5a9c1f6e19d$var$read(breakpoint));
        if (typeof window.matchMedia !== 'function') {
            const onResize = ()=>setIsMobile(window.innerWidth <= breakpoint);
            window.addEventListener('resize', onResize);
            return ()=>window.removeEventListener('resize', onResize);
        }
        const mq = window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint));
        const onChange = (e)=>setIsMobile(e.matches);
        // `addListener` is the pre-2019 Safari spelling; still worth keeping while
        // the product supports older iOS webviews.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [
        breakpoint
    ]);
    return {
        isMobile: isMobile
    };
}

});


parcelRegister("6usBW", function(module, exports) {

$parcel$export(module.exports, "ToastProvider", () => $352ffee698fbd002$export$f5d03d415824e0e);
$parcel$export(module.exports, "useToast", () => $352ffee698fbd002$export$a407b657d3044108);

var $acw62 = parcelRequire("acw62");

var $k27hS = parcelRequire("k27hS");

var $iK5Lj = parcelRequire("iK5Lj");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Toast — the one notification system for every Parsina client.
//
// Replaces: native alert() calls (doctor app), the 5+ per-screen setToast/
// setTimeout implementations (clinic app), and inline-only feedback (patient app).
//
// Usage:
//   <ToastProvider>  ← once, at the app root
//   const toast = useToast();
//   toast.success('ذخیره شد');
//   toast.error('خطا در ارتباط با سرور');
//   toast.info('...'); toast.warn('...');
//
// The contract is DESIGN_SYSTEM §9.3 / DESIGN_CONCEPT §7 (PM-0022):
//   • one sentence, auto-dismissed after 4 s — an error after 6 s;
//   • at most 3 stacked on desktop, 2 on a phone (the oldest leaves);
//   • desktop: the bottom, inline-END corner (the one farthest from the sidebar);
//     phone: bottom-centre, ABOVE whatever is docked there — the bottom nav
//     (`--app-bottom-nav`), a screen's CTA footer (`--app-bottom-dock`, see
//     `usePublishedHeight`) and the software keyboard;
//   • polite to a screen reader, except an error, which interrupts.
// ─────────────────────────────────────────────────────────────────────────────
const $352ffee698fbd002$var$PALETTE = {
    success: {
        bg: '#1A9B6C',
        text: '#ffffff'
    },
    error: {
        bg: '#D93025',
        text: '#ffffff'
    },
    warn: {
        bg: '#F59E0B',
        text: '#1a2332'
    },
    info: {
        bg: '#0173BE',
        text: '#ffffff'
    }
};
const $352ffee698fbd002$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $352ffee698fbd002$export$beb43bca45d33d34 = 4000;
const $352ffee698fbd002$export$7a658dea7a198286 = 6000;
const $352ffee698fbd002$export$3b92a0a0bf23cbdd = {
    desktop: 3,
    mobile: 2
};
let $352ffee698fbd002$var$nextId = 1;
function $352ffee698fbd002$export$f5d03d415824e0e({ children: children, duration: duration = $352ffee698fbd002$export$beb43bca45d33d34, errorDuration: errorDuration = $352ffee698fbd002$export$7a658dea7a198286 }) {
    const [toasts, setToasts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const keyboardInset = (0, $iK5Lj.default)();
    const max = isMobile ? $352ffee698fbd002$export$3b92a0a0bf23cbdd.mobile : $352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop;
    const dismiss = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
        const timer = timers.current.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);
    const push = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message, type = 'info', opts = {})=>{
        const id = $352ffee698fbd002$var$nextId++;
        // The state keeps the desktop cap; the phone's smaller one is applied at
        // render, so a rotation never needs the list rewritten.
        setToasts((t)=>[
                ...t,
                {
                    id: id,
                    message: message,
                    type: type
                }
            ].slice(-$352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop));
        const life = opts.duration ?? (type === 'error' ? errorDuration : duration);
        timers.current.set(id, setTimeout(()=>dismiss(id), life));
        return id;
    }, [
        dismiss,
        duration,
        errorDuration
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
        }, []);
    const api = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            show: push,
            success: (m, o)=>push(m, 'success', o),
            error: (m, o)=>push(m, 'error', o),
            warn: (m, o)=>push(m, 'warn', o),
            info: (m, o)=>push(m, 'info', o),
            dismiss: dismiss
        }), [
        push,
        dismiss
    ]);
    const visible = toasts.slice(-max);
    // Phone: clear the nav + a docked footer, or the keyboard when that is taller
    // (a footer that pads for the keyboard already contains it — hence `max`, not
    // a sum). Desktop has neither; the corner offset is all there is.
    const bottom = isMobile ? `calc(max(var(--app-bottom-nav, 0px) + var(--app-bottom-dock, 0px), env(safe-area-inset-bottom, 0px), ${keyboardInset}px) + 0.75rem)` : '1.5rem';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($352ffee698fbd002$var$ToastContext.Provider, {
        value: api
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "toast-stack",
        "data-placement": isMobile ? 'bottom-center' : 'bottom-end',
        style: {
            position: 'fixed',
            bottom: bottom,
            insetInline: 0,
            paddingInline: isMobile ? '1rem' : '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '0.5rem',
            zIndex: 9999,
            pointerEvents: 'none'
        }
    }, visible.map((t)=>{
        const p = $352ffee698fbd002$var$PALETTE[t.type] || $352ffee698fbd002$var$PALETTE.info;
        const isError = t.type === 'error';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            onClick: ()=>dismiss(t.id),
            role: isError ? 'alert' : 'status',
            "aria-live": isError ? 'assertive' : 'polite',
            "data-testid": "toast",
            "data-type": t.type,
            style: {
                pointerEvents: 'auto',
                cursor: 'pointer',
                background: p.bg,
                color: p.text,
                padding: '0.625rem 1.125rem',
                borderRadius: 'var(--radius, 10px)',
                fontSize: '0.8125rem',
                fontWeight: 600,
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 'min(92vw, 26.25rem)',
                animation: 'parsina-toast-in 0.22s ease-out'
            }
        }, t.message);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-toast-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion: reduce){[data-testid="toast"]{animation:none !important}}`)));
}
function $352ffee698fbd002$export$a407b657d3044108() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($352ffee698fbd002$var$ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}

});
parcelRegister("iK5Lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $da50fe1f8f323572$export$2e2bcd8739ae039);

var $drSko = parcelRequire("drSko");
'use client';
function $da50fe1f8f323572$export$a477a7ade7efed9c() {
    // One listener implementation for both facts: the bottom inset IS the
    // keyboard, `top` is the pan a sheet needs (PM-0108) and a composer does not.
    return (0, $drSko.useVisualViewportInsets)().bottom;
}
var $da50fe1f8f323572$export$2e2bcd8739ae039 = $da50fe1f8f323572$export$a477a7ade7efed9c;

});


parcelRegister("hZDga", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $31e8de2f297417a1$export$7f7cbe89f1eacd2);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $31e8de2f297417a1$export$7f7cbe89f1eacd2({ size: size = 32, color: color = (0, $jTCZr.C).teal, thickness: thickness = 2, style: style, label: label }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        // The accessible name is a PROP (rule 7). It used to be a Persian string
        // literal with no way past it, so an English screen announced its loading
        // state in Persian and the app could do nothing about it.
        "aria-label": label,
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            border: `${thickness}px solid ${color}`,
            borderTopColor: 'transparent',
            animation: 'parsina-spin 0.8s linear infinite',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-spin{to{transform:rotate(360deg)}}`));
}
function $31e8de2f297417a1$export$e2b0760399e6dece({ label: label, minHeight: minHeight = '60vh' }) {
    return(// No `dir` of its own — it inherits the document's, like every other
    // component in the kit. It is a centred column either way.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minHeight: minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31e8de2f297417a1$export$7f7cbe89f1eacd2, {
        label: label
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: '#9aa3b0',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, label) : null));
}
var $31e8de2f297417a1$export$2e2bcd8739ae039 = $31e8de2f297417a1$export$7f7cbe89f1eacd2;

});

parcelRegister("fvho4", function(module, exports) {

$parcel$export(module.exports, "SessionCheck", () => $3c4ca280922aa4ea$export$cd72095868f03c30);
$parcel$export(module.exports, "SessionError", () => $3c4ca280922aa4ea$export$d422f67d76bf24e4);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SessionCheck / SessionError / SessionPage — what EVERY Parsina panel shows
// between opening the tab and knowing who is signed in.
//
// The Keycloak round trip, the token check and whatever read a panel needs
// before its first screen (onboarding status, memberships, appearance) all sit
// behind this one card. It was the doctor panel's (its App.jsx `AuthPage`),
// copied into the clinic panel in 2026-09 and drawn differently again in the
// dentist, student and admin panels — five front doors to one product. It is
// the kit's now, so a person who opens two panels in one morning meets one
// door, and a change to it is one release rather than five edits.
//
//   SessionPage   the canvas (145° navy gradient, two drifting discs) and the
//                 420px white card that rises in
//   SessionCheck  the loading state: brand hero, three bouncing dots, the
//                 progress track, and the manual sign-in link after 4s
//   SessionError  a boot that could not finish: logo, tone disc, message,
//                 one gradient action, and the SSO host it tried
//
// ── Continuing across a remount ─────────────────────────────────────────────
//
// A panel's boot often has two owners — the auth check, then a provider that
// reads what the panel needs — and each renders its own SessionCheck. Left
// alone the second mount would restart every animation: the card rising again,
// the track snapping back to 5%. So every animation is offset by the time since
// this MODULE loaded (≈ the page's start) with a negative `animation-delay`,
// and the manual link counts from the same moment. The second mount continues
// the first.
//
// Every word is a PROP (rule 7) and so is the logo: the kit ships no image, and
// a panel with its own mark (ParsinaDent) passes its own.
// ─────────────────────────────────────────────────────────────────────────────
const $3c4ca280922aa4ea$var$now = ()=>typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
const $3c4ca280922aa4ea$var$SESSION_T0 = $3c4ca280922aa4ea$var$now();
/** Milliseconds since the kit loaded — the one clock every session screen shares. */ const $3c4ca280922aa4ea$var$sinceBoot = ()=>$3c4ca280922aa4ea$var$now() - $3c4ca280922aa4ea$var$SESSION_T0;
const $3c4ca280922aa4ea$var$continued = (elapsedMs, ownDelayS = 0)=>({
        animationDelay: `${ownDelayS - elapsedMs / 1000}s`
    });
const $3c4ca280922aa4ea$export$6b89370abb8fc4ae = `linear-gradient(145deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 55%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $3c4ca280922aa4ea$export$e3b7f640fe979c0e = `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 60%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $3c4ca280922aa4ea$var$SESSION_ACTION = `linear-gradient(135deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navy})`;
// Reduced motion: the card simply appears, the dots rest, the track sits part
// filled. Those resting values are the base rules, so they hold wherever the
// animation does not.
const $3c4ca280922aa4ea$var$SESSION_CSS = `
  @keyframes parsina-session-rise { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes parsina-session-dot { 0%, 65%, 100% { transform: translateY(0); opacity: 0.3 } 30% { transform: translateY(-9px); opacity: 1 } }
  @keyframes parsina-session-progress { 0% { width: 5% } 50% { width: 65% } 85% { width: 88% } 100% { width: 93% } }
  @keyframes parsina-session-float { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.06) } }
  @keyframes parsina-session-appear { from { opacity: 0 } to { opacity: 1 } }
  [data-session-dot] { opacity: 0.6; }
  [data-session-progress] { width: 65%; }
  @media (prefers-reduced-motion: no-preference) {
    [data-session-card] { animation: parsina-session-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both; }
    [data-session-dot] { animation: parsina-session-dot 1.5s ease-in-out infinite; }
    [data-session-progress] { animation: parsina-session-progress 3s ease-out both; }
    [data-session-float] { animation-name: parsina-session-float; animation-timing-function: ease-in-out; animation-iteration-count: infinite; }
    [data-session-appear] { animation: parsina-session-appear 0.4s ease both; }
  }
`;
function $3c4ca280922aa4ea$export$15364261a1aca489({ children: children, testId: testId }) {
    // Read once per mount: the offset must not move under a running animation.
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: $3c4ca280922aa4ea$export$6b89370abb8fc4ae,
            fontFamily: 'Meshkat, sans-serif',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $3c4ca280922aa4ea$var$SESSION_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            top: -120,
            insetInlineEnd: -80,
            width: 380,
            height: 380,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
            animationDuration: '9s',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            bottom: -160,
            insetInlineStart: -100,
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            animationDuration: '12s',
            pointerEvents: 'none',
            ...$3c4ca280922aa4ea$var$continued(elapsed, 3)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        "data-session-card": "",
        style: {
            background: 'white',
            borderRadius: 16,
            width: 420,
            maxWidth: 'calc(100vw - 48px)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.3), 0 8px 32px rgba(0,0,0,0.18)',
            textAlign: 'center',
            overflow: 'hidden',
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    }, children));
}
function $3c4ca280922aa4ea$export$cd72095868f03c30({ logo: logo, brandName: brandName, panelName: panelName, title: title, subtitle: subtitle, stuckLabel: stuckLabel, manualLabel: manualLabel, onManualSignIn: onManualSignIn, manualAfterMs: manualAfterMs = 4000, testId: testId = 'session-check' }) {
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    const [showManual, setShowManual] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>elapsed >= manualAfterMs);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (showManual || !onManualSignIn) return undefined;
        const timer = setTimeout(()=>setShowManual(true), Math.max(0, manualAfterMs - $3c4ca280922aa4ea$var$sinceBoot()));
        return ()=>clearTimeout(timer);
    }, [
        showManual,
        onManualSignIn,
        manualAfterMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: $3c4ca280922aa4ea$export$e3b7f640fe979c0e,
            padding: '36px 44px 32px',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            top: -24,
            insetInlineEnd: -24,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            bottom: -30,
            insetInlineStart: -20,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 14,
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'rgba(255,255,255,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain'
        }
    }))) : null, brandName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 26,
            fontWeight: 800,
            color: 'white',
            marginBottom: 4,
            letterSpacing: -0.5
        }
    }, brandName) : null, panelName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: 'rgba(255,255,255,0.55)'
        }
    }, panelName) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '32px 44px 40px'
        },
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            marginBottom: 18
        }
    }, [
        0,
        0.18,
        0.36
    ].map((delay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: delay,
            "data-session-dot": "",
            style: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: (0, $jTCZr.C).navy,
                ...$3c4ca280922aa4ea$var$continued(elapsed, delay)
            }
        }))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 15,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: 6,
            fontWeight: 500
        }
    }, title) : null, subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 28
        }
    }, subtitle) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            width: '100%',
            height: 4,
            background: (0, $jTCZr.C).border,
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 28
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-progress": "",
        style: {
            height: '100%',
            background: `linear-gradient(90deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navyLight})`,
            borderRadius: 4,
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    })), showManual && onManualSignIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-appear": "",
        style: {
            marginTop: 18,
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted
        }
    }, stuckLabel, stuckLabel ? ' ' : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onManualSignIn,
        "data-testid": `${testId}-manual`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            color: (0, $jTCZr.C).navy,
            textDecoration: 'underline',
            textUnderlineOffset: 3
        }
    }, manualLabel)) : null));
}
// Filled glyphs (Material `error`, `cloud_off`) — the doctor card's family.
const $3c4ca280922aa4ea$var$ErrorGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));
const $3c4ca280922aa4ea$var$OfflineGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }));
const $3c4ca280922aa4ea$var$TONES = {
    /** The sign-in service failed, or the redirect looped. */ danger: {
        bg: '#FEF2F2',
        ring: '#FECACA',
        ink: (0, $jTCZr.C).red,
        Glyph: $3c4ca280922aa4ea$var$ErrorGlyph
    },
    /** Signed in, but the panel's backend did not answer. */ warning: {
        bg: '#FFFBEB',
        ring: '#FDE68A',
        ink: '#B45309',
        Glyph: $3c4ca280922aa4ea$var$OfflineGlyph
    }
};
function $3c4ca280922aa4ea$export$d422f67d76bf24e4({ tone: tone = 'danger', logo: logo, brandName: brandName, title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, secondary: secondary, host: host, testId: testId = 'session-error', stateTestId: stateTestId }) {
    const look = $3c4ca280922aa4ea$var$TONES[tone] || $3c4ca280922aa4ea$var$TONES.danger;
    const { Glyph: Glyph } = look;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '40px 44px 44px'
        },
        role: "alert",
        "data-testid": stateTestId
    }, logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain',
            marginBottom: 20,
            opacity: 0.55
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: look.bg,
            border: `2px solid ${look.ring}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        color: look.ink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0 0 10px',
            color: (0, $jTCZr.C).textPrimary,
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: -0.3
        }
    }, title), body ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $jTCZr.C).textSecondary,
            fontSize: 14,
            marginBottom: detail ? 12 : 32,
            lineHeight: 1.8
        }
    }, body) : null, detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $jTCZr.C).textMuted,
            fontSize: 12,
            marginBottom: 32,
            lineHeight: 1.7,
            wordBreak: 'break-word'
        }
    }, detail) : null, onAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAction,
        style: {
            width: '100%',
            height: 50,
            background: $3c4ca280922aa4ea$var$SESSION_ACTION,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            fontSize: 15,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: `0 4px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.3)}`,
            marginBottom: secondary ? 10 : 20
        }
    }, actionLabel) : null, secondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: secondary.onClick,
        style: {
            width: '100%',
            height: 44,
            background: 'white',
            color: (0, $jTCZr.C).navy,
            border: `1.5px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            marginBottom: 20
        }
    }, secondary.label) : null, host ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 14px',
            background: '#f8fafc',
            borderRadius: 10,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $jTCZr.C).textMuted,
        width: "13",
        height: "13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: 11,
            color: (0, $jTCZr.C).textMuted,
            fontFamily: 'monospace',
            letterSpacing: 0.2
        }
    }, host)) : null));
}
var $3c4ca280922aa4ea$export$2e2bcd8739ae039 = $3c4ca280922aa4ea$export$cd72095868f03c30;

});

parcelRegister("66joL", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c90190398471f24a$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonRegion", () => $c90190398471f24a$export$8b3e24dbbac64362);
$parcel$export(module.exports, "SkeletonText", () => $c90190398471f24a$export$cb6ddd830302c2a8);
$parcel$export(module.exports, "SkeletonAvatar", () => $c90190398471f24a$export$53c2c5a35a7e31a2);
$parcel$export(module.exports, "SkeletonButton", () => $c90190398471f24a$export$7387c3f2666b9f16);
$parcel$export(module.exports, "SkeletonInput", () => $c90190398471f24a$export$5ce4f4d8e50e2948);
$parcel$export(module.exports, "SkeletonCard", () => $c90190398471f24a$export$5956eb8f2ff4afde);
$parcel$export(module.exports, "SkeletonRow", () => $c90190398471f24a$export$8bbcb87f63697989);
$parcel$export(module.exports, "SkeletonTable", () => $c90190398471f24a$export$6a15d3f7c248c5bb);
$parcel$export(module.exports, "SkeletonList", () => $c90190398471f24a$export$9e2e66b17fdb9730);
$parcel$export(module.exports, "SkeletonTabs", () => $c90190398471f24a$export$452537ec11d5437e);
$parcel$export(module.exports, "SkeletonChart", () => $c90190398471f24a$export$9e5a4339fadac171);
$parcel$export(module.exports, "SkeletonForm", () => $c90190398471f24a$export$68fb050a45c52f04);
$parcel$export(module.exports, "SkeletonHeader", () => $c90190398471f24a$export$171a4533b2ae49b5);
$parcel$export(module.exports, "SkeletonFilters", () => $c90190398471f24a$export$f70e1ea07462d9df);
$parcel$export(module.exports, "SkeletonStats", () => $c90190398471f24a$export$3122f708803a735a);
$parcel$export(module.exports, "default", () => $c90190398471f24a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Skeleton family — the loading state of every Parsina screen.
//
// A screen that is fetching draws ITS OWN SHAPE in placeholder blocks: the
// header, tabs, filters, table or cards it is about to show, at the sizes they
// will have. Not a centred spinner, not «در حال بارگذاری…», not a blank page —
// see DESIGN.md §"Loading & skeleton". The primitives here are the vocabulary;
// each screen composes its own skeleton from them (`PatientDetailSkeleton`,
// `ReceptionSkeleton`, …) so the skeleton matches THAT screen, desktop and
// mobile alike, and nothing jumps when the data lands.
//
// Sizes mirror the real components on purpose: `SkeletonInput` is 44px like a
// `TextInput`, `SkeletonButton` 44px like a `Button`, `SkeletonTable` rows are
// 52px (44 dense) like `Table`, `SkeletonCard` has the `Card` surface. If a real
// component's geometry changes, change its skeleton in the same commit.
//
// Every block is `aria-hidden`; a composite root carries `role="status"`,
// `aria-busy` and an accessible `label` (a prop, rule 7) so assistive tech hears
// ONE "loading" instead of forty empty boxes. Motion respects
// `prefers-reduced-motion`: the sheen stops, the blocks stay.
// ─────────────────────────────────────────────────────────────────────────────
const $c90190398471f24a$var$SHIMMER_CSS = `
  @keyframes parsina-shimmer {
    0%   { background-position: 200% 0 }
    100% { background-position: -200% 0 }
  }
  [data-skeleton] {
    background: linear-gradient(90deg, ${(0, $jTCZr.SKELETON).base} 25%, ${(0, $jTCZr.SKELETON).sheen} 50%, ${(0, $jTCZr.SKELETON).base} 75%);
    background-size: 200% 100%;
    animation: parsina-shimmer 1.4s ease-in-out infinite;
  }
  [data-skeleton][data-tone="onDark"] {
    background: linear-gradient(90deg, ${(0, $jTCZr.SKELETON).onDark} 25%, ${(0, $jTCZr.SKELETON).onDarkSheen} 50%, ${(0, $jTCZr.SKELETON).onDark} 75%);
    background-size: 200% 100%;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-skeleton] { animation: none; background: ${(0, $jTCZr.SKELETON).base}; }
    [data-skeleton][data-tone="onDark"] { background: ${(0, $jTCZr.SKELETON).onDark}; }
  }
`;
// One stylesheet for the whole family. React 19 hoists a <style> with `href` +
// `precedence` into <head> once, however many skeletons are on screen.
const $c90190398471f24a$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-skeleton",
        precedence: "default"
    }, $c90190398471f24a$var$SHIMMER_CSS);
function $c90190398471f24a$export$8f31e4c4a37b8e9c({ width: width = '100%', height: height = 14, radius: radius = (0, $jTCZr.RADIUS).chip, circle: circle = false, tone: tone, style: style, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-skeleton": "",
        // `tone="onDark"` — white-alpha blocks for a gradient header, a sidebar
        // or a dark image canvas, where the neutral grey would read as a hole.
        "data-tone": tone === 'onDark' ? 'onDark' : undefined,
        className: className,
        style: {
            width: width,
            height: circle ? width : height,
            borderRadius: circle ? '50%' : radius,
            flexShrink: 0,
            ...style
        },
        ...rest
    }));
}
// Whether we are already inside an announced skeleton region. A page skeleton
// composed of a SkeletonStats, a SkeletonTable and two SkeletonCards used to
// announce "loading" four times; only the OUTERMOST region speaks now, the
// nested ones are plain hidden boxes.
const $c90190398471f24a$var$Nested = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $c90190398471f24a$export$8b3e24dbbac64362({ as: Tag = 'div', label: label, style: style, children: children, ...rest }) {
    const nested = (0, $acw62.useContext)($c90190398471f24a$var$Nested);
    if (nested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "aria-hidden": true,
        "data-state": "loading",
        style: style,
        ...rest
    }, children);
    // An announced region is named in whatever language the page is showing: the
    // caller's `label`, or the kit's own word for "loading" in `<html lang>`.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Nested.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        role: "status",
        "aria-busy": "true",
        "aria-label": label ?? (0, $j9AxR.kitCopy)().loading,
        "data-state": "loading",
        style: style,
        ...rest
    }, children));
}
const $c90190398471f24a$var$Root = $c90190398471f24a$export$8b3e24dbbac64362;
// Line widths for a paragraph — the last line is shorter, like real text.
const $c90190398471f24a$var$LINE_WIDTHS = [
    '100%',
    '92%',
    '96%',
    '85%',
    '70%'
];
function $c90190398471f24a$export$cb6ddd830302c2a8({ width: width = '60%', height: height = 14, lines: lines = 1, lastWidth: lastWidth = '60%', gap: gap = 8, style: style, ...rest }) {
    if (lines <= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: width,
        height: height,
        style: style,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: '100%',
            ...style
        },
        ...rest
    }, Array.from({
        length: lines
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: height,
            width: i === lines - 1 ? lastWidth : $c90190398471f24a$var$LINE_WIDTHS[i % $c90190398471f24a$var$LINE_WIDTHS.length]
        })));
}
function $c90190398471f24a$export$53c2c5a35a7e31a2({ size: size = 40, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size,
        circle: true,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$7387c3f2666b9f16({ width: width = 112, size: size = 'default', style: style, ...rest }) {
    const height = size === 'sm' ? 36 : size === 'icon' ? 40 : 44;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size === 'icon' ? height : width,
        height: height,
        radius: (0, $jTCZr.RADIUS).control,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$5ce4f4d8e50e2948({ label: label = true, labelWidth: labelWidth = 88, multiline: multiline = false, width: width = '100%', style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: width,
            ...style
        },
        ...rest
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: labelWidth,
        height: 12
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: multiline ? 96 : 44,
        radius: (0, $jTCZr.RADIUS).control
    }));
}
function $c90190398471f24a$export$5956eb8f2ff4afde({ avatar: avatar = true, lines: lines = 0, chips: chips = 2, actions: actions = 2, padding: padding = 20, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: (0, $jTCZr.RADIUS).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            padding: padding,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
        size: 48
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "60%",
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "40%",
        height: 11
    }))), lines > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$cb6ddd830302c2a8, {
        lines: lines,
        height: 12
    }) : null, chips > 0 || actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border
        }
    }) : null, chips > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: 60 + i % 2 * 12,
            height: 22,
            radius: (0, $jTCZr.RADIUS).pill
        }))) : null, actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: 36,
            radius: (0, $jTCZr.RADIUS).control,
            style: {
                flex: 1
            }
        }))) : null);
}
const $c90190398471f24a$var$ROW_WIDTHS = [
    48,
    120,
    100,
    70,
    80,
    70,
    100
];
function $c90190398471f24a$export$8bbcb87f63697989({ cols: cols = 7, widths: widths = $c90190398471f24a$var$ROW_WIDTHS, dense: dense = false, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        "aria-hidden": true,
        style: {
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            height: dense ? 44 : 52
        },
        ...rest
    }, Array.from({
        length: cols
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            key: i,
            style: {
                padding: '0 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: widths[i % widths.length] || 80,
            height: i === 0 ? 18 : 13
        }))));
}
function $c90190398471f24a$export$6a15d3f7c248c5bb({ rows: rows = 6, columns: columns = 5, dense: dense = false, header: header = true, style: style, label: label, ...rest }) {
    const cols = Array.isArray(columns) ? columns : Array.from({
        length: columns
    }, (_, i)=>$c90190398471f24a$var$ROW_WIDTHS[(i + 1) % $c90190398471f24a$var$ROW_WIDTHS.length]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            overflow: 'hidden',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed'
        }
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $jTCZr.CT).surface2,
            height: 40
        }
    }, cols.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            style: {
                padding: '0 16px',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: Math.min(typeof w === 'number' ? w * 0.7 : 72, 96),
            height: 11
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: rows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8bbcb87f63697989, {
            key: i,
            cols: cols.length,
            widths: cols,
            dense: dense
        })))));
}
function $c90190398471f24a$export$9e2e66b17fdb9730({ count: count = 5, avatar: avatar = true, trailing: trailing = 56, divided: divided = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                minHeight: avatar ? 64 : 52,
                padding: '0 4px',
                borderTop: divided && i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
            size: 40
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${55 + i * 17 % 30}%`,
            height: 14
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${30 + i * 11 % 25}%`,
            height: 11
        })), trailing > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: trailing,
            height: 22,
            radius: (0, $jTCZr.RADIUS).pill
        }) : null)));
}
function $c90190398471f24a$export$452537ec11d5437e({ count: count = 4, widths: widths, gap: gap = 4, padding: padding = '12px 14px', style: style, ...rest }) {
    const ws = widths || Array.from({
        length: count
    }, (_, i)=>[
            72,
            60,
            96,
            84,
            68
        ][i % 5]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: gap,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            overflowX: 'hidden',
            ...style
        },
        ...rest
    }, ws.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: padding
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: w,
            height: 13
        }))));
}
const $c90190398471f24a$var$BAR_HEIGHTS = [
    0.55,
    0.8,
    0.4,
    0.95,
    0.65,
    0.75,
    0.5,
    0.85,
    0.6,
    0.7,
    0.45,
    0.9
];
function $c90190398471f24a$export$9e5a4339fadac171({ height: height = 200, bars: bars = 8, line: line = false, legend: legend = 2, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            ...style
        }
    }, legend > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, Array.from({
        length: legend
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 10,
            circle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 56,
            height: 11
        })))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: height,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: '0 8px'
        }
    }, line ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: Math.round(height * 0.35),
        radius: (0, $jTCZr.RADIUS).card,
        style: {
            marginBottom: Math.round(height * 0.25)
        }
    }) : Array.from({
        length: bars
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: Math.round(height * $c90190398471f24a$var$BAR_HEIGHTS[i % $c90190398471f24a$var$BAR_HEIGHTS.length]),
            radius: (0, $jTCZr.RADIUS).chip,
            style: {
                flex: 1,
                width: 'auto'
            }
        }))));
}
function $c90190398471f24a$export$68fb050a45c52f04({ fields: fields = 4, columns: columns = 1, actions: actions = 1, multiline: multiline = [], gap: gap = 16, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: gap
        }
    }, Array.from({
        length: fields
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$5ce4f4d8e50e2948, {
            key: i,
            multiline: multiline.includes(i),
            style: multiline.includes(i) && columns > 1 ? {
                gridColumn: '1 / -1'
            } : undefined
        }))), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 120 : 96
        }))) : null);
}
function $c90190398471f24a$export$171a4533b2ae49b5({ subtitle: subtitle = true, actions: actions = 1, back: back = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            minHeight: 44,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0
        }
    }, back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 160,
        height: 20
    }), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 110,
        height: 12
    }) : null)), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 112 : 44
        }))) : null);
}
function $c90190398471f24a$export$f70e1ea07462d9df({ search: search = true, chips: chips = 3, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            ...style
        },
        ...rest
    }, search ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 240,
        height: 44,
        radius: (0, $jTCZr.RADIUS).control,
        style: {
            maxWidth: '100%'
        }
    }) : null, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: [
                84,
                72,
                96,
                64
            ][i % 4],
            height: 36,
            radius: (0, $jTCZr.RADIUS).pill
        })));
}
function $c90190398471f24a$export$3122f708803a735a({ count: count = 4, icon: icon = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
            gap: 12,
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: 12,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                border: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 44,
            height: 44,
            radius: 12
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "55%",
            height: 22
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "70%",
            height: 11
        })))));
}
var $c90190398471f24a$export$2e2bcd8739ae039 = $c90190398471f24a$export$8f31e4c4a37b8e9c;

});

parcelRegister("7gSBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $838915ee2bfb8ab1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gYS9K = parcelRequire("gYS9K");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $838915ee2bfb8ab1$export$2e2bcd8739ae039({ icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gYS9K.default), {
    size: 44,
    strokeWidth: 1.5,
    "aria-hidden": true
}), title: title, description: description, action: action, fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            animation: 'fadeUp .3s ease',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 56,
            marginBottom: 16,
            color: (0, $jTCZr.C).textMuted,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, icon), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted
        }
    }, description), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, action));
}

});
parcelRegister("gYS9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c08c9e83bb1a976$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5c08c9e83bb1a976$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 12 16 12 14 15 10 15 8 12 2 12",
            key: "o97t9d"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ]
];
const $5c08c9e83bb1a976$export$2e2bcd8739ae039 = (0, $9QBug.default)("inbox", $5c08c9e83bb1a976$export$3efd853dbb351e94);

});
parcelRegister("9QBug", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb908d1b06653674$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");

var $cFsMh = parcelRequire("cFsMh");

var $agXzh = parcelRequire("agXzh");

var $8uM9A = parcelRequire("8uM9A");

var $kBnWl = parcelRequire("kBnWl");
const $cb908d1b06653674$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $kBnWl.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $cFsMh.mergeClasses)(`lucide-${(0, $agXzh.toKebabCase)((0, $8uM9A.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $8uM9A.toPascalCase)(iconName);
    return Component;
};

});
parcelRegister("cFsMh", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", () => $5921600fb4e81be8$export$3d46f4579dba46e5);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("agXzh", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $ebab042c7bf4d462$export$73bda83cddbc7187);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});

parcelRegister("8uM9A", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", () => $05938c6aab1a7024$export$6fb43ff9addf7357);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lTrzp = parcelRequire("lTrzp");
const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $lTrzp.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("lTrzp", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $679cfb4006de9dc2$export$86f54f62aa7a7514);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());

});


parcelRegister("kBnWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c69f6577678916e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4XSgb = parcelRequire("4XSgb");

var $cWxOD = parcelRequire("cWxOD");

var $cFsMh = parcelRequire("cFsMh");

var $efvHT = parcelRequire("efvHT");
"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $efvHT.useLucideContext)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $4XSgb.default),
        width: size ?? contextSize ?? (0, $4XSgb.default).width,
        height: size ?? contextSize ?? (0, $4XSgb.default).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $cFsMh.mergeClasses)("lucide", contextClass, className),
        ...!children && !(0, $cWxOD.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("4XSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02e0cdef8864a93$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $b02e0cdef8864a93$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});

parcelRegister("cWxOD", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", () => $08ed9cd30f364255$export$ab365959aa6deed0);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});

parcelRegister("efvHT", function(module, exports) {

$parcel$export(module.exports, "useLucideContext", () => $fdd26cba762f63b6$export$52ee7576b6cde767);

var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);

});





parcelRegister("7wZCE", function(module, exports) {

$parcel$export(module.exports, "avatarColor", () => $a53b6ea678d7efe0$export$75ef3c97b2be2f20);
$parcel$export(module.exports, "default", () => $a53b6ea678d7efe0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
// Inlined so the component carries no bundler-specific asset import (Parcel's
// `url:` scheme does not exist in Next.js) — same default-avatar silhouette.
const $a53b6ea678d7efe0$var$defaultAvatarSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><circle cx="20" cy="15" r="7" fill="#94a3b8"/><path d="M6 38c1.8-8 7.5-12 14-12s12.2 4 14 12z" fill="#94a3b8"/></svg>');
const $a53b6ea678d7efe0$var$AVATAR_COLORS = [
    '#1d4ed8',
    '#0891b2',
    '#0d9488',
    '#7c3aed',
    '#db2777',
    '#ea580c',
    '#16a34a'
];
function $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name) {
    const s = name || '';
    let h = 0;
    for(let i = 0; i < s.length; i++)h = s.charCodeAt(i) + ((h << 5) - h);
    return $a53b6ea678d7efe0$var$AVATAR_COLORS[Math.abs(h) % $a53b6ea678d7efe0$var$AVATAR_COLORS.length];
}
const $a53b6ea678d7efe0$var$Avatar = ({ name: name, size: size = 40, bg: bg, color: color = 'white', src: src })=>{
    const resolvedBg = bg ?? $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src ? 'loading' : 'idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setStatus(src ? 'loading' : 'idle');
    }, [
        src
    ]);
    const initials = (name || '').split(' ').filter(Boolean).map((w)=>w[0]).join('').slice(0, 2) || '?';
    const isSkeleton = status === 'loading';
    const isError = status === 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: isSkeleton ? '#e2e8f0' : src && !isError ? 'transparent' : resolvedBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.35,
            fontWeight: '700',
            color: color,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            animation: isSkeleton ? 'avatar-pulse 1.4s ease-in-out infinite' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes avatar-pulse{0%,100%{opacity:1}50%{opacity:.4}}`), src && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: name,
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isSkeleton ? 0 : 1,
            transition: 'opacity 0.25s',
            position: 'absolute',
            inset: 0
        }
    }), (!src || isError) && (isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: $a53b6ea678d7efe0$var$defaultAvatarSrc,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, initials)));
};
var $a53b6ea678d7efe0$export$2e2bcd8739ae039 = $a53b6ea678d7efe0$var$Avatar;

});

parcelRegister("2xPWT", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $7wZCE = parcelRequire("7wZCE");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PersonRow — a person, offered for choosing or simply stated.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// RECEPTION_PRACTITIONER_BOOKING §6.2 specifies a row anatomy for the clinic's
// practitioner picker — avatar, name, a meta line of «حرفه · تخصص · مدت», a
// trailing availability phrase, an ordinal for the first nine, and a disabled
// state that still says WHY. The patient app's practitioner step is the same
// row with different words in it. Two apps, one anatomy, and a *document*
// specifying it app-agnostically: §17.1 answers yes twice over.
//
// The rule it encodes is DESIGN.md rule 12 — an avatar means a person. This is
// not for anything that is not somebody.
//
// ── One component, two sizes — deliberately not two components ──────────────
// `size="sm"` is the CHIP: the pill in the clinic `BookingModal`'s header and
// the identity line of the patient's booking overlay. It is the same person
// with the same avatar and the same two lines, smaller and not tappable —
// shipping it as a second export would be the many-components failure §17.1
// warns about, and would let the two drift.
//
// Interactivity follows `onClick`: with one it is a real `<button>` and grows a
// chevron; without one it is a `<div>` that states rather than offers. A caller
// never has to ask for both.
//
// ── Unbookable is shown, never hidden (§2.6, §8.5) ──────────────────────────
// `disabled` mutes the row and shows `disabledReason` instead of dropping it
// from the list. Omitting is what makes a list lie: a patient looking for a
// specific doctor concludes they have left the clinic. `action` is the way out
// of the reason — the «تعریف ↗» link the clinic offers somebody who may fix it
// — and is simply not passed to a caller who may not.
//
// ── No copy, no numbers of its own ──────────────────────────────────────────
// §16.2 / §16.1: `name`, `meta`, `trailing`, `disabledReason` and `ordinal` are
// rendered VERBATIM, so their digits are whatever the app's own seam already
// made them. This component must never call a formatter and carries no
// catalogue. The patient app's `formatNumber` and the clinic's `formatDigits`
// are different seams, and both stay on their side of this line.
// ─────────────────────────────────────────────────────────────────────────────
// The chevron points the way the reader travels, which flips with the document.
// `--dir-flip` is the kit's one mirror (§11) — there is no `dir` prop, because a
// component that took one could be told to disagree with <html>.
const $cff717c1fa706fb8$var$Chevron = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "currentColor",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: (0, $jTCZr.C).textMuted,
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $cff717c1fa706fb8$var$SIZES = {
    md: {
        avatar: 34,
        pad: '0.6875rem 0.875rem',
        radius: (0, $jTCZr.RADIUS).card,
        name: '0.84375rem',
        meta: '0.75rem',
        gap: '0.625rem'
    },
    sm: {
        avatar: 28,
        pad: '0.3125rem 0.75rem',
        radius: (0, $jTCZr.RADIUS).pill,
        name: '0.8125rem',
        meta: '0.6875rem',
        gap: '0.5rem'
    }
};
function $cff717c1fa706fb8$export$2e2bcd8739ae039({ name: name, meta: meta, trailing: trailing, ordinal: ordinal, avatar: avatar, size: size = 'md', selected: selected = false, disabled: disabled = false, disabledReason: disabledReason, action: action, chevron: chevron, onClick: onClick, as: as, className: className, 'data-testid': testId, ...rest }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    const interactive = typeof onClick === 'function' && !disabled;
    const showChevron = chevron === undefined ? interactive : chevron && !disabled;
    const tail = disabled && disabledReason ? disabledReason : trailing;
    const Tag = as || (interactive ? 'button' : 'div');
    const isButton = Tag === 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        type: isButton ? 'button' : undefined,
        onClick: interactive ? onClick : undefined,
        disabled: isButton ? disabled : undefined,
        "aria-disabled": !isButton && disabled ? true : undefined,
        "aria-selected": rest.role === 'option' ? selected : undefined,
        "data-testid": testId,
        "data-state": disabled ? 'disabled' : selected ? 'selected' : 'default',
        className: (0, $5JYPc.cn)(interactive || size === 'md' ? 'w-full text-start' : 'text-start', className),
        style: {
            // A chip HUGS its contents; a row fills the list it is in. A
            // block-level chip stretched to the panel width reads as an empty field
            // rather than as a named person.
            display: size === 'sm' ? 'inline-flex' : 'flex',
            width: size === 'sm' ? 'fit-content' : undefined,
            maxWidth: '100%',
            alignItems: 'center',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: size === 'sm' ? 'none' : `1px solid ${selected ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: size === 'sm' ? (0, $jTCZr.C).bg : selected ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.08) : (0, $jTCZr.C).card,
            cursor: disabled ? 'not-allowed' : interactive ? 'pointer' : 'default',
            opacity: disabled ? 0.6 : 1,
            // ≥ 2.75rem is the phone hit target (MOBILE_WEB_PWA §5); a chip is not a
            // target at all, so it is exempt.
            minHeight: size === 'sm' ? undefined : '2.75rem',
            minWidth: 0,
            transition: 'background 0.15s, border-color 0.15s'
        },
        ...rest
    }, ordinal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            width: '1.25rem',
            textAlign: 'center',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textMuted
        }
    }, ordinal) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: avatar?.name ?? (typeof name === 'string' ? name : ''),
        bg: avatar?.color,
        src: avatar?.src,
        size: S.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.name,
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, meta) : null), tail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            lineHeight: 1.5,
            color: disabled ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk,
            textAlign: 'end'
        }
    }, tail) : null, action, showChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cff717c1fa706fb8$var$Chevron, null) : null);
}
function $cff717c1fa706fb8$export$fb8511da6566433c({ count: count = 4, size: size = 'md', label: label, 'data-testid': testId }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: S.gap,
                padding: S.pad,
                borderRadius: S.radius,
                border: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: S.avatar,
            height: S.avatar,
            radius: (0, $jTCZr.RADIUS).pill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "45%",
            height: 11,
            radius: (0, $jTCZr.RADIUS).chip
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "30%",
            height: 9,
            radius: (0, $jTCZr.RADIUS).chip
        })))));
}

});

parcelRegister("4LQcd", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $7718f00aead6941c$export$2e2bcd8739ae039({ state: state = 'content', slots: slots = [], value: value, onSelect: onSelect, notice: notice = null, label: label, loadingLabel: loadingLabel, min: min = '5rem', columns: columns, loadingCount: loadingCount = 12, className: className, 'data-testid': testId, ...rest }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().slotGrid.label;
    if (loadingLabel === undefined) loadingLabel = (0, $j9AxR.kitCopy)().slotGrid.loading;
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fill, minmax(${min}, 1fr))`,
        gap: '0.5rem'
    };
    if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: loadingLabel,
        "data-testid": testId,
        "data-state": "loading",
        style: gridStyle
    }, Array.from({
        length: loadingCount
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            height: 44,
            radius: (0, $jTCZr.RADIUS).control
        })));
    if (state === 'error' || state === 'empty') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: className,
        ...rest
    }, notice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label,
        "data-testid": testId,
        "data-state": "content",
        className: className,
        style: gridStyle,
        ...rest
    }, slots.map((slot)=>{
        const selected = value != null && slot.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: slot.value,
            type: "button",
            onClick: slot.disabled ? undefined : ()=>onSelect?.(slot),
            disabled: slot.disabled,
            "aria-pressed": selected,
            "data-testid": `${testId || 'slot'}-${slot.value}`,
            "data-state": slot.disabled ? 'disabled' : selected ? 'selected' : 'default',
            "data-held": slot.held || undefined,
            className: "tabular-nums",
            style: {
                // ≥ 2.75rem: a time is among the smallest things a thumb has to
                // hit on this screen, and there are dozens of them.
                minHeight: '2.75rem',
                padding: '0.5rem 0.625rem',
                borderRadius: (0, $jTCZr.RADIUS).control,
                fontSize: '0.8125rem',
                fontWeight: 600,
                cursor: slot.disabled ? 'not-allowed' : 'pointer',
                border: selected ? `2px solid ${(0, $jTCZr.CT).accent}` : slot.held ? `1.5px dashed ${(0, $jTCZr.CT).warn}` : `1.5px solid ${(0, $jTCZr.C).border}`,
                background: selected ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.14) : slot.held ? (0, $jTCZr.soft)((0, $jTCZr.CT).warn, 0.1) : (0, $jTCZr.C).card,
                color: selected ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textPrimary,
                opacity: slot.disabled ? 0.45 : 1,
                transition: 'background 0.14s, border-color 0.14s'
            }
        }, slot.label);
    }));
}

});

parcelRegister("g6X9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $9169df7fa2fdff01$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// Card — the system's surface unit.
//
// With `onClick` it becomes a REAL button (never a `<div onClick>`): callers used
// to wrap it in a `role="button"` div to get keyboard operation and a focus ring
// back, which nested two interactive elements and handed screen readers a control
// inside a control. Those semantics belong here. Pass `role="link"` when the tap
// navigates rather than acts.
const $9169df7fa2fdff01$var$Card = ({ children: children, style: style, onClick: onClick, role: role, disabled: disabled, className: className, ...rest })=>{
    const surface = {
        background: (0, $jTCZr.C).card,
        borderRadius: 16,
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: `1px solid ${(0, $jTCZr.C).border}`,
        ...style
    };
    if (!onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: surface,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: role,
        disabled: disabled,
        onClick: onClick,
        className: (0, $5JYPc.cn)('outline-none focus-visible:ring-2 focus-visible:ring-ring', className),
        style: {
            ...surface,
            display: 'block',
            width: '100%',
            textAlign: 'inherit',
            font: 'inherit',
            color: 'inherit',
            cursor: disabled ? 'default' : 'pointer',
            transition: 'transform 0.15s, box-shadow 0.15s'
        },
        onMouseDown: (e)=>{
            if (!disabled) e.currentTarget.style.transform = 'scale(0.98)';
        },
        onMouseUp: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        ...rest
    }, children);
};
var $9169df7fa2fdff01$export$2e2bcd8739ae039 = $9169df7fa2fdff01$var$Card;

});

parcelRegister("7h7Jc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f942082497afe1e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $4f942082497afe1e$export$2e2bcd8739ae039({ status: status, style: style }) {
    const cfg = (0, $jTCZr.statusColors)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, cfg.label);
}

});

parcelRegister("lUcdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $178f36e6e586ad89$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $178f36e6e586ad89$export$2e2bcd8739ae039({ label: label, value: value, unit: unit, icon: icon, bg: bg, accent: accent, loading: loading, minWidth: minWidth = 140, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            flex: 1,
            minWidth: minWidth,
            ...rest.style
        }
    }, icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 44,
            height: 44,
            borderRadius: 12,
            background: bg || (0, $jTCZr.C).bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 22,
            fontWeight: 800,
            color: accent || (0, $jTCZr.C).textPrimary,
            lineHeight: 1.15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, loading ? "\u2014" : value), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("wbr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 500,
            color: (0, $jTCZr.C).textMuted,
            marginInlineStart: 4,
            whiteSpace: 'nowrap'
        }
    }, unit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $jTCZr.C).textSecondary,
            marginTop: 4
        }
    }, label)));
}

});

parcelRegister("fkDNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $64626580dc6749e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $64626580dc6749e0$export$2e2bcd8739ae039({ stats: stats, loading: loading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: '12px 32px',
            display: 'flex',
            gap: 12,
            flexShrink: 0,
            overflowX: 'auto',
            ...style
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: s.bg,
                borderRadius: 10,
                padding: '8px 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 20,
                fontWeight: 800,
                color: s.color
            }
        }, loading ? "\u2014" : s.value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                fontWeight: 600,
                color: s.color,
                opacity: 0.75
            }
        }, s.label))));
}

});

parcelRegister("kyZIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed420e5a4f8c639f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ed420e5a4f8c639f$export$2e2bcd8739ae039({ title: title, sub: sub, breadcrumb: breadcrumb, children: children, autoFocus: autoFocus = false, ...rest }) {
    const hasMeta = sub || breadcrumb;
    const titleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!autoFocus) return;
        // `preventScroll`: the heading is already at the top of the page, and
        // scrolling on focus would fight the route change's own scroll reset.
        titleRef.current?.focus({
            preventScroll: true
        });
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: hasMeta ? '14px 32px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            minHeight: 64,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 3
        }
    }, breadcrumb), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: titleRef,
        // -1: reachable by script, never a stop in the tab order. A heading
        // that took a Tab of its own would be a new obstacle on every page.
        tabIndex: autoFocus ? -1 : undefined,
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: 18,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.2,
            outline: 'none'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, sub)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, children));
}

});

parcelRegister("jOGbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c79ee8367a72d83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $3c79ee8367a72d83$export$2e2bcd8739ae039({ onBack: onBack, backLabel: backLabel, title: title, sub: sub, avatar: avatar, status: status, badges: badges, meta: meta, stats: stats, children: children, className: className, 'data-testid': testId, ...rest }) {
    if (backLabel === undefined) backLabel = (0, $j9AxR.kitCopy)().back;
    const metaItems = (meta || []).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        },
        ...rest
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": testId ? `${testId}-back` : undefined,
        className: "shrink-0 gap-1.5 ps-2 pe-3 text-muted-foreground hover:text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flex: 1,
            minWidth: 0
        }
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        dir: "auto",
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), status, badges), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.1875rem'
        }
    }, sub), metaItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, metaItems.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: 3,
                height: 3,
                borderRadius: '50%',
                background: (0, $jTCZr.C).textMuted,
                opacity: 0.6,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, m)))))), (stats?.length || children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        }
    }, stats?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5625rem'
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                minWidth: '4.5rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.375rem',
                borderRadius: 'var(--radius, 0.625rem)',
                textAlign: 'center',
                background: s.accent ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.C).bg,
                border: `1px solid ${s.accent ? 'transparent' : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 600,
                marginBottom: '0.0625rem',
                color: s.accent ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textMuted
            }
        }, s.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 800,
                letterSpacing: '-0.01em',
                color: s.accent ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textPrimary,
                fontVariantNumeric: 'tabular-nums'
            }
        }, s.value)))), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, children)));
}

});
parcelRegister("d8YVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a140ead2dcbdb51$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2a140ead2dcbdb51$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $2a140ead2dcbdb51$export$2e2bcd8739ae039 = (0, $9QBug.default)("arrow-right", $2a140ead2dcbdb51$export$3efd853dbb351e94);

});


parcelRegister("9TQrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca91b548719491bb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
const $ca91b548719491bb$var$TopBar = ({ title: title, subtitle: subtitle, onBack: onBack, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).navy,
            padding: '16px 20px 20px',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onBack,
        style: {
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: 10,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'white',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'white',
            fontSize: 18,
            fontWeight: 700
        }
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: 12,
            marginTop: 2
        }
    }, subtitle))), action));
var $ca91b548719491bb$export$2e2bcd8739ae039 = $ca91b548719491bb$var$TopBar;

});

parcelRegister("dSwFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f4a9fc87ba90f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");
var $gKFEi = parcelRequire("gKFEi");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");

var $7wZCE = parcelRequire("7wZCE");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");

var $aM2JY = parcelRequire("aM2JY");
'use client';
/**
 * MobileHeader — the gradient screen header that is the mobile brand signature
 * (DESIGN-CONCEPT-MOBILE §3.2). Every top-level mobile screen opens with it.
 *
 * Two modes, chosen by the props you pass — never a mode flag:
 *
 *   • **Cockpit** (`user`) — the person's name as a *greeting*, not chrome:
 *     avatar + «خوش آمدید،» + name on the inline-start edge. What a top-level
 *     bottom-nav destination uses.
 *   • **Content screen** (`onBack` + `title`) — a drilled-into full-screen
 *     surface has no bottom nav, so the header itself carries the way back:
 *     back affordance above the screen title, on the same brand chrome rather
 *     than in a separate bar above it (§3.1).
 *   • **Compact** (`compact`) — one 3.75rem row for a WORKSPACE screen, where
 *     the chrome competes with the work (the visit room): icon-only back,
 *     the title and `subtitle` as two short lines beside an optional `avatar`,
 *     then `action`, then `actions`. The title shrinks a step at a time
 *     (0.9375 → 0.75rem) before it ellipsises, so a long name is read rather
 *     than cut. `onTitleClick` makes the identity block a button — the name IS
 *     the way into the record — and `titleActionLabel` says so under it.
 *
 * Both modes render `title` as the page's single `<h1>` (§12.1) and accept
 * `actions` — white-alpha square quick actions ≥2.75rem, the sanctioned way to
 * tint on-gradient chrome (§2.2). A control that navigates nowhere is a defect,
 * so a caller passes an action only when its destination exists.
 *
 * `children` is the optional context-widget row (a date navigator, a filter
 * strip) rendered inside the gradient below the identity row.
 *
 * Props:
 *   title      — screen title; rendered as the page's <h1>
 *   subtitle   — optional line under the title
 *   greeting   — cockpit lead-in above the name (default «خوش آمدید،»)
 *   user       — { name, avatar } → cockpit greeting mode
 *   onBack     — back handler → content mode; renders the «بازگشت» affordance
 *   backLabel  — label for the back affordance (default «بازگشت»)
 *   actions    — [{ key, icon, label, onClick, badge? }] end-side quick actions;
 *                `badge` = { color } renders a small status dot
 *   action     — a single trailing node (shorthand; rendered after `actions`;
 *                in compact mode BEFORE them, so a live control such as the
 *                visit's listen pill sits next to the identity, and «⋯» last)
 *   compact    — the one-row workspace layout (see above)
 *   figures    — compact only (PM-0120): [{ key, value, label, color? }] rendered
 *                as ONE inline row of figures under the identity row, on the
 *                gradient (`DayStatStrip onDark`) — the place a content screen
 *                used to spend four stat tiles and ~200 px on. Hidden when every
 *                value is null and nothing is loading: a row of «–» is not a
 *                glance. `figuresLoading`, `figuresFormat`, `figuresLabel` and
 *                `figuresTestIdPrefix` (→ `<prefix>-stats`) are the strip's own.
 *   avatar     — compact only: `{ name, src }` → a 2rem avatar before the title
 *   leading    — compact only: one node right after the back affordance, in
 *                the header's top inline-START corner (the visit's event bell).
 *                It renders nothing when it has nothing to say, so the slot
 *                costs the title no width until then.
 *   onTitleClick / titleActionLabel — compact only: make the identity block a
 *                button and name its destination under the title
 *   backTestId — override for the back control's `data-testid`. Defaults to
 *                `${testId}-back`; a screen whose selector contract already
 *                names its own back control passes it here rather than
 *                renaming the whole header (which is what an app fork did).
 *   sticky     — pin the header to the top of its scroller. A list destination
 *                whose filter bar lives in `children` needs the bar to stay
 *                reachable while the list scrolls under it (§3.2).
 *   search     — `{ value, onChange, placeholder, clearLabel, onClear, onSubmit,
 *                autoFocus, testId }`. Renders the on-gradient search field that a lookup
 *                screen opens into: a real `<input>` at ≥2.75rem with an inline
 *                clear control, sitting above `children`. Passing it is what
 *                turns a 🔍 quick action into a search surface, so no screen
 *                hand-rolls a white field on the brand chrome again.
 *   children   — optional context-widget row
 *   className / data-testid — forwarded to the root (§15.1)
 */ function $62f4a9fc87ba90f8$var$QuickActions({ actions: actions, testId: testId }) {
    if (!actions?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, actions.map(({ key: key, icon: icon, label: label, onClick: onClick, badge: badge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "data-testid": testId ? `${testId}-action-${key}` : undefined,
            className: "min-w-11 min-h-11 text-white hover:bg-white/25",
            style: {
                background: 'rgba(255,255,255,0.14)',
                borderRadius: 'var(--radius, 0.625rem)'
            }
        }, icon), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                position: 'absolute',
                top: '0.25rem',
                insetInlineEnd: '0.25rem',
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: badge.color,
                border: '1.5px solid rgba(1,94,156,0.9)'
            }
        }))));
}
// The compact title: tries each size in turn and keeps the largest at which
// the text still fits its box, then ellipsises. A patient's full name is the
// one thing on a visit header that must be READ, and a phone gives it ~9rem.
const $62f4a9fc87ba90f8$var$TITLE_SIZES = [
    '0.9375rem',
    '0.875rem',
    '0.8125rem',
    '0.75rem'
];
function $62f4a9fc87ba90f8$var$FitTitle({ children: children, testId: testId }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [step, setStep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const fit = ()=>{
            let k = 0;
            el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[0];
            while(k < $62f4a9fc87ba90f8$var$TITLE_SIZES.length - 1 && el.scrollWidth > el.clientWidth + 1){
                k += 1;
                el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[k];
            }
            setStep(k);
        };
        fit();
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
        ro?.observe(el.parentElement || el);
        return ()=>ro?.disconnect();
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: ref,
        dir: "auto",
        "data-testid": testId,
        style: {
            margin: 0,
            minWidth: 0,
            color: '#fff',
            fontWeight: 700,
            lineHeight: 1.25,
            fontSize: $62f4a9fc87ba90f8$var$TITLE_SIZES[step],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, children);
}
function $62f4a9fc87ba90f8$var$CompactIdentity({ title: title, subtitle: subtitle, avatar: avatar, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, testId: testId }) {
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: avatar.name || title || (0, $j9AxR.kitCopy)().mobileHeader.unknownInitial,
        size: 32,
        bg: "rgba(255,255,255,0.2)",
        src: avatar.src || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            gap: '0.0625rem',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$FitTitle, {
        testId: `${testId}-title`
    }, title), (subtitle || onTitleClick && titleActionLabel) && /* One run of inline text, so a narrow slot ellipsises the whole line
             instead of clipping the hint. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            fontSize: '0.6875rem',
            lineHeight: 1.3,
            color: 'rgba(255,255,255,0.72)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, subtitle, subtitle && onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, " \xb7 "), onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 600
        }
    }, titleActionLabel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
        size: 11,
        "aria-hidden": true,
        style: {
            display: 'inline-block',
            verticalAlign: '-0.125em',
            marginInlineStart: '0.125rem',
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    })))));
    const layout = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        minWidth: 0,
        flex: 1,
        minHeight: '2.75rem'
    };
    if (!onTitleClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: layout
    }, body);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onTitleClick,
        "aria-label": titleActionLabel ? `${titleActionLabel} \u{2014} ${title}` : title,
        "data-testid": `${testId}-identity`,
        className: "rounded-lg hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
        style: {
            ...layout,
            background: 'transparent',
            border: 0,
            padding: '0 0.25rem',
            color: '#fff',
            cursor: 'pointer',
            font: 'inherit'
        }
    }, body);
}
function $62f4a9fc87ba90f8$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, greeting: greeting, user: user, onBack: onBack, backLabel: backLabel, actions: actions = [], action: action, compact: compact = false, figures: figures, figuresLoading: figuresLoading = false, figuresFormat: figuresFormat, figuresLabel: figuresLabel, figuresTestIdPrefix: figuresTestIdPrefix = 'header', avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, backTestId: backTestId, sticky: sticky = false, search: search, children: children, className: className, style: style, 'data-testid': testId = 'mobile-header', ...rest }) {
    if (greeting === undefined) greeting = (0, $j9AxR.kitCopy)().mobileHeader.greeting;
    if (backLabel === undefined) backLabel = (0, $j9AxR.kitCopy)().back;
    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        "data-compact": "",
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            padding: 'calc(0.5rem + env(safe-area-inset-top, 0px)) 0.75rem 0.5rem',
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-2.5rem',
            insetInlineEnd: '-1.875rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            minHeight: '2.75rem'
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 20,
        "aria-hidden": true
    })), leading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$CompactIdentity, {
        title: title,
        subtitle: subtitle,
        avatar: avatar,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        testId: testId
    }), action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    })), figures && (figuresLoading || figures.some((f)=>f.value != null)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aM2JY.default), {
        onDark: true,
        items: figures,
        loading: figuresLoading,
        format: figuresFormat,
        ariaLabel: figuresLabel,
        testIdPrefix: figuresTestIdPrefix,
        style: {
            marginTop: '0.125rem',
            minHeight: '2rem'
        }
    }), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem'
        }
    }, children));
    const hasTrailing = actions.length > 0 || Boolean(action);
    const trailing = hasTrailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    }), action);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 1.5rem',
            // `sticky` keeps the filter bar in `children` reachable while a long
            // list scrolls under it; `relative` is the default so the decorative
            // circles below still clip to the header.
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            // A caller's `style` is MERGED OVER the computed layout, the convention
            // the rest of the kit follows (`Card`, the chat family). It used to fall
            // into `...rest` and — because the spread sits after this attribute —
            // REPLACE the whole object: passing `style` for so much as a
            // `position: sticky` silently deleted the brand gradient, the padding
            // and the safe-area inset, and left white text on a white page.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-1.875rem',
            insetInlineEnd: '-1.875rem',
            width: '8.75rem',
            height: '8.75rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            bottom: '-1.25rem',
            insetInlineStart: '-0.625rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, onBack ? /* Content mode — the way back lives on the brand chrome (§3.1). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "h-auto min-h-11 gap-1.5 ps-0 pe-2 text-white/85 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0.25rem 0 0',
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)) : /* Cockpit mode — greeting (or a bare title) + quick actions (§3.2). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (user || hasTrailing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: user.name || (0, $j9AxR.kitCopy)().mobileHeader.unknownInitial,
        size: 40,
        bg: "rgba(255,255,255,0.2)",
        src: user.avatar || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.6875rem'
        }
    }, greeting), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            color: '#fff',
            fontSize: '0.9375rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, user.name || "\u2026"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: user || hasTrailing ? '0.75rem 0 0' : 0,
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    }, subtitle), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, children)));
}
/**
 * The on-gradient search field (§3.2). A real `<input>` — not a kit `TextInput`
 * — because the kit field is painted for a white surface and this one sits on
 * the brand chrome; the shared contract it does keep is the 2.75rem height, the
 * ≥1rem font (anything smaller triggers iOS focus-zoom) and a clear control.
 */ function $62f4a9fc87ba90f8$var$SearchField({ value: value = '', onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, clearLabel: clearLabel, autoFocus: autoFocus = false, testId: testId, headerTestId: headerTestId }) {
    if (clearLabel === undefined) clearLabel = (0, $j9AxR.kitCopy)().mobileHeader.clear;
    const id = testId || `${headerTestId}-search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            marginTop: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            borderRadius: (0, $jTCZr.RADIUS).control,
            paddingInline: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 17,
        color: "rgba(255,255,255,0.75)",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        inputMode: "search",
        enterKeyHint: "search",
        autoFocus: autoFocus,
        value: value,
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: placeholder,
        "data-testid": id,
        style: {
            flex: 1,
            minWidth: 0,
            height: '2.75rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: '#fff',
            // ≥1rem or iOS zooms the whole page on focus and never zooms back.
            fontSize: '1rem',
            fontFamily: 'inherit'
        }
    }), value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>onClear?.(),
        "aria-label": clearLabel,
        "data-testid": `${id}-clear`,
        className: "min-w-11 min-h-11 text-white/80 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    })) : null);
}

});
parcelRegister("gKFEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b40836209aae972$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2b40836209aae972$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $2b40836209aae972$export$2e2bcd8739ae039 = (0, $9QBug.default)("chevron-left", $2b40836209aae972$export$3efd853dbb351e94);

});

parcelRegister("e5Ore", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b4d9519dd12f8d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $30b4d9519dd12f8d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $30b4d9519dd12f8d$export$2e2bcd8739ae039 = (0, $9QBug.default)("search", $30b4d9519dd12f8d$export$3efd853dbb351e94);

});

parcelRegister("6TdpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b6a18bc128c0629$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4b6a18bc128c0629$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $4b6a18bc128c0629$export$2e2bcd8739ae039 = (0, $9QBug.default)("x", $4b6a18bc128c0629$export$3efd853dbb351e94);

});

parcelRegister("aM2JY", function(module, exports) {

$parcel$export(module.exports, "default", () => $93cce909f7881164$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayStatStrip — a day's figures as ONE row: the mobile KPI zone of a
// LIST-DOMINANT cockpit (MOBILE_WEB_PWA §4, `StatStrip`), where the list is the
// screen's purpose and the counts only frame it. It replaces 4-up tiles, which
// cost ~100px above the first row.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»                       [end]
//
// Each number carries its semantic ink. A count that has not loaded is «–»,
// never 0 — a zero is a claim. Below 360px the words go and the coloured
// numbers stay; the row keeps a sentence for assistive tech either way.
//
// With `onSelect` each figure is also the FILTER it counts (aria-pressed): the
// clinic desk's status chips and its counts were two rows saying the same
// numbers, and are one here. Without it the row only reads.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3), PM-0052.
//
// Props:
//   items      — [{ key, value (number|null), label, color? }]
//   loading    — every value reads «–»
//   format     — (n) => string; the caller's digits (default: String)
//   ariaLabel  — the row read as one sentence
//   activeKey / onSelect(key) — makes the figures toggle filters
//   end        — optional trailing node (a money figure, a link)
//   testIdPrefix — default 'reception' → `reception-stats`, `reception-stat-<key>`
//   onDark     — the strip on brand chrome (MobileHeader `figures`, PM-0120): white
//                ink, no surface, no rule — the gradient is the background
// ─────────────────────────────────────────────────────────────────────────────
const $93cce909f7881164$var$useNarrow = ()=>{
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 360);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const onResize = ()=>setNarrow(window.innerWidth < 360);
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return narrow;
};
function $93cce909f7881164$export$2e2bcd8739ae039({ items: items, loading: loading = false, format: format = (n)=>String(n), ariaLabel: ariaLabel, activeKey: activeKey, onSelect: onSelect, end: end, testIdPrefix: testIdPrefix = 'reception', onDark: onDark = false, style: style }) {
    const narrow = $93cce909f7881164$var$useNarrow();
    const p = testIdPrefix;
    const n = (v)=>loading || v == null ? "\u2013" : format(v);
    const interactive = typeof onSelect === 'function';
    const figure = (it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 800,
                color: onDark ? 'rgba(255,255,255,0.95)' : it.color || (0, $jTCZr.C).textPrimary
            }
        }, n(it.value)), !narrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 500,
                color: onDark ? 'rgba(255,255,255,0.72)' : (0, $jTCZr.C).textSecondary,
                marginInlineStart: '0.1875rem'
            }
        }, it.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-stats`,
        style: {
            flexShrink: 0,
            minHeight: interactive ? '2.75rem' : '2.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: onDark ? 0 : '0 0.875rem',
            background: onDark ? 'transparent' : (0, $jTCZr.C).bg,
            borderBottom: onDark ? 'none' : `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": ariaLabel,
        className: "mobile-strip",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: interactive ? 'center' : 'baseline',
            gap: interactive ? 0 : '0.375rem',
            overflowX: interactive ? 'auto' : 'hidden',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none'
        }
    }, items.map((it, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: it.key
        }, i > 0 && !interactive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                color: onDark ? 'rgba(255,255,255,0.4)' : (0, $jTCZr.C).textMuted,
                fontSize: '0.75rem'
            }
        }, "\xb7"), interactive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            "data-testid": `${p}-stat-${it.key}`,
            "aria-pressed": activeKey === it.key,
            "aria-label": `${it.label} ${n(it.value)}`,
            onClick: ()=>onSelect(it.key),
            className: "h-auto min-h-9 shrink-0 rounded-full px-1.5 py-0 font-normal",
            style: {
                fontSize: '0.78125rem',
                background: activeKey === it.key ? (0, $jTCZr.soft)(it.color || (0, $jTCZr.C).navy, 0.14) : 'transparent',
                boxShadow: activeKey === it.key ? `inset 0 0 0 1px ${(0, $jTCZr.soft)(it.color || (0, $jTCZr.C).navy, 0.45)}` : 'none'
            }
        }, figure(it)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${p}-stat-${it.key}`,
            "aria-hidden": true,
            style: {
                fontSize: '0.78125rem'
            }
        }, figure(it))))), end ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, end) : null);
}

});


parcelRegister("hU4vR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd7f5e3d401ab69$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $2WFPf = parcelRequire("2WFPf");
var $kzPvP = parcelRequire("kzPvP");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayContextCard — the context row of a LIST-DOMINANT cockpit's gradient
// header (MOBILE_WEB_PWA §3.2): one white-alpha inset card answering "what am
// I looking at", in two rows.
//
//   line     — the lens: WHERE / WHOSE list this is. The doctor's پذیرش says
//              where the presence schedule puts them («اکنون در کلینیک مهر ·
//              تا ۱۴:۰۰»); the clinic's says whose queue the desk is working
//              («دکتر رضایی · تزریق»). With a choice to make it is the trigger
//              for the caller's picker (`onOpen`); without one it only informs
//              — absent, never disabled.
//   date bar — ‹ day › with the label opening the week sheet. It replaces a
//              navigator + week strip stack that cost ~130px of a phone.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.2) when
// the clinic's phone reception was rebuilt on the same anatomy (PM-0052). The
// card renders; it decides nothing: the sentence, the icon and the picker are
// the caller's.
//
// Props:
//   line        — null | {
//                   icon      lucide component
//                   text      the sentence (already formatted)
//                   hint      optional second, smaller line
//                   pill      optional trailing chip (the lens as it stands)
//                   tone      'warn' | 'muted' | undefined
//                   state     forwarded as data-place-state (tests, styling)
//                   onOpen    makes the row a button that opens a picker
//                   openLabel the button's accessible name
//                   ariaLabel the live region's label (live lines only)
//                   live      announce changes politely (a schedule boundary
//                             flips the sentence once, so it is said once)
//                 }
//   action      — optional node at the END of the lens row, outside its button
//                 (the clinic desk's registry search). On-gradient, ≥2.75rem.
//   dateLabel / isToday / onPrev / onNext / onToday / onOpenWeek
//   labels      — { prevDay, nextDay, today, backToToday, pickDay } (kitCopy defaults)
//   testIdPrefix — default 'reception' → `reception-context`, `-place`,
//                  `-place-open`, `-place-lens`, `-place-hint`, `-datenav`,
//                  `-datenav-prev|pick|today|next`
// ─────────────────────────────────────────────────────────────────────────────
const $9dd7f5e3d401ab69$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $9dd7f5e3d401ab69$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $9dd7f5e3d401ab69$var$rowBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    flex: 1,
    minWidth: 0,
    minHeight: '2.75rem',
    padding: '0 0.625rem',
    color: '#fff',
    textAlign: 'start'
};
function $9dd7f5e3d401ab69$export$2e2bcd8739ae039({ line: line, action: action, dateLabel: dateLabel, isToday: isToday, onPrev: onPrev, onNext: onNext, onToday: onToday, onOpenWeek: onOpenWeek, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception', style: style }) {
    const copy = {
        ...(0, $j9AxR.kitCopy)(locale).dayContext,
        ...labels
    };
    const p = testIdPrefix;
    const Icon = line?.icon;
    const warn = line?.tone === 'warn';
    const muted = line?.tone === 'muted';
    const lineBody = line && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: warn ? (0, $jTCZr.C).amberLight : '#fff',
            opacity: muted ? 0.7 : 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: '0.78125rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: muted ? 0.8 : 1
        }
    }, line.text), line.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-hint`,
        style: {
            display: 'block',
            fontSize: '0.65625rem',
            fontWeight: 500,
            color: 'rgba(255,255,255,0.7)'
        }
    }, line.hint)), line.pill && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-lens`,
        style: {
            flexShrink: 0,
            maxWidth: '40%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.2)'
        }
    }, line.pill), line.onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.75
        }
    }));
    const liveProps = line?.live ? {
        role: 'status',
        'aria-live': 'polite',
        'aria-label': line.ariaLabel ? `${line.ariaLabel}: ${line.text}` : undefined
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-context`,
        style: {
            background: 'rgba(255,255,255,0.12)',
            borderRadius: '0.75rem',
            overflow: 'hidden',
            ...style
        }
    }, line && line.text != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...liveProps,
        "data-testid": `${p}-place`,
        "data-place-state": line.state,
        style: {
            borderBottom: '1px solid rgba(255,255,255,0.14)',
            ...action ? {
                display: 'flex',
                alignItems: 'center'
            } : null
        }
    }, line.onOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        "data-testid": `${p}-place-open`,
        "aria-haspopup": "dialog",
        "aria-label": line.openLabel,
        className: "h-auto justify-start rounded-none font-normal hover:bg-white/10",
        style: $9dd7f5e3d401ab69$var$rowBase,
        onClick: line.onOpen
    }, lineBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9dd7f5e3d401ab69$var$rowBase,
            minHeight: action ? '2.75rem' : '2.25rem',
            paddingBlock: '0.375rem'
        }
    }, lineBody), action ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            paddingInlineEnd: '0.25rem'
        }
    }, action) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-datenav`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-prev`,
        "aria-label": copy.prevDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-pick`,
        "aria-label": onOpenWeek ? `${dateLabel} \u{2014} ${copy.pickDay}` : undefined,
        "aria-haspopup": onOpenWeek ? 'dialog' : undefined,
        className: "h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15",
        onClick: onOpenWeek
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 14,
        style: {
            opacity: 0.75
        },
        "aria-hidden": true
    }), dateLabel), isToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.24)',
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, copy.today) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-today`,
        className: "h-auto min-h-8 px-2 py-0.5 text-[0.65625rem] font-bold text-white whitespace-nowrap rounded-full hover:bg-white/25",
        style: {
            background: 'rgba(255,255,255,0.18)'
        },
        onClick: onToday
    }, copy.backToToday)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-next`,
        "aria-label": copy.nextDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$NEXT_GLYPH
    }))));
}

});
parcelRegister("6Md3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b56343e65588121$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5b56343e65588121$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
];
const $5b56343e65588121$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar-days", $5b56343e65588121$export$3efd853dbb351e94);

});

parcelRegister("2WFPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc4be5d9d5a360aa$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dc4be5d9d5a360aa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $dc4be5d9d5a360aa$export$2e2bcd8739ae039 = (0, $9QBug.default)("chevron-down", $dc4be5d9d5a360aa$export$3efd853dbb351e94);

});

parcelRegister("kzPvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8dd034124f4eb9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9c8dd034124f4eb9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $9c8dd034124f4eb9$export$2e2bcd8739ae039 = (0, $9QBug.default)("chevron-right", $9c8dd034124f4eb9$export$3efd853dbb351e94);

});


parcelRegister("300tQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d011a6fde34c03$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $kzPvP = parcelRequire("kzPvP");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $4Qco3 = parcelRequire("4Qco3");

var $j9AxR = parcelRequire("j9AxR");

var $hlTfq = parcelRequire("hlTfq");

var $2vdhF = parcelRequire("2vdhF");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// WeekPickerSheet — week browsing in a bottom sheet, opened from a day bar's
// label (`DayContextCard`). A seven-chip week strip answers a question asked a
// few times a day and costs ~64px on every screen load; the sheet costs none.
//
// Weeks are Jalali, Saturday → Friday, over Iran-local ISO dates, and the sheet
// opens on the week holding the selected day. Each row says what the day holds:
// the caller's `describeDay` line (the doctor: where the schedule puts them)
// and the count of appointments — `·` not counted yet, `—` counted and empty.
// A row described as `off` is muted but still tappable. Picking a day only
// calls `onPick(iso)` — the sheet never navigates.
//
// «تقویم کامل» swaps the body for the month grid (one sheet, two views — no
// stacked sheets) for far jumps.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.4), PM-0052.
//
// Props:
//   open / onClose / selISO / todayISO / onPick(iso)
//   useWeekCounts — a HOOK `(weekStartISO, { enabled }) => [{ iso, count|null }]`
//                   called on every render (pass a stable function); omit it
//                   and the count column stays blank
//   describeDay   — optional `(iso) => null | { text, aria?, off? }`
//   fmt           — { weekday(ms), dayMonth(ms), weekdayDayMonth(ms), number(n) };
//                   defaults use Intl with the Persian calendar
//   labels        — overrides for kitCopy().weekPicker
//   testIdPrefix  — default 'reception' → `reception-week-sheet`, `-week-<iso>`, …
// ─────────────────────────────────────────────────────────────────────────────
const $b3d011a6fde34c03$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $b3d011a6fde34c03$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $b3d011a6fde34c03$var$noCounts = ()=>null;
function $b3d011a6fde34c03$var$defaultFmt(locale) {
    const tag = `${locale || 'fa'}-IR-u-ca-persian`;
    const make = (opts)=>{
        try {
            const f = new Intl.DateTimeFormat(tag, {
                timeZone: 'UTC',
                ...opts
            });
            return (ms)=>f.format(ms);
        } catch  {
            return (ms)=>new Date(ms).toISOString().split('T')[0];
        }
    };
    const nf = (()=>{
        try {
            return new Intl.NumberFormat(tag);
        } catch  {
            return null;
        }
    })();
    return {
        weekday: make({
            weekday: 'long'
        }),
        dayMonth: make({
            day: 'numeric',
            month: 'long'
        }),
        weekdayDayMonth: make({
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }),
        number: (n)=>nf ? nf.format(n) : String(n)
    };
}
function $b3d011a6fde34c03$export$2e2bcd8739ae039({ open: open, onClose: onClose, selISO: selISO, todayISO: todayISO, onPick: onPick, useWeekCounts: useWeekCounts = $b3d011a6fde34c03$var$noCounts, describeDay: describeDay, fmt: fmtProp, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception' }) {
    const loc = locale || (0, $hlTfq.documentLocale)();
    const copy = {
        ...(0, $j9AxR.kitCopy)(loc).weekPicker,
        ...labels
    };
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            ...$b3d011a6fde34c03$var$defaultFmt(loc),
            ...fmtProp
        }), [
        loc,
        fmtProp
    ]);
    const p = testIdPrefix;
    const [weekStart, setWeekStart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $2vdhF.jalaliWeekStart)(selISO));
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('week');
    // Every opening starts on the selected day's week, in the week view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setWeekStart((0, $2vdhF.jalaliWeekStart)(selISO));
            setView('week');
        }
    }, [
        open,
        selISO
    ]);
    const days = useWeekCounts(weekStart, {
        enabled: open
    }) || [];
    const countOf = new Map(days.map((d)=>[
            d.iso,
            d.count
        ]));
    const thisWeek = (0, $2vdhF.jalaliWeekStart)(todayISO);
    const isoDays = (0, $2vdhF.weekDaysFrom)(weekStart);
    const range = copy.range(fmt.dayMonth((0, $2vdhF.isoNoonMs)(isoDays[0])), fmt.dayMonth((0, $2vdhF.isoNoonMs)(isoDays[6])));
    const pick = (iso)=>{
        onClose();
        if (iso) onPick(iso);
    };
    const quick = [
        {
            key: 'this',
            label: copy.thisWeek,
            start: thisWeek
        },
        {
            key: 'next',
            label: copy.nextWeek,
            start: (0, $2vdhF.shiftISO)(thisWeek, 7)
        },
        {
            key: 'prev',
            label: copy.prevWeek,
            start: (0, $2vdhF.shiftISO)(thisWeek, -7)
        }
    ];
    const footer = view === 'week' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        "data-testid": `${p}-week-calendar`,
        className: "w-full min-h-11 gap-2",
        onClick: ()=>setView('month')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 16,
        "aria-hidden": true
    }), copy.fullCalendar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        "data-testid": `${p}-week-back`,
        className: "w-full min-h-11",
        onClick: ()=>setView('week')
    }, copy.backToWeek);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: copy.title,
        closeLabel: copy.close,
        footer: footer,
        "data-testid": `${p}-week-sheet`
    }, view === 'month' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.JalaliCalendar), {
        value: selISO,
        onChange: (v)=>pick(v)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, quick.map((q)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: q.key,
            variant: weekStart === q.start ? 'default' : 'outline',
            size: "sm",
            "aria-pressed": weekStart === q.start,
            "data-testid": `${p}-week-quick-${q.key}`,
            className: "min-h-9 rounded-full",
            onClick: ()=>setWeekStart(q.start)
        }, q.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-prev`,
        "aria-label": copy.prevWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $2vdhF.shiftISO)(s, -7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-week-range`,
        style: {
            flex: 1,
            textAlign: 'center',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, range), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-next`,
        "aria-label": copy.nextWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $2vdhF.shiftISO)(s, 7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, isoDays.map((iso)=>{
        const ms = (0, $2vdhF.isoNoonMs)(iso);
        const desc = describeDay ? describeDay(iso) : null;
        const count = countOf.get(iso);
        const selected = iso === selISO;
        const today = iso === todayISO;
        const off = Boolean(desc?.off);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: iso,
            variant: "ghost",
            "data-testid": `${p}-week-${iso}`,
            "aria-current": selected ? 'date' : undefined,
            "aria-label": [
                fmt.weekdayDayMonth(ms),
                desc?.aria || (desc?.text && desc.text !== "\u2014" ? desc.text : null),
                count != null ? copy.countAria(fmt.number(count)) : null
            ].filter(Boolean).join(" \xb7 "),
            className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-none px-2 py-1.5 font-normal",
            style: {
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                textAlign: 'start'
            },
            onClick: ()=>pick(iso)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '4.5rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.8125rem',
                fontWeight: selected ? 800 : 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, fmt.weekday(ms)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, fmt.dayMonth(ms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                color: off ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textSecondary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, desc?.text || ''), today && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flexShrink: 0,
                fontSize: '0.625rem',
                fontWeight: 700,
                borderRadius: '1rem',
                padding: '0.0625rem 0.4375rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                color: (0, $jTCZr.C).navy
            }
        }, copy.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: '1.75rem',
                flexShrink: 0,
                textAlign: 'center',
                fontSize: '0.875rem',
                fontWeight: 800,
                color: count ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted
            }
        }, count == null ? useWeekCounts === $b3d011a6fde34c03$var$noCounts ? '' : "\xb7" : count === 0 ? "\u2014" : fmt.number(count)));
    }))));
}

});
parcelRegister("4Qco3", function(module, exports) {

$parcel$export(module.exports, "JalaliCalendar", () => $d9dd19094c9f758e$export$9c97d98ce20c6c7a);
$parcel$export(module.exports, "default", () => $d9dd19094c9f758e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $IZwml = parcelRequire("IZwml");
'use client';
// Everything the picker SHOWS — calendar, digits, month and weekday names, its own
// labels and its error messages — follows the page language (`<html lang>`, or the
// `locale` prop), from the table in lib/datePickerLocale.js. Under `en` that means a
// Gregorian, left-to-right calendar; under `fa` and `ar`, the Jalali one. `value` is
// Gregorian 'YYYY-MM-DD' in every language, so no caller changes with the language.
const $d9dd19094c9f758e$var$FA_DIGITS = (0, $IZwml.DATE_PICKER_LOCALES).fa.digits;
const $d9dd19094c9f758e$var$pad2 = (n)=>String(n).padStart(2, '0');
// ── Jalali math (works for years 1300–1500) ───────────────────────────────────
function $d9dd19094c9f758e$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $d9dd19094c9f758e$var$jMonthDays(y, m) {
    if (m <= 6) return 31;
    if (m <= 11) return 30;
    return $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29;
}
// Anchor: 1400/01/01 = 2021-03-21 UTC. Works backward too.
function $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21);
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(jy) ? 30 : 29
    ];
    let doy = jd - 1;
    for(let i = 0; i < jm - 1; i++)doy += md[i];
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    return anchor + (days + doy) * 86400000;
}
function $d9dd19094c9f758e$var$msToJalali(ms) {
    const anchor = Date.UTC(2021, 2, 21);
    let days = Math.floor((ms - anchor) / 86400000);
    let y = 1400;
    if (days >= 0) while(true){
        const diy = $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    else while(days < 0){
        y--;
        days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(m < 11 && days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
// ── The two calendars ─────────────────────────────────────────────────────────
// One shape, so the grids, the parser and the disableFuture rules below exist once
// and never ask which calendar they are drawing. Dates are `{ y, m, d }` with a
// 1-based month; `toMs`/`fromMs` read the day at UTC midnight.
const $d9dd19094c9f758e$var$JALALI = {
    id: 'jalali',
    firstYear: 1300,
    lastYear: 1500,
    weekStart: 6,
    monthDays: $d9dd19094c9f758e$var$jMonthDays,
    toMs: $d9dd19094c9f758e$var$jalaliToMs,
    fromMs: $d9dd19094c9f758e$var$msToJalali
};
const $d9dd19094c9f758e$var$GREGORIAN = {
    id: 'gregorian',
    firstYear: 1921,
    lastYear: 2121,
    weekStart: null,
    monthDays: (y, m)=>new Date(Date.UTC(y, m, 0)).getUTCDate(),
    toMs: (y, m, d)=>Date.UTC(y, m - 1, d),
    fromMs: (ms)=>{
        const t = new Date(ms);
        return {
            y: t.getUTCFullYear(),
            m: t.getUTCMonth() + 1,
            d: t.getUTCDate()
        };
    }
};
const $d9dd19094c9f758e$var$CALENDARS = {
    jalali: $d9dd19094c9f758e$var$JALALI,
    gregorian: $d9dd19094c9f758e$var$GREGORIAN
};
const $d9dd19094c9f758e$var$calendarOf = (id)=>$d9dd19094c9f758e$var$CALENDARS[id] || $d9dd19094c9f758e$var$JALALI;
const $d9dd19094c9f758e$var$todayIn = (cal)=>cal.fromMs(Date.now());
// 'YYYY-MM-DD' → the same day in `cal`.
function $d9dd19094c9f758e$var$valueToDate(cal, str) {
    if (!str || str.length < 10) return null;
    const [y, m, d] = str.split('-').map(Number);
    if (!y || !m || !d) return null;
    return cal.fromMs(Date.UTC(y, m - 1, d));
}
// A day in `cal` → 'YYYY-MM-DD'.
function $d9dd19094c9f758e$var$dateToValue(cal, y, m, d) {
    const dt = new Date(cal.toMs(y, m, d));
    return [
        dt.getUTCFullYear(),
        String(dt.getUTCMonth() + 1).padStart(2, '0'),
        String(dt.getUTCDate()).padStart(2, '0')
    ].join('-');
}
// The locale's data plus the calendar it resolves to — `calendar` pins one.
function $d9dd19094c9f758e$var$resolvePicker(locale, calendar) {
    const L = (0, $IZwml.datePickerLocale)(locale);
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar || L.calendar);
    return {
        L: L,
        cal: cal,
        months: L.months[cal.id],
        weekStart: cal.weekStart ?? L.weekStart,
        num: (n)=>(0, $IZwml.withDigits)(n, L.digits)
    };
}
function $d9dd19094c9f758e$export$565a3e0423f3fda3(value) {
    const s = String(value || '').trim();
    if (!s) return {
        date: '',
        time: ''
    };
    const [date, rest = ''] = s.split(/[T\s]+/);
    const t = rest.match(/^(\d{1,2}):(\d{1,2})/);
    return {
        date: date,
        time: t ? `${$d9dd19094c9f758e$var$pad2(+t[1])}:${$d9dd19094c9f758e$var$pad2(+t[2])}` : ''
    };
}
function $d9dd19094c9f758e$export$26bc4d93216d514d(raw, { withTime: withTime = false, disableFuture: disableFuture = false, calendar: calendar = 'jalali' } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const s = (0, $5JYPc.toEnDigits)(raw ?? '').replace(/[،,]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return {
        empty: true
    };
    const m = s.match(/^(\d{4})\s*[/\-.]\s*(\d{1,2})\s*[/\-.]\s*(\d{1,2})(?:[ T]+(\d{1,2})\s*[:.]\s*(\d{1,2}))?$/);
    if (!m) return {
        error: 'format'
    };
    const y = +m[1], mo = +m[2], d = +m[3];
    if (y < cal.firstYear || y > cal.lastYear) return {
        error: 'range'
    };
    if (mo < 1 || mo > 12) return {
        error: 'range'
    };
    if (d < 1 || d > cal.monthDays(y, mo)) return {
        error: 'range'
    };
    const hasTime = m[4] !== undefined;
    let hh = 0, mi = 0;
    if (hasTime) {
        if (!withTime) return {
            error: 'noTime'
        };
        hh = +m[4];
        mi = +m[5];
        if (hh > 23 || mi > 59) return {
            error: 'time'
        };
    }
    if (disableFuture) {
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        if (cal.toMs(y, mo, d) > cal.toMs(t.y, t.m, t.d)) return {
            error: 'future'
        };
    }
    const date = $d9dd19094c9f758e$var$dateToValue(cal, y, mo, d);
    return {
        j: {
            y: y,
            m: mo,
            d: d
        },
        hh: hh,
        mi: mi,
        hasTime: hasTime,
        value: withTime ? `${date} ${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}` : date
    };
}
function $d9dd19094c9f758e$export$c715042cb80ca422(value, { withTime: withTime = false, calendar: calendar = 'jalali', digits: digits = $d9dd19094c9f758e$var$FA_DIGITS } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const c = $d9dd19094c9f758e$var$valueToDate(cal, date);
    if (!c) return '';
    const base = `${c.y}/${$d9dd19094c9f758e$var$pad2(c.m)}/${$d9dd19094c9f758e$var$pad2(c.d)}`;
    return (0, $IZwml.withDigits)(withTime ? `${base} ${time || '00:00'}` : base, digits);
}
const $d9dd19094c9f758e$export$5a5aa410a9e7d978 = (raw, opts = {})=>$d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
        ...opts,
        calendar: 'jalali'
    });
const $d9dd19094c9f758e$export$544b31198dd3053c = (value, { withTime: withTime = false } = {})=>$d9dd19094c9f758e$export$c715042cb80ca422(value, {
        withTime: withTime,
        calendar: 'jalali',
        digits: $d9dd19094c9f758e$var$FA_DIGITS
    });
function $d9dd19094c9f758e$var$buildGrid(cal, y, m, weekStart) {
    const days = cal.monthDays(y, m);
    const offset = (new Date(cal.toMs(y, m, 1)).getUTCDay() - weekStart + 7) % 7;
    const cells = [
        ...Array(offset).fill(null),
        ...Array.from({
            length: days
        }, (_, i)=>i + 1)
    ];
    while(cells.length % 7)cells.push(null);
    const grid = [];
    for(let i = 0; i < cells.length; i += 7)grid.push(cells.slice(i, i + 7));
    return grid;
}
// ── Sub-components ────────────────────────────────────────────────────────────
const $d9dd19094c9f758e$var$NavBtn = ({ onClick: onClick, children: children, disabled: disabled })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov && !disabled ? '#e2e8f0' : '#f0f4f8',
            border: 'none',
            borderRadius: 6,
            width: 28,
            height: 28,
            cursor: disabled ? 'default' : 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#c8c8c8' : (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevR = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
const $d9dd19094c9f758e$var$ChevL = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $d9dd19094c9f758e$var$GridCell = ({ label: label, selected: selected, current: current, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    let bg = hov && !disabled ? '#e2e8f0' : '#f8fafc';
    let color = disabled ? '#c8c8c8' : (0, $jTCZr.C).textPrimary;
    let fw = 400;
    if (selected && !disabled) {
        bg = (0, $jTCZr.C).navy;
        color = 'white';
        fw = 700;
    } else if (current && !disabled) {
        bg = '#EAF4FC';
        color = (0, $jTCZr.C).navy;
        fw = 600;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 36,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            fontWeight: fw,
            background: bg,
            color: color,
            transition: 'background 0.12s'
        }
    }, label);
};
const $d9dd19094c9f758e$var$DayCell = ({ day: day, label: label, isToday: isToday, isSel: isSel, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let bg = hov && !disabled ? '#f0f4f8' : 'transparent';
    let color = disabled ? '#d0d0d0' : (0, $jTCZr.C).textPrimary;
    let fw = 400;
    if (isSel && !disabled) {
        bg = (0, $jTCZr.C).navy;
        color = 'white';
        fw = 700;
    } else if (isToday) {
        bg = '#EAF4FC';
        color = (0, $jTCZr.C).navy;
        fw = 700;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 34,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            background: bg,
            color: color,
            fontWeight: fw,
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            transition: 'background 0.12s'
        }
    }, label);
};
// ‹ label › — earlier on the LEFT and later on the RIGHT in every language. That is
// the reading order under `ltr`, and it is what the RTL picker has always drawn, so
// the row pins its own direction instead of mirroring with the card.
const $d9dd19094c9f758e$var$NavRow = ({ onPrev: onPrev, onNext: onNext, nextDisabled: nextDisabled, marginBottom: marginBottom, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: marginBottom,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onNext,
        disabled: nextDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)));
const $d9dd19094c9f758e$export$9c97d98ce20c6c7a = ({ locale: locale, calendar: calendar, ...rest })=>{
    const picker = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    // Keyed on the calendar: the view state is a year and month IN that calendar, so a
    // language switch that changes calendars starts over rather than reading 1405 as a
    // Gregorian year.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$CalendarBody, {
        key: picker.cal.id,
        picker: picker,
        ...rest
    });
};
const $d9dd19094c9f758e$var$CalendarBody = ({ value: value, onChange: onChange, disableFuture: disableFuture = false, picker: picker })=>{
    const { L: L, cal: cal, months: months, weekStart: weekStart, num: num } = picker;
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d9dd19094c9f758e$var$todayIn(cal), [
        cal
    ]);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day'); // 'day' | 'month' | 'year'
    const [viewY, setViewY] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.y);
    const [viewM, setViewM] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.m);
    const [sel, setSel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const yrRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // scrollable year container
    const yrSelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // selected/current year cell
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (value) {
            const c = $d9dd19094c9f758e$var$valueToDate(cal, value);
            if (c) {
                setSel(c);
                setViewY(c.y);
                setViewM(c.m);
                return;
            }
        }
        setSel(null);
    }, [
        value,
        cal
    ]);
    const changeMonth = (delta)=>{
        let m = viewM + delta, y = viewY;
        if (m > 12) {
            m = 1;
            y++;
        }
        if (m < 1) {
            m = 12;
            y--;
        }
        setViewM(m);
        setViewY(y);
    };
    const enterYearMode = ()=>setMode('year');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (mode !== 'year') return;
        const t = setTimeout(()=>{
            if (yrSelRef.current && yrRef.current) {
                const el = yrSelRef.current;
                const container = yrRef.current;
                container.scrollTop = el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2;
            }
        }, 30);
        return ()=>clearTimeout(t);
    }, [
        mode
    ]);
    const selectDay = (d)=>{
        if (!d) return;
        setSel({
            y: viewY,
            m: viewM,
            d: d
        });
        onChange($d9dd19094c9f758e$var$dateToValue(cal, viewY, viewM, d));
        setMode('day');
    };
    // disableFuture checks
    const yearDisabled = (y)=>disableFuture && y > today.y;
    const monthDisabled = (y, m)=>disableFuture && (y > today.y || y === today.y && m > today.m);
    const dayDisabled = (d)=>{
        if (!disableFuture || !d) return false;
        if (viewY > today.y) return true;
        if (viewY === today.y && viewM > today.m) return true;
        if (viewY === today.y && viewM === today.m && d > today.d) return true;
        return false;
    };
    const grid = $d9dd19094c9f758e$var$buildGrid(cal, viewY, viewM, weekStart);
    const weekdays = Array.from({
        length: 7
    }, (_, i)=>L.weekdays[(weekStart + i) % 7]);
    // Shared header label button style
    const labelBtn = (extra)=>({
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif',
            borderRadius: 6,
            padding: '4px 10px',
            ...extra
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mode === 'year' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: 10,
            letterSpacing: 1
        }
    }, L.strings.selectYear), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: yrRef,
        style: {
            maxHeight: 240,
            overflowY: 'auto',
            paddingLeft: 2,
            paddingRight: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 4
        }
    }, Array.from({
        length: today.y - cal.firstYear + 1 + (disableFuture ? 0 : 6)
    }, (_, i)=>cal.firstYear + i).map((yr)=>{
        const isFocused = yr === (sel?.y ?? today.y);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: yr,
            ref: isFocused ? yrSelRef : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            label: num(yr),
            selected: sel ? yr === sel.y : false,
            current: yr === today.y,
            disabled: yearDisabled(yr),
            onClick: ()=>{
                setViewY(yr);
                setMode('month');
            }
        }));
    })))), mode === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $jTCZr.C).navy
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 6
        }
    }, months.map((name, idx)=>{
        const mn = idx + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            key: idx,
            label: name,
            selected: !!(sel && sel.y === viewY && sel.m === mn),
            current: viewY === today.y && mn === today.m,
            disabled: monthDisabled(viewY, mn),
            onClick: ()=>{
                setViewM(mn);
                setMode('day');
            }
        });
    }))), mode === 'day' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 4,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 13,
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>changeMonth(-1),
        onNext: ()=>changeMonth(1),
        nextDisabled: monthDisabled(viewM === 12 ? viewY + 1 : viewY, viewM === 12 ? 1 : viewM + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setMode('month'),
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $jTCZr.C).navy
        })
    }, months[viewM - 1])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border,
            marginBottom: 10
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginBottom: 4
        }
    }, weekdays.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                padding: '2px 0'
            }
        }, d))), grid.map((week, wi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: wi,
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 2
            }
        }, week.map((day, di)=>{
            const isToday = day && viewY === today.y && viewM === today.m && day === today.d;
            const isSel = day && sel && viewY === sel.y && viewM === sel.m && day === sel.d;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$DayCell, {
                key: di,
                day: day,
                label: day ? num(day) : '',
                isToday: isToday,
                isSel: isSel,
                disabled: dayDisabled(day),
                onClick: ()=>selectDay(day)
            });
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setViewY(today.y);
            setViewM(today.m);
        },
        style: {
            marginTop: 12,
            width: '100%',
            height: 32,
            background: '#f8fafc',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.C).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.goToToday)));
};
// ── Popup shell ───────────────────────────────────────────────────────────────
// The floating card the calendar sits in, positioned under `anchorRef` (flipping above
// it when the viewport has no room below) and closed by a click anywhere outside both.
// Portaled to <body>: an ancestor with a CSS transform (e.g. a centered DialogContent)
// would otherwise become the containing block of this fixed card and misplace it, and
// an ancestor overflow would clip it. Dialog.jsx whitelists [data-jalali-popup] so the
// portaled card doesn't count as an outside click that dismisses the dialog.
//
// Placement is measured from the card's REAL height, never a guessed constant: the
// calendar is ~380px tall in day mode, so the old `spaceBelow > 320` test opened it
// downward with 60px too little room and the last week of the month fell off the
// bottom of the screen — the exact failure seen with the field low in a tall modal.
// The measured box is then clamped into the viewport on both axes, and re-placed on
// scroll/resize because a field inside a scrollable DialogContent moves under it.
const $d9dd19094c9f758e$var$POPUP_WIDTH = 300;
const $d9dd19094c9f758e$var$POPUP_GAP = 6; // breathing room between the trigger and the card
const $d9dd19094c9f758e$var$POPUP_MARGIN = 8; // never touch the viewport edge
const $d9dd19094c9f758e$export$bb703e6cd16789d6 = ({ anchorRef: anchorRef, onClose: onClose, children: children, width: width = $d9dd19094c9f758e$var$POPUP_WIDTH, locale: locale })=>{
    const cardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The card reads in the language its calendar is drawn in — pass the same `locale`
    // to both, or neither and let both read `<html lang>`.
    const rtl = (0, $IZwml.datePickerLocale)(locale).dir === 'rtl';
    // Positions the card by writing to the DOM node rather than through state: this runs
    // from a ResizeObserver (mode switches change the card's height) and from scroll, and
    // a setState there would re-render → re-measure → re-render without ever settling.
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const card = cardRef.current;
        const anchor = anchorRef.current;
        if (!card || !anchor) return;
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const maxH = vh - $d9dd19094c9f758e$var$POPUP_MARGIN * 2;
        // Cap first, measure second — otherwise a card taller than the viewport reports a
        // height no placement can satisfy.
        card.style.maxHeight = `${maxH}px`;
        const h = Math.min(card.offsetHeight || 0, maxH);
        const rect = anchor.getBoundingClientRect();
        const roomBelow = vh - rect.bottom - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        const roomAbove = rect.top - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        // Below by default; flip above only when that side genuinely has more room.
        let top = h <= roomBelow || roomBelow >= roomAbove ? rect.bottom + $d9dd19094c9f758e$var$POPUP_GAP : rect.top - $d9dd19094c9f758e$var$POPUP_GAP - h;
        top = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(top, vh - $d9dd19094c9f758e$var$POPUP_MARGIN - h));
        // The trigger's START edge: right edges align under RTL, left edges under LTR. Then
        // clamp so a trigger near either viewport edge can't push the card off-screen.
        let left = rtl ? rect.right - width : rect.left;
        left = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(left, vw - $d9dd19094c9f758e$var$POPUP_MARGIN - width));
        card.style.top = `${top}px`;
        card.style.left = `${left}px`;
        card.style.visibility = 'visible';
    }, [
        anchorRef,
        width,
        rtl
    ]);
    // Layout effect, before paint: a card positioned after the fact is a card the user
    // sees jump from the corner of the screen to where it belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        place();
        const onScroll = ()=>place();
        // capture:true — the scroll that matters is usually an ancestor's (the modal body),
        // and scroll events from those don't bubble to window.
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', place);
        let ro;
        if (typeof ResizeObserver !== 'undefined' && cardRef.current) {
            ro = new ResizeObserver(()=>place());
            ro.observe(cardRef.current);
        }
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('resize', place);
            ro?.disconnect();
        };
    }, [
        place
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const h = (e)=>{
            if (cardRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return; // the trigger toggles itself
            onClose();
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        anchorRef,
        onClose
    ]);
    // A modal Radix dialog locks scrolling with react-remove-scroll, which cancels every
    // `wheel` and `touchmove` that reaches `document` from OUTSIDE the dialog — and this
    // card is portaled out of it. So in «ویرایش بیمار» and every other dialog with a date
    // field the year list (and a card taller than the screen) could not be scrolled by
    // wheel, trackpad or finger, only by dragging a scrollbar (PM-0121). Stopped here they
    // never reach that listener; the card's own scrolling is the browser's and needs
    // nothing more. Passive: nothing here cancels a scroll. The page behind stays locked.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const card = cardRef.current;
        if (!card) return undefined;
        const keep = (e)=>e.stopPropagation();
        card.addEventListener('wheel', keep, {
            passive: true
        });
        card.addEventListener('touchmove', keep, {
            passive: true
        });
        return ()=>{
            card.removeEventListener('wheel', keep);
            card.removeEventListener('touchmove', keep);
        };
    }, []);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cardRef,
        "data-jalali-popup": "",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            visibility: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            zIndex: 9999,
            width: width,
            background: 'white',
            borderRadius: 16,
            padding: '16px 14px',
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            direction: rtl ? 'rtl' : 'ltr',
            boxSizing: 'border-box',
            pointerEvents: 'auto'
        }
    }, children), document.body);
};
// ── Time row ──────────────────────────────────────────────────────────────────
// Two spinnable segments under the calendar, shown only when `withTime`. Rendered LTR:
// an "HH:MM" pair inside an RTL paragraph gets its two numeric runs reordered by the
// bidi algorithm, so the minutes would appear where the hours belong.
//
// Steppers, not text boxes, on purpose. The popup is portaled to <body>, so inside a
// modal Radix dialog it sits outside the focus scope and anything focusable in it gets
// focus yanked straight back into the dialog — a text field there could never be typed
// into. Buttons don't need focus to be clicked, and an exact time can always be typed
// into the field itself, which does live inside the dialog.
const $d9dd19094c9f758e$var$StepBtn = ({ onClick: onClick, label: label, children: children })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov ? '#e2e8f0' : 'transparent',
            border: 'none',
            borderRadius: 4,
            width: 26,
            height: 18,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.C).textSecondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevUp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }));
const $d9dd19094c9f758e$var$ChevDn = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 16l6-6-1.41-1.41L12 13.17 7.41 8.59 6 10z"
    }));
const $d9dd19094c9f758e$var$TimeSegment = ({ value: value, onChange: onChange, max: max, step: step, label: label, L: L })=>{
    const wrap = (n)=>(n % (max + 1) + max + 1) % (max + 1);
    const shown = (0, $IZwml.withDigits)($d9dd19094c9f758e$var$pad2(value), L.digits);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "spinbutton",
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": max,
        "aria-valuetext": shown,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $IZwml.fillTemplate)(L.strings.stepUp, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value + step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevUp, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 42,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            background: '#f8fafc',
            color: (0, $jTCZr.C).textPrimary,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'Meshkat, sans-serif',
            boxSizing: 'border-box',
            userSelect: 'none'
        }
    }, shown), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $IZwml.fillTemplate)(L.strings.stepDown, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value - step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevDn, null)));
};
const $d9dd19094c9f758e$var$TimeRow = ({ hh: hh, mi: mi, onChange: onChange, minuteStep: minuteStep = 5, L: L })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.hour,
        value: hh,
        max: 23,
        step: 1,
        onChange: (h)=>onChange(h, mi)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 800,
            color: (0, $jTCZr.C).textMuted
        }
    }, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.minute,
        value: mi,
        max: 59,
        step: minuteStep,
        onChange: (m)=>onChange(hh, m)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>{
            const n = new Date();
            onChange(n.getHours(), Math.floor(n.getMinutes() / minuteStep) * minuteStep);
        },
        style: {
            background: '#f8fafc',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            height: 28,
            padding: '0 10px',
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.C).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.now));
// ── Main Component ────────────────────────────────────────────────────────────
// Editable input + the shared calendar. The selected moment lives entirely in `value` —
// the only local copy is `draft`, the half-typed text, which exists exactly while the
// field has focus and is discarded (never committed) if it never parses.
//
// Idle, the field reads «۱۲ مرداد ۱۴۰۴» (English: «August 3, 2025»); focused, it
// becomes the numeric «۱۴۰۴/۰۵/۱۲» («2025/08/03») the parser round-trips. The input is
// dir="ltr" while typed so date and time segments keep their order — bidi reorders two
// numeric runs inside an RTL field.
//
// `locale` (default `<html lang>`) and `calendar` behave as on `JalaliCalendar`.
const $d9dd19094c9f758e$var$JalaliDatePicker = ({ value: value, onChange: onChange, placeholder: placeholder, locale: locale, calendar: calendar, height: height = 44, fontSize: fontSize = 14, disabled: disabled = false, disableFuture: disableFuture = false, withTime: withTime = false, minuteStep: minuteStep = 5, readOnlyInput: readOnlyInput = false, id: // Forwarded to the typeable <input> (v0.16.1), so a FormField label can name it
// (DESIGN_CONCEPT §12.3) and a caller can validate on blur.
id, name: name, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, 'data-testid': testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null ⇒ not typing
    // The error CODE, not its wording — so a language switch re-words a standing error.
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { L: L, cal: cal, months: months, num: num } = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    const rtl = L.dir === 'rtl';
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const sel = date ? $d9dd19094c9f758e$var$valueToDate(cal, date) : null;
    const [hh, mi] = time ? time.split(':').map(Number) : [
        0,
        0
    ];
    const prettyDate = sel ? (0, $IZwml.fillTemplate)(L.date, {
        d: num(sel.d),
        month: months[sel.m - 1],
        y: num(sel.y)
    }) : '';
    const prettyVal = sel && withTime && time ? (0, $IZwml.fillTemplate)(L.dateTime, {
        date: prettyDate,
        time: num(`${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}`)
    }) : prettyDate;
    // «Date format: 2026/09/26» — the example is today, in the calendar and digits shown.
    const errorText = (()=>{
        if (!error) return '';
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        return (0, $IZwml.fillTemplate)(L.errors[error] || L.errors.format, {
            example: num(`${t.y}/${$d9dd19094c9f758e$var$pad2(t.m)}/${$d9dd19094c9f758e$var$pad2(t.d)}`)
        });
    })();
    const editable = !disabled && !readOnlyInput;
    const shownText = draft !== null ? draft : prettyVal;
    // The time a with-time field falls back to when a date arrives without one — by
    // picking or by typing, the same either way. Now, rounded down to the step: 00:00 is
    // almost never the moment someone meant, and the result is visible in the field.
    const fallbackTime = ()=>{
        const now = new Date();
        return `${$d9dd19094c9f758e$var$pad2(now.getHours())}:${$d9dd19094c9f758e$var$pad2(Math.floor(now.getMinutes() / minuteStep) * minuteStep)}`;
    };
    const emitDate = (gregorian)=>{
        if (!gregorian) {
            onChange('');
            return;
        }
        if (!withTime) {
            onChange(gregorian);
            setOpen(false);
            return;
        }
        onChange(`${gregorian} ${time || fallbackTime()}`); // popup stays open for the time
    };
    // Setting a time before a day picks today, so the field can never hold a bare time.
    // The draft is dropped: a modal's focus trap can bounce focus back into the field
    // while the popup is used, and a stale half-typed draft would then hide the new time.
    const emitTime = (h, m)=>{
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        const d = date || $d9dd19094c9f758e$var$dateToValue(cal, t.y, t.m, t.d);
        setDraft(null);
        setError('');
        onChange(`${d} ${$d9dd19094c9f758e$var$pad2(h)}:${$d9dd19094c9f758e$var$pad2(m)}`);
    };
    const handleType = (raw)=>{
        setDraft(raw);
        if (!raw.trim()) {
            setError('');
            if (value) onChange('');
            return;
        }
        const r = $d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
            withTime: withTime,
            disableFuture: disableFuture,
            calendar: cal.id
        });
        if (r.error) {
            setError(r.error);
            return;
        }
        setError('');
        // A date typed with no time keeps the time the field already holds.
        if (withTime && !r.hasTime) onChange(`${r.value.slice(0, 10)} ${time || fallbackTime()}`);
        else onChange(r.value);
    };
    const startEditing = ()=>{
        if (!editable || draft !== null) return;
        setDraft($d9dd19094c9f758e$export$c715042cb80ca422(value, {
            withTime: withTime,
            calendar: cal.id,
            digits: L.digits
        }));
    };
    const commit = ()=>{
        if (draft === null) return;
        setDraft(null); // whatever survived is already in `value`; anything else reverts
        setError('');
    };
    const clearDate = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setDraft(null);
        setError('');
        onChange('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggerRef,
        onMouseDown: (e)=>{
            // Only the box's own padding — the input and the icons handle their own clicks.
            if (disabled || e.target !== e.currentTarget) return;
            if (editable) {
                e.preventDefault();
                inputRef.current?.focus();
                setOpen(true);
            } else setOpen((o)=>!o);
        },
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            gap: 6,
            border: `1.5px solid ${error ? (0, $jTCZr.C).red : open || draft !== null ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            borderRadius: 10,
            cursor: disabled ? 'default' : editable ? 'text' : 'pointer',
            background: disabled ? '#f8fafc' : 'white',
            transition: 'border-color 0.18s',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        type: "text",
        id: id,
        name: name,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid ?? (error ? true : undefined),
        "data-testid": testId,
        // Displayed in the reader's direction, edited LTR. «۱۷ مهر ۱۳۶۹» is
        // number/word/number: under an LTR base the day lands on the far left and the
        // whole thing reads backwards. The typed «۱۳۶۹/۰۷/۱۷ ۱۴:۳۰» is the opposite
        // case — two numeric runs that bidi would swap in an RTL field, putting the
        // minutes where the year belongs.
        dir: draft !== null ? 'ltr' : L.dir,
        value: shownText,
        placeholder: placeholder ?? L.strings.placeholder,
        disabled: disabled,
        readOnly: !editable,
        onFocus: startEditing,
        onClick: ()=>{
            if (disabled) return;
            if (editable) setOpen(true);
            else setOpen((o)=>!o);
        },
        onChange: (e)=>handleType(e.target.value),
        onBlur: (e)=>{
            commit();
            onBlur?.(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                setOpen(false);
                inputRef.current?.blur();
            } else if (e.key === 'Escape') {
                setDraft(null);
                setError('');
                setOpen(false);
            } else if (e.key === 'ArrowDown' && !open) setOpen(true);
        },
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 'none',
            outline: 'none',
            // Pinned to the reader's side, so starting to type does not jump the text.
            background: 'transparent',
            padding: 0,
            textAlign: rtl ? 'right' : 'left',
            fontSize: fontSize,
            fontFamily: 'Meshkat, sans-serif',
            color: shownText ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
            cursor: editable ? 'text' : disabled ? 'default' : 'pointer'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0
        }
    }, (sel || draft) && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.clear,
        onMouseDown: clearDate,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            borderRadius: 4,
            color: (0, $jTCZr.C).textMuted,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.openCalendar,
        onMouseDown: (e)=>{
            e.preventDefault();
            if (!disabled) setOpen((o)=>!o);
        },
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: open ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 5 2 5.9 2 7v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 11,
            fontWeight: 600,
            color: (0, $jTCZr.C).red,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, errorText), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$bb703e6cd16789d6, {
        anchorRef: triggerRef,
        onClose: ()=>setOpen(false),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$9c97d98ce20c6c7a, {
        locale: locale,
        calendar: calendar,
        value: date,
        onChange: (v)=>{
            setDraft(null);
            setError('');
            emitDate(v);
        },
        disableFuture: disableFuture
    }), withTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeRow, {
        L: L,
        hh: hh,
        mi: mi,
        minuteStep: minuteStep,
        onChange: emitTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(false),
        style: {
            marginTop: 10,
            width: '100%',
            height: 34,
            background: (0, $jTCZr.C).navy,
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 700,
            color: 'white',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.confirm))));
};
var $d9dd19094c9f758e$export$2e2bcd8739ae039 = $d9dd19094c9f758e$var$JalaliDatePicker;

});
parcelRegister("IZwml", function(module, exports) {

$parcel$export(module.exports, "DATE_PICKER_LOCALES", () => $0873d4f32691c14e$export$4b8e9f545c94f612);
$parcel$export(module.exports, "datePickerLocale", () => $0873d4f32691c14e$export$90e478cf5247906b);
$parcel$export(module.exports, "fillTemplate", () => $0873d4f32691c14e$export$9a328bbde6508c84);
$parcel$export(module.exports, "withDigits", () => $0873d4f32691c14e$export$545c62727d3740ae);
// ─────────────────────────────────────────────────────────────────────────────
// What the date picker draws in each UI language.
//
// The picker used to be Persian whatever the page was: an English reception
// desk read «۴ مهر ۱۴۰۵» in a field whose own heading said «Saturday,
// September 26, 2026», and a mistyped date answered «قالب تاریخ: ۱۴۰۴/۰۵/۱۲».
// Everything the picker shows now comes from this table, keyed by the base
// language of `<html lang>` — the channel `MoneyInput` and `PhoneInput` already
// read (see `documentLocale` in money.js). The kit cannot import an app's i18n.
//
// `calendar` is the one entry that is not wording. It matches the calendar each
// app's locale descriptor hands Intl (`intl` in i18n/config.js): Persian and
// Arabic are Jalali (`-u-ca-persian`), English is Gregorian. The picker and the
// app's own `formatDate` have to agree, or the desk picks one day and reads back
// another. CLDR cannot supply it — it gives `ar` the Gregorian calendar, which
// both apps deliberately override — so it is data here, not
// `resolvedOptions().calendar`.
//
// `months` carries BOTH calendars' names for every language, because a caller
// can pin the calendar (`calendar="jalali"`) on a surface that is Jalali in
// every language — an accounting period is bounded by Jalali months whatever
// the UI language is.
//
// Adding a language is adding an entry. An unknown one gets Persian, the product
// default, exactly as `documentLocale` falls back — or the brand's default
// language when the brand names one.
//
// A BRAND that names a calendar (`calendar: 'gregory' | 'jalali'`,
// ui/lib/brand.js) moves every language's `calendar` to it, the same switch the
// apps' locale descriptors make, so picker and `formatDate` still agree. A caller
// that pins `calendar` on the picker still wins.
// ─────────────────────────────────────────────────────────────────────────────

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
// The brand's calendar ids → this table's.
const $0873d4f32691c14e$var$PICKER_CALENDAR = {
    gregory: 'gregorian',
    jalali: 'jalali'
};
const $0873d4f32691c14e$export$4b8e9f545c94f612 = {
    fa: {
        calendar: 'jalali',
        dir: 'rtl',
        digits: "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9",
        // First column of a Gregorian grid; a Jalali grid always opens on شنبه.
        weekStart: 6,
        // Indexed by `Date#getDay()` — 0 is Sunday.
        weekdays: [
            "\u06CC",
            "\u062F",
            "\u0633",
            "\u0686",
            "\u067E",
            "\u062C",
            "\u0634"
        ],
        months: {
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
                "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u06CC\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u06CC\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u06CC",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u0698\u0627\u0646\u0648\u06CC\u0647",
                "\u0641\u0648\u0631\u06CC\u0647",
                "\u0645\u0627\u0631\u0633",
                "\u0622\u0648\u0631\u06CC\u0644",
                "\u0645\u0647",
                "\u0698\u0648\u0626\u0646",
                "\u0698\u0648\u0626\u06CC\u0647",
                "\u0627\u0648\u062A",
                "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
                "\u0627\u06A9\u062A\u0628\u0631",
                "\u0646\u0648\u0627\u0645\u0628\u0631",
                "\u062F\u0633\u0627\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0633\u0627\u0639\u062A {time}",
        strings: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
            selectYear: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644",
            goToToday: "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
            openCalendar: "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
            time: "\u0633\u0627\u0639\u062A",
            hour: "\u0633\u0627\u0639\u062A",
            minute: "\u062F\u0642\u06CC\u0642\u0647",
            stepUp: "{label} \u0628\u06CC\u0634\u062A\u0631",
            stepDown: "{label} \u06A9\u0645\u062A\u0631",
            now: "\u0627\u06A9\u0646\u0648\u0646",
            confirm: "\u062A\u0627\u06CC\u06CC\u062F"
        },
        errors: {
            format: "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: {example}",
            range: "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            time: "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            noTime: "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
            future: "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A"
        }
    },
    en: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        weekStart: 0,
        weekdays: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        months: {
            // The Latin spellings ICU gives `en-US-u-ca-persian`, so a pinned-Jalali
            // picker and the app's `clinicCalendarIntl` labels name a month the same way.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
        },
        date: '{month} {d}, {y}',
        dateTime: '{date}, {time}',
        strings: {
            placeholder: 'Select date',
            selectYear: 'Select year',
            goToToday: 'Go to today',
            clear: 'Clear date',
            openCalendar: 'Show calendar',
            time: 'Time',
            hour: 'Hour',
            minute: 'Minute',
            stepUp: '{label} up',
            stepDown: '{label} down',
            now: 'Now',
            confirm: 'Done'
        },
        errors: {
            format: 'Date format: {example}',
            range: 'Invalid date',
            time: 'Invalid time',
            noTime: 'This field does not take a time',
            future: 'Future dates are not allowed'
        }
    },
    ar: {
        calendar: 'jalali',
        dir: 'rtl',
        // Arabic-Indic, the set the apps' `-u-nu-arab` renders — NOT Persian's.
        digits: "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669",
        weekStart: 6,
        weekdays: [
            "\u062D",
            "\u0646",
            "\u062B",
            "\u0631",
            "\u062E",
            "\u062C",
            "\u0633"
        ],
        months: {
            // The apps' corrected list (`monthNames` on their `ar` descriptor): CLDR's
            // Arabic names for the Persian calendar are not words in any language.
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
                "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u064A\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u064A\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u064A",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u064A\u0646\u0627\u064A\u0631",
                "\u0641\u0628\u0631\u0627\u064A\u0631",
                "\u0645\u0627\u0631\u0633",
                "\u0623\u0628\u0631\u064A\u0644",
                "\u0645\u0627\u064A\u0648",
                "\u064A\u0648\u0646\u064A\u0648",
                "\u064A\u0648\u0644\u064A\u0648",
                "\u0623\u063A\u0633\u0637\u0633",
                "\u0633\u0628\u062A\u0645\u0628\u0631",
                "\u0623\u0643\u062A\u0648\u0628\u0631",
                "\u0646\u0648\u0641\u0645\u0628\u0631",
                "\u062F\u064A\u0633\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0627\u0644\u0633\u0627\u0639\u0629 {time}",
        strings: {
            placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            selectYear: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0646\u0629",
            goToToday: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            clear: "\u0645\u0633\u062D \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            openCalendar: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
            time: "\u0627\u0644\u0648\u0642\u062A",
            hour: "\u0627\u0644\u0633\u0627\u0639\u0629",
            minute: "\u0627\u0644\u062F\u0642\u064A\u0642\u0629",
            stepUp: "\u0632\u064A\u0627\u062F\u0629 {label}",
            stepDown: "\u0625\u0646\u0642\u0627\u0635 {label}",
            now: "\u0627\u0644\u0622\u0646",
            confirm: "\u062A\u0623\u0643\u064A\u062F"
        },
        errors: {
            format: "\u0635\u064A\u063A\u0629 \u0627\u0644\u062A\u0627\u0631\u064A\u062E: {example}",
            range: "\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            time: "\u0648\u0642\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            noTime: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0644\u0627 \u064A\u0642\u0628\u0644 \u0648\u0642\u062A\u064B\u0627",
            future: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0627\u0631\u064A\u062E \u0645\u0633\u062A\u0642\u0628\u0644\u064A"
        }
    }
};
function $0873d4f32691c14e$export$90e478cf5247906b(locale) {
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    const L = $0873d4f32691c14e$export$4b8e9f545c94f612[base] || $0873d4f32691c14e$export$4b8e9f545c94f612[(0, $eLeza.brandDefaultLocale)('fa')] || $0873d4f32691c14e$export$4b8e9f545c94f612.fa;
    const calendar = $0873d4f32691c14e$var$PICKER_CALENDAR[(0, $eLeza.calendarSystem)(null)];
    return !calendar || calendar === L.calendar ? L : {
        ...L,
        calendar: calendar
    };
}
const $0873d4f32691c14e$export$9a328bbde6508c84 = (template, vars)=>String(template).replace(/\{(\w+)\}/g, (m, k)=>k in vars ? String(vars[k]) : m);
const $0873d4f32691c14e$export$545c62727d3740ae = (s, digits)=>String(s).replace(/\d/g, (d)=>digits[d]);

});


parcelRegister("2vdhF", function(module, exports) {

$parcel$export(module.exports, "shiftISO", () => $1d28c7ea24194f0d$export$c13cab26eb520a22);
$parcel$export(module.exports, "irWeekday", () => $1d28c7ea24194f0d$export$f9f83315c2979a2f);
$parcel$export(module.exports, "jalaliWeekStart", () => $1d28c7ea24194f0d$export$4905be222d58a860);
$parcel$export(module.exports, "weekDaysFrom", () => $1d28c7ea24194f0d$export$6b21eb5279a580dd);
$parcel$export(module.exports, "isoNoonMs", () => $1d28c7ea24194f0d$export$fa5589c3fde4793c);
// ─────────────────────────────────────────────────────────────────────────────
// Jalali weeks over Iran-local ISO dates ('YYYY-MM-DD').
//
// The reception surfaces of the doctor and clinic panels both browse a day at
// a time and a week at a time (`WeekPickerSheet`), and both speak an absolute
// ISO date in the URL or state. The arithmetic is done at UTC noon so neither
// DST nor the browser's own zone can move a day across midnight.
//
// A Jalali week opens on Saturday: شنبه = 0 … جمعه = 6.
// ─────────────────────────────────────────────────────────────────────────────
const $1d28c7ea24194f0d$var$DAY_MS = 86400000;
const $1d28c7ea24194f0d$var$noonMs = (iso)=>Date.parse(`${iso}T12:00:00Z`);
const $1d28c7ea24194f0d$export$c13cab26eb520a22 = (iso, days)=>new Date($1d28c7ea24194f0d$var$noonMs(iso) + days * $1d28c7ea24194f0d$var$DAY_MS).toISOString().split('T')[0];
const $1d28c7ea24194f0d$export$f9f83315c2979a2f = (iso)=>(new Date($1d28c7ea24194f0d$var$noonMs(iso)).getUTCDay() + 1) % 7;
const $1d28c7ea24194f0d$export$4905be222d58a860 = (iso)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(iso, -$1d28c7ea24194f0d$export$f9f83315c2979a2f(iso));
const $1d28c7ea24194f0d$export$6b21eb5279a580dd = (startISO)=>Array.from({
        length: 7
    }, (_, i)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(startISO, i));
const $1d28c7ea24194f0d$export$fa5589c3fde4793c = $1d28c7ea24194f0d$var$noonMs;

});


parcelRegister("gJslC", function(module, exports) {

$parcel$export(module.exports, "default", () => $336d0c00b1b6b543$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $336d0c00b1b6b543$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, closeLabel: closeLabel, groups: groups = [], locale: locale, testIdPrefix: testIdPrefix = 'choice' }) {
    const close = closeLabel || (0, $j9AxR.kitCopy)(locale).close;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: close,
        "data-testid": `${testIdPrefix}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, groups.filter((g)=>g.options?.length).map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.key,
            "data-testid": `${testIdPrefix}-group-${g.key}`
        }, g.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                margin: '0 0 0.25rem',
                padding: '0 0.25rem',
                fontSize: '0.75rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textSecondary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "radiogroup",
            "aria-label": g.label || g.title,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, g.options.map((row)=>{
            const Icon = row.icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                key: row.id,
                variant: "ghost",
                role: "radio",
                "aria-checked": Boolean(row.checked),
                "data-testid": `${testIdPrefix}-option-${row.id}`,
                className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-xl px-2.5 py-2 font-normal",
                style: {
                    background: row.checked ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                    textAlign: 'start'
                },
                onClick: ()=>{
                    g.onPick?.(row.id);
                    if (!row.keepOpen) onClose?.();
                }
            }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                style: {
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '0.5rem',
                    flexShrink: 0,
                    display: 'grid',
                    placeItems: 'center',
                    background: row.quiet ? (0, $jTCZr.C).bg : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                    color: row.quiet ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).navy
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            }, row.name), row.meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'block',
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    whiteSpace: 'normal'
                }
            }, row.meta)), row.checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                size: 16,
                "aria-hidden": true,
                style: {
                    color: (0, $jTCZr.C).navy,
                    flexShrink: 0
                }
            }));
        }))))));
}

});
parcelRegister("huNwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbaf9031554177f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3fbaf9031554177f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $3fbaf9031554177f$export$2e2bcd8739ae039 = (0, $9QBug.default)("check", $3fbaf9031554177f$export$3efd853dbb351e94);

});


parcelRegister("dyHsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cc8471170fac89$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $28cc8471170fac89$export$2e2bcd8739ae039({ checked: checked = false, onChange: onChange, disabled: disabled = false, suggested: suggested = false, separated: separated = false, compact: compact = false, title: title, hint: hint = null, labels: labels, locale: locale, testId: testId = 'walkin-toggle', style: style }) {
    const copy = {
        ...(0, $j9AxR.kitCopy)(locale).walkIn,
        ...labels
    };
    const lead = suggested && !checked && !disabled;
    const ink = checked ? (0, $jTCZr.CT).warnInk : lead ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textPrimary;
    const border = checked ? (0, $jTCZr.CT).warnInk : lead ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border;
    const bg = checked ? (0, $jTCZr.CT).warnSoft : lead ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07) : (0, $jTCZr.CT).surface;
    const track = {
        w: compact ? 34 : 40,
        h: compact ? 20 : 22
    };
    const knob = track.h - 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            ...style
        }
    }, separated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-testid": `${testId}-or`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 11.5,
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $jTCZr.C).border
        }
    }), copy.or, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $jTCZr.C).border
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onChange?.(!checked),
        "data-testid": testId,
        "data-suggested": lead ? 'true' : undefined,
        style: {
            position: 'relative',
            width: '100%',
            minHeight: compact ? 44 : 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: compact ? 10 : 12,
            padding: compact ? '6px 12px' : '10px 14px',
            borderRadius: 10,
            border: `1.5px solid ${border}`,
            background: bg,
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'background .14s, border-color .14s'
        }
    }, lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-badge`,
        style: {
            position: 'absolute',
            top: -9,
            insetInlineEnd: 10,
            padding: '0 8px',
            borderRadius: 999,
            fontSize: 10.5,
            fontWeight: 800,
            lineHeight: '17px',
            color: (0, $jTCZr.C).navy,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).navy}`
        }
    }, copy.suggested), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minWidth: 0,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: compact ? 13 : 13.5,
            fontWeight: 700,
            color: ink
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-hint`,
        style: {
            fontSize: compact ? 11 : 11.5,
            lineHeight: 1.55,
            fontWeight: 500,
            color: checked ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary
        }
    }, hint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'relative',
            flexShrink: 0,
            width: track.w,
            height: track.h,
            borderRadius: 999,
            background: checked ? (0, $jTCZr.CT).warnInk : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .14s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 3,
            width: knob,
            height: knob,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
            insetInlineStart: checked ? track.w - knob - 3 : 3,
            transition: 'inset-inline-start .14s'
        }
    }))));
}

});

parcelRegister("iuHQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5943a0a75dff01a1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $5943a0a75dff01a1$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, heightVar: heightVar = '--app-bottom-nav', className: className, 'data-testid': testId = 'bottom-nav', ...rest }) {
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Publish the real height while this bar is mounted, and clear it when it is
    // not — the bar is absent on full-screen flows, and a stale value there would
    // push floating chrome up over nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = barRef.current;
        if (!el || !heightVar || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(heightVar, `${Math.round(el.offsetHeight)}px`);
        publish();
        // ResizeObserver is absent in jsdom and in older webviews; the one-shot
        // measurement above is already right for them, since what it would catch
        // (a rotation changing the inset, a text-size change) is rare and
        // self-correcting on the next navigation.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(heightVar);
        };
    }, [
        heightVar,
        items.length
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ref: barRef,
        className: className,
        "data-testid": testId,
        "aria-label": (0, $j9AxR.kitCopy)().bottomNav.label,
        style: {
            flexShrink: 0,
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            paddingInline: '0.5rem',
            paddingTop: 0,
            // `max(…)`, not the bare inset: in a browser tab the inset is 0 because
            // the browser's own toolbar occupies that strip, which left the labels
            // sitting on the very edge of the window. The floor gives them the same
            // breathing room the home indicator provides in standalone mode.
            paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 0.25rem)',
            position: 'relative',
            zIndex: 50
        },
        ...rest
    }, items.map((item)=>{
        const isActive = item.key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: item.key,
            variant: "ghost",
            onClick: ()=>onSelect?.(item.key, item),
            "aria-current": isActive ? 'page' : undefined,
            "data-testid": `${testId}-${item.key}`,
            className: "h-auto min-h-11 flex-1 flex-col gap-1 rounded-none py-2 font-medium",
            style: {
                color: isActive ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'relative',
                display: 'inline-flex'
            }
        }, item.icon, item.badge != null && item.badge !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testId}-${item.key}-badge`,
            // The count is decoration to the eye and information to a
            // screen reader; without a label it is read as a bare digit
            // beside the destination's name. The caller supplies the
            // sentence because only it knows what is being counted.
            "aria-label": item.badgeLabel,
            style: {
                position: 'absolute',
                top: '-0.25rem',
                insetInlineEnd: '-0.375rem',
                minWidth: '1rem',
                height: '1rem',
                paddingInline: '0.25rem',
                borderRadius: '0.5rem',
                // Tone is the caller's to choose, and the default is NOT the
                // safe one. Red carries "something is wrong"; an unread count
                // is not wrong, it is waiting — the colour budget reserves red
                // for destructive meaning, so a count uses `badgeTone="count"`.
                // ('accent' is the original spelling and still resolves here;
                // it drew navy from the start, and navy is the swatch the
                // whole unread family now agrees on.)
                // The default stays red only because it is what shipped, and
                // changing it silently would restyle callers that meant alarm.
                background: item.badgeTone === 'count' || item.badgeTone === 'accent' ? (0, $jTCZr.C).navy : (0, $jTCZr.C).red,
                color: '#fff',
                fontSize: '0.625rem',
                fontWeight: 700,
                lineHeight: '1rem',
                textAlign: 'center'
            }
        }, item.badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: isActive ? 700 : 500
            }
        }, item.label));
    }));
}

});

parcelRegister("9y25V", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ea4bc4a14affb445$export$2e2bcd8739ae039({ tiles: tiles = [], loading: loading = false, columns: columns = 4, className: className, 'data-testid': testId = 'stat-tiles', ...rest }) {
    if (!tiles.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            display: 'grid',
            // minmax(0, 1fr) rather than 1fr: a grid track's default `min-width:auto`
            // is its content's minimum, so one long value would push the row past
            // 320px and take the whole page into horizontal scroll (§9).
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        ...rest
    }, tiles.map(({ key: key, label: label, value: value, icon: icon, color: color, solid: solid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ?? label,
            "data-testid": `${testId}-${key ?? label}`,
            style: {
                background: solid ? (0, $jTCZr.C).navy : (0, $jTCZr.C).card,
                borderRadius: '0.875rem',
                padding: '0.625rem 0.25rem',
                textAlign: 'center',
                boxShadow: solid ? `0 4px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35)}` : '0 1px 4px rgba(0,0,0,0.06)',
                border: `1px solid ${solid ? 'transparent' : (0, $jTCZr.C).border}`,
                minWidth: 0
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '0.1875rem',
                color: solid ? '#fff' : color || (0, $jTCZr.C).textMuted
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: solid ? '#fff' : color || (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loading || value == null || value === '' ? "\u2014" : value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                color: solid ? 'rgba(255,255,255,0.7)' : (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, label))));
}

});

parcelRegister("fHxBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a13c7c62f369d090$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $7wZCE = parcelRequire("7wZCE");

var $bfs4Q = parcelRequire("bfs4Q");

var $cZOyb = parcelRequire("cZOyb");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// AccountCard — the block at the foot of the sidebar.
//
// ONE component for the doctor, clinic, dentist and patient panels, each of
// which had hand-rolled its own version: three copies of the پارسه balance card
// that already disagreed about their hex values, and four different answers to
// «چطور از حسابم خارج شوم؟».
//
// ── TWO ZONES, ONE COMPONENT ────────────────────────────────────────────────
// The balance on top, the identity below it, separated by the hairline that was
// already there. Not one merged row: the balance is a number read at a glance
// many times an hour, the identity is a control pressed rarely. The doctor and
// clinic panels independently arrived at this same stacking; this makes it the
// rule rather than a coincidence.
//
// ── THE IDENTITY ROW IS THE MENU TRIGGER ────────────────────────────────────
// The two loose 16px glyphs are gone. A sign-out icon sat one pixel from an
// external-link icon, both unlabelled, and the only thing distinguishing «رفتن
// به حساب» from «خروج» was the shape of a 16px arrow. Now the whole row opens a
// menu whose every destination is named in words.
//
// ── ONE BALANCE: THE SIGNED-IN PERSON'S OWN ─────────────────────────────────
// In the clinic panel there are two pots of money — the clinic's shared pool
// that reception AI spends, and the person's own wallet. This card shows ONLY
// the person's. They are never summed and never offset, and a block labelled
// «حساب من» must not be able to show money that belongs to the clinic. Omit
// `credit` entirely (a receptionist owns no wallet; patients hold no پارسه at
// all) and the zone is not rendered — there is then no number here to be wrong
// about.
//
// ── THE APP FORMATS THE DIGITS ──────────────────────────────────────────────
// `credit.amount` is a STRING the app already localised — Persian digits in fa,
// Latin in en. Same seam as `BottomNav`'s badge: the digit boundary belongs to
// the app, which knows its locale; the kit does not. `credit.level` likewise
// comes from `creditLevel()` in @parsina/framework/tokens, so all four panels
// agree on what «کم» means.
//
// ── SURVIVING THE 68px RAIL ─────────────────────────────────────────────────
// Coin tile and avatar sit in fixed-width cells FIRST in DOM order, so under RTL
// they are rightmost and the collapse — which clips from the inline-end — takes
// only the fading text. Both zones stay operable collapsed, and the menu still
// opens (it is portaled, so the sidebar's `overflow: hidden` cannot slice it).
// Nothing focusable is left painted at zero opacity: the top-up button is not
// rendered at all when collapsed, rather than faded into an invisible tab stop.
//
// Props:
//   user       {name, subtitle?, avatarUrl?}                       — required
//   credit     {amount, level, unit, label, levelLabel, onClick?}  — omit to hide the zone
//   onTopUp    ()=>void  — shows «شارژ اعتبار», expanded + level 'low' only
//   topUpLabel string
//   items      MenuItem[] — {key, label, description?, icon?, href?, external?,
//                            onClick?, tone?, separatorBefore?, 'data-testid'?}
//   collapsed  boolean    — the 68px rail
//   overlay    'auto' | 'menu' | 'sheet'  — auto switches at 768px (DESIGN.md §6:
//              a BottomSheet is the default overlay for a task on mobile; a 236px
//              popover anchored to the bottom edge of a phone is not)
//   menuLabel  string     — accessible name; required, because the trigger's own
//                           visible text is a person's name
// ─────────────────────────────────────────────────────────────────────────────
const $a13c7c62f369d090$var$MINI = 68; // the collapsed rail, and so the width of every icon cell
const $a13c7c62f369d090$var$INSET = 10; // the card's inset from the sidebar edges
const $a13c7c62f369d090$var$NARROW_QUERY = '(max-width: 768px)';
function $a13c7c62f369d090$var$useNarrow(enabled) {
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($a13c7c62f369d090$var$NARROW_QUERY);
        const sync = ()=>setNarrow(mq.matches);
        sync();
        // `addListener` is the Safari < 14 spelling; both are cheap to support and
        // the patient app is the one that actually meets phones.
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, [
        enabled
    ]);
    return narrow;
}
const $a13c7c62f369d090$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.5v9M9.5 10h5M9.5 14h5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    }));
// Says the press LEAVES this panel. Without it a row that navigates to حساب
// پارسینا reads as a tab that never opens.
const $a13c7c62f369d090$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
// ── one menu row, in either presentation ────────────────────────────────────
function $a13c7c62f369d090$var$AccountMenuRow({ item: item, onDone: onDone, compact: compact, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).textPrimary;
    const hover = destructive ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.10) : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08);
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: compact ? '10px' : '13px 12px',
        minHeight: compact ? 40 : 48,
        border: 'none',
        borderRadius: 9,
        background: 'transparent',
        color: ink,
        textAlign: 'start',
        textDecoration: 'none',
        fontFamily: 'inherit',
        fontSize: 13.5,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.14s'
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            display: 'flex',
            color: destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).navy
        },
        "aria-hidden": true
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.label), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: 11,
            fontWeight: 500,
            marginTop: 1,
            color: (0, $jTCZr.C).textMuted,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.description)), item.external && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$ExternalGlyph, null));
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: style,
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    // A real <a> when the destination is a URL: it must be focusable, openable in
    // a new tab with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...shared,
        href: item.href,
        target: item.target,
        rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: ()=>onDone?.()
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        }
    }, body);
}
// ── the balance, in either presentation ─────────────────────────────────────
// A real <a> when `credit.href` is given — the clinic panel's balance points at
// حساب پارسینا, and a link there must be middle-clickable and readable in the
// status bar rather than a button that happens to navigate. A <button> when the
// destination is inside this SPA, so it does not reload the app.
function $a13c7c62f369d090$var$CreditZone({ credit: credit, levelColor: levelColor, isLow: isLow, collapsed: collapsed, fade: fade, testId: testId }) {
    const bg = (hovered)=>isLow ? (0, $jTCZr.soft)((0, $jTCZr.C).red, hovered ? 0.24 : 0.16) : `rgba(255,255,255,${hovered ? 0.12 : 0.06})`;
    const props = {
        'data-testid': `${testId}-credit`,
        onClick: credit.onClick,
        title: collapsed ? `${credit.label} \u{2014} ${credit.amount} ${credit.unit}` : undefined,
        'aria-label': `${credit.label} \u{2014} ${credit.amount} ${credit.unit}`,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `0 ${$a13c7c62f369d090$var$INSET}px`,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 12,
            padding: 0,
            background: bg(false),
            border: `1px solid ${isLow ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.4) : 'rgba(255,255,255,0.08)'}`,
            cursor: credit.href || credit.onClick ? 'pointer' : 'default',
            fontFamily: 'inherit',
            textAlign: 'start',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'background 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        }
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI - $a13c7c62f369d090$var$INSET * 2,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '9px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 9,
            flexShrink: 0,
            background: (0, $jTCZr.soft)(levelColor, 0.22),
            color: levelColor,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 16
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: $a13c7c62f369d090$var$INSET
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: 10.5,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            whiteSpace: 'nowrap'
        }
    }, credit.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            marginTop: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 15,
            fontWeight: 800,
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, credit.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'rgba(255,255,255,0.5)'
        }
    }, credit.unit), credit.levelLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginInlineStart: 'auto',
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: levelColor
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10.5,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)'
        }
    }, credit.levelLabel)))));
    return credit.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...props,
        href: credit.href,
        target: credit.target,
        rel: credit.target === '_blank' ? 'noopener noreferrer' : undefined
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props,
        type: "button"
    }, body);
}
function $a13c7c62f369d090$export$2e2bcd8739ae039({ user: user, credit: credit = null, onTopUp: onTopUp, topUpLabel: topUpLabel, items: items = [], collapsed: collapsed = false, overlay: overlay = 'auto', menuLabel: menuLabel, 'data-testid': testId = 'account-card' }) {
    if (topUpLabel === undefined) topUpLabel = (0, $j9AxR.kitCopy)().account.topUp;
    if (menuLabel === undefined) menuLabel = (0, $j9AxR.kitCopy)().account.menu;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const narrow = $a13c7c62f369d090$var$useNarrow(overlay === 'auto');
    const asSheet = overlay === 'sheet' || overlay === 'auto' && narrow;
    // Collapsing must not leave the menu floating beside a rail that just changed
    // width — the anchor moves 192px under a CSS transition.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const rows = items.filter(Boolean);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    const level = credit?.level || 'ok';
    const levelColor = (0, $jTCZr.CREDIT_LEVEL_META)[level]?.color || (0, $jTCZr.C).teal;
    const isLow = level === 'low';
    const rendered = rows.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.key
        }, item.separatorBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "separator",
            style: {
                height: 1,
                background: (0, $jTCZr.C).border,
                margin: '5px 8px'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$AccountMenuRow, {
            item: item,
            onDone: close,
            compact: !asSheet,
            testIdBase: testId
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            position: 'relative'
        }
    }, credit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '6px 0 2px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CreditZone, {
        credit: credit,
        levelColor: levelColor,
        isLow: isLow,
        collapsed: collapsed,
        fade: fade,
        testId: testId
    }), onTopUp && isLow && !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `${testId}-topup`,
        onClick: onTopUp,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `6px ${$a13c7c62f369d090$var$INSET}px 0`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            background: (0, $jTCZr.C).teal,
            border: 'none',
            borderRadius: 10,
            padding: '7px 0',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 13
    }), " ", topUpLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": `${testId}-trigger`,
        onClick: ()=>setOpen((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-label": `${menuLabel} \u{2014} ${user?.name || ''}`,
        title: collapsed ? `${menuLabel} \u{2014} ${user?.name || ''}` : undefined,
        style: {
            width: '100%',
            marginTop: credit ? 10 : 0,
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            background: open ? 'rgba(255,255,255,0.09)' : 'transparent',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            if (!open) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            if (!open) e.currentTarget.style.background = 'transparent';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: user?.name || '',
        size: 36,
        bg: (0, $jTCZr.C).navy,
        src: user?.avatarUrl || undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: '#fff',
            fontSize: 13,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user?.name || "\u2014"), user?.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: 'rgba(255,255,255,0.42)',
            fontSize: 11,
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user.subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "15",
        height: "15",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? '#fff' : 'rgba(255,255,255,0.45)',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "18 15 12 9 6 15"
    })))), asSheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: menuLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menu",
        "aria-label": menuLabel,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, rendered)) : // 'top': this card is the LAST thing in the sidebar, so a menu opening
    // downward would render off the bottom of the viewport.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: open,
        onClose: close,
        anchorRef: triggerRef,
        ariaLabel: menuLabel,
        placement: "top",
        width: 236,
        "data-testid": `${testId}-menu`
    }, rendered));
}

});

parcelRegister("fh5c7", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
function $dd795e2724b3b1d0$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, ariaLabel: ariaLabel, className: className, 'data-testid': testId = 'section-nav', ...rest }) {
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Keep the selected section in view: a strip long enough to scroll can put
    // the active item off-screen (or half-clipped at an edge) after a tap, a
    // route restore, or a rotation.
    //
    // Feature-detected, not assumed: `scrollIntoView` does not exist in jsdom and
    // is missing from some old webviews, and an unguarded call there throws from
    // inside an effect — which unmounts the whole record rather than merely
    // failing to centre a tab. Centring is a convenience; rendering is not.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = activeRef.current;
        if (typeof el?.scrollIntoView !== 'function') return;
        el.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "tablist",
        "aria-label": ariaLabel,
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        },
        ...rest
    }, items.map(({ key: key, label: label, icon: icon })=>{
        const on = key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: key,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `${testId}-${key}`,
            onClick: ()=>onSelect?.(key, {
                    key: key,
                    label: label,
                    icon: icon
                }),
            className: "h-auto min-h-11 shrink-0 flex-col gap-0.5 rounded-none px-3.5 py-2 hover:bg-transparent",
            style: {
                color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $jTCZr.C).navy}` : '2.5px solid transparent'
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                display: 'inline-flex'
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
}

});

parcelRegister("gehDE", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $kzPvP = parcelRequire("kzPvP");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $4Qco3 = parcelRequire("4Qco3");
'use client';
/**
 * DateNavigator — the mobile day stepper (DESIGN-CONCEPT-MOBILE §4): prev/next
 * arrows around a TAPPABLE day label that opens the kit `JalaliCalendar` in a
 * `BottomSheet`. It is the mobile counterpart of the desktop header's
 * `JalaliDatePicker`, and it exists because §4 says arrow-stepping must never
 * be the ONLY path to a date — a doctor looking at next Tuesday should not
 * press an arrow five times.
 *
 * `variant="onGradient"` is the §3.2 "white-alpha inset card": the context
 * widget that lives INSIDE `MobileHeader`'s gradient.
 *
 * Every label is a prop and none is defaulted to Persian. The kit has no
 * translator, the calendar formatting stays with the app (the same rule
 * `TimeRuler.formatTick` and `ChatDayDivider.label` follow), and this component
 * is used by an app that ships in two languages.
 *
 * Props:
 *   value / onChange  — Gregorian 'YYYY-MM-DD', like every kit date component
 *   dateLabel         — the day, formatted by the caller (Jalaali under fa)
 *   subLabel          — optional second line, shown only when `isToday`
 *   isToday           — drives the «back to today» affordance
 *   onPrev / onNext / onToday
 *   prevLabel / nextLabel / pickLabel / todayLabel / sheetTitle — all required
 *                       in practice; they are this component's whole copy
 *   variant           — 'onGradient' (default) | 'plain'
 *   className / data-testid — forwarded to the root
 */ const $e0ac3bcac665682a$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $e0ac3bcac665682a$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
function $e0ac3bcac665682a$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday = true, onPrev: onPrev, onNext: onNext, onToday: onToday, prevLabel: prevLabel, nextLabel: nextLabel, pickLabel: pickLabel, todayLabel: todayLabel, sheetTitle: sheetTitle, closeLabel: closeLabel, variant: variant = 'onGradient', className: className, 'data-testid': testId = 'date-navigator', ...rest }) {
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onGradient = variant === 'onGradient';
    const arrowClass = onGradient ? 'min-w-11 min-h-11 text-white hover:bg-white/25' : 'min-w-11 min-h-11';
    const arrowStyle = onGradient ? {
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '0.5rem'
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            background: onGradient ? 'rgba(255,255,255,0.12)' : 'transparent',
            borderRadius: '0.75rem',
            padding: '0.375rem 0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.375rem'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-prev`,
        "aria-label": prevLabel,
        title: prevLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-pick`,
        "aria-label": pickLabel,
        className: onGradient ? 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15' : 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold',
        onClick: ()=>setPickerOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 14,
        style: {
            opacity: 0.7
        },
        "aria-hidden": true
    }), dateLabel), isToday ? subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: onGradient ? 'rgba(255,255,255,0.6)' : undefined,
            fontSize: '0.6875rem'
        }
    }, subLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-today`,
        className: onGradient ? 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold text-white/85 hover:bg-transparent hover:text-white' : 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold',
        onClick: onToday
    }, todayLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-next`,
        "aria-label": nextLabel,
        title: nextLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        title: sheetTitle || pickLabel,
        closeLabel: closeLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.JalaliCalendar), {
        value: value,
        onChange: (v)=>{
            setPickerOpen(false);
            if (v) onChange?.(v);
        }
    }), !isToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "mt-3 w-full min-h-11",
        "data-testid": `${testId}-sheet-today`,
        onClick: ()=>{
            setPickerOpen(false);
            onToday?.();
        }
    }, todayLabel)));
}

});

parcelRegister("jbdF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c3a031457b1019$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $hZDga = parcelRequire("hZDga");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $a1c3a031457b1019$export$2e2bcd8739ae039({ onSave: onSave, onCancel: onCancel, saving: saving = false, saved: saved = false, disabled: disabled = false, sticky: sticky = false, saveLabel: saveLabel, cancelLabel: cancelLabel, savedLabel: savedLabel, className: className, style: // Merged OVER the computed layout, the `Card`/messaging-family precedent
// (DESIGN.md). It used to arrive through `...rest`, which is spread after
// `style` — so a caller adding one padding value silently deleted `display`,
// `position` and the safe-area inset and took the whole bar's layout with it.
style, 'data-testid': testId = 'savebar', ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().saveBar;
    if (saveLabel === undefined) saveLabel = copy.save;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    if (savedLabel === undefined) savedLabel = copy.saved;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": saving ? 'saving' : saved ? 'saved' : 'idle',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.75rem',
            ...sticky && {
                position: 'sticky',
                bottom: 0,
                marginTop: '1rem',
                background: (0, $jTCZr.C).card,
                borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                zIndex: 5
            },
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: onSave,
        disabled: saving || disabled,
        "data-testid": `${testId}-submit`
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 16,
        thickness: 2,
        color: "currentColor"
    }), saved && !saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 16,
        "aria-hidden": true
    }), saved && !saving ? savedLabel : saveLabel), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onCancel,
        disabled: saving,
        "data-testid": `${testId}-cancel`
    }, cancelLabel));
}

});

parcelRegister("eJIXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9cbffc25828c55$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $5f9cbffc25828c55$export$2e2bcd8739ae039({ n: n, title: title, sub: sub, icon: Icon, children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...rest,
        style: {
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 18,
            boxShadow: '0 1px 2px rgba(22,39,61,.04), 0 8px 24px rgba(22,39,61,.05)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 13,
            padding: '18px 22px 0'
        }
    }, n != null && n !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: (0, $jTCZr.C).navy,
            color: '#fff',
            fontWeight: 800,
            fontSize: 14,
            display: 'grid',
            placeItems: 'center'
        }
    }, n), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 16,
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 17,
        color: (0, $jTCZr.C).teal
    }), title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, sub))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 22px 22px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, children));
}

});

parcelRegister("jFCWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e7212e133be19c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");

var $jTCZr = parcelRequire("jTCZr");

var $66joL = parcelRequire("66joL");
'use client';
function $82e7212e133be19c$export$2e2bcd8739ae039({ columns: columns = [], rows: rows = [], rowKey: rowKey, onRowClick: onRowClick, onRowActivate: onRowActivate, rowProps: rowProps, empty: empty, loading: loading = false, skeletonRows: skeletonRows = 6, dense: dense = false, ariaLabel: ariaLabel, caption: caption, sort: sort, onSort: onSort, ...rest }) {
    const rowH = dense ? 44 : 52;
    // Logical, not physical. `'end'` used to resolve to `left`, which is the end
    // of an RTL row and the START of an LTR one — so a numeric column aligned to
    // the wrong edge the moment a table rendered in English.
    const alignOf = (a)=>a === 'center' ? 'center' : a === 'end' ? 'end' : 'start';
    const isEmpty = !loading && rows.length === 0;
    // Placeholder block widths for the loading body, derived from the REAL
    // column widths so a cell's block sits where that column's content will.
    // Without this the blocks cycled a generic width list, and a 70px status
    // column drew a 120px block that the <th> then clipped — the one thing a
    // skeleton exists to avoid. A column with no declared width (the flexible
    // ones, usually the name) keeps the generic rhythm; a percentage width is
    // relative to a table whose pixel size we do not know here, so it falls
    // back too. 60% of the column, because a cell is content plus padding.
    const skeletonWidths = columns.map((col, i)=>{
        const w = col.width;
        const px = typeof w === 'number' ? w : typeof w === 'string' && /^\d+(\.\d+)?px$/.test(w) ? parseFloat(w) : null;
        if (px == null) return [
            120,
            96,
            110,
            84
        ][i % 4];
        return Math.max(32, Math.round(px * 0.6));
    });
    const activate = onRowActivate || null;
    const interactive = !!(activate || onRowClick);
    const headerCell = (col)=>{
        if (!col.sortable || !onSort) return col.header;
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onSort(key),
            className: "inline-flex items-center gap-1 bg-transparent border-0 p-0 cursor-pointer text-inherit hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded",
            style: {
                fontSize: 'inherit',
                fontWeight: 'inherit',
                fontFamily: 'inherit'
            },
            "data-active": active ? 'true' : undefined
        }, col.header, active ? sort.dir === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
            size: 13,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 13,
            "aria-hidden": true
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": loading ? 'loading' : isEmpty ? 'empty' : 'content',
        "aria-busy": loading ? 'true' : undefined,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "aria-label": caption ? undefined : ariaLabel,
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13.5
        }
    }, caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        style: {
            captionSide: 'top',
            textAlign: 'start',
            padding: '0 14px 8px',
            fontSize: 12.5,
            color: (0, $jTCZr.C).textSecondary
        }
    }, caption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, columns.map((col)=>{
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: col.key,
            scope: "col",
            "aria-sort": !col.sortable || !onSort ? undefined : active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none',
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: (0, $jTCZr.C).bg,
                color: (0, $jTCZr.C).textSecondary,
                fontWeight: 700,
                fontSize: 12.5,
                textAlign: alignOf(col.align),
                padding: '10px 14px',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                width: col.width,
                whiteSpace: 'nowrap'
            }
        }, headerCell(col));
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: skeletonRows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRow), {
            key: i,
            cols: columns.length,
            widths: skeletonWidths,
            dense: dense
        }))), !loading && !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>{
        const extra = rowProps ? rowProps(row, i) || {} : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowKey ? rowKey(row, i) : row.id ?? i,
            onClick: interactive ? ()=>(activate || onRowClick)(row) : undefined,
            // Hover and focus are CSS states. The onMouseEnter/onMouseLeave
            // pair this replaces mutated inline styles — which §1.3 forbids,
            // and which left a row stuck highlighted whenever the pointer
            // left during a re-render.
            className: interactive ? 'transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring' : undefined,
            ...activate ? {
                tabIndex: 0,
                role: 'link',
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        activate(row);
                    }
                }
            } : null,
            ...extra,
            style: {
                height: rowH,
                cursor: interactive ? 'pointer' : 'default',
                ...extra.style
            }
        }, columns.map((col)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: col.key,
                style: {
                    textAlign: alignOf(col.align),
                    padding: '8px 14px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                    color: (0, $jTCZr.C).textPrimary,
                    verticalAlign: 'middle'
                }
            }, col.render ? col.render(row, i) : row[col.key])));
    })))), isEmpty && empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, empty) : null);
}

});
parcelRegister("azOWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8899ae39ae38a1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7f8899ae39ae38a1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $7f8899ae39ae38a1$export$2e2bcd8739ae039 = (0, $9QBug.default)("chevron-up", $7f8899ae39ae38a1$export$3efd853dbb351e94);

});


parcelRegister("fYgeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $24dfcaee8d76ee07$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $24dfcaee8d76ee07$export$2e2bcd8739ae039({ options: options = [], value: value, onChange: onChange, size: size = 'md', semantics: semantics = 'tabs', ariaLabel: ariaLabel, ...rest }) {
    const h = size === 'lg' ? 44 : size === 'sm' ? 32 : 36;
    const isFilter = semantics === 'filter';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const move = (delta)=>{
        const enabled = options.filter((o)=>!o.disabled);
        if (!enabled.length) return;
        const at = enabled.findIndex((o)=>o.value === value);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next) onChange?.(next.value);
    };
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') {
            const enabled = options.filter((o)=>!o.disabled);
            const target = e.key === 'Home' ? enabled[0] : enabled[enabled.length - 1];
            if (target) onChange?.(target.value);
            return;
        }
        // Direction from the DOM, not an assumption: the visual "next" option is on
        // the left in an RTL group and on the right in an LTR one.
        const rtl = ref.current ? getComputedStyle(ref.current).direction === 'rtl' : true;
        const forward = rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
        move(forward ? 1 : -1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        ref: ref,
        role: isFilter ? 'radiogroup' : 'tablist',
        "aria-label": ariaLabel,
        onKeyDown: onKeyDown,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            background: (0, $jTCZr.C).bg,
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, options.map((opt)=>{
        const active = opt.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            role: isFilter ? 'radio' : 'tab',
            ...isFilter ? {
                'aria-checked': active
            } : {
                'aria-selected': active
            },
            // Roving tabindex: the group is ONE tab stop and the arrows move
            // inside it. Without this every option is its own stop, so tabbing
            // past a six-option filter takes six presses.
            tabIndex: active ? 0 : -1,
            disabled: opt.disabled,
            "data-state": active ? 'active' : 'inactive',
            onClick: ()=>!opt.disabled && onChange?.(opt.value),
            className: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            style: {
                height: h,
                padding: size === 'sm' ? '0 12px' : '0 16px',
                border: 'none',
                cursor: opt.disabled ? 'not-allowed' : 'pointer',
                borderRadius: 9,
                fontSize: size === 'sm' ? 12.5 : 13.5,
                fontWeight: 700,
                fontFamily: 'inherit',
                background: active ? '#fff' : 'transparent',
                color: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                boxShadow: active ? '0 1px 3px rgba(22,39,61,.12)' : 'none',
                opacity: opt.disabled ? 0.5 : 1,
                transition: 'all .15s',
                whiteSpace: 'nowrap'
            }
        }, opt.label);
    }));
}

});

parcelRegister("hILSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bca3244df749c49$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");
'use client';
// The page's own numerals — the digit set the date picker draws for `<html lang>`.
const $7bca3244df749c49$var$pageNum = (n)=>(0, $IZwml.withDigits)(String(Math.trunc(Number(n))), (0, $IZwml.datePickerLocale)().digits);
function $7bca3244df749c49$export$2e2bcd8739ae039({ page: page = 1, pageCount: pageCount, total: total, pageSize: pageSize = 20, onChange: onChange, prevLabel: prevLabel, nextLabel: nextLabel, pageLabel: pageLabel, formatNumber: formatNumber = $7bca3244df749c49$var$pageNum }) {
    const copy = (0, $j9AxR.kitCopy)().pager;
    if (prevLabel === undefined) prevLabel = copy.prev;
    if (nextLabel === undefined) nextLabel = copy.next;
    if (pageLabel === undefined) pageLabel = copy.page;
    const pages = pageCount ?? Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const go = (p)=>{
        if (p >= 1 && p <= pages && p !== page) onChange?.(p);
    };
    const btn = (label, target, disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>go(target),
            disabled: disabled,
            style: {
                minWidth: 34,
                height: 34,
                padding: '0 10px',
                borderRadius: 9,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                background: '#fff',
                cursor: disabled ? 'default' : 'pointer',
                color: disabled ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
                fontFamily: 'inherit',
                fontSize: 13,
                opacity: disabled ? 0.5 : 1
            }
        }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '12px 0'
        }
    }, btn(prevLabel, page - 1, page <= 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textSecondary,
            fontWeight: 600,
            padding: '0 6px'
        }
    }, pageLabel(formatNumber(page), formatNumber(pages))), btn(nextLabel, page + 1, page >= pages));
}

});

parcelRegister("cjPik", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3d370aebf1b917$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4fYdd = parcelRequire("4fYdd");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $ab3d370aebf1b917$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, confirmDisabled: confirmDisabled = false, onConfirm: onConfirm, children: children, confirmTestId: confirmTestId, cancelTestId: cancelTestId, ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().confirm;
    if (confirmLabel === undefined) confirmLabel = copy.confirm;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "sm",
        showClose: false,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, title)), typeof description === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "text-sm text-muted-foreground leading-6"
    }, description) : description || null, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "mt-4"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "mt-6 flex gap-2 justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: destructive ? 'destructive' : 'default',
        disabled: loading || confirmDisabled,
        onClick: onConfirm,
        "data-testid": confirmTestId
    }, confirmLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        disabled: loading,
        autoFocus: true,
        onClick: ()=>onOpenChange?.(false),
        "data-testid": cancelTestId
    }, cancelLabel))));
}

});

parcelRegister("dOauK", function(module, exports) {

$parcel$export(module.exports, "default", () => $35331361c3270146$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Inline alert / callout banner (zone ②). Tokened bg/ink per variant — never raw hex.
 *
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'neutral'
 *   title    — optional bold lead line
 *   icon     — optional leading lucide node
 *   action   — optional trailing node (e.g. a Button)
 *   children — body content
 */ const $35331361c3270146$var$VARIANT = {
    info: {
        bg: (0, $jTCZr.CT).accentSoft,
        ink: (0, $jTCZr.CT).accentInk
    },
    success: {
        bg: (0, $jTCZr.CT).goodSoft,
        ink: (0, $jTCZr.CT).goodInk
    },
    warning: {
        bg: (0, $jTCZr.CT).warnSoft,
        ink: (0, $jTCZr.CT).warnInk
    },
    error: {
        bg: (0, $jTCZr.CT).dangerSoft,
        ink: (0, $jTCZr.CT).dangerInk
    },
    neutral: {
        bg: (0, $jTCZr.CT).surface2,
        ink: (0, $jTCZr.CT).ink2
    }
};
function $35331361c3270146$export$2e2bcd8739ae039({ variant: variant = 'info', title: title, icon: icon, action: action, children: children, style: style, ...rest }) {
    const v = $35331361c3270146$var$VARIANT[variant] || $35331361c3270146$var$VARIANT.info;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: v.bg,
            color: v.ink,
            padding: '11px 16px',
            borderRadius: 12,
            fontSize: 13,
            ...style
        }
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            marginBottom: children ? 4 : 0
        }
    }, title), children), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, action));
}

});

parcelRegister("2vXUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbee9b1abdcb86a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $3cbee9b1abdcb86a$export$2e2bcd8739ae039({ icon: icon, title: title, description: description, onRetry: onRetry, retryLabel: retryLabel, fill: fill = false, style: style, ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().errorState;
    if (title === undefined) title = copy.title;
    if (retryLabel === undefined) retryLabel = copy.retry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": "error",
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-flex',
            marginBottom: 16,
            color: (0, $jTCZr.C).red
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 44
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 16
        }
    }, description), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onRetry
    }, retryLabel));
}

});
parcelRegister("QG9Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66de94054a4f331$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f66de94054a4f331$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $f66de94054a4f331$export$2e2bcd8739ae039 = (0, $9QBug.default)("triangle-alert", $f66de94054a4f331$export$3efd853dbb351e94);

});


parcelRegister("2tqZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a user is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • sizes and weights are the documented type roles (hero / metric / body /
//     caption). The kit cannot import an app's `type` module, so the values are
//     inlined with the role named beside them — never a size chosen for this
//     component alone,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $46e1ac2ff7a7c6a8$var$TONES = {
    neutral: ()=>({
            fg: (0, $jTCZr.C).textMuted,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $jTCZr.C).navy,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight
        }),
    danger: ()=>({
            fg: (0, $jTCZr.C).red,
            bg: (0, $jTCZr.C).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $46e1ac2ff7a7c6a8$var$DISC = 56;
// The documented type roles, at their default-setting values. The kit cannot
// import an app's `constants/typography`, so the scale is restated here rather
// than sizes being invented per component — spread it exactly as an app spreads
// `type.*`, and the two surfaces stay identical.
const $46e1ac2ff7a7c6a8$var$TYPE = {
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    body: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.85
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    }
};
function $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($46e1ac2ff7a7c6a8$var$TONES[tone] || $46e1ac2ff7a7c6a8$var$TONES.neutral)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // user was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: '2rem 1.25rem',
            background: (0, $jTCZr.C).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '2.5rem 2rem 2rem',
            maxWidth: '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: (0, $jTCZr.SHADOW).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $46e1ac2ff7a7c6a8$var$DISC,
            height: $46e1ac2ff7a7c6a8$var$DISC,
            borderRadius: (0, $jTCZr.RADIUS).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.body,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46e1ac2ff7a7c6a8$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the user decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $jTCZr.C).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $46e1ac2ff7a7c6a8$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $46e1ac2ff7a7c6a8$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $46e1ac2ff7a7c6a8$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}

});

parcelRegister("coDoE", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $dfuoR = parcelRequire("dfuoR");

var $2tqZa = parcelRequire("2tqZa");

var $j9AxR = parcelRequire("j9AxR");
'use client';
class $10231e94a06472aa$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack. `error.stack` points at the component that
        // threw, not the tree that rendered it — and for a shared primitive
        // (Button, Card) the latter is the only part identifying WHICH screen is
        // broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $10231e94a06472aa$export$2e2bcd8739ae039({ children: children, resetKey: resetKey, title: title, body: body, retryLabel: retryLabel, showRetry: showRetry = true, actions: actions = [], footer: footer, fullscreen: fullscreen = false, onError: onError, testId: testId = 'error-boundary' }) {
    if (title === undefined) title = (0, $j9AxR.kitCopy)().errorBoundary.title;
    if (body === undefined) body = (0, $j9AxR.kitCopy)().errorBoundary.body;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().errorBoundary.retry;
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2tqZa.default), {
            testId: testId,
            tone: "danger",
            fullscreen: fullscreen,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfuoR.default), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: title,
            body: body,
            // The message, not the stack: a user cannot read a stack, and the message
            // is the part that lets support reproduce it. The stack is in the console
            // for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                ...showRetry ? [
                    {
                        key: 'retry',
                        label: retryLabel,
                        onClick: reset,
                        variant: 'primary',
                        testId: `${testId}-retry`
                    }
                ] : [],
                ...actions
            ],
            footer: footer
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($10231e94a06472aa$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        onError: onError
    }, children);
}

});
parcelRegister("dfuoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5539f6bdf6973c1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b5539f6bdf6973c1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
            key: "1fd625"
        }
    ]
];
const $b5539f6bdf6973c1$export$2e2bcd8739ae039 = (0, $9QBug.default)("octagon-alert", $b5539f6bdf6973c1$export$3efd853dbb351e94);

});


parcelRegister("fx6O8", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $dcn2F = parcelRequire("dcn2F");
var $aks7U = parcelRequire("aks7U");
var $5kK4h = parcelRequire("5kK4h");
var $6JkDX = parcelRequire("6JkDX");

var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $3EHig = parcelRequire("3EHig");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Without one, a dropped connection produces N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it comes back, so the user's only strategy is to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — which in a
//   clinical app is often the patient's name, not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a user can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS = 4000;
const $0790d8ae08647dfa$var$VARIANTS = {
    [(0, $3EHig.ConnectionState).OFFLINE]: {
        Icon: (0, $6JkDX.default),
        bg: (0, $jTCZr.C).red,
        fg: '#fff',
        testId: 'connectivity-offline'
    },
    [(0, $3EHig.ConnectionState).DEGRADED]: {
        Icon: (0, $dcn2F.default),
        bg: (0, $jTCZr.C).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // ink the kit already pairs with a warning surface — a hand-mixed brown
        // here is how a second, slightly-off warning colour enters a design system.
        fg: (0, $jTCZr.CT).warnInk,
        testId: 'connectivity-degraded'
    }
};
function $0790d8ae08647dfa$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy, offlineLabel: offlineLabel, degradedLabel: degradedLabel, restoredLabel: restoredLabel, retryLabel: retryLabel, busyLabel: busyLabel }) {
    if (offlineLabel === undefined) offlineLabel = (0, $j9AxR.kitCopy)().connectivity.offline;
    if (degradedLabel === undefined) degradedLabel = (0, $j9AxR.kitCopy)().connectivity.degraded;
    if (restoredLabel === undefined) restoredLabel = (0, $j9AxR.kitCopy)().connectivity.restored;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().connectivity.retry;
    if (busyLabel === undefined) busyLabel = (0, $j9AxR.kitCopy)().connectivity.busy;
    const disconnected = state !== (0, $3EHig.ConnectionState).ONLINE;
    const LABELS = {
        [(0, $3EHig.ConnectionState).OFFLINE]: offlineLabel,
        [(0, $3EHig.ConnectionState).DEGRADED]: degradedLabel
    };
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $0790d8ae08647dfa$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, testId: testId } = variant;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 15,
            strokeWidth: 2.2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, LABELS[state]), onRetry && // The kit Button at `sm`, not a hand-rolled pill. It sits on a
        // coloured bar rather than the page, so `currentColor` carries the
        // bar's ink through — the only thing the variants cannot know — and
        // height, radius, type, focus ring and disabled state all come from
        // the kit like every other button.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            variant: "ghost",
            onClick: onRetry,
            disabled: busy,
            "data-testid": "connectivity-retry",
            style: {
                marginInlineStart: 'auto',
                color: fg,
                border: '1px solid currentColor',
                background: 'transparent',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aks7U.default), {
            size: 12,
            "aria-hidden": true,
            style: busy ? {
                animation: 'connectivity-spin 0.9s linear infinite'
            } : undefined
        }), busy ? busyLabel : retryLabel));
    }
    if (recovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
        bg: (0, $jTCZr.C).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5kK4h.default), {
        size: 15,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, restoredLabel));
    return null;
}
function $0790d8ae08647dfa$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A user mid-sentence must not have their
        // screen reader interrupted by an infrastructure notice — the connection
        // dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            fontSize: '0.75rem',
            fontWeight: 600,
            flexShrink: 0,
            zIndex: 40
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'), children);
}

});
parcelRegister("dcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c0fad7e9511576$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $07c0fad7e9511576$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057",
            key: "1uxyv8"
        }
    ],
    [
        "path",
        {
            d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78",
            key: "99tcn7"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $07c0fad7e9511576$export$2e2bcd8739ae039 = (0, $9QBug.default)("cloud-off", $07c0fad7e9511576$export$3efd853dbb351e94);

});

parcelRegister("aks7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b330d9ae0cfa5e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $96b330d9ae0cfa5e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $96b330d9ae0cfa5e$export$2e2bcd8739ae039 = (0, $9QBug.default)("refresh-cw", $96b330d9ae0cfa5e$export$3efd853dbb351e94);

});

parcelRegister("5kK4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44aa7a4ced52702$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f44aa7a4ced52702$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const $f44aa7a4ced52702$export$2e2bcd8739ae039 = (0, $9QBug.default)("wifi", $f44aa7a4ced52702$export$3efd853dbb351e94);

});

parcelRegister("6JkDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b17daf5c0ea500$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $34b17daf5c0ea500$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 5.17-2.69",
            key: "1dl1wf"
        }
    ],
    [
        "path",
        {
            d: "M19 12.859a10 10 0 0 0-2.007-1.523",
            key: "4k23kn"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 4.177-2.643",
            key: "1grhjp"
        }
    ],
    [
        "path",
        {
            d: "M22 8.82a15 15 0 0 0-11.288-3.764",
            key: "z3jwby"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $34b17daf5c0ea500$export$2e2bcd8739ae039 = (0, $9QBug.default)("wifi-off", $34b17daf5c0ea500$export$3efd853dbb351e94);

});

parcelRegister("3EHig", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", () => $2a96b0bae45a4311$export$cd9c3c6bf535afc9);

var $acw62 = parcelRequire("acw62");

var $2sptB = parcelRequire("2sptB");
// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $2a96b0bae45a4311$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $2a96b0bae45a4311$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $2a96b0bae45a4311$var$PROBE_MIN_MS = 3000;
const $2a96b0bae45a4311$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would put a network banner in front of a user whose session
 * simply expired, which is a different problem with different copy.
 */ async function $2a96b0bae45a4311$var$probeBff(url, signal) {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $2a96b0bae45a4311$export$a32c5b7f472865fb({ url: url } = {}) {
    const [state, setState] = (0, $acw62.useState)(()=>$2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($2a96b0bae45a4311$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($2a96b0bae45a4311$var$isBrowserOffline()) {
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS);
        const reachable = url ? await $2a96b0bae45a4311$var$probeBff(url, controller.signal) : true;
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $2a96b0bae45a4311$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline,
        url
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $2sptB.onTransportFailure)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($2a96b0bae45a4311$var$isBrowserOffline()) setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $2a96b0bae45a4311$export$2e2bcd8739ae039 = $2a96b0bae45a4311$export$a32c5b7f472865fb;

});
parcelRegister("2sptB", function(module, exports) {

$parcel$export(module.exports, "onTransportFailure", () => $1ca1f567c505cbd8$export$288ba6b4215d30f3);
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $1ca1f567c505cbd8$var$listeners = new Set();
function $1ca1f567c505cbd8$export$288ba6b4215d30f3(listener) {
    $1ca1f567c505cbd8$var$listeners.add(listener);
    return ()=>$1ca1f567c505cbd8$var$listeners.delete(listener);
}
function $1ca1f567c505cbd8$export$87a8bdb1d0a966cf() {
    for (const listener of $1ca1f567c505cbd8$var$listeners)try {
        listener();
    } catch  {}
}
function $1ca1f567c505cbd8$export$d433e139d37a5376() {
    $1ca1f567c505cbd8$var$listeners.clear();
}

});



parcelRegister("5MbI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $26386601b5f40a7d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Square icon-only button with a ≥44px touch target (mobile-safe) and a required
 * accessible label. `onGradient` variant is the white-alpha control for gradient
 * headers (§3.2). Encapsulates the affordance so screens never hand-roll a raw <button>.
 *
 * Props:
 *   icon     — lucide node (required)
 *   label    — accessible label / tooltip (required)
 *   variant  — 'default' | 'ghost' | 'outline' | 'onGradient'
 *   size     — px (default 44 — the mobile minimum)
 *   onClick, disabled
 */ const $26386601b5f40a7d$var$VARIANT = {
    default: {
        background: (0, $jTCZr.C).navy,
        color: '#fff',
        border: 'none'
    },
    ghost: {
        background: 'transparent',
        color: (0, $jTCZr.C).textSecondary,
        border: 'none'
    },
    outline: {
        background: (0, $jTCZr.C).card,
        color: (0, $jTCZr.C).textPrimary,
        border: `1px solid ${(0, $jTCZr.C).border}`
    },
    onGradient: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none'
    }
};
function $26386601b5f40a7d$export$2e2bcd8739ae039({ icon: icon, label: label, onClick: onClick, variant: variant = 'default', size: size = 44, disabled: disabled = false, style: style, ...rest }) {
    const v = $26386601b5f40a7d$var$VARIANT[variant] || $26386601b5f40a7d$var$VARIANT.default;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ...rest,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        title: label,
        style: {
            width: size,
            height: size,
            minWidth: size,
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            flexShrink: 0,
            fontFamily: 'inherit',
            ...v,
            ...style
        }
    }, icon);
}

});

parcelRegister("hsrVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b6fb81a56105b0d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g4t5 = parcelRequire("8g4t5");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $9b6fb81a56105b0d$export$2e2bcd8739ae039({ label: label, icon: icon, onClick: onClick, minHeight: minHeight = 118, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        style: {
            width: '100%',
            minHeight: minHeight,
            padding: 16,
            background: 'transparent',
            border: `1.5px dashed ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            cursor: 'pointer',
            color: (0, $jTCZr.C).navy,
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: 14,
            ...style
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 22
    }), label);
}

});
parcelRegister("8g4t5", function(module, exports) {

$parcel$export(module.exports, "default", () => $83905746e46531b9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $83905746e46531b9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $83905746e46531b9$export$2e2bcd8739ae039 = (0, $9QBug.default)("plus", $83905746e46531b9$export$3efd853dbb351e94);

});


parcelRegister("cT2Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d47a2201c3cd6a9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $0d47a2201c3cd6a9$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, disabled: disabled = false, label: label, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "switch",
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-label": label,
        onClick: ()=>{
            if (!disabled) onChange?.(!checked);
        },
        style: {
            width: 44,
            height: 24,
            borderRadius: 4,
            flexShrink: 0,
            position: 'relative',
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .25s',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 3,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            right: checked ? 3 : 23,
            transition: 'right .25s'
        }
    }));
}

});

parcelRegister("lxEfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2358e3acbc4a7e55$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $2358e3acbc4a7e55$export$2e2bcd8739ae039({ title: title, badge: badge, defaultOpen: defaultOpen = false, open: controlledOpen, onOpenChange: onOpenChange, children: children, style: style }) {
    const [uncontrolled, setUncontrolled] = (0, $acw62.useState)(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : uncontrolled;
    const toggle = ()=>{
        const next = !open;
        if (onOpenChange) onOpenChange(next);
        if (controlledOpen === undefined) setUncontrolled(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: toggle,
        "aria-expanded": open,
        style: {
            width: '100%',
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700,
            fontSize: 14.5,
            color: (0, $jTCZr.C).textPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        }
    }, title, badge != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.C).teal,
            fontSize: 12
        }
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 18,
        color: (0, $jTCZr.C).textMuted,
        style: {
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s'
        }
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: 8
        }
    }, children));
}

});

parcelRegister("fW63i", function(module, exports) {

$parcel$export(module.exports, "default", () => $c173fca63c358943$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PrizeWheel — a wheel of fortune: N equal slices that spin and stop on one.
//
// Domain-free on purpose. The kit draws a circle and turns it; it knows nothing
// about prizes, wallets, campaigns or Parseh. The caller hands it the slices it
// should print and the slice it should land on, and is told when the wheel has
// stopped.
//
//   segments     [{ index, label }] in index order — position i IS slice i.
//                Labels arrive FORMATTED: Persian digits go through the app's
//                own digit seam (rule 7), never through the kit.
//   targetIndex  the winning slice, or null while nobody knows it yet. The
//                SERVER picks it; the wheel only animates to it.
//   spinning     whether the wheel should be turning. With a target but no
//                spin the wheel sits AT the result — that is how an already
//                spun draw is re-shown without replaying the animation.
//   onSettled    fired once, when the spin has stopped.
//   size         pixel diameter (it still shrinks to its container).
//
// ── Geometry ────────────────────────────────────────────────────────────────
// One 400×400 viewBox, so every number below is a user unit and the whole wheel
// scales with `size` — including the label type, which is why the labels do not
// need a second size prop. Slice i runs from `i·step − 90°` (SVG angles start
// at 3 o'clock and grow clockwise, so −90° is 12 o'clock) clockwise by one
// step. A label is rotated onto its slice's mid-angle and flipped 180° through
// the bottom half of the wheel, because a label that is merely rotated is
// upside down for half the circle.
//
// ── Motion ──────────────────────────────────────────────────────────────────
// ONE CSS transition on the slice group: θ = 5 full turns + (360 − the centre
// angle of the winning slice), so the slice's middle finishes under the pointer
// at 12 o'clock. The turns accumulate, so a wheel that is spun twice keeps
// turning the same way instead of unwinding.
//
// **Clockwise whatever the document's direction is.** Rule 8 is about layout
// and about content that carries direction; a wheel has neither. What the eye
// tracks is the pointer, and an RTL page that spun the other way would read as
// a different mechanism, not as a mirrored one.
//
// `prefers-reduced-motion: reduce` removes the transition (the BottomSheet /
// Dialog / Skeleton pattern: a media query in the kit's own stylesheet), so the
// wheel JUMPS to its result. `transitionend` then never fires — hence the
// timer, which is the real settle signal and the transition's is the early one.
// Whichever arrives first wins; `onSettled` is called exactly once per spin.
//
// ── Colour ──────────────────────────────────────────────────────────────────
// Four brand tones, cycled, with the label ink flipped against them so both
// pass contrast. The inks are `C.card` on the two filled tones and
// `var(--panel-ink)` on the two tints — the panel's deep ink rather than
// `CT.accentInk`, because an accent preset may NOT re-tint `--panel-ink`
// (tokens.css) while it does re-tint `--p-navy-dark`: under the فیروزه‌ای preset
// `accentInk` on a tint falls to ~3.9:1, and `--panel-ink` holds above 11:1
// under every preset and every panel.
// ─────────────────────────────────────────────────────────────────────────────
const $c173fca63c358943$var$CX = 200;
const $c173fca63c358943$var$CY = 200;
const $c173fca63c358943$var$R_SLICE = 190; // the coloured slices
const $c173fca63c358943$var$R_RIM = 196; // the white rim they sit on
const $c173fca63c358943$var$R_LABEL = 128; // where a slice prints its label
const $c173fca63c358943$var$R_HUB = 34; // the white hub cap
const $c173fca63c358943$var$R_HUB_INNER = 22;
const $c173fca63c358943$var$R_PIP = 9;
const $c173fca63c358943$var$TURNS = 5;
const $c173fca63c358943$var$SPIN_MS = 4000;
const $c173fca63c358943$var$SPIN_EASE = 'cubic-bezier(0.17, 0.67, 0.12, 1)';
// The transition's own `transitionend` is the early signal; this is the one
// that is always sent. The grace covers the frame between committing the
// rotation and the browser starting to paint it.
const $c173fca63c358943$var$SETTLE_GRACE_MS = 200;
const $c173fca63c358943$var$REDUCED_SETTLE_MS = 50;
const $c173fca63c358943$var$FILLS = [
    (0, $jTCZr.C).navy,
    (0, $jTCZr.C).tealLight,
    (0, $jTCZr.C).navyDark,
    (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
];
const $c173fca63c358943$var$INKS = [
    (0, $jTCZr.C).card,
    'var(--panel-ink)',
    (0, $jTCZr.C).card,
    'var(--panel-ink)'
];
const $c173fca63c358943$var$DISC_CSS = `
  [data-prize-disc] { transform-origin: ${$c173fca63c358943$var$CX}px ${$c173fca63c358943$var$CY}px; }
  [data-prize-disc][data-spinning="true"] { transition: transform ${$c173fca63c358943$var$SPIN_MS}ms ${$c173fca63c358943$var$SPIN_EASE}; }
  @media (prefers-reduced-motion: reduce) {
    [data-prize-disc][data-spinning="true"] { transition: none !important; }
  }
`;
// One stylesheet for every wheel on the page: React 19 hoists a <style> with
// `href` + `precedence` into <head> once (the Skeleton family does the same).
const $c173fca63c358943$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-prize-wheel",
        precedence: "default"
    }, $c173fca63c358943$var$DISC_CSS);
// Reduced motion, read in JS — only to choose how long to wait for a spin that
// the media query above has already cancelled. Defensive like the clinical
// module's `prefersInstant()`: with no window and no `matchMedia` there is no
// animation to wait for either, so "reduced" is the safe answer.
function $c173fca63c358943$var$prefersReducedMotion() {
    if (typeof window === 'undefined') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
const $c173fca63c358943$var$pol = (deg, r)=>{
    const t = deg * Math.PI / 180;
    return [
        $c173fca63c358943$var$CX + r * Math.cos(t),
        $c173fca63c358943$var$CY + r * Math.sin(t)
    ];
};
// The angle the disc must come to rest at, from zero, for slice `index` of
// `count` to face the pointer: whole turns for the show, then back to the
// slice's own middle.
function $c173fca63c358943$var$angleFor(index, count) {
    const step = 360 / count;
    return $c173fca63c358943$var$TURNS * 360 + (360 - (index * step + step / 2));
}
function $c173fca63c358943$export$2e2bcd8739ae039({ segments: segments = [], targetIndex: targetIndex = null, spinning: spinning = false, onSettled: onSettled, size: size = 320, label: // Rule 7: the app passes its own; unset, the kit's word in `<html lang>`.
label, className: className, style: style, ...rest }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().prizeWheel.label;
    const slices = Array.isArray(segments) ? segments : [];
    const count = slices.length;
    const step = count > 0 ? 360 / count : 0;
    const target = Number.isInteger(targetIndex) && targetIndex >= 0 && targetIndex < count ? targetIndex : null;
    const spin = Boolean(spinning) && target != null;
    const [rotation, setRotation] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // The live callback, so a caller that passes a fresh closure every render
    // does not re-arm the timer mid-spin.
    const onSettledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onSettled);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onSettledRef.current = onSettled;
    });
    // The armed settle, shared with `transitionend`; null when no spin is running.
    const settleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (target == null) {
            setRotation(0);
            return;
        }
        // Drop the fraction of a turn the disc is already at, then add whole turns:
        // the rotation only ever grows, so the wheel never runs backwards.
        setRotation((prev)=>prev - prev % 360 + $c173fca63c358943$var$angleFor(target, count));
    }, [
        target,
        count
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!spin) return undefined;
        let fired = false;
        const fire = ()=>{
            if (fired) return;
            fired = true;
            onSettledRef.current?.();
        };
        settleRef.current = fire;
        const timer = setTimeout(fire, $c173fca63c358943$var$prefersReducedMotion() ? $c173fca63c358943$var$REDUCED_SETTLE_MS : $c173fca63c358943$var$SPIN_MS + $c173fca63c358943$var$SETTLE_GRACE_MS);
        return ()=>{
            clearTimeout(timer);
            settleRef.current = null;
        };
    }, [
        spin,
        target
    ]);
    // Under two slices there is no wheel to draw — the arc flag below describes a
    // minor arc, and a single slice has no arc at all. Nothing is drawn rather
    // than something misleading, as `Sparkline` does with a single point.
    if (count < 2) return null;
    const paths = [];
    const labels = [];
    for(let i = 0; i < count; i += 1){
        const from = i * step - 90;
        const to = from + step;
        const mid = from + step / 2;
        const [x0, y0] = $c173fca63c358943$var$pol(from, $c173fca63c358943$var$R_SLICE);
        const [x1, y1] = $c173fca63c358943$var$pol(to, $c173fca63c358943$var$R_SLICE);
        const [lx, ly] = $c173fca63c358943$var$pol(mid, $c173fca63c358943$var$R_LABEL);
        // Through the bottom half of the wheel a label rotated onto its slice reads
        // upside down; turning it over keeps every label the right way up.
        const upright = mid > 90 && mid < 270 ? mid + 180 : mid;
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            key: `slice-${i}`,
            d: `M${$c173fca63c358943$var$CX},${$c173fca63c358943$var$CY} L${x0.toFixed(2)},${y0.toFixed(2)} A${$c173fca63c358943$var$R_SLICE},${$c173fca63c358943$var$R_SLICE} 0 0 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z`,
            fill: $c173fca63c358943$var$FILLS[i % $c173fca63c358943$var$FILLS.length],
            stroke: (0, $jTCZr.C).card,
            strokeWidth: 3
        }));
        labels.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: `label-${i}`,
            transform: `translate(${lx.toFixed(2)} ${ly.toFixed(2)}) rotate(${upright.toFixed(2)})`,
            fill: $c173fca63c358943$var$INKS[i % $c173fca63c358943$var$INKS.length],
            fontSize: 17,
            fontWeight: 700,
            textAnchor: "middle",
            dominantBaseline: "middle"
        }, slices[i]?.label));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c173fca63c358943$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 400 400",
        // The pointer sits above the disc, outside the box.
        style: {
            display: 'block',
            overflow: 'visible',
            maxWidth: '100%',
            height: 'auto',
            ...style
        },
        className: (0, $5JYPc.cn)(className),
        role: "img",
        "aria-label": label,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_RIM,
        fill: (0, $jTCZr.C).card,
        stroke: (0, $jTCZr.C).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "data-prize-disc": "",
        "data-spinning": spin ? 'true' : 'false',
        style: {
            transform: `rotate(${rotation}deg)`
        },
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'transform') settleRef.current?.();
        }
    }, paths, labels), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB,
        fill: (0, $jTCZr.C).card,
        stroke: (0, $jTCZr.C).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB_INNER,
        fill: (0, $jTCZr.C).teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_PIP,
        fill: (0, $jTCZr.C).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M182,-2 L218,-2 L200,34 Z",
        fill: (0, $jTCZr.C).navy,
        stroke: (0, $jTCZr.C).card,
        strokeWidth: 3,
        strokeLinejoin: "round"
    })));
}

});

parcelRegister("jM6yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7c85561d054b68$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fzlbJ = parcelRequire("fzlbJ");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $8jE1c = parcelRequire("8jE1c");
var $he6AI = parcelRequire("he6AI");
var $6TdpC = parcelRequire("6TdpC");

var $aJ1FU = parcelRequire("aJ1FU");

var $5MbI8 = parcelRequire("5MbI8");

var $7phmx = parcelRequire("7phmx");

var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
const $ad7c85561d054b68$export$d8640b1e4d69af25 = [
    'queued',
    'preparing',
    'sending',
    'done',
    'failed'
];
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5); a mouse keeps `sm`.
const $ad7c85561d054b68$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $ad7c85561d054b68$var$SIZES = {
    regular: {
        padBlock: '1.75rem',
        icon: 28
    },
    compact: {
        padBlock: '1rem',
        icon: 20
    }
};
// ── accept matching ─────────────────────────────────────────────────────────
function $ad7c85561d054b68$var$acceptTokens(accept) {
    if (!accept) return [];
    const list = Array.isArray(accept) ? accept : String(accept).split(',');
    return list.map((t)=>String(t).trim().toLowerCase()).filter(Boolean);
}
function $ad7c85561d054b68$export$b4699969e89702eb(file, accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    if (tokens.length === 0) return true;
    const name = String(file?.name || '').toLowerCase();
    const type = String(file?.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
// `null`, '' and [] mean "no filter" — and no `accept` attribute on the input.
function $ad7c85561d054b68$var$acceptAttr(accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    return tokens.length ? tokens.join(',') : undefined;
}
function $ad7c85561d054b68$var$isImage(file) {
    return !!file && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/');
}
function $ad7c85561d054b68$export$8c95ef2c56e9a241({ name: name, meta: meta, phase: phase = 'queued', progress: progress, progressLabel: progressLabel, error: error, file: file, previewUrl: previewUrl, badge: badge, removable: removable, replaceable: replaceable = false, trailing: trailing, busy: busy = false, disabled: disabled = false, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, phaseLabels: phaseLabels, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, as: Tag = 'li', className: className, 'data-testid': testId, ...rest }) {
    if (removeLabel === undefined) removeLabel = (0, $j9AxR.kitCopy)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $j9AxR.kitCopy)().files.replace;
    const labels = {
        ...(0, $j9AxR.kitCopy)().files.phases,
        ...phaseLabels
    };
    const phaseLabel = labels[phase] ?? phase;
    // A thumbnail for an image File, created here and revoked when the row
    // leaves or the file changes — a leaked object URL holds the whole blob.
    const [objectUrl, setObjectUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wantsObjectUrl = !previewUrl && !badge && $ad7c85561d054b68$var$isImage(file);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!wantsObjectUrl || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
            setObjectUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return ()=>{
            if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
        };
    }, [
        file,
        wantsObjectUrl
    ]);
    const thumbSrc = previewUrl || (wantsObjectUrl ? objectUrl : null);
    const canRemove = (removable ?? phase !== 'done') && !busy && typeof onRemove === 'function';
    const canRetry = phase === 'failed' && !!file && !busy && typeof onRetry === 'function';
    const canReplace = replaceable && !busy && typeof onReplace === 'function';
    const hasBar = typeof progress === 'number' && Number.isFinite(progress);
    const pct = hasBar ? Math.max(0, Math.min(100, progress)) : 0;
    const phaseColor = phase === 'failed' ? (0, $jTCZr.CT).dangerInk : phase === 'done' ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.C).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "data-testid": testId,
        "data-state": phase,
        "aria-live": "polite",
        className: (0, $5JYPc.cn)('flex items-center', className),
        style: {
            gap: '0.625rem',
            paddingBlock: '0.5rem',
            paddingInline: '0.625rem',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.C).card,
            minWidth: 0,
            opacity: disabled ? 0.6 : 1
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "flex items-center justify-center overflow-hidden",
        style: {
            flexShrink: 0,
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $jTCZr.RADIUS).chip,
            background: (0, $jTCZr.C).bg,
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.625rem',
            fontWeight: 800
        }
    }, badge ? badge : thumbSrc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: thumbSrc,
        alt: "",
        "data-testid": testId ? `${testId}-thumb` : undefined,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 18,
        strokeWidth: 1.5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col",
        style: {
            flex: 1,
            minWidth: 0,
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-start",
        style: {
            unicodeBidi: 'isolate',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), error ? // Keyed on the text: a CHANGED error remounts and is announced once;
    // an unchanged one re-rendering stays quiet.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        key: String(error),
        role: "alert",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).dangerInk,
            lineHeight: 1.5
        }
    }, error) : meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, meta) : null, hasBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct,
        "aria-label": progressLabel || phaseLabel,
        className: "flex",
        style: {
            flex: 1,
            height: '0.25rem',
            borderRadius: (0, $jTCZr.RADIUS).pill,
            background: (0, $jTCZr.C).border,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "transition-[width] duration-200 motion-reduce:transition-none",
        style: {
            width: `${pct}%`,
            height: '100%',
            background: (0, $jTCZr.CT).accent,
            borderRadius: (0, $jTCZr.RADIUS).pill
        }
    })), progressLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "tabular-nums",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, progressLabel) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            flexShrink: 0,
            gap: '0.375rem'
        }
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.25rem',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: phaseColor
        }
    }, phase === 'sending' || phase === 'preparing' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "inline-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        thickness: 2,
        label: ""
    })) : null, phase === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        "aria-hidden": true,
        size: 14,
        strokeWidth: 2,
        color: (0, $jTCZr.CT).good
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, phaseLabel)), canReplace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onReplace,
        disabled: disabled,
        "data-testid": testId ? `${testId}-replace` : undefined
    }, replaceLabel) : null, canRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onRetry,
        disabled: disabled,
        "data-testid": testId ? `${testId}-retry` : undefined
    }, retryLabel) : null, canRemove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: 40,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: removeLabel,
        onClick: onRemove,
        disabled: disabled,
        "data-testid": testId ? `${testId}-remove` : undefined
    }) : null));
}
const $ad7c85561d054b68$export$731398005976572f = $ad7c85561d054b68$export$8c95ef2c56e9a241;
// ─────────────────────────────────────────────────────────────────────────────
// FileDropzone
// ─────────────────────────────────────────────────────────────────────────────
// Every row the zone counts: the flat `files`, or the rows of every group.
function $ad7c85561d054b68$var$rowsOf(groups, files) {
    if (Array.isArray(groups)) return groups.flatMap((g)=>Array.isArray(g?.files) ? g.files : []);
    return Array.isArray(files) ? files : [];
}
function $ad7c85561d054b68$export$2e2bcd8739ae039({ files: filesProp, groups: groups, onFiles: onFiles, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, accept: accept, multiple: multiple = true, maxFiles: maxFiles, maxBytes: maxBytes, capture: capture, directory: directory = false, extraActions: extraActions, disabled: disabled = false, busy: busy = false, error: error, size: size = 'regular', label: label, required: required, helperText: helperText, dropLabel: dropLabel, pickLabel: pickLabel, cameraLabel: cameraLabel, directoryLabel: directoryLabel, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, phaseLabels: phaseLabels, draggingLabel: draggingLabel, emptyHint: emptyHint, listLabel: listLabel, className: className, style: style, 'data-testid': testId, ...rest }) {
    if (dropLabel === undefined) dropLabel = (0, $j9AxR.kitCopy)().files.drop;
    if (pickLabel === undefined) pickLabel = (0, $j9AxR.kitCopy)().files.pick;
    if (cameraLabel === undefined) cameraLabel = (0, $j9AxR.kitCopy)().files.camera;
    if (directoryLabel === undefined) directoryLabel = (0, $j9AxR.kitCopy)().files.directory;
    if (removeLabel === undefined) removeLabel = (0, $j9AxR.kitCopy)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $j9AxR.kitCopy)().files.replace;
    if (draggingLabel === undefined) draggingLabel = (0, $j9AxR.kitCopy)().files.dragging;
    const S = $ad7c85561d054b68$var$SIZES[size] || $ad7c85561d054b68$var$SIZES.regular;
    const baseId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const zoneId = `${baseId}-zone`;
    const helperId = helperText ? `${baseId}-helper` : undefined;
    const errorId = error ? `${baseId}-error` : undefined;
    const mainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const directoryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragDepth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const files = $ad7c85561d054b68$var$rowsOf(groups, filesProp);
    const warnedBoth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const inert = disabled || busy;
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    // `webkitdirectory` is not a React prop; it has to be an attribute.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = directoryRef.current;
        if (!el) return;
        el.setAttribute('webkitdirectory', '');
        el.setAttribute('directory', '');
    }, [
        directory
    ]);
    // Never lingers in `dragging` if the zone is disabled mid-drag.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inert) {
            dragDepth.current = 0;
            setDragging(false);
        }
    }, [
        inert
    ]);
    const report = (picked, source)=>{
        const list = Array.from(picked || []);
        // Nothing picked (a cancelled dialog, a drop of text) is not a batch.
        if (list.length === 0) return;
        let room = Infinity;
        if (typeof maxFiles === 'number') room = Math.max(0, maxFiles - files.length);
        if (!multiple) room = Math.min(room, 1);
        const accepted = [];
        const rejected = [];
        for (const f of list){
            if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) rejected.push({
                file: f,
                reason: 'type'
            });
            else if (typeof maxBytes === 'number' && typeof f.size === 'number' && f.size > maxBytes) rejected.push({
                file: f,
                reason: 'size'
            });
            else if (accepted.length >= room) rejected.push({
                file: f,
                reason: 'count'
            });
            else accepted.push(f);
        }
        onFiles?.(accepted, rejected, source);
    };
    const onInputChange = (source)=>(e)=>{
            const picked = e.target.files;
            try {
                report(picked, source);
            } finally{
                // Reset, so picking the same file twice still fires `change`.
                e.target.value = '';
            }
        };
    const onReplaceChange = (e)=>{
        const f = e.target.files?.[0];
        const id = replaceTarget.current;
        e.target.value = '';
        replaceTarget.current = null;
        if (!f || id == null) return;
        // A refused replacement is reported like any refused pick, so the caller
        // has one place that writes the sentence.
        if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'type'
                }
            ], 'picker');
            return;
        }
        if (typeof maxBytes === 'number' && f.size > maxBytes) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'size'
                }
            ], 'picker');
            return;
        }
        onReplace?.(id, f);
    };
    const open = (ref)=>()=>{
            if (inert) return;
            ref.current?.click();
        };
    const hasDragFiles = (e)=>{
        const types = e.dataTransfer?.types;
        if (!types) return true;
        return Array.from(types).includes('Files');
    };
    const onDragEnter = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (inert) return;
        dragDepth.current += 1;
        setDragging(true);
    };
    const onDragOver = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = inert ? 'none' : 'copy';
    };
    const onDragLeave = ()=>{
        if (inert) return;
        // `dragleave` fires on every child boundary; only the last one leaves.
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        if (inert) return;
        report(e.dataTransfer?.files, 'drop');
    };
    const state = disabled ? 'disabled' : dragging ? 'dragging' : files.length ? 'has-files' : 'idle';
    const accentOn = dragging && !inert;
    const describedBy = [
        helperId,
        errorId
    ].filter(Boolean).join(' ') || undefined;
    const pickerProps = {
        type: 'button',
        variant: 'outline',
        size: 'sm',
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        disabled: disabled,
        'aria-disabled': busy || undefined
    };
    const renderRow = (f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7c85561d054b68$export$8c95ef2c56e9a241, {
            key: f.id,
            name: f.name,
            meta: f.meta,
            phase: f.phase,
            progress: f.progress,
            progressLabel: f.progressLabel,
            error: f.error,
            file: f.file,
            previewUrl: f.previewUrl,
            badge: f.badge,
            removable: f.removable,
            replaceable: f.replaceable,
            trailing: f.trailing,
            busy: busy,
            disabled: disabled,
            phaseLabels: phaseLabels,
            removeLabel: removeLabel,
            retryLabel: retryLabel,
            replaceLabel: replaceLabel,
            onRemove: onRemove ? ()=>onRemove(f.id) : undefined,
            onRetry: onRetry ? ()=>onRetry(f.id) : undefined,
            onReplace: onReplace ? ()=>{
                if (inert) return;
                replaceTarget.current = f.id;
                replaceRef.current?.click();
            } : undefined,
            "data-testid": testId ? `${testId}-row-${f.id}` : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        "data-busy": busy || undefined,
        className: className,
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        htmlFor: zoneId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('frame'),
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        className: "flex flex-col items-center",
        style: {
            gap: '0.625rem',
            paddingBlock: S.padBlock,
            paddingInline: '1rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1.5px dashed ${accentOn ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: accentOn ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.06) : (0, $jTCZr.CT).surface2,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : undefined,
            transition: 'border-color 0.15s, background 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: zoneId,
        type: "button",
        "data-testid": tid('zone'),
        onClick: open(mainRef),
        disabled: disabled,
        "aria-disabled": busy || undefined,
        "aria-describedby": describedBy,
        className: "flex w-full flex-col items-center text-center outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        style: {
            gap: '0.375rem',
            background: 'transparent',
            border: 'none',
            padding: '0.25rem',
            cursor: inert ? disabled ? 'not-allowed' : 'default' : 'pointer',
            font: 'inherit',
            color: (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        "aria-hidden": true,
        size: S.icon,
        strokeWidth: 1.5,
        color: accentOn ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).textMuted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, accentOn ? draggingLabel : dropLabel), emptyHint && files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, emptyHint) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center justify-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(mainRef),
        "data-testid": tid('pick')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        "aria-hidden": true,
        size: 14
    }), pickLabel), capture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(cameraRef),
        "data-testid": tid('camera-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fzlbJ.default), {
        "aria-hidden": true,
        size: 14
    }), cameraLabel) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(directoryRef),
        "data-testid": tid('directory-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
        "aria-hidden": true,
        size: 14
    }), directoryLabel) : null, typeof extraActions === 'function' ? extraActions({
        openPicker: open(mainRef),
        openCamera: capture ? open(cameraRef) : undefined,
        openDirectory: directory ? open(directoryRef) : undefined,
        labels: {
            pick: pickLabel,
            camera: cameraLabel,
            directory: directoryLabel
        },
        disabled: inert
    }) : extraActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: mainRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": pickLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        multiple: multiple,
        disabled: disabled,
        onChange: onInputChange('picker'),
        "data-testid": tid('input')
    }), capture ? // A SEPARATE input: `capture` on the main one makes iOS skip the
    // gallery entirely.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: cameraRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": cameraLabel,
        accept: "image/*",
        capture: capture,
        disabled: disabled,
        onChange: onInputChange('camera'),
        "data-testid": tid('camera')
    }) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: directoryRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": directoryLabel,
        multiple: true,
        disabled: disabled,
        onChange: onInputChange('directory'),
        "data-testid": tid('directory')
    }) : null, typeof onReplace === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: replaceRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": replaceLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        disabled: disabled,
        onChange: onReplaceChange,
        "data-testid": tid('replace-input')
    }) : null), helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: helperId,
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, helperText) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: errorId,
        key: String(error),
        role: "alert",
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 500,
            lineHeight: 1.5
        }
    }, error) : null, Array.isArray(groups) ? groups.map((g)=>{
        const rows = Array.isArray(g.files) ? g.files : [];
        const headingId = `${baseId}-group-${g.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.id,
            "aria-labelledby": headingId,
            "data-testid": tid(`group-${g.id}`),
            "data-state": rows.length ? 'has-files' : 'empty',
            className: "flex flex-col",
            style: {
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-baseline",
            style: {
                gap: '0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: headingId,
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.5
            }
        }, g.title), g.meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5
            }
        }, g.meta) : null), rows.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "aria-labelledby": headingId,
            className: "m-0 flex list-none flex-col p-0",
            style: {
                gap: '0.375rem'
            }
        }, rows.map(renderRow)) : g.emptyText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0",
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5
            }
        }, g.emptyText) : null);
    }) : files.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": listLabel || (typeof label === 'string' ? label : undefined),
        className: "m-0 flex list-none flex-col p-0",
        style: {
            gap: '0.375rem'
        }
    }, files.map(renderRow)) : null)));
}

});
parcelRegister("fzlbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5401c97ba566f60e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5401c97ba566f60e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
            key: "18u6gg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
];
const $5401c97ba566f60e$export$2e2bcd8739ae039 = (0, $9QBug.default)("camera", $5401c97ba566f60e$export$3efd853dbb351e94);

});

parcelRegister("3FyOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9771111904a5d5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $df9771111904a5d5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $df9771111904a5d5$export$2e2bcd8739ae039 = (0, $9QBug.default)("file-text", $df9771111904a5d5$export$3efd853dbb351e94);

});

parcelRegister("8jE1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8745eaf007923a88$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8745eaf007923a88$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
            key: "usdka0"
        }
    ]
];
const $8745eaf007923a88$export$2e2bcd8739ae039 = (0, $9QBug.default)("folder-open", $8745eaf007923a88$export$3efd853dbb351e94);

});

parcelRegister("he6AI", function(module, exports) {

$parcel$export(module.exports, "default", () => $557120626e51c22d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $557120626e51c22d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m17 8-5-5-5 5",
            key: "7q97r8"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ]
];
const $557120626e51c22d$export$2e2bcd8739ae039 = (0, $9QBug.default)("upload", $557120626e51c22d$export$3efd853dbb351e94);

});


parcelRegister("bhQd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5da664f84994ea$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");
var $6ivsH = parcelRequire("6ivsH");
var $47abO = parcelRequire("47abO");
var $bU80g = parcelRequire("bU80g");

var $aJ1FU = parcelRequire("aJ1FU");

var $5MbI8 = parcelRequire("5MbI8");

var $fYgeo = parcelRequire("fYgeo");

var $7gSBD = parcelRequire("7gSBD");

var $2vXUl = parcelRequire("2vXUl");

var $hZDga = parcelRequire("hZDga");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");
'use client';
function $cb5da664f84994ea$export$bb0048c9149cbdb(locale) {
    const copy = (0, $j9AxR.kitCopy)(locale).imageStack;
    const { digits: digits } = (0, $IZwml.datePickerLocale)(locale);
    return {
        ...copy,
        frame: (i, n)=>copy.frame((0, $IZwml.withDigits)(i, digits), (0, $IZwml.withDigits)(n, digits))
    };
}
const $cb5da664f84994ea$export$eb119caddc05b7a2 = $cb5da664f84994ea$export$bb0048c9149cbdb('fa');
const $cb5da664f84994ea$var$MIN_ZOOM = 1;
const $cb5da664f84994ea$var$MAX_ZOOM = 8;
const $cb5da664f84994ea$var$ZOOM_STEP = 1.25;
// Pixels of wheel delta / finger travel per frame. Interaction thresholds,
// not layout — they never reach a style.
const $cb5da664f84994ea$var$WHEEL_PER_FRAME = 60;
const $cb5da664f84994ea$var$SWIPE_PER_FRAME = 24;
const $cb5da664f84994ea$var$DOUBLE_TAP_MS = 300;
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5).
const $cb5da664f84994ea$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $cb5da664f84994ea$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
function $cb5da664f84994ea$export$2e2bcd8739ae039({ frameCount: frameCount = 0, index: indexProp, defaultIndex: defaultIndex = 0, onIndexChange: onIndexChange, loadFrame: loadFrame, revokeFrame: revokeFrame, preloadRadius: preloadRadius = 5, sourceKey: sourceKey, series: series, activeSeriesId: activeSeriesId, onSeriesChange: onSeriesChange, presets: presets, activePresetId: activePresetId, onPresetChange: onPresetChange, caption: caption, banner: banner, loading: loading = false, error: error, onRetry: onRetry, labels: labelsProp, className: className, style: style, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$cb5da664f84994ea$export$bb0048c9149cbdb(),
        ...labelsProp
    };
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    const n = Math.max(0, Math.floor(Number(frameCount) || 0));
    // ── index: controlled when `index` is given, otherwise internal ───────────
    const [innerIndex, setInnerIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultIndex);
    const controlled = indexProp !== undefined && indexProp !== null;
    const index = n ? $cb5da664f84994ea$var$clamp(Math.floor(controlled ? indexProp : innerIndex) || 0, 0, n - 1) : 0;
    const indexRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(index);
    indexRef.current = index;
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!n) return;
        const target = $cb5da664f84994ea$var$clamp(Math.round(next), 0, n - 1);
        if (target === indexRef.current) return;
        if (!controlled) setInnerIndex(target);
        onIndexChange?.(target);
    }, [
        n,
        controlled,
        onIndexChange
    ]);
    // ── frame cache ───────────────────────────────────────────────────────────
    const loadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(loadFrame);
    loadRef.current = loadFrame;
    const revokeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(revokeFrame);
    revokeRef.current = revokeFrame;
    const cache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → url
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → AbortController
    const failed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set()); // i
    const shownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // url on screen
    const [, bump] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((x)=>x + 1, 0);
    const [shownUrl, setShownUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [, setRetryTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const release = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        if (!url || url === shownRef.current) return;
        revokeRef.current?.(url);
    }, []);
    const source = `${activeSeriesId ?? ''}|${activePresetId ?? ''}|${n}|${sourceKey ?? ''}`;
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(source);
    // A new source: cancel everything in flight and forget every frame. The
    // shown image stays up (under a spinner) until its replacement arrives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (sourceRef.current === source) return;
        sourceRef.current = source;
        for (const ctrl of pending.current.values())ctrl.abort();
        pending.current.clear();
        for (const url of cache.current.values())release(url);
        cache.current.clear();
        failed.current.clear();
        bump();
    }, [
        source,
        release
    ]);
    // Load the current frame and its neighbours; evict what fell out.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!n || typeof loadRef.current !== 'function' || loading || error) return;
        const lo = Math.max(0, index - preloadRadius);
        const hi = Math.min(n - 1, index + preloadRadius);
        for (const [i, ctrl] of pending.current)if (i < lo || i > hi) {
            ctrl.abort();
            pending.current.delete(i);
        }
        for (const [i, url] of cache.current)if (i < lo || i > hi) {
            cache.current.delete(i);
            release(url);
        }
        for (const i of failed.current)if (i < lo || i > hi) failed.current.delete(i);
        // Current frame first, then outward: ±1, ±2, …
        const order = [
            index
        ];
        for(let d = 1; d <= preloadRadius; d += 1){
            if (index + d <= hi) order.push(index + d);
            if (index - d >= lo) order.push(index - d);
        }
        const mySource = sourceRef.current;
        for (const i of order){
            if (cache.current.has(i) || pending.current.has(i) || failed.current.has(i)) continue;
            const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : {
                abort () {},
                signal: undefined
            };
            pending.current.set(i, ctrl);
            let p;
            try {
                p = Promise.resolve(loadRef.current(i, {
                    signal: ctrl.signal
                }));
            } catch (e) {
                p = Promise.reject(e);
            }
            p.then((url)=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) {
                    if (url) revokeRef.current?.(url);
                    return;
                }
                pending.current.delete(i);
                cache.current.set(i, url);
                bump();
            }, ()=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) return;
                pending.current.delete(i);
                failed.current.add(i);
                bump();
            });
        }
    });
    // Show the current frame as soon as it is cached; revoke what it replaced.
    const currentUrl = cache.current.get(index) ?? null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!currentUrl || currentUrl === shownRef.current) return;
        const previous = shownRef.current;
        shownRef.current = currentUrl;
        setShownUrl(currentUrl);
        if (previous && ![
            ...cache.current.values()
        ].includes(previous)) revokeRef.current?.(previous);
    }, [
        currentUrl
    ]);
    // Unmount: cancel, and hand back every URL still held.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const ctrl of pending.current.values())ctrl.abort();
            pending.current.clear();
            const urls = new Set([
                ...cache.current.values(),
                shownRef.current
            ].filter(Boolean));
            cache.current.clear();
            shownRef.current = null;
            for (const url of urls)revokeRef.current?.(url);
        }, []);
    const retryFrame = ()=>{
        failed.current.delete(index);
        setRetryTick((t)=>t + 1);
    };
    const frameState = failed.current.has(index) ? 'error' : currentUrl ? 'ready' : 'loading';
    // ── zoom & pan ────────────────────────────────────────────────────────────
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clampPan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p, z)=>{
        const rect = stageRef.current?.getBoundingClientRect?.();
        if (!rect || !rect.width || !rect.height) return z <= 1 ? {
            x: 0,
            y: 0
        } : p;
        const mx = (z - 1) * rect.width / 2;
        const my = (z - 1) * rect.height / 2;
        return {
            x: $cb5da664f84994ea$var$clamp(p.x, -mx, mx),
            y: $cb5da664f84994ea$var$clamp(p.y, -my, my)
        };
    }, []);
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z)=>{
        const next = $cb5da664f84994ea$var$clamp(z, $cb5da664f84994ea$var$MIN_ZOOM, $cb5da664f84994ea$var$MAX_ZOOM);
        setZoom(next);
        setPan((p)=>next <= 1 ? {
                x: 0,
                y: 0
            } : clampPan(p, next));
    }, [
        clampPan
    ]);
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        resetView();
    }, [
        activeSeriesId,
        resetView
    ]);
    // Latest values for the native listeners below.
    const live = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    live.current = {
        zoom: zoom,
        go: go,
        index: index,
        zoomTo: zoomTo
    };
    // Wheel needs a non-passive listener to keep the page from scrolling.
    const wheelAcc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = stageRef.current;
        if (!el) return undefined;
        const onWheel = (e)=>{
            e.preventDefault();
            const L = live.current;
            if (e.ctrlKey || e.metaKey) {
                L.zoomTo(L.zoom * (e.deltaY < 0 ? $cb5da664f84994ea$var$ZOOM_STEP : 1 / $cb5da664f84994ea$var$ZOOM_STEP));
                return;
            }
            // Line/page deltas (a notched mouse on some platforms) step one frame
            // per event; pixel deltas (trackpads) accumulate.
            if (e.deltaMode !== 0) {
                wheelAcc.current = 0;
                if (e.deltaY) L.go(L.index + Math.sign(e.deltaY));
                return;
            }
            wheelAcc.current += e.deltaY;
            const steps = Math.trunc(wheelAcc.current / $cb5da664f84994ea$var$WHEEL_PER_FRAME);
            if (steps) {
                wheelAcc.current -= steps * $cb5da664f84994ea$var$WHEEL_PER_FRAME;
                L.go(L.index + steps);
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    });
    // Pointers: one finger pans (zoomed) or swipes frames (not zoomed); two pinch.
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onPointerDown = (e)=>{
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) gesture.current = {
            kind: 'pinch',
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            zoom: zoom
        };
        else if (pts.length === 1) gesture.current = zoom > 1 ? {
            kind: 'pan',
            x: e.clientX,
            y: e.clientY,
            pan: pan
        } : {
            kind: 'swipe',
            y: e.clientY,
            index: index
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        const g = gesture.current;
        if (!g) return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            zoomTo(g.zoom * (dist / g.dist));
        } else if (g.kind === 'pan') setPan(clampPan({
            x: g.pan.x + (e.clientX - g.x),
            y: g.pan.y + (e.clientY - g.y)
        }, zoom));
        else if (g.kind === 'swipe') {
            // Finger up = next frame, like scrolling a page of film.
            const steps = Math.trunc((g.y - e.clientY) / $cb5da664f84994ea$var$SWIPE_PER_FRAME);
            go(g.index + steps);
        }
    };
    const onPointerUp = (e)=>{
        pointers.current.delete(e.pointerId);
        if (pointers.current.size === 0) {
            if (e.pointerType === 'touch') {
                const now = Date.now();
                if (now - lastTap.current < $cb5da664f84994ea$var$DOUBLE_TAP_MS) {
                    resetView();
                    lastTap.current = 0;
                } else lastTap.current = now;
            }
            gesture.current = null;
        } else if (pointers.current.size === 1) {
            const [pt] = [
                ...pointers.current.values()
            ];
            gesture.current = zoom > 1 ? {
                kind: 'pan',
                x: pt.x,
                y: pt.y,
                pan: pan
            } : null;
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
                go(index - 1);
                break;
            case 'ArrowDown':
            case 'PageDown':
                go(index + 1);
                break;
            case 'Home':
                go(0);
                break;
            case 'End':
                go(n - 1);
                break;
            case '+':
            case '=':
                zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '-':
            case '_':
                zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '0':
                resetView();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    // ── states ────────────────────────────────────────────────────────────────
    const state = loading ? 'loading' : error ? 'error' : n === 0 ? 'empty' : 'content';
    const frameText = n ? labels.frame(index + 1, n) : '';
    const canvasStyle = {
        position: 'relative',
        width: '100%',
        aspectRatio: '1 / 1',
        maxHeight: '70dvh',
        maxWidth: '100%',
        borderRadius: (0, $jTCZr.RADIUS).card,
        background: (0, $jTCZr.CT).ink,
        overflow: 'hidden'
    };
    const seriesStrip = Array.isArray(series) && series.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": labels.series,
        "data-testid": tid('series'),
        className: "flex",
        style: {
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBlock: '0.125rem',
            scrollbarWidth: 'thin'
        }
    }, series.map((s)=>{
        const active = s.id === activeSeriesId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            "aria-pressed": active,
            "data-state": active ? 'active' : 'inactive',
            "data-testid": tid(`series-${s.id}`),
            onClick: ()=>{
                if (!active) onSeriesChange?.(s.id);
            },
            className: (0, $5JYPc.cn)('inline-flex items-center outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flexShrink: 0,
                gap: '0.375rem',
                minHeight: '2.25rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.25rem',
                borderRadius: (0, $jTCZr.RADIUS).control,
                border: `1px solid ${active ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                background: active ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.1) : (0, $jTCZr.C).card,
                color: active ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary,
                font: 'inherit',
                fontSize: '0.75rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, s.label), s.badge != null && s.badge !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                background: (0, $jTCZr.C).bg,
                borderRadius: (0, $jTCZr.RADIUS).chip,
                paddingInline: '0.3125rem'
            }
        }, s.badge) : null);
    })) : null;
    const presetControl = Array.isArray(presets) && presets.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('presets'),
        style: {
            maxWidth: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        size: "lg",
        ariaLabel: labels.presets,
        options: presets.map((p)=>({
                value: p.id,
                label: p.label
            })),
        value: activePresetId,
        onChange: (id)=>{
            if (id !== activePresetId) onPresetChange?.(id);
        }
    })) : null;
    let body;
    if (state === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: labels.loading,
        "data-testid": tid('loading'),
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
        height: "auto",
        radius: (0, $jTCZr.RADIUS).card,
        style: {
            ...canvasStyle,
            background: undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
        height: "2.75rem",
        radius: (0, $jTCZr.RADIUS).control
    }));
    else if (state === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2vXUl.default), {
        "data-testid": tid('error'),
        title: typeof error === 'string' ? error : labels.error,
        onRetry: onRetry,
        retryLabel: labels.retry
    });
    else if (state === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": tid('empty'),
        title: labels.empty
    });
    else {
        const transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
        body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: stageRef,
            role: "img",
            "aria-roledescription": labels.viewport,
            "aria-label": frameText,
            tabIndex: 0,
            "data-testid": tid('stage'),
            "data-frame-state": frameState,
            "data-zoom": String(Math.round(zoom * 100) / 100),
            onKeyDown: onKeyDown,
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp,
            onDoubleClick: resetView,
            className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
            style: {
                ...canvasStyle,
                touchAction: 'none',
                userSelect: 'none',
                cursor: zoom > 1 ? 'grab' : 'ns-resize'
            }
        }, shownUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: shownUrl,
            alt: "",
            draggable: false,
            "data-testid": tid('image'),
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: transform,
                transformOrigin: 'center',
                opacity: frameState === 'ready' ? 1 : 0.6,
                pointerEvents: 'none'
            }
        }) : frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
            tone: "onDark",
            width: "100%",
            height: "100%",
            radius: 0,
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0
            }
        }) : null, frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('frame-loading'),
            className: "flex items-center justify-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 28,
            color: (0, $jTCZr.C).card,
            label: labels.loading
        })) : null, frameState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('frame-error'),
            className: "flex flex-col items-center justify-center text-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                gap: '0.75rem',
                paddingInline: '1rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.CT).ink, 0.7),
                color: (0, $jTCZr.C).card
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600
            }
        }, labels.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: $cb5da664f84994ea$var$TOUCH_TARGET,
            onClick: retryFrame,
            "data-testid": tid('frame-retry')
        }, labels.retry)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap items-center",
            style: {
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.prev,
            onClick: ()=>go(index - 1),
            disabled: index <= 0,
            "data-testid": tid('prev')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "range",
            min: 0,
            max: Math.max(0, n - 1),
            step: 1,
            value: index,
            "aria-label": labels.slider,
            "aria-valuetext": frameText,
            onChange: (e)=>go(Number(e.target.value)),
            disabled: n <= 1,
            "data-testid": tid('slider'),
            className: (0, $5JYPc.cn)('outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                minHeight: '2.25rem',
                accentColor: (0, $jTCZr.CT).accent
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.next,
            onClick: ()=>go(index + 1),
            disabled: index >= n - 1,
            "data-testid": tid('next')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-live": "polite",
            "aria-atomic": "true",
            "data-testid": tid('counter'),
            className: "tabular-nums",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textSecondary,
                whiteSpace: 'nowrap'
            }
        }, frameText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex items-center",
            style: {
                gap: '0.25rem',
                marginInlineStart: 'auto'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomOut,
            onClick: ()=>zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom <= $cb5da664f84994ea$var$MIN_ZOOM,
            "data-testid": tid('zoom-out')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47abO.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomIn,
            onClick: ()=>zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom >= $cb5da664f84994ea$var$MAX_ZOOM,
            "data-testid": tid('zoom-in')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ivsH.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.reset,
            onClick: resetView,
            disabled: zoom === 1 && pan.x === 0 && pan.y === 0,
            "data-testid": tid('reset')
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: (0, $5JYPc.cn)('flex flex-col', className),
        style: {
            gap: '0.625rem',
            minWidth: 0,
            ...style
        },
        ...rest
    }, banner, state !== 'loading' ? seriesStrip : null, state !== 'loading' ? presetControl : null, body, caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, caption) : null);
}

});
parcelRegister("6ivsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96e72789512f0bb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c96e72789512f0bb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3H5a2 2 0 0 0-2 2v3",
            key: "1dcmit"
        }
    ],
    [
        "path",
        {
            d: "M21 8V5a2 2 0 0 0-2-2h-3",
            key: "1e4gt3"
        }
    ],
    [
        "path",
        {
            d: "M3 16v3a2 2 0 0 0 2 2h3",
            key: "wsl5sc"
        }
    ],
    [
        "path",
        {
            d: "M16 21h3a2 2 0 0 0 2-2v-3",
            key: "18trek"
        }
    ]
];
const $c96e72789512f0bb$export$2e2bcd8739ae039 = (0, $9QBug.default)("maximize", $c96e72789512f0bb$export$3efd853dbb351e94);

});

parcelRegister("47abO", function(module, exports) {

$parcel$export(module.exports, "default", () => $191016e022d4d457$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $191016e022d4d457$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "11",
            x2: "11",
            y1: "8",
            y2: "14",
            key: "1vmskp"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
];
const $191016e022d4d457$export$2e2bcd8739ae039 = (0, $9QBug.default)("zoom-in", $191016e022d4d457$export$3efd853dbb351e94);

});

parcelRegister("bU80g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a481aded68921702$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a481aded68921702$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
];
const $a481aded68921702$export$2e2bcd8739ae039 = (0, $9QBug.default)("zoom-out", $a481aded68921702$export$3efd853dbb351e94);

});


parcelRegister("h4ZeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5f0e3d96e18162$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aJ1FU = parcelRequire("aJ1FU");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterChip — one toggleable filter in a chip row (category, type, status).
//
// Distinct from `ChipSelector`, which is a *form field* (label, validation,
// helper text, a value the user submits). This is a **view filter**: it narrows
// what a list shows, lives in a toolbar rather than a form, and reports its
// state through `aria-pressed` — the correct semantics for a toggle button, and
// the reason the two are not one component.
//
// Sized for touch by default (`min-h-11` = 2.75rem), because the phone is where
// chip rows are used most and a sub-44px target is a defect there. `count` is a
// node, not a number, so the caller formats digits in its own locale.
// ─────────────────────────────────────────────────────────────────────────────
const $4f5f0e3d96e18162$var$FilterChip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, count: count, active: active = false, onClick: onClick, disabled: disabled, className: className, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: ref,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-pressed": active,
        disabled: disabled,
        onClick: onClick,
        "data-state": active ? 'active' : 'inactive',
        className: (0, $5JYPc.cn)('min-h-11 shrink-0 rounded-full gap-1', className),
        ...rest
    }, label ?? children, count != null && count !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.625rem] opacity-70"
    }, "(", count, ")")));
$4f5f0e3d96e18162$var$FilterChip.displayName = 'FilterChip';
var $4f5f0e3d96e18162$export$2e2bcd8739ae039 = $4f5f0e3d96e18162$var$FilterChip;

});

parcelRegister("3Amwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $91c948f90369c6a3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Sparkline — an inline, axis-less trend glyph for a short numeric series.
//
// The smallest data-viz unit in the system: it rides inside a row or a tile to
// answer «is this going up or down?» without spending a chart's worth of space.
// It is deliberately unlabelled — the row already carries the name, the value
// and the unit, and the glyph only has to show shape.
//
// Tones resolve from the token set, so a sparkline never invents a colour:
// `accent` for an in-range series, `danger`/`warn` when the caller has already
// judged the latest reading out of range.
//
// Empty appearance (by design): fewer than two numeric points cannot describe a
// trend, so the glyph renders nothing at all rather than a misleading flat line.
// ─────────────────────────────────────────────────────────────────────────────
const $91c948f90369c6a3$var$TONES = {
    accent: (0, $jTCZr.CT).accent,
    danger: (0, $jTCZr.CT).danger,
    warn: (0, $jTCZr.CT).warn,
    good: (0, $jTCZr.CT).good,
    mute: (0, $jTCZr.CT).mute
};
const $91c948f90369c6a3$var$Sparkline = ({ points: points = [], width: width = 72, height: height = 26, tone: tone = 'accent', strokeWidth: strokeWidth = 1.5, showLast: showLast = true, className: className, style: style, ...rest })=>{
    const vals = (points || []).map((p)=>typeof p === 'number' ? p : parseFloat(p)).filter((v)=>!Number.isNaN(v));
    if (vals.length < 2) return null;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // A flat series would divide by zero; pad it so the line sits mid-height.
    const pad = (max - min) * 0.15 || 1;
    const lo = min - pad;
    const hi = max + pad;
    const xOf = (i)=>i / (vals.length - 1) * width;
    const yOf = (v)=>height - (v - lo) / (hi - lo) * height;
    const path = vals.map((v, i)=>`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`).join(' ');
    const stroke = $91c948f90369c6a3$var$TONES[tone] || $91c948f90369c6a3$var$TONES.accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        // Time always reads left→right, including on an RTL page.
        style: {
            direction: 'ltr',
            overflow: 'visible',
            display: 'block',
            flexShrink: 0,
            ...style
        },
        className: (0, $5JYPc.cn)(className),
        "aria-hidden": true,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: xOf(vals.length - 1),
        cy: yOf(vals[vals.length - 1]),
        r: "2.5",
        fill: stroke
    }));
};
var $91c948f90369c6a3$export$2e2bcd8739ae039 = $91c948f90369c6a3$var$Sparkline;

});

parcelRegister("ePaaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7b57ad44712e2b0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TrendChart — the full-size counterpart to `Sparkline`: one numeric series over
// time, with an optional reference band and per-point status.
//
// It is the system's answer to «show me this measurement's history» — a lab
// analyte, a vital sign, a wallet balance, a clinic's daily revenue. It stays
// presentational: the caller normalises its data to `readings` and decides what
// «abnormal» means; the chart only draws.
//
//   readings   [{ value, date?, status? }]  — chronological, oldest first
//   refLow/refHigh                          — optional reference band + guides
//   formatX(reading, index)                 — axis label; the caller owns the
//                                             locale (Jalali dates, digits…)
//   formatValue(v)                          — value-axis label; same reason —
//                                             digits follow the UI locale, and
//                                             only the app knows what that is
//   emptyLabel                              — copy for the not-enough-data state;
//                                             omitted ⇒ silent blank of the same
//                                             height, so layout never jumps
//
// Status → colour uses the semantic tokens and accepts either casing, because
// clinical back-ends disagree about it (`ABNORMAL` vs `abnormal`).
// ─────────────────────────────────────────────────────────────────────────────
const $b7b57ad44712e2b0$var$STATUS_TONE = {
    abnormal: (0, $jTCZr.CT).warn,
    ABNORMAL: (0, $jTCZr.CT).warn,
    critical: (0, $jTCZr.CT).danger,
    CRITICAL: (0, $jTCZr.CT).danger
};
const $b7b57ad44712e2b0$var$VIEWBOX_W = 520;
const $b7b57ad44712e2b0$var$PAD = {
    t: 12,
    r: 16,
    b: 36,
    l: 46
};
const $b7b57ad44712e2b0$var$TrendChart = ({ readings: readings = [], color: color = (0, $jTCZr.CT).accent, refLow: refLow, refHigh: refHigh, height: height = 160, gridLines: gridLines = 4, formatX: formatX, formatValue: formatValue = (v)=>v.toFixed(1), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const numeric = (readings || []).map((r)=>({
            ...r,
            num: typeof r?.value === 'number' ? r.value : parseFloat(r?.value)
        }));
    const plottable = numeric.filter((r)=>!Number.isNaN(r.num));
    if (plottable.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    const nums = plottable.map((r)=>r.num);
    const dataMin = Math.min(...nums);
    const dataMax = Math.max(...nums);
    const span = dataMax - dataMin;
    // Include the reference band in the visible window, then breathe by 15% (or a
    // flat ±2 when every reading is identical and the span is 0).
    const lo = Math.min(dataMin, refLow ?? dataMin) - (span * 0.15 || 2);
    const hi = Math.max(dataMax, refHigh ?? dataMax) + (span * 0.15 || 2);
    const range = hi - lo || 1;
    const H = height;
    const cw = $b7b57ad44712e2b0$var$VIEWBOX_W - $b7b57ad44712e2b0$var$PAD.l - $b7b57ad44712e2b0$var$PAD.r;
    const ch = H - $b7b57ad44712e2b0$var$PAD.t - $b7b57ad44712e2b0$var$PAD.b;
    const xOf = (i)=>$b7b57ad44712e2b0$var$PAD.l + i / (plottable.length - 1) * cw;
    const yOf = (v)=>$b7b57ad44712e2b0$var$PAD.t + ch - (v - lo) / range * ch;
    const path = plottable.map((r, i)=>`${xOf(i).toFixed(1)},${yOf(r.num).toFixed(1)}`).join(' ');
    const xStep = Math.max(1, Math.floor(plottable.length / 5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${$b7b57ad44712e2b0$var$VIEWBOX_W} ${H}`,
        // Decorative by contract: every screen that plots a series also lists the
        // readings, and the list is the accessible equivalent (§12).
        "aria-hidden": true,
        focusable: "false",
        className: (0, $5JYPc.cn)(className),
        "data-state": "content",
        // A time axis reads left→right regardless of the page's direction.
        style: {
            width: '100%',
            height: H,
            display: 'block',
            overflow: 'visible',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: $b7b57ad44712e2b0$var$PAD.l,
        y: yOf(refHigh),
        width: cw,
        height: Math.abs(yOf(refLow) - yOf(refHigh)),
        fill: (0, $jTCZr.soft)(color, 0.08),
        rx: "2"
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = yOf(v);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: $b7b57ad44712e2b0$var$PAD.l,
            x2: $b7b57ad44712e2b0$var$PAD.l + cw,
            y1: y,
            y2: y,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: $b7b57ad44712e2b0$var$PAD.l - 5,
            y: y + 4,
            textAnchor: "end",
            fontSize: "10",
            fill: (0, $jTCZr.CT).mute
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), plottable.map((r, i)=>{
        const cx = xOf(i);
        const cy = yOf(r.num);
        const dot = $b7b57ad44712e2b0$var$STATUS_TONE[r.status] || color;
        const label = i % xStep === 0 && formatX ? formatX(r, i) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: r.id ?? i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: cx,
            cy: cy,
            r: "4",
            fill: (0, $jTCZr.CT).surface,
            stroke: dot,
            strokeWidth: "2"
        }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: cx,
            y: H - 6,
            textAnchor: "middle",
            fontSize: "9",
            fill: (0, $jTCZr.CT).mute
        }, label));
    }), refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refHigh) + 4,
        fontSize: "9",
        fill: (0, $jTCZr.CT).mute
    }, formatValue(refHigh)), refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refLow) + 4,
        fontSize: "9",
        fill: (0, $jTCZr.CT).mute
    }, formatValue(refLow)));
};
var $b7b57ad44712e2b0$export$2e2bcd8739ae039 = $b7b57ad44712e2b0$var$TrendChart;

});

parcelRegister("cPdQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ed18dfb45d0422$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TimeRuler — the clock a stack of timeline lanes shares.
//
// It draws the tick labels once, at the top of the stack, so the lanes beneath
// stay pure plot. The caller owns the calendar: it supplies the tick
// timestamps and `formatTick`, exactly as `TrendChart.formatX` already does —
// the kit never decides that a boundary is a Jalali month rather than a week.
//
// Time reads left→right even on an RTL page (`direction: ltr`), the convention
// `Sparkline` and `TrendChart` already set; the surrounding labels stay RTL.
//
//   scale     — from createTimeScale, or pass xMin/xMax/width and let it build
//   ticks     — timestamps (ms) to label
//   formatTick(t, i) → node
//   nowAt     — timestamp of «now», drawn as the accent boundary
//   cursorAt  — synced crosshair position
//   markers   — optional [{ t, tone, shape, label }] event dots riding the axis
// ─────────────────────────────────────────────────────────────────────────────
const $88ed18dfb45d0422$var$TimeRuler = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, ticks: ticks = [], formatTick: formatTick, nowAt: nowAt, cursorAt: cursorAt, markers: markers, height: height = 52, labelGap: labelGap = 56, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const axisY = height - 18;
    // Labels thin out rather than collide: a tick keeps its gridline always, but
    // only prints its label when it clears the previous printed one. The newest
    // boundary is the anchor a reader looks for, so labelling walks from the end.
    const labelled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const keep = new Set();
        let lastX = Infinity;
        for(let i = ticks.length - 1; i >= 0; i -= 1){
            const t = ticks[i];
            if (!scale.inWindow(t)) continue;
            const x = scale.x(t);
            if (lastX - x >= labelGap) {
                keep.add(i);
                lastX = x;
            }
        }
        return keep;
    }, [
        ticks,
        scale,
        labelGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        // Decorative by contract (DESIGN.md data-viz rule): the readout and the
        // table view carry the same information for assistive tech.
        "aria-hidden": true,
        focusable: "false",
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: axisY
    }), (markers || []).map((m, i)=>{
        if (!scale.inWindow(m.t)) return null;
        const cx = scale.x(m.t);
        const cy = axisY - 20;
        if (m.shape === 'cross') {
            const r = 4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: m.id ?? i,
                stroke: m.tone || (0, $jTCZr.CT).mute,
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy - r,
                x2: cx + r,
                y2: cy + r
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy + r,
                x2: cx + r,
                y2: cy - r
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            key: m.id ?? i,
            cx: cx,
            cy: cy,
            r: "4.5",
            fill: m.filled ? m.tone || (0, $jTCZr.CT).accent : (0, $jTCZr.CT).surface,
            stroke: m.tone || (0, $jTCZr.CT).mute,
            strokeWidth: "2"
        });
    }), formatTick && ticks.map((t, i)=>{
        if (!labelled.has(i)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: i,
            x: scale.x(t),
            y: height - 5,
            textAnchor: "middle",
            fill: (0, $jTCZr.CT).mute,
            style: {
                fontSize: '0.625rem'
            }
        }, formatTick(t, i));
    }));
};
var $88ed18dfb45d0422$export$2e2bcd8739ae039 = $88ed18dfb45d0422$var$TimeRuler;

});
parcelRegister("cRX9v", function(module, exports) {

$parcel$export(module.exports, "createTimeScale", () => $95e851aef96b9382$export$27d74465d4d4bf01);
$parcel$export(module.exports, "linearTicks", () => $95e851aef96b9382$export$b9a1c56e49c8e590);
$parcel$export(module.exports, "thinPoints", () => $95e851aef96b9382$export$849b7cb2b6ea39a7);
// ─────────────────────────────────────────────────────────────────────────────
// timeScale — the shared time→pixel mapping behind the kit's timeline charts.
//
// A timeline is only useful when every lane agrees on the clock: the whole
// point of stacking a measurement strip over an interval bar is that a vertical
// line means «the same moment». So the scale is computed ONCE by the caller and
// handed to every lane, instead of each chart deriving its own domain from its
// own data (which would silently misalign lanes with different date coverage).
//
// Domain-free by contract: milliseconds in, viewBox units out. The kit never
// decides what a date *means* — locale, calendar and label text stay with the
// app (the same division `TrendChart.formatX` already draws).
// ─────────────────────────────────────────────────────────────────────────────
// A linear scale over [min,max] → [padStart, width-padEnd].
//
//   scale.x(t)        → viewBox x for a timestamp (ms)
//   scale.invert(px)  → timestamp for a viewBox x
//   scale.clampX(t)   → x, clamped into the plot area (bars that start before
//                       the window still render, flush to the edge)
//   scale.inWindow(t) → is this timestamp inside the visible domain
function $95e851aef96b9382$export$27d74465d4d4bf01({ min: min, max: max, width: width, padStart: padStart = 0, padEnd: padEnd = 0 }) {
    const span = max - min || 1;
    const x0 = padStart;
    const x1 = Math.max(padStart + 1, width - padEnd);
    const w = x1 - x0;
    const x = (t)=>x0 + (t - min) / span * w;
    return {
        min: min,
        max: max,
        x0: x0,
        x1: x1,
        width: w,
        x: x,
        clampX: (t)=>Math.min(x1, Math.max(x0, x(t))),
        invert: (px)=>min + (px - x0) / w * span,
        inWindow: (t)=>t >= min && t <= max
    };
}
function $95e851aef96b9382$export$b9a1c56e49c8e590(min, max, count = 6) {
    const step = (max - min) / Math.max(1, count);
    return Array.from({
        length: count + 1
    }, (_, i)=>min + step * i);
}
function $95e851aef96b9382$export$849b7cb2b6ea39a7(points, scale, minGapPx = 8, isSignificant) {
    if (!points || points.length < 3) return points || [];
    const out = [];
    let lastX = -Infinity;
    points.forEach((p, i)=>{
        const px = scale.x(p.x);
        const keep = i === 0 || i === points.length - 1 || (isSignificant ? isSignificant(p) : false) || px - lastX >= minGapPx;
        if (keep) {
            out.push(p);
            lastX = px;
        }
    });
    return out;
}

});

parcelRegister("b9CYW", function(module, exports) {

$parcel$export(module.exports, "LaneGrid", () => $33096ab4a7258714$export$52ff61eca6e84e5a);
$parcel$export(module.exports, "NowLine", () => $33096ab4a7258714$export$cb94255ec4be9f06);
$parcel$export(module.exports, "CursorLine", () => $33096ab4a7258714$export$5c09e766dd7f9830);
$parcel$export(module.exports, "statusTone", () => $33096ab4a7258714$export$348dc3495f07d294);
$parcel$export(module.exports, "LANE_PAD", () => $33096ab4a7258714$export$3b8c55d8340f8b88);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
const $33096ab4a7258714$export$52ff61eca6e84e5a = ({ scale: scale, ticks: ticks, top: top = 0, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "aria-hidden": true
    }, (ticks || []).map((t, i)=>{
        if (!scale.inWindow(t)) return null;
        const x = Math.round(scale.x(t)) + 0.5; // crisp hairline
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            key: i,
            "data-chrome": "grid",
            x1: x,
            x2: x,
            y1: top,
            y2: bottom,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        });
    }));
const $33096ab4a7258714$export$cb94255ec4be9f06 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "now",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $jTCZr.CT).accent,
        strokeWidth: "1",
        opacity: "0.9",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$5c09e766dd7f9830 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "cursor",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $jTCZr.CT).mute,
        strokeWidth: "1",
        opacity: "0.75",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$348dc3495f07d294 = (status, fallback)=>{
    const s = String(status || '').toLowerCase();
    if (s === 'critical') return (0, $jTCZr.CT).danger;
    if (s === 'abnormal' || s === 'high' || s === 'low' || s === 'h' || s === 'l') return (0, $jTCZr.CT).warn;
    return fallback;
};
const $33096ab4a7258714$export$3b8c55d8340f8b88 = {
    start: 44,
    end: 12
};

});


parcelRegister("kCQwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $db32618d5eb876e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SeriesLane — one measurement plotted against a SHARED time axis.
//
// The time-domain sibling of `TrendChart`. The two are deliberately different
// components rather than one with a mode, because they answer different
// questions and their x-axes are not the same kind of thing:
//
//   TrendChart  — one series, standalone, points spaced by INDEX. «How has this
//                 analyte moved?» Even spacing is a feature there: it spends
//                 every pixel on shape, and a lone chart has nothing to align to.
//   SeriesLane  — points sit at their real TIMESTAMPS on a domain the caller
//                 owns, so several lanes stack into one timeline and a vertical
//                 line means «the same moment» in all of them.
//
// Multiple series per lane are for the components of ONE measurement (systolic
// and diastolic), never for unrelated metrics: those get their own lane with
// their own value scale. Two unrelated measures sharing one y-axis is the
// dual-axis mistake, and it invents correlations that are not in the data.
//
//   series      — [{ points:[{x,y,status?,id?}], color?, label? }] (x = ms, sorted)
//   refLow/High — reference band + the window it must stay inside
//   ticks       — the shared gridline timestamps
//   formatValue — value-axis labels; the caller owns the locale/digits
// ─────────────────────────────────────────────────────────────────────────────
const $db32618d5eb876e6$var$PAD_TOP = 10;
const $db32618d5eb876e6$var$PAD_BOTTOM = 8;
const $db32618d5eb876e6$var$SeriesLane = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, series: series = [], refLow: refLow, refHigh: refHigh, height: height = 88, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, gridLines: gridLines = 2, formatValue: formatValue = (v)=>String(Math.round(v * 10) / 10), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const lanes = (series || []).map((s)=>({
            ...s,
            points: (s.points || []).filter((p)=>p && Number.isFinite(p.y))
        })).filter((s)=>s.points.length);
    const all = lanes.flatMap((s)=>s.points.map((p)=>p.y));
    if (!all.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    // The value window always contains the reference band: a result is read
    // against its range, so a band pushed off-canvas would hide the very thing
    // that makes the number mean something.
    const dataMin = Math.min(...all, refLow ?? Infinity);
    const dataMax = Math.max(...all, refHigh ?? -Infinity);
    const span = dataMax - dataMin;
    const lo = dataMin - (span * 0.18 || Math.abs(dataMin * 0.1) || 1);
    const hi = dataMax + (span * 0.18 || Math.abs(dataMax * 0.1) || 1);
    const range = hi - lo || 1;
    const plotTop = $db32618d5eb876e6$var$PAD_TOP;
    const plotBottom = height - $db32618d5eb876e6$var$PAD_BOTTOM;
    const yOf = (v)=>plotTop + (plotBottom - plotTop) - (v - lo) / range * (plotBottom - plotTop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": "content",
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: scale.x0,
        y: yOf(refHigh),
        width: scale.x1 - scale.x0,
        height: Math.max(1, Math.abs(yOf(refLow) - yOf(refHigh))),
        fill: (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.09)
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = Math.round(yOf(v)) + 0.5;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: `g${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: scale.x0,
            x2: scale.x1,
            y1: y,
            y2: y,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: scale.x0 - 6,
            y: y + 3,
            textAnchor: "end",
            fill: (0, $jTCZr.CT).mute,
            style: {
                fontSize: '0.5625rem'
            }
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: plotTop,
        bottom: plotBottom
    }), lanes.map((s, si)=>{
        const color = s.color || (0, $jTCZr.CT).accent;
        const inWin = s.points.filter((p)=>p.x >= scale.min && p.x <= scale.max);
        if (!inWin.length) return null;
        const path = inWin.map((p)=>`${scale.x(p.x).toFixed(1)},${yOf(p.y).toFixed(1)}`).join(' ');
        // Dots thin when dense, but an out-of-range reading is never thinned
        // away — the abnormal point is the one the doctor came for.
        const dots = (0, $cRX9v.thinPoints)(inWin, scale, 9, (p)=>!!p.status && p.status !== 'normal');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: s.id ?? si
        }, inWin.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: path,
            fill: "none",
            stroke: color,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        }), dots.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: p.id ?? i,
                cx: scale.x(p.x),
                cy: yOf(p.y),
                r: "3.5",
                fill: (0, $jTCZr.CT).surface,
                stroke: (0, $b9CYW.statusTone)(p.status, color),
                strokeWidth: "2"
            })));
    }));
};
var $db32618d5eb876e6$export$2e2bcd8739ae039 = $db32618d5eb876e6$var$SeriesLane;

});

parcelRegister("ctU9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $c413dd52a563653b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// IntervalBars — spans of time as bars on a shared axis (a Gantt lane).
//
// Some facts are not points: a prescription is an exposure window, a shift is a
// span of coverage. Plotted as intervals against the same clock as the
// measurement lanes, they answer the question a dot never can — «was this
// running while that changed?».
//
//   rows  — [{ id, label, segments: [{ from, to, label?, tone?, open? }] }]
//           `to == null` (or open) ⇒ still running: the bar reaches `nowAt`
//           and takes an arrow cap instead of a flat end.
//
// Adjacent segments of one row are separated by a 2px gap in the surface
// colour — never a stroke around the bar: the gap is the separator, a border
// would add ink that is not data. That gap is also how a dosage change reads
// as a change rather than one long uninterrupted bar.
// ─────────────────────────────────────────────────────────────────────────────
const $c413dd52a563653b$var$SEG_GAP = 2;
// SVG has no text-overflow, and slicing a string is the wrong tool for a label
// that may be RTL: cutting Persian text and appending «…» puts the ellipsis on
// the visually *leading* edge, so the label reads as though its beginning were
// missing. So a label is drawn only when it fits whole (measure-free estimate at
// the label's font size, ~6.2px/char for the mixed fa/Latin names this carries);
// otherwise it is dropped and the value lives in the row header and the table.
// «A label that won't fit doesn't get clipped.»
const $c413dd52a563653b$var$CHAR_W = 6.2;
const $c413dd52a563653b$var$labelFits = (label, room)=>String(label).length * $c413dd52a563653b$var$CHAR_W <= room;
const $c413dd52a563653b$var$IntervalBars = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, rows: rows = [], rowHeight: rowHeight = 26, barThickness: barThickness = 15, height: height, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, formatLabel: formatLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const h = height || Math.max(rowHeight, rows.length * rowHeight + 8);
    const r = barThickness / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": rows.length ? 'content' : 'empty',
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), rows.map((row, ri)=>{
        const cy = 4 + ri * rowHeight + rowHeight / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: row.id ?? ri
        }, (row.segments || []).map((seg, si)=>{
            const open = seg.open || seg.to == null;
            const rawTo = open ? nowAt ?? scale.max : seg.to;
            if (seg.from > scale.max || rawTo < scale.min) return null;
            const x1 = scale.clampX(seg.from);
            // The gap belongs to every segment but the row's last one.
            const isLast = si === row.segments.length - 1;
            const x2 = Math.max(x1 + 2, scale.clampX(rawTo) - (isLast ? 0 : $c413dd52a563653b$var$SEG_GAP));
            const w = Math.max(2, x2 - x1);
            const tone = seg.tone || (0, $jTCZr.CT).navy;
            const label = formatLabel ? formatLabel(seg, row) : seg.label;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: seg.id ?? si
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: x1,
                y: cy - r,
                width: w,
                height: barThickness,
                rx: Math.min(4, r),
                fill: tone
            }), open && scale.inWindow(rawTo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: `M${x2 - 1},${cy - r} L${x2 + 6},${cy} L${x2 - 1},${cy + r} Z`,
                fill: tone
            }), label && w > 52 && $c413dd52a563653b$var$labelFits(label, w - 14) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
                x: x1 + w / 2,
                y: cy + 3.5,
                textAnchor: "middle",
                fill: "#ffffff",
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    direction: 'rtl'
                }
            }, label));
        }));
    }));
};
var $c413dd52a563653b$export$2e2bcd8739ae039 = $c413dd52a563653b$var$IntervalBars;

});

parcelRegister("cLQXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b578d6619b9c2e00$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// EventMarkers — discrete moments on a shared time axis.
//
// The lane for things that happen rather than things that are measured: a
// diagnosis recorded, an order placed, a document filed. Each mark carries its
// identity in its SHAPE and its row as well as its tone, so the lane still
// reads under colour-blindness, in monochrome print, and — the case that
// actually bites — under an accent preset where two brand hues sit close
// together. Colour reinforces identity here; it never carries it alone.
//
//   events — [{ id, t, row, label, tone, shape }]
//            shape: 'triangle' | 'diamond' | 'circle' | 'square'
//            row:   0-based lane row (events of a kind share a row)
//
// Labels are placed left→right and only when they clear the previous label on
// the same row; the rest stay reachable through the crosshair readout and the
// table view. A dense month is normal for a sick patient, and overlapping
// labels would make exactly those months unreadable.
// ─────────────────────────────────────────────────────────────────────────────
const $b578d6619b9c2e00$var$SHAPES = {
    triangle: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy + s * 0.8} L${cx - s},${cy + s * 0.8} Z`,
    diamond: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy} L${cx},${cy + s} L${cx - s},${cy} Z`,
    square: (cx, cy, s)=>`M${cx - s},${cy - s} L${cx + s},${cy - s} L${cx + s},${cy + s} L${cx - s},${cy + s} Z`
};
const $b578d6619b9c2e00$var$CHAR_W = 5.6;
const $b578d6619b9c2e00$var$EventMarkers = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, events: events = [], rows: rows = 1, rowHeight: rowHeight = 22, height: height, size: size = 5, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, showLabels: showLabels = true, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const h = height || rows * rowHeight + 10;
    // Declutter per row, walking forward; `labelEnd` tracks where the last
    // printed label finished so the next one only prints if it clears it.
    const placed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rowEnd = {};
        return [
            ...events
        ].filter((e)=>scale.inWindow(e.t)).sort((a, b)=>a.t - b.t).map((e)=>{
            const x = scale.x(e.t);
            const row = e.row || 0;
            const textW = String(e.label || '').length * $b578d6619b9c2e00$var$CHAR_W;
            const start = x + 9;
            const show = showLabels && !!e.label && start >= (rowEnd[row] ?? -Infinity) + 8;
            if (show) rowEnd[row] = start + textW;
            return {
                ...e,
                x: x,
                row: row,
                showLabel: show
            };
        });
    }, [
        events,
        scale,
        showLabels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": events.length ? 'content' : 'empty',
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), placed.map((e, i)=>{
        const cy = 6 + e.row * rowHeight + rowHeight / 2;
        const tone = e.tone || (0, $jTCZr.CT).accent;
        const path = $b578d6619b9c2e00$var$SHAPES[e.shape];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: e.id ?? i
        }, path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: path(e.x, cy, size + 1),
            fill: tone,
            stroke: (0, $jTCZr.CT).surface,
            strokeWidth: "1.5"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: e.x,
            cy: cy,
            r: size,
            fill: tone,
            stroke: (0, $jTCZr.CT).surface,
            strokeWidth: "1.5"
        }), e.showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: e.x + 9,
            y: cy + 3.5,
            fill: (0, $jTCZr.CT).ink2,
            style: {
                fontSize: '0.625rem'
            }
        }, e.label));
    }));
};
var $b578d6619b9c2e00$export$2e2bcd8739ae039 = $b578d6619b9c2e00$var$EventMarkers;

});

parcelRegister("3uzzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $28afc58f3cd2c6a9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $28afc58f3cd2c6a9$export$7266b1e659c4866f(initial = 640) {
    const [width, setWidth] = (0, $acw62.useState)(initial);
    const observerRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // Expose the node on the callback ref itself.
        ref.current = node;
        if (!node) return;
        const read = ()=>{
            const w = node.clientWidth || node.getBoundingClientRect?.().width || 0;
            // Sub-pixel jitter would re-render every lane on every scroll.
            if (w > 0) setWidth((prev)=>Math.abs(prev - w) >= 0.5 ? w : prev);
        };
        read();
        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(read);
            ro.observe(node);
            observerRef.current = ro;
        }
    }, []);
    return [
        ref,
        width
    ];
}
var $28afc58f3cd2c6a9$export$2e2bcd8739ae039 = $28afc58f3cd2c6a9$export$7266b1e659c4866f;

});

parcelRegister("kLmaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d9659251ef0350$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $f1d9659251ef0350$export$2e2bcd8739ae039(ref, varName = '--app-bottom-dock', enabled = true) {
    (0, $acw62.useEffect)(()=>{
        const el = ref?.current;
        if (!enabled || !el || !varName || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(varName, `${Math.round(el.offsetHeight)}px`);
        publish();
        // Absent in jsdom and older webviews; the one-shot measurement stands in.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(varName);
        };
    }, [
        ref,
        varName,
        enabled
    ]);
}

});

parcelRegister("2u27R", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $1cf0083ab82acba7$export$8f772b88f40431ca({ pairingUrl: pairingUrl, getToken: getToken, headers: headers, loadSession: loadSession, unlinkSession: unlinkSession, pollWhileDisconnected: pollWhileDisconnected = false } = {}) {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    // The live pairing attempt: { kind, code, expiresAt, message } or null.
    const [pairing, setPairing] = (0, $acw62.useState)(null);
    const controller = (0, $acw62.useRef)(null);
    // The callers are re-created on every render by most call sites, and a
    // dependency on them would restart the effects below forever. The ref is read
    // at call time, so the newest one is always the one used.
    const io = (0, $acw62.useRef)({
        getToken: getToken,
        headers: headers,
        loadSession: loadSession,
        unlinkSession: unlinkSession
    });
    (0, $acw62.useEffect)(()=>{
        io.current = {
            getToken: getToken,
            headers: headers,
            loadSession: loadSession,
            unlinkSession: unlinkSession
        };
    });
    const refetch = (0, $acw62.useCallback)(async ()=>{
        try {
            const next = await io.current.loadSession?.() || null;
            setSession(next);
            setError(null);
            return next;
        } catch (err) {
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const stopPairing = (0, $acw62.useCallback)(()=>{
        // Aborting closes the HTTP response, which the BFF turns into a gRPC cancel.
        // Without it the gateway holds a fresh, half-linked device open for the full
        // three-minute window and the phone accumulates abandoned entries in its
        // «linked devices» list.
        controller.current?.abort();
        controller.current = null;
        setPairing(null);
    }, []);
    // Whatever happens — a tab closed, a route change, a component unmounted — the
    // stream must not outlive the screen that opened it.
    (0, $acw62.useEffect)(()=>()=>{
            controller.current?.abort();
        }, []);
    // DISCONNECTED is transient and recovers on its own, which is why a screen that
    // gates an action on the link may ask to watch it: somebody who fixes the link
    // in another tab must see the action become available without reopening
    // anything. Opt-in, because a settings page has no such need and a poll nobody
    // is watching is a request nobody wanted. PAIRING is NOT polled — the stream
    // delivers it.
    (0, $acw62.useEffect)(()=>{
        if (!pollWhileDisconnected || session?.state !== 'DISCONNECTED') return undefined;
        const timer = setInterval(refetch, 2500);
        return ()=>clearInterval(timer);
    }, [
        pollWhileDisconnected,
        session?.state,
        refetch
    ]);
    const startLink = (0, $acw62.useCallback)(async (method, phone)=>{
        stopPairing();
        // A new attempt clears the last one's failure. Without this the screen keeps
        // reporting a gateway that was down two minutes ago while a code is on the way.
        setError(null);
        const token = await io.current.getToken?.();
        if (!token) throw new Error('Not authenticated');
        const url = new URL(pairingUrl, typeof window === 'undefined' ? undefined : window.location.origin);
        url.searchParams.set('method', method === 'PAIRING_CODE' ? 'PAIRING_CODE' : 'QR');
        if (phone) url.searchParams.set('phone', phone);
        const ctrl = new AbortController();
        controller.current = ctrl;
        const extra = typeof io.current.headers === 'function' ? io.current.headers() || {} : io.current.headers || {};
        let res;
        try {
            res = await fetch(url.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'text/event-stream',
                    ...extra
                },
                signal: ctrl.signal
            });
        } catch (err) {
            // AN ABORT IS NOT A FAILURE, and reporting it as one is a bug users meet
            // constantly: while a code is slow to arrive the screen looks dead, so
            // people press the button again — or switch from QR to the typed code —
            // and THAT aborts this request. Rethrowing put the browser's own
            // «signal is aborted without reason» on a Persian screen, as the reason
            // the attempt they had just started had failed.
            //
            // `readStream` has always swallowed its own aborts for this reason; this
            // is the same rule on the half of the request that happens before the
            // stream exists.
            if (err?.name === 'AbortError') return false;
            throw err;
        }
        if (!res.ok || !res.body) {
            const body = await res.json().catch(()=>null);
            controller.current = null;
            // The BFF's own sentence when it has one — it knows whether this was a
            // missing permission, a missing account or an unreachable gateway, and the
            // screen does not. It travels as `serverMessage` rather than as the
            // Error's own message, so a caller that renders it cannot accidentally
            // render a DOMException's English text the same way. Absent on purpose
            // when the BFF said nothing: copy belongs in the caller's catalogue.
            const refusal = new Error(body?.error || 'pairing refused');
            refusal.serverMessage = body?.error || '';
            throw refusal;
        }
        setPairing({
            kind: 'CONNECTING',
            code: '',
            expiresAt: null,
            message: ''
        });
        // Deliberately not awaited: the stream lives for as long as the pairing does,
        // and the caller needs its button back the moment the first code can arrive.
        $1cf0083ab82acba7$var$readStream(res.body, ctrl, controller, {
            setPairing: setPairing,
            refetch: refetch,
            setError: setError
        });
        return true;
    }, [
        pairingUrl,
        refetch,
        stopPairing
    ]);
    const unlink = (0, $acw62.useCallback)(async ()=>{
        stopPairing();
        await io.current.unlinkSession?.();
        await refetch();
    }, [
        refetch,
        stopPairing
    ]);
    return {
        session: session,
        loading: loading,
        error: error,
        pairing: pairing,
        refetch: refetch,
        startLink: startLink,
        stopPairing: stopPairing,
        unlink: unlink,
        /** The one state where a message can actually leave the building. */ canSend: session?.state === 'CONNECTED'
    };
}
/**
 * Reads SSE frames off the response body.
 *
 * Frames are separated by a blank line and a frame's `data:` is one JSON object.
 * Lines beginning `:` are the server's keep-alive comments and carry nothing —
 * they exist so an intermediary does not close a connection that is idle between
 * two QR codes.
 */ async function $1cf0083ab82acba7$var$readStream(body, ctrl, controller, { setPairing: setPairing, refetch: refetch, setError: setError }) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        for(;;){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let split;
            while((split = buffer.indexOf('\n\n')) >= 0){
                const frame = buffer.slice(0, split);
                buffer = buffer.slice(split + 2);
                const parsed = $1cf0083ab82acba7$export$9616b51a1be2e082(frame);
                if (!parsed) continue;
                if (parsed.event === 'error') {
                    // Server copy, or nothing — see the comment on the failed-response branch.
                    setError(new Error(parsed.data?.message || ''));
                    setPairing(null);
                    continue;
                }
                const { kind: kind, code: code, expiresInSeconds: expiresInSeconds, message: message } = parsed.data || {};
                if (kind === 'SUCCESS') {
                    setPairing(null);
                    await refetch();
                    continue;
                }
                if (kind === 'TIMEOUT' || kind === 'ERROR') {
                    setPairing({
                        kind: kind,
                        code: '',
                        expiresAt: null,
                        message: message || ''
                    });
                    continue;
                }
                setPairing({
                    kind: kind || 'QR',
                    code: code || '',
                    // An absolute instant, not a countdown: a component that re-renders for
                    // its own reasons must not restart the clock.
                    expiresAt: expiresInSeconds > 0 ? new Date(Date.now() + expiresInSeconds * 1000).toISOString() : null,
                    message: message || ''
                });
            }
        }
    } catch (err) {
        // An abort is this hook's own doing — the operator navigated away — and is
        // not a failure to report.
        if (err?.name !== 'AbortError') setError(err);
    } finally{
        // The stream that just finished may not be the one now in flight: pressing
        // «اتصال» twice aborts the first, and its cleanup must not wipe the second
        // one's code off the screen.
        if (controller.current === ctrl) {
            controller.current = null;
            setPairing(null);
        }
    }
}
function $1cf0083ab82acba7$export$9616b51a1be2e082(frame) {
    let event = 'message';
    const data = [];
    for (const line of String(frame).split('\n')){
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trim());
    }
    if (!data.length) return null;
    try {
        return {
            event: event,
            data: JSON.parse(data.join('\n'))
        };
    } catch  {
        return null;
    }
}
var $1cf0083ab82acba7$export$2e2bcd8739ae039 = $1cf0083ab82acba7$export$8f772b88f40431ca;

});

parcelRegister("fOdIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6342f4e7688b45e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $kMJsW = parcelRequire("kMJsW");
var $QG9Z3 = parcelRequire("QG9Z3");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
/**
 * ChatBubble — one message in a conversation (kit-grade per DESIGN-CONCEPT
 * §17.2: tokens only, logical properties only, language-free, presentational).
 *
 * The chat-spec decisions this component encodes so no app re-derives them:
 *
 *  - **Alignment is `alignSelf`, never a margin hack.** `flex-end` for my
 *    messages, `flex-start` for the other party — logical values, so the whole
 *    conversation mirrors correctly under `dir="ltr"` with no direction prop.
 *  - **Radius 14px card scale (`0.875rem`) with a 10px "tail" corner**
 *    (`var(--radius, 0.625rem)`): the reduced corner sits on the block-end,
 *    *inline-start-or-end* edge nearest the sender — `borderEndEndRadius` on
 *    mine, `borderEndStartRadius` on theirs. Logical corners: the tail flips
 *    with the document direction by itself.
 *  - **No `•` separator ever** — the meta row (time + status) is a space-gap
 *    flex layout.
 *  - **A failed write must look failed**: `failed` restyles the surface from
 *    the `CT.danger*` family and renders a retry affordance; the caller decides
 *    when to actually re-send (`onRetry`).
 *  - **Delivery state is never colour-only.** Pass `status` and the bubble
 *    draws the glyph itself — `Clock` / `Check` / `TriangleAlert` — so the
 *    difference between "sending", "sent" and "failed" survives a colour-blind
 *    reader and a greyscale screen (DESIGN-CONCEPT §12 "colour is never the
 *    only carrier of meaning"). Apps do not ship their own dot.
 *
 * States (always stamped on the root as `data-state`): `sent` | `pending`
 * (60% opacity — visibly in flight) | `failed`.
 *
 * The root stays a plain div forwarding `...rest`; `role="listitem"` and any
 * grouping semantics are the caller's business.
 *
 * Props:
 *   body        — message text (rendered `dir="auto"`, pre-wrap, wraps anywhere)
 *   timeLabel   — pre-formatted time string; the calendar/locale stays with the app
 *   mine        — true for the authenticated user's own messages
 *   pending     — in-flight local echo (awaiting the server)
 *   failed      — the send failed; renders the retry affordance when `onRetry` given
 *   status      — 'pending' | 'sent' | 'failed': draws the delivery glyph. This
 *                 is the supported way to show delivery state; `statusLabel`
 *                 names it for screen readers.
 *   statusIcon  — escape hatch: a caller-supplied status node, used INSTEAD of
 *                 the built-in glyph
 *   statusLabel — screen-reader text for the status glyph (an icon alone says
 *                 nothing). NOTE: `statusLabel` on its own draws nothing
 *                 visible — it is the accessible name of a glyph, so it needs
 *                 `status` (or `statusIcon`) beside it. Dev builds warn.
 *   onRetry     — re-send handler; button rendered only when `failed`
 *   retryLabel  — label for the retry affordance
 *   style       — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // The delivery vocabulary the kit draws. Three states, three shapes — the
// glyph, not the hue, is what distinguishes them.
const $a6342f4e7688b45e$var$STATUS_GLYPH = {
    pending: (0, $kMJsW.default),
    sent: (0, $huNwV.default),
    failed: (0, $QG9Z3.default)
};
function $a6342f4e7688b45e$export$2e2bcd8739ae039({ body: body, timeLabel: timeLabel, mine: mine = false, pending: pending = false, failed: failed = false, status: status, statusIcon: statusIcon, statusLabel: statusLabel, onRetry: onRetry, retryLabel: retryLabel, className: className, style: style, 'data-testid': testId = 'chat-bubble', ...rest }) {
    const state = failed ? 'failed' : pending ? 'pending' : 'sent';
    // Surface per party; `failed` overrides both — an undelivered message is a
    // problem to act on, not a normal bubble at lower opacity.
    const surface = failed ? {
        background: (0, $jTCZr.CT).dangerSoft,
        color: (0, $jTCZr.CT).dangerInk,
        border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.CT).danger, 0.4)}`
    } : mine ? {
        background: (0, $jTCZr.C).navy,
        color: '#ffffff',
        border: 'none'
    } : {
        background: (0, $jTCZr.C).card,
        color: (0, $jTCZr.C).textPrimary,
        border: `1px solid ${(0, $jTCZr.C).border}`
    };
    // Meta ink follows the surface. On navy the safe soft ink is literal white at
    // reduced opacity (colour arithmetic on a var() token is banned — soft() would
    // work, but #fff is the one sanctioned literal on navy).
    const metaStyle = failed ? {
        color: (0, $jTCZr.CT).dangerInk,
        opacity: 0.8
    } : mine ? {
        color: '#ffffff',
        opacity: 0.75
    } : {
        color: (0, $jTCZr.C).textMuted
    };
    const Glyph = status ? $a6342f4e7688b45e$var$STATUS_GLYPH[status] : null;
    // Tint: the muted ink for the two quiet states, the danger ink for a failed
    // write. The one exception is the navy `mine` surface, where a fixed grey is
    // simply unreadable — there the glyph inherits the meta row's ink, which is
    // already the muted value FOR that surface. Same intent, legible result.
    const glyphColor = mine && !failed ? 'currentColor' : status === 'failed' ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).mute;
    const glyph = statusIcon || (Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        size: 13,
        strokeWidth: 2.25,
        "aria-hidden": true,
        style: {
            color: glyphColor
        }
    }) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: mine ? 'flex-end' : 'flex-start',
            // Alignment via alignSelf ONLY — never marginInline hacks, never textAlign.
            alignSelf: mine ? 'flex-end' : 'flex-start',
            maxWidth: 'min(85%, 42rem)',
            gap: '0.25rem',
            // Caller style MERGES over the computed layout (the `Card` precedent) —
            // spreading it after `...rest` used to silently drop `alignSelf` and
            // take mine/theirs alignment with it.
            ...style
        },
        ...rest,
        // AFTER ...rest: the delivery state is derived, not caller-supplied.
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...surface,
            borderRadius: '0.875rem',
            // The "tail": the corner nearest the sender drops to the base radius.
            ...mine ? {
                borderEndEndRadius: 'var(--radius, 0.625rem)'
            } : {
                borderEndStartRadius: 'var(--radius, 0.625rem)'
            },
            padding: '0.5rem 0.875rem',
            ...pending && {
                opacity: 0.6
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.875rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere'
        }
    }, body), (timeLabel || glyph || statusLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.375rem',
            marginTop: '0.125rem',
            fontSize: '0.75rem',
            ...metaStyle
        }
    }, timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, timeLabel), glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusLabel,
        style: {
            display: 'inline-flex',
            alignItems: 'center'
        }
    }, glyph), !glyph && statusLabel && // Misuse (warned above), but the fact is not thrown away: assistive
    // tech still gets the delivery state.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            border: 0
        }
    }, statusLabel))), failed && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onRetry,
        "data-testid": `${testId}-retry`,
        // size="sm" is 2.25rem; this renders on both apps' phone threads,
        // where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, retryLabel));
}

});
parcelRegister("kMJsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b71f7c0d2454a8e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2b71f7c0d2454a8e$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ]
];
const $2b71f7c0d2454a8e$export$2e2bcd8739ae039 = (0, $9QBug.default)("clock", $2b71f7c0d2454a8e$export$3efd853dbb351e94);

});


parcelRegister("l0ks6", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fd1e3fa9bffaa8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $01fd1e3fa9bffaa8$export$2e2bcd8739ae039({ label: label, className: className, style: style, 'data-testid': testId = 'chat-day-divider', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            paddingBlock: '0.5rem',
            // Caller style MERGES over the computed layout (the `Card` precedent):
            // arriving inside `...rest` it used to replace `display: flex` outright
            // and collapse the two hairlines.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $jTCZr.C).border
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.C).bg,
            paddingInline: '0.625rem',
            borderRadius: 'var(--radius, 0.625rem)',
            whiteSpace: 'nowrap'
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $jTCZr.C).border
        }
    }));
}

});

parcelRegister("jeN3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c9e9585cb6c9b4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6OGKD = parcelRequire("6OGKD");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $5MbI8 = parcelRequire("5MbI8");

var $dOauK = parcelRequire("dOauK");
'use client';
function $27c9e9585cb6c9b4$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, disabled: disabled = false, sending: sending = false, placeholder: placeholder, sendLabel: sendLabel, sendIcon: sendIcon, readOnlyNotice: readOnlyNotice, maxLength: maxLength = 4000, autoGrowMaxRem: autoGrowMaxRem = 7.5, className: className, style: style, 'data-testid': testId = 'chat-composer', inputProps: inputProps, ...rest }) {
    const fieldRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Auto-grow: collapse, then take the content's scrollHeight. The rem clamp
    // lives in CSS (`maxHeight`), so the px assignment here never exceeds it and
    // the field starts scrolling instead of growing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = fieldRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [
        value,
        readOnlyNotice
    ]);
    if (readOnlyNotice) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            padding: '0.5rem 1rem',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        },
        ...rest,
        "data-state": "readonly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testId}-notice`
    }, readOnlyNotice));
    const canSend = !disabled && !sending && Boolean(value && value.trim());
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter' || e.shiftKey) return;
        // Committing IME composition ends with Enter too — that one is not a send.
        if (e.nativeEvent && e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (canSend) onSend();
    };
    const { className: fieldClassName, style: fieldStyle, ...fieldRest } = inputProps || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            // Caller style MERGES over the computed layout (the `Card` precedent).
            ...style
        },
        ...rest,
        // AFTER ...rest: the send lifecycle is the composer's own state.
        "data-state": sending ? 'sending' : 'ready'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: fieldRef,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        "aria-label": placeholder,
        disabled: disabled || sending,
        rows: 1,
        maxLength: maxLength,
        dir: "auto",
        "data-testid": `${testId}-field`,
        className: (0, $5JYPc.cn)(// The replacement for the outline we suppress — keyboard focus on the
        // feature's primary input has to be visible (§12.2).
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', 'transition-shadow duration-150', fieldClassName),
        style: {
            flex: 1,
            minWidth: 0,
            // ≥1rem or iOS zooms the page on focus — the composer's iron rule.
            fontSize: '1rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary,
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 'var(--radius, 0.625rem)',
            padding: '0.625rem 0.875rem',
            resize: 'none',
            maxHeight: `${autoGrowMaxRem}rem`,
            overflowY: 'auto',
            ...disabled || sending ? {
                opacity: 0.6
            } : null,
            ...fieldStyle
        },
        ...fieldRest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: sendIcon || // RTL-first flip — see the header note; LTR apps override via sendIcon.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
            size: 18,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(-1)'
            }
        }),
        label: sendLabel,
        onClick: ()=>{
            if (canSend) onSend();
        },
        disabled: !canSend,
        "data-testid": `${testId}-send`
    }));
}

});
parcelRegister("6OGKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c49d7be4abd1b80$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6c49d7be4abd1b80$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $6c49d7be4abd1b80$export$2e2bcd8739ae039 = (0, $9QBug.default)("send", $6c49d7be4abd1b80$export$3efd853dbb351e94);

});


parcelRegister("kaN2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5a908f2b99a71b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $hZDga = parcelRequire("hZDga");
'use client';
/**
 * ChatThread — the message column of a conversation (kit-grade per
 * DESIGN-CONCEPT §17.2). A flex column of `ChatBubble`/`ChatDayDivider`
 * children with the two behaviours every thread needs and no app should
 * re-derive:
 *
 *  - **Backwards pagination is a button, never a scroll trigger** (the
 *    pagination-not-infinite-scroll rule): when `hasOlder`, a ghost expander
 *    sits at the top of the thread; `loadingOlder` disables it and shows the
 *    kit spinner.
 *  - **Containment-safe autoscroll**: when the children count grows and the
 *    user was at/near the bottom (within ~4rem), the thread follows — by
 *    assigning `scrollTop` on the **resolved scroll container**, NEVER
 *    `scrollIntoView`, which walks every ancestor scroller and yanks the whole
 *    page in an embedded pane. A reader scrolled up into history is never
 *    yanked down, and a prepended older page never triggers it.
 *
 * Two containment modes via `fill`:
 *   true  — the thread IS the scroll container (`flex: 1; minHeight: 0;
 *           overflowY: auto`) for a desktop pane (the doctor app's P4 column);
 *   false — the thread sits in page flow and something ABOVE it scrolls.
 *
 * **Resolving the scroller (why this is not `document.scrollingElement`).**
 * In `fill={false}` mode the scroller is whatever ancestor actually scrolls,
 * and on a phone that is almost never the document: both mobile shells are
 * `inset: 0; overflow: hidden` with a single inner `overflow-y: auto` region.
 * Writing `document.scrollingElement.scrollTop` there lands on an element that
 * cannot scroll, and listening on `window` never fires, so the sampled gap
 * stays at its seed and autoscroll is silently dead. So the component walks
 * `containerRef.current.parentElement` upward for a computed `overflowY` of
 * `auto`/`scroll` and uses the first hit — falling back to
 * `document.scrollingElement` for a genuinely page-scrolled surface. The result
 * is cached per mount and re-resolved if the container node itself changes.
 * Callers may name the scroller explicitly with `scrollParentRef` instead.
 *
 * `role="log"` + `aria-live="polite"`: new messages are announced without
 * interrupting, and assistive tech knows earliest-first ordering applies.
 *
 * Exposes `scrollToBottom()` via ref for the caller's "jump to latest"
 * affordances.
 *
 * Props:
 *   children       — the message column (bubbles, day dividers)
 *   fill           — scroll-container mode (see above; default false)
 *   padBlockRem    — block padding in rem. Pass this instead of
 *                    `style={{ paddingBlock }}`: `style` is merged now, but a
 *                    named prop keeps the caller out of the layout entirely.
 *   hasOlder       — render the load-older expander
 *   onLoadOlder    — expander handler
 *   loadingOlder   — expander busy state (disabled + spinner)
 *   loadOlderLabel — expander label
 *   autoScroll     — follow new messages when near the bottom (default true)
 *   scrollParentRef— optional ref to the scroll container, skipping resolution
 *   style          — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // "Near the bottom" — ~4rem at the default type scale. Close enough that the
// reader is clearly following the conversation, not studying history.
const $af5a908f2b99a71b$var$NEAR_BOTTOM_PX = 64;
const $af5a908f2b99a71b$var$SCROLLY = new Set([
    'auto',
    'scroll',
    'overlay'
]);
const $af5a908f2b99a71b$var$ChatThread = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChatThread({ children: children, fill: fill = false, padBlockRem: padBlockRem, hasOlder: hasOlder = false, onLoadOlder: onLoadOlder, loadingOlder: loadingOlder = false, loadOlderLabel: loadOlderLabel, autoScroll: autoScroll = true, scrollParentRef: scrollParentRef, className: className, style: style, 'data-testid': testId = 'chat-thread', ...rest }, ref) {
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Distance from the bottom edge, sampled on every scroll — read (not
    // recomputed) when children arrive, so the decision reflects where the user
    // WAS before the DOM grew. Starts at 0: opening a thread lands on the latest
    // message.
    const bottomGapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const prevCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // The resolved scroller, cached per mount, plus the container node it was
    // resolved FROM — a `key` swap gives us a new node and must re-resolve.
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerForRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set while a backwards page is being prepended, so the growth it causes is
    // not mistaken for a new message. Without it a short thread — one that never
    // scrolled, so the sampled gap is still its 0 seed — passes the near-bottom
    // guard and yanks the reader away from the «older» button they just pressed.
    const prependingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children);
    const resolveScroller = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = containerRef.current;
        if (!el) return null;
        // `fill` — the thread IS the scroller; nothing to walk.
        if (fill) return el;
        if (scrollParentRef && scrollParentRef.current) return scrollParentRef.current;
        if (scrollerForRef.current === el && scrollerRef.current) return scrollerRef.current;
        let found = null;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') for(let node = el.parentElement; node; node = node.parentElement){
            const overflowY = window.getComputedStyle(node).overflowY;
            if ($af5a908f2b99a71b$var$SCROLLY.has(overflowY)) {
                found = node;
                break;
            }
        }
        // Nothing between here and the root scrolls → the page really does.
        if (!found && typeof document !== 'undefined') found = document.scrollingElement;
        scrollerRef.current = found;
        scrollerForRef.current = el;
        return found;
    }, [
        fill,
        scrollParentRef
    ]);
    const sampleGap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) bottomGapRef.current = el.scrollHeight - el.scrollTop - el.clientHeight;
    }, [
        resolveScroller
    ]);
    const scrollToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) el.scrollTop = el.scrollHeight; // the scroller itself — containment-safe
        bottomGapRef.current = 0;
    }, [
        resolveScroller
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            scrollToBottom: scrollToBottom
        }), [
        scrollToBottom
    ]);
    // Sample the gap from whatever actually scrolls.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const el = resolveScroller();
        if (!el) return undefined;
        // The viewport's scroll event is dispatched at the Document, not at <html>,
        // so a document-level scroller has to be listened to on `window`.
        const isDocScroller = typeof document !== 'undefined' && (el === document.scrollingElement || el === document.documentElement || el === document.body);
        const target = isDocScroller ? window : el;
        const onScroll = ()=>sampleGap();
        target.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>target.removeEventListener('scroll', onScroll);
    }, [
        resolveScroller,
        sampleGap
    ]);
    // Follow growth only when the reader was already at the bottom.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const prev = prevCountRef.current;
        prevCountRef.current = childCount;
        if (!autoScroll || childCount <= prev) return;
        // Backwards page: the growth is above the reader, never below.
        if (prependingRef.current) {
            prependingRef.current = false;
            return;
        }
        if (bottomGapRef.current <= $af5a908f2b99a71b$var$NEAR_BOTTOM_PX) scrollToBottom();
    }, [
        childCount,
        autoScroll,
        scrollToBottom
    ]);
    // Declared AFTER the growth effect on purpose: when a load-older resolves,
    // both run in the same commit and the growth effect must still see the flag.
    // This one only clears a flag the fetch never spent — an empty or failed page
    // produces no growth, and a stale flag would swallow the next real message.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!loadingOlder) prependingRef.current = false;
    }, [
        loadingOlder
    ]);
    const handleLoadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        prependingRef.current = true;
        onLoadOlder?.(e);
    }, [
        onLoadOlder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "log",
        "aria-live": "polite",
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInline: '1rem',
            ...padBlockRem != null && {
                paddingBlock: `${padBlockRem}rem`
            },
            ...fill && {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            // Caller style MERGES over the computed layout — it never replaces it.
            // (Same precedent as `Card`.) Anything a caller genuinely needs to own,
            // like block padding, has a named prop.
            ...style
        },
        ...rest,
        // AFTER ...rest: the thread's own busy state is not the caller's to
        // overwrite — a caller-side data-state would hide `loading` forever.
        "data-state": loadingOlder ? 'loading' : 'ready'
    }, hasOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: handleLoadOlder,
        disabled: loadingOlder,
        "data-testid": `${testId}-load-older`,
        // size="sm" is 2.25rem; this control renders on both apps' phone
        // threads, where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $jTCZr.C).textSecondary
        }
    }, loadingOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        thickness: 2
    }), loadOlderLabel)), children);
});
var $af5a908f2b99a71b$export$2e2bcd8739ae039 = $af5a908f2b99a71b$var$ChatThread;

});

parcelRegister("awevB", function(module, exports) {

$parcel$export(module.exports, "rangeLabelFor", () => $751677fd0a80fd7a$export$94bb145bb1ee00a2);
$parcel$export(module.exports, "default", () => $751677fd0a80fd7a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $4UJrq = parcelRequire("4UJrq");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");

var $4Qco3 = parcelRequire("4Qco3");
'use client';
/**
 * Date-range filter as a single dropdown.
 *
 * The trigger always reads out the *applied* range ("امروز", "۱۲–۱۸ تیر", "Sep 12–18"), so the
 * active filter is never ambiguous — the older layout left the two date inputs
 * visible next to the preset chips, and a custom range highlighted no chip at all.
 *
 * Props:
 *   presets   — [{ id, label }]; the ids are opaque, the parent maps them to a window
 *   preset    — active preset id, or 'custom'
 *   custom    — { from, to } applied custom range, Gregorian 'YYYY-MM-DD' (picker format)
 *   onPreset  — (id) => void
 *   onCustom  — (from, to) => void; only fired once BOTH ends are picked
 */ // Gregorian 'YYYY-MM-DD' (what JalaliDatePicker emits) → { y, m, d } in the
// calendar the page reads: Jalali for Persian and Arabic, Gregorian for English —
// the same choice the picker itself makes (lib/datePickerLocale.js).
const $751677fd0a80fd7a$var$partsOf = (s, calendar)=>{
    if (!s || s.length < 10) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return calendar === 'jalali' ? (0, $4UJrq.msToJalali)(Date.UTC(y, m - 1, d)) : {
        y: y,
        m: m,
        d: d
    };
};
const $751677fd0a80fd7a$var$dayKey = (p)=>p.y * 10000 + p.m * 100 + p.d;
function $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale) {
    const L = (0, $IZwml.datePickerLocale)(locale);
    let a = $751677fd0a80fd7a$var$partsOf(fromStr, L.calendar);
    let b = $751677fd0a80fd7a$var$partsOf(toStr, L.calendar);
    if (!a || !b) return (0, $j9AxR.kitCopy)(locale).dateRange.custom;
    if ($751677fd0a80fd7a$var$dayKey(a) > $751677fd0a80fd7a$var$dayKey(b)) [a, b] = [
        b,
        a
    ];
    const num = (x)=>(0, $IZwml.withDigits)(x, L.digits);
    const month = (p)=>L.months[L.calendar][p.m - 1];
    if (L.calendar === 'gregorian') {
        const md = (p)=>`${month(p)} ${num(p.d)}`;
        if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${md(a)}, ${num(a.y)}`;
        if (a.y === b.y && a.m === b.m) return `${month(a)} ${num(a.d)}\u{2013}${num(b.d)}`;
        if (a.y === b.y) return `${md(a)} \u{2013} ${md(b)}`;
        return `${md(a)}, ${num(a.y)} \u{2013} ${md(b)}, ${num(b.y)}`;
    }
    const dm = (p)=>`${num(p.d)} ${month(p)}`;
    if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${dm(a)} ${num(a.y)}`;
    if (a.y === b.y && a.m === b.m) return `${num(a.d)}\u{2013}${num(b.d)} ${month(a)}`;
    if (a.y === b.y) return `${dm(a)} \u{2013} ${dm(b)}`;
    return `${dm(a)} ${num(a.y)} \u{2013} ${dm(b)} ${num(b.y)}`;
}
function $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, fromStr, toStr, presets, locale) {
    if (preset === 'custom') return $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale);
    return (presets.find((p)=>p.id === preset) || {}).label || '';
}
const $751677fd0a80fd7a$var$CalendarIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }));
const $751677fd0a80fd7a$var$ChevronIcon = ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "14",
        height: "14",
        fill: "currentColor",
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const $751677fd0a80fd7a$var$CheckIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
const $751677fd0a80fd7a$var$PresetRow = ({ label: label, active: active, onClick: onClick })=>{
    const [hov, setHov] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            border: 'none',
            background: active ? (0, $jTCZr.C).tealLight : hov ? (0, $jTCZr.C).bg : 'transparent',
            color: active ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textSecondary,
            fontSize: 13,
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            textAlign: 'start',
            transition: 'background 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CheckIcon, null));
};
function $751677fd0a80fd7a$export$2e2bcd8739ae039({ presets: presets, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    // Draft dates live here, not in the parent: a range is only *applied* once both
    // ends exist, so a half-picked range can never desync the trigger label from the
    // window the list is actually showing.
    const [dFrom, setDFrom] = (0, $acw62.useState)(custom.from);
    const [dTo, setDTo] = (0, $acw62.useState)(custom.to);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setDFrom(custom.from);
            setDTo(custom.to);
        }
    }, [
        open,
        custom.from,
        custom.to
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (!ref.current) return;
            if (ref.current.contains(e.target)) return;
            // The two custom-range fields are `JalaliDatePicker`s, and their calendar
            // is PORTALED to <body> so a clipping ancestor cannot slice it. That puts
            // it outside `ref`, so picking a day counted as an outside click and shut
            // the dropdown before the date could register — which made the custom
            // range unreachable by calendar in every screen that uses this filter.
            if (e.target.closest?.('[data-jalali-popup]')) return;
            setOpen(false);
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open
    ]);
    const copy = (0, $j9AxR.kitCopy)().dateRange;
    const isCustom = preset === 'custom';
    const label = $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, custom.from, custom.to, presets);
    const halfDone = !!dFrom !== !!dTo;
    const pickPreset = (id)=>{
        onPreset(id);
        setOpen(false);
    };
    const pickFrom = (v)=>{
        setDFrom(v);
        if (v && dTo) {
            onCustom(v, dTo);
            setOpen(false);
        }
    };
    const pickTo = (v)=>{
        setDTo(v);
        if (v && dFrom) {
            onCustom(dFrom, v);
            setOpen(false);
        }
    };
    const highlighted = open || isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOpen((o)=>!o),
        title: copy.title,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 36,
            padding: '0 12px',
            borderRadius: 8,
            border: `1px solid ${highlighted ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            background: highlighted ? '#fff' : (0, $jTCZr.C).bg,
            color: highlighted ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textPrimary,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CalendarIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$ChevronIcon, {
        open: open
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineStart: 0,
            zIndex: 60,
            width: 260,
            background: '#fff',
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 12px 36px rgba(0,0,0,0.14)',
            padding: 8
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$PresetRow, {
            key: p.id,
            label: p.label,
            active: preset === p.id,
            onClick: ()=>pickPreset(p.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border,
            margin: '8px 4px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: isCustom ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textMuted,
            padding: '2px 10px 8px'
        }
    }, copy.custom), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 8,
            padding: '0 4px 4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: dFrom,
        onChange: pickFrom,
        placeholder: copy.from,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: dTo,
        onChange: pickTo,
        placeholder: copy.to,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), halfDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $jTCZr.C).amber,
            fontWeight: 600,
            padding: '0 2px'
        }
    }, copy.needBoth))));
}

});
parcelRegister("4UJrq", function(module, exports) {

$parcel$export(module.exports, "IRAN_OFFSET_MS", () => $393fa4133562fea6$export$c7153f4b19854938);
$parcel$export(module.exports, "msToJalali", () => $393fa4133562fea6$export$129955be4a159fb3);
$parcel$export(module.exports, "jalaliToMs", () => $393fa4133562fea6$export$998538909dbe3791);
$parcel$export(module.exports, "jDaysInMonth", () => $393fa4133562fea6$export$33c90dd38a62167e);
const $393fa4133562fea6$export$6c2d0d964670e2e3 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $393fa4133562fea6$export$fb4a539c21dc93d2 = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $393fa4133562fea6$export$961e0c326b64dc98 = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[+d]);
const $393fa4133562fea6$export$c7153f4b19854938 = 12600000;
const $393fa4133562fea6$export$710ba58c9cc5d7e7 = ()=>new Date(Date.now() + $393fa4133562fea6$export$c7153f4b19854938);
function $393fa4133562fea6$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $393fa4133562fea6$export$129955be4a159fb3(ms) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = Math.floor((ms - anchor) / 86400000);
    if (!Number.isFinite(days)) return null;
    // Nothing in a medical record predates the Jalali era, so a timestamp that
    // far back is corrupt input. Reject it rather than walk ~270,000 iterations
    // and hand the caller a confident negative year.
    if (days < -520000) return null; // ≈ year 1
    let y = 1400;
    // Before the anchor: step back a year at a time until the day index lands
    // inside one, mirroring the forward walk below.
    while(days < 0){
        y--;
        days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    }
    while(true){
        const diy = $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $393fa4133562fea6$export$998538909dbe3791(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29
    ];
    for(let m = 0; m < jm - 1; m++)days += md[m];
    days += jd - 1;
    return anchor + days * 86400000;
}
function $393fa4133562fea6$export$33c90dd38a62167e(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    return $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29;
}
function $393fa4133562fea6$export$748262491e74cb62() {
    const now = $393fa4133562fea6$export$710ba58c9cc5d7e7();
    // Day-of-week in Iran time: getUTCDay() because we manually shifted the clock
    const jsDay = now.getUTCDay(); // 0=Sun … 6=Sat
    const irWeekday = (jsDay + 1) % 7; // 0=ش … 6=ج
    const nowMs = now.getTime(); // already shifted UTC+3:30
    return Array.from({
        length: 7
    }, (_, i)=>{
        const dayMs = nowMs + (i - irWeekday) * 86400000;
        return {
            ...$393fa4133562fea6$export$129955be4a159fb3(dayMs),
            shortName: $393fa4133562fea6$export$fb4a539c21dc93d2[i],
            isToday: i === irWeekday
        };
    });
}

});


parcelRegister("1Ssl4", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $54fc473ae52026aa$export$93d4e7f90805808f);
$parcel$export(module.exports, "default", () => $54fc473ae52026aa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Applies the doctor's accent preset and type scale to <html>.
 *
 * Where the value comes from, in order:
 *   1. localStorage, read synchronously during the first render, so a reload
 *      paints the chosen accent immediately instead of flashing the default
 *      while the `me` query is still in flight.
 *   2. The server copy, pushed in via `appearance` once settings load. That is
 *      the real record and wins whenever it differs — it is how the preference
 *      follows the doctor to another device.
 *
 * Themed values are CSS custom properties (see tokens.css), so switching the
 * preset re-themes every screen without re-rendering anything: this provider
 * only sets two attributes on the root element.
 */ const $54fc473ae52026aa$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $54fc473ae52026aa$export$d8964aec282183a3({ appearance: appearance, children: children }) {
    // Lazy initialiser — runs before first paint, not in an effect.
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const stored = (0, $jTCZr.readStoredAppearance)();
        (0, $jTCZr.applyAppearance)(stored);
        return stored;
    });
    const serverTheme = appearance?.theme;
    const serverFontSize = appearance?.fontSize;
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // the accent on another device). Nulls mean "not loaded yet" — not "reset".
    (0, $acw62.useEffect)(()=>{
        if (!serverTheme && !serverFontSize) return;
        setLocal((prev)=>{
            const next = {
                theme: serverTheme || prev.theme,
                fontSize: serverFontSize || prev.fontSize
            };
            if (next.theme === prev.theme && next.fontSize === prev.fontSize) return prev;
            const resolved = (0, $jTCZr.applyAppearance)(next);
            (0, $jTCZr.storeAppearance)(resolved);
            return resolved;
        });
    }, [
        serverTheme,
        serverFontSize
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            theme: local.theme,
            fontSize: local.fontSize,
            // Apply a choice locally and cache it. Two callers:
            //   - the settings picker, so the accent switches under the doctor's cursor
            //     instead of after a server round trip;
            //   - app boot, to adopt the server's copy once `me` resolves.
            // Persisting to the BFF is the caller's job — this only paints and caches.
            setAppearance: (patch)=>{
                setLocal((prev)=>{
                    const resolved = (0, $jTCZr.applyAppearance)({
                        ...prev,
                        ...patch
                    });
                    (0, $jTCZr.storeAppearance)(resolved);
                    return resolved;
                });
            }
        }), [
        local
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54fc473ae52026aa$var$ThemeContext.Provider, {
        value: value
    }, children);
}
function $54fc473ae52026aa$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($54fc473ae52026aa$var$ThemeContext) ?? {
        theme: (0, $jTCZr.DEFAULT_THEME),
        fontSize: (0, $jTCZr.DEFAULT_FONT_SIZE),
        setAppearance: ()=>{}
    };
}
var $54fc473ae52026aa$export$2e2bcd8739ae039 = $54fc473ae52026aa$export$d8964aec282183a3;

});

parcelRegister("ev4PJ", function(module, exports) {

$parcel$export(module.exports, "setUiStrings", () => $02b96a2843192315$export$bf11b40754c929ae);

var $acw62 = parcelRequire("acw62");
'use client';
const $02b96a2843192315$export$df49a36517896dd5 = {
    // ── The Jalali date picker ────────────────────────────────────────────────
    'common.datePicker.placeholder': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.clear': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.openCalendar': "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
    'common.datePicker.today': "\u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.goToToday': "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.now': "\u0627\u06A9\u0646\u0648\u0646",
    'common.datePicker.hour': "\u0633\u0627\u0639\u062A",
    'common.datePicker.minute': "\u062F\u0642\u06CC\u0642\u0647",
    // `{{unit}}` is one of the two above — a stepper's two arrows are named
    // "hour more" / "hour less" for a screen reader.
    'common.datePicker.increase': "{{unit}} \u0628\u06CC\u0634\u062A\u0631",
    'common.datePicker.decrease': "{{unit}} \u06A9\u0645\u062A\u0631",
    'common.datePicker.previousMonth': "\u0645\u0627\u0647 \u0642\u0628\u0644",
    'common.datePicker.nextMonth': "\u0645\u0627\u0647 \u0628\u0639\u062F",
    'common.datePicker.errors.format': "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: \u06F1\u06F4\u06F0\u06F4/\u06F0\u06F5/\u06F1\u06F2",
    'common.datePicker.errors.range': "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.time': "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.noTime': "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
    'common.datePicker.errors.future': "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A",
    // ── The mobile shell ──────────────────────────────────────────────────────
    // Not visible copy — the bottom bar's accessible name. It is here for the
    // same reason the rest is: a screen reader in an English panel should not
    // announce the navigation in Persian.
    'common.a11y.primaryNav': "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC",
    // ── The date-range filter ─────────────────────────────────────────────────
    'common.dateRange.label': "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
    'common.dateRange.custom': "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
    'common.dateRange.from': "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.to': "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.pickBoth': "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
};
const $02b96a2843192315$export$cdafc612aa9b582a = {
    'common.calendar.months': [
        "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
        "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
        "\u062E\u0631\u062F\u0627\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F\u0627\u062F",
        "\u0634\u0647\u0631\u06CC\u0648\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627\u0646",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645\u0646",
        "\u0627\u0633\u0641\u0646\u062F"
    ],
    // Saturday-first, one glyph each — the calendar header.
    'common.calendar.weekdaysNarrow': [
        "\u0634",
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C"
    ]
};
/** Persian digits — what the kit has always rendered. */ const $02b96a2843192315$var$toPersianDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// ── The registry ────────────────────────────────────────────────────────────
//
// Module state rather than context, because it has to be readable from plain
// functions (the date parser's error messages) and not only from components.
// `version` is what makes it REACTIVE: a panel that switches language at
// runtime bumps it, and every mounted kit component re-reads.
let $02b96a2843192315$var$table = null;
let $02b96a2843192315$var$version = 0;
const $02b96a2843192315$var$listeners = new Set();
function $02b96a2843192315$export$bf11b40754c929ae(next) {
    $02b96a2843192315$var$table = next || null;
    $02b96a2843192315$var$version += 1;
    $02b96a2843192315$var$listeners.forEach((notify)=>notify());
}
function $02b96a2843192315$var$subscribe(notify) {
    $02b96a2843192315$var$listeners.add(notify);
    return ()=>$02b96a2843192315$var$listeners.delete(notify);
}
const $02b96a2843192315$var$snapshot = ()=>$02b96a2843192315$var$version;
/** `{{unit}}` → vars.unit. The kit needs no more interpolation than this. */ function $02b96a2843192315$var$interpolate(text, vars) {
    if (!vars) return text;
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name)=>vars[name] === undefined ? match : String(vars[name]));
}
function $02b96a2843192315$export$44bc4c060d9b3ece(key, vars) {
    const override = $02b96a2843192315$var$table?.string?.(key);
    const text = override === undefined || override === null ? $02b96a2843192315$export$df49a36517896dd5[key] : override;
    // A key with no default is a bug in the kit, not in the app — surfacing the
    // key beats rendering `undefined` into the DOM.
    return $02b96a2843192315$var$interpolate(text === undefined ? key : text, vars);
}
function $02b96a2843192315$export$d041a4afca2888c(key) {
    const override = $02b96a2843192315$var$table?.list?.(key);
    return Array.isArray(override) ? override : $02b96a2843192315$export$cdafc612aa9b582a[key] || [];
}
function $02b96a2843192315$export$aa5144520a3863d7(value) {
    const override = $02b96a2843192315$var$table?.number?.(value);
    return override === undefined || override === null ? $02b96a2843192315$var$toPersianDigits(value) : String(override);
}
function $02b96a2843192315$export$ee19af4091ffbbfc() {
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore($02b96a2843192315$var$subscribe, $02b96a2843192315$var$snapshot, $02b96a2843192315$var$snapshot);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            t: $02b96a2843192315$export$44bc4c060d9b3ece,
            list: $02b96a2843192315$export$d041a4afca2888c,
            num: $02b96a2843192315$export$aa5144520a3863d7
        }), // `version` is read through the store above; naming it here is what ties
    // the memo to a catalogue swap.
    [
        $02b96a2843192315$var$version
    ]);
}

});


parcelRegister("dSPMK", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => (parcelRequire("4rEI6")).default);
$parcel$export(module.exports, "useTranslation", () => (parcelRequire("LNQP4")).default);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => (parcelRequire("Hy6Lb")).DEFAULT_LOCALE);
$parcel$export(module.exports, "MIRROR_ICON", () => (parcelRequire("asXy3")).MIRROR_ICON);
// ─────────────────────────────────────────────────────────────────────────────
// The i18n barrel — import from '../i18n', never from a file inside it.
//
//   import { useTranslation } from '../../i18n';
//
// Keeping the surface here means the internals (loader strategy, translator
// implementation, which Intl objects get memoised) can change without a sweep
// through the app.
//
// Full guide: docs/I18N.md
// ─────────────────────────────────────────────────────────────────────────────

var $4rEI6 = parcelRequire("4rEI6");

var $LNQP4 = parcelRequire("LNQP4");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $asXy3 = parcelRequire("asXy3");

var $4xMUZ = parcelRequire("4xMUZ");

var $dHfod = parcelRequire("dHfod");

});
parcelRegister("4rEI6", function(module, exports) {

$parcel$export(module.exports, "I18nContext", () => $464ca197ae32cd72$export$5603ab5ced17ce64);
$parcel$export(module.exports, "default", () => $464ca197ae32cd72$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $dHfod = parcelRequire("dHfod");

var $4xMUZ = parcelRequire("4xMUZ");

var $asXy3 = parcelRequire("asXy3");
// ─────────────────────────────────────────────────────────────────────────────
// The one i18n context. Everything a screen needs — `t`, the formatters, the
// direction, the way to change language — comes from here and nowhere else.
//
// It is deliberately shaped like the design system's ThemeProvider, because it
// solves the same problem and should be read the same way:
//
//   1. localStorage, read synchronously during the first render, so a reload
//      paints the right language AND the right direction immediately instead of
//      flashing Persian at an English-speaking doctor.
//   2. The server copy (`appearance.language` in doctor-preference), pushed in
//      once `me` resolves. That is the real record and wins whenever it differs
//      — it is how the choice follows the doctor to another device.
//
// Switching language NEVER unmounts anything. The new catalogue is loaded, then
// swapped in one state update, so the router, every open dialog and every
// half-filled form survive the switch — requirement 7, and the reason this is a
// context value rather than a remount with a `key`.
// ─────────────────────────────────────────────────────────────────────────────
const $464ca197ae32cd72$export$5603ab5ced17ce64 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $464ca197ae32cd72$export$a54013f0d02a8f82({ language: language, children: children, fallback: fallback = null }) {
    // Lazy initialiser — runs before first paint, not in an effect, so <html dir>
    // is correct for the very first frame.
    const [locale, setLocale] = (0, $acw62.useState)(()=>(0, $Hy6Lb.applyDocumentLocale)((0, $Hy6Lb.resolveInitialLocale)()));
    // The catalogues currently being rendered. `null` until the first load lands;
    // on a LATER switch the previous catalogue keeps rendering until the new one
    // is ready, so there is no flash of untranslated keys.
    const [catalogs, setCatalogs] = (0, $acw62.useState)(()=>{
        const active = (0, $dHfod.peekCatalog)(locale);
        if (!active) return null;
        const fb = locale === (0, $Hy6Lb.FALLBACK_LOCALE) ? active : (0, $dHfod.peekCatalog)((0, $Hy6Lb.FALLBACK_LOCALE));
        return fb ? {
            locale: locale,
            active: active,
            fallback: fb
        } : null;
    });
    // Guards against an out-of-order resolution when the doctor switches twice
    // quickly: only the most recently requested locale may commit.
    const requested = (0, $acw62.useRef)(locale);
    (0, $acw62.useEffect)(()=>{
        requested.current = locale;
        let live = true;
        // The fallback catalogue is loaded alongside the active one so a key
        // missing from a translation can resolve to English synchronously, inside
        // `t`, rather than triggering a load mid-render.
        Promise.all([
            (0, $dHfod.loadCatalog)(locale),
            locale === (0, $Hy6Lb.FALLBACK_LOCALE) ? null : (0, $dHfod.loadCatalog)((0, $Hy6Lb.FALLBACK_LOCALE))
        ]).then(([active, fb])=>{
            if (!live || requested.current !== locale) return;
            setCatalogs({
                locale: locale,
                active: active,
                fallback: fb || active
            });
        });
        return ()=>{
            live = false;
        };
    }, [
        locale
    ]);
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // language on another device). `null`/`undefined` means "not loaded yet" —
    // NOT "reset to default" — so an in-flight `me` query never clobbers a choice
    // the doctor just made. An unrecognised tag is ignored rather than applied:
    // a language this build does not ship must not blank the UI. Nor is one the
    // brand does not offer applied — the service's own default («fa») included.
    const serverLanguage = (0, $Hy6Lb.normalizeLocale)(language);
    (0, $acw62.useEffect)(()=>{
        if (!serverLanguage) return;
        setLocale((prev)=>{
            if (prev === serverLanguage) return prev;
            (0, $Hy6Lb.storeLocale)(serverLanguage);
            return (0, $Hy6Lb.applyDocumentLocale)(serverLanguage);
        });
    }, [
        serverLanguage
    ]);
    /**
   * Apply a language locally and cache it. Two callers:
   *   - the settings picker, so the UI switches under the doctor's cursor
   *     instead of after a server round trip;
   *   - app boot, to adopt the server's copy once `me` resolves.
   * Persisting to the BFF is the caller's job — this only paints and caches.
   */ const changeLocale = (0, $acw62.useCallback)((next)=>{
        const id = (0, $Hy6Lb.normalizeLocale)(next);
        if (!id) return;
        setLocale((prev)=>{
            if (prev === id) return prev;
            (0, $Hy6Lb.storeLocale)(id);
            return (0, $Hy6Lb.applyDocumentLocale)(id);
        });
    }, []);
    const value = (0, $acw62.useMemo)(()=>{
        const descriptor = (0, $Hy6Lb.localeDescriptor)(locale);
        const formatters = (0, $asXy3.createFormatters)(locale);
        // Catalogues for a DIFFERENT locale than `locale` means a switch is in
        // flight: keep translating with what we have. `t` still resolves — it just
        // resolves in the outgoing language for the frame or two it takes the new
        // catalogue to arrive from cache or network.
        const active = catalogs?.active || {};
        const fb = catalogs?.fallback || {};
        const renderedLocale = catalogs?.locale || locale;
        const pluralRules = typeof Intl.PluralRules === 'function' ? new Intl.PluralRules((0, $Hy6Lb.localeDescriptor)(renderedLocale).intl) : null;
        const { t: t, tList: tList, has: has } = (0, $4xMUZ.createTranslator)({
            locale: renderedLocale,
            catalog: active,
            fallbackCatalog: fb,
            pluralRules: pluralRules,
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        return {
            locale: // identity
            locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            // Whether this reader can read the Persian clinical reference data. NOT
            // implied by `isRTL` — Arabic shares the direction and not the language.
            readsPersianData: descriptor.readsPersianData === true,
            // What a language picker lists: every shipped language, or only the
            // ones the brand offers.
            locales: (0, $Hy6Lb.offeredLocales)(),
            t: // translation
            t,
            tList: tList,
            has: has,
            // formatting
            ...formatters,
            // the unit word beside a `formatMoney` figure: moneyUnit(currency, 'short')
            moneyUnit: (0, $asXy3.createMoneyUnit)(t, locale),
            // control
            setLocale: changeLocale,
            preloadLocale: (0, $dHfod.preloadCatalog),
            // true once the active locale's catalogue is the one being rendered
            ready: catalogs?.locale === locale
        };
    }, [
        locale,
        catalogs,
        changeLocale
    ]);
    // Only the FIRST load blocks — after that `catalogs` is never null again, so
    // a language switch re-renders in place and the navigation state survives.
    if (!catalogs) return fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($464ca197ae32cd72$export$5603ab5ced17ce64.Provider, {
        value: value
    }, children);
}
var $464ca197ae32cd72$export$2e2bcd8739ae039 = $464ca197ae32cd72$export$a54013f0d02a8f82;

});
parcelRegister("Hy6Lb", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $082e79695298041e$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "FALLBACK_LOCALE", () => $082e79695298041e$export$95b7602913551865);
$parcel$export(module.exports, "NAMESPACES", () => $082e79695298041e$export$4d2fb7344096e022);
$parcel$export(module.exports, "isSupportedLocale", () => $082e79695298041e$export$17a6a815985c8621);
$parcel$export(module.exports, "offeredLocales", () => $082e79695298041e$export$171765a6a37c37cd);
$parcel$export(module.exports, "productDefaultLocale", () => $082e79695298041e$export$1ad85a23f306da6d);
$parcel$export(module.exports, "localeDescriptor", () => $082e79695298041e$export$57270fb1f2649979);
$parcel$export(module.exports, "normalizeLocale", () => $082e79695298041e$export$dca0327c9b9c6498);
$parcel$export(module.exports, "storeLocale", () => $082e79695298041e$export$e8146f0b19c81b97);
$parcel$export(module.exports, "resolveInitialLocale", () => $082e79695298041e$export$831a5617a2963db1);
$parcel$export(module.exports, "applyDocumentLocale", () => $082e79695298041e$export$fff0f9a021c4ca38);
// ─────────────────────────────────────────────────────────────────────────────
// The locale registry — the one place that knows which languages exist.
//
// Adding a language is meant to be a data change, not a code change: append an
// entry here, drop a folder under `translations/`, register its loaders in
// loader.js, and every picker, formatter and direction switch picks it up. No
// component, screen or service is allowed to branch on a locale id — if a
// behaviour differs per language it belongs in the descriptor below.
//
// See docs/I18N.md for the full walkthrough.
//
// THE BRAND (ui/lib/brand.js) narrows this list and moves its defaults, never
// the descriptors' data: `locales` decides which of these languages are OFFERED
// (`isOfferedLocale` — every resolver below asks it, so a language the brand does
// not offer is never started in, cached or adopted from the server), and
// `defaultLocale` is the first-visit language. `calendar` swaps each descriptor's
// calendar through the descriptor's own `calendars` data. With no brand all three
// are exactly what they were.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
const $082e79695298041e$export$e49c1078bc46f17 = {
    // i18n-exempt: a locale's `label` is its ENDONYM — the name the language
    // gives itself — so it is deliberately not translated. «فارسی» stays «فارسی»
    // in the English UI, the same way «English» stays «English» in the Persian
    // one; that is what makes a language switcher usable to someone who cannot
    // read the current language. `weekdaySeparator` is likewise locale data.
    fa: {
        id: 'fa',
        label: "\u0641\u0627\u0631\u0633\u06CC",
        englishLabel: 'Persian',
        dir: 'rtl',
        // -u-ca-persian → Jalali (Shamsi) calendar; -u-nu-arabext → Persian digits.
        intl: 'fa-IR-u-ca-persian-nu-arabext',
        calendar: 'jalali',
        calendars: {
            gregory: {
                intl: 'fa-IR-u-ca-gregory-nu-arabext'
            }
        },
        timeZone: 'Asia/Tehran',
        // What goes between the weekday and the rest of a long date. See the
        // `full` style in format.js for why this is spelled out here rather than
        // left to `dateStyle: 'full'`.
        weekdaySeparator: "\u060C ",
        // Persian is the only language that reads the drug registry's own names.
        readsPersianData: true
    },
    en: {
        id: 'en',
        label: 'English',
        englishLabel: 'English',
        dir: 'ltr',
        intl: 'en-US',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere. ICU appends the era ("AP")
            // to a calendar that is not the language's own.
            jalali: {
                intl: 'en-US-u-ca-persian',
                stripEra: true
            },
            // A brand on the Gregorian calendar has no Jalali clinic months: the
            // analysis timeline grids on Gregorian months there (lib/analysisTimeline).
            gregory: {
                clinicCalendarIntl: undefined
            }
        },
        timeZone: 'Asia/Tehran',
        weekdaySeparator: ', ',
        // English dates are Gregorian, but a few surfaces are Jalali in EVERY
        // language because the clinic itself is — the analysis timeline's month
        // axis is gridded on Jalali month boundaries, so labelling those lines
        // «August» would name a month that does not start there. ICU renders the
        // Jalali months in Latin for this tag: «Farvardin», «Mordad».
        clinicCalendarIntl: 'en-US-u-ca-persian'
    },
    // i18n-exempt: endonym and locale data, exactly as for `fa` above — «العربية»
    // is the name Arabic gives itself and stays «العربية» in every UI language.
    // A second marker is needed because the first one's exemption ends with the
    // `fa` descriptor it introduces, and the audit cannot tell Arabic script from
    // Persian: both live in U+0600–U+06FF.
    ar: {
        id: 'ar',
        label: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        englishLabel: 'Arabic',
        dir: 'rtl',
        // JALALI, not Gregorian. An Iranian clinic runs on the Jalali calendar —
        // the day sheet, the appointment book and the accounting period are all
        // Jalali — and the date PICKER (@parsina/framework JalaliDatePicker, which
        // follows <html lang> since v0.19.0) draws Arabic on the Jalali calendar
        // too, to match this tag. Handing Arabic `ar-EG` here would
        // mean a doctor picks ۱۴۰۴/۰۵/۱۲ and reads back «٣ أغسطس ٢٠٢٥»: the same
        // class of transcription error the 24-hour clock rule in format.js exists
        // to prevent. -u-nu-arab → Arabic-Indic digits (٠١٢…), which is what an
        // Arabic reader expects and is a DIFFERENT set from Persian's arabext.
        intl: 'ar-u-ca-persian-nu-arab',
        calendar: 'jalali',
        calendars: {
            // On the Gregorian calendar two corrections below are Jalali-only: the
            // month names are Jalali names, and day-first is how Arabic writes a
            // Gregorian date.
            gregory: {
                intl: 'ar-u-ca-gregory-nu-arab',
                monthNames: undefined,
                numericDateOrder: undefined
            }
        },
        timeZone: 'Asia/Tehran',
        weekdaySeparator: "\u060C ",
        // ICU's Arabic patterns for the Persian calendar disagree with the clinic's
        // conventions in three ways. Correcting them here, as data, is what keeps
        // format.js free of locale ids — see the descriptor notes above.
        dateStyles: {
            // ICU gives Arabic an ALL-NUMERIC medium («١٢‏/٠٥‏/١٤٠٤») where both other
            // locales give a month name («۱۲ مرداد ۱۴۰۴», «Aug 3, 2025»). `medium` is
            // the default shape, on nearly every row in the app, so it is the one
            // that has to stay readable.
            medium: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        },
        // ICU appends «ه‍.ش» (with a ZWJ) to every Arabic-on-Persian-calendar shape
        // but `dayMonth`. It is noise next to a Persian date that never carries it,
        // and `era: undefined` does not suppress it.
        stripEra: true,
        // ICU orders the numeric Arabic date day-first («١٢/٥/١٤٠٤») where Persian
        // writes it year-first («۱۴۰۴/۵/۱۲»). Two RTL languages disagreeing about
        // the same calendar on the same screen is how a date gets transcribed wrong.
        numericDateOrder: [
            'year',
            'month',
            'day'
        ],
        // CLDR's ARABIC month names for the Persian calendar are corrupted: six of
        // the twelve are not words in any language. Verified against ICU 78, and
        // identical for every ar-* region (ar, ar-EG, ar-IQ, ar-SA):
        //
        //   ICU says   فرفردن · أذربيهشت · تار · شهرفار · آيان · اسفندار
        //   should be  فروردين · ارديبهشت · تير · شهريور · آبان · اسفند
        //
        // A month name sits on every visit row, every day sheet and every printed
        // prescription, so this cannot be left to upstream. Index 0 = فروردين.
        monthNames: [
            "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
            "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
            "\u062E\u0631\u062F\u0627\u062F",
            "\u062A\u064A\u0631",
            "\u0645\u0631\u062F\u0627\u062F",
            "\u0634\u0647\u0631\u064A\u0648\u0631",
            "\u0645\u0647\u0631",
            "\u0622\u0628\u0627\u0646",
            "\u0622\u0630\u0631",
            "\u062F\u064A",
            "\u0628\u0647\u0645\u0646",
            "\u0627\u0633\u0641\u0646\u062F"
        ]
    }
};
const $082e79695298041e$export$d953adbca2df8efa = Object.keys($082e79695298041e$export$e49c1078bc46f17);
const $082e79695298041e$export$1af4c7e47ad72f44 = 'fa';
const $082e79695298041e$export$95b7602913551865 = 'en';
const $082e79695298041e$export$4d2fb7344096e022 = [
    'common',
    'nav',
    'validation',
    'errors',
    'auth',
    'settings',
    'dashboard',
    'patient',
    'visit',
    'prescription',
    'encounters',
    'accounting',
    'credits',
    'clinic',
    'messages'
];
const $082e79695298041e$export$17a6a815985c8621 = (id)=>Object.prototype.hasOwnProperty.call($082e79695298041e$export$e49c1078bc46f17, id);
const $082e79695298041e$export$60d894e7aa1bc86e = ()=>(0, $eLeza.brandLocales)($082e79695298041e$export$d953adbca2df8efa);
const $082e79695298041e$export$d14eda3de108abc4 = (id)=>$082e79695298041e$export$17a6a815985c8621(id) && $082e79695298041e$export$60d894e7aa1bc86e().includes(id);
function $082e79695298041e$export$171765a6a37c37cd() {
    const ids = $082e79695298041e$export$60d894e7aa1bc86e();
    if (ids.length === $082e79695298041e$export$d953adbca2df8efa.length) return $082e79695298041e$export$e49c1078bc46f17;
    return Object.fromEntries(ids.map((id)=>[
            id,
            $082e79695298041e$export$e49c1078bc46f17[id]
        ]));
}
const $082e79695298041e$export$1ad85a23f306da6d = ()=>(0, $eLeza.brandDefaultLocale)($082e79695298041e$export$1af4c7e47ad72f44, $082e79695298041e$export$d953adbca2df8efa);
const $082e79695298041e$export$57270fb1f2649979 = (id)=>{
    const descriptor = $082e79695298041e$export$e49c1078bc46f17[id] || $082e79695298041e$export$e49c1078bc46f17[$082e79695298041e$export$1ad85a23f306da6d()];
    const calendar = (0, $eLeza.calendarSystem)(null);
    if (!calendar) return descriptor;
    // Applied even on the locale's own calendar: a Gregorian brand has no Jalali
    // clinic months, in English too (`en`'s `calendars.gregory`).
    const override = descriptor.calendars?.[calendar];
    if (!override && calendar === descriptor.calendar) return descriptor;
    return {
        ...descriptor,
        ...override,
        calendar: calendar
    };
};
function $082e79695298041e$export$dca0327c9b9c6498(tag) {
    if (!tag) return null;
    const raw = String(tag).trim();
    const base = raw.toLowerCase().split(/[-_]/)[0];
    const id = $082e79695298041e$export$17a6a815985c8621(raw) ? raw : $082e79695298041e$export$17a6a815985c8621(base) ? base : null;
    return id && $082e79695298041e$export$d14eda3de108abc4(id) ? id : null;
}
const $082e79695298041e$export$86880b4b2e1a2384 = 'parsina.locale';
function $082e79695298041e$export$9e89f130e918dc2a() {
    try {
        return $082e79695298041e$export$dca0327c9b9c6498(window.localStorage.getItem($082e79695298041e$export$86880b4b2e1a2384));
    } catch  {
        // Private mode, disabled storage, or no window at all (tests, SSR).
        return null;
    }
}
function $082e79695298041e$export$e8146f0b19c81b97(id) {
    try {
        if ($082e79695298041e$export$d14eda3de108abc4(id)) window.localStorage.setItem($082e79695298041e$export$86880b4b2e1a2384, id);
    } catch  {
    /* A locale we cannot cache still works — it just re-resolves next launch. */ }
}
function $082e79695298041e$export$25ddc0816bb523ad() {
    if (typeof navigator === 'undefined') return null;
    const candidates = navigator.languages?.length ? navigator.languages : [
        navigator.language
    ];
    for (const tag of candidates){
        const match = $082e79695298041e$export$dca0327c9b9c6498(tag);
        if (match) return match;
    }
    return null;
}
function $082e79695298041e$export$831a5617a2963db1() {
    return $082e79695298041e$export$9e89f130e918dc2a() || $082e79695298041e$export$25ddc0816bb523ad() || (0, $eLeza.brandDefaultLocale)($082e79695298041e$export$95b7602913551865, $082e79695298041e$export$d953adbca2df8efa);
}
function $082e79695298041e$export$fff0f9a021c4ca38(id) {
    const locale = $082e79695298041e$export$d14eda3de108abc4(id) ? id : $082e79695298041e$export$1ad85a23f306da6d();
    const root = typeof document !== 'undefined' ? document.documentElement : null;
    if (root) {
        root.setAttribute('lang', locale);
        root.setAttribute('dir', $082e79695298041e$export$e49c1078bc46f17[locale].dir);
    }
    // The landscape notice (J-17) is drawn by CSS, because a rotated phone must
    // be told something even before React has mounted — but its COPY is UI text
    // like any other and has to follow the panel language. `attr()` is how a
    // stylesheet reads a translated string, so the attribute is stamped here,
    // beside the two that already mirror the locale onto the document.
    if (typeof document !== 'undefined' && document.body) document.body.setAttribute('data-rotate-notice', $082e79695298041e$var$ROTATE_NOTICE[locale] || $082e79695298041e$var$ROTATE_NOTICE[$082e79695298041e$export$1af4c7e47ad72f44]);
    return locale;
}
// Deliberately NOT in the JSON catalogues: this string is read by a stylesheet
// before the catalogues are loaded, so it has to exist at module scope. Three
// short sentences are a smaller cost than a landscape phone showing nothing.
// i18n-exempt: read by CSS `attr()` before the catalogues resolve.
const $082e79695298041e$var$ROTATE_NOTICE = {
    fa: "\u0628\u0631\u0627\u06CC \u0627\u0633\u062A\u0641\u0627\u062F\u0647\u060C \u06AF\u0648\u0634\u06CC \u0631\u0627 \u0639\u0645\u0648\u062F\u06CC \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    en: 'Turn your phone upright to continue.',
    ar: "\u0623\u062F\u0650\u0631 \u0647\u0627\u062A\u0641\u0643 \u0639\u0645\u0648\u062F\u064A\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629."
};

});

parcelRegister("dHfod", function(module, exports) {

$parcel$export(module.exports, "loadCatalog", () => $9f8b3a8c6854f9d7$export$5bd1a830868d1d11);
$parcel$export(module.exports, "peekCatalog", () => $9f8b3a8c6854f9d7$export$d2d95d0a2b5fab1e);
$parcel$export(module.exports, "preloadCatalog", () => $9f8b3a8c6854f9d7$export$f2675afc1de9f02e);
// ─────────────────────────────────────────────────────────────────────────────
// Translation loading + cache.
//
// Every namespace is its own `import()`, so Parcel code-splits each feature's
// strings into its own asset and a locale is only ever downloaded once someone
// actually selects it. English is not on the wire for a doctor who never leaves
// Persian.
//
// Two caches, both process-lifetime:
//   `cache`    locale/namespace → the parsed bundle. A second switch back to a
//              language is synchronous — nothing is re-fetched or re-parsed.
//   `inflight` locale/namespace → the in-progress promise, so N simultaneous
//              requests for the same file share one network round trip.
//
// The map below is written out by hand rather than built from a template
// literal because Parcel resolves `import()` statically: a computed specifier
// would silently produce a bundle with no translations in it.
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");













































const $9f8b3a8c6854f9d7$var$IMPORTERS = {
    fa: {
        common: ()=>(parcelRequire("iCILN")),
        nav: ()=>(parcelRequire("2Efq0")),
        validation: ()=>(parcelRequire("ckeeW")),
        errors: ()=>(parcelRequire("8lVvN")),
        auth: ()=>(parcelRequire("CQy1v")),
        settings: ()=>(parcelRequire("NflAS")),
        dashboard: ()=>(parcelRequire("kdVQU")),
        patient: ()=>(parcelRequire("ame9z")),
        visit: ()=>(parcelRequire("iD84Q")),
        prescription: ()=>(parcelRequire("a7Q3E")),
        encounters: ()=>(parcelRequire("cJvos")),
        accounting: ()=>(parcelRequire("9R5PW")),
        credits: ()=>(parcelRequire("78DTD")),
        clinic: ()=>(parcelRequire("iT2YQ")),
        messages: ()=>(parcelRequire("5mY5e"))
    },
    en: {
        common: ()=>(parcelRequire("lNvL9")),
        nav: ()=>(parcelRequire("gBrPR")),
        validation: ()=>(parcelRequire("bDYv5")),
        errors: ()=>(parcelRequire("gWxY7")),
        auth: ()=>(parcelRequire("hIn0O")),
        settings: ()=>(parcelRequire("5J2T0")),
        dashboard: ()=>(parcelRequire("cV51U")),
        patient: ()=>(parcelRequire("gQg8c")),
        visit: ()=>(parcelRequire("b8aGV")),
        prescription: ()=>(parcelRequire("3P1Wb")),
        encounters: ()=>(parcelRequire("lfTfn")),
        accounting: ()=>(parcelRequire("h3grK")),
        credits: ()=>(parcelRequire("4T5MT")),
        clinic: ()=>(parcelRequire("bfJWC")),
        messages: ()=>(parcelRequire("bHiRm"))
    },
    ar: {
        common: ()=>(parcelRequire("6BP30")),
        nav: ()=>(parcelRequire("a9o8l")),
        validation: ()=>(parcelRequire("jghYY")),
        errors: ()=>(parcelRequire("91Cv7")),
        auth: ()=>(parcelRequire("glFDs")),
        settings: ()=>(parcelRequire("jtK7w")),
        dashboard: ()=>(parcelRequire("hjY7S")),
        patient: ()=>(parcelRequire("h6fJE")),
        visit: ()=>(parcelRequire("7WHIK")),
        prescription: ()=>(parcelRequire("a4xAw")),
        encounters: ()=>(parcelRequire("5Cez0")),
        accounting: ()=>(parcelRequire("fX9Li")),
        credits: ()=>(parcelRequire("3nPy4")),
        clinic: ()=>(parcelRequire("1hO0Y")),
        messages: ()=>(parcelRequire("lcJSW"))
    }
};
const $9f8b3a8c6854f9d7$var$cache = new Map();
const $9f8b3a8c6854f9d7$var$inflight = new Map();
const $9f8b3a8c6854f9d7$var$cacheKey = (locale, namespace)=>`${locale}/${namespace}`;
// Parcel hands back a module namespace object; the JSON is on `default` for a
// JSON asset, but a plain object comes through untouched under Jest's transform.
const $9f8b3a8c6854f9d7$var$unwrap = (mod)=>mod && mod.default || mod || {};
function $9f8b3a8c6854f9d7$export$3c148aa2c2f6601d(locale, namespace) {
    const key = $9f8b3a8c6854f9d7$var$cacheKey(locale, namespace);
    if ($9f8b3a8c6854f9d7$var$cache.has(key)) return Promise.resolve($9f8b3a8c6854f9d7$var$cache.get(key));
    if ($9f8b3a8c6854f9d7$var$inflight.has(key)) return $9f8b3a8c6854f9d7$var$inflight.get(key);
    const importer = $9f8b3a8c6854f9d7$var$IMPORTERS[locale]?.[namespace];
    if (!importer) {
        $9f8b3a8c6854f9d7$var$cache.set(key, {});
        return Promise.resolve({});
    }
    const promise = importer().then((mod)=>$9f8b3a8c6854f9d7$var$unwrap(mod)).catch((err)=>{
        return {};
    }).then((bundle)=>{
        $9f8b3a8c6854f9d7$var$cache.set(key, bundle);
        $9f8b3a8c6854f9d7$var$inflight.delete(key);
        return bundle;
    });
    $9f8b3a8c6854f9d7$var$inflight.set(key, promise);
    return promise;
}
function $9f8b3a8c6854f9d7$export$5bd1a830868d1d11(locale) {
    if (!(0, $Hy6Lb.isSupportedLocale)(locale)) return Promise.resolve({});
    return Promise.all((0, $Hy6Lb.NAMESPACES).map((ns)=>$9f8b3a8c6854f9d7$export$3c148aa2c2f6601d(locale, ns).then((bundle)=>[
                ns,
                bundle
            ]))).then(Object.fromEntries);
}
function $9f8b3a8c6854f9d7$export$d2d95d0a2b5fab1e(locale) {
    const entries = (0, $Hy6Lb.NAMESPACES).map((ns)=>[
            ns,
            $9f8b3a8c6854f9d7$var$cache.get($9f8b3a8c6854f9d7$var$cacheKey(locale, ns))
        ]);
    return entries.every(([, bundle])=>bundle !== undefined) ? Object.fromEntries(entries) : null;
}
function $9f8b3a8c6854f9d7$export$f2675afc1de9f02e(locale) {
    $9f8b3a8c6854f9d7$export$5bd1a830868d1d11(locale).catch(()=>{});
}
function $9f8b3a8c6854f9d7$export$ff2d99e7c0f75ee6() {
    $9f8b3a8c6854f9d7$var$cache.clear();
    $9f8b3a8c6854f9d7$var$inflight.clear();
}

});
parcelRegister("iCILN", function(module, exports) {
module.exports = import("6gmlX").then(()=>parcelRequire('3fFOk'));

});

parcelRegister("2Efq0", function(module, exports) {
module.exports = import("8nunk").then(()=>parcelRequire('8bT9F'));

});

parcelRegister("ckeeW", function(module, exports) {
module.exports = import("3aK9q").then(()=>parcelRequire('9fo9N'));

});

parcelRegister("8lVvN", function(module, exports) {
module.exports = import("e8b6w").then(()=>parcelRequire('ccETr'));

});

parcelRegister("CQy1v", function(module, exports) {
module.exports = import("801bc").then(()=>parcelRequire('ewg5Z'));

});

parcelRegister("NflAS", function(module, exports) {
module.exports = import("91XV7").then(()=>parcelRequire('hRPKf'));

});

parcelRegister("kdVQU", function(module, exports) {
module.exports = import("4BKEJ").then(()=>parcelRequire('12sAr'));

});

parcelRegister("ame9z", function(module, exports) {
module.exports = import("9Dfw0").then(()=>parcelRequire('fjV3a'));

});

parcelRegister("iD84Q", function(module, exports) {
module.exports = import("c49La").then(()=>parcelRequire('863mN'));

});

parcelRegister("a7Q3E", function(module, exports) {
module.exports = import("iRekQ").then(()=>parcelRequire('bfb2V'));

});

parcelRegister("cJvos", function(module, exports) {
module.exports = import("lKx08").then(()=>parcelRequire('7eTsj'));

});

parcelRegister("9R5PW", function(module, exports) {
module.exports = import("90ArL").then(()=>parcelRequire('clHbB'));

});

parcelRegister("78DTD", function(module, exports) {
module.exports = import("21tfh").then(()=>parcelRequire('5mEfs'));

});

parcelRegister("iT2YQ", function(module, exports) {
module.exports = import("7yAhl").then(()=>parcelRequire('bUn2j'));

});

parcelRegister("5mY5e", function(module, exports) {
module.exports = import("hr8kB").then(()=>parcelRequire('7M9Vd'));

});

parcelRegister("lNvL9", function(module, exports) {
module.exports = import("84Zxf").then(()=>parcelRequire('iZxX2'));

});

parcelRegister("gBrPR", function(module, exports) {
module.exports = import("9Q3ZC").then(()=>parcelRequire('wHk8H'));

});

parcelRegister("bDYv5", function(module, exports) {
module.exports = import("bI2YL").then(()=>parcelRequire('1zImr'));

});

parcelRegister("gWxY7", function(module, exports) {
module.exports = import("5y0GB").then(()=>parcelRequire('aQQ2a'));

});

parcelRegister("hIn0O", function(module, exports) {
module.exports = import("27oK8").then(()=>parcelRequire('ckTj6'));

});

parcelRegister("5J2T0", function(module, exports) {
module.exports = import("2Ty8Y").then(()=>parcelRequire('esECq'));

});

parcelRegister("cV51U", function(module, exports) {
module.exports = import("27bjU").then(()=>parcelRequire('fghHP'));

});

parcelRegister("gQg8c", function(module, exports) {
module.exports = import("k7VTP").then(()=>parcelRequire('6c0qc'));

});

parcelRegister("b8aGV", function(module, exports) {
module.exports = import("73B2k").then(()=>parcelRequire('dttTe'));

});

parcelRegister("3P1Wb", function(module, exports) {
module.exports = import("yX7Kv").then(()=>parcelRequire('lSGr9'));

});

parcelRegister("lfTfn", function(module, exports) {
module.exports = import("f3dA3").then(()=>parcelRequire('Gefsl'));

});

parcelRegister("h3grK", function(module, exports) {
module.exports = import("iVfcT").then(()=>parcelRequire('9vzcX'));

});

parcelRegister("4T5MT", function(module, exports) {
module.exports = import("c1En5").then(()=>parcelRequire('55Xcr'));

});

parcelRegister("bfJWC", function(module, exports) {
module.exports = import("fBH5M").then(()=>parcelRequire('epYjV'));

});

parcelRegister("bHiRm", function(module, exports) {
module.exports = import("fTYrC").then(()=>parcelRequire('3Hm0p'));

});

parcelRegister("6BP30", function(module, exports) {
module.exports = import("iPcmV").then(()=>parcelRequire('clsvA'));

});

parcelRegister("a9o8l", function(module, exports) {
module.exports = import("id1zk").then(()=>parcelRequire('4R55T'));

});

parcelRegister("jghYY", function(module, exports) {
module.exports = import("e8wKv").then(()=>parcelRequire('2hPzL'));

});

parcelRegister("91Cv7", function(module, exports) {
module.exports = import("7YJuj").then(()=>parcelRequire('fANYT'));

});

parcelRegister("glFDs", function(module, exports) {
module.exports = import("cgLMV").then(()=>parcelRequire('9Gxgv'));

});

parcelRegister("jtK7w", function(module, exports) {
module.exports = import("gP4Nf").then(()=>parcelRequire('14oyD'));

});

parcelRegister("hjY7S", function(module, exports) {
module.exports = import("lCUkw").then(()=>parcelRequire('a6rxM'));

});

parcelRegister("h6fJE", function(module, exports) {
module.exports = import("4K60i").then(()=>parcelRequire('gUIvD'));

});

parcelRegister("7WHIK", function(module, exports) {
module.exports = import("izKRn").then(()=>parcelRequire('6RdJM'));

});

parcelRegister("a4xAw", function(module, exports) {
module.exports = import("5ec4v").then(()=>parcelRequire('igzTm'));

});

parcelRegister("5Cez0", function(module, exports) {
module.exports = import("s0FnF").then(()=>parcelRequire('7vc1I'));

});

parcelRegister("fX9Li", function(module, exports) {
module.exports = import("5a1Kt").then(()=>parcelRequire('aT9dd'));

});

parcelRegister("3nPy4", function(module, exports) {
module.exports = import("e0FVI").then(()=>parcelRequire('lR7By'));

});

parcelRegister("1hO0Y", function(module, exports) {
module.exports = import("fLTZ1").then(()=>parcelRequire('8514w'));

});

parcelRegister("lcJSW", function(module, exports) {
module.exports = import("5eqER").then(()=>parcelRequire('idKo5'));

});


parcelRegister("4xMUZ", function(module, exports) {

$parcel$export(module.exports, "createTranslator", () => $34f030a12b1d4a12$export$6f3122ee6dbd9f46);
// ─────────────────────────────────────────────────────────────────────────────
// The translator — key → string. Pure, synchronous, and it never throws.
//
// A key is FULLY QUALIFIED and its first segment is the namespace:
//
//     t('settings.language.title')   → translations/<locale>/settings.json
//                                      → { language: { title: … } }
//
// One rule, no per-call configuration, and a key is enough to find the string
// on disk. That matters more than the keystrokes a scoped `t` would save: the
// question asked in front of a screen is always "where does this text live".
//
// Resolution order for every lookup:
//   1. the active locale — the brand's `strings` overlay, then the catalogue
//   2. FALLBACK_LOCALE (English — the source catalogue, where every key exists),
//      overlay first in the same way
//   3. the key's last segment, humanised
//
// Step 3 exists so a missing key degrades to something a doctor can still read
// rather than to a crash or an empty button. Steps 2 and 3 log once per key in
// development and stay silent in production.
//
// THE BRAND (ui/lib/brand.js). A catalogue value names the product as
// `{{brand}}`, its credit as `{{coin}}` / `{{coinEz}}` and its tagline as
// `{{tagline}}`; those resolve here, in the language of the catalogue the text
// came from, with no value passed by the caller. With no brand configured they
// resolve to the words the catalogue used to spell out, so the output is what it
// always was (clinical/__tests__/brandParity.test.js).
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");

var $eLeza = parcelRequire("eLeza");
const $34f030a12b1d4a12$var$isDev = false;
// One warning per key per session. A missing key inside a list that renders on
// every keystroke would otherwise bury the console it is trying to inform.
const $34f030a12b1d4a12$var$warned = new Set();
function $34f030a12b1d4a12$var$warnOnce(message) {
    if (!$34f030a12b1d4a12$var$isDev) return;
    if ($34f030a12b1d4a12$var$warned.has(message)) return;
    $34f030a12b1d4a12$var$warned.add(message);
    console.warn(`[i18n] ${message}`);
}
function $34f030a12b1d4a12$export$d141035fe52f4cd7() {
    $34f030a12b1d4a12$var$warned.clear();
}
/**
 * `settings.language.title` → `catalog.settings.language.title`, or undefined.
 * Dotted segments only; a value that is not a string or array is treated as a
 * miss, so pointing a key at a whole subtree reports as missing instead of
 * rendering `[object Object]`.
 */ function $34f030a12b1d4a12$var$lookup(catalog, key) {
    if (!catalog || !key) return undefined;
    let node = catalog;
    for (const segment of key.split('.')){
        if (node == null || typeof node !== 'object') return undefined;
        node = node[segment];
    }
    return typeof node === 'string' || Array.isArray(node) ? node : undefined;
}
/**
 * `lookup`, with the brand's own text for `key` in `locale` asked first — the
 * `strings` overlay a deployment uses for wording a token cannot express.
 */ function $34f030a12b1d4a12$var$find(catalog, locale, key) {
    const own = (0, $eLeza.brandString)(locale, key);
    if (typeof own === 'string' || Array.isArray(own)) return own;
    return $34f030a12b1d4a12$var$lookup(catalog, key);
}
/**
 * `{{name}}` → the matching value. An unknown placeholder is left verbatim so
 * the gap is visible in review rather than silently swallowed.
 *
 * A NUMBER is interpolated through the locale's number formatter, not
 * `String()`. «۳ مورد» is the Persian for "3 items"; «3 مورد» is a half-
 * translated string, and it is the single easiest way for Latin digits to leak
 * into an otherwise Persian screen — every count, total and threshold in the
 * app arrives through this function.
 *
 * Pass a STRING when a number must not be grouped or localised — a year, a
 * version, an ICD code. That is the escape hatch, and it is explicit at the
 * call site rather than inferred from magnitude.
 *
 * Values are inserted as text: this returns a string for React to render as a
 * text node, so there is no HTML parsing and nothing to escape. Interpolating
 * markup is deliberately impossible — a string that needs a bold span is two
 * keys and a component, not a template.
 *
 * A placeholder the caller did not name may be a BRAND token (`{{brand}}`,
 * `{{coin}}`, `{{coinEz}}`, `{{tagline}}`, optionally with an inline default:
 * `{{brand|بارسينا}}`) — resolved for `locale`, the language of the template.
 * One pass, so a caller's value that happens to contain `{{brand}}` is inserted
 * as written and never resolved.
 */ function $34f030a12b1d4a12$var$interpolate(template, values, formatNumber, locale) {
    if (template.indexOf('{{') === -1) return template;
    return template.replace((0, $eLeza.PLACEHOLDER), (match, name, inline)=>{
        const named = values != null && Object.prototype.hasOwnProperty.call(values, name);
        if (!named) {
            const token = (0, $eLeza.brandToken)(name, locale, inline);
            if (token !== undefined) return token;
        }
        const value = values?.[name];
        if (value == null) return match;
        if (typeof value === 'number' && Number.isFinite(value)) return formatNumber(value);
        return String(value);
    });
}
/**
 * Plural suffix for `count`, using the locale's own CLDR rules — Persian has
 * `one`/`other`, English has `one`/`other`, and a language added later with six
 * forms works without touching this file.
 *
 * `key_zero` is honoured ahead of the CLDR category when it exists, because
 * "no appointments" is usually a different sentence rather than a different
 * number, in every language.
 */ function $34f030a12b1d4a12$var$pluralKey(get, key, count, pluralRules) {
    if (count === 0 && get(`${key}_zero`) !== undefined) return `${key}_zero`;
    const category = pluralRules ? pluralRules.select(count) : 'other';
    if (get(`${key}_${category}`) !== undefined) return `${key}_${category}`;
    if (get(`${key}_other`) !== undefined) return `${key}_other`;
    return key;
}
/** `settings.language.title` → `Title`. The last-resort rendering. */ function $34f030a12b1d4a12$var$humanise(key) {
    const last = String(key).split('.').pop() || String(key);
    return last.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c)=>c.toUpperCase());
}
function $34f030a12b1d4a12$export$6f3122ee6dbd9f46({ locale: locale, catalog: catalog, fallbackCatalog: fallbackCatalog, pluralRules: pluralRules, joinList: joinList, formatNumber: formatNumber, fallbackLocale: fallbackLocale = (0, $Hy6Lb.FALLBACK_LOCALE) }) {
    const join = joinList || ((items)=>items.join(', '));
    const num = formatNumber || ((n)=>String(n));
    const active = (key)=>$34f030a12b1d4a12$var$find(catalog, locale, key);
    const fallback = (key)=>$34f030a12b1d4a12$var$find(fallbackCatalog, fallbackLocale, key);
    /**
   * @param {string} key    fully-qualified, e.g. 'common.actions.save'
   * @param {object} [vars] interpolation values; `count` also selects the plural
   * @returns {string}      always a string, even when everything is missing
   */ function t(key, vars) {
        if (typeof key !== 'string' || !key) {
            $34f030a12b1d4a12$var$warnOnce(`t() called with a non-string key: ${JSON.stringify(key)}`);
            return '';
        }
        const hasCount = vars != null && typeof vars.count === 'number';
        // Active locale.
        let resolved = hasCount ? $34f030a12b1d4a12$var$pluralKey(active, key, vars.count, pluralRules) : key;
        let value = active(resolved);
        let from = locale;
        // Fallback locale.
        if (value === undefined && fallbackCatalog && fallbackCatalog !== catalog) {
            const fallbackResolved = hasCount ? $34f030a12b1d4a12$var$pluralKey(fallback, key, vars.count, pluralRules) : key;
            value = fallback(fallbackResolved);
            from = fallbackLocale;
            if (value !== undefined) $34f030a12b1d4a12$var$warnOnce(`missing key "${key}" in "${locale}" \u{2014} fell back to English`);
        }
        // Nothing anywhere.
        if (value === undefined) {
            $34f030a12b1d4a12$var$warnOnce(`missing key "${key}" in every locale \u{2014} showing the key`);
            return $34f030a12b1d4a12$var$humanise(key);
        }
        // A key whose value is an array joined for `t`; `tList` returns the array.
        if (Array.isArray(value)) return join(value.map((item)=>$34f030a12b1d4a12$var$interpolate(String(item), vars, num, from)));
        return $34f030a12b1d4a12$var$interpolate(value, vars, num, from);
    }
    /**
   * A key whose value is a JSON array, as an array — for bullet lists and
   * option sets, so a translator can add or drop an item without a code change.
   * Always an array, empty when the key is missing.
   */ function tList(key, vars) {
        let value = active(key);
        let from = locale;
        if (value === undefined) {
            value = fallback(key);
            from = fallbackLocale;
        }
        if (!Array.isArray(value)) {
            if (value === undefined) $34f030a12b1d4a12$var$warnOnce(`missing list key "${key}"`);
            return [];
        }
        return value.map((item)=>$34f030a12b1d4a12$var$interpolate(String(item), vars, num, from));
    }
    /** Whether a key resolves anywhere — for conditionally-rendered optional copy. */ function has(key) {
        return active(key) !== undefined || fallback(key) !== undefined;
    }
    return {
        t: t,
        tList: tList,
        has: has
    };
}

});

parcelRegister("asXy3", function(module, exports) {

$parcel$export(module.exports, "createFormatters", () => $79eab5f6e33897ad$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "createMoneyUnit", () => $79eab5f6e33897ad$export$9b6501e8a1c6bef1);
$parcel$export(module.exports, "MIRROR_ICON", () => $79eab5f6e33897ad$export$ddb338179359cccc);
// ─────────────────────────────────────────────────────────────────────────────
// Locale-aware formatting: dates, times, numbers, money, relative time.
//
// Everything here is driven by the locale descriptor's `intl` tag, which
// carries the calendar and numbering system as Unicode extensions
// (`fa-IR-u-ca-persian-nu-arabext`). That is what makes "add a language" a
// data change: no formatter in this file branches on a locale id, and the
// Jalali↔Gregorian switch is a consequence of the tag, not an `if`.
//
// Where ICU's own data for a locale disagrees with how an Iranian clinic writes
// a date — or is simply wrong — the correction is declared on the DESCRIPTOR
// (`dateStyles`, `stripEra`, `numericDateOrder`, `monthNames`) and applied
// generically below. That is the escape hatch that keeps the rule above true:
// the knowledge that Arabic on the Persian calendar needs an era stripped and
// six of CLDR's twelve month names replaced lives with the locale, not in here.
//
// Two rules that are not negotiable:
//
//   • MONEY. Every service, gRPC message and GraphQL field in Parsina carries
//     an integer number of MINOR UNITS of the document's currency — WHOLE RIALS
//     for IRR, which is also what a blank currency means. Humans read TOMAN for
//     IRR: `formatMoney` takes rials and renders toman, exactly like
//     @parsina/framework's `fmtToman` — it only adds the locale. Passing a toman
//     figure to it bills a tenth of what was meant. Another currency is passed
//     as `{ currency }` and read through the kit's `currency` table; two
//     currencies are never added or compared.
//
//   • TIME ZONE. A clinic runs on Iran local time whatever language the UI is
//     in: an appointment at 14:30 is 14:30 in Tehran, not in the browser's
//     zone. Every date formatter pins `timeZone` from the descriptor.
//
// Instances are memoised per (locale, shape) because constructing an
// Intl.DateTimeFormat is expensive relative to using one, and these run inside
// list rows that re-render on every keystroke.
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");

var $lHVFz = parcelRequire("lHVFz");
const $79eab5f6e33897ad$var$memo = new Map();
function $79eab5f6e33897ad$var$intl(Ctor, name, locale, options) {
    const key = `${name}|${locale}|${JSON.stringify(options)}`;
    let instance = $79eab5f6e33897ad$var$memo.get(key);
    if (!instance) {
        instance = new Ctor(locale, options);
        $79eab5f6e33897ad$var$memo.set(key, instance);
    }
    return instance;
}
/** Anything date-ish → Date, or null when it is not a usable instant. */ function $79eab5f6e33897ad$var$toDate(value) {
    if (value == null || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
// What an empty/unparseable value renders as. An em dash reads as "no value"
// in both scripts and never looks like a zero.
const $79eab5f6e33897ad$var$EMPTY = "\u2014";
// Named date shapes, so screens ask for a meaning rather than a field list and
// every «visit date» in the app looks the same.
//
//   short    ۱۴۰۴/۵/۱۲            8/3/25          dense tables
//   medium   ۱۲ مرداد ۱۴۰۴        Aug 3, 2025     the default
//   long     ۱۲ مرداد ۱۴۰۴        August 3, 2025  headers
//   full     یکشنبه، ۱۲ مرداد ۱۴۰۴ Sunday, …      day views
//   dayMonth ۱۲ مرداد            Aug 3           calendar chrome
//   weekdayDayMonth  یکشنبه، ۱۲ مرداد   Sunday, Aug 3   day navigator
//
// A descriptor may override individual shapes through its `dateStyles` field
// when ICU's pattern for that locale disagrees with how an Iranian clinic
// writes the date — see `ar` in config.js. The override is data, not a branch.
const $79eab5f6e33897ad$var$DATE_STYLES = {
    short: {
        dateStyle: 'short'
    },
    medium: {
        dateStyle: 'medium'
    },
    long: {
        dateStyle: 'long'
    },
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    monthYear: {
        month: 'long',
        year: 'numeric'
    },
    // The month alone — for a chart's month gridline, where the year is carried
    // by the one tick that crosses it rather than repeated on all twelve.
    month: {
        month: 'long'
    }
};
/**
 * Drop the era designator ICU appends when a locale is asked for a calendar
 * that is not its own default: Arabic on the Persian calendar renders
 * «١٢ مرداد ١٤٠٤ ه‍.ش», and `era: undefined` does not suppress it. The literal
 * that only ever joined the era to the date goes with it, so nothing is left
 * dangling at either end.
 */ function $79eab5f6e33897ad$var$dropEra(parts) {
    if (!parts.some((part)=>part.type === 'era')) return parts;
    return parts.filter((part, i)=>{
        if (part.type === 'era') return false;
        if (part.type !== 'literal') return true;
        return parts[i - 1]?.type !== 'era' && parts[i + 1]?.type !== 'era';
    });
}
// Any Unicode decimal digit — Arabic-Indic ٠-٩ and Persian ۰-۹ included. Used
// to tell a numeric month («٥») from a month NAME («مرداد») without knowing
// which numbering system is in play.
const $79eab5f6e33897ad$var$DIGITS_ONLY = /^\p{Nd}+$/u;
const $79eab5f6e33897ad$var$DATE_FIELDS = [
    'year',
    'month',
    'day'
];
/** A month rendered as a NAME rather than as digits. */ const $79eab5f6e33897ad$var$isNamedMonth = (part)=>part.type === 'month' && !$79eab5f6e33897ad$var$DIGITS_ONLY.test(part.value);
/**
 * Substitute the descriptor's own month names for ICU's, for the locales where
 * CLDR's data for this language/calendar pairing is wrong. Only a month
 * rendered as a name is touched — a numeric month is already correct, and
 * replacing it would turn «٥» into a word.
 */ function $79eab5f6e33897ad$var$withMonthNames(parts, names, monthNumber) {
    const replacement = names[monthNumber - 1];
    if (!replacement) return parts;
    return parts.map((part)=>$79eab5f6e33897ad$var$isNamedMonth(part) ? {
            ...part,
            value: replacement
        } : part);
}
/**
 * Re-order an ALL-NUMERIC date into the descriptor's field order, keeping the
 * separator the locale itself chose. ICU writes the numeric Arabic date
 * day-first while Persian writes it year-first, and two RTL languages
 * disagreeing about the same calendar on the same screen is how a date gets
 * transcribed wrong.
 *
 * Returns null — meaning "leave this one alone" — for any shape that is not
 * exactly three numeric fields and their separators, so a month name, a
 * weekday or a time is never reordered.
 */ function $79eab5f6e33897ad$var$reorderNumericDate(parts, order) {
    const fields = parts.filter((part)=>$79eab5f6e33897ad$var$DATE_FIELDS.includes(part.type));
    if (fields.length !== 3) return null;
    if (!fields.every((part)=>$79eab5f6e33897ad$var$DIGITS_ONLY.test(part.value))) return null;
    if (parts.some((part)=>part.type !== 'literal' && !$79eab5f6e33897ad$var$DATE_FIELDS.includes(part.type))) return null;
    const value = Object.fromEntries(fields.map((part)=>[
            part.type,
            part.value
        ]));
    const separator = parts.find((part)=>part.type === 'literal')?.value ?? '/';
    return order.map((type)=>value[type]).join(separator);
}
function $79eab5f6e33897ad$export$c3f4cd5551df13fd(localeId) {
    const { intl: tag, timeZone: timeZone, weekdaySeparator: weekdaySeparator = ', ', dateStyles: styleOverrides, stripEra: stripEra, numericDateOrder: numericDateOrder, monthNames: monthNames, clinicCalendarIntl: clinicCalendarIntl } = (0, $Hy6Lb.localeDescriptor)(localeId);
    // Surfaces that are Jalali in every language fall back to the locale's own
    // tag, which is already Jalali for `fa` and `ar`.
    const clinicTag = clinicCalendarIntl || tag;
    const dateTime = (options)=>$79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            ...options
        });
    const number = (options)=>$79eab5f6e33897ad$var$intl(Intl.NumberFormat, 'n', tag, options);
    /** The options for a named shape, with the locale's override applied. */ const styleOptions = (style)=>{
        const name = $79eab5f6e33897ad$var$DATE_STYLES[style] || styleOverrides?.[style] ? style : 'medium';
        return styleOverrides?.[name] || $79eab5f6e33897ad$var$DATE_STYLES[name];
    };
    /**
   * The month's number (1-12) in this locale's own calendar. Forced to Latin
   * digits so it is an index rather than a glyph run — the tag's `-nu-` would
   * otherwise hand back «٥».
   */ const monthNumber = (date)=>Number($79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            month: 'numeric',
            numberingSystem: 'latn'
        }).format(date));
    /**
   * One date shape, with the descriptor's corrections applied. A locale that
   * declares none of them goes straight through ICU untouched, which is every
   * locale but `ar`.
   */ const renderDate = (date, style)=>{
        const formatter = dateTime(styleOptions(style));
        if (!stripEra && !numericDateOrder && !monthNames) return formatter.format(date);
        let parts = formatter.formatToParts(date);
        if (stripEra) parts = $79eab5f6e33897ad$var$dropEra(parts);
        if (monthNames && parts.some($79eab5f6e33897ad$var$isNamedMonth)) parts = $79eab5f6e33897ad$var$withMonthNames(parts, monthNames, monthNumber(date));
        if (numericDateOrder) {
            const reordered = $79eab5f6e33897ad$var$reorderNumericDate(parts, numericDateOrder);
            if (reordered !== null) return reordered;
        }
        return parts.map((part)=>part.value).join('').trim();
    };
    /**
   * The month of the CLINIC's calendar — Jalali — in the reading locale's
   * language and digits, whatever calendar that locale otherwise uses.
   *
   * The analysis timeline grids its axis on Jalali month boundaries, because
   * «this month» to an Iranian clinic means the Jalali month on the wall. A
   * gridline standing at 1 Mordad must therefore be labelled «مرداد» /
   * «Mordad», not «August» — the Gregorian month that line does not start.
   *
   * Composed from parts rather than asked for as a pattern, for two reasons ICU
   * forces: every locale puts the year on a different side of the month (Persian
   * emits «۱۴۰۴ مرداد», English «Mordad 1404»), and a non-default calendar drags
   * an era along with it («1404 AP», «١٤٠٤ ه‍.ش»). An axis label has to be the
   * same shape in all three languages and has no room for an era.
   */ const formatClinicMonth = (value, { withYear: withYear = false } = {})=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        const options = {
            month: 'long',
            ...withYear ? {
                year: 'numeric'
            } : {}
        };
        let parts = $79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', clinicTag, {
            timeZone: timeZone,
            ...options
        }).formatToParts(date);
        parts = $79eab5f6e33897ad$var$dropEra(parts);
        if (monthNames && parts.some($79eab5f6e33897ad$var$isNamedMonth)) parts = $79eab5f6e33897ad$var$withMonthNames(parts, monthNames, monthNumber(date));
        const month = parts.find((part)=>part.type === 'month')?.value ?? '';
        const year = parts.find((part)=>part.type === 'year')?.value ?? '';
        return withYear && year ? `${month} ${year}` : month;
    };
    /**
   * A date in one of the named shapes above.
   *
   * `full` is composed rather than delegated to `dateStyle: 'full'`. Node's
   * bundled ICU emits the Persian full pattern as year–month–day–weekday
   * («۱۴۰۴ مرداد ۱۲، یکشنبه»), which is both wrong for Persian and the reverse
   * of what the same ICU gives for `long`. Browsers disagree with it and with
   * each other. Composing weekday + long date makes the one date shape a
   * doctor reads at the top of a day sheet identical everywhere, which matters
   * more here than deferring to CLDR.
   */ const formatDate = (value, style = 'medium')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        // `full` and `weekdayDayMonth` are the two composed shapes.
        if (style === 'full' || style === 'weekdayDayMonth') {
            const weekday = dateTime({
                weekday: 'long'
            }).format(date);
            const rest = renderDate(date, style === 'full' ? 'long' : 'dayMonth');
            return `${weekday}${weekdaySeparator}${rest}`;
        }
        return renderDate(date, style);
    };
    /**
   * Clock time, 24-hour in every locale. Iranian clinical scheduling is written
   * and spoken in 24-hour time, and an English UI for an Iranian clinic that
   * suddenly says "2:30 PM" while the printed day sheet says 14:30 is a
   * transcription error waiting to happen.
   */ const formatTime = (value)=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return dateTime({
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    };
    const formatDateTime = (value, style = 'medium')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return `${formatDate(date, style)} ${formatTime(date)}`;
    };
    /**
   * Weekday name. The three widths are NOT what the names suggest in Persian,
   * so pick by looking at the output rather than by analogy with English:
   *
   *   long    یکشنبه   Sunday   الأحد
   *   short   یکشنبه   Sun      الأحد     ← Persian/Arabic `short` is the FULL word
   *   narrow  ی        S        ح
   *
   * A one-letter chip — the reception week strip — needs `narrow`; anything that
   * reads as a word needs `long`. `short` only differs from `long` in English.
   */ const formatWeekday = (value, width = 'long')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return dateTime({
            weekday: width
        }).format(date);
    };
    /**
   * A plain count — NOT money, so no toman conversion. Persian digits in `fa`,
   * Latin in `en`, grouped in both.
   */ const formatNumber = (value, options)=>{
        if (value == null || value === '' || !Number.isFinite(Number(value))) return $79eab5f6e33897ad$var$EMPTY;
        return number(options).format(Number(value));
    };
    const formatPercent = (value, options)=>{
        if (value == null || !Number.isFinite(Number(value))) return $79eab5f6e33897ad$var$EMPTY;
        return number({
            style: 'percent',
            maximumFractionDigits: 0,
            ...options
        }).format(Number(value) / 100);
    };
    /**
   * Clinic money: MINOR UNITS of `currency` in → the figure a human reads out.
   *
   * No currency — or '' or 'IRR' — is the contract this always had: WHOLE RIALS
   * in, a toman figure out, and `withUnit` appends the caller's `unitLabel` (the
   * app's own «تومان»/«toman» catalogue word), or nothing when there is none.
   *
   * Any other currency is divided by its own divisor and shown with its own
   * fraction digits (USD 2, KWD 3) in this locale's digits. With `withUnit` its
   * unit is the currency table's word — `unitStyle` 'long' («US dollar»,
   * default) or 'short' («USD») — and a caller's `unitLabel` is IGNORED: at every
   * call site written before currencies existed it is a toman word, and a
   * non-IRR figure must never read «تومان». A code outside the table throws.
   */ const formatMoney = (amountMinor, { currency: currency, withUnit: withUnit = false, unitLabel: unitLabel = '', unitStyle: unitStyle = 'long' } = {})=>{
        const info = (0, $lHVFz.currencyInfo)(currency);
        if (info.code !== (0, $lHVFz.DEFAULT_CURRENCY)) {
            const value = (0, $lHVFz.toDisplay)(amountMinor, info.code);
            if (value == null) return $79eab5f6e33897ad$var$EMPTY;
            const text = number({
                minimumFractionDigits: info.minDisplayDecimals,
                maximumFractionDigits: info.maxDisplayDecimals
            }).format(value);
            return withUnit ? `${text} ${(0, $lHVFz.unitLabel)(info.code, localeId, unitStyle)}` : text;
        }
        if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return $79eab5f6e33897ad$var$EMPTY;
        const toman = Number(amountMinor) / 10; // IRR: whole rials → toman
        // Prices are entered in toman so sub-toman precision cannot exist, but a
        // percentage discount can land on a half-toman: show it rather than
        // silently rounding money away.
        const text = number({
            maximumFractionDigits: 1
        }).format(toman);
        return withUnit && unitLabel ? `${text} ${unitLabel}` : text;
    };
    /**
   * «۳ روز پیش» / «3 days ago». Picks the largest unit that fits, so a two-hour
   * gap reads in hours and a two-month gap in months.
   */ const formatRelativeTime = (value, now = Date.now())=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        const rtf = $79eab5f6e33897ad$var$intl(Intl.RelativeTimeFormat, 'rt', tag, {
            numeric: 'auto'
        });
        const deltaSeconds = (date.getTime() - now) / 1000;
        const units = [
            [
                'year',
                31536000
            ],
            [
                'month',
                2592000
            ],
            [
                'week',
                604800
            ],
            [
                'day',
                86400
            ],
            [
                'hour',
                3600
            ],
            [
                'minute',
                60
            ]
        ];
        for (const [unit, seconds] of units){
            if (Math.abs(deltaSeconds) >= seconds) return rtf.format(Math.round(deltaSeconds / seconds), unit);
        }
        return rtf.format(Math.round(deltaSeconds), 'second');
    };
    /** «الف، ب و ج» / «a, b, and c» — grammatically correct list joining. */ const formatList = (items, type = 'conjunction')=>{
        const list = (items || []).filter((item)=>item != null && item !== '').map(String);
        if (!list.length) return '';
        if (typeof Intl.ListFormat !== 'function') return list.join(', ');
        return $79eab5f6e33897ad$var$intl(Intl.ListFormat, 'lf', tag, {
            style: 'long',
            type: type
        }).format(list);
    };
    /**
   * Digits only, in the locale's numbering system, with NO grouping — for
   * things that are digit strings rather than quantities: a national id, a
   * medical-council code, a file number. Grouping one of those would read as a
   * different identifier.
   */ // '0'…'9' in this locale's numbering system, resolved once.
    const digitMap = Array.from({
        length: 10
    }, (_, d)=>number({
            useGrouping: false
        }).format(d));
    const formatDigits = (value)=>{
        if (value == null || value === '') return '';
        return String(value).replace(/\d/g, (d)=>digitMap[Number(d)]);
    };
    return {
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateTime: formatDateTime,
        formatWeekday: formatWeekday,
        formatClinicMonth: formatClinicMonth,
        formatNumber: formatNumber,
        formatPercent: formatPercent,
        formatMoney: formatMoney,
        formatRelativeTime: formatRelativeTime,
        formatList: formatList,
        formatDigits: formatDigits
    };
}
function $79eab5f6e33897ad$export$9b6501e8a1c6bef1(t, localeId) {
    return (currency, style = 'long')=>{
        const info = (0, $lHVFz.currencyInfo)(currency);
        if (info.code === (0, $lHVFz.DEFAULT_CURRENCY)) return t(style === 'short' ? 'common.units.tomanShort' : 'common.units.toman');
        return (0, $lHVFz.unitLabel)(info.code, localeId, style);
    };
}
const $79eab5f6e33897ad$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
const $79eab5f6e33897ad$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};

});


parcelRegister("LNQP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb0f44759e108b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $4rEI6 = parcelRequire("4rEI6");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $asXy3 = parcelRequire("asXy3");

var $4xMUZ = parcelRequire("4xMUZ");
// ─────────────────────────────────────────────────────────────────────────────
// The only way a component reads a string.
//
//   const { t, formatDate, isRTL } = useTranslation();
//   <button>{t('common.actions.save')}</button>
//
// Keys are always fully qualified — the first segment names the file the string
// lives in (see translator.js). There is no scoped/`useTranslation('visit')`
// form on purpose: one rule means a key you see in a screen is a key you can
// grep for, and a string cannot be reached by two different names.
// ─────────────────────────────────────────────────────────────────────────────
// Rendered outside a provider — a component under test, or an error boundary
// that caught the provider itself. It reports the product's default locale (the
// brand's, when it names one) and translates to the humanised key rather than
// throwing, because "no translations" must never be the reason a clinical
// screen fails to render. Rebuilt if the brand changes after the first build.
let $08fb0f44759e108b$var$orphan = null;
let $08fb0f44759e108b$var$orphanRevision = -1;
function $08fb0f44759e108b$var$orphanValue() {
    if (!$08fb0f44759e108b$var$orphan || $08fb0f44759e108b$var$orphanRevision !== (0, $eLeza.brandRevision)()) {
        $08fb0f44759e108b$var$orphanRevision = (0, $eLeza.brandRevision)();
        const locale = (0, $Hy6Lb.productDefaultLocale)();
        const descriptor = (0, $Hy6Lb.localeDescriptor)(locale);
        const formatters = (0, $asXy3.createFormatters)(locale);
        const { t: t, tList: tList, has: has } = (0, $4xMUZ.createTranslator)({
            locale: locale,
            catalog: {},
            fallbackCatalog: {},
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        $08fb0f44759e108b$var$orphan = {
            locale: locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            readsPersianData: descriptor.readsPersianData === true,
            locales: {},
            t: t,
            tList: tList,
            has: has,
            ...formatters,
            moneyUnit: (0, $asXy3.createMoneyUnit)(t, locale),
            setLocale: ()=>{},
            preloadLocale: ()=>{},
            ready: false
        };
    }
    return $08fb0f44759e108b$var$orphan;
}
function $08fb0f44759e108b$export$9fc83ad70ead8663() {
    return (0, $acw62.useContext)((0, $4rEI6.I18nContext)) ?? $08fb0f44759e108b$var$orphanValue();
}
var $08fb0f44759e108b$export$2e2bcd8739ae039 = $08fb0f44759e108b$export$9fc83ad70ead8663;

});


parcelRegister("a83Oj", function(module, exports) {

$parcel$export(module.exports, "getToken", () => $75fd9b66ad1c343c$export$257b2d10b709d8ef);
$parcel$export(module.exports, "getValidToken", () => $75fd9b66ad1c343c$export$51699064a8fe557f);
$parcel$export(module.exports, "refreshAccessToken", () => $75fd9b66ad1c343c$export$f8f36faf9a051362);
$parcel$export(module.exports, "parseJwt", () => $75fd9b66ad1c343c$export$83cd1f1503eb19c0);
$parcel$export(module.exports, "isTokenExpired", () => $75fd9b66ad1c343c$export$b007d77a962aa175);
// The clinical module's view of authentication — an ADAPTER, not a flow.
//
// In the doctor panel this file was the whole OIDC/PKCE client. The clinical
// screens only ever needed five things from it: the current token, a valid one,
// a refresh, the refresh token's claims (for the expiry banner) and a sign-out.
// Every panel that renders them already has its own sign-in, so they come from
// the host (../host.jsx) and the flow itself stays with the panel that owns it.

var $e317r = parcelRequire("e317r");
function $75fd9b66ad1c343c$export$257b2d10b709d8ef() {
    return (0, $e317r.hostAuth)().getToken?.() ?? null;
}
function $75fd9b66ad1c343c$export$c8736e6c4fef498e() {
    return (0, $e317r.hostAuth)().getRefresh?.() ?? null;
}
async function $75fd9b66ad1c343c$export$51699064a8fe557f() {
    return await (0, $e317r.hostAuth)().getValidToken?.() ?? null;
}
async function $75fd9b66ad1c343c$export$f8f36faf9a051362() {
    return await (0, $e317r.hostAuth)().refreshAccessToken?.() ?? false;
}
function $75fd9b66ad1c343c$export$a0973bcfe11b05c9() {
    return (0, $e317r.hostAuth)().logout?.();
}
function $75fd9b66ad1c343c$export$83cd1f1503eb19c0(token) {
    const own = (0, $e317r.hostAuth)().parseJwt;
    if (typeof own === 'function') {
        const claims = own(token);
        if (claims !== undefined) return claims;
    }
    return $75fd9b66ad1c343c$var$decodeJwt(token);
}
function $75fd9b66ad1c343c$var$decodeJwt(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $75fd9b66ad1c343c$export$b007d77a962aa175(token) {
    const own = (0, $e317r.hostAuth)().isTokenExpired;
    if (typeof own === 'function') {
        const expired = own(token);
        if (expired !== undefined) return expired;
    }
    const p = $75fd9b66ad1c343c$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}

});
parcelRegister("e317r", function(module, exports) {

$parcel$export(module.exports, "configureClinical", () => $a2c818bd066c02a1$export$ea0e7255dd85d322);
$parcel$export(module.exports, "hostBffUrl", () => $a2c818bd066c02a1$export$20af24a32eacf994);
$parcel$export(module.exports, "hostWsBase", () => $a2c818bd066c02a1$export$3b6b531768f3bab4);
$parcel$export(module.exports, "hostAuth", () => $a2c818bd066c02a1$export$52577b4f7e562784);
$parcel$export(module.exports, "hostActiveClinicId", () => $a2c818bd066c02a1$export$eb4e3d365e278024);
$parcel$export(module.exports, "ClinicalHostProvider", () => $a2c818bd066c02a1$export$3bbc25d04279abb7);
$parcel$export(module.exports, "useClinicalHost", () => $a2c818bd066c02a1$export$746c366fc2da5120);
$parcel$export(module.exports, "useIranianRails", () => $a2c818bd066c02a1$export$2d5b1aaea152528e);

var $acw62 = parcelRequire("acw62");

var $lHVFz = parcelRequire("lHVFz");

var $eLeza = parcelRequire("eLeza");
/**
 * The clinical module's HOST — everything the Visit and Patient Details screens
 * need from the application that renders them, and nothing else.
 *
 * The screens are the same code in the doctor panel and the clinic panel. What
 * differs is WHERE they live: which BFF they talk to and with which token, how
 * «back» and «top up credits» are routed, and what surrounds them. That is all a
 * host supplies. Clinical behaviour — what a visit is, what is saved when, what
 * the AI is asked — is never a host decision.
 *
 * Two halves, because the code that needs them runs in two different places:
 *
 *   configureClinical({...})  — module-level, set ONCE at boot, for code that
 *                               runs outside React: the GraphQL transport, the
 *                               transcription WebSocket, DICOM fetches.
 *   <ClinicalHostProvider>    — React context, for what changes per render:
 *                               navigation and the current pathname.
 *
 * Neither half grants anything. The doctor BFF authorises every read and scopes
 * every visit to the token's `sub`; a host that mounts these screens for a person
 * who may not use them gets that BFF's refusal, never someone else's data.
 */ const $a2c818bd066c02a1$var$DEFAULT_BFF_URL = 'https://api.parsinabot.ir/graphql';
const $a2c818bd066c02a1$var$deriveWsBase = (url)=>String(url || '').replace(/^https/, 'wss').replace(/^http/, 'ws').replace(/\/graphql\/?$/, '');
const $a2c818bd066c02a1$var$noAuth = {
    getToken: ()=>null,
    getRefresh: ()=>null,
    getValidToken: async ()=>null,
    refreshAccessToken: async ()=>false,
    logout: ()=>{}
};
let $a2c818bd066c02a1$var$host = {
    bffUrl: $a2c818bd066c02a1$var$DEFAULT_BFF_URL,
    wsBase: null,
    auth: $a2c818bd066c02a1$var$noAuth,
    /** The clinic the upload/record screens should default to, or '' for none. */ activeClinicId: null
};
function $a2c818bd066c02a1$export$ea0e7255dd85d322(cfg = {}) {
    $a2c818bd066c02a1$var$host = {
        ...$a2c818bd066c02a1$var$host,
        ...cfg,
        auth: {
            ...$a2c818bd066c02a1$var$noAuth,
            ...$a2c818bd066c02a1$var$host.auth,
            ...cfg.auth || {}
        }
    };
    return $a2c818bd066c02a1$var$host;
}
const $a2c818bd066c02a1$var$read = (v)=>typeof v === 'function' ? v() : v;
function $a2c818bd066c02a1$export$6268306c4a1a8f2a() {
    return $a2c818bd066c02a1$var$host;
}
const $a2c818bd066c02a1$export$20af24a32eacf994 = ()=>$a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.bffUrl) || $a2c818bd066c02a1$var$DEFAULT_BFF_URL;
const $a2c818bd066c02a1$export$3b6b531768f3bab4 = ()=>$a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.wsBase) || $a2c818bd066c02a1$var$deriveWsBase($a2c818bd066c02a1$export$20af24a32eacf994());
const $a2c818bd066c02a1$export$52577b4f7e562784 = ()=>$a2c818bd066c02a1$var$host.auth;
const $a2c818bd066c02a1$export$eb4e3d365e278024 = ()=>{
    const v = $a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.activeClinicId);
    return v == null ? null : String(v);
};
// ── Per-render half ─────────────────────────────────────────────────────────
const $a2c818bd066c02a1$var$warn = (what)=>()=>{
        // Returning quietly is what made a missing route in the doctor panel so hard to
        // see (useAppNavigate's own note). A host that forgot to wire an intent says so.
        console.warn(`[clinical] the host provides no ${what}`);
    };
const $a2c818bd066c02a1$var$DEFAULT_NAV = {
    navigate: $a2c818bd066c02a1$var$warn('navigate()'),
    back: $a2c818bd066c02a1$var$warn('back()'),
    pathname: '',
    clinicCurrency: ''
};
const $a2c818bd066c02a1$var$HostContext = /*#__PURE__*/ (0, $acw62.createContext)($a2c818bd066c02a1$var$DEFAULT_NAV);
function $a2c818bd066c02a1$export$3bbc25d04279abb7({ navigate: navigate, back: back, pathname: pathname = '', clinicCurrency: clinicCurrency = '', children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            navigate: navigate || $a2c818bd066c02a1$var$DEFAULT_NAV.navigate,
            back: back || $a2c818bd066c02a1$var$DEFAULT_NAV.back,
            pathname: pathname,
            clinicCurrency: clinicCurrency || ''
        }), [
        navigate,
        back,
        pathname,
        clinicCurrency
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a2c818bd066c02a1$var$HostContext.Provider, {
        value: value
    }, children);
}
function $a2c818bd066c02a1$export$746c366fc2da5120() {
    return (0, $acw62.useContext)($a2c818bd066c02a1$var$HostContext);
}
function $a2c818bd066c02a1$export$2d5b1aaea152528e() {
    const { clinicCurrency: clinicCurrency } = (0, $acw62.useContext)($a2c818bd066c02a1$var$HostContext);
    if (!(0, $eLeza.isIranMarket)()) return false;
    return !((0, $lHVFz.isClinicCurrency)(clinicCurrency) && clinicCurrency !== (0, $lHVFz.DEFAULT_CURRENCY));
}

});


parcelRegister("4CVxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $241691b67a43640c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $241691b67a43640c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
            key: "18mbvz"
        }
    ],
    [
        "path",
        {
            d: "M6.453 15h11.094",
            key: "3shlmq"
        }
    ],
    [
        "path",
        {
            d: "M8.5 2h7",
            key: "csnxdl"
        }
    ]
];
const $241691b67a43640c$export$2e2bcd8739ae039 = (0, $9QBug.default)("flask-conical", $241691b67a43640c$export$3efd853dbb351e94);

});

parcelRegister("aVx4q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffe798f65d504e7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5ffe798f65d504e7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
            key: "wa1lgi"
        }
    ],
    [
        "path",
        {
            d: "m8.5 8.5 7 7",
            key: "rvfmvr"
        }
    ]
];
const $5ffe798f65d504e7$export$2e2bcd8739ae039 = (0, $9QBug.default)("pill", $5ffe798f65d504e7$export$3efd853dbb351e94);

});

parcelRegister("ggYuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f35c50d66e81764$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3f35c50d66e81764$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
];
const $3f35c50d66e81764$export$2e2bcd8739ae039 = (0, $9QBug.default)("clipboard-list", $3f35c50d66e81764$export$3efd853dbb351e94);

});

parcelRegister("97xXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba16dd414953e5a4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ba16dd414953e5a4$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $ba16dd414953e5a4$export$2e2bcd8739ae039 = (0, $9QBug.default)("info", $ba16dd414953e5a4$export$3efd853dbb351e94);

});

parcelRegister("hSPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f4b1e9a7f47143$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f9f4b1e9a7f47143$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 19v3",
            key: "npa21l"
        }
    ],
    [
        "path",
        {
            d: "M19 10v2a7 7 0 0 1-14 0v-2",
            key: "1vc78b"
        }
    ],
    [
        "rect",
        {
            x: "9",
            y: "2",
            width: "6",
            height: "13",
            rx: "3",
            key: "s6n7sd"
        }
    ]
];
const $f9f4b1e9a7f47143$export$2e2bcd8739ae039 = (0, $9QBug.default)("mic", $f9f4b1e9a7f47143$export$3efd853dbb351e94);

});

parcelRegister("aGlWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9f3418dec68a42$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1f9f3418dec68a42$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $1f9f3418dec68a42$export$2e2bcd8739ae039 = (0, $9QBug.default)("pencil", $1f9f3418dec68a42$export$3efd853dbb351e94);

});

parcelRegister("bF8pu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a234a87c35ebe3af$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a234a87c35ebe3af$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8",
            key: "1p45f6"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ]
];
const $a234a87c35ebe3af$export$2e2bcd8739ae039 = (0, $9QBug.default)("rotate-cw", $a234a87c35ebe3af$export$3efd853dbb351e94);

});

parcelRegister("53qqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8e7ce95b64d1ad$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dd8e7ce95b64d1ad$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $dd8e7ce95b64d1ad$export$2e2bcd8739ae039 = (0, $9QBug.default)("settings", $dd8e7ce95b64d1ad$export$3efd853dbb351e94);

});

parcelRegister("bo0GS", function(module, exports) {

$parcel$export(module.exports, "default", () => $273768d0abd0c569$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $273768d0abd0c569$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $273768d0abd0c569$export$2e2bcd8739ae039 = (0, $9QBug.default)("shield-check", $273768d0abd0c569$export$3efd853dbb351e94);

});

parcelRegister("chm1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b0597d7da6e50a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $53b0597d7da6e50a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
            key: "1s2grr"
        }
    ],
    [
        "path",
        {
            d: "M20 2v4",
            key: "1rf3ol"
        }
    ],
    [
        "path",
        {
            d: "M22 4h-4",
            key: "gwowj6"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "20",
            r: "2",
            key: "6kqj1y"
        }
    ]
];
const $53b0597d7da6e50a$export$2e2bcd8739ae039 = (0, $9QBug.default)("sparkles", $53b0597d7da6e50a$export$3efd853dbb351e94);

});

parcelRegister("7udIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5340d072e86ce769$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5340d072e86ce769$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ]
];
const $5340d072e86ce769$export$2e2bcd8739ae039 = (0, $9QBug.default)("square", $5340d072e86ce769$export$3efd853dbb351e94);

});

parcelRegister("fX0JO", function(module, exports) {

$parcel$export(module.exports, "default", () => $02839c5704f38745$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $02839c5704f38745$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 2v2",
            key: "1539x4"
        }
    ],
    [
        "path",
        {
            d: "M5 2v2",
            key: "1yf1q8"
        }
    ],
    [
        "path",
        {
            d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
            key: "rb5t3r"
        }
    ],
    [
        "path",
        {
            d: "M8 15a6 6 0 0 0 12 0v-3",
            key: "x18d4x"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "10",
            r: "2",
            key: "ts1r5v"
        }
    ]
];
const $02839c5704f38745$export$2e2bcd8739ae039 = (0, $9QBug.default)("stethoscope", $02839c5704f38745$export$3efd853dbb351e94);

});

parcelRegister("lpOUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $28fbfb65224954a2$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $28fbfb65224954a2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $28fbfb65224954a2$export$2e2bcd8739ae039 = (0, $9QBug.default)("trash-2", $28fbfb65224954a2$export$3efd853dbb351e94);

});

parcelRegister("6imzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $df82e729d4b50e19$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $df82e729d4b50e19$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $df82e729d4b50e19$export$2e2bcd8739ae039 = (0, $9QBug.default)("users", $df82e729d4b50e19$export$3efd853dbb351e94);

});

parcelRegister("4gxLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32d8b6368f72037$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b32d8b6368f72037$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
            key: "10ikf1"
        }
    ]
];
const $b32d8b6368f72037$export$2e2bcd8739ae039 = (0, $9QBug.default)("play", $b32d8b6368f72037$export$3efd853dbb351e94);

});

parcelRegister("1HT9m", function(module, exports) {

$parcel$export(module.exports, "type", () => $13e4963cbb566500$export$bf9fb029d174d554);
// ─────────────────────────────────────────────────────────────────────────────
// Centralized typography scale for the Parsina doctor app.
//
// FONT FAMILY is global and inherited — never set it inline.
//   `styles.css` sets `font-family: var(--app-font)` on <body> + all form
//   controls, and `--app-font` follows the doctor's typeface choice
//   (Settings → ظاهر برنامه → قلم; catalogue in src/constants/fonts.js, default
//   «Meshkat» = Vazirmatn). Every element inherits it. These tokens deliberately
//   OMIT `fontFamily` so text always resolves to that single global face — the
//   moment a component hardcodes a family (or an outlier weight/letter-spacing)
//   it visually forks from the page AND stops following the doctor's choice.
//
// SIZES are in `rem`, not `px`, so they scale with the app's font-size preference
//   (Settings → ظاهر drives the root font-size; see tokens.css `data-font-size`).
//   1rem = 16px at the default "medium" setting, so each token matches the value
//   it replaced by default while now scaling for "small"/"large" too.
//
// USAGE — spread a role token, then layer only colour/margins on top:
//   <div style={{ ...type.title, color: C.textPrimary }}>عنوان</div>
//   <span style={{ ...type.hero }}>{fmtCoins(balance, formatNumber)}</span>
// One import, one scale — future components inherit the same typography.
// ─────────────────────────────────────────────────────────────────────────────
const $13e4963cbb566500$export$bf9fb029d174d554 = {
    // Headline number — the balance. Bold for hierarchy, but a scale weight (800),
    // not the ad-hoc 900+negative-tracking that read as a different font.
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    // Large value — hero on compact/mobile surfaces.
    display: {
        fontSize: '1.625rem',
        fontWeight: 800,
        lineHeight: 1.1
    },
    // KPI / stat value.
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Card / section headings.
    title: {
        fontSize: '0.9375rem',
        fontWeight: 800,
        lineHeight: 1.3
    },
    // Numeric amounts (transaction rows, group totals).
    amount: {
        fontSize: '0.875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Primary body / row text.
    body: {
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Field / stat labels.
    label: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Secondary meta.
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Tiny meta / dot labels.
    micro: {
        fontSize: '0.625rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Unit suffix («پارسه»), sits beside a value in a lighter weight.
    unit: {
        fontSize: '0.75rem',
        fontWeight: 700
    }
};
var $13e4963cbb566500$export$2e2bcd8739ae039 = $13e4963cbb566500$export$bf9fb029d174d554;

});

parcelRegister("jhSl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc74fc270115805$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ccc74fc270115805$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4",
            key: "re6nr2"
        }
    ],
    [
        "path",
        {
            d: "M2 6h4",
            key: "aawbzj"
        }
    ],
    [
        "path",
        {
            d: "M2 10h4",
            key: "l0bgd4"
        }
    ],
    [
        "path",
        {
            d: "M2 14h4",
            key: "1gsvsf"
        }
    ],
    [
        "path",
        {
            d: "M2 18h4",
            key: "1bu2t1"
        }
    ],
    [
        "path",
        {
            d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
            key: "pqwjuv"
        }
    ]
];
const $ccc74fc270115805$export$2e2bcd8739ae039 = (0, $9QBug.default)("notebook-pen", $ccc74fc270115805$export$3efd853dbb351e94);

});

parcelRegister("2XwcZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa705b4b24684ba$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6fa705b4b24684ba$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $6fa705b4b24684ba$export$2e2bcd8739ae039 = (0, $9QBug.default)("download", $6fa705b4b24684ba$export$3efd853dbb351e94);

});

parcelRegister("gr49X", function(module, exports) {

$parcel$export(module.exports, "default", () => $839cd39f53db0480$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $839cd39f53db0480$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $839cd39f53db0480$export$2e2bcd8739ae039 = (0, $9QBug.default)("eye", $839cd39f53db0480$export$3efd853dbb351e94);

});

parcelRegister("k2reB", function(module, exports) {

$parcel$export(module.exports, "default", () => $340d4e1a05281a91$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $340d4e1a05281a91$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const $340d4e1a05281a91$export$2e2bcd8739ae039 = (0, $9QBug.default)("activity", $340d4e1a05281a91$export$3efd853dbb351e94);

});

parcelRegister("a0SXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27abdf05888854f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $d27abdf05888854f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
            key: "143wyd"
        }
    ],
    [
        "path",
        {
            d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
            key: "1itne7"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "14",
            width: "12",
            height: "8",
            rx: "1",
            key: "1ue0tg"
        }
    ]
];
const $d27abdf05888854f$export$2e2bcd8739ae039 = (0, $9QBug.default)("printer", $d27abdf05888854f$export$3efd853dbb351e94);

});

parcelRegister("0hzSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe506e7c2094458f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fe506e7c2094458f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $fe506e7c2094458f$export$2e2bcd8739ae039 = (0, $9QBug.default)("log-out", $fe506e7c2094458f$export$3efd853dbb351e94);

});

parcelRegister("ctEhH", function(module, exports) {

$parcel$export(module.exports, "announceTaminReturn", () => $9157711a0471cf88$export$f0148742d4f159a2);
$parcel$export(module.exports, "onTaminReturn", () => $9157711a0471cf88$export$28c940609d8f8ac7);
// تأمین's login happens on تأمین's own page, in a tab the e-prescription card
// opened. When it is done, تأمین sends that tab to the doctor app's return page
// (/erx/tamin-return), which uses this module to tell the tab still holding the
// card — so the card re-checks the session and carries on without the doctor
// having to find it and press anything.
//
// Two carriers, because either alone misses a browser: BroadcastChannel reaches
// every same-origin tab directly; a localStorage write fires a `storage` event in
// the OTHER tabs, which covers a browser without BroadcastChannel. Both are
// same-origin only, which is the point — nothing outside the doctor app can
// trigger it.
const $9157711a0471cf88$export$5b756be60bce09c4 = 'parsina-erx';
const $9157711a0471cf88$export$ca28998d10652f48 = 'parsina-erx-tamin-return';
function $9157711a0471cf88$export$f0148742d4f159a2({ ok: ok, error: error = null, state: state = null } = {}) {
    const detail = {
        type: 'tamin-return',
        ok: Boolean(ok),
        error: error,
        state: state,
        at: Date.now()
    };
    try {
        const ch = new BroadcastChannel($9157711a0471cf88$export$5b756be60bce09c4);
        ch.postMessage(detail);
        ch.close();
    } catch  {}
    try {
        localStorage.setItem($9157711a0471cf88$export$ca28998d10652f48, JSON.stringify(detail));
    } catch  {}
    return detail;
}
function $9157711a0471cf88$export$28c940609d8f8ac7(handler) {
    let ch = null;
    try {
        ch = new BroadcastChannel($9157711a0471cf88$export$5b756be60bce09c4);
        ch.onmessage = (e)=>{
            if (e?.data?.type === 'tamin-return') handler(e.data);
        };
    } catch  {
        ch = null;
    }
    const onStorage = (e)=>{
        if (e.key !== $9157711a0471cf88$export$ca28998d10652f48 || !e.newValue) return;
        try {
            const detail = JSON.parse(e.newValue);
            if (detail?.type === 'tamin-return') handler(detail);
        } catch  {}
    };
    window.addEventListener('storage', onStorage);
    return ()=>{
        window.removeEventListener('storage', onStorage);
        try {
            ch?.close();
        } catch  {}
    };
}

});

parcelRegister("61bLk", function(module, exports) {

$parcel$export(module.exports, "decompressSync", () => $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe);
$parcel$export(module.exports, "UnzipInflate", () => $461bf5d8bd29e0d8$export$eb188945cc39e642);
$parcel$export(module.exports, "Unzip", () => $461bf5d8bd29e0d8$export$9b7485f84cbaaa56);
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$u32 = Uint32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a[0], $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b[0], $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >>> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >>> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >>> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >>> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? $461bf5d8bd29e0d8$var$u16 : v.BYTES_PER_ELEMENT == 4 ? $461bf5d8bd29e0d8$var$u32 : $461bf5d8bd29e0d8$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $461bf5d8bd29e0d8$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        $461bf5d8bd29e0d8$var$et,
        0
    ];
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $461bf5d8bd29e0d8$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, syms[i] >>> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
        var dst = syms[i] & 31;
        $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
    } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $461bf5d8bd29e0d8$var$u16(32768), head = new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, $461bf5d8bd29e0d8$var$et);
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $461bf5d8bd29e0d8$var$ch[id] = $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id][1]);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$u32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gu8
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$u32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zlv
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $461bf5d8bd29e0d8$var$gu8 = function(o) {
    return o && o.size && new $461bf5d8bd29e0d8$var$u8(o.size);
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $461bf5d8bd29e0d8$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if (d[1] & 32) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: preset dictionaries not supported');
};
function $461bf5d8bd29e0d8$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        var l = this.p.length;
        var n = new $461bf5d8bd29e0d8$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.o, this.s);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, !f);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$gzs(data), -8), out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(($461bf5d8bd29e0d8$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, out) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            $461bf5d8bd29e0d8$var$slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) $461bf5d8bd29e0d8$var$err(8);
        return out;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295;
        if (z) {
            e = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            if ($461bf5d8bd29e0d8$var$b4(data, e) != 0x6064B50) {
                cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
                return tAll;
            }
            c = lft = $461bf5d8bd29e0d8$var$b4(data, e + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, e + 48);
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, new $461bf5d8bd29e0d8$var$u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        if ($461bf5d8bd29e0d8$var$b4(data, e) != 0x6064B50) $461bf5d8bd29e0d8$var$err(13);
        c = $461bf5d8bd29e0d8$var$b4(data, e + 32);
        o = $461bf5d8bd29e0d8$var$b4(data, e + 48);
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), new $461bf5d8bd29e0d8$var$u8(su));
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

});

parcelRegister("cF21O", function(module, exports) {
/*! dicom-parser - 1.8.12 - 2023-02-20 | (c) 2017 Chris Hafey | https://github.com/cornerstonejs/dicomParser */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $937ae3202df95507$require$Buffer = $6ZWSX.Buffer;

!function(e, t) {
    module.exports = t((parcelRequire("kjyEk")));
}(module.exports, function(r) {
    var a, i;
    return a = [
        function(e, t) {
            e.exports = r;
        },
        function(e, t, s) {
            "use strict";
            s.r(t), s.d(t, "isStringVr", function() {
                return d;
            }), s.d(t, "isPrivateTag", function() {
                return f;
            }), s.d(t, "parsePN", function() {
                return a;
            }), s.d(t, "parseTM", function() {
                return n;
            }), s.d(t, "parseDA", function() {
                return o;
            }), s.d(t, "explicitElementToString", function() {
                return l;
            }), s.d(t, "explicitDataSetToJS", function() {
                return u;
            }), s.d(t, "createJPEGBasicOffsetTable", function() {
                return p;
            }), s.d(t, "parseDicomDataSetExplicit", function() {
                return q;
            }), s.d(t, "parseDicomDataSetImplicit", function() {
                return T;
            }), s.d(t, "readFixedString", function() {
                return b;
            }), s.d(t, "alloc", function() {
                return k;
            }), s.d(t, "version", function() {
                return L;
            }), s.d(t, "bigEndianByteArrayParser", function() {
                return N;
            }), s.d(t, "ByteStream", function() {
                return J;
            }), s.d(t, "sharedCopy", function() {
                return j;
            }), s.d(t, "DataSet", function() {
                return w;
            }), s.d(t, "findAndSetUNElementLength", function() {
                return y;
            }), s.d(t, "findEndOfEncapsulatedElement", function() {
                return g;
            }), s.d(t, "findItemDelimitationItemAndSetElementLength", function() {
                return x;
            }), s.d(t, "littleEndianByteArrayParser", function() {
                return M;
            }), s.d(t, "parseDicom", function() {
                return V;
            }), s.d(t, "readDicomElementExplicit", function() {
                return B;
            }), s.d(t, "readDicomElementImplicit", function() {
                return A;
            }), s.d(t, "readEncapsulatedImageFrame", function() {
                return W;
            }), s.d(t, "readEncapsulatedPixelData", function() {
                return K;
            }), s.d(t, "readEncapsulatedPixelDataFromFragments", function() {
                return _;
            }), s.d(t, "readPart10Header", function() {
                return G;
            }), s.d(t, "readSequenceItemsExplicit", function() {
                return I;
            }), s.d(t, "readSequenceItemsImplicit", function() {
                return F;
            }), s.d(t, "readSequenceItem", function() {
                return S;
            }), s.d(t, "readTag", function() {
                return h;
            });
            var r = {
                AE: !0,
                AS: !0,
                AT: !1,
                CS: !0,
                DA: !0,
                DS: !0,
                DT: !0,
                FL: !1,
                FD: !1,
                IS: !0,
                LO: !0,
                LT: !0,
                OB: !1,
                OD: !1,
                OF: !1,
                OW: !1,
                PN: !0,
                SH: !0,
                SL: !1,
                SQ: !1,
                SS: !1,
                ST: !0,
                TM: !0,
                UI: !0,
                UL: !1,
                UN: void 0,
                UR: !0,
                US: !1,
                UT: !0
            }, d = function(e) {
                return r[e];
            }, f = function(e) {
                e = parseInt(e[4], 16);
                if (isNaN(e)) throw "dicomParser.isPrivateTag: cannot parse last character of group";
                return e % 2 == 1;
            }, a = function(e) {
                if (void 0 !== e) {
                    e = e.split("^");
                    return {
                        familyName: e[0],
                        givenName: e[1],
                        middleName: e[2],
                        prefix: e[3],
                        suffix: e[4]
                    };
                }
            };
            function n(e, t) {
                if (2 <= e.length) {
                    var r = parseInt(e.substring(0, 2), 10), a = 4 <= e.length ? parseInt(e.substring(2, 4), 10) : void 0, n = 6 <= e.length ? parseInt(e.substring(4, 6), 10) : void 0, i = 8 <= e.length ? e.substring(7, 13) : void 0, i = i ? parseInt(i, 10) * Math.pow(10, 6 - i.length) : void 0;
                    if (t && (isNaN(r) || void 0 !== a && isNaN(a) || void 0 !== n && isNaN(n) || void 0 !== i && isNaN(i) || r < 0 || 23 < r || a && (a < 0 || 59 < a) || n && (n < 0 || 59 < n) || i && (i < 0 || 999999 < i))) throw "invalid TM '".concat(e, "'");
                    return {
                        hours: r,
                        minutes: a,
                        seconds: n,
                        fractionalSeconds: i
                    };
                }
                if (t) throw "invalid TM '".concat(e, "'");
            }
            function i(e, t, r) {
                return !isNaN(r) && 0 < t && t <= 12 && 0 < e && e <= function(e, t) {
                    switch(e){
                        case 2:
                            return t % 4 == 0 && t % 100 || t % 400 == 0 ? 29 : 28;
                        case 9:
                        case 4:
                        case 6:
                        case 11:
                            return 30;
                        default:
                            return 31;
                    }
                }(t, r);
            }
            function o(e, t) {
                if (e && 8 === e.length) {
                    var r = parseInt(e.substring(0, 4), 10), a = parseInt(e.substring(4, 6), 10), n = parseInt(e.substring(6, 8), 10);
                    if (t && !0 !== i(n, a, r)) throw "invalid DA '".concat(e, "'");
                    return {
                        year: r,
                        month: a,
                        day: n
                    };
                }
                if (t) throw "invalid DA '".concat(e, "'");
            }
            function l(n, e) {
                if (void 0 === n || void 0 === e) throw "dicomParser.explicitElementToString: missing required parameters";
                if (void 0 === e.vr) throw "dicomParser.explicitElementToString: cannot convert implicit element to string";
                var t, r = e.vr, i = e.tag;
                function a(e, t) {
                    for(var r = "", a = 0; a < e; a++)0 !== a && (r += "/"), r += t.call(n, i, a).toString();
                    return r;
                }
                if (!0 === d(r)) t = n.string(i);
                else {
                    if ("AT" === r) {
                        var o = n.uint32(i);
                        return void 0 === o ? void 0 : "x".concat((o = o < 0 ? 4294967295 + o + 1 : o).toString(16).toUpperCase());
                    }
                    "US" === r ? t = a(e.length / 2, n.uint16) : "SS" === r ? t = a(e.length / 2, n.int16) : "UL" === r ? t = a(e.length / 4, n.uint32) : "SL" === r ? t = a(e.length / 4, n.int32) : "FD" === r ? t = a(e.length / 8, n.double) : "FL" === r && (t = a(e.length / 4, n.float));
                }
                return t;
            }
            function u(e, t) {
                if (void 0 === e) throw "dicomParser.explicitDataSetToJS: missing required parameter dataSet";
                t = t || {
                    omitPrivateAttibutes: !0,
                    maxElementLength: 128
                };
                var r, a = {};
                for(r in e.elements){
                    var n = e.elements[r];
                    if (!0 !== t.omitPrivateAttibutes || !f(r)) {
                        if (n.items) {
                            for(var i = [], o = 0; o < n.items.length; o++)i.push(u(n.items[o].dataSet, t));
                            a[r] = i;
                        } else {
                            var s = void 0;
                            n.length < t.maxElementLength && (s = l(e, n)), a[r] = void 0 !== s ? s : {
                                dataOffset: n.dataOffset,
                                length: n.length
                            };
                        }
                    }
                }
                return a;
            }
            function c(e, t) {
                return 255 === e.byteArray[t] && 217 === e.byteArray[t + 1];
            }
            function m(e, t, r) {
                for(var a, n, i = r; i < t.fragments.length; i++)if (a = e, n = i, n = t.fragments[n], !(!c(a, n.position + n.length - 2) && !c(a, n.position + n.length - 3))) return i;
            }
            function p(e, t, r) {
                if (void 0 === e) throw "dicomParser.createJPEGBasicOffsetTable: missing required parameter dataSet";
                if (void 0 === t) throw "dicomParser.createJPEGBasicOffsetTable: missing required parameter pixelDataElement";
                if ("x7fe00010" !== t.tag) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010'";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (t.fragments.length <= 0) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (r && r.length <= 0) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'fragments' must not be zero length";
                r = r || t.fragments;
                for(var a = [], n = 0;;){
                    a.push(t.fragments[n].offset);
                    var i = m(e, t, n);
                    if (void 0 === i || i === t.fragments.length - 1) return a;
                    n = i + 1;
                }
            }
            function h(e) {
                if (void 0 === e) throw "dicomParser.readTag: missing required parameter 'byteStream'";
                var t = 256 * e.readUint16() * 256, e = e.readUint16();
                return "x".concat("00000000".concat((t + e).toString(16)).substr(-8));
            }
            function g(e, t, r) {
                if (void 0 === e) throw "dicomParser.findEndOfEncapsulatedElement: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.findEndOfEncapsulatedElement: missing required parameter 'element'";
                if (t.encapsulatedPixelData = !0, t.basicOffsetTable = [], t.fragments = [], "xfffee000" !== h(e)) throw "dicomParser.findEndOfEncapsulatedElement: basic offset table not found";
                for(var a = e.readUint32() / 4, n = 0; n < a; n++){
                    var i = e.readUint32();
                    t.basicOffsetTable.push(i);
                }
                for(var o = e.position; e.position < e.byteArray.length;){
                    var s = h(e), d = e.readUint32();
                    if ("xfffee0dd" === s) return e.seek(d), void (t.length = e.position - t.dataOffset);
                    if ("xfffee000" !== s) return r && r.push("unexpected tag ".concat(s, " while searching for end of pixel data element with undefined length")), d > e.byteArray.length - e.position && (d = e.byteArray.length - e.position), t.fragments.push({
                        offset: e.position - o - 8,
                        position: e.position,
                        length: d
                    }), e.seek(d), void (t.length = e.position - t.dataOffset);
                    t.fragments.push({
                        offset: e.position - o - 8,
                        position: e.position,
                        length: d
                    }), e.seek(d);
                }
                r && r.push("pixel data element ".concat(t.tag, " missing sequence delimiter tag xfffee0dd"));
            }
            function y(e, t) {
                if (void 0 === e) throw "dicomParser.findAndSetUNElementLength: missing required parameter 'byteStream'";
                for(var r = e.byteArray.length - 8; e.position <= r;)if (65534 === e.readUint16()) {
                    var a = e.readUint16();
                    if (57565 === a) return 0 !== e.readUint32() && e.warnings("encountered non zero length following item delimiter at position ".concat(e.position - 4, " while reading element of undefined length with tag ").concat(t.tag)), void (t.length = e.position - t.dataOffset);
                }
                t.length = e.byteArray.length - t.dataOffset, e.seek(e.byteArray.length - e.position);
            }
            function b(e, t, r) {
                if (r < 0) throw "dicomParser.readFixedString - length cannot be less than 0";
                if (t + r > e.length) throw "dicomParser.readFixedString: attempt to read past end of buffer";
                for(var a, n = "", i = 0; i < r; i++){
                    if (0 === (a = e[t + i])) return t += r, n;
                    n += String.fromCharCode(a);
                }
                return n;
            }
            function v(e, t) {
                for(var r = 0; r < t.length; r++){
                    var a = t[r];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                }
            }
            function P(e, t) {
                return void 0 !== e.parser ? e.parser : t;
            }
            var w = function() {
                function a(e, t, r) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), this.byteArrayParser = e, this.byteArray = t, this.elements = r;
                }
                var e, t, r;
                return e = a, t = [
                    {
                        key: "uint16",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readUint16(this.byteArray, e.dataOffset + 2 * t);
                        }
                    },
                    {
                        key: "int16",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readInt16(this.byteArray, e.dataOffset + 2 * t);
                        }
                    },
                    {
                        key: "uint32",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readUint32(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "int32",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readInt32(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "float",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readFloat(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "double",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readDouble(this.byteArray, e.dataOffset + 8 * t);
                        }
                    },
                    {
                        key: "numStringValues",
                        value: function(e) {
                            e = this.elements[e];
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length).match(/\\/g);
                                return null === e ? 1 : e.length + 1;
                            }
                        }
                    },
                    {
                        key: "string",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (e && e.Value) return e.Value;
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length);
                                return 0 <= t ? e.split("\\")[t].trim() : e.trim();
                            }
                        }
                    },
                    {
                        key: "text",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length);
                                return 0 <= t ? e.split("\\")[t].replace(/ +$/, "") : e.replace(/ +$/, "");
                            }
                        }
                    },
                    {
                        key: "floatString",
                        value: function(e, t) {
                            var r = this.elements[e];
                            if (r && 0 < r.length) {
                                t = this.string(e, t = void 0 !== t ? t : 0);
                                if (void 0 !== t) return parseFloat(t);
                            }
                        }
                    },
                    {
                        key: "intString",
                        value: function(e, t) {
                            var r = this.elements[e];
                            if (r && 0 < r.length) {
                                t = this.string(e, t = void 0 !== t ? t : 0);
                                if (void 0 !== t) return parseInt(t);
                            }
                        }
                    },
                    {
                        key: "attributeTag",
                        value: function(e) {
                            var t = this.elements[e];
                            if (t && 4 === t.length) {
                                var r = P(t, this.byteArrayParser).readUint16, e = this.byteArray, t = t.dataOffset;
                                return "x".concat("00000000".concat((256 * r(e, t) * 256 + r(e, t + 2)).toString(16)).substr(-8));
                            }
                        }
                    }
                ], v(e.prototype, t), r && v(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), a;
            }();
            function x(e, t) {
                if (void 0 === e) throw "dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";
                for(var r = e.byteArray.length - 8; e.position <= r;)if (65534 === e.readUint16()) {
                    var a = e.readUint16();
                    if (57357 === a) return 0 !== e.readUint32() && e.warnings("encountered non zero length following item delimiter at position ".concat(e.position - 4, " while reading element of undefined length with tag ").concat(t.tag)), void (t.length = e.position - t.dataOffset);
                }
                t.length = e.byteArray.length - t.dataOffset, e.seek(e.byteArray.length - e.position);
            }
            var E = function(e, t) {
                if (void 0 !== e.vr) return "SQ" === e.vr;
                if (t.position + 4 <= t.byteArray.length) {
                    e = h(t);
                    return t.seek(-4), "xfffee000" === e || "xfffee0dd" === e;
                }
                return t.warnings.push("eof encountered before finding sequence item tag or sequence delimiter tag in peeking to determine VR"), !1;
            };
            function A(e, t, r) {
                if (void 0 === e) throw "dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";
                var a = h(e), a = {
                    tag: a,
                    vr: void 0 !== r ? r(a) : void 0,
                    length: e.readUint32(),
                    dataOffset: e.position
                };
                return 4294967295 === a.length && (a.hadUndefinedLength = !0), a.tag === t || (!E(a, e) || f(a.tag) && !a.hadUndefinedLength ? a.hadUndefinedLength ? x(e, a) : e.seek(a.length) : (F(e, a, r), f(a.tag) && (a.items = void 0))), a;
            }
            function S(e) {
                if (void 0 === e) throw "dicomParser.readSequenceItem: missing required parameter 'byteStream'";
                var t = {
                    tag: h(e),
                    length: e.readUint32(),
                    dataOffset: e.position
                };
                if ("xfffee000" !== t.tag) throw "dicomParser.readSequenceItem: item tag (FFFE,E000) not found at offset ".concat(e.position);
                return t;
            }
            function D(e, t) {
                var r = S(e);
                return 4294967295 === r.length ? (r.hadUndefinedLength = !0, r.dataSet = function(e, t) {
                    for(var r = {}; e.position < e.byteArray.length;){
                        var a = A(e, void 0, t);
                        if ("xfffee00d" === (r[a.tag] = a).tag) return new w(e.byteArrayParser, e.byteArray, r);
                    }
                    return e.warnings.push("eof encountered before finding sequence item delimiter in sequence item of undefined length"), new w(e.byteArrayParser, e.byteArray, r);
                }(e, t), r.length = e.position - r.dataOffset) : (r.dataSet = new w(e.byteArrayParser, e.byteArray, {}), T(r.dataSet, e, e.position + r.length, {
                    vrCallback: t
                })), r;
            }
            function F(e, t, r) {
                if (void 0 === e) throw "dicomParser.readSequenceItemsImplicit: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.readSequenceItemsImplicit: missing required parameter 'element'";
                t.items = [], (4294967295 === t.length ? function(e, t, r) {
                    for(; e.position + 4 <= e.byteArray.length;){
                        var a = h(e);
                        if (e.seek(-4), "xfffee0dd" === a) return t.length = e.position - t.dataOffset, e.seek(8);
                        a = D(e, r);
                        t.items.push(a);
                    }
                    e.warnings.push("eof encountered before finding sequence delimiter in sequence of undefined length"), t.length = e.byteArray.length - t.dataOffset;
                } : function(e, t, r) {
                    for(var a = t.dataOffset + t.length; e.position < a;){
                        var n = D(e, r);
                        t.items.push(n);
                    }
                })(e, t, r);
            }
            function O(e, t) {
                var r = S(e);
                return 4294967295 === r.length ? (r.hadUndefinedLength = !0, r.dataSet = function(e, t) {
                    for(var r = {}; e.position < e.byteArray.length;){
                        var a = B(e, t);
                        if ("xfffee00d" === (r[a.tag] = a).tag) return new w(e.byteArrayParser, e.byteArray, r);
                    }
                    return t.push("eof encountered before finding item delimiter tag while reading sequence item of undefined length"), new w(e.byteArrayParser, e.byteArray, r);
                }(e, t), r.length = e.position - r.dataOffset) : (r.dataSet = new w(e.byteArrayParser, e.byteArray, {}), q(r.dataSet, e, e.position + r.length)), r;
            }
            function I(e, t, r) {
                if (void 0 === e) throw "dicomParser.readSequenceItemsExplicit: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.readSequenceItemsExplicit: missing required parameter 'element'";
                t.items = [], (4294967295 === t.length ? function(e, t, r) {
                    for(; e.position + 4 <= e.byteArray.length;){
                        var a = h(e);
                        if (e.seek(-4), "xfffee0dd" === a) return t.length = e.position - t.dataOffset, e.seek(8);
                        a = O(e, r);
                        t.items.push(a);
                    }
                    r.push("eof encountered before finding sequence delimitation tag while reading sequence of undefined length"), t.length = e.position - t.dataOffset;
                } : function(e, t, r) {
                    for(var a = t.dataOffset + t.length; e.position < a;){
                        var n = O(e, r);
                        t.items.push(n);
                    }
                })(e, t, r);
            }
            var U = function(e) {
                return "OB" === e || "OD" === e || "OL" === e || "OW" === e || "SQ" === e || "OF" === e || "UC" === e || "UR" === e || "UT" === e || "UN" === e ? 4 : 2;
            };
            function B(e, t, r) {
                if (void 0 === e) throw "dicomParser.readDicomElementExplicit: missing required parameter 'byteStream'";
                var a = {
                    tag: h(e),
                    vr: e.readFixedString(2)
                };
                return 2 === U(a.vr) ? a.length = e.readUint16() : (e.seek(2), a.length = e.readUint32()), a.dataOffset = e.position, 4294967295 === a.length && (a.hadUndefinedLength = !0), a.tag === r || ("SQ" === a.vr ? I(e, a, t) : 4294967295 === a.length ? "x7fe00010" === a.tag ? g(e, a, t) : ("UN" === a.vr ? F : x)(e, a) : e.seek(a.length)), a;
            }
            function q(e, t, r) {
                var a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
                if (r = void 0 === r ? t.byteArray.length : r, void 0 === t) throw "dicomParser.parseDicomDataSetExplicit: missing required parameter 'byteStream'";
                if (r < t.position || r > t.byteArray.length) throw "dicomParser.parseDicomDataSetExplicit: invalid value for parameter 'maxP osition'";
                for(var n = e.elements; t.position < r;){
                    var i = B(t, e.warnings, a.untilTag);
                    if ((n[i.tag] = i).tag === a.untilTag) return;
                }
                if (t.position > r) throw "dicomParser:parseDicomDataSetExplicit: buffer overrun";
            }
            function T(e, t, r) {
                var a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
                if (r = void 0 === r ? e.byteArray.length : r, void 0 === t) throw "dicomParser.parseDicomDataSetImplicit: missing required parameter 'byteStream'";
                if (r < t.position || r > t.byteArray.length) throw "dicomParser.parseDicomDataSetImplicit: invalid value for parameter 'maxPosition'";
                for(var n = e.elements; t.position < r;){
                    var i = A(t, a.untilTag, a.vrCallback);
                    if ((n[i.tag] = i).tag === a.untilTag) return;
                }
            }
            function k(e, t) {
                if ("undefined" != typeof $937ae3202df95507$require$Buffer && e instanceof $937ae3202df95507$require$Buffer) return $937ae3202df95507$require$Buffer.alloc(t);
                if (e instanceof Uint8Array) return new Uint8Array(t);
                throw "dicomParser.alloc: unknown type for byteArray";
            }
            var L = "1.8.12", N = {
                readUint16: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readUint16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "bigEndianByteArrayParser.readUint16: attempt to read past end of buffer";
                    return (e[t] << 8) + e[t + 1];
                },
                readInt16: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readInt16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "bigEndianByteArrayParser.readInt16: attempt to read past end of buffer";
                    t = (e[t] << 8) + e[t + 1];
                    return t = 32768 & t ? t - 65535 - 1 : t;
                },
                readUint32: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readUint32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readUint32: attempt to read past end of buffer";
                    return 256 * (256 * (256 * e[t] + e[t + 1]) + e[t + 2]) + e[t + 3];
                },
                readInt32: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readInt32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readInt32: attempt to read past end of buffer";
                    return (e[t] << 24) + (e[t + 1] << 16) + (e[t + 2] << 8) + e[t + 3];
                },
                readFloat: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readFloat: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readFloat: attempt to read past end of buffer";
                    var r = new Uint8Array(4);
                    return r[3] = e[t], r[2] = e[t + 1], r[1] = e[t + 2], r[0] = e[t + 3], new Float32Array(r.buffer)[0];
                },
                readDouble: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readDouble: position cannot be less than 0";
                    if (t + 8 > e.length) throw "bigEndianByteArrayParser.readDouble: attempt to read past end of buffer";
                    var r = new Uint8Array(8);
                    return r[7] = e[t], r[6] = e[t + 1], r[5] = e[t + 2], r[4] = e[t + 3], r[3] = e[t + 4], r[2] = e[t + 5], r[1] = e[t + 6], r[0] = e[t + 7], new Float64Array(r.buffer)[0];
                }
            };
            function j(e, t, r) {
                if ("undefined" != typeof $937ae3202df95507$require$Buffer && e instanceof $937ae3202df95507$require$Buffer) return e.slice(t, t + r);
                if (e instanceof Uint8Array) return new Uint8Array(e.buffer, e.byteOffset + t, r);
                throw "dicomParser.from: unknown type for byteArray";
            }
            function C(e, t) {
                for(var r = 0; r < t.length; r++){
                    var a = t[r];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                }
            }
            var J = function() {
                function a(e, t, r) {
                    if (!function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), void 0 === e) throw "dicomParser.ByteStream: missing required parameter 'byteArrayParser'";
                    if (void 0 === t) throw "dicomParser.ByteStream: missing required parameter 'byteArray'";
                    if (t instanceof Uint8Array == !1 && ("undefined" == typeof $937ae3202df95507$require$Buffer || t instanceof $937ae3202df95507$require$Buffer == !1)) throw "dicomParser.ByteStream: parameter byteArray is not of type Uint8Array or Buffer";
                    if (r < 0) throw "dicomParser.ByteStream: parameter 'position' cannot be less than 0";
                    if (r >= t.length) throw "dicomParser.ByteStream: parameter 'position' cannot be greater than or equal to 'byteArray' length";
                    this.byteArrayParser = e, this.byteArray = t, this.position = r || 0, this.warnings = [];
                }
                var e, t, r;
                return e = a, t = [
                    {
                        key: "seek",
                        value: function(e) {
                            if (this.position + e < 0) throw "dicomParser.ByteStream.prototype.seek: cannot seek to position < 0";
                            this.position += e;
                        }
                    },
                    {
                        key: "readByteStream",
                        value: function(e) {
                            if (this.position + e > this.byteArray.length) throw "dicomParser.ByteStream.prototype.readByteStream: readByteStream - buffer overread";
                            var t = j(this.byteArray, this.position, e);
                            return this.position += e, new a(this.byteArrayParser, t);
                        }
                    },
                    {
                        key: "getSize",
                        value: function() {
                            return this.byteArray.length;
                        }
                    },
                    {
                        key: "readUint16",
                        value: function() {
                            var e = this.byteArrayParser.readUint16(this.byteArray, this.position);
                            return this.position += 2, e;
                        }
                    },
                    {
                        key: "readUint32",
                        value: function() {
                            var e = this.byteArrayParser.readUint32(this.byteArray, this.position);
                            return this.position += 4, e;
                        }
                    },
                    {
                        key: "readFixedString",
                        value: function(e) {
                            var t = b(this.byteArray, this.position, e);
                            return this.position += e, t;
                        }
                    }
                ], C(e.prototype, t), r && C(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), a;
            }(), M = {
                readUint16: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readUint16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "littleEndianByteArrayParser.readUint16: attempt to read past end of buffer";
                    return e[t] + 256 * e[t + 1];
                },
                readInt16: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readInt16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "littleEndianByteArrayParser.readInt16: attempt to read past end of buffer";
                    t = e[t] + (e[t + 1] << 8);
                    return t = 32768 & t ? t - 65535 - 1 : t;
                },
                readUint32: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readUint32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readUint32: attempt to read past end of buffer";
                    return e[t] + 256 * e[t + 1] + 256 * e[t + 2] * 256 + 256 * e[t + 3] * 65536;
                },
                readInt32: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readInt32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readInt32: attempt to read past end of buffer";
                    return e[t] + (e[t + 1] << 8) + (e[t + 2] << 16) + (e[t + 3] << 24);
                },
                readFloat: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readFloat: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readFloat: attempt to read past end of buffer";
                    var r = new Uint8Array(4);
                    return r[0] = e[t], r[1] = e[t + 1], r[2] = e[t + 2], r[3] = e[t + 3], new Float32Array(r.buffer)[0];
                },
                readDouble: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readDouble: position cannot be less than 0";
                    if (t + 8 > e.length) throw "littleEndianByteArrayParser.readDouble: attempt to read past end of buffer";
                    var r = new Uint8Array(8);
                    return r[0] = e[t], r[1] = e[t + 1], r[2] = e[t + 2], r[3] = e[t + 3], r[4] = e[t + 4], r[5] = e[t + 5], r[6] = e[t + 6], r[7] = e[t + 7], new Float64Array(r.buffer)[0];
                }
            };
            function G(e) {
                var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                if (void 0 === e) throw "dicomParser.readPart10Header: missing required parameter 'byteArray'";
                var o = i.TransferSyntaxUID, s = new J(M, e);
                return function() {
                    var e = function() {
                        if (s.getSize() <= 132 && o) return !1;
                        if (s.seek(128), "DICM" === s.readFixedString(4)) return !0;
                        if (!(i || {}).TransferSyntaxUID) throw "dicomParser.readPart10Header: DICM prefix not found at location 132 - this is not a valid DICOM P10 file.";
                        return s.seek(0), !1;
                    }(), t = [], r = {};
                    if (!e) return s.position = 0, {
                        elements: {
                            x00020010: {
                                tag: "x00020010",
                                vr: "UI",
                                Value: o
                            }
                        },
                        warnings: t
                    };
                    for(; s.position < s.byteArray.length;){
                        var a = s.position, n = B(s, t);
                        if ("x0002ffff" < n.tag) {
                            s.position = a;
                            break;
                        }
                        n.parser = M, r[n.tag] = n;
                    }
                    return (e = new w(s.byteArrayParser, s.byteArray, r)).warnings = s.warnings, e.position = s.position, e;
                }();
            }
            var z = "1.2.840.10008.1.2.2";
            function V(i) {
                var o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                if (void 0 === i) throw new Error("dicomParser.parseDicom: missing required parameter 'byteArray'");
                var e, a = function(e) {
                    if (void 0 === e.elements.x00020010) throw new Error("dicomParser.parseDicom: missing required meta header attribute 0002,0010");
                    e = e.elements.x00020010;
                    return e && e.Value || b(i, e.dataOffset, e.length);
                };
                function t(t) {
                    var e = a(t), r = "1.2.840.10008.1.2" !== e, e = function(e, t) {
                        var r = "[object process]" === Object.prototype.toString.call(0);
                        if ("1.2.840.10008.1.2.1.99" !== e) return new J(e === z ? N : M, i, t);
                        if (o && o.inflater) {
                            e = o.inflater(i, t);
                            return new J(M, e, 0);
                        }
                        if (!0 == r) {
                            var a = s(0), n = j(i, t, i.length - t), a = a.inflateRawSync(n), n = k(i, a.length + t);
                            return i.copy(n, 0, 0, t), a.copy(n, t), new J(M, n, 0);
                        }
                        if ("undefined" == typeof pako) throw "dicomParser.parseDicom: no inflater available to handle deflate transfer syntax";
                        return a = i.slice(t), n = pako.inflateRaw(a), (a = k(i, n.length + t)).set(i.slice(0, t), 0), a.set(n, t), new J(M, a, 0);
                    }(e, t.position), t = new w(e.byteArrayParser, e.byteArray, {});
                    t.warnings = e.warnings;
                    try {
                        (r ? q : T)(t, e, e.byteArray.length, o);
                    } catch (e) {
                        throw {
                            exception: e,
                            dataSet: t
                        };
                    }
                    return t;
                }
                return function(e, t) {
                    for(var r in e.elements)e.elements.hasOwnProperty(r) && (t.elements[r] = e.elements[r]);
                    return void 0 !== e.warnings && (t.warnings = e.warnings.concat(t.warnings)), t;
                }(e = G(i, o), t(e));
            }
            var R = function(e, t, r) {
                for(var a = 0, n = t; n < t + r; n++)a += e[n].length;
                return a;
            };
            function _(e, t, r, a, n) {
                if (n = n || t.fragments, void 0 === e) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'pixelDataElement'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'startFragmentIndex'";
                if (void 0 === (a = a || 1)) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'numFragments'";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (t.fragments.length <= 0) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (r < 0) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be >= 0";
                if (r >= t.fragments.length) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be < number of fragments";
                if (a < 1) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'numFragments' must be > 0";
                if (r + a > t.fragments.length) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragment' + 'numFragments' < number of fragments";
                var i = new J(e.byteArrayParser, e.byteArray, t.dataOffset), t = S(i);
                if ("xfffee000" !== t.tag) throw "dicomParser.readEncapsulatedPixelData: missing basic offset table xfffee000";
                i.seek(t.length);
                var o = i.position;
                if (1 === a) return j(i.byteArray, o + n[r].offset + 8, n[r].length);
                for(var t = R(n, r, a), s = k(i.byteArray, t), d = 0, f = r; f < r + a; f++)for(var l = o + n[f].offset + 8, u = 0; u < n[f].length; u++)s[d++] = i.byteArray[l++];
                return s;
            }
            var H = function(e, t) {
                for(var r = 0; r < e.length; r++)if (e[r].offset === t) return r;
            }, Q = function(e, t, r, a) {
                if (e === t.length - 1) return r.length - a;
                for(var n = t[e + 1], i = a + 1; i < r.length; i++)if (r[i].offset === n) return i - a;
                throw "dicomParser.calculateNumberOfFragmentsForFrame: could not find fragment with offset matching basic offset table";
            };
            function W(e, t, r, a, n) {
                if (a = a || t.basicOffsetTable, n = n || t.fragments, void 0 === e) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'pixelDataElement'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'frameIndex'";
                if (void 0 === a) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' does not have basicOffsetTable";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010)";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have undefined length";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have fragments";
                if (0 === a.length) throw "dicomParser.readEncapsulatedImageFrame: basicOffsetTable has zero entries";
                if (r < 0) throw "dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be >= 0";
                if (r >= a.length) throw "dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be < basicOffsetTable.length";
                var i = a[r], i = H(n, i);
                if (void 0 === i) throw "dicomParser.readEncapsulatedImageFrame: unable to find fragment that matches basic offset table entry";
                return _(e, t, i, Q(r, a, n, i), n);
            }
            var $ = !1;
            function K(e, t, r) {
                if ($ || ($ = !0, console && console.log && console.log("WARNING: dicomParser.readEncapsulatedPixelData() has been deprecated")), void 0 === e) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'element'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'frame'";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to non pixel data tag (expected tag = x7fe00010)";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (r < 0) throw "dicomParser.readEncapsulatedPixelData: parameter 'frame' must be >= 0";
                return 0 !== t.basicOffsetTable.length ? W(e, t, r) : _(e, t, 0, t.fragments.length);
            }
            t.default = {
                isStringVr: d,
                isPrivateTag: f,
                parsePN: a,
                parseTM: n,
                parseDA: o,
                explicitElementToString: l,
                explicitDataSetToJS: u,
                createJPEGBasicOffsetTable: p,
                parseDicomDataSetExplicit: q,
                parseDicomDataSetImplicit: T,
                readFixedString: b,
                alloc: k,
                version: L,
                bigEndianByteArrayParser: N,
                ByteStream: J,
                sharedCopy: j,
                DataSet: w,
                findAndSetUNElementLength: y,
                findEndOfEncapsulatedElement: g,
                findItemDelimitationItemAndSetElementLength: x,
                littleEndianByteArrayParser: M,
                parseDicom: V,
                readDicomElementExplicit: B,
                readDicomElementImplicit: A,
                readEncapsulatedImageFrame: W,
                readEncapsulatedPixelData: K,
                readEncapsulatedPixelDataFromFragments: _,
                readPart10Header: G,
                readSequenceItemsExplicit: I,
                readSequenceItemsImplicit: F,
                readSequenceItem: S,
                readTag: h,
                LEI: "1.2.840.10008.1.2",
                LEE: "1.2.840.10008.1.2.1"
            };
        }
    ], i = {}, n.m = a, n.c = i, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var a in t)n.d(r, a, (function(e) {
            return t[e];
        }).bind(null, a));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
    function n(e) {
        if (i[e]) return i[e].exports;
        var t = i[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return a[e].call(t.exports, t, t.exports, n), t.l = !0, t.exports;
    }
});

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("gDDAu", function(module, exports) {
module.exports = import("eYTu9").then(()=>parcelRequire('eNok6'));

});

parcelRegister("aRAFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7191d404a5f3bf70$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7191d404a5f3bf70$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
];
const $7191d404a5f3bf70$export$2e2bcd8739ae039 = (0, $9QBug.default)("chart-line", $7191d404a5f3bf70$export$3efd853dbb351e94);

});

parcelRegister("2VplL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6117d2af5e6ea38b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6117d2af5e6ea38b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m13.5 8.5-5 5",
            key: "1cs55j"
        }
    ],
    [
        "path",
        {
            d: "m8.5 8.5 5 5",
            key: "a8mexj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
];
const $6117d2af5e6ea38b$export$2e2bcd8739ae039 = (0, $9QBug.default)("search-x", $6117d2af5e6ea38b$export$3efd853dbb351e94);

});

parcelRegister("ljvFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e5fcd5ed76b0a6f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9e5fcd5ed76b0a6f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
            key: "mvr1a0"
        }
    ],
    [
        "path",
        {
            d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27",
            key: "auskq0"
        }
    ]
];
const $9e5fcd5ed76b0a6f$export$2e2bcd8739ae039 = (0, $9QBug.default)("heart-pulse", $9e5fcd5ed76b0a6f$export$3efd853dbb351e94);

});

parcelRegister("i7Rt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b885961d6f223caf$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b885961d6f223caf$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M17 14h-6",
            key: "bkmgh3"
        }
    ],
    [
        "path",
        {
            d: "M13 18H7",
            key: "bb0bb7"
        }
    ],
    [
        "path",
        {
            d: "M7 14h.01",
            key: "1qa3f1"
        }
    ],
    [
        "path",
        {
            d: "M17 18h.01",
            key: "1bdyru"
        }
    ]
];
const $b885961d6f223caf$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar-range", $b885961d6f223caf$export$3efd853dbb351e94);

});

parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $040dbb9c344a508d$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $7939e29d663dd3ed$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("l37hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dfd9db3a50f7eb1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7dfd9db3a50f7eb1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
];
const $7dfd9db3a50f7eb1$export$2e2bcd8739ae039 = (0, $9QBug.default)("wallet", $7dfd9db3a50f7eb1$export$3efd853dbb351e94);

});

parcelRegister("6YS1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $86bc9f94aec05e0c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $86bc9f94aec05e0c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $86bc9f94aec05e0c$export$2e2bcd8739ae039 = (0, $9QBug.default)("user-round", $86bc9f94aec05e0c$export$3efd853dbb351e94);

});

parcelRegister("3SiwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e976e543b929c4c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8e976e543b929c4c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473",
            key: "ol2ft2"
        }
    ],
    [
        "path",
        {
            d: "m16.5 3.5 5 5",
            key: "15e6fa"
        }
    ],
    [
        "path",
        {
            d: "m21.5 3.5-5 5",
            key: "m0lwru"
        }
    ]
];
const $8e976e543b929c4c$export$2e2bcd8739ae039 = (0, $9QBug.default)("funnel-x", $8e976e543b929c4c$export$3efd853dbb351e94);

});

parcelRegister("O6OQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa913da585dd100$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ffa913da585dd100$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
            key: "18887p"
        }
    ]
];
const $ffa913da585dd100$export$2e2bcd8739ae039 = (0, $9QBug.default)("message-square", $ffa913da585dd100$export$3efd853dbb351e94);

});

parcelRegister("8gMKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf1fbadf27297cb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9bf1fbadf27297cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const $9bf1fbadf27297cb$export$2e2bcd8739ae039 = (0, $9QBug.default)("package", $9bf1fbadf27297cb$export$3efd853dbb351e94);

});

parcelRegister("6ed2x", function(module, exports) {
module.exports = import("7KWdT").then(()=>parcelRequire('eUo5r'));

});

parcelRegister("2eb5d", function(module, exports) {
module.exports = import("1spe4").then(()=>parcelRequire('kY2KV'));

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $eLeza = parcelRequire("eLeza");

var $e317r = parcelRequire("e317r");
// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so the same image serves every environment. process.env is
// the Parcel build-time fallback (baked in via the Dockerfile ARG) for local dev
// and any image built before the runtime mechanism existed.
const $d87bd335296b449f$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $d87bd335296b449f$export$bb117bdb9f34de64 = $d87bd335296b449f$var$runtime.BFF_URL || "https://api.parsinabot.ir/graphql";
const $d87bd335296b449f$export$d8ff6422767fc83a = $d87bd335296b449f$export$bb117bdb9f34de64.replace(/^https/, 'wss').replace(/^http/, 'ws').replace('/graphql', '');
const $d87bd335296b449f$export$91dbb4a8660769db = $d87bd335296b449f$var$runtime.KEYCLOAK_URL || $d87bd335296b449f$var$runtime.PARSINA_KC_BASE_URL || undefined || 'https://sso.itechtrade.ir';
// ── Keycloak identity: realm, client, roles client ──────────────────────────
// Which realm this panel signs in to, which client it signs in as, and which
// client's roles the BFFs read off the token. Parsina's own values are the
// fallbacks, so an image run with none of these set signs in exactly as before;
// a deployment on another realm sets them at container start, same image.
//
// Each lookup takes the first value that is set: the brand-neutral name in
// env.js, the legacy PARSINA_* name in env.js, what the image was built with,
// today's literal. docker-entrypoint.sh writes these keys only when they are
// set, so "nothing set" really does reach the build-time value.
//
// Read on every call, not once at load like the values above: what decides is
// the env.js of the page that is running, and a test can set its own.
const $d87bd335296b449f$var$runtimeNow = ()=>typeof window !== 'undefined' && window.__ENV__ || {};
function $d87bd335296b449f$export$75000a7ae96cb4e() {
    const value = String($d87bd335296b449f$var$runtimeNow().GIFT_CODES || '').trim().toLowerCase();
    return value !== 'off' && value !== 'false' && value !== '0';
}
function $d87bd335296b449f$export$982c4c4b626b71dc() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_REALM || env.PARSINA_KC_REALM || undefined || undefined || 'parsina';
}
function $d87bd335296b449f$export$7769b0c1484b082d() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_CLIENT_ID || env.PARSINA_KC_CLIENT_ID || "parsina-doctor";
}
function $d87bd335296b449f$export$c49a86c673af918f() {
    return $d87bd335296b449f$var$runtimeNow().KEYCLOAK_BFF_CLIENT_ID || 'parsina-bff';
}
const $d87bd335296b449f$export$ce4d22a853fad121 = ($d87bd335296b449f$var$runtime.CLINIC_APP_URL || undefined || 'https://clinic.parsinabot.ir').replace(/\/+$/, '');
// ── The map in «صفحهٔ من» › اطلاعات مطب ─────────────────────────────────────
// The same two settings, defaults and validation as the clinic panel's
// LocationPicker (clinic-app src/lib/runtimeEnv.js), so one mirror serves both.
//
// MAP_TILE_URL  the Leaflet tile template. A value without {z}/{x}/{y} is not a
//               tile template and falls back to the default instead of drawing
//               grey squares (an entrypoint once truncated it to "https://{s").
// MAP_LIB_BASE  where leaflet.js/.css are loaded from, at runtime: the map is
//               optional, and a library most sessions never open should not
//               sit in the entry bundle. Overridable for a network that cannot
//               reach the CDN.
const $d87bd335296b449f$var$isTileTemplate = (v)=>typeof v === 'string' && /\{z\}/.test(v) && /\{x\}/.test(v) && /\{y\}/.test(v);
const $d87bd335296b449f$export$78f3b16823fa1002 = [
    $d87bd335296b449f$var$runtime.MAP_TILE_URL,
    undefined
].find($d87bd335296b449f$var$isTileTemplate) || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const $d87bd335296b449f$export$dbbae022d435eb02 = ($d87bd335296b449f$var$runtime.MAP_LIB_BASE || undefined || 'https://unpkg.com/leaflet@1.9.4/dist').replace(/\/+$/, '');
const $d87bd335296b449f$export$5aec0b605bf1c5bb = ($d87bd335296b449f$var$runtime.ACCOUNT_APP_URL || undefined || 'https://account.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$cce6d3603c0b63d(section = '/') {
    const back = typeof window !== 'undefined' ? window.location.origin : '';
    const path = section.startsWith('/') ? section : `/${section}`;
    return `${$d87bd335296b449f$export$5aec0b605bf1c5bb}${path}${back ? `?return_url=${encodeURIComponent(back)}` : ''}`;
}


// OIDC Authorization Code + PKCE flow for Keycloak

var $eLeza = parcelRequire("eLeza");

// Storage half of `phiSearch.js`, with no React in it, so boot code (auth.js)
// can clear it on sign-out. See phiSearch.js for why search terms live here
// rather than in the URL.
const $0694d51df2baaf30$export$c8f905688ad77381 = 'parsina.search.';
function $0694d51df2baaf30$export$a715a88d17f75e81(key) {
    try {
        return sessionStorage.getItem($0694d51df2baaf30$export$c8f905688ad77381 + key) || '';
    } catch  {
        return '';
    }
}
function $0694d51df2baaf30$export$970916b3799c92c9(key, value) {
    try {
        if (value) sessionStorage.setItem($0694d51df2baaf30$export$c8f905688ad77381 + key, value);
        else sessionStorage.removeItem($0694d51df2baaf30$export$c8f905688ad77381 + key);
    } catch  {}
}
function $0694d51df2baaf30$export$829f62d88ad834c2() {
    try {
        Object.keys(sessionStorage).filter((k)=>k.startsWith($0694d51df2baaf30$export$c8f905688ad77381)).forEach((k)=>sessionStorage.removeItem(k));
    } catch  {}
}


// The realm's URL, resolved on every call like the client id (kcClientId()):
// both come from the deployment, and runtimeEnv.js says in which order.
const $3bdb28763df76ec7$var$kcBase = ()=>`${0, $d87bd335296b449f$export$91dbb4a8660769db}/realms/${encodeURIComponent((0, $d87bd335296b449f$export$982c4c4b626b71dc)())}`;
// Always derived at call time so redirect_uri is consistent across
// the auth request and token exchange even if the page reloads.
function $3bdb28763df76ec7$var$getRedirectUri() {
    return `${window.location.origin}/`;
}
// ── Login language ───────────────────────────────────────────────────────────
// The sign-in screen — and, more importantly, every error Keycloak resolves
// server-side before the theme ever runs — follows the language the panel is
// in. Without this the realm picks for itself, so a doctor working in Persian
// could be sent to an English login page and shown English errors on it.
//
// `<html lang>` is the live panel language: index.html's inline bootstrap sets
// it from the cached choice before this module is even parsed, and I18nProvider
// keeps it current after that. Read here rather than imported from the i18n module so
// this stays a leaf module with no React dependency.
//
// Both parameters are sent on purpose: `ui_locales` is the OIDC standard hint,
// `kc_locale` is the one Keycloak acts on — it also sets the KEYCLOAK_LOCALE
// cookie, which is what carries the language through the rest of the flow
// (password step, OTP step, any required action) rather than just the first page.
// Deliberately NOT the panel's locale list. The panel also ships Arabic, but
// the Keycloak login theme does not — it carries `fa` and `en` message bundles
// only (parsina.keycloakify, IMPROVED_LANGUAGE_TAGS). Sending `kc_locale=ar` to
// a realm with no Arabic gets a login page half in Keycloak's own fallback,
// which is worse than a coherent Persian one. So an Arabic panel signs in
// through the Persian login screen until the theme grows an `ar` bundle; add
// 'ar' here on the same day that lands, and not before.
//
// A deployment's brand (docs/rebranding/CONTRACT.md) narrows the list to the
// languages it offers and names the fallback: a brand without Persian signs an
// Arabic panel in through its own default language, never through Persian.
// With no brand this is the list above and Persian, exactly as before. The
// brand's helpers are dependency-free, so this module stays a leaf.
const $3bdb28763df76ec7$var$LOGIN_LOCALES = [
    'fa',
    'en'
];
function $3bdb28763df76ec7$export$616b226114932e4d() {
    const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    return (0, $eLeza.brandLocales)($3bdb28763df76ec7$var$LOGIN_LOCALES).includes(lang) ? lang : (0, $eLeza.brandDefaultLocale)('fa', $3bdb28763df76ec7$var$LOGIN_LOCALES);
}
// ── PKCE helpers ─────────────────────────────────────────────────────────────
function $3bdb28763df76ec7$var$randomBytes(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return arr;
}
function $3bdb28763df76ec7$var$base64url(buf) {
    return btoa(String.fromCharCode(...buf)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
async function $3bdb28763df76ec7$var$sha256(str) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return new Uint8Array(buf);
}
async function $3bdb28763df76ec7$var$generateChallenge(verifier) {
    return $3bdb28763df76ec7$var$base64url(await $3bdb28763df76ec7$var$sha256(verifier));
}
// ── Token storage ─────────────────────────────────────────────────────────────
// A sign-in lasts as long as Keycloak's refresh token — 30 days on beta1 — not
// as long as one tab (PM-0158). The REFRESH token and the id token (the logout
// hint) live in localStorage, so a new tab, a reopened browser or a Chrome that
// Android killed in the background signs in silently from them. The 5-minute
// ACCESS token stays per tab. Before this, all three lived in sessionStorage and
// every new tab or browser restart threw a valid 30-day token away and sent the
// user to the login form. A copy left in sessionStorage by an older build is
// still read, so a tab open across the deploy keeps working.
const $3bdb28763df76ec7$var$PERSISTED = [
    'kc_refresh',
    'kc_id_token'
];
function $3bdb28763df76ec7$var$durable() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$var$readPersisted(key) {
    try {
        const v = $3bdb28763df76ec7$var$durable()?.getItem(key);
        if (v) return v;
    } catch  {}
    return sessionStorage.getItem(key);
}
function $3bdb28763df76ec7$export$257b2d10b709d8ef() {
    return sessionStorage.getItem('kc_token');
}
function $3bdb28763df76ec7$export$c8736e6c4fef498e() {
    return $3bdb28763df76ec7$var$readPersisted('kc_refresh');
}
function $3bdb28763df76ec7$export$393ade1005606e67() {
    return $3bdb28763df76ec7$var$readPersisted('kc_id_token');
}
function $3bdb28763df76ec7$var$saveTokens(token, refresh, idToken) {
    sessionStorage.setItem('kc_token', token);
    const pairs = [
        [
            'kc_refresh',
            refresh
        ],
        [
            'kc_id_token',
            idToken
        ]
    ].filter(([, v])=>v);
    try {
        const store = $3bdb28763df76ec7$var$durable();
        if (!store) throw new Error('no localStorage');
        pairs.forEach(([k, v])=>store.setItem(k, v));
        pairs.forEach(([k])=>sessionStorage.removeItem(k));
    } catch  {
        // Private mode or blocked storage: the tab still works, as it always did.
        pairs.forEach(([k, v])=>sessionStorage.setItem(k, v));
    }
}
function $3bdb28763df76ec7$export$67488bf92fa15f1e() {
    [
        'kc_token',
        'kc_refresh',
        'kc_id_token',
        'kc_verifier',
        'kc_state'
    ].forEach((k)=>sessionStorage.removeItem(k));
    try {
        $3bdb28763df76ec7$var$PERSISTED.forEach((k)=>$3bdb28763df76ec7$var$durable()?.removeItem(k));
    } catch  {}
}
// Keycloak ROTATES the refresh token. With it shared across tabs, two tabs
// refreshing at the same moment would present the same token twice and the
// second would be refused — and a refused refresh signs the user out. The
// browser's Web Locks serialise refreshes across every tab of this origin; each
// refresh reads the stored token inside the lock, so it uses the one the
// previous tab just received. Where Web Locks are missing, the per-tab
// single-flight below still holds.
async function $3bdb28763df76ec7$var$withRefreshLock(fn) {
    const locks = typeof navigator !== 'undefined' ? navigator.locks : null;
    if (!locks || typeof locks.request !== 'function') return fn();
    return locks.request('parsina-kc-refresh', ()=>fn());
}
// ── Redirect-loop guard ───────────────────────────────────────────────────────
// Records each redirect timestamp. If 3+ happen within 30 s, stops redirecting
// and lets the app render an error screen instead.
const $3bdb28763df76ec7$var$LOOP_KEY = 'kc_redirect_ts';
const $3bdb28763df76ec7$var$LOOP_LIMIT = 3;
const $3bdb28763df76ec7$var$LOOP_WIN = 30000; // ms
function $3bdb28763df76ec7$var$redirectAllowed() {
    const raw = sessionStorage.getItem($3bdb28763df76ec7$var$LOOP_KEY);
    const hist = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const recent = hist.filter((ts)=>now - ts < $3bdb28763df76ec7$var$LOOP_WIN);
    if (recent.length >= $3bdb28763df76ec7$var$LOOP_LIMIT) return false;
    sessionStorage.setItem($3bdb28763df76ec7$var$LOOP_KEY, JSON.stringify([
        ...recent,
        now
    ]));
    return true;
}
function $3bdb28763df76ec7$export$639ddbdf19445d0c() {
    sessionStorage.removeItem($3bdb28763df76ec7$var$LOOP_KEY);
}
async function $3bdb28763df76ec7$export$2fb87bbf5418dbe1() {
    if (!$3bdb28763df76ec7$var$redirectAllowed()) {
        // Too many consecutive redirects — surface the error to the user instead.
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/?auth_error=loop');
        window.location.reload();
        return;
    }
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256',
        ui_locales: $3bdb28763df76ec7$export$616b226114932e4d(),
        kc_locale: $3bdb28763df76ec7$export$616b226114932e4d()
    });
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/auth?${params}`;
}
async function $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('kc_verifier');
    const saved = sessionStorage.getItem('kc_state');
    // Keycloak returned an explicit error (access_denied, login_required, etc.)
    if (error) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/');
        return false;
    }
    // Missing or mismatched PKCE / state — don't retry immediately
    if (!code || !verifier || state !== saved) {
        window.history.replaceState({}, '', '/');
        return false;
    }
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
            redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
            code: code,
            code_verifier: verifier
        })
    });
    window.history.replaceState({}, '', '/');
    if (!res.ok) return false;
    const data = await res.json();
    if (!data.access_token) return false;
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    $3bdb28763df76ec7$export$639ddbdf19445d0c(); // successful auth — reset loop counter
    return true;
}
// In-flight refresh, shared by every caller.
//
// Keycloak rotates the refresh token, so the second concurrent refresh presents
// one the first already spent — Keycloak rejects it, clearTokens() fires, and the
// user is thrown to the login screen mid-task. Anything that fans out hits this:
// two queries in a Promise.all, or the DICOM viewer, which loads a whole series
// in parallel. Everyone waits on the same promise instead.
let $3bdb28763df76ec7$var$refreshInFlight = null;
async function $3bdb28763df76ec7$var$refreshAccessTokenInTab() {
    if ($3bdb28763df76ec7$var$refreshInFlight) return $3bdb28763df76ec7$var$refreshInFlight;
    $3bdb28763df76ec7$var$refreshInFlight = $3bdb28763df76ec7$var$doRefresh().finally(()=>{
        $3bdb28763df76ec7$var$refreshInFlight = null;
    });
    return $3bdb28763df76ec7$var$refreshInFlight;
}
async function $3bdb28763df76ec7$var$doRefresh() {
    const refresh = $3bdb28763df76ec7$export$c8736e6c4fef498e();
    if (!refresh) return false;
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
            refresh_token: refresh
        })
    });
    if (!res.ok) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    return true;
}
async function $3bdb28763df76ec7$export$51699064a8fe557f() {
    let token = $3bdb28763df76ec7$export$257b2d10b709d8ef();
    if (!token) return null;
    if ($3bdb28763df76ec7$export$b007d77a962aa175(token)) {
        if (!await $3bdb28763df76ec7$export$f8f36faf9a051362()) return null;
        token = $3bdb28763df76ec7$export$257b2d10b709d8ef();
    }
    return token;
}
function $3bdb28763df76ec7$export$a0973bcfe11b05c9() {
    const idToken = $3bdb28763df76ec7$export$393ade1005606e67();
    $3bdb28763df76ec7$export$67488bf92fa15f1e();
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    // Search terms can be patient names; they never outlive the session.
    (0, $0694d51df2baaf30$export$829f62d88ad834c2)();
    const params = new URLSearchParams({
        client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
        post_logout_redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        ui_locales: $3bdb28763df76ec7$export$616b226114932e4d(),
        kc_locale: $3bdb28763df76ec7$export$616b226114932e4d()
    });
    if (idToken) params.set('id_token_hint', idToken);
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/logout?${params}`;
}
function $3bdb28763df76ec7$export$83cd1f1503eb19c0(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$export$b007d77a962aa175(token) {
    const p = $3bdb28763df76ec7$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}
function $3bdb28763df76ec7$export$f8f36faf9a051362() {
    return $3bdb28763df76ec7$var$withRefreshLock(()=>$3bdb28763df76ec7$var$refreshAccessTokenInTab());
}


// The brand, before anything else (docs/rebranding/CONTRACT.md): the product's
// name, its credit's name, the languages offered, the calendar and the market.
// The deployment hands it over as env.js's BRAND_B64; without one this is a
// no-op and the panel is Parsina, byte for byte. It is read once, here, because
// App.jsx imports this module first — before the first render and before the
// clinical module, the translator and the date pickers ask for it. The three
// modules imported above read the brand only when called, never while loading.
(0, $eLeza.configureBrandFromEnv)();
// The doctor panel as a HOST of the clinical module (docs/CLINICAL_KIT_DESIGN.md).
//
// The visit room and the patient record live in @parsina/framework/clinical so
// the clinic panel can render the same ones. What they need from whichever panel
// renders them is configured here, once, before the first screen mounts — App.jsx
// imports this module first for exactly that reason.
//
// The doctor panel's own BFF, and its own sign-in: nothing about the doctor
// panel's behaviour changes by being a host. The per-render half (navigation,
// the current path) is <ClinicalHostProvider> in App.jsx's AppShell.
(0, $e317r.configureClinical)({
    bffUrl: (0, $d87bd335296b449f$export$bb117bdb9f34de64),
    wsBase: (0, $d87bd335296b449f$export$d8ff6422767fc83a),
    auth: {
        getToken: $3bdb28763df76ec7$export$257b2d10b709d8ef,
        getRefresh: $3bdb28763df76ec7$export$c8736e6c4fef498e,
        getValidToken: $3bdb28763df76ec7$export$51699064a8fe557f,
        refreshAccessToken: $3bdb28763df76ec7$export$f8f36faf9a051362,
        logout: $3bdb28763df76ec7$export$a0973bcfe11b05c9,
        parseJwt: $3bdb28763df76ec7$export$83cd1f1503eb19c0,
        isTokenExpired: $3bdb28763df76ec7$export$b007d77a962aa175
    }
});


/**
 * @parsina/framework/clinical — the Visit and Patient Details experience, shared
 * by the doctor panel and the clinic panel.
 *
 * A host does three things (docs/CLINICAL_KIT_DESIGN.md):
 *
 *   1. configureClinical({ bffUrl, auth, activeClinicId })   once, at boot
 *   2. <ClinicalHostProvider navigate back pathname           around its routes
 *        clinicCurrency>                                      (optional: the visit's
 *      clinic's ISO 4217 code — a non-IRR one hides the Iranian insurer rails)
 *   3. <ClinicalI18n language>                               around the screens,
 *      then render <VisitScreen patient> / <PatientDetailScreen patient tab …>
 *
 * The doctor panel does all three at its root and so renders every clinical
 * component anywhere; the clinic panel does them only around its two clinical
 * routes. Neither may fork what is exported here — a behaviour that belongs to
 * one panel is a host intent, never a copy.
 */ 
var $e317r = parcelRequire("e317r");
/**
 * Every navigation INTENT the clinical screens raise on their host.
 *
 * A host (ClinicalHostProvider's `navigate`) must give each one a destination —
 * or deliberately none — and each host's own test says so. The kit's test
 * (clinical/__tests__/intents.test.js) scans these sources and fails when a
 * screen raises an intent that is not listed here, so a new one can never reach
 * a host as a silent dead button.
 *
 *   reception       the host's home: the visit closed, or the record is gone
 *                   (doctor → its day sheet; clinic → پذیرش)
 *   patient-detail  { id, tab? } — the patient's record, from inside a visit
 *   credits         top up پارسه — the balance ran out mid-visit
 *   profile         { tab: 'visit' } — the visit-layout editor
 *
 * «Back» is not an intent; it is the host's `back()`.
 */ const $1df498c4a77aa468$export$102fd40a9fb0f382 = Object.freeze([
    'reception',
    'patient-detail',
    'credits',
    'profile'
]);



var $acw62 = parcelRequire("acw62");
// The app's ONE mobile breakpoint: ≤ 768px, inclusive (DESIGN-CONCEPT-MOBILE
// preamble). Every `X.mobile.jsx` fork, the bottom-nav shell in App.jsx, the
// `IOSDevice` frame and the `@media` block in styles.css all key off this one
// number — a rule that only became true after a viewport between 501 and 768px
// was found getting the mobile shell from JS and the desktop viewport rules
// from CSS, which is how the bottom nav ended up below the fold.
//
// The implementation moved into @parsina/framework (a byte-identical copy
// already existed in the clinic client). This file stays as the app's import
// path so the ten screens and the /docs pages that quote it keep working, and
// so there remains one obvious place to look for "what counts as mobile here".
//
// What the kit version fixes over the local copy it replaces:
//   • `matchMedia` instead of a `resize` listener — one state change at the
//     boundary rather than a re-render on every frame of a rotation;
//   • a `typeof window` guard, so a node-environment test can import a screen.
parcelRequire("5N0ZI");
var $k27hS = parcelRequire("k27hS");
var $b2986342a4eb23f5$export$2e2bcd8739ae039 = (0, $k27hS.default);



var $e317r = parcelRequire("e317r");
function $aa19facd75e3670a$export$5b61ff3425c1c197() {
    return (0, $e317r.useClinicalHost)().navigate;
}
function $aa19facd75e3670a$export$2225579b56f43845() {
    return (0, $e317r.useClinicalHost)().back;
}


// ── Visit.mobile.jsx ─────────────────────────────────────────────────────────
// The mobile clinical-visit workspace — a platform fork of the desktop Visit
// screen (DESIGN-CONCEPT-MOBILE v2 §1.1). A render-only composition of the
// dedicated MobileVisit* library over brand tokens + kit primitives; every
// clinical derivation and mutation below is the same behaviour the desktop
// screen runs, kept here as wiring rather than re-implemented. The warm-beige
// sub-theme, the raw button tags, px units and custom icon set are gone — the
// Visit page now lives on the one design system (freeze lifted 2026-07-18).
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");


var $jTCZr = parcelRequire("jTCZr");
const $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $56f50ba2a6b5ae3c$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};


var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $3tGMU = parcelRequire("3tGMU");
var $66joL = parcelRequire("66joL");
var $iK5Lj = parcelRequire("iK5Lj");
var $kLmaN = parcelRequire("kLmaN");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The visit workspace's loading shapes (DESIGN.md §"Loading & skeleton").
//
// Desktop (`VisitSkeleton`) is the three-column cockpit at its real grid —
// 54px top bar, 340px record rail, the SOAP centre with its tab strip, the
// 360px copilot rail — so the workspace lands in place when the patient
// arrives. Mobile (`VisitMobileSkeleton`) is the phone's own shape: the 7rem
// brand band, the section pills, SOAP cards, the pinned CTA bar.
//
// The region pieces below stand in for ONE pending region inside a live
// workspace: the orders list, a catalogue picker, a past visit's detail.
// ─────────────────────────────────────────────────────────────────────────────
const $84e131569ade80e0$var$RailSection = ({ lines: lines = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control,
            padding: '12px 14px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 110,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 14,
        height: 14,
        radius: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 11,
        lastWidth: "55%"
    }));
const $84e131569ade80e0$export$9bd146003e37d24c = 56;
const $84e131569ade80e0$export$f5b59ff325509bf0 = 1440;
const $84e131569ade80e0$export$e6a645360361d3ad = ()=>{
    try {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
        return window.matchMedia(`(min-width: ${$84e131569ade80e0$export$f5b59ff325509bf0}px)`).matches !== false;
    } catch  {
        return true;
    }
};
const $84e131569ade80e0$export$88c3a43a7eaf51eb = ({ contextExpanded: contextExpanded = false, copilotExpanded: copilotExpanded = false, recordOpen: recordOpen = true, copilotOpen: copilotOpen = true } = {})=>[
        `${$84e131569ade80e0$export$9bd146003e37d24c}px`,
        !recordOpen ? '0px' : contextExpanded ? 'min(560px, 38%)' : 'clamp(220px, calc(30% - 92px), 340px)',
        'minmax(0,1fr)',
        !copilotOpen ? '0px' : copilotExpanded ? 'min(600px, 40%)' : 'clamp(240px, calc(30% - 72px), 360px)'
    ].join(' ');
const $84e131569ade80e0$var$SOAP_LABELS = [
    64,
    80,
    72,
    56
];
const $84e131569ade80e0$export$39c20a58c12966ae = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    // The skeleton lands on the grid the page will open with on this screen.
    const open = $84e131569ade80e0$export$e6a645360361d3ad();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: $84e131569ade80e0$export$88c3a43a7eaf51eb({
                recordOpen: open,
                copilotOpen: open
            }),
            gridTemplateRows: '54px 1fr',
            height: '100vh',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            gridColumn: '1 / -1',
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '0 16px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
        size: 34
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 150,
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 200,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 72,
        height: 28,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 104
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 120
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            gridColumn: 1,
            gridRow: 2,
            padding: '12px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.C).card,
            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 48,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 48,
        radius: (0, $jTCZr.RADIUS).control
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 2,
            gridRow: 2,
            padding: 16,
            display: open ? 'flex' : 'none',
            flexDirection: 'column',
            gap: 10,
            borderInlineStart: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 3,
            gridRow: 2,
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTabs), {
        widths: [
            72,
            60,
            96,
            84
        ],
        padding: "11px 16px"
    }), $84e131569ade80e0$var$SOAP_LABELS.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonInput), {
            key: i,
            labelWidth: w,
            multiline: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 128
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 4,
            gridRow: 2,
            padding: 16,
            display: open ? 'flex' : 'none',
            flexDirection: 'column',
            gap: 12,
            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 22,
        height: 22,
        radius: 6
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    })));
};
const $84e131569ade80e0$var$MobileSoapCard = ({ lines: lines })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 26,
        height: 26,
        radius: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 96,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 28,
        height: 28,
        radius: (0, $jTCZr.RADIUS).control,
        style: {
            marginInlineStart: 'auto'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "60%"
    }));
const $84e131569ade80e0$export$2ed6987820fcbbfe = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-content",
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            height: '7rem',
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0,
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "55%",
        height: 15,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "40%",
        height: 11,
        tone: "onDark"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 28,
        radius: (0, $jTCZr.RADIUS).pill,
        tone: "onDark"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: '0.5rem',
            padding: '0.75rem 0.875rem 0',
            overflow: 'hidden',
            flexShrink: 0
        }
    }, [
        72,
        60,
        84,
        68
    ].map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            width: w,
            height: 36,
            radius: (0, $jTCZr.RADIUS).pill
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            padding: '0.75rem 0.875rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            gap: '0.5rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        style: {
            flex: 1,
            width: 'auto'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "icon"
    })));
};
/** One clinical order row: type glyph · title + meta · status chip. Desktop and mobile alike. */ const $84e131569ade80e0$var$OrderRowSkeleton = ({ i: i, dense: dense })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: dense ? '0.625rem 0.75rem' : '10px 12px',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${46 + i * 17 % 30}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${28 + i * 11 % 22}%`,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    }));
const $84e131569ade80e0$export$ab93a3750a1b92b6 = ({ count: count = 3, dense: dense = false, testId: testId = 'visit-orders-loading', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: dense ? '0.5rem' : 8
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$OrderRowSkeleton, {
            key: i,
            i: i,
            dense: dense
        })));
};
const $84e131569ade80e0$export$217179f0f838b1dd = ({ count: count = 5, testId: testId, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
        count: count,
        avatar: false,
        trailing: 48,
        "data-testid": testId,
        label: label ?? t('common.state.loading')
    });
};
const $84e131569ade80e0$export$785af5d3304b5931 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            padding: '6px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 96,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 84,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 80,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2,
        height: 11,
        lastWidth: "50%"
    }));
};
const $84e131569ade80e0$export$562f3f75696de122 = ({ count: count = 3, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-history-rail-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            "aria-hidden": true,
            style: {
                padding: '8px 10px',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).control,
                background: (0, $jTCZr.CT).surface2,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 90,
            height: 11
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 48,
            height: 11
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: `${40 + i * 13 % 30}%`,
            height: 11
        }))));
};
var $84e131569ade80e0$export$2e2bcd8739ae039 = $84e131569ade80e0$export$39c20a58c12966ae;



var $QG9Z3 = parcelRequire("QG9Z3");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9c3425eadfb41de5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5l4 2",
            key: "1fdv2h"
        }
    ]
];
const $9c3425eadfb41de5$export$2e2bcd8739ae039 = (0, $9QBug.default)("history", $9c3425eadfb41de5$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $24a488cfd7efdee5$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const $24a488cfd7efdee5$export$2e2bcd8739ae039 = (0, $9QBug.default)("ellipsis", $24a488cfd7efdee5$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $0d97ad00fbef0d0b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
            key: "ftymec"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "6",
            width: "14",
            height: "12",
            rx: "2",
            key: "158x01"
        }
    ]
];
const $0d97ad00fbef0d0b$export$2e2bcd8739ae039 = (0, $9QBug.default)("video", $0d97ad00fbef0d0b$export$3efd853dbb351e94);


var $6TdpC = parcelRequire("6TdpC");

var $acw62 = parcelRequire("acw62");

var $a83Oj = parcelRequire("a83Oj");
// The clinical module's view of the runtime environment.
//
// In the doctor panel this file read `window.__ENV__` directly. Inside the kit
// it cannot: the clinic panel has its OWN BFF (capi.…) and must reach the
// DOCTOR BFF (api.…) for clinical data, so the address is the host's to give
// (see ../host.jsx). Getters rather than constants because the host is
// configured at boot, after this module has been evaluated.

var $e317r = parcelRequire("e317r");
const $eabde0fc143396e8$export$dd8e552c8e6ae595 = ()=>(0, $e317r.hostBffUrl)();
const $eabde0fc143396e8$export$8742212cdac9d01 = ()=>(0, $e317r.hostWsBase)();


// ─────────────────────────────────────────────────────────────────────────────
// The error taxonomy.
//
// Before this module every failure in the app was the same failure: a screen
// rendered «اطلاعات در دسترس نیست» and printed `err.message` in monospace. That
// is the correct answer to exactly one of the things that actually go wrong,
// and the wrong answer to all the others — a doctor whose Wi-Fi dropped, a
// doctor whose shift ran past token expiry, a doctor opening a colleague's
// patient, and a doctor hitting a service that is genuinely down all need
// DIFFERENT next actions, and only one of those four is "press retry".
//
// So: every error that crosses the network boundary is classified exactly once,
// here, into a `kind`. The kind decides the copy, the icon, whether a retry
// button appears at all, and whether the failure is worth reporting. Screens
// never re-sniff `err.message` — that is what produced the inconsistency this
// replaces.
//
// The classification order is deliberate and NOT rearrangeable:
//   offline first, because a dropped connection makes every other signal a lie
//   (a fetch that never left the machine has no status to read);
//   then transport, because a `TypeError: Failed to fetch` carries no status;
//   then explicit GraphQL `extensions.code`, the server saying what it meant;
//   then HTTP status;
//   then message sniffing, which is the last resort and only for gRPC codes
//   that reach us as prose because no layer in between structured them.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * The complete set of failure kinds the UI knows how to talk about.
 *
 * Adding one means adding its copy in `errors.kind.*` (both locales) and
 * deciding its row in RETRYABLE below — the i18n ratchet enforces the first
 * half of that automatically.
 */ const $91f57610161f2da8$export$896afd8541959ee5 = {
    /** The device has no network at all. Nothing left the machine. */ OFFLINE: 'offline',
    /** The request left but never landed — DNS, TLS, connection reset, CORS. */ NETWORK: 'network',
    /** The request landed but we gave up waiting. */ TIMEOUT: 'timeout',
    /** No valid session. The token is missing, expired, or was rejected. */ UNAUTHENTICATED: 'unauthenticated',
    /** Authenticated, but not allowed to do this. Retrying cannot help. */ FORBIDDEN: 'forbidden',
    /** The thing addressed does not exist (or is not visible to this doctor). */ NOT_FOUND: 'notFound',
    /** The submission was rejected on its contents. The user must change it. */ VALIDATION: 'validation',
    /** Someone else changed it first; the write would clobber them. */ CONFLICT: 'conflict',
    /** Too many requests — retry is correct, but only after a wait. */ RATE_LIMITED: 'rateLimited',
    /** A dependency is down or deploying. Retry later, not now. */ MAINTENANCE: 'maintenance',
    /** The server broke while handling a well-formed request. */ SERVER: 'server',
    /** Out of Parsina credits — a business state, not a fault. */ INSUFFICIENT_CREDITS: 'insufficientCredits',
    /** Classified as nothing else. Treated as retryable and reported. */ UNKNOWN: 'unknown'
};
/**
 * Whether the SAME request, sent again unchanged, could plausibly succeed.
 *
 * This is what decides whether a retry button is rendered — and a retry button
 * on an unretryable failure is worse than no button, because it invites the
 * doctor to keep pressing something that will never work. FORBIDDEN, NOT_FOUND
 * and VALIDATION need a different action, not the same one again.
 */ const $91f57610161f2da8$var$RETRYABLE = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.OFFLINE,
    $91f57610161f2da8$export$896afd8541959ee5.NETWORK,
    $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED,
    $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    $91f57610161f2da8$export$896afd8541959ee5.SERVER,
    $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN
]);
/**
 * Kinds that mean "this session is over". The session layer watches for these
 * and raises the re-authentication dialog rather than letting each screen
 * render its own dead-end error card.
 */ const $91f57610161f2da8$var$SESSION_ENDING = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED
]);
/**
 * Kinds worth reporting to a human. A doctor on a train going through a tunnel
 * is not a defect, and neither is a 403 on a link someone shared; drowning the
 * console in those is how the real INTERNAL_SERVER_ERROR gets missed.
 */ const $91f57610161f2da8$var$REPORTABLE = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.SERVER,
    $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN
]);
// GraphQL `extensions.code` → kind. Apollo's own codes plus the ones the BFF
// mints (see parsina.bff.web resolvers). A code that is not here falls through
// to the HTTP status, which is the right default: the BFF sends 200 with an
// errors array for domain failures and a real status for transport ones.
const $91f57610161f2da8$var$CODE_KINDS = {
    UNAUTHENTICATED: $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    FORBIDDEN: $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    NOT_FOUND: $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    BAD_USER_INPUT: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    GRAPHQL_VALIDATION_FAILED: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    BAD_REQUEST: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    DUPLICATE_DOCTOR: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    CONFLICT: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    INSUFFICIENT_CREDITS: $91f57610161f2da8$export$896afd8541959ee5.INSUFFICIENT_CREDITS,
    // The BFF's «…_UNAVAILABLE» family means a downstream microservice did not
    // answer — from the doctor's side that is indistinguishable from maintenance,
    // and the advice is the same: it is not you, try again shortly.
    ACCOUNTING_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    CHAT_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    SERVICE_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    INTERNAL_SERVER_ERROR: $91f57610161f2da8$export$896afd8541959ee5.SERVER
};
const $91f57610161f2da8$var$STATUS_KINDS = {
    400: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    401: $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    403: $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    404: $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    408: $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    409: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    422: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    429: $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED,
    502: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    503: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    504: $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT
};
// gRPC status names that reach the client inside a message string because no
// layer between the microservice and here turned them into an extension code.
// `UNAVAILABLE` is by far the common one — it is what every stopped Python
// service produces, and reading it as a generic server error told doctors the
// system was broken when it was merely restarting.
//
// i18n-exempt: gRPC status names — wire values matched against, never displayed.
const $91f57610161f2da8$var$GRPC_MESSAGE_KINDS = [
    [
        /\bUNAVAILABLE\b|No connection established|ECONNREFUSED/i,
        $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE
    ],
    [
        /\bDEADLINE_EXCEEDED\b|\bETIMEDOUT\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT
    ],
    [
        /\bPERMISSION_DENIED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN
    ],
    [
        /\bUNAUTHENTICATED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED
    ],
    [
        /\bNOT_FOUND\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND
    ],
    [
        /\bALREADY_EXISTS\b|\bABORTED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.CONFLICT
    ],
    [
        /\bRESOURCE_EXHAUSTED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED
    ],
    [
        /\bINVALID_ARGUMENT\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.VALIDATION
    ]
];
// A fetch that never reached a server. The browsers disagree on the wording, and
// deliberately so — the spec forbids exposing why, to avoid leaking network
// topology to script. So this matches the shapes rather than one string.
//
// i18n-exempt: browser-generated network error text, matched against, never displayed.
const $91f57610161f2da8$var$TRANSPORT_MESSAGE = /Failed to fetch|NetworkError|Network request failed|Load failed|ERR_NETWORK|ERR_INTERNET_DISCONNECTED/i;
function $91f57610161f2da8$export$a81aa9769d155ec5() {
    return typeof navigator !== 'undefined' && navigator.onLine === false;
}
function $91f57610161f2da8$export$1b8dff08c06e2cb8(err) {
    // A kind already decided upstream (bffClient stamps one on) is authoritative:
    // re-deriving it from a message that has since been wrapped loses information.
    if (err && typeof err === 'object' && err.kind && Object.values($91f57610161f2da8$export$896afd8541959ee5).includes(err.kind)) return err.kind;
    // Offline first. With no network there is no status and no server opinion to
    // read, so every later signal would be noise — and «اینترنت قطع است» is a far
    // more actionable thing to say than «خطای شبکه».
    if ($91f57610161f2da8$export$a81aa9769d155ec5()) return $91f57610161f2da8$export$896afd8541959ee5.OFFLINE;
    if (err && typeof err === 'object' && err.name === 'AbortError') return $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT;
    const message = String(err?.message ?? err ?? '');
    // A TypeError with no status is the browser's way of saying the request never
    // completed — the one case where the class of the object is the evidence.
    if (err instanceof TypeError && !err.status) return $91f57610161f2da8$export$896afd8541959ee5.NETWORK;
    if (!err?.status && !err?.extensions && $91f57610161f2da8$var$TRANSPORT_MESSAGE.test(message)) return $91f57610161f2da8$export$896afd8541959ee5.NETWORK;
    const code = err?.extensions?.code;
    if (code && $91f57610161f2da8$var$CODE_KINDS[code]) return $91f57610161f2da8$var$CODE_KINDS[code];
    // `extensions.http.status` is how Apollo carries a status on an error that
    // travelled inside a 200 response body.
    const status = err?.status ?? err?.extensions?.http?.status;
    if (status && $91f57610161f2da8$var$STATUS_KINDS[status]) return $91f57610161f2da8$var$STATUS_KINDS[status];
    if (status >= 500) return $91f57610161f2da8$export$896afd8541959ee5.SERVER;
    if (status >= 400) return $91f57610161f2da8$export$896afd8541959ee5.VALIDATION;
    for (const [pattern, kind] of $91f57610161f2da8$var$GRPC_MESSAGE_KINDS){
        if (pattern.test(message)) return kind;
    }
    return $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN;
}
const $91f57610161f2da8$export$f146c102d7613638 = (kind)=>$91f57610161f2da8$var$RETRYABLE.has(kind);
const $91f57610161f2da8$export$a5ddc661666022ae = (kind)=>$91f57610161f2da8$var$SESSION_ENDING.has(kind);
const $91f57610161f2da8$export$ee13084f38878c77 = (kind)=>$91f57610161f2da8$var$REPORTABLE.has(kind);
const $91f57610161f2da8$export$78353e7f4dfe1b54 = (kind)=>`errors.kind.${kind}`;
function $91f57610161f2da8$export$ec1c1ab7432e3493(err, extra = {}) {
    if (!err || typeof err !== 'object') return err;
    err.kind = $91f57610161f2da8$export$1b8dff08c06e2cb8(err);
    err.retryable = $91f57610161f2da8$export$f146c102d7613638(err.kind);
    Object.assign(err, extra);
    return err;
}
/**
 * The technical detail line shown under an error, or null when there is nothing
 * a human could act on.
 *
 * Suppressed for the kinds whose message is pure noise: the doctor gains
 * nothing from «Failed to fetch» beneath «اینترنت قطع است», and a raw stack
 * fragment under a permission error reads as a malfunction rather than a rule.
 * It is kept for SERVER and UNKNOWN, where it is the only thing that will let
 * support identify the failure.
 */ const $91f57610161f2da8$var$DETAIL_SUPPRESSED = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.OFFLINE,
    $91f57610161f2da8$export$896afd8541959ee5.NETWORK,
    $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE
]);
function $91f57610161f2da8$export$b08d804d6ffdb3ed(err) {
    const kind = $91f57610161f2da8$export$1b8dff08c06e2cb8(err);
    if ($91f57610161f2da8$var$DETAIL_SUPPRESSED.has(kind)) return null;
    const message = err?.message ? String(err.message) : null;
    if (!message) return null;
    // A request id, when the BFF sent one, is the single most useful thing a
    // doctor can read out to support — so it leads the line.
    return err?.requestId ? `${err.requestId} \u{2014} ${message}` : message;
}


// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $e86ae3699bc75753$var$listeners = new Set();
function $e86ae3699bc75753$export$288ba6b4215d30f3(listener) {
    $e86ae3699bc75753$var$listeners.add(listener);
    return ()=>$e86ae3699bc75753$var$listeners.delete(listener);
}
function $e86ae3699bc75753$export$87a8bdb1d0a966cf() {
    for (const listener of $e86ae3699bc75753$var$listeners)try {
        listener();
    } catch  {}
}
function $e86ae3699bc75753$export$d433e139d37a5376() {
    $e86ae3699bc75753$var$listeners.clear();
}


// The session EVENT BUS — the one channel by which clinical code says «this
// session is over» to whichever panel is hosting it.
//
// The doctor panel's full session module (return paths, the expiry watcher, the
// «extend session» button) is shell behaviour and stays in that shell; it
// re-exports THIS bus so a 401 raised inside a visit reaches the same listeners
// as one raised on پذیرش. The clinic panel subscribes to it the same way.
const $81fe69ded19c5b5e$export$3b6ed64b5b4e542d = {
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};
const $81fe69ded19c5b5e$export$9a8e643ece3bd90e = 120000;
const $81fe69ded19c5b5e$var$listeners = new Set();
function $81fe69ded19c5b5e$export$a883a9af61079ac7(listener) {
    $81fe69ded19c5b5e$var$listeners.add(listener);
    return ()=>$81fe69ded19c5b5e$var$listeners.delete(listener);
}
function $81fe69ded19c5b5e$export$c21f8c101d467dce(event) {
    for (const listener of $81fe69ded19c5b5e$var$listeners)try {
        listener(event);
    } catch  {}
}
function $81fe69ded19c5b5e$export$4a79209357ec4bed() {
    $81fe69ded19c5b5e$var$listeners.clear();
}


// How long a single GraphQL round trip may take before we stop waiting.
//
// Without this a request on a dead connection hangs until the browser's own
// timeout — minutes, on mobile networks — and the screen sits on its skeleton
// the whole time, which reads as "the app is broken" rather than "this is
// slow". 30s is well past the slowest real query (the AI ones) and well short
// of a doctor's patience.
const $adebb901af88e18b$var$REQUEST_TIMEOUT_MS = 30000;
const $adebb901af88e18b$export$5c63bf3ded5aa229 = 120000;
function $adebb901af88e18b$export$7f5d9d25e625ad97() {
    try {
        return (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    } catch  {
        return ''; // no document (tests, SSR) → let the BFF default
    }
}
async function $adebb901af88e18b$var$executeRequest(token, query, variables, timeoutMs) {
    // AbortController rather than a Promise.race: racing leaves the real request
    // running in the background, so a screen that "timed out" would still be
    // holding a socket and could still fire its .then() later.
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    try {
        return await fetch((0, $eabde0fc143396e8$export$dd8e552c8e6ae595)(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-parsina-language': $adebb901af88e18b$export$7f5d9d25e625ad97()
            },
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            signal: controller.signal
        });
    } finally{
        clearTimeout(timer);
    }
}
async function $adebb901af88e18b$var$bffRequest(query, variables = {}, { timeoutMs: timeoutMs = $adebb901af88e18b$var$REQUEST_TIMEOUT_MS } = {}) {
    const token = await (0, $a83Oj.getValidToken)();
    if (!token) {
        // Raise, do not navigate. `redirectToLogin()` here was a full-document
        // navigation, which unmounts React and destroys everything unsaved — a
        // half-written SOAP note, a prescription mid-assembly — without warning and
        // without returning the doctor to the page they were on. The shell listens
        // for this and raises a dialog over the still-intact screen instead.
        (0, $81fe69ded19c5b5e$export$c21f8c101d467dce)((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRED);
        throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(new Error('Not authenticated'), {
            kind: (0, $91f57610161f2da8$export$896afd8541959ee5).UNAUTHENTICATED
        }); // i18n-exempt: developer-facing throw; the UI renders errors.kind.* by `kind`
    }
    let res;
    try {
        res = await $adebb901af88e18b$var$executeRequest(token, query, variables, timeoutMs);
    } catch (err) {
        // Transport-level: never reached the BFF, so there is no status and no body
        // to read. classifyError separates "the device is offline" from "the request
        // was aborted on our timeout" from "the connection failed" — three different
        // things to tell the doctor, and previously all three were «خطای سرور».
        //
        // Tell the connectivity detector, which cannot see this from its own
        // vantage point: `navigator.onLine` reports online for a captive portal, a
        // dead VPN and a firewall black-holing the BFF, and those are precisely the
        // outages worth naming — the laptop insists everything is fine in all of
        // them. One report does not itself raise the banner; it prompts a probe.
        (0, $e86ae3699bc75753$export$87a8bdb1d0a966cf)();
        throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(err);
    }
    // On 401, try to refresh once and retry — handles server-side expiry / clock skew
    if (res.status === 401) {
        const refreshed = await (0, $a83Oj.refreshAccessToken)();
        if (!refreshed) {
            (0, $81fe69ded19c5b5e$export$c21f8c101d467dce)((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRED);
            throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(new Error('Session expired'), {
                kind: (0, $91f57610161f2da8$export$896afd8541959ee5).UNAUTHENTICATED
            }); // i18n-exempt: developer-facing throw; the UI renders errors.kind.* by `kind`
        }
        const newToken = (0, $a83Oj.getToken)();
        try {
            res = await $adebb901af88e18b$var$executeRequest(newToken, query, variables, timeoutMs);
        } catch (err) {
            throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(err);
        }
    }
    // The BFF's correlation id, when it sends one. Carried onto the error so the
    // detail line under a server failure is something support can actually look
    // up, instead of a message that appears identically in a thousand logs.
    const requestId = res.headers?.get?.('x-request-id') || null;
    if (!res.ok) {
        // Read the body before giving up. Apollo sends a perfectly normal GraphQL error
        // payload alongside a non-2xx status, and throwing on the status alone dropped
        // `extensions` — leaving callers unable to tell "your token was rejected" from
        // "the server fell over". App.jsx's boot check treats any failure as
        // not-onboarded, so that gap put the onboarding wizard in front of doctors who
        // were merely holding a stale token.
        const body = await res.json().catch(()=>null);
        const gqlError = body?.errors?.[0];
        const err = new Error(gqlError?.message || `BFF error: ${res.status}`); // i18n-exempt: fallback for a server error with no message; shown only in the monospace detail line
        err.status = res.status;
        if (gqlError?.extensions) err.extensions = gqlError.extensions;
        if (body?.errors) err.graphQLErrors = body.errors;
        throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(err, {
            requestId: requestId
        });
    }
    const { data: data, errors: errors } = await res.json();
    if (errors?.length) {
        const err = new Error(errors[0].message);
        err.extensions = errors[0].extensions;
        err.graphQLErrors = errors;
        throw (0, $91f57610161f2da8$export$ec1c1ab7432e3493)(err, {
            requestId: requestId
        });
    }
    return data;
}
const $adebb901af88e18b$export$7fb4864174f056c = $adebb901af88e18b$var$bffRequest;
const $adebb901af88e18b$export$8395d0fc0d822a81 = $adebb901af88e18b$var$bffRequest;


const $ea02b2b734b36651$var$PATIENT_QUERY = `
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      name
      phone
      birthDate
      age
      gender
      bloodType
      nationalId
      job
      insurance
      status
      lastWeight
      height
      bmi
      lastVisit
      visitsCount
      createdAt

      clinicalAllergies {
        id
        allergen
        reaction
        severity
        status
      }

      clinicalObservations {
        id
        appointmentId
        code
        display
        value
        unit
        status
        category
        effectiveDate
        createdAt
      }
      encounters {
        id
        type
        status
        scheduledDate
        dischargeInstructions
        followUpSuggestion
        duration
        consentId
        createdAt
        doctorId
      }
      clinicalFiles {
        id
        appointmentId
        orderId
        fileName
        fileType
        ocrContent
        createdAt
        # Who put it there. Not derivable from doctorId, which names the ORDERING
        # doctor even on a patient's own upload so that doctor-side scoping still
        # finds it \u{2014} so without this a patient upload is indistinguishable from
        # one the clinic scanned in.
        uploadedBy
        # Short "storage:labfile:<id>" reference for uploads whose bytes live in
        # MinIO \u{2014} used to recognise a clinical file and a storage lab file as one
        # document. Inline legacy payloads are stripped from list responses, so
        # this never carries a base64 blob.
        fileUrl
        # The care context. Only rendered when the doctor works at more than one
        # clinic \u{2014} on a single-clinic doctor's screen the chip would say the same
        # thing on every row and mean nothing.
        clinicId
        # LAB | IMAGING | MEDICAL_REPORT | PRESCRIPTION | TREATMENT_DOCUMENT | OTHER
        kind
        fileSize
        # What the analysis pipeline has done with it. The analysis ITSELF is
        # deliberately not selected here: it is one more round trip per file and
        # only the drawer needs it.
        processingStatus
        processingError
        processedAt
        # Patient documents: the document's own date and note, what the CALLER may do
        # with it (evaluated server-side), whether values or a report from it are in
        # the record, and the request it answers.
        doctorId
        documentDate
        description
        canEdit
        editScope
        canDelete
        extractable
        promotedAt
        resolvedOrder { id description orderType status }
      }

      history {
        id
        date
        specialty
      }
    }
  }
`;
const $ea02b2b734b36651$var$LIST_CONDITIONS = `
  query ListConditions($patientId: ID!) {
    listConditions(patientId: $patientId) {
      id
      appointmentId
      code
      display
      clinicalStatus
      verificationStatus
      onsetDate
      createdAt
    }
  }
`;
// `meta` carries the drug-list product a medication was prescribed from
// (`drugId`): «تجویز مجدد» on the record rail prescribes THAT product again,
// looked up by id rather than re-matched by name (K1, 2026-10-03).
const $ea02b2b734b36651$var$LIST_MEDICATIONS = `
  query ListMedications($patientId: ID!) {
    listMedications(patientId: $patientId) {
      id
      appointmentId
      code
      display
      status
      authoredOn
      dosageInstruction
      endDate
      meta
      createdAt
    }
  }
`;
const $ea02b2b734b36651$var$LIST_CLINICAL_NOTES = `
  query ListClinicalNotes($patientId: ID!) {
    listClinicalNotes(patientId: $patientId) {
      id
      appointmentId
      noteType
      format
      content
      authorRole
      createdAt
      updatedAt
    }
  }
`;
function $ea02b2b734b36651$var$fetchClinicalData(id) {
    return Promise.all([
        (0, $adebb901af88e18b$export$7fb4864174f056c)($ea02b2b734b36651$var$PATIENT_QUERY, {
            id: id
        }),
        (0, $adebb901af88e18b$export$7fb4864174f056c)($ea02b2b734b36651$var$LIST_CONDITIONS, {
            patientId: id
        }),
        (0, $adebb901af88e18b$export$7fb4864174f056c)($ea02b2b734b36651$var$LIST_MEDICATIONS, {
            patientId: id
        }),
        (0, $adebb901af88e18b$export$7fb4864174f056c)($ea02b2b734b36651$var$LIST_CLINICAL_NOTES, {
            patientId: id
        })
    ]).then(([patientData, conditionsData, medicationsData, notesData])=>{
        if (!patientData.patient) return patientData.patient;
        return {
            ...patientData.patient,
            clinicalConditions: conditionsData.listConditions || [],
            clinicalMedications: medicationsData.listMedications || [],
            clinicalNotes: notesData.listClinicalNotes || []
        };
    });
}
function $ea02b2b734b36651$export$9b570c45914f833c(id) {
    const [patient, setPatient] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (silent = false)=>{
        if (!id) return;
        if (!silent) setLoading(true);
        $ea02b2b734b36651$var$fetchClinicalData(id).then(setPatient).catch(setError).finally(()=>{
            if (!silent) setLoading(false);
        });
    };
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        id
    ]);
    const refresh = ()=>{
        return $ea02b2b734b36651$var$fetchClinicalData(id).then(setPatient).catch(setError);
    };
    return {
        patient: patient,
        loading: loading,
        error: error,
        refresh: refresh
    };
}



var $acw62 = parcelRequire("acw62");

// One query, not two. `Doctor.settings` used to be null and the AI section was
// fetched separately (and tolerated failing); it is a single field resolver over
// doctor-preference now, so every section arrives together or the query fails
// together — which is what the error state is for.
//
// `scheduling` and `insurance` are deliberately absent: neither is persisted
// (scheduling settings belong to the scheduling service) and neither is
// surfaced by the settings screen, so querying them only invited the UI to
// render values that no save could ever change.
const $6f41166a3447eed0$var$ME_QUERY = `
  query {
    me {
      id
      name
      firstName
      lastName
      nationalId
      gender
      birthDate
      medicalCode
      specialty
      phone
      email
      bio
      avatar
      settings {
        appearance {
          theme
          fontSize
          language
          fontFamily
        }
        visitLayout {
          recordSectionOrder
          recordSectionsHidden
          recordSectionsCollapsed
          workTabsHidden
          defaultWorkTab
          copilotTabsHidden
          defaultCopilotTab
        }
        notifications {
          smsNew
          smsReminder
          smsCancel
          emailSummary
          emailReport
          appNew
          appReminder
          appUrgent
        }
        security {
          otpEnabled
          biometricEnabled
        }
        aiAgent {
          interruptOnCritical
          interruptOnWarning
          spo2Threshold
          bpSystolicThreshold
          recommendationLogsEnabled
          autoDifferentialOnStart
          differentialPollingEnabled
          differentialPollIntervalSec
          liveHintsEnabled
          autoPrescriptionAssist
          reassessOnNoteEdit
          endVisitInteractionSweep
          speechEngine
          autoCompleteOnMonitoringStop
        }
      }
    }
  }
`;
const $6f41166a3447eed0$var$CHANGE_PASSWORD = `
  mutation($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;
// `image` is a JPEG/PNG data URI, or null to remove the current picture. The BFF
// stores the bytes and returns the URL it recorded in Keycloak.
const $6f41166a3447eed0$var$UPDATE_AVATAR = `
  mutation($image: String) {
    updateDoctorAvatar(image: $image) { id avatar }
  }
`;
const $6f41166a3447eed0$var$mutations = {
    profile: `
    mutation($input: DoctorProfileInput!) {
      updateDoctorProfile(input: $input) {
        id firstName lastName name nationalId gender birthDate medicalCode specialty phone email bio
      }
    }
  `,
    notifications: `
    mutation($input: NotificationSettingsInput!) {
      updateNotificationSettings(input: $input) { id }
    }
  `,
    appearance: `
    mutation($input: AppearanceSettingsInput!) {
      updateAppearanceSettings(input: $input) { id }
    }
  `,
    security: `
    mutation($input: SecuritySettingsInput!) {
      updateSecuritySettings(input: $input) { id }
    }
  `,
    aiAgent: `
    mutation($input: AIAgentSettingsInput!) {
      updateAIAgentSettings(input: $input) { id }
    }
  `,
    visitLayout: `
    mutation($input: VisitLayoutSettingsInput!) {
      updateVisitLayoutSettings(input: $input) { id }
    }
  `
};
function $6f41166a3447eed0$export$c33fab67557a8508() {
    const [doctor, setDoctor] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchDoctor = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($6f41166a3447eed0$var$ME_QUERY);
            setDoctor(data?.me ?? null);
            setError(null);
        } catch (err) {
            setError(err);
        }
    }, []);
    // Manual reload for a failed initial load — drives the ErrorState «تلاش مجدد».
    const refetch = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return fetchDoctor().finally(()=>setLoading(false));
    }, [
        fetchDoctor
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)($6f41166a3447eed0$var$ME_QUERY).then((data)=>{
            if (active) {
                setDoctor(data?.me ?? null);
                setError(null);
            }
        }).catch((err)=>{
            if (active) setError(err);
        }).finally(()=>{
            if (active) setLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, []);
    const update = (0, $acw62.useCallback)((section, input)=>{
        setSaving(true);
        return (0, $adebb901af88e18b$export$8395d0fc0d822a81)($6f41166a3447eed0$var$mutations[section], {
            input: input
        }).then(fetchDoctor).catch((err)=>{
            setError(err);
            throw err;
        }).finally(()=>setSaving(false));
    }, [
        fetchDoctor
    ]);
    // Note: does NOT toggle the shared `saving` flag (that drives the profile-save
    // button). The password form tracks its own local saving state.
    const changePassword = (0, $acw62.useCallback)((currentPassword, newPassword)=>{
        return (0, $adebb901af88e18b$export$8395d0fc0d822a81)($6f41166a3447eed0$var$CHANGE_PASSWORD, {
            currentPassword: currentPassword,
            newPassword: newPassword
        }).then((res)=>res?.changePassword === true);
    }, []);
    // Upload (data URI) or remove (null) the profile picture. Patches the local
    // doctor rather than refetching: the server's response already carries the
    // authoritative URL, and a full refetch would flicker the whole form.
    //
    // Like changePassword, this keeps its own saving state out of `saving` so the
    // profile SaveBar doesn't react to an avatar upload.
    const updateAvatar = (0, $acw62.useCallback)((image)=>{
        return (0, $adebb901af88e18b$export$8395d0fc0d822a81)($6f41166a3447eed0$var$UPDATE_AVATAR, {
            image: image ?? null
        }).then((res)=>{
            const next = res?.updateDoctorAvatar?.avatar ?? null;
            setDoctor((d)=>d ? {
                    ...d,
                    avatar: next
                } : d);
            return next;
        });
    }, []);
    return {
        doctor: doctor,
        loading: loading,
        saving: saving,
        error: error,
        update: update,
        changePassword: changePassword,
        updateAvatar: updateAvatar,
        refetch: refetch
    };
}


parcelRequire("5N0ZI");
var $6usBW = parcelRequire("6usBW");
const $5a7a6039daa594b4$var$NOOP = {
    show () {},
    success () {},
    error () {},
    warn () {},
    info () {},
    dismiss () {}
};
function $5a7a6039daa594b4$export$5476e2845fb28531() {
    try {
        return (0, $6usBW.useToast)();
    } catch  {
        return $5a7a6039daa594b4$var$NOOP;
    }
}


// ─────────────────────────────────────────────────────────────────────────────
// «اعمال قالب» — the control that puts a template into the visit in front of
// the doctor.
//
// One component for both kinds and both surfaces. It is a button that opens a
// list of the doctor's templates for that kind; picking one shows its items
// with a tick beside each, and «افزودن» applies the ticked ones.
//
// The second step exists for one reason: the patient in the chair is not the
// patient the template was written for. A respiratory template holds the
// antihistamine this patient is allergic to, or the antibiotic they are already
// on, and the doctor needs to leave that line out BEFORE it is written, not
// delete it afterwards. Everything is ticked by default, so the common case is
// still two clicks; a recorded allergy starts unticked and says why.
//
// What it deliberately does NOT do is decide what applying MEANS: it calls the
// apply mutation and hands the created visit rows to its parent. The rule that
// applying copies — that the visit gets its own editable rows — lives in the
// BFF, where it holds for every surface, not in whichever screen mounted this.
//
// The picker also states, every time it is open, that applied items stay
// editable and never write back to the template. That sentence is the whole
// mental model, and it belongs where the decision is being made.
//
// ── Two surfaces, two overlays ───────────────────────────────────────────────
// DESKTOP is a popover, rendered through a portal and fixed to the viewport
// rather than absolutely inside the card. The visit page's work column is
// `overflow: hidden` and sits between two side panels, so anything positioned
// inside it is cut off at the column edge — which on screen reads as the
// popover sliding under «پروندهٔ بیمار». A portal escapes the column; the
// position is recomputed from the trigger on scroll and resize so it stays
// attached.
//
// PHONE is a `BottomSheet` — the kit's default overlay for every mobile filter,
// form and picker (DESIGN-CONCEPT-MOBILE §6). It used to get the desktop
// popover, and that was wrong twice over: a 380px-tall list anchored under a
// button two thirds of the way down a scrolling tab has ~160px left to render
// into, and the panel had no colour at all — see the palette note below. The
// sheet also brings the things a phone overlay owes the doctor and a popover
// cannot: a scrim, `dvh` sizing, a focus trap, a body scroll lock, the keyboard
// inset, and hardware-back closing the picker instead of leaving the visit.
//
// ── Why it reads tokens and not the workspace's CSS variables ────────────────
// `Visit.web.jsx` injects the `:root` block that defines `--panel-2`, `--ink`
// and friends; `Visit.mobile.jsx` deliberately injects none of it (its screens
// speak the unified design language rather than the workspace's warm-beige
// sub-theme). An unresolved custom property is not a fallback to something
// sensible — `background: var(--panel-2)` is simply dropped — so the picker
// rendered as transparent text floating over the نسخه list.
//
// A var() fallback is NOT the fix, and finding out why is the reason this note
// exists: `--accent` is already defined globally by the framework's token
// sheet, as the shadcn HSL triple `207 66% 95%`. `var(--accent, …)` therefore
// resolves — to a value that is not a colour, which computes to transparent.
// The fallback would have looked right in review and shipped an invisible
// «افزودن» button.
//
// So every value comes straight from the framework token module. The `:root`
// block derives ITS values from those same tokens, so the desktop surface is
// unchanged, and the component is now correct anywhere it is mounted — inside
// the workspace, on the phone, or portaled out of both. `closure/tokens.js`
// records the same lesson for the closure screens.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $66joL = parcelRequire("66joL");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// «در فهرست تأمین» (`taminListed`) is asked of the BFF wherever a drug or an
// order reaches the screen. A BFF that predates the field refuses the whole
// question — GraphQL validates before it executes, so nothing ran: no lookup,
// no AI run, no charge — and the same question without the field is safe to
// ask instead. An environment whose BFF lags its client keeps working, without
// the flag.
const $8d8ac6402cc7b03c$var$schemaGap = (e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || /Cannot query field|Unknown argument|Unknown type/.test(String(e?.message || ''));
const $8d8ac6402cc7b03c$export$c6116461efe42e05 = (q)=>q.replace(/\s+taminListed\b/g, '');
function $8d8ac6402cc7b03c$export$405a623d7e907e9d(send = (0, $adebb901af88e18b$export$7fb4864174f056c)) {
    let preTamin = false;
    return async (full, vars, ...rest)=>{
        const old = $8d8ac6402cc7b03c$export$c6116461efe42e05(full);
        if (old === full) return send(full, vars, ...rest);
        if (preTamin) return send(old, vars, ...rest);
        try {
            return await send(full, vars, ...rest);
        } catch (e) {
            if (!$8d8ac6402cc7b03c$var$schemaGap(e)) throw e;
            preTamin = true;
            return send(old, vars, ...rest);
        }
    };
}



var $acw62 = parcelRequire("acw62");

// ─────────────────────────────────────────────────────────────────────────────
// Visit templates — the one place the client agrees with itself about what a
// template is.
//
// Two doctor-owned, named, ORDERED sets, assembled once in «تنظیمات ← قالب‌ها»
// and applied during a visit:
//
//   medication  «قالب نسخه»     — a set of drugs with their dosing
//   order       «قالب دستورات»  — a set of labs / imaging / procedures
//
// Four surfaces touch them (Settings desktop, Settings mobile, Visit desktop,
// Visit mobile) and none of them may disagree about the item shape, the
// validation rules, or what applying one does. All of that non-visual truth is
// here; markup belongs to whichever surface renders it.
//
// It holds no TEXT either. Every user-facing string is a translation KEY,
// resolved by the renderer — a literal here would be one language, and a plain
// module cannot call a hook.
//
// The rules below MIRROR app/domain/models.py in the doctorpreference service.
// They exist so the editor can tell the doctor what is wrong before a round
// trip, never so the client can decide policy: the service validates again and
// its answer is the one that counts.
// ─────────────────────────────────────────────────────────────────────────────
// ── Drug names ───────────────────────────────────────────────────────────────
// ONE rule, for every surface that shows a drug: the Latin generic name leads.
//
// It lives in its own module rather than in Visit.shared.js because the screens
// that need it are not all visit screens — the patient record's medication list,
// the templates panel in تنظیمات and the analysis timeline each show a drug name
// too, and none of them should have to pull in the visit module to ask what to
// call it.
/**
 * THE name of a drug, anywhere one name is shown: its Latin generic name, which
 * is what a pharmacy, a referral letter and every other clinician reads without
 * ambiguity. `drug.name` is the Persian product string and is only the fallback,
 * for a formulary row (or a plan-suggested drug) that carries no generic.
 *
 * This is the whole rule for single-name surfaces — the نسخه print sheet, the
 * closure card, the export text, the plan block. Never read `drug.name` directly
 * to display it; the Persian is the STORED identity, not the shown one.
 */ const $bb8a11e7c1131df5$export$128ec9ce691e4cfc = (drug)=>(drug?.genericName || '').trim() || (drug?.name || '').trim();
const $bb8a11e7c1131df5$export$3c5ec0a5e65ceb27 = $bb8a11e7c1131df5$export$128ec9ce691e4cfc;
const $bb8a11e7c1131df5$export$f7cd022e8c4a05fd = (med)=>{
    const code = (med?.code || '').trim();
    return $bb8a11e7c1131df5$var$nameLike(code) ? code : '';
};
const $bb8a11e7c1131df5$export$74649666e1751bea = (med)=>$bb8a11e7c1131df5$export$590163154e34e5bd({
        name: med?.display,
        genericName: $bb8a11e7c1131df5$export$f7cd022e8c4a05fd(med)
    });
/**
 * Whether a `code` is a drug NAME rather than an identifier.
 *
 * A name has letters; an RxNorm code is all digits. The awkward case is a code
 * that mixes the two — ATC's «A10BA02» — which is told apart by being short,
 * unspaced and alphanumeric. Every real generic name this has to keep is either
 * unspaced letters («Metformin») or a registry product string carrying its
 * strength and form («RIZATRIPTAN (AS BENZOATE) 5 mg TABLET ORAL»), and the
 * second always has spaces.
 */ const $bb8a11e7c1131df5$var$nameLike = (v)=>{
    if (!v || !/[A-Za-z\u0600-\u06FF]/.test(v)) return false;
    const identifierShaped = /\d/.test(v) && !/\s/.test(v) && v.length <= 12 && /^[A-Za-z0-9.-]+$/.test(v);
    return !identifierShaped;
};
const $bb8a11e7c1131df5$export$74f59380a530b722 = (med)=>$bb8a11e7c1131df5$export$74649666e1751bea(med).primary;
// ── The name a drug is CHECKED under ─────────────────────────────────────────
//
// The interaction check and the prescription assist hand the AI service a list
// of drugs, and the service reads that list two ways: the model is prompted with
// it verbatim («Medications: [...]»), and a deterministic rule engine matches
// each entry, lower-cased, against tables keyed on bare generic names
// («warfarin», «ibuprofen»), then asks openFDA about the same strings.
//
// The list used to be the formulary ids. Those were the generic names once — the
// retired curated rows were keyed «amoxicillin» — but every drug a doctor can pick
// now is `tamin-<srvId>` or `erx-<code>`. An id says nothing about the drug, so
// the rule engine matched nothing and the model, asked about «tamin-70521», made
// a finding up: «warfarin + aspirin, severe» for amoxicillin and ibuprofen on a
// live visit. The Persian product string is no better for the rule engine.
//
// What goes instead is the SUBSTANCE, in Latin: the generic name with the
// registry's product dressing taken off. A تأمین row's `genericName` is the whole
// product («AMOXICILLIN 500 mg CAPSULE ORAL», «RIZATRIPTAN (AS BENZOATE) 5 mg
// TABLET ORAL»), an eRx row's is already the molecule («ACETAMINOPHEN / CAFFEINE /
// CODEINE PHOSPHATE»). Strength, salt note, brand, dose form and route are cut, so
// both read «AMOXICILLIN» — the string a table, a label search and a model all
// know. Nothing is cut that would leave the name empty: a row whose name IS its
// dressing keeps the whole Latin string.
//
// Never the id and never the Persian when a Latin name exists. The Persian name is
// sent only for a row that has nothing else (a plan-suggested or refilled drug the
// formulary did not match) — the model can still read it, which an id never was.
// The registry's trailing dose-form and route words. Only ever stripped from the
// END, so a substance that merely contains one («ORAL REHYDRATION SALTS») keeps it.
const $bb8a11e7c1131df5$var$FORM_OR_ROUTE_WORDS = new Set([
    'TABLET',
    'TABLETS',
    'CAPSULE',
    'CAPSULES',
    'SOLUTION',
    'SUSPENSION',
    'SYRUP',
    'ELIXIR',
    'EMULSION',
    'INJECTION',
    'INJECTABLE',
    'DROPS',
    'DROP',
    'CREAM',
    'OINTMENT',
    'GEL',
    'LOTION',
    'SPRAY',
    'AEROSOL',
    'INHALER',
    'INHALATION',
    'POWDER',
    'GRANULES',
    'SACHET',
    'SUPPOSITORY',
    'SUPPOSITORIES',
    'PATCH',
    'LOZENGE',
    'FILM',
    'COATED',
    'EXTENDED',
    'DELAYED',
    'MODIFIED',
    'RELEASE',
    'CHEWABLE',
    'EFFERVESCENT',
    'ORAL',
    'TOPICAL',
    'PARENTERAL',
    'OPHTHALMIC',
    'OTIC',
    'NASAL',
    'VAGINAL',
    'RECTAL',
    'SUBLINGUAL',
    'CUTANEOUS',
    'TRANSDERMAL',
    'RESPIRATORY',
    'INTRAVENOUS',
    'INTRAMUSCULAR',
    'SUBCUTANEOUS',
    'FOR'
]);
const $bb8a11e7c1131df5$var$PERSIAN_LETTER = /[؀-ۿ]/;
const $bb8a11e7c1131df5$export$25a9d8c7e2474bfd = (latin)=>{
    const whole = String(latin || '').replace(/\s+/g, ' ').trim();
    if (!whole) return '';
    const tokens = whole.replace(/\[[^\]]*\]/g, ' ') // the bracketed brand
    .replace(/\([^)]*\)/g, ' ') // a salt note, «(AS BENZOATE)»
    .split(/\s+/).filter(Boolean);
    // The strength starts the product's dressing. Not the FIRST token, though: a
    // name may begin with a digit («5-FLUOROURACIL»).
    const strength = tokens.findIndex((tok, i)=>i > 0 && /^[\d.]/.test(tok));
    const head = strength === -1 ? tokens : tokens.slice(0, strength);
    while(head.length > 1 && $bb8a11e7c1131df5$var$FORM_OR_ROUTE_WORDS.has(head[head.length - 1].replace(/[,;]+$/, '').toUpperCase()))head.pop();
    return head.join(' ').replace(/[,;]+$/, '').trim() || whole;
};
const $bb8a11e7c1131df5$export$5ad2c5daad3b8af = (drug)=>{
    const latin = (drug?.genericName || '').trim();
    if (latin) return $bb8a11e7c1131df5$export$25a9d8c7e2474bfd(latin);
    const name = (drug?.name || '').trim();
    // An eRx row's own name is the Latin product string; a Persian one goes as is.
    return name && !$bb8a11e7c1131df5$var$PERSIAN_LETTER.test(name) ? $bb8a11e7c1131df5$export$25a9d8c7e2474bfd(name) : name;
};
const $bb8a11e7c1131df5$export$868d19c379622928 = (rxItems)=>(rxItems || []).map((r)=>$bb8a11e7c1131df5$export$5ad2c5daad3b8af(r?.drug)).filter(Boolean);
// ── Whether a warning still describes the نسخه ─────────────────────────────
//
// The prescription assist runs once per assessment, and its warnings are cards
// in «نکات بالینی» that outlive the list they were computed for. Removing a drug
// cleared the نسخه tab's own interaction result but not these, so a safety card
// went on naming a drug that was no longer prescribed. A warning is therefore
// shown only while every drug it names is still on the نسخه.
//
// The test is the AI service's own (medication_names.py `filter_interaction_
// warnings`), which already holds the model's warnings to the names it was sent:
// the same split of a pair, the same folding of case, ZWNJ, Arabic letterforms
// and punctuation, the same whole-word containment. Applied to the current list,
// a drug still on it matches exactly as it did on the server, so nothing that
// still applies is hidden. A warning that names no drug cannot be made stale by
// a removal and is kept.
// How a model writes a pair. Not "/" or "-": both occur inside drug names.
const $bb8a11e7c1131df5$var$PAIR_SPLIT = /\s*\+\s*|\s*[,،;&]\s*|\s+(?:and|with|vs\.?|و|مع)\s+/i;
const $bb8a11e7c1131df5$var$ARABIC_TO_PERSIAN = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u06C0": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627"
};
const $bb8a11e7c1131df5$var$INVISIBLE = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g;
const $bb8a11e7c1131df5$var$DIACRITICS = /[\u064B-\u0670]/g;
const $bb8a11e7c1131df5$var$foldDrugName = (text)=>String(text ?? '').normalize('NFKC').toLowerCase().replace($bb8a11e7c1131df5$var$INVISIBLE, '').replace($bb8a11e7c1131df5$var$DIACRITICS, '').replace(/[يىكةۀأإآ]/g, (ch)=>$bb8a11e7c1131df5$var$ARABIC_TO_PERSIAN[ch]).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
const $bb8a11e7c1131df5$var$warningDrugNames = (warning)=>{
    const pair = String(warning?.drugPair || '').trim();
    if (pair) return pair.split($bb8a11e7c1131df5$var$PAIR_SPLIT).filter((p)=>p && p.trim());
    const drug = String(warning?.drug || '').trim();
    return drug ? [
        drug
    ] : [];
};
// Equal once folded (spaces ignored too), or one contains the other as whole
// words — «amoxicillin» in «amoxicillin clavulanate». Never a bare substring:
// «pril» is not «enalapril».
const $bb8a11e7c1131df5$var$isListed = (name, listed)=>{
    const key = $bb8a11e7c1131df5$var$foldDrugName(name);
    if (key.length < 3) return false;
    return listed.some((item)=>{
        if (key === item || key.replace(/ /g, '') === item.replace(/ /g, '')) return true;
        const [short, long] = key.length <= item.length ? [
            key,
            item
        ] : [
            item,
            key
        ];
        return short.length >= 4 && ` ${long} `.includes(` ${short} `);
    });
};
const $bb8a11e7c1131df5$export$e960330bae0466a4 = (warning, rxNames)=>{
    const named = $bb8a11e7c1131df5$var$warningDrugNames(warning);
    if (!named.length) return true;
    const listed = (rxNames || []).map($bb8a11e7c1131df5$var$foldDrugName).filter(Boolean);
    return named.every((n)=>$bb8a11e7c1131df5$var$isListed(n, listed));
};
const $bb8a11e7c1131df5$export$3641abf9efdf7316 = (a, b)=>{
    if (!a || !b) return false;
    if ((a.warningType || 'interaction') !== (b.warningType || 'interaction')) return false;
    if ($bb8a11e7c1131df5$var$foldDrugName(a.condition) !== $bb8a11e7c1131df5$var$foldDrugName(b.condition)) return false;
    const na = $bb8a11e7c1131df5$var$warningDrugNames(a);
    const nb = $bb8a11e7c1131df5$var$warningDrugNames(b);
    if (!na.length || !nb.length) {
        const desc = $bb8a11e7c1131df5$var$foldDrugName(a.description);
        return !na.length && !nb.length && desc !== '' && desc === $bb8a11e7c1131df5$var$foldDrugName(b.description);
    }
    if (na.length !== nb.length) return false;
    const fa = na.map($bb8a11e7c1131df5$var$foldDrugName);
    const fb = nb.map($bb8a11e7c1131df5$var$foldDrugName);
    return na.every((n)=>$bb8a11e7c1131df5$var$isListed(n, fb)) && nb.every((n)=>$bb8a11e7c1131df5$var$isListed(n, fa));
};
const $bb8a11e7c1131df5$export$57fe41c96b1d272c = $bb8a11e7c1131df5$var$foldDrugName;
/**
 * Whether the page's reader reads Persian — the `readsPersianData` of the
 * locale descriptor, read from `<html lang>` (which I18nProvider owns) for the
 * callers that are not components. Only Persian does: an English or Arabic
 * reader cannot read the registry's Persian product string.
 */ const $bb8a11e7c1131df5$var$pageReadsPersian = ()=>{
    if (typeof document === 'undefined') return true;
    const lang = (document.documentElement.getAttribute('lang') || 'fa').toLowerCase();
    return lang.startsWith('fa');
};
const $bb8a11e7c1131df5$export$590163154e34e5bd = (drug, readsPersianData = $bb8a11e7c1131df5$var$pageReadsPersian())=>{
    const persian = (drug?.name || '').trim();
    const latin = (drug?.genericName || '').trim();
    if (!readsPersianData) {
        // `name` is not Persian on every row. An eRx row's is the registry's LATIN
        // product string («AMOXICILLIN 500 mg CAPSULE ORAL [AFAMOX]») under a
        // molecule-only `genericName` («AMOXICILLIN»), and it is the line that tells
        // two products of one molecule apart — dropping it left an Arabic reader a
        // product chooser of identical names. Only a Persian `name` is the noise.
        const readable = latin && persian && persian !== latin && !$bb8a11e7c1131df5$var$PERSIAN_LETTER.test(persian);
        return {
            primary: latin || persian,
            secondary: readable ? persian : ''
        };
    }
    // A row missing one of the two — a plan-suggested drug carries no generic —
    // shows the one it has, never an empty primary line. A row whose two names are
    // the SAME string is one name, not two: showing it twice reads as a bug.
    if (!persian || !latin || persian === latin) return {
        primary: persian || latin,
        secondary: ''
    };
    return {
        primary: latin,
        secondary: persian
    };
};


// What a doctor may pick for a prescribed drug's دوز, تناوب and نحوه مصرف.
//
// Closed lists, because the e-prescription sends these fields as codes and refuses a
// line it cannot code (doctor BFF lib/opnaji/parsinaRx.js). The formulary's own
// suggestions were the trap: a تأمین row offered its STRENGTH as the dose («5 MG»),
// some rows offered English frequencies («daily»), and every such line came back
// «مقدار هر نوبت باید «عدد + واحد» باشد» (K1, 2026-09-30). The dose is the AMOUNT PER
// TAKE in units of the product's own form — «۱ قرص» of a 5 mg tablet, not «5 mg».
//
// Every dose here is «<number> <form noun>», a noun parseDoseField reads (RX_DOSE_UNITS),
// and every frequency is a phrase resolveDosageText maps to an appendix-11 code.
const $ace44487380106d3$var$faDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// Insulin is taken in UNITS dialled from a pen, a cartridge or a vial that holds
// many doses. As an «آمپول» the only doses of an INSULIN ASPART 100 [iU]/mL 3 mL
// pen were «۱/۲ آمپول» — one whole pen a dose — and روزی سه بار × ۱ ماه worked
// out to 90 pens (K1, 2026-10-03). The amounts are the usual insulin doses. There
// is no default: no number of units is a safe guess, so a new line says «ناقص:
// دوز» until the doctor picks one.
const $ace44487380106d3$var$INSULIN_UNITS = Array.from({
    length: 60
}, (_, i)=>$ace44487380106d3$var$faDigits(i + 1));
// The product's form, read from its names: the eRx / تأمین name ends in the form and
// the route («… 5 mg TABLET ORAL»), the Persian name says it too («… قرص خوراکی»).
// Order matters: a DROPS line is also a SOLUTION, an injection is also a SOLUTION,
// an effervescent TABLET is still a tablet, and an insulin is also an INJECTION.
//
// `unit` names the noun in the catalogue (`visit.rx.doseUnit.*`) for a reader who
// does not read Persian — see doseLabel.
const $ace44487380106d3$var$FORMS = [
    {
        noun: "\u0648\u0627\u062D\u062F",
        unit: 'unit',
        re: /INSULIN|انسولین/i,
        amounts: $ace44487380106d3$var$INSULIN_UNITS,
        noDefault: true
    },
    {
        noun: "\u0634\u06CC\u0627\u0641",
        unit: 'suppository',
        re: /SUPPOSITOR|شیاف/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u067E\u0627\u0641",
        unit: 'puff',
        re: /INHAL|AEROSOL|SPRAY|اسپری|افشانه|استنشاقی/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3",
            "\u06F4"
        ]
    },
    {
        noun: "\u0642\u0637\u0631\u0647",
        unit: 'drop',
        re: /DROPS?\b|قطره/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3",
            "\u06F4",
            "\u06F5",
            "\u06F1\u06F0"
        ]
    },
    {
        noun: "\u0648\u06CC\u0627\u0644",
        unit: 'vial',
        re: /VIAL|ویال/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u0622\u0645\u067E\u0648\u0644",
        unit: 'ampoule',
        re: /INJECT|AMPOULE|AMPULE|PARENTERAL|آمپول|تزریقی/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u0642\u0631\u0635",
        unit: 'tablet',
        re: /TABLET|\bTAB\b|قرص/i,
        amounts: [
            "\u06F0\u066B\u06F2\u06F5",
            "\u06F0\u066B\u06F5",
            "\u06F1",
            "\u06F1\u066B\u06F5",
            "\u06F2",
            "\u06F3"
        ]
    },
    {
        noun: "\u06A9\u067E\u0633\u0648\u0644",
        unit: 'capsule',
        re: /CAPSULE|\bCAP\b|کپسول|پرل/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3"
        ]
    },
    {
        noun: "\u0633\u06CC \u0633\u06CC",
        unit: 'ml',
        re: /SYRUP|SUSPENSION|ELIXIR|SOLUTION.*ORAL|ORAL.*SOLUTION|شربت|سوسپانسیون|محلول خوراکی/i,
        amounts: [
            "\u06F2\u066B\u06F5",
            "\u06F5",
            "\u06F7\u066B\u06F5",
            "\u06F1\u06F0",
            "\u06F1\u06F5"
        ],
        start: "\u06F5"
    },
    {
        noun: "\u0633\u0627\u0634\u0647",
        unit: 'sachet',
        re: /SACHET|GRANULE|ساشه|گرانول/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    }
];
// A form the names do not state (a cream, a device): a count, sent with the eRx code.
const $ace44487380106d3$var$FALLBACK = {
    noun: "\u0639\u062F\u062F",
    unit: 'count',
    amounts: [
        "\u06F1",
        "\u06F2"
    ]
};
const $ace44487380106d3$var$namesOf = (drug)=>`${drug?.genericName || ''} ${drug?.name || ''}`;
function $ace44487380106d3$export$3e83362a56784c9(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    return $ace44487380106d3$var$FORMS.find((f)=>f.re.test(text)) || $ace44487380106d3$var$FALLBACK;
}
// A container that holds MANY doses: an insulin, a pen or a cartridge, a vial
// marked multi-dose, or an injectable whose strength is in units («[iU]», «IU»,
// «۱۰۰ واحد»: heparin, insulin vials). دوز × doses a day × days counts DOSES, and
// a month of one of these is a pen or two, not 90 — so its مقدار تحویلی is never
// worked out: the doctor types the number of pens or vials (K1, 2026-10-03).
const $ace44487380106d3$var$INJECTABLE = /INJECT|PARENTERAL|AMPOULE|AMPULE|VIAL|CARTRIDGE|PENFILL|\bPEN\b|PEN\]|آمپول|ویال|تزریقی|قلم|کارتریج/i;
const $ace44487380106d3$var$MANY_DOSES = /INSULIN|انسولین|\[I\.?U\]|\bI\.?U\b|[\d۰-۹]\s*واحد|CARTRIDGE|PENFILL|\bPEN\b|PEN\]|KWIKPEN|FLEXPEN|FLEXTOUCH|SOLOSTAR|MULTI-?\s?DOSE|قلم|کارتریج|چند\s*دوز/i;
function $ace44487380106d3$export$df367f6eb2d011ee(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    return $ace44487380106d3$var$INJECTABLE.test(text) && $ace44487380106d3$var$MANY_DOSES.test(text);
}
function $ace44487380106d3$export$23fceca71987facd(drug, current = '') {
    const f = $ace44487380106d3$export$3e83362a56784c9(drug);
    const list = f.amounts.map((a)=>`${a} ${f.noun}`);
    const cur = String(current || '').trim();
    return cur && !list.includes(cur) ? [
        cur,
        ...list
    ] : list;
}
function $ace44487380106d3$export$f3c4ec3c63ab1d60(drug) {
    const f = $ace44487380106d3$export$3e83362a56784c9(drug);
    if (f.noDefault) return '';
    return `${f.start || (f.amounts.includes("\u06F1") ? "\u06F1" : f.amounts[0])} ${f.noun}`;
}
const $ace44487380106d3$export$93a11165d6a55361 = [
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631",
    "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A",
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627",
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646",
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631",
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632",
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC",
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC"
];
function $ace44487380106d3$export$ac4b3f6873c02e40(current = '') {
    const cur = String(current || '').trim();
    return cur && !$ace44487380106d3$export$93a11165d6a55361.includes(cur) ? [
        cur,
        ...$ace44487380106d3$export$93a11165d6a55361
    ] : $ace44487380106d3$export$93a11165d6a55361;
}
// ── Is a stored value one of its closed list? ───────────────────────────────
//
// Asked the way the doctor BFF asks it (normalizeFa, lib/opnaji/terminology.js):
// Persian and Arabic-Indic digits read as ASCII, Arabic ي/ك as Persian, a ZWNJ as
// a space, a run of spaces as one. NOTHING else is folded — the BFF does not read
// «روزی ۲ بار» as «روزی دو بار», so a line holding it is not complete here either.
// A line used to count as complete as soon as each field held anything, and
// «Daily», «BID», «روزی ۲ بار» or a hand-typed route were then refused by the
// insurer after the visit (K1, 2026-10-03).
const $ace44487380106d3$var$listKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/\u200c/g, ' ').replace(/\s+/g, ' ').trim();
const $ace44487380106d3$var$FREQUENCY_KEYS = new Set($ace44487380106d3$export$93a11165d6a55361.map($ace44487380106d3$var$listKey));
const $ace44487380106d3$export$bad71ce44b13580d = (value)=>$ace44487380106d3$var$FREQUENCY_KEYS.has($ace44487380106d3$var$listKey(value));
// ── نحوه مصرف: one VALUE per route, whatever the UI language ────────────────
//
// The e-prescription codes a route from its STORED value (doctor BFF parsinaRx.js
// RX_ROUTE_CODES), keyed by the Persian names. The route list used to store its
// TRANSLATED label, so a route picked in the English or Arabic UI («Oral»,
// «فموي») was refused by the insurer (K1, 2026-10-03). The value is now the
// Persian name in every language; only the label the doctor reads is translated
// (`routeLabel`, from `visit.rx.routes.<key>`).
// i18n-exempt: wire values the doctor BFF matches — shown only through routeLabel
const $ace44487380106d3$var$ROUTE_VALUES = {
    oral: "\u062E\u0648\u0631\u0627\u06A9\u06CC",
    sublingual: "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC",
    iv: "\u062A\u0632\u0631\u06CC\u0642 \u0648\u0631\u06CC\u062F\u06CC",
    im: "\u062A\u0632\u0631\u06CC\u0642 \u0639\u0636\u0644\u0627\u0646\u06CC",
    sc: "\u062A\u0632\u0631\u06CC\u0642 \u0632\u06CC\u0631\u062C\u0644\u062F\u06CC",
    topical: "\u0645\u0648\u0636\u0639\u06CC (\u067E\u0648\u0633\u062A\u06CC)",
    inhaled: "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC",
    ophthalmic: "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC",
    otic: "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634\u06CC",
    nasal: "\u0628\u06CC\u0646\u06CC",
    rectal: "\u0645\u0642\u0639\u062F\u06CC",
    vaginal: "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644"
};
const $ace44487380106d3$export$d74359aba7d2c55a = Object.keys($ace44487380106d3$var$ROUTE_VALUES);
const $ace44487380106d3$export$4e844baf4fb2f82b = $ace44487380106d3$export$d74359aba7d2c55a.map((k)=>$ace44487380106d3$var$ROUTE_VALUES[k]);
// What else a stored route may say and still name its route: the English and
// Arabic labels the list stored before its values were fixed — lines written then
// are in the record, and must still read, and count, as their route — and the
// abbreviations the doctor BFF codes as well (RX_ROUTE_CODES_EN).
// i18n-exempt: matched against stored values — never displayed
const $ace44487380106d3$var$ROUTE_ALIASES = {
    oral: [
        'Oral',
        "\u0641\u0645\u0648\u064A",
        'PO'
    ],
    sublingual: [
        'Sublingual',
        "\u062A\u062D\u062A \u0627\u0644\u0644\u0633\u0627\u0646",
        'SL'
    ],
    iv: [
        'Intravenous',
        "\u0648\u0631\u064A\u062F\u064A",
        'IV'
    ],
    im: [
        'Intramuscular',
        "\u0639\u0636\u0644\u064A",
        'IM'
    ],
    sc: [
        'Subcutaneous',
        "\u062A\u062D\u062A \u0627\u0644\u062C\u0644\u062F",
        'SC'
    ],
    topical: [
        'Topical',
        "\u0645\u0648\u0636\u0639\u064A"
    ],
    inhaled: [
        'Inhaled',
        "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u064A"
    ],
    ophthalmic: [
        'Eye drops',
        "\u0642\u0637\u0631\u0629 \u0639\u064A\u0646\u064A\u0629",
        'ophthalmic'
    ],
    otic: [
        'Ear drops',
        "\u0642\u0637\u0631\u0629 \u0623\u0630\u0646\u064A\u0629",
        'otic'
    ],
    nasal: [
        'Intranasal',
        "\u0623\u0646\u0641\u064A"
    ],
    rectal: [
        'Rectal',
        "\u0634\u0631\u062C\u064A",
        'PR'
    ],
    vaginal: [
        'Vaginal',
        "\u0645\u0647\u0628\u0644\u064A",
        'PV'
    ]
};
const $ace44487380106d3$var$ROUTE_KEY_BY_TEXT = new Map($ace44487380106d3$export$d74359aba7d2c55a.flatMap((k)=>[
        $ace44487380106d3$var$ROUTE_VALUES[k],
        ...$ace44487380106d3$var$ROUTE_ALIASES[k]
    ].map((v)=>[
            $ace44487380106d3$var$listKey(v).toLowerCase(),
            k
        ])));
function $ace44487380106d3$export$ee4bfde455f56776(value) {
    const k = $ace44487380106d3$var$listKey(value).toLowerCase();
    return k && $ace44487380106d3$var$ROUTE_KEY_BY_TEXT.get(k) || null;
}
const $ace44487380106d3$export$333786c46079a63a = (key)=>$ace44487380106d3$var$ROUTE_VALUES[key] || '';
const $ace44487380106d3$export$242a279056f60471 = (value)=>$ace44487380106d3$export$ee4bfde455f56776(value) !== null;
const $ace44487380106d3$export$1aea987f77fa496a = (value)=>$ace44487380106d3$export$333786c46079a63a($ace44487380106d3$export$ee4bfde455f56776(value));
const $ace44487380106d3$var$ROUTE_KEY_BY_VALUE = new Map($ace44487380106d3$export$d74359aba7d2c55a.map((k)=>[
        $ace44487380106d3$var$listKey($ace44487380106d3$var$ROUTE_VALUES[k]),
        k
    ]));
function $ace44487380106d3$export$80ace2b99405d272(value, t) {
    const k = $ace44487380106d3$var$ROUTE_KEY_BY_VALUE.get($ace44487380106d3$var$listKey(value));
    return k ? t(`visit.rx.routes.${k}`) : String(value ?? '');
}
// ── A دوز, read in another language ────────────────────────────────────────
//
// The دوز is stored as the closed list writes it — «۱ کپسول» — because that is
// what the e-prescription parses, and it does not move. A reader who does not
// read Persian sees it through the catalogue instead: the amount as a NUMBER the
// locale formats and pluralises («1 capsule», «2 capsules», «١ كبسولة», «٣
// كبسولات»), the noun from `visit.rx.doseUnit.*`. It used to go through the
// English plan translator for every such reader, so an Arabic نسخه read
// «1 capsule كل ٨ ساعات» — English in the middle of an Arabic line.
const $ace44487380106d3$var$DOSE_UNIT_BY_NOUN = new Map([
    ...$ace44487380106d3$var$FORMS,
    $ace44487380106d3$var$FALLBACK
].map((f)=>[
        $ace44487380106d3$var$listKey(f.noun),
        f.unit
    ]));
function $ace44487380106d3$export$6742958aefab4338(value, t) {
    const m = $ace44487380106d3$var$listKey(value).replace(/[٫,]/g, '.').match(/^(\d+(?:\.\d+)?)\s+(.+)$/);
    const unit = m && $ace44487380106d3$var$DOSE_UNIT_BY_NOUN.get(m[2]);
    if (!unit || typeof t !== 'function') return '';
    return t(`visit.rx.doseUnit.${unit}`, {
        count: Number(m[1])
    });
}
// ── A مدت, read in another language ─────────────────────────────────────────
//
// The مدت field offers `visit.duration.*` in the reader's language (DURATIONS in
// Visit.shared). A value that arrives from elsewhere — the model's «10 روز», a
// line stored under a Persian UI — is read through the same keys, by the days it
// covers. A span that is not one of the listed ones is shown as written.
const $ace44487380106d3$var$DURATION_KEY_BY_DAYS = new Map([
    [
        3,
        'd3'
    ],
    [
        5,
        'd5'
    ],
    [
        7,
        'd7'
    ],
    [
        10,
        'd10'
    ],
    [
        14,
        'd14'
    ],
    [
        30,
        'm1'
    ],
    [
        60,
        'm2'
    ],
    [
        90,
        'm3'
    ],
    [
        180,
        'm6'
    ]
]);
function $ace44487380106d3$export$6983ec1528bb4f57(value, t) {
    const raw = String(value ?? '').trim();
    if (!raw || typeof t !== 'function') return raw;
    const key = $ace44487380106d3$var$DURATION_KEY_BY_DAYS.get($ace44487380106d3$var$durationDays(raw));
    return key ? t(`visit.duration.${key}`) : raw;
}
// The route the product's name states — the key of RX_ROUTES' `visit.rx.routes.*`.
// An injection names no route («PARENTERAL»): IV, IM and SC stay the doctor's call.
const $ace44487380106d3$var$ROUTES = [
    [
        'sublingual',
        /SUBLINGUAL|زیرزبانی/i
    ],
    [
        'ophthalmic',
        /OPHTHALMIC|چشمی/i
    ],
    [
        'otic',
        /\bOTIC|AURICULAR|گوشی/i
    ],
    [
        'nasal',
        /NASAL|بینی/i
    ],
    [
        'inhaled',
        /INHALATION|RESPIRATORY|استنشاقی/i
    ],
    [
        'rectal',
        /RECTAL|مقعدی/i
    ],
    [
        'vaginal',
        /VAGINAL|واژینال/i
    ],
    [
        'iv',
        /INTRAVENOUS|وریدی/i
    ],
    [
        'im',
        /INTRAMUSCULAR|عضلانی/i
    ],
    [
        'sc',
        /SUBCUTANEOUS|زیرجلدی/i
    ],
    [
        'topical',
        /TOPICAL|CUTANEOUS|TRANSDERMAL|موضعی|پوستی/i
    ],
    [
        'oral',
        /\bORAL\b|خوراکی/i
    ]
];
function $ace44487380106d3$export$973512cfacf8eb2c(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    const hit = $ace44487380106d3$var$ROUTES.find(([, re])=>re.test(text));
    return hit ? hit[0] : null;
}
const $ace44487380106d3$export$ae410c87a5d0011f = (drug)=>$ace44487380106d3$export$333786c46079a63a($ace44487380106d3$export$973512cfacf8eb2c(drug));
// «روزی ۳ بار» and «روزی سه بار» are one frequency: the formulary writes either.
// This maps a value ONTO the list (a default, an AI's answer); whether a stored
// value already IS on it is isFrequencyOption's question, asked more strictly.
const $ace44487380106d3$var$COUNT_WORDS = {
    1: "\u06CC\u06A9",
    2: "\u062F\u0648",
    3: "\u0633\u0647",
    4: "\u0686\u0647\u0627\u0631"
};
const $ace44487380106d3$var$freqKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/\b[1-4]\b/g, (m)=>$ace44487380106d3$var$COUNT_WORDS[m]).replace(/[\u200c\u00a0]/g, ' ').replace(/\s+/g, ' ').trim();
function $ace44487380106d3$export$84160816d8079a95(drug) {
    const key = $ace44487380106d3$var$freqKey(drug?.commonFrequencies?.[0]);
    return key && $ace44487380106d3$export$93a11165d6a55361.find((o)=>$ace44487380106d3$var$freqKey(o) === key) || '';
}
function $ace44487380106d3$export$48f972f5effb9c(q) {
    const ascii = String(q ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[^\d]/g, '');
    return ascii ? Number(ascii) : null;
}
const $ace44487380106d3$export$b30a5604adc93160 = [
    'dosage',
    'frequency',
    'route',
    'quantity'
];
function $ace44487380106d3$export$e9b4e5de48a21156(row = {}) {
    return $ace44487380106d3$export$b30a5604adc93160.filter((k)=>{
        if (k === 'quantity') return !($ace44487380106d3$export$48f972f5effb9c(row.quantity) > 0);
        if (k === 'frequency') return !$ace44487380106d3$export$bad71ce44b13580d(row.frequency);
        if (k === 'route') return !$ace44487380106d3$export$242a279056f60471(row.route);
        return !String(row[k] ?? '').trim();
    });
}
// «ناقص: تناوب، مقدار تحویلی» — the missing fields by their form labels.
const $ace44487380106d3$var$RX_FIELD_LABEL_KEYS = {
    dosage: 'visit.rx.dose',
    frequency: 'visit.rx.frequency',
    route: 'visit.rx.route',
    quantity: 'visit.rx.quantity'
};
const $ace44487380106d3$export$a1043144d576f6b6 = (missing, t)=>missing.map((k)=>t($ace44487380106d3$var$RX_FIELD_LABEL_KEYS[k])).join(t('visit.rx.incompleteSep'));
function $ace44487380106d3$export$ab36a14ecd73702e(missing, t) {
    return t('visit.rx.incomplete', {
        fields: $ace44487380106d3$export$a1043144d576f6b6(missing, t)
    });
}
// ── مقدار تحویلی, worked out ────────────────────────────────────────────────
//
// دوز × doses a day × days of the course, for a form that is dispensed by the
// unit it is taken in: a tablet, a capsule, a suppository, a sachet, an ampoule,
// a vial. A syrup's dose is in سی سی and drops or puffs come from a bottle — how
// many BOTTLES that is depends on the pack, so those stay the doctor's to type.
// So do insulin's units («واحد» is not counted here) and every container that
// holds many doses (isMultiDoseInjectable): a pen is not used up by one dose.
const $ace44487380106d3$var$COUNTED_IN_DOSE_UNITS = new Set([
    "\u0642\u0631\u0635",
    "\u06A9\u067E\u0633\u0648\u0644",
    "\u0634\u06CC\u0627\u0641",
    "\u0633\u0627\u0634\u0647",
    "\u0622\u0645\u067E\u0648\u0644",
    "\u0648\u06CC\u0627\u0644"
]);
// Doses a day for each frequency choice. «در صورت نیاز» and the meal-bound ones
// are absent on purpose: they say when, not how often.
const $ace44487380106d3$var$PER_DAY = new Map([
    [
        "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1
    ],
    [
        "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631",
        2
    ],
    [
        "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631",
        3
    ],
    [
        "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631",
        4
    ],
    [
        "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A",
        6
    ],
    [
        "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A",
        4
    ],
    [
        "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A",
        3
    ],
    [
        "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A",
        2
    ],
    [
        "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
        1
    ],
    [
        "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627",
        1
    ],
    [
        "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646",
        0.5
    ],
    [
        "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 7
    ],
    [
        "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631",
        2 / 7
    ],
    [
        "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 14
    ],
    [
        "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 30
    ]
].map(([k, v])=>[
        $ace44487380106d3$var$freqKey(k),
        v
    ]));
const $ace44487380106d3$var$asciiDigits = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[٫,]/g, '.');
function $ace44487380106d3$var$doseAmount(dosage) {
    const m = $ace44487380106d3$var$asciiDigits(dosage).trim().match(/^(\d+(?:\.\d+)?)\s+(.+)$/);
    if (!m || !$ace44487380106d3$var$COUNTED_IN_DOSE_UNITS.has(m[2].trim())) return null;
    const n = Number(m[1]);
    return n > 0 ? n : null;
}
// The course length, in days, from the stored duration in whichever language it
// was written («5 روز», «1 month», «3 أشهر» — and Arabic's «شهر» / «شهران», which
// carry no digit). «تا اطلاع ثانوی» has no end, so no quantity follows from it.
function $ace44487380106d3$var$durationDays(duration) {
    const s = $ace44487380106d3$var$asciiDigits(duration).trim().toLowerCase();
    if (s === "\u0634\u0647\u0631") return 30;
    if (s === "\u0634\u0647\u0631\u0627\u0646") return 60;
    const m = s.match(/(\d+)\s*(روز|days?|يوم|أيام|هفته|weeks?|أسبوع|أسابيع|ماه|months?|شهر|أشهر)/);
    if (!m) return null;
    const n = Number(m[1]);
    const unit = m[2];
    const per = /هفته|week|أسبوع|أسابيع/.test(unit) ? 7 : /ماه|month|شهر|أشهر/.test(unit) ? 30 : 1;
    return n > 0 ? n * per : null;
}
function $ace44487380106d3$export$d2b1f8f4188143eb({ drug: drug, dosage: dosage, frequency: frequency, duration: duration } = {}) {
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return null;
    const amount = $ace44487380106d3$var$doseAmount(dosage);
    const perDay = $ace44487380106d3$var$PER_DAY.get($ace44487380106d3$var$freqKey(frequency));
    const days = $ace44487380106d3$var$durationDays(duration);
    if (!amount || !perDay || !days) return null;
    // The epsilon keeps 1/7 × 7 = 1.0000000000000002 from rounding up to 2.
    return Math.max(1, Math.ceil(amount * perDay * days - 1e-9));
}
// ── Any two of مقدار تحویلی, تناوب and مدت settle the third ───────────────────
//
// quantity = دوز × doses a day × days, so a doctor who writes «۳۰ قرص، روزی سه
// بار» has said «۱۰ روز» (K1, 2026-10-03). Whichever two are set, an EMPTY third
// is worked out — as one of its own field's options, since both are closed lists:
//   • مدت: the listed duration whose count is exactly this one, else the nearest
//     listed duration within a quarter of the days the count covers (20 tablets
//     at three a day is «7 روز»); nothing when no listed duration is that close;
//   • تناوب: the option whose doses a day give exactly this count over the course,
//     «روزی N بار» before «هر X ساعت»; nothing when none does — a frequency is
//     the instruction itself, never rounded;
//   • مقدار تحویلی: as above (quantityFor).
// Counted forms only, like the quantity: a syrup's bottles say nothing of days.
// A value the doctor chose is never replaced. The field the app filled is marked
// on the line (`derivedField`, never saved) so it keeps following the other two —
// and is cleared, not left stale, once they no longer settle it.
const $ace44487380106d3$var$DURATION_TOLERANCE = 0.25;
function $ace44487380106d3$export$714272fa680980ea(row = {}, durations = []) {
    const { drug: drug, dosage: dosage, frequency: frequency } = row;
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return '';
    const amount = $ace44487380106d3$var$doseAmount(dosage);
    const perDay = $ace44487380106d3$var$PER_DAY.get($ace44487380106d3$var$freqKey(frequency));
    const q = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    if (!amount || !perDay || !(q > 0) || !durations?.length) return '';
    const exact = durations.find((d)=>$ace44487380106d3$export$d2b1f8f4188143eb({
            drug: drug,
            dosage: dosage,
            frequency: frequency,
            duration: d
        }) === q);
    if (exact) return exact;
    const days = q / (amount * perDay);
    let best = '';
    let err = Infinity;
    for (const d of durations){
        const n = $ace44487380106d3$var$durationDays(d);
        if (!n) continue;
        const e = Math.abs(n - days) / days;
        if (e < err) {
            best = d;
            err = e;
        }
    }
    return err <= $ace44487380106d3$var$DURATION_TOLERANCE ? best : '';
}
function $ace44487380106d3$export$2992050be156a590(row = {}) {
    const { drug: drug, dosage: dosage, duration: duration } = row;
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return '';
    const q = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    if (!$ace44487380106d3$var$doseAmount(dosage) || !$ace44487380106d3$var$durationDays(duration) || !(q > 0)) return '';
    return $ace44487380106d3$export$93a11165d6a55361.find((f)=>$ace44487380106d3$var$PER_DAY.has($ace44487380106d3$var$freqKey(f)) && $ace44487380106d3$export$d2b1f8f4188143eb({
            drug: drug,
            dosage: dosage,
            frequency: f,
            duration: duration
        }) === q) || '';
}
// The order an empty one of the three is filled in.
const $ace44487380106d3$var$RX_TRIPLE = [
    'quantity',
    'duration',
    'frequency'
];
const $ace44487380106d3$var$isEmpty = (v)=>!String(v ?? '').trim();
function $ace44487380106d3$var$deriveField(key, row, durations) {
    if (key === 'quantity') {
        const q = $ace44487380106d3$export$d2b1f8f4188143eb(row);
        return q ? String(q) : '';
    }
    return key === 'duration' ? $ace44487380106d3$export$714272fa680980ea(row, durations) : $ace44487380106d3$export$2992050be156a590(row);
}
function $ace44487380106d3$export$8dbcc67e0ab5a150(row, { durations: durations = [] } = {}) {
    if (!row) return row;
    if (!($ace44487380106d3$export$48f972f5effb9c(row.quantity) > 0)) {
        const q = $ace44487380106d3$export$d2b1f8f4188143eb(row);
        return q ? {
            ...row,
            quantity: String(q)
        } : row;
    }
    for (const key of [
        'duration',
        'frequency'
    ]){
        if (!$ace44487380106d3$var$isEmpty(row[key])) continue;
        const v = $ace44487380106d3$var$deriveField(key, row, durations);
        if (v) return {
            ...row,
            [key]: v,
            derivedField: key
        };
    }
    return row;
}
function $ace44487380106d3$export$b0f426f8468d8007(row, key, val, { durations: durations = [], targets: targets = $ace44487380106d3$var$RX_TRIPLE } = {}) {
    const next = {
        ...row,
        [key]: val
    };
    if (key !== 'dosage' && !$ace44487380106d3$var$RX_TRIPLE.includes(key)) return next;
    if (row.derivedField === key) next.derivedField = undefined; // the doctor took it over
    const open = (k)=>k !== key && targets.includes(k);
    const had = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    const target = (row.derivedField && open(row.derivedField) ? row.derivedField : null) || $ace44487380106d3$var$RX_TRIPLE.find((k)=>open(k) && $ace44487380106d3$var$isEmpty(row[k])) || (!row.derivedField && open('quantity') && had > 0 && had === $ace44487380106d3$export$d2b1f8f4188143eb(row) ? 'quantity' : null);
    if (!target) return next;
    const value = $ace44487380106d3$var$deriveField(target, next, durations);
    if (!value && $ace44487380106d3$var$isEmpty(row[target])) return next; // nothing to fill, nothing of ours to clear
    next[target] = value;
    if (target !== 'quantity') next.derivedField = value ? target : undefined;
    return next;
}
// ── An AI's answer, held to the closed lists ────────────────────────────────
//
// The «نسخه»'s AI helpers propose a whole line — and models write a dose as a
// strength («500mg»), a frequency in last year's words («شب‌ها قبل از خواب»), a
// quantity as packs («1 بسته»). Each such value would land outside the field's
// closed list and the e-prescription would refuse the line (K1, 2026-10-03). So a
// proposal's values are mapped onto the options here: the same option in other
// digits or words becomes that option; anything else is dropped, and the line
// starts from the app's own default for that field instead.
const $ace44487380106d3$var$NUMBER_WORDS = {
    "\u0646\u06CC\u0645": '0.5',
    "\u06CC\u06A9": '1',
    "\u062F\u0648": '2',
    "\u0633\u0647": '3',
    "\u0686\u0647\u0627\u0631": '4'
};
const $ace44487380106d3$var$plainKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[٫,]/g, '.').replace(/[‌ ]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
const $ace44487380106d3$var$doseKey = (s)=>$ace44487380106d3$var$plainKey(s).replace(/^(نیم|یک|دو|سه|چهار)(?=\s)/, (w)=>$ace44487380106d3$var$NUMBER_WORDS[w]);
function $ace44487380106d3$export$af120d81d82db54b(drug, value) {
    const k = $ace44487380106d3$var$doseKey(value);
    return k && $ace44487380106d3$export$23fceca71987facd(drug).find((o)=>$ace44487380106d3$var$doseKey(o) === k) || '';
}
function $ace44487380106d3$export$698a3d49e661c86e(value) {
    const k = $ace44487380106d3$var$freqKey(value);
    return k && $ace44487380106d3$export$93a11165d6a55361.find((o)=>$ace44487380106d3$var$freqKey(o) === k) || '';
}
function $ace44487380106d3$export$ab1f7fee793c0c30(value, options = []) {
    const k = $ace44487380106d3$var$plainKey(value);
    return k && options.find((o)=>$ace44487380106d3$var$plainKey(o) === k) || '';
}
function $ace44487380106d3$export$e8df75bdc9e038c6(drug, defaults = {}, { durations: durations = [] } = {}) {
    const q = String(defaults.quantity ?? '').trim();
    return {
        ...defaults,
        dosage: $ace44487380106d3$export$af120d81d82db54b(drug, defaults.dosage) || undefined,
        frequency: $ace44487380106d3$export$698a3d49e661c86e(defaults.frequency) || undefined,
        route: $ace44487380106d3$export$1aea987f77fa496a(defaults.route),
        duration: $ace44487380106d3$export$ab1f7fee793c0c30(defaults.duration, durations),
        quantity: /^[\d۰-۹٠-٩]+$/.test(q) && $ace44487380106d3$export$48f972f5effb9c(q) > 0 ? String($ace44487380106d3$export$48f972f5effb9c(q)) : ''
    };
}
function $ace44487380106d3$export$2e037991db2fc726(drug, defaults = {}, { durations: durations = [] } = {}) {
    const out = {};
    const put = (key, value)=>{
        const v = String(value ?? '').trim();
        if (v) out[key] = v;
    };
    put('dosage', $ace44487380106d3$export$af120d81d82db54b(drug, defaults.dosage) || defaults.dosage);
    put('frequency', $ace44487380106d3$export$698a3d49e661c86e(defaults.frequency) || defaults.frequency);
    put('route', $ace44487380106d3$export$1aea987f77fa496a(defaults.route) || defaults.route);
    put('duration', $ace44487380106d3$export$ab1f7fee793c0c30(defaults.duration, durations) || defaults.duration);
    const q = String(defaults.quantity ?? '').trim();
    if (/^[\d۰-۹٠-٩]+$/.test(q) && $ace44487380106d3$export$48f972f5effb9c(q) > 0) out.quantity = String($ace44487380106d3$export$48f972f5effb9c(q));
    put('instructions', defaults.instructions);
    return out;
}
function $ace44487380106d3$export$5352dbb17a06665d(drug, defaults = {}, seq = 0, { durations: durations = [] } = {}) {
    return $ace44487380106d3$export$8dbcc67e0ab5a150({
        // Date.now() alone collides when a batch is added in the same millisecond,
        // and a duplicated React key silently drops rows from the list.
        id: `${Date.now()}-${seq}-${drug.id}`,
        drug: drug,
        dosage: defaults.dosage ?? $ace44487380106d3$export$f3c4ec3c63ab1d60(drug),
        frequency: defaults.frequency ?? $ace44487380106d3$export$84160816d8079a95(drug),
        route: defaults.route || '',
        duration: defaults.duration || '',
        quantity: defaults.quantity || '',
        instructions: defaults.instructions || ''
    }, {
        durations: durations
    });
}
function $ace44487380106d3$export$c1d8ac96a7e23c6f(row, answer, { durations: durations = [] } = {}) {
    if (!row || !answer) return row;
    let next = row;
    const fill = (key, value, open)=>{
        if (value && open) next = $ace44487380106d3$export$b0f426f8468d8007(next, key, value, {
            durations: durations
        });
    };
    fill('dosage', answer.dosage, !String(row.dosage ?? '').trim() || row.dosage === $ace44487380106d3$export$f3c4ec3c63ab1d60(row.drug));
    fill('frequency', $ace44487380106d3$export$698a3d49e661c86e(answer.frequency), !$ace44487380106d3$export$bad71ce44b13580d(row.frequency));
    fill('route', $ace44487380106d3$export$1aea987f77fa496a(answer.route), !$ace44487380106d3$export$242a279056f60471(row.route) || row.route === $ace44487380106d3$export$ae410c87a5d0011f(row.drug));
    fill('duration', answer.duration, !String(row.duration ?? '').trim());
    if (!($ace44487380106d3$export$48f972f5effb9c(next.quantity) > 0) && answer.quantity) next = {
        ...next,
        quantity: answer.quantity
    };
    return next === row ? row : {
        ...next,
        aiNote: answer.note || ''
    };
}
const $ace44487380106d3$export$eeb7c46608d96e19 = $ace44487380106d3$export$93a11165d6a55361[0];
function $ace44487380106d3$export$87bc9af39161d883(drug, usual, { defaultDuration: defaultDuration = '' } = {}) {
    const u = usual || {};
    const sig = {
        dosage: u.dosage || $ace44487380106d3$export$f3c4ec3c63ab1d60(drug),
        frequency: u.frequency || $ace44487380106d3$export$84160816d8079a95(drug) || $ace44487380106d3$export$eeb7c46608d96e19,
        route: u.route || $ace44487380106d3$export$ae410c87a5d0011f(drug),
        duration: u.duration || defaultDuration,
        instructions: u.instructions || ''
    };
    const sameSig = u.quantity && [
        'dosage',
        'frequency',
        'duration'
    ].every((k)=>sig[k] === u[k]);
    return {
        ...sig,
        quantity: sameSig ? u.quantity : ''
    };
}
function $ace44487380106d3$export$e4f91298b6c5a0f0(label) {
    const s = String(label || '').replace(/[أإآ]/g, "\u0627").replace(/\s+/g, ' ').trim().toLowerCase();
    if (!s) return null;
    if (s.includes("\u062A\u0627\u0645\u06CC\u0646") || s === 'social' || s.includes('tamin')) return 'tamin';
    return null;
}
function $ace44487380106d3$export$60f8cb686aa6701e(drug, insurer) {
    if (insurer !== 'tamin' || !drug?.id) return null;
    return typeof drug.taminListed === 'boolean' ? drug.taminListed : null;
}
function $ace44487380106d3$export$6c8fe862de8e39ae(drugs, insurer) {
    const states = (drugs || []).map((d)=>$ace44487380106d3$export$60f8cb686aa6701e(d, insurer));
    if (states.some((s)=>s === true)) return true;
    return states.length && states.every((s)=>s === false) ? false : null;
}
function $ace44487380106d3$export$fd52a5511e853f43(entry, lists) {
    if (!entry?.drug?.id) return null;
    const sig = {
        dosage: entry.dosage,
        frequency: entry.frequency,
        route: entry.route,
        duration: entry.duration,
        quantity: entry.quantity
    };
    const mapped = $ace44487380106d3$export$e8df75bdc9e038c6(entry.drug, sig, lists);
    const intact = [
        'dosage',
        'frequency',
        'duration'
    ].every((k)=>mapped[k]);
    return {
        dosage: mapped.dosage,
        frequency: mapped.frequency,
        route: mapped.route,
        duration: mapped.duration,
        quantity: intact ? mapped.quantity : '',
        instructions: String(entry.instructions || '').trim()
    };
}


const $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a = 50;
const $5e2e0b7ea22d1ff2$export$14e010b4b1ab287e = 120;
const $5e2e0b7ea22d1ff2$export$fb3297c0e60769da = 500;
const $5e2e0b7ea22d1ff2$export$5f711b58035cee0 = 200;
const $5e2e0b7ea22d1ff2$export$b835574315bb6fe = [
    'medication',
    'order'
];
const $5e2e0b7ea22d1ff2$export$7fe249ad93dcc233 = [
    'lab',
    'imaging',
    'procedure',
    'other'
];
const $5e2e0b7ea22d1ff2$export$c9b31a4acc93d37d = [
    'routine',
    'urgent',
    'stat'
];
// ── GraphQL ──────────────────────────────────────────────────────────────────
const $5e2e0b7ea22d1ff2$var$MED_ITEM_FIELDS = 'drugId name genericName dosage frequency route duration quantity instructions';
const $5e2e0b7ea22d1ff2$var$ORD_ITEM_FIELDS = 'orderType name catalogId code urgency notes sessionCount';
const $5e2e0b7ea22d1ff2$var$MED_FIELDS = `id title description updatedAt items { ${$5e2e0b7ea22d1ff2$var$MED_ITEM_FIELDS} }`;
const $5e2e0b7ea22d1ff2$var$ORD_FIELDS = `id title description updatedAt items { ${$5e2e0b7ea22d1ff2$var$ORD_ITEM_FIELDS} }`;
const $5e2e0b7ea22d1ff2$export$ec65b30d180d4ef = `query MedicationTemplates{medicationTemplates{${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$95d049bf5f64bb7d = `query OrderTemplates{orderTemplates{${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$e16fea1a0a21b540 = `mutation AddMedicationTemplate($input:MedicationTemplateInput!){addMedicationTemplate(input:$input){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$863f702bf73a955d = `mutation UpdateMedicationTemplate($id:ID!,$input:MedicationTemplateInput!){updateMedicationTemplate(id:$id,input:$input){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$c4e9fb414738a0b0 = `mutation DuplicateMedicationTemplate($id:ID!){duplicateMedicationTemplate(id:$id){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$6228a01070183d6d = `mutation DeleteMedicationTemplate($id:ID!){deleteMedicationTemplate(id:$id)}`;
const $5e2e0b7ea22d1ff2$export$75fee887852c226f = `mutation AddOrderTemplate($input:OrderTemplateInput!){addOrderTemplate(input:$input){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$a6f87369be8a4720 = `mutation UpdateOrderTemplate($id:ID!,$input:OrderTemplateInput!){updateOrderTemplate(id:$id,input:$input){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$d4954dee18c11fa4 = `mutation DuplicateOrderTemplate($id:ID!){duplicateOrderTemplate(id:$id){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$ccad65d57167dba = `mutation DeleteOrderTemplate($id:ID!){deleteOrderTemplate(id:$id)}`;
const $5e2e0b7ea22d1ff2$export$77f43b7c8f6b1caf = `mutation ApplyMedicationTemplate($templateId:ID!,$appointmentId:ID!,$patientId:ID!,$itemIndexes:[Int!]){applyMedicationTemplate(templateId:$templateId,appointmentId:$appointmentId,patientId:$patientId,itemIndexes:$itemIndexes){templateId templateTitle appliedCount failures{name reason} medications{id code display status dosageInstruction meta taminListed}}}`;
const $5e2e0b7ea22d1ff2$export$d0abd4e5a22ebbe = `mutation ApplyOrderTemplate($templateId:ID!,$appointmentId:ID!,$patientId:ID!,$itemIndexes:[Int!]){applyOrderTemplate(templateId:$templateId,appointmentId:$appointmentId,patientId:$patientId,itemIndexes:$itemIndexes){templateId templateTitle appliedCount failures{name reason} orders{id orderType description urgency status notes createdAt performedDate code catalogId}}}`;
const $5e2e0b7ea22d1ff2$export$46ab2989285eb791 = `query ListMedications($patientId:ID!,$appointmentId:ID){listMedications(patientId:$patientId,appointmentId:$appointmentId){id code display status dosageInstruction meta taminListed}}`;
const $5e2e0b7ea22d1ff2$export$a2d52108c6de7f27 = {
    medication: {
        kind: 'medication',
        listQuery: $5e2e0b7ea22d1ff2$export$ec65b30d180d4ef,
        listField: 'medicationTemplates',
        addMutation: $5e2e0b7ea22d1ff2$export$e16fea1a0a21b540,
        addField: 'addMedicationTemplate',
        updateMutation: $5e2e0b7ea22d1ff2$export$863f702bf73a955d,
        updateField: 'updateMedicationTemplate',
        duplicateMutation: $5e2e0b7ea22d1ff2$export$c4e9fb414738a0b0,
        duplicateField: 'duplicateMedicationTemplate',
        deleteMutation: $5e2e0b7ea22d1ff2$export$6228a01070183d6d,
        deleteField: 'deleteMedicationTemplate',
        applyMutation: $5e2e0b7ea22d1ff2$export$77f43b7c8f6b1caf,
        applyField: 'applyMedicationTemplate',
        // The kind's NAME lives with the editor that owns it, so the Visit picker
        // and the Settings tab cannot end up calling the same thing two things.
        labelKey: 'settings.templates.medication.label',
        hintKey: 'settings.templates.medication.hint',
        emptyKey: 'settings.templates.medication.empty',
        explainKey: 'settings.templates.medication.explain',
        newKey: 'settings.templates.medication.new'
    },
    order: {
        kind: 'order',
        listQuery: $5e2e0b7ea22d1ff2$export$95d049bf5f64bb7d,
        listField: 'orderTemplates',
        addMutation: $5e2e0b7ea22d1ff2$export$75fee887852c226f,
        addField: 'addOrderTemplate',
        updateMutation: $5e2e0b7ea22d1ff2$export$a6f87369be8a4720,
        updateField: 'updateOrderTemplate',
        duplicateMutation: $5e2e0b7ea22d1ff2$export$d4954dee18c11fa4,
        duplicateField: 'duplicateOrderTemplate',
        deleteMutation: $5e2e0b7ea22d1ff2$export$ccad65d57167dba,
        deleteField: 'deleteOrderTemplate',
        applyMutation: $5e2e0b7ea22d1ff2$export$d0abd4e5a22ebbe,
        applyField: 'applyOrderTemplate',
        labelKey: 'settings.templates.order.label',
        hintKey: 'settings.templates.order.hint',
        emptyKey: 'settings.templates.order.empty',
        explainKey: 'settings.templates.order.explain',
        newKey: 'settings.templates.order.new'
    }
};
const $5e2e0b7ea22d1ff2$export$47a272116a5ed65b = ()=>({
        drugId: '',
        name: '',
        genericName: '',
        dosage: '',
        frequency: '',
        route: '',
        duration: '',
        quantity: '',
        instructions: ''
    });
const $5e2e0b7ea22d1ff2$export$9b75ebcf168938fe = (drug, defaults = {})=>({
        drugId: drug?.id || '',
        name: drug?.name || '',
        genericName: drug?.genericName || '',
        dosage: defaults.dosage ?? (0, $ace44487380106d3$export$f3c4ec3c63ab1d60)(drug),
        frequency: defaults.frequency ?? (0, $ace44487380106d3$export$84160816d8079a95)(drug),
        route: defaults.route || '',
        duration: defaults.duration || '',
        quantity: defaults.quantity || '',
        instructions: defaults.instructions || '',
        commonDosages: drug?.commonDosages || [],
        commonFrequencies: drug?.commonFrequencies || []
    });
const $5e2e0b7ea22d1ff2$export$5f07940018c62174 = (draft)=>new Set((draft?.items || []).map((item)=>item.drugId).filter(Boolean));
const $5e2e0b7ea22d1ff2$export$604beaf67ef18d4d = ()=>({
        orderType: 'lab',
        name: '',
        catalogId: null,
        code: '',
        urgency: 'routine',
        notes: '',
        sessionCount: 0
    });
const $5e2e0b7ea22d1ff2$export$f533e11413e84a55 = (kind)=>kind === 'order' ? $5e2e0b7ea22d1ff2$export$604beaf67ef18d4d() : $5e2e0b7ea22d1ff2$export$47a272116a5ed65b();
const $5e2e0b7ea22d1ff2$export$41368fcaa4adc5d3 = ()=>({
        title: '',
        description: '',
        items: []
    });
const $5e2e0b7ea22d1ff2$export$6db8446c3a030733 = (kind, template)=>{
    if (!template) return $5e2e0b7ea22d1ff2$export$41368fcaa4adc5d3();
    const blank = $5e2e0b7ea22d1ff2$export$f533e11413e84a55(kind);
    return {
        title: template.title || '',
        description: template.description || '',
        items: (template.items || []).map((item)=>({
                ...blank,
                ...item
            }))
    };
};
const $5e2e0b7ea22d1ff2$export$d2a97effe7dc2dbb = (kind, draft)=>{
    const trim = (v)=>typeof v === 'string' ? v.trim() : v;
    const items = (draft.items || []).map((item)=>{
        if (kind === 'order') return {
            orderType: item.orderType || 'lab',
            name: trim(item.name) || '',
            catalogId: item.catalogId || null,
            code: trim(item.code) || '',
            urgency: item.urgency || 'routine',
            notes: trim(item.notes) || '',
            sessionCount: Number(item.sessionCount) || 0
        };
        return {
            drugId: trim(item.drugId) || '',
            name: trim(item.name) || '',
            genericName: trim(item.genericName) || '',
            dosage: trim(item.dosage) || '',
            frequency: trim(item.frequency) || '',
            route: trim(item.route) || '',
            duration: trim(item.duration) || '',
            quantity: trim(item.quantity) || '',
            instructions: trim(item.instructions) || ''
        };
    });
    return {
        title: trim(draft.title) || '',
        description: trim(draft.description) || '',
        items: items
    };
};
function $5e2e0b7ea22d1ff2$export$2a244ffb744b0c05(kind, draft) {
    const errors = {
        items: {}
    };
    const title = (draft?.title || '').trim();
    if (!title) errors.title = 'validation.template.title';
    else if (title.length > $5e2e0b7ea22d1ff2$export$14e010b4b1ab287e) errors.title = 'validation.template.titleTooLong';
    if ((draft?.description || '').trim().length > $5e2e0b7ea22d1ff2$export$fb3297c0e60769da) errors.description = 'validation.template.descriptionTooLong';
    const items = draft?.items || [];
    if (items.length > $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a) errors.itemCount = 'validation.template.tooManyItems';
    items.forEach((item, index)=>{
        const itemErrors = {};
        if (!(item?.name || '').trim()) itemErrors.name = 'validation.template.itemName';
        else if ((item.name || '').trim().length > $5e2e0b7ea22d1ff2$export$5f711b58035cee0) itemErrors.name = 'validation.template.itemNameTooLong';
        if (kind === 'order') {
            if (!$5e2e0b7ea22d1ff2$export$7fe249ad93dcc233.includes(item?.orderType)) itemErrors.orderType = 'validation.template.orderType';
            if (item?.urgency && !$5e2e0b7ea22d1ff2$export$c9b31a4acc93d37d.includes(item.urgency)) itemErrors.urgency = 'validation.template.urgency';
            const sessions = Number(item?.sessionCount ?? 0);
            if (!Number.isFinite(sessions) || sessions < 0 || sessions > 100) itemErrors.sessionCount = 'validation.template.sessionCount';
        }
        if (Object.keys(itemErrors).length) errors.items[index] = itemErrors;
    });
    return errors;
}
const $5e2e0b7ea22d1ff2$export$b26b94f22deb9fbf = (errors)=>Boolean(errors && (errors.title || errors.description || errors.itemCount || Object.keys(errors.items || {}).length));
function $5e2e0b7ea22d1ff2$export$5d7b2ba43c325442(items, from, to) {
    const list = [
        ...items || []
    ];
    if (from < 0 || from >= list.length || to < 0 || to >= list.length || from === to) return list;
    const [moved] = list.splice(from, 1);
    list.splice(to, 0, moved);
    return list;
}
const $5e2e0b7ea22d1ff2$export$57c9a27f259f5c39 = (item)=>[
        item?.dosage,
        item?.frequency,
        item?.route,
        item?.duration,
        item?.quantity
    ].map((v)=>(v || '').trim()).filter(Boolean).join(" \xb7 ");
const $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2 = (template)=>(template?.items || []).length;
function $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1(med) {
    if (!med) return null;
    const dosage = med.dosageInstruction && typeof med.dosageInstruction === 'object' ? med.dosageInstruction : {};
    const meta = med.meta && typeof med.meta === 'object' ? med.meta : {};
    // Rows written before structured dosing have only `text`. Showing it in the
    // dose column is closer to right than showing nothing, and the doctor can
    // still edit it.
    const legacyText = typeof med.dosageInstruction === 'string' ? med.dosageInstruction : dosage.text || '';
    const hasStructured = Boolean(dosage.dosage || dosage.frequency || dosage.duration);
    return {
        id: `med-${med.id}`,
        medicationId: med.id,
        drug: {
            id: meta.drugId || med.code || med.display,
            name: med.display || '',
            // Nothing writes `meta.genericName` today, so without the fallback every
            // row of a RESUMED visit would come back with no Latin name and be shown
            // under its Persian one — the one place the rule would break hardest.
            // `code` is where the Latin generic actually lands (see useEndVisit), and
            // `medGenericName` ignores it when it holds an identifier instead.
            genericName: meta.genericName || (0, $bb8a11e7c1131df5$export$f7cd022e8c4a05fd)(med),
            category: '',
            commonDosages: [],
            commonFrequencies: [],
            // «در فهرست تأمین» as the BFF says it of the line (Medication.taminListed):
            // the row carries only the drug's id, which no longer tells (rxOptions
            // inInsurerList). Absent from an older BFF — then nothing is said.
            ...typeof med.taminListed === 'boolean' ? {
                taminListed: med.taminListed
            } : {}
        },
        dosage: hasStructured ? dosage.dosage || '' : legacyText,
        frequency: hasStructured ? dosage.frequency || '' : '',
        duration: hasStructured ? dosage.duration || '' : '',
        route: dosage.route || '',
        quantity: dosage.quantity || '',
        instructions: dosage.instructions || '',
        templateTitle: meta.templateTitle || ''
    };
}
function $5e2e0b7ea22d1ff2$export$aac88d3c48aba92(med) {
    if (!med) return null;
    const name = (med.display || med.code || '').trim();
    if (!name) return null;
    // Carried so a refilled row can still be shown under its Latin name when the
    // formulary lookup misses.
    const genericName = (0, $bb8a11e7c1131df5$export$f7cd022e8c4a05fd)(med);
    // The product the line was prescribed from — the refill looks it up by THIS,
    // never by name: matched again by its Persian name, atropine 1% came back as
    // 0.5% and adapalene + benzoyl peroxide as plain adapalene, because one name
    // covers several strengths and combinations (K1, 2026-10-03). Empty for a line
    // written before the id was kept, or one that never named a product.
    const meta = med.meta && typeof med.meta === 'object' ? med.meta : {};
    const drugId = $5e2e0b7ea22d1ff2$var$productIdOf(meta.drugId);
    const di = med.dosageInstruction;
    const dosage = di && typeof di === 'object' ? di : {};
    const legacyText = typeof di === 'string' ? di : dosage.text || '';
    const hasStructured = Boolean(dosage.dosage || dosage.frequency || dosage.duration || dosage.route || dosage.quantity || dosage.instructions);
    return {
        name: name,
        genericName: genericName,
        ...drugId ? {
            drugId: drugId
        } : {},
        dosage: hasStructured ? dosage.dosage || '' : legacyText,
        frequency: dosage.frequency || '',
        route: dosage.route || '',
        duration: dosage.duration || '',
        quantity: dosage.quantity || '',
        instructions: dosage.instructions || ''
    };
}
// Ids the Visit screen makes up for rows that did not come from the drug list —
// an AI suggestion, a treatment-plan line, a refill or a document line the drug
// list did not answer for. They name no product, so they are never written as
// one, nor read back as one by a refill (K1, 2026-10-03).
const $5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID = /^(sugg-med-|plan-med-|refill-med-|doc-med-)/;
/** A drug id that names a product of the drug list, or '' for a made-up one. */ function $5e2e0b7ea22d1ff2$var$productIdOf(id) {
    const s = String(id || '').trim();
    return s && !$5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID.test(s) ? s : '';
}
const $5e2e0b7ea22d1ff2$export$2fe3f622dc680493 = (drug)=>{
    const id = String(drug?.id || '').trim();
    if (!id || $5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID.test(id) || id === drug?.name) return undefined;
    return {
        drugId: id
    };
};
const $5e2e0b7ea22d1ff2$export$1ed13c90275604ad = (item)=>({
        text: [
            item?.dosage,
            item?.frequency,
            item?.route,
            item?.duration,
            item?.quantity,
            item?.instructions
        ].map((v)=>(v || '').trim()).filter(Boolean).join(" \xb7 "),
        dosage: item?.dosage || '',
        frequency: item?.frequency || '',
        route: item?.route || '',
        duration: item?.duration || '',
        quantity: item?.quantity || '',
        instructions: item?.instructions || ''
    });
function $5e2e0b7ea22d1ff2$export$801d163b2e9340ef(existing, incoming) {
    const seen = new Set((existing || []).map((r)=>r.medicationId).filter(Boolean));
    const additions = (incoming || []).filter((r)=>r && !seen.has(r.medicationId));
    return additions.length ? [
        ...existing || [],
        ...additions
    ] : existing || [];
}
function $5e2e0b7ea22d1ff2$export$3c2b35db6130bf21(existing, incoming) {
    const seen = new Set((existing || []).map((o)=>o.id).filter(Boolean));
    const additions = (incoming || []).filter((o)=>o && !seen.has(o.id));
    return additions.length ? [
        ...additions.slice().reverse(),
        ...existing || []
    ] : existing || [];
}
function $5e2e0b7ea22d1ff2$export$89fd35b67bcc0da1(result) {
    const applied = result?.appliedCount || 0;
    const failures = result?.failures || [];
    if (failures.length) return {
        kind: 'partial',
        applied: applied,
        failed: failures.map((f)=>f.name)
    };
    if (!applied) return {
        kind: 'none',
        applied: 0,
        failed: []
    };
    return {
        kind: 'ok',
        applied: applied,
        failed: []
    };
}


function $f6afc37e3d3310be$export$a282db6c512184e6(kind, { enabled: enabled = true } = {}) {
    const meta = (0, $5e2e0b7ea22d1ff2$export$a2d52108c6de7f27)[kind];
    if (!meta) throw new Error(`unknown template kind: ${kind}`);
    const [templates, setTemplates] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    // Distinguishes "no templates yet" from "we have not looked" — an empty list
    // is a real answer and the empty state may only be shown once it is one.
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled) return [];
        setLoading(true);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)(meta.listQuery);
            const rows = data?.[meta.listField] || [];
            setTemplates(rows);
            setError(null);
            setLoaded(true);
            return rows;
        } catch (err) {
            // The previous list is left standing: a failed refetch is not evidence
            // that the doctor's templates are gone.
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, [
        enabled,
        meta.listQuery,
        meta.listField
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    // Writes deliberately do NOT swallow their errors — the editor shows what
    // went wrong beside the form, which it can only do if it is told.
    const create = (0, $acw62.useCallback)(async (draft)=>{
        const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(meta.addMutation, {
            input: (0, $5e2e0b7ea22d1ff2$export$d2a97effe7dc2dbb)(kind, draft)
        });
        await reload();
        return data?.[meta.addField] || null;
    }, [
        kind,
        meta.addMutation,
        meta.addField,
        reload
    ]);
    const update = (0, $acw62.useCallback)(async (id, draft)=>{
        const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(meta.updateMutation, {
            id: id,
            input: (0, $5e2e0b7ea22d1ff2$export$d2a97effe7dc2dbb)(kind, draft)
        });
        await reload();
        return data?.[meta.updateField] || null;
    }, [
        kind,
        meta.updateMutation,
        meta.updateField,
        reload
    ]);
    const duplicate = (0, $acw62.useCallback)(async (id)=>{
        const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(meta.duplicateMutation, {
            id: id
        });
        await reload();
        return data?.[meta.duplicateField] || null;
    }, [
        meta.duplicateMutation,
        meta.duplicateField,
        reload
    ]);
    const remove = (0, $acw62.useCallback)(async (id)=>{
        const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(meta.deleteMutation, {
            id: id
        });
        await reload();
        return Boolean(data?.[meta.deleteField]);
    }, [
        meta.deleteMutation,
        meta.deleteField,
        reload
    ]);
    return {
        kind: kind,
        meta: meta,
        templates: templates,
        loading: loading,
        loaded: loaded,
        error: error,
        reload: reload,
        create: create,
        update: update,
        duplicate: duplicate,
        remove: remove
    };
}



// ─────────────────────────────────────────────────────────────────────────────
// The drug formulary's own vocabulary, in the reading language.
//
// The formulary is the Iranian IRC registry: 37,120 rows whose `category` and
// `common_frequencies` are Persian. Those two fields are NOT free text — they
// are closed vocabularies of 56 and 42 values respectively, repeated across the
// whole table. So they are translated here, at the display edge, rather than by
// adding a column: 98 strings instead of 37,120 rows, and it covers every row
// including the ~36,500 that live only in the database and not in any seed file.
//
// `category` is ALSO A FILTER KEY — `listDrugs(category:)` and `drugCategories`
// query it — so the stored Persian value is never replaced, only displayed
// differently. Everything here maps value → key and leaves the value alone.
//
// A value with no mapping renders AS ITSELF. That is deliberate and not a gap:
// a clinic's own custom entry, or a formulary value added after this file, must
// still show the doctor something true rather than a blank or a humanised key.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Fold the spelling variants that render identically.
 *
 * Persian text arrives with and without ZWNJ («آنتی‌بیوتیک» / «آنتیبیوتیک»),
 * and rows keyed by hand carry Arabic yeh (U+064A) and kaf (U+0643) where
 * Persian uses yeh (U+06CC) and keh (U+06A9) — indistinguishable on screen and
 * different bytes. The AI service's `specialty.py` documents the same trap for
 * specialty names. An `===` against one spelling silently misses the others.
 */ const $f78c92fb84c2d04c$export$c7eebf90714d5a8a = (value)=>String(value || '').replace(/\u200c/g, '') // ZWNJ
    .replace(/\u064a/g, '\u06cc') // Arabic yeh → Persian yeh
    .replace(/\u0643/g, '\u06a9') // Arabic kaf → Persian keh
    .replace(/\s+/g, ' ').trim();
/**
 * Category → key. Several Persian spellings deliberately share one key: the
 * table holds two overlapping taxonomies (16 imported IRC/ATC groups over
 * ~36,600 rows, 40 curated ones over ~520) and «قلب و عروق» and «قلبی - عروقی»
 * are the same category written twice. Mapping both to one key merges them for
 * the reader WITHOUT touching the stored values or the filter.
 */ // i18n-exempt: these are MATCHERS against the formulary's own stored values,
// not UI copy. The Persian on the left is what the database holds; the
// translation is the key on the right. Written as the data appears so the
// table stays reviewable against a `SELECT DISTINCT category FROM drugs`.
const $f78c92fb84c2d04c$var$CATEGORY_KEYS = {
    "\u0628\u06CC\u0647\u0648\u0634\u06CC / \u0627\u0648\u0631\u0698\u0627\u0646\u0633": 'anaesthesiaEmergency',
    "\u0645\u0633\u06A9\u0646 / \u0636\u062F\u0627\u0644\u062A\u0647\u0627\u0628": 'analgesicAntiInflammatory',
    "\u0645\u0633\u06A9\u0646": 'analgesics',
    "\u0636\u062F\u0622\u0644\u0631\u0698\u06CC": 'antiallergics',
    "\u0622\u0646\u062A\u06CC\u200C\u0628\u06CC\u0648\u062A\u06CC\u06A9": 'antibiotics',
    "\u0636\u062F \u062F\u06CC\u0627\u0628\u062A": 'antidiabetics',
    "\u0636\u062F\u0642\u0627\u0631\u0686": 'antifungals',
    "\u0636\u062F \u0645\u0627\u0644\u0627\u0631\u06CC\u0627": 'antimalarials',
    "\u0636\u062F\u0633\u0631\u0637\u0627\u0646 \u0648 \u062A\u0639\u062F\u06CC\u0644 \u0627\u06CC\u0645\u0646\u06CC": 'antineoplastic',
    "\u0636\u062F\u0627\u0646\u06AF\u0644": 'antiparasitic',
    "\u0636\u062F \u0633\u0644": 'antituberculars',
    "\u0636\u062F\u0648\u06CC\u0631\u0648\u0633": 'antivirals',
    "\u062E\u0648\u0646 / \u0627\u0646\u0639\u0642\u0627\u062F": 'bloodCoagulation',
    "\u062E\u0648\u0646 \u0648 \u062E\u0648\u0646\u200C\u0633\u0627\u0632\u06CC": 'bloodForming',
    "\u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642": 'cardiovascular',
    "\u06A9\u0648\u0631\u062A\u06CC\u06A9\u0648\u0627\u0633\u062A\u0631\u0648\u0626\u06CC\u062F": 'corticosteroids',
    "\u067E\u0648\u0633\u062A": 'dermatologicals',
    "\u063A\u062F\u062F \u062F\u0631\u0648\u0646\u200C\u0631\u06CC\u0632": 'endocrine',
    "\u06AF\u0648\u0634 \u0648 \u062D\u0644\u0642 \u0648 \u0628\u06CC\u0646\u06CC": 'ent',
    "\u0635\u0631\u0639": 'epilepsy',
    "\u0635\u0631\u0639 / \u062F\u0631\u062F \u0639\u0635\u0628\u06CC": 'epilepsyNeuropathic',
    "\u06AF\u0648\u0627\u0631\u0634\u06CC": 'gastrointestinal',
    "\u0627\u062F\u0631\u0627\u0631\u06CC\u200C\u062A\u0646\u0627\u0633\u0644\u06CC \u0648 \u0647\u0648\u0631\u0645\u0648\u0646 \u062C\u0646\u0633\u06CC": 'genitourinary',
    "\u06AF\u0648\u0627\u0631\u0634 \u0648 \u0645\u062A\u0627\u0628\u0648\u0644\u06CC\u0633\u0645": 'giMetabolism',
    "\u0646\u0642\u0631\u0633": 'gout',
    "\u0647\u0648\u0631\u0645\u0648\u0646\u06CC / \u0628\u0627\u0631\u0648\u0631\u06CC": 'hormonalFertility',
    "\u062E\u0648\u0627\u0628\u200C\u0622\u0648\u0631": 'hypnotics',
    "\u0633\u0631\u0645 / \u0627\u0644\u06A9\u062A\u0631\u0648\u0644\u06CC\u062A": 'ivFluids',
    "\u0645\u06CC\u06AF\u0631\u0646": 'migraine',
    "\u0645\u06CC\u06AF\u0631\u0646 / \u0635\u0631\u0639": 'migraineEpilepsy',
    "\u0627\u0633\u06A9\u0644\u062A\u06CC\u200C\u0639\u0636\u0644\u0627\u0646\u06CC": 'musculoskeletal',
    "\u0646\u0641\u0631\u0648\u0644\u0648\u0698\u06CC": 'nephrology',
    "\u0633\u06CC\u0633\u062A\u0645 \u0639\u0635\u0628\u06CC": 'nervousSystem',
    "\u0646\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'neurology',
    "\u062F\u0631\u062F \u0639\u0635\u0628\u06CC": 'neuropathicPain',
    "\u0632\u0646\u0627\u0646 \u0648 \u0632\u0627\u06CC\u0645\u0627\u0646": 'obgyn',
    "\u0627\u0646\u06A9\u0648\u0644\u0648\u0698\u06CC": 'oncology',
    "\u0686\u0634\u0645\u200C\u067E\u0632\u0634\u06A9\u06CC": 'ophthalmology',
    "\u0645\u0633\u06A9\u0646 \u0627\u0648\u067E\u06CC\u0648\u0626\u06CC\u062F\u06CC": 'opioidAnalgesics',
    "\u067E\u0648\u06A9\u06CC \u0627\u0633\u062A\u062E\u0648\u0627\u0646": 'osteoporosis',
    "\u0633\u0627\u06CC\u0631": 'other',
    "\u0631\u0648\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC": 'psychiatry',
    "\u0631\u0648\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC / \u0635\u0631\u0639": 'psychiatryEpilepsy',
    "\u062F\u0633\u062A\u06AF\u0627\u0647 \u062A\u0646\u0641\u0633": 'respiratory',
    "\u0631\u0648\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC / \u0627\u06CC\u0645\u0648\u0646\u0648\u0644\u0648\u0698\u06CC": 'rheumImmunology',
    "\u0686\u0634\u0645 \u0648 \u06AF\u0648\u0634": 'sensoryOrgans',
    "\u0645\u06A9\u0645\u0644 \u0648 \u0633\u0627\u06CC\u0631": 'supplementsOther',
    "\u0636\u062F\u0639\u0641\u0648\u0646\u062A \u0633\u06CC\u0633\u062A\u0645\u06CC\u06A9": 'systemicAntiInfective',
    "\u0647\u0648\u0631\u0645\u0648\u0646\u200C\u0647\u0627\u06CC \u0633\u06CC\u0633\u062A\u0645\u06CC\u06A9": 'systemicHormonal',
    "\u062F\u0627\u0631\u0648\u06CC\u06CC - \u0637\u0628\u0642\u0647\u200C\u0628\u0646\u062F\u06CC\u200C\u0646\u0634\u062F\u0647": 'unclassified',
    "\u0627\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'urology',
    "\u0648\u06CC\u062A\u0627\u0645\u06CC\u0646 / \u0645\u06A9\u0645\u0644": 'vitaminsSupplements',
    "\u062A\u0646\u0641\u0633\u06CC": 'respiratory',
    "\u0636\u062F \u0627\u0646\u06AF\u0644": 'antiparasitic',
    "\u0639\u0636\u0644\u0647\u200C\u0627\u06CC - \u0627\u0633\u06A9\u0644\u062A\u06CC": 'musculoskeletal',
    "\u0642\u0644\u0628\u06CC - \u0639\u0631\u0648\u0642\u06CC": 'cardiovascular'
};
/** Dosing frequency → key. Present on 616 rows; the imported rows carry none. */ // i18n-exempt: matchers against stored formulary values, as above.
const $f78c92fb84c2d04c$var$FREQUENCY_KEYS = {
    "\u0628\u0639\u062F \u0627\u0632 \u0647\u0631 \u0627\u0633\u0647\u0627\u0644": 'afterEachStool',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632": 'asNeeded',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632 (\u062D\u062F\u0627\u06A9\u062B\u0631 \u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631)": 'asNeededMaxTwiceDaily',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632 (\u06CC\u06A9 \u0633\u0627\u0639\u062A \u0642\u0628\u0644)": 'asNeededOneHourBefore',
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'beforeMeals',
    "\u0647\u0631 \u06F1\u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every12WeeksOnce',
    "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A": 'every12h',
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647": 'every2Weeks',
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every2WeeksOnce',
    "\u0647\u0631 \u06F3 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every3Weeks',
    "\u0647\u0631 \u06F4 \u0647\u0641\u062A\u0647": 'every4Weeks',
    "\u0647\u0631 \u06F4 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every4WeeksOnce',
    "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A": 'every4h',
    "\u0647\u0631 \u06F4 \u062A\u0627 \u06F6 \u0633\u0627\u0639\u062A": 'every4to6h',
    "\u0647\u0631 \u06F6 \u0645\u0627\u0647": 'every6Months',
    "\u0647\u0631 \u06F6 \u0645\u0627\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every6MonthsOnce',
    "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A": 'every6h',
    "\u0647\u0631 \u06F6 \u062A\u0627 \u06F8 \u0633\u0627\u0639\u062A": 'every6to8h',
    "\u0647\u0631 \u06F8 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every8WeeksOnce',
    "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A": 'every8h',
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646": 'everyOtherDay',
    "\u0647\u0631 \u062F\u0648 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'everyTwoWeeks',
    "\u0631\u0648\u0632\u06CC \u067E\u0646\u062C \u0628\u0627\u0631": 'fiveTimesDaily',
    "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631": 'fourTimesDaily',
    "\u062D\u062F\u0627\u06A9\u062B\u0631 \u06F8mg \u062F\u0631 \u0631\u0648\u0632": 'max8mgPerDay',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u06F8 \u062A\u0627 \u06F1\u06F4 \u0633\u0627\u0639\u062A)": 'once8to14h',
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'onceAtNight',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceDaily',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (10mg)": 'onceDaily10mg',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627": 'onceDailyFasting',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (SR)": 'onceDailySR',
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceMonthly',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceWeekly',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (70mg)": 'onceWeekly70mg',
    "\u0633\u0627\u0644\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceYearly',
    "\u062F\u0648\u0632 \u0648\u0627\u062D\u062F": 'singleDose',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u062F\u0648\u0632)": 'singleDoseParen',
    "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631": 'threeTimesDaily',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u0633\u0647 \u0628\u0627\u0631": 'threeTimesWeekly',
    "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631": 'twiceDaily',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631": 'twiceWeekly',
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'withMeals'
};
// The tables above are written with the values as they appear in the database,
// which is what makes them reviewable against a `SELECT DISTINCT`. They are
// re-keyed through the SAME normaliser the lookup uses, once at module load, so
// a key containing a ZWNJ («آنتی‌بیوتیک») cannot fail to match its own value.
// Writing the table pre-normalised instead would have made every entry
// unrecognisable next to the data it describes.
const $f78c92fb84c2d04c$var$normalizedTable = (table)=>Object.fromEntries(Object.entries(table).map(([value, slug])=>[
            $f78c92fb84c2d04c$export$c7eebf90714d5a8a(value),
            slug
        ]));
const $f78c92fb84c2d04c$export$c8fcf34a4f7c8505 = (table, prefix)=>{
    const byNormalized = $f78c92fb84c2d04c$var$normalizedTable(table);
    return (value, t)=>{
        const raw = String(value || '').trim();
        if (!raw) return '';
        const slug = byNormalized[$f78c92fb84c2d04c$export$c7eebf90714d5a8a(raw)];
        return slug ? t(`${prefix}.${slug}`) : raw;
    };
};
const $f78c92fb84c2d04c$var$lookup = $f78c92fb84c2d04c$export$c8fcf34a4f7c8505;
const $f78c92fb84c2d04c$export$6ff5af8a69b07db4 = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$CATEGORY_KEYS, 'visit.rx.drugCategory');
const $f78c92fb84c2d04c$export$d93ed016efabc5b = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$FREQUENCY_KEYS, 'visit.rx.frequencyValue');
// The ORDER catalogue has its own category vocabulary — 38 values — and it is
// NOT the drug one. Only six strings appear in both, so one shared table would
// have silently mistranslated the rest.
//
// i18n-exempt: matchers against stored catalogue values, as above.
const $f78c92fb84c2d04c$var$ORDER_CATEGORY_KEYS = {
    "\u0628\u06CC\u0648\u0634\u06CC\u0645\u06CC": 'biochemistry',
    "\u0642\u0644\u0628": 'cardiac',
    "\u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642": 'cardiovascular',
    "CT Scan": 'ctScan',
    "\u067E\u0648\u0633\u062A": 'dermatology',
    "\u062A\u0634\u062E\u06CC\u0635\u06CC": 'diagnostic',
    "\u0645\u0633\u062A\u0646\u062F\u0633\u0627\u0632\u06CC": 'documentation',
    "\u062E\u0627\u0631\u062C\u200C\u062F\u0647\u0627\u0646\u06CC": 'extraoral',
    "\u062B\u0627\u0628\u062A": 'fixed',
    "\u06AF\u0648\u0627\u0631\u0634\u06CC": 'gastrointestinal',
    "\u0632\u0646\u0627\u0646": 'gynaecology',
    "\u0647\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC": 'haematology',
    "\u0647\u0648\u0631\u0645\u0648\u0646": 'hormone',
    "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A": 'implant',
    "\u0627\u0644\u062A\u0647\u0627\u0628": 'inflammation',
    "\u062F\u0627\u062E\u0644\u200C\u062F\u0647\u0627\u0646\u06CC": 'intraoral',
    "\u0686\u0631\u0628\u06CC\u200C\u0647\u0627": 'lipids',
    "\u0639\u0645\u0644\u06A9\u0631\u062F \u06A9\u0628\u062F": 'liverFunction',
    "\u0645\u06CC\u06A9\u0631\u0648\u0628\u06CC\u0648\u0644\u0648\u0698\u06CC": 'microbiology',
    "MRI": 'mri',
    "\u0646\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'neurology',
    "\u0627\u0631\u062A\u0648\u062F\u0646\u0633\u06CC": 'orthodontics',
    "\u0627\u0631\u062A\u0648\u067E\u062F\u06CC": 'orthopaedics',
    "\u0633\u0627\u06CC\u0631": 'other',
    "\u0641\u06CC\u0632\u06CC\u0648\u062A\u0631\u0627\u067E\u06CC": 'physiotherapy',
    "\u0631\u06CC\u0648\u06CC": 'pulmonary',
    "\u0631\u0627\u062F\u06CC\u0648\u06AF\u0631\u0627\u0641\u06CC": 'radiography',
    "\u0645\u062A\u062D\u0631\u06A9": 'removable',
    "\u0631\u0648\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC": 'rheumatology',
    "\u0633\u0631\u0648\u0644\u0648\u0698\u06CC": 'serology',
    "\u0627\u0633\u067E\u0644\u06CC\u0646\u062A": 'splint',
    "\u0633\u0647\u200C\u0628\u0639\u062F\u06CC": 'threeD',
    "\u062A\u06CC\u0631\u0648\u0626\u06CC\u062F": 'thyroid',
    "\u0627\u062A\u0627\u0642 \u062F\u0631\u0645\u0627\u0646": 'treatmentRoom',
    "\u062A\u0648\u0645\u0648\u0631\u0645\u0627\u0631\u06A9\u0631": 'tumourMarkers',
    "\u0633\u0648\u0646\u0648\u06AF\u0631\u0627\u0641\u06CC": 'ultrasound',
    "\u0627\u062F\u0631\u0627\u0631": 'urine',
    "\u0627\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'urology',
    "\u0622\u0632\u0645\u0627\u06CC\u0634": 'laboratory',
    "\u0627\u0646\u062F\u0648\u062F\u0627\u0646\u062A\u06CC\u06A9\u0633": 'endodontics',
    "\u062A\u0631\u0645\u06CC\u0645\u06CC": 'restorative',
    "\u062C\u0631\u0627\u062D\u06CC": 'surgery',
    "\u0632\u06CC\u0628\u0627\u06CC\u06CC": 'cosmetic',
    "\u0648\u06CC\u0632\u06CC\u062A": 'visit',
    "\u067E\u0631\u0648\u062A\u0632 \u062B\u0627\u0628\u062A": 'fixedProsthesis',
    "\u067E\u0631\u0648\u062A\u0632 \u0645\u062A\u062D\u0631\u06A9": 'removableProsthesis',
    "\u067E\u0631\u06CC\u0648\u062F\u0646\u062A\u06CC\u06A9\u0633": 'periodontics',
    "\u067E\u06CC\u0634\u06AF\u06CC\u0631\u06CC": 'prevention',
    "\u06A9\u0648\u062F\u06A9\u0627\u0646": 'paediatrics'
};
const $f78c92fb84c2d04c$export$79313fed3d273b1f = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$ORDER_CATEGORY_KEYS, 'visit.orders.category');



var $jTCZr = parcelRequire("jTCZr");
const $157d5bd48cfffbad$export$10a6273ddaa5498e = Object.freeze([
    'LAB',
    'IMAGING',
    'MEDICAL_REPORT',
    'PRESCRIPTION',
    'TREATMENT_DOCUMENT',
    'OTHER'
]);
const $157d5bd48cfffbad$export$764f121a336c64b7 = Object.freeze({
    LAB_IMAGE: 'LAB',
    LAB_PDF: 'LAB',
    IMAGING_REPORT: 'IMAGING',
    MEDICAL_DOCUMENT: 'MEDICAL_REPORT'
});
function $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind) {
    const upper = String(kind || '').trim().toUpperCase();
    if (!upper) return null;
    const value = $157d5bd48cfffbad$export$764f121a336c64b7[upper] || upper;
    return $157d5bd48cfffbad$export$10a6273ddaa5498e.includes(value) ? value : null;
}
const $157d5bd48cfffbad$export$e9b52c65a7ff27b6 = Object.freeze({
    LAB: 'patient.files.kind.lab',
    IMAGING: 'patient.files.kind.imaging',
    MEDICAL_REPORT: 'patient.files.kind.medicalReport',
    PRESCRIPTION: 'patient.files.kind.prescription',
    TREATMENT_DOCUMENT: 'patient.files.kind.treatmentDocument',
    OTHER: 'patient.files.kind.other'
});
function $157d5bd48cfffbad$export$d2ebff77a9864278(kind) {
    const value = $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind);
    return value ? $157d5bd48cfffbad$export$e9b52c65a7ff27b6[value] : null;
}
const $157d5bd48cfffbad$export$4f5645f323f84265 = Object.freeze($157d5bd48cfffbad$export$10a6273ddaa5498e.map((value)=>({
        value: value,
        labelKey: $157d5bd48cfffbad$export$e9b52c65a7ff27b6[value]
    })));
function $157d5bd48cfffbad$export$5838ca9a34e7c8(kind) {
    return $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind) === 'LAB' ? 'LAB_RESULTS' : 'REPORT';
}
const $157d5bd48cfffbad$export$4c32b942640c490c = Object.freeze([
    'clinical_info',
    'technique',
    'comparison',
    'findings',
    'impression',
    'recommendation',
    'other'
]);
const $157d5bd48cfffbad$export$918e760d3bce1cbe = Object.freeze([
    'US',
    'CT',
    'MRI',
    'XR',
    'MG',
    'NM',
    'ECG',
    'PATH',
    'OTHER'
]);
const $157d5bd48cfffbad$export$2420ba89f9c47be8 = Object.freeze([
    'LAB_RESULT',
    'IMAGING_REPORT',
    'MEDICAL_REPORT',
    'PRESCRIPTION',
    'HANDWRITTEN_NOTE',
    'MEDICAL_RECORD',
    'OTHER'
]);
const $157d5bd48cfffbad$export$2c244d895de88ead = Object.freeze({
    LAB_RESULT: 'LAB_RESULTS',
    IMAGING_REPORT: 'REPORT',
    MEDICAL_REPORT: 'REPORT',
    PRESCRIPTION: 'PRESCRIPTION',
    HANDWRITTEN_NOTE: 'NOTE',
    MEDICAL_RECORD: 'RECORD'
});
const $157d5bd48cfffbad$export$6638e927deac1763 = Object.freeze($157d5bd48cfffbad$export$2420ba89f9c47be8.filter((c)=>c !== 'OTHER'));
const $157d5bd48cfffbad$export$f6b40a7b264b3557 = (cls)=>$157d5bd48cfffbad$export$2420ba89f9c47be8.includes(cls) ? `patient.files.extract.class.${cls}` : null;
const $157d5bd48cfffbad$export$48ad29fa49c5e125 = Object.freeze([
    'history',
    'exam',
    'assessment',
    'plan',
    'other'
]);
const $157d5bd48cfffbad$export$8e824c3a51e639a1 = 0.8;
function $157d5bd48cfffbad$export$e0b123b1c38f1e9c(confidence) {
    const c = Number(confidence);
    if (!Number.isFinite(c)) return null;
    if (c >= 0.9) return 'high';
    if (c >= 0.75) return 'medium';
    return 'low';
}
function $157d5bd48cfffbad$export$ce70ae537f7b403c(flags, prefix) {
    return (flags || []).filter((f)=>String(f?.path || '').startsWith(prefix));
}
function $157d5bd48cfffbad$export$c58f98e613dc3eb2(flags) {
    return (flags || []).filter((f)=>!/\[\d+\]/.test(String(f?.path || '')));
}
const $157d5bd48cfffbad$export$d66c76d9d0c49c6f = (text)=>/\[\?\]|\[ناخوانا\]/.test(String(text || '')); // i18n-exempt: matcher against model output
const $157d5bd48cfffbad$export$7a368dd5ea360393 = {
    // Stored, and that is all the clinic asked for. This is the DEFAULT and, for a
    // clinic that does not analyse uploads, the only state its files will ever be
    // in. It must never read as a failure.
    none: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.none'
    },
    queued: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'patient.files.processing.queued'
    },
    processing: {
        ...(0, $jTCZr.statusColors).in_visit,
        labelKey: 'patient.files.processing.processing'
    },
    // A model read it and produced text.
    analyzed: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.analyzed'
    },
    // …and structured values came out of it.
    extracted: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.extracted'
    },
    // The analysis did not happen. Deliberately NOT the red `cancelled` swatch: the
    // document itself is safely stored and the doctor can still open and read it,
    // so this is a missing convenience, not a lost file.
    failed: {
        ...(0, $jTCZr.statusColors).no_show,
        labelKey: 'patient.files.processing.failed'
    }
};
const $157d5bd48cfffbad$export$753f4d39807a1a61 = [
    'queued',
    'processing'
];
const $157d5bd48cfffbad$export$16f32956b0e27d9f = [
    'analyzed',
    'extracted'
];
function $157d5bd48cfffbad$var$normalize(status) {
    return String(status || '').toLowerCase().replace(/-/g, '_');
}
function $157d5bd48cfffbad$export$47893326198c9a54(status) {
    return $157d5bd48cfffbad$export$7a368dd5ea360393[$157d5bd48cfffbad$var$normalize(status)] || null;
}
function $157d5bd48cfffbad$export$96ba48b359c8edfb(status) {
    return $157d5bd48cfffbad$export$753f4d39807a1a61.includes($157d5bd48cfffbad$var$normalize(status));
}
function $157d5bd48cfffbad$export$2c31f9f3ffd05797(status) {
    return $157d5bd48cfffbad$export$16f32956b0e27d9f.includes($157d5bd48cfffbad$var$normalize(status));
}
function $157d5bd48cfffbad$export$f771ebfc53d8840d(file) {
    if (!file) return false;
    if ($157d5bd48cfffbad$export$2c31f9f3ffd05797(file.processingStatus)) return true;
    return Boolean(file.clinicId) && Boolean($157d5bd48cfffbad$export$7a368dd5ea360393[$157d5bd48cfffbad$var$normalize(file.processingStatus)]);
}
function $157d5bd48cfffbad$export$ca16185462233788(status) {
    const key = $157d5bd48cfffbad$var$normalize(status);
    return Boolean($157d5bd48cfffbad$export$7a368dd5ea360393[key]) && key !== 'none';
}
function $157d5bd48cfffbad$export$70f239c59f207d0(processingError) {
    return $157d5bd48cfffbad$var$normalize(processingError) === 'credit' ? 'patient.files.processing.failedCredit' : 'patient.files.processing.failedOther';
}


const $bf42e0131d395ab7$export$a69e980913efc937 = {
    social: 'patient.insurance.social',
    military: 'patient.insurance.military',
    health: 'patient.insurance.health',
    other: 'patient.insurance.other',
    // patientmanagement now derives `patients.insurance` from the patient's policy
    // row and writes the insurer's PERSIAN name, and older rows hold whatever a
    // panel typed. Each spelling reads through the same key, so an English doctor
    // sees «Social Security», not «تامین اجتماعی».
    // i18n-exempt: stored values matched here, not UI copy.
    "\u062A\u0627\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u062A\u0623\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u0628\u06CC\u0645\u0647 \u062A\u0627\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u0646\u06CC\u0631\u0648\u0647\u0627\u06CC \u0645\u0633\u0644\u062D": 'patient.insurance.military',
    "\u0628\u06CC\u0645\u0647 \u0633\u0644\u0627\u0645\u062A": 'patient.insurance.health',
    "\u0628\u06CC\u0645\u0647\u0654 \u0633\u0644\u0627\u0645\u062A": 'patient.insurance.health',
    "\u0622\u0632\u0627\u062F": 'patient.insurance.other',
    "\u0633\u0627\u06CC\u0631 / \u0622\u0632\u0627\u062F": 'patient.insurance.other',
    "\u0633\u0627\u06CC\u0631/\u0622\u0632\u0627\u062F": 'patient.insurance.other'
};
const $bf42e0131d395ab7$export$8b0ae89b0b488ed9 = [
    'SOAP',
    'consultation',
    'discharge',
    'referral',
    'other'
];
const $bf42e0131d395ab7$export$fe67f05a766290fd = {
    SOAP_NOTE: 'patient.noteType.SOAP_NOTE',
    VISIT_SUMMARY: 'patient.noteType.VISIT_SUMMARY',
    PROCEDURE_NOTE: 'patient.noteType.PROCEDURE_NOTE'
};
const $bf42e0131d395ab7$export$8bd836c94e04bf93 = {
    active: 'patient.medStatus.active',
    'on-hold': 'patient.medStatus.onHold',
    stopped: 'patient.medStatus.stopped',
    completed: 'patient.medStatus.completed'
};
const $bf42e0131d395ab7$export$eb40f3474cc5e6d5 = {
    active: 'patient.condStatus.active',
    resolved: 'patient.condStatus.resolved',
    inactive: 'patient.condStatus.inactive',
    recurrence: 'patient.condStatus.recurrence'
};
const $bf42e0131d395ab7$export$e06a38df942076e8 = {
    OUTPATIENT: 'patient.encType.outpatient',
    outpatient: 'patient.encType.outpatient',
    INPATIENT: 'patient.encType.inpatient',
    inpatient: 'patient.encType.inpatient',
    EMERGENCY: 'patient.encType.emergency',
    emergency: 'patient.encType.emergency',
    FOLLOW_UP: 'patient.encType.followUp',
    follow_up: 'patient.encType.followUp',
    ambulatory: 'patient.encType.outpatient'
};
const $bf42e0131d395ab7$export$74eff50fc31aba23 = {
    'in-progress': 'patient.encStatus.inProgress',
    active: 'patient.encStatus.inProgress',
    completed: 'patient.encStatus.finished',
    finished: 'patient.encStatus.finished',
    cancelled: 'patient.encStatus.cancelled'
};
const $bf42e0131d395ab7$export$f3254cc21757d13e = [
    {
        k: 'S',
        nameKey: 'patient.soap.subjective',
        types: [
            'SOAP_S',
            'subjective',
            'chief_complaint',
            'history'
        ]
    },
    {
        k: 'O',
        nameKey: 'patient.soap.objective',
        types: [
            'SOAP_O',
            'objective',
            'examination',
            'findings'
        ]
    },
    {
        k: 'A',
        nameKey: 'patient.soap.assessment',
        types: [
            'SOAP_A',
            'assessment',
            'evaluation'
        ]
    },
    {
        k: 'P',
        nameKey: 'patient.soap.plan',
        types: [
            'SOAP_P',
            'plan',
            'treatment_plan'
        ]
    }
];
const $bf42e0131d395ab7$export$a7724bba2d8d6794 = {
    lab: 'patient.orderType.lab',
    imaging: 'patient.orderType.imaging',
    procedure: 'patient.orderType.procedure',
    other: 'patient.orderType.other'
};
const $bf42e0131d395ab7$export$4a1cfa27d42d8e0c = {
    requested: 'patient.orderStat.requested',
    completed: 'patient.orderStat.completed',
    cancelled: 'patient.orderStat.cancelled'
};
const $bf42e0131d395ab7$export$4db6aab28b3b7a99 = {
    requested: 'amber',
    completed: 'good',
    cancelled: 'muted'
};
const $bf42e0131d395ab7$export$520152d4ddd823c6 = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '2708-6',
    '8310-5',
    '29463-7',
    '55284-4',
    '9279-1'
]);
const $bf42e0131d395ab7$export$92cbb70125dbdf80 = [
    {
        id: 'bp',
        labelKey: 'patient.vitals.bp',
        loinc: '55284-4',
        unit: 'mmHg',
        icon: 'HeartPulse',
        refLow: 90,
        refHigh: 140
    },
    {
        id: 'hr',
        labelKey: 'patient.vitals.hr',
        loinc: '8867-4',
        unit: 'bpm',
        icon: 'Activity',
        refLow: 60,
        refHigh: 100
    },
    {
        id: 'temp',
        labelKey: 'patient.vitals.temp',
        loinc: '8310-5',
        unit: "\xb0C",
        icon: 'Thermometer',
        refLow: 36.1,
        refHigh: 37.2
    },
    {
        id: 'spo2',
        labelKey: 'patient.vitals.spo2',
        loinc: '59408-5',
        unit: '%',
        icon: 'Wind',
        refLow: 95,
        refHigh: 100
    },
    {
        id: 'wt',
        labelKey: 'patient.vitals.wt',
        loinc: '29463-7',
        unit: 'kg',
        icon: 'Scale',
        refLow: null,
        refHigh: null
    }
];
const $bf42e0131d395ab7$export$5a8441d057c1b67f = [
    {
        id: 'vitals',
        labelKey: 'patient.labCategory.vitals',
        color: '#ef4444',
        tests: [
            "\u0641\u0634\u0627\u0631 \u0633\u06CC\u0633\u062A\u0648\u0644\u06CC\u06A9",
            "\u0641\u0634\u0627\u0631 \u062F\u06CC\u0627\u0633\u062A\u0648\u0644\u06CC\u06A9",
            "\u0636\u0631\u0628\u0627\u0646 \u0642\u0644\u0628",
            "\u0627\u0634\u0628\u0627\u0639 \u0627\u06A9\u0633\u06CC\u0698\u0646",
            "\u062F\u0645\u0627\u06CC \u0628\u062F\u0646",
            "\u0648\u0632\u0646",
            'blood pressure',
            'heart rate',
            'spo2',
            'temperature',
            'weight',
            'respiratory rate'
        ]
    },
    {
        id: 'biochemistry',
        labelKey: 'patient.labCategory.biochemistry',
        color: '#3b82f6',
        tests: [
            'glucose',
            'fasting glucose',
            'blood sugar',
            'bun',
            'urea',
            'blood urea',
            'creatinine',
            'sodium',
            'potassium',
            'chloride',
            'bicarbonate',
            'co2',
            'calcium',
            'phosphorus',
            'magnesium',
            'uric acid',
            'total protein',
            'albumin',
            'globulin',
            'a/g ratio'
        ]
    },
    {
        id: 'endocrine',
        labelKey: 'patient.labCategory.endocrine',
        color: '#8b5cf6',
        tests: [
            'cortisol',
            'acth',
            'growth hormone',
            'prolactin',
            'lh',
            'fsh',
            'estradiol',
            'testosterone',
            'progesterone',
            'dheas',
            'insulin',
            'c-peptide',
            'pth',
            'aldosterone',
            'renin',
            'igf-1',
            'free testosterone',
            'shbg',
            'amh'
        ]
    },
    {
        id: 'immunology',
        labelKey: 'patient.labCategory.immunology',
        color: '#ec4899',
        tests: [
            'crp',
            'c-reactive protein',
            'esr',
            'ana',
            'anti-dsdna',
            'rf',
            'rheumatoid factor',
            'anti-ccp',
            'complement c3',
            'complement c4',
            'anca',
            'igg',
            'igm',
            'iga',
            'ige',
            'hiv',
            'hbsag',
            'hbs ag',
            'hcv',
            'vdrl',
            'rpr',
            'cmv',
            'ebv',
            'toxoplasma',
            'anti-hbs',
            'anti-hbc',
            'hbeag'
        ]
    },
    {
        id: 'hematology',
        labelKey: 'patient.labCategory.hematology',
        color: '#ef4444',
        tests: [
            'wbc',
            'rbc',
            'hemoglobin',
            'hematocrit',
            'mcv',
            'mch',
            'mchc',
            'platelets',
            'rdw',
            'neutrophils',
            'lymphocytes',
            'monocytes',
            'eosinophils',
            'basophils',
            'reticulocytes',
            'esr',
            'hematology',
            's.g.o.t (ast)',
            's.g.p.t (alt)'
        ]
    },
    {
        id: 'urinalysis',
        labelKey: 'patient.labCategory.urinalysis',
        color: '#06b6d4',
        tests: [
            'urine ph',
            'urine specific gravity',
            'urine glucose',
            'urine protein',
            'urine ketones',
            'urine blood',
            'urine bilirubin',
            'urine nitrites',
            'urine wbc',
            'urine rbc',
            'urine casts',
            'urine bacteria',
            'specific gravity',
            'urinalysis'
        ]
    },
    {
        id: 'tumor',
        labelKey: 'patient.labCategory.tumor',
        color: '#f59e0b',
        tests: [
            'psa',
            'ca 125',
            'ca125',
            'ca 19-9',
            'ca19-9',
            'ca 15-3',
            'ca15-3',
            'cea',
            'afp',
            'beta hcg',
            'bhcg',
            'nse',
            'chromogranin',
            'ca 72-4',
            'he4',
            'cyfra 21-1',
            's100',
            'lca'
        ]
    },
    {
        id: 'vitamins',
        labelKey: 'patient.labCategory.vitamins',
        color: '#10b981',
        tests: [
            'vitamin d',
            'vitamin d3 (25-oh)',
            '25-oh vitamin d',
            'vitamin b12',
            'folate',
            'folic acid',
            'vitamin a',
            'vitamin e',
            'zinc',
            'copper',
            'selenium',
            'iron',
            'ferritin',
            'tibc',
            'serum iron',
            'vitamin c',
            'vitamin k',
            'manganese'
        ]
    },
    {
        id: 'microbiology',
        labelKey: 'patient.labCategory.microbiology',
        color: '#6366f1',
        tests: [
            'blood culture',
            'urine culture',
            'sputum culture',
            'wound culture',
            'stool culture',
            'csf culture',
            'throat culture',
            'nasal culture',
            'ear culture',
            'h.pylori',
            'helicobacter pylori',
            'tb',
            'afb',
            'fungal culture',
            'mrsa'
        ]
    },
    {
        id: 'diabetes',
        labelKey: 'patient.labCategory.diabetes',
        color: '#f97316',
        tests: [
            'hba1c',
            'hgba1c',
            'glycated hemoglobin',
            'fasting blood sugar',
            'fasting glucose',
            'fbs',
            'ogtt',
            'insulin',
            'c-peptide',
            'fructosamine',
            'gad antibodies',
            'glucose (biochemistry)'
        ]
    },
    {
        id: 'coagulation',
        labelKey: 'patient.labCategory.coagulation',
        color: '#dc2626',
        tests: [
            'pt',
            'inr',
            'ptt',
            'aptt',
            'fibrinogen',
            'd-dimer',
            'anti-thrombin iii',
            'factor viii',
            'platelet function',
            'bleeding time',
            'clotting time',
            'vwf'
        ]
    },
    {
        id: 'lft',
        labelKey: 'patient.labCategory.lft',
        color: '#92400e',
        tests: [
            'alt',
            'sgpt',
            's.g.p.t (alt)',
            'ast',
            'sgot',
            's.g.o.t (ast)',
            'alkaline phosphatase',
            'alkaline p (alp)',
            'alp',
            'ggt',
            'total bilirubin',
            'direct bilirubin',
            'indirect bilirubin',
            'albumin',
            'total protein',
            'ldh',
            'ammonia'
        ]
    },
    {
        id: 'lipid',
        labelKey: 'patient.labCategory.lipid',
        color: '#d97706',
        tests: [
            'total cholesterol',
            'cholesterol',
            'ldl',
            'hdl',
            'triglycerides',
            'vldl',
            'non-hdl',
            'apolipoprotein a',
            'apolipoprotein b',
            'lp(a)',
            'apo a1',
            'apo b'
        ]
    },
    {
        id: 'thyroid',
        labelKey: 'patient.labCategory.thyroid',
        color: '#059669',
        tests: [
            'tsh',
            't.s.h',
            't4',
            'free t4',
            'ft4',
            't3',
            'free t3',
            'ft3',
            'thyroglobulin',
            'anti-tpo',
            'anti-thyroglobulin',
            'reverse t3'
        ]
    },
    {
        id: 'csf',
        labelKey: 'patient.labCategory.csf',
        color: '#7c3aed',
        tests: [
            'csf glucose',
            'csf protein',
            'csf wbc',
            'csf rbc',
            'csf appearance',
            'csf pressure',
            'csf lactate',
            'oligoclonal bands',
            'csf culture',
            'csf opening pressure'
        ]
    },
    {
        id: 'renal',
        labelKey: 'patient.labCategory.renal',
        color: '#0284c7',
        tests: [
            'creatinine',
            'serum creatinine',
            'bun',
            'egfr',
            'cystatin c',
            'uric acid',
            'urine albumin',
            'urine creatinine',
            'acr',
            'albumin creatinine ratio',
            'crcl',
            '24h creatinine'
        ]
    },
    {
        id: 'abg',
        labelKey: 'patient.labCategory.abg',
        color: '#0891b2',
        tests: [
            'ph',
            'pao2',
            'paco2',
            'hco3',
            'o2 saturation',
            'sao2',
            'base excess',
            'lactate',
            'fio2',
            'papo2',
            'arterial ph',
            'bicarbonate'
        ]
    },
    {
        id: 'cardiac',
        labelKey: 'patient.labCategory.cardiac',
        color: '#b91c1c',
        tests: [
            'troponin i',
            'troponin t',
            'troponin',
            'ck',
            'creatine kinase',
            'ck-mb',
            'myoglobin',
            'bnp',
            'nt-probnp',
            'ldh',
            'homocysteine',
            'hs-crp',
            'cardiac troponin'
        ]
    }
];
const $bf42e0131d395ab7$var$_OBS_CAT_CACHE = {};
function $bf42e0131d395ab7$export$88ddf826312c2ac7(display) {
    const k = (display || '').toLowerCase().trim();
    if ($bf42e0131d395ab7$var$_OBS_CAT_CACHE[k] !== undefined) return $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k];
    const cat = $bf42e0131d395ab7$export$5a8441d057c1b67f.find((c)=>c.tests.some((item)=>k === item || k.includes(item) || item.includes(k)));
    $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k] = cat?.id || 'other';
    return $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k];
}
const $bf42e0131d395ab7$export$db667ec233a83b = [
    {
        id: 'all',
        labelKey: 'common.state.all',
        emoji: "\uD83D\uDCC1"
    },
    {
        id: 'lab_report',
        labelKey: 'visit.orders.lab',
        emoji: "\uD83E\uDDEA"
    },
    {
        id: 'imaging',
        labelKey: 'patient.orderType.imaging',
        emoji: "\uD83E\uDE7B"
    },
    {
        id: 'ecg',
        labelKey: 'patient.files.ecg',
        emoji: "\uD83D\uDC93"
    },
    {
        id: 'pathology',
        labelKey: 'patient.files.pathology',
        emoji: "\uD83D\uDD2C"
    },
    {
        id: 'general',
        labelKey: 'patient.files.documents',
        emoji: "\uD83D\uDCC4"
    }
];
const $bf42e0131d395ab7$export$5bd526b8cddb0bce = 'storage:labfile:';
function $bf42e0131d395ab7$export$3d3bfe33466ff5e(f) {
    // What the document IS decides first (docs/PATIENT_MEDICAL_DOCUMENT_UPLOAD_DESIGN.md
    // §8.1). Only the two kinds that ARE a bucket answer outright: a MEDICAL_REPORT may
    // still be an ECG or a pathology sheet, which the legacy fileType can still tell.
    const kind = (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(f?.kind);
    if (kind === 'LAB') return 'lab_report';
    if (kind === 'IMAGING') return 'imaging';
    const value = (f?.fileType || '').toLowerCase();
    if (value === 'lab_report' || value === 'lab') return 'lab_report';
    if ([
        'imaging',
        'xray',
        'mri',
        'ct',
        'ultrasound'
    ].includes(value)) return 'imaging';
    if (value === 'ecg') return 'ecg';
    if (value === 'pathology') return 'pathology';
    return 'general';
}
function $bf42e0131d395ab7$export$f0dc803487bda7d5(clinicalFiles, storageFiles) {
    const seen = new Set();
    const clinical = (clinicalFiles || []).filter((f)=>{
        if (seen.has(f.id)) return false;
        seen.add(f.id);
        return true;
    }).map((f)=>({
            ...f,
            _source: 'clinical'
        }));
    const linked = new Set(clinical.map((f)=>(f.fileUrl || '').startsWith($bf42e0131d395ab7$export$5bd526b8cddb0bce) ? f.fileUrl.slice($bf42e0131d395ab7$export$5bd526b8cddb0bce.length) : null).filter(Boolean));
    const storageSeen = new Set();
    const storage = (storageFiles || []).filter((f)=>!linked.has(f.id)).filter((f)=>{
        if (storageSeen.has(f.id)) return false;
        storageSeen.add(f.id);
        return true;
    }).map((f)=>({
            ...f,
            _source: 'storage'
        }));
    // Newest DOCUMENT first: a lab sheet dated last month and uploaded today belongs
    // under last month. Without a stated date the upload day stands in; the upload
    // time breaks ties.
    const effective = (f)=>f.documentDate || (f.createdAt || '').slice(0, 10);
    return [
        ...clinical,
        ...storage
    ].sort((a, b)=>effective(b).localeCompare(effective(a)) || (b.createdAt || '').localeCompare(a.createdAt || ''));
}


// An applied template's lines come back with their «در فهرست تأمین»
// (taminListed) — asked without it of a BFF that predates it.
const $737671bfbc703ec9$var$applyTemplate = (0, $8d8ac6402cc7b03c$export$405a623d7e907e9d)((0, $adebb901af88e18b$export$8395d0fc0d822a81));
const $737671bfbc703ec9$var$norm = (s)=>(s || '').toString().trim().toLowerCase();
// The same values the `:root` block computes to, read from their source.
const $737671bfbc703ec9$var$PAL = {
    panel: (0, $jTCZr.CT).surface,
    panel2: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    mute2: (0, $jTCZr.CT).mute2,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
// One vocabulary of sizes per surface. The desktop numbers are the ones this
// popover has always used; the phone column is `rem` and sized for a thumb —
// §6 puts the floor for a tap target at 2.75rem and forbids px type.
const $737671bfbc703ec9$var$SIZES = {
    web: {
        title: '12.5px',
        body: '12.5px',
        meta: '10.5px',
        note: '10.5px',
        hint: '11px',
        action: '11.5px',
        chevron: '14px',
        cardPad: '8px 9px',
        itemPad: '6px 6px',
        itemGap: '2px',
        radius: 8,
        checkbox: undefined,
        minTap: undefined
    },
    mobile: {
        title: '0.9375rem',
        body: '0.875rem',
        meta: '0.75rem',
        note: '0.75rem',
        hint: '0.8125rem',
        action: '0.875rem',
        chevron: '1.25rem',
        cardPad: '0.75rem 0.875rem',
        itemPad: '0.625rem 0.5rem',
        itemGap: '0.25rem',
        radius: 10,
        checkbox: '1.125rem',
        minTap: '2.75rem'
    }
};
// Popover geometry (desktop only). z-index sits above the page's sticky headers
// (2) and the side panels, and below its modals (1100+), so a confirm dialog
// opened from elsewhere still covers it.
const $737671bfbc703ec9$var$POP_WIDTH = 340;
const $737671bfbc703ec9$var$POP_MAX_HEIGHT = 380;
const $737671bfbc703ec9$var$POP_GAP = 8;
const $737671bfbc703ec9$var$POP_Z = 1000;
function $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies) {
    const names = [
        $737671bfbc703ec9$var$norm(item?.name),
        $737671bfbc703ec9$var$norm(item?.genericName)
    ].filter(Boolean);
    for (const a of allergies || []){
        const al = $737671bfbc703ec9$var$norm(a);
        if (al.length < 3) continue;
        if (names.some((n)=>n.includes(al) || al.includes(n))) return a;
    }
    return null;
}
const $737671bfbc703ec9$var$itemSummary = (kind, item, t)=>{
    if (kind === 'order') return [
        item.orderType && (0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[item.orderType] && t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[item.orderType]),
        item.code
    ].filter(Boolean).join(" \xb7 ");
    return [
        item.dosage,
        item.frequency && (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(item.frequency, t),
        item.duration
    ].filter(Boolean).join(" \xb7 ");
};
function $737671bfbc703ec9$export$2e2bcd8739ae039({ kind: kind, appointmentId: appointmentId, patientId: patientId, onApplied: onApplied, compact: compact = false, disabled: disabled = false, allergies: allergies = [], existingDrugIds: existingDrugIds = [] }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const S = isMobile ? $737671bfbc703ec9$var$SIZES.mobile : $737671bfbc703ec9$var$SIZES.web;
    const meta = (0, $5e2e0b7ea22d1ff2$export$a2d52108c6de7f27)[kind];
    const ready = Boolean(appointmentId && patientId) && !disabled;
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [picked, setPicked] = (0, $acw62.useState)(null); // the template being previewed
    const [selected, setSelected] = (0, $acw62.useState)(new Set());
    const [applying, setApplying] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useRef)(null); // the trigger
    const popRef = (0, $acw62.useRef)(null); // the portalled list
    const [pos, setPos] = (0, $acw62.useState)(null);
    // Templates are fetched only once the doctor asks for them: this control sits
    // on a screen that is already making a dozen calls at open, and a list nobody
    // opened is a call nobody needed.
    const store = (0, $f6afc37e3d3310be$export$a282db6c512184e6)(kind, {
        enabled: open
    });
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        setPicked(null);
        setError(null);
    }, []);
    // Where the list goes: under the trigger, its inline-end edge on the
    // trigger's inline-end edge, kept inside the viewport. Measured on open and
    // again whenever anything scrolls or the window resizes, because a fixed
    // element does not move with the card it belongs to.
    //
    // Desktop only — the sheet is laid out by the viewport, not by the trigger.
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open || isMobile) {
            setPos(null);
            return undefined;
        }
        const measure = ()=>{
            const r = rootRef.current?.getBoundingClientRect();
            if (!r) return;
            const vw = window.innerWidth || 0;
            const vh = window.innerHeight || 0;
            const width = compact ? Math.max(r.width, 240) : $737671bfbc703ec9$var$POP_WIDTH;
            let left = isRTL ? r.left : r.right - width;
            if (vw) left = Math.max($737671bfbc703ec9$var$POP_GAP, Math.min(left, vw - width - $737671bfbc703ec9$var$POP_GAP));
            const top = r.bottom + 6;
            const maxHeight = vh ? Math.max(160, Math.min($737671bfbc703ec9$var$POP_MAX_HEIGHT, vh - top - $737671bfbc703ec9$var$POP_GAP)) : $737671bfbc703ec9$var$POP_MAX_HEIGHT;
            setPos({
                top: top,
                left: left,
                width: width,
                maxHeight: maxHeight
            });
        };
        measure();
        window.addEventListener('resize', measure);
        document.addEventListener('scroll', measure, true);
        return ()=>{
            window.removeEventListener('resize', measure);
            document.removeEventListener('scroll', measure, true);
        };
    }, [
        open,
        isMobile,
        compact,
        isRTL
    ]);
    // Clicking away closes the list, the way every other popover on this screen
    // behaves. Esc steps back before it closes. Bound only while open. The list
    // lives outside the trigger's subtree (portal), so both are checked.
    //
    // Desktop only. The sheet owns Esc, the scrim tap and the back button itself,
    // and everything inside it is outside both refs — this listener would close
    // the sheet on the first tap on a template.
    (0, $acw62.useEffect)(()=>{
        if (!open || isMobile) return undefined;
        const onDocDown = (e)=>{
            const inTrigger = rootRef.current?.contains(e.target);
            const inPop = popRef.current?.contains(e.target);
            if (!inTrigger && !inPop) close();
        };
        const onEsc = (e)=>{
            if (e.key !== 'Escape') return;
            if (picked) setPicked(null);
            else close();
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onEsc);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onEsc);
        };
    }, [
        open,
        isMobile,
        picked,
        close
    ]);
    const existing = (0, $acw62.useMemo)(()=>new Set((existingDrugIds || []).filter(Boolean)), [
        existingDrugIds
    ]);
    const apply = (0, $acw62.useCallback)(async (template, indexes)=>{
        if (!ready) return;
        setApplying(true);
        setError(null);
        try {
            const variables = {
                templateId: template.id,
                appointmentId: appointmentId,
                patientId: patientId
            };
            // Sent only when the doctor left something out: a full apply is the
            // same request it always was.
            if (indexes) variables.itemIndexes = indexes;
            const data = await $737671bfbc703ec9$var$applyTemplate(meta.applyMutation, variables);
            const result = data?.[meta.applyField];
            if (!result) throw new Error(t('visit.templates.failed'));
            onApplied?.(result, (0, $5e2e0b7ea22d1ff2$export$89fd35b67bcc0da1)(result));
            close();
        } catch (err) {
            // Kept ON the picker rather than raised as a toast: the doctor is still
            // looking at the list and the next thing they want is to try again or
            // pick another one.
            setError(err?.message || t('visit.templates.failed'));
        } finally{
            setApplying(false);
        }
    }, [
        ready,
        meta.applyMutation,
        meta.applyField,
        appointmentId,
        patientId,
        onApplied,
        t,
        close
    ]);
    // Picking a template opens its items for review. An empty template has
    // nothing to review and applies straight away — a defined no-op that the
    // toast reports as such.
    const pick = (0, $acw62.useCallback)((template)=>{
        const items = template.items || [];
        if (items.length === 0) {
            apply(template, null);
            return;
        }
        const ticked = new Set();
        items.forEach((item, i)=>{
            if (kind === 'medication' && $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies)) return;
            ticked.add(i);
        });
        setSelected(ticked);
        setPicked(template);
        setError(null);
    }, [
        apply,
        kind,
        allergies
    ]);
    const toggle = (i)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(i)) next.delete(i);
            else next.add(i);
            return next;
        });
    const confirm = ()=>{
        if (!picked) return;
        const items = picked.items || [];
        const all = selected.size === items.length;
        apply(picked, all ? null : [
            ...selected
        ].sort((a, b)=>a - b));
    };
    const label = kind === 'order' ? t('visit.templates.applyOrders') : t('visit.templates.applyRx');
    const triggerStyle = compact ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.375rem',
        width: '100%',
        minHeight: isMobile ? '2.75rem' : undefined,
        padding: isMobile ? '0.625rem 0.75rem' : '10px 12px',
        borderRadius: 10,
        border: `1px dashed ${$737671bfbc703ec9$var$PAL.line}`,
        background: isMobile ? $737671bfbc703ec9$var$PAL.panel : 'transparent',
        color: $737671bfbc703ec9$var$PAL.ink2,
        fontSize: isMobile ? '0.8125rem' : 12.5,
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: ready ? 'pointer' : 'not-allowed',
        opacity: ready ? 1 : 0.55
    } : {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '5px 11px',
        borderRadius: 7,
        border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
        background: $737671bfbc703ec9$var$PAL.panel2,
        color: $737671bfbc703ec9$var$PAL.ink2,
        fontSize: 11.5,
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: ready ? 'pointer' : 'not-allowed',
        opacity: ready ? 1 : 0.55
    };
    const smallLink = {
        background: 'none',
        border: 0,
        padding: 0,
        fontFamily: 'inherit',
        fontSize: S.hint,
        fontWeight: 700,
        color: $737671bfbc703ec9$var$PAL.accentInk,
        cursor: 'pointer'
    };
    // The one sentence that carries the whole mental model. Rendered above
    // whichever step is showing, on both surfaces.
    const renderNote = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.note,
                color: $737671bfbc703ec9$var$PAL.mute,
                lineHeight: 1.7,
                padding: isMobile ? '0 0 0.625rem' : '2px 4px 6px',
                borderBottom: `1px solid ${$737671bfbc703ec9$var$PAL.line2}`,
                marginBottom: isMobile ? '0.625rem' : 6
            }
        }, t('visit.templates.editable'));
    const renderError = ()=>error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visit-template-error-${kind}`,
            style: {
                marginTop: isMobile ? '0.625rem' : 6,
                padding: isMobile ? '0.625rem 0.75rem' : '6px 8px',
                borderRadius: 7,
                background: $737671bfbc703ec9$var$PAL.dangerSoft,
                color: $737671bfbc703ec9$var$PAL.dangerInk,
                fontSize: S.action,
                fontWeight: 600
            }
        }, error) : null;
    const renderList = ()=>store.loading && !store.loaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: isMobile ? '0.75rem 0' : '4px 0'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
            count: 2,
            avatar: false,
            trailing: 0,
            label: t('common.state.loading')
        })) : store.templates.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-template-empty-${kind}`,
            style: {
                padding: isMobile ? '0.75rem 0' : '10px 6px',
                fontSize: S.body,
                color: $737671bfbc703ec9$var$PAL.mute,
                lineHeight: 1.8
            }
        }, t('visit.templates.none'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.meta,
                color: $737671bfbc703ec9$var$PAL.mute2,
                marginTop: 2
            }
        }, t('visit.templates.manage'))) : store.templates.map((template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: template.id,
                type: "button",
                role: "option",
                "aria-selected": false,
                disabled: applying,
                onClick: ()=>pick(template),
                "data-testid": `visit-template-pick-${kind}`,
                "data-template-id": template.id,
                style: {
                    display: 'block',
                    width: '100%',
                    textAlign: 'start',
                    minHeight: S.minTap,
                    padding: S.cardPad,
                    marginBottom: isMobile ? '0.5rem' : 4,
                    borderRadius: S.radius,
                    border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
                    background: $737671bfbc703ec9$var$PAL.panel,
                    cursor: applying ? 'wait' : 'pointer',
                    fontFamily: 'inherit'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: S.title,
                    fontWeight: 700,
                    color: $737671bfbc703ec9$var$PAL.ink
                }
            }, template.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.mute,
                    marginTop: 2
                }
            }, (0, $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2)(template) ? t('settings.templates.itemCount', {
                count: (0, $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2)(template)
            }) : t('settings.templates.noItems'), template.description ? ` \xb7 ${template.description}` : '')));
    // The commit row. Docked in the sheet's footer on a phone — §6 says a submit
    // docks to the bottom edge, and the body here is a scroll region, so a button
    // placed in it scrolls away exactly when the doctor reaches for it.
    const renderCommit = ()=>{
        const count = selected.size;
        const applyLabel = kind === 'order' ? t('visit.templates.applySelectedOrders', {
            count: count
        }) : t('visit.templates.applySelected', {
            count: count
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                paddingTop: isMobile ? 0 : 6,
                borderTop: isMobile ? 'none' : `1px solid ${$737671bfbc703ec9$var$PAL.line2}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: close,
            style: {
                ...smallLink,
                color: $737671bfbc703ec9$var$PAL.ink2,
                fontSize: S.action,
                minHeight: S.minTap,
                padding: isMobile ? '0 0.875rem' : '6px 8px'
            }
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: confirm,
            disabled: applying || count === 0,
            "data-testid": `visit-template-apply-${kind}`,
            style: {
                minHeight: S.minTap,
                padding: isMobile ? '0 1.25rem' : '6px 12px',
                borderRadius: isMobile ? 10 : 7,
                border: 0,
                fontFamily: 'inherit',
                background: $737671bfbc703ec9$var$PAL.accent,
                color: '#fff',
                fontSize: S.action,
                fontWeight: 700,
                cursor: applying || count === 0 ? 'not-allowed' : 'pointer',
                opacity: applying || count === 0 ? 0.55 : 1
            }
        }, applying ? t('visit.templates.applying') : applyLabel));
    };
    const renderPreview = ({ commit: commit })=>{
        const items = picked.items || [];
        const count = selected.size;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-template-preview-${kind}`,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>setPicked(null),
            "aria-label": t('visit.templates.back'),
            "data-testid": `visit-template-back-${kind}`,
            style: {
                ...smallLink,
                color: $737671bfbc703ec9$var$PAL.ink2,
                fontSize: S.chevron,
                lineHeight: 1,
                minWidth: S.minTap,
                minHeight: S.minTap,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: isMobile ? 0 : '0 4px',
                // The chevron points back along the reading direction, so it is
                // one of the few glyphs that must mirror with the layout.
                transform: 'scaleX(var(--dir-flip, 1))'
            }
        }, "\u2039"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.title,
                fontWeight: 700,
                color: $737671bfbc703ec9$var$PAL.ink,
                flex: 1,
                minWidth: 0
            }
        }, picked.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: S.hint,
                color: $737671bfbc703ec9$var$PAL.mute,
                padding: isMobile ? '0 0 0.5rem' : '4px 4px 6px',
                borderBottom: `1px solid ${$737671bfbc703ec9$var$PAL.line2}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set(items.map((_, i)=>i))),
            "data-testid": `visit-template-select-all-${kind}`
        }, t('visit.templates.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set()),
            "data-testid": `visit-template-select-none-${kind}`
        }, t('visit.templates.selectNone')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.templates.selectedOf', {
            selected: formatNumber(count),
            total: formatNumber(items.length)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: S.itemGap
            }
        }, items.map((item, i)=>{
            const checked = selected.has(i);
            const allergy = kind === 'medication' ? $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies) : null;
            const already = kind === 'medication' && item.drugId && existing.has(item.drugId);
            const summary = $737671bfbc703ec9$var$itemSummary(kind, item, t);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
                key: i,
                "data-testid": "visit-template-item",
                "data-index": i,
                "data-checked": checked ? 'true' : 'false',
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8,
                    padding: S.itemPad,
                    minHeight: S.minTap,
                    borderRadius: 7,
                    cursor: 'pointer',
                    background: allergy && !checked ? $737671bfbc703ec9$var$PAL.dangerSoft : 'transparent'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "checkbox",
                checked: checked,
                onChange: ()=>toggle(i),
                style: {
                    marginTop: 3,
                    accentColor: $737671bfbc703ec9$var$PAL.accent,
                    width: S.checkbox,
                    height: S.checkbox,
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6,
                    flexWrap: 'wrap'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: S.body,
                    fontWeight: 600,
                    color: checked ? $737671bfbc703ec9$var$PAL.ink : $737671bfbc703ec9$var$PAL.mute
                }
            }, item.name), summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.mute
                }
            }, summary)), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-template-allergy-hit",
                style: {
                    fontSize: S.meta,
                    fontWeight: 700,
                    color: $737671bfbc703ec9$var$PAL.dangerInk,
                    marginTop: 2
                }
            }, t('visit.templates.allergyHit', {
                substance: allergy
            })), already && !allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-template-already-in-rx",
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.accentInk,
                    marginTop: 2
                }
            }, t('visit.templates.alreadyInRx'))));
        })), commit ? renderCommit() : null);
    };
    const body = (commit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderNote(), picked ? renderPreview({
            commit: commit
        }) : renderList(), renderError());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: rootRef,
        style: {
            position: 'relative',
            ...compact ? {
                width: '100%'
            } : null
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>open ? close() : setOpen(true),
        disabled: !ready,
        title: ready ? undefined : t('visit.templates.needsVisit'),
        "data-testid": `visit-template-open-${kind}`,
        "aria-haspopup": isMobile ? 'dialog' : 'listbox',
        "aria-expanded": open,
        style: triggerStyle
    }, label), isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: label,
        closeLabel: t('common.actions.close'),
        // Deliberately NOT `fullHeight`: the sheet hugs what it holds and the
        // cap does the rest, so three drugs are a short sheet and fifteen are
        // a scroll region — either way the commit row is docked at the bottom
        // edge. `fullHeight` would put a screen of white space under a
        // three-item template.
        snap: 0.9,
        "data-testid": `visit-template-sheet-${kind}`,
        footer: picked ? renderCommit() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-template-list-${kind}`
    }, body(false))) : open && pos && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popRef,
        role: "listbox",
        dir: isRTL ? 'rtl' : 'ltr',
        "data-testid": `visit-template-list-${kind}`,
        style: {
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            width: pos.width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            zIndex: $737671bfbc703ec9$var$POP_Z,
            background: $737671bfbc703ec9$var$PAL.panel2,
            border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
            borderRadius: 10,
            boxShadow: $737671bfbc703ec9$var$PAL.shadowPop,
            padding: 8,
            // Portaled to document.body, so `inherit` would miss the app face.
            fontFamily: 'var(--app-font)'
        }
    }, body(true)), document.body));
}
function $737671bfbc703ec9$export$9694ceada819b6a5(kind, result, outcome, t, formatList) {
    const title = result?.templateTitle || '';
    if (outcome.kind === 'none') return t('visit.templates.appliedNone', {
        title: title
    });
    const countKey = kind === 'order' ? 'visit.templates.appliedOrders' : 'visit.templates.appliedRx';
    const main = t(countKey, {
        count: outcome.applied,
        title: title
    });
    if (outcome.kind === 'partial') return `${main} \u{2014} ${t('visit.templates.partial', {
        items: formatList(outcome.failed)
    })}`;
    return main;
}



var $acw62 = parcelRequire("acw62");


// ── Visit.shared.js ──────────────────────────────────────────────────────────
// Shared GraphQL operations, CSS, primitives, and helper components used by both
// Visit.web.jsx (desktop) and Visit.mobile.jsx (mobile). Extracted verbatim from
// the former unified Visit.web.jsx so desktop's behavior/output is unchanged.
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
function $9cbf1cd12683ca1b$export$1b636b4aaaa4a081({ continuous: continuous = false, autoRestart: autoRestart = false, onFinalSegment: onFinalSegment } = {}) {
    // A hook may call a hook: the messages this sets land in the UI, so they
    // follow the selected language like any other copy.
    const { t: t } = (0, $LNQP4.default)();
    const [status, setStatus] = (0, $acw62.useState)('idle');
    const [transcript, setTranscript] = (0, $acw62.useState)('');
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)('');
    const recRef = (0, $acw62.useRef)(null);
    const accRef = (0, $acw62.useRef)('');
    const permOkRef = (0, $acw62.useRef)(false); // skip getUserMedia re-check after first grant
    // wantRef  — the caller asked to listen and has not asked to stop.
    // busyRef  — a start() is between "asked" and "recognizer running"; a second
    //            call in that window must not spawn a rival recognizer.
    // sessionRef — monotonic id of the newest recogniser. A superseded one still
    //            fires its own onend (abort is asynchronous in the browser), and
    //            that stale end must not restart anything on top of its successor.
    // timerRef — the pending auto-restart, cancelled by stop()/unmount.
    const wantRef = (0, $acw62.useRef)(false);
    const busyRef = (0, $acw62.useRef)(false);
    const sessionRef = (0, $acw62.useRef)(0);
    const timerRef = (0, $acw62.useRef)(null);
    const mountedRef = (0, $acw62.useRef)(true);
    const startRef = (0, $acw62.useRef)(null); // latest start(), for the restart timer
    const getSR = ()=>{
        try {
            return window.SpeechRecognition || window.webkitSpeechRecognition || null;
        } catch  {
            return null;
        }
    };
    const clearRestart = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const stop = (0, $acw62.useCallback)(()=>{
        wantRef.current = false;
        clearRestart();
        try {
            recRef.current?.stop();
        } catch  {}
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        accRef.current = '';
        setTranscript('');
        setStatus('idle');
        setErrorDetail('');
    }, []);
    const start = (0, $acw62.useCallback)(async ()=>{
        wantRef.current = true;
        // One recognizer at a time. Without this the permission await below is a
        // window in which every extra start() call creates another instance.
        if (busyRef.current) return;
        const SR = getSR();
        if (!SR) {
            wantRef.current = false;
            setStatus('unsupported');
            return;
        }
        busyRef.current = true;
        try {
            // Claim the session BEFORE aborting the previous recogniser. The abort
            // makes that one fire its own end/error, and it must already look stale
            // when it does — otherwise it schedules a restart of its own and the two
            // take turns aborting each other forever.
            const session = ++sessionRef.current;
            clearRestart();
            // Abort any in-flight recognition before starting a new one
            try {
                recRef.current?.abort();
            } catch  {}
            recRef.current = null;
            setErrorDetail('');
            // First call: force OS-level mic permission dialog via getUserMedia.
            // Subsequent re-starts skip this — permission is already cached by the browser.
            if (!permOkRef.current && navigator.mediaDevices?.getUserMedia) try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
                stream.getTracks().forEach((track)=>track.stop());
                permOkRef.current = true;
            } catch (err) {
                const name = err?.name || '';
                wantRef.current = false;
                if (name === 'NotAllowedError' || name === 'PermissionDeniedError') setStatus('denied');
                else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
                    setStatus('error');
                    setErrorDetail(t('errors.mic.notFound'));
                } else {
                    setStatus('error');
                    setErrorDetail(err?.message || t('errors.mic.access'));
                }
                return;
            }
            // The caller may have stopped (or unmounted) while the permission dialog
            // was open — starting now would leave a recognizer nobody owns.
            if (!wantRef.current || !mountedRef.current) return;
            let rec;
            try {
                rec = new SR();
            } catch  {
                wantRef.current = false;
                setStatus('unsupported');
                return;
            }
            rec.lang = 'fa-IR';
            rec.continuous = continuous;
            rec.interimResults = true;
            rec.maxAlternatives = 1;
            recRef.current = rec;
            // Every callback below is session-guarded: a recogniser that has been
            // superseded still fires events, and none of them are this hook's state.
            rec.onstart = ()=>{
                if (session === sessionRef.current) setStatus('listening');
            };
            rec.onerror = (e)=>{
                if (session !== sessionRef.current) return; // superseded — not our state
                const err = e.error;
                if (err === 'not-allowed' || err === 'permission-denied') {
                    wantRef.current = false;
                    setStatus('denied');
                } else if (err === 'audio-capture') {
                    wantRef.current = false;
                    setStatus('error');
                    setErrorDetail(t('errors.mic.notFound'));
                } else if (err === 'network') {
                    wantRef.current = false;
                    setStatus('error');
                    setErrorDetail(t('errors.networkHint'));
                } else if (err === 'no-speech' || err === 'aborted') // Silence timeout or manual abort — onend decides whether to resume
                setStatus('idle');
                else {
                    console.warn('[useVoiceInput] error:', err);
                    setStatus('idle');
                }
            };
            rec.onend = ()=>{
                if (recRef.current === rec) recRef.current = null;
                if (session !== sessionRef.current) return; // superseded — not our state
                setStatus((prev)=>prev === 'listening' ? 'idle' : prev);
                // A browser-initiated end while the caller still wants to listen: resume.
                if (autoRestart && wantRef.current && mountedRef.current) {
                    clearRestart();
                    timerRef.current = setTimeout(()=>{
                        timerRef.current = null;
                        if (wantRef.current && mountedRef.current) startRef.current?.();
                    }, 250);
                }
            };
            rec.onresult = (e)=>{
                if (session !== sessionRef.current) return; // superseded — not our transcript
                let interim = '';
                for(let i = e.resultIndex; i < e.results.length; i++){
                    const text = e.results[i][0].transcript;
                    if (e.results[i].isFinal) {
                        accRef.current += text + ' ';
                        onFinalSegment?.(text);
                    } else interim = text;
                }
                setTranscript((accRef.current + interim).trim());
            };
            try {
                rec.start();
            } catch (err) {
                console.warn('[useVoiceInput] start failed:', err);
                setStatus('idle');
            }
        } finally{
            busyRef.current = false;
        }
    }, [
        continuous,
        autoRestart,
        onFinalSegment,
        t
    ]);
    // The restart timer fires outside render, so it needs the current closure.
    (0, $acw62.useEffect)(()=>{
        startRef.current = start;
    });
    (0, $acw62.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
            wantRef.current = false;
            clearRestart();
            try {
                recRef.current?.abort();
            } catch  {}
        };
    }, []);
    return {
        status: status,
        transcript: transcript,
        errorDetail: errorDetail,
        start: start,
        stop: stop,
        reset: reset,
        isSupported: !!getSR()
    };
}



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $a83Oj = parcelRequire("a83Oj");


const $7ecc8909c8058bf5$export$806b28ef46e23f03 = 30000;
function $7ecc8909c8058bf5$var$pickMime() {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4'
    ];
    try {
        return types.find((type)=>window.MediaRecorder?.isTypeSupported?.(type)) || '';
    } catch  {
        return '';
    }
}
const $7ecc8909c8058bf5$var$supported = ()=>{
    try {
        return typeof window !== 'undefined' && typeof window.MediaRecorder !== 'undefined' && Boolean(navigator?.mediaDevices?.getUserMedia) && typeof window.WebSocket !== 'undefined';
    } catch  {
        return false;
    }
};
const $7ecc8909c8058bf5$var$join = (a, b)=>[
        a,
        b
    ].map((x)=>(x || '').trim()).filter(Boolean).join(' ');
function $7ecc8909c8058bf5$export$db41ba3bc0cf8f1c({ engine: engine = 'parsina' } = {}) {
    const { t: t } = (0, $LNQP4.default)();
    const [status, setStatus] = (0, $acw62.useState)('idle'); // idle | listening | transcribing | denied | unsupported | error
    const [transcript, setTranscript] = (0, $acw62.useState)('');
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)('');
    const [servedEngine, setServedEngine] = (0, $acw62.useState)(null);
    const mountedRef = (0, $acw62.useRef)(true);
    const wsRef = (0, $acw62.useRef)(null);
    const mrRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const prefixRef = (0, $acw62.useRef)(''); // text of earlier streams (stop → resume)
    const currentRef = (0, $acw62.useRef)(''); // this stream's text so far
    const doneSentRef = (0, $acw62.useRef)(false);
    const startingRef = (0, $acw62.useRef)(false);
    const finalWaitersRef = (0, $acw62.useRef)([]);
    const timeoutRef = (0, $acw62.useRef)(null);
    const full = ()=>$7ecc8909c8058bf5$var$join(prefixRef.current, currentRef.current);
    const publish = ()=>{
        if (mountedRef.current) setTranscript(full());
    };
    const set = (fn, v)=>{
        if (mountedRef.current) fn(v);
    };
    const settle = ()=>{
        const text = full();
        const waiters = finalWaitersRef.current;
        finalWaitersRef.current = [];
        waiters.forEach((resolve)=>resolve(text));
    };
    // Every exit — final frame, server error, socket close, timeout, cancel,
    // unmount — passes through here, so an awaiting finish() never hangs.
    const teardown = (0, $acw62.useCallback)(()=>{
        startingRef.current = false;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        try {
            if (mrRef.current && mrRef.current.state !== 'inactive') mrRef.current.stop();
        } catch  {}
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        mrRef.current = null;
        streamRef.current = null;
        const ws = wsRef.current;
        wsRef.current = null;
        if (ws) {
            try {
                ws.onmessage = ws.onerror = ws.onclose = null;
            } catch  {}
            try {
                ws.close(1000, 'client done');
            } catch  {}
        }
        // The finished stream's words become the prefix of the next one.
        prefixRef.current = full();
        currentRef.current = '';
        settle();
    }, []);
    const fail = (0, $acw62.useCallback)((kind, detail)=>{
        teardown();
        set(setErrorDetail, detail || '');
        set(setStatus, kind);
    }, [
        teardown
    ]);
    const start = (0, $acw62.useCallback)(async ()=>{
        if (startingRef.current || wsRef.current) return;
        if (!$7ecc8909c8058bf5$var$supported()) {
            set(setStatus, 'unsupported');
            return;
        }
        startingRef.current = true;
        setErrorDetail('');
        let token = (0, $a83Oj.getToken)();
        if (!token || (0, $a83Oj.isTokenExpired)(token)) {
            const ok = await (0, $a83Oj.refreshAccessToken)();
            token = ok ? (0, $a83Oj.getToken)() : null;
        }
        if (!token) {
            startingRef.current = false;
            fail('error', t('visit.voice.sessionExpired'));
            return;
        }
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
        } catch (err) {
            startingRef.current = false;
            const denied = err?.name === 'NotAllowedError' || err?.name === 'SecurityError';
            set(setStatus, denied ? 'denied' : 'error');
            set(setErrorDetail, denied ? '' : t('visit.voice.micError'));
            return;
        }
        if (!mountedRef.current || !startingRef.current) {
            stream.getTracks().forEach((track)=>track.stop());
            return;
        }
        streamRef.current = stream;
        doneSentRef.current = false;
        currentRef.current = '';
        const url = `${(0, $eabde0fc143396e8$export$8742212cdac9d01)()}/ws/transcribe?token=${encodeURIComponent(token)}` + `&language=${encodeURIComponent((0, $adebb901af88e18b$export$7f5d9d25e625ad97)())}&hints=off&engine=${encodeURIComponent(engine)}`;
        const ws = new WebSocket(url);
        wsRef.current = ws;
        ws.onopen = ()=>{
            const mime = $7ecc8909c8058bf5$var$pickMime();
            let mr;
            try {
                mr = new MediaRecorder(stream, mime ? {
                    mimeType: mime
                } : {});
            } catch  {
                fail('error', t('visit.voice.micError'));
                return;
            }
            mrRef.current = mr;
            mr.ondataavailable = (e)=>{
                if (e.data && e.data.size > 0 && ws.readyState === WebSocket.OPEN) ws.send(e.data);
            };
            // `done` goes out only once the recorder has flushed its LAST chunk —
            // MediaRecorder.stop() emits it asynchronously, and a chunk that lands
            // after `done` is dropped by the BFF.
            mr.onstop = ()=>{
                if (ws.readyState === WebSocket.OPEN && !doneSentRef.current) {
                    doneSentRef.current = true;
                    ws.send(JSON.stringify({
                        done: true
                    }));
                }
            };
            mr.start(250);
            startingRef.current = false;
            set(setStatus, 'listening');
        };
        ws.onmessage = (e)=>{
            let msg;
            try {
                msg = JSON.parse(e.data);
            } catch  {
                return;
            }
            if (msg.engine) set(setServedEngine, msg.engine);
            if (msg.error) {
                fail('error', t('visit.voice.serverError'));
                return;
            }
            if (msg.is_final) {
                // The final pass covers THIS stream's whole buffer, so it replaces.
                if (msg.text) currentRef.current = msg.text;
                publish();
                teardown();
                set(setStatus, 'idle');
                return;
            }
            if (msg.text) {
                currentRef.current = msg.replace ? msg.text : $7ecc8909c8058bf5$var$join(currentRef.current, msg.text);
                publish();
            }
        };
        ws.onerror = ()=>{};
        ws.onclose = ()=>{
            if (wsRef.current !== ws) return;
            // Closed before the final frame: keep whatever arrived, and say so only
            // when nothing did.
            const heard = full();
            teardown();
            if (heard) set(setStatus, 'idle');
            else fail('error', t('visit.voice.serverError'));
        };
    }, [
        engine,
        fail,
        teardown,
        t
    ]);
    // Ask for the final pass. Resolves with the full transcript either way.
    const finish = (0, $acw62.useCallback)(()=>{
        const ws = wsRef.current;
        if (!ws) {
            startingRef.current = false;
            return Promise.resolve(full());
        }
        const promise = new Promise((resolve)=>{
            finalWaitersRef.current.push(resolve);
        });
        set(setStatus, 'transcribing');
        const mr = mrRef.current;
        if (mr && mr.state !== 'inactive') try {
            mr.stop();
        } catch  {}
        else if (ws.readyState === WebSocket.OPEN && !doneSentRef.current) {
            doneSentRef.current = true;
            ws.send(JSON.stringify({
                done: true
            }));
        }
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        if (!timeoutRef.current) timeoutRef.current = setTimeout(()=>{
            timeoutRef.current = null;
            teardown();
            set(setStatus, 'idle');
        }, $7ecc8909c8058bf5$export$806b28ef46e23f03);
        return promise;
    }, [
        teardown
    ]);
    // Abandon: close without waiting. The BFF cancels an unfinished stream.
    const cancel = (0, $acw62.useCallback)(()=>{
        teardown();
        set(setStatus, 'idle');
    }, [
        teardown
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        teardown();
        prefixRef.current = '';
        currentRef.current = '';
        setTranscript('');
        setErrorDetail('');
        setServedEngine(null);
        setStatus('idle');
    }, [
        teardown
    ]);
    (0, $acw62.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
            teardown();
        };
    }, [
        teardown
    ]);
    return {
        status: status,
        transcript: transcript,
        errorDetail: errorDetail,
        servedEngine: servedEngine,
        start: start,
        stop: finish,
        finish: finish,
        cancel: cancel,
        reset: reset,
        isSupported: $7ecc8909c8058bf5$var$supported()
    };
}


// «موتور تبدیل گفتار به متن» — which engine turns the doctor's voice into text.
//
// The doctor picks one in Settings → دستیار هوشمند; the value is stored on the
// practitioner's AI settings (`speechEngine`) and read here. Three engines:
//
//   parsina    «گفتار به متن پارسینا» — the AI service's dedicated speech model
//              (speech_engines.py). The product default.
//   assistant  «دستیار هوشمند» — the AI service's general transcription.
//   browser    «مرورگر (Chrome)» — the browser's own Web Speech API. Free, but
//              absent on Safari and every browser on iOS, and it sends the audio
//              to the browser vendor rather than to Parsina.
//
// Two surfaces use an engine and they do not have the same options:
//
//   • per-section dictation («ثبت صوتی») may use all three;
//   • the ambient visit recording may use only the two SERVER engines — the
//     browser recogniser cannot hear a video call's audio and feeds no clinical
//     hints — so a doctor who chose `browser` records the visit on Parsina STT.
//
// "PARSINA IS THE DEFAULT, WITH FALLBACK" is enforced by the AI service, not
// here: a stream that asks for Parsina STT while it cannot answer is served —
// and billed — by the assistant engine, and the stream's first frame says which
// engine served (`engine` on the socket). So nothing here waits on a readiness
// check before starting a microphone.
const $33deae5c7ec89d7f$export$303b337dd3fdcd5e = 'parsina';
const $33deae5c7ec89d7f$export$c61f8b0aeda2c58e = 'assistant';
const $33deae5c7ec89d7f$export$14e406b759a48fe6 = 'browser';
const $33deae5c7ec89d7f$export$b9da910a30b0dc48 = Object.freeze([
    $33deae5c7ec89d7f$export$303b337dd3fdcd5e,
    $33deae5c7ec89d7f$export$c61f8b0aeda2c58e,
    $33deae5c7ec89d7f$export$14e406b759a48fe6
]);
const $33deae5c7ec89d7f$export$a94ba151bfc9b67a = $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
const $33deae5c7ec89d7f$export$e46fd2bfabfad0c8 = Object.freeze({
    [$33deae5c7ec89d7f$export$303b337dd3fdcd5e]: 'TranscribeAudioParsina',
    [$33deae5c7ec89d7f$export$c61f8b0aeda2c58e]: 'TranscribeAudio'
});
const $33deae5c7ec89d7f$export$8636e31299dc73ad = (engine)=>engine === $33deae5c7ec89d7f$export$303b337dd3fdcd5e || engine === $33deae5c7ec89d7f$export$c61f8b0aeda2c58e;
function $33deae5c7ec89d7f$export$e976735e46efaec2(ai) {
    const value = ai?.speechEngine;
    return $33deae5c7ec89d7f$export$b9da910a30b0dc48.includes(value) ? value : $33deae5c7ec89d7f$export$a94ba151bfc9b67a;
}
function $33deae5c7ec89d7f$export$27c418303ede0f96() {
    try {
        return typeof window !== 'undefined' && Boolean(window.SpeechRecognition || window.webkitSpeechRecognition);
    } catch  {
        return false;
    }
}
function $33deae5c7ec89d7f$export$6d89c0f0f7f89c2d(preference, { browserSupported: browserSupported = $33deae5c7ec89d7f$export$27c418303ede0f96() } = {}) {
    if (preference === $33deae5c7ec89d7f$export$14e406b759a48fe6) return browserSupported ? $33deae5c7ec89d7f$export$14e406b759a48fe6 : $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
    return $33deae5c7ec89d7f$export$8636e31299dc73ad(preference) ? preference : $33deae5c7ec89d7f$export$a94ba151bfc9b67a;
}
function $33deae5c7ec89d7f$export$a597380b597b4b46(preference) {
    return preference === $33deae5c7ec89d7f$export$c61f8b0aeda2c58e ? $33deae5c7ec89d7f$export$c61f8b0aeda2c58e : $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
}


parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");
var $5JYPc = parcelRequire("5JYPc");

var $eLeza = parcelRequire("eLeza");
// ─────────────────────────────────────────────────────────────────────────────
// Settings — shared logic (DESIGN-CONCEPT-MOBILE v2 §1.1).
//
// `Settings.web.jsx` and `Settings.mobile.jsx` are two independent render trees
// that must never *disagree* about what a setting means, what its default is,
// which section owns it, or when the form is dirty. All of that non-visual truth
// lives here.
//
// Markup is NOT here — a component belongs to exactly one surface. This module
// holds the section registry, defaults, validation and pure derivations only.
//
// It also holds no TEXT. Every user-facing string in this file is a translation
// KEY, resolved by whichever surface renders it. That is what keeps «what a
// setting is called» a single fact while still letting it be called it in two
// languages — a literal here would be a Persian string neither surface could
// translate, because a plain module cannot call a hook.
// ─────────────────────────────────────────────────────────────────────────────

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $Hy6Lb = parcelRequire("Hy6Lb");
// ─────────────────────────────────────────────────────────────────────────────
// Font family — the doctor's choice of typeface, applied app-wide.
//
// The accent preset and the type SCALE are painted by the design system's
// ThemeProvider (`data-theme` / `data-font-size` on <html>, consumed by
// tokens.css). The typeFACE is the app's own: the framework declares no font,
// each client ships its own faces (see styles.css), so the catalogue of ids
// lives here and the painting works the same way — one attribute on the root,
// `data-font-family`, and every screen follows through `var(--app-font)`.
//
// The ids are what the server stores (`appearance.fontFamily` — a free-form
// string, like `theme`). Adding a face is a client-only change: a @font-face
// block and a `--font-<id>` variable in styles.css, one entry here, one label
// in settings.json. Nothing else knows the list.
//
// Why the CSS variable rather than setting `font-family` on <html>: form
// controls do NOT inherit the document font, so styles.css pins them to the
// same variable; and the picker previews each option in its own face through
// `fontFamilyVar(id)` without duplicating the stack in JavaScript.
// ─────────────────────────────────────────────────────────────────────────────
const $2b1ef8e92b4fa1dc$export$5e0101b7a2e9ac78 = [
    // The brand face — Vazirmatn, served as «Meshkat». Default for every doctor
    // who never opens the picker, so shipping this changes nothing for them.
    {
        id: 'meshkat',
        labelKey: 'settings.appearance.fonts.meshkat',
        hintKey: 'settings.appearance.fonts.meshkatHint'
    },
    {
        id: 'sahel',
        labelKey: 'settings.appearance.fonts.sahel',
        hintKey: 'settings.appearance.fonts.sahelHint'
    },
    {
        id: 'shabnam',
        labelKey: 'settings.appearance.fonts.shabnam',
        hintKey: 'settings.appearance.fonts.shabnamHint'
    },
    {
        id: 'samim',
        labelKey: 'settings.appearance.fonts.samim',
        hintKey: 'settings.appearance.fonts.samimHint'
    },
    // The operating system's own UI face (Segoe UI / Tahoma on the Windows
    // workstations most clinics run) — for a doctor who wants the panel to look
    // like the rest of their desktop, or whose eyes are used to Tahoma from the
    // older HIS software.
    {
        id: 'system',
        labelKey: 'settings.appearance.fonts.system',
        hintKey: 'settings.appearance.fonts.systemHint'
    }
];
const $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294 = 'meshkat';
const $2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7 = 'data-font-family';
const $2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2 = 'parsina.fontFamily';
const $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d = (id)=>$2b1ef8e92b4fa1dc$export$5e0101b7a2e9ac78.some((f)=>f.id === id);
const $2b1ef8e92b4fa1dc$export$b2f634c57ce36bba = (id)=>`var(--font-${$2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(id) ? id : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294})`;
const $2b1ef8e92b4fa1dc$var$rootOf = (doc)=>(doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
const $2b1ef8e92b4fa1dc$var$storageOf = (storage)=>storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
function $2b1ef8e92b4fa1dc$export$858b2319de02e404(storage) {
    try {
        const raw = $2b1ef8e92b4fa1dc$var$storageOf(storage)?.getItem($2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2);
        return $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(raw) ? raw : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    } catch  {
        return $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    }
}
function $2b1ef8e92b4fa1dc$export$cdb625a815e5766e(id, storage) {
    try {
        $2b1ef8e92b4fa1dc$var$storageOf(storage)?.setItem($2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2, id);
    } catch  {
    // Best-effort cache; the server copy is the record.
    }
}
function $2b1ef8e92b4fa1dc$export$a9095290f9c44563(id, doc) {
    const resolved = $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(id) ? id : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    const root = $2b1ef8e92b4fa1dc$var$rootOf(doc);
    if (root) root.setAttribute($2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7, resolved);
    return resolved;
}
function $2b1ef8e92b4fa1dc$export$1e5f589b69a6bdc(doc) {
    const value = $2b1ef8e92b4fa1dc$var$rootOf(doc)?.getAttribute($2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7);
    return $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(value) ? value : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
}
function $2b1ef8e92b4fa1dc$export$17d5115a21e3d7f9(id, { doc: doc, storage: storage } = {}) {
    const resolved = $2b1ef8e92b4fa1dc$export$a9095290f9c44563(id, doc);
    $2b1ef8e92b4fa1dc$export$cdb625a815e5766e(resolved, storage);
    return resolved;
}


// ─────────────────────────────────────────────────────────────────────────────
// Visit page layout — the vocabulary the doctor can customise, and the pure
// resolution from "what the server stored" to "what the page renders".
//
// Both Visit surfaces (Visit.web.jsx, Visit.mobile.jsx) and the Settings
// editor read THIS module, so the three can never disagree about which
// sections exist, what they are called, which may be hidden, or what the
// untouched page looks like. No markup, no text — labels are translation keys.
//
// The stored shape (`doctor.settings.visitLayout`, see VISIT_LAYOUT_DEFAULTS)
// is deliberately sparse: a doctor who never opened the editor has empty lists,
// which resolves to the page exactly as it shipped. The service stores ids
// verbatim and validates nothing, so every rule about unknown ids, locked
// sections and "at least one tab" lives here — the client is the only thing
// that knows the catalogue.
//
// Adding a customisable thing to the visit page: add its id to the matching
// catalogue below (with a `labelKey`), render it from the resolved layout, and
// the editor, the persistence and the tests pick it up. Adding a NEW screen's
// layout: a sibling module like this one plus a new settings section — see
// docs/UI-CUSTOMIZATION.md.
// ─────────────────────────────────────────────────────────────────────────────
// «پرونده بیمار» — the record column, in the order the page shipped with.
// `locked` sections can be reordered and collapsed but never hidden: the
// allergy banner is a safety signal, not a preference.
const $792124e2f7de719a$export$286013f25f0f7b72 = [
    {
        id: 'allergy',
        labelKey: 'visit.patient.allergyAlert',
        locked: true
    },
    {
        id: 'demo',
        labelKey: 'visit.patient.details'
    },
    // «سوابق ویزیت‌های قبلی» sits right under «مشخصات» (PM-0023): what happened last
    // time is the first thing a doctor looks for, and it used to be the last
    // section of the app's longest scroll. A doctor who arranged their own order
    // keeps it — this is only the untouched page.
    {
        id: 'history',
        labelKey: 'visit.history.title'
    },
    {
        id: 'vitals',
        labelKey: 'visit.vitals.title'
    },
    {
        id: 'meds',
        labelKey: 'patient.meds.current'
    },
    {
        id: 'dx',
        labelKey: 'patient.conditions.active'
    },
    {
        id: 'conds',
        labelKey: 'visit.patient.conditionHistory'
    },
    {
        id: 'labs',
        labelKey: 'visit.patient.labResults'
    },
    // «مدارک بیمار» (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1). A doctor
    // whose stored order predates it gets it appended at the end (orderByPreference).
    {
        id: 'files',
        labelKey: 'visit.patient.files'
    }
];
const $792124e2f7de719a$export$b42ce7b9554c2388 = [
    {
        id: 'soap',
        labelKey: 'visit.tabs.soap',
        locked: true
    },
    {
        id: 'rx',
        labelKey: 'visit.tabs.rx'
    },
    {
        id: 'orders',
        labelKey: 'visit.tabs.orders'
    },
    {
        id: 'plan',
        labelKey: 'visit.tabs.plan',
        locked: true
    }
];
const $792124e2f7de719a$export$cf705f4052b87526 = [
    {
        id: 'sugg',
        labelKey: 'visit.copilot.clinicalNotes'
    },
    {
        id: 'diff',
        labelKey: 'visit.copilot.differential'
    },
    {
        id: 'ask',
        labelKey: 'visit.copilot.ask'
    }
];
const $792124e2f7de719a$export$df312747b9dc7053 = {
    recordSectionOrder: [],
    recordSectionsHidden: [],
    recordSectionsCollapsed: [],
    workTabsHidden: [],
    defaultWorkTab: 'soap',
    copilotTabsHidden: [],
    defaultCopilotTab: 'sugg'
};
const $792124e2f7de719a$var$asList = (v)=>Array.isArray(v) ? v.filter((x)=>typeof x === 'string') : [];
function $792124e2f7de719a$export$3847309b37cec074(catalog, storedOrder) {
    const known = new Set(catalog.map((c)=>c.id));
    const seen = new Set();
    const ids = [];
    for (const id of $792124e2f7de719a$var$asList(storedOrder))if (known.has(id) && !seen.has(id)) {
        seen.add(id);
        ids.push(id);
    }
    for (const c of catalog)if (!seen.has(c.id)) ids.push(c.id);
    const byId = Object.fromEntries(catalog.map((c)=>[
            c.id,
            c
        ]));
    return ids.map((id)=>byId[id]);
}
// A tab set with its default: hidden ids drop out (never a locked one), and if
// the stored default is hidden or unknown the first visible tab stands in, so
// the page always opens on something that exists.
function $792124e2f7de719a$var$resolveTabs(catalog, hidden, storedDefault, fallbackId) {
    const hiddenSet = new Set($792124e2f7de719a$var$asList(hidden));
    let tabs = catalog.map((tab)=>({
            ...tab,
            visible: Boolean(tab.locked) || !hiddenSet.has(tab.id)
        }));
    if (!tabs.some((tab)=>tab.visible)) tabs = tabs.map((tab)=>({
            ...tab,
            visible: true
        }));
    const visible = tabs.filter((tab)=>tab.visible);
    const preferred = visible.find((tab)=>tab.id === storedDefault) || visible.find((tab)=>tab.id === fallbackId) || visible[0];
    return {
        tabs: tabs,
        defaultTab: preferred.id
    };
}
function $792124e2f7de719a$export$e88ad8319f3008b2(settings) {
    const s = {
        ...$792124e2f7de719a$export$df312747b9dc7053,
        ...settings || {}
    };
    const hidden = new Set($792124e2f7de719a$var$asList(s.recordSectionsHidden));
    const collapsed = new Set($792124e2f7de719a$var$asList(s.recordSectionsCollapsed));
    const recordSections = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, s.recordSectionOrder).map((sec)=>({
            ...sec,
            visible: Boolean(sec.locked) || !hidden.has(sec.id),
            collapsed: collapsed.has(sec.id)
        }));
    const work = $792124e2f7de719a$var$resolveTabs($792124e2f7de719a$export$b42ce7b9554c2388, s.workTabsHidden, s.defaultWorkTab, $792124e2f7de719a$export$df312747b9dc7053.defaultWorkTab);
    const copilot = $792124e2f7de719a$var$resolveTabs($792124e2f7de719a$export$cf705f4052b87526, s.copilotTabsHidden, s.defaultCopilotTab, $792124e2f7de719a$export$df312747b9dc7053.defaultCopilotTab);
    return {
        recordSections: recordSections,
        workTabs: work.tabs,
        defaultWorkTab: work.defaultTab,
        copilotTabs: copilot.tabs,
        defaultCopilotTab: copilot.defaultTab
    };
}
const $792124e2f7de719a$export$e111fe7e8e6c2d5d = (layout)=>layout.recordSections.filter((s)=>s.visible);
const $792124e2f7de719a$export$6a56c49bd01f6de1 = (layout)=>layout.workTabs.filter((t)=>t.visible);
const $792124e2f7de719a$export$8ea4bfdcdcef566 = (layout)=>layout.copilotTabs.filter((t)=>t.visible);
const $792124e2f7de719a$export$172b3bca5806e964 = (layout, id)=>layout.recordSections.some((s)=>s.id === id && s.visible);
const $792124e2f7de719a$export$f9d63a319ff0f5db = (layout)=>Object.fromEntries(layout.recordSections.map((s)=>[
            s.id,
            !s.collapsed
        ]));
// ── Editor operations — pure, return the PATCH to persist ────────────────────
//
// Each takes the stored settings (sparse) and returns only the keys that
// change, in the stored shape, so the caller can hand the result straight to
// the partial-update mutation.
const $792124e2f7de719a$var$without = (list, id)=>$792124e2f7de719a$var$asList(list).filter((x)=>x !== id);
const $792124e2f7de719a$var$withId = (list, id)=>$792124e2f7de719a$var$asList(list).includes(id) ? $792124e2f7de719a$var$asList(list) : [
        ...$792124e2f7de719a$var$asList(list),
        id
    ];
function $792124e2f7de719a$export$740573c0382b46de(settings, id, toIndex) {
    const order = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, settings?.recordSectionOrder).map((s)=>s.id);
    const from = order.indexOf(id);
    const to = Math.max(0, Math.min(order.length - 1, Math.trunc(toIndex)));
    if (from === -1 || from === to || !Number.isFinite(toIndex)) return {};
    const next = [
        ...order
    ];
    next.splice(from, 1);
    next.splice(to, 0, id);
    return {
        recordSectionOrder: next
    };
}
function $792124e2f7de719a$export$64d504ab69df77b0(settings, id, delta) {
    const order = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, settings?.recordSectionOrder).map((s)=>s.id);
    const from = order.indexOf(id);
    if (from === -1) return {};
    const to = from + delta;
    if (to < 0 || to >= order.length) return {};
    return $792124e2f7de719a$export$740573c0382b46de(settings, id, to);
}
function $792124e2f7de719a$export$276da83ac94a32f6(settings, id, visible) {
    const section = $792124e2f7de719a$export$286013f25f0f7b72.find((s)=>s.id === id);
    if (!section || section.locked) return {};
    return {
        recordSectionsHidden: visible ? $792124e2f7de719a$var$without(settings?.recordSectionsHidden, id) : $792124e2f7de719a$var$withId(settings?.recordSectionsHidden, id)
    };
}
function $792124e2f7de719a$export$38f0593b6bfb6420(settings, id, collapsed) {
    return {
        recordSectionsCollapsed: collapsed ? $792124e2f7de719a$var$withId(settings?.recordSectionsCollapsed, id) : $792124e2f7de719a$var$without(settings?.recordSectionsCollapsed, id)
    };
}
function $792124e2f7de719a$export$7eeed700e5288c3(settings, id, visible) {
    const tab = $792124e2f7de719a$export$b42ce7b9554c2388.find((t)=>t.id === id);
    if (!tab || tab.locked) return {};
    return {
        workTabsHidden: visible ? $792124e2f7de719a$var$without(settings?.workTabsHidden, id) : $792124e2f7de719a$var$withId(settings?.workTabsHidden, id)
    };
}
function $792124e2f7de719a$export$fa98c16fa5ba5172(settings, id, visible) {
    if (!$792124e2f7de719a$export$cf705f4052b87526.some((t)=>t.id === id)) return {};
    const hidden = visible ? $792124e2f7de719a$var$without(settings?.copilotTabsHidden, id) : $792124e2f7de719a$var$withId(settings?.copilotTabsHidden, id);
    // The last visible tab cannot be hidden — the resolver would un-hide
    // everything, which is not what the click meant.
    if ($792124e2f7de719a$export$cf705f4052b87526.every((t)=>hidden.includes(t.id))) return {};
    return {
        copilotTabsHidden: hidden
    };
}
const $792124e2f7de719a$export$aeba1cec85888be3 = (settings, id)=>$792124e2f7de719a$export$b42ce7b9554c2388.some((t)=>t.id === id) ? {
        defaultWorkTab: id
    } : {};
const $792124e2f7de719a$export$ceb766f504646314 = (settings, id)=>$792124e2f7de719a$export$cf705f4052b87526.some((t)=>t.id === id) ? {
        defaultCopilotTab: id
    } : {};
function $792124e2f7de719a$export$4deb366eab2f1d1a(settings) {
    const s = {
        ...$792124e2f7de719a$export$df312747b9dc7053,
        ...settings || {}
    };
    const untouchedOrder = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, s.recordSectionOrder).every((sec, i)=>sec.id === $792124e2f7de719a$export$286013f25f0f7b72[i].id);
    return untouchedOrder && $792124e2f7de719a$var$asList(s.recordSectionsHidden).length === 0 && $792124e2f7de719a$var$asList(s.recordSectionsCollapsed).length === 0 && $792124e2f7de719a$var$asList(s.workTabsHidden).length === 0 && s.defaultWorkTab === $792124e2f7de719a$export$df312747b9dc7053.defaultWorkTab && $792124e2f7de719a$var$asList(s.copilotTabsHidden).length === 0 && s.defaultCopilotTab === $792124e2f7de719a$export$df312747b9dc7053.defaultCopilotTab;
}
// ── Mobile ───────────────────────────────────────────────────────────────────
//
// Visit.mobile.jsx is a reduction of the desktop page and names its tabs
// differently (note / diff / rx / ord). The same preference applies through
// this mapping: hiding «نسخه» on the desktop hides it on the phone too. There
// is no differential nav tab — on the phone it lives in the copilot sheet.
const $792124e2f7de719a$var$MOBILE_TAB_SOURCE = {
    note: {
        kind: 'work',
        id: 'soap'
    },
    rx: {
        kind: 'work',
        id: 'rx'
    },
    ord: {
        kind: 'work',
        id: 'orders'
    }
};
function $792124e2f7de719a$export$6fd5b56eddd00f9b(layout, mobileId) {
    const src = $792124e2f7de719a$var$MOBILE_TAB_SOURCE[mobileId];
    if (!src) return true;
    const pool = src.kind === 'work' ? layout.workTabs : layout.copilotTabs;
    return pool.some((t)=>t.id === src.id && t.visible);
}
function $792124e2f7de719a$export$dde3a1a6c2d91941(layout) {
    const wanted = Object.entries($792124e2f7de719a$var$MOBILE_TAB_SOURCE).find(([, src])=>src.kind === 'work' && src.id === layout.defaultWorkTab);
    return wanted ? wanted[0] : 'note';
}
// The phone's copilot SHEET is a third surface for the same preference, and it
// carries exactly the desktop copilot's three tabs — the differential included,
// as a real panel. It is the differential's ONE home on the phone: a «تشخیص»
// nav tab used to show the same list as well, and was removed. «گفتگو» (the
// full transcript) was removed earlier; its live lines remain at the top of
// «نکات بالینی».
const $792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE = {
    hints: 'sugg',
    diff: 'diff',
    ask: 'ask'
};
function $792124e2f7de719a$export$ec23aec8c07c3d8a(layout, sheetTabId) {
    const id = $792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE[sheetTabId];
    if (!id) return true;
    return layout.copilotTabs.some((t)=>t.id === id && t.visible);
}
function $792124e2f7de719a$export$c5c16556be0d657b(layout, order = [
    'hints',
    'diff',
    'ask'
]) {
    const preferred = Object.entries($792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE).find(([, id])=>id === layout.defaultCopilotTab);
    if (preferred && $792124e2f7de719a$export$ec23aec8c07c3d8a(layout, preferred[0])) return preferred[0];
    return order.find((id)=>$792124e2f7de719a$export$ec23aec8c07c3d8a(layout, id)) ?? order[0];
}


const $2d58c73a38525204$export$5ff47a1a5df62032 = [
    // «قالب‌ها» sits next to «دستیار هوشمند» because both are about what the
    // Visit page does for the doctor — one automatically, one on request.
    // «صفحه ویزیت» sits between them: it is about what the Visit page SHOWS.
    // «نسخه» follows the templates: what the doctor's prescriptions are billed as
    // (the RVU3 visit code — PrescriptionSettings.jsx).
    'profile',
    'ai',
    'visit',
    'templates',
    'prescription',
    'credits',
    'language',
    'appearance',
    'clinics',
    'security'
].map((id)=>({
        id: id,
        labelKey: `settings.sections.${id}.label`,
        hintKey: `settings.sections.${id}.hint`
    }));
const $2d58c73a38525204$export$d0fe0b0df5d61021 = $2d58c73a38525204$export$5ff47a1a5df62032.map((s)=>s.id);
const $2d58c73a38525204$export$d5df8095c82b1b1a = (id)=>$2d58c73a38525204$export$d0fe0b0df5d61021.includes(id);
const $2d58c73a38525204$export$b22bf82651bf4640 = 'profile';
const $2d58c73a38525204$export$40990cfbf62fff64 = [
    'firstName',
    'lastName',
    'phone',
    'nationalId',
    'gender',
    'birthDate',
    'medicalCode',
    'specialty',
    'bio'
];
const $2d58c73a38525204$export$e8bf9d673f0f461f = {
    firstName: 'common.labels.firstName',
    lastName: 'common.labels.lastName',
    phone: 'common.labels.phone',
    nationalId: 'common.labels.nationalId',
    gender: 'common.labels.gender',
    birthDate: 'common.labels.birthDate',
    medicalCode: 'common.labels.medicalCode',
    specialty: 'common.labels.specialty',
    bio: 'common.labels.bio'
};
const $2d58c73a38525204$export$1429510cfa0d4432 = (form)=>$2d58c73a38525204$export$40990cfbf62fff64.map((key)=>({
            key: key,
            labelKey: $2d58c73a38525204$export$e8bf9d673f0f461f[key],
            filled: Boolean((form?.[key] ?? '').toString().trim())
        }));
const $2d58c73a38525204$export$b0c3bc556f31ebe8 = (saved)=>Boolean((saved?.medicalCode || '').trim());
function $2d58c73a38525204$export$a07b599d4f364c08(form, saved) {
    const errors = {};
    if (!form.firstName?.trim()) errors.firstName = 'validation.firstName';
    if (!form.lastName?.trim()) errors.lastName = 'validation.lastName';
    if (saved?.medicalCode && !form.medicalCode?.trim()) errors.medicalCode = 'validation.medicalCode';
    return errors;
}
function $2d58c73a38525204$export$4d2a7159fda5dc93(pw) {
    const errors = {};
    if (!pw.current) errors.current = 'validation.password.current';
    if ((pw.next || '').trim().length < 6) errors.next = 'validation.password.minLength';
    if (pw.next !== pw.confirm) errors.confirm = 'validation.password.mismatch';
    return errors;
}
const $2d58c73a38525204$export$b76bdd93b2cd1293 = (doctor)=>Object.fromEntries($2d58c73a38525204$export$40990cfbf62fff64.map((k)=>[
            k,
            doctor?.[k] ?? ''
        ]));
const $2d58c73a38525204$export$6751d1764e58e2a1 = (form, saved)=>$2d58c73a38525204$export$40990cfbf62fff64.some((k)=>(form[k] || '').trim() !== (saved[k] || '').trim());
const $2d58c73a38525204$export$46e28ca63030741b = (form, saved)=>Object.fromEntries($2d58c73a38525204$export$40990cfbf62fff64.filter((k)=>!(k === 'medicalCode' && $2d58c73a38525204$export$b0c3bc556f31ebe8(saved))).map((k)=>[
            k,
            typeof form[k] === 'string' ? form[k].trim() : form[k]
        ]).filter(([k, v])=>v !== (saved[k] || '')));
const $2d58c73a38525204$export$98245d8165151e62 = (form)=>{
    const filled = $2d58c73a38525204$export$40990cfbf62fff64.filter((f)=>(form[f] || '').toString().trim()).length;
    return Math.round(filled / $2d58c73a38525204$export$40990cfbf62fff64.length * 100);
};
const $2d58c73a38525204$export$cc12720b27678a68 = {
    interruptOnCritical: true,
    interruptOnWarning: true,
    spo2Threshold: 95,
    bpSystolicThreshold: 140,
    recommendationLogsEnabled: true,
    autoDifferentialOnStart: true,
    differentialPollingEnabled: true,
    differentialPollIntervalSec: 15,
    liveHintsEnabled: true,
    autoPrescriptionAssist: true,
    reassessOnNoteEdit: true,
    endVisitInteractionSweep: true,
    // «تکمیل خودکار پس از پایش بالینی» — on for everyone (K1, 2026-10-06).
    autoCompleteOnMonitoringStop: true,
    // «موتور تبدیل گفتار به متن» — lib/speechEngine.js. Parsina STT by default;
    // the AI service falls back to the assistant engine whenever it cannot answer.
    speechEngine: 'parsina'
};
const $2d58c73a38525204$export$e5402420929f4067 = {
    theme: (0, $jTCZr.DEFAULT_THEME),
    fontSize: (0, $jTCZr.DEFAULT_FONT_SIZE),
    language: (0, $Hy6Lb.DEFAULT_LOCALE),
    fontFamily: (0, $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294)
};
const $2d58c73a38525204$export$eceb5de8d7df09f9 = {
    otpEnabled: false,
    biometricEnabled: false
};
const $2d58c73a38525204$export$4df9c0969a9e0160 = (section, defaults)=>({
        ...defaults,
        ...Object.fromEntries(Object.entries(section || {}).filter(([, v])=>v != null))
    });
const $2d58c73a38525204$export$12678b5895b9b663 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.aiAgent, $2d58c73a38525204$export$cc12720b27678a68);
const $2d58c73a38525204$export$109495996d5012e4 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.appearance, $2d58c73a38525204$export$e5402420929f4067);
const $2d58c73a38525204$export$74c8f641b046dabd = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.security, $2d58c73a38525204$export$eceb5de8d7df09f9);
const $2d58c73a38525204$export$dc4d894629379c14 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.visitLayout, (0, $792124e2f7de719a$export$df312747b9dc7053));
// ── Visit-page AI controls ────────────────────────────────────────────────────
//
// The two settings this screen exists to expose, described once so the desktop
// card, the mobile sheet and the tests all read the same words. `key` matches
// AIAgentSettingsInput; `impactKey` names the copy shown under the toggle so
// the doctor knows what turning it off actually stops.
//
// Only KEYS live here — the words are in settings.json, under a path derived
// from `key`, so a toggle's name and its translation cannot drift apart.
//
// These are AUTOMATION switches, and now the ONLY AI switches: they decide
// whether a pass runs by itself, never whether a capability exists. Nothing
// here can take a feature away from the doctor — turning a toggle off just
// means running the same thing by hand from the Visit page.
// Every toggle's copy lives at `settings.ai.toggles.<key>.*`, so this helper is
// the only place that spelling appears.
const $2d58c73a38525204$var$aiToggleKey = (key, part)=>`settings.ai.toggles.${key}.${part}`;
const $2d58c73a38525204$var$aiToggle = (key)=>({
        key: key,
        labelKey: $2d58c73a38525204$var$aiToggleKey(key, 'label'),
        impactKey: $2d58c73a38525204$var$aiToggleKey(key, 'impact')
    });
const $2d58c73a38525204$export$8035bf38917cdb6e = [
    $2d58c73a38525204$var$aiToggle('recommendationLogsEnabled'),
    $2d58c73a38525204$var$aiToggle('liveHintsEnabled'),
    $2d58c73a38525204$var$aiToggle('autoCompleteOnMonitoringStop'),
    $2d58c73a38525204$var$aiToggle('autoPrescriptionAssist'),
    $2d58c73a38525204$var$aiToggle('autoDifferentialOnStart'),
    $2d58c73a38525204$var$aiToggle('endVisitInteractionSweep')
];
const $2d58c73a38525204$export$d84b29c60bbbdc31 = [
    $2d58c73a38525204$var$aiToggle('differentialPollingEnabled'),
    $2d58c73a38525204$var$aiToggle('reassessOnNoteEdit')
];
const $2d58c73a38525204$export$fdba03209e26fe6d = [
    {
        key: 'interruptOnCritical',
        labelKey: $2d58c73a38525204$var$aiToggleKey('interruptOnCritical', 'label')
    },
    {
        key: 'interruptOnWarning',
        labelKey: $2d58c73a38525204$var$aiToggleKey('interruptOnWarning', 'label')
    }
];
const $2d58c73a38525204$export$b18cfe9ad6d2d648 = (ai)=>$2d58c73a38525204$export$fdba03209e26fe6d.some((item)=>ai?.[item.key] !== false);
const $2d58c73a38525204$export$ced99d35363868d3 = (ai)=>ai?.recommendationLogsEnabled !== false;
const $2d58c73a38525204$export$77b83820a545461a = (ai)=>ai?.liveHintsEnabled !== false;
const $2d58c73a38525204$export$2b2bb51f62de8576 = (ai)=>ai?.autoPrescriptionAssist !== false;
const $2d58c73a38525204$export$c41b9e42cb7b861 = (ai)=>ai?.autoCompleteOnMonitoringStop !== false;
const $2d58c73a38525204$export$211159940a78ce44 = (ai)=>ai?.autoDifferentialOnStart !== false && ai?.reassessOnNoteEdit !== false;
const $2d58c73a38525204$export$6bc5afae02a61f49 = (ai)=>ai?.endVisitInteractionSweep !== false;
const $2d58c73a38525204$export$7c8e7f6b23543e69 = [
    15,
    30,
    60,
    120,
    300
];
const $2d58c73a38525204$export$7d379a2ec9a8613b = 15;
const $2d58c73a38525204$export$8c8aa4bf9ee20a73 = (ai)=>ai?.autoDifferentialOnStart !== false && ai?.differentialPollingEnabled !== false;
const $2d58c73a38525204$export$291b76ac275aac62 = (ai)=>{
    const n = Number(ai?.differentialPollIntervalSec);
    if (!Number.isFinite(n) || n < 5 || n > 600) return $2d58c73a38525204$export$7d379a2ec9a8613b;
    return Math.round(n);
};
const $2d58c73a38525204$export$8929775566921897 = (ai)=>$2d58c73a38525204$export$291b76ac275aac62(ai) * 1000;
const $2d58c73a38525204$export$934efb048138efd3 = (sec, t, formatNumber = (n)=>String(n))=>sec < 60 ? t('settings.ai.pollEverySeconds', {
        count: formatNumber(sec)
    }) : t('settings.ai.pollEveryMinutes', {
        count: formatNumber(sec / 60)
    });
// Only the keys that actually changed go to the server — the mutation merges,
// so sending the whole object would rewrite settings the doctor never touched.
// Lists (the layout sections) compare by CONTENT: a fresh array with the same
// ids is not a change, and sending it would be a pointless write.
const $2d58c73a38525204$var$sameValue = (a, b)=>Array.isArray(a) || Array.isArray(b) ? JSON.stringify(a) === JSON.stringify(b) : a === b;
const $2d58c73a38525204$export$59230889ac977c02 = (next, saved)=>Object.fromEntries(Object.entries(next).filter(([k, v])=>!$2d58c73a38525204$var$sameValue(v, saved?.[k])));
const $2d58c73a38525204$export$b9d28ecb694e8fb5 = 12582912;
function $2d58c73a38525204$export$37e4fcb024c1e74e(file) {
    return new Promise((resolve)=>{
        if (!file) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.notAnImage'
            });
            return;
        }
        if (!file.type?.startsWith('image/')) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.notAnImage'
            });
            return;
        }
        if (file.size > $2d58c73a38525204$export$b9d28ecb694e8fb5) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.tooLarge'
            });
            return;
        }
        const reader = new FileReader();
        reader.onload = (ev)=>resolve({
                ok: true,
                dataUri: ev.target.result
            });
        reader.onerror = ()=>resolve({
                ok: false,
                messageKey: 'errors.avatar.read'
            });
        reader.readAsDataURL(file);
    });
}



// ─────────────────────────────────────────────────────────────────────────────
// The treatment plan speaks English.
//
// «برنامه درمان» is not UI chrome — it is a clinical document. It is read at the
// pharmacy counter, pasted into a referral, and handed to whoever sees the
// patient next, and those readers do not share the doctor's UI language. So the
// managed plan block is written in standard English regardless of the locale the
// app is running in: drug name, dose, dose form, frequency, duration, and the
// kind of every order.
//
// That is a translation problem, because the data underneath is Persian. The
// formulary stores `generic_name` in Latin (usable as-is) but `common_dosages`
// carries Persian dose-form words («ویال 500mg») and `common_frequencies` is
// entirely Persian («روزی دو بار»). This module is the one place that maps them.
//
// Two rules for everything here:
//
//   1. A value we cannot map is passed through UNCHANGED, never dropped and
//      never guessed at. A doctor seeing their own words is recoverable; a
//      silently altered dose is not.
//   2. Mapping is done on a NORMALISED string (Persian digits folded to ASCII,
//      ZWNJ removed, whitespace collapsed) so that «هر ۸ ساعت» and «هر 8 ساعت»
//      are the same input. The normalisation is for LOOKUP only — anything
//      passed through keeps the doctor's original spelling.
//
// The tables below were built from the actual seed data (616 drugs,
// clinicalencounter `drug_formulary_data.py`), not from imagination: every distinct
// `common_frequencies` value and every dose-form token in `common_dosages` is
// covered, with a compositional fallback for the numeric patterns so a value
// added to the formulary later («هر ۱۰ ساعت») still comes out English.
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable */ // Character classes, not per-glyph tables: the invisible members (ZWNJ, ZWJ,
// bidi marks, NBSP) cannot be reviewed by eye, and one silently lost from a
// literal table would stop the whole thing matching.
const $f91797fd10151718$var$FA_DIGIT = /[۰-۹٠-٩]/g; // Persian and Arabic-Indic digits
const $f91797fd10151718$var$INVISIBLE = /[​-‏ ]/g; // ZWNJ, ZWJ, bidi marks, NBSP
const $f91797fd10151718$var$PERSIAN_LETTER = /[؀-ۿ]/;
function $f91797fd10151718$export$a7f0d01bd35ee833(text) {
    return String(text ?? '').replace($f91797fd10151718$var$FA_DIGIT, (d)=>String(d.codePointAt(0) & 0xf)).replace($f91797fd10151718$var$INVISIBLE, ' ').replace(/\s+/g, ' ').trim();
}
function $f91797fd10151718$export$7c06148ed8936def(text) {
    return $f91797fd10151718$var$PERSIAN_LETTER.test(String(text ?? ''));
}
// Persian number words, for the frequency patterns that spell the count out
// («هر دو هفته یک بار») rather than using a digit.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$FA_NUMBER_WORDS = {
    "\u06CC\u06A9": 1,
    "\u062F\u0648": 2,
    "\u0633\u0647": 3,
    "\u0686\u0647\u0627\u0631": 4,
    "\u067E\u0646\u062C": 5,
    "\u0634\u0634": 6,
    "\u0647\u0641\u062A": 7,
    "\u0647\u0634\u062A": 8,
    "\u0646\u0647": 9,
    "\u062F\u0647": 10,
    "\u062F\u0648\u0627\u0632\u062F\u0647": 12,
    "\u0628\u06CC\u0633\u062A": 20,
    "\u0628\u06CC\u0633\u062A \u0648 \u0686\u0647\u0627\u0631": 24
};
const $f91797fd10151718$var$faCount = (token)=>{
    const t = (token || '').trim();
    if (/^\d+$/.test(t)) return Number(t);
    return $f91797fd10151718$var$FA_NUMBER_WORDS[t] ?? null;
};
// "once / twice / three times", the way a prescription is written in English.
const $f91797fd10151718$var$TIMES = [
    '',
    'once',
    'twice',
    'three times',
    'four times',
    'five times',
    'six times'
];
const $f91797fd10151718$var$timesWord = (n)=>$f91797fd10151718$var$TIMES[n] || `${n} times`;
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$UNIT_EN = {
    "\u0633\u0627\u0639\u062A": 'hour',
    "\u0631\u0648\u0632": 'day',
    "\u0647\u0641\u062A\u0647": 'week',
    "\u0645\u0627\u0647": 'month',
    "\u0633\u0627\u0644": 'year'
};
const $f91797fd10151718$var$plural = (unit, n)=>n === 1 ? unit : `${unit}s`;
// ── Frequency ────────────────────────────────────────────────────────────────
//
// Idioms first: phrases whose English is not a function of their parts. The
// numeric families («روزی N بار», «هر N ساعت») are handled by pattern below, so
// they are deliberately NOT enumerated here.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$FREQUENCY_IDIOMS = {
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632": 'as needed (PRN)',
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'once nightly',
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'before meals',
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'with meals',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627": 'once daily on an empty stomach',
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'once monthly',
    "\u0633\u0627\u0644\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'once yearly',
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646": 'every other day',
    "\u062F\u0648\u0632 \u0648\u0627\u062D\u062F": 'single dose',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u062F\u0648\u0632)": 'single dose',
    "\u06CC\u06A9 \u0628\u0627\u0631": 'single dose',
    "\u0628\u0639\u062F \u0627\u0632 \u0647\u0631 \u0627\u0633\u0647\u0627\u0644": 'after each loose stool',
    "\u06CC\u06A9 \u0633\u0627\u0639\u062A \u0642\u0628\u0644": 'one hour before',
    "\u062D\u062F\u0627\u06A9\u062B\u0631 \u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631": 'max twice daily',
    "\u0646\u0627\u0634\u062A\u0627": 'on an empty stomach',
    "\u0642\u0628\u0644 \u0627\u0632 \u062E\u0648\u0627\u0628": 'at bedtime',
    "\u0635\u0628\u062D": 'in the morning',
    "\u0634\u0628": 'at night'
};
/**
 * The numeric frequency families:
 *   روزی N بار / هفته‌ای N بار  → N times daily / weekly
 *   هر N [تا M] <unit> [یک بار] → every N [to M] <unit>s
 *   حداکثر Nmg در روز           → max Nmg per day
 * Returns null when nothing matches, so the caller can fall through.
 */ function $f91797fd10151718$var$frequencyByPattern(s) {
    let m;
    if (m = s.match(/^روزی\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} daily`;
    }
    if (m = s.match(/^هفته\s*ای\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} weekly`;
    }
    if (m = s.match(/^ماهی\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} monthly`;
    }
    // «هر ۸ ساعت», «هر ۴ تا ۶ ساعت», «هر ۳ هفته یک بار», «هر دو هفته یک بار»
    if (m = s.match(/^هر\s+(\S+)(?:\s+تا\s+(\S+))?\s+(ساعت|روز|هفته|ماه|سال)(?:\s+یک\s+بار)?$/)) {
        const from = $f91797fd10151718$var$faCount(m[1]);
        const to = m[2] ? $f91797fd10151718$var$faCount(m[2]) : null;
        const unit = $f91797fd10151718$var$UNIT_EN[m[3]];
        if (from && unit) return to ? `every ${from} to ${to} ${$f91797fd10151718$var$plural(unit, to)}` : `every ${from} ${$f91797fd10151718$var$plural(unit, from)}`;
    }
    if (m = s.match(/^حداکثر\s+(.+?)\s+در\s+روز$/)) return `max ${m[1]} per day`;
    return null;
}
function $f91797fd10151718$export$7a6106170485de57(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original);
    const paren = s.match(/^(.*?)\s*\((.+)\)$/);
    if (paren) {
        const head = $f91797fd10151718$export$7a6106170485de57(paren[1]);
        const inner = paren[2].trim();
        const innerEn = $f91797fd10151718$export$7c06148ed8936def(inner) ? $f91797fd10151718$export$7a6106170485de57(inner) : inner;
        return `${head} (${innerEn})`;
    }
    if ($f91797fd10151718$var$FREQUENCY_IDIOMS[s]) return $f91797fd10151718$var$FREQUENCY_IDIOMS[s];
    return $f91797fd10151718$var$frequencyByPattern(s) || original;
}
// ── Dose forms ───────────────────────────────────────────────────────────────
//
// `common_dosages` mixes a Latin strength with a Persian dose form, in either
// order: «ویال 500mg», «250mg/5ml شربت», «0.4mg زیرزبانی». Only the Persian
// tokens are translated; the strength is left exactly as stored, because it is
// the one part of a prescription that must never be paraphrased.
//
// Longest match first — «قطره چشمی» must not be read as «قطره» + «چشمی».
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$DOSE_FORM_EN = {
    "\u0633\u0631\u0646\u06AF \u0622\u0645\u0627\u062F\u0647": 'prefilled syringe',
    "\u0622\u0645\u0627\u062F\u0647 \u062A\u0632\u0631\u06CC\u0642": 'ready-to-inject',
    "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC": 'eye drops',
    "\u0642\u0637\u0631\u0647 \u0628\u06CC\u0646\u06CC": 'nasal drops',
    "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634": 'ear drops',
    "\u0642\u0637\u0631\u0647 \u062E\u0648\u0631\u0627\u06A9\u06CC": 'oral drops',
    "\u0627\u0633\u067E\u0631\u06CC \u0628\u06CC\u0646\u06CC": 'nasal spray',
    "\u0627\u0633\u067E\u0631\u06CC \u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC": 'inhaler',
    "\u0698\u0644 \u062F\u0647\u0627\u0646\u06CC": 'oral gel',
    "\u0622\u0647\u0633\u062A\u0647 \u0631\u0647\u0634": 'extended release',
    "\u0633\u0648\u0633\u067E\u0627\u0646\u0633\u06CC\u0648\u0646": 'suspension',
    "\u062F\u0647\u0627\u0646\u0634\u0648\u06CC\u0647": 'mouthwash',
    "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A": 'implant',
    "\u06A9\u0627\u0631\u062A\u0631\u06CC\u062C": 'cartridge',
    "\u0627\u0646\u0641\u0648\u0632\u06CC\u0648\u0646": 'infusion',
    "\u0627\u0633\u067E\u0627\u06CC\u0646\u0627\u0644": 'spinal',
    "\u062F\u06A9\u0627\u0646\u0648\u0627\u062A": 'decanoate',
    "\u0645\u06CC\u0644\u06CC \u0644\u06CC\u062A\u0631": 'ml',
    // The dose units of the closed دوز list (lib/rxOptions.js).
    "\u0633\u06CC \u0633\u06CC": 'ml',
    "\u067E\u0627\u0641": 'puff',
    "\u0639\u062F\u062F": 'unit',
    "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC": 'sublingual',
    "\u062C\u0648\u06CC\u062F\u0646\u06CC": 'chewable',
    "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644": 'vaginal',
    "\u0644\u0648\u0633\u06CC\u0648\u0646": 'lotion',
    "\u0645\u062D\u0644\u0648\u0644": 'solution',
    "\u0622\u0645\u067E\u0648\u0644": 'ampoule',
    "\u06A9\u067E\u0633\u0648\u0644": 'capsule',
    "\u0648\u06CC\u0627\u0644": 'vial',
    "\u0627\u0633\u06A9\u0631\u0627\u0628": 'scrub',
    "\u0634\u0627\u0645\u067E\u0648": 'shampoo',
    "\u062F\u0647\u0627\u0646\u06CC": 'oral',
    "\u0634\u0631\u0628\u062A": 'syrup',
    "\u0634\u06CC\u0627\u0641": 'suppository',
    "\u0633\u0627\u0634\u0647": 'sachet',
    "\u067E\u0645\u0627\u062F": 'ointment',
    "\u0642\u0637\u0631\u0647": 'drops',
    "\u0648\u0627\u062D\u062F": 'units',
    "\u0627\u0646\u0645\u0627": 'enema',
    "\u06A9\u0631\u0645": 'cream',
    "\u067E\u0648\u062F\u0631": 'powder',
    "\u0642\u0631\u0635": 'tablet',
    "\u0627\u0633\u067E\u0631\u06CC": 'spray',
    "\u0633\u0631\u0645": 'infusion',
    "\u0642\u0644\u0645": 'pen',
    "\u067E\u0686": 'patch',
    "\u0698\u0644": 'gel'
};
const $f91797fd10151718$var$DOSE_FORM_KEYS = Object.keys($f91797fd10151718$var$DOSE_FORM_EN).sort((a, b)=>b.length - a.length);
function $f91797fd10151718$export$faf0542505380f3e(raw) {
    const original = String(raw ?? '').trim();
    if (!original || !$f91797fd10151718$export$7c06148ed8936def(original)) return original;
    // «۰٫۵ قرص»: the Persian decimal separator, which normalizeFa leaves alone.
    let rest = $f91797fd10151718$export$a7f0d01bd35ee833(original).replace(/٫/g, '.');
    const forms = [];
    for (const key of $f91797fd10151718$var$DOSE_FORM_KEYS){
        const at = rest.indexOf(key);
        if (at === -1) continue;
        forms.push($f91797fd10151718$var$DOSE_FORM_EN[key]);
        rest = `${rest.slice(0, at)} ${rest.slice(at + key.length)}`.replace(/\s+/g, ' ').trim();
    }
    if (!forms.length) return original;
    return [
        rest,
        forms.join(' ')
    ].map((x)=>x.trim()).filter(Boolean).join(' ');
}
// ── Route of administration ──────────────────────────────────────────────────
//
// Unlike dose and frequency, the route comes from a CLOSED list this app renders
// itself (`RX_ROUTES` in Visit.shared.js), so the mapping is exact rather than
// best-effort. Both spellings have to be covered: under a Persian UI the stored
// value is «خوراکی», under an English one it is already "Oral".
// i18n-exempt: lookup keys, matched against stored route values — never displayed
const $f91797fd10151718$var$ROUTE_EN = {
    "\u062E\u0648\u0631\u0627\u06A9\u06CC": 'PO',
    "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC": 'SL',
    "\u062A\u0632\u0631\u06CC\u0642 \u0648\u0631\u06CC\u062F\u06CC": 'IV',
    "\u062A\u0632\u0631\u06CC\u0642 \u0639\u0636\u0644\u0627\u0646\u06CC": 'IM',
    "\u062A\u0632\u0631\u06CC\u0642 \u0632\u06CC\u0631\u062C\u0644\u062F\u06CC": 'SC',
    "\u0645\u0648\u0636\u0639\u06CC (\u067E\u0648\u0633\u062A\u06CC)": 'topical',
    "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC": 'inhaled',
    "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC": 'ophthalmic',
    "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634\u06CC": 'otic',
    "\u0628\u06CC\u0646\u06CC": 'intranasal',
    "\u0645\u0642\u0639\u062F\u06CC": 'PR',
    "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644": 'PV'
};
function $f91797fd10151718$export$cfcbced31e5dd385(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original);
    if ($f91797fd10151718$var$ROUTE_EN[s]) return $f91797fd10151718$var$ROUTE_EN[s];
    // Already-English values (English UI) pass straight through; so does anything
    // unrecognised, per rule 1 at the top of this file.
    return original;
}
// ── Duration ─────────────────────────────────────────────────────────────────
//
// Durations come from a closed list the UI renders through i18n, so the stored
// value is «7 روز» under a Persian UI and "7 days" under an English one. Both
// must print as English here.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$DURATION_IDIOMS = {
    "\u062A\u0627 \u0627\u0637\u0644\u0627\u0639 \u062B\u0627\u0646\u0648\u06CC": 'until further notice',
    "\u062A\u0627 \u0627\u0637\u0644\u0627\u0639 \u0628\u0639\u062F\u06CC": 'until further notice'
};
function $f91797fd10151718$export$d579c09ab10cbff4(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original);
    if ($f91797fd10151718$var$DURATION_IDIOMS[s]) return $f91797fd10151718$var$DURATION_IDIOMS[s];
    const m = s.match(/^(\d+)\s*(ساعت|روز|هفته|ماه|سال)$/);
    if (m) {
        const n = Number(m[1]);
        return `${n} ${$f91797fd10151718$var$plural($f91797fd10151718$var$UNIT_EN[m[2]], n)}`;
    }
    return original;
}


// The پارسه price list, resolved — ONE server-side list instead of the
// hardcoded constants (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md
// §9.2, phase 3).
//
// Every price this app prints or charges to the visit ledger goes through
// `costOf(actionId)` below. The action ids are the ones the app already used
// (`COIN_COSTS.ASK_QUESTION`, …); `SERVICE_KEY_BY_ACTION` is the ONE table that
// maps them onto the AI RPC names the service prices — change a mapping here,
// nowhere else.
//
// ── The constants are the fallback and the first paint ──────────────────────
// `constants/creditPricing.js` is what renders before the list has arrived and
// what renders when it never does (offline, BFF down, the AI service down and
// the BFF serving its own frozen copy). A price chip therefore NEVER spins and
// never goes blank: it shows the shipped number, then the policy's number the
// moment it is known. `source` says which one is on screen.
//
// ── Fetched once per page load, remembered for the session ──────────────────
// The list is read through the app's own GraphQL client the first time any
// surface asks for it and shared by every component after that (a module-level
// store read through `useSyncExternalStore`). The last answer is also kept in
// sessionStorage so a reload paints the policy price first, not the constant.
// A FAILED read is not remembered: the next surface to mount tries again.
//
// ── Buying credit, and what one costs in money (PM-0211) ────────────────────
// The same answer carries the wallet's side (docs/platform-money/CONTRACT.md §5):
// `creditPrice { amountMinor currency }`, `packages` and `purchaseAvailable`.
// They do not depend on the AI price list, so they are kept whatever `source`
// says. Every «خرید پارسه» / «شارژ اعتبار» entry point asks `purchaseAvailable()`;
// until the BFF has said, the brand's market answers (Iran: yes — today; any
// other market: no), so neither deployment flashes a button it then takes away.
// A BFF that predates the fields refuses the whole query; it is then asked the
// old one, so the price chips never fall back to the constants because of it.

var $acw62 = parcelRequire("acw62");


var $eLeza = parcelRequire("eLeza");
// Parseh («پارسه») price list — the OFFLINE FALLBACK and the first-paint value.
//
// Since 2026-09-12 the price of every AI action comes from ONE server-side
// list: the AI service's active pricing policy, served by the BFF as
// `creditPrices` and read here through `src/lib/useCreditPrices.js`
// (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md §9.2, phase 3). Every
// price chip, the Credits price list and the visit ledger's `chargeVisit` go
// through `costOf(actionId)` / `useCreditPrices()` there, so what is advertised
// follows the policy the service actually debits from.
//
// THIS FILE is what renders before that list has arrived and what renders when
// it never does (offline, BFF down). It mirrors the flat-rate schedule the AI
// service shipped with (usage_context.py / credits_policy.md):
//   transcription 5 پارسه/دقیقه · LLM actions 10 پارسه · prescription checks 3 پارسه.
// It is NOT where a price is changed — the design doc is the reference, and the
// admin panel's pricing policy is the instrument.
//
// Unit language: the unit is «پارسه» / "Parseh" — واحد اعتبار هوشمند پارسینا —
// everywhere in the UI, in both locales; never «سکه», never "coin", never the
// Latin "PC". Toman appears only at purchase and in the hero equivalence line.
// The COIN_* identifiers below keep their names on purpose: they are internal,
// and the wallet/GraphQL contract still spells the unit "coin".
//
// The MONEY price of one credit has a currency since PM-0211
// (docs/platform-money/CONTRACT.md): the wallet says `IRT` (toman) for Parsina,
// which is everything below, and e.g. `USD` for a deployment that sells credit
// in dollars. A credit stays a unit either way — only `formatCreditMoney` /
// `coinsToMoneyLabel` at the bottom of this file know about the money side.

var $lHVFz = parcelRequire("lHVFz");
const $2a90b979c3d41f86$export$603323bf3f7bd8d9 = 1000;
const $2a90b979c3d41f86$export$ae8383984baa5079 = 'IRT';
const $2a90b979c3d41f86$export$e6d8c7e3d913b530 = {
    TRANSCRIPTION_PER_MIN: 5,
    // The same minute decoded by «گفتار به متن پارسینا» (its own price row,
    // TranscribeAudioParsina). Offline fallback only, like every entry here.
    TRANSCRIPTION_PARSINA_PER_MIN: 5,
    ASK_QUESTION: 10,
    SOAP_REFINE: 10,
    // when the merge produced new content; the server's
    // `charged` flag is the signal, never the click
    RECOMMENDATIONS: 10,
    DIFFERENTIAL: 10,
    CONFIRM_QUESTIONS: 10,
    TREATMENT_PLAN: 10,
    DOCTOR_ORDERS: 10,
    OCR: 10,
    ANALYZE_FILE: 10,
    // one price per run whatever the class; not charged for
    // NOT_MEDICAL / ILLEGIBLE / a failure (§24.1 R-A3)
    INTERACTION_CHECK: 3,
    ASSIST_PRESCRIPTION: 3,
    // The نسخه's AI helpers (docs/VISIT_RX_AI_ASSIST.md). Charged ONLY when the run
    // proposed a drug — the server's `charged` flag, never the click.
    RX_VOICE: 1,
    RX_MONITORING: 3,
    RX_HISTORY: 3,
    RX_DIRECTIONS: 3,
    // «پایش بالینی» beyond the نسخه (PM-0029): three readings, one equal price each,
    // charged only when the reading found something.
    MONITORING_VITALS: 3,
    MONITORING_ORDERS: 3,
    MONITORING_RECORD: 3
};
const $2a90b979c3d41f86$export$52690e1136e04e64 = [
    {
        id: 'transcription',
        action: 'TRANSCRIPTION_PER_MIN',
        labelKey: 'credits.price.transcription',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.TRANSCRIPTION_PER_MIN,
        perKey: 'common.units.minute'
    },
    {
        id: 'ask',
        action: 'ASK_QUESTION',
        labelKey: 'credits.price.ask',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.ASK_QUESTION
    },
    {
        id: 'differential',
        action: 'DIFFERENTIAL',
        labelKey: 'credits.price.differential',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.DIFFERENTIAL
    },
    {
        id: 'confirmq',
        action: 'CONFIRM_QUESTIONS',
        labelKey: 'credits.price.confirmq',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.CONFIRM_QUESTIONS
    },
    {
        id: 'recs',
        action: 'RECOMMENDATIONS',
        labelKey: 'credits.price.recs',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RECOMMENDATIONS
    },
    {
        id: 'plan',
        action: 'TREATMENT_PLAN',
        labelKey: 'credits.price.plan',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.TREATMENT_PLAN
    },
    {
        id: 'orders',
        action: 'DOCTOR_ORDERS',
        labelKey: 'credits.price.orders',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.DOCTOR_ORDERS
    },
    {
        id: 'ocr',
        action: 'OCR',
        labelKey: 'credits.price.ocr',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.OCR
    },
    {
        id: 'interaction',
        action: 'INTERACTION_CHECK',
        labelKey: 'credits.price.interaction',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.INTERACTION_CHECK
    },
    {
        id: 'rx',
        action: 'ASSIST_PRESCRIPTION',
        labelKey: 'credits.price.rx',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.ASSIST_PRESCRIPTION
    },
    {
        id: 'rxMonitoring',
        action: 'RX_MONITORING',
        labelKey: 'credits.price.rxMonitoring',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_MONITORING
    },
    {
        id: 'rxHistory',
        action: 'RX_HISTORY',
        labelKey: 'credits.price.rxHistory',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_HISTORY
    },
    {
        id: 'rxDirections',
        action: 'RX_DIRECTIONS',
        labelKey: 'credits.price.rxDirections',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_DIRECTIONS
    },
    {
        id: 'rxVoice',
        action: 'RX_VOICE',
        labelKey: 'credits.price.rxVoice',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_VOICE
    },
    {
        id: 'monitoringVitals',
        action: 'MONITORING_VITALS',
        labelKey: 'credits.price.monitoringVitals',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_VITALS
    },
    {
        id: 'monitoringOrders',
        action: 'MONITORING_ORDERS',
        labelKey: 'credits.price.monitoringOrders',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_ORDERS
    },
    {
        id: 'monitoringRecord',
        action: 'MONITORING_RECORD',
        labelKey: 'credits.price.monitoringRecord',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_RECORD
    }
];
function $2a90b979c3d41f86$export$b634cc5d06849b0a(n, formatNumber) {
    if (n == null || !Number.isFinite(Number(n))) return "\u2014";
    const rounded = Math.round(Number(n));
    return formatNumber ? formatNumber(rounded) : String(rounded);
}
function $2a90b979c3d41f86$export$3c73313758e13369(coins, { formatNumber: formatNumber, tomanLabel: tomanLabel, tomanPerCoin: tomanPerCoin = $2a90b979c3d41f86$export$603323bf3f7bd8d9 } = {}) {
    if (coins == null || !Number.isFinite(Number(coins))) return '';
    const toman = Math.round(Number(coins)) * tomanPerCoin;
    const text = formatNumber ? formatNumber(toman) : String(toman);
    return `\u{2248} ${text} ${tomanLabel || ''}`.trim();
}
function $2a90b979c3d41f86$export$5452ee5bf8a4b337(price) {
    const currency = price?.currency;
    return !currency || currency === $2a90b979c3d41f86$export$ae8383984baa5079;
}
function $2a90b979c3d41f86$export$af3bb5d0c1d26c33(minor, currency, { formatNumber: formatNumber, tomanLabel: tomanLabel, locale: locale } = {}) {
    if (minor == null || minor === '' || !Number.isFinite(Number(minor))) return '';
    if (!currency || currency === $2a90b979c3d41f86$export$ae8383984baa5079) {
        const toman = Math.round(Number(minor));
        const text = formatNumber ? formatNumber(toman) : String(toman);
        return `${text} ${tomanLabel || ''}`.trim();
    }
    try {
        return (0, $lHVFz.formatAmount)(Number(minor), currency, {
            locale: locale,
            unit: 'short',
            fallback: ''
        });
    } catch  {
        return '';
    }
}
function $2a90b979c3d41f86$export$e610461cba74a0c9(coins, { creditPrice: creditPrice, formatNumber: formatNumber, tomanLabel: tomanLabel, locale: locale } = {}) {
    if ($2a90b979c3d41f86$export$5452ee5bf8a4b337(creditPrice)) return $2a90b979c3d41f86$export$3c73313758e13369(coins, {
        formatNumber: formatNumber,
        tomanLabel: tomanLabel,
        tomanPerCoin: creditPrice?.amountMinor ?? $2a90b979c3d41f86$export$603323bf3f7bd8d9
    });
    if (coins == null || !Number.isFinite(Number(coins))) return '';
    const money = $2a90b979c3d41f86$export$af3bb5d0c1d26c33(Math.round(Number(coins)) * Number(creditPrice.amountMinor), creditPrice.currency, {
        locale: locale
    });
    return money ? `\u{2248} ${money}` : '';
}


const $121df138798ec781$export$c3ecc18ec062bc34 = Object.freeze({
    TRANSCRIPTION_PER_MIN: 'TranscribeAudio',
    TRANSCRIPTION_PARSINA_PER_MIN: 'TranscribeAudioParsina',
    ASK_QUESTION: 'AskDoctorQuestion',
    SOAP_REFINE: 'RefineSoapNote',
    RECOMMENDATIONS: 'RecommendTestsAndMedications',
    DIFFERENTIAL: 'GetDifferentialDiagnosis',
    CONFIRM_QUESTIONS: 'GenerateConfirmationQuestions',
    TREATMENT_PLAN: 'SuggestTreatmentPlan',
    DOCTOR_ORDERS: 'SuggestDoctorOrders',
    OCR: 'ProcessDocumentOCR',
    ANALYZE_FILE: 'AnalyzeClinicalFile',
    INTERACTION_CHECK: 'CheckDrugInteraction',
    ASSIST_PRESCRIPTION: 'AssistPrescription',
    RX_VOICE: 'ParseMedicationVoice',
    RX_MONITORING: 'ExtractMonitoringMedications',
    RX_HISTORY: 'SuggestMedicationsFromHistory',
    RX_DIRECTIONS: 'CompleteRxDirections',
    MONITORING_VITALS: 'ExtractMonitoringVitals',
    MONITORING_ORDERS: 'ExtractMonitoringOrders',
    MONITORING_RECORD: 'ExtractMonitoringRecord'
});
const $121df138798ec781$export$f5e24740e23fe4a0 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
      creditPrice { amountMinor currency }
      packages
      purchaseAvailable
    }
  }
`;
const $121df138798ec781$export$fc2d6e3af2c81503 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
    }
  }
`;
const $121df138798ec781$var$STORAGE_KEY = 'parsina:creditPrices:v1';
const $121df138798ec781$var$FALLBACK_STATE = Object.freeze({
    byService: null,
    parsehToman: null,
    policyId: null,
    source: 'fallback',
    loaded: false,
    // The wallet's side — null until the BFF has said (purchaseFromAnswer).
    creditPrice: null,
    packages: null,
    purchaseAvailable: null
});
let $121df138798ec781$var$state = $121df138798ec781$var$FALLBACK_STATE;
const $121df138798ec781$var$listeners = new Set();
let $121df138798ec781$var$inflight = null;
let $121df138798ec781$var$answered = false; // a SERVICE answer landed this page load — read once
function $121df138798ec781$var$emit(next) {
    $121df138798ec781$var$state = next;
    for (const fn of $121df138798ec781$var$listeners)fn();
}
function $121df138798ec781$export$34eacae788ce613f(list) {
    const price = list?.creditPrice;
    const amount = Number(price?.amountMinor);
    const currency = typeof price?.currency === 'string' ? price.currency.trim() : '';
    const creditPrice = currency && currency !== (0, $2a90b979c3d41f86$export$ae8383984baa5079) && Number.isFinite(amount) && amount > 0 ? {
        amountMinor: amount,
        currency: currency
    } : null;
    const packages = Array.isArray(list?.packages) ? list.packages.map(Number).filter((n)=>Number.isInteger(n) && n > 0) : [];
    return {
        creditPrice: creditPrice,
        // Empty = the deployment names none: each surface keeps its own list.
        packages: packages.length ? packages : null,
        purchaseAvailable: typeof list?.purchaseAvailable === 'boolean' ? list.purchaseAvailable : null
    };
}
function $121df138798ec781$export$34ef7267354f580f(list) {
    const purchase = $121df138798ec781$export$34eacae788ce613f(list);
    if (!list || list.source !== 'service' || !Array.isArray(list.items)) // The BFF's own fallback is still the constants — say so, and keep them.
    return {
        ...$121df138798ec781$var$FALLBACK_STATE,
        ...purchase,
        loaded: true
    };
    const byService = new Map();
    for (const item of list.items){
        // An unpriced row (null) leaves the constant in place: a chip must never
        // go blank for a service the AI still charges under its code default.
        // Checked for null BEFORE Number(): Number(null) is 0, and 0 is a price.
        if (!item?.serviceKey || item.parseh === null || item.parseh === undefined) continue;
        const n = Number(item.parseh);
        if (Number.isFinite(n) && n >= 0) byService.set(item.serviceKey, n);
    }
    const toman = Number(list.parsehToman);
    return {
        byService: byService,
        parsehToman: Number.isFinite(toman) && toman > 0 ? Math.round(toman) : null,
        policyId: list.policyId || null,
        source: 'service',
        loaded: true,
        ...purchase
    };
}
function $121df138798ec781$export$477e957045ea2243(list) {
    const next = $121df138798ec781$export$34ef7267354f580f(list);
    if (next.source === 'service') {
        $121df138798ec781$var$answered = true;
        try {
            sessionStorage.setItem($121df138798ec781$var$STORAGE_KEY, JSON.stringify(list));
        } catch  {}
    }
    $121df138798ec781$var$emit(next);
}
function $121df138798ec781$export$230b85c65d633100() {
    $121df138798ec781$var$state = $121df138798ec781$var$FALLBACK_STATE;
    $121df138798ec781$var$inflight = null;
    $121df138798ec781$var$answered = false;
    try {
        sessionStorage.removeItem($121df138798ec781$var$STORAGE_KEY);
    } catch  {}
    for (const fn of $121df138798ec781$var$listeners)fn();
}
// A reload paints the last policy price first, not the constant.
try {
    const cached = sessionStorage.getItem($121df138798ec781$var$STORAGE_KEY);
    if (cached) {
        const restored = $121df138798ec781$export$34ef7267354f580f(JSON.parse(cached));
        if (restored.source === 'service') $121df138798ec781$var$state = {
            ...restored,
            loaded: false
        };
    }
} catch  {}
/** Apollo's answer to a field the schema does not have (an older BFF). */ function $121df138798ec781$var$isSchemaRefusal(err) {
    const errors = err?.graphQLErrors || [];
    return err?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || errors.some((e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') || /Cannot query field/.test(String(err?.message || ''));
}
/** The wallet fields of a non-service answer, over what is held: unsaid keeps the held value. */ function $121df138798ec781$var$wallet(list) {
    const said = $121df138798ec781$export$34eacae788ce613f(list);
    return {
        creditPrice: said.creditPrice ?? $121df138798ec781$var$state.creditPrice,
        packages: said.packages ?? $121df138798ec781$var$state.packages,
        purchaseAvailable: said.purchaseAvailable ?? $121df138798ec781$var$state.purchaseAvailable
    };
}
function $121df138798ec781$export$84016827a72d6537() {
    if ($121df138798ec781$var$answered) return Promise.resolve($121df138798ec781$var$state);
    if ($121df138798ec781$var$inflight) return $121df138798ec781$var$inflight;
    $121df138798ec781$var$inflight = Promise.resolve().then(()=>(0, $adebb901af88e18b$export$7fb4864174f056c)($121df138798ec781$export$f5e24740e23fe4a0).catch((err)=>{
            // A BFF older than the wallet fields refuses the whole document; ask it
            // the old question. Any other failure is a failure.
            if (!$121df138798ec781$var$isSchemaRefusal(err)) throw err;
            return (0, $adebb901af88e18b$export$7fb4864174f056c)($121df138798ec781$export$fc2d6e3af2c81503);
        })).then((data)=>{
        const list = data?.creditPrices;
        if (list && list.source === 'service') $121df138798ec781$export$477e957045ea2243(list);
        else $121df138798ec781$var$emit({
            ...$121df138798ec781$var$state,
            ...$121df138798ec781$var$wallet(list),
            loaded: true
        });
    }).catch(()=>{
        // Offline, signed out, the BFF down: the constants stay on screen.
        $121df138798ec781$var$emit({
            ...$121df138798ec781$var$state,
            loaded: true
        });
    }).finally(()=>{
        $121df138798ec781$var$inflight = null;
    }).then(()=>$121df138798ec781$var$state);
    return $121df138798ec781$var$inflight;
}
function $121df138798ec781$export$c932aceb7c67d0f4(actionId) {
    const key = $121df138798ec781$export$c3ecc18ec062bc34[actionId];
    if (key && $121df138798ec781$var$state.byService && $121df138798ec781$var$state.byService.has(key)) return $121df138798ec781$var$state.byService.get(key);
    return (0, $2a90b979c3d41f86$export$e6d8c7e3d913b530)[actionId] ?? null;
}
function $121df138798ec781$export$ca9b35f04336e4e5() {
    return $121df138798ec781$var$state.parsehToman ?? (0, $2a90b979c3d41f86$export$603323bf3f7bd8d9);
}
function $121df138798ec781$export$a1d28c3cec9e428f() {
    return $121df138798ec781$var$state.creditPrice ?? {
        amountMinor: $121df138798ec781$export$ca9b35f04336e4e5(),
        currency: (0, $2a90b979c3d41f86$export$ae8383984baa5079)
    };
}
function $121df138798ec781$export$869601a36456db2d() {
    return $121df138798ec781$var$state.purchaseAvailable ?? (0, $eLeza.isIranMarket)();
}
function $121df138798ec781$export$3a224a8d5e40047a() {
    return $121df138798ec781$var$state.packages;
}
function $121df138798ec781$export$685f009c83717b79() {
    return (0, $2a90b979c3d41f86$export$52690e1136e04e64).map((row)=>({
            ...row,
            cost: $121df138798ec781$export$c932aceb7c67d0f4(row.action)
        }));
}
const $121df138798ec781$var$subscribe = (fn)=>{
    $121df138798ec781$var$listeners.add(fn);
    return ()=>$121df138798ec781$var$listeners.delete(fn);
};
const $121df138798ec781$var$getSnapshot = ()=>$121df138798ec781$var$state;
function $121df138798ec781$export$34ab9a07791a6651(load = true) {
    const snapshot = (0, $acw62.useSyncExternalStore)($121df138798ec781$var$subscribe, $121df138798ec781$var$getSnapshot, $121df138798ec781$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (load) $121df138798ec781$export$84016827a72d6537();
    }, [
        load
    ]);
    return snapshot.purchaseAvailable ?? (0, $eLeza.isIranMarket)();
}
function $121df138798ec781$export$204bd72286fdb787() {
    const snapshot = (0, $acw62.useSyncExternalStore)($121df138798ec781$var$subscribe, $121df138798ec781$var$getSnapshot, $121df138798ec781$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        $121df138798ec781$export$84016827a72d6537();
    }, []);
    return {
        costOf: $121df138798ec781$export$c932aceb7c67d0f4,
        coinPriceToman: snapshot.parsehToman ?? (0, $2a90b979c3d41f86$export$603323bf3f7bd8d9),
        creditPrice: snapshot.creditPrice ?? {
            amountMinor: snapshot.parsehToman ?? (0, $2a90b979c3d41f86$export$603323bf3f7bd8d9),
            currency: (0, $2a90b979c3d41f86$export$ae8383984baa5079)
        },
        packages: snapshot.packages,
        purchaseAvailable: snapshot.purchaseAvailable ?? (0, $eLeza.isIranMarket)(),
        priceList: $121df138798ec781$export$685f009c83717b79(),
        source: snapshot.source,
        policyId: snapshot.policyId,
        loaded: snapshot.loaded
    };
}


// «نوع تشخیص» — how certain a diagnosis is.
//
// Values mirror ALLOWED_VERIFICATION_STATUSES in clinicalencounter's
// app/domain/models.py — that's the canonical source, and they travel as
// `Condition.verificationStatus`. The GraphQL argument that WRITES one is the
// `DiagnosisType` enum (SCREAMING_CASE), so `DIAGNOSIS_TYPE_ARG` maps between
// the two; nothing else in the app should spell either vocabulary by hand.
//
// Colours are NOT defined here — they come from `diagnosisTypeColors` in
// ./statuses.js so `<StatusChip status={cond.verificationStatus} />` renders the
// same badge on every surface (visit record rail, record sheet, mobile sheet,
// patient file). One badge, one source, no screen inventing its own.
const $4a744c4def3d338a$export$effbc4db6100f5f7 = 'provisional';
const $4a744c4def3d338a$export$283afbef2b868970 = 'confirmed';
const $4a744c4def3d338a$export$a2b1cf9e15bc836 = [
    $4a744c4def3d338a$export$effbc4db6100f5f7,
    $4a744c4def3d338a$export$283afbef2b868970
];
const $4a744c4def3d338a$export$96cc294a492899cc = {
    [$4a744c4def3d338a$export$effbc4db6100f5f7]: 'PROVISIONAL',
    [$4a744c4def3d338a$export$283afbef2b868970]: 'CONFIRMED'
};
const $4a744c4def3d338a$export$fbea400e1bd2969e = {
    [$4a744c4def3d338a$export$effbc4db6100f5f7]: 'visit.dx.type.provisional',
    [$4a744c4def3d338a$export$283afbef2b868970]: 'visit.dx.type.confirmed'
};
const $4a744c4def3d338a$export$5d68a431913dd40b = (cond)=>$4a744c4def3d338a$export$a2b1cf9e15bc836.includes(cond?.verificationStatus) ? cond.verificationStatus : $4a744c4def3d338a$export$effbc4db6100f5f7;
const $4a744c4def3d338a$export$354ec45a177e3da7 = (v)=>$4a744c4def3d338a$export$a2b1cf9e15bc836.includes(v);



// ─────────────────────────────────────────────────────────────────────────────
// The overlay-history law (spec §C.3 rule 1), re-exported from the kit.
//
// An overlay that owns the screen JOINS THE HISTORY STACK, so the platform back
// button — Android's hardware key, the iOS edge-swipe, the browser's own arrow
// — closes IT and not the route behind it. Before this, back with a sheet open
// navigated the route *underneath* the sheet: the sheet stayed on screen over a
// different screen, or a half-finished form was abandoned without being asked.
//
// `BottomSheet` does this itself from @parsina/framework v0.10.0, so most
// overlays in this app get it for free. This module is for the ones that are
// NOT kit sheets — the visit's closure receipt, the per-field voice modal — and
// it exists as an app-local file for the same reason `useResponsive` does: one
// import path, and one file for a convention guard to name.
//
// `overlayHistoryDepth()` is what a route-level leave-guard unwinds past. The
// visit guard used to hardcode `history.go(-2)`, which is correct only while
// exactly one anchor exists and wrong the moment a sheet sits on top of it.
//
// `overlayOwnsPop()` is what a leave-guard asks FIRST on every `popstate`.
// Closing a sheet from inside the app pops the sheet's own entry, and a guard
// that cannot tell that pop from a real back asks «خروج از ویزیت؟» over a
// screen nobody tried to leave — which is what every sheet on the phone's
// visit did until kit v0.11.5.
// ─────────────────────────────────────────────────────────────────────────────

var $9BgRG = parcelRequire("9BgRG");


var $9BgRG = parcelRequire("9BgRG");

var $acw62 = parcelRequire("acw62");

var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// Where a line stands with the insurer, once its part of the visit is registered
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md). One chip per نسخه line and
// دستورات row, read from `ePrescriptionStatus` (lib/erxCorrection.js):
//
//   «ثبت در بیمه»             REGISTERED — at the insurer as it is now. Quiet:
//                              it is the normal state, not news.
//   «تغییر کرده — ارسال نشده»  CHANGED — the insurer holds an older form; its
//                              tooltip says which.
//   «ارسال نشده»               ADDED — not in the registration: written after
//                              it, or left unticked on «ثبت نسخه در بیمه»
//                              (PM-0187), which the server cannot tell apart.
//   «حذف، ارسال نشده»          REMOVED — the insurer still holds it.
//
// Same grammar as the line's other inline chips (RxItemCard's «تکمیل», «از پرونده
// حذف نشد»): 9.5px, 16px tall, never wrapping. Colours from the token module,
// never the visit's CSS variables, which a panel theme can override.
// ─────────────────────────────────────────────────────────────────────────────
const $960c956cfd0a23df$var$TONE = {
    REGISTERED: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        fontWeight: 600
    },
    CHANGED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    },
    ADDED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    },
    REMOVED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    }
};
function $960c956cfd0a23df$export$a8584f59cd36e423({ line: line, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const state = line?.state;
    if (!$960c956cfd0a23df$var$TONE[state]) return null;
    // What the insurer holds, for a line that differs from it.
    const title = line.sentSummary && (state === 'CHANGED' || state === 'REMOVED') ? t('visit.erx.correction.atInsurer', {
        summary: line.sentSummary
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-state": state,
        title: title,
        style: {
            fontSize: 9.5,
            padding: '0 6px',
            borderRadius: 4,
            lineHeight: '16px',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            ...$960c956cfd0a23df$var$TONE[state]
        }
    }, t(`visit.erx.lineState.${state === 'ADDED' ? 'NOT_SENT' : state}`));
}
function $960c956cfd0a23df$export$3e7bfa10fb8d8624({ lines: lines, part: part = 'DRUGS', testid: testid = 'visit-rx-erx-removed' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    const Icon = part === 'SERVICES' ? (0, $4CVxl.default) : (0, $aVx4q.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": testid,
        "aria-label": t('visit.erx.lineState.removedList'),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, lines.map((line, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${line.medicationId || line.orderId || line.name}-${i}`,
            "data-testid": `${testid}-line`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '6px 10px',
                borderRadius: 10,
                border: `1px dashed ${(0, $jTCZr.CT).border2}`,
                background: (0, $jTCZr.CT).surface2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                width: 22,
                height: 22,
                borderRadius: 6,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                color: (0, $jTCZr.CT).mute
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 12,
            strokeWidth: 1.75
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", {
            dir: "auto",
            style: {
                fontSize: 12,
                fontWeight: 600,
                color: (0, $jTCZr.CT).mute,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0
            }
        }, line.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.CT).mute,
                flexShrink: 0
            }
        }, "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($960c956cfd0a23df$export$a8584f59cd36e423, {
            line: line,
            testid: `${testid}-state`
        }), line.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 10.5,
                color: (0, $jTCZr.CT).mute,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0
            }
        }, t('visit.erx.correction.atInsurer', {
            summary: line.sentSummary
        }))))));
}



var $QG9Z3 = parcelRequire("QG9Z3");
var $d8YVq = parcelRequire("d8YVq");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $828bf11fc38b9d89$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M18 17V9",
            key: "2bz60n"
        }
    ],
    [
        "path",
        {
            d: "M13 17V5",
            key: "1frdt8"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
];
const $828bf11fc38b9d89$export$2e2bcd8739ae039 = (0, $9QBug.default)("chart-column", $828bf11fc38b9d89$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $20b80355eea4425a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ],
    [
        "path",
        {
            d: "M10 8h4",
            key: "1sr2af"
        }
    ],
    [
        "path",
        {
            d: "M14 21v-3a2 2 0 0 0-4 0v3",
            key: "1rgiei"
        }
    ],
    [
        "path",
        {
            d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
            key: "secmi2"
        }
    ],
    [
        "path",
        {
            d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
            key: "16ra0t"
        }
    ]
];
const $20b80355eea4425a$export$2e2bcd8739ae039 = (0, $9QBug.default)("building-2", $20b80355eea4425a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4980c56854bb97ce$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $4980c56854bb97ce$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar", $4980c56854bb97ce$export$3efd853dbb351e94);


var $huNwV = parcelRequire("huNwV");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $ggYuf = parcelRequire("ggYuf");
var $kMJsW = parcelRequire("kMJsW");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $97xXr = parcelRequire("97xXr");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b8deaef2bfa57b80$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "3",
            rx: "1",
            key: "1g98yp"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "3",
            rx: "1",
            key: "6d4xhi"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "14",
            rx: "1",
            key: "nxv5o0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "14",
            rx: "1",
            key: "1bb6yr"
        }
    ]
];
const $b8deaef2bfa57b80$export$2e2bcd8739ae039 = (0, $9QBug.default)("layout-grid", $b8deaef2bfa57b80$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $899acbe55afec07f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 17H7A5 5 0 0 1 7 7h2",
            key: "8i5ue5"
        }
    ],
    [
        "path",
        {
            d: "M15 7h2a5 5 0 1 1 0 10h-2",
            key: "1b9ql8"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "12",
            y2: "12",
            key: "1jonct"
        }
    ]
];
const $899acbe55afec07f$export$2e2bcd8739ae039 = (0, $9QBug.default)("link-2", $899acbe55afec07f$export$3efd853dbb351e94);


var $hSPBf = parcelRequire("hSPBf");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7c47b6817ea26fcd$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
];
const $7c47b6817ea26fcd$export$2e2bcd8739ae039 = (0, $9QBug.default)("ellipsis-vertical", $7c47b6817ea26fcd$export$3efd853dbb351e94);


var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");
var $bF8pu = parcelRequire("bF8pu");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2fbfeb4276877a84$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
];
const $2fbfeb4276877a84$export$2e2bcd8739ae039 = (0, $9QBug.default)("save", $2fbfeb4276877a84$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6828da86e4d4e8df$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 7V5a2 2 0 0 1 2-2h2",
            key: "aa7l1z"
        }
    ],
    [
        "path",
        {
            d: "M17 3h2a2 2 0 0 1 2 2v2",
            key: "4qcy5o"
        }
    ],
    [
        "path",
        {
            d: "M21 17v2a2 2 0 0 1-2 2h-2",
            key: "6vwrx8"
        }
    ],
    [
        "path",
        {
            d: "M7 21H5a2 2 0 0 1-2-2v-2",
            key: "ioqczr"
        }
    ]
];
const $6828da86e4d4e8df$export$2e2bcd8739ae039 = (0, $9QBug.default)("scan", $6828da86e4d4e8df$export$3efd853dbb351e94);


var $e5Ore = parcelRequire("e5Ore");
var $6OGKD = parcelRequire("6OGKD");
var $53qqr = parcelRequire("53qqr");
var $bo0GS = parcelRequire("bo0GS");
var $chm1L = parcelRequire("chm1L");
var $7udIf = parcelRequire("7udIf");
var $fX0JO = parcelRequire("fX0JO");
var $lpOUO = parcelRequire("lpOUO");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4aa5203766da4495$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $4aa5203766da4495$export$2e2bcd8739ae039 = (0, $9QBug.default)("trending-up", $4aa5203766da4495$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f3ac79315652b37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 13v8",
            key: "1l5pq0"
        }
    ],
    [
        "path",
        {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            key: "1pljnt"
        }
    ],
    [
        "path",
        {
            d: "m8 17 4-4 4 4",
            key: "1quai1"
        }
    ]
];
const $f3ac79315652b37f$export$2e2bcd8739ae039 = (0, $9QBug.default)("cloud-upload", $f3ac79315652b37f$export$3efd853dbb351e94);


var $6imzq = parcelRequire("6imzq");
var $6TdpC = parcelRequire("6TdpC");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4b055447143d8b14$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
];
const $4b055447143d8b14$export$2e2bcd8739ae039 = (0, $9QBug.default)("zap", $4b055447143d8b14$export$3efd853dbb351e94);


const $375f8776645d5aee$export$610b800a6c6defa5 = `mutation CreateVisit($patientId:ID!,$type:String!){createVisit(patientId:$patientId,type:$type){id}}`;
const $375f8776645d5aee$export$cdc0bbb5663f787c = `mutation StartVisit($id:ID!){startVisit(id:$id){id status}}`;
const $375f8776645d5aee$export$15aef7fbfc49de29 = `mutation UpdateVisit($id:ID!,$input:VisitInput!){updateVisit(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$33b114336c19593d = `mutation EndVisit($id:ID!){endVisit(id:$id){id status}}`;
const $375f8776645d5aee$export$d877ca4a83c64a39 = `query AskDoctorQuestion($visitId:ID!,$question:String!,$transcriptionContext:String,$patientHistory:String,$patientId:ID){askDoctorQuestion(visitId:$visitId,question:$question,transcriptionContext:$transcriptionContext,patientHistory:$patientHistory,patientId:$patientId){answer confidence followUpSuggestions}}`;
const $375f8776645d5aee$export$15324fc83c054605 = `query GenerateConfirmationQuestions($visitId:ID,$patientId:ID,$differentials:[ConfirmationDiagnosisInput!]!,$transcriptionContext:String,$patientHistory:String){generateConfirmationQuestions(visitId:$visitId,patientId:$patientId,differentials:$differentials,transcriptionContext:$transcriptionContext,patientHistory:$patientHistory){items{diagnosisCode description questions{id question hint positiveStatement negativeStatement}}fallback}}`;
const $375f8776645d5aee$export$9812972017b718e1 = `query CheckDrugInteraction($medicationIds:[String!]!,$patientId:ID!,$patientConditions:[String!],$patientAllergies:[String!]){checkDrugInteraction(medicationIds:$medicationIds,patientId:$patientId,patientConditions:$patientConditions,patientAllergies:$patientAllergies){hasInteractions warnings{severity description drugPair source warningType drug condition}}}`;
const $375f8776645d5aee$export$781b4a03507fea1f = `mutation InitializeVisitSession($visitId:ID!,$patientId:ID!){initializeVisitSession(visitId:$visitId,patientId:$patientId){sessionId status}}`;
const $375f8776645d5aee$export$bc9f2df565557d4f = `query GetDifferentialDiagnosis($visitId:ID!){getDifferentialDiagnosis(visitId:$visitId){regenerated items{diagnosisCode description confidence status supportingEvidence contradictingEvidence vitalSignImpact{vital value status effect explanation} citations{pmid title journal year url}confidenceScore{level score factors}}}}`;
const $375f8776645d5aee$export$477e67f6b97e7e38 = `mutation UpdateDifferentialItem($appointmentId:ID!,$diagnosisCode:String!,$action:String!,$diagnosisType:DiagnosisType){updateDifferentialItem(appointmentId:$appointmentId,diagnosisCode:$diagnosisCode,action:$action,diagnosisType:$diagnosisType){items{diagnosisCode description confidence status supportingEvidence contradictingEvidence vitalSignImpact{vital value status effect explanation} citations{pmid title journal year url}confidenceScore{level score factors}}}}`;
const $375f8776645d5aee$export$d3a7b2340b0c9d48 = 8000;
const $375f8776645d5aee$export$7ae855654c1494b5 = `mutation RefineSoapNote($visitId:ID!,$patientId:ID,$input:RefineSoapNoteInput!){refineSoapNote(visitId:$visitId,patientId:$patientId,input:$input){sections{section text changed additions}changed charged status}}`;
const $375f8776645d5aee$export$82d8fcb090733ceb = `mutation AssistPrescription($input:AssistPrescriptionInput!){assistPrescription(input:$input){hasInteractions interactionWarnings{severity description drugPair source warningType drug condition}suggestedMedications{name dosage frequency duration notes citations{pmid title journal year url}}alternativeMedications recommendedTests{testName reason urgency}missingTests followUpTimeline}}`;
const $375f8776645d5aee$export$e94eea18383a4188 = `query ListDrugs($query:String,$category:String,$limit:Int,$offset:Int){listDrugs(query:$query,category:$category,limit:$limit,offset:$offset){drugs{id name genericName category commonDosages commonFrequencies taminListed}total}}`;
const $375f8776645d5aee$export$b3499ea44c0870d9 = `query DrugsById($ids:[ID!],$limit:Int){listDrugs(ids:$ids,limit:$limit){drugs{id name genericName category commonDosages commonFrequencies taminListed}}}`;
const $375f8776645d5aee$export$64bb5ba76d2f107b = `query MyFrequentDrugs($limit:Int){myFrequentDrugs(limit:$limit){times name search dosage frequency route duration quantity instructions drug{id name genericName category commonDosages commonFrequencies taminListed}}}`;
const $375f8776645d5aee$export$f6cdc6e4a4a3c80a = `mutation UpdatePatient($id:ID!,$input:UpdatePatientInput!){updatePatient(id:$id,input:$input){id name phone birthDate bloodType nationalId job insurance height}}`;
const $375f8776645d5aee$export$19b465740ee91bc = `query RecommendTestsAndMedications($input:RecommendationInput!){recommendTestsAndMedications(input:$input){recommendedTests{testName reason urgency}recommendedMedications{name dosage frequency duration notes}clinicalRationale}}`;
const $375f8776645d5aee$export$59a0707dfedfe8a6 = `mutation AddMedication($patientId:ID!,$input:CreateMedicationInput!){addMedication(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$52e699bb9024b09d = `mutation AddCondition($patientId:ID!,$input:CreateConditionInput!){addCondition(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$ea4d931135e95fd1 = `mutation DeleteCondition($id:ID!){deleteCondition(id:$id)}`;
const $375f8776645d5aee$export$b8ec51b731e55222 = `mutation UpdateCondition($id:ID!,$input:UpdateConditionInput!){updateCondition(id:$id,input:$input){id verificationStatus}}`;
const $375f8776645d5aee$export$6762df89b8e36811 = `mutation UpdateEncounter($id:ID!,$input:UpdateEncounterInput!){updateEncounter(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$32eb09bac36a8a3b = `mutation AddClinicalNote($patientId:ID!,$input:CreateClinicalNoteInput!){addClinicalNote(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$1d32d39b70c8b52e = `mutation CreateClinicalNote($patientId:ID!,$input:ClinicalNoteInput!){createClinicalNote(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$6e7c5d8b5a28479a = `mutation UpdateClinicalNote($id:ID!,$input:UpdateClinicalNoteInput!){updateClinicalNote(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$5fcaf1729c987f4d = `mutation CreateMedication($patientId:ID!,$input:MedicationInput!){createMedication(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$5d20d1065b54c736 = `mutation AddObservation($patientId:ID!,$input:CreateObservationInput!){addObservation(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$815cd81bee1aa526 = `query PatientVisitHistory($patientId:ID!,$limit:Int){patientVisitHistory(patientId:$patientId,limit:$limit){visits{appointmentId visitId summary suggestedDiagnosis icdCodes{code description}}}}`;
const $375f8776645d5aee$export$c3637e87e40dab8f = `query SuggestDoctorOrders($appointmentId:ID,$patientId:ID!,$icdCodes:[String!],$diagnoses:[String!],$age:Int,$gender:String,$existingTests:[String!]){suggestDoctorOrders(appointmentId:$appointmentId,patientId:$patientId,icdCodes:$icdCodes,diagnoses:$diagnoses,age:$age,gender:$gender,existingTests:$existingTests){labTests{testName reason urgency category loincCode}imagingStudies{studyType modality bodyPart reason urgency}procedureOrders{name code reason urgency category}clinicalRationale}}`;
const $375f8776645d5aee$export$bed6819e031e8e35 = `mutation SaveDoctorOrders($input:SaveDoctorOrdersInput!){saveDoctorOrders(input:$input){success savedCount error}}`;
const $375f8776645d5aee$export$e8c7fd9774d91e48 = `query EncounterContext($appointmentId:ID!){getEncounterContext(appointmentId:$appointmentId){conditions{id code display clinicalStatus}medications{id code display status dosageInstruction meta}orders{id orderType description status}notes{id format content}}}`;
const $375f8776645d5aee$export$a03187f2f2e2a95d = 3;
const $375f8776645d5aee$export$47d6b1214c1fc978 = 6;
function $375f8776645d5aee$export$8b03bbb666cde734({ soap: soap } = {}) {
    const history = (soap?.s || '').trim();
    const words = history.split(/\s+/).filter(Boolean);
    const chars = history.replace(/\s+/g, '').length;
    const historyOk = words.length >= $375f8776645d5aee$export$a03187f2f2e2a95d && chars >= $375f8776645d5aee$export$47d6b1214c1fc978;
    // An empty «S» and a one-line «S» are different problems, and the doctor is
    // told which one they have: one asks them to write, the other to say more.
    const missing = historyOk ? [] : [
        history ? 'historyThin' : 'history'
    ];
    return {
        ready: historyOk,
        missing: missing,
        historyOk: historyOk
    };
}
const $375f8776645d5aee$export$eaa2f90824feaabb = `query VideoVisitAvailability($patientId:ID!,$appointmentId:ID){videoVisitAvailability(patientId:$patientId,appointmentId:$appointmentId){appointmentId canJoin canConvert reason}}`;
const $375f8776645d5aee$export$16ac3aeec5aaa168 = `mutation SetVisitMode($patientId:ID!,$appointmentId:ID,$online:Boolean!){setVisitMode(patientId:$patientId,appointmentId:$appointmentId,online:$online){appointmentId canJoin canConvert reason}}`;
const $375f8776645d5aee$export$6651891395397547 = `query VideoVisitSession($patientId:ID!,$appointmentId:ID){videoVisitSession(patientId:$patientId,appointmentId:$appointmentId){domain roomName token expiresAt displayName moderator appointmentId}}`;
const $375f8776645d5aee$export$a921a07aefa7f54c = `query VisitCoinUsage($appointmentId:ID!){visitCoinUsage(appointmentId:$appointmentId){total entries{id coins count}}}`;
const $375f8776645d5aee$export$f6b16ee713a6ec9e = `mutation RecordVisitCoinCharge($appointmentId:ID!,$itemId:String!,$coins:Float!){recordVisitCoinCharge(appointmentId:$appointmentId,itemId:$itemId,coins:$coins){total entries{id coins count}}}`;
function $375f8776645d5aee$export$68c00840ed3a0f40(stored, pending) {
    const byId = new Map((stored || []).map((e)=>[
            e.id,
            {
                ...e
            }
        ]));
    for (const c of pending || []){
        const row = byId.get(c.itemId);
        if (row) {
            row.coins += c.coins;
            row.count += 1;
        } else byId.set(c.itemId, {
            id: c.itemId,
            coins: c.coins,
            count: 1
        });
    }
    // Biggest spender first — the breakdown is read to find where the Parseh went.
    return [
        ...byId.values()
    ].sort((a, b)=>b.coins - a.coins);
}
const $375f8776645d5aee$var$toCoinEntries = (usage)=>(usage?.entries || []).map((e)=>({
            id: e.id,
            coins: Number(e.coins) || 0,
            count: Number(e.count) || 0
        }));
function $375f8776645d5aee$export$18ea943e404e01dd(appointmentId) {
    // `stored` is what the visit says it has spent; `pending` is what this page
    // has spent and not yet seen confirmed. What the badge shows is the two folded
    // together, so a charge is visible the instant the action returns and the
    // record still wins the moment it answers.
    const [ledger, setLedger] = (0, $acw62.useState)({
        stored: [],
        pending: []
    });
    const entries = (0, $acw62.useMemo)(()=>$375f8776645d5aee$export$68c00840ed3a0f40(ledger.stored, ledger.pending), [
        ledger
    ]);
    const total = (0, $acw62.useMemo)(()=>entries.reduce((sum, e)=>sum + (e.coins || 0), 0), [
        entries
    ]);
    // The appointment is read through a ref so `charge` can be created ONCE and
    // stay stable for the whole visit. The effects that bill — the debounced
    // interaction sweep — take it as a dependency, and an identity that changed
    // every render would re-trigger the very charge it exists to record.
    const apptRef = (0, $acw62.useRef)(appointmentId);
    apptRef.current = appointmentId;
    const pendingRef = (0, $acw62.useRef)(ledger.pending);
    pendingRef.current = ledger.pending;
    const tokenRef = (0, $acw62.useRef)(0);
    const sentRef = (0, $acw62.useRef)(new Set());
    const prevApptRef = (0, $acw62.useRef)(null);
    // Write one charge and reconcile against the aggregate that comes back. The
    // reply is read AFTER the write commits, so it already contains this charge —
    // which is why the pending copy is dropped at the same moment the stored one
    // replaces it, never before and never twice.
    const sendRef = (0, $acw62.useRef)(null);
    sendRef.current = (charge)=>{
        const appt = apptRef.current;
        if (!appt) return;
        (0, $adebb901af88e18b$export$8395d0fc0d822a81)($375f8776645d5aee$export$f6b16ee713a6ec9e, {
            appointmentId: appt,
            itemId: charge.itemId,
            coins: charge.coins
        }).then((d)=>{
            const usage = d?.recordVisitCoinCharge;
            // No aggregate in the reply means nothing to reconcile against. The
            // local copy stays: the doctor keeps seeing what the action cost.
            if (!usage) return;
            setLedger((l)=>({
                    stored: $375f8776645d5aee$var$toCoinEntries(usage),
                    pending: l.pending.filter((p)=>p.token !== charge.token)
                }));
        })// Left pending on purpose. What was spent was spent; only the record of
        // it is missing, and the badge must not pretend otherwise.
        .catch((err)=>console.warn('visit coin charge not recorded:', err?.message || err));
    };
    // Entering a visit — including re-entering one, and including the reload that
    // follows a refresh — reads the stored usage. This is the whole feature: the
    // badge is recovered from the visit rather than remembered from the session.
    (0, $acw62.useEffect)(()=>{
        const prev = prevApptRef.current;
        prevApptRef.current = appointmentId;
        // Moving to a DIFFERENT visit starts from nothing. Arriving at one from "no
        // visit yet" does not — that is the same visit finishing opening, and the
        // charges it made while its id was in flight are written below.
        if (prev && prev !== appointmentId) {
            sentRef.current.clear();
            setLedger({
                stored: [],
                pending: []
            });
        }
        if (!appointmentId) return undefined;
        let alive = true;
        // The page can bill before getActiveEncounter answers — the automatic
        // «نکات بالینی» pass on mount. Those coins belong to the visit that is
        // opening, so they are written now rather than dropped.
        for (const c of pendingRef.current){
            if (sentRef.current.has(c.token)) continue;
            sentRef.current.add(c.token);
            sendRef.current(c);
        }
        (0, $adebb901af88e18b$export$7fb4864174f056c)($375f8776645d5aee$export$a921a07aefa7f54c, {
            appointmentId: appointmentId
        }).then((d)=>{
            if (alive && d?.visitCoinUsage) setLedger((l)=>({
                    ...l,
                    stored: $375f8776645d5aee$var$toCoinEntries(d.visitCoinUsage)
                }));
        })// A readout that cannot be read keeps whatever it has. Failing to fetch
        // the tally is not a reason to tell the doctor the visit was free.
        .catch((err)=>console.warn('visit coin usage load failed:', err?.message || err));
        return ()=>{
            alive = false;
        };
    }, [
        appointmentId
    ]);
    // Read the stored tally again, for the charges this page did NOT make.
    //
    // Transcription is the one priced component the client no longer bills
    // (spec §3.1 A5): the line is written by the BFF, from the audio it actually
    // received, so the browser's counter can no longer bill a suspended page for
    // dead air. The consequence is that the badge learns about it only by asking,
    // which is what a stopped recording does.
    const refetch = (0, $acw62.useCallback)(()=>{
        const appt = apptRef.current;
        if (!appt) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)($375f8776645d5aee$export$a921a07aefa7f54c, {
            appointmentId: appt
        }).then((d)=>{
            if (d?.visitCoinUsage) setLedger((l)=>({
                    ...l,
                    stored: $375f8776645d5aee$var$toCoinEntries(d.visitCoinUsage)
                }));
        }).catch((err)=>console.warn('visit coin usage refetch failed:', err?.message || err));
    }, []);
    const charge = (0, $acw62.useCallback)((coins, itemId)=>{
        if (!coins || !itemId) return;
        const entry = {
            token: ++tokenRef.current,
            coins: coins,
            itemId: itemId
        };
        setLedger((l)=>({
                ...l,
                pending: [
                    ...l.pending,
                    entry
                ]
            }));
        // No encounter id yet means the visit is still opening; the effect above
        // writes it as soon as there is a visit to attach it to.
        if (!apptRef.current) return;
        sentRef.current.add(entry.token);
        sendRef.current(entry);
    }, []);
    return {
        entries: entries,
        total: total,
        charge: charge,
        refetch: refetch
    };
}
const $375f8776645d5aee$export$8b5e11eca8d53d1 = 30;
function $375f8776645d5aee$export$507352e36a49c92e(soap, key) {
    return key === 'p' ? $375f8776645d5aee$export$35974e4f6db92b0(soap?.p || '') : soap?.[key] || '';
}
function $375f8776645d5aee$export$2bf69ab1543620b6(merged, base, current) {
    const was = String(base || '').trimEnd();
    const now = String(current || '').trimEnd();
    if (now === was) return merged;
    if (!now.startsWith(was)) return null;
    const tail = now.slice(was.length);
    if (was && !/^\s/.test(tail)) return null;
    const head = String(merged || '').trimEnd();
    return was ? `${head}${tail}` : `${head}\n${tail.trimStart()}`;
}
function $375f8776645d5aee$export$3c5b8ac9cc0f8a4(soapNoteId, setSoapNoteId, visitKey) {
    const idRef = (0, $acw62.useRef)(soapNoteId);
    const keyRef = (0, $acw62.useRef)(visitKey);
    const creatingRef = (0, $acw62.useRef)(null); // null | { key, settled }
    // Layout, not passive: a save from the very next event must already see a new
    // visit's null (or a resumed note's id), never the previous visit's row.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        idRef.current = soapNoteId;
    }, [
        soapNoteId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        keyRef.current = visitKey;
    }, [
        visitKey
    ]);
    // write({ create: () => Promise<id>, update: (id) => Promise }) → the row's id
    return (0, $acw62.useCallback)(async ({ create: create, update: update })=>{
        const key = keyRef.current;
        let id = idRef.current;
        const pending = creatingRef.current;
        if (!id && pending && pending.key === key) id = await pending.settled;
        if (id) {
            await update(id);
            return id;
        }
        const creating = Promise.resolve().then(create);
        const entry = {
            key: key,
            settled: creating.then((x)=>x || null, ()=>null)
        };
        creatingRef.current = entry;
        try {
            const created = await creating;
            if (created && keyRef.current === key) {
                idRef.current = created;
                setSoapNoteId(created);
            }
            return created || null;
        } finally{
            if (creatingRef.current === entry) creatingRef.current = null;
        }
    }, [
        setSoapNoteId
    ]);
}
function $375f8776645d5aee$export$79f39042065fbd7d({ visitId: visitId, patientId: patientId, soapRef: soapRef, liveTranscript: liveTranscript, chargeVisit: chargeVisit, onApply: onApply, onCreditError: onCreditError, t: t }) {
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [loadingSections, setLoadingSections] = (0, $acw62.useState)(null); // null | string[]
    // {key: {text, additions, base, stale?}} — `base` is the section the proposal
    // was made from (soapSectionText at request time); `stale` marks one whose
    // section the doctor changed before confirming it (rebaseSoapProposal).
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)(null); // null|'ok'|'no_new_content'|'no_transcript'|'error'
    const [lastRefineLen, setLastRefineLen] = (0, $acw62.useState)(null);
    const inFlightRef = (0, $acw62.useRef)(false);
    // Render-assigned, like soapRef: «تأیید» decides from the proposals on screen,
    // outside the state updater, so the write happens once and only once.
    const previewRef = (0, $acw62.useRef)(preview);
    previewRef.current = preview;
    const liveRef = (0, $acw62.useRef)('');
    liveRef.current = liveTranscript || '';
    // A new visit is a clean slate — previews from the last patient's note must
    // never survive into this one.
    (0, $acw62.useEffect)(()=>{
        setPreview(null);
        setStatus(null);
        setLastRefineLen(null);
    }, [
        visitId
    ]);
    const liveLen = (liveTranscript || '').length;
    const hasNewContent = (liveTranscript || '').trim().length >= $375f8776645d5aee$export$8b5e11eca8d53d1 && (lastRefineLen === null || liveLen >= lastRefineLen + $375f8776645d5aee$export$8b5e11eca8d53d1);
    // «محتوای جدیدی یافت نشد» stops being true the moment new speech lands —
    // clear it so the doctor is not reading a stale verdict.
    (0, $acw62.useEffect)(()=>{
        if (hasNewContent) setStatus((s)=>s === 'no_new_content' || s === 'no_transcript' ? null : s);
    }, [
        hasNewContent
    ]);
    // Resolves to the outcome: 'found' (proposals are on screen), 'none' (read,
    // nothing new) or 'error' (not read — including a merge the SERVER reports it
    // could not do, which the visit-wide «تکمیل» must report as failed, never as
    // «nothing new»).
    const refine = (0, $acw62.useCallback)(async (sections)=>{
        if (inFlightRef.current || !visitId) return 'error';
        inFlightRef.current = true;
        setLoading(true);
        setLoadingSections(sections && sections.length ? sections : null);
        setStatus(null);
        try {
            const soap = soapRef.current || {};
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($375f8776645d5aee$export$7ae855654c1494b5, {
                visitId: visitId,
                patientId: patientId || null,
                input: {
                    s: soap.s || '',
                    o: soap.o || '',
                    a: soap.a || '',
                    // Only the narrative travels: the managed drug/order block is derived
                    // client-side and re-spliced on apply (see planBlockText).
                    p: $375f8776645d5aee$export$35974e4f6db92b0(soap.p || ''),
                    sections: sections && sections.length ? sections : null,
                    transcriptTail: liveRef.current.slice(-3000)
                }
            }, {
                timeoutMs: (0, $adebb901af88e18b$export$5c63bf3ded5aa229)
            });
            const res = data?.refineSoapNote;
            if (!res) {
                setStatus('error');
                return 'error';
            }
            // The server, not the click, decides whether this cost anything.
            if (res.charged) chargeVisit?.((0, $121df138798ec781$export$c932aceb7c67d0f4)('SOAP_REFINE'), 'ask', t?.('visit.soap.completed'));
            setLastRefineLen(liveRef.current.length);
            const changedSections = (res.sections || []).filter((x)=>x.changed && (x.text || '').trim());
            const found = !!(res.changed && changedSections.length);
            // A stale proposal in a part that was just read again has been answered:
            // replaced below if the reading found something, gone if it did not.
            const read = sections && sections.length ? sections : [
                's',
                'o',
                'a',
                'p'
            ];
            if (found || res.status !== 'error') setPreview((prev)=>{
                if (!found && !read.some((k)=>prev?.[k]?.stale)) return prev;
                const next = {
                    ...prev || {}
                };
                read.forEach((k)=>{
                    if (next[k]?.stale) delete next[k];
                });
                changedSections.forEach((x)=>{
                    next[x.section] = {
                        text: x.text,
                        additions: x.additions || [],
                        base: $375f8776645d5aee$export$507352e36a49c92e(soap, x.section)
                    };
                });
                return Object.keys(next).length ? next : null;
            });
            if (found) setStatus('ok');
            else // 'error' is the server saying the merge itself failed — a timeout or
            // an unparseable answer. Folding it into «محتوای جدیدی یافت نشد» told
            // the doctor their visit had nothing new in it, which is the one thing
            // that was certainly untrue.
            setStatus(res.status === 'no_transcript' ? 'no_transcript' : res.status === 'error' ? 'error' : 'no_new_content');
            return found ? 'found' : res.status === 'error' ? 'error' : 'none';
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') onCreditError?.(e.message);
            else {
                console.error('[SOAP refine]', e);
                setStatus('error');
            }
            return 'error';
        } finally{
            inFlightRef.current = false;
            setLoading(false);
            setLoadingSections(null);
        }
    }, [
        visitId,
        patientId,
        chargeVisit,
        onCreditError,
        t,
        soapRef
    ]);
    // «تأیید» for the proposals of `keys`, in ONE onApply. Each is written against
    // the section as it is NOW: as merged when untouched, with the doctor's
    // appended text kept when they only added to it, and not at all when they
    // changed it otherwise — that proposal turns stale and waits to be read again,
    // because writing it would silently delete what they wrote.
    const applyKeys = (0, $acw62.useCallback)((keys)=>{
        const prev = previewRef.current;
        if (!prev) return;
        const soap = soapRef.current || {};
        const entries = {};
        const stale = [];
        keys.forEach((key)=>{
            const entry = prev[key];
            if (!entry || entry.stale) return;
            const text = $375f8776645d5aee$export$2bf69ab1543620b6(entry.text, entry.base, $375f8776645d5aee$export$507352e36a49c92e(soap, key));
            if (text == null) stale.push(key);
            else entries[key] = text;
        });
        const applied = Object.keys(entries);
        if (!applied.length && !stale.length) return;
        // Settle exactly the entries decided on here — a proposal that arrived since
        // is a different object and stays.
        const settle = (cur)=>{
            if (!cur) return cur;
            const next = {
                ...cur
            };
            applied.forEach((k)=>{
                if (next[k] === prev[k]) delete next[k];
            });
            stale.forEach((k)=>{
                if (next[k] === prev[k]) next[k] = {
                    ...prev[k],
                    stale: true
                };
            });
            return Object.keys(next).length ? next : null;
        };
        previewRef.current = settle(prev);
        if (applied.length) onApply?.(entries);
        setPreview(settle);
        setStatus(null);
    }, [
        onApply,
        soapRef
    ]);
    const apply = (0, $acw62.useCallback)((key)=>applyKeys([
            key
        ]), [
        applyKeys
    ]);
    // `keys`: the sections whose proposals are ON SCREEN. The desktop's S/O/A tab
    // does not show «P» (it has a tab of its own), and «اعمال همه» there wrote a
    // proposal the doctor never saw. No list (or a click event) means every one.
    const applyAll = (0, $acw62.useCallback)((keys)=>{
        applyKeys(Array.isArray(keys) ? keys : Object.keys(previewRef.current || {}));
    }, [
        applyKeys
    ]);
    const dismiss = (0, $acw62.useCallback)((key)=>{
        setPreview((prev)=>{
            if (!prev?.[key]) return prev;
            const next = {
                ...prev
            };
            delete next[key];
            return Object.keys(next).length ? next : null;
        });
    }, []);
    const dismissAll = (0, $acw62.useCallback)(()=>{
        setPreview(null);
        setStatus(null);
    }, []);
    return {
        refine: refine,
        loading: loading,
        loadingSections: loadingSections,
        preview: preview,
        status: status,
        hasNewContent: hasNewContent,
        apply: apply,
        applyAll: applyAll,
        dismiss: dismiss,
        dismissAll: dismissAll
    };
}
function $375f8776645d5aee$export$3f0d5a0b11f5b929(ai, settingsUnknown, visitId) {
    const [override, setOverride] = (0, $acw62.useState)(null);
    // A new or resumed encounter is a different visit — the previous one's
    // exception must not follow the doctor into it.
    (0, $acw62.useEffect)(()=>{
        setOverride(null);
    }, [
        visitId
    ]);
    // While the doctor's choice is unknown — the settings are still in flight, or
    // the query that carries them FAILED — nothing has been decided yet, so the
    // loop stays parked rather than guessing with the defaults. Guessing costs
    // real credits here: every tick that re-assesses is billed.
    const fromSettings = !settingsUnknown && (0, $2d58c73a38525204$export$8c8aa4bf9ee20a73)(ai);
    const active = override == null ? fromSettings : override;
    const toggle = (0, $acw62.useCallback)(()=>setOverride(!active), [
        active
    ]);
    return {
        active: active,
        pollMs: (0, $2d58c73a38525204$export$8929775566921897)(ai),
        seconds: (0, $2d58c73a38525204$export$291b76ac275aac62)(ai),
        // True once the doctor has departed from Settings for this visit, so the
        // surfaces can say so instead of leaving them to wonder why the switch in
        // Settings no longer matches what the page is doing.
        overridden: override != null,
        toggle: toggle
    };
}
const $375f8776645d5aee$export$d20c1dcfc45ad42b = (d)=>d?.status === 'accepted' || d?.status === 'modified';
const $375f8776645d5aee$var$isDifferentialDecided = (d)=>$375f8776645d5aee$export$d20c1dcfc45ad42b(d) || d?.status === 'rejected';
async function $375f8776645d5aee$export$a11a26367843ed4f(seqRef, run) {
    seqRef.current += 1;
    try {
        return await run();
    } finally{
        seqRef.current += 1;
    }
}
function $375f8776645d5aee$export$24f67d3076448bf7(prev, items, { stale: stale = false } = {}) {
    const prevMap = Object.fromEntries((prev || []).map((d)=>[
            d.diagnosisCode,
            d
        ]));
    const merged = (items || []).map((item)=>{
        const shown = prevMap[item.diagnosisCode];
        const next = {
            ...item,
            confidenceScore: item.confidenceScore ?? shown?.confidenceScore
        };
        if (stale && $375f8776645d5aee$var$isDifferentialDecided(shown)) next.status = shown.status;
        return next;
    });
    if (!stale) return merged;
    const present = new Set(merged.map((d)=>d.diagnosisCode));
    return merged.concat((prev || []).filter((d)=>$375f8776645d5aee$export$d20c1dcfc45ad42b(d) && !present.has(d.diagnosisCode)));
}
async function $375f8776645d5aee$export$5cadc197239e50ce({ bffMutation: bffMutation, visitId: visitId, diagnosisCode: diagnosisCode, diagnosisType: diagnosisType, isAccepted: isAccepted, setDifferential: setDifferential }) {
    const res = await bffMutation($375f8776645d5aee$export$477e67f6b97e7e38, {
        appointmentId: visitId,
        diagnosisCode: diagnosisCode,
        action: isAccepted ? 'modify' : 'accept',
        diagnosisType: (0, $4a744c4def3d338a$export$96cc294a492899cc)[diagnosisType]
    });
    const updated = res.updateDifferentialItem?.items;
    if (updated) setDifferential((prev)=>{
        const prevMap = Object.fromEntries((prev || []).map((x)=>[
                x.diagnosisCode,
                x
            ]));
        return updated.map((item)=>({
                ...item,
                confidenceScore: item.confidenceScore ?? prevMap[item.diagnosisCode]?.confidenceScore
            }));
    });
    return updated;
}
function $375f8776645d5aee$export$5b3196b6580e75eb(conditions, diagnosisCode) {
    if (!diagnosisCode) return null;
    const hit = (conditions || []).find((c)=>c.code === diagnosisCode);
    return hit ? (0, $4a744c4def3d338a$export$5d68a431913dd40b)(hit) : null;
}
function $375f8776645d5aee$export$89161e2370097cc4(encounters, { limit: limit, excludeId: excludeId } = {}) {
    const rows = (encounters || []).filter((e)=>e && e.status === 'finished' && (!excludeId || e.id !== excludeId)).sort((a, b)=>new Date(b.scheduledDate || 0) - new Date(a.scheduledDate || 0));
    return limit ? rows.slice(0, limit) : rows;
}
function $375f8776645d5aee$export$22c958772a7f76e1(summaries) {
    const map = new Map();
    for (const s of summaries || []){
        const key = s?.appointmentId || s?.visitId;
        if (key) map.set(String(key), s);
    }
    return map;
}
function $375f8776645d5aee$export$33b3781481f6ac85(context, summary) {
    const coded = (context?.conditions || []).map((c)=>c.display || c.code).filter(Boolean);
    if (coded.length) return coded;
    return summary?.suggestedDiagnosis ? [
        summary.suggestedDiagnosis
    ] : [];
}
function $375f8776645d5aee$export$e60dc5b789daafad(context) {
    for (const note of context?.notes || []){
        const c = note?.content || {};
        const text = c.assessment || c.a || c.plan || c.p || c.subjective || c.s || c.text;
        if (text && String(text).trim()) return String(text).trim();
    }
    return '';
}
const $375f8776645d5aee$export$f34a41ed9a6da313 = `query SuggestTreatmentPlan($input:SuggestTreatmentPlanInput!){suggestTreatmentPlan(input:$input){medications{name dosage frequency duration notes}labTests{testName reason urgency category loincCode}imagingStudies{studyType modality bodyPart reason urgency}procedureOrders{name code reason urgency category}planNote clinicalRationale interactionWarnings{severity description drugPair source warningType drug condition}}}`;
const $375f8776645d5aee$export$9c8ef21e5ce2027 = `query TreatmentPlan($appointmentId:ID!,$patientId:ID){treatmentPlan(appointmentId:$appointmentId,patientId:$patientId){id status planNote aiGenerated confirmedAt exists}}`;
const $375f8776645d5aee$export$97c305a43bb466fa = `mutation SaveTreatmentPlanNote($appointmentId:ID!,$patientId:ID,$planNote:String!,$aiGenerated:Boolean){saveTreatmentPlanNote(appointmentId:$appointmentId,patientId:$patientId,planNote:$planNote,aiGenerated:$aiGenerated){id status planNote aiGenerated exists}}`;
const $375f8776645d5aee$export$11e9f559a2c034d2 = `mutation ConfirmTreatmentPlan($appointmentId:ID!){confirmTreatmentPlan(appointmentId:$appointmentId){id status confirmedAt exists}}`;
const $375f8776645d5aee$export$725e3ec3814f10de = `mutation DeleteObservation($id:ID!){deleteObservation(id:$id)}`;
const $375f8776645d5aee$export$608c51c2a533f155 = `mutation DeleteMedication($id:ID!){deleteMedication(id:$id)}`;
const $375f8776645d5aee$export$b41f928ed45f8779 = `mutation UpdateMedication($id:ID!,$input:UpdateMedicationInput!){updateMedication(id:$id,input:$input){id status}}`;
const $375f8776645d5aee$export$cd39121473ec6a95 = `query PrescriptionTemplates{prescriptionTemplates{id title content scope}}`;
const $375f8776645d5aee$export$13ca7cd8c39f4461 = `query{getActiveEncounter{id patientId status}}`;
const $375f8776645d5aee$export$a98b585598d708d2 = `mutation ParseSoapVoiceField($transcript:String!,$field:String!){parseSoapVoiceField(transcript:$transcript,field:$field)}`;
const $375f8776645d5aee$export$5b71fce46c6ed6a3 = `query ListClinicalNotes($patientId:ID!,$appointmentId:ID){listClinicalNotes(patientId:$patientId,appointmentId:$appointmentId){id noteType content}}`;
const $375f8776645d5aee$export$337c36ab78c979c4 = `mutation CancelEncounter($id:ID!){cancelEncounter(id:$id){id status}}`;
const $375f8776645d5aee$export$1d5821a442552a84 = `query ListOrders($appointmentId:ID!){listOrders(appointmentId:$appointmentId){id orderType description urgency status notes createdAt performedDate code catalogId}}`;
const $375f8776645d5aee$export$81ebae6b21d102e1 = `mutation CreateOrder($appointmentId:ID!,$patientId:ID!,$orderType:String!,$description:String!,$urgency:OrderUrgency,$notes:String,$code:String,$catalogId:ID,$sessionCount:Int){createOrder(appointmentId:$appointmentId,patientId:$patientId,orderType:$orderType,description:$description,urgency:$urgency,notes:$notes,code:$code,catalogId:$catalogId,sessionCount:$sessionCount){id orderType description urgency status notes createdAt performedDate code catalogId}}`;
// ثبت ویزیت در تأمین اجتماعی — the inline card in the closure modal. All three
// select the same fields because every step returns the same envelope; the card
// re-renders from `state` alone and never merges two shapes.
const $375f8776645d5aee$var$TAMIN_FIELDS = `state sessionId otpSentTo trackingCode message registeredCount missingFields skipped{name reason}`;
const $375f8776645d5aee$export$7bbd1b1f2e567778 = `query TaminPreview($appointmentId:ID!,$patientId:ID!){taminRegistrationPreview(appointmentId:$appointmentId,patientId:$patientId){available unavailableReason missingFields hasLiveSession registrableCount skipped{name reason}}}`;
const $375f8776645d5aee$export$b7f69c13f88802ea = `mutation BeginTamin($appointmentId:ID!,$patientId:ID!,$credentials:TaminCredentialsInput){beginTaminRegistration(appointmentId:$appointmentId,patientId:$patientId,credentials:$credentials){${$375f8776645d5aee$var$TAMIN_FIELDS}}}`;
const $375f8776645d5aee$export$905c6cb0f2f2e234 = `mutation SubmitTaminOtp($appointmentId:ID!,$patientId:ID!,$sessionId:ID!,$code:String!){submitTaminOtp(appointmentId:$appointmentId,patientId:$patientId,sessionId:$sessionId,code:$code){${$375f8776645d5aee$var$TAMIN_FIELDS}}}`;
// نسخه‌نویسی الکترونیک (op-naji) — the card beside the تأمین one in the closure.
// The server gathers the visit and holds the insurer session; the card renders
// what comes back (components/visit/EPrescriptionCard.jsx).
const $375f8776645d5aee$var$ERX_SESSION_FIELDS = 'insurer insurerLabel state expiresAt otpSentTo captchaImage redirectUrl messageCode message';
const $375f8776645d5aee$var$ERX_SUBMISSION_FIELDS = 'state insurer localId lifecycle trackingCode prescriptionCode ditasStatus gatewayStatus messageCode message fieldErrors{field message} retryable attempts updatedAt blockers{code message fixIn}';
const $375f8776645d5aee$export$fa16d22e4f643897 = `mutation CompleteRxDirections($input:RxDirectionsInput!){completeRxDirections(input:$input){status charged lines{lineId dosage frequency route duration quantity note}}}`;
// The preview, as the card reads it. «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04;
// docs/eprescription/CORRECTION.md) added what a registered part now holds: each
// line's part and the record row behind it, what the insurer has of a changed or
// removed line (`sentSummary`), and whether a correction can go (`correction`).
const $375f8776645d5aee$var$erxPreviewOp = (name, lineExtra, extra)=>`query ${name}($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer,$patientNationalCode:String){ePrescriptionPreview(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,patientNationalCode:$patientNationalCode){enabled insurer insurerLabel offeredInsurers patientInsurer ready sendableCount draftOnly serviceIssue serviceMessage siamId patientNationalCode sentNationalCode blockers{code message fixIn} lines{name sendable reasonCode reason erxCode serviceCode${lineExtra}}${extra} session{${$375f8776645d5aee$var$ERX_SESSION_FIELDS}} submission{${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS}}}}`;
const $375f8776645d5aee$export$4d6ef37e3b3fc364 = $375f8776645d5aee$var$erxPreviewOp('ErxPreview', ' part medicationId orderId sentSummary sentAs heldTrackingCode', ' correction{available pendingCount parts until unavailableReason}');
const $375f8776645d5aee$export$2fedc374da938b3c = $375f8776645d5aee$var$erxPreviewOp('ErxPreviewPreCorrection', '', '');
const $375f8776645d5aee$export$a95f04fc131305cf = `mutation ErxStartLogin($insurer:EPrescriptionInsurer!,$username:String,$password:String,$nationalCode:String,$mobile:String){startInsurerLogin(insurer:$insurer,username:$username,password:$password,nationalCode:$nationalCode,mobile:$mobile){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$d688676352e6afeb = `mutation ErxAnswer($insurer:EPrescriptionInsurer!,$otp:String,$captcha:String){answerInsurerChallenge(insurer:$insurer,otp:$otp,captcha:$captcha){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$d48ea6856e66736d = `mutation ErxLogout($insurer:EPrescriptionInsurer!){logoutInsurer(insurer:$insurer){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$3713d209ae047851 = `mutation ErxSetSiam($siamId:String!){setMySiamId(siamId:$siamId)}`;
const $375f8776645d5aee$export$cdbeae1ac264703e = `mutation ErxSend($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$labDue:EPrescriptionLabDueInput,$patientNationalCode:String,$savePatientNationalCode:Boolean){sendEPrescription(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,labDue:$labDue,patientNationalCode:$patientNationalCode,savePatientNationalCode:$savePatientNationalCode){${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS} patientNationalCodeSaved}}`;
// The same two operations scoped to the نسخه or the دستورات (K1, 2026-10-03). Kept
// apart so an unscoped card still asks exactly what an older BFF understands.
const $375f8776645d5aee$var$withErxScope = (op, field)=>op.replace(/^(query|mutation) (\w+)\(/, '$1 $2Scoped($scope:EPrescriptionScope,').replace(`${field}(`, `${field}(scope:$scope,`);
const $375f8776645d5aee$export$e76d3b0c177e8362 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$4d6ef37e3b3fc364, 'ePrescriptionPreview');
const $375f8776645d5aee$export$5ddaa93868d3670f = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$2fedc374da938b3c, 'ePrescriptionPreview');
const $375f8776645d5aee$export$876fbc5c8db40344 = 'query ErxEligibility($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$patientNationalCode:String){ePrescriptionEligibility(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,patientNationalCode:$patientNationalCode){state reason blocks message coverageStatus checkedAt cached}}';
const $375f8776645d5aee$export$4b366d0c9745cd96 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$cdbeae1ac264703e, 'sendEPrescription');
const $375f8776645d5aee$export$45a656a5891fd4c1 = $375f8776645d5aee$export$cdbeae1ac264703e.replace('mutation ErxSend(', 'mutation ErxSendSavingInsurer($savePatientInsurer:Boolean,').replace('sendEPrescription(', 'sendEPrescription(savePatientInsurer:$savePatientInsurer,').replace(' patientNationalCodeSaved}}', ' patientNationalCodeSaved patientInsurerSaved}}');
const $375f8776645d5aee$export$f4844156b4b46778 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$45a656a5891fd4c1, 'sendEPrescription');
const $375f8776645d5aee$export$3dbec13a22a52d5f = (op)=>{
    const field = (op.match(/\b(ePrescriptionPreview|sendEPrescriptionCorrection|sendEPrescription)\(/) || [])[1];
    if (!field) return op;
    const out = op.replace(/^(query|mutation) (\w+)\(/, '$1 $2WithPatient($patientGender:String,$patientMobile:String,').replace(`${field}(`, `${field}(patientGender:$patientGender,patientMobile:$patientMobile,`);
    return field === 'sendEPrescription' ? out.replace(' patientNationalCodeSaved', ' patientNationalCodeSaved patientDetailsSaved') : out;
};
const $375f8776645d5aee$export$aebcdf6f5e0d5e2c = (op)=>op.replace(/^mutation (\w+)\(/, 'mutation $1Excluding($excludedMedicationIds:[ID!],$excludedOrderIds:[ID!],').replace('sendEPrescription(', 'sendEPrescription(excludedMedicationIds:$excludedMedicationIds,excludedOrderIds:$excludedOrderIds,');
const $375f8776645d5aee$export$e436a36803f66c6f = `query ErxStatus($appointmentId:ID!,$patientId:ID!){ePrescriptionStatus(appointmentId:$appointmentId,patientId:$patientId){enabled registered insurer final until expired pendingCount parts{part registered pendingCount trackingCode} lines{part medicationId orderId name state sentSummary}}}`;
const $375f8776645d5aee$export$998c87dffbd5dcdb = `mutation ErxSendCorrection($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$scope:EPrescriptionScope,$labDue:EPrescriptionLabDueInput,$patientNationalCode:String){sendEPrescriptionCorrection(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,scope:$scope,labDue:$labDue,patientNationalCode:$patientNationalCode){${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS} correctsLocalId}}`;
const $375f8776645d5aee$export$a829ddd2566c75b7 = `mutation StartOrder($orderId:ID!){startOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$b0b354e2ddeac24b = `mutation CompleteOrder($orderId:ID!){completeOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$494a03338ebc3893 = `mutation CancelOrder($orderId:ID!){cancelOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$1f71eb225ba1e723 = `
  @keyframes spin    { to{transform:rotate(360deg)} }
  @keyframes pulse   { 0%,100%{opacity:.35;transform:scale(1)} 50%{opacity:.9;transform:scale(1.1)} }
  @keyframes fadeUp  { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideDown { from{opacity:0;transform:translateY(-6px)} to{opacity:1;transform:translateY(0)} }
  @keyframes waveAnim0 { from{transform:scaleY(.40)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim1 { from{transform:scaleY(.55)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim2 { from{transform:scaleY(.30)} to{transform:scaleY(.95)} }
  @keyframes waveAnim3 { from{transform:scaleY(.60)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim4 { from{transform:scaleY(.45)} to{transform:scaleY(.85)} }
  @keyframes blink   { 0%,100%{opacity:1} 50%{opacity:0} }
  @keyframes draw    { to{stroke-dashoffset:0} }
  @keyframes rgFade  { from{opacity:0} to{opacity:1} }
  @keyframes rgPop   { from{opacity:0;transform:scale(.92)} to{opacity:1;transform:scale(1)} }
  @keyframes rgRing  { 0%{opacity:.6;transform:scale(1)} 100%{opacity:0;transform:scale(1.7)} }
  @keyframes rgWave  { 0%,100%{transform:scaleY(.4)} 50%{transform:scaleY(1)} }
`;
const $375f8776645d5aee$export$220f2e5d84ced4cb = `
  :root {
    --bg:           ${(0, $jTCZr.CT).bg};
    --panel:        ${(0, $jTCZr.CT).surface};
    --panel-2:      ${(0, $jTCZr.CT).surface};
    --panel-inset:  ${(0, $jTCZr.CT).surface2};
    --line:         ${(0, $jTCZr.CT).border};
    --line-2:       ${(0, $jTCZr.CT).border2};
    --ink:          ${(0, $jTCZr.CT).ink};
    --ink-2:        ${(0, $jTCZr.CT).ink2};
    --mute:         ${(0, $jTCZr.CT).mute};
    --mute-2:       ${(0, $jTCZr.CT).mute2};
    --primary:      ${(0, $jTCZr.CT).navy};
    --primary-ink:  ${(0, $jTCZr.C).navyDark};
    --accent:       ${(0, $jTCZr.CT).accent};
    --accent-soft:  ${(0, $jTCZr.CT).accentSoft};
    --accent-ink:   ${(0, $jTCZr.CT).accentInk};
    --warn:         ${(0, $jTCZr.CT).warn};
    --warn-soft:    ${(0, $jTCZr.CT).warnSoft};
    --warn-ink:     ${(0, $jTCZr.CT).warnInk};
    --danger:       ${(0, $jTCZr.CT).danger};
    --danger-soft:  ${(0, $jTCZr.CT).dangerSoft};
    --danger-ink:   ${(0, $jTCZr.CT).dangerInk};
    --good:         ${(0, $jTCZr.CT).good};
    --good-soft:    ${(0, $jTCZr.CT).goodSoft};
    --good-ink:     ${(0, $jTCZr.CT).goodInk};
    --field:        #faf8f5;   /* warm-beige field/section-head \u{2014} the Visit "focus mode" literal (design-doc \xa7scope-exception) */
    --radius:       10px;
    --radius-lg:    14px;
    --shadow:       0 1px 0 rgba(15,23,42,.04), 0 1px 2px rgba(15,23,42,.05);
    --shadow-pop:   0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06);
  }
`;
const $375f8776645d5aee$export$8b6317f87e032c1 = (t)=>[
        t('visit.copilot.likelyDifferentials'),
        t('visit.suggest.tests'),
        t('visit.quick.dosingForComorbidities'),
        t('visit.quick.checkInteractions'),
        t('visit.quick.cvRisk'),
        t('visit.quick.followUpForVisit')
    ];
const $375f8776645d5aee$export$74f6a832d246e098 = (t)=>[
        t('visit.duration.d3'),
        t('visit.duration.d5'),
        t('visit.duration.d7'),
        t('visit.duration.d10'),
        t('visit.duration.d14'),
        t('visit.duration.m1'),
        t('visit.duration.m2'),
        t('visit.duration.m3'),
        t('visit.duration.m6'),
        t('visit.duration.untilFurtherNotice')
    ];
const $375f8776645d5aee$export$e730a0734bbb1219 = ()=>(0, $ace44487380106d3$export$4e844baf4fb2f82b);
const $375f8776645d5aee$export$7be9a8bfe9895054 = (t)=>[
        t('visit.rx.instructionPresets.afterMeal'),
        t('visit.rx.instructionPresets.beforeMeal'),
        t('visit.rx.instructionPresets.withFood'),
        t('visit.rx.instructionPresets.emptyStomach'),
        t('visit.rx.instructionPresets.bedtime'),
        t('visit.rx.instructionPresets.asNeeded'),
        t('visit.rx.instructionPresets.finishCourse')
    ];
const $375f8776645d5aee$export$b9d67b8f1f51ac8d = `
.m-app{display:flex;flex-direction:column;height:100%;background:var(--bg);overflow:hidden;position:relative;font-family:var(--app-font);direction:rtl}
.m-topbar{display:flex;align-items:center;gap:8px;padding:8px 12px;background:var(--panel);border-bottom:1px solid var(--line)}
.m-icon-btn{width:36px;height:36px;border-radius:9px;display:grid;place-items:center;color:var(--ink-2);background:transparent;border:none;cursor:pointer}
.m-icon-btn:active{background:var(--line)}
.m-icon-btn svg{width:17px;height:17px}
.m-icon-btn.small{width:30px;height:30px}
.m-title{flex:1;min-width:0}
.m-title-1{font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.m-title-2{display:flex;align-items:center;gap:6px;font-size:11px;color:var(--mute);margin-top:1px}
.m-dot{width:3px;height:3px;border-radius:50%;background:var(--mute-2)}
.m-rec{width:6px;height:6px;border-radius:50%;background:var(--danger);margin-inline-start:2px;animation:pulse 1.6s infinite}
.m-rec.off{background:var(--mute-2);animation:none}
.m-allergy{display:flex;align-items:center;gap:8px;padding:7px 12px;background:var(--danger-soft);border-bottom:1px solid oklch(0.85 0.08 25);font-size:11.5px}
.m-allergy svg{width:13px;height:13px;color:var(--danger);flex-shrink:0}
.m-allergy-chips{display:flex;gap:4px;overflow:auto;-webkit-overflow-scrolling:touch}
.m-allergy-pill{padding:2px 7px;border-radius:999px;background:#fff;border:1px solid oklch(0.82 0.08 25);color:var(--danger-ink);font-size:10.5px;font-weight:500;white-space:nowrap}
.m-vital-strip{display:flex;gap:8px;padding:10px 12px;overflow-x:auto;background:var(--panel);border-bottom:1px solid var(--line);scrollbar-width:none}
.m-vital-strip::-webkit-scrollbar{display:none}
.m-vital{flex-shrink:0;width:100px;padding:9px 11px;border-radius:10px;background:var(--panel-2);border:1px solid var(--line);text-align:start;cursor:pointer}
.m-vital.alert{background:var(--warn-soft);border-color:oklch(0.85 0.07 60)}
.m-vital-k{font-size:9.5px;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600}
.m-vital-v{font-family:'JetBrains Mono',ui-monospace,monospace;font-weight:700;font-size:16px;color:var(--ink);display:flex;align-items:baseline;gap:3px;margin:2px 0 4px}
.m-vital-u{font-size:9px;color:var(--mute);font-weight:500}
.m-vital-add{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border:1px dashed var(--line);background:transparent;color:var(--mute);font-size:11px;width:80px}
.m-vital-add svg{width:14px;height:14px}
.m-tabs{display:flex;gap:0;background:var(--panel);border-bottom:1px solid var(--line);padding:0 4px;position:sticky;top:0;z-index:5}
.m-tab{flex:1;padding:11px 6px;font-size:12px;font-weight:500;color:var(--mute);border-bottom:2px solid transparent;margin-bottom:-1px;display:flex;align-items:center;justify-content:center;gap:5px;background:transparent;border-top:none;border-left:none;border-right:none;cursor:pointer;font-family:inherit}
.m-tab svg{width:13px;height:13px}
.m-tab.on{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}
.m-tab-b{font-size:9.5px;background:var(--line);color:var(--ink-2);padding:1px 5px;border-radius:999px;font-weight:600}
.m-tab.on .m-tab-b{background:var(--accent-soft);color:var(--accent-ink)}
.m-content{flex:1;overflow-y:auto;padding:12px 12px 160px;background:var(--bg)}
.m-card-head{display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap}
.m-soap{background:var(--panel-2);border:1px solid var(--line);border-radius:10px;margin-bottom:8px;overflow:hidden}
.m-soap-head{display:flex;align-items:center;gap:10px;padding:11px 13px;width:100%;text-align:start;background:transparent;border:none;cursor:pointer;font-family:inherit}
.m-soap-letter{width:24px;height:24px;border-radius:6px;background:var(--accent-soft);color:var(--accent-ink);font-family:'JetBrains Mono',monospace;font-size:11px;font-weight:700;display:grid;place-items:center;flex-shrink:0}
.m-soap-name{flex:1;font-weight:600;font-size:13.5px}
.m-soap-chev{color:var(--mute);display:grid;place-items:center;transition:transform .15s}
.m-soap-chev svg{width:11px;height:11px;transform:rotate(90deg)}
.m-soap-chev.open svg{transform:rotate(-90deg)}
.m-soap-body{padding:0 13px 13px}
.m-soap-ta{width:100%;border:1px solid var(--line);border-radius:8px;padding:10px 12px;font-size:13px;line-height:1.75;resize:vertical;outline:none;font-family:inherit;color:var(--ink);background:#faf8f5;direction:rtl;box-sizing:border-box}
.m-soap-ta:focus{background:#fff;border-color:var(--accent)}
.m-block-btn{margin-top:6px;display:flex;align-items:center;justify-content:center;gap:6px;padding:11px;border-radius:10px;border:1px dashed var(--line);color:var(--mute);font-size:12.5px;width:100%;background:transparent;cursor:pointer;font-family:inherit}
.m-diff{background:var(--panel-2);border:1px solid var(--line);border-radius:10px;padding:11px 13px;margin-bottom:8px}
.m-diff.primary{background:linear-gradient(180deg,var(--accent-soft),var(--panel-2) 80%);border-color:var(--accent)}
.m-diff.rejected{opacity:.5}
.m-diff-top{display:flex;align-items:center;gap:8px;margin-bottom:3px}
.m-diff-title{flex:1;font-weight:600;font-size:13px;display:flex;align-items:center;gap:6px}
.m-diff-conf{font-size:12px;color:var(--ink);font-weight:600;font-family:monospace}
.m-diff-code{font-size:10.5px;color:var(--mute);margin-bottom:6px;font-family:monospace}
.m-diff-bar{height:5px;background:var(--line);border-radius:3px;overflow:hidden;margin-bottom:8px}
.m-diff-fill{height:100%;background:var(--accent);border-radius:3px}
.m-diff-actions{display:flex;gap:6px}
.m-diff-btn{padding:7px 10px;border-radius:8px;font-size:12px;font-weight:500;background:var(--panel);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;justify-content:center;gap:5px;cursor:pointer;font-family:inherit}
.m-diff-btn.pin{flex:1}
.m-diff-btn.ok,.m-diff-btn.no{width:38px}
.m-diff-btn svg{width:12px;height:12px}
.m-diff-btn.pin.on{background:var(--accent);color:#fff;border-color:var(--accent)}
.m-diff-btn.ok.on{background:var(--ink);color:#fbfaf6;border-color:var(--ink)}
.m-diff-btn.no.on{background:var(--danger-soft);color:var(--danger-ink);border-color:transparent}
.m-rx{display:flex;gap:11px;background:var(--panel-2);border:1px solid var(--line);border-radius:10px;padding:11px 12px;margin-bottom:8px}
.m-rx-pill{width:32px;height:20px;border-radius:10px;background:linear-gradient(90deg,#e8a86a 0 50%,#fff 50% 100%);border:1px solid var(--line);flex-shrink:0;margin-top:2px}
.m-rx-info{flex:1;min-width:0}
.m-rx-name{font-weight:700;font-size:13px}
.m-rx-gen{font-size:10.5px;color:var(--mute);margin-bottom:5px}
.m-rx-meta{display:flex;gap:10px;font-size:11.5px;color:var(--ink-2);flex-wrap:wrap}
.m-rx-k{font-size:9.5px;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600}
.m-ord{display:flex;align-items:center;gap:10px;padding:11px 12px;background:var(--panel-2);border:1px solid var(--line);border-radius:10px;margin-bottom:6px}
.m-ord-name{font-size:13px;font-weight:500}
.m-ord-meta{font-size:10.5px;color:var(--mute);margin-top:1px}
.m-empty{padding:24px;text-align:center;color:var(--mute-2);font-size:11.5px;background:var(--panel-2);border:1px dashed var(--line);border-radius:10px}
.m-aibar{position:absolute;left:12px;right:12px;bottom:64px;display:flex;align-items:center;gap:10px;padding:9px 11px 9px 9px;background:var(--ink);color:#fbfaf6;border-radius:14px;box-shadow:0 8px 24px rgba(28,29,26,0.18);z-index:10;cursor:pointer}
.m-aibar-dot{width:8px;height:8px;border-radius:50%;background:var(--good);box-shadow:0 0 0 3px rgba(127,205,158,.25);animation:pulse 1.6s infinite;flex-shrink:0}
.m-aibar-text{flex:1;min-width:0}
.m-aibar-l{font-size:10.5px;color:oklch(0.85 0.04 175);font-weight:600;margin-bottom:1px}
.m-aibar-s{font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.m-aibar-mic{width:34px;height:34px;border-radius:10px;background:var(--accent);color:#fff;display:grid;place-items:center;flex-shrink:0;border:none;cursor:pointer}
.m-aibar-mic svg{width:14px;height:14px}
.m-end-fab{position:absolute;bottom:8px;left:12px;right:12px;padding:13px;border-radius:12px;background:var(--danger);color:#fff;font-weight:600;font-size:14px;z-index:9;box-shadow:0 6px 20px rgba(217,87,69,.3);border:none;cursor:pointer;font-family:inherit}
.m-sheet-backdrop{position:absolute;inset:0;background:rgba(28,29,26,.45);z-index:40;display:flex;align-items:flex-end;animation:fadeIn .2s ease}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.m-sheet{width:100%;background:var(--panel-2);border-radius:18px 18px 0 0;max-height:80%;display:flex;flex-direction:column;box-shadow:0 -8px 24px rgba(0,0,0,.15);animation:slideUp .25s cubic-bezier(.2,.8,.2,1)}
@keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}
.m-sheet-grab{width:42px;height:4px;border-radius:2px;background:var(--line);margin:8px auto 0}
.m-sheet-head{display:flex;align-items:center;gap:8px;padding:8px 12px 6px}
.m-sheet-title{flex:1;font-weight:700;font-size:15px}
.m-sheet-body{flex:1;overflow-y:auto;padding:8px 14px 20px}
.m-aitabs{display:flex;gap:6px;padding:4px;background:var(--bg);border-radius:10px;margin-bottom:12px}
.m-aitab{flex:1;padding:8px;font-size:12.5px;color:var(--mute);font-weight:500;border-radius:7px;border:none;cursor:pointer;font-family:inherit;background:transparent}
.m-aitab.on{background:var(--panel-2);color:var(--ink);font-weight:600;box-shadow:0 1px 2px rgba(28,29,26,.06)}
.m-aitab-b{margin-inline-start:4px;font-size:10px;padding:1px 5px;border-radius:999px;background:var(--line);color:var(--ink-2);font-weight:600}
.m-aitab.on .m-aitab-b{background:var(--accent-soft);color:var(--accent-ink)}
.m-transcript{background:var(--bg);border:1px solid var(--line);border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12px;line-height:1.7}
.m-transcript-head{display:flex;align-items:center;gap:8px;padding-bottom:8px;border-bottom:1px solid var(--line);margin-bottom:8px}
.m-composer{margin-top:12px;display:flex;align-items:center;gap:8px;padding:8px 12px;background:var(--bg);border:1px solid var(--line);border-radius:12px;position:sticky;bottom:0}
.m-composer input{flex:1;border:0;background:transparent;outline:none;font-size:13px;font-family:inherit;direction:rtl}
.m-composer-send{width:32px;height:32px;border-radius:10px;background:var(--ink);color:#fbfaf6;display:grid;place-items:center;border:none;cursor:pointer}
.m-composer-send svg{width:13px;height:13px}
.sugg{background:var(--panel-2);border:1px solid var(--line);border-radius:var(--radius);padding:12px 13px;margin-bottom:10px}
.sugg.priority.warn{border-color:oklch(0.85 0.06 60);background:linear-gradient(180deg,var(--warn-soft),var(--panel-2) 60%)}
.sugg-head{display:flex;align-items:center;gap:8px;margin-bottom:6px}
.sugg-kind{font-size:10px;font-weight:600;letter-spacing:.04em;padding:2px 7px;border-radius:4px;background:var(--accent-soft);color:var(--accent-ink);text-transform:uppercase}
.sugg-kind.warn{background:var(--warn-soft);color:var(--warn-ink)}
.sugg-kind.soap{background:oklch(0.95 0.04 290);color:oklch(0.38 0.14 290)}
.sugg-conf{margin-inline-start:auto;font-size:11px;color:var(--mute);font-family:monospace}
.sugg-title{font-weight:600;font-size:13px;color:var(--ink);margin-bottom:4px;line-height:1.4}
.sugg-body{font-size:12.5px;color:var(--ink-2);line-height:1.65}
.sugg-evidence{margin-top:8px;padding:7px 9px;border-radius:6px;background:rgba(0,0,0,.025);border:1px dashed var(--line);font-size:11.5px;color:var(--mute);line-height:1.55}
.sugg-evidence b{color:var(--ink-2);font-weight:600}
.evidence-citations{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px}
.citation-badge{display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:999px;background:var(--accent-soft);color:var(--accent-ink);font-size:10.5px;font-weight:500;text-decoration:none;border:1px solid rgba(0,0,0,.06);cursor:pointer}
.citation-badge:hover{background:var(--accent-ink);color:#fff}
.warning-source-tag{display:inline-flex;align-items:center;gap:3px;padding:1px 6px;border-radius:4px;font-size:9.5px;font-weight:600;letter-spacing:.03em;margin-inline-start:6px;vertical-align:middle}
.warning-source-tag.rule_engine_static{background:#fff3cd;color:#7d5a00}
.warning-source-tag.rule_engine_rxnorm{background:#d1ecf1;color:#0c5460}
.warning-source-tag.rule_engine_contraindication{background:#f8d7da;color:#721c24}
.warning-source-tag.rule_engine_allergy{background:#f5c6cb;color:#721c24}
.warning-source-tag.rule_engine_openfda{background:#e2d9f3;color:#432874}
.warning-source-tag.llm{background:var(--panel-2);color:var(--mute)}
.conf-bar{display:flex;align-items:center;gap:6px;margin-top:5px}
.conf-bar-track{flex:1;height:5px;border-radius:3px;background:var(--line);overflow:hidden}
.conf-bar-fill{height:100%;border-radius:3px;transition:width .3s}
.conf-bar-label{font-size:10px;color:var(--mute);min-width:28px;text-align:right}
.sugg-actions{display:flex;gap:6px;margin-top:10px;padding-top:10px;border-top:1px solid var(--line)}
.sugg-btn{flex:1;padding:6px 10px;border-radius:6px;font-size:12px;font-weight:500;background:transparent;border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;justify-content:center;gap:5px;cursor:pointer;font-family:inherit}
.sugg-btn.accept{background:var(--ink);color:#fbfaf6;border-color:var(--ink)}
.sugg-btn svg{width:12px;height:12px}
.ts-line{margin-bottom:6px;display:flex;gap:8px;align-items:flex-start}
.ts-spk{font-size:9.5px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;padding:1px 6px;border-radius:3px;height:fit-content;line-height:1.6;flex-shrink:0;margin-top:2px}
.ts-spk.dr{background:var(--accent-soft);color:var(--accent-ink)}
.ts-spk.pt{background:#f0ebdc;color:var(--ink-2)}
.ts-text{color:var(--ink-2);flex:1;min-width:0}
.rec-dot{width:8px;height:8px;border-radius:50%;background:var(--danger);animation:pulse 1.6s infinite}
.section-h{display:flex;align-items:center;gap:8px;margin:16px 0 10px;color:var(--mute);font-size:10.5px;text-transform:uppercase;letter-spacing:.06em;font-weight:600}
.section-h::after{content:'';flex:1;height:1px;background:var(--line)}
.demo-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 14px}
.demo-item .k{font-size:10.5px;color:var(--mute-2);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:1px}
.demo-item .v{font-size:13px;color:var(--ink);font-weight:500}
.med-row{display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid var(--line-2)}
.med-row:first-child{border-top:0;padding-top:0}
.med-pill{width:30px;height:18px;border-radius:9px;background:linear-gradient(90deg,#e8a86a 0 50%,#fff 50% 100%);border:1px solid var(--line);flex-shrink:0}
.med-info{flex:1;min-width:0}
.med-info .n{font-size:12.5px;font-weight:600}
.med-info .d{font-size:10.5px;color:var(--mute);font-family:monospace}
.cond-list{display:flex;flex-wrap:wrap;gap:5px}
.cond-chip{font-size:11.5px;padding:4px 10px;border-radius:6px;background:var(--panel-2);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;gap:6px}
.history-list{display:flex;flex-direction:column;gap:10px}
.hist-item{display:grid;grid-template-columns:auto 1fr;gap:10px}
.hist-marker{width:8px;height:8px;border-radius:50%;background:var(--accent);margin-top:7px;flex-shrink:0}
.hist-title{font-size:12.5px;font-weight:600;color:var(--ink)}
.hist-meta{font-size:11px;color:var(--mute);margin-top:1px}
.hist-desc{font-size:12px;color:var(--ink-2);line-height:1.55;margin-top:3px}
.prompt-btn{display:block;width:100%;text-align:start;padding:9px 11px;margin-bottom:5px;background:var(--panel-2);border:1px solid var(--line);border-radius:8px;font-size:12px;color:var(--ink-2);cursor:pointer;font-family:inherit}
.iconbtn{width:28px;height:28px;border-radius:6px;display:grid;place-items:center;color:var(--mute);background:transparent;border:0;cursor:pointer;flex-shrink:0}
.iconbtn:hover{background:var(--line-2);color:var(--ink)}
.iconbtn.danger:hover{background:var(--danger-soft);color:var(--danger-ink)}
.iconbtn svg{width:14px;height:14px}
.med-card{display:flex;align-items:center;gap:10px;padding:11px 12px;background:var(--panel);border:1px solid var(--line-2);border-radius:10px;margin-bottom:7px}
.med-card:last-child{margin-bottom:0}
.med-card-info{flex:1;min-width:0;text-align:right}
.med-card-name{font-size:13.5px;font-weight:700;color:var(--ink)}
.med-card-dose{font-size:11.5px;color:var(--mute);margin-top:1px}
.med-warn-badge{display:inline-flex;align-items:center;gap:4px;padding:2px 7px;border-radius:999px;background:var(--warn-soft);color:var(--warn-ink);font-size:10.5px;font-weight:600;margin-top:4px}
.med-warn-badge svg{width:10px;height:10px}
.med-toggle-wrap{position:relative;cursor:pointer;flex-shrink:0}
.med-toggle-wrap input{position:absolute;opacity:0;width:0;height:0}
.med-track{width:36px;height:20px;border-radius:999px;background:var(--line-2);transition:background .2s;display:flex;align-items:center;padding:2px}
.med-toggle-wrap input:checked ~ .med-track{background:var(--good)}
.med-thumb{width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.2);transition:transform .2s;flex-shrink:0}
.med-toggle-wrap input:checked ~ .med-track .med-thumb{transform:translateX(16px)}
.med-undo-banner{display:flex;align-items:center;justify-content:space-between;padding:9px 12px;background:oklch(0.95 0.06 75);border:1px solid oklch(0.85 0.1 75);border-radius:10px;margin-bottom:8px;gap:8px;animation:fadeUp .2s ease}
.med-undo-text{font-size:12px;color:oklch(0.38 0.1 60);flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.med-undo-btn{font-size:12px;font-weight:700;color:oklch(0.38 0.1 60);background:transparent;border:none;cursor:pointer;white-space:nowrap;padding:0;font-family:inherit;flex-shrink:0}
.med-undo-btn:hover{text-decoration:underline}
.rx-row{display:grid;grid-template-columns:minmax(0,2fr) 90px 110px 100px auto;align-items:center;gap:12px;padding:11px 0;border-top:1px solid var(--line-2)}
.rx-row:first-child,.rx-row.header{border-top:0;padding-top:0}
.rx-row.header{padding-bottom:6px;border-bottom:1px solid var(--line-2);margin-bottom:6px}
.rx-name{font-weight:600;font-size:13px;display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.rx-gen{font-size:11px;color:var(--mute);margin-top:1px}
.rx-cell{font-size:12px;color:var(--ink-2);font-family:monospace}
.rx-cell.label{font-size:10.5px;color:var(--mute-2);text-transform:uppercase;letter-spacing:.06em;font-family:inherit;font-weight:600}
.rx-warn{display:inline-flex;align-items:center;gap:5px;padding:3px 8px;border-radius:999px;background:var(--warn-soft);color:var(--warn-ink);font-size:10.5px;font-weight:600}
.rx-warn svg{width:10px;height:10px}
.rx-add{margin-top:10px;display:flex;align-items:center;gap:8px;padding:11px 13px;border-radius:8px;border:1px dashed var(--line);color:var(--mute);font-size:12.5px;width:100%;justify-content:center;transition:all .12s;background:transparent;cursor:pointer;font-family:inherit}
.rx-add:hover{border-color:var(--accent);color:var(--accent-ink);background:var(--accent-soft)}
.v-micbtn{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:600;color:var(--mute);background:var(--panel-2);border:1px solid var(--line);border-radius:20px;padding:2px 8px;cursor:pointer;font-family:inherit;transition:.13s;flex-shrink:0}
.v-micbtn:hover{color:var(--danger-ink);background:var(--danger-soft);border-color:oklch(0.85 0.08 25)}
.v-micbtn.active{color:#fff;background:var(--danger);border-color:var(--danger)}
[data-soap-key]:empty:before{content:attr(data-placeholder);color:var(--mute);pointer-events:none}
`;
const $375f8776645d5aee$export$5d26717df14e8026 = `
.v-voice-scrim{
  --bg:${(0, $jTCZr.CT).bg};--panel:${(0, $jTCZr.CT).surface};--panel-2:${(0, $jTCZr.CT).surface};--line:${(0, $jTCZr.CT).border};
  --line-2:${(0, $jTCZr.CT).border2};--ink:${(0, $jTCZr.CT).ink};--ink-2:${(0, $jTCZr.CT).ink2};--mute:${(0, $jTCZr.CT).mute};
  --mute-2:${(0, $jTCZr.CT).mute2};--accent:${(0, $jTCZr.CT).accent};--accent-soft:${(0, $jTCZr.CT).accentSoft};
  --accent-ink:${(0, $jTCZr.CT).accentInk};--danger:${(0, $jTCZr.CT).danger};--danger-soft:${(0, $jTCZr.CT).dangerSoft};
}
.v-voice-scrim{position:fixed;inset:0;background:rgba(28,29,26,.5);backdrop-filter:blur(3px);z-index:400;display:grid;place-items:center;padding:20px;animation:rgFade .2s ease}
.v-fvoice{position:relative;width:440px;max-width:94vw;background:var(--panel);border-radius:20px;box-shadow:0 30px 80px rgba(28,29,26,.35);padding:30px 26px 22px;text-align:center;animation:rgPop .24s ease;direction:rtl;border:1px solid var(--line)}
.v-fvoice-close{position:absolute;top:14px;left:14px;width:30px;height:30px;border-radius:8px;display:grid;place-items:center;color:var(--mute);border:none;background:none;cursor:pointer}
.v-fvoice-close:hover{background:var(--line-2)}
.v-mic-wrap{position:relative;width:80px;height:80px;margin:0 auto 14px;display:grid;place-items:center}
.v-mic{position:relative;z-index:2;width:60px;height:60px;border-radius:50%;display:grid;place-items:center;color:#fff;background:var(--danger);box-shadow:0 8px 22px rgba(217,87,69,.35)}
.v-mic-ring{position:absolute;inset:0;border-radius:50%;border:2px solid var(--danger);opacity:0}
.v-mic-ring.r1{animation:rgRing 2s ease-out infinite}
.v-mic-ring.r2{animation:rgRing 2s ease-out .66s infinite}
.v-wave{display:flex;align-items:center;justify-content:center;gap:4px;height:36px;margin:10px 0 8px}
.v-wave span{width:4px;height:12px;border-radius:2px;background:var(--accent);animation:rgWave .9s ease-in-out infinite}
.v-transcript{margin:4px auto 0;max-width:380px;font-size:13px;line-height:1.9;color:var(--ink);min-height:44px;direction:rtl;text-align:right;background:var(--bg);border:1px solid var(--line);border-radius:10px;padding:8px 12px}
.v-confirm-btn{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:9px 20px;border-radius:10px;background:var(--ink);color:#faf7f4;font-weight:600;font-size:13px;border:none;cursor:pointer;font-family:inherit}
.v-confirm-btn:hover{background:var(--ink-2)}
.v-confirm-btn:disabled{opacity:0.45;cursor:not-allowed}
.v-wavebars{display:flex;align-items:center;justify-content:center;gap:3px;height:32px;margin:8px 0}
.v-wavebars span{width:3px;border-radius:2px;transition:.15s}
`;
const $375f8776645d5aee$export$ee258ff23bc0049f = {
    high: (0, $jTCZr.C).red,
    medium: (0, $jTCZr.C).amber,
    low: (0, $jTCZr.C).green
};
const $375f8776645d5aee$export$236de8c7b98b7ff0 = (t)=>({
        high: t('visit.severity.high'),
        medium: t('credits.level.midShort'),
        low: t('visit.severity.low')
    });
const $375f8776645d5aee$export$60d82a5be99a0a11 = {
    high: 3,
    medium: 2,
    low: 1
};
const $375f8776645d5aee$export$a20f1db6dc818677 = (s)=>{
    const v = typeof s === 'string' ? s.trim().toLowerCase() : '';
    return Object.prototype.hasOwnProperty.call($375f8776645d5aee$export$60d82a5be99a0a11, v) ? v : 'medium';
};
const $375f8776645d5aee$export$2ba0e4a723757c09 = (warnings = [])=>{
    const out = {
        high: [],
        medium: [],
        low: []
    };
    warnings.forEach((w)=>out[$375f8776645d5aee$export$a20f1db6dc818677(w?.severity)].push(w));
    return out;
};
const $375f8776645d5aee$export$9ad745a931ba51ed = (warnings = [])=>{
    let best = null;
    warnings.forEach((w)=>{
        const s = $375f8776645d5aee$export$a20f1db6dc818677(w?.severity);
        if (!best || $375f8776645d5aee$export$60d82a5be99a0a11[s] > $375f8776645d5aee$export$60d82a5be99a0a11[best]) best = s;
    });
    return best;
};
const $375f8776645d5aee$export$73a34cab37d00ce4 = (rxItems = [], conditionsKey = '')=>`${rxItems.map((r)=>r?.drug?.id).join('|')}#${conditionsKey}`;
const $375f8776645d5aee$export$ead65992cf57cabf = (patient, acceptedDiagnoses = [])=>({
        conditions: [
            ...(patient?.clinicalConditions || []).map((c)=>c?.display),
            ...acceptedDiagnoses || [],
            ...$375f8776645d5aee$export$5176433c16ff5a4(patient?.clinicalObservations)
        ].filter(Boolean),
        allergies: (patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean)
    });
const $375f8776645d5aee$export$1e5ddc066f5dd4da = (rxItems, patient, acceptedDiagnoses = [])=>{
    const count = (rxItems || []).length;
    if (!patient?.id || count === 0) return false;
    if (count >= 2) return true;
    const { conditions: conditions, allergies: allergies } = $375f8776645d5aee$export$ead65992cf57cabf(patient, acceptedDiagnoses);
    return conditions.length > 0 || allergies.length > 0;
};
// ── Icon set — lucide-react (§1.1). `mk` preserves the legacy `<I.x width={n}
// height={n} />` call-site API by mapping width/height onto lucide's `size`, so
// the ~30 icon references across Visit.web.jsx keep working unchanged. ───────────
const $375f8776645d5aee$var$mk = (Lucide)=>{
    const Wrapped = ({ width: width, height: height, size: size, strokeWidth: strokeWidth, ...p })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Lucide, {
            size: size ?? width ?? height ?? 16,
            strokeWidth: strokeWidth ?? 1.75,
            "aria-hidden": true,
            ...p
        });
    return Wrapped;
};
const $375f8776645d5aee$export$9bb611d729802a56 = {
    dash: $375f8776645d5aee$var$mk((0, $b8deaef2bfa57b80$export$2e2bcd8739ae039)),
    users: $375f8776645d5aee$var$mk((0, $6imzq.default)),
    cal: $375f8776645d5aee$var$mk((0, $4980c56854bb97ce$export$2e2bcd8739ae039)),
    chart: $375f8776645d5aee$var$mk((0, $828bf11fc38b9d89$export$2e2bcd8739ae039)),
    cog: $375f8776645d5aee$var$mk((0, $53qqr.default)),
    doc: $375f8776645d5aee$var$mk((0, $3FyOw.default)),
    sparkle: $375f8776645d5aee$var$mk((0, $chm1L.default)),
    ai: $375f8776645d5aee$var$mk((0, $chm1L.default)),
    stop: $375f8776645d5aee$var$mk((0, $7udIf.default)),
    mic: $375f8776645d5aee$var$mk((0, $hSPBf.default)),
    send: $375f8776645d5aee$var$mk((0, $6OGKD.default)),
    check: $375f8776645d5aee$var$mk((0, $huNwV.default)),
    x: $375f8776645d5aee$var$mk((0, $6TdpC.default)),
    plus: $375f8776645d5aee$var$mk((0, $8g4t5.default)),
    edit: $375f8776645d5aee$var$mk((0, $aGlWN.default)),
    bolt: $375f8776645d5aee$var$mk((0, $4b055447143d8b14$export$2e2bcd8739ae039)),
    trend: $375f8776645d5aee$var$mk((0, $4aa5203766da4495$export$2e2bcd8739ae039)),
    flask: $375f8776645d5aee$var$mk((0, $4CVxl.default)),
    pill: $375f8776645d5aee$var$mk((0, $aVx4q.default)),
    arrow: $375f8776645d5aee$var$mk((0, $kzPvP.default)),
    alert: $375f8776645d5aee$var$mk((0, $QG9Z3.default)),
    history: $375f8776645d5aee$var$mk((0, $9c3425eadfb41de5$export$2e2bcd8739ae039)),
    notes: $375f8776645d5aee$var$mk((0, $ggYuf.default)),
    link: $375f8776645d5aee$var$mk((0, $899acbe55afec07f$export$2e2bcd8739ae039)),
    ref: $375f8776645d5aee$var$mk((0, $d8YVq.default)),
    more: $375f8776645d5aee$var$mk((0, $7c47b6817ea26fcd$export$2e2bcd8739ae039)),
    trash: $375f8776645d5aee$var$mk((0, $lpOUO.default)),
    search: $375f8776645d5aee$var$mk((0, $e5Ore.default)),
    back: $375f8776645d5aee$var$mk((0, $gKFEi.default)),
    close: $375f8776645d5aee$var$mk((0, $6TdpC.default)),
    save: $375f8776645d5aee$var$mk((0, $2fbfeb4276877a84$export$2e2bcd8739ae039)),
    reload: $375f8776645d5aee$var$mk((0, $bF8pu.default)),
    scan: $375f8776645d5aee$var$mk((0, $6828da86e4d4e8df$export$2e2bcd8739ae039)),
    steth: $375f8776645d5aee$var$mk((0, $fX0JO.default)),
    clock: $375f8776645d5aee$var$mk((0, $kMJsW.default)),
    clinic: $375f8776645d5aee$var$mk((0, $20b80355eea4425a$export$2e2bcd8739ae039)),
    upload: $375f8776645d5aee$var$mk((0, $f3ac79315652b37f$export$2e2bcd8739ae039)),
    shield: $375f8776645d5aee$var$mk((0, $bo0GS.default)),
    info: $375f8776645d5aee$var$mk((0, $97xXr.default))
};
const $375f8776645d5aee$export$c63347898143db2f = ({ data: data, alert: alert })=>{
    const w = 32, h = 10;
    const max = Math.max(...data, 1);
    const min = Math.min(...data, 0);
    const pts = data.map((d, i)=>{
        const x = i / (data.length - 1) * w;
        const y = h - (d - min) / (max - min || 1) * h;
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${w} ${h}`,
        width: w,
        height: h
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: pts,
        fill: "none",
        stroke: alert ? (0, $jTCZr.C).red : (0, $jTCZr.C).teal,
        strokeWidth: "1.2"
    }));
};
const $375f8776645d5aee$export$b04be29aa201d4f5 = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
            marginBottom: 6,
            ...style
        }
    }, children);
const $375f8776645d5aee$export$60332b2344f7fe41 = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, children);
const $375f8776645d5aee$export$37f54d0b7407611f = ({ children: children, onClick: onClick, color: color, disabled: disabled, style: style, size: size = 'md' })=>{
    const pad = size === 'sm' ? '5px 12px' : size === 'lg' ? '11px 24px' : '8px 18px';
    const fs = size === 'sm' ? 12 : size === 'lg' ? 15 : 13;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        disabled: disabled,
        style: {
            background: color || (0, $jTCZr.C).navy,
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: pad,
            fontSize: fs,
            fontWeight: 600,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? .55 : 1,
            transition: 'all .15s',
            fontFamily: 'inherit',
            ...style
        }
    }, children);
};
const $375f8776645d5aee$export$3288d34c523a1192 = ({ children: children, color: color, bg: bg })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            background: bg || (0, $jTCZr.C).tealLight,
            color: color || (0, $jTCZr.C).teal,
            fontSize: 11,
            fontWeight: 600,
            padding: '2px 8px',
            borderRadius: 20
        }
    }, children);
const $375f8776645d5aee$export$7f7cbe89f1eacd2 = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            border: '2px solid rgba(255,255,255,.3)',
            borderTopColor: '#fff',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            display: 'inline-block'
        }
    });
const $375f8776645d5aee$export$68595c7f7403ce8d = 30;
const $375f8776645d5aee$export$e72eedeb22c02c24 = 2;
// Pages survive the component. The Rx panel is `{workTab === 'rx' && …}`, so
// glancing at «دستورات» unmounts the picker; without this, coming back re-runs
// a fetch the doctor already waited for. Bounded, because it is a session-long
// module global rather than a per-request cache.
const $375f8776645d5aee$var$DRUG_CACHE_LIMIT = 60;
const $375f8776645d5aee$var$drugCache = new Map();
const $375f8776645d5aee$var$cacheGet = (key)=>{
    const hit = $375f8776645d5aee$var$drugCache.get(key);
    if (!hit) return null;
    $375f8776645d5aee$var$drugCache.delete(key); // re-insert: Map iterates in insertion order, so
    $375f8776645d5aee$var$drugCache.set(key, hit); // the oldest key is the first one evicted.
    return hit;
};
const $375f8776645d5aee$var$cachePut = (key, value)=>{
    $375f8776645d5aee$var$drugCache.set(key, value);
    if ($375f8776645d5aee$var$drugCache.size > $375f8776645d5aee$var$DRUG_CACHE_LIMIT) $375f8776645d5aee$var$drugCache.delete($375f8776645d5aee$var$drugCache.keys().next().value);
};
const $375f8776645d5aee$export$2d42b44329a671d = ()=>$375f8776645d5aee$var$drugCache.clear();
// Asked for `taminListed`, and without it of a BFF that predates the field.
const $375f8776645d5aee$var$askDrugs = (0, $8d8ac6402cc7b03c$export$405a623d7e907e9d)((0, $adebb901af88e18b$export$7fb4864174f056c));
async function $375f8776645d5aee$export$66192a3e729ccb0d({ query: query = '', category: category = '', offset: offset = 0 } = {}) {
    const q = query.trim();
    if (q && q.length < $375f8776645d5aee$export$e72eedeb22c02c24) return {
        drugs: [],
        total: 0
    };
    const key = `${q}\u0000${category}\u0000${offset}`;
    const hit = $375f8776645d5aee$var$cacheGet(key);
    if (hit) return hit;
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$e94eea18383a4188, {
        query: q || null,
        category: category || null,
        limit: $375f8776645d5aee$export$68595c7f7403ce8d,
        offset: offset
    });
    const page = {
        drugs: data.listDrugs?.drugs || [],
        total: data.listDrugs?.total || 0
    };
    $375f8776645d5aee$var$cachePut(key, page);
    return page;
}
async function $375f8776645d5aee$export$9b2f95caa9aaf04d(limit = 12) {
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$64bb5ba76d2f107b, {
        limit: limit
    });
    return (data.myFrequentDrugs || []).filter((f)=>f?.drug?.id || f?.search);
}
async function $375f8776645d5aee$export$668a72b79cec9ed7(ids) {
    const wanted = [
        ...new Set((ids || []).map((id)=>String(id || '').trim()).filter(Boolean))
    ];
    if (!wanted.length) return [];
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$b3499ea44c0870d9, {
        ids: wanted,
        limit: wanted.length
    });
    return (data?.listDrugs?.drugs || []).filter((d)=>wanted.includes(d?.id));
}
// A name as the drug list matches it: one letterform for ي/ك, digits as ASCII,
// no spaces or ZWNJ («آموکسی‌سیلین» and «آموکسی سیلین» are one name), no case.
const $375f8776645d5aee$var$drugNameKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s\u200c]+/g, '').toLowerCase();
function $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, ...names) {
    const keys = new Set(names.map($375f8776645d5aee$var$drugNameKey).filter(Boolean));
    if (!keys.size) return null;
    const hits = new Map();
    for (const d of drugs || [])if (d?.id && (keys.has($375f8776645d5aee$var$drugNameKey(d.name)) || keys.has($375f8776645d5aee$var$drugNameKey(d.genericName)))) hits.set(d.id, d);
    return hits.size === 1 ? [
        ...hits.values()
    ][0] : null;
}
async function $375f8776645d5aee$export$3f253215194ac0f3(name) {
    const q = String(name || '').trim();
    if (q.length < $375f8776645d5aee$export$e72eedeb22c02c24) return null;
    const { drugs: drugs, total: total } = await $375f8776645d5aee$export$66192a3e729ccb0d({
        query: q
    });
    return $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, q) || (total === 1 && drugs.length === 1 ? drugs[0] : null);
}
async function $375f8776645d5aee$export$dcced24b144b6c10(src) {
    const own = {
        name: src.name,
        genericName: src.genericName || '',
        category: '',
        commonDosages: src.dosage ? [
            src.dosage
        ] : [],
        commonFrequencies: src.frequency ? [
            src.frequency
        ] : []
    };
    if (src.drugId) {
        try {
            const [hit] = await $375f8776645d5aee$export$668a72b79cec9ed7([
                src.drugId
            ]);
            if (hit) return hit;
        } catch (e) {
            console.warn('[rx] refill lookup by id failed:', e.message);
        }
        return {
            id: src.drugId,
            ...own
        };
    }
    try {
        const { drugs: drugs } = await $375f8776645d5aee$export$66192a3e729ccb0d({
            query: src.name
        });
        const match = $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, src.name, src.genericName);
        if (match) return match;
    } catch (e) {
        // A lookup failure is a refill that keeps the doctor's own text, not a
        // refill that fails.
        console.warn('[rx] refill lookup failed:', e.message);
    }
    return {
        id: `refill-med-${src.name}`,
        ...own
    };
}
const $375f8776645d5aee$export$a6616cb9d478340f = (value, readsPersianData, t)=>readsPersianData ? value : (0, $ace44487380106d3$export$6742958aefab4338)(value, t) || (0, $f91797fd10151718$export$faf0542505380f3e)(value);
function $375f8776645d5aee$export$cbaf757fd313ab43({ drug: drug, insurer: insurer, both: both = false, listed: given, testid: testid, size: size = 9.5, hint: hint }) {
    const { t: t } = (0, $LNQP4.default)();
    const listed = given !== undefined ? given : (0, $ace44487380106d3$export$60f8cb686aa6701e)(drug, insurer);
    if (listed === null || listed && !both) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid || `visit-rx-coverage-${drug.id}`,
        "data-listed": listed ? 'true' : 'false',
        title: listed ? undefined : hint || t('visit.rx.coverage.outTaminHint'),
        style: {
            fontSize: size,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            background: listed ? (0, $jTCZr.CT).goodSoft : (0, $jTCZr.CT).warnSoft,
            color: listed ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
        }
    }, listed ? t('visit.rx.coverage.inTamin') : t('visit.rx.coverage.outTamin'));
}
// «در فهرست تأمین» for an ORDER (K1, 2026-10-07). The catalogue says it per row
// (taminListed — the BFF applies the e-prescription send's own rule); like a
// drug's, it means something only for a تأمین patient.
const $375f8776645d5aee$var$TAMIN_ORDER_TYPES = new Set([
    'lab',
    'imaging',
    'dental_lab'
]);
const $375f8776645d5aee$export$ff0b3160d2d98f35 = (row, insurer)=>insurer === 'tamin' && typeof row?.taminListed === 'boolean' ? row.taminListed : null;
function $375f8776645d5aee$export$467168533c33d9ca(order, resolved, insurer) {
    if (insurer !== 'tamin' || !$375f8776645d5aee$var$TAMIN_ORDER_TYPES.has(order?.orderType) || order?.status === 'cancelled') return null;
    if (!order.catalogId) return false;
    return $375f8776645d5aee$export$ff0b3160d2d98f35(resolved?.get?.(order.catalogId), insurer);
}
function $375f8776645d5aee$export$41198ed546152d40(item, t, readsPersianData) {
    if (!item) return '';
    return [
        item.dosage && $375f8776645d5aee$export$a6616cb9d478340f(item.dosage, readsPersianData, t),
        item.frequency && (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(item.frequency, t),
        item.route && (0, $ace44487380106d3$export$80ace2b99405d272)(item.route, t),
        item.duration && t('visit.rx.forDuration', {
            duration: item.duration
        }),
        item.quantity
    ].filter(Boolean).join(" \xb7 ");
}
function $375f8776645d5aee$export$564a716e7cf1f53f({ item: item, onChange: onChange, onRemove: onRemove, insurer: insurer, erxLine: erxLine }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const { drug: drug, dosage: dosage, frequency: frequency, route: route, duration: duration, quantity: quantity, instructions: instructions, templateTitle: templateTitle } = item;
    const names = (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(drug);
    const [editing, setEditing] = (0, $acw62.useState)(false);
    // دوز and تناوب are CLOSED lists (lib/rxOptions.js): the e-prescription sends
    // them as codes, and the formulary's own suggestions («5 MG», «daily») were
    // refused on every line (K1, 2026-09-30). The same controls as the picker's add
    // bar, so a line is written the same way wherever it is written.
    const listId = `rx-opts-${item.id}`;
    // `labelFor` translates what the reader SEES without touching what is stored.
    // The input still receives the option's `value`, so a frequency picked from
    // the list is written to the record in Persian exactly as before — which is
    // what the pharmacy reads and what every stored prescription already holds.
    // Omitted for a Persian reader, so their markup is unchanged.
    const field = (key, val, opts, placeholder, width, labelFor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                minWidth: 0,
                ...width ? {
                    width: width
                } : {
                    flex: 1
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: $375f8776645d5aee$export$6897efa034860c56,
            htmlFor: `${listId}-${key}`
        }, placeholder), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            id: `${listId}-${key}`,
            list: opts?.length ? `${listId}-${key}-list` : undefined,
            value: val || '',
            onChange: (e)=>onChange(key, e.target.value),
            placeholder: placeholder,
            "data-testid": `visit-rx-field-${key}`,
            style: {
                ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
                padding: '6px 9px',
                fontSize: 12
            }
        }), opts?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("datalist", {
            id: `${listId}-${key}-list`
        }, opts.map((o)=>{
            const shown = labelFor ? labelFor(o) : o;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: o,
                value: o,
                ...shown !== o ? {
                    label: shown
                } : {}
            });
        })));
    const withCurrent = (opts, cur)=>cur && !opts.includes(cur) ? [
            cur,
            ...opts
        ] : opts;
    const shownRoute = (0, $ace44487380106d3$export$1aea987f77fa496a)(route) || route;
    const choice = (key, val, opts, placeholder, width, labelFor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                minWidth: 0,
                ...width ? {
                    width: width
                } : {
                    flex: 1
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: $375f8776645d5aee$export$6897efa034860c56,
            htmlFor: `${listId}-${key}`
        }, placeholder), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
            id: `${listId}-${key}`,
            value: val || '',
            onChange: (e)=>onChange(key, e.target.value),
            "data-testid": `visit-rx-field-${key}`,
            style: {
                ...$375f8776645d5aee$export$775ae08e7b0fd486,
                padding: '6px 9px',
                fontSize: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: ""
        }, placeholder), opts.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: o,
                value: o
            }, labelFor ? labelFor(o) : o))));
    // A line's details — دوز، تناوب، نحوه مصرف، مدت، تعداد — in the page's own
    // typeface at a size that reads at arm's length. They used to be 10px in a
    // monospace face, which has no Persian glyphs of its own: the browser spaced
    // a fallback font's letters apart and the words came out as «ر و ز ی   ی ک».
    // `strong` is the count: the one number a pharmacy dispenses by.
    const chip = (text, key, strong = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: key,
            "data-rx-detail": key,
            style: {
                fontSize: 12,
                fontWeight: strong ? 700 : 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                color: strong ? 'var(--accent-ink)' : 'var(--ink)',
                background: strong ? 'var(--accent-soft)' : 'var(--panel-2)',
                whiteSpace: 'nowrap',
                flexShrink: 0
            }
        }, text);
    if (editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-card-${item.id}`,
        "data-editing": "true",
        style: {
            background: 'var(--panel)',
            border: '1.5px solid var(--accent)',
            borderRadius: 10,
            padding: '10px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            animation: 'fadeUp .15s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.pill, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: 12.5,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: 10.5,
            color: 'var(--mute-2)'
        }
    }, names.secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>setEditing(false),
        title: t('common.actions.confirm'),
        "data-testid": `visit-rx-confirm-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: onRemove,
        title: t('common.actions.delete'),
        "aria-label": t('visit.rx.removeAria', {
            name: (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(drug)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            alignItems: 'flex-end'
        }
    }, choice('dosage', dosage, (0, $ace44487380106d3$export$23fceca71987facd)(drug, dosage), t('visit.rx.dose'), 130, (v)=>$375f8776645d5aee$export$a6616cb9d478340f(v, readsPersianData, t)), choice('frequency', frequency, (0, $ace44487380106d3$export$ac4b3f6873c02e40)(frequency), t('visit.rx.frequency'), 150, (v)=>(0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(v, t)), choice('route', shownRoute, withCurrent($375f8776645d5aee$export$e730a0734bbb1219(), shownRoute), t('visit.rx.route'), 130, (v)=>(0, $ace44487380106d3$export$80ace2b99405d272)(v, t)), choice('duration', duration, withCurrent($375f8776645d5aee$export$74f6a832d246e098(t), duration), t('visit.rx.duration'), 120), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: 0,
            width: 110
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: $375f8776645d5aee$export$6897efa034860c56,
        htmlFor: `${listId}-quantity`
    }, t('visit.rx.quantity')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: `${listId}-quantity`,
        inputMode: "numeric",
        value: quantity || '',
        onChange: (e)=>onChange('quantity', (0, $5JYPc.toEnDigits)(e.target.value).replace(/[^\d]/g, '')),
        placeholder: t('visit.rx.quantity'),
        "data-testid": "visit-rx-field-quantity",
        style: {
            ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
            padding: '6px 9px',
            fontSize: 12
        }
    }))), field('instructions', instructions, $375f8776645d5aee$export$7be9a8bfe9895054(t), t('visit.rx.instructions')));
    const missing = (0, $ace44487380106d3$export$e9b4e5de48a21156)(item);
    const chips = [
        dosage && chip($375f8776645d5aee$export$a6616cb9d478340f(dosage, readsPersianData, t), 'd'),
        frequency && chip((0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(frequency, t), 'f'),
        route && chip((0, $ace44487380106d3$export$80ace2b99405d272)(route, t), 'r'),
        duration && chip(t('visit.rx.forDuration', {
            duration: duration
        }), 'u'),
        // A bare «7» at the end of a line says nothing; «تعداد 7» is the count. A
        // count written with its own unit («۲۱ عدد», a refilled older line) already
        // says what it is and is shown as written.
        quantity && chip(/^[\d۰-۹٠-٩]+$/.test(String(quantity).trim()) ? t('visit.rx.quantityCount', {
            n: quantity
        }) : quantity, 'q', true)
    ].filter(Boolean);
    // Two lines: the drug's name, then its details. On one line the details were
    // squeezed to 10px to fit beside a long product name, and clipped when they
    // still did not; on their own line they wrap instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-card-${item.id}`,
        style: {
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '9px 10px',
            animation: 'fadeUp .2s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 8,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.pill, {
        width: 15,
        height: 15
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 8,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: 13,
            fontWeight: 700,
            color: 'var(--ink)',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '0 1 auto',
            minWidth: 0
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: 11.5,
            color: 'var(--ink-2)',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '0 2 auto',
            minWidth: 0
        }
    }, names.secondary), templateTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: templateTitle,
        style: {
            fontSize: 10.5,
            fontWeight: 600,
            color: 'var(--ink-2)',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            padding: '0 6px',
            borderRadius: 4,
            lineHeight: '18px',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            maxWidth: 140,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, templateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-details-${item.id}`,
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            minWidth: 0
        }
    }, chips, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$cbaf757fd313ab43, {
        drug: drug,
        insurer: insurer
    }), item.aiNote !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-ai-mark-${item.id}`,
        title: item.aiNote || undefined,
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: 'oklch(0.38 0.14 290)',
            background: 'oklch(0.97 0.02 290)',
            border: '1px solid oklch(0.87 0.06 290)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, t('visit.rx.directions.badge')), missing.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-incomplete-${item.id}`,
        "data-missing": missing.join(' '),
        title: t('visit.rx.incompleteHint'),
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--warn-ink)',
            background: 'var(--warn-soft)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, (0, $ace44487380106d3$export$ab36a14ecd73702e)(missing, t)), item.removeFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-remove-failed-${item.id}`,
        title: t('visit.rx.removeFailedHint'),
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--danger-ink)',
            background: 'var(--danger-soft)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, t('visit.rx.removeFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$a8584f59cd36e423), {
        line: erxLine,
        testid: `visit-rx-erx-state-${item.id}`
    }), instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: 12,
            color: 'var(--ink-2)',
            lineHeight: '22px',
            overflowWrap: 'anywhere',
            minWidth: 0
        }
    }, instructions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>setEditing(true),
        title: t('common.actions.edit'),
        "data-testid": `visit-rx-edit-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.edit, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: onRemove,
        title: t('common.actions.delete'),
        "aria-label": t('visit.rx.removeAria', {
            name: (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(drug)
        }),
        "data-testid": `visit-rx-remove-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })));
}
function $375f8776645d5aee$export$fed3aff69bf06eb1({ m: m, clr: clr, bg: bg, last: last, prev: prev, sorted: sorted }) {
    const { formatDate: formatDate } = (0, $LNQP4.default)();
    const [hovIdx, setHovIdx] = (0, $acw62.useState)(null);
    const delta = prev != null ? +(last.value - prev.value).toFixed(1) : null;
    const arrow = delta === null ? null : delta > 0 ? "\u2191" : delta < 0 ? "\u2193" : "\u2192";
    const W = 90, H = 38;
    let sparkEl = null;
    if (sorted.length >= 2) {
        const vals = sorted.map((p)=>p.value);
        const minV = Math.min(...vals), maxV = Math.max(...vals);
        const vR = maxV - minV || 1;
        const n = sorted.length - 1;
        const xOf = (i)=>4 + i / n * (W - 8);
        const yOf = (v)=>4 + (H - 8) - (v - minV) / vR * (H - 8);
        const pts = sorted.map((p, i)=>`${xOf(i).toFixed(1)},${yOf(p.value).toFixed(1)}`).join(' ');
        const hov = hovIdx !== null ? sorted[hovIdx] : null;
        const tipW = 60, tipH = 26;
        const tipX = hov ? Math.min(Math.max(xOf(hovIdx) - tipW / 2, 0), W - tipW) : 0;
        const rawTipY = hov ? yOf(hov.value) - tipH - 5 : 0;
        const tipY = rawTipY < -10 ? hov ? yOf(hov.value) + 5 : 0 : rawTipY;
        const dateStr = hov ? formatDate(hov.date, 'dayMonth') : '';
        sparkEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: `0 0 ${W} ${H}`,
            width: W,
            height: H,
            style: {
                display: 'block',
                overflow: 'visible'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: pts,
            fill: "none",
            stroke: clr,
            strokeWidth: 1.5,
            strokeLinejoin: "round",
            strokeOpacity: 0.7
        }), sorted.map((p, i)=>{
            const isl = i === sorted.length - 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: i,
                cx: xOf(i),
                cy: yOf(p.value),
                r: hovIdx === i ? 4 : isl ? 3 : 1.8,
                fill: hovIdx === i || isl ? clr : 'var(--panel-2)',
                stroke: clr,
                strokeWidth: 1.2,
                style: {
                    cursor: 'crosshair'
                },
                onMouseEnter: ()=>setHovIdx(i),
                onMouseLeave: ()=>setHovIdx(null)
            });
        }), hov && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            style: {
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            x: tipX,
            y: tipY,
            width: tipW,
            height: tipH,
            rx: 5,
            fill: "var(--ink)",
            opacity: 0.9
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: tipX + tipW / 2,
            y: tipY + 10,
            textAnchor: "middle",
            fill: "white",
            fontSize: 9,
            fontWeight: 700,
            fontFamily: "inherit"
        }, hov.value, " ", m.unit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: tipX + tipW / 2,
            y: tipY + 20,
            textAnchor: "middle",
            fill: "rgba(255,255,255,.65)",
            fontSize: 8,
            fontFamily: "inherit"
        }, dateStr)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: bg,
            border: `1px solid ${clr}22`,
            borderRadius: 10,
            padding: '10px 11px',
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            fontWeight: 700,
            color: clr,
            letterSpacing: '.02em'
        }
    }, m.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: clr,
            opacity: .7,
            fontWeight: 600
        }
    }, m.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 22,
            fontWeight: 800,
            color: clr,
            lineHeight: 1,
            fontVariantNumeric: 'tabular-nums'
        }
    }, last.value), arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: clr,
            opacity: .8
        }
    }, arrow, Math.abs(delta))), sparkEl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4
        }
    }, sparkEl));
}
const $375f8776645d5aee$export$f5b2122ece54afe9 = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
const $375f8776645d5aee$export$e7c7d59bbcc29ee1 = {
    bpSys: '8480-6',
    bpDia: '8462-4',
    pulse: '8867-4',
    spo2: '59408-5',
    temp: '8310-5',
    weight: '29463-7'
};
const $375f8776645d5aee$export$ccc2c13eb48542b9 = ()=>({
        bpSys: '',
        bpDia: '',
        pulse: '',
        spo2: '',
        temp: '',
        weight: ''
    });
const $375f8776645d5aee$export$8c63808338caf15c = (raw)=>{
    const v = (0, $5JYPc.toEnDigits)(raw ?? '').replace(/[٫,]/g, '.').replace(/[^\d.]/g, '');
    const i = v.indexOf('.');
    return i < 0 ? v : v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
};
function $375f8776645d5aee$export$1e5a39e00c998387(observations, encounterId) {
    const values = $375f8776645d5aee$export$ccc2c13eb48542b9();
    const ids = [];
    if (!encounterId) return {
        values: values,
        ids: ids,
        recorded: false
    };
    const key = String(encounterId);
    const mine = (observations || []).filter((o)=>o.appointmentId && String(o.appointmentId) === key);
    for (const [field, code] of Object.entries($375f8776645d5aee$export$e7c7d59bbcc29ee1)){
        const matches = mine.filter((o)=>o.code === code).sort((a, b)=>(b.effectiveDate || b.createdAt || '').localeCompare(a.effectiveDate || a.createdAt || ''));
        if (!matches.length) continue;
        values[field] = matches[0].value ?? '';
        for (const m of matches)if (m.id) ids.push(m.id);
    }
    return {
        values: values,
        ids: ids,
        recorded: Object.values(values).some((v)=>v !== '' && v != null)
    };
}
const $375f8776645d5aee$export$c6702e128b41d3a7 = {
    'X-Ray': '#6b7280',
    'US': '#0891b2',
    'CT': '#7c3aed',
    'MRI': '#be185d',
    'Echo': '#0f766e',
    'Doppler': '#0369a1',
    'DEXA': '#92400e',
    'Nuclear': '#9f1239',
    'Mammography': '#6d28d9',
    'Angio': '#b45309'
};
const $375f8776645d5aee$export$792cf12450c08f12 = (t)=>({
        stat: {
            label: t('common.urgency.stat'),
            bg: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        },
        urgent: {
            label: t('common.urgency.urgent'),
            bg: 'var(--warn-soft)',
            color: 'oklch(0.42 0.12 50)'
        },
        routine: {
            label: t('common.urgency.routine'),
            bg: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    });
const $375f8776645d5aee$export$e867161a6e6ed178 = (t)=>({
        lab: t('visit.orders.lab'),
        imaging: t('patient.orderType.imaging'),
        procedure: t('visit.orders.therapeutic'),
        referral: t('visit.orders.referral'),
        other: t('common.state.other')
    });
const $375f8776645d5aee$export$ba9a3a2cefb281d = {
    lab: 'flask',
    imaging: 'scan',
    procedure: 'steth',
    referral: 'ref',
    other: 'doc'
};
const $375f8776645d5aee$export$937baa5a2896e852 = new Set([
    'lab',
    'imaging'
]);
const $375f8776645d5aee$export$a4db75a9928d8ae7 = (orderType)=>$375f8776645d5aee$export$937baa5a2896e852.has(orderType);
const $375f8776645d5aee$export$97da64870f5585b8 = {
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    borderRadius: 'var(--radius-lg)',
    boxShadow: 'var(--shadow)',
    overflow: 'hidden'
};
const $375f8776645d5aee$export$10c499a234e299a6 = {
    padding: '12px 16px',
    borderBottom: '1px solid var(--line-2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    background: 'var(--field)'
};
const $375f8776645d5aee$export$a931407aa8dfff78 = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontWeight: 600,
    fontSize: 13,
    color: 'var(--ink)'
};
const $375f8776645d5aee$export$7b8c3b54c8233354 = {
    width: 22,
    height: 22,
    borderRadius: 6,
    background: 'var(--accent-soft)',
    color: 'var(--accent-ink)',
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0
};
const $375f8776645d5aee$export$8fe483d880a02f5f = {
    fontSize: 10,
    background: 'var(--line)',
    color: 'var(--ink-2)',
    padding: '1px 6px',
    borderRadius: 4,
    fontWeight: 600
};
const $375f8776645d5aee$export$4e02c9f6bbae01b0 = {
    background: 'var(--panel)',
    border: '1px solid var(--line)',
    borderRadius: 10,
    padding: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 10
};
const $375f8776645d5aee$export$6897efa034860c56 = {
    fontSize: 11,
    color: 'var(--mute)',
    fontWeight: 500
};
const $375f8776645d5aee$export$d4e2cf4ef3f8061 = {
    border: '1px solid var(--line)',
    borderRadius: 7,
    padding: '8px 11px',
    fontSize: 13,
    fontFamily: 'inherit',
    outline: 'none',
    color: 'var(--ink)',
    background: 'var(--field)',
    boxSizing: 'border-box',
    width: '100%'
};
const $375f8776645d5aee$export$775ae08e7b0fd486 = {
    ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
    padding: '7px 10px',
    fontSize: 12.5,
    cursor: 'pointer'
};
const $375f8776645d5aee$export$739e6a3f924c37ce = (effect, t)=>({
        supports: {
            label: t('visit.copilot.vitalImpact.supports'),
            tone: 'good'
        },
        contradicts: {
            label: t('visit.copilot.vitalImpact.contradicts'),
            tone: 'danger'
        },
        neutral: {
            label: t('visit.copilot.vitalImpact.neutral'),
            tone: 'mute'
        }
    })[effect] || {
        label: t('visit.copilot.vitalImpact.neutral'),
        tone: 'mute'
    };
const $375f8776645d5aee$export$4a255e08a08267a2 = `query($appointmentId:ID){getClinicalOrderCatalog(appointmentId:$appointmentId){labTests{id name nameEn nameAr loincCode category inHouse}imagingStudies{id name nameEn nameAr modality bodyPart category inHouse}procedures{id name nameEn nameAr code category inHouse}}}`;
const $375f8776645d5aee$export$bfb5df55ff94459 = 30;
const $375f8776645d5aee$export$6770277ab0ca292e = 2;
const $375f8776645d5aee$var$ORDER_CACHE_LIMIT = 60;
const $375f8776645d5aee$var$orderCatalogCache = new Map();
const $375f8776645d5aee$var$orderCacheGet = (key)=>{
    const hit = $375f8776645d5aee$var$orderCatalogCache.get(key);
    if (!hit) return null;
    $375f8776645d5aee$var$orderCatalogCache.delete(key); // re-insert so the oldest key evicts first
    $375f8776645d5aee$var$orderCatalogCache.set(key, hit);
    return hit;
};
const $375f8776645d5aee$var$orderCachePut = (key, value)=>{
    $375f8776645d5aee$var$orderCatalogCache.set(key, value);
    if ($375f8776645d5aee$var$orderCatalogCache.size > $375f8776645d5aee$var$ORDER_CACHE_LIMIT) $375f8776645d5aee$var$orderCatalogCache.delete($375f8776645d5aee$var$orderCatalogCache.keys().next().value);
};
const $375f8776645d5aee$export$e06d85e1fea83f6b = ()=>$375f8776645d5aee$var$orderCatalogCache.clear();
const $375f8776645d5aee$export$14a88ef3dbc10c6b = `query($query:String,$orderType:String,$appointmentId:ID,$limit:Int,$offset:Int){searchClinicalOrderCatalog(query:$query,orderType:$orderType,appointmentId:$appointmentId,limit:$limit,offset:$offset){total entries{id orderType name nameEn nameAr category code codeSystem modality bodyPart inHouse isClinicOwned taminListed}}}`;
const $375f8776645d5aee$export$5b0044a5c8c756be = `query($ids:[ID!],$names:[String!],$orderType:String,$appointmentId:ID){resolveClinicalCatalogEntries(ids:$ids,names:$names,orderType:$orderType,appointmentId:$appointmentId){id matchedName orderType name nameEn category code codeSystem inHouse taminListed}}`;
// A BFF that predates `taminListed` (K1, 2026-10-07) is asked the same two
// questions without it: an environment whose BFF lags its client keeps a
// working picker, without the flag.
const $375f8776645d5aee$var$askCatalog = (0, $8d8ac6402cc7b03c$export$405a623d7e907e9d)((0, $adebb901af88e18b$export$7fb4864174f056c));
async function $375f8776645d5aee$export$14e053085c2b7017({ query: query = '', orderType: orderType = '', appointmentId: appointmentId = null, offset: offset = 0 } = {}) {
    const q = (query || '').trim();
    if (q && q.length < $375f8776645d5aee$export$6770277ab0ca292e) return {
        entries: [],
        total: 0
    };
    const key = `${q}\u0000${orderType}\u0000${appointmentId || ''}\u0000${offset}`;
    const hit = $375f8776645d5aee$var$orderCacheGet(key);
    if (hit) return hit;
    const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$14a88ef3dbc10c6b, {
        query: q || null,
        orderType: orderType || null,
        appointmentId: appointmentId,
        limit: $375f8776645d5aee$export$bfb5df55ff94459,
        offset: offset
    });
    const page = {
        entries: data?.searchClinicalOrderCatalog?.entries || [],
        total: data?.searchClinicalOrderCatalog?.total || 0
    };
    $375f8776645d5aee$var$orderCachePut(key, page);
    return page;
}
/**
 * What ALREADY-SAVED orders need from the catalogue: the English name the SOAP
 * plan block prints, whether this clinic performs the service, and its code.
 *
 * `names` is for the two shapes that carry no catalogId — orders written before
 * the catalogue did, and the AI treatment plan, which proposes a service as free
 * text and must be matched back to a row before it can be billed. An ambiguous
 * name resolves to NOTHING rather than to a guess; narrow it with orderType.
 *
 * Not cached: it is one call per visit, and a stale «انجام» button is a stale
 * billing affordance.
 */ // English catalogue names for orders that identify themselves by their Persian
// name — an AI suggestion, an order it created, an order on a past visit. Looked
// up once per name (cached for the page), and only for a reader who does not read
// Persian. The Persian is what is stored and matched; this changes what is SHOWN.
const $375f8776645d5aee$var$catalogNameEnCache = new Map();
function $375f8776645d5aee$export$69d0d94972917188(rows) {
    for (const r of rows || []){
        // A row found BY name carries the name it matched; one found by id carries
        // its own Persian name, which is what an order's description says.
        for (const n of [
            r?.matchedName,
            r?.name
        ])if (n) $375f8776645d5aee$var$catalogNameEnCache.set(n.trim(), r.nameEn || '');
    }
}
async function $375f8776645d5aee$export$d1f71c951f3a3ccc(names) {
    const want = [
        ...new Set((names || []).map((n)=>(n || '').trim()).filter(Boolean))
    ].filter((n)=>!$375f8776645d5aee$var$catalogNameEnCache.has(n));
    if (!want.length) return;
    const rows = await $375f8776645d5aee$export$ff3759fdd9615d20({
        names: want
    });
    for (const n of want)$375f8776645d5aee$var$catalogNameEnCache.set(n, '');
    $375f8776645d5aee$export$69d0d94972917188(rows);
}
function $375f8776645d5aee$export$891bfbeed44ddfce(names) {
    const { readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const key = readsPersianData ? '' : [
        ...new Set((names || []).map((n)=>(n || '').trim()).filter(Boolean))
    ].sort().join('\u0000');
    const [, bump] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!key) return undefined;
        const want = key.split('\u0000').filter((n)=>!$375f8776645d5aee$var$catalogNameEnCache.has(n));
        if (!want.length) return undefined;
        let live = true;
        $375f8776645d5aee$export$d1f71c951f3a3ccc(want).then(()=>{
            if (live) bump((x)=>x + 1);
        }).catch((err)=>console.warn('catalogue English names unavailable:', err));
        return ()=>{
            live = false;
        };
    }, [
        key
    ]);
    return (name)=>readsPersianData ? name : $375f8776645d5aee$var$catalogNameEnCache.get((name || '').trim()) || name;
}
function $375f8776645d5aee$export$f1536cfec6e3f4b8(text, t, readsPersianData) {
    if (readsPersianData || !text) return text;
    return String(text).split(" \xb7 ").map((raw)=>{
        const part = raw.trim();
        const freq = (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(part, t);
        if (freq !== part) return freq;
        const dur = (0, $f91797fd10151718$export$d579c09ab10cbff4)(part);
        if (dur && dur !== part) return dur;
        return $375f8776645d5aee$export$a6616cb9d478340f(part, false, t);
    }).join(" \xb7 ");
}
async function $375f8776645d5aee$export$ff3759fdd9615d20({ ids: ids = [], names: names = [], orderType: orderType = '', appointmentId: appointmentId = null } = {}) {
    const wantIds = [
        ...new Set(ids.filter(Boolean))
    ];
    const wantNames = [
        ...new Set(names.filter(Boolean))
    ];
    if (!wantIds.length && !wantNames.length) return [];
    const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$5b0044a5c8c756be, {
        ids: wantIds.length ? wantIds : null,
        names: wantNames.length ? wantNames : null,
        orderType: orderType || null,
        appointmentId: appointmentId
    });
    return data?.resolveClinicalCatalogEntries || [];
}
function $375f8776645d5aee$export$30e9b064e10043f9({ urgency: urgency }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!urgency || urgency === 'routine') return null;
    const cfg = $375f8776645d5aee$export$792cf12450c08f12(t)[urgency] || $375f8776645d5aee$export$792cf12450c08f12(t).routine;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            padding: '2px 7px',
            borderRadius: 4,
            background: cfg.bg,
            color: cfg.color,
            fontWeight: 700,
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, cfg.label);
}
function $375f8776645d5aee$export$a36149ed7c50a677({ item: item, selected: selected, onToggle: onToggle, showLoinc: showLoinc }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const names = $375f8776645d5aee$export$adea16e688375bbf(item, readsPersianData, item?.nameAr);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onToggle(item.key),
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 9,
            padding: '9px 12px',
            borderRadius: 10,
            border: `1.5px solid ${selected ? 'var(--accent)' : 'var(--line)'}`,
            background: selected ? 'var(--accent-soft)' : 'var(--panel-2)',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'all .12s',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 17,
            height: 17,
            borderRadius: 5,
            border: `1.5px solid ${selected ? 'var(--accent)' : 'var(--line-2)'}`,
            background: selected ? 'var(--accent)' : 'transparent',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            marginTop: 1,
            transition: 'all .12s'
        }
    }, selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 9,
        height: 9,
        style: {
            color: '#fff'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            fontWeight: 600,
            color: selected ? 'var(--accent-ink)' : 'var(--ink)',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, names.primary, item.inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t('visit.orders.doneHere'),
        style: {
            fontSize: 9.5,
            padding: '1px 6px',
            borderRadius: 4,
            background: 'var(--ok-soft, #0f766e22)',
            color: 'var(--ok-ink, #0f766e)',
            fontWeight: 700,
            border: '1px solid #0f766e33',
            whiteSpace: 'nowrap'
        }
    }, t('visit.orders.thisClinic')), item.modality && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9.5,
            padding: '1px 6px',
            borderRadius: 4,
            background: $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] ? $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] + '22' : 'var(--line)',
            color: $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] || 'var(--mute)',
            fontWeight: 700,
            border: `1px solid ${$375f8776645d5aee$export$c6702e128b41d3a7[item.modality] || 'var(--line)'}33`
        }
    }, item.modality), showLoinc && item.loincCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9,
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, "LOINC ", item.loincCode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$cbaf757fd313ab43, {
        drug: {
            id: item.catalogId || item.key
        },
        listed: item.taminListed ?? null,
        both: true,
        testid: `visit-order-coverage-${item.catalogId || item.key}`,
        hint: t('visit.orders.outTaminHint')
    })), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute-2)',
            marginTop: 1
        }
    }, names.secondary), item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            marginTop: 2,
            lineHeight: 1.5
        }
    }, item.reason), item.sub && !item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute-2)',
            marginTop: 1
        }
    }, item.sub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$30e9b064e10043f9, {
        urgency: item.urgency
    }));
}
const $375f8776645d5aee$export$9c5829f0850e67fe = (patient)=>patient?.age ?? null;
function $375f8776645d5aee$export$bf8ea0179266f66d(patient) {
    if (!patient) return '';
    const parts = [];
    const demo = [
        patient.age != null ? `age=${patient.age}` : null,
        patient.gender ? `gender=${patient.gender}` : null
    ].filter(Boolean);
    if (demo.length) parts.push('DEMOGRAPHICS: ' + demo.join(', '));
    const conds = (patient.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active');
    if (conds.length) parts.push('CONDITIONS: ' + conds.map((c)=>c.display).join(', '));
    const meds = (patient.clinicalMedications || []).filter((m)=>m.status === 'active');
    if (meds.length) parts.push('MEDICATIONS: ' + meds.map((m)=>`${m.display}${m.dosageInstruction?.text ? ' ' + m.dosageInstruction.text : ''}`).join(', '));
    // Only last 10 abnormal/noteworthy observations to keep token count low.
    //
    // Vitals are excluded, and that exclusion is the point of the filter rather
    // than a token-budget nicety. `clinicalObservations` spans the patient's whole
    // record, so the ten most recent numbers here are drawn from whichever visits
    // happened to be busy — and this block is sent verbatim as the `patientHistory`
    // argument of askDoctorQuestion and generateConfirmationQuestions. A blood
    // pressure from last month arriving under a heading the model reads as the
    // patient's current state is exactly the confusion the AI-side scoping exists
    // to prevent. This visit's vitals reach the service by the appointment id and
    // are attached there; nothing this block could add would belong to this visit.
    // Labs stay: a creatinine from two months ago is history, and reads as history.
    const ABNORMAL_THRESHOLD = {};
    const obs = (patient.clinicalObservations || []).filter((o)=>o.value && !isNaN(parseFloat(o.value))).filter((o)=>!(0, $bf42e0131d395ab7$export$520152d4ddd823c6).has(o.code)).sort((a, b)=>(b.effectiveDate || b.createdAt || '').localeCompare(a.effectiveDate || a.createdAt || '')).slice(0, 10);
    if (obs.length) {
        const obsLines = obs.map((o)=>{
            const date = o.effectiveDate || o.createdAt || '';
            return `${o.display || o.code}=${o.value}${o.unit ? ' ' + o.unit : ''}${date ? ' [' + date.slice(0, 10) + ']' : ''}`;
        });
        parts.push('LAB_HISTORY:\n' + obsLines.join('\n'));
    }
    const visits = (patient.history || []).slice(0, 3);
    if (visits.length) {
        const visitLines = visits.map((v)=>`[${v.date || ''}] ${v.diagnosis || ''}`).filter((l)=>l.trim() !== '[]');
        if (visitLines.length) parts.push('VISIT_HISTORY: ' + visitLines.join(' | '));
    }
    return parts.join('\n');
}
function $375f8776645d5aee$export$282a2c8a3d030b1(soap, diagnosis, pendingTests) {
    const parts = [];
    const hasSoap = soap && (soap.s || soap.o || soap.a || soap.p);
    if (hasSoap) {
        parts.push('CURRENT_VISIT_SOAP:');
        if (soap.s) parts.push(`S: ${soap.s}`);
        if (soap.o) parts.push(`O: ${soap.o}`);
        if (soap.a) parts.push(`A: ${soap.a}`);
        if (soap.p) parts.push(`P: ${soap.p}`);
    }
    if (diagnosis && diagnosis.length) {
        const dxText = Array.isArray(diagnosis) ? diagnosis.map((d)=>d.display || d.name || d).filter(Boolean).join(', ') : String(diagnosis);
        if (dxText) parts.push(`CURRENT_DIAGNOSIS: ${dxText}`);
    }
    if (pendingTests && pendingTests.length) {
        const orderLines = pendingTests.map((test)=>`- ${test.name} [${test.type || 'order'}, ${test.urgency || 'routine'}]`);
        parts.push('CURRENT_ORDERS:\n' + orderLines.join('\n'));
    }
    return parts.join('\n');
}
function $375f8776645d5aee$export$afbcfcdadda1b1bf(q, answer, t) {
    const stem = String(q?.question || '').replace(/^آیا\s+/, '').replace(/[؟?]+$/, '');
    return answer === 'yes' ? q?.positiveStatement || stem : q?.negativeStatement || t('visit.text.without', {
        text: stem
    });
}
function $375f8776645d5aee$export$9c2ce4aa2a7d6fc6(q, answer, t, followUp) {
    const base = $375f8776645d5aee$export$afbcfcdadda1b1bf(q, answer, t);
    const note = (followUp || '').trim();
    return note ? `${base} (${note})` : base;
}
function $375f8776645d5aee$export$7904c2b41f6b4e23(state, activeCodes) {
    if (!state) return {};
    const keep = new Set(activeCodes || []);
    const next = {};
    let dropped = false;
    for (const [key, value] of Object.entries(state)){
        const sep = key.indexOf(':'); // ICD codes contain no ':'
        if (keep.has(sep === -1 ? key : key.slice(0, sep))) next[key] = value;
        else dropped = true;
    }
    return dropped ? next : state;
}
function $375f8776645d5aee$export$5a4e1c8ddaeead64(s, finding) {
    const bullet = `\u{2022} ${finding}`;
    return s ? `${s}\n${bullet}` : bullet;
}
const $375f8776645d5aee$export$d1f269d7e988a6d = "\u2500\u2500\u2500 Treatment plan (auto-updated) \u2500\u2500\u2500"; // i18n-exempt: structural marker parsed back out of stored notes — see above
const $375f8776645d5aee$export$4d844df10945fd3f = "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500"; // i18n-exempt: structural marker, nothing to translate
const $375f8776645d5aee$export$155046b7971ebae7 = [
    "\u2500\u2500\u2500 \u0628\u0631\u0646\u0627\u0645\u0647 \u062F\u0631\u0645\u0627\u0646 (\u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062E\u0648\u062F\u06A9\u0627\u0631) \u2500\u2500\u2500"
]; // i18n-exempt: recognises notes written before the plan block became English
// Section headings and order kinds, English by the same rule. // i18n-exempt: clinical document, deliberately locale-independent
const $375f8776645d5aee$var$PLAN_MEDS_HEADING = 'Medications:';
const $375f8776645d5aee$var$PLAN_ORDERS_HEADING = 'Orders and procedures:';
const $375f8776645d5aee$export$adea16e688375bbf = (item, readsPersianData, preferred)=>{
    const persian = (item?.name || '').trim();
    // `preferred` is this reader's own language if the row carries it — Arabic
    // for an Arabic reader — and English is the second best, not the first: a lab
    // test has a settled Arabic name and «تعداد الدم الكامل» reads better to that
    // doctor than "CBC with differential" does. Both are nullable, and a clinic's
    // own custom service usually has neither, so this is a cascade and not a
    // choice: name_ar → name_en → name.
    const translated = (preferred || '').trim() || (item?.nameEn || '').trim();
    // A reader who does not read Persian gets their own line alone; the Persian
    // name is shown only when it is the only one the row has.
    if (readsPersianData) return {
        primary: persian || translated,
        secondary: ''
    };
    return {
        primary: translated || persian,
        secondary: ''
    };
};
/**
 * One display line per prescribed drug, in prescription order, in English:
 *
 *     • Metformin — 500mg tablet twice daily for 7 days
 *
 * The strength is never paraphrased — only the Persian dose form and dosing
 * frequency around it are translated, and anything unrecognised is passed
 * through as the doctor entered it (see planEnglish.js).
 */ function $375f8776645d5aee$var$planMedLines(rxItems) {
    return (rxItems || []).map((r)=>{
        const name = (0, $bb8a11e7c1131df5$export$3c5ec0a5e65ceb27)(r?.drug);
        if (!name) return null;
        const detail = [
            (0, $f91797fd10151718$export$faf0542505380f3e)(r.dosage),
            (0, $f91797fd10151718$export$cfcbced31e5dd385)(r.route),
            (0, $f91797fd10151718$export$7a6106170485de57)(r.frequency),
            r.duration ? `for ${(0, $f91797fd10151718$export$d579c09ab10cbff4)(r.duration)}` : ''
        ].map((x)=>(x || '').trim()).filter(Boolean).join(' ');
        // The instruction is the doctor's own sentence — passed through verbatim
        // (rule 1 in planEnglish.js) and parenthesised so it reads as an aside
        // rather than as part of the dosing.
        const note = (r.instructions || '').trim();
        const line = detail ? `${name} \u{2014} ${detail}` : name;
        return `\u{2022} ${note ? `${line} (${note})` : line}`;
    }).filter(Boolean);
}
// Cancelled orders are deliberately dropped: a plan that still lists a request
// the doctor withdrew is exactly the divergence this whole mechanism exists to
// prevent. Everything else — pending, in progress, completed — is part of the
// plan for this visit and stays listed.
const $375f8776645d5aee$var$PLAN_ORDER_LABELS = {
    lab: 'Lab',
    imaging: 'Imaging',
    procedure: 'Procedure'
}; // i18n-exempt: English clinical document
const $375f8776645d5aee$var$PLAN_ORDER_FALLBACK_LABEL = 'Order'; // i18n-exempt: English clinical document
// Grouped by kind rather than by insertion time. The live order list is built by
// PREPENDING new orders, so following it would print the plan newest-first and
// reshuffle every line each time the doctor adds one. Grouping makes the block a
// function of WHAT is ordered, not of the sequence it was entered in — which is
// what lets `planBlockInSync` treat "same items" as "no change".
const $375f8776645d5aee$var$PLAN_ORDER_KINDS = [
    'lab',
    'imaging',
    'procedure'
];
/**
 * One display line per live clinical order, grouped lab → imaging → procedure,
 * in English:
 *
 *     • Lab: CBC with differential
 *     • Imaging: Chest X-ray PA
 *
 * The order stores the Persian catalogue name as its description, so the English
 * name is resolved through `orderNameEn` — the catalogue's own `nameEn`, looked
 * up by the catalogId the order was created with. An order the catalogue cannot
 * answer for (free text the doctor typed) keeps their words: inventing an
 * English name for a request nobody standardised would be worse than showing it.
 */ function $375f8776645d5aee$var$planOrderLines(orders, orderNameEn) {
    const live = (orders || []).filter((o)=>o && o.status !== 'cancelled' && (o.description || '').trim());
    const kindRank = (o)=>{
        const i = $375f8776645d5aee$var$PLAN_ORDER_KINDS.indexOf(o.orderType);
        return i === -1 ? $375f8776645d5aee$var$PLAN_ORDER_KINDS.length : i;
    };
    return live.map((o, i)=>({
            o: o,
            i: i
        })).sort((a, b)=>kindRank(a.o) - kindRank(b.o) || a.i - b.i).map(({ o: o })=>{
        const kind = $375f8776645d5aee$var$PLAN_ORDER_LABELS[o.orderType] || $375f8776645d5aee$var$PLAN_ORDER_FALLBACK_LABEL;
        const english = (orderNameEn && orderNameEn(o) || '').trim();
        return `\u{2022} ${kind}: ${english || o.description.trim()}`;
    });
}
function $375f8776645d5aee$export$d3332d0820799abb({ rxItems: rxItems, orders: orders, orderNameEn: orderNameEn }) {
    const meds = $375f8776645d5aee$var$planMedLines(rxItems);
    const ords = $375f8776645d5aee$var$planOrderLines(orders, orderNameEn);
    if (!meds.length && !ords.length) return '';
    const body = [];
    if (meds.length) body.push($375f8776645d5aee$var$PLAN_MEDS_HEADING, ...meds);
    if (ords.length) body.push($375f8776645d5aee$var$PLAN_ORDERS_HEADING, ...ords);
    return [
        $375f8776645d5aee$export$d1f269d7e988a6d,
        ...body,
        $375f8776645d5aee$export$4d844df10945fd3f
    ].join('\n');
}
// Matches the block wherever it sits, including a trailing END marker the doctor
// may have orphaned by deleting lines. The START marker is the anchor; if END is
// missing we take the rest of the text, because a half-deleted block must still
// be replaceable rather than accumulate a second one below it.
function $375f8776645d5aee$var$findPlanBlock(text) {
    const src = text || '';
    // Earliest marker wins, current or legacy: a note stored before the block
    // became English still has to be FOUND, or reconciliation would leave the old
    // Persian block in place and write an English one underneath it.
    let start = -1, marker = $375f8776645d5aee$export$d1f269d7e988a6d;
    for (const candidate of [
        $375f8776645d5aee$export$d1f269d7e988a6d,
        ...$375f8776645d5aee$export$155046b7971ebae7
    ]){
        const at = src.indexOf(candidate);
        if (at !== -1 && (start === -1 || at < start)) {
            start = at;
            marker = candidate;
        }
    }
    if (start === -1) return null;
    const endIdx = src.indexOf($375f8776645d5aee$export$4d844df10945fd3f, start + marker.length);
    const end = endIdx === -1 ? src.length : endIdx + $375f8776645d5aee$export$4d844df10945fd3f.length;
    return {
        start: start,
        end: end
    };
}
function $375f8776645d5aee$export$35974e4f6db92b0(text) {
    let src = text || '';
    for(let at = $375f8776645d5aee$var$findPlanBlock(src); at; at = $375f8776645d5aee$var$findPlanBlock(src)){
        const before = src.slice(0, at.start).trim();
        const after = src.slice(at.end).trim();
        src = before && after ? `${before}\n\n${after}` : before || after;
    }
    return src.trim();
}
function $375f8776645d5aee$export$a3aead4a50abe781(text, block) {
    const narrative = $375f8776645d5aee$export$35974e4f6db92b0(text);
    if (!block) return narrative;
    return narrative ? `${narrative}\n\n${block}` : block;
}
function $375f8776645d5aee$export$46cdec4733783b45(text, block) {
    return $375f8776645d5aee$export$a3aead4a50abe781(text, block) === (text || '');
}
function $375f8776645d5aee$export$69cdf1bc97231e5(text) {
    const src = text || '';
    const at = $375f8776645d5aee$var$findPlanBlock(src);
    return at ? src.slice(at.start, at.end) : '';
}
const $375f8776645d5aee$export$1d07db446c57b398 = {
    note: 'note',
    rationale: 'rationale',
    safety: 'safety',
    followup: 'followup',
    soap: 'soap'
};
const $375f8776645d5aee$export$528d025f14f74fd4 = [
    'lab',
    'imaging',
    'drug'
];
const $375f8776645d5aee$export$bd515ef4f7b2f032 = (s)=>!$375f8776645d5aee$export$528d025f14f74fd4.includes(s?.type);
const $375f8776645d5aee$export$b2355ec0f81e9680 = (list)=>(list || []).filter($375f8776645d5aee$export$bd515ef4f7b2f032);
const $375f8776645d5aee$export$769e1e6a71b6cabc = 0.5;
const $375f8776645d5aee$var$insightWords = (text)=>new Set((0, $bb8a11e7c1131df5$export$57fe41c96b1d272c)(text).split(' ').filter((w)=>w.length > 1));
const $375f8776645d5aee$export$6a1145afc4baa12e = (a, b)=>{
    const wa = $375f8776645d5aee$var$insightWords(a);
    const wb = $375f8776645d5aee$var$insightWords(b);
    if (!wa.size || !wb.size) return 0;
    let overlap = 0;
    wa.forEach((w)=>{
        if (wb.has(w)) overlap++;
    });
    return overlap / (wa.size + wb.size - overlap);
};
const $375f8776645d5aee$export$bd5821baf0a03519 = (warning, shown = [])=>{
    const rank = $375f8776645d5aee$export$60d82a5be99a0a11[$375f8776645d5aee$export$a20f1db6dc818677(warning?.severity)];
    return (shown || []).some((s)=>(0, $bb8a11e7c1131df5$export$3641abf9efdf7316)(s, warning) && $375f8776645d5aee$export$60d82a5be99a0a11[$375f8776645d5aee$export$a20f1db6dc818677(s?.severity)] >= rank);
};
// Maps abnormal clinical observations to rule engine condition strings.
//
// What comes out of here is sent with every interaction check as a condition
// the patient HAS, so a false one is not harmless: «liver_disease» turns a
// statin into a شدید contraindication and holds the visit at its end. Three
// ways this used to invent one:
//
//   1. Bare substrings. «f-AST-ing glucose» is AST, so a fasting glucose of 96
//      (> 45) became liver disease; «alt» hid in words the same way. Latin
//      names are matched as whole tokens now.
//   2. The wrong specimen or quantity. Urine creatinine (~100), creatinine
//      clearance (~90 mL/min) and the albumin/creatinine ratio all read as
//      «creatinine > 1.5»; urine potassium (20–100 mmol/L) as hyperkalaemia;
//      urine WBC per HPF as infection. Only a blood level is compared now. A
//      creatinine clearance is a filtration rate, so it is read as one (< 30).
//   3. Units. The thresholds are in mg/dL, % and ×10³/µL. A result reported in
//      µmol/L, mmol/L, mmol/mol or cells/µL is converted first: a creatinine of
//      80 µmol/L is a normal 0.9 mg/dL.
//
// Left as it was: a urine result whose name and unit both look like a blood
// test's (a bare «Glucose» row in mg/dL under a urinalysis heading) cannot be
// told apart here — observations carry no specimen field.
//
// i18n-exempt: the Persian names below are MATCHED against the display name an
// observation arrives with — wire data, not copy. Translating them would stop
// a Persian-reported creatinine or potassium from ever being recognised, and
// the rule engine would silently miss the condition. That is a clinical bug
// with no visible symptom, which is exactly why the marker is here.
// A Latin name as a whole token: not preceded or followed by a letter or digit.
// No lookbehind — older Safari cannot parse it, and the parse error would take
// the whole visit screen down with it.
const $375f8776645d5aee$var$labTerm = (...terms)=>new RegExp(`(?:^|[^a-z0-9])(?:${terms.join('|')})(?![a-z0-9])`);
// Persian has no case and no word-boundary class; its names are distinct enough
// to be matched as they are.
const $375f8776645d5aee$var$LAB_NAMES = {
    creatinine: [
        $375f8776645d5aee$var$labTerm('creatinine'),
        "\u06A9\u0631\u0627\u062A\u06CC\u0646\u06CC\u0646"
    ],
    gfr: [
        $375f8776645d5aee$var$labTerm('e?gfr', 'glomerular filtration')
    ],
    alt: [
        $375f8776645d5aee$var$labTerm('alt', 'sgpt', 'alanine aminotransferase', 'alanine transaminase')
    ],
    ast: [
        $375f8776645d5aee$var$labTerm('ast', 'sgot', 'aspartate aminotransferase', 'aspartate transaminase')
    ],
    glucose: [
        $375f8776645d5aee$var$labTerm('glucose', 'fbs'),
        "\u0642\u0646\u062F",
        "\u06AF\u0644\u0648\u06A9\u0632"
    ],
    a1c: [
        $375f8776645d5aee$var$labTerm('hba1c', 'a1c')
    ],
    potassium: [
        $375f8776645d5aee$var$labTerm('potassium'),
        "\u067E\u062A\u0627\u0633\u06CC\u0645"
    ],
    wbc: [
        $375f8776645d5aee$var$labTerm('wbc'),
        "\u06AF\u0644\u0628\u0648\u0644 \u0633\u0641\u06CC\u062F"
    ],
    qtc: [
        $375f8776645d5aee$var$labTerm('qtc', 'qt interval')
    ]
};
const $375f8776645d5aee$var$isLab = (name, key)=>$375f8776645d5aee$var$LAB_NAMES[key].some((p)=>typeof p === 'string' ? name.includes(p) : p.test(name));
// Not a blood level: another specimen, or a ratio of two analytes.
const $375f8776645d5aee$var$NOT_BLOOD_NAME = $375f8776645d5aee$var$labTerm('urin[a-z]*', 'u/a', 'csf', 'cerebrospinal', 'cerebral spinal', 'body fluid', 'pleural', 'peritoneal', 'ascitic', 'synovial', 'dialysate', 'stool', 'feces', 'faeces', 'ratio');
const $375f8776645d5aee$var$NOT_BLOOD_NAME_FA = [
    "\u0627\u062F\u0631\u0627\u0631",
    "\u0645\u0627\u06CC\u0639",
    "\u0646\u0633\u0628\u062A"
];
// «albumin/creatinine», «BUN/Cr…»: a ratio even when the word is not written.
const $375f8776645d5aee$var$CREATININE_RATIO = /\/\s*(?:creatinine|کراتینین)|(?:creatinine|کراتینین)\s*\//;
const $375f8776645d5aee$var$CLEARANCE = /clearance|کلیرانس/;
// Per microscope field (urine sediment) or per timed collection (24-h urine).
const $375f8776645d5aee$var$NOT_BLOOD_UNIT = /hpf|lpf|24h|\/24|\/day|\/d(?![a-z])/;
const $375f8776645d5aee$var$MICROMOL_PER_L = /(?:µ|μ|u|micro)mol\/l/;
const $375f8776645d5aee$var$MMOL_PER_L = /mmol\/l(?![a-z])/;
const $375f8776645d5aee$var$MMOL_PER_MOL = /mmol\/mol/;
function $375f8776645d5aee$export$5176433c16ff5a4(observations) {
    const inferred = new Set();
    for (const obs of observations || []){
        const name = String(obs?.display || obs?.code || '').toLowerCase();
        let val = parseFloat(obs?.value);
        if (!name || isNaN(val)) continue;
        const unit = String(obs?.unit || '').toLowerCase().replace(/\s+/g, '');
        const is = (key)=>$375f8776645d5aee$var$isLab(name, key);
        // A filtration rate, however it was derived — «eGFR … by Creatinine-based
        // formula» names creatinine but is not a creatinine level.
        if (is('gfr') || is('creatinine') && $375f8776645d5aee$var$CLEARANCE.test(name)) {
            if (val < 30) inferred.add('renal_failure');
            continue;
        }
        if ($375f8776645d5aee$var$CLEARANCE.test(name) || $375f8776645d5aee$var$NOT_BLOOD_NAME.test(name) || $375f8776645d5aee$var$NOT_BLOOD_NAME_FA.some((w)=>name.includes(w)) || $375f8776645d5aee$var$NOT_BLOOD_UNIT.test(unit)) continue;
        if (is('creatinine') && !$375f8776645d5aee$var$CREATININE_RATIO.test(name) && !/ml\/min/.test(unit)) {
            const mgPerDl = $375f8776645d5aee$var$MICROMOL_PER_L.test(unit) ? val / 88.4 : val;
            if (mgPerDl > 1.5) inferred.add('renal_failure');
        }
        if (is('alt') && val > 55) inferred.add('liver_disease');
        if (is('ast') && val > 45) inferred.add('liver_disease');
        if (is('glucose')) {
            const mgPerDl = $375f8776645d5aee$var$MMOL_PER_L.test(unit) ? val * 18 : val;
            if (mgPerDl > 200) inferred.add('diabetes');
        }
        if (is('a1c')) {
            // IFCC mmol/mol → NGSP %.
            const pct = $375f8776645d5aee$var$MMOL_PER_MOL.test(unit) ? val * 0.0915 + 2.15 : val;
            if (pct > 7.5) inferred.add('diabetes');
        }
        if (is('potassium') && val > 5.5) inferred.add('hyperkalemia');
        if (is('wbc')) {
            // A count in cells/µL (7500) rather than ×10³/µL (7.5). No count in
            // thousands per µL reaches 1000, so the size alone tells them apart.
            if (val >= 1000) val /= 1000;
            if (val > 12) inferred.add('systemic_infection');
        }
        if (is('qtc') && val > 450) inferred.add('qt_prolongation');
    }
    return [
        ...inferred
    ];
}
const $375f8776645d5aee$export$cb3932e7be74e021 = 3000;
function $375f8776645d5aee$export$ce13baf245686a19(transcript, consumedLen, overlap = 400) {
    const text = transcript || '';
    const marker = Number(consumedLen) || 0;
    const usable = marker > 0 && marker <= text.length;
    const start = usable ? Math.max(0, marker - overlap) : 0;
    return {
        window: text.slice(start).slice(-$375f8776645d5aee$export$cb3932e7be74e021),
        nextConsumed: text.length
    };
}
// ── Voice capture state, shared by both field-voice modals ───────────────────
// One hook so the two modals cannot drift on the part that is easy to get
// wrong: the recorder is started exactly once on open, the browser's own
// silence timeout is resumed by the hook (never by a status-watching effect
// here — that is what used to race the mount-time start and kill recording),
// and stop() is idempotent so confirm/close/unmount can all call it.
//
// `engine` is the doctor's «موتور تبدیل گفتار به متن» as resolved for dictation
// (lib/speechEngine.js `dictationEngine`): 'browser' drives the Web Speech API,
// 'parsina' / 'assistant' stream to the AI service. Both hooks are always
// CALLED — hooks may not be conditional — and only the chosen one is started.
// A server engine returns its words after the audio stops, which is why
// `finish()` is a promise and the sheets await it before committing.
function $375f8776645d5aee$var$useFieldVoiceCapture(engine = (0, $33deae5c7ec89d7f$export$14e406b759a48fe6)) {
    const server = (0, $33deae5c7ec89d7f$export$8636e31299dc73ad)(engine);
    const browserVoice = (0, $9cbf1cd12683ca1b$export$1b636b4aaaa4a081)({
        continuous: true,
        autoRestart: true
    });
    const serverVoice = (0, $7ecc8909c8058bf5$export$db41ba3bc0cf8f1c)({
        engine: server ? engine : 'parsina'
    });
    const v = server ? serverVoice : browserVoice;
    const { status: status, transcript: transcript, errorDetail: errorDetail, start: start, stop: stop, reset: reset } = v;
    (0, $acw62.useEffect)(()=>{
        reset();
        start();
        // Closing the sheet abandons a server stream rather than waiting on it.
        return ()=>server ? serverVoice.cancel() : browserVoice.stop();
    }, []);
    return {
        engine: engine,
        isServer: server,
        servedEngine: server ? serverVoice.servedEngine : null,
        transcript: transcript,
        errorDetail: errorDetail,
        stop: stop,
        // The whole transcript, once there is no more to come.
        finish: server ? serverVoice.finish : async ()=>{
            stop();
            return transcript || '';
        },
        retry: ()=>{
            reset();
            start();
        },
        resume: start,
        isListening: status === 'listening',
        isTranscribing: status === 'transcribing',
        isDenied: status === 'denied',
        isUnsup: status === 'unsupported',
        // 'error' used to fall through to the listening UI, so a missing mic or a
        // dropped network looked exactly like a doctor who had not spoken yet.
        isError: status === 'denied' || status === 'unsupported' || status === 'error'
    };
}
// Which engine is listening, under the microphone. Says so plainly when the
// doctor asked for Parsina STT and the service answered with the assistant.
function $375f8776645d5aee$var$VoiceEngineNote({ v: v }) {
    const { t: t } = (0, $LNQP4.default)();
    const fellBack = v.isServer && v.servedEngine && v.servedEngine !== v.engine;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "voice-engine",
        "data-engine": v.servedEngine || v.engine,
        style: {
            fontSize: 10.5,
            color: fellBack ? 'var(--warn-ink, #8a5a00)' : 'var(--mute)',
            textAlign: 'center',
            marginBottom: 8,
            lineHeight: 1.6
        }
    }, t('visit.voice.engineLabel', {
        engine: t(`visit.voice.engines.${v.servedEngine || v.engine}`)
    }), fellBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " \u2014 ", t('visit.voice.engineFellBack')), v.isServer && !fellBack && !v.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, t('visit.voice.serverHint')));
}
// The recording indicator + stop/resume control, identical in both modals.
function $375f8776645d5aee$var$VoiceRecordingControl({ isListening: isListening, onStop: onStop, onResume: onResume, isTranscribing: isTranscribing = false }) {
    const { t: t } = (0, $LNQP4.default)();
    if (isTranscribing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "voice-transcribing",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            marginBottom: 8,
            fontSize: 11,
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--accent)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.voice.transcribing'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            marginBottom: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 11,
            color: isListening ? 'var(--danger)' : 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: isListening ? 'var(--danger)' : 'var(--mute-2)',
            animation: isListening ? 'pulse 1.6s infinite' : 'none'
        }
    }), isListening ? t('visit.voice.recording') : t('visit.voice.paused')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": "voice-toggle",
        onClick: ()=>isListening ? onStop() : onResume(),
        style: {
            padding: '4px 10px',
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 600,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--ink-2)',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, isListening ? t('visit.voice.stop') : t('visit.voice.resume')));
}
function $375f8776645d5aee$export$82f3f43056418bdf({ fieldLabel: fieldLabel, onClose: onClose, onResult: onResult, engine: engine = (0, $33deae5c7ec89d7f$export$14e406b759a48fe6) }) {
    const { t: t } = (0, $LNQP4.default)();
    const v = $375f8776645d5aee$var$useFieldVoiceCapture(engine);
    const { transcript: transcript, errorDetail: errorDetail, isListening: isListening, isDenied: isDenied, isUnsup: isUnsup, isError: isError } = v;
    (0, $acw62.useEffect)(()=>{
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, []);
    const commit = (text)=>{
        const value = (text || '').trim();
        if (value) onResult(value);
        else onClose();
    };
    // The browser engine already holds its words; a server engine sends them
    // after the audio stops, so «تأیید» waits for the final pass.
    const handleConfirm = ()=>{
        if (v.isServer) {
            v.finish().then(commit);
            return;
        }
        v.stop();
        commit(transcript);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-voice-scrim",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $375f8776645d5aee$export$5d26717df14e8026), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-fvoice",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-fvoice-close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })), isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--danger-soft)',
            color: 'var(--danger)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 6
        }
    }, isDenied ? t('visit.voice.denied') : isUnsup ? t('visit.voice.unsupported') : t('visit.voice.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--mute)',
            lineHeight: 1.7,
            marginBottom: 14
        }
    }, isDenied ? t('visit.voice.deniedHint') : isUnsup ? t(v.isServer ? 'visit.voice.recordingUnsupported' : 'visit.voice.unsupportedHint') : errorDetail || t('visit.voice.micError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'center'
        }
    }, !isUnsup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: v.retry,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontWeight: 600,
            fontSize: 12,
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-retry"
    }, t('common.actions.retry')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)',
            fontWeight: 600,
            fontSize: 12,
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-close"
    }, t('common.actions.close')))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-mic-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic-ring r1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic-ring r2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 22,
        height: 22
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 2
        }
    }, t('visit.voice.sayField', {
        field: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceRecordingControl, {
        isListening: isListening,
        isTranscribing: v.isTranscribing,
        onStop: v.stop,
        onResume: v.resume
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-wave"
    }, Array.from({
        length: 9
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                animationDelay: i * 0.09 + 's',
                height: isListening ? undefined : 8,
                background: isListening ? 'var(--danger)' : 'var(--line)',
                animation: isListening ? undefined : 'none'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-transcript"
    }, transcript || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute-2)'
        }
    }, t('visit.voice.listening'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        onClick: handleConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))));
}
function $375f8776645d5aee$export$50bc53bed8a43ae3({ fieldKey: fieldKey, fieldLabel: fieldLabel, onClose: onClose, onResult: onResult, engine: engine = (0, $33deae5c7ec89d7f$export$14e406b759a48fe6), submit: submit, hint: hint, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const v = $375f8776645d5aee$var$useFieldVoiceCapture(engine);
    const { transcript: transcript, errorDetail: errorDetail, isListening: isListening, isDenied: isDenied, isUnsup: isUnsup, isError: isError } = v;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [manualInput, setManualInput] = (0, $acw62.useState)('');
    // Whether the doctor TYPED in the box. A server engine's words arrive after
    // «تأیید»; they are what gets committed unless the doctor wrote their own.
    const editedRef = (0, $acw62.useRef)(false);
    // §C.3 rule 1 — a full-screen overlay joins the history stack, so the
    // platform back closes the dictation instead of leaving the visit with a
    // microphone open over another screen. Dismissing loses only an
    // un-confirmed transcript, which is what Escape and the ✕ already do.
    (0, $9BgRG.default)(true, onClose, {
        id: 'soap-field-voice'
    });
    (0, $acw62.useEffect)(()=>{
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, []);
    // Sync voice transcript into the editable area (only if user hasn't cleared it)
    (0, $acw62.useEffect)(()=>{
        if (transcript) setManualInput(transcript);
    }, [
        transcript
    ]);
    const handleConfirm = async ()=>{
        let raw = manualInput.trim();
        if (v.isServer) {
            // Nothing may be in the box yet: a server engine's words arrive after
            // the audio stops. What it heard is committed unless the doctor typed.
            setProcessing(true);
            const heard = (await v.finish() || '').trim();
            if (!editedRef.current && heard) raw = heard;
        } else v.stop();
        if (!raw) {
            onClose();
            return;
        }
        setProcessing(true);
        if (submit) {
            try {
                await submit(raw);
            } finally{
                onResult(raw);
            }
            return;
        }
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($375f8776645d5aee$export$a98b585598d708d2, {
                transcript: raw,
                field: fieldKey
            });
            onResult(data?.parseSoapVoiceField || raw);
        } catch  {
            onResult(raw);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-voice-scrim",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $375f8776645d5aee$export$5d26717df14e8026), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-fvoice",
        "data-testid": testid,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-fvoice-close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })), isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--danger-soft)',
            color: 'var(--danger)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 6
        }
    }, isUnsup ? t('visit.voice.unsupported') : isDenied ? t('visit.voice.permissionNeeded') : t('visit.voice.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            textAlign: 'center',
            marginBottom: 14
        }
    }, isUnsup ? t(v.isServer ? 'visit.voice.recordingUnsupported' : 'visit.voice.useChrome') : isDenied ? t('visit.voice.enableInSettings') : errorDetail || t('visit.voice.micError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        "data-testid": "voice-input",
        placeholder: t('visit.voice.typeInstead'),
        value: manualInput,
        onChange: (e)=>{
            editedRef.current = true;
            setManualInput(e.target.value);
        },
        rows: 3,
        style: {
            width: '100%',
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: '#fff',
            fontSize: 13,
            lineHeight: 1.7,
            fontFamily: 'inherit',
            resize: 'none',
            outline: 'none',
            color: 'var(--ink)',
            boxSizing: 'border-box'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'center',
            marginTop: 10
        }
    }, !isUnsup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: v.retry,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontWeight: 600,
            fontSize: 12,
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-retry"
    }, t('common.actions.retry')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        style: {
            margin: 0
        },
        onClick: handleConfirm,
        disabled: !manualInput.trim()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))) : processing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 22,
            height: 22,
            border: '3px solid var(--accent)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--mute)',
            textAlign: 'center'
        }
    }, t('visit.voice.processing'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            textAlign: 'center',
            marginBottom: hint ? 4 : 10
        }
    }, fieldLabel), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute-2)',
            textAlign: 'center',
            lineHeight: 1.7,
            marginBottom: 10
        }
    }, hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '0 auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: isListening ? 'var(--danger-soft)' : 'var(--accent-soft)',
            color: isListening ? 'var(--danger)' : 'var(--accent)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceRecordingControl, {
        isListening: isListening,
        isTranscribing: v.isTranscribing,
        onStop: v.stop,
        onResume: v.resume
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-wavebars",
        style: {
            marginBottom: 12
        }
    }, Array.from({
        length: 9
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                animationDelay: i * 0.09 + 's',
                height: isListening ? undefined : 8,
                background: isListening ? 'var(--danger)' : 'var(--line)',
                animation: isListening ? undefined : 'none'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-transcript"
    }, transcript || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute-2)'
        }
    }, t('visit.voice.listening'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        "data-testid": "voice-input",
        placeholder: t('visit.voice.editOrType'),
        value: manualInput,
        onChange: (e)=>{
            editedRef.current = true;
            setManualInput(e.target.value);
        },
        rows: 3,
        style: {
            width: '100%',
            marginTop: 8,
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: '#fff',
            fontSize: 13,
            lineHeight: 1.7,
            fontFamily: 'inherit',
            resize: 'none',
            outline: 'none',
            color: 'var(--ink)',
            boxSizing: 'border-box',
            transition: 'border-color .12s'
        },
        onFocus: (e)=>{
            e.target.style.borderColor = 'var(--accent)';
        },
        onBlur: (e)=>{
            e.target.style.borderColor = 'var(--line)';
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        onClick: handleConfirm,
        disabled: !manualInput.trim() && !v.isServer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))));
}
// ─────────────────────────────────────────────────────────────────────────────
// Printed prescription — ONE document for both surfaces
// ─────────────────────────────────────────────────────────────────────────────
// These builders used to live inside Visit.web.jsx, which meant the phone had
// no way to print at all. They are the legal Persian sheet a pharmacy, insurer
// and the medical council read, so there must be exactly one of them: desktop
// (PrescriptionPrintModal) and the mobile closure flow both render from here.
// ── Prescription template helpers ────────────────────────────────────────────
// ── The printed prescription is a Persian legal document ────────────────────
// Everything from here to `buildRxHTML` builds paper, not UI. Two reasons it
// stays Persian whatever language the doctor's panel is in:
//
//   • The `.replace(/نام بیمار:…/)` matchers run against template CONTENT that
//     templatemanagement stores in Persian. Translating a matcher would stop it
//     matching, and the printed sheet would silently keep the blank dot-lines
//     instead of the patient's details — the same failure class as translating
//     a lab-name matcher.
//   • An Iranian pharmacy, insurer and the medical council all read this sheet.
//     A prescription rendered in English is not a document anyone downstream
//     can act on.
//
// This warning was written BEFORE the i18n migration and the migration ignored
// it: every matcher below was rewritten to `t('visit.print.…')`, so on an
// English or Arabic panel `tr.startsWith('Patient:')` never matched the stored
// Persian «نام بیمار:» line and the whole sheet printed as unfilled dot-lines —
// no name, age, sex, phone, date, file number, diagnosis, follow-up or council
// number. They are back to Persian literals and must stay that way. A `t` is
// still threaded in from the callers (the signatures are shared with the UI
// side) but nothing below may use it: this is paper, not panel.
//
// i18n-exempt: printed-document builders — see above.
// Persian digits, fixed — NOT the panel's. `formatDigits` follows the doctor's UI
// language and would put Latin or Arabic-Indic digits on the paper; this is the same
// rule, and the same reason, as the `today` stamp in `printPrescription` below.
// Written as a code-point offset rather than a literal `'۰۱۲۳۴۵۶۷۸۹'` so a later editor
// cannot break it invisibly.
// i18n-exempt: printed-document digits — see the note above.
const $375f8776645d5aee$var$faDigits = (value)=>String(value ?? '').replace(/[0-9]/g, (d)=>String.fromCharCode(0x06f0 + Number(d)));
function $375f8776645d5aee$export$d0669af8f70abe11(raw) {
    return $375f8776645d5aee$var$faDigits((0, $5AX1S).forDisplay(raw));
}
function $375f8776645d5aee$export$4cf11838cdc2a8a8(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// The sheet's footer — Persian in every panel language like everything else on
// the paper, and the BRAND's (ui/lib/brand.js): its Persian name, or its own
// Persian wording for `visit.rx.generatedBy` — the key the on-screen preview of
// this sheet reads — so paper and preview never name two products. With no
// brand configured this is the sentence the sheet always printed.
// i18n-exempt: printed-document builder — see the note above `escapeHtml`.
const $375f8776645d5aee$var$PRINT_FOOTER_FA = "\u0646\u0633\u062E\u0647 \u062A\u0648\u0644\u06CC\u062F\u0634\u062F\u0647 \u062A\u0648\u0633\u0637 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F {{brand}}";
function $375f8776645d5aee$export$49f892522e84db92() {
    const own = (0, $eLeza.brandString)('fa', 'visit.rx.generatedBy');
    return $375f8776645d5aee$export$4cf11838cdc2a8a8((0, $eLeza.applyBrandTokens)(typeof own === 'string' ? own : $375f8776645d5aee$var$PRINT_FOOTER_FA, 'fa'));
}
function $375f8776645d5aee$export$1512fb0c882aac98(content, { rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const lines = (content || '').split('\n');
    const result = [];
    let i = 0;
    while(i < lines.length){
        const line = lines[i];
        const tr = line.trim();
        // Patient name / age / gender row
        if (tr.startsWith("\u0646\u0627\u0645 \u0628\u06CC\u0645\u0627\u0631:")) {
            result.push(line.replace(/نام بیمار:\s*\.{2,}/, `\u{646}\u{627}\u{645} \u{628}\u{6CC}\u{645}\u{627}\u{631}: ${patient?.name || ''}`).replace(/سن:\s*\.{2,}/, "\u0633\u0646: ").replace(/جنس:\s*\.{2,}/, "\u062C\u0646\u0633: "));
            i++;
            continue;
        }
        // Phone / date / file-number row
        if (tr.startsWith("\u0634\u0645\u0627\u0631\u0647 \u062A\u0645\u0627\u0633:")) {
            result.push(line.replace(/شماره تماس:\s*\.{2,}/, `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{645}\u{627}\u{633}: ${$375f8776645d5aee$export$d0669af8f70abe11(patient?.phone)}`).replace(/تاریخ:\s*\.{2,}/, `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}: ${today}`).replace(/شماره پرونده:\s*\.{2,}/, "\u0634\u0645\u0627\u0631\u0647 \u067E\u0631\u0648\u0646\u062F\u0647: "));
            i++;
            continue;
        }
        // Diagnosis header — fill blank dot-lines that follow
        if (tr === "\u062A\u0634\u062E\u06CC\u0635:") {
            result.push(line);
            i++;
            while(i < lines.length && lines[i].trim().match(/^\.+$/))i++;
            result.push(soap?.a || diagnosis || '');
            result.push('');
            continue;
        }
        // Rx header — replace all numbered drug slots with actual rxItems
        if (tr === 'Rx:') {
            result.push(line);
            result.push('');
            (rxItems || []).forEach((item, idx)=>{
                const name = (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug) || item.name || '';
                result.push(`${idx + 1}. ${name}`);
                result.push(`   \u{62F}\u{648}\u{632} \u{648} \u{634}\u{6A9}\u{644} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC}: ${item.dosage || ''}`);
                // «نحوه مصرف» used to be filled with the FREQUENCY, which is a different
                // thing and left the real route off the paper entirely. Now that the item
                // carries a route, each label gets its own field.
                result.push(`   \u{62A}\u{646}\u{627}\u{648}\u{628} \u{645}\u{635}\u{631}\u{641}: ${item.frequency || ''}`);
                result.push(`   \u{646}\u{62D}\u{648}\u{647} \u{645}\u{635}\u{631}\u{641}: ${item.route || ''}`);
                result.push(`   \u{645}\u{62F}\u{62A} \u{645}\u{635}\u{631}\u{641}: ${item.duration || ''}`);
                if (item.quantity) result.push(`   \u{645}\u{642}\u{62F}\u{627}\u{631} \u{62A}\u{62D}\u{648}\u{6CC}\u{644}\u{6CC}: ${item.quantity}`);
                if (item.instructions) result.push(`   \u{62F}\u{633}\u{62A}\u{648}\u{631} \u{645}\u{635}\u{631}\u{641}: ${item.instructions}`);
                result.push('');
            });
            // Skip template drug-slot lines (numbered items, their sub-lines, and blank separators)
            i++;
            while(i < lines.length){
                const nl = lines[i].trim();
                if (nl.match(/^[۱۲۳۴۵۶۷۸۹0-9]\./) || nl.startsWith("\u062F\u0648\u0632") || nl.startsWith("\u0646\u062D\u0648\u0647 \u0645\u0635\u0631\u0641") || nl.startsWith("\u062A\u0639\u062F\u0627\u062F:") || nl.startsWith("\u0645\u062F\u062A \u0645\u0635\u0631\u0641:") || nl === '') i++;
                else break;
            }
            continue;
        }
        // Non-drug instructions — replace bullet dot-lines with actual soap.p
        if (tr === "\u062A\u0648\u0635\u06CC\u0647\u200C\u0647\u0627\u06CC \u063A\u06CC\u0631 \u062F\u0627\u0631\u0648\u06CC\u06CC:") {
            result.push(line);
            const instr = soap?.p || '';
            i++;
            while(i < lines.length && lines[i].trim().startsWith("\u2022"))i++;
            if (instr) result.push(instr);
            else result.push("\u2022 ");
            continue;
        }
        // Follow-up line
        if (tr.startsWith("\u067E\u06CC\u06AF\u06CC\u0631\u06CC:")) {
            result.push(line.replace(/پیگیری:\s*\.{5,}/, "\u067E\u06CC\u06AF\u06CC\u0631\u06CC: "));
            i++;
            continue;
        }
        // Doctor info lines
        if (tr.startsWith("\u0646\u0627\u0645 \u067E\u0632\u0634\u06A9:")) {
            result.push(line.replace(/نام پزشک:\s*\.{5,}/, `\u{646}\u{627}\u{645} \u{67E}\u{632}\u{634}\u{6A9}: \u{62F}\u{6A9}\u{62A}\u{631} ${doctor?.name || ''}`));
            i++;
            continue;
        }
        if (tr.startsWith("\u062A\u062E\u0635\u0635:")) {
            result.push(line.replace(/تخصص:\s*\.{5,}/, `\u{62A}\u{62E}\u{635}\u{635}: ${doctor?.specialty || ''}`));
            i++;
            continue;
        }
        if (tr.startsWith("\u0634\u0645\u0627\u0631\u0647 \u0646\u0638\u0627\u0645:")) {
            result.push(line.replace(/شماره نظام:\s*\.{5,}/, `\u{634}\u{645}\u{627}\u{631}\u{647} \u{646}\u{638}\u{627}\u{645}: ${doctor?.medicalCode || ''}`));
            i++;
            continue;
        }
        result.push(line);
        i++;
    }
    // Append test/imaging orders if not already covered by the template
    const labOrders = (pendingTests || []).filter((test)=>!test.type || test.type === 'lab');
    const imgOrders = (pendingTests || []).filter((test)=>test.type === 'imaging');
    if (labOrders.length + imgOrders.length > 0) {
        result.push('');
        result.push("\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC \u0628\u0627\u0644\u06CC\u0646\u06CC:");
        labOrders.forEach((order)=>{
            const urg = order.urgency === 'urgent' || order.urgency === 'stat' ? " [\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC]" : '';
            result.push(`\u{2022} \u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}: ${order.name || order.testName || ''}${urg}`);
        });
        imgOrders.forEach((order)=>{
            const urg = order.urgency === 'urgent' || order.urgency === 'stat' ? " [\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC]" : '';
            result.push(`\u{2022} \u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC}: ${order.name || order.testName || ''}${urg}`);
        });
    }
    return result.join('\n');
}
function $375f8776645d5aee$export$fd7ee5a010036e9e({ template: template, rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const filled = $375f8776645d5aee$export$1512fb0c882aac98(template.content, {
        t: t,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today
    });
    return `<!DOCTYPE html><html dir="rtl" lang="fa"><head><meta charset="UTF-8">
<title>\u{646}\u{633}\u{62E}\u{647} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC} - ${$375f8776645d5aee$export$4cf11838cdc2a8a8(patient?.name || '')}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Tahoma,Arial,sans-serif;direction:rtl;background:#fff;color:#222}
.page{width:148mm;min-height:210mm;margin:0 auto;padding:10mm 12mm;border:1px solid #ccc}
@media print{body{margin:0}.page{border:none;width:100%;padding:8mm}@page{size:A5;margin:5mm}}
pre{white-space:pre-wrap;font-family:Tahoma,Arial,sans-serif;font-size:12.5px;line-height:1.9;color:#222}
.foot{font-size:9px;color:#ccc;text-align:center;margin-top:20px;padding-top:8px;border-top:1px solid #eee}
</style></head><body>
<div class="page">
<pre>${$375f8776645d5aee$export$4cf11838cdc2a8a8(filled)}</pre>
<div class="foot">${$375f8776645d5aee$export$49f892522e84db92()}</div>
</div></body></html>`;
}
function $375f8776645d5aee$export$2429942a486a55fe({ rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const dxText = soap?.a || diagnosis || '';
    const instructions = soap?.p || '';
    const labOrders = (pendingTests || []).filter((test)=>!test.type || test.type === 'lab');
    const imgOrders = (pendingTests || []).filter((test)=>test.type === 'imaging');
    const drugRows = (rxItems || []).map((item, idx)=>`
    <div class="drug-item">
      <div class="drug-num">${idx + 1}</div>
      <div>
        <div class="drug-name" dir="auto">${$375f8776645d5aee$export$4cf11838cdc2a8a8((0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug) || item.name || '')}</div>
        <div class="drug-detail">${[
            item.dosage,
            item.route,
            item.frequency,
            item.duration ? `\u{628}\u{647} \u{645}\u{62F}\u{62A} ${item.duration}` : '',
            item.quantity
        ].filter(Boolean).join(" \xb7 ")}</div>
        ${item.instructions ? `<div class="drug-detail">${item.instructions}</div>` : ''}
      </div>
    </div>`).join('');
    const labRows = labOrders.map((order)=>`
    <div class="order-item">
      <span class="order-badge lab">\u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}\u{6AF}\u{627}\u{647}</span>
      ${order.urgency === 'urgent' || order.urgency === 'stat' ? '<span class="order-badge urgent">\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC</span>' : ''}
      <span class="order-name">${order.name || order.testName || ''}</span>
    </div>`).join('');
    const imgRows = imgOrders.map((order)=>`
    <div class="order-item">
      <span class="order-badge imaging">\u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC}</span>
      ${order.urgency === 'urgent' || order.urgency === 'stat' ? '<span class="order-badge urgent">\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC</span>' : ''}
      <span class="order-name">${order.name || order.testName || ''}</span>
    </div>`).join('');
    return `<!DOCTYPE html>
<html dir="rtl" lang="fa">
<head>
<meta charset="UTF-8">
<title>\u{646}\u{633}\u{62E}\u{647} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC} - ${patient?.name || ''}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Tahoma,Arial,sans-serif;direction:rtl;background:#fff;color:#222;font-size:12px}
.page{width:148mm;min-height:210mm;margin:0 auto;padding:8mm 10mm;border:1px solid #ccc}
@media print{body{margin:0}.page{border:none;width:100%;padding:8mm}@page{size:A5;margin:5mm}}
.hdr{border-bottom:2.5px solid #1B4E6B;padding-bottom:10px;margin-bottom:12px;display:flex;justify-content:space-between;align-items:flex-start}
.dr-name{font-size:18px;font-weight:900;color:#1B4E6B}
.dr-meta{font-size:11px;color:#555;margin-top:3px}
.date-box{font-size:11px;color:#555;text-align:center;border:1px solid #ddd;padding:5px 10px;border-radius:4px}
.date-val{font-weight:700;color:#333;margin-bottom:2px}
.date-lbl{font-size:10px;color:#aaa}
.patient-row{background:#f0f6fb;border-radius:0px;padding:7px 12px;margin-bottom:12px;display:flex;gap:24px}
.pt-label{font-size:10px;color:#888;margin-bottom:1px}
.pt-val{font-weight:700;color:#1B4E6B}
.sec-title{display:flex;align-items:center;gap:8px;margin:10px 0 6px;font-size:11px;font-weight:700;color:#1B4E6B}
.sec-line{flex:1;height:1px;background:#e5e7eb}
.dx-box{background:#fff8e7;border-right:3px solid #F59E0B;padding:7px 12px;border-radius:4px;font-size:12.5px;margin-bottom:10px}
.drug-item{display:flex;gap:10px;margin-bottom:10px;padding-bottom:10px;border-bottom:1px dashed #eee;align-items:flex-start}
.drug-num{width:22px;height:22px;border-radius:50%;background:#1B4E6B;color:#fff;font-size:11px;font-weight:700;text-align:center;line-height:22px;flex-shrink:0;margin-top:1px}
.drug-name{font-weight:700;font-size:13px;color:#111}
.drug-detail{font-size:11px;color:#666;margin-top:2px}
.order-item{display:flex;gap:6px;margin-bottom:5px;align-items:center}
.order-badge{font-size:10px;padding:1px 7px;border-radius:0px;font-weight:600}
.lab{background:#dbeafe;color:#1d4ed8}
.imaging{background:#fce7f3;color:#9d174d}
.urgent{background:#fee2e2;color:#991b1b}
.order-name{font-size:12px;color:#333}
.instr-box{border:1px dashed #ccc;border-radius:0px;padding:8px 12px;font-size:11.5px;color:#333;line-height:1.8;white-space:pre-wrap;min-height:48px;margin-bottom:10px}
.sig-area{display:flex;justify-content:space-between;align-items:flex-end;padding-top:12px;border-top:1px solid #e5e7eb;margin-top:20px}
.sig-block{text-align:center}
.sig-line{width:90px;border-bottom:1px solid #999;margin-bottom:4px;height:32px}
.sig-lbl{font-size:10px;color:#888}
.footer-note{font-size:9px;color:#ccc}
</style>
</head>
<body>
<div class="page">
  <div class="hdr">
    <div>
      <div class="dr-name">\u{62F}\u{6A9}\u{62A}\u{631} ${doctor?.name || "\u2014"}</div>
      ${doctor?.specialty ? `<div class="dr-meta">\u{645}\u{62A}\u{62E}\u{635}\u{635} ${doctor.specialty}</div>` : ''}
      ${doctor?.medicalCode ? `<div class="dr-meta">\u{6A9}\u{62F} \u{646}\u{638}\u{627}\u{645} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC}: ${doctor.medicalCode}</div>` : ''}
    </div>
    <div class="date-box">
      <div class="date-val">${today}</div>
      <div class="date-lbl">\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{646}\u{633}\u{62E}\u{647}</div>
    </div>
  </div>
  <div class="patient-row">
    <div><div class="pt-label">\u{646}\u{627}\u{645} \u{628}\u{6CC}\u{645}\u{627}\u{631}</div><div class="pt-val">${patient?.name || "\u2014"}</div></div>
    ${patient?.nationalId ? `<div><div class="pt-label">\u{6A9}\u{62F} \u{645}\u{644}\u{6CC}</div><div class="pt-val" style="color:#333">${patient.nationalId}</div></div>` : ''}
  </div>
  ${dxText ? `<div class="sec-title">\u{62A}\u{634}\u{62E}\u{6CC}\u{635} <div class="sec-line"></div></div><div class="dx-box">${dxText}</div>` : ''}
  ${(rxItems || []).length > 0 ? `<div class="sec-title">\u{62F}\u{627}\u{631}\u{648}\u{647}\u{627} <div class="sec-line"></div></div>${drugRows}` : ''}
  ${labOrders.length > 0 ? `<div class="sec-title">\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634} <div class="sec-line"></div></div>${labRows}` : ''}
  ${imgOrders.length > 0 ? `<div class="sec-title">\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC} <div class="sec-line"></div></div>${imgRows}` : ''}
  <div class="sec-title">\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{62A} \u{67E}\u{632}\u{634}\u{6A9} <div class="sec-line"></div></div>
  <div class="instr-box">${instructions}</div>
  <div class="sig-area">
    <div class="footer-note">${$375f8776645d5aee$export$49f892522e84db92()}</div>
    <div class="sig-block"><div class="sig-line"></div><div class="sig-lbl">\u{627}\u{645}\u{636}\u{627} \u{648} \u{645}\u{647}\u{631} \u{67E}\u{632}\u{634}\u{6A9}</div></div>
  </div>
</div>
</body>
</html>`;
}
const $375f8776645d5aee$export$abc13ae812b14a42 = {
    paper: '#ffffff',
    ink: '#111111',
    inkSoft: '#333333',
    inkMuted: '#666666',
    inkFaint: '#888888',
    hairline: '#eeeeee',
    rule: '#e5e7eb',
    brand: '#1B4E6B',
    patientBg: '#f0f6fb',
    dxBg: '#fff8e7',
    dxRule: '#F59E0B',
    labBg: '#dbeafe',
    labInk: '#1d4ed8',
    imgBg: '#fce7f3',
    imgInk: '#9d174d',
    statBg: '#fee2e2',
    statInk: '#991b1b',
    watermark: '#cccccc',
    dashed: '#cccccc',
    font: '"Tahoma","Arial",sans-serif'
};
const $375f8776645d5aee$export$2d0aef78bb90a46a = 'visit_record_sections_v1';
const $375f8776645d5aee$export$bd00c9f029ebc508 = Object.fromEntries((0, $792124e2f7de719a$export$286013f25f0f7b72).map((section)=>[
        section.id,
        true
    ]));
function $375f8776645d5aee$export$e5c711a17013eb66(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        return {
            ...$375f8776645d5aee$export$bd00c9f029ebc508,
            ...JSON.parse(store?.getItem($375f8776645d5aee$export$2d0aef78bb90a46a) || '{}')
        };
    } catch  {
        // Private mode, quota, or a corrupt value — the shipped page, not a throw.
        return {
            ...$375f8776645d5aee$export$bd00c9f029ebc508
        };
    }
}
function $375f8776645d5aee$export$6523efd640f02d3b(layout, storedVisitLayout, doctorLoading, updateSettings) {
    const [recordOpen, setRecordOpen] = (0, $acw62.useState)($375f8776645d5aee$export$e5c711a17013eb66);
    // The server copy wins over the cache, ONCE, when it lands. Re-adopting on
    // every settings refetch would slam a section the doctor just opened shut
    // again mid-visit.
    const adopted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (adopted.current || doctorLoading || !storedVisitLayout) return;
        adopted.current = true;
        setRecordOpen((prev)=>{
            const next = {
                ...prev,
                ...(0, $792124e2f7de719a$export$f9d63a319ff0f5db)(layout)
            };
            try {
                localStorage.setItem($375f8776645d5aee$export$2d0aef78bb90a46a, JSON.stringify(next));
            } catch  {}
            return next;
        });
    }, [
        doctorLoading,
        storedVisitLayout,
        layout
    ]);
    const toggleRecordSection = (0, $acw62.useCallback)((id)=>{
        setRecordOpen((prev)=>{
            const next = {
                ...prev,
                [id]: !prev[id]
            };
            try {
                localStorage.setItem($375f8776645d5aee$export$2d0aef78bb90a46a, JSON.stringify(next));
            } catch  {}
            // Persist best-effort: the panel and the cache have already moved, and a
            // failed write must not interrupt a visit over a collapsed section.
            const recordSectionsCollapsed = Object.keys(next).filter((key)=>next[key] === false);
            Promise.resolve(updateSettings?.('visitLayout', {
                recordSectionsCollapsed: recordSectionsCollapsed
            })).catch(()=>{});
            return next;
        });
    }, [
        updateSettings
    ]);
    return {
        recordOpen: recordOpen,
        toggleRecordSection: toggleRecordSection
    };
}
function $375f8776645d5aee$export$e57f8733307287ae({ template: template, rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, t: t }) {
    // i18n-exempt: printed-document date. The sheet this stamps is read by an
    // Iranian pharmacy, so it is Persian whatever the panel's UI language is —
    // the same reason the document itself is built as `<html dir="rtl" lang="fa">`.
    // Do NOT route this through `formatDate`: that would follow the doctor's UI
    // language and put Arabic-Indic or Latin digits on the paper.
    const today = new Date().toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const html = template ? $375f8776645d5aee$export$fd7ee5a010036e9e({
        template: template,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today,
        t: t
    }) : $375f8776645d5aee$export$2429942a486a55fe({
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today,
        t: t
    });
    const win = window.open('', '_blank', 'width=640,height=900,menubar=yes');
    if (!win) return false;
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(()=>win.print(), 500);
    return true;
}




// A re-opened visit's lines, each with its «در فهرست تأمین» (taminListed).
const $0a8c07ac6d7bacfd$var$askMedications = (0, $8d8ac6402cc7b03c$export$405a623d7e907e9d)((0, $adebb901af88e18b$export$7fb4864174f056c));
// An edit writes the medication's `quantity` COLUMN along with its dosage: the
// تأمین submission reads srvQty from the column, and op-naji falls back to it when
// the dosage holds none — so a column left at its first value sent the old count,
// and one the doctor had CLEARED sent a count they had taken back (K1,
// 2026-10-03). `UpdateMedicationInput.quantity` is newer than this hook, and a BFF
// that predates it refuses the WHOLE input; an edit must not be lost to that, so
// the save is sent again without the column.
const $0a8c07ac6d7bacfd$var$quantityRefused = (e)=>/\bquantity\b/.test(e?.message || '') && /UpdateMedicationInput/.test(e?.message || '');
async function $0a8c07ac6d7bacfd$var$updateMedication(id, input) {
    try {
        return await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
            id: id,
            input: input
        });
    } catch (e) {
        if (!$0a8c07ac6d7bacfd$var$quantityRefused(e)) throw e;
        const withoutColumn = {
            ...input
        };
        delete withoutColumn.quantity;
        return (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
            id: id,
            input: withoutColumn
        });
    }
}
function $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3({ appointmentId: appointmentId, patientId: patientId, setRxItems: setRxItems, rxItems: rxItems }) {
    // Writes are debounced per ROW: a dosage is typed a character at a time and
    // each keystroke must not become a mutation, while the text on screen updates
    // immediately either way.
    const timers = (0, $acw62.useRef)(new Map());
    const byId = (0, $acw62.useRef)(new Map());
    // Rows this hook wrote itself (writeNow), by row id → medication id. The row's
    // own `medicationId` arrives through state a render later; this is what a save,
    // a delete or a second writeNow in that gap reads instead, so nothing is
    // written twice and nothing is orphaned.
    const written = (0, $acw62.useRef)(new Map());
    // Rows the doctor removed. Gone from the screen at once; their record is deleted
    // on the queue below, after any write of them still in flight — so a draft in
    // this set is never created, and an edit to it is never saved.
    const removed = (0, $acw62.useRef)(new Set());
    const medicationIdOf = (row, rowId)=>row?.medicationId || written.current.get(rowId) || null;
    (0, $acw62.useEffect)(()=>{
        byId.current = new Map((rxItems || []).map((r)=>[
                r.id,
                r
            ]));
    }, [
        rxItems
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            timers.current.forEach(clearTimeout);
            timers.current.clear();
        }, []);
    // ── ONE queue for every write to the record ─────────────────────────────────
    //
    // An edit's save, a removal's delete and writeNow all run on it, one at a time,
    // in the order they were asked for. writeNow used to wait only for the saves
    // still on their timers: a save already out, a delete (fired and forgotten), and
    // a draft being created while its line was removed all raced the e-prescription
    // that writeNow is called before — which then sent a line the doctor had just
    // removed, an orphan of one, or the dose from before an edit (K1, 2026-10-03).
    const queue = (0, $acw62.useRef)(Promise.resolve());
    const enqueue = (0, $acw62.useCallback)((op)=>{
        const done = queue.current.then(op);
        queue.current = done.catch(()=>{});
        return done;
    }, []);
    // Settled once NOTHING is queued — not only what was queued when it was asked:
    // a delete or a save that joins while a write is out is waited for as well.
    const settled = (0, $acw62.useCallback)(async ()=>{
        let tail;
        do {
            tail = queue.current;
            await tail;
        }while (tail !== queue.current);
    }, []);
    // Read the row at WRITE time, not at schedule time: the whole point of the
    // delay is that more edits arrive during it, and the last one is the one the
    // doctor means. Runs ON the queue (or inside a writeNow that is).
    const saveRow = (0, $acw62.useCallback)(async (rowId)=>{
        if (removed.current.has(rowId)) return;
        const row = byId.current.get(rowId);
        const id = medicationIdOf(row, rowId);
        if (!row || !id) return;
        try {
            await $0a8c07ac6d7bacfd$var$updateMedication(id, {
                display: row.drug?.name || '',
                dosageInstruction: (0, $5e2e0b7ea22d1ff2$export$1ed13c90275604ad)(row),
                // 0 is «not stated» on the wire — what a cleared quantity must say.
                quantity: (0, $ace44487380106d3$export$48f972f5effb9c)(row.quantity) || 0
            });
        } catch (e) {
            console.warn('[rx] persist medication edit failed:', e.message);
        }
    }, []);
    const scheduleSave = (0, $acw62.useCallback)((rowId)=>{
        clearTimeout(timers.current.get(rowId));
        timers.current.set(rowId, setTimeout(()=>{
            timers.current.delete(rowId);
            enqueue(()=>saveRow(rowId));
        }, 700));
    }, [
        saveRow,
        enqueue
    ]);
    /** Forget a row's pending write — it is being deleted, or the visit is over. */ const cancelSave = (0, $acw62.useCallback)((rowId)=>{
        clearTimeout(timers.current.get(rowId));
        timers.current.delete(rowId);
    }, []);
    /**
   * Delete the record behind a row, if it has one. Local removal is the caller's.
   *
   * Queued, so it waits for a create of the same row that is still out, and the
   * id it deletes is read when it RUNS. A failed delete is not only logged: the
   * record still holds the line, so the line goes back on the نسخه, where it was,
   * marked `removeFailed` — what the doctor sees is what would be sent, and
   * removing it again retries.
   */ const deleteRow = (0, $acw62.useCallback)((rowId)=>{
        const row = byId.current.get(rowId);
        const at = [
            ...byId.current.keys()
        ].indexOf(rowId);
        cancelSave(rowId);
        removed.current.add(rowId);
        enqueue(async ()=>{
            const id = medicationIdOf(row, rowId);
            if (!id) return;
            try {
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$608c51c2a533f155), {
                    id: id
                });
                written.current.delete(rowId);
            } catch (e) {
                console.warn('[rx] delete medication failed:', e.message);
                removed.current.delete(rowId);
                if (!row) return;
                const back = {
                    ...row,
                    medicationId: id,
                    removeFailed: true
                };
                setRxItems((prev)=>{
                    if (prev.some((r)=>r.id === rowId)) return prev;
                    const next = [
                        ...prev
                    ];
                    next.splice(at < 0 ? next.length : Math.min(at, next.length), 0, back);
                    return next;
                });
            }
        });
    }, [
        cancelSave,
        enqueue,
        setRxItems
    ]);
    /**
   * Write the نسخه to the record NOW, as it is on screen: every pending edit, and
   * every draft line — exactly as closing the visit would write it (useEndVisit),
   * so a reader of the record sees what the doctor sees. The e-prescription card
   * in the visit's نسخه/دستورات section calls this before each read and send,
   * because the server builds the prescription from the record (K1, 2026-10-03).
   * A draft written here gets its `medicationId`, which is what keeps closing the
   * visit from writing it a second time. Calls are queued, never overlapped, and
   * the returned promise settles only when every write queued before or during
   * it — a save, a delete — has reached the record.
   *
   * `fresh` names lines just put on the نسخه in the same handler, which this hook
   * has not seen yet: it reads the list a render late (an applied treatment plan).
   */ const writeNow = (0, $acw62.useCallback)((fresh)=>{
        const extra = Array.isArray(fresh) ? fresh : [];
        enqueue(async ()=>{
            const pending = [
                ...timers.current.keys()
            ];
            pending.forEach((rowId)=>clearTimeout(timers.current.get(rowId)));
            timers.current.clear();
            await Promise.all(pending.map(saveRow));
            if (!appointmentId || !patientId) return;
            const rows = new Map(byId.current);
            extra.forEach((r)=>{
                if (r?.id != null && !rows.has(r.id)) rows.set(r.id, r);
            });
            const drafts = [
                ...rows.entries()
            ].filter(([rowId, row])=>row?.drug && !medicationIdOf(row, rowId) && !removed.current.has(rowId));
            for (const [rowId, row] of drafts){
                // Removed while an earlier draft was being written: never created.
                if (removed.current.has(rowId)) continue;
                try {
                    const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5fcaf1729c987f4d), {
                        patientId: patientId,
                        input: {
                            code: row.drug.genericName || row.drug.name,
                            display: row.drug.name,
                            status: 'active',
                            authoredOn: new Date().toISOString().split('T')[0],
                            dosageInstruction: (0, $5e2e0b7ea22d1ff2$export$1ed13c90275604ad)(row),
                            quantity: (0, $ace44487380106d3$export$48f972f5effb9c)(row.quantity),
                            meta: (0, $5e2e0b7ea22d1ff2$export$2fe3f622dc680493)(row.drug),
                            appointmentId: appointmentId
                        }
                    });
                    const id = res?.createMedication?.id;
                    if (!id) continue;
                    written.current.set(rowId, id);
                    setRxItems((prev)=>prev.map((r)=>r.id === rowId ? {
                                ...r,
                                medicationId: id
                            } : r));
                    // An edit made while this write was in flight landed on a row with no
                    // id yet and was not written — write the row as it is now. (A row
                    // removed meanwhile is not saved; its delete is queued behind this.)
                    const now = byId.current.get(rowId);
                    if (now && now !== row) await saveRow(rowId);
                } catch (e) {
                    console.warn('[rx] write draft line failed:', e.message);
                }
            }
        });
        return settled();
    }, [
        appointmentId,
        patientId,
        saveRow,
        setRxItems,
        enqueue,
        settled
    ]);
    /**
   * Let every edit and delete already asked for reach the record — the saves
   * still waiting on their delay included — WITHOUT writing the draft lines.
   * What the e-prescription status is read behind (useErxStatus, K1
   * 2026-10-04): it must see the edit the doctor just made, but a line still
   * being composed is not the record's yet.
   */ const flush = (0, $acw62.useCallback)(()=>{
        enqueue(async ()=>{
            const pending = [
                ...timers.current.keys()
            ];
            pending.forEach((rowId)=>clearTimeout(timers.current.get(rowId)));
            timers.current.clear();
            await Promise.all(pending.map(saveRow));
        });
        return settled();
    }, [
        saveRow,
        enqueue,
        settled
    ]);
    // ── Re-opening a visit ──────────────────────────────────────────────────────
    //
    // MERGED, never assigned: the doctor may already have typed rows that are not
    // saved yet, and `mergeRxItems` keys on the server id so nothing is dropped
    // and nothing is listed twice.
    //
    // `hydration` says how that read went ('idle' | 'loading' | 'ready' | 'error')
    // and `rehydrate` asks again — for a surface that opens ON a visit's نسخه, the
    // past-visit «اصلاح نسخه» sheet (K1, 2026-10-04), where an empty list must not
    // be mistaken for one that failed to load.
    const hydratedFor = (0, $acw62.useRef)(null);
    const [hydration, setHydration] = (0, $acw62.useState)('idle');
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const key = `${appointmentId}\u0000${attempt}`;
        if (!appointmentId || !patientId || hydratedFor.current === key) return;
        hydratedFor.current = key;
        setHydration('loading');
        $0a8c07ac6d7bacfd$var$askMedications((0, $5e2e0b7ea22d1ff2$export$46ab2989285eb791), {
            patientId: patientId,
            appointmentId: appointmentId
        }).then((data)=>{
            const rows = (data?.listMedications || []).map((0, $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1)).filter(Boolean);
            if (rows.length) setRxItems((prev)=>(0, $5e2e0b7ea22d1ff2$export$801d163b2e9340ef)(prev, rows));
            setHydration('ready');
        })// A failed read leaves the tab as it was, and does NOT retry on the next
        // render: that would be a loop. Nothing is lost — the rows are in the
        // record, and the doctor can still prescribe.
        .catch((e)=>{
            console.warn('[rx] could not load this visit\'s medications:', e.message);
            setHydration('error');
        });
    }, [
        appointmentId,
        patientId,
        setRxItems,
        attempt
    ]);
    const rehydrate = (0, $acw62.useCallback)(()=>setAttempt((n)=>n + 1), []);
    return {
        scheduleSave: scheduleSave,
        cancelSave: cancelSave,
        deleteRow: deleteRow,
        writeNow: writeNow,
        flush: flush,
        hydration: hydration,
        rehydrate: rehydrate
    };
}



var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

// ویزیت تصویری — loading and driving the Jitsi IFrame API.
//
// React-free on purpose, like the rest of src/lib: this module knows about a
// script tag and an external API object, and nothing about the screen it is
// drawn on. The hook (src/hooks/useVideoVisit.js) owns the React side.
//
// ── Why the script is loaded at RUN TIME from the server's answer ────────────
// `external_api.js` must come from the SAME host that serves the conference,
// and which host that is arrives in `videoVisitSession.domain` — from the BFF,
// per environment. Bundling it, or configuring the URL in the client, would put
// a second copy of "which environment am I in" in the client, and a staging
// client pointed at a production media server is exactly the kind of mismatch
// runtimeEnv.js's BFF_WS_BASE derivation exists to prevent.

var $eLeza = parcelRequire("eLeza");

var $hlTfq = parcelRequire("hlTfq");
/** Resolved script loads, keyed by domain — the tag is added at most once. */ const $331226a77f852a09$var$loaded = new Map();
/**
 * The call's own interface language when the caller names none: Persian, as it
 * has always been — unless the brand does not offer Persian (ui/lib/brand.js),
 * where it is the panel's language, the one the person is reading.
 */ const $331226a77f852a09$var$defaultCallLanguage = ()=>{
    const offered = (0, $eLeza.brand)().locales;
    return !offered || offered.includes('fa') ? 'fa' : (0, $hlTfq.documentLocale)();
};
function $331226a77f852a09$export$e5f23e1a6d5d1e7b(domain) {
    if (!domain) return Promise.reject(new Error('jitsi: no domain'));
    const existing = $331226a77f852a09$var$loaded.get(domain);
    if (existing) return existing;
    const promise = new Promise((resolve, reject)=>{
        // Already there — a previous load in this session, or a remount after the
        // map was cleared. The global is what matters, not our bookkeeping.
        if (typeof window !== 'undefined' && window.JitsiMeetExternalAPI) {
            resolve(window.JitsiMeetExternalAPI);
            return;
        }
        const script = document.createElement('script');
        script.src = `https://${domain}/external_api.js`;
        script.async = true;
        script.onload = ()=>{
            if (window.JitsiMeetExternalAPI) resolve(window.JitsiMeetExternalAPI);
            else reject(new Error('jitsi: script loaded but API is missing'));
        };
        script.onerror = ()=>{
            // The tag is dropped so a later attempt can retry: a failed load that
            // leaves its tag behind makes every retry a no-op.
            $331226a77f852a09$var$loaded.delete(domain);
            script.remove();
            reject(new Error('jitsi: script failed to load'));
        };
        document.head.appendChild(script);
    });
    $331226a77f852a09$var$loaded.set(domain, promise);
    return promise;
}
function $331226a77f852a09$export$dcaa598e6bc560df({ roomName: roomName, token: token, displayName: displayName, parentNode: parentNode, prejoin: prejoin = false, lang: lang = $331226a77f852a09$var$defaultCallLanguage(), providerName: // The brand as the CALL shows it — window title, join/leave notifications.
// An argument rather than a literal because it is user-facing and therefore
// translatable: the doctor app passes it through t(), and this module has no
// i18n of its own (it is React-free by design). The Latin default is the
// brand's name (ui/lib/brand.js), safe in any locale, and keeps this file
// free of UI strings.
providerName = (0, $eLeza.brandName)('en') }) {
    return {
        roomName: roomName,
        jwt: token,
        parentNode: parentNode,
        width: '100%',
        height: '100%',
        userInfo: {
            displayName: displayName
        },
        configOverwrite: {
            // The doctor joins from inside the visit workspace and the patient from
            // a card they already tapped; a prejoin screen is a second confirmation
            // of a decision already made. The patient app turns it back on, where
            // checking your own camera before a doctor sees you is worth the tap.
            //
            // `prejoinConfig` and nothing else: the older `prejoinPageEnabled` is not
            // on the config whitelist — see «Branding» below — so it was doing
            // nothing, and this is the key the device-check screen actually obeys.
            prejoinConfig: {
                enabled: prejoin
            },
            startWithAudioMuted: false,
            startWithVideoMuted: false,
            disableDeepLinking: true,
            // 1:1. Nobody is invited, so nothing offers to invite.
            disableInviteFunctions: true,
            doNotStoreRoom: true,
            // ── Branding: the ONE key that reaches the conference ────────────────
            // An empty logo URL means the watermark renders nothing at all. It is not
            // a preference — it is the only lever the client has:
            //
            //   • Jitsi filters EVERY override we send. `configOverwrite` and
            //     `interfaceConfigOverwrite` both travel as URL-hash params that
            //     external_api.js appends, and the app picks them through a whitelist
            //     before merging. Whatever is not on the list is dropped in silence;
            //     the console logs only the survivors, as «Extending config with: …».
            //   • The interfaceConfig whitelist — 44 keys in jitsi/web:stable-11031 —
            //     contains NO logo or watermark key. SHOW_JITSI_WATERMARK,
            //     DEFAULT_LOGO_URL and their neighbours were set here for months and
            //     never once took effect: that is how the Jitsi logo outlived the
            //     commit that "removed" it.
            //   • The logo url moved to config.defaultLogoUrl. Left unset, a legacy
            //     shim in the bundle falls back to the hardcoded images/watermark.svg
            //     — the Jitsi logo — because the server's interface_config.js has
            //     DEFAULT_LOGO_URL commented out. Setting it is the whole fix.
            //   • This key is whitelisted only while the app runs in an IFRAME
            //     (`window.self !== window.top`), which every Parsina client does. If
            //     a future jitsi/web image drops that gate the logo comes back, and
            //     this line is the first place to look; the escape hatch is then
            //     server-side — see parsina.k8s.deployments/jitsi/README.md.
            //
            // To show پارسینا in the call rather than nothing, this is the one line
            // to change: 'images/parsina-logo.png' is already served by the media
            // server (parsina.k8s.deployments/jitsi/branding.yaml). Relative on
            // purpose — it resolves against the conference host, so the image is
            // same-origin, carries no build hash and names no environment.
            defaultLogoUrl: '',
            // Jitsi's OWN transcriber, refused. It is NOT «پایش بالینی», which is
            // Parsina's own AI reading the conversation live to draft the note and
            // writing nothing to disk. Do not turn this on to enable that — they are
            // unrelated systems. See docs/online-visit-audio-capture.md.
            transcribingEnabled: false,
            liveStreamingEnabled: false,
            hideConferenceSubject: true,
            hideConferenceTimer: false,
            disableThirdPartyRequests: true
        },
        interfaceConfigOverwrite: {
            // Only whitelisted keys reach the conference (see «Branding» above), and
            // these are the ones the list actually honours. Anything about the
            // watermark or the logo belongs in configOverwrite.defaultLogoUrl —
            // adding a SHOW_*_WATERMARK key back here changes nothing at all.
            TOOLBAR_BUTTONS: [
                'microphone',
                'camera',
                'desktop',
                'fullscreen',
                'settings',
                'videoquality',
                'tileview',
                'hangup'
            ],
            // Nothing is KEPT. Recording is not offered because it is absent from
            // TOOLBAR_BUTTONS, the minted token refuses it, and there is no jibri
            // container that could honour it — those three facts are the guarantee.
            // The fileRecordingsEnabled flag that used to sit in configOverwrite read
            // like a fourth one and was discarded by the whitelist unread.
            PROVIDER_NAME: providerName,
            NATIVE_APP_NAME: providerName,
            SHOW_POWERED_BY: false,
            // No DEFAULT_BACKGROUND. It would have to be a literal colour — the
            // design tokens are CSS `var()` references and mean nothing inside
            // Jitsi's iframe — and a raw hex is exactly what the conformance tests
            // in both clients refuse. The branding is on OUR chrome around the frame;
            // the video area is the video.
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: false
        },
        lang: lang
    };
}
async function $331226a77f852a09$export$323cdae55ed0200(options) {
    const JitsiMeetExternalAPI = await $331226a77f852a09$export$e5f23e1a6d5d1e7b(options.domain);
    const { domain: domain, ...rest } = options;
    return new JitsiMeetExternalAPI(domain, $331226a77f852a09$export$dcaa598e6bc560df(rest));
}


// «پایش بالینی» — taking the visit's audio from the CALL instead of the mic.
//
// The parent half of parsina.k8s.deployments/jitsi/bridge/parsina-audio-bridge.js.
// React-free, like the rest of src/lib: it knows about an iframe and a message
// channel, and nothing about the screen it is used on.
//
// ── Why this exists ─────────────────────────────────────────────────────────
// During a video visit the microphone is the wrong source, and not by a little:
//
//   · The patient is INAUDIBLE on it. Their voice reaches the doctor through
//     the speakers, and echo cancellation exists precisely to remove that — so
//     «پایش بالینی» captured one half of a dialogue and the AI, whose prompt
//     assumes "a raw mixed recording" of both people, wrote a confident note
//     from it. A half-transcript that looks whole is worse than none.
//   · On iOS Safari a second `getUserMedia` steals the audio session, so
//     starting monitoring could break the call's own microphone.
//
// The conference already holds both tracks. It just lives on another origin, so
// a script inside it hands them over here.
//
// ── What this module does NOT decide ────────────────────────────────────────
// Whether to monitor at all. It is a source, nothing more: it starts when asked
// and stops when asked, exactly like the microphone it replaces.
/** Message names, byte-identical to the in-iframe half. */ const $7c08ab51fde905a5$export$78d8c50e853acd10 = {
    START: 'parsina:audio:start',
    STOP: 'parsina:audio:stop',
    READY: 'parsina:audio:ready',
    CHUNK: 'parsina:audio:chunk',
    STATE: 'parsina:audio:state',
    ERROR: 'parsina:audio:error'
};
/** How long to wait for the bridge to answer before falling back. */ const $7c08ab51fde905a5$var$READY_TIMEOUT_MS = 4000;
function $7c08ab51fde905a5$export$e24590596d9795fc(iframe, origin, onChunk) {
    return new Promise((resolve, reject)=>{
        const target = iframe?.contentWindow;
        if (!target || !origin) {
            reject(new Error('bridge: no conference frame'));
            return;
        }
        let settled = false;
        let timer = null;
        const onMessage = (event)=>{
            // Both checks matter: the origin proves it is the conference, and the
            // source window proves it is OUR conference and not another frame on the
            // same host.
            if (event.origin !== origin || event.source !== target) return;
            const data = event.data;
            if (!data || typeof data.type !== 'string') return;
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.CHUNK && data.chunk) {
                // Arrives as an ArrayBuffer; the socket wants something sendable.
                onChunk(new Blob([
                    data.chunk
                ], {
                    type: 'audio/webm'
                }));
                return;
            }
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.READY && !settled) {
                settled = true;
                clearTimeout(timer);
                resolve({
                    sources: Number(data.sources) || 0,
                    stop () {
                        window.removeEventListener('message', onMessage);
                        try {
                            target.postMessage({
                                type: $7c08ab51fde905a5$export$78d8c50e853acd10.STOP
                            }, origin);
                        } catch  {
                        // The frame is already gone; nothing to stop.
                        }
                    }
                });
                return;
            }
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.ERROR && !settled) {
                settled = true;
                clearTimeout(timer);
                window.removeEventListener('message', onMessage);
                reject(new Error(`bridge: ${data.reason || 'failed'}`));
            }
        };
        window.addEventListener('message', onMessage);
        try {
            target.postMessage({
                type: $7c08ab51fde905a5$export$78d8c50e853acd10.START
            }, origin);
        } catch (err) {
            window.removeEventListener('message', onMessage);
            reject(err);
            return;
        }
        timer = setTimeout(()=>{
            if (settled) return;
            settled = true;
            window.removeEventListener('message', onMessage);
            // Silence here means an older media server with no bridge script. Say so
            // plainly rather than waiting forever with the meter running.
            reject(new Error('bridge: no response'));
        }, $7c08ab51fde905a5$var$READY_TIMEOUT_MS);
    });
}
function $7c08ab51fde905a5$export$6e2ba4bd9a522bbc(api, container) {
    try {
        const fromApi = api?.getIFrame?.();
        if (fromApi) return fromApi;
    } catch  {
    // Not available on this version.
    }
    return container?.querySelector?.('iframe') || null;
}



const $b23a4f29e1a7fc1a$export$985b4499d05c66a6 = 'idle';
const $b23a4f29e1a7fc1a$export$3c482fb33388beb2 = 'starting';
const $b23a4f29e1a7fc1a$export$1617cb1ce4943d48 = 'live';
const $b23a4f29e1a7fc1a$export$93578a4f81d1df7e = 'error';
/** Read a GraphQL error code off whichever shape bffClient produced. */ function $b23a4f29e1a7fc1a$var$errorCode(err) {
    return err?.extensions?.code || err?.graphQLErrors?.[0]?.extensions?.code || null;
}
function $b23a4f29e1a7fc1a$export$fd58d87a1fa8fc0d({ patientId: patientId, appointmentId: appointmentId, ensureVisitStarted: ensureVisitStarted, providerName: providerName }) {
    const [state, setState] = (0, $acw62.useState)($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
    const [error, setError] = (0, $acw62.useState)(null);
    const [available, setAvailable] = (0, $acw62.useState)(null);
    const [reason, setReason] = (0, $acw62.useState)(null);
    const [canConvert, setCanConvert] = (0, $acw62.useState)(false);
    const [converting, setConverting] = (0, $acw62.useState)(false);
    const [convertError, setConvertError] = (0, $acw62.useState)(false);
    const [enlarged, setEnlarged] = (0, $acw62.useState)(false);
    const apiRef = (0, $acw62.useRef)(null);
    const openingRef = (0, $acw62.useRef)(false);
    const containerRef = (0, $acw62.useRef)(null);
    // The conference frame and its origin, for «پایش بالینی» — during a call the
    // audio must come from the CALL, not from a second microphone that cannot
    // hear the patient. Null whenever no call is live, which is what makes the
    // in-person path fall through to the microphone unchanged.
    const [audioSource, setAudioSource] = (0, $acw62.useState)(null);
    /**
   * Take the conference down.
   *
   * Handlers are removed BEFORE `dispose()`: disposing fires
   * `readyToClose`/`videoConferenceLeft`, and a handler still attached would run
   * against state a later session may already own.
   */ const teardown = (0, $acw62.useCallback)(()=>{
        const api = apiRef.current;
        apiRef.current = null;
        openingRef.current = false;
        if (!api) return;
        try {
            api.removeAllListeners?.();
            api.dispose?.();
        } catch  {
        // A conference that is already gone is the state we wanted.
        }
    }, []);
    /**
   * Can this deployment open a call for this patient, right now?
   *
   * Cheap: `videoVisitAvailability` mints nothing and writes nothing, so it is
   * safe on mount and safe to repeat. It answers `not_configured` rather than
   * failing when the deployment has no media server.
   */ const probe = (0, $acw62.useCallback)(async ()=>{
        if (!patientId) {
            setAvailable(false);
            setCanConvert(false);
            setReason(null);
            return;
        }
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$eaa2f90824feaabb), {
                patientId: patientId,
                appointmentId: appointmentId || null
            });
            const a = data?.videoVisitAvailability;
            setAvailable(Boolean(a?.canJoin));
            setCanConvert(Boolean(a?.canConvert));
            setReason(a?.reason || null);
        } catch  {
            // A probe that failed is not a feature that is off, but for the purpose of
            // drawing a button the two are the same: do not offer what we could not
            // confirm.
            setAvailable(false);
            setCanConvert(false);
            setReason(null);
        }
    }, [
        patientId,
        appointmentId
    ]);
    const start = (0, $acw62.useCallback)(async ()=>{
        if (openingRef.current || apiRef.current) return;
        openingRef.current = true;
        setError(null);
        setState($b23a4f29e1a7fc1a$export$3c482fb33388beb2);
        try {
            // Pressing connect starts the visit. Done FIRST and through the screen's
            // own path, so a doctor answering a waiting patient never has to press
            // «شروع ویزیت» separately — and so there is still only one place that
            // marks an appointment in_visit.
            let apptId = appointmentId || null;
            if (!apptId && ensureVisitStarted) apptId = await ensureVisitStarted();
            // A fresh session BEFORE anything else. The token is short-lived by
            // design, so the query is re-run rather than its answer cached — and
            // re-running it is also what re-checks that this visit is still open.
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$6651891395397547), {
                patientId: patientId,
                appointmentId: apptId || null
            });
            const session = data?.videoVisitSession;
            if (!session) {
                setAvailable(false);
                throw new Error('unavailable');
            }
            // The panel mounts its container in the same render that flips state to
            // STARTING, so the node exists by the time the await above resolves. If it
            // does not, the panel was closed mid-open — stop rather than attach a
            // conference to nothing.
            const parentNode = containerRef.current;
            if (!parentNode) {
                openingRef.current = false;
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                return;
            }
            const api = await (0, $331226a77f852a09$export$323cdae55ed0200)({
                domain: session.domain,
                roomName: session.roomName,
                token: session.token,
                displayName: session.displayName,
                parentNode: parentNode,
                providerName: providerName,
                // The doctor is already inside the visit; a device-check screen here is
                // a second confirmation of a decision already made.
                prejoin: false
            });
            // Closed while the script was loading.
            if (!containerRef.current) {
                try {
                    api.dispose?.();
                } catch  {}
                openingRef.current = false;
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                return;
            }
            apiRef.current = api;
            openingRef.current = false;
            setState($b23a4f29e1a7fc1a$export$1617cb1ce4943d48);
            // Published only once the conference is actually up, so «پایش بالینی»
            // can never attach to a frame that is still negotiating.
            const frame = (0, $7c08ab51fde905a5$export$6e2ba4bd9a522bbc)(api, parentNode);
            setAudioSource(frame ? {
                frame: frame,
                origin: `https://${session.domain}`
            } : null);
            // «قطع تماس» inside the Jitsi UI, and any other end the iframe decides on.
            // Without this the panel would keep showing a dead conference.
            api.addListener('readyToClose', ()=>{
                teardown();
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                setEnlarged(false);
                setAudioSource(null);
            });
            api.addListener('errorOccurred', (event)=>{
                // Only a fatal error takes the call down; Jitsi reports recoverable ones
                // (a brief reconnect) through the same channel.
                if (event?.error?.isFatal) {
                    teardown();
                    setError('connection');
                    setState($b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
                    setEnlarged(false);
                    setAudioSource(null);
                }
            });
        } catch (err) {
            teardown();
            const code = $b23a4f29e1a7fc1a$var$errorCode(err);
            setError(code === 'VISIT_NOT_EDITABLE' ? 'visitOver' : code === 'NO_OPEN_APPOINTMENT' ? 'noAppointment' : code === 'NOT_ONLINE' || err?.message === 'unavailable' ? 'unavailable' : 'connection');
            setState($b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
            setEnlarged(false);
        }
    }, [
        patientId,
        appointmentId,
        ensureVisitStarted,
        providerName,
        teardown
    ]);
    /**
   * Change the visit's mode and take the BFF's fresh answer as the new state.
   * Returns true when the write landed.
   */ const setMode = (0, $acw62.useCallback)(async (online)=>{
        if (!patientId || converting) return false;
        setConverting(true);
        setConvertError(false);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$16ac3aeec5aaa168), {
                patientId: patientId,
                appointmentId: appointmentId || null,
                online: online
            });
            const a = data?.setVisitMode;
            setAvailable(Boolean(a?.canJoin));
            setCanConvert(Boolean(a?.canConvert));
            setReason(a?.reason || null);
            return true;
        } catch  {
            setConvertError(true);
            return false;
        } finally{
            setConverting(false);
        }
    }, [
        patientId,
        appointmentId,
        converting
    ]);
    /**
   * «تبدیل به ویزیت آنلاین». With `andCall`, the same press goes on to open the
   * call — the doctor asked for an online visit, not for a second button.
   */ const convert = (0, $acw62.useCallback)(async ({ andCall: andCall = false } = {})=>{
        const ok = await setMode(true);
        if (ok && andCall) await start();
        return ok;
    }, [
        setMode,
        start
    ]);
    /** «برگرداندن به ویزیت حضوری» — never under a running call. */ const revert = (0, $acw62.useCallback)(async ()=>{
        if (apiRef.current || openingRef.current) return false;
        return setMode(false);
    }, [
        setMode
    ]);
    const clearConvertError = (0, $acw62.useCallback)(()=>setConvertError(false), []);
    /** «پایان تماس» from OUR chrome, as opposed to Jitsi's own hangup. */ const stop = (0, $acw62.useCallback)(()=>{
        const api = apiRef.current;
        // Ask the conference to leave properly first so the other side sees a
        // departure rather than a silence; teardown then disposes regardless.
        try {
            api?.executeCommand?.('hangup');
        } catch  {}
        teardown();
        setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
        setError(null);
        setEnlarged(false);
        setAudioSource(null);
    }, [
        teardown
    ]);
    /** «بزرگ‌نمایی» / «کوچک‌نمایی» — a CSS size change on ONE node. See VisitCall.jsx. */ const toggleEnlarged = (0, $acw62.useCallback)(()=>setEnlarged((v)=>!v), []);
    // Esc returns from the enlarged view. Attached only WHILE enlarged, so this
    // screen's sheets and dialogs keep their own Esc the rest of the time.
    (0, $acw62.useEffect)(()=>{
        if (!enlarged) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') setEnlarged(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        enlarged
    ]);
    // A conference outlives the screen unless something ends it. This is the
    // camera indicator staying lit after the doctor navigated away.
    (0, $acw62.useEffect)(()=>teardown, [
        teardown
    ]);
    // Moving to another visit must not leave the previous visit's call running in
    // a container that now belongs to a different patient.
    (0, $acw62.useEffect)(()=>{
        teardown();
        setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
        setError(null);
        setEnlarged(false);
        setAudioSource(null);
        setConvertError(false);
    }, [
        patientId,
        teardown
    ]);
    return {
        state: state,
        error: error,
        available: available,
        reason: reason,
        containerRef: containerRef,
        enlarged: enlarged,
        audioSource: audioSource,
        canConvert: canConvert,
        converting: converting,
        convertError: convertError,
        live: state === $b23a4f29e1a7fc1a$export$1617cb1ce4943d48,
        busy: state === $b23a4f29e1a7fc1a$export$3c482fb33388beb2,
        probe: probe,
        start: start,
        stop: stop,
        toggleEnlarged: toggleEnlarged,
        convert: convert,
        revert: revert,
        clearConvertError: clearConvertError
    };
}


// ویزیت تصویری — the call, in پرونده بیمار: pinned to the foot of the desktop rail
// (`dock="bottom"`, PM-0023), at the top of the phone's record.
//
// ── Why this is NOT literally a `RecordSection` ─────────────────────────────
// It speaks that component's header grammar — icon, title, status chip, a
// one-line gist while collapsed, inline actions, chevron — and sits in the same
// rail as the record sections. But `RecordSection` renders its body as
// `{open && <div>{children}</div>}`, and an UNMOUNT is exactly what must never
// happen here: the body holds the Jitsi iframe, so collapsing the section would
// drop the call. Collapsing hides the video by HEIGHT instead; the conference
// keeps running and the audio keeps flowing, which is also the honest behaviour
// — a doctor who folds the section away has not hung up.
//
// ── THE ONE-NODE RULE (do not refactor this away) ───────────────────────────
// `containerRef` is where Jitsi attaches its iframe. Re-parenting an iframe in
// the DOM RELOADS it, and React unmounts and remounts a subtree whenever it
// renders in a different position in the tree. So:
//
//   · the container div is rendered in EXACTLY ONE place, unconditionally, for
//     the whole life of the call;
//   · docked vs enlarged is nothing but a different `style` object on the
//     WRAPPER around it — the container's own position in the tree never moves;
//   · the header is one component in both states (same type, different props),
//     so the container is always the same child index and React never has cause
//     to recreate it;
//   · the container has NO React children, ever. React owns the chrome around
//     it; Jitsi owns everything inside it.
//
// Written any other way — a portal, a `key` on the enlarged flag, a
// `{enlarged ? <Modal>…</Modal> : <Rail>…</Rail>}` — the call drops every time
// the doctor zooms, which is the one interaction this panel exists for.
//
// ── An in-person visit: the band offers a CONVERSION, not a call ─────────────
// A call belongs to an online visit (PM-0019). On an in-person one the hook
// reports `canConvert`, and the same band — same header, same one node — holds
// «تبدیل به ویزیت آنلاین» where the connect button would be: the visit's type
// changes (its price does not), and the call follows in the same press. On the
// PHONE the band does not render in that state at all: the conversion is a
// 44px control at the end of the tab strip and a sheet (Visit.mobile.jsx), so
// an in-person visit — nearly every visit — gives the call no height.
// An online visit that has no call running can be turned back the same way.
//
// ── The enlarged view has no scrim, deliberately ────────────────────────────
// A scrim would put the chart, the copilot and the prescription behind glass,
// and a doctor on a video visit is still charting. The panel floats over the
// work area instead: bigger patient, everything still readable and typeable
// underneath. Esc (owned by the hook) returns to docked.
/**
 * THE PALETTE. Framework tokens, not the Visit workspace's private `--…` set.
 *
 * This panel is SHARED by the desktop workspace and the phone, and only
 * `Visit.web.jsx` ever injected `CSS_VARS`. On mobile every one of those custom
 * properties resolved to nothing — and a browser DROPS an invalid declaration
 * while keeping a valid one, so `background: var(--primary)` vanished and the
 * literal `color: '#fff'` beside it stayed: «تماس با بیمار» was white text on a
 * white card, and the panel had no surface and no borders either.
 *
 * Injecting the private palette into the mobile tree would have fixed the
 * symptom and broken the rule — §2.2 retired that sub-theme on the phone, and
 * `uiUnification` asserts it. Reading the tokens directly is what makes one
 * component legal in both trees.
 *
 * The values are the ones `CSS_VARS` already assigned, so the desktop is
 * pixel-identical; `CT.navy`/`CT.accent` are framework globals, which is a gain
 * — the call button now follows the theme preset the doctor picked, where
 * `--primary` was frozen at whatever the Visit page happened to define.
 */ /**
 * The Visit workspace's warm «focus mode» band — a raw literal because that is
 * what it is on the desktop: a documented exception to the token palette owned
 * by that page (`CSS_VARS` → `--field`), not a colour role. It never reaches
 * the phone; see the wrapper below.
 */ const $013436dd88cfa3ff$var$FIELD = '#faf8f5';
const $013436dd88cfa3ff$var$S = {
    primary: (0, $jTCZr.CT).navy,
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    accent: (0, $jTCZr.CT).accent,
    danger: (0, $jTCZr.CT).danger,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    good: (0, $jTCZr.CT).good,
    goodSoft: (0, $jTCZr.CT).goodSoft,
    goodInk: (0, $jTCZr.CT).goodInk,
    radius: '10px',
    radiusLg: '14px',
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
/** Docked video width is the rail's, minus its padding. 4:3 — one face, not a meeting. */ const $013436dd88cfa3ff$var$DOCKED_ASPECT = 0.75;
/** The enlarged panel. Wide enough to actually examine someone; not the screen. */ const $013436dd88cfa3ff$var$ENLARGED_WIDTH = 720;
function $013436dd88cfa3ff$var$VideoIcon({ size: size = 13, color: color = $013436dd88cfa3ff$var$S.accent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M22 8l-6 4 6 4V8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "2",
        y: "6",
        width: "14",
        height: "12",
        rx: "2"
    }));
}
function $013436dd88cfa3ff$var$HangUpIcon({ size: size = 13, color: color = '#fff' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "23",
        y1: "1",
        x2: "1",
        y2: "23"
    }));
}
function $013436dd88cfa3ff$var$ResizeIcon({ enlarged: enlarged, size: size = 13, color: color = $013436dd88cfa3ff$var$S.ink2 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, enlarged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "4 14 10 14 10 20"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "20 10 14 10 14 4"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 21 3 21 3 15"
    })));
}
function $013436dd88cfa3ff$var$ChevronIcon({ open: open, size: size = 13, color: color = $013436dd88cfa3ff$var$S.mute }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "6 9 12 15 18 9"
    }));
}
function $013436dd88cfa3ff$var$ShieldIcon({ size: size = 12 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: $013436dd88cfa3ff$var$S.mute,
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
    }));
}
/**
 * The header row — ONE component in every state, so the video container beneath
 * it keeps a stable position among its siblings and is never recreated.
 */ function $013436dd88cfa3ff$var$CallHeader({ t: t, live: live, busy: busy, enlarged: enlarged, patientName: patientName, open: open, onToggle: onToggle, onResize: onResize, onHangUp: onHangUp }) {
    const showChip = live || busy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            // Folded and idle, the section is a single slim row.
            padding: enlarged ? '9px 14px' : open || showChip ? '11px 16px' : '7px 16px',
            background: enlarged ? $013436dd88cfa3ff$var$S.primary : 'transparent',
            color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggle,
        "aria-expanded": open,
        "data-testid": "visit-call-toggle",
        title: open ? t('visit.panel.collapse') : t('visit.panel.expand'),
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            color: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.accent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            fontSize: 13,
            whiteSpace: 'nowrap'
        }
    }, enlarged ? patientName || t('visit.call.section') : t('visit.call.section')), showChip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-call-chip",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            padding: '3px 9px',
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            flexShrink: 0,
            fontSize: 11,
            fontWeight: 700,
            background: enlarged ? 'rgba(255,255,255,.16)' : $013436dd88cfa3ff$var$S.goodSoft,
            color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.goodInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 5,
            height: 5,
            borderRadius: '50%',
            display: 'inline-block',
            background: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.good,
            animation: 'pulse 1.6s infinite'
        }
    }), live ? t('visit.call.live') : t('visit.call.connecting')), !enlarged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            display: 'inline-flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ChevronIcon, {
        open: open
    }))), showChip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onResize,
        "data-testid": "visit-call-resize",
        "aria-pressed": enlarged,
        "aria-label": enlarged ? t('visit.call.shrink') : t('visit.call.enlarge'),
        title: enlarged ? t('visit.call.shrink') : t('visit.call.enlarge'),
        style: {
            width: 26,
            height: 26,
            borderRadius: 7,
            flexShrink: 0,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'inherit',
            border: enlarged ? 'none' : `1px solid ${$013436dd88cfa3ff$var$S.line2}`,
            background: enlarged ? 'rgba(255,255,255,.16)' : $013436dd88cfa3ff$var$S.panel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ResizeIcon, {
        enlarged: enlarged,
        color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.ink2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onHangUp,
        "data-testid": "visit-call-hangup",
        "aria-label": t('visit.call.hangUp'),
        title: t('visit.call.hangUp'),
        style: {
            height: 26,
            minWidth: 26,
            borderRadius: 7,
            flexShrink: 0,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            padding: enlarged ? '0 12px' : 0,
            border: 'none',
            background: $013436dd88cfa3ff$var$S.danger,
            color: '#fff',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$HangUpIcon, null), enlarged && t('visit.call.hangUp'))));
}
function $013436dd88cfa3ff$export$2e2bcd8739ae039({ call: call, patientName: patientName, variant: variant = 'web', dock: dock = 'top' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { state: state, error: error, available: available, reason: reason, live: live, busy: busy, enlarged: enlarged, containerRef: containerRef, start: start, stop: stop, toggleEnlarged: toggleEnlarged, canConvert: canConvert, converting: converting, convertError: convertError, convert: convert, revert: revert } = call;
    // FOLDED by default. An online visit is under 5% of visits; the other 95% the
    // doctor is charting a patient who is in the room, and a camera panel above
    // the allergies is space taken from that work. Folded, the section is one
    // slim row — the doctor opens it when they mean to call.
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    /** Connecting or connected — the only states in which the video has height. */ const inCall = live || busy;
    const errored = state === (0, $b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
    // A call that starts while the section is folded away would run invisibly,
    // and a call that just dropped must show why — both open it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inCall || errored) setOpen(true);
    }, [
        inCall,
        errored
    ]);
    // Nothing to draw at all when this deployment has no media server, when there
    // is no open appointment to call about, or when the visit is over. A button
    // that always fails is worse than no button — it reads as a broken feature
    // rather than an absent one.
    //
    // An error is the one case that still renders while `available` is false: a
    // call that just dropped must leave the doctor a way back, not vanish.
    /** An open in-person visit: the band offers the conversion instead of a call. */ const convertible = !available && Boolean(canConvert) && !inCall && !errored;
    if (!inCall && !errored && !available && !convertible) return null;
    // The phone's conversion lives in the tab strip + a sheet, not in the flow.
    if (convertible && variant === 'mobile') return null;
    const gist = live ? t('visit.call.gistLive') : reason === 'visit_over' ? t('visit.call.gistOver') : reason === 'no_appointment' ? t('visit.call.gistNoAppointment') : reason === 'in_person' ? t('visit.call.gistInPerson') : t('visit.call.gistReady');
    // The whole panel moves; the video container inside it does not. Docked, this
    // is an ordinary block in the rail. Enlarged, it is fixed to the viewport —
    // which is safe here because no ancestor of the Visit grid carries a
    // `transform`, `filter` or `will-change`. If one is ever added, the enlarged
    // panel would be trapped inside the 340px column instead.
    const isMobile = variant === 'mobile';
    const wrapperStyle = enlarged && !isMobile ? {
        position: 'fixed',
        top: 78,
        insetInlineStart: 24,
        width: $013436dd88cfa3ff$var$ENLARGED_WIDTH,
        maxWidth: 'calc(100vw - 48px)',
        background: $013436dd88cfa3ff$var$S.panel,
        border: `1px solid ${$013436dd88cfa3ff$var$S.line2}`,
        borderRadius: $013436dd88cfa3ff$var$S.radiusLg,
        boxShadow: $013436dd88cfa3ff$var$S.shadowPop,
        overflow: 'hidden',
        // Above the workspace, below the record sheets (1200) and the print modal
        // (1100): a ConfirmDialog for «پایان ویزیت» must still cover this.
        zIndex: 60
    } : {
        // The docked band's own surface. On the desktop that is the Visit
        // workspace's warm «focus mode» tint — a documented scope exception that
        // belongs to that page. §2.2 retired the warm-beige sub-theme on the
        // phone, so there the band is the neutral token surface instead: the same
        // job (separate the call from the chart below it), in each surface's own
        // palette.
        background: isMobile ? (0, $jTCZr.CT).surface2 : $013436dd88cfa3ff$var$FIELD,
        ...dock === 'bottom' ? {
            // `marginTop: auto` keeps it on the floor of a short record too; the
            // z-index is the rail header's, so sections scroll UNDER the band.
            position: 'sticky',
            bottom: 0,
            zIndex: 2,
            marginTop: 'auto',
            flexShrink: 0,
            borderTop: `1px solid ${$013436dd88cfa3ff$var$S.line}`,
            boxShadow: '0 -4px 12px rgba(15,23,42,.05)'
        } : {
            borderBottom: `1px solid ${$013436dd88cfa3ff$var$S.line}`
        }
    };
    const videoHeight = !open ? 0 : isMobile ? enlarged ? 380 : 206 : enlarged ? Math.round(($013436dd88cfa3ff$var$ENLARGED_WIDTH - 32) * $013436dd88cfa3ff$var$DOCKED_ASPECT) : 231;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "data-testid": "visit-call",
        "data-state": state,
        "data-enlarged": enlarged ? 'true' : 'false',
        "aria-label": t('visit.call.panelLabel'),
        style: wrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$CallHeader, {
        t: t,
        live: live,
        busy: busy,
        enlarged: enlarged && !isMobile,
        patientName: patientName,
        open: open,
        onToggle: ()=>setOpen((v)=>!v),
        onResize: toggleEnlarged,
        onHangUp: stop
    }), !open && !enlarged && !live && reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 11px',
            fontSize: 11,
            color: $013436dd88cfa3ff$var$S.mute,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, gist), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: open ? '0 16px' : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        "data-testid": "visit-call-video",
        role: "presentation",
        style: {
            height: inCall ? videoHeight : 0,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            background: inCall ? $013436dd88cfa3ff$var$S.ink : 'transparent',
            overflow: 'hidden',
            position: 'relative',
            transition: 'height .18s ease'
        }
    })), busy && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '8px 16px 0',
            fontSize: 11.5,
            color: $013436dd88cfa3ff$var$S.mute,
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, t('visit.call.connecting')), error && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 16px 0'
        },
        role: "alert",
        "data-testid": "visit-call-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            padding: '10px 12px',
            background: $013436dd88cfa3ff$var$S.dangerSoft,
            border: `1px solid ${$013436dd88cfa3ff$var$S.danger}`,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            fontSize: 12,
            color: $013436dd88cfa3ff$var$S.dangerInk,
            lineHeight: 1.8
        }
    }, t(`visit.call.error.${error}`))), convertible && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        },
        "data-testid": "visit-call-convert-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: $013436dd88cfa3ff$var$S.ink2,
            lineHeight: 1.8,
            marginBottom: 10
        }
    }, t('visit.call.convertBody')), convertError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-call-convert-error",
        style: {
            padding: '8px 12px',
            marginBottom: 10,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            background: $013436dd88cfa3ff$var$S.dangerSoft,
            border: `1px solid ${$013436dd88cfa3ff$var$S.danger}`,
            fontSize: 12,
            color: $013436dd88cfa3ff$var$S.dangerInk,
            lineHeight: 1.8
        }
    }, t('visit.call.convertError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>convert({
                andCall: true
            }),
        disabled: converting,
        "data-testid": "visit-call-convert",
        style: {
            width: '100%',
            minHeight: 40,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 7,
            border: 'none',
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            cursor: converting ? 'progress' : 'pointer',
            opacity: converting ? 0.7 : 1,
            background: $013436dd88cfa3ff$var$S.primary,
            color: '#fff'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        size: 15,
        color: "#fff"
    }), converting ? t('visit.call.converting') : t('visit.call.convertAndCall'))), !inCall && !convertible && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: start,
        disabled: !available,
        "data-testid": "visit-call-connect",
        style: {
            width: '100%',
            minHeight: 40,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 7,
            border: 'none',
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            cursor: available ? 'pointer' : 'not-allowed',
            opacity: available ? 1 : 0.55,
            background: $013436dd88cfa3ff$var$S.primary,
            color: '#fff'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        size: 15,
        color: "#fff"
    }), state === (0, $b23a4f29e1a7fc1a$export$93578a4f81d1df7e) ? t('visit.call.redial') : t('visit.call.connect')), available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: 11,
            color: $013436dd88cfa3ff$var$S.mute
        }
    }, t('visit.call.connectHint')), available && revert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: revert,
        disabled: converting,
        "data-testid": "visit-call-revert",
        style: {
            marginTop: 6,
            minHeight: isMobile ? 44 : 28,
            padding: 0,
            background: 'none',
            border: 'none',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 600,
            color: $013436dd88cfa3ff$var$S.ink2,
            textDecoration: 'underline',
            cursor: converting ? 'progress' : 'pointer'
        }
    }, t('visit.call.revert'))), inCall && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-call-not-recorded",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px 12px',
            fontSize: 10.5,
            color: $013436dd88cfa3ff$var$S.mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ShieldIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.call.notRecorded'))));
}





var $acw62 = parcelRequire("acw62");

var $e317r = parcelRequire("e317r");

const $29025bf29a861ca6$var$WALLET_QUERY = `
  query GetWalletBalance($ownerId: String!, $ownerType: String!) {
    walletBalance(ownerId: $ownerId, ownerType: $ownerType) {
      balance
      currency
    }
  }
`;
const $29025bf29a861ca6$export$86382edbd39ea53 = 'parsina:wallet-changed';
function $29025bf29a861ca6$export$70e96f88d72639c() {
    if (typeof window !== 'undefined') window.dispatchEvent(new Event($29025bf29a861ca6$export$86382edbd39ea53));
}
function $29025bf29a861ca6$export$512f6b8a30d065e1(doctorId) {
    const [balance, setBalance] = (0, $acw62.useState)(null);
    // The HOST's path, not a router's: the clinical module has no router of its own.
    const { pathname: pathname = '' } = (0, $e317r.useClinicalHost)();
    const prevPathRef = (0, $acw62.useRef)(pathname);
    const fetch = (0, $acw62.useCallback)(()=>{
        if (!doctorId) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)($29025bf29a861ca6$var$WALLET_QUERY, {
            ownerId: doctorId,
            ownerType: 'doctor'
        }).then((data)=>setBalance(data?.walletBalance?.balance ?? null)).catch(()=>{});
    }, [
        doctorId
    ]);
    // Fetch on mount and whenever doctorId changes
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    // Refetch when navigating back to any non-visit screen (e.g. returning from visit)
    (0, $acw62.useEffect)(()=>{
        const prev = prevPathRef.current;
        const curr = pathname;
        prevPathRef.current = curr;
        // Only refetch if we navigated away from a visit screen
        if (prev.includes('/visit') && !curr.includes('/visit')) fetch();
    }, [
        pathname,
        fetch
    ]);
    // Refetch when something in this tab moved the balance.
    (0, $acw62.useEffect)(()=>{
        window.addEventListener($29025bf29a861ca6$export$86382edbd39ea53, fetch);
        return ()=>window.removeEventListener($29025bf29a861ca6$export$86382edbd39ea53, fetch);
    }, [
        fetch
    ]);
    // Refetch when the tab becomes visible again (user switches back)
    (0, $acw62.useEffect)(()=>{
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') fetch();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>document.removeEventListener('visibilitychange', onVisible);
    }, [
        fetch
    ]);
    return balance;
}






// Parsina-Credit («پارسه») balance thresholds.
//
// THE DEFINITION MOVED. It lives in `@parsina/framework/tokens` as of framework
// v0.10.0 and this file is now a re-export, so the ~15 call sites that know it by
// this path keep working while there is exactly ONE copy in the monorepo.
//
// It moved because there were three: this file, the dentist client's
// `constants/credit.js` and the clinic client's `hooks/useClinicCredits.js`, each
// carrying the same two numbers and the same three levels, and each commented
// "deliberately identical to the other panel's" — three files kept in sync by
// comment, which is not a mechanism. One person has ONE wallet: a dentist who
// also uses this panel is looking at the same balance in both, so «اعتبار کم»
// cannot mean 50 پارسه here and something else there.
//
// Add nothing to this file. A new rule about how a balance is painted belongs in
// the framework, where every panel gets it.

var $jTCZr = parcelRequire("jTCZr");


var $jTCZr = parcelRequire("jTCZr");

// Reading a visit's SOAP note — one implementation for every surface.
//
// THREE shapes are live in the data, and a reader that knows one of them shows
// an empty — or worse, mislabelled — note for the other two:
//
//   1. one row, noteType SOAP_NOTE, content {s, o, a, p}   ← what this app writes
//   2. one row per section, noteType SOAP_S / subjective / …, text in content
//   3. one row, noteType SOAP, content a flat "S: …\n\nO: …" string
//      ← what the Flutter doctor app writes
//
// This module is that reader. It was the desktop record's private logic; the
// phone had its own, narrower version and could not display a normal SOAP note
// at all, which is exactly the class of divergence a shared module prevents.
// Shape 3 matters for the same reason in the other direction: a visit charted on
// the Flutter app is read here, and would otherwise show as one unsplit block.
const $a044c29e4a6b3520$export$7c327048bd66c9d9 = [
    'S',
    'O',
    'A',
    'P'
];
const $a044c29e4a6b3520$var$SOAP_TYPES = {
    S: [
        'SOAP_S',
        'subjective',
        'chief_complaint',
        'history'
    ],
    O: [
        'SOAP_O',
        'objective',
        'examination',
        'findings'
    ],
    A: [
        'SOAP_A',
        'assessment',
        'evaluation'
    ],
    P: [
        'SOAP_P',
        'plan',
        'treatment_plan'
    ]
};
function $a044c29e4a6b3520$export$90858b03e74b9658(c) {
    if (typeof c === 'string') try {
        return JSON.parse(c);
    } catch  {
        return {
            text: c
        };
    }
    if (c && typeof c === 'object') return c;
    return {};
}
function $a044c29e4a6b3520$export$9329abe70f8a78fc(n) {
    if (!n) return '';
    const c = n.content;
    if (typeof c === 'string') return c;
    if (c && typeof c === 'object') {
        if (typeof c.text === 'string') return c.text;
        return Object.values(c).filter((v)=>typeof v === 'string' && v.trim()).join('\n\n');
    }
    return '';
}
const $a044c29e4a6b3520$export$c9bd16384a2ab405 = (n)=>[
        'SOAP_NOTE',
        'SOAP'
    ].includes((n?.noteType || '').toUpperCase());
const $a044c29e4a6b3520$export$7be7553f2fdf281 = (n)=>(n?.noteType || '').toUpperCase() === 'VISIT_SUMMARY';
function $a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k) {
    const c = $a044c29e4a6b3520$export$90858b03e74b9658(n?.content);
    const lower = k.toLowerCase();
    if (typeof c[lower] === 'string' && c[lower].trim()) return c[lower];
    return typeof c[k] === 'string' ? c[k] : '';
}
function $a044c29e4a6b3520$export$621a2712ace849e5(text) {
    const out = {};
    if (typeof text !== 'string' || !text.trim()) return out;
    const re = /(^|\n)\s*([SOAP])\s*:\s*/g;
    const marks = [];
    let m;
    while((m = re.exec(text)) !== null)marks.push({
        key: m[2],
        from: m.index + m[0].length
    });
    if (!marks.length) return out;
    marks.forEach((mark, i)=>{
        const end = i + 1 < marks.length ? text.lastIndexOf('\n', marks[i + 1].from) : text.length;
        out[mark.key] = text.slice(mark.from, end < mark.from ? text.length : end).trim();
    });
    return out;
}
function $a044c29e4a6b3520$export$b26efe9e640f95c2(notes) {
    const soaps = (notes || []).filter($a044c29e4a6b3520$export$c9bd16384a2ab405);
    return soaps.find((n)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.some((k)=>$a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k).trim())) || soaps[0] || null;
}
function $a044c29e4a6b3520$export$e6f6e37795c24083(notes, k) {
    const list = notes || [];
    for (const n of list){
        if (!$a044c29e4a6b3520$export$c9bd16384a2ab405(n)) continue;
        const v = $a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k);
        if (v.trim()) return v;
        // A note written by the Flutter app is one flat string, not four keys.
        const c = $a044c29e4a6b3520$export$90858b03e74b9658(n.content);
        const flat = typeof n.content === 'string' ? n.content : typeof c.text === 'string' ? c.text : '';
        const split = $a044c29e4a6b3520$export$621a2712ace849e5(flat)[k];
        if (split) return split;
    }
    const types = $a044c29e4a6b3520$var$SOAP_TYPES[k] || [];
    return list.filter((n)=>types.some((item)=>(n.noteType || '').toLowerCase().includes(item.toLowerCase()))).map($a044c29e4a6b3520$export$9329abe70f8a78fc).filter(Boolean).join('\n\n');
}
const $a044c29e4a6b3520$export$41de64d84beb8926 = (notes)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.reduce((acc, k)=>{
        acc[k] = $a044c29e4a6b3520$export$e6f6e37795c24083(notes, k);
        return acc;
    }, {});
const $a044c29e4a6b3520$export$be3e5596841df79 = (notes)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.some((k)=>$a044c29e4a6b3520$export$e6f6e37795c24083(notes, k).trim());
const $a044c29e4a6b3520$export$3389fc0b000be7e3 = (notes)=>(notes || []).filter((n)=>!$a044c29e4a6b3520$export$7be7553f2fdf281(n) && !$a044c29e4a6b3520$export$c9bd16384a2ab405(n) && !$a044c29e4a6b3520$export$a4eacf66670598b3(n));
function $a044c29e4a6b3520$export$a4eacf66670598b3(n) {
    const nt = (n?.noteType || '').toLowerCase();
    return Object.values($a044c29e4a6b3520$var$SOAP_TYPES).some((types)=>types.some((item)=>nt.includes(item.toLowerCase())));
}
function $a044c29e4a6b3520$export$320c8a0e29298519(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleString('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
}
const $a044c29e4a6b3520$export$9cbdfdc6daea18e2 = (enc)=>[
        'in_progress',
        'in-progress',
        'active'
    ].includes((enc?.status || '').toLowerCase());


const $b840d32ddf66046b$var$PUBMED_BASE = 'https://eutils.ncbi.nlm.nih.gov/entrez/eutils';
async function $b840d32ddf66046b$export$afaf1496218aac9a(query, conditions = [], maxResults = 3) {
    try {
        // Build a focused query: condition terms + question keywords
        const condTerms = conditions.slice(0, 3).join(' OR ');
        const combined = condTerms ? `(${condTerms}) AND (${query})` : query;
        const encoded = encodeURIComponent(combined);
        const searchRes = await fetch(`${$b840d32ddf66046b$var$PUBMED_BASE}/esearch.fcgi?db=pubmed&term=${encoded}&retmax=${maxResults}&retmode=json&sort=relevance`, {
            signal: AbortSignal.timeout(6000)
        });
        const searchData = await searchRes.json();
        const ids = searchData.esearchresult?.idlist || [];
        if (!ids.length) return [];
        const summaryRes = await fetch(`${$b840d32ddf66046b$var$PUBMED_BASE}/esummary.fcgi?db=pubmed&id=${ids.join(',')}&retmode=json`, {
            signal: AbortSignal.timeout(6000)
        });
        const summaryData = await summaryRes.json();
        return ids.map((id)=>{
            const doc = summaryData.result?.[id];
            if (!doc) return null;
            return {
                pmid: id,
                title: doc.title || '',
                journal: doc.fulljournalname || doc.source || '',
                year: doc.pubdate?.split(' ')[0] || '',
                url: `https://pubmed.ncbi.nlm.nih.gov/${id}/`
            };
        }).filter(Boolean);
    } catch  {
        return [];
    }
}



var $acw62 = parcelRequire("acw62");

var $a83Oj = parcelRequire("a83Oj");



// WHY «پایش بالینی» could not start (or died) — `recError.kind` from
// useTranscription, and the key under `visit.monitoringError.*` that explains it.
//
// Every one of these used to be a `console.error` and a `return` with the state
// left on `idle` — so the doctor pressed the button, it looked exactly as it did
// before, and the only record of why was a console nobody opens. Each kind is
// something the doctor can act on differently, which is the test for splitting
// it out: «allow the microphone» and «plug one in» are not the same instruction.
//
// Its own module rather than an export of the hook alone, because the visit
// screens' tests replace the hook module wholesale; the dialog must still be able
// to read the vocabulary when they do.
const $fd4d0818319d4b44$export$5b7e21fbf8c676ba = {
    MIC_DENIED: 'micDenied',
    MIC_NOT_FOUND: 'micNotFound',
    MIC_BUSY: 'micBusy',
    UNSUPPORTED: 'unsupported',
    SESSION: 'session',
    AUTH: 'auth',
    CONNECTION: 'connection',
    CREDIT: 'credit',
    SERVICE: 'service',
    CALL_AUDIO: 'callAudio'
};


// How long to wait for the final transcript after «توقف پایش بالینی» before
// giving up and closing the socket.
//
// This was 5s, which is shorter than the work it waits on. On stop the AI
// service re-transcribes the ENTIRE visit buffer in one provider call, so the
// wait grows with the length of the recording: measured against the real
// service, a 25s recording answered in 3.3s but a 2-minute one took 8.5s — and
// that was direct egress, without the cluster's LLM proxy in the path. Every
// visit longer than about a minute therefore lost its transcript, because
// closing the socket makes the BFF cancel the gRPC stream (`call.cancel()` in
// transcribeHandler.js) and the finished text is discarded server-side.
//
// A ceiling is still wanted so a genuinely dead stream cannot hang «در حال
// پردازش» forever; it just has to be longer than a long visit's final pass
// rather than shorter than a short one's. The UI shows `stopping` throughout.
const $b5da27b488005ec5$var$FINAL_TRANSCRIPT_TIMEOUT_MS = 120000;
const $b5da27b488005ec5$export$a82430915e8eaf8e = {
    IDLE: 'idle',
    CONNECTING: 'connecting',
    RECORDING: 'recording',
    STOPPING: 'stopping',
    PAUSED_BY_SYSTEM: 'paused-by-system',
    ERROR: 'error'
};
// The DOMException names getUserMedia rejects with, per the spec and the
// legacy Chrome/Firefox spellings still seen on older builds.
const $b5da27b488005ec5$var$MIC_ERROR_KINDS = {
    NotAllowedError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_DENIED,
    PermissionDeniedError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_DENIED,
    SecurityError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_DENIED,
    NotFoundError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_NOT_FOUND,
    DevicesNotFoundError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_NOT_FOUND,
    OverconstrainedError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_NOT_FOUND,
    NotReadableError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_BUSY,
    TrackStartError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_BUSY,
    AbortError: (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).MIC_BUSY
};
function $b5da27b488005ec5$export$7361891803c21a19(err) {
    return $b5da27b488005ec5$var$MIC_ERROR_KINDS[err?.name] || (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).UNSUPPORTED;
}
// A server-side `{ error }` frame carries the gRPC message verbatim
// ("8 RESOURCE_EXHAUSTED: اعتبار پارسه شما کافی نیست").
function $b5da27b488005ec5$var$serviceErrorKind(message) {
    return /RESOURCE_EXHAUSTED/.test(String(message || '')) ? (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).CREDIT : (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).SERVICE;
}
// The BFF's close codes (transcribeHandler.js): 4001 for a missing/invalid
// token, 1011 when the gRPC stream could not be opened or failed.
const $b5da27b488005ec5$var$WS_CLOSE_AUTH = 4001;
const $b5da27b488005ec5$var$WS_CLOSE_SERVICE = 1011;
function $b5da27b488005ec5$var$getSupportedMimeType() {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4'
    ];
    return types.find((item)=>MediaRecorder.isTypeSupported(item)) || '';
}
function $b5da27b488005ec5$export$e2373706461b5244({ visitId: visitId, patientHistory: patientHistory = '', patientId: patientId = '', callAudio: callAudio = null, hintsEnabled: hintsEnabled = true, engine: // The server engine that decodes the recording — 'parsina' or 'assistant'
// (lib/speechEngine.js `ambientEngine`). The browser engine cannot hear a
// conference and feeds no hints, so it never reaches here. Null sends no
// parameter, which an older BFF and AI service read as the assistant engine.
engine = null, onSystemPause: onSystemPause = null }) {
    const [recState, setRecState] = (0, $acw62.useState)($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [hints, setHints] = (0, $acw62.useState)([]);
    const [liveTranscript, setLiveTranscript] = (0, $acw62.useState)('');
    const [report, setReport] = (0, $acw62.useState)(null);
    // `{ kind, detail }` while `recState` is `error`, else null. `kind` is one of
    // RecErrorKind; `detail` is the raw browser/server text, for support only.
    const [recError, setRecError] = (0, $acw62.useState)(null);
    const wsRef = (0, $acw62.useRef)(null);
    const bridgeRef = (0, $acw62.useRef)(null);
    const mediaRecorderRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const transcriptRef = (0, $acw62.useRef)('');
    const timerRef = (0, $acw62.useRef)(null);
    const stopTimeoutRef = (0, $acw62.useRef)(null);
    const wakeLockRef = (0, $acw62.useRef)(null);
    const elapsedRef = (0, $acw62.useRef)(0);
    // The hook's own view of the state, readable from the DOM listeners below
    // without re-registering them on every tick.
    const recStateRef = (0, $acw62.useRef)($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    const onSystemPauseRef = (0, $acw62.useRef)(onSystemPause);
    onSystemPauseRef.current = onSystemPause;
    const applyState = (0, $acw62.useCallback)((next)=>{
        recStateRef.current = next;
        setRecState(next);
    }, []);
    /** The one way into `error`: the state and its reason always move together. */ const fail = (0, $acw62.useCallback)((kind, detail = '')=>{
        setRecError({
            kind: kind,
            detail: String(detail || '')
        });
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.ERROR);
    }, [
        applyState
    ]);
    const stopTimer = (0, $acw62.useCallback)(()=>{
        clearInterval(timerRef.current);
        timerRef.current = null;
    }, []);
    // ── Screen Wake Lock ───────────────────────────────────────────────────────
    // The commonest way a recording dies is the least dramatic: the phone is on
    // the desk between the doctor and the patient, and the auto-lock timer runs
    // out. A screen wake lock removes that case entirely — no permission prompt,
    // no UI, supported on iOS Safari ≥16.4 and Android Chrome, and a silent no-op
    // everywhere else. It makes the honest-stop path below the RARE one instead
    // of the normal one.
    const acquireWakeLock = (0, $acw62.useCallback)(async ()=>{
        try {
            if (!navigator.wakeLock || wakeLockRef.current) return;
            const sentinel = await navigator.wakeLock.request('screen');
            // The OS drops it on its own when the page is hidden; forget the dead
            // sentinel so a re-acquire on resume is not skipped as redundant.
            sentinel.addEventListener?.('release', ()=>{
                if (wakeLockRef.current === sentinel) wakeLockRef.current = null;
            });
            wakeLockRef.current = sentinel;
        } catch  {}
    }, []);
    const releaseWakeLock = (0, $acw62.useCallback)(()=>{
        const sentinel = wakeLockRef.current;
        wakeLockRef.current = null;
        try {
            sentinel?.release?.();
        } catch  {}
    }, []);
    /** Everything that produces audio, torn down. Never touches `recState`. */ const teardownCapture = (0, $acw62.useCallback)(()=>{
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') try {
            mediaRecorderRef.current.stop();
        } catch  {}
        try {
            bridgeRef.current?.stop();
        } catch  {}
        bridgeRef.current = null;
        streamRef.current?.getTracks().forEach((track)=>track.stop());
        streamRef.current = null;
    }, []);
    // Read inside the socket's `onmessage`, which closes over the value it was
    // created with — a ref so turning the switch off mid-visit takes effect on
    // the next frame instead of at the next recording.
    const hintsEnabledRef = (0, $acw62.useRef)(hintsEnabled);
    hintsEnabledRef.current = hintsEnabled;
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            clearInterval(timerRef.current);
            clearTimeout(stopTimeoutRef.current);
            wsRef.current?.close();
            try {
                bridgeRef.current?.stop();
            } catch  {}
            streamRef.current?.getTracks().forEach((track)=>track.stop());
            const sentinel = wakeLockRef.current;
            wakeLockRef.current = null;
            try {
                sentinel?.release?.();
            } catch  {}
        };
    }, []);
    const startRec = (0, $acw62.useCallback)(async ()=>{
        // One start at a time. A second press while the first is still setting up
        // (or already recording, or finishing) used to open a second socket and a
        // second recorder alongside the first.
        const prior = recStateRef.current;
        if (prior === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING || prior === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING || prior === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING) return;
        setHints([]);
        setLiveTranscript('');
        setElapsed(0);
        elapsedRef.current = 0;
        transcriptRef.current = '';
        // A retry starts from a clean slate; `error` is left only by a new attempt
        // or by `dismissError`.
        setRecError(null);
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING);
        // The previous socket (a paused recording's, left open on purpose so the
        // server can finish its final pass) is no longer this hook's to report on:
        // its close must not read as THIS attempt failing.
        wsRef.current = null;
        // Stopped, dismissed or unmounted while a step below was awaited.
        const abandoned = ()=>recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING;
        let token = (0, $a83Oj.getToken)();
        if (!token || (0, $a83Oj.isTokenExpired)(token)) {
            const ok = await (0, $a83Oj.refreshAccessToken)();
            if (abandoned()) return;
            if (!ok) {
                fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).SESSION);
                return;
            }
            token = (0, $a83Oj.getToken)();
        }
        // The conference is the source whenever there is one. Only reach for the
        // microphone when this is an in-person visit.
        const useCallAudio = Boolean(callAudio?.frame && callAudio?.origin);
        let stream = null;
        if (!useCallAudio) {
            // Checked up front rather than left to throw: on a non-HTTPS page
            // `navigator.mediaDevices` does not exist at all, and the TypeError that
            // produced said nothing a doctor could use.
            if (!navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === 'undefined') {
                fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).UNSUPPORTED, window.isSecureContext === false ? 'insecure-context' : 'no-media-api');
                return;
            }
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
            } catch (err) {
                if (abandoned()) return;
                console.error('Mic access denied:', err);
                fail($b5da27b488005ec5$export$7361891803c21a19(err), `${err?.name || 'Error'}: ${err?.message || ''}`);
                return;
            }
            // The permission prompt can sit open for as long as the doctor ignores
            // it; a start given up on meanwhile must not leave the microphone live.
            if (abandoned()) {
                stream.getTracks().forEach((track)=>track.stop());
                return;
            }
            streamRef.current = stream;
        }
        // `language` is the doctor's panel language. It decides two things on the
        // far side: which language the live «نکات بالینی» hints come back in, and
        // which source language speech recognition is told to expect. Without it
        // both defaulted to Persian, so an Arabic-reading doctor got Persian hints
        // about a dictation that had been decoded by a Persian-locked recogniser.
        // A query parameter and not a header because a browser cannot set headers
        // on a WebSocket handshake — the token travels the same way for the same
        // reason.
        // `hints=off` only when the doctor turned them off — the parameter is
        // absent otherwise, so an older BFF that does not read it keeps doing
        // exactly what it did.
        const wsUrl = `${(0, $eabde0fc143396e8$export$8742212cdac9d01)()}/ws/transcribe?token=${encodeURIComponent(token)}&visit_id=${encodeURIComponent(visitId || '')}&patient_id=${encodeURIComponent(patientId || '')}&language=${encodeURIComponent((0, $adebb901af88e18b$export$7f5d9d25e625ad97)())}${hintsEnabled ? '' : '&hints=off'}${engine ? `&engine=${encodeURIComponent(engine)}` : ''}`;
        const ws = new WebSocket(wsUrl);
        wsRef.current = ws;
        ws.onopen = async ()=>{
            // Given up on while the handshake was in flight: let this socket go.
            if (wsRef.current !== ws || abandoned()) {
                stream?.getTracks().forEach((track)=>track.stop());
                if (streamRef.current === stream) streamRef.current = null;
                try {
                    ws.close();
                } catch  {}
                return;
            }
            const send = (data)=>{
                if (data && data.size > 0 && ws.readyState === WebSocket.OPEN) ws.send(data);
            };
            if (useCallAudio) {
                try {
                    bridgeRef.current = await (0, $7c08ab51fde905a5$export$e24590596d9795fc)(callAudio.frame, callAudio.origin, send);
                } catch (err) {
                    // No fallback to the microphone, on purpose. A media server without
                    // the bridge script would otherwise hand the AI the doctor's half of
                    // the conversation and nothing would look wrong.
                    console.error('Call-audio bridge unavailable:', err?.message);
                    fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).CALL_AUDIO, err?.message);
                    try {
                        ws.close();
                    } catch  {}
                    return;
                }
                // The socket can be refused (4001) while the bridge was starting; the
                // close already reported why, and «recording» must not overwrite it.
                if (ws.readyState !== WebSocket.OPEN || abandoned()) {
                    try {
                        bridgeRef.current?.stop();
                    } catch  {}
                    bridgeRef.current = null;
                    if (ws.readyState === WebSocket.OPEN) try {
                        ws.close();
                    } catch  {}
                    return;
                }
            } else // A browser can have getUserMedia and still refuse to record it (an
            // older Safari, a codec it will not encode). This used to throw out of
            // `onopen` unhandled, leaving the socket open, the microphone live and
            // the button idle.
            try {
                const mimeType = $b5da27b488005ec5$var$getSupportedMimeType();
                const mr = new MediaRecorder(stream, mimeType ? {
                    mimeType: mimeType
                } : {});
                mediaRecorderRef.current = mr;
                mr.ondataavailable = (e)=>send(e.data);
                mr.start(250);
            } catch (err) {
                console.error('MediaRecorder unavailable:', err);
                fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).UNSUPPORTED, `${err?.name || 'Error'}: ${err?.message || ''}`);
                try {
                    ws.close();
                } catch  {}
                return;
            }
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING);
            acquireWakeLock();
            stopTimer();
            timerRef.current = setInterval(()=>{
                elapsedRef.current += 1;
                setElapsed(elapsedRef.current);
            }, 1000);
        };
        ws.onmessage = async (e)=>{
            try {
                const msg = JSON.parse(e.data);
                // A superseded socket — a paused recording's, still finishing its final
                // pass when «ادامه» opened the next one — speaks for a segment this hook
                // no longer shows. Read as current, its `is_final` dropped the NEW
                // recording to `idle` while audio was still flowing (and wrote the old
                // segment over the new transcript); its `error` failed it. The server has
                // already saved what it says, so it is only let go.
                if (wsRef.current !== ws) {
                    if (msg.is_final) try {
                        ws.close();
                    } catch  {}
                    return;
                }
                if (msg.error) {
                    console.error('Transcription error:', msg.error);
                    stopTimer();
                    fail($b5da27b488005ec5$var$serviceErrorKind(msg.error), msg.error);
                    ws.close();
                    return;
                }
                if (msg.text && !msg.is_final) {
                    // `replace` means the service re-transcribed the whole recording and
                    // reworded something it had already sent, so `text` is the corrected
                    // transcript IN FULL rather than the newest words. Appending it would
                    // show the doctor the first minutes of the visit a second time, which
                    // is what used to happen on every re-wording.
                    transcriptRef.current = msg.replace ? msg.text + ' ' : transcriptRef.current + msg.text + ' ';
                    setLiveTranscript(transcriptRef.current.trim());
                }
                // The far side is asked not to produce these at all; this is the
                // backstop for a BFF or an AI service that has not been deployed yet,
                // so the switch is honoured by the surface the doctor is looking at
                // even while the two halves are out of step.
                if (msg.real_time_hint && hintsEnabledRef.current) setHints((prev)=>[
                        {
                            text: msg.real_time_hint,
                            hint_type: msg.hint_type || 'clinical_note',
                            soap_suggestions: msg.soap_suggestions || {}
                        },
                        ...prev
                    ]);
                if (msg.is_final) {
                    clearTimeout(stopTimeoutRef.current);
                    ws.close();
                    const finalText = msg.text || transcriptRef.current.trim();
                    if (finalText) {
                        transcriptRef.current = finalText;
                        setLiveTranscript(finalText);
                    }
                    // A hidden tab ends here too: `onHidden` sent `done` and said
                    // `paused-by-system` at once, and this is the final pass landing after
                    // it. It keeps the transcript and NOT the state — moving to `idle`
                    // took the interrupted strip down while the doctor was away, so they
                    // came back to a plain «پایش بالینی» with nothing saying the recording
                    // had stopped. The strip stays until they resume or dismiss it, and
                    // «ادامه» opens a new socket, so this one closing costs it nothing.
                    if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
                    releaseWakeLock();
                }
            } catch  {}
        };
        ws.onerror = ()=>console.error('WebSocket connection failed');
        // ── The socket closing is never silent ────────────────────────────────────
        // This used to stop the tracks and return, leaving `recState` wherever it
        // was — which on an OS-killed socket meant `'recording'`, and the UI went
        // on claiming to record for as long as the doctor left it open.
        //
        // Three closes are possible and only one of them is a surprise:
        //   • after `is_final` — the handler above already moved to `idle`, or
        //     left a hidden tab's `paused-by-system` standing;
        //   • after the doctor pressed stop and the wait timed out — `stopping`
        //     resolves to `idle`, because the audio is on the server and the final
        //     pass will land there with or without this tab;
        //   • out of nowhere — the OS suspended the page. That is
        //     `paused-by-system`: an honest state the strip can offer to resume.
        //
        // …unless the close says otherwise. The BFF upgrades the socket BEFORE it
        // verifies the token, so a refused token opens, flips to «recording» and is
        // closed 4001 a moment later; read as an OS pause, «ادامه» then failed the
        // same way forever. And a socket that closes while still `connecting` is a
        // network that will not carry it (a proxy, a VPN, antivirus stripping the
        // upgrade), which used to leave the button idle with nothing said.
        ws.onclose = (event)=>{
            // A superseded socket — a paused recording's, closing after «ادامه»
            // started a new one — owns none of the capture, timer or state any more;
            // tearing those down would kill the recording that replaced it.
            if (wsRef.current !== ws) return;
            stopTimer();
            teardownCapture();
            releaseWakeLock();
            clearTimeout(stopTimeoutRef.current);
            const current = recStateRef.current;
            const code = event?.code;
            const inFlight = current === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING || current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING;
            if (inFlight && code === $b5da27b488005ec5$var$WS_CLOSE_AUTH) fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).AUTH, event?.reason);
            else if (inFlight && code === $b5da27b488005ec5$var$WS_CLOSE_SERVICE) fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).SERVICE, event?.reason);
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING) fail((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).CONNECTION, code ? `close ${code}` : '');
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM);
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
        // `idle` and `error` are already terminal and stay put.
        };
    }, [
        visitId,
        patientId,
        callAudio,
        hintsEnabled,
        engine,
        applyState,
        fail,
        acquireWakeLock,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    /** The error dialog was closed: back to a plain «پایش بالینی» button. */ const dismissError = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.ERROR) return;
        setRecError(null);
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState
    ]);
    const stopRec = (0, $acw62.useCallback)(()=>{
        stopTimer();
        clearTimeout(stopTimeoutRef.current);
        teardownCapture();
        releaseWakeLock();
        if (wsRef.current?.readyState === WebSocket.OPEN) {
            try {
                wsRef.current.send(JSON.stringify({
                    done: true
                }));
            } catch  {}
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING);
            stopTimeoutRef.current = setTimeout(()=>{
                wsRef.current?.close();
                applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
            }, $b5da27b488005ec5$var$FINAL_TRANSCRIPT_TIMEOUT_MS);
        } else applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    // ── The page leaving, and coming back ─────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        // The OS gives a short, unspecified window between «this page is hidden»
        // and «this page's JS is frozen». What fits in it is a small frame on an
        // already-open socket, so that is exactly what this does:
        //
        //   stop the recorder      no more audio can be produced anyway
        //   send { done: true }    tells the BFF the client FINISHED. That is the
        //                          difference between the AI service running its
        //                          final pass, saving the transcript and charging
        //                          the wallet — and `call.cancel()` throwing all
        //                          three away.
        //   say so immediately     `paused-by-system` is set here, NOT after
        //                          `is_final`. The final pass takes 3–9s and the
        //                          page will not be alive for it.
        //
        // What it must NOT do is close the socket. Closing is precisely what makes
        // the BFF cancel the stream; the socket is left to die on its own, by which
        // time the server has what it needs.
        const onHidden = ()=>{
            if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) return;
            teardownCapture();
            try {
                if (wsRef.current?.readyState === WebSocket.OPEN) wsRef.current.send(JSON.stringify({
                    done: true
                }));
            } catch  {}
            stopTimer();
            releaseWakeLock();
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM);
            // Hand the screen everything it needs for the draft while JS still runs.
            try {
                onSystemPauseRef.current?.({
                    elapsed: elapsedRef.current,
                    transcript: transcriptRef.current.trim()
                });
            } catch  {}
        };
        const onVisible = ()=>{
            const current = recStateRef.current;
            // The OS releases a wake lock when the page hides. Take it back.
            if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) {
                acquireWakeLock();
                return;
            }
            // A stop that was waiting for the final pass when the page went away is
            // not still waiting — the socket is gone and the 120s timer was frozen
            // with everything else. Resolve it now rather than showing «در حال
            // پردازش» for two more minutes over nothing.
            if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING && wsRef.current?.readyState !== WebSocket.OPEN) {
                clearTimeout(stopTimeoutRef.current);
                applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
            }
        // `paused-by-system` is deliberately left alone. Resuming needs a user
        // gesture for the microphone on iOS, and silently reopening a stream the
        // doctor did not ask for is how a private conversation gets recorded. The
        // screen renders `RecordingInterruptedStrip` and waits.
        };
        const onVisibility = ()=>{
            if (document.visibilityState === 'hidden') onHidden();
            else onVisible();
        };
        // `pagehide` as well as `visibilitychange`: iOS fires `pagehide` on a
        // back-forward-cache eviction where `visibilitychange` may not arrive.
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('pagehide', onHidden);
        return ()=>{
            document.removeEventListener('visibilitychange', onVisibility);
            window.removeEventListener('pagehide', onHidden);
        };
    }, [
        applyState,
        acquireWakeLock,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    /** «ادامه» on the interrupted strip — a NEW socket and a new gRPC stream. */ const resumeRec = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) return;
        // The stored transcript is seeded server-side: a second stream for the same
        // encounter reads what the first one saved and appends to it, so this does
        // not overwrite the first segment.
        startRec();
    }, [
        startRec
    ]);
    /** «رد کردن» — the doctor does not want to carry on recording. */ const dismissPause = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) return;
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState
    ]);
    return {
        recState: recState,
        elapsed: elapsed,
        hints: hints,
        liveTranscript: liveTranscript,
        report: report,
        recError: recError,
        startRec: startRec,
        stopRec: stopRec,
        resumeRec: resumeRec,
        dismissPause: dismissPause,
        dismissError: dismissError
    };
}



var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5a6e4961dcb5cc3f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 19v3",
            key: "npa21l"
        }
    ],
    [
        "path",
        {
            d: "M15 9.34V5a3 3 0 0 0-5.68-1.33",
            key: "1gzdoj"
        }
    ],
    [
        "path",
        {
            d: "M16.95 16.95A7 7 0 0 1 5 12v-2",
            key: "cqa7eg"
        }
    ],
    [
        "path",
        {
            d: "M18.89 13.23A7 7 0 0 0 19 12v-2",
            key: "16hl24"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M9 9v3a3 3 0 0 0 5.12 2.12",
            key: "r2i35w"
        }
    ]
];
const $5a6e4961dcb5cc3f$export$2e2bcd8739ae039 = (0, $9QBug.default)("mic-off", $5a6e4961dcb5cc3f$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// «ضبط به‌دلیل خروج از برنامه متوقف شد» — the honest end of a recording the
// phone took away.
//
// A Safari tab or an installed PWA that leaves the foreground — screen lock, an
// app switch, an incoming call — has its timers frozen, its WebSocket closed by
// the OS and its microphone capture paused. There is no background-audio
// entitlement for web content, so the recording DOES stop. What was wrong was
// that nothing said so: `recState` stayed on `'recording'`, the header chip and
// the docked bar both went on claiming «در حال ضبط», and the visit was billed
// for the dead air by a browser timer that never stopped counting.
//
// This strip is what replaces the lie. Three rules it exists to keep:
//
//   NEVER AUTO-RESUME. iOS requires a user gesture to reopen the microphone,
//   so a silent restart would fail — and where it did not, a page that starts
//   recording a consultation on its own is a page nobody should trust.
//
//   THE OFFER IS SAFE TO ACCEPT. «ادامه» opens a NEW socket and a new gRPC
//   stream, and the AI service seeds that stream from what the first one stored
//   before appending. Without that seeding, resuming would silently delete the
//   first half of the visit — which is why the resume affordance could not ship
//   until the service change landed.
//
//   THE FIRST SEGMENT IS ALREADY SAFE. Whatever was transcribed before the
//   interruption was persisted per hint tick and again by the final pass the
//   BFF now lets complete, so declining costs nothing that was said.
//
// Rendered above the fold on both mobile visit surfaces, not in a dialog: it is
// information about something that already happened, and a modal would demand a
// decision at the moment the doctor is putting the phone down.
// ─────────────────────────────────────────────────────────────────────────────
const $685ede922aaeb8a3$var$RecordingInterruptedStrip = ({ onResume: onResume, onDismiss: onDismiss, busy: busy = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-recording-interrupted",
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            background: (0, $jTCZr.CT).warnSoft,
            borderBottom: `1px solid ${(0, $jTCZr.CT).warn}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5a6e4961dcb5cc3f$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).warnInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('visit.record.interrupted')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        className: "shrink-0 min-h-11",
        "data-testid": "visit-recording-resume",
        onClick: onResume,
        disabled: busy
    }, t('visit.record.resume')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "shrink-0 min-h-11",
        "data-testid": "visit-recording-dismiss",
        onClick: onDismiss,
        style: {
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('common.actions.dismiss')));
};
var $685ede922aaeb8a3$export$2e2bcd8739ae039 = $685ede922aaeb8a3$var$RecordingInterruptedStrip;



parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
function $ac5f41923e150410$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, message: message, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, onConfirm: onConfirm, ...rest }) {
    const { t: t } = (0, $LNQP4.default)();
    // Defaults live HERE, not in the parameter list. Written as
    // `title = t('common.actions.confirmAction')` this threw ReferenceError the
    // moment a caller omitted `title` — default parameters are evaluated in their
    // own scope, which cannot see the `const t` below.
    const titleText = title ?? t('common.actions.confirmAction');
    const confirmLabelText = confirmLabel ?? t('common.actions.confirm');
    const cancelLabelText = cancelLabel ?? t('common.actions.cancel');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        ...rest,
        open: open,
        onOpenChange: onOpenChange,
        title: titleText,
        description: description ?? message,
        confirmLabel: confirmLabelText,
        cancelLabel: cancelLabelText,
        destructive: destructive,
        loading: loading,
        // The kit closes on the caller's say-so, not its own: a confirm whose
        // action can fail must stay open long enough to report it. This wrapper's
        // predecessor closed unconditionally, so a failed delete looked done.
        onConfirm: ()=>{
            onConfirm?.();
            onOpenChange?.(false);
        }
    });
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// «پایش بالینی» could not start, or died — and WHY.
//
// Before this, every one of these failures was a console line: the doctor
// pressed the button, it looked exactly as it had a second earlier, and the
// report that reached support was «the button does nothing». Each kind names
// what happened in the doctor's terms and the one thing they can do about it;
// the raw browser/server text sits underneath for whoever they forward it to.
//
// The confirm is «تلاش دوباره» for every kind, including the ones a retry will
// not fix on its own: the fix text asks the doctor to change something (a
// permission, a cable, a VPN) and then retry, and that retry must be one press
// away rather than a trip back to the panel.
//
// Not `destructive`: nothing is being removed; red is spent on delete.
const $4314c1a6ed955567$var$KNOWN = new Set(Object.values((0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba)));
function $4314c1a6ed955567$export$2e2bcd8739ae039({ error: error, onRetry: onRetry, onClose: onClose }) {
    const { t: t } = (0, $LNQP4.default)();
    const kind = error && $4314c1a6ed955567$var$KNOWN.has(error.kind) ? error.kind : (0, $fd4d0818319d4b44$export$5b7e21fbf8c676ba).SERVICE;
    const base = `visit.monitoringError.${kind}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(error),
        onOpenChange: (open)=>{
            if (!open) onClose?.();
        },
        "data-testid": "visit-monitoring-error",
        confirmTestId: "visit-monitoring-error-retry",
        cancelTestId: "visit-monitoring-error-close",
        title: t(`${base}.title`),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "space-y-3 text-sm leading-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "text-muted-foreground",
            "data-testid": "visit-monitoring-error-body"
        }, t(`${base}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "font-medium text-foreground",
            "data-testid": "visit-monitoring-error-fix"
        }, t(`${base}.fix`)), error?.detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "text-xs text-muted-foreground"
        }, t('visit.monitoringError.detail'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr",
            className: "font-mono",
            "data-testid": "visit-monitoring-error-detail"
        }, error.detail)) : null),
        confirmLabel: t('visit.monitoringError.retry'),
        cancelLabel: t('visit.monitoringError.close'),
        // Retry replaces the error rather than closing on top of it: the hook
        // clears `recError` as the new attempt starts, which closes the dialog,
        // and a failed retry reopens it with the new reason.
        onConfirm: onRetry
    });
}


// The review step of the «نسخه»'s three AI helpers (docs/VISIT_RX_AI_ASSIST.md):
// dictation, «پایش بالینی», شرح حال. One list for all three and both surfaces —
// the visit's proposal card (PM-0038), inline in the نسخه tab, so a proposal for
// the نسخه reads and is confirmed exactly like one for the note or the دستورات.
//
// Nothing here writes. Each row is a proposal the doctor ticks, resolves (an
// ambiguous drug is chosen from the formulary candidates the server scored) or
// leaves; «تأیید» hands the ticked rows to the screen, which adds them as it adds
// a drug picked by hand.
//
// A row says WHY it is not ticked: already on the نسخه, a recorded allergy, a drug
// the formulary does not carry, several formulary drugs that fit. The last two are
// the ones the model cannot settle, and the list never settles them for it.

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// The «نسخه»'s three AI helpers — docs/VISIT_RX_AI_ASSIST.md.
//
//   VOICE       the doctor dictates «آموکسی‌سیلین ۵۰۰ هر هشت ساعت یک هفته»
//   MONITORING  the drugs in the visit's «پایش بالینی» transcript
//   HISTORY     drugs the current شرح حال / assessment / diagnoses call for
//
// All three come back as PROPOSALS. Nothing reaches the نسخه until the doctor has
// looked at the list, resolved every ambiguous drug and pressed «افزودن به نسخه»;
// the lines are then added exactly as a drug ticked in the picker is (makeRxItem),
// so autosave, the «P» block and the closing write treat them the same.
//
// The formulary row is decided on the server, in code, with a visible score — the
// model only reads what was said. A proposal the formulary does not carry is shown
// as such and can only be searched for by hand: it is never turned into a synthetic
// drug that looks like a formulary one.
//
// This module is pure (no React): the rules for which rows start ticked live here
// so both surfaces and the tests read one copy.


// «افزودن به نسخه ویزیت» — a drug line read off a document, offered to THIS visit's
// نسخه. DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §23.3 A13, §9.5;
// MEDICAL_FILE_INGESTION_DICOM_COMPRESSION_OCR_DESIGN.md §6.8.
//
// An extracted item NEVER enters the visit's prescription by itself. This module
// only turns a reviewed row into the shape the Visit's own drug form starts from —
// a drug plus the per-drug defaults `makeRxItem` takes — and the Visit puts it in
// the form's add state. The row becomes a نسخه line when the doctor presses the
// form's own «افزودن», through the same path a drug they picked by hand takes, so
// the SOAP «P» plan block (derived from the نسخه) follows it like any other line.
const $622fea85856450c1$var$text = (v)=>v == null ? '' : String(v).trim();
const $622fea85856450c1$export$af2260c3b4941e91 = (row)=>row?.verified === false || row?.confidence !== null && row?.confidence !== undefined && Number.isFinite(Number(row.confidence)) && Number(row.confidence) < (0, $157d5bd48cfffbad$export$8e824c3a51e639a1);
function $622fea85856450c1$export$f9bb0cd25dab9659(row) {
    if (!row) return 'patient.files.extract.rx.needsDrug';
    if (!$622fea85856450c1$var$text(row.drugText) && !row.drugId) return 'patient.files.extract.rx.needsDrug';
    if ((0, $157d5bd48cfffbad$export$d66c76d9d0c49c6f)(row.drugText) && !row.drugId) return 'patient.files.extract.rx.illegibleDrug';
    return null;
}
// «Amoxicillin» + «500mg» reads «Amoxicillin 500mg»; a name that already says its
// strength is not told twice.
const $622fea85856450c1$var$withQualifiers = (name, ...parts)=>parts.map($622fea85856450c1$var$text).filter((p)=>p && !name.toLowerCase().includes(p.toLowerCase())).reduce((acc, p)=>`${acc} ${p}`, name);
function $622fea85856450c1$export$304c866dced88570(row) {
    const drugId = $622fea85856450c1$var$text(row?.drugId);
    const candidate = drugId ? (row.candidates || []).find((c)=>c.drugId === drugId) : null;
    const strength = $622fea85856450c1$var$text(candidate?.strength) || $622fea85856450c1$var$text(row?.strength);
    const form = $622fea85856450c1$var$text(candidate?.form) || $622fea85856450c1$var$text(row?.form);
    const dose = $622fea85856450c1$var$text(row?.dose);
    const frequency = $622fea85856450c1$var$text(row?.frequency) || $622fea85856450c1$var$text(row?.frequencyCode);
    const baseName = $622fea85856450c1$var$text(candidate?.name) || $622fea85856450c1$var$text(row?.drugText);
    const name = $622fea85856450c1$var$withQualifiers(baseName, strength, form);
    const drug = {
        id: drugId || `doc-med-${$622fea85856450c1$var$text(row?.drugText).toLowerCase()}`,
        name: name,
        genericName: $622fea85856450c1$var$text(candidate?.genericName),
        strength: strength,
        form: form,
        category: '',
        commonDosages: dose ? [
            dose
        ] : [],
        commonFrequencies: frequency ? [
            frequency
        ] : [],
        fromFormulary: Boolean(drugId)
    };
    return {
        key: row?.key || drug.id,
        drug: drug,
        defaults: {
            dosage: dose,
            frequency: frequency,
            frequencyCode: $622fea85856450c1$var$text(row?.frequencyCode),
            route: $622fea85856450c1$var$text(row?.route),
            duration: $622fea85856450c1$var$text(row?.duration),
            quantity: $622fea85856450c1$var$text(row?.quantity),
            instructions: $622fea85856450c1$var$text(row?.instructions)
        }
    };
}
function $622fea85856450c1$export$4a6823332c424d49(defaults) {
    const out = {};
    for (const k of [
        'dosage',
        'frequency',
        'route',
        'duration',
        'quantity',
        'instructions'
    ])if ($622fea85856450c1$var$text(defaults?.[k])) out[k] = $622fea85856450c1$var$text(defaults[k]);
    return out;
}
const $622fea85856450c1$export$5883510ef829fa69 = (batch, documentDefaults)=>({
        ...batch || {},
        ...$622fea85856450c1$export$4a6823332c424d49(documentDefaults)
    });
const $622fea85856450c1$export$41eca2609e16adbf = (defaults)=>Object.values($622fea85856450c1$export$4a6823332c424d49(defaults)).join(" \xb7 ");
function $622fea85856450c1$export$26bd9984be9bfd1c(rxItems, drug) {
    const nameKey = $622fea85856450c1$var$text(drug?.name).toLowerCase();
    return (rxItems || []).some((r)=>r.drug?.id && r.drug.id === drug?.id || nameKey && $622fea85856450c1$var$text(r.drug?.name).toLowerCase() === nameKey);
}



// A drug-list row, read as what it is: one PRODUCT of an ingredient — a strength,
// a form, a route, sometimes a pack size and a brand.
//
// The picker used to show every product as its own card, so «پردنی» filled its
// first page with seven brands of one 5 mg tablet. The doctor now searches for the
// DRUG and picks its شکل and قدرت in the add form (PM-0059), and this module is
// what tells one from the other.
//
// Nothing here is guessed from Persian. The imported rows carry the official eRx
// product string, and that string has a fixed order:
//
//     INGREDIENT  strength  [pack]  FORM[, qualifier …]  ROUTE  [pack]  [BRAND]
//     PREDNISOLONE 5 mg TABLET ORAL [NISOPRED]
//     AMOXICILLIN 125 mg/5mL 100 mL POWDER, FOR SUSPENSION ORAL
//
// It is read from the END — brand, pack, route, form, strength — and what is left
// is the ingredient, so an ingredient written in several words needs no list of
// its own. A row whose name is not such a string (a curated row: «Prednisolone»)
// is one product of its own name: no form, no strength, never folded into another.
const $1954c03f878fe45b$var$ROUTE_WORDS = new Set([
    'ORAL',
    'PARENTERAL',
    'TOPICAL',
    'INTRAVENOUS',
    'INTRAMUSCULAR',
    'SUBCUTANEOUS',
    'OPHTHALMIC',
    'OTIC',
    'NASAL',
    'RESPIRATORY',
    'INHALATION',
    'VAGINAL',
    'RECTAL',
    'SUBLINGUAL',
    'BUCCAL',
    'TRANSDERMAL',
    'CUTANEOUS',
    'DENTAL',
    'INTRAPERITONEAL',
    'ENDOTRACHEAL',
    'IRRIGATION',
    'HEMODIALYSIS',
    'TRANSTRACHEAL',
    'INTRASPINAL',
    'INTRATHECAL',
    'EPIDURAL',
    'INTRAVITREAL',
    'INTRAOCULAR',
    'INTRAARTICULAR',
    'INTRADERMAL',
    'INTRAUTERINE',
    'URETHRAL',
    'INTRAVESICAL',
    'AURICULAR',
    'OROMUCOSAL'
]);
// The words a dose form is written with: the form itself and its qualifiers.
const $1954c03f878fe45b$var$FORM_HEADS = new Set([
    'TABLET',
    'CAPSULE',
    'SOFTGEL',
    'SOLUTION',
    'SUSPENSION',
    'SYRUP',
    'ELIXIR',
    'INJECTION',
    'INJECTABLE',
    'POWDER',
    'DROPS',
    'DROP',
    'CREAM',
    'OINTMENT',
    'GEL',
    'LOTION',
    'SPRAY',
    'AEROSOL',
    'INHALER',
    'INHALANT',
    'SUPPOSITORY',
    'PATCH',
    'SHAMPOO',
    'EMULSION',
    'GRANULE',
    'GRANULES',
    'PELLET',
    'PELLETS',
    'LOZENGE',
    'PASTE',
    'FOAM',
    'IMPLANT',
    'KIT',
    'GAS',
    'LIQUID',
    'PESSARY',
    'OVULE',
    'ENEMA',
    'TINCTURE',
    'MOUTHWASH',
    'JELLY',
    'FILM',
    'GUM',
    'SACHET',
    'PILL',
    'TROCHE',
    'INSERT',
    'RING',
    'SUPPOSITORIES',
    'CONCENTRATE',
    'SOLID',
    'BAR',
    'OIL',
    'SOAP',
    'STICK',
    'WAFER'
]);
const $1954c03f878fe45b$var$FORM_QUALIFIERS = new Set([
    'FOR',
    'EXTENDED',
    'DELAYED',
    'RELEASE',
    'CHEWABLE',
    'COATED',
    'ORALLY',
    'DISINTEGRATING',
    'EFFERVESCENT',
    'SOLUBLE',
    'DISPERSIBLE',
    'METERED',
    'FILLED',
    'LYOPHILIZED',
    'LIPOSOMAL',
    'ENTERIC',
    'SUSTAINED',
    'MODIFIED',
    'PROLONGED',
    'GELATIN',
    'LIQUID',
    'PREFILLED',
    'SYRINGE',
    'RECONSTITUTION',
    'INFUSION',
    'AUGMENTED',
    'SUBLINGUAL',
    'VAGINAL',
    'RECTAL',
    'NASAL',
    'WITH',
    'DILUENT'
]);
const $1954c03f878fe45b$var$UNIT_WORDS = new Set([
    'IU',
    'L',
    'U',
    'G',
    'MILLILITER',
    'GRAM',
    'MG',
    'ML',
    'KG',
    'MCG'
]);
const $1954c03f878fe45b$var$bare = (tok)=>tok.replace(/^[(]+|[),]+$/g, '');
// «500», «2.5», «0.05%», «125mg», «(2» — where a strength or a pack begins.
const $1954c03f878fe45b$var$startsWithNumber = (tok)=>/^\(?[\d.]*\d/.test(tok);
// «mg», «mL», «mg/5mL», «[iU]/mL», «{Puff}», «g)» — a unit standing alone after its number.
const $1954c03f878fe45b$var$isUnit = (tok)=>{
    const b = $1954c03f878fe45b$var$bare(tok);
    if (!b) return false;
    if ($1954c03f878fe45b$var$UNIT_WORDS.has(b.toUpperCase()) && b.length <= 10) return true;
    return b.length <= 14 && /[a-zµ%]/.test(b) && /^[\[\]{}A-Za-zµ%/\d.]+$/.test(b);
};
const $1954c03f878fe45b$var$isMeasure = (tok)=>$1954c03f878fe45b$var$startsWithNumber(tok) || $1954c03f878fe45b$var$isUnit(tok);
// One «number unit[/number unit]» at the head of a measure string.
const $1954c03f878fe45b$var$MEASURE = /^\(?[\d.,]+\s*(?:[\[{]?[A-Za-zµ]+[\]}]?|%)?(?:\s*[/+]\s*[\d.,]*\s*(?:[\[{]?[A-Za-zµ]+[\]}]?|%)?)*\)?/;
function $1954c03f878fe45b$var$splitMeasures(text) {
    const parts = [];
    let rest = text.trim();
    while(rest){
        const m = rest.match($1954c03f878fe45b$var$MEASURE);
        if (!m || !m[0]) {
            parts.push(rest);
            break;
        }
        parts.push(m[0].trim());
        rest = rest.slice(m[0].length).trim();
    }
    return parts;
}
const $1954c03f878fe45b$export$7ff7ad4866bf0f48 = (drug)=>{
    const id = String(drug?.id || '');
    return String((id.startsWith('erx-') ? drug?.name : drug?.genericName) || '').trim();
};
const $1954c03f878fe45b$var$isImported = (drug)=>/^(tamin|erx)-/.test(String(drug?.id || ''));
function $1954c03f878fe45b$export$118f73129e96440a(drug) {
    const plain = {
        ingredient: String(drug?.genericName || drug?.name || '').trim(),
        strength: '',
        form: '',
        route: '',
        pack: '',
        brand: '',
        structured: false
    };
    if (!$1954c03f878fe45b$var$isImported(drug)) return plain;
    let text = $1954c03f878fe45b$export$7ff7ad4866bf0f48(drug);
    if (!text) return plain;
    let brand = '';
    const b = text.match(/\s*\[([^\]]+)\]\s*$/);
    // «100 [iU]/mL» ends in a bracket too — a brand is a bracket standing alone.
    if (b && !/[\d/]\s*$/.test(text.slice(0, b.index)) && !/^i?u$/i.test(b[1].trim())) {
        brand = b[1].trim();
        text = text.slice(0, b.index).trim();
    }
    const toks = text.split(/\s+/).filter(Boolean);
    const popWhile = (test)=>{
        const out = [];
        while(toks.length > 1 && test(toks[toks.length - 1]))out.unshift(toks.pop());
        return out;
    };
    const tailPack = popWhile($1954c03f878fe45b$var$isMeasure);
    let route = '';
    if (toks.length > 1 && $1954c03f878fe45b$var$ROUTE_WORDS.has($1954c03f878fe45b$var$bare(toks[toks.length - 1]).toUpperCase())) route = $1954c03f878fe45b$var$bare(toks.pop()).toUpperCase();
    const formToks = popWhile((tok)=>{
        const w = tok.replace(/,$/, '').toUpperCase();
        return w.split('/').every((p)=>$1954c03f878fe45b$var$FORM_HEADS.has(p) || $1954c03f878fe45b$var$FORM_QUALIFIERS.has(p));
    });
    // A qualifier alone is not a form («… WITH»): it belongs to the name.
    if (formToks.length && !formToks.some((tok)=>tok.replace(/,$/, '').toUpperCase().split('/').some((p)=>$1954c03f878fe45b$var$FORM_HEADS.has(p)))) toks.push(...formToks.splice(0));
    const measures = popWhile($1954c03f878fe45b$var$isMeasure);
    if (!formToks.length && !route) return {
        ...plain,
        brand: brand
    };
    const [strength = '', ...packs] = $1954c03f878fe45b$var$splitMeasures(measures.join(' '));
    // The molecule head an eRx row carries beside its product string is the
    // ingredient as the registry cut it; a تأمین row has only what is left here.
    const head = String(drug?.id || '').startsWith('erx-') ? String(drug?.genericName || '').trim() : '';
    const ingredient = (head && text.toUpperCase().startsWith(head.toUpperCase()) ? head : toks.join(' ')).replace(/[,\s]+$/, '');
    if (!ingredient) return {
        ...plain,
        brand: brand
    };
    return {
        ingredient: ingredient,
        strength: strength,
        form: formToks.join(' ').toUpperCase(),
        route: route,
        pack: [
            ...packs,
            ...$1954c03f878fe45b$var$splitMeasures(tailPack.join(' '))
        ].join(' '),
        brand: brand,
        structured: true
    };
}
// One ingredient, whatever salt it is written as and however it is spaced:
// «DAPOXETINE (AS HYDROCHLORIDE)» is dapoxetine.
const $1954c03f878fe45b$var$ingredientKey = (name)=>String(name || '').replace(/\(\s*AS\s+[^)]*\)/gi, ' ').toLowerCase().replace(/[^a-z0-9؀-ۿ]+/g, ' ').trim();
const $1954c03f878fe45b$export$49bc12753c4ae83 = (p)=>p.form || p.route ? `${p.form}|${p.route}` : '';
const $1954c03f878fe45b$export$6bd67e54caba8b84 = (name)=>$1954c03f878fe45b$var$ingredientKey(name);
function $1954c03f878fe45b$export$1d5b418d03549c72(drug) {
    const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
    return p.structured ? `${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}#${$1954c03f878fe45b$export$49bc12753c4ae83(p)}` : null;
}
function $1954c03f878fe45b$export$cbf1162dc7529312(drugs) {
    const groups = new Map();
    for (const drug of drugs || []){
        if (!drug?.id) continue;
        const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
        const key = p.structured ? `i:${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}` : `id:${drug.id}`;
        if (!groups.has(key)) groups.set(key, {
            key: key,
            ingredient: p.ingredient,
            structured: p.structured,
            products: []
        });
        const g = groups.get(key);
        if (!g.products.some((x)=>x.drug.id === drug.id)) g.products.push({
            drug: drug,
            ...p
        });
    }
    return [
        ...groups.values()
    ];
}
function $1954c03f878fe45b$export$9148a864884cb04b(group, drugs) {
    if (!group?.structured) return group;
    const seen = new Set(group.products.map((p)=>p.drug.id));
    const extra = [];
    for (const drug of drugs || []){
        if (!drug?.id || seen.has(drug.id)) continue;
        const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
        if (!p.structured || `i:${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}` !== group.key) continue;
        seen.add(drug.id);
        extra.push({
            drug: drug,
            ...p
        });
    }
    return extra.length ? {
        ...group,
        products: [
            ...group.products,
            ...extra
        ]
    } : group;
}
const $1954c03f878fe45b$var$strengthNumber = (s)=>{
    const m = String(s || '').match(/[\d.]+/);
    return m ? Number(m[0]) : Infinity;
};
const $1954c03f878fe45b$var$byStrength = (a, b)=>$1954c03f878fe45b$var$strengthNumber(a) - $1954c03f878fe45b$var$strengthNumber(b) || String(a).localeCompare(String(b));
function $1954c03f878fe45b$export$c4e7c4d3b2f5c593(group) {
    const out = new Map();
    for (const p of group?.products || []){
        const key = $1954c03f878fe45b$export$49bc12753c4ae83(p);
        if (!out.has(key)) out.set(key, {
            key: key,
            form: p.form,
            route: p.route
        });
    }
    return [
        ...out.values()
    ];
}
function $1954c03f878fe45b$export$266cf92cac578c66(group, formKey) {
    const set = new Set();
    for (const p of group?.products || [])if ($1954c03f878fe45b$export$49bc12753c4ae83(p) === formKey) set.add(p.strength);
    return [
        ...set
    ].sort($1954c03f878fe45b$var$byStrength);
}
function $1954c03f878fe45b$export$b9c0747ef7361846(group, formKey, strength) {
    return (group?.products || []).filter((p)=>$1954c03f878fe45b$export$49bc12753c4ae83(p) === formKey && p.strength === strength).sort((a, b)=>(a.brand ? 1 : 0) - (b.brand ? 1 : 0));
}
const $1954c03f878fe45b$export$c877a6c4e166c3c6 = (p)=>[
        p.pack,
        p.brand
    ].filter(Boolean).join(" \xb7 ");
function $1954c03f878fe45b$export$269cca928fe29b43(group, drugId) {
    const list = group?.products || [];
    return list.find((p)=>p.drug.id === drugId) || list[0] || null;
}
function $1954c03f878fe45b$export$421cf268395c9223(group, formLabel) {
    return $1954c03f878fe45b$export$c4e7c4d3b2f5c593(group).map((f)=>{
        const strengths = $1954c03f878fe45b$export$266cf92cac578c66(group, f.key).filter(Boolean);
        // The strengths are Latin and read left to right as ONE run, whatever the
        // direction of the line they sit in: unisolated, «5 mg, 50 mg» after a
        // Persian form word came out as «mg، 50 mg 5».
        const run = strengths.length ? `\u{2066}${strengths.join(', ')}\u{2069}` : '';
        return [
            formLabel(f.form, f.route),
            run
        ].filter(Boolean).join(' ');
    }).filter(Boolean).join(" \xb7 ");
}
// The form word a doctor reads, by the registry's head word. Keys of
// `visit.rx.forms.*`; a head with no key is shown as the registry writes it.
const $1954c03f878fe45b$var$FORM_LABEL_KEYS = {
    TABLET: 'tablet',
    CAPSULE: 'capsule',
    SOFTGEL: 'softgel',
    SOLUTION: 'solution',
    SUSPENSION: 'suspension',
    SYRUP: 'syrup',
    ELIXIR: 'elixir',
    INJECTION: 'injection',
    INJECTABLE: 'injection',
    POWDER: 'powder',
    DROPS: 'drops',
    DROP: 'drops',
    CREAM: 'cream',
    OINTMENT: 'ointment',
    GEL: 'gel',
    LOTION: 'lotion',
    SPRAY: 'spray',
    AEROSOL: 'spray',
    INHALER: 'inhaler',
    INHALANT: 'inhaler',
    SUPPOSITORY: 'suppository',
    SUPPOSITORIES: 'suppository',
    PATCH: 'patch',
    SHAMPOO: 'shampoo',
    EMULSION: 'emulsion',
    GRANULE: 'granule',
    GRANULES: 'granule',
    LOZENGE: 'lozenge',
    PASTE: 'paste',
    FOAM: 'foam',
    SACHET: 'sachet',
    PESSARY: 'pessary',
    OVULE: 'pessary',
    ENEMA: 'enema',
    MOUTHWASH: 'mouthwash'
};
const $1954c03f878fe45b$var$QUALIFIER_LABEL_KEYS = [
    [
        /EXTENDED RELEASE|SUSTAINED RELEASE|PROLONGED RELEASE|MODIFIED RELEASE/,
        'extendedRelease'
    ],
    [
        /DELAYED RELEASE|ENTERIC COATED/,
        'delayedRelease'
    ],
    [
        /CHEWABLE/,
        'chewable'
    ],
    [
        /EFFERVESCENT/,
        'effervescent'
    ],
    [
        /ORALLY DISINTEGRATING|DISPERSIBLE/,
        'dispersible'
    ],
    [
        /FOR SUSPENSION/,
        'forSuspension'
    ],
    [
        /FOR SOLUTION/,
        'forSolution'
    ],
    [
        /METERED/,
        'metered'
    ]
];
const $1954c03f878fe45b$var$ROUTE_LABEL_KEYS = {
    ORAL: 'oral',
    SUBLINGUAL: 'sublingual',
    INTRAVENOUS: 'iv',
    INTRAMUSCULAR: 'im',
    SUBCUTANEOUS: 'sc',
    TOPICAL: 'topical',
    CUTANEOUS: 'topical',
    TRANSDERMAL: 'topical',
    RESPIRATORY: 'inhaled',
    INHALATION: 'inhaled',
    OPHTHALMIC: 'ophthalmic',
    OTIC: 'otic',
    AURICULAR: 'otic',
    NASAL: 'nasal',
    RECTAL: 'rectal',
    VAGINAL: 'vaginal'
};
function $1954c03f878fe45b$export$2eb6d07f42ee42be(form, route, t, fallback = '') {
    const words = String(form || '').toUpperCase().replace(/,/g, ' ').split(/\s+/).filter(Boolean);
    // «SOLUTION, DROPS» is drops to a doctor: the way it is taken leads.
    const parts = words.flatMap((w)=>w.split('/'));
    const headKey = parts.some((p)=>p === 'DROPS' || p === 'DROP') ? 'drops' : $1954c03f878fe45b$var$FORM_LABEL_KEYS[parts.find((p)=>$1954c03f878fe45b$var$FORM_LABEL_KEYS[p])];
    const phrase = words.join(' ');
    const qualifiers = $1954c03f878fe45b$var$QUALIFIER_LABEL_KEYS.filter(([re])=>re.test(phrase)).map(([, k])=>t(`visit.rx.forms.qualifier.${k}`));
    const base = headKey ? t(`visit.rx.forms.${headKey}`) : form || fallback;
    const routeKey = $1954c03f878fe45b$var$ROUTE_LABEL_KEYS[String(route || '').toUpperCase()];
    return {
        label: [
            base,
            ...qualifiers
        ].filter(Boolean).join(' '),
        detail: routeKey ? t(`visit.rx.routes.${routeKey}`) : route && route !== 'PARENTERAL' ? route : ''
    };
}


const $864ce04f6c433567$export$89249b52d57a6841 = `
  mutation ProposeMedications($input: MedicationProposalInput!) {
    proposeMedications(input: $input) {
      status charged
      proposals {
        kind drugText genericName strength form dosage frequency route duration quantity
        instructions rationale evidence confidence matchStatus selectedDrugId
        candidates {
          score strengthMatch
          drug { id name genericName category commonDosages commonFrequencies taminListed }
        }
      }
    }
  }
`;
const $864ce04f6c433567$export$594476081fc43e05 = Object.freeze({
    VOICE: 'VOICE',
    MONITORING: 'MONITORING',
    HISTORY: 'HISTORY'
});
const $864ce04f6c433567$export$8f37739954cc7f1c = Object.freeze({
    VOICE: {
        action: 'RX_VOICE',
        ledgerId: 'rxVoice'
    },
    MONITORING: {
        action: 'RX_MONITORING',
        ledgerId: 'rxMonitoring'
    },
    HISTORY: {
        action: 'RX_HISTORY',
        ledgerId: 'rxHistory'
    }
});
const $864ce04f6c433567$export$154a8f47e4320513 = 12000;
const $864ce04f6c433567$var$text = (v)=>(v == null ? '' : String(v)).trim();
function $864ce04f6c433567$export$afd37530d39fcdf4(source, ctx = {}) {
    const patient = ctx.patient || {};
    const allergies = (patient.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean);
    const input = {
        source: source,
        appointmentId: ctx.appointmentId || '',
        patientId: patient.id || null,
        currentMedications: (ctx.rxItems || []).map((r)=>r?.drug?.name).filter(Boolean),
        patientAllergies: allergies,
        // null = unknown — never 0, which the model reads as a newborn.
        age: patient.age ?? null,
        gender: ''
    };
    if (source === $864ce04f6c433567$export$594476081fc43e05.VOICE) input.utterance = $864ce04f6c433567$var$text(ctx.utterance);
    if (source === $864ce04f6c433567$export$594476081fc43e05.MONITORING) input.utterance = $864ce04f6c433567$var$text(ctx.transcript).slice(-$864ce04f6c433567$export$154a8f47e4320513);
    if (source === $864ce04f6c433567$export$594476081fc43e05.HISTORY) {
        const soap = ctx.soap || {};
        Object.assign(input, {
            soapS: $864ce04f6c433567$var$text(soap.s),
            soapO: $864ce04f6c433567$var$text(soap.o),
            soapA: $864ce04f6c433567$var$text(soap.a),
            soapP: $864ce04f6c433567$var$text(soap.p),
            diagnoses: (ctx.diagnoses || []).map($864ce04f6c433567$var$text).filter(Boolean)
        });
    }
    return input;
}
function $864ce04f6c433567$export$9ff2a43ac3d586f(source, ctx = {}) {
    if (source === $864ce04f6c433567$export$594476081fc43e05.HISTORY) {
        const soap = ctx.soap || {};
        return !!($864ce04f6c433567$var$text(soap.s) || $864ce04f6c433567$var$text(soap.a) || (ctx.diagnoses || []).some((d)=>$864ce04f6c433567$var$text(d)));
    }
    if (source === $864ce04f6c433567$export$594476081fc43e05.MONITORING) return !!(ctx.hasTranscript || $864ce04f6c433567$var$text(ctx.transcript));
    return true;
}
const $864ce04f6c433567$export$d17c451ccb229dcb = Object.freeze({
    READY: 'ready',
    ALLERGY: 'allergy',
    IN_RX: 'inRx',
    CHOOSE: 'choose',
    UNMATCHED: 'unmatched',
    UNAVAILABLE: 'unavailable'
});
const $864ce04f6c433567$var$candidateDrugs = (p)=>(p?.candidates || []).map((c)=>c.drug).filter((d)=>d?.id);
function $864ce04f6c433567$export$dfbc9b6ad0d6c589(row) {
    if (!row?.drugId) return null;
    return $864ce04f6c433567$var$candidateDrugs(row.proposal).find((d)=>d.id === row.drugId) || null;
}
function $864ce04f6c433567$export$cb853f6c272ac55f(row, rxItems = []) {
    if (!rxItems?.length || !row?.proposal) return false;
    const drugs = [
        $864ce04f6c433567$export$dfbc9b6ad0d6c589(row),
        ...$864ce04f6c433567$var$candidateDrugs(row.proposal)
    ].filter(Boolean);
    if (drugs.some((d)=>(0, $622fea85856450c1$export$26bd9984be9bfd1c)(rxItems, d))) return true;
    const lines = rxItems.map((r)=>r?.drug).filter(Boolean);
    if (drugs.length) {
        const held = new Set(lines.map((0, $1954c03f878fe45b$export$1d5b418d03549c72)).filter(Boolean));
        return drugs.some((d)=>{
            const k = (0, $1954c03f878fe45b$export$1d5b418d03549c72)(d);
            return !!k && held.has(k);
        });
    }
    const named = (0, $1954c03f878fe45b$export$6bd67e54caba8b84)(row.proposal.genericName);
    return !!named && lines.some((d)=>{
        const p = (0, $1954c03f878fe45b$export$118f73129e96440a)(d);
        return p.structured && (0, $1954c03f878fe45b$export$6bd67e54caba8b84)(p.ingredient) === named;
    });
}
function $864ce04f6c433567$export$38b57db04f34575e(row, { rxItems: rxItems = [], allergies: allergies = [] } = {}) {
    if ($864ce04f6c433567$export$cb853f6c272ac55f(row, rxItems)) return $864ce04f6c433567$export$d17c451ccb229dcb.IN_RX;
    const drug = $864ce04f6c433567$export$dfbc9b6ad0d6c589(row);
    if (!drug) {
        if (row.proposal?.matchStatus === 'unavailable') return $864ce04f6c433567$export$d17c451ccb229dcb.UNAVAILABLE;
        return $864ce04f6c433567$var$candidateDrugs(row.proposal).length ? $864ce04f6c433567$export$d17c451ccb229dcb.CHOOSE : $864ce04f6c433567$export$d17c451ccb229dcb.UNMATCHED;
    }
    if ((0, $737671bfbc703ec9$export$7ec7358ec49034c8)(drug, allergies) || (0, $737671bfbc703ec9$export$7ec7358ec49034c8)({
        name: row.proposal?.drugText,
        genericName: row.proposal?.genericName
    }, allergies)) return $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY;
    return $864ce04f6c433567$export$d17c451ccb229dcb.READY;
}
function $864ce04f6c433567$export$63b3df14443601d9(row, allergies = []) {
    const drug = $864ce04f6c433567$export$dfbc9b6ad0d6c589(row);
    return drug && (0, $737671bfbc703ec9$export$7ec7358ec49034c8)(drug, allergies) || (0, $737671bfbc703ec9$export$7ec7358ec49034c8)({
        name: row.proposal?.drugText,
        genericName: row.proposal?.genericName
    }, allergies);
}
// A dictated line and a drug the doctor prescribed aloud are the doctor's own
// decisions; a drug merely mentioned in the conversation and a model suggestion
// are not, and wait for a tick.
const $864ce04f6c433567$var$DECIDED_KINDS = new Set([
    'dictated',
    'prescribed'
]);
function $864ce04f6c433567$export$b06f6f1f87b469fc(proposals, ctx = {}) {
    return (proposals || []).map((proposal, i)=>{
        const row = {
            key: `p${i}`,
            proposal: proposal,
            drugId: proposal.selectedDrugId || '',
            checked: false
        };
        row.checked = $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY && proposal.matchStatus === 'matched' && $864ce04f6c433567$var$DECIDED_KINDS.has(proposal.kind);
        return row;
    });
}
function $864ce04f6c433567$export$2eabf1eeeee79bc3(rows, ctx = {}) {
    let changed = false;
    const next = (rows || []).map((row)=>{
        const known = $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.IN_RX;
        if (known === !!row.known) return row;
        changed = true;
        return {
            ...row,
            known: known,
            checked: row.checked && !known
        };
    });
    return changed ? next : rows;
}
function $864ce04f6c433567$export$c3f458c6c3133171(rows, key, drugId, ctx = {}) {
    return rows.map((row)=>{
        if (row.key !== key) return row;
        const next = {
            ...row,
            drugId: drugId || ''
        };
        // Choosing IS the decision — unless the choice is unsafe or a duplicate.
        next.checked = !!drugId && $864ce04f6c433567$export$38b57db04f34575e(next, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY;
        return next;
    });
}
function $864ce04f6c433567$export$93f90af192fa87b(rows, key, ctx = {}) {
    return rows.map((row)=>{
        if (row.key !== key) return row;
        const state = $864ce04f6c433567$export$38b57db04f34575e(row, ctx);
        // A row with no formulary drug, or one already prescribed, has nothing to add.
        if (![
            $864ce04f6c433567$export$d17c451ccb229dcb.READY,
            $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY
        ].includes(state)) return row;
        return {
            ...row,
            checked: !row.checked
        };
    });
}
function $864ce04f6c433567$export$b1b58b633f75984f(rows, checked, ctx = {}) {
    return (rows || []).map((row)=>{
        if (!checked) return row.checked ? {
            ...row,
            checked: false
        } : row;
        return !row.checked && $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY ? {
            ...row,
            checked: true
        } : row;
    });
}
function $864ce04f6c433567$export$987de25ed0ca3e20(p) {
    const out = {};
    const dosage = $864ce04f6c433567$var$text(p?.dosage) || $864ce04f6c433567$var$text(p?.strength);
    if (dosage) out.dosage = dosage;
    for (const k of [
        'frequency',
        'route',
        'duration',
        'quantity',
        'instructions'
    ])if ($864ce04f6c433567$var$text(p?.[k])) out[k] = $864ce04f6c433567$var$text(p[k]);
    return out;
}
function $864ce04f6c433567$export$231c4e06e639a88f(rows, ctx = {}) {
    return (rows || []).filter((row)=>row.checked).filter((row)=>[
            $864ce04f6c433567$export$d17c451ccb229dcb.READY,
            $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY
        ].includes($864ce04f6c433567$export$38b57db04f34575e(row, ctx))).map((row)=>({
            drug: $864ce04f6c433567$export$dfbc9b6ad0d6c589(row),
            defaults: $864ce04f6c433567$export$987de25ed0ca3e20(row.proposal)
        }));
}
function $864ce04f6c433567$export$cb741851902ee7c4(lines, { source: source = '', durations: durations = [], label: label = ()=>'' } = {}) {
    const fresh = [];
    for (const line of lines || [])if (line?.drug?.id && !fresh.some((l)=>l.drug.id === line.drug.id)) fresh.push(line);
    const stamp = Date.now();
    return fresh.map(({ drug: drug, defaults: defaults }, i)=>{
        const values = (0, $ace44487380106d3$export$2e037991db2fc726)(drug, defaults, {
            durations: durations
        });
        const dose = (0, $ace44487380106d3$export$af120d81d82db54b)(drug, defaults?.dosage);
        if (dose) values.dosage = dose;
        else delete values.dosage;
        return {
            key: `ai:${source}:${stamp}:${i}:${drug.id}`,
            drug: drug,
            defaults: values,
            sourceLabel: label(i + 1, fresh.length),
            sourceKind: 'ai'
        };
    });
}
function $864ce04f6c433567$export$38da4481450f6e5c(p, frequencyLabel = (f)=>f) {
    return [
        $864ce04f6c433567$var$text(p?.dosage) || $864ce04f6c433567$var$text(p?.strength),
        p?.frequency && frequencyLabel(p.frequency),
        $864ce04f6c433567$var$text(p?.route),
        $864ce04f6c433567$var$text(p?.duration)
    ].filter(Boolean).join(" \xb7 ");
}


// «تکمیل از پایش بالینی» (PM-0038) — the ONE vocabulary for everything the visit's
// transcript can fill in: the control that makes the transcript, the button that
// reads it, the card a reading comes back as, and the guide that walks the doctor
// from one section's proposals to the next.
//
//   MonitoringControl   «پایش بالینی» itself + the visit-wide «تکمیل», in the desk's top
//                       bar. (The phone composes MobileVisitMonitorButton + the
//                       same CompleteButton in its pinned top strip.)
//   CompleteButton      the same button in every section: press it and the recorded
//                       «پایش بالینی» is read for THAT section.
//   ProposalCard        what a reading returns — a proposal, labelled as AI output,
//   ProposalActions     sitting in the section it would fill until the doctor
//                       confirms or rejects it. Nothing here writes.
//   CompletionGuide     the sections that still hold proposals, in order, and the
//                       way to the next one.
//   ProposalBadge       the count a tab or a section header wears while it waits.
//
// Both surfaces render these (`variant`): px on the desk, rem and 44px targets on
// the phone. Colour is the accent family only, so a preset re-themes all of it.

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3365fede8cd1121a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $3365fede8cd1121a$export$2e2bcd8739ae039 = (0, $9QBug.default)("loader-circle", $3365fede8cd1121a$export$3efd853dbb351e94);


var $hSPBf = parcelRequire("hSPBf");
var $4gxLI = parcelRequire("4gxLI");
var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $7udIf = parcelRequire("7udIf");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $6b8cec43441c5f15$var$K = 'visit.complete';
const $6b8cec43441c5f15$var$SIZES = {
    web: {
        font: 11.5,
        small: 10.5,
        icon: 12,
        padY: 5,
        padX: 11,
        gap: 5,
        radius: 8,
        minH: undefined
    },
    mobile: {
        font: '0.8125rem',
        small: '0.75rem',
        icon: 15,
        padY: '0.375rem',
        padX: '0.875rem',
        gap: '0.375rem',
        radius: 10,
        minH: '2.75rem'
    }
};
const $6b8cec43441c5f15$var$pad = (n)=>String(n).padStart(2, '0');
const $6b8cec43441c5f15$var$spinner = (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
        size: size,
        "aria-hidden": true,
        className: "animate-spin motion-reduce:animate-none",
        style: {
            flexShrink: 0
        }
    });
// The look of «تکمیل» (PM-0045). Two tones of one family, both built from the
// accent tokens so a panel or an accent preset re-themes them:
//   solid — the brand gradient with a passing sheen: the visit-wide button;
//   soft  — a surface pill inside a slowly turning gradient ring: every section.
// While it reads, the waveform of the mark moves instead of a spinner: the button
// is listening to the transcript. Keyframes cannot live in an inline style, so the
// rules ship as one <style> the first button on the page renders.
const $6b8cec43441c5f15$var$COMPLETE_CSS = `
@property --pc-a { syntax: '<angle>'; initial-value: 0deg; inherits: false; }
@keyframes pc-spin { to { --pc-a: 360deg } }
@keyframes pc-sheen { 0%,70% { transform: translateX(130%) } 100% { transform: translateX(-130%) } }
@keyframes pc-wave { 0%,100% { transform: scaleY(.45) } 50% { transform: scaleY(1.25) } }
.pc-complete { position: relative; transition: transform .15s, box-shadow .2s; }
.pc-complete:not([aria-disabled="true"]):not(:disabled):active { transform: scale(.97); }
.pc-complete:focus-visible { outline: 2px solid var(--p-navy); outline-offset: 2px; }
.pc-complete .pc-bar { transform-origin: center; transform-box: fill-box; }
.pc-complete[aria-busy="true"] .pc-bar { animation: pc-wave .9s ease-in-out infinite; }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(2) { animation-delay: .15s }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(3) { animation-delay: .3s }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(4) { animation-delay: .45s }
.pc-complete--solid { overflow: hidden; border: 1px solid transparent;
  background: linear-gradient(120deg, var(--p-teal), var(--p-navy));
  box-shadow: 0 3px 12px color-mix(in srgb, var(--p-navy) 30%, transparent); }
.pc-complete--solid::after { content: ''; position: absolute; inset: 0; pointer-events: none;
  background: linear-gradient(105deg, transparent 35%, rgba(255,255,255,.45) 50%, transparent 65%);
  animation: pc-sheen 4s ease-in-out infinite; }
.pc-complete--solid:not(:disabled):hover { box-shadow: 0 5px 20px color-mix(in srgb, var(--p-teal) 50%, transparent); }
.pc-complete--soft { border: 1.5px solid transparent;
  background: linear-gradient(${(0, $jTCZr.CT).surface}, ${(0, $jTCZr.CT).surface}) padding-box,
    conic-gradient(from var(--pc-a), var(--p-teal), var(--p-navy), var(--p-teal-light), var(--p-teal)) border-box;
  animation: pc-spin 5s linear infinite;
  box-shadow: 0 2px 10px color-mix(in srgb, var(--p-navy) 14%, transparent); }
.pc-complete--soft:not(:disabled):not([aria-disabled="true"]):hover { animation-duration: 1.6s;
  box-shadow: 0 4px 18px color-mix(in srgb, var(--p-teal) 35%, transparent); }
.pc-complete--soft[aria-busy="true"] { animation-duration: 1.2s; }
.pc-complete--soft .pc-spark { fill: var(--p-teal); }
@media (prefers-reduced-motion: reduce) {
  .pc-complete, .pc-complete::after, .pc-complete .pc-bar { animation: none !important; transition: none !important; }
}
`;
function $6b8cec43441c5f15$export$70c07385940452eb({ size: size = 12, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": true,
        viewBox: "0 0 26 20",
        fill: "currentColor",
        width: Math.round(size * 1.3),
        height: size,
        style: {
            flexShrink: 0,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "1",
        y: "7",
        width: "2.4",
        height: "6",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "5.6",
        y: "3",
        width: "2.4",
        height: "14",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "10.2",
        y: "6",
        width: "2.4",
        height: "8",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "14.8",
        y: "8",
        width: "2.4",
        height: "4",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "pc-spark",
        d: "M21.5 1.5l1 2.6 2.6 1-2.6 1-1 2.6-1-2.6-2.6-1 2.6-1z"
    }));
}
function $6b8cec43441c5f15$export$75b49caa06e7c59e({ count: count, variant: variant = 'web', testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (!(count > 0)) return null;
    const mobile = variant === 'mobile';
    const n = formatNumber ? formatNumber(count) : String(count);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        title: t(`${$6b8cec43441c5f15$var$K}.badge`, {
            n: n
        }),
        "aria-label": t(`${$6b8cec43441c5f15$var$K}.badge`, {
            n: n
        }),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0,
            padding: mobile ? '0.0625rem 0.3125rem' : '1px 6px',
            borderRadius: 999,
            fontSize: mobile ? '0.625rem' : 10,
            fontWeight: 700,
            lineHeight: 1.5,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: mobile ? 10 : 9,
        "aria-hidden": true
    }), " ", n);
}
function $6b8cec43441c5f15$export$5a0ca1724712239e({ onClick: onClick, busy: busy = false, disabled: disabled = false, title: title, label: label, count: count = 0, variant: variant = 'web', tone: tone = 'soft', compact: compact = false, nested: nested = false, testid: testid = 'visit-complete' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const off = disabled || busy;
    const solid = tone === 'solid';
    const press = (e)=>{
        e.stopPropagation();
        if (!off) onClick?.(e);
    };
    // `nested`: the button sits inside another button (a section header that
    // toggles), where a real <button> would be invalid markup — same control, as
    // a focusable role="button".
    const Tag = nested ? 'span' : 'button';
    const own = nested ? {
        role: 'button',
        tabIndex: off ? -1 : 0,
        'aria-disabled': off || undefined,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                press(e);
            }
        }
    } : {
        type: 'button',
        disabled: off
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...own,
        onClick: press,
        title: title || t(`${$6b8cec43441c5f15$var$K}.hint`),
        "aria-busy": busy || undefined,
        "data-testid": testid,
        "data-tone": tone,
        className: `pc-complete pc-complete--${solid ? 'solid' : 'soft'}`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: S.gap,
            flexShrink: 0,
            padding: compact && variant !== 'mobile' ? '3px 9px' : `${typeof S.padY === 'number' ? `${S.padY}px` : S.padY} ${typeof S.padX === 'number' ? `${S.padX}px` : S.padX}`,
            minHeight: S.minH,
            borderRadius: 999,
            whiteSpace: 'nowrap',
            color: solid ? (0, $jTCZr.CT).surface : (0, $jTCZr.CT).accentInk,
            fontSize: compact && variant !== 'mobile' ? S.small : S.font,
            fontWeight: 700,
            fontFamily: 'inherit',
            // Busy keeps its full colour — the moving waveform is the state.
            cursor: off ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $6b8cec43441c5f15$var$COMPLETE_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon
    }), label || t(`${$6b8cec43441c5f15$var$K}.button`), count > 0 && !busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testid}-count`,
        style: {
            minWidth: '1.25em',
            padding: '0 0.3em',
            borderRadius: 999,
            textAlign: 'center',
            fontSize: '0.85em',
            lineHeight: 1.5,
            background: solid ? (0, $jTCZr.CT).surface : (0, $jTCZr.CT).navy,
            color: solid ? (0, $jTCZr.CT).navy : (0, $jTCZr.CT).surface
        }
    }, formatNumber ? formatNumber(count) : count));
}
function $6b8cec43441c5f15$export$c77d4a7df286b4a9({ title: title, heading: heading, onClose: onClose, children: children, footer: footer, variant: variant = 'web', testid: testid, style: style, ...rest }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-proposal-card": "",
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: mobile ? '0.625rem' : 9,
            flexShrink: 0,
            padding: mobile ? '0.75rem' : '10px 12px',
            borderRadius: S.radius,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            borderInlineStart: `3px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accentSoft,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon,
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.font,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, heading || (title ? t(`${$6b8cec43441c5f15$var$K}.proposalFor`, {
        section: title
    }) : t(`${$6b8cec43441c5f15$var$K}.proposal`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: S.small,
            fontWeight: 600,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap'
        }
    }, t('visit.suggest.ai'))), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        "data-testid": `${testid}-close`,
        style: {
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            width: mobile ? '2.75rem' : 22,
            height: mobile ? '2.75rem' : 22,
            // The 44px target reaches into the card's own padding, so the row
            // stays one line tall.
            marginBlock: mobile ? '-0.625rem' : undefined,
            marginInlineEnd: mobile ? '-0.5rem' : undefined,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: mobile ? 16 : 13,
        "aria-hidden": true
    }))), children, footer);
}
function $6b8cec43441c5f15$export$8f3e57e0bb4fa42c({ onAccept: onAccept, acceptLabel: acceptLabel, acceptDisabled: acceptDisabled = false, busy: busy = false, onDismiss: onDismiss, dismissLabel: dismissLabel, children: children, variant: variant = 'web', testid: testid, acceptTestid: acceptTestid = `${testid}-apply`, dismissTestid: dismissTestid = `${testid}-cancel` }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const off = acceptDisabled || busy;
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: S.gap,
        minHeight: S.minH,
        borderRadius: mobile ? 10 : 7,
        fontSize: S.font,
        fontFamily: 'inherit',
        padding: mobile ? '0.375rem 0.875rem' : '5px 12px',
        whiteSpace: 'nowrap'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 8,
            flexWrap: 'wrap',
            paddingTop: mobile ? '0.625rem' : 9,
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onDismiss,
        "data-testid": dismissTestid,
        style: {
            ...base,
            fontWeight: 600,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink2,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: S.icon,
        "aria-hidden": true
    }), " ", dismissLabel || t(`${$6b8cec43441c5f15$var$K}.reject`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAccept,
        disabled: off,
        "data-testid": acceptTestid,
        style: {
            ...base,
            fontWeight: 700,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            cursor: off ? 'not-allowed' : 'pointer',
            opacity: off ? 0.5 : 1
        }
    }, busy ? $6b8cec43441c5f15$var$spinner(S.icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: S.icon,
        "aria-hidden": true
    }), " ", acceptLabel || t(`${$6b8cec43441c5f15$var$K}.accept`)));
}
function $6b8cec43441c5f15$export$f8baeb9beb7439e1({ steps: steps, current: current, next: next, onGo: onGo, variant: variant = 'web', testid: testid = 'visit-complete-guide' }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    if (!steps?.length) return null;
    const Forward = isRTL ? (0, $gKFEi.default) : (0, $kzPvP.default);
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const waiting = steps.filter((s)=>!s.done).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 8,
            flexShrink: 0,
            padding: mobile ? '0.375rem 0.875rem' : '6px 16px',
            background: (0, $jTCZr.CT).accentSoft,
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t(`${$6b8cec43441c5f15$var$K}.guide.title`, {
            n: fmt(waiting)
        }),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            flexShrink: 0,
            fontSize: S.small,
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon
    }), !mobile && t(`${$6b8cec43441c5f15$var$K}.guide.title`, {
        n: fmt(waiting)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.375rem' : 6,
            overflowX: 'auto'
        }
    }, steps.map((s)=>{
        const on = s.id === current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            onClick: ()=>onGo?.(s.id),
            "data-testid": `${testid}-step-${s.id}`,
            "data-state": s.done ? 'done' : 'waiting',
            "aria-current": on ? 'step' : undefined,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                minHeight: mobile ? '2.25rem' : undefined,
                padding: mobile ? '0.25rem 0.625rem' : '3px 9px',
                borderRadius: 999,
                border: `1px solid ${on ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
                background: (0, $jTCZr.CT).surface,
                color: s.done ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                fontSize: S.small,
                fontWeight: on ? 700 : 600,
                fontFamily: 'inherit',
                cursor: 'pointer'
            }
        }, s.done ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: S.icon,
            "aria-hidden": true,
            style: {
                color: (0, $jTCZr.CT).good
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                minWidth: '1.3em',
                padding: '0 0.3em',
                borderRadius: 999,
                textAlign: 'center',
                background: (0, $jTCZr.CT).accent,
                color: (0, $jTCZr.CT).surface,
                fontSize: '0.9em'
            }
        }, fmt(s.count)), s.label);
    })), next && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onGo?.(next.id),
        "data-testid": `${testid}-next`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            minHeight: mobile ? '2.25rem' : undefined,
            padding: mobile ? '0.25rem 0.75rem' : '4px 11px',
            borderRadius: 999,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            fontSize: S.small,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer'
        }
    }, t(`${$6b8cec43441c5f15$var$K}.guide.next`, {
        section: next.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Forward, {
        size: S.icon,
        "aria-hidden": true
    })));
}
function $6b8cec43441c5f15$export$45fe3bada8fd7008({ recState: recState = 'idle', recElapsed: recElapsed = 0, onToggle: onToggle, disabled: disabled = false, complete: complete = null, variant: variant = 'web', testid: testid = variant === 'mobile' ? 'visit-rec-toggle' : 'visit-monitoring-toggle' }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const digits = (s)=>formatDigits ? formatDigits(s) : s;
    const clock = digits(`${$6b8cec43441c5f15$var$pad(Math.floor(recElapsed / 60))}:${$6b8cec43441c5f15$var$pad(recElapsed % 60)}`);
    const recording = recState === 'recording';
    const stopping = recState === 'stopping';
    const connecting = recState === 'connecting';
    const paused = recState === 'paused-by-system';
    const error = recState === 'error';
    const off = disabled || stopping || connecting;
    let label = t('visit.listen.start');
    let Icon = (0, $hSPBf.default);
    // Idle is the invitation: the accent, soft. The two waiting states are neutral.
    let colors = {
        background: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk,
        borderColor: (0, $jTCZr.CT).accent
    };
    const neutral = {
        background: (0, $jTCZr.CT).surface,
        color: (0, $jTCZr.CT).ink2,
        borderColor: (0, $jTCZr.CT).border
    };
    if (recording) {
        label = t('visit.listen.stop');
        Icon = (0, $7udIf.default);
        colors = {
            background: (0, $jTCZr.CT).dangerSoft,
            color: (0, $jTCZr.CT).dangerInk,
            borderColor: (0, $jTCZr.CT).danger
        };
    } else if (connecting) {
        label = t('visit.record.connecting');
        Icon = (0, $3365fede8cd1121a$export$2e2bcd8739ae039);
        colors = neutral;
    } else if (stopping) {
        label = t('visit.listen.stopping');
        Icon = (0, $7udIf.default);
        colors = neutral;
    } else if (paused) {
        label = t('visit.listen.resume');
        Icon = (0, $4gxLI.default);
        colors = {
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        };
    } else if (error) {
        label = t(mobile ? 'errors.connection.lostTap' : 'errors.connection.lostClick');
        Icon = (0, $bF8pu.default);
        colors = {
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": t('visit.copilot.monitoring'),
        "data-testid": "visit-monitoring-control",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 6,
            ...mobile ? {
                padding: '0.5rem 0.875rem',
                background: (0, $jTCZr.CT).surface,
                borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
            } : {
                flexShrink: 0
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggle,
        disabled: off,
        "data-testid": testid,
        "data-state": recState,
        "aria-label": recording ? `${label} \u{2014} ${clock}` : label,
        title: label,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: S.gap,
            flex: mobile ? 1 : undefined,
            minWidth: 0,
            minHeight: S.minH,
            padding: mobile ? '0.375rem 0.875rem' : '5px 11px',
            borderRadius: 999,
            border: `1px solid ${colors.borderColor}`,
            background: colors.background,
            color: colors.color,
            fontSize: mobile ? '0.875rem' : 12,
            fontWeight: 700,
            fontFamily: 'inherit',
            whiteSpace: 'nowrap',
            cursor: off ? 'default' : 'pointer',
            opacity: off ? 0.6 : 1
        }
    }, recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: mobile ? 16 : 13,
        "aria-hidden": true,
        className: connecting ? 'animate-spin motion-reduce:animate-none' : undefined,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, label), recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": mobile ? 'visit-rec-clock' : 'visit-monitoring-clock',
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, clock)), complete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$5a0ca1724712239e, {
        tone: "solid",
        variant: variant,
        testid: "visit-complete-all",
        ...complete
    }));
}


const $2366d82badfc6b73$var$SIZES = {
    web: {
        title: '12px',
        body: '12.5px',
        meta: '10.5px',
        pad: '8px 10px',
        gap: 6,
        radius: 8,
        checkbox: undefined,
        action: '11.5px'
    },
    mobile: {
        title: '0.9375rem',
        body: '0.875rem',
        meta: '0.75rem',
        pad: '0.625rem 0.75rem',
        gap: 8,
        radius: 10,
        checkbox: '1.125rem',
        action: '0.875rem'
    }
};
const $2366d82badfc6b73$var$TITLE_KEY = {
    VOICE: 'visit.rxAssist.voiceTitle',
    MONITORING: 'visit.rxAssist.monitoringTitle',
    HISTORY: 'visit.rxAssist.historyTitle'
};
const $2366d82badfc6b73$var$LOADING_KEY = {
    VOICE: 'visit.rxAssist.loading.voice',
    MONITORING: 'visit.rxAssist.loading.monitoring',
    HISTORY: 'visit.rxAssist.loading.history'
};
// Why a finished run has no rows — each status says what to do next.
const $2366d82badfc6b73$var$EMPTY_KEY = {
    none_found: {
        VOICE: 'visit.rxAssist.empty.voice',
        MONITORING: 'visit.rxAssist.empty.monitoring',
        HISTORY: 'visit.rxAssist.empty.history'
    },
    no_input: 'visit.rxAssist.empty.noInput',
    no_transcript: 'visit.rxAssist.empty.noTranscript',
    no_history: 'visit.rxAssist.empty.noHistory'
};
const $2366d82badfc6b73$var$emptyKey = (status, source)=>{
    const entry = $2366d82badfc6b73$var$EMPTY_KEY[status] || $2366d82badfc6b73$var$EMPTY_KEY.none_found;
    return typeof entry === 'string' ? entry : entry[source];
};
const $2366d82badfc6b73$var$same = (a, b)=>String(a || '').replace(/[\s‌]+/g, '').toLowerCase() === String(b || '').replace(/[\s‌]+/g, '').toLowerCase();
function $2366d82badfc6b73$var$Badge({ tone: tone, children: children, testid: testid }) {
    const tones = {
        danger: [
            (0, $jTCZr.CT).dangerSoft,
            (0, $jTCZr.CT).dangerInk
        ],
        warn: [
            (0, $jTCZr.CT).warnSoft,
            (0, $jTCZr.CT).warnInk
        ],
        good: [
            (0, $jTCZr.CT).goodSoft,
            (0, $jTCZr.CT).goodInk
        ],
        mute: [
            (0, $jTCZr.CT).surface2,
            (0, $jTCZr.CT).ink2
        ],
        accent: [
            (0, $jTCZr.CT).accentSoft,
            (0, $jTCZr.CT).accentInk
        ]
    };
    const [bg, fg] = tones[tone] || tones.mute;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: '0.92em',
            fontWeight: 600,
            background: bg,
            color: fg,
            whiteSpace: 'nowrap'
        }
    }, children);
}
// A formulary product's name(s) by the one rule every drug surface follows
// (lib/drugNames drugNameLines): the Latin leads, and the registry's Persian
// product string follows it only for a reader who reads Persian. It used to be
// «Persian — LATIN» for everyone, so an Arabic doctor chose between strings like
// «آموکسی‌سیلین 500 میلی‌گرم کپسول خوراکی — AMOXICILLIN 500 mg CAPSULE ORAL».
const $2366d82badfc6b73$var$productLabel = (drug, readsPersianData)=>{
    const { primary: primary, secondary: secondary } = (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(drug, readsPersianData);
    return secondary ? `${primary} \u{2014} ${secondary}` : primary;
};
// The line under a row's name for a reader who does not read Persian. A
// proposal carries the model's raw values — the closed lists' Persian, often with
// ASCII digits — and only the frequency went through a label, which then missed
// «هر 8 ساعت» for its digit: an Arabic doctor read «1 کپسول · هر 8 ساعت · خوراکی ·
// 10 روز». It now reads in the words the نسخه's own line uses once it is added:
// the dose by its units, the frequency by its option, route and duration by their
// keys. Anything outside those lists is shown as the model wrote it.
const $2366d82badfc6b73$var$readerSig = (p, t)=>[
        (0, $ace44487380106d3$export$6742958aefab4338)(p?.dosage, t) || String(p?.dosage || p?.strength || '').trim(),
        p?.frequency && (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)((0, $ace44487380106d3$export$698a3d49e661c86e)(p.frequency) || p.frequency, t),
        p?.route && (0, $ace44487380106d3$export$80ace2b99405d272)(p.route, t),
        p?.duration && (0, $ace44487380106d3$export$6983ec1528bb4f57)(p.duration, t)
    ].map((x)=>String(x || '').trim()).filter(Boolean).join(" \xb7 ");
function $2366d82badfc6b73$var$ProposalRow({ row: row, ctx: ctx, S: S, source: source, onToggle: onToggle, onChoose: onChoose, onSearch: onSearch, testid: testid }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const p = row.proposal;
    const state = (0, $864ce04f6c433567$export$38b57db04f34575e)(row, ctx);
    const drug = (0, $864ce04f6c433567$export$dfbc9b6ad0d6c589)(row);
    const allergy = state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).ALLERGY ? (0, $864ce04f6c433567$export$63b3df14443601d9)(row, ctx.allergies) : null;
    const addable = state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).READY || state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).ALLERGY;
    const names = drug ? (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(drug, readsPersianData) : null;
    const name = names?.primary || p.drugText || p.genericName;
    // A Persian reader reads the values as written.
    const sig = readsPersianData ? (0, $864ce04f6c433567$export$38da4481450f6e5c)(p, (f)=>(0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(f, t)) : $2366d82badfc6b73$var$readerSig(p, t);
    const candidates = (p.candidates || []).filter((c)=>c.drug?.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-row-${row.key}`,
        "data-state": state,
        "data-checked": row.checked ? 'true' : 'false',
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: `1px solid ${allergy ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            opacity: state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).IN_RX ? 0.7 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        "aria-label": name,
        checked: row.checked,
        disabled: !addable,
        onChange: ()=>onToggle(row.key),
        "data-testid": `${testid}-check-${row.key}`,
        style: {
            marginTop: 3,
            accentColor: (0, $jTCZr.CT).accent,
            width: S.checkbox,
            height: S.checkbox,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 3
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        style: {
            fontSize: S.body,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, name), names?.secondary && !$2366d82badfc6b73$var$same(names.secondary, name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute
        }
    }, names.secondary), p.kind === 'prescribed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "accent"
    }, t('visit.rxAssist.kind.prescribed')), p.kind === 'mentioned' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "mute"
    }, t('visit.rxAssist.kind.mentioned'))), sig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, sig), p.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, p.instructions), drug && source !== 'HISTORY' && p.drugText && !$2366d82badfc6b73$var$same(p.drugText, drug.name) && !$2366d82badfc6b73$var$same(p.drugText, drug.genericName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rxAssist.heard', {
        text: p.drugText
    })), source === 'HISTORY' && p.rationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.6
        }
    }, p.rationale), source === 'MONITORING' && p.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute,
            lineHeight: 1.6
        }
    }, "\xab", p.evidence, "\xbb"), state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).IN_RX && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "good"
    }, t('visit.rxAssist.state.inRx'))), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "danger",
        testid: `${testid}-allergy-${row.key}`
    }, t('visit.rxAssist.state.allergy', {
        allergen: allergy
    }))), (state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).CHOOSE || drug && candidates.length > 1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).warnInk
        }
    }, state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).CHOOSE && t('visit.rxAssist.state.choose'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: row.drugId,
        onChange: (e)=>onChoose(row.key, e.target.value),
        "data-testid": `${testid}-choose-${row.key}`,
        style: {
            fontSize: S.meta,
            fontFamily: 'inherit',
            padding: '3px 6px',
            borderRadius: 6,
            border: `1px solid ${state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).CHOOSE ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            maxWidth: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rxAssist.chooseDrug')), candidates.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: c.drug.id,
            value: c.drug.id
        }, $2366d82badfc6b73$var$productLabel(c.drug, readsPersianData))))), (state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).UNMATCHED || state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).UNAVAILABLE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "mute"
    }, t(state === (0, $864ce04f6c433567$export$d17c451ccb229dcb).UNMATCHED ? 'visit.rxAssist.state.unmatched' : 'visit.rxAssist.state.unavailable')), onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onSearch(p.genericName || p.drugText),
        "data-testid": `${testid}-search-${row.key}`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('visit.rxAssist.search')))));
}
// A proposal the نسخه already holds is left out of the list (K1, 2026-10-06):
// every «تکمیل» re-reads the whole transcript and hears again each drug the
// doctor already added, and a list of drugs nobody can add hides the one that
// is new. One line says how many were left out, so none looks lost.
const $2366d82badfc6b73$var$shownRows = (rows, ctx)=>(rows || []).filter((r)=>!r.known && (0, $864ce04f6c433567$export$38b57db04f34575e)(r, ctx) !== (0, $864ce04f6c433567$export$d17c451ccb229dcb).IN_RX);
function $2366d82badfc6b73$var$Body({ review: review, ctx: ctx, S: S, onToggle: onToggle, onChoose: onChoose, onSearch: onSearch, onRetry: onRetry, testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { phase: phase, source: source, status: status, error: error } = review;
    const rows = $2366d82badfc6b73$var$shownRows(review.rows, ctx);
    const onRx = (review.rows || []).length - rows.length;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).mute,
        lineHeight: 1.7
    };
    if (phase === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-loading`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '6px 2px',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: `1.5px solid ${(0, $jTCZr.CT).border}`,
            borderTopColor: (0, $jTCZr.CT).accent,
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            flexShrink: 0
        }
    }), t($2366d82badfc6b73$var$LOADING_KEY[source]));
    if (phase === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(error === 'credit' ? 'visit.rxAssist.error.credit' : 'visit.rxAssist.error.failed'), error !== 'credit' && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onRetry,
        "data-testid": `${testid}-retry`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('common.actions.retry')));
    if (!rows.length) return onRx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": "inRx",
        style: note
    }, t('visit.rxAssist.empty.allInRx')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": status,
        style: note
    }, t($2366d82badfc6b73$var$emptyKey(status, source)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-list`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: S.gap
        }
    }, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$ProposalRow, {
            key: row.key,
            row: row,
            ctx: ctx,
            S: S,
            source: source,
            onToggle: onToggle,
            onChoose: onChoose,
            onSearch: onSearch,
            testid: testid
        })), onRx > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-in-rx`,
        "data-count": onRx,
        style: note
    }, t('visit.rxAssist.inRxHidden', {
        count: onRx,
        n: formatNumber ? formatNumber(onRx) : String(onRx)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: note
    }, t('visit.rxAssist.reviewHint')));
}
function $2366d82badfc6b73$var$Commit({ review: review, ctx: ctx, S: S, variant: variant, onSetAll: onSetAll, onApply: onApply, onClose: onClose, testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rows = $2366d82badfc6b73$var$shownRows(review.rows, ctx);
    const picked = rows.filter((r)=>r.checked).length;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const link = {
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: S.meta,
        fontWeight: 600,
        color: (0, $jTCZr.CT).accentInk
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$8f3e57e0bb4fa42c), {
        variant: variant,
        testid: testid,
        onAccept: onApply,
        acceptDisabled: !picked,
        acceptLabel: t('visit.complete.acceptN', {
            n: fmt(picked)
        }),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": `${testid}-count`
    }, t('visit.rxAssist.selectedOf', {
        n: fmt(picked),
        total: fmt(rows.length)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(true),
        "data-testid": `${testid}-all`
    }, t('visit.rxAssist.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(false),
        "data-testid": `${testid}-none`
    }, t('visit.rxAssist.selectNone')));
}
function $2366d82badfc6b73$export$2e2bcd8739ae039({ review: review, rxItems: rxItems, allergies: allergies, variant: variant = 'web', onToggle: onToggle, onChoose: onChoose, onSetAll: onSetAll, onApply: onApply, onClose: onClose, onRetry: onRetry, onSearch: onSearch, testid: testid = 'visit-rx-assist' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!review?.open) return null;
    const S = $2366d82badfc6b73$var$SIZES[variant] || $2366d82badfc6b73$var$SIZES.web;
    const ctx = {
        rxItems: rxItems || [],
        allergies: allergies || []
    };
    const monitoring = review.source === 'MONITORING';
    const showCommit = review.phase === 'ready' && $2366d82badfc6b73$var$shownRows(review.rows, ctx).length > 0;
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Body, {
        review: review,
        ctx: ctx,
        S: S,
        onToggle: onToggle,
        onChoose: onChoose,
        onSearch: onSearch,
        onRetry: onRetry,
        testid: testid
    });
    const commit = showCommit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Commit, {
        review: review,
        ctx: ctx,
        S: S,
        variant: variant,
        onSetAll: onSetAll,
        onApply: onApply,
        onClose: onClose,
        testid: testid
    }) : null;
    // A reading of «پایش بالینی» is the section's «تکمیل» proposal; the other
    // sources keep their own title in the same card.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$c77d4a7df286b4a9), {
        variant: variant,
        testid: testid,
        "data-source": review.source,
        "data-phase": review.phase,
        title: monitoring ? t('visit.tabs.rx') : undefined,
        heading: monitoring ? undefined : t($2366d82badfc6b73$var$TITLE_KEY[review.source]),
        onClose: onClose,
        footer: commit
    }, body);
}


// The «نسخه»'s three AI helpers, as one piece of state both Visit surfaces share
// (docs/VISIT_RX_AI_ASSIST.md). The screen supplies what the visit knows through
// `getContext()` — read at call time, so a run always sends the SOAP and نسخه as
// they are now — and receives the approved lines through `onApply`.
//
// One review at a time: starting a second source replaces the first list. The
// list is proposals only; closing it adds nothing.

var $acw62 = parcelRequire("acw62");




// A proposal's candidates come back with their «در فهرست تأمین» (taminListed),
// which a line made from one keeps. Asked without it of a BFF that predates it:
// a validation error runs nothing, so the run is neither lost nor charged twice.
const $3e1a1a8acf34d11a$var$askProposals = (0, $8d8ac6402cc7b03c$export$405a623d7e907e9d)((0, $adebb901af88e18b$export$8395d0fc0d822a81));
const $3e1a1a8acf34d11a$var$IDLE = {
    open: false,
    source: null,
    phase: 'idle',
    status: null,
    rows: [],
    error: null
};
function $3e1a1a8acf34d11a$export$c779192d33323523({ getContext: getContext, chargeVisit: chargeVisit, chargeLabel: chargeLabel, onCreditError: onCreditError, onApply: onApply }) {
    const [review, setReview] = (0, $acw62.useState)($3e1a1a8acf34d11a$var$IDLE);
    // A slow answer to a run the doctor already replaced or closed must not reopen it.
    const runRef = (0, $acw62.useRef)(0);
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        getContext: getContext,
        chargeVisit: chargeVisit,
        chargeLabel: chargeLabel,
        onCreditError: onCreditError,
        onApply: onApply
    };
    // What a row is checked against: the نسخه and allergies as they are NOW.
    const reviewCtx = ()=>{
        const ctx = deps.current.getContext?.() || {};
        const allergies = (ctx.patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean);
        return {
            rxItems: ctx.rxItems || [],
            allergies: allergies
        };
    };
    /**
   * → 'found' | 'none' | 'known' | 'error' (undefined when a newer run replaced
   * this one). 'known': every row is already on the نسخه and the run was still
   * charged — nothing to add, but not «nothing found, no charge» either.
   */ const run = (0, $acw62.useCallback)(async (source, extra = {})=>{
        const runId = ++runRef.current;
        const ctx = {
            ...deps.current.getContext?.() || {},
            ...extra
        };
        setReview({
            ...$3e1a1a8acf34d11a$var$IDLE,
            open: true,
            source: source,
            phase: 'loading'
        });
        try {
            // Long budget (PM-0069): the server re-reads the whole visit transcript, so
            // a long visit outlives the 30 s default and the client gave up on a run
            // the server was still finishing (and might still charge for).
            const data = await $3e1a1a8acf34d11a$var$askProposals((0, $864ce04f6c433567$export$89249b52d57a6841), {
                input: (0, $864ce04f6c433567$export$afd37530d39fcdf4)(source, ctx)
            }, {
                timeoutMs: (0, $adebb901af88e18b$export$5c63bf3ded5aa229)
            });
            if (runRef.current !== runId) return undefined;
            const result = data?.proposeMedications || {
                status: 'none_found',
                charged: false,
                proposals: []
            };
            const { action: action, ledgerId: ledgerId } = (0, $864ce04f6c433567$export$8f37739954cc7f1c)[source];
            // The server's `charged` is the signal, never the click: an empty run is free.
            if (result.charged) deps.current.chargeVisit?.((0, $121df138798ec781$export$c932aceb7c67d0f4)(action), ledgerId, deps.current.chargeLabel?.(source));
            const ctxNow = reviewCtx();
            const rows = (0, $864ce04f6c433567$export$2eabf1eeeee79bc3)((0, $864ce04f6c433567$export$b06f6f1f87b469fc)(result.proposals, ctxNow), ctxNow);
            setReview({
                open: true,
                source: source,
                phase: 'ready',
                status: result.status,
                error: null,
                rows: rows
            });
            if (rows.some((r)=>!r.known)) return 'found';
            return rows.length && result.charged ? 'known' : 'none';
        } catch (e) {
            if (runRef.current !== runId) return undefined;
            const credit = e?.extensions?.code === 'INSUFFICIENT_CREDITS';
            if (credit) deps.current.onCreditError?.(e.message);
            setReview({
                ...$3e1a1a8acf34d11a$var$IDLE,
                open: true,
                source: source,
                phase: 'error',
                error: credit ? 'credit' : 'failed'
            });
            return 'error';
        }
    }, []);
    const close = (0, $acw62.useCallback)(()=>{
        runRef.current += 1;
        setReview($3e1a1a8acf34d11a$var$IDLE);
    }, []);
    const toggle = (0, $acw62.useCallback)((key)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $864ce04f6c433567$export$93f90af192fa87b)(r.rows, key, reviewCtx())
            }));
    }, []);
    const choose = (0, $acw62.useCallback)((key, drugId)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $864ce04f6c433567$export$c3f458c6c3133171)(r.rows, key, drugId, reviewCtx())
            }));
    }, []);
    const setAll = (0, $acw62.useCallback)((checked)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $864ce04f6c433567$export$b1b58b633f75984f)(r.rows, checked, reviewCtx())
            }));
    }, []);
    const apply = (0, $acw62.useCallback)(()=>{
        const lines = (0, $864ce04f6c433567$export$231c4e06e639a88f)(review.rows, reviewCtx());
        if (!lines.length) return 0;
        deps.current.onApply?.(lines, review.source);
        close();
        return lines.length;
    }, [
        review,
        close
    ]);
    // Shown against the نسخه as it is now: a drug added by hand while the review is
    // open turns «در نسخه» and stops waiting.
    const rows = (0, $864ce04f6c433567$export$2eabf1eeeee79bc3)(review.rows, reviewCtx());
    return {
        review: rows === review.rows ? review : {
            ...review,
            rows: rows
        },
        run: run,
        close: close,
        toggle: toggle,
        choose: choose,
        setAll: setAll,
        apply: apply
    };
}



// What «تکمیل» read from «پایش بالینی» for ONE group — علائم حیاتی, دستورات or
// اطلاعات پرونده — as the proposal card of the section it fills (PM-0029, PM-0038).
// The same card on both surfaces; `variant` only sizes it.
//
// Nothing here writes. Each row is a finding with the words it was read from; the
// doctor ticks, and «تأیید» hands the ticked ones to the screen, which writes each
// through the path a hand-entered value takes. A finding the visit already holds
// (`row.known` — an order already placed, a vital sign already recorded) reads
// «در این ویزیت ثبت شده», like the نسخه's «در نسخه», and cannot be ticked.
//
// A heard lab, imaging study or procedure also says which catalogue entry it will
// be saved as (`row.catalog`, lib/monitoringExtraction): the one entry named
// exactly like it, or a short list from the picker's search for the doctor to
// pick from — or their explicit «ثبت بدون کد». «تأیید» waits for that choice.

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// «پایش بالینی» beyond the نسخه (PM-0029): the visit's transcript read three more
// ways — علائم حیاتی, دستورات, اطلاعات پرونده — each its own AI service and price.
// The drugs prescribed in the conversation are the fourth reading and live in
// lib/medicationProposals.js.
//
// Everything comes back as FINDINGS the doctor ticks. Nothing reaches the record
// until «ثبت موارد انتخاب‌شده»; each kind is then written through the path a
// hand-entered value takes — the vitals form, the order list, the record's own
// mutations, the «P» of the note.
//
// The AI service has already dropped what is implausible (a vital sign outside the
// physical range) and what the record already holds (allergies, current drugs,
// conditions); what THIS VISIT already holds — its orders and recorded vitals — is
// marked here (visitHoldings). This module is pure (no
// React): which rows start ticked and how a finding becomes a form value live here,
// so both surfaces and the tests read one copy.
const $80f289cb339918db$export$1047922e50d45b96 = `
  mutation ExtractMonitoring($input: MonitoringExtractionInput!) {
    extractMonitoring(input: $input) {
      status charged
      findings { group kind text value value2 unit detail urgency evidence confidence }
    }
  }
`;
const $80f289cb339918db$export$16054fa089fae9a7 = Object.freeze([
    'VITALS',
    'ORDERS',
    'RECORD'
]);
const $80f289cb339918db$export$a7f2f1cb3a3e0344 = Object.freeze({
    VITALS: {
        action: 'MONITORING_VITALS',
        ledgerId: 'monitoringVitals'
    },
    ORDERS: {
        action: 'MONITORING_ORDERS',
        ledgerId: 'monitoringOrders'
    },
    RECORD: {
        action: 'MONITORING_RECORD',
        ledgerId: 'monitoringRecord'
    }
});
// The newest part of a long visit is where the decisions are; the server reads its
// own copy first and this is only the fallback.
const $80f289cb339918db$var$TRANSCRIPT_TAIL = 12000;
// Below this the model was not sure the transcript says it: shown, not ticked.
const $80f289cb339918db$var$TICK_MIN_CONFIDENCE = 0.6;
const $80f289cb339918db$var$text = (v)=>String(v ?? '').trim();
const $80f289cb339918db$var$names = (list, pick)=>(list || []).map(pick).map($80f289cb339918db$var$text).filter(Boolean);
function $80f289cb339918db$export$a60a48c0701dddbf(group, ctx = {}) {
    const patient = ctx.patient || {};
    return {
        group: group,
        appointmentId: ctx.appointmentId || '',
        patientId: patient.id || null,
        utterance: $80f289cb339918db$var$text(ctx.transcript).slice(-$80f289cb339918db$var$TRANSCRIPT_TAIL),
        // null = unknown — never 0, which the model reads as a newborn.
        age: patient.age ?? null,
        gender: patient.gender || '',
        knownAllergies: $80f289cb339918db$var$names(patient.clinicalAllergies, (a)=>a?.allergen),
        currentMedications: $80f289cb339918db$var$names((patient.clinicalMedications || []).filter((m)=>m?.status === 'active'), (m)=>m?.display),
        knownConditions: $80f289cb339918db$var$names(patient.clinicalConditions, (c)=>c?.display)
    };
}
// ── what the visit already holds ────────────────────────────────────────────
//
// Every «تکمیل» re-reads the WHOLE transcript, so a second run hears the CBC the
// first one already ordered and the respiratory rate already recorded, and offered
// them again, ticked: «تأیید» then wrote a second order and a second observation.
// A finding the visit already holds is now a row like the نسخه's «در نسخه» —
// shown, never ticked, never written, never counted as waiting. The service cannot
// leave it out itself: its request carries no orders and no vitals.
// Spellings that render alike: Persian/Arabic digits, Arabic yeh and kaf, ZWNJ and
// spacing, letter case — «CBC» and «cbc», «سونوگرافی‌شکم» and «سونوگرافی شکم».
const $80f289cb339918db$var$foldKey = (v)=>$80f289cb339918db$var$text(v).replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[يى]/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s‌‍]+/g, '').toLowerCase();
// «36.5» and «36.50» are one reading.
const $80f289cb339918db$var$valueKey = (v)=>{
    const key = $80f289cb339918db$var$foldKey(v).replace(/٫/g, '.');
    return key && Number.isFinite(Number(key)) ? String(Number(key)) : key;
};
// The code each vital sign is recorded under: the vitals form's (Visit.shared
// VITAL_FIELD_CODES) and OBSERVATION's below. A blood pressure is two rows.
const $80f289cb339918db$var$VITAL_CODES = {
    bp: [
        '8480-6',
        '8462-4'
    ],
    pulse: [
        '8867-4'
    ],
    spo2: [
        '59408-5'
    ],
    temp: [
        '8310-5'
    ],
    weight: [
        '29463-7'
    ],
    resp: [
        '9279-1'
    ],
    height: [
        '8302-2'
    ],
    glucose: [
        '2339-0'
    ]
};
function $80f289cb339918db$export$7ae37be9d0ec5cca(ctx = {}) {
    const ids = new Set([
        ctx.encounterId,
        ctx.appointmentId
    ].filter(Boolean).map(String));
    return {
        orders: (ctx.orders || []).filter((o)=>o && o.status !== 'cancelled'),
        observations: (ctx.patient?.clinicalObservations || []).filter((o)=>o?.appointmentId && ids.has(String(o.appointmentId)))
    };
}
function $80f289cb339918db$export$94302b4dd2f2e4e7(f, holdings, group = f?.group) {
    if (!f || !holdings) return false;
    const g = String(group || '').toLowerCase();
    if (g === 'orders') {
        const names = [
            f.text,
            f.catalogName
        ].map($80f289cb339918db$var$foldKey).filter(Boolean);
        return (holdings.orders || []).some((o)=>{
            if (f.catalogId && o.catalogId && String(f.catalogId) === String(o.catalogId)) return true;
            if (f.code && o.code) return $80f289cb339918db$var$foldKey(f.code) === $80f289cb339918db$var$foldKey(o.code);
            return names.includes($80f289cb339918db$var$foldKey(o.description));
        });
    }
    if (g === 'vitals') {
        const codes = $80f289cb339918db$var$VITAL_CODES[f.kind];
        const values = f.kind === 'bp' ? [
            f.value,
            f.value2
        ] : [
            f.value
        ];
        return !!codes && codes.every((code, i)=>(holdings.observations || []).some((o)=>o.code === code && $80f289cb339918db$var$valueKey(o.value) === $80f289cb339918db$var$valueKey(values[i])));
    }
    return false;
}
function $80f289cb339918db$export$860f2bf2c98c63a4(group, findings, holdings) {
    return (findings || []).map((finding, i)=>{
        const known = $80f289cb339918db$export$94302b4dd2f2e4e7(finding, holdings, group);
        return {
            key: `${group}-${i}`,
            group: group,
            finding: finding,
            known: known,
            checked: !known && Number(finding?.confidence) >= $80f289cb339918db$var$TICK_MIN_CONFIDENCE
        };
    });
}
function $80f289cb339918db$export$d41f702336c09e8f(rows, holdings) {
    let changed = false;
    const next = (rows || []).map((r)=>{
        const known = $80f289cb339918db$export$94302b4dd2f2e4e7($80f289cb339918db$export$e8abafe383e20726(r), holdings, r.group);
        if (known === !!r.known) return r;
        changed = true;
        return {
            ...r,
            known: known,
            checked: r.checked && !known
        };
    });
    return changed ? next : rows;
}
const $80f289cb339918db$export$2164ecbb0f5578b7 = (rows, key)=>(rows || []).map((r)=>r.key === key && !r.known ? {
            ...r,
            checked: !r.checked
        } : r);
const $80f289cb339918db$export$c4c19acf0e1cd628 = (rows, checked)=>(rows || []).map((r)=>r.checked === checked || checked && r.known ? r : {
            ...r,
            checked: checked
        });
function $80f289cb339918db$export$4c5f4dc82f210788(rows) {
    const out = {
        vitals: [],
        orders: [],
        record: []
    };
    (rows || []).filter((r)=>r.checked && !r.known).forEach((r)=>{
        const bucket = out[String(r.finding?.group || r.group).toLowerCase()];
        if (bucket) bucket.push($80f289cb339918db$export$e8abafe383e20726(r));
    });
    return out;
}
const $80f289cb339918db$export$77d99fb6a2c44f1b = Object.freeze([
    'lab',
    'imaging',
    'procedure'
]);
const $80f289cb339918db$var$CATALOG_CANDIDATES = 5;
const $80f289cb339918db$export$f0279dbb8aaf3182 = (f)=>String(f?.group || '').toLowerCase() === 'orders' && $80f289cb339918db$export$77d99fb6a2c44f1b.includes(f?.kind);
function $80f289cb339918db$export$1f55bc41f83183ff(f, entries) {
    const want = $80f289cb339918db$var$foldKey(f?.text);
    if (!want) return null;
    const hits = new Map();
    (entries || []).forEach((e)=>{
        if (!e || e.orderType && e.orderType !== f.kind) return;
        if ($80f289cb339918db$var$foldKey(e.name) === want || $80f289cb339918db$var$foldKey(e.nameEn) === want) hits.set(e.id ?? e.name, e);
    });
    return hits.size === 1 ? [
        ...hits.values()
    ][0] : null;
}
function $80f289cb339918db$export$c8e0648bbd3956bd(f, entries) {
    const candidates = (entries || []).filter((e)=>e && (!e.orderType || e.orderType === f?.kind)).slice(0, $80f289cb339918db$var$CATALOG_CANDIDATES);
    const match = $80f289cb339918db$export$1f55bc41f83183ff(f, entries);
    return match ? {
        state: 'linked',
        entry: match,
        auto: true,
        candidates: candidates
    } : {
        state: 'choose',
        entry: null,
        auto: false,
        candidates: candidates
    };
}
function $80f289cb339918db$export$e8abafe383e20726(row) {
    const f = row?.finding;
    const e = row?.catalog?.state === 'linked' ? row.catalog.entry : null;
    if (!f || !e) return f;
    return {
        ...f,
        catalogId: e.id || null,
        code: e.code || '',
        codeSystem: e.codeSystem || '',
        catalogName: e.name || ''
    };
}
const $80f289cb339918db$export$65c4d13db359029b = (row)=>!!row?.checked && !row.known && !!row.catalog && row.catalog.state !== 'linked' && row.catalog.state !== 'free';
function $80f289cb339918db$export$998c598c6be6e5b2(row, choice) {
    if (!row?.catalog) return row;
    if (choice === 'free') return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'free',
            entry: null,
            auto: false
        }
    };
    if (choice && typeof choice === 'object') return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'linked',
            entry: choice,
            auto: false
        }
    };
    return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'choose',
            entry: null,
            auto: false
        }
    };
}
// ── علائم حیاتی ─────────────────────────────────────────────────────────────
// The vitals form's own fields (Visit.shared `emptyVitals`).
const $80f289cb339918db$var$FORM_FIELD = {
    pulse: 'pulse',
    spo2: 'spo2',
    temp: 'temp',
    weight: 'weight'
};
function $80f289cb339918db$export$40b6415e2650a54e(findings) {
    const patch = {};
    (findings || []).forEach((f)=>{
        if (f.kind === 'bp') {
            patch.bpSys = $80f289cb339918db$var$text(f.value);
            patch.bpDia = $80f289cb339918db$var$text(f.value2);
        } else if ($80f289cb339918db$var$FORM_FIELD[f.kind]) patch[$80f289cb339918db$var$FORM_FIELD[f.kind]] = $80f289cb339918db$var$text(f.value);
    });
    return patch;
}
// Vital signs the form has no field for are recorded as observations of their own.
const $80f289cb339918db$var$OBSERVATION = {
    resp: {
        code: '9279-1',
        labelKey: 'visit.monitoringExtract.vital.resp'
    },
    height: {
        code: '8302-2',
        labelKey: 'visit.monitoringExtract.vital.height'
    },
    glucose: {
        code: '2339-0',
        labelKey: 'visit.monitoringExtract.vital.glucose'
    }
};
function $80f289cb339918db$export$9987edde8f07e80c(findings, t) {
    return (findings || []).filter((f)=>$80f289cb339918db$var$OBSERVATION[f.kind]).map((f)=>({
            code: $80f289cb339918db$var$OBSERVATION[f.kind].code,
            display: t($80f289cb339918db$var$OBSERVATION[f.kind].labelKey),
            value: $80f289cb339918db$var$text(f.value),
            unit: f.unit || ''
        }));
}
function $80f289cb339918db$export$2e0352eb98b59734(f) {
    const v = f.kind === 'bp' ? `${$80f289cb339918db$var$text(f.value)}/${$80f289cb339918db$var$text(f.value2)}` : $80f289cb339918db$var$text(f.value);
    return [
        v,
        f.unit
    ].filter(Boolean).join(' ');
}
// ── دستورات ─────────────────────────────────────────────────────────────────
// The encounter's order types (clinicalencounter ALLOWED_ORDER_TYPES). It has no
// «referral»: a referral is written as an order of type `other` that says so.
const $80f289cb339918db$var$ORDER_TYPE = {
    lab: 'lab',
    imaging: 'imaging',
    procedure: 'procedure',
    referral: 'other'
};
function $80f289cb339918db$export$33ef048cffb1af5d(f) {
    return {
        key: `monitoring:${f.kind}:${f.text}`,
        orderType: $80f289cb339918db$var$ORDER_TYPE[f.kind] || 'other',
        name: $80f289cb339918db$var$text(f.catalogName || f.text),
        reason: $80f289cb339918db$var$text(f.detail),
        urgency: [
            'routine',
            'urgent',
            'stat'
        ].includes(f.urgency) ? f.urgency : 'routine',
        catalogId: f.catalogId || null,
        code: $80f289cb339918db$var$text(f.code),
        // A LOINC badge is only honest when the code IS a LOINC (the picker's rule).
        loincCode: f.codeSystem === 'LOINC' ? $80f289cb339918db$var$text(f.code) : ''
    };
}
function $80f289cb339918db$export$3e993be304a3ed8f(findings, t) {
    return (findings || []).filter((f)=>f.kind === 'follow_up' && $80f289cb339918db$var$text(f.text)).map((f)=>t('visit.monitoringExtract.followUpLine', {
            text: $80f289cb339918db$var$text(f.text)
        }));
}
function $80f289cb339918db$export$6a1840833052c978(p, lines) {
    const have = String(p || '');
    const fresh = (lines || []).filter((l)=>l && !have.includes(l));
    if (!fresh.length) return have;
    return [
        have.trimEnd(),
        ...fresh
    ].filter(Boolean).join('\n');
}



const $a77297e82307ffaa$var$SIZES = {
    web: {
        body: '12.5px',
        meta: '10.5px',
        pad: '8px 10px',
        gap: 6,
        radius: 8,
        checkbox: undefined
    },
    mobile: {
        body: '0.875rem',
        meta: '0.75rem',
        pad: '0.625rem 0.75rem',
        gap: 8,
        radius: 10,
        checkbox: '1.125rem'
    }
};
const $a77297e82307ffaa$var$K = 'visit.monitoringExtract';
function $a77297e82307ffaa$var$Badge({ tone: tone = 'mute', children: children }) {
    const tones = {
        warn: [
            (0, $jTCZr.CT).warnSoft,
            (0, $jTCZr.CT).warnInk
        ],
        mute: [
            (0, $jTCZr.CT).surface2,
            (0, $jTCZr.CT).ink2
        ],
        accent: [
            (0, $jTCZr.CT).accentSoft,
            (0, $jTCZr.CT).accentInk
        ],
        danger: [
            (0, $jTCZr.CT).dangerSoft,
            (0, $jTCZr.CT).dangerInk
        ],
        good: [
            (0, $jTCZr.CT).goodSoft,
            (0, $jTCZr.CT).goodInk
        ]
    };
    const [bg, fg] = tones[tone] || tones.mute;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: '0.92em',
            fontWeight: 600,
            background: bg,
            color: fg,
            whiteSpace: 'nowrap'
        }
    }, children);
}
/** What a finding is, as the row's first line. */ function $a77297e82307ffaa$var$findingTitle(f, t) {
    if (f.group === 'vitals') return `${t(`${$a77297e82307ffaa$var$K}.vital.${f.kind}`)}: ${(0, $80f289cb339918db$export$2e0352eb98b59734)(f)}`;
    return f.text;
}
const $a77297e82307ffaa$var$linkStyle = (S)=>({
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: S.meta,
        fontWeight: 600,
        color: (0, $jTCZr.CT).accentInk
    });
const $a77297e82307ffaa$var$codeOf = (e)=>e?.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '';
/** Which catalogue entry a heard order will be saved as — and the choice when it is not settled. */ function $a77297e82307ffaa$var$CatalogChoice({ row: row, S: S, onCatalog: onCatalog, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const c = row.catalog;
    if (!c || row.known) return null;
    const id = `${testid}-catalog-${row.key}`;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).ink2,
        lineHeight: 1.7
    };
    const line = {
        ...note,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap'
    };
    if (c.state === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "pending",
        style: note
    }, t(`${$a77297e82307ffaa$var$K}.catalog.finding`));
    if (c.state === 'linked') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "linked",
        style: line
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).goodInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(`${$a77297e82307ffaa$var$K}.catalog.linked`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            color: (0, $jTCZr.CT).ink,
            fontWeight: 600
        }
    }, c.entry?.name), $a77297e82307ffaa$var$codeOf(c.entry) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "good"
    }, $a77297e82307ffaa$var$codeOf(c.entry))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, null),
        "data-testid": `${id}-change`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.change`)));
    if (c.state === 'free') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "free",
        style: line
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(`${$a77297e82307ffaa$var$K}.catalog.freeChosen`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, null),
        "data-testid": `${id}-pick`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.pick`)));
    const waiting = (0, $80f289cb339918db$export$65c4d13db359029b)(row);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "choose",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...note,
            color: waiting ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).ink2
        }
    }, c.candidates.length ? t(`${$a77297e82307ffaa$var$K}.catalog.choose`) : t(c.failed ? `${$a77297e82307ffaa$var$K}.catalog.searchFailed` : `${$a77297e82307ffaa$var$K}.catalog.notFound`)), c.candidates.map((e, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: e.id || e.name,
            type: "button",
            onClick: ()=>onCatalog?.(row.key, e),
            "data-testid": `${id}-option-${i}`,
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap',
                textAlign: 'start',
                padding: '4px 8px',
                borderRadius: 6,
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                background: (0, $jTCZr.CT).surface2,
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: S.meta,
                color: (0, $jTCZr.CT).ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontWeight: 600
            }
        }, e.name), e.nameEn && e.nameEn !== e.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.CT).ink2
            }
        }, e.nameEn), $a77297e82307ffaa$var$codeOf(e) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.CT).ink2
            }
        }, $a77297e82307ffaa$var$codeOf(e)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, 'free'),
        "data-testid": `${id}-free`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.free`))));
}
function $a77297e82307ffaa$var$FindingRow({ row: row, S: S, onToggle: onToggle, onCatalog: onCatalog, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const f = row.finding;
    const urgent = f.group === 'orders' && f.urgency && f.urgency !== 'routine';
    const known = !!row.known;
    // The catalogue choice sits under the row, outside its label: pressing a
    // candidate must never tick or untick the finding.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            padding: S.pad,
            borderRadius: S.radius,
            border: `1px solid ${row.checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            opacity: known ? 0.7 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        "data-testid": `${testid}-row-${row.key}`,
        "data-kind": f.kind,
        "data-known": known ? 'true' : 'false',
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'flex-start',
            cursor: known ? 'default' : 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        checked: row.checked && !known,
        disabled: known,
        onChange: ()=>onToggle(row.key),
        "data-testid": `${testid}-check-${row.key}`,
        style: {
            marginTop: 3,
            width: S.checkbox,
            height: S.checkbox,
            accentColor: (0, $jTCZr.CT).accent,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            fontSize: S.body,
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, $a77297e82307ffaa$var$findingTitle(f, t)), f.group !== 'vitals' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, null, t(`${$a77297e82307ffaa$var$K}.kind.${f.kind}`)), urgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "warn"
    }, t(`${$a77297e82307ffaa$var$K}.urgency.${f.urgency}`)), f.kind === 'follow_up' && f.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "accent"
    }, t(`${$a77297e82307ffaa$var$K}.inDays`, {
        n: f.value
    })), known && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "good"
    }, t(`${$a77297e82307ffaa$var$K}.onVisit`))), f.detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, f.detail), f.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, t(`${$a77297e82307ffaa$var$K}.heard`, {
        text: f.evidence
    })))), row.catalog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingInlineStart: 22
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$CatalogChoice, {
        row: row,
        S: S,
        onCatalog: onCatalog,
        testid: testid
    })));
}
function $a77297e82307ffaa$var$Body({ group: group, review: review, S: S, onToggle: onToggle, onCatalog: onCatalog, onRetry: onRetry, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const { phase: phase, rows: rows, status: status, error: error } = review;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).ink2,
        lineHeight: 1.7
    };
    if (phase === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-loading`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: `1.5px solid ${(0, $jTCZr.CT).border}`,
            borderTopColor: (0, $jTCZr.CT).accent,
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            flexShrink: 0
        }
    }), t(`${$a77297e82307ffaa$var$K}.loading`));
    if (phase === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(error === 'credit' ? `${$a77297e82307ffaa$var$K}.error.credit` : `${$a77297e82307ffaa$var$K}.error.failed`), error !== 'credit' && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onRetry,
        "data-testid": `${testid}-retry`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('common.actions.retry')));
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": status,
        style: note
    }, t(status === 'no_transcript' ? `${$a77297e82307ffaa$var$K}.empty.noTranscript` : `${$a77297e82307ffaa$var$K}.empty.${group}`));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-list`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: S.gap
        }
    }, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$FindingRow, {
            key: row.key,
            row: row,
            S: S,
            onToggle: onToggle,
            onCatalog: onCatalog,
            testid: testid
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: note
    }, t(`${$a77297e82307ffaa$var$K}.hint.${group}`)), error === 'apply' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-apply-error`,
        style: {
            ...note,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(`${$a77297e82307ffaa$var$K}.error.apply`)));
}
function $a77297e82307ffaa$export$2e2bcd8739ae039({ group: group, review: review, variant: variant = 'web', onToggle: onToggle, onSetAll: onSetAll, onApply: onApply, onClose: onClose, onRetry: onRetry, onCatalog: onCatalog, style: style, testid: testid = `visit-complete-${String(group).toLowerCase()}` }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (!review?.open) return null;
    const S = $a77297e82307ffaa$var$SIZES[variant] || $a77297e82307ffaa$var$SIZES.web;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const picked = review.rows.filter((r)=>r.checked && !r.known).length;
    // Ticked orders still waiting for their catalogue entry: «تأیید» waits with them.
    const waiting = review.rows.filter((0, $80f289cb339918db$export$65c4d13db359029b)).length;
    const link = $a77297e82307ffaa$var$linkStyle(S);
    const footer = review.phase === 'ready' && review.rows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$8f3e57e0bb4fa42c), {
        variant: variant,
        testid: testid,
        onAccept: onApply,
        acceptDisabled: !picked || waiting > 0,
        busy: review.applying,
        acceptLabel: t('visit.complete.acceptN', {
            n: fmt(picked)
        }),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": `${testid}-count`
    }, t('visit.rxAssist.selectedOf', {
        n: fmt(picked),
        total: fmt(review.rows.length)
    })), waiting > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).warnInk
        },
        "data-testid": `${testid}-waiting`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.waiting`, {
        n: fmt(waiting)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(true),
        "data-testid": `${testid}-all`
    }, t('visit.rxAssist.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(false),
        "data-testid": `${testid}-none`
    }, t('visit.rxAssist.selectNone'))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$c77d4a7df286b4a9), {
        variant: variant,
        testid: testid,
        "data-group": group,
        "data-status": review.status || review.phase,
        title: t(`${$a77297e82307ffaa$var$K}.group.${group}`),
        onClose: onClose,
        footer: footer,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Body, {
        group: group,
        review: review,
        S: S,
        onToggle: onToggle,
        onCatalog: onCatalog,
        onRetry: onRetry,
        testid: testid
    }));
}



// State of «تکمیل از پایش بالینی» for علائم حیاتی, دستورات and اطلاعات پرونده
// (PM-0029, PM-0038): each group is read, reviewed and confirmed ON ITS OWN, in the
// section it fills — so each has its own review, and one group's answer never
// replaces another's list.
//
// `getContext()` is read at call time, so a run always sends the record as it is
// NOW. The screen owns everything that writes: this hook hands it the ticked
// findings and nothing else.

var $acw62 = parcelRequire("acw62");



const $b71ef3742639a482$var$IDLE = Object.freeze({
    open: false,
    phase: 'idle',
    rows: [],
    status: null,
    error: null,
    applying: false
});
const $b71ef3742639a482$var$ALL_IDLE = Object.freeze(Object.fromEntries((0, $80f289cb339918db$export$16054fa089fae9a7).map((g)=>[
        g,
        $b71ef3742639a482$var$IDLE
    ])));
// Each review's rows against what the visit holds now; the same object when no row changed.
function $b71ef3742639a482$var$withHoldings(reviews, holdings) {
    let changed = false;
    const next = {};
    (0, $80f289cb339918db$export$16054fa089fae9a7).forEach((g)=>{
        const r = reviews[g];
        const rows = (0, $80f289cb339918db$export$d41f702336c09e8f)(r.rows, holdings);
        next[g] = rows === r.rows ? r : {
            ...r,
            rows: rows
        };
        if (next[g] !== r) changed = true;
    });
    return changed ? next : reviews;
}
function $b71ef3742639a482$export$ae55c3af901dcf33({ getContext: getContext, chargeVisit: chargeVisit, chargeLabel: chargeLabel, onCreditError: onCreditError, onApply: onApply, searchCatalog: searchCatalog }) {
    const [reviews, setReviews] = (0, $acw62.useState)($b71ef3742639a482$var$ALL_IDLE);
    // A slow answer to a run the doctor already replaced or closed must not reopen it.
    const runRef = (0, $acw62.useRef)({});
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        getContext: getContext,
        chargeVisit: chargeVisit,
        chargeLabel: chargeLabel,
        onCreditError: onCreditError,
        onApply: onApply,
        searchCatalog: searchCatalog
    };
    const reviewsRef = (0, $acw62.useRef)(reviews);
    reviewsRef.current = reviews;
    // What the visit holds as it is NOW, read at call time like the rest of the context.
    const holdingsNow = ()=>(0, $80f289cb339918db$export$7ae37be9d0ec5cca)(deps.current.getContext?.() || {});
    const patch = (0, $acw62.useCallback)((group, next)=>setReviews((all)=>({
                ...all,
                [group]: typeof next === 'function' ? next(all[group]) : next
            })), []);
    const patchRow = (0, $acw62.useCallback)((group, key, change)=>patch(group, (r)=>({
                ...r,
                rows: r.rows.map((x)=>x.key === key ? change(x) : x)
            })), [
        patch
    ]);
    // Each heard order the catalogue should name is looked up with the picker's own
    // search, one row at a time, and never holds the reading's answer back. A reply
    // to a run the doctor already replaced or closed is dropped, like the run's own.
    const lookUpCatalog = (group, id, rows, ctx)=>{
        const search = deps.current.searchCatalog;
        if (!search) return rows;
        const marked = rows.map((r)=>(0, $80f289cb339918db$export$f0279dbb8aaf3182)(r.finding) ? {
                ...r,
                catalog: {
                    state: 'pending',
                    entry: null,
                    auto: false,
                    candidates: []
                }
            } : r);
        marked.filter((r)=>r.catalog).forEach((row)=>{
            Promise.resolve().then(()=>search({
                    query: row.finding.text,
                    orderType: row.finding.kind,
                    appointmentId: ctx.appointmentId || ctx.encounterId || null
                })).then((page)=>(0, $80f289cb339918db$export$c8e0648bbd3956bd)(row.finding, page?.entries))// A search that failed leaves the choice to the doctor, never a guess.
            .catch(()=>({
                    state: 'choose',
                    entry: null,
                    auto: false,
                    candidates: [],
                    failed: true
                })).then((catalog)=>{
                if (runRef.current[group] !== id) return;
                patchRow(group, row.key, (x)=>({
                        ...x,
                        catalog: catalog
                    }));
            });
        });
        return marked;
    };
    /** `groups`: one group, or several — each is its own service, charge and review. */ const run = (0, $acw62.useCallback)(async (groups = (0, $80f289cb339918db$export$16054fa089fae9a7))=>{
        const wanted = (Array.isArray(groups) ? groups : [
            groups
        ]).filter((g)=>(0, $80f289cb339918db$export$16054fa089fae9a7).includes(g));
        if (!wanted.length) return {};
        const ctx = deps.current.getContext?.() || {};
        const ids = {};
        wanted.forEach((group)=>{
            ids[group] = (runRef.current[group] || 0) + 1;
            runRef.current[group] = ids[group];
            patch(group, {
                ...$b71ef3742639a482$var$IDLE,
                open: true,
                phase: 'loading'
            });
        });
        // → { [group]: 'found' | 'none' | 'known' | 'error' } — what the caller may act on.
        const outcome = {};
        await Promise.all(wanted.map(async (group)=>{
            try {
                // Long budget, like the نسخه's reading (PM-0069).
                const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $80f289cb339918db$export$1047922e50d45b96), {
                    input: (0, $80f289cb339918db$export$a60a48c0701dddbf)(group, ctx)
                }, {
                    timeoutMs: (0, $adebb901af88e18b$export$5c63bf3ded5aa229)
                });
                if (runRef.current[group] !== ids[group]) return;
                const result = data?.extractMonitoring || {};
                const rows = lookUpCatalog(group, ids[group], (0, $80f289cb339918db$export$860f2bf2c98c63a4)(group, result.findings, holdingsNow()), ctx);
                // Found only what the visit already holds: nothing to confirm. 'known' when
                // that was still charged (the service cannot tell — it is sent no orders or
                // vitals), so the visit-wide run does not say «nothing found, no charge».
                if (rows.some((r)=>!r.known)) outcome[group] = 'found';
                else outcome[group] = rows.length && result.charged ? 'known' : 'none';
                // The server's `charged` is the signal, never the click: an empty run is free.
                if (result.charged) {
                    const { action: action, ledgerId: ledgerId } = (0, $80f289cb339918db$export$a7f2f1cb3a3e0344)[group];
                    deps.current.chargeVisit?.((0, $121df138798ec781$export$c932aceb7c67d0f4)(action), ledgerId, deps.current.chargeLabel?.(group));
                }
                patch(group, {
                    ...$b71ef3742639a482$var$IDLE,
                    open: true,
                    phase: 'ready',
                    status: result.status || 'none_found',
                    rows: rows
                });
            } catch (e) {
                if (runRef.current[group] !== ids[group]) return;
                const credit = e?.extensions?.code === 'INSUFFICIENT_CREDITS';
                if (credit) deps.current.onCreditError?.(e.message);
                outcome[group] = 'error';
                patch(group, {
                    ...$b71ef3742639a482$var$IDLE,
                    open: true,
                    phase: 'error',
                    status: 'error',
                    error: credit ? 'credit' : 'failed'
                });
            }
        }));
        return outcome;
    }, [
        patch
    ]);
    const close = (0, $acw62.useCallback)((group)=>{
        runRef.current[group] = (runRef.current[group] || 0) + 1;
        patch(group, $b71ef3742639a482$var$IDLE);
    }, [
        patch
    ]);
    const toggle = (0, $acw62.useCallback)((group, key)=>{
        const holdings = holdingsNow();
        patch(group, (r)=>({
                ...r,
                rows: (0, $80f289cb339918db$export$2164ecbb0f5578b7)((0, $80f289cb339918db$export$d41f702336c09e8f)(r.rows, holdings), key)
            }));
    }, [
        patch
    ]);
    const setAll = (0, $acw62.useCallback)((group, checked)=>{
        const holdings = holdingsNow();
        patch(group, (r)=>({
                ...r,
                rows: (0, $80f289cb339918db$export$c4c19acf0e1cd628)((0, $80f289cb339918db$export$d41f702336c09e8f)(r.rows, holdings), checked)
            }));
    }, [
        patch
    ]);
    /** A catalogue entry for an order row, 'free' to save it without one, or null to choose again. */ const chooseCatalog = (0, $acw62.useCallback)((group, key, choice)=>{
        patchRow(group, key, (x)=>(0, $80f289cb339918db$export$998c598c6be6e5b2)(x, choice));
    }, [
        patchRow
    ]);
    const apply = (0, $acw62.useCallback)(async (group)=>{
        // Checked against the visit as it is at «تأیید»: an order placed by hand while
        // the review was open is not created a second time.
        const rows = (0, $80f289cb339918db$export$d41f702336c09e8f)(reviewsRef.current[group]?.rows, holdingsNow());
        // A ticked order with no catalogue entry yet is not saved as free text by default.
        if ((rows || []).some((0, $80f289cb339918db$export$65c4d13db359029b))) return;
        const picked = (0, $80f289cb339918db$export$4c5f4dc82f210788)(rows);
        if (!picked.vitals.length && !picked.orders.length && !picked.record.length) return;
        patch(group, (r)=>({
                ...r,
                applying: true,
                error: null
            }));
        try {
            await deps.current.onApply?.(picked);
            close(group);
        } catch (e) {
            console.warn('[monitoringExtraction] apply failed:', e);
            patch(group, (r)=>({
                    ...r,
                    applying: false,
                    error: 'apply'
                }));
        }
    }, [
        close,
        patch
    ]);
    // Shown against the visit as it is now (the screen re-renders on every transcript
    // chunk, so the holdings are only read while some review has rows).
    const shown = (0, $80f289cb339918db$export$16054fa089fae9a7).some((g)=>reviews[g].rows.length) ? $b71ef3742639a482$var$withHoldings(reviews, holdingsNow()) : reviews;
    return {
        reviews: shown,
        run: run,
        close: close,
        toggle: toggle,
        setAll: setAll,
        apply: apply,
        chooseCatalog: chooseCatalog
    };
}


// The flow of «تکمیل از پایش بالینی» (PM-0038), for both Visit surfaces.
//
// The screen already owns three pieces of state that hold proposals — the note's
// merge preview, the نسخه's review and the per-group findings. This hook does not
// duplicate any of it: it is told how many proposals WAIT in each section
// (`pending`) and how to read each one (`runners`), and from that it gives
//
//   runAll()   the top bar's «تکمیل»: read every section that has nothing waiting;
//   steps      the sections that received proposals this round, reviewed or not;
//   nextFrom   where the doctor goes after the section they are in.
//
// A round starts with the first proposal and ends when none is left — confirmed
// or rejected, one by one. Then `onDone` fires and the guide goes away.

var $acw62 = parcelRequire("acw62");
// «تکمیل از پایش بالینی» as ONE flow (PM-0038). The visit's transcript fills five
// places — the note, the نسخه, the دستورات, the علائم حیاتی and the record — and each
// has its own «تکمیل» button and its own proposal. This module is what makes them
// one thing: which sections the top bar's «تکمیل» reads, what that may cost, and the
// order the doctor is walked through whatever came back.
//
// Pure (no React): both Visit surfaces and the tests read one copy.
/** Every section a reading can propose for — the order the guide walks them in. */ const $7bb6bd2305b75ff2$export$a44880a6e20af2f8 = Object.freeze([
    'soap',
    'rx',
    'orders',
    'vitals',
    'record'
]);
const $7bb6bd2305b75ff2$export$3e60d0866daba7e3 = Object.freeze([
    'soap',
    'rx',
    'orders',
    'vitals'
]);
const $7bb6bd2305b75ff2$export$cfc0f0f1064d8989 = Object.freeze({
    soap: 'SOAP_REFINE',
    rx: 'RX_MONITORING',
    orders: 'MONITORING_ORDERS',
    vitals: 'MONITORING_VITALS',
    record: 'MONITORING_RECORD'
});
const $7bb6bd2305b75ff2$export$e1f06a5f97075575 = Object.freeze({
    orders: 'ORDERS',
    vitals: 'VITALS',
    record: 'RECORD'
});
const $7bb6bd2305b75ff2$export$3a4845752d2bf748 = Object.freeze([
    's',
    'o',
    'a',
    'p'
]);
const $7bb6bd2305b75ff2$var$count = (pending, id)=>Number(pending?.[id]) || 0;
// How many proposals can wait in a section before nothing in it is left to read:
// one per part of the note, one card everywhere else.
const $7bb6bd2305b75ff2$var$capacity = (id)=>id === 'soap' ? $7bb6bd2305b75ff2$export$3a4845752d2bf748.length : 1;
function $7bb6bd2305b75ff2$export$402cbbcda510e1bd(pending, sections = $7bb6bd2305b75ff2$export$3e60d0866daba7e3) {
    return sections.filter((id)=>$7bb6bd2305b75ff2$var$count(pending, id) < $7bb6bd2305b75ff2$var$capacity(id));
}
// A note proposal is `stale` when the doctor changed its part before confirming
// it in a way the merge cannot carry (useSoapRefine). It can no longer be
// confirmed — only read again — so it is not a proposal waiting.
const $7bb6bd2305b75ff2$var$waitingNote = (entry)=>!!entry && !entry.stale;
function $7bb6bd2305b75ff2$export$698b53ef55a14015(soapPreview) {
    return $7bb6bd2305b75ff2$export$3a4845752d2bf748.filter((k)=>!$7bb6bd2305b75ff2$var$waitingNote(soapPreview?.[k]));
}
function $7bb6bd2305b75ff2$export$d028ecf95ff92290(costOf, sections = $7bb6bd2305b75ff2$export$3e60d0866daba7e3) {
    return sections.reduce((sum, id)=>sum + (Number(costOf($7bb6bd2305b75ff2$export$cfc0f0f1064d8989[id])) || 0), 0);
}
function $7bb6bd2305b75ff2$export$e6e7d400543bb13d(seen, pending, labelOf = (id)=>id) {
    return $7bb6bd2305b75ff2$export$a44880a6e20af2f8.filter((id)=>(seen || []).includes(id)).map((id)=>({
            id: id,
            label: labelOf(id),
            count: $7bb6bd2305b75ff2$var$count(pending, id),
            done: $7bb6bd2305b75ff2$var$count(pending, id) === 0
        }));
}
function $7bb6bd2305b75ff2$export$1740d07632cd7131(steps, current) {
    const waiting = (steps || []).filter((s)=>!s.done && s.id !== current);
    if (!waiting.length) return null;
    const at = $7bb6bd2305b75ff2$export$a44880a6e20af2f8.indexOf(current);
    return waiting.find((s)=>$7bb6bd2305b75ff2$export$a44880a6e20af2f8.indexOf(s.id) > at) || waiting[0];
}
// A row the visit already holds — an order already placed, a vital sign already
// recorded, a drug already on the نسخه — is shown as such but waits for nothing:
// counted, a second «تکمیل» that only re-heard them held the guide open on rows
// nobody can confirm.
const $7bb6bd2305b75ff2$var$readyRows = (review)=>review?.open && review.phase === 'ready' ? review.rows.filter((r)=>!r?.known).length : 0;
function $7bb6bd2305b75ff2$export$e7fce37d4c24e7e3({ soapPreview: soapPreview, rxReview: rxReview, reviews: reviews }) {
    return {
        soap: soapPreview ? Object.values(soapPreview).filter($7bb6bd2305b75ff2$var$waitingNote).length : 0,
        rx: $7bb6bd2305b75ff2$var$readyRows(rxReview),
        orders: $7bb6bd2305b75ff2$var$readyRows(reviews?.ORDERS),
        vitals: $7bb6bd2305b75ff2$var$readyRows(reviews?.VITALS),
        record: $7bb6bd2305b75ff2$var$readyRows(reviews?.RECORD)
    };
}


function $d3f3ee41c97afb39$export$9ef1799c38d9eb96({ pending: pending, runners: runners, labelOf: labelOf, onNothing: onNothing, onKnown: onKnown, onAllWaiting: onAllWaiting, onFailed: onFailed, onDone: onDone }) {
    const [seen, setSeen] = (0, $acw62.useState)([]);
    const [round, setRound] = (0, $acw62.useState)(null); // null | 'running' | { failed: [section], known: [section] }
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        pending: pending,
        runners: runners,
        labelOf: labelOf,
        onNothing: onNothing,
        onKnown: onKnown,
        onAllWaiting: onAllWaiting,
        onFailed: onFailed,
        onDone: onDone
    };
    const seenRef = (0, $acw62.useRef)(seen);
    seenRef.current = seen;
    const counts = (0, $7bb6bd2305b75ff2$export$a44880a6e20af2f8).map((id)=>Number(pending?.[id]) || 0);
    const countsKey = counts.join(',');
    const waitingKey = (0, $7bb6bd2305b75ff2$export$a44880a6e20af2f8).filter((_, i)=>counts[i] > 0).join(',');
    // A section that just received proposals joins the round; a round whose
    // proposals are all gone is over.
    (0, $acw62.useEffect)(()=>{
        const waiting = waitingKey ? waitingKey.split(',') : [];
        const prev = seenRef.current;
        if (waiting.length) {
            const fresh = waiting.filter((id)=>!prev.includes(id));
            if (fresh.length) setSeen([
                ...prev,
                ...fresh
            ]);
        } else if (prev.length) {
            setSeen([]);
            deps.current.onDone?.(prev);
        }
    }, [
        waitingKey
    ]);
    // The visit-wide run is back. A button that answers with silence reads as
    // broken, so the two quiet outcomes are said: nothing found, or not read.
    (0, $acw62.useEffect)(()=>{
        if (!round || round === 'running') return;
        setRound(null);
        if (round.failed.length) deps.current.onFailed?.(round.failed);
        else if (!waitingKey && round.known?.length) deps.current.onKnown?.(round.known);
        else if (!waitingKey) deps.current.onNothing?.();
    }, [
        round,
        waitingKey
    ]);
    const runAll = (0, $acw62.useCallback)(async ()=>{
        const open = (0, $7bb6bd2305b75ff2$export$402cbbcda510e1bd)(deps.current.pending);
        // Silence here read as «تکمیل no longer works» in a long visit (PM-0069):
        // a section with a proposal on screen is never read again, so say why.
        if (!open.length) {
            deps.current.onAllWaiting?.();
            return;
        }
        const todo = open.filter((id)=>deps.current.runners?.[id]);
        if (!todo.length) return;
        setRound('running');
        const settled = await Promise.allSettled(todo.map((id)=>deps.current.runners[id]()));
        setRound({
            failed: todo.filter((_, i)=>settled[i].status === 'rejected' || settled[i].value === 'error'),
            known: todo.filter((_, i)=>settled[i].value === 'known')
        });
    }, []);
    const steps = (0, $acw62.useMemo)(()=>(0, $7bb6bd2305b75ff2$export$e6e7d400543bb13d)(seen, Object.fromEntries((0, $7bb6bd2305b75ff2$export$a44880a6e20af2f8).map((id, i)=>[
                id,
                Number(countsKey.split(',')[i])
            ])), (id)=>deps.current.labelOf?.(id) ?? id), [
        seen,
        countsKey
    ]);
    const nextFrom = (0, $acw62.useCallback)((current)=>(0, $7bb6bd2305b75ff2$export$1740d07632cd7131)(steps, current), [
        steps
    ]);
    const total = steps.reduce((n, s)=>n + s.count, 0);
    return {
        runAll: runAll,
        busy: round === 'running',
        steps: steps,
        nextFrom: nextFrom,
        total: total
    };
}
const $d3f3ee41c97afb39$var$GROUP_OF = {
    orders: 'ORDERS',
    vitals: 'VITALS',
    record: 'RECORD'
};
function $d3f3ee41c97afb39$export$3bfa7c0c0c355160({ t: t, formatNumber: formatNumber, toast: toast, soapRefine: soapRefine, rxAssist: rxAssist, monitoringExtract: monitoringExtract, costOf: costOf, disabled: disabled = false, recState: recState = 'idle', autoRunOnStop: autoRunOnStop = false }) {
    const api = (0, $acw62.useRef)({});
    api.current = {
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        t: t,
        toast: toast
    };
    const pending = (0, $7bb6bd2305b75ff2$export$e7fce37d4c24e7e3)({
        soapPreview: soapRefine.preview,
        rxReview: rxAssist.review,
        reviews: monitoringExtract.reviews
    });
    // One section, from its own button: the answer stays in the section whatever it is.
    const runSection = (0, $acw62.useCallback)((id)=>{
        const a = api.current;
        if (id === 'soap') return a.soapRefine.refine();
        if (id === 'rx') return a.rxAssist.run('MONITORING');
        return a.monitoringExtract.run([
            $d3f3ee41c97afb39$var$GROUP_OF[id]
        ]);
    }, []);
    // The visit-wide run: a reading that found nothing leaves no empty card behind
    // in a tab the doctor is not looking at — the guide lists what DID come back.
    // The note is read for the parts with no proposal waiting; the new proposals
    // join the ones already on screen.
    const runners = (0, $acw62.useMemo)(()=>({
            soap: async ()=>{
                const open = (0, $7bb6bd2305b75ff2$export$698b53ef55a14015)(api.current.soapRefine.preview);
                const sections = open.length === (0, $7bb6bd2305b75ff2$export$3a4845752d2bf748).length ? undefined : open;
                // refine answers 'found' | 'none' | 'error'. It used to answer true for any
                // reply, so a merge the SERVER said it could not do came out here as
                // «nothing new was found» — the one thing that was certainly not known.
                return api.current.soapRefine.refine(sections);
            },
            rx: async ()=>{
                const outcome = await api.current.rxAssist.run('MONITORING');
                if (outcome === 'none' || outcome === 'known') api.current.rxAssist.close();
                return outcome;
            },
            ...Object.fromEntries([
                'orders',
                'vitals'
            ].map((id)=>[
                    id,
                    async ()=>{
                        const group = $d3f3ee41c97afb39$var$GROUP_OF[id];
                        const outcome = (await api.current.monitoringExtract.run([
                            group
                        ]))[group];
                        if (outcome === 'none' || outcome === 'known') api.current.monitoringExtract.close(group);
                        return outcome;
                    }
                ]))
        }), []);
    const flow = $d3f3ee41c97afb39$export$9ef1799c38d9eb96({
        pending: pending,
        runners: runners,
        labelOf: (id)=>api.current.t(`visit.complete.section.${id}`),
        onNothing: ()=>api.current.toast?.info?.(api.current.t('visit.complete.nothing')),
        onKnown: ()=>api.current.toast?.info?.(api.current.t('visit.complete.known')),
        onAllWaiting: ()=>api.current.toast?.info?.(api.current.t('visit.complete.allWaiting')),
        onFailed: ()=>api.current.toast?.error?.(api.current.t('visit.complete.failed')),
        // One section confirmed says so itself; a round across sections is worth closing.
        onDone: (sections)=>{
            if (sections.length > 1) api.current.toast?.success?.(api.current.t('visit.complete.done'));
        }
    });
    // «تکمیل خودکار پس از پایش بالینی» (K1, 2026-10-06): the visit-wide run, by
    // itself, once the doctor stops the recording. Armed only by their own press of
    // the stop control (`armAutoRun`) — a stop that is part of ending or cancelling
    // the visit calls stopRec directly and reads nothing. Fired on the stopping →
    // idle step, which is the final transcript arriving: the AI service stores it
    // before it sends is_final, so every section is read against the whole
    // conversation. Anything else the recording does first — an error, a system
    // pause — disarms it, and so does a visit that can no longer take proposals.
    const armed = (0, $acw62.useRef)(false);
    const autoOn = (0, $acw62.useRef)(false);
    autoOn.current = !!autoRunOnStop && !disabled;
    const lastRecState = (0, $acw62.useRef)(recState);
    const runAll = flow.runAll;
    (0, $acw62.useEffect)(()=>{
        const was = lastRecState.current;
        lastRecState.current = recState;
        if (recState === 'stopping' || !armed.current) return;
        armed.current = false;
        if (was === 'stopping' && recState === 'idle' && autoOn.current) runAll();
    }, [
        recState,
        runAll
    ]);
    const armAutoRun = (0, $acw62.useCallback)(()=>{
        armed.current = autoOn.current;
    }, []);
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const busyOf = (id)=>{
        if (id === 'soap') return !!soapRefine.loading;
        if (id === 'rx') return rxAssist.review.phase === 'loading' && rxAssist.review.source === 'MONITORING';
        return monitoringExtract.reviews[$d3f3ee41c97afb39$var$GROUP_OF[id]]?.phase === 'loading';
    };
    /** The props of the section's CompleteButton. */ const button = (id)=>({
            onClick: ()=>runSection(id),
            busy: busyOf(id),
            disabled: disabled,
            count: pending[id],
            title: t('visit.complete.hintPrice', {
                section: t(`visit.complete.section.${id}`),
                coins: fmt(costOf((0, $7bb6bd2305b75ff2$export$cfc0f0f1064d8989)[id]))
            })
        });
    /** The props of the top bar's visit-wide CompleteButton. */ const allButton = {
        onClick: flow.runAll,
        busy: flow.busy,
        disabled: disabled,
        count: flow.total,
        title: t('visit.complete.allHint', {
            coins: fmt((0, $7bb6bd2305b75ff2$export$d028ecf95ff92290)(costOf))
        })
    };
    return {
        pending: pending,
        flow: flow,
        button: button,
        allButton: allButton,
        runSection: runSection,
        armAutoRun: armAutoRun
    };
}



// «ثبت موارد انتخاب‌شده» of «استخراج از پایش بالینی» (PM-0029) — the writes, shared
// by the desktop and the phone Visit. Each finding goes through the path a
// hand-entered value takes:
//
//   علائم حیاتی   the form's own fields come back as a PATCH — the screen puts them in
//                the vitals form and the doctor presses «ثبت», so its range check,
//                its alerts and its replace-on-edit all still run. A vital sign the
//                form has no field for (تنفس, قد, قند خون) is recorded as an observation.
//   دستورات       createOrder, as an AI-suggested order is added — with the
//                catalogue entry it was matched to, so it carries its code.
//   حساسیت        addAllergy.
//   داروی جاری    addMedication with NO appointment — a record medication, not a line
//                of this visit's نسخه.
//   بیماری زمینه‌ای addCondition, active.
//   پیگیری        comes back as lines for the note's «P».
//
// One failed write does not undo the others: the result says how many of each
// landed and how many did not, and the screen says so.



const $f5fd2a1ce8ccb8d9$export$b4ec7241301303fb = `mutation AddAllergy($patientId:ID!,$input:CreateAllergyInput!){addAllergy(patientId:$patientId,input:$input){id allergen reaction severity status}}`;
async function $f5fd2a1ce8ccb8d9$export$920e2c679038b5a0({ picked: picked, patientId: patientId, appointmentId: appointmentId, t: t }) {
    const today = new Date().toISOString().split('T')[0];
    const jobs = [];
    const orders = [];
    const add = (run)=>jobs.push(run());
    (0, $80f289cb339918db$export$9987edde8f07e80c)(picked.vitals, t).forEach((e)=>add(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5d20d1065b54c736), {
                patientId: patientId,
                input: {
                    code: e.code,
                    display: e.display,
                    value: e.value,
                    unit: e.unit,
                    status: 'NORMAL',
                    effectiveDate: today,
                    appointmentId: appointmentId || undefined
                }
            })));
    picked.orders.map((0, $80f289cb339918db$export$33ef048cffb1af5d)).forEach((item)=>add(async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$81ebae6b21d102e1), {
                appointmentId: appointmentId,
                patientId: patientId,
                orderType: item.orderType,
                description: item.name,
                urgency: item.urgency,
                notes: item.reason || '',
                // The catalogue entry the doctor confirmed (or that matched exactly): the
                // order is then the same row a hand-picked one is, code and all.
                ...item.catalogId ? {
                    catalogId: item.catalogId
                } : {},
                ...item.code ? {
                    code: item.code
                } : {}
            });
            if (!data?.createOrder) throw new Error('createOrder returned nothing');
            orders.push({
                item: item,
                created: data.createOrder
            });
        }));
    picked.record.forEach((f)=>{
        if (f.kind === 'allergy') add(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($f5fd2a1ce8ccb8d9$export$b4ec7241301303fb, {
                patientId: patientId,
                input: {
                    allergen: f.text,
                    reaction: f.detail || '',
                    status: 'active'
                }
            }));
        else if (f.kind === 'current_medication') add(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$59a0707dfedfe8a6), {
                patientId: patientId,
                input: {
                    display: f.text,
                    status: 'active',
                    authoredOn: today,
                    dosageInstruction: f.detail ? {
                        text: f.detail
                    } : undefined,
                    meta: {
                        source: 'monitoring',
                        patientReported: true
                    }
                }
            }));
        else if (f.kind === 'condition') add(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$52e699bb9024b09d), {
                patientId: patientId,
                input: {
                    display: f.text,
                    clinicalStatus: 'active',
                    meta: {
                        source: 'monitoring',
                        note: f.detail || undefined
                    }
                }
            }));
    });
    const settled = await Promise.allSettled(jobs);
    const failed = settled.filter((s)=>s.status === 'rejected');
    failed.forEach((s)=>console.warn('[monitoringApply] write failed:', s.reason));
    // A spent balance or a refused write must reach the doctor, not vanish in a count.
    const credit = failed.find((s)=>s.reason?.extensions?.code === 'INSUFFICIENT_CREDITS');
    const vitalsPatch = (0, $80f289cb339918db$export$40b6415e2650a54e)(picked.vitals);
    const followUps = (0, $80f289cb339918db$export$3e993be304a3ed8f)(picked.record, t);
    return {
        vitalsPatch: vitalsPatch,
        orders: orders,
        followUps: followUps,
        saved: settled.length - failed.length,
        failed: failed.length,
        creditError: credit ? credit.reason.message : null
    };
}


// ── Which interaction findings the doctor has already been shown ─────────────
// The end-of-visit sweep is the one interaction check nobody asked for, and it
// holds a visit open only for a high-severity finding the doctor has NOT seen.
//
// "Seen" used to mean "some earlier result had some high finding". Adding a drug
// does not clear the result on the نسخه tab (only removing one does), so a check
// that flagged A + B, followed by adding C, let a NEW high A + C close the visit
// unstopped: the old A + B answered "already seen" for it. A finding is now known
// by the drugs it names, and an earlier result counts only when it was computed
// for THIS نسخه — its `signature` (rxCheckSignature) equals the current one.
//
// Used by both useEndVisit (desktop) and Visit.mobile.jsx's handleEnd, so the two
// cannot disagree about when a visit may close.
// How the service writes a pair: "<drug> + <drug>" is what it asks its model for,
// the rest is what models write anyway (aiassitant medication_names._PAIR_SPLIT).
// Not "/" or "-": both occur inside drug names.
const $ea35d970f69d5497$var$PAIR_SPLIT = /\s*\+\s*|\s*[,،;&]\s*|\s+(?:and|with|vs\.?|و|مع)\s+/i;
// Case, spacing, ZWNJ and the Arabic forms of ی / ک do not make a different drug.
const $ea35d970f69d5497$var$drugKey = (name)=>String(name || '').replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s\u200C]+/g, '').toLowerCase();
const $ea35d970f69d5497$export$d203c3f0dcf18f13 = (w)=>{
    const pair = String(w?.drugPair || '').trim();
    const named = pair ? pair.split($ea35d970f69d5497$var$PAIR_SPLIT) : [
        w?.drug
    ];
    const drugs = [
        ...new Set(named.map($ea35d970f69d5497$var$drugKey).filter(Boolean))
    ].sort();
    if (drugs.length > 0) return drugs.join('+');
    // A finding that names no drug has only its wording to be known by.
    return `?${$ea35d970f69d5497$var$drugKey(w?.description)}`;
};
// «High», «HIGH » and «high» are one severity — compared verbatim, a model that
// capitalised let a شدید finding close the visit unstopped. The server
// normalises too; the sweep does not rely on it (Visit.shared normalizeSeverity).
const $ea35d970f69d5497$var$isHigh = (w)=>typeof w?.severity === 'string' && w.severity.trim().toLowerCase() === 'high';
const $ea35d970f69d5497$export$f00407a316e4306b = (warnings)=>(warnings || []).filter($ea35d970f69d5497$var$isHigh).map($ea35d970f69d5497$export$d203c3f0dcf18f13);
function $ea35d970f69d5497$export$2f7a0c550c40d1e3(warnings, { shown: shown, signature: signature, seenKeys: seenKeys } = {}) {
    const seen = new Set(seenKeys || []);
    if (signature != null && shown?.signature === signature) $ea35d970f69d5497$export$f00407a316e4306b(shown.warnings).forEach((k)=>seen.add(k));
    return (warnings || []).filter((w)=>$ea35d970f69d5497$var$isHigh(w) && !seen.has($ea35d970f69d5497$export$d203c3f0dcf18f13(w)));
}
function $ea35d970f69d5497$export$9b1b472b8328535d(warnings, { shown: shown, signature: signature, memo: memo } = {}) {
    const earlier = signature != null && memo?.current?.signature === signature ? memo.current.keys : [];
    const unseen = $ea35d970f69d5497$export$2f7a0c550c40d1e3(warnings, {
        shown: shown,
        signature: signature,
        seenKeys: earlier
    });
    if (unseen.length === 0) return false;
    if (memo) memo.current = {
        signature: signature,
        keys: [
            ...earlier,
            ...$ea35d970f69d5497$export$f00407a316e4306b(warnings)
        ]
    };
    return true;
}




const $3f422a714825191a$export$b7142a5aec62c528 = (item)=>{
    const sessions = Number(item?.sessionCount);
    return {
        orderType: item.type || 'lab',
        name: item.name || item.testName || item,
        code: item.code || item.loincCode || '',
        urgency: item.urgency || 'routine',
        description: item.reason || '',
        ...item.catalogId ? {
            catalogId: item.catalogId
        } : {},
        ...Number.isInteger(sessions) && sessions > 0 ? {
            sessionCount: sessions
        } : {}
    };
};
async function $3f422a714825191a$export$12af1fa985734757({ patientId: patientId, appointmentId: appointmentId }, order) {
    const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$bed6819e031e8e35), {
        input: {
            patientId: patientId,
            appointmentId: appointmentId,
            orders: [
                order
            ]
        }
    });
    const result = res?.saveDoctorOrders;
    if (!result?.success || !(result.savedCount >= 1)) throw new Error(result?.error || `order not saved: ${order?.name || ''}`);
    return result;
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cb1b2f70e9c265fc$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $cb1b2f70e9c265fc$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-alert", $cb1b2f70e9c265fc$export$3efd853dbb351e94);


parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1HT9m = parcelRequire("1HT9m");

function $4b153162db005cb6$export$2e2bcd8739ae039({ error: error, title: title, detail: detail, onRetry: onRetry, retryLabel: retryLabel, note: note }) {
    const { t: t } = (0, $LNQP4.default)();
    // NOTE: these defaults live in the body, not in the parameter list. Written as
    // `title = t('errors.unavailableInfo')` they threw ReferenceError — default
    // parameters are evaluated in their own scope, which cannot see the `const t`
    // below — so omitting `title` crashed the component whose entire job is to
    // render a crash. Every call site happened to pass one, which is the only
    // reason it went unnoticed.
    const kind = error ? (0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(error) : null;
    // The two halves of a useful error message answer different questions, and a
    // screen and the taxonomy each own one of them. The screen knows WHAT failed
    // («گزارش حسابداری در دسترس نیست»); only the classifier knows WHY («دستگاه
    // شما به اینترنت متصل نیست»). Showing just the first leaves the doctor
    // hunting for a fault in the accounting service when their Wi-Fi is off;
    // showing just the second loses which part of the screen is now unreliable.
    // So the caller's title heads the card and the kind's body explains it.
    const heading = title ?? (kind ? t(`${(0, $91f57610161f2da8$export$78353e7f4dfe1b54)(kind)}.title`) : t('errors.unavailableInfo'));
    const explanation = note ?? (kind ? t(`${(0, $91f57610161f2da8$export$78353e7f4dfe1b54)(kind)}.body`) : null);
    const technical = detail !== undefined ? detail : error ? (0, $91f57610161f2da8$export$b08d804d6ffdb3ed)(error) : null;
    const retryLabelText = retryLabel ?? t('common.actions.retry');
    // A retry button on a 403 or a 404 invites the doctor to keep pressing
    // something that cannot work. When we know the kind, it decides.
    const showRetry = Boolean(onRetry) && (kind ? (0, $91f57610161f2da8$export$f146c102d7613638)(kind) : true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "error-state",
        "data-error-kind": kind || undefined,
        role: "alert",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            boxShadow: (0, $56f50ba2a6b5ae3c$export$98b6069deb71e13e).card,
            padding: '2.5rem 1.75rem',
            textAlign: 'center',
            maxWidth: '30rem',
            margin: '1.5rem auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).pill,
            background: (0, $jTCZr.C).redLight,
            color: (0, $jTCZr.C).red,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
        size: 28,
        strokeWidth: 1.9,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, heading), explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).body,
            fontWeight: 500,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '0.75rem',
            lineHeight: 1.8
        }
    }, explanation), technical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            padding: '0.5rem 0.625rem',
            marginBottom: '1.25rem'
        }
    }, technical), showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: onRetry,
        "data-testid": "error-state-retry"
    }, retryLabelText));
}




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dSwFB = parcelRequire("dSwFB");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The gradient screen header — now a thin wrapper over the kit's `MobileHeader`
// (@parsina/framework), not a fork of it.
//
// It WAS a fork. DESIGN.md names `MobileHeader` and `BottomNav` as the mobile
// chrome the kit ships "so no app hand-rolls them again", and the clinic and
// patient apps consume the kit versions — so this app's private copy was the
// third implementation of one component, and a third implementation is how the
// surfaces drift. Compared line by line, the app's copy differed by exactly two
// things — a `backTestId` escape hatch and the `Icon`-as-component action shape
// — and both survive here, in ~40 lines, on top of the kit.
//
// The app-facing API is unchanged on purpose, so no screen edits:
//   doctor      → the kit's `user` (cockpit greeting mode)
//   actions     → [{ key, Icon, label, onClick, badge }] with `Icon` as a
//                 COMPONENT; the kit takes a rendered node, so the size and the
//                 `aria-hidden` are applied once here rather than at every call
//                 site.
//   backTestId  → forwarded to the kit prop of the same name, added for exactly
//                 this: Messages' selector contract names
//                 'messages-header-back' and must not have to rename the header
//                 to keep it.
//   backLabel   → defaults to the translated «بازگشت». The kit's own default is
//                 a Persian literal, which is right for a kit and wrong for an
//                 app that also ships en/ar.
//
// Passed straight through: `sticky` (a filter bar in `children` stays reachable
// while the list scrolls under it) and `search` (the on-gradient search field a
// lookup screen opens into).
// ─────────────────────────────────────────────────────────────────────────────
const $577e5af2575afc25$var$MobileHeader = ({ doctor: doctor, title: title, subtitle: subtitle, onBack: onBack, backLabel: backLabel, backTestId: backTestId = 'mobile-header-back', actions: actions = [], action: action, compact: compact = false, avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, sticky: sticky = false, search: search, children: children, // Everything else goes straight to the kit header — notably `figures*`
// (PM-0120). Naming each prop dropped the new ones silently: the record's
// figures row never appeared on beta1 although the BFF sent the visit count.
...rest })=>{
    const { t: t } = (0, $LNQP4.default)();
    const kitActions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>actions.map(({ key: key, Icon: Icon, label: label, onClick: onClick, badge: badge })=>({
                key: key,
                label: label,
                onClick: onClick,
                badge: badge,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                    size: 18,
                    "aria-hidden": true
                })
            })), [
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dSwFB.default), {
        user: doctor,
        greeting: t('dashboard.welcome'),
        title: title,
        subtitle: subtitle,
        onBack: onBack,
        backLabel: backLabel || t('common.actions.back'),
        backTestId: backTestId,
        actions: kitActions,
        action: action,
        compact: compact,
        avatar: avatar,
        leading: leading,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        sticky: sticky,
        search: search,
        ...rest
    }, children);
};
var $577e5af2575afc25$export$2e2bcd8739ae039 = $577e5af2575afc25$var$MobileHeader;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $3Amwd = parcelRequire("3Amwd");

var $8g4t5 = parcelRequire("8g4t5");
// ─────────────────────────────────────────────────────────────────────────────
// The observation model — ONE behavioural truth for the «مشاهدات» section of the
// patient record, shared by the desktop tab and the mobile section
// (DESIGN-CONCEPT-MOBILE §1.1: the two surfaces may look nothing alike, but they
// must never disagree on which panel a test belongs to, how many results a
// category holds, or which reading is the latest).
//
// Both surfaces used to carry their own copy of this derivation, which is
// exactly the drift the shared-logic rule exists to prevent.
//
// The lab taxonomy itself (`LAB_CATEGORIES`, `obsLabCategory`, `VITAL_LOINC_SET`)
// stays in `constants/patientRecord.js` — this module is the behaviour over it.
// ─────────────────────────────────────────────────────────────────────────────

const $00011fef9dd464cc$export$cb21c69c81e22f82 = (s)=>s === 'abnormal' || s === 'ABNORMAL' || s === 'critical' || s === 'CRITICAL';
function $00011fef9dd464cc$export$ac4947c400027274(observations) {
    const seen = new Set();
    return (observations || []).filter((o)=>{
        if (!o || seen.has(o.id)) return false;
        seen.add(o.id);
        return true;
    });
}
function $00011fef9dd464cc$export$1be0eaa0fb63147e(observations) {
    const map = {};
    $00011fef9dd464cc$export$ac4947c400027274(observations).forEach((o)=>{
        const key = o.display || o.code || '';
        if (!map[key]) map[key] = {
            display: key,
            code: o.code,
            unit: o.unit,
            readings: [],
            catId: (0, $bf42e0131d395ab7$export$520152d4ddd823c6).has(o.code) ? 'vitals' : (0, $bf42e0131d395ab7$export$88ddf826312c2ac7)(key)
        };
        const v = parseFloat(o.value);
        map[key].readings.push({
            id: o.id,
            date: o.effectiveDate || o.createdAt || '',
            value: Number.isNaN(v) ? o.value : v,
            numVal: v,
            status: o.status
        });
    });
    Object.values(map).forEach((s)=>{
        s.readings.sort((a, b)=>(a.date || '').localeCompare(b.date || ''));
    });
    return map;
}
function $00011fef9dd464cc$export$e4e463683289edb3(seriesMap) {
    const counts = {};
    Object.values(seriesMap).forEach((s)=>{
        counts[s.catId] = (counts[s.catId] || 0) + 1;
    });
    return counts;
}
function $00011fef9dd464cc$export$dbdc2bb8017e2c29(counts) {
    return Object.entries(counts).filter(([id])=>id !== 'vitals').sort((a, b)=>b[1] - a[1])[0]?.[0] || null;
}
function $00011fef9dd464cc$export$930962f873333845(seriesMap, catId) {
    if (!catId) return [];
    return Object.values(seriesMap).filter((s)=>s.catId === catId).sort((a, b)=>a.display.localeCompare(b.display));
}
function $00011fef9dd464cc$export$8020253fe86b6056(counts) {
    const cats = (0, $bf42e0131d395ab7$export$5a8441d057c1b67f).filter((c)=>c.id !== 'vitals' && counts[c.id]).map((c)=>({
            id: c.id,
            labelKey: c.labelKey,
            color: c.color,
            count: counts[c.id]
        }));
    if (counts.other) cats.push({
        id: 'other',
        labelKey: 'patient.labCategory.other',
        color: null,
        count: counts.other
    });
    return cats;
}
function $00011fef9dd464cc$export$f9b3ea7266dcc489(seriesMap, catId) {
    return Object.values(seriesMap).filter((s)=>s.catId === catId && s.readings.some((r)=>$00011fef9dd464cc$export$cb21c69c81e22f82(r.status))).length;
}
const $00011fef9dd464cc$export$ff3c197fd9303a2c = {
    '8480-6': {
        labelKey: 'patient.vitals.systolic',
        unit: 'mmHg',
        warn: (v)=>v > 140 || v < 90
    },
    '8462-4': {
        labelKey: 'patient.vitals.diastolic',
        unit: 'mmHg',
        warn: (v)=>v > 90 || v < 60
    },
    '8867-4': {
        labelKey: 'patient.vitals.hr',
        unit: 'bpm',
        warn: (v)=>v > 100 || v < 60
    },
    '59408-5': {
        labelKey: 'patient.vitals.spo2',
        unit: '%',
        warn: (v)=>v < 95
    },
    '8310-5': {
        labelKey: 'patient.vitals.temp',
        unit: "\xb0C",
        warn: (v)=>v > 37.5 || v < 36
    },
    '29463-7': {
        labelKey: 'patient.vitals.wt',
        unit: 'kg',
        warn: ()=>false
    }
};
function $00011fef9dd464cc$export$82bcdfaefbcbaa1e(observations) {
    return Object.entries($00011fef9dd464cc$export$ff3c197fd9303a2c).map(([code, meta])=>{
        const sorted = (observations || []).filter((o)=>o.code === code).sort((a, b)=>(b.effectiveDate || '').localeCompare(a.effectiveDate || ''));
        const latest = sorted[0];
        if (!latest) return null;
        const curr = parseFloat(latest.value);
        const prev = sorted[1] ? parseFloat(sorted[1].value) : null;
        const delta = prev != null && !Number.isNaN(prev) && !Number.isNaN(curr) ? curr - prev : null;
        return {
            id: code,
            labelKey: meta.labelKey,
            unit: meta.unit,
            value: latest.value,
            delta: delta,
            alert: !Number.isNaN(curr) && meta.warn(curr)
        };
    }).filter(Boolean);
}
const $00011fef9dd464cc$export$5050dfaf8101b0e4 = (delta)=>Math.abs(delta).toFixed(Math.abs(delta) < 10 ? 1 : 0);
function $00011fef9dd464cc$export$81571910c7bff4d5(readings) {
    const last = readings?.[readings.length - 1];
    const prev = readings?.[readings.length - 2];
    if (!last || !prev) return null;
    const a = parseFloat(last.value);
    const b = parseFloat(prev.value);
    return Number.isNaN(a) || Number.isNaN(b) ? null : a - b;
}


const $652abbe9694ab398$export$372861cd7d55d715 = (v, formatDate)=>{
    if (!v) return '';
    return formatDate ? formatDate(v, 'short') : '';
};
// Semantic pill tones, all resolved from tokens (no raw hex, §2.2).
const $652abbe9694ab398$var$PILL_TONE = {
    navy: {
        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
        color: (0, $jTCZr.C).navy
    },
    teal: {
        bg: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk
    },
    amber: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    danger: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    },
    good: {
        bg: (0, $jTCZr.C).greenLight,
        color: (0, $jTCZr.CT).goodInk
    },
    muted: {
        bg: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.C).textSecondary
    }
};
const $652abbe9694ab398$export$d2cf3038149dd1b5 = ({ children: children, tone: tone = 'teal', style: style })=>{
    const palette = $652abbe9694ab398$var$PILL_TONE[tone] || $652abbe9694ab398$var$PILL_TONE.teal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: palette.bg,
            color: palette.color,
            whiteSpace: 'nowrap',
            ...style
        }
    }, children);
};
const $652abbe9694ab398$export$69bc41ee738923ec = ({ children: children, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, children), action);
const $652abbe9694ab398$export$6d88ebe453be59d7 = ({ onClick: onClick, label: label, testId: testId })=>{
    const { t: t } = (0, $LNQP4.default)();
    const labelText = label ?? t('common.actions.add');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        "data-testid": testId,
        onClick: onClick,
        className: "gap-1 min-h-11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        strokeWidth: 2.6,
        "aria-hidden": true
    }), labelText);
};
const $652abbe9694ab398$export$1d9ba1b0141b442f = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: (0, $jTCZr.C).card,
            borderRadius: '0.625rem',
            padding: '0.8125rem 1rem',
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, value));
const $652abbe9694ab398$export$a344623fbba4b280 = ({ test: test, onOpen: onOpen, testId: testId })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const last = test.readings[test.readings.length - 1];
    const abn = (0, $00011fef9dd464cc$export$cb21c69c81e22f82)(last?.status);
    const delta = (0, $00011fef9dd464cc$export$81571910c7bff4d5)(test.readings);
    const points = test.readings.slice(-6).map((r)=>r.value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        onClick: onOpen,
        "aria-label": t('patient.obs.showTrendAria', {
            name: test.display
        }),
        "data-testid": testId,
        style: {
            padding: '0.75rem 0.875rem',
            borderColor: abn ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).border,
            borderRadius: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, test.display), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            alignItems: 'center',
            marginTop: '0.1875rem',
            flexWrap: 'wrap'
        }
    }, last?.date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, $652abbe9694ab398$export$372861cd7d55d715(last.date, formatDate)), abn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).danger,
            background: (0, $jTCZr.CT).dangerSoft,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.25rem'
        }
    }, t('visit.vitals.abnormal')), delta != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 600,
            color: delta > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good
        }
    }, delta > 0 ? "\u25B2" : "\u25BC", formatDigits((0, $00011fef9dd464cc$export$5050dfaf8101b0e4)(delta))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 72,
        height: 26,
        tone: abn ? 'danger' : 'accent'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            textAlign: 'end',
            minWidth: '3.25rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '1.0625rem',
            fontWeight: 800,
            color: abn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
            lineHeight: 1
        }
    }, last?.value != null ? formatDigits(last.value) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.5625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.125rem'
        }
    }, test.unit || ''))));
};
const $652abbe9694ab398$export$a80c208d4b2a2828 = ({ vitals: vitals = [], testId: testId = 'vitals-strip' })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!vitals.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.5rem',
            scrollbarWidth: 'none'
        }
    }, vitals.map((v)=>{
        const alert = v.alert;
        const deltaClr = v.delta == null ? null : v.delta > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id,
            style: {
                flexShrink: 0,
                minWidth: '5.625rem',
                background: alert ? (0, $jTCZr.C).amberLight : (0, $jTCZr.CT).surface2,
                border: `1px solid ${alert ? (0, $jTCZr.C).amber : (0, $jTCZr.C).border}`,
                borderRadius: '0.625rem',
                padding: '0.5625rem 0.75rem',
                textAlign: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: alert ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
                fontWeight: 600,
                marginBottom: '0.1875rem'
            }
        }, t(v.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: alert ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                lineHeight: 1
            }
        }, formatDigits(v.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, v.unit), v.delta != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: deltaClr,
                marginTop: '0.125rem',
                fontWeight: 600
            }
        }, v.delta > 0 ? "\u25B2" : "\u25BC", " ", formatDigits((0, $00011fef9dd464cc$export$5050dfaf8101b0e4)(v.delta))));
    }));
};


var $jTCZr = parcelRequire("jTCZr");
// The allergy safety band (patient-record chrome): a persistent danger-toned
// strip directly under the header so a critical allergy is never a tab away.
// Read-only, tokens-only, horizontally scroll-safe on a crowded list. Renders
// nothing when there is no allergy to warn about.
const $40b242509fe3ec60$var$MobilePatientAllergyStrip = ({ allergies: allergies = [] })=>{
    const { t: t } = (0, $LNQP4.default)();
    const items = allergies.map((a)=>typeof a === 'string' ? {
            allergen: a,
            severity: null
        } : a).filter((a)=>a && a.allergen);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-allergy-strip",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.375rem 1rem',
            background: (0, $jTCZr.CT).dangerSoft,
            borderBottom: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.15)}`,
            overflowX: 'auto',
            flexShrink: 0,
            scrollbarWidth: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            flexShrink: 0,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 13,
        strokeWidth: 2.4,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 800,
            letterSpacing: '0.06em'
        }
    }, t('patient.allergies.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.3125rem',
            flexShrink: 0
        }
    }, items.map((a, i)=>{
        const high = a.severity === 'high' || a.severity === 'severe';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                fontWeight: 600,
                padding: '0.125rem 0.5rem',
                borderRadius: '0.75rem',
                whiteSpace: 'nowrap',
                background: high ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.1) : (0, $jTCZr.C).amberLight,
                color: high ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, a.allergen);
    })));
};
var $40b242509fe3ec60$export$2e2bcd8739ae039 = $40b242509fe3ec60$var$MobilePatientAllergyStrip;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $hSPBf = parcelRequire("hSPBf");
var $4gxLI = parcelRequire("4gxLI");
var $bF8pu = parcelRequire("bF8pu");
var $7udIf = parcelRequire("7udIf");
// «پایش بالینی» — the phone's monitoring control. It sits in the visit's pinned
// top strip, beside the visit-wide «تکمیل» that reads what it records (PM-0038):
// the control that makes the transcript and the button that uses it, together,
// and on screen whichever tab the doctor is in. It takes the width «تکمیل»
// leaves, at the 44px touch height — the same as every other control in the
// visit's chrome (PM-0044), not the 48px of a page-level CTA.
//
// It is the state and the control at once. Idle it is the teal invitation (the
// same fill as «شروع ویزیت»); while listening it is an outline with a pulsing
// red dot, the running clock and «توقف»; paused or disconnected it is amber
// with the way back. §14.2 holds: recording / reconnecting / paused / stopped
// differ by fill, glyph AND words, never by colour alone. Listening is never
// solid red, so it cannot be mistaken for «پایان ویزیت».
const $943b784cb4e4dd8b$var$pad = (n)=>String(n).padStart(2, '0');
const $943b784cb4e4dd8b$var$MobileVisitMonitorButton = ({ recState: recState = 'idle', recElapsed: recElapsed = 0, onToggle: onToggle, disabled: disabled })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const clock = formatDigits(`${$943b784cb4e4dd8b$var$pad(Math.floor(recElapsed / 60))}:${$943b784cb4e4dd8b$var$pad(recElapsed % 60)}`);
    const recording = recState === 'recording';
    const stopping = recState === 'stopping';
    const connecting = recState === 'connecting';
    const paused = recState === 'paused-by-system';
    const error = recState === 'error';
    // `label` is what is SEEN, `fullLabel` what is announced (and the tooltip). The
    // button shares a 360–412px row with «تکمیل» and «بیمه», so once the pulsing
    // dot, the glyph and the clock are in, «توقف پایش بالینی» has no room: it wrapped
    // to three lines and spilled out of the pill. The states that carry extra
    // furniture therefore show the short word — the glyph and the fill still say
    // which control it is, and the screen reader hears all of it.
    let variant = 'teal';
    let style;
    let label = t('visit.listen.start');
    let fullLabel = label;
    let Icon = (0, $hSPBf.default);
    if (recording) {
        variant = 'outline';
        style = {
            borderColor: (0, $jTCZr.CT).danger,
            color: (0, $jTCZr.CT).dangerInk
        };
        label = t('visit.listen.stopShort');
        fullLabel = t('visit.listen.stop');
        Icon = (0, $7udIf.default);
    } else if (connecting) {
        variant = 'outline';
        label = fullLabel = t('visit.record.connecting');
        Icon = (0, $3365fede8cd1121a$export$2e2bcd8739ae039);
    } else if (stopping) {
        variant = 'outline';
        label = fullLabel = t('visit.listen.stopping');
        Icon = (0, $7udIf.default);
    } else if (paused) {
        style = {
            background: (0, $jTCZr.CT).warn,
            color: (0, $jTCZr.CT).ink
        };
        label = t('visit.listen.resumeShort');
        fullLabel = t('visit.listen.resume');
        Icon = (0, $4gxLI.default);
    } else if (error) {
        style = {
            background: (0, $jTCZr.CT).warn,
            color: (0, $jTCZr.CT).ink
        };
        label = t('visit.listen.retryShort');
        fullLabel = t('errors.connection.lostTap');
        Icon = (0, $bF8pu.default);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: variant,
        size: "lg",
        onClick: onToggle,
        disabled: disabled || stopping || connecting,
        "data-testid": "visit-rec-toggle",
        "data-state": recState,
        "aria-label": recording ? `${fullLabel} \u{2014} ${clock}` : fullLabel,
        title: fullLabel,
        className: "flex-1 min-w-0 h-11 min-h-11 gap-1.5 px-3 text-[14px] whitespace-nowrap overflow-hidden",
        style: style
    }, recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        "aria-hidden": true,
        className: `shrink-0${connecting ? ' animate-spin motion-reduce:animate-none' : ''}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "min-w-0 truncate"
    }, label), recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rec-clock",
        style: {
            fontVariantNumeric: 'tabular-nums',
            fontWeight: 700,
            flexShrink: 0
        }
    }, clock));
};
var $943b784cb4e4dd8b$export$2e2bcd8739ae039 = $943b784cb4e4dd8b$var$MobileVisitMonitorButton;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $k27hS = parcelRequire("k27hS");

var $7udIf = parcelRequire("7udIf");
// «پایان ویزیت» on the phone (PM-0044, design §۱۲).
//
// It is the one thing on this screen that is done ONCE per visit, and it used
// to be the largest, loudest element on it: a full-width solid red bar, at
// rest, on every visit. Red is for a real problem, and width says frequency.
// So it is now:
//
//   · an OUTLINE in the danger ink — recognisably the terminal action, without
//     a red fill sitting under the doctor's thumb for the whole consultation;
//   · as wide as its words, at the inline END of the footer — the corner
//     farthest from the thumb, away from the control that is pressed often;
//   · still 44px tall, still behind the screen's ConfirmDialog. Nothing closes
//     on this press alone.
//
// Below 360px the label shortens to «پایان»; the full name stays in the
// accessible name. While the visit is closing it says so and cannot be pressed.
const $8f551dfec33029cb$var$MobileVisitEndButton = ({ onEnd: onEnd, ending: ending = false, style: style, testId: testId = 'visit-cta-end' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const { isMobile: narrow } = (0, $k27hS.default)(359);
    const full = t('dashboard.hero.endVisit');
    const label = ending ? t('visit.header.ending') : narrow ? t('visit.footer.endShort') : full;
    const Icon = ending ? (0, $3365fede8cd1121a$export$2e2bcd8739ae039) : (0, $7udIf.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onEnd,
        disabled: ending,
        "data-testid": testId,
        "data-state": ending ? 'ending' : 'idle',
        "aria-label": ending ? label : full,
        className: "h-11 min-h-11 shrink-0 gap-1.5 px-3.5",
        style: {
            borderColor: (0, $jTCZr.CT).danger,
            color: (0, $jTCZr.CT).dangerInk,
            fontSize: '0.8125rem',
            fontWeight: 700,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        "aria-hidden": true,
        className: ending ? 'animate-spin motion-reduce:animate-none' : undefined
    }), label);
};
var $8f551dfec33029cb$export$2e2bcd8739ae039 = $8f551dfec33029cb$var$MobileVisitEndButton;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $754dc1fb92ffe304$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 22h5a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v7",
            key: "oagw2b"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M3.62 18.8A2.25 2.25 0 1 1 7 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a1 1 0 0 1-1.507 0z",
            key: "rg3psg"
        }
    ]
];
const $754dc1fb92ffe304$export$2e2bcd8739ae039 = (0, $9QBug.default)("file-heart", $754dc1fb92ffe304$export$3efd853dbb351e94);



// «پروندهٔ بیمار» — the way into the patient's record from the visit room, on
// the phone (PM-0033).
//
// It used to be a whole identity card under the header row: unmissable, and
// ~5.5rem of height before the first line of the note. Before that it was the
// patient's name itself, which cost nothing and which nobody found. This is
// the third shape and the reason for both lessons: a LABELLED button — icon
// and the word «پرونده» — in the header's own row, at the inline end beside
// «⋯». It has one fixed place, it says what it opens, and it adds no height.
//
// The patient's identity moved into the row with it: the name is the header's
// title and the facts that tell two namesakes apart are its subtitle
// (`visitPatientFacts`). The national id is not among them — it does not fit
// one line at 320px, and it is the first thing the record sheet shows.
const $4426115d6c876762$var$sexKey = (value)=>{
    const v = String(value || '').trim().toLowerCase();
    if ([
        'm',
        'male',
        'man',
        "\u0645\u0631\u062F"
    ].includes(v)) return 'male'; // i18n-exempt: wire values of patient.gender
    if ([
        'f',
        'female',
        'woman',
        "\u0632\u0646"
    ].includes(v)) return 'female'; // i18n-exempt: wire values of patient.gender
    return null;
};
const $4426115d6c876762$export$a800c9151312278d = (patient, t, formatDigits)=>{
    const p = patient || {};
    const sex = $4426115d6c876762$var$sexKey(p.gender);
    return [
        sex && t(`common.gender.${sex}`),
        p.age != null && p.age !== '' && t('patient.ageYears', {
            count: formatDigits(p.age)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        })
    ].filter(Boolean);
};
// `proposals`: «تکمیل» proposals waiting inside the record (علائم حیاتی, سوابق) — PM-0038.
const $4426115d6c876762$var$MobileVisitRecordButton = ({ onOpen: onOpen, patientName: patientName, proposals: proposals = 0, testId: testId = 'visit-record-button' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const label = t('visit.patientCard.open');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onOpen,
        "data-testid": testId,
        "aria-label": patientName ? `${t('visit.patient.record')} \u{2014} ${patientName}` : t('visit.patient.record'),
        className: "min-h-11 shrink-0 gap-1.5 px-3 bg-white/15 text-white hover:bg-white/25 hover:text-white",
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $754dc1fb92ffe304$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true
    }), label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$75b49caa06e7c59e), {
        variant: "mobile",
        count: proposals,
        testid: `${testId}-proposals`
    }));
};
var $4426115d6c876762$export$2e2bcd8739ae039 = $4426115d6c876762$var$MobileVisitRecordButton;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cd16704c2a54ea93$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.268 21a2 2 0 0 0 3.464 0",
            key: "vwvbt9"
        }
    ],
    [
        "path",
        {
            d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
            key: "11g9vi"
        }
    ]
];
const $cd16704c2a54ea93$export$2e2bcd8739ae039 = (0, $9QBug.default)("bell", $cd16704c2a54ea93$export$3efd853dbb351e94);


const $acb36492df172d8d$export$c171d27cac495866 = 5000;
const $acb36492df172d8d$var$MobileVisitEvents = ({ events: events = [], onSeen: onSeen, testId: testId = 'visit-events' })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Ids already announced / already read. Refs would do for the first; state
    // for the second, because the count is drawn from it.
    const announcedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    const [readIds, setReadIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [announcing, setAnnouncing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The screen rebuilds `events` on every render (the visit clock ticks once a
    // second), so the effects key on WHICH events exist, not on the array — a
    // timer torn down every second would never fire.
    const idsKey = events.map((e)=>e.id).join('|');
    const eventsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(events);
    eventsRef.current = events;
    // Announce each event ONCE, the first time it appears.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const live = eventsRef.current;
        const fresh = live.find((e)=>!announcedRef.current.has(e.id));
        if (fresh) {
            announcedRef.current.add(fresh.id);
            setAnnouncing(fresh);
        } else // The event being announced went away under the announcement.
        setAnnouncing((cur)=>cur && !live.some((e)=>e.id === cur.id) ? null : cur);
    }, [
        idsKey
    ]);
    // …and fold it back into the bell by itself.
    const announcingId = announcing?.id;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!announcingId) return undefined;
        const timer = setTimeout(()=>setAnnouncing(null), $acb36492df172d8d$export$c171d27cac495866);
        return ()=>clearTimeout(timer);
    }, [
        announcingId
    ]);
    // An event that went away (the condition cleared, the screen dismissed it)
    // may come back later as news.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const live = new Set(eventsRef.current.map((e)=>e.id));
        announcedRef.current.forEach((id)=>{
            if (!live.has(id)) announcedRef.current.delete(id);
        });
        setReadIds((prev)=>{
            const next = new Set([
                ...prev
            ].filter((id)=>live.has(id)));
            return next.size === prev.size ? prev : next;
        });
    }, [
        idsKey
    ]);
    if (!events.length) return null;
    const unread = events.filter((e)=>!readIds.has(e.id)).length;
    const openSheet = ()=>{
        setAnnouncing(null);
        setOpen(true);
    };
    const closeSheet = ()=>{
        setOpen(false);
        setReadIds(new Set(events.map((e)=>e.id)));
        const gone = events.filter((e)=>!e.sticky).map((e)=>e.id);
        if (gone.length && onSeen) onSeen(gone);
    };
    const bellLabel = unread > 0 ? t('visit.events.bellUnread', {
        count: formatDigits(unread)
    }) : t('visit.events.title');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        onClick: openSheet,
        "aria-label": bellLabel,
        title: bellLabel,
        "data-testid": testId,
        "data-unread": unread,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white",
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd16704c2a54ea93$export$2e2bcd8739ae039), {
        size: 19,
        "aria-hidden": true
    }), unread > 0 && // White on the brand chrome, never red: unread is not an alarm.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        "data-testid": `${testId}-count`,
        style: {
            position: 'absolute',
            top: '0.3125rem',
            insetInlineEnd: '0.3125rem',
            minWidth: '1rem',
            height: '1rem',
            padding: '0 0.25rem',
            borderRadius: '0.5rem',
            background: '#fff',
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.625rem',
            fontWeight: 800,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1
        }
    }, formatDigits(unread))), announcing && !open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: openSheet,
        role: "status",
        "data-testid": `${testId}-announce`,
        style: {
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            zIndex: 2,
            height: '2.75rem',
            maxWidth: 'min(calc(100vw - 5rem), 20rem)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0 0.875rem 0 0.75rem',
            border: 0,
            borderRadius: '1.375rem',
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            font: 'inherit',
            cursor: 'pointer',
            boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
            fontSize: '0.8125rem',
            fontWeight: 700,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(announcing.Icon || (0, $cd16704c2a54ea93$export$2e2bcd8739ae039), {
        size: 16,
        'aria-hidden': true,
        style: {
            flexShrink: 0,
            color: announcing.tone === 'warn' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, announcing.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: closeSheet,
        title: t('visit.events.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-sheet`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, events.map((e)=>{
        const warn = e.tone === 'warn';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: e.id,
            "data-testid": `${testId}-item-${e.id}`,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.625rem',
                padding: '0.75rem 0.875rem',
                borderRadius: '0.875rem',
                background: warn ? (0, $jTCZr.CT).warnSoft : (0, $jTCZr.CT).surface2,
                border: `1px solid ${warn ? (0, $jTCZr.CT).warn : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e.Icon || (0, $cd16704c2a54ea93$export$2e2bcd8739ae039), {
            size: 17,
            'aria-hidden': true,
            style: {
                flexShrink: 0,
                marginTop: '0.125rem',
                color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                lineHeight: 1.7
            }
        }, e.title), e.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.8,
                marginTop: '0.125rem'
            }
        }, e.body), e.action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11 mt-2",
            "data-testid": `${testId}-action-${e.id}`,
            onClick: ()=>{
                closeSheet();
                e.action.onClick();
            }
        }, e.action.label)));
    }))));
};
var $acb36492df172d8d$export$2e2bcd8739ae039 = $acb36492df172d8d$var$MobileVisitEvents;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $4CVxl = parcelRequire("4CVxl");
var $jhSl7 = parcelRequire("jhSl7");
var $aVx4q = parcelRequire("aVx4q");

// The visit section navigator — ویزیت / نسخه / درخواست: the three things the
// doctor WRITES. Sticky under the header so switching sections is always one
// thumb-tap. Kit Button tabs (≥44px).
//
// There is no تشخیص tab. The differential is AI output and lives in the
// assistant sheet («تشخیص افتراقی»); it used to be reachable from both, which
// read as two lists. Diagnoses the doctor records go in the note's «A».
//
// The note tab is labelled from `visit.tabs.soap` — the same key the desktop
// work tab uses — so the section is named «ویزیت» identically on both surfaces.
//
// There is no برنامه tab: the AI treatment plan is generated, reviewed and filed
// from the «برنامه» section of the note, inside ویزیت.
const $82e479bcc1dba2a2$var$TABS = (t)=>[
        {
            id: 'note',
            label: t('visit.tabs.soap'),
            Icon: (0, $jhSl7.default)
        },
        {
            id: 'rx',
            label: t('visit.tabs.rx'),
            Icon: (0, $aVx4q.default),
            countKey: 'rx'
        },
        {
            id: 'ord',
            label: t('visit.orders.request'),
            Icon: (0, $4CVxl.default),
            countKey: 'ord'
        }
    ];
// `isVisible(id)` is the doctor's layout preference (Settings → «صفحه ویزیت»),
// mapped onto this surface's tab ids by screens/Visit/visitLayout.js. Absent,
// every tab shows — the nav has no opinion of its own.
//
// `proposals` is how many «تکمیل» proposals wait in each tab (PM-0038): the tab
// wears the count until the doctor has confirmed or rejected them.
//
// `trailing` is one optional 44px control at the END of the strip — the phone's
// «تبدیل به ویزیت آنلاین» on an in-person visit. It rides the row the tabs
// already occupy, so the secondary path costs no height.
const $82e479bcc1dba2a2$var$MobileVisitNav = ({ active: active, onChange: onChange, counts: counts = {}, proposals: proposals = {}, isVisible: isVisible = ()=>true, trailing: trailing = null })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-nav",
        style: {
            display: 'flex',
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingInline: '0.25rem'
        }
    }, $82e479bcc1dba2a2$var$TABS(t).filter(({ id: id })=>isVisible(id)).map(({ id: id, label: label, Icon: Icon, countKey: countKey })=>{
        const on = active === id;
        const badge = countKey ? counts[countKey] : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: "ghost",
            onClick: ()=>onChange(id),
            "data-testid": `visit-nav-${id}`,
            "aria-pressed": on,
            className: "flex-1 min-h-11 h-auto flex-col gap-0.5 rounded-none px-1 py-2 hover:bg-transparent",
            style: {
                borderBottom: `2px solid ${on ? (0, $jTCZr.C).navy : 'transparent'}`,
                color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 14,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: on ? 700 : 500
            }
        }, label), badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.75rem',
                background: on ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).surface2,
                color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary
            }
        }, badge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$75b49caa06e7c59e), {
            variant: "mobile",
            count: proposals[id],
            testid: `visit-nav-proposals-${id}`
        })));
    }), trailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            gap: '0.25rem',
            paddingInlineStart: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 1,
            height: '1.5rem',
            background: (0, $jTCZr.C).border
        }
    }), trailing));
};
var $82e479bcc1dba2a2$export$2e2bcd8739ae039 = $82e479bcc1dba2a2$var$MobileVisitNav;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $97xXr = parcelRequire("97xXr");
var $hSPBf = parcelRequire("hSPBf");
var $chm1L = parcelRequire("chm1L");

var $jTCZr = parcelRequire("jTCZr");
// The note's proposal: what «تکمیل» would add to ONE section of the SOAP note,
// shown under that section until the doctor confirms or rejects it (§13.3 — AI
// output stays labelled and OUTSIDE the note). The same card as every other
// «تکمیل» proposal (PM-0038), on both surfaces.
//
// The body is the server-merged section, diffed against the section it was
// merged FROM (`base`): added words marked, any word the merge dropped struck
// through, long unchanged stretches elided. «تأیید» writes exactly that merged
// section (doctor text preserved by contract), plus anything the doctor
// appended since it was proposed — which is not the AI's to show.
//
// It is never the model's `additions` list. That is a summary the model writes
// ABOUT its merge, and it left facts out: the card showed a line or two while
// «تأیید» wrote a paragraph, so the doctor reviewed one text and accepted
// another.
//
// A STALE proposal is one whose section the doctor changed otherwise before
// confirming it: writing it would delete what they wrote, so it was not written.
// The card says so in place and offers to read the section again instead.

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $acw62 = parcelRequire("acw62");
// What «اعمال در یادداشت» will actually do to a SOAP section, as a word diff.
//
// The refine service returns two things per section: `text`, the full merged
// section that apply writes, and `additions`, a short list the model writes
// ABOUT what it added. The preview used to show `additions` — a summary that
// routinely left facts out — so the doctor reviewed one thing and accepted
// another. The preview is now derived from `text` itself, diffed against what
// the section holds right now, so every word apply would add (or drop) is on
// screen before the click.
// Unchanged runs longer than this are trimmed to CONTEXT words either side of
// a change. The doctor's own text is already in the box above the preview;
// repeating all of it would bury the change it is there to show.
const $aeab41940996b2c6$export$1c0f41907b107ef3 = 8;
// Above this many DP cells the middle is shown as a whole replacement rather
// than diffed. Only reachable when a large note was rewritten throughout.
const $aeab41940996b2c6$var$MAX_LCS_CELLS = 2000000;
// A word with the whitespace after it; leading whitespace is a token of its
// own. Tokens compare by the word alone, so a reflowed line break is not a
// change. Punctuation at either edge of a word is split off: the merge
// typically continues a sentence the doctor ended, and «120/80» becoming
// «120/80،» is an added comma, not a deleted and re-added reading. Punctuation
// INSIDE a word (37.8, 120/80) stays put.
const $aeab41940996b2c6$var$EDGE_PUNCT = ".,\u060C;\u061B:!?\u061F\u2026()\xab\xbb\"'\\[\\]";
const $aeab41940996b2c6$var$LEAD_RE = new RegExp(`^([${$aeab41940996b2c6$var$EDGE_PUNCT}]+)(?=[^\\s${$aeab41940996b2c6$var$EDGE_PUNCT}])`);
const $aeab41940996b2c6$var$TRAIL_RE = new RegExp(`(?<=\\S)([${$aeab41940996b2c6$var$EDGE_PUNCT}]+\\s*)$`);
function $aeab41940996b2c6$var$tokenize(text) {
    const out = [];
    ((text || '').match(/\s+|\S+\s*/g) || []).forEach((tok)=>{
        let rest = tok;
        const lead = rest.match($aeab41940996b2c6$var$LEAD_RE);
        if (lead) {
            out.push(lead[1]);
            rest = rest.slice(lead[1].length);
        }
        const trail = rest.match($aeab41940996b2c6$var$TRAIL_RE);
        if (trail && trail.index > 0) {
            out.push(rest.slice(0, trail.index));
            out.push(trail[1]);
        } else out.push(rest);
    });
    return out;
}
const $aeab41940996b2c6$var$keyOf = (tok)=>tok.trim();
function $aeab41940996b2c6$var$pushSeg(out, kind, toks) {
    if (!toks.length) return;
    const last = out[out.length - 1];
    if (last && last.kind === kind) last.toks.push(...toks);
    else out.push({
        kind: kind,
        toks: [
            ...toks
        ]
    });
}
function $aeab41940996b2c6$var$lcsDiff(a, b, out) {
    const n = a.length, m = b.length;
    if (!n) {
        $aeab41940996b2c6$var$pushSeg(out, 'add', b);
        return;
    }
    if (!m) {
        $aeab41940996b2c6$var$pushSeg(out, 'del', a);
        return;
    }
    if (n * m > $aeab41940996b2c6$var$MAX_LCS_CELLS) {
        $aeab41940996b2c6$var$pushSeg(out, 'del', a);
        $aeab41940996b2c6$var$pushSeg(out, 'add', b);
        return;
    }
    const w = m + 1;
    const dp = new Uint32Array((n + 1) * w);
    for(let i = n - 1; i >= 0; i--)for(let j = m - 1; j >= 0; j--)dp[i * w + j] = $aeab41940996b2c6$var$keyOf(a[i]) === $aeab41940996b2c6$var$keyOf(b[j]) ? dp[(i + 1) * w + j + 1] + 1 : Math.max(dp[(i + 1) * w + j], dp[i * w + j + 1]);
    let i = 0, j = 0;
    while(i < n && j < m){
        if ($aeab41940996b2c6$var$keyOf(a[i]) === $aeab41940996b2c6$var$keyOf(b[j])) {
            $aeab41940996b2c6$var$pushSeg(out, 'same', [
                b[j]
            ]);
            i++;
            j++;
        } else if (dp[(i + 1) * w + j] >= dp[i * w + j + 1]) {
            $aeab41940996b2c6$var$pushSeg(out, 'del', [
                a[i]
            ]);
            i++;
        } else {
            $aeab41940996b2c6$var$pushSeg(out, 'add', [
                b[j]
            ]);
            j++;
        }
    }
    if (i < n) $aeab41940996b2c6$var$pushSeg(out, 'del', a.slice(i));
    if (j < m) $aeab41940996b2c6$var$pushSeg(out, 'add', b.slice(j));
}
// An insertion between equal tokens can sit in more than one place: adding
// «. تب ندارد.» after «دارد.» matches the doctor's final period to the NEW
// sentence's, and the highlight reads «. تب ندارد» + «.». Slide each change
// right while its first token equals the unchanged token after it — the text
// is identical, and the change now ends where its own sentence does.
function $aeab41940996b2c6$var$slideRight(segs) {
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        if (seg.kind === 'same') continue;
        for(let next = segs[i + 1]; next && next.kind === 'same' && seg.toks.length && next.toks.length && $aeab41940996b2c6$var$keyOf(seg.toks[0]) === $aeab41940996b2c6$var$keyOf(next.toks[0]); next = segs[i + 1]){
            const x0 = seg.toks.shift();
            const b0 = next.toks.shift();
            // `same` text is the merged side's; a deletion keeps the current side's.
            const keep = seg.kind === 'add' ? x0 : b0;
            seg.toks.push(seg.kind === 'add' ? b0 : x0);
            const prev = segs[i - 1];
            if (prev && prev.kind === 'same') prev.toks.push(keep);
            else {
                segs.splice(i, 0, {
                    kind: 'same',
                    toks: [
                        keep
                    ]
                });
                i++;
            }
            if (!next.toks.length) segs.splice(i + 1, 1);
        }
    }
    return segs;
}
function $aeab41940996b2c6$var$collapse(segs, context) {
    return segs.flatMap((seg, idx)=>{
        if (seg.kind !== 'same') return [
            seg
        ];
        const words = seg.toks.filter((t)=>$aeab41940996b2c6$var$keyOf(t));
        const first = idx === 0, last = idx === segs.length - 1;
        const keepHead = first ? 0 : context;
        const keepTail = last ? 0 : context;
        if (words.length <= keepHead + keepTail + 2) return [
            seg
        ];
        // Index the token positions of the words to keep on either side.
        const wordIdx = seg.toks.map((t, k)=>$aeab41940996b2c6$var$keyOf(t) ? k : -1).filter((k)=>k >= 0);
        const headEnd = keepHead ? wordIdx[keepHead - 1] + 1 : 0;
        const tailStart = keepTail ? wordIdx[wordIdx.length - keepTail] : seg.toks.length;
        const parts = [];
        if (headEnd) parts.push({
            kind: 'same',
            toks: seg.toks.slice(0, headEnd)
        });
        parts.push({
            kind: 'gap',
            toks: []
        });
        if (tailStart < seg.toks.length) parts.push({
            kind: 'same',
            toks: seg.toks.slice(tailStart)
        });
        return parts;
    });
}
function $aeab41940996b2c6$export$5c9f5a0a5df5343e(current, merged, opts = {}) {
    const context = opts.context ?? $aeab41940996b2c6$export$1c0f41907b107ef3;
    const a = $aeab41940996b2c6$var$tokenize(current);
    const b = $aeab41940996b2c6$var$tokenize(merged);
    // Common prefix and suffix first: the service appends to the end of a
    // section by preference, so this usually leaves only the addition to diff.
    let pre = 0;
    while(pre < a.length && pre < b.length && $aeab41940996b2c6$var$keyOf(a[pre]) === $aeab41940996b2c6$var$keyOf(b[pre]))pre++;
    let suf = 0;
    while(suf < a.length - pre && suf < b.length - pre && $aeab41940996b2c6$var$keyOf(a[a.length - 1 - suf]) === $aeab41940996b2c6$var$keyOf(b[b.length - 1 - suf]))suf++;
    const segs = [];
    $aeab41940996b2c6$var$pushSeg(segs, 'same', b.slice(0, pre));
    $aeab41940996b2c6$var$lcsDiff(a.slice(pre, a.length - suf), b.slice(pre, b.length - suf), segs);
    $aeab41940996b2c6$var$pushSeg(segs, 'same', b.slice(b.length - suf));
    // A whitespace-only token is a word boundary, not content: fold it into the
    // unchanged text so it never renders as a highlighted blank.
    const cleaned = [];
    $aeab41940996b2c6$var$slideRight(segs).forEach((s)=>{
        if (s.kind !== 'same' && !s.toks.some($aeab41940996b2c6$var$keyOf)) {
            if (s.kind === 'add') $aeab41940996b2c6$var$pushSeg(cleaned, 'same', s.toks);
            return;
        }
        $aeab41940996b2c6$var$pushSeg(cleaned, s.kind, s.toks);
    });
    return $aeab41940996b2c6$var$collapse(cleaned, context).map((s)=>({
            kind: s.kind,
            text: s.toks.join('')
        }));
}


function $7be017aeba1bb501$export$c50637ba86c566c2({ current: current, merged: merged, addStyle: addStyle, delStyle: delStyle, style: style, testId: testId }) {
    const segments = (0, $acw62.useMemo)(()=>(0, $aeab41940996b2c6$export$5c9f5a0a5df5343e)(current, merged), [
        current,
        merged
    ]);
    const hasChange = segments.some((s)=>s.kind === 'add' || s.kind === 'del');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        dir: "auto",
        style: {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            ...style
        }
    }, hasChange ? segments.map((s, i)=>{
        if (s.kind === 'add') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ins", {
            key: i,
            "data-diff": "add",
            style: {
                textDecoration: 'none',
                borderRadius: 3,
                ...addStyle
            }
        }, s.text);
        if (s.kind === 'del') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", {
            key: i,
            "data-diff": "del",
            style: {
                opacity: 0.75,
                ...delStyle
            }
        }, s.text);
        if (s.kind === 'gap') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            "data-diff": "gap",
            "aria-hidden": true,
            style: {
                opacity: 0.6
            }
        }, "\u2026 ");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i
        }, s.text);
    }) : merged);
}
var $7be017aeba1bb501$export$2e2bcd8739ae039 = $7be017aeba1bb501$export$c50637ba86c566c2;


function $fcdf6086c22a8d18$export$2e2bcd8739ae039({ sectionKey: sectionKey, title: title, preview: preview, onAccept: onAccept, onDismiss: onDismiss, onRerun: onRerun, busy: busy = false, variant: variant = 'web', style: style }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!preview) return null;
    const mobile = variant === 'mobile';
    const stale = !!preview.stale;
    const text = {
        fontSize: mobile ? '0.8125rem' : 12,
        color: (0, $jTCZr.CT).ink,
        lineHeight: 1.7
    };
    const testid = `visit-soap-refine-preview-${sectionKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$c77d4a7df286b4a9), {
        variant: variant,
        testid: testid,
        title: title,
        style: style,
        "data-stale": stale ? 'true' : undefined,
        footer: stale ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$8f3e57e0bb4fa42c), {
            variant: variant,
            testid: testid,
            onAccept: onRerun,
            acceptLabel: t('visit.soap.refine.rerun'),
            acceptDisabled: !onRerun,
            busy: busy,
            acceptTestid: `visit-soap-refine-rerun-${sectionKey}`,
            onDismiss: onDismiss,
            dismissTestid: `visit-soap-refine-dismiss-${sectionKey}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$8f3e57e0bb4fa42c), {
            variant: variant,
            testid: testid,
            onAccept: onAccept,
            acceptTestid: `visit-soap-refine-apply-${sectionKey}`,
            onDismiss: onDismiss,
            dismissTestid: `visit-soap-refine-dismiss-${sectionKey}`
        })
    }, stale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": `${testid}-stale`,
        dir: "auto",
        style: {
            fontSize: mobile ? '0.75rem' : 11.5,
            lineHeight: 1.7,
            color: (0, $jTCZr.CT).warnInk,
            background: (0, $jTCZr.CT).warnSoft,
            borderRadius: mobile ? '0.5rem' : 6,
            padding: mobile ? '0.5rem 0.625rem' : '6px 9px'
        }
    }, t('visit.soap.refine.stale', {
        section: title
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7be017aeba1bb501$export$2e2bcd8739ae039), {
        testId: `visit-soap-refine-diff-${sectionKey}`,
        current: preview.base || '',
        merged: preview.text,
        addStyle: {
            background: `color-mix(in srgb, ${(0, $jTCZr.CT).accent} 30%, transparent)`
        },
        delStyle: {
            color: (0, $jTCZr.CT).dangerInk
        },
        style: {
            ...text,
            maxHeight: mobile ? '12rem' : 220,
            overflowY: 'auto'
        }
    }));
}


// The SOAP note — «شرح حال» leading, then معاینه/ارزیابی/برنامه. Each part
// is a token-tinted letter badge + label + a full-width textarea; the doctor
// types, the screen owns the `soap` state and persistence. Accordion open/closed
// is local presentational state (no clinical meaning), so it stays here.
//
// Each part also carries its own dictation button. `onVoice(key, name)` hands
// the section's identity back to the screen, which is what keeps a dictation
// started under «ارزیابی» out of «شکایت اصلی» — the section is never inferred
// from whatever happens to be focused.
//
// «برنامه» additionally carries the AI treatment-plan action: `onPlanAi` asks
// the screen to generate the plan, and `planPanel` is the review panel the
// screen renders directly under this section's textarea. The plan's prose is
// written into this very field, so the doctor edits it like any other SOAP text.
//
// `refine` is the screen's useSoapRefine hook value — the merge-aware
// «تکمیل یادداشت» flow. The outcome strip and the per-section previews render
// HERE, in the note's own surface. The trigger does not (PM-0046): the note is
// read by the visit-wide «تکمیل» in the screen's pinned top strip, and a second
// "complete all" above the note was a duplicate of it.
// «شرح حال» LEADS the note. It is what the doctor writes first and most, and
// what the differential, the confirmation questions and the plan all read — so
// on the phone it is labelled by its clinical name, is always open, starts
// tall and grows with its text, and carries an accent edge the other three do
// not. The others stay a compact accordion below it.
const $58ef1df1f5757bce$var$LEAD = 's';
/** «شرح حال»'s field: tall enough to write a history in, capped so the other
 *  parts stay reachable; past the cap it scrolls inside itself. */ const $58ef1df1f5757bce$var$LEAD_MIN_H = '13rem';
const $58ef1df1f5757bce$var$LEAD_MAX_H = '60dvh';
const $58ef1df1f5757bce$var$PARTS = (t)=>[
        {
            k: 'S',
            key: 's',
            name: t('visit.soap.historyShort'),
            tone: (0, $jTCZr.CT).accentInk
        },
        {
            k: 'O',
            key: 'o',
            name: t('visit.soap.objective'),
            tone: (0, $jTCZr.CT).accentInk
        },
        {
            k: 'A',
            key: 'a',
            name: t('patient.soap.assessment'),
            tone: (0, $jTCZr.C).navy
        },
        {
            k: 'P',
            key: 'p',
            name: t('patient.soap.plan'),
            tone: (0, $jTCZr.CT).goodInk
        }
    ];
const $58ef1df1f5757bce$var$MobileVisitSoap = ({ soap: soap, onChange: onChange, onVoice: onVoice, voiceDisabled: voiceDisabled = false, onPlanAi: onPlanAi, planAiDisabled: planAiDisabled = false, planAiLoading: planAiLoading = false, planPanelOpen: planPanelOpen = false, planPanel: planPanel = null, onPlanFocusChange: // The screen's plan reconciler rewrites «برنامه» when the drug/order lists
// change. It must not do that under the doctor's fingers, so the field reports
// when it holds focus and the reconciler waits.
onPlanFocusChange, planBlockHint: planBlockHint = null, refine: refine = null })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        s: true,
        o: false,
        a: false,
        p: false
    });
    // Opening the plan panel from a collapsed «برنامه» would put the panel where
    // the doctor cannot see the text it just wrote, so the section follows it open.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (planPanelOpen) setOpen((o)=>o.p ? o : {
                ...o,
                p: true
            });
    }, [
        planPanelOpen
    ]);
    // A preview the doctor cannot see is a preview that never gets applied —
    // sections that received one follow it open.
    const previewKeys = refine?.preview ? Object.keys(refine.preview) : [];
    const previewSig = previewKeys.join(',');
    // What «تأیید همه» confirms: every part's proposal — all four are on this one
    // surface — except a stale one, which can only be read again.
    const applicableKeys = previewKeys.filter((k)=>!refine.preview[k]?.stale);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!previewSig) return;
        setOpen((o)=>{
            const next = {
                ...o
            };
            previewSig.split(',').forEach((k)=>{
                next[k] = true;
            });
            return next;
        });
    }, [
        previewSig
    ]);
    const refineStatus = refine?.status && refine.status !== 'ok' ? refine.status : null;
    const hasNewContent = !!refine?.hasNewContent && !refine.loading;
    // «شرح حال» grows with what is written in it (up to LEAD_MAX_H) instead of
    // making the doctor scroll a three-line box. Measured after every change,
    // collapsing first so deleted text shrinks it back.
    const leadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = leadRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight + 2}px`;
    }, [
        soap[$58ef1df1f5757bce$var$LEAD]
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, (hasNewContent || applicableKeys.length > 1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, hasNewContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-soap-refine-newdot",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.3125rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).accent,
            flexShrink: 0
        }
    }), t('visit.soap.refine.newContent')), applicableKeys.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        onClick: ()=>refine.applyAll(applicableKeys),
        "data-testid": "visit-soap-refine-apply-all",
        className: "min-h-11 gap-1.5 px-3 text-xs",
        style: {
            marginInlineStart: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.soap.refine.applyAll'))), refineStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-refine-status",
        "data-status": refineStatus,
        role: refineStatus === 'error' ? 'alert' : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.6875rem',
            borderRadius: '0.5rem',
            fontSize: '0.71875rem',
            background: refineStatus === 'error' ? (0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.10) : (0, $jTCZr.CT).surface2,
            border: `1px solid ${refineStatus === 'error' ? (0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.35) : (0, $jTCZr.C).border}`,
            color: refineStatus === 'error' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            lineHeight: 1.6
        }
    }, refineStatus === 'error' ? t('visit.soap.refine.error') : refineStatus === 'no_transcript' ? t('visit.soap.refine.noTranscript') : t('visit.soap.refine.noNew')), refineStatus === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>refine.refine(),
        "data-testid": "visit-soap-refine-retry",
        className: "min-h-11 px-3 text-xs"
    }, t('common.actions.retry'))), $58ef1df1f5757bce$var$PARTS(t).map(({ k: k, key: key, name: name, tone: tone })=>{
        const lead = key === $58ef1df1f5757bce$var$LEAD;
        // The lead section cannot be folded away — it is the note.
        const isOpen = lead || open[key];
        const filled = !!soap[key]?.trim();
        const preview = refine?.preview?.[key] || null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-lead": lead ? 'true' : undefined,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${lead ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.55) : (0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                overflow: 'hidden',
                ...lead ? {
                    borderInlineStart: `3px solid ${(0, $jTCZr.CT).accent}`,
                    boxShadow: `0 1px 0 ${(0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.10)}`
                } : null
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                paddingInlineEnd: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: lead ? undefined : ()=>setOpen((o)=>({
                        ...o,
                        [key]: !o[key]
                    })),
            "data-testid": `visit-soap-toggle-${key}`,
            "aria-expanded": isOpen,
            "aria-disabled": lead || undefined,
            className: "flex-1 min-w-0 min-h-11 h-auto justify-start gap-2.5 px-3.5 py-3 rounded-none hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '1.5rem',
                height: '1.5rem',
                borderRadius: '0.375rem',
                flexShrink: 0,
                background: filled ? tone : (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.14),
                color: filled ? '#fff' : (0, $jTCZr.C).textMuted,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.6875rem',
                fontWeight: 800
            }
        }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                textAlign: 'start',
                fontSize: lead ? '0.9375rem' : '0.8125rem',
                fontWeight: lead ? 700 : 600,
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, name), preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.375rem',
                height: '0.375rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).accent,
                flexShrink: 0
            },
            "aria-hidden": true
        }), !lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 15,
            "aria-hidden": true,
            style: {
                color: (0, $jTCZr.C).textMuted,
                transition: 'transform .15s',
                transform: isOpen ? 'rotate(180deg)' : 'none'
            }
        })), onVoice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            disabled: voiceDisabled,
            // Dictating into a collapsed section would put the words
            // where the doctor cannot see them land — it opens first.
            onClick: ()=>{
                setOpen((o)=>o[key] ? o : {
                        ...o,
                        [key]: true
                    });
                onVoice(key, name);
            },
            "data-testid": `visit-soap-voice-${key}`,
            "aria-label": t('visit.voice.recordSection', {
                section: name
            }),
            className: "min-h-11 shrink-0 gap-1.5 px-3 text-xs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hSPBf.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.voice.record')), key === 'p' && onPlanAi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            disabled: planAiDisabled,
            onClick: onPlanAi,
            "data-testid": "visit-soap-plan-ai",
            "aria-expanded": planPanelOpen,
            "aria-label": t('visit.plan.aiForPlan'),
            className: "min-h-11 shrink-0 gap-1.5 px-3 text-xs",
            style: {
                color: (0, $jTCZr.CT).accentInk,
                borderColor: (0, $jTCZr.CT).accent
            }
        }, planAiLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accentInk,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 13,
            "aria-hidden": true
        }), ' ', "AI")), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0 0.875rem 0.875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
            ref: lead ? leadRef : undefined,
            value: soap[key] || '',
            onChange: (e)=>onChange(key, e.target.value),
            onFocus: key === 'p' && onPlanFocusChange ? ()=>onPlanFocusChange(true) : undefined,
            onBlur: key === 'p' && onPlanFocusChange ? ()=>onPlanFocusChange(false) : undefined,
            placeholder: `${name}\u{2026}`,
            rows: lead ? 8 : 3,
            "data-testid": `visit-soap-input-${key}`,
            style: {
                width: '100%',
                boxSizing: 'border-box',
                resize: 'vertical',
                ...lead ? {
                    minHeight: $58ef1df1f5757bce$var$LEAD_MIN_H,
                    maxHeight: $58ef1df1f5757bce$var$LEAD_MAX_H,
                    overflowY: 'auto',
                    background: (0, $jTCZr.C).card
                } : null,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.5rem',
                padding: '0.625rem 0.75rem',
                fontSize: '1rem',
                lineHeight: 1.75,
                fontFamily: 'inherit',
                color: (0, $jTCZr.C).textPrimary,
                ...lead ? null : {
                    background: (0, $jTCZr.CT).surface2
                },
                outline: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fcdf6086c22a8d18$export$2e2bcd8739ae039), {
            variant: "mobile",
            sectionKey: key,
            title: name,
            preview: preview,
            onAccept: ()=>refine.apply(key),
            onDismiss: ()=>refine.dismiss(key),
            onRerun: ()=>refine.refine([
                    key
                ]),
            busy: !!refine?.loading,
            style: {
                marginTop: '0.5rem'
            }
        }), key === 'p' && planBlockHint, key === 'p' && planPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.625rem'
            }
        }, planPanel)));
    }));
};
var $58ef1df1f5757bce$export$2e2bcd8739ae039 = $58ef1df1f5757bce$var$MobileVisitSoap;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");

var $huNwV = parcelRequire("huNwV");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $67dd26035226e4d8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 17v5",
            key: "bb1du9"
        }
    ],
    [
        "path",
        {
            d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
            key: "1nkz8b"
        }
    ]
];
const $67dd26035226e4d8$export$2e2bcd8739ae039 = (0, $9QBug.default)("pin", $67dd26035226e4d8$export$3efd853dbb351e94);


var $8g4t5 = parcelRequire("8g4t5");
var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $hZDga = parcelRequire("hZDga");

var $chm1L = parcelRequire("chm1L");

var $jTCZr = parcelRequire("jTCZr");
const $e031888e2d726c18$export$c606e0dfdc515248 = ({ label: label, style: style })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "ai-badge",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 11,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), label ?? t('visit.suggest.ai'));
};
const $e031888e2d726c18$export$491ebe8eaed97507 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            padding: '0.375rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), label ?? t('common.state.loadingEllipsis'));
};
const $e031888e2d726c18$export$b4c46f7bd56514c0 = ({ children: children, badge: badge, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, children), badge, action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto'
        }
    }, action));
const $e031888e2d726c18$export$4ca721b91274208a = (t)=>({
        high: {
            color: (0, $jTCZr.CT).dangerInk,
            bg: (0, $jTCZr.C).redLight,
            label: t('visit.severity.high')
        },
        medium: {
            color: (0, $jTCZr.CT).warnInk,
            bg: (0, $jTCZr.C).amberLight,
            label: t('credits.level.midShort')
        },
        low: {
            color: (0, $jTCZr.CT).goodInk,
            bg: (0, $jTCZr.C).greenLight,
            label: t('visit.severity.low')
        }
    });
const $e031888e2d726c18$export$d5e749cf0acf0b49 = (u)=>u === 'stat' ? (0, $jTCZr.CT).danger : u === 'urgent' ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).good;


var $jTCZr = parcelRequire("jTCZr");


var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $acw62 = parcelRequire("acw62");
// Single app-level status vocabulary.
//
// The framework token export (`statusColors`) owns the appointment-lifecycle and
// patient-record statuses. Three more vocabularies the doctor app needs — invoice
// *settlement*, order *urgency*, and order *lifecycle status* — are not in the
// framework yet, so they live here. Their colours are DERIVED from `statusColors`
// so there is exactly one hex source in the whole app; nothing re-hardcodes a
// status colour.
//
// When the framework adds these keys, delete the maps below and let everything
// fall through to `statusColors` — `StatusChip` will keep working.

var $jTCZr = parcelRequire("jTCZr");

const $fa15d8b4a746e70c$export$6994ca3c75ca1caa = {
    SETTLED: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'common.settlement.SETTLED'
    },
    PARTIALLY_PAID: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.settlement.PARTIALLY_PAID'
    },
    UNPAID: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.settlement.UNPAID'
    }
};
const $fa15d8b4a746e70c$export$7ae9bf836a83e0f0 = {
    routine: {
        ...(0, $jTCZr.statusColors).scheduled,
        labelKey: 'common.urgency.routine'
    },
    urgent: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.urgency.urgent'
    },
    stat: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.urgency.stat'
    }
};
const $fa15d8b4a746e70c$export$5f296182ef21a05b = {
    pending: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.orderStatus.pending'
    },
    in_progress: {
        ...(0, $jTCZr.statusColors).scheduled,
        labelKey: 'common.orderStatus.in_progress'
    },
    completed: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'common.orderStatus.completed'
    },
    cancelled: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.orderStatus.cancelled'
    }
};
const $fa15d8b4a746e70c$export$72f0d53c30dd261e = {
    [(0, $4a744c4def3d338a$export$effbc4db6100f5f7)]: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: (0, $4a744c4def3d338a$export$fbea400e1bd2969e)[0, $4a744c4def3d338a$export$effbc4db6100f5f7]
    },
    [(0, $4a744c4def3d338a$export$283afbef2b868970)]: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: (0, $4a744c4def3d338a$export$fbea400e1bd2969e)[0, $4a744c4def3d338a$export$283afbef2b868970]
    }
};
const $fa15d8b4a746e70c$export$dcac1cce4fca5347 = [
    'pending',
    'in_progress'
];
const $fa15d8b4a746e70c$export$a1b41aa6b5adf2fe = {
    scheduled: 'common.status.scheduled',
    arrived: 'common.status.arrived',
    in_visit: 'common.status.in_visit',
    completed: 'common.status.completed',
    cancelled: 'common.status.cancelled',
    // A booked patient who never arrived. scheduling's REOPENABLE_STATUSES sets
    // it, so the day list really can receive one; without a key it would fall
    // through to the framework's Persian «عدم حضور» in every language.
    no_show: 'common.status.no_show',
    // The patient asked; reception has not answered. Read-only on every doctor
    // surface — confirming a request is the desk's job, not the doctor's.
    requested: 'common.status.requested',
    rejected: 'common.status.rejected',
    waiting: 'common.status.waiting',
    visited: 'common.status.visited',
    inprogress: 'common.status.inprogress'
};
const $fa15d8b4a746e70c$export$e50006273435e7d4 = {
    ...(0, $jTCZr.statusColors),
    ...$fa15d8b4a746e70c$export$6994ca3c75ca1caa,
    ...$fa15d8b4a746e70c$export$7ae9bf836a83e0f0,
    ...$fa15d8b4a746e70c$export$72f0d53c30dd261e
};


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $547c752fb4c18299$export$2e2bcd8739ae039({ status: status, style: style, label: label }) {
    const { t: t, has: has } = (0, $LNQP4.default)();
    const cfg = (0, $fa15d8b4a746e70c$export$e50006273435e7d4)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    const key = cfg.labelKey || (0, $fa15d8b4a746e70c$export$a1b41aa6b5adf2fe)[status];
    const resolved = key && has(key) ? t(key) : cfg.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            whiteSpace: 'nowrap',
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, label ?? resolved);
}


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


function $5311b30cb4607f8a$export$914997c98d3577e5({ cond: cond, style: style, testid: testid }) {
    const type = (0, $4a744c4def3d338a$export$5d68a431913dd40b)(cond);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid || `dx-type-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
        status: type,
        style: {
            fontSize: 9.5,
            padding: '2px 7px',
            ...style
        }
    }));
}
// Framework tokens, not the Visit workspace's CSS variables.
//
// `Visit.web.jsx` injects the `:root` block that defines `--accent`, `--ink` and
// friends; `Visit.mobile.jsx` deliberately injects none of it. An unresolved
// custom property is not a fallback to something sensible — the declaration is
// dropped — so on the phone this gate rendered with no panel behind it at all,
// which is how a decision the doctor cannot skip ended up looking like body
// text. Nor is `var(--accent, …)` the fix: `--accent` also exists globally as
// the shadcn HSL triple, so the fallback never fires and the value that wins is
// not a colour. The `:root` block computes to these same token values, so the
// desktop surface is unchanged. See TemplateApplyButton.jsx for the long form.
const $5311b30cb4607f8a$var$PAL = {
    line: (0, $jTCZr.CT).border,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    accent: (0, $jTCZr.CT).accent,
    accentSoft: (0, $jTCZr.CT).accentSoft
};
function $5311b30cb4607f8a$export$7085d532b18268b({ current: current, onPick: onPick, onCancel: onCancel, busy: busy, title: title, testidPrefix: testidPrefix = 'dx-type-choice' }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testidPrefix,
        style: {
            marginTop: 8,
            padding: 9,
            borderRadius: 8,
            border: `1px solid ${$5311b30cb4607f8a$var$PAL.accent}`,
            background: $5311b30cb4607f8a$var$PAL.accentSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            fontWeight: 600,
            color: $5311b30cb4607f8a$var$PAL.ink,
            marginBottom: 2
        }
    }, title || t('visit.dx.type.pickTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: $5311b30cb4607f8a$var$PAL.ink2,
            marginBottom: 8
        }
    }, t('visit.dx.type.pickHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, (0, $4a744c4def3d338a$export$a2b1cf9e15bc836).map((type)=>{
        const cfg = (0, $fa15d8b4a746e70c$export$e50006273435e7d4)[type] || {};
        const isCurrent = current === type;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: type,
            type: "button",
            disabled: busy,
            "data-testid": `${testidPrefix}-${type}`,
            onClick: ()=>onPick(type),
            style: {
                flex: 1,
                minWidth: 96,
                padding: '6px 10px',
                borderRadius: 6,
                fontSize: 11.5,
                fontWeight: 600,
                fontFamily: 'inherit',
                background: cfg.bg,
                color: cfg.text,
                border: `1px solid ${isCurrent ? cfg.text : 'transparent'}`,
                cursor: busy ? 'default' : 'pointer',
                opacity: busy ? 0.6 : 1
            }
        }, t((0, $4a744c4def3d338a$export$fbea400e1bd2969e)[type]));
    }), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        disabled: busy,
        "data-testid": `${testidPrefix}-cancel`,
        onClick: onCancel,
        style: {
            padding: '6px 10px',
            borderRadius: 6,
            fontSize: 11.5,
            fontFamily: 'inherit',
            background: 'transparent',
            color: $5311b30cb4607f8a$var$PAL.ink2,
            border: `1px solid ${$5311b30cb4607f8a$var$PAL.line}`,
            cursor: busy ? 'default' : 'pointer'
        }
    }, t('common.actions.cancel'))));
}


// The AI differential-diagnosis list (§13.3: AI-labelled until the doctor owns
// it). Each item can be pinned as the primary diagnosis, accepted (→ offer to
// add to SOAP A), rejected, or opened to a per-diagnosis AI confirmation-question
// panel (بله/خیر findings → یادداشت SOAP). All mutations live in the screen; this
// component is render-only and raises intent through callbacks.
const $e7b4aced78aeee5a$var$CONF = (t)=>({
        high: {
            label: t('visit.vitals.high'),
            color: (0, $jTCZr.CT).good
        },
        medium: {
            label: t('credits.level.midShort'),
            color: (0, $jTCZr.CT).warn
        },
        low: {
            label: t('visit.vitals.low'),
            color: (0, $jTCZr.C).textMuted
        }
    });
// The inline AI confirmation-question panel for one diagnosis. Each question is
// answered once: tapping بله/خیر commits that finding to the SOAP «S» and — once
// the save lands — that question alone closes, collapsing to the line it wrote
// while the rest stay open to be worked through. A question whose save failed
// stays open with its choices live and says why.
const $e7b4aced78aeee5a$var$DiagAIPanel = ({ diag: diag, questions: questions, answers: answers, loading: loading, submitting: submitting = {}, errors: errors = {}, onAnswer: onAnswer, onReload: onReload })=>{
    const { t: t } = (0, $LNQP4.default)();
    const qs = questions || [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-diff-qbox-${diag.diagnosisCode}`,
        style: {
            marginTop: '0.5rem',
            padding: '0.75rem 0.8125rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$491ebe8eaed97507), {
        label: t('visit.copilot.preparingQuestions')
    }), !loading && qs.map((q)=>{
        const ans = answers?.[q.id];
        const yes = ans?.answer === 'yes';
        const no = ans?.answer === 'no';
        const answered = yes || no;
        const qKey = `${diag.diagnosisCode}:${q.id}`;
        const pending = submitting[qKey];
        const qError = errors[qKey];
        const locked = answered || !!pending;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: q.id,
            "data-testid": `visit-diff-q-${q.id}`,
            "data-state": answered ? 'answered' : 'open',
            style: {
                border: `1px solid ${answered ? yes ? (0, $jTCZr.soft)((0, $jTCZr.C).green, 0.6) : (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.6) : (0, $jTCZr.C).border}`,
                borderRadius: '0.5625rem',
                padding: '0.5625rem 0.6875rem',
                background: answered ? yes ? (0, $jTCZr.C).greenLight : (0, $jTCZr.C).amberLight : (0, $jTCZr.C).card
            }
        }, answered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: yes ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }, (0, $375f8776645d5aee$export$afbcfcdadda1b1bf)(q, ans.answer, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted
            }
        }, t('visit.state.recorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.6,
                marginBottom: q.hint ? '0.1875rem' : '0.4375rem'
            }
        }, q.question), q.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5,
                marginBottom: '0.4375rem'
            }
        }, q.hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            className: "min-h-11 gap-1.5",
            "data-testid": `visit-diff-q-yes-${q.id}`,
            disabled: locked,
            "aria-busy": pending === 'yes' || undefined,
            onClick: ()=>onAnswer(diag, q, 'yes')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), " ", pending === 'yes' ? t('common.state.saving') : t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            className: "min-h-11 gap-1.5",
            "data-testid": `visit-diff-q-no-${q.id}`,
            disabled: locked,
            "aria-busy": pending === 'no' || undefined,
            onClick: ()=>onAnswer(diag, q, 'no')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        }), " ", pending === 'no' ? t('common.state.saving') : t('common.actions.no')))), qError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visit-diff-q-error-${q.id}`,
            style: {
                marginTop: '0.4375rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).danger,
                lineHeight: 1.5
            }
        }, qError));
    }), !loading && qs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": `visit-diff-q-reload-${diag.diagnosisCode}`,
        onClick: ()=>onReload(diag),
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bF8pu.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.copilot.regenerateQuestions')));
};
const $e7b4aced78aeee5a$var$MobileVisitDifferential = ({ items: items, loading: loading, primaryCode: primaryCode, onSetPrimary: onSetPrimary, onAccept: onAccept, onReject: onReject, typePick: // «نوع تشخیص»: `typePick` is the diagnosisCode whose type is being chosen,
// `conditions` the patient's chart rows the recorded type is read back from.
// onAccept is (diagnosis, diagnosisType) — never called without a type.
typePick, onPickType: onPickType, typeBusy: typeBusy, conditions: conditions, confirmToA: confirmToA, onConfirmToA: onConfirmToA, onAddIcd: onAddIcd, visitStatus: visitStatus, openAIDiag: openAIDiag, onToggleAIDiag: onToggleAIDiag, aiQuestions: aiQuestions = {}, aiAnswers: aiAnswers = {}, aiLoading: aiLoading = {}, aiSubmitting: aiSubmitting = {}, aiErrors: aiErrors = {}, onAnswer: onAnswer, onReloadQuestions: onReloadQuestions, gate: gate, pollingActive: pollingActive, pollLabel: pollLabel, pollSeconds: pollSeconds, pollOverridden: pollOverridden, onTogglePolling: onTogglePolling })=>{
    const { t: t } = (0, $LNQP4.default)();
    const list = items || [];
    // A gated differential is not an empty one — see the panel below.
    const blocked = !!gate && !gate.ready && visitStatus === 'inprogress';
    const state = loading && !list.length ? 'loading' : !list.length ? 'empty' : 'content';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-differential-content",
        "data-state": state,
        "aria-busy": loading || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$b4c46f7bd56514c0), {
        badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$c606e0dfdc515248), {
            label: t('visit.copilot.fromVisitEvidence')
        })
    }, t('credits.price.differential')), blocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate",
        "data-missing": gate.missing.join(','),
        style: {
            margin: '0.5rem 0 0.625rem',
            padding: '0.75rem 0.8125rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
            marginBottom: '0.5625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 14,
        color: (0, $jTCZr.CT).accentInk,
        style: {
            flexShrink: 0,
            marginTop: '0.125rem'
        },
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.65
        }
    }, t('visit.copilot.diffGate.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-history",
        "data-state": "todo",
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.4375rem',
            fontSize: '0.75rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            marginTop: '0.4375rem',
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).accent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t(`visit.copilot.diffGate.${gate.missing.includes('historyThin') ? 'historyThin' : 'history'}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-hint",
        style: {
            marginTop: '0.4375rem',
            paddingTop: '0.4375rem',
            borderTop: `1px dashed ${(0, $jTCZr.C).border}`,
            fontSize: '0.6875rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.copilot.diffGate.monitoringHint'))), onTogglePolling && !blocked && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            margin: '0.5rem 0 0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: pollingActive ? 'default' : 'outline',
        size: "sm",
        className: "w-full min-h-11 justify-between gap-1.5",
        "data-testid": "visit-diff-poll-toggle",
        "data-poll-state": pollingActive ? 'on' : 'off',
        "data-poll-seconds": pollingActive ? String(pollSeconds) : undefined,
        "aria-pressed": !!pollingActive,
        "aria-label": pollingActive ? t('visit.copilot.pollDisable') : t('visit.copilot.pollEnable'),
        onClick: onTogglePolling
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: pollingActive ? '#fff' : (0, $jTCZr.C).textMuted,
            flexShrink: 0
        }
    }), t('visit.copilot.pollLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        },
        "data-testid": "visit-diff-poll-state"
    }, pollingActive ? pollLabel : t('visit.copilot.pollOff'))), pollOverridden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-poll-note",
        style: {
            marginTop: '0.3125rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, t('visit.copilot.pollVisitOnly'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$491ebe8eaed97507), {
        label: t('visit.copilot.updatingDx')
    }), confirmToA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            margin: '0.5rem 0 0.625rem',
            padding: '0.6875rem 0.875rem',
            background: (0, $jTCZr.CT).accentSoft,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            borderRadius: '0.625rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.soap.addToAssessment', {
        text: confirmToA.description
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "default",
        className: "min-h-11 shrink-0",
        "data-testid": "visit-diff-confirm-a-yes",
        onClick: ()=>onConfirmToA(true)
    }, t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "outline",
        className: "min-h-11 shrink-0",
        "data-testid": "visit-diff-confirm-a-no",
        onClick: ()=>onConfirmToA(false)
    }, t('common.actions.no'))), state === 'empty' && !loading && !blocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: visitStatus === 'inprogress' ? t('visit.copilot.processingDifferential') : t('visit.copilot.afterStart')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, list.map((d, i)=>{
        const isPrimary = primaryCode === d.diagnosisCode;
        const isAccepted = (0, $375f8776645d5aee$export$d20c1dcfc45ad42b)(d);
        const isRejected = d.status === 'rejected';
        const conf = $e7b4aced78aeee5a$var$CONF(t)[d.confidence];
        const isAIOpen = openAIDiag === d.diagnosisCode;
        const isTypePicking = typePick === d.diagnosisCode;
        // Read back from the chart, not from the differential item — the same
        // source the record sheet's badge uses, so they cannot disagree.
        const acceptedType = (0, $375f8776645d5aee$export$5b3196b6580e75eb)(conditions, d.diagnosisCode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: d.diagnosisCode || i,
            "data-testid": `visit-diff-row-${d.diagnosisCode || i}`,
            style: {
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.8125rem',
                border: `1px solid ${isPrimary ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                background: isPrimary ? `linear-gradient(180deg, ${(0, $jTCZr.CT).accentSoft}, ${(0, $jTCZr.C).card} 80%)` : (0, $jTCZr.C).card,
                opacity: isRejected ? 0.5 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.1875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, isPrimary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).accent,
                color: '#fff'
            }
        }, t('visit.dx.primaryShort')), isAccepted && (acceptedType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
            cond: {
                verificationStatus: acceptedType
            },
            testid: `visit-diff-type-badge-${d.diagnosisCode || i}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.C).greenLight,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('common.actions.confirm'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: isAccepted ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.C).textPrimary
            }
        }, d.description)), conf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: conf.color
            }
        }, conf.label)), d.diagnosisCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.375rem',
                fontFamily: 'ui-monospace, monospace'
            }
        }, d.diagnosisCode), d.supportingEvidence?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                margin: '0.3125rem 0 0.125rem'
            }
        }, d.supportingEvidence.slice(0, 2).map((e, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).good,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), e))), d.contradictingEvidence?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginBottom: '0.125rem'
            }
        }, d.contradictingEvidence.slice(0, 1).map((e, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).danger,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), e))), d.vitalSignImpact?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.375rem',
                paddingTop: '0.375rem',
                borderTop: `1px dashed ${(0, $jTCZr.C).border}`
            },
            "data-testid": `visit-diff-vital-impact-${d.diagnosisCode || i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 600,
                marginBottom: '0.25rem'
            }
        }, t('visit.copilot.vitalImpact.title')), d.vitalSignImpact.map((v, j)=>{
            const meta = (0, $375f8776645d5aee$export$739e6a3f924c37ce)(v.effect, t);
            const tone = {
                good: (0, $jTCZr.CT).good,
                danger: (0, $jTCZr.CT).danger,
                mute: (0, $jTCZr.C).textMuted
            }[meta.tone];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: tone,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, v.vital, v.value ? ` ${v.value}` : ''), v.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: tone,
                    fontWeight: 600
                }
            }, " \xb7 ", v.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.C).textMuted
                }
            }, " \xb7 ", meta.label), " \u2014 ", v.explanation));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isPrimary ? 'default' : 'outline',
            size: "sm",
            className: "flex-1 min-h-11 gap-1.5",
            "data-testid": `visit-diff-pin-${d.diagnosisCode || i}`,
            "aria-pressed": isPrimary,
            onClick: ()=>onSetPrimary(isPrimary ? null : d.diagnosisCode)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $67dd26035226e4d8$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }), isPrimary ? t('visit.dx.primary') : t('visit.dx.mark')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isAIOpen ? 'default' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": t('visit.copilot.confirmQuestions'),
            "aria-pressed": isAIOpen,
            "data-testid": `visit-diff-ai-${d.diagnosisCode || i}`,
            onClick: ()=>onToggleAIDiag(d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 14,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isAccepted ? 'default' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": isAccepted ? t('visit.dx.type.changeTitle') : t('visit.orders.approveAria', {
                name: d.description
            }),
            "aria-expanded": isTypePicking,
            "data-testid": `visit-diff-accept-${d.diagnosisCode || i}`,
            // Opens the «نوع تشخیص» choice — same gate as the desktop rail.
            onClick: ()=>onPickType(isTypePicking ? null : d.diagnosisCode)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 14,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isRejected ? 'destructive' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": t('visit.orders.rejectAria', {
                name: d.description
            }),
            "data-testid": `visit-diff-reject-${d.diagnosisCode || i}`,
            onClick: ()=>onReject(d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 14,
            "aria-hidden": true
        }))), isTypePicking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$7085d532b18268b), {
            testidPrefix: `visit-diff-type-${d.diagnosisCode || i}`,
            current: acceptedType,
            busy: typeBusy,
            title: isAccepted ? t('visit.dx.type.changeTitle') : undefined,
            onCancel: ()=>onPickType(null),
            onPick: (type)=>onAccept(d, type)
        }), isAIOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e7b4aced78aeee5a$var$DiagAIPanel, {
            diag: d,
            questions: aiQuestions[d.diagnosisCode],
            answers: aiAnswers[d.diagnosisCode],
            loading: aiLoading[d.diagnosisCode],
            submitting: aiSubmitting,
            errors: aiErrors,
            onAnswer: onAnswer,
            onReload: onReloadQuestions
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: onAddIcd,
        "data-testid": "visit-diff-add",
        className: "w-full min-h-11 mt-2 gap-1.5 border-dashed",
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.dx.addIcd11')));
};
var $e7b4aced78aeee5a$export$2e2bcd8739ae039 = $e7b4aced78aeee5a$var$MobileVisitDifferential;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $hZDga = parcelRequire("hZDga");
var $5JYPc = parcelRequire("5JYPc");

var $QG9Z3 = parcelRequire("QG9Z3");
var $97xXr = parcelRequire("97xXr");
var $aVx4q = parcelRequire("aVx4q");
var $bo0GS = parcelRequire("bo0GS");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");




var $jTCZr = parcelRequire("jTCZr");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");





var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $bkKUS = parcelRequire("bkKUS");
var $7phmx = parcelRequire("7phmx");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");
var $5JYPc = parcelRequire("5JYPc");

var $jTCZr = parcelRequire("jTCZr");

var $3FyOw = parcelRequire("3FyOw");
var $8g4t5 = parcelRequire("8g4t5");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c6c970ba75b9f5ae$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6c970ba75b9f5ae$export$2e2bcd8739ae039 = (0, $9QBug.default)("rotate-ccw", $c6c970ba75b9f5ae$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");





// ─────────────────────────────────────────────────────────────────────────────
// The form a drug is added to the نسخه through (PM-0059).
//
// A drug used to land on the نسخه the moment it was picked, with whatever the
// product implied, and a line the e-prescription would refuse was only flagged
// «ناقص» afterwards. Now picking a search result opens this form: the doctor
// settles WHICH product (شکل دارویی، قدرت — and the pack or brand where several
// share both), then its دوز، تناوب، نحوه مصرف and مقدار تحویلی. Those are
// required — «افزودن به نسخه» stays off, naming what is missing, until each
// holds a value the e-prescription codes (missingRxFields, the same rule the
// نسخه's «ناقص» chip reads). زمان مصرف and مدت are optional.
//
// Every field opens filled (rxAddDefaults, through `defaultsFor`), so the common
// case is one confirmation. The values are the closed lists of lib/rxOptions.js,
// shown as chips: what is picked here is exactly what a line's own editor offers.
//
// One component for the visit's desktop picker, its phone tab and the past-visit
// correction sheet — `touch` sizes it for a finger.
// ─────────────────────────────────────────────────────────────────────────────
// How many تناوب choices show before «بیشتر»: the ones written every day.
const $876230c716e4c6d3$var$COMMON_FREQUENCIES = 6;
// A دوز list longer than this is a dial (insulin's 60 units), not a row of chips.
const $876230c716e4c6d3$var$MAX_DOSE_CHIPS = 10;
const $876230c716e4c6d3$var$SIG_KEYS = [
    'dosage',
    'frequency',
    'route',
    'duration',
    'quantity',
    'instructions'
];
function $876230c716e4c6d3$export$2e2bcd8739ae039({ group: group, initialDrugId: initialDrugId, loadingProducts: loadingProducts = false, defaultsFor: defaultsFor, seed: seed, sourceLabel: sourceLabel, sourceKind: sourceKind, prescribedIds: prescribedIds, insurer: insurer, onAdd: onAdd, onCancel: onCancel, touch: touch = false }) {
    const { t: t, readsPersianData: readsPersianData, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const durations = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$74f6a832d246e098)(t), [
        t
    ]);
    // The offered sig is about the drug as it is taken, so it follows the doctor
    // to another strength or brand of the same شکل — the AI's «هر ۸ ساعت» used to
    // turn back into the product's default the moment قدرت was corrected. A change
    // of شکل starts from that product, and a dose goes along only where the
    // product has it.
    const seedFits = (0, $acw62.useCallback)((drug)=>{
        if (!seed?.drugId) return false;
        if (seed.drugId === drug.id) return true;
        const offered = (0, $1954c03f878fe45b$export$269cca928fe29b43)(group, seed.drugId);
        const now = (0, $1954c03f878fe45b$export$269cca928fe29b43)(group, drug.id);
        return !!offered && !!now && offered.drug.id === seed.drugId && now.drug.id === drug.id && (0, $1954c03f878fe45b$export$49bc12753c4ae83)(offered) === (0, $1954c03f878fe45b$export$49bc12753c4ae83)(now);
    }, [
        seed,
        group
    ]);
    const seedRow = (0, $acw62.useCallback)((drug)=>{
        const fromSeed = seedFits(drug) ? Object.fromEntries($876230c716e4c6d3$var$SIG_KEYS.filter((k)=>seed.defaults?.[k]).filter((k)=>k !== 'dosage' || seed.drugId === drug.id || (0, $ace44487380106d3$export$23fceca71987facd)(drug).includes(String(seed.defaults[k]))).map((k)=>[
                k,
                String(seed.defaults[k])
            ])) : {};
        return (0, $ace44487380106d3$export$8dbcc67e0ab5a150)({
            drug: drug,
            instructions: '',
            ...defaultsFor(drug),
            ...fromSeed
        }, {
            durations: durations
        });
    }, [
        defaultsFor,
        seed,
        seedFits,
        durations
    ]);
    const [drugId, setDrugId] = (0, $acw62.useState)(()=>(0, $1954c03f878fe45b$export$269cca928fe29b43)(group, initialDrugId)?.drug.id);
    const product = (0, $1954c03f878fe45b$export$269cca928fe29b43)(group, drugId);
    const drug = product?.drug;
    const [row, setRow] = (0, $acw62.useState)(()=>drug ? seedRow(drug) : null);
    // What the doctor set by hand — kept when they move to another product of the
    // same drug; everything else re-seeds from that product.
    const touched = (0, $acw62.useRef)(new Set());
    const [allFrequencies, setAllFrequencies] = (0, $acw62.useState)(false);
    const [allRoutes, setAllRoutes] = (0, $acw62.useState)(false);
    const submitRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        submitRef.current?.focus?.({
            preventScroll: true
        });
    }, []);
    const edit = (0, $acw62.useCallback)((key, val)=>{
        touched.current.add(key);
        setRow((r)=>{
            let next = (0, $ace44487380106d3$export$b0f426f8468d8007)(r, key, val, {
                durations: durations
            });
            // An emptied مقدار تحویلی goes back to the worked-out one.
            if (key === 'quantity' && !val) {
                const q = (0, $ace44487380106d3$export$d2b1f8f4188143eb)(next);
                if (q) next = {
                    ...next,
                    quantity: String(q)
                };
            }
            return next;
        });
    }, [
        durations
    ]);
    const openProduct = (0, $acw62.useCallback)((next)=>{
        if (!next || next.drug.id === drug?.id) return;
        setDrugId(next.drug.id);
        setRow((prev)=>{
            let r = seedRow(next.drug);
            for (const key of touched.current){
                if (key === 'dosage' && !(0, $ace44487380106d3$export$23fceca71987facd)(next.drug).includes(prev.dosage)) continue;
                r = (0, $ace44487380106d3$export$b0f426f8468d8007)(r, key, prev[key], {
                    durations: durations
                });
            }
            return r;
        });
    }, [
        drug,
        seedRow,
        durations
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        touched.current = new Set();
        setRow(seedRow(drug));
    }, [
        drug,
        seedRow
    ]);
    if (!product || !row) return null;
    // ── which product ──
    const formKey = (0, $1954c03f878fe45b$export$49bc12753c4ae83)(product);
    const forms = group.structured ? (0, $1954c03f878fe45b$export$c4e7c4d3b2f5c593)(group) : [];
    const strengths = group.structured ? (0, $1954c03f878fe45b$export$266cf92cac578c66)(group, formKey) : [];
    const variants = group.structured ? (0, $1954c03f878fe45b$export$b9c0747ef7361846)(group, formKey, product.strength) : [];
    const formOptions = (()=>{
        const worded = forms.map((f)=>{
            const parts = (0, $1954c03f878fe45b$export$2eb6d07f42ee42be)(f.form, f.route, t, t('visit.rx.form.unknownForm'));
            return {
                f: f,
                label: [
                    parts.label,
                    parts.detail
                ].filter(Boolean).join(" \xb7 ")
            };
        });
        // Two forms the reader's language words alike are told apart as the registry
        // writes them («INJECTION, SOLUTION» / «INJECTION, SUSPENSION»).
        const twice = new Set(worded.filter((a, i)=>worded.some((b, j)=>i !== j && a.label === b.label)).map((w)=>w.label));
        return worded.map(({ f: f, label: label })=>({
                value: f.key,
                label: twice.has(label) && f.form ? `${label} (${f.form.toLowerCase()})` : label,
                title: [
                    f.form,
                    f.route
                ].filter(Boolean).join(' ')
            }));
    })();
    const pickForm = (key)=>{
        if (!key) return;
        const own = (0, $1954c03f878fe45b$export$266cf92cac578c66)(group, key);
        const strength = own.includes(product.strength) ? product.strength : own[0];
        openProduct((0, $1954c03f878fe45b$export$b9c0747ef7361846)(group, key, strength)[0]);
    };
    const pickStrength = (s)=>{
        if (s !== '' || strengths.includes('')) openProduct((0, $1954c03f878fe45b$export$b9c0747ef7361846)(group, formKey, s)[0]);
    };
    const pickVariant = (id)=>{
        if (id) openProduct(variants.find((p)=>p.drug.id === id));
    };
    // ── its sig ──
    const doseOptions = (0, $ace44487380106d3$export$23fceca71987facd)(drug, row.dosage);
    const frequencyOptions = (()=>{
        const all = (0, $ace44487380106d3$export$93a11165d6a55361).includes(row.frequency) || !row.frequency ? (0, $ace44487380106d3$export$93a11165d6a55361) : [
            row.frequency,
            ...(0, $ace44487380106d3$export$93a11165d6a55361)
        ];
        if (allFrequencies) return all;
        const common = all.slice(0, $876230c716e4c6d3$var$COMMON_FREQUENCIES);
        return row.frequency && !common.includes(row.frequency) ? [
            ...common,
            row.frequency
        ] : common;
    })();
    const routeOptions = allRoutes || !row.route ? row.route && !(0, $ace44487380106d3$export$4e844baf4fb2f82b).includes(row.route) ? [
        row.route,
        ...(0, $ace44487380106d3$export$4e844baf4fb2f82b)
    ] : (0, $ace44487380106d3$export$4e844baf4fb2f82b) : [
        row.route
    ];
    const whenOptions = [
        t('visit.rx.instructionPresets.beforeMeal'),
        t('visit.rx.instructionPresets.withFood'),
        t('visit.rx.instructionPresets.afterMeal')
    ];
    const auto = (0, $ace44487380106d3$export$d2b1f8f4188143eb)(row);
    const quantityIsAuto = !!auto && (0, $ace44487380106d3$export$48f972f5effb9c)(row.quantity) === auto;
    const missing = (0, $ace44487380106d3$export$e9b4e5de48a21156)(row);
    const already = !!prescribedIds?.has?.(drug.id);
    const blocked = missing.length > 0 || already;
    const submit = ()=>{
        if (blocked) return;
        onAdd(drug, Object.fromEntries($876230c716e4c6d3$var$SIG_KEYS.map((k)=>[
                k,
                row[k] || ''
            ])));
    };
    const names = (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(drug);
    // The line as it will read on the نسخه — its count named, since a bare number
    // at the end of a sentence says nothing.
    const summary = [
        (0, $375f8776645d5aee$export$41198ed546152d40)({
            ...row,
            quantity: ''
        }, t, readsPersianData),
        row.quantity && `${t('visit.rx.quantity')} ${formatNumber((0, $ace44487380106d3$export$48f972f5effb9c)(row.quantity))}`,
        row.instructions
    ].filter(Boolean).join(" \xb7 ");
    const toggle = (open, set, testid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "link",
            size: "sm",
            onClick: ()=>set(!open),
            "data-testid": testid,
            className: touch ? 'min-h-11 px-2' : 'h-[34px] px-2'
        }, open ? t('visit.rx.form.less') : t('visit.rx.form.more'));
    const optional = (label)=>`${label} (${t('visit.rx.form.optional')})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": t('visit.rx.form.title'),
        "data-testid": "visit-rx-form",
        "data-drug-id": drug.id,
        "data-state": blocked ? 'incomplete' : 'ready',
        onKeyDown: (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onCancel?.();
            }
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                submit();
            }
        },
        style: {
            border: `1.5px solid ${(0, $jTCZr.C).navy}`,
            borderRadius: 10,
            background: (0, $jTCZr.CT).surface,
            padding: touch ? '0.75rem' : 14,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "visit-rx-form-name",
        style: {
            fontSize: touch ? '0.9375rem' : 14,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            overflowWrap: 'anywhere'
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: touch ? '0.75rem' : 11.5,
            color: (0, $jTCZr.CT).ink2,
            overflowWrap: 'anywhere'
        }
    }, names.secondary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
        drug: drug,
        insurer: insurer,
        both: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        onClick: reset,
        "data-testid": "visit-rx-form-reset",
        className: touch ? 'min-h-11 gap-1 shrink-0' : 'gap-1 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.rx.form.reset')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: onCancel,
        "aria-label": t('common.actions.close'),
        "data-testid": "visit-rx-form-close",
        className: touch ? 'h-11 w-11 shrink-0' : 'h-8 w-8 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 15,
        "aria-hidden": true
    }))), sourceLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-form-source",
        "data-kind": sourceKind || 'document',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: touch ? '0.75rem' : 11.5,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk
        }
    }, sourceKind === 'ai' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 13,
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 13,
        "aria-hidden": true
    }), " ", sourceLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-form-summary",
        style: {
            background: (0, $jTCZr.CT).surface2,
            borderRadius: 8,
            padding: '8px 10px',
            fontSize: touch ? '0.8125rem' : 12.5,
            color: (0, $jTCZr.CT).ink,
            lineHeight: 1.7
        }
    }, summary || t('visit.rx.needsDosing')), group.structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.dosageForm'),
        required: true,
        touch: touch,
        value: formKey,
        onChange: pickForm,
        options: formOptions,
        testId: "visit-rx-form-dosageForm"
    }, loadingProducts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rx-form-loading",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 11.5,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.rx.form.loadingProducts'))), strengths.some(Boolean) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.strength'),
        required: true,
        touch: touch,
        value: product.strength,
        onChange: pickStrength,
        options: strengths.map((s)=>({
                value: s,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                    dir: "ltr"
                }, s || "\u2014")
            })),
        testId: "visit-rx-form-strength"
    }), variants.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.product'),
        required: true,
        touch: touch,
        value: drug.id,
        onChange: pickVariant,
        options: variants.map((p)=>({
                value: p.drug.id,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                    dir: "ltr"
                }, (0, $1954c03f878fe45b$export$c877a6c4e166c3c6)(p) || t('visit.rx.form.generic')),
                title: (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(p.drug).primary
            })),
        testId: "visit-rx-form-product"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
            paddingTop: 10,
            fontSize: touch ? '0.8125rem' : 12.5,
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk
        }
    }, t('visit.rx.form.sig')), doseOptions.length > $876230c716e4c6d3$var$MAX_DOSE_CHIPS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.rx.dose'),
        required: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: row.dosage || '',
        onChange: (e)=>edit('dosage', e.target.value),
        "data-testid": "visit-rx-form-dosage",
        style: {
            minHeight: touch ? '2.75rem' : 34,
            maxWidth: 220,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: 8,
            padding: '0 10px',
            fontFamily: 'inherit',
            fontSize: touch ? '1rem' : 12.5,
            color: (0, $jTCZr.CT).ink,
            background: (0, $jTCZr.CT).surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.dose')), doseOptions.map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: d,
            value: d
        }, (0, $375f8776645d5aee$export$a6616cb9d478340f)(d, readsPersianData, t))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.dose'),
        required: true,
        touch: touch,
        value: row.dosage,
        onChange: (v)=>edit('dosage', v),
        options: doseOptions.map((d)=>({
                value: d,
                label: (0, $375f8776645d5aee$export$a6616cb9d478340f)(d, readsPersianData, t)
            })),
        testId: "visit-rx-form-dosage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.frequency'),
        required: true,
        touch: touch,
        value: row.frequency,
        onChange: (v)=>edit('frequency', v),
        options: frequencyOptions.map((f)=>({
                value: f,
                label: (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(f, t)
            })),
        testId: "visit-rx-form-frequency"
    }, toggle(allFrequencies, setAllFrequencies, 'visit-rx-form-frequency-more')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.route'),
        required: true,
        touch: touch,
        value: row.route,
        onChange: (v)=>edit('route', v),
        options: routeOptions.map((r)=>({
                value: r,
                label: (0, $ace44487380106d3$export$80ace2b99405d272)(r, t)
            })),
        testId: "visit-rx-form-route"
    }, row.route ? toggle(allRoutes, setAllRoutes, 'visit-rx-form-route-more') : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: optional(t('visit.rx.form.when')),
        touch: touch,
        value: whenOptions.includes(row.instructions) ? row.instructions : '',
        onChange: (v)=>edit('instructions', v),
        options: whenOptions.map((w)=>({
                value: w,
                label: w
            })),
        testId: "visit-rx-form-when"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: optional(t('visit.rx.duration')),
        touch: touch,
        value: row.duration,
        onChange: (v)=>edit('duration', v),
        options: (row.duration && !durations.includes(row.duration) ? [
            row.duration,
            ...durations
        ] : durations).map((d)=>({
                value: d,
                label: d
            })),
        testId: "visit-rx-form-duration"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.rx.quantity'),
        required: true,
        value: row.quantity || '',
        onChange: (e)=>edit('quantity', (0, $5JYPc.toEnDigits)(e?.target ? e.target.value : String(e ?? '')).replace(/[^\d]/g, '')),
        inputMode: "numeric",
        dir: "ltr",
        helperText: quantityIsAuto ? t('visit.rx.form.auto') : undefined,
        "data-testid": "visit-rx-form-quantity",
        "data-auto": quantityIsAuto || undefined,
        style: {
            width: touch ? '100%' : 200
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.rx.instructionsOptional'),
        value: row.instructions || '',
        onChange: (e)=>edit('instructions', e?.target ? e.target.value : String(e ?? '')),
        placeholder: t('visit.rx.instructionsPlaceholder'),
        dir: "auto",
        "data-testid": "visit-rx-form-instructions",
        style: {
            flex: 1,
            minWidth: touch ? '100%' : 200
        }
    })), (missing.length > 0 || already) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-rx-form-missing",
        "data-missing": missing.join(' '),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            fontSize: touch ? '0.8125rem' : 12,
            fontWeight: 600,
            lineHeight: 1.6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, already ? t('visit.rx.form.alreadyOn') : t('visit.rx.form.missing', {
        fields: (0, $ace44487380106d3$export$a1043144d576f6b6)(missing, t)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: submitRef,
        type: "button",
        onClick: submit,
        disabled: blocked,
        "data-testid": "visit-rx-form-submit",
        className: touch ? 'flex-1 min-h-11 gap-1.5' : 'flex-1 gap-1.5'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.form.submit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        onClick: onCancel,
        "data-testid": "visit-rx-form-cancel",
        className: touch ? 'min-h-11' : undefined
    }, t('common.actions.cancel'))));
}


// ─────────────────────────────────────────────────────────────────────────────
// «افزودن دارو» — the one way a drug is found for the نسخه (PM-0043, PM-0059).
//
// Nothing is listed until the doctor searches. The picker used to open on the
// first page of the formulary, a category rail and the doctor's frequent drugs;
// all three are gone — a drug appears only as a search result. Results are the
// DRUGS the matching products belong to (lib/drugProducts.js), one row each, and
// picking one opens the add form (RxAddForm) where its شکل، قدرت and sig are
// completed. Nothing reaches the نسخه except through that form's «افزودن به نسخه».
//
// One component for the desktop visit, the phone visit and the past-visit
// correction sheet. `testIdPrefix` keeps each surface's own ids.
// ─────────────────────────────────────────────────────────────────────────────
const $fadae58d6c7ed04a$var$DEBOUNCE_MS = 300;
// How far the other products of a drug are read when its form opens: the page
// that found it plus this many more of the same ingredient.
const $fadae58d6c7ed04a$var$SIBLING_PAGES = 5;
// The search that finds a drug's own products: its name without the salt.
const $fadae58d6c7ed04a$var$siblingQuery = (ingredient)=>String(ingredient || '').replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').trim();
function $fadae58d6c7ed04a$export$2e2bcd8739ae039({ defaultsFor: defaultsFor, prescribedIds: prescribedIds, onAdd: onAdd, request: request = null, onRequestDone: onRequestDone, searchRequest: searchRequest = null, touch: touch = false, testIdPrefix: testIdPrefix = 'visit-rx', inputId: inputId, showKeys: showKeys = false, insurer: insurer }) {
    const { t: t } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)({
        state: 'idle',
        drugs: [],
        total: 0
    });
    const [moreLoading, setMoreLoading] = (0, $acw62.useState)(false);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    const [adding, setAdding] = (0, $acw62.useState)(null);
    const inputRef = (0, $acw62.useRef)(null);
    const live = (0, $acw62.useRef)(0);
    // ── the search: nothing until two letters, then a debounced server page ──
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        const mine = ++live.current;
        if (q.length < (0, $375f8776645d5aee$export$e72eedeb22c02c24)) {
            setSearch({
                state: q ? 'short' : 'idle',
                drugs: [],
                total: 0
            });
            return undefined;
        }
        setSearch((s)=>({
                ...s,
                state: 'loading'
            }));
        const h = setTimeout(()=>{
            (0, $375f8776645d5aee$export$66192a3e729ccb0d)({
                query: q
            }).then(({ drugs: drugs, total: total })=>{
                if (mine === live.current) setSearch({
                    state: 'ready',
                    drugs: drugs || [],
                    total: total || 0
                });
            }).catch((err)=>{
                if (mine !== live.current) return;
                console.error('[rx] listDrugs failed:', err);
                setSearch({
                    state: 'error',
                    drugs: [],
                    total: 0
                });
            });
        }, $fadae58d6c7ed04a$var$DEBOUNCE_MS);
        return ()=>clearTimeout(h);
    }, [
        query,
        attempt
    ]);
    const loadMore = (0, $acw62.useCallback)(()=>{
        const q = query.trim();
        const mine = live.current;
        setMoreLoading(true);
        (0, $375f8776645d5aee$export$66192a3e729ccb0d)({
            query: q,
            offset: search.drugs.length
        }).then(({ drugs: drugs, total: total })=>{
            if (mine !== live.current) return;
            setSearch((s)=>({
                    ...s,
                    drugs: [
                        ...s.drugs,
                        ...drugs || []
                    ],
                    total: total || s.total
                }));
        }).catch((err)=>console.error('[rx] listDrugs (more) failed:', err)).finally(()=>setMoreLoading(false));
    }, [
        query,
        search.drugs.length
    ]);
    const groups = (0, $acw62.useMemo)(()=>(0, $1954c03f878fe45b$export$cbf1162dc7529312)(search.drugs), [
        search.drugs
    ]);
    // ── opening a drug's form, and reading its other products behind it ──
    const openSeq = (0, $acw62.useRef)(0);
    const open = (0, $acw62.useCallback)((group, drugId, extra = {})=>{
        const mine = ++openSeq.current;
        setAdding({
            group: group,
            drugId: drugId || group.products[0].drug.id,
            loading: !!group.structured,
            ...extra
        });
        if (!group.structured) return;
        const q = $fadae58d6c7ed04a$var$siblingQuery(group.ingredient);
        if (q.length < (0, $375f8776645d5aee$export$e72eedeb22c02c24)) {
            setAdding((a)=>a ? {
                    ...a,
                    loading: false
                } : a);
            return;
        }
        (async ()=>{
            let merged = group;
            try {
                for(let page = 0; page < $fadae58d6c7ed04a$var$SIBLING_PAGES; page += 1){
                    // eslint-disable-next-line no-await-in-loop
                    const { drugs: drugs, total: total } = await (0, $375f8776645d5aee$export$66192a3e729ccb0d)({
                        query: q,
                        offset: page * (0, $375f8776645d5aee$export$68595c7f7403ce8d)
                    });
                    if (mine !== openSeq.current) return;
                    merged = (0, $1954c03f878fe45b$export$9148a864884cb04b)(merged, drugs);
                    const next = merged;
                    setAdding((a)=>a && a.group.key === next.key ? {
                            ...a,
                            group: next
                        } : a);
                    if (!drugs?.length || (page + 1) * (0, $375f8776645d5aee$export$68595c7f7403ce8d) >= (total || 0)) break;
                }
            } catch (err) {
                // The form still works on the products the search already found.
                console.warn('[rx] other products of the drug could not be read:', err?.message);
            }
            if (mine === openSeq.current) setAdding((a)=>a ? {
                    ...a,
                    loading: false
                } : a);
        })();
    }, []);
    const addingRef = (0, $acw62.useRef)(null);
    addingRef.current = adding;
    const close = (0, $acw62.useCallback)((added = false)=>{
        openSeq.current += 1;
        const was = addingRef.current;
        setAdding(null);
        if (was?.request) onRequestDone?.(was.request, added);
    }, [
        onRequestDone
    ]);
    // A drug offered from outside opens its form, prefilled with what came with it.
    const requestKey = request?.key ?? request?.drug?.id ?? null;
    (0, $acw62.useEffect)(()=>{
        if (!request?.drug?.id) return;
        const [group] = (0, $1954c03f878fe45b$export$cbf1162dc7529312)([
            request.drug
        ]);
        open(group, request.drug.id, {
            request: request,
            seed: {
                drugId: request.drug.id,
                defaults: request.defaults || {}
            },
            sourceLabel: request.sourceLabel,
            sourceKind: request.sourceKind
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestKey
    ]);
    // A search asked for from outside (an AI proposal the list did not settle).
    const searchNonce = searchRequest?.nonce;
    (0, $acw62.useEffect)(()=>{
        if (searchNonce === undefined) return;
        close();
        setQuery(searchRequest.query || '');
        inputRef.current?.focus?.({
            preventScroll: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchNonce
    ]);
    const submit = (drug, sig)=>{
        const req = adding?.request || null;
        onAdd(drug, sig, req);
        close(true);
        setQuery('');
        // Back to the search for the next drug — on a workstation. On a phone a
        // focused input RAISES THE KEYBOARD, which covered the line just added
        // and scrolled the list under the sticky strip (PM-0113); there the next
        // drug starts with a tap on the search, as every other field does.
        if (!touch) inputRef.current?.focus?.({
            preventScroll: true
        });
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            if (search.state === 'ready' && groups.length) open(groups[0]);
            e.preventDefault();
        } else if (e.key === 'Escape' && query) {
            setQuery('');
            e.stopPropagation();
        }
    };
    const p = testIdPrefix;
    const formLabel = (form, route)=>{
        const parts = (0, $1954c03f878fe45b$export$2eb6d07f42ee42be)(form, route, t, '');
        return [
            parts.label,
            parts.detail
        ].filter(Boolean).join(' ');
    };
    const fs = (desk, phone)=>touch ? phone : desk;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${query || adding ? (0, $jTCZr.C).navy : (0, $jTCZr.CT).border}`,
            borderRadius: 10,
            padding: touch ? '0 0.75rem' : '0 10px',
            minHeight: touch ? '2.75rem' : 36
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: touch ? 16 : 14,
        color: (0, $jTCZr.CT).ink2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        id: inputId,
        value: query,
        onChange: (e)=>{
            if (adding && !adding.request) close();
            setQuery(e.target.value);
        },
        onKeyDown: onKeyDown,
        placeholder: t('visit.rx.searchDrug'),
        "aria-label": t('visit.rx.searchDrug'),
        autoComplete: "off",
        "data-testid": `${p}-search`,
        style: {
            flex: 1,
            minWidth: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: fs(13, '1rem'),
            color: (0, $jTCZr.CT).ink,
            minHeight: touch ? '2.625rem' : 34
        }
    }), search.state === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), query && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>{
            setQuery('');
            inputRef.current?.focus?.();
        },
        "aria-label": t('common.actions.clearSearch'),
        "data-testid": `${p}-search-clear`,
        className: touch ? 'h-11 w-11 shrink-0' : 'h-7 w-7 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }))), adding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $876230c716e4c6d3$export$2e2bcd8739ae039), {
        key: `${adding.group.key}:${adding.request?.key ?? ''}`,
        group: adding.group,
        initialDrugId: adding.drugId,
        loadingProducts: adding.loading,
        defaultsFor: defaultsFor,
        seed: adding.seed,
        sourceLabel: adding.sourceLabel,
        sourceKind: adding.sourceKind,
        prescribedIds: prescribedIds,
        insurer: insurer,
        onAdd: submit,
        onCancel: ()=>close(false),
        touch: touch
    }) : search.state === 'idle' ? // One quiet line, not an empty state of its own: the نسخه below already
    // has one («دارویی ثبت نشده»), and two pictures of a pill say nothing twice.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-idle`,
        "data-state": "idle",
        style: {
            fontSize: fs(11.5, '0.75rem'),
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.rx.form.searchTitle')), " \u2014 ", t('visit.rx.form.searchBody')) : search.state === 'short' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-short`,
        style: {
            fontSize: fs(11.5, '0.75rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.keepTyping')) : search.state === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-error`,
        "data-state": "error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        color: (0, $jTCZr.CT).dangerInk,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: fs(12, '0.8125rem'),
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('errors.load.drugs')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "subtle",
        size: "sm",
        onClick: ()=>setAttempt((n)=>n + 1),
        "data-testid": `${p}-search-retry`,
        className: touch ? 'min-h-11 shrink-0' : 'shrink-0'
    }, t('common.actions.retry'))) : search.state === 'ready' && groups.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-no-results`,
        "data-state": "no-results",
        style: {
            padding: touch ? '0.875rem' : 12,
            textAlign: 'center',
            fontSize: fs(12, '0.8125rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('errors.empty.drugs')) : groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-results`,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: fs(11, '0.6875rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.form.results', {
        count: groups.length,
        query: query.trim()
    })), groups.map((g, i)=>{
        const first = g.products[0].drug;
        const names = g.structured ? {
            primary: g.ingredient,
            secondary: (0, $1954c03f878fe45b$export$421cf268395c9223)(g, formLabel)
        } : (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(first);
        const allOn = g.products.every((x)=>prescribedIds?.has?.(x.drug.id));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: g.key,
            type: "button",
            variant: "outline",
            onClick: ()=>open(g),
            "data-testid": `${p}-result-${first.id}`,
            "data-first": i === 0 || undefined,
            className: `w-full h-auto justify-start text-start gap-2 px-3 py-2 ${touch ? 'min-h-11' : ''}`,
            style: i === 0 ? {
                borderColor: (0, $jTCZr.C).navy
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: fs(13, '0.875rem'),
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: fs(11.5, '0.75rem'),
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
            drug: first,
            insurer: insurer,
            both: true,
            size: fs(10.5, '0.6875rem'),
            listed: (0, $ace44487380106d3$export$6c8fe862de8e39ae)(g.products.map((x)=>x.drug), insurer),
            testid: `${p}-result-coverage-${first.id}`
        }), allOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: fs(10.5, '0.6875rem'),
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk,
                whiteSpace: 'nowrap'
            }
        }, t('visit.rx.frequent.added')), g.products.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: fs(11, '0.6875rem'),
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'nowrap'
            }
        }, t('visit.rx.form.productsCount', {
            count: g.products.length
        })));
    }), search.total > search.drugs.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-more-results`,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, moreLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "link",
        size: "sm",
        onClick: loadMore,
        className: touch ? 'min-h-11' : undefined
    }, t('visit.rx.moreResults', {
        shown: search.drugs.length,
        total: search.total
    }))), showKeys && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.form.keys'))) : null);
}


// `labelFor` translates the option TEXT only; the option's value — and so what
// onChange writes to the record — stays the stored Persian. A frequency saved
// from this dropdown is byte-identical to one saved before, in every locale.
// The route choices: the fixed values, with a stored value that names none of
// them kept on top — it must still show what it says until the doctor replaces it.
const $3d5dc5a5bf298474$var$withRoute = (route)=>route && !(0, $ace44487380106d3$export$1aea987f77fa496a)(route) ? [
        route,
        ...(0, $375f8776645d5aee$export$e730a0734bbb1219)()
    ] : (0, $375f8776645d5aee$export$e730a0734bbb1219)();
const $3d5dc5a5bf298474$var$Select = ({ value: value, onChange: onChange, options: options, placeholder: placeholder, testId: testId, labelFor: labelFor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: value || '',
        onChange: onChange,
        "data-testid": testId,
        style: {
            minWidth: 0,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.375rem',
            padding: '0.375rem 0.5rem',
            fontSize: '1rem',
            minHeight: '2.75rem',
            fontFamily: 'inherit',
            color: value ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.C).card,
            outline: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), (options || []).map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o,
            value: o
        }, labelFor ? labelFor(o) : o)));
const $3d5dc5a5bf298474$var$MobileVisitRx = ({ rxItems: rxItems, onAdd: onAdd, onRemove: onRemove, onUpdate: onUpdate, interactions: interactions, interactionLoading: interactionLoading, interactionError: interactionError, interactionStale: interactionStale, onCheckInteractions: onCheckInteractions, canCheckInteractions: canCheckInteractions, assist: // The نسخه's AI helper (docs/VISIT_RX_AI_ASSIST.md): «پیشنهاد دارو» proposes
// from the note — { busySource, onHistory, canHistory }. Reading «پایش بالینی»
// is the visit-wide «تکمیل» in the pinned strip, which covers the نسخه like
// every other section; the section's own copy of that button is gone
// (PM-0110 item 2). «ثبت صوتی دارو» was removed (PM-0024).
assist, proposal: proposal = null, templateButton: // «قالب نسخه»: the screen's TemplateApplyButton, placed here beside «پیشنهاد
// دارو» in one row under the search (PM-0110 item 3) rather than as a
// full-width band above the tab.
templateButton = null, documentDrafts: // Drugs offered to this visit from outside — a document review («افزودن به
// نسخه ویزیت», DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §23.3 A13) or
// an approved AI proposal (a draft carrying its own `sourceLabel`/`sourceKind`):
// each opens the add form prefilled with its sig, one at a time, and reaches the
// نسخه only by that form's «افزودن به نسخه» — as the product the form ended on.
// «انصراف» drops it.
documentDrafts = [], onConfirmDocumentDraft: onConfirmDocumentDraft, onDiscardDocumentDraft: onDiscardDocumentDraft, defaultsFor: // The sig a product opens the add form with; the product's own when not given.
defaultsFor, insurer: // The patient's basic insurer (rxOptions insurerKeyOf): «در فهرست تأمین» on the
// search results and the add form, as on the desktop.
insurer = null })=>{
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const startWith = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>defaultsFor || ((drug)=>(0, $ace44487380106d3$export$87bc9af39161d883)(drug, null, {
                defaultDuration: t('visit.duration.d7')
            })), [
        defaultsFor,
        t
    ]);
    const prescribed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    const draft = documentDrafts[0] || null;
    const draftRequest = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>draft ? {
            key: draft.key,
            drug: draft.drug,
            defaults: (0, $ace44487380106d3$export$2e037991db2fc726)(draft.drug, draft.defaults, {
                durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
            }),
            sourceLabel: draft.sourceLabel || t('visit.rx.documentDraft.title'),
            sourceKind: draft.sourceKind,
            draft: draft
        } : null, [
        draft,
        t
    ]);
    const warnings = interactions?.warnings || [];
    const hasIx = !!interactions?.hasInteractions;
    const groups = (0, $375f8776645d5aee$export$2ba0e4a723757c09)(warnings);
    const top = (0, $375f8776645d5aee$export$9ad745a931ba51ed)(warnings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-content",
        "data-state": rxItems.length ? 'content' : 'empty'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadae58d6c7ed04a$export$2e2bcd8739ae039), {
        touch: true,
        defaultsFor: startWith,
        prescribedIds: prescribed,
        onAdd: (drug, sig, req)=>req?.draft ? onConfirmDocumentDraft?.(req.draft, sig, drug) : onAdd(drug, sig),
        request: draftRequest,
        onRequestDone: (req, added)=>{
            if (!added) onDiscardDocumentDraft?.(req.draft);
        },
        insurer: insurer
    })), (templateButton || assist || hasIx && !interactionStale && top !== 'low') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ai-actions",
        style: {
            display: 'flex',
            alignItems: 'stretch',
            gap: '0.375rem',
            marginBottom: '0.625rem'
        }
    }, templateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex'
        }
    }, templateButton), assist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: assist.onHistory,
        disabled: !assist.canHistory || assist.busySource === 'HISTORY',
        "data-testid": "visit-rx-ai-suggest",
        className: "min-h-11 flex-1 gap-1.5 px-2",
        style: {
            fontSize: '0.75rem'
        }
    }, assist.busySource === 'HISTORY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 15,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), t('visit.rxAssist.history')), hasIx && !interactionStale && top !== 'low' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rx-ix-chip",
        "data-severity": top,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
            gap: '0.25rem',
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: top === 'high' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
            color: top === 'high' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 11,
        "aria-hidden": true
    }), top === 'high' ? t('visit.rx.ixHighChip') : t('visit.rx.ixMediumChip'))), proposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, proposal), rxItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.rx.noneRecorded')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, rxItems.map((item)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.id,
            "data-testid": `visit-rx-row-${item.id}`,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '2.375rem',
                height: '2.375rem',
                borderRadius: '0.625rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 17,
            color: (0, $jTCZr.C).navy,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(item.drug).primary), (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(item.drug).secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(item.drug).secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('visit.rx.removeAria', {
                name: (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug)
            }),
            "data-testid": `visit-rx-remove-${item.id}`,
            onClick: ()=>onRemove(item.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.dosage,
            onChange: (e)=>onUpdate(item.id, 'dosage', e.target.value),
            options: (0, $ace44487380106d3$export$23fceca71987facd)(item.drug, item.dosage),
            placeholder: t('visit.rx.dose'),
            testId: `visit-rx-dosage-${item.id}`,
            labelFor: (v)=>(0, $375f8776645d5aee$export$a6616cb9d478340f)(v, readsPersianData, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.frequency,
            onChange: (e)=>onUpdate(item.id, 'frequency', e.target.value),
            options: (0, $ace44487380106d3$export$ac4b3f6873c02e40)(item.frequency),
            placeholder: t('visit.rx.timesPerDay'),
            testId: `visit-rx-freq-${item.id}`,
            labelFor: (v)=>(0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(v, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.duration,
            onChange: (e)=>onUpdate(item.id, 'duration', e.target.value),
            options: (0, $375f8776645d5aee$export$74f6a832d246e098)(t),
            placeholder: t('visit.rx.duration'),
            testId: `visit-rx-dur-${item.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
                gap: '0.375rem',
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: (0, $ace44487380106d3$export$1aea987f77fa496a)(item.route) || item.route,
            onChange: (e)=>onUpdate(item.id, 'route', e.target.value),
            options: $3d5dc5a5bf298474$var$withRoute(item.route),
            placeholder: t('visit.rx.route'),
            testId: `visit-rx-route-${item.id}`,
            labelFor: (v)=>(0, $ace44487380106d3$export$80ace2b99405d272)(v, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            inputMode: "numeric",
            value: item.quantity || '',
            onChange: (e)=>onUpdate(item.id, 'quantity', (0, $5JYPc.toEnDigits)(e.target.value).replace(/[^\d]/g, '')),
            placeholder: t('visit.rx.quantity'),
            "aria-label": t('visit.rx.quantity'),
            "data-testid": `visit-rx-qty-${item.id}`,
            style: {
                minWidth: 0,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.375rem',
                padding: '0.375rem 0.5rem',
                fontSize: '1rem',
                minHeight: '2.75rem',
                fontFamily: 'inherit',
                color: (0, $jTCZr.C).textPrimary,
                background: (0, $jTCZr.C).card,
                outline: 'none'
            }
        })), (0, $ace44487380106d3$export$e9b4e5de48a21156)(item).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-rx-incomplete-${item.id}`,
            title: t('visit.rx.incompleteHint'),
            style: {
                marginTop: '0.375rem',
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).warnInk
            }
        }, (0, $ace44487380106d3$export$ab36a14ecd73702e)((0, $ace44487380106d3$export$e9b4e5de48a21156)(item), t)), item.removeFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-rx-remove-failed-${item.id}`,
            title: t('visit.rx.removeFailedHint'),
            style: {
                marginTop: '0.375rem',
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).dangerInk
            }
        }, t('visit.rx.removeFailed')));
    })), onCheckInteractions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onCheckInteractions,
        disabled: !canCheckInteractions,
        "data-testid": "visit-rx-check-interactions",
        className: "w-full min-h-11 mt-2 gap-1.5"
    }, interactionLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.rx.checkingInteractionsShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.rx.checkInteractions'))), onCheckInteractions && !interactionLoading && !canCheckInteractions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-needs-drugs",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            padding: '0.375rem 0'
        }
    }, t('visit.rx.ixNeedsDrugs')), interactionError && !interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-error",
        style: {
            marginTop: '0.5rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 600
        }
    }, t('errors.load.interactions')), interactions && !interactionLoading && !interactionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        "data-testid": "visit-rx-ix-report"
    }, interactionStale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-stale",
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.rx.ixStale')), hasIx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, groups.high.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-high",
        role: "alert",
        style: {
            background: (0, $jTCZr.CT).dangerSoft,
            border: `2px solid ${(0, $jTCZr.CT).danger}`,
            borderRadius: '0.625rem',
            padding: '0.625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontWeight: 800,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).dangerInk,
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.ixHighTitle'), " (", groups.high.length, ")"), groups.high.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.65,
                padding: '0.1875rem 0',
                borderTop: i ? `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12)}` : 'none'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, w.drugPair, ": "), w.description))), groups.medium.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-medium",
        style: {
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.4)}`,
            borderRadius: '0.625rem',
            padding: '0.5625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).warnInk,
            marginBottom: '0.3125rem'
        }
    }, t('visit.rx.ixMediumTitle'), " (", groups.medium.length, ")"), groups.medium.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.6,
                padding: '0.1875rem 0',
                borderTop: i ? `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12)}` : 'none'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, w.drugPair, ": "), w.description))), groups.low.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-low",
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.5rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontWeight: 600,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('visit.rx.ixLowTitle'), " (", groups.low.length, ")"), groups.low.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.6,
                padding: '0.125rem 0'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, w.drugPair, ": "), w.description)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).greenLight,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.3)}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).goodInk,
            fontWeight: 600
        }
    }, t('visit.rx.noInteractions'))));
};
var $3d5dc5a5bf298474$export$2e2bcd8739ae039 = $3d5dc5a5bf298474$var$MobileVisitRx;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $hZDga = parcelRequire("hZDga");


var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8g4t5 = parcelRequire("8g4t5");
var $e5Ore = parcelRequire("e5Ore");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $d1d8c0bbf580ccf5$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "18",
            cy: "5",
            r: "3",
            key: "gq8acd"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "12",
            r: "3",
            key: "w7nqdw"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "19",
            r: "3",
            key: "1xt0gg"
        }
    ],
    [
        "line",
        {
            x1: "8.59",
            x2: "15.42",
            y1: "13.51",
            y2: "17.49",
            key: "47mynk"
        }
    ],
    [
        "line",
        {
            x1: "15.41",
            x2: "8.59",
            y1: "6.51",
            y2: "10.49",
            key: "1n3mei"
        }
    ]
];
const $d1d8c0bbf580ccf5$export$2e2bcd8739ae039 = (0, $9QBug.default)("share-2", $d1d8c0bbf580ccf5$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");


// ── AI-suggested orders ──────────────────────────────────────────────────────
//
// «پیشنهاد درخواست» answers with catalogue rows: the AI service keeps only names
// it finds in the clinical order catalogue and hands back that row's own code —
// LOINC for a lab, CPT for a procedure (prescription_agent.py
// `suggest_doctor_orders`). The desktop built its rows without the code and
// created the order without it, so an AI-suggested lab reached the record and the
// insurer with no service code; the phone's live add path dropped it the same
// way. Both now carry it.
/**
 * The desktop «دستورات» suggestion rows, unranked, each carrying the code its
 * catalogue row gave it. `loincCode` is set only for a lab — the one code that
 * IS a LOINC — exactly as the catalogue picker sets it.
 */ const $027388f7462935a9$export$1565dcb2999a6fb9 = (s)=>[
        ...(s?.labTests || []).map((test)=>({
                key: `lab:${test.testName}`,
                orderType: 'lab',
                name: test.testName,
                reason: test.reason,
                urgency: test.urgency || 'routine',
                code: test.loincCode || '',
                loincCode: test.loincCode || ''
            })),
        ...(s?.imagingStudies || []).map((x)=>({
                key: `imaging:${x.studyType}`,
                orderType: 'imaging',
                name: x.studyType,
                reason: [
                    x.bodyPart,
                    x.reason
                ].filter(Boolean).join(" \u2014 "),
                urgency: x.urgency || 'routine',
                code: '',
                loincCode: ''
            })),
        ...(s?.procedureOrders || []).map((p)=>({
                key: `procedure:${p.name}`,
                orderType: 'procedure',
                name: p.name,
                reason: p.reason,
                urgency: p.urgency || 'routine',
                code: p.code || '',
                loincCode: ''
            }))
    ];
const $027388f7462935a9$export$ce329d894bbd1d2b = (orders, orderType, name)=>{
    const want = String(name || '').trim();
    if (!want) return false;
    return (orders || []).some((o)=>o && o.status !== 'cancelled' && (!orderType || !o.orderType || o.orderType === orderType) && String(o.description || '').trim() === want);
};


// Icons per order type — the phone's answer to the desktop ORDER_TYPE_ICON map,
// which indexes a desktop-only icon set.
const $dcedef1256f07607$var$TYPE_ICON = {
    lab: (0, $4CVxl.default),
    imaging: (0, $6828da86e4d4e8df$export$2e2bcd8739ae039),
    procedure: (0, $fX0JO.default),
    referral: (0, $d1d8c0bbf580ccf5$export$2e2bcd8739ae039),
    other: (0, $3FyOw.default)
};
// The clinical-orders tab: an AI order-suggestion pass (labelled §13.3), a
// structured catalog picker (type → searchable, category-grouped checklist →
// urgency / note / sessions — the mobile-native fork of the desktop add-order
// form), and the pending list. Orders live in pendingTests and are persisted by
// the screen at «پایان ویزیت»; this stays render-only.
const $dcedef1256f07607$var$ORDER_TYPES = (t)=>[
        {
            value: 'lab',
            label: t('visit.orders.lab')
        },
        {
            value: 'imaging',
            label: t('patient.orderType.imaging')
        },
        {
            value: 'procedure',
            label: t('visit.orders.procedureShort')
        },
        {
            value: 'other',
            label: t('common.state.other')
        }
    ];
const $dcedef1256f07607$var$URGENCIES = (t)=>[
        {
            value: 'routine',
            label: t('common.urgency.routine')
        },
        {
            value: 'urgent',
            label: t('common.urgency.urgent')
        },
        {
            value: 'stat',
            label: t('common.urgency.stat')
        }
    ];
const $dcedef1256f07607$var$TYPE_LBL = (t)=>({
        lab: t('patient.orderType.lab'),
        imaging: t('patient.orderType.imaging'),
        procedure: t('visit.orders.procedureShort'),
        other: t('common.state.other')
    });
// One search result, in the shape the checklist reads. The server has already
// filtered by query and type and ranked what this clinic performs first, so
// there is nothing left to filter here.
const $dcedef1256f07607$var$normalizeResults = (entries, t, insurer)=>(entries || []).map((e)=>({
            key: `${e.orderType}:${e.name}`,
            type: e.orderType,
            name: e.name,
            nameEn: e.nameEn || '',
            catalogId: e.id || null,
            code: e.code || '',
            // A «LOINC» badge is only honest when the code IS a LOINC — the same field now
            // also carries CPT, and soon LAB-ir and Radiology-ir numbers.
            loincCode: e.codeSystem === 'LOINC' ? e.code || '' : '',
            modality: e.modality || '',
            sub: e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '',
            category: e.category || t('common.state.other'),
            inHouse: !!e.inHouse,
            // «در فهرست تأمین» — for a تأمین patient, as on the desktop (K1, 2026-10-07).
            taminListed: (0, $375f8776645d5aee$export$ff0b3160d2d98f35)(e, insurer)
        }));
// 1rem and 2.75rem: anything smaller makes iOS zoom on focus and misses the
// touch floor (MOBILE_WEB_PWA §5; seen in the 2026-10-12 tour).
const $dcedef1256f07607$var$selectStyle = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: '0.5rem',
    padding: '0.5rem 0.625rem',
    fontSize: '1rem',
    minHeight: '2.75rem',
    fontFamily: 'inherit',
    color: (0, $jTCZr.C).textPrimary,
    background: (0, $jTCZr.CT).surface2,
    outline: 'none'
};
const $dcedef1256f07607$var$inputStyle = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: '0.5rem',
    padding: '0.625rem 0.75rem',
    fontSize: '1rem',
    fontFamily: 'inherit',
    color: (0, $jTCZr.C).textPrimary,
    background: (0, $jTCZr.CT).surface2,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box'
};
const $dcedef1256f07607$var$CheckRow = ({ item: item, checked: checked, onToggle: onToggle })=>{
    // A reader who does not read Persian sees the catalogue's English name; the
    // Persian `name` is still what the order is created with.
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onToggle,
        "aria-pressed": checked,
        "data-testid": `visit-order-catalog-item-${item.key}`,
        className: "w-full min-h-11 h-auto justify-start rounded-lg px-2 py-2 gap-2 hover:bg-transparent font-normal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.125rem',
            height: '1.125rem',
            borderRadius: '0.3125rem',
            flexShrink: 0,
            border: `1.5px solid ${checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: checked ? (0, $jTCZr.CT).accent : 'transparent',
            display: 'grid',
            placeItems: 'center'
        }
    }, checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        color: "#fff",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: (0, $jTCZr.C).textPrimary
        }
    }, !readsPersianData && item.nameEn || item.name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
        drug: {
            id: item.catalogId || item.key
        },
        listed: item.taminListed ?? null,
        both: true,
        size: "0.625rem",
        testid: `visit-order-coverage-${item.catalogId || item.key}`,
        hint: t('visit.orders.outTaminHint')
    })), (item.sub || item.modality) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem'
        }
    }, [
        item.modality,
        item.sub
    ].filter(Boolean).join(" \xb7 "))));
};
const $dcedef1256f07607$var$MobileVisitOrders = ({ onFetchSuggestions: onFetchSuggestions, suggestions: suggestions, suggestionsLoading: suggestionsLoading, canSuggest: canSuggest, searchCatalog: searchCatalog, pendingTests: pendingTests, onAddOrders: onAddOrders, onAddPending: onAddPending, onRemovePending: onRemovePending, orders: // ── Saved orders and their lifecycle (§5.5) ───────────────────────────────
orders = [], ordersLoading: ordersLoading = false, ordersLoaded: ordersLoaded = false, transitioningId: transitioningId = null, inHouseCatalogIds: inHouseCatalogIds, insurer: // The patient's basic insurer and the chart's catalogue rows (id → row): what
// «در فهرست تأمین» on the picker and «خارج از فهرست تأمین» on a card read.
insurer = null, catalogResolved: catalogResolved = null, onCompleteOrder: onCompleteOrder, onCancelOrder: onCancelOrder, orderError: orderError, onDismissOrderError: onDismissOrderError, completeAction: // «تکمیل از پایش بالینی» (PM-0038): the section's button and its proposal card,
// built by the screen from the visit's one vocabulary.
completeAction = null, proposal: proposal = null, onPendingChange: // How many picked items are not on the visit yet — ticked in the catalogue
// (or typed under «سایر») but «افزودن» not pressed. The screen holds
// «پایان ویزیت» on it: a CBC ticked and never added used to vanish when the
// visit ended (2026-10-12 tour, PM-0121).
onPendingChange })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    // Orders this clinic performs float to the top; everything else keeps its
    // creation order. Stable via the paired index — the desktop ordering.
    const sortedOrders = (0, $acw62.useMemo)(()=>orders.map((o, i)=>[
                o,
                i
            ]).sort((a, b)=>{
            const ah = !!a[0]?.catalogId && !!inHouseCatalogIds?.has?.(a[0].catalogId);
            const bh = !!b[0]?.catalogId && !!inHouseCatalogIds?.has?.(b[0].catalogId);
            return bh - ah || a[1] - b[1];
        }).map(([o])=>o), [
        orders,
        inHouseCatalogIds
    ]);
    const [type, setType] = (0, $acw62.useState)('lab');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [urgency, setUrgency] = (0, $acw62.useState)('routine');
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [sessions, setSessions] = (0, $acw62.useState)(1);
    const [selected, setSelected] = (0, $acw62.useState)(()=>new Set());
    const [freeText, setFreeText] = (0, $acw62.useState)('');
    // One search per pause in typing. A reply to an older query never lands on top
    // of a newer one, and a checked item survives the next keystroke — the picker
    // no longer holds a catalogue to look a key up in later.
    const [page, setPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    const chosenRef = (0, $acw62.useRef)(new Map());
    (0, $acw62.useEffect)(()=>{
        if (type === 'other' || typeof searchCatalog !== 'function') return undefined;
        // Nothing is listed until the doctor searches (PM-0098, as on the نسخه).
        if (search.trim().length < (0, $375f8776645d5aee$export$6770277ab0ca292e)) {
            setPage({
                entries: [],
                total: 0,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setPage((prev)=>({
                ...prev,
                loading: true
            }));
        const timer = setTimeout(()=>{
            searchCatalog({
                query: search,
                orderType: type
            }).then((res)=>{
                if (live) setPage({
                    ...res,
                    loading: false,
                    error: null
                });
            }).catch((err)=>{
                if (!live) return;
                console.error('order catalog search failed:', err);
                setPage({
                    entries: [],
                    total: 0,
                    loading: false,
                    error: err?.message || 'error'
                });
            });
        }, 250);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        type,
        search,
        searchCatalog
    ]);
    const items = (0, $acw62.useMemo)(()=>$dcedef1256f07607$var$normalizeResults(page.entries, t, insurer), [
        page.entries,
        t,
        insurer
    ]);
    const grouped = (0, $acw62.useMemo)(()=>{
        if (type === 'other') return [];
        const byCat = new Map();
        for (const it of items){
            if (!byCat.has(it.category)) byCat.set(it.category, []);
            byCat.get(it.category).push(it);
        }
        // In-house services lead their category — the desktop ordering, which the
        // phone silently lacked while it filtered in memory.
        return Array.from(byCat, ([category, list])=>({
                category: category,
                list: list.map((it, i)=>[
                        it,
                        i
                    ]).sort((a, b)=>!!b[0].inHouse - !!a[0].inHouse || a[1] - b[1]).map(([it])=>it)
            }));
    }, [
        items,
        type
    ]);
    const itemByKey = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const it of items)m.set(it.key, it);
        return m;
    }, [
        items
    ]);
    const changeType = (item)=>{
        setType(item);
        setSearch('');
        setSelected(new Set());
        chosenRef.current.clear();
    };
    const toggleKey = (key)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
                chosenRef.current.delete(key);
            } else {
                next.add(key);
                // Hold the ITEM, not just its key. The list changes with the next
                // keystroke, and there is no resident catalogue to resolve a key against
                // when «افزودن» is finally pressed.
                const it = itemByKey.get(key);
                if (it) chosenRef.current.set(key, it);
            }
            return next;
        });
    const canAdd = type === 'other' ? !!freeText.trim() : selected.size > 0;
    const pendingCount = type === 'other' ? freeText.trim() ? 1 : 0 : selected.size;
    (0, $acw62.useEffect)(()=>{
        onPendingChange?.(pendingCount);
    }, [
        pendingCount,
        onPendingChange
    ]);
    (0, $acw62.useEffect)(()=>()=>onPendingChange?.(0), [
        onPendingChange
    ]);
    const submit = ()=>{
        if (type === 'other') {
            const name = freeText.trim();
            if (!name) return;
            onAddOrders([
                {
                    name: name,
                    type: 'other',
                    urgency: urgency,
                    reason: notes.trim()
                }
            ]);
            setFreeText('');
            setNotes('');
            return;
        }
        const chosen = Array.from(selected).map((k)=>chosenRef.current.get(k) || itemByKey.get(k)).filter(Boolean);
        if (!chosen.length) return;
        const sc = type === 'procedure' ? Math.max(1, Number(sessions) || 1) : 1;
        // `catalogId` travels too, as the desktop's «افزودن» sends it: without it
        // the order reaches the record unlinked from the row it was picked from.
        onAddOrders(chosen.map((it)=>({
                name: it.name,
                type: it.type,
                urgency: urgency,
                reason: notes.trim(),
                code: it.code,
                loincCode: it.loincCode || it.code,
                sessionCount: sc,
                catalogId: it.catalogId || null
            })));
        setSelected(new Set());
        setNotes('');
        setSessions(1);
    };
    const suggItems = [
        ...suggestions?.labTests || [],
        ...suggestions?.imagingStudies || []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-content",
        "data-state": pendingTests.length ? 'content' : 'empty'
    }, completeAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            marginBottom: '0.5rem'
        }
    }, completeAction), proposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, proposal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        onClick: onFetchSuggestions,
        disabled: suggestionsLoading || !canSuggest,
        "data-testid": "visit-orders-suggest",
        className: "w-full min-h-11 mb-2 gap-1.5"
    }, suggestionsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "#fff",
        thickness: 2
    }), " ", t('visit.copilot.analysing')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.suggest.smartTests'))), suggItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$c606e0dfdc515248), {
        label: t('visit.suggest.smart')
    })), suggItems.map((order, i)=>{
        const name = order.testName || order.studyType;
        const orderType = order.testName ? 'lab' : 'imaging';
        // Already on the visit counts as added: a saved order (from the
        // desktop, a template, or before a reload) is in `orders`, not in
        // `pendingTests`, and adding it again wrote a second row.
        const added = pendingTests.some((p)=>p.name === name) || (0, $027388f7462935a9$export$ce329d894bbd1d2b)(orders, orderType, name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `${i}:${name}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.75rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, name), order.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, order.reason)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: added ? 'subtle' : 'default',
            size: "sm",
            disabled: added,
            "data-testid": `visit-orders-add-sugg-${i}`,
            className: "min-h-11 shrink-0 gap-1",
            // The lab's catalogue LOINC rides along: «پایان ویزیت» saves
            // `code || loincCode`, and without it the order reached the
            // record and the insurer uncoded (lib/suggestedOrders).
            onClick: ()=>onAddPending({
                    id: Date.now() + i,
                    name: name,
                    type: orderType,
                    urgency: order.urgency || 'routine',
                    reason: order.reason || '',
                    code: order.loincCode || '',
                    loincCode: order.loincCode || ''
                })
        }, added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.orders.added')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.orders.add'))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-form",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.75rem',
            marginBottom: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.orders.add')), selected.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk
        }
    }, selected.size, " ", t('visit.orders.selectedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-type-tabs",
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.375rem'
        }
    }, $dcedef1256f07607$var$ORDER_TYPES(t).map((o)=>{
        const on = type === o.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: o.value,
            variant: on ? 'default' : 'outline',
            size: "sm",
            className: "min-h-11",
            "data-testid": `visit-order-type-${o.value}`,
            "aria-pressed": on,
            onClick: ()=>changeType(o.value)
        }, o.label);
    })), type === 'other' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: freeText,
        onChange: (e)=>setFreeText(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        placeholder: t('visit.orders.freeText'),
        "data-testid": "visit-order-freetext-input",
        style: $dcedef1256f07607$var$inputStyle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 15,
        "aria-hidden": true,
        style: {
            position: 'absolute',
            insetInlineStart: '0.625rem',
            top: '50%',
            transform: 'translateY(-50%)',
            color: (0, $jTCZr.C).textMuted,
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: search,
        onChange: (e)=>setSearch(e.target.value),
        placeholder: t('visit.orders.searchCatalog'),
        "data-testid": "visit-order-catalog-search",
        style: {
            ...$dcedef1256f07607$var$inputStyle,
            paddingInlineStart: '2rem'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-catalog-list",
        style: {
            maxHeight: '15rem',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, search.trim().length < (0, $375f8776645d5aee$export$6770277ab0ca292e) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-search-idle",
        "data-state": "idle",
        style: {
            padding: '0.5rem 0.25rem',
            color: (0, $jTCZr.CT).ink2,
            fontSize: '0.75rem',
            lineHeight: 1.7
        }
    }, search.trim() ? t('visit.orders.keepTyping') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody'))) : page.loading && !items.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem',
            padding: '1rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.orders.loadingCatalog')) : page.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-catalog-error",
        style: {
            textAlign: 'center',
            padding: '1rem 0',
            color: (0, $jTCZr.CT).danger,
            fontSize: '0.75rem'
        }
    }, t('visit.orders.catalogSearchFailed')) : grouped.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '1rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, t('visit.orders.noCatalogMatch')) : grouped.map(({ category: category, list: list })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: category,
            style: {
                marginBottom: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: (0, $jTCZr.C).textMuted,
                padding: '0.375rem 0.25rem 0.1875rem'
            }
        }, category), list.map((it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dcedef1256f07607$var$CheckRow, {
                key: it.key,
                item: it,
                checked: selected.has(it.key),
                onToggle: ()=>toggleKey(it.key)
            }))))), selected.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-selected-chips",
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            marginTop: '0.5rem'
        }
    }, Array.from(selected).map((key)=>{
        const it = chosenRef.current.get(key);
        if (!it) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: key,
            variant: "subtle",
            size: "sm",
            className: "min-h-11 gap-1.5",
            onClick: ()=>toggleKey(key),
            "aria-label": t('visit.rx.removeAria', {
                name: it.name
            }),
            "data-testid": `visit-order-selected-${key}`
        }, it.name, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: urgency,
        onChange: (e)=>setUrgency(e.target.value),
        "data-testid": "visit-order-urgency",
        style: {
            ...$dcedef1256f07607$var$selectStyle,
            flex: 1
        }
    }, $dcedef1256f07607$var$URGENCIES(t).map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), type === 'procedure' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "number",
        min: 1,
        value: sessions,
        onChange: (e)=>setSessions(e.target.value),
        "aria-label": t('visit.rx.sessions'),
        "data-testid": "visit-order-sessions",
        style: {
            ...$dcedef1256f07607$var$selectStyle,
            width: '5rem',
            textAlign: 'center'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: notes,
        onChange: (e)=>setNotes(e.target.value),
        placeholder: t('visit.orders.noteOptionalPlaceholder'),
        "data-testid": "visit-order-notes",
        style: $dcedef1256f07607$var$inputStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: canAdd ? 'default' : 'outline',
        size: "sm",
        onClick: submit,
        disabled: !canAdd,
        "data-testid": "visit-order-create",
        "data-pending": pendingCount || undefined,
        className: `w-full min-h-11 gap-1.5${canAdd ? '' : ' border-dashed'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", pendingCount > 0 ? t('visit.orders.addPending', {
        count: formatDigits(pendingCount)
    }) : t('common.actions.add'))), pendingTests.length === 0 && !suggItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.orders.noneRecorded')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, pendingTests.map((order)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-orders-row-${order.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: (0, $e031888e2d726c18$export$d5e749cf0acf0b49)(order.urgency),
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 500,
                color: (0, $jTCZr.C).textPrimary
            }
        }, order.name, order.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 400
            }
        }, " \xb7 ", formatDigits(order.sessionCount), " ", t('visit.rx.session'))), order.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, order.reason)), order.type && order.type !== 'lab' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).surface2,
                color: (0, $jTCZr.C).textSecondary
            }
        }, $dcedef1256f07607$var$TYPE_LBL(t)[order.type] || order.type), order.urgency && order.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: order.urgency === 'stat' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
                color: order.urgency === 'stat' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, order.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('visit.orders.removeAria', {
                name: order.name
            }),
            "data-testid": `visit-orders-remove-${order.id}`,
            onClick: ()=>onRemovePending(order.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))))), (ordersLoading || ordersLoaded || orders.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, t('visit.orders.saved')), orders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            background: (0, $jTCZr.CT).surface2,
            borderRadius: '0.25rem',
            padding: '0.0625rem 0.375rem'
        }
    }, formatDigits(orders.length))), orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            borderRadius: '0.5rem',
            padding: '0.5rem 0.625rem',
            marginBottom: '0.5rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, orderError), onDismissOrderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        "aria-label": t('common.actions.close'),
        onClick: onDismissOrderError,
        style: {
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 14,
        "aria-hidden": true
    }))), ordersLoading && orders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$ab93a3750a1b92b6), {
        count: 2,
        dense: true
    }) : orders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('visit.orders.noneRecorded')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        },
        "data-testid": "visit-orders-saved",
        "data-state": "content"
    }, sortedOrders.map((order)=>{
        const inHouse = !!order.catalogId && !!inHouseCatalogIds?.has?.(order.catalogId);
        const open = (0, $fa15d8b4a746e70c$export$dcac1cce4fca5347).includes(order.status);
        const busy = transitioningId === order.id;
        const TypeIcon = $dcedef1256f07607$var$TYPE_ICON[order.orderType] || (0, $3FyOw.default);
        const st = (0, $fa15d8b4a746e70c$export$5f296182ef21a05b)[order.status];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-order-card-${order.id}`,
            "data-status": order.status,
            ...inHouse ? {
                'data-clinic-order': 'true'
            } : {},
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            size: 14,
            color: (0, $jTCZr.C).textMuted,
            "aria-hidden": true,
            style: {
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, order.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                marginTop: '0.125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                fontFamily: 'ui-monospace, monospace'
            }
        }, order.code), inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, t('visit.orders.thisClinic')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
            drug: {
                id: order.id
            },
            size: "0.5625rem",
            listed: (0, $375f8776645d5aee$export$467168533c33d9ca)(order, catalogResolved, insurer),
            testid: `visit-order-coverage-${order.id}`,
            hint: t('visit.orders.outTaminHint')
        }), order.urgency && order.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                background: order.urgency === 'stat' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
                color: order.urgency === 'stat' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, order.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')))), st && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: st.bg,
                color: st.text,
                flexShrink: 0
            }
        }, t(st.labelKey))), order.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.25rem'
            }
        }, order.notes), open && (inHouse || order.status === 'pending') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            className: "min-h-11 gap-1",
            "data-testid": `visit-order-done-${order.id}`,
            disabled: busy,
            onClick: ()=>onCompleteOrder?.(order.id)
        }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 12
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), t('visit.orders.markDone')), order.status === 'pending' && onCancelOrder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "min-h-11",
            "data-testid": `visit-order-cancel-${order.id}`,
            disabled: busy,
            onClick: ()=>onCancelOrder(order),
            style: {
                color: (0, $jTCZr.CT).dangerInk
            }
        }, t('common.actions.cancel'))));
    }))));
};
var $dcedef1256f07607$export$2e2bcd8739ae039 = $dcedef1256f07607$var$MobileVisitOrders;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $chm1L = parcelRequire("chm1L");
// The clinical-copilot entry — one quiet row: «دستیار» with its count, and the
// dictation mic. It used to be a dark floating slab with a pulsing dot that
// streamed the top suggestion's title, which put AI output in the doctor's eye
// line on every screen of the visit. The assistant is opened, not broadcast:
// the count says there is something to read, the sheet is where it is read.
// The mic is not here: «پایش بالینی» is its own control in the visit's top
// strip (MobileVisitMonitorButton), and one control per action is the rule.
//
// It shares the footer's ONE row with «پایان ویزیت» (PM-0044): it takes the
// width that is left, and says how many suggestions are waiting in its
// accessible name as well as in the chip.
const $d7965145b8773dba$var$MobileVisitCopilotBar = ({ count: count = 0, onOpen: onOpen })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-bar",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onOpen,
        "data-testid": "visit-copilot-open",
        "aria-label": count > 0 ? `${t('visit.copilot.open')} \u{2014} ${formatDigits(count)}` : t('visit.copilot.open'),
        className: "flex-1 min-w-0 h-11 min-h-11 justify-start gap-2 rounded-lg px-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.copilot.assistant')), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-copilot-count",
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk
        }
    }, formatDigits(count))));
};
var $d7965145b8773dba$export$2e2bcd8739ae039 = $d7965145b8773dba$var$MobileVisitCopilotBar;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $2WFPf = parcelRequire("2WFPf");
var $6OGKD = parcelRequire("6OGKD");

var $jTCZr = parcelRequire("jTCZr");

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");


var $1HT9m = parcelRequire("1HT9m");
function $2f6240fe22cbf69b$export$11c467f1ec2afb25({ size: size = 12 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: "none",
        "aria-hidden": "true",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "6.4",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "2.1",
        fill: "currentColor"
    }));
}
function $2f6240fe22cbf69b$export$2e2bcd8739ae039({ cost: cost, per: per, prefix: prefix, tone: tone = 'accent', size: size = 'sm', title: title, style: style, testid: testid = 'coin-chip' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (cost == null) return null;
    const tones = {
        accent: {
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.14),
            fg: (0, $jTCZr.C).teal
        },
        onDark: {
            bg: 'rgba(255,255,255,0.18)',
            fg: '#fff'
        },
        warn: {
            bg: (0, $jTCZr.C).amberLight,
            fg: (0, $jTCZr.C).amber
        },
        danger: {
            bg: (0, $jTCZr.C).redLight,
            fg: (0, $jTCZr.C).red
        },
        mute: {
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12),
            fg: (0, $jTCZr.C).textSecondary
        }
    };
    const palette = tones[tone] || tones.accent;
    const isSm = size === 'sm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: title,
        "data-testid": testid,
        style: {
            ...isSm ? (0, $1HT9m.type).caption : (0, $1HT9m.type).label,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: palette.bg,
            color: palette.fg,
            borderRadius: 999,
            padding: isSm ? '1px 8px' : '3px 10px',
            fontWeight: 800,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2f6240fe22cbf69b$export$11c467f1ec2afb25, {
        size: isSm ? 11 : 12
    }), prefix ? `${prefix} ` : '', (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(cost, formatNumber), per ? ` / ${per}` : '');
}




// The clinical-copilot BottomSheet (§6 default overlay): three tabs — نکات بالینی
// (live hints + clinical-insight cards), تشخیص افتراقی (the differential) and
// پرسش (AI Q&A) — over a docked composer. All AI output is badged (§13.3); accept/reject
// and the ask handler live in the screen and arrive as callbacks.
//
// The insight feed is decision support, NOT an order pad: no test, imaging or
// drug card reaches it. Those are placed in «دستورات» and «نسخه». Note
// completion is not here either — it lives in the note's own section
// (MobileVisitSoap), so the feed is purely something to read.
const $9331b3f7d9a9e1d6$var$SOURCE_LBL = (t)=>({
        rule_engine_static: 'Rule Engine',
        rule_engine_rxnorm: 'RxNorm',
        rule_engine_contraindication: t('visit.rx.contraindication'),
        rule_engine_allergy: t('patient.allergies.title'),
        rule_engine_openfda: 'FDA',
        llm: 'AI'
    });
const $9331b3f7d9a9e1d6$var$TranscriptRow = ({ line: line })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'flex-start',
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.1875rem',
            background: line.role === 'dr' ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).surface2,
            color: line.role === 'dr' ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            marginTop: '0.125rem'
        }
    }, line.spk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.C).textSecondary,
            flex: 1,
            minWidth: 0,
            fontSize: '0.75rem',
            lineHeight: 1.6
        }
    }, line.text));
const $9331b3f7d9a9e1d6$var$SuggestionCard = ({ s: s })=>{
    const { t: t } = (0, $LNQP4.default)();
    const warn = s.level === 'warn';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${warn ? (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.5) : (0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem 0.8125rem',
            marginBottom: '0.625rem',
            ...warn ? {
                background: `linear-gradient(180deg, ${(0, $jTCZr.C).amberLight}, ${(0, $jTCZr.C).card} 60%)`
            } : null
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            letterSpacing: '0.03em',
            padding: '0.125rem 0.4375rem',
            borderRadius: '0.25rem',
            textTransform: 'uppercase',
            background: warn ? (0, $jTCZr.C).amberLight : (0, $jTCZr.CT).accentSoft,
            color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
        }
    }, s.kind), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$c606e0dfdc515248), {
        style: {
            padding: '0.0625rem 0.375rem'
        }
    }), s.conf != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontFamily: 'ui-monospace, monospace'
        }
    }, Math.round(s.conf * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.25rem',
            lineHeight: 1.4
        }
    }, s.title), s.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.6,
            whiteSpace: 'pre-line'
        }
    }, s.body), s.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem',
            padding: '0.4375rem 0.5625rem',
            borderRadius: '0.375rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: (0, $jTCZr.C).textSecondary
        }
    }, t('visit.copilot.evidence'), " "), s.evidence, s._citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.3125rem',
            marginTop: '0.375rem'
        }
    }, s._citations.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            key: c.pmid,
            href: c.url,
            target: "_blank",
            rel: "noopener noreferrer",
            title: c.title,
            style: {
                fontSize: '0.625rem',
                fontWeight: 500,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk,
                textDecoration: 'none'
            }
        }, "PubMed ", c.pmid, " \xb7 ", c.journal, " ", c.year)))), s._source && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            marginTop: '0.375rem',
            fontSize: '0.5625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.25rem',
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textSecondary
        }
    }, $9331b3f7d9a9e1d6$var$SOURCE_LBL(t)[s._source] || s._source));
};
const $9331b3f7d9a9e1d6$var$MobileVisitCopilotSheet = ({ open: open, onClose: onClose, tab: tab, onTab: onTab, suggestions: suggestions, transcriptLines: transcriptLines, messages: messages, chatLoading: chatLoading, recsLoading: recsLoading, quickQs: quickQs, aiInput: aiInput, onAiInput: onAiInput, onAsk: onAsk, recsError: recsError, recsRan: recsRan, onRunRecs: onRunRecs, visitCoins: visitCoins = 0, coinEntries: coinEntries = [], differentialPanel: // «تشخیص افتراقی» — the differential's one home on the phone. The screen
// renders the panel (it owns ~28 handlers and the polling) and hands it in
// as an element, so this sheet only decides WHEN it shows.
differentialPanel = null, diffCount: diffCount = 0, isTabVisible: // The doctor's copilot preference, mapped onto this sheet's tab ids by
// screens/Visit/visitLayout.js. Absent, every tab shows — the sheet has no
// opinion of its own. The tabs are the desktop copilot's three, and nothing
// else: a «گفتگو» tab that showed the whole transcript used to sit between
// them and was removed. What it displayed is not lost — «نکات بالینی» still
// carries the live lines as they arrive, which is where a doctor reads them
// while the visit is running rather than scrolling a transcript.
isTabVisible = ()=>true })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [ledgerOpen, setLedgerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Biggest spender first — the breakdown is read to find where the Parseh went.
    // Same rows the desktop popover shows, from the same ledger entries; only the
    // shape differs, because a hover popover has no meaning on a phone.
    const ledgerRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const labelKeyById = Object.fromEntries((0, $2a90b979c3d41f86$export$52690e1136e04e64).map((p)=>[
                p.id,
                p.labelKey
            ]));
        return [
            ...coinEntries
        ].filter((e)=>e && e.coins > 0).sort((a, b)=>b.coins - a.coins).map((e)=>({
                ...e,
                label: labelKeyById[e.id] ? t(labelKeyById[e.id]) : e.id
            }));
    }, [
        coinEntries,
        t
    ]);
    // A hidden tab stays reachable while it is the ACTIVE one — a programmatic
    // jump into it must still show the doctor where they are.
    const TABS = [
        {
            id: 'hints',
            label: t('visit.copilot.clinicalNotes'),
            badge: suggestions.length
        },
        ...differentialPanel ? [
            {
                id: 'diff',
                label: t('visit.copilot.differential'),
                badge: diffCount
            }
        ] : [],
        {
            id: 'ask',
            label: t('visit.copilot.ask')
        }
    ].filter((item)=>isTabVisible(item.id) || tab === item.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.copilot.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-sheet",
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, visitCoins > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, ledgerRows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 gap-1 px-1",
        "data-testid": "visit-coin-ledger-toggle",
        "aria-expanded": ledgerOpen,
        onClick: ()=>setLedgerOpen((o)=>!o)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: visitCoins,
        prefix: t('visit.header.thisVisitPrefix'),
        title: t('visit.header.coinsSpent')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.C).textMuted,
            transform: ledgerOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform .2s'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: visitCoins,
        prefix: t('visit.header.thisVisitPrefix'),
        title: t('visit.header.coinsSpent')
    })), ledgerOpen && ledgerRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-coin-ledger",
        style: {
            marginTop: '0.375rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.5rem 0.625rem'
        }
    }, ledgerRows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.id,
            "data-testid": `visit-coin-ledger-row-${row.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, row.label), row.count > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, "\xd7", formatDigits(row.count)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, formatDigits(row.coins)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            padding: '0.25rem',
            background: (0, $jTCZr.CT).surface2,
            borderRadius: '0.625rem',
            marginBottom: '0.75rem'
        }
    }, TABS.map((item)=>{
        const on = tab === item.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: item.id,
            variant: "ghost",
            onClick: ()=>onTab(item.id),
            "data-testid": `visit-copilot-tab-${item.id}`,
            "aria-pressed": on,
            className: "flex-1 min-h-11 rounded-md gap-1",
            style: {
                background: on ? (0, $jTCZr.C).card : 'transparent',
                color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500
            }
        }, item.label, item.badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.75rem',
                background: on ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.C).border,
                color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary
            }
        }, item.badge));
    })), tab === 'hints' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, transcriptLines.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.625rem 0.75rem',
            marginBottom: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            paddingBottom: '0.5rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.copilot.liveTranscript'))), transcriptLines.slice(-3).map((l, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9331b3f7d9a9e1d6$var$TranscriptRow, {
            key: i,
            line: l
        }))), recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem',
            padding: '0.5rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.copilot.loadingNotes')), suggestions.length === 0 && !recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-sugg-empty",
        style: {
            textAlign: 'center',
            padding: '1.5rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.8125rem'
        }
    }, recsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8,
            color: (0, $jTCZr.CT).danger
        }
    }, recsError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 mt-2",
        "data-testid": "visit-sugg-run",
        onClick: onRunRecs
    }, t('common.actions.retry'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8
        }
    }, recsRan ? t('errors.empty.clinicalNotes') : t('visit.copilot.autoRunOff')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 mt-2 gap-1.5",
        "data-testid": "visit-sugg-run",
        onClick: onRunRecs
    }, t('visit.copilot.getClinicalNotes'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: (0, $121df138798ec781$export$c932aceb7c67d0f4)('RECOMMENDATIONS')
    })))), suggestions.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9331b3f7d9a9e1d6$var$SuggestionCard, {
            key: (s.id || s.title) + '_' + i,
            s: s
        })), quickQs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: (0, $jTCZr.C).textMuted,
            margin: '0.625rem 0 0.375rem'
        }
    }, t('visit.copilot.quickQuestions')), quickQs.slice(0, 4).map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: i,
            variant: "outline",
            onClick: ()=>{
                onTab('ask');
                onAsk(q);
            },
            "data-testid": `visit-quickq-${i}`,
            className: "w-full min-h-11 h-auto justify-start rounded-lg mb-1 py-2 text-right font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                textAlign: 'start'
            }
        }, q))))), tab === 'diff' && differentialPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-diff"
    }, differentialPanel), tab === 'ask' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, messages.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '1.25rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, t('visit.copilot.askOrQuick')), messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                marginBottom: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0.5625rem 0.75rem',
                borderRadius: '0.5625rem',
                fontSize: '0.8125rem',
                lineHeight: 1.7,
                background: m.role === 'user' ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).card,
                color: m.role === 'user' ? '#fff' : (0, $jTCZr.C).textPrimary,
                border: m.role === 'ai' ? `1px solid ${(0, $jTCZr.C).border}` : 'none',
                marginInlineStart: m.role === 'user' ? '1.25rem' : 0,
                marginInlineEnd: m.role === 'ai' ? '1.25rem' : 0
            }
        }, m.text), m.role === 'ai' && m.citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.25rem',
                padding: '0.375rem 0.5625rem',
                background: (0, $jTCZr.CT).surface2,
                border: `1px dashed ${(0, $jTCZr.C).border}`,
                borderRadius: '0.4375rem',
                marginInlineEnd: '1rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                marginBottom: '0.25rem'
            }
        }, "PubMed"), m.citations.map((c, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                key: j,
                href: c.url,
                target: "_blank",
                rel: "noreferrer",
                style: {
                    display: 'block',
                    fontSize: '0.625rem',
                    color: (0, $jTCZr.CT).accentInk,
                    lineHeight: 1.4,
                    marginBottom: '0.1875rem',
                    textDecoration: 'none'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600
                }
            }, c.title), c.year && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.C).textMuted
                }
            }, " (", c.year, ")")))))), chatLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.5625rem',
            width: 'fit-content',
            marginBottom: '0.5rem'
        }
    }, [
        0,
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                width: '0.3125rem',
                height: '0.3125rem',
                borderRadius: '50%',
                background: (0, $jTCZr.C).textMuted,
                animation: `pulse .9s ease ${i * 0.2}s infinite`
            }
        }))), quickQs.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: i,
            variant: "outline",
            onClick: ()=>onAsk(q),
            "data-testid": `visit-askq-${i}`,
            className: "w-full min-h-11 h-auto justify-start rounded-lg mb-1 py-2 text-right font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                textAlign: 'start'
            }
        }, q)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            position: 'sticky',
            bottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: aiInput,
        onChange: (e)=>onAiInput(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                onTab('ask');
                onAsk();
            }
        },
        placeholder: t('visit.copilot.askPlaceholder'),
        "data-testid": "visit-copilot-input",
        style: {
            flex: 1,
            minHeight: '2.75rem',
            border: 'none',
            background: 'transparent',
            outline: 'none',
            fontSize: '1rem',
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "icon",
        className: "min-h-11 min-w-11 shrink-0",
        "aria-label": t('visit.copilot.send'),
        "data-testid": "visit-copilot-send",
        onClick: ()=>{
            onTab('ask');
            onAsk();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 15,
        "aria-hidden": true
    })))));
};
var $9331b3f7d9a9e1d6$export$2e2bcd8739ae039 = $9331b3f7d9a9e1d6$var$MobileVisitCopilotSheet;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2cf9022b4ea6e252$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 5H3",
            key: "1qgfaw"
        }
    ],
    [
        "path",
        {
            d: "M12 19H3",
            key: "yhmn1j"
        }
    ],
    [
        "path",
        {
            d: "M14 3v4",
            key: "1sua03"
        }
    ],
    [
        "path",
        {
            d: "M16 17v4",
            key: "1q0r14"
        }
    ],
    [
        "path",
        {
            d: "M21 12h-9",
            key: "1o4lsq"
        }
    ],
    [
        "path",
        {
            d: "M21 19h-5",
            key: "1rlt1p"
        }
    ],
    [
        "path",
        {
            d: "M21 5h-7",
            key: "1oszz2"
        }
    ],
    [
        "path",
        {
            d: "M8 10v4",
            key: "tgpxqk"
        }
    ],
    [
        "path",
        {
            d: "M8 12H3",
            key: "a7s4jb"
        }
    ]
];
const $2cf9022b4ea6e252$export$2e2bcd8739ae039 = (0, $9QBug.default)("sliders-horizontal", $2cf9022b4ea6e252$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");
var $lpOUO = parcelRequire("lpOUO");





var $jTCZr = parcelRequire("jTCZr");




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $bfs4Q = parcelRequire("bfs4Q");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8cb58a0e56c12463$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $8cb58a0e56c12463$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-check", $8cb58a0e56c12463$export$3efd853dbb351e94);


var $ggYuf = parcelRequire("ggYuf");
var $2XwcZ = parcelRequire("2XwcZ");
var $gr49X = parcelRequire("gr49X");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $824b163d7442530e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
            key: "1miecu"
        }
    ]
];
const $824b163d7442530e$export$2e2bcd8739ae039 = (0, $9QBug.default)("paperclip", $824b163d7442530e$export$3efd853dbb351e94);


var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ccc00afea4040e64$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 7V5a2 2 0 0 1 2-2h2",
            key: "aa7l1z"
        }
    ],
    [
        "path",
        {
            d: "M17 3h2a2 2 0 0 1 2 2v2",
            key: "4qcy5o"
        }
    ],
    [
        "path",
        {
            d: "M21 17v2a2 2 0 0 1-2 2h-2",
            key: "6vwrx8"
        }
    ],
    [
        "path",
        {
            d: "M7 21H5a2 2 0 0 1-2-2v-2",
            key: "ioqczr"
        }
    ],
    [
        "path",
        {
            d: "M7 12h10",
            key: "b7w52i"
        }
    ]
];
const $ccc00afea4040e64$export$2e2bcd8739ae039 = (0, $9QBug.default)("scan-line", $ccc00afea4040e64$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");
var $lpOUO = parcelRequire("lpOUO");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// Parsing shared by both «فایل‌ها» surfaces.
//
// The OCR payload is read on the desktop tab and in the phone's file-detail
// sheet. It lived in the desktop helpers, which put the phone one import away
// from a desktop-only module; it lives here so the two surfaces cannot disagree
// about which line is a result and which is unparsed text.
// Line format: "WBC: 6.8 10³/µL (ref: 4.0–10.0) [normal]"
function $bced050439dec003$export$ebcae889d05cbae5(ocrContent) {
    if (!ocrContent) return [];
    return ocrContent.split('\n').map((line)=>{
        const m = line.match(/^(.+?):\s*([\d.<>≤≥\-–]+)\s*([^\s([\]]+)?\s*(?:\(ref:\s*([^)]+)\))?\s*\[([^\]]+)\]$/);
        if (!m) return {
            raw: line
        };
        return {
            testName: m[1].trim(),
            value: m[2].trim(),
            unit: m[3]?.trim() || '',
            refRange: m[4]?.trim() || '',
            status: m[5]?.trim() || 'normal'
        };
    }).filter((r)=>r.testName || r.raw);
}
const $bced050439dec003$export$dff2f0d9dc32e832 = (r)=>!!r.status && r.status !== 'normal' && r.status !== 'unknown';
const $bced050439dec003$export$6e0aae7ac52ee4b7 = (rows)=>rows.filter($bced050439dec003$export$dff2f0d9dc32e832).length;
const $bced050439dec003$export$c2a61e046b7fd3b2 = (rows)=>rows.some((r)=>r.testName);
// ── Dates and grouping (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1) ──
const $bced050439dec003$var$IRAN_DAY = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});
function $bced050439dec003$export$bb0bcaf0a6a50714(iso) {
    const d = new Date(iso);
    if (!iso || Number.isNaN(d.getTime())) return '';
    const parts = {};
    for (const { type: type, value: value } of $bced050439dec003$var$IRAN_DAY.formatToParts(d))parts[type] = value;
    return `${parts.year}-${parts.month}-${parts.day}`;
}
function $bced050439dec003$export$8be12e4e93c8dacd(file) {
    return file?.documentDate || $bced050439dec003$export$bb0bcaf0a6a50714(file?.createdAt) || '';
}
function $bced050439dec003$export$d791f2a3277ada5e(file) {
    return Boolean(file?.documentDate && file?.createdAt && $bced050439dec003$export$bb0bcaf0a6a50714(file.createdAt) !== file.documentDate);
}
function $bced050439dec003$export$a719a8ff130c98cb(files) {
    return (files || []).slice().sort((a, b)=>$bced050439dec003$export$8be12e4e93c8dacd(b).localeCompare($bced050439dec003$export$8be12e4e93c8dacd(a)) || String(b.createdAt || '').localeCompare(String(a.createdAt || '')));
}
function $bced050439dec003$export$dfcaeb32ab9590ba(files, appointmentId) {
    const sorted = $bced050439dec003$export$a719a8ff130c98cb(files);
    if (!appointmentId) return {
        thisVisit: [],
        others: sorted
    };
    return {
        thisVisit: sorted.filter((f)=>f.appointmentId === appointmentId),
        others: sorted.filter((f)=>f.appointmentId !== appointmentId)
    };
}
function $bced050439dec003$export$d15fc12d83f90a2c(files, sinceIso) {
    if (!sinceIso) return 0;
    return (files || []).filter((f)=>f.uploadedBy === 'patient' && String(f.createdAt || '') > sinceIso).length;
}


var $75472431f73f934f$exports = {};

$parcel$export($75472431f73f934f$exports, "bffOrigin", () => $75472431f73f934f$export$a9b90d04cbeb257e);
$parcel$export($75472431f73f934f$exports, "DicomSessionError", () => $75472431f73f934f$export$ed9681397fa5101a);
$parcel$export($75472431f73f934f$exports, "authHeader", () => $75472431f73f934f$export$a3b7721557df7601);
$parcel$export($75472431f73f934f$exports, "openSession", () => $75472431f73f934f$export$19459b3f81b4a899);
$parcel$export($75472431f73f934f$exports, "commitSession", () => $75472431f73f934f$export$1215abca88606fce);
$parcel$export($75472431f73f934f$exports, "abortSession", () => $75472431f73f934f$export$a19aba171dab428);
$parcel$export($75472431f73f934f$exports, "sendBatch", () => $75472431f73f934f$export$f884bdf12a147dbe);
$parcel$export($75472431f73f934f$exports, "isRetryable", () => $75472431f73f934f$export$f146c102d7613638);

var $a83Oj = parcelRequire("a83Oj");

const $75472431f73f934f$export$a9b90d04cbeb257e = ()=>(0, $eabde0fc143396e8$export$dd8e552c8e6ae595)().replace(/\/graphql\/?$/, '');
class $75472431f73f934f$export$ed9681397fa5101a extends Error {
    constructor(code, message, status = 0, body = null){
        super(message || code);
        this.name = 'DicomSessionError';
        this.code = code;
        this.status = status;
        this.body = body;
    }
}
async function $75472431f73f934f$export$a3b7721557df7601() {
    const token = await (0, $a83Oj.getValidToken)();
    if (!token) throw new $75472431f73f934f$export$ed9681397fa5101a('UNAUTHENTICATED', 'Not authenticated', 401);
    return {
        Authorization: `Bearer ${token}`
    };
}
const $75472431f73f934f$var$errorFrom = (status, body)=>new $75472431f73f934f$export$ed9681397fa5101a(body?.code || (status === 413 ? 'DICOM_INSTANCE_TOO_LARGE' : status === 404 ? 'FORBIDDEN' : `HTTP_${status}`), body?.message || '', status, body);
async function $75472431f73f934f$var$requestJson(method, path, body, { signal: signal } = {}) {
    let res;
    try {
        res = await fetch(`${$75472431f73f934f$export$a9b90d04cbeb257e()}${path}`, {
            method: method,
            headers: {
                ...await $75472431f73f934f$export$a3b7721557df7601(),
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
    } catch (e) {
        if (e?.name === 'AbortError') throw new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted');
        if (e instanceof $75472431f73f934f$export$ed9681397fa5101a) throw e;
        throw new $75472431f73f934f$export$ed9681397fa5101a('NETWORK', e?.message || 'network');
    }
    let data = null;
    try {
        data = res.status === 204 ? null : await res.json();
    } catch  {}
    if (!res.ok) throw $75472431f73f934f$var$errorFrom(res.status, data);
    return data;
}
function $75472431f73f934f$export$19459b3f81b4a899(payload, opts) {
    return $75472431f73f934f$var$requestJson('POST', '/dicom/sessions', payload, opts);
}
function $75472431f73f934f$export$1215abca88606fce(sessionId, payload, opts) {
    return $75472431f73f934f$var$requestJson('POST', `/dicom/sessions/${encodeURIComponent(sessionId)}/commit`, payload || {}, opts);
}
async function $75472431f73f934f$export$a19aba171dab428(sessionId) {
    if (!sessionId) return;
    try {
        await $75472431f73f934f$var$requestJson('DELETE', `/dicom/sessions/${encodeURIComponent(sessionId)}`);
    } catch  {}
}
function $75472431f73f934f$export$f884bdf12a147dbe(sessionId, instances, { onProgress: onProgress, signal: signal } = {}) {
    return $75472431f73f934f$export$a3b7721557df7601().then((headers)=>new Promise((resolve, reject)=>{
            const form = new FormData();
            instances.forEach((it)=>form.append('files', it.file, it.name || it.file?.name || 'instance.dcm'));
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${$75472431f73f934f$export$a9b90d04cbeb257e()}/dicom/sessions/${encodeURIComponent(sessionId)}/batches`);
            Object.entries(headers).forEach(([k, v])=>xhr.setRequestHeader(k, v));
            const onAbort = ()=>xhr.abort();
            if (signal) {
                if (signal.aborted) {
                    reject(new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted'));
                    return;
                }
                signal.addEventListener('abort', onAbort, {
                    once: true
                });
            }
            const done = ()=>signal?.removeEventListener?.('abort', onAbort);
            xhr.upload.onprogress = (e)=>{
                if (e.lengthComputable) onProgress?.(e.loaded);
            };
            xhr.onload = ()=>{
                done();
                let body = null;
                try {
                    body = JSON.parse(xhr.responseText);
                } catch  {}
                if (xhr.status >= 200 && xhr.status < 300) resolve(body || {});
                else reject($75472431f73f934f$var$errorFrom(xhr.status, body));
            };
            xhr.onerror = ()=>{
                done();
                reject(new $75472431f73f934f$export$ed9681397fa5101a('NETWORK', 'network error during upload'));
            };
            xhr.onabort = ()=>{
                done();
                reject(new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted'));
            };
            xhr.send(form);
        }));
}
function $75472431f73f934f$export$f146c102d7613638(err) {
    if (!err || err.code === 'ABORTED') return false;
    if (err.code === 'NETWORK') return true;
    return err.status === 408 || err.status === 429 || err.status >= 500 && err.code !== 'DICOM_RECORD_PENDING';
}


const $a9fe471dd730c044$export$1b4f8208f28b4aed = ()=>`${(0, $75472431f73f934f$export$a9b90d04cbeb257e)()}/dicom-web`;
const $a9fe471dd730c044$var$enc = encodeURIComponent;
function $a9fe471dd730c044$export$e382c1f734fd6fcc(studyUid, seriesUid) {
    return `${$a9fe471dd730c044$export$1b4f8208f28b4aed()}/studies/${$a9fe471dd730c044$var$enc(studyUid)}/series/${$a9fe471dd730c044$var$enc(seriesUid)}/thumbnail`;
}
function $a9fe471dd730c044$export$4c5664a761278db0(studyUid, seriesUid, sopUid, { frame: frame = 1, window: window = null, size: size = 1024 } = {}) {
    const q = new URLSearchParams({
        frame: String(frame),
        size: String(size)
    });
    if (window) q.set('window', window);
    return `${$a9fe471dd730c044$export$1b4f8208f28b4aed()}/studies/${$a9fe471dd730c044$var$enc(studyUid)}/series/${$a9fe471dd730c044$var$enc(seriesUid)}/instances/${$a9fe471dd730c044$var$enc(sopUid)}/rendered?${q}`;
}
async function $a9fe471dd730c044$export$3a2589cc21066709(url, { signal: signal } = {}) {
    const res = await fetch(url, {
        headers: {
            ...await (0, $75472431f73f934f$export$a3b7721557df7601)(),
            Accept: 'image/jpeg, image/*'
        },
        signal: signal
    });
    if (!res.ok) {
        const err = new Error(`image ${res.status}`);
        err.status = res.status;
        throw err;
    }
    const blob = await res.blob();
    return URL.createObjectURL(blob);
}
const $a9fe471dd730c044$export$225fbfbd424a214e = Object.freeze([
    {
        id: 'brain',
        center: 40,
        width: 80
    },
    {
        id: 'lung',
        center: -600,
        width: 1500
    },
    {
        id: 'bone',
        center: 300,
        width: 1500
    },
    {
        id: 'abdomen',
        center: 40,
        width: 400
    },
    {
        id: 'softTissue',
        center: 50,
        width: 350
    }
]);
const $a9fe471dd730c044$export$eaa947fb3d44a841 = Object.freeze({
    id: 'auto',
    center: null,
    width: null
});
function $a9fe471dd730c044$export$5d687327647c3afb(modality) {
    return String(modality || '').toUpperCase() === 'CT' ? [
        $a9fe471dd730c044$export$eaa947fb3d44a841,
        ...$a9fe471dd730c044$export$225fbfbd424a214e
    ] : [
        $a9fe471dd730c044$export$eaa947fb3d44a841
    ];
}
function $a9fe471dd730c044$export$8fc65bc1bd573695(presetId, modality) {
    const p = $a9fe471dd730c044$export$5d687327647c3afb(modality).find((x)=>x.id === presetId);
    return p && p.center != null ? `${p.center},${p.width}` : null;
}
function $a9fe471dd730c044$export$ccb65542726085d6(study) {
    const list = study?.series || [];
    return list.reduce((best, s)=>!best || (s.instances || 0) > (best.instances || 0) ? s : best, null);
}
function $a9fe471dd730c044$export$3963a516697574a(series) {
    const out = [];
    (series?.instances || []).slice().sort((a, b)=>(a.number ?? 0) - (b.number ?? 0)).forEach((inst)=>{
        const n = Math.max(1, inst.frames || 1);
        for(let f = 1; f <= n; f += 1)out.push({
            sopUid: inst.sopUid,
            frame: f
        });
    });
    return out;
}
function $a9fe471dd730c044$export$5fe06db7379f90a6(study) {
    const d = study?.documentObjects;
    return Boolean(d && (d.sr || 0) + (d.encapsulatedPdf || 0) + (d.secondaryCapture || 0) > 0);
}
const $a9fe471dd730c044$export$918b21086f1a685e = (file)=>String(file?.mediaClass || '').toLowerCase() === 'dicom';



var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");



function $7fab7b93fa77b6d7$export$2e2bcd8739ae039({ study: study, seriesUid: seriesUid, modality: modality, size: size = '2rem', testid: testid = 'dicom-thumbnail' }) {
    const series = seriesUid ? null : (0, $a9fe471dd730c044$export$ccb65542726085d6)(study);
    const studyUid = study?.studyUid;
    const targetSeries = seriesUid || series?.seriesUid;
    const canFetch = Boolean(studyUid && targetSeries && study?.rendered !== false);
    const [url, setUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!canFetch) {
            setUrl(null);
            return undefined;
        }
        const controller = new AbortController();
        let objectUrl = null;
        (0, $a9fe471dd730c044$export$3a2589cc21066709)((0, $a9fe471dd730c044$export$e382c1f734fd6fcc)(studyUid, targetSeries), {
            signal: controller.signal
        }).then((u)=>{
            if (controller.signal.aborted) {
                URL.revokeObjectURL(u);
                return;
            }
            objectUrl = u;
            setUrl(u);
        }).catch(()=>{
            if (!controller.signal.aborted) setUrl(null);
        });
        return ()=>{
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [
        canFetch,
        studyUid,
        targetSeries
    ]);
    const mark = modality || series?.modality || (study?.modalities || [])[0] || '';
    const box = {
        width: size,
        height: size,
        borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
        flexShrink: 0,
        overflow: 'hidden',
        background: url ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).accentInk,
        display: 'grid',
        placeItems: 'center'
    };
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: box,
        "data-testid": testid,
        "data-state": "content",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: url,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: box,
        "data-testid": testid,
        "data-state": "fallback",
        "aria-hidden": true
    }, mark ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            letterSpacing: '0.02em'
        }
    }, mark) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ccc00afea4040e64$export$2e2bcd8739ae039), {
        size: 16,
        strokeWidth: 1.75
    }));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// «مدارک بیمار» — the limits and byte handling of the doctor's own uploads and
// downloads. docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3, §7.6.
//
// One place for every number the upload flow enforces, so the dropzone's helper
// line, its refusals and the queue cannot quote three different limits.
// The BFF refuses a file larger than 0.7 × its JSON body limit (20 MB): base64
// inflates by 4/3, and a body past the limit is an opaque 413 before any resolver
// runs. The design's first draft said 15 MB, which base64 turns into exactly the
// limit plus the JSON around it — 14 is the largest size that always fits.
const $2dcdf1c1963f00da$export$b9158b9f13d80898 = 14680064;
const $2dcdf1c1963f00da$export$7c6f6c38c781ae96 = 5;
const $2dcdf1c1963f00da$export$48c908e1ec06ccc6 = 10485760;
const $2dcdf1c1963f00da$var$EXT_MIME = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf',
    webp: 'image/webp',
    gif: 'image/gif',
    bmp: 'image/bmp'
};
function $2dcdf1c1963f00da$export$f36c73f7356be416(policy) {
    const ceiling = Number(policy?.ceilings?.documentBytes) || $2dcdf1c1963f00da$export$b9158b9f13d80898;
    const physical = Math.min(ceiling, $2dcdf1c1963f00da$export$b9158b9f13d80898);
    if (!policy) return physical;
    if (policy.sizeLimitEnabled && Number(policy.maxFileBytes) > 0) return Math.min(Number(policy.maxFileBytes), physical);
    return physical;
}
const $2dcdf1c1963f00da$export$a9a070740fdaf1b0 = Object.freeze({
    DICOM_DISABLED: 'patient.files.dicom.errors.DICOM_DISABLED',
    DICOM_UNAVAILABLE: 'patient.files.dicom.errors.DICOM_UNAVAILABLE',
    STUDY_UID_CONFLICT: 'patient.files.dicom.errors.STUDY_UID_CONFLICT',
    DICOM_LIMIT_STUDY: 'patient.files.dicom.errors.DICOM_LIMIT_STUDY',
    DICOM_LIMIT_INSTANCES: 'patient.files.dicom.errors.DICOM_LIMIT_INSTANCES',
    DICOM_QUOTA: 'patient.files.dicom.errors.DICOM_QUOTA',
    DICOM_SESSION_EXPIRED: 'patient.files.dicom.errors.DICOM_SESSION_EXPIRED',
    DICOM_INSTANCE_TOO_LARGE: 'patient.files.dicom.errors.DICOM_INSTANCE_TOO_LARGE',
    DICOM_NO_FILES: 'patient.files.dicom.errors.DICOM_NO_FILES',
    FORBIDDEN: 'patient.files.dicom.errors.FORBIDDEN',
    DICOM_RECORD_PENDING: 'patient.files.dicom.errors.DICOM_RECORD_PENDING',
    // The BFF's own transport refusals (not in §24.10's list, added by the BFF build).
    DICOM_BATCH_TOO_LARGE: 'patient.files.dicom.errors.DICOM_BATCH_TOO_LARGE',
    BAD_REQUEST: 'patient.files.dicom.errors.failed',
    UNAUTHENTICATED: 'patient.files.dicom.errors.UNAUTHENTICATED',
    OFFLINE: 'patient.files.upload.offline',
    NETWORK: 'patient.files.dicom.errors.NETWORK'
});
const $2dcdf1c1963f00da$var$extensionOf = (name)=>String(name || '').toLowerCase().split('.').pop();
function $2dcdf1c1963f00da$export$516ffdc000f2cdae(file) {
    return (file?.type || $2dcdf1c1963f00da$var$EXT_MIME[$2dcdf1c1963f00da$var$extensionOf(file?.name)] || '').toLowerCase();
}
function $2dcdf1c1963f00da$export$cf709db89eaa620b(file) {
    const type = String(file?.type || '').toLowerCase();
    return type === 'image/heic' || type === 'image/heif' || [
        'heic',
        'heif'
    ].includes($2dcdf1c1963f00da$var$extensionOf(file?.name));
}
const $2dcdf1c1963f00da$export$d56bb2ab6cd19776 = (bytes)=>Math.round((Number(bytes) || 0) / 1048576 * 10) / 10;
function $2dcdf1c1963f00da$export$d16689d79378b0e4(t, formatNumber, bytes) {
    const n = Number(bytes) || 0;
    if (n >= 1073741824) return t('patient.files.sizeGb', {
        value: formatNumber(Math.round(n / 1073741824 * 10) / 10)
    });
    return t('patient.files.upload.size', {
        mb: formatNumber($2dcdf1c1963f00da$export$d56bb2ab6cd19776(n))
    });
}
function $2dcdf1c1963f00da$export$25df2e315be8e003(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(String(reader.result || '').split(',')[1] || '');
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(file);
    });
}
function $2dcdf1c1963f00da$export$64f75967084abe8e(uri) {
    const m = /^data:([^;,]*)(;base64)?,([\s\S]*)$/.exec(String(uri || ''));
    if (!m || !m[2]) return null;
    return {
        contentType: m[1] || 'application/octet-stream',
        data: m[3]
    };
}
function $2dcdf1c1963f00da$export$b3fb17ae4345ac8f(data, type) {
    const binary = atob(String(data || ''));
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i += 1)bytes[i] = binary.charCodeAt(i);
    return new Blob([
        bytes
    ], {
        type: type || 'application/octet-stream'
    });
}
function $2dcdf1c1963f00da$export$9016c9576545678(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'document';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $2dcdf1c1963f00da$export$d4b677401f6be1f8(t, has, err, fallbackKey) {
    const key = err?.extensions?.messageKey;
    if (key && typeof has === 'function' && has(key)) return t(key);
    if (err?.extensions?.code === 'INSUFFICIENT_CREDITS') return t('patient.files.extract.credit');
    const message = String(err?.message || '');
    if (message && err?.extensions?.messageKey) return message;
    return t(fallbackKey);
}


function $00e4129789459a85$export$8b4ef6368b96e1d9({ modality: modality, testid: testid = 'file-modality' }) {
    if (!modality) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "accent",
        "data-testid": testid,
        dir: "ltr",
        style: {
            unicodeBidi: 'isolate'
        }
    }, modality);
}
function $00e4129789459a85$export$6a1ed6b8a13ed847(t, formatNumber, study) {
    if (!study) return '';
    const parts = [
        t('patient.files.dicom.seriesCount', {
            count: formatNumber(study.seriesCount ?? (study.series || []).length)
        }),
        t('patient.files.dicom.imageCount', {
            count: formatNumber(study.instanceCount ?? 0)
        })
    ];
    const bytes = study.storedBytes ?? study.bytes;
    if (bytes) parts.push((0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, bytes));
    return parts.join(" \xb7 ");
}
function $00e4129789459a85$export$de7977fb4fae854b({ verdict: verdict, testid: testid = 'file-identity' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (verdict !== 'mismatch' && verdict !== 'partial') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "warn",
        "data-testid": testid,
        "data-verdict": verdict
    }, t(verdict === 'mismatch' ? 'patient.files.dicom.identity.mismatchChip' : 'patient.files.dicom.identity.partialChip'));
}
function $00e4129789459a85$export$afd3e13bab74f45d({ study: study, testid: testid = 'file-lossy' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!study?.lossySource) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        "data-testid": testid
    }, t('patient.files.dicom.lossyChip'));
}
const $00e4129789459a85$var$sexKey = (sex)=>{
    const s = String(sex || '').toUpperCase();
    if (s === 'M') return 'patient.files.dicom.sex.M';
    if (s === 'F') return 'patient.files.dicom.sex.F';
    return null;
};
function $00e4129789459a85$export$a1bc28ff57200918(t, formatDate, header) {
    if (!header) return '';
    const parts = [];
    if (header.name) parts.push(header.name);
    if (header.birthDate) parts.push((0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(header.birthDate, formatDate));
    const sk = $00e4129789459a85$var$sexKey(header.sex);
    if (sk) parts.push(t(sk));
    return parts.join(" \xb7 ");
}
function $00e4129789459a85$export$1090f771f7d0b229({ file: file, patient: patient, onConfirm: onConfirm, confirming: confirming = false, testid: testid = 'dicom-identity' }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const study = file?.dicom;
    if (!study || study.identityCheck !== 'mismatch') return null;
    const onFile = $00e4129789459a85$export$a1bc28ff57200918(t, formatDate, study.headerPatient) || t('patient.files.dicom.identity.empty');
    const inRecord = patient ? [
        patient.name,
        patient.birthDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(String(patient.birthDate).slice(0, 10), formatDate) : null
    ].filter(Boolean).join(" \xb7 ") : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": testid,
        action: onConfirm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onConfirm,
            disabled: confirming,
            "data-testid": `${testid}-confirm`
        }, confirming ? t('common.state.saving') : t('patient.files.dicom.identity.confirm')) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.dicom.identity.mismatch')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '0.125rem 0.5rem',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.dicom.identity.onFile')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        "data-testid": `${testid}-on-file`
    }, onFile), inRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.dicom.identity.inRecord')), inRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        "data-testid": `${testid}-in-record`
    }, inRecord))));
}
function $00e4129789459a85$export$3a5c932de3a0f9c9({ study: study, testid: testid = 'dicom-lossy' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!study?.lossySource) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": testid
    }, t('patient.files.dicom.lossy'));
}
function $00e4129789459a85$export$31a954d36640d797({ study: study, testid: testid = 'dicom-metadata' }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber, formatList: formatList } = (0, $LNQP4.default)();
    if (!study) return null;
    const rows = [
        [
            'modality',
            (study.modalities || []).join(', '),
            'ltr'
        ],
        [
            'studyDate',
            study.studyDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(study.studyDate, formatDate) : ''
        ],
        [
            'studyTime',
            study.studyTime || '',
            'ltr'
        ],
        [
            'description',
            study.description || '',
            'auto'
        ],
        [
            'bodyParts',
            (study.bodyParts || []).length ? formatList(study.bodyParts) : '',
            'ltr'
        ],
        [
            'counts',
            $00e4129789459a85$export$6a1ed6b8a13ed847(t, formatNumber, study)
        ],
        [
            'institution',
            study.institutionName || '',
            'auto'
        ],
        [
            'referring',
            study.referringPhysician || '',
            'auto'
        ],
        [
            'accession',
            study.accessionNumber || '',
            'ltr'
        ],
        [
            'transcoded',
            study.transcoded ? t('patient.files.dicom.meta.transcodedLossless') : ''
        ]
    ].filter(([, value])=>value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
        "data-testid": testid,
        style: {
            margin: 0,
            display: 'grid',
            gridTemplateColumns: 'minmax(6rem, auto) 1fr',
            gap: '0.25rem 0.75rem',
            fontSize: '0.75rem'
        }
    }, rows.map(([key, value, dir])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t(`patient.files.dicom.meta.${key}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            "data-testid": `${testid}-${key}`,
            dir: dir,
            style: {
                margin: 0,
                color: (0, $jTCZr.CT).ink,
                unicodeBidi: dir ? 'isolate' : undefined,
                wordBreak: 'break-word'
            }
        }, value))));
}


const $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a = {
    LAB: (0, $4CVxl.default),
    IMAGING: (0, $ccc00afea4040e64$export$2e2bcd8739ae039),
    MEDICAL_REPORT: (0, $3FyOw.default),
    PRESCRIPTION: (0, $aVx4q.default),
    TREATMENT_DOCUMENT: (0, $ggYuf.default),
    OTHER: (0, $824b163d7442530e$export$2e2bcd8739ae039)
};
const $b2efaf4152cb92eb$var$TONES = {
    neutral: {
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).ink2,
        border: `1px solid ${(0, $jTCZr.CT).border}`
    },
    accent: {
        background: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk,
        border: '1px solid transparent'
    },
    good: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        border: '1px solid transparent'
    },
    warn: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        border: '1px solid transparent'
    }
};
function $b2efaf4152cb92eb$export$ba419c27a5974bb1({ tone: tone = 'neutral', children: children, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...rest,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.0625rem 0.4375rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            fontSize: '0.6875rem',
            fontWeight: 600,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            ...$b2efaf4152cb92eb$var$TONES[tone],
            ...style
        }
    }, children);
}
function $b2efaf4152cb92eb$export$7dee33e761ba98a6(value, formatDate) {
    if (!value) return '';
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value;
    try {
        return formatDate(iso, 'medium');
    } catch  {
        return String(value);
    }
}
function $b2efaf4152cb92eb$export$6047a074a83ec744({ file: file, clinicName: clinicName }) {
    const { t: t } = (0, $LNQP4.default)();
    const kindKey = (0, $157d5bd48cfffbad$export$d2ebff77a9864278)(file.kind);
    const proc = (0, $157d5bd48cfffbad$export$47893326198c9a54)(file.processingStatus);
    const study = (0, $a9fe471dd730c044$export$918b21086f1a685e)(file) ? file.dicom : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, study ? (study.modalities || []).slice(0, 3).map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$8b4ef6368b96e1d9), {
            key: m,
            modality: m,
            testid: `file-modality-${m}`
        })) : kindKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-kind"
    }, t(kindKey)), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$de7977fb4fae854b), {
        verdict: study.identityCheck
    }), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$afd3e13bab74f45d), {
        study: study
    }), file.uploadedBy === 'patient' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        tone: "accent",
        "data-testid": "file-uploaded-by-patient"
    }, t('visit.orders.result.uploadedByPatient')), file.uploadedBy === 'modality' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-uploaded-by-modality"
    }, t('patient.files.dicom.fromModality')), file.promotedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        tone: "good",
        "data-testid": "file-promoted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": true
    }), " ", t('patient.files.promoted')), (0, $157d5bd48cfffbad$export$ca16185462233788)(file.processingStatus) && proc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-processing",
        style: {
            background: proc.bg,
            color: proc.text,
            border: '1px solid transparent'
        }
    }, t(proc.labelKey)), clinicName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-clinic",
        dir: "auto"
    }, clinicName));
}
function $b2efaf4152cb92eb$export$2e2bcd8739ae039({ file: file, onOpen: onOpen, onView: onView, onExtract: onExtract, onEdit: onEdit, onDownload: onDownload, onDelete: onDelete, clinicName: clinicName, dense: dense = false, touch: touch = false, testid: testid = 'file-row' }) {
    // A phone needs ≥ 2.75rem targets (MOBILE_WEB_PWA §5); a workstation row stays compact.
    const iconSize = touch ? 'h-11 w-11' : 'h-9 w-9';
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const moreRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const kind = (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(file.kind);
    const Icon = $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a[kind] || (0, $824b163d7442530e$export$2e2bcd8739ae039);
    const date = (0, $bced050439dec003$export$8be12e4e93c8dacd)(file);
    const study = (0, $a9fe471dd730c044$export$918b21086f1a685e)(file) ? file.dicom : null;
    const isStudy = (0, $a9fe471dd730c044$export$918b21086f1a685e)(file);
    const canEdit = Boolean(file.canEdit && onEdit);
    const canDelete = Boolean(file.canDelete && onDelete);
    // A study is read by AI only through its document objects (SR, PDF, secondary
    // capture) — never the diagnostic images themselves (§9.9).
    const canExtract = Boolean(file.extractable && onExtract && (!isStudy || (0, $a9fe471dd730c044$export$5fe06db7379f90a6)(study)));
    // A study has no single file to download.
    const canDownload = Boolean(onDownload) && !isStudy;
    const hasMenu = canEdit || canDownload || canDelete;
    const view = isStudy && onView ? onView : onOpen;
    const pick = (fn)=>()=>{
            setMenuOpen(false);
            fn(file);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-${file.id}`,
        "data-kind": kind || 'unknown',
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.625rem',
            padding: dense ? '0.5rem 0' : '0.625rem 0.25rem',
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginTop: '0.125rem',
            display: 'inline-flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fab7b93fa77b6d7$export$2e2bcd8739ae039), {
        study: study,
        testid: `${testid}-thumb-${file.id}`,
        size: "2rem"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '2rem',
            height: '2rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
            flexShrink: 0,
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center',
            marginTop: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        strokeWidth: 1.75
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: ()=>onOpen?.(file),
        "aria-label": t('patient.files.openDetail', {
            name: file.fileName
        }),
        "data-testid": `${testid}-open-${file.id}`,
        className: "flex-1 min-w-0 h-auto min-h-11 justify-start px-0 py-0.5 font-normal hover:bg-transparent text-start",
        style: {
            display: 'block'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        title: file.fileName,
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink,
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            unicodeBidi: 'isolate'
        }
    }, file.fileName || t('patient.files.file')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$6047a074a83ec744, {
        file: file,
        clinicName: clinicName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-date"
    }, $b2efaf4152cb92eb$export$7dee33e761ba98a6(date, formatDate)), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-study-meta"
    }, "\xb7 ", (0, $00e4129789459a85$export$6a1ed6b8a13ed847)(t, formatNumber, study)), (0, $bced050439dec003$export$d791f2a3277ada5e)(file) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-uploaded-at"
    }, "\xb7 ", t('patient.files.uploadedOn', {
        date: $b2efaf4152cb92eb$export$7dee33e761ba98a6(file.createdAt, formatDate)
    })), file.resolvedOrder?.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-answers-order",
        dir: "auto"
    }, "\xb7 ", t('visit.orders.result.answersOrder'), ": ", file.resolvedOrder.description)), file.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-description",
        dir: "auto",
        title: file.description,
        style: {
            display: 'block',
            marginTop: '0.1875rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, file.description), file.processingStatus === 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-failure",
        "data-error-code": file.processingError || 'unknown',
        style: {
            display: 'block',
            marginTop: '0.1875rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t((0, $157d5bd48cfffbad$export$70f239c59f207d0)(file.processingError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.125rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t(isStudy ? 'patient.files.dicom.viewImages' : 'patient.files.actions.view'),
        title: t(isStudy ? 'patient.files.dicom.viewImages' : 'patient.files.actions.view'),
        "data-testid": `${testid}-view-${file.id}`,
        onClick: ()=>view?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gr49X.default), {
        size: 16,
        "aria-hidden": true
    })), canExtract && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t('patient.files.actions.extract'),
        title: t('patient.files.actions.extract'),
        "data-testid": `${testid}-extract-${file.id}`,
        onClick: ()=>onExtract(file),
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    })), hasMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: moreRef,
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t('patient.files.actions.more'),
        title: t('patient.files.actions.more'),
        "aria-haspopup": "menu",
        "aria-expanded": menuOpen,
        "data-testid": `${testid}-more-${file.id}`,
        onClick: ()=>setMenuOpen((v)=>!v)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: menuOpen,
        onClose: ()=>setMenuOpen(false),
        anchorRef: moreRef,
        width: 200,
        placement: "auto",
        ariaLabel: t('patient.files.actions.more'),
        "data-testid": `${testid}-menu-${file.id}`
    }, canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onEdit),
        "data-testid": `${testid}-edit-${file.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.edit')), canDownload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onDownload),
        "data-testid": `${testid}-download-${file.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onDelete),
        "data-testid": `${testid}-delete-${file.id}`,
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete'))))));
}



// The in-visit patient record BottomSheet — the phone's rendering of the desktop
// Visit CONTEXT PANEL (Visit.web.jsx, gridColumn 1), which is the source of
// truth for what the record contains and in what order:
//
//   افزودن نتیجه → allergies → مشخصات (+ویرایش) → علائم حیاتی (+تاریخچه)
//   → داروهای جاری → تشخیص‌های فعال → سابقه بیماری → نتایج آزمایش → مراجعات اخیر
//
// Data + persistence live in the screen; this is render-only. Destructive
// actions (stop a med, remove a diagnosis) are confirm-gated (§6/§9) and both
// are undoable, exactly as on desktop.
const $e0b3b7ef84bbae65$var$VITAL_FIELDS = (t)=>[
        {
            key: 'bpSys',
            label: 'BP sys',
            unit: 'mmHg'
        },
        {
            key: 'bpDia',
            label: 'BP dia',
            unit: 'mmHg'
        },
        {
            key: 'pulse',
            label: t('visit.vitals.pulse'),
            unit: 'bpm'
        },
        {
            key: 'spo2',
            label: "SpO\u2082",
            unit: '%'
        },
        {
            key: 'temp',
            label: t('patient.vitals.temp'),
            unit: "\xb0C"
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg'
        }
    ];
// Non-vital observations are the "lab results" list; the same LOINC codes the
// desktop context panel filters out.
const $e0b3b7ef84bbae65$var$VITAL_CODES_CTX = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
// One record section, with the desktop rail's header grammar (Visit.web.jsx
// `RecordSection`): title + count pill + one-line gist SHOWN ONLY WHILE
// COLLAPSED + inline actions + chevron. Same `record-section-<id>` /
// `record-toggle-<id>` testids, because it is the same section.
//
// The chevron turns rather than pointing sideways: «down = open me, up = close
// me» needs no mirroring, and this sheet is read in both directions.
const $e0b3b7ef84bbae65$var$Section = ({ id: id, title: title, count: count, badge: badge, gist: gist, action: action, open: open, onToggle: onToggle, children: children })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `record-section-${id}`,
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: ()=>onToggle(id),
        "aria-expanded": open,
        "data-testid": `record-toggle-${id}`,
        "aria-label": open ? t('visit.recordPanel.collapseSection', {
            title: title
        }) : t('visit.recordPanel.expandSection', {
            title: title
        }),
        className: "flex-1 min-h-11 h-auto justify-start gap-1.5 px-0 py-2 hover:bg-transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.C).textMuted,
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .18s'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 500,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(count)), badge), !open && gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.125rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, gist))), action), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: '0.75rem'
        }
    }, children));
};
const $e0b3b7ef84bbae65$var$UndoBanner = ({ text: text, onUndo: onUndo, testId: testId })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            padding: '0.4375rem 0.625rem',
            borderRadius: '0.5rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textSecondary
        }
    }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 shrink-0",
        onClick: onUndo
    }, t('visit.orders.undo')));
};
const $e0b3b7ef84bbae65$var$MobileVisitRecordSheet = ({ open: open, onClose: onClose, patient: patient, vitals: vitals, onVitalChange: onVitalChange, vitalsMode: vitalsMode, onVitalsSave: onVitalsSave, vitalsLoading: vitalsLoading, vitalsError: vitalsError, vitalsAlert: vitalsAlert, onDismissVitalsAlert: onDismissVitalsAlert, onEditVitals: onEditVitals, onVitalsHistory: onVitalsHistory, vitalsComplete: vitalsComplete = null, vitalsProposal: vitalsProposal = null, recordComplete: recordComplete = null, meds: meds, onStopMed: onStopMed, undoMed: undoMed, onUndoMed: onUndoMed, diagnoses: diagnoses = [], onRemoveDiagnosis: onRemoveDiagnosis, undoCondition: undoCondition, onUndoCondition: onUndoCondition, conditions: conditions, labResults: labResults = [], pastVisits: pastVisits, encounters: encounters = [], clinicalNotes: clinicalNotes = [], onUploadLab: onUploadLab, onEditPatient: onEditPatient, onRepresribeMed: // ── Parity extensions (docs/mobile-visit-redesign.md §5.6) ─────────────────
// تجویز مجدد: a current medication and a drug from a past visit are the same
// refill door, keyed by NAME — a record row and a formulary entry never share
// an id, and the same drug must read «در نسخه» whichever door it came through.
onRepresribeMed, prescribedNames: prescribedNames, onChangeDxType: // «نوع تشخیص» in place: the only edit path for a diagnosis typed into SOAP «A».
onChangeDxType, dxTypeBusyId: dxTypeBusyId, visitContexts: // Past-visit detail is fetched on expand, not with the record: a visit the
// doctor never opens costs nothing.
visitContexts = {}, onOpenVisit: onOpenVisit, onViewAllLabs: // The labs preview truncates; this opens the full list rather than telling the
// doctor how many results they cannot see.
onViewAllLabs, sections: // ── The doctor's layout (Settings → «صفحه ویزیت») ──────────────────────────
// `sections` is the RESOLVED, ordered, visible list (visitLayout.js); the
// screen owns `recordOpen` and its persistence, exactly as the desktop rail
// does, so this stays render-only. Absent, every section renders open in
// catalogue order — the sheet has no opinion of its own.
sections, recordOpen: recordOpen = {}, onToggleSection: onToggleSection, onEditLayout: onEditLayout, files: // «مدارک بیمار»: the patient's documents (sorted by the screen) and the actions the
// screen's `useClinicalFiles` host performs.
files = [], currentVisitId: currentVisitId = null, onOpenFile: onOpenFile, onViewFile: onViewFile, onExtractFile: onExtractFile, onEditFile: onEditFile, onDownloadFile: onDownloadFile, onDeleteFile: onDeleteFile })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatList: formatList, formatRelativeTime: formatRelativeTime, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const [pendingStop, setPendingStop] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pendingDx, setPendingDx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [openVisitId, setOpenVisitId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [dxTypePick, setDxTypePick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // condition id being retyped
    const [showAllFiles, setShowAllFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const p = patient || {};
    const isPrescribed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((name)=>!!prescribedNames?.has?.((name || '').trim().toLowerCase()), [
        prescribedNames
    ]);
    // Same four facts the desktop demographics grid shows.
    const demo = [
        {
            k: t('common.labels.age'),
            v: p.age != null ? t('patient.ageYears', {
                count: formatDigits(p.age)
            }) : "\u2014"
        },
        {
            k: t('visit.patient.bloodType'),
            v: p.bloodType || "\u2014"
        },
        {
            k: t('visit.patient.insurance'),
            v: (0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance] ? t((0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance]) : p.insurance || "\u2014"
        },
        {
            k: 'BMI',
            v: p.bmi ? formatDigits(p.bmi) : "\u2014"
        }
    ];
    // Abnormal/critical first, then newest — the desktop ordering.
    const labs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(labResults || []).filter((o)=>!$e0b3b7ef84bbae65$var$VITAL_CODES_CTX.has(o.code)).slice().sort((a, b)=>{
            const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
            const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
            if (sA !== sB) return sA - sB;
            return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
        }).slice(0, 10), [
        labResults
    ]);
    const totalLabs = (labResults || []).filter((o)=>!$e0b3b7ef84bbae65$var$VITAL_CODES_CTX.has(o.code)).length;
    // Last three finished encounters, newest first (desktop «مراجعات اخیر»).
    const pastEncs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(encounters || []).slice().sort((a, b)=>new Date(b.periodStart) - new Date(a.periodStart)).filter((e)=>e.status === 'finished').slice(0, 3), [
        encounters
    ]);
    const summaries = pastVisits || [];
    const visitRows = pastEncs.length ? pastEncs : summaries;
    // Rendered only while a section is COLLAPSED, so a closed section still tells
    // the doctor what it holds — the desktop rail's rule, on the phone.
    const demoGist = demo.filter((d)=>d.v && d.v !== "\u2014").map((d)=>d.v).slice(0, 3).join(" \xb7 ");
    const vitalsGist = [
        vitals?.bpSys || vitals?.bpDia ? `${vitals.bpSys || "\u2014"}/${vitals.bpDia || "\u2014"}` : null,
        vitals?.spo2 ? `${formatDigits(vitals.spo2)}% SpO\u{2082}` : null,
        vitals?.pulse ? `${formatDigits(vitals.pulse)} bpm` : null
    ].filter(Boolean).join(" \xb7 ");
    const medsGist = formatList((meds || []).slice(0, 3).map((m)=>m.display));
    const dxGist = formatList((diagnoses || []).slice(0, 3).map((c)=>c.display));
    const condsGist = formatList((conditions || []).slice(0, 3));
    const labsGist = formatList(labs.slice(0, 3).map((o)=>o.display).filter(Boolean));
    const historyGist = visitRows[0]?.periodStart ? formatRelativeTime(visitRows[0].periodStart) : null;
    const labCritical = labs.filter((o)=>o.status === 'CRITICAL').length;
    const labAbnormal = labs.filter((o)=>o.status === 'ABNORMAL').length;
    const labsBadge = labCritical > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).danger,
            color: '#fff'
        }
    }, t('visit.recordPanel.criticalCount', {
        count: formatDigits(labCritical)
    })) : labAbnormal > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.C).amberLight,
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('visit.recordPanel.abnormalCount', {
        count: formatDigits(labAbnormal)
    })) : null;
    // The doctor's order, or the catalogue's when the screen passes none.
    const sectionList = sections || (0, $792124e2f7de719a$export$e111fe7e8e6c2d5d)((0, $792124e2f7de719a$export$e88ad8319f3008b2)(null));
    const toggleSection = onToggleSection || (()=>{});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.record'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-record-sheet"
    }, recordComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, recordComplete), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.75rem'
        }
    }, onUploadLab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        className: "flex-1 min-h-11 gap-1.5",
        "data-testid": "visit-record-upload",
        onClick: onUploadLab
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile')), onEditLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: `min-h-11 gap-1.5 shrink-0${onUploadLab ? '' : ' flex-1'}`,
        "data-testid": "visit-record-edit-layout",
        onClick: onEditLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2cf9022b4ea6e252$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.recordPanel.editLayout'))), (()=>{
        const blocks = {
            /* Demographics + ویرایش */ demo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "demo",
                title: t('visit.patient.details'),
                gist: demoGist,
                action: onEditPatient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-demographics-edit",
                    onClick: onEditPatient
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
                    size: 12,
                    "aria-hidden": true
                }), " ", t('common.actions.edit')) : null,
                open: recordOpen['demo'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0.5rem 0.875rem'
                }
            }, demo.map(({ k: k, v: v })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        fontWeight: 600
                    }
                }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.8125rem',
                        color: (0, $jTCZr.C).textPrimary,
                        fontWeight: 500
                    }
                }, v))))),
            /* Vitals — alert, then the recorder (form ⇄ saved) */ vitals: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "vitals",
                title: vitalsMode === 'saved' ? t('visit.vitals.thisVisit') : t('visit.vitals.record'),
                gist: vitalsGist,
                action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                    }
                }, vitalsComplete, onVitalsHistory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-vitals-history",
                    onClick: onVitalsHistory
                }, t('common.actions.viewDetails'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 12,
                    "aria-hidden": true
                })), vitalsMode === 'saved' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "subtle",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-vitals-edit",
                    onClick: onEditVitals
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
                    size: 12,
                    "aria-hidden": true
                }), " ", t('common.actions.edit'))),
                open: recordOpen['vitals'] !== false,
                onToggle: toggleSection
            }, vitalsProposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginBottom: '0.625rem'
                }
            }, vitalsProposal), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-vitals-alert",
                style: {
                    borderRadius: '0.5rem',
                    padding: '0.5625rem 0.6875rem',
                    marginBottom: '0.625rem',
                    background: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).amberLight,
                    border: `1.5px solid ${vitalsAlert.level === 'critical' ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.45) : (0, $jTCZr.CT).warn}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    marginBottom: '0.1875rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
                size: 12,
                "aria-hidden": true,
                style: {
                    color: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    color: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
                }
            }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning'))), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, m)), onDismissVitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "min-h-11 mt-1",
                onClick: onDismissVitalsAlert
            }, t('common.actions.close'))), vitalsMode === 'saved' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0.5rem'
                }
            }, $e0b3b7ef84bbae65$var$VITAL_FIELDS(t).filter((f)=>vitals[f.key]).map(({ key: key, label: label, unit: unit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        background: (0, $jTCZr.C).greenLight,
                        border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.35)}`,
                        borderRadius: '0.5rem',
                        padding: '0.5rem 0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        marginBottom: '0.1875rem'
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: '0.1875rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, formatDigits(vitals[key])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, unit))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: '0.5rem'
                }
            }, $e0b3b7ef84bbae65$var$VITAL_FIELDS(t).map(({ key: key, label: label, unit: unit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        minWidth: 0,
                        background: (0, $jTCZr.CT).surface2,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.5rem',
                        padding: '0.5rem 0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        marginBottom: '0.125rem'
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    type: "text",
                    inputMode: "decimal",
                    dir: "ltr",
                    value: vitals[key] || '',
                    onChange: (e)=>onVitalChange(key, e.target.value),
                    "data-testid": `visit-vital-${key}`,
                    style: {
                        flex: 1,
                        minWidth: 0,
                        minHeight: '2.75rem',
                        border: 'none',
                        outline: 'none',
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        background: 'transparent',
                        color: (0, $jTCZr.C).textPrimary
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-vitals-error",
                style: {
                    borderRadius: '0.5rem',
                    padding: '0.5rem 0.6875rem',
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.12),
                    border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.4)}`,
                    marginTop: '0.625rem'
                }
            }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).red,
                        fontWeight: 600
                    }
                }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "default",
                size: "lg",
                onClick: onVitalsSave,
                disabled: vitalsLoading,
                "data-testid": "visit-vitals-save",
                className: "w-full min-h-11 mt-2.5"
            }, vitalsLoading ? t('visit.plan.saving') : t('visit.vitals.record')))),
            /* Current medications */ meds: (meds.length > 0 || undoMed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "meds",
                title: t('patient.meds.current'),
                count: meds.length,
                gist: medsGist,
                open: recordOpen['meds'] !== false,
                onToggle: toggleSection
            }, undoMed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$UndoBanner, {
                testId: "visit-med-undo",
                onUndo: onUndoMed,
                text: t('visit.rx.stoppedNotAdded', {
                    name: undoMed.display
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, meds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (m.id || m.display) + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.625rem',
                        padding: '0.625rem 0.75rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "icon",
                    className: "h-11 w-11 text-muted-foreground shrink-0",
                    "aria-label": t('patient.meds.stopAria', {
                        name: m.display
                    }),
                    "data-testid": `visit-med-stop-${m.id}`,
                    onClick: ()=>setPendingStop(m)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
                    size: 15,
                    "aria-hidden": true
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "auto",
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m)), m.warn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.25rem',
                        marginTop: '0.125rem',
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).warnInk
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
                    size: 10,
                    "aria-hidden": true
                }), m.warn), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, (0, $375f8776645d5aee$export$f1536cfec6e3f4b8)(m.dosageInstruction.text, t, readsPersianData))), onRepresribeMed && (isPrescribed(m.display) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "data-testid": `visit-med-represcribed-${m.id}`,
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.1875rem',
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).good,
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                    size: 12,
                    "aria-hidden": true
                }), t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "subtle",
                    size: "sm",
                    className: "min-h-11 gap-1 shrink-0",
                    "data-testid": `visit-med-represcribe-${m.id}`,
                    "aria-label": t('visit.rx.represcribeAria', {
                        name: m.display
                    }),
                    onClick: ()=>onRepresribeMed(m)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
                    size: 12,
                    "aria-hidden": true
                }), t('visit.rx.represcribe'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '1.75rem',
                        height: '1.75rem',
                        borderRadius: '0.5rem',
                        background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                    size: 14,
                    color: (0, $jTCZr.C).navy,
                    "aria-hidden": true
                })))))),
            /* Active diagnoses */ dx: (diagnoses.length > 0 || undoCondition) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "dx",
                title: t('patient.conditions.active'),
                count: diagnoses.length,
                gist: dxGist,
                open: recordOpen['dx'] !== false,
                onToggle: toggleSection
            }, undoCondition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$UndoBanner, {
                testId: "visit-dx-undo",
                onUndo: onUndoCondition,
                text: t('visit.dx.removedNamed', {
                    name: undoCondition.display
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, diagnoses.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (c.id || c.display) + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.625rem',
                        padding: '0.625rem 0.75rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "icon",
                    className: "h-11 w-11 text-muted-foreground shrink-0",
                    "aria-label": t('patient.conditions.removeAria', {
                        name: c.display
                    }),
                    "data-testid": `visit-dx-remove-${c.id}`,
                    onClick: ()=>setPendingDx(c)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
                    size: 15,
                    "aria-hidden": true
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.375rem',
                        flexWrap: 'wrap'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, c.display), onChangeDxType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 px-1",
                    "data-testid": `visit-dx-type-edit-${c.id}`,
                    "aria-label": `${t('visit.dx.type.change')} \u{2014} ${c.display}`,
                    disabled: dxTypeBusyId === c.id,
                    onClick: ()=>setDxTypePick(dxTypePick === c.id ? null : c.id)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
                    cond: c
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
                    cond: c
                })), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontFamily: 'ui-monospace, monospace'
                    }
                }, c.code), dxTypePick === c.id && onChangeDxType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$7085d532b18268b), {
                    current: (0, $4a744c4def3d338a$export$5d68a431913dd40b)(c),
                    busy: dxTypeBusyId === c.id,
                    testidPrefix: `visit-dx-type-choice-${c.id}`,
                    onCancel: ()=>setDxTypePick(null),
                    onPick: async (type)=>{
                        await onChangeDxType(c, type);
                        setDxTypePick(null);
                    }
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '1.75rem',
                        height: '1.75rem',
                        borderRadius: '0.5rem',
                        background: (0, $jTCZr.CT).accentSoft,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
                    size: 14,
                    color: (0, $jTCZr.CT).accentInk,
                    "aria-hidden": true
                })))))),
            /* Condition history */ conds: conditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "conds",
                title: t('visit.patient.conditionHistory'),
                count: conditions.length,
                gist: condsGist,
                open: recordOpen['conds'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.3125rem'
                }
            }, conditions.slice(0, 8).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: {
                        fontSize: '0.6875rem',
                        padding: '0.25rem 0.625rem',
                        borderRadius: '0.375rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        color: (0, $jTCZr.C).textSecondary
                    }
                }, c)))),
            /* Lab results */ labs: labs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "labs",
                title: t('visit.patient.labResults'),
                count: totalLabs,
                badge: labsBadge,
                gist: labsGist,
                action: onViewAllLabs && totalLabs > labs.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-record-labs-all",
                    onClick: onViewAllLabs
                }, t('common.actions.viewAll'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 12,
                    "aria-hidden": true
                })) : null,
                open: recordOpen['labs'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-record-labs",
                style: {
                    display: 'flex',
                    flexDirection: 'column'
                }
            }, labs.map((obs, i)=>{
                const isCritical = obs.status === 'CRITICAL';
                const isAbnormal = obs.status === 'ABNORMAL';
                const valColor = isCritical ? (0, $jTCZr.CT).danger : isAbnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).good;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (obs.id || '') + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.4375rem 0.5rem',
                        borderRadius: '0.5rem',
                        background: isCritical ? (0, $jTCZr.CT).dangerSoft : isAbnormal ? (0, $jTCZr.C).amberLight : 'transparent',
                        borderBottom: i < labs.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '0.4375rem',
                        height: '0.4375rem',
                        borderRadius: '50%',
                        background: valColor,
                        flexShrink: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textPrimary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }
                }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.5625rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        fontFamily: 'ui-monospace, monospace',
                        color: valColor,
                        flexShrink: 0
                    }
                }, formatDigits(obs.value), obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 400,
                        color: (0, $jTCZr.C).textMuted
                    }
                }, " ", obs.unit) : ''), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 700,
                        padding: '0.0625rem 0.3125rem',
                        borderRadius: '0.25rem',
                        flexShrink: 0,
                        background: isCritical ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warn,
                        color: isCritical ? '#fff' : (0, $jTCZr.CT).warnInk
                    }
                }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
            })), totalLabs > labs.length && (onViewAllLabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "w-full min-h-11 mt-1",
                "data-testid": "visit-record-labs-more",
                onClick: onViewAllLabs
            }, "+ ", formatDigits(totalLabs - labs.length), " ", t('patient.obs.result')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    textAlign: 'center',
                    paddingTop: '0.375rem'
                }
            }, "+ ", formatDigits(totalLabs - labs.length), " ", t('patient.obs.result')))),
            /* «مدارک بیمار» — this visit's documents first, three at a time */ files: (()=>{
                const ordered = currentVisitId ? [
                    ...files.filter((f)=>f.appointmentId === currentVisitId),
                    ...files.filter((f)=>f.appointmentId !== currentVisitId)
                ] : files;
                const shown = showAllFiles ? ordered : ordered.slice(0, 3);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                    id: "files",
                    title: t('visit.patient.files'),
                    count: files.length,
                    gist: formatList([
                        ...new Set(ordered.slice(0, 3).map((f)=>(0, $157d5bd48cfffbad$export$d2ebff77a9864278)(f.kind)).filter(Boolean))
                    ].map((k)=>t(k))),
                    open: recordOpen['files'] !== false,
                    onToggle: toggleSection
                }, files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    "data-testid": "visit-record-files-empty",
                    "data-state": "empty",
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, t('patient.files.empty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    "data-testid": "visit-record-files",
                    "data-state": "content"
                }, shown.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$2e2bcd8739ae039), {
                        key: f.id,
                        file: f,
                        dense: true,
                        touch: true,
                        testid: "visit-record-file",
                        onOpen: onOpenFile,
                        onView: onViewFile,
                        onExtract: onExtractFile,
                        onEdit: onEditFile,
                        onDownload: onDownloadFile,
                        onDelete: onDeleteFile
                    })), ordered.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "w-full min-h-11 mt-1",
                    "data-testid": "visit-record-files-more",
                    onClick: ()=>setShowAllFiles((v)=>!v)
                }, showAllFiles ? t('visit.files.showLess') : `+ ${formatDigits(ordered.length - 3)} ${t('patient.files.file')}`)));
            })(),
            /* Recent visits — expandable, same detail as the desktop rail */ history: visitRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "history",
                title: t('visit.patient.recentVisits'),
                count: visitRows.length,
                gist: historyGist,
                open: recordOpen['history'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, visitRows.map((item, idx)=>{
                const enc = pastEncs[idx];
                const sum = summaries[idx];
                const encId = enc?.id || sum?.visitId || String(idx);
                const isOpen = openVisitId === encId;
                const note = enc ? (clinicalNotes || []).find((n)=>n.appointmentId === enc.id) : null;
                const dateStr = enc?.periodStart ? formatDate(enc.periodStart, 'medium') : null;
                const reason = enc?.reason || sum?.suggestedDiagnosis || t('patient.visit');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: encId,
                    style: {
                        borderRadius: '0.625rem',
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        overflow: 'hidden',
                        background: (0, $jTCZr.C).card
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    onClick: ()=>{
                        const next = isOpen ? null : encId;
                        setOpenVisitId(next);
                        // Fetch on expand, not with the record: a visit the
                        // doctor never opens costs nothing. The screen caches,
                        // so re-expanding the same row does not re-ask.
                        if (next && enc?.id) onOpenVisit?.(enc.id);
                    },
                    "aria-expanded": isOpen,
                    "data-testid": `visit-past-${encId}`,
                    className: "w-full min-h-11 h-auto justify-start gap-2 rounded-none px-3 py-2.5 hover:bg-transparent"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '0.4375rem',
                        height: '0.4375rem',
                        borderRadius: '50%',
                        background: (0, $jTCZr.CT).accent,
                        flexShrink: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'block',
                        fontSize: '0.78125rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textPrimary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }
                }, reason), dateStr && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'block',
                        fontSize: '0.65625rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontWeight: 400
                    }
                }, dateStr)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 14,
                    "aria-hidden": true,
                    style: {
                        color: (0, $jTCZr.C).textMuted,
                        flexShrink: 0,
                        transform: isOpen ? 'rotate(-90deg)' : 'none',
                        transition: 'transform .2s'
                    }
                })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        padding: '0 0.75rem 0.75rem',
                        borderTop: `1px solid ${(0, $jTCZr.C).border}`
                    }
                }, sum?.summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted,
                        letterSpacing: '0.06em',
                        marginBottom: '0.3125rem'
                    }
                }, t('visit.suggest.visitSummary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textSecondary,
                        lineHeight: 1.7
                    }
                }, sum.summary)), !sum?.summary && note?.content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted,
                        letterSpacing: '0.06em',
                        marginBottom: '0.3125rem'
                    }
                }, t('visit.orders.clinicalNote')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textSecondary,
                        lineHeight: 1.7
                    }
                }, note.content?.text || note.content?.a || '')), sum?.suggestedDiagnosis && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.375rem',
                        marginTop: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted
                    }
                }, t('visit.print.diagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        padding: '0.125rem 0.5rem',
                        borderRadius: '0.25rem',
                        background: (0, $jTCZr.CT).accentSoft,
                        color: (0, $jTCZr.CT).accentInk
                    }
                }, sum.suggestedDiagnosis)), sum?.icdCodes?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.25rem',
                        marginTop: '0.5rem'
                    }
                }, sum.icdCodes.map((c, ci)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        key: ci,
                        dir: "ltr",
                        style: {
                            fontSize: '0.625rem',
                            padding: '0.125rem 0.4375rem',
                            borderRadius: '0.3125rem',
                            background: (0, $jTCZr.CT).surface2,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            color: (0, $jTCZr.C).textMuted,
                            fontFamily: 'ui-monospace, monospace'
                        }
                    }, c.code, c.description ? ` \xb7 ${c.description}` : ''))), (()=>{
                    const ctx = enc?.id ? visitContexts[enc.id] : null;
                    if (!enc?.id || !onOpenVisit) return null;
                    if (!ctx || ctx.state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "loading",
                        "aria-busy": "true",
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
                        lines: 2,
                        height: 11,
                        lastWidth: "50%"
                    }));
                    if (ctx.state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "error",
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.CT).dangerInk,
                            marginBottom: '0.25rem'
                        }
                    }, t('errors.load.record')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        className: "min-h-11",
                        "data-testid": `visit-past-retry-${encId}`,
                        onClick: ()=>onOpenVisit(enc.id)
                    }, t('common.actions.retry')));
                    const d = ctx.data || {};
                    const dxs = d.conditions || [];
                    const cmeds = d.medications || [];
                    const cords = d.orders || [];
                    if (!dxs.length && !cmeds.length && !cords.length) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "content"
                    }, dxs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('patient.tabs.conditions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.25rem'
                        }
                    }, dxs.map((dx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            key: dx.id,
                            style: {
                                fontSize: '0.65625rem',
                                padding: '0.125rem 0.4375rem',
                                borderRadius: '0.3125rem',
                                background: (0, $jTCZr.CT).accentSoft,
                                color: (0, $jTCZr.CT).accentInk,
                                fontWeight: 600
                            }
                        }, dx.display, dx.code ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            dir: "ltr",
                            style: {
                                opacity: 0.7
                            }
                        }, " \xb7 ", dx.code) : null)))), cmeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('patient.tabs.medications')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.375rem'
                        }
                    }, cmeds.map((hm)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            key: hm.id,
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                fontSize: '0.71875rem',
                                fontWeight: 600,
                                color: (0, $jTCZr.C).textPrimary
                            }
                        }, hm.display), (hm.dosageInstruction?.text || typeof hm.dosageInstruction === 'string') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                fontSize: '0.625rem',
                                color: (0, $jTCZr.C).textMuted
                            }
                        }, (0, $375f8776645d5aee$export$f1536cfec6e3f4b8)(hm.dosageInstruction?.text || hm.dosageInstruction, t, readsPersianData))), onRepresribeMed && (isPrescribed(hm.display) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            "data-testid": `visit-history-med-represcribed-${hm.id}`,
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.1875rem',
                                fontSize: '0.625rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.CT).good,
                                flexShrink: 0
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                            size: 12,
                            "aria-hidden": true
                        }), t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                            variant: "subtle",
                            size: "sm",
                            className: "min-h-11 gap-1 shrink-0",
                            "data-testid": `visit-history-med-represcribe-${hm.id}`,
                            "aria-label": t('visit.rx.represcribeAria', {
                                name: hm.display
                            }),
                            onClick: ()=>onRepresribeMed(hm)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
                            size: 12,
                            "aria-hidden": true
                        }), t('visit.rx.represcribe'))))))), cords.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('visit.orders.request')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.25rem'
                        }
                    }, cords.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            key: o.id,
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.375rem',
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textSecondary
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            style: {
                                flex: 1,
                                minWidth: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }
                        }, o.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            style: {
                                fontSize: '0.625rem',
                                color: (0, $jTCZr.C).textMuted,
                                flexShrink: 0
                            }
                        }, o.status))))));
                })(), !sum?.summary && !note?.content && !sum?.suggestedDiagnosis && !enc?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.625rem',
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontStyle: 'italic'
                    }
                }, t('visit.patient.noExtra'))));
            })))
        };
        return sectionList.filter(({ id: id })=>blocks[id]).map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: id
            }, blocks[id]));
    })()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!pendingStop,
        onOpenChange: (o)=>{
            if (!o) setPendingStop(null);
        },
        title: t('visit.rx.stop'),
        message: t('patient.meds.stopConfirm', {
            name: pendingStop?.display || t('patient.meds.one')
        }),
        confirmLabel: t('visit.rx.stop'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: ()=>{
            if (pendingStop) onStopMed(pendingStop);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!pendingDx,
        onOpenChange: (o)=>{
            if (!o) setPendingDx(null);
        },
        title: t('visit.dx.remove'),
        message: t('patient.conditions.deleteConfirmNamed', {
            name: pendingDx?.display || t('patient.conditions.one')
        }),
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: ()=>{
            if (pendingDx) onRemoveDiagnosis?.(pendingDx);
        }
    }));
};
var $e0b3b7ef84bbae65$export$2e2bcd8739ae039 = $e0b3b7ef84bbae65$var$MobileVisitRecordSheet;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $Ydgp5 = parcelRequire("Ydgp5");
var $lffTJ = parcelRequire("lffTJ");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");
var $a7Rbr = parcelRequire("a7Rbr");

var $k2reB = parcelRequire("k2reB");

var $jTCZr = parcelRequire("jTCZr");
// The two overlays the in-visit record opens: the vitals history and the
// demographics editor. Both are the phone rendering of a desktop Visit modal
// (Visit.web.jsx → «تاریخچه علائم حیاتی» and «ویرایش بیمار»); they carry the
// same data and the same write contract, in a BottomSheet instead of a Dialog.
// Same LOINC set + thresholds the desktop vitals-history modal uses.
const $f91b9c2a59f5e411$var$VITAL_META = (t)=>({
        '8480-6': {
            label: 'BP sys',
            unit: 'mmHg',
            status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
        },
        '8462-4': {
            label: 'BP dia',
            unit: 'mmHg',
            status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
        },
        '8867-4': {
            label: t('visit.vitals.pulse'),
            unit: 'bpm',
            status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
        },
        '59408-5': {
            label: "SpO\u2082",
            unit: '%',
            status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
        },
        '8310-5': {
            label: t('patient.vitals.temp'),
            unit: "\xb0C",
            status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
        },
        '29463-7': {
            label: t('patient.vitals.wt'),
            unit: 'kg',
            status: ()=>'ok'
        }
    });
const $f91b9c2a59f5e411$var$STATUS_COLOR = {
    ok: (0, $jTCZr.CT).good,
    warn: (0, $jTCZr.CT).warnInk,
    crit: (0, $jTCZr.CT).danger
};
const $f91b9c2a59f5e411$var$STATUS_BG = {
    ok: (0, $jTCZr.CT).goodSoft,
    warn: (0, $jTCZr.CT).warnSoft,
    crit: (0, $jTCZr.CT).dangerSoft
};
const $f91b9c2a59f5e411$export$4a9e58f0ce1db37f = ({ open: open, onClose: onClose, observations: observations = [] })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const meta = $f91b9c2a59f5e411$var$VITAL_META(t);
    const cards = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const groups = {};
        observations.forEach((obs)=>{
            const m = meta[obs.code];
            if (!m) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!groups[obs.code]) groups[obs.code] = {
                ...m,
                code: obs.code,
                pts: []
            };
            groups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        return Object.values(groups);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        observations
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.vitals.history'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-vitals-history-sheet"
    }, cards.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 40,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.patient.noHistory')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
        }
    }, cards.map((m)=>{
        const sorted = [
            ...m.pts
        ].sort((a, b)=>new Date(a.date) - new Date(b.date));
        const last = sorted[sorted.length - 1];
        const prev = sorted[sorted.length - 2];
        const st = m.status(last.value);
        const delta = prev ? last.value - prev.value : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.code,
            "data-testid": `vitals-history-${m.code}`,
            style: {
                background: $f91b9c2a59f5e411$var$STATUS_BG[st],
                border: `1px solid ${(0, $jTCZr.soft)($f91b9c2a59f5e411$var$STATUS_COLOR[st], 0.35)}`,
                borderRadius: '0.625rem',
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textMuted,
                textTransform: 'uppercase',
                marginBottom: '0.25rem'
            }
        }, m.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '1.125rem',
                fontWeight: 700,
                color: $f91b9c2a59f5e411$var$STATUS_COLOR[st],
                fontFamily: 'ui-monospace, monospace'
            }
        }, formatDigits(last.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, m.unit)), delta != null && delta !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, delta > 0 ? "\u25B2" : "\u25BC", " ", formatDigits(Math.abs(Math.round(delta * 10) / 10))), sorted.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: sorted.map((x)=>x.value),
            width: 72,
            height: 18,
            tone: st === 'crit' ? 'danger' : st === 'warn' ? 'warn' : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.25rem'
            }
        }, t('visit.vitals.readingCount', {
            count: sorted.length
        })));
    }))));
};
const $f91b9c2a59f5e411$var$BLOOD_TYPES = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
];
const $f91b9c2a59f5e411$export$9a251dbf2f7b9965 = ({ open: open, onClose: onClose, form: form = {}, onChange: onChange, saving: saving, error: error, onSave: onSave })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.edit'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-edit-patient-sheet",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: form.name || '',
        onChange: (e)=>onChange('name', e.target.value),
        placeholder: t('visit.patient.fullName')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: form.phone || '',
        onChange: (phone)=>onChange('phone', phone)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: form.nationalId || '',
        allowOtherCountries: true,
        onChange: (e)=>onChange('nationalId', e.target.value),
        onCountryChange: (c)=>onChange('nationalIdCountry', c),
        "data-testid": "visit-edit-patient-nid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('common.labels.birthDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: form.birthDate || '',
        onChange: (v)=>onChange('birthDate', v),
        height: 44,
        placeholder: t('visit.patient.birthDatePlaceholder'),
        disableFuture: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: form.job || '',
        onChange: (e)=>onChange('job', e.target.value),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        type: "number",
        dir: "ltr",
        value: form.height || '',
        onChange: (e)=>onChange('height', e.target.value),
        placeholder: "175"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: form.bloodType || '',
        onChange: (e)=>onChange('bloodType', e.target.value),
        options: $f91b9c2a59f5e411$var$BLOOD_TYPES.map((bt)=>({
                value: bt,
                label: bt
            })),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: form.insurance || '',
        onChange: (e)=>onChange('insurance', e.target.value),
        options: [
            {
                value: 'social',
                label: t('patient.insurance.social')
            },
            {
                value: 'health',
                label: t('patient.insurance.health')
            },
            {
                value: 'military',
                label: t('patient.insurance.military')
            },
            {
                value: 'other',
                label: t('patient.insurance.other')
            }
        ],
        placeholder: t('common.actions.select')
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-edit-patient-error",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 600
        }
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "flex-1 min-h-11",
        onClick: onClose
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        className: "flex-1 min-h-11",
        disabled: saving,
        "data-testid": "visit-edit-patient-save",
        onClick: onSave
    }, saving ? t('common.state.saving') : t('common.actions.save')))));
};


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
// The full lab list behind the record sheet's preview — the phone's answer to
// the desktop «مشاهدهٔ همه» RecordListSheet (Visit.web.jsx, `record-sheet-labs`).
//
// The record sheet shows ten and used to end with a dead «+N نتیجه» line: the
// count of results the doctor was being told they could not see. This is where
// that number now leads.
//
// Vital signs are not lab results. The record panel filters them out by LOINC
// and so does this — the same six codes, spelled here rather than imported from
// the record sheet, because a sheet that renders labs should not depend on the
// sheet that links to it.
const $8666d5605a00f2ea$var$VITAL_CODES = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
const $8666d5605a00f2ea$var$PAGE = 20;
const $8666d5605a00f2ea$var$FILTERS = (t)=>[
        {
            id: 'all',
            label: t('common.state.all')
        },
        {
            id: 'critical',
            label: t('visit.vitals.critical')
        },
        {
            id: 'abnormal',
            label: t('visit.vitals.abnormal')
        }
    ];
const $8666d5605a00f2ea$var$MobileVisitLabsSheet = ({ open: open, onClose: onClose, labResults: labResults = [] })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [filter, setFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($8666d5605a00f2ea$var$PAGE);
    // Reopening starts at the top of an unfiltered list: the previous visit's
    // scroll position is not a state the doctor asked to keep.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setFilter('all');
            setShown($8666d5605a00f2ea$var$PAGE);
        }
    }, [
        open
    ]);
    // Critical → abnormal → newest, the desktop ordering.
    const all = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(labResults || []).filter((o)=>!$8666d5605a00f2ea$var$VITAL_CODES.has(o.code)).slice().sort((a, b)=>{
            const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
            const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
            if (sA !== sB) return sA - sB;
            return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
        }), [
        labResults
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            all: all.length,
            critical: all.filter((o)=>o.status === 'CRITICAL').length,
            abnormal: all.filter((o)=>o.status === 'ABNORMAL').length
        }), [
        all
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>filter === 'all' ? all : all.filter((o)=>o.status === filter.toUpperCase()), [
        all,
        filter
    ]);
    const page = filtered.slice(0, shown);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.labResults')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-labs-sheet",
        "data-state": filtered.length ? 'content' : 'empty'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            marginBottom: '0.75rem',
            flexWrap: 'wrap'
        }
    }, $8666d5605a00f2ea$var$FILTERS(t).map(({ id: id, label: label })=>{
        const on = filter === id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: on ? 'default' : 'outline',
            size: "sm",
            className: "min-h-11 gap-1",
            "aria-pressed": on,
            "data-testid": `visit-labs-filter-${id}`,
            onClick: ()=>{
                setFilter(id);
                setShown($8666d5605a00f2ea$var$PAGE);
            }
        }, label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                opacity: 0.75
            }
        }, formatDigits(counts[id] || 0)));
    })), filtered.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-labs-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: filter === 'all' ? t('patient.obs.noLabResults') : t('common.state.empty'),
        hint: filter === 'all' ? undefined : t('common.actions.clearFilters')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, page.map((obs, i)=>{
        const isCritical = obs.status === 'CRITICAL';
        const isAbnormal = obs.status === 'ABNORMAL';
        const valColor = isCritical ? (0, $jTCZr.CT).danger : isAbnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).good;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (obs.id || '') + '_' + i,
            "data-testid": `visit-labs-row-${obs.id || i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem',
                borderRadius: '0.5rem',
                background: isCritical ? (0, $jTCZr.CT).dangerSoft : isAbnormal ? (0, $jTCZr.C).amberLight : 'transparent',
                borderBottom: i < page.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: valColor,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                fontFamily: 'ui-monospace, monospace',
                color: valColor,
                flexShrink: 0
            }
        }, formatDigits(obs.value), obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 400,
                color: (0, $jTCZr.C).textMuted
            }
        }, " ", obs.unit) : ''), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                flexShrink: 0,
                background: isCritical ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warn,
                color: isCritical ? '#fff' : (0, $jTCZr.CT).warnInk
            }
        }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
    })), filtered.length > page.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "w-full min-h-11 mt-2",
        "data-testid": "visit-labs-more",
        onClick: ()=>setShown((s)=>s + $8666d5605a00f2ea$var$PAGE)
    }, t('common.actions.showMore'), " (", formatDigits(filtered.length - page.length), ")"))));
};
var $8666d5605a00f2ea$export$2e2bcd8739ae039 = $8666d5605a00f2ea$var$MobileVisitLabsSheet;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");

var $a0SXV = parcelRequire("a0SXV");


// چاپ نسخه, reachable while the visit is still open.
//
// The phone could only print THROUGH the closure — the نسخه a patient is handed
// mid-visit had no door, and the doctor had to end the visit to produce it. The
// document is unchanged: the same `printPrescription` builders the desktop and
// the closure use, so a نسخه printed here and one printed at closure are the
// same sheet.
//
// The desktop's side-by-side A5 preview pane has no place on a 360px viewport;
// the preview here is a single scrolling column, and only the print itself is
// paginated by the browser.
const $84b0860f5c9bbf22$var$Label = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.06em',
            marginBottom: '0.3125rem'
        }
    }, children);
const $84b0860f5c9bbf22$var$MobileVisitPrintSheet = ({ open: open, onClose: onClose, templates: templates = [], rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [tplId, setTplId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // «قالب سیستم» is the default on every open: a template chosen for the last
    // نسخه is not a preference, and silently reusing it prints the wrong document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setTplId('');
    }, [
        open
    ]);
    const template = templates.find((x)=>x.id === tplId) || null;
    const canPrint = rxItems.length > 0;
    const handlePrint = ()=>(0, $375f8776645d5aee$export$e57f8733307287ae)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
    const labs = pendingTests.filter((x)=>x.type === 'lab');
    const imaging = pendingTests.filter((x)=>x.type === 'imaging');
    const templateText = template ? (0, $375f8776645d5aee$export$1512fb0c882aac98)(template.content, {
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        t: t
    }) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.rx.print'),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            size: "lg",
            className: "w-full min-h-11 gap-1.5",
            "data-testid": "visit-print-confirm",
            disabled: !canPrint,
            onClick: handlePrint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
            size: 15,
            "aria-hidden": true
        }), " ", t('visit.rx.print'))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-sheet",
        "data-state": canPrint ? 'content' : 'empty'
    }, !canPrint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('visit.rx.none'),
        hint: t('visit.rx.emptyHint')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.rx.template')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: tplId,
        onChange: (e)=>setTplId(e.target.value),
        "data-testid": "visit-print-template",
        style: {
            width: '100%',
            boxSizing: 'border-box',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.5rem',
            padding: '0.5rem 0.625rem',
            background: (0, $jTCZr.CT).surface2,
            // 1rem or iOS zooms the page on focus (§6).
            fontSize: '1rem',
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.systemFormat')), templates.map((x)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: x.id,
            value: x.id
        }, x.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.rx.preview')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-preview",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem',
            maxHeight: '22rem',
            overflowY: 'auto'
        }
    }, template ? // A filled template is the author's own layout — shown verbatim,
    // and allowed to scroll sideways INSIDE its own box so the page
    // itself never does.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            margin: 0,
            fontFamily: 'inherit',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap',
            overflowX: 'auto'
        }
    }, templateText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingBottom: '0.5rem',
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, doctor?.name || ''), doctor?.specialty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, doctor.specialty), doctor?.medicalCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.print.medicalCode'), ": ", formatDigits(doctor.medicalCode))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, patient?.name || ''), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr"
    }, formatDigits(patient.nationalId))), diagnosis && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.print.diagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.8
        }
    }, diagnosis)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('patient.tabs.medications')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, rxItems.map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: r.id || i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontWeight: 700
            }
        }, (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(r.drug)), [
            r.dosage,
            r.route,
            r.frequency,
            r.duration
        ].filter(Boolean).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.C).textSecondary
            }
        }, " \u2014 ", [
            r.dosage,
            r.route,
            r.frequency,
            r.duration
        ].filter(Boolean).join(" \xb7 ")), r.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, r.instructions)))), labs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.orders.lab')), labs.map((x, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", x.name))), imaging.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('patient.orderType.imaging')), imaging.map((x, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", x.name))), soap?.p && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.soap.pLetter')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap'
        }
    }, soap.p)))))));
};
var $84b0860f5c9bbf22$export$2e2bcd8739ae039 = $84b0860f5c9bbf22$var$MobileVisitPrintSheet;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6bb373bd7e3948d8$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M4.929 4.929 19.07 19.071",
            key: "196cmz"
        }
    ]
];
const $6bb373bd7e3948d8$export$2e2bcd8739ae039 = (0, $9QBug.default)("ban", $6bb373bd7e3948d8$export$3efd853dbb351e94);


var $a0SXV = parcelRequire("a0SXV");

var $jTCZr = parcelRequire("jTCZr");
// The ⋯ header menu — what the desktop topbar carries and the phone's single
// docked CTA cannot.
//
// لغو ویزیت lives HERE, not in the footer, on purpose: the footer holds «پایان
// ویزیت», and two terminal actions with opposite meanings sitting side by side
// on a thumb-sized target is how a visit gets destroyed instead of closed.
// Burying it costs one tap and removes that class of mistake entirely.
//
// Nothing here confirms — the screen owns every ConfirmDialog, so the confirm
// copy and the mutation stay in one place.
const $0225b93de05eb560$var$Row = ({ Icon: Icon, label: label, onClick: onClick, disabled: disabled, danger: danger, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: danger ? 'ghost' : 'subtle',
        size: "lg",
        className: "w-full min-h-11 justify-start gap-2.5 mb-2",
        "data-testid": testId,
        disabled: disabled,
        onClick: onClick,
        style: danger ? {
            color: (0, $jTCZr.CT).dangerInk,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.08)
        } : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        "aria-hidden": true
    }), label);
const $0225b93de05eb560$var$MobileVisitOverflowSheet = ({ open: open, onClose: onClose, onPrint: onPrint, onUploadLab: onUploadLab, onCancelVisit: onCancelVisit, canPrint: canPrint = false, canCancel: canCancel = false, cancelling: cancelling = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('common.actions.more')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-overflow-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $a0SXV.default),
        label: t('visit.rx.print'),
        testId: "visit-overflow-print",
        disabled: !canPrint,
        onClick: onPrint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $824b163d7442530e$export$2e2bcd8739ae039),
        label: t('visit.patient.uploadResult'),
        testId: "visit-overflow-upload",
        onClick: onUploadLab
    }), canCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $6bb373bd7e3948d8$export$2e2bcd8739ae039),
        danger: true,
        label: cancelling ? t('visit.header.cancelling') : t('visit.header.cancelVisit'),
        testId: "visit-overflow-cancel",
        disabled: cancelling,
        onClick: onCancelVisit
    })));
};
var $0225b93de05eb560$export$2e2bcd8739ae039 = $0225b93de05eb560$var$MobileVisitOverflowSheet;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $4CVxl = parcelRequire("4CVxl");
var $jhSl7 = parcelRequire("jhSl7");
var $aVx4q = parcelRequire("aVx4q");
var $a0SXV = parcelRequire("a0SXV");
var $chm1L = parcelRequire("chm1L");
parcelRequire("4UJrq");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $3tGMU = parcelRequire("3tGMU");
var $Ydgp5 = parcelRequire("Ydgp5");
var $5AX1S = parcelRequire("5AX1S");
var $lffTJ = parcelRequire("lffTJ");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $gCvEY = parcelRequire("gCvEY");
var $a7Rbr = parcelRequire("a7Rbr");
var $5JYPc = parcelRequire("5JYPc");
var $k27hS = parcelRequire("k27hS");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ce8c437c319961cc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $ce8c437c319961cc$export$2e2bcd8739ae039 = (0, $9QBug.default)("arrow-left", $ce8c437c319961cc$export$3efd853dbb351e94);


var $d8YVq = parcelRequire("d8YVq");
var $huNwV = parcelRequire("huNwV");
var $kMJsW = parcelRequire("kMJsW");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fc88d8cf02c9ed12$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $fc88d8cf02c9ed12$export$2e2bcd8739ae039 = (0, $9QBug.default)("external-link", $fc88d8cf02c9ed12$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5389c2c2de1c7f38$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $5389c2c2de1c7f38$export$2e2bcd8739ae039 = (0, $9QBug.default)("lock", $5389c2c2de1c7f38$export$3efd853dbb351e94);


var $0hzSL = parcelRequire("0hzSL");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f12b90bce5d0156f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
];
const $f12b90bce5d0156f$export$2e2bcd8739ae039 = (0, $9QBug.default)("minus", $f12b90bce5d0156f$export$3efd853dbb351e94);


var $aGlWN = parcelRequire("aGlWN");
var $6OGKD = parcelRequire("6OGKD");
var $bo0GS = parcelRequire("bo0GS");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");


var $ctEhH = parcelRequire("ctEhH");


// The card's segmented choices (insurer, gender, lab due) are 44 px on a phone
// — they were 32 px under a thumb (PM-0137 c); the desktop keeps the size asked.
function $1ccba15c4d511e83$var$ErxSegmented(props) {
    const { isMobile: isMobile } = (0, $k27hS.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        ...props,
        size: isMobile ? 'lg' : props.size
    });
}
// «نسخهٔ الکترونیک بیمه» — sends the visit's drugs to the patient's insurer through
// the op-naji gateway, from inside the visit-closure dialog, beside the تأمین card.
//
// Like that card it owns no protocol knowledge. The server gathers the visit and
// says, by name, what is missing (`blockers`) and which drugs cannot go and why
// (`lines`); the sending service holds the doctor's insurer session. This component
// renders those answers and asks the doctor for exactly three kinds of input: which
// insurer (when the record does not say), their login AT THE INSURER (once — it
// outlives this visit), and the SMS code or captcha the insurer asks for.
//
// One decision, like the تأمین checkbox: pressing «ارسال» is the decision to send.
// When the doctor is not logged in, the login appears in the card and, once it
// completes, the prescription goes without a second press.
//
// The password never outlives the form: it is cleared the moment it is submitted,
// and nothing here stores or logs it.
//
// «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04; docs/eprescription/CORRECTION.md): once a
// part is registered, the server compares what it would send now with what the
// insurer holds, line by line — added, changed (with what the insurer has) or
// removed — and says whether a correction can go (`preview.correction`). The card
// shows that diff, when it can still be corrected, and «ارسال اصلاحیه به بیمه»
// behind a confirmation — or, when it cannot, why. A correction resends the whole
// prescription, through the same login as a send; whatever happens to it, the
// registration stands.
//
// «ثبت نسخه در بیمه» — the visit's panel and the phone's sheet — is `flow="panel"`
// (K1, 2026-10-13, PM-0187). It opens on the login rather than on a button: a
// live insurer session goes straight to «اطلاعات بیمه» and the preview; تأمین
// opens its own login page; سلامت, نیروهای مسلح and a patient whose insurer is not
// on record get a login window. The preview is a checkbox per line, every one
// ticked to start with, and only the ticked lines go. Nothing is sent before the
// doctor presses «ثبت نسخه در …». The closure dialog keeps the card as it was —
// except that no card offers to change an insurer the patient's record names.
// The card's state as the selector contract sees it: one word per state, so a test
// asserts «waiting for a code» rather than looking for Persian copy.
const $1ccba15c4d511e83$var$DATA_STATE = {
    LOADING: 'loading',
    UNAVAILABLE: 'unavailable',
    BLOCKED: 'blocked',
    READY: 'ready',
    LOGIN: 'login',
    OTP: 'otp',
    CAPTCHA: 'captcha',
    REDIRECT: 'redirect',
    SENDING: 'sending',
    REGISTERED: 'registered',
    REJECTED: 'rejected',
    FAILED: 'failed',
    // The preview could not be read; the card says so and offers to read again.
    LOAD_FAILED: 'load-failed'
};
const $1ccba15c4d511e83$var$OTP_MIN = 4;
const $1ccba15c4d511e83$var$OTP_MAX = 8;
const $1ccba15c4d511e83$var$CHALLENGE = [
    'OTP_REQUIRED',
    'CAPTCHA_REQUIRED',
    'REDIRECT_REQUIRED'
];
// Blockers the card itself resolves, so they are not listed as problems: the
// insurer picker answers the first, the login form the next two, the SIAM form
// the last.
const $1ccba15c4d511e83$var$HANDLED_IN_CARD = new Set([
    'INSURER_NOT_SELECTED',
    'DOCTOR_NATIONAL_CODE_MISSING',
    'DOCTOR_MOBILE_MISSING',
    'SIAM_ID_MISSING',
    'PATIENT_GENDER_MISSING',
    'PATIENT_MOBILE_MISSING'
]);
// What the insurer requires of the patient and the record lacks: asked in the
// card (PatientDetailsField), sent, and written into the record by the send.
const $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS = {
    gender: 'PATIENT_GENDER_MISSING',
    mobile: 'PATIENT_MOBILE_MISSING'
};
// The two the login form asks for, and saves to the doctor's profile in the same
// call. They must not hold «ارسال» shut: that form opens only FROM «ارسال», so a
// card that waited on `ready` for them sat «ready», silent, with a dead button —
// for good (K1, 2026-10-03).
const $1ccba15c4d511e83$var$LOGIN_NEEDS = new Set([
    'DOCTOR_NATIONAL_CODE_MISSING',
    'DOCTOR_MOBILE_MISSING'
]);
const $1ccba15c4d511e83$export$d7dc397751880ad8 = 4000;
const $1ccba15c4d511e83$export$1591506e3dd28b74 = 5;
// The BFF cannot answer the question at all — it predates the field, or an
// argument the card sends. Asking again never helps and the doctor never had the
// feature, so this is the one failed read the card answers with silence.
function $1ccba15c4d511e83$var$isSchemaGap(e) {
    if (e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') return true;
    return /Cannot query field|Unknown argument|Unknown type/.test(String(e?.message || ''));
}
// Test ids. The closure dialog's card keeps «visit-closure-erx-*»; the card the
// visit's نسخه/دستورات section opens can be on screen beneath that dialog, so it
// takes its own prefix rather than duplicate every id.
const $1ccba15c4d511e83$var$ErxTestIdPrefix = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('visit-closure-erx');
// What this card sends: ALL (the نسخه and the دستورات), DRUGS or SERVICES.
const $1ccba15c4d511e83$var$ErxScope = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('ALL');
function $1ccba15c4d511e83$var$useErxTid() {
    const prefix = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($1ccba15c4d511e83$var$ErxTestIdPrefix);
    return (s)=>s ? `${prefix}-${s}` : prefix;
}
// ── shell ───────────────────────────────────────────────────────────────────
// `bare`: the panel's — the panel is the frame, so the card draws none of its own.
function $1ccba15c4d511e83$var$CardShell({ tone: tone = 'idle', state: state, compact: compact = false, bare: bare = false, children: children }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const border = {
        idle: (0, $jTCZr.C).border,
        busy: (0, $jTCZr.CT).accent,
        good: (0, $jTCZr.CT).good,
        bad: (0, $jTCZr.CT).danger
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": tid(),
        "data-state": state,
        "data-compact": compact || undefined,
        "data-flow": bare ? 'panel' : undefined,
        style: bare ? {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem',
            minWidth: 0,
            flex: '1 0 auto'
        } : {
            background: (0, $jTCZr.CT).surface,
            borderRadius: (0, $jTCZr.RADIUS).card,
            border: `1px solid ${border}`,
            padding: '0.8125rem 0.9375rem',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            transition: 'border-color .2s'
        }
    }, children);
}
function $1ccba15c4d511e83$var$CardHead({ subtitle: subtitle, badges: badges }) {
    const { t: t } = (0, $LNQP4.default)();
    const scope = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($1ccba15c4d511e83$var$ErxScope);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            marginBottom: '0.6875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: '1.625rem',
            height: '1.625rem',
            borderRadius: (0, $jTCZr.RADIUS).chip,
            flexShrink: 0,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.erx.title'), scope !== 'ALL' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-erx-scope",
        "data-scope": scope,
        style: {
            marginInlineStart: 6,
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: 4,
            padding: '1px 6px'
        }
    }, t(`visit.erx.scope.${scope}`))), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.CT).mute2
        }
    }, subtitle)), badges);
}
function $1ccba15c4d511e83$var$Note({ tone: tone = 'mute', children: children, ...rest }) {
    const color = {
        mute: (0, $jTCZr.CT).mute,
        good: (0, $jTCZr.CT).good,
        bad: (0, $jTCZr.CT).danger,
        ink: (0, $jTCZr.CT).ink2
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: color,
            lineHeight: 1.7
        },
        ...rest
    }, children);
}
// استحقاق‌سنجی (PM-0145): the insurer's answer on covering the patient, under the
// session line. Quiet when covered; the insurer's words when not — red only where
// that stops the send; a muted line when it could not be asked; nothing when it
// was not asked at all (no session, no national code, an insurer not asked).
function $1ccba15c4d511e83$var$EligibilityLine({ value: value, insurerName: insurerName }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (!value) return null;
    if (value === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "loading",
        style: {
            marginBottom: '0.5rem',
            maxWidth: '14rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 1
    }));
    if (value.state === 'NOT_ASKED') return null;
    if (value.state === 'ELIGIBLE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "ELIGIBLE",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
        size: 12,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.erx.eligibility.ELIGIBLE', {
        insurer: insurerName
    })));
    if (value.state === 'NOT_ELIGIBLE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "NOT_ELIGIBLE",
        "data-blocks": value.blocks ? 'true' : 'false',
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: value.blocks ? 'bad' : 'ink'
    }, t(value.blocks ? 'visit.erx.eligibility.NOT_ELIGIBLE_BLOCKS' : 'visit.erx.eligibility.NOT_ELIGIBLE', {
        insurer: insurerName
    })), value.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.eligibility.insurerSaid', {
        message: value.message
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "UNAVAILABLE",
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.eligibility.UNAVAILABLE')));
}
// ── the drugs ───────────────────────────────────────────────────────────────
// Every drug of the visit, each saying whether it goes and — if not — why. A doctor
// told «sent» must also be told which lines were not part of it.
//
// Two reason codes say a line's PART is already at the insurer (K1, 2026-10-03):
// ALREADY_REGISTERED went with that registration; ADDED_AFTER_REGISTRATION was
// written after it, never reached the insurer, and cannot be added to it from
// Parsina yet.
const $1ccba15c4d511e83$var$ALREADY_REGISTERED = 'ALREADY_REGISTERED';
const $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION = 'ADDED_AFTER_REGISTRATION';
// What a registered part now holds that the insurer does not (K1, 2026-10-04):
// a line changed since — the insurer has the older form, `sentSummary` — or one
// removed since, which the insurer still holds and the server lists on its own.
const $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION = 'CHANGED_SINCE_REGISTRATION';
const $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION = 'REMOVED_SINCE_REGISTRATION';
const $1ccba15c4d511e83$var$SINCE_REGISTRATION = new Set([
    $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION,
    $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION,
    $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION
]);
const $1ccba15c4d511e83$export$7a9c4ec4ae364c2 = [
    'FINAL',
    'EXPIRED',
    'EMPTY_PART',
    'NOT_SENDABLE',
    'UNSUPPORTED'
];
/**
 * What one line IS, as the doctor must read it: 'sendable' (goes with «ارسال»),
 * 'registered' (at the insurer) or 'not-sent'. The registered card used to draw
 * the live lines as the pre-send list did, so a drug written AFTER the
 * registration came out as sent (K1, 2026-10-03). Now only the server's word
 * makes a line registered: ALREADY_REGISTERED, or — on the registered card — a
 * line it still calls sendable, which is one the send just carried (the preview
 * was read before it). Anything it does not call sendable did not go.
 *
 * Two more since corrections (K1, 2026-10-04): 'changed' — at the insurer in an
 * older form — and 'removed' — no longer on the نسخه, still at the insurer. A
 * line added after the registration never reached it, sendable or not.
 */ function $1ccba15c4d511e83$var$lineStanding(line, registeredView = false) {
    if (line?.reasonCode === $1ccba15c4d511e83$var$ALREADY_REGISTERED) return 'registered';
    if (line?.reasonCode === $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION) return 'changed';
    if (line?.reasonCode === $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION) return 'removed';
    if (line?.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION || !line?.sendable) return 'not-sent';
    return registeredView ? 'registered' : 'sendable';
}
// How each standing is marked: a tick for what is (or will be) at the insurer as
// it is, a cross for what is not, amber for what the insurer holds differently.
const $1ccba15c4d511e83$var$MARK = {
    registered: {
        mark: 'check',
        Icon: (0, $huNwV.default),
        color: (0, $jTCZr.CT).good
    },
    sendable: {
        mark: 'check',
        Icon: (0, $huNwV.default),
        color: (0, $jTCZr.CT).good
    },
    'not-sent': {
        mark: 'x',
        Icon: (0, $6TdpC.default),
        color: (0, $jTCZr.CT).danger
    },
    changed: {
        mark: 'changed',
        Icon: (0, $aGlWN.default),
        color: (0, $jTCZr.CT).warn
    },
    removed: {
        mark: 'removed',
        Icon: (0, $f12b90bce5d0156f$export$2e2bcd8739ae039),
        color: (0, $jTCZr.CT).warn
    }
};
/**
 * `correctionAware`: the server said what a correction can do (`preview.correction`),
 * so the old «cannot be changed from Parsina yet» note no longer holds — the
 * correction section speaks instead.
 */ function $1ccba15c4d511e83$var$Lines({ lines: lines, reasonText: reasonText, registered: registered = false, correctionAware: correctionAware = false }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    const standing = lines.map((l)=>$1ccba15c4d511e83$var$lineStanding(l, registered));
    const count = (s)=>standing.filter((x)=>x === s).length;
    // A removed line is the insurer's, no longer the visit's: not one of its items.
    const total = lines.length - count('removed');
    const addedAfter = !correctionAware && lines.some((l)=>l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.25rem'
        }
    }, registered ? t('visit.erx.linesRegistered', {
        registered: count('registered'),
        total: total
    }) : t('visit.erx.linesSummary', {
        sendable: count('sendable'),
        total: total
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'grid',
            gap: '0.1875rem'
        }
    }, lines.map((l, i)=>{
        const s = standing[i];
        const goes = s === 'registered' || s === 'sendable';
        const { mark: mark, Icon: Icon, color: color } = $1ccba15c4d511e83$var$MARK[s];
        // Drug names are Latin: isolate them so a Persian line stays in order.
        const name = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                color: s === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                fontWeight: 600
            }
        }, l.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${l.name}-${i}`,
            "data-testid": tid('line'),
            "data-sendable": l.sendable ? 'true' : 'false',
            "data-standing": s,
            "data-reason": l.reasonCode || undefined,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.375rem',
                fontSize: '0.6875rem',
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            "data-mark": mark,
            style: {
                color: color,
                marginTop: '0.125rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 12
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                minWidth: 0
            }
        }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, name) : name, goes && l.erxCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute2,
                marginInlineStart: '0.375rem'
            }
        }, t('visit.erx.erxCoded'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate'
            }
        }, l.erxCode)), goes && l.sentAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('line-sent-as'),
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, t('visit.erx.sentAsGeneric'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr"
        }, l.sentAs)), goes && l.serviceCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute2,
                marginInlineStart: '0.375rem'
            }
        }, t('visit.erx.serviceCoded'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate'
            }
        }, l.serviceCode)), s === 'registered' && !registered && l.reasonCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, reasonText(l)), s === 'not-sent' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "sr-only"
        }, t('visit.erx.lineNotSent'), ": "), reasonText(l)), (s === 'changed' || s === 'removed') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, reasonText(l), l.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                display: 'block'
            }
        }, t('visit.erx.correction.atInsurer', {
            summary: l.sentSummary
        })))));
    })), addedAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('added-after'),
        style: {
            marginTop: '0.375rem',
            padding: '0.375rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`,
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.75
        }
    }, t('visit.erx.addedAfterRegistration')));
}
// ── what a correction would carry ───────────────────────────────────────────
// The registered part's changes, grouped the way a doctor checks them before
// resending: اضافه, تغییر (what the insurer holds → what the نسخه says now), حذف.
// `describeLine` is the visit's: it knows the line as it is now. Without it (the
// closure dialog) a change says only what the insurer holds.
const $1ccba15c4d511e83$var$DIFF_GROUPS = [
    [
        'added',
        $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION
    ],
    [
        'changed',
        $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION
    ],
    [
        'removed',
        $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION
    ]
];
function $1ccba15c4d511e83$var$CorrectionDiff({ lines: lines, parts: parts, describeLine: describeLine }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t, isRTL: isRTL } = (0, $LNQP4.default)();
    const inParts = (l)=>!l.part || !parts?.length || parts.includes(l.part);
    const groups = $1ccba15c4d511e83$var$DIFF_GROUPS.map(([key, code])=>[
            key,
            (lines || []).filter((l)=>l.reasonCode === code && inParts(l))
        ]).filter(([, list])=>list.length > 0);
    if (!groups.length) return null;
    const Becomes = isRTL ? (0, $ce8c437c319961cc$export$2e2bcd8739ae039) : (0, $d8YVq.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('correction-diff'),
        style: {
            display: 'grid',
            gap: '0.375rem',
            marginBottom: '0.5rem'
        }
    }, groups.map(([key, list])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-testid": tid(`correction-${key}`),
            "data-count": list.length
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink2
            }
        }, t(`visit.erx.correction.${key}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            style: {
                listStyle: 'none',
                margin: 0,
                padding: 0,
                display: 'grid',
                gap: '0.125rem'
            }
        }, list.map((l, i)=>{
            let now = null;
            if (key === 'changed' && describeLine && l.medicationId) try {
                now = describeLine(l) || null;
            } catch  {
                now = null;
            }
            const name = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                dir: "auto",
                style: {
                    fontWeight: 600,
                    color: key === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink
                }
            }, l.name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: `${l.name}-${i}`,
                "data-testid": tid('correction-line'),
                "data-kind": key,
                style: {
                    fontSize: '0.6875rem',
                    lineHeight: 1.6,
                    color: (0, $jTCZr.CT).ink2
                }
            }, key === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, name) : name, key !== 'added' && (l.sentSummary || now) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '0.25rem',
                    color: (0, $jTCZr.CT).mute
                }
            }, l.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto"
            }, t('visit.erx.correction.atInsurer', {
                summary: l.sentSummary
            })), l.sentSummary && now && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Becomes, {
                size: 11,
                "aria-hidden": "true",
                style: {
                    flexShrink: 0
                }
            }), now && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    color: (0, $jTCZr.CT).ink2
                }
            }, t('visit.erx.correction.now', {
                summary: now
            }))));
        })))));
}
// A send or a correction the insurer did not take: the insurer's words, verbatim,
// with the fields it named — or ours, when it said nothing.
function $1ccba15c4d511e83$var$SubmissionProblem({ result: result, msgText: msgText }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        style: {
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, msgText(result.messageCode, result.message) || (result.state === 'NOT_ACCEPTED' ? t('visit.erx.notAccepted', {
        status: result.gatewayStatus || "\u2014"
    }) : result.state === 'FAILED' ? t('visit.erx.failed') : t('visit.erx.rejected'))))), result.fieldErrors?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.fieldErrors')), result.fieldErrors.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.CT).mute,
                unicodeBidi: 'isolate',
                lineHeight: 1.7
            }
        }, f.field, ": ", f.message))));
}
const $1ccba15c4d511e83$export$6740b37c986bc74d = [
    'TODAY',
    'ONE_MONTH',
    'THREE_MONTHS',
    'ONE_YEAR',
    'CUSTOM'
];
const $1ccba15c4d511e83$var$todayIso = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const $1ccba15c4d511e83$export$b4445206d11e7272 = (labDue)=>{
    if (labDue?.preset !== 'CUSTOM') return null;
    if (!labDue.date) return 'pickDate';
    return labDue.date < $1ccba15c4d511e83$var$todayIso() ? 'pastDate' : null;
};
function $1ccba15c4d511e83$var$LabDue({ value: value, onChange: onChange, disabled: disabled }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const problem = $1ccba15c4d511e83$export$b4445206d11e7272(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        },
        "data-testid": tid('lab-due')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.25rem'
        }
    }, t('visit.erx.labDue.label')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.labDue.label'),
        size: "sm",
        value: value.preset,
        onChange: (preset)=>onChange({
                ...value,
                preset: preset
            }),
        options: $1ccba15c4d511e83$export$6740b37c986bc74d.map((p)=>({
                value: p,
                label: t(`visit.erx.labDue.${p}`),
                disabled: disabled
            }))
    }), value.preset === 'CUSTOM' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.375rem',
            maxWidth: '15rem'
        },
        "data-testid": tid('lab-due-date')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.labDue.date'),
        error: problem === 'pastDate' ? t('visit.erx.labDue.pastDate') : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: value.date || '',
        onChange: (date)=>onChange({
                ...value,
                date: date
            }),
        height: 36,
        placeholder: t('visit.erx.labDue.pickDate')
    }))));
}
// What must be fixed elsewhere before anything can go — each with where.
function $1ccba15c4d511e83$var$Blockers({ blockers: blockers, blockerText: blockerText }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const shown = (blockers || []).filter((b)=>!$1ccba15c4d511e83$var$HANDLED_IN_CARD.has(b.code));
    if (!shown.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('blockers'),
        style: {
            marginBottom: '0.625rem',
            padding: '0.5rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.25rem'
        }
    }, t('visit.erx.blockedTitle')), shown.map((b)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: b.code,
            "data-code": b.code,
            style: {
                fontSize: '0.65625rem',
                color: (0, $jTCZr.CT).ink2,
                lineHeight: 1.75
            }
        }, "\u2022 ", blockerText(b), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, "(", t(`visit.erx.fixIn.${b.fixIn}`), ")"))));
}
// ── تأمین's login tab ───────────────────────────────────────────────────────
// تأمین's login is a page of its own, and reaching it took three presses —
// «ارسال نسخه», «ورود به تأمین», «باز کردن صفحهٔ ورود» (K1, 2026-10-05). The tab
// is now opened IN the press that decides, while the browser still counts it as
// the doctor's own action: one opened after the login call has answered is a
// popup most browsers block. It shows «در حال اتصال…» until the call returns
// تأمین's address, and is pointed there; the return page (erxReturn.js) then
// carries the send on by itself. `noopener` cannot be passed — it hides the tab
// from us — so the link back is cut by hand before تأمین's page loads in it.
// null when the browser refused: the card's own «باز کردن» button stays.
function $1ccba15c4d511e83$var$openLoginTab(text) {
    let tab = null;
    try {
        tab = window.open('', '_blank');
    } catch  {
        return null;
    }
    if (!tab) return null;
    try {
        tab.opener = null;
    } catch  {}
    try {
        const doc = tab.document;
        doc.title = text;
        doc.documentElement.dir = document.documentElement.dir || 'rtl';
        doc.body.style.cssText = "margin:0;min-height:100vh;display:grid;place-items:center;font:14px system-ui,sans-serif;color:#475569;background:#f8fafc";
        doc.body.textContent = text;
    } catch  {}
    return tab;
}
// ── the insurer login ───────────────────────────────────────────────────────
// The doctor's own username and password AT THE INSURER, and — when their profile
// lacks them — the national code and mobile the insurer identifies them by. The
// password is cleared as soon as it is submitted.
function $1ccba15c4d511e83$var$LoginForm({ insurerName: insurerName, needs: needs, onSubmit: onSubmit, busy: busy, error: error, note: note, redirect: redirect = false }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    // `redirect` = تأمین: the doctor logs in on تأمین's own page, so there is no
    // username or password here — only the national code and mobile when missing.
    const { t: t } = (0, $LNQP4.default)();
    const needsNid = needs.includes('DOCTOR_NATIONAL_CODE_MISSING');
    const needsMobile = needs.includes('DOCTOR_MOBILE_MISSING');
    const [username, setUsername] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [nid, setNid] = (0, $acw62.useState)('');
    const [mobile, setMobile] = (0, $acw62.useState)('');
    const ready = (redirect || username.trim() && password) && (!needsNid || $1ccba15c4d511e83$var$isValidNationalCode(nid)) && (!needsMobile || mobile !== '');
    const submit = ()=>{
        if (!ready || busy) return;
        const payload = {
            ...redirect ? {} : {
                username: (0, $5JYPc.toEnDigits)(username.trim()),
                password: password
            },
            nationalCode: needsNid ? nid : undefined,
            mobile: needsMobile ? (0, $5AX1S).toNational(mobile) : undefined
        };
        setPassword('');
        onSubmit(payload);
    };
    const onEnter = (e)=>{
        if (e.key === 'Enter') submit();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('login')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            marginBottom: '0.1875rem'
        }
    }, t('visit.erx.login.title', {
        insurer: insurerName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, note || t('visit.erx.login.hint')), redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.redirectHint')), (needsNid || needsMobile) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.needsDetails')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: '0.5rem',
            marginTop: '0.5625rem',
            gridTemplateColumns: 'repeat(auto-fit, minmax(11rem, 1fr))'
        }
    }, needsNid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: nid,
        onChange: (e)=>setNid(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('nid')
    }), needsMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('auth.login.phoneLabel'),
        value: mobile,
        onChange: setMobile,
        countries: [
            'IR'
        ],
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('mobile')
    }), !redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.login.username'),
        helperText: t('visit.erx.login.usernameHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-username",
        value: username,
        onChange: (e)=>setUsername(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "username",
        dir: "ltr",
        "data-testid": tid('username')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.login.password')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-password",
        type: "password",
        value: password,
        onChange: (e)=>setPassword(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "current-password",
        dir: "ltr",
        "data-testid": tid('password')
    })))), !redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            marginTop: '0.375rem',
            fontSize: '0.625rem',
            color: (0, $jTCZr.CT).mute2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.login.passwordNote')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        dir: "auto",
        style: {
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).danger,
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: submit,
        disabled: !ready || busy,
        className: "gap-1.5 mt-2.5",
        "data-testid": tid('login-submit')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), redirect ? t('visit.erx.login.submitRedirect', {
        insurer: insurerName
    }) : t('visit.erx.login.submit')));
}
// ── تأمین's SIAM id ─────────────────────────────────────────────────────────
// Asked only when تأمین is the insurer and none is recorded for this doctor at
// this clinic. Saved on their membership here, so it is asked once per clinic;
// the clinic can also record it from its «پرسنل» screen.
function $1ccba15c4d511e83$var$SiamForm({ onSave: onSave, busy: busy, error: error }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const [value, setValue] = (0, $acw62.useState)('');
    const clean = (0, $5JYPc.toEnDigits)(value).trim();
    const submit = ()=>{
        if (clean && !busy) onSave(clean);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('siam'),
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.siam.label'),
        helperText: t('visit.erx.siam.hint'),
        error: error,
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-siam",
        value: value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        disabled: busy,
        dir: "ltr",
        autoComplete: "off",
        spellCheck: false,
        maxLength: 64,
        "data-testid": tid('siam-input')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: submit,
        disabled: !clean || busy,
        className: "gap-1.5",
        "data-testid": tid('siam-save')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), t('visit.erx.siam.save'))));
}
// ── the insurer's challenge: an SMS code, or a captcha ──────────────────────
// One field: a code is usually pasted or typed in one go. Persian digits are
// normalised on the way in. The length is the insurer's, not ours, so the button
// waits for a plausible code rather than an exact count.
function $1ccba15c4d511e83$var$ChallengeField({ kind: kind, captchaImage: captchaImage, sentTo: sentTo, onSubmit: onSubmit, busy: busy, error: error }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const [value, setValue] = (0, $acw62.useState)('');
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        inputRef.current?.focus();
    }, [
        kind
    ]);
    const isOtp = kind === 'otp';
    const clean = isOtp ? (0, $5JYPc.toEnDigits)(value).replace(/\D/g, '').slice(0, $1ccba15c4d511e83$var$OTP_MAX) : (0, $5JYPc.toEnDigits)(value).trim();
    const complete = isOtp ? clean.length >= $1ccba15c4d511e83$var$OTP_MIN : clean.length > 0;
    const submit = ()=>{
        if (!complete || busy) return;
        onSubmit(isOtp ? {
            otp: clean
        } : {
            captcha: clean
        });
        setValue('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, !isOtp && captchaImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: captchaImage,
        alt: t('visit.erx.captcha.imageAlt'),
        style: {
            display: 'block',
            maxHeight: '3rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: isOtp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('visit.erx.otp.label'), sentTo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, ' ', t('visit.erx.otp.sentTo'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block'
            }
        }, sentTo))) : t('visit.erx.captcha.label'),
        error: error,
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        ref: inputRef,
        id: isOtp ? 'erx-otp' : 'erx-captcha',
        value: isOtp ? clean : value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        disabled: busy,
        inputMode: isOtp ? 'numeric' : 'text',
        autoComplete: isOtp ? 'one-time-code' : 'off',
        "aria-invalid": !!error,
        dir: "ltr",
        "data-testid": isOtp ? tid('otp') : tid('captcha'),
        inputStyle: isOtp ? {
            textAlign: 'center',
            letterSpacing: '.3em',
            fontWeight: 700
        } : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: submit,
        disabled: !complete || busy,
        className: "gap-1.5",
        "data-testid": isOtp ? tid('otp-submit') : tid('captcha-submit')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), isOtp ? t('visit.erx.otp.submit') : t('visit.erx.captcha.submit'))));
}
// ── card ────────────────────────────────────────────────────────────────────
// کد ملی بیمار. The record's, pre-filled; the doctor may send another one for
// THIS prescription (K1, 2026-10-03) — a wrong or missing code on file used to
// block the send until someone fixed the record screen. Writing it back to the
// record is a separate, explicit box, offered only for a valid code that differs.
// The rule is the kit's (PM-0076), and Iran's: this is an Iranian insurer's
// prescription, so the code it carries is an Iranian کد ملی.
const $1ccba15c4d511e83$var$isValidNationalCode = (code)=>(0, $3tGMU).isValidNationalId(code, 'IR');
function $1ccba15c4d511e83$var$NidSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-nid-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientNid.saved') : t('visit.erx.patientNid.notSaved')));
}
// ── the patient's gender and mobile (K1, 2026-10-06) ────────────────────────
// The insurer refuses a prescription without either — «جنسیت الزامی است» came
// back after the doctor had logged in and pressed send — and most records have
// no gender. Asked only for what the record lacks (and kept on screen once
// given); what the doctor gives goes with the prescription and is written into
// the patient's record by the send, with nothing to tick: the next visit is not
// asked again. Parsina keeps two genders.
function $1ccba15c4d511e83$var$PatientDetailsField({ askGender: askGender, askMobile: askMobile, value: value, onGender: onGender, onMobile: onMobile, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (!askGender && !askMobile) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-details'),
        style: {
            marginBottom: '0.625rem',
            maxWidth: '22rem'
        }
    }, askGender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-gender'),
        "data-value": value.gender || undefined,
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            marginBottom: '0.25rem'
        }
    }, t('visit.erx.patientDetails.gender')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.patientDetails.gender'),
        size: "sm",
        value: value.gender || '',
        onChange: onGender,
        options: [
            'male',
            'female'
        ].map((g)=>({
                value: g,
                label: t(`common.gender.${g}`),
                disabled: disabled
            }))
    })), askMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('visit.erx.patientDetails.mobile'),
        value: value.mobile,
        onChange: onMobile,
        countries: [
            'IR'
        ],
        disabled: disabled,
        "data-testid": tid('patient-mobile')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.patientDetails.hint')));
}
function $1ccba15c4d511e83$var$DetailsSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-details-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientDetails.saved') : t('visit.erx.patientDetails.notSaved')));
}
// ── the insurer (PM-0101) ───────────────────────────────────────────────────
// The card opens on the patient's own basic insurer — the server reads it from
// their policy, else the record's «بیمه» field — and says so. The doctor may
// send to another: that holds for this prescription alone, and the card says
// that too. A patient whose record names NONE gets the insurer picked here, and
// — the box under it, ticked from the start — written to their record, so the
// next visit does not ask again. A record that already names one is never
// changed from a prescription.
function $1ccba15c4d511e83$var$InsurerSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientInsurer.saved') : t('visit.erx.patientInsurer.notSaved')));
}
function $1ccba15c4d511e83$var$InsurerField({ insurer: insurer, record: record, offered: offered, insurerName: insurerName, onPick: onPick, save: save, onSaveChange: onSaveChange, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const recordOffered = !!record && offered.includes(record);
    // Where the selection stands against the record.
    const source = !record ? 'none' : !recordOffered ? 'unsupported' : !insurer ? 'unpicked' : insurer === record ? 'record' : 'differs';
    const note = source === 'none' ? insurer ? t('visit.erx.patientInsurer.noRecord') : t('visit.erx.patientHasNoInsurer') : source === 'unsupported' ? t('visit.erx.patientInsurer.unsupported', {
        insurer: insurerName(record)
    }) : source === 'record' ? t('visit.erx.patientInsurer.fromRecord') : source === 'differs' ? t('visit.erx.patientInsurer.differs', {
        insurer: insurerName(record)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-field'),
        "data-source": source,
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.3125rem'
        }
    }, t('visit.erx.patientInsurer.label')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.insurerLabel'),
        size: "sm",
        value: insurer || '',
        onChange: onPick,
        options: offered.map((v)=>({
                value: v,
                label: insurerName(v),
                disabled: disabled
            }))
    })), note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-note'),
        style: {
            marginTop: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: source === 'record' ? 'mute' : 'ink'
    }, note)), source === 'none' && !!insurer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save,
        onChange: (v)=>onSaveChange(!!v),
        disabled: disabled,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[11px]",
        style: {
            marginTop: '0.375rem'
        },
        "data-testid": tid('insurer-save')
    }));
}
function $1ccba15c4d511e83$var$PatientNidField({ value: value, onChange: onChange, record: record, save: save, onSaveChange: onSaveChange, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const valid = $1ccba15c4d511e83$var$isValidNationalCode(value);
    const differs = !!value && value !== (record || '');
    const hint = differs ? t('visit.erx.patientNid.differs') : !record ? t('visit.erx.patientNid.noRecord') : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-nid'),
        "data-differs": differs || undefined,
        style: {
            marginBottom: '0.625rem',
            maxWidth: '22rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('visit.erx.patientNid.label'),
        value: value,
        onChange: (e)=>onChange(e.target.value),
        helperText: hint,
        disabled: disabled,
        "data-testid": tid('patient-nid-input')
    }), differs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save && valid,
        onChange: (v)=>onSaveChange(!!v),
        disabled: !valid || disabled,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[11px]",
        style: {
            marginTop: '0.375rem'
        },
        "data-testid": tid('patient-nid-save')
    }));
}
const $1ccba15c4d511e83$export$d0b86cebda39e386 = (l)=>l?.medicationId ? `m:${l.medicationId}` : l?.orderId ? `o:${l.orderId}` : null;
const $1ccba15c4d511e83$var$linePart = (l)=>l?.part || (l?.orderId ? 'SERVICES' : 'DRUGS');
const $1ccba15c4d511e83$var$PANEL_GROUPS = [
    [
        'DRUGS',
        'visit.erx.panel.drugs'
    ],
    [
        'SERVICES',
        'visit.erx.panel.orders'
    ]
];
// What the panel answers itself: the card's own fields, the patient's national
// code (asked above the preview) and the insurer (asked in the login window).
// Anything else stops the automatic login — there is something to fix first,
// and the login can wait for «ثبت نسخه در …».
const $1ccba15c4d511e83$var$PANEL_FIXES = new Set([
    ...$1ccba15c4d511e83$var$HANDLED_IN_CARD,
    'PATIENT_NATIONAL_CODE_MISSING',
    'PATIENT_NATIONAL_CODE_INVALID',
    'PATIENT_INSURER_UNKNOWN'
]);
// A line the panel's send carries: one that can go and is still ticked.
const $1ccba15c4d511e83$var$panelGoes = (l, unticked)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable' && (!$1ccba15c4d511e83$export$d0b86cebda39e386(l) || !unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l)));
// «وارد هستید تا …»: the hour, and within the hour the minutes left (a تأمین
// login lasts 15); «فردا» for one that outlives today. Days are compared as the
// kit's formatter writes them, so both are read in the one zone it pins.
function $1ccba15c4d511e83$var$sessionUntil(t, formatDate, formatTime, expiresAt, now = new Date()) {
    const end = expiresAt ? new Date(expiresAt) : null;
    if (!end || Number.isNaN(end.getTime())) return t('visit.erx.panel.signedIn');
    const time = formatTime(end);
    const minutes = Math.round((end.getTime() - now.getTime()) / 60000);
    if (minutes >= 0 && minutes < 60) return t('visit.erx.panel.untilSoon', {
        time: time,
        minutes: minutes
    });
    const day = (d)=>formatDate(d, 'medium');
    if (day(end) === day(now)) return t('visit.erx.panel.until', {
        time: time
    });
    if (day(end) === day(new Date(now.getTime() + 86400000))) return t('visit.erx.panel.untilTomorrow', {
        time: time
    });
    return t('visit.erx.panel.signedIn');
}
// «اطلاعات بیمه»: the insurer the prescription goes to and how long the login
// lasts — or, before one, how to log in (`children`).
function $1ccba15c4d511e83$var$InsuranceInfo({ name: name, session: session, onLogout: onLogout, locked: locked, children: children }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const active = session?.state === 'ACTIVE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": tid('insurance'),
        "data-session": session?.state || 'NONE',
        "aria-label": t('visit.erx.panel.infoTitle'),
        style: {
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.75rem 0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.panel.infoTitle')), active && onLogout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onLogout,
        disabled: locked,
        "data-testid": tid('logout'),
        style: {
            background: 'none',
            border: 0,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.6875rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0hzSL.default), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.logout'))), name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurance-name'),
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.panel.noInsurer')), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurance-until'),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kMJsW.default), {
        size: 14,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, $1ccba15c4d511e83$var$sessionUntil(t, formatDate, formatTime, session?.expiresAt))), children);
}
// One line of the preview: its checkbox, its name, the visit's words for it (a
// drug's dose, an order's kind) and — when it cannot go — why. Only a line that
// can go can be ticked.
function $1ccba15c4d511e83$var$PreviewLine({ line: l, on: on, onToggle: onToggle, reasonText: reasonText, describeLine: describeLine, disabled: disabled }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const s = $1ccba15c4d511e83$var$lineStanding(l);
    const goes = s === 'sendable';
    const key = $1ccba15c4d511e83$export$d0b86cebda39e386(l);
    let sub = null;
    if (describeLine) try {
        sub = describeLine(l) || null;
    } catch  {
        sub = null;
    }
    const label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "auto",
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: goes ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).mute
        }
    }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, l.name) : l.name), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, sub), goes && l.sentAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": tid('line-sent-as'),
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.sentAsGeneric'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "ltr"
    }, l.sentAs)), !goes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: s === 'registered' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only"
    }, t('visit.erx.lineNotSent'), ": "), reasonText(l)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        "data-testid": tid('line'),
        "data-standing": s,
        "data-sendable": l.sendable ? 'true' : 'false',
        "data-reason": l.reasonCode || undefined,
        "data-selected": goes && on ? 'true' : 'false',
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            background: goes || s === 'registered' ? undefined : (0, $jTCZr.CT).warnSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: goes && on,
        onChange: ()=>onToggle(key),
        disabled: disabled || !goes || !key,
        label: label,
        className: "items-start",
        style: {
            padding: '0.625rem 0.875rem',
            minHeight: 52
        },
        "data-testid": tid('line-check')
    }));
}
// The preview: the نسخه's drugs and the دستورات, each a group whose own checkbox
// ticks or clears every line of it that can go — «some» is a dash.
function $1ccba15c4d511e83$var$SelectableLines({ lines: lines, unticked: unticked, onToggle: onToggle, onToggleGroup: onToggleGroup, reasonText: reasonText, describeLine: describeLine, disabled: disabled }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('preview'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.panel.previewTitle')), $1ccba15c4d511e83$var$PANEL_GROUPS.map(([part, label])=>{
        const group = lines.filter((l)=>$1ccba15c4d511e83$var$linePart(l) === part);
        if (!group.length) return null;
        const canGo = group.filter((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable');
        const choosable = canGo.filter((l)=>$1ccba15c4d511e83$export$d0b86cebda39e386(l));
        const going = canGo.filter((l)=>$1ccba15c4d511e83$var$panelGoes(l, unticked)).length;
        const ticked = choosable.filter((l)=>!unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l))).length;
        const all = choosable.length > 0 && ticked === choosable.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: part,
            "data-testid": tid(`group-${part}`),
            "data-selected": going,
            "data-total": canGo.length,
            "aria-label": t(label),
            style: {
                background: (0, $jTCZr.CT).surface,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).card,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                minHeight: 48,
                padding: '0 0.875rem',
                background: (0, $jTCZr.CT).surface2,
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: all ? true : ticked > 0 ? 'indeterminate' : false,
            onChange: ()=>onToggleGroup(choosable.map($1ccba15c4d511e83$export$d0b86cebda39e386), !all),
            disabled: disabled || choosable.length === 0,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.CT).ink
                }
            }, t(label)),
            style: {
                flex: 1,
                minHeight: 44
            },
            "data-testid": tid(`group-${part}-toggle`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t('visit.erx.panel.groupCount', {
            selected: going,
            total: canGo.length
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            style: {
                listStyle: 'none',
                margin: 0,
                padding: 0
            }
        }, group.map((l, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PreviewLine, {
                key: $1ccba15c4d511e83$export$d0b86cebda39e386(l) || `${l.name}-${i}`,
                line: l,
                on: $1ccba15c4d511e83$var$panelGoes(l, unticked),
                onToggle: onToggle,
                reasonText: reasonText,
                describeLine: describeLine,
                disabled: disabled
            }))));
    }));
}
// The send's answer, line by line: registered, left unticked, or not sent and
// why. A line the doctor unticked reads so for as long as the panel knows it —
// after a fresh read the server can only say it is not in the registration.
function $1ccba15c4d511e83$var$resultStanding(l, unticked) {
    const s = $1ccba15c4d511e83$var$lineStanding(l, true);
    const left = unticked?.has($1ccba15c4d511e83$export$d0b86cebda39e386(l));
    if (left && (s === 'registered' ? l.reasonCode !== $1ccba15c4d511e83$var$ALREADY_REGISTERED : l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION)) return 'not-selected';
    return s;
}
const $1ccba15c4d511e83$var$RESULT_TONE = {
    registered: [
        (0, $jTCZr.CT).goodSoft,
        (0, $jTCZr.CT).goodInk
    ],
    'not-selected': [
        (0, $jTCZr.CT).surface2,
        (0, $jTCZr.CT).ink2
    ],
    'not-sent': [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ],
    changed: [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ],
    removed: [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ]
};
function $1ccba15c4d511e83$var$PanelResult({ lines: lines, unticked: unticked, reasonText: reasonText, name: name, trackingCode: trackingCode, fallback: fallback, notes: notes }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const rows = (lines || []).map((l)=>[
            l,
            $1ccba15c4d511e83$var$resultStanding(l, unticked)
        ]);
    // A removed line is the insurer's, no longer the visit's: not one of its items.
    const counted = rows.filter(([, s])=>s !== 'removed');
    const registered = counted.filter(([, s])=>s === 'registered').length;
    const notSent = counted.length - registered;
    const all = notSent === 0;
    const chip = (l, s)=>s === 'registered' ? t('visit.erx.panel.lineRegistered') : s === 'not-selected' ? t('visit.erx.panel.lineNotSelected') : s === 'not-sent' ? t('visit.erx.panel.lineNotSent', {
            reason: reasonText(l) || ''
        }) : reasonText(l);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('result-head'),
        "data-all": all ? 'true' : 'false',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            padding: '0.75rem 0.875rem',
            borderRadius: (0, $jTCZr.RADIUS).card,
            background: all ? (0, $jTCZr.CT).goodSoft : (0, $jTCZr.CT).warnSoft,
            border: `1px solid ${all ? (0, $jTCZr.CT).good : (0, $jTCZr.CT).warn}`,
            color: all ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700
        }
    }, !counted.length ? fallback : all ? t('visit.erx.panel.resultAll', {
        count: registered
    }) : t('visit.erx.panel.resultSome', {
        registered: registered,
        notSent: notSent
    })), trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem'
        }
    }, t('visit.erx.panel.trackingCode', {
        insurer: name
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        "data-testid": tid('tracking'),
        style: {
            unicodeBidi: 'isolate',
            display: 'inline-block',
            userSelect: 'all'
        }
    }, trackingCode)), notes), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": tid('result-lines'),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            overflow: 'hidden'
        }
    }, rows.map(([l, s], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: $1ccba15c4d511e83$export$d0b86cebda39e386(l) ? `${$1ccba15c4d511e83$export$d0b86cebda39e386(l)}-${s}` : `${l.name}-${i}`,
            "data-testid": tid('line'),
            "data-standing": s,
            "data-reason": l.reasonCode || undefined,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '0.625rem',
                minHeight: 48,
                padding: '0.625rem 0.875rem',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                fontSize: '0.84375rem',
                fontWeight: 600,
                color: s === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                minWidth: 0
            }
        }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, l.name) : l.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('line-result'),
            style: {
                flexShrink: 0,
                maxWidth: '55%',
                fontSize: '0.75rem',
                fontWeight: 600,
                lineHeight: 1.6,
                padding: '0.25rem 0.625rem',
                borderRadius: 999,
                background: $1ccba15c4d511e83$var$RESULT_TONE[s][0],
                color: $1ccba15c4d511e83$var$RESULT_TONE[s][1]
            }
        }, chip(l, s))))));
}
// The login window: the doctor's username and password AT the insurer — and,
// when their profile lacks them, their national code and mobile — then the code
// the insurer texts. تأمین has no password here: its own page is opened by the
// press. The insurer is CHOSEN here only for a patient whose record names none;
// a known one is a name in the title, never a choice (K1, 2026-10-13). The
// password is cleared the moment it is submitted.
const $1ccba15c4d511e83$var$SLOT = "\u2063";
function $1ccba15c4d511e83$var$ErxLoginDialog({ open: open, step: step, insurer: insurer, insurerName: insurerName, nameOf: nameOf, known: known, offered: offered, onPick: onPick, showSave: showSave, save: save, onSaveChange: onSaveChange, unsupportedRecord: unsupportedRecord, needs: needs, otpSentTo: otpSentTo, captchaImage: captchaImage, busy: busy, error: error, onLogin: onLogin, onAnswer: onAnswer, onCancel: onCancel, onRetry: onRetry }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const [username, setUsername] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [nid, setNid] = (0, $acw62.useState)('');
    const [mobile, setMobile] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (!open) setPassword('');
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        setCode('');
    }, [
        step
    ]);
    const tamin = insurer === 'TAMIN';
    const needsNid = needs.includes('DOCTOR_NATIONAL_CODE_MISSING');
    const needsMobile = needs.includes('DOCTOR_MOBILE_MISSING');
    const isOtp = step === 'otp';
    const isCaptcha = step === 'captcha';
    const clean = isOtp ? (0, $5JYPc.toEnDigits)(code).replace(/\D/g, '').slice(0, $1ccba15c4d511e83$var$OTP_MAX) : (0, $5JYPc.toEnDigits)(code).trim();
    const ready = step === 'login' ? !!insurer && (tamin || !!username.trim() && !!password) && (!needsNid || $1ccba15c4d511e83$var$isValidNationalCode(nid)) && (!needsMobile || mobile !== '') : step === 'rateLimited' || (isOtp ? clean.length >= $1ccba15c4d511e83$var$OTP_MIN : clean.length > 0);
    const submit = ()=>{
        if (!ready || busy) return;
        if (step === 'rateLimited') {
            onRetry();
            return;
        }
        if (isOtp || isCaptcha) {
            onAnswer(isOtp ? {
                otp: clean
            } : {
                captcha: clean
            });
            setCode('');
            return;
        }
        const form = {
            ...tamin ? {} : {
                username: (0, $5JYPc.toEnDigits)(username.trim()),
                password: password
            },
            nationalCode: needsNid ? nid : undefined,
            mobile: needsMobile ? (0, $5AX1S).toNational(mobile) : undefined
        };
        setPassword('');
        onLogin(form);
    };
    const onEnter = (e)=>{
        if (e.key === 'Enter') submit();
    };
    const title = isOtp ? t('visit.erx.panel.otpTitle', {
        insurer: insurerName
    }) : isCaptcha ? t('visit.erx.panel.captchaTitle', {
        insurer: insurerName
    }) : known ? t('visit.erx.panel.loginTitle', {
        insurer: insurerName
    }) : t('visit.erx.panel.pickTitle');
    const primary = isOtp || isCaptcha ? t('visit.erx.panel.confirm') : step === 'rateLimited' ? t('common.actions.retry') : tamin ? t('visit.erx.panel.submitTamin') : t('visit.erx.panel.submit');
    // The masked number sits inside the sentence, isolated: its digits and dots
    // would otherwise be reordered by the Persian around them.
    const [otpBefore, otpAfter = ''] = t('visit.erx.panel.otpLabel', {
        to: $1ccba15c4d511e83$var$SLOT
    }).split($1ccba15c4d511e83$var$SLOT);
    const fieldStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.875rem'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: onCancel,
        title: title,
        size: "sm",
        busy: busy,
        "data-testid": tid('login-dialog'),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            onClick: submit,
            disabled: !ready || busy,
            className: "gap-1.5",
            "data-testid": tid(isOtp ? 'otp-submit' : isCaptcha ? 'captcha-submit' : 'login-submit')
        }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), primary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            onClick: onCancel,
            disabled: busy,
            "data-testid": tid('login-cancel')
        }, t('common.actions.cancel')))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('login'),
        "data-step": step,
        style: fieldStyle
    }, step === 'login' && !known && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-field'),
        "data-source": unsupportedRecord ? 'unsupported' : 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            marginBottom: '0.5rem'
        }
    }, unsupportedRecord ? t('visit.erx.patientInsurer.unsupported', {
        insurer: unsupportedRecord
    }) : t('visit.erx.panel.pickLegend')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.insurerLabel'),
        size: "sm",
        value: insurer || '',
        onChange: onPick,
        options: offered.map((v)=>({
                value: v,
                label: nameOf(v),
                disabled: busy
            }))
    })), showSave && !!insurer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save,
        onChange: (v)=>onSaveChange(!!v),
        disabled: busy,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[13px]",
        style: {
            marginTop: '0.5rem',
            minHeight: 40
        },
        "data-testid": tid('insurer-save')
    })), step === 'login' && tamin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('tamin-note'),
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            padding: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: (0, $jTCZr.RADIUS).control
        }
    }, t('visit.erx.panel.taminNote')), step === 'login' && (needsNid || needsMobile) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: fieldStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.needsDetails')), needsNid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: nid,
        onChange: (e)=>setNid(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('nid')
    }), needsMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('auth.login.phoneLabel'),
        value: mobile,
        onChange: setMobile,
        countries: [
            'IR'
        ],
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('mobile')
    })), step === 'login' && !!insurer && !tamin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: fieldStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.panel.username', {
            insurer: insurerName
        }),
        helperText: t('visit.erx.login.usernameHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-username",
        value: username,
        onChange: (e)=>setUsername(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "username",
        dir: "ltr",
        "data-testid": tid('username')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.panel.password')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-password",
        type: "password",
        value: password,
        onChange: (e)=>setPassword(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "current-password",
        dir: "ltr",
        "data-testid": tid('password')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
        size: 12,
        "aria-hidden": "true"
    }), " ", t('visit.erx.panel.passwordNote'))), (isOtp || isCaptcha) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, isCaptcha && captchaImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: captchaImage,
        alt: t('visit.erx.captcha.imageAlt'),
        style: {
            display: 'block',
            maxHeight: '3rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: isOtp ? otpSentTo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, otpBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr"
        }, otpSentTo), otpAfter) : t('visit.erx.panel.otpLabelPlain') : t('visit.erx.captcha.label')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: isOtp ? 'erx-otp' : 'erx-captcha',
        value: isOtp ? clean : code,
        onChange: (e)=>setCode(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        inputMode: isOtp ? 'numeric' : 'text',
        autoComplete: isOtp ? 'one-time-code' : 'off',
        autoFocus: true,
        "aria-invalid": !!error,
        dir: "ltr",
        "data-testid": tid(isOtp ? 'otp' : 'captcha'),
        inputStyle: isOtp ? {
            textAlign: 'center',
            letterSpacing: '.3em',
            fontWeight: 700
        } : undefined
    }))), step === 'rateLimited' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.rateLimited')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, error))));
}
function $1ccba15c4d511e83$export$2e2bcd8739ae039({ testIdPrefix: testIdPrefix = 'visit-closure-erx', scope: scope = 'ALL', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxTestIdPrefix.Provider, {
        value: testIdPrefix
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxScope.Provider, {
        value: scope || 'ALL'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EPrescriptionCardBody, {
        ...props,
        scope: scope || 'ALL'
    })));
}
function $1ccba15c4d511e83$var$EPrescriptionCardBody({ appointmentId: appointmentId, patientId: patientId, onBusyChange: onBusyChange, prepare: prepare, refreshKey: refreshKey, scope: scope = 'ALL', onSubmitted: onSubmitted, describeLine: describeLine, compactWhenSettled: compactWhenSettled = false, flow: flow = 'card' }) {
    // A scoped card asks the scoped operations; an unscoped one the plain ones.
    const scoped = scope !== 'ALL';
    const panel = flow === 'panel';
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t, has: has, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const [preview, setPreview] = (0, $acw62.useState)(null);
    // Why the last read failed: null, 'absent' (isSchemaGap — silence) or 'failed'.
    // One failed read used to hide the card for the rest of the visit, read again
    // by nothing (K1, 2026-10-03); now it says so and offers to read again.
    const [loadError, setLoadError] = (0, $acw62.useState)(null);
    const [insurer, setInsurer] = (0, $acw62.useState)(null);
    const [session, setSession] = (0, $acw62.useState)(null);
    const [submission, setSubmission] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(null); // null | 'load' | 'login' | 'answer' | 'send' | 'correct' | 'logout' | 'siam'
    // What the doctor pressed and a login stands between: null, 'send' (the plain
    // send) or 'correct' (a correction they confirmed). Once the insurer session is
    // active it goes without a second press — the same one decision for both.
    const [wants, setWants] = (0, $acw62.useState)(null);
    // «اصلاح نسخه» (K1, 2026-10-04): the confirmation open; the last correction the
    // insurer did not take (the registration stands, so this is NOT `submission`);
    // the one it took, for «اصلاحیه … ثبت شد».
    const [confirmOpen, setConfirmOpen] = (0, $acw62.useState)(false);
    const [correctionResult, setCorrectionResult] = (0, $acw62.useState)(null);
    const [corrected, setCorrected] = (0, $acw62.useState)(null);
    // The settled registration's one line, opened into the whole card (PM-0097).
    const [detailsOpen, setDetailsOpen] = (0, $acw62.useState)(false);
    const [labDue, setLabDueState] = (0, $acw62.useState)({
        preset: 'TODAY',
        date: ''
    });
    // Whether the doctor chose the labs' day on this card. A correction carries it
    // only then: without one the registration's own day stands — a correction
    // changes only what the doctor changed (K1, 2026-10-04).
    const labDueChosen = (0, $acw62.useRef)(false);
    const setLabDue = (0, $acw62.useCallback)((value)=>{
        labDueChosen.current = true;
        setLabDueState(value);
    }, []);
    const [loginError, setLoginError] = (0, $acw62.useState)(null);
    const [challengeError, setChallengeError] = (0, $acw62.useState)(null);
    const [siamError, setSiamError] = (0, $acw62.useState)(null);
    // A login this card started reached the insurer. The server opens no session
    // without the doctor's national code and mobile, so from then on a preview
    // still naming them missing is stale, and the form must not ask again.
    const [needsMet, setNeedsMet] = (0, $acw62.useState)(false);
    // تأمین's login page was opened in a tab of its own by the press that sent.
    const [redirectOpened, setRedirectOpened] = (0, $acw62.useState)(false);
    // Completed reads, counted: the wait-and-read-again for a send still running
    // is scheduled after each one — not on a `busy` flip, which React may batch away.
    const [reads, setReads] = (0, $acw62.useState)(0);
    const inFlight = (0, $acw62.useRef)(false);
    // کد ملی بیمار: what the field shows, whether the doctor touched it, and the
    // last send's answer to «save it to the record».
    const [nid, setNid] = (0, $acw62.useState)('');
    const nidTouched = (0, $acw62.useRef)(false);
    // null = the doctor has not touched the box: it then starts ticked for a
    // record that holds NO code (nothing is overwritten), unticked for one that
    // holds another (PM-0101).
    const [saveNid, setSaveNid] = (0, $acw62.useState)(null);
    const [nidSaved, setNidSaved] = (0, $acw62.useState)(null);
    // The insurer picked for a patient whose record names none: saved to the
    // record unless the doctor unticks it (PM-0101), and the send's answer to that.
    const [saveInsurer, setSaveInsurer] = (0, $acw62.useState)(true);
    const [insurerSaved, setInsurerSaved] = (0, $acw62.useState)(null);
    // The code to send INSTEAD of the record's — null while the field holds the
    // record's own. A ref, so a read started by anything sends the current one.
    const nidOverride = (0, $acw62.useRef)(null);
    // The patient's gender and mobile the doctor gave for a record without them —
    // what the fields show, what every read and send carries (a ref, like the
    // national code), and the send's answer to writing them to the record.
    const [details, setDetails] = (0, $acw62.useState)({
        gender: '',
        mobile: ''
    });
    const detailsGiven = (0, $acw62.useRef)({
        gender: null,
        mobile: null
    });
    const [detailsSaved, setDetailsSaved] = (0, $acw62.useState)(null);
    const withDetails = (op, vars)=>{
        const { gender: gender, mobile: mobile } = detailsGiven.current;
        return gender || mobile ? [
            (0, $375f8776645d5aee$export$3dbec13a22a52d5f)(op),
            {
                ...vars,
                patientGender: gender,
                patientMobile: mobile
            }
        ] : [
            op,
            vars
        ];
    };
    const prepareRef = (0, $acw62.useRef)(prepare);
    prepareRef.current = prepare;
    const runPrepare = (0, $acw62.useCallback)(async ()=>{
        if (!prepareRef.current) return;
        try {
            await prepareRef.current();
        } catch (e) {
            console.warn('[erx] could not write the visit first:', e?.message);
        }
    }, []);
    const onSubmittedRef = (0, $acw62.useRef)(onSubmitted);
    onSubmittedRef.current = onSubmitted;
    const told = (0, $acw62.useCallback)((r)=>{
        try {
            onSubmittedRef.current?.(r);
        } catch (e) {
            console.warn('[erx] onSubmitted failed:', e?.message);
        }
    }, []);
    // A BFF that predates corrections refuses the preview's new fields. Asked once
    // more without them, it answers the card it always did — and from then on this
    // card asks it the old question (K1, 2026-10-04).
    const preCorrection = (0, $acw62.useRef)(false);
    // ── the panel (PM-0187) ──
    // The lines the doctor unticked (erxLineKey), and the ones a registered send
    // left out — for its answer, line by line.
    const [unticked, setUnticked] = (0, $acw62.useState)(()=>new Set());
    const [sentUnticked, setSentUnticked] = (0, $acw62.useState)(null);
    // The doctor closed the login window without logging in.
    const [loginCancelled, setLoginCancelled] = (0, $acw62.useState)(false);
    // The panel checks the insurer session once, on its first read.
    const autoChecked = (0, $acw62.useRef)(false);
    // Our sentences arrive with a code and render in the doctor's language; the
    // insurer's arrive without one and are shown exactly as they came.
    const msgText = (0, $acw62.useCallback)((code, fallback)=>code && has(`visit.erx.msg.${code}`) ? t(`visit.erx.msg.${code}`) : fallback || null, [
        t,
        has
    ]);
    const blockerText = (0, $acw62.useCallback)((b)=>has(`visit.erx.blocker.${b.code}`) ? t(`visit.erx.blocker.${b.code}`) : b.message, [
        t,
        has
    ]);
    // A correction refused before anything was sent names the same reasons the
    // preview gives (Rules §3) — said in the same words as there.
    const correctionMsgText = (0, $acw62.useCallback)((code, fallback)=>code && has(`visit.erx.correction.unavailable.${code}`) ? t(`visit.erx.correction.unavailable.${code}`) : msgText(code, fallback), [
        t,
        has,
        msgText
    ]);
    // ALREADY_AT_INSURER names the prescription that holds the service: its
    // tracking code (heldTrackingCode, K1 2026-10-11).
    // ADDED_AFTER_REGISTRATION is any line the registration does not hold — one
    // written after it, or one the doctor left unticked (PM-0187): the server
    // cannot tell them apart, so the card says what both are.
    const reasonText = (0, $acw62.useCallback)((l)=>{
        const code = l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION ? 'NOT_IN_REGISTRATION' : l.reasonCode;
        return code && has(`visit.erx.reason.${code}`) ? t(`visit.erx.reason.${code}`, {
            trackingCode: l.heldTrackingCode || ''
        }) : l.reason;
    }, [
        t,
        has
    ]);
    const insurerName = (0, $acw62.useCallback)((value)=>value && has(`visit.erx.insurer.${value}`) ? t(`visit.erx.insurer.${value}`) : preview?.insurerLabel || '', [
        t,
        has,
        preview
    ]);
    const load = (0, $acw62.useCallback)(async (chosen)=>{
        setBusy('load');
        try {
            await runPrepare();
            const vars = {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: chosen || null,
                patientNationalCode: nidOverride.current,
                ...scoped ? {
                    scope: scope
                } : {}
            };
            const ask = (old)=>(0, $adebb901af88e18b$export$7fb4864174f056c)(...withDetails(scoped ? old ? (0, $375f8776645d5aee$export$5ddaa93868d3670f) : (0, $375f8776645d5aee$export$e76d3b0c177e8362) : old ? (0, $375f8776645d5aee$export$2fedc374da938b3c) : (0, $375f8776645d5aee$export$4d6ef37e3b3fc364), vars));
            let d;
            try {
                d = await ask(preCorrection.current);
            } catch (e) {
                if (preCorrection.current || !$1ccba15c4d511e83$var$isSchemaGap(e)) throw e;
                preCorrection.current = true;
                d = await ask(true);
            }
            const p = d?.ePrescriptionPreview || null;
            setPreview(p);
            setSession(p?.session || null);
            setSubmission(p?.submission || null);
            setInsurer(p?.insurer || chosen || null);
            if (!nidTouched.current) setNid(p?.patientNationalCode || '');
            setLoadError(null);
        } catch (e) {
            // A BFF that cannot even ask is shown as nothing: the feature is not there
            // to fail. Any other failure is said, with a retry — silence there took the
            // card away from a doctor who had it, over one dropped request.
            setLoadError($1ccba15c4d511e83$var$isSchemaGap(e) ? 'absent' : 'failed');
        } finally{
            setBusy(null);
            setReads((n)=>n + 1);
        }
    }, [
        appointmentId,
        patientId,
        runPrepare,
        scoped,
        scope
    ]);
    (0, $acw62.useEffect)(()=>{
        if (appointmentId && patientId) load(null);
    }, [
        appointmentId,
        patientId,
        load
    ]);
    // What the visit holds changed (the in-visit section): read again — unless the
    // doctor is mid-login or mid-send, which a re-read must never interrupt.
    const insurerRef = (0, $acw62.useRef)(insurer);
    insurerRef.current = insurer;
    const sessionStateRef = (0, $acw62.useRef)(null);
    sessionStateRef.current = session?.state || null;
    const firstKey = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (firstKey.current) {
            firstKey.current = false;
            return;
        }
        if (inFlight.current || $1ccba15c4d511e83$var$CHALLENGE.includes(sessionStateRef.current)) return;
        load(insurerRef.current);
    }, [
        refreshKey,
        load
    ]);
    // A send the server says is still running, which this card did not start — a
    // send left in flight when پایان ویزیت unmounted the in-visit card, say (K1,
    // 2026-10-03). Read again after a short wait, a few times, until it settles;
    // «بررسی دوباره» asks at once and starts the count again. Never mid-login.
    const serverSending = submission?.state === 'SENDING';
    const challenged = $1ccba15c4d511e83$var$CHALLENGE.includes(session?.state);
    const rechecks = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        if (!serverSending) {
            rechecks.current = 0;
            return undefined;
        }
        if (busy || challenged || rechecks.current >= $1ccba15c4d511e83$export$1591506e3dd28b74) return undefined;
        const timer = setTimeout(()=>{
            rechecks.current += 1;
            load(insurerRef.current);
        }, $1ccba15c4d511e83$export$d7dc397751880ad8);
        return ()=>clearTimeout(timer);
    }, [
        serverSending,
        busy,
        challenged,
        load,
        reads
    ]);
    const onRecheck = ()=>{
        rechecks.current = 0;
        load(insurerRef.current);
    };
    // استحقاق‌سنجی (PM-0145): once the card could send — the doctor signed in to the
    // insurer, nothing else in the way — ask whether the insurer covers the patient.
    // On its own, so the card is never held up by the insurer. A BFF without the
    // question, or an answer that fails, shows nothing: it decides no send.
    const [eligibility, setEligibility] = (0, $acw62.useState)(null);
    const eligibilityKey = preview?.ready && session?.state === 'ACTIVE' && preview?.insurer ? `${preview.insurer}|${preview.sentNationalCode || ''}` : null;
    (0, $acw62.useEffect)(()=>{
        if (!eligibilityKey || !appointmentId || !patientId) {
            setEligibility(null);
            return undefined;
        }
        let live = true;
        setEligibility('loading');
        const [insurerEnum, code] = eligibilityKey.split('|');
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$876fbc5c8db40344), {
            appointmentId: appointmentId,
            patientId: patientId,
            insurer: insurerEnum,
            patientNationalCode: code || null
        }).then((d)=>{
            if (live) setEligibility(d?.ePrescriptionEligibility || null);
        }).catch(()=>{
            if (live) setEligibility(null);
        });
        return ()=>{
            live = false;
        };
    }, [
        eligibilityKey,
        appointmentId,
        patientId
    ]);
    const eligibilityBlocks = eligibility?.state === 'NOT_ELIGIBLE' && eligibility.blocks === true;
    // The doctor typed a national code: re-read once it is a whole one, so the
    // blockers and the سلامت number say what THIS code would do.
    const onNidChange = (value)=>{
        nidTouched.current = true;
        setNid(value);
        setNidSaved(null);
        const record = preview?.patientNationalCode || '';
        const next = value && value !== record ? value : null;
        if (value.length === 10 || value === record || value === '') {
            if (next !== nidOverride.current) {
                nidOverride.current = next;
                if (value.length === 10 || value === record) load(insurer);
            }
        }
    };
    // The doctor gave the patient's gender or mobile: re-read, so the card says
    // what the prescription would do with it — a mobile once it is a whole one.
    const onGenderChange = (gender)=>{
        setDetails((d)=>({
                ...d,
                gender: gender
            }));
        setDetailsSaved(null);
        if (gender !== detailsGiven.current.gender) {
            detailsGiven.current = {
                ...detailsGiven.current,
                gender: gender
            };
            load(insurer);
        }
    };
    const onMobileChange = (e164)=>{
        setDetails((d)=>({
                ...d,
                mobile: e164 || ''
            }));
        setDetailsSaved(null);
        const next = e164 && (0, $5AX1S).toNational(e164) || null;
        if (next !== detailsGiven.current.mobile) {
            detailsGiven.current = {
                ...detailsGiven.current,
                mobile: next
            };
            load(insurer);
        }
    };
    // A login waiting for a code, or a send in flight, is unsaved work: the closure
    // asks before any exit abandons it.
    const midFlight = busy === 'send' || busy === 'correct' || busy === 'login' || busy === 'answer' || $1ccba15c4d511e83$var$CHALLENGE.includes(session?.state);
    (0, $acw62.useEffect)(()=>{
        onBusyChange?.(midFlight);
    }, [
        midFlight,
        onBusyChange
    ]);
    (0, $acw62.useEffect)(()=>()=>onBusyChange?.(false), [
        onBusyChange
    ]);
    // In-flight guard: a double click must not send twice or log in twice. The
    // server would cope, but there is no reason to make it prove that.
    const guard = async (kind, fn)=>{
        if (inFlight.current) return;
        inFlight.current = true;
        setBusy(kind);
        try {
            await fn();
        } finally{
            inFlight.current = false;
            setBusy(null);
        }
    };
    // What the login form must ask for: the doctor's own national code and mobile,
    // when their profile lacks them — until a login has shown they are on file.
    const needs = needsMet ? [] : (preview?.blockers || []).filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>b.code);
    // Sends now. Only called when the session is known to be active — from the
    // button, or straight after a login completes.
    const hasLabs = (preview?.lines || []).some((l)=>l.sendable && l.serviceCode && (!panel || $1ccba15c4d511e83$var$panelGoes(l, unticked)));
    // The panel's unticked lines a send leaves out — only ones that could go at all,
    // so a line gone from the visit since it was unticked asks nothing.
    const exclusion = (0, $acw62.useMemo)(()=>{
        if (!panel || !unticked.size) return null;
        const keys = (preview?.lines || []).filter((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable' && unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l))).map($1ccba15c4d511e83$export$d0b86cebda39e386);
        if (!keys.length) return null;
        return {
            keys: new Set(keys),
            vars: {
                excludedMedicationIds: keys.filter((k)=>k.startsWith('m:')).map((k)=>k.slice(2)),
                excludedOrderIds: keys.filter((k)=>k.startsWith('o:')).map((k)=>k.slice(2))
            }
        };
    }, [
        panel,
        unticked,
        preview
    ]);
    // The national-code box as it stands: the doctor's own choice once they have
    // made one, else ticked only for a record with no code at all.
    const saveNidOn = saveNid ?? !preview?.patientNationalCode;
    // The insurer is written to the record only when the record names none.
    const insurerToRecord = !!insurer && !!preview && !preview.patientInsurer && saveInsurer;
    const sendNow = (0, $acw62.useCallback)(async ()=>{
        try {
            await runPrepare();
            const vars = {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: insurer,
                ...scoped ? {
                    scope: scope
                } : {},
                labDue: hasLabs ? {
                    preset: labDue.preset,
                    date: labDue.preset === 'CUSTOM' ? labDue.date : null
                } : null,
                patientNationalCode: nidOverride.current,
                savePatientNationalCode: !!(saveNidOn && nidOverride.current),
                ...exclusion ? exclusion.vars : {}
            };
            // The lines the doctor unticked, asked only when there are some (PM-0187).
            const op = (base)=>exclusion ? (0, $375f8776645d5aee$export$aebcdf6f5e0d5e2c)(base) : base;
            // The insurer goes to the record only for a patient whose record names
            // none, and only through its own operation. A BFF that predates it refuses
            // the argument: the prescription then goes as it always did, and the card
            // says the record was not changed.
            let d;
            let insurerUnsaved = false;
            if (insurerToRecord) try {
                d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(...withDetails(op(scoped ? (0, $375f8776645d5aee$export$f4844156b4b46778) : (0, $375f8776645d5aee$export$45a656a5891fd4c1)), {
                    ...vars,
                    savePatientInsurer: true
                }));
            } catch (e) {
                if (!$1ccba15c4d511e83$var$isSchemaGap(e)) throw e;
                insurerUnsaved = true;
            }
            if (!d) d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(...withDetails(op(scoped ? (0, $375f8776645d5aee$export$4b366d0c9745cd96) : (0, $375f8776645d5aee$export$cdbeae1ac264703e)), vars));
            const r = d?.sendEPrescription || null;
            setSubmission(r);
            if (r?.state === 'REGISTERED') setSentUnticked(exclusion ? exclusion.keys : null);
            setNidSaved(r?.patientNationalCodeSaved ?? null);
            setDetailsSaved(r?.patientDetailsSaved ?? null);
            setInsurerSaved(insurerUnsaved ? false : r?.patientInsurerSaved ?? null);
            setWants(null);
            if (r?.state === 'SESSION_REQUIRED') {
                // The insurer stopped accepting the login: ask for it again, and send
                // once it is back — the doctor already decided to send.
                setSession((s)=>({
                        ...s || {},
                        state: 'EXPIRED'
                    }));
                setWants('send');
            }
            told(r);
        } catch (e) {
            setSubmission({
                state: 'FAILED',
                message: e.message,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        }
    }, [
        appointmentId,
        patientId,
        insurer,
        hasLabs,
        labDue,
        saveNidOn,
        insurerToRecord,
        runPrepare,
        t,
        scoped,
        scope,
        told,
        exclusion
    ]);
    // تأمین, with nothing the login form would ask: there is no form to fill, so
    // the press that decides goes straight to تأمین's page (openLoginTab).
    const loginInOnePress = insurer === 'TAMIN' && needs.length === 0;
    const onSend = ()=>guard('send', async ()=>{
            setLoginError(null);
            // Not logged in — or the doctor's own national code or mobile is missing,
            // which only the login form asks for (and saves): the form, then the send.
            if (session?.state !== 'ACTIVE' || needs.length) {
                setWants('send');
                if (!loginInOnePress) return;
                const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
                setBusy('login');
                const s = await startLogin({}, tab);
                if (s?.state === 'ACTIVE') {
                    setBusy('send');
                    await sendNow();
                }
                return;
            }
            await sendNow();
        });
    // ── «اصلاح نسخه» (K1, 2026-10-04) ──────────────────────────────────────────
    // Sends the correction — the whole prescription of every registered part in
    // this scope, as the record now holds it — with the same insurer and national
    // code a send would carry, and the labs' day if the doctor chose one. Only
    // called with the session known to be active: from the confirmation, or
    // straight after a login completes.
    const submissionRef = (0, $acw62.useRef)(submission);
    submissionRef.current = submission;
    const correctNow = (0, $acw62.useCallback)(async ()=>{
        try {
            await runPrepare();
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(...withDetails((0, $375f8776645d5aee$export$998c87dffbd5dcdb), {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: insurer,
                scope: scope,
                labDue: labDueChosen.current ? {
                    preset: labDue.preset,
                    date: labDue.preset === 'CUSTOM' ? labDue.date : null
                } : null,
                patientNationalCode: nidOverride.current
            }));
            const r = d?.sendEPrescriptionCorrection || null;
            setWants(null);
            told(r);
            if (r?.state === 'SESSION_REQUIRED') {
                // As a send: the login again, and the correction once it is back.
                setSession((s)=>({
                        ...s || {},
                        state: 'EXPIRED'
                    }));
                setWants('correct');
                return;
            }
            if (r?.state === 'REGISTERED' && r.correctsLocalId) {
                // The correction IS the registration now (Rules §5): its tracking code at
                // once, then the lines and what is left to correct as the insurer holds
                // them. A scope with a part still unsent stays on its send.
                setCorrectionResult(null);
                setCorrected(r);
                if (submissionRef.current?.state === 'REGISTERED') setSubmission(r);
                await load(insurerRef.current);
                return;
            }
            if (r && (r.state === 'REGISTERED' || r.state === 'NONE')) {
                // Refused before anything was sent — the registration as it stands, and
                // why (Rules §3; or it moved meanwhile, REGISTRATION_SUPERSEDED). Said,
                // and the card reads again: what it showed is no longer so.
                setCorrectionResult({
                    ...r,
                    state: 'REFUSED'
                });
                await load(insurerRef.current);
                return;
            }
            setCorrectionResult(r || {
                state: 'FAILED',
                message: null,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        } catch (e) {
            setCorrectionResult({
                state: 'FAILED',
                message: e.message,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        }
    }, [
        appointmentId,
        patientId,
        insurer,
        scope,
        labDue,
        runPrepare,
        load,
        told
    ]);
    const onCorrect = ()=>{
        setConfirmOpen(false);
        return guard('correct', async ()=>{
            setLoginError(null);
            setCorrectionResult(null);
            setCorrected(null);
            if (session?.state !== 'ACTIVE' || needs.length) {
                setWants('correct');
                if (!loginInOnePress) return;
                const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
                setBusy('login');
                const s = await startLogin({}, tab);
                if (s?.state === 'ACTIVE') {
                    setBusy('correct');
                    await correctNow();
                }
                return;
            }
            await correctNow();
        });
    };
    // What a login was for, once the insurer session is active.
    const proceed = ()=>wants === 'send' ? sendNow() : wants === 'correct' ? correctNow() : null;
    // Starts the insurer login and answers with the session it opened. `tab` — a
    // tab opened for تأمین's page by the press itself (openLoginTab): pointed at
    // the page when the insurer names it, closed when it does not.
    const startLogin = async (form, tab = null)=>{
        setLoginError(null);
        setChallengeError(null);
        setRedirectOpened(false);
        let handedOver = false;
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$a95f04fc131305cf), {
                insurer: insurer,
                ...form
            });
            const s = d?.startInsurerLogin || null;
            setSession(s);
            // Any answer from the insurer itself proves the profile holds both.
            if (s?.state === 'ACTIVE' || $1ccba15c4d511e83$var$CHALLENGE.includes(s?.state)) setNeedsMet(true);
            if (s?.state === 'REDIRECT_REQUIRED' && s.redirectUrl && tab && !tab.closed) try {
                tab.location.href = s.redirectUrl;
                handedOver = true;
                setRedirectOpened(true);
            } catch  {}
            if (s?.state !== 'ACTIVE' && !$1ccba15c4d511e83$var$CHALLENGE.includes(s?.state) && s?.state !== 'RATE_LIMITED') setLoginError(msgText(s?.messageCode, s?.message) || t('visit.erx.failed'));
            return s;
        } catch (e) {
            setLoginError(e.message);
            return null;
        } finally{
            // Never left behind blank.
            if (tab && !handedOver) try {
                tab.close();
            } catch  {}
        }
    };
    const onLogin = (form)=>guard('login', async ()=>{
            // تأمین's page opens from this press too, as from «ارسال».
            const tab = insurer === 'TAMIN' ? $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab')) : null;
            const s = await startLogin(form, tab);
            if (s?.state === 'ACTIVE') await proceed();
        });
    const onAnswer = (answer)=>guard('answer', async ()=>{
            setChallengeError(null);
            try {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$d688676352e6afeb), {
                    insurer: insurer,
                    ...answer
                });
                const s = d?.answerInsurerChallenge || null;
                setSession(s);
                if (s?.state === 'ACTIVE') await proceed();
                else if (s?.messageCode || s?.message) {
                    const text = msgText(s.messageCode, s.message);
                    if ($1ccba15c4d511e83$var$CHALLENGE.includes(s.state)) setChallengeError(text);
                    else setLoginError(text);
                }
            } catch (e) {
                setChallengeError(e.message);
            }
        });
    // تأمین: the return page (/erx/tamin-return) announces that the doctor is back
    // from تأمین's own login page, and the card re-checks the session — and sends,
    // if that was the decision — without the doctor finding it and pressing
    // anything. «ورود را انجام دادم» stays as the manual fallback.
    const onAnswerRef = (0, $acw62.useRef)(onAnswer);
    onAnswerRef.current = onAnswer;
    (0, $acw62.useEffect)(()=>{
        if (session?.state !== 'REDIRECT_REQUIRED') return undefined;
        return (0, $ctEhH.onTaminReturn)((detail)=>{
            if (detail.ok) onAnswerRef.current({});
            else setChallengeError(t('visit.erx.redirect.denied'));
        });
    }, [
        session?.state,
        t
    ]);
    const onSaveSiam = (siamId)=>guard('siam', async ()=>{
            setSiamError(null);
            try {
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$3713d209ae047851), {
                    siamId: siamId
                });
                await load(insurer);
            } catch (e) {
                setSiamError(e.message);
            }
        });
    const onLogout = ()=>guard('logout', async ()=>{
            try {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$d48ea6856e66736d), {
                    insurer: insurer
                });
                setSession(d?.logoutInsurer || {
                    state: 'NONE'
                });
            } catch  {}
        });
    const onPickInsurer = (value)=>{
        if (value === insurer) return;
        setInsurer(value);
        // The panel picks in its login window, which stays open for the login.
        if (!panel) setWants(null);
        setLoginError(null);
        setChallengeError(null);
        setCorrectionResult(null);
        setInsurerSaved(null);
        load(value);
    };
    // ── the panel's login (PM-0187) ────────────────────────────────────────────
    // The patient's insurer is known when their record names one this deployment
    // sends to: then it is never offered as a choice, on any card.
    const recordKnown = !!preview?.patientInsurer && (preview?.offeredInsurers || []).includes(preview.patientInsurer);
    // تأمین, known, with nothing the window would ask: its own page, no window.
    const taminDirect = insurer === 'TAMIN' && recordKnown && needs.length === 0;
    // تأمین's page opened by the panel itself, on its first read. No press stands
    // behind it, so the browser may refuse the tab: the «باز کردن» button the
    // waiting note carries then opens it.
    const openTaminByItself = ()=>guard('login', async ()=>{
            const s = await startLogin({});
            if (s?.state !== 'REDIRECT_REQUIRED' || !s.redirectUrl) return;
            const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
            if (!tab) return;
            try {
                tab.location.href = s.redirectUrl;
                setRedirectOpened(true);
            } catch  {
                try {
                    tab.close();
                } catch  {}
            }
        });
    // The panel opens on the login, not on a button (K1, 2026-10-13): once, on the
    // first read — a live session goes straight to the preview; anything the
    // doctor must fix first, or nothing to send, leaves the login for later.
    (0, $acw62.useEffect)(()=>{
        if (!panel || autoChecked.current || !preview || busy) return;
        autoChecked.current = true;
        if (!preview.enabled || preview.serviceIssue) return;
        if ([
            'REGISTERED',
            'SENDING'
        ].includes(preview.submission?.state)) return;
        if ((preview.blockers || []).some((b)=>!$1ccba15c4d511e83$var$PANEL_FIXES.has(b.code))) return;
        if (!(preview.lines || []).some((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable')) return;
        const state = preview.session?.state;
        if (state === 'ACTIVE' && !needs.length) return;
        setWants('login');
        if (taminDirect && ![
            'OTP_REQUIRED',
            'CAPTCHA_REQUIRED'
        ].includes(state)) openTaminByItself();
    }, [
        panel,
        preview,
        busy
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Logged in: nothing left for the login to do, and nothing to say it failed.
    (0, $acw62.useEffect)(()=>{
        if (session?.state !== 'ACTIVE') return;
        setLoginCancelled(false);
        if (wants === 'login' && !needs.length) setWants(null);
    }, [
        session?.state,
        wants,
        needs.length
    ]);
    // «ورود به بیمه» on the panel: the window — or, for تأمین, its page, opened by
    // this press. A send the doctor already pressed stays what the login is for.
    const onPanelLogin = ()=>{
        setLoginCancelled(false);
        setLoginError(null);
        setChallengeError(null);
        setWants((w)=>w === 'send' || w === 'correct' ? w : 'login');
        if (!taminDirect) return;
        guard('login', async ()=>{
            const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
            const s = await startLogin({}, tab);
            if (s?.state === 'ACTIVE') await proceed();
        });
    };
    // «انصراف» in the window: no login, and the panel says what that means. A
    // challenge left half-answered is dropped here; the next login starts anew.
    const onLoginCancel = ()=>{
        setWants(null);
        setLoginCancelled(true);
        setLoginError(null);
        setChallengeError(null);
        if ($1ccba15c4d511e83$var$CHALLENGE.includes(session?.state) || session?.state === 'RATE_LIMITED') setSession((s)=>({
                ...s || {},
                state: 'NONE'
            }));
    };
    const toggleLine = (key)=>setUnticked((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    const toggleGroup = (keys, tick)=>setUnticked((prev)=>{
            const next = new Set(prev);
            for (const key of keys)if (tick) next.delete(key);
            else next.add(key);
            return next;
        });
    // ── render ──────────────────────────────────────────────────────────────
    if (loadError === 'absent') return null;
    if (loadError === 'failed') {
        // Still silence for a doctor the feature is not offered to: a read that
        // failed after one that said so must not make them see it fail.
        if (preview && !preview.enabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            state: $1ccba15c4d511e83$var$DATA_STATE.LOAD_FAILED,
            bare: panel
        }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, t('visit.erx.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>load(insurerRef.current),
            disabled: busy === 'load',
            "data-testid": tid('reload')
        }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('common.actions.retry'))));
    }
    if (!preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        state: $1ccba15c4d511e83$var$DATA_STATE.LOADING,
        bare: panel
    }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        width: "60%"
    }), panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 4
    }));
    if (!preview.enabled) return null;
    const name = insurerName(insurer);
    const subtitle = insurer ? t('visit.erx.subtitle', {
        insurer: name
    }) : t('visit.erx.subtitleNoInsurer');
    const draftBadge = preview.draftOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "outline"
    }, t('visit.erx.draftBadge')) : null;
    // The sending service itself is unusable — nothing the doctor can do here.
    if (preview.serviceIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        state: $1ccba15c4d511e83$var$DATA_STATE.UNAVAILABLE,
        bare: panel
    }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
        subtitle: subtitle,
        badges: draftBadge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: preview.serviceIssue === 'SERVICE_NOT_CONFIGURED' ? 'neutral' : 'error',
        style: {
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, msgText(preview.serviceIssue, preview.serviceMessage)))), preview.serviceIssue !== 'SERVICE_NOT_CONFIGURED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "mt-2.5",
        onClick: ()=>load(insurer),
        disabled: busy === 'load',
        "data-testid": tid('reload')
    }, t('common.actions.retry')));
    const sub = submission || {
        state: 'NONE'
    };
    const sessionState = session?.state || 'NONE';
    // ── «اصلاح نسخه»: what the server says a correction can do (K1, 2026-10-04) ──
    // `correction` is null from a BFF that predates corrections: the card is then
    // exactly what it was, «cannot be changed from Parsina yet» note and all.
    const correction = preview.correction || null;
    const correctionParts = correction?.parts || [];
    const changesSince = (preview.lines || []).some((l)=>$1ccba15c4d511e83$var$SINCE_REGISTRATION.has(l.reasonCode));
    const changesPending = !!correction && ((correction.pendingCount || 0) > 0 || changesSince);
    const correctionReason = correction && !correction.available && $1ccba15c4d511e83$export$7a9c4ec4ae364c2.includes(correction.unavailableReason) ? correction.unavailableReason : null;
    // The login, when it stands between the doctor and a confirmed correction.
    const correctLoginShown = !!insurer && wants === 'correct' && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && (sessionState !== 'ACTIVE' || needs.length > 0);
    // تأمین's login started by «ارسال» itself: no form to show meanwhile — it
    // returns, with the error, only when that login did not reach تأمین.
    const connectingInOnePress = busy === 'login' && loginInOnePress;
    // The insurer's challenges and the login form — under whichever decision
    // (the send, or the correction) the doctor is completing.
    const sessionSteps = (loginVisible)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, sessionState === 'OTP_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ChallengeField, {
            kind: "otp",
            sentTo: session?.otpSentTo,
            onSubmit: onAnswer,
            busy: busy === 'answer',
            error: challengeError
        }), sessionState === 'CAPTCHA_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ChallengeField, {
            kind: "captcha",
            captchaImage: session?.captchaImage,
            onSubmit: onAnswer,
            busy: busy === 'answer',
            error: challengeError
        }), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('redirect-note'),
            "data-opened": redirectOpened ? 'true' : 'false'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t(redirectOpened ? 'visit.erx.redirect.opened' : 'visit.erx.redirect.waiting'))), challengeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, challengeError)), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem',
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: redirectOpened ? 'outline' : 'default',
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>window.open(session.redirectUrl, '_blank', 'noopener'),
            "data-testid": tid('redirect-open')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": "true"
        }), " ", t(redirectOpened ? 'visit.erx.redirect.reopen' : 'visit.erx.redirect.open')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>onAnswer({}),
            disabled: busy === 'answer',
            "data-testid": tid('redirect-done')
        }, t('visit.erx.redirect.done'))), sessionState === 'RATE_LIMITED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.rateLimited')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "mt-2",
            onClick: ()=>setSession({
                    state: 'NONE'
                })
        }, t('common.actions.retry'))), loginVisible && connectingInOnePress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('connecting'),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.connecting'))), loginVisible && !connectingInOnePress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LoginForm, {
            insurerName: name,
            needs: needs,
            onSubmit: onLogin,
            busy: busy === 'login',
            error: loginError,
            note: sessionState === 'EXPIRED' ? t('visit.erx.sessionRequired') : t('visit.erx.sendNeedsLogin', {
                insurer: name
            }),
            redirect: insurer === 'TAMIN'
        }));
    // The registered part's changes, and «ارسال اصلاحیه به بیمه» — or, when a
    // correction cannot go, why, in one line. `view` is the card it sits in:
    // 'registered', or 'send' when another part of the scope is still unsent.
    const correctionSection = (view)=>{
        if (!correction) return null;
        // The same amber band as the card's other «not yet at the insurer» notes.
        const holder = {
            marginTop: '0.625rem',
            padding: '0.5rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`
        };
        if (correction.available) {
            const here = wants === 'correct';
            const challengedHere = here && ($1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) || sessionState === 'RATE_LIMITED');
            const pendingElsewhere = correctionResult?.state === 'SENDING';
            const state = busy === 'correct' ? 'sending' : here && sessionState === 'OTP_REQUIRED' ? 'otp' : here && sessionState === 'CAPTCHA_REQUIRED' ? 'captcha' : here && sessionState === 'REDIRECT_REQUIRED' ? 'redirect' : correctLoginShown ? 'login' : correctionResult && !pendingElsewhere ? 'refused' : 'available';
            const locked = !!busy || view === 'send' && serverSending;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction'),
                "data-state": state,
                style: holder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.CT).ink2,
                    marginBottom: '0.25rem'
                }
            }, t('visit.erx.correction.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CorrectionDiff, {
                lines: preview.lines,
                parts: correctionParts,
                describeLine: describeLine
            }), correction.until && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction-until')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
                tone: "ink"
            }, t('visit.erx.correction.until', {
                date: formatDate(correction.until, 'medium')
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.correction.limited')), correctionResult && !pendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction-result'),
                "data-result": correctionResult.state,
                "data-code": correctionResult.messageCode || undefined,
                style: {
                    marginTop: '0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
                result: correctionResult,
                msgText: correctionMsgText
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.correction.stands'))), pendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), here && !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginTop: '0.5rem'
                }
            }, sessionSteps(correctLoginShown)), !correctLoginShown && !challengedHere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "default",
                size: "sm",
                onClick: ()=>setConfirmOpen(true),
                disabled: locked || !insurer || labDueChosen.current && !!$1ccba15c4d511e83$export$b4445206d11e7272(labDue),
                className: "gap-1.5 mt-2",
                "data-testid": tid('correct')
            }, busy === 'correct' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
                size: 13,
                color: "currentColor",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
                size: 13,
                "aria-hidden": "true"
            }), busy === 'correct' ? t('visit.erx.correction.sending') : t('visit.erx.correction.send')));
        }
        if (correctionReason && changesPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('correction'),
            "data-state": "unavailable",
            "data-reason": correctionReason,
            style: holder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, t(`visit.erx.correction.unavailable.${correctionReason}`)));
        return null;
    };
    // The one confirmation before a correction goes: it replaces what the insurer
    // holds, and the insurer allows only so many.
    const confirmDialog = correction?.available ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: confirmOpen,
        onOpenChange: (open)=>{
            if (!open) setConfirmOpen(false);
        },
        title: t('visit.erx.correction.confirmTitle', {
            insurer: name || t('visit.erx.insurerLabel')
        }),
        description: t('visit.erx.correction.confirmBody'),
        confirmLabel: t('visit.erx.correction.confirm'),
        onConfirm: onCorrect,
        confirmTestId: tid('correction-confirm'),
        cancelTestId: tid('correction-cancel'),
        "data-testid": tid('correction-dialog')
    }) : null;
    // ── registered: the doctor's proof — and, once it differs from the نسخه, the
    // correction ──
    if (sub.state === 'REGISTERED') {
        const registeredText = sub.lifecycle === 'incomplete' ? t('visit.erx.registeredDraft', {
            insurer: name
        }) : t('visit.erx.registered', {
            insurer: name
        });
        if (panel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            bare: true,
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PanelResult, {
            lines: preview.lines,
            unticked: sentUnticked,
            reasonText: reasonText,
            name: name,
            trackingCode: sub.trackingCode,
            fallback: registeredText,
            notes: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, sub.ditasStatus === 'queued' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.queued')), sub.lifecycle === 'incomplete' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), corrected && !correction?.available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('corrected')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, t('visit.erx.correction.done', {
            insurer: name
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, correctionSection('registered')), confirmDialog);
        // Registered during the visit and unchanged since: nothing left to decide.
        const settled = compactWhenSettled && !detailsOpen && busy !== 'correct' && !changesPending && !corrected && !correctionResult && wants !== 'correct';
        if (settled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED,
            compact: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite",
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 15,
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: '1 1 12rem',
                minWidth: 0,
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).goodInk
            }
        }, registeredText), sub.trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            "data-testid": tid('tracking'),
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block',
                userSelect: 'all'
            }
        }, sub.trackingCode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            onClick: ()=>setDetailsOpen(true),
            "data-testid": tid('details')
        }, t('visit.erx.chip.details'))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
            subtitle: subtitle,
            badges: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
                variant: "success"
            }, t('common.state.registered'))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, registeredText), sub.trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2,
                marginTop: '0.3125rem'
            }
        }, t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            "data-testid": tid('tracking'),
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block',
                userSelect: 'all'
            }
        }, sub.trackingCode)), sub.ditasStatus === 'queued' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.queued')), sub.lifecycle === 'incomplete' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), corrected && !correction?.available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('corrected')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, t('visit.erx.correction.done', {
            insurer: name
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Lines, {
            lines: preview.lines,
            reasonText: reasonText,
            registered: true,
            correctionAware: !!correction
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, correctionSection('registered')), confirmDialog);
    }
    // ── everything before a registration ──
    const blockers = preview.blockers || [];
    const hardBlocked = blockers.some((b)=>!$1ccba15c4d511e83$var$HANDLED_IN_CARD.has(b.code));
    const needsInsurer = !insurer;
    const offered = preview.offeredInsurers || [];
    // The insurer row: only for a patient whose record names no insurer this
    // deployment sends to. A known one is never offered as a choice (K1,
    // 2026-10-13) — the prescription goes to the patient's own insurer.
    const showPicker = !recordKnown && offered.length > 0;
    // Ready to press: nothing blocks — or all that does is what the login form asks
    // for, and «ارسال» is the way to that form.
    const canSend = preview.ready || blockers.length > 0 && blockers.every((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code));
    // Running on the server, not started here: shown as running, never as ready —
    // «ارسال» over it would start a second send of the same prescription.
    const sendingElsewhere = serverSending && busy !== 'send';
    const sending = busy === 'send' || sendingElsewhere;
    const locked = !!busy || sendingElsewhere;
    // The login appears once the doctor has asked to send and is not logged in —
    // or is, but their profile lacks what only the login form asks for.
    const loginShown = !!insurer && !hardBlocked && wants === 'send' && !sendingElsewhere && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && (sessionState !== 'ACTIVE' || needs.length > 0);
    const result = [
        'REJECTED',
        'NOT_ACCEPTED',
        'FAILED',
        'BLOCKED'
    ].includes(sub.state) ? sub : null;
    // The panel's login window: open while a login is wanted and the insurer asks
    // for one here — never for تأمین's own page, which the waiting note stands for.
    const modalStep = sessionState === 'OTP_REQUIRED' ? 'otp' : sessionState === 'CAPTCHA_REQUIRED' ? 'captcha' : sessionState === 'RATE_LIMITED' ? 'rateLimited' : 'login';
    const modalOpen = panel && !!wants && !sendingElsewhere && sessionState !== 'REDIRECT_REQUIRED' && (modalStep !== 'login' || (sessionState !== 'ACTIVE' || needs.length > 0) && !taminDirect);
    const dataState = busy === 'send' ? $1ccba15c4d511e83$var$DATA_STATE.SENDING : sessionState === 'OTP_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.OTP : sessionState === 'CAPTCHA_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.CAPTCHA : sessionState === 'REDIRECT_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.REDIRECT : (panel ? modalOpen : loginShown) ? $1ccba15c4d511e83$var$DATA_STATE.LOGIN : sendingElsewhere ? $1ccba15c4d511e83$var$DATA_STATE.SENDING : result?.state === 'FAILED' ? $1ccba15c4d511e83$var$DATA_STATE.FAILED : result ? $1ccba15c4d511e83$var$DATA_STATE.REJECTED : hardBlocked || needsInsurer ? $1ccba15c4d511e83$var$DATA_STATE.BLOCKED : $1ccba15c4d511e83$var$DATA_STATE.READY;
    const tone = result ? 'bad' : busy || sendingElsewhere || $1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) || loginShown ? 'busy' : 'idle';
    if (panel) {
        const lines = preview.lines || [];
        const selectedCount = lines.filter((l)=>$1ccba15c4d511e83$var$panelGoes(l, unticked)).length;
        const nidRecord = preview.patientNationalCode || '';
        // The patient's national code is asked only when the record holds no valid
        // one — or the doctor has started typing another.
        const nidAsked = !nidRecord || !$1ccba15c4d511e83$var$isValidNationalCode(nidRecord) || nidTouched.current;
        const signedOut = sessionState !== 'ACTIVE' && sessionState !== 'REDIRECT_REQUIRED';
        const sendDisabled = !canSend || !insurer || locked || selectedCount === 0 || hasLabs && !!$1ccba15c4d511e83$export$b4445206d11e7272(labDue) || nid.length > 0 && !$1ccba15c4d511e83$var$isValidNationalCode(nid) || eligibilityBlocks;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            bare: true,
            state: dataState
        }, modalOpen ? // Behind the login window: the panel's shape, nothing to read yet.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('waiting'),
            "aria-hidden": "true",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 5
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsuranceInfo, {
            name: insurer ? name : null,
            session: session,
            onLogout: onLogout,
            locked: locked
        }, sessionState === 'ACTIVE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EligibilityLine, {
            value: eligibility,
            insurerName: name
        }), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('redirect-note'),
            "data-opened": redirectOpened ? 'true' : 'false',
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, t(wants === 'send' ? redirectOpened ? 'visit.erx.redirect.opened' : 'visit.erx.redirect.waiting' : redirectOpened ? 'visit.erx.panel.taminOpened' : 'visit.erx.panel.taminWaiting')), challengeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, challengeError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: redirectOpened ? 'outline' : 'default',
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>{
                window.open(session.redirectUrl, '_blank', 'noopener');
                setRedirectOpened(true);
            },
            "data-testid": tid('redirect-open')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": "true"
        }), " ", t(redirectOpened ? 'visit.erx.redirect.reopen' : 'visit.erx.redirect.open')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>onAnswer({}),
            disabled: busy === 'answer',
            "data-testid": tid('redirect-done')
        }, busy === 'answer' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.erx.redirect.done')))), signedOut && busy === 'login' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('connecting'),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.connecting'))), signedOut && busy !== 'login' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('signin'),
            "data-cancelled": loginCancelled ? 'true' : 'false',
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '0.375rem',
                marginTop: '0.25rem'
            }
        }, (loginCancelled || !!insurer) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).ink
            }
        }, loginCancelled ? t('visit.erx.panel.cancelledTitle') : t('visit.erx.panel.notSignedIn', {
            insurer: name
        })), loginCancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.panel.cancelledBody')), loginError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, loginError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onPanelLogin,
            disabled: locked,
            "data-testid": tid('signin-button')
        }, t('visit.erx.panel.signIn')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), nidAsked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientNidField, {
            value: nid,
            onChange: onNidChange,
            record: nidRecord,
            save: saveNidOn,
            onSaveChange: setSaveNid,
            // Not during the re-read the tenth digit itself triggers (PM-0114).
            disabled: locked && busy !== 'load'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientDetailsField, {
            askGender: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.gender) || !!details.gender,
            askMobile: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.mobile) || !!details.mobile,
            value: details,
            onGender: onGenderChange,
            onMobile: onMobileChange,
            disabled: locked
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), blockers.some((b)=>b.code === 'SIAM_ID_MISSING') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SiamForm, {
            onSave: onSaveSiam,
            busy: busy === 'siam',
            error: siamError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Blockers, {
            blockers: blockers,
            blockerText: blockerText
        }), needs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('needs')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, blockers.filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>blockerText(b)).join(' '), ' ', t('visit.erx.askedAtLogin'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('result'),
            "data-result": result.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
            result: result,
            msgText: msgText
        })), sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('sending-elsewhere'),
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: onRecheck,
            disabled: busy === 'load',
            "data-testid": tid('recheck')
        }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.erx.recheck')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SelectableLines, {
            lines: lines,
            unticked: unticked,
            onToggle: toggleLine,
            onToggleGroup: toggleGroup,
            reasonText: reasonText,
            describeLine: describeLine,
            disabled: locked
        }), hasLabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LabDue, {
            value: labDue,
            onChange: setLabDue,
            disabled: locked
        }), preview.draftOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')), correctionSection('send'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('footer'),
            style: {
                position: 'sticky',
                bottom: 0,
                zIndex: 1,
                marginTop: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '0.75rem',
                padding: '0.75rem 0',
                background: (0, $jTCZr.CT).surface,
                borderTop: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('selected-count'),
            "data-count": selectedCount,
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, t('visit.erx.panel.selectedCount', {
            count: selectedCount
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            onClick: onSend,
            disabled: sendDisabled,
            className: "gap-1.5",
            "data-testid": tid('send')
        }, sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
            size: 14,
            "aria-hidden": "true"
        }), sending ? t('visit.erx.sending') : t('visit.erx.panel.send', {
            insurer: name || t('visit.erx.insurerLabel')
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxLoginDialog, {
            open: modalOpen,
            step: modalStep,
            insurer: insurer,
            insurerName: name,
            nameOf: insurerName,
            known: recordKnown,
            offered: offered,
            onPick: onPickInsurer,
            showSave: !preview.patientInsurer,
            save: saveInsurer,
            onSaveChange: setSaveInsurer,
            unsupportedRecord: preview.patientInsurer && !recordKnown ? insurerName(preview.patientInsurer) : null,
            needs: needs,
            otpSentTo: session?.otpSentTo,
            captchaImage: session?.captchaImage,
            busy: busy === 'login' || busy === 'answer',
            error: modalStep === 'login' ? loginError : challengeError,
            onLogin: onLogin,
            onAnswer: onAnswer,
            onCancel: onLoginCancel,
            onRetry: ()=>setSession({
                    state: 'NONE'
                })
        }), confirmDialog);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        tone: tone,
        state: dataState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
        subtitle: subtitle,
        badges: draftBadge
    }), showPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerField, {
        insurer: insurer,
        record: preview.patientInsurer || null,
        offered: offered,
        insurerName: insurerName,
        onPick: onPickInsurer,
        save: saveInsurer,
        onSaveChange: setSaveInsurer,
        disabled: locked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
        saved: insurerSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientNidField, {
        value: nid,
        onChange: onNidChange,
        record: preview.patientNationalCode || '',
        save: saveNidOn,
        onSaveChange: setSaveNid,
        // Not during the re-read the tenth digit itself triggers: disabling the
        // field the doctor is typing into drops its focus, and on a phone the
        // keyboard goes with it (PM-0114). A send still locks it.
        disabled: locked && busy !== 'load'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
        saved: nidSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientDetailsField, {
        askGender: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.gender) || !!details.gender,
        askMobile: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.mobile) || !!details.mobile,
        value: details,
        onGender: onGenderChange,
        onMobile: onMobileChange,
        disabled: locked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
        saved: detailsSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Lines, {
        lines: preview.lines,
        reasonText: reasonText,
        correctionAware: !!correction
    }), hasLabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LabDue, {
        value: labDue,
        onChange: setLabDue,
        disabled: locked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Blockers, {
        blockers: blockers,
        blockerText: blockerText
    }), needs.length > 0 && !loginShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('needs'),
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, blockers.filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>blockerText(b)).join(' '), ' ', t('visit.erx.askedAtLogin'))), blockers.some((b)=>b.code === 'SIAM_ID_MISSING') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SiamForm, {
        onSave: onSaveSiam,
        busy: busy === 'siam',
        error: siamError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite"
    }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('result'),
        "data-result": result.state,
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
        result: result,
        msgText: msgText
    })), wants !== 'correct' && sessionSteps(loginShown), !loginShown && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, sessionState === 'ACTIVE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, session?.expiresAt ? t('visit.erx.loggedInUntil', {
        insurer: name,
        time: formatTime(session.expiresAt)
    }) : t('visit.erx.loggedIn', {
        insurer: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onLogout,
        disabled: locked,
        "data-testid": tid('logout'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 0,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.625rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0hzSL.default), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.logout'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EligibilityLine, {
        value: eligibility,
        insurerName: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: onSend,
        disabled: !canSend || !insurer || locked || hasLabs && !!$1ccba15c4d511e83$export$b4445206d11e7272(labDue) || nid.length > 0 && !$1ccba15c4d511e83$var$isValidNationalCode(nid) || eligibilityBlocks,
        className: "gap-1.5",
        "data-testid": tid('send')
    }, sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13,
        "aria-hidden": "true"
    }), sending ? t('visit.erx.sending') : result ? t('visit.erx.sendAgain') : t('visit.erx.send', {
        insurer: name || t('visit.erx.insurerLabel')
    })), sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('sending-elsewhere'),
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem',
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: onRecheck,
        disabled: busy === 'load',
        "data-testid": tid('recheck')
    }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), t('visit.erx.recheck'))), preview.draftOnly && canSend && !sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')))), correctionSection('send'), confirmDialog);
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// «ثبت ویزیت در بیمه» on the end-of-visit receipt (K1, 2026-10-04): the visit
// ITSELF registered with the patient's insurer once it has ended, when the doctor
// turned it on in تنظیمات → «نسخه». The doctor BFF decides everything — whether
// the switch is on, the visit's RVU3 code, the insurer, whether it is already
// registered (registerVisitWithInsurer); this file only says how each answer
// reads on the receipt.
const $3ad824a6335eeb13$export$c3900a7eba896779 = `mutation RegisterVisitWithInsurer($appointmentId:ID!,$patientId:ID!){
  registerVisitWithInsurer(appointmentId:$appointmentId,patientId:$patientId){
    visitCode{ageBand electronic code name}
    insurerLabel
    submission{state trackingCode messageCode message retryable blockers{code message fixIn}}
  }
}`;
function $3ad824a6335eeb13$export$3b87c219506a389a(answer, { failed: failed = false } = {}) {
    if (failed) return {
        tone: 'bad',
        kind: 'unknown',
        retry: true
    };
    if (!answer) return {
        tone: 'running',
        kind: 'running',
        retry: false
    };
    const s = answer.submission || {};
    const base = {
        code: answer.visitCode?.code || null,
        insurer: answer.insurerLabel || null
    };
    switch(s.state){
        case 'NONE':
            return null;
        case 'REGISTERED':
            return {
                ...base,
                tone: 'good',
                kind: 'registered',
                tracking: s.trackingCode || null,
                retry: false
            };
        case 'SENDING':
            return {
                ...base,
                tone: 'running',
                kind: 'running',
                retry: false
            };
        case 'BLOCKED':
            return {
                ...base,
                tone: 'warn',
                kind: 'blocked',
                blocker: s.blockers?.[0] || null,
                message: s.message || null,
                retry: false
            };
        case 'SESSION_REQUIRED':
            return {
                ...base,
                tone: 'warn',
                kind: 'session',
                retry: true
            };
        case 'NOT_ACCEPTED':
        case 'REJECTED':
            return {
                ...base,
                tone: 'bad',
                kind: 'rejected',
                message: s.message || null,
                retry: false
            };
        default:
            return {
                ...base,
                tone: 'bad',
                kind: 'failed',
                message: s.message || null,
                retry: s.retryable !== false
            };
    }
}


// «ثبت ویزیت در بیمه» on the end-of-visit receipt (K1, 2026-10-04). Asked once
// when the receipt opens — the visit has ended and its writes have landed — and
// again only when the doctor presses «ثبت دوباره». The BFF answers NONE for a
// doctor who has not turned it on, and then this renders nothing at all; asking
// is idempotent, so a receipt opened twice never registers a visit twice.
const $f632729d4a10d2cf$var$INK = {
    good: ()=>(0, $jTCZr.CT).goodInk,
    warn: ()=>(0, $jTCZr.CT).warnInk,
    bad: ()=>(0, $jTCZr.C).red,
    running: ()=>(0, $jTCZr.C).textSecondary
};
function $f632729d4a10d2cf$export$2e2bcd8739ae039({ appointmentId: appointmentId, patientId: patientId }) {
    const { t: t, has: has } = (0, $LNQP4.default)();
    const [answer, setAnswer] = (0, $acw62.useState)(null);
    const [failed, setFailed] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const inFlight = (0, $acw62.useRef)(false);
    const alive = (0, $acw62.useRef)(true);
    const ask = (0, $acw62.useCallback)(async ()=>{
        if (inFlight.current) return;
        inFlight.current = true;
        setBusy(true);
        setFailed(false);
        setAnswer(null);
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $3ad824a6335eeb13$export$c3900a7eba896779), {
                appointmentId: appointmentId,
                patientId: patientId
            });
            if (!alive.current) return;
            if (d?.registerVisitWithInsurer) setAnswer(d.registerVisitWithInsurer);
            else setFailed(true);
        } catch (e) {
            if (!alive.current) return;
            // A BFF that predates the mutation: nobody can have turned the switch on
            // against it either (the «نسخه» panel reads the same schema), so there is
            // nothing to report — never «not known» on every visit of every doctor.
            if (e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') setAnswer({
                submission: {
                    state: 'NONE'
                }
            });
            else setFailed(true);
        } finally{
            inFlight.current = false;
            if (alive.current) setBusy(false);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        alive.current = true;
        ask();
        return ()=>{
            alive.current = false;
        };
    }, [
        ask
    ]);
    const view = (0, $3ad824a6335eeb13$export$3b87c219506a389a)(answer, {
        failed: failed
    });
    if (!view) return null;
    const blockerText = (b)=>has(`visit.erx.blocker.${b.code}`) ? t(`visit.erx.blocker.${b.code}`) : b.message;
    const vars = {
        insurer: view.insurer || t('visit.visitInsurance.theInsurer'),
        code: view.code || ''
    };
    let text;
    switch(view.kind){
        case 'running':
            text = t('visit.visitInsurance.running');
            break;
        case 'registered':
            text = t('visit.visitInsurance.registered', vars);
            break;
        case 'blocked':
            text = t('visit.visitInsurance.blocked', {
                reason: view.blocker ? blockerText(view.blocker) : view.message || ''
            });
            break;
        case 'session':
            text = t('visit.visitInsurance.session', vars);
            break;
        case 'rejected':
            text = t('visit.visitInsurance.rejected', {
                message: view.message || ''
            });
            break;
        case 'unknown':
            text = t('visit.visitInsurance.unknown');
            break;
        default:
            text = view.message ? t('visit.visitInsurance.failedWith', {
                message: view.message
            }) : t('visit.visitInsurance.failed');
    }
    const ink = $f632729d4a10d2cf$var$INK[view.tone]();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "visit-closure-visit-insurance",
        "data-state": view.kind,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            flexWrap: 'wrap',
            padding: '0.5rem 0.75rem',
            borderRadius: '0.625rem',
            border: `1px solid ${(0, $jTCZr.soft)(ink, 0.25)}`,
            background: (0, $jTCZr.soft)(ink, 0.06)
        }
    }, view.kind === 'running' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: ink,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: '12rem',
            fontSize: '0.8125rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.CT).ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: ink
        }
    }, t('visit.visitInsurance.title')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, text), view.kind === 'registered' && view.tracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, " \xb7 ", t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        "data-testid": "visit-closure-visit-insurance-tracking",
        style: {
            unicodeBidi: 'isolate',
            userSelect: 'all'
        }
    }, view.tracking))), view.retry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "outline",
        onClick: ask,
        disabled: busy,
        "data-testid": "visit-closure-visit-insurance-retry"
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: "currentColor",
        label: ""
    }), t('visit.visitInsurance.retry')));
}



var $e317r = parcelRequire("e317r");




var $9BgRG = parcelRequire("9BgRG");
const $78bf9afd2f70d001$var$SEEDED_RX_TEMPLATE_TITLE = "\u0646\u0633\u062E\u0647 \u067E\u0632\u0634\u06A9\u06CC";
// End-of-visit closure — the phone rendering of the desktop ClosureFlowWizard.
//
// SINGLE STEP, deliberately. The visit is already finalized in the backend
// before this opens (handleEndVisit), so this screen is a read-only review plus
// one final ثبت. There is no stepper, no discharge/outcome step, no consent
// gate and no انصراف: once پایان ویزیت is pressed the doctor cannot abort or
// leave the visit half-open. The phone used to run a four-step wizard
// (review → مرخصی → امضا → ثبت) whose outcome, follow-up and signature state
// was never sent anywhere — it was legacy UI the desktop had already dropped.
//
// The two real actions the desktop closure offers are both here: ثبت در تأمین
// اجتماعی (inline, because it is a decision about THIS visit) and چاپ نسخه,
// which renders the same Persian document via the shared printPrescription.
const $78bf9afd2f70d001$var$SOAP_LABEL = (t)=>({
        s: t('visit.soap.sLetter'),
        o: t('visit.soap.oLetter'),
        a: t('visit.soap.aLetter'),
        p: t('visit.soap.pLetter')
    });
const $78bf9afd2f70d001$var$ReviewCard = ({ Icon: Icon, title: title, sub: sub, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem 0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        color: (0, $jTCZr.C).textMuted,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, sub))), children);
const $78bf9afd2f70d001$var$Muted = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, children);
const $78bf9afd2f70d001$var$MobileVisitClosureFlow = ({ onClose: onClose, soap: soap, rxItems: rxItems, pendingTests: pendingTests, patient: patient, doctor: doctor, diagnosis: diagnosis, prescriptionTemplates: prescriptionTemplates = [], appointmentId: appointmentId, saveFailures: saveFailures = [] })=>{
    // The e-prescription card's login or send in flight — the one piece of unsaved
    // work here. As on the desktop receipt (VisitClosureDialog), every exit — ثبت
    // and the platform back — asks before abandoning it. The phone mounted the card
    // without `onBusyChange`, so either left mid-OTP or mid-send unasked (K1,
    // 2026-10-03).
    const [erxBusy, setErxBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [leaveConfirm, setLeaveConfirm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Both insurer cards are Iranian rails (host.jsx useIranianRails), as on desktop.
    const iranianRails = (0, $e317r.useIranianRails)();
    const guardedExit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((run)=>{
        if (erxBusy) {
            setLeaveConfirm(()=>run);
            return;
        }
        run();
    }, [
        erxBusy
    ]);
    const exit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>guardedExit(onClose), [
        guardedExit,
        onClose
    ]);
    // §C.3 rule 1 — the closure owns the screen, so back closes IT rather than
    // navigating the visit route out from under it. The receipt is safe to
    // re-enter: the encounter is already finalised when this opens, and every
    // action on it (چاپ, ثبت تأمین) is idempotent. A back refused at the leave
    // confirmation is re-claimed by the hook.
    (0, $9BgRG.default)(true, exit, {
        id: 'visit-closure'
    });
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    // The نسخه's dose and frequency are stored as the Persian closed-list values.
    // A Persian reader is shown them as written; anyone else reads them through
    // the labels the desktop receipt uses (ClosureRxCard) — without them an Arabic
    // receipt read «۱ قرص · هر ۸ ساعت».
    const rxLine = (r)=>(readsPersianData ? [
            r.dosage,
            r.frequency
        ] : [
            r.dosage && (0, $375f8776645d5aee$export$a6616cb9d478340f)(r.dosage, false, t),
            r.frequency && (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(r.frequency, t)
        ]).filter(Boolean).join(" \xb7 ");
    // doctorpreference seeds every doctor's first print template as «نسخه پزشکی».
    // The title is the doctor's own data and is never translated on the wire;
    // this is display only — the option's VALUE is the template id.
    const templateTitle = (tpl)=>!readsPersianData && tpl.title === $78bf9afd2f70d001$var$SEEDED_RX_TEMPLATE_TITLE ? t('visit.rx.seededTemplateTitle') : tpl.title;
    // What did not reach the record. The tick in the header is a claim about the
    // visit having been saved; when part of it was not, making that claim anyway
    // is how a doctor walks away from an unrecorded prescription.
    const partial = saveFailures.length > 0;
    // تشخیص shows what the doctor wrote — «A» of the SOAP note, else the diagnosis
    // field. There is no AI summary here any more; see Visit.web.jsx's CFStepReview.
    const dxText = (soap?.a || '').trim() || (diagnosis || '').trim();
    // The template picker is a plain select on the phone: the desktop's A5 preview
    // pane has no place on a 360px viewport, but the document it prints is the same.
    const [tplId, setTplId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(prescriptionTemplates[0]?.id || '');
    const template = prescriptionTemplates.find((x)=>x.id === tplId) || null;
    const handlePrint = ()=>(0, $375f8776645d5aee$export$e57f8733307287ae)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            zIndex: 60,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.CT).bg
        },
        "data-testid": "visit-closure"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0,
            padding: 'calc(0.75rem + env(safe-area-inset-top, 0px)) 0.875rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '1.875rem',
            height: '1.875rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
        }
    }, partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 16,
        strokeWidth: 2.4,
        color: "white",
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 16,
        strokeWidth: 2.6,
        color: "white",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'white',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, t('visit.header.endVisitNamed', {
        name: patient?.name || ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: 'rgba(255,255,255,0.6)',
            marginTop: '0.0625rem'
        }
    }, t(partial ? 'visit.end.partialSaveSubtitle' : 'visit.closure.subtitleSaved'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '1rem 0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, partial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "closure-partial-save",
        role: "alert",
        style: {
            padding: '0.75rem 0.8125rem',
            borderRadius: '0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.C).amber}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.375rem'
        }
    }, t('visit.end.partialSaveTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.85,
            marginBottom: '0.5rem'
        }
    }, t('visit.end.partialSaveBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.9
        }
    }, saveFailures.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i
        }, item)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.closure.review'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $chm1L.default),
        title: t('visit.dx.title'),
        sub: "ICD"
    }, dxText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            padding: '0.1875rem 0.625rem',
            borderRadius: '0.25rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.71875rem',
            fontWeight: 600
        }
    }, dxText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, "\u2014")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $aVx4q.default),
        title: t('visit.tabs.rx'),
        sub: t('visit.rx.count', {
            count: rxItems.length
        })
    }, rxItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.3125rem'
        }
    }, rxItems.slice(0, 3).map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary,
                borderInlineStart: `2px solid ${(0, $jTCZr.CT).accent}`,
                paddingInlineStart: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(r.drug)), (r.dosage || r.frequency) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.C).textMuted
            }
        }, " ", rxLine(r)))), rxItems.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.rx.more', {
        count: rxItems.length - 3
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.rx.none'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $4CVxl.default),
        title: t('visit.orders.requests'),
        sub: t('visit.orders.count', {
            count: pendingTests.length
        })
    }, pendingTests.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, pendingTests.slice(0, 3).map((test, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", test.name || test.testName || String(test))), pendingTests.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.orders.more', {
        count: pendingTests.length - 3
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.orders.noneRecordedShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $jhSl7.default),
        title: t('visit.end.partSoap'),
        sub: t('visit.closure.itemsCount', {
            count: [
                's',
                'o',
                'a',
                'p'
            ].filter((k)=>(soap?.[k] || '').trim()).length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, [
        's',
        'o',
        'a',
        'p'
    ].map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: k,
            style: {
                background: (0, $jTCZr.CT).surface2,
                borderRadius: '0.375rem',
                padding: '0.375rem 0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textMuted,
                letterSpacing: '0.08em',
                display: 'block'
            }
        }, k.toUpperCase(), " \xb7 ", $78bf9afd2f70d001$var$SOAP_LABEL(t)[k]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap'
            }
        }, soap[k] || "\u2014"))))), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f632729d4a10d2cf$export$2e2bcd8739ae039), {
        appointmentId: appointmentId,
        patientId: patient.id
    }), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccba15c4d511e83$export$2e2bcd8739ae039), {
        appointmentId: appointmentId,
        patientId: patient.id,
        onBusyChange: setErxBusy,
        compactWhenSettled: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            padding: '0.75rem 0.875rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card
        }
    }, rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, prescriptionTemplates.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: tplId,
        onChange: (e)=>setTplId(e.target.value),
        "aria-label": t('visit.rx.template'),
        "data-testid": "visit-closure-template",
        style: {
            width: '100%',
            minHeight: '2.75rem',
            padding: '0 0.6875rem',
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textPrimary,
            fontSize: '0.8125rem',
            fontFamily: 'inherit'
        }
    }, prescriptionTemplates.map((tpl)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: tpl.id,
            value: tpl.id
        }, templateTitle(tpl))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.systemFormat'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: handlePrint,
        "data-testid": "visit-closure-print",
        className: "w-full min-h-11 gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.print'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: exit,
        "data-testid": "visit-closure-done",
        className: "w-full min-h-11 gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.closure.backToReception'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: !!leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-closure-leave-ok",
        cancelTestId: "visit-closure-leave-cancel",
        "data-testid": "visit-closure-leave-confirm",
        onConfirm: ()=>{
            const run = leaveConfirm;
            setLeaveConfirm(null);
            run?.();
        }
    }));
};
var $78bf9afd2f70d001$export$2e2bcd8739ae039 = $78bf9afd2f70d001$var$MobileVisitClosureFlow;




var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $6OGKD = parcelRequire("6OGKD");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// «ارسال به بیمه» — the visit's one way into the e-prescription, and where it
// stands with the insurer, in the top bar on every tab (PM-0097).
//
// It used to be a button in the work-tab bar, on the نسخه and دستورات tabs only:
// a doctor writing the note could neither reach it nor see that a registered
// prescription had changed since. The chip is that button moved up and given
// the status to carry — erxCorrection.erxChipState decides what it says:
//
//   send        «ارسال به بیمه»            (+ «n ناقص» while lines are unfinished)
//   registered  «ارسال به بیمه · ثبت شد»   (a check, the good tone)
//   pending     «ارسال اصلاحیه (n)»        (the amber dot the old button had)
//
// The name of the control never changes — only what follows it — so the doctor
// finds the same button in every state. Open, it says how to close its panel.
// State is never colour alone: each has its own words and its own glyph.
const $6f243566eab73828$var$TONE = {
    idle: {
        border: (0, $jTCZr.CT).accent,
        background: (0, $jTCZr.CT).surface,
        color: (0, $jTCZr.CT).accentInk
    },
    muted: {
        border: (0, $jTCZr.C).border,
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).ink2
    },
    good: {
        border: (0, $jTCZr.CT).good,
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk
    },
    warn: {
        border: (0, $jTCZr.CT).warn,
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk
    },
    open: {
        border: (0, $jTCZr.CT).accent,
        background: (0, $jTCZr.CT).accent,
        color: (0, $jTCZr.CT).surface
    }
};
function $6f243566eab73828$export$7ae4019f15d7dc12(state) {
    const { t: t } = (0, $LNQP4.default)();
    const kind = state?.kind || 'send';
    const label = kind === 'pending' ? t('visit.erx.correction.button', {
        count: state.pending
    }) : t('visit.erx.inVisit.open');
    let sub = null;
    if (kind === 'registered') sub = state.part && state.part !== 'ALL' ? t(`visit.erx.chip.registered${state.part}`) : t('visit.erx.chip.registered');
    else if (kind === 'send' && state?.incomplete > 0) sub = t('visit.erx.chip.incomplete', {
        count: state.incomplete
    });
    return {
        kind: kind,
        label: label,
        sub: sub
    };
}
const $6f243566eab73828$var$Glyph = ({ kind: kind, size: size })=>kind === 'registered' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: size,
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: size,
        "aria-hidden": "true"
    });
const $6f243566eab73828$var$PendingDot = ({ testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": `${testid}-pending`,
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).warn,
            flexShrink: 0
        }
    });
function $6f243566eab73828$export$2e2bcd8739ae039({ state: state, open: open = false, onClick: onClick, testid: testid = 'visit-erx-open' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { kind: kind, label: label, sub: sub } = $6f243566eab73828$export$7ae4019f15d7dc12(state);
    const tone = $6f243566eab73828$var$TONE[open ? 'open' : state?.tone || 'idle'] || $6f243566eab73828$var$TONE.idle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        "aria-expanded": open,
        "data-testid": testid,
        "data-state": kind,
        "data-pending": state?.pending || undefined,
        title: t('visit.erx.inVisit.bothHint'),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexShrink: 0,
            padding: '5px 12px',
            borderRadius: 999,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            border: `1px solid ${tone.border}`,
            background: tone.background,
            color: tone.color
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$Glyph, {
        kind: open ? 'send' : kind,
        size: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, open ? t('visit.erx.inVisit.close') : label), !open && sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testid}-sub`,
        style: {
            fontWeight: 600
        }
    }, "\xb7 ", sub), kind === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$PendingDot, {
        testid: testid
    }));
}
function $6f243566eab73828$export$9103f952c2bc2d33({ state: state, onClick: onClick, testid: testid = 'visit-erx-open' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { kind: kind, label: label, sub: sub } = $6f243566eab73828$export$7ae4019f15d7dc12(state);
    const tone = $6f243566eab73828$var$TONE[state?.tone || 'idle'] || $6f243566eab73828$var$TONE.idle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onClick,
        "aria-haspopup": "dialog",
        "aria-label": sub ? `${label} \u{2014} ${sub}` : label,
        "data-testid": testid,
        "data-state": kind,
        "data-pending": state?.pending || undefined,
        className: "shrink-0 h-11 min-h-11 gap-1.5 px-3",
        style: {
            borderColor: tone.border,
            background: tone.background,
            color: tone.color
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$Glyph, {
        kind: kind,
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.erx.chip.short')), kind === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$PendingDot, {
        testid: testid
    }));
}



var $acw62 = parcelRequire("acw62");


function $5d2858db85b3973f$export$2eef96f829c6b514({ appointmentId: appointmentId, patientId: patientId, prepare: prepare, active: active = true }) {
    const [status, setStatus] = (0, $acw62.useState)(null);
    const seq = (0, $acw62.useRef)(0);
    const prepareRef = (0, $acw62.useRef)(prepare);
    prepareRef.current = prepare;
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!appointmentId || !patientId) return;
        const mine = ++seq.current;
        try {
            if (prepareRef.current) try {
                await prepareRef.current();
            } catch (e) {
                console.warn('[erx-status] could not settle the record first:', e?.message);
            }
            const d = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$e436a36803f66c6f), {
                appointmentId: appointmentId,
                patientId: patientId
            });
            if (mine === seq.current) setStatus(d?.ePrescriptionStatus || null);
        } catch  {
            if (mine === seq.current) setStatus(null);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active || !appointmentId || !patientId) {
            seq.current += 1; // an answer still on its way no longer applies
            setStatus(null);
            return;
        }
        reload();
    }, [
        active,
        appointmentId,
        patientId,
        reload
    ]);
    return {
        status: status,
        reload: reload
    };
}
var $5d2858db85b3973f$export$2e2bcd8739ae039 = $5d2858db85b3973f$export$2eef96f829c6b514;


// ─────────────────────────────────────────────────────────────────────────────
// «اصلاح نسخهٔ ثبت‌شده» — what the visit screen makes of `ePrescriptionStatus`
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md).
//
// The status says, for a visit, whether anything of it is registered with an
// insurer, and per line whether that line is at the insurer as it is now
// (REGISTERED), at the insurer in an older form (CHANGED), written after the
// registration (ADDED), or gone from the record while the insurer still holds it
// (REMOVED). The screen turns that into a chip per line and a count on the
// «ارسال … به بیمه» buttons. Those decisions live here, as plain functions, so
// the visit's نسخه, its دستورات and the past-visit sheet cannot answer them
// differently.
// ─────────────────────────────────────────────────────────────────────────────

var $4UJrq = parcelRequire("4UJrq");
const $2c5a3cdef49d8209$export$bc7c25e7495df5a4 = [
    'REGISTERED',
    'CHANGED',
    'ADDED',
    'REMOVED'
];
const $2c5a3cdef49d8209$export$e932fff06946488f = [
    'DRUGS',
    'SERVICES'
];
function $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status) {
    return status && status.enabled && status.registered ? status : null;
}
function $2c5a3cdef49d8209$export$f71c8410924ea136(status) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    return !!s && !s.final && !s.expired;
}
const $2c5a3cdef49d8209$var$partOf = (line)=>line?.part || (line?.orderId ? 'SERVICES' : 'DRUGS');
const $2c5a3cdef49d8209$var$partStatus = (status, part)=>(status?.parts || []).find((p)=>p?.part === part) || null;
function $2c5a3cdef49d8209$export$5977fd636411c9b9(status) {
    const none = {
        ALL: 0,
        DRUGS: 0,
        SERVICES: 0
    };
    if (!$2c5a3cdef49d8209$export$f71c8410924ea136(status)) return none;
    const part = (p)=>{
        const s = $2c5a3cdef49d8209$var$partStatus(status, p);
        return s?.registered ? Math.max(0, s.pendingCount || 0) : 0;
    };
    return {
        ALL: Math.max(0, status.pendingCount || 0),
        DRUGS: part('DRUGS'),
        SERVICES: part('SERVICES')
    };
}
function $2c5a3cdef49d8209$export$25dd885c960a3a43(status, { incomplete: incomplete = 0, empty: empty = false } = {}) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    if (!s) return {
        kind: 'send',
        tone: empty ? 'muted' : 'idle',
        pending: 0,
        part: null,
        incomplete: Math.max(0, incomplete || 0)
    };
    const pending = $2c5a3cdef49d8209$export$5977fd636411c9b9(status).ALL;
    const drugs = !!$2c5a3cdef49d8209$var$partStatus(s, 'DRUGS')?.registered;
    const services = !!$2c5a3cdef49d8209$var$partStatus(s, 'SERVICES')?.registered;
    const part = drugs && !services ? 'DRUGS' : services && !drugs ? 'SERVICES' : 'ALL';
    if (pending > 0) return {
        kind: 'pending',
        tone: 'warn',
        pending: pending,
        part: part,
        incomplete: 0
    };
    return {
        kind: 'registered',
        tone: 'good',
        pending: 0,
        part: part,
        incomplete: 0
    };
}
function $2c5a3cdef49d8209$export$7aaa1df6f77403de(status) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    if (!s) return null;
    const byMedication = new Map();
    const byOrder = new Map();
    for (const line of s.lines || []){
        if (!line || !$2c5a3cdef49d8209$export$bc7c25e7495df5a4.includes(line.state)) continue;
        if (line.medicationId != null && line.medicationId !== '') byMedication.set(String(line.medicationId), line);
        if (line.orderId != null && line.orderId !== '') byOrder.set(String(line.orderId), line);
    }
    const registered = Object.fromEntries($2c5a3cdef49d8209$export$e932fff06946488f.map((p)=>[
            p,
            !!$2c5a3cdef49d8209$var$partStatus(s, p)?.registered
        ]));
    return {
        status: s,
        lines: (s.lines || []).filter(Boolean),
        byMedication: byMedication,
        byOrder: byOrder,
        registered: registered
    };
}
function $2c5a3cdef49d8209$export$98676285bdb35e36(item, index) {
    if (!index || !item) return null;
    if (item.medicationId) return index.byMedication.get(String(item.medicationId)) || null;
    return index.registered.DRUGS ? {
        part: 'DRUGS',
        state: 'ADDED',
        name: ''
    } : null;
}
function $2c5a3cdef49d8209$export$be2f84bce07e3ba5(order, index) {
    if (!index || !order?.id) return null;
    return index.byOrder.get(String(order.id)) || null;
}
function $2c5a3cdef49d8209$export$4ddbdca59aee3c1a(index, part, presentIds = []) {
    if (!index) return [];
    const present = new Set([
        ...presentIds
    ].filter((id)=>id != null).map(String));
    return index.lines.filter((l)=>{
        if (l.state !== 'REMOVED' || $2c5a3cdef49d8209$var$partOf(l) !== part) return false;
        const id = part === 'SERVICES' ? l.orderId : l.medicationId;
        return !(id != null && present.has(String(id)));
    });
}
// ── The month a prescription can be corrected in ────────────────────────────
//
// op-naji allows a correction for one month after the visit. The BFF decides it
// (CORRECTION.md Rules §3, EXPIRED: later than `until`); the screen only needs it
// to offer «اصلاح نسخه» on a past visit, and reads it the same way — the visit's
// time plus one JALAALI month, in Iran, at the visit's own hour: the same day of
// the next month, or that month's last day when it is shorter (31 شهریور → 30 مهر).
const $2c5a3cdef49d8209$var$DAY_MS = 86400000;
const $2c5a3cdef49d8209$var$toMs = (d)=>d instanceof Date ? d.getTime() : new Date(d ?? NaN).getTime();
function $2c5a3cdef49d8209$export$c160d8a2cdbe6390(visitDate) {
    const ms = $2c5a3cdef49d8209$var$toMs(visitDate);
    if (!Number.isFinite(ms)) return null;
    const j = (0, $4UJrq.msToJalali)(ms + (0, $4UJrq.IRAN_OFFSET_MS));
    if (!j) return null;
    const index = j.y * 12 + (j.m - 1) + 1;
    const y = Math.floor(index / 12);
    const m = index - y * 12 + 1;
    return {
        y: y,
        m: m,
        d: Math.min(j.d, (0, $4UJrq.jDaysInMonth)(y, m))
    };
}
function $2c5a3cdef49d8209$export$66408e4557608948(visitDate) {
    const ms = $2c5a3cdef49d8209$var$toMs(visitDate);
    const last = $2c5a3cdef49d8209$export$c160d8a2cdbe6390(visitDate);
    if (!last) return null;
    const local = ms + (0, $4UJrq.IRAN_OFFSET_MS);
    const timeOfDay = (local % $2c5a3cdef49d8209$var$DAY_MS + $2c5a3cdef49d8209$var$DAY_MS) % $2c5a3cdef49d8209$var$DAY_MS;
    return new Date((0, $4UJrq.jalaliToMs)(last.y, last.m, last.d) + timeOfDay - (0, $4UJrq.IRAN_OFFSET_MS));
}
function $2c5a3cdef49d8209$export$e0cd0eea0dc73912(visitDate, now = Date.now()) {
    const deadline = $2c5a3cdef49d8209$export$66408e4557608948(visitDate);
    const nowMs = now instanceof Date ? now.getTime() : now;
    return !!deadline && Number.isFinite(nowMs) && nowMs <= deadline.getTime();
}



var $e317r = parcelRequire("e317r");

var $acw62 = parcelRequire("acw62");

var $a83Oj = parcelRequire("a83Oj");

// Subscribe to the doctor's realtime event stream (`/ws/events` on the BFF). Every
// scheduling change the desk makes off this screen — arrival, in-visit, reorder,
// complete/cancel — arrives here; the caller reacts by refetching. The payload only
// says *something changed*, so `onEvent` is a plain "refresh" trigger.
//
// Mirrors the transcription WS auth (token in query, refresh-if-expired) and adds
// what a long-lived socket needs the one-shot transcription socket doesn't:
// exponential-backoff reconnect and an immediate reconnect when the tab is refocused.
const $57c81437ed051aa9$var$RECONNECT_MIN_MS = 2000;
const $57c81437ed051aa9$var$RECONNECT_MAX_MS = 30000;
function $57c81437ed051aa9$export$30a0463a44a8ca67(onEvent) {
    const [connected, setConnected] = (0, $acw62.useState)(false);
    const onEventRef = (0, $acw62.useRef)(onEvent);
    onEventRef.current = onEvent;
    (0, $acw62.useEffect)(()=>{
        let stopped = false;
        let ws = null;
        let backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
        let reconnectTimer = null;
        const scheduleReconnect = ()=>{
            if (stopped) return;
            clearTimeout(reconnectTimer);
            const delay = backoff;
            backoff = Math.min(backoff * 2, $57c81437ed051aa9$var$RECONNECT_MAX_MS);
            reconnectTimer = setTimeout(connect, delay);
        };
        async function connect() {
            if (stopped) return;
            // Don't hold a socket open for a backgrounded tab — reconnect on refocus.
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            let token = (0, $a83Oj.getToken)();
            if (!token || (0, $a83Oj.isTokenExpired)(token)) {
                const ok = await (0, $a83Oj.refreshAccessToken)();
                if (!ok || stopped) {
                    if (!stopped) scheduleReconnect();
                    return;
                }
                token = (0, $a83Oj.getToken)();
            }
            if (!token) {
                scheduleReconnect();
                return;
            }
            try {
                ws = new WebSocket(`${(0, $eabde0fc143396e8$export$8742212cdac9d01)()}/ws/events?token=${encodeURIComponent(token)}`);
            } catch  {
                scheduleReconnect();
                return;
            }
            ws.onopen = ()=>{
                backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
                setConnected(true);
            };
            ws.onmessage = (e)=>{
                try {
                    const msg = JSON.parse(e.data);
                    if (msg?.type === 'connected') return; // handshake ack, not a change
                    onEventRef.current?.(msg);
                } catch  {}
            };
            ws.onclose = ()=>{
                setConnected(false);
                if (!stopped) scheduleReconnect();
            };
            ws.onerror = ()=>{
                try {
                    ws.close();
                } catch  {}
            };
        }
        const onVisibility = ()=>{
            if (document.visibilityState !== 'visible') return;
            // Back on the tab: if the socket died while hidden, reconnect now (not after
            // the current backoff), so پذیرش is fresh the instant it's looked at.
            if (!ws || ws.readyState > WebSocket.OPEN) {
                backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
                clearTimeout(reconnectTimer);
                connect();
            }
        };
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisibility);
        connect();
        return ()=>{
            stopped = true;
            clearTimeout(reconnectTimer);
            if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisibility);
            try {
                ws?.close();
            } catch  {}
            ws = null;
        };
    }, []);
    return {
        connected: connected
    };
}


function $3a32a09d8f6c45ba$export$2e2bcd8739ae039({ patientId: patientId, onChange: onChange }) {
    (0, $57c81437ed051aa9$export$30a0463a44a8ca67)((evt)=>{
        const type = String(evt?.type || '');
        if (!type.startsWith('clinical_file.')) return;
        if (patientId && evt.patient_id && String(evt.patient_id) !== String(patientId)) return;
        onChange?.();
    });
    return null;
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $k27hS = parcelRequire("k27hS");


// Single source for the desktop Patient record's GraphQL contract.
// (Edit/delete of the patient itself is intentionally absent — the doctor app
// never mutates core demographics from this screen.)
// ── Clinical data ─────────────────────────────────────────────────────────────
const $dec379065a898322$export$5fcaf1729c987f4d = `mutation CreateMedication($patientId:ID!,$input:MedicationInput!){createMedication(patientId:$patientId,input:$input){id}}`;
const $dec379065a898322$export$608c51c2a533f155 = `mutation DeleteMedication($id: ID!) { deleteMedication(id: $id) }`;
const $dec379065a898322$export$725e3ec3814f10de = `mutation DeleteObservation($id: ID!) { deleteObservation(id: $id) }`;
const $dec379065a898322$export$810f8877c7c31725 = `query QueryVitalTimeSeries($patientId:ID!,$codes:[String!]){queryVitalTimeSeries(patientId:$patientId,codes:$codes){code display unit points{timestamp value}}}`;
const $dec379065a898322$export$b57f2fa191d92b55 = `
  query AskDoctorQuestion($question: String!, $patientId: ID, $conversationHistory: [ChatTurnInput!]) {
    askDoctorQuestion(question: $question, patientId: $patientId, conversationHistory: $conversationHistory) {
      answer confidence followUpSuggestions referencedVisitIds
    }
  }
`;
const $dec379065a898322$export$c49184db1de2de24 = `
  query ListDoctorOrdersEnc($patientId: ID!, $appointmentId: ID) {
    listDoctorOrders(patientId: $patientId, appointmentId: $appointmentId) {
      id appointmentId patientId orderType name code urgency status notes createdAt performedDate
      reviewStatus lastResultAt reviewVerdict reviewNote reviewedAt reviewedResultAt
      resultFiles { id fileName fileType createdAt uploadedBy reportText }
    }
  }
`;
const $dec379065a898322$export$a62561eb8157d4fe = `
  mutation ReviewOrderResult($orderId: ID!, $verdict: ResultVerdict!, $note: String, $seenResultAt: String) {
    reviewOrderResult(orderId: $orderId, verdict: $verdict, note: $note, seenResultAt: $seenResultAt) {
      id status reviewStatus reviewVerdict reviewNote reviewedAt reviewedResultAt lastResultAt
    }
  }
`;
const $dec379065a898322$export$b621353cbd29d7b3 = `
  query PendingResultReviews($limit: Int) {
    pendingResultReviews(limit: $limit) {
      patientId patientName appointmentId submittedAt
      order { id name orderType code reviewStatus lastResultAt }
    }
  }
`;
const $dec379065a898322$export$25ba33c54a6be1ed = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate}}`;
const $dec379065a898322$export$718ae50ae5858c4c = `mutation UpdateDoctorOrder($orderId:ID!,$status:String,$notes:String){updateDoctorOrder(orderId:$orderId,status:$status,notes:$notes){id status}}`;
const $dec379065a898322$export$2d0ba8abb4a3a0eb = `query GetFileUrl($fileId: ID!) { clinicalFileUrl(fileId: $fileId) }`;
const $dec379065a898322$export$ef15c8f83a956e90 = `query StorageLabFiles($patientId: ID!) { storageLabFiles(patientId: $patientId) { id fileName fileType fileSize createdAt appointmentId } }`;
const $dec379065a898322$export$6b196bd9c5c0429b = `query StorageLabFileUrl($id: ID!) { storageLabFileUrl(id: $id) }`;
const $dec379065a898322$export$9ae3a22786248a30 = `mutation DeleteStorageLabFile($id: ID!) { deleteStorageLabFile(id: $id) }`;
const $dec379065a898322$export$2b5fa1bb7f71febd = `mutation DeleteLabFile($id: ID!) { deleteLabFile(id: $id) }`;
const $dec379065a898322$export$c97661997f8a2b63 = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate}}`;
const $dec379065a898322$export$34ea31500f2ab29c = `
  studyId studyUid modalities studyDate studyTime description bodyParts
  seriesCount instanceCount storedBytes lossySource transcoded identityCheck
  institutionName referringPhysician accessionNumber origin viewable rendered
  series { seriesId seriesUid number modality description instances frames lossy }
  documentObjects { sr encapsulatedPdf secondaryCapture }
  headerPatient { name birthDate sex }
`;
const $dec379065a898322$export$aa44142d485ff6ab = `
  id patientId doctorId appointmentId orderId fileName fileType fileUrl ocrContent createdAt
  uploadedBy clinicId kind fileSize documentDate description
  processingStatus processingError processedAt
  canEdit editScope canDelete extractable promotedAt
  resolvedOrder { id description orderType status }
  mediaClass originalSize
  optimization { profile outcome by originalBytes storedBytes }
  dicom { ${$dec379065a898322$export$34ea31500f2ab29c} }
`;
const $dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS = `
  drugText strength form dose frequency frequencyCode route duration quantity instructions
  sourceText confidence verified selectedDrugId
  candidates { drugId name genericName strength form score }
`;
const $dec379065a898322$var$EXTRACTION_RUN_FIELDS = `
  id fileId status mode documentType summaryText clinicalNotes
  abnormalFlags recommendedActions diagnoses costParseh errorCode createdAt detectedDocumentDate
  labResults {
    testName value unit referenceRange status
    sourceText confidence verified panel specimen flagOnDocument referenceRangeText flag
    row testKey region { page x y width height }
  }
  medications { name dosage frequency }
  report { fullText modality bodyRegion reportDate sections { key title text } }
  documentClass classConfidence handwriting legibility promptVersion classSource truncatedPages
  kindSuggestion patientNameOnDocument charged
  flags { code path message }
  prescription {
    prescriberName prescriberSpecialty medicalCouncilNo prescribedOn prescribedOnIso
    diagnosesText notes transcript
    items { ${$dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS} }
  }
  note {
    transcript diagnosesText medicationsText legibility
    lines { text confidence }
    sections { key title text }
  }
  record {
    recordType facility admissionDate dischargeDate followUp fullText
    sections { key title text }
    diagnoses { text icd10Hint sourceText verified }
    procedures { text date }
    medications { ${$dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS} }
  }
`;
const $dec379065a898322$export$81a8e54dcce2ae4a = `mutation UploadClinicalFile($input: UploadClinicalFileInput!) { uploadClinicalFile(input: $input) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$ab95be7703af4e9d = `mutation UpdateClinicalFile($fileId: ID!, $input: UpdateClinicalFileInput!) { updateClinicalFile(fileId: $fileId, input: $input) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$75adfe99f4855836 = `mutation DeleteClinicalFile($fileId: ID!) { deleteClinicalFile(fileId: $fileId) }`;
const $dec379065a898322$export$8e0c20a74feb40eb = `mutation ExtractClinicalFile($fileId: ID!, $mode: ClinicalExtractionMode, $classOverride: ClinicalDocumentClass) { extractClinicalFile(fileId: $fileId, mode: $mode, classOverride: $classOverride) { ${$dec379065a898322$var$EXTRACTION_RUN_FIELDS} } }`;
// The lab review's database half (docs/lab_results_ocr_wireframe_ai_agent.md): the unit,
// reference range and status of each OCR row for THIS patient, the test catalogue an
// unmatched row picks from, and the OCR confidence bands. Free — no model runs.
const $dec379065a898322$var$LAB_REFERENCE_FIELDS = 'testKey matched displayName unit low high criticalLow criticalHigh referenceText referenceAvailable missingReason basis interpretation critical status';
const $dec379065a898322$export$dfd091d72822b70 = `query LabReview($patientId: ID!, $items: [LabReferenceQueryInput!]!) { labReview(patientId: $patientId, items: $items) { items { ${$dec379065a898322$var$LAB_REFERENCE_FIELDS} } catalog { ${$dec379065a898322$var$LAB_REFERENCE_FIELDS} } policy { acceptConfidence reviewConfidence } patientSex patientAgeYears } }`;
const $dec379065a898322$export$929a9aed56e6870c = `mutation SavePrescriptionExtraction($input: SavePrescriptionExtractionInput!) { savePrescriptionExtraction(input: $input) { saved failed file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
const $dec379065a898322$export$56698d1fe562d38e = `mutation SaveMedicalRecordExtraction($input: SaveMedicalRecordExtractionInput!) { saveMedicalRecordExtraction(input: $input) { saved failed file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
// ── Upload limits, capabilities and DICOM (DICOM_COMPRESSION_LIMITS… §24.8) ──
const $dec379065a898322$var$UPLOAD_CEILINGS_FIELDS = 'ceilings { documentBytes dicomInstanceBytes dicomBatchBytes dicomStudyBytes }';
const $dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS = `
  sizeLimitEnabled maxFileBytes dicomEnabled ${$dec379065a898322$var$UPLOAD_CEILINGS_FIELDS}
  clinics { clinicId clinicName sizeLimitEnabled maxFileBytes locked sources { field source } }
`;
const $dec379065a898322$export$3dd1b73433915098 = `query UploadCapabilities { uploadCapabilities { dicom rendered optimizeMode maxInstanceBytes maxBatchBytes } }`;
const $dec379065a898322$export$4d54656f1bf91c28 = `query UploadPolicy($patientId: ID!, $clinicId: ID, $kind: ClinicalDocumentKind) { uploadPolicy(patientId: $patientId, clinicId: $clinicId, kind: $kind) { maxFileBytes sizeLimitEnabled sizeLimitLocked configuredMaxFileBytes allowedMime maxFilesPerUpload dicomEnabled maxDicomStudyBytes maxDicomStudyInstances ${$dec379065a898322$var$UPLOAD_CEILINGS_FIELDS} sources { field source } } }`;
const $dec379065a898322$export$76c7df4da1e249d1 = `query MyUploadSettings { myUploadSettings { ${$dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS} } }`;
const $dec379065a898322$export$15b6bccfe535d9ba = `mutation UpdateMyUploadSettings($input: UploadSettingsInput!, $mask: [String!]!) { updateMyUploadSettings(input: $input, mask: $mask) { ${$dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS} } }`;
const $dec379065a898322$export$5ba246e021e79195 = `query DicomStudyViewer($fileId: ID!) { dicomStudyViewer(fileId: $fileId) { studyUid rendered series { seriesId seriesUid number modality description lossy instances { instanceId sopUid number frames } } } }`;
const $dec379065a898322$export$f6a06f00c2ea9339 = `mutation ConfirmDicomPatientMatch($fileId: ID!) { confirmDicomPatientMatch(fileId: $fileId) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$edb578819a2e86f4 = `query ClinicalFileAnalyses($patientId: ID!) { patient(id: $patientId) { id clinicalFiles { id processingStatus analysis { ${$dec379065a898322$var$EXTRACTION_RUN_FIELDS} } } } }`;
const $dec379065a898322$export$12566aca247381aa = `mutation SaveClinicalReport($input: SaveClinicalReportInput!) { saveClinicalReport(input: $input) { noteSaved file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
const $dec379065a898322$export$1541403edf337a0 = `mutation SaveLabResultsForFile($input: SaveLabResultsInput!) { saveLabResults(input: $input) { success savedObservations savedConditions savedMedications error errorCode } }`;
const $dec379065a898322$export$a7d989aaa610e68c = `query ClinicalFileDownload($fileId: ID!) { clinicalFileDownload(fileId: $fileId) { fileName contentType data size } }`;
const $dec379065a898322$export$b25799d4be2e0e7b = `query ListResultOrders($patientId: ID!) { listDoctorOrders(patientId: $patientId) { id appointmentId orderType name status createdAt } }`;




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $beZBx = parcelRequire("beZBx");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $2XwcZ = parcelRequire("2XwcZ");
var $aGlWN = parcelRequire("aGlWN");
var $chm1L = parcelRequire("chm1L");
var $lpOUO = parcelRequire("lpOUO");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c17edf56d0b04896$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ],
    [
        "path",
        {
            d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3",
            key: "mhlwft"
        }
    ]
];
const $c17edf56d0b04896$export$2e2bcd8739ae039 = (0, $9QBug.default)("file-question-mark", $c17edf56d0b04896$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



var $acw62 = parcelRequire("acw62");



function $286ab8933969f880$export$2e2bcd8739ae039(file) {
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        url: null,
        type: ''
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!file?.id) return undefined;
        let cancelled = false;
        let objectUrl = null;
        setView({
            status: 'loading',
            url: null,
            type: ''
        });
        // Started inside a promise so a client that throws synchronously becomes the
        // error state instead of an exception that unmounts the whole overlay.
        const read = Promise.resolve().then(()=>file._source === 'storage' ? (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$6b196bd9c5c0429b), {
                id: file.id
            }).then((d)=>d?.storageLabFileUrl) : (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$2d0ba8abb4a3a0eb), {
                fileId: file.id
            }).then((d)=>d?.clinicalFileUrl));
        read.then((uri)=>{
            if (cancelled) return;
            const parts = (0, $2dcdf1c1963f00da$export$64f75967084abe8e)(uri);
            if (!parts) {
                setView({
                    status: 'error',
                    url: null,
                    type: ''
                });
                return;
            }
            // The row's own MIME when it has one; storage only infers a type from the name.
            const type = String(file.fileType || '').includes('/') ? file.fileType : parts.contentType;
            objectUrl = URL.createObjectURL((0, $2dcdf1c1963f00da$export$b3fb17ae4345ac8f)(parts.data, type));
            setView({
                status: 'ready',
                url: objectUrl,
                type: type
            });
        }).catch(()=>{
            if (!cancelled) setView({
                status: 'error',
                url: null,
                type: ''
            });
        });
        return ()=>{
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [
        file?.id,
        file?._source,
        file?.fileType,
        attempt
    ]);
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setAttempt((n)=>n + 1), []);
    return {
        ...view,
        retry: retry
    };
}


function $9a38d4c43e1d261e$export$2e2bcd8739ae039({ file: file, height: height = '26rem', testid: testid = 'file-viewer' }) {
    const { t: t } = (0, $LNQP4.default)();
    const view = (0, $286ab8933969f880$export$2e2bcd8739ae039)(file);
    const frame = {
        height: height,
        borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
        border: `1px solid ${(0, $jTCZr.CT).border}`,
        background: (0, $jTCZr.CT).surface2,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    if (view.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": `${testid}-loading`,
        style: frame
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: 0
    }));
    if (view.status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        "data-state": "error",
        style: {
            ...frame,
            height: 'auto',
            minHeight: '10rem',
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.files.unavailable'),
        onRetry: view.retry
    }));
    const isImage = view.type.startsWith('image/');
    const isPdf = view.type === 'application/pdf';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-state": "content",
        "data-type": view.type,
        style: frame
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: view.url,
        alt: file.fileName || '',
        style: {
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            display: 'block'
        }
    }), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: file.fileName || t('patient.files.file'),
        src: view.url,
        style: {
            width: '100%',
            height: '100%',
            border: 'none'
        }
    }), !isImage && !isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.75rem',
            padding: '1rem',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c17edf56d0b04896$export$2e2bcd8739ae039), {
        size: 32,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), t('patient.files.detail.noPreview')));
}




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $jM6yW = parcelRequire("jM6yW");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $gCvEY = parcelRequire("gCvEY");
var $iygI2 = parcelRequire("iygI2");

var $jTCZr = parcelRequire("jTCZr");

var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $k27hS = parcelRequire("k27hS");



var $acw62 = parcelRequire("acw62");



// OCR-safe image optimisation in the browser — the SAME rules storage applies.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.4 (binding), §6.
//
// Why the client does it at all: bandwidth, and the size guard. A 6 MB phone photo of
// a lab sheet reads just as well at 2800 px, and the doctor's per-file limit is judged
// on the STORED bytes of an image — so the overlay has to know what will be stored
// before it sends anything («۸٫۴ ← ۱٫۹ مگابایت»). The server trusts a client result
// only when its long side is within the profile cap (outcome `client`), and otherwise
// optimises again, so a wrong client can cost quality never correctness.
//
// Two rules the whole module is built around: colour is never removed, and a
// re-encode that makes the text less legible is thrown away (the Laplacian guard).
// A failure anywhere keeps the source bytes — an optimiser must never be the reason
// a document is not stored.
//
// The canvas work goes through `env` so the decisions can be tested without a real
// canvas (jsdom has none).
// «افزودن فایل» — what a selection actually CONTAINS, decided from its bytes.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §8.2, §23.3 A11, §24.12.
//
// The upload overlay accepts anything (`FileDropzone accept={null}`): files with
// any extension or none, a CD's folder, a ZIP. This module sorts it:
//
//   • documents — a PDF or a photo/scan (JPEG, PNG, WEBP, HEIC, GIF, BMP), by magic
//     bytes, never by the name or the browser's guessed MIME;
//   • DICOM instances — `DICM` at offset 128, their header read with `dicom-parser`
//     only up to the pixel data, grouped by StudyInstanceUID into study rows;
//   • everything else — counted, never silently dropped.
//
// A ZIP is streamed one entry at a time with fflate, under the §23 A11 limits.
// Inside a ZIP only DICOM is taken: a CD's viewer binaries, readme files and the
// odd JPEG screenshot of the viewer are counted as ignored.
//
// App-local, not kit: it reads files, and the kit never does.

var $61bLk = parcelRequire("61bLk");

var $cF21O = parcelRequire("cF21O");
// The UMD build is consumed as CommonJS by Parcel and jest alike; its API sits either
// on the namespace or on its `default`, depending on the interop in play.
const $b4cbe3bcc0ad1160$var$dicomParser = typeof $cF21O.parseDicom === 'function' ? $cF21O : $cF21O.default;
const $b4cbe3bcc0ad1160$var$MiB = 1048576;
const $b4cbe3bcc0ad1160$var$GiB = 1024 * $b4cbe3bcc0ad1160$var$MiB;
const $b4cbe3bcc0ad1160$export$44f404102543c3 = Object.freeze({
    maxEntries: 5000,
    maxUncompressedBytes: 2 * $b4cbe3bcc0ad1160$var$GiB,
    maxEntryBytes: 60 * $b4cbe3bcc0ad1160$var$MiB
});
const $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK = 1 * $b4cbe3bcc0ad1160$var$MiB;
const $b4cbe3bcc0ad1160$export$2d53d0a1222ec833 = '1.2.840.10008.1.3.10';
const $b4cbe3bcc0ad1160$export$90e6b981bc528c3a = Object.freeze([
    '1.2.840.10008.1.2.4.50',
    '1.2.840.10008.1.2.4.51',
    '1.2.840.10008.1.2.4.91',
    '1.2.840.10008.1.2.4.81',
    '1.2.840.10008.1.2.4.100',
    '1.2.840.10008.1.2.4.101',
    '1.2.840.10008.1.2.4.102',
    '1.2.840.10008.1.2.4.103',
    '1.2.840.10008.1.2.4.201'
]);
const $b4cbe3bcc0ad1160$export$ca410b253ced059c = Object.freeze([
    'pdf',
    'jpeg',
    'png',
    'webp',
    'heic',
    'gif',
    'bmp'
]);
const $b4cbe3bcc0ad1160$export$8d94abc20542bccb = Object.freeze({
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    heic: 'image/heic',
    gif: 'image/gif',
    bmp: 'image/bmp',
    dicom: 'application/dicom',
    zip: 'application/zip'
});
const $b4cbe3bcc0ad1160$var$HEIC_BRANDS = [
    'heic',
    'heix',
    'hevc',
    'hevx',
    'heim',
    'heis',
    'mif1',
    'msf1'
];
const $b4cbe3bcc0ad1160$var$ascii = (bytes, from, length)=>{
    let s = '';
    for(let i = from; i < from + length && i < bytes.length; i += 1)s += String.fromCharCode(bytes[i]);
    return s;
};
function $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(bytes) {
    const b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
    if (b.length >= 132 && $b4cbe3bcc0ad1160$var$ascii(b, 128, 4) === 'DICM') return 'dicom';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === '%PDF') return 'pdf';
    if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return 'jpeg';
    if (b[0] === 0x89 && $b4cbe3bcc0ad1160$var$ascii(b, 1, 3) === 'PNG') return 'png';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === 'RIFF' && $b4cbe3bcc0ad1160$var$ascii(b, 8, 4) === 'WEBP') return 'webp';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 4, 4) === 'ftyp' && $b4cbe3bcc0ad1160$var$HEIC_BRANDS.includes($b4cbe3bcc0ad1160$var$ascii(b, 8, 4))) return 'heic';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === 'GIF8') return 'gif';
    if (b[0] === 0x42 && b[1] === 0x4d) return 'bmp';
    if (b[0] === 0x50 && b[1] === 0x4b && (b[2] === 0x03 || b[2] === 0x05) && (b[3] === 0x04 || b[3] === 0x06)) return 'zip';
    return 'unknown';
}
function $b4cbe3bcc0ad1160$export$a069c676e7361cc6(bytes) {
    return $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(bytes) === 'webp' && $b4cbe3bcc0ad1160$var$ascii(bytes, 12, 4) === 'VP8L';
}
function $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob, start = 0, end) {
    const part = end == null && start === 0 ? blob : blob.slice(start, end);
    if (typeof part.arrayBuffer === 'function') return part.arrayBuffer().then((buf)=>new Uint8Array(buf));
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(new Uint8Array(reader.result));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsArrayBuffer(part);
    });
}
const $b4cbe3bcc0ad1160$export$54e431c725c56f5b = (path)=>String(path || '').split(/[\\/]/).pop();
const $b4cbe3bcc0ad1160$var$isHiddenPath = (path)=>String(path || '').split(/[\\/]/).some((seg)=>seg.startsWith('.') && seg !== '.' && seg !== '..');
const $b4cbe3bcc0ad1160$var$isMacResourcePath = (path)=>/(^|[\\/])__MACOSX([\\/]|$)/.test(String(path || ''));
const $b4cbe3bcc0ad1160$var$isDicomdirName = (path)=>$b4cbe3bcc0ad1160$export$54e431c725c56f5b(path).toUpperCase() === 'DICOMDIR';
function $b4cbe3bcc0ad1160$export$9e0323d9bfc03253(value) {
    const m = /^(\d{4})(\d{2})(\d{2})$/.exec(String(value || '').trim());
    if (!m) return '';
    const [, y, mo, d] = m;
    if (Number(mo) < 1 || Number(mo) > 12 || Number(d) < 1 || Number(d) > 31) return '';
    return `${y}-${mo}-${d}`;
}
const $b4cbe3bcc0ad1160$var$tag = (ds, t)=>{
    try {
        return (ds.string(t) || '').trim();
    } catch  {
        return '';
    }
};
function $b4cbe3bcc0ad1160$export$b185cf1351499cf1(bytes) {
    const ds = $b4cbe3bcc0ad1160$var$dicomParser.parseDicom(bytes, {
        untilTag: 'x7fe00010'
    });
    const frames = Number.parseInt($b4cbe3bcc0ad1160$var$tag(ds, 'x00280008'), 10);
    return {
        studyUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x0020000d'),
        seriesUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x0020000e'),
        sopUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x00080018') || $b4cbe3bcc0ad1160$var$tag(ds, 'x00020003'),
        sopClassUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x00020002') || $b4cbe3bcc0ad1160$var$tag(ds, 'x00080016'),
        modality: $b4cbe3bcc0ad1160$var$tag(ds, 'x00080060').toUpperCase(),
        studyDate: $b4cbe3bcc0ad1160$export$9e0323d9bfc03253($b4cbe3bcc0ad1160$var$tag(ds, 'x00080020')),
        studyDescription: $b4cbe3bcc0ad1160$var$tag(ds, 'x00081030'),
        seriesDescription: $b4cbe3bcc0ad1160$var$tag(ds, 'x0008103e'),
        seriesNumber: Number.parseInt($b4cbe3bcc0ad1160$var$tag(ds, 'x00200011'), 10) || null,
        bodyPart: $b4cbe3bcc0ad1160$var$tag(ds, 'x00180015').toUpperCase(),
        patientName: $b4cbe3bcc0ad1160$var$tag(ds, 'x00100010').replace(/\^+/g, ' ').replace(/\s+/g, ' ').trim(),
        patientBirthDate: $b4cbe3bcc0ad1160$export$9e0323d9bfc03253($b4cbe3bcc0ad1160$var$tag(ds, 'x00100030')),
        patientSex: $b4cbe3bcc0ad1160$var$tag(ds, 'x00100040').toUpperCase(),
        transferSyntax: $b4cbe3bcc0ad1160$var$tag(ds, 'x00020010'),
        numberOfFrames: Number.isFinite(frames) && frames > 0 ? frames : 1
    };
}
// Most headers fit in the first 64 KiB; a few carry large private tags. Read more
// only when the parser ran out of bytes.
const $b4cbe3bcc0ad1160$var$HEADER_READS = [
    65536,
    1048576
];
async function $b4cbe3bcc0ad1160$var$readDicomHeader(blob) {
    for (const size of $b4cbe3bcc0ad1160$var$HEADER_READS){
        if (size >= blob.size) break;
        // eslint-disable-next-line no-await-in-loop
        const bytes = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob, 0, size);
        try {
            return $b4cbe3bcc0ad1160$export$b185cf1351499cf1(bytes);
        } catch  {}
    }
    return $b4cbe3bcc0ad1160$export$b185cf1351499cf1(await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob));
}
const $b4cbe3bcc0ad1160$var$emptySkipped = ()=>({
        dicomdir: 0,
        hidden: 0,
        nestedZip: 0,
        nonDicomInZip: 0,
        entryTooLarge: 0,
        unreadable: 0,
        duplicate: 0,
        noStudyUid: 0
    });
async function $b4cbe3bcc0ad1160$export$782034fc1c54f156(zipFile, { onEntry: onEntry, skipped: skipped, signal: signal, limits: limits = $b4cbe3bcc0ad1160$export$44f404102543c3 } = {}) {
    const kept = [];
    let entries = 0;
    let total = 0;
    let failure = null;
    const unzip = new (0, $61bLk.Unzip)((entry)=>{
        if (failure) return;
        const path = entry.name;
        if (path.endsWith('/')) return; // a directory record
        entries += 1;
        if (entries > limits.maxEntries) {
            failure = 'entries';
            return;
        }
        if ($b4cbe3bcc0ad1160$var$isMacResourcePath(path) || $b4cbe3bcc0ad1160$var$isHiddenPath(path)) {
            skipped.hidden += 1;
            return;
        }
        if ($b4cbe3bcc0ad1160$var$isDicomdirName(path)) {
            skipped.dicomdir += 1;
            return;
        }
        if (/\.zip$/i.test(path)) {
            skipped.nestedZip += 1;
            return;
        }
        if (entry.originalSize != null && entry.originalSize > limits.maxEntryBytes) {
            skipped.entryTooLarge += 1;
            return;
        }
        const chunks = [];
        let size = 0;
        let dropped = false;
        entry.ondata = (err, data, final)=>{
            if (failure || dropped) return;
            if (err) {
                failure = 'unreadable';
                return;
            }
            size += data.length;
            total += data.length;
            if (total > limits.maxUncompressedBytes) {
                failure = 'bytes';
                return;
            }
            if (size > limits.maxEntryBytes) {
                dropped = true;
                skipped.entryTooLarge += 1;
                try {
                    entry.terminate();
                } catch  {}
                return;
            }
            chunks.push(data);
            if (final) kept.push(new File(chunks, $b4cbe3bcc0ad1160$export$54e431c725c56f5b(path), {
                type: ''
            }));
        };
        try {
            entry.start();
        } catch  {
            skipped.unreadable += 1; // a compression method fflate cannot read
        }
    });
    unzip.register((0, $61bLk.UnzipInflate));
    try {
        for(let offset = 0; offset < zipFile.size; offset += $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK){
            if (signal?.aborted) return {
                ok: false,
                reason: 'aborted'
            };
            // eslint-disable-next-line no-await-in-loop
            const chunk = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(zipFile, offset, Math.min(zipFile.size, offset + $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK));
            unzip.push(chunk, offset + $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK >= zipFile.size);
            if (failure) break;
            // Hand over what completed in this chunk, so memory holds one chunk's worth of
            // parsing at a time rather than the whole archive's list.
            while(kept.length)// eslint-disable-next-line no-await-in-loop
            await onEntry(kept.shift());
        }
        if (zipFile.size === 0) unzip.push(new Uint8Array(0), true);
    } catch  {
        failure = failure || 'unreadable';
    }
    if (failure) return {
        ok: false,
        reason: failure
    };
    while(kept.length)// eslint-disable-next-line no-await-in-loop
    await onEntry(kept.shift());
    return {
        ok: true
    };
}
const $b4cbe3bcc0ad1160$var$summariseSeries = (instances)=>{
    const bySeries = new Map();
    instances.forEach((it)=>{
        const key = it.seriesUid || '';
        if (!bySeries.has(key)) bySeries.set(key, {
            seriesUid: key,
            number: it.seriesNumber,
            modality: it.modality,
            description: it.seriesDescription,
            instances: 0,
            frames: 0
        });
        const s = bySeries.get(key);
        s.instances += 1;
        s.frames += it.numberOfFrames || 1;
    });
    return [
        ...bySeries.values()
    ].sort((a, b)=>(a.number ?? 0) - (b.number ?? 0));
};
function $b4cbe3bcc0ad1160$export$acb516cc3fcaa054(instances) {
    const byStudy = new Map();
    instances.forEach((it)=>{
        if (!byStudy.has(it.studyUid)) byStudy.set(it.studyUid, []);
        byStudy.get(it.studyUid).push(it);
    });
    return [
        ...byStudy.entries()
    ].map(([studyUid, list])=>{
        const first = list.find((x)=>x.studyDescription) || list[0];
        const withPatient = list.find((x)=>x.patientName || x.patientBirthDate || x.patientSex) || list[0];
        const series = $b4cbe3bcc0ad1160$var$summariseSeries(list);
        const unique = (values)=>[
                ...new Set(values.filter(Boolean))
            ];
        const transferSyntaxes = unique(list.map((x)=>x.transferSyntax));
        return {
            studyUid: studyUid,
            instances: list,
            bytes: list.reduce((n, x)=>n + (x.size || 0), 0),
            instanceCount: list.length,
            frameCount: list.reduce((n, x)=>n + (x.numberOfFrames || 1), 0),
            series: series,
            seriesCount: series.length,
            modalities: unique(list.map((x)=>x.modality)),
            bodyParts: unique(list.map((x)=>x.bodyPart)),
            description: first.studyDescription || '',
            studyDate: list.find((x)=>x.studyDate)?.studyDate || '',
            transferSyntaxes: transferSyntaxes,
            lossySource: transferSyntaxes.some((ts)=>$b4cbe3bcc0ad1160$export$90e6b981bc528c3a.includes(ts)),
            patient: {
                name: withPatient.patientName || '',
                birthDate: withPatient.patientBirthDate || '',
                sex: withPatient.patientSex || ''
            }
        };
    });
}
async function $b4cbe3bcc0ad1160$export$4f9320e1e3a0d4ba(files, { known: known = new Set(), signal: signal, limits: limits = $b4cbe3bcc0ad1160$export$44f404102543c3 } = {}) {
    const documents = [];
    const instances = [];
    const rejected = [];
    const skipped = $b4cbe3bcc0ad1160$var$emptySkipped();
    const seen = new Set(known);
    const takeDicom = async (file, { fromZip: fromZip })=>{
        let header;
        try {
            header = await $b4cbe3bcc0ad1160$var$readDicomHeader(file);
        } catch  {
            skipped.unreadable += 1;
            return;
        }
        if (header.sopClassUid === $b4cbe3bcc0ad1160$export$2d53d0a1222ec833) {
            skipped.dicomdir += 1;
            return;
        }
        if (!header.studyUid || !header.sopUid) {
            skipped.noStudyUid += 1;
            return;
        }
        if (seen.has(header.sopUid)) {
            skipped.duplicate += 1;
            return;
        }
        seen.add(header.sopUid);
        instances.push({
            ...header,
            file: file,
            name: file.name,
            size: file.size,
            fromZip: fromZip
        });
    };
    for (const file of files || []){
        if (signal?.aborted) break;
        const path = file.webkitRelativePath || file.name;
        if (file.webkitRelativePath && ($b4cbe3bcc0ad1160$var$isMacResourcePath(path) || $b4cbe3bcc0ad1160$var$isHiddenPath(path))) {
            skipped.hidden += 1;
            continue;
        }
        if ($b4cbe3bcc0ad1160$var$isDicomdirName(path)) {
            skipped.dicomdir += 1;
            continue;
        }
        // eslint-disable-next-line no-await-in-loop
        const head = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(file, 0, Math.min(file.size, 132));
        const type = $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(head);
        if (type === 'dicom') // eslint-disable-next-line no-await-in-loop
        await takeDicom(file, {
            fromZip: false
        });
        else if (type === 'zip') {
            // eslint-disable-next-line no-await-in-loop
            const result = await $b4cbe3bcc0ad1160$export$782034fc1c54f156(file, {
                skipped: skipped,
                signal: signal,
                limits: limits,
                onEntry: async (entry)=>{
                    const entryHead = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(entry, 0, Math.min(entry.size, 132));
                    const entryType = $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(entryHead);
                    if (entryType === 'dicom') await takeDicom(entry, {
                        fromZip: true
                    });
                    else if (entryType === 'zip') skipped.nestedZip += 1;
                    else skipped.nonDicomInZip += 1;
                }
            });
            if (!result.ok && result.reason !== 'aborted') rejected.push({
                file: file,
                reason: `archive_${result.reason}`
            });
        } else if ($b4cbe3bcc0ad1160$export$ca410b253ced059c.includes(type)) documents.push(file);
        else if (file.webkitRelativePath) // A CD folder is full of viewer binaries and readme files: counted, not refused.
        skipped.nonDicomInZip += 1;
        else rejected.push({
            file: file,
            reason: 'type'
        });
    }
    return {
        documents: documents,
        studies: $b4cbe3bcc0ad1160$export$acb516cc3fcaa054(instances),
        rejected: rejected,
        skipped: skipped
    };
}
const $b4cbe3bcc0ad1160$export$45d8c05978783c00 = (skipped)=>Object.values(skipped || {}).reduce((n, v)=>n + (Number(v) || 0), 0);
// ── Identity (§8.7) — never blocks, always said ───────────────────────────────
const $b4cbe3bcc0ad1160$var$ARABIC_TO_PERSIAN = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627",
    "\u0624": "\u0648"
}; // i18n-exempt: letter-variant normalisation table for name matching, not UI copy
function $b4cbe3bcc0ad1160$export$628e08be8fd033f7(name) {
    return String(name || '').replace(/[ً-ٰٟ]/g, '') // diacritics
    .replace(/[يىكةأإآؤ]/g, (ch)=>$b4cbe3bcc0ad1160$var$ARABIC_TO_PERSIAN[ch] || ch).replace(/‌/g, ' ').replace(/[\^,._\-]+/g, ' ').toLowerCase().split(/\s+/).filter((tok)=>tok.length > 1);
}
const $b4cbe3bcc0ad1160$var$scriptOf = (tokens)=>{
    const joined = tokens.join('');
    if (!joined) return 'none';
    if (/[؀-ۿ]/.test(joined)) return /[a-z]/.test(joined) ? 'mixed' : 'persian';
    return 'latin';
};
const $b4cbe3bcc0ad1160$var$sexOf = (value)=>{
    const v = String(value || '').trim().toLowerCase();
    if ([
        'm',
        'male',
        'man',
        "\u0645\u0631\u062F"
    ].includes(v)) return 'M'; // i18n-exempt: wire values of patient.gender
    if ([
        'f',
        'female',
        'woman',
        "\u0632\u0646"
    ].includes(v)) return 'F'; // i18n-exempt: wire values of patient.gender
    return '';
};
function $b4cbe3bcc0ad1160$export$3de73ed166baf608(header, patient) {
    const h = header || {};
    const p = patient || {};
    const facts = [];
    const hTokens = $b4cbe3bcc0ad1160$export$628e08be8fd033f7(h.name);
    const pTokens = $b4cbe3bcc0ad1160$export$628e08be8fd033f7(p.name);
    if (hTokens.length && pTokens.length && $b4cbe3bcc0ad1160$var$scriptOf(hTokens) === $b4cbe3bcc0ad1160$var$scriptOf(pTokens)) {
        const shared = hTokens.filter((tok)=>pTokens.includes(tok)).length;
        const ratio = shared / Math.min(hTokens.length, pTokens.length);
        facts.push(ratio >= 1 ? 'same' : ratio > 0 ? 'some' : 'differs');
    }
    const pBirth = String(p.birthDate || '').slice(0, 10);
    if (h.birthDate && /^\d{4}-\d{2}-\d{2}$/.test(pBirth)) facts.push(h.birthDate === pBirth ? 'same' : 'differs');
    const hs = $b4cbe3bcc0ad1160$var$sexOf(h.sex);
    const ps = $b4cbe3bcc0ad1160$var$sexOf(p.gender ?? p.sex);
    if (hs && ps) facts.push(hs === ps ? 'same' : 'differs');
    if (!facts.length) return 'unknown';
    if (facts.every((f)=>f === 'same')) return 'match';
    if (facts.some((f)=>f === 'differs') && !facts.some((f)=>f === 'same')) return 'mismatch';
    return 'partial';
}


const $c51f7f79bb474588$export$f3801eed144224d0 = 'ocr-safe-v1';
const $c51f7f79bb474588$var$MiB = 1048576;
const $c51f7f79bb474588$export$d206f45f4f829757 = 1.5 * $c51f7f79bb474588$var$MiB;
const $c51f7f79bb474588$export$278d586e51f9c9d0 = 0.10;
const $c51f7f79bb474588$export$30a9584fd9cfe3bf = 0.80;
const $c51f7f79bb474588$var$GUARD_SIDE = 1024;
const $c51f7f79bb474588$var$SCREENSHOT_SAMPLE = 256;
const $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS = 256;
const $c51f7f79bb474588$var$SCREENSHOT_FLAT_TILES = 0.60;
const $c51f7f79bb474588$var$SCREENSHOT_CAP = 4000;
const $c51f7f79bb474588$export$a9e660cb533368c2 = Object.freeze({
    text: {
        id: 'text',
        cap: 2800,
        floor: 1800,
        quality: 90
    },
    handwriting: {
        id: 'handwriting',
        cap: 3400,
        floor: 2400,
        quality: 92
    },
    photo: {
        id: 'photo',
        cap: 3000,
        floor: 2000,
        quality: 88
    },
    screenshot: {
        id: 'screenshot',
        cap: $c51f7f79bb474588$var$SCREENSHOT_CAP,
        floor: null,
        quality: null
    }
});
function $c51f7f79bb474588$export$b5390dc2a3033f19(kind) {
    const k = String(kind || '').toUpperCase();
    if (k === 'PRESCRIPTION') return $c51f7f79bb474588$export$a9e660cb533368c2.handwriting;
    if (k === 'IMAGING') return $c51f7f79bb474588$export$a9e660cb533368c2.photo;
    return $c51f7f79bb474588$export$a9e660cb533368c2.text;
}
function $c51f7f79bb474588$export$34ca597b217cfe3c(width, height, profile, { atFloor: atFloor = false } = {}) {
    const long = Math.max(width, height);
    if (!long) return {
        width: width,
        height: height
    };
    let targetLong = Math.min(long, profile.cap);
    if (atFloor && profile.floor) targetLong = Math.min(long, profile.floor);
    const scale = Math.min(1, targetLong / long);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $c51f7f79bb474588$export$d29e7856232087fe(gray, width, height) {
    if (width < 3 || height < 3) return 0;
    let sum = 0;
    let sumSq = 0;
    let n = 0;
    for(let y = 1; y < height - 1; y += 1){
        const row = y * width;
        for(let x = 1; x < width - 1; x += 1){
            const i = row + x;
            const v = gray[i - width] + gray[i + width] + gray[i - 1] + gray[i + 1] - 4 * gray[i];
            sum += v;
            sumSq += v * v;
            n += 1;
        }
    }
    const mean = sum / n;
    return sumSq / n - mean * mean;
}
function $c51f7f79bb474588$export$8ad175d0a4ef8db2(rgba, width, height) {
    const gray = new Float32Array(width * height);
    for(let i = 0, p = 0; i < gray.length; i += 1, p += 4)gray[i] = 0.299 * rgba[p] + 0.587 * rgba[p + 1] + 0.114 * rgba[p + 2];
    return gray;
}
function $c51f7f79bb474588$export$6a132d5382a1ff88(rgba, width, height) {
    const colours = new Set();
    for(let p = 0; p < rgba.length; p += 4){
        colours.add(rgba[p] << 16 | rgba[p + 1] << 8 | rgba[p + 2]);
        if (colours.size > $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS) break;
    }
    if (colours.size <= $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS) return true;
    let tiles = 0;
    let flat = 0;
    for(let ty = 0; ty + 16 <= height; ty += 16)for(let tx = 0; tx + 16 <= width; tx += 16){
        tiles += 1;
        const first = (ty * width + tx) * 4;
        let same = true;
        for(let y = ty; y < ty + 16 && same; y += 1)for(let x = tx; x < tx + 16; x += 1){
            const p = (y * width + x) * 4;
            if (rgba[p] !== rgba[first] || rgba[p + 1] !== rgba[first + 1] || rgba[p + 2] !== rgba[first + 2]) {
                same = false;
                break;
            }
        }
        if (same) flat += 1;
    }
    return tiles > 0 && flat / tiles >= $c51f7f79bb474588$var$SCREENSHOT_FLAT_TILES;
}
function $c51f7f79bb474588$export$f755ac40c153b09f(bytes) {
    const b = bytes;
    if (!(b[0] === 0xff && b[1] === 0xd8)) return 1;
    let off = 2;
    while(off + 4 < b.length){
        if (b[off] !== 0xff) return 1;
        const marker = b[off + 1];
        const len = b[off + 2] << 8 | b[off + 3];
        if (marker === 0xe1 && String.fromCharCode(b[off + 4], b[off + 5], b[off + 6], b[off + 7]) === 'Exif') {
            const tiff = off + 10;
            const little = b[tiff] === 0x49;
            const u16 = (o)=>little ? b[o] | b[o + 1] << 8 : b[o] << 8 | b[o + 1];
            const u32 = (o)=>(little ? b[o] | b[o + 1] << 8 | b[o + 2] << 16 | b[o + 3] << 24 : b[o] << 24 | b[o + 1] << 16 | b[o + 2] << 8 | b[o + 3]) >>> 0;
            const ifd = tiff + u32(tiff + 4);
            const count = u16(ifd);
            for(let i = 0; i < count; i += 1){
                const entry = ifd + 2 + i * 12;
                if (u16(entry) === 0x0112) return u16(entry + 8) || 1;
            }
            return 1;
        }
        if (marker === 0xda) return 1;
        off += 2 + len;
    }
    return 1;
}
function $c51f7f79bb474588$export$f8253e721f02caf2(bytes) {
    const b = bytes;
    if (!(b[0] === 0xff && b[1] === 0xd8)) return b;
    const out = [
        b.subarray(0, 2)
    ];
    let off = 2;
    while(off + 4 <= b.length){
        if (b[off] !== 0xff) return b;
        const marker = b[off + 1];
        if (marker === 0xda) {
            out.push(b.subarray(off));
            break;
        } // start of scan: the rest is image data
        const len = b[off + 2] << 8 | b[off + 3];
        const end = off + 2 + len;
        if (end > b.length) return b;
        const isApp = marker >= 0xe1 && marker <= 0xef;
        const isIcc = marker === 0xe2 && String.fromCharCode(...b.subarray(off + 4, off + 15)) === 'ICC_PROFILE';
        if (!(isApp && !isIcc || marker === 0xfe)) out.push(b.subarray(off, end));
        off = end;
    }
    const size = out.reduce((n, part)=>n + part.length, 0);
    const merged = new Uint8Array(size);
    let at = 0;
    out.forEach((part)=>{
        merged.set(part, at);
        at += part.length;
    });
    return merged;
}
const $c51f7f79bb474588$export$4bb03266d09e8616 = {
    canDecode: ()=>typeof createImageBitmap === 'function' && typeof document !== 'undefined',
    // `imageOrientation: 'from-image'` applies EXIF orientation to the pixels (§24.4 step 2).
    decode: (blob)=>createImageBitmap(blob, {
            imageOrientation: 'from-image'
        }),
    canvas: (width, height)=>{
        const c = document.createElement('canvas');
        c.width = width;
        c.height = height;
        return c;
    },
    encode: (canvas, type, quality)=>new Promise((resolve)=>canvas.toBlob(resolve, type, quality))
};
// Halve in steps, then finish at the exact size with high-quality smoothing (§24.4 step 5).
function $c51f7f79bb474588$var$resample(env, source, width, height) {
    let current = source;
    let cw = source.width;
    let ch = source.height;
    while(cw / 2 >= width && ch / 2 >= height){
        const nw = Math.round(cw / 2);
        const nh = Math.round(ch / 2);
        const step = env.canvas(nw, nh);
        const ctx = step.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(current, 0, 0, nw, nh);
        current = step;
        cw = nw;
        ch = nh;
    }
    const out = env.canvas(width, height);
    const ctx = out.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(current, 0, 0, width, height);
    return out;
}
function $c51f7f79bb474588$var$sharpnessOf(env, drawable) {
    const long = Math.max(drawable.width, drawable.height);
    const scale = Math.min(1, $c51f7f79bb474588$var$GUARD_SIDE / long);
    const w = Math.max(3, Math.round(drawable.width * scale));
    const h = Math.max(3, Math.round(drawable.height * scale));
    const c = env.canvas(w, h);
    const ctx = c.getContext('2d');
    ctx.drawImage(drawable, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    return $c51f7f79bb474588$export$d29e7856232087fe($c51f7f79bb474588$export$8ad175d0a4ef8db2(data, w, h), w, h);
}
function $c51f7f79bb474588$var$screenshotCandidate(env, bitmap, type, head) {
    if (!(type === 'png' || type === 'gif' || type === 'bmp' || type === 'webp' && (0, $b4cbe3bcc0ad1160$export$a069c676e7361cc6)(head))) return false;
    const c = env.canvas($c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    const ctx = c.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    const { data: data } = ctx.getImageData(0, 0, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    return $c51f7f79bb474588$export$6a132d5382a1ff88(data, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
}
const $c51f7f79bb474588$var$renamed = (name, ext)=>`${String(name || 'image').replace(/\.[a-z0-9]{2,5}$/i, '')}.${ext}`;
async function $c51f7f79bb474588$export$39f73a062db15148(file, { kind: kind, env: env = $c51f7f79bb474588$export$4bb03266d09e8616 } = {}) {
    const srcBytes = file?.size || 0;
    const base = {
        version: $c51f7f79bb474588$export$f3801eed144224d0,
        by: 'client',
        srcBytes: srcBytes,
        outBytes: srcBytes,
        srcPx: null,
        outPx: null,
        quality: null,
        sharpnessRatio: null
    };
    let head;
    try {
        head = await (0, $b4cbe3bcc0ad1160$export$8417eef9459ad88c)(file, 0, Math.min(srcBytes, 65536));
    } catch  {
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'passthrough'
            }
        };
    }
    const type = (0, $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a)(head);
    if (type === 'pdf' || ![
        'jpeg',
        'png',
        'webp',
        'heic',
        'gif',
        'bmp'
    ].includes(type)) return {
        file: file,
        measurement: {
            ...base,
            profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
            outcome: 'skipped'
        }
    };
    if (!env.canDecode()) {
        if (type === 'heic') return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            },
            refused: 'heic'
        };
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            }
        };
    }
    let bitmap;
    try {
        bitmap = await env.decode(file);
    } catch  {
        // An undecodable HEIC cannot be sent at all — the server does not accept HEIC.
        if (type === 'heic') return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            },
            refused: 'heic'
        };
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'passthrough'
            }
        };
    }
    try {
        const srcPx = [
            bitmap.width,
            bitmap.height
        ];
        const long = Math.max(bitmap.width, bitmap.height);
        const screenshot = type !== 'jpeg' && type !== 'heic' && $c51f7f79bb474588$var$screenshotCandidate(env, bitmap, type, head);
        const profile = screenshot ? $c51f7f79bb474588$export$a9e660cb533368c2.screenshot : $c51f7f79bb474588$export$b5390dc2a3033f19(kind);
        const measured = {
            ...base,
            profile: profile.id,
            srcPx: srcPx,
            outPx: srcPx
        };
        // Step 3 — small enough already. A JPEG still loses its metadata losslessly, but
        // only when it carries no rotation: stripping the EXIF of a rotated photo would
        // turn the page on its side, so that one is re-encoded upright instead.
        const orientation = type === 'jpeg' ? $c51f7f79bb474588$export$f755ac40c153b09f(head) : 1;
        if (type !== 'heic' && srcBytes <= $c51f7f79bb474588$export$d206f45f4f829757 && long <= profile.cap && orientation === 1) {
            if (type === 'jpeg') {
                const stripped = $c51f7f79bb474588$export$f8253e721f02caf2(await (0, $b4cbe3bcc0ad1160$export$8417eef9459ad88c)(file));
                if (stripped.length < srcBytes) {
                    const out = new File([
                        stripped
                    ], file.name, {
                        type: (0, $b4cbe3bcc0ad1160$export$8d94abc20542bccb).jpeg,
                        lastModified: file.lastModified
                    });
                    return {
                        file: out,
                        measurement: {
                            ...measured,
                            outcome: 'skipped',
                            outBytes: out.size
                        }
                    };
                }
            }
            return {
                file: file,
                measurement: {
                    ...measured,
                    outcome: 'skipped'
                }
            };
        }
        const encodeAt = async ({ atFloor: atFloor, quality: quality })=>{
            const size = $c51f7f79bb474588$export$34ca597b217cfe3c(bitmap.width, bitmap.height, profile, {
                atFloor: atFloor
            });
            const canvas = $c51f7f79bb474588$var$resample(env, bitmap, size.width, size.height);
            const blob = screenshot ? await env.encode(canvas, (0, $b4cbe3bcc0ad1160$export$8d94abc20542bccb).png) : await env.encode(canvas, (0, $b4cbe3bcc0ad1160$export$8d94abc20542bccb).jpeg, quality / 100);
            return {
                canvas: canvas,
                blob: blob,
                size: size
            };
        };
        const sourceSharpness = $c51f7f79bb474588$var$sharpnessOf(env, bitmap);
        const ratioOf = (canvas)=>sourceSharpness > 0 ? $c51f7f79bb474588$var$sharpnessOf(env, canvas) / sourceSharpness : 1;
        let attempt = await encodeAt({
            atFloor: false,
            quality: profile.quality
        });
        let ratio = ratioOf(attempt.canvas);
        let quality = profile.quality;
        if (!screenshot && ratio < $c51f7f79bb474588$export$30a9584fd9cfe3bf) {
            quality = Math.min(100, profile.quality + 4);
            attempt = await encodeAt({
                atFloor: true,
                quality: quality
            });
            ratio = ratioOf(attempt.canvas);
        }
        const rounded = Math.round(ratio * 1000) / 1000;
        if (!attempt.blob || !screenshot && ratio < $c51f7f79bb474588$export$30a9584fd9cfe3bf) {
            // A HEIC has no source bytes the server would take: the upright JPEG goes anyway.
            if (type !== 'heic' || !attempt.blob) return {
                file: file,
                measurement: {
                    ...measured,
                    outcome: 'gate_failed',
                    quality: quality,
                    sharpnessRatio: rounded
                }
            };
        }
        const outPx = [
            attempt.size.width,
            attempt.size.height
        ];
        const smaller = attempt.blob.size <= srcBytes * (1 - $c51f7f79bb474588$export$278d586e51f9c9d0);
        if (!smaller && type !== 'heic' && orientation === 1) return {
            file: file,
            measurement: {
                ...measured,
                outcome: 'passthrough',
                quality: quality,
                sharpnessRatio: rounded
            }
        };
        const ext = screenshot ? 'png' : 'jpg';
        const out = new File([
            attempt.blob
        ], $c51f7f79bb474588$var$renamed(file.name, ext), {
            type: screenshot ? (0, $b4cbe3bcc0ad1160$export$8d94abc20542bccb).png : (0, $b4cbe3bcc0ad1160$export$8d94abc20542bccb).jpeg,
            lastModified: file.lastModified
        });
        return {
            file: out,
            measurement: {
                ...measured,
                outcome: 'optimized',
                outBytes: out.size,
                outPx: outPx,
                quality: screenshot ? null : quality,
                sharpnessRatio: rounded
            }
        };
    } finally{
        try {
            bitmap.close?.();
        } catch  {}
    }
}
function $c51f7f79bb474588$export$4778fb58f6bdd5c4(measurement) {
    if (!measurement) return null;
    const [srcWidth, srcHeight] = measurement.srcPx || [];
    const [width, height] = measurement.outPx || [];
    return {
        profile: measurement.profile || null,
        srcBytes: measurement.srcBytes ?? null,
        srcWidth: srcWidth ?? null,
        srcHeight: srcHeight ?? null,
        width: width ?? null,
        height: height ?? null,
        quality: measurement.quality ?? null,
        sharpnessRatio: measurement.sharpnessRatio ?? null
    };
}
const $c51f7f79bb474588$export$3a09f495b2bef3af = (measurement)=>Boolean(measurement && measurement.outBytes < measurement.srcBytes);


// The doctor's document queue — docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3,
// with the OCR-safe optimiser of DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.4.
//
// One mutation PER FILE, SEQUENTIALLY: a batch of five photos in one request is five
// times the body limit, and a failure halfway would lose the four that worked. Each
// row carries its own phase in the kit's vocabulary (FILE_PHASES), so the dropzone
// draws exactly what the queue knows, and a failed row is retried on its own.
//
// A row is PREPARED when it is added, not when it is sent: the overlay needs the
// stored size before the doctor presses anything, because an image's limit is judged
// on what will be stored («۸٫۴ ← ۱٫۹ مگابایت»). A kind whose profile differs
// (a prescription reads at a larger size than a lab sheet) prepares it again.
//
// Nothing here runs AI or touches an order: an upload stores a document, and the
// extraction is a separate, priced press (design §6.5, D3).
let $60b54b640883ab96$var$sequence = 0;
function $60b54b640883ab96$export$a04d2650265678af({ patientId: patientId, optimize: optimize = (0, $c51f7f79bb474588$export$39f73a062db15148) }) {
    const [items, setItems] = (0, $acw62.useState)([]);
    const [sending, setSending] = (0, $acw62.useState)(false);
    const itemsRef = (0, $acw62.useRef)(items);
    itemsRef.current = items;
    const patch = (0, $acw62.useCallback)((id, change)=>{
        setItems((list)=>list.map((it)=>it.id === id ? {
                    ...it,
                    ...change
                } : it));
    }, []);
    const prepare = (0, $acw62.useCallback)(async (id, file, kind)=>{
        let prepared;
        try {
            prepared = await optimize(file, {
                kind: kind
            });
        } catch  {
            prepared = {
                file: file,
                measurement: null
            };
        }
        setItems((list)=>list.map((it)=>{
                // The row was removed, or its kind changed again while this ran.
                if (it.id !== id || it.kind !== kind) return it;
                return {
                    ...it,
                    prepared: prepared,
                    phase: prepared.refused ? 'failed' : 'queued',
                    error: prepared.refused ? {
                        code: 'HEIC'
                    } : null
                };
            }));
    }, [
        optimize
    ]);
    const add = (0, $acw62.useCallback)((files, kind)=>{
        if (!files?.length) return;
        const fresh = files.map((file)=>{
            $60b54b640883ab96$var$sequence += 1;
            return {
                id: `upload-${$60b54b640883ab96$var$sequence}`,
                file: file,
                name: file.name,
                size: file.size,
                kind: kind,
                phase: 'preparing',
                error: null,
                result: null,
                prepared: null
            };
        });
        setItems((list)=>[
                ...list,
                ...fresh
            ]);
        fresh.forEach((it)=>{
            prepare(it.id, it.file, kind);
        });
    }, [
        prepare
    ]);
    const remove = (0, $acw62.useCallback)((id)=>setItems((list)=>list.filter((it)=>it.id !== id)), []);
    const setKind = (0, $acw62.useCallback)((id, kind)=>{
        const current = itemsRef.current.find((it)=>it.id === id);
        if (!current || current.kind === kind) return;
        const reprofile = (0, $c51f7f79bb474588$export$b5390dc2a3033f19)(current.kind).id !== (0, $c51f7f79bb474588$export$b5390dc2a3033f19)(kind).id && Boolean(current.prepared?.measurement?.srcPx);
        patch(id, reprofile ? {
            kind: kind,
            phase: 'preparing',
            prepared: null
        } : {
            kind: kind
        });
        if (reprofile) prepare(id, current.file, kind);
    }, [
        patch,
        prepare
    ]);
    const reset = (0, $acw62.useCallback)(()=>setItems([]), []);
    /** Rows the overlay's limits refuse; a send counts them out instead of trying. */ const setBlocked = (0, $acw62.useCallback)((blockedIds)=>{
        setItems((list)=>{
            let changed = false;
            const next = list.map((it)=>{
                const blocked = blockedIds.has(it.id);
                if (Boolean(it.blocked) === blocked) return it;
                changed = true;
                return {
                    ...it,
                    blocked: blocked
                };
            });
            return changed ? next : list;
        });
    }, []);
    // Leaving the page mid-send would abandon a file the doctor believes is on its way.
    (0, $acw62.useEffect)(()=>{
        if (!sending) return undefined;
        const guard = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', guard);
        return ()=>window.removeEventListener('beforeunload', guard);
    }, [
        sending
    ]);
    const sendOne = (0, $acw62.useCallback)(async (item, shared)=>{
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            patch(item.id, {
                phase: 'failed',
                error: {
                    offline: true
                }
            });
            return null;
        }
        patch(item.id, {
            phase: 'sending',
            error: null
        });
        try {
            const upload = item.prepared?.file || item.file;
            const measurement = item.prepared?.measurement || null;
            const fileData = await (0, $2dcdf1c1963f00da$export$25df2e315be8e003)(upload);
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$81a8e54dcce2ae4a), {
                input: {
                    patientId: patientId,
                    fileName: upload.name || item.name,
                    contentType: (0, $2dcdf1c1963f00da$export$516ffdc000f2cdae)(upload),
                    fileData: fileData,
                    kind: item.kind,
                    appointmentId: shared.appointmentId || null,
                    orderId: shared.orderId || null,
                    documentDate: shared.documentDate || null,
                    description: shared.description?.trim() ? shared.description.trim() : null,
                    // Only a decoded image was measured; a PDF travels without a measurement.
                    optimization: measurement?.srcPx ? (0, $c51f7f79bb474588$export$4778fb58f6bdd5c4)(measurement) : null
                }
            });
            const result = d?.uploadClinicalFile || null;
            patch(item.id, {
                phase: 'done',
                result: result
            });
            return result;
        } catch (error) {
            patch(item.id, {
                phase: 'failed',
                error: error
            });
            return null;
        }
    }, [
        patch,
        patientId
    ]);
    /**
   * Send every row that is not done yet (or only `onlyId`). Resolves with the rows
   * that are stored — including ones stored by an earlier pass — and how many failed.
   * A refused or limit-blocked row counts as failed without a request.
   */ const send = (0, $acw62.useCallback)(async (shared, onlyId)=>{
        setSending(true);
        const stored = [];
        let failed = 0;
        try {
            for (const item of itemsRef.current){
                if (item.phase === 'done') {
                    if (item.result) stored.push(item.result);
                    continue;
                }
                if (onlyId && item.id !== onlyId) continue;
                if (item.prepared?.refused || item.blocked || item.phase === 'preparing') {
                    failed += 1;
                    continue;
                }
                // eslint-disable-next-line no-await-in-loop
                const result = await sendOne(item, shared);
                if (result) stored.push(result);
                else failed += 1;
            }
        } finally{
            setSending(false);
        }
        return {
            stored: stored,
            failed: failed
        };
    }, [
        sendOne
    ]);
    const preparing = items.some((it)=>it.phase === 'preparing');
    return {
        items: items,
        sending: sending,
        preparing: preparing,
        add: add,
        remove: remove,
        setKind: setKind,
        reset: reset,
        send: send,
        setBlocked: setBlocked
    };
}
var $60b54b640883ab96$export$2e2bcd8739ae039 = $60b54b640883ab96$export$a04d2650265678af;



var $acw62 = parcelRequire("acw62");

// The doctor's DICOM queue — one row per study, one upload session per study.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §8.3, §10.1, §24.10.
//
//   open session → skip what the server already holds (`present`) → pack whole
//   instances into batches ≤ maxBatchBytes → send each with progress, retrying a
//   batch up to three times (waits 1 s, 4 s) → commit → the study's record row.
//
// One session per study, not one for the selection: a row then has exactly one
// outcome, a failed study is retried without touching the one that worked, and a
// commit can never flip a half-sent study visible.
//
// A committed session whose record step failed (DICOM_RECORD_PENDING) is retried at
// the COMMIT only — the bytes are already stored and commit is idempotent. An
// expired session starts again from open; instances already stored are skipped.
//
// Nothing here runs AI (§10.1 step 8).
const $225b8f2d08ed4546$var$MiB = 1048576;
const $225b8f2d08ed4546$var$DEFAULT_BATCH_BYTES = 16 * $225b8f2d08ed4546$var$MiB;
const $225b8f2d08ed4546$var$DEFAULT_INSTANCE_BYTES = 22 * $225b8f2d08ed4546$var$MiB;
const $225b8f2d08ed4546$export$46724b8ba8ac0660 = [
    1000,
    4000
];
const $225b8f2d08ed4546$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $225b8f2d08ed4546$export$3181a6d5c18d7823(instances, maxBatchBytes) {
    const batches = [];
    let current = [];
    let bytes = 0;
    instances.forEach((it)=>{
        const size = it.size || 0;
        if (size > maxBatchBytes) {
            if (current.length) {
                batches.push(current);
                current = [];
                bytes = 0;
            }
            batches.push([
                it
            ]);
            return;
        }
        if (bytes + size > maxBatchBytes && current.length) {
            batches.push(current);
            current = [];
            bytes = 0;
        }
        current.push(it);
        bytes += size;
    });
    if (current.length) batches.push(current);
    return batches;
}
const $225b8f2d08ed4546$var$rowFor = (study)=>({
        id: `study-${study.studyUid}`,
        ...study,
        documentDate: study.studyDate || '',
        phase: 'queued',
        progress: null,
        sentInstances: 0,
        presentCount: 0,
        rejectedCount: 0,
        tooLargeCount: 0,
        error: null,
        result: null,
        sessionId: null,
        uploaded: false
    });
function $225b8f2d08ed4546$export$9e757e81a22d1b0d({ patientId: patientId, clinicId: clinicId = null, api: api = $75472431f73f934f$exports, sleep: sleep = $225b8f2d08ed4546$var$wait } = {}) {
    const [studies, setStudies] = (0, $acw62.useState)([]);
    const [sending, setSending] = (0, $acw62.useState)(false);
    const studiesRef = (0, $acw62.useRef)(studies);
    studiesRef.current = studies;
    const controllerRef = (0, $acw62.useRef)(null);
    const activeSessionRef = (0, $acw62.useRef)(null);
    const patch = (0, $acw62.useCallback)((id, change)=>{
        setStudies((list)=>list.map((s)=>{
                if (s.id !== id) return s;
                const next = {
                    ...s,
                    ...typeof change === 'function' ? change(s) : change
                };
                studiesRef.current = studiesRef.current.map((x)=>x.id === id ? next : x);
                return next;
            }));
    }, []);
    /** Add intake study rows; a study already queued gains the instances it lacked. */ const addStudies = (0, $acw62.useCallback)((incoming)=>{
        if (!incoming?.length) return;
        setStudies((list)=>{
            const next = list.slice();
            incoming.forEach((study)=>{
                const at = next.findIndex((s)=>s.studyUid === study.studyUid);
                if (at === -1) {
                    next.push($225b8f2d08ed4546$var$rowFor(study));
                    return;
                }
                const existing = next[at];
                const known = new Set(existing.instances.map((i)=>i.sopUid));
                const fresh = study.instances.filter((i)=>!known.has(i.sopUid));
                if (!fresh.length) return;
                const instances = [
                    ...existing.instances,
                    ...fresh
                ];
                next[at] = {
                    ...existing,
                    instances: instances,
                    instanceCount: instances.length,
                    bytes: instances.reduce((n, i)=>n + (i.size || 0), 0),
                    frameCount: instances.reduce((n, i)=>n + (i.numberOfFrames || 1), 0),
                    phase: existing.phase === 'done' ? 'queued' : existing.phase,
                    uploaded: false
                };
            });
            studiesRef.current = next;
            return next;
        });
    }, []);
    const remove = (0, $acw62.useCallback)((id)=>setStudies((list)=>list.filter((s)=>s.id !== id)), []);
    const setDocumentDate = (0, $acw62.useCallback)((id, documentDate)=>patch(id, {
            documentDate: documentDate
        }), [
        patch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        studiesRef.current = [];
        setStudies([]);
    }, []);
    /** SOP UIDs already queued — the intake skips them when the same CD is dropped again. */ const knownSopUids = (0, $acw62.useMemo)(()=>new Set(studies.flatMap((s)=>s.instances.map((i)=>i.sopUid))), [
        studies
    ]);
    // Leaving the page mid-send would abandon a study the doctor believes is on its way.
    (0, $acw62.useEffect)(()=>{
        if (!sending) return undefined;
        const guard = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', guard);
        return ()=>window.removeEventListener('beforeunload', guard);
    }, [
        sending
    ]);
    const sendBatchWithRetry = (0, $acw62.useCallback)(async (sessionId, batch, { onProgress: onProgress, signal: signal })=>{
        for(let attempt = 0;; attempt += 1)try {
            // eslint-disable-next-line no-await-in-loop
            return await api.sendBatch(sessionId, batch, {
                onProgress: onProgress,
                signal: signal
            });
        } catch (err) {
            if (attempt >= $225b8f2d08ed4546$export$46724b8ba8ac0660.length || !api.isRetryable(err) || signal?.aborted) throw err;
            onProgress?.(0);
            // eslint-disable-next-line no-await-in-loop
            await sleep($225b8f2d08ed4546$export$46724b8ba8ac0660[attempt]);
        }
    }, [
        api,
        sleep
    ]);
    const sendStudy = (0, $acw62.useCallback)(async (row, shared, signal)=>{
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            patch(row.id, {
                phase: 'failed',
                error: {
                    code: 'OFFLINE'
                }
            });
            return null;
        }
        let sessionId = row.uploaded ? row.sessionId : null;
        try {
            if (!row.uploaded) {
                patch(row.id, {
                    phase: 'sending',
                    progress: 0,
                    error: null,
                    sentInstances: 0
                });
                const opened = await api.openSession({
                    patientId: patientId,
                    clinicId: clinicId || null,
                    appointmentId: shared.appointmentId || null,
                    orderId: shared.orderId || null,
                    studies: [
                        {
                            studyUid: row.studyUid,
                            bytes: row.bytes,
                            instances: row.instanceCount
                        }
                    ]
                }, {
                    signal: signal
                });
                sessionId = opened.sessionId;
                activeSessionRef.current = sessionId;
                const maxBatch = opened.maxBatchBytes || shared.maxBatchBytes || $225b8f2d08ed4546$var$DEFAULT_BATCH_BYTES;
                const maxInstance = opened.maxInstanceBytes || shared.maxInstanceBytes || $225b8f2d08ed4546$var$DEFAULT_INSTANCE_BYTES;
                const present = new Set((opened.present || []).filter((p)=>p.studyUid === row.studyUid).flatMap((p)=>p.sopUids || []));
                const tooLarge = row.instances.filter((i)=>(i.size || 0) > maxInstance);
                const toSend = row.instances.filter((i)=>!present.has(i.sopUid) && (i.size || 0) <= maxInstance);
                patch(row.id, {
                    sessionId: sessionId,
                    presentCount: present.size,
                    tooLargeCount: tooLarge.length
                });
                if (!toSend.length && !present.size) throw new $75472431f73f934f$exports.DicomSessionError(tooLarge.length ? 'DICOM_INSTANCE_TOO_LARGE' : 'DICOM_NO_FILES', '', 0, {
                    maxInstanceBytes: maxInstance
                });
                const totalBytes = toSend.reduce((n, i)=>n + (i.size || 0), 0) || 1;
                let sentBytes = 0;
                let sentInstances = 0;
                let rejected = 0;
                for (const batch of $225b8f2d08ed4546$export$3181a6d5c18d7823(toSend, maxBatch)){
                    const batchBytes = batch.reduce((n, i)=>n + (i.size || 0), 0);
                    // eslint-disable-next-line no-await-in-loop
                    const verdict = await sendBatchWithRetry(sessionId, batch, {
                        signal: signal,
                        onProgress: (loaded)=>patch(row.id, {
                                progress: Math.min(1, (sentBytes + Math.min(loaded, batchBytes)) / totalBytes)
                            })
                    });
                    sentBytes += batchBytes;
                    sentInstances += batch.length;
                    rejected += (verdict?.rejected || []).length;
                    patch(row.id, {
                        progress: Math.min(1, sentBytes / totalBytes),
                        sentInstances: sentInstances,
                        rejectedCount: rejected
                    });
                }
                patch(row.id, {
                    uploaded: true
                });
            }
            patch(row.id, {
                phase: 'committing',
                error: null
            });
            const committed = await api.commitSession(sessionId, {
                documentDate: row.documentDate || null,
                description: shared.description?.trim() ? shared.description.trim() : null,
                perStudy: [
                    {
                        studyUid: row.studyUid,
                        documentDate: row.documentDate || null
                    }
                ]
            }, {
                signal: signal
            });
            const file = (committed?.files || [])[0] || null;
            activeSessionRef.current = null;
            patch(row.id, {
                phase: 'done',
                progress: 1,
                result: file,
                uploaded: true
            });
            return file;
        } catch (error) {
            activeSessionRef.current = null;
            if (error?.code === 'ABORTED') {
                if (sessionId) api.abortSession(sessionId);
                patch(row.id, {
                    phase: 'queued',
                    progress: null,
                    error: null,
                    uploaded: false,
                    sessionId: null
                });
                return null;
            }
            const recordPending = error?.code === 'DICOM_RECORD_PENDING';
            // Bytes that never got as far as a commit are released now rather than left
            // pending for the sweeper; a record-pending session is kept for its retry.
            if (sessionId && !recordPending && !row.uploaded) api.abortSession(sessionId);
            patch(row.id, (s)=>({
                    phase: 'failed',
                    error: error,
                    uploaded: recordPending ? true : false,
                    sessionId: recordPending ? sessionId : null,
                    progress: recordPending ? 1 : s.progress
                }));
            return null;
        }
    }, [
        api,
        patientId,
        clinicId,
        patch,
        sendBatchWithRetry
    ]);
    /**
   * Send every study that is not done (or only `onlyId`). `shared` carries the visit,
   * request and description, plus capability ceilings as a fallback for the session's.
   * Resolves `{ stored: ClinicalFile[], failed }`.
   */ const send = (0, $acw62.useCallback)(async (shared = {}, onlyId)=>{
        const controller = new AbortController();
        controllerRef.current = controller;
        setSending(true);
        const stored = [];
        let failed = 0;
        try {
            for (const row of studiesRef.current){
                if (row.phase === 'done') {
                    if (row.result) stored.push(row.result);
                    continue;
                }
                if (onlyId && row.id !== onlyId) continue;
                if (row.blocked) {
                    failed += 1;
                    continue;
                }
                if (controller.signal.aborted) break;
                // eslint-disable-next-line no-await-in-loop
                const file = await sendStudy(studiesRef.current.find((s)=>s.id === row.id) || row, shared, controller.signal);
                if (file) stored.push(file);
                else if (!controller.signal.aborted) failed += 1;
            }
        } finally{
            controllerRef.current = null;
            setSending(false);
        }
        return {
            stored: stored,
            failed: failed,
            cancelled: controller.signal.aborted
        };
    }, [
        sendStudy
    ]);
    /** Stop the send in flight; its session is aborted and the row returns to the queue. */ const cancel = (0, $acw62.useCallback)(()=>{
        controllerRef.current?.abort();
    }, []);
    /** Mark rows the overlay's limits refuse, so a send counts them out instead of trying. */ const setBlocked = (0, $acw62.useCallback)((blockedIds)=>{
        setStudies((list)=>{
            let changed = false;
            const next = list.map((s)=>{
                const blocked = blockedIds.has(s.id);
                if (Boolean(s.blocked) === blocked) return s;
                changed = true;
                return {
                    ...s,
                    blocked: blocked
                };
            });
            if (!changed) return list;
            studiesRef.current = next;
            return next;
        });
    }, []);
    return {
        studies: studies,
        sending: sending,
        addStudies: addStudies,
        remove: remove,
        setDocumentDate: setDocumentDate,
        reset: reset,
        send: send,
        cancel: cancel,
        knownSopUids: knownSopUids,
        setBlocked: setBlocked
    };
}
var $225b8f2d08ed4546$export$2e2bcd8739ae039 = $225b8f2d08ed4546$export$9e757e81a22d1b0d;



var $acw62 = parcelRequire("acw62");


function $49bf42b1e5c69ef4$export$4225000df8440168({ open: open, patientId: patientId, clinicId: clinicId }) {
    const [capabilities, setCapabilities] = (0, $acw62.useState)(null);
    const [basePolicy, setBasePolicy] = (0, $acw62.useState)(null);
    const [byKind, setByKind] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const requested = (0, $acw62.useRef)(new Set());
    const readyRef = (0, $acw62.useRef)(Promise.resolve());
    (0, $acw62.useEffect)(()=>{
        if (!open || !patientId) return undefined;
        let cancelled = false;
        requested.current = new Set();
        setByKind({});
        setLoading(true);
        const caps = (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$3dd1b73433915098), {}).then((d)=>{
            if (!cancelled) setCapabilities(d?.uploadCapabilities || null);
            return d?.uploadCapabilities || null;
        }).catch(()=>{
            if (!cancelled) setCapabilities(null);
            return null;
        });
        const base = (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$4d54656f1bf91c28), {
            patientId: patientId,
            clinicId: clinicId || null,
            kind: null
        }).then((d)=>{
            if (!cancelled) setBasePolicy(d?.uploadPolicy || null);
            return d?.uploadPolicy || null;
        }).catch(()=>{
            if (!cancelled) setBasePolicy(null);
            return null;
        });
        readyRef.current = Promise.all([
            caps,
            base
        ]).then(([c, p])=>({
                capabilities: c,
                policy: p
            }));
        readyRef.current.finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        patientId,
        clinicId
    ]);
    /** Make sure a kind's policy is (being) read. */ const ensureKind = (0, $acw62.useCallback)((kind)=>{
        if (!kind || !patientId || requested.current.has(kind)) return;
        requested.current.add(kind);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$4d54656f1bf91c28), {
            patientId: patientId,
            clinicId: clinicId || null,
            kind: kind
        }).then((d)=>setByKind((m)=>({
                    ...m,
                    [kind]: d?.uploadPolicy || null
                }))).catch(()=>setByKind((m)=>({
                    ...m,
                    [kind]: null
                })));
    }, [
        patientId,
        clinicId
    ]);
    const policyFor = (0, $acw62.useCallback)((kind)=>kind && byKind[kind] !== undefined ? byKind[kind] || basePolicy : basePolicy, [
        byKind,
        basePolicy
    ]);
    /** Resolves once capabilities and the base policy have answered (or failed). */ const ready = (0, $acw62.useCallback)(()=>readyRef.current, []);
    return {
        capabilities: capabilities,
        basePolicy: basePolicy,
        policyFor: policyFor,
        ensureKind: ensureKind,
        loading: loading,
        ready: ready
    };
}
var $49bf42b1e5c69ef4$export$2e2bcd8739ae039 = $49bf42b1e5c69ef4$export$4225000df8440168;




var $e317r = parcelRequire("e317r");
// Which clinic the doctor is receiving at right now.
//
// A doctor can be a member of several clinics at once, and پذیرش used to render
// every one of their appointments in one undifferentiated day sheet — so a
// doctor who works Saturdays at one clinic and Sundays at another could not
// tell, from the screen, whose desk had booked the patient in front of them.
//
// This module owns the ANSWER, not the UI: one stored id, read and written from
// a single place, so the header chip, the day filter and the row tags can never
// disagree about where the doctor is.
//
// A leaf module with no React dependency, like `auth.js` — the value is read at
// module scope by whoever needs it, and the hook layers React state on top.
const $fdc4e943ddc88ca2$var$KEY = 'parsina_active_clinic_v1';
const $fdc4e943ddc88ca2$export$c5abb0256123e62d = 'ALL';
function $fdc4e943ddc88ca2$export$712e97de44ae5c43() {
    const fromHost = (0, $e317r.hostActiveClinicId)();
    if (fromHost != null) return fromHost;
    try {
        return localStorage.getItem($fdc4e943ddc88ca2$var$KEY) || '';
    } catch  {
        // A private window, or storage blocked entirely. Not an error worth telling
        // anyone about: the doctor simply starts each session unfiltered.
        return '';
    }
}
function $fdc4e943ddc88ca2$export$31ee8104798ff02e(id) {
    try {
        if (id) localStorage.setItem($fdc4e943ddc88ca2$var$KEY, id);
        else localStorage.removeItem($fdc4e943ddc88ca2$var$KEY);
    } catch  {
    // Ignore — the in-memory state still holds for this session.
    }
}







// «افزودن فایل» — the doctor adds documents AND imaging studies to the patient's record.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3, §8.4;
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §10.1, §11.1, §24.12.
//
// `TaskOverlay` (a framed Dialog on a workstation, a full-height sheet on a phone —
// DESIGN_CONCEPT §5.2) around the kit's `FileDropzone`. The zone accepts ANYTHING
// (`accept={null}`): files, a CD's folder (desktop), a ZIP. `lib/fileIntake` sorts the
// selection by its bytes into two groups —
//
//   «مدارک»          one row per PDF or photo, with its kind, optimised on arrival so
//                    the row can say what will be stored («۸٫۴ ← ۱٫۹ مگابایت»);
//   «مطالعات DICOM»  one row per study — modality, description, counts, its own date
//                    (from StudyDate), whether the file's patient looks like this one.
//
// Limits are the doctor's resolved policy: an image is judged on what will be STORED,
// a PDF on what is sent, a study on its bytes and instance count. DICOM is offered only
// where this environment ingests it and the policy allows it; otherwise a DICOM file
// is refused out loud, never dropped.
//
// Shared by the batch: the visit (pre-linked inside a visit), optionally one of its
// lab/imaging requests, a description, and — for documents — the document date.
//
// Two things this deliberately never does: run AI, and change an order. Storing a
// document is not an extraction (that is a separate, priced press — «بارگذاری و
// استخراج» is two explicit acts in one button, and the price is on it), and linking
// a result to a request does not complete the request (design §6.5).
const $f959cceb164f70c8$var$DEFAULT_KIND = 'LAB';
function $f959cceb164f70c8$export$b1b80d45b3914dd7(order, t) {
    const type = String(order?.orderType || '').toLowerCase();
    const typeLabel = type.includes('imag') || type.includes('radiolog') ? t('patient.orderType.imaging') : t('patient.orderType.lab');
    return t('patient.files.upload.orderOption', {
        type: typeLabel,
        name: order?.name || order?.description || t('patient.files.upload.orderUntitled')
    });
}
function $f959cceb164f70c8$export$6fb3676f9dc22f1b({ value: value, onChange: onChange, options: options, loading: loading, disabled: disabled, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!loading && !options.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.upload.linkOrder')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-none`,
        style: {
            minHeight: '2.75rem',
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.upload.noOrdersForVisit')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.linkOrder'),
        helperText: t('patient.files.upload.linkOrderHint'),
        value: value,
        onChange: (e)=>onChange(e.target.value),
        options: options,
        placeholder: loading ? t('common.state.loading') : t('patient.files.upload.noLink'),
        disabled: disabled || loading,
        "data-testid": testid
    });
}
/** Can this browser pick a folder? iOS Safari cannot (§10.6 E30). */ function $f959cceb164f70c8$var$supportsDirectoryPicker() {
    if (typeof document === 'undefined') return false;
    try {
        return 'webkitdirectory' in document.createElement('input');
    } catch  {
        return false;
    }
}
const $f959cceb164f70c8$var$isImageUpload = (item)=>Boolean(item.prepared?.measurement?.srcPx);
function $f959cceb164f70c8$export$2e2bcd8739ae039({ open: open, onClose: onClose, patientId: patientId, patient: patient, preset: preset = {}, visits: visits = [], orders: orders = [], ordersLoading: ordersLoading = false, onUploaded: onUploaded }) {
    const { t: t, has: has, formatDate: formatDate, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const { costOf: costOf } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const price = costOf('ANALYZE_FILE');
    const clinicId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (preset.clinicId) return preset.clinicId;
        const stored = (0, $fdc4e943ddc88ca2$export$712e97de44ae5c43)();
        return stored && stored !== (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d) ? stored : null;
    }, [
        preset.clinicId
    ]);
    const upload = (0, $60b54b640883ab96$export$a04d2650265678af)({
        patientId: patientId
    });
    const dicom = (0, $225b8f2d08ed4546$export$9e757e81a22d1b0d)({
        patientId: patientId,
        clinicId: clinicId
    });
    const limits = (0, $49bf42b1e5c69ef4$export$4225000df8440168)({
        open: open,
        patientId: patientId,
        clinicId: clinicId
    });
    const { reset: reset } = upload;
    const { reset: resetStudies } = dicom;
    const [documentDate, setDocumentDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [description, setDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [appointmentId, setAppointmentId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [orderId, setOrderId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [zoneError, setZoneError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [notice, setNotice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [skipped, setSkipped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [intaking, setIntaking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failedCount, setFailedCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        reset();
        resetStudies();
        setDocumentDate('');
        setDescription('');
        setAppointmentId(preset.appointmentId || '');
        setOrderId(preset.orderId || '');
        setZoneError('');
        setNotice('');
        setSkipped(0);
        setFailedCount(0);
        setConfirmDiscard(false);
    }, [
        open,
        reset,
        resetStudies,
        preset.appointmentId,
        preset.orderId
    ]);
    const items = upload.items;
    const studies = dicom.studies;
    const busy = upload.sending || dicom.sending;
    const allDone = items.length + studies.length > 0 && items.every((it)=>it.phase === 'done') && studies.every((s)=>s.phase === 'done');
    const dirty = !allDone && (items.length > 0 || studies.length > 0 || Boolean(description.trim()) || Boolean(documentDate));
    const caps = limits.capabilities;
    const base = limits.basePolicy;
    const dicomAllowed = Boolean(caps?.dicom && base?.dicomEnabled);
    const canPickFolder = !isMobile && $f959cceb164f70c8$var$supportsDirectoryPicker();
    const maxDocs = base?.maxFilesPerUpload || (0, $2dcdf1c1963f00da$export$7c6f6c38c781ae96);
    // A kind's own policy is read the first time a row of that kind exists.
    const kindsKey = [
        ...new Set(items.map((it)=>it.kind))
    ].join(',');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        kindsKey.split(',').filter(Boolean).forEach(limits.ensureKind);
    }, [
        kindsKey,
        limits.ensureKind
    ]);
    const kindOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $157d5bd48cfffbad$export$4f5645f323f84265).map((k)=>({
                value: k.value,
                label: t(k.labelKey)
            })), [
        t
    ]);
    const visitOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>visits.map((v)=>({
                value: v.id,
                label: v.scheduledDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(v.scheduledDate, formatDate) : t('patient.visit')
            })), [
        visits,
        formatDate,
        t
    ]);
    // A request belongs to exactly one visit, so the request picker exists only once a
    // visit is chosen, and lists that visit's lab and imaging requests — never a mixed
    // list of every visit's requests to pick from.
    const orderOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>appointmentId ? orders.filter((o)=>o.appointmentId === appointmentId).map((o)=>({
                value: o.id,
                label: $f959cceb164f70c8$export$b1b80d45b3914dd7(o, t)
            })) : [], [
        orders,
        appointmentId,
        t
    ]);
    const presetVisit = preset.appointmentId && appointmentId === preset.appointmentId ? visits.find((v)=>v.id === preset.appointmentId) : null;
    // ── Limits, per row (§24.3) ───────────────────────────────────────────────
    const documentLimitError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((it)=>{
        if (it.phase === 'preparing' || it.phase === 'done' || it.prepared?.refused) return null;
        const policy = limits.policyFor(it.kind);
        const image = $f959cceb164f70c8$var$isImageUpload(it);
        const bytes = image ? it.prepared?.file?.size ?? it.size : it.size;
        const physical = (0, $2dcdf1c1963f00da$export$f36c73f7356be416)(policy ? {
            ...policy,
            sizeLimitEnabled: false
        } : null);
        if (bytes > physical) return t('patient.files.upload.limitPlatform', {
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, physical)
        });
        const limit = (0, $2dcdf1c1963f00da$export$f36c73f7356be416)(policy);
        if (bytes > limit) return t(image ? 'patient.files.upload.limitFile' : 'patient.files.upload.limitFilePdf', {
            size: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, bytes),
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, limit)
        });
        return null;
    }, [
        limits,
        t,
        formatNumber
    ]);
    const studyLimitError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((s)=>{
        if (s.phase === 'done' || !base) return null;
        if (base.maxDicomStudyBytes > 0 && s.bytes > base.maxDicomStudyBytes) return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_LIMIT_STUDY, {
            size: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, s.bytes),
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, base.maxDicomStudyBytes)
        });
        if (base.maxDicomStudyInstances > 0 && s.instanceCount > base.maxDicomStudyInstances) return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_LIMIT_INSTANCES, {
            count: formatNumber(s.instanceCount),
            limit: formatNumber(base.maxDicomStudyInstances)
        });
        return null;
    }, [
        base,
        t,
        formatNumber
    ]);
    const blockedDocs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(items.filter((it)=>documentLimitError(it)).map((it)=>it.id)), [
        items,
        documentLimitError
    ]);
    const blockedStudies = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(studies.filter((s)=>studyLimitError(s)).map((s)=>s.id)), [
        studies,
        studyLimitError
    ]);
    const blockedKey = [
        ...blockedDocs
    ].join('|');
    const blockedStudyKey = [
        ...blockedStudies
    ].join('|');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        upload.setBlocked(blockedDocs);
    }, [
        blockedKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        dicom.setBlocked(blockedStudies);
    }, [
        blockedStudyKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const blockedCount = blockedDocs.size + blockedStudies.size;
    // ── Intake ────────────────────────────────────────────────────────────────
    const onFiles = async (accepted, rejected)=>{
        const messages = [];
        const rejectedByZone = rejected || [];
        if (rejectedByZone.length) messages.push(...rejectedByZone.map(({ file: file })=>t('patient.files.upload.typeRejectedAny', {
                name: file.name
            })));
        if (!accepted?.length) {
            setZoneError([
                ...new Set(messages)
            ].join(' '));
            return;
        }
        setIntaking(true);
        try {
            const [{ capabilities: readCaps, policy: readPolicy }, out] = await Promise.all([
                limits.ready(),
                (0, $b4cbe3bcc0ad1160$export$4f9320e1e3a0d4ba)(accepted, {
                    known: dicom.knownSopUids
                })
            ]);
            const allowDicom = Boolean(readCaps?.dicom && readPolicy?.dicomEnabled);
            const room = Math.max(0, (readPolicy?.maxFilesPerUpload || (0, $2dcdf1c1963f00da$export$7c6f6c38c781ae96)) - items.filter((it)=>it.phase !== 'done').length);
            if (out.documents.length > room) messages.push(t('patient.files.upload.tooMany', {
                count: formatDigits(readPolicy?.maxFilesPerUpload || (0, $2dcdf1c1963f00da$export$7c6f6c38c781ae96))
            }));
            upload.add(out.documents.slice(0, room), $f959cceb164f70c8$var$DEFAULT_KIND);
            if (out.studies.length) {
                if (allowDicom) dicom.addStudies(out.studies);
                else {
                    // Never silently dropped: the doctor is told why the images are not here.
                    const count = out.studies.reduce((n, s)=>n + s.instanceCount, 0);
                    messages.push(t(!readCaps?.dicom ? 'patient.files.dicom.refusedUnavailable' : 'patient.files.dicom.refusedDisabled', {
                        count: formatNumber(count)
                    }));
                }
            }
            out.rejected.forEach(({ file: file, reason: reason })=>{
                if (reason === 'type') messages.push(t('patient.files.upload.typeRejectedAny', {
                    name: file.name
                }));
                else if (reason === 'archive_entries') messages.push(t('patient.files.dicom.archiveEntries', {
                    name: file.name,
                    count: formatNumber(5000)
                }));
                else if (reason === 'archive_bytes') messages.push(t('patient.files.dicom.archiveBytes', {
                    name: file.name
                }));
                else messages.push(t('patient.files.dicom.archiveUnreadable', {
                    name: file.name
                }));
            });
            const skippedNow = (0, $b4cbe3bcc0ad1160$export$45d8c05978783c00)(out.skipped);
            setSkipped((n)=>n + skippedNow);
            if (!out.documents.length && !out.studies.length && !out.rejected.length && skippedNow) messages.push(t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_NO_FILES));
            setNotice(out.studies.length && allowDicom && out.documents.length ? t('patient.files.dicom.mixedNotice') : '');
        } finally{
            setIntaking(false);
            setZoneError([
                ...new Set(messages)
            ].join(' '));
        }
    };
    const pickVisit = (id)=>{
        setAppointmentId(id);
        if (orderId && !orders.some((o)=>o.id === orderId && o.appointmentId === id)) setOrderId('');
    };
    const shared = {
        appointmentId: appointmentId,
        orderId: orderId,
        documentDate: documentDate,
        description: description
    };
    const dicomShared = {
        ...shared,
        maxBatchBytes: caps?.maxBatchBytes || undefined,
        maxInstanceBytes: caps?.maxInstanceBytes || base?.ceilings?.dicomInstanceBytes || undefined
    };
    const pendingDocs = items.some((it)=>it.phase !== 'done');
    const pendingStudies = studies.some((s)=>s.phase !== 'done');
    const canSubmit = !busy && !intaking && !upload.preparing && (pendingDocs || pendingStudies);
    const submit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (extract)=>{
        if (!canSubmit) return;
        setFailedCount(0);
        // Documents first — they are quick — then the studies.
        const docs = pendingDocs || items.length ? await upload.send(shared) : {
            stored: [],
            failed: 0
        };
        const imaging = pendingStudies || studies.length ? await dicom.send(dicomShared) : {
            stored: [],
            failed: 0
        };
        const stored = [
            ...docs.stored,
            ...imaging.stored
        ];
        const failed = docs.failed + imaging.failed;
        if (failed || imaging.cancelled) {
            setFailedCount(failed);
            // What did land is in the record already; the list behind the overlay shows it.
            if (stored.length) onUploaded?.(stored, {
                partial: true
            });
            return;
        }
        // The extraction that «بارگذاری و استخراج» asks for is a document's, never a study's.
        onUploaded?.(docs.stored.length ? docs.stored : stored, {
            extract: Boolean(extract) && docs.stored.length > 0
        });
    }, [
        canSubmit,
        pendingDocs,
        pendingStudies,
        items.length,
        studies.length,
        upload,
        dicom,
        shared,
        dicomShared,
        onUploaded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const requestClose = ()=>{
        if (busy) return;
        if (dirty) {
            setConfirmDiscard(true);
            return;
        }
        onClose?.();
    };
    // Ctrl+Enter submits the dialog's primary action (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || isMobile) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                e.preventDefault();
                submit(false);
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        isMobile,
        submit
    ]);
    // ── Rows ──────────────────────────────────────────────────────────────────
    const documentError = (it)=>{
        if (it.error?.code === 'HEIC') return t('patient.files.upload.heic');
        if (it.error?.offline) return t('patient.files.upload.offline');
        const ext = it.error?.extensions;
        if (ext?.code === 'UPLOAD_LIMIT_FILE' && (ext.size || ext.storedBytes) && (ext.limit || ext.limitBytes)) return t('patient.files.upload.limitFile', {
            size: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, ext.storedBytes ?? ext.size),
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, ext.limitBytes ?? ext.limit)
        });
        return (0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, it.error, 'patient.files.upload.failedOne');
    };
    const documentRows = items.map((it)=>{
        const limitError = documentLimitError(it);
        const measurement = it.prepared?.measurement;
        const meta = (0, $c51f7f79bb474588$export$3a09f495b2bef3af)(measurement) && it.prepared?.file !== it.file ? t('patient.files.optimizedFromTo', {
            from: formatNumber((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(measurement.srcBytes)),
            to: formatNumber((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(it.prepared.file.size))
        }) : t('patient.files.upload.size', {
            mb: formatDigits((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(it.size))
        });
        return {
            id: it.id,
            name: it.name,
            file: it.file,
            phase: limitError && it.phase !== 'done' ? 'failed' : it.phase,
            meta: meta,
            error: limitError || (it.phase === 'failed' ? documentError(it) : undefined),
            removable: !busy && it.phase !== 'done',
            trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
                "aria-label": t('patient.files.upload.kindLabel'),
                value: it.kind,
                onChange: (e)=>upload.setKind(it.id, e.target.value),
                options: kindOptions,
                placeholder: "",
                disabled: busy || it.phase === 'done',
                "data-testid": `upload-kind-${it.id}`,
                style: {
                    minWidth: '9.5rem'
                }
            })
        };
    });
    const studyError = (s)=>{
        const code = s.error?.code;
        if (code === 'DICOM_LIMIT_STUDY') return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_LIMIT_STUDY, {
            size: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, s.bytes),
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, base?.maxDicomStudyBytes || 0)
        });
        if (code === 'DICOM_LIMIT_INSTANCES') return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_LIMIT_INSTANCES, {
            count: formatNumber(s.instanceCount),
            limit: formatNumber(base?.maxDicomStudyInstances || 0)
        });
        if (code === 'DICOM_INSTANCE_TOO_LARGE') return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0).DICOM_INSTANCE_TOO_LARGE, {
            limit: (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, s.error?.body?.maxInstanceBytes || caps?.maxInstanceBytes || 23068672)
        });
        if (code && (0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0)[code]) return t((0, $2dcdf1c1963f00da$export$a9a070740fdaf1b0)[code]);
        return t('patient.files.dicom.errors.failed');
    };
    const studyRows = studies.map((s, index)=>{
        const limitError = studyLimitError(s);
        const verdict = (0, $b4cbe3bcc0ad1160$export$3de73ed166baf608)(s.patient, patient);
        const counts = [];
        if (s.presentCount) counts.push(t('patient.files.dicom.presentCount', {
            count: formatNumber(s.presentCount)
        }));
        if (s.tooLargeCount) counts.push(t('patient.files.dicom.tooLargeCount', {
            count: formatNumber(s.tooLargeCount)
        }));
        if (s.rejectedCount) counts.push(t('patient.files.dicom.rejectedCount', {
            count: formatNumber(s.rejectedCount)
        }));
        const sendingPhase = s.phase === 'sending' || s.phase === 'committing';
        return {
            id: s.id,
            name: s.description || t('patient.files.dicom.untitled', {
                modality: s.modalities?.[0] || 'DICOM'
            }),
            phase: limitError && s.phase !== 'done' ? 'failed' : sendingPhase ? 'sending' : s.phase,
            progress: s.phase === 'sending' && s.progress != null ? Math.round(s.progress * 100) : undefined,
            progressLabel: s.phase === 'committing' ? t('patient.files.dicom.committing') : s.phase === 'sending' ? t('patient.files.dicom.sentOf', {
                sent: formatNumber(s.sentInstances || 0),
                total: formatNumber(s.instanceCount)
            }) : undefined,
            badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                "data-testid": `files-upload-study-${index}-modality`,
                style: {
                    width: '2.5rem',
                    height: '2.5rem',
                    borderRadius: '0.5rem',
                    background: (0, $jTCZr.CT).accentSoft,
                    color: (0, $jTCZr.CT).accentInk,
                    display: 'grid',
                    placeItems: 'center',
                    fontSize: '0.6875rem',
                    fontWeight: 700
                },
                dir: "ltr"
            }, (s.modalities || []).slice(0, 2).join('/') || 'DCM'),
            meta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `files-upload-study-${index}`,
                "data-state": s.phase,
                style: {
                    display: 'inline-flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '0.25rem 0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $00e4129789459a85$export$6a1ed6b8a13ed847)(t, formatNumber, s)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$de7977fb4fae854b), {
                verdict: verdict,
                testid: `files-upload-study-${index}-identity`
            }), counts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.CT).mute
                }
            }, counts.join(" \xb7 "))),
            error: limitError || (s.phase === 'failed' ? studyError(s) : undefined),
            removable: !busy && s.phase !== 'done',
            trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    minWidth: '9.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
                value: s.documentDate,
                onChange: (v)=>dicom.setDocumentDate(s.id, v),
                disableFuture: true,
                disabled: busy || s.phase === 'done',
                placeholder: t('patient.files.dicom.studyDate'),
                "aria-label": t('patient.files.dicom.studyDate'),
                "data-testid": `files-upload-study-${index}-date`
            }))
        };
    });
    const groups = [];
    if (documentRows.length) groups.push({
        id: 'documents',
        title: t('patient.files.upload.groups.documents'),
        meta: formatNumber(documentRows.length),
        files: documentRows
    });
    if (studyRows.length) groups.push({
        id: 'dicom',
        title: t('patient.files.upload.groups.dicom'),
        meta: formatNumber(studyRows.length),
        files: studyRows
    });
    const phaseLabels = {
        queued: t('patient.files.upload.phase.queued'),
        preparing: t('patient.files.upload.phase.preparing'),
        sending: t('patient.files.upload.phase.sending'),
        done: t('patient.files.upload.phase.done'),
        failed: t('patient.files.upload.phase.failed')
    };
    const helper = [
        t('patient.files.upload.acceptAll', {
            mb: formatDigits((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)((0, $2dcdf1c1963f00da$export$f36c73f7356be416)(base))),
            count: formatDigits(maxDocs)
        }),
        dicomAllowed ? t(canPickFolder ? 'patient.files.dicom.hintFolder' : 'patient.files.dicom.hintZip') : null
    ].filter(Boolean).join(' ');
    const onRetry = (id)=>id.startsWith('study-') ? dicom.send(dicomShared, id) : upload.send(shared, id);
    const onRemove = (id)=>id.startsWith('study-') ? dicom.remove(id) : upload.remove(id);
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            justifyContent: 'flex-end'
        }
    }, dicom.sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: dicom.cancel,
        "data-testid": "upload-stop"
    }, t('patient.files.dicom.stop')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        disabled: busy,
        "data-testid": "upload-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        onClick: ()=>submit(true),
        disabled: !canSubmit || !pendingDocs,
        "data-testid": "upload-submit-extract",
        className: "gap-1.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.upload.submitAndExtract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: price,
        size: "sm",
        testid: "upload-extract-price"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: ()=>submit(false),
        disabled: !canSubmit,
        "data-testid": "upload-submit"
    }, busy ? t('patient.files.upload.sending') : t('patient.files.upload.submit')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: requestClose,
        title: t('patient.files.upload.title'),
        description: isMobile ? undefined : t('patient.files.upload.subtitle'),
        footer: footer,
        busy: busy,
        size: "lg",
        isMobile: isMobile,
        closeLabel: t('common.actions.close'),
        "data-testid": "upload-file-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jM6yW.default), {
        label: t('patient.files.upload.filesLabel'),
        required: true,
        helperText: helper,
        accept: null,
        capture: isMobile ? 'environment' : undefined,
        directory: canPickFolder,
        size: isMobile ? 'compact' : 'regular',
        groups: groups.length ? groups : undefined,
        files: groups.length ? undefined : [],
        onFiles: onFiles,
        onRemove: onRemove,
        onRetry: onRetry,
        busy: busy || intaking,
        error: zoneError || undefined,
        dropLabel: t('patient.files.upload.drop'),
        pickLabel: t('patient.files.upload.pick'),
        cameraLabel: t('patient.files.upload.camera'),
        directoryLabel: t('patient.files.upload.pickFolder'),
        draggingLabel: t('patient.files.upload.dragging'),
        removeLabel: t('common.actions.delete'),
        retryLabel: t('common.actions.retry'),
        listLabel: t('patient.files.upload.filesLabel'),
        phaseLabels: phaseLabels,
        "data-testid": "upload-dropzone"
    }), intaking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "upload-intaking"
    }, t('patient.files.dicom.reading')), notice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "upload-notice"
    }, notice), skipped > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "upload-skipped",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.dicom.skipped', {
        count: formatNumber(skipped)
    })), blockedCount > 0 && !busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "upload-blocked"
    }, t('patient.files.upload.blocked', {
        count: formatNumber(blockedCount)
    })), failedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "upload-partial"
    }, t('patient.files.upload.partial', {
        count: formatDigits(failedCount)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '0.75rem 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.upload.linkVisit')
    }, presetVisit || preset.appointmentId && appointmentId === preset.appointmentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "upload-visit-linked",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minHeight: '2.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 600
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $899acbe55afec07f$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true
    }), presetVisit?.scheduledDate ? t('patient.files.upload.thisVisitOn', {
        date: (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(presetVisit.scheduledDate, formatDate)
    }) : t('patient.files.upload.thisVisit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "gap-1",
        onClick: ()=>pickVisit(''),
        disabled: busy,
        "data-testid": "upload-visit-unlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.files.upload.unlink'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        value: appointmentId,
        onChange: (e)=>pickVisit(e.target.value),
        options: visitOptions,
        placeholder: t('patient.files.upload.noLink'),
        disabled: busy || !visitOptions.length,
        "data-testid": "upload-visit"
    })), appointmentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f959cceb164f70c8$export$6fb3676f9dc22f1b, {
        value: orderId,
        onChange: setOrderId,
        options: orderOptions,
        loading: ordersLoading,
        disabled: busy,
        testid: "upload-order"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxWidth: isMobile ? 'none' : 'calc(50% - 0.5rem)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t(studies.length ? 'patient.files.dicom.dateHintMixed' : 'patient.files.upload.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: documentDate,
        onChange: setDocumentDate,
        disableFuture: true,
        disabled: busy,
        placeholder: t('patient.files.upload.datePlaceholder'),
        "data-testid": "upload-document-date"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.description'),
        value: description,
        onChange: (e)=>setDescription(e.target.value),
        placeholder: t('patient.files.upload.descriptionPlaceholder'),
        maxLength: 500,
        showCount: true,
        rows: 2,
        disabled: busy,
        "data-testid": "upload-description"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirmDiscard,
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.upload.discardTitle'),
        description: t('patient.files.upload.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            setConfirmDiscard(false);
            onClose?.();
        },
        confirmTestId: "upload-discard-confirm"
    }));
}








/**
 * A study, in the drawer: its identity and quality warnings, a thumbnail that opens
 * the images, the §8.5 metadata and its series. What `FileViewer` is for a document.
 */ function $1f567419dd4447b1$var$StudyDetail({ file: file, patient: patient, isMobile: isMobile, onView: onView, onConfirmIdentity: onConfirmIdentity, confirming: confirming }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const study = file.dicom || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-study",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$1090f771f7d0b229), {
        file: file,
        patient: patient,
        onConfirm: onConfirmIdentity ? ()=>onConfirmIdentity(file) : undefined,
        confirming: confirming,
        testid: "file-detail-identity"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$3a5c932de3a0f9c9), {
        study: study,
        testid: "file-detail-lossy"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fab7b93fa77b6d7$export$2e2bcd8739ae039), {
        study: study,
        size: "4.5rem",
        testid: "file-detail-study-thumb"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, (study.modalities || []).map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$8b4ef6368b96e1d9), {
            key: m,
            modality: m,
            testid: `file-detail-modality-${m}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": "file-detail-study-meta"
    }, (0, $00e4129789459a85$export$6a1ed6b8a13ed847)(t, formatNumber, study)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        onClick: ()=>onView?.(file),
        disabled: !study.viewable && !(isMobile && study.rendered),
        "data-testid": "file-detail-view-images"
    }, t('patient.files.dicom.viewImages'))), !study.viewable && !(isMobile && study.rendered) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        },
        "data-testid": "file-detail-not-viewable"
    }, t('patient.files.dicom.notViewable')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.dicom.viewer.metadata'),
        testid: "file-detail-study-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$31a954d36640d797), {
        study: study,
        testid: "file-detail-dicom-metadata"
    })), (study.series || []).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.dicom.viewer.series'),
        testid: "file-detail-series"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, study.series.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: s.seriesUid || i,
            "data-testid": `file-detail-series-${i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$8b4ef6368b96e1d9), {
            modality: s.modality,
            testid: `file-detail-series-modality-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, s.description || t('patient.files.dicom.seriesNumber', {
            number: formatNumber(s.number ?? i + 1)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t('patient.files.dicom.imageCount', {
            count: formatNumber(s.frames || s.instances || 0)
        })))))));
}
// «فایل» — one document: see it, read what was extracted from it, correct what it is,
// download or delete it, or have it read by AI.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.4–§7.6, §8.3.
//
// The kit `Drawer` at the inline-end on a workstation, a full-height `BottomSheet` on a
// phone (DESIGN_SYSTEM §8). It replaces the hand-rolled `AnalysisDrawer` (design F16).
//
// It is one of the overlays `useClinicalFiles` owns, and only one of those is ever
// open: the extraction review REPLACES this drawer and hands back to it on close, so
// nothing stacks except a confirm (DESIGN_CONCEPT §5.2).
const $1f567419dd4447b1$var$DRAWER_WIDTH = 560;
function $1f567419dd4447b1$var$Section({ title: title, children: children, testid: testid, action: action }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).mute,
            flex: 1
        }
    }, title), action), children);
}
/** The values or the report text the record already holds from this file. */ function $1f567419dd4447b1$var$RecordedContent({ file: file }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const rows = (0, $bced050439dec003$export$ebcae889d05cbae5)(file.ocrContent);
    if (!file.ocrContent) return null;
    if (!(0, $bced050439dec003$export$c2a61e046b7fd3b2)(rows)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-report-text",
        style: {
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.625rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        }
    }, file.ocrContent);
    const th = {
        padding: '0.375rem 0.5rem',
        textAlign: 'start',
        fontWeight: 600,
        color: (0, $jTCZr.CT).mute,
        borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
        background: (0, $jTCZr.CT).surface2
    };
    const td = {
        padding: '0.3125rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
        color: (0, $jTCZr.CT).ink2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "file-detail-values",
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.71875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.files.extract.test')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('patient.files.extract.value')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.files.extract.range')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>r.raw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 3,
            style: {
                ...td,
                color: (0, $jTCZr.CT).mute
            }
        }, r.raw)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i,
            style: {
                background: r.status === 'critical' ? (0, $jTCZr.CT).dangerSoft : r.status !== 'normal' && r.status !== 'unknown' ? (0, $jTCZr.CT).warnSoft : 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $jTCZr.CT).ink,
                fontWeight: 600
            },
            dir: "auto"
        }, r.testName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums'
            },
            dir: "ltr"
        }, formatDigits(r.value), " ", r.unit || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td,
            dir: "ltr"
        }, r.refRange || "\u2014"))))));
}
/** The newest analysis run, summarised, with the way back into its review. */ function $1f567419dd4447b1$var$LatestRun({ file: file, patientId: patientId, onReview: onReview }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        run: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        setState({
            status: 'loading',
            run: null
        });
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$edb578819a2e86f4), {
            patientId: patientId
        }).then((d)=>{
            if (cancelled) return;
            const row = (d?.patient?.clinicalFiles || []).find((f)=>f.id === file.id);
            setState({
                status: row?.analysis ? 'content' : 'empty',
                run: row?.analysis || null
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'error',
                run: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        file.id,
        file.processedAt,
        patientId,
        attempt
    ]);
    if (state.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "file-detail-run-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2
    }));
    if (state.status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "file-detail-run-error",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>setAttempt((n)=>n + 1)
        }, t('common.actions.retry'))
    }, t('patient.files.analysis.loadFailed'));
    if (!state.run) return null;
    const run = state.run;
    const isReport = run.mode === 'REPORT' || Boolean(run.report);
    const rows = run.labResults || [];
    const gist = isReport ? run.report?.sections?.find((s)=>s.key === 'impression')?.text || run.report?.fullText || run.summaryText || '' : rows.slice(0, 4).map((r)=>`${r.testName} ${r.value ?? ''}${r.unit ? ` ${r.unit}` : ''}`).join(" \xb7 ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-run",
        style: {
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.625rem 0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(isReport ? 'patient.files.extract.report' : 'patient.files.extract.lab')), run.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(run.createdAt, formatDate)), run.costParseh > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", t('patient.files.extract.chargedAmount', {
        price: formatDigits(run.costParseh)
    })), !isReport && rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", t('patient.files.testCount', {
        count: formatDigits(rows.length)
    }))), gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
        }
    }, gist), run.status !== 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>onReview(file, run),
        "data-testid": "file-detail-review"
    }, t('patient.files.extract.review'))));
}
function $1f567419dd4447b1$export$2e2bcd8739ae039({ open: open, file: file, patientId: patientId, visits: visits = [], orders: orders = [], ordersLoading: ordersLoading = false, clinicName: clinicName, isMobile: isMobile, startEditing: startEditing = false, patient: patient, onView: onView, onConfirmIdentity: onConfirmIdentity, confirming: confirming = false, onClose: onClose, onExtract: onExtract, onReview: onReview, onDownload: onDownload, onDelete: onDelete, onSaved: onSaved }) {
    const { t: t, has: has, formatDate: formatDate, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { costOf: costOf } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const closeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const initialDraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((f)=>({
            fileName: f?.fileName || '',
            kind: (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(f?.kind) || 'OTHER',
            documentDate: f?.documentDate || '',
            description: f?.description || '',
            appointmentId: f?.appointmentId || '',
            orderId: f?.orderId || ''
        }), []);
    // «ویرایش» from a row's menu opens the drawer already in its form.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setEditing(Boolean(startEditing && file?.canEdit));
        setDraft(initialDraft(file));
        setSaveError('');
    }, [
        file?.id,
        initialDraft,
        startEditing
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Focus lands inside the panel when it opens (DESIGN_CONCEPT §5.2).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && !isMobile) closeRef.current?.focus?.();
    }, [
        open,
        isMobile,
        file?.id
    ]);
    const scope = file?.editScope || null;
    const curation = scope === 'curation';
    const storageOnly = file?._source === 'storage';
    const dirty = editing && draft && JSON.stringify(draft) !== JSON.stringify(initialDraft(file));
    const requestClose = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard(true);
            return;
        }
        onClose?.();
    };
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!file || !draft || saving || !dirty) return;
        const before = initialDraft(file);
        const input = {};
        for (const key of Object.keys(draft)){
            if (draft[key] === before[key]) continue;
            if (curation && ![
                'kind',
                'documentDate',
                'description',
                'appointmentId'
            ].includes(key)) continue;
            input[key] = draft[key];
        }
        if (!Object.keys(input).length) {
            setEditing(false);
            return;
        }
        setSaving(true);
        setSaveError('');
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$ab95be7703af4e9d), {
                fileId: file.id,
                input: input
            });
            setEditing(false);
            onSaved?.(d?.updateClinicalFile || null);
        } catch (e) {
            setSaveError((0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.edit.failed'));
        } finally{
            setSaving(false);
        }
    }, [
        file,
        draft,
        saving,
        dirty,
        curation,
        initialDraft,
        onSaved,
        t,
        has
    ]);
    // Ctrl+S saves the open form (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !editing) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
                e.preventDefault();
                save();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        editing,
        save
    ]);
    if (!open || !file) return null;
    const kind = (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(file.kind);
    const Icon = (0, $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a)[kind] || (0, $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a).OTHER;
    const isStudy = (0, $a9fe471dd730c044$export$918b21086f1a685e)(file);
    const studyExtractable = !isStudy || (0, $a9fe471dd730c044$export$5fe06db7379f90a6)(file.dicom);
    const optimized = !isStudy && file.optimization?.originalBytes > 0 && file.optimization?.storedBytes > 0 && file.optimization.storedBytes < file.optimization.originalBytes;
    const visit = visits.find((v)=>v.id === file.appointmentId);
    const docDate = (0, $bced050439dec003$export$8be12e4e93c8dacd)(file);
    const inFlight = (0, $157d5bd48cfffbad$export$96ba48b359c8edfb)(file.processingStatus);
    const price = costOf('ANALYZE_FILE');
    const set = (key)=>(value)=>setDraft((d)=>({
                    ...d,
                    [key]: value
                }));
    const kindOptions = (0, $157d5bd48cfffbad$export$4f5645f323f84265).map((k)=>({
            value: k.value,
            label: t(k.labelKey)
        }));
    const visitOptions = visits.map((v)=>({
            value: v.id,
            label: v.scheduledDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(v.scheduledDate, formatDate) : t('patient.visit')
        }));
    const orderOptions = orders.filter((o)=>draft?.appointmentId && o.appointmentId === draft.appointmentId).map((o)=>({
            value: o.id,
            label: (0, $f959cceb164f70c8$export$b1b80d45b3914dd7)(o, t)
        }));
    const visitLocked = curation && Boolean(file.orderId);
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.625rem'
        }
    }, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fab7b93fa77b6d7$export$2e2bcd8739ae039), {
        study: file.dicom,
        size: "2.25rem",
        testid: "file-detail-thumb"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 18,
        strokeWidth: 1.75
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-name",
        style: {
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            wordBreak: 'break-word',
            unicodeBidi: 'isolate'
        }
    }, file.fileName || t('patient.files.file')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.25rem',
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$6047a074a83ec744), {
        file: file,
        clinicName: clinicName
    }))), !isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: closeRef,
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        onClick: requestClose,
        "aria-label": t('common.actions.close'),
        "data-testid": "file-detail-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    }))));
    const facts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-facts",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, docDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(file.documentDate ? 'patient.files.documentDateIs' : 'patient.files.uploadedOn', {
        date: (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(docDate, formatDate)
    })), (0, $bced050439dec003$export$d791f2a3277ada5e)(file) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", t('patient.files.uploadedOn', {
        date: (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(file.createdAt, formatDate)
    })), !isStudy && !optimized && file.fileSize > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", t('patient.files.upload.size', {
        mb: formatDigits((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(file.fileSize))
    })), optimized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        },
        "data-testid": "file-detail-optimized"
    }, " \xb7 ", t('patient.files.optimizedFromTo', {
        from: formatNumber((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(file.optimization.originalBytes)),
        to: formatNumber((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(file.optimization.storedBytes))
    })), isStudy && file.dicom?.storedBytes > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", (0, $2dcdf1c1963f00da$export$d16689d79378b0e4)(t, formatNumber, file.dicom.storedBytes))), (visit || file.resolvedOrder) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $899acbe55afec07f$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), visit?.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.visitOn', {
        date: (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(visit.scheduledDate, formatDate)
    })), file.resolvedOrder?.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, "\xb7 ", t('visit.orders.result.answersOrder'), ": ", file.resolvedOrder.description)), file.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-description",
        style: {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        }
    }, file.description));
    const editForm = draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-edit",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, curation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info"
    }, t('patient.files.edit.curationHint')), !curation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.files.edit.fileName'),
        value: draft.fileName,
        onChange: (v)=>set('fileName')(typeof v === 'string' ? v : v?.target?.value ?? ''),
        dir: "auto",
        "data-testid": "file-edit-name"
    }), !isStudy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.kindLabel'),
        value: draft.kind,
        onChange: (e)=>set('kind')(e.target.value),
        options: kindOptions,
        placeholder: "",
        "data-testid": "file-edit-kind"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t('patient.files.upload.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.documentDate,
        onChange: set('documentDate'),
        disableFuture: true,
        placeholder: t('patient.files.upload.datePlaceholder')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.linkVisit'),
        value: draft.appointmentId,
        onChange: (e)=>setDraft((d)=>({
                    ...d,
                    appointmentId: e.target.value,
                    orderId: orders.some((o)=>o.id === d.orderId && o.appointmentId === e.target.value) ? d.orderId : ''
                })),
        options: visitOptions,
        placeholder: t('patient.files.upload.noLink'),
        disabled: visitLocked,
        helperText: visitLocked ? t('patient.files.edit.visitLocked') : undefined,
        "data-testid": "file-edit-visit"
    }), !curation && draft.appointmentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f959cceb164f70c8$export$6fb3676f9dc22f1b), {
        value: draft.orderId,
        onChange: set('orderId'),
        options: orderOptions,
        loading: ordersLoading,
        testid: "file-edit-order"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.description'),
        value: draft.description,
        onChange: (e)=>set('description')(e.target.value),
        maxLength: 500,
        showCount: true,
        rows: 3,
        "data-testid": "file-edit-description"
    }), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "file-edit-error"
    }, saveError));
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, !isMobile && header, isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, header), editing ? editForm : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, facts, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$StudyDetail, {
        file: file,
        patient: patient,
        isMobile: isMobile,
        onView: onView,
        onConfirmIdentity: onConfirmIdentity,
        confirming: confirming
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a38d4c43e1d261e$export$2e2bcd8739ae039), {
        file: file,
        height: isMobile ? '18rem' : '24rem'
    }), file.processingStatus === 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "file-detail-failure"
    }, t((0, $157d5bd48cfffbad$export$70f239c59f207d0)(file.processingError))), inFlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "file-detail-in-flight"
    }, t('patient.files.extract.inFlight')), !storageOnly && (0, $157d5bd48cfffbad$export$2c31f9f3ffd05797)(file.processingStatus) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.detail.lastRun'),
        testid: "file-detail-run-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$LatestRun, {
        file: file,
        patientId: patientId,
        onReview: onReview
    })), file.ocrContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.detail.inRecord'),
        testid: "file-detail-recorded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$RecordedContent, {
        file: file
    }))));
    const footer = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: ()=>{
            setEditing(false);
            setDraft(initialDraft(file));
            setSaveError('');
        },
        disabled: saving,
        "data-testid": "file-edit-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: save,
        disabled: saving || !dirty,
        "data-testid": "file-edit-save"
    }, saving ? t('common.state.saving') : t('common.actions.save'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center'
        }
    }, !storageOnly && studyExtractable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        className: "gap-1.5",
        onClick: ()=>onExtract(file),
        disabled: !file.extractable,
        title: inFlight ? t('patient.files.extract.inFlight') : undefined,
        "data-testid": "file-detail-extract"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.actions.extract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: price,
        size: "sm",
        testid: "file-detail-extract-price"
    })), isStudy && !studyExtractable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-detail-no-extraction",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            flex: '1 1 14rem'
        }
    }, t('patient.files.dicom.noExtraction')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), !isStudy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onDownload(file),
        "data-testid": "file-detail-download"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), file.canEdit && !storageOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>setEditing(true),
        "data-testid": "file-detail-edit-open"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.edit')), (file.canDelete || storageOnly) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onDelete(file),
        "data-testid": "file-detail-delete",
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete')));
    const discard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirmDiscard,
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.upload.discardTitle'),
        description: t('patient.files.upload.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            setConfirmDiscard(false);
            setEditing(false);
            onClose?.();
        }
    });
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: t(editing ? 'patient.files.edit.title' : 'patient.files.detailTitle'),
        footer: footer,
        fullHeight: true,
        closeLabel: t('common.actions.close'),
        "data-testid": "file-detail-drawer"
    }, body), discard);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000
        },
        "data-testid": "file-detail-drawer",
        "data-editing": editing || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $beZBx.default), {
        open: open,
        onClose: requestClose,
        width: $1f567419dd4447b1$var$DRAWER_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": file.fileName || t('patient.files.detailTitle'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '1rem 1.125rem'
        }
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.75rem 1.125rem',
            background: (0, $jTCZr.CT).surface
        }
    }, footer)))), discard);
}




var $acw62 = parcelRequire("acw62");

parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $cjPik = parcelRequire("cjPik");
var $bfs4Q = parcelRequire("bfs4Q");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");

var $2WFPf = parcelRequire("2WFPf");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $272fea46916dddb1$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
];
const $272fea46916dddb1$export$2e2bcd8739ae039 = (0, $9QBug.default)("image", $272fea46916dddb1$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");

var $k27hS = parcelRequire("k27hS");









// ─────────────────────────────────────────────────────────────────────────────
// The lab-result review, as data — docs/lab_results_ocr_wireframe_ai_agent.md.
//
// OCR IS RAW DATA. From the image come exactly: the row, the test name as printed
// and the value as printed (plus the printed row as evidence, a confidence and where
// the row is on the page). Everything shown beside them comes from the internal
// catalogue through the BFF's `labReview` query, resolved for THIS patient:
//
//   unit / reference range   → the catalogue reference (never editable)
//   status                   → interpretLabValue(value, reference)  (never editable)
//   the value                → the ONE thing the doctor corrects
//
// `interpretLabValue` MIRRORS `interpret_value` in the AI service's
// app/services/reference_ranges.py so a corrected value re-evaluates as it is typed.
// It is a preview: the BFF re-resolves every row through the service before anything
// is written. Change one, change both — src/__tests__/labReview.test.js carries the
// same cases as tests/test_lab_reference_catalog.py.
// ─────────────────────────────────────────────────────────────────────────────
// Folding tables, written as code points: Arabic letter forms → their Persian forms
// (yeh, alef maksura → ی; kaf → ک; teh marbuta, heh-yeh → ه; hamza/madda alefs → ا).
const $4bee6261c6e7da77$var$LETTERS = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u06C0": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627"
}; // i18n-exempt: letter folding for matching printed values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$INVISIBLE = /[‌‍‎‏‪-‮⁦-⁩﻿ـ]/g;
// Persian (U+06F0–U+06F9) and Arabic-Indic (U+0660–U+0669) digits → ASCII: the low
// nibble of either code point is the digit.
const $4bee6261c6e7da77$var$foldDigits = (text)=>String(text ?? '').replace(/[۰-۹٠-٩]/g, (d)=>String(d.charCodeAt(0) & 0xF));
function $4bee6261c6e7da77$export$4fa6c6d12e97b690(text) {
    return $4bee6261c6e7da77$var$foldDigits(text).replace(/[يىكةۀأإآ]/g, (c)=>$4bee6261c6e7da77$var$LETTERS[c]).replace($4bee6261c6e7da77$var$INVISIBLE, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}
// i18n-exempt: matchers against printed lab values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$QUALITATIVE_NORMAL = [
    'negative',
    'neg',
    'absent',
    'none',
    'normal',
    'nil',
    "\u0645\u0646\u0641\u06CC"
];
// i18n-exempt: matchers against printed lab values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL = [
    'positive',
    'pos',
    'present',
    'trace',
    "\u0645\u062B\u0628\u062A"
];
// Printed results that are valid but carry no numeric rule (the status stays unknown).
// i18n-exempt: matchers against printed lab values
const $4bee6261c6e7da77$var$QUALITATIVE_OTHER = [
    'reactive',
    'non-reactive',
    'nonreactive',
    'non reactive',
    'detected',
    'not detected',
    'not seen',
    'rare',
    'few',
    'many',
    'moderate',
    'occasional',
    'seen',
    'normal range'
];
const $4bee6261c6e7da77$var$VALUE_NUMBER = /^([<>≤≥])?\s*(-?\d+(?:\.\d+)?)$/;
function $4bee6261c6e7da77$export$806c78176a41fb4e(value) {
    const text = $4bee6261c6e7da77$var$foldDigits(value).replace(/٫/g, '.').replace(/[٬,]/g, '').trim(); // i18n-exempt: Arabic decimal/thousands separators in printed values
    const match = text.match($4bee6261c6e7da77$var$VALUE_NUMBER);
    if (!match) return null;
    return {
        comparator: match[1] || null,
        number: Number(match[2])
    };
}
const $4bee6261c6e7da77$var$UNKNOWN_VERDICT = Object.freeze({
    interpretation: 'unknown',
    critical: false,
    status: 'unknown'
});
function $4bee6261c6e7da77$export$77819e6353fc2d38(value, reference) {
    const text = String(value ?? '').trim();
    if (!text || !reference?.matched) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const folded = $4bee6261c6e7da77$export$4fa6c6d12e97b690(text);
    if ($4bee6261c6e7da77$var$QUALITATIVE_NORMAL.includes(folded)) return {
        interpretation: 'normal',
        critical: false,
        status: 'normal'
    };
    if ($4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL.includes(folded)) return {
        interpretation: 'abnormal',
        critical: false,
        status: 'abnormal'
    };
    if (!reference.referenceAvailable) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const parsed = $4bee6261c6e7da77$export$806c78176a41fb4e(text);
    if (!parsed) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    let n = parsed.number;
    // "<5" sits just below 5 and ">40" just above 40, as the service reads them.
    if (parsed.comparator === '<' || parsed.comparator === "\u2264") n -= 0.001;
    else if (parsed.comparator === '>' || parsed.comparator === "\u2265") n += 0.001;
    const { low: low, high: high, criticalLow: criticalLow, criticalHigh: criticalHigh } = reference;
    let interpretation = 'normal';
    if (low != null && n < low) interpretation = 'low';
    else if (high != null && n > high) interpretation = 'high';
    const critical = interpretation !== 'normal' && (criticalLow != null && n < criticalLow || criticalHigh != null && n > criticalHigh);
    const status = critical ? 'critical' : interpretation === 'normal' ? 'normal' : 'abnormal';
    return {
        interpretation: interpretation,
        critical: critical,
        status: status
    };
}
function $4bee6261c6e7da77$export$59e23cb7df3fc649(value) {
    const text = String(value ?? '').trim();
    if (!text) return 'missing';
    if ($4bee6261c6e7da77$export$806c78176a41fb4e(text)) return null;
    const folded = $4bee6261c6e7da77$export$4fa6c6d12e97b690(text);
    if ($4bee6261c6e7da77$var$QUALITATIVE_NORMAL.includes(folded) || $4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL.includes(folded) || $4bee6261c6e7da77$var$QUALITATIVE_OTHER.includes(folded)) return null;
    if (/^\d?\s*\+{1,4}$/.test(folded)) return null; // 1+, ++, +++
    if (/^\d+\s*[:/]\s*\d+$/.test(folded)) return null; // a titre: 1/320, 1:80
    return 'invalid';
}
function $4bee6261c6e7da77$export$3aee0d7cce272488(confidence, policy) {
    if (confidence == null) return null;
    const c = Number(confidence);
    const accept = policy?.acceptConfidence;
    const review = policy?.reviewConfidence;
    if (!Number.isFinite(c) || accept == null || review == null) return null;
    if (c >= accept) return 'accepted';
    if (c >= review) return 'review';
    return 'uncertain';
}
function $4bee6261c6e7da77$export$725f4e3b103b8ffd(run) {
    return (run?.labResults || []).map((r, i)=>{
        const value = r.value == null ? '' : String(r.value);
        return {
            key: `ocr-${i}`,
            source: 'ocr',
            row: Number.isInteger(r.row) && r.row > 0 ? r.row : i + 1,
            rawTestName: r.testName || '',
            ocrTestKey: r.testKey || null,
            testKey: r.testKey || '',
            value: value,
            ocrValue: value,
            confidence: r.confidence ?? null,
            verified: r.verified ?? null,
            sourceText: r.sourceText || '',
            region: r.region || null,
            implausible: r.flag === 'implausible',
            // A row with no evidence in what the model read starts UNTICKED (§9.6).
            selected: r.verified !== false
        };
    });
}
let $4bee6261c6e7da77$var$manualSeq = 0;
function $4bee6261c6e7da77$export$7eba22ca66154cf6(rows = []) {
    $4bee6261c6e7da77$var$manualSeq += 1;
    const next = rows.reduce((max, r)=>Math.max(max, Number(r.row) || 0), 0) + 1;
    return {
        key: `manual-${Date.now().toString(36)}-${$4bee6261c6e7da77$var$manualSeq}`,
        source: 'manual',
        row: next,
        rawTestName: '',
        ocrTestKey: null,
        testKey: '',
        value: '',
        ocrValue: null,
        confidence: null,
        verified: null,
        sourceText: '',
        region: null,
        implausible: false,
        selected: true
    };
}
function $4bee6261c6e7da77$export$9402c7d9ee327bb9(rows) {
    return rows.map((r)=>({
            testKey: r.testKey || null,
            testName: r.rawTestName || '',
            value: r.value || ''
        }));
}
function $4bee6261c6e7da77$export$adc9098288f9ed0b(data, rows) {
    const byRowKey = new Map();
    (data?.items || []).forEach((item, i)=>{
        if (rows[i]) byRowKey.set(rows[i].key, item);
    });
    const catalog = data?.catalog || [];
    return {
        byRowKey: byRowKey,
        catalog: catalog,
        catalogByKey: new Map(catalog.filter((c)=>c.testKey).map((c)=>[
                c.testKey,
                c
            ])),
        policy: data?.policy || null,
        patientSex: data?.patientSex || null,
        patientAgeYears: data?.patientAgeYears ?? null
    };
}
const $4bee6261c6e7da77$var$UNMATCHED = Object.freeze({
    testKey: null,
    matched: false,
    unit: null,
    low: null,
    high: null,
    criticalLow: null,
    criticalHigh: null,
    referenceText: null,
    referenceAvailable: false,
    missingReason: 'not_matched',
    basis: null
});
function $4bee6261c6e7da77$export$c7c79a53ae71fe3b(row, review) {
    if (!review) return null;
    if (row.testKey) {
        const picked = review.catalogByKey.get(row.testKey);
        if (picked) return picked;
    }
    const own = review.byRowKey.get(row.key);
    if (own && (!row.testKey || own.testKey === row.testKey)) return own;
    return $4bee6261c6e7da77$var$UNMATCHED;
}
const $4bee6261c6e7da77$export$843191028a978a16 = Object.freeze([
    'noTest',
    'missing',
    'invalid'
]);
const $4bee6261c6e7da77$export$bcb12241a240418c = Object.freeze([
    'unmatched',
    'uncertain',
    'review',
    'implausible',
    'unverified'
]);
function $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review) {
    const ref = $4bee6261c6e7da77$export$c7c79a53ae71fe3b(row, review);
    const matched = Boolean(ref?.matched);
    const verdict = ref ? $4bee6261c6e7da77$export$77819e6353fc2d38(row.value, ref) : $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const valueProblem = $4bee6261c6e7da77$export$59e23cb7df3fc649(row.value);
    const corrected = row.source === 'ocr' && row.ocrValue != null && String(row.value).trim() !== String(row.ocrValue).trim();
    const band = row.source === 'ocr' ? $4bee6261c6e7da77$export$3aee0d7cce272488(row.confidence, review?.policy) : null;
    const issues = [];
    if (row.source === 'manual' && !matched) issues.push('noTest');
    else if (!matched) issues.push('unmatched');
    if (valueProblem) issues.push(valueProblem);
    if (matched && !ref.referenceAvailable) issues.push('noReference');
    // Correcting the value is the doctor's answer to every doubt about the READING. A
    // reading that produced nothing has no value to doubt («مقدار قابل تشخیص نیست» says
    // it), but a row with no evidence on the page is still worth a look.
    if (!corrected && row.source === 'ocr') {
        if (String(row.ocrValue ?? '').trim()) {
            if (band === 'uncertain') issues.push('uncertain');
            else if (band === 'review') issues.push('review');
            if (row.implausible) issues.push('implausible');
        }
        if (row.verified === false) issues.push('unverified');
    }
    return {
        ref: ref,
        matched: matched,
        ...verdict,
        valueProblem: valueProblem,
        band: band,
        corrected: corrected,
        issues: issues
    };
}
function $4bee6261c6e7da77$export$b0c762580619fe10(rows, review) {
    const blocking = [];
    const suspicious = [];
    rows.filter((r)=>r.selected !== false).forEach((row)=>{
        const { issues: issues } = $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review);
        if (issues.some((i)=>$4bee6261c6e7da77$export$843191028a978a16.includes(i))) blocking.push(row);
        else if (issues.some((i)=>$4bee6261c6e7da77$export$bcb12241a240418c.includes(i))) suspicious.push(row);
    });
    return {
        blocking: blocking,
        suspicious: suspicious
    };
}
function $4bee6261c6e7da77$export$2ace0c9b49273a05(rows, review) {
    return rows.filter((r)=>r.selected !== false).map((row)=>{
        const view = $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review);
        const ref = view.ref || $4bee6261c6e7da77$var$UNMATCHED;
        return {
            testName: view.matched && ref.displayName || row.rawTestName,
            value: String(row.value).trim(),
            unit: ref.unit || '',
            referenceRange: ref.referenceText || '',
            status: view.status,
            source: row.source,
            testKey: view.matched && ref.testKey || null,
            ocrTestKey: row.ocrTestKey || null,
            rawTestName: row.rawTestName || null,
            ocrValue: row.source === 'ocr' ? row.ocrValue : null,
            row: Number.isInteger(row.row) ? row.row : null,
            confidence: row.confidence ?? null
        };
    }).filter((input)=>input.testName && input.value);
}
function $4bee6261c6e7da77$export$446eb29412604ad7(review) {
    return (review?.catalog || []).map((c)=>({
            value: c.testKey,
            label: c.displayName || c.testKey
        }));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $lxEfx = parcelRequire("lxEfx");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $97xXr = parcelRequire("97xXr");
var $aGlWN = parcelRequire("aGlWN");
var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $5MbI8 = parcelRequire("5MbI8");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dbc3cbe2df76370b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 15 6 6",
            key: "1s409w"
        }
    ],
    [
        "path",
        {
            d: "m15 9 6-6",
            key: "ko1vev"
        }
    ],
    [
        "path",
        {
            d: "M21 16v5h-5",
            key: "1ck2sf"
        }
    ],
    [
        "path",
        {
            d: "M21 8V3h-5",
            key: "1qoq8a"
        }
    ],
    [
        "path",
        {
            d: "M3 16v5h5",
            key: "1t08am"
        }
    ],
    [
        "path",
        {
            d: "m3 21 6-6",
            key: "wwnumi"
        }
    ],
    [
        "path",
        {
            d: "M3 8V3h5",
            key: "1ln10m"
        }
    ],
    [
        "path",
        {
            d: "M9 9 3 3",
            key: "v551iv"
        }
    ]
];
const $dbc3cbe2df76370b$export$2e2bcd8739ae039 = (0, $9QBug.default)("expand", $dbc3cbe2df76370b$export$3efd853dbb351e94);


var $6ivsH = parcelRequire("6ivsH");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $61d40a05e8e57206$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8",
            key: "17vawe"
        }
    ],
    [
        "path",
        {
            d: "M9 19.8V15m0 0H4.2M9 15l-6 6",
            key: "chjx8e"
        }
    ],
    [
        "path",
        {
            d: "M15 4.2V9m0 0h4.8M15 9l6-6",
            key: "lav6yq"
        }
    ],
    [
        "path",
        {
            d: "M9 4.2V9m0 0H4.2M9 9 3 3",
            key: "1pxi2q"
        }
    ]
];
const $61d40a05e8e57206$export$2e2bcd8739ae039 = (0, $9QBug.default)("shrink", $61d40a05e8e57206$export$3efd853dbb351e94);


var $47abO = parcelRequire("47abO");
var $bU80g = parcelRequire("bU80g");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// The lab sheet beside its extracted rows — docs/lab_results_ocr_wireframe_ai_agent.md §6–§7.
//
// What it must let the doctor answer: «was this value really read from THIS row?»
//
//   • zoom (buttons, Ctrl/⌘ + wheel about the cursor, + / −), fit (0), pan (drag, wheel
//     or arrow keys once zoomed), and «expand» for more room — at the image's own
//     resolution: the bitmap is scaled by the browser, never re-encoded;
//   • a numbered, subtle highlight over every row the model could place. Hovering or
//     focusing a table row lights its highlight (and brings it into view when zoomed);
//     pressing a highlight makes its table row active;
//   • a PDF is drawn by the browser's own viewer, where no highlight can be laid over
//     the page — the panel says so, and each row still carries its printed text.
//
// The frame is laid out left-to-right on purpose: an image has no reading direction,
// and its row coordinates are measured from its top-left corner (the same exception
// DESIGN_SYSTEM §11 makes for the dental arch). The chrome around it stays logical.
const $ddefab495daaa435$var$MIN_ZOOM = 0.5;
const $ddefab495daaa435$var$MAX_ZOOM = 8;
const $ddefab495daaa435$var$STEP = 1.25;
const $ddefab495daaa435$var$PAN_STEP = 48;
const $ddefab495daaa435$var$DRAG_THRESHOLD = 4;
const $ddefab495daaa435$var$clamp = (v, lo, hi)=>Math.min(hi, Math.max(lo, v));
const $ddefab495daaa435$var$TOOL = 34;
function $ddefab495daaa435$var$Highlight({ mark: mark, active: active, label: label, number: number, onPress: onPress, testid: testid }) {
    const { region: region } = mark;
    // The number sits just OUTSIDE the row's end edge, where a lab sheet has margin,
    // so it never covers the printed name or value (§7). A row that runs to the page's
    // edge keeps it inside, on that edge.
    const roomOutside = region.x + region.width < 0.95;
    return(// A raw button on purpose: a highlight is a hit-area laid over a bitmap at the
    // row's own geometry, not a control with the kit's padding and height.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": testid,
        "data-active": active || undefined,
        "aria-pressed": active,
        "aria-label": label,
        title: label,
        onClick: onPress,
        style: {
            position: 'absolute',
            insetInlineStart: `${region.x * 100}%`,
            top: `${region.y * 100}%`,
            width: `${region.width * 100}%`,
            height: `${region.height * 100}%`,
            padding: 0,
            margin: 0,
            background: 'transparent',
            border: 'none',
            borderRadius: 3,
            cursor: 'pointer',
            outlineOffset: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            inset: 0,
            borderRadius: 3,
            border: `${active ? 2 : 1}px solid ${(0, $jTCZr.CT).accent}`,
            opacity: active ? 1 : 0.4
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            inset: 0,
            borderRadius: 3,
            background: (0, $jTCZr.CT).accent,
            opacity: active ? 0.12 : 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '50%',
            ...roomOutside ? {
                insetInlineStart: 'calc(100% + 4px)',
                transform: 'translateY(-50%)'
            } : {
                insetInlineEnd: 2,
                transform: 'translateY(-50%)'
            },
            minWidth: 16,
            height: 16,
            padding: '0 3px',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1,
            background: active ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).card,
            color: active ? (0, $jTCZr.CT).card : (0, $jTCZr.CT).accentInk,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            opacity: active ? 1 : 0.85
        }
    }, number)));
}
function $ddefab495daaa435$export$2e2bcd8739ae039({ file: file, marks: marks = [], activeKey: activeKey = null, activeSource: activeSource = null, onActivate: onActivate, expanded: expanded = false, onToggleExpand: onToggleExpand, height: height, testid: testid = 'lab-image-viewer' }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const k = (s)=>`patient.files.extract.labReview.viewer.${s}`;
    const view = (0, $286ab8933969f880$export$2e2bcd8739ae039)(file);
    const hintId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [frame, setFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        w: 0,
        h: 0
    });
    const [natural, setNatural] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const current = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        zoom: 1,
        pan: {
            x: 0,
            y: 0
        }
    });
    const drag = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const suppressClick = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const isImage = view.status === 'ready' && view.type.startsWith('image/');
    const isPdf = view.status === 'ready' && view.type === 'application/pdf';
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = frameRef.current;
        if (!el) return undefined;
        const measure = ()=>setFrame({
                w: el.clientWidth,
                h: el.clientHeight
            });
        measure();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        view.status
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setNatural(null);
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
        current.current = {
            zoom: 1,
            pan: {
                x: 0,
                y: 0
            }
        };
    }, [
        view.url
    ]);
    const measured = Boolean(natural) && frame.w > 0 && frame.h > 0;
    const fit = measured ? Math.min(frame.w / natural.w, frame.h / natural.h) : 1;
    const scale = fit * zoom;
    const size = measured ? {
        w: natural.w * scale,
        h: natural.h * scale
    } : null;
    const apply = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z, p)=>{
        if (!measured) return;
        const w = natural.w * fit * z;
        const h = natural.h * fit * z;
        const maxX = Math.max(0, (w - frame.w) / 2);
        const maxY = Math.max(0, (h - frame.h) / 2);
        const next = {
            x: $ddefab495daaa435$var$clamp(p.x, -maxX, maxX),
            y: $ddefab495daaa435$var$clamp(p.y, -maxY, maxY)
        };
        current.current = {
            zoom: z,
            pan: next
        };
        setZoom(z);
        setPan(next);
    }, [
        measured,
        natural,
        fit,
        frame.w,
        frame.h
    ]);
    // Zoom keeping one point of the image under one point of the frame.
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next, anchor)=>{
        if (!measured) return;
        const { zoom: z1, pan: p } = current.current;
        const z2 = $ddefab495daaa435$var$clamp(next, $ddefab495daaa435$var$MIN_ZOOM, $ddefab495daaa435$var$MAX_ZOOM);
        const ax = anchor ? anchor.x : frame.w / 2;
        const ay = anchor ? anchor.y : frame.h / 2;
        const ox = (frame.w - natural.w * fit * z1) / 2 + p.x;
        const oy = (frame.h - natural.h * fit * z1) / 2 + p.y;
        const ix = (ax - ox) / (fit * z1);
        const iy = (ay - oy) / (fit * z1);
        apply(z2, {
            x: ax - ix * fit * z2 - (frame.w - natural.w * fit * z2) / 2,
            y: ay - iy * fit * z2 - (frame.h - natural.h * fit * z2) / 2
        });
    }, [
        measured,
        natural,
        fit,
        frame.w,
        frame.h,
        apply
    ]);
    const fitView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>apply(1, {
            x: 0,
            y: 0
        }), [
        apply
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = frameRef.current;
        if (!el || !isImage) return undefined;
        const onWheel = (e)=>{
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                const rect = el.getBoundingClientRect();
                zoomTo(current.current.zoom * (e.deltaY < 0 ? $ddefab495daaa435$var$STEP : 1 / $ddefab495daaa435$var$STEP), {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                });
                return;
            }
            if (current.current.zoom > 1) {
                e.preventDefault();
                const { zoom: z, pan: p } = current.current;
                apply(z, {
                    x: p.x - e.deltaX,
                    y: p.y - e.deltaY
                });
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    }, [
        isImage,
        zoomTo,
        apply
    ]);
    const activeMark = marks.find((m)=>m.key === activeKey) || null;
    const activeRegion = activeMark?.region && (activeMark.region.page || 1) === 1 ? activeMark.region : null;
    // A row activated from the table is brought into view when the zoom has hidden it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!activeRegion || !measured || activeSource === 'image') return;
        const { zoom: z, pan: p } = current.current;
        const w = natural.w * fit * z;
        const h = natural.h * fit * z;
        const cx = (frame.w - w) / 2 + p.x + (activeRegion.x + activeRegion.width / 2) * w;
        const cy = (frame.h - h) / 2 + p.y + (activeRegion.y + activeRegion.height / 2) * h;
        const margin = 24;
        if (cx >= margin && cx <= frame.w - margin && cy >= margin && cy <= frame.h - margin) return;
        apply(z, {
            x: p.x + (frame.w / 2 - cx),
            y: p.y + (frame.h / 2 - cy)
        });
    }, [
        activeKey,
        activeRegion,
        activeSource,
        measured,
        natural,
        fit,
        frame.w,
        frame.h,
        apply
    ]);
    const onPointerDown = (e)=>{
        if (e.button !== 0 || !measured) return;
        drag.current = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY,
            pan: current.current.pan,
            moved: false
        };
    };
    const onPointerMove = (e)=>{
        const d = drag.current;
        if (!d || d.id !== e.pointerId) return;
        const dx = e.clientX - d.x;
        const dy = e.clientY - d.y;
        if (!d.moved) {
            if (Math.hypot(dx, dy) < $ddefab495daaa435$var$DRAG_THRESHOLD) return;
            d.moved = true;
            e.currentTarget.setPointerCapture?.(e.pointerId);
        }
        apply(current.current.zoom, {
            x: d.pan.x + dx,
            y: d.pan.y + dy
        });
    };
    const onPointerUp = (e)=>{
        const d = drag.current;
        drag.current = null;
        if (d?.moved) {
            e.currentTarget.releasePointerCapture?.(e.pointerId);
            suppressClick.current = true;
        }
    };
    // A drag that ends over a highlight is a pan, not a press.
    const onClickCapture = (e)=>{
        if (!suppressClick.current) return;
        suppressClick.current = false;
        e.stopPropagation();
        e.preventDefault();
    };
    const onKeyDown = (e)=>{
        if (!measured || e.ctrlKey || e.metaKey || e.altKey) return;
        const { zoom: z, pan: p } = current.current;
        const actions = {
            '+': ()=>zoomTo(z * $ddefab495daaa435$var$STEP),
            '=': ()=>zoomTo(z * $ddefab495daaa435$var$STEP),
            '-': ()=>zoomTo(z / $ddefab495daaa435$var$STEP),
            '0': fitView,
            ArrowLeft: ()=>apply(z, {
                    x: p.x + $ddefab495daaa435$var$PAN_STEP,
                    y: p.y
                }),
            ArrowRight: ()=>apply(z, {
                    x: p.x - $ddefab495daaa435$var$PAN_STEP,
                    y: p.y
                }),
            ArrowUp: ()=>apply(z, {
                    x: p.x,
                    y: p.y + $ddefab495daaa435$var$PAN_STEP
                }),
            ArrowDown: ()=>apply(z, {
                    x: p.x,
                    y: p.y - $ddefab495daaa435$var$PAN_STEP
                })
        };
        const action = actions[e.key];
        if (!action || e.target !== e.currentTarget) return;
        e.preventDefault();
        action();
    };
    const placed = marks.filter((m)=>m.region && (m.region.page || 1) === 1);
    const atFit = zoom === 1 && pan.x === 0 && pan.y === 0;
    let body;
    if (view.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": `${testid}-loading`,
        style: {
            position: 'absolute',
            inset: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: 0
    }));
    else if (view.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.files.unavailable'),
        onRetry: view.retry
    }));
    else if (isPdf) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: file?.fileName || t('patient.files.file'),
        src: view.url,
        style: {
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block'
        }
    });
    else if (isImage) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-canvas`,
        style: {
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            width: size ? size.w : '100%',
            height: size ? size.h : '100%',
            transform: size ? `translate(${(frame.w - size.w) / 2 + pan.x}px, ${(frame.h - size.h) / 2 + pan.y}px)` : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: view.url,
        alt: file?.fileName || '',
        draggable: false,
        "data-testid": `${testid}-image`,
        onLoad: (e)=>{
            const img = e.currentTarget;
            if (img.naturalWidth && img.naturalHeight) setNatural({
                w: img.naturalWidth,
                h: img.naturalHeight
            });
        },
        style: {
            width: '100%',
            height: '100%',
            objectFit: size ? 'fill' : 'contain',
            display: 'block',
            userSelect: 'none',
            pointerEvents: 'none'
        }
    }), size && placed.map((mark)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ddefab495daaa435$var$Highlight, {
            key: mark.key,
            mark: mark,
            active: mark.key === activeKey,
            number: formatDigits(mark.row),
            label: t(k('highlight'), {
                row: formatDigits(mark.row),
                name: mark.name || "\u2014"
            }),
            onPress: ()=>onActivate?.(mark.key),
            testid: `lab-highlight-${mark.key}`
        })));
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.75rem',
            padding: '1rem',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c17edf56d0b04896$export$2e2bcd8739ae039), {
        size: 32,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), t('patient.files.detail.noPreview'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-state": view.status,
        "data-type": view.type || undefined,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem',
            minHeight: 0,
            flex: height ? undefined : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "toolbar",
        "aria-label": t(k('label')),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.125rem',
            minHeight: $ddefab495daaa435$var$TOOL
        }
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47abO.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('zoomIn')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: ()=>zoomTo(zoom * $ddefab495daaa435$var$STEP),
        disabled: !measured || zoom >= $ddefab495daaa435$var$MAX_ZOOM,
        "data-testid": `${testid}-zoom-in`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('zoomOut')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: ()=>zoomTo(zoom / $ddefab495daaa435$var$STEP),
        disabled: !measured || zoom <= $ddefab495daaa435$var$MIN_ZOOM,
        "data-testid": `${testid}-zoom-out`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ivsH.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('fit')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: fitView,
        disabled: !measured || atFit,
        "data-testid": `${testid}-fit`
    }), measured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        "data-testid": `${testid}-zoom-level`,
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            paddingInline: '0.375rem',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap'
        }
    }, t(k('zoomLevel'), {
        percent: Math.round(scale * 100)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), onToggleExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: expanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61d40a05e8e57206$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbc3cbe2df76370b$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k(expanded ? 'collapse' : 'expand')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        "aria-pressed": expanded,
        onClick: onToggleExpand,
        "data-testid": `${testid}-expand`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: frameRef,
        "data-testid": `${testid}-frame`,
        tabIndex: isImage ? 0 : undefined,
        role: isImage ? 'region' : undefined,
        "aria-label": isImage ? t(k('label')) : undefined,
        "aria-describedby": isImage ? hintId : undefined,
        onKeyDown: isImage ? onKeyDown : undefined,
        onPointerDown: isImage ? onPointerDown : undefined,
        onPointerMove: isImage ? onPointerMove : undefined,
        onPointerUp: isImage ? onPointerUp : undefined,
        onPointerCancel: isImage ? onPointerUp : undefined,
        onClickCapture: isImage ? onClickCapture : undefined,
        style: {
            position: 'relative',
            direction: 'ltr',
            overflow: 'hidden',
            flex: height ? undefined : 1,
            height: height,
            minHeight: '14rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            cursor: isImage && zoom > 1 ? 'grab' : 'default',
            touchAction: isImage && zoom > 1 ? 'none' : 'pan-y'
        }
    }, body, isImage && activeMark && !activeRegion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite",
        "data-testid": `${testid}-no-region`,
        style: {
            position: 'absolute',
            bottom: 8,
            insetInlineStart: 8,
            insetInlineEnd: 8,
            direction: 'rtl',
            display: 'flex',
            justifyContent: 'center',
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            background: (0, $jTCZr.CT).card,
            color: (0, $jTCZr.CT).ink2,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            padding: '0.125rem 0.5rem',
            fontSize: '0.6875rem'
        }
    }, t(k('noRegion'), {
        row: formatDigits(activeMark.row)
    })))), isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: hintId,
        className: "sr-only"
    }, t(k('keyboardHint'))), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testid}-pdf-note`
    }, t(k('pdfNoHighlight'))));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5MbI8 = parcelRequire("5MbI8");
var $fAR2n = parcelRequire("fAR2n");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $dfuoR = parcelRequire("dfuoR");
var $QG9Z3 = parcelRequire("QG9Z3");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c8d58349d145e6a3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
];
const $c8d58349d145e6a3$export$2e2bcd8739ae039 = (0, $9QBug.default)("arrow-down", $c8d58349d145e6a3$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $eda1c78859f80095$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const $eda1c78859f80095$export$2e2bcd8739ae039 = (0, $9QBug.default)("arrow-up", $eda1c78859f80095$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c2768ed5a904339e$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $c2768ed5a904339e$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-question-mark", $c2768ed5a904339e$export$3efd853dbb351e94);


var $97xXr = parcelRequire("97xXr");
var $aGlWN = parcelRequire("aGlWN");
var $lpOUO = parcelRequire("lpOUO");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $854b6748a2b0b789$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $854b6748a2b0b789$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-x", $854b6748a2b0b789$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dcfebb84a9a026be$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
            key: "rib7q0"
        }
    ],
    [
        "path",
        {
            d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
            key: "1ymkrd"
        }
    ]
];
const $dcfebb84a9a026be$export$2e2bcd8739ae039 = (0, $9QBug.default)("quote", $dcfebb84a9a026be$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


const $9d2aabecd4883b7c$export$95f93c6e984947ba = (item)=>Number.isFinite(Number(item?.confidence)) && item.confidence !== null && Number(item.confidence) < (0, $157d5bd48cfffbad$export$8e824c3a51e639a1);
const $9d2aabecd4883b7c$export$1c8d84be23596b2a = (item)=>item?.verified === false;
const $9d2aabecd4883b7c$export$db8ce6b495f12ddc = (item)=>$9d2aabecd4883b7c$export$1c8d84be23596b2a(item) || $9d2aabecd4883b7c$export$95f93c6e984947ba(item) ? (0, $jTCZr.CT).warnSoft : 'transparent';
function $9d2aabecd4883b7c$export$2e9eab6b9d145d15({ item: item, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $9d2aabecd4883b7c$export$1c8d84be23596b2a(item) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "warn",
        "data-testid": `${testid}-unverified`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('patient.files.extract.evidence.unverified')), !$9d2aabecd4883b7c$export$1c8d84be23596b2a(item) && $9d2aabecd4883b7c$export$95f93c6e984947ba(item) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "warn",
        "data-testid": `${testid}-review`
    }, t('patient.files.extract.evidence.review')));
}
function $9d2aabecd4883b7c$export$d01dc4a28d149339({ text: text, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!text) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.25rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dcfebb84a9a026be$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            marginTop: '0.1875rem',
            color: (0, $jTCZr.CT).mute
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.evidence.source'), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate'
        }
    }, text)));
}
function $9d2aabecd4883b7c$export$1c49e2087a373b64({ flags: flags, testid: testid }) {
    if (!flags?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": testid,
        style: {
            margin: 0,
            paddingInlineStart: '1rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk,
            lineHeight: 1.8
        }
    }, flags.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${f.code}-${i}`,
            "data-code": f.code,
            dir: "auto"
        }, f.message || f.code)));
}



// The pieces one lab row is drawn from, shared by the desktop table and the phone
// cards (design-language parts, not layout — DESIGN_SYSTEM §7).
//
//   read-only  → the test name, unit, reference range and status: plain text, no box
//   editable   → the value alone: a bordered field, so the difference never depends on
//                colour (§17)
//
// Every state is said in words with an icon (§18): a status is «بالا» with an arrow,
// never a red cell.
const $e984a1b6384d4ce7$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $e984a1b6384d4ce7$var$LTR = {
    direction: 'ltr',
    unicodeBidi: 'isolate'
};
const $e984a1b6384d4ce7$var$TONE = {
    normal: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        Icon: (0, $8cb58a0e56c12463$export$2e2bcd8739ae039)
    },
    high: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $eda1c78859f80095$export$2e2bcd8739ae039)
    },
    low: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $c8d58349d145e6a3$export$2e2bcd8739ae039)
    },
    abnormal: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $QG9Z3.default)
    },
    critical: {
        background: (0, $jTCZr.CT).dangerSoft,
        color: (0, $jTCZr.CT).dangerInk,
        Icon: (0, $dfuoR.default)
    },
    unknown: {
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).mute,
        Icon: (0, $c2768ed5a904339e$export$2e2bcd8739ae039)
    }
};
function $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2(row, view) {
    return view?.matched && view.ref?.displayName || row.rawTestName || '';
}
function $e984a1b6384d4ce7$export$e39d377614ea8158(row, view) {
    if (!view?.matched || !row.rawTestName) return false;
    return (0, $4bee6261c6e7da77$export$4fa6c6d12e97b690)(row.rawTestName) !== (0, $4bee6261c6e7da77$export$4fa6c6d12e97b690)(view.ref?.displayName || '');
}
function $e984a1b6384d4ce7$export$1dd29eecb96d6990({ view: view, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const key = view.critical ? 'critical' : $e984a1b6384d4ce7$var$TONE[view.interpretation] ? view.interpretation : 'unknown';
    const labelKey = view.critical ? view.interpretation === 'low' ? 'criticalLow' : 'criticalHigh' : key;
    const { Icon: Icon, ...tone } = $e984a1b6384d4ce7$var$TONE[key];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-status": key,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            fontSize: '0.71875rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            lineHeight: 1.6,
            ...tone
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 12,
        "aria-hidden": true
    }), " ", t($e984a1b6384d4ce7$var$k(`status.${labelKey}`)));
}
function $e984a1b6384d4ce7$export$76451f5ae0877040({ view: view, testid: testid }) {
    return view.ref?.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'nowrap'
        }
    }, view.ref.unit) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, "\u2014");
}
function $e984a1b6384d4ce7$export$9419155be3602f77({ view: view, testid: testid }) {
    return view.ref?.referenceAvailable && view.ref.referenceText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums'
        }
    }, view.ref.referenceText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, "\u2014");
}
const $e984a1b6384d4ce7$export$1690d49a4660854d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LabValueInput({ row: row, view: view, name: name, onChange: onChange, onRevert: onRevert, onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, describedBy: describedBy, testid: testid }, ref) {
    const { t: t } = (0, $LNQP4.default)();
    const invalid = view.valueProblem === 'invalid';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: '4.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        ref: ref,
        value: row.value,
        onChange: (e)=>onChange(typeof e === 'string' ? e : e?.target?.value ?? ''),
        dir: "ltr",
        inputMode: "decimal",
        autoComplete: "off",
        spellCheck: false,
        "aria-label": t($e984a1b6384d4ce7$var$k('valueLabel'), {
            name: name || t('patient.files.extract.test')
        }),
        "aria-invalid": invalid || undefined,
        "aria-describedby": describedBy,
        placeholder: view.valueProblem === 'missing' ? "\u2014" : undefined,
        disabled: disabled,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        inputStyle: {
            fontWeight: 600,
            fontVariantNumeric: 'tabular-nums',
            ...invalid ? {
                borderColor: (0, $jTCZr.CT).danger
            } : null
        },
        "data-testid": testid
    })), view.corrected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
            size: 14,
            "aria-hidden": true
        }),
        label: t($e984a1b6384d4ce7$var$k('revert')),
        variant: "ghost",
        size: 32,
        onClick: onRevert,
        disabled: disabled,
        "data-testid": `${testid}-revert`
    }));
});
function $e984a1b6384d4ce7$var$Notice({ tone: tone = 'warn', icon: Icon, children: children, action: action, testid: testid }) {
    const color = {
        warn: (0, $jTCZr.CT).warnInk,
        danger: (0, $jTCZr.CT).dangerInk,
        info: (0, $jTCZr.CT).ink2,
        mute: (0, $jTCZr.CT).mute
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            fontSize: '0.71875rem',
            color: color,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 13,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, children), action);
}
function $e984a1b6384d4ce7$export$8442fca60fc3bfd2(row, view, active) {
    return view.issues.length > 0 || view.corrected || row.source === 'manual' || row.source === 'ocr' && row.testKey && row.testKey !== row.ocrTestKey || active && Boolean(row.sourceText);
}
function $e984a1b6384d4ce7$export$18ebf7db3a596718({ row: row, view: view, active: active, catalogOptions: catalogOptions, onPickTest: onPickTest, onEditValue: onEditValue, onRemove: onRemove, disabled: disabled, id: id, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const [picking, setPicking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const has = (issue)=>view.issues.includes(issue);
    const pickedByDoctor = row.source === 'ocr' && Boolean(row.testKey) && row.testKey !== row.ocrTestKey;
    const showPicker = row.source === 'manual' || pickedByDoctor || has('unmatched') && picking;
    const editAction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "h-7 gap-1 px-2",
        onClick: onEditValue,
        disabled: disabled,
        "data-testid": `${testid}-edit`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t($e984a1b6384d4ce7$var$k('edit')));
    const reasonKey = view.ref?.missingReason === 'sex_unknown' ? 'noReferenceSex' : view.ref?.missingReason === 'no_band' ? 'noReferenceBand' : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, has('noTest') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-no-test`
    }, t($e984a1b6384d4ce7$var$k('noTest'))), has('unmatched') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-unmatched`,
        action: !picking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "h-7 px-2",
            onClick: ()=>setPicking(true),
            disabled: disabled,
            "data-testid": `${testid}-pick-open`
        }, t($e984a1b6384d4ce7$var$k('pickTest')))
    }, t($e984a1b6384d4ce7$var$k('unmatched'))), showPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxWidth: '18rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t($e984a1b6384d4ce7$var$k('pickTestLabel')),
        value: row.testKey || '',
        onChange: (e)=>onPickTest(e.target.value),
        options: catalogOptions,
        placeholder: t($e984a1b6384d4ce7$var$k('pickTestPlaceholder')),
        disabled: disabled,
        "data-testid": `${testid}-pick`
    })), has('invalid') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "danger",
        icon: (0, $854b6748a2b0b789$export$2e2bcd8739ae039),
        testid: `${testid}-invalid`
    }, t($e984a1b6384d4ce7$var$k('invalidValue'))), has('missing') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "mute",
        icon: (0, $f12b90bce5d0156f$export$2e2bcd8739ae039),
        testid: `${testid}-missing`
    }, t($e984a1b6384d4ce7$var$k('missingValue'))), has('uncertain') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-uncertain`,
        action: editAction
    }, t($e984a1b6384d4ce7$var$k('uncertain')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t($e984a1b6384d4ce7$var$k('extractedValue'), {
        value: ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, row.ocrValue)), has('review') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "info",
        icon: (0, $97xXr.default),
        testid: `${testid}-review`,
        action: editAction
    }, t($e984a1b6384d4ce7$var$k('reviewBand'))), has('implausible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-implausible`
    }, view.ref?.unit ? t($e984a1b6384d4ce7$var$k('implausible'), {
        unit: view.ref.unit
    }) : t($e984a1b6384d4ce7$var$k('implausibleNoUnit'))), has('noReference') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-no-reference`
    }, t($e984a1b6384d4ce7$var$k('noReference')), reasonKey ? ` ${t($e984a1b6384d4ce7$var$k(reasonKey))}` : ''), view.corrected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "mute",
        icon: (0, $aGlWN.default),
        testid: `${testid}-corrected`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "accent"
    }, t($e984a1b6384d4ce7$var$k('corrected'))), ' ', t($e984a1b6384d4ce7$var$k('ocrValue'), {
        value: ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $e984a1b6384d4ce7$var$LTR
    }, row.ocrValue || "\u2014")), has('unverified') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$2e9eab6b9d145d15), {
        item: {
            verified: false
        },
        testid: `${testid}-evidence`
    })), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$d01dc4a28d149339), {
        text: row.sourceText,
        testid: `${testid}-source`
    }), row.source === 'manual' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "h-7 gap-1 px-2",
        onClick: onRemove,
        disabled: disabled,
        "data-testid": `${testid}-remove`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('patient.files.extract.removeRow'))));
}


// «جدول نتایج» on a workstation — docs/lab_results_ocr_wireframe_ai_agent.md §4.
//
//   ردیف │ آیتم آزمایش │ مقدار │ واحد │ محدودهٔ مرجع │ وضعیت
//   OCR  │ OCR+catalog │ OCR ✎ │ DB   │ DB           │ rule engine
//
// Only the value is a field. Hovering or focusing a row makes it the active row (its
// highlight lights on the image); ↑ / ↓ / Enter move between the value fields.
const $a64846894ac678ef$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $a64846894ac678ef$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
const $a64846894ac678ef$var$headerCell = {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: (0, $jTCZr.CT).surface2,
    padding: '0.5rem',
    textAlign: 'start',
    fontWeight: 600,
    color: (0, $jTCZr.CT).mute,
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
    fontSize: '0.75rem'
};
const $a64846894ac678ef$var$cell = {
    padding: '0.375rem 0.5rem',
    verticalAlign: 'middle'
};
function $a64846894ac678ef$export$2e2bcd8739ae039({ rows: rows, views: views, activeKey: activeKey, onActivate: onActivate, onRowChange: onRowChange, onRevert: onRevert, onPickTest: onPickTest, onRemove: onRemove, onValueKeyDown: onValueKeyDown, onEditValue: onEditValue, registerValue: registerValue, catalogOptions: catalogOptions, disabled: disabled }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            background: (0, $jTCZr.CT).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "lab-results-table",
        style: {
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: '0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t($a64846894ac678ef$var$k('tableTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '2.5rem',
            borderStartStartRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only"
    }, t($a64846894ac678ef$var$k('columns.record')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '3.25rem'
        }
    }, t($a64846894ac678ef$var$k('columns.row'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: $a64846894ac678ef$var$headerCell
    }, t($a64846894ac678ef$var$k('columns.test'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '9rem'
        }
    }, t($a64846894ac678ef$var$k('columns.value'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '6rem'
        }
    }, t($a64846894ac678ef$var$k('columns.unit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '7rem',
            textAlign: 'end'
        }
    }, t($a64846894ac678ef$var$k('columns.range'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '8rem',
            borderStartEndRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card
        }
    }, t($a64846894ac678ef$var$k('columns.status'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row)=>{
        const view = views.get(row.key);
        if (!view) return null;
        const active = row.key === activeKey;
        const selected = row.selected !== false;
        const name = (0, $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2)(row, view);
        const noticesId = `lab-row-notices-${row.key}`;
        const withNotices = (0, $e984a1b6384d4ce7$export$8442fca60fc3bfd2)(row, view, active);
        const band = active ? (0, $jTCZr.CT).accentSoft : 'transparent';
        const edge = {
            borderInlineStart: `3px solid ${active ? (0, $jTCZr.CT).accent : 'transparent'}`
        };
        const dim = selected ? undefined : 0.55;
        const activate = ()=>onActivate(row.key, 'table');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: row.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            "data-testid": "lab-row",
            "data-key": row.key,
            "data-active": active || undefined,
            "data-status": view.status,
            "data-selected": selected,
            "data-issues": view.issues.join(' ') || undefined,
            onMouseEnter: activate,
            onFocusCapture: activate,
            style: {
                background: band
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                ...edge,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                textAlign: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: selected,
            onChange: (v)=>onRowChange(row.key, {
                    selected: $a64846894ac678ef$var$checkedValue(v)
                }),
            "aria-label": t('patient.files.extract.recordRow', {
                name: name || t('patient.files.extract.test')
            }),
            disabled: disabled,
            "data-testid": `lab-row-select-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-8 min-w-8 px-2 tabular-nums",
            onClick: ()=>onActivate(row.key, 'table', {
                    reveal: true
                }),
            "aria-label": t($a64846894ac678ef$var$k('showOnImage'), {
                row: formatDigits(row.row)
            }),
            "data-testid": `lab-row-locate-${row.key}`
        }, formatDigits(row.row))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim,
                minWidth: '8rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            "data-testid": `lab-row-name-${row.key}`,
            style: {
                fontWeight: 600,
                color: view.matched ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).ink2,
                unicodeBidi: 'isolate'
            }
        }, name || "\u2014"), (0, $e984a1b6384d4ce7$export$e39d377614ea8158)(row, view) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t($a64846894ac678ef$var$k('onDocument'), {
            name: ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, row.rawTestName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$1690d49a4660854d), {
            ref: (el)=>registerValue(row.key, el),
            row: row,
            view: view,
            name: name,
            onChange: (value)=>onRowChange(row.key, {
                    value: value
                }),
            onRevert: ()=>onRevert(row.key),
            onKeyDown: onValueKeyDown(row.key),
            disabled: disabled,
            describedBy: withNotices ? noticesId : undefined,
            testid: `lab-row-value-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$76451f5ae0877040), {
            view: view,
            testid: `lab-row-unit-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim,
                textAlign: 'end'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$9419155be3602f77), {
            view: view,
            testid: `lab-row-range-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$1dd29eecb96d6990), {
            view: view,
            testid: `lab-row-status-${row.key}`
        }))), withNotices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            "data-testid": "lab-row-detail",
            onMouseEnter: activate,
            style: {
                background: band
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...edge,
                padding: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 5,
            style: {
                padding: '0 0.5rem 0.5rem',
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$18ebf7db3a596718), {
            id: noticesId,
            row: row,
            view: view,
            active: active,
            catalogOptions: catalogOptions,
            onPickTest: (testKey)=>onPickTest(row.key, testKey),
            onEditValue: ()=>onEditValue(row.key),
            onRemove: ()=>onRemove(row.key),
            disabled: disabled,
            testid: `lab-row-notices-${row.key}`
        }))));
    }))));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// «جدول نتایج» on a phone: one card per row, the same parts as the desktop table and
// the same rule — the value is the only field (docs/lab_results_ocr_wireframe_ai_agent.md §4, §17).
const $6a4a7b67771311d8$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $6a4a7b67771311d8$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
function $6a4a7b67771311d8$export$2e2bcd8739ae039({ rows: rows, views: views, activeKey: activeKey, onActivate: onActivate, onRowChange: onRowChange, onRevert: onRevert, onPickTest: onPickTest, onRemove: onRemove, onValueKeyDown: onValueKeyDown, onEditValue: onEditValue, registerValue: registerValue, catalogOptions: catalogOptions, disabled: disabled }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": "lab-result-cards",
        "aria-label": t($6a4a7b67771311d8$var$k('tableTitle')),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, rows.map((row)=>{
        const view = views.get(row.key);
        if (!view) return null;
        const active = row.key === activeKey;
        const selected = row.selected !== false;
        const name = (0, $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2)(row, view);
        const noticesId = `lab-row-notices-${row.key}`;
        const withNotices = (0, $e984a1b6384d4ce7$export$8442fca60fc3bfd2)(row, view, active);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: row.key,
            "data-testid": "lab-row",
            "data-key": row.key,
            "data-active": active || undefined,
            "data-status": view.status,
            "data-selected": selected,
            "data-issues": view.issues.join(' ') || undefined,
            onFocusCapture: ()=>onActivate(row.key, 'table'),
            style: {
                border: `1px solid ${active ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
                borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                background: active ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).card,
                padding: '0.625rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: selected,
            onChange: (v)=>onRowChange(row.key, {
                    selected: $6a4a7b67771311d8$var$checkedValue(v)
                }),
            "aria-label": t('patient.files.extract.recordRow', {
                name: name || t('patient.files.extract.test')
            }),
            disabled: disabled,
            "data-testid": `lab-row-select-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-9 min-w-9 px-2 tabular-nums",
            onClick: ()=>onActivate(row.key, 'table', {
                    reveal: true
                }),
            "aria-label": t($6a4a7b67771311d8$var$k('showOnImage'), {
                row: formatDigits(row.row)
            }),
            "data-testid": `lab-row-locate-${row.key}`
        }, formatDigits(row.row)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                opacity: selected ? undefined : 0.55
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontWeight: 600,
                fontSize: '0.875rem',
                color: view.matched ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).ink2,
                unicodeBidi: 'isolate',
                overflowWrap: 'anywhere'
            }
        }, name || "\u2014"), (0, $e984a1b6384d4ce7$export$e39d377614ea8158)(row, view) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('onDocument'), {
            name: ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, row.rawTestName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$1dd29eecb96d6990), {
            view: view,
            testid: `lab-row-status-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                opacity: selected ? undefined : 0.55,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$1690d49a4660854d), {
            ref: (el)=>registerValue(row.key, el),
            row: row,
            view: view,
            name: name,
            onChange: (value)=>onRowChange(row.key, {
                    value: value
                }),
            onRevert: ()=>onRevert(row.key),
            onKeyDown: onValueKeyDown(row.key),
            disabled: disabled,
            describedBy: withNotices ? noticesId : undefined,
            testid: `lab-row-value-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
            style: {
                margin: 0,
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: '0.125rem 0.5rem',
                fontSize: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('columns.unit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$76451f5ae0877040), {
            view: view,
            testid: `lab-row-unit-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('columns.range'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$9419155be3602f77), {
            view: view,
            testid: `lab-row-range-${row.key}`
        }))), withNotices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e984a1b6384d4ce7$export$18ebf7db3a596718), {
            id: noticesId,
            row: row,
            view: view,
            active: active,
            catalogOptions: catalogOptions,
            onPickTest: (testKey)=>onPickTest(row.key, testKey),
            onEditValue: ()=>onEditValue(row.key),
            onRemove: ()=>onRemove(row.key),
            disabled: disabled,
            testid: `lab-row-notices-${row.key}`
        })));
    }));
}



// «استخراج نتایج آزمایش» — the body of the review overlay in LAB_RESULTS mode.
// doctor-app/parsina.client.web/docs/lab_results_ocr_wireframe_ai_agent.md
//
//   ┌ source panel (≈40 %) ──────────┐ ┌ results (≈60 %) ───────────────┐
//   │ LabImageViewer + highlights    │ │ notices · date · table · extras│  ← only this scrolls
//   │ «اطلاعات استخراج‌شده از تصویر» │ │                                │
//   └────────────────────────────────┘ └────────────────────────────────┘
//
// The overlay owns the rows (so it knows what is unsaved), the catalogue state and the
// commit; this component owns which row is active and the value fields, and exposes
// `focusRow(key)` so «ثبت و ادامه» can send the doctor to the row that needs them.
const $52ac9b8dd4c1cc5a$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $52ac9b8dd4c1cc5a$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
function $52ac9b8dd4c1cc5a$var$ExtractionInfo() {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-extraction-info",
        style: {
            display: 'flex',
            gap: '0.5rem',
            padding: '0.625rem 0.75rem',
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface2,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 16,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0,
            marginTop: '0.125rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelBody1'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelBody2')))));
}
const $52ac9b8dd4c1cc5a$var$LabResultExtraction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LabResultExtraction({ file: file, run: run, rows: rows, onRowsChange: onRowsChange, review: review, documentDate: documentDate, onDocumentDateChange: onDocumentDateChange, pickedDiagnoses: pickedDiagnoses, onPickDiagnosis: onPickDiagnosis, pickedMedications: pickedMedications, onPickMedication: onPickMedication, disabled: disabled = false, isMobile: isMobile = false, sourceVisible: sourceVisible = true, onSourceVisibleChange: onSourceVisibleChange, notices: notices = null, footnote: footnote = null }, ref) {
    const { t: t } = (0, $LNQP4.default)();
    const titleId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        key: null,
        source: null
    });
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const valueRefs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ready = review.status === 'ready';
    const views = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Map(rows.map((r)=>[
                r.key,
                (0, $4bee6261c6e7da77$export$d1f0b5cf52fcd31)(r, review.review)
            ])), [
        rows,
        review.review
    ]);
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $4bee6261c6e7da77$export$446eb29412604ad7)(review.review), [
        review.review
    ]);
    const marks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>rows.map((r)=>({
                key: r.key,
                row: r.row,
                name: (0, $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2)(r, views.get(r.key)),
                region: r.region
            })), [
        rows,
        views
    ]);
    const registerValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, el)=>{
        if (el) valueRefs.current.set(key, el);
        else valueRefs.current.delete(key);
    }, []);
    const revealSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!sourceVisible) onSourceVisibleChange?.(true);
        else if (isMobile) sourceRef.current?.scrollIntoView?.({
            block: 'start',
            behavior: 'smooth'
        });
    }, [
        sourceVisible,
        onSourceVisibleChange,
        isMobile
    ]);
    const activate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, source = 'table', options = {})=>{
        setActive((prev)=>prev.key === key && prev.source === source ? prev : {
                key: key,
                source: source
            });
        if (options.reveal) revealSource();
    }, [
        revealSource
    ]);
    const focusValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        const el = valueRefs.current.get(key);
        if (!el) return;
        el.scrollIntoView?.({
            block: 'center'
        });
        el.focus();
        el.select?.();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            focusRow: (key)=>{
                activate(key, 'table');
                focusValue(key);
            }
        }), [
        activate,
        focusValue
    ]);
    // A phone opens the image above the results; bring it into view when it opens.
    const wasVisible = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(sourceVisible);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isMobile && sourceVisible && !wasVisible.current) sourceRef.current?.scrollIntoView?.({
            block: 'start',
            behavior: 'smooth'
        });
        wasVisible.current = sourceVisible;
    }, [
        isMobile,
        sourceVisible
    ]);
    const update = (key, patch)=>onRowsChange(rows.map((r)=>r.key === key ? {
                ...r,
                ...patch
            } : r));
    const revert = (key)=>{
        const row = rows.find((r)=>r.key === key);
        if (row) update(key, {
            value: row.ocrValue ?? ''
        });
        focusValue(key);
    };
    const pickTest = (key, testKey)=>update(key, {
            testKey: testKey || ''
        });
    const remove = (key)=>onRowsChange(rows.filter((r)=>r.key !== key));
    const addRow = ()=>{
        const row = (0, $4bee6261c6e7da77$export$7eba22ca66154cf6)(rows);
        onRowsChange([
            ...rows,
            row
        ]);
        setActive({
            key: row.key,
            source: 'table'
        });
    };
    const onValueKeyDown = (key)=>(e)=>{
            if (![
                'ArrowDown',
                'ArrowUp',
                'Enter'
            ].includes(e.key) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return;
            const index = rows.findIndex((r)=>r.key === key);
            const next = rows[index + (e.key === 'ArrowUp' ? -1 : 1)];
            if (!next) return;
            e.preventDefault();
            focusValue(next.key);
        };
    const onImageActivate = (key)=>{
        setActive({
            key: key,
            source: 'image'
        });
        valueRefs.current.get(key)?.scrollIntoView?.({
            block: 'nearest'
        });
    };
    const actions = run?.recommendedActions || [];
    const diagnoses = run?.diagnoses || [];
    const medications = run?.medications || [];
    const listProps = {
        rows: rows,
        views: views,
        activeKey: active.key,
        onActivate: activate,
        onRowChange: update,
        onRevert: revert,
        onPickTest: pickTest,
        onRemove: remove,
        onValueKeyDown: onValueKeyDown,
        onEditValue: focusValue,
        registerValue: registerValue,
        catalogOptions: options,
        disabled: disabled
    };
    const basisNotes = ready ? [
        review.review.patientAgeYears == null ? t($52ac9b8dd4c1cc5a$var$k('adultAssumed')) : null,
        !review.review.patientSex ? t($52ac9b8dd4c1cc5a$var$k('sexUnknown')) : null
    ].filter(Boolean) : [];
    const results = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-labelledby": titleId,
        "data-testid": "lab-results-panel",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            minWidth: 0,
            minHeight: 0,
            overflowY: isMobile ? 'visible' : 'auto',
            paddingInlineEnd: isMobile ? 0 : '0.25rem',
            overscrollBehavior: 'contain'
        }
    }, notices, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t('patient.files.extract.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: documentDate,
        onChange: onDocumentDateChange,
        disableFuture: true,
        disabled: disabled,
        placeholder: t('patient.files.upload.datePlaceholder')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        id: titleId,
        style: {
            margin: 0,
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t($52ac9b8dd4c1cc5a$var$k('tableTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "lab-standard-info",
        style: {
            margin: 0,
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0,
            marginTop: '0.25rem'
        }
    }), t($52ac9b8dd4c1cc5a$var$k('standardInfo'))), basisNotes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "lab-basis-notes"
    }, basisNotes.join(' '))), review.status === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t($52ac9b8dd4c1cc5a$var$k('loadingReferences')),
        "data-testid": "lab-review-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTable), {
        rows: Math.min(Math.max(rows.length, 3), 8),
        columns: isMobile ? 2 : 6,
        dense: true
    })), review.status === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t($52ac9b8dd4c1cc5a$var$k('referencesFailed')),
        onRetry: review.retry
    })), ready && rows.length > 0 && (isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a4a7b67771311d8$export$2e2bcd8739ae039), listProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a64846894ac678ef$export$2e2bcd8739ae039), listProps)), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: addRow,
        disabled: disabled,
        "data-testid": "lab-add-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t($52ac9b8dd4c1cc5a$var$k('addRow'))), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "lab-only-value",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t($52ac9b8dd4c1cc5a$var$k('onlyValueEditable')))), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.actions', {
            count: actions.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            dir: "auto"
        }, a)))), (diagnoses.length > 0 || medications.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-opt-in",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.optInHint')), diagnoses.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            key: `dx-${i}`,
            checked: pickedDiagnoses.has(i),
            onChange: (checked)=>onPickDiagnosis(i, $52ac9b8dd4c1cc5a$var$checkedValue(checked)),
            label: t('patient.files.extract.diagnosisOption', {
                name: d
            }),
            disabled: disabled,
            "data-testid": `lab-dx-${i}`
        })), medications.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            key: `med-${i}`,
            checked: pickedMedications.has(i),
            onChange: (checked)=>onPickMedication(i, $52ac9b8dd4c1cc5a$var$checkedValue(checked)),
            label: t('patient.files.extract.medicationOption', {
                name: [
                    m.name,
                    m.dosage,
                    m.frequency
                ].filter(Boolean).join(' ')
            }),
            disabled: disabled,
            "data-testid": `lab-med-${i}`
        }))), run?.summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.readText')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'pre-wrap',
            lineHeight: 1.9
        }
    }, run.summaryText)), footnote);
    const source = sourceVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        ref: sourceRef,
        "aria-label": t($52ac9b8dd4c1cc5a$var$k('viewer.label')),
        "data-testid": "lab-source-panel",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem',
            minWidth: 0,
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ddefab495daaa435$export$2e2bcd8739ae039), {
        file: file,
        marks: marks,
        activeKey: active.key,
        activeSource: active.source,
        onActivate: onImageActivate,
        expanded: expanded,
        onToggleExpand: isMobile ? undefined : ()=>setExpanded((v)=>!v),
        height: isMobile ? '18rem' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($52ac9b8dd4c1cc5a$var$ExtractionInfo, null));
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review",
        "data-layout": "stack",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, source, results);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review",
        "data-layout": "split",
        "data-expanded": expanded || undefined,
        style: {
            display: 'grid',
            // The image sits at the inline start, the results at the end; ≈40 / 60, and
            // ≈60 / 40 while the image is expanded — but the results never narrower than
            // their six columns need, so expanding on a small workstation cannot push the
            // status out of sight.
            gridTemplateColumns: !sourceVisible ? 'minmax(0, 1fr)' : expanded ? 'minmax(0, 3fr) minmax(40rem, 2fr)' : 'minmax(0, 2fr) minmax(0, 3fr)',
            gap: '1rem',
            height: 'calc(100vh - 15rem)',
            minHeight: '26rem'
        }
    }, source, results);
});
var $52ac9b8dd4c1cc5a$export$2e2bcd8739ae039 = $52ac9b8dd4c1cc5a$var$LabResultExtraction;



var $acw62 = parcelRequire("acw62");



function $0a30962c2cbe3aeb$export$2e2bcd8739ae039({ patientId: patientId, run: run, enabled: enabled }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'idle',
        review: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || !patientId || !run) {
            setState({
                status: 'idle',
                review: null
            });
            return undefined;
        }
        let cancelled = false;
        const rows = (0, $4bee6261c6e7da77$export$725f4e3b103b8ffd)(run);
        setState({
            status: 'loading',
            review: null
        });
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$dfd091d72822b70), {
            patientId: patientId,
            items: (0, $4bee6261c6e7da77$export$9402c7d9ee327bb9)(rows)
        }).then((d)=>{
            if (cancelled) return;
            if (!d?.labReview) {
                setState({
                    status: 'error',
                    review: null
                });
                return;
            }
            setState({
                status: 'ready',
                review: (0, $4bee6261c6e7da77$export$adc9098288f9ed0b)(d.labReview, rows)
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'error',
                review: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        patientId,
        run,
        attempt
    ]);
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setAttempt((n)=>n + 1), []);
    return {
        ...state,
        retry: retry
    };
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $8g4t5 = parcelRequire("8g4t5");
var $lpOUO = parcelRequire("lpOUO");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// A medical / imaging report read off a document, as the doctor proofreads it against
// the scan beside it. docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.8, §5.3.
//
// Sections keep the heading AS PRINTED (`title`) beside a closed `key`, so the doctor's
// panel can label a section in its own language without translating the report. With
// no sections the whole text is one field — a report the model could not split is
// still a report.
//
// The same editor carries a handwritten note's sections (history / exam / assessment /
// plan) and a medical record's: `sectionKeys` is the closed set for the document at
// hand, and `showMeta` hides the modality/body-region/date row a note does not have.
let $9dde797c4c39f144$var$sectionSeq = 0;
function $9dde797c4c39f144$export$3e4b15c08f658203(key = 'findings') {
    $9dde797c4c39f144$var$sectionSeq += 1;
    return {
        id: `section-${$9dde797c4c39f144$var$sectionSeq}`,
        key: key,
        title: '',
        text: ''
    };
}
function $9dde797c4c39f144$export$db22bbf0b0807335(sections, keys = (0, $157d5bd48cfffbad$export$4c32b942640c490c)) {
    return (sections || []).map((s)=>({
            ...$9dde797c4c39f144$export$3e4b15c08f658203(keys.includes(s.key) ? s.key : 'other'),
            title: s.title || '',
            text: s.text || ''
        }));
}
function $9dde797c4c39f144$export$30d31e5015655e10(run, file, appointmentId) {
    const r = run?.report || {};
    return {
        sections: $9dde797c4c39f144$export$db22bbf0b0807335(r.sections),
        fullText: r.fullText || run?.summaryText || '',
        modality: r.modality || '',
        bodyRegion: r.bodyRegion || '',
        reportDate: r.reportDate || file?.documentDate || '',
        alsoNote: Boolean(appointmentId)
    };
}
function $9dde797c4c39f144$export$4d7a379d161f67c1(draft) {
    const fromSections = draft.sections.map((s)=>s.text.trim()).filter(Boolean).join('\n\n');
    return fromSections || draft.fullText.trim();
}
function $9dde797c4c39f144$export$119b361f471fb70e(draft) {
    return {
        fullText: $9dde797c4c39f144$export$4d7a379d161f67c1(draft),
        sections: draft.sections.filter((s)=>s.text.trim()).map((s)=>({
                key: s.key,
                title: s.title || null,
                text: s.text.trim()
            })),
        modality: draft.modality || null,
        bodyRegion: draft.bodyRegion || null,
        reportDate: draft.reportDate || null
    };
}
function $9dde797c4c39f144$export$2e2bcd8739ae039({ draft: draft, onChange: onChange, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false, sectionKeys: sectionKeys = (0, $157d5bd48cfffbad$export$4c32b942640c490c), showMeta: showMeta = true, testid: testid = 'report-sections-editor' }) {
    const { t: t } = (0, $LNQP4.default)();
    const set = (patch)=>onChange({
            ...draft,
            ...patch
        });
    const setSection = (id, patch)=>set({
            sections: draft.sections.map((s)=>s.id === id ? {
                    ...s,
                    ...patch
                } : s)
        });
    const keyOptions = sectionKeys.map((k)=>({
            value: k,
            label: t(`patient.files.sections.${k}`)
        }));
    const modalityOptions = (0, $157d5bd48cfffbad$export$918e760d3bce1cbe).map((m)=>({
            value: m,
            label: t(`patient.files.modality.${m}`)
        }));
    const firstKey = sectionKeys[0] === 'clinical_info' ? 'findings' : sectionKeys[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, showMeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: compact ? '1fr' : 'repeat(3, minmax(0, 1fr))',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.extract.modality'),
        value: draft.modality,
        onChange: (e)=>set({
                modality: e.target.value
            }),
        options: modalityOptions,
        placeholder: t('patient.files.extract.notStated'),
        disabled: disabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.files.extract.bodyRegion'),
        value: draft.bodyRegion,
        onChange: (v)=>set({
                bodyRegion: typeof v === 'string' ? v : v?.target?.value ?? ''
            }),
        dir: "auto",
        disabled: disabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.extract.reportDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.reportDate,
        onChange: (v)=>set({
                reportDate: v
            }),
        disableFuture: true,
        disabled: disabled,
        placeholder: t('patient.files.upload.datePlaceholder')
    }))), draft.sections.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.extract.fullText'),
        value: draft.fullText,
        onChange: (e)=>set({
                fullText: e.target.value
            }),
        rows: compact ? 8 : 12,
        dir: "auto",
        disabled: disabled,
        "data-testid": "report-full-text"
    }) : draft.sections.map((s, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: s.id,
            "data-testid": "report-section",
            "data-key": s.key,
            style: {
                borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                padding: '0.625rem 0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'flex-end',
                flexWrap: compact ? 'wrap' : 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                minWidth: '9rem',
                flex: compact ? '1 1 100%' : '0 0 11rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            label: t('patient.files.extract.sectionKey'),
            value: s.key,
            onChange: (e)=>setSection(s.id, {
                    key: e.target.value
                }),
            options: keyOptions,
            placeholder: "",
            disabled: disabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.sectionTitle'),
            value: s.title,
            onChange: (v)=>setSection(s.id, {
                    title: typeof v === 'string' ? v : v?.target?.value ?? ''
                }),
            dir: "auto",
            disabled: disabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            onClick: ()=>set({
                    sections: draft.sections.filter((x)=>x.id !== s.id)
                }),
            "aria-label": t('patient.files.extract.removeSection', {
                index: index + 1
            }),
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
            "aria-label": t('patient.files.extract.sectionText'),
            value: s.text,
            onChange: (e)=>setSection(s.id, {
                    text: e.target.value
                }),
            rows: 4,
            dir: "auto",
            disabled: disabled
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>set({
                sections: [
                    ...draft.sections,
                    $9dde797c4c39f144$export$3e4b15c08f658203(draft.sections.length ? 'other' : firstKey)
                ]
            }),
        disabled: disabled,
        "data-testid": "report-add-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.addSection'))), canWriteNote && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: draft.alsoNote,
        onChange: (checked)=>set({
                alsoNote: typeof checked === 'boolean' ? checked : Boolean(checked?.target?.checked)
            }),
        label: t('patient.files.extract.alsoNote'),
        disabled: disabled,
        "data-testid": "report-also-note"
    }));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $fAR2n = parcelRequire("fAR2n");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $huNwV = parcelRequire("huNwV");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");
var $lpOUO = parcelRequire("lpOUO");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




// A prescription read off a document — one row per drug line, as the doctor checks it
// before it enters the patient's MEDICATION HISTORY (never the visit's نسخه: §23.3 A13,
// §24.8). DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §9.5, §10.6 E23.
//
// Copying a line into the visit's نسخه is a separate, explicit per-row act —
// «افزودن به نسخه ویزیت» — offered only when the host passes `visitRx` (a Visit page
// with an editable prescription). It fills the visit's drug form; it saves nothing.
//
// Each line names the drug AS WRITTEN and offers the formulary's closest candidates;
// the model pre-selects one only when both the match and the reading were confident.
// A line the model could not verify starts unticked. A drug name with an illegible
// mark cannot be recorded until the doctor picks a formulary drug or corrects the text.
let $8f52a74ebbd4d691$var$seq = 0;
const $8f52a74ebbd4d691$var$FIELDS = [
    'strength',
    'form',
    'dose',
    'frequency',
    'route',
    'duration',
    'quantity'
];
function $8f52a74ebbd4d691$export$795b12f8cb8a81c7(items, { selectByDefault: selectByDefault = true } = {}) {
    return (items || []).map((it, index)=>{
        $8f52a74ebbd4d691$var$seq += 1;
        return {
            key: `rx-${$8f52a74ebbd4d691$var$seq}`,
            index: index,
            selected: selectByDefault ? it.verified !== false : false,
            drugText: it.drugText || '',
            drugId: it.selectedDrugId || '',
            strength: it.strength || '',
            form: it.form || '',
            dose: it.dose || '',
            frequency: it.frequency || '',
            frequencyCode: it.frequencyCode || '',
            route: it.route || '',
            duration: it.duration || '',
            quantity: it.quantity || '',
            instructions: it.instructions || '',
            candidates: it.candidates || [],
            sourceText: it.sourceText || '',
            confidence: it.confidence ?? null,
            verified: it.verified ?? null,
            ai: true
        };
    });
}
function $8f52a74ebbd4d691$export$e71d71e9768ed106() {
    $8f52a74ebbd4d691$var$seq += 1;
    return {
        key: `rx-${$8f52a74ebbd4d691$var$seq}`,
        index: null,
        selected: true,
        drugText: '',
        drugId: '',
        strength: '',
        form: '',
        dose: '',
        frequency: '',
        frequencyCode: '',
        route: '',
        duration: '',
        quantity: '',
        instructions: '',
        candidates: [],
        sourceText: '',
        confidence: null,
        verified: null,
        ai: false
    };
}
function $8f52a74ebbd4d691$export$2670ff772f77e35(row) {
    if (!row.selected) return null;
    if (!row.drugText.trim() && !row.drugId) return 'patient.files.extract.rx.needsDrug';
    if ((0, $157d5bd48cfffbad$export$d66c76d9d0c49c6f)(row.drugText) && !row.drugId) return 'patient.files.extract.rx.illegibleDrug';
    return null;
}
const $8f52a74ebbd4d691$export$87efde12b0cfb4b2 = (rows)=>rows.some((r)=>r.selected) && rows.every((r)=>!$8f52a74ebbd4d691$export$2670ff772f77e35(r));
function $8f52a74ebbd4d691$export$746c205fdeed75ed(rows) {
    const blank = (v)=>v && String(v).trim() ? String(v).trim() : null;
    return rows.filter((r)=>r.selected).map((r)=>{
        const candidate = r.candidates.find((c)=>c.drugId === r.drugId);
        return {
            drugText: r.drugText.trim() || candidate?.name || '',
            drugId: r.drugId || null,
            strength: blank(r.strength),
            form: blank(r.form),
            dose: blank(r.dose),
            frequency: blank(r.frequency),
            frequencyCode: blank(r.frequencyCode),
            route: blank(r.route),
            duration: blank(r.duration),
            quantity: blank(r.quantity),
            instructions: blank(r.instructions)
        };
    });
}
const $8f52a74ebbd4d691$var$inputValue = (v)=>typeof v === 'string' ? v : v?.target?.value ?? '';
function $8f52a74ebbd4d691$export$2e2bcd8739ae039({ rows: rows, onRowsChange: onRowsChange, flags: flags, flagPrefix: flagPrefix = 'prescription.items', compact: compact = false, disabled: disabled = false, testid: testid = 'rx-editor', visitRx: visitRx = null, recordable: recordable = true }) {
    const { t: t, formatPercent: formatPercent } = (0, $LNQP4.default)();
    const patchRow = (key, patch)=>onRowsChange(rows.map((r)=>r.key === key ? {
                ...r,
                ...patch,
                ai: false
            } : r));
    const remove = (key)=>onRowsChange(rows.filter((r)=>r.key !== key));
    const candidateLabel = (c)=>{
        const name = [
            c.name,
            c.strength,
            c.form
        ].filter(Boolean).join(' ');
        // `score` is 0..1; formatPercent takes a percentage.
        return Number.isFinite(Number(c.score)) ? t('patient.files.extract.rx.candidate', {
            name: name,
            score: formatPercent(Math.round(Number(c.score) * 100))
        }) : name;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, rows.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testid}-empty`
    }, t('patient.files.extract.rx.empty')), rows.map((row)=>{
        const problem = $8f52a74ebbd4d691$export$2670ff772f77e35(row);
        const itemFlags = row.index == null ? [] : (0, $157d5bd48cfffbad$export$ce70ae537f7b403c)(flags, `${flagPrefix}[${row.index}]`);
        const options = [
            {
                value: '',
                label: t('patient.files.extract.rx.asWritten')
            },
            ...row.candidates.map((c)=>({
                    value: c.drugId,
                    label: candidateLabel(c)
                }))
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.key,
            "data-testid": `${testid}-row`,
            "data-selected": row.selected,
            "data-ready": !problem,
            style: {
                borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                border: `1px solid ${problem ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).border}`,
                background: row.ai ? (0, $9d2aabecd4883b7c$export$db8ce6b495f12ddc)(row) : 'transparent',
                padding: '0.625rem 0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                opacity: row.selected ? 1 : 0.8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                flexWrap: 'wrap'
            }
        }, recordable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: row.selected,
            onChange: (v)=>onRowsChange(rows.map((r)=>r.key === row.key ? {
                        ...r,
                        selected: typeof v === 'boolean' ? v : Boolean(v?.target?.checked)
                    } : r)),
            label: t('patient.files.extract.rx.record'),
            disabled: disabled,
            "data-testid": `${testid}-select-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                gap: '0.25rem',
                flexWrap: 'wrap',
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$2e9eab6b9d145d15), {
            item: row,
            testid: `${testid}-${row.key}`
        })), visitRx && (()=>{
            const state = visitRx.added?.get(row.key) || null;
            const blocked = Boolean((0, $622fea85856450c1$export$f9bb0cd25dab9659)(row));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: state ? 'subtle' : 'outline',
                size: "sm",
                className: `gap-1.5${compact ? ' min-h-11' : ''}`,
                onClick: ()=>visitRx.onAdd(row),
                disabled: Boolean(state) || blocked || Boolean(visitRx.disabled),
                "data-state": state || (blocked ? 'blocked' : 'ready'),
                "data-testid": `${testid}-add-visit-${row.key}`
            }, state ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                size: 14,
                "aria-hidden": true
            }), " ", t(state === 'already' ? 'patient.files.extract.rx.alreadyInVisit' : 'patient.files.extract.rx.addedToVisit')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                size: 14,
                "aria-hidden": true
            }), " ", t('patient.files.extract.rx.addToVisit')));
        })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: compact ? 'h-11 w-11' : 'h-9 w-9',
            onClick: ()=>remove(row.key),
            "aria-label": t('patient.files.extract.removeRow'),
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: compact ? '1fr' : 'minmax(0, 1fr) minmax(0, 1fr)',
                gap: '0.5rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.rx.drugText'),
            value: row.drugText,
            onChange: (v)=>patchRow(row.key, {
                    drugText: $8f52a74ebbd4d691$var$inputValue(v)
                }),
            dir: "auto",
            disabled: disabled,
            "data-testid": `${testid}-drug-text-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            label: t('patient.files.extract.rx.formulary'),
            value: row.drugId,
            onChange: (e)=>patchRow(row.key, {
                    drugId: e.target.value
                }),
            options: options,
            placeholder: "",
            disabled: disabled,
            "data-testid": `${testid}-drug-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: compact ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
                gap: '0.5rem 0.75rem'
            }
        }, $8f52a74ebbd4d691$var$FIELDS.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
                key: f,
                label: t(`patient.files.extract.rx.${f}`),
                value: row[f],
                onChange: (v)=>patchRow(row.key, {
                        [f]: $8f52a74ebbd4d691$var$inputValue(v),
                        ...f === 'frequency' ? {
                            frequencyCode: ''
                        } : {}
                    }),
                dir: "auto",
                disabled: disabled,
                "data-testid": `${testid}-${f}-${row.key}`
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.rx.instructions'),
            value: row.instructions,
            onChange: (v)=>patchRow(row.key, {
                    instructions: $8f52a74ebbd4d691$var$inputValue(v)
                }),
            dir: "auto",
            disabled: disabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$d01dc4a28d149339), {
            text: row.sourceText,
            testid: `${testid}-source-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$1c49e2087a373b64), {
            flags: itemFlags,
            testid: `${testid}-flags-${row.key}`
        }), problem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testid}-problem-${row.key}`,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.CT).warnInk
            }
        }, t(problem)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onRowsChange([
                ...rows,
                $8f52a74ebbd4d691$export$e71d71e9768ed106()
            ]),
        disabled: disabled,
        "data-testid": `${testid}-add`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.rx.add'))));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $gr49X = parcelRequire("gr49X");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



function $03ea67e3552fde0c$export$e23fc6f95352710c(note, file, appointmentId) {
    return {
        lines: (note?.lines || []).map((l, i)=>({
                key: `line-${i}`,
                text: l.text || '',
                confidence: l.confidence ?? null
            })),
        report: {
            sections: (0, $9dde797c4c39f144$export$db22bbf0b0807335)(note?.sections, (0, $157d5bd48cfffbad$export$48ad29fa49c5e125)),
            fullText: note?.transcript || (note?.lines || []).map((l)=>l.text).join('\n'),
            modality: '',
            bodyRegion: '',
            reportDate: file?.documentDate || '',
            alsoNote: Boolean(appointmentId)
        },
        opened: []
    };
}
const $03ea67e3552fde0c$export$a6af00b81fcce69b = (draft)=>draft.lines.filter((l)=>(0, $157d5bd48cfffbad$export$d66c76d9d0c49c6f)(l.text));
function $03ea67e3552fde0c$export$a979aee123e1947c(draft, legibility) {
    if (!(0, $9dde797c4c39f144$export$4d7a379d161f67c1)(draft.report) && !draft.lines.some((l)=>l.text.trim())) return false;
    if (String(legibility || '').toLowerCase() !== 'poor') return true;
    return $03ea67e3552fde0c$export$a6af00b81fcce69b(draft).every((l)=>draft.opened.includes(l.key));
}
function $03ea67e3552fde0c$export$e02b4268ba84d59b(draft) {
    return (0, $9dde797c4c39f144$export$4d7a379d161f67c1)(draft.report) || draft.lines.map((l)=>l.text.trim()).filter(Boolean).join('\n');
}
function $03ea67e3552fde0c$var$MarkedText({ text: text }) {
    const parts = String(text).split(/(\[\?\])/);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate'
        }
    }, parts.map((p, i)=>p === '[?]' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("mark", {
            key: i,
            "data-illegible": true,
            style: {
                background: (0, $jTCZr.CT).warnSoft,
                color: (0, $jTCZr.CT).warnInk,
                borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
                padding: '0 0.125rem'
            }
        }, p) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, p)));
}
function $03ea67e3552fde0c$export$2e2bcd8739ae039({ draft: draft, onChange: onChange, legibility: legibility, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const poor = String(legibility || '').toLowerCase() === 'poor';
    const marked = $03ea67e3552fde0c$export$a6af00b81fcce69b(draft);
    const unopened = marked.filter((l)=>!draft.opened.includes(l.key)).length;
    const setLine = (key, text)=>onChange({
            ...draft,
            lines: draft.lines.map((l)=>l.key === key ? {
                    ...l,
                    text: text
                } : l)
        });
    const open = (key)=>{
        if (!draft.opened.includes(key)) onChange({
            ...draft,
            opened: [
                ...draft.opened,
                key
            ]
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "note-lines-editor",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, poor && unopened > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "note-open-required"
    }, t('patient.files.extract.note.openRequired', {
        count: formatNumber(unopened)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.note.lines', {
            count: formatNumber(draft.lines.length)
        }),
        defaultOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        "data-testid": "note-lines",
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, draft.lines.map((line)=>{
        const isMarked = (0, $157d5bd48cfffbad$export$d66c76d9d0c49c6f)(line.text);
        const isOpen = draft.opened.includes(line.key);
        const lowConfidence = line.confidence != null && line.confidence < (0, $157d5bd48cfffbad$export$8e824c3a51e639a1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: line.key,
            "data-testid": `note-line-${line.key}`,
            "data-marked": isMarked || undefined,
            "data-opened": isOpen || undefined,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
                padding: '0.25rem 0.375rem',
                background: isMarked || lowConfidence ? (0, $jTCZr.CT).warnSoft : 'transparent',
                fontSize: '0.8125rem'
            }
        }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            "aria-label": t('patient.files.extract.note.lineText'),
            value: line.text,
            onChange: (v)=>setLine(line.key, typeof v === 'string' ? v : v?.target?.value ?? ''),
            dir: "auto",
            disabled: disabled,
            "data-testid": `note-line-input-${line.key}`
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                color: (0, $jTCZr.CT).ink,
                lineHeight: 1.9
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($03ea67e3552fde0c$var$MarkedText, {
            text: line.text
        })), !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isMarked ? 'outline' : 'ghost',
            size: "sm",
            className: compact ? 'min-h-11 gap-1' : 'gap-1',
            onClick: ()=>open(line.key),
            disabled: disabled,
            "data-testid": `note-line-open-${line.key}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gr49X.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t(isMarked ? 'patient.files.extract.note.review' : 'patient.files.extract.note.edit')));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dde797c4c39f144$export$2e2bcd8739ae039), {
        draft: draft.report,
        onChange: (report)=>onChange({
                ...draft,
                report: report
            }),
        canWriteNote: canWriteNote,
        compact: compact,
        disabled: disabled,
        sectionKeys: (0, $157d5bd48cfffbad$export$48ad29fa49c5e125),
        showMeta: false,
        testid: "note-sections-editor"
    }));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $9gEOi = parcelRequire("9gEOi");
var $lxEfx = parcelRequire("lxEfx");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");





const $48e3b9f1b8c2cc26$export$5989ba6500cbc848 = Object.freeze([
    ...new Set([
        ...(0, $157d5bd48cfffbad$export$4c32b942640c490c),
        ...(0, $157d5bd48cfffbad$export$48ad29fa49c5e125)
    ])
]);
function $48e3b9f1b8c2cc26$export$1a4e5ae4f93ae22(record, file, appointmentId) {
    return {
        report: {
            sections: (0, $9dde797c4c39f144$export$db22bbf0b0807335)(record?.sections, $48e3b9f1b8c2cc26$export$5989ba6500cbc848),
            fullText: record?.fullText || '',
            modality: '',
            bodyRegion: '',
            reportDate: record?.dischargeDate || record?.admissionDate || file?.documentDate || '',
            alsoNote: Boolean(appointmentId)
        },
        pickedDiagnoses: [],
        includeMedications: false,
        medications: (0, $8f52a74ebbd4d691$export$795b12f8cb8a81c7)(record?.medications, {
            selectByDefault: false
        })
    };
}
function $48e3b9f1b8c2cc26$export$2e2bcd8739ae039({ record: record, draft: draft, onChange: onChange, flags: flags, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false, visitRx: visitRx = null }) {
    const { t: t, has: has, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const set = (patch)=>onChange({
            ...draft,
            ...patch
        });
    const diagnoses = record?.diagnoses || [];
    const procedures = record?.procedures || [];
    const typeKey = record?.recordType ? `patient.files.extract.record.types.${record.recordType}` : null;
    const facts = [
        [
            'recordType',
            typeKey ? has(typeKey) ? t(typeKey) : record.recordType : ''
        ],
        [
            'facility',
            record?.facility || ''
        ],
        [
            'admissionDate',
            record?.admissionDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(record.admissionDate, formatDate) : ''
        ],
        [
            'dischargeDate',
            record?.dischargeDate ? (0, $b2efaf4152cb92eb$export$7dee33e761ba98a6)(record.dischargeDate, formatDate) : ''
        ],
        [
            'followUp',
            record?.followUp || ''
        ]
    ].filter(([, v])=>v);
    const toggleDx = (i, checked)=>set({
            pickedDiagnoses: checked ? [
                ...new Set([
                    ...draft.pickedDiagnoses,
                    i
                ])
            ] : draft.pickedDiagnoses.filter((x)=>x !== i)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "medical-record-editor",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, facts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
        "data-testid": "record-facts",
        style: {
            margin: 0,
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '0.25rem 0.75rem',
            fontSize: '0.75rem'
        }
    }, facts.map(([k, v])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: k
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t(`patient.files.extract.record.${k}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0,
                color: (0, $jTCZr.CT).ink
            },
            dir: "auto"
        }, v)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dde797c4c39f144$export$2e2bcd8739ae039), {
        draft: draft.report,
        onChange: (report)=>set({
                report: report
            }),
        canWriteNote: canWriteNote,
        compact: compact,
        disabled: disabled,
        sectionKeys: $48e3b9f1b8c2cc26$export$5989ba6500cbc848,
        showMeta: false,
        testid: "record-sections-editor"
    }), procedures.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.record.procedures')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": "record-procedures",
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, procedures.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            dir: "auto"
        }, p.text, p.date ? ` \u{2014} ${p.date}` : '')))), diagnoses.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "record-diagnoses",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.record.diagnosesHint')), diagnoses.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: draft.pickedDiagnoses.includes(i),
            onChange: (v)=>toggleDx(i, typeof v === 'boolean' ? v : Boolean(v?.target?.checked)),
            label: t('patient.files.extract.diagnosisOption', {
                name: d.icd10Hint ? `${d.text} (${d.icd10Hint})` : d.text
            }),
            disabled: disabled,
            "data-testid": `record-dx-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$2e9eab6b9d145d15), {
            item: d,
            testid: `record-dx-${i}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$d01dc4a28d149339), {
            text: d.sourceText,
            testid: `record-dx-source-${i}`
        })))), draft.medications.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: draft.includeMedications,
        onChange: (v)=>set({
                includeMedications: typeof v === 'boolean' ? v : Boolean(v?.target?.checked)
            }),
        label: t('patient.files.extract.record.includeMedications', {
            count: formatNumber(draft.medications.length)
        }),
        disabled: disabled,
        "data-testid": "record-include-meds"
    }), (draft.includeMedications || visitRx) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f52a74ebbd4d691$export$2e2bcd8739ae039), {
        rows: draft.medications,
        onRowsChange: (medications)=>set({
                medications: medications
            }),
        flags: flags,
        flagPrefix: "record.medications",
        compact: compact,
        disabled: disabled,
        testid: "record-meds",
        visitRx: visitRx,
        recordable: draft.includeMedications
    })));
}





// «استخراج هوشمند» — a model decides what a stored document IS, reads it the way that
// kind of document is read, and the doctor decides what of it enters the record.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §6.2–§6.4, §7.7–§7.8, §8.5;
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §9, §10.4, §24.1 (R-A3, R-A4, R-P1), §24.7.
//
// The rules the overlay is built around:
//
//  1. It spends پارسه only on an explicit press (DESIGN_CONCEPT §13.4). Opening it from
//     «استخراج» IS that press, and the price is on the button that opened it; opening it
//     from «بازبینی» shows a stored run and costs nothing. «استخراج مجدد» and «تغییر روش
//     استخراج» say their price before they run. The price is the policy's
//     (AnalyzeClinicalFile), one per run whatever the class.
//  2. Nothing enters the record until «ثبت در پرونده». The run is a reading of a
//     document, labelled «پیشنهاد هوش مصنوعی» until a clinician saves it (§13.3).
//  3. A failed, illegible or not-medical run says nothing was charged, and the manual
//     path is never blocked.
//  4. The class is decided AFTER the run (R-A4): a chip says what the model thought the
//     document is and how sure it was; «تغییر نوع» corrects the file's kind and «تغییر
//     روش استخراج» reads it again as another class. There is no mid-run pause.
//  5. There is no progress signal, so the running state says one honest sentence
//     (R-P1), not timed stages.
//  6. A drug line never enters the visit's نسخه by itself (§23.3 A13). With the
//     host's `onAddToVisitPrescription` capability (a Visit page) each line offers
//     «افزودن به نسخه ویزیت», which fills the visit's drug form and saves nothing;
//     an unverified or low-confidence line asks first, and a line goes once per review.
//  7. A LAB sheet is reviewed as raw OCR beside its image (docs/lab_results_ocr_wireframe_ai_agent.md):
//     the model supplies each row's name and value, the catalogue supplies the unit,
//     reference range and status for this patient (`labReview`), only the value is
//     editable, and «ثبت و ادامه» first stops on values it cannot record, then asks
//     about doubtful rows, then records and closes.
const $a73dbad6d1e43f27$var$PHASE = {
    CHOOSE: 'choose',
    RUNNING: 'running',
    READY: 'ready',
    ERROR: 'error'
};
// Legacy modes keep their existing titles.
const $a73dbad6d1e43f27$var$TITLE_KEY = {
    LAB_RESULTS: 'patient.files.extract.lab',
    REPORT: 'patient.files.extract.report',
    PRESCRIPTION: 'patient.files.extract.modeTitle.PRESCRIPTION',
    NOTE: 'patient.files.extract.modeTitle.NOTE',
    RECORD: 'patient.files.extract.modeTitle.RECORD',
    NOT_MEDICAL: 'patient.files.extract.modeTitle.NOT_MEDICAL'
};
// The lab review wants the room of a near-full-screen modal on a workstation (§3); the
// kit's widest dialog is 52rem, and the dialog merges a caller's class last.
const $a73dbad6d1e43f27$var$LAB_DIALOG_CLASS = 'max-w-[min(96rem,calc(100vw-2rem))]';
function $a73dbad6d1e43f27$var$RunningSkeleton({ isMobile: isMobile }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-running-label",
        "aria-live": "polite",
        style: {
            margin: 0,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.extract.runningDetect')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.extract.runningDetect'),
        "data-testid": "extract-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 5fr) minmax(0, 6fr)',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: isMobile ? 160 : 420,
        radius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTable), {
        rows: 6,
        columns: isMobile ? 2 : 5,
        dense: true
    }))));
}
/** «تشخیص: نسخه · اطمینان زیاد» */ function $a73dbad6d1e43f27$var$ClassChip({ run: run }) {
    const { t: t } = (0, $LNQP4.default)();
    const key = (0, $157d5bd48cfffbad$export$f6b40a7b264b3557)(run?.documentClass);
    if (!key) return null;
    const bucket = (0, $157d5bd48cfffbad$export$e0b123b1c38f1e9c)(run.classConfidence);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "accent",
        "data-testid": "extract-class",
        "data-class": run.documentClass,
        "data-source": run.classSource || undefined
    }, bucket ? t('patient.files.extract.classChip', {
        class: t(key),
        confidence: t(`patient.files.extract.confidence.${bucket}`)
    }) : t('patient.files.extract.classChipNoConfidence', {
        class: t(key)
    }));
}
function $a73dbad6d1e43f27$export$2e2bcd8739ae039({ open: open, file: file, patientId: patientId, appointmentId: appointmentId, initialRun: initialRun, initialMode: initialMode, onClose: onClose, onRan: onRan, onSaved: onSaved, onAddToVisitPrescription: onAddToVisitPrescription = null }) {
    const { t: t, has: has, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const navigate = (0, $aa19facd75e3670a$export$5b61ff3425c1c197)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    // «افزایش اعتبار» on a refused run only where this deployment sells credit (PM-0211).
    const { costOf: costOf, purchaseAvailable: purchaseAvailable } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const price = costOf('ANALYZE_FILE');
    const kind = (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(file?.kind);
    const needsChoice = !kind || kind === 'OTHER';
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($a73dbad6d1e43f27$var$PHASE.RUNNING);
    const [chosenClass, setChosenClass] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('AUTO');
    const [run, setRun] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { kind: 'credit'|'inflight'|'illegible'|'failed', text }
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [pickedDx, setPickedDx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [pickedMeds, setPickedMeds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [documentDate, setDocumentDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [report, setReport] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [rxRows, setRxRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [record, setRecord] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saved, setSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { text, tone }
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false); // false | 'close' | 'leave'
    const [confirmRerun, setConfirmRerun] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { classOverride } | null
    // «افزودن به نسخه ویزیت», per row key: 'added' | 'already'. Held for this review only.
    const [visitAdds, setVisitAdds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Map());
    const [confirmVisitAdd, setConfirmVisitAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the row awaiting «افزودن؟»
    const [methodMenu, setMethodMenu] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [kindState, setKindState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        saving: false,
        done: false,
        error: ''
    });
    // The lab review: the image panel (open beside the table on a workstation, on demand
    // on a phone), rows «ثبت و ادامه» was stopped on, and doubtful rows awaiting «ادامه؟».
    const [labSourceVisible, setLabSourceVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>!isMobile);
    const [labBlocked, setLabBlocked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [confirmSuspicious, setConfirmSuspicious] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // rows | null
    const labContinuing = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const labPanelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const methodRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const adoptRun = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((r)=>{
        setRun(r);
        setRows((0, $4bee6261c6e7da77$export$725f4e3b103b8ffd)(r));
        setPickedDx(new Set());
        setPickedMeds(new Set());
        setDocumentDate(r?.detectedDocumentDate || file?.documentDate || '');
        setReport((0, $9dde797c4c39f144$export$30d31e5015655e10)(r, file, appointmentId));
        setRxRows((0, $8f52a74ebbd4d691$export$795b12f8cb8a81c7)(r?.prescription?.items));
        setNote((0, $03ea67e3552fde0c$export$e23fc6f95352710c)(r?.note, file, appointmentId));
        setRecord((0, $48e3b9f1b8c2cc26$export$1a4e5ae4f93ae22)(r?.record, file, appointmentId));
        setTouched(false);
        setSaved(null);
        setSaveError('');
        setKindState({
            saving: false,
            done: false,
            error: ''
        });
        setVisitAdds(new Map());
        setConfirmVisitAdd(null);
        setLabBlocked(false);
        setConfirmSuspicious(null);
    }, [
        file,
        appointmentId
    ]);
    const extract = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ mode: mode = 'AUTO', classOverride: classOverride = null } = {})=>{
        if (!file?.id) return;
        setPhase($a73dbad6d1e43f27$var$PHASE.RUNNING);
        setError(null);
        try {
            // The model reads a whole lab sheet: 30–40s is ORDINARY here, and the
            // default 30s budget aborted the fetch mid-run. The server finished anyway
            // and recorded a charged, successful extraction — so the doctor saw
            // «استخراج انجام نشد؛ هزینه‌ای کسر نشده است» over a run that HAD cost 10
            // پارسه, and was invited to spend 10 more retrying it. Measured on beta1
            // 2026-09-20: 35s and 37s for the same sheet, both reported as failures.
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$8e0c20a74feb40eb), {
                fileId: file.id,
                mode: mode,
                classOverride: classOverride
            }, {
                timeoutMs: (0, $adebb901af88e18b$export$5c63bf3ded5aa229)
            });
            const r = d?.extractClinicalFile || null;
            onRan?.(r);
            if (!r || r.status === 'failed') {
                const code = String(r?.errorCode || '').toUpperCase();
                setError({
                    kind: code === 'ILLEGIBLE' ? 'illegible' : 'failed',
                    text: code === 'ILLEGIBLE' ? t('patient.files.extract.illegible') : code === 'UNSUPPORTED' ? t('patient.files.extract.noBytes') : t('patient.files.extract.failed')
                });
                setPhase($a73dbad6d1e43f27$var$PHASE.ERROR);
                return;
            }
            adoptRun(r);
            setPhase($a73dbad6d1e43f27$var$PHASE.READY);
        } catch (e) {
            const code = e?.extensions?.code;
            setError({
                kind: code === 'INSUFFICIENT_CREDITS' ? 'credit' : code === 'ANALYSIS_IN_FLIGHT' ? 'inflight' : 'failed',
                text: code === 'INSUFFICIENT_CREDITS' ? t('patient.files.extract.credit') : code === 'ANALYSIS_IN_FLIGHT' ? t('patient.files.extract.inFlight') : (0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.extract.failed')
            });
            setPhase($a73dbad6d1e43f27$var$PHASE.ERROR);
        }
    }, [
        file?.id,
        adoptRun,
        onRan,
        t,
        has
    ]);
    // Opening the overlay is the press: run now — unless it was opened on a stored run
    // («بازبینی», free) or the document does not say what it is (the doctor may name it).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return;
        setConfirmDiscard(false);
        setConfirmRerun(null);
        if (initialRun) {
            adoptRun(initialRun);
            setPhase($a73dbad6d1e43f27$var$PHASE.READY);
            return;
        }
        if (needsChoice && !initialMode) {
            setRun(null);
            setChosenClass('AUTO');
            setPhase($a73dbad6d1e43f27$var$PHASE.CHOOSE);
            return;
        }
        extract({
            mode: initialMode || 'AUTO'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        file?.id
    ]);
    const notMedical = String(run?.errorCode || '').toUpperCase() === 'NOT_MEDICAL';
    const editorMode = notMedical ? 'NOT_MEDICAL' : run?.mode || 'REPORT';
    const labMode = phase === $a73dbad6d1e43f27$var$PHASE.READY && editorMode === 'LAB_RESULTS';
    const labReview = (0, $0a30962c2cbe3aeb$export$2e2bcd8739ae039)({
        patientId: patientId || file?.patientId,
        run: run,
        enabled: labMode
    });
    const labReady = labReview.status === 'ready';
    const labInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>labReady ? (0, $4bee6261c6e7da77$export$2ace0c9b49273a05)(rows, labReview.review) : [], [
        labReady,
        rows,
        labReview.review
    ]);
    const reportText = report ? (0, $9dde797c4c39f144$export$4d7a379d161f67c1)(report) : '';
    const legibility = run?.legibility || run?.note?.legibility || '';
    const recordReady = ()=>{
        if (!record) return false;
        const meds = record.includeMedications ? record.medications.filter((r)=>r.selected) : [];
        if (meds.some((r)=>(0, $8f52a74ebbd4d691$export$2670ff772f77e35)(r))) return false;
        return Boolean((0, $9dde797c4c39f144$export$4d7a379d161f67c1)(record.report)) || record.pickedDiagnoses.length > 0 || meds.length > 0;
    };
    const modeReady = {
        // Without the catalogue a lab value has no unit or status: nothing is recordable.
        LAB_RESULTS: ()=>labReady && (labInput.length > 0 || pickedDx.size > 0 || pickedMeds.size > 0),
        REPORT: ()=>Boolean(reportText),
        PRESCRIPTION: ()=>(0, $8f52a74ebbd4d691$export$87efde12b0cfb4b2)(rxRows),
        NOTE: ()=>Boolean(note) && (0, $03ea67e3552fde0c$export$a979aee123e1947c)(note, legibility),
        RECORD: recordReady,
        NOT_MEDICAL: ()=>false
    }[editorMode] || (()=>false);
    const nothingFound = phase === $a73dbad6d1e43f27$var$PHASE.READY && !notMedical && ({
        LAB_RESULTS: !rows.length && !run?.diagnoses?.length && !run?.medications?.length,
        REPORT: !reportText,
        PRESCRIPTION: !rxRows.length,
        NOTE: !note?.lines?.length && !(note && (0, $9dde797c4c39f144$export$4d7a379d161f67c1)(note.report)),
        RECORD: !(record && (0, $9dde797c4c39f144$export$4d7a379d161f67c1)(record.report)) && !run?.record?.diagnoses?.length
    })[editorMode];
    const canSave = phase === $a73dbad6d1e43f27$var$PHASE.READY && !saving && !saved && modeReady();
    const dirty = phase === $a73dbad6d1e43f27$var$PHASE.READY && !saved && touched;
    // How many ticked rows still cannot be recorded — live, so the notice leaves as the
    // doctor fixes them.
    const labBlockingCount = labMode && labBlocked && labReady ? (0, $4bee6261c6e7da77$export$b0c762580619fe10)(rows, labReview.review).blocking.length : 0;
    const requestClose = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard('close');
            return;
        }
        onClose?.();
    };
    // «رفتن به نسخه ویزیت» — the review closes for the page's drug form. An unsaved
    // history import is still guarded: leaving is not the same as discarding it silently.
    const leaveToVisitPrescription = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard('leave');
            return;
        }
        onClose?.({
            toVisitPrescription: true
        });
    };
    const commitVisitAdd = (row)=>{
        if (!onAddToVisitPrescription || visitAdds.has(row.key)) return;
        const outcome = onAddToVisitPrescription((0, $622fea85856450c1$export$304c866dced88570)(row));
        setVisitAdds((prev)=>new Map(prev).set(row.key, outcome === 'alreadyPrescribed' ? 'already' : 'added'));
    };
    const requestVisitAdd = (row)=>{
        if (visitAdds.has(row.key)) return;
        if ((0, $622fea85856450c1$export$af2260c3b4941e91)(row)) {
            setConfirmVisitAdd(row);
            return;
        }
        commitVisitAdd(row);
    };
    const visitRx = onAddToVisitPrescription ? {
        onAdd: requestVisitAdd,
        added: visitAdds,
        disabled: saving
    } : null;
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!canSave) return;
        setSaving(true);
        setSaveError('');
        const analysisId = run?.id || null;
        try {
            if (editorMode === 'REPORT' || editorMode === 'NOTE') {
                const draft = editorMode === 'NOTE' ? note.report : report;
                const base = (0, $9dde797c4c39f144$export$119b361f471fb70e)(draft);
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$12566aca247381aa), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        ...base,
                        fullText: editorMode === 'NOTE' ? (0, $03ea67e3552fde0c$export$e02b4268ba84d59b)(note) : base.fullText,
                        alsoNote: Boolean(appointmentId) && draft.alsoNote,
                        appointmentId: appointmentId || null
                    }
                });
                const noteMissed = Boolean(appointmentId) && draft.alsoNote && !d?.saveClinicalReport?.noteSaved;
                setSaved({
                    tone: noteMissed ? 'warning' : 'success',
                    text: t(noteMissed ? 'patient.files.extract.savedReportNoNote' : 'patient.files.extract.savedReport')
                });
                onSaved?.(d?.saveClinicalReport?.file || null);
            } else if (editorMode === 'PRESCRIPTION') {
                const items = (0, $8f52a74ebbd4d691$export$746c205fdeed75ed)(rxRows);
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$929a9aed56e6870c), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        items: items,
                        appointmentId: appointmentId || null
                    }
                });
                const r = d?.savePrescriptionExtraction;
                if (r?.failed > 0) {
                    setSaveError(t('patient.files.extract.savedPartial', {
                        saved: formatDigits(r.saved ?? 0),
                        total: formatDigits(items.length)
                    }));
                    if (r.saved > 0) onSaved?.(r.file || null);
                } else {
                    setSaved({
                        tone: 'success',
                        text: t('patient.files.extract.rx.saved', {
                            count: formatNumber(r?.saved ?? items.length)
                        })
                    });
                    onSaved?.(r?.file || null);
                }
            } else if (editorMode === 'RECORD') {
                const base = (0, $9dde797c4c39f144$export$119b361f471fb70e)(record.report);
                const dx = run?.record?.diagnoses || [];
                const meds = record.includeMedications ? (0, $8f52a74ebbd4d691$export$746c205fdeed75ed)(record.medications) : [];
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$56698d1fe562d38e), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        report: {
                            fileId: file.id,
                            analysisId: analysisId,
                            ...base,
                            alsoNote: Boolean(appointmentId) && record.report.alsoNote,
                            appointmentId: appointmentId || null
                        },
                        diagnoses: record.pickedDiagnoses.map((i)=>dx[i]).filter(Boolean).map((x)=>({
                                text: x.text,
                                icd10: x.icd10Hint || null
                            })),
                        medications: meds.length ? meds : null
                    }
                });
                const r = d?.saveMedicalRecordExtraction;
                if (r?.failed > 0) {
                    setSaveError(t('patient.files.extract.record.savedPartial', {
                        failed: formatNumber(r.failed)
                    }));
                    onSaved?.(r.file || null);
                } else {
                    setSaved({
                        tone: 'success',
                        text: t('patient.files.extract.record.saved')
                    });
                    onSaved?.(r?.file || null);
                }
            } else {
                // The rows carry their provenance; the BFF re-resolves test, unit, reference
                // range and status from the catalogue before anything is written.
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$1541403edf337a0), {
                    input: {
                        patientId: patientId,
                        fileId: file.id,
                        analysisId: analysisId,
                        appointmentId: file.appointmentId || appointmentId || null,
                        fileName: file.fileName || '',
                        documentType: run?.documentType || 'lab_report',
                        effectiveDate: documentDate || null,
                        labResults: labInput,
                        diagnoses: (run?.diagnoses || []).filter((_, i)=>pickedDx.has(i)),
                        medications: (run?.medications || []).filter((_, i)=>pickedMeds.has(i)).map((m)=>({
                                name: m.name,
                                dosage: m.dosage,
                                frequency: m.frequency
                            })),
                        clinicalNotes: run?.clinicalNotes || '',
                        abnormalFlags: run?.abnormalFlags || [],
                        categories: []
                    }
                });
                const r = d?.saveLabResults;
                const savedCount = r?.savedObservations ?? 0;
                if (r?.errorCode === 'FILE_NOT_FOUND' || r?.errorCode === 'LAB_REFERENCES_UNAVAILABLE') setSaveError(t(`patient.files.saveLabError.${r.errorCode}`));
                else if (savedCount < labInput.length) {
                    setSaveError(t('patient.files.extract.savedPartial', {
                        saved: formatDigits(savedCount),
                        total: formatDigits(labInput.length)
                    }));
                    if (savedCount > 0) onSaved?.(null);
                } else if (r?.errorCode || savedCount === 0) {
                    setSaved({
                        tone: r?.errorCode ? 'warning' : 'success',
                        text: r?.errorCode ? t(`patient.files.saveLabError.${r.errorCode}`) : t('patient.files.extract.savedLab', {
                            count: formatDigits(savedCount)
                        })
                    });
                    onSaved?.(null);
                } else {
                    // «ثبت و ادامه»: the values are in the record, so the review is done.
                    toast.success?.(t('patient.files.extract.labReview.saved', {
                        count: savedCount
                    }));
                    onSaved?.(null);
                    onClose?.();
                }
            }
        } catch (e) {
            setSaveError((0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, editorMode === 'LAB_RESULTS' ? 'patient.files.extract.saveLabFailed' : 'patient.files.extract.saveReportFailed'));
        } finally{
            setSaving(false);
        }
    }, [
        canSave,
        editorMode,
        file,
        run,
        report,
        note,
        rxRows,
        record,
        appointmentId,
        patientId,
        documentDate,
        labInput,
        pickedDx,
        pickedMeds,
        onSaved,
        onClose,
        toast,
        t,
        has,
        formatDigits,
        formatNumber
    ]);
    // §15 — before a lab review is recorded: values it cannot record stop it (and the
    // first one is focused), doubtful rows ask «ادامه با موارد مشکوک؟», then it saves.
    const requestSave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!canSave) return;
        if (editorMode === 'LAB_RESULTS') {
            const check = (0, $4bee6261c6e7da77$export$b0c762580619fe10)(rows, labReview.review);
            if (check.blocking.length) {
                setLabBlocked(true);
                labPanelRef.current?.focusRow(check.blocking[0].key);
                return;
            }
            setLabBlocked(false);
            if (check.suspicious.length) {
                setConfirmSuspicious(check.suspicious);
                return;
            }
        }
        save();
    }, [
        canSave,
        editorMode,
        rows,
        labReview.review,
        save
    ]);
    // Ctrl+Enter records it (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || isMobile) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                e.preventDefault();
                requestSave();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        isMobile,
        requestSave
    ]);
    // «تغییر نوع» — the file's kind follows what the document turned out to be.
    const applyKindSuggestion = async ()=>{
        if (!run?.kindSuggestion) return;
        setKindState({
            saving: true,
            done: false,
            error: ''
        });
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$ab95be7703af4e9d), {
                fileId: file.id,
                input: {
                    kind: run.kindSuggestion
                }
            });
            setKindState({
                saving: false,
                done: true,
                error: ''
            });
            onRan?.(run);
        } catch (e) {
            setKindState({
                saving: false,
                done: false,
                error: (0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.edit.failed')
            });
        }
    };
    if (!open || !file) return null;
    const toggleSet = (setter)=>(i, checked)=>{
            setTouched(true);
            setter((prev)=>{
                const next = new Set(prev);
                if (checked) next.add(i);
                else next.delete(i);
                return next;
            });
        };
    const touch = (setter)=>(next)=>{
            setTouched(true);
            setter(next);
        };
    const disabled = saving || Boolean(saved);
    const title = phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE ? t('patient.files.extract.chooseTitle') : t($a73dbad6d1e43f27$var$TITLE_KEY[phase === $a73dbad6d1e43f27$var$PHASE.READY ? editorMode : 'REPORT'] || $a73dbad6d1e43f27$var$TITLE_KEY.REPORT);
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, phase === $a73dbad6d1e43f27$var$PHASE.READY && !saved && !notMedical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "extract-ai-badge",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.6875rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('patient.files.extract.aiBadge')), labMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
        tone: "neutral",
        "data-testid": "extract-source-ocr"
    }, t('patient.files.extract.labReview.sourceOcr')), phase === $a73dbad6d1e43f27$var$PHASE.READY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a73dbad6d1e43f27$var$ClassChip, {
        run: run
    }), labMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: labSourceVisible ? 'outline' : 'ghost',
        size: "sm",
        className: "h-7 gap-1 px-2",
        "aria-pressed": labSourceVisible,
        onClick: ()=>setLabSourceVisible((v)=>!v),
        "data-testid": "extract-image-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $272fea46916dddb1$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.files.extract.labReview.imageToggle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%'
        }
    }, file.fileName));
    const rerunAvailable = phase === $a73dbad6d1e43f27$var$PHASE.READY || phase === $a73dbad6d1e43f27$var$PHASE.ERROR && (error?.kind === 'failed' || error?.kind === 'illegible');
    const rerunButtons = rerunAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "gap-1.5",
        onClick: ()=>setConfirmRerun({
                classOverride: run?.classSource === 'override' ? run.documentClass : null
            }),
        disabled: saving,
        "data-testid": "extract-rerun"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.rerun'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: price,
        size: "sm",
        testid: "extract-rerun-price"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: methodRef,
        variant: "ghost",
        className: "gap-1",
        onClick: ()=>setMethodMenu((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": methodMenu,
        disabled: saving,
        "data-testid": "extract-method"
    }, t('patient.files.extract.changeMethod'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: methodMenu,
        onClose: ()=>setMethodMenu(false),
        anchorRef: methodRef,
        width: 240,
        placement: "auto",
        ariaLabel: t('patient.files.extract.changeMethod'),
        "data-testid": "extract-method-menu"
    }, (0, $157d5bd48cfffbad$export$6638e927deac1763).map((cls)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: cls,
            variant: "ghost",
            role: "menuitem",
            className: "w-full justify-start font-normal",
            onClick: ()=>{
                setMethodMenu(false);
                setConfirmRerun({
                    classOverride: cls
                });
            },
            "data-testid": `extract-method-${cls}`,
            "aria-current": run?.documentClass === cls ? 'true' : undefined
        }, t((0, $157d5bd48cfffbad$export$f6b40a7b264b3557)(cls))))));
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center'
        }
    }, rerunButtons, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        "data-testid": "extract-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        className: "gap-1.5",
        onClick: ()=>extract({
                classOverride: chosenClass === 'AUTO' ? null : chosenClass
            }),
        "data-testid": "extract-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.actions.extract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$2e2bcd8739ae039), {
        cost: price,
        size: "sm",
        tone: "onDark",
        testid: "extract-start-price"
    }))) : saved || notMedical ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: onClose,
        "data-testid": "extract-done"
    }, t('common.actions.close')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        disabled: saving,
        "data-testid": "extract-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: requestSave,
        disabled: !canSave,
        className: labMode ? 'gap-1.5' : undefined,
        "data-testid": "extract-save"
    }, saving ? t('common.state.saving') : labMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('patient.files.extract.labReview.save', {
        count: labInput.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce8c437c319961cc$export$2e2bcd8739ae039), {
        size: 15,
        "aria-hidden": true,
        style: (0, $asXy3.MIRROR_ICON)
    })) : t('patient.files.extract.saveReport'))));
    const viewer = isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.showDocument')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a38d4c43e1d261e$export$2e2bcd8739ae039), {
        file: file,
        height: "16rem",
        testid: "extract-viewer"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            alignSelf: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a38d4c43e1d261e$export$2e2bcd8739ae039), {
        file: file,
        height: "min(70vh, 40rem)",
        testid: "extract-viewer"
    }));
    // What the run said about the document before any editor: truncation, handwriting,
    // legibility, the class disagreement, a name on the page, and document-wide flags.
    const banners = phase === $a73dbad6d1e43f27$var$PHASE.READY && run ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, run.truncatedPages > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-truncated"
    }, t('patient.files.extract.truncated', {
        count: formatNumber(run.truncatedPages)
    })), [
        'partial',
        'predominant'
    ].includes(String(run.handwriting || '').toLowerCase()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-handwriting"
    }, t(`patient.files.extract.handwriting.${String(run.handwriting).toLowerCase()}`)), [
        'fair',
        'poor'
    ].includes(String(legibility).toLowerCase()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "extract-legibility",
        "data-legibility": legibility
    }, t(`patient.files.extract.legibility.${String(legibility).toLowerCase()}`)), run.kindSuggestion && (0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(run.kindSuggestion) !== kind && !notMedical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-kind-suggestion",
        action: kindState.done ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: applyKindSuggestion,
            disabled: kindState.saving,
            "data-testid": "extract-kind-apply"
        }, kindState.saving ? t('common.state.saving') : t('patient.files.extract.changeKind'))
    }, kindState.done ? t('patient.files.extract.kindChanged', {
        kind: t((0, $157d5bd48cfffbad$export$d2ebff77a9864278)(run.kindSuggestion) || 'patient.files.kind.other')
    }) : t('patient.files.extract.kindDisagrees', {
        suggested: t((0, $157d5bd48cfffbad$export$d2ebff77a9864278)(run.kindSuggestion) || 'patient.files.kind.other'),
        declared: t((0, $157d5bd48cfffbad$export$d2ebff77a9864278)(kind) || 'patient.files.kind.other')
    }), kindState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            color: (0, $jTCZr.CT).danger
        }
    }, kindState.error)), run.patientNameOnDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-name-on-document",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.extract.nameOnDocument'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate',
            fontWeight: 600
        }
    }, run.patientNameOnDocument)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d2aabecd4883b7c$export$1c49e2087a373b64), {
        flags: (0, $157d5bd48cfffbad$export$c58f98e613dc3eb2)(run.flags),
        testid: "extract-document-flags"
    })) : null;
    const chargeNote = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, run?.costParseh > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-charged",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.chargedAmount', {
        price: formatDigits(run.costParseh)
    })), run?.charged === false && !(run?.costParseh > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-uncharged",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.uncharged')));
    let content;
    if (phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "extract-choose",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            maxWidth: '32rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, t('patient.files.extract.chooseClass')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.extract.chooseClassLabel'),
        value: chosenClass,
        onChange: (e)=>setChosenClass(e.target.value),
        options: [
            {
                value: 'AUTO',
                label: t('patient.files.extract.autoDetect')
            },
            ...(0, $157d5bd48cfffbad$export$6638e927deac1763).map((cls)=>({
                    value: cls,
                    label: t((0, $157d5bd48cfffbad$export$f6b40a7b264b3557)(cls))
                }))
        ],
        placeholder: "",
        "data-testid": "extract-choose-class"
    }));
    else if (phase === $a73dbad6d1e43f27$var$PHASE.RUNNING) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a73dbad6d1e43f27$var$RunningSkeleton, {
        isMobile: isMobile
    });
    else if (phase === $a73dbad6d1e43f27$var$PHASE.ERROR) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "extract-error",
        "data-kind": error?.kind,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: error?.kind === 'credit' ? 'warning' : 'error',
        action: error?.kind === 'credit' && purchaseAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>navigate('credits'),
            "data-testid": "extract-top-up"
        }, t('patient.files.extract.topUp')) : undefined
    }, error?.text), error?.kind !== 'inflight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.manualHint')), viewer);
    else if (labMode) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $52ac9b8dd4c1cc5a$export$2e2bcd8739ae039), {
        ref: labPanelRef,
        file: file,
        run: run,
        rows: rows,
        onRowsChange: touch(setRows),
        review: labReview,
        documentDate: documentDate,
        onDocumentDateChange: (v)=>{
            setTouched(true);
            setDocumentDate(v);
        },
        pickedDiagnoses: pickedDx,
        onPickDiagnosis: toggleSet(setPickedDx),
        pickedMedications: pickedMeds,
        onPickMedication: toggleSet(setPickedMeds),
        disabled: disabled,
        isMobile: isMobile,
        sourceVisible: labSourceVisible,
        onSourceVisibleChange: setLabSourceVisible,
        footnote: chargeNote,
        notices: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, banners, nothingFound && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-nothing"
        }, t('patient.files.extract.nothingFound')), saved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: saved.tone,
            "data-testid": "extract-saved"
        }, saved.text), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-save-error"
        }, saveError), labBlockingCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-lab-blocking"
        }, t('patient.files.extract.labReview.blocking', {
            count: labBlockingCount
        })))
    });
    else {
        let editor = null;
        if (notMedical) editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-not-medical"
        }, t('patient.files.extract.notMedical'));
        else if (editorMode === 'REPORT') editor = report && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dde797c4c39f144$export$2e2bcd8739ae039), {
            draft: report,
            onChange: touch(setReport),
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled
        });
        else if (editorMode === 'PRESCRIPTION') editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (run?.prescription?.prescriberName || run?.prescription?.prescribedOn) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            "data-testid": "rx-prescriber",
            style: {
                margin: 0,
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2
            },
            dir: "auto"
        }, [
            run.prescription.prescriberName,
            run.prescription.prescriberSpecialty,
            run.prescription.prescribedOn
        ].filter(Boolean).join(" \xb7 ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            style: {
                margin: 0,
                fontSize: '0.71875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t('patient.files.extract.rx.intoHistory')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f52a74ebbd4d691$export$2e2bcd8739ae039), {
            rows: rxRows,
            onRowsChange: touch(setRxRows),
            flags: run?.flags,
            compact: isMobile,
            disabled: disabled,
            visitRx: visitRx
        }));
        else if (editorMode === 'NOTE') editor = note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03ea67e3552fde0c$export$2e2bcd8739ae039), {
            draft: note,
            onChange: touch(setNote),
            legibility: legibility,
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled
        });
        else if (editorMode === 'RECORD') editor = record && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48e3b9f1b8c2cc26$export$2e2bcd8739ae039), {
            record: run?.record,
            draft: record,
            onChange: touch(setRecord),
            flags: run?.flags,
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled,
            visitRx: visitRx
        });
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 5fr) minmax(0, 6fr)',
                gap: '1rem',
                alignItems: 'start'
            }
        }, viewer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75rem',
                minWidth: 0
            }
        }, banners, nothingFound && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-nothing"
        }, t('patient.files.extract.nothingFound')), saved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: saved.tone,
            "data-testid": "extract-saved"
        }, saved.text), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-save-error"
        }, saveError), visitRx && [
            ...visitAdds.values()
        ].includes('added') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-visit-rx-added",
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                onClick: leaveToVisitPrescription,
                disabled: saving,
                "data-testid": "extract-visit-rx-go"
            }, t('patient.files.extract.rx.goToVisitRx'))
        }, t('patient.files.extract.rx.addedHint')), editor, chargeNote));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: requestClose,
        title: title,
        header: header,
        footer: footer,
        busy: saving || phase === $a73dbad6d1e43f27$var$PHASE.RUNNING,
        size: "xl",
        className: labMode && !isMobile ? $a73dbad6d1e43f27$var$LAB_DIALOG_CLASS : undefined,
        isMobile: isMobile,
        closeLabel: t('common.actions.close'),
        "data-testid": "extraction-review"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": phase,
        "data-mode": editorMode
    }, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmDiscard),
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.extract.discardTitle'),
        description: t('patient.files.extract.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            const leave = confirmDiscard === 'leave';
            setConfirmDiscard(false);
            if (leave) onClose?.({
                toVisitPrescription: true
            });
            else onClose?.();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmSuspicious),
        onOpenChange: (o)=>{
            if (o) return;
            const first = confirmSuspicious?.[0];
            setConfirmSuspicious(null);
            // «بازگشت به بررسی» takes the doctor to the first doubtful row.
            if (!labContinuing.current && first) labPanelRef.current?.focusRow(first.key);
            labContinuing.current = false;
        },
        title: t('patient.files.extract.labReview.confirmTitle', {
            count: confirmSuspicious?.length || 0
        }),
        description: t('patient.files.extract.labReview.confirmBody'),
        confirmLabel: t('patient.files.extract.labReview.confirmContinue'),
        cancelLabel: t('patient.files.extract.labReview.confirmBack'),
        onConfirm: ()=>{
            labContinuing.current = true;
            setConfirmSuspicious(null);
            save();
        },
        confirmTestId: "extract-lab-confirm-continue"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmVisitAdd),
        onOpenChange: (o)=>{
            if (!o) setConfirmVisitAdd(null);
        },
        title: t('patient.files.extract.rx.confirmAddTitle'),
        description: confirmVisitAdd?.verified === false ? t('patient.files.extract.rx.confirmAddUnverified') : t('patient.files.extract.rx.confirmAddReview'),
        confirmLabel: t('patient.files.extract.rx.confirmAddAction'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>{
            const row = confirmVisitAdd;
            setConfirmVisitAdd(null);
            if (row) commitVisitAdd(row);
        },
        confirmTestId: "extract-visit-rx-confirm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmRerun),
        onOpenChange: (o)=>{
            if (!o) setConfirmRerun(null);
        },
        title: confirmRerun?.classOverride ? t('patient.files.extract.rerunAsTitle', {
            class: t((0, $157d5bd48cfffbad$export$f6b40a7b264b3557)(confirmRerun.classOverride))
        }) : t('patient.files.extract.rerunTitle'),
        description: t('patient.files.extract.rerunMessage', {
            price: formatDigits(price ?? 0)
        }),
        confirmLabel: t('patient.files.extract.rerun'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>{
            const next = confirmRerun;
            setConfirmRerun(null);
            extract({
                classOverride: next?.classOverride || null
            });
        },
        confirmTestId: "extract-rerun-confirm"
    }));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $7gSBD = parcelRequire("7gSBD");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a92bbd74876a0a00$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 18a6 6 0 0 0 0-12v12z",
            key: "j4l70d"
        }
    ]
];
const $a92bbd74876a0a00$export$2e2bcd8739ae039 = (0, $9QBug.default)("contrast", $a92bbd74876a0a00$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $194a2e33b6f84e97$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m3 7 5 5-5 5V7",
            key: "couhi7"
        }
    ],
    [
        "path",
        {
            d: "m21 7-5 5 5 5V7",
            key: "6ouia7"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "M12 14v2",
            key: "8jcxud"
        }
    ],
    [
        "path",
        {
            d: "M12 8v2",
            key: "1woqiv"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ]
];
const $194a2e33b6f84e97$export$2e2bcd8739ae039 = (0, $9QBug.default)("flip-horizontal-2", $194a2e33b6f84e97$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cc10787427ff9cd4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $cc10787427ff9cd4$export$2e2bcd8739ae039 = (0, $9QBug.default)("layers", $cc10787427ff9cd4$export$3efd853dbb351e94);


var $6ivsH = parcelRequire("6ivsH");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $754dfea6cb717fed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v20",
            key: "t6zp3m"
        }
    ],
    [
        "path",
        {
            d: "m15 19-3 3-3-3",
            key: "11eu04"
        }
    ],
    [
        "path",
        {
            d: "m19 9 3 3-3 3",
            key: "1mg7y2"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ],
    [
        "path",
        {
            d: "m5 9-3 3 3 3",
            key: "j64kie"
        }
    ],
    [
        "path",
        {
            d: "m9 5 3-3 3 3",
            key: "l8vdw6"
        }
    ]
];
const $754dfea6cb717fed$export$2e2bcd8739ae039 = (0, $9QBug.default)("move", $754dfea6cb717fed$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c0ad648fb4fb7066$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "14",
            y: "3",
            width: "5",
            height: "18",
            rx: "1",
            key: "kaeet6"
        }
    ],
    [
        "rect",
        {
            x: "5",
            y: "3",
            width: "5",
            height: "18",
            rx: "1",
            key: "1wsw3u"
        }
    ]
];
const $c0ad648fb4fb7066$export$2e2bcd8739ae039 = (0, $9QBug.default)("pause", $c0ad648fb4fb7066$export$3efd853dbb351e94);


var $4gxLI = parcelRequire("4gxLI");
var $bF8pu = parcelRequire("bF8pu");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $e4c2dda478a7569e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
            key: "icamh8"
        }
    ],
    [
        "path",
        {
            d: "m14.5 12.5 2-2",
            key: "inckbg"
        }
    ],
    [
        "path",
        {
            d: "m11.5 9.5 2-2",
            key: "fmmyf7"
        }
    ],
    [
        "path",
        {
            d: "m8.5 6.5 2-2",
            key: "vc6u1g"
        }
    ],
    [
        "path",
        {
            d: "m17.5 15.5 2-2",
            key: "wo5hmg"
        }
    ]
];
const $e4c2dda478a7569e$export$2e2bcd8739ae039 = (0, $9QBug.default)("ruler", $e4c2dda478a7569e$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c569109e8b7be3a9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M14.837 16.385a6 6 0 1 1-7.223-7.222c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.259c.589-.255 1.396.09 1.248.715",
            key: "xlf6rm"
        }
    ],
    [
        "path",
        {
            d: "M16 12a4 4 0 0 0-4-4",
            key: "6vsxu"
        }
    ],
    [
        "path",
        {
            d: "m19 5-1.256 1.256",
            key: "1yg6a6"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ]
];
const $c569109e8b7be3a9$export$2e2bcd8739ae039 = (0, $9QBug.default)("sun-moon", $c569109e8b7be3a9$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $727bbd7113825529$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
            key: "14u9p9"
        }
    ]
];
const $727bbd7113825529$export$2e2bcd8739ae039 = (0, $9QBug.default)("triangle", $727bbd7113825529$export$3efd853dbb351e94);


var $47abO = parcelRequire("47abO");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");









// The full DICOM viewer — doctor desktop only (§8.9.1, R-C6).
//
// A kit `TaskOverlay` at `xl` (its desktop half is the framed Dialog), so the Visit
// page stays mounted underneath and its timer and recording carry on. It is one of
// the overlays `useClinicalFiles` owns: nothing else is open while it is.
//
// Cornerstone is heavy (WASM codecs, workers), so the viewer is a lazy chunk loaded
// with this overlay and never imported by a phone route — the phone gets the
// server-rendered `RenderedStudySheet` instead.
//
// Keyboard (recorded in docs/APP-SPEC.md): ↑/↓ and PageUp/PageDown step frames,
// ←/→ step series, W window/level, Z zoom, P pan, L length, A angle, R reset,
// I invert, Space cine, Esc closes (the overlay's own). Bound on the overlay's own
// element — focus is trapped inside it while it is open, so the keys exist exactly
// as long as the viewer does, with no global listener. Bare digits are never bound
// (DESKTOP_WEB §5), so presets are chosen with the segmented control.
const $96636c9b1990d1e6$var$DicomViewer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("gDDAu")));
const $96636c9b1990d1e6$var$TOOLS = [
    {
        id: 'windowLevel',
        icon: (0, $a92bbd74876a0a00$export$2e2bcd8739ae039),
        key: 'w'
    },
    {
        id: 'zoom',
        icon: (0, $47abO.default),
        key: 'z'
    },
    {
        id: 'pan',
        icon: (0, $754dfea6cb717fed$export$2e2bcd8739ae039),
        key: 'p'
    },
    {
        id: 'length',
        icon: (0, $e4c2dda478a7569e$export$2e2bcd8739ae039),
        key: 'l'
    },
    {
        id: 'angle',
        icon: (0, $727bbd7113825529$export$2e2bcd8739ae039),
        key: 'a'
    }
];
const $96636c9b1990d1e6$var$CINE_FPS = 15;
function $96636c9b1990d1e6$var$ViewerSkeleton() {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.loadingDicom'),
        "data-testid": "dicom-viewer-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: '9rem 1fr',
            gap: '0.75rem',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, [
        1,
        2,
        3
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            width: "100%",
            height: 88,
            radius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
        tone: "onDark"
    }));
}
function $96636c9b1990d1e6$export$2e2bcd8739ae039({ open: open, file: file, patient: patient, onClose: onClose, onConfirmIdentity: onConfirmIdentity, confirming: confirming = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const study = file?.dicom || null;
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        viewer: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [seriesIndex, setSeriesIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [tool, setTool] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('windowLevel');
    const [presetId, setPresetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [frame, setFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        index: 0,
        total: 0
    });
    const [cine, setCine] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const apiRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return undefined;
        let cancelled = false;
        setState({
            status: 'loading',
            viewer: null
        });
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$5ba246e021e79195), {
            fileId: file.id
        }).then((d)=>{
            if (cancelled) return;
            const viewer = d?.dicomStudyViewer || null;
            setState({
                status: viewer?.series?.length ? 'content' : 'empty',
                viewer: viewer
            });
            setSeriesIndex(0);
        }).catch((error)=>{
            if (!cancelled) setState({
                status: 'error',
                viewer: null,
                error: error
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        file?.id,
        attempt
    ]);
    const seriesList = state.viewer?.series || [];
    const active = seriesList[seriesIndex] || null;
    const presets = (0, $a9fe471dd730c044$export$5d687327647c3afb)(active?.modality);
    // A new series starts from its own defaults.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPresetId('auto');
        setCine(false);
        setFrame({
            index: 0,
            total: 0
        });
    }, [
        active?.seriesUid
    ]);
    // Focus lands inside the viewer so its keys work at once.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && state.status === 'content') frameRef.current?.focus?.();
    }, [
        open,
        state.status
    ]);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>active && state.viewer ? {
            dicomWebRoot: (0, $a9fe471dd730c044$export$1b4f8208f28b4aed)(),
            studyInstanceUid: state.viewer.studyUid,
            seriesInstanceUid: active.seriesUid,
            // Instances that predate the rendering engine are read whole, by id.
            fallbackInstances: (active.instances || []).map((inst)=>({
                    url: `${(0, $75472431f73f934f$export$a9b90d04cbeb257e)()}/wado/instances/${encodeURIComponent(inst.instanceId)}`,
                    instanceNumber: inst.number ?? 0
                }))
        } : null, [
        active,
        state.viewer
    ]);
    const api = ()=>apiRef.current;
    const chooseTool = (id)=>{
        setTool(id);
        api()?.setTool(id);
    };
    const choosePreset = (id)=>{
        setPresetId(id);
        const p = presets.find((x)=>x.id === id);
        api()?.setWindow(p?.center ?? null, p?.width ?? null);
    };
    const toggleCine = ()=>{
        const next = !cine;
        setCine(next);
        api()?.setCine(next, $96636c9b1990d1e6$var$CINE_FPS);
    };
    const stepSeries = (delta)=>{
        if (!seriesList.length) return;
        setSeriesIndex((i)=>Math.max(0, Math.min(seriesList.length - 1, i + delta)));
    };
    const onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (e.target?.closest?.('input, textarea, select')) return;
        const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
        const rtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
        const handled = {
            ArrowUp: ()=>api()?.step(-1),
            PageUp: ()=>api()?.step(-1),
            ArrowDown: ()=>api()?.step(1),
            PageDown: ()=>api()?.step(1),
            // The series rail reads in the page's direction.
            ArrowLeft: ()=>stepSeries(rtl ? 1 : -1),
            ArrowRight: ()=>stepSeries(rtl ? -1 : 1),
            r: ()=>api()?.reset(),
            i: ()=>api()?.toggleInvert(),
            ' ': toggleCine,
            ...Object.fromEntries($96636c9b1990d1e6$var$TOOLS.map((tl)=>[
                    tl.key,
                    ()=>chooseTool(tl.id)
                ]))
        }[key];
        if (!handled) return;
        e.preventDefault();
        e.stopPropagation();
        handled();
    };
    const toolButton = ({ id: id, icon: Icon, label: label, onClick: onClick, pressed: pressed, testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: pressed ? 'subtle' : 'ghost',
            size: "icon",
            className: "h-9 w-9",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "aria-pressed": pressed === undefined ? undefined : pressed,
            "data-testid": testid
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 16,
            "aria-hidden": true
        }));
    const toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "dicom-viewer-toolbar",
        role: "toolbar",
        "aria-label": t('patient.files.dicom.viewer.toolbar'),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, $96636c9b1990d1e6$var$TOOLS.map((tl)=>toolButton({
            id: tl.id,
            icon: tl.icon,
            label: t(`patient.files.dicom.viewer.tools.${tl.id}`),
            onClick: ()=>chooseTool(tl.id),
            pressed: tool === tl.id,
            testid: `dicom-viewer-tool-${tl.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 1,
            alignSelf: 'stretch',
            background: (0, $jTCZr.CT).border,
            marginInline: '0.25rem'
        }
    }), toolButton({
        id: 'reset',
        icon: (0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039),
        label: t('patient.files.dicom.viewer.tools.reset'),
        onClick: ()=>api()?.reset(),
        testid: 'dicom-viewer-reset'
    }), toolButton({
        id: 'invert',
        icon: (0, $c569109e8b7be3a9$export$2e2bcd8739ae039),
        label: t('patient.files.dicom.viewer.tools.invert'),
        onClick: ()=>api()?.toggleInvert(),
        testid: 'dicom-viewer-invert'
    }), toolButton({
        id: 'rotate',
        icon: (0, $bF8pu.default),
        label: t('patient.files.dicom.viewer.tools.rotate'),
        onClick: ()=>api()?.rotate(),
        testid: 'dicom-viewer-rotate'
    }), toolButton({
        id: 'flip',
        icon: (0, $194a2e33b6f84e97$export$2e2bcd8739ae039),
        label: t('patient.files.dicom.viewer.tools.flip'),
        onClick: ()=>api()?.flip(),
        testid: 'dicom-viewer-flip'
    }), toolButton({
        id: 'cine',
        icon: cine ? (0, $c0ad648fb4fb7066$export$2e2bcd8739ae039) : (0, $4gxLI.default),
        label: t(cine ? 'patient.files.dicom.viewer.tools.pause' : 'patient.files.dicom.viewer.tools.play'),
        onClick: toggleCine,
        pressed: cine,
        testid: 'dicom-viewer-cine'
    }), toolButton({
        id: 'fullscreen',
        icon: (0, $6ivsH.default),
        label: t('patient.files.dicom.viewer.tools.fullscreen'),
        onClick: ()=>frameRef.current?.requestFullscreen?.(),
        testid: 'dicom-viewer-fullscreen'
    }), presets.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        ariaLabel: t('patient.files.dicom.viewer.presets'),
        value: presetId,
        onChange: choosePreset,
        options: presets.map((p)=>({
                value: p.id,
                label: t(`patient.files.dicom.presets.${p.id}`)
            })),
        "data-testid": "dicom-viewer-presets"
    })));
    const rail = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": t('patient.files.dicom.viewer.series'),
        "data-testid": "dicom-viewer-series",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            overflowY: 'auto',
            minHeight: 0
        }
    }, seriesList.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: s.seriesUid,
            variant: i === seriesIndex ? 'subtle' : 'ghost',
            onClick: ()=>setSeriesIndex(i),
            "aria-current": i === seriesIndex ? 'true' : undefined,
            "data-testid": `dicom-viewer-series-${i}`,
            className: "h-auto w-full flex-col items-stretch gap-1 p-1.5 font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fab7b93fa77b6d7$export$2e2bcd8739ae039), {
            study: {
                studyUid: state.viewer.studyUid,
                rendered: state.viewer.rendered
            },
            seriesUid: s.seriesUid,
            modality: s.modality,
            size: "100%",
            testid: `dicom-viewer-series-thumb-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$8b4ef6368b96e1d9), {
            modality: s.modality,
            testid: `dicom-viewer-series-modality-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.dicom.imageCount', {
            count: formatNumber((s.instances || []).reduce((n, x)=>n + (x.frames || 1), 0))
        }))), s.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, s.description))));
    let body;
    if (state.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($96636c9b1990d1e6$var$ViewerSkeleton, null);
    else if (state.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "dicom-viewer-error",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: state.error,
        title: t('patient.files.dicomLoadFailed'),
        onRetry: ()=>setAttempt((n)=>n + 1)
    }));
    else if (state.status === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "dicom-viewer-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc10787427ff9cd4$export$2e2bcd8739ae039), {
            size: 40,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: t('patient.files.dicom.viewer.empty')
    });
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '9rem minmax(0, 1fr) minmax(12rem, 16rem)',
            gap: '0.75rem',
            height: 'min(72vh, 46rem)',
            minHeight: 0
        }
    }, rail, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            minHeight: 0
        }
    }, toolbar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: frameRef,
        tabIndex: -1,
        onKeyDown: onKeyDown,
        "data-testid": "dicom-viewer-stage",
        style: {
            position: 'relative',
            flex: 1,
            minHeight: 0,
            background: (0, $jTCZr.CT).ink,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            overflow: 'hidden',
            outline: 'none'
        }
    }, source && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "100%",
            height: "100%",
            radius: 0,
            tone: "onDark"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($96636c9b1990d1e6$var$DicomViewer, {
        key: active.seriesUid,
        source: source,
        height: "100%",
        onReady: (viewerApi)=>{
            apiRef.current = viewerApi;
            viewerApi.setTool(tool);
        },
        onFrameChange: (index, total)=>setFrame({
                index: index,
                total: total
            })
    })), frame.total > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "dicom-viewer-frame",
        "aria-live": "polite",
        style: {
            position: 'absolute',
            insetBlockStart: '0.5rem',
            insetInlineStart: '0.5rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            fontSize: '0.6875rem',
            fontWeight: 600
        }
    }, t('patient.files.dicom.viewer.frame', {
        index: formatNumber(frame.index + 1),
        total: formatNumber(frame.total)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            overflowY: 'auto',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.dicom.viewer.metadata'),
        defaultOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$31a954d36640d797), {
        study: study
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: onClose,
        title: study?.description || file?.fileName || t('patient.files.dicomStudy'),
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$1090f771f7d0b229), {
            file: file,
            patient: patient,
            onConfirm: onConfirmIdentity,
            confirming: confirming,
            testid: "dicom-viewer-identity"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$3a5c932de3a0f9c9), {
            study: active ? {
                lossySource: active.lossy || study?.lossySource
            } : study,
            testid: "dicom-viewer-lossy"
        })),
        size: "xl",
        isMobile: false,
        closeLabel: t('common.actions.close'),
        "data-testid": "dicom-viewer-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": state.status
    }, body));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $7gSBD = parcelRequire("7gSBD");
var $bhQd4 = parcelRequire("bhQd4");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3237de5b7cdbe550$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "2",
            y2: "22",
            key: "a6p6uj"
        }
    ],
    [
        "path",
        {
            d: "M10.41 10.41a2 2 0 1 1-2.83-2.83",
            key: "1bzlo9"
        }
    ],
    [
        "line",
        {
            x1: "13.5",
            x2: "6",
            y1: "13.5",
            y2: "21",
            key: "1q0aeu"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "21",
            y1: "12",
            y2: "15",
            key: "5mozeu"
        }
    ],
    [
        "path",
        {
            d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
            key: "mmje98"
        }
    ],
    [
        "path",
        {
            d: "M21 15V5a2 2 0 0 0-2-2H9",
            key: "43el77"
        }
    ]
];
const $3237de5b7cdbe550$export$2e2bcd8739ae039 = (0, $9QBug.default)("image-off", $3237de5b7cdbe550$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");





// A study on the phone — server-rendered frames in the kit's `ImageStackViewer`
// (§8.9.2, R-C6). The diagnostic viewer is a desktop tool and is never loaded here.
//
// Every frame is fetched through the BFF's per-study-authorised `/rendered` proxy
// with the token in a header, handed to the kit as an object URL, and revoked by the
// kit's `revokeFrame` the moment it leaves the preload window. Window presets are
// rendered by the SERVER, so a preset change is a new set of frames.
//
// A full-height `BottomSheet` — it owns the screen and its history entry.
const $39e00aa6827caf22$var$RENDER_SIZE = 1024;
function $39e00aa6827caf22$export$2e2bcd8739ae039({ open: open, file: file, patient: patient, onClose: onClose }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        viewer: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [seriesId, setSeriesId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [presetId, setPresetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [index, setIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return undefined;
        let cancelled = false;
        setState({
            status: 'loading',
            viewer: null
        });
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$5ba246e021e79195), {
            fileId: file.id
        }).then((d)=>{
            if (cancelled) return;
            const viewer = d?.dicomStudyViewer || null;
            const status = !viewer?.series?.length ? 'empty' : viewer.rendered === false ? 'unavailable' : 'content';
            setState({
                status: status,
                viewer: viewer
            });
            setSeriesId(viewer?.series?.[0]?.seriesUid || null);
        }).catch((error)=>{
            if (!cancelled) setState({
                status: 'error',
                viewer: null,
                error: error
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        file?.id,
        attempt
    ]);
    const viewer = state.viewer;
    const series = viewer?.series?.find((s)=>s.seriesUid === seriesId) || viewer?.series?.[0] || null;
    const frames = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a9fe471dd730c044$export$3963a516697574a)(series), [
        series
    ]);
    const presets = (0, $a9fe471dd730c044$export$5d687327647c3afb)(series?.modality);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIndex(0);
        setPresetId('auto');
    }, [
        series?.seriesUid
    ]);
    const loadFrame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((i, { signal: signal } = {})=>{
        const f = frames[i];
        if (!f || !viewer) return Promise.reject(new Error('no frame'));
        const url = (0, $a9fe471dd730c044$export$4c5664a761278db0)(viewer.studyUid, series.seriesUid, f.sopUid, {
            frame: f.frame,
            window: (0, $a9fe471dd730c044$export$8fc65bc1bd573695)(presetId, series.modality),
            size: $39e00aa6827caf22$var$RENDER_SIZE
        });
        return (0, $a9fe471dd730c044$export$3a2589cc21066709)(url, {
            signal: signal
        });
    }, [
        frames,
        viewer,
        series,
        presetId
    ]);
    const revokeFrame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        try {
            URL.revokeObjectURL(url);
        } catch  {}
    }, []);
    const labels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            frame: (i, n)=>t('patient.files.dicom.viewer.frame', {
                    index: formatNumber(i),
                    total: formatNumber(n)
                }),
            prev: t('patient.files.dicom.stack.prev'),
            next: t('patient.files.dicom.stack.next'),
            slider: t('patient.files.dicom.stack.slider'),
            zoomIn: t('patient.files.dicom.stack.zoomIn'),
            zoomOut: t('patient.files.dicom.stack.zoomOut'),
            reset: t('patient.files.dicom.stack.reset'),
            series: t('patient.files.dicom.viewer.series'),
            presets: t('patient.files.dicom.viewer.presets'),
            viewport: t('patient.files.dicom.stack.viewport'),
            loading: t('patient.files.dicom.stack.loading'),
            error: t('patient.files.dicom.stack.error'),
            retry: t('common.actions.retry'),
            empty: t('patient.files.dicom.viewer.empty')
        }), [
        t,
        formatNumber
    ]);
    const study = file?.dicom || null;
    let body;
    if (state.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.loadingDicom'),
        "data-testid": "rendered-study-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "55dvh",
        radius: 12,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: 36,
        radius: 8
    }));
    else if (state.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "rendered-study-error",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: state.error,
        title: t('patient.files.dicomLoadFailed'),
        onRetry: ()=>setAttempt((n)=>n + 1)
    }));
    else if (state.status === 'unavailable' || state.status === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": `rendered-study-${state.status}`,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3237de5b7cdbe550$export$2e2bcd8739ae039), {
            size: 40,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: t(state.status === 'unavailable' ? 'patient.files.dicom.stack.unavailable' : 'patient.files.dicom.viewer.empty')
    });
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bhQd4.default), {
        frameCount: frames.length,
        index: index,
        onIndexChange: setIndex,
        loadFrame: loadFrame,
        revokeFrame: revokeFrame,
        preloadRadius: 5,
        sourceKey: `${series?.seriesUid}:${presetId}`,
        series: (viewer.series || []).map((s)=>({
                id: s.seriesUid,
                label: s.description || t('patient.files.dicom.seriesNumber', {
                    number: formatNumber(s.number ?? 0)
                }),
                badge: s.modality || undefined
            })),
        activeSeriesId: series?.seriesUid,
        onSeriesChange: setSeriesId,
        presets: presets.length > 1 ? presets.map((p)=>({
                id: p.id,
                label: t(`patient.files.dicom.presets.${p.id}`)
            })) : undefined,
        activePresetId: presetId,
        onPresetChange: setPresetId,
        caption: t('patient.files.dicom.stack.caption'),
        banner: series?.lossy || study?.lossySource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$3a5c932de3a0f9c9), {
            study: {
                lossySource: true
            },
            testid: "rendered-study-lossy"
        }) : null,
        labels: labels,
        "data-testid": "rendered-study-stack"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: study?.description || file?.fileName || t('patient.files.dicomStudy'),
        fullHeight: true,
        snap: 1,
        closeLabel: t('common.actions.close'),
        "data-testid": "rendered-study-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": state.status,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00e4129789459a85$export$1090f771f7d0b229), {
        file: file,
        patient: patient,
        testid: "rendered-study-identity"
    }), body));
}


// «مدارک بیمار» — every overlay a document can open, owned in ONE place.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7, §8.
//
// The Visit page's record section, its full-list sheet, the patient record's «فایل‌ها»
// tab and both phone reductions all call the same four verbs — open, upload, extract,
// download, delete — and render the same `overlays`. That is what keeps the flows
// identical wherever the doctor meets a document, and it is what enforces the overlay
// law structurally: only one of detail / upload / review is ever open, and the review
// hands back to the detail it came from (DESIGN_CONCEPT §5.2 — no stacking except a
// confirm).
// A document can answer any lab or imaging request that was PLACED at a visit —
// pending, in progress or already performed (the result often arrives after the
// service is marked done). A cancelled request collects nothing.
const $489287129a199b1d$var$RESULT_ORDER_TYPES = [
    'lab',
    'imaging',
    'radiology'
];
const $489287129a199b1d$var$isResultOrder = (o)=>$489287129a199b1d$var$RESULT_ORDER_TYPES.some((k)=>String(o?.orderType || '').toLowerCase().includes(k)) && String(o?.status || '').toLowerCase() !== 'cancelled';
function $489287129a199b1d$export$513d4933d99292ab({ patient: patient, files: files = [], appointmentId: appointmentId = null, clinicNameOf: clinicNameOf, onChanged: onChanged, onAddToVisitPrescription: onAddToVisitPrescription = null }) {
    const { t: t, has: has, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const patientId = patient?.id || null;
    const [overlay, setOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirm, setConfirm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { type: 'delete' | 'largeDownload', file }
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [ordersLoading, setOrdersLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The requests a result can answer — read when a surface that links to one opens.
    const loadOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!patientId) return;
        setOrdersLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$b25799d4be2e0e7b), {
            patientId: patientId
        }).then((d)=>setOrders((d?.listDoctorOrders || []).filter($489287129a199b1d$var$isResultOrder))).catch(()=>setOrders([])).finally(()=>setOrdersLoading(false));
    }, [
        patientId
    ]);
    const visits = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(patient?.encounters || []).filter((e)=>e?.id).slice().sort((a, b)=>String(b.scheduledDate || '').localeCompare(String(a.scheduledDate || ''))), [
        patient?.encounters
    ]);
    // The overlay holds the file it was opened on; the list is re-read after every
    // change, so the drawer always shows the row as it is now.
    const fresh = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((f)=>f ? files.find((x)=>x.id === f.id && (x._source || 'clinical') === (f._source || 'clinical')) || f : f, [
        files
    ]);
    const openDetail = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file, { edit: edit = false } = {})=>{
        loadOrders();
        setOverlay({
            type: 'detail',
            file: file,
            edit: edit
        });
    }, [
        loadOrders
    ]);
    const openUpload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((preset = {})=>{
        loadOrders();
        setOverlay({
            type: 'upload',
            preset: {
                appointmentId: appointmentId || null,
                ...preset
            }
        });
    }, [
        loadOrders,
        appointmentId
    ]);
    const openExtract = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file, { mode: mode, run: run } = {})=>{
        setOverlay((current)=>({
                type: 'extract',
                file: file,
                mode: mode,
                run: run,
                returnTo: current?.type === 'detail' ? {
                    type: 'detail',
                    file: file
                } : null
            }));
    }, []);
    // A DICOM study's images: the diagnostic viewer on a workstation, the server-rendered
    // preview on a phone (R-C6). Like the review, it replaces the drawer it came from.
    const openViewer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>{
        setOverlay((current)=>({
                type: isMobile ? 'rendered' : 'viewer',
                file: file,
                returnTo: current?.type === 'detail' ? {
                    type: 'detail',
                    file: file
                } : null
            }));
    }, [
        isMobile
    ]);
    const [confirming, setConfirming] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «تأیید تعلق به این بیمار» — the doctor read both identities and says the study is
    // this patient's; the warning clears for everyone who opens it after.
    const confirmIdentity = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setConfirming(true);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$f6a06f00c2ea9339), {
                fileId: file.id
            });
            toast.success?.(t('patient.files.dicom.identity.confirmed'));
            onChanged?.();
        } catch (e) {
            toast.error?.((0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.dicom.identity.confirmFailed'));
        } finally{
            setConfirming(false);
        }
    }, [
        onChanged,
        toast,
        t,
        has
    ]);
    const doDownload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setConfirm(null);
        try {
            if (file._source === 'storage') {
                const d = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$6b196bd9c5c0429b), {
                    id: file.id
                });
                const parts = (0, $2dcdf1c1963f00da$export$64f75967084abe8e)(d?.storageLabFileUrl);
                if (!parts) throw new Error('empty');
                (0, $2dcdf1c1963f00da$export$9016c9576545678)((0, $2dcdf1c1963f00da$export$b3fb17ae4345ac8f)(parts.data, parts.contentType), file.fileName);
            } else {
                const d = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$a7d989aaa610e68c), {
                    fileId: file.id
                });
                const x = d?.clinicalFileDownload;
                if (!x?.data) throw new Error('empty');
                (0, $2dcdf1c1963f00da$export$9016c9576545678)((0, $2dcdf1c1963f00da$export$b3fb17ae4345ac8f)(x.data, x.contentType), x.fileName);
            }
        } catch (e) {
            toast.error?.((0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.download.failed'));
        }
    }, [
        toast,
        t,
        has
    ]);
    const download = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>{
        if ((file?.fileSize || 0) > (0, $2dcdf1c1963f00da$export$48c908e1ec06ccc6)) setConfirm({
            type: 'largeDownload',
            file: file
        });
        else doDownload(file);
    }, [
        doDownload
    ]);
    const requestDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>setConfirm({
            type: 'delete',
            file: file
        }), []);
    const doDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setBusy(true);
        try {
            if (file._source === 'storage') await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$9ae3a22786248a30), {
                id: file.id
            });
            else await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$75adfe99f4855836), {
                fileId: file.id
            });
            setConfirm(null);
            setOverlay(null);
            // A deleted row leaves a list the doctor may have scrolled away from, so the
            // success is said out loud (DESIGN_CONCEPT §2.4).
            toast.success?.(t('patient.files.deletion.done'));
            onChanged?.();
        } catch (e) {
            setConfirm(null);
            toast.error?.((0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, e, 'patient.files.deletion.failed'));
        } finally{
            setBusy(false);
        }
    }, [
        onChanged,
        toast,
        t,
        has
    ]);
    const clinicName = (file)=>clinicNameOf && file?.clinicId ? clinicNameOf(file.clinicId) : null;
    const overlays = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, overlay?.type === 'detail' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f567419dd4447b1$export$2e2bcd8739ae039), {
        open: true,
        file: fresh(overlay.file),
        startEditing: Boolean(overlay.edit),
        patientId: patientId,
        visits: visits,
        orders: orders,
        ordersLoading: ordersLoading,
        clinicName: clinicName(overlay.file),
        isMobile: isMobile,
        onClose: ()=>setOverlay(null),
        onExtract: (f)=>openExtract(f),
        onReview: (f, run)=>openExtract(f, {
                run: run
            }),
        onView: openViewer,
        onConfirmIdentity: confirmIdentity,
        confirming: confirming,
        patient: patient,
        onDownload: download,
        onDelete: requestDelete,
        onSaved: ()=>onChanged?.()
    }), overlay?.type === 'viewer' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96636c9b1990d1e6$export$2e2bcd8739ae039), {
        open: true,
        file: fresh(overlay.file),
        patient: patient,
        onConfirmIdentity: ()=>confirmIdentity(fresh(overlay.file)),
        confirming: confirming,
        onClose: ()=>setOverlay(overlay.returnTo || null)
    }), overlay?.type === 'rendered' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39e00aa6827caf22$export$2e2bcd8739ae039), {
        open: true,
        file: fresh(overlay.file),
        patient: patient,
        onClose: ()=>setOverlay(overlay.returnTo || null)
    }), overlay?.type === 'upload' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f959cceb164f70c8$export$2e2bcd8739ae039), {
        open: true,
        patientId: patientId,
        patient: patient,
        preset: overlay.preset,
        visits: visits,
        orders: orders,
        ordersLoading: ordersLoading,
        onClose: ()=>setOverlay(null),
        onUploaded: (stored, { extract: extract, partial: partial } = {})=>{
            onChanged?.();
            if (partial) return;
            if (extract && stored[0]) setOverlay({
                type: 'extract',
                file: stored[0],
                returnTo: null
            });
            else setOverlay(null);
        }
    }), overlay?.type === 'extract' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a73dbad6d1e43f27$export$2e2bcd8739ae039), {
        open: true,
        file: fresh(overlay.file),
        patientId: patientId,
        appointmentId: appointmentId,
        initialRun: overlay.run || null,
        initialMode: overlay.mode,
        // A run changed the file's processing status whether or not anything is saved.
        onRan: ()=>onChanged?.(),
        onSaved: ()=>onChanged?.(),
        onAddToVisitPrescription: onAddToVisitPrescription,
        // «رفتن به نسخه ویزیت» leaves for the page's drug form, so nothing is handed
        // back to — the drawer it came from would cover the form it is going to.
        onClose: (opts)=>setOverlay(opts?.toVisitPrescription ? null : overlay.returnTo || null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirm?.type === 'delete',
        onOpenChange: (o)=>{
            if (!o && !busy) setConfirm(null);
        },
        title: t('patient.files.deletion.confirm', {
            name: confirm?.file?.fileName || ''
        }),
        description: t('patient.files.deletion.keeps'),
        confirmLabel: t('patient.files.deletion.confirmLabel'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        loading: busy,
        onConfirm: ()=>doDelete(confirm.file),
        confirmTestId: "file-delete-confirm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirm?.type === 'largeDownload',
        onOpenChange: (o)=>{
            if (!o) setConfirm(null);
        },
        title: t('patient.files.download.largeTitle'),
        description: t('patient.files.download.largeMessage', {
            mb: formatDigits((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(confirm?.file?.fileSize))
        }),
        confirmLabel: t('patient.files.actions.download'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>doDownload(confirm.file)
    }));
    return {
        openDetail: openDetail,
        openUpload: openUpload,
        openExtract: openExtract,
        openViewer: openViewer,
        confirmIdentity: confirmIdentity,
        download: download,
        requestDelete: requestDelete,
        overlays: overlays,
        visits: visits
    };
}
var $489287129a199b1d$export$2e2bcd8739ae039 = $489287129a199b1d$export$513d4933d99292ab;







parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $huNwV = parcelRequire("huNwV");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $11d7bd64b06fae29$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "m9 14 2 2 4-4",
            key: "df797q"
        }
    ]
];
const $11d7bd64b06fae29$export$2e2bcd8739ae039 = (0, $9QBug.default)("clipboard-check", $11d7bd64b06fae29$export$3efd853dbb351e94);


var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");
// The AI treatment-plan review panel, docked under the «برنامه» section of the
// SOAP note (§13.3: AI-labelled until the doctor owns it). One AI call composes
// meds + labs + imaging + procedures, grounded in the whole SOAP note, the
// reviewed differentials and the patient's longitudinal history.
//
// The plan's prose is NOT edited here — it was written straight into the «برنامه»
// textarea above, which is the note the doctor signs. This panel carries only
// what is not prose: interaction warnings, the structured items to tick off, and
// the clinical rationale. All mutations live in the screen; this is render-only.
const $b567ba15159c8a42$var$planKey = (type, name)=>`${type}:${name}`;
// The four plan buckets, each mapped to a display name + optional sub-line.
const $b567ba15159c8a42$var$GROUPS = (t)=>[
        {
            key: 'med',
            title: t('visit.rx.medications'),
            field: 'medications',
            nameOf: (m)=>m.name,
            subOf: (m)=>[
                    m.dosage,
                    m.frequency,
                    m.duration ? t('visit.rx.forDuration', {
                        duration: m.duration
                    }) : '',
                    m.notes
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'lab',
            title: t('visit.orders.tests'),
            field: 'labTests',
            nameOf: (test)=>test.testName,
            subOf: (test)=>[
                    test.reason,
                    test.loincCode ? `LOINC ${test.loincCode}` : ''
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'imaging',
            title: t('patient.orderType.imaging'),
            field: 'imagingStudies',
            nameOf: (s)=>s.studyType,
            subOf: (s)=>[
                    s.modality,
                    [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 ")
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'procedure',
            title: t('visit.orders.paraclinical'),
            field: 'procedureOrders',
            nameOf: (p)=>p.name,
            subOf: (p)=>p.reason || ''
        }
    ];
const $b567ba15159c8a42$var$PlanCheckRow = ({ name: name, sub: sub, checked: checked, onToggle: onToggle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onToggle,
        "aria-pressed": checked,
        className: "w-full min-h-11 h-auto justify-start rounded-lg px-2 py-2 gap-2 hover:bg-transparent font-normal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.125rem',
            height: '1.125rem',
            borderRadius: '0.3125rem',
            flexShrink: 0,
            border: `1.5px solid ${checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: checked ? (0, $jTCZr.CT).accent : 'transparent',
            display: 'grid',
            placeItems: 'center'
        }
    }, checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        color: "#fff",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: (0, $jTCZr.C).textPrimary
        }
    }, name), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem',
            lineHeight: 1.5
        }
    }, sub)));
const $b567ba15159c8a42$var$MobileVisitPlan = ({ suggestion: suggestion, loading: loading, saving: saving, status: status, error: error, selected: selected, onToggle: onToggle, onGenerate: onGenerate, onConfirm: onConfirm, inprogress: inprogress, canGenerate: canGenerate, onClose: onClose, onRestore: onRestore, canRestore: canRestore = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    const confirmed = status === 'confirmed';
    const totalItems = suggestion ? $b567ba15159c8a42$var$GROUPS(t).reduce((n, g)=>n + (suggestion[g.field] || []).length, 0) : 0;
    const dropped = suggestion ? totalItems - selected.size : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-content",
        "data-state": suggestion ? 'content' : loading ? 'loading' : 'empty',
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$b4c46f7bd56514c0), {
        badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem'
            }
        }, confirmed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.5rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.C).greenLight,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('visit.state.confirmedAdj')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$c606e0dfdc515248), {
            label: t('visit.plan.basis')
        }), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            "data-testid": "visit-plan-close",
            "aria-label": t('common.actions.close'),
            onClick: onClose,
            style: {
                color: (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        })))
    }, t('credits.price.plan')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-error",
        style: {
            padding: '0.5rem 0.75rem',
            marginBottom: '0.625rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.C).redLight}`,
            borderRadius: '0.5rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk
        }
    }, error), canRestore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.625rem',
            marginBottom: '0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.CT).warn}`,
            borderRadius: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            lineHeight: 1.7
        }
    }, t('visit.plan.replacedNotice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 shrink-0 px-3 text-xs",
        "data-testid": "visit-plan-restore",
        onClick: onRestore,
        style: {
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        }
    }, t('visit.plan.restorePrevious'))), !suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.9,
            margin: '0 0 0.875rem'
        }
    }, t('visit.plan.explainer')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-generate",
        onClick: onGenerate,
        disabled: !canGenerate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.plan.generate')), !inprogress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            textAlign: 'center',
            marginTop: '0.5rem'
        }
    }, t('visit.plan.needsOpenVisit'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.5rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e031888e2d726c18$export$491ebe8eaed97507), {
        label: t('visit.plan.generating')
    })), suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, suggestion.interactionWarnings?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, suggestion.interactionWarnings.map((w, i)=>{
        const tone = (0, $e031888e2d726c18$export$4ca721b91274208a)(t)[w.severity] || (0, $e031888e2d726c18$export$4ca721b91274208a)(t).medium;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: '0.5rem 0.6875rem',
                borderRadius: '0.5rem',
                background: tone.bg,
                border: `1px solid ${(0, $jTCZr.soft)(tone.color, 0.35)}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.25rem',
                background: tone.color,
                color: '#fff',
                marginInlineEnd: '0.375rem'
            }
        }, tone.label), w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: tone.color
            }
        }, w.drugPair, " \xb7 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, w.description));
    })), $b567ba15159c8a42$var$GROUPS(t).map((g)=>{
        const rows = suggestion[g.field] || [];
        if (!rows.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.key,
            "data-testid": `visit-plan-group-${g.key}`,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.5rem 0.5rem 0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0.375rem 0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.CT).surface2,
                color: (0, $jTCZr.C).textSecondary
            }
        }, rows.length)), rows.map((it, i)=>{
            const name = g.nameOf(it);
            const key = $b567ba15159c8a42$var$planKey(g.key, name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b567ba15159c8a42$var$PlanCheckRow, {
                key: `${key}:${i}`,
                name: name,
                sub: g.subOf(it),
                checked: selected.has(key),
                onToggle: ()=>onToggle(key)
            });
        }));
    }), suggestion.clinicalRationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.625rem 0.75rem',
            borderRadius: '0.625rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: '0.25rem'
        }
    }, t('visit.copilot.clinicalRationale')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8
        }
    }, suggestion.clinicalRationale)), dropped > 0 && !confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-drift",
        style: {
            padding: '0.5rem 0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.CT).warn}`,
            borderRadius: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk,
            lineHeight: 1.7
        }
    }, t('visit.plan.editNoteHint', {
        count: dropped
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-confirm",
        onClick: onConfirm,
        disabled: saving || confirmed
    }, saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "#fff",
        thickness: 2
    }), " ", t('visit.plan.saving')) : confirmed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11d7bd64b06fae29$export$2e2bcd8739ae039), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.plan.approved')) : t('visit.plan.confirmWithCount', {
        count: selected.size
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-regenerate",
        onClick: onGenerate,
        disabled: saving,
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bF8pu.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.plan.regenerate')))));
};
var $b567ba15159c8a42$export$2e2bcd8739ae039 = $b567ba15159c8a42$var$MobileVisitPlan;




var $acw62 = parcelRequire("acw62");

var $9BgRG = parcelRequire("9BgRG");
function $f987ed8f19153509$export$b78e23134a4d4c2b({ active: active, visitKey: visitKey, onRequest: onRequest, back: back }) {
    const leavingRef = (0, $acw62.useRef)(false);
    const visitHref = (0, $acw62.useRef)(null);
    // The latest callbacks without re-arming the anchor on every render: re-running
    // the effect would push a fresh anchor each time.
    const latest = (0, $acw62.useRef)({
        onRequest: onRequest,
        back: back
    });
    latest.current = {
        onRequest: onRequest,
        back: back
    };
    (0, $acw62.useEffect)(()=>{
        if (!active) return undefined;
        leavingRef.current = false;
        const onPop = ()=>{
            if (leavingRef.current) {
                if (window.location.href === visitHref.current) latest.current.back?.();
                return;
            }
            if ((0, $9BgRG.overlayOwnsPop)()) return;
            // Put the anchor back so the URL does not change yet.
            window.history.pushState(null, '', window.location.href);
            latest.current.onRequest?.(()=>window.history.go(-(2 + (0, $9BgRG.overlayHistoryDepth)())));
        };
        visitHref.current = window.location.href;
        // Anchor the current state so the first popstate is catchable.
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', onPop);
        return ()=>window.removeEventListener('popstate', onPop);
    }, [
        active,
        visitKey
    ]);
    return (0, $acw62.useCallback)((run)=>{
        leavingRef.current = true;
        run?.();
    }, []);
}
var $f987ed8f19153509$export$2e2bcd8739ae039 = $f987ed8f19153509$export$b78e23134a4d4c2b;




var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $5JYPc = parcelRequire("5JYPc");
var $5MbI8 = parcelRequire("5MbI8");
var $9iIGe = parcelRequire("9iIGe");
var $amyVq = parcelRequire("amyVq");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $cT2Zr = parcelRequire("cT2Zr");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6fb6c94f3b917ca1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 5h8",
            key: "a7qcls"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 19h8",
            key: "c3s6r1"
        }
    ],
    [
        "path",
        {
            d: "m3 17 2 2 4-4",
            key: "1jhpwq"
        }
    ],
    [
        "path",
        {
            d: "m3 7 2 2 4-4",
            key: "1obspn"
        }
    ]
];
const $6fb6c94f3b917ca1$export$2e2bcd8739ae039 = (0, $9QBug.default)("list-checks", $6fb6c94f3b917ca1$export$3efd853dbb351e94);


var $8g4t5 = parcelRequire("8g4t5");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3645c7b532883384$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 14 4 9l5-5",
            key: "102s5s"
        }
    ],
    [
        "path",
        {
            d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
            key: "f3b9sd"
        }
    ]
];
const $3645c7b532883384$export$2e2bcd8739ae039 = (0, $9QBug.default)("undo-2", $3645c7b532883384$export$3efd853dbb351e94);


var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




// «پروسهٔ درمان» — the GraphQL documents and the pure helpers behind
// TreatmentProcessPanel (docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md §8).
//
// Its own module rather than more lines in Visit.shared.jsx, for one reason that
// matters at release time: every document here names fields only the doctor BFF
// that ships the treatment schema knows (`treatmentProcesses`, `isBundle`,
// `parts`). Kept apart, the orders tab's own catalogue query (SEARCH_CATALOG)
// is untouched, so a kit released ahead of that BFF costs the visit nothing but
// this panel — which hides itself on a schema that does not know it (see
// `isSchemaMissing`).
//
// The panel never derives a status or a lock. `ready`, `blockedReason`,
// `status` and the process status all come from clinicalencounter; what this
// module decides is only which AFFORDANCES to draw, and the service refuses
// anything drawn wrongly.


// ── Documents ────────────────────────────────────────────────────────────────
const $cc9c65451b327263$var$SESSION_FIELDS = 'id sessionNo appointmentId performerId performerType performedAt outcome voidedAt voidReason';
// A bundle's parts are TreatmentSteps one level down (D13: bundles do not nest),
// so they ask for everything a step does except `parts`.
const $cc9c65451b327263$var$STEP_CORE = `id processId sequenceNo catalogId orderType description urgency notes status sessionCount completedSessions approvedAt cancelledAt cancelReason ready blockedReason isBundle sessions{${$cc9c65451b327263$var$SESSION_FIELDS}}`;
const $cc9c65451b327263$var$STEP_FIELDS = `${$cc9c65451b327263$var$STEP_CORE} parts{${$cc9c65451b327263$var$STEP_CORE}}`;
const $cc9c65451b327263$var$PROCESS_FIELDS = `id appointmentId patientId doctorId title isSequential status createdAt cancelledAt cancelReason steps{${$cc9c65451b327263$var$STEP_FIELDS}}`;
const $cc9c65451b327263$export$ded596a6f695eb70 = `query TreatmentProcesses($appointmentId:ID,$patientId:ID){treatmentProcesses(appointmentId:$appointmentId,patientId:$patientId){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$9654bb78a2d6522c = `query TreatmentProcess($id:ID!){treatmentProcess(id:$id){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$437e33b36726a318 = `mutation CreateTreatmentProcess($input:CreateTreatmentProcessInput!){createTreatmentProcess(input:$input){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$bda37785cd9face4 = `mutation AddTreatmentStep($processId:ID!,$step:TreatmentStepInput!){addTreatmentStep(processId:$processId,step:$step){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$576c4c8d321ab8be = `mutation ReorderTreatmentSteps($processId:ID!,$orderIds:[ID!]!){reorderTreatmentSteps(processId:$processId,orderIds:$orderIds){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$6dd17c00d60d61ff = `mutation UpdateTreatmentProcess($processId:ID!,$title:String,$isSequential:Boolean){updateTreatmentProcess(processId:$processId,title:$title,isSequential:$isSequential){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$aac1481a680a885b = `mutation CancelTreatmentProcess($processId:ID!,$reason:String){cancelTreatmentProcess(processId:$processId,reason:$reason){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$77405f779326be7d = `mutation CancelTreatmentStep($orderId:ID!,$reason:String){cancelTreatmentStep(orderId:$orderId,reason:$reason){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$e270757d3cbed79f = `mutation RecordOrderSession($orderId:ID!,$appointmentId:ID,$sessionNo:Int){recordOrderSession(orderId:$orderId,appointmentId:$appointmentId,sessionNo:$sessionNo){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$472bbc624aac8d8 = `mutation VoidOrderSession($sessionId:ID!,$reason:String!){voidOrderSession(sessionId:$sessionId,reason:$reason){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$69e17ba6f90ba607 = `query SearchProcessCatalog($query:String,$orderType:String,$appointmentId:ID,$limit:Int,$offset:Int){searchClinicalOrderCatalog(query:$query,orderType:$orderType,appointmentId:$appointmentId,limit:$limit,offset:$offset){total entries{id orderType name nameEn nameAr category code codeSystem modality bodyPart inHouse isClinicOwned isBundle parts{childId quantity childName childOrderType}}}}`;
const $cc9c65451b327263$export$208e1de6c5d1e37f = 30;
async function $cc9c65451b327263$export$85f2b5118ae3d90f({ query: query = '', orderType: orderType = '', appointmentId: appointmentId = null, minQuery: minQuery = 2 } = {}) {
    const q = (query || '').trim();
    if (q && q.length < minQuery) return {
        entries: [],
        total: 0
    };
    const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($cc9c65451b327263$export$69e17ba6f90ba607, {
        query: q || null,
        orderType: orderType || null,
        appointmentId: appointmentId,
        limit: $cc9c65451b327263$export$208e1de6c5d1e37f,
        offset: 0
    });
    return {
        entries: data?.searchClinicalOrderCatalog?.entries || [],
        total: data?.searchClinicalOrderCatalog?.total || 0
    };
}
// ── Reading a process ────────────────────────────────────────────────────────
const $cc9c65451b327263$var$OPEN_STEP = new Set([
    'pending',
    'in_progress'
]);
const $cc9c65451b327263$var$LIVE_PROCESS = new Set([
    'PROPOSED',
    'APPROVED',
    'IN_PROGRESS'
]);
const $cc9c65451b327263$export$7aebe44be0193f30 = (step)=>$cc9c65451b327263$var$OPEN_STEP.has(step?.status || 'pending');
const $cc9c65451b327263$export$d3f4649a1e650bff = (process)=>$cc9c65451b327263$var$LIVE_PROCESS.has(process?.status);
const $cc9c65451b327263$export$5a1be7d780aea15d = (session)=>!!session?.voidedAt;
const $cc9c65451b327263$export$eecaad90352df6df = (process)=>!process?.cancelledAt && (process?.steps || []).length > 1 && (process?.steps || []).every((s)=>!s.approvedAt);
const $cc9c65451b327263$export$12467dc22e28ee1d = (process)=>(process?.steps || []).some((step)=>[
            step,
            ...step.parts || []
        ].some((s)=>(s.sessions || []).some((x)=>!$cc9c65451b327263$export$5a1be7d780aea15d(x))));
function $cc9c65451b327263$export$ed6ac67359824afd(process, step) {
    if (!process || !step) return process;
    return {
        ...process,
        steps: (process.steps || []).map((s)=>{
            if (s.id === step.id) return {
                ...s,
                ...step
            };
            if ((s.parts || []).some((p)=>p.id === step.id)) return {
                ...s,
                parts: s.parts.map((p)=>p.id === step.id ? {
                        ...p,
                        ...step
                    } : p)
            };
            return s;
        })
    };
}
function $cc9c65451b327263$export$1dac6939cf74bd(steps, from, delta) {
    const ids = (steps || []).map((s)=>s.id);
    const to = from + delta;
    if (from < 0 || from >= ids.length || to < 0 || to >= ids.length) return null;
    [ids[from], ids[to]] = [
        ids[to],
        ids[from]
    ];
    return ids;
}
function $cc9c65451b327263$export$5b2832ec8df1654c(entry, sessionCount = 1) {
    const n = Math.max(1, Math.min(100, parseInt(sessionCount, 10) || 1));
    return {
        catalogId: entry.id || null,
        orderType: entry.orderType || null,
        description: entry.name || null,
        code: entry.code || null,
        // D14: a bundle is ONE session, and the BFF ignores the field for one.
        // Sending it anyway would only put a number on the wire nobody reads.
        ...entry.isBundle ? {} : {
            sessionCount: n
        }
    };
}
// ── Errors ───────────────────────────────────────────────────────────────────
// ORDER_NOT_READY carries `extensions.reason` as well as its key, and the
// reason is the contract (docs/ERROR_CODES.md): a BFF that sent the code but a
// key this catalogue does not know still gets the right sentence.
const $cc9c65451b327263$var$REASON_KEYS = {
    NOT_APPROVED: 'errors.bff.treatment.notApproved',
    WAITING_PREVIOUS: 'errors.bff.treatment.waitingPrevious',
    CLOSED: 'errors.bff.treatment.closed',
    PROCESS_CANCELLED: 'errors.bff.treatment.processCancelled',
    BUNDLE_PARENT: 'errors.bff.treatment.bundleParent'
};
// Failures that never reached a resolver: the BFF has no sentence for them, and
// «ثبت انجام شد با خطا مواجه شد» would hide that it is the network.
const $cc9c65451b327263$var$TRANSPORT_KINDS = new Set([
    (0, $91f57610161f2da8$export$896afd8541959ee5).OFFLINE,
    (0, $91f57610161f2da8$export$896afd8541959ee5).NETWORK,
    (0, $91f57610161f2da8$export$896afd8541959ee5).TIMEOUT,
    (0, $91f57610161f2da8$export$896afd8541959ee5).MAINTENANCE,
    (0, $91f57610161f2da8$export$896afd8541959ee5).UNAUTHENTICATED
]);
function $cc9c65451b327263$export$2cc0e11189006055(t, has, err, fallbackKey) {
    const key = err?.extensions?.messageKey;
    const knows = (k)=>typeof has === 'function' && has(k);
    if (key && knows(key)) return t(key);
    const reasonKey = err?.extensions?.code === 'ORDER_NOT_READY' && $cc9c65451b327263$var$REASON_KEYS[err?.extensions?.reason];
    if (reasonKey) return t(reasonKey);
    const kind = (0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(err);
    if ($cc9c65451b327263$var$TRANSPORT_KINDS.has(kind)) return t(`${(0, $91f57610161f2da8$export$78353e7f4dfe1b54)(kind)}.title`);
    const message = String(err?.message || '');
    if (key && message) return message;
    return t(fallbackKey);
}
function $cc9c65451b327263$export$c2acac313c7201fb(err) {
    const errors = err?.graphQLErrors || (err?.extensions ? [
        err
    ] : []);
    return errors.some((e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' && /treatmentProcess|TreatmentProcess/.test(String(e?.message || '')));
}


// ─────────────────────────────────────────────────────────────────────────────
// «پروسهٔ درمان» — docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md §8, the
// doctor's side.
//
// The doctor attaches a list of catalogue services to this visit and decides
// whether they must happen in order. The CLINIC approves it (never the doctor);
// after that the doctor may still add steps (they arrive unapproved, at the
// end), cancel a step or the whole process, record a session they performed
// themselves («انجام شد») and void one.
//
// Nothing here derives a state. `ready`, `blockedReason`, the step status and
// the process status are clinicalencounter's; the panel only chooses which
// affordance to draw, and after any write to a step it re-reads the whole
// process, because one step's session can unlock the next one's.
//
// Styling note: Tailwind classes, and never the `navy`/`primary`/`accent`
// colours — the visit room redefines `--primary` and `--accent` on :root as
// plain colours (Visit.shared.jsx CSS_VARS), which turns `hsl(var(--primary))`
// into nothing. `--p-*` and `--chip-*` are the tokens that survive both the
// desktop room and the phone one, which does not inject CSS_VARS at all.
//
// `compact` is the phone's reduction of the same panel: 44px targets, rows that
// wrap their actions onto a second line, and a stacked picker.
// ─────────────────────────────────────────────────────────────────────────────
const $0385119c9c941a3e$var$PROCESS_STATUS = {
    PROPOSED: [
        'proposed',
        'warning'
    ],
    APPROVED: [
        'approved',
        'info'
    ],
    IN_PROGRESS: [
        'inProgress',
        'info'
    ],
    COMPLETED: [
        'completed',
        'success'
    ],
    CANCELLED: [
        'cancelled',
        'muted'
    ]
};
const $0385119c9c941a3e$var$STEP_TONE = {
    in_progress: 'info',
    completed: 'success',
    cancelled: 'muted'
};
const $0385119c9c941a3e$var$LOCK_KEYS = {
    NOT_APPROVED: 'notApproved',
    WAITING_PREVIOUS: 'waitingPrevious'
};
function $0385119c9c941a3e$var$Tone({ tone: tone, className: className, children: children, ...rest }) {
    const variant = tone === 'success' || tone === 'warning' ? tone : 'outline';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: variant,
        className: (0, $5JYPc.cn)('gap-1 text-[10.5px] px-2', tone === 'info' && 'border-[var(--p-teal)] bg-[var(--p-teal-light)] text-[var(--p-navy-dark)]', tone === 'muted' && 'text-muted-foreground', className),
        ...rest
    }, children);
}
function $0385119c9c941a3e$var$BundleBadge({ count: count, testId: testId }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "info",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc10787427ff9cd4$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": true
    }), t('visit.process.bundleParts', {
        count: count
    }));
}
// ── Catalogue picker ─────────────────────────────────────────────────────────
// The orders tab's picker rules (server page, browse on an empty query, «keep
// typing» under ORDER_MIN_QUERY) over a document that also returns bundles.
function $0385119c9c941a3e$var$StepPicker({ appointmentId: appointmentId, compact: compact, busy: busy, submitLabel: submitLabel, hint: hint, onAdd: onAdd, onClose: onClose, testId: testId }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [type, setType] = (0, $acw62.useState)('all');
    const [page, setPage] = (0, $acw62.useState)({
        loading: true,
        error: null,
        entries: [],
        total: 0
    });
    const [picked, setPicked] = (0, $acw62.useState)(null);
    const [sessions, setSessions] = (0, $acw62.useState)('1');
    const typeLabels = (0, $375f8776645d5aee$export$e867161a6e6ed178)(t);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        setPage((p)=>({
                ...p,
                loading: true,
                error: null
            }));
        const handle = setTimeout(()=>{
            (0, $cc9c65451b327263$export$85f2b5118ae3d90f)({
                query: query,
                orderType: type === 'all' ? '' : type,
                appointmentId: appointmentId,
                minQuery: (0, $375f8776645d5aee$export$6770277ab0ca292e)
            }).then((r)=>{
                if (live) setPage({
                    loading: false,
                    error: null,
                    ...r
                });
            }).catch((error)=>{
                if (live) setPage({
                    loading: false,
                    error: error,
                    entries: [],
                    total: 0
                });
            });
        }, query ? 250 : 0);
        return ()=>{
            live = false;
            clearTimeout(handle);
        };
    }, [
        query,
        type,
        appointmentId
    ]);
    const submit = async ()=>{
        if (!picked) return;
        const entry = picked;
        const ok = await onAdd(entry, sessions);
        // Only clear what was added: a second pick made while the write was in
        // flight is the doctor's next step, not something to throw away.
        if (ok !== false) {
            setPicked((cur)=>cur === entry ? null : cur);
            setSessions('1');
        }
    };
    const q = query.trim();
    const typeOptions = [
        {
            value: 'all',
            label: t('common.state.all')
        },
        {
            value: 'procedure',
            label: typeLabels.procedure
        },
        {
            value: 'lab',
            label: typeLabels.lab
        },
        {
            value: 'imaging',
            label: typeLabels.imaging
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex gap-2', compact ? 'flex-col' : 'items-center')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(compact && 'max-w-full overflow-x-auto')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        size: compact ? 'lg' : 'sm',
        ariaLabel: t('visit.process.typeFilter'),
        options: typeOptions,
        value: type,
        onChange: setType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        className: "flex-1",
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('visit.orders.searchCatalog'),
        clearLabel: t('common.actions.clearSearch'),
        inputProps: {
            'data-testid': `${testId}-search`
        }
    })), page.loading && !page.entries.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        className: "flex flex-col gap-1.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    })) : page.error ? // Said out loud: a picker that silently lists nothing reads as a
    // catalogue that does not carry the service.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        "data-testid": `${testId}-error`,
        className: "m-0 text-xs text-destructive"
    }, t('visit.orders.catalogSearchFailed')) : page.entries.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": `${testId}-empty`,
        className: "m-0 text-xs text-muted-foreground"
    }, q && q.length < (0, $375f8776645d5aee$export$6770277ab0ca292e) ? t('visit.orders.keepTyping') : t('visit.orders.noCatalogMatch')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `${testId}-results`,
        className: "m-0 p-0 list-none max-h-56 overflow-y-auto flex flex-col gap-1"
    }, page.entries.map((entry)=>{
        const names = (0, $375f8776645d5aee$export$adea16e688375bbf)(entry, readsPersianData, entry?.nameAr);
        const selected = picked?.id === entry.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: entry.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            "aria-pressed": selected,
            "data-testid": `${testId}-entry-${entry.id}`,
            onClick: ()=>setPicked(entry),
            className: (0, $5JYPc.cn)('w-full h-auto justify-start gap-2 px-2 py-1.5 font-normal text-start', compact ? 'min-h-11' : 'min-h-9', selected && 'bg-muted ring-1 ring-border')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex-1 min-w-0 flex flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[12.5px] font-semibold text-foreground truncate"
        }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[10.5px] text-muted-foreground truncate"
        }, names.secondary)), entry.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (entry.parts || []).length,
            testId: `${testId}-bundle-${entry.id}`
        }), entry.inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
            tone: "success"
        }, t('visit.orders.thisClinic')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[10.5px] text-muted-foreground whitespace-nowrap"
        }, typeLabels[entry.orderType] || entry.orderType)));
    }), page.total > page.entries.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "text-center text-[11px] text-muted-foreground py-1"
    }, t('visit.rx.moreResults', {
        shown: page.entries.length,
        total: page.total
    }))), picked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-picked`,
        className: "rounded-lg bg-muted p-2.5 flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 flex-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[12.5px] font-bold text-foreground"
    }, (0, $375f8776645d5aee$export$adea16e688375bbf)(picked, readsPersianData, picked?.nameAr).primary), picked.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
        count: (picked.parts || []).length
    })), picked.isBundle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `${testId}-parts`,
        className: "m-0 p-0 list-none flex flex-col gap-0.5"
    }, (picked.parts || []).map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: part.childId,
            className: "flex items-center gap-1.5 text-[11.5px] text-foreground"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc10787427ff9cd4$export$2e2bcd8739ae039), {
            size: 11,
            "aria-hidden": true,
            className: "text-muted-foreground"
        }), part.childName || part.childId, part.quantity > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, t('visit.process.sessionsLabel', {
            count: part.quantity
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[11px] text-muted-foreground"
    }, t('visit.process.bundleFixed'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "w-28"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9iIGe.default), {
        label: t('visit.process.sessionCount'),
        value: sessions,
        onChange: (e)=>setSessions(e.target.value),
        validate: ()=>'',
        "data-testid": `${testId}-sessions`
    })), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[11px] text-muted-foreground"
    }, hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center justify-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        disabled: busy,
        onClick: submit,
        "data-testid": `${testId}-add`,
        className: (0, $5JYPc.cn)('gap-1.5', compact && 'min-h-11')
    }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), submitLabel))), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onClose,
        "data-testid": `${testId}-close`,
        className: (0, $5JYPc.cn)(compact && 'min-h-11')
    }, t('common.actions.close'))));
}
// ── Reorder arrows ───────────────────────────────────────────────────────────
function $0385119c9c941a3e$var$MoveButtons({ name: name, index: index, count: count, disabled: disabled, compact: compact, onMove: onMove, testId: testId }) {
    const { t: t } = (0, $LNQP4.default)();
    const size = compact ? 44 : 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "inline-flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: size,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
            size: 14,
            "aria-hidden": true
        }),
        label: t('visit.process.moveUp', {
            name: name
        }),
        disabled: disabled || index === 0,
        onClick: ()=>onMove(index, -1),
        "data-testid": `${testId}-up`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: size,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 14,
            "aria-hidden": true
        }),
        label: t('visit.process.moveDown', {
            name: name
        }),
        disabled: disabled || index === count - 1,
        onClick: ()=>onMove(index, 1),
        "data-testid": `${testId}-down`
    }));
}
// ── Builder: the process before it exists ───────────────────────────────────
let $0385119c9c941a3e$var$draftSeq = 0;
function $0385119c9c941a3e$var$ProcessBuilder({ appointmentId: appointmentId, compact: compact, busy: busy, onCreate: onCreate, onClose: onClose }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [title, setTitle] = (0, $acw62.useState)('');
    const [sequential, setSequential] = (0, $acw62.useState)(false);
    const [draft, setDraft] = (0, $acw62.useState)([]);
    const add = (entry, sessions)=>{
        $0385119c9c941a3e$var$draftSeq += 1;
        setDraft((d)=>[
                ...d,
                {
                    key: `d${$0385119c9c941a3e$var$draftSeq}`,
                    entry: entry,
                    sessions: sessions || '1'
                }
            ]);
        return true;
    };
    const move = (from, delta)=>setDraft((d)=>{
            const to = from + delta;
            if (to < 0 || to >= d.length) return d;
            const next = [
                ...d
            ];
            [next[from], next[to]] = [
                next[to],
                next[from]
            ];
            return next;
        });
    const remove = (key)=>setDraft((d)=>d.filter((x)=>x.key !== key));
    const setSessions = (key, value)=>setDraft((d)=>d.map((x)=>x.key === key ? {
                    ...x,
                    sessions: value
                } : x));
    const submit = ()=>onCreate({
            title: title.trim() || null,
            isSequential: sequential,
            steps: draft.map((d)=>(0, $cc9c65451b327263$export$5b2832ec8df1654c)(d.entry, d.sessions))
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-process-builder",
        className: "rounded-[10px] border border-dashed border-border p-3 flex flex-col gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('grid gap-3', compact ? 'grid-cols-1' : 'grid-cols-[1fr_auto] items-end')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.process.titleLabel'),
        placeholder: t('visit.process.titlePlaceholder'),
        value: title,
        onChange: (e)=>setTitle(e.target.value),
        "data-testid": "visit-process-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex items-center gap-2 text-[12px] font-semibold text-foreground', compact ? 'min-h-11' : 'h-11')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cT2Zr.default), {
        checked: sequential,
        onChange: setSequential,
        label: t('visit.process.sequential')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.process.sequential')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[11px] text-muted-foreground"
    }, t('visit.process.sequentialHint')), draft.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-draft-empty",
        className: "m-0 text-xs text-muted-foreground"
    }, t('visit.process.draftEmpty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        "data-testid": "visit-process-draft",
        className: "m-0 p-0 list-none flex flex-col divide-y divide-border rounded-lg border border-border"
    }, draft.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: d.key,
            "data-testid": `visit-process-draft-${i}`,
            className: (0, $5JYPc.cn)('flex items-center gap-2 px-2 py-1.5', compact && 'flex-wrap')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "w-5 h-5 shrink-0 grid place-items-center rounded-full bg-muted text-[11px] font-bold text-muted-foreground"
        }, formatNumber(i + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex-1 min-w-0 text-[12.5px] font-semibold text-foreground truncate"
        }, d.entry.name), d.entry.isBundle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (d.entry.parts || []).length
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "w-20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9iIGe.default), {
            "aria-label": t('visit.process.sessionCount'),
            value: d.sessions,
            onChange: (e)=>setSessions(d.key, e.target.value),
            validate: ()=>'',
            "data-testid": `visit-process-draft-${i}-sessions`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$MoveButtons, {
            name: d.entry.name,
            index: i,
            count: draft.length,
            compact: compact,
            onMove: move,
            testId: `visit-process-draft-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 26,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 14,
                "aria-hidden": true
            }),
            label: t('visit.process.removeStep', {
                name: d.entry.name
            }),
            onClick: ()=>remove(d.key),
            "data-testid": `visit-process-draft-${i}-remove`
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepPicker, {
        appointmentId: appointmentId,
        compact: compact,
        submitLabel: t('visit.process.addStep'),
        onAdd: add,
        testId: "visit-process-builder-picker"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center justify-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: onClose,
        disabled: busy,
        "data-testid": "visit-process-builder-cancel",
        className: (0, $5JYPc.cn)(compact && 'min-h-11')
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        onClick: submit,
        disabled: busy || draft.length === 0,
        "data-testid": "visit-process-create",
        className: (0, $5JYPc.cn)('gap-1.5', compact && 'min-h-11')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }), busy ? t('visit.process.creating') : t('visit.process.create'))));
}
// ── One process ──────────────────────────────────────────────────────────────
function $0385119c9c941a3e$var$StepChips({ step: step, readiness: readiness = true }) {
    const { t: t } = (0, $LNQP4.default)();
    const status = step.status || 'pending';
    const lock = $0385119c9c941a3e$var$LOCK_KEYS[step.blockedReason];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, status !== 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: $0385119c9c941a3e$var$STEP_TONE[status],
        "data-testid": `visit-process-step-${step.id}-status`
    }, status === 'completed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 10,
        "aria-hidden": true
    }), t(`common.orderStatus.${status}`)), readiness && lock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: lock === 'notApproved' ? 'warning' : 'muted',
        "data-testid": `visit-process-step-${step.id}-lock`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
        size: 10,
        "aria-hidden": true
    }), t(`visit.process.blocked.${lock}`)), readiness && !lock && step.ready && status === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "info",
        "data-testid": `visit-process-step-${step.id}-ready`
    }, t('visit.process.ready')));
}
function $0385119c9c941a3e$var$Sessions({ step: step, editable: editable, busy: busy, compact: compact, onVoid: onVoid }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const sessions = [
        ...step.sessions || []
    ].sort((a, b)=>a.sessionNo - b.sessionNo);
    if (!sessions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `visit-process-step-${step.id}-sessions`,
        className: "m-0 p-0 list-none flex flex-wrap gap-1.5"
    }, sessions.map((s)=>{
        const voided = (0, $cc9c65451b327263$export$5a1be7d780aea15d)(s);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: s.id,
            "data-testid": `visit-process-session-${s.id}`,
            "data-voided": voided || undefined,
            className: "inline-flex items-center gap-1 rounded-full border border-border bg-white ps-2 pe-1 py-0.5 text-[11px] text-foreground"
        }, voided ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3645c7b532883384$export$2e2bcd8739ae039), {
            size: 11,
            "aria-hidden": true,
            className: "text-muted-foreground"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true,
            className: "text-[var(--chip-success-ink)]"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $5JYPc.cn)(voided && 'line-through text-muted-foreground')
        }, t('visit.process.session', {
            no: s.sessionNo
        })), !voided && s.performedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, formatDate(s.performedAt, 'short')), voided && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, s.voidReason ? t('visit.process.voidedReason', {
            reason: s.voidReason
        }) : t('visit.process.voided')), editable && !voided && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 20,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3645c7b532883384$export$2e2bcd8739ae039), {
                size: 11,
                "aria-hidden": true
            }),
            label: t('visit.process.voidSessionAria', {
                no: s.sessionNo,
                name: step.description
            }),
            disabled: busy,
            onClick: ()=>onVoid(step, s),
            "data-testid": `visit-process-session-${s.id}-void`
        }));
    }));
}
function $0385119c9c941a3e$var$DoneButton({ step: step, busy: busy, spinning: spinning, compact: compact, onRecord: onRecord }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        disabled: busy,
        onClick: ()=>onRecord(step),
        "aria-label": t('visit.process.markDoneAria', {
            name: step.description
        }),
        "data-testid": `visit-process-step-${step.id}-done`,
        className: (0, $5JYPc.cn)('gap-1 shrink-0', compact ? 'min-h-11 px-3' : 'h-7 px-2.5')
    }, spinning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 11,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": true
    }), t('visit.process.markDone'));
}
function $0385119c9c941a3e$var$ProcessCard({ process: process, editable: editable, compact: compact, busy: busy, earlier: earlier, appointmentId: appointmentId, onMove: onMove, onToggleSequential: onToggleSequential, onAddStep: onAddStep, onRecord: onRecord, onCancelStep: onCancelStep, onCancelProcess: onCancelProcess, onVoid: onVoid }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $LNQP4.default)();
    const [adding, setAdding] = (0, $acw62.useState)(false);
    const live = (0, $cc9c65451b327263$export$d3f4649a1e650bff)(process);
    const cancelled = !!process.cancelledAt || process.status === 'CANCELLED';
    const steps = process.steps || [];
    const reorderable = editable && (0, $cc9c65451b327263$export$eecaad90352df6df)(process);
    const sequentialLocked = (0, $cc9c65451b327263$export$12467dc22e28ee1d)(process);
    const anyApproved = steps.some((s)=>!!s.approvedAt);
    const [statusKey, statusTone] = $0385119c9c941a3e$var$PROCESS_STATUS[process.status] || $0385119c9c941a3e$var$PROCESS_STATUS.PROPOSED;
    const isBusy = !!busy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("article", {
        "data-testid": `visit-process-${process.id}`,
        "data-status": process.status,
        className: "rounded-[10px] border border-border bg-white overflow-hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center gap-2 px-3 py-2 border-b border-border bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[12.5px] font-bold text-foreground min-w-0 truncate"
    }, process.title || t('visit.process.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: statusTone,
        "data-testid": `visit-process-${process.id}-status`
    }, t(`visit.process.status.${statusKey}`)), earlier && process.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[11px] text-muted-foreground"
    }, formatDate(process.createdAt, 'medium')), !editable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[11px] text-muted-foreground"
    }, t('visit.process.otherDoctor')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex items-center gap-2', compact ? 'w-full justify-between' : 'ms-auto')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 text-[11.5px] text-muted-foreground",
        title: editable && live && sequentialLocked ? t('visit.process.sequentialLocked') : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cT2Zr.default), {
        checked: !!process.isSequential,
        onChange: (next)=>onToggleSequential(process, next),
        disabled: !editable || cancelled || !live || sequentialLocked || isBusy,
        label: t('visit.process.sequential')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.process.sequential'))), editable && live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        disabled: isBusy,
        onClick: ()=>onCancelProcess(process),
        "data-testid": `visit-process-${process.id}-cancel`,
        className: (0, $5JYPc.cn)('text-destructive', compact ? 'min-h-11 px-3' : 'h-7 px-2')
    }, t('visit.process.cancelProcess')))), cancelled && process.cancelReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 px-3 pt-2 text-[11.5px] text-muted-foreground"
    }, t('visit.process.cancelledWithReason', {
        reason: process.cancelReason
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        className: "m-0 p-0 list-none flex flex-col divide-y divide-border"
    }, steps.map((step, i)=>{
        const open = (0, $cc9c65451b327263$export$7aebe44be0193f30)(step);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: step.id,
            "data-testid": `visit-process-step-${step.id}`,
            "data-ready": step.ready ? 'true' : 'false',
            "data-blocked": step.blockedReason || undefined,
            className: "px-3 py-2 flex flex-col gap-1.5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('flex items-center gap-2', compact && 'flex-wrap')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "w-5 h-5 shrink-0 grid place-items-center rounded-full bg-muted text-[11px] font-bold text-muted-foreground"
        }, formatNumber(i + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $5JYPc.cn)('min-w-0 truncate text-[12.5px] font-semibold text-foreground', step.status === 'cancelled' && 'line-through text-muted-foreground')
        }, step.description), step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (step.parts || []).length,
            testId: `visit-process-step-${step.id}-bundle`
        }), step.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `visit-process-step-${step.id}-progress`,
            className: "text-[11px] text-muted-foreground whitespace-nowrap"
        }, t('visit.process.sessionsProgress', {
            done: step.completedSessions || 0,
            total: step.sessionCount
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepChips, {
            step: step
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('flex items-center gap-1 shrink-0', compact ? 'w-full justify-end' : 'ms-auto')
        }, reorderable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$MoveButtons, {
            name: step.description,
            index: i,
            count: steps.length,
            compact: compact,
            disabled: isBusy,
            onMove: (from, delta)=>onMove(process, from, delta),
            testId: `visit-process-step-${step.id}`
        }), editable && step.ready && !step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$DoneButton, {
            step: step,
            busy: isBusy,
            spinning: busy === `record:${step.id}`,
            compact: compact,
            onRecord: (s)=>onRecord(process, s)
        }), editable && open && !cancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            disabled: isBusy,
            onClick: ()=>onCancelStep(process, step),
            "data-testid": `visit-process-step-${step.id}-cancel`,
            className: (0, $5JYPc.cn)('text-destructive', compact ? 'min-h-11 px-3' : 'h-7 px-2')
        }, t('visit.process.cancelStep')))), step.status === 'cancelled' && step.cancelReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0 ps-7 text-[11px] text-muted-foreground"
        }, t('visit.process.cancelledWithReason', {
            reason: step.cancelReason
        })), !step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Sessions, {
            step: step,
            editable: editable,
            busy: isBusy,
            compact: compact,
            onVoid: (s, x)=>onVoid(process, s, x)
        })), step.isBundle && // The parts are fixed (D13): no reorder, no cancel of their own
        // (D16). Each is performed — and recorded — on its own; the
        // bundle completes, and bills once, with the last of them.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "data-testid": `visit-process-step-${step.id}-parts`,
            className: "m-0 ps-7 list-none flex flex-col gap-1"
        }, (step.parts || []).map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: part.id,
                "data-testid": `visit-process-part-${part.id}`,
                className: "flex flex-col gap-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $5JYPc.cn)('flex items-center gap-2', compact && 'flex-wrap')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc10787427ff9cd4$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": true,
                className: "shrink-0 text-muted-foreground"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $5JYPc.cn)('min-w-0 truncate text-[12px] text-foreground', part.status === 'cancelled' && 'line-through text-muted-foreground')
            }, part.description), part.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "text-[11px] text-muted-foreground whitespace-nowrap"
            }, t('visit.process.sessionsProgress', {
                done: part.completedSessions || 0,
                total: part.sessionCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepChips, {
                step: part,
                readiness: false
            }), editable && part.ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $5JYPc.cn)('flex items-center', compact ? 'w-full justify-end' : 'ms-auto')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$DoneButton, {
                step: part,
                busy: isBusy,
                spinning: busy === `record:${part.id}`,
                compact: compact,
                onRecord: (s)=>onRecord(process, s)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Sessions, {
                step: part,
                editable: editable,
                busy: isBusy,
                compact: compact,
                onVoid: (s, x)=>onVoid(process, s, x)
            })))));
    })), editable && !cancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "px-3 py-2 border-t border-border"
    }, adding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepPicker, {
        appointmentId: appointmentId,
        compact: compact,
        busy: busy === `add:${process.id}`,
        submitLabel: t('visit.process.addToProcess'),
        hint: anyApproved ? t('visit.process.lateStepHint') : null,
        onAdd: async (entry, sessions)=>{
            const ok = await onAddStep(process, entry, sessions);
            if (ok) setAdding(false);
            return ok;
        },
        onClose: ()=>setAdding(false),
        testId: `visit-process-${process.id}-picker`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        disabled: isBusy,
        onClick: ()=>setAdding(true),
        "data-testid": `visit-process-${process.id}-add`,
        className: (0, $5JYPc.cn)('gap-1', compact ? 'min-h-11 px-3' : 'h-7 px-2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.addStep'))));
}
function $0385119c9c941a3e$export$2e2bcd8739ae039({ appointmentId: appointmentId, patientId: patientId, doctorId: doctorId, compact: compact = false, className: className }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [processes, setProcesses] = (0, $acw62.useState)(null);
    const [loadError, setLoadError] = (0, $acw62.useState)(null);
    const [unsupported, setUnsupported] = (0, $acw62.useState)(false);
    const [actionError, setActionError] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(null);
    const [building, setBuilding] = (0, $acw62.useState)(false);
    const [showEarlier, setShowEarlier] = (0, $acw62.useState)(false);
    const [confirm, setConfirm] = (0, $acw62.useState)(null);
    const [reason, setReason] = (0, $acw62.useState)('');
    const loadSeq = (0, $acw62.useRef)(0);
    const busyRef = (0, $acw62.useRef)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!appointmentId) return;
        const seq = ++loadSeq.current;
        setLoadError(null);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $cc9c65451b327263$export$ded596a6f695eb70), patientId ? {
                patientId: patientId
            } : {
                appointmentId: appointmentId
            });
            if (seq === loadSeq.current) setProcesses(data?.treatmentProcesses || []);
        } catch (err) {
            if (seq !== loadSeq.current) return;
            if ((0, $cc9c65451b327263$export$c2acac313c7201fb)(err)) setUnsupported(true);
            else setLoadError(err);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        setProcesses(null);
        load();
    }, [
        load
    ]);
    const putProcess = (p)=>{
        if (!p) return;
        setProcesses((prev)=>{
            const list = prev || [];
            return list.some((x)=>x.id === p.id) ? list.map((x)=>x.id === p.id ? p : x) : [
                p,
                ...list
            ];
        });
    };
    // One write at a time across the panel: two taps on «انجام شد» must not be
    // two sessions, and a reorder must not race a cancel.
    const run = async (key, fallbackKey, fn)=>{
        if (busyRef.current) return false;
        busyRef.current = key;
        setBusy(key);
        setActionError(null);
        try {
            await fn();
            return true;
        } catch (err) {
            setActionError((0, $cc9c65451b327263$export$2cc0e11189006055)(t, has, err, fallbackKey));
            return false;
        } finally{
            busyRef.current = null;
            setBusy(null);
        }
    };
    // A step write answers with that step only, but its session may have opened
    // the next step of a sequential process and moved the process status — so the
    // whole process is read back. If that read fails the step itself is already
    // current, and the rest is re-read on the next load.
    const afterStepWrite = async (process, step)=>{
        if (step) setProcesses((prev)=>(prev || []).map((x)=>x.id === process.id ? (0, $cc9c65451b327263$export$ed6ac67359824afd)(x, step) : x));
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $cc9c65451b327263$export$9654bb78a2d6522c), {
                id: process.id
            });
            putProcess(data?.treatmentProcess);
        } catch  {}
    };
    const create = (input)=>run('create', 'errors.bff.treatment.createFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$437e33b36726a318), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patientId,
                    title: input.title,
                    isSequential: input.isSequential,
                    steps: input.steps
                }
            });
            putProcess(data?.createTreatmentProcess);
            setBuilding(false);
        });
    const addStep = (process, entry, sessions)=>run(`add:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$bda37785cd9face4), {
                processId: process.id,
                step: (0, $cc9c65451b327263$export$5b2832ec8df1654c)(entry, sessions)
            });
            putProcess(data?.addTreatmentStep);
        });
    const move = (process, from, delta)=>{
        const orderIds = (0, $cc9c65451b327263$export$1dac6939cf74bd)(process.steps, from, delta);
        if (!orderIds) return;
        run(`move:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$576c4c8d321ab8be), {
                processId: process.id,
                orderIds: orderIds
            });
            putProcess(data?.reorderTreatmentSteps);
        });
    };
    const toggleSequential = (process, next)=>run(`seq:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$6dd17c00d60d61ff), {
                processId: process.id,
                isSequential: next
            });
            putProcess(data?.updateTreatmentProcess);
        });
    const record = (process, step)=>run(`record:${step.id}`, 'errors.bff.treatment.recordFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$e270757d3cbed79f), {
                orderId: step.id,
                appointmentId: appointmentId
            });
            await afterStepWrite(process, data?.recordOrderSession);
        });
    const ask = (next)=>{
        setReason('');
        setConfirm(next);
    };
    const confirmNow = ()=>{
        const c = confirm;
        const why = reason.trim();
        if (!c) return;
        if (c.kind === 'cancelProcess') run(`cancel:${c.process.id}`, 'errors.bff.treatment.cancelFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$aac1481a680a885b), {
                processId: c.process.id,
                reason: why || null
            });
            putProcess(data?.cancelTreatmentProcess);
        });
        else if (c.kind === 'cancelStep') run(`cancel:${c.step.id}`, 'errors.bff.treatment.cancelFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$77405f779326be7d), {
                orderId: c.step.id,
                reason: why || null
            });
            await afterStepWrite(c.process, data?.cancelTreatmentStep);
        });
        else if (c.kind === 'void' && why) run(`void:${c.session.id}`, 'errors.bff.treatment.voidFailed', async ()=>{
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $cc9c65451b327263$export$472bbc624aac8d8), {
                sessionId: c.session.id,
                reason: why
            });
            await afterStepWrite(c.process, data?.voidOrderSession);
        });
    };
    if (unsupported) return null;
    const list = processes || [];
    const thisVisit = list.filter((p)=>p.appointmentId === appointmentId);
    const earlier = list.filter((p)=>p.appointmentId !== appointmentId && (0, $cc9c65451b327263$export$d3f4649a1e650bff)(p));
    const editableOf = (p)=>doctorId ? p.doctorId === doctorId : p.appointmentId === appointmentId;
    const canBuild = !!appointmentId && !!patientId && processes !== null && !building;
    const cardProps = {
        compact: compact,
        busy: busy,
        appointmentId: appointmentId,
        onMove: move,
        onToggleSequential: toggleSequential,
        onAddStep: addStep,
        onRecord: record,
        onCancelStep: (process, step)=>ask({
                kind: 'cancelStep',
                process: process,
                step: step
            }),
        onCancelProcess: (process)=>ask({
                kind: 'cancelProcess',
                process: process
            }),
        onVoid: (process, step, session)=>ask({
                kind: 'void',
                process: process,
                step: step,
                session: session
            })
    };
    const dialog = confirm && ({
        cancelProcess: {
            title: t('visit.process.cancelProcessTitle'),
            body: t('visit.process.cancelProcessBody'),
            confirm: t('visit.process.cancelProcess')
        },
        cancelStep: {
            title: t('visit.process.cancelStepTitle', {
                name: confirm.step?.description || ''
            }),
            body: t('visit.process.cancelStepBody'),
            confirm: t('visit.process.cancelStep')
        },
        void: {
            title: t('visit.process.voidTitle', {
                no: confirm.session?.sessionNo ?? '',
                name: confirm.step?.description || ''
            }),
            body: t('visit.process.voidBody'),
            confirm: t('visit.process.voidConfirm')
        }
    })[confirm.kind];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": "visit-process-panel",
        "aria-label": t('visit.process.title'),
        className: (0, $5JYPc.cn)('rounded-[14px] border border-border bg-white overflow-hidden', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: "flex items-center justify-between gap-2 px-4 py-2.5 border-b border-border bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 text-[13px] font-semibold text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "grid place-items-center w-[22px] h-[22px] rounded-md bg-[var(--p-teal-light)] text-[var(--p-navy-dark)]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fb6c94f3b917ca1$export$2e2bcd8739ae039), {
        size: 12,
        "aria-hidden": true
    })), t('visit.process.title'), thisVisit.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "muted"
    }, formatNumber(thisVisit.length))), canBuild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>setBuilding(true),
        disabled: !!busy,
        "data-testid": "visit-process-new",
        className: (0, $5JYPc.cn)('gap-1', compact ? 'min-h-11' : 'h-8 px-3')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.new'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-3', compact ? 'p-3' : 'p-4')
    }, actionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        "data-testid": "visit-process-error",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 28,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 14,
                "aria-hidden": true
            }),
            label: t('errors.dismiss'),
            onClick: ()=>setActionError(null)
        })
    }, actionError), !appointmentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-needs-visit",
        className: "m-0 text-xs text-muted-foreground"
    }, t('visit.process.needsVisit')) : loadError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: loadError,
        title: t('visit.process.loadFailed'),
        onRetry: load
    }) : processes === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "visit-process-loading",
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 40
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 40
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, building && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessBuilder, {
        appointmentId: appointmentId,
        compact: compact,
        busy: busy === 'create',
        onCreate: create,
        onClose: ()=>setBuilding(false)
    }), thisVisit.length === 0 && !building && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-empty",
        className: "m-0 text-xs text-muted-foreground leading-6"
    }, t('visit.process.emptyHint')), thisVisit.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessCard, {
            key: p.id,
            process: p,
            editable: editableOf(p),
            ...cardProps
        })), earlier.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "aria-expanded": showEarlier,
        onClick: ()=>setShowEarlier((v)=>!v),
        "data-testid": "visit-process-earlier-toggle",
        className: (0, $5JYPc.cn)('self-start gap-1.5 text-muted-foreground', compact ? 'min-h-11' : 'h-8 px-2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c3425eadfb41de5$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.earlier'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "muted"
    }, formatNumber(earlier.length))), showEarlier && earlier.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessCard, {
            key: p.id,
            process: p,
            editable: editableOf(p),
            earlier: true,
            ...cardProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!confirm,
        onOpenChange: (open)=>{
            if (!open) {
                setConfirm(null);
                setReason('');
            }
        },
        title: dialog?.title,
        description: dialog?.body,
        confirmLabel: dialog?.confirm,
        destructive: true,
        confirmDisabled: confirm?.kind === 'void' && !reason.trim(),
        onConfirm: confirmNow,
        "data-testid": "visit-process-dialog",
        confirmTestId: "visit-process-dialog-confirm",
        cancelTestId: "visit-process-dialog-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: confirm?.kind === 'void' ? t('visit.process.reasonRequired') : t('visit.process.reasonOptional'),
        required: confirm?.kind === 'void',
        value: reason,
        onChange: (e)=>setReason(e.target.value),
        rows: 2,
        "data-testid": "visit-process-reason"
    })));
}


function $e1fb04c8016deb8f$export$2e2bcd8739ae039({ navigate: navProp, patient: routePatient }) {
    const { t: t, formatNumber: formatNumber, formatList: formatList, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const goBack = (0, $aa19facd75e3670a$export$2225579b56f43845)();
    const { patient: patient, loading: pLoading, error: pError, refresh: refreshPatient } = (0, $ea02b2b734b36651$export$9b570c45914f833c)(routePatient?.id);
    // `loading` matters: until the doctor's settings have arrived, `ai` is {}
    // and every `!== false` gate reads as ENABLED. Deciding an auto-run in that
    // window means the setting is honoured only when the doctor query happens to
    // win the race against the patient query.
    const { doctor: doctor, loading: doctorLoading, error: doctorError, update: updateDoctorSettings } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    // The doctor's layout (Settings → «صفحه ویزیت»), reduced to what this surface
    // has: which of note/rx/ord/diff exist and which opens first, which record
    // sections the sheet shows and in what order, and which copilot tabs remain.
    const storedVisitLayout = doctor?.settings?.visitLayout ?? null;
    const visitLayout = (0, $acw62.useMemo)(()=>(0, $792124e2f7de719a$export$e88ad8319f3008b2)(storedVisitLayout), [
        storedVisitLayout
    ]);
    const recordSections = (0, $acw62.useMemo)(()=>(0, $792124e2f7de719a$export$e111fe7e8e6c2d5d)(visitLayout), [
        visitLayout
    ]);
    // Open/closed per record section — the same hook, the same persistence and
    // the same localStorage cache the desktop rail uses (Visit.shared.js).
    const { recordOpen: recordOpen, toggleRecordSection: toggleRecordSection } = (0, $375f8776645d5aee$export$6523efd640f02d3b)(visitLayout, storedVisitLayout, doctorLoading, updateDoctorSettings);
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const walletBalance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    // The per-visit «پارسه» tally lives with the visit — see the coin ledger
    // below, declared once the encounter id it is keyed by exists.
    const ai = doctor?.settings?.aiAgent || {};
    // «نکات بالینی» is always available — the doctor only chooses whether it
    // arrives unprompted. Off ONLY on an explicit `false`, so an absent key never
    // reads as an opt-out. See Settings.shared.js. An empty `ai` is a different
    // case entirely, and the predicate below is what tells the two apart.
    // Whether the doctor's choice is KNOWN. `loading` was the only guard here,
    // which made every gate below fail OPEN on a failed query: `me` fetches
    // `settings` through a second gRPC call inside the same request, so one
    // unavailable doctor-preference call throws the whole query, leaves `doctor`
    // null and `ai` empty — and an empty `ai` reads as ENABLED, because an absent
    // key is not an opt-out. A doctor who switched all three automations off then
    // got the differential, the polling loop and the insight pass anyway, and was
    // billed for them. An error is not a choice, so it reads as "don't run
    // anything by yourself"; every manual button stays live.
    const aiSettingsUnknown = doctorLoading || !!doctorError;
    // Auto-run only when we know the doctor left it on. This also decides
    // whether the RECORDING produces «نکات بالینی»: the AI service runs a hint
    // agent on its own timer for the whole visit, a second producer of the same
    // feed that this switch did not use to reach.
    const suggestionsAutoRun = !aiSettingsUnknown && (0, $2d58c73a38525204$export$ced99d35363868d3)(ai);
    // The other automatic runs, each on its own switch now. «بازبینی پس از
    // ویرایش یادداشت» has no gate here because this surface has no such path:
    // the phone's SOAP editor saves on blur and never re-assesses.
    //
    // They used to ride on the two above — honest about the billing, dishonest
    // about the naming — or, in the sweep's case, on nothing at all. Each reads as
    // OFF while the doctor's choice is unknown: see the predicate above, and
    // Settings.shared.js for what each switch actually stops.
    const liveHintsOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$77b83820a545461a)(ai);
    // «موتور تبدیل گفتار به متن». Unlike the switches above this is NOT held off
    // while the choice is unknown: the default is Parsina STT, and the AI service
    // serves the assistant engine whenever Parsina STT cannot answer — so the
    // worst an unknown choice costs is the default, never a dead microphone.
    const speechPref = (0, $33deae5c7ec89d7f$export$e976735e46efaec2)(ai);
    const ambientSpeechEngine = (0, $33deae5c7ec89d7f$export$a597380b597b4b46)(speechPref);
    const autoAssistOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$2b2bb51f62de8576)(ai);
    // «تکمیل خودکار پس از پایش بالینی» — the top bar's «تکمیل» once the doctor stops.
    const autoCompleteOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$c41b9e42cb7b861)(ai);
    // The sweep is the exception to "unknown reads as off": it is a SAFETY
    // backstop, and a settings query that failed is no reason to stop checking a
    // prescription for a high-severity interaction. Only an explicit «off» from a
    // doctor who says they check by hand stops it.
    const endVisitSweepOn = (0, $2d58c73a38525204$export$6bc5afae02a61f49)(ai);
    const [visitId, setVisitId] = (0, $acw62.useState)(null);
    const [visitStatus, setVisitStatus] = (0, $acw62.useState)(null);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const [pendingEnd, setPendingEnd] = (0, $acw62.useState)(false);
    const pendingNavRef = (0, $acw62.useRef)(null);
    const [tab, setTab] = (0, $acw62.useState)('notes');
    // Prescription
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    // Drug lines offered to this visit from outside — a document review («افزودن به
    // نسخه ویزیت», §23.3 A13) or an approved AI proposal: prefilled forms on the
    // نسخه tab, one at a time, not نسخه lines until confirmed.
    const [docRxDrafts, setDocRxDrafts] = (0, $acw62.useState)([]);
    const [rxInteractions, setRxInteractions] = (0, $acw62.useState)(null);
    const [interactionLoading, setIxLoading] = (0, $acw62.useState)(false);
    const [ixError, setIxError] = (0, $acw62.useState)(null);
    const [aiResult, setAiResult] = (0, $acw62.useState)(null);
    const [aiLoading, setAiLoading] = (0, $acw62.useState)(false);
    const [diagnosis, setDiagnosis] = (0, $acw62.useState)('');
    // AI Recommendations. `recsRan` records that the pass completed at least once,
    // so an empty sheet can say "nothing to suggest" instead of "not run yet".
    const [recommendations, setRecommendations] = (0, $acw62.useState)(null);
    const [recsLoading, setRecsLoading] = (0, $acw62.useState)(false);
    const [recsError, setRecsError] = (0, $acw62.useState)(null);
    const [recsRan, setRecsRan] = (0, $acw62.useState)(false);
    const recsAutoFired = (0, $acw62.useRef)(false);
    const assistAutoFired = (0, $acw62.useRef)('');
    // Notes & visit
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [aiInput, setAiInput] = (0, $acw62.useState)('');
    const [aiMessages, setAiMessages] = (0, $acw62.useState)([]);
    const [aiChatLoading, setAiChatLoading] = (0, $acw62.useState)(false);
    const [labOpen, setLabOpen] = (0, $acw62.useState)(false);
    const [showClosureFlow, setShowClosureFlow] = (0, $acw62.useState)(false);
    // What did NOT save when the visit ended — see Visit.web.jsx.
    const [saveFailures, setSaveFailures] = (0, $acw62.useState)([]);
    const [endingVisit, setEndingVisit] = (0, $acw62.useState)(false);
    const [pmEncounterId, setPmEncounterId] = (0, $acw62.useState)(null);
    // ── Per-visit «پارسه» tally ────────────────────────────────────────────────
    // Same record as the desktop surface reads (useVisitCoinLedger): a visit
    // started here and reopened there — or simply refreshed — shows the same
    // figure, because both read it from the encounter rather than from memory.
    const { total: visitCoins, entries: coinEntries, charge: recordCoinCharge, refetch: refetchCoins } = (0, $375f8776645d5aee$export$18ea943e404e01dd)(pmEncounterId || visitId || null);
    // «مدارک بیمار» — the same documents host the desktop record column uses.
    const visitFileList = (0, $acw62.useMemo)(()=>(0, $bced050439dec003$export$a719a8ff130c98cb)(patient?.clinicalFiles || []), [
        patient?.clinicalFiles
    ]);
    // The review's «افزودن به نسخه ویزیت» — reached through a ref because the drug
    // handlers are declared further down.
    const docRxCapability = (0, $acw62.useRef)(null);
    const addToVisitPrescription = (0, $acw62.useCallback)((draft)=>docRxCapability.current?.(draft), []);
    const clinicalFiles = (0, $489287129a199b1d$export$513d4933d99292ab)({
        patient: patient,
        files: visitFileList,
        appointmentId: pmEncounterId || visitId || null,
        onChanged: refreshPatient,
        onAddToVisitPrescription: addToVisitPrescription
    });
    const chargeDepsRef = (0, $acw62.useRef)({
        toast: toast,
        t: t,
        formatNumber: formatNumber
    });
    chargeDepsRef.current = {
        toast: toast,
        t: t,
        formatNumber: formatNumber
    };
    const chargeVisit = (0, $acw62.useCallback)((coins, itemId, label)=>{
        if (!coins) return;
        recordCoinCharge(coins, itemId);
        const { toast: tst, t: tr, formatNumber: fn } = chargeDepsRef.current;
        if (label) tst.success(tr('visit.credits.chargedToast', {
            label: label,
            coins: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(coins, fn)
        }));
    }, [
        recordCoinCharge
    ]);
    const [differential, setDifferential] = (0, $acw62.useState)(null);
    const [diffLoading, setDiffLoading] = (0, $acw62.useState)(false);
    const [sessionReady, setSessionReady] = (0, $acw62.useState)(false);
    const [resumedVisit, setResumedVisit] = (0, $acw62.useState)(false); // true when visit was recovered on page reload
    const [soapDiffConfirm, setSoapDiffConfirm] = (0, $acw62.useState)(null); // { description, diagnosisCode }
    // diagnosisCode whose «نوع تشخیص» is being chosen — see Visit.web.jsx.
    const [diffTypePick, setDiffTypePick] = (0, $acw62.useState)(null);
    const [diffTypeBusy, setDiffTypeBusy] = (0, $acw62.useState)(false);
    const [addedSugTests, setAddedSugTests] = (0, $acw62.useState)(new Set());
    const [chartMetric, setChartMetric] = (0, $acw62.useState)(null);
    const [vitals, setVitals] = (0, $acw62.useState)((0, $375f8776645d5aee$export$ccc2c13eb48542b9));
    const [vitalsMode, setVitalsMode] = (0, $acw62.useState)('form'); // 'form' | 'saved'
    const [demoOpen, setDemoOpen] = (0, $acw62.useState)(true);
    const [vitalsOpen, setVitalsOpen] = (0, $acw62.useState)(true);
    const [vitalsLoading, setVitalsLoading] = (0, $acw62.useState)(false);
    const [vitalsAlert, setVitalsAlert] = (0, $acw62.useState)(null);
    const [vitalsError, setVitalsError] = (0, $acw62.useState)(null); // validation errors (array of strings)
    const [showVitalsModal, setShowVitalsModal] = (0, $acw62.useState)(false);
    const savedVitalIds = (0, $acw62.useRef)([]); // IDs of this encounter's vital observations
    const vitalsSeeded = (0, $acw62.useRef)(null); // encounter whose recorded vitals we already adopted
    const [creditError, setCreditError] = (0, $acw62.useState)(null);
    // «خرید پارسه» / «شارژ اعتبار» only where this deployment sells credit
    // (PM-0211, lib/useCreditPrices.js); the warnings themselves always show.
    const canBuyCredits = (0, $121df138798ec781$export$34ab9a07791a6651)(Boolean(creditError) || walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low');
    const [prescriptionTemplates, setPrescriptionTemplates] = (0, $acw62.useState)([]);
    // Visit timer
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [recElapsed, setRecElapsed] = (0, $acw62.useState)(0); // recording-specific counter
    // How many pixels the software keyboard is covering. 0 on a desktop and
    // wherever `visualViewport` is missing, so every use below is unconditional.
    const keyboardInset = (0, $iK5Lj.default)();
    // The docked footer tells floating chrome (the toast stack) how tall it is,
    // so a toast lands above «پایان ویزیت» and not on it (PM-0022).
    const footerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $kLmaN.default)(footerRef);
    // New SOAP + copilot/work tab state
    const [soap, setSoap] = (0, $acw62.useState)({
        s: '',
        o: '',
        a: '',
        p: ''
    });
    const [copilotTab, setCopilotTab] = (0, $acw62.useState)('sugg');
    const [diagAIQuestions, setDiagAIQuestions] = (0, $acw62.useState)({}); // { [diagCode]: [{id,question,hint}] }
    const [diagAIAnswers, setDiagAIAnswers] = (0, $acw62.useState)({}); // { [diagCode]: { [qId]: {answer:'yes'|'no', followUp:''} } }
    const [diagAILoading, setDiagAILoading] = (0, $acw62.useState)({}); // { [diagCode]: boolean }
    // An answer is committed the moment it is picked, so the in-flight and failed
    // states are per QUESTION, not per diagnosis: `${diagCode}:${questionId}`.
    const [diagQSubmitting, setDiagQSubmitting] = (0, $acw62.useState)({}); // { [diagCode:qId]: 'yes'|'no' }
    const [diagQError, setDiagQError] = (0, $acw62.useState)({}); // { [diagCode:qId]: string }
    const [openAIDiag, setOpenAIDiag] = (0, $acw62.useState)(null); // diagCode | null
    const [workTab, setWorkTab] = (0, $acw62.useState)('soap');
    const [soapNoteId, setSoapNoteId] = (0, $acw62.useState)(null); // ID of the in-progress ClinicalNote for this visit
    // Clinical orders (from clinicalencounter microservice)
    const [clinicalOrders, setClinicalOrders] = (0, $acw62.useState)([]);
    const [ordersLoading, setOrdersLoading] = (0, $acw62.useState)(false);
    // Whether the list above is the server's answer rather than "not asked yet" —
    // see the reconciler: an empty list is a claim, and only the fetch may make it.
    const [ordersLoaded, setOrdersLoaded] = (0, $acw62.useState)(false);
    const [orderTransitioning, setOrderTransitioning] = (0, $acw62.useState)(null); // orderId being transitioned
    const [orderError, setOrderError] = (0, $acw62.useState)(null);
    const [newOrder, setNewOrder] = (0, $acw62.useState)({
        orderType: 'lab',
        description: '',
        urgency: 'routine',
        notes: ''
    });
    const [orderSaving, setOrderSaving] = (0, $acw62.useState)(false);
    const [cancellingVisit, setCancellingVisit] = (0, $acw62.useState)(false);
    // The order catalogue is SEARCHED, never held — see Visit.web.jsx for why
    // (~20,000 national rows are not a payload). `catalogPage` is the picker's
    // current page; `catalogResolved` is what the orders already on this chart need
    // from the catalogue: their English name for the plan block, whether this
    // clinic performs them, and their code.
    const [catalogPage, setCatalogPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    const [catalogResolved, setCatalogResolved] = (0, $acw62.useState)(()=>new Map());
    // AI-assisted treatment plan — generated from the SOAP «برنامه» section, not a
    // tab of its own. The plan composes meds + labs + imaging + procedures in one
    // call, grounded in the whole SOAP note + reviewed differentials + history;
    // its prose becomes the «P» text, and the review panel under P governs which
    // structured items get persisted.
    const [planSuggestion, setPlanSuggestion] = (0, $acw62.useState)(null);
    const [planLoading, setPlanLoading] = (0, $acw62.useState)(false);
    const [selectedPlanItems, setSelectedPlanItems] = (0, $acw62.useState)(new Set()); // "med:name" | "lab:name" | ...
    const [planSaving, setPlanSaving] = (0, $acw62.useState)(false);
    const [planStatus, setPlanStatus] = (0, $acw62.useState)(null); // null | 'draft' | 'confirmed'
    const [planError, setPlanError] = (0, $acw62.useState)(null);
    const [planPanelOpen, setPlanPanelOpen] = (0, $acw62.useState)(false);
    const [planReplacedP, setPlanReplacedP] = (0, $acw62.useState)(null); // undo for an overwritten «P»
    // ── Parity surfaces (docs/mobile-visit-redesign.md §3) ─────────────────────
    // `mobileSheet` carries the record/copilot sheets; these are the ones that can
    // stack over them (labs, print) or replace the desktop topbar (overflow).
    const [labsSheetOpen, setLabsSheetOpen] = (0, $acw62.useState)(false);
    const [printSheetOpen, setPrintSheetOpen] = (0, $acw62.useState)(false);
    const [overflowOpen, setOverflowOpen] = (0, $acw62.useState)(false);
    const [pendingCancelVisit, setPendingCancelVisit] = (0, $acw62.useState)(false);
    // Per-visit record detail behind «مراجعات اخیر», keyed by appointment id:
    // { [encId]: { state: 'loading'|'ready'|'error', data } }. Requests are
    // de-duped by ref so a row re-expanded during a fetch does not fire a second.
    const [visitContexts, setVisitContexts] = (0, $acw62.useState)({});
    const visitCtxRequested = (0, $acw62.useRef)(new Set());
    // «نوع تشخیص» being rewritten on a chart condition (record sheet).
    const [dxTypeBusyId, setDxTypeBusyId] = (0, $acw62.useState)(null);
    // The order the doctor asked to cancel — the sheet asks, the screen confirms.
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null);
    // Refs for contentEditable SOAP editors
    const soapEditorRefs = (0, $acw62.useRef)({
        s: null,
        o: null,
        a: null,
        p: null
    });
    // Keep contentEditable DOM in sync with soap state (draft restore, AI appends, tab remount, etc.)
    // useLayoutEffect fires synchronously after refs are attached but before browser paint,
    // so adding workTab as a dep ensures fields repopulate immediately when SOAP tab remounts.
    // Skip update if the element is currently focused (user is actively typing).
    (0, $acw62.useLayoutEffect)(()=>{
        [
            's',
            'o',
            'a',
            'p'
        ].forEach((key)=>{
            const el = soapEditorRefs.current[key];
            if (el && document.activeElement !== el && el.textContent !== (soap[key] || '')) el.textContent = soap[key] || '';
        });
    }, [
        soap.s,
        soap.o,
        soap.a,
        soap.p,
        workTab
    ]);
    // Load saved SOAP note from server on visit resume/reload
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || visitStatus !== 'inprogress' || soapNoteId) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$5b71fce46c6ed6a3), {
            patientId: patient.id,
            appointmentId: encId
        }).then((data)=>{
            // The note is matched with the SHARED reader, not on a literal noteType.
            // When encounters merged into appointments the service dropped
            // `note_type` and kept only `format`, which it refuses to store as
            // anything but "SOAP" — so the BFF now reports every note as
            // noteType 'SOAP'. The old `=== 'SOAP_NOTE'` filter could therefore
            // never match: the editors came up empty on reload AND `soapNoteId`
            // stayed null, so the next autosave took the CREATE branch and left the
            // appointment with two SOAP rows that disagree.
            const note = (0, $a044c29e4a6b3520$export$b26efe9e640f95c2)(data?.listClinicalNotes || []);
            if (!note) return;
            // The id FIRST and unconditionally — the next save must UPDATE this row
            // even if it is currently empty, or the duplicate comes back.
            setSoapNoteId(note.id);
            const draft = (0, $a044c29e4a6b3520$export$41de64d84beb8926)([
                note
            ]);
            const next = {
                s: draft.S || '',
                o: draft.O || '',
                a: draft.A || '',
                p: draft.P || ''
            };
            if (!(next.s || next.o || next.a || next.p)) return;
            // A localStorage draft restored moments ago is FRESHER than the server
            // copy (it holds keystrokes made after the last autosave), so it wins.
            setSoap((prev)=>prev.s || prev.o || prev.a || prev.p ? prev : next);
        }).catch(()=>{});
    }, [
        pmEncounterId,
        visitId,
        patient?.id,
        visitStatus
    ]);
    const [mobileSheet, setMobileSheet] = (0, $acw62.useState)(null); // null | 'ai' | 'vitals'
    const [mobileTab, setMobileTab] = (0, $acw62.useState)('note'); // note | rx | ord
    // Items ticked in «درخواست» but not added yet (PM-0121): «پایان ویزیت»
    // waits for them instead of ending without them.
    const [ordersPending, setOrdersPending] = (0, $acw62.useState)(0);
    // Open on the doctor's default tab until they pick one in this visit; a tab
    // hidden while active falls back to the default.
    const mobileTabTouched = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        setMobileTab((prev)=>!mobileTabTouched.current || !(0, $792124e2f7de719a$export$6fd5b56eddd00f9b)(visitLayout, prev) ? (0, $792124e2f7de719a$export$dde3a1a6c2d91941)(visitLayout) : prev);
    }, [
        visitLayout
    ]);
    const pickMobileTab = (0, $acw62.useCallback)((id)=>{
        mobileTabTouched.current = true;
        setMobileTab(id);
    }, []);
    const mobileTabShown = (0, $acw62.useCallback)((id)=>(0, $792124e2f7de719a$export$6fd5b56eddd00f9b)(visitLayout, id) || mobileTab === id, [
        visitLayout,
        mobileTab
    ]);
    const [mobileAiTab, setMobileAiTab] = (0, $acw62.useState)('hints');
    // Same rule as the nav: the doctor's default until they pick a tab in this
    // visit, and a tab hidden while active falls back.
    const aiTabTouched = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        setMobileAiTab((prev)=>!aiTabTouched.current || !(0, $792124e2f7de719a$export$ec23aec8c07c3d8a)(visitLayout, prev) ? (0, $792124e2f7de719a$export$c5c16556be0d657b)(visitLayout) : prev);
    }, [
        visitLayout
    ]);
    const pickAiTab = (0, $acw62.useCallback)((id)=>{
        aiTabTouched.current = true;
        setMobileAiTab(id);
    }, []);
    const [mobileSoapOpen, setMobileSoapOpen] = (0, $acw62.useState)({
        S: true,
        O: false,
        A: false,
        P: false
    });
    const [mobileDiffPrimary, setMobileDiffPrimary] = (0, $acw62.useState)(null);
    const [mobileDiffState, setMobileDiffState] = (0, $acw62.useState)({});
    const [dismissedSuggs, setDismissedSuggs] = (0, $acw62.useState)(new Set());
    // Past visit history panel
    const [pastVisitSummaries, setPastVisitSummaries] = (0, $acw62.useState)(null);
    const [expandedEncId, setExpandedEncId] = (0, $acw62.useState)(null);
    const [expandedLabDate, setExpandedLabDate] = (0, $acw62.useState)(null);
    const [showAllLabDates, setShowAllLabDates] = (0, $acw62.useState)(false);
    // Accepted suggestions tracking
    const [pendingTests, setPendingTests] = (0, $acw62.useState)([]);
    // Doctor order suggestions (AI)
    const [orderSuggestions, setOrderSuggestions] = (0, $acw62.useState)(null); // { labTests, imagingStudies, procedureOrders }
    const [orderSuggestionsLoading, setOrderSuggestionsLoading] = (0, $acw62.useState)(false);
    const [selectedOrders, setSelectedOrders] = (0, $acw62.useState)(new Set()); // Set of "<type>:<name>"
    const [savingOrders, setSavingOrders] = (0, $acw62.useState)(false);
    const [savedOrdersCount, setSavedOrdersCount] = (0, $acw62.useState)(0);
    // Current-meds panel: delete via mutation, undo re-adds locally (optimistic)
    const [removedMedNames, setRemovedMedNames] = (0, $acw62.useState)(new Set());
    const [undoMed, setUndoMed] = (0, $acw62.useState)(null);
    const undoTimerRef = (0, $acw62.useRef)(null);
    const [removedCondIds, setRemovedCondIds] = (0, $acw62.useState)(new Set());
    const [undoCond, setUndoCond] = (0, $acw62.useState)(null);
    const undoCondTimerRef = (0, $acw62.useRef)(null);
    const [activeVisitConflict, setActiveVisitConflict] = (0, $acw62.useState)(null); // { visitId } | null
    // Everything else that can stop a visit being created. Without it the failure
    // is a console.warn and a screen whose controls silently do not render — see
    // the matching note in Visit.web.jsx.
    const [startError, setStartError] = (0, $acw62.useState)(null);
    const medKey = (med)=>(med.display || '').trim().toLowerCase();
    const removeMed = async (med)=>{
        setRemovedMedNames((prev)=>new Set([
                ...prev,
                medKey(med)
            ]));
        setUndoMed(med);
        clearTimeout(undoTimerRef.current);
        undoTimerRef.current = setTimeout(()=>setUndoMed(null), 8000);
        const duplicates = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === medKey(med));
        for (const m of duplicates)try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
                id: m.id,
                input: {
                    status: 'stopped'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const restoreMed = async ()=>{
        if (!undoMed) return;
        clearTimeout(undoTimerRef.current);
        const key = medKey(undoMed);
        setRemovedMedNames((prev)=>{
            const s = new Set(prev);
            s.delete(key);
            return s;
        });
        setUndoMed(null);
        const stopped = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === key && m.status === 'stopped');
        for (const m of stopped)try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
                id: m.id,
                input: {
                    status: 'active'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const removeCondition = async (cond)=>{
        setRemovedCondIds((prev)=>new Set([
                ...prev,
                cond.id
            ]));
        setUndoCond(cond);
        clearTimeout(undoCondTimerRef.current);
        undoCondTimerRef.current = setTimeout(()=>setUndoCond(null), 8000);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$ea4d931135e95fd1), {
                id: cond.id
            });
        } catch  {}
        refreshPatient();
    };
    const restoreCondition = async ()=>{
        if (!undoCond) return;
        clearTimeout(undoCondTimerRef.current);
        setRemovedCondIds((prev)=>{
            const s = new Set(prev);
            s.delete(undoCond.id);
            return s;
        });
        setUndoCond(null);
        // Restoring must carry the type the row had — see Visit.web.jsx.
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$52e699bb9024b09d), {
                patientId: patient.id,
                input: {
                    code: undoCond.code,
                    display: undoCond.display,
                    clinicalStatus: 'active',
                    verificationStatus: (0, $4a744c4def3d338a$export$5d68a431913dd40b)(undoCond)
                }
            });
        } catch  {}
        refreshPatient();
    };
    // ── Demographics edit ──────────────────────────────────────────────────────
    // Same contract as the desktop «ویرایش» dialog: seed from the loaded patient,
    // send only the changed fields, refresh on success.
    const [showEditPatient, setShowEditPatient] = (0, $acw62.useState)(false);
    const [editPatientForm, setEditPatientForm] = (0, $acw62.useState)({});
    const [editPatientSaving, setEditPatientSaving] = (0, $acw62.useState)(false);
    const [editPatientError, setEditPatientError] = (0, $acw62.useState)('');
    const openEditPatient = ()=>{
        setEditPatientError('');
        setEditPatientForm({
            name: patient?.name || '',
            phone: patient?.phone || '',
            nationalId: patient?.nationalId || '',
            birthDate: patient?.birthDate || '',
            bloodType: patient?.bloodType || '',
            job: patient?.job || '',
            insurance: patient?.insurance || '',
            height: patient?.height != null ? String(patient.height) : ''
        });
        setShowEditPatient(true);
    };
    const saveEditPatient = async ()=>{
        if (editPatientSaving) return;
        // Parity with the desktop dialog: a changed code must pass its country's rule.
        if (editPatientForm.nationalId !== (patient?.nationalId || '') && (0, $3tGMU).nationalIdProblem(editPatientForm.nationalId, {
            country: editPatientForm.nationalIdCountry
        })) {
            setEditPatientError(t('validation.nationalId'));
            return;
        }
        setEditPatientSaving(true);
        setEditPatientError('');
        try {
            const u = {};
            if (editPatientForm.name !== (patient?.name || '')) u.name = editPatientForm.name;
            if (editPatientForm.phone !== (patient?.phone || '')) u.phone = editPatientForm.phone;
            if (editPatientForm.nationalId !== (patient?.nationalId || '')) u.nationalId = editPatientForm.nationalId;
            if (editPatientForm.birthDate !== (patient?.birthDate || '')) u.birthDate = editPatientForm.birthDate;
            if (editPatientForm.bloodType !== (patient?.bloodType || '')) u.bloodType = editPatientForm.bloodType;
            if (editPatientForm.job !== (patient?.job || '')) u.job = editPatientForm.job;
            if (editPatientForm.insurance !== (patient?.insurance || '')) u.insurance = editPatientForm.insurance;
            const nh = parseFloat(editPatientForm.height);
            if (!Number.isNaN(nh) && nh !== patient?.height) u.height = nh;
            if (Object.keys(u).length) {
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$f6cdc6e4a4a3c80a), {
                    id: patient.id,
                    input: u
                });
                await refreshPatient();
            }
            setShowEditPatient(false);
        } catch (e) {
            setEditPatientError(e?.message || t('errors.save.patientEdit'));
        } finally{
            setEditPatientSaving(false);
        }
    };
    const visitStartTime = (0, $acw62.useRef)(null);
    // Vitals belong to the visit, so the recorder opens EMPTY — never seeded with
    // the patient's older readings (see vitalsForEncounter in Visit.shared).
    (0, $acw62.useEffect)(()=>{
        setVitalsMode('form');
        setVitals((0, $375f8776645d5aee$export$ccc2c13eb48542b9)());
        savedVitalIds.current = [];
        vitalsSeeded.current = null;
    }, [
        visitId
    ]);
    // …and fills in only from vitals actually recorded against THIS encounter, so
    // a reload mid-visit shows what was measured today. Runs on every patient
    // refetch but adopts once per encounter, so it can never wipe a form the
    // doctor is filling in.
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId || null;
        if (!encId || !patient) return;
        const key = String(encId);
        if (vitalsSeeded.current === key) return;
        const { values: values, ids: ids, recorded: recorded } = (0, $375f8776645d5aee$export$1e5a39e00c998387)(patient.clinicalObservations, encId);
        if (!recorded) return;
        vitalsSeeded.current = key;
        setVitals(values);
        savedVitalIds.current = ids;
        setVitalsMode('saved');
    }, [
        patient,
        pmEncounterId,
        visitId
    ]);
    // Fetch doctor's prescription templates once on mount
    (0, $acw62.useEffect)(()=>{
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$cd39121473ec6a95)).then((r)=>{
            if (r?.prescriptionTemplates) setPrescriptionTemplates(r.prescriptionTemplates);
        }).catch(()=>{});
    }, []);
    // Declared BEFORE useTranscription, and that ordering is load-bearing:
    // the transcription hook reads `call.audioSource` to decide whether the
    // visit's audio comes from the conference or from the microphone.
    // ── ویزیت تصویری ───────────────────────────────────────────────────────────
    // A reduction of the web panel: same hook, same one-node rule, but
    // «بزرگ‌نمایی» grows the video in place rather than floating a fixed panel —
    // a fixed child would escape the IOSDevice frame's rounded clip.
    const ensureVisitStarted = (0, $acw62.useCallback)(async ()=>{
        const existing = pmEncounterId || visitId;
        if (existing) return existing;
        const id = await handleStart();
        if (!id) throw new Error('unavailable');
        return id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    const call = (0, $b23a4f29e1a7fc1a$export$fd58d87a1fa8fc0d)({
        patientId: patient?.id,
        appointmentId: pmEncounterId || visitId || null,
        ensureVisitStarted: ensureVisitStarted,
        // The brand the CALL shows (window title, join/leave toasts). Passed from
        // here because jitsiEmbed.js is React-free and has no i18n of its own.
        providerName: t('visit.call.providerName')
    });
    const { probe: probeCall } = call;
    (0, $acw62.useEffect)(()=>{
        probeCall();
    }, [
        probeCall
    ]);
    // «تبدیل به ویزیت آنلاین» — the in-person visit's secondary path. The control
    // is one 44px button at the end of the tab strip; the decision is this sheet.
    const [convertSheetOpen, setConvertSheetOpen] = (0, $acw62.useState)(false);
    const canConvertVisit = call.canConvert && !call.available && !call.live && !call.busy;
    const handleConvertVisit = (0, $acw62.useCallback)(async ()=>{
        // Close first when it lands: the call band mounts in the page behind the
        // sheet, and the call opens into it.
        const ok = await call.convert({
            andCall: false
        });
        if (!ok) return;
        setConvertSheetOpen(false);
        call.start();
    }, [
        call
    ]);
    // The OS is about to freeze this page mid-recording. Everything still only in
    // memory has to reach the draft inside this call — the hook runs it from the
    // `visibilitychange` handler, which is the last moment JS is guaranteed to run.
    const systemPauseRef = (0, $acw62.useRef)(null);
    const onSystemPause = (0, $acw62.useCallback)((snapshot)=>{
        systemPauseRef.current?.(snapshot);
    }, []);
    const { recState: recState, recError: recError, hints: hints, liveTranscript: liveTranscript, startRec: startRec, stopRec: stopRec, resumeRec: resumeRec, dismissPause: dismissPause, dismissError: dismissError } = (0, $b5da27b488005ec5$export$e2373706461b5244)({
        patientId: patient?.id,
        visitId: visitId,
        patientHistory: (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient) + '\n' + (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests),
        // During a video visit the audio comes from the CALL, not from a second
        // microphone — the mic cannot hear the patient (echo cancellation removes
        // them) and on iOS it would steal the call's own audio session. Null when
        // no call is live, which leaves the in-person path exactly as it was.
        callAudio: call.audioSource,
        onSystemPause: onSystemPause,
        // The switch reaches the STREAM, so the hint agent is never RUN for a
        // doctor who turned «نکات بالینی زنده هنگام ضبط» off — rather than run,
        // billed for in tokens, and then hidden on arrival.
        hintsEnabled: liveHintsOn,
        engine: ambientSpeechEngine
    });
    const isRecording = recState === 'recording';
    const isStopping = recState === 'stopping';
    // Pressed, not yet recording — held so a second tap cannot start a second
    // recording (useTranscription, `connecting`).
    const isConnecting = recState === 'connecting';
    const isRecError = recState === 'error';
    const isRecPaused = recState === 'paused-by-system';
    // ── The visit's «پارسه» line is not the client's to write ─────────────────
    // It used to be `chargeVisit(ceil(recElapsed / 60) * 5)` right here, from a
    // `setInterval` counter — which kept counting while a suspended page recorded
    // nothing, so a backgrounded visit was billed for dead air, and a visit whose
    // page died before «توقف» was billed for nothing at all.
    //
    // The line is written server-side now, by the BFF, from the audio that
    // actually reached it. All this has to do is stop; the badge reads the ledger
    // back below.
    const stopRecCharged = stopRec;
    const hint = hints[0] ? typeof hints[0] === 'string' ? hints[0] : hints[0].text || '' : '';
    // ── Visit lifecycle ────────────────────────────────────────────────────────
    // Returns the started visit's id (= the scheduling appointment id) so that
    // «تماس با بیمار» can start the visit and open the room in one press. Null on
    // every failure it already handles — the conflict dialog and the error banner
    // still surface those.
    const handleStart = async ()=>{
        if (!patient?.id) return null;
        setStartError(null);
        try {
            const now = new Date().toISOString();
            visitStartTime.current = now;
            const cv = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$610b800a6c6defa5), {
                patientId: patient.id,
                type: 'OUTPATIENT'
            });
            const id = cv.createVisit.id;
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$cdc0bbb5663f787c), {
                id: id
            });
            setVisitId(id);
            setPmEncounterId(id);
            setVisitStatus('inprogress');
            setSoapNoteId(null);
            setSessionReady(false);
            (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
                visitId: id,
                patientId: patient.id
            }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            return id;
        } catch (e) {
            const code = e?.extensions?.code || e?.graphQLErrors?.[0]?.extensions?.code;
            if (code === 'ACTIVE_VISIT_EXISTS') {
                const activeId = e?.extensions?.activeVisitId || e?.graphQLErrors?.[0]?.extensions?.activeVisitId;
                setActiveVisitConflict({
                    visitId: activeId || null
                });
                return null;
            }
            console.warn('handleStart error:', e);
            setStartError(e);
            return null;
        }
    };
    const handleResumeConflictVisit = ()=>{
        setStartError(null);
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (!activeId) return;
        setVisitId(activeId);
        setPmEncounterId(activeId);
        setVisitStatus('inprogress');
        setSoapNoteId(null);
        setSessionReady(false);
        (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
            visitId: activeId,
            patientId: patient.id
        }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
    };
    const handleCloseConflictVisit = async ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (activeId) try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$33b114336c19593d), {
                id: activeId
            });
        } catch  {}
        handleStart();
    };
    // Resolves to whether the note is now persisted. Most callers are fire-and-
    // forget autosaves that ignore it; the confirmation-question flow does not —
    // it may only close its panel once the write it just made has landed.
    //
    // Saves can race for a note not created yet — a confirmed proposal, the
    // plan's debounced save, an answered confirmation question. useSoapNoteRow
    // keeps that to ONE CREATE: a save behind it waits and updates the row it made.
    const writeSoapNoteRow = (0, $375f8776645d5aee$export$3c5b8ac9cc0f8a4)(soapNoteId, setSoapNoteId, visitId);
    const handleSaveSoapNote = async (currentSoap)=>{
        const s = currentSoap || soap;
        if (!patient?.id) return false;
        if (!(s.s || s.o || s.a || s.p)) return true;
        const resolvedEncId = pmEncounterId || visitId || null;
        const content = {
            s: s.s || '',
            o: s.o || '',
            a: s.a || '',
            p: s.p || ''
        };
        try {
            await writeSoapNoteRow({
                update: (id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6e7c5d8b5a28479a), {
                        id: id,
                        input: {
                            content: content
                        }
                    }),
                create: async ()=>{
                    const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$1d32d39b70c8b52e), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedEncId
                        }
                    });
                    return res?.createClinicalNote?.id;
                }
            });
            return true;
        } catch (e) {
            console.warn('handleSaveSoapNote error:', e);
            return false;
        }
    };
    // ── Plan ⇄ نسخه/دستورات reconciliation ────────────────────────────────────
    //
    // Same loop as the desktop fork: «P» carries a managed block listing every
    // prescribed drug and live order, recomputed from the lists and rewritten only
    // when it has drifted. Derived, never accumulated — so add / edit / delete all
    // converge, and a re-run on correct text is a no-op, which is what makes the
    // effect safe to fire on every render that could have changed anything.
    //
    // English, like the desktop fork — the block is a clinical document, so an
    // order is named from the catalogue's `nameEn`, found by catalogId or by the
    // Persian description for orders that carry no id.
    // Catalog ids the clinic has an ACTIVE service declaration for (the `inHouse`
    // flag from getClinicalOrderCatalog). Only these can be performed — and billed
    // — here, so only they get the «انجام» button; everything else is fulfilled
    // elsewhere and merely waits.
    const inHouseCatalogIds = (0, $acw62.useMemo)(()=>{
        const ids = new Set();
        for (const [key, row] of catalogResolved)if (row?.inHouse && key === row.id) ids.add(row.id);
        return ids;
    }, [
        catalogResolved
    ]);
    const catalogNameEn = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const [key, row] of catalogResolved)if (row?.nameEn) m.set(key, row.nameEn);
        return m;
    }, [
        catalogResolved
    ]);
    const orderNameEn = (0, $acw62.useCallback)((o)=>catalogNameEn.get(o?.catalogId) || catalogNameEn.get((o?.description || '').trim()) || '', [
        catalogNameEn
    ]);
    const planBlock = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$d3332d0820799abb)({
            rxItems: rxItems,
            orders: clinicalOrders,
            orderNameEn: orderNameEn
        }), [
        rxItems,
        clinicalOrders,
        orderNameEn
    ]);
    // Live views for handleApplyPlan, which creates items and then has to file a
    // plan note listing them within the same async run.
    const rxItemsRef = (0, $acw62.useRef)(rxItems);
    rxItemsRef.current = rxItems;
    const clinicalOrdersRef = (0, $acw62.useRef)(clinicalOrders);
    clinicalOrdersRef.current = clinicalOrders;
    // Same reason, for the note: a confirmation answer appends to «S» and awaits
    // the save, so it must append to the latest text rather than to whatever the
    // closure captured before the previous answer landed.
    const soapRef = (0, $acw62.useRef)(soap);
    soapRef.current = soap;
    // ── تکمیل یادداشت — merge-aware SOAP completion (same hook as desktop) ────
    // handleSaveSoapNote is recreated each render, so the stable apply callback
    // below reads it through a ref — otherwise it would save with the FIRST
    // render's patient/soapNoteId closure and file a duplicate note.
    const saveSoapNoteRef = (0, $acw62.useRef)(null);
    saveSoapNoteRef.current = handleSaveSoapNote;
    const applyRefinedSections = (0, $acw62.useCallback)((entries)=>{
        setSoap((prev)=>{
            const next = {
                ...prev
            };
            Object.entries(entries).forEach(([k, text])=>{
                // The merge worked on the «P» NARRATIVE only; the block the note
                // already carries is preserved verbatim and re-spliced.
                if (k === 'p') next.p = (0, $375f8776645d5aee$export$a3aead4a50abe781)(text, (0, $375f8776645d5aee$export$69cdf1bc97231e5)(prev.p));
                else next[k] = text;
            });
            saveSoapNoteRef.current?.(next);
            return next;
        });
    }, []);
    const soapRefine = (0, $375f8776645d5aee$export$79f39042065fbd7d)({
        visitId: visitId,
        patientId: patient?.id || null,
        soapRef: soapRef,
        liveTranscript: liveTranscript,
        chargeVisit: chargeVisit,
        onApply: applyRefinedSections,
        onCreditError: setCreditError,
        t: t
    });
    // The «برنامه» textarea is controlled, so rewriting its value under the
    // doctor's fingers would move their caret. Defer while it holds focus; blur is
    // a dependency here, so releasing it reconciles at once.
    const [planEditorFocused, setPlanEditorFocused] = (0, $acw62.useState)(false);
    const planSaveTimer = (0, $acw62.useRef)(null);
    const schedulePlanNoteSave = (0, $acw62.useCallback)((nextSoap)=>{
        clearTimeout(planSaveTimer.current);
        planSaveTimer.current = setTimeout(()=>{
            handleSaveSoapNote(nextSoap);
        }, 700);
    }, [
        handleSaveSoapNote
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(planSaveTimer.current), []);
    // Same guard as the desktop fork: a resumed visit restores «P» from the server
    // note, which already lists this encounter's orders. Reconciling before the
    // order fetch returns would read "not loaded yet" as "nothing ordered" and
    // strip those lines out of the plan.
    const ordersAuthoritative = ordersLoaded || !(pmEncounterId || visitId);
    (0, $acw62.useEffect)(()=>{
        if (planEditorFocused) return;
        if (!ordersAuthoritative) return;
        const nextP = (0, $375f8776645d5aee$export$a3aead4a50abe781)(soap.p, planBlock);
        if (nextP === (soap.p || '')) return;
        setSoap((prev)=>prev.p === soap.p ? {
                ...prev,
                p: nextP
            } : prev);
        schedulePlanNoteSave({
            ...soap,
            p: nextP
        });
    }, [
        planBlock,
        planEditorFocused,
        ordersAuthoritative,
        soap,
        schedulePlanNoteSave
    ]);
    // Returns whether the list is now authoritative — a failed fetch leaves the
    // previous list standing rather than reporting an empty visit, because the
    // reconciler would take that literally and delete the doctor's orders from «P».
    const loadClinicalOrders = async (encId)=>{
        if (!encId) return false;
        setOrdersLoading(true);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$1d5821a442552a84), {
                appointmentId: encId
            });
            setClinicalOrders(data?.listOrders || []);
            setOrdersLoaded(true);
            return true;
        } catch  {
            return false;
        } finally{
            setOrdersLoading(false);
        }
    };
    const handleCreateOrder = async ()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || !newOrder.description.trim()) return;
        setOrderSaving(true);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$81ebae6b21d102e1), {
                appointmentId: encId,
                patientId: patient.id,
                orderType: newOrder.orderType,
                description: newOrder.description,
                urgency: newOrder.urgency,
                notes: newOrder.notes
            });
            setClinicalOrders((prev)=>[
                    data.createOrder,
                    ...prev
                ]);
            setNewOrder({
                orderType: 'lab',
                description: '',
                urgency: 'routine',
                notes: ''
            });
        } catch  {} finally{
            setOrderSaving(false);
        }
    };
    // Returns whether the transition landed: «انجام» chains start→complete, and
    // chaining past a failed start would report a completed order the server never
    // completed. A failure surfaces in the orders tab's error strip.
    const handleOrderTransition = async (orderId, action)=>{
        setOrderTransitioning(orderId);
        const mutMap = {
            start: (0, $375f8776645d5aee$export$a829ddd2566c75b7),
            complete: (0, $375f8776645d5aee$export$b0b354e2ddeac24b),
            cancel: (0, $375f8776645d5aee$export$494a03338ebc3893)
        };
        const fieldMap = {
            start: 'startOrder',
            complete: 'completeOrder',
            cancel: 'cancelOrder'
        };
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(mutMap[action], {
                orderId: orderId
            });
            const updated = data[fieldMap[action]];
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        status: updated.status
                    } : o));
            setOrderError(null);
            return true;
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderStatus'));
            return false;
        } finally{
            setOrderTransitioning(null);
        }
    };
    // The «انجام» rail: completion is the billing event, and clinicalencounter only
    // accepts it from in_progress — so a pending order is started first. Both
    // steps ride the one transition handler so the row's busy state covers both.
    const handleOrderDone = async (orderId)=>{
        const order = clinicalOrders.find((o)=>o.id === orderId);
        if (!order) return;
        if (order.status === 'pending') {
            const started = await handleOrderTransition(orderId, 'start');
            if (!started) return;
        }
        await handleOrderTransition(orderId, 'complete');
    };
    const handleCancelEncounter = async ()=>{
        if (!visitId || cancellingVisit) return;
        setCancellingVisit(true);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$337c36ab78c979c4), {
                id: visitId
            });
            if (isRecording) stopRec();
            setVisitId(null);
            setVisitStatus(null);
            setPmEncounterId(null);
            // Cancelled visit leaves nothing behind: drop the recovery draft and leave
            // the visit screen. navProp (not the wrapped navigate) — this closure still
            // sees visitStatus 'inprogress', which would re-arm the leave guard.
            try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            navProp('patient-detail', {
                id: patient?.id
            });
        } catch (e) {
            console.error('[cancelEncounter]', e);
        } finally{
            setCancellingVisit(false);
        }
    };
    // High findings an earlier stop of the sweep below already showed, under the
    // signature of the نسخه they were found in — the desktop hook keeps the same.
    const sweepShownRef = (0, $acw62.useRef)(null);
    const handleEnd = async ()=>{
        if (!visitId) return;
        setEndingVisit(true);
        try {
            if (isRecording) stopRec();
            // Encounter ID for clinicalencounter — set to visitId at start; fallback to visitId.
            const resolvedPmEncId = pmEncounterId || visitId || null;
            // Final safety sweep — the one interaction check the doctor does not ask
            // for, and the backstop for a prescription that was never checked by hand.
            // Severity-gated on purpose: ONLY a high-severity finding holds the visit
            // open; متوسط and خفیف wait in the نسخه tab.
            // «بررسی تداخل دارویی در پایان ویزیت» — the only automation switch here
            // that is about safety rather than spend, which is why it is read
            // directly and not through `aiSettingsUnknown`: a settings query that
            // failed is no reason to stop checking a prescription.
            if (endVisitSweepOn && rxItems.length > 0 && patient?.id) try {
                const sweepConditions = [
                    ...(patient.clinicalConditions || []).map((c)=>c.display),
                    ...(differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((d)=>d.description),
                    ...(0, $375f8776645d5aee$export$5176433c16ff5a4)(patient.clinicalObservations)
                ];
                const sweepAllergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
                const sweepResult = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9812972017b718e1), {
                    // Names, not formulary ids — see interactionDrugName.
                    medicationIds: (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems),
                    patientId: patient.id,
                    patientConditions: sweepConditions,
                    patientAllergies: sweepAllergies
                });
                // The sweep is an AI call like any other and the service debits for
                // it (3 پارسه), so it belongs in the visit's own tally. Without this
                // the debit showed up in the account panel and NOWHERE on the visit —
                // a doctor closing a visit watched credits leave for something they
                // never pressed a button for and the page never mentioned.
                chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('INTERACTION_CHECK'), 'interaction');
                const sweepWarnings = sweepResult.checkDrugInteraction?.warnings || [];
                // Same gate as the desktop (useEndVisit): every high finding not yet
                // shown for THIS نسخه holds the visit, matched by its drugs. «Any
                // earlier high» let a new A + C close on an A + B seen before C was
                // added (interactionSeen.js).
                if ((0, $ea35d970f69d5497$export$9b1b472b8328535d)(sweepWarnings, {
                    shown: rxInteractions,
                    signature: rxSignature,
                    memo: sweepShownRef
                })) {
                    setRxInteractions({
                        hasInteractions: true,
                        warnings: sweepWarnings,
                        signature: rxSignature
                    });
                    setMobileTab('rx');
                    setEndingVisit(false);
                    return;
                }
            } catch  {}
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$33b114336c19593d), {
                id: visitId
            });
            // Captured BEFORE the reset below — same duplicate-note fix as
            // Visit.web.jsx: closure must UPDATE the autosaved row, not add a second.
            const endNoteId = soapNoteId;
            // Mark finished immediately so all reactive AI effects (SOAP refine, differential regen)
            // see visitStatus !== 'inprogress' and stop firing — their cleanup functions also run here.
            setVisitStatus('finished');
            setSoapNoteId(null);
            // Ending a visit costs nothing and calls no AI — same contract as the
            // desktop surface. See the note in Visit.web.jsx's handleEndVisit.
            // Same accumulator, same reason, as Visit.web.jsx: every write below used
            // to swallow its failure and fall through to a closure screen that says
            // the visit is done, so a network blip meant a doctor closed a visit
            // believing the prescription was in the record when it was not.
            const failures = [];
            const today = new Date().toISOString().split('T')[0];
            const endTime = new Date().toISOString();
            // Update encounter in patient management
            if (resolvedPmEncId) try {
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6762df89b8e36811), {
                    id: resolvedPmEncId,
                    input: {
                        status: 'finished',
                        periodEnd: endTime,
                        reason: soap.a || diagnosis || ''
                    }
                });
            } catch (e) {
                console.warn('updateEncounter failed:', e.message);
                failures.push(t('visit.end.partEncounter'));
            }
            // Save structured SOAP note (always, if any SOAP content exists). The
            // autosave already owns a row (endNoteId) — update it; only a visit whose
            // SOAP was never autosaved creates one here. Plain update, not an
            // amendment: ending a visit records no edit history.
            if (patient?.id && (soap.s || soap.o || soap.a || soap.p)) {
                const content = {
                    s: soap.s || '',
                    o: soap.o || '',
                    a: soap.a || '',
                    p: soap.p || ''
                };
                try {
                    if (endNoteId) await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6e7c5d8b5a28479a), {
                        id: endNoteId,
                        input: {
                            content: content
                        }
                    });
                    else await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$1d32d39b70c8b52e), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('saveSoapNote failed:', e.message);
                    failures.push(t('visit.end.partSoap'));
                }
            }
            // No VISIT_SUMMARY note is written any more — see Visit.web.jsx.
            // Save prescribed drugs to patient medication list.
            // Rows carrying a `medicationId` already exist in the record — a template
            // put them there and every edit since went to that same row — so writing
            // them again would give the patient two rows for one drug. Same rule as
            // Visit.web.jsx; see useVisitRxPersistence.
            if (patient?.id && rxItems.length > 0) for (const item of rxItems){
                if (item.medicationId) continue;
                try {
                    await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5fcaf1729c987f4d), {
                        patientId: patient.id,
                        input: {
                            code: item.drug.genericName || item.drug.name,
                            display: item.drug.name,
                            status: 'active',
                            authoredOn: today,
                            // The SAME structured payload the desktop writes (useEndVisit):
                            // dose, frequency, route and quantity as fields, not one sentence.
                            // A phone-written drug used to keep only the sentence, so it could
                            // never be sent to an insurer — no route, no quantity.
                            dosageInstruction: (0, $5e2e0b7ea22d1ff2$export$1ed13c90275604ad)(item),
                            quantity: (0, $ace44487380106d3$export$48f972f5effb9c)(item.quantity),
                            meta: (0, $5e2e0b7ea22d1ff2$export$2fe3f622dc680493)(item.drug),
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('save medication failed:', e.message);
                    failures.push(`${t('visit.end.partDrug')} \u{2014} ${(0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug)}`);
                }
            }
            // Save diagnosis as active condition.
            // Note: accepted differential items are already persisted server-side by
            // ai.js's updateDifferentialItem resolver (action 'accept') the moment the
            // doctor accepts them — do NOT re-save those here, or every accepted
            // diagnosis ends up with two duplicate Condition rows.
            if (patient?.id) {
                const primaryDisplay = soap.a || diagnosis || '';
                if (primaryDisplay) try {
                    await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$52e699bb9024b09d), {
                        patientId: patient.id,
                        input: {
                            code: '',
                            display: primaryDisplay,
                            status: 'active',
                            // Free assessment prose nobody was asked to type — a working
                            // diagnosis until the doctor says otherwise. See Visit.web.jsx.
                            verificationStatus: (0, $4a744c4def3d338a$export$effbc4db6100f5f7),
                            onsetDate: today,
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('save condition failed:', e.message);
                    failures.push(t('visit.end.partDiagnosis'));
                }
            }
            // Save any pending orders that weren't saved yet via the panel button —
            // one write per order, as the desktop does (visitOrders.saveDoctorOrder):
            // the batch's answer was never read, and it said success even when every
            // order in it failed, so the closure showed none of them as «ثبت نشد».
            const unsavedAtEnd = pendingTests.filter((test)=>!test.savedToBackend);
            if (patient?.id && unsavedAtEnd.length > 0) {
                for (const item of unsavedAtEnd)try {
                    await (0, $3f422a714825191a$export$12af1fa985734757)({
                        patientId: patient.id,
                        appointmentId: resolvedPmEncId || visitId
                    }, (0, $3f422a714825191a$export$b7142a5aec62c528)(item));
                } catch (e) {
                    console.warn('save pendingTests at end failed:', e.message);
                    failures.push(`${t('visit.end.partOrders')} \u{2014} ${item.name || item.testName || item}`);
                }
            }
            // Only a clean end drops the draft — when a write failed it is the sole
            // surviving copy of what the doctor typed.
            if (failures.length === 0) try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            setSaveFailures(failures);
            if (failures.length > 0) toast?.error?.(t('visit.end.partialSaveToast'));
            setEndingVisit(false);
            setShowClosureFlow(true);
        } catch (e) {
            console.error('[handleEndVisit]', e);
            toast?.error?.(t('visit.end.failedToast'));
            setEndingVisit(false);
        }
    };
    // Back to پذیرش when the closure is done — see Visit.web.jsx.
    const goToReception = ()=>{
        setShowClosureFlow(false);
        navigate('reception');
    };
    // ── Load last 3 visit summaries for the context panel ────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || pastVisitSummaries !== null) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$815cd81bee1aa526), {
            patientId: patient.id,
            limit: 4
        }).then((data)=>setPastVisitSummaries(data.patientVisitHistory?.visits || [])).catch(()=>setPastVisitSummaries([]));
    }, [
        patient?.id
    ]);
    // ── Elapsed timer (ticks only while visit is in progress) ─────────────────
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const timer = setInterval(()=>setElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        visitStatus
    ]);
    // ── Recording timer (resets to 0 each time recording starts) ──────────────
    (0, $acw62.useEffect)(()=>{
        // A system pause FREEZES the count rather than resetting it: the doctor
        // should see how long the interrupted segment ran, and the number is no
        // longer what anything is billed from.
        if (isRecPaused) return undefined;
        if (!isRecording) {
            setRecElapsed(0);
            return undefined;
        }
        const timer = setInterval(()=>setRecElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        isRecording,
        isRecPaused
    ]);
    // ── The transcription line, read back rather than written ────────────────
    // Asking when the recording LEAVES `recording` covers every ending: a
    // deliberate stop, a final pass that resolved, and the system pause — which
    // still bills, because the audio still arrived.
    const wasRecordingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const was = wasRecordingRef.current;
        wasRecordingRef.current = isRecording;
        if (!was || isRecording) return undefined;
        // After the socket's own write, which happens the moment `done` reaches
        // the BFF. One retry covers a slow write without polling.
        const first = setTimeout(refetchCoins, 1200);
        const second = setTimeout(refetchCoins, 6000);
        return ()=>{
            clearTimeout(first);
            clearTimeout(second);
        };
    }, [
        isRecording,
        refetchCoins
    ]);
    // ── Auto-start or resume encounter when patient loads ────────────────────
    // Checks for an active in-progress encounter on the server first.
    // If found for this patient, restores visitId/status and pulls SOAP draft
    // from localStorage instead of creating a duplicate encounter.
    const autoStarted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || visitId || autoStarted.current) return;
        autoStarted.current = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$13ca7cd8c39f4461)).then((data)=>{
            const enc = data?.getActiveEncounter;
            if (enc?.id && enc.patientId === patient.id && enc.status === 'in_progress') {
                setVisitId(enc.id);
                setPmEncounterId(enc.id);
                setVisitStatus('inprogress');
                setResumedVisit(true);
                // Restore draft from localStorage — it's the only recovery path now;
                // enc.notes/enc.diagnosis no longer exist on Encounter, so there is no
                // server-side fallback anymore.
                try {
                    const raw = localStorage.getItem(`visit_draft_${patient.id}`);
                    if (raw) {
                        const draft = JSON.parse(raw);
                        if (draft.visitId === enc.id && Date.now() - draft.ts < 3600000) {
                            if (draft.soap) setSoap(draft.soap);
                            if (draft.rxItems?.length) setRxItems(draft.rxItems);
                            if (draft.diagnosis) setDiagnosis(draft.diagnosis);
                        }
                    }
                } catch  {}
                // Re-initialize AI session and differential for the resumed encounter
                setSessionReady(false);
                (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
                    visitId: enc.id,
                    patientId: patient.id
                }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            } else handleStart();
        }).catch(()=>handleStart());
    }, [
        patient?.id
    ]);
    // ── Leave-guard ───────────────────────────────────────────────────────────
    // window.__parsina_visit_guard: called by WebLayout/AppShell before navigating.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus === 'inprogress') window.__parsina_visit_guard = (proceedFn)=>{
            pendingNavRef.current = {
                callback: proceedFn
            };
            setLeaveConfirm(true);
        };
        else window.__parsina_visit_guard = null;
        return ()=>{
            window.__parsina_visit_guard = null;
        };
    }, [
        visitStatus
    ]);
    // ── The leave-guard's history anchor (§C.3 rule 2) ───────────────────────
    // A browser/platform back asks «خروج از ویزیت؟» through the anchor; a leave the
    // doctor has confirmed goes through `leaveVisit`, so it is not asked twice
    // (PM-0135). The anchor, the overlay rules and the unwind depth live in the hook.
    const leaveVisit = (0, $f987ed8f19153509$export$b78e23134a4d4c2b)({
        active: visitStatus === 'inprogress',
        visitKey: patient?.id,
        onRequest: (proceed)=>{
            pendingNavRef.current = {
                callback: proceed
            };
            setLeaveConfirm(true);
        },
        back: goBack
    });
    // Wrap the prop-based navigate so it also goes through the guard
    const navigate = (...args)=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = args;
            setLeaveConfirm(true);
        } else navProp(...args);
    };
    // ── Layer 1: Warn before accidental page close ────────────────────────────
    // beforeunload works on desktop Chrome/Firefox/Edge but is suppressed by
    // iOS Safari. Layers 1b handles iOS via visibilitychange + pagehide.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const onUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', onUnload);
        return ()=>window.removeEventListener('beforeunload', onUnload);
    }, [
        visitStatus
    ]);
    // ── Layer 1b: iOS / Android — immediate flush on page hide ───────────────
    // iOS Safari never fires beforeunload. visibilitychange (hidden) + pagehide
    // are the reliable signals that the page is about to die. When fired we
    // immediately write localStorage AND attempt a server save so no work is
    // lost between 30-second auto-save ticks.
    // Use a ref so the handlers always see the latest state without re-registering
    // on every keystroke.
    const draftFlushRef = (0, $acw62.useRef)(null);
    draftFlushRef.current = (recording = null)=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now(),
                // The transcript and the elapsed count exist only in the
                // transcription hook's memory, and the OS is about to freeze this
                // page. They ride into the draft so a doctor who comes back to a
                // reloaded tab still has what was said before the interruption —
                // independently of the server-side copy.
                ...recording ? {
                    recording: recording
                } : null
            }));
        } catch  {}
    };
    // Called INSIDE the `visibilitychange` handler — the last moment JS is
    // guaranteed to run — so it must stay synchronous.
    systemPauseRef.current = (snapshot)=>draftFlushRef.current(snapshot);
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress' || !visitId) return;
        const onVis = ()=>{
            if (document.visibilityState === 'hidden') draftFlushRef.current();
        };
        const onHide = ()=>draftFlushRef.current();
        document.addEventListener('visibilitychange', onVis);
        window.addEventListener('pagehide', onHide);
        return ()=>{
            document.removeEventListener('visibilitychange', onVis);
            window.removeEventListener('pagehide', onHide);
        };
    }, [
        visitStatus,
        visitId
    ]);
    // ── Layer 2: Save draft to localStorage on every SOAP / rx / diagnosis change
    // Keyed by patientId so recovery can find it even if the component remounts.
    (0, $acw62.useEffect)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now()
            }));
        } catch  {}
    }, [
        soap,
        rxItems,
        diagnosis,
        visitId,
        visitStatus
    ]);
    // Layer 3 (server auto-save every 30s) removed — VisitInput no longer accepts
    // notes/diagnosis/prescription; the Layer 2 localStorage draft above is the
    // only persistence for in-progress drafts now.
    // ── Fetch/refresh differential diagnosis ─────────────────────────────────
    //
    // Nothing below runs — not the visit-open call, not the loop, not a manual
    // refresh — until «S» carries a chief complaint and the history behind it. The
    // panel says so rather than sitting empty. Clinical monitoring is NOT part of
    // this: it is one way of filling «S», not a licence to reason from it.
    const diffGate = (0, $375f8776645d5aee$export$8b03bbb666cde734)({
        soap: soap
    });
    const diffReady = diffGate.ready;
    const diffReadyRef = (0, $acw62.useRef)(false);
    diffReadyRef.current = diffReady;
    // One in-flight request at a time. Every call re-runs the assessment against
    // whatever the visit knows at that moment, so two overlapping calls answer the
    // same question twice — and a poll that ticks while the previous one is still
    // out would stack requests without ever showing a newer answer.
    const diffInFlightRef = (0, $acw62.useRef)(false);
    // Moves whenever a confirm/dismiss leaves or settles — see
    // trackDifferentialDecision. A poll whose answer comes back with it moved
    // must not undo that decision on screen.
    const diffDecisionSeqRef = (0, $acw62.useRef)(0);
    const fetchDifferential = (0, $acw62.useCallback)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        if (!diffReadyRef.current) return;
        if (diffInFlightRef.current) return;
        diffInFlightRef.current = true;
        setDiffLoading(true);
        const decisionSeq = diffDecisionSeqRef.current;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$bc9f2df565557d4f), {
            visitId: visitId
        }).then((data)=>{
            const newItems = data.getDifferentialDiagnosis?.items || [];
            // Record the visit-ledger charge only when the AI service actually
            // re-ran (and billed) the assessment — free cache reads stay free.
            if (data.getDifferentialDiagnosis?.regenerated) chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('DIFFERENTIAL'), 'differential');
            const stale = diffDecisionSeqRef.current !== decisionSeq;
            setDifferential((prev)=>(0, $375f8776645d5aee$export$24f67d3076448bf7)(prev, newItems, {
                    stale: stale
                }));
        }).catch(()=>{}).finally(()=>{
            diffInFlightRef.current = false;
            setDiffLoading(false);
        });
    }, [
        visitId,
        visitStatus,
        chargeVisit
    ]);
    // Settings → دستیار هوشمند → «اجرای خودکار تشخیص افتراقی». Gates the two
    // AUTOMATIC paths below only; an explicit refresh still calls
    // fetchDifferential directly. Undefined reads as on.
    const autoDifferential = !aiSettingsUnknown && ai.autoDifferentialOnStart !== false;
    // Only fetch differential after session init is done — avoids race condition
    // where AI service has no session data and returns the empty fallback.
    // diffReady is a real dependency, not just the ref read inside
    // fetchDifferential: on a page reload the saved SOAP note is still in flight
    // when sessionReady flips, so the fetch used to be skipped by the readiness
    // guard and never retried (nothing else fetches unless recording) — the list
    // then only showed up after a remount, where the localStorage draft restores
    // SOAP first. It now also carries clinical monitoring, so the first automatic
    // run happens when the visit is genuinely under way.
    // Latched per visit so this stays ONE automatic call (each one bills credits).
    const autoDiffVisitRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!sessionReady || !autoDifferential || !diffReady) return;
        if (autoDiffVisitRef.current === visitId) return;
        autoDiffVisitRef.current = visitId;
        fetchDifferential();
    }, [
        sessionReady,
        autoDifferential,
        diffReady,
        visitId,
        fetchDifferential
    ]);
    // ── Re-assessment while the visit is live ────────────────────────────────
    //
    // Each tick is a full re-evaluation, not a cache read: the AI service rebuilds
    // the list from the transcript as it has grown, SOAP notes saved since, and
    // vitals recorded since, and returns the stored list untouched when none of
    // those moved. The cadence is the doctor's, from Settings → دستیار هوشمند
    // (which also honours the master automatic-differential switch, because
    // polling is a kind of automatic run); the on/off can be taken back for this
    // visit alone from the switch above the list.
    const { active: pollingActive, pollMs: pollMs, seconds: pollSeconds, overridden: pollOverridden, toggle: togglePolling } = (0, $375f8776645d5aee$export$3f0d5a0b11f5b929)(ai, aiSettingsUnknown, visitId);
    (0, $acw62.useEffect)(()=>{
        if (!pollingActive) return;
        // Recording is this LOOP's own prerequisite, not the differential's: each
        // tick exists to re-ask as the conversation grows, and with nothing being
        // transcribed there is nothing new to re-ask about. A doctor who writes the
        // history by hand still gets the differential, just not on a timer.
        if (!diffReady || recState !== 'recording') return;
        if (!visitId || visitStatus !== 'inprogress') return;
        // A backgrounded phone is nobody reading the list. The visit keeps
        // recording — this only defers the re-assessment, which the next visible
        // tick picks up with MORE context than it would have had, not less.
        const tick = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchDifferential();
        };
        const initial = setTimeout(tick, Math.min((0, $375f8776645d5aee$export$d3a7b2340b0c9d48), pollMs));
        const interval = setInterval(tick, pollMs);
        return ()=>{
            clearTimeout(initial);
            clearInterval(interval);
        };
    }, [
        diffReady,
        recState,
        visitId,
        visitStatus,
        fetchDifferential,
        pollingActive,
        pollMs
    ]);
    // Reset confirmation state only when the actual set of active diagnosis codes changes,
    // not on every poll (differential is a new array reference each fetch even with same data).
    // A refresh REVISES the list — a diagnosis that survives the reassessment keeps
    // its questions and the answers already recorded against it.
    const prevDiffCodesRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const active = (differential || []).filter((d)=>d.status !== 'rejected').map((d)=>d.diagnosisCode);
        const codes = [
            ...active
        ].sort().join(',');
        if (prevDiffCodesRef.current !== null && prevDiffCodesRef.current !== codes) {
            setDiagAIQuestions((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagAIAnswers((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagQSubmitting((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagQError((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setOpenAIDiag((prev)=>prev && active.includes(prev) ? prev : null);
        }
        prevDiffCodesRef.current = codes;
    }, [
        differential
    ]);
    // Loaded as soon as the encounter is known, NOT when the دستورات tab opens: the
    // plan block lists these orders, so they must be there for a doctor who goes
    // straight to «برنامه». The tab remains a retry point for a failed fetch.
    const ordersLoadedFor = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || ordersLoadedFor.current === encId) return;
        ordersLoadedFor.current = encId;
        loadClinicalOrders(encId).then((ok)=>{
            if (!ok) ordersLoadedFor.current = null;
        });
    }, [
        workTab,
        pmEncounterId,
        visitId
    ]);
    // What the orders already on this chart need from the catalogue — a lookup by
    // id, not a reason to fetch a dictionary. Orders written before catalogIds
    // existed resolve by name; an ambiguous name resolves to nothing.
    const resolveKey = (0, $acw62.useMemo)(()=>clinicalOrders.map((o)=>o?.catalogId || (o?.description || '').trim()).filter(Boolean).sort().join('\u0000'), [
        clinicalOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!resolveKey) {
            setCatalogResolved(new Map());
            return undefined;
        }
        let live = true;
        const current = clinicalOrders;
        (0, $375f8776645d5aee$export$ff3759fdd9615d20)({
            ids: current.map((o)=>o?.catalogId).filter(Boolean),
            names: current.filter((o)=>!o?.catalogId).map((o)=>(o?.description || '').trim()).filter(Boolean),
            appointmentId: pmEncounterId || visitId
        }).then((rows)=>{
            if (!live) return;
            const m = new Map();
            for (const r of rows){
                m.set(r.id, r);
                if (r.matchedName) m.set(r.matchedName, r);
            }
            setCatalogResolved(m);
        }).catch((err)=>console.error('order catalogue resolve failed:', err));
        return ()=>{
            live = false;
        };
    }, [
        resolveKey,
        pmEncounterId,
        visitId
    ]);
    // The picker's own query and type live in MobileVisitOrders, so the search goes
    // with them; the parent hands down the call, scoped to this visit's clinic.
    const searchCatalog = (0, $acw62.useCallback)(({ query: query, orderType: orderType })=>(0, $375f8776645d5aee$export$14e053085c2b7017)({
            query: query,
            orderType: orderType,
            appointmentId: pmEncounterId || visitId
        }), [
        pmEncounterId,
        visitId
    ]);
    // Load an already-saved treatment plan once the visit is known, so a resumed
    // visit shows «تأییدشده» on the «برنامه» section instead of offering to
    // generate a second plan. The SOAP note is the authority for the P text; the
    // stored plan note is only a fallback for a note that was lost.
    const planTabLoaded = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const appointmentId = pmEncounterId || visitId;
        if (planTabLoaded.current || !appointmentId || !patient?.id) return;
        planTabLoaded.current = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9c8ef21e5ce2027), {
            appointmentId: appointmentId,
            patientId: patient.id
        }).then((data)=>{
            const plan = data?.treatmentPlan;
            if (!plan?.exists) return;
            setPlanStatus(plan.status || 'draft');
            if (plan.planNote) setSoap((s)=>(s.p || '').trim() ? s : {
                    ...s,
                    p: plan.planNote
                });
        }).catch((e)=>console.warn('treatmentPlan load failed:', e.message));
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    // ── Clinical insight pass ──────────────────────────────────────────────────
    // The one pass, callable from two places: the automatic effect below and the
    // «دریافت نکات بالینی» button in the copilot sheet. Only the response's
    // `clinicalRationale` reaches the feed — its test/medication halves are
    // orders, and they belong to «دستورات» and «نسخه». Failures are kept rather
    // than swallowed — a silently empty sheet is indistinguishable from "the AI
    // had nothing to say", which is the one thing it must never be confused with.
    const runRecommendations = (0, $acw62.useCallback)(()=>{
        if (!patient?.id) return;
        const conditions = (patient.clinicalConditions || []).map((c)=>c.code || c.display).filter(Boolean);
        setRecsError(null);
        setRecsLoading(true);
        return (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$19b465740ee91bc), {
            input: {
                patientId: patient.id,
                icdCodes: conditions.slice(0, 5),
                age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                gender: '',
                existingMedications: (patient.clinicalMedications || []).filter((m)=>m.status === 'active').map((m)=>m.display),
                existingTests: []
            }
        }).then((data)=>{
            setRecommendations(data.recommendTestsAndMedications);
            setRecsRan(true);
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('RECOMMENDATIONS'), 'recs');
        }).catch((err)=>{
            console.error('[recommendations]', err);
            setRecsError(err?.message || t('errors.ai.suggestionsFailed'));
        }).finally(()=>setRecsLoading(false));
    }, [
        patient,
        chargeVisit,
        t
    ]);
    // Auto-fire it when the patient loads — but only if the doctor has left the
    // automation on. `suggestionsAutoRun` is in the deps on purpose: turning the
    // setting on mid-visit must start the pass, not wait for a remount.
    (0, $acw62.useEffect)(()=>{
        // Nothing is decided while the settings are still loading — otherwise the
        // default-on fallback fires the pass and latches recsAutoFired before the
        // doctor's actual choice is known.
        if (aiSettingsUnknown) return;
        if (!patient?.id || recsAutoFired.current) return;
        if (!suggestionsAutoRun) return;
        recsAutoFired.current = true;
        runRecommendations();
    }, [
        patient,
        aiSettingsUnknown,
        suggestionsAutoRun,
        runRecommendations
    ]);
    // ── Drug management ────────────────────────────────────────────────────────
    // None of these touch the SOAP «P» text. They used to: addDrug appended a line
    // to «P» from inside the setRxItems updater — an impure updater, and a one-way
    // append that no later edit or delete could take back. The plan block is
    // derived from rxItems instead (see the reconciler below).
    // A drug reaches the نسخه through the add form (RxDrugSearch → RxAddForm), which
    // hands over the sig the doctor confirmed: every required field on its closed
    // list (PM-0059). The line's shape is newRxLine's, as on the desktop.
    const addDrug = (0, $acw62.useCallback)((drug, sig)=>{
        setRxItems((prev)=>{
            if (prev.find((r)=>r.drug.id === drug.id)) return prev;
            return [
                ...prev,
                (0, $ace44487380106d3$export$5352dbb17a06665d)(drug, sig || {
                    route: (0, $ace44487380106d3$export$ae410c87a5d0011f)(drug)
                }, prev.length, {
                    durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                })
            ];
        });
    }, [
        t
    ]);
    // «افزودن به نسخه ویزیت» from a document review (§23.3 A13). It opens a prefilled
    // draft on the نسخه tab — the record sheet steps aside so the tab is what is
    // behind the review — and the line is added only by the draft's own «افزودن به نسخه».
    const offerDocumentRx = (0, $acw62.useCallback)((draft)=>{
        if ((0, $622fea85856450c1$export$26bd9984be9bfd1c)(rxItems, draft.drug)) return 'alreadyPrescribed';
        setDocRxDrafts((prev)=>prev.some((d)=>d.drug.id === draft.drug.id) ? prev : [
                ...prev,
                draft
            ]);
        setMobileSheet(null);
        setMobileTab('rx');
        return 'prefilled';
    }, [
        rxItems
    ]);
    docRxCapability.current = offerDocumentRx;
    // `chosen` — the product the form ended on: the doctor may have changed its
    // شکل or قدرت there, and the line is that product, not the one offered.
    const confirmDocRxDraft = (0, $acw62.useCallback)((draft, values, chosen)=>{
        const uniq = (v, list)=>[
                ...new Set([
                    v,
                    ...list || []
                ].filter(Boolean))
            ];
        const drug = chosen?.id ? chosen : draft.drug;
        setRxItems((prev)=>(0, $622fea85856450c1$export$26bd9984be9bfd1c)(prev, drug) ? prev : [
                ...prev,
                {
                    id: Date.now(),
                    // The row's selects offer the drug's common values; the confirmed sig is one.
                    drug: {
                        ...drug,
                        commonDosages: uniq(values.dosage, drug.commonDosages),
                        commonFrequencies: uniq(values.frequency, drug.commonFrequencies)
                    },
                    dosage: values.dosage || '',
                    frequency: values.frequency || '',
                    route: values.route || '',
                    duration: values.duration || '',
                    quantity: values.quantity || '',
                    instructions: values.instructions || ''
                }
            ]);
        setDocRxDrafts((prev)=>prev.filter((d)=>d.key !== draft.key));
    }, []);
    const discardDocRxDraft = (0, $acw62.useCallback)((draft)=>{
        setDocRxDrafts((prev)=>prev.filter((d)=>d.key !== draft.key));
    }, []);
    // ── تجویز مجدد — refill from the record sheet or a past visit ──────────────
    // One entry point for both refill doors (a current medication, and a drug
    // prescribed in a previous visit), exactly as on desktop. The previous dosing
    // rides along as the new row's defaults so the doctor lands on an editable
    // نسخه row instead of re-typing the drug. The product is the one the line was
    // written from, looked up by its id (refillDrugFor) — matched by name, it was
    // another strength or product (K1, 2026-10-03); only a line with no id is
    // matched by name.
    const represcribeMed = (0, $acw62.useCallback)(async (med)=>{
        const src = (0, $5e2e0b7ea22d1ff2$export$aac88d3c48aba92)(med);
        if (!src) return;
        const nameKey = src.name.toLowerCase();
        const drug = await (0, $375f8776645d5aee$export$dcced24b144b6c10)(src);
        let added = false;
        setRxItems((prev)=>{
            if (prev.some((r)=>r.drug.id === drug.id || (r.drug.name || '').trim().toLowerCase() === nameKey)) return prev;
            added = true;
            return [
                ...prev,
                (0, $ace44487380106d3$export$8dbcc67e0ab5a150)({
                    id: Date.now(),
                    drug: drug,
                    dosage: src.dosage || (0, $ace44487380106d3$export$f3c4ec3c63ab1d60)(drug),
                    frequency: src.frequency || (0, $ace44487380106d3$export$84160816d8079a95)(drug),
                    // A route stored under an older translated label («Oral») is written
                    // again as the route's value — the one the insurer codes.
                    route: (0, $ace44487380106d3$export$1aea987f77fa496a)(src.route) || src.route,
                    duration: src.duration || '',
                    quantity: src.quantity,
                    instructions: src.instructions
                }, {
                    durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                })
            ];
        });
        // The phone cannot show the نسخه tab behind an open sheet, and yanking the
        // doctor out of the record mid-review is worse than a line they can find:
        // the row flips to «در نسخه» and the toast offers the trip.
        if (added) {
            toast.success(t('visit.rx.represcribedToast', {
                name: src.name
            }));
            setRxInteractions(null);
            setIxError(null);
        }
    }, [
        toast,
        t
    ]);
    // Refill sources are keyed by NAME, not id: a record row and a formulary entry
    // never share ids, and the same drug must read «در نسخه» through either door.
    const prescribedMedNames = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>(r.drug?.name || '').trim().toLowerCase()).filter(Boolean)), [
        rxItems
    ]);
    // ── Past-visit detail ──────────────────────────────────────────────────────
    // Fetched when a «مراجعات اخیر» row is expanded, cached per encounter. The
    // ref de-dupes in-flight requests; the state carries the row's own three
    // states so one failed visit does not blank the others.
    const loadVisitContext = (0, $acw62.useCallback)(async (encId)=>{
        if (!encId) return;
        if (visitCtxRequested.current.has(encId) && visitContexts[encId]?.state !== 'error') return;
        visitCtxRequested.current.add(encId);
        setVisitContexts((prev)=>({
                ...prev,
                [encId]: {
                    state: 'loading'
                }
            }));
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$e8c7fd9774d91e48), {
                appointmentId: encId
            });
            setVisitContexts((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'ready',
                        data: data?.getEncounterContext || {}
                    }
                }));
        } catch  {
            visitCtxRequested.current.delete(encId);
            setVisitContexts((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'error'
                    }
                }));
        }
    }, [
        visitContexts
    ]);
    // «نوع تشخیص» on a chart condition — the only edit path for a diagnosis typed
    // into SOAP «A», which is never promoted from a differential.
    const changeCondType = (0, $acw62.useCallback)(async (cond, verificationStatus)=>{
        if (!cond?.id) return;
        setDxTypeBusyId(cond.id);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b8ec51b731e55222), {
                id: cond.id,
                input: {
                    verificationStatus: verificationStatus
                }
            });
            refreshPatient();
        } catch (e) {
            console.warn('[dx] retype failed:', e.message);
        } finally{
            setDxTypeBusyId(null);
        }
    }, [
        refreshPatient
    ]);
    // Rows that already exist server-side — everything a template put here, and
    // everything read back when this visit was reopened — are edited and deleted
    // through the record, not only in local state. Shared with the desktop
    // surface so the two cannot disagree about when a نسخه line becomes a record.
    const rxPersistence = (0, $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // ── «ارسال به بیمه» while the visit is open (PM-0097) ─────────────────────
    // The phone had the e-prescription card in the closure flow only: a doctor
    // could not send, or see that a registered نسخه had changed, before «پایان
    // ویزیت». The chip in the pinned strip carries the status on every tab and
    // opens the desktop panel's card in a sheet. Same rules as the desktop: never
    // in a clinic outside Iran, never while the visit is being closed, and the
    // status is read behind the نسخه's queued saves — the server reads the record.
    const iranianRails = (0, $e317r.useIranianRails)();
    const [erxSheetOpen, setErxSheetOpen] = (0, $acw62.useState)(false);
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [erxLeaveOpen, setErxLeaveOpen] = (0, $acw62.useState)(false);
    const erxAvailable = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endingVisit && !showClosureFlow;
    const { status: erxStatus, reload: reloadErxStatus } = (0, $5d2858db85b3973f$export$2eef96f829c6b514)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        prepare: rxPersistence.flush,
        active: erxAvailable
    });
    // Read again once an edit to the نسخه or the دستورات has settled — the chip's
    // status, and the open card through its refreshKey.
    const erxContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.medicationId || null,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            clinicalOrders.map((o)=>[
                    o.id,
                    o.status
                ])
        ]), [
        rxItems,
        clinicalOrders
    ]);
    const [erxRefreshKey, setErxRefreshKey] = (0, $acw62.useState)(erxContent);
    const erxReadFor = (0, $acw62.useRef)(erxContent);
    (0, $acw62.useEffect)(()=>{
        if (!erxAvailable || erxReadFor.current === erxContent) return undefined;
        const h = setTimeout(()=>{
            erxReadFor.current = erxContent;
            setErxRefreshKey(erxContent);
            reloadErxStatus();
        }, 900);
        return ()=>clearTimeout(h);
    }, [
        erxContent,
        erxAvailable,
        reloadErxStatus
    ]);
    const erxChip = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$25dd885c960a3a43)(erxStatus, {
            incomplete: rxItems.filter((r)=>(0, $ace44487380106d3$export$e9b4e5de48a21156)(r).length > 0).length,
            empty: rxItems.length === 0 && clinicalOrders.length === 0
        }), [
        erxStatus,
        rxItems,
        clinicalOrders
    ]);
    // A login waiting for its code, or a send in flight, is unsaved work: the
    // sheet asks before it closes over one.
    const closeErxSheet = (0, $acw62.useCallback)(()=>{
        if (erxBusy) {
            setErxLeaveOpen(true);
            return;
        }
        setErxSheetOpen(false);
    }, [
        erxBusy
    ]);
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        // applyRxEdit: a دوز/تناوب/مدت change carries a worked-out quantity along.
        // An edit to a line whose removal failed keeps it: the «حذف نشد» mark goes.
        // Any two of مقدار تحویلی / تناوب / مدت settle an empty third (applyRxEdit).
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $ace44487380106d3$export$b0f426f8468d8007)(r, key, val, {
                        durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                    }),
                    removeFailed: undefined
                } : r));
        rxPersistence.scheduleSave(id);
    }, [
        rxPersistence,
        t
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete FIRST: the hook reads the row out of the list it last saw.
        rxPersistence.deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
        // A result naming a drug that is no longer on the list is worse than no
        // result, so a removal clears it outright rather than marking it stale.
        setRxInteractions(null);
        setIxError(null);
    }, [
        rxPersistence
    ]);
    // ── Applying a template ─────────────────────────────────────────────────────
    // The server has already created the rows; these only show them. Same rail as
    // the desktop surface — the items arrive as ordinary نسخه/دستورات rows.
    const handleMedicationTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        setRxItems((prev)=>(0, $5e2e0b7ea22d1ff2$export$801d163b2e9340ef)(prev, (result?.medications || []).map((0, $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1))));
        if (outcome.applied) {
            setRxInteractions(null);
            setIxError(null);
        }
        const message = (0, $737671bfbc703ec9$export$9694ceada819b6a5)('medication', result, outcome, t, formatList);
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    const handleOrderTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        const orders = result?.orders || [];
        setClinicalOrders((prev)=>(0, $5e2e0b7ea22d1ff2$export$3c2b35db6130bf21)(prev, orders));
        setPendingTests((prev)=>{
            const have = new Set(prev.map((x)=>x.name));
            const fresh = orders.filter((o)=>[
                    'lab',
                    'imaging',
                    'procedure'
                ].includes(o.orderType) && !have.has(o.description)).map((o)=>({
                    id: `${o.id}`,
                    name: o.description,
                    type: o.orderType,
                    urgency: o.urgency || 'routine',
                    reason: o.notes || '',
                    loincCode: o.code || '',
                    savedToBackend: true
                }));
            return fresh.length ? [
                ...prev,
                ...fresh
            ] : prev;
        });
        const message = (0, $737671bfbc703ec9$export$9694ceada819b6a5)('order', result, outcome, t, formatList);
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    // Only diagnoses the doctor has ACCEPTED reach the rule engine, so a reshuffle
    // of the suggestions below them does not change the clinical picture a check
    // was run against.
    const acceptedDiagnoses = (0, $acw62.useMemo)(()=>(differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((d)=>d.description), [
        differential
    ]);
    const acceptedDiagnosesKey = acceptedDiagnoses.join(' ');
    // Doctor-requested only — mirrors the desktop. The former 800ms auto-sweep
    // interrupted the doctor mid-prescription; the sole check that still runs
    // unasked is the high-severity sweep in handleEnd.
    const rxSignature = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$73a34cab37d00ce4)(rxItems, acceptedDiagnosesKey), [
        rxItems,
        acceptedDiagnosesKey
    ]);
    const ixStale = !!rxInteractions && rxInteractions.signature !== rxSignature;
    // Two drugs, or one with an allergy or a condition to read it against
    // (Visit.shared canRunInteractionCheck — the same rule on both surfaces).
    const interactionCheckReady = (0, $375f8776645d5aee$export$1e5ddc066f5dd4da)(rxItems, patient, acceptedDiagnoses);
    const canCheckInteractions = interactionCheckReady && !interactionLoading;
    const runInteractionCheck = (0, $acw62.useCallback)(async ()=>{
        if (!(0, $375f8776645d5aee$export$1e5ddc066f5dd4da)(rxItems, patient, acceptedDiagnoses) || interactionLoading) return;
        setIxLoading(true);
        setIxError(null);
        try {
            const { conditions: conditions, allergies: allergies } = (0, $375f8776645d5aee$export$ead65992cf57cabf)(patient, acceptedDiagnoses);
            const result = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9812972017b718e1), {
                // Names, not formulary ids — see interactionDrugName.
                medicationIds: (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems),
                patientId: patient.id,
                patientConditions: conditions,
                patientAllergies: allergies
            });
            // Ours is the only answer. An empty result used to fall back to NLM RxNav's
            // interaction API from the browser — shut down in January 2024, so it
            // could never add a finding; it only added latency and sent the drug
            // names to a third party.
            const warnings = result.checkDrugInteraction?.warnings || [];
            setRxInteractions({
                hasInteractions: warnings.length > 0,
                warnings: warnings,
                signature: rxSignature
            });
            // The service debits every check, so the visit's own tally records it —
            // as the desktop and the end-of-visit sweep already did. Without it the
            // phone's «پارسه» figure ran one check short for every press.
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('INTERACTION_CHECK'), 'interaction');
        } catch (e) {
            setIxError(e?.message || t('errors.load.interactions'));
        } finally{
            setIxLoading(false);
        }
    }, [
        patient,
        rxItems,
        acceptedDiagnoses,
        interactionLoading,
        rxSignature,
        chargeVisit,
        t
    ]);
    // ── AI Assist ──────────────────────────────────────────────────────────────
    // Grounds the prescription assist in the full clinical picture of the current
    // visit: recorded conditions + accepted differentials + lab-inferred conditions
    // + the SOAP subjective/assessment + the working diagnosis, plus allergies.
    const buildAssistPrescriptionInput = ()=>{
        const recordedConditions = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
        const diffConditions = (differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((d)=>d.description);
        const labConditions = (0, $375f8776645d5aee$export$5176433c16ff5a4)(patient.clinicalObservations);
        const soapConditions = [
            soap.s,
            soap.a
        ].filter(Boolean);
        const allergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
        return {
            visitId: visitId || '',
            patientId: patient.id,
            // Checked by the same rule engine as the interaction check, so the same names.
            medications: (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems),
            conditions: [
                ...recordedConditions,
                ...diffConditions,
                ...labConditions,
                ...soapConditions
            ],
            diagnosis: soap.a || diagnosis || '',
            age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
            gender: '',
            existingTests: [],
            patientAllergies: allergies
        };
    };
    const handleAssistPrescription = async ()=>{
        if (!patient?.id) return;
        setAiLoading(true);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$82d8fcb090733ceb), {
                input: buildAssistPrescriptionInput()
            });
            setAiResult(data.assistPrescription);
            // The service debits for this exactly as it does for the نسخه tab's
            // button, so it goes on the visit ledger exactly as that one does. It used
            // to be the quietest spend on the page: unasked, and invisible everywhere
            // except the account panel.
            // `costOf`, not the constant. A Parseh price is a ROW served by the
            // active pricing policy (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_
            // DESIGN.md); the shipped constant in creditPricing.js is the OFFLINE FALLBACK the PriceBook uses
            // before its first load. Reading the constant here put a stale figure on
            // the visit ledger while the wallet was debited the real one — the same
            // call one panel over already did this correctly.
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('ASSIST_PRESCRIPTION'), 'rx');
        } catch (e) {
            // A spent wallet is the one failure the doctor has to be told about —
            // otherwise the panel simply never fills and nothing says why.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn(e);
        } finally{
            setAiLoading(false);
        }
    };
    // ── The نسخه's AI helpers: dictation · «پایش بالینی» · شرح حال ──────────────
    // docs/VISIT_RX_AI_ASSIST.md — the same hook and review as the desktop. The
    // approved lines open the add form a searched drug opens, one after another,
    // prefilled with the proposal's sig (proposalFormRequests, K1 2026-10-05) — in
    // the queue a document review's drugs wait in. They used to become lines
    // directly and arrive «ناقص» where the model left a required field out. The old
    // one-tap «پیشنهاد دارو» list added the model's free-text name as a synthetic
    // `sugg-med-` drug and is gone.
    const rxHistoryCtx = {
        soap: soap,
        diagnoses: [
            ...acceptedDiagnoses,
            diagnosis
        ].filter(Boolean)
    };
    const rxAssist = (0, $3e1a1a8acf34d11a$export$c779192d33323523)({
        getContext: ()=>({
                appointmentId: visitId || '',
                patient: patient,
                soap: soap,
                diagnoses: rxHistoryCtx.diagnoses,
                rxItems: rxItemsRef.current,
                transcript: liveTranscript
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (source)=>t(`visit.rxAssist.charged.${source.toLowerCase()}`),
        onCreditError: setCreditError,
        onApply: (lines, source)=>{
            const have = new Set(rxItemsRef.current.map((r)=>r.drug?.id));
            const requests = (0, $864ce04f6c433567$export$cb741851902ee7c4)(lines.filter((l)=>!have.has(l.drug.id)), {
                source: source,
                durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t),
                label: (n, total)=>total > 1 ? t('visit.rxAssist.formSourceN', {
                        n: formatNumber(n),
                        total: formatNumber(total)
                    }) : t('visit.rxAssist.formSource')
            });
            setDocRxDrafts((prev)=>[
                    ...prev,
                    ...requests.filter((r)=>!prev.some((d)=>d.drug.id === r.drug.id))
                ]);
        }
    });
    // ── «تکمیل از پایش بالینی» beyond the note and the نسخه (PM-0029, PM-0038) ──
    // علائم حیاتی, دستورات and اطلاعات پرونده read from the same transcript, each
    // from the «تکمیل» button of its own section. Findings are proposals; what the
    // doctor ticks is written through the path a hand-entered value takes
    // (monitoringApply.js): vitals land in the vitals FORM for the doctor to «ثبت»,
    // orders join the order list, a follow-up becomes a line of «P».
    const monitoringExtract = (0, $b71ef3742639a482$export$ae55c3af901dcf33)({
        // The visit's orders and encounter id say what it already holds: a second
        // «تکمیل» shows those findings as already on the visit, never writes them again.
        getContext: ()=>({
                appointmentId: visitId || '',
                encounterId: pmEncounterId || visitId || '',
                patient: patient,
                transcript: liveTranscript,
                orders: clinicalOrdersRef.current
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (group)=>t(`visit.monitoringExtract.charged.${group}`),
        onCreditError: setCreditError,
        // A heard lab / imaging / procedure is matched to its catalogue entry with the
        // picker's own search, so it is saved with its code like a hand-picked one.
        searchCatalog: (0, $375f8776645d5aee$export$14e053085c2b7017),
        onApply: async (picked)=>{
            const res = await (0, $f5fd2a1ce8ccb8d9$export$920e2c679038b5a0)({
                picked: picked,
                patientId: patient.id,
                appointmentId: pmEncounterId || visitId,
                t: t
            });
            if (res.creditError) setCreditError(res.creditError);
            if (Object.keys(res.vitalsPatch).length) {
                setVitals((prev)=>({
                        ...prev,
                        ...res.vitalsPatch
                    }));
                setVitalsMode('form');
            }
            if (res.orders.length) {
                setClinicalOrders((prev)=>[
                        ...res.orders.map((o)=>o.created),
                        ...prev
                    ]);
                setPendingTests((prev)=>[
                        ...prev,
                        ...res.orders.filter((o)=>[
                                'lab',
                                'imaging',
                                'procedure'
                            ].includes(o.item.orderType)).map((o)=>({
                                id: `${Date.now()}-${o.item.name}`,
                                name: o.item.name,
                                type: o.item.orderType,
                                urgency: o.item.urgency,
                                reason: o.item.reason,
                                loincCode: o.item.loincCode || o.item.code || '',
                                savedToBackend: true
                            }))
                    ]);
            }
            if (res.followUps.length) applyRefinedSections({
                p: (0, $80f289cb339918db$export$6a1840833052c978)((0, $375f8776645d5aee$export$35974e4f6db92b0)(soapRef.current?.p || ''), res.followUps)
            });
            if (res.saved) refreshPatient();
            // Nothing landed at all: keep the review open so the ticks are not lost.
            const landed = res.saved + res.followUps.length + Object.keys(res.vitalsPatch).length;
            if (!landed && res.failed) throw new Error('monitoring findings were not saved');
            if (res.failed) toast.error(t('visit.monitoringExtract.partlyApplied', {
                failed: res.failed
            }));
            else toast.success(t(Object.keys(res.vitalsPatch).length ? 'visit.monitoringExtract.appliedVitals' : 'visit.monitoringExtract.applied'));
        }
    });
    // ── «تکمیل» as one flow (PM-0038) ─────────────────────────────────────────
    // The same button in every section, the visit-wide one beside «پایش بالینی»,
    // and the guide that walks from one section's proposals to the next.
    const completion = (0, $d3f3ee41c97afb39$export$3bfa7c0c0c355160)({
        t: t,
        formatNumber: formatNumber,
        toast: toast,
        costOf: $121df138798ec781$export$c932aceb7c67d0f4,
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        disabled: !visitId || !patient?.id,
        recState: // «تکمیل خودکار پس از پایش بالینی»: never into a visit being closed.
        recState,
        autoRunOnStop: autoCompleteOn && visitStatus === 'inprogress' && !endingVisit && !showClosureFlow
    });
    // The stop control's own press — the one stop that may run «تکمیل» after it.
    const stopMonitoring = ()=>{
        completion.armAutoRun();
        stopRecCharged();
    };
    // Where a section lives on the phone: three of them are tabs, the vitals and
    // the record are the record sheet.
    const completeSectionShown = mobileSheet === 'vitals' ? 'vitals' : ({
        note: 'soap',
        rx: 'rx',
        ord: 'orders'
    })[mobileTab];
    const goCompleteSection = (id)=>{
        if (id === 'vitals' || id === 'record') {
            setMobileSheet('vitals');
            return;
        }
        setMobileSheet(null);
        pickMobileTab({
            soap: 'note',
            rx: 'rx',
            orders: 'ord'
        }[id]);
    };
    const findingsCard = (group)=>monitoringExtract.reviews[group].open ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a77297e82307ffaa$export$2e2bcd8739ae039), {
            variant: "mobile",
            group: group,
            review: monitoringExtract.reviews[group],
            onToggle: (key)=>monitoringExtract.toggle(group, key),
            onSetAll: (checked)=>monitoringExtract.setAll(group, checked),
            onApply: ()=>monitoringExtract.apply(group),
            onClose: ()=>monitoringExtract.close(group),
            onRetry: ()=>monitoringExtract.run([
                    group
                ]),
            onCatalog: (key, choice)=>monitoringExtract.chooseCatalog(group, key, choice)
        }) : null;
    // Auto-fire prescription assist when SOAP assessment is filled.
    //
    // Gated by the «نکات بالینی» switch, because that is where this answer LANDS:
    // the interaction warnings and the follow-up line it returns are cards in that
    // feed, beside the ones the insight pass produces. It is also an automatic
    // spend — 3 پارسه for every DISTINCT assessment text, so refining «A» three
    // times pays three times — which is precisely what a doctor turning the
    // automation off is asking to stop. The «پیشنهاد دارو» button in the نسخه tab
    // is untouched: that one they asked for.
    (0, $acw62.useEffect)(()=>{
        if (!autoAssistOn) return;
        const assessment = soap.a?.trim();
        if (!assessment || !patient?.id) return;
        if (assistAutoFired.current === assessment) return;
        const timer = setTimeout(()=>{
            assistAutoFired.current = assessment;
            handleAssistPrescription();
        }, 2500);
        return ()=>clearTimeout(timer);
    }, [
        soap.a,
        patient?.id,
        autoAssistOn
    ]);
    // ── AI Chat ────────────────────────────────────────────────────────────────
    const handleAsk = async (q)=>{
        const question = q || aiInput;
        if (!question.trim()) return;
        setAiMessages((prev)=>[
                ...prev,
                {
                    role: 'user',
                    text: question
                }
            ]);
        setAiInput('');
        setAiChatLoading(true);
        try {
            const history = (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient);
            const visitCtx = (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests);
            const conditionNames = (patient?.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const [bffResult, citations] = await Promise.allSettled([
                (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$d877ca4a83c64a39), {
                    visitId: visitId || '',
                    question: question,
                    transcriptionContext: visitCtx,
                    patientHistory: history,
                    patientId: patient?.id
                }),
                (0, $b840d32ddf66046b$export$afaf1496218aac9a)(question, conditionNames)
            ]);
            if (bffResult.status === 'rejected') throw bffResult.reason;
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: bffResult.value.askDoctorQuestion.answer,
                        confidence: bffResult.value.askDoctorQuestion.confidence,
                        suggestions: bffResult.value.askDoctorQuestion.followUpSuggestions,
                        citations: citations.status === 'fulfilled' ? citations.value : []
                    }
                ]);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: t('errors.ai.responseFailed'),
                        suggestions: [],
                        citations: []
                    }
                ]);
        } finally{
            setAiChatLoading(false);
        }
    };
    // ── Confirmation questions ────────────────────────────────────────────────
    const handleLoadDiagAIQuestions = async (diag)=>{
        if (diagAILoading[diag.diagnosisCode]) return;
        setDiagAILoading((prev)=>({
                ...prev,
                [diag.diagnosisCode]: true
            }));
        try {
            const history = (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient);
            const visitCtx = (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests);
            const result = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$15324fc83c054605), {
                visitId: visitId,
                patientId: patient?.id,
                differentials: [
                    {
                        diagnosisCode: diag.diagnosisCode,
                        description: diag.description
                    }
                ],
                transcriptionContext: visitCtx,
                patientHistory: history
            });
            const items = result?.generateConfirmationQuestions?.items || [];
            const qs = items[0]?.questions || [];
            setDiagAIQuestions((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: qs
                }));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
        } finally{
            setDiagAILoading((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: false
                }));
        }
    };
    // One question, one commit — the desktop fork's flow, unchanged: picking
    // بله/خیر writes that finding into «S», saves the note, and only then closes
    // THAT question, collapsing it to the finding it recorded while the panel
    // stays open on the rest. Nothing is keyed to the first question, so every
    // question in the set behaves the same; a committed one is inert on re-click.
    const handleAnswerDiagQuestion = async (diag, q, value)=>{
        const code = diag.diagnosisCode;
        const key = `${code}:${q.id}`;
        if (diagQSubmitting[key]) return; // in flight
        if (diagAIAnswers[code]?.[q.id]?.answer) return; // already recorded
        setDiagQSubmitting((prev)=>({
                ...prev,
                [key]: value
            }));
        setDiagQError((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        const updated = {
            ...soapRef.current,
            s: (0, $375f8776645d5aee$export$5a4e1c8ddaeead64)(soapRef.current.s, (0, $375f8776645d5aee$export$9c2ce4aa2a7d6fc6)(q, value, t))
        };
        const saved = await handleSaveSoapNote(updated);
        setDiagQSubmitting((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        if (!saved) {
            // «S» is left untouched, the answer unrecorded, and the panel open, so the
            // doctor can retry the same question rather than lose the finding.
            setDiagQError((prev)=>({
                    ...prev,
                    [key]: t('errors.save.answer')
                }));
            return;
        }
        soapRef.current = updated;
        setSoap(updated);
        // Recording the answer is what closes this question: the panel renders an
        // answered one as the single line it wrote, with no choices left to make.
        setDiagAIAnswers((prev)=>({
                ...prev,
                [code]: {
                    ...prev[code],
                    [q.id]: {
                        answer: value
                    }
                }
            }));
    };
    // Open/close a diagnosis's AI confirmation-question panel; fetch on first open.
    const toggleDiagAI = (d)=>{
        const next = openAIDiag === d.diagnosisCode ? null : d.diagnosisCode;
        setOpenAIDiag(next);
        if (next && !diagAIQuestions[d.diagnosisCode] && !diagAILoading[d.diagnosisCode]) handleLoadDiagAIQuestions(d);
    };
    const reloadDiagQuestions = (d)=>{
        // The findings already committed stay in «S» — this only drops the questions
        // they came from.
        setDiagAIQuestions((prev)=>({
                ...prev,
                [d.diagnosisCode]: []
            }));
        setDiagAIAnswers((prev)=>({
                ...prev,
                [d.diagnosisCode]: {}
            }));
        setDiagQError((prev)=>Object.fromEntries(Object.entries(prev).filter(([k])=>!k.startsWith(`${d.diagnosisCode}:`))));
        handleLoadDiagAIQuestions(d);
    };
    // ── Add suggested med/test from summary modal ─────────────────────────────
    // handleAddSuggestedMed is gone, as on the desktop: nothing called it, and it
    // wrote the drug as an uncoded prose record no insurer could be sent (K1,
    // 2026-10-03). Suggested drugs reach the نسخه as structured lines.
    const handleAddSuggestedTest = (idx)=>{
        setAddedSugTests((prev)=>new Set([
                ...prev,
                idx
            ]));
    };
    // ── Doctor Order Suggestions ───────────────────────────────────────────────
    const handleFetchOrderSuggestions = async ()=>{
        if (!patient?.id) return;
        setOrderSuggestionsLoading(true);
        setOrderSuggestions(null);
        setSelectedOrders(new Set());
        try {
            const icdCodes = (patient.clinicalConditions || []).map((c)=>c.code).filter(Boolean);
            const diagnoses = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const existingTests = (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean);
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$c3637e87e40dab8f), {
                appointmentId: visitId || undefined,
                patientId: patient.id,
                icdCodes: icdCodes.slice(0, 8),
                diagnoses: diagnoses.slice(0, 8),
                age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                gender: '',
                existingTests: existingTests.slice(0, 10)
            });
            setOrderSuggestions(data.suggestDoctorOrders);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn('suggestDoctorOrders failed:', e);
        } finally{
            setOrderSuggestionsLoading(false);
        }
    };
    const toggleOrder = (key)=>{
        setSelectedOrders((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSaveSelectedOrders = async ()=>{
        const unsavedManual = pendingTests.filter((test)=>!test.savedToBackend);
        if (!patient?.id || selectedOrders.size === 0 && unsavedManual.length === 0) return;
        setSavingOrders(true);
        const ordersToSave = [];
        // AI-suggested items the doctor checked
        if (orderSuggestions?.labTests) orderSuggestions.labTests.forEach((test)=>{
            if (selectedOrders.has(`lab:${test.testName}`)) ordersToSave.push({
                orderType: 'lab',
                name: test.testName,
                code: test.loincCode || '',
                description: test.reason || '',
                urgency: test.urgency || 'routine'
            });
        });
        if (orderSuggestions?.imagingStudies) orderSuggestions.imagingStudies.forEach((s)=>{
            if (selectedOrders.has(`imaging:${s.studyType}`)) ordersToSave.push({
                orderType: 'imaging',
                name: s.studyType,
                code: '',
                description: [
                    s.bodyPart,
                    s.reason
                ].filter(Boolean).join(" \u2014 "),
                urgency: s.urgency || 'routine'
            });
        });
        if (orderSuggestions?.procedureOrders) orderSuggestions.procedureOrders.forEach((p)=>{
            if (selectedOrders.has(`procedure:${p.name}`)) ordersToSave.push({
                orderType: 'procedure',
                name: p.name,
                code: p.code || '',
                description: p.reason || '',
                urgency: p.urgency || 'routine'
            });
        });
        // Manual orders added by the doctor that haven't been saved yet — with their
        // catalogue row and session count (visitOrders.doctorOrderInput).
        const firstManual = ordersToSave.length;
        unsavedManual.forEach((item)=>{
            ordersToSave.push((0, $3f422a714825191a$export$b7142a5aec62c528)(item));
        });
        if (ordersToSave.length === 0) {
            setSavingOrders(false);
            return;
        }
        // One write per order (visitOrders.saveDoctorOrder). This marked EVERY
        // unsaved row saved on the batch's `success`, which the BFF reported even
        // when all of the orders failed — and the end-of-visit flush sends only
        // unsaved rows, so an order that never reached the record was never sent
        // again. Now only an order that landed is marked; the rest stay unsaved
        // (and their AI ticks stay on) for the next «ثبت» or the end of the visit.
        const savedAi = [];
        const savedManual = [];
        try {
            for(let n = 0; n < ordersToSave.length; n++){
                const o = ordersToSave[n];
                try {
                    await (0, $3f422a714825191a$export$12af1fa985734757)({
                        appointmentId: pmEncounterId || visitId || undefined,
                        patientId: patient.id
                    }, o);
                    if (n >= firstManual) savedManual.push(unsavedManual[n - firstManual]);
                    else savedAi.push(o);
                } catch (e) {
                    console.warn('saveDoctorOrders failed:', o.name, e?.message);
                }
            }
            const allSaved = savedAi.length + savedManual.length === ordersToSave.length;
            if (!allSaved) toast?.error?.(t('visit.orders.saveRetry'));
            if (savedAi.length + savedManual.length > 0) {
                setSavedOrdersCount((c)=>c + savedAi.length + savedManual.length);
                // Mark the manual rows that landed as saved and add the AI orders that
                // landed (lab, imaging, procedure) to pendingTests. A row is matched by
                // its id, so one edited while the save ran is still found.
                const landed = (test)=>savedManual.some((r)=>r === test || r.id != null && r.id === test.id);
                setPendingTests((prev)=>{
                    let updated = prev.map((test)=>!test.savedToBackend && landed(test) ? {
                            ...test,
                            savedToBackend: true
                        } : test);
                    savedAi.forEach((o)=>{
                        if (!updated.find((item)=>item.name === o.name)) updated = [
                            ...updated,
                            {
                                id: Date.now() + Math.random(),
                                name: o.name,
                                type: o.orderType,
                                reason: o.description,
                                urgency: o.urgency,
                                savedToBackend: true
                            }
                        ];
                    });
                    return updated;
                });
                // Selection keys are `${orderType}:${name}` (toggleOrder's callers).
                setSelectedOrders((prev)=>{
                    if (allSaved) return new Set();
                    const next = new Set(prev);
                    savedAi.forEach((o)=>next.delete(`${o.orderType}:${o.name}`));
                    return next;
                });
            }
        } finally{
            setSavingOrders(false);
        }
    };
    // ── Structured catalog orders ─────────────────────────────────────────────
    // The درخواست tab's structured picker hands back one or more pending entries
    // (carrying the catalog linkage: code / loincCode / sessionCount / catalogId). We keep the
    // mobile persistence model — orders live in pendingTests and are saved at
    // «پایان ویزیت» via SAVE_DOCTOR_ORDERS — and just enrich what goes in.
    const handleAddOrders = (entries)=>{
        if (!entries?.length) return;
        setPendingTests((prev)=>{
            let updated = [
                ...prev
            ];
            entries.forEach((e)=>{
                if (!updated.find((test)=>test.name === e.name && test.type === e.type)) updated = [
                    ...updated,
                    {
                        id: `${Date.now()}-${e.name}`,
                        name: e.name,
                        type: e.type,
                        urgency: e.urgency || 'routine',
                        reason: e.reason || '',
                        code: e.code || '',
                        loincCode: e.loincCode || e.code || '',
                        sessionCount: e.sessionCount || 1,
                        catalogId: e.catalogId || null,
                        savedToBackend: false
                    }
                ];
            });
            return updated;
        });
    };
    // ── AI-assisted treatment plan (SOAP «برنامه» section) ─────────────────────
    const planKey = (type, name)=>`${type}:${name}`;
    const togglePlanItem = (key)=>{
        setSelectedPlanItems((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSuggestPlan = async ()=>{
        if (!patient?.id) return;
        setPlanLoading(true);
        setPlanError(null);
        try {
            const appointmentId = pmEncounterId || visitId || undefined;
            const reviewedDiffs = differential || [];
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$f34a41ed9a6da313), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    diagnosis: soap.a || '',
                    icdCodes: (patient.clinicalConditions || []).filter((c)=>c.code).slice(0, 8).map((c)=>({
                            code: c.code,
                            description: c.display || ''
                        })),
                    age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                    gender: patient.gender || '',
                    patientAllergies: (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
                    existingMedications: rxItems.map((r)=>r.drug.name).filter(Boolean),
                    existingTests: (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean).slice(0, 10),
                    existingImaging: clinicalOrders.filter((o)=>o.orderType === 'imaging').map((o)=>o.description).filter(Boolean),
                    soapSubjective: soap.s || '',
                    soapObjective: soap.o || '',
                    soapAssessment: soap.a || '',
                    soapPlan: soap.p || '',
                    differentials: reviewedDiffs.map((d)=>({
                            diagnosisCode: d.diagnosisCode || '',
                            diagnosisName: d.description || '',
                            confidence: d.confidence || '',
                            status: d.status || 'active',
                            supportingEvidence: d.supportingEvidence || [],
                            contradictingEvidence: d.contradictingEvidence || []
                        }))
                }
            });
            const plan = data.suggestTreatmentPlan;
            if (!plan) return;
            setPlanSuggestion(plan);
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('TREATMENT_PLAN'), 'plan', t('visit.plan.ready'));
            // Preselect everything: the doctor reviews by unchecking, which is faster.
            const preselected = new Set([
                ...(plan.medications || []).map((m)=>planKey('med', m.name)),
                ...(plan.labTests || []).map((test)=>planKey('lab', test.testName)),
                ...(plan.imagingStudies || []).map((s)=>planKey('imaging', s.studyType)),
                ...(plan.procedureOrders || []).map((p)=>planKey('procedure', p.name))
            ]);
            setSelectedPlanItems(preselected);
            // The note IS the «P» section — write it there and autosave. It replaces
            // the NARRATIVE only: the managed drug/order block belongs to the
            // reconciler and is spliced back on, so generating never drops the list of
            // what is already prescribed.
            const note = (plan.planNote || '').trim();
            if (note) {
                const prevNarrative = (0, $375f8776645d5aee$export$35974e4f6db92b0)(soap.p);
                setPlanReplacedP(prevNarrative && prevNarrative !== note ? prevNarrative : null);
                const nextP = (0, $375f8776645d5aee$export$a3aead4a50abe781)(note, planBlock);
                setSoap((s)=>({
                        ...s,
                        p: nextP
                    }));
                await handleSaveSoapNote({
                    ...soap,
                    p: nextP
                });
            }
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else {
                console.warn('suggestTreatmentPlan failed:', e);
                setPlanError(e.message || t('errors.ai.treatmentPlan'));
            }
        } finally{
            setPlanLoading(false);
        }
    };
    // Open the panel and generate on first use; afterwards the button just toggles
    // the panel so the doctor is never charged twice by a stray tap. Opening on a
    // visit that is not in progress still shows the panel — it explains why the
    // generate button is disabled, which a dead AI button would not.
    const handleOpenPlanPanel = ()=>{
        if (planPanelOpen) {
            setPlanPanelOpen(false);
            return;
        }
        setPlanPanelOpen(true);
        if (!planSuggestion && !planLoading && patient?.id && visitStatus === 'inprogress') handleSuggestPlan();
    };
    // Undo a generation that overwrote the doctor's own «P» narrative. The managed
    // block rides along untouched — it describes what is prescribed, which the undo
    // has no business changing.
    const handleRestorePlanText = async ()=>{
        if (planReplacedP == null) return;
        const restored = (0, $375f8776645d5aee$export$a3aead4a50abe781)(planReplacedP, planBlock);
        setPlanReplacedP(null);
        setSoap((s)=>({
                ...s,
                p: restored
            }));
        await handleSaveSoapNote({
            ...soap,
            p: restored
        });
    };
    // Persist the checked items, then the note, then flip the plan to confirmed.
    const handleApplyPlan = async ()=>{
        const appointmentId = pmEncounterId || visitId;
        if (!patient?.id || !appointmentId || !planSuggestion) return;
        setPlanSaving(true);
        setPlanError(null);
        let planFresh = [];
        try {
            // 1) Medications → the نسخه, ONE structured line each, as on the desktop
            // (K1, 2026-10-03). The phone wrote each as a prose record — a name and
            // `{ text }`, which no insurer can be sent — and never put it on the نسخه.
            // Now: the drug-list product the name stands for (matchFormularyDrug), the
            // plan's sig held to the closed lists, one line, written to the record with
            // the rest of the نسخه (writeNow).
            const meds = (planSuggestion.medications || []).filter((m)=>selectedPlanItems.has(planKey('med', m.name)));
            const lists = {
                routes: (0, $375f8776645d5aee$export$e730a0734bbb1219)(),
                durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
            };
            const planLines = [];
            const unmatched = [];
            for (const m of meds){
                let drug = null;
                try {
                    drug = await (0, $375f8776645d5aee$export$3f253215194ac0f3)(m.name);
                } catch (e) {
                    console.warn('plan: drug-list lookup failed:', e.message);
                }
                if (!drug) {
                    // No product the list settles: on the نسخه under the plan's name, and
                    // the doctor is told to choose the product.
                    unmatched.push(m.name);
                    drug = {
                        id: `plan-med-${m.name}`,
                        name: m.name,
                        genericName: '',
                        category: '',
                        commonDosages: [],
                        commonFrequencies: []
                    };
                }
                const sig = (0, $ace44487380106d3$export$e8df75bdc9e038c6)(drug, {
                    dosage: m.dosage,
                    frequency: m.frequency,
                    duration: m.duration,
                    instructions: m.notes
                }, lists);
                planLines.push((0, $ace44487380106d3$export$5352dbb17a06665d)(drug, {
                    ...sig,
                    route: sig.route || (0, $ace44487380106d3$export$ae410c87a5d0011f)(drug)
                }, planLines.length, {
                    durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                }));
            }
            planFresh = planLines.filter((l, i)=>!(0, $622fea85856450c1$export$26bd9984be9bfd1c)(rxItemsRef.current, l.drug) && !planLines.slice(0, i).some((p)=>p.drug.id === l.drug.id));
            if (planFresh.length) {
                setRxItems((prev)=>[
                        ...prev,
                        ...planFresh
                    ]);
                await rxPersistence.writeNow(planFresh);
            }
            if (unmatched.length) toast.warn(t('visit.rx.planUnmatched', {
                names: formatList(unmatched)
            }));
            // 2) Lab / imaging / procedure → doctor orders, in one call.
            const orders = [];
            (planSuggestion.labTests || []).forEach((test)=>{
                if (selectedPlanItems.has(planKey('lab', test.testName))) orders.push({
                    orderType: 'lab',
                    name: test.testName,
                    code: test.loincCode || '',
                    description: test.reason || '',
                    urgency: test.urgency || 'routine'
                });
            });
            (planSuggestion.imagingStudies || []).forEach((s)=>{
                if (selectedPlanItems.has(planKey('imaging', s.studyType))) orders.push({
                    orderType: 'imaging',
                    name: s.studyType,
                    code: '',
                    description: [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 "),
                    urgency: s.urgency || 'routine'
                });
            });
            (planSuggestion.procedureOrders || []).forEach((p)=>{
                if (selectedPlanItems.has(planKey('procedure', p.name))) orders.push({
                    orderType: 'procedure',
                    name: p.name,
                    code: p.code || '',
                    description: p.reason || '',
                    urgency: p.urgency || 'routine'
                });
            });
            // One write each (visitOrders.saveDoctorOrder), so the درخواست tab below
            // knows WHICH landed: this was one batch whose failure — or its
            // `success: false` — was swallowed, and every order was then listed as
            // saved regardless.
            const savedPlanOrders = new Set();
            for (const o of orders)try {
                await (0, $3f422a714825191a$export$12af1fa985734757)({
                    appointmentId: appointmentId,
                    patientId: patient.id
                }, o);
                savedPlanOrders.add(o);
            } catch (e) {
                console.warn('plan: saveDoctorOrders failed:', o.name, e.message);
            }
            // 3) The plan text is the SOAP «P» the doctor just reviewed — narrative
            // plus the managed block. Reconcile once more so the block reflects what
            // this confirm just created, drop any debounced write so it cannot land
            // after (and overwrite) this one, and save synchronously. `aiGenerated`
            // compares the NARRATIVE; the block is always machine-written.
            const rxForBlock = [
                ...rxItemsRef.current.filter((r)=>!planFresh.some((l)=>l.id === r.id)),
                ...planFresh
            ];
            const freshBlock = (0, $375f8776645d5aee$export$d3332d0820799abb)({
                rxItems: rxForBlock,
                orders: clinicalOrdersRef.current,
                orderNameEn: orderNameEn
            });
            const planNote = (0, $375f8776645d5aee$export$a3aead4a50abe781)(soap.p, freshBlock).trim();
            if (planNote) {
                clearTimeout(planSaveTimer.current);
                const nextSoap = {
                    ...soap,
                    p: planNote
                };
                setSoap(nextSoap);
                await handleSaveSoapNote(nextSoap);
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$97c305a43bb466fa), {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    planNote: planNote,
                    aiGenerated: (0, $375f8776645d5aee$export$35974e4f6db92b0)(planNote) === (planSuggestion.planNote || '').trim()
                });
            }
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$11e9f559a2c034d2), {
                appointmentId: appointmentId
            });
            setPlanStatus(res.confirmTreatmentPlan?.status || 'confirmed');
            setPlanReplacedP(null);
            // Reflect the saved orders in the درخواست tab without a refetch. One whose
            // write did not land is listed UNSAVED, with its code, so the end-of-visit
            // flush sends it again instead of the tab claiming it is in the record.
            if (orders.length) setPendingTests((prev)=>{
                let updated = [
                    ...prev
                ];
                orders.forEach((o)=>{
                    if (!updated.find((test)=>test.name === o.name)) updated = [
                        ...updated,
                        {
                            id: `${Date.now()}-${o.name}`,
                            name: o.name,
                            type: o.orderType,
                            reason: o.description,
                            urgency: o.urgency,
                            code: o.code || '',
                            savedToBackend: savedPlanOrders.has(o)
                        }
                    ];
                });
                return updated;
            });
        } catch (e) {
            console.warn('plan: confirm failed:', e);
            setPlanError(e.message || t('errors.save.treatmentPlan'));
        } finally{
            setPlanSaving(false);
        }
    };
    // ── Mid-visit SOAP save ───────────────────────────────────────────────────
    // ── Vitals ────────────────────────────────────────────────────────────────
    const handleSaveVitals = async ()=>{
        if (!patient?.id) return;
        // ── Validation: plausible physiological ranges; reject nonsensical input ──
        const RANGES = {
            bpSys: {
                min: 40,
                max: 300,
                label: t('patient.vitals.systolic')
            },
            bpDia: {
                min: 20,
                max: 200,
                label: t('patient.vitals.diastolic')
            },
            pulse: {
                min: 20,
                max: 300,
                label: t('patient.vitals.hr')
            },
            spo2: {
                min: 50,
                max: 100,
                label: t('patient.vitals.spo2')
            },
            temp: {
                min: 30,
                max: 45,
                label: t('patient.vitals.bodyTemp')
            },
            weight: {
                min: 1,
                max: 500,
                label: t('patient.vitals.wt')
            }
        };
        const errors = [];
        for (const [key, r] of Object.entries(RANGES)){
            const raw = vitals[key];
            if (raw === '' || raw == null) continue;
            const n = Number(raw);
            if (!Number.isFinite(n)) {
                errors.push(t('visit.vitals.invalidNumber', {
                    label: r.label
                }));
                continue;
            }
            if (n < r.min || n > r.max) errors.push(t('visit.vitals.outOfRange', {
                label: r.label,
                min: r.min,
                max: r.max
            }));
        }
        // Cross-field: systolic must exceed diastolic when both are entered
        if (vitals.bpSys && vitals.bpDia && Number.isFinite(Number(vitals.bpSys)) && Number.isFinite(Number(vitals.bpDia)) && Number(vitals.bpSys) <= Number(vitals.bpDia)) errors.push(t('visit.vitals.bpOrder'));
        if (errors.length) {
            setVitalsError(errors);
            return;
        }
        const today = new Date().toISOString().split('T')[0];
        const entries = [
            vitals.bpSys && {
                code: '8480-6',
                display: t('patient.vitals.systolic'),
                value: vitals.bpSys,
                unit: 'mmHg'
            },
            vitals.bpDia && {
                code: '8462-4',
                display: t('patient.vitals.diastolic'),
                value: vitals.bpDia,
                unit: 'mmHg'
            },
            vitals.pulse && {
                code: '8867-4',
                display: t('patient.vitals.hr'),
                value: vitals.pulse,
                unit: 'bpm'
            },
            vitals.spo2 && {
                code: '59408-5',
                display: t('patient.vitals.spo2'),
                value: vitals.spo2,
                unit: '%'
            },
            vitals.temp && {
                code: '8310-5',
                display: t('patient.vitals.bodyTemp'),
                value: vitals.temp,
                unit: "\xb0C"
            },
            vitals.weight && {
                code: '29463-7',
                display: t('patient.vitals.wt'),
                value: vitals.weight,
                unit: 'kg'
            }
        ].filter(Boolean);
        if (!entries.length) {
            setVitalsError([
                t('validation.atLeastOneValue')
            ]);
            return;
        }
        setVitalsError(null);
        setVitalsLoading(true);
        try {
            // On edit: delete this encounter's existing vitals first to avoid duplicates
            if (savedVitalIds.current.length) {
                await Promise.allSettled(savedVitalIds.current.map((id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$725e3ec3814f10de), {
                        id: id
                    })));
                savedVitalIds.current = [];
            }
            const results = await Promise.all(entries.map((e)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5d20d1065b54c736), {
                    patientId: patient.id,
                    input: {
                        code: e.code,
                        display: e.display,
                        value: e.value,
                        unit: e.unit,
                        status: 'NORMAL',
                        effectiveDate: today,
                        appointmentId: pmEncounterId || visitId || undefined
                    }
                })));
            // Store the new IDs so editing again can delete them
            savedVitalIds.current = results.map((r)=>r?.addObservation?.id).filter(Boolean);
            // What's on screen is now the encounter's record: no re-adoption on refetch.
            vitalsSeeded.current = String(pmEncounterId || visitId || '');
            setVitalsMode('saved');
            const spo2Limit = ai.spo2Threshold ?? 95;
            const bpLimit = ai.bpSystolicThreshold ?? 140;
            const alerts = [];
            if (vitals.spo2 && Number(vitals.spo2) < spo2Limit) alerts.push(t('visit.vitals.spo2Alert', {
                value: vitals.spo2,
                limit: spo2Limit
            }));
            if (vitals.bpSys && Number(vitals.bpSys) > bpLimit) alerts.push(t('visit.vitals.bpAlert', {
                value: vitals.bpSys,
                limit: bpLimit
            }));
            if (alerts.length) {
                const isCritical = vitals.spo2 && Number(vitals.spo2) < spo2Limit - 5 || vitals.bpSys && Number(vitals.bpSys) > bpLimit + 20;
                if (isCritical ? ai.interruptOnCritical !== false : ai.interruptOnWarning !== false) setVitalsAlert({
                    level: isCritical ? 'critical' : 'warning',
                    messages: alerts
                });
            }
            refreshPatient();
        } catch (e) {
            console.warn('saveVitals error:', e);
        } finally{
            setVitalsLoading(false);
        }
    };
    // ── Helpers ────────────────────────────────────────────────────────────────
    const patientConditions = (patient?.clinicalConditions || []).map((c)=>c.display);
    // Active diagnoses for the record sheet — same filter the desktop context
    // panel applies (active, minus the ones removed this session).
    const activeDiagnoses = (patient?.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active' && !removedCondIds.has(c.id));
    const rxText = rxItems.length > 0 ? rxItems.map((r)=>`\u{2022} ${(0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(r.drug)}${r.dosage ? ' ' + r.dosage : ''}${r.frequency ? ' - ' + r.frequency : ''}${r.duration ? ' ' + t('visit.rx.forDuration', {
            duration: r.duration
        }) : ''}`).join('\n') : '';
    if (pError && !patient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-content",
        "data-state": "error",
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: '7rem',
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('errors.load.patientRecord'),
        detail: pError?.message || String(pError),
        onRetry: refreshPatient
    })));
    // The phone's own shape — brand band, section pills, SOAP cards, CTA bar —
    // never a bare spinner (§2.4 / mobile §7).
    if (pLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$2ed6987820fcbbfe), null);
    const p = patient || routePatient;
    // ── Timer display ─────────────────────────────────────────────────────────
    const mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    const ss = String(elapsed % 60).padStart(2, '0');
    // ── «نکات بالینی» derived from live data ──────────────────────────────────
    // Insight only. Nothing orderable is built here — see Visit.shared.js for the
    // policy and filterClinicalInsights below for the backstop.
    const rawSuggestions = [];
    if (hints.length > 0) hints.forEach((h, i)=>{
        const text = typeof h === 'string' ? h : h.text || '';
        const hintType = typeof h === 'string' ? 'clinical_note' : h.hint_type || 'clinical_note';
        // A live hint that is really an order («CBC بده») is dropped rather than
        // shown: the doctor places tests in «دستورات» and drugs in «نسخه», and the
        // AI is prompted to reason instead of ordering.
        if (hintType === 'lab_test' || hintType === 'medication') return;
        const kind = t('visit.copilot.clinicalNote');
        // Skip if an existing card of the same kind already covers this hint
        // (Visit.shared `insightSimilarity`: Persian-folded words, not raw text).
        const isDup = rawSuggestions.some((s)=>s.kind === kind && (0, $375f8776645d5aee$export$6a1145afc4baa12e)(s.title, text) > (0, $375f8776645d5aee$export$769e1e6a71b6cabc));
        if (!isDup && text) rawSuggestions.push({
            id: `hint-${i}`,
            kind: kind,
            type: 'note',
            level: 'ok',
            conf: null,
            title: text,
            body: '',
            evidence: ''
        });
    });
    if (rxInteractions?.hasInteractions) rxInteractions.warnings.forEach((w, i)=>{
        const kindMap = {
            contraindication: t('visit.rx.contraindication'),
            allergy: t('visit.patient.allergyAlert'),
            black_box: 'Black Box FDA',
            interaction: t('visit.rx.interaction')
        };
        const kind = kindMap[w.warningType] || t('visit.rx.interaction');
        // A خفیف interaction is information: it joins the feed at note volume, so
        // only شدید/متوسط render as a warning card.
        const mild = (0, $375f8776645d5aee$export$a20f1db6dc818677)(w.severity) === 'low';
        rawSuggestions.push({
            id: `ix-${i}`,
            kind: kind,
            type: mild ? 'note' : 'safety',
            level: mild ? 'ok' : 'warn',
            conf: null,
            title: w.description,
            body: w.drug ? t('visit.interactions.drugLine', {
                drug: w.drug
            }) + (w.condition ? t('visit.interactions.conditionSuffix', {
                condition: w.condition
            }) : '') : '',
            evidence: w.drugPair || w.drug || '',
            _source: w.source || null
        });
    });
    // The insight pass answers with three things at once: recommended tests,
    // recommended medications, and the clinical rationale. Only the rationale is
    // read — the other two are orders, and they reach the doctor through
    // «دستورات» and «نسخه», which is where they can actually be placed.
    if (recommendations?.clinicalRationale) rawSuggestions.push({
        id: 'rationale',
        kind: t('visit.copilot.clinicalAnalysis'),
        type: 'rationale',
        level: 'ok',
        conf: null,
        title: t('visit.copilot.patientAssessment'),
        body: recommendations.clinicalRationale,
        evidence: ''
    });
    if (aiResult) {
        if (aiResult.hasInteractions && aiResult.interactionWarnings?.length) {
            // A warning naming a drug no longer on the نسخه is not shown — see the
            // desktop. Skipped by index so a dismissed `aiix-` card stays dismissed.
            const rxNames = (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems);
            // «بررسی تداخل» runs the same rule engine over the same drugs; a finding
            // its card already shows is not shown a second time (interactionAlreadyShown).
            const checkedIx = rxInteractions?.hasInteractions ? rxInteractions.warnings : [];
            aiResult.interactionWarnings.forEach((w, i)=>{
                if (!(0, $bb8a11e7c1131df5$export$e960330bae0466a4)(w, rxNames)) return;
                if ((0, $375f8776645d5aee$export$bd5821baf0a03519)(w, checkedIx)) return;
                const kindMap = {
                    contraindication: t('visit.rx.contraindication'),
                    allergy: t('visit.patient.allergyAlert'),
                    black_box: 'Black Box FDA',
                    interaction: t('visit.rx.interaction')
                };
                const mild = (0, $375f8776645d5aee$export$a20f1db6dc818677)(w.severity) === 'low';
                rawSuggestions.push({
                    id: `aiix-${i}`,
                    kind: kindMap[w.warningType] || t('visit.rx.interaction'),
                    type: mild ? 'note' : 'safety',
                    level: mild ? 'ok' : 'warn',
                    conf: null,
                    title: w.description,
                    body: w.drug ? t('visit.interactions.drugLine', {
                        drug: w.drug
                    }) + (w.condition ? t('visit.interactions.conditionSuffix', {
                        condition: w.condition
                    }) : '') : '',
                    evidence: w.drugPair || w.drug || '',
                    _source: w.source || null
                });
            });
        }
        // `suggestedMedications` / `recommendedTests` from the same response are
        // deliberately not read here — they are the نسخه tab's AI panel and the
        // دستورات tab's suggest button respectively.
        if (aiResult.followUpTimeline) rawSuggestions.push({
            id: 'followup',
            kind: t('patient.encType.followUp'),
            type: 'followup',
            level: 'ok',
            conf: null,
            title: aiResult.followUpTimeline,
            body: '',
            evidence: ''
        });
    }
    // The backstop: no producer above builds an orderable card, and this makes
    // sure a new AI response field cannot reintroduce one. See Visit.shared.js.
    // Note completion no longer injects a card here — the note's own section
    // owns the completion flow (per-section previews in MobileVisitSoap).
    const copilotSuggestions = (0, $375f8776645d5aee$export$b2355ec0f81e9680)(rawSuggestions.filter((s)=>!dismissedSuggs.has(s.id)));
    // ── Transcript lines ───────────────────────────────────────────────────────
    const transcriptLines = liveTranscript ? liveTranscript.split('\n').filter(Boolean).map((l)=>{
        const isDr = l.startsWith(t('visit.print.doctorPrefix')) || l.startsWith('Doctor:');
        // i18n-exempt: speaker prefixes as the transcriber emits them, in both
        // languages it can produce. A matcher, not a label.
        return {
            role: isDr ? 'dr' : 'pt',
            spk: isDr ? t('visit.print.doctorTitle') : t('common.labels.patient'),
            text: l.replace(/^(دکتر:|Doctor:|بیمار:|Patient:)\s*/, '')
        };
    }) : [];
    const activeDiffs = (differential || []).filter((d)=>d.status !== 'rejected');
    const diffQuickQ = activeDiffs.length > 0 ? [
        ...activeDiffs.slice(0, 3).map((d)=>t('visit.copilot.confirmQuestion', {
                diagnosis: d.description
            })),
        t('visit.plan.prompt')
    ] : (0, $375f8776645d5aee$export$8b6317f87e032c1)(t);
    const allergies = p?.allergies || p?.clinicalAllergies || [];
    // ── Composition-layer wiring (regular handlers, defined after the loading
    //    early-return; these lift the render's intents onto the logic above) ──
    const handleBack = ()=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = [
                '__back__'
            ];
            setLeaveConfirm(true);
        } else goBack();
    };
    const handleLeaveConfirm = ()=>{
        const pending = pendingNavRef.current;
        setLeaveConfirm(false);
        pendingNavRef.current = null;
        if (!pending) return;
        leaveVisit(()=>{
            if (pending.callback) {
                pending.callback();
                return;
            }
            if (Array.isArray(pending)) {
                if (pending[0] === '__back__') goBack();
                else navProp(...pending);
            }
        });
    };
    // Accepting takes the «نوع تشخیص» the doctor picked — same shared call the
    // desktop rail makes, so the two surfaces cannot ask for it differently.
    // `d` alone is never enough: without a type there is nothing to record.
    const handleDiffAccept = async (d, diagnosisType)=>{
        const isAccepted = (0, $375f8776645d5aee$export$d20c1dcfc45ad42b)(d);
        setDiffTypeBusy(true);
        try {
            await (0, $375f8776645d5aee$export$a11a26367843ed4f)(diffDecisionSeqRef, ()=>(0, $375f8776645d5aee$export$5cadc197239e50ce)({
                    bffMutation: $adebb901af88e18b$export$8395d0fc0d822a81,
                    visitId: visitId,
                    diagnosisCode: d.diagnosisCode,
                    diagnosisType: diagnosisType,
                    isAccepted: isAccepted,
                    setDifferential: setDifferential
                }));
            setDiffTypePick(null);
            refreshPatient();
            if (!isAccepted) setSoapDiffConfirm({
                description: d.description,
                diagnosisCode: d.diagnosisCode
            });
        } catch  {}
        setDiffTypeBusy(false);
    };
    const handleDiffReject = async (d)=>{
        try {
            await (0, $375f8776645d5aee$export$a11a26367843ed4f)(diffDecisionSeqRef, async ()=>{
                const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$477e67f6b97e7e38), {
                    appointmentId: visitId,
                    diagnosisCode: d.diagnosisCode,
                    action: 'reject'
                });
                setDifferential(res.updateDifferentialItem?.items || differential);
            });
        } catch  {}
    };
    const handleDiffConfirmToA = (yes)=>{
        if (yes && soapDiffConfirm) setSoap((prev)=>{
            const updated = {
                ...prev,
                a: [
                    prev.a,
                    soapDiffConfirm.description
                ].filter(Boolean).join('\n')
            };
            handleSaveSoapNote(updated);
            return updated;
        });
        setSoapDiffConfirm(null);
    };
    // Current active meds, de-duplicated by id then display, minus any stopped
    // this session — the record sheet's «داروهای جاری» list.
    const seenMedIds = new Set();
    const seenMedNames = new Set();
    const uniqMeds = (patient?.clinicalMedications || []).filter((m)=>{
        if (m.status !== 'active') return false;
        if (removedMedNames.has(medKey(m))) return false;
        if (seenMedIds.has(m.id)) return false;
        const nm = (m.display || '').trim().toLowerCase();
        if (nm && seenMedNames.has(nm)) return false;
        seenMedIds.add(m.id);
        if (nm) seenMedNames.add(nm);
        return true;
    });
    // One header action: everything that has no home on a phone's single CTA —
    // print, upload, and لغو ویزیت. The cancel deliberately does NOT sit beside
    // «پایان ویزیت» in the footer: adjacent terminal actions with opposite
    // meaning are an error trap. The record has its own labelled button beside
    // it, in the header's `action` slot (MobileVisitRecordButton, PM-0033).
    const headerActions = [
        {
            key: 'more',
            Icon: (0, $24a488cfd7efdee5$export$2e2bcd8739ae039),
            label: t('common.actions.more'),
            onClick: ()=>setOverflowOpen(true)
        }
    ];
    // رویدادها — what used to be a three-line banner under the tabs («ویزیت
    // ناتمام بازیابی شد») and a strip above the header (low credit) is now the
    // bell in the header's top corner: announced once, then one 44px control.
    // The strips that remain are the ones the doctor must act on NOW.
    const visitEvents = [
        resumedVisit && visitStatus === 'inprogress' && {
            id: 'resumed',
            Icon: (0, $9c3425eadfb41de5$export$2e2bcd8739ae039),
            title: t('visit.resume.recovered'),
            body: t('visit.resume.recoveredBody')
        },
        !creditError && walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low' && {
            id: 'lowCredit',
            tone: 'warn',
            Icon: (0, $QG9Z3.default),
            // The condition, not an occurrence: it stays listed while it holds.
            sticky: true,
            title: `${t('visit.header.lowCreditPrefix')}${(0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(walletBalance, formatNumber)} ${t('visit.header.lowCreditSuffix')}`,
            action: canBuyCredits ? {
                label: t('credits.topUp'),
                onClick: ()=>navProp('credits')
            } : undefined
        }
    ].filter(Boolean);
    const handleEventsSeen = (ids)=>{
        if (ids.includes('resumed')) setResumedVisit(false);
    };
    // The header row is the patient: the name is the title, and under it the
    // visit clock (while it runs) and the facts that tell two namesakes apart.
    const pad2 = (n)=>String(n).padStart(2, '0');
    const headerSubtitle = [
        visitStatus === 'inprogress' && formatDigits(`${pad2(Math.floor(elapsed / 60))}:${pad2(elapsed % 60)}`),
        ...(0, $4426115d6c876762$export$a800c9151312278d)(p, t, formatDigits)
    ].filter(Boolean).join(" \xb7 ") || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $375f8776645d5aee$export$1f71eb225ba1e723)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        }
    }, isRecPaused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $685ede922aaeb8a3$export$2e2bcd8739ae039), {
        onResume: resumeRec,
        onDismiss: dismissPause
    }), creditError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-credit-error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            background: (0, $jTCZr.CT).dangerSoft,
            borderBottom: `1px solid ${(0, $jTCZr.C).redLight}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('errors.kind.insufficientCredits.title'), walletBalance !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            opacity: 0.8
        }
    }, " \xb7 ", t('visit.header.balanceLabel'), " ", (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(walletBalance, formatNumber), " ", t('common.units.coin'))), canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        className: "shrink-0",
        "data-testid": "visit-credit-topup",
        onClick: ()=>navProp('credits')
    }, t('credits.buyCoins')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        "aria-label": t('common.actions.close'),
        onClick: ()=>setCreditError(null),
        style: {
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
        compact: true,
        title: p?.name || t('patient.visit'),
        subtitle: headerSubtitle,
        onBack: handleBack,
        backLabel: t('common.actions.back'),
        leading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acb36492df172d8d$export$2e2bcd8739ae039), {
            events: visitEvents,
            onSeen: handleEventsSeen
        }),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4426115d6c876762$export$2e2bcd8739ae039), {
            patientName: p?.name,
            proposals: completion.pending.vitals + completion.pending.record,
            onOpen: ()=>setMobileSheet('vitals')
        }),
        actions: headerActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013436dd88cfa3ff$export$2e2bcd8739ae039), {
        call: call,
        patientName: p?.name,
        variant: "mobile"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 20,
            background: (0, $jTCZr.C).card
        }
    }, allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40b242509fe3ec60$export$2e2bcd8739ae039), {
        allergies: allergies
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-monitoring-control",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $943b784cb4e4dd8b$export$2e2bcd8739ae039), {
        recState: recState,
        recElapsed: recElapsed,
        disabled: isStopping || isConnecting,
        onToggle: isRecording ? stopMonitoring : isRecPaused ? resumeRec : startRec
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
        variant: "mobile",
        tone: "solid",
        testid: "visit-complete-all",
        ...completion.allButton
    }), erxAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f243566eab73828$export$9103f952c2bc2d33), {
        state: erxChip,
        onClick: ()=>setErxSheetOpen(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$f8baeb9beb7439e1), {
        variant: "mobile",
        steps: completion.flow.steps,
        current: completeSectionShown,
        next: completion.flow.nextFrom(completeSectionShown),
        onGo: goCompleteSection
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82e479bcc1dba2a2$export$2e2bcd8739ae039), {
        active: mobileTab,
        onChange: pickMobileTab,
        isVisible: mobileTabShown,
        counts: {
            rx: rxItems.length,
            ord: pendingTests.length
        },
        proposals: {
            note: completion.pending.soap,
            rx: completion.pending.rx,
            ord: completion.pending.orders
        },
        trailing: canConvertVisit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            onClick: ()=>{
                call.clearConvertError();
                setConvertSheetOpen(true);
            },
            "aria-label": t('visit.call.convert'),
            title: t('visit.call.convert'),
            "data-testid": "visit-convert-online",
            className: "min-w-11 min-h-11 shrink-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'grid',
                placeItems: 'center',
                width: '2.125rem',
                height: '2.125rem',
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d97ad00fbef0d0b$export$2e2bcd8739ae039), {
            size: 17,
            "aria-hidden": true
        }))) : null
    })), startError && visitStatus !== 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-start-failed",
        role: "alert",
        style: {
            padding: '0.625rem 0.875rem',
            background: (0, $jTCZr.C).redLight,
            borderBottom: `1px solid ${(0, $jTCZr.CT).danger}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.start.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "h-9 shrink-0",
        "data-testid": "visit-start-retry",
        onClick: handleStart
    }, t('visit.start.retry'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.3125rem',
            lineHeight: 1.7
        }
    }, t(`${(0, $91f57610161f2da8$export$78353e7f4dfe1b54)((0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(startError))}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.1875rem',
            lineHeight: 1.7
        }
    }, t('visit.start.failedHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 0.875rem 1rem'
        },
        "data-testid": "visit-content",
        "data-state": visitStatus === 'inprogress' ? 'content' : 'empty'
    }, mobileTab === 'note' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $58ef1df1f5757bce$export$2e2bcd8739ae039), {
        soap: soap,
        onChange: (key, val)=>setSoap((prev)=>({
                    ...prev,
                    [key]: val
                })),
        /* «برنامه» is where the treatment plan is produced: its AI
                     button generates the plan, whose prose lands in this very
                     field, and the review panel opens underneath it. */ onPlanAi: handleOpenPlanPanel,
        planAiDisabled: planLoading || planSaving || !visitId,
        planAiLoading: planLoading,
        planPanelOpen: planPanelOpen,
        onPlanFocusChange: setPlanEditorFocused,
        /* تکمیل یادداشت — merge-aware completion, same hook as
                     desktop: previews per section, apply/dismiss, charge only
                     when the server says it charged. Asked for from the top
                     strip's visit-wide «تکمیل»; the note has no button of its
                     own (PM-0046). */ refine: soapRefine,
        planBlockHint: planBlock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-plan-block-hint",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.3125rem',
                marginTop: '0.375rem',
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.3125rem',
                height: '0.3125rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), t('visit.plan.blockHint')) : null,
        planPanel: planPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b567ba15159c8a42$export$2e2bcd8739ae039), {
            suggestion: planSuggestion,
            loading: planLoading,
            saving: planSaving,
            status: planStatus,
            error: planError,
            selected: selectedPlanItems,
            onToggle: togglePlanItem,
            onGenerate: handleSuggestPlan,
            onConfirm: handleApplyPlan,
            onClose: ()=>setPlanPanelOpen(false),
            onRestore: handleRestorePlanText,
            canRestore: planReplacedP != null,
            inprogress: visitStatus === 'inprogress',
            canGenerate: !!patient?.id && visitStatus === 'inprogress'
        }) : null
    }), mobileTab === 'rx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3d5dc5a5bf298474$export$2e2bcd8739ae039), {
        rxItems: rxItems,
        templateButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $737671bfbc703ec9$export$2e2bcd8739ae039), {
            kind: "medication",
            compact: true,
            allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
            existingDrugIds: rxItems.map((r)=>r.drug?.id).filter(Boolean),
            appointmentId: pmEncounterId || visitId,
            patientId: patient?.id,
            onApplied: handleMedicationTemplateApplied
        }),
        onAdd: addDrug,
        insurer: (0, $ace44487380106d3$export$e4f91298b6c5a0f0)(patient?.insurance),
        documentDrafts: docRxDrafts,
        onConfirmDocumentDraft: confirmDocRxDraft,
        onDiscardDocumentDraft: discardDocRxDraft,
        onRemove: removeDrug,
        onUpdate: updateDrug,
        interactions: rxInteractions,
        interactionLoading: interactionLoading,
        interactionError: ixError,
        interactionStale: ixStale,
        onCheckInteractions: runInteractionCheck,
        canCheckInteractions: canCheckInteractions,
        assist: {
            busySource: rxAssist.review.phase === 'loading' ? rxAssist.review.source : null,
            onHistory: ()=>rxAssist.run((0, $864ce04f6c433567$export$594476081fc43e05).HISTORY),
            canHistory: !!visitId && (0, $864ce04f6c433567$export$9ff2a43ac3d586f)((0, $864ce04f6c433567$export$594476081fc43e05).HISTORY, rxHistoryCtx)
        },
        /* The proposal sits in the tab it would fill, like every other. */ proposal: rxAssist.review.open ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2366d82badfc6b73$export$2e2bcd8739ae039), {
            variant: "mobile",
            review: rxAssist.review,
            rxItems: rxItems,
            allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
            onToggle: rxAssist.toggle,
            onChoose: rxAssist.choose,
            onSetAll: rxAssist.setAll,
            onApply: rxAssist.apply,
            onClose: rxAssist.close,
            onRetry: ()=>rxAssist.run(rxAssist.review.source)
        }) : null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        hidden: mobileTab !== 'ord',
        "data-testid": "visit-tab-ord"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $737671bfbc703ec9$export$2e2bcd8739ae039), {
        kind: "order",
        compact: true,
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleOrderTemplateApplied
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dcedef1256f07607$export$2e2bcd8739ae039), {
        onFetchSuggestions: handleFetchOrderSuggestions,
        suggestions: orderSuggestions,
        suggestionsLoading: orderSuggestionsLoading,
        canSuggest: !!visitId,
        searchCatalog: searchCatalog,
        pendingTests: pendingTests,
        onAddOrders: handleAddOrders,
        onAddPending: (item)=>setPendingTests((prev)=>prev.find((test)=>test.name === item.name) ? prev : [
                    ...prev,
                    item
                ]),
        onRemovePending: (id)=>setPendingTests((prev)=>prev.filter((x)=>x.id !== id)),
        /* Saved orders and their lifecycle. Until now the phone
                     fetched these and showed none of them: an order created on
                     either surface was invisible here, and «انجام» — the event
                     accounting bills on — had no button at all. */ orders: clinicalOrders,
        ordersLoading: ordersLoading,
        ordersLoaded: ordersLoaded,
        transitioningId: orderTransitioning,
        inHouseCatalogIds: inHouseCatalogIds,
        insurer: (0, $ace44487380106d3$export$e4f91298b6c5a0f0)(patient?.insurance),
        catalogResolved: catalogResolved,
        onCompleteOrder: handleOrderDone,
        onCancelOrder: setOrderToCancel,
        orderError: orderError,
        onDismissOrderError: ()=>setOrderError(null),
        /* No section «تکمیل»: the pinned strip's visit-wide one reads
                     the دستورات too, as it does the نسخه (PM-0110 item 2 — one
                     «تکمیل», the same in every section). */ proposal: findingsCard('ORDERS'),
        onPendingChange: setOrdersPending
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0385119c9c941a3e$export$2e2bcd8739ae039), {
        compact: true,
        className: "mt-3",
        appointmentId: pmEncounterId || visitId || null,
        patientId: patient?.id,
        doctorId: doctor?.id
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: footerRef,
        style: {
            flexShrink: 0,
            padding: `0.5rem 0.875rem calc(0.5rem + env(safe-area-inset-bottom, 0px) + ${keyboardInset}px)`,
            // ONE row (PM-0044, design §۱۲). The three actions of a visit are
            // three different kinds of thing, and their weight follows how often
            // they are used: «پایش بالینی» — the running process — is the solid
            // control in the top strip; down here «دستیار» is a quiet way in and
            // «پایان ویزیت», done once, is an outline at the far end. Nothing in
            // this row is filled except «شروع ویزیت» before the visit exists.
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.5rem',
            background: (0, $jTCZr.C).bg,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        },
        "data-testid": "visit-footer"
    }, !visitStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        onClick: handleStart,
        "data-testid": "visit-cta-start",
        className: "w-full min-h-11"
    }, t('dashboard.hero.startVisit')) : visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, keyboardInset === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d7965145b8773dba$export$2e2bcd8739ae039), {
        count: copilotSuggestions.length + activeDiffs.length,
        onOpen: ()=>setMobileSheet('ai')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f551dfec33029cb$export$2e2bcd8739ae039), {
        onEnd: ()=>{
            if (ordersPending > 0) {
                setMobileTab('ord');
                toast?.warn?.(t('visit.orders.pendingOnEnd', {
                    count: formatDigits(ordersPending)
                }));
                return;
            }
            setPendingEnd(true);
        },
        ending: endingVisit,
        style: {
            marginInlineStart: keyboardInset === 0 ? '0.5rem' : 'auto'
        }
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9331b3f7d9a9e1d6$export$2e2bcd8739ae039), {
        open: mobileSheet === 'ai',
        onClose: ()=>setMobileSheet(null),
        tab: mobileAiTab,
        onTab: pickAiTab,
        isTabVisible: (id)=>(0, $792124e2f7de719a$export$ec23aec8c07c3d8a)(visitLayout, id),
        // The differential lives HERE and nowhere else on the phone: it is AI
        // output, so it sits with the assistant, and the nav keeps the three
        // things the doctor writes (note, prescription, orders).
        diffCount: activeDiffs.length,
        differentialPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e7b4aced78aeee5a$export$2e2bcd8739ae039), {
            items: differential,
            loading: diffLoading,
            visitStatus: visitStatus,
            primaryCode: mobileDiffPrimary,
            confirmToA: soapDiffConfirm,
            onSetPrimary: setMobileDiffPrimary,
            onAccept: handleDiffAccept,
            onReject: handleDiffReject,
            typePick: diffTypePick,
            onPickType: setDiffTypePick,
            typeBusy: diffTypeBusy,
            conditions: activeDiagnoses,
            onConfirmToA: handleDiffConfirmToA,
            onAddIcd: ()=>{},
            openAIDiag: openAIDiag,
            onToggleAIDiag: toggleDiagAI,
            aiQuestions: diagAIQuestions,
            aiAnswers: diagAIAnswers,
            aiLoading: diagAILoading,
            aiSubmitting: diagQSubmitting,
            aiErrors: diagQError,
            onAnswer: handleAnswerDiagQuestion,
            onReloadQuestions: reloadDiagQuestions,
            gate: diffGate,
            pollingActive: pollingActive,
            pollSeconds: pollSeconds,
            pollLabel: (0, $2d58c73a38525204$export$934efb048138efd3)(pollSeconds, t, formatNumber),
            pollOverridden: pollOverridden,
            onTogglePolling: togglePolling
        }),
        suggestions: copilotSuggestions,
        transcriptLines: transcriptLines,
        messages: aiMessages,
        chatLoading: aiChatLoading,
        recsLoading: recsLoading,
        recsError: recsError,
        recsRan: recsRan,
        onRunRecs: runRecommendations,
        visitCoins: visitCoins,
        /* The total alone cannot answer «چه چیزی این را خرج کرد؟» — the
               itemised ledger the desktop popover shows, folded into the one
               place the phone talks about money. */ coinEntries: coinEntries,
        quickQs: diffQuickQ,
        aiInput: aiInput,
        onAiInput: setAiInput,
        onAsk: handleAsk
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e0b3b7ef84bbae65$export$2e2bcd8739ae039), {
        open: mobileSheet === 'vitals',
        onClose: ()=>setMobileSheet(null),
        patient: p,
        vitals: vitals,
        onVitalChange: (k, v)=>setVitals((prev)=>({
                    ...prev,
                    [k]: (0, $375f8776645d5aee$export$8c63808338caf15c)(v)
                })),
        vitalsMode: vitalsMode,
        onVitalsSave: handleSaveVitals,
        vitalsLoading: vitalsLoading,
        vitalsError: vitalsError,
        vitalsAlert: vitalsAlert,
        onDismissVitalsAlert: ()=>setVitalsAlert(null),
        onEditVitals: ()=>setVitalsMode('form'),
        onVitalsHistory: ()=>setShowVitalsModal(true),
        vitalsComplete: visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
            variant: "mobile",
            testid: "visit-vitals-complete",
            ...completion.button('vitals')
        }) : null,
        vitalsProposal: findingsCard('VITALS'),
        recordComplete: visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
            variant: "mobile",
            testid: "visit-record-complete",
            ...completion.button('record')
        })), findingsCard('RECORD')) : null,
        meds: uniqMeds,
        onStopMed: removeMed,
        undoMed: undoMed,
        onUndoMed: restoreMed,
        diagnoses: activeDiagnoses,
        onRemoveDiagnosis: removeCondition,
        undoCondition: undoCond,
        onUndoCondition: restoreCondition,
        conditions: patientConditions,
        labResults: patient?.clinicalObservations || [],
        pastVisits: pastVisitSummaries,
        encounters: patient?.encounters || [],
        clinicalNotes: patient?.clinicalNotes || [],
        onUploadLab: ()=>clinicalFiles.openUpload(),
        files: visitFileList,
        currentVisitId: pmEncounterId || visitId || null,
        onOpenFile: clinicalFiles.openDetail,
        onViewFile: clinicalFiles.openViewer,
        onExtractFile: (f)=>clinicalFiles.openExtract(f),
        onEditFile: (f)=>clinicalFiles.openDetail(f, {
                edit: true
            }),
        onDownloadFile: clinicalFiles.download,
        onDeleteFile: clinicalFiles.requestDelete,
        onEditPatient: openEditPatient,
        onRepresribeMed: represcribeMed,
        prescribedNames: prescribedMedNames,
        onChangeDxType: changeCondType,
        dxTypeBusyId: dxTypeBusyId,
        visitContexts: visitContexts,
        onOpenVisit: loadVisitContext,
        onViewAllLabs: ()=>setLabsSheetOpen(true),
        /* The arrangement: which sections, in what order, open or closed —
               and the way to change it from where it is noticed. */ sections: recordSections,
        recordOpen: recordOpen,
        onToggleSection: toggleRecordSection,
        onEditLayout: ()=>navProp('profile', {
                tab: 'visit'
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8666d5605a00f2ea$export$2e2bcd8739ae039), {
        open: labsSheetOpen,
        onClose: ()=>setLabsSheetOpen(false),
        labResults: patient?.clinicalObservations || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f91b9c2a59f5e411$export$4a9e58f0ce1db37f), {
        open: showVitalsModal,
        onClose: ()=>setShowVitalsModal(false),
        observations: patient?.clinicalObservations || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f91b9c2a59f5e411$export$9a251dbf2f7b9965), {
        open: showEditPatient,
        onClose: ()=>setShowEditPatient(false),
        form: editPatientForm,
        onChange: (k, v)=>setEditPatientForm((f)=>({
                    ...f,
                    [k]: v
                })),
        saving: editPatientSaving,
        error: editPatientError,
        onSave: saveEditPatient
    }), clinicalFiles.overlays, patient?.id && true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a32a09d8f6c45ba$export$2e2bcd8739ae039), {
        patientId: patient.id,
        onChange: refreshPatient
    }), showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78bf9afd2f70d001$export$2e2bcd8739ae039), {
        onClose: goToReception,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        patient: patient,
        doctor: doctor,
        diagnosis: diagnosis,
        prescriptionTemplates: prescriptionTemplates,
        appointmentId: visitId,
        saveFailures: saveFailures
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84b0860f5c9bbf22$export$2e2bcd8739ae039), {
        open: printSheetOpen,
        onClose: ()=>setPrintSheetOpen(false),
        templates: prescriptionTemplates,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: soap.a || diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0225b93de05eb560$export$2e2bcd8739ae039), {
        open: overflowOpen,
        onClose: ()=>setOverflowOpen(false),
        canPrint: rxItems.length > 0,
        canCancel: visitStatus === 'inprogress',
        cancelling: cancellingVisit,
        onPrint: ()=>{
            setOverflowOpen(false);
            setPrintSheetOpen(true);
        },
        onUploadLab: ()=>{
            setOverflowOpen(false);
            clinicalFiles.openUpload();
        },
        onCancelVisit: ()=>{
            setOverflowOpen(false);
            setPendingCancelVisit(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4314c1a6ed955567$export$2e2bcd8739ae039), {
        error: recError,
        onRetry: startRec,
        onClose: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: pendingCancelVisit,
        onOpenChange: (o)=>{
            if (!o) setPendingCancelVisit(false);
        },
        title: t('visit.confirm.cancelTitle'),
        message: t('visit.confirm.cancelBody'),
        confirmLabel: t('visit.confirm.cancelConfirm'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: handleCancelEncounter
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!orderToCancel,
        onOpenChange: (o)=>{
            if (!o) setOrderToCancel(null);
        },
        title: orderToCancel?.description ? t('visit.orders.cancelNamed', {
            name: orderToCancel.description
        }) : t('visit.orders.cancelTitle'),
        message: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: ()=>{
            if (orderToCancel) handleOrderTransition(orderToCancel.id, 'cancel');
            setOrderToCancel(null);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: erxAvailable && erxSheetOpen,
        onClose: closeErxSheet,
        title: t('visit.erx.panel.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel"
    }, erxStatus?.enabled === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-erx-panel-not-offered",
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8
        }
    }, t('visit.erx.inVisit.notOffered')) : erxAvailable && erxSheetOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccba15c4d511e83$export$2e2bcd8739ae039), {
        flow: "panel",
        testIdPrefix: "visit-erx",
        appointmentId: pmEncounterId || visitId,
        patientId: patient.id,
        prepare: rxPersistence.writeNow,
        refreshKey: erxRefreshKey,
        onSubmitted: reloadErxStatus,
        onBusyChange: setErxBusy
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: erxLeaveOpen,
        onOpenChange: (o)=>{
            if (!o) setErxLeaveOpen(false);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-erx-leave-ok",
        cancelTestId: "visit-erx-leave-cancel",
        onConfirm: ()=>{
            setErxLeaveOpen(false);
            setErxBusy(false);
            setErxSheetOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: convertSheetOpen,
        onClose: ()=>{
            if (!call.converting) setConvertSheetOpen(false);
        },
        title: t('visit.call.convert'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-convert-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            marginBottom: '0.875rem'
        }
    }, t('visit.call.convertBody')), call.convertError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "visit-convert-error"
    }, t('visit.call.convertError'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: handleConvertVisit,
        disabled: call.converting,
        "data-testid": "visit-convert-confirm",
        className: "w-full min-h-11 mb-2"
    }, call.converting ? t('visit.call.converting') : t('visit.call.convertAndCall')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: ()=>setConvertSheetOpen(false),
        disabled: call.converting,
        className: "w-full min-h-11"
    }, t('common.actions.cancel')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!activeVisitConflict,
        onClose: ()=>setActiveVisitConflict(null),
        title: t('visit.resume.activeTitle'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-conflict-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            marginBottom: '0.875rem'
        }
    }, t('visit.resume.activeBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: handleResumeConflictVisit,
        "data-testid": "visit-conflict-resume",
        className: "w-full min-h-11 mb-2"
    }, t('visit.resume.continuePrevious')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: handleCloseConflictVisit,
        "data-testid": "visit-conflict-restart",
        className: "w-full min-h-11"
    }, t('visit.resume.closeAndStart')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: pendingEnd,
        onOpenChange: (o)=>{
            if (!o) setPendingEnd(false);
        },
        title: t('dashboard.hero.endVisit'),
        message: t('visit.confirm.endBody'),
        confirmLabel: t('visit.confirm.endConfirm'),
        cancelLabel: t('visit.confirm.endCancel'),
        destructive: true,
        onConfirm: handleEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: leaveConfirm,
        onOpenChange: (o)=>{
            if (!o) {
                setLeaveConfirm(false);
                pendingNavRef.current = null;
            }
        },
        title: t('visit.confirm.leaveTitleShort'),
        message: t('visit.confirm.leaveDraftBody'),
        confirmLabel: t('nav.sidebar.logout'),
        cancelLabel: t('visit.confirm.endCancel'),
        onConfirm: handleLeaveConfirm
    }), endingVisit && !showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            zIndex: 50,
            background: 'rgba(26,35,50,0.72)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem',
            width: '100%',
            maxWidth: '20rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.875rem',
            fontWeight: 700,
            color: 'white',
            textAlign: 'center'
        }
    }, t('visit.header.ending'))))));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");














parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $7phmx = parcelRequire("7phmx");
var $jOGbh = parcelRequire("jOGbh");
var $4Qco3 = parcelRequire("4Qco3");
var $3tGMU = parcelRequire("3tGMU");
var $Ydgp5 = parcelRequire("Ydgp5");
var $lffTJ = parcelRequire("lffTJ");
var $jbdF9 = parcelRequire("jbdF9");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");





var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");


/**
 * VisitCoinUsage — the ONE coin readout on the Visit page.
 *
 * The page used to price itself in place: a cost chip next to every AI button
 * («۱۰» beside «تکمیل متن ویزیت», «۵ / دقیقه» beside the recorder, …). That put
 * a price tag in the doctor's eye-line during the visit and still never
 * answered the only question worth asking — *what has this visit cost so far?*
 * All of those chips are gone; this badge in the page header replaces them.
 *
 * Closed, it is the running total. Opened — hover, focus, or click to pin — it
 * breaks that total down by the component that spent it, so «۳۸ پارسه» becomes
 * «رونویسی ۲۰ · برنامه درمانی ۱۰ · تداخل دارویی ۳ …». Hover is the discovery
 * path and click is the reading path: a hover popover that vanishes when the
 * pointer travels toward it cannot be read, so a click pins it open until the
 * next click outside (or Escape).
 *
 * Props:
 *   entries — [{ id, coins, count }] where `id` is a PRICE_LIST id, `coins` the
 *             running total for that component and `count` how many times it
 *             ran. Unknown ids are rendered with the id itself rather than
 *             dropped: a missing row would silently make the total not add up.
 *   total   — coins spent in this visit (the caller's sum, not re-derived here).
 */ /**
 * Framework tokens, not the Visit workspace's private `--…` set — the same
 * rule, for the same reason, as `VisitCall.jsx`.
 *
 * Both apps stamp `data-panel` on <html>, and tokens.css's
 * `:root[data-panel=…]` redefines `--accent` as a bare HSL triplet for the
 * Tailwind layer. That selector outranks the page's injected `:root`, so here
 * `var(--accent)` was an invalid colour: the browser dropped the declaration,
 * kept the literal `#fff` beside it, and opening the breakdown turned the badge
 * into white text on a white header — it vanished exactly when clicked.
 */ const $95619a68e42b6cf6$var$S = {
    accent: (0, $jTCZr.CT).accent,
    accentSoft: (0, $jTCZr.CT).accentSoft,
    accentInk: (0, $jTCZr.CT).accentInk,
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    ink: (0, $jTCZr.CT).ink,
    mute: (0, $jTCZr.CT).mute
};
function $95619a68e42b6cf6$export$2e2bcd8739ae039({ entries: entries = [], total: total = 0, testid: testid = 'visit-coin-usage' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [pinned, setPinned] = (0, $acw62.useState)(false);
    const wrapRef = (0, $acw62.useRef)(null);
    // Pinned means "the doctor asked to read this": it survives the pointer
    // leaving, and only an outside click or Escape takes it back.
    (0, $acw62.useEffect)(()=>{
        if (!pinned) return undefined;
        const onDocDown = (e)=>{
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setPinned(false);
                setOpen(false);
            }
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                setPinned(false);
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        pinned
    ]);
    // Biggest spender first — the breakdown is read to find where the coins went.
    const rows = (0, $acw62.useMemo)(()=>{
        const labelKeyById = Object.fromEntries((0, $2a90b979c3d41f86$export$52690e1136e04e64).map((p)=>[
                p.id,
                p.labelKey
            ]));
        return [
            ...entries
        ].filter((e)=>e && e.coins > 0).sort((a, b)=>b.coins - a.coins).map((e)=>({
                ...e,
                label: labelKeyById[e.id] ? t(labelKeyById[e.id]) : e.id
            }));
    }, [
        entries,
        t
    ]);
    const show = ()=>setOpen(true);
    const hide = ()=>{
        if (!pinned) setOpen(false);
    };
    const toggle = ()=>{
        setPinned((p)=>{
            const next = !p;
            setOpen(next);
            return next;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: wrapRef,
        style: {
            position: 'relative',
            display: 'inline-flex'
        },
        onMouseEnter: show,
        onMouseLeave: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": testid,
        // The visible total is locale-formatted (Persian digits by default);
        // this is the same number in a form a test — or a screenshot diff —
        // can assert on without re-implementing the formatter.
        "data-coins": total,
        onClick: toggle,
        onFocus: show,
        onBlur: hide,
        "aria-expanded": open,
        "aria-haspopup": "dialog",
        "aria-label": t('visit.coins.aria', {
            coins: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(total, formatNumber)
        }),
        title: t('visit.coins.hint'),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '5px 11px',
            borderRadius: 999,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.6,
            background: open ? $95619a68e42b6cf6$var$S.accent : $95619a68e42b6cf6$var$S.accentSoft,
            color: open ? '#fff' : $95619a68e42b6cf6$var$S.accentInk,
            border: `1px solid ${$95619a68e42b6cf6$var$S.accent}`,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
        size: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(total, formatNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            opacity: 0.85
        }
    }, t('common.units.coin'))), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-label": t('visit.coins.panelTitle'),
        "data-testid": `${testid}-panel`,
        style: {
            position: 'absolute',
            top: 'calc(100% + 7px)',
            insetInlineEnd: 0,
            zIndex: 80,
            width: 268,
            maxHeight: 320,
            overflowY: 'auto',
            background: $95619a68e42b6cf6$var$S.panel,
            border: `1px solid ${$95619a68e42b6cf6$var$S.line}`,
            borderRadius: 10,
            boxShadow: '0 10px 28px rgba(15,23,42,.16)',
            padding: '10px 12px 8px',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            fontWeight: 700,
            color: $95619a68e42b6cf6$var$S.ink,
            marginBottom: 2
        }
    }, t('visit.coins.panelTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: $95619a68e42b6cf6$var$S.mute,
            marginBottom: 8
        }
    }, t('visit.coins.hint')), rows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        style: {
            fontSize: 11.5,
            color: $95619a68e42b6cf6$var$S.mute,
            lineHeight: 1.9,
            padding: '4px 0 8px'
        }
    }, t('visit.coins.empty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.id,
            "data-testid": `${testid}-row-${row.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 0',
                borderBottom: `1px dashed ${$95619a68e42b6cf6$var$S.line}`,
                fontSize: 11.5,
                color: $95619a68e42b6cf6$var$S.ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, row.label), row.count > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                color: $95619a68e42b6cf6$var$S.mute,
                flexShrink: 0
            }
        }, t('visit.coins.times', {
            count: row.count
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 700,
                fontVariantNumeric: 'tabular-nums',
                flexShrink: 0,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 3,
                color: $95619a68e42b6cf6$var$S.accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
            size: 10
        }), (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(row.coins, formatNumber))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-total`,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            paddingTop: 8,
            marginTop: 2,
            fontSize: 12,
            fontWeight: 800,
            color: $95619a68e42b6cf6$var$S.ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.coins.total')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontVariantNumeric: 'tabular-nums',
            color: $95619a68e42b6cf6$var$S.accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
        size: 11
    }), (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(total, formatNumber), " ", t('common.units.coin')))));
}






var $jTCZr = parcelRequire("jTCZr");







// ─────────────────────────────────────────────────────────────────────────────
// «تجویز مجدد» — refill several drugs at once, picked off a list.
//
// The batch twin of the per-drug refill buttons: it sits on the «داروهای جاری»
// header and on every past visit in «سوابق ویزیت‌های قبلی», and opens the same
// review step «افزودن از قالب نسخه» has — every drug with a tick, «همه» /
// «هیچ‌کدام», and one commit button. Same interaction because it is the same
// task: take a known list of drugs and leave out what this visit should not get.
//
// Ticked by default, except a drug already on the نسخه (shown as «در نسخه»,
// never added twice) and a recorded-allergy match (unticked, and it says why).
//
// It decides nothing about what refilling MEANS — `onApply` receives the chosen
// medication records and the screen puts them on the نسخه the way its single
// refill does, so both doors keep producing identical rows.
//
// The trigger is a `span role="button"`, not a button: both places it lives are
// themselves whole-row buttons (the section header, the visit row). The popover
// is portalled to escape the record column's overflow, and it stops click
// propagation because React bubbles portal events up the COMPONENT tree — a tick
// would otherwise also toggle the section or open the visit behind it. Colours
// come from the token module for the reason TemplateApplyButton records.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

const $b69acda6ae3622c4$var$PAL = {
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
const $b69acda6ae3622c4$export$5474f41aa0731c97 = 330;
const $b69acda6ae3622c4$export$a2958ba5d3e441bd = 420;
const $b69acda6ae3622c4$var$POP_GAP = 8;
// Above the history sheet (1200) it is opened from, below nothing else it can
// share the screen with.
const $b69acda6ae3622c4$var$POP_Z = 1300;
// Clearance between trigger and popover, and the least usable list height.
const $b69acda6ae3622c4$var$POP_OFFSET = 6;
const $b69acda6ae3622c4$var$POP_MIN_HEIGHT = 120;
function $b69acda6ae3622c4$export$1534ebe230218d96(rect, vw, vh, isRTL) {
    let left = isRTL ? rect.left : rect.right - $b69acda6ae3622c4$export$5474f41aa0731c97;
    if (vw) left = Math.max($b69acda6ae3622c4$var$POP_GAP, Math.min(left, vw - $b69acda6ae3622c4$export$5474f41aa0731c97 - $b69acda6ae3622c4$var$POP_GAP));
    // No viewport to measure (jsdom, a detached render): keep the simple placement.
    if (!vh) return {
        top: rect.bottom + $b69acda6ae3622c4$var$POP_OFFSET,
        left: left,
        maxHeight: $b69acda6ae3622c4$export$a2958ba5d3e441bd
    };
    const below = vh - rect.bottom - $b69acda6ae3622c4$var$POP_OFFSET - $b69acda6ae3622c4$var$POP_GAP;
    const above = rect.top - $b69acda6ae3622c4$var$POP_OFFSET - $b69acda6ae3622c4$var$POP_GAP;
    // Flip only when it actually helps — a cramped viewport keeps the list below,
    // where the doctor's eye already is.
    const flip = below < Math.min($b69acda6ae3622c4$export$a2958ba5d3e441bd, 240) && above > below;
    const room = Math.max($b69acda6ae3622c4$var$POP_MIN_HEIGHT, Math.min($b69acda6ae3622c4$export$a2958ba5d3e441bd, flip ? above : below));
    const top = flip ? Math.max($b69acda6ae3622c4$var$POP_GAP, rect.top - $b69acda6ae3622c4$var$POP_OFFSET - room) : Math.min(rect.bottom + $b69acda6ae3622c4$var$POP_OFFSET, Math.max($b69acda6ae3622c4$var$POP_GAP, vh - room - $b69acda6ae3622c4$var$POP_GAP));
    return {
        top: top,
        left: left,
        maxHeight: room
    };
}
const $b69acda6ae3622c4$var$medName = (m)=>(m?.display || m?.code || '').trim();
const $b69acda6ae3622c4$var$medKey = (m)=>$b69acda6ae3622c4$var$medName(m).toLowerCase();
const $b69acda6ae3622c4$var$medDose = (m)=>{
    const di = m?.dosageInstruction;
    return typeof di === 'string' ? di : di?.text || '';
};
function $b69acda6ae3622c4$export$2e2bcd8739ae039({ meds: meds = [], state: state = 'ready', title: title, onOpen: onOpen, onApply: onApply, prescribedNames: prescribedNames, allergies: allergies = [], testid: testid = 'represcribe' }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)(new Set());
    const [applying, setApplying] = (0, $acw62.useState)(false);
    const [pos, setPos] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useRef)(null);
    const popRef = (0, $acw62.useRef)(null);
    const initialised = (0, $acw62.useRef)(false);
    const rows = (0, $acw62.useMemo)(()=>(meds || []).filter((m)=>$b69acda6ae3622c4$var$medName(m)).map((m, i)=>({
                i: i,
                med: m,
                already: Boolean(prescribedNames?.has($b69acda6ae3622c4$var$medKey(m))),
                allergy: (0, $737671bfbc703ec9$export$7ec7358ec49034c8)({
                    name: $b69acda6ae3622c4$var$medName(m)
                }, allergies)
            })), [
        meds,
        prescribedNames,
        allergies
    ]);
    const selectable = rows.filter((r)=>!r.already);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        initialised.current = false;
    }, []);
    // Tick the defaults once the list is there — immediately for current
    // medications, after the context arrives for a past visit.
    (0, $acw62.useEffect)(()=>{
        if (!open || state !== 'ready' || initialised.current) return;
        initialised.current = true;
        setSelected(new Set(rows.filter((r)=>!r.already && !r.allergy).map((r)=>r.i)));
    }, [
        open,
        state,
        rows
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const measure = ()=>{
            const r = rootRef.current?.getBoundingClientRect();
            if (!r) return;
            setPos($b69acda6ae3622c4$export$1534ebe230218d96(r, window.innerWidth || 0, window.innerHeight || 0, isRTL));
        };
        measure();
        window.addEventListener('resize', measure);
        document.addEventListener('scroll', measure, true);
        return ()=>{
            window.removeEventListener('resize', measure);
            document.removeEventListener('scroll', measure, true);
        };
    }, [
        open,
        isRTL
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onDocDown = (e)=>{
            if (!rootRef.current?.contains(e.target) && !popRef.current?.contains(e.target)) close();
        };
        // Stopped here so Esc closes the picker and NOT the history sheet under it,
        // which listens on window.
        const onEsc = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                close();
            }
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onEsc);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onEsc);
        };
    }, [
        open,
        close
    ]);
    const toggleOpen = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (open) {
            close();
            return;
        }
        setOpen(true);
        onOpen?.();
    };
    const toggle = (i)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(i)) next.delete(i);
            else next.add(i);
            return next;
        });
    const confirm = async ()=>{
        const chosen = rows.filter((r)=>selected.has(r.i) && !r.already).map((r)=>r.med);
        if (!chosen.length) return;
        setApplying(true);
        try {
            await onApply?.(chosen);
            close();
        } finally{
            setApplying(false);
        }
    };
    const count = rows.filter((r)=>selected.has(r.i) && !r.already).length;
    const smallLink = {
        background: 'none',
        border: 0,
        padding: 0,
        fontFamily: 'inherit',
        fontSize: 11,
        fontWeight: 700,
        color: $b69acda6ae3622c4$var$PAL.accentInk,
        cursor: 'pointer'
    };
    const renderBody = ()=>{
        if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 4px',
                fontSize: 12,
                color: $b69acda6ae3622c4$var$PAL.mute
            }
        }, t('common.state.loadingEllipsis'));
        if (state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            style: {
                padding: '10px 4px',
                fontSize: 12,
                color: $b69acda6ae3622c4$var$PAL.dangerInk
            }
        }, t('visit.history.loadFailed'));
        if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 4px',
                fontSize: 12,
                color: $b69acda6ae3622c4$var$PAL.mute
            }
        }, t('visit.history.noMedications'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 11,
                color: $b69acda6ae3622c4$var$PAL.mute,
                padding: '4px 4px 6px',
                borderBottom: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set(selectable.map((r)=>r.i))),
            "data-testid": `${testid}-select-all`
        }, t('visit.templates.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set()),
            "data-testid": `${testid}-select-none`
        }, t('visit.templates.selectNone')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.templates.selectedOf', {
            selected: formatNumber(count),
            total: formatNumber(selectable.length)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            "data-testid": `${testid}-items`,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                paddingTop: 4,
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto'
            }
        }, rows.map(({ i: i, med: med, already: already, allergy: allergy })=>{
            const checked = already || selected.has(i);
            const dose = $b69acda6ae3622c4$var$medDose(med);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
                key: med.id || i,
                "data-testid": "represcribe-item",
                "data-checked": checked ? 'true' : 'false',
                "data-prescribed": already || undefined,
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8,
                    padding: '6px 6px',
                    borderRadius: 7,
                    cursor: already ? 'default' : 'pointer',
                    opacity: already ? 0.6 : 1,
                    background: allergy && !checked ? $b69acda6ae3622c4$var$PAL.dangerSoft : 'transparent'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "checkbox",
                checked: checked,
                disabled: already,
                onChange: ()=>toggle(i),
                style: {
                    marginTop: 3,
                    accentColor: $b69acda6ae3622c4$var$PAL.accent,
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6,
                    flexWrap: 'wrap'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: checked ? $b69acda6ae3622c4$var$PAL.ink : $b69acda6ae3622c4$var$PAL.mute,
                    overflowWrap: 'anywhere'
                }
            }, $b69acda6ae3622c4$var$medName(med)), already && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: $b69acda6ae3622c4$var$PAL.accentInk
                }
            }, t('visit.rx.represcribed'))), dose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    color: $b69acda6ae3622c4$var$PAL.mute,
                    marginTop: 1
                }
            }, dose), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: $b69acda6ae3622c4$var$PAL.dangerInk,
                    marginTop: 2
                }
            }, t('visit.templates.allergyHit', {
                substance: allergy
            }))));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `${testid}-footer`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                paddingTop: 8,
                marginTop: 4,
                borderTop: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: close,
            style: {
                ...smallLink,
                color: $b69acda6ae3622c4$var$PAL.ink2,
                fontSize: 11.5,
                padding: '6px 8px'
            }
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: confirm,
            disabled: applying || count === 0,
            "data-testid": `${testid}-apply`,
            style: {
                padding: '6px 12px',
                borderRadius: 7,
                border: 0,
                fontFamily: 'inherit',
                background: $b69acda6ae3622c4$var$PAL.accent,
                color: '#fff',
                fontSize: 11.5,
                fontWeight: 700,
                cursor: applying || count === 0 ? 'not-allowed' : 'pointer',
                opacity: applying || count === 0 ? 0.55 : 1
            }
        }, applying ? t('visit.templates.applying') : t('visit.templates.applySelected', {
            count: count
        }))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: rootRef,
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "button",
        tabIndex: 0,
        onClick: toggleOpen,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') toggleOpen(e);
        },
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        title: title,
        "data-testid": `${testid}-open`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            whiteSpace: 'nowrap',
            padding: '3px 8px',
            borderRadius: 6,
            border: `1px solid ${$b69acda6ae3622c4$var$PAL.line}`,
            background: $b69acda6ae3622c4$var$PAL.panel,
            color: $b69acda6ae3622c4$var$PAL.accentInk,
            fontSize: 10.5,
            fontWeight: 700,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "11",
        height: "11",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.5 8a5.5 5.5 0 1 1-1.6-3.9M13.5 2.5v2.8h-2.8"
    })), t('visit.rx.represcribe')), open && pos && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popRef,
        role: "listbox",
        "aria-label": title,
        dir: isRTL ? 'rtl' : 'ltr',
        "data-testid": `${testid}-list`,
        onClick: (e)=>e.stopPropagation(),
        onMouseDown: (e)=>e.stopPropagation(),
        style: {
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            width: $b69acda6ae3622c4$export$5474f41aa0731c97,
            maxHeight: pos.maxHeight,
            zIndex: $b69acda6ae3622c4$var$POP_Z,
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            background: $b69acda6ae3622c4$var$PAL.panel,
            border: `1px solid ${$b69acda6ae3622c4$var$PAL.line}`,
            borderRadius: 10,
            boxShadow: $b69acda6ae3622c4$var$PAL.shadowPop,
            padding: 8,
            fontFamily: 'inherit',
            textAlign: 'start',
            cursor: 'default'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            fontWeight: 700,
            color: $b69acda6ae3622c4$var$PAL.ink,
            padding: '2px 4px',
            flexShrink: 0
        }
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: $b69acda6ae3622c4$var$PAL.mute,
            lineHeight: 1.7,
            flexShrink: 0,
            padding: '2px 4px 6px',
            borderBottom: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
            marginBottom: 4
        }
    }, t('visit.rx.represcribeHint')), renderBody()), document.body));
}





var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");









var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
var $8g4t5 = parcelRequire("8g4t5");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// ─────────────────────────────────────────────────────────────────────────────
// «افزودن دستور» on a past visit — the دستورات tab's catalogue search, in the
// past-visit sheet (RxCorrectionSheet; K1, 2026-10-10).
//
// The same question as the visit room's picker (searchOrderCatalog): a type
// first — آزمایشگاه، تصویربرداری، اقدام درمانی — then nothing until two letters,
// one server page per pause in typing, scoped to the clinic of the visit by its
// appointment. A result says whether تأمین lists the service, and one already on
// the visit says so instead of offering a second row. Pressing a result adds it
// (`onAdd(entry)`): there is no form — an order added to a past visit is routine,
// one session, as the doctor would have written it then.
// ─────────────────────────────────────────────────────────────────────────────
const $064eb81477d0449c$var$ORDER_KINDS = [
    'lab',
    'imaging',
    'procedure'
];
const $064eb81477d0449c$var$DEBOUNCE_MS = 250;
function $064eb81477d0449c$export$2e2bcd8739ae039({ appointmentId: appointmentId, insurer: insurer, orders: orders, onAdd: onAdd, adding: adding = null, disabled: disabled = false, testIdPrefix: testIdPrefix = 'visit-order', inputId: inputId }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const [kind, setKind] = (0, $acw62.useState)('lab');
    const [query, setQuery] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)({
        state: 'idle',
        entries: [],
        total: 0
    });
    const [moreLoading, setMoreLoading] = (0, $acw62.useState)(false);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    const inputRef = (0, $acw62.useRef)(null);
    const live = (0, $acw62.useRef)(0);
    // ── the search: nothing until two letters, then a debounced server page ──
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        const mine = ++live.current;
        if (q.length < (0, $375f8776645d5aee$export$6770277ab0ca292e)) {
            setSearch({
                state: q ? 'short' : 'idle',
                entries: [],
                total: 0
            });
            return undefined;
        }
        setSearch((s)=>({
                ...s,
                state: 'loading'
            }));
        const h = setTimeout(()=>{
            (0, $375f8776645d5aee$export$14e053085c2b7017)({
                query: q,
                orderType: kind,
                appointmentId: appointmentId
            }).then(({ entries: entries, total: total })=>{
                if (mine === live.current) setSearch({
                    state: 'ready',
                    entries: entries || [],
                    total: total || 0
                });
            }).catch((err)=>{
                if (mine !== live.current) return;
                // Said, not swallowed: an empty list would read as «not in the catalogue».
                console.error('[orders] catalogue search failed:', err);
                setSearch({
                    state: 'error',
                    entries: [],
                    total: 0
                });
            });
        }, $064eb81477d0449c$var$DEBOUNCE_MS);
        return ()=>clearTimeout(h);
    }, [
        query,
        kind,
        appointmentId,
        attempt
    ]);
    const loadMore = (0, $acw62.useCallback)(()=>{
        const mine = live.current;
        setMoreLoading(true);
        (0, $375f8776645d5aee$export$14e053085c2b7017)({
            query: query.trim(),
            orderType: kind,
            appointmentId: appointmentId,
            offset: search.entries.length
        }).then(({ entries: entries, total: total })=>{
            if (mine !== live.current) return;
            setSearch((s)=>({
                    ...s,
                    entries: [
                        ...s.entries,
                        ...entries || []
                    ],
                    total: total || s.total
                }));
        }).catch((err)=>console.error('[orders] catalogue search (more) failed:', err)).finally(()=>setMoreLoading(false));
    }, [
        query,
        kind,
        appointmentId,
        search.entries.length
    ]);
    // Another type is another search: the last type's rows never stand under it.
    const chooseKind = (k)=>{
        if (k === kind) return;
        setSearch((s)=>({
                ...s,
                entries: [],
                total: 0
            }));
        setKind(k);
    };
    const p = testIdPrefix;
    const types = (0, $375f8776645d5aee$export$e867161a6e6ed178)(t);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-types`,
        style: {
            display: 'flex',
            gap: 4,
            flexWrap: 'wrap'
        }
    }, $064eb81477d0449c$var$ORDER_KINDS.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: k,
            type: "button",
            size: "sm",
            variant: kind === k ? 'default' : 'outline',
            "aria-pressed": kind === k,
            onClick: ()=>chooseKind(k),
            "data-testid": `${p}-type-${k}`
        }, types[k]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${query ? (0, $jTCZr.C).navy : (0, $jTCZr.CT).border}`,
            borderRadius: 10,
            padding: '0 10px',
            minHeight: 36
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 14,
        color: (0, $jTCZr.CT).ink2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        id: inputId,
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Escape' && query) {
                setQuery('');
                e.stopPropagation();
            }
        },
        placeholder: t('visit.orders.searchCatalog'),
        "aria-label": t('visit.orders.searchCatalog'),
        autoComplete: "off",
        "data-testid": `${p}-search`,
        style: {
            flex: 1,
            minWidth: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: 13,
            color: (0, $jTCZr.CT).ink,
            minHeight: 34
        }
    }), search.state === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), query && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>{
            setQuery('');
            inputRef.current?.focus?.();
        },
        "aria-label": t('common.actions.clearSearch'),
        "data-testid": `${p}-search-clear`,
        className: "h-7 w-7 shrink-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }))), search.state === 'idle' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-idle`,
        "data-state": "idle",
        style: {
            fontSize: 11.5,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody')) : search.state === 'short' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-short`,
        style: {
            fontSize: 11.5,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.keepTyping')) : search.state === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-error`,
        "data-state": "error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        color: (0, $jTCZr.CT).dangerInk,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.orders.catalogSearchFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "subtle",
        size: "sm",
        onClick: ()=>setAttempt((n)=>n + 1),
        "data-testid": `${p}-search-retry`,
        className: "shrink-0"
    }, t('common.actions.retry'))) : search.state === 'ready' && search.entries.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-no-results`,
        "data-state": "no-results",
        style: {
            padding: 12,
            textAlign: 'center',
            fontSize: 12,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.noCatalogMatch')) : search.entries.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-results`,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, search.entries.map((e)=>{
        const names = (0, $375f8776645d5aee$export$adea16e688375bbf)(e, readsPersianData, e.nameAr);
        const already = (0, $027388f7462935a9$export$ce329d894bbd1d2b)(orders, e.orderType, e.name);
        const sub = e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: e.id || `${e.orderType}:${e.name}`,
            type: "button",
            variant: "outline",
            onClick: ()=>onAdd(e),
            disabled: already || disabled,
            "data-testid": `${p}-result-${e.id}`,
            "data-added": already || undefined,
            className: "w-full h-auto justify-start text-start gap-2 px-3 py-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 13,
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.primary), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 11.5,
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, sub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
            drug: {
                id: e.id
            },
            listed: (0, $375f8776645d5aee$export$ff0b3160d2d98f35)(e, insurer),
            both: true,
            size: 10.5,
            testid: `${p}-result-coverage-${e.id}`,
            hint: t('visit.orders.outTaminHint')
        }), already ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10.5,
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.added')) : adding != null && adding === e.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 11.5,
                fontWeight: 600,
                color: (0, $jTCZr.CT).accentInk,
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('common.actions.add')));
    }), search.total > search.entries.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-more-results`,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, moreLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "link",
        size: "sm",
        onClick: loadMore
    }, t('visit.rx.moreResults', {
        shown: search.entries.length,
        total: search.total
    })))) : null);
}





// ─────────────────────────────────────────────────────────────────────────────
// «اصلاح نسخهٔ ویزیت {date}» — a past visit's نسخه, corrected after the visit
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md).
//
// op-naji allows a registered prescription to be corrected for one month after
// the visit. This sheet opens on ONE past visit: its نسخه lines, read by that
// appointment; edited, removed and added exactly as on the visit's own نسخه —
// the same RxItemCard and closed lists, the same persistence (useVisitRxPersistence,
// pointed at that appointment); and the same e-prescription card, which sends a
// prescription never sent or corrects a registered one.
//
// Its دستورات too (K1, 2026-10-10): an order the insurer cannot take — a free-text
// «LFT» — is cancelled and replaced from the catalogue (AST, ALT, ALP), with the
// visit room's own operations: listOrders, cancelOrder, createOrder.
//
// It touches that visit's medication rows and orders and nothing else: the visit
// is not started, ended, reopened or edited. Opening the sheet costs two reads,
// its نسخه and its دستورات.
//
// An inline-start sheet like «سوابق ویزیت‌های قبلی», but layered BELOW the kit's
// dialogs (1100) rather than above them as that one is (1200): the card asks for
// a confirmation from inside it, and a dialog drawn behind its sheet freezes the
// page (DESIGN.md «Overlay layering»).
// ─────────────────────────────────────────────────────────────────────────────
const $49c99466dee6cafa$var$SHEET_Z = 1050;
// On a phone the sheet is mounted from the patient record, which never loads the
// visit page's stylesheet — so RxItemCard's fields drew with no border at 12 px
// and its ✎/✕ shrank to the bare 14 px glyph (`.iconbtn` lives in MOBILE_CSS;
// seen in the 2026-10-12 tour, PM-0119). The sheet brings that stylesheet with
// it and, inside itself only, lifts every control to the phone floor: 44 px
// targets, 16 px text in fields (anything smaller makes iOS zoom on focus).
const $49c99466dee6cafa$var$PHONE_SCOPE = '[data-testid="visit-rx-correction-sheet"]';
const $49c99466dee6cafa$var$PHONE_CSS = `
${$49c99466dee6cafa$var$PHONE_SCOPE} .iconbtn{width:44px;height:44px;border-radius:10px}
${$49c99466dee6cafa$var$PHONE_SCOPE} .iconbtn svg{width:18px;height:18px}
${$49c99466dee6cafa$var$PHONE_SCOPE} [data-testid$="-search"]{min-height:44px !important}
${$49c99466dee6cafa$var$PHONE_SCOPE} select,${$49c99466dee6cafa$var$PHONE_SCOPE} input:not([type=checkbox]):not([type=radio]),${$49c99466dee6cafa$var$PHONE_SCOPE} textarea{font-size:16px !important;min-height:44px !important}
${$49c99466dee6cafa$var$PHONE_SCOPE} [role=radiogroup] button,${$49c99466dee6cafa$var$PHONE_SCOPE} [role=tablist] button,${$49c99466dee6cafa$var$PHONE_SCOPE} [aria-pressed]{min-height:44px !important}
`;
// Edits settle before the card and the chips read again, as on the visit's نسخه.
const $49c99466dee6cafa$var$SETTLE_MS = 900;
function $49c99466dee6cafa$var$useSettled(value, ms) {
    const [settled, setSettled] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const h = setTimeout(()=>setSettled(value), ms);
        return ()=>clearTimeout(h);
    }, [
        value,
        ms
    ]);
    return settled;
}
function $49c99466dee6cafa$export$2e2bcd8739ae039({ visit: visit, patientId: patientId, insurer: insurer, onClose: onClose, mode: mode = 'correct' }) {
    const { t: t, formatDate: formatDate, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const durations = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$74f6a832d246e098)(t), [
        t
    ]);
    const orderTypes = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$e867161a6e6ed178)(t), [
        t
    ]);
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    const { scheduleSave: scheduleSave, deleteRow: deleteRow, writeNow: writeNow, flush: flush, hydration: hydration, rehydrate: rehydrate } = (0, $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3)({
        appointmentId: visit.id,
        patientId: patientId,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // ── the chips: where each line stands with the insurer ──
    const { status: status, reload: reloadStatus } = (0, $5d2858db85b3973f$export$2eef96f829c6b514)({
        appointmentId: visit.id,
        patientId: patientId,
        prepare: flush
    });
    const erxIndex = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$7aaa1df6f77403de)(status), [
        status
    ]);
    const removedLines = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$4ddbdca59aee3c1a)(erxIndex, 'DRUGS', rxItems.map((r)=>r.medicationId)), [
        erxIndex,
        rxItems
    ]);
    // ── this visit's دستورات, read as the visit room's دستورات tab reads them ──
    // A cancelled order is no longer on the visit: it is not listed, and what the
    // insurer still holds of it shows under the list (ErxRemovedLines).
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [ordersState, setOrdersState] = (0, $acw62.useState)('loading'); // 'loading' | 'ready' | 'error'
    const ordersRead = (0, $acw62.useRef)(0);
    const loadOrders = (0, $acw62.useCallback)(async ()=>{
        const mine = ++ordersRead.current; // only the newest read lands
        try {
            const d = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$1d5821a442552a84), {
                appointmentId: visit.id
            });
            if (mine !== ordersRead.current) return;
            setOrders(d?.listOrders || []);
            setOrdersState('ready');
        } catch (e) {
            if (mine !== ordersRead.current) return;
            console.warn('[rx-correction] could not read the visit\'s orders:', e?.message);
            setOrdersState('error');
        }
    }, [
        visit.id
    ]);
    (0, $acw62.useEffect)(()=>{
        loadOrders();
    }, [
        loadOrders
    ]);
    const retryOrders = (0, $acw62.useCallback)(()=>{
        setOrdersState('loading');
        loadOrders();
    }, [
        loadOrders
    ]);
    const liveOrders = (0, $acw62.useMemo)(()=>orders.filter((o)=>o && o.status !== 'cancelled'), [
        orders
    ]);
    const removedOrders = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$4ddbdca59aee3c1a)(erxIndex, 'SERVICES', liveOrders.map((o)=>o.id)), [
        erxIndex,
        liveOrders
    ]);
    const orderName = (0, $375f8776645d5aee$export$891bfbeed44ddfce)(liveOrders.map((o)=>o.description));
    // The card re-reads once an edit has settled — a نسخه line's, or an order added
    // or cancelled; the chips too, and also once a line has been written (its
    // record id is what they are matched by).
    const cardContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            orders.map((o)=>[
                    o.id,
                    o.status
                ])
        ]), [
        rxItems,
        orders
    ]);
    const cardKey = $49c99466dee6cafa$var$useSettled(cardContent, $49c99466dee6cafa$var$SETTLE_MS);
    const statusContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            cardContent,
            rxItems.map((r)=>r.medicationId || null)
        ]), [
        cardContent,
        rxItems
    ]);
    const statusKey = $49c99466dee6cafa$var$useSettled(statusContent, $49c99466dee6cafa$var$SETTLE_MS);
    const firstStatusKey = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (firstStatusKey.current) {
            firstStatusKey.current = false;
            return;
        }
        reloadStatus();
    }, [
        statusKey,
        reloadStatus
    ]);
    // ── editing, as on the visit's نسخه ──
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $ace44487380106d3$export$b0f426f8468d8007)(r, key, val, {
                        durations: durations
                    }),
                    aiNote: undefined,
                    removeFailed: undefined
                } : r));
        scheduleSave(id);
    }, [
        scheduleSave,
        durations
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete first: the hook finds the row it deletes in the list it last saw.
        deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
    }, [
        deleteRow
    ]);
    // ── adding from the formulary: search, pick the drug, complete its form ──
    // The same search and the same add form as the visit's own نسخه (RxDrugSearch):
    // a line is added only with every required field filled (PM-0059).
    const seq = (0, $acw62.useRef)(0);
    const prescribed = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    const defaultsFor = (0, $acw62.useCallback)((drug)=>(0, $ace44487380106d3$export$87bc9af39161d883)(drug, null, {
            defaultDuration: t('visit.duration.d7')
        }), [
        t
    ]);
    const addDrug = (0, $acw62.useCallback)((drug, sig)=>{
        if (!drug?.id) return;
        seq.current += 1;
        const n = seq.current;
        setRxItems((prev)=>prev.some((r)=>r.drug?.id === drug.id) ? prev : [
                ...prev,
                (0, $ace44487380106d3$export$5352dbb17a06665d)(drug, sig, n, {
                    durations: durations
                })
            ]);
    }, [
        durations
    ]);
    // The card's own words for a line as it is now, beside what the insurer holds.
    const describeLine = (0, $acw62.useCallback)((line)=>{
        const row = line?.medicationId ? rxItems.find((r)=>r.medicationId && String(r.medicationId) === String(line.medicationId)) : null;
        return row ? (0, $375f8776645d5aee$export$41198ed546152d40)(row, t, readsPersianData) : null;
    }, [
        rxItems,
        t,
        readsPersianData
    ]);
    // ── cancelling and adding an order, as on the دستورات tab ──
    // One write at a time (a second press joins the first), then the list is read
    // again. Closing, and each read and send of the card, wait for a write still in
    // flight: the server builds the prescription from the record, and an order
    // pressed a moment before «ارسال» must be in it.
    const [cancelling, setCancelling] = (0, $acw62.useState)(null); // the order being cancelled
    const [adding, setAdding] = (0, $acw62.useState)(null); // the catalogue row being added
    const [orderError, setOrderError] = (0, $acw62.useState)(null);
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null);
    const orderBusy = !!(cancelling || adding);
    const orderWrite = (0, $acw62.useRef)(null);
    const writeOrder = (0, $acw62.useCallback)((run)=>{
        if (orderWrite.current) return orderWrite.current;
        const p = run().finally(()=>{
            orderWrite.current = null;
        });
        orderWrite.current = p;
        return p;
    }, []);
    const cancelOrder = (0, $acw62.useCallback)((order)=>writeOrder(async ()=>{
            setCancelling(order.id);
            setOrderError(null);
            try {
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$494a03338ebc3893), {
                    orderId: order.id
                });
                await loadOrders();
            } catch (e) {
                console.error('[rx-correction] cancelOrder failed:', e);
                setOrderError(e?.message || t('errors.save.orderStatus'));
            } finally{
                setCancelling(null);
            }
        }), [
        writeOrder,
        loadOrders,
        t
    ]);
    // The visit room's «افزودن» (handleCreateOrder): the catalogue row travels with
    // the order — its code and catalogId are what the insurer's service is found by.
    const addOrder = (0, $acw62.useCallback)((entry)=>writeOrder(async ()=>{
            setAdding(entry.id);
            setOrderError(null);
            try {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$81ebae6b21d102e1), {
                    appointmentId: visit.id,
                    patientId: patientId,
                    orderType: entry.orderType,
                    description: entry.name,
                    urgency: 'routine',
                    notes: '',
                    code: entry.code || null,
                    catalogId: entry.id || null,
                    sessionCount: null
                });
                // An answer with no order back is a write that did not land.
                if (!d?.createOrder) setOrderError(t('visit.orders.saveRetry'));
                await loadOrders();
            } catch (e) {
                console.error('[rx-correction] createOrder failed:', e);
                setOrderError(e?.message || t('errors.save.order'));
            } finally{
                setAdding(null);
            }
        }), [
        writeOrder,
        loadOrders,
        visit.id,
        patientId,
        t
    ]);
    // Every write asked for, landed: an order in flight, then the نسخه's lines.
    const writeAll = (0, $acw62.useCallback)(async ()=>{
        await orderWrite.current;
        return writeNow();
    }, [
        writeNow
    ]);
    // ── leaving ──
    // Every change is written before the sheet goes — an edit still on its delay,
    // a drug just added, an order being added or cancelled — so nothing done here
    // is lost by closing. A send or a login in flight on the card is unsaved work:
    // it asks first, as the closure dialog does.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const [closing, setClosing] = (0, $acw62.useState)(false);
    const closingRef = (0, $acw62.useRef)(false); // a second click before the re-render
    const close = (0, $acw62.useCallback)(async ()=>{
        if (closingRef.current) return;
        closingRef.current = true;
        setClosing(true);
        try {
            await writeAll();
        } catch (e) {
            console.warn('[rx-correction] could not write before closing:', e?.message);
        }
        onClose?.();
    }, [
        writeAll,
        onClose
    ]);
    const requestClose = (0, $acw62.useCallback)(()=>{
        if (erxBusy) {
            setLeaveConfirm(true);
            return;
        }
        close();
    }, [
        erxBusy,
        close
    ]);
    const panelRef = (0, $acw62.useRef)(null);
    // On a phone the sheet is the kit BottomSheet (PM-0119): full height, a 44 px
    // close, the keyboard inset, and — what the side panel never had — an entry in
    // history, so the platform back closes the SHEET instead of leaving the
    // patient record under it. The panel below stays the workstation's.
    const { isMobile: isMobile } = (0, $k27hS.default)();
    (0, $acw62.useEffect)(()=>{
        if (!isMobile) panelRef.current?.focus?.();
    }, [
        isMobile
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMobile) return undefined; // the BottomSheet owns Escape there
        const onKey = (e)=>{
            if (e.key !== 'Escape' || e.defaultPrevented) return;
            // A dialog opened from inside the sheet closes itself, not the sheet.
            const inDialog = e.target instanceof Element ? e.target.closest('[role="dialog"],[role="alertdialog"]') : null;
            if (inDialog && inDialog !== panelRef.current) return;
            requestClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        requestClose,
        isMobile
    ]);
    const dateLabel = visit.scheduledDate ? formatDate(visit.scheduledDate, 'medium') : '';
    const sending = mode === 'send';
    // Until when a correction may go — the server's word (ePrescriptionStatus.until),
    // null while it offers none: op-naji documents no correction since its 2026-10
    // revision, and a window that cannot be used is not one to state.
    const lastDay = sending || !status?.until ? null : new Date(status.until);
    const title = sending ? t('visit.rxCorrection.sendTitle', {
        date: dateLabel
    }) : t('visit.rxCorrection.title', {
        date: dateLabel
    });
    const loading = hydration === 'loading' || hydration === 'idle';
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, closing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: (0, $jTCZr.CT).mute
        }
    }, t('common.state.saving')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.lines'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 12,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).pill, {
        width: 12,
        height: 12
    }), t('visit.rxCorrection.lines'), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            background: (0, $jTCZr.CT).border,
            color: (0, $jTCZr.CT).ink2,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 600
        }
    }, rxItems.length)), hydration === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-error",
        "data-state": "error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.history.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        onClick: rehydrate,
        "data-testid": "visit-rx-correction-retry"
    }, t('common.actions.retry'))) : loading && rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-loading",
        "data-state": "loading",
        style: {
            display: 'grid',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    })) : rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-empty",
        "data-state": "empty",
        style: {
            fontSize: 12,
            color: (0, $jTCZr.CT).mute,
            fontStyle: 'italic'
        }
    }, t('visit.history.noMedications')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, rxItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$564a716e7cf1f53f), {
            key: item.id,
            item: item,
            onChange: (key, val)=>updateDrug(item.id, key, val),
            onRemove: ()=>removeDrug(item.id),
            insurer: insurer,
            erxLine: (0, $2c5a3cdef49d8209$export$98676285bdb35e36)(item, erxIndex)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$3e7bfa10fb8d8624), {
        lines: removedLines,
        testid: "visit-rx-correction-removed"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rx.addMedication'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: "visit-rx-correction-search",
        style: {
            fontSize: 11,
            fontWeight: 600,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rx.addMedication')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadae58d6c7ed04a$export$2e2bcd8739ae039), {
        touch: isMobile,
        testIdPrefix: "visit-rx-correction",
        inputId: "visit-rx-correction-search",
        defaultsFor: defaultsFor,
        prescribedIds: prescribed,
        insurer: insurer,
        onAdd: addDrug
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.orders'),
        "data-testid": "visit-rx-correction-orders",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 12,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).flask, {
        width: 12,
        height: 12
    }), t('visit.rxCorrection.orders'), liveOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            background: (0, $jTCZr.CT).border,
            color: (0, $jTCZr.CT).ink2,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 600
        }
    }, liveOrders.length)), orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-order-error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, orderError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOrderError(null),
        "aria-label": t('errors.dismiss'),
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: (0, $jTCZr.CT).dangerInk,
            display: 'grid',
            placeItems: 'center',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 13,
        height: 13
    }))), ordersState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-error",
        "data-state": "error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.orders.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        onClick: retryOrders,
        "data-testid": "visit-rx-correction-orders-retry"
    }, t('common.actions.retry'))) : ordersState === 'loading' && liveOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-loading",
        "data-state": "loading",
        style: {
            display: 'grid',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    })) : liveOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-empty",
        "data-state": "empty",
        style: {
            fontSize: 12,
            color: (0, $jTCZr.CT).mute,
            fontStyle: 'italic'
        }
    }, t('visit.history.noOrders')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, liveOrders.map((order)=>{
        const TypeIcon = (0, $375f8776645d5aee$export$9bb611d729802a56)[(0, $375f8776645d5aee$export$ba9a3a2cefb281d)[order.orderType]] || (0, $375f8776645d5aee$export$9bb611d729802a56).doc;
        // Only a pending order can be withdrawn; any other says where it stands.
        const st = order.status === 'pending' ? null : (0, $fa15d8b4a746e70c$export$5f296182ef21a05b)[order.status];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-rx-correction-order-${order.id}`,
            "data-status": order.status,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 10px',
                borderRadius: 10,
                background: (0, $jTCZr.CT).surface,
                border: `1px solid ${(0, $jTCZr.CT).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                width: 30,
                height: 30,
                borderRadius: 8,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            width: 15,
            height: 15
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 13,
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                lineHeight: 1.5,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, orderName(order.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 6,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                color: (0, $jTCZr.CT).ink,
                background: (0, $jTCZr.CT).surface2
            }
        }, orderTypes[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: 12,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                color: (0, $jTCZr.CT).ink2,
                background: (0, $jTCZr.CT).surface2
            }
        }, order.code), st && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                fontWeight: 700,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                color: st.text,
                background: st.bg
            }
        }, t(st.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$a8584f59cd36e423), {
            line: (0, $2c5a3cdef49d8209$export$be2f84bce07e3ba5)(order, erxIndex),
            testid: `visit-rx-correction-order-erx-state-${order.id}`
        }))), order.status === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>setOrderToCancel(order),
            disabled: orderBusy,
            "data-testid": `visit-rx-correction-order-cancel-${order.id}`,
            style: {
                color: (0, $jTCZr.CT).dangerInk
            }
        }, cancelling === order.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : t('common.actions.discard')));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$3e7bfa10fb8d8624), {
        lines: removedOrders,
        part: "SERVICES",
        testid: "visit-rx-correction-orders-removed"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.addOrder'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: "visit-rx-correction-order-search",
        style: {
            fontSize: 11,
            fontWeight: 600,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rxCorrection.addOrder')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $064eb81477d0449c$export$2e2bcd8739ae039), {
        testIdPrefix: "visit-rx-correction-order",
        inputId: "visit-rx-correction-order-search",
        appointmentId: visit.id,
        insurer: insurer,
        orders: liveOrders,
        adding: adding,
        disabled: orderBusy,
        onAdd: addOrder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccba15c4d511e83$export$2e2bcd8739ae039), {
        testIdPrefix: "visit-rx-correction-erx",
        scope: "ALL",
        appointmentId: visit.id,
        patientId: patientId,
        prepare: writeAll,
        refreshKey: cardKey,
        onSubmitted: reloadStatus,
        describeLine: describeLine,
        onBusyChange: setErxBusy
    }));
    const dialogs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(false);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-rx-correction-leave-ok",
        cancelTestId: "visit-rx-correction-leave-cancel",
        "data-testid": "visit-rx-correction-leave-confirm",
        onConfirm: ()=>{
            setLeaveConfirm(false);
            close();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!orderToCancel,
        onOpenChange: (open)=>{
            if (!open) setOrderToCancel(null);
        },
        title: orderToCancel ? t('visit.orders.cancelNamed', {
            name: orderName(orderToCancel.description)
        }) : t('visit.orders.cancelTitle'),
        description: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        confirmTestId: "visit-rx-correction-order-cancel-ok",
        cancelTestId: "visit-rx-correction-order-cancel-back",
        "data-testid": "visit-rx-correction-order-cancel-confirm",
        onConfirm: ()=>{
            if (orderToCancel) cancelOrder(orderToCancel);
        }
    }));
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $375f8776645d5aee$export$220f2e5d84ced4cb) + (0, $375f8776645d5aee$export$b9d67b8f1f51ac8d) + $49c99466dee6cafa$var$PHONE_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: true,
        onClose: requestClose,
        title: title,
        fullHeight: true,
        snap: 1,
        closeLabel: t('common.actions.close'),
        "data-testid": "visit-rx-correction-sheet",
        "data-appointment-id": visit.id,
        "data-mode": sending ? 'send' : 'correct'
    }, lastDay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-window",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            marginBottom: '0.5rem'
        }
    }, t('visit.erx.correction.until', {
        date: formatDate(lastDay, 'medium')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            paddingBottom: '0.5rem'
        }
    }, body)), dialogs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: $49c99466dee6cafa$var$SHEET_Z,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: requestClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        tabIndex: -1,
        "data-testid": "visit-rx-correction-sheet",
        "data-appointment-id": visit.id,
        "data-mode": sending ? 'send' : 'correct',
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(640px, 94vw)',
            background: (0, $jTCZr.CT).surface,
            borderInlineEnd: `1px solid ${(0, $jTCZr.CT).border}`,
            outline: 'none',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: 24,
            height: 24,
            borderRadius: 7,
            display: 'grid',
            placeItems: 'center',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).edit, {
        width: 13,
        height: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13.5,
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, title), lastDay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-window",
        style: {
            fontSize: 11,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.correction.until', {
        date: formatDate(lastDay, 'medium')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: requestClose,
        disabled: closing,
        "aria-label": t('common.actions.close'),
        "data-testid": "visit-rx-correction-close",
        style: {
            background: 'none',
            border: 'none',
            cursor: closing ? 'default' : 'pointer',
            color: (0, $jTCZr.CT).mute,
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, closing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '14px 16px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, body))), dialogs);
}



var $acw62 = parcelRequire("acw62");

var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $5MbI8 = parcelRequire("5MbI8");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $82f55e2793e90da1$export$d25afe3d0bd013b5 = 400;
const $82f55e2793e90da1$export$2aa65abd2a659822 = 860;
function $82f55e2793e90da1$export$2e2bcd8739ae039({ scope: scope = 'ALL', onClose: onClose, overlay: overlay = false, notOffered: notOffered = false, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const ref = (0, $acw62.useRef)(null);
    // Opened from the dock: bring the keyboard along.
    (0, $acw62.useEffect)(()=>{
        ref.current?.focus?.({
            preventScroll: true
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        ref: ref,
        tabIndex: -1,
        "aria-label": t('visit.erx.panel.title'),
        "data-testid": "visit-erx-panel",
        "data-scope": scope,
        "data-layout": overlay ? 'overlay' : 'push',
        style: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            outline: 'none',
            background: (0, $jTCZr.CT).surface,
            borderInlineStart: `1px solid ${(0, $jTCZr.C).border}`,
            ...overlay ? {
                position: 'absolute',
                top: 0,
                bottom: 0,
                insetInlineEnd: 0,
                zIndex: 5,
                width: `min(${$82f55e2793e90da1$export$d25afe3d0bd013b5}px, 100%)`,
                boxShadow: (0, $jTCZr.SHADOW).floating
            } : {
                flex: `0 0 ${$82f55e2793e90da1$export$d25afe3d0bd013b5}px`,
                width: $82f55e2793e90da1$export$d25afe3d0bd013b5
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 12px 10px 14px',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        style: {
            margin: 0,
            flex: 1,
            minWidth: 0,
            fontSize: 14,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.erx.panel.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": "true"
        }),
        label: t('visit.erx.inVisit.close'),
        variant: "ghost",
        size: 32,
        onClick: onClose,
        "data-testid": "visit-erx-panel-close"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel-body",
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            padding: '14px 16px 0',
            display: 'flex',
            flexDirection: 'column'
        }
    }, notOffered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel-not-offered",
        style: {
            fontSize: 12.5,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            paddingBottom: 14
        }
    }, t('visit.erx.inVisit.notOffered')) : children));
}














var $e317r = parcelRequire("e317r");



var $acw62 = parcelRequire("acw62");









const $be5cdb537ae81129$export$8a2ed3f7f077984e = {
    PENDING: 'pending',
    RUNNING: 'running',
    DONE: 'done',
    FAILED: 'failed',
    SKIPPED: 'skipped'
};
const $be5cdb537ae81129$export$2b9b886dddb4ba32 = {
    SWEEP: 'sweep',
    CLOSE: 'close',
    ENCOUNTER: 'encounter',
    SOAP: 'soap',
    DRUG: 'drug',
    DIAGNOSIS: 'diagnosis',
    ORDERS: 'orders'
};
const $be5cdb537ae81129$var$EMPTY_PROGRESS = {
    steps: [],
    running: false
};
/** Minutes a visit lasted, rounded up — a 40-second visit reads «۱ دقیقه», not «۰». */ const $be5cdb537ae81129$var$minutesOf = (seconds)=>Math.max(1, Math.ceil((Number(seconds) || 0) / 60));
function $be5cdb537ae81129$export$2e2bcd8739ae039(deps) {
    // Every input arrives through a ref rather than the dependency array: the
    // sequence reads the state as it was when the doctor pressed the button, and
    // `start` / `retryFailed` keep a stable identity so they can be handed to a
    // memoised dialog without re-arming it on every keystroke in the SOAP field.
    const depsRef = (0, $acw62.useRef)(deps);
    depsRef.current = deps;
    const [progress, setProgress] = (0, $acw62.useState)($be5cdb537ae81129$var$EMPTY_PROGRESS);
    const [saveFailures, setSaveFailures] = (0, $acw62.useState)([]);
    const [endedAt, setEndedAt] = (0, $acw62.useState)(null);
    const [durationMin, setDurationMin] = (0, $acw62.useState)(null);
    // The runner for each recorded failure, keyed by the failure's id. Kept out
    // of state because it is a closure, not data: state holds what the screen
    // renders (group + label), this holds what «تلاش مجدد» executes.
    const runnersRef = (0, $acw62.useRef)(new Map());
    // Facts captured at the moment the visit closed. A retry minutes later must
    // update the SAME SOAP row and stamp the SAME encounter — re-deriving them
    // from a later `Date.now()` would file a second note for one visit.
    const contextRef = (0, $acw62.useRef)(null);
    const inFlightRef = (0, $acw62.useRef)(false);
    // High findings an earlier stop of the sweep put in front of the doctor, under
    // the signature of the نسخه they were found in (interactionSeen.sweepHolds).
    const sweepShownRef = (0, $acw62.useRef)(null);
    const mark = (0, $acw62.useCallback)((key, state)=>{
        setProgress((p)=>({
                ...p,
                steps: p.steps.map((s)=>s.key === key ? {
                        ...s,
                        state: state
                    } : s)
            }));
    }, []);
    const markRemaining = (0, $acw62.useCallback)((fromKey, state)=>{
        setProgress((p)=>{
            const i = p.steps.findIndex((s)=>s.key === fromKey);
            if (i === -1) return p;
            return {
                ...p,
                steps: p.steps.map((s, n)=>n > i && s.state === $be5cdb537ae81129$export$8a2ed3f7f077984e.PENDING ? {
                        ...s,
                        state: state
                    } : s)
            };
        });
    }, []);
    // ── the plan ──────────────────────────────────────────────────────────────
    // Built from the visit's actual content, so a visit with no prescription
    // never shows a «نسخه» row that would only ever say "skipped". Each task owns
    // its label and its runner; the runner is what a retry re-executes.
    const buildPlan = (0, $acw62.useCallback)(()=>{
        const d = depsRef.current;
        const { t: t, soap: soap = {}, rxItems: rxItems = [], pendingTests: pendingTests = [], patient: patient, diagnosis: diagnosis, interactionSweepEnabled: // «بررسی تداخل دارویی در پایان ویزیت». Defaults to true so a caller that
        // has not learned about the switch keeps the backstop — and so does a
        // doctor whose settings query failed, which is why the Visit page reads
        // this one switch directly instead of through its "is the choice known"
        // guard. Only an explicit «off» removes the step, and then it is not a
        // SKIPPED row either: a plan row for a check nobody asked for would be
        // the screen explaining a decision the doctor already made in Settings.
        interactionSweepEnabled = true } = d;
        const ctx = contextRef.current;
        const tasks = [];
        if (interactionSweepEnabled && rxItems.length > 0 && patient?.id) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP,
            retryable: false,
            label: t('visit.end.step.sweep'),
            run: async ()=>{
                const dd = depsRef.current;
                const sweepConditions = [
                    ...(dd.patient?.clinicalConditions || []).map((c)=>c.display),
                    ...(dd.differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((x)=>x.description),
                    ...(0, $375f8776645d5aee$export$5176433c16ff5a4)(dd.patient?.clinicalObservations)
                ];
                const sweepAllergies = (dd.patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
                const res = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9812972017b718e1), {
                    // Names, not formulary ids — see interactionDrugName.
                    medicationIds: (0, $bb8a11e7c1131df5$export$868d19c379622928)(dd.rxItems),
                    patientId: dd.patient.id,
                    patientConditions: sweepConditions,
                    patientAllergies: sweepAllergies
                });
                // The sweep is an AI call like any other and the service debits for
                // it, so it belongs in the visit's own tally. Without this the debit
                // showed up in the account panel and NOWHERE on the visit — a doctor
                // closing a visit watched credits leave for something they never
                // pressed a button for and the page never mentioned. Charged on the
                // answer, not the request: a sweep that threw is not billed.
                dd.chargeVisit?.((0, $121df138798ec781$export$c932aceb7c67d0f4)('INTERACTION_CHECK'), 'interaction');
                const warnings = res.checkDrugInteraction?.warnings || [];
                // Only a high finding the doctor has NOT already been shown for THIS
                // نسخه holds the visit open — every one of them, matched by its drugs,
                // against a result whose signature is the current one. It used to be
                // "any earlier result had any high finding", which let a new A + C
                // through on the strength of an A + B shown before C was added
                // (interactionSeen.js). Medium and low findings wait in the نسخه tab.
                if ((0, $ea35d970f69d5497$export$9b1b472b8328535d)(warnings, {
                    shown: dd.rxInteractions,
                    signature: dd.rxSignature,
                    memo: sweepShownRef
                })) {
                    dd.onInteractionFound?.(warnings);
                    return 'stop';
                }
                return 'ok';
            }
        });
        tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE,
            fatal: true,
            retryable: false,
            label: t('visit.end.step.close'),
            run: async ()=>{
                const dd = depsRef.current;
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$33b114336c19593d), {
                    id: dd.visitId
                });
                return 'ok';
            }
        });
        if (ctx.pmEncId) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.ENCOUNTER,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.ENCOUNTER,
            retryable: true,
            label: t('visit.end.partEncounter'),
            run: async ()=>{
                const dd = depsRef.current;
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6762df89b8e36811), {
                    id: ctx.pmEncId,
                    input: {
                        status: 'finished',
                        periodEnd: ctx.endTime,
                        reason: dd.soap?.a || dd.diagnosis || ''
                    }
                });
            }
        });
        if (patient?.id && (soap.s || soap.o || soap.a || soap.p)) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.SOAP,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.SOAP,
            retryable: true,
            label: t('visit.end.partSoap'),
            run: async ()=>{
                const dd = depsRef.current;
                const content = {
                    s: dd.soap.s || '',
                    o: dd.soap.o || '',
                    a: dd.soap.a || '',
                    p: dd.soap.p || ''
                };
                // The in-visit autosave already owns a row — update it. Only a visit
                // whose SOAP was never autosaved creates one here; writing a second
                // SOAP_NOTE for one appointment is what made post-visit editing
                // ambiguous. `ctx.soapNoteId` is the id as it was at closure, which
                // is why a retry cannot drift onto a create.
                if (ctx.soapNoteId) await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6e7c5d8b5a28479a), {
                    id: ctx.soapNoteId,
                    input: {
                        content: content
                    }
                });
                else {
                    const created = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$1d32d39b70c8b52e), {
                        patientId: dd.patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: ctx.pmEncId || dd.visitId
                        }
                    });
                    // A retry after a failed create must not create a second note.
                    const id = created?.createClinicalNote?.id;
                    if (id) ctx.soapNoteId = id;
                }
            }
        });
        // Rows that already carry a `medicationId` live in the record from the
        // moment a template put them there, and every edit since was written to
        // that row. Writing them again gives the patient two rows for one drug.
        const drugsToWrite = patient?.id ? rxItems.filter((item)=>!item.medicationId) : [];
        if (drugsToWrite.length > 0) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG,
            retryable: true,
            fanOut: true,
            label: t('visit.end.step.rx', {
                count: drugsToWrite.length
            }),
            // One step row, N writes: the doctor thinks «نسخه», not «six mutations».
            // Failures are still per drug, because that is what a retry re-sends.
            items: drugsToWrite.map((item)=>({
                    id: `${$be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG}:${item.id || item.drug?.id || item.drug?.name}`,
                    label: `${t('visit.end.partDrug')} \u{2014} ${(0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug)}`,
                    run: async ()=>{
                        const dd = depsRef.current;
                        await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5fcaf1729c987f4d), {
                            patientId: dd.patient.id,
                            input: {
                                code: item.drug.genericName || item.drug.name,
                                display: item.drug.name,
                                status: 'active',
                                authoredOn: ctx.today,
                                // The SAME structured payload the persistence hook writes for a
                                // row that already lives server-side; a bare `text` here would
                                // make a drug added on this tab come back from the record as one
                                // undifferentiated string in the dose column.
                                dosageInstruction: (0, $5e2e0b7ea22d1ff2$export$1ed13c90275604ad)(item),
                                // تعداد as a first-class column: a تأمین اجتماعی ثبت‌نسخه reads
                                // srvQty from it and drops any drug line that has none.
                                quantity: (0, $ace44487380106d3$export$48f972f5effb9c)(item.quantity),
                                // The drug-list row it came from — how an eRx drug reaches the
                                // insurer with its product code instead of as a name.
                                meta: (0, $5e2e0b7ea22d1ff2$export$2fe3f622dc680493)(item.drug),
                                appointmentId: ctx.pmEncId || dd.visitId
                            }
                        });
                    }
                }))
        });
        const primaryDisplay = (soap.a || diagnosis || '').trim();
        if (patient?.id && primaryDisplay) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.DIAGNOSIS,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.DIAGNOSIS,
            retryable: true,
            label: t('visit.end.partDiagnosis'),
            run: async ()=>{
                const dd = depsRef.current;
                // Accepted differential items are already persisted server-side by
                // ai.js's updateDifferentialItem resolver (action 'accept') the moment
                // the doctor accepts them — do NOT re-save those here, or every
                // accepted diagnosis ends up with two duplicate Condition rows.
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$52e699bb9024b09d), {
                    patientId: dd.patient.id,
                    input: {
                        code: '',
                        display: primaryDisplay,
                        status: 'active',
                        // Free prose nobody was asked to type: a working diagnosis until
                        // the doctor says otherwise in the record panel.
                        verificationStatus: (0, $4a744c4def3d338a$export$effbc4db6100f5f7),
                        onsetDate: ctx.today,
                        appointmentId: ctx.pmEncId || dd.visitId
                    }
                });
            }
        });
        const unsaved = pendingTests.filter((test)=>!test.savedToBackend);
        if (patient?.id && unsaved.length > 0) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS,
            retryable: true,
            fanOut: true,
            label: t('visit.end.partOrders'),
            count: unsaved.length,
            // One write per order, like the drugs. This was one batch whose answer
            // was never read, and the BFF said `success: true` even when every
            // order inside it failed — the closure reported «ثبت شد» over orders
            // that were not in the record. Per order, a refusal is a failure the
            // doctor sees, and «تلاش مجدد» re-sends that order alone rather than
            // the batch, which would write the ones that landed a second time.
            items: unsaved.map((order, n)=>({
                    id: `${$be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS}:${n}:${order.id || order.name || ''}`,
                    label: `${t('visit.end.partOrders')} \u{2014} ${order.name || order.testName || order}`,
                    run: async ()=>{
                        const dd = depsRef.current;
                        await (0, $3f422a714825191a$export$12af1fa985734757)({
                            patientId: dd.patient.id,
                            appointmentId: ctx.pmEncId || dd.visitId
                        }, (0, $3f422a714825191a$export$b7142a5aec62c528)(order));
                    }
                }))
        });
        return tasks;
    }, []);
    /** The local draft is the sole surviving copy when a write failed — it goes only on a clean end. */ const dropDraft = (0, $acw62.useCallback)(()=>{
        const d = depsRef.current;
        try {
            localStorage.removeItem(`visit_draft_${d.patient?.id}`);
        } catch  {}
    }, []);
    // ── run ───────────────────────────────────────────────────────────────────
    const start = (0, $acw62.useCallback)(async ()=>{
        const d = depsRef.current;
        if (inFlightRef.current || !d.visitId) return 'failed';
        inFlightRef.current = true;
        contextRef.current = {
            pmEncId: d.pmEncounterId || d.visitId || null,
            // Captured BEFORE the caller resets it: the SOAP save must UPDATE the row
            // the in-visit autosave created.
            soapNoteId: d.soapNoteId || null,
            today: new Date().toISOString().split('T')[0],
            endTime: new Date().toISOString()
        };
        runnersRef.current = new Map();
        const plan = buildPlan();
        setSaveFailures([]);
        setProgress({
            running: true,
            steps: plan.map((task)=>({
                    key: task.key,
                    label: task.label,
                    count: task.count,
                    state: $be5cdb537ae81129$export$8a2ed3f7f077984e.PENDING
                }))
        });
        const failures = [];
        const runners = new Map();
        try {
            for (const task of plan){
                mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.RUNNING);
                if (task.group === $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP) {
                    let verdict = 'ok';
                    // The sweep is advisory: an API failure must not prevent a doctor
                    // from closing a visit, so it is the one task whose own error is not
                    // recorded as a failed write.
                    try {
                        verdict = await task.run();
                    } catch  {
                        verdict = 'error';
                    }
                    if (verdict === 'stop') {
                        mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                        markRemaining(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED);
                        setProgress((p)=>({
                                ...p,
                                running: false
                            }));
                        return 'stopped-interaction';
                    }
                    mark(task.key, verdict === 'error' ? $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED : $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                    continue;
                }
                if (task.fanOut) {
                    let anyFailed = false;
                    for (const item of task.items)try {
                        await item.run();
                    } catch (e) {
                        console.warn('[endVisit] write failed:', task.key, e?.message);
                        anyFailed = true;
                        failures.push({
                            id: item.id,
                            group: task.group,
                            label: item.label
                        });
                        runners.set(item.id, item.run);
                    }
                    mark(task.key, anyFailed ? $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED : $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                    continue;
                }
                try {
                    await task.run();
                    mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                } catch (e) {
                    // `END_VISIT` failing means the sequence never started, not that part
                    // of it landed. The caller must not show a closure that says the
                    // visit is done, so this is the one write that aborts.
                    if (task.fatal) {
                        console.error('[endVisit]', e);
                        mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED);
                        markRemaining(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED);
                        setProgress((p)=>({
                                ...p,
                                running: false
                            }));
                        return 'failed';
                    }
                    console.warn('[endVisit] write failed:', task.key, e?.message);
                    mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED);
                    failures.push({
                        id: task.key,
                        group: task.group,
                        label: task.label
                    });
                    runners.set(task.key, task.run);
                    continue;
                }
                // Everything after this point is bookkeeping on a visit that IS closed.
                if (task.group === $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE) {
                    d.onVisitClosed?.();
                    setEndedAt(new Date());
                    setDurationMin($be5cdb537ae81129$var$minutesOf(d.elapsedSeconds));
                }
            }
        } finally{
            inFlightRef.current = false;
        }
        runnersRef.current = runners;
        setSaveFailures(failures);
        if (failures.length === 0) dropDraft();
        setProgress((p)=>({
                ...p,
                running: false
            }));
        return failures.length > 0 ? 'partial' : 'done';
    }, [
        buildPlan,
        mark,
        markRemaining,
        dropDraft
    ]);
    // ── retry ─────────────────────────────────────────────────────────────────
    // Only the writes that failed, and never automatically: §14.2 — a duplicated
    // clinical write is strictly worse than a failed one the doctor can see.
    const [retrying, setRetrying] = (0, $acw62.useState)(false);
    const retryFailed = (0, $acw62.useCallback)(async ()=>{
        if (inFlightRef.current) return false;
        const pending = saveFailures;
        if (pending.length === 0) return true;
        inFlightRef.current = true;
        setRetrying(true);
        const stillFailing = [];
        try {
            for (const failure of pending){
                const run = runnersRef.current.get(failure.id);
                if (!run) continue;
                try {
                    await run();
                    runnersRef.current.delete(failure.id);
                } catch (e) {
                    console.warn('[endVisit] retry failed:', failure.id, e?.message);
                    stillFailing.push(failure);
                }
            }
        } finally{
            inFlightRef.current = false;
            setRetrying(false);
        }
        setSaveFailures(stillFailing);
        setProgress((p)=>({
                ...p,
                steps: p.steps.map((s)=>s.state === $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED && !stillFailing.some((f)=>f.group === s.key) ? {
                        ...s,
                        state: $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE
                    } : s)
            }));
        if (stillFailing.length === 0) dropDraft();
        return stillFailing.length === 0;
    }, [
        saveFailures,
        dropDraft
    ]);
    /** Groups that did not reach the record — what the closure marks «ثبت نشد». */ const failedGroups = saveFailures.reduce((acc, f)=>{
        acc[f.group] = (acc[f.group] || 0) + 1;
        return acc;
    }, {});
    const reset = (0, $acw62.useCallback)(()=>{
        setProgress($be5cdb537ae81129$var$EMPTY_PROGRESS);
        setSaveFailures([]);
        runnersRef.current = new Map();
    }, []);
    return {
        endProgress: progress,
        saveFailures: saveFailures,
        failedGroups: failedGroups,
        retrying: retrying,
        start: start,
        retryFailed: retryFailed,
        reset: reset,
        endedAt: endedAt,
        durationMin: durationMin
    };
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $54b8ecca4695c6ef$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, patientName: patientName, recording: recording, onConfirm: onConfirm }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: open,
        onOpenChange: onOpenChange,
        "data-testid": "visit-end-confirm",
        confirmTestId: "visit-end-confirm-ok",
        cancelTestId: "visit-end-confirm-cancel",
        // A node, not an interpolated string: the patient's name is data in an
        // unknown script, so it is bidi-isolated rather than glued into the
        // sentence (§16.4).
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('visit.endConfirm.titleLead'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto"
        }, patientName || ''), t('visit.endConfirm.titleTail')),
        description: recording ? `${t('visit.endConfirm.body')} ${t('visit.endConfirm.recordingNote')}` : t('visit.endConfirm.body'),
        confirmLabel: t('visit.endConfirm.confirm'),
        cancelLabel: t('visit.endConfirm.cancel'),
        onConfirm: onConfirm
    });
}














var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4e081ec70e23b03f$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $4e081ec70e23b03f$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle", $4e081ec70e23b03f$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $034b067d9e02706b$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ]
];
const $034b067d9e02706b$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-minus", $034b067d9e02706b$export$3efd853dbb351e94);


parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// The wait while the visit is written to the record.
//
// The overlay this replaces showed a spinner, the sentence «در حال ذخیره
// یادداشت‌ها و تهیه خلاصه AI» — no AI has run here since ending a visit became
// free — and three chips whose dots pulsed on a timer, forever, connected to
// nothing. Everything here is the real plan: one row per write, flipping as it
// lands, so a doctor watching a slow connection can see WHICH step is slow and,
// afterwards, which one failed.
//
// Nothing can interrupt it. Esc, the scrim and the close button are all
// disabled, because a half-run sequence is worse than a slow one.
const $6d5a7a965cfe42c6$var$GLYPH = {
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).PENDING]: {
        Icon: (0, $4e081ec70e23b03f$export$2e2bcd8739ae039),
        color: (0, $jTCZr.CT).mute
    },
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).DONE]: {
        Icon: (0, $8cb58a0e56c12463$export$2e2bcd8739ae039),
        color: (0, $jTCZr.CT).good
    },
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).FAILED]: {
        Icon: (0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039),
        color: (0, $jTCZr.CT).danger
    },
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).SKIPPED]: {
        Icon: (0, $034b067d9e02706b$export$2e2bcd8739ae039),
        color: (0, $jTCZr.CT).mute
    }
};
const $6d5a7a965cfe42c6$var$STATE_KEY = {
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).PENDING]: 'visit.end.stepState.pending',
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).RUNNING]: 'visit.end.stepState.running',
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).DONE]: 'visit.end.stepState.done',
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).FAILED]: 'visit.end.stepState.failed',
    [(0, $be5cdb537ae81129$export$8a2ed3f7f077984e).SKIPPED]: 'visit.end.stepState.skipped'
};
function $6d5a7a965cfe42c6$var$StepRow({ step: step }) {
    const { t: t } = (0, $LNQP4.default)();
    const glyph = $6d5a7a965cfe42c6$var$GLYPH[step.state];
    const running = step.state === (0, $be5cdb537ae81129$export$8a2ed3f7f077984e).RUNNING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minWidth: 0
        },
        "data-testid": `visit-end-step-${step.key}`,
        "data-state": step.state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0,
            width: '1rem',
            justifyContent: 'center'
        },
        "aria-hidden": "true"
    }, running ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(glyph.Icon, {
        size: 15,
        color: glyph.color
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            fontSize: '0.8125rem',
            color: step.state === (0, $be5cdb537ae81129$export$8a2ed3f7f077984e).PENDING ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, step.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            flexShrink: 0
        }
    }, t($6d5a7a965cfe42c6$var$STATE_KEY[step.state])));
}
function $6d5a7a965cfe42c6$export$2e2bcd8739ae039({ steps: steps = [] }) {
    const { t: t } = (0, $LNQP4.default)();
    const stop = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "sm",
        layout: "frame",
        showClose: false,
        onEscapeKeyDown: stop,
        onPointerDownOutside: stop,
        onInteractOutside: stop,
        "data-testid": "visit-end-progress",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 18,
        color: (0, $jTCZr.CT).accent,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '0.9375rem'
        }
    }, t('visit.header.ending'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogDescription), {
        style: {
            fontSize: '0.75rem'
        }
    }, t('visit.header.endingHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        "aria-live": "polite"
    }, steps.map((step)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6d5a7a965cfe42c6$var$StepRow, {
            key: step.key,
            step: step
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null)));
}



var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $a0SXV = parcelRequire("a0SXV");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $4fYdd = parcelRequire("4fYdd");
var $hZDga = parcelRequire("hZDga");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $9BgRG = parcelRequire("9BgRG");






var $e317r = parcelRequire("e317r");

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $jTCZr = parcelRequire("jTCZr");
const $53657303f9877f90$export$95783a805443ad7d = {
    background: (0, $jTCZr.CT).surface,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    padding: '0.875rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    minWidth: 0
};
const $53657303f9877f90$export$6dbe65f67bd0d0fd = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    minWidth: 0
};
const $53657303f9877f90$export$ab4acd4f7dcb595f = {
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: (0, $jTCZr.CT).ink,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
};
const $53657303f9877f90$export$72b0f1ae75602dae = {
    fontSize: '0.78125rem',
    lineHeight: 1.7,
    color: (0, $jTCZr.CT).ink2
};
const $53657303f9877f90$export$32d70c2a0f618291 = {
    fontSize: '0.78125rem',
    lineHeight: 1.7,
    color: (0, $jTCZr.CT).mute
};
const $53657303f9877f90$export$67c34e73d0f66b9f = {
    dir: 'auto'
};
const $53657303f9877f90$export$2eca6f417e9e523e = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate',
        display: 'inline-block'
    }
};


// The receipt's first line, and the one sentence a doctor reads before walking
// away from the visit.
//
// The disc is a CLAIM. A green tick over a save that half failed is the single
// most expensive lie this screen could tell, so it follows the fact rather than
// the act: ⚠ whenever anything did not reach the record.
//
// The subtitle used to read «خلاصه ثبت‌شده در پرونده الکترونیک بیمار» — there
// has been no summary since ending a visit stopped calling the AI, so it named
// a thing that does not exist. It now names the four things that were actually
// written.
const $e85a01c372dd00b8$var$SUBTITLE_KEY = {
    clean: 'visit.closure.subtitleSaved',
    empty: 'visit.closure.subtitleEmpty',
    partial: 'visit.end.partialSaveSubtitle'
};
function $e85a01c372dd00b8$export$2e2bcd8739ae039({ state: state, patient: patient, endedAt: endedAt, durationMin: durationMin, coins: coins }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const partial = state === 'partial';
    const meta = [
        endedAt ? formatDate(endedAt, 'short') : null,
        endedAt ? formatTime(endedAt) : null,
        durationMin ? t('visit.closure.durationMinutes', {
            count: durationMin
        }) : null
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: '50%',
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: partial ? (0, $jTCZr.CT).warnSoft : (0, $jTCZr.CT).goodSoft,
            color: partial ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).good
        }
    }, partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 18
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 18,
        strokeWidth: 2.6
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '1.0625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        title: patient?.name || ''
    }, t('visit.closure.titleLead'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "auto"
    }, patient?.name || ''), t('visit.closure.titleTail')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            marginTop: '0.125rem'
        }
    }, t($e85a01c372dd00b8$var$SUBTITLE_KEY[state] || $e85a01c372dd00b8$var$SUBTITLE_KEY.clean)), (meta.length > 0 || patient?.nationalId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute2,
            marginTop: '0.25rem'
        }
    }, meta.map((part, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true"
        }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, part))), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, meta.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true"
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.closure.patientCodeLabel'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $53657303f9877f90$export$2eca6f417e9e523e), patient.nationalId))))), coins?.total > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95619a68e42b6cf6$export$2e2bcd8739ae039), {
        entries: coins.entries,
        total: coins.total
    })));
}



var $acw62 = parcelRequire("acw62");

var $fX0JO = parcelRequire("fX0JO");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

const $437b45feafd91083$export$b299642011ab9f53 = 3;
function $437b45feafd91083$export$2e2bcd8739ae039({ icon: Icon, title: title, count: count, total: total, expanded: expanded, onToggle: onToggle, failedCount: failedCount, testId: testId, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const listId = testId ? `${testId}-list` : undefined;
    const hasMore = typeof total === 'number' && total > $437b45feafd91083$export$b299642011ab9f53;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        style: (0, $53657303f9877f90$export$95783a805443ad7d),
        "data-testid": testId,
        "data-state": failedCount ? 'failed' : 'saved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $53657303f9877f90$export$6dbe65f67bd0d0fd)
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            color: (0, $jTCZr.CT).mute,
            flexShrink: 0
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            ...(0, $53657303f9877f90$export$ab4acd4f7dcb595f),
            margin: 0
        }
    }, title), typeof count === 'number' && count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "outline"
    }, t('visit.closure.itemsCount', {
        count: count
    })), failedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "destructive",
        "data-testid": testId ? `${testId}-unsaved` : undefined
    }, failedCount > 1 ? t('visit.closure.notSavedCount', {
        count: failedCount
    }) : t('visit.closure.notSavedTag'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: listId,
        style: {
            minWidth: 0
        }
    }, children), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        className: "h-auto p-0",
        onClick: onToggle,
        "aria-expanded": !!expanded,
        "aria-controls": listId,
        "data-testid": testId ? `${testId}-expand` : undefined
    }, expanded ? t('visit.closure.showLess') : t('visit.closure.showAll', {
        count: total
    }))));
}
function $437b45feafd91083$export$21407d21daa9d31({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            ...(0, $53657303f9877f90$export$32d70c2a0f618291),
            margin: 0
        }
    }, children);
}



function $0a43bdf6bf7b450a$export$2e2bcd8739ae039({ soap: soap, diagnosis: diagnosis, accepted: accepted = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const primary = (soap?.a || '').trim() || (diagnosis || '').trim();
    const items = [
        ...primary ? [
            {
                text: primary,
                tag: t('visit.closure.provisionalTag'),
                key: 'primary'
            }
        ] : [],
        ...accepted.map((d, i)=>({
                text: d.description || d.display || '',
                code: d.icdCode || d.code || '',
                tag: t('visit.closure.acceptedTag'),
                key: `accepted-${d.id || i}`
            })).filter((d)=>d.text)
    ];
    const shown = expanded ? items : items.slice(0, (0, $437b45feafd91083$export$b299642011ab9f53));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$2e2bcd8739ae039), {
        icon: (0, $fX0JO.default),
        title: t('visit.dx.title'),
        total: items.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-dx"
    }, items.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$21407d21daa9d31), null, t('visit.closure.noDiagnosis')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: item.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                padding: '0.1875rem 0.625rem',
                borderRadius: (0, $jTCZr.RADIUS).chip,
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk,
                fontSize: '0.71875rem',
                fontWeight: 600,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, item.text)), item.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            ...(0, $53657303f9877f90$export$2eca6f417e9e523e),
            style: {
                ...(0, $53657303f9877f90$export$2eca6f417e9e523e).style,
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute,
                fontFamily: 'monospace'
            }
        }, item.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "outline"
        }, item.tag)))));
}



var $acw62 = parcelRequire("acw62");

var $aVx4q = parcelRequire("aVx4q");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






function $3f321e934a2c42ad$export$2e2bcd8739ae039({ rxItems: rxItems = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const shown = expanded ? rxItems : rxItems.slice(0, (0, $437b45feafd91083$export$b299642011ab9f53));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$2e2bcd8739ae039), {
        icon: (0, $aVx4q.default),
        title: t('visit.tabs.rx'),
        count: rxItems.length,
        total: rxItems.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-rx"
    }, rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$21407d21daa9d31), null, t('visit.rx.none')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((item, i)=>{
        const parts = (readsPersianData ? [
            item.dosage,
            item.route,
            item.frequency,
            item.duration
        ] : [
            item.dosage && (0, $375f8776645d5aee$export$a6616cb9d478340f)(item.dosage, false, t),
            item.route && (0, $ace44487380106d3$export$80ace2b99405d272)(item.route, t),
            item.frequency && (0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(item.frequency, t),
            item.duration
        ]).filter(Boolean);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: item.id || `${item.drug?.id}-${i}`,
            style: {
                borderInlineStart: `2px solid ${(0, $jTCZr.CT).accent}`,
                paddingInlineStart: '0.5rem',
                minWidth: 0
            },
            "data-testid": "visit-closure-rx-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug) || item.name)), parts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $53657303f9877f90$export$72b0f1ae75602dae),
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, parts.map((part, n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: n
            }, n > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": "true"
            }, " \xb7 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, part)))), (0, $ace44487380106d3$export$48f972f5effb9c)(item.quantity) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $53657303f9877f90$export$72b0f1ae75602dae),
                color: (0, $jTCZr.CT).mute2,
                display: 'block'
            }
        }, t('visit.closure.quantity', {
            count: (0, $ace44487380106d3$export$48f972f5effb9c)(item.quantity)
        })), (0, $ace44487380106d3$export$e9b4e5de48a21156)(item).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-closure-rx-incomplete",
            title: t('visit.rx.incompleteHint'),
            style: {
                ...(0, $53657303f9877f90$export$72b0f1ae75602dae),
                color: (0, $jTCZr.CT).warnInk,
                fontWeight: 700,
                display: 'block'
            }
        }, (0, $ace44487380106d3$export$ab36a14ecd73702e)((0, $ace44487380106d3$export$e9b4e5de48a21156)(item), t)));
    })));
}



var $acw62 = parcelRequire("acw62");

var $4CVxl = parcelRequire("4CVxl");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// درخواست‌های بالینی — labs, imaging and referrals.
//
// Urgency is a badge with a word in it, never a colour alone: §12.3 says colour
// is never the only carrier of meaning, and «اورژانسی» is precisely the fact a
// colour-blind doctor must not miss.
const $915e51e033df3655$var$TYPE_KEY = {
    lab: 'visit.orders.lab',
    imaging: 'visit.orders.imaging',
    referral: 'visit.orders.referral'
};
function $915e51e033df3655$export$2e2bcd8739ae039({ pendingTests: pendingTests = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const shown = expanded ? pendingTests : pendingTests.slice(0, (0, $437b45feafd91083$export$b299642011ab9f53));
    // The order carries its Persian catalogue name; an English reader sees the
    // catalogue's English one.
    const orderName = (0, $375f8776645d5aee$export$891bfbeed44ddfce)(pendingTests.map((o)=>o.name || o.testName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$2e2bcd8739ae039), {
        icon: (0, $4CVxl.default),
        title: t('visit.orders.requests'),
        count: pendingTests.length,
        total: pendingTests.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-orders"
    }, pendingTests.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$21407d21daa9d31), null, t('visit.orders.noneRecordedShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((order, i)=>{
        const type = order.type || 'lab';
        const urgent = order.urgency === 'urgent' || order.urgency === 'stat';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: order.id || `${order.name}-${i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                minWidth: 0
            },
            "data-testid": "visit-closure-orders-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "outline"
        }, t($915e51e033df3655$var$TYPE_KEY[type] || $915e51e033df3655$var$TYPE_KEY.lab)), urgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "destructive"
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.78125rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, orderName(order.name || order.testName) || String(order))));
    })));
}



var $acw62 = parcelRequire("acw62");

var $jhSl7 = parcelRequire("jhSl7");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// یادداشت SOAP — the four sections as they were written.
//
// Each block clamps to three lines and the card expands all four together. The
// version this replaces rendered the raw text into a 10.5px quadrant with no
// clamp at all, so one long plan pushed the prescription card off the screen.
//
// The section count is COMPUTED. It used to be the literal string «۴ بخش»,
// which claimed four sections for a visit that had one — and, being a literal,
// showed Persian digits in the English UI.
const $62be6e4f8a045166$var$SECTIONS = [
    's',
    'o',
    'a',
    'p'
];
const $62be6e4f8a045166$var$LETTER_KEY = {
    s: 'visit.soap.sLetter',
    o: 'visit.soap.oLetter',
    a: 'visit.soap.aLetter',
    p: 'visit.soap.pLetter'
};
function $62be6e4f8a045166$export$2e2bcd8739ae039({ soap: soap = {}, failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const filled = $62be6e4f8a045166$var$SECTIONS.filter((k)=>(soap[k] || '').trim());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$2e2bcd8739ae039), {
        icon: (0, $jhSl7.default),
        title: t('visit.end.partSoap'),
        count: filled.length,
        failedCount: failedCount,
        testId: "visit-closure-soap"
    }, filled.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $437b45feafd91083$export$21407d21daa9d31), null, t('visit.closure.noSoap')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(8rem, 1fr))',
            gap: '0.375rem'
        }
    }, $62be6e4f8a045166$var$SECTIONS.map((k)=>{
        const text = (soap[k] || '').trim();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: k,
            style: {
                background: (0, $jTCZr.CT).surface2,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).chip,
                padding: '0.375rem 0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 800,
                color: (0, $jTCZr.CT).mute,
                letterSpacing: '.08em',
                display: 'block'
            }
        }, t($62be6e4f8a045166$var$LETTER_KEY[k])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.71875rem',
                lineHeight: 1.7,
                color: text ? (0, $jTCZr.CT).ink2 : (0, $jTCZr.CT).mute,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                ...expanded ? {} : {
                    WebkitLineClamp: 3
                }
            }
        }, text || t('visit.closure.sectionEmpty')));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        className: "h-auto p-0",
        onClick: onToggle,
        "aria-expanded": !!expanded,
        "data-testid": "visit-closure-soap-expand"
    }, expanded ? t('visit.closure.showLess') : t('visit.closure.showFullNote')))));
}



var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $5a45f32ddaf989a5$export$2e2bcd8739ae039({ failures: failures = [], onRetry: onRetry, retrying: retrying }) {
    const { t: t } = (0, $LNQP4.default)();
    if (failures.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "closure-partial-save",
        role: "alert",
        style: {
            alignItems: 'flex-start',
            marginBottom: '1rem'
        },
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
            size: 18,
            "aria-hidden": "true"
        }),
        title: t('visit.end.partialSaveTitle'),
        action: onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onRetry,
            disabled: retrying,
            "data-testid": "visit-closure-retry",
            className: "gap-1.5"
        }, retrying && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.end.retryFailed'))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: '0 0 0.5rem',
            fontSize: '0.71875rem',
            lineHeight: 1.85
        }
    }, t('visit.end.partialSaveBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.71875rem',
            lineHeight: 1.9,
            color: (0, $jTCZr.CT).ink
        }
    }, failures.map((failure, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: failure.id || i,
            dir: "auto"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, failure.label || failure)))));
}



var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");
var $a0SXV = parcelRequire("a0SXV");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $5MbI8 = parcelRequire("5MbI8");
var $fAR2n = parcelRequire("fAR2n");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");


// پیش‌نمایش نسخه — a VIEW of the closure dialog, not a modal above it.
//
// It used to be a second fixed overlay at z-70 stacked on the closure's z-50:
// two scrims, two focus scopes, and no answer to «which one does Esc close?».
// §5.2 allows exactly one floating layer at a time, so the preview swaps the
// dialog's body instead of covering it. Esc here goes back to the review; the
// only way out of the closure is still its own footer.
//
// The sheet is the one RTL island in the app that does not follow the UI
// language: it is a picture of the paper an Iranian pharmacy reads. Its colours
// come from `PRINT_SHEET` for the same reason — see the note beside it.
function $858d5203ed82f22a$var$SectionTitle({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            margin: '12px 0 7px',
            fontSize: 11,
            fontWeight: 700,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).brand,
            letterSpacing: '.03em'
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $375f8776645d5aee$export$abc13ae812b14a42).rule
        }
    }));
}
function $858d5203ed82f22a$export$652305dc8151bb22({ onBack: onBack }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: 36,
        label: t('visit.closure.backToReview'),
        onClick: onBack,
        "data-testid": "visit-closure-print-back",
        // A directional glyph: "back" points the other way under `ltr`, so it is
        // mirrored rather than swapped for a second icon at each site (§16.3).
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
            size: 17,
            style: (0, $asXy3.MIRROR_ICON)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '0.9375rem'
        }
    }, t('visit.rx.preview')));
}
function $858d5203ed82f22a$export$515831587eb72291({ onBack: onBack, onPrint: onPrint }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onBack,
        "data-testid": "visit-closure-print-back-cta"
    }, t('visit.closure.backToReview')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: onPrint,
        className: "gap-1.5",
        "data-testid": "visit-closure-print-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('common.actions.print')));
}
function $858d5203ed82f22a$export$2e2bcd8739ae039({ rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, prescriptionTemplates: prescriptionTemplates = [], selectedTplId: selectedTplId, onSelectTemplate: onSelectTemplate }) {
    const { t: t } = (0, $LNQP4.default)();
    const selectedTemplate = prescriptionTemplates.find((tpl)=>tpl.id === selectedTplId) || null;
    // i18n-exempt: printed-document date — stamped on the paper an Iranian
    // pharmacy reads, so it is Persian whatever the UI language is. Same reason
    // as the matching note in `printPrescription`.
    const today = new Date().toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const dxText = soap?.a || diagnosis || '';
    const instructions = soap?.p || '';
    const labOrders = (pendingTests || []).filter((x)=>!x.type || x.type === 'lab');
    const imgOrders = (pendingTests || []).filter((x)=>x.type === 'imaging');
    const filledPreviewText = selectedTemplate ? (0, $375f8776645d5aee$export$1512fb0c882aac98)(selectedTemplate.content, {
        t: t,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '0.5rem 0.75rem',
            marginBottom: '1rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.rx.template'),
        value: selectedTplId,
        onChange: (e)=>onSelectTemplate(e.target.value),
        style: {
            flex: 1,
            minWidth: 0
        },
        "data-testid": "visit-closure-print-template",
        options: [
            ...prescriptionTemplates.map((tpl)=>({
                    value: tpl.id,
                    label: tpl.title
                })),
            {
                value: '',
                label: t('visit.rx.systemFormat')
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        dir: "rtl",
        lang: "fa",
        "data-testid": "visit-closure-print-sheet",
        style: {
            display: 'flex',
            justifyContent: 'center',
            background: (0, $jTCZr.CT).surface2,
            padding: '1.25rem',
            borderRadius: 10
        }
    }, selectedTemplate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 'min(30rem, 100%)',
            background: (0, $375f8776645d5aee$export$abc13ae812b14a42).paper,
            borderRadius: 4,
            boxShadow: '0 4px 24px rgba(0,0,0,.18)',
            padding: '1.5rem 1.75rem',
            minHeight: '36rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            whiteSpace: 'pre-wrap',
            fontFamily: (0, $375f8776645d5aee$export$abc13ae812b14a42).font,
            fontSize: 12.5,
            lineHeight: 1.9,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft,
            margin: 0
        }
    }, filledPreviewText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).watermark,
            textAlign: 'center',
            marginTop: 20,
            paddingTop: 8,
            borderTop: `1px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).hairline}`
        }
    }, t('visit.rx.generatedBy'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 'min(27.5rem, 100%)',
            background: (0, $375f8776645d5aee$export$abc13ae812b14a42).paper,
            borderRadius: 4,
            boxShadow: '0 4px 24px rgba(0,0,0,.18)',
            padding: '1.5rem 1.75rem',
            fontFamily: (0, $375f8776645d5aee$export$abc13ae812b14a42).font,
            minHeight: '36rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `2.5px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).brand}`,
            paddingBottom: 11,
            marginBottom: 13,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 900,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).brand
        }
    }, t('visit.print.doctorTitle'), " ", doctor?.name || "\u2014"), doctor?.specialty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkMuted,
            marginTop: 2
        }
    }, t('visit.print.specialistIn'), " ", doctor.specialty), doctor?.medicalCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkFaint,
            marginTop: 1
        }
    }, t('visit.print.councilCode'), " ", doctor.medicalCode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            border: `1px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).rule}`,
            borderRadius: 5,
            padding: '5px 10px',
            fontSize: 11,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft,
            marginBottom: 2
        }
    }, today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).watermark
        }
    }, t('visit.rx.date')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $375f8776645d5aee$export$abc13ae812b14a42).patientBg,
            borderRadius: 6,
            padding: '7px 12px',
            marginBottom: 13,
            display: 'flex',
            gap: 24,
            fontSize: 11.5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkFaint,
            marginBottom: 1
        }
    }, t('visit.print.patientNameLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).brand
        }
    }, patient?.name || "\u2014")), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkFaint,
            marginBottom: 1
        }
    }, t('common.labels.nationalId')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft
        }
    }, patient.nationalId))), dxText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('patient.conditions.one')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $375f8776645d5aee$export$abc13ae812b14a42).dxBg,
            borderInlineStart: `3px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).dxRule}`,
            padding: '7px 12px',
            borderRadius: 4,
            fontSize: 12.5,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft,
            marginBottom: 11
        }
    }, dxText)), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.rx.medications')), rxItems.map((item, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.id || idx,
            style: {
                display: 'flex',
                gap: 10,
                marginBottom: 9,
                paddingBottom: 9,
                borderBottom: idx < rxItems.length - 1 ? `1px dashed ${(0, $375f8776645d5aee$export$abc13ae812b14a42).hairline}` : 'none',
                alignItems: 'flex-start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 21,
                height: 21,
                borderRadius: '50%',
                background: (0, $375f8776645d5aee$export$abc13ae812b14a42).brand,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).paper,
                fontSize: 11,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: 1
            }
        }, idx + 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontWeight: 700,
                fontSize: 13,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).ink
            }
        }, (0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(item.drug) || item.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkMuted,
                marginTop: 2
            }
        }, [
            item.dosage,
            item.route,
            item.frequency,
            item.duration && t('visit.text.forDuration', {
                duration: item.duration
            })
        ].filter(Boolean).join(" \xb7 ")), item.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkMuted,
                marginTop: 2
            }
        }, item.instructions))))), labOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.labRequest')), labOrders.map((order, ii)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: ii,
            style: {
                display: 'flex',
                gap: 7,
                marginBottom: 5,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 7px',
                borderRadius: 10,
                background: (0, $375f8776645d5aee$export$abc13ae812b14a42).labBg,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).labInk,
                fontWeight: 600
            }
        }, t('visit.orders.lab')), (order.urgency === 'urgent' || order.urgency === 'stat') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 6px',
                borderRadius: 10,
                background: (0, $375f8776645d5aee$export$abc13ae812b14a42).statBg,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).statInk,
                fontWeight: 700
            }
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft
            }
        }, order.name || order.testName)))), imgOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.imagingRequest')), imgOrders.map((order, ii)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: ii,
            style: {
                display: 'flex',
                gap: 7,
                marginBottom: 5,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 7px',
                borderRadius: 10,
                background: (0, $375f8776645d5aee$export$abc13ae812b14a42).imgBg,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).imgInk,
                fontWeight: 600
            }
        }, t('visit.orders.imaging')), (order.urgency === 'urgent' || order.urgency === 'stat') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 6px',
                borderRadius: 10,
                background: (0, $375f8776645d5aee$export$abc13ae812b14a42).statBg,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).statInk,
                fontWeight: 700
            }
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft
            }
        }, order.name || order.testName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.doctorOrders')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: `1px dashed ${(0, $375f8776645d5aee$export$abc13ae812b14a42).dashed}`,
            borderRadius: 6,
            padding: '8px 12px',
            fontSize: 12,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkSoft,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            minHeight: 44,
            marginBottom: 10
        }
    }, instructions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginTop: 16,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).rule}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).watermark
        }
    }, t('visit.rx.generatedBy')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 90,
            borderBottom: `1px solid ${(0, $375f8776645d5aee$export$abc13ae812b14a42).inkFaint}`,
            marginBottom: 4,
            height: 30
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $375f8776645d5aee$export$abc13ae812b14a42).inkFaint
        }
    }, t('visit.rx.signature')))))));
}


function $c82e14f46c6e08fd$export$2e2bcd8739ae039({ patient: patient, doctor: doctor, soap: soap = {}, rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, acceptedDifferential: acceptedDifferential = [], prescriptionTemplates: prescriptionTemplates = [], appointmentId: appointmentId, saveFailures: saveFailures = [], failedGroups: failedGroups = {}, retrying: retrying = false, onRetryFailed: onRetryFailed, endedAt: endedAt, durationMin: durationMin, coins: coins, onExit: onExit, onViewRecord: onViewRecord }) {
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    // Both insurer cards below are Iranian rails (host.jsx useIranianRails).
    const iranianRails = (0, $e317r.useIranianRails)();
    const [view, setView] = (0, $acw62.useState)('review');
    const [expanded, setExpanded] = (0, $acw62.useState)({});
    const [tplId, setTplId] = (0, $acw62.useState)(prescriptionTemplates[0]?.id || '');
    // The e-prescription card's login or send in flight — unsaved work.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(null);
    const partial = saveFailures.length > 0;
    const nothingRecorded = !(soap.s || soap.o || soap.a || soap.p || rxItems.length || pendingTests.length || diagnosis);
    const state = partial ? 'partial' : nothingRecorded ? 'empty' : 'clean';
    const canPrint = rxItems.length > 0 || pendingTests.length > 0;
    const toggle = (0, $acw62.useCallback)((key)=>{
        setExpanded((prev)=>({
                ...prev,
                [key]: !prev[key]
            }));
    }, []);
    // ── leaving ───────────────────────────────────────────────────────────────
    // An e-prescription login or send mid-flight is the one piece of unsaved work
    // on this screen (§5.2: an overlay with unsaved input asks before it closes).
    // Every exit path funnels through here — the footer, Esc, the scrim and the
    // platform back button — so none of them can quietly abandon an OTP the
    // doctor is halfway through typing.
    const guardedExit = (0, $acw62.useCallback)((run)=>{
        if (erxBusy) {
            setLeaveConfirm(()=>run);
            return;
        }
        run();
    }, [
        erxBusy
    ]);
    const exit = (0, $acw62.useCallback)(()=>guardedExit(onExit), [
        guardedExit,
        onExit
    ]);
    const viewRecord = (0, $acw62.useCallback)(()=>guardedExit(onViewRecord), [
        guardedExit,
        onViewRecord
    ]);
    // Back closes the RECEIPT, not the route behind it. The receipt is safe to
    // re-enter: the encounter is already final when it opens and every action on
    // it is idempotent.
    (0, $9BgRG.default)(true, exit, {
        id: 'visit-closure'
    });
    const handlePrint = (0, $acw62.useCallback)(()=>{
        const template = prescriptionTemplates.find((x)=>x.id === tplId) || null;
        const ok = (0, $375f8776645d5aee$export$e57f8733307287ae)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
        // A blocked popup is silent in every browser; without this the doctor
        // presses «چاپ» and concludes the app is broken.
        if (ok === false) toast?.error?.(t('visit.rx.printBlocked'));
    }, [
        prescriptionTemplates,
        tplId,
        rxItems,
        pendingTests,
        diagnosis,
        soap,
        doctor,
        patient,
        t,
        toast
    ]);
    const handleRetry = (0, $acw62.useCallback)(async ()=>{
        const allSaved = await onRetryFailed?.();
        if (allSaved) toast?.success?.(t('visit.end.retrySucceeded'));
        else toast?.error?.(t('visit.end.retryPartial'));
    }, [
        onRetryFailed,
        toast,
        t
    ]);
    const failedDrugs = failedGroups[(0, $be5cdb537ae81129$export$2b9b886dddb4ba32).DRUG] || 0;
    const body = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5a45f32ddaf989a5$export$2e2bcd8739ae039), {
            failures: saveFailures,
            onRetry: handleRetry,
            retrying: retrying
        }), state === 'empty' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "neutral",
            style: {
                alignItems: 'flex-start',
                marginBottom: '1rem'
            },
            "data-testid": "visit-closure-empty"
        }, t('visit.closure.emptyVisitBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr))',
                gap: '0.75rem',
                alignItems: 'stretch'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a43bdf6bf7b450a$export$2e2bcd8739ae039), {
            soap: soap,
            diagnosis: diagnosis,
            accepted: acceptedDifferential,
            failedCount: failedGroups[(0, $be5cdb537ae81129$export$2b9b886dddb4ba32).DIAGNOSIS] || 0,
            expanded: expanded.dx,
            onToggle: ()=>toggle('dx')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3f321e934a2c42ad$export$2e2bcd8739ae039), {
            rxItems: rxItems,
            failedCount: failedDrugs,
            expanded: expanded.rx,
            onToggle: ()=>toggle('rx')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $915e51e033df3655$export$2e2bcd8739ae039), {
            pendingTests: pendingTests,
            failedCount: failedGroups[(0, $be5cdb537ae81129$export$2b9b886dddb4ba32).ORDERS] || 0,
            expanded: expanded.orders,
            onToggle: ()=>toggle('orders')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $62be6e4f8a045166$export$2e2bcd8739ae039), {
            soap: soap,
            failedCount: failedGroups[(0, $be5cdb537ae81129$export$2b9b886dddb4ba32).SOAP] || 0,
            expanded: expanded.soap,
            onToggle: ()=>toggle('soap')
        })), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f632729d4a10d2cf$export$2e2bcd8739ae039), {
            appointmentId: appointmentId,
            patientId: patient.id
        })), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccba15c4d511e83$export$2e2bcd8739ae039), {
            appointmentId: appointmentId,
            patientId: patient.id,
            onBusyChange: setErxBusy,
            compactWhenSettled: true
        }))), [
        saveFailures,
        handleRetry,
        retrying,
        state,
        t,
        soap,
        diagnosis,
        acceptedDifferential,
        failedGroups,
        failedDrugs,
        expanded,
        toggle,
        rxItems,
        pendingTests,
        appointmentId,
        patient,
        iranianRails
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (open)=>{
            if (!open) exit();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "xl",
        layout: "frame",
        showClose: false,
        "data-testid": "visit-closure",
        "data-state": retrying ? 'retrying' : state,
        "data-view": view,
        onEscapeKeyDown: (e)=>{
            // Esc in the preview means "back to the receipt", not "leave the
            // visit". It is the only place this dialog intercepts the key.
            if (view === 'print') {
                e.preventDefault();
                setView('review');
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $858d5203ed82f22a$export$652305dc8151bb22), {
        onBack: ()=>setView('review')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e85a01c372dd00b8$export$2e2bcd8739ae039), {
        state: state,
        patient: patient,
        endedAt: endedAt,
        durationMin: durationMin,
        coins: coins
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $858d5203ed82f22a$export$2e2bcd8739ae039), {
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        prescriptionTemplates: prescriptionTemplates,
        selectedTplId: tplId,
        onSelectTemplate: setTplId
    }) : body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $858d5203ed82f22a$export$515831587eb72291), {
        onBack: ()=>setView('review'),
        onPrint: handlePrint
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, canPrint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: ()=>setView('print'),
        disabled: retrying,
        className: "gap-1.5",
        "data-testid": "visit-closure-print"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('visit.rx.print')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: viewRecord,
        disabled: retrying,
        "data-testid": "visit-closure-view-record"
    }, t('visit.closure.viewRecord')), partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: handleRetry,
        disabled: retrying,
        className: "gap-1.5",
        "data-testid": "visit-closure-primary"
    }, retrying && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "currentColor",
        label: ""
    }), t('visit.end.retryFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: exit,
        disabled: retrying,
        "data-testid": "visit-closure-exit"
    }, t('visit.closure.backToReception'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: exit,
        autoFocus: true,
        className: "gap-1.5",
        "data-testid": "visit-closure-primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('visit.closure.backToReception')))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: !!leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-closure-leave-ok",
        cancelTestId: "visit-closure-leave-cancel",
        "data-testid": "visit-closure-leave-confirm",
        onConfirm: ()=>{
            const run = leaveConfirm;
            setLeaveConfirm(null);
            run?.();
        }
    }));
}


// The copilot composer grows with the question up to this height (≈6 lines at
// 12.5px/1.6 plus the field's own block padding), then scrolls inside itself
// rather than eating the conversation above it.
const $9b4ee9e6346f75da$var$ASK_MAX_H = 126;
// سوابق ویزیت‌های قبلی — how deep each surface goes. The rail is a preview: it
// competes for height with allergies, vitals, meds, diagnoses and labs in a
// column that already overflows, so it shows three and defers the rest to the
// sheet. The sheet's cap is what one patient's history is allowed to cost.
const $9b4ee9e6346f75da$var$VISIT_HISTORY_PREVIEW = 3;
const $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX = 12;
// Diagnosis chips that fit a 340px rail row before the «+N» rollup takes over.
const $9b4ee9e6346f75da$var$RAIL_DX_CHIPS = 2;
// ─────────────────────────────────────────────────────────────────────────────
// SoapPlanPanel — the AI treatment plan, docked under the SOAP «P» editor.
//
// The plan's prose already went into the P field when it was generated; what
// lives here is everything that is NOT prose: the interaction warnings, the
// structured items the doctor ticks off, and the clinical rationale. Confirming
// persists the ticked items and files the P text as the visit's treatment plan.
// ─────────────────────────────────────────────────────────────────────────────
const $9b4ee9e6346f75da$var$PLAN_GROUPS = (t, s)=>[
        {
            key: 'med',
            title: t('visit.rx.medications'),
            items: s.medications || [],
            nameOf: (m)=>m.name,
            reasonOf: (m, tt)=>[
                    m.dosage,
                    m.frequency,
                    m.duration ? tt('visit.text.forDuration', {
                        duration: m.duration
                    }) : '',
                    m.notes
                ].filter(Boolean).join(" \u2022 ")
        },
        {
            key: 'lab',
            title: t('visit.orders.tests'),
            items: s.labTests || [],
            nameOf: (x)=>x.testName,
            reasonOf: (x)=>x.reason
        },
        {
            key: 'imaging',
            title: t('visit.orders.imaging'),
            items: s.imagingStudies || [],
            nameOf: (x)=>x.studyType,
            reasonOf: (x)=>[
                    x.bodyPart,
                    x.reason
                ].filter(Boolean).join(" \u2014 ")
        },
        {
            key: 'procedure',
            title: t('visit.orders.paraclinical'),
            items: s.procedureOrders || [],
            nameOf: (x)=>x.name,
            reasonOf: (x)=>x.reason
        }
    ];
function $9b4ee9e6346f75da$var$SoapPlanPanel({ suggestion: suggestion, loading: loading, saving: saving, status: status, error: error, selected: selected, planKey: planKey, onToggle: onToggle, onConfirm: onConfirm, onRegenerate: onRegenerate, onClose: onClose, onRestore: onRestore, canRestore: canRestore, canGenerate: canGenerate }) {
    const { t: t } = (0, $LNQP4.default)();
    const confirmed = status === 'confirmed';
    const totalItems = suggestion ? $9b4ee9e6346f75da$var$PLAN_GROUPS(t, suggestion).reduce((n, g)=>n + g.items.length, 0) : 0;
    const dropped = suggestion ? totalItems - selected.size : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-panel",
        style: {
            marginTop: 8,
            borderRadius: 10,
            border: '1px solid oklch(0.87 0.06 290)',
            background: 'oklch(0.985 0.008 290)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderBottom: '1px solid oklch(0.90 0.04 290)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'oklch(0.38 0.14 290)',
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: 'oklch(0.38 0.14 290)'
        }
    }, t('credits.price.plan')), confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-plan-status",
        style: {
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--good-soft)',
            color: 'var(--good-ink)'
        }
    }, t('visit.state.confirmedAdj')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, t('visit.plan.basis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-close",
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            border: 'none',
            background: 'none',
            color: 'var(--mute)',
            cursor: 'pointer',
            padding: 2,
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 11,
        height: 11
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 12
        }
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-error",
        style: {
            marginBottom: 10,
            padding: '8px 10px',
            borderRadius: 7,
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger)',
            color: 'var(--danger-ink)',
            fontSize: 11.5
        }
    }, error), canRestore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '7px 10px',
            borderRadius: 7,
            background: 'var(--warn-soft)',
            border: '1px solid var(--warn)',
            fontSize: 11,
            color: 'var(--warn-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t('visit.plan.replacedNotice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-restore",
        onClick: onRestore,
        style: {
            border: '1px solid var(--warn)',
            background: 'var(--panel-2)',
            color: 'var(--warn-ink)',
            borderRadius: 6,
            padding: '3px 8px',
            fontSize: 10.5,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('visit.plan.restorePrevious'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 9,
            padding: '22px 0',
            color: 'var(--mute)',
            fontSize: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 13,
            height: 13,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.plan.generating')), !suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '14px 8px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: 'var(--mute)',
            lineHeight: 1.9,
            marginBottom: 12
        }
    }, t('visit.plan.explainer')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-generate",
        onClick: onRegenerate,
        disabled: !canGenerate,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontSize: 12.5,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: canGenerate ? 'pointer' : 'not-allowed',
            opacity: canGenerate ? 1 : 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 12,
        height: 12
    }), t('visit.plan.generate')), !canGenerate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute-2)',
            marginTop: 8
        }
    }, t('visit.plan.needsOpenVisit'))), suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suggestion.interactionWarnings?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 12
        }
    }, suggestion.interactionWarnings.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,
                padding: '8px 10px',
                marginBottom: 5,
                borderRadius: 7,
                background: ((0, $375f8776645d5aee$export$ee258ff23bc0049f)[w.severity] || (0, $jTCZr.C).amber) + '14',
                border: `1px solid ${(0, $375f8776645d5aee$export$ee258ff23bc0049f)[w.severity] || (0, $jTCZr.C).amber}44`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9.5,
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $375f8776645d5aee$export$ee258ff23bc0049f)[w.severity] || (0, $jTCZr.C).amber,
                color: '#fff',
                flexShrink: 0
            }
        }, (0, $375f8776645d5aee$export$236de8c7b98b7ff0)(t)[w.severity] || w.severity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: 'var(--ink)',
                lineHeight: 1.6
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
            style: {
                marginInlineEnd: 4
            }
        }, w.drugPair, ":"), w.description)))), $9b4ee9e6346f75da$var$PLAN_GROUPS(t, suggestion).filter((g)=>g.items.length > 0).map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: group.key,
            "data-testid": `visit-plan-group-${group.key}`,
            style: {
                marginBottom: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11.5,
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, group.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9.5,
                background: 'var(--line)',
                color: 'var(--ink-2)',
                padding: '1px 6px',
                borderRadius: 4,
                fontWeight: 700
            }
        }, group.items.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, group.items.map((item, i)=>{
            const name = group.nameOf(item);
            const key = planKey(group.key, name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$a36149ed7c50a677), {
                key: `${key}-${i}`,
                item: {
                    key: key,
                    name: name,
                    reason: group.reasonOf(item, t),
                    urgency: item.urgency,
                    loincCode: item.loincCode,
                    modality: item.modality
                },
                selected: selected.has(key),
                onToggle: onToggle,
                showLoinc: group.key === 'lab'
            });
        })))), suggestion.clinicalRationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 12,
            padding: '9px 11px',
            borderRadius: 7,
            background: 'var(--bg)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            fontWeight: 600,
            color: 'var(--mute)',
            marginBottom: 3
        }
    }, t('visit.copilot.clinicalRationale')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, suggestion.clinicalRationale)), dropped > 0 && !confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-drift",
        style: {
            marginBottom: 10,
            fontSize: 10.5,
            color: 'var(--warn-ink)',
            background: 'var(--warn-soft)',
            border: '1px solid var(--warn)',
            borderRadius: 7,
            padding: '7px 10px',
            lineHeight: 1.7
        }
    }, t('visit.plan.editNoteHint', {
        count: dropped
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-apply",
        onClick: onConfirm,
        disabled: saving || confirmed,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            background: confirmed ? 'var(--line)' : 'var(--accent)',
            color: confirmed ? 'var(--mute)' : '#fff',
            fontSize: 12.5,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: saving || confirmed ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.7 : 1
        }
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 10,
            height: 10,
            border: '2px solid #ffffff55',
            borderTopColor: '#fff',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), confirmed ? t('visit.plan.approved') : t('visit.plan.confirmWithCount', {
        count: selected.size
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-regen",
        onClick: onRegenerate,
        disabled: loading || saving,
        style: {
            padding: '8px 12px',
            borderRadius: 8,
            border: '1px solid var(--line)',
            background: 'none',
            color: 'var(--mute)',
            fontSize: 11.5,
            fontFamily: 'inherit',
            cursor: loading || saving ? 'not-allowed' : 'pointer'
        }
    }, t('visit.plan.regenerateIcon'))))));
}
// ── Work-tab section vocabulary ────────────────────────────────────────────────
// The SEC_* card/head/title/icon/field vocabulary now lives in Visit.shared.js
// (imported above) so the shared order forms render the exact same language as
// the encounter-order form here. Used by all four work tabs, not orders alone.
// ─────────────────────────────────────────────────────────────────────────────
// سوابق ویزیت‌های قبلی — previous-visit history
//
// Two surfaces over one cache. The RAIL row answers "what happened last time?"
// without a click: date, the diagnoses, and how many drugs and orders came out
// of it. The SHEET answers "what exactly?" — every diagnosis, every drug with
// its dosage, every order with its state, and the visit summary — for all
// visits at once, so the doctor compares rather than pogo-sticks.
//
// The rail deliberately does NOT expand in place. Its column already scrolls
// past the viewport with allergies, vitals, meds, diagnoses and labs above it;
// an accordion there buries the sections below whichever visit is open.
// ─────────────────────────────────────────────────────────────────────────────
const $9b4ee9e6346f75da$var$HIST_CHIP = {
    fontSize: 10.5,
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: 5,
    background: 'var(--accent-soft)',
    color: 'var(--accent-ink)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
};
const $9b4ee9e6346f75da$var$HIST_COUNT = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    fontSize: 10.5,
    color: 'var(--mute)',
    whiteSpace: 'nowrap'
};
const $9b4ee9e6346f75da$var$HIST_SECTION_LABEL = {
    fontSize: 10,
    fontWeight: 700,
    color: 'var(--mute-2)',
    letterSpacing: '.06em',
    marginBottom: 6
};
/** «۳ دارو · ۲ دستور» — the counts that make a row worth opening. */ function $9b4ee9e6346f75da$var$VisitCountStrip({ medCount: medCount, orderCount: orderCount }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!medCount && !orderCount) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginTop: 5
        }
    }, medCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $9b4ee9e6346f75da$var$HIST_COUNT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).pill, {
        width: 11,
        height: 11
    }), t('visit.history.drugCount', {
        count: medCount
    })), orderCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $9b4ee9e6346f75da$var$HIST_COUNT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).notes, {
        width: 11,
        height: 11
    }), t('visit.history.orderCount', {
        count: orderCount
    })));
}
// «تکمیل نحوه مصرف» is hidden for now (PM-0096, owner's call 2026-10-05). The
// button, its handler and its price row all stay; flip this to show it again.
const $9b4ee9e6346f75da$var$SHOW_RX_DIRECTIONS = false;
/**
 * «اصلاح نسخه» on a past visit still inside its month (K1, 2026-10-04) — opens
 * the RxCorrectionSheet for that visit. A `span role="button"` for the reason
 * ReprescribePicker's trigger is one: the rail row it sits in is itself a button.
 * Styled as that trigger, beside which it sits.
 */ function $9b4ee9e6346f75da$var$RxCorrectAction({ onOpen: onOpen, title: title, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const open = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        onOpen();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "button",
        tabIndex: 0,
        onClick: open,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') open(e);
        },
        title: title,
        "data-testid": testid,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            padding: '3px 8px',
            borderRadius: 6,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).accentInk,
            fontSize: 10.5,
            fontWeight: 700,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).edit, {
        width: 11,
        height: 11
    }), t('visit.rxCorrection.action'));
}
/**
 * One rail row. Whole card is the button — a 340px row has no space for a
 * separate affordance, and the entire row meaning "open this visit" is less to
 * learn than a chevron that means it.
 *
 * `onCorrect` — «اصلاح نسخه», offered only while the visit is inside its month.
 */ function $9b4ee9e6346f75da$var$VisitHistoryRow({ visit: visit, ctx: ctx, summary: summary, onOpen: onOpen, onReprescribe: onReprescribe, onCorrect: onCorrect, prescribedNames: prescribedNames, allergies: allergies }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime } = (0, $LNQP4.default)();
    const data = ctx?.state === 'ready' ? ctx.data : null;
    const failed = ctx?.state === 'error';
    const busy = !ctx || ctx.state === 'loading';
    const dx = (0, $375f8776645d5aee$export$33b3781481f6ac85)(data, summary);
    const meds = data?.medications || [];
    const orders = data?.orders || [];
    const shown = dx.slice(0, $9b4ee9e6346f75da$var$RAIL_DX_CHIPS);
    const rest = dx.length - shown.length;
    const dateLabel = visit.scheduledDate ? formatDate(visit.scheduledDate, 'medium') : '';
    const timeLabel = visit.scheduledDate ? formatTime(visit.scheduledDate) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onOpen(visit.id),
        title: t('visit.history.openDetails', {
            date: dateLabel
        }),
        style: {
            width: '100%',
            textAlign: 'start',
            fontFamily: 'inherit',
            cursor: 'pointer',
            padding: '9px 11px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            display: 'block'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            flexShrink: 0,
            alignSelf: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, dateLabel), timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute)'
        }
    }, timeLabel), visit.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            color: 'var(--mute-2)',
            marginInlineStart: 'auto'
        }
    }, formatRelativeTime(visit.scheduledDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 5,
            marginInlineStart: 12
        }
    }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 11
    }) : failed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute)'
        }
    }, t('visit.history.loadFailed')) : shown.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4
        }
    }, shown.map((label, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: $9b4ee9e6346f75da$var$HIST_CHIP
        }, label)), rest > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_CHIP,
            background: 'var(--panel)',
            color: 'var(--mute)',
            border: '1px solid var(--line)'
        }
    }, t('visit.history.more', {
        count: rest
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute-2)'
        }
    }, t('visit.history.noDiagnoses')), (!busy && !failed || onCorrect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, !busy && !failed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitCountStrip, {
        medCount: meds.length,
        orderCount: orders.length
    })), !busy && !failed && onReprescribe && meds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b69acda6ae3622c4$export$2e2bcd8739ae039), {
        meds: meds,
        title: t('visit.rx.represcribeFromVisit', {
            date: dateLabel
        }),
        onApply: onReprescribe,
        prescribedNames: prescribedNames,
        allergies: allergies,
        testid: "history-row-represcribe"
    }), onCorrect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RxCorrectAction, {
        onOpen: onCorrect,
        title: t('visit.rxCorrection.title', {
            date: dateLabel
        }),
        testid: "history-row-rx-correct"
    }))));
}
/** A titled group inside the sheet; renders its own empty line rather than vanishing. */ function $9b4ee9e6346f75da$var$VisitDetailGroup({ icon: Icon, title: title, empty: empty, children: children, count: count }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_SECTION_LABEL,
            display: 'flex',
            alignItems: 'center',
            gap: 5
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 11,
        height: 11
    }), title, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 400,
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '1px 6px',
            borderRadius: 99
        }
    }, count)), count > 0 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: 'var(--mute-2)',
            fontStyle: 'italic'
        }
    }, empty));
}
/** Everything one past visit holds — the sheet's body for a single encounter. */ function $9b4ee9e6346f75da$var$VisitDetailBody({ ctx: ctx, summary: summary, onReprescribe: onReprescribe, prescribedNames: prescribedNames }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const orderName = (0, $375f8776645d5aee$export$891bfbeed44ddfce)((ctx?.data?.orders || []).map((o)=>o.description));
    if (!ctx || ctx.state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$785af5d3304b5931), null);
    if (ctx.state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--danger)'
        }
    }, t('visit.history.loadFailed'));
    const data = ctx.data || {};
    const conds = data.conditions || [];
    const meds = data.medications || [];
    const orders = data.orders || [];
    const gist = (0, $375f8776645d5aee$export$e60dc5b789daafad)(data);
    const summaryText = summary?.summary || gist;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).sparkle,
        title: t('visit.history.diagnoses'),
        empty: t('visit.history.noDiagnoses'),
        count: conds.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, conds.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: c.id,
            style: {
                ...$9b4ee9e6346f75da$var$HIST_CHIP,
                fontSize: 11.5,
                padding: '3px 9px'
            }
        }, c.display || c.code, c.code && c.display && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontFamily: 'monospace',
                fontWeight: 400,
                opacity: .7,
                marginInlineStart: 5
            }
        }, c.code))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
        title: t('visit.history.medications'),
        empty: t('visit.history.noMedications'),
        count: meds.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, meds.map((m)=>{
        const added = prescribedNames?.has((m.display || m.code || '').trim().toLowerCase());
        const medName = (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, medName), m.dosageInstruction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                color: 'var(--mute)'
            }
        }, (0, $375f8776645d5aee$export$f1536cfec6e3f4b8)(typeof m.dosageInstruction === 'string' ? m.dosageInstruction : m.dosageInstruction.text, t, readsPersianData))), onReprescribe && (added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "history-med-represcribed",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 10.5,
                fontWeight: 700,
                color: 'var(--good)',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
            width: 11,
            height: 11
        }), " ", t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>onReprescribe(m),
            "data-testid": "history-med-represcribe",
            "aria-label": t('visit.rx.represcribeAria', {
                name: m.display || m.code
            }),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0,
                fontSize: 10.5,
                fontWeight: 700,
                fontFamily: 'inherit',
                cursor: 'pointer',
                padding: '3px 8px',
                borderRadius: 6,
                border: '1px solid var(--line)',
                background: 'var(--panel)',
                color: 'var(--accent-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).reload, {
            width: 11,
            height: 11
        }), " ", t('visit.rx.represcribe'))));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).notes,
        title: t('visit.history.orders'),
        empty: t('visit.history.noOrders'),
        count: orders.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, orders.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: o.id,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                fontWeight: 700,
                color: 'var(--mute)',
                flexShrink: 0
            }
        }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[o.orderType] || o.orderType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                color: 'var(--ink)',
                flex: 1,
                minWidth: 0
            }
        }, orderName(o.description)), o.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9.5,
                padding: '1px 6px',
                borderRadius: 4,
                flexShrink: 0,
                background: 'var(--line-2)',
                color: 'var(--mute)'
            }
        }, o.status === 'completed' ? t('common.state.completed') : o.status === 'cancelled' ? t('common.state.cancelled') : o.status === 'in_progress' ? t('common.state.inProgress') : t('common.state.pending')))))), summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.history.summary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, summaryText), summary?.icdCodes?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            marginTop: 7
        }
    }, summary.icdCodes.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: 10,
                padding: '2px 7px',
                borderRadius: 5,
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                color: 'var(--mute)',
                fontFamily: 'monospace'
            }
        }, c.code, c.description ? ` \xb7 ${c.description}` : '')))));
}
/**
 * The full-history sheet.
 *
 * Anchored to the inline-start edge — the same side the record panel lives on
 * under `dir="rtl"` — so it opens next to the rail row that was clicked and
 * leaves the work area visible for comparison against the visit in progress.
 * Hand-rolled rather than the framework `Drawer`, which is `position:absolute`
 * and hard-pinned to the physical left edge.
 */ function $9b4ee9e6346f75da$var$VisitHistorySheet({ visits: visits, ctxById: ctxById, summaryMap: summaryMap, expandedId: expandedId, onExpand: onExpand, onClose: onClose, onReprescribe: onReprescribe, onReprescribeMany: onReprescribeMany, onLoadContext: onLoadContext, prescribedNames: prescribedNames, allergies: allergies, canCorrect: canCorrect, onCorrect: onCorrect }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime, formatList: formatList } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": t('visit.history.sheetTitle'),
        "data-testid": "visit-history-sheet",
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(560px, 94vw)',
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).history, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13.5,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, t('visit.history.sheetTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '2px 8px',
            borderRadius: 99
        }
    }, t('visit.history.visitCount', {
        count: visits.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '10px 16px 20px'
        }
    }, visits.map((v)=>{
        const isOpen = expandedId === v.id;
        const summary = summaryMap.get(String(v.id));
        const ctx = ctxById[v.id];
        const data = ctx?.state === 'ready' ? ctx.data : null;
        const dateLabel = v.scheduledDate ? formatDate(v.scheduledDate, 'medium') : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id,
            style: {
                borderBottom: '1px solid var(--line-2)',
                paddingBottom: isOpen ? 12 : 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>onExpand(isOpen ? null : v.id),
            "aria-expanded": isOpen,
            style: {
                width: '100%',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                padding: '11px 2px',
                display: 'flex',
                alignItems: 'center',
                gap: 9,
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 16 16",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            style: {
                width: 13,
                height: 13,
                color: 'var(--mute)',
                flexShrink: 0,
                transform: isOpen ? 'rotate(90deg)' : 'none',
                transition: 'transform .2s'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M5 3l5 5-5 5"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12.5,
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, dateLabel), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10.5,
                color: 'var(--mute)'
            }
        }, formatTime(v.scheduledDate))), !isOpen && data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: 'var(--mute)',
                marginTop: 2,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, formatList((0, $375f8776645d5aee$export$33b3781481f6ac85)(data, summary)) || t('visit.history.noDiagnoses'))), onReprescribeMany && ctx?.state !== 'error' && !(data && !(data.medications || []).length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b69acda6ae3622c4$export$2e2bcd8739ae039), {
            meds: data?.medications || [],
            state: data ? 'ready' : 'loading',
            title: t('visit.rx.represcribeFromVisit', {
                date: dateLabel
            }),
            onOpen: ()=>onLoadContext?.(v.id),
            onApply: onReprescribeMany,
            prescribedNames: prescribedNames,
            allergies: allergies,
            testid: "history-sheet-represcribe"
        }), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                color: 'var(--mute-2)',
                flexShrink: 0
            }
        }, formatRelativeTime(v.scheduledDate))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                paddingInlineStart: 22,
                animation: 'fadeUp .18s ease'
            }
        }, onCorrect && canCorrect?.(v) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onCorrect(v),
            title: t('visit.rxCorrection.title', {
                date: dateLabel
            }),
            "data-testid": "history-sheet-rx-correct",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                fontFamily: 'inherit',
                cursor: 'pointer',
                padding: '4px 10px',
                borderRadius: 7,
                border: `1px solid ${(0, $jTCZr.CT).accent}`,
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk,
                fontSize: 11.5,
                fontWeight: 700
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).edit, {
            width: 12,
            height: 12
        }), t('visit.rxCorrection.action'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailBody, {
            ctx: ctx,
            summary: summary,
            onReprescribe: onReprescribe,
            prescribedNames: prescribedNames
        })));
    }))));
}
// ── پرونده بیمار — collapsible context-panel sections ────────────────────────
//
// Every section of the record column speaks one header grammar: title, count
// pill, a one-line gist of the content, optional inline actions, and the
// chevron. The gist renders only while the section is CLOSED, so a collapsed
// section still tells the doctor what it holds without re-opening it. Open
// state persists per section in localStorage, so the layout a doctor arranges
// (labs collapsed, vitals open) survives reloads and carries to the next visit.
//
// Long lists never grow in place — beyond the preview cap they open in a
// RecordListSheet, the same inline-start sheet the visit history uses (§5.2:
// contextual detail beside a list you must not lose), so the work area and the
// rest of the record stay visible underneath.
// ─────────────────────────────────────────────────────────────────────────────
// Preview caps for the record rail — beyond these the section opens its sheet.
/** Where the record column's open/closed choice is remembered, per browser (PM-0035). Unset = the screen-size default. */ const $9b4ee9e6346f75da$var$RECORD_OPEN_KEY = 'parsina.visit.record.open';
/** After this many dismissals in one visit the dock's nudge stays quiet (PM-0048). */ const $9b4ee9e6346f75da$var$NUDGE_MAX_DISMISSALS = 2;
const $9b4ee9e6346f75da$var$RECORD_PREVIEW = {
    meds: 6,
    dx: 6,
    conds: 8,
    labs: 10,
    files: 3
};
// ── The visit dock — «پرونده» and «دستیار» in ONE strip (PM-0048) ─────────────
//
// The two side panels used to fold to two rails on opposite edges of the page.
// They now share a single strip at the inline-start that is always there, open
// or closed, so each panel has one button in one place:
//
//   · «پرونده» first — the record is what the doctor works from; its panel
//     opens right beside the dock.
//   · «دستیار» second — with a count of what it is holding, so a closed
//     assistant still says it has something.
//   · «نسخه» third — «ارسال به بیمه» (PM-0152, K1 2026-10-12): it opens the
//     e-prescription panel for the whole visit, and replaces the نسخه and
//     دستورات headers' own send buttons. An amber dot when a registered
//     prescription has changes a correction can still carry. Only where the
//     visit offers an Iranian insurer at all (erxAvailable).
//   · the NUDGE: when the assistant is closed and something NEW arrived
//     (differentials after the history is written, a clinical note after
//     vitals), one small card beside its button says what, and «مشاهده» opens
//     that tab. It appears once per arrival, never on a timer, never loops, and
//     after two dismissals in a visit it stays quiet — the count remains.
//   · what must survive a closed record: the allergy alert (a safety signal,
//     not reference material) and the way to a video visit.
//
// The mic / «پایش بالینی» is NOT here: it lives in the page's top bar.
// The dock's two tones in CT tokens (PM-0154). The page's own `var(--primary)` /
// `var(--accent)` lose to tokens.css `:root[data-panel]`, which makes them bare HSL
// triples — an invalid colour — so a pressed «پرونده» or «نسخه» had no border, no
// tint and black text, looked unpressed, and jumped 2 px when toggled.
const $9b4ee9e6346f75da$var$DOCK_TONE = {
    primary: {
        line: (0, $jTCZr.CT).navy,
        tint: (0, $jTCZr.soft)((0, $jTCZr.CT).navy, 0.1),
        ink: (0, $jTCZr.CT).navy
    },
    accent: {
        line: (0, $jTCZr.CT).accent,
        tint: (0, $jTCZr.CT).accentSoft,
        ink: (0, $jTCZr.CT).accentInk
    }
};
const $9b4ee9e6346f75da$export$5ba9ea9124f78b58 = (on, tone)=>{
    const c = $9b4ee9e6346f75da$var$DOCK_TONE[tone] || $9b4ee9e6346f75da$var$DOCK_TONE.primary;
    return {
        position: 'relative',
        width: 44,
        padding: '8px 0 6px',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        border: `1px solid ${on ? c.line : 'transparent'}`,
        background: on ? c.tint : 'transparent',
        color: c.ink,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 10,
        fontWeight: 600
    };
};
function $9b4ee9e6346f75da$export$cccda98cbc9f2aa5({ t: t, formatNumber: formatNumber, recordOpen: recordOpen, recordLocked: recordLocked, onToggleRecord: onToggleRecord, copilotOpen: copilotOpen, copilotLocked: copilotLocked, onToggleCopilot: onToggleCopilot, copilotCount: copilotCount, allergyCount: allergyCount, allergyTitle: allergyTitle, showCall: showCall, lowBalance: lowBalance, onOpenRecord: onOpenRecord, onOpenCopilot: onOpenCopilot, nudge: nudge, onNudgeView: onNudgeView, onNudgeDismiss: onNudgeDismiss, erxAvailable: erxAvailable = false, erxOpen: erxOpen = false, onToggleErx: onToggleErx, erxPendingCount: erxPendingCount = 0, canBuyCredits: canBuyCredits = true }) {
    // The low-balance button opens the copilot, where the strip offers «شارژ
    // اعتبار» — or, where credit is not sold here, only says the balance is low.
    const lowBalanceLabel = canBuyCredits ? t('credits.topUp') : t('credits.level.low');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "data-testid": "visit-dock",
        "aria-label": t('visit.panel.dock'),
        style: {
            gridRow: 2,
            gridColumn: 1,
            position: 'relative',
            zIndex: 5,
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            padding: '12px 0',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: recordLocked ? undefined : onToggleRecord,
        "data-testid": "visit-dock-record",
        "aria-pressed": recordOpen,
        "aria-label": recordOpen ? t('visit.panel.foldRecord') : t('visit.panel.openRecord'),
        title: recordOpen ? t('visit.panel.foldRecord') : t('visit.panel.openRecord'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(recordOpen, 'primary')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).doc, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.panel.recordShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: copilotLocked ? undefined : onToggleCopilot,
        "data-testid": "visit-dock-copilot",
        "aria-pressed": copilotOpen,
        "aria-label": copilotOpen ? t('visit.copilot.fold') : t('visit.copilot.open'),
        title: copilotOpen ? t('visit.copilot.fold') : t('visit.copilot.open'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(copilotOpen, 'accent')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.copilot.assistant')), !copilotOpen && copilotCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-dock-copilot-count",
        style: {
            position: 'absolute',
            top: -6,
            insetInlineEnd: -5,
            minWidth: 17,
            height: 17,
            padding: '0 4px',
            borderRadius: 9,
            background: 'var(--accent-ink)',
            color: '#fff',
            fontSize: 9.5,
            fontWeight: 700,
            display: 'grid',
            placeItems: 'center',
            lineHeight: 1
        }
    }, formatNumber(copilotCount))), erxAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggleErx,
        "data-testid": "visit-dock-erx",
        "aria-pressed": erxOpen,
        "aria-label": erxOpen ? t('visit.erx.dock.fold') : t('visit.erx.dock.open'),
        title: erxOpen ? t('visit.erx.dock.fold') : t('visit.erx.dock.open'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(erxOpen, 'primary')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).send, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.erx.dock.label')), erxPendingCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "visit-dock-erx-pending",
        style: {
            position: 'absolute',
            top: -3,
            insetInlineEnd: -2,
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).warn
        }
    })), !recordOpen && allergyCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenRecord,
        "data-testid": "visit-dock-allergy",
        "aria-label": allergyTitle,
        title: allergyTitle,
        style: {
            position: 'relative',
            width: 40,
            height: 40,
            borderRadius: 8,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            marginTop: 4,
            border: '1px solid var(--danger)',
            background: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 16,
        height: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: -6,
            insetInlineEnd: -6,
            minWidth: 17,
            height: 17,
            padding: '0 4px',
            borderRadius: 9,
            background: 'var(--danger)',
            color: '#fff',
            fontSize: 9.5,
            fontWeight: 700,
            display: 'grid',
            placeItems: 'center',
            lineHeight: 1
        }
    }, formatNumber(allergyCount))), !recordOpen && showCall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenRecord,
        "data-testid": "visit-dock-call",
        "aria-label": t('visit.panel.recordCall'),
        title: t('visit.panel.recordCall'),
        style: {
            width: 40,
            padding: '7px 0 5px',
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            border: '1px solid var(--accent)',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 9.5,
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            display: 'inline-block'
        }
    }), t('visit.panel.recordCallShort')), !copilotOpen && lowBalance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenCopilot,
        "data-testid": "visit-dock-lowbalance",
        "aria-label": lowBalanceLabel,
        title: lowBalanceLabel,
        style: {
            width: 28,
            height: 28,
            borderRadius: 7,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            border: '1px solid var(--warn)',
            background: 'var(--warn-soft)',
            color: 'var(--warn-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 13,
        height: 13
    })), nudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-dock-nudge",
        role: "status",
        style: {
            position: 'absolute',
            insetInlineStart: 'calc(100% + 8px)',
            top: 70,
            width: 250,
            background: 'var(--panel)',
            border: '1px solid var(--accent)',
            borderRadius: 10,
            boxShadow: 'var(--shadow-pop)',
            padding: '10px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            animation: 'fadeUp .22s ease both'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 13,
        height: 13
    }), t('visit.copilot.title'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onNudgeDismiss,
        "data-testid": "visit-dock-nudge-dismiss",
        "aria-label": t('visit.panel.nudgeDismiss'),
        title: t('visit.panel.nudgeDismiss'),
        style: {
            marginInlineStart: 'auto',
            width: 22,
            height: 22,
            display: 'grid',
            placeItems: 'center',
            border: 'none',
            background: 'transparent',
            color: 'var(--mute)',
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 12,
        height: 12
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            fontWeight: 600,
            color: 'var(--ink)',
            lineHeight: 1.7
        }
    }, t(nudge.kind === 'diff' ? 'visit.panel.nudgeDiff' : 'visit.panel.nudgeSugg', {
        count: formatNumber(nudge.count)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onNudgeView,
        "data-testid": "visit-dock-nudge-view",
        style: {
            alignSelf: 'flex-start',
            padding: '4px 12px',
            borderRadius: 8,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 600,
            border: '1px solid var(--accent-ink)',
            background: 'var(--accent-ink)',
            color: '#fff'
        }
    }, t('visit.panel.nudgeView'))));
}
function $9b4ee9e6346f75da$var$RecordSection({ id: id, icon: Icon, title: title, count: count, badge: badge, gist: gist, actions: actions, open: open, onToggle: onToggle, tone: tone, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const danger = tone === 'danger';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `record-section-${id}`,
        style: {
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onToggle(id),
        "aria-expanded": open,
        "data-testid": `record-toggle-${id}`,
        title: open ? t('visit.recordPanel.collapseSection', {
            title: title
        }) : t('visit.recordPanel.expandSection', {
            title: title
        }),
        style: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '11px 16px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7
        }
    }, danger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: 'var(--danger)',
            color: '#fff',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 9,
        height: 9
    })) : Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 13,
        height: 13,
        style: {
            color: 'var(--mute)',
            flexShrink: 0
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            fontSize: 13,
            color: danger ? 'var(--danger-ink)' : 'var(--ink)',
            whiteSpace: 'nowrap'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 400,
            padding: '2px 8px',
            borderRadius: 99,
            flexShrink: 0,
            background: danger ? 'var(--danger-soft)' : 'var(--line-2)',
            color: danger ? 'var(--danger-ink)' : 'var(--mute)'
        }
    }, count), badge), !open && gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            marginTop: 3,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, gist)), actions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            transition: 'transform .18s',
            transform: open ? 'rotate(-90deg)' : 'rotate(90deg)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).arrow, {
        width: 11,
        height: 11
    }))), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        }
    }, children));
}
/** «مشاهدهٔ همه» — the header action that opens a section's full-list sheet. */ function $9b4ee9e6346f75da$var$RecordViewAll({ onOpen: onOpen, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
        label: t('common.actions.viewAll'),
        onClick: onOpen,
        testid: testid
    });
}
// ── «پرونده بیمار» — the rail's ONE visual vocabulary (PM-0036) ───────────────
// Every section used to carry its own copy of these — three header-action
// styles, two label sizes, two chip radii, two empty-line styles — and they had
// drifted. A section now picks from here and nowhere else:
//   · header: icon + title + count (+ badge) + ONE kind of action + chevron
//   · body:   RECORD_LABEL over values, RECORD_CHIP for short facts,
//             RECORD_CARD for a boxed value, RECORD_EMPTY when there is nothing,
//             RecordMore as the «+N» line under a preview
const $9b4ee9e6346f75da$var$RECORD_LABEL = {
    fontSize: 9.5,
    fontWeight: 600,
    letterSpacing: '.04em',
    color: 'var(--mute-2)'
};
const $9b4ee9e6346f75da$var$RECORD_EMPTY = {
    fontSize: 11.5,
    color: 'var(--mute-2)'
};
const $9b4ee9e6346f75da$var$RECORD_CHIP = {
    fontSize: 11.5,
    padding: '3px 9px',
    borderRadius: 6,
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    color: 'var(--ink-2)'
};
const $9b4ee9e6346f75da$var$RECORD_CHIP_DANGER = {
    ...$9b4ee9e6346f75da$var$RECORD_CHIP,
    background: 'var(--panel)',
    border: '1px solid oklch(0.82 0.08 25)',
    color: 'var(--danger-ink)',
    fontWeight: 500
};
const $9b4ee9e6346f75da$var$RECORD_CARD = {
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    borderRadius: 'var(--radius)'
};
/**
 * A section header's inline action («ویرایش», «مشاهدهٔ جزئیات», «مشاهدهٔ همه»).
 * A span, not a button: it sits inside the section's toggle <button>.
 */ function $9b4ee9e6346f75da$var$RecordHeaderAction({ icon: Icon, label: label, onClick: onClick, testid: testid }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--accent-ink)',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 10,
        height: 10
    }), " ", label);
}
/** The «+N …» line under a section's preview; opens that section's full list. */ function $9b4ee9e6346f75da$var$RecordMore({ onOpen: onOpen, testid: testid, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onOpen,
        "data-testid": testid,
        style: {
            width: '100%',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--accent-ink)',
            textAlign: 'center',
            paddingTop: 6
        }
    }, children);
}
/**
 * Full-list sheet for one record section. Same chrome and same edge as the
 * visit-history sheet, so «مشاهدهٔ همه» behaves identically wherever it
 * appears in the record column.
 */ function $9b4ee9e6346f75da$var$RecordListSheet({ icon: Icon, title: title, count: count, onClose: onClose, children: children, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        "data-testid": testid,
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(480px, 94vw)',
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13.5,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '2px 8px',
            borderRadius: 99
        }
    }, count), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '12px 16px 20px'
        }
    }, children)));
}
// ─────────────────────────────────────────────────────────────────────────────
// «بیمار در یک نگاه» — the patient at a glance (PM-0023)
//
// One modal that answers "who is this patient, clinically?" without a search
// through the record: the history, what was prescribed before, what they take
// now, and what needs attention. It holds NO data of its own — every panel reads
// what the rail already loaded (the patient, the three prefetched past visits,
// the summaries), so opening it costs no request and it can never disagree with
// the sections beside it. Read-only by design: editing stays in the rail.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * A past visit's «شرح حال» — the S the DOCTOR wrote, and nothing standing in for
 * it. No assessment, no plan, no AI summary: a doctor reading «شرح حال» must be
 * reading their own words or an honest "nothing was written".
 */ function $9b4ee9e6346f75da$var$visitHistoryText(context) {
    for (const note of context?.notes || []){
        const c = (0, $a044c29e4a6b3520$export$90858b03e74b9658)(note?.content);
        const s = c.subjective || c.s || c.S;
        if (typeof s === 'string' && s.trim()) return s.trim();
    }
    return '';
}
// The glance shows a preview of the two lists that can run long; «مشاهدهٔ همه»
// hands over to the SAME full-list sheet the rail opens, so there is one full
// list per section, not two.
const $9b4ee9e6346f75da$var$GLANCE_PREVIEW = {
    meds: 6,
    dx: 6
};
const $9b4ee9e6346f75da$var$GLANCE_EMPTY = {
    fontSize: 11.5,
    color: 'var(--mute-2)',
    fontStyle: 'italic'
};
function $9b4ee9e6346f75da$var$GlancePanel({ icon: Icon, title: title, count: count, tone: tone, testid: testid, action: action, children: children }) {
    const danger = tone === 'danger';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": testid,
        style: {
            border: `1px solid ${danger ? 'oklch(0.85 0.08 25)' : 'var(--line)'}`,
            borderRadius: 10,
            background: 'var(--panel)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 13,
        height: 13,
        style: {
            color: danger ? 'var(--danger)' : 'var(--accent)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12.5,
            fontWeight: 700,
            color: danger ? 'var(--danger-ink)' : 'var(--ink)'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            padding: '1px 7px',
            borderRadius: 99,
            background: danger ? 'var(--danger-soft)' : 'var(--line-2)',
            color: danger ? 'var(--danger-ink)' : 'var(--mute)'
        }
    }, count), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            flexShrink: 0
        }
    }, action)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 12px 12px',
            overflowY: 'auto',
            minHeight: 0
        }
    }, children));
}
function $9b4ee9e6346f75da$var$PatientGlanceModal({ patient: patient, conditions: conditions, activeConds: activeConds, visits: visits, ctxById: ctxById, currentMeds: currentMeds, abnormalLabs: abnormalLabs, vitalsAlert: vitalsAlert, hasMoreVisits: hasMoreVisits, onOpenHistory: onOpenHistory, onViewAllMeds: onViewAllMeds, onViewAllDx: onViewAllDx, onClose: onClose }) {
    const { t: t, formatDate: formatDate, formatRelativeTime: formatRelativeTime, formatList: formatList, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    const allergies = patient?.allergies || [];
    const doseOf = (m)=>{
        const text = typeof m.dosageInstruction === 'string' ? m.dosageInstruction : m.dosageInstruction?.text;
        return text ? (0, $375f8776645d5aee$export$f1536cfec6e3f4b8)(text, t, readsPersianData) : '';
    };
    const medLine = (m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (m.id || m.display) + '_' + i,
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap',
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m)), doseOf(m) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                color: 'var(--mute)'
            }
        }, doseOf(m)));
    const visitHead = (v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 6,
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--accent)',
                flexShrink: 0,
                alignSelf: 'center'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, v.scheduledDate ? formatDate(v.scheduledDate, 'medium') : ''), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                color: 'var(--mute-2)',
                marginInlineStart: 'auto'
            }
        }, formatRelativeTime(v.scheduledDate)));
    const ctxOf = (v)=>ctxById[v.id];
    const dataOf = (v)=>ctxOf(v)?.state === 'ready' ? ctxOf(v).data : null;
    const loading = visits.some((v)=>!ctxOf(v) || ctxOf(v).state === 'loading');
    // «شرح حال» is the LAST visit's, only — older ones are one click away in
    // «همهٔ سوابق ویزیت», and three half-read histories are not a glance.
    const lastVisit = visits[0] || null;
    const lastCtx = lastVisit ? ctxOf(lastVisit) : null;
    const lastLoading = Boolean(lastVisit) && (!lastCtx || lastCtx.state === 'loading');
    const lastHistory = lastVisit ? $9b4ee9e6346f75da$var$visitHistoryText(dataOf(lastVisit)) : '';
    const rxRows = visits.map((v)=>({
            v: v,
            meds: dataOf(v)?.medications || []
        })).filter((r)=>r.meds.length);
    const hasHistory = conditions.length > 0 || activeConds.length > 0 || Boolean(lastVisit);
    const attentionCount = allergies.length + abnormalLabs.length + (vitalsAlert?.messages?.length || 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)',
            display: 'grid',
            placeItems: 'center',
            padding: 24
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": t('visit.glance.title'),
        "data-testid": "patient-glance-modal",
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: 'min(1040px, 100%)',
            maxHeight: '100%',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 14,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 12px 48px rgba(0,0,0,.22)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            background: 'var(--panel)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).scan, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13.5,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, t('visit.glance.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            color: 'var(--mute)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, [
        patient?.name,
        patient?.age ? t('visit.patient.years', {
            count: patient.age
        }) : null
    ].filter(Boolean).join(" \xb7 ")), hasMoreVisits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        onClick: onOpenHistory,
        "data-testid": "glance-all-visits",
        style: {
            marginInlineStart: 'auto'
        }
    }, t('visit.glance.allVisits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        "data-testid": "glance-close",
        style: {
            marginInlineStart: hasMoreVisits ? 0 : 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            padding: 14,
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 12,
            alignItems: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).alert,
        title: t('visit.glance.attention'),
        count: attentionCount,
        tone: attentionCount > 0 ? 'danger' : undefined,
        testid: "glance-attention"
    }, attentionCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noAttention')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.allergyAlert')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: 11.5,
                padding: '3px 9px',
                borderRadius: 4,
                background: 'var(--danger-soft)',
                border: '1px solid oklch(0.82 0.08 25)',
                color: 'var(--danger-ink)',
                fontWeight: 500
            }
        }, a)))), vitalsAlert?.messages?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.vitals.title')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: 12,
                color: 'var(--ink)'
            }
        }, m))), abnormalLabs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.labResults')), abnormalLabs.map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
            key: (obs.id || '') + '_' + i,
            obs: obs,
            isLast: i === arr.length - 1
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
        title: t('patient.meds.current'),
        count: currentMeds.length,
        testid: "glance-current-meds",
        action: currentMeds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "link",
            size: "sm",
            onClick: onViewAllMeds,
            "data-testid": "glance-viewall-meds"
        }, t('common.actions.viewAll')) : null
    }, currentMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noCurrentMeds')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, currentMeds.slice(0, $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds).map(medLine), currentMeds.length > $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            textAlign: 'center',
            paddingTop: 2
        }
    }, "+ ", currentMeds.length - $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds, " ", t('visit.rx.moreMedications')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).notes,
        title: t('visit.glance.history'),
        testid: "glance-history"
    }, !hasHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noHistory')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, lastVisit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "glance-last-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.glance.lastVisitHistory')), visitHead(lastVisit), lastLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 180,
        height: 11
    }) : lastHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: 12.5,
            color: 'var(--ink)',
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap'
        }
    }, lastHistory) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noLastHistory'))), activeConds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_SECTION_LABEL,
            marginBottom: 0
        }
    }, t('patient.conditions.active')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        onClick: onViewAllDx,
        "data-testid": "glance-viewall-dx"
    }, t('common.actions.viewAll'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, activeConds.slice(0, $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: (c.id || c.display) + '_' + i,
            style: {
                ...$9b4ee9e6346f75da$var$HIST_CHIP,
                fontSize: 11.5,
                padding: '3px 9px'
            }
        }, c.display)), activeConds.length > $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_CHIP,
            fontSize: 11.5,
            padding: '3px 9px',
            background: 'var(--panel)',
            color: 'var(--mute)',
            border: '1px solid var(--line)'
        }
    }, t('visit.history.more', {
        count: activeConds.length - $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx
    })))), conditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.conditionHistory')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, formatList([
        ...new Set(conditions.filter(Boolean))
    ]))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).history,
        title: t('visit.glance.pastRx'),
        testid: "glance-past-rx"
    }, loading && rxRows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$785af5d3304b5931), null) : rxRows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noPastRx')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, rxRows.map(({ v: v, meds: meds })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id
        }, visitHead(v), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, meds.map(medLine)))))))));
}
/** One active-medication card — shared by the record rail and the full sheet. */ function $9b4ee9e6346f75da$var$MedCard({ med: med, onRemove: onRemove, onReprescribe: onReprescribe, represcribed: represcribed }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: ()=>onRemove(med),
        title: t('visit.rx.stop'),
        style: {
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).trash, {
        width: 14,
        height: 14
    })), onReprescribe && (represcribed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t('visit.rx.represcribed'),
        "data-testid": "med-represcribed",
        style: {
            width: 28,
            height: 28,
            display: 'grid',
            placeItems: 'center',
            color: 'var(--good)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
        width: 14,
        height: 14
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>onReprescribe(med),
        title: t('visit.rx.represcribe'),
        "aria-label": t('visit.rx.represcribeAria', {
            name: (0, $bb8a11e7c1131df5$export$74f59380a530b722)(med)
        }),
        "data-testid": "med-represcribe",
        style: {
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).reload, {
        width: 14,
        height: 14
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-name",
        dir: "auto"
    }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(med)), med.warn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-warn-badge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 10,
        height: 10
    }), med.warn), med.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-dose"
    }, (0, $375f8776645d5aee$export$f1536cfec6e3f4b8)(med.dosageInstruction.text, t, readsPersianData))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--accent-soft)',
            display: 'grid',
            placeItems: 'center',
            color: 'var(--accent-ink)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).pill, {
        width: 14,
        height: 14
    })));
}
/**
 * One active-diagnosis card — shared by the record rail and the full sheet.
 *
 * Carries the «نوع تشخیص» badge (موقت/احتمالی vs قطعی): requirement 4 is that a
 * doctor can tell the two apart at a glance in this list, so the badge sits on
 * the title line rather than being deferred to a detail view. `onChangeType`
 * makes the badge the edit affordance too — the type is changed where it is
 * read, which is also the only place a diagnosis NOT promoted from a
 * differential (one typed into SOAP «A») can be re-typed at all.
 */ function $9b4ee9e6346f75da$var$CondCard({ cond: cond, onRemove: onRemove, onChangeType: onChangeType, busy: busy }) {
    const { t: t } = (0, $LNQP4.default)();
    const [picking, setPicking] = (0, $acw62.useState)(false);
    const type = (0, $4a744c4def3d338a$export$5d68a431913dd40b)(cond);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card",
        style: {
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: ()=>onRemove(cond),
        title: t('visit.dx.remove'),
        style: {
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).trash, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-name",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, cond.display), onChangeType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `dx-type-edit-${cond.id || cond.display}`,
        onClick: ()=>setPicking((v)=>!v),
        title: t('visit.dx.type.changeTitle'),
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
        cond: cond
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
        cond: cond
    })), cond.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-dose"
    }, cond.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--accent-soft)',
            display: 'grid',
            placeItems: 'center',
            color: 'var(--accent-ink)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 14,
        height: 14
    })), picking && onChangeType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexBasis: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$7085d532b18268b), {
        testidPrefix: `dx-type-choice-${cond.id || cond.display}`,
        title: t('visit.dx.type.changeTitle'),
        current: type,
        busy: busy,
        onCancel: ()=>setPicking(false),
        onPick: async (next)=>{
            if (next !== type) await onChangeType(cond, next);
            setPicking(false);
        }
    })));
}
/** One lab-result row — shared by the record rail and the full sheet. */ function $9b4ee9e6346f75da$var$LabResultRow({ obs: obs, isLast: isLast }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const isCritical = obs.status === 'CRITICAL';
    const isAbnormal = obs.status === 'ABNORMAL';
    const valColor = isCritical ? 'var(--danger)' : isAbnormal ? 'oklch(0.52 0.18 50)' : 'var(--good)';
    const rowBg = isCritical ? 'var(--danger-soft)' : isAbnormal ? 'oklch(0.98 0.025 55)' : 'transparent';
    const dateStr = obs.effectiveDate ? formatDate(obs.effectiveDate, 'dayMonth') : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '7px 9px',
            borderRadius: 8,
            background: rowBg,
            borderBottom: isLast ? 'none' : '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: valColor,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            fontWeight: 500,
            color: 'var(--ink)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9.5,
            color: 'var(--mute)',
            marginTop: 1,
            direction: 'ltr'
        }
    }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'end',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: 13.5,
            color: valColor,
            fontFamily: 'monospace',
            direction: 'ltr',
            lineHeight: 1.2
        }
    }, obs.value, obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9.5,
            fontWeight: 400,
            color: 'var(--mute)',
            marginInlineStart: 2
        }
    }, " ", obs.unit) : ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: 'var(--mute)',
            textAlign: 'start',
            marginTop: 1
        }
    }, dateStr)), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9,
            padding: '1px 5px',
            borderRadius: 4,
            flexShrink: 0,
            background: isCritical ? 'var(--danger)' : 'oklch(0.88 0.08 55)',
            color: isCritical ? '#fff' : 'oklch(0.42 0.14 55)',
            fontWeight: 700
        }
    }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
}
function $9b4ee9e6346f75da$export$2e2bcd8739ae039({ navigate: navProp, patient: routePatient }) {
    const { t: t, formatNumber: formatNumber, formatList: formatList, formatDigits: formatDigits, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    // The Iranian insurer rails — «ارسال به بیمه», the eRx registry's category — only
    // for a clinic in rials, or one the host has not said (host.jsx useIranianRails).
    const iranianRails = (0, $e317r.useIranianRails)();
    const goBack = (0, $aa19facd75e3670a$export$2225579b56f43845)();
    const { patient: patient, loading: pLoading, refresh: refreshPatient } = (0, $ea02b2b734b36651$export$9b570c45914f833c)(routePatient?.id);
    // `loading` matters: until the doctor's settings have arrived, `ai` is {}
    // and every `!== false` gate reads as ENABLED. Deciding an auto-run in that
    // window means the setting is honoured only when the doctor query happens to
    // win the race against the patient query.
    const { doctor: doctor, loading: doctorLoading, error: doctorError, update: updateDoctorSettings } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const walletBalance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    // ── Layout the doctor arranged in Settings → «صفحه ویزیت» ────────────────
    // Resolved once per settings object: which record sections render and in
    // what order, which work/copilot tabs exist, and which open first. `null`
    // (settings in flight or failed) resolves to the page as it shipped, so the
    // first paint is never wrong, only default. See screens/Visit/visitLayout.js.
    const storedVisitLayout = doctor?.settings?.visitLayout ?? null;
    const visitLayout = (0, $acw62.useMemo)(()=>(0, $792124e2f7de719a$export$e88ad8319f3008b2)(storedVisitLayout), [
        storedVisitLayout
    ]);
    const workTabVisible = (0, $acw62.useMemo)(()=>Object.fromEntries(visitLayout.workTabs.map((tab)=>[
                tab.id,
                tab.visible
            ])), [
        visitLayout
    ]);
    const copilotTabVisible = (0, $acw62.useMemo)(()=>Object.fromEntries(visitLayout.copilotTabs.map((tab)=>[
                tab.id,
                tab.visible
            ])), [
        visitLayout
    ]);
    // The per-visit «پارسه» tally lives with the visit — see the coin ledger
    // below, declared once the encounter id it is keyed by exists.
    const ai = doctor?.settings?.aiAgent || {};
    // «نکات بالینی» is always available — the doctor only chooses whether it
    // arrives unprompted. Off ONLY on an explicit `false`, so an absent key never
    // reads as an opt-out. See Settings.shared.js. An empty `ai` is a different
    // case entirely, and the predicate below is what tells the two apart.
    // Whether the doctor's choice is KNOWN. `loading` was the only guard here,
    // which made every gate below fail OPEN on a failed query: `me` fetches
    // `settings` through a second gRPC call inside the same request, so one
    // unavailable doctor-preference call throws the whole query, leaves `doctor`
    // null and `ai` empty — and an empty `ai` reads as ENABLED, because an absent
    // key is not an opt-out. A doctor who switched all three automations off then
    // got the differential, the polling loop and the insight pass anyway, and was
    // billed for them. An error is not a choice, so it reads as "don't run
    // anything by yourself"; every manual button stays live.
    const aiSettingsUnknown = doctorLoading || !!doctorError;
    // Auto-run only when we know the doctor left it on. This also decides
    // whether the RECORDING produces «نکات بالینی»: the AI service runs a hint
    // agent on its own timer for the whole visit, a second producer of the same
    // feed that this switch did not use to reach.
    const suggestionsAutoRun = !aiSettingsUnknown && (0, $2d58c73a38525204$export$ced99d35363868d3)(ai);
    // The other three automatic runs, each on its own switch now. They used to
    // ride on the two above — which was honest about the billing and dishonest
    // about the naming — or, in the sweep's case, on nothing at all. Every one of
    // them reads as OFF while the doctor's choice is unknown: see the predicate
    // above, and Settings.shared.js for what each switch actually stops.
    const liveHintsOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$77b83820a545461a)(ai);
    // «موتور تبدیل گفتار به متن». Unlike the switches above this is NOT held off
    // while the choice is unknown: the default is Parsina STT, and the AI service
    // serves the assistant engine whenever Parsina STT cannot answer — so the
    // worst an unknown choice costs is the default, never a dead microphone.
    const speechPref = (0, $33deae5c7ec89d7f$export$e976735e46efaec2)(ai);
    const ambientSpeechEngine = (0, $33deae5c7ec89d7f$export$a597380b597b4b46)(speechPref);
    const autoAssistOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$2b2bb51f62de8576)(ai);
    const reassessOnEdit = !aiSettingsUnknown && (0, $2d58c73a38525204$export$211159940a78ce44)(ai);
    // «تکمیل خودکار پس از پایش بالینی» — the top bar's «تکمیل» once the doctor stops.
    const autoCompleteOn = !aiSettingsUnknown && (0, $2d58c73a38525204$export$c41b9e42cb7b861)(ai);
    // The sweep is the exception to "unknown reads as off": it is a SAFETY
    // backstop, and a settings query that failed is no reason to stop checking a
    // prescription for a high-severity interaction. Only an explicit «off» from a
    // doctor who says they check by hand stops it.
    const endVisitSweepOn = (0, $2d58c73a38525204$export$6bc5afae02a61f49)(ai);
    const [visitId, setVisitId] = (0, $acw62.useState)(null);
    const [visitStatus, setVisitStatus] = (0, $acw62.useState)(null);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const pendingNavRef = (0, $acw62.useRef)(null);
    const [tab, setTab] = (0, $acw62.useState)('notes');
    // Prescription
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    const [rxInteractions, setRxInteractions] = (0, $acw62.useState)(null);
    const [interactionLoading, setIxLoading] = (0, $acw62.useState)(false);
    const [ixError, setIxError] = (0, $acw62.useState)(null);
    const [aiResult, setAiResult] = (0, $acw62.useState)(null);
    const [aiLoading, setAiLoading] = (0, $acw62.useState)(false);
    const [diagnosis, setDiagnosis] = (0, $acw62.useState)('');
    // ── نسخه drug picker ────────────────────────────────────────────────────────
    // Search-only (PM-0043): nothing is listed until the doctor searches, and a
    // drug reaches the نسخه only through the add form, whose required fields must
    // be filled first (PM-0059). Both live in RxDrugSearch; what stays here is what
    // the visit feeds it.
    //
    // A drug offered from outside — a document review («افزودن به نسخه ویزیت»,
    // §23.3 A13) or an approved AI proposal: its form opens prefilled, and it
    // becomes a نسخه line only by that form's «افزودن به نسخه». Several wait their
    // turn, one form at a time, as on the phone; a drug already waiting is not
    // queued twice.
    const [rxAddQueue, setRxAddQueue] = (0, $acw62.useState)([]);
    const queueRxAdds = (0, $acw62.useCallback)((requests)=>setRxAddQueue((prev)=>[
                ...prev,
                ...requests.filter((r)=>!prev.some((p)=>p.drug.id === r.drug.id))
            ]), []);
    // A search asked for from outside the picker (an AI proposal the list did not settle).
    const [rxSearchRequest, setRxSearchRequest] = (0, $acw62.useState)(null);
    // «داروهای پرتکرار من»: the doctor's most prescribed drugs, each with the sig of
    // their latest prescription of it. No longer a row of chips above the picker —
    // a drug is found by search alone — but still the starting sig of any such
    // drug in the add form.
    const [frequentDrugs, setFrequentDrugs] = (0, $acw62.useState)([]);
    const frequentDrugsFetched = (0, $acw62.useRef)(false);
    // AI Recommendations. `recsRan` records that the pass completed at least once,
    // so an empty panel can say "nothing to suggest" instead of "not run yet".
    const [recommendations, setRecommendations] = (0, $acw62.useState)(null);
    const [recsLoading, setRecsLoading] = (0, $acw62.useState)(false);
    const [recsError, setRecsError] = (0, $acw62.useState)(null);
    const [recsRan, setRecsRan] = (0, $acw62.useState)(false);
    const recsAutoFired = (0, $acw62.useRef)(false);
    const assistAutoFired = (0, $acw62.useRef)('');
    // Notes & visit
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [aiInput, setAiInput] = (0, $acw62.useState)('');
    const [aiMessages, setAiMessages] = (0, $acw62.useState)([]);
    const [aiChatLoading, setAiChatLoading] = (0, $acw62.useState)(false);
    const [labOpen, setLabOpen] = (0, $acw62.useState)(false);
    const [savedLabResults, setSavedLabResults] = (0, $acw62.useState)([]);
    const [showClosureFlow, setShowClosureFlow] = (0, $acw62.useState)(false);
    // «ثبت نسخه در بیمه» while the visit is open — the e-prescription card in a
    // panel at the inline-end of the work area (PM-0097; it used to open above the
    // نسخه, K1 2026-10-03, and had to scroll itself into view). Opened from the
    // dock's «نسخه» alone (PM-0152; the top bar's chip went with PM-0187), always
    // on ALL — the card's checkboxes choose the lines. null = closed.
    const [erxScope, setErxScope] = (0, $acw62.useState)(null);
    const erxOpen = erxScope !== null;
    // A login waiting for its code, or a send in flight, is unsaved work: closing
    // the panel or changing its part unmounts the card, so either asks first —
    // as the closure dialog does before it exits.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const erxBusyRef = (0, $acw62.useRef)(false);
    erxBusyRef.current = erxBusy;
    const [erxLeave, setErxLeave] = (0, $acw62.useState)(null); // null | { next: scope | null }
    const changeErxScope = (0, $acw62.useCallback)((next)=>{
        if (erxBusyRef.current) {
            setErxLeave({
                next: next
            });
            return;
        }
        setErxScope(next);
    }, []);
    const erxScopeRef = (0, $acw62.useRef)(null);
    erxScopeRef.current = erxScope;
    // The work area's width decides whether the panel stands beside the work or
    // lies over its edge (VisitErxPanel). Unknown (no ResizeObserver) = beside.
    // A callback ref: the workspace mounts after the record has loaded, long
    // after this component did.
    const [workBodyWidth, setWorkBodyWidth] = (0, $acw62.useState)(0);
    const workBodyObserver = (0, $acw62.useRef)(null);
    const workBodyRef = (0, $acw62.useCallback)((el)=>{
        workBodyObserver.current?.disconnect();
        workBodyObserver.current = null;
        if (!el || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver((entries)=>setWorkBodyWidth(Math.round(entries[0]?.contentRect?.width || 0)));
        ro.observe(el);
        workBodyObserver.current = ro;
    }, []);
    // «پایان ویزیت» asks before it closes an encounter that cannot be reopened —
    // Reception and the phone always did, the workspace's own topbar did not.
    const [pendingEnd, setPendingEnd] = (0, $acw62.useState)(false);
    // A high-severity interaction found by the closing sweep held the visit open
    // in silence. This raises the banner in the نسخه tab that says why.
    const [interactionStop, setInteractionStop] = (0, $acw62.useState)(false);
    const [pmEncounterId, setPmEncounterId] = (0, $acw62.useState)(null);
    // ── Per-visit «پارسه» tally ────────────────────────────────────────────────
    // Persisted against the encounter, so it survives a refresh, leaving and
    // re-entering the visit, and a reload of the record — see useVisitCoinLedger.
    // `chargeVisit` stays stable for the whole visit (the ledger's `charge` is
    // created once), which is what lets the billing effects depend on it.
    const { entries: coinLedger, total: visitCoins, charge: recordCoinCharge, refetch: refetchCoins } = (0, $375f8776645d5aee$export$18ea943e404e01dd)(pmEncounterId || visitId || null);
    // The toast is the surface's own voice, so it stays here rather than in the
    // shared ledger; the moving parts it needs are read through a ref so the
    // callback identity never changes.
    const chargeDepsRef = (0, $acw62.useRef)({
        toast: toast,
        t: t,
        formatNumber: formatNumber
    });
    chargeDepsRef.current = {
        toast: toast,
        t: t,
        formatNumber: formatNumber
    };
    const chargeVisit = (0, $acw62.useCallback)((coins, itemId, label)=>{
        if (!coins) return;
        recordCoinCharge(coins, itemId);
        const { toast: tst, t: tr, formatNumber: fn } = chargeDepsRef.current;
        if (label) tst.success(tr('visit.header.coinsToast', {
            label: label,
            coins: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(coins, fn)
        }));
    }, [
        recordCoinCharge
    ]);
    const [differential, setDifferential] = (0, $acw62.useState)(null);
    const [diffLoading, setDiffLoading] = (0, $acw62.useState)(false);
    const [sessionReady, setSessionReady] = (0, $acw62.useState)(false);
    const [resumedVisit, setResumedVisit] = (0, $acw62.useState)(false); // true when visit was recovered on page reload
    const [soapDiffConfirm, setSoapDiffConfirm] = (0, $acw62.useState)(null); // { description, diagnosisCode }
    // diagnosisCode whose «نوع تشخیص» is being chosen. Confirming a differential
    // is a two-step act on purpose: the type is not a detail to fix up later,
    // it is part of the diagnosis, so there is no path that records one without it.
    const [diffTypePick, setDiffTypePick] = (0, $acw62.useState)(null);
    const [diffTypeBusy, setDiffTypeBusy] = (0, $acw62.useState)(false);
    const [addedSugTests, setAddedSugTests] = (0, $acw62.useState)(new Set());
    const [vitals, setVitals] = (0, $acw62.useState)((0, $375f8776645d5aee$export$ccc2c13eb48542b9));
    const [vitalsMode, setVitalsMode] = (0, $acw62.useState)('form'); // 'form' | 'saved'
    // Per-section open state for the record column — persisted so the layout the
    // doctor arranges (labs collapsed, vitals open) survives reloads mid-visit.
    const [recordSheet, setRecordSheet] = (0, $acw62.useState)(null); // 'meds' | 'dx' | 'conds' | 'labs' | 'files' | null
    // The kind filter of the «مدارک بیمار» sheet; null = every kind.
    const [fileKindFilter, setFileKindFilter] = (0, $acw62.useState)(null);
    // Open/closed per section — the doctor's preference, shared with the phone's
    // record sheet (Visit.shared.js).
    const { recordOpen: recordOpen, toggleRecordSection: toggleRecordSection } = (0, $375f8776645d5aee$export$6523efd640f02d3b)(visitLayout, storedVisitLayout, doctorLoading, updateDoctorSettings);
    const [vitalsLoading, setVitalsLoading] = (0, $acw62.useState)(false);
    const [vitalsAlert, setVitalsAlert] = (0, $acw62.useState)(null);
    const [vitalsError, setVitalsError] = (0, $acw62.useState)(null); // validation errors (array of strings)
    const [showVitalsModal, setShowVitalsModal] = (0, $acw62.useState)(false);
    const [showEditPatient, setShowEditPatient] = (0, $acw62.useState)(false);
    const [editPatientForm, setEditPatientForm] = (0, $acw62.useState)({});
    const [editPatientSaving, setEditPatientSaving] = (0, $acw62.useState)(false);
    const [editPatientError, setEditPatientError] = (0, $acw62.useState)('');
    const savedVitalIds = (0, $acw62.useRef)([]); // IDs of this encounter's vital observations
    const vitalsSeeded = (0, $acw62.useRef)(null); // encounter whose recorded vitals we already adopted
    const [creditError, setCreditError] = (0, $acw62.useState)(null);
    // «خرید پارسه» on the out-of-credit banner and «شارژ اعتبار» on the low-balance
    // strip are offered only where this deployment sells credit (PM-0211,
    // lib/useCreditPrices.js); the warnings themselves always show. Asked of the
    // BFF only once one of the two is on screen.
    const canBuyCredits = (0, $121df138798ec781$export$34ab9a07791a6651)(Boolean(creditError) || walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low');
    const [prescriptionTemplates, setPrescriptionTemplates] = (0, $acw62.useState)([]);
    // Visit timer
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [recElapsed, setRecElapsed] = (0, $acw62.useState)(0); // recording-specific counter
    // New SOAP + copilot/work tab state
    const [soap, setSoap] = (0, $acw62.useState)({
        s: '',
        o: '',
        a: '',
        p: ''
    });
    const [copilotTab, setCopilotTab] = (0, $acw62.useState)('sugg');
    const [copilotExpanded, setCopilotExpanded] = (0, $acw62.useState)(false);
    // Both side panels START by screen size (PM-0048): open on a large monitor,
    // closed on a tablet or a small laptop, where the note needs the width. The
    // dock keeps both one click away either way.
    //   · the assistant's choice lasts for this visit only — a fold remembered
    //     per browser once meant the page opened with it minimized and the doctor
    //     could not tell why;
    //   · the record's choice (PM-0035) is remembered per browser, and a stored
    //     choice wins over the screen-size default.
    const [copilotOpen, setCopilotOpen] = (0, $acw62.useState)((0, $84e131569ade80e0$export$e6a645360361d3ad));
    const toggleCopilotOpen = (0, $acw62.useCallback)((next)=>{
        setCopilotOpen((prev)=>typeof next === 'boolean' ? next : !prev);
    }, []);
    const [recordPanelOpen, setRecordPanelOpen] = (0, $acw62.useState)(()=>{
        try {
            const stored = localStorage.getItem($9b4ee9e6346f75da$var$RECORD_OPEN_KEY);
            if (stored === '0' || stored === '1') return stored === '1';
        } catch  {}
        return (0, $84e131569ade80e0$export$e6a645360361d3ad)();
    });
    const toggleRecordPanelOpen = (0, $acw62.useCallback)((next)=>{
        setRecordPanelOpen((prev)=>{
            const v = typeof next === 'boolean' ? next : !prev;
            try {
                localStorage.setItem($9b4ee9e6346f75da$var$RECORD_OPEN_KEY, v ? '1' : '0');
            } catch  {}
            return v;
        });
    }, []);
    // The dock's nudge: what the assistant held when the doctor last looked (or
    // last dismissed the card), and how often they dismissed it this visit.
    const [copilotSeen, setCopilotSeen] = (0, $acw62.useState)({
        sugg: 0,
        diff: 0
    });
    const [nudgeDismissals, setNudgeDismissals] = (0, $acw62.useState)(0);
    // Which tab each column opens on comes from Settings, but only until the
    // doctor picks one themselves in this visit — a settings refetch mid-visit
    // must not yank a tab out from under them. A tab that became hidden while
    // active falls back to the default regardless.
    const tabsTouched = (0, $acw62.useRef)({
        work: false,
        copilot: false
    });
    const [contextExpanded, setContextExpanded] = (0, $acw62.useState)(false);
    const [diagAIQuestions, setDiagAIQuestions] = (0, $acw62.useState)({}); // { [diagCode]: [{id,question,hint}] }
    const [diagAIAnswers, setDiagAIAnswers] = (0, $acw62.useState)({}); // { [diagCode]: { [qId]: {answer:'yes'|'no', followUp:''} } }
    const [diagAILoading, setDiagAILoading] = (0, $acw62.useState)({}); // { [diagCode]: boolean }
    // An answer is committed the moment it is picked, so the in-flight and failed
    // states are per QUESTION, not per diagnosis: `${diagCode}:${questionId}`.
    const [diagQSubmitting, setDiagQSubmitting] = (0, $acw62.useState)({}); // { [diagCode:qId]: 'yes'|'no' }
    const [diagQError, setDiagQError] = (0, $acw62.useState)({}); // { [diagCode:qId]: string }
    const [openAIDiag, setOpenAIDiag] = (0, $acw62.useState)(null); // diagCode | null
    const [workTab, setWorkTab] = (0, $acw62.useState)('soap');
    (0, $acw62.useEffect)(()=>{
        setWorkTab((prev)=>!tabsTouched.current.work || workTabVisible[prev] === false ? visitLayout.defaultWorkTab : prev);
        setCopilotTab((prev)=>!tabsTouched.current.copilot || copilotTabVisible[prev] === false ? visitLayout.defaultCopilotTab : prev);
    }, [
        visitLayout,
        workTabVisible,
        copilotTabVisible
    ]);
    const pickWorkTab = (0, $acw62.useCallback)((id)=>{
        tabsTouched.current.work = true;
        setWorkTab(id);
    }, []);
    // The tabs that render the SOAP note's editors: S/O/A on «ویزیت», P on «برنامه درمان».
    const noteTab = workTab === 'soap' || workTab === 'plan';
    const pickCopilotTab = (0, $acw62.useCallback)((id)=>{
        tabsTouched.current.copilot = true;
        setCopilotTab(id);
    }, []);
    const [soapNoteId, setSoapNoteId] = (0, $acw62.useState)(null); // ID of the in-progress ClinicalNote for this visit
    // AI-assisted treatment plan — lives inside the SOAP «P» section (the AI button
    // there generates it) rather than in the copilot panel, so the plan is produced,
    // reviewed and filed in the one place the plan belongs: the note.
    const [planSuggestion, setPlanSuggestion] = (0, $acw62.useState)(null); // TreatmentPlanSuggestion | null
    const [planLoading, setPlanLoading] = (0, $acw62.useState)(false);
    const [selectedPlanItems, setSelectedPlanItems] = (0, $acw62.useState)(new Set()); // "med:name" | "lab:name" | ...
    const [planSaving, setPlanSaving] = (0, $acw62.useState)(false);
    const [planStatus, setPlanStatus] = (0, $acw62.useState)(null); // null | 'draft' | 'confirmed'
    const [planError, setPlanError] = (0, $acw62.useState)(null);
    const [planPanelOpen, setPlanPanelOpen] = (0, $acw62.useState)(false); // review panel under the P field
    // The P text the AI note replaced, kept so the doctor can undo a generation
    // that overwrote something they had already written. null = nothing to restore.
    const [planReplacedP, setPlanReplacedP] = (0, $acw62.useState)(null);
    // Clinical orders (from clinicalencounter microservice)
    const [clinicalOrders, setClinicalOrders] = (0, $acw62.useState)([]);
    const [ordersLoading, setOrdersLoading] = (0, $acw62.useState)(false);
    // Whether the list above is the server's answer rather than "not asked yet".
    // The plan reconciler DERIVES «P» from it, and an empty list means "this visit
    // has no orders" — a claim we may only make once the fetch has come back.
    const [ordersLoaded, setOrdersLoaded] = (0, $acw62.useState)(false);
    const [orderTransitioning, setOrderTransitioning] = (0, $acw62.useState)(null); // orderId being transitioned
    const [orderSaving, setOrderSaving] = (0, $acw62.useState)(false);
    const [orderError, setOrderError] = (0, $acw62.useState)(null); // last add-order failure, surfaced in the tab
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null); // order pending a §5.2 destructive cancel confirm
    const [cancellingVisit, setCancellingVisit] = (0, $acw62.useState)(false);
    // The order catalogue is SEARCHED, never held. It is about to carry the national
    // مکسا list (~20,000 rows): loading it to filter in the browser would be ~4 MB
    // per picker open, and this service has already been OOM-killed once by that
    // shape. Two pieces of state replace the old blob:
    //
    //   catalogPage      the CURRENT PAGE the picker shows — one server search
    //   catalogResolved  what orders ALREADY on the chart need from the catalogue:
    //                    the English name the SOAP plan block prints, whether this
    //                    clinic performs the service, and its code. Keyed by
    //                    catalogId, and by name for the older orders that have none.
    const [catalogPage, setCatalogPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    const [catalogResolved, setCatalogResolved] = (0, $acw62.useState)(()=>new Map());
    // Checked items survive a change of query: the doctor ticks «CBC», searches for
    // something else, and both are still added. The old code resolved keys against
    // the full catalogue at submit time, which no longer exists.
    const selectedOrderItems = (0, $acw62.useRef)(new Map());
    // AI order suggestions for the encounter order list (درخواست‌های بالینی)
    const [encOrderSugg, setEncOrderSugg] = (0, $acw62.useState)(null); // { items: [...ranked best-first], rationale }
    const [encOrderSuggLoading, setEncOrderSuggLoading] = (0, $acw62.useState)(false);
    const [encSuggAdding, setEncSuggAdding] = (0, $acw62.useState)(null); // suggestion key being added
    const [encSuggAdded, setEncSuggAdded] = (0, $acw62.useState)(new Set()); // keys already added to the list
    // The tab's structured add-order form. orderDraftType drives which catalog bucket
    // is shown; selectedOrderKeys holds the checked catalog items (keyed `type:name`);
    // 'other' switches the catalog list for a free-text field.
    const [orderDraftType, setOrderDraftType] = (0, $acw62.useState)('lab'); // lab | imaging | procedure | other
    const [orderSearch, setOrderSearch] = (0, $acw62.useState)('');
    const [orderUrgency, setOrderUrgency] = (0, $acw62.useState)('routine');
    const [orderNotes, setOrderNotes] = (0, $acw62.useState)('');
    const [orderSessions, setOrderSessions] = (0, $acw62.useState)(1); // procedure only (physiotherapy → N appointments)
    const [selectedOrderKeys, setSelectedOrderKeys] = (0, $acw62.useState)(new Set());
    // Refs for contentEditable SOAP editors
    const soapEditorRefs = (0, $acw62.useRef)({
        s: null,
        o: null,
        a: null,
        p: null
    });
    // Keep contentEditable DOM in sync with soap state (draft restore, AI appends, tab remount, etc.)
    // useLayoutEffect fires synchronously after refs are attached but before browser paint,
    // so adding workTab as a dep ensures fields repopulate immediately when SOAP tab remounts.
    // Skip update if the element is currently focused (user is actively typing).
    (0, $acw62.useLayoutEffect)(()=>{
        [
            's',
            'o',
            'a',
            'p'
        ].forEach((key)=>{
            const el = soapEditorRefs.current[key];
            if (el && document.activeElement !== el && el.textContent !== (soap[key] || '')) el.textContent = soap[key] || '';
        });
    }, [
        soap.s,
        soap.o,
        soap.a,
        soap.p,
        workTab
    ]);
    // Load saved SOAP note from server on visit resume/reload
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || visitStatus !== 'inprogress' || soapNoteId) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$5b71fce46c6ed6a3), {
            patientId: patient.id,
            appointmentId: encId
        }).then((data)=>{
            // The note is matched with the SHARED reader, not on a literal noteType.
            // When encounters merged into appointments the service dropped
            // `note_type` and kept only `format`, which it refuses to store as
            // anything but "SOAP" — so the BFF now reports every note as
            // noteType 'SOAP'. The old `=== 'SOAP_NOTE'` filter could therefore
            // never match: the editors came up empty on reload AND `soapNoteId`
            // stayed null, so the next autosave took the CREATE branch and left the
            // appointment with two SOAP rows that disagree.
            const note = (0, $a044c29e4a6b3520$export$b26efe9e640f95c2)(data?.listClinicalNotes || []);
            if (!note) return;
            // The id FIRST and unconditionally — the next save must UPDATE this row
            // even if it is currently empty, or the duplicate comes back.
            setSoapNoteId(note.id);
            const draft = (0, $a044c29e4a6b3520$export$41de64d84beb8926)([
                note
            ]);
            const next = {
                s: draft.S || '',
                o: draft.O || '',
                a: draft.A || '',
                p: draft.P || ''
            };
            if (!(next.s || next.o || next.a || next.p)) return;
            // A localStorage draft restored moments ago is FRESHER than the server
            // copy (it holds keystrokes made after the last autosave), so it wins.
            setSoap((prev)=>prev.s || prev.o || prev.a || prev.p ? prev : next);
        }).catch(()=>{});
    }, [
        pmEncounterId,
        visitId,
        patient?.id,
        visitStatus
    ]);
    const [dismissedSuggs, setDismissedSuggs] = (0, $acw62.useState)(new Set());
    // ── سوابق ویزیت‌های قبلی ────────────────────────────────────────────────────
    // The rail shows VISIT_HISTORY_PREVIEW visits as scannable rows and nothing
    // else — it is already taller than the viewport, so full detail lives in the
    // sheet instead of expanding in place. `visitCtx` caches one
    // getEncounterContext per visit, keyed by encounter id, and is shared by both.
    const [pastVisitSummaries, setPastVisitSummaries] = (0, $acw62.useState)(null);
    const [expandedEncId, setExpandedEncId] = (0, $acw62.useState)(null);
    const [visitCtx, setVisitCtx] = (0, $acw62.useState)({});
    const [historyOpen, setHistoryOpen] = (0, $acw62.useState)(false);
    // «بیمار در یک نگاه» — reads the same cache; one overlay at a time (§5.2).
    const [glanceOpen, setGlanceOpen] = (0, $acw62.useState)(false);
    // «اصلاح نسخه» — the past visit whose نسخه is open for correction (K1,
    // 2026-10-04), or null. One overlay at a time: it replaces the history sheet.
    const [rxCorrectionVisit, setRxCorrectionVisit] = (0, $acw62.useState)(null);
    // Requested ids live in a ref, not in `visitCtx`, so a re-render mid-flight
    // cannot fire the same query twice.
    const visitCtxRequested = (0, $acw62.useRef)(new Set());
    const loadVisitContext = (0, $acw62.useCallback)((encId)=>{
        if (!encId || visitCtxRequested.current.has(encId)) return;
        visitCtxRequested.current.add(encId);
        setVisitCtx((prev)=>({
                ...prev,
                [encId]: {
                    state: 'loading'
                }
            }));
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$e8c7fd9774d91e48), {
            appointmentId: encId
        }).then((data)=>setVisitCtx((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'ready',
                        data: data?.getEncounterContext || {}
                    }
                }))).catch(()=>setVisitCtx((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'error'
                    }
                })));
    }, []);
    // Accepted suggestions tracking
    const [pendingTests, setPendingTests] = (0, $acw62.useState)([]);
    // Current-meds panel: delete via mutation, undo re-adds locally (optimistic)
    const [removedMedNames, setRemovedMedNames] = (0, $acw62.useState)(new Set());
    const [undoMed, setUndoMed] = (0, $acw62.useState)(null);
    const undoTimerRef = (0, $acw62.useRef)(null);
    const [removedCondIds, setRemovedCondIds] = (0, $acw62.useState)(new Set());
    const [undoCond, setUndoCond] = (0, $acw62.useState)(null);
    const undoCondTimerRef = (0, $acw62.useRef)(null);
    const [activeVisitConflict, setActiveVisitConflict] = (0, $acw62.useState)(null); // { visitId } | null
    // The OTHER way starting a visit fails. `activeVisitConflict` is the one cause
    // we can offer a choice about; this is everything else — the encounter was
    // never created, so `visitStatus` stays null and the recording control, the
    // end-visit button and the duration all silently do not render. Holding the
    // error is what turns three missing buttons into one sentence.
    const [startError, setStartError] = (0, $acw62.useState)(null);
    const medKey = (med)=>(med.display || '').trim().toLowerCase();
    const removeMed = async (med)=>{
        setRemovedMedNames((prev)=>new Set([
                ...prev,
                medKey(med)
            ]));
        setUndoMed(med);
        clearTimeout(undoTimerRef.current);
        undoTimerRef.current = setTimeout(()=>setUndoMed(null), 8000);
        const duplicates = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === medKey(med));
        for (const m of duplicates)try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
                id: m.id,
                input: {
                    status: 'stopped'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const restoreMed = async ()=>{
        if (!undoMed) return;
        clearTimeout(undoTimerRef.current);
        const key = medKey(undoMed);
        setRemovedMedNames((prev)=>{
            const s = new Set(prev);
            s.delete(key);
            return s;
        });
        setUndoMed(null);
        const stopped = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === key && m.status === 'stopped');
        for (const m of stopped)try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b41f928ed45f8779), {
                id: m.id,
                input: {
                    status: 'active'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const removeCondition = async (cond)=>{
        setRemovedCondIds((prev)=>new Set([
                ...prev,
                cond.id
            ]));
        setUndoCond(cond);
        clearTimeout(undoCondTimerRef.current);
        undoCondTimerRef.current = setTimeout(()=>setUndoCond(null), 8000);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$ea4d931135e95fd1), {
                id: cond.id
            });
        } catch  {}
        refreshPatient();
    };
    const restoreCondition = async ()=>{
        if (!undoCond) return;
        clearTimeout(undoCondTimerRef.current);
        setRemovedCondIds((prev)=>{
            const s = new Set(prev);
            s.delete(undoCond.id);
            return s;
        });
        setUndoCond(null);
        // Restoring must carry the type the row had — an undo that silently
        // downgraded a قطعی diagnosis to موقت would be an unannounced clinical edit.
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$52e699bb9024b09d), {
                patientId: patient.id,
                input: {
                    code: undoCond.code,
                    display: undoCond.display,
                    clinicalStatus: 'active',
                    verificationStatus: (0, $4a744c4def3d338a$export$5d68a431913dd40b)(undoCond)
                }
            });
        } catch  {}
        refreshPatient();
    };
    // «تغییر نوع تشخیص» from the record panel — the one edit path that works for
    // every diagnosis, including those never promoted from a differential.
    const changeCondType = async (cond, type)=>{
        setDiffTypeBusy(true);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b8ec51b731e55222), {
                id: cond.id,
                input: {
                    verificationStatus: type
                }
            });
            await refreshPatient();
        } catch  {}
        setDiffTypeBusy(false);
    };
    const toggleMed = (id)=>{};
    const visitStartTime = (0, $acw62.useRef)(null);
    // Vitals belong to the visit, so the recorder opens EMPTY — never seeded with
    // the patient's older readings (see vitalsForEncounter in Visit.shared).
    (0, $acw62.useEffect)(()=>{
        setVitalsMode('form');
        setVitals((0, $375f8776645d5aee$export$ccc2c13eb48542b9)());
        savedVitalIds.current = [];
        vitalsSeeded.current = null;
    }, [
        visitId
    ]);
    // …and fills in only from vitals actually recorded against THIS encounter, so
    // a reload mid-visit shows what was measured today. Runs on every patient
    // refetch but adopts once per encounter, so it can never wipe a form the
    // doctor is filling in.
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId || null;
        if (!encId || !patient) return;
        const key = String(encId);
        if (vitalsSeeded.current === key) return;
        const { values: values, ids: ids, recorded: recorded } = (0, $375f8776645d5aee$export$1e5a39e00c998387)(patient.clinicalObservations, encId);
        if (!recorded) return;
        vitalsSeeded.current = key;
        setVitals(values);
        savedVitalIds.current = ids;
        setVitalsMode('saved');
    }, [
        patient,
        pmEncounterId,
        visitId
    ]);
    // Fetch doctor's prescription templates once on mount
    (0, $acw62.useEffect)(()=>{
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$cd39121473ec6a95)).then((r)=>{
            if (r?.prescriptionTemplates) setPrescriptionTemplates(r.prescriptionTemplates);
        }).catch(()=>{});
    }, []);
    // Declared BEFORE useTranscription, and that ordering is load-bearing:
    // the transcription hook reads `call.audioSource` to decide whether the
    // visit's audio comes from the conference or from the microphone.
    // ── ویزیت تصویری ───────────────────────────────────────────────────────────
    // The call is opened by a button, never by mounting this screen. Pressing it
    // also starts the visit — `ensureVisitStarted` runs the screen's OWN start
    // path, so there is still exactly one place that marks an appointment
    // in_visit, and a doctor answering a patient who is already waiting does not
    // have to press «شروع ویزیت» first.
    const ensureVisitStarted = (0, $acw62.useCallback)(async ()=>{
        const existing = pmEncounterId || visitId;
        if (existing) return existing;
        const id = await handleStart();
        // null means handleStart already surfaced the reason — the active-visit
        // conflict dialog, or the start-error banner. Nothing to add here.
        if (!id) throw new Error('unavailable');
        return id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    const call = (0, $b23a4f29e1a7fc1a$export$fd58d87a1fa8fc0d)({
        patientId: patient?.id,
        appointmentId: pmEncounterId || visitId || null,
        ensureVisitStarted: ensureVisitStarted,
        // The brand the CALL shows (window title, join/leave toasts). Passed from
        // here because jitsiEmbed.js is React-free and has no i18n of its own.
        providerName: t('visit.call.providerName')
    });
    // Ask once per patient whether a call is even possible. Cheap: the query mints
    // nothing and writes nothing, and answers `not_configured` rather than failing
    // where no media server exists.
    const { probe: probeCall } = call;
    (0, $acw62.useEffect)(()=>{
        probeCall();
    }, [
        probeCall
    ]);
    // The page is about to be frozen mid-recording — a laptop lid closing, a tab
    // going to the background. Everything still only in memory reaches the draft
    // in this call; see A2 in useTranscription.
    const systemPauseRef = (0, $acw62.useRef)(null);
    const onSystemPause = (0, $acw62.useCallback)((snapshot)=>{
        systemPauseRef.current?.(snapshot);
    }, []);
    const { recState: recState, recError: recError, hints: hints, liveTranscript: liveTranscript, startRec: startRec, stopRec: stopRec, resumeRec: resumeRec, dismissPause: dismissPause, dismissError: dismissError } = (0, $b5da27b488005ec5$export$e2373706461b5244)({
        patientId: patient?.id,
        visitId: visitId,
        patientHistory: (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient) + '\n' + (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests),
        // During a video visit the audio comes from the CALL, not from a second
        // microphone — the mic cannot hear the patient (echo cancellation removes
        // them) and on iOS it would steal the call's own audio session. Null when
        // no call is live, which leaves the in-person path exactly as it was.
        callAudio: call.audioSource,
        onSystemPause: onSystemPause,
        // The switch reaches the STREAM, so the hint agent is never RUN for a
        // doctor who turned «نکات بالینی زنده هنگام ضبط» off — rather than run,
        // billed for in tokens, and then hidden on arrival.
        hintsEnabled: liveHintsOn,
        engine: ambientSpeechEngine
    });
    const isRecording = recState === 'recording';
    const isStopping = recState === 'stopping';
    // Pressed, not yet recording: the button is held so a second press cannot
    // open a second recording (useTranscription, `connecting`).
    const isConnecting = recState === 'connecting';
    const isRecError = recState === 'error';
    // The OS closed the socket while the page was in the background. A desktop
    // tab suspends far less often than a phone does, but it does suspend — and
    // the failure mode was the same on both: the panel went on saying «در حال
    // ضبط» over a socket that no longer existed (§3.1 A1).
    const isRecPaused = recState === 'paused-by-system';
    const hint = hints[0] ? typeof hints[0] === 'string' ? hints[0] : hints[0].text || '' : '';
    // ── Visit lifecycle ────────────────────────────────────────────────────────
    // Returns the started visit's id (= the scheduling appointment id) so that
    // «تماس با بیمار» can start the visit and open the room in one press without
    // a second, subtly different start path. Returns null on every failure it
    // already handles — the conflict dialog and the error banner still surface it.
    const handleStart = async ()=>{
        if (!patient?.id) return null;
        setStartError(null);
        try {
            const now = new Date().toISOString();
            visitStartTime.current = now;
            const cv = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$610b800a6c6defa5), {
                patientId: patient.id,
                type: 'OUTPATIENT'
            });
            const id = cv.createVisit.id;
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$cdc0bbb5663f787c), {
                id: id
            });
            setVisitId(id);
            setPmEncounterId(id);
            setVisitStatus('inprogress');
            setSoapNoteId(null);
            setSessionReady(false);
            (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
                visitId: id,
                patientId: patient.id
            }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            return id;
        } catch (e) {
            const code = e?.extensions?.code || e?.graphQLErrors?.[0]?.extensions?.code;
            if (code === 'ACTIVE_VISIT_EXISTS') {
                const activeId = e?.extensions?.activeVisitId || e?.graphQLErrors?.[0]?.extensions?.activeVisitId;
                setActiveVisitConflict({
                    visitId: activeId || null
                });
                return null;
            }
            // Was a bare console.warn. A doctor cannot see the console, and the only
            // other symptom is three controls quietly not rendering — which reads as
            // "the feature is gone", not "the visit was never created". They can be
            // half-way through a SOAP note before noticing.
            console.warn('handleStart error:', e);
            setStartError(e);
            return null;
        }
    };
    const handleResumeConflictVisit = ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        setStartError(null);
        if (!activeId) return;
        setVisitId(activeId);
        setPmEncounterId(activeId);
        setVisitStatus('inprogress');
        setSoapNoteId(null);
        setSessionReady(false);
        (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
            visitId: activeId,
            patientId: patient.id
        }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
    };
    const handleCloseConflictVisit = async ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (activeId) try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$33b114336c19593d), {
                id: activeId
            });
        } catch  {}
        handleStart();
    };
    // Resolves to whether the note is now persisted. Most callers are fire-and-
    // forget autosaves that ignore it; the confirmation-question flow does not —
    // it may only close its panel once the write it just made has landed.
    //
    // Saves can race for a note not created yet — the editor's blur and the
    // «تأیید» that caused it both save. useSoapNoteRow keeps that to ONE CREATE:
    // a save behind it waits and updates the row it made.
    const writeSoapNoteRow = (0, $375f8776645d5aee$export$3c5b8ac9cc0f8a4)(soapNoteId, setSoapNoteId, visitId);
    const handleSaveSoapNote = async (currentSoap)=>{
        const s = currentSoap || soap;
        if (!patient?.id) return false;
        if (!(s.s || s.o || s.a || s.p)) return true;
        const resolvedEncId = pmEncounterId || visitId || null;
        const content = {
            s: s.s || '',
            o: s.o || '',
            a: s.a || '',
            p: s.p || ''
        };
        try {
            await writeSoapNoteRow({
                update: (id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$6e7c5d8b5a28479a), {
                        id: id,
                        input: {
                            content: content
                        }
                    }),
                create: async ()=>{
                    const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$1d32d39b70c8b52e), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedEncId
                        }
                    });
                    return res?.createClinicalNote?.id;
                }
            });
            return true;
        } catch (e) {
            console.warn('handleSaveSoapNote error:', e);
            return false;
        }
    };
    // ── Plan ⇄ نسخه/دستورات reconciliation ────────────────────────────────────
    //
    // The «P» text carries a managed block listing every prescribed drug and every
    // live order (see buildPlanBlock in Visit.shared). This effect is the loop that
    // keeps it true: it recomputes the block from the current lists, compares it
    // against what «P» actually says, and rewrites only on drift.
    //
    // It runs on every render path that can change either list OR «P» itself, so
    // divergence introduced by any means — a drug added, a dose edited, an order
    // cancelled, a draft restored from localStorage, the doctor deleting half the
    // block by hand — is corrected on the next pass rather than only at the point
    // of the edit. Recomputing from scratch is what makes that safe: the block is
    // derived, never accumulated, so replaying it can't double up.
    //
    // The block is written in English (it is a clinical document, not UI), so an
    // order needs its English catalogue name. The catalogue is keyed twice: by
    // catalogId, which an order created from the picker carries, and by the
    // Persian name, which is all an order created before that linkage — or by the
    // AI suggestion rail — has to identify itself with.
    // The English names the SOAP plan block prints, for the orders on this chart.
    // Resolved by id (and by name for orders older than catalogIds), never by
    // holding the dictionary. An order the server could not resolve is simply
    // absent here, and buildPlanBlock falls back to its Persian description — the
    // same behaviour as before, for the same rows.
    const catalogNameEn = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const [key, row] of catalogResolved)if (row?.nameEn) m.set(key, row.nameEn);
        return m;
    }, [
        catalogResolved
    ]);
    const orderNameEn = (0, $acw62.useCallback)((o)=>catalogNameEn.get(o?.catalogId) || catalogNameEn.get((o?.description || '').trim()) || '', [
        catalogNameEn
    ]);
    // What the orders tab SHOWS a reader who does not read Persian: the catalogue's
    // English name, for suggestions (named by their Persian catalogue name) and for
    // the orders on the chart. What is stored and matched stays the Persian.
    const suggestedOrderName = (0, $375f8776645d5aee$export$891bfbeed44ddfce)((encOrderSugg?.items || []).map((i)=>i.name));
    const chartOrderName = (o)=>readsPersianData ? o?.description : orderNameEn(o) || o?.description;
    const planBlock = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$d3332d0820799abb)({
            rxItems: rxItems,
            orders: clinicalOrders,
            orderNameEn: orderNameEn
        }), [
        rxItems,
        clinicalOrders,
        orderNameEn
    ]);
    // Live views of the two lists, for the one caller that mutates them and then
    // needs the result within the same async run: handleApplyPlan creates meds and
    // orders and must file a plan note that already lists them, which its own
    // closure — captured before any of those writes — cannot supply.
    const rxItemsRef = (0, $acw62.useRef)(rxItems);
    rxItemsRef.current = rxItems;
    const clinicalOrdersRef = (0, $acw62.useRef)(clinicalOrders);
    clinicalOrdersRef.current = clinicalOrders;
    // Same reason, for the note: a confirmation answer appends to «S» and awaits
    // the save, so it must append to the latest text rather than to whatever the
    // closure captured before the previous answer landed.
    const soapRef = (0, $acw62.useRef)(soap);
    soapRef.current = soap;
    // ── تکمیل یادداشت — merge-aware SOAP completion ──────────────────────────
    //
    // The server merges (doctor text is authoritative, only new facts are added)
    // and the doctor reviews per section before anything touches the note. The
    // charge follows the server's `charged` flag, never the click.
    //
    // handleSaveSoapNote is recreated each render, so the stable apply callback
    // below reads it through a ref — otherwise it would save with the FIRST
    // render's patient/soapNoteId closure and file a duplicate note.
    const saveSoapNoteRef = (0, $acw62.useRef)(null);
    saveSoapNoteRef.current = handleSaveSoapNote;
    const applyRefinedSections = (0, $acw62.useCallback)((entries)=>{
        setSoap((prev)=>{
            const next = {
                ...prev
            };
            Object.entries(entries).forEach(([k, text])=>{
                // The merge worked on the «P» NARRATIVE only; the managed drug/order
                // block the note already carries is preserved verbatim and re-spliced —
                // re-deriving it here would repeat the "orders not loaded yet ⇒ nothing
                // ordered" trap the reconciler guards against.
                if (k === 'p') next.p = (0, $375f8776645d5aee$export$a3aead4a50abe781)(text, (0, $375f8776645d5aee$export$69cdf1bc97231e5)(prev.p));
                else next[k] = text;
            });
            saveSoapNoteRef.current?.(next);
            return next;
        });
    }, []);
    const soapRefine = (0, $375f8776645d5aee$export$79f39042065fbd7d)({
        visitId: visitId,
        patientId: patient?.id || null,
        soapRef: soapRef,
        liveTranscript: liveTranscript,
        chargeVisit: chargeVisit,
        onApply: applyRefinedSections,
        onCreditError: setCreditError,
        t: t
    });
    const soapRefineLoading = soapRefine.loading;
    const soapFieldRefineLoading = soapRefine.loadingSections?.length === 1 ? soapRefine.loadingSections[0] : null;
    const handleSoapRefine = ()=>soapRefine.refine();
    const handleSoapFieldRefine = (fieldKey)=>soapRefine.refine([
            fieldKey
        ]);
    // The proposals the S/O/A tab shows — and so the only ones its «اعمال همه» may
    // confirm. «P» is on «برنامه درمان».
    const soapTabProposals = Object.entries(soapRefine.preview || {}).filter(([k, v])=>k !== 'p' && !v.stale).map(([k])=>k);
    // Writing to «P» while the doctor has the caret in it would fight them for the
    // field: the DOM-sync layout effect deliberately skips a focused editor, so the
    // state write would be reverted by their very next keystroke. Defer instead —
    // this flag is a dependency of the reconciler, so blur re-runs it immediately.
    const [planEditorFocused, setPlanEditorFocused] = (0, $acw62.useState)(false);
    // Leaving the «برنامه درمان» tab unmounts the editor without firing blur, which
    // would strand the flag at true and silently stop reconciling for the rest of
    // the visit — the exact failure this guard is meant to prevent, inverted.
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'plan') setPlanEditorFocused(false);
    }, [
        workTab
    ]);
    // Rapid edits (a dosage typed character by character) must not each cost a
    // mutation, but the text on screen must still be right immediately. So the
    // splice is synchronous and only the write is debounced, with the latest
    // snapshot always winning.
    const planSaveTimer = (0, $acw62.useRef)(null);
    const schedulePlanNoteSave = (0, $acw62.useCallback)((nextSoap)=>{
        clearTimeout(planSaveTimer.current);
        planSaveTimer.current = setTimeout(()=>{
            handleSaveSoapNote(nextSoap);
        }, 700);
    }, [
        handleSaveSoapNote
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(planSaveTimer.current), []);
    // A resumed visit restores «P» from the server note, which already lists the
    // orders this encounter carries. Reconciling before the order list has been
    // fetched would compare that text against an empty list and strip those lines —
    // the block is derived, so "not loaded yet" and "nothing ordered" are the same
    // input. Wait for the fetch. With no encounter there is nothing to fetch and
    // nothing to wait for, so the drug side keeps reconciling as usual.
    const ordersAuthoritative = ordersLoaded || !(pmEncounterId || visitId);
    (0, $acw62.useEffect)(()=>{
        if (planEditorFocused) return;
        if (!ordersAuthoritative) return;
        const nextP = (0, $375f8776645d5aee$export$a3aead4a50abe781)(soap.p, planBlock);
        if (nextP === (soap.p || '')) return; // already consistent — the common case
        setSoap((prev)=>prev.p === soap.p ? {
                ...prev,
                p: nextP
            } : prev);
        schedulePlanNoteSave({
            ...soap,
            p: nextP
        });
    }, [
        planBlock,
        planEditorFocused,
        ordersAuthoritative,
        soap,
        schedulePlanNoteSave
    ]);
    // Returns whether the list is now authoritative — a failed fetch leaves the
    // previous list standing rather than reporting an empty visit, because the
    // reconciler would take that literally and delete the doctor's orders from «P».
    const loadClinicalOrders = async (encId)=>{
        if (!encId) return false;
        setOrdersLoading(true);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$1d5821a442552a84), {
                appointmentId: encId
            });
            setClinicalOrders(data?.listOrders || []);
            setOrdersLoaded(true);
            return true;
        } catch  {
            return false;
        } finally{
            setOrdersLoading(false);
        }
    };
    // Creates an encounter order carrying the full catalog linkage the backend
    // supports (code / catalogId / sessionCount). Returns the created order on
    // success, or null on failure so callers keep what the doctor entered.
    const handleCreateOrder = async ({ type: type, urgency: urgency, name: name, notes: notes, code: code, catalogId: catalogId, sessionCount: sessionCount })=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || !name) return null;
        setOrderSaving(true);
        setOrderError(null);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$81ebae6b21d102e1), {
                appointmentId: encId,
                patientId: patient.id,
                orderType: type,
                description: name,
                urgency: urgency,
                notes: notes || '',
                code: code || null,
                catalogId: catalogId || null,
                sessionCount: sessionCount && sessionCount > 1 ? sessionCount : null
            });
            const created = data?.createOrder;
            // A successful mutation with no order back means the write didn't land —
            // treat it as a failure rather than pushing a null row into the list.
            if (!created) {
                setOrderError(t('visit.orders.saveRetry'));
                return null;
            }
            setClinicalOrders((prev)=>[
                    created,
                    ...prev
                ]);
            return created;
        } catch (e) {
            // Don't swallow: surface why nothing was added (backend down, unmigrated
            // schema, validation) instead of a silent no-op that looks like a dead button.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else setOrderError(e?.message || t('errors.save.order'));
            console.error('[createOrder]', e);
            return null;
        } finally{
            setOrderSaving(false);
        }
    };
    // Lab/imaging/procedure orders are mirrored into pendingTests so the printed
    // نسخه and the end-of-visit doctor-order save keep working exactly as before.
    //
    // `savedToBackend` says whether the row ALREADY exists as an encounter order.
    // `useEndVisit` flushes every pendingTest that says it does not, so a row that is
    // already saved and claims otherwise is written a second time. Every caller here
    // mirrors an order it has just created on the server, so every one passes true;
    // the catalogue «افزودن», AI-suggested and plan-confirm paths passed the default
    // and each such order was saved twice (2026-09-29, beta1: two CBC rows per visit,
    // sent twice to تأمین and op-naji). clinical/__tests__/visitOrderMirror.test.js
    // pins it.
    const mirrorOrderToPendingTests = (o, { savedToBackend: savedToBackend = false } = {})=>{
        if (![
            'lab',
            'imaging',
            'procedure'
        ].includes(o.type)) return;
        setPendingTests((prev)=>[
                ...prev,
                {
                    id: `${Date.now()}-${o.name}`,
                    name: o.name,
                    type: o.type,
                    urgency: o.urgency || 'routine',
                    reason: o.reason || '',
                    loincCode: o.loincCode || o.code || '',
                    savedToBackend: savedToBackend
                }
            ]);
    };
    // ── Structured order form ────────────────────────────────────────────────────
    // Flatten the fetched catalog into one common item shape per type. Each item
    // carries the identifiers the create mutation wants: catalogId (row id), code
    // (LOINC for labs / CPT for procedures), and a display sub-line + modality.
    // The current page, in the shape OrderCheckItem reads. The server has already
    // filtered by query and type and ranked in-house first, so there is nothing to
    // filter here — only to group, which is a display decision.
    const catalogItems = (0, $acw62.useMemo)(()=>catalogPage.entries.map((e)=>({
                key: `${e.orderType}:${e.name}`,
                type: e.orderType,
                name: e.name,
                nameEn: e.nameEn || '',
                catalogId: e.id || null,
                code: e.code || '',
                // A LOINC badge is only honest when the code IS a LOINC: the same column now
                // also carries CPT and, soon, LAB-ir and Radiology-ir numbers.
                loincCode: e.codeSystem === 'LOINC' ? e.code || '' : '',
                modality: e.modality || '',
                sub: e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '',
                category: e.category || t('common.state.other'),
                inHouse: !!e.inHouse,
                // «در فهرست تأمین» — for a تأمین patient (K1, 2026-10-07).
                taminListed: (0, $375f8776645d5aee$export$ff0b3160d2d98f35)(e, (0, $ace44487380106d3$export$e4f91298b6c5a0f0)(patient?.insurance))
            })), [
        catalogPage.entries,
        t,
        patient?.insurance
    ]);
    // Grouped by category, in-house first — within a category, and categories that
    // contain an in-house service lead. Stable via the paired index.
    const groupedCatalog = (0, $acw62.useMemo)(()=>{
        const byCat = new Map();
        for (const it of catalogItems){
            if (!byCat.has(it.category)) byCat.set(it.category, []);
            byCat.get(it.category).push(it);
        }
        const groups = Array.from(byCat, ([category, list])=>({
                category: category,
                list: list.map((it, i)=>[
                        it,
                        i
                    ]).sort((a, b)=>!!b[0].inHouse - !!a[0].inHouse || a[1] - b[1]).map(([it])=>it),
                hasInHouse: list.some((it)=>it.inHouse)
            }));
        return groups.map((g, i)=>[
                g,
                i
            ]).sort((a, b)=>b[0].hasInHouse - a[0].hasInHouse || a[1] - b[1]).map(([{ category: category, list: list }])=>({
                category: category,
                list: list
            }));
    }, [
        catalogItems
    ]);
    const catalogByKey = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const it of catalogItems)m.set(it.key, it);
        return m;
    }, [
        catalogItems
    ]);
    // Catalog ids the clinic has an ACTIVE service declaration for (inHouse flag from
    // getClinicalOrderCatalog). Only these orders can be performed — and billed — here,
    // so only they get the انجام button (accounting bills on completion iff declared, §3½).
    const inHouseCatalogIds = (0, $acw62.useMemo)(()=>{
        const ids = new Set();
        for (const [key, row] of catalogResolved)if (row?.inHouse && key === row.id) ids.add(row.id);
        return ids;
    }, [
        catalogResolved
    ]);
    // Whether an order is fulfilled by the current clinic — i.e. its catalog item is
    // one this clinic declares (in-house). Same signal that gates the انجام button.
    const isClinicOrder = (0, $acw62.useCallback)((o)=>!!o?.catalogId && inHouseCatalogIds.has(o.catalogId), [
        inHouseCatalogIds
    ]);
    // Orders performed by the current clinic float to the top of the list; every other
    // order keeps its original (creation) order. Stable sort via the paired index.
    const sortedClinicalOrders = (0, $acw62.useMemo)(()=>clinicalOrders.map((o, i)=>[
                o,
                i
            ]).sort((a, b)=>isClinicOrder(b[0]) - isClinicOrder(a[0]) || a[1] - b[1]).map(([o])=>o), [
        clinicalOrders,
        isClinicOrder
    ]);
    const toggleOrderKey = (key)=>setSelectedOrderKeys((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
                selectedOrderItems.current.delete(key);
            } else {
                next.add(key);
                // Remember the ITEM, not just its key: the list under the doctor changes
                // with the next keystroke, and the old code looked keys up in a catalogue
                // that was fully resident. Nothing resolves a key at submit time now.
                const item = catalogByKey.get(key);
                if (item) selectedOrderItems.current.set(key, item);
            }
            return next;
        });
    // Switching type starts a new search and KEEPS what is picked: the picked items
    // are on screen as chips (keys are unique per type), so a lab and an imaging
    // study go in with one «افزودن».
    const handleOrderTypeChange = (item)=>{
        setOrderDraftType(item);
        setOrderSearch('');
    };
    // Add every selected catalog item (or the single free-text entry for 'other')
    // as an encounter order, applying the shared urgency / notes / session count.
    const handleAddSelectedOrders = async ()=>{
        if (orderSaving) return;
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id) return;
        const chosen = Array.from(selectedOrderKeys).map((k)=>selectedOrderItems.current.get(k) || catalogByKey.get(k)).filter(Boolean);
        if (!chosen.length) return;
        // «تعداد جلسات» is a خدمت's: a lab picked beside one is ordered once.
        const sessions = Math.max(1, Number(orderSessions) || 1);
        let anyOk = false;
        for (const it of chosen){
            const created = await handleCreateOrder({
                type: it.type,
                urgency: orderUrgency,
                name: it.name,
                notes: orderNotes,
                code: it.code,
                catalogId: it.catalogId,
                sessionCount: it.type === 'procedure' ? sessions : 1
            });
            if (created) {
                anyOk = true;
                mirrorOrderToPendingTests({
                    type: it.type,
                    name: it.name,
                    urgency: orderUrgency,
                    code: it.code,
                    loincCode: it.loincCode
                }, {
                    savedToBackend: true
                });
            }
        }
        if (anyOk) {
            setSelectedOrderKeys(new Set());
            selectedOrderItems.current.clear();
            setOrderSearch('');
            setOrderNotes('');
            setOrderSessions(1);
            setOrderUrgency('routine');
        }
    };
    // AI: rank the most appropriate orders for the patient's current conditions
    // (record diagnoses + the SOAP assessment) and offer them for one-tap
    // insertion into the encounter order list. Best candidate first.
    const URGENCY_RANK = {
        stat: 0,
        urgent: 1,
        routine: 2
    };
    const handleSuggestEncounterOrders = async ()=>{
        if (!patient?.id || encOrderSuggLoading) return;
        setEncOrderSuggLoading(true);
        try {
            const icdCodes = (patient.clinicalConditions || []).map((c)=>c.code).filter(Boolean);
            const diagnoses = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            if (soap.a.trim()) diagnoses.push(soap.a.trim().slice(0, 160));
            const existingTests = (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean);
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$c3637e87e40dab8f), {
                appointmentId: pmEncounterId || visitId || undefined,
                patientId: patient.id,
                icdCodes: icdCodes.slice(0, 8),
                diagnoses: diagnoses.slice(0, 8),
                age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                gender: patient.gender || '',
                existingTests: existingTests.slice(0, 10)
            });
            const s = data.suggestDoctorOrders || {};
            // Each row keeps the code its catalogue row came with (lib/suggestedOrders):
            // built without it, the order reached the record and the insurer uncoded.
            const items = (0, $027388f7462935a9$export$1565dcb2999a6fb9)(s).sort((a, b)=>(URGENCY_RANK[a.urgency] != null ? URGENCY_RANK[a.urgency] : 2) - (URGENCY_RANK[b.urgency] != null ? URGENCY_RANK[b.urgency] : 2));
            // The suggestions carry Persian catalogue names; an English reader's names
            // are fetched first, so the list never shows Persian that flips to English.
            if (!readsPersianData) await (0, $375f8776645d5aee$export$d1f71c951f3a3ccc)(items.map((i)=>i.name)).catch((err)=>console.warn('suggested order English names unavailable:', err));
            setEncOrderSugg({
                items: items,
                rationale: s.clinicalRationale || ''
            });
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('DOCTOR_ORDERS'), 'orders', t('visit.suggest.orderReady'));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn('suggestDoctorOrders (orders tab) failed:', e);
        } finally{
            setEncOrderSuggLoading(false);
        }
    };
    const handleAddSuggestedOrder = async (item)=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || encSuggAdding) return;
        // Already on this visit — picked from the catalogue, or added from an
        // earlier suggestion pass. A second press would be a second order.
        if ((0, $027388f7462935a9$export$ce329d894bbd1d2b)(clinicalOrders, item.orderType, item.name)) return;
        setEncSuggAdding(item.key);
        try {
            // Through handleCreateOrder, like every other add on this page, so the
            // catalogue code travels with the order — this was the one desktop path
            // that wrote its own mutation and sent none. There is no catalogId to
            // send: the suggestion is a catalogue NAME, and the service links the row
            // by that exact name, which is what the «انجام» button reads.
            const created = await handleCreateOrder({
                type: item.orderType,
                urgency: item.urgency,
                name: item.name,
                notes: item.reason,
                code: item.code
            });
            if (!created) return;
            setEncSuggAdded((prev)=>new Set(prev).add(item.key));
            mirrorOrderToPendingTests({
                type: item.orderType,
                name: item.name,
                urgency: item.urgency,
                reason: item.reason,
                code: item.code,
                loincCode: item.loincCode
            }, {
                savedToBackend: true
            });
        } finally{
            setEncSuggAdding(null);
        }
    };
    const handleOrderTransition = async (orderId, action)=>{
        setOrderTransitioning(orderId);
        const mutMap = {
            start: (0, $375f8776645d5aee$export$a829ddd2566c75b7),
            complete: (0, $375f8776645d5aee$export$b0b354e2ddeac24b),
            cancel: (0, $375f8776645d5aee$export$494a03338ebc3893)
        };
        const fieldMap = {
            start: 'startOrder',
            complete: 'completeOrder',
            cancel: 'cancelOrder'
        };
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(mutMap[action], {
                orderId: orderId
            });
            const updated = data[fieldMap[action]];
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        status: updated.status
                    } : o));
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderStatus'));
            console.error('[orderTransition]', action, e);
        } finally{
            setOrderTransitioning(null);
        }
    };
    // One-click انجام for services the clinic declares (in-house): marks the order
    // done. The backend lifecycle is pending → in_progress → completed with no
    // shortcut, so a pending order is started first, then completed — completion is
    // what publishes accounting.medical_service.done for billing.
    const handleOrderDone = async (order)=>{
        if (orderTransitioning) return;
        setOrderTransitioning(order.id);
        setOrderError(null);
        try {
            if (order.status === 'pending') {
                const startData = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$a829ddd2566c75b7), {
                    orderId: order.id
                });
                const started = startData?.startOrder;
                // The START result is written back BEFORE the second hop, and that is
                // the whole point of this branch. The list is loaded exactly once per
                // encounter (`ordersLoadedFor` fences the only refetch), so the row's
                // local status is the only status this screen will ever have. Throwing
                // the result away left it saying «در انتظار» while the server had
                // already moved to in_progress: the retry re-entered this branch,
                // re-sent StartOrder, and clinicalencounter refused it
                // (FAILED_PRECONDITION — only a pending order can be started), so
                // CompleteOrder was never reached. «لغو» failed for the same reason,
                // and the order could be neither finished nor retracted until the
                // doctor left the visit and came back. Visit.mobile.jsx has always
                // chained through handleOrderTransition, which does write it back.
                if (started) setClinicalOrders((prev)=>prev.map((o)=>o.id === order.id ? {
                            ...o,
                            status: started.status
                        } : o));
            }
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$b0b354e2ddeac24b), {
                orderId: order.id
            });
            const updated = data?.completeOrder;
            if (updated) setClinicalOrders((prev)=>prev.map((o)=>o.id === order.id ? {
                        ...o,
                        status: updated.status
                    } : o));
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderDone'));
            console.error('[orderDone]', e);
        } finally{
            setOrderTransitioning(null);
        }
    };
    const handleCancelEncounter = async ()=>{
        if (!visitId || cancellingVisit) return;
        setCancellingVisit(true);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$337c36ab78c979c4), {
                id: visitId
            });
            if (isRecording) stopRec();
            setVisitId(null);
            setVisitStatus(null);
            setPmEncounterId(null);
            // Cancelled visit leaves nothing behind: drop the recovery draft and leave
            // the visit screen. navProp (not the wrapped navigate) — this closure still
            // sees visitStatus 'inprogress', which would re-arm the leave guard.
            try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            navProp('patient-detail', {
                id: patient?.id
            });
        } catch (e) {
            console.error('[cancelEncounter]', e);
        } finally{
            setCancellingVisit(false);
        }
    };
    // ── پایان ویزیت ───────────────────────────────────────────────────────────
    // The write sequence itself lives in `useEndVisit` — it is identical on the
    // phone, and keeping two copies of "what ending a visit does" is how the two
    // forks drift on the one thing they must agree about. What stays here is the
    // three things the SCREEN does with the result.
    const runEnd = async ()=>{
        setPendingEnd(false);
        if (!visitId || endProgress.running) return;
        if (isRecording) stopRec();
        const outcome = await startEndVisit();
        if (outcome === 'stopped-interaction') {
            // The sweep used to abort in silence: the doctor was dropped into the نسخه
            // tab with no message and no idea why the visit had not ended, and the
            // obvious next move — pressing پایان ویزیت again — just repeated it.
            setWorkTab('rx');
            setInteractionStop(true);
            toast?.warn?.(t('visit.end.stoppedForInteraction'));
            return;
        }
        if (outcome === 'failed') {
            // The sequence itself broke, so the visit is still open. Refusing to show
            // the closure is the point: "the visit is complete" would be a lie.
            toast?.error?.(t('visit.end.failedToast'));
            return;
        }
        // `partial` comes back from the hook rather than being read off its state:
        // this closure captured the previous render, so `saveFailures` here would
        // still be the empty array it was before the sequence ran.
        if (outcome === 'partial') toast?.error?.(t('visit.end.partialSaveToast'));
        setShowClosureFlow(true);
    };
    // Leaving the closure returns to پذیرش, not to the record: the visit is over
    // and the next thing the doctor does is call the next patient. The record is
    // one tap away from the queue for the rare case they want to re-read it.
    const goToReception = ()=>{
        setShowClosureFlow(false);
        // `from` is how پذیرش knows to take focus on arrival. The closure owned the
        // screen and the button that opened it no longer exists, so there is
        // nothing for the dialog to hand focus back to — without this it lands on
        // <body> and a keyboard user tabs from the top of the document (§12.2).
        navigate('reception', {
            from: 'visit-closure'
        });
    };
    // ── Load the AI visit summaries for the context panel ────────────────────
    // Fetched to the sheet's depth, not the rail's: the sheet lists every visit
    // the rail summarises plus the rest, and a summary missing there reads as
    // "this visit had no summary" rather than "we only asked for four".
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || pastVisitSummaries !== null) return;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$815cd81bee1aa526), {
            patientId: patient.id,
            limit: $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX
        }).then((data)=>setPastVisitSummaries(data.patientVisitHistory?.visits || [])).catch(()=>setPastVisitSummaries([]));
    }, [
        patient?.id
    ]);
    // The patient's finished visits, newest first, minus the one in progress.
    const pastVisits = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$89161e2370097cc4)(patient?.encounters, {
            limit: $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX,
            excludeId: pmEncounterId || visitId
        }), [
        patient?.encounters,
        pmEncounterId,
        visitId
    ]);
    const railVisits = (0, $acw62.useMemo)(()=>pastVisits.slice(0, $9b4ee9e6346f75da$var$VISIT_HISTORY_PREVIEW), [
        pastVisits
    ]);
    // «مدارک بیمار» (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1). The
    // patient's whole library, this visit's documents first; «جدید» counts what the
    // PATIENT sent since the last finished visit (or the last 30 days without one).
    const currentVisitId = pmEncounterId || visitId || null;
    const visitFiles = (0, $acw62.useMemo)(()=>{
        const all = patient?.clinicalFiles || [];
        const { thisVisit: thisVisit, others: others } = (0, $bced050439dec003$export$dfcaeb32ab9590ba)(all, currentVisitId);
        const since = pastVisits[0]?.scheduledDate || new Date(Date.now() - 2592000000).toISOString();
        return {
            all: all,
            thisVisit: thisVisit,
            others: others,
            ordered: [
                ...thisVisit,
                ...others
            ],
            newCount: (0, $bced050439dec003$export$d15fc12d83f90a2c)(all, since)
        };
    }, [
        patient?.clinicalFiles,
        currentVisitId,
        pastVisits
    ]);
    // The review's «افزودن به نسخه ویزیت» lands in the نسخه picker below; the ref lets
    // the files host be built before the drug handlers it reaches are.
    const docRxCapability = (0, $acw62.useRef)(null);
    const addToVisitPrescription = (0, $acw62.useCallback)((draft)=>docRxCapability.current?.(draft), []);
    const clinicalFiles = (0, $489287129a199b1d$export$513d4933d99292ab)({
        patient: patient,
        files: visitFiles.all,
        appointmentId: currentVisitId,
        onChanged: refreshPatient,
        onAddToVisitPrescription: addToVisitPrescription
    });
    // One row for the rail and the sheet; from the sheet, an action closes it first so
    // only one overlay is ever open (DESIGN_CONCEPT §5.2).
    const renderVisitFile = (f, fromSheet = false)=>{
        const via = (fn)=>(file, opts)=>{
                if (fromSheet) setRecordSheet(null);
                fn(file, opts);
            };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$2e2bcd8739ae039), {
            key: f.id,
            file: f,
            dense: true,
            testid: "record-file",
            onOpen: via(clinicalFiles.openDetail),
            onView: via(clinicalFiles.openViewer),
            onExtract: via((file)=>clinicalFiles.openExtract(file)),
            onEdit: via((file)=>clinicalFiles.openDetail(file, {
                    edit: true
                })),
            onDownload: clinicalFiles.download,
            onDelete: via(clinicalFiles.requestDelete)
        });
    };
    const renderVisitFileList = (list, fromSheet = false)=>list.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: f.id
            }, i === 0 && f.appointmentId === currentVisitId && currentVisitId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: 'var(--mute)',
                    padding: '4px 0 2px'
                }
            }, t('visit.files.thisVisit')), i > 0 && currentVisitId && list[i - 1].appointmentId === currentVisitId && f.appointmentId !== currentVisitId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: 'var(--mute)',
                    padding: '8px 0 2px'
                }
            }, t('visit.files.otherDocuments')), renderVisitFile(f, fromSheet)));
    const summaryMap = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$22c958772a7f76e1)(pastVisitSummaries), [
        pastVisitSummaries
    ]);
    // Prefetch only what the rail shows. The sheet loads the rest as each visit is
    // opened, so a patient with forty visits still costs three calls on mount.
    const railVisitKey = railVisits.map((v)=>v.id).join(',');
    (0, $acw62.useEffect)(()=>{
        railVisits.forEach((v)=>loadVisitContext(v.id));
    }, [
        railVisitKey,
        loadVisitContext
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // ── Elapsed timer (ticks only while visit is in progress) ─────────────────
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const timer = setInterval(()=>setElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        visitStatus
    ]);
    // ── Recording timer (resets to 0 each time recording starts) ──────────────
    (0, $acw62.useEffect)(()=>{
        // A system pause FREEZES the count rather than resetting it: the doctor
        // should see how long the interrupted segment ran. It bills nothing
        // either way — the ledger line is the BFF's now (§3.1 A5).
        if (isRecPaused) return undefined;
        if (!isRecording) {
            setRecElapsed(0);
            return undefined;
        }
        const timer = setInterval(()=>setRecElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        isRecording,
        isRecPaused
    ]);
    // ── The transcription line, read back rather than written (§3.1 A5) ───────
    const wasRecordingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const was = wasRecordingRef.current;
        wasRecordingRef.current = isRecording;
        if (!was || isRecording) return undefined;
        const first = setTimeout(refetchCoins, 1200);
        const second = setTimeout(refetchCoins, 6000);
        return ()=>{
            clearTimeout(first);
            clearTimeout(second);
        };
    }, [
        isRecording,
        refetchCoins
    ]);
    // ── Auto-start or resume encounter when patient loads ────────────────────
    // Checks for an active in-progress encounter on the server first.
    // If found for this patient, restores visitId/status and pulls SOAP draft
    // from localStorage instead of creating a duplicate encounter.
    const autoStarted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || visitId || autoStarted.current) return;
        autoStarted.current = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$13ca7cd8c39f4461)).then((data)=>{
            const enc = data?.getActiveEncounter;
            if (enc?.id && enc.patientId === patient.id && enc.status === 'in_progress') {
                setVisitId(enc.id);
                setPmEncounterId(enc.id);
                setVisitStatus('inprogress');
                setResumedVisit(true);
                // Restore draft from localStorage — it's the only recovery path now;
                // enc.notes/enc.diagnosis no longer exist on Encounter, so there is no
                // server-side fallback anymore.
                try {
                    const raw = localStorage.getItem(`visit_draft_${patient.id}`);
                    if (raw) {
                        const draft = JSON.parse(raw);
                        if (draft.visitId === enc.id && Date.now() - draft.ts < 3600000) {
                            if (draft.soap) setSoap(draft.soap);
                            if (draft.rxItems?.length) setRxItems(draft.rxItems);
                            if (draft.diagnosis) setDiagnosis(draft.diagnosis);
                        }
                    }
                } catch  {}
                // Re-initialize AI session and differential for the resumed encounter
                setSessionReady(false);
                (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$781b4a03507fea1f), {
                    visitId: enc.id,
                    patientId: patient.id
                }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            } else handleStart();
        }).catch(()=>handleStart());
    }, [
        patient?.id
    ]);
    // ── Leave-guard ───────────────────────────────────────────────────────────
    // window.__parsina_visit_guard: called by WebLayout/AppShell before navigating.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus === 'inprogress') window.__parsina_visit_guard = (proceedFn)=>{
            pendingNavRef.current = {
                callback: proceedFn
            };
            setLeaveConfirm(true);
        };
        else window.__parsina_visit_guard = null;
        return ()=>{
            window.__parsina_visit_guard = null;
        };
    }, [
        visitStatus
    ]);
    // ── The leave-guard's history anchor (spec §C.3 rule 2) ──────────────────
    // A browser/platform back asks «خروج از ویزیت؟» through the anchor; a leave the
    // doctor has confirmed goes through `leaveVisit`, so it is not asked twice
    // (PM-0135). The anchor, the overlay rules and the unwind depth live in the hook.
    const leaveVisit = (0, $f987ed8f19153509$export$b78e23134a4d4c2b)({
        active: visitStatus === 'inprogress',
        visitKey: patient?.id,
        onRequest: (proceed)=>{
            pendingNavRef.current = {
                callback: proceed
            };
            setLeaveConfirm(true);
        },
        back: goBack
    });
    // Wrap the prop-based navigate so it also goes through the guard
    const navigate = (...args)=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = args;
            setLeaveConfirm(true);
        } else navProp(...args);
    };
    // ── Layer 1: Warn before accidental page close ────────────────────────────
    // beforeunload works on desktop Chrome/Firefox/Edge but is suppressed by
    // iOS Safari. Layers 1b handles iOS via visibilitychange + pagehide.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const onUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', onUnload);
        return ()=>window.removeEventListener('beforeunload', onUnload);
    }, [
        visitStatus
    ]);
    // ── Layer 1b: iOS / Android — immediate flush on page hide ───────────────
    // iOS Safari never fires beforeunload. visibilitychange (hidden) + pagehide
    // are the reliable signals that the page is about to die. When fired we
    // immediately write localStorage AND attempt a server save so no work is
    // lost between 30-second auto-save ticks.
    // Use a ref so the handlers always see the latest state without re-registering
    // on every keystroke.
    const draftFlushRef = (0, $acw62.useRef)(null);
    draftFlushRef.current = (recording = null)=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now(),
                // §3.1 A2: the live transcript and the elapsed count exist only in
                // the transcription hook's memory, and the page is about to be
                // frozen. They ride into the draft so a reloaded tab still has what
                // was said before the interruption.
                ...recording ? {
                    recording: recording
                } : null
            }));
        } catch  {}
    };
    // Called INSIDE the `visibilitychange` handler — the last moment JS is
    // guaranteed to run — so it must stay synchronous.
    systemPauseRef.current = (snapshot)=>draftFlushRef.current(snapshot);
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress' || !visitId) return;
        const onVis = ()=>{
            if (document.visibilityState === 'hidden') draftFlushRef.current();
        };
        const onHide = ()=>draftFlushRef.current();
        document.addEventListener('visibilitychange', onVis);
        window.addEventListener('pagehide', onHide);
        return ()=>{
            document.removeEventListener('visibilitychange', onVis);
            window.removeEventListener('pagehide', onHide);
        };
    }, [
        visitStatus,
        visitId
    ]);
    // ── Layer 2: Save draft to localStorage on every SOAP / rx / diagnosis change
    // Keyed by patientId so recovery can find it even if the component remounts.
    (0, $acw62.useEffect)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now()
            }));
        } catch  {}
    }, [
        soap,
        rxItems,
        diagnosis,
        visitId,
        visitStatus
    ]);
    // Layer 3 (server auto-save every 30s) removed — VisitInput no longer accepts
    // notes/diagnosis/prescription; the Layer 2 localStorage draft above is the
    // only persistence for in-progress drafts now.
    // ── Fetch/refresh differential diagnosis ─────────────────────────────────
    //
    // Nothing below runs — not the visit-open call, not the loop, not the refresh
    // button — until «S» carries a chief complaint and the history behind it. The
    // panel says so rather than sitting empty. Clinical monitoring is NOT part of
    // this: it is one way of filling «S», not a licence to reason from it.
    const diffGate = (0, $375f8776645d5aee$export$8b03bbb666cde734)({
        soap: soap
    });
    const diffReady = diffGate.ready;
    const diffReadyRef = (0, $acw62.useRef)(false);
    diffReadyRef.current = diffReady;
    // One in-flight request at a time. Every call re-runs the assessment against
    // whatever the visit knows at that moment, so two overlapping calls answer the
    // same question twice — and a poll that ticks while the previous one is still
    // out would stack requests without ever showing a newer answer.
    const diffInFlightRef = (0, $acw62.useRef)(false);
    // Moves whenever a confirm/dismiss leaves or settles — see
    // trackDifferentialDecision. A poll whose answer comes back with it moved
    // must not undo that decision on screen.
    const diffDecisionSeqRef = (0, $acw62.useRef)(0);
    const fetchDifferential = (0, $acw62.useCallback)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        if (!diffReadyRef.current) return;
        if (diffInFlightRef.current) return;
        diffInFlightRef.current = true;
        setDiffLoading(true);
        const decisionSeq = diffDecisionSeqRef.current;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$bc9f2df565557d4f), {
            visitId: visitId
        }).then((data)=>{
            const newItems = data.getDifferentialDiagnosis?.items || [];
            // Only a call that actually re-ran the assessment billed the wallet
            // (`regenerated` — the AI service's own charge gate). Recording a
            // charge for every poll used to overstate a 10-minute visit by
            // hundreds of Parseh against a wallet that debited a fraction of it.
            if (data.getDifferentialDiagnosis?.regenerated) chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('DIFFERENTIAL'), 'differential');
            const stale = diffDecisionSeqRef.current !== decisionSeq;
            setDifferential((prev)=>(0, $375f8776645d5aee$export$24f67d3076448bf7)(prev, newItems, {
                    stale: stale
                }));
        }).catch(()=>{}).finally(()=>{
            diffInFlightRef.current = false;
            setDiffLoading(false);
        });
    }, [
        visitId,
        visitStatus,
        chargeVisit
    ]);
    // Settings → دستیار هوشمند → «اجرای خودکار تشخیص افتراقی». It gates the two
    // AUTOMATIC paths below only; the list's «به‌روزرسانی» button still calls
    // fetchDifferential directly, so turning this off means "don't run it for
    // me", not "take the feature away". Undefined reads as on.
    const autoDifferential = !aiSettingsUnknown && ai.autoDifferentialOnStart !== false;
    // Only fetch differential after session init is done — avoids race condition
    // where AI service has no session data and returns the empty fallback.
    // diffReady is a real dependency, not just the ref read inside
    // fetchDifferential: on a page reload the saved SOAP note is still in flight
    // when sessionReady flips, so the fetch used to be skipped by the readiness
    // guard and never retried (nothing else fetches unless recording) — the list
    // then only showed up after a remount, where the localStorage draft restores
    // SOAP first. It now also carries clinical monitoring, so the first automatic
    // run happens when the visit is genuinely under way rather than the moment a
    // stale draft is restored.
    // Latched per visit so this stays ONE automatic call (each one bills credits).
    const autoDiffVisitRef = (0, $acw62.useRef)(null);
    // What each SOAP section said when the doctor put the caret in it. `onInput`
    // writes every keystroke into `soap`, so by the time blur runs the state and
    // the field already agree — comparing them would answer "nothing changed" for
    // every edit ever made. The entry value is the only thing that still knows.
    const soapEntryTextRef = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(()=>{
        if (!sessionReady || !autoDifferential || !diffReady) return;
        if (autoDiffVisitRef.current === visitId) return;
        autoDiffVisitRef.current = visitId;
        fetchDifferential();
    }, [
        sessionReady,
        autoDifferential,
        diffReady,
        visitId,
        fetchDifferential
    ]);
    // ── Re-assessment while the visit is live ────────────────────────────────
    //
    // Each tick is a full re-evaluation, not a cache read: the AI service rebuilds
    // the list from the transcript as it has grown, SOAP notes saved since, and
    // vitals recorded since, and returns the stored list untouched when none of
    // those moved. So the cadence decides how often the differential is allowed to
    // change its mind — which is a clinical preference, and now the doctor's.
    //
    // Settings → دستیار هوشمند set the standing preference (and honour the master
    // «اجرای خودکار تشخیص افتراقی» switch, because polling is a kind of automatic
    // run). `useDifferentialPolling` layers this visit's own on/off on top, so the
    // toolbar switch below changes the loop for THIS visit without touching them.
    const { active: pollingActive, pollMs: pollMs, seconds: pollSeconds, overridden: pollOverridden, toggle: togglePolling } = (0, $375f8776645d5aee$export$3f0d5a0b11f5b929)(ai, aiSettingsUnknown, visitId);
    (0, $acw62.useEffect)(()=>{
        if (!pollingActive) return;
        // Recording is this LOOP's own prerequisite, not the differential's: each
        // tick exists to re-ask as the conversation grows, and with nothing being
        // transcribed there is nothing new to re-ask about — it would re-answer the
        // same note and bill for it. A doctor who writes the history by hand still
        // gets the differential; they get it on their own «به‌روزرسانی».
        if (!diffReady || recState !== 'recording') return;
        if (!visitId || visitStatus !== 'inprogress') return;
        // A hidden tab is nobody reading the list. The visit keeps recording — this
        // only defers the re-assessment, which the next visible tick picks up with
        // MORE context than it would have had, not less.
        const tick = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchDifferential();
        };
        const initial = setTimeout(tick, Math.min((0, $375f8776645d5aee$export$d3a7b2340b0c9d48), pollMs));
        const interval = setInterval(tick, pollMs);
        return ()=>{
            clearTimeout(initial);
            clearInterval(interval);
        };
    }, [
        diffReady,
        recState,
        visitId,
        visitStatus,
        fetchDifferential,
        pollingActive,
        pollMs
    ]);
    // Reset confirmation state only when the actual set of active diagnosis codes changes,
    // not on every poll (differential is a new array reference each fetch even with same data).
    // A refresh REVISES the list — a diagnosis that survives the reassessment keeps
    // its questions and the answers already recorded against it.
    const prevDiffCodesRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const active = (differential || []).filter((d)=>d.status !== 'rejected').map((d)=>d.diagnosisCode);
        const codes = [
            ...active
        ].sort().join(',');
        if (prevDiffCodesRef.current !== null && prevDiffCodesRef.current !== codes) {
            setDiagAIQuestions((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagAIAnswers((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagQSubmitting((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setDiagQError((prev)=>(0, $375f8776645d5aee$export$7904c2b41f6b4e23)(prev, active));
            setOpenAIDiag((prev)=>prev && active.includes(prev) ? prev : null);
        }
        prevDiffCodesRef.current = codes;
    }, [
        differential
    ]);
    // Load clinical orders when orders tab opens
    // Loaded as soon as the encounter is known, NOT when the دستورات tab opens: the
    // plan block lists these orders, so a doctor who goes straight to «برنامه» must
    // see them there without having visited the tab first. The tab remains a retry
    // point for a fetch that failed.
    const ordersLoadedFor = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || ordersLoadedFor.current === encId) return;
        ordersLoadedFor.current = encId;
        loadClinicalOrders(encId).then((ok)=>{
            if (!ok) ordersLoadedFor.current = null;
        });
    }, [
        workTab,
        pmEncounterId,
        visitId
    ]);
    // What the orders ALREADY on the chart need from the catalogue.
    //
    // This used to be a reason to fetch the whole dictionary — the plan block wants
    // English names and the list wants the «انجام» button, so «any visit that HAS
    // orders» fetched everything whatever tab was open. It is a lookup by id, and
    // is now asked as one. Orders written before catalogIds existed are resolved by
    // name; an ambiguous name resolves to nothing rather than to a guess.
    const resolveKey = (0, $acw62.useMemo)(()=>clinicalOrders.map((o)=>o?.catalogId || (o?.description || '').trim()).filter(Boolean).sort().join('\u0000'), [
        clinicalOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!resolveKey) {
            setCatalogResolved(new Map());
            return undefined;
        }
        let live = true;
        const ids = clinicalOrdersRef.current.map((o)=>o?.catalogId).filter(Boolean);
        const names = clinicalOrdersRef.current.filter((o)=>!o?.catalogId).map((o)=>(o?.description || '').trim()).filter(Boolean);
        (0, $375f8776645d5aee$export$ff3759fdd9615d20)({
            ids: ids,
            names: names,
            appointmentId: pmEncounterId || visitId
        }).then((rows)=>{
            if (!live) return;
            const m = new Map();
            for (const r of rows){
                m.set(r.id, r);
                if (r.matchedName) m.set(r.matchedName, r); // so orderNameEn can find it by description
            }
            (0, $375f8776645d5aee$export$69d0d94972917188)(rows); // the closure card reads these by name
            setCatalogResolved(m);
        }).catch((err)=>{
            // A failed resolve costs a badge and an English name, never the visit.
            // It must NOT leave a half-filled map: a plan block written from one
            // would be saved with some lines translated and some not.
            console.error('order catalogue resolve failed:', err);
        });
        return ()=>{
            live = false;
        };
    }, [
        resolveKey,
        pmEncounterId,
        visitId
    ]);
    // The picker's page. One search per pause in typing, per type, and the reply to
    // an older query never overwrites a newer one.
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'orders' || orderDraftType === 'other') return undefined;
        // Nothing is listed until the doctor searches (PM-0098, as on the نسخه): the
        // picker used to open on the first page of the catalogue.
        if (orderSearch.trim().length < (0, $375f8776645d5aee$export$6770277ab0ca292e)) {
            setCatalogPage({
                entries: [],
                total: 0,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setCatalogPage((prev)=>({
                ...prev,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $375f8776645d5aee$export$14e053085c2b7017)({
                query: orderSearch,
                orderType: orderDraftType,
                appointmentId: pmEncounterId || visitId
            }).then((page)=>{
                if (live) setCatalogPage({
                    ...page,
                    loading: false,
                    error: null
                });
            }).catch((err)=>{
                if (!live) return;
                // Shown, not swallowed: a picker that silently returns nothing is
                // indistinguishable from a catalogue that does not carry the service.
                console.error('order catalog search failed:', err);
                setCatalogPage({
                    entries: [],
                    total: 0,
                    loading: false,
                    error: err?.message || 'error'
                });
            });
        }, 250);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        workTab,
        orderDraftType,
        orderSearch,
        pmEncounterId,
        visitId
    ]);
    // ── Clinical insight pass ──────────────────────────────────────────────────
    // The one pass, callable from two places: the automatic effect below and the
    // «دریافت نکات بالینی» button in the نکات بالینی tab. Only the response's
    // `clinicalRationale` reaches the feed — its test/medication halves are
    // orders, and they belong to «دستورات» and «نسخه». Failures are kept rather
    // than swallowed — a silently empty panel is indistinguishable from "the AI
    // had nothing to say", which is the one thing it must never be confused with.
    const runRecommendations = (0, $acw62.useCallback)(()=>{
        if (!patient?.id) return;
        const conditions = (patient.clinicalConditions || []).map((c)=>c.code || c.display).filter(Boolean);
        setRecsError(null);
        setRecsLoading(true);
        return (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$19b465740ee91bc), {
            input: {
                patientId: patient.id,
                icdCodes: conditions.slice(0, 5),
                age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                gender: '',
                existingMedications: (patient.clinicalMedications || []).filter((m)=>m.status === 'active').map((m)=>m.display),
                existingTests: []
            }
        }).then((data)=>{
            setRecommendations(data.recommendTestsAndMedications);
            setRecsRan(true);
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('RECOMMENDATIONS'), 'recs');
        }).catch((err)=>{
            console.error('[recommendations]', err);
            setRecsError(err?.message || t('errors.ai.suggestionsFailed'));
        }).finally(()=>setRecsLoading(false));
    }, [
        patient,
        chargeVisit,
        t
    ]);
    // Auto-fire it when the patient loads — but only if the doctor has left the
    // automation on. `suggestionsAutoRun` is in the deps on purpose: turning the
    // setting on mid-visit must start the pass, not wait for a remount.
    (0, $acw62.useEffect)(()=>{
        // Nothing is decided while the settings are still loading — otherwise the
        // default-on fallback fires the pass and latches recsAutoFired before the
        // doctor's actual choice is known.
        if (aiSettingsUnknown) return;
        if (!patient?.id || recsAutoFired.current) return;
        if (!suggestionsAutoRun) return;
        recsAutoFired.current = true;
        runRecommendations();
    }, [
        patient,
        aiSettingsUnknown,
        suggestionsAutoRun,
        runRecommendations
    ]);
    // ── Drug management ────────────────────────────────────────────────────────
    // None of these touch the SOAP «P» text. They used to: addDrug appended a line
    // to «P» from inside the setRxItems updater — an impure updater, and a one-way
    // append that no later edit or delete could take back. The plan block is
    // derived from rxItems instead (see the reconciler below), so add / edit /
    // remove stay pure list operations and the text follows automatically.
    //
    // One entry point for every source of a prescribed drug — the catalogue
    // picker, the AI panel, and an applied treatment plan all land here, so a
    // medication has the same shape whichever door it came through. `defaults`
    // carries the picker's batch fields; anything the caller does not set falls
    // back to the formulary's own first common dose/frequency.
    // مقدار تحویلی, when not given, is worked out from the line's دوز × تناوب × مدت
    // (withAutoQuantity) — the e-prescription refuses a line without one.
    // «داروهای پرتکرار من», by drug: the doctor's last sig for it, on today's lists.
    const rxLists = (0, $acw62.useMemo)(()=>({
            routes: (0, $375f8776645d5aee$export$e730a0734bbb1219)(),
            durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
        }), [
        t
    ]);
    const usualRx = (0, $acw62.useMemo)(()=>new Map(frequentDrugs.filter((f)=>f.drug?.id).map((f)=>[
                f.drug.id,
                (0, $ace44487380106d3$export$fd52a5511e853f43)(f, rxLists)
            ]).filter(([, u])=>u)), [
        frequentDrugs,
        rxLists
    ]);
    // What a product opens the add form with: the doctor's own last sig for it where
    // there is one, else the product's — one unit of its form, the formulary's
    // frequency, the route its name states (as the route's VALUE, never a
    // translated label: K1, 2026-10-03) — and a one-week course (rxAddDefaults).
    const rxDefaultsFor = (0, $acw62.useCallback)((drug)=>(0, $ace44487380106d3$export$87bc9af39161d883)(drug, usualRx.get(drug.id), {
            defaultDuration: t('visit.duration.d7')
        }), [
        usualRx,
        t
    ]);
    // One unit of the product's form, never the formulary's first dose: a تأمین
    // row's list holds its STRENGTH («5 MG»), which the e-prescription refuses. The
    // shape itself is lib/rxOptions.js newRxLine — the phone makes its lines there too.
    // An empty مدت or تناوب on a new line follows from a given quantity (newRxLine).
    const makeRxItem = (0, $acw62.useCallback)((drug, defaults = {}, seq = 0)=>(0, $ace44487380106d3$export$5352dbb17a06665d)(drug, defaults, seq, {
            durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
        }), [
        t
    ]);
    const addDrug = (0, $acw62.useCallback)((drug, defaults)=>{
        setRxItems((prev)=>{
            if (prev.find((r)=>r.drug.id === drug.id)) return prev;
            return [
                ...prev,
                makeRxItem(drug, defaults)
            ];
        });
    }, [
        makeRxItem
    ]);
    // «افزودن به نسخه ویزیت» from a document review (§23.3 A13). The line is NOT added:
    // the add form opens on it, prefilled with the document's sig — on the closed
    // lists where the paper named an option, as written where it did not — and it
    // becomes a نسخه line only by that form's «افزودن به نسخه», the same door as a
    // drug the doctor searched for (so the «P» block follows as usual).
    const prefillRxFromDocument = (0, $acw62.useCallback)(({ drug: drug, defaults: defaults })=>{
        if ((0, $622fea85856450c1$export$26bd9984be9bfd1c)(rxItemsRef.current, drug)) return 'alreadyPrescribed';
        queueRxAdds([
            {
                key: `document:${drug.id}:${Date.now()}`,
                drug: drug,
                defaults: (0, $ace44487380106d3$export$2e037991db2fc726)(drug, defaults, rxLists),
                sourceLabel: t('visit.rx.documentDraft.title')
            }
        ]);
        setWorkTab('rx');
        return 'prefilled';
    }, [
        rxLists,
        t,
        queueRxAdds
    ]);
    docRxCapability.current = prefillRxFromDocument;
    // «داروهای پرتکرار من» — once per visit, and optional: without it every drug
    // starts from the product's sig.
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'rx' || frequentDrugsFetched.current) return;
        frequentDrugsFetched.current = true;
        (0, $375f8776645d5aee$export$9b2f95caa9aaf04d)().then(setFrequentDrugs).catch((err)=>console.error('[rx] myFrequentDrugs failed:', err));
    }, [
        workTab
    ]);
    // Already on the نسخه — checking it again would be a no-op, so the row says so.
    const prescribedDrugIds = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    // Rows that already exist server-side — everything a template put here, and
    // everything read back when this visit was reopened — are edited and deleted
    // through the record, not only in local state. See useVisitRxPersistence.
    const rxPersistence = (0, $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // The in-visit e-prescription card re-reads when the نسخه or the دستورات change —
    // once they have settled, so a dose being typed is not re-read per keystroke.
    const erxContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            clinicalOrders.map((o)=>[
                    o.id,
                    o.status
                ])
        ]), [
        rxItems,
        clinicalOrders
    ]);
    const [erxRefreshKey, setErxRefreshKey] = (0, $acw62.useState)(erxContent);
    (0, $acw62.useEffect)(()=>{
        if (!erxOpen) return undefined;
        const h = setTimeout(()=>setErxRefreshKey(erxContent), 900);
        return ()=>clearTimeout(h);
    }, [
        erxContent,
        erxOpen
    ]);
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        // applyRxEdit: a دوز/تناوب/مدت change carries a worked-out quantity along.
        // A doctor's own edit ends the line's «پیشنهاد هوش مصنوعی» mark, and — on a
        // line whose removal failed — the «حذف نشد» mark: they are keeping it.
        // Any two of مقدار تحویلی / تناوب / مدت settle an empty third (applyRxEdit).
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $ace44487380106d3$export$b0f426f8468d8007)(r, key, val, {
                        durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                    }),
                    aiNote: undefined,
                    removeFailed: undefined
                } : r));
        rxPersistence.scheduleSave(id);
    }, [
        rxPersistence,
        t
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete FIRST: the hook reads the row it is deleting out of the list it
        // last saw, and clearing local state before that would leave it nothing to
        // find and the record row orphaned.
        rxPersistence.deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
        // A result naming a drug that is no longer on the list is worse than no
        // result, so a removal clears it outright rather than marking it stale.
        setRxInteractions(null);
        setIxError(null);
    }, [
        rxPersistence
    ]);
    // ── Applying a «قالب نسخه» ──────────────────────────────────────────────────
    //
    // The server has already created the rows; this only shows them. They arrive
    // as ordinary نسخه rows carrying their own ids, so from here on they are
    // edited, removed and printed exactly like a drug the doctor typed — which is
    // the property the whole feature is for.
    const handleMedicationTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        setRxItems((prev)=>(0, $5e2e0b7ea22d1ff2$export$801d163b2e9340ef)(prev, (result?.medications || []).map((0, $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1))));
        // A displayed interaction result was computed against the old list.
        if (outcome.applied) {
            setRxInteractions(null);
            setIxError(null);
        }
        const message = (0, $737671bfbc703ec9$export$9694ceada819b6a5)('medication', result, outcome, t, formatList);
        // A partial apply is reported as an error, not a success: the sentence
        // names drugs the doctor still has to add by hand, and a green toast is
        // read as "done" and dismissed.
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    const handleOrderTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        const orders = result?.orders || [];
        setClinicalOrders((prev)=>(0, $5e2e0b7ea22d1ff2$export$3c2b35db6130bf21)(prev, orders));
        // Same mirror the manual دستورات form does, so the printed نسخه and the
        // end-of-visit flush see a template-placed order like any other.
        // `savedToBackend: true` — applying a template is a SERVER write: these
        // orders exist already. Mirroring them as unsaved would have the
        // end-of-visit flush create every one of them a second time.
        orders.forEach((o)=>mirrorOrderToPendingTests({
                type: o.orderType,
                name: o.description,
                urgency: o.urgency,
                reason: o.notes || '',
                code: o.code || '',
                loincCode: o.code || ''
            }, {
                savedToBackend: true
            }));
        const message = (0, $737671bfbc703ec9$export$9694ceada819b6a5)('order', result, outcome, t, formatList);
        // A partial apply is reported as an error, not a success: the sentence
        // names drugs the doctor still has to add by hand, and a green toast is
        // read as "done" and dismissed.
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    // Only diagnoses the doctor has ACCEPTED reach the rule engine, so a reshuffle
    // of the suggestions below them does not change the clinical picture a check
    // was run against.
    const acceptedDiagnoses = (0, $acw62.useMemo)(()=>(differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((d)=>d.description), [
        differential
    ]);
    const acceptedDiagnosesKey = acceptedDiagnoses.join(' ');
    // The interaction check runs ONLY when the doctor asks for it. It used to fire
    // itself 800ms after any change to rxItems or the accepted diagnoses, so the
    // doctor was interrupted — and billed — mid-thought, over a prescription that
    // wasn't finished enough to judge yet. The one check that still runs unasked is
    // the sweep in `useEndVisit`, and it speaks up only for a high-severity finding:
    // that is the backstop for a doctor who never pressed this button, not a second
    // opinion on one who did.
    //
    // `signature` records the rx list + clinical picture the displayed result was
    // computed from; when it stops matching, the result is stale and says so
    // instead of silently re-running.
    const rxSignature = (0, $acw62.useMemo)(()=>(0, $375f8776645d5aee$export$73a34cab37d00ce4)(rxItems, acceptedDiagnosesKey), [
        rxItems,
        acceptedDiagnosesKey
    ]);
    // The stop banner describes a finding computed from one prescription; editing
    // that prescription makes it a statement about a list that no longer exists.
    (0, $acw62.useEffect)(()=>{
        setInteractionStop(false);
    }, [
        rxSignature
    ]);
    // ── The end-of-visit write sequence ───────────────────────────────────────
    // Placed here rather than beside the other state because it reads
    // `rxSignature`: a sweep result the doctor is shown must carry the signature
    // of the prescription it was computed from, or the نسخه tab reports it as
    // fresh forever.
    const { endProgress: endProgress, saveFailures: saveFailures, failedGroups: failedGroups, retrying: retrying, start: startEndVisit, retryFailed: retryFailed, endedAt: endedAt, durationMin: durationMin } = (0, $be5cdb537ae81129$export$2e2bcd8739ae039)({
        t: t,
        visitId: visitId,
        pmEncounterId: pmEncounterId,
        soapNoteId: soapNoteId,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        patient: patient,
        diagnosis: diagnosis,
        differential: differential,
        rxInteractions: rxInteractions,
        rxSignature: // What the sweep reads `rxInteractions` against: a result counts as "shown"
        // only for the نسخه it was computed from (interactionSeen.js).
        rxSignature,
        elapsedSeconds: elapsed,
        chargeVisit: // The closure sweep is a billed AI call; the hook charges it to the visit.
        chargeVisit,
        // «بررسی تداخل دارویی در پایان ویزیت». The only automation switch that is
        // about safety rather than spend, so it is the only one that survives an
        // unknown settings state — see `endVisitSweepOn`.
        interactionSweepEnabled: endVisitSweepOn,
        // Marking the visit finished immediately is what stops every reactive AI
        // effect (SOAP refine, differential regen) from firing into a closed visit;
        // their cleanups run here too.
        onVisitClosed: ()=>{
            setVisitStatus('finished');
            setSoapNoteId(null);
        },
        onInteractionFound: (warnings)=>{
            setRxInteractions({
                hasInteractions: true,
                warnings: warnings,
                signature: rxSignature
            });
        }
    });
    // The in-visit «ارسال به بیمه»: on every tab (PM-0097 — it was the نسخه and
    // دستورات tabs only), once the visit has an id and a patient, and never while
    // the visit is being closed — nor in a clinic outside Iran, whose patients no
    // Iranian insurer covers.
    const erxAvailable = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endProgress.running && !showClosureFlow;
    // ── «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04; docs/eprescription/CORRECTION.md) ──
    //
    // Once a part of this visit is registered, each نسخه line and دستورات row says
    // where it stands with the insurer, and the «ارسال … به بیمه» buttons count
    // what a correction would carry. `ePrescriptionStatus` never reaches the
    // insurer: it is read once the visit is known, again when the نسخه or دستورات
    // tab opens, once an edit there has settled, and after the card sends or
    // corrects — each time behind the نسخه's queued saves (rxPersistence.flush),
    // since the server reads the record. A read that fails shows nothing new.
    const erxStatusActive = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endProgress.running && !showClosureFlow;
    const { status: erxStatus, reload: reloadErxStatus } = (0, $5d2858db85b3973f$export$2eef96f829c6b514)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        prepare: rxPersistence.flush,
        active: erxStatusActive
    });
    const erxTabOpen = workTab === 'rx' || workTab === 'orders';
    // What the chips depend on: the card's content, and which lines have reached
    // the record (a line is matched by its record id).
    const erxStatusContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            erxContent,
            rxItems.map((r)=>r.medicationId || null)
        ]), [
        erxContent,
        rxItems
    ]);
    const erxStatusReadFor = (0, $acw62.useRef)(erxStatusContent);
    const erxStatusTab = (0, $acw62.useRef)(null);
    // The نسخه or دستورات tab opening (or the doctor moving between them).
    (0, $acw62.useEffect)(()=>{
        const tab = erxStatusActive && erxTabOpen ? workTab : null;
        if (tab && erxStatusTab.current !== tab) {
            erxStatusReadFor.current = erxStatusContent;
            reloadErxStatus();
        }
        erxStatusTab.current = tab;
    }, [
        workTab,
        erxTabOpen,
        erxStatusActive,
        erxStatusContent,
        reloadErxStatus
    ]);
    // An edit there, once it has settled — as the card's own refreshKey.
    (0, $acw62.useEffect)(()=>{
        if (!erxStatusActive || !erxTabOpen || erxStatusReadFor.current === erxStatusContent) return undefined;
        const h = setTimeout(()=>{
            erxStatusReadFor.current = erxStatusContent;
            reloadErxStatus();
        }, 900);
        return ()=>clearTimeout(h);
    }, [
        erxStatusContent,
        erxStatusActive,
        erxTabOpen,
        reloadErxStatus
    ]);
    const erxIndex = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$7aaa1df6f77403de)(erxStatus), [
        erxStatus
    ]);
    const erxPending = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$5977fd636411c9b9)(erxStatus), [
        erxStatus
    ]);
    const erxRemovedRx = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$4ddbdca59aee3c1a)(erxIndex, 'DRUGS', rxItems.map((r)=>r.medicationId)), [
        erxIndex,
        rxItems
    ]);
    const erxRemovedOrders = (0, $acw62.useMemo)(()=>(0, $2c5a3cdef49d8209$export$4ddbdca59aee3c1a)(erxIndex, 'SERVICES', clinicalOrders.map((o)=>o.id)), [
        erxIndex,
        clinicalOrders
    ]);
    // The card's words for a line as it is now: a نسخه line's dose — beside what
    // the insurer holds of a changed one — and a دستور's kind (the panel's preview,
    // PM-0187).
    const describeErxLine = (0, $acw62.useCallback)((line)=>{
        if (line?.orderId && !line.medicationId) {
            const order = clinicalOrders.find((o)=>String(o.id) === String(line.orderId));
            return order ? (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[order.orderType] || null : null;
        }
        const row = line?.medicationId ? rxItems.find((r)=>r.medicationId && String(r.medicationId) === String(line.medicationId)) : null;
        return row ? (0, $375f8776645d5aee$export$41198ed546152d40)(row, t, readsPersianData) : null;
    }, [
        rxItems,
        clinicalOrders,
        t,
        readsPersianData
    ]);
    // «اصلاح نسخه» on a past visit: offered while the visit is inside its month,
    // to a doctor this deployment offers e-prescription to (the status says so).
    const canCorrectVisit = (0, $acw62.useCallback)((v)=>erxStatus?.enabled === true && !!v?.scheduledDate && (0, $2c5a3cdef49d8209$export$e0cd0eea0dc73912)(v.scheduledDate), [
        erxStatus
    ]);
    const openRxCorrection = (0, $acw62.useCallback)((v)=>{
        setHistoryOpen(false);
        setGlanceOpen(false);
        setRxCorrectionVisit(v);
    }, []);
    const closeRxCorrection = (0, $acw62.useCallback)(()=>{
        const id = rxCorrectionVisit?.id;
        setRxCorrectionVisit(null);
        // Its drugs and orders may have changed: the rail's row and the sheet read it again.
        if (id) {
            visitCtxRequested.current.delete(id);
            loadVisitContext(id);
        }
    }, [
        rxCorrectionVisit,
        loadVisitContext
    ]);
    const ixStale = !!rxInteractions && rxInteractions.signature !== rxSignature;
    // Two drugs, or one with an allergy or a condition to read it against
    // (Visit.shared canRunInteractionCheck — the same rule on both surfaces).
    const interactionCheckReady = (0, $375f8776645d5aee$export$1e5ddc066f5dd4da)(rxItems, patient, acceptedDiagnoses);
    const canCheckInteractions = interactionCheckReady && !interactionLoading;
    const runInteractionCheck = (0, $acw62.useCallback)(async ()=>{
        if (!(0, $375f8776645d5aee$export$1e5ddc066f5dd4da)(rxItems, patient, acceptedDiagnoses) || interactionLoading) return;
        setIxLoading(true);
        setIxError(null);
        try {
            const { conditions: conditions, allergies: allergies } = (0, $375f8776645d5aee$export$ead65992cf57cabf)(patient, acceptedDiagnoses);
            const result = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9812972017b718e1), {
                // The drugs' Latin substance names. The argument is still called
                // `medicationIds`, but the service prompts its model with these strings
                // and matches its rules on them: a formulary id («tamin-70521») told it
                // nothing, and it invented a finding (lib/drugNames interactionDrugName).
                medicationIds: (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems),
                patientId: patient.id,
                patientConditions: conditions,
                patientAllergies: allergies
            });
            const warnings = result.checkDrugInteraction?.warnings || [];
            setRxInteractions({
                hasInteractions: warnings.length > 0,
                warnings: warnings,
                signature: rxSignature
            });
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('INTERACTION_CHECK'), 'interaction');
        } catch (e) {
            // A check the doctor asked for has to say when it failed — swallowing the
            // error leaves an empty panel that reads as «تداخلی نیست».
            setIxError(e?.message || t('errors.load.interactions'));
        } finally{
            setIxLoading(false);
        }
    }, [
        patient,
        rxItems,
        acceptedDiagnoses,
        interactionLoading,
        rxSignature,
        chargeVisit,
        t
    ]);
    // ── AI Assist ──────────────────────────────────────────────────────────────
    // Grounds the prescription assist in the full clinical picture of the current
    // visit: recorded conditions + accepted differentials + lab-inferred conditions
    // + the SOAP subjective/assessment + the working diagnosis, plus allergies.
    const buildAssistPrescriptionInput = ()=>{
        const recordedConditions = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
        const diffConditions = (differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)).map((d)=>d.description);
        const labConditions = (0, $375f8776645d5aee$export$5176433c16ff5a4)(patient.clinicalObservations);
        const soapConditions = [
            soap.s,
            soap.a
        ].filter(Boolean);
        const allergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
        return {
            visitId: visitId || '',
            patientId: patient.id,
            // Checked by the same rule engine as the interaction check, so the same names.
            medications: (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems),
            conditions: [
                ...recordedConditions,
                ...diffConditions,
                ...labConditions,
                ...soapConditions
            ],
            diagnosis: soap.a || diagnosis || '',
            age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
            gender: '',
            existingTests: [],
            patientAllergies: allergies
        };
    };
    const handleAssistPrescription = async ()=>{
        if (!patient?.id) return;
        setAiLoading(true);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$82d8fcb090733ceb), {
                input: buildAssistPrescriptionInput()
            });
            setAiResult(data.assistPrescription);
            // The service debits for this exactly as it does for the نسخه tab's
            // button, so it goes on the visit ledger exactly as that one does. It used
            // to be the quietest spend on the page: unasked, and invisible everywhere
            // except the account panel.
            // `costOf`, not the constant. A Parseh price is a ROW served by the
            // active pricing policy (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_
            // DESIGN.md); the shipped constant in creditPricing.js is the OFFLINE FALLBACK the PriceBook uses
            // before its first load. Reading the constant here put a stale figure on
            // the visit ledger while the wallet was debited the real one — the same
            // call one panel over already did this correctly.
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('ASSIST_PRESCRIPTION'), 'rx');
        } catch (e) {
            // A spent wallet is the one failure the doctor has to be told about —
            // otherwise the panel simply never fills and nothing says why.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn(e);
        } finally{
            setAiLoading(false);
        }
    };
    // ── The نسخه's AI helpers: dictation · «پایش بالینی» · شرح حال ──────────────
    // docs/VISIT_RX_AI_ASSIST.md. Three sources, one review: every proposal is a
    // formulary drug the server matched in code, and it waits for the doctor's
    // tick. The approved lines then open the add form a searched drug opens, one
    // after another, prefilled with the model's sig (proposalFormRequests, K1
    // 2026-10-05) — they used to land on the نسخه directly and arrive «ناقص» where
    // the model left a required field out. Each becomes a line only by the form's
    // «افزودن به نسخه», through addDrug like any other. The old «پیشنهاد دارو» panel
    // added the model's free-text names as synthetic `sugg-med-` drugs one click at
    // a time; «پیشنهاد از شرح حال» replaces it.
    const rxHistoryCtx = {
        soap: soap,
        diagnoses: [
            ...acceptedDiagnoses,
            diagnosis
        ].filter(Boolean)
    };
    const rxAssist = (0, $3e1a1a8acf34d11a$export$c779192d33323523)({
        getContext: ()=>({
                appointmentId: visitId || '',
                patient: patient,
                soap: soap,
                diagnoses: rxHistoryCtx.diagnoses,
                rxItems: rxItemsRef.current,
                transcript: liveTranscript
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (source)=>t(`visit.rxAssist.charged.${source.toLowerCase()}`),
        onCreditError: setCreditError,
        onApply: (lines, source)=>{
            const have = new Set(rxItemsRef.current.map((r)=>r.drug?.id));
            queueRxAdds((0, $864ce04f6c433567$export$cb741851902ee7c4)(lines.filter((l)=>!have.has(l.drug.id)), {
                source: source,
                durations: rxLists.durations,
                label: (n, total)=>total > 1 ? t('visit.rxAssist.formSourceN', {
                        n: formatNumber(n),
                        total: formatNumber(total)
                    }) : t('visit.rxAssist.formSource')
            }));
            // The form opens in «افزودن دارو», right below the closed card.
            requestAnimationFrame(()=>document.querySelector('[data-testid="visit-rx-picker"]')?.scrollIntoView?.({
                    block: 'nearest',
                    behavior: 'smooth'
                }));
        }
    });
    // ── «تکمیل نحوه مصرف» (K1, 2026-10-03) ─────────────────────────────────────
    // One press fills دوز, تناوب, نحوه مصرف, مدت and مقدار تحویلی on the lines that
    // still need them (missingRxFields). The AI only fills what the doctor has not
    // DECIDED: an empty field, or one still holding what the app itself pre-filled
    // — the product's one-unit دوز, the route read from its name. A value the
    // doctor picked is never replaced, and a line edited while the call was out is
    // left alone. The quantity follows the formula where it can (applyRxEdit);
    // the AI's count is used only where the formula has none (a syrup's bottles).
    const [rxDirectionsBusy, setRxDirectionsBusy] = (0, $acw62.useState)(false);
    // The patient's basic insurer, for the «در فهرست تأمین» chips on the نسخه.
    const patientInsurer = (0, $acw62.useMemo)(()=>(0, $ace44487380106d3$export$e4f91298b6c5a0f0)(patient?.insurance), [
        patient?.insurance
    ]);
    const rxIncompleteCount = (0, $acw62.useMemo)(()=>rxItems.filter((r)=>(0, $ace44487380106d3$export$e9b4e5de48a21156)(r).length > 0).length, [
        rxItems
    ]);
    const completeRxDirections = (0, $acw62.useCallback)(async ()=>{
        const snapshot = rxItemsRef.current.filter((r)=>(0, $ace44487380106d3$export$e9b4e5de48a21156)(r).length > 0);
        if (!snapshot.length || rxDirectionsBusy) return;
        setRxDirectionsBusy(true);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$fa16d22e4f643897), {
                input: {
                    appointmentId: pmEncounterId || visitId || '',
                    patientId: patient?.id || null,
                    lines: snapshot.map((r)=>({
                            lineId: String(r.id),
                            drugName: r.drug?.name || '',
                            genericName: r.drug?.genericName || '',
                            doseOptions: (0, $ace44487380106d3$export$23fceca71987facd)(r.drug),
                            dosage: r.dosage || '',
                            frequency: r.frequency || '',
                            route: r.route || '',
                            duration: r.duration || '',
                            quantity: r.quantity || ''
                        })),
                    frequencyOptions: (0, $ace44487380106d3$export$93a11165d6a55361),
                    // The routes' VALUES, as a line stores them in every UI language — the
                    // answer is one of these and is written as it comes (K1, 2026-10-03).
                    routeOptions: (0, $375f8776645d5aee$export$e730a0734bbb1219)(),
                    durationOptions: (0, $375f8776645d5aee$export$74f6a832d246e098)(t),
                    diagnoses: [
                        ...acceptedDiagnoses,
                        diagnosis
                    ].filter((d)=>typeof d === 'string' && d.trim()),
                    soapS: soap?.s || '',
                    soapA: soap?.a || '',
                    patientAllergies: (patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean),
                    age: Number.isFinite(patient?.age) ? patient.age : null,
                    gender: patient?.gender || ''
                }
            });
            const result = data?.completeRxDirections || {
                status: 'none_completed',
                charged: false,
                lines: []
            };
            if (result.charged) chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('RX_DIRECTIONS'), 'rx-directions');
            // Matched to the lines by their ids, and merged into each line AS IT IS NOW.
            // They were matched by object identity, so a line that changed in any way
            // while the call was out — writeNow giving it its record id is enough —
            // lost its answer, though the call was charged and the toast said
            // «applied» (K1, 2026-10-03). fillRxDirections fills only what is still
            // open in the line now, so a field the doctor set meanwhile still wins.
            const answers = new Map((result.lines || []).map((l)=>[
                    String(l.lineId),
                    l
                ]));
            const asked = new Set(snapshot.map((r)=>String(r.id)));
            const merge = (r)=>asked.has(String(r.id)) ? (0, $ace44487380106d3$export$c1d8ac96a7e23c6f)(r, answers.get(String(r.id)), {
                    durations: (0, $375f8776645d5aee$export$74f6a832d246e098)(t)
                }) : r;
            const applied = rxItemsRef.current.filter((r)=>merge(r) !== r).map((r)=>r.id);
            setRxItems((prev)=>prev.map(merge));
            applied.forEach((id)=>rxPersistence.scheduleSave(id));
            if (applied.length) toast.success(t('visit.rx.directions.applied', {
                count: applied.length
            }));
            else toast.info(t('visit.rx.directions.none'));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else toast.error(t('visit.rx.directions.failed'));
        } finally{
            setRxDirectionsBusy(false);
        }
    }, [
        rxDirectionsBusy,
        pmEncounterId,
        visitId,
        patient,
        t,
        acceptedDiagnoses,
        diagnosis,
        soap,
        chargeVisit,
        rxPersistence,
        toast
    ]);
    // ── «تکمیل از پایش بالینی» beyond the note and the نسخه (PM-0029, PM-0038) ──
    // علائم حیاتی, دستورات and اطلاعات پرونده read from the same transcript, each
    // from the «تکمیل» button of its own section. Findings are proposals; what the
    // doctor ticks is written through the path a hand-entered value takes
    // (monitoringApply.js): vitals land in the vitals FORM for the doctor to «ثبت»,
    // orders join the order list, a follow-up becomes a line of «P».
    const monitoringExtract = (0, $b71ef3742639a482$export$ae55c3af901dcf33)({
        // The visit's orders and encounter id say what it already holds: a second
        // «تکمیل» shows those findings as already on the visit, never writes them again.
        getContext: ()=>({
                appointmentId: visitId || '',
                encounterId: pmEncounterId || visitId || '',
                patient: patient,
                transcript: liveTranscript,
                orders: clinicalOrdersRef.current
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (group)=>t(`visit.monitoringExtract.charged.${group}`),
        onCreditError: setCreditError,
        // A heard lab / imaging / procedure is matched to its catalogue entry with the
        // picker's own search, so it is saved with its code like a hand-picked one.
        searchCatalog: (0, $375f8776645d5aee$export$14e053085c2b7017),
        onApply: async (picked)=>{
            const res = await (0, $f5fd2a1ce8ccb8d9$export$920e2c679038b5a0)({
                picked: picked,
                patientId: patient.id,
                appointmentId: pmEncounterId || visitId,
                t: t
            });
            if (res.creditError) setCreditError(res.creditError);
            if (Object.keys(res.vitalsPatch).length) {
                setVitals((prev)=>({
                        ...prev,
                        ...res.vitalsPatch
                    }));
                setVitalsMode('form');
            }
            if (res.orders.length) {
                setClinicalOrders((prev)=>[
                        ...res.orders.map((o)=>o.created),
                        ...prev
                    ]);
                res.orders.forEach((o)=>mirrorOrderToPendingTests({
                        type: o.item.orderType,
                        name: o.item.name,
                        urgency: o.item.urgency,
                        reason: o.item.reason,
                        code: o.item.code,
                        loincCode: o.item.loincCode
                    }, {
                        savedToBackend: true
                    }));
            }
            if (res.followUps.length) applyRefinedSections({
                p: (0, $80f289cb339918db$export$6a1840833052c978)((0, $375f8776645d5aee$export$35974e4f6db92b0)(soapRef.current?.p || ''), res.followUps)
            });
            if (res.saved) refreshPatient();
            // Nothing landed at all: keep the review open so the ticks are not lost.
            const landed = res.saved + res.followUps.length + Object.keys(res.vitalsPatch).length;
            if (!landed && res.failed) throw new Error('monitoring findings were not saved');
            if (res.failed) toast.error(t('visit.monitoringExtract.partlyApplied', {
                failed: res.failed
            }));
            else toast.success(t(Object.keys(res.vitalsPatch).length ? 'visit.monitoringExtract.appliedVitals' : 'visit.monitoringExtract.applied'));
        }
    });
    // ── «تکمیل» as one flow (PM-0038) ─────────────────────────────────────────
    // The same button in every section, the visit-wide one beside «پایش بالینی» in
    // the top bar, and the guide that walks from one section's proposals to the next.
    const completion = (0, $d3f3ee41c97afb39$export$3bfa7c0c0c355160)({
        t: t,
        formatNumber: formatNumber,
        toast: toast,
        costOf: $121df138798ec781$export$c932aceb7c67d0f4,
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        disabled: !visitId || !patient?.id,
        recState: // «تکمیل خودکار پس از پایش بالینی»: never into a visit being closed.
        recState,
        autoRunOnStop: autoCompleteOn && visitStatus === 'inprogress' && !endProgress.running && !showClosureFlow
    });
    // The stop control's own press — the one stop that may run «تکمیل» after it.
    const stopMonitoring = ()=>{
        completion.armAutoRun();
        stopRec();
    };
    // The note is two tabs (S/O/A and «برنامه درمان»), one section of the guide.
    const completeSectionShown = {
        soap: 'soap',
        plan: 'soap',
        rx: 'rx',
        orders: 'orders'
    }[workTab];
    const goCompleteSection = (id)=>{
        if (id === 'vitals' || id === 'record') {
            toggleRecordPanelOpen(true);
            if (id === 'vitals' && !recordOpen.vitals) toggleRecordSection('vitals');
            requestAnimationFrame(()=>document.querySelector(`[data-testid="visit-complete-${id}"]`)?.scrollIntoView?.({
                    block: 'nearest',
                    behavior: 'smooth'
                }));
            return;
        }
        if (id === 'soap') {
            const keys = Object.keys(soapRefine.preview || {});
            pickWorkTab(keys.length && keys.every((k)=>k === 'p') ? 'plan' : 'soap');
            return;
        }
        pickWorkTab(id);
    };
    const findingsCard = (group, style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a77297e82307ffaa$export$2e2bcd8739ae039), {
            group: group,
            review: monitoringExtract.reviews[group],
            onToggle: (key)=>monitoringExtract.toggle(group, key),
            onSetAll: (checked)=>monitoringExtract.setAll(group, checked),
            onApply: ()=>monitoringExtract.apply(group),
            onClose: ()=>monitoringExtract.close(group),
            onRetry: ()=>monitoringExtract.run([
                    group
                ]),
            onCatalog: (key, choice)=>monitoringExtract.chooseCatalog(group, key, choice),
            style: style
        });
    // An unmatched proposal is searched for by hand, in the picker right below.
    const searchRxPicker = (0, $acw62.useCallback)((query)=>{
        setRxSearchRequest({
            query: query || '',
            nonce: Date.now()
        });
        document.querySelector('[data-testid="visit-rx-picker"]')?.scrollIntoView?.({
            block: 'nearest',
            behavior: 'smooth'
        });
    }, []);
    // ── تجویز مجدد — refill from the record rail or a past visit ───────────────
    // One entry point for both refill sources: a current medication on the
    // record rail and a drug prescribed in a previous visit (history sheet).
    // The previous dosing rides along as the new row's defaults, so the doctor
    // lands on an editable نسخه row instead of re-typing the drug. The product is
    // the one the line was written from, looked up by its id (refillDrugFor) — a
    // match by name put another strength or product on the نسخه (K1, 2026-10-03);
    // only a line with no id is matched by name, and a miss keeps the doctor's
    // text under a synthesized id.
    const represcribeMed = (0, $acw62.useCallback)(async (med)=>{
        const src = (0, $5e2e0b7ea22d1ff2$export$aac88d3c48aba92)(med);
        if (!src) return;
        const nameKey = src.name.toLowerCase();
        const drug = await (0, $375f8776645d5aee$export$dcced24b144b6c10)(src);
        setRxItems((prev)=>prev.some((r)=>r.drug.id === drug.id || (r.drug.name || '').trim().toLowerCase() === nameKey) ? prev : [
                ...prev,
                makeRxItem(drug, {
                    // `|| undefined` on dose/frequency so an empty source still falls
                    // back to the matched formulary entry's own first common values.
                    dosage: src.dosage || undefined,
                    frequency: src.frequency || undefined,
                    // A route stored under an older translated label («Oral») is written
                    // again as the route's value — the one the insurer codes.
                    route: (0, $ace44487380106d3$export$1aea987f77fa496a)(src.route) || src.route,
                    duration: src.duration,
                    quantity: src.quantity,
                    instructions: src.instructions
                })
            ]);
        // Land the doctor where the editable row now is. The history sheet stays
        // open over it — its row flips to «در نسخه» — so several refills in a row
        // cost one click each.
        setWorkTab('rx');
    }, [
        makeRxItem
    ]);
    // Refill sources are keyed by NAME, not id: a current medication and a
    // formulary entry never share ids, and the same drug must read as «در نسخه»
    // whichever door it came through.
    const prescribedMedNames = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>(r.drug?.name || '').trim().toLowerCase()).filter(Boolean)), [
        rxItems
    ]);
    // «تجویز مجدد» as a batch — the picker on «داروهای جاری» and on each past
    // visit. Every chosen drug goes through the single refill, so the rows are
    // identical to one-at-a-time refills (formulary match, dosing, no duplicates).
    const represcribeMeds = (0, $acw62.useCallback)(async (meds)=>{
        await Promise.all((meds || []).map((m)=>represcribeMed(m)));
        if (meds?.length) toast.success(t('visit.rx.represcribeApplied', {
            count: meds.length
        }));
    }, [
        represcribeMed,
        t,
        toast
    ]);
    const rxAllergens = (0, $acw62.useMemo)(()=>(patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean), [
        patient?.clinicalAllergies
    ]);
    // Auto-fire prescription assist when SOAP assessment is filled.
    //
    // Gated by the «نکات بالینی» switch, because that is where this answer LANDS:
    // the interaction warnings and the follow-up line it returns are cards in that
    // feed, beside the ones the insight pass produces. It is also an automatic
    // spend — 3 پارسه for every DISTINCT assessment text, so refining «A» three
    // times pays three times — which is precisely what a doctor turning the
    // automation off is asking to stop. The «پیشنهاد دارو» button in the نسخه tab
    // is untouched: that one they asked for.
    (0, $acw62.useEffect)(()=>{
        if (!autoAssistOn) return;
        const assessment = soap.a?.trim();
        if (!assessment || !patient?.id) return;
        if (assistAutoFired.current === assessment) return;
        const timer = setTimeout(()=>{
            assistAutoFired.current = assessment;
            handleAssistPrescription();
        }, 2500);
        return ()=>clearTimeout(timer);
    }, [
        soap.a,
        patient?.id,
        autoAssistOn
    ]);
    // ── AI Chat ────────────────────────────────────────────────────────────────
    // A clinical question is rarely one line, so the composer is a textarea that
    // grows with its content. It is collapsed to `auto` BEFORE measuring —
    // otherwise `scrollHeight` can only ever grow and a deleted line would leave
    // the box permanently tall. The clamp lives in CSS (`maxHeight: ASK_MAX_H`),
    // so this assignment can never exceed it and the field starts scrolling
    // inside itself at that point instead of pushing the thread off-screen.
    const askFieldRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const el = askFieldRef.current;
        if (!el) return;
        const fit = ()=>{
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
        };
        fit();
        // Re-wrapping (window resize, panel expand/collapse) changes the height the
        // same text needs, so the measurement is not a one-shot on value change.
        window.addEventListener('resize', fit);
        return ()=>window.removeEventListener('resize', fit);
    }, [
        aiInput,
        copilotExpanded
    ]);
    const handleAsk = async (q)=>{
        const question = q || aiInput;
        if (!question.trim()) return;
        setAiMessages((prev)=>[
                ...prev,
                {
                    role: 'user',
                    text: question
                }
            ]);
        setAiInput('');
        setAiChatLoading(true);
        try {
            const history = (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient);
            const visitCtx = (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests);
            const conditionNames = (patient?.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const [bffResult, citations] = await Promise.allSettled([
                (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$d877ca4a83c64a39), {
                    visitId: visitId || '',
                    question: question,
                    transcriptionContext: visitCtx,
                    patientHistory: history,
                    patientId: patient?.id
                }),
                (0, $b840d32ddf66046b$export$afaf1496218aac9a)(question, conditionNames)
            ]);
            if (bffResult.status === 'rejected') throw bffResult.reason;
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('ASK_QUESTION'), 'ask');
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: bffResult.value.askDoctorQuestion.answer,
                        confidence: bffResult.value.askDoctorQuestion.confidence,
                        suggestions: bffResult.value.askDoctorQuestion.followUpSuggestions,
                        citations: citations.status === 'fulfilled' ? citations.value : []
                    }
                ]);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: t('errors.ai.responseFailed'),
                        suggestions: [],
                        citations: []
                    }
                ]);
        } finally{
            setAiChatLoading(false);
        }
    };
    // ── Confirmation questions ────────────────────────────────────────────────
    const handleLoadDiagAIQuestions = async (diag)=>{
        if (diagAILoading[diag.diagnosisCode]) return;
        setDiagAILoading((prev)=>({
                ...prev,
                [diag.diagnosisCode]: true
            }));
        try {
            const history = (0, $375f8776645d5aee$export$bf8ea0179266f66d)(patient);
            const visitCtx = (0, $375f8776645d5aee$export$282a2c8a3d030b1)(soap, diagnosis, pendingTests);
            const result = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$15324fc83c054605), {
                visitId: visitId,
                patientId: patient?.id,
                differentials: [
                    {
                        diagnosisCode: diag.diagnosisCode,
                        description: diag.description
                    }
                ],
                transcriptionContext: visitCtx,
                patientHistory: history
            });
            const items = result?.generateConfirmationQuestions?.items || [];
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('CONFIRM_QUESTIONS'), 'confirmq');
            const qs = items[0]?.questions || [];
            setDiagAIQuestions((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: qs
                }));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
        } finally{
            setDiagAILoading((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: false
                }));
        }
    };
    // One question, one commit: picking بله/خیر writes that finding into «S»,
    // saves the note, and — only once the save has landed — closes THAT question,
    // which collapses to the finding it recorded. The panel itself stays open on
    // the questions still unanswered, so the doctor works straight down the list.
    //
    // Nothing here is keyed to the first question: every one of them takes the
    // same path. A committed question is inert (its answer is part of the note;
    // un-picking it would have to un-write prose the doctor may since have
    // edited), so re-clicking it does nothing.
    const handleAnswerDiagQuestion = async (diag, q, value)=>{
        const code = diag.diagnosisCode;
        const key = `${code}:${q.id}`;
        if (diagQSubmitting[key]) return; // in flight
        if (diagAIAnswers[code]?.[q.id]?.answer) return; // already recorded
        setDiagQSubmitting((prev)=>({
                ...prev,
                [key]: value
            }));
        setDiagQError((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        const updated = {
            ...soapRef.current,
            s: (0, $375f8776645d5aee$export$5a4e1c8ddaeead64)(soapRef.current.s, (0, $375f8776645d5aee$export$9c2ce4aa2a7d6fc6)(q, value, t))
        };
        const saved = await handleSaveSoapNote(updated);
        setDiagQSubmitting((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        if (!saved) {
            // «S» is left untouched, the answer unrecorded, and the panel open, so the
            // doctor can retry the same question rather than lose the finding.
            setDiagQError((prev)=>({
                    ...prev,
                    [key]: t('errors.save.answer')
                }));
            return;
        }
        soapRef.current = updated;
        setSoap(updated);
        // Recording the answer is what closes this question: the panel renders an
        // answered one as the single line it wrote, with no choices left to make.
        setDiagAIAnswers((prev)=>({
                ...prev,
                [code]: {
                    ...prev[code],
                    [q.id]: {
                        answer: value
                    }
                }
            }));
    };
    // ── Add suggested med/test from summary modal ─────────────────────────────
    // The summary modal's «افزودن دارو» is gone, and with it handleAddSuggestedMed:
    // nothing called it, and what it did was write the drug as an uncoded prose
    // record — `{ text }` and a name — that no insurer could be sent (K1,
    // 2026-10-03). A drug suggested anywhere now reaches the نسخه as a structured
    // line (the AI helpers' review, or the treatment plan below).
    const handleAddSuggestedTest = (idx)=>{
        setAddedSugTests((prev)=>new Set([
                ...prev,
                idx
            ]));
    };
    // ── AI-assisted treatment plan (SOAP «P» section) ──────────────────────────
    // The plan composes all four categories in one call. The AI grounds it in the
    // whole SOAP note (S/O/A as well as the current P), the differentials the
    // doctor accepted/rejected, and the patient's longitudinal history — so we send
    // SOAP and differentials rather than just a diagnosis string, and let the
    // service fetch the history itself.
    //
    // The generated note is the doctor's «P» draft: it lands straight in the P
    // editor, where it is edited like any other SOAP text, and the review panel
    // below P only governs which structured items get persisted on confirm.
    const planKey = (type, name)=>`${type}:${name}`;
    const togglePlanItem = (key)=>{
        setSelectedPlanItems((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSuggestPlan = async ()=>{
        if (!patient?.id) return;
        setPlanLoading(true);
        setPlanError(null);
        try {
            const appointmentId = pmEncounterId || visitId || undefined;
            // Send rejected differentials too — a ruled-out diagnosis tells the AI what
            // NOT to work up, which is as useful as an accepted one. The service ranks
            // accepted first and labels each with its status.
            const reviewedDiffs = differential || [];
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$f34a41ed9a6da313), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    diagnosis: soap.a || '',
                    icdCodes: (patient.clinicalConditions || []).filter((c)=>c.code).slice(0, 8).map((c)=>({
                            code: c.code,
                            description: c.display || ''
                        })),
                    age: (0, $375f8776645d5aee$export$9c5829f0850e67fe)(patient),
                    gender: patient.gender || '',
                    patientAllergies: (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
                    existingMedications: rxItems.map((r)=>r.drug.name).filter(Boolean),
                    existingTests: (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean).slice(0, 10),
                    existingImaging: clinicalOrders.filter((o)=>o.orderType === 'imaging').map((o)=>o.description).filter(Boolean),
                    soapSubjective: soap.s || '',
                    soapObjective: soap.o || '',
                    soapAssessment: soap.a || '',
                    soapPlan: soap.p || '',
                    differentials: reviewedDiffs.map((d)=>({
                            diagnosisCode: d.diagnosisCode || '',
                            diagnosisName: d.description || '',
                            confidence: d.confidence || '',
                            status: d.status || 'active',
                            supportingEvidence: d.supportingEvidence || [],
                            contradictingEvidence: d.contradictingEvidence || []
                        }))
                }
            });
            const plan = data.suggestTreatmentPlan;
            if (!plan) return;
            setPlanSuggestion(plan);
            chargeVisit((0, $121df138798ec781$export$c932aceb7c67d0f4)('TREATMENT_PLAN'), 'plan', t('visit.plan.ready'));
            // Preselect everything: the doctor reviews by unchecking, which is faster
            // than checking a dozen boxes.
            const preselected = new Set([
                ...(plan.medications || []).map((m)=>planKey('med', m.name)),
                ...(plan.labTests || []).map((test)=>planKey('lab', test.testName)),
                ...(plan.imagingStudies || []).map((s)=>planKey('imaging', s.studyType)),
                ...(plan.procedureOrders || []).map((p)=>planKey('procedure', p.name))
            ]);
            setSelectedPlanItems(preselected);
            // The note IS the «P» section — write it there and autosave, so the plan
            // is visible and editable in the note the moment it exists. It replaces the
            // NARRATIVE only: the managed drug/order block is owned by the reconciler
            // and is spliced back on, so generating a plan never drops the list of what
            // is already prescribed. Whatever narrative P held before is kept for
            // one-click restore rather than silently lost.
            const note = (plan.planNote || '').trim();
            if (note) {
                const prevNarrative = (0, $375f8776645d5aee$export$35974e4f6db92b0)(soap.p);
                setPlanReplacedP(prevNarrative && prevNarrative !== note ? prevNarrative : null);
                const nextP = (0, $375f8776645d5aee$export$a3aead4a50abe781)(note, planBlock);
                setSoap((s)=>({
                        ...s,
                        p: nextP
                    }));
                await handleSaveSoapNote({
                    ...soap,
                    p: nextP
                });
            }
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else {
                console.warn('suggestTreatmentPlan failed:', e);
                setPlanError(e.message || t('errors.ai.treatmentPlan'));
            }
        } finally{
            setPlanLoading(false);
        }
    };
    // Open the panel and generate on first use; afterwards the button just toggles
    // the panel so the doctor is never charged twice by a stray click. Opening on
    // a visit that is not in progress still shows the panel — it explains why the
    // generate button is disabled, which a dead AI button would not.
    const handleOpenPlanPanel = ()=>{
        if (planPanelOpen) {
            setPlanPanelOpen(false);
            return;
        }
        setPlanPanelOpen(true);
        if (!planSuggestion && !planLoading && patient?.id && visitStatus === 'inprogress') handleSuggestPlan();
    };
    // Undo a generation that overwrote the doctor's own «P» narrative. The managed
    // block rides along untouched — it describes what is prescribed, which the undo
    // has no business changing.
    const handleRestorePlanText = async ()=>{
        if (planReplacedP == null) return;
        const restored = (0, $375f8776645d5aee$export$a3aead4a50abe781)(planReplacedP, planBlock);
        setPlanReplacedP(null);
        setSoap((s)=>({
                ...s,
                p: restored
            }));
        await handleSaveSoapNote({
            ...soap,
            p: restored
        });
    };
    // Persist the checked items, then the note, then flip the plan to confirmed.
    // The confirmed plan is the visit's output, so applying it also propagates
    // into the work area: meds land in the نسخه (rxItems) and orders go through the
    // same createOrder rail as the manual دستورات form (live list + pendingTests
    // mirror, so the printed نسخه and the end-of-visit doctor-order flush keep
    // working). The plan text itself is the SOAP «P» the doctor is looking at —
    // it was written there at generation time, so confirming files that text as
    // the visit's treatment plan rather than appending a second summary to it.
    const handleApplyPlan = async ()=>{
        const appointmentId = pmEncounterId || visitId;
        if (!patient?.id || !appointmentId || !planSuggestion) return;
        setPlanSaving(true);
        setPlanError(null);
        const failures = [];
        try {
            // 1) Medications → the نسخه, ONE structured line each (K1, 2026-10-03).
            // They were written as a prose record — a name and `{ text }`, which no
            // insurer can be sent — AND mirrored as a `plan-med-` line carrying the AI's
            // raw dose, so the e-prescription listed every plan drug twice. They now
            // take the AI helpers' path: the drug-list product the name stands for
            // (matchFormularyDrug), the plan's sig held to the closed lists
            // (closedListDefaults), one line (makeRxItem) — written to the record with
            // the rest of the نسخه, exactly as a line the doctor added (writeNow).
            const meds = (planSuggestion.medications || []).filter((m)=>selectedPlanItems.has(planKey('med', m.name)));
            const planLines = [];
            const unmatched = [];
            for (const m of meds){
                let drug = null;
                try {
                    drug = await (0, $375f8776645d5aee$export$3f253215194ac0f3)(m.name);
                } catch (e) {
                    console.warn('plan: drug-list lookup failed:', e.message);
                }
                if (!drug) {
                    // No product the list settles. The line keeps the plan's name — on the
                    // نسخه, not silently dropped — and the doctor is told to choose the
                    // product, without which no insurer will take it.
                    unmatched.push(m.name);
                    drug = {
                        id: `plan-med-${m.name}`,
                        name: m.name,
                        genericName: '',
                        category: '',
                        commonDosages: [],
                        commonFrequencies: []
                    };
                }
                const sig = (0, $ace44487380106d3$export$e8df75bdc9e038c6)(drug, {
                    dosage: m.dosage,
                    frequency: m.frequency,
                    duration: m.duration,
                    instructions: m.notes
                }, rxLists);
                // The plan names no route: the product's own, read from its name.
                planLines.push(makeRxItem(drug, {
                    ...sig,
                    route: sig.route || (0, $ace44487380106d3$export$ae410c87a5d0011f)(drug)
                }, planLines.length));
            }
            const planFresh = planLines.filter((l, i)=>!(0, $622fea85856450c1$export$26bd9984be9bfd1c)(rxItemsRef.current, l.drug) && !planLines.slice(0, i).some((p)=>p.drug.id === l.drug.id));
            if (planFresh.length) {
                setRxItems((prev)=>[
                        ...prev,
                        ...planFresh
                    ]);
                await rxPersistence.writeNow(planFresh);
            }
            if (unmatched.length) toast.warn(t('visit.rx.planUnmatched', {
                names: formatList(unmatched)
            }));
            // 2) Lab / imaging / procedure → encounter orders, one createOrder per
            // item like the manual form (updates the دستورات list in place). A catalog
            // match attaches the id/code linkage that enables in-house performance.
            const orderItems = [];
            (planSuggestion.labTests || []).forEach((test)=>{
                if (selectedPlanItems.has(planKey('lab', test.testName))) orderItems.push({
                    type: 'lab',
                    name: test.testName,
                    code: test.loincCode || '',
                    reason: test.reason || '',
                    urgency: test.urgency || 'routine',
                    label: t('patient.orderType.lab')
                });
            });
            (planSuggestion.imagingStudies || []).forEach((s)=>{
                if (selectedPlanItems.has(planKey('imaging', s.studyType))) orderItems.push({
                    type: 'imaging',
                    name: s.studyType,
                    code: '',
                    reason: [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 "),
                    urgency: s.urgency || 'routine',
                    label: t('visit.orders.imaging')
                });
            });
            (planSuggestion.procedureOrders || []).forEach((p)=>{
                if (selectedPlanItems.has(planKey('procedure', p.name))) orderItems.push({
                    type: 'procedure',
                    name: p.name,
                    code: p.code || '',
                    reason: p.reason || '',
                    urgency: p.urgency || 'routine',
                    label: t('visit.orders.procedure')
                });
            });
            // The plan proposes services as free text, and each one has to find its
            // catalogue row before it can be billed — the linkage the «انجام» button
            // and the invoice both read. That match used to run against a resident
            // catalogue; it is now one lookup per type, and a name that answers to two
            // services resolves to NOTHING rather than to the wrong one.
            const planMatches = new Map();
            for (const type of [
                ...new Set(orderItems.map((o)=>o.type))
            ]){
                const names = orderItems.filter((o)=>o.type === type).map((o)=>o.name);
                try {
                    const rows = await (0, $375f8776645d5aee$export$ff3759fdd9615d20)({
                        names: names,
                        orderType: type,
                        appointmentId: pmEncounterId || visitId
                    });
                    for (const r of rows)planMatches.set(`${type}:${r.matchedName || r.name}`, r);
                } catch (err) {
                    // An unmatched plan order is still created — it just carries no
                    // catalogue linkage, exactly as a hand-typed order does.
                    console.error('plan catalogue match failed:', err);
                }
            }
            const createdOrders = [];
            for (const o of orderItems){
                const hit = planMatches.get(`${o.type}:${o.name}`);
                const cat = hit && {
                    code: hit.code || '',
                    catalogId: hit.id,
                    loincCode: hit.codeSystem === 'LOINC' ? hit.code || '' : ''
                };
                const created = await handleCreateOrder({
                    type: o.type,
                    urgency: o.urgency,
                    name: o.name,
                    notes: o.reason,
                    code: cat?.code || o.code || '',
                    catalogId: cat?.catalogId || null
                });
                if (created) {
                    createdOrders.push(created);
                    mirrorOrderToPendingTests({
                        type: o.type,
                        name: o.name,
                        urgency: o.urgency,
                        reason: o.reason,
                        code: cat?.code || o.code || '',
                        loincCode: cat?.loincCode || o.code || ''
                    }, {
                        savedToBackend: true
                    });
                } else failures.push(o.name);
            }
            // 3) The plan text is the SOAP «P» the doctor just reviewed — narrative
            // plus the managed block. Reconcile once more before filing so the block
            // reflects the items this very confirm just created, cancel any debounced
            // write so it cannot land after (and overwrite) this one, and save
            // synchronously. `aiGenerated` compares the NARRATIVE: the block is always
            // machine-written, so including it would make the flag permanently true.
            // The orders this confirm just created are taken from the calls themselves,
            // not from clinicalOrdersRef: that ref is only as fresh as the last RENDER,
            // and nothing guarantees one happened between the final create and this
            // line. When it had not, the block was filed WITHOUT the orders — the plan
            // note in the record then disagreed with the orders on the chart, silently.
            const justCreated = createdOrders.filter(Boolean);
            const ordersForBlock = [
                ...justCreated,
                ...clinicalOrdersRef.current.filter((o)=>!justCreated.some((c)=>c?.id === o?.id))
            ];
            // The same for the lines this confirm put on the نسخه.
            const rxForBlock = [
                ...rxItemsRef.current.filter((r)=>!planFresh.some((l)=>l.id === r.id)),
                ...planFresh
            ];
            const freshBlock = (0, $375f8776645d5aee$export$d3332d0820799abb)({
                rxItems: rxForBlock,
                orders: ordersForBlock,
                orderNameEn: orderNameEn
            });
            const planNote = (0, $375f8776645d5aee$export$a3aead4a50abe781)(soap.p, freshBlock).trim();
            if (planNote) {
                clearTimeout(planSaveTimer.current);
                const nextSoap = {
                    ...soap,
                    p: planNote
                };
                setSoap(nextSoap);
                await handleSaveSoapNote(nextSoap);
                await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$97c305a43bb466fa), {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    planNote: planNote,
                    aiGenerated: (0, $375f8776645d5aee$export$35974e4f6db92b0)(planNote) === (planSuggestion.planNote || '').trim()
                });
            }
            // 4) Confirm. A plan with no note is still a valid plan.
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$11e9f559a2c034d2), {
                appointmentId: appointmentId
            });
            setPlanStatus(res.confirmTreatmentPlan?.status || 'confirmed');
            setPlanReplacedP(null);
            if (failures.length) setPlanError(t('visit.plan.partialFailure', {
                items: formatList(failures)
            }));
        } catch (e) {
            console.warn('plan: confirm failed:', e);
            setPlanError(e.message || t('errors.save.treatmentPlan'));
        } finally{
            setPlanSaving(false);
        }
    };
    // Load an already-saved plan once the visit is known, so a resumed visit shows
    // «تأییدشده» on the P section instead of offering to generate a second plan.
    // The SOAP note is the authority for the P text; the stored plan note is only
    // a fallback for the case where the note was lost but the plan survived.
    const planTabLoaded = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const appointmentId = pmEncounterId || visitId;
        if (planTabLoaded.current || !appointmentId || !patient?.id) return;
        planTabLoaded.current = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$9c8ef21e5ce2027), {
            appointmentId: appointmentId,
            patientId: patient.id
        }).then((data)=>{
            const plan = data?.treatmentPlan;
            if (!plan?.exists) return;
            setPlanStatus(plan.status || 'draft');
            if (plan.planNote) setSoap((s)=>(s.p || '').trim() ? s : {
                    ...s,
                    p: plan.planNote
                });
        }).catch((e)=>console.warn('treatmentPlan load failed:', e.message));
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    // ── Mid-visit SOAP save ───────────────────────────────────────────────────
    // ── Vitals ────────────────────────────────────────────────────────────────
    const handleSaveVitals = async ()=>{
        if (!patient?.id) return;
        // ── Validation: plausible physiological ranges; reject nonsensical input ──
        const RANGES = {
            bpSys: {
                min: 40,
                max: 300,
                label: t('patient.vitals.systolic')
            },
            bpDia: {
                min: 20,
                max: 200,
                label: t('patient.vitals.diastolic')
            },
            pulse: {
                min: 20,
                max: 300,
                label: t('patient.vitals.hr')
            },
            spo2: {
                min: 50,
                max: 100,
                label: t('patient.vitals.spo2')
            },
            temp: {
                min: 30,
                max: 45,
                label: t('patient.vitals.bodyTemp')
            },
            weight: {
                min: 1,
                max: 500,
                label: t('patient.vitals.wt')
            }
        };
        const errors = [];
        for (const [key, r] of Object.entries(RANGES)){
            const raw = vitals[key];
            if (raw === '' || raw == null) continue;
            const n = Number(raw);
            if (!Number.isFinite(n)) {
                errors.push(t('visit.vitals.notNumeric', {
                    field: r.label
                }));
                continue;
            }
            if (n < r.min || n > r.max) errors.push(t('visit.vitals.outOfRange', {
                field: r.label,
                min: r.min,
                max: r.max
            }));
        }
        // Cross-field: systolic must exceed diastolic when both are entered
        if (vitals.bpSys && vitals.bpDia && Number.isFinite(Number(vitals.bpSys)) && Number.isFinite(Number(vitals.bpDia)) && Number(vitals.bpSys) <= Number(vitals.bpDia)) errors.push(t('visit.vitals.bpOrder'));
        if (errors.length) {
            setVitalsError(errors);
            return;
        }
        const today = new Date().toISOString().split('T')[0];
        const entries = [
            vitals.bpSys && {
                code: '8480-6',
                display: t('patient.vitals.systolic'),
                value: vitals.bpSys,
                unit: 'mmHg'
            },
            vitals.bpDia && {
                code: '8462-4',
                display: t('patient.vitals.diastolic'),
                value: vitals.bpDia,
                unit: 'mmHg'
            },
            vitals.pulse && {
                code: '8867-4',
                display: t('patient.vitals.hr'),
                value: vitals.pulse,
                unit: 'bpm'
            },
            vitals.spo2 && {
                code: '59408-5',
                display: t('patient.vitals.spo2'),
                value: vitals.spo2,
                unit: '%'
            },
            vitals.temp && {
                code: '8310-5',
                display: t('patient.vitals.bodyTemp'),
                value: vitals.temp,
                unit: "\xb0C"
            },
            vitals.weight && {
                code: '29463-7',
                display: t('patient.vitals.wt'),
                value: vitals.weight,
                unit: 'kg'
            }
        ].filter(Boolean);
        if (!entries.length) {
            setVitalsError([
                t('validation.atLeastOneValue')
            ]);
            return;
        }
        setVitalsError(null);
        setVitalsLoading(true);
        try {
            // On edit: delete this encounter's existing vitals first to avoid duplicates
            if (savedVitalIds.current.length) {
                await Promise.allSettled(savedVitalIds.current.map((id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$725e3ec3814f10de), {
                        id: id
                    })));
                savedVitalIds.current = [];
            }
            const results = await Promise.all(entries.map((e)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$5d20d1065b54c736), {
                    patientId: patient.id,
                    input: {
                        code: e.code,
                        display: e.display,
                        value: e.value,
                        unit: e.unit,
                        status: 'NORMAL',
                        effectiveDate: today,
                        appointmentId: pmEncounterId || visitId || undefined
                    }
                })));
            // Store the new IDs so editing again can delete them
            savedVitalIds.current = results.map((r)=>r?.addObservation?.id).filter(Boolean);
            // What's on screen is now the encounter's record: no re-adoption on refetch.
            vitalsSeeded.current = String(pmEncounterId || visitId || '');
            setVitalsMode('saved');
            const spo2Limit = ai.spo2Threshold ?? 95;
            const bpLimit = ai.bpSystolicThreshold ?? 140;
            const alerts = [];
            if (vitals.spo2 && Number(vitals.spo2) < spo2Limit) alerts.push(t('visit.vitals.spo2Alert', {
                value: vitals.spo2,
                limit: spo2Limit
            }));
            if (vitals.bpSys && Number(vitals.bpSys) > bpLimit) alerts.push(t('visit.vitals.bpAlert', {
                value: vitals.bpSys,
                limit: bpLimit
            }));
            if (alerts.length) {
                const isCritical = vitals.spo2 && Number(vitals.spo2) < spo2Limit - 5 || vitals.bpSys && Number(vitals.bpSys) > bpLimit + 20;
                if (isCritical ? ai.interruptOnCritical !== false : ai.interruptOnWarning !== false) setVitalsAlert({
                    level: isCritical ? 'critical' : 'warning',
                    messages: alerts
                });
            }
            refreshPatient();
        } catch (e) {
            console.warn('saveVitals error:', e);
        } finally{
            setVitalsLoading(false);
        }
    };
    // ── Helpers ────────────────────────────────────────────────────────────────
    const patientConditions = (patient?.clinicalConditions || []).map((c)=>c.display);
    // Record-column lists, hoisted out of the JSX so the rail (preview slice) and
    // the full-list sheets render from the same source.
    const currentMeds = (()=>{
        const seenIds = new Set();
        const seenNames = new Set();
        return (patient?.clinicalMedications || []).filter((m)=>{
            if (m.status !== 'active' && m.status !== 'on-hold') return false;
            const nm = (m.display || '').trim().toLowerCase();
            if (removedMedNames.has(nm)) return false;
            if (seenIds.has(m.id)) return false;
            if (nm && seenNames.has(nm)) return false;
            seenIds.add(m.id);
            if (nm) seenNames.add(nm);
            return true;
        });
    })();
    const activeConds = (patient?.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active' && !removedCondIds.has(c.id));
    const labObsAll = (patient?.clinicalObservations || []).filter((o)=>!(0, $bf42e0131d395ab7$export$520152d4ddd823c6).has(o.code)) // vitals are not lab results
    .slice().sort((a, b)=>{
        // Abnormal/critical first, then by date desc
        const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
        const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
        if (sA !== sB) return sA - sB;
        return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
    });
    const labCriticalCount = labObsAll.filter((o)=>o.status === 'CRITICAL').length;
    const labAbnormalCount = labObsAll.filter((o)=>o.status === 'ABNORMAL').length;
    const rxText = rxItems.length > 0 ? rxItems.map((r)=>`\u{2022} ${(0, $bb8a11e7c1131df5$export$128ec9ce691e4cfc)(r.drug)}${r.dosage ? ' ' + r.dosage : ''}${r.route ? ' ' + r.route : ''}${r.frequency ? ' - ' + r.frequency : ''}${r.duration ? ' ' + t('visit.rx.forDuration', {
            duration: r.duration
        }) : ''}${r.instructions ? ' (' + r.instructions + ')' : ''}`).join('\n') : '';
    // Route-level data load → the workspace's own skeleton (top bar, record rail,
    // SOAP centre, copilot rail at their real grid), never a bare spinner (§2.4).
    if (pLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$39c20a58c12966ae), null);
    const p = patient || routePatient;
    // ── Timer display ─────────────────────────────────────────────────────────
    const mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    const ss = String(elapsed % 60).padStart(2, '0');
    // ── «نکات بالینی» derived from live data ──────────────────────────────────
    // Insight only. Nothing orderable is built here — see Visit.shared.js for the
    // policy and filterClinicalInsights below for the backstop.
    const rawSuggestions = [];
    if (hints.length > 0) hints.forEach((h, i)=>{
        const text = typeof h === 'string' ? h : h.text || '';
        const hintType = typeof h === 'string' ? 'clinical_note' : h.hint_type || 'clinical_note';
        // A live hint that is really an order («CBC بده») is dropped rather than
        // shown: the doctor places tests in «دستورات» and drugs in «نسخه», and the
        // AI is prompted to reason instead of ordering.
        if (hintType === 'lab_test' || hintType === 'medication') return;
        const kind = t('visit.copilot.clinicalNote');
        // Skip if an existing card of the same kind already covers this hint
        // (Visit.shared `insightSimilarity`: Persian-folded words, not raw text).
        const isDup = rawSuggestions.some((s)=>s.kind === kind && (0, $375f8776645d5aee$export$6a1145afc4baa12e)(s.title, text) > (0, $375f8776645d5aee$export$769e1e6a71b6cabc));
        if (!isDup && text) rawSuggestions.push({
            id: `hint-${i}`,
            kind: kind,
            type: 'note',
            level: 'ok',
            conf: null,
            title: text,
            body: '',
            evidence: ''
        });
    });
    if (rxInteractions?.hasInteractions) rxInteractions.warnings.forEach((w, i)=>{
        const kindMap = {
            contraindication: t('visit.rx.contraindication'),
            allergy: t('visit.patient.allergyAlert'),
            black_box: 'Black Box FDA',
            interaction: t('visit.rx.interaction')
        };
        const kind = kindMap[w.warningType] || t('visit.rx.interaction');
        // A خفیف interaction is information, so it enters the feed as a note at the
        // same volume as every other clinical note; only شدید/متوسط raise a card
        // that looks like a warning.
        const mild = (0, $375f8776645d5aee$export$a20f1db6dc818677)(w.severity) === 'low';
        rawSuggestions.push({
            id: `ix-${i}`,
            kind: kind,
            type: mild ? 'note' : 'safety',
            level: mild ? 'ok' : 'warn',
            conf: null,
            title: w.description,
            body: w.drug ? t('visit.text.drugCondition', {
                drug: w.drug
            }) + (w.condition ? t('visit.text.condition', {
                condition: w.condition
            }) : '') : '',
            evidence: w.drugPair || w.drug || '',
            _source: w.source || null
        });
    });
    // The insight pass answers with three things at once: recommended tests,
    // recommended medications, and the clinical rationale. Only the rationale is
    // read — the other two are orders, and they reach the doctor through
    // «دستورات» and «نسخه», which is where they can actually be placed.
    if (recommendations?.clinicalRationale) rawSuggestions.push({
        id: 'rationale',
        kind: t('visit.copilot.clinicalAnalysis'),
        type: 'rationale',
        level: 'ok',
        conf: null,
        title: t('visit.copilot.patientAssessment'),
        body: recommendations.clinicalRationale,
        evidence: ''
    });
    if (aiResult) {
        if (aiResult.hasInteractions && aiResult.interactionWarnings?.length) {
            // The assist answered about the نسخه as it was when it ran. A warning that
            // names a drug the doctor has since removed is no longer true, so it is not
            // shown (warningOnRx). Skipped by index rather than filtered first, so the
            // `aiix-` ids a dismissal is keyed on stay with the same warning.
            const rxNames = (0, $bb8a11e7c1131df5$export$868d19c379622928)(rxItems);
            // «بررسی تداخل» runs the same rule engine over the same drugs; a finding
            // its card already shows is not shown a second time (interactionAlreadyShown).
            const checkedIx = rxInteractions?.hasInteractions ? rxInteractions.warnings : [];
            aiResult.interactionWarnings.forEach((w, i)=>{
                if (!(0, $bb8a11e7c1131df5$export$e960330bae0466a4)(w, rxNames)) return;
                if ((0, $375f8776645d5aee$export$bd5821baf0a03519)(w, checkedIx)) return;
                const kindMap = {
                    contraindication: t('visit.rx.contraindication'),
                    allergy: t('visit.patient.allergyAlert'),
                    black_box: 'Black Box FDA',
                    interaction: t('visit.rx.interaction')
                };
                const mild = (0, $375f8776645d5aee$export$a20f1db6dc818677)(w.severity) === 'low';
                rawSuggestions.push({
                    id: `aiix-${i}`,
                    kind: kindMap[w.warningType] || t('visit.rx.interaction'),
                    type: mild ? 'note' : 'safety',
                    level: mild ? 'ok' : 'warn',
                    conf: null,
                    title: w.description,
                    body: w.drug ? t('visit.text.drugCondition', {
                        drug: w.drug
                    }) + (w.condition ? t('visit.text.condition', {
                        condition: w.condition
                    }) : '') : '',
                    evidence: w.drugPair || w.drug || '',
                    _source: w.source || null
                });
            });
        }
        // `suggestedMedications` / `recommendedTests` from the same response are
        // deliberately not read here — they are the نسخه tab's AI panel and the
        // دستورات tab's suggest button respectively.
        if (aiResult.followUpTimeline) rawSuggestions.push({
            id: 'followup',
            kind: t('visit.copilot.followUpKind'),
            type: 'followup',
            level: 'ok',
            conf: null,
            title: aiResult.followUpTimeline,
            body: '',
            evidence: ''
        });
    }
    // The backstop: no producer above builds an orderable card, and this makes
    // sure a new AI response field cannot reintroduce one. See Visit.shared.js.
    // Note completion no longer injects a card here — «نکات بالینی» is insight
    // only; the note's own tab owns the completion flow (per-section previews).
    const copilotSuggestions = (0, $375f8776645d5aee$export$b2355ec0f81e9680)(rawSuggestions.filter((s)=>!dismissedSuggs.has(s.id)));
    const activeDiffs = (differential || []).filter((d)=>d.status !== 'rejected');
    const diffQuickQ = activeDiffs.length > 0 ? [
        ...activeDiffs.slice(0, 3).map((d)=>t('visit.text.confirmQuestionsPrompt', {
                diagnosis: d.description
            })),
        t('visit.plan.prompt')
    ] : (0, $375f8776645d5aee$export$8b6317f87e032c1)(t);
    const handleLeaveConfirm = ()=>{
        setLeaveConfirm(false);
        const pending = pendingNavRef.current;
        pendingNavRef.current = null;
        if (!pending) return;
        leaveVisit(()=>{
            if (pending.callback) pending.callback();
            else if (pending[0] === '__back__') goBack();
            else navProp(...pending);
        });
    };
    const handleLeaveCancel = ()=>{
        setLeaveConfirm(false);
        pendingNavRef.current = null;
    };
    // A visit that failed to start says so from the copilot column (its «پایش
    // بالینی» slot) — that alert is never folded away.
    const copilotShown = copilotOpen || !!startError && visitStatus !== 'inprogress';
    // The video call's band lives at the foot of the record column, and folding
    // the column would unmount a call in progress — so a call holds it open.
    const callHoldsRecord = call.live || call.busy;
    const recordShown = recordPanelOpen || callHoldsRecord;
    const copilotDiffCount = (differential || []).filter((d)=>d.status !== 'rejected').length;
    const copilotSuggCount = copilotSuggestions.length;
    const copilotRailCount = copilotSuggCount + copilotDiffCount;
    // While the assistant is open the doctor sees what it holds, so that is the
    // baseline; only what arrives AFTER it is closed can raise the nudge.
    // (Adjusted during render, not in an effect: this sits below the loading
    // early-return, where a hook may not live.)
    if (copilotShown && (copilotSeen.sugg !== copilotSuggCount || copilotSeen.diff !== copilotDiffCount)) setCopilotSeen({
        sugg: copilotSuggCount,
        diff: copilotDiffCount
    });
    const dockNudge = copilotShown || nudgeDismissals >= $9b4ee9e6346f75da$var$NUDGE_MAX_DISMISSALS ? null : copilotDiffCount > copilotSeen.diff && copilotTabVisible.diff !== false ? {
        kind: 'diff',
        count: copilotDiffCount
    } : copilotSuggCount > copilotSeen.sugg && copilotTabVisible.sugg !== false ? {
        kind: 'sugg',
        count: copilotSuggCount
    } : null;
    const dismissDockNudge = ()=>{
        setCopilotSeen({
            sugg: copilotSuggCount,
            diff: copilotDiffCount
        });
        setNudgeDismissals((n)=>n + 1);
    };
    const viewDockNudge = ()=>{
        if (dockNudge) pickCopilotTab(dockNudge.kind);
        toggleCopilotOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $375f8776645d5aee$export$1f71eb225ba1e723) + (0, $375f8776645d5aee$export$220f2e5d84ced4cb) + (0, $375f8776645d5aee$export$b9d67b8f1f51ac8d)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: leaveConfirm,
        onOpenChange: (v)=>{
            if (!v) handleLeaveCancel();
        },
        title: t('visit.confirm.leaveTitle'),
        message: t('visit.confirm.leaveBody'),
        confirmLabel: t('visit.confirm.leaveConfirm'),
        cancelLabel: t('visit.confirm.leaveCancel'),
        destructive: true,
        onConfirm: handleLeaveConfirm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!orderToCancel,
        onOpenChange: (v)=>{
            if (!v) setOrderToCancel(null);
        },
        title: orderToCancel ? t('visit.orders.cancelNamed', {
            name: orderToCancel.description
        }) : t('visit.orders.cancelTitle'),
        message: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        onConfirm: ()=>{
            if (orderToCancel) handleOrderTransition(orderToCancel.id, 'cancel');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!erxLeave,
        onOpenChange: (open)=>{
            if (!open) setErxLeave(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-erx-leave-ok",
        cancelTestId: "visit-erx-leave-cancel",
        "data-testid": "visit-erx-leave-confirm",
        onConfirm: ()=>{
            const next = erxLeave?.next ?? null;
            setErxLeave(null);
            setErxBusy(false);
            setErxScope(next);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-workspace",
        style: {
            display: 'grid',
            gridTemplateColumns: (0, $84e131569ade80e0$export$88c3a43a7eaf51eb)({
                contextExpanded: contextExpanded,
                copilotExpanded: copilotExpanded,
                recordOpen: recordShown,
                copilotOpen: copilotShown
            }),
            gridTemplateRows: 'auto 1fr',
            height: '100vh',
            background: 'var(--bg)',
            transition: 'grid-template-columns .22s ease',
            // The doctor's chosen face, not a pinned one — see src/constants/fonts.js.
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOGbh.default), {
        "data-testid": "visit-topbar",
        onBack: ()=>visitStatus === 'inprogress' ? (pendingNavRef.current = [
                '__back__'
            ], setLeaveConfirm(true)) : goBack(),
        backLabel: t('common.actions.back'),
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'var(--primary)',
                color: '#fff',
                display: 'grid',
                placeItems: 'center',
                fontWeight: 700,
                fontSize: 15
            }
        }, p?.name?.charAt(0) || '?'),
        title: p?.name || "\u2014",
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>setGlanceOpen(true),
            "data-testid": "visit-record-glance",
            title: t('visit.glance.title'),
            "aria-label": t('visit.glance.title'),
            "aria-haspopup": "dialog",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                flexShrink: 0,
                padding: '4px 11px',
                borderRadius: 'var(--radius)',
                background: 'var(--primary)',
                border: 'none',
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
                fontFamily: 'inherit',
                whiteSpace: 'nowrap',
                cursor: 'pointer'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).scan, {
            width: 13,
            height: 13
        }), " ", t('visit.glance.open')), visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--good-soft)',
                color: 'var(--good-ink)',
                fontSize: 11,
                fontWeight: 700
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--good)',
                animation: 'pulse 1.6s infinite',
                display: 'inline-block'
            }
        }), t('visit.resume.inProgress')) : visitStatus === 'finished' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--good-soft)',
                color: 'var(--good-ink)',
                fontSize: 11,
                fontWeight: 700
            }
        }, t('visit.header.ended')) : null),
        badges: // A live call must read at a glance from anywhere on the screen —
        // the doctor may have the record rail folded away or be deep in the
        // prescription tab when they need to know the camera is on.
        call.live ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-header-call-pill",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)',
                fontSize: 11,
                fontWeight: 700
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--accent)',
                animation: 'pulse 1.6s infinite',
                display: 'inline-block'
            }
        }), t('visit.call.headerPill')) : resumedVisit && visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--warn-soft)',
                border: '1px solid var(--warn)',
                fontSize: 11,
                color: 'var(--warn-ink)',
                fontWeight: 600
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).history, {
            width: 12,
            height: 12
        }), t('visit.resume.recovered'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            "aria-label": t('common.actions.close'),
            "data-testid": "visit-resumed-dismiss",
            className: "h-5 w-5",
            onClick: ()=>setResumedVisit(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
            width: 12,
            height: 12
        }))) : null,
        meta: [
            p?.age ? t('visit.patient.years', {
                count: p.age
            }) : null,
            p?.bloodType || null,
            p?.nationalId ? t('visit.patient.codeIs', {
                code: p.nationalId
            }) : null
        ]
    }, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$45fe3bada8fd7008), {
        recState: recState,
        recElapsed: recElapsed,
        disabled: isStopping || isConnecting,
        onToggle: isRecording ? stopMonitoring : isRecPaused ? resumeRec : startRec,
        complete: completion.allButton
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-header-duration",
        "aria-label": `${t('visit.header.duration')} ${formatDigits(`${mm}:${ss}`)}`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '5px 11px',
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            background: 'var(--panel-2)',
            color: 'var(--ink)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).clock, {
        width: 13,
        height: 13,
        style: {
            color: 'var(--mute)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: 'var(--mute)'
        }
    }, t('visit.header.duration')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, formatDigits(`${mm}:${ss}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95619a68e42b6cf6$export$2e2bcd8739ae039), {
        entries: coinLedger,
        total: visitCoins
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: handleCancelEncounter,
        disabled: cancellingVisit,
        "aria-label": t('visit.header.cancelVisit'),
        "data-testid": "visit-topbar-cancel",
        className: "gap-1.5 text-destructive border-destructive/30"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).close, {
        width: 12,
        height: 12
    }), " ", cancellingVisit ? t('visit.header.cancelling') : t('visit.header.cancelVisit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: ()=>setPendingEnd(true),
        disabled: endProgress.running,
        "data-testid": "visit-topbar-end",
        className: "gap-1.5",
        title: t('visit.header.endVisitTitle')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).stop, {
        width: 13,
        height: 13
    }), " ", t('visit.header.endVisit')))), creditError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-credit-banner",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
            background: 'var(--danger-soft)',
            borderBottom: '2px solid var(--danger)',
            padding: '8px 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            fontSize: '0.85rem',
            fontWeight: 600,
            color: 'var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 15,
        height: 15
    }), " ", t('errors.kind.insufficientCredits.title'), walletBalance !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            opacity: 0.85
        }
    }, "\xb7 ", t('visit.header.balanceLabel'), " ", (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(walletBalance, formatNumber), " ", t('common.units.coin'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        "data-testid": "visit-credit-topup",
        onClick: ()=>navProp('credits')
    }, t('credits.buyCoins')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": t('visit.state.dismissAlert'),
        title: t('visit.state.dismissAlert'),
        "data-testid": "visit-credit-dismiss",
        onClick: ()=>setCreditError(null),
        style: {
            display: 'grid',
            placeItems: 'center',
            width: 30,
            height: 30,
            padding: 0,
            borderRadius: 8,
            border: '1px solid var(--danger)',
            background: 'transparent',
            color: 'var(--danger-ink)',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 15,
        height: 15
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$f8baeb9beb7439e1), {
        steps: completion.flow.steps,
        current: completeSectionShown,
        next: completion.flow.nextFrom(completeSectionShown),
        onGo: goCompleteSection
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$cccda98cbc9f2aa5, {
        t: t,
        formatNumber: formatNumber,
        recordOpen: recordShown,
        recordLocked: callHoldsRecord,
        onToggleRecord: ()=>toggleRecordPanelOpen(),
        onOpenRecord: ()=>toggleRecordPanelOpen(true),
        copilotOpen: copilotShown,
        copilotLocked: copilotShown && !copilotOpen,
        onToggleCopilot: ()=>toggleCopilotOpen(),
        onOpenCopilot: ()=>toggleCopilotOpen(true),
        copilotCount: copilotRailCount,
        allergyCount: p?.allergies?.length || 0,
        allergyTitle: p?.allergies?.length ? `${t('visit.patient.allergyAlert')}: ${formatList(p.allergies)}` : '',
        showCall: !!call.available,
        lowBalance: walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low',
        canBuyCredits: canBuyCredits,
        nudge: dockNudge,
        onNudgeView: viewDockNudge,
        onNudgeDismiss: dismissDockNudge,
        erxAvailable: erxAvailable,
        erxOpen: erxOpen,
        onToggleErx: ()=>changeErxScope(erxScopeRef.current !== null ? null : 'ALL'),
        erxPendingCount: erxPending.ALL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 4,
            background: 'var(--panel)',
            borderInlineStart: '1px solid var(--line)',
            display: copilotShown ? 'flex' : 'none',
            flexDirection: 'column',
            minHeight: 0,
            minWidth: 0
        }
    }, copilotShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontWeight: 600,
            fontSize: 13,
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setCopilotExpanded((v)=>!v),
        title: copilotExpanded ? t('visit.panel.collapse') : t('visit.panel.expand'),
        "aria-label": copilotExpanded ? t('visit.panel.collapseCopilot') : t('visit.panel.expandCopilot'),
        "aria-pressed": copilotExpanded,
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: copilotExpanded ? 'var(--accent-soft)' : 'var(--panel-2)',
            color: copilotExpanded ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, copilotExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).arrow, {
        width: 14,
        height: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).back, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: visitStatus === 'inprogress' ? 'var(--good)' : 'var(--mute-2)',
            display: 'inline-block',
            boxShadow: visitStatus === 'inprogress' ? '0 0 0 3px var(--good-soft)' : 'none'
        }
    }), t('visit.copilot.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, "AI \xb7 v2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>toggleCopilotOpen(false),
        "data-testid": "visit-copilot-fold",
        title: t('visit.copilot.fold'),
        "aria-label": t('visit.copilot.fold'),
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 13,
        height: 13
    })))), walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-lowbalance-strip",
        style: {
            padding: '8px 12px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: 'var(--warn-soft)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 13,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--warn-ink)'
        }
    }, t('visit.header.lowCreditPrefix'), (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(walletBalance, formatNumber), " ", t('visit.header.lowCreditSuffix')), canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>navProp('credits'),
        "data-testid": "visit-lowbalance-topup",
        style: {
            border: '1px solid var(--warn)',
            color: 'var(--warn-ink)',
            background: 'transparent',
            borderRadius: 6,
            padding: '2px 9px',
            fontSize: 10.5,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            whiteSpace: 'nowrap'
        }
    }, t('credits.topUp'))), startError && visitStatus !== 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-start-failed",
        role: "alert",
        style: {
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)',
            background: 'var(--danger-soft)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 13,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 11.5,
            fontWeight: 700,
            color: 'var(--danger-ink)'
        }
    }, t('visit.start.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        "data-testid": "visit-start-retry",
        onClick: handleStart,
        className: "h-7 gap-1.5 text-[10.5px]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).reload, {
        width: 11,
        height: 11
    }), " ", t('visit.start.retry'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute)',
            marginTop: 5,
            lineHeight: 1.7
        }
    }, t(`${(0, $91f57610161f2da8$export$78353e7f4dfe1b54)((0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(startError))}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: 'var(--mute)',
            marginTop: 3,
            lineHeight: 1.7
        }
    }, t('visit.start.failedHint'))), visitStatus === 'inprogress' && isRecPaused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-recording-interrupted",
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderBottom: '1px solid var(--line)',
            background: 'oklch(0.97 0.04 85)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 11,
            fontWeight: 600,
            color: 'oklch(0.45 0.09 70)'
        }
    }, t('visit.record.interrupted')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-recording-dismiss",
        onClick: dismissPause,
        style: {
            background: 'transparent',
            border: 'none',
            color: 'oklch(0.45 0.09 70)',
            fontSize: 11,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.dismiss'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            borderBottom: '1px solid var(--line)',
            background: 'var(--panel)',
            flexShrink: 0
        }
    }, [
        {
            id: 'sugg',
            label: t('visit.copilot.clinicalNotes'),
            count: copilotSuggestions.length
        },
        {
            id: 'diff',
            label: t('visit.copilot.differential'),
            count: (differential || []).filter((d)=>d.status !== 'rejected').length
        },
        // «برنامه درمانی» is not a copilot tab: the plan is generated,
        // reviewed and filed from the SOAP «P» section in the work area.
        {
            id: 'ask',
            label: t('visit.copilot.ask'),
            count: 0
        }
    ].filter((tab)=>copilotTabVisible[tab.id] !== false || copilotTab === tab.id).map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: tab.id,
            "data-testid": `visit-copilot-tab-${tab.id}`,
            onClick: ()=>pickCopilotTab(tab.id),
            style: {
                flex: 1,
                padding: '10px 6px',
                fontSize: 11,
                fontWeight: 500,
                color: copilotTab === tab.id ? 'var(--ink)' : 'var(--mute)',
                borderBottom: copilotTab === tab.id ? '2px solid var(--ink)' : '2px solid transparent',
                background: 'none',
                borderTop: 'none',
                borderInlineEnd: 'none',
                borderInlineStart: 'none',
                borderBottom: copilotTab === tab.id ? '2px solid var(--ink)' : '2px solid transparent',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, tab.label, tab.count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                fontWeight: 700,
                padding: '1px 5px',
                borderRadius: 4,
                background: copilotTab === tab.id ? 'var(--accent-soft)' : 'var(--line)',
                color: copilotTab === tab.id ? 'var(--accent-ink)' : 'var(--ink-2)'
            }
        }, tab.count)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: 12
        }
    }, copilotTab === 'sugg' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--mute)',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '10px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.copilot.loadingNotes')), copilotSuggestions.length === 0 && !recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-sugg-empty",
        style: {
            textAlign: 'center',
            padding: '32px 12px',
            color: 'var(--mute)',
            fontSize: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, null)), recsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8,
            color: 'var(--danger)'
        }
    }, recsError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        style: {
            marginTop: 10
        },
        "data-testid": "visit-sugg-run",
        onClick: runRecommendations
    }, t('common.actions.retry'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8
        }
    }, recsRan ? t('errors.empty.clinicalNotes') : t('visit.copilot.autoRunOff')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        style: {
            marginTop: 10
        },
        className: "gap-1.5",
        "data-testid": "visit-sugg-run",
        onClick: runRecommendations
    }, t('visit.copilot.getClinicalNotes')))), copilotSuggestions.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (s.id || s.title) + '_' + i,
            style: {
                background: s.level === 'warn' ? 'linear-gradient(180deg,var(--warn-soft),var(--panel-2) 60%)' : 'var(--panel-2)',
                border: `1px solid ${s.level === 'warn' ? 'oklch(0.85 0.06 55)' : 'var(--line)'}`,
                borderRadius: 9,
                padding: '11px 12px',
                marginBottom: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                padding: '2px 6px',
                borderRadius: 4,
                background: s.level === 'warn' ? 'var(--warn-soft)' : 'var(--accent-soft)',
                color: s.level === 'warn' ? 'oklch(0.42 0.12 50)' : 'var(--accent-ink)'
            }
        }, s.kind), s.conf != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                color: 'var(--mute)',
                fontFamily: 'monospace',
                marginInlineStart: 'auto'
            }
        }, Math.round(s.conf * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12.5,
                fontWeight: 600,
                color: 'var(--ink)',
                marginBottom: 3,
                lineHeight: 1.45
            }
        }, s.title), s.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12,
                color: 'var(--ink-2)',
                lineHeight: 1.65,
                marginBottom: 5,
                whiteSpace: 'pre-line'
            }
        }, s.body), s.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: 'var(--mute)',
                marginTop: 5,
                padding: '5px 8px',
                borderRadius: 5,
                background: 'rgba(0,0,0,.025)',
                border: '1px dashed var(--line)',
                lineHeight: 1.5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            style: {
                color: 'var(--ink-2)'
            }
        }, t('visit.copilot.evidence'), " "), s.evidence)))), copilotTab === 'diff' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, t('visit.copilot.fromVisitEvidence')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, visitStatus === 'inprogress' && diffReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": "visit-diff-poll-toggle",
        "data-poll-state": pollingActive ? 'on' : 'off',
        "data-poll-seconds": pollingActive ? String(pollSeconds) : undefined,
        "aria-pressed": pollingActive,
        onClick: togglePolling,
        title: pollingActive ? t('visit.copilot.pollDisable') : t('visit.copilot.pollEnable'),
        style: {
            background: pollingActive ? 'var(--accent-soft)' : 'transparent',
            border: `1px solid ${pollingActive ? 'var(--accent)' : 'var(--line)'}`,
            cursor: 'pointer',
            padding: '3px 8px',
            borderRadius: 6,
            fontSize: 10.5,
            color: pollingActive ? 'var(--accent-ink)' : 'var(--mute)',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: pollingActive ? 'var(--accent)' : 'var(--mute)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.copilot.pollLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        },
        "data-testid": "visit-diff-poll-state"
    }, pollingActive ? (0, $2d58c73a38525204$export$934efb048138efd3)(pollSeconds, t, formatNumber) : t('visit.copilot.pollOff'))), diffLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), !diffLoading && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-diff-refresh",
        onClick: fetchDifferential,
        disabled: !diffReady,
        title: diffReady ? t('common.actions.refresh') : t('visit.copilot.diffGate.blockedRefresh'),
        style: {
            background: 'transparent',
            border: '1px solid var(--line)',
            cursor: diffReady ? 'pointer' : 'not-allowed',
            opacity: diffReady ? 1 : 0.5,
            padding: '3px 8px',
            borderRadius: 6,
            fontSize: 10.5,
            color: 'var(--mute)',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 4
        }
    }, t('visit.copilot.refresh')))), pollOverridden && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-poll-note",
        style: {
            marginTop: -4,
            marginBottom: 10,
            fontSize: 10.5,
            color: 'var(--mute)'
        }
    }, t('visit.copilot.pollVisitOnly')), !diffReady && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate",
        "data-missing": diffGate.missing.join(','),
        style: {
            marginBottom: 10,
            padding: '12px 13px',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            marginBottom: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 13,
        height: 13,
        style: {
            flexShrink: 0,
            color: 'var(--accent-ink)',
            marginTop: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--ink)',
            lineHeight: 1.65
        }
    }, t('visit.copilot.diffGate.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-history",
        "data-state": "todo",
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 7,
            fontSize: 11.5,
            lineHeight: 1.7,
            color: 'var(--ink-2)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            marginTop: 5,
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t(`visit.copilot.diffGate.${diffGate.missing.includes('historyThin') ? 'historyThin' : 'history'}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-hint",
        style: {
            marginTop: 7,
            paddingTop: 7,
            borderTop: '1px dashed var(--line)',
            fontSize: 11,
            lineHeight: 1.7,
            color: 'var(--mute)'
        }
    }, t('visit.copilot.diffGate.monitoringHint'))), soapDiffConfirm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 8,
            padding: '10px 12px',
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            borderRadius: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            marginBottom: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 13,
        height: 13,
        style: {
            flexShrink: 0,
            color: 'var(--accent-ink)',
            marginTop: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            color: 'var(--ink)',
            lineHeight: 1.6
        }
    }, t('visit.soap.addToAssessment', {
        text: soapDiffConfirm.description
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setSoap((prev)=>{
                const updated = {
                    ...prev,
                    a: [
                        prev.a,
                        soapDiffConfirm.description
                    ].filter(Boolean).join('\n')
                };
                handleSaveSoapNote(updated);
                return updated;
            });
            setSoapDiffConfirm(null);
        },
        style: {
            flex: 1,
            padding: '5px 12px',
            borderRadius: 6,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontSize: 11.5,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setSoapDiffConfirm(null),
        style: {
            padding: '5px 12px',
            borderRadius: 6,
            border: '1px solid var(--line)',
            background: 'transparent',
            color: 'var(--mute)',
            fontSize: 11.5,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.no')))), (!differential || differential.length === 0) && !diffLoading && (diffReady || visitStatus !== 'inprogress') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '32px 12px',
            color: 'var(--mute)',
            fontSize: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, null)), visitStatus === 'inprogress' ? sessionReady ? t('errors.empty.differential') : t('visit.header.preparing') : t('visit.copilot.afterStart')), (differential || []).map((d, i)=>{
        const confColor = {
            high: 'var(--good)',
            medium: 'var(--warn)',
            low: 'var(--mute)'
        }[d.confidenceScore?.level || d.confidence] || 'var(--mute)';
        const confBg = {
            high: 'var(--good-soft)',
            medium: 'var(--warn-soft)',
            low: 'var(--panel-2)'
        }[d.confidenceScore?.level || d.confidence] || 'var(--panel-2)';
        const confLabel = {
            high: t('visit.vitals.high'),
            medium: t('visit.vitals.moderate'),
            low: t('visit.vitals.low')
        }[d.confidence] || d.confidence;
        const rawScore = d.confidenceScore?.score || 0;
        const confPct = Math.round(rawScore <= 1 ? rawScore * 100 : rawScore);
        const isAccepted = (0, $375f8776645d5aee$export$d20c1dcfc45ad42b)(d);
        const isRejected = d.status === 'rejected';
        const acceptedType = (0, $375f8776645d5aee$export$5b3196b6580e75eb)(activeConds, d.diagnosisCode);
        const isAIOpen = openAIDiag === d.diagnosisCode;
        const aiQs = diagAIQuestions[d.diagnosisCode] || [];
        const aiAnswers = diagAIAnswers[d.diagnosisCode] || {};
        const aiLoading = diagAILoading[d.diagnosisCode] || false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: isAccepted ? 'linear-gradient(180deg,var(--good-soft),var(--panel-2) 60%)' : 'var(--panel-2)',
                border: `1px solid ${isAccepted ? 'var(--good)' : 'var(--line)'}`,
                borderRadius: 9,
                padding: '11px 12px',
                marginBottom: 8,
                opacity: isRejected ? 0.55 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 6,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9.5,
                fontWeight: 700,
                fontFamily: 'monospace',
                letterSpacing: '.03em',
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--line)',
                color: 'var(--ink-2)',
                direction: 'ltr'
            }
        }, d.diagnosisCode), isAccepted && (acceptedType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
            cond: {
                verificationStatus: acceptedType
            },
            testid: `visit-diff-type-badge-${d.diagnosisCode}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--good-soft)',
                color: 'var(--good)'
            }
        }, t('visit.state.confirmed'))), isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--panel)',
                color: 'var(--mute)'
            }
        }, t('visit.state.dismissed')), d.confidenceScore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                fontWeight: 700,
                color: confColor,
                fontFamily: 'monospace',
                marginInlineStart: 'auto'
            }
        }, confPct, t('visit.state.percentSign')) : confLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                fontWeight: 700,
                padding: '2px 7px',
                borderRadius: 4,
                background: confBg,
                color: confColor,
                marginInlineStart: 'auto'
            }
        }, confLabel) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12.5,
                fontWeight: 600,
                color: isAccepted ? 'var(--good)' : 'var(--ink)',
                lineHeight: 1.45,
                textDecoration: isRejected ? 'line-through' : 'none'
            }
        }, d.description), d.confidenceScore && !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginTop: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "conf-bar-track",
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "conf-bar-fill",
            style: {
                width: `${confPct}%`,
                background: confColor
            }
        })), confLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                color: 'var(--mute)',
                flexShrink: 0
            }
        }, t('visit.copilot.confidence'), " ", confLabel)), d.vitalSignImpact?.length > 0 && !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: 8,
                paddingTop: 8,
                borderTop: '1px dashed var(--line)'
            },
            "data-testid": "visit-diff-vital-impact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                ...(0, $375f8776645d5aee$export$6897efa034860c56),
                fontSize: 9.5,
                marginBottom: 4
            }
        }, t('visit.copilot.vitalImpact.title')), d.vitalSignImpact.map((v, j)=>{
            const meta = (0, $375f8776645d5aee$export$739e6a3f924c37ce)(v.effect, t);
            const tone = {
                good: 'var(--good)',
                danger: 'var(--danger)',
                mute: 'var(--mute)'
            }[meta.tone];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: 6,
                    marginBottom: 3,
                    fontSize: 10.5,
                    lineHeight: 1.55,
                    color: 'var(--ink-2)'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: 5,
                    height: 5,
                    borderRadius: '50%',
                    background: tone,
                    flexShrink: 0,
                    marginTop: 5
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600,
                    color: 'var(--ink)'
                }
            }, v.vital, v.value ? ` ${v.value}` : ''), v.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: tone,
                    fontWeight: 600
                }
            }, " \xb7 ", v.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)'
                }
            }, " \xb7 ", meta.label), " \u2014 ", v.explanation));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 6,
                marginTop: 10,
                paddingTop: 10,
                borderTop: '1px solid var(--line)'
            }
        }, !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-accept-${d.diagnosisCode}`,
            // Opens the «نوع تشخیص» choice instead of confirming
            // outright — there is no path from this button to a
            // recorded diagnosis that skips the type. On an
            // already-accepted item the same button is how the
            // doctor CHANGES the type.
            onClick: ()=>setDiffTypePick(diffTypePick === d.diagnosisCode ? null : d.diagnosisCode),
            title: isAccepted ? t('visit.dx.type.changeTitle') : t('common.actions.confirm'),
            style: {
                flex: 1,
                padding: '5px 8px',
                borderRadius: 6,
                fontSize: 11.5,
                fontWeight: 500,
                background: isAccepted ? 'var(--good-soft)' : 'var(--ink)',
                color: isAccepted ? 'var(--good)' : '#faf7f4',
                border: isAccepted ? '1px solid var(--good)' : 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
            width: 11,
            height: 11
        }), " ", isAccepted ? t('visit.dx.type.change') : t('visit.copilot.confirmDiagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: async ()=>{
                try {
                    setDiffTypePick(null);
                    await (0, $375f8776645d5aee$export$a11a26367843ed4f)(diffDecisionSeqRef, async ()=>{
                        const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$477e67f6b97e7e38), {
                            appointmentId: visitId,
                            diagnosisCode: d.diagnosisCode,
                            action: 'reject'
                        });
                        const updated = res.updateDifferentialItem?.items;
                        if (updated) setDifferential((prev)=>{
                            const prevMap = Object.fromEntries((prev || []).map((x)=>[
                                    x.diagnosisCode,
                                    x
                                ]));
                            return updated.map((item)=>({
                                    ...item,
                                    confidenceScore: item.confidenceScore ?? prevMap[item.diagnosisCode]?.confidenceScore
                                }));
                        });
                    });
                } catch  {}
            },
            title: t('visit.state.dismiss'),
            style: {
                padding: '5px 10px',
                borderRadius: 6,
                fontSize: 11.5,
                fontWeight: 500,
                background: 'transparent',
                color: 'var(--ink-2)',
                border: '1px solid var(--line)',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
            width: 11,
            height: 11
        }), " ", t('visit.state.dismiss'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-ai-${d.diagnosisCode}`,
            "aria-expanded": isAIOpen,
            onClick: ()=>{
                const next = isAIOpen ? null : d.diagnosisCode;
                setOpenAIDiag(next);
                if (next && !diagAIQuestions[d.diagnosisCode] && !aiLoading) handleLoadDiagAIQuestions(d);
            },
            title: t('visit.copilot.confirmQuestions'),
            style: {
                flex: isRejected ? 1 : undefined,
                padding: '5px 10px',
                borderRadius: 6,
                fontSize: 11.5,
                fontWeight: 500,
                border: `1px solid ${isAIOpen ? 'var(--accent)' : 'var(--line)'}`,
                background: isAIOpen ? 'var(--accent-soft)' : 'transparent',
                color: isAIOpen ? 'var(--accent-ink)' : 'var(--ink-2)',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
            width: 11,
            height: 11
        }), " ", t('visit.copilot.questions'))), diffTypePick === d.diagnosisCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$7085d532b18268b), {
            testidPrefix: `visit-diff-type-${d.diagnosisCode}`,
            current: (0, $375f8776645d5aee$export$5b3196b6580e75eb)(activeConds, d.diagnosisCode),
            busy: diffTypeBusy,
            title: isAccepted ? t('visit.dx.type.changeTitle') : undefined,
            onCancel: ()=>setDiffTypePick(null),
            onPick: async (type)=>{
                setDiffTypeBusy(true);
                try {
                    await (0, $375f8776645d5aee$export$a11a26367843ed4f)(diffDecisionSeqRef, ()=>(0, $375f8776645d5aee$export$5cadc197239e50ce)({
                            bffMutation: $adebb901af88e18b$export$8395d0fc0d822a81,
                            visitId: visitId,
                            diagnosisCode: d.diagnosisCode,
                            diagnosisType: type,
                            isAccepted: isAccepted,
                            setDifferential: setDifferential
                        }));
                    setDiffTypePick(null);
                    // The chart now holds this diagnosis with its type —
                    // pull it back so the record panel and this card agree.
                    refreshPatient();
                    if (!isAccepted) setSoapDiffConfirm({
                        description: d.description,
                        diagnosisCode: d.diagnosisCode
                    });
                } catch  {}
                setDiffTypeBusy(false);
            }
        }), isAIOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-diff-qbox-${d.diagnosisCode}`,
            style: {
                marginTop: 10,
                padding: '11px 12px',
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                borderRadius: 9,
                display: 'flex',
                flexDirection: 'column',
                gap: 10
            }
        }, aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'center',
                gap: 4,
                padding: '10px 0'
            }
        }, [
            0,
            1,
            2
        ].map((j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: 'var(--mute)',
                    animation: `pulse .9s ease ${j * .2}s infinite`
                }
            }))), !aiLoading && aiQs.map((q)=>{
            const ans = aiAnswers[q.id];
            const qKey = `${d.diagnosisCode}:${q.id}`;
            const submitting = diagQSubmitting[qKey];
            const qError = diagQError[qKey];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: q.id,
                "data-testid": `visit-diff-q-${q.id}`,
                "data-state": ans?.answer ? 'answered' : 'open',
                style: {
                    border: `1.5px solid ${ans?.answer ? ans.answer === 'yes' ? 'oklch(0.72 0.18 145)' : 'oklch(0.72 0.18 30)' : qError ? 'var(--danger)' : 'var(--line)'}`,
                    borderRadius: 9,
                    padding: '9px 11px',
                    background: ans?.answer ? ans.answer === 'yes' ? 'oklch(0.96 0.05 145)' : 'oklch(0.97 0.05 30)' : 'var(--panel-2)',
                    transition: 'all .15s'
                }
            }, ans?.answer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: ans.answer === 'yes' ? 'oklch(0.25 0.14 145)' : 'oklch(0.35 0.12 30)'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
                width: 11,
                height: 11
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1
                }
            }, (0, $375f8776645d5aee$export$afbcfcdadda1b1bf)(q, ans.answer, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 10,
                    fontWeight: 700,
                    color: 'var(--mute)'
                }
            }, t('visit.state.recorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 12.5,
                    color: 'var(--ink)',
                    lineHeight: 1.65,
                    marginBottom: q.hint ? 3 : 7
                }
            }, q.question), q.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    color: 'var(--mute)',
                    lineHeight: 1.5,
                    marginBottom: 7
                }
            }, q.hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 5
                }
            }, [
                {
                    v: 'yes',
                    label: t('visit.state.yesTick'),
                    hue: 145
                },
                {
                    v: 'no',
                    label: t('visit.state.noCross'),
                    hue: 30
                }
            ].map(({ v: v, label: label, hue: hue })=>{
                const pending = submitting === v;
                const locked = !!submitting;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    key: v,
                    "data-testid": `visit-diff-q-${v}-${q.id}`,
                    disabled: locked,
                    "aria-busy": pending || undefined,
                    onClick: ()=>handleAnswerDiagQuestion(d, q, v),
                    style: {
                        padding: '7px 0',
                        borderRadius: 7,
                        fontSize: 12.5,
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        cursor: locked ? 'default' : 'pointer',
                        transition: 'all .12s',
                        opacity: locked && !pending ? 0.5 : 1,
                        background: 'var(--panel)',
                        border: `1.5px solid ${pending ? `oklch(0.65 0.2 ${hue})` : 'var(--line)'}`,
                        color: 'var(--ink-2)'
                    }
                }, pending ? t('common.state.saving') : label);
            }))), qError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                role: "alert",
                "data-testid": `visit-diff-q-error-${q.id}`,
                style: {
                    marginTop: 6,
                    fontSize: 11,
                    color: 'var(--danger)',
                    lineHeight: 1.5
                }
            }, qError));
        }), !aiLoading && aiQs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-q-reload-${d.diagnosisCode}`,
            onClick: ()=>{
                // The findings already committed stay in «S» — this
                // only drops the questions they came from.
                setDiagAIQuestions((prev)=>({
                        ...prev,
                        [d.diagnosisCode]: []
                    }));
                setDiagAIAnswers((prev)=>({
                        ...prev,
                        [d.diagnosisCode]: {}
                    }));
                setDiagQError((prev)=>Object.fromEntries(Object.entries(prev).filter(([k])=>!k.startsWith(`${d.diagnosisCode}:`))));
                handleLoadDiagAIQuestions(d);
            },
            style: {
                padding: '5px 0',
                borderRadius: 7,
                border: '1px solid var(--line)',
                background: 'transparent',
                fontSize: 11,
                color: 'var(--mute)',
                fontFamily: 'inherit',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).reload, {
            width: 10,
            height: 10
        }), " ", t('visit.copilot.regenerateQuestions'))));
    })), copilotTab === 'ask' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, aiMessages.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '28px 12px',
            color: 'var(--mute)',
            fontSize: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).ai, null)), t('visit.copilot.askOrQuick')), aiMessages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                animation: 'fadeUp .2s ease'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '9px 12px',
                borderRadius: 9,
                fontSize: 12.5,
                lineHeight: 1.7,
                // The composer accepts newlines, so the bubble has to keep
                // them — otherwise a multi-line question echoes back as one
                // run-on line.
                whiteSpace: 'pre-wrap',
                background: m.role === 'user' ? 'var(--ink)' : 'var(--panel-2)',
                color: m.role === 'user' ? '#faf7f4' : 'var(--ink)',
                border: m.role === 'ai' ? '1px solid var(--line)' : 'none',
                marginInlineStart: m.role === 'user' ? 20 : 0,
                marginInlineEnd: m.role === 'ai' ? 20 : 0
            }
        }, m.text), m.role === 'ai' && m.citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: 5,
                padding: '7px 10px',
                background: 'var(--panel)',
                border: '1px dashed var(--line)',
                borderRadius: 7,
                marginInlineEnd: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 9.5,
                fontWeight: 700,
                color: 'var(--mute)',
                letterSpacing: '.05em',
                textTransform: 'uppercase',
                marginBottom: 5
            }
        }, t('visit.copilot.pubmedSources')), m.citations.map((c, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                key: j,
                href: c.url,
                target: "_blank",
                rel: "noreferrer",
                style: {
                    display: 'block',
                    fontSize: 11,
                    color: 'var(--accent-ink)',
                    lineHeight: 1.45,
                    marginBottom: 4,
                    textDecoration: 'none'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600
                }
            }, c.title), c.journal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)',
                    fontStyle: 'italic'
                }
            }, " \xb7 ", c.journal), c.year && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute-2)'
                }
            }, " (", c.year, ")")))), m.suggestions?.map((s, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: j,
                onClick: ()=>handleAsk(s),
                style: {
                    background: 'none',
                    border: '1px solid var(--line)',
                    borderRadius: 7,
                    padding: '4px 10px',
                    fontSize: 11,
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    marginTop: 4,
                    display: 'block',
                    width: '100%',
                    textAlign: 'start',
                    fontFamily: 'inherit'
                }
            }, s)))), aiChatLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 4,
            padding: '8px 12px',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 9,
            width: 'fit-content'
        }
    }, [
        0,
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--mute)',
                animation: `pulse .9s ease ${i * .2}s infinite`
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 10,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '.06em',
            color: 'var(--mute-2)',
            marginBottom: 4
        }
    }, t('visit.copilot.quickQuestions')), diffQuickQ.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: i,
            onClick: ()=>handleAsk(q),
            style: {
                display: 'block',
                width: '100%',
                textAlign: 'start',
                padding: '7px 10px',
                marginBottom: 3,
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 8,
                fontSize: 11,
                color: 'var(--ink-2)',
                cursor: 'pointer',
                fontFamily: 'inherit'
            }
        }, q))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: '1px solid var(--line)',
            padding: '10px 12px',
            background: 'var(--panel)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: 7,
            padding: '7px 11px',
            borderRadius: 9,
            background: 'var(--panel-2)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: askFieldRef,
        value: aiInput,
        onChange: (e)=>setAiInput(e.target.value),
        onKeyDown: (e)=>{
            if (e.key !== 'Enter' || e.shiftKey) return; // Shift+Enter = newline
            // Committing Persian predictive text ends with Enter too —
            // that one is not a send.
            if (e.nativeEvent?.isComposing) return;
            e.preventDefault();
            setCopilotTab('ask');
            handleAsk();
        },
        placeholder: t('visit.copilot.askPlaceholder'),
        "aria-label": t('visit.copilot.askPlaceholder'),
        rows: 1,
        "data-testid": "visit-copilot-ask-field",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'block',
            boxSizing: 'border-box',
            border: 'none',
            background: 'transparent',
            outline: 'none',
            fontSize: 12.5,
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: 'var(--ink)',
            // 3px block padding makes the one-line field exactly as tall as
            // the 26px send button, so the row reads as it did before.
            padding: '3px 0',
            margin: 0,
            resize: 'none',
            maxHeight: $9b4ee9e6346f75da$var$ASK_MAX_H,
            overflowY: 'auto'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setCopilotTab('ask');
            handleAsk();
        },
        style: {
            width: 26,
            height: 26,
            flexShrink: 0,
            borderRadius: 6,
            background: 'var(--ink)',
            border: 'none',
            color: '#faf7f4',
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).send, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            marginTop: 6,
            fontSize: 10,
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.copilot.answerBasis')))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 3,
            background: 'var(--bg)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 0,
            padding: '0 16px',
            background: 'var(--bg)',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, [
        {
            id: 'soap',
            label: t('visit.tabs.soap'),
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).notes,
            proposals: Object.keys(soapRefine.preview || {}).filter((k)=>k !== 'p').length
        },
        {
            id: 'rx',
            label: t('visit.tabs.rx'),
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
            badge: rxItems.length || null,
            proposals: completion.pending.rx
        },
        {
            id: 'orders',
            label: t('visit.tabs.orders'),
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).doc,
            badge: clinicalOrders.filter((o)=>o.status === 'pending').length || null,
            proposals: completion.pending.orders
        },
        {
            id: 'plan',
            label: t('visit.tabs.plan'),
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).steth,
            proposals: soapRefine.preview?.p ? 1 : 0
        }
    ].filter(({ id: id })=>workTabVisible[id] !== false || workTab === id).map(({ id: id, label: label, icon: Ic, badge: badge, loading: loading, proposals: proposals })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: id,
            "data-testid": `visit-work-tab-${id}`,
            onClick: ()=>pickWorkTab(id),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '11px 16px',
                fontSize: 14,
                fontWeight: workTab === id ? 600 : 400,
                color: workTab === id ? 'var(--ink)' : 'var(--mute)',
                borderBottom: workTab === id ? '2px solid var(--ink)' : '2px solid transparent',
                background: 'none',
                borderTop: 'none',
                borderInlineEnd: 'none',
                borderInlineStart: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                transition: 'color .12s'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Ic, null), label, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 8,
                height: 8,
                border: '1.5px solid var(--line)',
                borderTopColor: 'var(--accent)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }), !loading && badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                background: 'var(--line)',
                color: 'var(--ink-2)',
                padding: '1px 5px',
                borderRadius: 4,
                fontWeight: 600
            }
        }, badge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$75b49caa06e7c59e), {
            count: proposals,
            testid: `visit-work-tab-proposals-${id}`
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: workBodyRef,
        "data-testid": "visit-work-body",
        style: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            overflowY: 'auto',
            padding: noteTab ? '18px 20px' : '18px 20px 40px',
            ...noteTab ? {
                display: 'flex',
                flexDirection: 'column'
            } : {}
        }
    }, noteTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-note-card-${workTab}`,
        style: {
            ...(0, $375f8776645d5aee$export$97da64870f5585b8),
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        }
    }, workTab === 'plan' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$10c499a234e299a6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$a931407aa8dfff78)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).steth, {
        width: 12,
        height: 12
    })), t('visit.tabs.plan'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$10c499a234e299a6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$a931407aa8dfff78)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).notes, {
        width: 12,
        height: 12
    })), t('visit.soap.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, soapRefine.hasNewContent && !soapRefineLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-soap-refine-newdot",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 10.5,
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            flexShrink: 0
        }
    }), t('visit.soap.refine.newContent')), soapTabProposals.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-soap-refine-apply-all",
        onClick: ()=>soapRefine.applyAll(soapTabProposals),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 999,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            fontSize: 11.5,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
        width: 11,
        height: 11
    }), " ", t('visit.soap.refine.applyAll')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-scroll",
        style: {
            padding: '16px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflowY: 'auto'
        }
    }, workTab === 'soap' && soapRefine.status && soapRefine.status !== 'ok' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-refine-status",
        "data-status": soapRefine.status,
        role: soapRefine.status === 'error' ? 'alert' : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 12,
            padding: '8px 11px',
            borderRadius: 8,
            fontSize: 11.5,
            flexShrink: 0,
            background: soapRefine.status === 'error' ? 'var(--warn-soft)' : 'var(--panel-2)',
            border: `1px solid ${soapRefine.status === 'error' ? 'oklch(0.85 0.06 55)' : 'var(--line)'}`,
            color: soapRefine.status === 'error' ? 'oklch(0.42 0.12 50)' : 'var(--ink-2)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).info, {
        width: 12,
        height: 12,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, soapRefine.status === 'error' ? t('visit.soap.refine.error') : soapRefine.status === 'no_transcript' ? t('visit.soap.refine.noTranscript') : t('visit.soap.refine.noNew')), soapRefine.status === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-soap-refine-retry",
        onClick: handleSoapRefine,
        style: {
            padding: '3px 10px',
            borderRadius: 6,
            fontSize: 11,
            fontWeight: 600,
            background: 'transparent',
            color: 'inherit',
            border: '1px solid currentColor',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.retry'))), [
        {
            k: 'S',
            key: 's',
            name: t('visit.soap.subjective'),
            hint: t('visit.soap.subjectiveHint'),
            ph: t('visit.soap.subjectivePlaceholder')
        },
        {
            k: 'O',
            key: 'o',
            name: t('visit.soap.objective'),
            hint: t('visit.soap.objectiveHint'),
            ph: t('visit.soap.objectivePlaceholder')
        },
        {
            k: 'A',
            key: 'a',
            name: t('visit.soap.assessment'),
            hint: t('visit.soap.assessmentHint'),
            ph: t('visit.soap.assessmentPlaceholder')
        },
        {
            k: 'P',
            key: 'p',
            name: t('visit.soap.plan'),
            hint: t('visit.soap.planHint'),
            ph: t('visit.soap.planPlaceholder')
        }
    ].filter((s)=>s.key === 'p' === (workTab === 'plan')).map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: s.k,
            style: {
                marginBottom: 16,
                flex: '1 0 auto',
                display: 'flex',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 7,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 22,
                height: 22,
                borderRadius: '50%',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)',
                fontFamily: 'monospace',
                fontSize: 11,
                fontWeight: 700,
                display: 'grid',
                placeItems: 'center',
                flexShrink: 0
            }
        }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 600,
                fontSize: 13,
                color: 'var(--ink)'
            }
        }, s.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                color: 'var(--mute-2)',
                marginInlineStart: 'auto'
            }
        }, s.hint), s.key === 'p' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            className: "v-micbtn",
            "data-testid": "visit-soap-plan-ai",
            onClick: handleOpenPlanPanel,
            disabled: planLoading || planSaving || !visitId,
            "aria-expanded": planPanelOpen,
            style: {
                color: planLoading ? 'oklch(0.38 0.14 290)' : undefined
            },
            title: t('visit.plan.generate')
        }, planLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 8,
                height: 8,
                border: '1.5px solid oklch(0.80 0.06 290)',
                borderTopColor: 'oklch(0.38 0.14 290)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
            width: 9,
            height: 9
        }), ' ', "AI") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
            compact: true,
            testid: `visit-soap-complete-${s.key}`,
            title: t('visit.complete.hintPrice', {
                section: s.name,
                coins: formatNumber((0, $121df138798ec781$export$c932aceb7c67d0f4)('SOAP_REFINE'))
            }),
            onClick: ()=>handleSoapFieldRefine(s.key),
            disabled: !!soapFieldRefineLoading || soapRefineLoading || !visitId,
            busy: soapFieldRefineLoading === s.key
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: (el)=>{
                soapEditorRefs.current[s.key] = el;
            },
            contentEditable: true,
            suppressContentEditableWarning: true,
            "data-soap-key": s.key,
            "data-placeholder": s.ph,
            onInput: (e)=>{
                const text = e.currentTarget.textContent;
                setSoap((prev)=>({
                        ...prev,
                        [s.key]: text
                    }));
            },
            style: {
                ...(0, $375f8776645d5aee$export$d4e2cf4ef3f8061),
                padding: '10px 12px',
                lineHeight: 1.75,
                minHeight: 72,
                // basis auto + no shrink: a short note still grows to
                // fill the work area, a long one keeps its full height
                // and scrolls the card body instead of spilling out.
                flex: '1 0 auto',
                transition: 'border-color .12s',
                textAlign: 'start',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                cursor: 'text'
            },
            onFocus: (e)=>{
                e.currentTarget.style.background = 'var(--panel)';
                e.currentTarget.style.borderColor = 'var(--accent)';
                soapEntryTextRef.current[s.key] = e.currentTarget.textContent;
                // Hold the plan reconciler off «P» while the caret is in it.
                if (s.key === 'p') setPlanEditorFocused(true);
            },
            onBlur: async (e)=>{
                e.currentTarget.style.background = 'var(--field)';
                e.currentTarget.style.borderColor = 'var(--line)';
                const text = e.currentTarget.textContent;
                const enteredWith = soapEntryTextRef.current[s.key];
                // No entry value means this blur belongs to no editing
                // session at all — nothing was typed, so there is
                // nothing to re-read.
                const sectionChanged = enteredWith !== undefined && text !== enteredWith;
                delete soapEntryTextRef.current[s.key];
                const updated = {
                    ...soap,
                    [s.key]: text
                };
                // Releasing the field re-runs the reconciler, which
                // repairs a block the doctor edited or deleted by hand.
                if (s.key === 'p') setPlanEditorFocused(false);
                await handleSaveSoapNote(updated);
                // Re-assess on what was just written — an AUTOMATIC
                // run like any other, and the one that used to answer
                // to nothing: a doctor with every «دستیار هوشمند»
                // switch off still paid 10 پارسه for a fresh
                // differential every time they clicked out of a SOAP
                // box. «بازبینی پس از ویرایش یادداشت» governs it now,
                // under the differential master switch — NOT under the
                // timed loop, which needs a recording this path exists
                // without.
                //
                // And only when the text actually MOVED. Tabbing
                // through the four boxes, or clicking into one and out
                // again, changes nothing the AI could reason from — the
                // service would re-answer the same note, and bill for
                // it once per blur.
                if (sectionChanged && reassessOnEdit) fetchDifferential();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fcdf6086c22a8d18$export$2e2bcd8739ae039), {
            sectionKey: s.key,
            title: s.name,
            preview: soapRefine.preview?.[s.key],
            onAccept: ()=>soapRefine.apply(s.key),
            onDismiss: ()=>soapRefine.dismiss(s.key),
            onRerun: ()=>soapRefine.refine([
                    s.key
                ]),
            busy: soapRefineLoading,
            style: {
                marginTop: 6
            }
        }), s.key === 'p' && planBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-plan-block-hint",
            style: {
                marginTop: 5,
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                fontSize: 10,
                color: 'var(--mute-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--good)',
                display: 'inline-block',
                flexShrink: 0
            }
        }), t('visit.plan.blockHint')), s.key === 'p' && planPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$SoapPlanPanel, {
            suggestion: planSuggestion,
            loading: planLoading,
            saving: planSaving,
            status: planStatus,
            error: planError,
            selected: selectedPlanItems,
            planKey: planKey,
            onToggle: togglePlanItem,
            onConfirm: handleApplyPlan,
            onRegenerate: handleSuggestPlan,
            onClose: ()=>setPlanPanelOpen(false),
            onRestore: handleRestorePlanText,
            canRestore: planReplacedP != null,
            canGenerate: !!patient?.id && visitStatus === 'inprogress'
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: '1px solid var(--line)',
            paddingTop: 10,
            marginTop: 4,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            padding: '2px 8px',
            borderRadius: 20,
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, t('visit.soap.draft')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            fontSize: 10,
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: 'var(--good)',
            display: 'inline-block'
        }
    }), t('visit.soap.autosaveOn')), (pmEncounterId || visitId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            padding: '2px 8px',
            borderRadius: 20,
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            color: 'var(--accent-ink)',
            fontWeight: 500
        }
    }, t('visit.soap.linkedToVisit'))))), workTab === 'rx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $375f8776645d5aee$export$97da64870f5585b8),
            overflow: 'visible'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$10c499a234e299a6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$a931407aa8dfff78)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).pill, {
        width: 12,
        height: 12
    })), t('visit.rx.forThisVisit'), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$8fe483d880a02f5f)
    }, rxItems.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $737671bfbc703ec9$export$2e2bcd8739ae039), {
        kind: "medication",
        allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
        existingDrugIds: rxItems.map((r)=>r.drug?.id).filter(Boolean),
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleMedicationTemplateApplied
    }), rxInteractions?.hasInteractions && !ixStale && (()=>{
        const top = (0, $375f8776645d5aee$export$9ad745a931ba51ed)(rxInteractions.warnings);
        if (top === 'low') return null;
        const high = top === 'high';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-rx-ix-chip",
            "data-severity": top,
            style: {
                fontSize: 11,
                padding: '2px 8px',
                borderRadius: 4,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                background: high ? 'var(--danger-soft)' : 'var(--warn-soft)',
                color: high ? 'var(--danger-ink)' : 'var(--warn-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
            width: 10,
            height: 10
        }), high ? t('visit.rx.ixHighChip') : t('visit.rx.ixMediumChip'));
    })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: runInteractionCheck,
        disabled: !canCheckInteractions,
        "data-testid": "visit-rx-check-interactions",
        title: !interactionCheckReady ? t('visit.rx.ixNeedsDrugs') : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 7,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--ink-2)',
            fontSize: 11.5,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: canCheckInteractions ? 'pointer' : 'not-allowed',
            opacity: canCheckInteractions ? 1 : 0.55
        }
    }, interactionLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 9,
            height: 9,
            border: '1.5px solid var(--line)',
            borderTopColor: 'var(--ink-2)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), " ", t('visit.rx.checkingInteractionsShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).shield, {
        width: 11,
        height: 11
    }), " ", t('visit.rx.checkInteractions'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
        testid: "visit-rx-ai-monitoring",
        ...completion.button('rx'),
        disabled: !visitId
    }), [
        {
            source: (0, $864ce04f6c433567$export$594476081fc43e05).HISTORY,
            testid: 'visit-rx-ai-suggest',
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).sparkle,
            label: t('visit.rxAssist.history'),
            disabled: !visitId || !(0, $864ce04f6c433567$export$9ff2a43ac3d586f)((0, $864ce04f6c433567$export$594476081fc43e05).HISTORY, rxHistoryCtx),
            title: (0, $864ce04f6c433567$export$9ff2a43ac3d586f)((0, $864ce04f6c433567$export$594476081fc43e05).HISTORY, rxHistoryCtx) ? undefined : t('visit.rxAssist.historyNeeded'),
            onClick: ()=>rxAssist.run((0, $864ce04f6c433567$export$594476081fc43e05).HISTORY)
        },
        {
            source: 'DIRECTIONS',
            testid: 'visit-rx-ai-directions',
            icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
            label: t('visit.rx.directions.button'),
            disabled: !visitId || rxIncompleteCount === 0,
            title: rxIncompleteCount === 0 ? t('visit.rx.directions.allComplete') : t('visit.rx.directions.hint'),
            onClick: completeRxDirections,
            busy: rxDirectionsBusy
        }
    ].filter((b)=>$9b4ee9e6346f75da$var$SHOW_RX_DIRECTIONS || b.source !== 'DIRECTIONS').map((b)=>{
        const busy = b.busy !== undefined ? b.busy : rxAssist.review.phase === 'loading' && rxAssist.review.source === b.source;
        const off = b.disabled || busy;
        const Icon = b.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: b.source,
            onClick: b.onClick,
            disabled: off,
            title: b.title,
            "data-testid": b.testid,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                padding: '5px 11px',
                borderRadius: 7,
                border: '1px solid oklch(0.87 0.06 290)',
                background: busy ? 'oklch(0.95 0.02 290)' : 'oklch(0.97 0.02 290)',
                color: 'oklch(0.38 0.14 290)',
                fontSize: 11.5,
                fontWeight: 600,
                cursor: off ? 'not-allowed' : 'pointer',
                opacity: off ? 0.6 : 1,
                fontFamily: 'inherit',
                whiteSpace: 'nowrap'
            }
        }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 9,
                height: 9,
                border: '1.5px solid oklch(0.80 0.06 290)',
                borderTopColor: 'oklch(0.38 0.14 290)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            width: 11,
            height: 11
        }), b.label);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, interactionStop && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        "data-testid": "visit-rx-interaction-stop",
        style: {
            alignItems: 'flex-start'
        },
        title: t('visit.end.stoppedForInteraction'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>{
                setInteractionStop(false);
                setPendingEnd(true);
            },
            "data-testid": "visit-rx-interaction-continue"
        }, t('visit.end.continueEnding')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            onClick: ()=>setInteractionStop(false),
            "aria-label": t('common.actions.close')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
            width: 13,
            height: 13
        })))
    }, t('visit.end.stoppedForInteractionBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2366d82badfc6b73$export$2e2bcd8739ae039), {
        review: rxAssist.review,
        rxItems: rxItems,
        allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
        onToggle: rxAssist.toggle,
        onChoose: rxAssist.choose,
        onSetAll: rxAssist.setAll,
        onApply: rxAssist.apply,
        onClose: rxAssist.close,
        onRetry: ()=>rxAssist.run(rxAssist.review.source),
        onSearch: searchRxPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$4e02c9f6bbae01b0),
        "data-testid": "visit-rx-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).plus, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12.5,
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, t('visit.rx.addMedication'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadae58d6c7ed04a$export$2e2bcd8739ae039), {
        defaultsFor: rxDefaultsFor,
        prescribedIds: prescribedDrugIds,
        insurer: patientInsurer,
        onAdd: addDrug,
        request: rxAddQueue[0] || null,
        onRequestDone: (req)=>setRxAddQueue((q)=>q.filter((r)=>r.key !== req.key)),
        searchRequest: rxSearchRequest,
        showKeys: true
    })), rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).pill, {
            width: 40,
            height: 40
        }),
        title: t('visit.rx.noneRecorded'),
        description: t('visit.rx.emptyHint')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, rxItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$564a716e7cf1f53f), {
            key: item.id,
            item: item,
            onChange: (key, val)=>updateDrug(item.id, key, val),
            onRemove: ()=>removeDrug(item.id),
            insurer: patientInsurer,
            erxLine: (0, $2c5a3cdef49d8209$export$98676285bdb35e36)(item, erxIndex)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$3e7bfa10fb8d8624), {
        lines: erxRemovedRx
    }), interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--mute)',
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--warn)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.rx.checkingInteractions')), ixError && !interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-error",
        style: {
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: 12,
            color: 'var(--danger-ink)',
            fontWeight: 600
        }
    }, t('errors.load.interactions')), rxInteractions && !interactionLoading && !ixError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        "data-testid": "visit-rx-ix-report"
    }, ixStale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-stale",
        style: {
            background: 'var(--panel-2)',
            border: '1px dashed var(--line)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: 11.5,
            color: 'var(--mute)'
        }
    }, t('visit.rx.ixStale')), rxInteractions.hasInteractions ? (()=>{
        // One panel per severity, and the panel's whole appearance —
        // colour, border weight, icon, type weight — is set by which
        // severity it is. شدید shouts, متوسط informs, خفیف just sits
        // there as reference text.
        const groups = (0, $375f8776645d5aee$export$2ba0e4a723757c09)(rxInteractions.warnings);
        const line = (w, i, muted)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                style: {
                    fontSize: muted ? 11.5 : 12.5,
                    color: muted ? 'var(--ink-2)' : 'var(--ink)',
                    lineHeight: 1.65,
                    padding: '3px 0',
                    borderTop: i > 0 ? '1px solid var(--line-2)' : 'none'
                }
            }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
                style: {
                    marginInlineEnd: 4
                }
            }, w.drugPair, ":"), w.description, w.drug && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)'
                }
            }, " \xb7 ", w.drug, w.condition ? ` / ${w.condition}` : ''));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, groups.high.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-high",
            role: "alert",
            style: {
                background: 'var(--danger-soft)',
                border: '2px solid var(--danger)',
                borderRadius: 9,
                padding: '10px 13px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                fontWeight: 800,
                fontSize: 13,
                color: 'var(--danger-ink)',
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
            width: 14,
            height: 14
        }), t('visit.rx.ixHighTitle'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10.5,
                fontWeight: 700,
                padding: '1px 7px',
                borderRadius: 20,
                background: 'var(--danger)',
                color: '#fff'
            }
        }, groups.high.length)), groups.high.map((w, i)=>line(w, i, false))), groups.medium.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-medium",
            style: {
                background: 'var(--warn-soft)',
                border: '1px solid var(--warn)',
                borderRadius: 9,
                padding: '9px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontWeight: 700,
                fontSize: 12,
                color: 'var(--warn-ink)',
                marginBottom: 5
            }
        }, t('visit.rx.ixMediumTitle'), " (", groups.medium.length, ")"), groups.medium.map((w, i)=>line(w, i, false))), groups.low.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-low",
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 9,
                padding: '8px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                fontWeight: 600,
                fontSize: 11.5,
                color: 'var(--mute)',
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).info, {
            width: 11,
            height: 11
        }), t('visit.rx.ixLowTitle'), " (", groups.low.length, ")"), groups.low.map((w, i)=>line(w, i, true))));
    })() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: 'var(--good-soft)',
            border: '1px solid var(--good)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: 12,
            color: 'var(--good-ink)',
            fontWeight: 600
        }
    }, t('visit.rx.noInteractions'))))), workTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$97da64870f5585b8)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$10c499a234e299a6)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $375f8776645d5aee$export$a931407aa8dfff78)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).flask, {
        width: 12,
        height: 12
    })), t('visit.orders.title'), clinicalOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$8fe483d880a02f5f)
    }, clinicalOrders.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '1 1 0',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $737671bfbc703ec9$export$2e2bcd8739ae039), {
        kind: "order",
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleOrderTemplateApplied
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
        testid: "visit-orders-complete",
        ...completion.button('orders')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleSuggestEncounterOrders,
        disabled: encOrderSuggLoading || !visitId,
        "data-testid": "visit-orders-ai-suggest",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 7,
            border: '1px solid oklch(0.87 0.06 290)',
            background: encOrderSuggLoading ? 'oklch(0.95 0.02 290)' : 'oklch(0.97 0.02 290)',
            color: 'oklch(0.38 0.14 290)',
            fontSize: 11.5,
            fontWeight: 600,
            cursor: encOrderSuggLoading || !visitId ? 'not-allowed' : 'pointer',
            opacity: encOrderSuggLoading || !visitId ? 0.6 : 1,
            fontFamily: 'inherit'
        }
    }, encOrderSuggLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 9,
            height: 9,
            border: '1.5px solid oklch(0.80 0.06 290)',
            borderTopColor: 'oklch(0.38 0.14 290)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), " ", t('visit.copilot.checking')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 11,
        height: 11
    }), " ", t('visit.suggest.order'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '9px 12px',
            borderRadius: 8,
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).alert, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--danger-ink)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--danger-ink)',
            lineHeight: 1.6
        }
    }, orderError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOrderError(null),
        "aria-label": t('errors.dismiss'),
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--danger-ink)',
            display: 'flex',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 14,
        height: 14
    }))), findingsCard('ORDERS'), encOrderSugg && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $375f8776645d5aee$export$4e02c9f6bbae01b0),
            borderColor: 'var(--accent)'
        },
        "data-testid": "visit-orders-ai-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).sparkle, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, t('visit.suggest.orderBasis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 9.5,
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 20,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, "AI"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setEncOrderSugg(null),
        "aria-label": t('visit.suggest.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'flex',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 13,
        height: 13
    }))), encOrderSugg.rationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11.5,
            color: 'var(--ink-2)',
            lineHeight: 1.7
        }
    }, encOrderSugg.rationale), encOrderSugg.items.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--mute)'
        }
    }, t('visit.copilot.noneForState')), encOrderSugg.items.map((item, idx)=>{
        const added = encSuggAdded.has(item.key) || (0, $027388f7462935a9$export$ce329d894bbd1d2b)(clinicalOrders, item.orderType, item.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 10px',
                borderRadius: 8,
                border: `1px solid ${idx === 0 ? 'var(--accent)' : 'var(--line)'}`,
                background: idx === 0 ? 'var(--accent-soft)' : 'var(--field)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12.5,
                fontWeight: 600,
                color: 'var(--ink)',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                flexWrap: 'wrap'
            }
        }, suggestedOrderName(item.name), idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9.5,
                fontWeight: 700,
                padding: '1px 7px',
                borderRadius: 4,
                background: 'var(--accent)',
                color: '#fff'
            }
        }, t('visit.copilot.bestOption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                color: 'var(--mute)',
                padding: '1px 7px',
                borderRadius: 4,
                background: 'var(--panel-2)',
                border: '1px solid var(--line)'
            }
        }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[item.orderType] || item.orderType)), item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 10.5,
                color: 'var(--mute)',
                marginTop: 2,
                lineHeight: 1.5
            }
        }, item.reason)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$30e9b064e10043f9), {
            urgency: item.urgency
        }), added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                fontWeight: 700,
                color: 'var(--good)',
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
            width: 11,
            height: 11
        }), " ", t('visit.suggest.added')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            onClick: ()=>handleAddSuggestedOrder(item),
            disabled: encSuggAdding === item.key,
            "data-testid": `visit-order-suggest-add-${idx}`,
            className: "gap-1 shrink-0"
        }, encSuggAdding === item.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).plus, {
            width: 11,
            height: 11
        }), " ", t('common.actions.add')));
    })), (()=>{
        // Must mirror the precondition handleAddSelectedOrders/handleCreateOrder
        // actually enforce (encounter id + patient id) — otherwise the button can
        // show enabled while the patient hasn't loaded yet and silently no-op.
        const encReady = !!((pmEncounterId || visitId) && patient?.id);
        const selectedCount = selectedOrderKeys.size;
        const canAdd = encReady && !orderSaving && selectedCount > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: (0, $375f8776645d5aee$export$4e02c9f6bbae01b0),
            "data-testid": "visit-order-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: (0, $375f8776645d5aee$export$7b8c3b54c8233354)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).plus, {
            width: 12,
            height: 12
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12.5,
                fontWeight: 700,
                color: 'var(--ink)'
            }
        }, t('visit.orders.add')), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $375f8776645d5aee$export$8fe483d880a02f5f),
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)'
            }
        }, selectedCount, " ", t('visit.orders.selectedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 4,
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 8,
                padding: 3
            },
            "data-testid": "visit-order-type-tabs"
        }, [
            'lab',
            'imaging',
            'procedure'
        ].map((kind)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: kind,
                onClick: ()=>handleOrderTypeChange(kind),
                "data-testid": `visit-order-type-${kind}`,
                "data-active": orderDraftType === kind,
                style: {
                    flex: 1,
                    padding: '6px 8px',
                    borderRadius: 6,
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    fontSize: 12,
                    fontWeight: orderDraftType === kind ? 700 : 500,
                    background: orderDraftType === kind ? 'var(--panel)' : 'transparent',
                    color: orderDraftType === kind ? 'var(--accent-ink)' : 'var(--mute)',
                    boxShadow: orderDraftType === kind ? 'var(--shadow)' : 'none',
                    transition: 'all .12s'
                }
            }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[kind]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'absolute',
                insetInlineStart: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--mute)',
                pointerEvents: 'none',
                display: 'flex'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).search, {
            width: 13,
            height: 13
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            value: orderSearch,
            onChange: (e)=>setOrderSearch(e.target.value),
            placeholder: t('visit.orders.searchCatalog'),
            "data-testid": "visit-order-catalog-search",
            style: {
                ...(0, $375f8776645d5aee$export$d4e2cf4ef3f8061),
                paddingInlineStart: 32
            }
        })), orderSearch.trim().length < (0, $375f8776645d5aee$export$6770277ab0ca292e) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-search-idle",
            "data-state": "idle",
            style: {
                fontSize: 11.5,
                color: 'var(--ink-2)',
                lineHeight: 1.7
            }
        }, orderSearch.trim() ? t('visit.orders.keepTyping') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody'))) : catalogPage.loading && !catalogItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$217179f0f838b1dd), {
            testId: "visit-order-catalog-loading",
            count: 4
        }) : catalogPage.error ? /* Said out loud. A picker that silently returns nothing is
                           indistinguishable from a catalogue that does not carry
                           the service, and the doctor would type it by hand. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-error",
            style: {
                fontSize: 12,
                color: 'var(--danger-ink)',
                textAlign: 'center',
                padding: 14
            }
        }, t('visit.orders.catalogSearchFailed')) : groupedCatalog.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-empty",
            style: {
                fontSize: 12,
                color: 'var(--mute)',
                textAlign: 'center',
                padding: 14
            }
        }, t('visit.orders.noCatalogMatch')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-list",
            style: {
                maxHeight: 320,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                paddingInlineEnd: 2
            }
        }, groupedCatalog.map(({ category: category, list: list })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: category,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    color: 'var(--mute-2)',
                    letterSpacing: '.02em'
                }
            }, (0, $f78c92fb84c2d04c$export$79313fed3d273b1f)(category, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 6
                }
            }, list.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$a36149ed7c50a677), {
                    key: item.key,
                    item: item,
                    selected: selectedOrderKeys.has(item.key),
                    onToggle: toggleOrderKey,
                    showLoinc: orderDraftType === 'lab'
                }))))), catalogPage.total > catalogItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-more-results",
            style: {
                textAlign: 'center',
                fontSize: 11,
                color: 'var(--mute)',
                padding: '4px 0'
            }
        }, t('visit.rx.moreResults', {
            shown: catalogItems.length,
            total: catalogPage.total
        }))), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-selected-chips",
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 6
            }
        }, Array.from(selectedOrderKeys).map((key)=>{
            const it = selectedOrderItems.current.get(key);
            if (!it) return null;
            const name = !readsPersianData && it.nameEn ? it.nameEn : it.name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: key,
                onClick: ()=>toggleOrderKey(key),
                "aria-label": t('visit.rx.removeAria', {
                    name: name
                }),
                "data-testid": `visit-order-selected-${key}`,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '0 9px',
                    lineHeight: '24px',
                    borderRadius: 6,
                    border: '1px solid var(--accent)',
                    background: 'var(--accent-soft)',
                    color: 'var(--accent-ink)',
                    fontSize: 12,
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    cursor: 'pointer'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 500,
                    opacity: 0.8
                }
            }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[it.type] || it.type), name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
                width: 11,
                height: 11
            }));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-end',
                gap: 8,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $375f8776645d5aee$export$6897efa034860c56)
        }, t('visit.orders.urgency')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
            value: orderUrgency,
            onChange: (e)=>setOrderUrgency(e.target.value),
            "data-testid": "visit-order-urgency",
            style: {
                ...(0, $375f8776645d5aee$export$775ae08e7b0fd486),
                width: 120
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "routine"
        }, t('common.urgency.routine')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "urgent"
        }, t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "stat"
        }, t('common.urgency.stat')))), (orderDraftType === 'procedure' || Array.from(selectedOrderKeys).some((k)=>k.startsWith('procedure:'))) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $375f8776645d5aee$export$6897efa034860c56)
        }, t('visit.rx.sessions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "number",
            min: 1,
            value: orderSessions,
            onChange: (e)=>setOrderSessions(e.target.value),
            "data-testid": "visit-order-sessions",
            style: {
                ...(0, $375f8776645d5aee$export$d4e2cf4ef3f8061),
                width: 90
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                flex: 1,
                minWidth: 160
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $375f8776645d5aee$export$6897efa034860c56)
        }, t('visit.orders.noteOptional')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            value: orderNotes,
            onChange: (e)=>setOrderNotes(e.target.value),
            placeholder: t('visit.orders.clinicalNotePlaceholder'),
            "data-testid": "visit-order-notes",
            style: (0, $375f8776645d5aee$export$d4e2cf4ef3f8061)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            size: "sm",
            onClick: handleAddSelectedOrders,
            disabled: !canAdd,
            "data-testid": "visit-order-create",
            className: "gap-1.5 shrink-0"
        }, orderSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "#fff",
            thickness: 2
        }), " ", t('visit.orders.saving')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).plus, {
            width: 13,
            height: 13
        }), " ", selectedCount > 0 ? t('visit.orders.addWithCount', {
            count: selectedCount
        }) : t('visit.orders.add')))));
    })(), ordersLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$ab93a3750a1b92b6), {
        count: 3
    }) : clinicalOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).flask, {
            width: 40,
            height: 40
        }),
        title: t('visit.orders.noneRecorded'),
        description: t('visit.orders.emptyHint')
    })) : sortedClinicalOrders.map((order)=>{
        // Lab/imaging are fulfilled outside this visit (clinic accepts, or the
        // patient uploads a result) — the doctor never starts/completes them, so
        // "pending" reads as "awaiting fulfillment" and only cancel is offered.
        const isExternal = (0, $375f8776645d5aee$export$a4db75a9928d8ae7)(order.orderType);
        // Orders the current clinic performs are tagged and sorted to the top.
        const isClinic = isClinicOrder(order);
        const statusMap = {
            pending: {
                label: isExternal ? t('visit.orders.awaiting') : t('common.state.pending'),
                color: 'var(--warn-ink)',
                bg: 'var(--warn-soft)'
            },
            in_progress: {
                label: t('common.orderStatus.in_progress'),
                color: 'var(--accent-ink)',
                bg: 'var(--accent-soft)'
            },
            completed: {
                label: t('common.orderStatus.completed'),
                color: 'var(--good-ink)',
                bg: 'var(--good-soft)'
            },
            cancelled: {
                label: t('common.orderStatus.cancelled'),
                color: 'var(--mute)',
                bg: 'var(--line)'
            }
        };
        const st = statusMap[order.status] || statusMap.pending;
        const TypeIcon = (0, $375f8776645d5aee$export$9bb611d729802a56)[(0, $375f8776645d5aee$export$ba9a3a2cefb281d)[order.orderType]] || (0, $375f8776645d5aee$export$9bb611d729802a56).doc;
        const isTransitioning = orderTransitioning === order.id;
        const isOpen = order.status === 'pending' || order.status === 'in_progress';
        // انجام only for services the clinic has an active declaration for —
        // completing is what triggers billing, so undeclared orders (including
        // free-text) are fulfilled elsewhere and offer no doctor-side انجام.
        const canPerformHere = isOpen && !!order.catalogId && inHouseCatalogIds.has(order.catalogId);
        // Backend allows cancelling pending orders only.
        const canCancel = order.status === 'pending';
        return(// Two lines, like a نسخه row: the name, then its details — type, code,
        // urgency, where it stands with the insurer, the note — at a size
        // that reads, wrapping instead of being clipped (PM-0098).
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-order-card-${order.id}`,
            "data-clinic-order": isClinic || undefined,
            style: {
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 10px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 30,
                height: 30,
                borderRadius: 8,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            width: 15,
            height: 15
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 13,
                fontWeight: 700,
                color: 'var(--ink)',
                lineHeight: 1.5,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: '0 1 auto',
                minWidth: 0
            }
        }, chartOrderName(order)), isClinic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                fontWeight: 700,
                color: 'var(--accent-ink)',
                background: 'var(--accent-soft)',
                padding: '0 8px',
                borderRadius: 6,
                lineHeight: '20px',
                flexShrink: 0,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.thisClinic'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-order-details-${order.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 6,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                color: 'var(--ink)',
                background: 'var(--panel-2)'
            }
        }, (0, $375f8776645d5aee$export$e867161a6e6ed178)(t)[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                color: 'var(--ink-2)',
                background: 'var(--panel-2)'
            }
        }, order.orderType === 'procedure' ? 'CPT' : 'LOINC', " ", order.code), order.urgency === 'stat' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                fontWeight: 700,
                color: 'var(--danger-ink)',
                background: 'var(--danger-soft)'
            }
        }, "STAT"), order.urgency === 'urgent' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                fontWeight: 700,
                color: 'var(--warn-ink)',
                background: 'var(--warn-soft)'
            }
        }, t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$a8584f59cd36e423), {
            line: (0, $2c5a3cdef49d8209$export$be2f84bce07e3ba5)(order, erxIndex),
            testid: `visit-order-erx-state-${order.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$cbaf757fd313ab43), {
            drug: {
                id: order.id
            },
            size: 11.5,
            listed: (0, $375f8776645d5aee$export$467168533c33d9ca)(order, catalogResolved, patientInsurer),
            testid: `visit-order-coverage-${order.id}`,
            hint: t('visit.orders.outTaminHint')
        }), order.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: 12,
                color: 'var(--ink-2)',
                lineHeight: '22px',
                overflowWrap: 'anywhere',
                minWidth: 0
            }
        }, order.notes))), canPerformHere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>handleOrderDone(order),
            disabled: isTransitioning,
            "data-testid": `visit-order-done-${order.id}`,
            style: {
                color: 'var(--good-ink)'
            }
        }, isTransitioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : t('visit.orders.markDone')), canCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>setOrderToCancel(order),
            disabled: isTransitioning,
            "data-testid": `visit-order-cancel-${order.id}`,
            style: {
                color: 'var(--danger-ink)'
            }
        }, t('common.actions.discard')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                padding: '0 10px',
                lineHeight: '24px',
                borderRadius: 20,
                fontSize: 11.5,
                fontWeight: 700,
                background: st.bg,
                color: st.color,
                flexShrink: 0,
                whiteSpace: 'nowrap'
            }
        }, order.status === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).clock, {
            width: 11,
            height: 11
        }), order.status === 'completed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).check, {
            width: 11,
            height: 11
        }), st.label)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $960c956cfd0a23df$export$3e7bfa10fb8d8624), {
        lines: erxRemovedOrders,
        part: "SERVICES",
        testid: "visit-orders-erx-removed"
    }))), workTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0385119c9c941a3e$export$2e2bcd8739ae039), {
        className: "mt-3",
        appointmentId: pmEncounterId || visitId || null,
        patientId: patient?.id,
        doctorId: doctor?.id
    }), workTab === '__removed__' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, vitalsMode === 'saved' ? t('visit.vitals.thisVisit') : t('visit.vitals.record')), vitalsMode === 'saved' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setVitalsMode('form'),
        style: {
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--accent-ink)',
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            borderRadius: 7,
            padding: '4px 10px',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.edit'))), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: 8,
            padding: '10px 12px',
            background: vitalsAlert.level === 'critical' ? 'var(--danger-soft)' : 'var(--warn-soft)',
            border: `1.5px solid ${vitalsAlert.level === 'critical' ? 'oklch(0.82 0.09 25)' : 'oklch(0.85 0.06 55)'}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: 13,
            color: vitalsAlert.level === 'critical' ? 'var(--danger-ink)' : 'oklch(0.42 0.12 50)',
            marginBottom: 4
        }
    }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: 12.5,
                color: 'var(--ink)'
            }
        }, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setVitalsAlert(null),
        style: {
            marginTop: 6,
            fontSize: 11,
            background: 'none',
            border: 'none',
            color: 'var(--mute)',
            cursor: 'pointer',
            padding: 0,
            fontFamily: 'inherit'
        }
    }, t('common.actions.close'))), vitalsMode === 'saved' ? // ── Read-only saved view ──
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 10
        }
    }, (vitals.bpSys || vitals.bpDia) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1',
            background: 'var(--good-soft)',
            border: '1px solid oklch(0.88 0.07 145)',
            borderRadius: 10,
            padding: '10px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            fontWeight: 600,
            color: 'var(--mute-2)',
            marginBottom: 4,
            textTransform: 'uppercase',
            letterSpacing: '.04em'
        }
    }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 22,
            fontWeight: 700,
            color: 'var(--ink)',
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, vitals.bpSys || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 16,
            color: 'var(--mute)',
            fontWeight: 400,
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 22,
            fontWeight: 700,
            color: 'var(--ink)',
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, vitals.bpDia || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, "mmHg"))), [
        {
            key: 'pulse',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            key: 'spo2',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            key: 'temp',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg'
        }
    ].map(({ key: key, label: label, unit: unit })=>vitals[key] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                background: 'var(--good-soft)',
                border: '1px solid oklch(0.88 0.07 145)',
                borderRadius: 10,
                padding: '10px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 10,
                fontWeight: 600,
                color: 'var(--mute-2)',
                marginBottom: 4,
                textTransform: 'uppercase',
                letterSpacing: '.04em'
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 22,
                fontWeight: 700,
                color: 'var(--ink)',
                fontFamily: 'JetBrains Mono,monospace'
            }
        }, vitals[key]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                color: 'var(--mute)',
                fontWeight: 500
            }
        }, unit))) : null)) : // ── Editable form ──
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 10,
            padding: '10px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            fontWeight: 600,
            color: 'var(--mute-2)',
            marginBottom: 6,
            textTransform: 'uppercase',
            letterSpacing: '.04em'
        }
    }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "decimal",
        dir: "ltr",
        value: vitals.bpSys,
        onChange: (e)=>setVitals((v)=>({
                    ...v,
                    bpSys: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                })),
        placeholder: "120",
        style: {
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'inherit',
            background: 'transparent',
            color: 'var(--ink)',
            width: 0,
            textAlign: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 18,
            color: 'var(--mute)',
            fontWeight: 300,
            lineHeight: 1
        }
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "decimal",
        dir: "ltr",
        value: vitals.bpDia,
        onChange: (e)=>setVitals((v)=>({
                    ...v,
                    bpDia: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                })),
        placeholder: "80",
        style: {
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'inherit',
            background: 'transparent',
            color: 'var(--ink)',
            width: 0,
            textAlign: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, "mmHg"))), [
        {
            key: 'pulse',
            label: t('patient.vitals.hr'),
            unit: 'bpm',
            ph: '72'
        },
        {
            key: 'spo2',
            label: t('patient.vitals.spo2'),
            unit: '%',
            ph: '98'
        },
        {
            key: 'temp',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C",
            ph: '37'
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg',
            ph: ''
        }
    ].map(({ key: key, label: label, unit: unit, ph: ph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 10,
                padding: '10px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 10,
                fontWeight: 600,
                color: 'var(--mute-2)',
                marginBottom: 6,
                textTransform: 'uppercase',
                letterSpacing: '.04em'
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "text",
            inputMode: "decimal",
            dir: "ltr",
            value: vitals[key],
            onChange: (e)=>setVitals((v)=>({
                        ...v,
                        [key]: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                    })),
            placeholder: ph,
            style: {
                flex: 1,
                border: 'none',
                outline: 'none',
                fontSize: 20,
                fontWeight: 700,
                fontFamily: 'inherit',
                background: 'transparent',
                color: 'var(--ink)',
                width: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 11,
                color: 'var(--mute)',
                fontWeight: 500
            }
        }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: 8,
            padding: '8px 11px',
            background: 'var(--danger-soft)',
            border: '1.5px solid oklch(0.82 0.09 25)',
            marginTop: 10
        }
    }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: 12,
                color: 'var(--danger-ink)',
                fontWeight: 600
            }
        }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleSaveVitals,
        disabled: vitalsLoading,
        style: {
            height: 40,
            background: 'var(--ink)',
            color: '#faf7f4',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: vitalsLoading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit'
        }
    }, vitalsLoading ? '...' : t('visit.vitals.record'))), (()=>{
        const VITAL_META = {
            '8480-6': {
                label: 'BP sys',
                unit: 'mmHg',
                status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
            },
            '8462-4': {
                label: 'BP dia',
                unit: 'mmHg',
                status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
            },
            '8867-4': {
                label: t('visit.vitals.pulse'),
                unit: 'bpm',
                status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
            },
            '59408-5': {
                label: "SpO\u2082",
                unit: '%',
                status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
            },
            '8310-5': {
                label: t('patient.vitals.temp'),
                unit: "\xb0C",
                status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
            },
            '29463-7': {
                label: t('patient.vitals.wt'),
                unit: 'kg',
                status: ()=>'ok'
            }
        };
        const STATUS_COLOR = {
            ok: 'var(--good)',
            warn: 'var(--warn)',
            crit: 'var(--danger)'
        };
        const STATUS_BG = {
            ok: 'var(--good-soft)',
            warn: 'var(--warn-soft)',
            crit: 'var(--danger-soft)'
        };
        const vGroups = {};
        (patient?.clinicalObservations || []).forEach((obs)=>{
            const meta = VITAL_META[obs.code];
            if (!meta) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!vGroups[obs.code]) vGroups[obs.code] = {
                ...meta,
                code: obs.code,
                pts: []
            };
            vGroups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        const cards = Object.values(vGroups);
        if (!cards.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 'var(--radius-lg)',
                boxShadow: 'var(--shadow)',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 14px',
                borderBottom: '1px solid var(--line-2)',
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink)',
                background: 'var(--field)'
            }
        }, t('visit.vitals.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '12px',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 8
            }
        }, cards.map((m)=>{
            const sorted = [
                ...m.pts
            ].sort((a, b)=>new Date(a.date) - new Date(b.date));
            const last = sorted[sorted.length - 1];
            const prev = sorted[sorted.length - 2];
            const st = m.status(last.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$fed3aff69bf06eb1), {
                key: m.code,
                m: m,
                clr: STATUS_COLOR[st],
                bg: STATUS_BG[st],
                last: last,
                prev: prev,
                sorted: sorted
            });
        })));
    })())), erxAvailable && erxOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82f55e2793e90da1$export$2e2bcd8739ae039), {
        scope: erxScope,
        onClose: ()=>changeErxScope(null),
        overlay: workBodyWidth > 0 && workBodyWidth < (0, $82f55e2793e90da1$export$2aa65abd2a659822),
        notOffered: erxStatus?.enabled === false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccba15c4d511e83$export$2e2bcd8739ae039), {
        key: erxScope,
        scope: erxScope,
        flow: "panel",
        testIdPrefix: "visit-erx",
        appointmentId: pmEncounterId || visitId,
        patientId: patient.id,
        prepare: rxPersistence.writeNow,
        refreshKey: erxRefreshKey,
        onSubmitted: reloadErxStatus,
        onBusyChange: setErxBusy,
        describeLine: describeErxLine
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 2,
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: recordShown ? 'flex' : 'none',
            flexDirection: 'column',
            minHeight: 0,
            minWidth: 0,
            overflowY: 'auto'
        }
    }, recordShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--line)',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            background: 'var(--panel)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontWeight: 600,
            fontSize: 13,
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setContextExpanded((v)=>!v),
        title: contextExpanded ? t('visit.panel.collapse') : t('visit.panel.expand'),
        "aria-label": contextExpanded ? t('visit.panel.collapseRecord') : t('visit.panel.expandRecord'),
        "aria-pressed": contextExpanded,
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: contextExpanded ? 'var(--accent-soft)' : 'var(--panel-2)',
            color: contextExpanded ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, contextExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).back, {
        width: 14,
        height: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).arrow, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: 'var(--primary)',
            display: 'inline-block'
        }
    }), t('visit.patient.record')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
        compact: true,
        testid: "visit-record-complete",
        ...completion.button('record')
    }), !callHoldsRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>toggleRecordPanelOpen(false),
        "data-testid": "visit-record-fold",
        title: t('visit.panel.foldRecord'),
        "aria-label": t('visit.panel.foldRecord'),
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$9bb611d729802a56).x, {
        width: 13,
        height: 13
    })))), monitoringExtract.reviews.RECORD.open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)'
        }
    }, findingsCard('RECORD')), (()=>{
        const recordBlocks = {
            /* Allergies — collapsible like every section, but the header keeps the
              red identity and the count, so the safety signal survives collapse. */ allergy: p?.allergies?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "allergy",
                tone: "danger",
                title: t('visit.patient.allergyAlert'),
                count: p.allergies.length,
                gist: formatList(p.allergies),
                open: recordOpen.allergy,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    padding: '8px 10px',
                    background: 'var(--danger-soft)',
                    border: '1px solid oklch(0.85 0.08 25)',
                    borderRadius: 8,
                    marginBottom: 7
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 12,
                    color: 'var(--danger-ink)',
                    fontWeight: 600
                }
            }, t('visit.patient.allergyHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 5
                }
            }, p.allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: $9b4ee9e6346f75da$var$RECORD_CHIP_DANGER
                }, a)))),
            /* Demographics */ demo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "demo",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).users,
                title: t('visit.patient.details'),
                gist: [
                    p?.age ? t('visit.patient.years', {
                        count: p.age
                    }) : null,
                    p?.bloodType || null,
                    (0, $bf42e0131d395ab7$export$a69e980913efc937)[p?.insurance] ? t((0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance]) : p?.insurance || null
                ].filter(Boolean).join(" \xb7 "),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    icon: (0, $375f8776645d5aee$export$9bb611d729802a56).edit,
                    label: t('common.actions.edit'),
                    testid: "visit-demographics-edit",
                    onClick: ()=>{
                        setEditPatientError('');
                        setEditPatientForm({
                            name: p?.name || '',
                            phone: p?.phone || '',
                            nationalId: p?.nationalId || '',
                            birthDate: p?.birthDate || '',
                            bloodType: p?.bloodType || '',
                            job: p?.job || '',
                            insurance: p?.insurance || '',
                            height: p?.height != null ? String(p.height) : ''
                        });
                        setShowEditPatient(true);
                    }
                }),
                open: recordOpen.demo,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '7px 12px'
                }
            }, [
                {
                    k: t('common.labels.age'),
                    v: p?.age ? t('visit.patient.years', {
                        count: p.age
                    }) : "\u2014"
                },
                {
                    k: t('visit.patient.bloodType'),
                    v: p?.bloodType || "\u2014"
                },
                {
                    k: t('visit.patient.insurance'),
                    v: (0, $bf42e0131d395ab7$export$a69e980913efc937)[p?.insurance] ? t((0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance]) : p?.insurance || "\u2014"
                },
                {
                    k: 'BMI',
                    v: p?.bmi || "\u2014"
                }
            ].map(({ k: k, v: v })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 1
                    }
                }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: 13,
                        color: 'var(--ink)',
                        fontWeight: 500
                    }
                }, v))))),
            /* Vitals — inline editable */ vitals: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "vitals",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).trend,
                title: t('visit.vitals.title'),
                badge: vitalsAlert ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: 7,
                        height: 7,
                        borderRadius: '50%',
                        flexShrink: 0,
                        display: 'inline-block',
                        background: vitalsAlert.level === 'critical' ? 'var(--danger)' : 'oklch(0.62 0.15 55)'
                    }
                }) : null,
                gist: (()=>{
                    const parts = [
                        vitals.bpSys || vitals.bpDia ? `${vitals.bpSys || "\u2014"}/${vitals.bpDia || "\u2014"}` : null,
                        vitals.spo2 ? `${vitals.spo2}% SpO\u{2082}` : null,
                        vitals.pulse ? `${vitals.pulse} bpm` : null,
                        vitals.temp ? `${vitals.temp}\xb0C` : null
                    ].filter(Boolean);
                    return parts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        dir: "ltr"
                    }, parts.join(" \xb7 ")) : null;
                })(),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b8cec43441c5f15$export$5a0ca1724712239e), {
                    nested: true,
                    compact: true,
                    testid: "visit-vitals-complete",
                    ...completion.button('vitals'),
                    onClick: ()=>{
                        if (!recordOpen.vitals) toggleRecordSection('vitals');
                        completion.runSection('vitals');
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    label: t('common.actions.viewDetails'),
                    onClick: ()=>setShowVitalsModal(true),
                    testid: "record-vitals-details"
                })),
                open: recordOpen.vitals,
                onToggle: toggleRecordSection
            }, findingsCard('VITALS', {
                marginBottom: 10
            }), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    borderRadius: 8,
                    padding: '9px 11px',
                    background: vitalsAlert.level === 'critical' ? 'var(--danger-soft)' : 'var(--warn-soft)',
                    border: `1.5px solid ${vitalsAlert.level === 'critical' ? 'oklch(0.82 0.09 25)' : 'oklch(0.85 0.06 55)'}`,
                    marginBottom: 10
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontWeight: 700,
                    fontSize: 12,
                    color: vitalsAlert.level === 'critical' ? 'var(--danger-ink)' : 'oklch(0.42 0.12 50)',
                    marginBottom: 3
                }
            }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: 12,
                        color: 'var(--ink)'
                    }
                }, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setVitalsAlert(null),
                style: {
                    marginTop: 4,
                    fontSize: 10,
                    background: 'none',
                    border: 'none',
                    color: 'var(--mute)',
                    cursor: 'pointer',
                    padding: 0,
                    fontFamily: 'inherit'
                }
            }, t('common.actions.close'))), vitalsMode === 'saved' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 7,
                    marginBottom: 8
                }
            }, (vitals.bpSys || vitals.bpDia) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    background: 'var(--good-soft)',
                    border: '1px solid oklch(0.88 0.07 145)',
                    borderRadius: 'var(--radius)',
                    padding: '9px 11px'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                    marginBottom: 4
                }
            }, t('visit.vitals.bpUnit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 20,
                    fontWeight: 700,
                    color: 'var(--ink)',
                    fontFamily: 'JetBrains Mono,monospace',
                    lineHeight: 1
                }
            }, vitals.bpSys || "\u2014", "/", vitals.bpDia || "\u2014")), [
                {
                    key: 'spo2',
                    label: t('patient.vitals.spo2'),
                    unit: '%'
                },
                {
                    key: 'pulse',
                    label: t('patient.vitals.hr'),
                    unit: 'bpm'
                },
                {
                    key: 'temp',
                    label: t('patient.vitals.bodyTemp'),
                    unit: "\xb0C"
                },
                {
                    key: 'weight',
                    label: t('patient.vitals.wt'),
                    unit: 'kg'
                }
            ].map(({ key: key, label: label, unit: unit })=>vitals[key] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        background: 'var(--good-soft)',
                        border: '1px solid oklch(0.88 0.07 145)',
                        borderRadius: 'var(--radius)',
                        padding: '9px 11px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 4
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: 3
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: 20,
                        fontWeight: 700,
                        color: 'var(--ink)',
                        fontFamily: 'JetBrains Mono,monospace',
                        lineHeight: 1
                    }
                }, vitals[key]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: 9,
                        color: 'var(--mute)',
                        fontWeight: 500
                    }
                }, unit))) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setVitalsMode('form'),
                "data-testid": "record-vitals-edit",
                style: {
                    width: '100%',
                    padding: '6px',
                    borderRadius: 'var(--radius)',
                    background: 'none',
                    border: '1px solid var(--line)',
                    fontSize: 12,
                    fontWeight: 600,
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    fontFamily: 'inherit'
                }
            }, t('common.actions.edit'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 7,
                    marginBottom: 8
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    gridColumn: '1 / -1',
                    ...$9b4ee9e6346f75da$var$RECORD_CARD,
                    padding: '7px 10px'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                    marginBottom: 4
                }
            }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text",
                inputMode: "decimal",
                dir: "ltr",
                value: vitals.bpSys,
                onChange: (e)=>setVitals((v)=>({
                            ...v,
                            bpSys: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                        })),
                placeholder: "120",
                style: {
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    fontSize: 17,
                    fontWeight: 700,
                    fontFamily: 'inherit',
                    background: 'transparent',
                    color: 'var(--ink)',
                    width: 0,
                    textAlign: 'center'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 15,
                    color: 'var(--mute)',
                    fontWeight: 300,
                    lineHeight: 1
                }
            }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text",
                inputMode: "decimal",
                dir: "ltr",
                value: vitals.bpDia,
                onChange: (e)=>setVitals((v)=>({
                            ...v,
                            bpDia: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                        })),
                placeholder: "80",
                style: {
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    fontSize: 17,
                    fontWeight: 700,
                    fontFamily: 'inherit',
                    background: 'transparent',
                    color: 'var(--ink)',
                    width: 0,
                    textAlign: 'center'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 10,
                    color: 'var(--mute)',
                    fontWeight: 500
                }
            }, "mmHg"))), [
                {
                    key: 'pulse',
                    label: t('patient.vitals.hr'),
                    unit: 'bpm',
                    ph: '72'
                },
                {
                    key: 'spo2',
                    label: t('patient.vitals.spo2'),
                    unit: '%',
                    ph: '98'
                },
                {
                    key: 'temp',
                    label: t('patient.vitals.bodyTemp'),
                    unit: "\xb0C",
                    ph: '37'
                },
                {
                    key: 'weight',
                    label: t('patient.vitals.wt'),
                    unit: 'kg',
                    ph: ''
                }
            ].map(({ key: key, label: label, unit: unit, ph: ph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_CARD,
                        padding: '7px 10px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 4
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    type: "text",
                    inputMode: "decimal",
                    dir: "ltr",
                    value: vitals[key],
                    onChange: (e)=>setVitals((v)=>({
                                ...v,
                                [key]: (0, $375f8776645d5aee$export$8c63808338caf15c)(e.target.value)
                            })),
                    placeholder: ph,
                    style: {
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        fontSize: 17,
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        background: 'transparent',
                        color: 'var(--ink)',
                        width: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: 10,
                        color: 'var(--mute)',
                        fontWeight: 500
                    }
                }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    borderRadius: 8,
                    padding: '7px 10px',
                    background: 'var(--danger-soft)',
                    border: '1.5px solid oklch(0.82 0.09 25)',
                    marginBottom: 8
                }
            }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: 11.5,
                        color: 'var(--danger-ink)',
                        fontWeight: 600
                    }
                }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: handleSaveVitals,
                disabled: vitalsLoading,
                style: {
                    width: '100%',
                    height: 36,
                    background: 'var(--primary)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 'var(--radius)',
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: vitalsLoading ? 'not-allowed' : 'pointer',
                    fontFamily: 'inherit'
                }
            }, vitalsLoading ? '...' : t('visit.vitals.record')))),
            /* Active medications */ meds: (currentMeds.length + removedMedNames.size > 0 || undoMed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "meds",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
                title: t('patient.meds.current'),
                count: currentMeds.length,
                gist: formatList(currentMeds.slice(0, 3).map((m)=>m.display)),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, currentMeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b69acda6ae3622c4$export$2e2bcd8739ae039), {
                    meds: currentMeds,
                    title: t('visit.rx.represcribeFromCurrent'),
                    onApply: represcribeMeds,
                    prescribedNames: prescribedMedNames,
                    allergies: rxAllergens,
                    testid: "current-meds-represcribe"
                }), currentMeds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('meds'),
                    testid: "record-viewall-meds"
                })),
                open: recordOpen.meds,
                onToggle: toggleRecordSection
            }, undoMed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "med-undo-banner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "med-undo-text"
            }, t('visit.rx.stoppedNotAdded', {
                name: undoMed.display
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: "med-undo-btn",
                onClick: restoreMed
            }, t('visit.orders.undo'))), currentMeds.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds).map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$MedCard, {
                    key: (m.id || m.display) + '_' + i,
                    med: m,
                    onRemove: removeMed,
                    onReprescribe: represcribeMed,
                    represcribed: prescribedMedNames.has((m.display || '').trim().toLowerCase())
                })), currentMeds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('meds'),
                testid: "record-more-meds"
            }, "+ ", currentMeds.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds, " ", t('visit.rx.moreMedications'))),
            /* Active Diagnoses */ dx: (activeConds.length + removedCondIds.size > 0 || undoCond) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "dx",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).sparkle,
                title: t('patient.conditions.active'),
                count: activeConds.length,
                gist: formatList(activeConds.slice(0, 3).map((c)=>c.display)),
                actions: activeConds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('dx'),
                    testid: "record-viewall-dx"
                }) : null,
                open: recordOpen.dx,
                onToggle: toggleRecordSection
            }, undoCond && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "med-undo-banner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "med-undo-text"
            }, t('visit.dx.removedNamed', {
                name: undoCond.display
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: "med-undo-btn",
                onClick: restoreCondition
            }, t('visit.orders.undo'))), activeConds.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$CondCard, {
                    key: (c.id || c.display) + '_' + i,
                    cond: c,
                    onRemove: removeCondition,
                    onChangeType: changeCondType,
                    busy: diffTypeBusy
                })), activeConds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('dx'),
                testid: "record-more-dx"
            }, "+ ", activeConds.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx, " ", t('visit.dx.moreDiagnoses'))),
            /* Conditions */ conds: patientConditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "conds",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).notes,
                title: t('visit.patient.conditionHistory'),
                count: patientConditions.length,
                gist: formatList(patientConditions.slice(0, 3)),
                actions: patientConditions.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('conds'),
                    testid: "record-viewall-conds"
                }) : null,
                open: recordOpen.conds,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 5
                }
            }, patientConditions.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: $9b4ee9e6346f75da$var$RECORD_CHIP
                }, c)), patientConditions.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setRecordSheet('conds'),
                "data-testid": "record-more-conds",
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_CHIP,
                    background: 'none',
                    border: '1px dashed var(--line)',
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    fontWeight: 600
                }
            }, "+", patientConditions.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds))),
            /* ── Lab results ── */ labs: labObsAll.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "labs",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).flask,
                title: t('visit.patient.labResults'),
                count: labObsAll.length,
                badge: labCriticalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: 10,
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'var(--danger)',
                        color: '#fff',
                        flexShrink: 0
                    }
                }, t('visit.recordPanel.criticalCount', {
                    count: labCriticalCount
                })) : labAbnormalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: 10,
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'oklch(0.88 0.08 55)',
                        color: 'oklch(0.42 0.14 55)',
                        flexShrink: 0
                    }
                }, t('visit.recordPanel.abnormalCount', {
                    count: labAbnormalCount
                })) : null,
                gist: formatList(labObsAll.slice(0, 3).map((o)=>o.display)),
                actions: labObsAll.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('labs'),
                    testid: "record-viewall-labs"
                }) : null,
                open: recordOpen.labs,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                }
            }, labObsAll.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs).map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
                    key: (obs.id || '') + '_' + i,
                    obs: obs,
                    isLast: i === arr.length - 1
                }))), labObsAll.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('labs'),
                testid: "record-more-labs"
            }, "+ ", labObsAll.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs, " ", t('patient.obs.result'))),
            /* ── مدارک بیمار — every document of the patient, this visit's first ── */ files: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "files",
                icon: (0, $824b163d7442530e$export$2e2bcd8739ae039),
                title: t('visit.patient.files'),
                count: visitFiles.all.length,
                badge: visitFiles.newCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "data-testid": "record-files-new",
                    style: {
                        fontSize: 10,
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'var(--accent-soft)',
                        color: 'var(--accent-ink)',
                        flexShrink: 0
                    }
                }, t('visit.files.newCount', {
                    count: visitFiles.newCount
                })) : null,
                gist: formatList([
                    ...new Set(visitFiles.ordered.slice(0, 3).map((f)=>(0, $157d5bd48cfffbad$export$d2ebff77a9864278)(f.kind)).filter(Boolean))
                ].map((k)=>t(k))),
                /* «افزودن فایل» lives HERE and nowhere else in the rail (PM-0036):
                 adding a document is an act on this section, and two buttons for
                 one act read as two different things. «مشاهدهٔ همه» shows whenever
                 there is a file, as on the other list sections of the glance —
                 the sheet is also where the kind filter lives. */ actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    icon: (0, $375f8776645d5aee$export$9bb611d729802a56).plus,
                    label: t('visit.patient.addFile'),
                    onClick: ()=>clinicalFiles.openUpload(),
                    testid: "record-files-add"
                }), visitFiles.all.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>{
                        setFileKindFilter(null);
                        setRecordSheet('files');
                    },
                    testid: "record-viewall-files"
                })),
                open: recordOpen.files !== false,
                onToggle: toggleRecordSection
            }, visitFiles.all.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "record-files-empty",
                "data-state": "empty",
                style: $9b4ee9e6346f75da$var$RECORD_EMPTY
            }, t('patient.files.empty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "record-files",
                "data-state": "content"
            }, renderVisitFileList(visitFiles.ordered.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.files)), visitFiles.all.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.files && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>{
                    setFileKindFilter(null);
                    setRecordSheet('files');
                },
                testid: "record-more-files"
            }, "+ ", visitFiles.all.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.files, " ", t('patient.files.file')))),
            /* ── سوابق ویزیت‌های قبلی ── */ /* Preview only: three rows, each already carrying diagnoses and the
              drug/order counts. Full detail opens in the sheet, never in place —
              this column is the app's longest scroll already. */ history: (railVisits.length > 0 || pastVisitSummaries === null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "history",
                icon: (0, $375f8776645d5aee$export$9bb611d729802a56).history,
                title: t('visit.history.title'),
                count: pastVisits.length,
                gist: railVisits[0]?.scheduledDate ? formatRelativeTime(railVisits[0].scheduledDate) : null,
                actions: pastVisits.length > railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>{
                        setExpandedEncId(null);
                        setHistoryOpen(true);
                    },
                    testid: "visit-history-view-all"
                }) : null,
                open: recordOpen.history,
                onToggle: toggleRecordSection
            }, pastVisitSummaries === null && !railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e131569ade80e0$export$562f3f75696de122), {
                count: 3
            }) : railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                "data-testid": "visit-history-rail"
            }, railVisits.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitHistoryRow, {
                    key: v.id,
                    visit: v,
                    ctx: visitCtx[v.id],
                    summary: summaryMap.get(String(v.id)),
                    onOpen: (id)=>{
                        setExpandedEncId(id);
                        loadVisitContext(id);
                        setHistoryOpen(true);
                    },
                    onReprescribe: represcribeMeds,
                    onCorrect: canCorrectVisit(v) ? ()=>openRxCorrection(v) : null,
                    prescribedNames: prescribedMedNames,
                    allergies: rxAllergens
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: $9b4ee9e6346f75da$var$RECORD_EMPTY
            }, t('visit.history.empty')))
        };
        return (0, $792124e2f7de719a$export$e111fe7e8e6c2d5d)(visitLayout).map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: id
            }, recordBlocks[id]));
    })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $013436dd88cfa3ff$export$2e2bcd8739ae039), {
        call: call,
        patientName: p?.name,
        dock: "bottom"
    })))), historyOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitHistorySheet, {
        visits: pastVisits,
        ctxById: visitCtx,
        summaryMap: summaryMap,
        expandedId: expandedEncId,
        onExpand: (id)=>{
            setExpandedEncId(id);
            if (id) loadVisitContext(id);
        },
        onClose: ()=>setHistoryOpen(false),
        onReprescribe: represcribeMed,
        onReprescribeMany: represcribeMeds,
        onLoadContext: loadVisitContext,
        prescribedNames: prescribedMedNames,
        allergies: rxAllergens,
        canCorrect: canCorrectVisit,
        onCorrect: openRxCorrection
    }), rxCorrectionVisit && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $49c99466dee6cafa$export$2e2bcd8739ae039), {
        key: rxCorrectionVisit.id,
        visit: rxCorrectionVisit,
        patientId: patient.id,
        insurer: patientInsurer,
        onClose: closeRxCorrection
    }), glanceOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$PatientGlanceModal, {
        patient: p,
        conditions: patientConditions,
        activeConds: activeConds,
        visits: railVisits,
        ctxById: visitCtx,
        currentMeds: currentMeds,
        abnormalLabs: labObsAll.filter((o)=>o.status === 'CRITICAL' || o.status === 'ABNORMAL'),
        vitalsAlert: vitalsAlert,
        hasMoreVisits: pastVisits.length > 0,
        onOpenHistory: ()=>{
            setGlanceOpen(false);
            setExpandedEncId(null);
            setHistoryOpen(true);
        },
        onViewAllMeds: ()=>{
            setGlanceOpen(false);
            setRecordSheet('meds');
        },
        onViewAllDx: ()=>{
            setGlanceOpen(false);
            setRecordSheet('dx');
        },
        onClose: ()=>setGlanceOpen(false)
    }), recordSheet === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).pill,
        title: t('patient.meds.current'),
        count: currentMeds.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-meds"
    }, currentMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$MedCard, {
            key: (m.id || m.display) + '_' + i,
            med: m,
            onRemove: removeMed,
            onReprescribe: represcribeMed,
            represcribed: prescribedMedNames.has((m.display || '').trim().toLowerCase())
        }))), recordSheet === 'dx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).sparkle,
        title: t('patient.conditions.active'),
        count: activeConds.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-dx"
    }, activeConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$CondCard, {
            key: (c.id || c.display) + '_' + i,
            cond: c,
            onRemove: removeCondition,
            onChangeType: changeCondType,
            busy: diffTypeBusy
        }))), recordSheet === 'conds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).notes,
        title: t('visit.patient.conditionHistory'),
        count: patientConditions.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-conds"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, patientConditions.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: $9b4ee9e6346f75da$var$RECORD_CHIP
        }, c)))), recordSheet === 'labs' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $375f8776645d5aee$export$9bb611d729802a56).flask,
        title: t('visit.patient.labResults'),
        count: labObsAll.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-labs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }
    }, labObsAll.map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
            key: (obs.id || '') + '_' + i,
            obs: obs,
            isLast: i === arr.length - 1
        })))), recordSheet === 'files' && (()=>{
        const kinds = [
            ...new Set(visitFiles.all.map((f)=>(0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(f.kind)).filter(Boolean))
        ];
        const shown = fileKindFilter ? visitFiles.ordered.filter((f)=>(0, $157d5bd48cfffbad$export$ffe1b0e1a3bc5981)(f.kind) === fileKindFilter) : visitFiles.ordered;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
            icon: (0, $824b163d7442530e$export$2e2bcd8739ae039),
            title: t('visit.patient.files'),
            count: visitFiles.all.length,
            onClose: ()=>setRecordSheet(null),
            testid: "record-sheet-files"
        }, kinds.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "record-files-kinds",
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 6,
                marginBottom: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            label: t('common.state.all'),
            active: !fileKindFilter,
            onClick: ()=>setFileKindFilter(null)
        }), kinds.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
                key: k,
                label: t((0, $157d5bd48cfffbad$export$e9b52c65a7ff27b6)[k]),
                active: fileKindFilter === k,
                onClick: ()=>setFileKindFilter(k),
                "data-testid": `record-files-kind-${k}`
            }))), renderVisitFileList(shown, true));
    })(), clinicalFiles.overlays, patient?.id && true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a32a09d8f6c45ba$export$2e2bcd8739ae039), {
        patientId: patient.id,
        onChange: refreshPatient
    }), showVitalsModal && (()=>{
        const VITAL_META = {
            '8480-6': {
                label: 'BP sys',
                unit: 'mmHg',
                status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
            },
            '8462-4': {
                label: 'BP dia',
                unit: 'mmHg',
                status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
            },
            '8867-4': {
                label: t('visit.vitals.pulse'),
                unit: 'bpm',
                status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
            },
            '59408-5': {
                label: "SpO\u2082",
                unit: '%',
                status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
            },
            '8310-5': {
                label: t('patient.vitals.temp'),
                unit: "\xb0C",
                status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
            },
            '29463-7': {
                label: t('patient.vitals.wt'),
                unit: 'kg',
                status: ()=>'ok'
            }
        };
        const STATUS_COLOR = {
            ok: 'var(--good)',
            warn: 'var(--warn)',
            crit: 'var(--danger)'
        };
        const STATUS_BG = {
            ok: 'var(--good-soft)',
            warn: 'var(--warn-soft)',
            crit: 'var(--danger-soft)'
        };
        const vGroups = {};
        (patient?.clinicalObservations || []).forEach((obs)=>{
            const meta = VITAL_META[obs.code];
            if (!meta) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!vGroups[obs.code]) vGroups[obs.code] = {
                ...meta,
                code: obs.code,
                pts: []
            };
            vGroups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        const cards = Object.values(vGroups);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'fixed',
                inset: 0,
                zIndex: 1100,
                background: 'rgba(28,27,24,.55)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20
            },
            onClick: (e)=>e.target === e.currentTarget && setShowVitalsModal(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: 'var(--panel)',
                borderRadius: 16,
                width: '100%',
                maxWidth: 680,
                maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '16px 20px',
                borderBottom: '1px solid var(--line)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 15,
                fontWeight: 700,
                color: 'var(--ink)'
            }
        }, t('visit.vitals.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>setShowVitalsModal(false),
            style: {
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: 20,
                color: 'var(--mute)',
                lineHeight: 1
            }
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                overflowY: 'auto',
                padding: '16px 20px'
            }
        }, cards.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'center',
                color: 'var(--mute)',
                fontSize: 13,
                padding: '32px 0'
            }
        }, t('visit.patient.noHistory')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 10
            }
        }, cards.map((m)=>{
            const sorted = [
                ...m.pts
            ].sort((a, b)=>new Date(a.date) - new Date(b.date));
            const last = sorted[sorted.length - 1];
            const prev = sorted[sorted.length - 2];
            const st = m.status(last.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $375f8776645d5aee$export$fed3aff69bf06eb1), {
                key: m.code,
                m: m,
                clr: STATUS_COLOR[st],
                bg: STATUS_BG[st],
                last: last,
                prev: prev,
                sorted: sorted
            });
        })))));
    })(), showEditPatient && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (o)=>{
            if (!o) setShowEditPatient(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('visit.patient.edit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: editPatientForm.name || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    name: e.target.value
                })),
        placeholder: t('visit.patient.fullName')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: editPatientForm.phone || '',
        onChange: (phone)=>setEditPatientForm((f)=>({
                    ...f,
                    phone: phone
                }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: editPatientForm.nationalId || '',
        allowOtherCountries: true,
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    nationalId: e.target.value
                })),
        onCountryChange: (c)=>setEditPatientForm((f)=>({
                    ...f,
                    nationalIdCountry: c
                })),
        "data-testid": "visit-edit-patient-nid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('common.labels.birthDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: editPatientForm.birthDate || '',
        onChange: (v)=>setEditPatientForm((f)=>({
                    ...f,
                    birthDate: v
                })),
        height: 40,
        placeholder: t('visit.patient.birthDatePlaceholder'),
        disableFuture: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: editPatientForm.job || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    job: e.target.value
                })),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        type: "number",
        dir: "ltr",
        value: editPatientForm.height || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    height: e.target.value
                })),
        placeholder: "175"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: editPatientForm.bloodType || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    bloodType: e.target.value
                })),
        placeholder: t('common.actions.select'),
        options: [
            'A+',
            'A-',
            'B+',
            'B-',
            'AB+',
            'AB-',
            'O+',
            'O-'
        ].map((bt)=>({
                value: bt,
                label: bt
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: editPatientForm.insurance || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    insurance: e.target.value
                })),
        placeholder: t('common.actions.select'),
        options: [
            {
                value: 'social',
                label: t('patient.insurance.social')
            },
            {
                value: 'health',
                label: t('patient.insurance.health')
            },
            {
                value: 'military',
                label: t('patient.insurance.military')
            },
            {
                value: 'other',
                label: t('patient.insurance.other')
            }
        ]
    }), editPatientError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: 'var(--danger-ink)',
            fontWeight: 600
        }
    }, editPatientError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbdF9.default), {
        onCancel: ()=>setShowEditPatient(false),
        cancelLabel: t('common.actions.cancel'),
        saveLabel: editPatientSaving ? t('common.state.saving') : t('common.actions.save'),
        onSave: async ()=>{
            if (editPatientSaving) return;
            // A changed code must pass its country's rule; an unchanged one is
            // the record's and is not re-judged here.
            if (editPatientForm.nationalId !== (p?.nationalId || '') && (0, $3tGMU).nationalIdProblem(editPatientForm.nationalId, {
                country: editPatientForm.nationalIdCountry
            })) {
                setEditPatientError(t('validation.nationalId'));
                return;
            }
            setEditPatientSaving(true);
            setEditPatientError('');
            try {
                const u = {};
                if (editPatientForm.name !== (p?.name || '')) u.name = editPatientForm.name;
                if (editPatientForm.phone !== (p?.phone || '')) u.phone = editPatientForm.phone;
                if (editPatientForm.nationalId !== (p?.nationalId || '')) u.nationalId = editPatientForm.nationalId;
                if (editPatientForm.birthDate !== (p?.birthDate || '')) u.birthDate = editPatientForm.birthDate;
                if (editPatientForm.bloodType !== (p?.bloodType || '')) u.bloodType = editPatientForm.bloodType;
                if (editPatientForm.job !== (p?.job || '')) u.job = editPatientForm.job;
                if (editPatientForm.insurance !== (p?.insurance || '')) u.insurance = editPatientForm.insurance;
                const nh = parseFloat(editPatientForm.height);
                if (!Number.isNaN(nh) && nh !== p?.height) u.height = nh;
                if (Object.keys(u).length) {
                    await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $375f8776645d5aee$export$f6cdc6e4a4a3c80a), {
                        id: p.id,
                        input: u
                    });
                    await refreshPatient();
                }
                setShowEditPatient(false);
            } catch (e) {
                setEditPatientError(e?.message || t('errors.save.patientEdit'));
            } finally{
                setEditPatientSaving(false);
            }
        }
    })))), endProgress.running && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d5a7a965cfe42c6$export$2e2bcd8739ae039), {
        steps: endProgress.steps
    }), activeVisitConflict && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 200,
            background: 'rgba(20,20,20,.6)',
            backdropFilter: 'blur(5px)',
            display: 'grid',
            placeItems: 'center',
            padding: 20,
            animation: 'fadeIn .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: 'var(--panel-2)',
            borderRadius: 20,
            padding: '32px 28px',
            border: '1px solid var(--line)',
            boxShadow: 'var(--shadow-pop)',
            width: '100%',
            maxWidth: 400,
            textAlign: 'start',
            animation: 'fadeUp .2s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'rgba(245,158,11,.12)',
            border: '1.5px solid rgba(245,158,11,.35)',
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#f59e0b",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "12",
        y1: "9",
        x2: "12",
        y2: "13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: 8,
            fontSize: 16,
            fontWeight: 700,
            color: 'var(--text)'
        }
    }, t('visit.resume.activeTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: 28,
            fontSize: 13,
            color: 'var(--mute)',
            lineHeight: 1.8
        }
    }, t('visit.resume.activeShort'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("br", null), t('visit.resume.activeChoice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleResumeConflictVisit,
        style: {
            width: '100%',
            padding: '12px 0',
            borderRadius: 12,
            background: 'var(--accent)',
            border: 'none',
            color: '#fff',
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "5 3 19 12 5 21 5 3"
    })), t('visit.resume.continuePrevious')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleCloseConflictVisit,
        style: {
            width: '100%',
            padding: '12px 0',
            borderRadius: 12,
            background: 'rgba(239,68,68,.08)',
            border: '1px solid rgba(239,68,68,.25)',
            color: '#ef4444',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "9",
        y1: "9",
        x2: "15",
        y2: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "15",
        y1: "9",
        x2: "9",
        y2: "15"
    })), t('visit.resume.closeAndStart')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setActiveVisitConflict(null),
        style: {
            width: '100%',
            padding: '9px 0',
            borderRadius: 10,
            background: 'transparent',
            border: 'none',
            color: 'var(--mute)',
            fontSize: 13,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.cancel'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4314c1a6ed955567$export$2e2bcd8739ae039), {
        error: recError,
        onRetry: startRec,
        onClose: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54b8ecca4695c6ef$export$2e2bcd8739ae039), {
        open: pendingEnd,
        onOpenChange: setPendingEnd,
        patientName: patient?.name,
        recording: isRecording,
        onConfirm: runEnd
    }), showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c82e14f46c6e08fd$export$2e2bcd8739ae039), {
        patient: patient,
        doctor: doctor,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        acceptedDifferential: (differential || []).filter((0, $375f8776645d5aee$export$d20c1dcfc45ad42b)),
        prescriptionTemplates: prescriptionTemplates,
        appointmentId: visitId,
        saveFailures: saveFailures,
        failedGroups: failedGroups,
        retrying: retrying,
        onRetryFailed: retryFailed,
        endedAt: endedAt,
        durationMin: durationMin,
        coins: {
            entries: coinLedger,
            total: visitCoins
        },
        onExit: goToReception,
        onViewRecord: ()=>navProp('patient-detail', {
                id: patient?.id
            })
    }));
}


function $5847361e5dafb1ed$export$2e2bcd8739ae039({ patient: patient, mobile: mobile }) {
    const navigate = (0, $aa19facd75e3670a$export$5b61ff3425c1c197)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const phone = typeof mobile === 'boolean' ? mobile : isMobile;
    if (!patient?.id) return null;
    return phone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e1fb04c8016deb8f$export$2e2bcd8739ae039), {
        navigate: navigate,
        patient: patient
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b4ee9e6346f75da$export$2e2bcd8739ae039), {
        navigate: navigate,
        patient: patient
    });
}



var $acw62 = parcelRequire("acw62");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The mobile record's loading shape — the SECTION body only. The MobileHeader
// band, the overlapping stat tiles (`MobileStatTiles loading`), the allergy
// strip and the section nav all render for real above it, so the phone keeps
// its chrome through the wait. Per section, like the desktop pane: overview
// cards, an analysis chart, observation tiles, visit rows, file cards.
// ─────────────────────────────────────────────────────────────────────────────
const $64a1fb07b6844f34$var$MobileSectionCard = ({ lines: lines = 2, title: title = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 110,
        height: 13
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "72%"
    }));
const $64a1fb07b6844f34$var$MobileVisitRow = ({ i: i })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 40,
        height: 40,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${50 + i * 13 % 28}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${30 + i * 9 % 20}%`,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 56,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    }));
const $64a1fb07b6844f34$var$MobileFileCard = ({ i: i })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 44,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${44 + i * 17 % 30}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${26 + i * 11 % 22}%`,
        height: 11
    })));
function $64a1fb07b6844f34$export$2e2bcd8739ae039({ tab: tab = 'overview', label: label }) {
    const { t: t } = (0, $LNQP4.default)();
    const lbl = label ?? t('common.state.loading');
    let body;
    switch(tab){
        case 'analysis':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
                height: 160,
                line: true,
                legend: 2,
                label: lbl
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 3
            }));
            break;
        case 'labs':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: '0.625rem'
                }
            }, Array.from({
                length: 4
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                    key: i,
                    "aria-hidden": true,
                    style: {
                        padding: '0.75rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                    width: 64,
                    height: 11
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                    width: 52,
                    height: 18
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 2
            }));
            break;
        case 'visits':
            body = [
                0,
                1,
                2,
                3
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileVisitRow, {
                    key: i,
                    i: i
                }));
            break;
        case 'files':
            body = [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileFileCard, {
                    key: i,
                    i: i
                }));
            break;
        default:
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
                size: 40
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                width: "55%",
                height: 13
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                width: "35%",
                height: 11
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 3
            }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: lbl,
        "data-testid": `patient-section-skeleton-${tab}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, body);
}







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $1HT9m = parcelRequire("1HT9m");

// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a doctor is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • every size/weight comes from `type` (constants/typography); no literal
//     fontSize, because a page that invents its own is a page that stops
//     matching the app the first time the scale moves,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $fc04608d7d7444fa$var$TONES = {
    neutral: ()=>({
            fg: (0, $jTCZr.C).textMuted,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $jTCZr.C).navy,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight
        }),
    danger: ()=>({
            fg: (0, $jTCZr.C).red,
            bg: (0, $jTCZr.C).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $fc04608d7d7444fa$var$DISC = 56;
function $fc04608d7d7444fa$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($fc04608d7d7444fa$var$TONES[tone] || $fc04608d7d7444fa$var$TONES.neutral)();
    // ── The phone is not a narrow desktop (spec §B.5, J-15) ───────────────────
    // These pages were the last surface in the app with no mobile geometry at
    // all: a 460px card, centred, with 2rem of padding around it — which on a
    // 320px screen is a card wider than the window inside a page that then
    // scrolls sideways, and on any phone is a lot of empty chrome around one
    // sentence. They are also the pages a doctor is MOST likely to meet on a
    // phone, because a bad link arrives in a message.
    //
    // On a phone the card stops being a card: it fills the width, drops its
    // border and shadow (there is nothing to float above), and the actions stack
    // full-width so each is a real target rather than two half-width buttons on
    // a 320px row.
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // doctor was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: '100%',
            // `100dvh`, not `100vh`: `vh` is the LARGEST viewport, so a fullscreen
            // system page on iOS Safari ran under the address bar — and the part
            // that went missing was its action buttons (§3.4 Z3, §H.1).
            height: fullscreen ? '100dvh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: isMobile ? '1.5rem 0.875rem' : '2rem 1.25rem',
            background: (0, $jTCZr.C).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: isMobile ? 'none' : `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: isMobile ? 0 : (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
            padding: isMobile ? '2rem 1.25rem 1.5rem' : '2.5rem 2rem 2rem',
            maxWidth: isMobile ? '100%' : '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: isMobile ? 'none' : (0, $56f50ba2a6b5ae3c$export$98b6069deb71e13e).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...(0, $1HT9m.type).hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $fc04608d7d7444fa$var$DISC,
            height: $fc04608d7d7444fa$var$DISC,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).body,
            fontWeight: 500,
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.85,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            // Stacked on a phone whatever the count: two half-width buttons on
            // a 320px row are two targets that are each too small.
            flexDirection: isMobile || actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fc04608d7d7444fa$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the doctor decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $fc04608d7d7444fa$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $fc04608d7d7444fa$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $fc04608d7d7444fa$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}



parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $4f09c2fbf6e97540$export$1c8a31b6c319fadd({ titleKey: titleKey, bodyKey: bodyKey, detail: detail, onBack: onBack }) {
    const { t: t } = (0, $LNQP4.default)();
    const navigate = (0, $aa19facd75e3670a$export$5b61ff3425c1c197)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
        testId: "record-not-found",
        tone: "neutral",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c17edf56d0b04896$export$2e2bcd8739ae039), {
            size: 28,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t(titleKey || 'errors.routes.recordNotFoundTitle'),
        body: t(bodyKey || 'errors.routes.recordNotFoundBody'),
        detail: detail,
        actions: [
            ...onBack ? [
                {
                    key: 'back',
                    label: t('common.actions.back'),
                    onClick: onBack
                }
            ] : [],
            {
                key: 'reception',
                label: t('errors.routes.goReception'),
                onClick: ()=>navigate('reception'),
                variant: onBack ? 'secondary' : 'primary'
            }
        ]
    });
}
var $4f09c2fbf6e97540$export$2e2bcd8739ae039 = $4f09c2fbf6e97540$export$1c8a31b6c319fadd;





parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $aRAFQ = parcelRequire("aRAFQ");
var $fX0JO = parcelRequire("fX0JO");
const $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0 = (t)=>[
        {
            id: 'overview',
            label: t('patient.tabs.overview'),
            Icon: (0, $k2reB.default)
        },
        // «تحلیل» — the record's measurements, prescriptions and events on one time
        // axis. Sits beside «خلاصه» on both surfaces: summary is what changed, the
        // analysis is how it moved.
        {
            id: 'analysis',
            label: t('patient.tabs.analysis'),
            Icon: (0, $aRAFQ.default)
        },
        // «مشاهدات» — vitals + laboratory analytes. The route segment stays `labs`
        // so existing links and bookmarks keep resolving.
        {
            id: 'labs',
            label: t('patient.tabs.observations'),
            Icon: (0, $4CVxl.default)
        },
        {
            id: 'visits',
            label: t('patient.tabs.visits'),
            Icon: (0, $fX0JO.default)
        },
        {
            id: 'files',
            label: t('patient.tabs.files'),
            Icon: (0, $8jE1c.default)
        }
    ];
const $d1e2b5d6e06e4f47$var$MobilePatientNav = ({ active: active, onChange: onChange })=>{
    const { t: t } = (0, $LNQP4.default)();
    // Keep the selected tab in view: five tabs fit most phones, but on a narrow
    // viewport the strip still scrolls, so centre the selected one.
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        activeRef.current?.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-nav",
        role: "tablist",
        "aria-label": t('patient.tabs.sectionsLabel'),
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0,
            overflowX: 'auto',
            display: 'flex',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        }
    }, $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0(t).map(({ id: id, label: label, Icon: Icon })=>{
        const on = active === id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `patient-nav-${id}`,
            onClick: ()=>onChange(id),
            className: "h-auto min-h-11 flex-col gap-0.5 rounded-none px-3.5 py-2 shrink-0 hover:bg-transparent",
            style: {
                color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $jTCZr.C).navy}` : '2.5px solid transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 16,
            strokeWidth: on ? 2.4 : 2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
};
var $d1e2b5d6e06e4f47$export$2e2bcd8739ae039 = $d1e2b5d6e06e4f47$var$MobilePatientNav;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $3Amwd = parcelRequire("3Amwd");
var $6usBW = parcelRequire("6usBW");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");



var $jTCZr = parcelRequire("jTCZr");



// Overview — «خلاصه», the record's landing section.
//
// This is the phone rendering of the DESKTOP overview (PatientDetail/web/tabs/
// OverviewTab.jsx), which is the source of truth for what the section contains:
// the last-visit AI summary, active medications (prescribe + delete), active
// diagnoses, allergies, abnormal labs and the vitals glance — in that order.
// The phone stacks what the desktop lays out as main + rail; the derivations
// below are the same ones, so the two surfaces can never disagree.
//
// The mobile-only «رویدادهای بالینی» milestone timeline and «یادداشت‌های اخیر»
// block were removed: neither exists on the desktop record, and notes are read
// in the visit they belong to («تاریخچه مراجعات»).
const $d983d5badec2112a$var$LIST_DOCTOR_ORDERS_VISITS = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate}}`;
const $d983d5badec2112a$var$DELETE_MEDICATION = `mutation DeleteMedication($id: ID!) { deleteMedication(id: $id) }`;
// Same vital LOINC set + labels the desktop overview glances at (web/constants →
// OV_VITAL_DEF). Kept in the same order so both surfaces read alike.
const $d983d5badec2112a$var$OV_VITAL_DEF = (t)=>[
        {
            code: '55284-4',
            label: t('patient.vitals.bp'),
            unit: 'mmHg'
        },
        {
            code: '8867-4',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            code: '59408-5',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            code: '8310-5',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        }
    ];
const $d983d5badec2112a$var$ENCOUNTER_TYPE = (t)=>({
        ambulatory: t('patient.encType.outpatient'),
        emergency: t('common.urgency.emergency'),
        inpatient: t('patient.encType.inpatient'),
        observation: t('patient.obs.view')
    });
const $d983d5badec2112a$var$OV_SEVERITY = (t)=>({
        severe: {
            l: t('visit.severity.high'),
            tone: 'high'
        },
        moderate: {
            l: t('credits.level.midShort'),
            tone: 'mid'
        },
        mild: {
            l: t('visit.severity.low'),
            tone: 'mid'
        }
    });
// ── Card chrome ──────────────────────────────────────────────────────────────
const $d983d5badec2112a$var$Card = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: '0.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden',
            ...style
        }
    }, children);
const $d983d5badec2112a$var$CardHead = ({ Icon: Icon, title: title, count: count, action: action, danger: danger })=>{
    const { formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.6875rem 0.875rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.625rem',
            height: '1.625rem',
            borderRadius: '0.5rem',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: danger ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).accentSoft,
            color: danger ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), count != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem'
        }
    }, formatDigits(count)), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto'
        }
    }, action));
};
const $d983d5badec2112a$var$LinkButton = ({ onClick: onClick, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onClick,
        "data-testid": testId,
        className: "min-h-11 px-1 font-bold",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, children);
const $d983d5badec2112a$var$CardEmpty = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem',
            textAlign: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, children);
const $d983d5badec2112a$var$MobilePatientOverview = ({ p: p, patientId: patientId, onRefresh: onRefresh, setTab: setTab })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const pid = patientId || p.id;
    // Doctor orders back the last-visit "what was done" list, exactly as on desktop.
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!pid) return;
        setOrders(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($d983d5badec2112a$var$LIST_DOCTOR_ORDERS_VISITS, {
            patientId: pid
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch(()=>setOrders([]));
    }, [
        pid
    ]);
    // ── Derived data (mirrors web/tabs/OverviewTab.jsx) ────────────────────────
    const conditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalConditions || []).filter((c)=>{
            if (seen.has(c.id)) return false;
            seen.add(c.id);
            return true;
        });
    }, [
        p.clinicalConditions
    ]);
    const activeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>conditions.filter((c)=>c.clinicalStatus === 'active'), [
        conditions
    ]);
    const medications = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalMedications || []).filter((m)=>{
            if (seen.has(m.id)) return false;
            seen.add(m.id);
            return true;
        });
    }, [
        p.clinicalMedications
    ]);
    const activeMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const byCode = {};
        medications.filter((m)=>m.status === 'active' || m.status === 'on-hold').forEach((m)=>{
            const key = m.code || m.display;
            if (!byCode[key] || (m.authoredOn || '') > (byCode[key].authoredOn || '')) byCode[key] = m;
        });
        return Object.values(byCode).sort((a, b)=>(b.authoredOn || '').localeCompare(a.authoredOn || ''));
    }, [
        medications
    ]);
    const allergies = p.clinicalAllergies || [];
    const obsByCode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        [
            ...p.clinicalObservations || []
        ].sort((a, b)=>(a.effectiveDate || a.createdAt || '').localeCompare(b.effectiveDate || b.createdAt || '')).forEach((o)=>{
            (map[o.code] = map[o.code] || []).push(o);
        });
        return map;
    }, [
        p.clinicalObservations
    ]);
    const abnormalLabs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seenId = new Set();
        const abnormal = [
            ...p.clinicalObservations || []
        ].filter((o)=>{
            if (seenId.has(o.id)) return false;
            seenId.add(o.id);
            return true;
        }).filter((o)=>!(0, $bf42e0131d395ab7$export$520152d4ddd823c6).has(o.code)).filter((o)=>[
                'abnormal',
                'critical',
                'high',
                'low',
                'h',
                'l'
            ].includes((o.status || '').toLowerCase()));
        const seenCode = new Set();
        return abnormal.filter((o)=>{
            const k = o.code || o.display;
            if (seenCode.has(k)) return false;
            seenCode.add(k);
            return true;
        }).reverse().slice(0, 6).map((o)=>({
                ...o,
                series: (obsByCode[o.code] || []).map((x)=>parseFloat(x.value)).filter((v)=>!isNaN(v)).slice(-6)
            }));
    }, [
        p.clinicalObservations,
        obsByCode
    ]);
    const lastVisitSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const notes = [
            ...p.clinicalNotes || []
        ].reverse();
        return notes.find((n)=>n.noteType === 'VISIT_SUMMARY') || null;
    }, [
        p.clinicalNotes
    ]);
    const lastVisitInfo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!lastVisitSummary) return null;
        const encId = lastVisitSummary.appointmentId;
        const encounter = (p.encounters || []).find((e)=>e.id === encId);
        const bp = (obsByCode['55284-4'] || []).filter((o)=>o.appointmentId === encId).slice(-1)[0];
        const actions = [
            ...medications.filter((m)=>m.appointmentId === encId).map((m)=>m.dosageInstruction?.text ? t('patient.overview.medStartedWithDose', {
                    name: m.display,
                    dose: m.dosageInstruction.text
                }) : t('patient.overview.medStarted', {
                    name: m.display
                })),
            ...(orders || []).filter((o)=>o.appointmentId === encId).map((o)=>t('patient.overview.orderRequested', {
                    name: o.name
                }))
        ];
        return {
            date: (0, $652abbe9694ab398$export$372861cd7d55d715)(lastVisitSummary.createdAt, formatDate),
            type: encounter ? $d983d5badec2112a$var$ENCOUNTER_TYPE(t)[encounter.type] || encounter.type : null,
            dxCount: conditions.filter((c)=>c.appointmentId === encId).length,
            bp: bp?.value || null,
            text: (lastVisitSummary.content?.text || '').replace(/<[^>]*>/g, ''),
            actions: actions
        };
    }, [
        lastVisitSummary,
        p.encounters,
        obsByCode,
        medications,
        orders,
        conditions,
        t,
        formatDate
    ]);
    const vitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d983d5badec2112a$var$OV_VITAL_DEF(t).map((v)=>{
            const series = (obsByCode[v.code] || []).map((o)=>parseFloat(o.value)).filter((n)=>!isNaN(n)).slice(-6);
            const latest = (obsByCode[v.code] || [])[obsByCode[v.code]?.length - 1];
            return {
                ...v,
                value: latest?.value,
                series: series
            };
        }).filter((v)=>v.value != null), [
        obsByCode,
        t
    ]);
    // ── Medication list: confirm-gated delete only. The free-text «+ تجویز» that
    // wrote a name into the medication list is gone (PM-0118): a drug reaches the
    // record through a visit's نسخه, where it is a formulary row with a sig, is
    // interaction-checked and can go to بیمه — a typed name was none of those and
    // read as a prescription to the doctor.
    const [confirmMed, setConfirmMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deletingMed, setDeletingMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const doDeleteMed = async (id)=>{
        setDeletingMed(id);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($d983d5badec2112a$var$DELETE_MEDICATION, {
                id: id
            });
            onRefresh?.();
        } catch  {
            toast?.error?.(t('errors.save.medicationDelete'));
        } finally{
            setDeletingMed(null);
        }
    };
    const nothing = !lastVisitInfo && !activeMeds.length && !activeConditions.length && !allergies.length && !abnormalLabs.length && !vitals.length;
    if (nothing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.empty.nothingToShow')
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        },
        "data-testid": "overview-content"
    }, lastVisitInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, {
        "data-testid": "overview-last-visit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $3FyOw.default),
        title: t('patient.overview.lastVisitSummary'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$LinkButton, {
            testId: "overview-view-visit",
            onClick: ()=>setTab?.('visits')
        }, t('patient.overview.viewFull'))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.75rem 0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.375rem',
            marginBottom: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: (0, $jTCZr.C).textPrimary
        }
    }, lastVisitInfo.date), lastVisitInfo.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, lastVisitInfo.type)), lastVisitInfo.dxCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(lastVisitInfo.dxCount), " ", t('patient.conditions.one'))), lastVisitInfo.bp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.vitals.bp'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        style: {
            color: (0, $jTCZr.C).textPrimary
        }
    }, formatDigits(lastVisitInfo.bp))))), lastVisitInfo.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.75,
            margin: 0
        }
    }, lastVisitInfo.text), lastVisitInfo.actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem',
            paddingTop: '0.625rem',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.05em',
            marginBottom: '0.375rem'
        }
    }, t('patient.overview.visitActions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.3125rem'
        }
    }, lastVisitInfo.actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.4375rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).good,
                flexShrink: 0,
                marginTop: '0.1875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true
        })), a)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $aVx4q.default),
        title: t('patient.meds.active'),
        count: activeMeds.length
    }), activeMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('visit.rx.noneRecorded')) : activeMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '2rem',
                height: '2rem',
                borderRadius: '0.5rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 15,
            color: (0, $jTCZr.C).navy,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m)), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            onClick: ()=>setConfirmMed(m.id),
            disabled: deletingMed === m.id,
            "aria-label": t('patient.meds.removeAria', {
                name: m.display
            }),
            "data-testid": `overview-med-delete-${m.id}`,
            style: {
                color: (0, $jTCZr.CT).danger,
                opacity: deletingMed === m.id ? 0.4 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $fX0JO.default),
        title: t('patient.conditions.active'),
        count: activeConditions.length
    }), activeConditions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.empty.noneRecorded')) : activeConditions.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: c.id || i,
            style: {
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('common.state.active')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
            cond: c
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, c.display), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontFamily: 'ui-monospace, monospace'
            }
        }, c.code)), c.onsetDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.1875rem'
            }
        }, t('patient.conditions.onset'), " ", (0, $652abbe9694ab398$export$372861cd7d55d715)(c.onsetDate, formatDate))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $QG9Z3.default),
        title: t('patient.allergies.drug'),
        count: allergies.length,
        danger: true
    }), allergies.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.allergies.none')) : allergies.map((a, i)=>{
        const sev = $d983d5badec2112a$var$OV_SEVERITY(t)[a.severity];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: a.id || i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.5rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                flexShrink: 0,
                background: sev?.tone === 'high' ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).amberLight,
                color: sev?.tone === 'high' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, sev?.l || a.severity || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, a.allergen), a.reaction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, t('patient.allergies.reaction'), " ", a.reaction)));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $4CVxl.default),
        title: t('patient.obs.abnormal'),
        count: abnormalLabs.length,
        action: abnormalLabs.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$LinkButton, {
            testId: "overview-view-labs",
            onClick: ()=>setTab?.('labs')
        }, t('patient.obs.viewAll')) : null
    }), abnormalLabs.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.empty.noneRecorded')) : abnormalLabs.map((o, i)=>{
        const isCrit = (o.status || '').toLowerCase() === 'critical';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: o.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.78125rem',
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, o.display), o.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: o.series,
            width: 40,
            height: 18,
            tone: isCrit ? 'danger' : 'warn'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'end',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                fontFamily: 'ui-monospace, monospace',
                color: isCrit ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warnInk
            }
        }, formatDigits(o.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                color: isCrit ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warnInk
            }
        }, isCrit ? t('visit.vitals.critical') : t('visit.vitals.abnormal'))));
    })), vitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$69bc41ee738923ec), null, t('patient.labCategory.vitals')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
        }
    }, vitals.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.code,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.25rem'
            }
        }, v.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '1rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary,
                fontFamily: 'ui-monospace, monospace'
            }
        }, formatDigits(v.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, v.unit)), v.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: v.series,
            width: 40,
            height: 9
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!confirmMed,
        onOpenChange: (o)=>{
            if (!o) setConfirmMed(null);
        },
        title: t('patient.meds.delete'),
        message: t('patient.meds.deleteConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>doDeleteMed(confirmMed)
    }));
};
var $d983d5badec2112a$export$2e2bcd8739ae039 = $d983d5badec2112a$var$MobilePatientOverview;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $cRX9v = parcelRequire("cRX9v");
var $7gSBD = parcelRequire("7gSBD");
var $cLQXb = parcelRequire("cLQXb");
var $h4ZeB = parcelRequire("h4ZeB");
var $ctU9L = parcelRequire("ctU9L");
var $kCQwN = parcelRequire("kCQwN");
var $66joL = parcelRequire("66joL");
var $cPdQE = parcelRequire("cPdQE");
var $3uzzV = parcelRequire("3uzzV");

var $k2reB = parcelRequire("k2reB");
var $aRAFQ = parcelRequire("aRAFQ");
var $8g4t5 = parcelRequire("8g4t5");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b7762e62111820ee$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
            key: "gugj83"
        }
    ]
];
const $b7762e62111820ee$export$2e2bcd8739ae039 = (0, $9QBug.default)("table-2", $b7762e62111820ee$export$3efd853dbb351e94);


var $6TdpC = parcelRequire("6TdpC");
var $bU80g = parcelRequire("bU80g");



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $acw62 = parcelRequire("acw62");



// The patient's vital-sign history — ONE source for both surfaces of «مشاهدات».
//
// The desktop tab read `queryVitalTimeSeries` (full history, so it can plot a
// trend) while the mobile section derived latest-only values from whatever
// vitals happened to be embedded in the record payload. Same section, two data
// paths, two answers — the divergence DESIGN-CONCEPT-MOBILE §1.1 exists to
// prevent. Both now call this.
//
// The vitals service returns points without a status, so «out of range» is
// derived here from the reference bounds in `VITAL_DEFS`; beyond ±15% of the
// bound it is critical rather than merely abnormal.
const $065bc8b7ead4fbf6$var$QUERY_VITAL_TIME_SERIES = `query QueryVitalTimeSeries($patientId:ID!,$codes:[String!]){queryVitalTimeSeries(patientId:$patientId,codes:$codes){code display unit points{timestamp value}}}`;
function $065bc8b7ead4fbf6$var$statusFor(def, numVal) {
    if (def?.refLow == null || def?.refHigh == null || Number.isNaN(numVal)) return 'normal';
    if (numVal < def.refLow * 0.85 || numVal > def.refHigh * 1.15) return 'critical';
    if (numVal < def.refLow || numVal > def.refHigh) return 'abnormal';
    return 'normal';
}
function $065bc8b7ead4fbf6$export$dbab5d47820ca910(patientId) {
    const [raw, setRaw] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(()=>{
        if (!patientId) return;
        setLoading(true);
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($065bc8b7ead4fbf6$var$QUERY_VITAL_TIME_SERIES, {
            patientId: patientId,
            codes: (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).map((d)=>d.loinc)
        }).then((d)=>setRaw(d?.queryVitalTimeSeries || []))// A failed query must not look like a patient with no vitals (§14.3).
        .catch((e)=>{
            setRaw(null);
            setError(e);
        }).finally(()=>setLoading(false));
    }, [
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const byLoinc = (0, $acw62.useMemo)(()=>{
        const map = {};
        (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).forEach((d)=>{
            map[d.loinc] = [];
        });
        (raw || []).forEach((series)=>{
            if (map[series.code] === undefined) return;
            const def = (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).find((d)=>d.loinc === series.code);
            map[series.code] = (series.points || []).map((pt, idx)=>{
                const numVal = typeof pt.value === 'number' ? pt.value : parseFloat(pt.value);
                const value = Number.isNaN(numVal) ? String(pt.value ?? '') : Number.isInteger(numVal) ? String(numVal) : parseFloat(numVal.toFixed(2)).toString();
                return {
                    id: `${series.code}-${idx}`,
                    date: pt.timestamp || '',
                    value: value,
                    numVal: numVal,
                    status: $065bc8b7ead4fbf6$var$statusFor(def, numVal)
                };
            });
        });
        return map;
    }, [
        raw
    ]);
    const flagged = (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).filter((def)=>{
        const readings = byLoinc[def.loinc];
        return (0, $00011fef9dd464cc$export$cb21c69c81e22f82)(readings?.[readings.length - 1]?.status);
    });
    return {
        byLoinc: byLoinc,
        flagged: flagged,
        loading: loading,
        error: error,
        retry: load
    };
}
function $065bc8b7ead4fbf6$export$31957fd116297820(byLoinc) {
    return (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).map((def)=>{
        const readings = byLoinc[def.loinc] || [];
        const last = readings[readings.length - 1];
        if (!last) return null;
        const prev = readings[readings.length - 2];
        const delta = prev && !Number.isNaN(last.numVal) && !Number.isNaN(prev.numVal) ? last.numVal - prev.numVal : null;
        return {
            id: def.id,
            labelKey: def.labelKey,
            unit: def.unit,
            value: last.value,
            delta: delta,
            alert: (0, $00011fef9dd464cc$export$cb21c69c81e22f82)(last.status)
        };
    }).filter(Boolean);
}



// ─────────────────────────────────────────────────────────────────────────────
// The analysis-timeline model — ONE behavioural truth for the «تحلیل» section of
// the patient record, shared by the desktop tab and the mobile section
// (DESIGN-CONCEPT-MOBILE §1.1: the two surfaces may look nothing alike, but they
// must never disagree about which observations exist, which reading is out of
// range, or when a medication was actually running).
//
// It answers the question the record's other tabs cannot: *how did this patient
// move over time, and did what we did line up with the change?* Everything is
// projected onto one time axis — measurements as series, prescriptions as
// intervals, diagnoses/orders/encounters as events.
//
// The vocabulary is NOT re-declared here: observations come from
// `lib/observations` (`buildSeriesMap`), vitals from `hooks/useVitalSeries`, the
// taxonomy and reference ranges from `constants/patientRecord`. This module is
// the projection onto a clock, nothing more.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");


var $4UJrq = parcelRequire("4UJrq");


const $aa3ffb82ad5c03f7$export$fa2e89afea4272f6 = 86400000;
// ── The clinic's calendar ────────────────────────────────────────────────────
// «This month», the month gridlines and «which year» are the CLINIC's calendar:
// Jalali, unless the brand puts the product on the Gregorian one
// (`calendar: 'gregory'`, ui/lib/brand.js). The formatters agree — the locale
// descriptors switch `formatClinicMonth` to the same calendar — so a gridline
// is always labelled with the month it starts. Both read the UTC day, as
// `msToJalali` always has.
const $aa3ffb82ad5c03f7$var$gregorianClinic = ()=>(0, $eLeza.calendarSystem)('jalali') === 'gregory';
/** `{ y, m, d }` of the day `ms` falls on, in the clinic's calendar; null when corrupt. */ function $aa3ffb82ad5c03f7$var$clinicDate(ms) {
    if (!$aa3ffb82ad5c03f7$var$gregorianClinic()) return (0, $4UJrq.msToJalali)(ms);
    const date = new Date(ms);
    if (Number.isNaN(date.getTime())) return null;
    return {
        y: date.getUTCFullYear(),
        m: date.getUTCMonth() + 1,
        d: date.getUTCDate()
    };
}
/** The first day of month `m` of year `y` in the clinic's calendar, at UTC midnight. */ const $aa3ffb82ad5c03f7$var$clinicMonthStart = (y, m)=>$aa3ffb82ad5c03f7$var$gregorianClinic() ? Date.UTC(y, m - 1, 1) : (0, $4UJrq.jalaliToMs)(y, m, 1);
function $aa3ffb82ad5c03f7$export$ff695c3374a8851c(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    const s = String(value);
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T12:00:00Z` : s;
    const ms = new Date(iso).getTime();
    return Number.isNaN(ms) ? null : ms;
}
const $aa3ffb82ad5c03f7$export$5f37411c4bafeb65 = [
    {
        id: 'month',
        labelKey: 'patient.analysis.range.month',
        calendarMonth: true
    },
    {
        id: '3m',
        labelKey: 'patient.analysis.range.3m',
        months: 3
    },
    {
        id: '6m',
        labelKey: 'patient.analysis.range.6m',
        months: 6
    },
    {
        id: '12m',
        labelKey: 'patient.analysis.range.12m',
        months: 12
    },
    {
        id: 'all',
        labelKey: 'patient.analysis.range.all',
        months: 0
    }
];
const $aa3ffb82ad5c03f7$export$5cd86cf5917308cd = '12m';
const $aa3ffb82ad5c03f7$export$f791bb8fbe557da2 = 'custom';
const $aa3ffb82ad5c03f7$export$b5a289615f33ef57 = 3600000; // one hour
function $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2(rangeId, earliest, now = Date.now(), custom = null) {
    if (rangeId === $aa3ffb82ad5c03f7$export$f791bb8fbe557da2 && custom && custom.from != null && custom.to != null) return $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5(custom.from, custom.to);
    const preset = $aa3ffb82ad5c03f7$export$5f37411c4bafeb65.find((r)=>r.id === rangeId) || $aa3ffb82ad5c03f7$export$5f37411c4bafeb65.find((r)=>r.id === $aa3ffb82ad5c03f7$export$5cd86cf5917308cd);
    // A little air after «now» so the marker and an open interval's arrow cap are
    // not clipped by the plot edge.
    const max = now + 6 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
    if (preset.calendarMonth) {
        const j = $aa3ffb82ad5c03f7$var$clinicDate(now);
        // Before the converter's epoch there is no Jalali month to speak of; fall
        // back to a rolling month rather than throwing.
        if (!j) return {
            min: now - 30 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6,
            max: max
        };
        const min = $aa3ffb82ad5c03f7$var$clinicMonthStart(j.y, j.m);
        const nextM = j.m === 12 ? 1 : j.m + 1;
        const nextY = j.m === 12 ? j.y + 1 : j.y;
        // The month's own end, but never beyond «now»'s breathing room — a window
        // reaching into next week would waste half the axis on empty future.
        return {
            min: min,
            max: Math.min($aa3ffb82ad5c03f7$var$clinicMonthStart(nextY, nextM), max)
        };
    }
    if (!preset.months) {
        const min = earliest != null ? earliest - 7 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6 : now - 365 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
        return {
            min: Math.min(min, now - 30 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6),
            max: max
        };
    }
    return {
        min: now - preset.months * 30.44 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6,
        max: max
    };
}
function $aa3ffb82ad5c03f7$export$50a7e9003a1e4b26(fromMs, toMs, t) {
    if (fromMs == null || toMs == null) return t('validation.date.bothRequired');
    if (!Number.isFinite(fromMs) || !Number.isFinite(toMs)) return t('validation.date.invalid');
    if (Math.abs(toMs - fromMs) < $aa3ffb82ad5c03f7$export$b5a289615f33ef57) return t('validation.date.minOneHour');
    return null;
}
function $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5(a, b) {
    let min = Math.min(a, b);
    let max = Math.max(a, b);
    if (max - min < $aa3ffb82ad5c03f7$export$b5a289615f33ef57) {
        const mid = (min + max) / 2;
        min = mid - $aa3ffb82ad5c03f7$export$b5a289615f33ef57 / 2;
        max = mid + $aa3ffb82ad5c03f7$export$b5a289615f33ef57 / 2;
    }
    return {
        min: min,
        max: max
    };
}
function $aa3ffb82ad5c03f7$export$71edd4bcc3ce038a(min, max, limit = 40) {
    const start = $aa3ffb82ad5c03f7$var$clinicDate(min);
    // The converter reaches both sides of its 1400/01/01 anchor as of framework
    // v0.5.0, so this guard is now only about a corrupt timestamp rather than
    // about the old epoch floor.
    if (!start) return [];
    const ticks = [];
    let { y: y, m: m } = start;
    for(let i = 0; i < limit; i += 1){
        const ms = $aa3ffb82ad5c03f7$var$clinicMonthStart(y, m);
        if (ms > max) break;
        if (ms >= min) ticks.push(ms);
        m += 1;
        if (m > 12) {
            m = 1;
            y += 1;
        }
    }
    return ticks;
}
function $aa3ffb82ad5c03f7$export$57a214e89a3308a1(ms, { formatClinicMonth: formatClinicMonth }) {
    const j = $aa3ffb82ad5c03f7$var$clinicDate(ms);
    if (!j) return '';
    return formatClinicMonth(ms, {
        withYear: j.m === 1
    });
}
function $aa3ffb82ad5c03f7$export$d2cb3004af48acf4(ms, { formatDate: formatDate }) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, 'long');
}
function $aa3ffb82ad5c03f7$export$e00157e2cd456ae7(ms, { formatDate: formatDate }) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, 'short');
}
function $aa3ffb82ad5c03f7$export$3ff7acb1a8ca9b7c(ms, { formatDate: formatDate }, withYear = false) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, withYear ? 'long' : 'dayMonth');
}
const $aa3ffb82ad5c03f7$var$pad2 = (n)=>String(n).padStart(2, '0');
function $aa3ffb82ad5c03f7$export$77faf5e1a63b35f8(ms, { formatTime: formatTime }) {
    return formatTime(ms);
}
function $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae({ min: min, max: max }, t, { withTime: withTime = false, fmt: fmt } = {}) {
    const a = $aa3ffb82ad5c03f7$var$clinicDate(min);
    const b = $aa3ffb82ad5c03f7$var$clinicDate(max);
    if (!a || !b) return '';
    const crossesYear = a.y !== b.y;
    const time = withTime || max - min <= 3 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
    const one = (ms)=>$aa3ffb82ad5c03f7$export$3ff7acb1a8ca9b7c(ms, fmt, crossesYear) + (time ? ` ${$aa3ffb82ad5c03f7$export$77faf5e1a63b35f8(ms, fmt)}` : '');
    return t('patient.analysis.rangeBetween', {
        from: one(min),
        to: one(max)
    });
}
function $aa3ffb82ad5c03f7$export$8d73c39233125377(value) {
    if (!value) return null;
    const s = String(value).trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    const [, y, mo, d, hh, mi] = m;
    const utc = Date.UTC(+y, +mo - 1, +d, +(hh ?? 0), +(mi ?? 0));
    return utc - (0, $4UJrq.IRAN_OFFSET_MS);
}
function $aa3ffb82ad5c03f7$export$9b9263c8189aa410(ms, { withTime: withTime = true } = {}) {
    if (ms == null) return '';
    const d = new Date(ms + (0, $4UJrq.IRAN_OFFSET_MS));
    const date = `${d.getUTCFullYear()}-${$aa3ffb82ad5c03f7$var$pad2(d.getUTCMonth() + 1)}-${$aa3ffb82ad5c03f7$var$pad2(d.getUTCDate())}`;
    return withTime ? `${date} ${$aa3ffb82ad5c03f7$var$pad2(d.getUTCHours())}:${$aa3ffb82ad5c03f7$var$pad2(d.getUTCMinutes())}` : date;
}
const $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4 = 'vitals';
const $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4 = 'other';
const $aa3ffb82ad5c03f7$export$1fe33fa0a1eed6fa = (catId)=>((0, $bf42e0131d395ab7$export$5a8441d057c1b67f).find((c)=>c.id === catId) || {}).labelKey || 'patient.labCategory.other';
const $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4 = (item, m)=>(m?.nameKey && item ? item(m.nameKey) : m?.name) || '';
const $aa3ffb82ad5c03f7$var$statusOf = (reading, def)=>{
    if (reading.status && reading.status !== 'normal') return String(reading.status).toLowerCase();
    if (def && def.refLow != null && def.refHigh != null && Number.isFinite(reading.numVal)) {
        if (reading.numVal < def.refLow * 0.85 || reading.numVal > def.refHigh * 1.15) return 'critical';
        if (reading.numVal < def.refLow || reading.numVal > def.refHigh) return 'abnormal';
    }
    return 'normal';
};
function $aa3ffb82ad5c03f7$export$ff45910b09935506({ patient: patient, vitalsByLoinc: vitalsByLoinc } = {}) {
    const metrics = [];
    // Which LOINCs the vitals service actually delivered a series for. The record
    // payload is skipped for exactly these and no others — see the note below.
    const coveredByVitalsService = new Set();
    // Vitals — full history from the vitals service (the same hook «مشاهدات»
    // uses), so the two sections cannot disagree about a reading.
    (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).forEach((def)=>{
        const readings = (vitalsByLoinc || {})[def.loinc] || [];
        const points = readings.map((r)=>({
                x: $aa3ffb82ad5c03f7$export$ff695c3374a8851c(r.date),
                y: r.numVal,
                status: $aa3ffb82ad5c03f7$var$statusOf(r, def),
                id: r.id
            })).filter((p)=>p.x != null && Number.isFinite(p.y)).sort((a, b)=>a.x - b.x);
        if (!points.length) return;
        coveredByVitalsService.add(def.loinc);
        metrics.push({
            key: `vital:${def.loinc}`,
            nameKey: def.labelKey,
            unit: def.unit,
            category: $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4,
            catId: 'vitals',
            isVital: true,
            refLow: def.refLow,
            refHigh: def.refHigh,
            points: points
        });
    });
    // Everything else on the record — laboratory analytes, and any measurement
    // the vitals service did not answer for.
    //
    // The skip below is keyed to what was ACTUALLY covered above, never to the
    // broader `VITAL_LOINC_SET`. Those two sets are not the same size and never
    // were: the taxonomy classes eight LOINCs as vital, while the vitals service
    // is only asked for the five in `VITAL_DEFS`. Skipping on the taxonomy made
    // the difference — systolic `8480-6`, diastolic `8462-4`, respiratory rate
    // `9279-1` — fall through both paths and vanish from the record entirely
    // (14 of 51 observations on the dev data set). A measurement the patient
    // actually has must never be silently unselectable, so anything the vitals
    // service did not return is taken from the record payload instead.
    const seriesMap = (0, $00011fef9dd464cc$export$1be0eaa0fb63147e)(patient?.clinicalObservations);
    Object.values(seriesMap).forEach((s)=>{
        if (coveredByVitalsService.has(s.code)) return; // already covered, with better history
        const points = s.readings.map((r)=>({
                x: $aa3ffb82ad5c03f7$export$ff695c3374a8851c(r.date),
                y: r.numVal,
                status: $aa3ffb82ad5c03f7$var$statusOf(r, null),
                id: r.id
            })).filter((p)=>p.x != null && Number.isFinite(p.y)).sort((a, b)=>a.x - b.x);
        if (!points.length) return;
        metrics.push({
            key: `lab:${s.display}`,
            // A lab analyte's name is what the lab reported — wire data, not UI copy,
            // so it is shown verbatim in either language.
            name: s.display,
            unit: s.unit || '',
            category: s.catId || $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4,
            catId: s.catId,
            isVital: false,
            refLow: null,
            refHigh: null,
            points: points
        });
    });
    metrics.forEach((m)=>{
        m.latest = m.points[m.points.length - 1];
        m.worst = m.points.some((p)=>p.status === 'critical') ? 'critical' : m.points.some((p)=>(0, $00011fef9dd464cc$export$cb21c69c81e22f82)(p.status) || p.status === 'abnormal') ? 'abnormal' : 'normal';
        m.latestStatus = m.latest?.status && m.latest.status !== 'normal' ? m.latest.status : null;
    });
    return metrics;
}
function $aa3ffb82ad5c03f7$export$d93eda82a58a56de(metrics, item) {
    const order = [
        $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4,
        ...(0, $bf42e0131d395ab7$export$5a8441d057c1b67f).filter((c)=>c.id !== 'vitals').map((c)=>c.id),
        $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4
    ];
    const byCat = new Map();
    metrics.forEach((m)=>{
        if (!byCat.has(m.category)) byCat.set(m.category, []);
        byCat.get(m.category).push(m);
    });
    // A metric's own name may be a key (vitals) or a wire string (lab analytes),
    // so resolve before sorting — otherwise the list is ordered by key path.
    const nameOf = (m)=>m.nameKey && item ? item(m.nameKey) : m.name || '';
    return order.filter((c)=>byCat.has(c)).map((c)=>({
            category: c,
            categoryKey: $aa3ffb82ad5c03f7$export$1fe33fa0a1eed6fa(c),
            metrics: byCat.get(c).sort((a, b)=>nameOf(a).localeCompare(nameOf(b))),
            abnormal: byCat.get(c).filter((m)=>m.latestStatus).length
        }));
}
const $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5 = 6;
function $aa3ffb82ad5c03f7$export$792e61c1707842c4(metrics, cap = 3) {
    const rank = (m)=>m.latestStatus === 'critical' ? 3 : m.latestStatus ? 2 : 0;
    return [
        ...metrics
    ].sort((a, b)=>rank(b) - rank(a) || (b.latest?.x || 0) - (a.latest?.x || 0) || b.points.length - a.points.length).slice(0, cap).map((m)=>m.key);
}
function $aa3ffb82ad5c03f7$export$347601b23791171(medications, now = Date.now()) {
    const byName = new Map();
    (medications || []).forEach((m)=>{
        const from = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(m.authoredOn || m.createdAt);
        if (from == null) return;
        // The Latin generic leads here too, so a bar on the rail carries the same
        // name as the نسخه row that created it.
        const name = (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m) || "\u2014";
        const key = m.code || name;
        const to = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(m.endDate);
        const dose = m.dosageInstruction?.text || m.dosage || '';
        if (!byName.has(key)) byName.set(key, {
            id: key,
            label: name,
            segments: []
        });
        byName.get(key).segments.push({
            id: m.id,
            from: from,
            to: to && to <= now ? to : null,
            dose: dose,
            label: dose ? `${name} ${dose}` : name
        });
    });
    return [
        ...byName.values()
    ].map((row)=>({
            ...row,
            segments: row.segments.sort((a, b)=>a.from - b.from)
        })).sort((a, b)=>{
        const aOpen = a.segments.some((s)=>s.to == null);
        const bOpen = b.segments.some((s)=>s.to == null);
        if (aOpen !== bOpen) return aOpen ? -1 : 1;
        return (b.segments[b.segments.length - 1]?.from || 0) - (a.segments[a.segments.length - 1]?.from || 0);
    });
}
const $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619 = {
    dx: {
        row: 1,
        shape: 'triangle',
        tone: 'accent'
    },
    order: {
        row: 0,
        shape: 'diamond',
        tone: 'warn'
    }
};
function $aa3ffb82ad5c03f7$export$f575cae50c008afe({ conditions: conditions, orders: orders } = {}, t) {
    const out = [];
    (conditions || []).forEach((c)=>{
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(c.onsetDate || c.createdAt);
        if (ms == null) return;
        const resolved = c.clinicalStatus === 'resolved';
        out.push({
            id: `dx-${c.id}`,
            t: ms,
            kind: 'dx',
            label: c.display || "\u2014",
            detail: resolved ? t('patient.conditions.resolved') : c.code ? `ICD ${c.code}` : t('patient.conditions.one'),
            hollow: resolved
        });
    });
    (orders || []).forEach((o)=>{
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(o.performedDate || o.createdAt);
        if (ms == null) return;
        out.push({
            id: `ord-${o.id}`,
            t: ms,
            kind: 'order',
            label: o.name || "\u2014",
            detail: o.orderType || t('visit.orders.procedure')
        });
    });
    return out.sort((a, b)=>a.t - b.t);
}
function $aa3ffb82ad5c03f7$export$eb6bc7e4d8dbcf1c(encounters) {
    return (encounters || []).map((e)=>{
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(e.scheduledDate || e.startDate || e.createdAt);
        if (ms == null) return null;
        const status = String(e.status || '').toLowerCase();
        const live = status === 'in-progress' || status === 'in_progress' || status === 'arrived' || status === 'active';
        const cancelled = status === 'cancelled';
        return {
            id: e.id,
            t: ms,
            live: live,
            cancelled: cancelled,
            type: e.encounterType || e.type || '',
            status: status
        };
    }).filter(Boolean).sort((a, b)=>a.t - b.t);
}
function $aa3ffb82ad5c03f7$export$9113702d80a167d8({ metrics: metrics, medRows: medRows, events: events, encounters: encounters }) {
    const candidates = [
        ...(metrics || []).map((m)=>m.points[0]?.x),
        ...(medRows || []).flatMap((r)=>r.segments.map((s)=>s.from)),
        ...(events || []).map((e)=>e.t),
        ...(encounters || []).map((e)=>e.t)
    ].filter((v)=>v != null);
    return candidates.length ? Math.min(...candidates) : null;
}
function $aa3ffb82ad5c03f7$export$ba330bb14d26e4ac(points, item, tolerance) {
    let best = null;
    let bestD = Infinity;
    (points || []).forEach((p)=>{
        const d = Math.abs(p.x - item);
        if (d < bestD) {
            bestD = d;
            best = p;
        }
    });
    return bestD <= tolerance ? best : null;
}
function $aa3ffb82ad5c03f7$export$29e5558020ac2bd3(medRows, item, now = Date.now()) {
    return (medRows || []).filter((r)=>r.segments.some((s)=>item >= s.from && item <= (s.to ?? now))).map((r)=>r.label);
}


// A zoom that jumps is disorienting: the eye loses which part of the old window
// it is now looking at. Tweening the domain keeps that thread — every lane is
// derived from it, so one animated value moves the whole timeline together.
//
// Motion is opt-out by environment, not by preference alone: without
// `matchMedia` (jsdom) or `requestAnimationFrame` there is nothing to tween
// against, so the value snaps. That is also what keeps component tests
// deterministic — they never observe a half-finished zoom (§15.2).
const $3dddcf07f47e64f7$var$ZOOM_MS = 260;
const $3dddcf07f47e64f7$var$easeOutCubic = (item)=>1 - Math.pow(1 - item, 3);
function $3dddcf07f47e64f7$var$prefersInstant() {
    if (typeof window === 'undefined') return true;
    if (typeof window.requestAnimationFrame !== 'function') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
function $3dddcf07f47e64f7$var$useAnimatedWindow(target) {
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(target);
    const fromRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(target);
    const rafRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const from = fromRef.current;
        if (from.min === target.min && from.max === target.max) return undefined;
        if ($3dddcf07f47e64f7$var$prefersInstant()) {
            fromRef.current = target;
            setShown(target);
            return undefined;
        }
        const t0 = performance.now();
        const step = (now)=>{
            const k = $3dddcf07f47e64f7$var$easeOutCubic(Math.min(1, (now - t0) / $3dddcf07f47e64f7$var$ZOOM_MS));
            const cur = {
                min: from.min + (target.min - from.min) * k,
                max: from.max + (target.max - from.max) * k
            };
            fromRef.current = cur;
            setShown(cur);
            if (k < 1) rafRef.current = requestAnimationFrame(step);
            else {
                fromRef.current = target;
                setShown(target);
            }
        };
        rafRef.current = requestAnimationFrame(step);
        return ()=>cancelAnimationFrame(rafRef.current);
    }, [
        target.min,
        target.max
    ]);
    return shown;
}
// The «تحلیل» section's data + selection behaviour, kept out of the render tree
// (DESIGN-CONCEPT §2.6) so the desktop tab and the mobile section share one
// answer — and so the derivation is unit-testable without a DOM.
//
// Three sources feed one timeline:
//   • the record payload (`usePatient`) — observations, medications,
//     conditions, encounters: already loaded by the page root, never refetched;
//   • `useVitalSeries` — the vitals service's full history, the same hook
//     «مشاهدات» calls;
//   • `listDoctorOrders` — the only query this section adds.
//
// Selection persists per patient: an investigation is usually resumed, and
// re-picking six metrics on every visit to the tab is a tax, not a feature.
const $3dddcf07f47e64f7$var$storageKey = (patientId)=>`parsina.analysis.metrics.${patientId}`;
const $3dddcf07f47e64f7$var$readStored = (patientId)=>{
    if (!patientId || typeof localStorage === 'undefined') return null;
    try {
        const raw = localStorage.getItem($3dddcf07f47e64f7$var$storageKey(patientId));
        const parsed = raw ? JSON.parse(raw) : null;
        return Array.isArray(parsed) && parsed.length ? parsed : null;
    } catch  {
        return null;
    }
};
const $3dddcf07f47e64f7$var$writeStored = (patientId, keys)=>{
    if (!patientId || typeof localStorage === 'undefined') return;
    try {
        localStorage.setItem($3dddcf07f47e64f7$var$storageKey(patientId), JSON.stringify(keys));
    } catch  {}
};
function $3dddcf07f47e64f7$export$e015f957982fab20(patient, options = {}) {
    const { t: t } = (0, $LNQP4.default)();
    // «now» is pinned for the life of the section, not read per render.
    //
    // As a default parameter it was re-evaluated on every render, so the window's
    // upper bound moved by a few milliseconds each time. Nothing looked wrong,
    // but everything downstream churned: `target` was a new value on every
    // render, the zoom tween restarted continuously, and the custom-range
    // dialog's "seed from the current window" effect re-fired and wiped whatever
    // the doctor had just typed. A timeline's clock has to hold still to be
    // reasoned about — and tests still inject their own (§15.2).
    const nowRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(options.now ?? Date.now());
    const now = options.now ?? nowRef.current;
    const patientId = patient?.id;
    const vitals = (0, $065bc8b7ead4fbf6$export$dbab5d47820ca910)(patientId);
    // ── Doctor orders ─────────────────────────────────────────────────────────
    // `null` = in flight, `[]` = loaded-or-failed. A failed order fetch degrades
    // to *no procedure events* rather than blanking the timeline: the rest of the
    // analysis stays valid without it, but the failure is still surfaced (§14.3)
    // via `ordersError` so it never reads as "this patient has no orders".
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [ordersError, setOrdersError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!patientId) return;
        setOrders(null);
        setOrdersError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$25ba33c54a6be1ed), {
            patientId: patientId
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch((e)=>{
            setOrders([]);
            setOrdersError(e);
        });
    }, [
        patientId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadOrders();
    }, [
        loadOrders
    ]);
    // ── Derivation ────────────────────────────────────────────────────────────
    const metrics = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$ff45910b09935506)({
            patient: patient,
            vitalsByLoinc: vitals.byLoinc
        }), [
        patient,
        vitals.byLoinc
    ]);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$d93eda82a58a56de)(metrics, t), [
        metrics,
        t
    ]);
    const medRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$347601b23791171)(patient?.clinicalMedications, now), [
        patient?.clinicalMedications,
        now
    ]);
    const events = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$f575cae50c008afe)({
            conditions: patient?.clinicalConditions,
            orders: orders
        }, t), [
        patient?.clinicalConditions,
        orders,
        t
    ]);
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$eb6bc7e4d8dbcf1c)(patient?.encounters), [
        patient?.encounters
    ]);
    // ── Selection ─────────────────────────────────────────────────────────────
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const seededFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Seed once per patient, from the stored set when it still resolves against
    // this record, else from the smart default. Re-seeding on every metrics
    // change would yank the doctor's own selection away as data streams in.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!metrics.length || seededFor.current === patientId) return;
        const valid = new Set(metrics.map((m)=>m.key));
        const stored = ($3dddcf07f47e64f7$var$readStored(patientId) || []).filter((k)=>valid.has(k));
        setSelected(stored.length ? stored.slice(0, (0, $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5)) : (0, $aa3ffb82ad5c03f7$export$792e61c1707842c4)(metrics));
        seededFor.current = patientId;
    }, [
        metrics,
        patientId
    ]);
    // A patient switch must drop the previous patient's selection immediately —
    // showing patient A's metrics under patient B's name, even for one frame, is
    // a clinical-safety defect, not a flicker.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (seededFor.current !== patientId) setSelected([]);
    }, [
        patientId
    ]);
    const persist = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((keys)=>{
        setSelected(keys);
        $3dddcf07f47e64f7$var$writeStored(patientId, keys);
    }, [
        patientId
    ]);
    const toggleMetric = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        setSelected((prev)=>{
            const next = prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= (0, $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5) ? prev : [
                ...prev,
                key
            ];
            $3dddcf07f47e64f7$var$writeStored(patientId, next);
            return next;
        });
    }, [
        patientId
    ]);
    const selectedMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>selected.map((k)=>metrics.find((m)=>m.key === k)).filter(Boolean), [
        selected,
        metrics
    ]);
    // ── The shared window ─────────────────────────────────────────────────────
    // One window drives every lane, so zooming, picking a preset and typing a
    // custom range are the same operation with three front doors.
    const [range, setRangeState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $aa3ffb82ad5c03f7$export$5cd86cf5917308cd));
    const [custom, setCustom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { from, to } in ms
    const earliest = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$9113702d80a167d8)({
            metrics: metrics,
            medRows: medRows,
            events: events,
            encounters: encounters
        }), [
        metrics,
        medRows,
        events,
        encounters
    ]);
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2)(range, earliest, now, custom), [
        range,
        earliest,
        now,
        custom
    ]);
    // What the lanes actually draw — the tweened value on its way to `target`.
    const domain = $3dddcf07f47e64f7$var$useAnimatedWindow(target);
    const setRange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setCustom(null); // a preset always replaces a zoom
        setRangeState(id);
    }, []);
    // Drag-zoom and the custom picker both land here.
    const setWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((from, to)=>{
        const w = (0, $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5)(from, to);
        setCustom({
            from: w.min,
            to: w.max
        });
        setRangeState((0, $aa3ffb82ad5c03f7$export$f791bb8fbe557da2));
    }, []);
    const isCustom = range === (0, $aa3ffb82ad5c03f7$export$f791bb8fbe557da2) && !!custom;
    const resetWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setRange((0, $aa3ffb82ad5c03f7$export$5cd86cf5917308cd)), [
        setRange
    ]);
    const ticks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aa3ffb82ad5c03f7$export$71edd4bcc3ce038a)(domain.min, domain.max), [
        domain.min,
        domain.max
    ]);
    // Layer visibility — the lanes the doctor wants to reason with right now.
    const [layers, setLayers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        events: true,
        meds: true,
        metrics: true
    });
    const toggleLayer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>setLayers((prev)=>({
                ...prev,
                [id]: !prev[id]
            })), []);
    const inWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((item)=>item >= domain.min && item <= domain.max, [
        domain
    ]);
    return {
        metrics: // data
        metrics,
        groups: groups,
        medRows: medRows,
        events: events,
        encounters: encounters,
        selected: selected,
        selectedMetrics: selectedMetrics,
        cap: (0, $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5),
        range: // window
        range,
        setRange: setRange,
        domain: domain,
        target: target,
        ticks: ticks,
        now: now,
        earliest: earliest,
        inWindow: inWindow,
        setWindow: setWindow,
        isCustom: isCustom,
        resetWindow: resetWindow,
        layers: // layers
        layers,
        toggleLayer: toggleLayer,
        toggleMetric: // selection
        toggleMetric,
        setSelection: persist,
        // state
        loading: vitals.loading,
        error: vitals.error,
        retry: vitals.retry,
        ordersLoading: orders === null,
        ordersError: ordersError,
        retryOrders: loadOrders,
        hasData: metrics.length > 0 || medRows.length > 0 || events.length > 0 || encounters.length > 0
    };
}
var $3dddcf07f47e64f7$export$2e2bcd8739ae039 = $3dddcf07f47e64f7$export$e015f957982fab20;




var $acw62 = parcelRequire("acw62");

var $2VplL = parcelRequire("2VplL");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $amyVq = parcelRequire("amyVq");
var $3Amwd = parcelRequire("3Amwd");

// «انتخاب سنجه‌ها» on the phone — the same catalogue as the desktop dialog, in
// the overlay the mobile tier uses for it (§5.2: Dialog on desktop ⇒
// BottomSheet on mobile).
//
// The category dropdown becomes a scrollable chip row: a native <select> on a
// phone opens a full-screen wheel that hides the list it is filtering, while
// chips keep the choice and its result on screen together.
//
// Selection is drafted and committed on «اعمال», like the desktop dialog — a
// mis-tap in a long list must not silently rewrite the chart underneath.
const $9ea1e5b4638e5be6$var$STATUS_META = (t)=>({
        critical: {
            label: t('visit.vitals.critical'),
            color: (0, $jTCZr.CT).danger,
            soft: (0, $jTCZr.CT).dangerSoft,
            tone: 'danger'
        },
        abnormal: {
            label: t('visit.vitals.abnormal'),
            color: (0, $jTCZr.CT).warnInk,
            soft: (0, $jTCZr.CT).warnSoft,
            tone: 'warn'
        }
    });
const $9ea1e5b4638e5be6$var$MobileMetricPickerSheet = ({ open: open, onClose: onClose, groups: groups, selected: selected, onApply: onApply, cap: cap = (0, $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5) })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(selected);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [category, setCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [abnormalOnly, setAbnormalOnly] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // BottomSheet unmounts its children when closed, so this also resets the
    // draft on every open — but state the intent explicitly rather than relying
    // on that implementation detail.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft(selected);
            setQuery('');
            setCategory('');
            setAbnormalOnly(false);
        }
    }, [
        open,
        selected
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim();
        return groups.filter((g)=>!category || g.category === category).map((g)=>({
                ...g,
                metrics: g.metrics.filter((m)=>(!q || (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m).includes(q)) && (!abnormalOnly || !!m.latestStatus))
            })).filter((g)=>g.metrics.length);
    }, [
        groups,
        category,
        query,
        abnormalOnly,
        t
    ]);
    const abnormalCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.abnormal, 0), [
        groups
    ]);
    const full = draft.length >= cap;
    const toggle = (key)=>setDraft((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= cap ? prev : [
                ...prev,
                key
            ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('patient.analysis.pickMetrics'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('patient.analysis.searchMetric'),
        clearLabel: t('common.actions.clearSearch'),
        "data-testid": "analysis-picker-search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            overflowX: 'auto',
            paddingBottom: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('common.state.all'),
        active: !category && !abnormalOnly,
        onClick: ()=>{
            setCategory('');
            setAbnormalOnly(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.abnormalOnly'),
        count: abnormalCount ? formatDigits(abnormalCount) : undefined,
        active: abnormalOnly,
        onClick: ()=>setAbnormalOnly((v)=>!v),
        "data-testid": "analysis-picker-abnormal"
    }), groups.map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: g.category,
            label: t(g.categoryKey),
            count: formatDigits(g.metrics.length),
            active: category === g.category,
            onClick: ()=>setCategory((c)=>c === g.category ? '' : g.category)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker-list",
        "data-state": filtered.length ? 'content' : 'empty',
        style: {
            maxHeight: '50vh',
            overflowY: 'auto',
            margin: '0 -0.25rem'
        }
    }, !filtered.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2VplL.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noMetricMatch'),
        description: t('accounting.changeFilters')
    }) : filtered.map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.category
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                margin: 0,
                background: (0, $jTCZr.C).card,
                padding: '0.4375rem 0.25rem 0.25rem',
                fontSize: '0.6875rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textMuted
            }
        }, t(g.categoryKey)), g.metrics.map((m)=>{
            const on = draft.includes(m.key);
            const st = $9ea1e5b4638e5be6$var$STATUS_META(t)[m.latestStatus];
            const disabled = full && !on;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
                key: m.key,
                checked: on,
                disabled: disabled,
                onChange: ()=>toggle(m.key),
                "data-testid": `analysis-picker-row-${m.key}`,
                "data-state": on ? 'selected' : 'unselected',
                labelClassName: "flex-1 min-w-0",
                style: {
                    padding: '0.5rem 0.25rem',
                    minHeight: '2.75rem'
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).text,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }, (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        marginInlineStart: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
                    points: m.points.slice(-8).map((p)=>p.y),
                    tone: st ? st.tone : 'accent',
                    width: 40,
                    height: 15
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 800,
                        direction: 'ltr',
                        color: st ? st.color : (0, $jTCZr.C).textMuted
                    }
                }, formatDigits(Math.round(m.latest.y * 10) / 10)), st && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 800,
                        borderRadius: '0.3125rem',
                        padding: '0.0625rem 0.375rem',
                        background: st.soft,
                        color: st.color
                    }
                }, st.label)))
            });
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            paddingTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: ()=>onApply(draft),
        "data-testid": "analysis-picker-apply",
        style: {
            flex: 1
        }
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: onClose
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: full ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
            whiteSpace: 'nowrap'
        }
    }, formatDigits(draft.length), "/", formatDigits(cap)))));
};
var $9ea1e5b4638e5be6$export$2e2bcd8739ae039 = $9ea1e5b4638e5be6$var$MobileMetricPickerSheet;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");

// «بازهٔ دلخواه» on the phone — the same exact-window task as the desktop
// dialog, in the overlay the mobile tier uses for it (§5.2).
//
// The calendar and the time spinners are the kit's `JalaliDatePicker`
// (`withTime`), and the ms conversion lives in the shared model, so a range
// typed here and a range dragged on the desktop chart are the same object.
const $8de549f95d07f683$var$QUICK = [
    'month',
    '3m',
    '6m'
];
const $8de549f95d07f683$var$MobileRangeSheet = ({ open: open, onClose: onClose, domain: domain, earliest: earliest, now: now, onApply: onApply })=>{
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime
        }), [
        formatDate,
        formatTime
    ]);
    const [from, setFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [to, setTo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setFrom((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(domain.min));
        setTo((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(domain.max));
        setError('');
    }, [
        open,
        domain.min,
        domain.max
    ]);
    const fromMs = (0, $aa3ffb82ad5c03f7$export$8d73c39233125377)(from);
    const toMs = (0, $aa3ffb82ad5c03f7$export$8d73c39233125377)(to);
    const preview = fromMs != null && toMs != null ? (0, $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae)((0, $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5)(fromMs, toMs), t, {
        withTime: true,
        fmt: fmt
    }) : '';
    const apply = ()=>{
        const problem = (0, $aa3ffb82ad5c03f7$export$50a7e9003a1e4b26)(fromMs, toMs, t);
        if (problem) {
            setError(problem);
            return;
        }
        // A reversed pair is a slip, not an error — the model orders it either way.
        onApply(fromMs, toMs);
    };
    const applyQuick = (id)=>{
        const w = (0, $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2)(id, earliest, now);
        setFrom((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(w.min));
        setTo((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(w.max));
        setError('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('patient.analysis.customRange'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-range-dialog",
        style: {
            display: 'grid',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('common.labels.from')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-from"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: from,
        onChange: setFrom,
        withTime: true,
        placeholder: t('patient.analysis.startDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('common.labels.to')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-to"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: to,
        onChange: setTo,
        withTime: true,
        placeholder: t('patient.analysis.endDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 700
        }
    }, t('patient.analysis.shortcut')), (0, $aa3ffb82ad5c03f7$export$5f37411c4bafeb65).filter((r)=>$8de549f95d07f683$var$QUICK.includes(r.id)).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: r.id,
            type: "button",
            variant: "outline",
            size: "sm",
            onClick: ()=>applyQuick(r.id),
            "data-testid": `analysis-range-quick-${r.id}`
        }, t(r.labelKey)))), preview && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 700
        },
        "data-testid": "analysis-range-preview"
    }, preview), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger,
            fontWeight: 700
        },
        "data-testid": "analysis-range-error"
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: apply,
        style: {
            flex: 1
        },
        "data-testid": "analysis-range-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: onClose
    }, t('common.actions.cancel')))));
};
var $8de549f95d07f683$export$2e2bcd8739ae039 = $8de549f95d07f683$var$MobileRangeSheet;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");


// ─────────────────────────────────────────────────────────────────────────────
// The «تحلیل» chart's accessible twin on the phone.
//
// The stacked lanes are `aria-hidden` SVG — the same posture the desktop chart
// takes. Desktop pairs that with a table carrying every value as text; shipping
// the chart on the phone without it is not "the mobile version", it is the
// surface being unreadable for anyone who cannot read the chart.
//
// Same rows the desktop table builds, from the same derived model, sorted newest
// first. At phone width a five-column grid cannot hold them, so each row stacks:
// the date and kind ride a header line, the value sits large beneath it. Long
// analyte names wrap — a phone has no hover to reveal a truncated title.
// ─────────────────────────────────────────────────────────────────────────────
const $bf9f992bce10c377$var$KIND_KEYS = {
    metric: 'patient.obs.measurement',
    med: 'patient.meds.one',
    dx: 'patient.tabs.conditions',
    order: 'visit.orders.procedure',
    enc: 'patient.encounter'
};
const $bf9f992bce10c377$var$KIND_TONE = {
    metric: 'teal',
    med: 'navy',
    dx: 'teal',
    order: 'amber',
    enc: 'muted'
};
const $bf9f992bce10c377$var$MobileAnalysisTable = ({ metrics: metrics, medRows: medRows, events: events, encounters: encounters, domain: domain })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate } = (0, $LNQP4.default)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = [];
        metrics.forEach((m)=>m.points.forEach((pt)=>out.push({
                    t: pt.x,
                    kind: 'metric',
                    name: (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m),
                    value: `${formatDigits(Math.round(pt.y * 10) / 10)}${m.unit ? ` ${m.unit}` : ''}`,
                    status: pt.status !== 'normal' ? pt.status : null
                })));
        medRows.forEach((r)=>r.segments.forEach((s)=>out.push({
                    t: s.from,
                    kind: 'med',
                    name: s.label,
                    value: '',
                    status: null,
                    note: s.to == null ? t('common.state.active') : t('dashboard.queue.finished')
                })));
        events.forEach((e)=>out.push({
                t: e.t,
                kind: e.kind,
                name: e.label,
                value: '',
                status: null,
                note: e.detail
            }));
        encounters.forEach((e)=>out.push({
                t: e.t,
                kind: 'enc',
                name: e.type || t('patient.encounter'),
                value: '',
                status: null,
                note: e.live ? t('common.state.inProgress') : e.cancelled ? t('common.state.cancelled') : t('patient.meds.finished')
            }));
        return out.filter((r)=>r.t >= domain.min && r.t <= domain.max).sort((a, b)=>b.t - a.t);
    }, [
        metrics,
        medRows,
        events,
        encounters,
        domain,
        t,
        formatDigits
    ]);
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-table",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('patient.analysis.noDataInRange'),
        description: t('patient.analysis.widenRange')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-table",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "sr-only"
    }, t('patient.analysis.tableCaption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, rows.map((r, i)=>{
        const crit = r.status === 'critical';
        const abnormal = !!r.status;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${r.kind}-${r.t}-${r.name}-${i}`,
            "data-testid": "analysis-table-row",
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.625rem',
                border: `1px solid ${abnormal ? crit ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).warnSoft : (0, $jTCZr.C).border}`,
                padding: '0.5rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                whiteSpace: 'nowrap'
            }
        }, (0, $aa3ffb82ad5c03f7$export$e00157e2cd456ae7)(r.t, {
            formatDate: formatDate
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: $bf9f992bce10c377$var$KIND_TONE[r.kind] || 'muted'
        }, t($bf9f992bce10c377$var$KIND_KEYS[r.kind] || $bf9f992bce10c377$var$KIND_KEYS.enc)), abnormal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: crit ? 'danger' : 'amber'
        }, t(crit ? 'visit.vitals.critical' : 'visit.vitals.abnormal'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.5rem',
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary,
                overflowWrap: 'anywhere'
            }
        }, r.name), r.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.875rem',
                fontWeight: 800,
                flexShrink: 0,
                fontVariantNumeric: 'tabular-nums',
                color: crit ? (0, $jTCZr.CT).danger : abnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary
            }
        }, r.value)), !r.value && r.note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, r.note));
    })));
};
var $bf9f992bce10c377$export$2e2bcd8739ae039 = $bf9f992bce10c377$var$MobileAnalysisTable;


// ─────────────────────────────────────────────────────────────────────────────
// «تحلیل» on the phone — the same model as the desktop tab, a different shape.
//
// The desktop lane (a fixed rail beside the plot) does not survive 390px: the
// rail would eat half the width, and the plot — the only part carrying
// information — would get the rest. So the phone stacks: the label row sits
// ABOVE its plot, full-bleed, and the plot keeps the whole width.
//
// What does NOT change is the model (DESIGN-CONCEPT-MOBILE §1.1): the window,
// the metric pool, the selection cap and the derivation all come from
// `useAnalysisTimeline`, so the phone and the workstation can never disagree
// about which readings exist or when a drug was running.
//
// The crosshair is a pointer affordance and has no place here (§6: touch has no
// hover); a tap opens the picker instead, and the values ride the label rows.
// ─────────────────────────────────────────────────────────────────────────────
const $450dbe611cd068cd$var$Block = ({ title: title, sub: sub, value: value, tone: tone, action: action, children: children, testId: testId, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        style: {
            padding: '0.625rem 0',
            overflow: 'hidden'
        },
        "data-testid": testId,
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0 0.75rem 0.5rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text,
            overflowWrap: 'anywhere'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem'
        }
    }, sub)), value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            fontSize: '1.0625rem',
            fontWeight: 800,
            direction: 'ltr',
            letterSpacing: '-0.02em',
            color: tone || (0, $jTCZr.C).text
        }
    }, value), action), children);
const $450dbe611cd068cd$var$MobilePatientAnalysis = ({ p: p, patientId: patientId })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatTime: formatTime, formatClinicMonth: formatClinicMonth } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime,
            formatClinicMonth: formatClinicMonth
        }), [
        formatDate,
        formatTime,
        formatClinicMonth
    ]);
    const a = (0, $3dddcf07f47e64f7$export$e015f957982fab20)(p);
    const [plotRef, plotWidth] = (0, $3uzzV.default)(340);
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Per-session, like desktop: reopening the section starts on the chart.
    const [showTable, setShowTable] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The phone's rail is gone, so the value gutter shrinks — but every lane
    // still shares one scale, or the stack stops meaning "the same moment".
    const scale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $cRX9v.createTimeScale)({
            min: a.domain.min,
            max: a.domain.max,
            width: plotWidth,
            padStart: 34,
            padEnd: 8
        }), [
        a.domain,
        plotWidth
    ]);
    const eventMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.events.map((e)=>{
            const kind = (0, $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619)[e.kind] || (0, $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619).order;
            return {
                id: e.id,
                t: e.t,
                row: kind.row,
                shape: kind.shape,
                // Labels are dropped on the phone: at this width they would collide into
                // noise. The event's identity still reads from its shape and row, and the
                // full list stays one tab away in «دستورات» / «تشخیص».
                tone: kind.tone === 'accent' ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).warn
            };
        }), [
        a.events
    ]);
    const encounterMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.encounters.map((e)=>({
                id: e.id,
                t: e.t,
                shape: e.cancelled ? 'cross' : 'circle',
                filled: e.live,
                tone: e.live ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).mute
            })), [
        a.encounters
    ]);
    const medRowsInWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.medRows.filter((r)=>r.segments.some((s)=>s.from <= a.domain.max && (s.to ?? a.now) >= a.domain.min)), [
        a.medRows,
        a.domain,
        a.now
    ]);
    if (a.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "loading",
        "aria-busy": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
        height: 160,
        line: true,
        legend: 2,
        label: t('common.state.loading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
        avatar: false,
        lines: 2,
        chips: 0,
        actions: 0,
        label: t('common.state.loading')
    }));
    if (a.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.analysis.historyLoadFailed'),
        detail: a.error?.message || String(a.error),
        onRetry: a.retry
    }));
    if (!a.hasData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 24,
            "aria-hidden": true
        }),
        title: t('patient.analysis.nothingToAnalyse'),
        description: t('patient.analysis.emptyHint')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            overflowX: 'auto',
            paddingBottom: '0.125rem'
        },
        role: "group",
        "aria-label": t('common.labels.dateRange')
    }, (0, $aa3ffb82ad5c03f7$export$5f37411c4bafeb65).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: r.id,
            label: t(r.labelKey),
            active: a.range === r.id,
            onClick: ()=>a.setRange(r.id),
            "data-testid": `analysis-range-${r.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.custom'),
        active: a.isCustom,
        onClick: ()=>setRangeOpen(true),
        "data-testid": "analysis-range-custom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-active-range",
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 700
        }
    }, t('patient.analysis.activeRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text,
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: '999px',
            padding: '0.125rem 0.625rem'
        }
    }, (0, $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae)(a.target, t, {
        fmt: fmt
    })), a.isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        type: "button",
        onClick: a.resetWindow,
        "data-testid": "analysis-range-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('common.actions.reset')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        type: "button",
        className: "min-h-11 gap-1",
        style: {
            marginInlineStart: 'auto'
        },
        "aria-pressed": showTable,
        onClick: ()=>setShowTable((v)=>!v),
        "data-testid": "analysis-view-toggle"
    }, showTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.chartView')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b7762e62111820ee$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.tableView')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$69bc41ee738923ec), {
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            type: "button",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-pick-metrics"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.metricsCountPrefix'), formatDigits(a.selected.length), "/", formatDigits(a.cap), ")")
    }, t('patient.analysis.selectedObservations')), showTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf9f992bce10c377$export$2e2bcd8739ae039), {
        metrics: a.selectedMetrics,
        medRows: medRowsInWindow,
        events: a.events,
        encounters: a.encounters,
        domain: a.domain
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        style: {
            padding: '0.625rem 0 0',
            overflow: 'hidden'
        },
        "data-testid": "analysis-lane-ruler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 0.75rem 0.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text
        }
    }, t('patient.tabs.visits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(a.encounters.length), " ", t('patient.encounter'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: plotRef,
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cPdQE.default), {
        width: plotWidth,
        scale: scale,
        ticks: a.ticks,
        formatTick: (ms)=>(0, $aa3ffb82ad5c03f7$export$57a214e89a3308a1)(ms, fmt),
        nowAt: a.now,
        markers: encounterMarks,
        height: 50
    }))), a.events.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
        title: t('patient.analysis.events'),
        sub: t('patient.analysis.legend'),
        testId: "analysis-lane-events",
        state: "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cLQXb.default), {
        width: plotWidth,
        scale: scale,
        events: eventMarks,
        rows: 2,
        rowHeight: 22,
        ticks: a.ticks,
        nowAt: a.now,
        showLabels: false
    }))), medRowsInWindow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
        title: t('visit.rx.medications'),
        // At phone width most bars are too narrow to carry their own label, so
        // the kit drops it rather than clipping it — which would leave a bar
        // with no identity at all. The names ride the header instead, in the
        // same top-to-bottom order as the rows beneath.
        sub: medRowsInWindow.map((r)=>r.label).join(" \xb7 "),
        testId: "analysis-lane-meds",
        state: "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ctU9L.default), {
        width: plotWidth,
        scale: scale,
        rows: medRowsInWindow,
        rowHeight: 24,
        ticks: a.ticks,
        nowAt: a.now
    }))), a.selectedMetrics.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-metrics-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
            size: 22,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noneSelected'),
        description: t('patient.analysis.allAvailableList'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-metrics-empty-cta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.pickMetrics'))
    })) : a.selectedMetrics.map((m)=>{
        const st = m.latestStatus;
        const tone = st === 'critical' ? (0, $jTCZr.CT).danger : st === 'abnormal' ? (0, $jTCZr.CT).warnInk : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
            key: m.key,
            testId: `analysis-lane-${m.key}`,
            state: "content",
            title: (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m),
            sub: [
                m.unit,
                m.refLow != null && m.refHigh != null ? t('patient.analysis.referenceRange', {
                    low: formatDigits(m.refLow),
                    high: formatDigits(m.refHigh)
                }) : null
            ].filter(Boolean).join(" \xb7 "),
            value: formatDigits(Math.round(m.latest.y * 10) / 10),
            tone: tone,
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "icon",
                type: "button",
                "aria-label": t('patient.analysis.removeFromChartAria', {
                    name: m.name
                }),
                "data-testid": `analysis-lane-remove-${m.key}`,
                onClick: ()=>a.toggleMetric(m.key),
                style: {
                    marginInlineStart: '0.25rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 15,
                "aria-hidden": true
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                direction: 'ltr'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kCQwN.default), {
            width: plotWidth,
            scale: scale,
            series: [
                {
                    id: m.key,
                    points: m.points,
                    color: (0, $jTCZr.CT).accent
                }
            ],
            refLow: m.refLow,
            refHigh: m.refHigh,
            ticks: a.ticks,
            nowAt: a.now,
            height: 86,
            formatValue: (v)=>formatDigits(Math.round(v * 10) / 10),
            emptyLabel: t('patient.analysis.noneInRange')
        })));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8de549f95d07f683$export$2e2bcd8739ae039), {
        open: rangeOpen,
        onClose: ()=>setRangeOpen(false),
        domain: a.target,
        earliest: a.earliest,
        now: a.now,
        onApply: (from, to)=>{
            a.setWindow(from, to);
            setRangeOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ea1e5b4638e5be6$export$2e2bcd8739ae039), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        groups: a.groups,
        selected: a.selected,
        cap: a.cap,
        onApply: (keys)=>{
            a.setSelection(keys);
            setPickerOpen(false);
        }
    }));
};
var $450dbe611cd068cd$export$2e2bcd8739ae039 = $450dbe611cd068cd$var$MobilePatientAnalysis;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");

var $2WFPf = parcelRequire("2WFPf");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");


var $a83Oj = parcelRequire("a83Oj");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");

var $6OGKD = parcelRequire("6OGKD");
var $chm1L = parcelRequire("chm1L");


var $jTCZr = parcelRequire("jTCZr");
// ─────────────────────────────────────────────────────────────────────────────
// «دستیار تاریخچه» on the phone — the record assistant that answers across a
// patient's visits (desktop VisitsTab's «دستیار» rail).
//
// Desktop affords a permanently visible rail because it has a spare column;
// the phone has none, so the assistant is a docked entry inside «تاریخچه
// مراجعات» that opens a full sheet. It is NOT a screen-fixed floating button:
// nothing else on this record floats, and one floating control for one section
// of one screen is chrome the doctor has to learn for a single feature.
//
// `chat` IS the session memory — it renders the thread and is replayed to the
// BFF on every turn, so a follow-up can be asked short. Same contract as
// desktop; this screen adds no billing surface of its own.
// ─────────────────────────────────────────────────────────────────────────────
const $67c1024be06ff12d$var$ASK_PATIENT_AI = `
  query AskDoctorQuestion($question: String!, $patientId: ID, $conversationHistory: [ChatTurnInput!]) {
    askDoctorQuestion(question: $question, patientId: $patientId, conversationHistory: $conversationHistory) {
      answer confidence followUpSuggestions referencedVisitIds
    }
  }
`;
const $67c1024be06ff12d$var$CONFIDENCE_KEYS = {
    high: 'visit.vitals.high',
    medium: 'credits.level.midShort',
    low: 'visit.vitals.low'
};
const $67c1024be06ff12d$var$QUICK_Q_KEYS = [
    'visit.quick.a1cTrend',
    'visit.quick.medChanges',
    'visit.quick.openOrders',
    'visit.quick.sixMonthCourse'
];
// A tappable suggestion — quick question before the first turn, follow-up after.
const $67c1024be06ff12d$var$QuickQuestion = ({ label: label, onPick: onPick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>onPick(label),
        "data-testid": testId,
        className: "w-full min-h-11 justify-start text-start whitespace-normal h-auto py-2",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary
        }
    }, label);
const $67c1024be06ff12d$export$449e370937586546 = ({ onOpen: onOpen, disabled: disabled })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onOpen,
        disabled: disabled,
        "data-testid": "patient-assistant-open",
        className: "w-full min-h-11 gap-2 justify-start",
        style: {
            borderColor: (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.35),
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.visits.askAssistant'));
};
const $67c1024be06ff12d$export$7a3c97ef8da260ee = ({ open: open, onClose: onClose, patientId: patientId, encounterCount: encounterCount = 0 })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [chat, setChat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const bodyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const seq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // A new patient is a new conversation — never carry one patient's thread over.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChat([]);
        setDraft('');
    }, [
        patientId
    ]);
    // Keep the newest turn in view. The sheet owns its own scroll, so this scrolls
    // the panel rather than the page behind it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = bodyRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        chat,
        loading,
        open
    ]);
    const ask = (raw)=>{
        const q = (raw ?? draft).trim();
        if (!q || loading) return;
        // Snapshot the thread BEFORE this turn is appended — the new question travels
        // as `question`, so replaying it here would duplicate it.
        const history = chat.filter((m)=>!m.error && m.text).map((m)=>({
                role: m.role === 'user' ? 'user' : 'assistant',
                content: m.text
            }));
        setChat((prev)=>[
                ...prev,
                {
                    id: ++seq.current,
                    role: 'user',
                    text: q
                }
            ]);
        setDraft('');
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($67c1024be06ff12d$var$ASK_PATIENT_AI, {
            question: q,
            patientId: patientId,
            conversationHistory: history
        }).then((d)=>{
            const a = d?.askDoctorQuestion || {};
            setChat((prev)=>[
                    ...prev,
                    {
                        id: ++seq.current,
                        role: 'assistant',
                        text: a.answer || t('errors.ai.noResponse'),
                        confidence: a.confidence,
                        suggestions: a.followUpSuggestions || []
                    }
                ]);
        })// Surface the real reason — a failed turn that just says «خطا» sends the
        // doctor looking for a fault that isn't theirs (credits, service down).
        .catch((e)=>setChat((prev)=>[
                    ...prev,
                    {
                        id: ++seq.current,
                        role: 'assistant',
                        error: true,
                        text: e?.extensions?.code === 'INSUFFICIENT_CREDITS' ? t('visit.copilot.notEnoughCredit') : t('visit.copilot.askError') + (e?.message ? ` \u{2014} ${e.message}` : '')
                    }
                ])).finally(()=>setLoading(false));
    };
    const state = loading ? 'loading' : chat.length ? 'content' : 'empty';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.copilot.historyAssistant')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-assistant-sheet",
        "data-state": state,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, chat.length ? t('visit.copilot.threadOpen') : t('visit.copilot.askAcrossVisits', {
        count: encounterCount
    })), chat.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 gap-1",
        disabled: loading,
        onClick: ()=>{
            setChat([]);
            setDraft('');
        },
        "data-testid": "patient-assistant-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.copilot.newThread'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: bodyRef,
        role: "log",
        "aria-live": "polite",
        "data-testid": "patient-assistant-thread",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem',
            maxHeight: '22rem',
            overflowY: 'auto'
        }
    }, chat.length === 0 && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, t('visit.copilot.quickQuestions')), $67c1024be06ff12d$var$QUICK_Q_KEYS.map((k, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($67c1024be06ff12d$var$QuickQuestion, {
            key: k,
            label: t(k),
            onPick: ask,
            testId: `patient-assistant-quick-${i}`
        }))), chat.map((m)=>m.role === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                alignSelf: 'flex-end',
                maxWidth: '85%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.CT).accent,
                color: (0, $jTCZr.CT).onAccent || '#fff',
                borderRadius: '0.875rem',
                padding: '0.5rem 0.75rem',
                fontSize: '0.75rem',
                lineHeight: 1.75
            }
        }, m.text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                alignSelf: 'flex-start',
                maxWidth: '92%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: m.error ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).surface2,
                border: `1px solid ${m.error ? (0, $jTCZr.soft)((0, $jTCZr.CT).danger, 0.3) : (0, $jTCZr.C).border}`,
                color: m.error ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.C).textSecondary,
                borderRadius: '0.875rem',
                padding: '0.5rem 0.75rem',
                fontSize: '0.75rem',
                lineHeight: 1.75,
                whiteSpace: 'pre-wrap'
            }
        }, !m.error && $67c1024be06ff12d$var$CONFIDENCE_KEYS[String(m.confidence).toLowerCase()] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).accentInk,
                marginBottom: '0.25rem'
            }
        }, t('visit.copilot.confidence'), " ", t($67c1024be06ff12d$var$CONFIDENCE_KEYS[String(m.confidence).toLowerCase()])), m.text), m.suggestions?.length > 0 && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 700
            }
        }, t('visit.copilot.continue')), m.suggestions.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($67c1024be06ff12d$var$QuickQuestion, {
                key: i,
                label: q,
                onPick: ask,
                testId: `patient-assistant-followup-${i}`
            }))))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-assistant-typing",
        "aria-label": t('visit.copilot.typing'),
        style: {
            alignSelf: 'flex-start',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.875rem',
            padding: '0.5rem 0.875rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, "\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        value: draft,
        onChange: (e)=>setDraft(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') ask();
        },
        placeholder: chat.length ? t('visit.copilot.nextQuestion') : t('visit.copilot.askHistory'),
        disabled: loading,
        "data-testid": "patient-assistant-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: "min-h-11 shrink-0 bg-gradient-brand",
        disabled: loading || !draft.trim(),
        onClick: ()=>ask(),
        "aria-label": t('visit.copilot.send'),
        "data-testid": "patient-assistant-send"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 16,
        "aria-hidden": true
    })))));
};





var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f2114e9cca6c57fd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 21h8",
            key: "1jsn5i"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ],
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ]
];
const $f2114e9cca6c57fd$export$2e2bcd8739ae039 = (0, $9QBug.default)("pencil-line", $f2114e9cca6c57fd$export$3efd853dbb351e94);


var $6OGKD = parcelRequire("6OGKD");
var $bo0GS = parcelRequire("bo0GS");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $e317r = parcelRequire("e317r");





function $5f64ac416f593a18$export$2e2bcd8739ae039({ visit: visit, patientId: patientId, insurance: insurance, mine: mine, hasLines: hasLines, onChanged: onChanged, testid: testid = 'history-erx', style: style }) {
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const { t: t } = (0, $LNQP4.default)();
    const iranian = (0, $e317r.useIranianRails)();
    const eligible = !!(visit?.id && patientId && mine && hasLines && iranian && !(0, $a044c29e4a6b3520$export$9cbdfdc6daea18e2)(visit));
    const { status: status, reload: reload } = (0, $5d2858db85b3973f$export$2eef96f829c6b514)({
        appointmentId: visit?.id,
        patientId: patientId,
        active: eligible
    });
    const [open, setOpen] = (0, $acw62.useState)(false);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        reload();
        onChanged?.();
    }, [
        reload,
        onChanged
    ]);
    if (!eligible || !status?.enabled) return null;
    const sent = !!(0, $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7)(status);
    if (sent && !(0, $2c5a3cdef49d8209$export$f71c8410924ea136)(status)) {
        const why = status.final ? t('visit.erx.correction.unavailable.FINAL') : t('visit.erx.correction.unavailable.EXPIRED');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: style
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testid}-registered`,
            "data-state": "registered",
            title: why,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                fontSize: 11.5,
                fontWeight: 600,
                padding: '3px 9px',
                borderRadius: 999,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
            size: 13,
            "aria-hidden": true
        }), t('visit.historyErx.registered')));
    }
    const label = sent ? t('visit.historyErx.correct') : t('visit.historyErx.send');
    // `style` places it (the caller's row); nothing is drawn while it is hidden.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: sent ? 'subtle' : 'default',
        size: "sm",
        // 44 px on a phone (it was 36 — PM-0137 c); the desktop row keeps its compact size.
        className: isMobile ? 'min-h-11 gap-1.5' : 'gap-1.5',
        onClick: (e)=>{
            e.stopPropagation();
            setOpen(true);
        },
        "data-testid": testid,
        "data-state": sent ? 'registered' : 'send'
    }, sent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2114e9cca6c57fd$export$2e2bcd8739ae039), {
        size: 13,
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13,
        "aria-hidden": true
    }), label), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $49c99466dee6cafa$export$2e2bcd8739ae039), {
        visit: visit,
        patientId: patientId,
        insurer: (0, $ace44487380106d3$export$e4f91298b6c5a0f0)(insurance),
        mode: sent ? 'correct' : 'send',
        onClose: close
    }));
}




const $e99e18a7ba5d97dc$var$LIST_ORDERS_ENC = `query ListDoctorOrdersEnc($patientId:ID!,$appointmentId:ID){listDoctorOrders(patientId:$patientId,appointmentId:$appointmentId){id appointmentId orderType name code urgency status notes createdAt performedDate}}`;
// amendClinicalNote (unlike updateClinicalNote, the in-visit autosave) is
// attributed to the calling doctor server-side: the prior content is snapshotted
// into the revision history and updatedAt is stamped.
const $e99e18a7ba5d97dc$var$AMEND_CLINICAL_NOTE = `mutation AmendClinicalNote($id:ID!,$input:UpdateClinicalNoteInput!){amendClinicalNote(id:$id,input:$input){id content updatedAt}}`;
// First post-visit save on a visit that never got a SOAP row: a plain create —
// there is no prior content, so correctly no revision either.
const $e99e18a7ba5d97dc$var$CREATE_SOAP_NOTE = `mutation CreateClinicalNote($patientId:ID!,$input:ClinicalNoteInput!){createClinicalNote(patientId:$patientId,input:$input){id content createdAt updatedAt}}`;
const $e99e18a7ba5d97dc$var$CLINICAL_NOTE_REVISIONS = `query ClinicalNoteRevisions($appointmentId:ID!){clinicalNoteRevisions(appointmentId:$appointmentId){id noteId editedBy editedAt content}}`;
// «تاریخچه مراجعات» — the encounter history as a stack of expandable cards.
// Tapping a card opens its workspace: SOAP notes, this-visit diagnoses,
// medications and orders (orders fetched lazily on first open). A live visit is
// ringed in teal.
//
// This is the record's CORRECTION rail, not a charting surface: a finished
// visit's SOAP can be amended here (attributed, with a revision trail), but a
// live visit's note belongs to the Visit page and is read-only here — the same
// gate the desktop rail applies.
const $e99e18a7ba5d97dc$var$InnerEmpty = ({ text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                opacity: 0.4
            }
        }, "\u2014"),
        title: text,
        style: {
            padding: '1.5rem 1rem'
        }
    });
const $e99e18a7ba5d97dc$var$SoapSectionShell = ({ letter: letter, name: name, action: action, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.625rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.C).bg,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.375rem',
            height: '1.375rem',
            borderRadius: '0.375rem',
            background: (0, $jTCZr.CT).accentSoft,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }, letter), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, name), action), children);
const $e99e18a7ba5d97dc$var$MobilePatientVisits = ({ p: p, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [openId, setOpenId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [innerTab, setInnerTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('soap');
    const [encOrders, setEncOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [loadingOrders, setLoadingOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [orderErr, setOrderErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [assistantOpen, setAssistantOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ── post-visit SOAP amendment ───────────────────────────────────────────────
    const [editingId, setEditingId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [soapDraft, setSoapDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        S: '',
        O: '',
        A: '',
        P: ''
    });
    const [savingSoap, setSavingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapSaveError, setSoapSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Saves are reflected without refetching the whole patient: an overlay of
    // {noteId: {content, updatedAt}} plus any notes created from this section.
    const [noteOverlay, setNoteOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [createdNotes, setCreatedNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [historyId, setHistoryId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [revisions, setRevisions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null = not fetched yet
    const [expandedRevId, setExpandedRevId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const myDoctorId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a83Oj.parseJwt)((0, $a83Oj.getToken)() || '')?.sub || null, []);
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.encounters || []
        ].sort((a, b)=>(b.scheduledDate || b.createdAt || '').localeCompare(a.scheduledDate || a.createdAt || '')), [
        p.encounters
    ]);
    // The record's notes with this section's own saves folded in.
    const allNotes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.clinicalNotes || [],
            ...createdNotes
        ].map((n)=>noteOverlay[n.id] ? {
                ...n,
                ...noteOverlay[n.id]
            } : n), [
        p.clinicalNotes,
        createdNotes,
        noteOverlay
    ]);
    const fetchOrders = (id)=>{
        setLoadingOrders((prev)=>({
                ...prev,
                [id]: true
            }));
        setOrderErr((prev)=>({
                ...prev,
                [id]: false
            }));
        (0, $adebb901af88e18b$export$7fb4864174f056c)($e99e18a7ba5d97dc$var$LIST_ORDERS_ENC, {
            patientId: patientId,
            appointmentId: id
        }).then((d)=>setEncOrders((prev)=>({
                    ...prev,
                    [id]: d.listDoctorOrders || []
                }))).catch(()=>setOrderErr((prev)=>({
                    ...prev,
                    [id]: true
                }))).finally(()=>setLoadingOrders((prev)=>({
                    ...prev,
                    [id]: false
                })));
    };
    const closeEditUi = ()=>{
        // Collapsing or switching visits drops the edit/history UI state, never the
        // saves — those live in the overlay.
        setEditingId(null);
        setSoapSaveError('');
        setHistoryId(null);
        setRevisions(null);
        setExpandedRevId(null);
    };
    const toggle = (id)=>{
        closeEditUi();
        if (openId === id) {
            setOpenId(null);
            return;
        }
        setOpenId(id);
        setInnerTab('soap');
        if (!encOrders[id] && !loadingOrders[id]) fetchOrders(id);
    };
    const startSoapEdit = (encId, encNotes)=>{
        setSoapDraft((0, $a044c29e4a6b3520$export$41de64d84beb8926)(encNotes));
        setSoapSaveError('');
        setHistoryId(null);
        setEditingId(encId);
    };
    const refreshRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((encId)=>{
        (0, $adebb901af88e18b$export$7fb4864174f056c)($e99e18a7ba5d97dc$var$CLINICAL_NOTE_REVISIONS, {
            appointmentId: encId
        }).then((d)=>setRevisions(d?.clinicalNoteRevisions || [])).catch(()=>setRevisions([]));
    }, []);
    const toggleHistory = (encId)=>{
        if (historyId === encId) {
            setHistoryId(null);
            return;
        }
        setHistoryId(encId);
        setExpandedRevId(null);
        if (revisions === null) refreshRevisions(encId);
    };
    const saveSoapEdit = async (encId, note)=>{
        if (savingSoap) return;
        setSavingSoap(true);
        setSoapSaveError('');
        const content = {
            s: soapDraft.S,
            o: soapDraft.O,
            a: soapDraft.A,
            p: soapDraft.P
        };
        try {
            if (note) {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($e99e18a7ba5d97dc$var$AMEND_CLINICAL_NOTE, {
                    id: note.id,
                    input: {
                        content: content
                    }
                });
                const saved = d?.amendClinicalNote;
                if (saved) setNoteOverlay((prev)=>({
                        ...prev,
                        [note.id]: {
                            content: saved.content,
                            updatedAt: saved.updatedAt || note.updatedAt
                        }
                    }));
                // An open history panel must show the newly recorded revision.
                if (revisions !== null) refreshRevisions(encId);
            } else {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($e99e18a7ba5d97dc$var$CREATE_SOAP_NOTE, {
                    patientId: patientId,
                    input: {
                        noteType: 'SOAP_NOTE',
                        content: content,
                        authorRole: 'doctor',
                        appointmentId: encId
                    }
                });
                const created = d?.createClinicalNote;
                if (created) setCreatedNotes((prev)=>[
                        ...prev,
                        {
                            ...created,
                            appointmentId: encId,
                            noteType: 'SOAP_NOTE'
                        }
                    ]);
            }
            setEditingId(null);
        } catch (e) {
            // Inline, not a toast: the draft stays on screen and editable so nothing
            // typed is lost while the doctor retries (§11).
            setSoapSaveError(e?.message || t('errors.save.edit'));
        } finally{
            setSavingSoap(false);
        }
    };
    if (!encounters.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fX0JO.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.empty.noEncounters')
    }));
    const INNER_TABS = (encConds, encMeds, orders)=>[
            {
                id: 'soap',
                label: 'SOAP'
            },
            {
                id: 'conds',
                label: encConds.length ? t('patient.visits.condsWithCount', {
                    count: encConds.length
                }) : t('patient.tabs.conditions')
            },
            {
                id: 'meds',
                label: encMeds.length ? t('patient.visits.medsWithCount', {
                    count: encMeds.length
                }) : t('patient.tabs.medications')
            },
            {
                id: 'orders',
                label: orders.length ? t('patient.visits.ordersWithCount', {
                    count: orders.length
                }) : t('visit.tabs.orders')
            }
        ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $67c1024be06ff12d$export$449e370937586546), {
        onOpen: ()=>setAssistantOpen(true)
    }), encounters.map((enc)=>{
        const isOpen = openId === enc.id;
        const encConds = (p.clinicalConditions || []).filter((c)=>c.appointmentId === enc.id);
        const encMeds = (p.clinicalMedications || []).filter((m)=>m.appointmentId === enc.id);
        const encNotes = allNotes.filter((n)=>n.appointmentId === enc.id);
        const summary = encNotes.find((0, $a044c29e4a6b3520$export$7be7553f2fdf281));
        const orders = encOrders[enc.id] || [];
        const live = (0, $a044c29e4a6b3520$export$9cbdfdc6daea18e2)(enc);
        const soapNote = (0, $a044c29e4a6b3520$export$b26efe9e640f95c2)(encNotes);
        const soapUpdatedAt = soapNote?.updatedAt || null;
        const isEditing = editingId === enc.id;
        // Amendment is a post-visit affordance only — a live visit's SOAP belongs
        // to the Visit page. Charting stays there; this is the correction rail.
        const canEdit = !live;
        const hasSoap = (0, $a044c29e4a6b3520$export$be3e5596841df79)(encNotes);
        const extraNotes = (0, $a044c29e4a6b3520$export$3389fc0b000be7e3)(encNotes);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: enc.id,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.75rem',
                border: `1px solid ${live ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggle(enc.id),
            "aria-expanded": isOpen,
            "data-testid": `visit-toggle-${enc.id}`,
            className: "w-full h-auto min-h-11 justify-start gap-2.5 rounded-none px-4 py-3 text-start hover:bg-transparent"
        }, live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                marginBottom: '0.25rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $bf42e0131d395ab7$export$e06a38df942076e8)[enc.type] ? t((0, $bf42e0131d395ab7$export$e06a38df942076e8)[enc.type]) : enc.type || t('patient.visit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: live ? 'teal' : 'muted'
        }, (0, $bf42e0131d395ab7$export$74eff50fc31aba23)[enc.status] ? t((0, $bf42e0131d395ab7$export$74eff50fc31aba23)[enc.status]) : enc.status || "\u2014")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 400,
                flexWrap: 'wrap'
            }
        }, (enc.scheduledDate || enc.createdAt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $652abbe9694ab398$export$372861cd7d55d715)(enc.scheduledDate || enc.createdAt, formatDate)), encConds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(encConds.length), " ", t('patient.conditions.one')), encMeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(encMeds.length), " ", t('patient.meds.one')), orders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(orders.length), " ", t('patient.orderType.procedure')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 16,
            strokeWidth: 2,
            "aria-hidden": true,
            style: {
                flexShrink: 0,
                color: (0, $jTCZr.C).textMuted,
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                transition: 'transform .2s'
            }
        })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                borderTop: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f64ac416f593a18$export$2e2bcd8739ae039), {
            style: {
                display: 'flex',
                padding: '0.625rem 1rem',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            },
            visit: enc,
            patientId: patientId,
            insurance: p.insurance,
            mine: !!myDoctorId && enc.doctorId === myDoctorId,
            hasLines: encMeds.length + orders.length > 0,
            onChanged: ()=>{
                onRefresh?.();
                fetchOrders(enc.id);
            },
            testid: `history-erx-${enc.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                overflowX: 'auto',
                scrollbarWidth: 'none',
                background: (0, $jTCZr.C).bg,
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, INNER_TABS(encConds, encMeds, orders).map((item)=>{
            const on = innerTab === item.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                key: item.id,
                variant: "ghost",
                onClick: ()=>setInnerTab(item.id),
                role: "tab",
                "aria-selected": on,
                "data-testid": `visit-inner-${enc.id}-${item.id}`,
                className: "h-auto min-h-11 rounded-none px-3.5 py-2.5 shrink-0 hover:bg-transparent",
                style: {
                    fontSize: '0.75rem',
                    fontWeight: on ? 700 : 500,
                    color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textMuted,
                    borderBottom: on ? `2px solid ${(0, $jTCZr.CT).accent}` : '2px solid transparent'
                }
            }, item.label);
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0.875rem 1rem'
            }
        }, innerTab === 'soap' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visits-soap-${enc.id}`,
            "data-state": isEditing ? 'editing' : hasSoap ? 'content' : 'empty',
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.625rem'
            }
        }, summary && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.CT).accentSoft,
                borderRadius: '0.625rem',
                padding: '0.75rem 0.875rem',
                border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.2)}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).accentInk,
                marginBottom: '0.375rem'
            }
        }, t('credits.price.summary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2,
                lineHeight: 1.75,
                whiteSpace: 'pre-wrap'
            }
        }, (0, $a044c29e4a6b3520$export$90858b03e74b9658)(summary.content).text || (0, $a044c29e4a6b3520$export$9329abe70f8a78fc)(summary))), (hasSoap || isEditing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, soapUpdatedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: "muted",
            style: {
                fontWeight: 600
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `visits-soap-edited-${enc.id}`
        }, t('patient.visits.soapEditedAt', {
            date: (0, $a044c29e4a6b3520$export$320c8a0e29298519)(soapUpdatedAt)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginInlineStart: 'auto',
                display: 'flex',
                gap: '0.25rem'
            }
        }, soapUpdatedAt && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "min-h-11 gap-1",
            onClick: ()=>toggleHistory(enc.id),
            "data-testid": `visits-soap-history-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c3425eadfb41de5$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }), " ", t('patient.visits.editHistory')), canEdit && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11 gap-1",
            onClick: ()=>startSoapEdit(enc.id, encNotes),
            "data-testid": `visits-soap-edit-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('common.actions.edit')))), isEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, t('patient.visits.editSoapHint')), (0, $bf42e0131d395ab7$export$f3254cc21757d13e).map((sec)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$SoapSectionShell, {
                key: sec.k,
                letter: sec.k,
                name: t(sec.nameKey)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    padding: '0.5rem 0.625rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
                value: soapDraft[sec.k] || '',
                onChange: (e)=>{
                    const v = e.target.value;
                    setSoapDraft((prev)=>({
                            ...prev,
                            [sec.k]: v
                        }));
                },
                rows: 3,
                "data-testid": `visits-soap-field-${enc.id}-${sec.k}`
            })))), soapSaveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visits-soap-error-${enc.id}`,
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).dangerInk,
                background: (0, $jTCZr.CT).dangerSoft,
                borderRadius: '0.5rem',
                padding: '0.5rem 0.625rem'
            }
        }, t('patient.visits.soapSaveError'), " \u2014 ", soapSaveError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "lg",
            className: "flex-1 min-h-11",
            disabled: savingSoap,
            onClick: ()=>{
                setEditingId(null);
                setSoapSaveError('');
            },
            "data-testid": `visits-soap-cancel-${enc.id}`
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "lg",
            className: "flex-1 min-h-11 bg-gradient-brand font-bold",
            disabled: savingSoap,
            onClick: ()=>saveSoapEdit(enc.id, soapNote),
            "data-testid": `visits-soap-save-${enc.id}`
        }, savingSoap ? t('common.state.saving') : t('common.actions.save')))) : (0, $bf42e0131d395ab7$export$f3254cc21757d13e).map((sec)=>{
            const text = (0, $a044c29e4a6b3520$export$e6f6e37795c24083)(encNotes, sec.k);
            if (!text) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$SoapSectionShell, {
                key: sec.k,
                letter: sec.k,
                name: t(sec.nameKey)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    padding: '0.625rem 0.75rem',
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.75,
                    whiteSpace: 'pre-wrap'
                }
            }, text));
        }), historyId === enc.id && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visits-soap-history-panel-${enc.id}`,
            "data-state": revisions === null ? 'loading' : revisions.length ? 'content' : 'empty',
            style: {
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: '0.5rem'
            }
        }, t('patient.visits.editHistory')), revisions === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 2,
            height: 11,
            lastWidth: "45%"
        }), revisions !== null && !revisions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, t('patient.visits.noRevisions')), (revisions || []).map((rev)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: rev.id,
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: '0.375rem',
                    marginTop: '0.375rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: ()=>setExpandedRevId(expandedRevId === rev.id ? null : rev.id),
                "aria-expanded": expandedRevId === rev.id,
                "data-testid": `visits-revision-${rev.id}`,
                className: "w-full h-auto min-h-11 justify-start gap-2 rounded-none px-0 hover:bg-transparent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, (0, $a044c29e4a6b3520$export$320c8a0e29298519)(rev.editedAt)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, rev.editedBy && rev.editedBy === myDoctorId ? t('patient.visits.editedByYou') : rev.editedBy || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
                size: 14,
                "aria-hidden": true,
                style: {
                    marginInlineStart: 'auto',
                    color: (0, $jTCZr.C).textMuted,
                    transform: expandedRevId === rev.id ? 'rotate(180deg)' : 'rotate(0)'
                }
            })), expandedRevId === rev.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.375rem',
                    paddingBottom: '0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.625rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, t('patient.visits.priorVersion')), (0, $bf42e0131d395ab7$export$f3254cc21757d13e).map((sec)=>{
                const c = (0, $a044c29e4a6b3520$export$90858b03e74b9658)(rev.content);
                const lk = sec.k.toLowerCase();
                const txt = typeof c[lk] === 'string' && c[lk].trim() ? c[lk] : typeof c[sec.k] === 'string' ? c[sec.k] : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: sec.k,
                    style: {
                        fontSize: '0.6875rem',
                        lineHeight: 1.75
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).accentInk
                    }
                }, sec.k, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: txt ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).textMuted,
                        whiteSpace: 'pre-wrap'
                    }
                }, txt || t('patient.obs.notRecorded')));
            }))))), extraNotes.map((n, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: n.id || i,
                style: {
                    borderRadius: '0.625rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    padding: '0.625rem 0.75rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.3125rem'
                }
            }, (0, $bf42e0131d395ab7$export$fe67f05a766290fd)[n.noteType] ? t((0, $bf42e0131d395ab7$export$fe67f05a766290fd)[n.noteType]) : n.noteType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.75,
                    whiteSpace: 'pre-wrap'
                }
            }, (0, $a044c29e4a6b3520$export$9329abe70f8a78fc)(n)))), !summary && !hasSoap && !extraNotes.length && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('visit.empty.noNoteForEncounter')
        }), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "lg",
            className: "w-full min-h-11 gap-1",
            onClick: ()=>startSoapEdit(enc.id, encNotes),
            "data-testid": `visits-soap-add-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.visits.addSoapNote')))), innerTab === 'conds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, !encConds.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('patient.conditions.none')
        }), encConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: c.id || i,
                style: {
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    flexWrap: 'wrap'
                }
            }, i === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
                tone: "teal"
            }, t('visit.dx.primary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, c.display || c.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    gap: '0.375rem',
                    marginTop: '0.25rem',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }
            }, c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
                tone: "navy"
            }, c.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: c.clinicalStatus === 'active' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
                    fontWeight: 600
                }
            }, (0, $bf42e0131d395ab7$export$eb40f3474cc5e6d5)[c.clinicalStatus] ? t((0, $bf42e0131d395ab7$export$eb40f3474cc5e6d5)[c.clinicalStatus]) : c.clinicalStatus), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
                cond: c
            }))))), innerTab === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, !encMeds.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('patient.meds.none')
        }), encMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: m.id || i,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem',
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                size: 16,
                color: (0, $jTCZr.C).navy,
                "aria-hidden": true,
                style: {
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                dir: "auto",
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m)), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginTop: '0.125rem'
                }
            }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    color: m.status === 'active' ? (0, $jTCZr.CT).good : (0, $jTCZr.C).textMuted
                }
            }, (0, $bf42e0131d395ab7$export$8bd836c94e04bf93)[m.status] ? t((0, $bf42e0131d395ab7$export$8bd836c94e04bf93)[m.status]) : m.status || "\u2014")))), innerTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, loadingOrders[enc.id] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 2,
            height: 12,
            lastWidth: "55%",
            style: {
                padding: '0.5rem 0'
            }
        }), !loadingOrders[enc.id] && orderErr[enc.id] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'center',
                padding: '1.25rem 1rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).dangerInk,
                marginBottom: '0.625rem'
            }
        }, t('visit.orders.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11",
            onClick: ()=>fetchOrders(enc.id),
            "data-testid": `visit-orders-retry-${enc.id}`
        }, t('common.actions.retry'))), !loadingOrders[enc.id] && !orderErr[enc.id] && !orders.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('visit.orders.noneRecordedShort')
        }), orders.map((o, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: o.id || i,
                style: {
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: '0.3125rem'
                }
            }, o.name || o.code || "\u2014"), o.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.3125rem'
                }
            }, o.notes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    gap: '0.375rem',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                }
            }, o.orderType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
                tone: "navy"
            }, (0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[o.orderType] ? t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[o.orderType]) : o.orderType), o.urgency && o.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
                tone: "amber"
            }, o.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
                tone: (0, $bf42e0131d395ab7$export$4db6aab28b3b7a99)[o.status] || 'muted'
            }, (0, $bf42e0131d395ab7$export$4a1cfa27d42d8e0c)[o.status] ? t((0, $bf42e0131d395ab7$export$4a1cfa27d42d8e0c)[o.status]) : o.status || "\u2014"))))))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $67c1024be06ff12d$export$7a3c97ef8da260ee), {
        open: assistantOpen,
        onClose: ()=>setAssistantOpen(false),
        patientId: patientId,
        encounterCount: encounters.length
    }));
};
var $e99e18a7ba5d97dc$export$2e2bcd8739ae039 = $e99e18a7ba5d97dc$var$MobilePatientVisits;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");


var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");
var $chm1L = parcelRequire("chm1L");





parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $lffTJ = parcelRequire("lffTJ");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $lpOUO = parcelRequire("lpOUO");




var $acw62 = parcelRequire("acw62");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $6ad2538fee34d7d1$export$db6b977dd1b3391f(dirty, onClose) {
    const [asking, setAsking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Read through refs so `requestClose` keeps one identity for the life of the
    // sheet: it is handed to `BottomSheet`'s `onClose`, and a changing identity
    // there re-runs the sheet's own history and focus effects on every keystroke.
    const dirtyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(dirty);
    dirtyRef.current = dirty;
    const onCloseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onClose);
    onCloseRef.current = onClose;
    const requestClose = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!dirtyRef.current) {
            onCloseRef.current?.();
            return;
        }
        setAsking(true);
    }, []);
    const discard = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setAsking(false);
        onCloseRef.current?.();
    }, []);
    return {
        requestClose: requestClose,
        asking: asking,
        guard: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6ad2538fee34d7d1$export$2e2bcd8739ae039, {
            open: asking,
            onDiscard: discard,
            onKeepEditing: ()=>setAsking(false)
        })
    };
}
function $6ad2538fee34d7d1$export$2e2bcd8739ae039({ open: open, onDiscard: onDiscard, onKeepEditing: onKeepEditing }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onKeepEditing?.();
        },
        title: t('common.unsaved.title'),
        message: t('common.unsaved.body'),
        confirmLabel: t('common.unsaved.discard'),
        cancelLabel: t('common.unsaved.keepEditing'),
        destructive: true,
        onConfirm: onDiscard
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// Patient-record sheets — every task/overlay is the kit BottomSheet (§6), every
// field a kit input (≥1rem font ⇒ no iOS zoom), every action the kit Button.
// RecordFormSheet & ObservationDetailSheet are presentational (events via callbacks);
// EditPatientSheet is a self-contained editor. Destructive rows never delete
// inline — they ask the parent, which raises a ConfirmDialog (§6).
// ─────────────────────────────────────────────────────────────────────────────
const $9bde5d8958d2209d$var$primaryCta = 'w-full min-h-11 bg-gradient-brand font-extrabold';
const $9bde5d8958d2209d$export$a89d1549ab715ef1 = ({ open: open, title: title, fields: fields, onSave: onSave, onClose: onClose, saving: saving, submitLabel: submitLabel })=>{
    const { t: t } = (0, $LNQP4.default)();
    const submitLabelText = submitLabel ?? t('common.actions.save');
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const init = {};
        fields.forEach((f)=>{
            init[f.key] = f.default || '';
        });
        setForm(init);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const set = (k)=>(e)=>setForm((f)=>({
                    ...f,
                    [k]: e.target.value
                }));
    // Dirty = anything typed that the schema did not put there. A sheet opened by
    // mistake still shuts in one tap; a half-written medication asks first —
    // `onClose` was unconditional, and on a phone the sheet has four dismissals
    // including an accidental edge-swipe.
    const dirty = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.some((f)=>(form[f.key] ?? '') !== (f.default || '')), [
        form,
        fields
    ]);
    const { requestClose: requestClose, guard: guard } = (0, $6ad2538fee34d7d1$export$db6b977dd1b3391f)(dirty, onClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: title,
        closeLabel: t('common.actions.close')
    }, guard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, fields.map((f)=>f.type === 'select' ? // A schema that omits `placeholder` would otherwise land on the
        // framework's own Persian default, which no language switch reaches.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            options: f.options || [],
            placeholder: f.placeholder ?? t('common.actions.select')
        }) : f.type === 'textarea' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            placeholder: f.placeholder,
            rows: 4
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            placeholder: f.placeholder,
            type: f.type || 'text',
            dir: f.type === 'date' ? 'ltr' : 'rtl'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: $9bde5d8958d2209d$var$primaryCta,
        disabled: saving,
        onClick: ()=>onSave(form),
        "data-testid": "record-sheet-save"
    }, saving ? t('common.state.saving') : submitLabelText)));
};
const $9bde5d8958d2209d$export$4fa2d36987272d1b = ({ test: test, onClose: onClose, onDeleteRequest: onDeleteRequest })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!test) return null;
    const readings = [
        ...test.readings
    ].sort((a, b)=>(b.date || '').localeCompare(a.date || ''));
    const last = readings[0];
    const abn = (v)=>[
            'abnormal',
            'ABNORMAL',
            'critical',
            'CRITICAL'
        ].includes(v);
    const isAbn = abn(last?.status);
    const points = test.readings.slice(-8).map((r)=>r.value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!test,
        onClose: onClose,
        title: test.display,
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '2.5rem',
            fontWeight: 800,
            color: isAbn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
            lineHeight: 1
        }
    }, last?.value != null ? formatDigits(last.value) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.25rem'
        }
    }, test.unit || ''), isAbn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-block',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).dangerInk,
            background: (0, $jTCZr.CT).dangerSoft,
            padding: '0.1875rem 0.625rem',
            borderRadius: '0.75rem',
            marginTop: '0.375rem'
        }
    }, t('patient.obs.outOfRange'))), points.length >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '1rem',
            padding: '0.75rem',
            background: (0, $jTCZr.C).bg,
            borderRadius: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 260,
        height: 48,
        tone: isAbn ? 'danger' : 'accent'
    })), readings.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '0.5rem'
        }
    }, t('patient.obs.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, readings.map((r, i)=>{
        const prev = readings[i + 1];
        const dlt = prev && !Number.isNaN(parseFloat(r.value)) && !Number.isNaN(parseFloat(prev.value)) ? parseFloat(r.value) - parseFloat(prev.value) : null;
        const rAbn = abn(r.status);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: r.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.625rem 0.75rem',
                background: (0, $jTCZr.C).bg,
                borderRadius: '0.5625rem',
                border: `1px solid ${rAbn ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $652abbe9694ab398$export$372861cd7d55d715)(r.date, formatDate) || "\u2014"), dlt != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 600,
                color: dlt > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good
            }
        }, dlt > 0 ? "\u25B2" : "\u25BC", formatDigits(Math.abs(dlt).toFixed(1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 700,
                color: rAbn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
                minWidth: '3rem',
                textAlign: 'end'
            }
        }, formatDigits(r.value), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 400,
                color: (0, $jTCZr.C).textMuted
            }
        }, test.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('patient.obs.deleteValueShort'),
            "data-testid": `observations-reading-delete-${r.id}`,
            onClick: ()=>onDeleteRequest?.(r)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
            size: 14,
            "aria-hidden": true
        })));
    }))));
};
const $9bde5d8958d2209d$export$9bd51fc9a60d7978 = ({ file: file, onClose: onClose, onPreview: onPreview, onDeleteRequest: onDeleteRequest })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!file) return null;
    const rows = (0, $bced050439dec003$export$ebcae889d05cbae5)(file.ocrContent);
    // A narrative report parses into `raw` rows only — it is prose, and reads as
    // prose, not as a one-cell-per-sentence table.
    const structured = (0, $bced050439dec003$export$c2a61e046b7fd3b2)(rows);
    const hasContent = !!file.ocrContent;
    const th = {
        textAlign: 'start',
        fontSize: '0.625rem',
        fontWeight: 700,
        color: (0, $jTCZr.C).textMuted,
        background: (0, $jTCZr.CT).surface2,
        padding: '0.375rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.C).border}`
    };
    const td = {
        padding: '0.375rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
        color: (0, $jTCZr.C).textSecondary
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!file,
        onClose: onClose,
        title: t('patient.files.detailTitle')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-detail-sheet",
        "data-state": hasContent ? 'content' : 'empty',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            wordBreak: 'break-word',
            textAlign: 'start'
        }
    }, file.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: '0.25rem'
        }
    }, file.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, (0, $652abbe9694ab398$export$372861cd7d55d715)(file.createdAt)), structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
        tone: "muted"
    }, t('patient.files.testCount', {
        count: formatDigits(rows.filter((r)=>r.testName).length)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "w-full min-h-11 gap-2",
        "data-testid": "files-detail-preview",
        onClick: ()=>onPreview?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $272fea46916dddb1$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.files.viewImage')), structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "files-detail-table",
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.6875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.orderType.lab')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('patient.obs.result')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.obs.referenceRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.status')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>{
        if (r.raw) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 4,
            style: {
                ...td,
                color: (0, $jTCZr.C).textMuted
            }
        }, r.raw));
        const crit = r.status === 'critical';
        const abnormal = r.status !== 'normal' && r.status !== 'unknown';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i,
            style: {
                background: crit ? (0, $jTCZr.CT).dangerSoft : abnormal ? (0, $jTCZr.C).amberLight : 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $jTCZr.C).textPrimary,
                fontWeight: abnormal ? 700 : 400
            }
        }, r.testName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            dir: "ltr",
            style: {
                ...td,
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums',
                fontWeight: abnormal ? 700 : 400,
                color: crit ? (0, $jTCZr.CT).danger : abnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary
            }
        }, formatDigits(r.value), " ", r.unit || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            dir: "ltr",
            style: {
                ...td,
                color: (0, $jTCZr.C).textMuted,
                textAlign: 'start'
            }
        }, r.refRange ? formatDigits(r.refRange) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, abnormal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: crit ? 'danger' : 'amber'
        }, t(crit ? 'visit.vitals.critical' : 'visit.vitals.abnormal')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$d2cf3038149dd1b5), {
            tone: "good"
        }, t('patient.obs.normal'))));
    })))), !structured && file.ocrContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.625rem 0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textAlign: 'start'
        }
    }, file.ocrContent), !hasContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('patient.empty.noContent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "w-full min-h-11 gap-2",
        style: {
            color: (0, $jTCZr.CT).danger,
            borderColor: (0, $jTCZr.CT).dangerSoft
        },
        "data-testid": "files-detail-delete",
        onClick: ()=>onDeleteRequest?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lpOUO.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.delete'))));
};
// ── Edit patient — self-contained editor over UPDATE_PATIENT ──────────────────
const $9bde5d8958d2209d$var$UPDATE_PATIENT = `mutation UpdatePatient($id: ID!, $input: UpdatePatientInput!) {
  updatePatient(id: $id, input: $input) { id name phone birthDate bloodType insurance job lastWeight height bmi status }
}`;
const $9bde5d8958d2209d$var$BLOOD_TYPES = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
];
const $9bde5d8958d2209d$var$INSURANCE_OPTS = (t)=>[
        {
            value: 'social',
            label: t('patient.insurance.social')
        },
        {
            value: 'health',
            label: t('patient.insurance.health')
        },
        {
            value: 'military',
            label: t('patient.insurance.military')
        },
        {
            value: 'other',
            label: t('patient.insurance.other')
        }
    ];
const $9bde5d8958d2209d$export$826bc793596d1870 = ({ patient: patient, open: open, onClose: onClose, onSaved: onSaved })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setErr('');
        setForm({
            name: patient.name || '',
            phone: patient.phone || '',
            birthDate: patient.birthDate || '',
            bloodType: patient.bloodType || '',
            insurance: patient.insurance || '',
            job: patient.job || '',
            height: patient.height != null ? String(patient.height) : ''
        });
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const set = (k)=>(e)=>setForm((f)=>({
                    ...f,
                    [k]: e.target.value
                }));
    // The same comparison `handleSave` makes to build its patch: if there is
    // nothing to send, there is nothing to lose by closing.
    const dirty = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>form.name !== (patient.name || '') || form.phone !== (patient.phone || '') || form.birthDate !== (patient.birthDate || '') || form.bloodType !== (patient.bloodType || '') || form.insurance !== (patient.insurance || '') || form.job !== (patient.job || '') || (form.height || '') !== (patient.height != null ? String(patient.height) : ''), [
        form,
        patient
    ]);
    const { requestClose: requestClose, guard: guard } = (0, $6ad2538fee34d7d1$export$db6b977dd1b3391f)(dirty, onClose);
    const handleSave = async ()=>{
        setSaving(true);
        setErr('');
        try {
            const u = {};
            if (form.name !== (patient.name || '')) u.name = form.name;
            if (form.phone !== (patient.phone || '')) u.phone = form.phone;
            if (form.birthDate !== (patient.birthDate || '')) u.birthDate = form.birthDate;
            if (form.bloodType !== (patient.bloodType || '')) u.bloodType = form.bloodType;
            if (form.insurance !== (patient.insurance || '')) u.insurance = form.insurance;
            if (form.job !== (patient.job || '')) u.job = form.job;
            const nh = parseFloat(form.height);
            if (!Number.isNaN(nh) && nh !== patient.height) u.height = nh;
            if (!Object.keys(u).length) {
                onClose();
                return;
            }
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($9bde5d8958d2209d$var$UPDATE_PATIENT, {
                id: patient.id,
                input: u
            });
            onSaved();
            onClose();
        } catch (e) {
            setErr(e?.message || t('errors.save.edit'));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: t('patient.edit.title'),
        closeLabel: t('common.actions.close')
    }, guard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: form.name || '',
        onChange: set('name'),
        placeholder: t('visit.patient.fullName')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: form.phone || '',
        onChange: (phone)=>setForm((f)=>({
                    ...f,
                    phone: phone
                }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.edit.birthDate'),
        value: form.birthDate || '',
        onChange: set('birthDate'),
        placeholder: "1990-01-01",
        dir: "ltr"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: form.job || '',
        onChange: set('job'),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: form.bloodType || '',
        onChange: set('bloodType'),
        options: $9bde5d8958d2209d$var$BLOOD_TYPES.map((bt)=>({
                value: bt,
                label: bt
            })),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: form.insurance || '',
        onChange: set('insurance'),
        options: $9bde5d8958d2209d$var$INSURANCE_OPTS(t),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        value: form.height || '',
        onChange: set('height'),
        placeholder: "175",
        type: "number",
        dir: "ltr"
    }), err && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger,
            fontWeight: 600
        }
    }, err), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: $9bde5d8958d2209d$var$primaryCta,
        disabled: saving,
        onClick: handleSave,
        "data-testid": "patient-edit-save"
    }, saving ? t('common.state.saving') : t('common.actions.saveChanges'))));
};




const $e797c45ee6cbcd0d$var$DELETE_OBSERVATION = `mutation DeleteObservation($id: ID!) { deleteObservation(id: $id) }`;
// «مشاهدات» — the record's measured values on the phone. Latest vitals first,
// then panel chips that filter the analyte list; each analyte taps through to a
// trend + history sheet. Deleting a reading is destructive ⇒ ConfirmDialog (§6).
// Upload adds the document and, on «بارگذاری و استخراج», reads its values for the
// doctor to review before any enters the record (useClinicalFiles).
//
// Composition only: the grouping/counting/ordering all come from
// `lib/observations`, the same module the desktop tab uses, so the two surfaces
// can never disagree about which panel a test belongs to (§1.1).
const $e797c45ee6cbcd0d$var$MobilePatientObservations = ({ p: p, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits, formatList: formatList } = (0, $LNQP4.default)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const vitals = (0, $065bc8b7ead4fbf6$export$dbab5d47820ca910)(patientId);
    const documents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bced050439dec003$export$a719a8ff130c98cb)(p.clinicalFiles || []), [
        p.clinicalFiles
    ]);
    const files = (0, $489287129a199b1d$export$513d4933d99292ab)({
        patient: {
            ...p,
            id: p.id || patientId
        },
        files: documents,
        onChanged: onRefresh
    });
    const [activeCategory, setActiveCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [detailItem, setDetailItem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pendingDelete, setPendingDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const seriesMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$1be0eaa0fb63147e)(p.clinicalObservations), [
        p.clinicalObservations
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$e4e463683289edb3)(seriesMap), [
        seriesMap
    ]);
    // `flagged` per panel is the same derivation the desktop tab's hook makes, so
    // the two surfaces cannot mark different panels as holding a bad result.
    const panels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$8020253fe86b6056)(counts).map((c)=>({
                ...c,
                flagged: (0, $00011fef9dd464cc$export$f9b3ea7266dcc489)(seriesMap, c.id)
            })), [
        counts,
        seriesMap
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (activeCategory) return;
        setActiveCategory((0, $00011fef9dd464cc$export$dbdc2bb8017e2c29)(counts));
    }, [
        counts
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const tests = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$930962f873333845)(seriesMap, activeCategory), [
        seriesMap,
        activeCategory
    ]);
    const hasAny = Object.keys(seriesMap).length > 0;
    const confirmDelete = ()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($e797c45ee6cbcd0d$var$DELETE_OBSERVATION, {
            id: pendingDelete.id
        }).then(()=>{
            setDetailItem(null);
            onRefresh();
        })// A confirmed delete that quietly fails reads as success (§7 / §14.3).
        .catch(()=>toast.error(t('patient.obs.deleteFailed')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-content",
        "data-state": hasAny ? 'content' : 'empty',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        onClick: ()=>files.openUpload(),
        "data-testid": "observations-upload",
        className: "w-full min-h-11 gap-2 bg-gradient-brand font-bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.files.uploadAndAnalyse')), !vitals.loading && !vitals.error && vitals.flagged.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "observations-out-of-range",
        style: {
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.CT).danger}`,
            borderRadius: '0.5rem',
            padding: '0.625rem 0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        }
    }, t('patient.obs.outOfRangeCount', {
        count: formatDigits(vitals.flagged.length)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatList(vitals.flagged.map((d)=>t(d.labelKey))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$a80c208d4b2a2828), {
        vitals: (0, $065bc8b7ead4fbf6$export$31957fd116297820)(vitals.byLoinc),
        testId: "observations-vitals"
    }), p.bmi != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-bmi",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.75rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
        size: 18,
        color: (0, $jTCZr.CT).accent,
        strokeWidth: 2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 600
        }
    }, t('patient.vitals.bmi')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.125rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: '1.25rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        }
    }, formatDigits(p.bmi.toFixed(1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, "kg/m\xb2"), p.lastWeight && p.height && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(p.lastWeight), " kg \xb7 ", formatDigits(p.height), " cm")))), panels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-panels",
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.375rem',
            scrollbarWidth: 'none'
        }
    }, panels.map((cat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: cat.id,
            // A flagged panel is marked with a danger dot composed into the
            // chip's own label slot — the kit has no `flagged` variant and
            // this needs no new one.
            label: cat.flagged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `observations-panel-flag-${cat.id}`,
                "aria-label": t('patient.obs.outOfRange'),
                style: {
                    width: '0.375rem',
                    height: '0.375rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).danger,
                    flexShrink: 0
                }
            }), cat.label) : cat.label,
            count: formatDigits(cat.count),
            active: activeCategory === cat.id,
            onClick: ()=>setActiveCategory(cat.id),
            "data-testid": `observations-panel-${cat.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, tests.map((test, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$a344623fbba4b280), {
            key: test.display,
            test: test,
            onOpen: ()=>setDetailItem(test),
            testId: `observations-row-${i}`
        })))), !hasAny && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "observations-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.none'),
        description: t('patient.obs.uploadHint')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9bde5d8958d2209d$export$4fa2d36987272d1b), {
        test: detailItem,
        onClose: ()=>setDetailItem(null),
        onDeleteRequest: (r)=>setPendingDelete(r)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!pendingDelete,
        onOpenChange: (o)=>{
            if (!o) setPendingDelete(null);
        },
        title: t('patient.obs.deleteValue'),
        message: t('patient.obs.deleteConfirm'),
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: confirmDelete
    }), files.overlays);
};
var $e797c45ee6cbcd0d$export$2e2bcd8739ae039 = $e797c45ee6cbcd0d$var$MobilePatientObservations;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $66joL = parcelRequire("66joL");

var $2WFPf = parcelRequire("2WFPf");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b77ca10bb12022b4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8",
            key: "14sh0y"
        }
    ],
    [
        "path",
        {
            d: "M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z",
            key: "1970lx"
        }
    ],
    [
        "path",
        {
            d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1",
            key: "l4dndm"
        }
    ]
];
const $b77ca10bb12022b4$export$2e2bcd8739ae039 = (0, $9QBug.default)("files", $b77ca10bb12022b4$export$3efd853dbb351e94);


var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $ljvFv = parcelRequire("ljvFv");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5935de03d6f5e9ca$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 18h8",
            key: "1borvv"
        }
    ],
    [
        "path",
        {
            d: "M3 22h18",
            key: "8prr45"
        }
    ],
    [
        "path",
        {
            d: "M14 22a7 7 0 1 0 0-14h-1",
            key: "1jwaiy"
        }
    ],
    [
        "path",
        {
            d: "M9 14h2",
            key: "197e7h"
        }
    ],
    [
        "path",
        {
            d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z",
            key: "1bmzmy"
        }
    ],
    [
        "path",
        {
            d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3",
            key: "1drr47"
        }
    ]
];
const $5935de03d6f5e9ca$export$2e2bcd8739ae039 = (0, $9QBug.default)("microscope", $5935de03d6f5e9ca$export$3efd853dbb351e94);


var $he6AI = parcelRequire("he6AI");







// «فایل‌ها» — the record's documents on the phone.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §8.6.
//
// The same documents, the same row and the same host (`useClinicalFiles`) as the
// workstation's tab — the queries are imported from the one contract module rather
// than copied (design F17). On the phone the overlays are sheets, the upload offers
// the camera, and the extraction review stacks its viewer above the editor.
//
// A DICOM study is a row like any document (DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md
// §24.12). On the phone «مشاهده» opens the server-rendered preview sheet, never the
// desktop diagnostic viewer (R-C6); the host decides which from the tier.
const $93d0222d1c690f96$var$CAT_ICON = {
    all: (0, $b77ca10bb12022b4$export$2e2bcd8739ae039),
    lab_report: (0, $4CVxl.default),
    imaging: (0, $6828da86e4d4e8df$export$2e2bcd8739ae039),
    ecg: (0, $ljvFv.default),
    pathology: (0, $5935de03d6f5e9ca$export$2e2bcd8739ae039),
    general: (0, $3FyOw.default)
};
const $93d0222d1c690f96$var$asRow = (f)=>f._source === 'storage' ? {
        ...f,
        canEdit: false,
        editScope: null,
        extractable: false,
        canDelete: true
    } : f;
const $93d0222d1c690f96$var$MobilePatientFiles = ({ p: p = {}, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [storageFiles, setStorageFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [filterCat, setFilterCat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [collapsedCats, setCollapsedCats] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$ef15c8f83a956e90), {
            patientId: patientId
        }).then((d)=>setStorageFiles(d.storageLabFiles || [])).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, [
        patientId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const allFiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bf42e0131d395ab7$export$f0dc803487bda7d5)(p.clinicalFiles, storageFiles).map($93d0222d1c690f96$var$asRow), [
        p.clinicalFiles,
        storageFiles
    ]);
    const refreshAll = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        load();
        onRefresh?.();
    }, [
        load,
        onRefresh
    ]);
    const files = (0, $489287129a199b1d$export$513d4933d99292ab)({
        patient: {
            ...p,
            id: p.id || patientId
        },
        files: allFiles,
        onChanged: refreshAll
    });
    const catCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bf42e0131d395ab7$export$db667ec233a83b).reduce((acc, c)=>{
            acc[c.id] = c.id === 'all' ? allFiles.length : allFiles.filter((f)=>(0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f) === c.id).length;
            return acc;
        }, {}), [
        allFiles
    ]);
    const chips = (0, $bf42e0131d395ab7$export$db667ec233a83b).filter((c)=>c.id === 'all' || catCounts[c.id] > 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (filterCat !== 'all' && !catCounts[filterCat]) setFilterCat('all');
    }, [
        catCounts,
        filterCat
    ]);
    const visibleFiles = filterCat === 'all' ? allFiles : allFiles.filter((f)=>(0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f) === filterCat);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (filterCat !== 'all') return [
            {
                id: filterCat,
                files: visibleFiles
            }
        ];
        const byCat = new Map();
        visibleFiles.forEach((f)=>{
            const id = (0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f);
            if (!byCat.has(id)) byCat.set(id, []);
            byCat.get(id).push(f);
        });
        return (0, $bf42e0131d395ab7$export$db667ec233a83b).filter((c)=>c.id !== 'all' && byCat.has(c.id)).map((c)=>({
                id: c.id,
                files: byCat.get(c.id)
            }));
    }, [
        visibleFiles,
        filterCat
    ]);
    const toggleCat = (catId)=>setCollapsedCats((prev)=>{
            const next = new Set(prev);
            if (next.has(catId)) next.delete(catId);
            else next.add(catId);
            return next;
        });
    const catLabel = (id)=>{
        const cat = (0, $bf42e0131d395ab7$export$db667ec233a83b).find((c)=>c.id === id);
        return cat ? t(cat.labelKey) : id;
    };
    const state = loading ? 'loading' : error ? 'error' : allFiles.length ? 'content' : 'empty';
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: error,
        title: t('patient.files.loadFailed'),
        onRetry: load
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-content",
        "data-state": state,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        onClick: ()=>files.openUpload(),
        "data-testid": "files-upload",
        className: "w-full min-h-11 gap-2 bg-gradient-brand font-bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile')), !loading && chips.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-categories",
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.375rem',
            scrollbarWidth: 'none'
        }
    }, chips.map((c)=>{
        const Icon = $93d0222d1c690f96$var$CAT_ICON[c.id] || (0, $3FyOw.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: c.id,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 13,
                "aria-hidden": true
            }), t(c.labelKey)),
            count: catCounts[c.id] ? formatDigits(catCounts[c.id]) : undefined,
            active: filterCat === c.id,
            onClick: ()=>setFilterCat(c.id),
            "data-testid": `files-category-${c.id}`
        });
    })), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, [
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
            key: i,
            chips: 0,
            actions: 0,
            padding: 12,
            label: t('common.state.loading')
        }))), !loading && groups.map((g)=>{
        const collapsed = collapsedCats.has(g.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.id,
            "data-testid": `files-group-${g.id}`,
            "data-state": collapsed ? 'collapsed' : 'content'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggleCat(g.id),
            "aria-expanded": !collapsed,
            "data-testid": `files-group-toggle-${g.id}`,
            className: "w-full h-auto min-h-11 justify-start gap-2 rounded-none px-0 py-1 hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $652abbe9694ab398$export$69bc41ee738923ec), null, catLabel(g.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.625rem'
            }
        }, formatDigits(g.files.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 15,
            strokeWidth: 2,
            "aria-hidden": true,
            style: {
                marginInlineStart: 'auto',
                marginBottom: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                transform: collapsed ? 'rotate(-90deg)' : 'rotate(0)',
                transition: 'transform .2s'
            }
        })), !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.75rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0 0.75rem'
            }
        }, g.files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$2e2bcd8739ae039), {
                key: `${f._source}-${f.id}`,
                file: f,
                touch: true,
                dense: true,
                testid: "files-row",
                onOpen: files.openDetail,
                onView: files.openViewer,
                onExtract: (file)=>files.openExtract(file),
                onEdit: (file)=>files.openDetail(file, {
                        edit: true
                    }),
                onDownload: files.download,
                onDelete: files.requestDelete
            }))));
    }), !loading && allFiles.length > 0 && !visibleFiles.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-category-empty",
        title: t('patient.files.noneInCategory')
    }), !loading && !allFiles.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.files.empty'),
        description: t('patient.files.emptyHint')
    }), files.overlays);
};
var $93d0222d1c690f96$export$2e2bcd8739ae039 = $93d0222d1c690f96$var$MobilePatientFiles;


// The mobile patient EHR — a drilled-into full-screen record (DESIGN-CONCEPT-
// MOBILE v2 §1.1/§3.2): the gradient MobileHeader (back to the list + the
// patient's name), the identity glance as the compact header's figures row (PM-0120), the persistent
// allergy safety strip, then the section navigator over one scrolling body.
// Composed entirely from the dedicated mobile library; behaviour comes from the
// same `usePatient` hook the desktop record uses (render-only screen, §5/§9).
//
// Section parity: the phone renders the SAME five sections as the desktop record
// (خلاصه / تحلیل / مشاهدات / تاریخچه مراجعات / فایل‌ها) — see PATIENT_SECTIONS.
// The identity facts that used to have their own «اطلاعات» section now ride the
// header's meta line, mirroring the desktop InnerPageHeader.
const $2515f4e67960210f$var$PatientDetailMobile = ({ navigate: navigate, onBack: onBack, patient: routePatient, tab: tabProp, setTab: setTab })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    // Section from the URL (screen index owns the /patients/:id/:tab navigation);
    // an unknown segment — e.g. a web-only tab id after a viewport switch — falls
    // back to the overview.
    const tab = (0, $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0)(t).some((s)=>s.id === tabProp) ? tabProp : 'overview';
    const patientId = routePatient?.patientId || routePatient?.id;
    const { patient: fullPatient, loading: loading, error: error, refresh: refresh } = (0, $ea02b2b734b36651$export$9b570c45914f833c)(patientId);
    const p = fullPatient || routePatient || {};
    const allergies = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalAllergies || p.allergies || []).filter((a)=>typeof a === 'string' ? a : a?.allergen), [
        p.clinicalAllergies,
        p.allergies
    ]);
    const isLoading = loading && !fullPatient;
    const isError = !!error && !fullPatient;
    const isMissing = isError && [
        (0, $91f57610161f2da8$export$896afd8541959ee5).NOT_FOUND,
        (0, $91f57610161f2da8$export$896afd8541959ee5).FORBIDDEN
    ].includes((0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(error));
    const contentState = isLoading ? 'loading' : isMissing ? 'missing' : isError ? 'error' : 'content';
    // Desktop parity: web/layout/PatientHeader renders age · blood · phone ·
    // insurance as the identity meta line. INSURANCE_LABEL_KEYS maps the wire
    // value to its Persian label, exactly as the desktop demographics do.
    const meta = [
        p.age != null && t('patient.ageYears', {
            count: formatDigits(p.age)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        }),
        // Same rule as the desktop header: `phone.forDisplay` before `formatDigits`, which
        // is a Persian-digit renderer and would happily print the stored `+98…`. The kit's
        // read path is landline-tolerant and falls back to the raw value, so nothing here
        // can blank.
        p.phone && t('common.labels.phone') + ' ' + formatDigits((0, $5AX1S).forDisplay(p.phone)),
        p.insurance && t('patient.insuranceLabel', {
            name: (0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance] ? t((0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance]) : p.insurance
        })
    ].filter(Boolean);
    // The header's one meta line (compact mode): the identifier first, then the
    // same facts the desktop header carries.
    const headerMeta = [
        p.nationalId && `${t('common.labels.nationalId')} ${formatDigits(p.nationalId)}`,
        ...meta
    ].filter(Boolean);
    // The glance, as the header's figures (`null` = unknown, never a dash string:
    // the strip prints «–» itself and hides when nothing is known).
    const figures = [
        {
            key: 'age',
            label: t('common.labels.age'),
            value: p.age != null ? formatDigits(p.age) : null
        },
        {
            key: 'blood',
            label: t('visit.patient.bloodType'),
            value: p.bloodType || null
        },
        {
            key: 'bmi',
            label: 'BMI',
            value: p.bmi ? formatDigits(Math.round(p.bmi * 10) / 10) : null
        },
        {
            key: 'visits',
            label: t('patient.visit'),
            value: p.visitsCount != null ? formatDigits(p.visitsCount) : null
        }
    ];
    const sectionProps = {
        p: p,
        patientId: patientId,
        onRefresh: refresh
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
        compact: true,
        title: p.name || t('nav.items.patients'),
        subtitle: headerMeta.join(' \u00b7 '),
        onBack: onBack,
        backLabel: t('common.actions.back'),
        action: p.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
            status: p.status
        }) : undefined,
        figures: figures,
        figuresLoading: isLoading,
        figuresLabel: t('patient.visit'),
        figuresTestIdPrefix: "patient"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 20,
            background: (0, $jTCZr.C).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40b242509fe3ec60$export$2e2bcd8739ae039), {
        allergies: allergies
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1e2b5d6e06e4f47$export$2e2bcd8739ae039), {
        active: tab,
        onChange: setTab
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem 2rem'
        },
        "data-testid": "patient-content",
        "data-state": contentState,
        "aria-busy": isLoading || undefined
    }, isMissing ? // A record that does not exist is not a record that failed to load,
    // and retrying will never produce it. Same split as the desktop
    // surface — see PatientDetail.web.jsx.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f09c2fbf6e97540$export$1c8a31b6c319fadd), {
        titleKey: "patient.empty.notFoundTitle",
        bodyKey: "patient.empty.notFoundBody",
        detail: patientId
    }) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: error,
        title: t('errors.load.record'),
        onRetry: refresh
    }) : isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $64a1fb07b6844f34$export$2e2bcd8739ae039), {
        tab: tab
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, tab === 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d983d5badec2112a$export$2e2bcd8739ae039), {
        ...sectionProps,
        setTab: setTab
    }), tab === 'analysis' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $450dbe611cd068cd$export$2e2bcd8739ae039), {
        p: p,
        patientId: patientId
    }), tab === 'labs' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e797c45ee6cbcd0d$export$2e2bcd8739ae039), sectionProps), tab === 'visits' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e99e18a7ba5d97dc$export$2e2bcd8739ae039), sectionProps), tab === 'files' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93d0222d1c690f96$export$2e2bcd8739ae039), sectionProps)))));
};
var $2515f4e67960210f$export$2e2bcd8739ae039 = $2515f4e67960210f$var$PatientDetailMobile;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");




// Shared design + domain constants for the desktop Patient record.
// Colours come from the framework token set only (DESIGN §1.1): the legacy `CL`
// field names are kept (thousands of inline call-sites) but every value is sourced
// from the canonical `CT` tokens, so the page renders in the shared navy/teal
// language — no raw hex is introduced.

var $jTCZr = parcelRequire("jTCZr");
const $1f9ad82cbe711bba$export$9bf3043cb7503aa1 = {
    bg: (0, $jTCZr.CT).bg,
    surface: (0, $jTCZr.CT).surface,
    surface2: (0, $jTCZr.CT).surface2,
    border: (0, $jTCZr.CT).border,
    border2: (0, $jTCZr.CT).border2,
    text1: (0, $jTCZr.CT).ink,
    text2: (0, $jTCZr.CT).ink2,
    text3: (0, $jTCZr.CT).mute,
    text4: (0, $jTCZr.CT).mute2,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    accentSoft: (0, $jTCZr.CT).accentSoft,
    // The panel's primary (azure #0173BE in the doctor panel). Used as the "medication"
    // timeline category so it reads distinct from the teal "diagnosis" accent
    // without importing an off-brand blue.
    navy: (0, $jTCZr.CT).navy,
    navySoft: (0, $jTCZr.soft)((0, $jTCZr.CT).navy, 0.10),
    good: (0, $jTCZr.CT).good,
    goodInk: (0, $jTCZr.CT).goodInk,
    goodSoft: (0, $jTCZr.CT).goodSoft,
    warn: (0, $jTCZr.CT).warn,
    warnInk: (0, $jTCZr.CT).warnInk,
    warnSoft: (0, $jTCZr.CT).warnSoft,
    danger: (0, $jTCZr.CT).danger,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft
};
const $1f9ad82cbe711bba$export$770e25a75af047b6 = (t)=>[
        {
            code: '55284-4',
            label: t('patient.vitals.bp'),
            unit: 'mmHg'
        },
        {
            code: '8867-4',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            code: '59408-5',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            code: '8310-5',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        }
    ];
const $1f9ad82cbe711bba$export$1574ad95f483ccf4 = (t)=>({
        active: {
            l: t('common.state.active'),
            cls: 'active'
        },
        resolved: {
            l: t('patient.conditions.resolved'),
            cls: 'resolved'
        }
    });


// Scoped stylesheet for the desktop Patient record. Injected once by the root.
// Colour values interpolate from the framework-sourced CL token map (DESIGN §1.1).

const $0708e7191fc9d5b2$export$72b22e63cf166bcb = `
  :root{
    --bg:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).bg}; --panel-2:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface}; --surface:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface}; --line:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}; --line-2:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border2};
    --ink:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1}; --ink-2:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2}; --mute:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3}; --mute-2:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text4};
    --accent:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent}; --accent-ink:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk}; --accent-soft:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentSoft};
    --navy:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).navy}; --navy-soft:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).navySoft};
    --good:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).good}; --good-soft:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).goodSoft};
    --warn:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn}; --warn-ink:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk}; --warn-soft:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnSoft};
    --danger:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger}; --danger-ink:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerInk}; --danger-soft:${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerSoft};
  }
  /* The Record's zone-\u{2460} identity band now lives in the shared InnerPageHeader
     (DESIGN-CONCEPT \xa72.3-C); the old .pb* breadcrumb+banner CSS was removed. */

  .pt-tabs{display:flex;gap:2px;padding:0 28px;background:var(--panel-2);border-bottom:1px solid var(--line);
    position:sticky;top:0;z-index:10;overflow-x:auto;flex-shrink:0}
  .pt-tab{position:relative;padding:13px 16px;font-size:13.5px;font-weight:600;color:var(--mute);
    border-bottom:2.5px solid transparent;margin-bottom:-1px;transition:color .14s;white-space:nowrap;
    background:none;border-inline:none;border-top:none;cursor:pointer;font-family:inherit}
  .pt-tab:hover{color:var(--ink-2)}
  .pt-tab.active{color:var(--accent-ink);border-bottom-color:var(--accent)}
  .pt-tab-dot{display:inline-block;width:5px;height:5px;border-radius:50%;background:var(--accent);margin-inline-start:6px;vertical-align:middle}

  .ps-grid{display:grid;grid-template-columns:minmax(0,1fr) 320px;gap:16px;align-items:start}
  .ps-main{display:flex;flex-direction:column;gap:16px;min-width:0}
  .ps-two{display:grid;grid-template-columns:1fr 1fr;gap:16px}
  .ps-rail{display:flex;flex-direction:column;gap:16px}
  @media(max-width:1180px){.ps-grid{grid-template-columns:1fr}.ps-two{grid-template-columns:1fr}}

  .ps-card{background:var(--panel-2);border:1px solid var(--line);border-radius:14px;
    box-shadow:0 1px 2px rgba(20,20,15,.04);overflow:hidden}
  .ps-card-head{display:flex;align-items:center;gap:9px;padding:13px 16px;border-bottom:1px solid var(--line-2)}
  .ps-card-title{display:flex;align-items:center;gap:9px;font-size:14px;font-weight:700}
  .ps-ic{width:26px;height:26px;border-radius:8px;display:grid;place-items:center;flex-shrink:0;
    background:var(--accent-soft);color:var(--accent-ink);font-size:13px}
  .ps-count{font-size:11px;color:var(--mute);font-weight:600;background:var(--bg);padding:2px 9px;border-radius:999px;margin-inline-start:2px}
  .ps-card-body{padding:14px 16px}
  .ps-card-body.pad0{padding:2px 16px}
  .ps-link{display:inline-flex;align-items:center;gap:5px;color:var(--accent-ink);font-weight:600;font-size:12.5px;
    background:none;border:none;cursor:pointer;font-family:inherit}
  .ps-link.sm{font-size:12px;margin-inline-start:auto}

  .ps-card.hero{background:linear-gradient(120deg,var(--accent-soft),var(--panel-2) 75%);border-color:transparent;
    box-shadow:0 1px 2px rgba(20,20,15,.04),0 6px 20px rgba(20,20,15,.04)}
  .ps-summary-text{margin:0;font-size:13px;line-height:1.95;color:var(--ink-2);text-align:justify}
  .ps-summary-actions{margin-top:13px}
  .ps-summary-actions-l{font-size:11.5px;font-weight:800;color:var(--ink);margin-bottom:9px;
    display:flex;align-items:center;gap:7px}
  .ps-summary-actions-l::before{content:"";width:4px;height:13px;border-radius:2px;background:var(--accent)}
  .ps-summary-actions ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:7px}
  .ps-summary-actions li{display:flex;align-items:flex-start;gap:9px;font-size:12.5px;color:var(--ink-2);line-height:1.55}
  .ps-bullet{width:16px;height:16px;border-radius:5px;flex-shrink:0;margin-top:1px;display:grid;place-items:center;
    background:var(--accent-soft);color:var(--accent-ink);font-size:10px}

  .dx-row{display:flex;align-items:flex-start;gap:12px;padding:12px 0;border-top:1px solid var(--line-2)}
  .dx-row:first-child{border-top:0}
  .dx-main{flex:1;min-width:0}
  .dx-title-row{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  .dx-cat{font-size:9.5px;font-weight:800;padding:2px 8px;border-radius:5px;letter-spacing:.03em}
  .dx-cat.active{background:var(--good-soft);color:var(--good)}
  .dx-cat.diff{background:var(--warn-soft);color:var(--warn-ink)}
  .dx-cat.resolved{background:var(--line-2);color:var(--mute)}
  .dx-name{font-size:13px;font-weight:600;line-height:1.4}
  .dx-code{background:var(--bg);border:1px solid var(--line);color:var(--ink-2);padding:1px 7px;border-radius:5px;font-size:10.5px;font-weight:700}
  .dx-note{font-size:11.5px;color:var(--mute);margin-top:4px;line-height:1.55}

  .med-row{display:flex;align-items:flex-start;gap:11px;padding:10px 0;border-top:1px solid var(--line-2)}
  .med-row:first-child{border-top:0}
  .med-pill{width:30px;height:30px;border-radius:8px;background:var(--accent-soft);display:grid;place-items:center;
    color:var(--accent-ink);flex-shrink:0;margin-top:1px;font-size:13px}
  .med-top{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  .med-top .n{font-size:13px;font-weight:700}
  .med-dose{font-size:11px;font-weight:700;color:var(--accent-ink);background:var(--accent-soft);padding:1px 7px;border-radius:5px}
  .med-row .d{font-size:11.5px;color:var(--mute);margin-top:1px}
  .med-badges{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px}
  .med-badge{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;padding:2px 7px;border-radius:6px}
  .med-badge.warn{background:var(--warn-soft);color:var(--warn-ink)}

  .ps-rail-block{background:var(--panel-2);border:1px solid var(--line);border-radius:14px;padding:14px 15px;
    box-shadow:0 1px 2px rgba(20,20,15,.04)}
  .ps-rail-title{display:flex;align-items:center;font-size:12.5px;font-weight:800;color:var(--ink);margin-bottom:11px}

  .vit-grid{display:grid;grid-template-columns:1fr 1fr;gap:9px}
  .vit-cell{padding:9px 11px;border-radius:10px;background:var(--bg);border:1px solid var(--line)}
  .vit-cell .k{font-size:10.5px;color:var(--mute);font-weight:600}
  .vit-cell .v{display:flex;align-items:baseline;gap:3px;margin-top:2px}
  .vit-cell .v .mono{font-size:16px;font-weight:800;letter-spacing:-.02em}
  .vit-cell .v .u{font-size:9.5px;color:var(--mute);font-weight:600}
  .vit-cell .trend{margin-top:5px}

  .ps-tabph{text-align:center;padding:60px 20px}
  .ps-tabph-t{font-size:16px;font-weight:800}
  .ps-tabph-s{font-size:12.5px;color:var(--mute);margin-top:4px}

  /* \xab\u{646}\u{645}\u{627}\u{6CC} \u{6A9}\u{644}\u{6CC} \u{628}\u{627}\u{644}\u{6CC}\u{646}\u{6CC}\xbb (.ov-*) and \xab\u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} \u{627}\u{62E}\u{6CC}\u{631}\xbb (.ps-enc*) were removed from the
     Summary tab; their rules went with them. The visit history lives in the
     \xab\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A}\xbb tab. */

  .lv-meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:12px;color:var(--mute);
    padding-bottom:11px;margin-bottom:12px;border-bottom:1px solid var(--line-2)}
  .lv-meta b{color:var(--ink);font-weight:700}
  .lv-meta .dot{width:3px;height:3px;border-radius:50%;background:var(--mute-2)}
  .lv-type{font-size:9.5px;font-weight:800;letter-spacing:.04em;padding:2px 7px;border-radius:5px;
    background:var(--accent-soft);color:var(--accent-ink)}

  .ps-card-head.danger{border-bottom-color:var(--line-2)}
  .ps-ic.danger{background:var(--danger-soft);color:var(--danger-ink)}
  .alg-row{display:flex;align-items:center;gap:11px;padding:12px 16px;border-top:1px solid var(--line-2)}
  .alg-row:first-child{border-top:0}
  .alg-sev{font-size:11px;font-weight:800;padding:4px 11px;border-radius:8px;flex-shrink:0;color:var(--surface)}
  .alg-sev.high{background:var(--danger)}
  .alg-sev.mid{background:var(--warn)}
  .alg-body{flex:1;min-width:0}
  .alg-name{font-size:13px;font-weight:700}
  .alg-react{font-size:11px;color:var(--mute);margin-top:2px}

  .abn-row{display:flex;align-items:center;gap:11px;padding:12px 16px;border-top:1px solid var(--line-2)}
  .abn-row:first-child{border-top:0}
  .abn-info{flex:1;min-width:0}
  .abn-name{font-size:13px;font-weight:700}
  .abn-ref{font-size:10.5px;color:var(--mute);margin-top:2px}
  .abn-spark{flex-shrink:0}
  .abn-val{text-align:center;flex-shrink:0;min-width:46px}
  .abn-v{display:block;font-size:16px;font-weight:800;letter-spacing:-.02em}
  .abn-v.hi{color:var(--danger-ink)}.abn-v.mid{color:var(--warn-ink)}
  .abn-state{display:block;font-size:9.5px;font-weight:700;margin-top:1px}
  .abn-state.hi{color:var(--danger-ink)}.abn-state.mid{color:var(--warn-ink)}

  .ps-empty{text-align:center;padding:18px 8px}
  .ps-empty-ic{width:42px;height:42px;border-radius:12px;margin:0 auto 10px;display:grid;place-items:center;
    background:var(--bg);border:1px solid var(--line);color:var(--mute-2);font-size:18px}
  .ps-empty-t{font-size:13px;font-weight:700;color:var(--ink)}
  .ps-empty-s{font-size:11.5px;color:var(--mute);margin-top:4px;line-height:1.6;max-width:240px;margin-inline:auto}

  .demo-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 14px}
  .demo-item .k{font-size:10.5px;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:1px}
  .demo-item .v{font-size:13px;color:var(--ink);font-weight:500}
  .demo-item .v.mono{font-family:ui-monospace,monospace;font-weight:600}

  .vit-cell.alert{background:var(--warn-soft);border-color:transparent}
  .vit-cell.alert .k{color:var(--warn-ink)}

  .allergy-banner{display:flex;align-items:center;gap:8px;padding:8px 11px;
    background:var(--danger-soft);border:1px solid transparent;border-radius:8px;margin-bottom:8px}
  .allergy-banner .ic{width:18px;height:18px;border-radius:50%;background:var(--danger-ink);
    color:#fff;display:grid;place-items:center;flex-shrink:0;font-size:11px}
  .allergy-list{display:flex;flex-wrap:wrap;gap:5px}
  .allergy-chip{font-size:11.5px;padding:3px 9px;border-radius:999px;
    background:var(--panel-2);border:1px solid var(--line);color:var(--danger-ink);font-weight:500}

  .history-list{display:flex;flex-direction:column;gap:10px}
  .hist-item{display:grid;grid-template-columns:auto 1fr;gap:10px}
  .hist-marker{width:8px;height:8px;border-radius:50%;background:var(--accent);margin-top:7px;flex-shrink:0;position:relative}
  .hist-marker::after{content:"";position:absolute;top:12px;inset-inline-start:3.5px;width:1px;height:32px;background:var(--line)}
  .hist-item:last-child .hist-marker::after{display:none}
  .hist-title{font-size:12.5px;font-weight:600;color:var(--ink)}
  .hist-meta{font-size:11px;color:var(--mute);font-family:ui-monospace,monospace;margin-top:1px}

  .cond-list{display:flex;flex-wrap:wrap;gap:5px}
  .cond-chip{font-size:11.5px;padding:4px 10px;border-radius:6px;
    background:var(--bg);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;gap:6px}
  .cond-chip.primary{background:var(--accent-soft);border-color:transparent;color:var(--accent-ink)}
  .cond-chip .code{font-family:ui-monospace,monospace;font-size:10px;color:var(--mute);font-weight:600}
  .cond-chip.primary .code{color:var(--accent-ink);opacity:.7}

  /* \u{2500}\u{2500} Encounter workspace (\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} tab) \u{2500}\u{2500} */
  .soap-tabs{display:flex;gap:4px;padding:0 20px;background:var(--bg);border-bottom:1px solid var(--line)}
  .soap-tab{padding:10px 14px;font-size:13px;font-weight:500;color:var(--mute);
    border-bottom:2px solid transparent;margin-bottom:-1px;
    display:flex;align-items:center;gap:7px;background:transparent;transition:color .12s}
  .soap-tab:hover{color:var(--ink-2)}
  .soap-tab.active{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}
  .soap-tab .badge{font-size:10px;background:var(--line-2,#ece9e4);color:var(--ink-2);
    padding:1px 6px;border-radius:999px;font-weight:600}
  .soap-tab.active .badge{background:var(--accent-soft);color:var(--accent-ink)}

  .work-scroll{flex:1;overflow-y:auto;padding:22px 24px 60px}

  .enc-card{background:var(--surface);border:1px solid var(--line);border-radius:12px;
    margin-bottom:14px;overflow:hidden}
  .enc-card-head{padding:11px 16px;border-bottom:1px solid var(--line-2,#ece9e4);
    display:flex;align-items:center;justify-content:space-between;background:var(--bg)}
  .enc-card-title{font-weight:600;font-size:13px;display:flex;align-items:center;gap:8px}
  .enc-card-title .ic{width:22px;height:22px;border-radius:6px;background:var(--accent-soft);
    color:var(--accent-ink);display:grid;place-items:center;font-size:12px}
  .enc-card-body{padding:14px 16px}

  .soap-section{margin-bottom:16px}
  .soap-label{display:flex;align-items:center;gap:8px;margin-bottom:7px}
  .soap-letter{width:22px;height:22px;border-radius:6px;background:var(--accent-soft);
    color:var(--accent-ink);font-family:ui-monospace,monospace;font-size:11px;font-weight:700;
    display:grid;place-items:center;flex-shrink:0}
  .soap-name{font-weight:600;font-size:13px}
  .soap-editor{border:1px solid var(--line);border-radius:8px;padding:10px 12px;
    background:var(--bg);font-size:13px;line-height:1.75;min-height:52px;color:var(--ink-2);
    white-space:pre-wrap;word-break:break-word}

  .diff-row{display:grid;grid-template-columns:1fr auto;align-items:center;gap:12px;
    padding:11px 0;border-top:1px solid var(--line-2,#ece9e4)}
  .diff-row:first-child{border-top:0;padding-top:0}
  .diff-name{font-size:13px;font-weight:600;display:flex;align-items:center;gap:7px;flex-wrap:wrap}
  .diff-code{font-size:11px;color:var(--mute);font-family:ui-monospace,monospace}
  .diff-evidence{font-size:11.5px;color:var(--mute);margin-top:3px;line-height:1.5}
  .diff-conf{display:flex;align-items:center;gap:7px;flex-shrink:0}
  .conf-bar{width:72px;height:5px;background:var(--line-2,#ece9e4);border-radius:3px;overflow:hidden}
  .conf-fill{height:100%;background:var(--accent);border-radius:3px}
  .conf-num{font-family:ui-monospace,monospace;font-size:11px;color:var(--ink-2);font-weight:600;width:34px}

  .rx-row{display:grid;grid-template-columns:minmax(0,2fr) 80px 1fr auto;
    align-items:center;gap:10px;padding:10px 0;border-top:1px solid var(--line-2,#ece9e4)}
  .rx-row:first-child{border-top:0;padding-top:0}
  .rx-row.header{padding-bottom:5px;border-bottom:1px solid var(--line-2,#ece9e4);margin-bottom:4px}
  .rx-name{font-weight:600;font-size:13px;display:flex;align-items:center;gap:7px;flex-wrap:wrap}
  .rx-gen{font-size:11px;color:var(--mute);margin-top:1px}
  .rx-cell{font-size:12px;color:var(--ink-2);font-family:ui-monospace,monospace}
  .rx-cell.label{font-size:10.5px;color:var(--mute);font-family:inherit;
    text-transform:uppercase;letter-spacing:.05em;font-weight:600}
  .rx-warn{display:inline-flex;align-items:center;gap:4px;padding:2px 7px;border-radius:999px;
    background:var(--warn-soft);color:var(--warn-ink);font-size:10.5px;font-weight:600}
  .rx-badge{display:inline-flex;padding:2px 8px;border-radius:999px;font-size:10.5px;font-weight:600}
  .rx-badge.continue{background:var(--accent-soft);color:var(--accent-ink)}
  .rx-badge.reduce{background:var(--warn-soft);color:var(--warn-ink)}

  .order-group-h{display:flex;align-items:center;gap:8px;font-size:11px;
    text-transform:uppercase;letter-spacing:.06em;color:var(--mute);font-weight:600;
    padding:10px 0 6px;border-top:1px solid var(--line-2,#ece9e4)}
  .order-group-h:first-child{border-top:0;padding-top:2px}
  .order-row{display:grid;grid-template-columns:1fr auto auto;gap:10px;align-items:center;
    padding:9px 0;border-top:1px dashed var(--line-2,#ece9e4)}
  .order-row:first-child{border-top:0}
  .order-name{font-size:13px;font-weight:500}
  .order-meta{font-size:11px;color:var(--mute);margin-top:1px}
  .order-urg{font-size:10px;font-weight:700;padding:2px 7px;border-radius:3px;
    text-transform:uppercase;letter-spacing:.04em}
  .order-urg.routine{background:var(--line-2,#ece9e4);color:var(--ink-2)}
  .order-urg.stat{background:var(--danger-soft);color:var(--danger-ink)}
  .order-urg.urgent{background:var(--warn-soft);color:var(--warn-ink)}
  .order-urg.requested{background:var(--accent-soft);color:var(--accent-ink)}
  .order-urg.active{background:var(--good-soft);color:oklch(0.38 0.08 155)}

  .iconbtn{width:28px;height:28px;border-radius:6px;display:grid;place-items:center;
    color:var(--mute);background:transparent;border:0;cursor:pointer}
  .iconbtn:hover{background:var(--line-2,#ece9e4);color:var(--ink)}

  /* Right panel toggle */
  .enc-rtabs{display:flex;padding:0 14px;background:var(--surface);
    border-bottom:1px solid var(--line)}
  .enc-rtab{flex:1;padding:12px 8px;font-size:13px;font-weight:500;color:var(--mute);
    border-bottom:2px solid transparent;margin-bottom:-1px;background:transparent;
    display:flex;align-items:center;justify-content:center;gap:6px;transition:color .12s}
  .enc-rtab:hover{color:var(--ink-2)}
  .enc-rtab.active{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}

  /* Encounter list (right \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} panel) */
  .enc-list{overflow-y:auto;flex:1;padding:8px 0}
  .enc-list-item{padding:12px 14px;cursor:pointer;border-bottom:1px solid var(--line-2,#ece9e4);
    transition:background .1s;position:relative}
  .enc-list-item:hover{background:var(--bg)}
  .enc-list-item.selected{background:var(--accent-soft);border-inline-start:3px solid var(--accent)}
  .enc-list-item .enc-li-row{display:flex;align-items:center;gap:7px;margin-bottom:4px}
  .enc-li-date{font-size:11px;color:var(--mute);font-family:ui-monospace,monospace}
  .enc-li-type{font-size:10.5px;padding:2px 7px;border-radius:999px;
    background:var(--line-2,#ece9e4);color:var(--ink-2);font-weight:500}
  .enc-li-status{font-size:10px;padding:2px 6px;border-radius:999px;font-weight:600}
  .enc-li-status.live{background:var(--good-soft);color:oklch(0.38 0.08 155)}
  .enc-li-status.done{background:var(--line-2,#ece9e4);color:var(--ink-2)}
  .enc-li-status.emergency{background:var(--danger-soft);color:var(--danger-ink)}
  .enc-live-dot{width:6px;height:6px;border-radius:50%;background:oklch(0.55 0.09 155);
    animation:pulse-dot 1.6s infinite;flex-shrink:0}
  @keyframes pulse-dot{0%{box-shadow:0 0 0 0 rgba(22,163,74,.4)}70%{box-shadow:0 0 0 6px rgba(22,163,74,0)}100%{box-shadow:0 0 0 0 rgba(22,163,74,0)}}
  .enc-li-title{font-size:13px;font-weight:600;color:var(--ink);margin-bottom:3px;
    white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .enc-li-counts{font-size:11px;color:var(--mute)}

  /* AI assistant panel \u{2014} conversational */
  .ai-panel{display:flex;flex-direction:column;flex:1;overflow:hidden;min-height:0}
  .ai-chat-head{display:flex;align-items:center;gap:10px;padding:12px 14px;
    border-bottom:1px solid var(--line-2,#ece9e4);background:var(--surface);flex-shrink:0}
  .ai-chat-avatar{width:32px;height:32px;border-radius:9px;flex-shrink:0;
    background:linear-gradient(135deg,var(--accent),var(--navy));
    display:grid;place-items:center;color:#fff;font-size:15px}
  .ai-panel-title{font-weight:700;font-size:13.5px;color:var(--ink);margin-bottom:2px}
  .ai-panel-sub{font-size:11px;color:var(--mute);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .ai-newchat{margin-inline-start:auto;flex-shrink:0;font-family:inherit;font-size:11px;
    padding:4px 9px;border-radius:7px;border:1px solid var(--line);background:var(--bg);
    color:var(--ink-2);cursor:pointer;transition:all .12s}
  .ai-newchat:hover:not(:disabled){border-color:var(--accent);color:var(--accent-ink)}
  .ai-newchat:disabled{opacity:.5;cursor:default}
  .ai-panel-body{flex:1;overflow-y:auto;padding:12px 14px;min-height:0}

  .ai-chat{display:flex;flex-direction:column;gap:10px}
  .ai-chat-intro{font-size:12px;line-height:1.8;color:var(--mute);
    background:var(--bg);border:1px dashed var(--line);border-radius:9px;padding:10px 12px;margin-bottom:4px}
  .ai-msg{display:flex;flex-direction:column;max-width:100%;animation:ai-msg-in .18s ease}
  .ai-msg.user{align-items:flex-start}
  .ai-msg.bot{align-items:flex-end}
  @keyframes ai-msg-in{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
  .ai-bubble{max-width:88%;padding:9px 12px;border-radius:11px;font-size:12.5px;line-height:1.8;
    word-break:break-word}
  .ai-bubble-text{white-space:pre-wrap}
  /* Tail corner sits on the side the bubble hangs off: user is inline-start
     (right in RTL), assistant inline-end (left). */
  .ai-bubble.user{background:var(--ink);color:#faf7f4;border-end-start-radius:4px}
  .ai-bubble.bot{background:var(--surface);border:1px solid var(--line);color:var(--ink);
    border-end-end-radius:4px}
  .ai-bubble.bot.error{background:var(--danger-soft);border-color:transparent;color:var(--danger-ink)}
  .ai-typing{display:flex;gap:4px;align-items:center;padding:12px}
  .ai-typing span{width:5px;height:5px;border-radius:50%;background:var(--mute);
    animation:ai-typing-dot .9s ease infinite}
  .ai-typing span:nth-child(2){animation-delay:.15s}
  .ai-typing span:nth-child(3){animation-delay:.3s}
  @keyframes ai-typing-dot{0%,60%,100%{opacity:.25}30%{opacity:1}}
  .ai-quick-q{display:block;width:100%;text-align:start;padding:9px 11px;margin-bottom:6px;
    background:var(--surface);border:1px solid var(--line);border-radius:8px;
    font-size:12px;color:var(--ink-2);transition:all .12s;cursor:pointer;font-family:inherit}
  .ai-quick-q:hover{background:#fff;border-color:var(--accent);color:var(--ink)}
  .ai-quick-q-arrow{float:left;color:var(--mute);font-size:10px;margin-inline-start:4px}
  .ai-answer-meta{font-size:10.5px;color:var(--mute);margin-bottom:6px;display:flex;gap:6px;align-items:center}
  .ai-follow-ups{display:flex;flex-direction:column;gap:5px;margin-top:7px;width:88%;align-self:flex-end}
  .ai-follow-up-label{font-size:10.5px;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:4px}
  .ai-composer{border-top:1px solid var(--line);padding:11px 14px;background:var(--surface)}
  .ai-composer-row{display:flex;align-items:center;gap:7px;padding:7px 11px;
    border-radius:9px;background:var(--bg);border:1px solid var(--line)}
  .ai-composer-row input{flex:1;border:0;background:transparent;outline:none;font-size:13px;font-family:inherit;direction:rtl}
  .ai-composer-row input::placeholder{color:var(--mute)}
  .ai-send{width:28px;height:28px;border-radius:7px;background:var(--ink);color:#fff;
    display:grid;place-items:center;flex-shrink:0;border:0;cursor:pointer;font-size:14px}
  .ai-send:hover:not(:disabled){background:var(--accent)}
  .ai-send:disabled{opacity:.4;cursor:default}
  .ai-composer-row input:disabled{cursor:default}

  /* Collapsible left panel \u{2014} strip always visible */
  .enc-left-panel{
    display:flex;flex-direction:row;overflow:hidden;flex-shrink:0;
    transition:width .35s cubic-bezier(.4,0,.2,1);
    border-inline-end:1px solid var(--line);
  }
  .enc-left-panel.open{width:390px}
  .enc-left-panel.closed{width:40px}

  /* 40px always-visible strip */
  .enc-collapse-strip{
    width:40px;flex-shrink:0;display:flex;flex-direction:column;
    align-items:center;padding:8px 0;gap:4px;
    background:var(--surface);border-inline-start:1px solid var(--line-2,#ece9e4);
    order:1
  }
  .enc-collapse-btn{
    width:26px;height:26px;border-radius:6px;border:1px solid var(--line);
    background:transparent;display:flex;align-items:center;justify-content:center;
    cursor:pointer;color:var(--mute);transition:all .18s;flex-shrink:0;margin-bottom:6px
  }
  .enc-collapse-btn:hover{background:var(--line-2,#ece9e4);color:var(--ink)}
  .enc-collapse-btn svg{transition:transform .35s cubic-bezier(.4,0,.2,1)}
  /* Hide chevron when closed \u{2014} only tab buttons show */
  .enc-left-panel.closed .enc-collapse-btn{display:none}

  /* Vertical tab buttons \u{2014} only visible when collapsed */
  .enc-strip-tab{
    display:none;width:32px;padding:10px 0;align-items:center;justify-content:center;
    cursor:pointer;border:1px solid var(--line);background:transparent;
    border-radius:7px;transition:background .15s,color .15s,border-color .15s;
    flex-shrink:0
  }
  .enc-left-panel.closed .enc-strip-tab{display:flex}
  .enc-strip-tab:hover{background:var(--line-2,#ece9e4);border-color:var(--ink-2)}
  .enc-strip-tab.active{background:var(--accent-soft);border-color:var(--accent)}
  .enc-strip-label{
    writing-mode:vertical-lr;font-size:11px;font-weight:600;
    letter-spacing:.06em;transform:rotate(180deg);
    color:var(--mute);transition:color .15s;user-select:none
  }
  .enc-strip-tab.active .enc-strip-label{color:var(--accent-ink)}
  .enc-strip-tab:hover .enc-strip-label{color:var(--ink)}

  /* Scrollable panel content \u{2014} 350px, hides as panel collapses */
  .enc-panel-inner{
    width:350px;flex-shrink:0;display:flex;flex-direction:column;
    overflow:hidden;transition:opacity .2s;order:2
  }
  .enc-left-panel.closed .enc-panel-inner{opacity:0;pointer-events:none}

  /* \u{2500}\u{2500} \xab\u{62A}\u{62D}\u{644}\u{6CC}\u{644}\xbb \u{2014} the analysis timeline (\xa74.5: rem everywhere; the 1px hairlines
        are the documented optical exception, and the plot itself is 1:1 pixel
        by contract \u{2014} see the kit's useMeasuredWidth). \u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500} */
  .an-root{display:flex;flex-direction:column;gap:0.75rem}

  .an-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem 0.75rem;
    padding:0.625rem 0.875rem;background:var(--panel-2);border:1px solid var(--line);
    border-radius:0.75rem;box-shadow:0 1px 2px rgba(20,20,15,.04)}
  .an-toolbar-l{font-size:0.6875rem;color:var(--mute);font-weight:700}
  .an-toolbar-end{margin-inline-start:auto;display:flex;align-items:center;gap:0.5rem}
  .an-seg{display:flex;background:var(--bg);border:1px solid var(--line);border-radius:0.5625rem;padding:0.125rem}
  .an-seg-b{border:0;background:none;font:inherit;font-size:0.71875rem;color:var(--ink-2);
    padding:0.25rem 0.75rem;border-radius:0.4375rem;cursor:pointer;min-height:1.75rem}
  .an-seg-b:hover{color:var(--ink)}
  .an-seg-b.on{background:var(--panel-2);color:var(--ink);font-weight:800;box-shadow:0 1px 2px rgba(20,20,15,.06)}

  .an-range{display:flex;align-items:center;gap:0.5rem;width:100%;padding-top:0.125rem}
  .an-range-l{font-size:0.625rem;color:var(--mute);font-weight:700}
  .an-range-v{font-size:0.6875rem;color:var(--ink);font-weight:800;
    background:var(--accent-soft);border-radius:999px;padding:0.125rem 0.625rem}
  .an-range-x{display:inline-flex;align-items:center;gap:0.25rem;border:1px solid var(--line);
    background:var(--panel-2);color:var(--ink-2);font:inherit;font-size:0.625rem;font-weight:700;
    border-radius:0.4375rem;padding:0.1875rem 0.5rem;cursor:pointer;min-height:1.5rem}
  .an-range-x:hover{border-color:var(--accent);color:var(--accent-ink)}

  .an-card{background:var(--panel-2);border:1px solid var(--line);border-radius:0.875rem;
    box-shadow:0 1px 2px rgba(20,20,15,.04);overflow:clip}
  /* Drag across the plot to zoom. pan-y keeps the page scrollable under a
     finger while a horizontal drag still selects a range. */
  .an-zoomable{position:relative;cursor:crosshair;touch-action:pan-y}
  .an-zoomable.dragging{user-select:none}
  .an-brush{position:absolute;top:0;bottom:0;z-index:8;pointer-events:none;
    background:var(--accent-soft);border-inline:1px solid var(--accent)}
  .an-brush-label{position:absolute;top:0.375rem;left:50%;transform:translateX(-50%);
    white-space:nowrap;background:var(--ink);color:var(--panel-2);
    font-size:0.625rem;font-weight:800;border-radius:0.375rem;padding:0.125rem 0.5rem}

  .an-lane{display:grid;grid-template-columns:10.75rem minmax(0,1fr);border-top:1px solid var(--line-2)}
  .an-lane:first-child{border-top:0}
  /* The clock never scrolls away while the lanes beneath it do. */
  .an-lane-ruler{position:sticky;top:0;z-index:6;background:var(--panel-2);
    box-shadow:0 3px 0.5rem -0.3125rem rgba(10,20,30,.14)}
  .an-rail{padding:0.625rem 0.875rem;border-inline-end:1px solid var(--line-2);
    display:flex;flex-direction:column;justify-content:center;gap:0.125rem;min-width:0}
  .an-rail-t{font-size:0.75rem;font-weight:800;color:var(--ink);overflow-wrap:anywhere}
  .an-rail-u{font-size:0.625rem;color:var(--mute)}
  .an-rail-v{font-size:1rem;font-weight:800;letter-spacing:-.02em;direction:ltr;text-align:end;color:var(--ink)}
  .an-keys{display:flex;flex-direction:column;gap:0.0625rem;margin-top:0.1875rem}
  .an-key{display:flex;align-items:center;gap:0.375rem;font-size:0.625rem;color:var(--ink-2)}
  .an-key i{width:0.75rem;height:0;border-top:2px solid;border-radius:2px}
  .an-rm{align-self:flex-start;margin-top:0.25rem;border:1px solid var(--line);background:var(--bg);
    color:var(--mute);font:inherit;font-size:0.625rem;border-radius:0.4375rem;
    padding:0.125rem 0.5rem;cursor:pointer;min-height:1.375rem}
  .an-rm:hover{color:var(--danger);border-color:var(--danger)}
  .an-plot{position:relative;direction:ltr;min-width:0}
  .an-plot svg{display:block;width:100%}
  .an-lane-empty{padding:0.75rem 0.875rem;color:var(--mute);font-size:0.71875rem}
  .an-empty-cta{padding:0;grid-column:1/-1}

  .an-obs-head{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem 0.625rem;
    padding:0.6875rem 0.875rem;border-top:1px solid var(--line-2);background:var(--bg)}
  .an-obs-t{font-size:0.75rem;font-weight:800;color:var(--ink)}
  .an-obs-hint{font-size:0.625rem;color:var(--mute);flex:1 1 12rem;min-width:0}
  .an-obs-btn{margin-inline-start:auto}
  .an-obs-count{font-size:0.625rem;font-weight:700;color:var(--ink-2)}
  .an-chips{display:flex;flex-wrap:wrap;gap:0.375rem;width:100%}
  .an-chip{display:inline-flex;align-items:center;gap:0.375rem;background:var(--panel-2);
    border:1px solid var(--line);border-radius:999px;padding:0.125rem 0.3125rem 0.125rem 0.6875rem;
    font-size:0.625rem;font-weight:700;color:var(--ink-2)}
  .an-chip::before{content:"";width:0.4375rem;height:0.4375rem;border-radius:50%;background:var(--accent)}
  .an-chip button{border:0;background:var(--bg);color:var(--mute);width:1.125rem;height:1.125rem;
    border-radius:50%;cursor:pointer;display:grid;place-items:center;padding:0}
  .an-chip button:hover{background:var(--danger-soft);color:var(--danger)}

  .an-legend{display:flex;gap:0.875rem;flex-wrap:wrap;padding:0.5625rem 1rem;
    border-top:1px solid var(--line-2);background:var(--bg);font-size:0.65625rem;color:var(--ink-2)}
  .an-legend-l{font-weight:700;color:var(--mute)}
  .an-legend-i{display:flex;align-items:center;gap:0.375rem}
  .an-legend-i .lg-dot{width:0.625rem;height:0.625rem;border-radius:50%;border:2px solid var(--mute)}
  .an-legend-i .lg-bar{width:0.875rem;height:0.5625rem;border-radius:2px 0.25rem 0.25rem 2px;background:var(--navy)}
  .an-legend-i .lg-sq{width:0.5rem;height:0.5rem;border-radius:2px}
  .an-legend-i .lg-now{width:2px;height:0.75rem;background:var(--accent)}

  .an-note{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem;padding:0.5rem 0.875rem;
    background:var(--warn-soft);border:1px solid var(--warn);border-radius:0.625rem;
    font-size:0.71875rem;color:var(--warn-ink)}

  /* Compact tier (\xa74.1): the rail narrows before the plot does \u{2014} the plot is
     where the information is. */
  @media(max-width:1180px){
    .an-lane{grid-template-columns:8.25rem minmax(0,1fr)}
    .an-rail{padding:0.5rem 0.625rem}
    .an-obs-hint{display:none}
  }
`;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $jOGbh = parcelRequire("jOGbh");
var $5AX1S = parcelRequire("5AX1S");

// Shared pure helpers for the desktop Patient record.
// Locale digits (DESIGN-CONCEPT §16.1, hard rule): every number the UI *displays*
// on the Persian surface renders in Persian digits — mixing digit sets in one
// view is a defect. Display-only: storage/wire stay ASCII. Separators, units and
// Latin identifiers pass through untouched.
/**
 * Digits in the reading locale.
 *
 * This used to hardcode the Persian digit set. It now delegates to the locale's
 * own numbering system, so an English UI keeps Latin digits — and it takes the
 * formatter as an argument rather than reaching for a hook, because it is also
 * called from plain helpers and from tests.
 *
 * Without a formatter it returns the value untouched, which is the correct
 * Latin-digit rendering rather than a wrong Persian one.
 */ 
const $3a8eaefcca13cf5f$export$25b095a1ad9e1176 = (n, formatDigits)=>{
    if (n == null || n === '') return n;
    return formatDigits ? formatDigits(n) : String(n);
};
const $3a8eaefcca13cf5f$export$d5126f8c047ed6ad = (iso, formatDate)=>{
    if (!iso) return '';
    const [y, m, d] = iso.slice(0, 10).split('-');
    const at = new Date(`${y}-${m}-${d}T12:00:00Z`);
    return formatDate ? formatDate(at, 'short') : iso.slice(0, 10);
};



// The desktop Record's zone-① header (archetype C, DESIGN-CONCEPT §2.3-C).
// It is the shared `InnerPageHeader` in its identity-band density: a back
// affordance to the referrer (§3.2 — replaces the old, banned breadcrumb),
// the patient identity (avatar + name + live-visit status + کد ملی), a
// dot-separated meta line, and the quick stat chips on the end edge.
// (The ویرایش / ویزیت جدید actions were removed per product decision.)
const $489311c8b0711f95$var$PatientHeader = ({ p: p, onBack: onBack })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const initials = p.name ? p.name.split(' ').map((w)=>w[0]).join('').slice(0, 2) : t('common.punct.question');
    const isLive = (p.encounters || []).some((e)=>e.status === 'in_progress' || e.status === 'arrived');
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '2.5rem',
            height: '2.5rem',
            borderRadius: '0.75rem',
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            fontWeight: 700,
            fontSize: '0.9375rem'
        }
    }, initials);
    const status = isLive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.375rem',
            paddingInline: '0.625rem',
            paddingBlock: '0.1875rem',
            borderRadius: 999,
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentSoft,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk,
            fontSize: '0.71875rem',
            fontWeight: 600
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent
        }
    }), t('patient.visitInProgress'));
    const badges = p.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).bg,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            paddingInline: '0.5625rem',
            paddingBlock: '0.1875rem',
            borderRadius: '0.4375rem',
            fontWeight: 600
        }
    }, t('common.labels.code'), " ", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.nationalId, formatDigits));
    const meta = [
        p.age != null && t('patient.ageYears', {
            count: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.age, formatDigits)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        }),
        // `faNum` is a DIGIT renderer, not a phone formatter — it would print
        // `+989121234567` in Persian digits. `phone.forDisplay` is the kit's READ path and
        // goes first: national spelling, landline-tolerant (this column has legacy landlines
        // in it), and the raw value handed back untouched when it cannot parse one, so this
        // line can never blank. The screen's Persian-digit rendering still runs last, on the
        // ASCII the helper returns.
        p.phone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr"
        }, t('common.labels.phone'), " ", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)((0, $5AX1S).forDisplay(p.phone), formatDigits)),
        p.insurance && t('patient.insuranceLabel', {
            name: (0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance] ? t((0, $bf42e0131d395ab7$export$a69e980913efc937)[p.insurance]) : p.insurance
        })
    ];
    const stats = [
        p.age != null && {
            label: t('common.labels.age'),
            value: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.age, formatDigits)
        },
        p.bmi != null && {
            label: 'BMI',
            value: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.bmi.toFixed(1), formatDigits)
        },
        p.lastWeight != null && {
            label: t('patient.vitals.weightKg'),
            value: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.lastWeight, formatDigits)
        },
        p.visitsCount != null && {
            label: t('patient.totalVisits'),
            value: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.visitsCount, formatDigits),
            accent: true
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOGbh.default), {
        "data-testid": "patient-detail-header",
        onBack: onBack,
        backLabel: t('common.actions.back'),
        title: p.name || "\u2014",
        avatar: avatar,
        status: status,
        badges: badges,
        meta: meta,
        stats: stats
    });
};
var $489311c8b0711f95$export$2e2bcd8739ae039 = $489311c8b0711f95$var$PatientHeader;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");

// Shared display primitives for the desktop Patient record.
//
// `Sparkline` and `TrendChart` used to live here (and, separately, in the mobile
// record's kit). Both are now framework components — `import { Sparkline,
// TrendChart } from '@parsina/framework'` — because a trend glyph is a
// design-language primitive, not a doctor-app one.

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
// ── Clinical pill ─────────────────────────────────────────────────────────────
// Thin adapter over the kit `Badge` (DESIGN §1 — no hand-rolled chips): the
// screen's clinical `tone` vocabulary maps onto Badge's CVA variants.
const $749083270f41223e$var$TONE_VARIANT = {
    accent: 'default',
    good: 'success',
    warn: 'warning',
    danger: 'destructive',
    mono: 'outline',
    neutral: 'outline'
};
const $749083270f41223e$export$d2cf3038149dd1b5 = ({ tone: tone = 'neutral', size: size, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: $749083270f41223e$var$TONE_VARIANT[tone] || 'outline',
        ...rest
    }, children);


// Persistent allergy / alert safety strip shown above every non-overview tab.
const $39b130ae8b467aab$var$SafetyStrip = ({ allergies: allergies = [], alerts: alerts = [] })=>{
    const { t: t } = (0, $LNQP4.default)();
    if (!allergies.length && !alerts.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '6px 28px',
            background: 'rgba(220,38,38,0.04)',
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            overflowX: 'auto',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontSize: 10,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2,
            fontWeight: 600,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 12
    }), " ", t('patient.safety')), allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            paddingInlineStart: 10,
            borderInlineStart: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            flexShrink: 0
        }
    }, t('patient.allergies.title')), allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $749083270f41223e$export$d2cf3038149dd1b5), {
            key: i,
            tone: "danger"
        }, a))), alerts.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $749083270f41223e$export$d2cf3038149dd1b5), {
            key: i,
            tone: a.severity === 'CRITICAL' ? 'danger' : 'warn'
        }, a.message)));
};
var $39b130ae8b467aab$export$2e2bcd8739ae039 = $39b130ae8b467aab$var$SafetyStrip;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
const $54fb4340d9fc8f69$export$73b877b58963a4f = (t)=>[
        {
            id: 'overview',
            label: t('patient.tabs.overview')
        },
        // «تحلیل» sits next to «خلاصه» because the two are companions: the summary is
        // *what changed*, the analysis is *how it moved* — the record reads
        // narrative → evidence.
        {
            id: 'analysis',
            label: t('patient.tabs.analysis')
        },
        // «مشاهدات» — vitals + laboratory analytes. The route segment stays `labs`
        // so existing links and bookmarks keep resolving.
        {
            id: 'labs',
            label: t('patient.tabs.observations')
        },
        // «دستورات و اقدامات» was removed from the record: orders are read in the
        // visit they belong to («تاریخچه مراجعات» → دستورات) rather than as a
        // standalone patient-level section.
        // «تاریخچه مراجعات» — the tab reads as a chronological visit history
        // (newest first), not as a static file cabinet. Route segment stays `visits`.
        {
            id: 'visits',
            label: t('patient.tabs.visitHistory')
        },
        {
            id: 'files',
            label: t('patient.tabs.files')
        }
    ];
const $54fb4340d9fc8f69$var$ClinicalTabBar = ({ tab: tab, setTab: setTab })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "pt-tabs"
    }, $54fb4340d9fc8f69$export$73b877b58963a4f(t).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: item.id,
            className: 'pt-tab' + (tab === item.id ? ' active' : ''),
            onClick: ()=>setTab(item.id)
        }, item.label, item.id === 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "pt-tab-dot"
        }))));
};
var $54fb4340d9fc8f69$export$2e2bcd8739ae039 = $54fb4340d9fc8f69$var$ClinicalTabBar;



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// The patient record's loading shapes (DESIGN.md §"Loading & skeleton").
//
// `PatientDetailSkeleton` is the whole page on first entry: breadcrumb strip,
// identity row, vitals strip, the five-tab bar, then the overview's cards —
// each at the height the real `PatientHeader` / `SafetyStrip` / `ClinicalTabBar`
// draw, so the record fills the shape in place. `PatientTabSkeleton` is the
// pane alone, for a refresh while the header is already on screen, and it is
// per tab: the analysis pane is a chart, the observations pane a tile grid,
// the visits pane a list — one generic skeleton would fit none of them.
// ─────────────────────────────────────────────────────────────────────────────
const $d1e1ffd8e261dcdc$var$TAB_WIDTHS = [
    70,
    60,
    110,
    90,
    65
];
const $d1e1ffd8e261dcdc$var$SectionCardSkeleton = ({ lines: lines = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            borderRadius: 10,
            padding: 20,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "80%"
    }));
const $d1e1ffd8e261dcdc$export$cb1cd28f421b0672 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            borderRadius: 10,
            padding: '0.75rem 0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        circle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 56,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 70,
        height: 22,
        radius: (0, $jTCZr.RADIUS).chip
    })));
const $d1e1ffd8e261dcdc$export$33f6e3467d893933 = ({ tab: tab = 'overview', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    const lbl = label ?? t('common.state.loading');
    let body;
    switch(tab){
        case 'analysis':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
                height: 220,
                line: true,
                legend: 3,
                label: lbl
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                lines: 3
            }));
            break;
        case 'labs':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(10.9375rem, 1fr))',
                    gap: '0.625rem'
                }
            }, Array.from({
                length: 6
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$export$cb1cd28f421b0672, {
                    key: i
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                lines: 3
            }));
            break;
        case 'visits':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
                count: 4,
                avatar: false,
                trailing: 72,
                label: lbl
            });
            break;
        case 'files':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(14rem, 1fr))',
                    gap: 12
                }
            }, Array.from({
                length: 4
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
                    key: i,
                    avatar: false,
                    lines: 2,
                    chips: 1,
                    actions: 0,
                    label: lbl
                })));
            break;
        default:
            body = [
                1,
                2,
                3
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                    key: i
                }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: lbl,
        "data-testid": `patient-tab-skeleton-${tab}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, body);
};
/** The whole record on first entry. */ const $d1e1ffd8e261dcdc$var$PatientDetailSkeleton = ({ tab: tab = 'overview', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "patient-detail-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).bg,
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface2,
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            padding: '7px 28px',
            display: 'flex',
            gap: 8,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 60,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        height: 8,
        radius: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 50,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        height: 8,
        radius: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 90,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            padding: '14px 28px',
            display: 'flex',
            gap: 14,
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
        size: 50
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 10,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 140,
        height: 22
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 70,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 50,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 60,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 80,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 55,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 100,
        height: 12
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 104
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 36
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface2,
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            display: 'flex',
            padding: '9px 28px',
            overflowX: 'hidden'
        }
    }, [
        130,
        110,
        120,
        110
    ].map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: '0 16px',
                borderInlineEnd: i < 3 ? `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}` : 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 60,
            height: 10
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: w,
            height: 16
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTabs), {
        widths: $d1e1ffd8e261dcdc$var$TAB_WIDTHS,
        gap: 0,
        padding: "12px 14px",
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            padding: '0 28px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            padding: 28,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$export$33f6e3467d893933, {
        tab: tab
    })));
};
var $d1e1ffd8e261dcdc$export$2e2bcd8739ae039 = $d1e1ffd8e261dcdc$var$PatientDetailSkeleton;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $3Amwd = parcelRequire("3Amwd");
var $6usBW = parcelRequire("6usBW");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");








// Overview-only label map (not shared with other tabs). Encounter *status*
// labels left with «مراجعات اخیر» when that rail block was removed.
const $bb877cde7ef1a601$var$ENCOUNTER_TYPE = (t)=>({
        ambulatory: t('patient.encType.outpatient'),
        emergency: t('common.urgency.emergency'),
        inpatient: t('patient.encType.inpatient'),
        observation: t('patient.obs.view')
    });
const $bb877cde7ef1a601$var$OV_SEVERITY = (t)=>({
        severe: {
            l: t('visit.severity.high'),
            cls: 'high'
        },
        moderate: {
            l: t('credits.level.midShort'),
            cls: 'mid'
        },
        mild: {
            l: t('visit.severity.low'),
            cls: 'mid'
        }
    });
const $bb877cde7ef1a601$var$OverviewTab = ({ p: p, setTab: setTab, onRefresh: onRefresh })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!p.id) return;
        setOrders(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$c97661997f8a2b63), {
            patientId: p.id
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch(()=>setOrders([]));
    }, [
        p.id
    ]);
    // ── Derived data ──────────────────────────────────────────────────────────
    const conditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalConditions || []).filter((c)=>{
            if (seen.has(c.id)) return false;
            seen.add(c.id);
            return true;
        });
    }, [
        p.clinicalConditions
    ]);
    const activeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>conditions.filter((c)=>c.clinicalStatus === 'active'), [
        conditions
    ]);
    const medications = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalMedications || []).filter((m)=>{
            if (seen.has(m.id)) return false;
            seen.add(m.id);
            return true;
        });
    }, [
        p.clinicalMedications
    ]);
    const activeMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const byCode = {};
        medications.filter((m)=>m.status === 'active' || m.status === 'on-hold').forEach((m)=>{
            const key = m.code || m.display;
            if (!byCode[key] || (m.authoredOn || '') > (byCode[key].authoredOn || '')) byCode[key] = m;
        });
        return Object.values(byCode).sort((a, b)=>(b.authoredOn || '').localeCompare(a.authoredOn || ''));
    }, [
        medications
    ]);
    const allergies = p.clinicalAllergies || [];
    const abnormalObs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return [
            ...p.clinicalObservations || []
        ].filter((o)=>{
            if (seen.has(o.id)) return false;
            seen.add(o.id);
            return true;
        }).filter((o)=>!(0, $bf42e0131d395ab7$export$520152d4ddd823c6).has(o.code)).filter((o)=>[
                'abnormal',
                'critical',
                'high',
                'low',
                'h',
                'l'
            ].includes((o.status || '').toLowerCase()));
    }, [
        p.clinicalObservations
    ]);
    const obsByCode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        [
            ...p.clinicalObservations || []
        ].sort((a, b)=>(a.effectiveDate || a.createdAt || '').localeCompare(b.effectiveDate || b.createdAt || '')).forEach((o)=>{
            (map[o.code] = map[o.code] || []).push(o);
        });
        return map;
    }, [
        p.clinicalObservations
    ]);
    const abnormalLabs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return abnormalObs.filter((o)=>{
            const k = o.code || o.display;
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
        }).reverse().slice(0, 6).map((o)=>({
                ...o,
                series: (obsByCode[o.code] || []).map((x)=>parseFloat(x.value)).filter((v)=>!isNaN(v)).slice(-6)
            }));
    }, [
        abnormalObs,
        obsByCode
    ]);
    const lastVisitSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const notes = [
            ...p.clinicalNotes || []
        ].reverse();
        return notes.find((n)=>n.noteType === 'VISIT_SUMMARY') || null;
    }, [
        p.clinicalNotes
    ]);
    // ── Last-visit hero card ─────────────────────────────────────────────────
    const lastVisitInfo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!lastVisitSummary) return null;
        const encId = lastVisitSummary.appointmentId;
        const encounter = (p.encounters || []).find((e)=>e.id === encId);
        const bp = (obsByCode['55284-4'] || []).filter((o)=>o.appointmentId === encId).slice(-1)[0];
        const actions = [
            ...medications.filter((m)=>m.appointmentId === encId).map((m)=>m.dosageInstruction?.text ? t('patient.overview.medStartedWithDose', {
                    name: m.display,
                    dose: m.dosageInstruction.text
                }) : t('patient.overview.medStarted', {
                    name: m.display
                })),
            ...(orders || []).filter((o)=>o.appointmentId === encId).map((o)=>t('patient.overview.orderRequested', {
                    name: o.name
                }))
        ];
        return {
            date: (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(lastVisitSummary.createdAt, formatDate),
            type: encounter ? $bb877cde7ef1a601$var$ENCOUNTER_TYPE(t)[encounter.type] || encounter.type : null,
            dxCount: conditions.filter((c)=>c.appointmentId === encId).length,
            bp: bp?.value || null,
            text: lastVisitSummary.content?.text || '',
            actions: actions
        };
    }, [
        lastVisitSummary,
        p.encounters,
        obsByCode,
        medications,
        orders,
        conditions,
        t,
        formatDate
    ]);
    const vitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $1f9ad82cbe711bba$export$770e25a75af047b6)(t).map((v)=>{
            const series = (obsByCode[v.code] || []).map((o)=>parseFloat(o.value)).filter((n)=>!isNaN(n)).slice(-6);
            const latest = (obsByCode[v.code] || [])[obsByCode[v.code]?.length - 1];
            return {
                ...v,
                value: latest?.value,
                series: series
            };
        }).filter((v)=>v.value != null), [
        obsByCode,
        t
    ]);
    const [deletingMed, setDeletingMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmMed, setConfirmMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const doDeleteMed = async (id)=>{
        setDeletingMed(id);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$608c51c2a533f155), {
                id: id
            });
            onRefresh();
        } catch  {
            toast.error(t('errors.save.medicationDelete'));
        } finally{
            setDeletingMed(null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-main"
    }, lastVisitInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card hero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.overview.lastVisitSummary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ps-link sm",
        onClick: ()=>setTab('visits')
    }, t('patient.overview.viewFull'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "lv-meta"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", null, lastVisitInfo.date), lastVisitInfo.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "lv-type"
    }, lastVisitInfo.type)), lastVisitInfo.dxCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(lastVisitInfo.dxCount, formatDigits), " ", t('patient.conditions.one'))), lastVisitInfo.bp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.vitals.bp'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(lastVisitInfo.bp, formatDigits))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "ps-summary-text",
        dangerouslySetInnerHTML: {
            __html: lastVisitInfo.text
        }
    }), lastVisitInfo.actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-summary-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-summary-actions-l"
    }, t('patient.overview.visitActions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, lastVisitInfo.actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ps-bullet"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true
        })), a)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-two"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.meds.active'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(activeMeds.length, formatDigits), " ", t('patient.meds.one')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, activeMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('visit.rx.noneRecorded'))) : activeMeds.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-row",
            key: m.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "med-pill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 15,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-info",
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "n",
            dir: "auto"
        }, (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m))), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "d"
        }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>setConfirmMed(m.id),
            disabled: deletingMed === m.id,
            "aria-label": t('patient.meds.removeAria', {
                name: (0, $bb8a11e7c1131df5$export$74f59380a530b722)(m)
            }),
            style: {
                background: 'none',
                border: 'none',
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger,
                cursor: 'pointer',
                display: 'grid',
                placeItems: 'center',
                opacity: deletingMed === m.id ? 0.4 : 1,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fX0JO.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.conditions.active'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(activeConditions.length, formatDigits), " ", t('dashboard.queue.finishedCount')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, activeConditions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.empty.noneRecorded'))) : activeConditions.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-row",
            key: c.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-title-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-cat active"
        }, (0, $1f9ad82cbe711bba$export$1574ad95f483ccf4)(t).active.l), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
            cond: c
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-name"
        }, c.display), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-code",
            dir: "ltr"
        }, c.code)), c.onsetDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-note"
        }, t('patient.conditions.onset'), " ", (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(c.onsetDate, formatDate))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card allergy-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.allergies.drug')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(allergies.length, formatDigits), " ", t('dashboard.queue.finishedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, allergies.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.allergies.none'))) : allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-row",
            key: a.id || i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "alg-sev " + ($bb877cde7ef1a601$var$OV_SEVERITY(t)[a.severity]?.cls || 'mid')
        }, $bb877cde7ef1a601$var$OV_SEVERITY(t)[a.severity]?.l || a.severity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-name"
        }, a.allergen), a.reaction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-react"
        }, t('patient.allergies.reaction'), " ", a.reaction)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.obs.abnormal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(abnormalLabs.length, formatDigits), " ", t('dashboard.queue.finishedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, abnormalLabs.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.empty.noneRecorded'))) : abnormalLabs.map((o)=>{
        const isCrit = (o.status || '').toLowerCase() === 'critical';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-row",
            key: o.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-info"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-name"
        }, o.display)), o.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-spark"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: o.series,
            width: 40,
            height: 18,
            tone: isCrit ? 'danger' : 'warn'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-val"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "abn-v " + (isCrit ? 'hi' : 'mid')
        }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(o.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "abn-state " + (isCrit ? 'hi' : 'mid')
        }, isCrit ? t('visit.vitals.critical') : t('visit.vitals.abnormal'))));
    })), abnormalLabs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '8px 16px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ps-link sm",
        onClick: ()=>setTab('labs')
    }, t('patient.obs.viewAll')))), vitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail-block"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail-title"
    }, t('patient.labCategory.vitals')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "vit-grid"
    }, vitals.map((v)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "vit-cell",
            key: v.code
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "k"
        }, v.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "v"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "mono",
            dir: "ltr"
        }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(v.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "u"
        }, v.unit)), v.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "trend"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: v.series,
            width: 40,
            height: 9
        })));
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!confirmMed,
        onOpenChange: (o)=>{
            if (!o) setConfirmMed(null);
        },
        title: t('patient.meds.delete'),
        message: t('patient.meds.deleteConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        onConfirm: ()=>doDeleteMed(confirmMed)
    }));
};
var $bb877cde7ef1a601$export$2e2bcd8739ae039 = $bb877cde7ef1a601$var$OverviewTab;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $cRX9v = parcelRequire("cRX9v");
var $7gSBD = parcelRequire("7gSBD");
var $cLQXb = parcelRequire("cLQXb");
var $h4ZeB = parcelRequire("h4ZeB");
var $ctU9L = parcelRequire("ctU9L");
var $kCQwN = parcelRequire("kCQwN");
var $66joL = parcelRequire("66joL");
var $cPdQE = parcelRequire("cPdQE");
var $3uzzV = parcelRequire("3uzzV");

var $k2reB = parcelRequire("k2reB");
var $i7Rt0 = parcelRequire("i7Rt0");
var $aRAFQ = parcelRequire("aRAFQ");
var $8g4t5 = parcelRequire("8g4t5");
var $6TdpC = parcelRequire("6TdpC");
var $bU80g = parcelRequire("bU80g");






var $acw62 = parcelRequire("acw62");

var $2VplL = parcelRequire("2VplL");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $4fYdd = parcelRequire("4fYdd");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");



// ─────────────────────────────────────────────────────────────────────────────
// «انتخاب سنجه‌ها» — the ONE way observations get onto the analysis chart.
//
// The tab deliberately lists nothing by default: a chronic patient carries
// dozens of analytes, and an always-visible catalogue would spend the whole
// screen on a menu. So the full catalogue lives here — vitals and laboratory
// analytes in one pool, because the entire point of the tab is putting a vital
// beside an analyte on one clock — narrowed by a category dropdown, a search
// box, and an «فقط غیرطبیعی» toggle.
//
// Each row carries the evidence the choice needs: last value, its status, and a
// sparkline. Choosing what to investigate IS a triage decision; a bare list of
// names would make the doctor open six charts to find the one that moved.
//
// Selection is drafted locally and committed on «اعمال» (§5.2: an overlay with
// unsaved input closes only through an explicit action), so a mis-tap in a
// 40-row list never silently rewrites the chart behind the dialog.
// ─────────────────────────────────────────────────────────────────────────────
const $89dd3c5e44c5e235$var$STATUS_META = (t)=>({
        critical: {
            label: t('visit.vitals.critical'),
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger,
            soft: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerSoft,
            tone: 'danger'
        },
        abnormal: {
            label: t('visit.vitals.abnormal'),
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk,
            soft: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnSoft,
            tone: 'warn'
        }
    });
const $89dd3c5e44c5e235$var$MetricPickerDialog = ({ open: open, onOpenChange: onOpenChange, groups: groups, selected: selected, onApply: onApply, cap: cap = (0, $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5) })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(selected);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [category, setCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [abnormalOnly, setAbnormalOnly] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Reopening always starts from what is actually on the chart — a stale draft
    // from a cancelled session would silently re-apply on the next «اعمال».
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft(selected);
            setQuery('');
            setCategory('');
            setAbnormalOnly(false);
        }
    }, [
        open,
        selected
    ]);
    // §5.2: closing returns focus to the trigger. Radix restores to whatever was
    // focused at mount, but this dialog is opened from a *controlled* state (there
    // is no DialogTrigger — two different buttons open it), and the re-render that
    // opens it costs the automatic restore its anchor: focus lands on <body>,
    // which strands a keyboard user at the top of the document. So the opener is
    // captured on the way in and focused explicitly on the way out.
    const openerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) openerRef.current = document.activeElement;
    }, [
        open
    ]);
    const returnFocus = (e)=>{
        const el = openerRef.current;
        if (el && typeof el.focus === 'function' && el.isConnected) {
            e.preventDefault();
            el.focus();
        }
    };
    const categoryOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.map((g)=>({
                value: g.category,
                label: `${t(g.categoryKey)} (${(0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(g.metrics.length, formatDigits)})`
            })), [
        groups,
        t,
        formatDigits
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim();
        return groups.filter((g)=>!category || g.category === category).map((g)=>({
                ...g,
                metrics: g.metrics.filter((m)=>(!q || (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m).includes(q)) && (!abnormalOnly || !!m.latestStatus))
            })).filter((g)=>g.metrics.length);
    }, [
        groups,
        category,
        query,
        abnormalOnly,
        t
    ]);
    const total = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.metrics.length, 0), [
        groups
    ]);
    const abnormalCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.abnormal, 0), [
        groups
    ]);
    const full = draft.length >= cap;
    const toggle = (key)=>setDraft((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= cap ? prev : [
                ...prev,
                key
            ]);
    const filtersActive = !!query || !!category || abnormalOnly;
    const clearFilters = ()=>{
        setQuery('');
        setCategory('');
        setAbnormalOnly(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        className: "max-w-2xl",
        "aria-describedby": undefined,
        "data-testid": "analysis-picker",
        onCloseAutoFocus: returnFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('patient.analysis.pickForChart')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 600,
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.analysis.compareHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
        }
    }, "(", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(total, formatDigits), " ", t('patient.analysis.metricsCountSuffix')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.5rem',
            alignItems: 'center',
            marginBottom: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '1 1 12rem',
            minWidth: '10rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('patient.analysis.searchMetric'),
        clearLabel: t('common.actions.clearSearch'),
        "data-testid": "analysis-picker-search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '0 1 11rem',
            minWidth: '9rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        value: category,
        onChange: (e)=>setCategory(e.target.value),
        options: categoryOptions,
        placeholder: t('patient.analysis.allCategories')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.abnormalOnly'),
        count: abnormalCount ? (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(abnormalCount, formatDigits) : undefined,
        active: abnormalOnly,
        onClick: ()=>setAbnormalOnly((v)=>!v),
        "data-testid": "analysis-picker-abnormal"
    }), filtersActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        type: "button",
        onClick: clearFilters
    }, t('encounters.clearFilters'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker-list",
        "data-state": filtered.length ? 'content' : 'empty',
        style: {
            maxHeight: '26rem',
            overflowY: 'auto',
            margin: '0 -0.5rem',
            borderTop: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border2}`
        }
    }, !filtered.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2VplL.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noMetricMatch'),
        description: total ? t('accounting.changeOrClearFilters') : t('patient.analysis.noMeasurements'),
        action: filtersActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            type: "button",
            onClick: clearFilters
        }, t('encounters.clearFilters')) : null,
        style: {
            padding: '1.5rem 1rem'
        }
    }) : filtered.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: group.category
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                margin: 0,
                padding: '0.5rem 1rem 0.25rem',
                background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
                fontSize: '0.6875rem',
                fontWeight: 800,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
            }
        }, t(group.categoryKey)), group.metrics.map((m)=>{
            const on = draft.includes(m.key);
            // Only the two off-normal states have a badge; «طبیعی» rows
            // show a dash, so a miss here is the normal case, not an error.
            const st = $89dd3c5e44c5e235$var$STATUS_META(t)[m.latestStatus] || null;
            const disabled = full && !on;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
                key: m.key,
                checked: on,
                disabled: disabled,
                onChange: ()=>toggle(m.key),
                "data-testid": `analysis-picker-row-${m.key}`,
                "data-state": on ? 'selected' : 'unselected',
                labelClassName: "flex-1 min-w-0",
                style: {
                    padding: '0.4375rem 1rem',
                    background: on ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentSoft : 'transparent'
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
                        whiteSpace: 'nowrap'
                    }
                }, (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m), m.unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
                        fontWeight: 400,
                        fontSize: '0.625rem'
                    }
                }, " ", m.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        marginInlineStart: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
                    points: m.points.slice(-8).map((p)=>p.y),
                    tone: st ? st.tone : 'accent',
                    width: 52,
                    height: 16
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 800,
                        direction: 'ltr',
                        minWidth: '2.75rem',
                        textAlign: 'end',
                        color: st ? st.color : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
                    }
                }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(Math.round(m.latest.y * 10) / 10, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        minWidth: '3.25rem',
                        textAlign: 'center',
                        fontSize: '0.5625rem',
                        fontWeight: 800,
                        borderRadius: '0.3125rem',
                        padding: '0.0625rem 0.375rem',
                        background: st ? st.soft : 'transparent',
                        color: st ? st.color : 'transparent'
                    }
                }, st ? st.label : "\u2014")))
            });
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: ()=>onApply(draft),
        "data-testid": "analysis-picker-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: ()=>onOpenChange(false)
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            alignSelf: 'center',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: full ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(draft.length, formatDigits), "/", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(cap, formatDigits), " ", t('common.state.selected'), full && t('patient.analysis.maxSuffix')))));
};
var $89dd3c5e44c5e235$export$2e2bcd8739ae039 = $89dd3c5e44c5e235$var$MetricPickerDialog;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $4Qco3 = parcelRequire("4Qco3");


// ─────────────────────────────────────────────────────────────────────────────
// «بازهٔ دلخواه» — an exact analysis window, to the minute.
//
// The presets answer "roughly the last N months"; this answers "between the
// admission and the discharge", which is the question that needs a *time*, not
// just a date — two visits on one day are a normal Tuesday, and a day-precision
// range would fold them together.
//
// The Jalali calendar and the time spinners both come from the kit's
// `JalaliDatePicker` (`withTime`) — the only Jalaali implementation in the
// system (DESIGN.md), so this dialog never re-implements calendar maths. Values
// are Iran wall-clock; the ms conversion lives in the model so the picker, the
// drag-zoom and the presets all produce the same kind of window.
// ─────────────────────────────────────────────────────────────────────────────
const $e1b7856d4270460e$var$QUICK = [
    'month',
    '3m',
    '6m'
];
const $e1b7856d4270460e$var$CustomRangeDialog = ({ open: open, onOpenChange: onOpenChange, domain: domain, earliest: earliest, now: now, onApply: onApply })=>{
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime
        }), [
        formatDate,
        formatTime
    ]);
    const [from, setFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [to, setTo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Open on the window currently in view: the commonest edit is a nudge to one
    // end, not a range typed from nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setFrom((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(domain.min));
        setTo((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(domain.max));
        setError('');
    }, [
        open,
        domain.min,
        domain.max
    ]);
    const openerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) openerRef.current = document.activeElement;
    }, [
        open
    ]);
    const returnFocus = (e)=>{
        const el = openerRef.current;
        if (el?.focus && el.isConnected) {
            e.preventDefault();
            el.focus();
        }
    };
    const fromMs = (0, $aa3ffb82ad5c03f7$export$8d73c39233125377)(from);
    const toMs = (0, $aa3ffb82ad5c03f7$export$8d73c39233125377)(to);
    const preview = fromMs != null && toMs != null ? (0, $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae)((0, $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5)(fromMs, toMs), t, {
        withTime: true,
        fmt: fmt
    }) : '';
    const apply = ()=>{
        const problem = (0, $aa3ffb82ad5c03f7$export$50a7e9003a1e4b26)(fromMs, toMs, t);
        if (problem) {
            setError(problem);
            return;
        }
        // A reversed pair is a slip, not an error — the model orders it either way.
        onApply(fromMs, toMs);
    };
    const applyQuick = (id)=>{
        const w = (0, $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2)(id, earliest, now);
        setFrom((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(w.min));
        setTo((0, $aa3ffb82ad5c03f7$export$9b9263c8189aa410)(w.max));
        setError('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        className: "max-w-lg",
        "aria-describedby": undefined,
        "data-testid": "analysis-range-dialog",
        onCloseAutoFocus: returnFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('patient.analysis.customRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 600
        }
    }, t('patient.analysis.rangeHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
        }
    }, t('common.labels.from')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-from"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: from,
        onChange: setFrom,
        withTime: true,
        placeholder: t('patient.analysis.startDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
        }
    }, t('common.labels.to')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-to"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: to,
        onChange: setTo,
        withTime: true,
        placeholder: t('patient.analysis.endDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 700
        }
    }, t('patient.analysis.shortcut')), (0, $aa3ffb82ad5c03f7$export$5f37411c4bafeb65).filter((r)=>$e1b7856d4270460e$var$QUICK.includes(r.id)).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: r.id,
            type: "button",
            variant: "outline",
            size: "sm",
            onClick: ()=>applyQuick(r.id),
            "data-testid": `analysis-range-quick-${r.id}`
        }, t(r.labelKey)))), preview && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk,
            fontWeight: 700
        },
        "data-testid": "analysis-range-preview"
    }, preview), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger,
            fontWeight: 700
        },
        "data-testid": "analysis-range-error"
    }, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: apply,
        "data-testid": "analysis-range-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: ()=>onOpenChange(false)
    }, t('common.actions.cancel')))));
};
var $e1b7856d4270460e$export$2e2bcd8739ae039 = $e1b7856d4270460e$var$CustomRangeDialog;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// The crosshair's readout: everything true at ONE moment, in one card.
//
// It reads across lanes rather than per-lane on purpose — the pointer never has
// to land on a line to get its value, and the answer the doctor came for
// («the pressure was that, on this drug, right after that order») is a single
// vertical slice, not five separate hovers.
//
// Tooltips enhance, they never gate (§12): every value here is also in the
// table view, so nothing is reachable only by hovering.
const $f17f7c741e45d648$var$TimelineReadout = ({ at: at, metrics: metrics, medRows: medRows, events: events, encounters: encounters, tolerance: tolerance, now: now, style: style })=>{
    const { t: t, formatDigits: formatDigits, formatList: formatList, formatDate: formatDate } = (0, $LNQP4.default)();
    if (at == null) return null;
    const rows = metrics.map((m)=>({
            m: m,
            p: (0, $aa3ffb82ad5c03f7$export$ba330bb14d26e4ac)(m.points, at, tolerance)
        })).filter((r)=>r.p);
    const near = (item)=>Math.abs(item - at) <= tolerance;
    const evs = events.filter((e)=>near(e.t));
    const encs = encounters.filter((e)=>near(e.t));
    const meds = (0, $aa3ffb82ad5c03f7$export$29e5558020ac2bd3)(medRows, at, now);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "analysis-readout",
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            borderRadius: '0.6875rem',
            boxShadow: '0 8px 26px rgba(10,20,30,.16)',
            padding: '0.625rem 0.8125rem',
            minWidth: '12.5rem',
            maxWidth: '18rem',
            pointerEvents: 'none',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 800,
            fontSize: '0.71875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border2}`,
            paddingBottom: '0.3125rem',
            marginBottom: '0.375rem'
        }
    }, (0, $aa3ffb82ad5c03f7$export$d2cb3004af48acf4)(at, {
        formatDate: formatDate
    })), rows.map(({ m: m, p: p })=>{
        const tone = p.status === 'critical' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger : p.status === 'abnormal' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.4375rem',
                margin: '0.15625rem 0',
                fontSize: '0.71875rem',
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                width: '0.6875rem',
                borderTop: `2.5px solid ${tone}`,
                borderRadius: '2px',
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            style: {
                marginInlineStart: 'auto',
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
                direction: 'ltr',
                unicodeBidi: 'isolate'
            }
        }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(Math.round(p.y * 10) / 10, formatDigits), m.unit ? ` ${m.unit}` : ''));
    }), !rows.length && !evs.length && !encs.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, t('patient.analysis.noDataOnDate')), encs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.encounterLabel'), " ", formatList(encs.map((e)=>e.type || t('patient.visit')))), evs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.eventLabel'), " ", formatList(evs.map((e)=>e.label))), meds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.activeMedLabel'), " ", formatList(meds)));
};
var $f17f7c741e45d648$export$2e2bcd8739ae039 = $f17f7c741e45d648$var$TimelineReadout;



var $acw62 = parcelRequire("acw62");

var $ggYuf = parcelRequire("ggYuf");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");



// The chart's accessible twin (§12.4 / DESIGN.md data-viz rule): the lanes are
// `aria-hidden` SVG, so every value they draw must also be reachable as text.
//
// It is the same slice the chart shows — same window, same selection — sorted
// newest first, because "what happened lately" is the question a list answers
// well and a timeline answers slowly.
const $b61a9124911a13c6$var$KIND = (t)=>({
        metric: {
            label: t('patient.obs.measurement'),
            bg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentSoft,
            fg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk
        },
        med: {
            label: t('patient.meds.one'),
            bg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).navySoft,
            fg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).navy
        },
        dx: {
            label: t('patient.tabs.conditions'),
            bg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentSoft,
            fg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk
        },
        order: {
            label: t('visit.orders.procedure'),
            bg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnSoft,
            fg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk
        },
        enc: {
            label: t('patient.encounter'),
            bg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border2,
            fg: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
        }
    });
const $b61a9124911a13c6$var$STATUS_LBL = (t)=>({
        critical: t('visit.vitals.critical'),
        abnormal: t('visit.vitals.abnormal')
    });
const $b61a9124911a13c6$var$Chip = ({ kind: kind })=>{
    const { t: t } = (0, $LNQP4.default)();
    const k = $b61a9124911a13c6$var$KIND(t)[kind] || $b61a9124911a13c6$var$KIND(t).enc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            fontSize: '0.625rem',
            fontWeight: 800,
            borderRadius: '0.3125rem',
            padding: '0.09375rem 0.5rem',
            background: k.bg,
            color: k.fg
        }
    }, k.label);
};
const $b61a9124911a13c6$var$AnalysisTable = ({ metrics: metrics, medRows: medRows, events: events, encounters: encounters, domain: domain, now: now })=>{
    const { formatDigits: formatDigits, t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = [];
        metrics.forEach((m)=>m.points.forEach((p)=>out.push({
                    t: p.x,
                    kind: 'metric',
                    name: (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m),
                    value: `${(0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(Math.round(p.y * 10) / 10, formatDigits)}${m.unit ? ` ${m.unit}` : ''}`,
                    status: p.status !== 'normal' ? p.status : null
                })));
        medRows.forEach((r)=>r.segments.forEach((s)=>out.push({
                    t: s.from,
                    kind: 'med',
                    name: s.label,
                    value: '',
                    status: null,
                    note: s.to == null ? t('common.state.active') : t('dashboard.queue.finished')
                })));
        events.forEach((e)=>out.push({
                t: e.t,
                kind: e.kind,
                name: e.label,
                value: '',
                status: null,
                note: e.detail
            }));
        encounters.forEach((e)=>out.push({
                t: e.t,
                kind: 'enc',
                name: e.type || t('patient.encounter'),
                value: '',
                status: null,
                note: e.live ? t('common.state.inProgress') : e.cancelled ? t('common.state.cancelled') : t('patient.meds.finished')
            }));
        return out.filter((r)=>r.t >= domain.min && r.t <= domain.max).sort((a, b)=>b.t - a.t);
    }, [
        metrics,
        medRows,
        events,
        encounters,
        domain,
        t,
        formatDigits
    ]);
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ggYuf.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noDataInRange'),
        description: t('patient.analysis.widenRange'),
        "data-testid": "analysis-table-empty"
    });
    const th = {
        textAlign: 'start',
        fontSize: '0.65625rem',
        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
        fontWeight: 700,
        background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface2,
        padding: '0.5rem 0.875rem',
        borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
        position: 'sticky',
        top: 0,
        zIndex: 1
    };
    const td = {
        padding: '0.4375rem 0.875rem',
        borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border2}`,
        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            overflowX: 'auto'
        },
        "data-testid": "analysis-table",
        "data-state": "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t('patient.analysis.tableCaption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.date')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.type')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('common.labels.value')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.status')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: `${r.kind}-${r.t}-${r.name}-${i}`,
            "data-testid": "analysis-table-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                whiteSpace: 'nowrap'
            }
        }, (0, $aa3ffb82ad5c03f7$export$e00157e2cd456ae7)(r.t, {
            formatDate: formatDate
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b61a9124911a13c6$var$Chip, {
            kind: r.kind
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
                fontWeight: 700
            }
        }, r.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                direction: 'ltr',
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums'
            }
        }, r.value || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, r.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 800,
                borderRadius: '0.3125rem',
                padding: '0.09375rem 0.5rem',
                background: r.status === 'critical' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerSoft : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnSoft,
                color: r.status === 'critical' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk
            }
        }, $b61a9124911a13c6$var$STATUS_LBL(t)[r.status] || r.status) : r.note || ''))))));
};
var $b61a9124911a13c6$export$2e2bcd8739ae039 = $b61a9124911a13c6$var$AnalysisTable;


// ─────────────────────────────────────────────────────────────────────────────
// «تحلیل» — the record's investigation surface.
//
// Where «خلاصه» tells the story of what changed, this tab answers *how it
// moved, and did what we did line up with it*: measurements, prescriptions,
// diagnoses, orders and visits all projected onto ONE time axis, so a vertical
// glance means «at the same moment».
//
// Structural notes:
//   • Read-only. Not one mutation lives here — it is a lens, never a pen.
//     Authoring stays on the Visit page, correction on «خلاصه».
//   • The lanes are `aria-hidden` SVG from the kit's timeline family; the table
//     view (نمای جدول) is their accessible twin, carrying every value as text.
//   • Nothing is listed by default: metrics come only from the picker dialog,
//     so the screen spends its pixels on the chart rather than on a catalogue.
//   • Every lane shares one scale, built once here from the measured plot width
//     — that shared object is what makes the crosshair mean the same thing in
//     all of them.
// ─────────────────────────────────────────────────────────────────────────────
const $b89e7462d024c03d$var$EVENT_ROWS = 2;
// Below this a drag is a click that wobbled, not a selection.
const $b89e7462d024c03d$var$MIN_DRAG_PX = 8;
// A lane row: the RTL rail (name/unit/latest) beside the LTR plot.
const $b89e7462d024c03d$var$Lane = ({ title: title, sub: sub, value: value, valueTone: valueTone, keys: keys, action: action, children: children, testId: testId, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane",
        "data-testid": testId,
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-t"
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-u"
    }, sub), value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-v",
        style: valueTone ? {
            color: valueTone
        } : undefined
    }, value), keys, action), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-plot"
    }, children));
const $b89e7462d024c03d$var$AnalysisTab = ({ p: p, setTab: setTab })=>{
    const { formatDigits: formatDigits, t: t, formatDate: formatDate, formatTime: formatTime, formatClinicMonth: formatClinicMonth } = (0, $LNQP4.default)();
    // The timeline's date helpers are plain module functions, so they take the
    // formatters rather than reaching for the hook themselves.
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime,
            formatClinicMonth: formatClinicMonth
        }), [
        formatDate,
        formatTime,
        formatClinicMonth
    ]);
    const a = (0, $3dddcf07f47e64f7$export$e015f957982fab20)(p);
    const [plotRef, plotWidth] = (0, $3uzzV.default)(640);
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('chart');
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { t, x, y } | null
    // ONE scale for every lane. `padStart` reserves the value-axis gutter in all
    // lanes — including those that draw no axis — or they would not line up.
    const scale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $cRX9v.createTimeScale)({
            min: a.domain.min,
            max: a.domain.max,
            width: plotWidth,
            padStart: 44,
            padEnd: 12
        }), [
        a.domain,
        plotWidth
    ]);
    // How far from the pointer a datum still counts as "at this moment". It
    // scales with the window: on a year-wide view, demanding pixel-perfect aim on
    // a reading three weeks away would make the crosshair useless.
    const tolerance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Math.max(3 * (0, $aa3ffb82ad5c03f7$export$fa2e89afea4272f6), (a.domain.max - a.domain.min) * 0.022), [
        a.domain
    ]);
    // Pointer → plot x. Measured against the PLOT's own box — the same box whose
    // width built the scale. Converting against the card would silently bake in
    // the rail width and the card border, and any layout change would re-break it.
    const plotX = (clientX)=>{
        const node = plotRef.current;
        if (!node) return null;
        return clientX - node.getBoundingClientRect().left;
    };
    // ── Drag to zoom ──────────────────────────────────────────────────────────
    // A range is easier to point at than to type: the doctor sees the interesting
    // stretch and draws across it. The band is drawn live and labelled with the
    // range it currently covers, so the gesture is committed with the answer
    // already visible — no "select, release, hope".
    const [drag, setDrag] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { from, to } in plot px
    const dragRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const beginDrag = (e)=>{
        // Left button only, and never from a control that happens to sit over the plot.
        if (e.button !== 0 || e.target.closest('button, a, input, select, label')) return;
        const x = plotX(e.clientX);
        if (x == null || x < scale.x0 || x > scale.x1) return;
        dragRef.current = {
            from: x,
            to: x,
            moved: false
        };
        setDrag({
            from: x,
            to: x
        });
        setCursor(null);
        e.currentTarget.setPointerCapture?.(e.pointerId);
    };
    const onPointerMove = (e)=>{
        const x = plotX(e.clientX);
        if (x == null) return;
        if (dragRef.current) {
            const to = Math.min(scale.x1, Math.max(scale.x0, x));
            dragRef.current = {
                ...dragRef.current,
                to: to,
                moved: true
            };
            setDrag({
                from: dragRef.current.from,
                to: to
            });
            return;
        }
        if (x < scale.x0 || x > scale.x1) {
            setCursor(null);
            return;
        }
        setCursor({
            t: scale.invert(x),
            x: e.clientX,
            y: e.clientY
        });
    };
    const endDrag = (e)=>{
        const d = dragRef.current;
        dragRef.current = null;
        setDrag(null);
        e?.currentTarget?.releasePointerCapture?.(e.pointerId);
        if (!d) return;
        // A drag shorter than this is a click that wobbled, not a selection.
        if (!d.moved || Math.abs(d.to - d.from) < $b89e7462d024c03d$var$MIN_DRAG_PX) return;
        a.setWindow(scale.invert(d.from), scale.invert(d.to));
    };
    // Esc abandons a drag in progress — the same escape hatch every overlay gives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!drag) return undefined;
        const onKey = (ev)=>{
            if (ev.key === 'Escape') {
                dragRef.current = null;
                setDrag(null);
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        drag
    ]);
    const dragBand = drag && Math.abs(drag.to - drag.from) >= 2 ? {
        left: Math.min(drag.from, drag.to),
        width: Math.abs(drag.to - drag.from)
    } : null;
    const dragLabel = dragBand ? (0, $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae)((0, $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5)(scale.invert(drag.from), scale.invert(drag.to)), t, {
        fmt: fmt
    }) : '';
    const eventMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.events.map((e)=>{
            const kind = (0, $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619)[e.kind] || (0, $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619).order;
            return {
                id: e.id,
                t: e.t,
                row: kind.row,
                shape: kind.shape,
                label: e.label,
                tone: kind.tone === 'accent' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn
            };
        }), [
        a.events
    ]);
    const encounterMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.encounters.map((e)=>({
                id: e.id,
                t: e.t,
                shape: e.cancelled ? 'cross' : 'circle',
                filled: e.live,
                tone: e.live ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
            })), [
        a.encounters
    ]);
    const medRowsInWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.medRows.filter((r)=>r.segments.some((s)=>s.from <= a.domain.max && (s.to ?? a.now) >= a.domain.min)), [
        a.medRows,
        a.domain,
        a.now
    ]);
    // ── States (§2.4) ─────────────────────────────────────────────────────────
    if (a.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "loading",
        "aria-busy": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
        height: 220,
        line: true,
        legend: 3,
        label: t('common.state.loading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
        avatar: false,
        lines: 3,
        chips: 0,
        actions: 0,
        label: t('common.state.loading')
    }));
    if (a.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.analysis.historyLoadFailed'),
        note: t('patient.analysis.needsData'),
        detail: a.error?.message || String(a.error),
        onRetry: a.retry
    }));
    if (!a.hasData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 26,
            "aria-hidden": true
        }),
        title: t('patient.analysis.nothingToAnalyse'),
        description: t('patient.analysis.emptyHintLong')
    }));
    const rangeKey = ((0, $aa3ffb82ad5c03f7$export$5f37411c4bafeb65).find((r)=>r.id === a.range) || {}).labelKey;
    const rangeLabel = rangeKey ? t(rangeKey) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "content",
        className: "an-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-toolbar",
        "data-testid": "analysis-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-toolbar-l"
    }, t('common.labels.dateRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-seg",
        role: "group",
        "aria-label": t('common.labels.dateRange')
    }, (0, $aa3ffb82ad5c03f7$export$5f37411c4bafeb65).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: r.id,
            type: "button",
            className: 'an-seg-b' + (a.range === r.id ? ' on' : ''),
            "aria-pressed": a.range === r.id,
            "data-testid": `analysis-range-${r.id}`,
            onClick: ()=>a.setRange(r.id)
        }, t(r.labelKey))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: 'an-seg-b' + (a.isCustom ? ' on' : ''),
        "aria-pressed": a.isCustom,
        "data-testid": "analysis-range-custom",
        onClick: ()=>setRangeOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i7Rt0.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.analysis.custom'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-toolbar-l"
    }, t('patient.analysis.layers')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.events'),
        active: a.layers.events,
        onClick: ()=>a.toggleLayer('events'),
        "data-testid": "analysis-layer-events"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('visit.rx.medications'),
        active: a.layers.meds,
        onClick: ()=>a.toggleLayer('meds'),
        "data-testid": "analysis-layer-meds"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.metrics'),
        active: a.layers.metrics,
        onClick: ()=>a.toggleLayer('metrics'),
        "data-testid": "analysis-layer-metrics"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-toolbar-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        type: "button",
        onClick: ()=>setView((v)=>v === 'chart' ? 'table' : 'chart'),
        "data-testid": "analysis-view-toggle",
        "aria-pressed": view === 'table'
    }, view === 'chart' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b7762e62111820ee$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.tableView')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.chartView')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-range",
        "data-testid": "analysis-active-range",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-range-l"
    }, t('patient.analysis.activeRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-range-v"
    }, (0, $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae)(a.target, t, {
        fmt: fmt
    })), a.isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: "an-range-x",
        onClick: a.resetWindow,
        "data-testid": "analysis-range-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('common.actions.reset')))), view === 'table' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b61a9124911a13c6$export$2e2bcd8739ae039), {
        metrics: a.selectedMetrics,
        medRows: a.layers.meds ? a.medRows : [],
        events: a.layers.events ? a.events : [],
        encounters: a.encounters,
        domain: a.domain,
        now: a.now
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: 'an-card an-zoomable' + (drag ? ' dragging' : ''),
        "data-testid": "analysis-chart",
        onPointerDown: beginDrag,
        onPointerMove: onPointerMove,
        onPointerUp: endDrag,
        onPointerCancel: endDrag,
        onPointerLeave: ()=>{
            if (!dragRef.current) setCursor(null);
        }
    }, dragBand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-brush",
        style: {
            left: dragBand.left,
            width: dragBand.width
        },
        "data-testid": "analysis-brush"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-brush-label"
    }, dragLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane an-lane-ruler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-t"
    }, t('patient.tabs.visits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-u"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(a.encounters.length, formatDigits), " ", t('patient.encounter'), rangeLabel ? ` \xb7 ${rangeLabel}` : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-plot",
        ref: plotRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cPdQE.default), {
        width: plotWidth,
        scale: scale,
        ticks: a.ticks,
        formatTick: (ms)=>(0, $aa3ffb82ad5c03f7$export$57a214e89a3308a1)(ms, fmt),
        nowAt: a.now,
        cursorAt: cursor?.t,
        markers: encounterMarks,
        height: 56
    }))), a.layers.events && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
        title: t('patient.analysis.events'),
        testId: "analysis-lane-events",
        state: a.events.length ? 'content' : 'empty',
        keys: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "an-keys"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "an-key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                borderColor: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent
            }
        }), t('patient.analysis.legendDx')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "an-key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                borderColor: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn
            }
        }), t('patient.analysis.legendProc')))
    }, a.events.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cLQXb.default), {
        width: plotWidth,
        scale: scale,
        events: eventMarks,
        rows: $b89e7462d024c03d$var$EVENT_ROWS,
        rowHeight: 24,
        ticks: a.ticks,
        nowAt: a.now,
        cursorAt: cursor?.t
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty"
    }, t('patient.analysis.noEventsInRange'))), a.layers.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
        title: t('visit.rx.medications'),
        sub: t('patient.analysis.medBandCaption'),
        testId: "analysis-lane-meds",
        state: medRowsInWindow.length ? 'content' : 'empty'
    }, medRowsInWindow.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ctU9L.default), {
        width: plotWidth,
        scale: scale,
        rows: medRowsInWindow,
        rowHeight: 26,
        ticks: a.ticks,
        nowAt: a.now,
        cursorAt: cursor?.t
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty"
    }, t('patient.analysis.noMedsInRange'))), a.layers.metrics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-obs-head",
        "data-testid": "analysis-metrics-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-t"
    }, t('patient.analysis.selectedObservations')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-hint"
    }, t('patient.analysis.pickerHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        type: "button",
        className: "an-obs-btn",
        onClick: ()=>setPickerOpen(true),
        "data-testid": "analysis-pick-metrics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.pickMetrics')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-count"
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(a.selected.length, formatDigits), "/", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(a.cap, formatDigits), " ", t('patient.analysis.metric')), a.selectedMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-chips"
    }, a.selectedMetrics.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: m.key,
            className: "an-chip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            "aria-label": t('patient.analysis.removeFromChartAria', {
                name: m.name
            }),
            "data-testid": `analysis-chip-remove-${m.key}`,
            onClick: ()=>a.toggleMetric(m.key)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 11,
            "aria-hidden": true
        })))))), a.selectedMetrics.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty an-empty-cta",
        "data-testid": "analysis-metrics-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
            size: 24,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noneSelected'),
        description: t('patient.analysis.allAvailableDialog'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-metrics-empty-cta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.pickMetrics'))
    })) : a.selectedMetrics.map((m)=>{
        const st = m.latestStatus;
        const tone = st === 'critical' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger : st === 'abnormal' ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warnInk : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
            key: m.key,
            testId: `analysis-lane-${m.key}`,
            state: "content",
            title: (0, $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4)(t, m),
            sub: [
                m.unit,
                m.refLow != null && m.refHigh != null ? t('patient.analysis.referenceRange', {
                    low: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(m.refLow, formatDigits),
                    high: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(m.refHigh, formatDigits)
                }) : null
            ].filter(Boolean).join(" \xb7 "),
            value: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(Math.round(m.latest.y * 10) / 10, formatDigits),
            valueTone: tone,
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: "an-rm",
                "aria-label": t('patient.analysis.removeFromChartAria', {
                    name: m.name
                }),
                "data-testid": `analysis-lane-remove-${m.key}`,
                onClick: ()=>a.toggleMetric(m.key)
            }, t('common.actions.delete'))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kCQwN.default), {
            width: plotWidth,
            scale: scale,
            series: [
                {
                    id: m.key,
                    points: m.points,
                    color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent
                }
            ],
            refLow: m.refLow,
            refHigh: m.refHigh,
            ticks: a.ticks,
            nowAt: a.now,
            cursorAt: cursor?.t,
            height: 92,
            formatValue: (v)=>(0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(Math.round(v * 10) / 10, formatDigits),
            emptyLabel: t('patient.analysis.noneInRange')
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-legend"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-l"
    }, t('patient.analysis.legendLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-dot"
    }), t('patient.visit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent
        }
    }, "\u25B2"), t('patient.conditions.one')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn
        }
    }, "\u25C6"), t('visit.orders.procedure')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-bar"
    }), t('patient.analysis.medBand')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-sq",
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn
        }
    }), t('visit.vitals.abnormal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-sq",
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger
        }
    }), t('visit.vitals.critical')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-now"
    }), t('common.time.now')))), a.ordersError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-note",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "warning"
    }, t('patient.analysis.actionsLoadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.analysis.ordersMissing')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: "ps-link",
        onClick: a.retryOrders,
        "data-testid": "analysis-orders-retry"
    }, t('common.actions.retry'))), cursor && view === 'chart' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            zIndex: 40,
            pointerEvents: 'none',
            top: Math.min(cursor.y + 14, (typeof window !== 'undefined' ? window.innerHeight : 800) - 220),
            left: Math.max(12, cursor.x - 300)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f17f7c741e45d648$export$2e2bcd8739ae039), {
        at: cursor.t,
        metrics: a.layers.metrics ? a.selectedMetrics : [],
        medRows: a.layers.meds ? a.medRows : [],
        events: a.layers.events ? a.events : [],
        encounters: a.encounters,
        tolerance: tolerance,
        now: a.now
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89dd3c5e44c5e235$export$2e2bcd8739ae039), {
        open: pickerOpen,
        onOpenChange: setPickerOpen,
        groups: a.groups,
        selected: a.selected,
        cap: a.cap,
        onApply: (keys)=>{
            a.setSelection(keys);
            setPickerOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e1b7856d4270460e$export$2e2bcd8739ae039), {
        open: rangeOpen,
        onOpenChange: setRangeOpen,
        domain: a.target,
        earliest: a.earliest,
        now: a.now,
        onApply: (from, to)=>{
            a.setWindow(from, to);
            setRangeOpen(false);
        }
    }));
};
var $b89e7462d024c03d$export$2e2bcd8739ae039 = $b89e7462d024c03d$var$AnalysisTab;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");


var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");







// Desktop presentation vocabulary for the «مشاهدات» section.
//
// The section renders two families of observation that the record treats alike:
// vital signs (fixed set, reference ranges known) and laboratory analytes (open
// set, grouped into panels). Both families' *domain* definitions are shared with
// the mobile surface — `VITAL_DEFS` and the lab taxonomy in
// `constants/patientRecord.js` — so only the desktop's rendering choices live
// here.

var $k2reB = parcelRequire("k2reB");
var $ljvFv = parcelRequire("ljvFv");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $0ca1411ae90a041d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "m19 8 3 8a5 5 0 0 1-6 0zV7",
            key: "zcdpyk"
        }
    ],
    [
        "path",
        {
            d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1",
            key: "1yorad"
        }
    ],
    [
        "path",
        {
            d: "m5 8 3 8a5 5 0 0 1-6 0zV7",
            key: "eua70x"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ]
];
const $0ca1411ae90a041d$export$2e2bcd8739ae039 = (0, $9QBug.default)("scale", $0ca1411ae90a041d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $445e5c36990c15a3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z",
            key: "17jzev"
        }
    ]
];
const $445e5c36990c15a3$export$2e2bcd8739ae039 = (0, $9QBug.default)("thermometer", $445e5c36990c15a3$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $434e7bc41e3193cc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.8 19.6A2 2 0 1 0 14 16H2",
            key: "148xed"
        }
    ],
    [
        "path",
        {
            d: "M17.5 8a2.5 2.5 0 1 1 2 4H2",
            key: "1u4tom"
        }
    ],
    [
        "path",
        {
            d: "M9.8 4.4A2 2 0 1 1 11 8H2",
            key: "75valh"
        }
    ]
];
const $434e7bc41e3193cc$export$2e2bcd8739ae039 = (0, $9QBug.default)("wind", $434e7bc41e3193cc$export$3efd853dbb351e94);



var $jTCZr = parcelRequire("jTCZr");


// The shared definitions name their icon; the desktop resolves it to a lucide
// component (a constants module stays free of React imports).
const $45176aa1d6f403ce$var$ICONS = {
    HeartPulse: $ljvFv.default,
    Activity: $k2reB.default,
    Thermometer: $445e5c36990c15a3$export$2e2bcd8739ae039,
    Wind: $434e7bc41e3193cc$export$2e2bcd8739ae039,
    Scale: $0ca1411ae90a041d$export$2e2bcd8739ae039
};
const $45176aa1d6f403ce$export$7be94d9308953985 = (0, $bf42e0131d395ab7$export$92cbb70125dbdf80).map((d)=>({
        ...d,
        Icon: $45176aa1d6f403ce$var$ICONS[d.icon] || (0, $k2reB.default)
    }));
const $45176aa1d6f403ce$export$2c2158458d644e4b = (s)=>s === 'abnormal' || s === 'ABNORMAL';
const $45176aa1d6f403ce$export$32de35ebf66c4eca = (s)=>s === 'critical' || s === 'CRITICAL';
const $45176aa1d6f403ce$export$a1176940376eb77f = (t)=>({
        critical: t('visit.vitals.critical'),
        abnormal: t('visit.vitals.abnormal'),
        normal: t('patient.obs.normal')
    });
const $45176aa1d6f403ce$export$1094b4db5e23d27c = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? 'critical' : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? 'abnormal' : 'normal';
const $45176aa1d6f403ce$export$348dc3495f07d294 = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).warn : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).good;
const $45176aa1d6f403ce$export$eafbb00f0f1ef8c5 = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? (0, $jTCZr.CT).dangerSoft : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? (0, $jTCZr.CT).warnSoft : 'transparent';
const $45176aa1d6f403ce$export$bd269aa233c571a9 = (r)=>typeof r?.numVal === 'number' ? r.numVal : parseFloat(r?.value);



var $acw62 = parcelRequire("acw62");


function $a0dafa72fb6939ff$export$4acc038e2d2fe1df(patient) {
    const vitals = (0, $065bc8b7ead4fbf6$export$dbab5d47820ca910)(patient?.id);
    const seriesMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$1be0eaa0fb63147e)(patient?.clinicalObservations), [
        patient?.clinicalObservations
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$e4e463683289edb3)(seriesMap), [
        seriesMap
    ]);
    const panels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$8020253fe86b6056)(counts).map((c)=>({
                ...c,
                flagged: (0, $00011fef9dd464cc$export$f9b3ea7266dcc489)(seriesMap, c.id)
            })), [
        counts,
        seriesMap
    ]);
    const [activeCategory, setActiveCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (activeCategory || !Object.keys(counts).length) return;
        setActiveCategory((0, $00011fef9dd464cc$export$dbdc2bb8017e2c29)(counts));
    }, [
        counts
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const categoryTests = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00011fef9dd464cc$export$930962f873333845)(seriesMap, activeCategory), [
        seriesMap,
        activeCategory
    ]);
    // ── One selection across both families ────────────────────────────────────
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const selectedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(selected);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        selectedRef.current = selected;
    }, [
        selected
    ]);
    // Opening a panel selects its first test — unless the doctor is currently
    // reading a vital, which must not be yanked away underneath them.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!categoryTests.length) return;
        const cur = selectedRef.current;
        if (cur?.type === 'vital') return;
        const stillListed = cur?.type === 'lab' && categoryTests.some((test)=>test.display === cur.display);
        if (!stillListed) setSelected({
            type: 'lab',
            display: categoryTests[0].display
        });
    }, [
        categoryTests
    ]);
    const openPanel = (catId)=>{
        if (activeCategory === catId) {
            setActiveCategory(null);
            setSelected(null);
            return;
        }
        setActiveCategory(catId);
        const first = (0, $00011fef9dd464cc$export$930962f873333845)(seriesMap, catId)[0];
        setSelected(first ? {
            type: 'lab',
            display: first.display
        } : null);
    };
    return {
        // vitals (from the shared hook)
        vitalsByLoinc: vitals.byLoinc,
        vitalsLoading: vitals.loading,
        vitalsError: vitals.error,
        flaggedVitals: vitals.flagged,
        retryVitals: vitals.retry,
        seriesMap: // labs
        seriesMap,
        counts: counts,
        panels: panels,
        categoryTests: categoryTests,
        activeCategory: activeCategory,
        openPanel: openPanel,
        hasObservations: Object.keys(seriesMap).length > 0,
        selected: // selection
        selected,
        setSelected: setSelected
    };
}



var $acw62 = parcelRequire("acw62");

// The «مشاهدات» section's zone heading: a coloured dot, the zone's name, its
// technical vocabulary, and an optional right-aligned status summary. Used twice
// (علائم حیاتی and آزمایش‌ها) so the two zones read as one section.
const $35983bafd431f487$var$SectionHead = ({ dot: dot = (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent, title: title, hint: hint, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.625rem',
            height: '0.625rem',
            borderRadius: '50%',
            background: dot,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, hint)), summary);
var $35983bafd431f487$export$2e2bcd8739ae039 = $35983bafd431f487$var$SectionHead;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $3Amwd = parcelRequire("3Amwd");

var $jTCZr = parcelRequire("jTCZr");




// One vital sign as a selectable tile: name, latest value, change against the
// previous reading, a trend glyph and the reference range. Selecting it drives
// the section's shared detail rail — so it is the kit `Button` re-laid-out as a
// card (DESIGN §1.2), never a styled div with an onClick.
const $c5d0b046c6a6fc0f$var$VitalTile = ({ def: def, readings: readings = [], selected: selected, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    const latest = readings[readings.length - 1];
    const prev = readings[readings.length - 2];
    const tone = (0, $45176aa1d6f403ce$export$348dc3495f07d294)(latest?.status);
    const delta = latest && prev && !Number.isNaN((0, $45176aa1d6f403ce$export$bd269aa233c571a9)(latest)) && !Number.isNaN((0, $45176aa1d6f403ce$export$bd269aa233c571a9)(prev)) ? (0, $45176aa1d6f403ce$export$bd269aa233c571a9)(latest) - (0, $45176aa1d6f403ce$export$bd269aa233c571a9)(prev) : null;
    const points = readings.map((0, $45176aa1d6f403ce$export$bd269aa233c571a9)).filter((v)=>!Number.isNaN(v));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onSelect,
        "aria-pressed": !!selected,
        "data-testid": `observations-vital-${def.id}`,
        "data-state": latest ? 'content' : 'empty',
        className: "h-auto w-full flex-col items-stretch justify-start gap-0 rounded-xl p-3 text-right font-normal",
        style: {
            background: selected ? (0, $jTCZr.soft)(tone, 0.06) : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            borderColor: selected ? tone : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.4375rem',
            marginBottom: '0.4375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(def.Icon, {
        size: 15,
        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2,
            fontWeight: 600,
            flex: 1
        }
    }, t(def.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: latest ? tone : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border
        }
    })), latest ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.5rem',
            fontWeight: 700,
            color: tone,
            direction: 'ltr'
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(latest.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, def.unit), delta !== null && delta !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: delta > 0 ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).goodInk,
            marginInlineStart: 'auto'
        }
    }, delta > 0 ? "\u2191" : "\u2193", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)((0, $00011fef9dd464cc$export$5050dfaf8101b0e4)(delta), formatDigits))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginTop: '0.375rem',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(latest.date, formatDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 70,
        height: 22,
        tone: tone === (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).good ? 'accent' : 'danger'
    })), def.refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            marginTop: '0.1875rem',
            direction: 'ltr',
            unicodeBidi: 'isolate',
            textAlign: 'start'
        }
    }, t('patient.obs.referenceLabel'), " ", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(def.refLow, formatDigits), "\u2013", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(def.refHigh, formatDigits), " ", def.unit)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            marginTop: '0.25rem'
        }
    }, t('patient.obs.notRecorded')));
};
var $c5d0b046c6a6fc0f$export$2e2bcd8739ae039 = $c5d0b046c6a6fc0f$var$VitalTile;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");


// One laboratory panel (بیوشیمی، هماتولوژی، تیروئید…) as a selectable tile:
// how many analytes it holds, and a danger dot when any of them has ever come
// back out of range. Selecting it opens that panel's test list below.
//
// `color` is the panel's identity hue from the shared lab taxonomy — a
// categorical palette (18 panels the brand tokens cannot tell apart), used only
// to distinguish panels from each other; status still speaks in semantic tokens.
const $29e63e805722b904$var$PanelTile = ({ id: id, label: label, color: color, count: count = 0, flagged: flagged = 0, active: active, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const hue = color || (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent;
    const hasData = count > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onSelect,
        "aria-pressed": !!active,
        "data-testid": `observations-panel-${id}`,
        "data-state": hasData ? 'content' : 'empty',
        className: "h-auto w-full flex-col items-stretch justify-start gap-0 rounded-lg p-3 text-right font-normal",
        style: {
            background: active ? (0, $jTCZr.soft)(hue, 0.08) : hasData ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface2,
            borderColor: active ? hue : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.3125rem',
            marginBottom: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.4375rem',
            height: '0.4375rem',
            borderRadius: '50%',
            background: hasData ? hue : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border,
            flexShrink: 0
        }
    }), flagged > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": t('patient.obs.outOfRangeCount', {
            count: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(flagged, formatDigits)
        }),
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger,
            flexShrink: 0,
            marginInlineStart: 'auto'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: active ? hue : hasData ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1 : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            marginTop: '0.3125rem',
            fontWeight: hasData ? 600 : 400,
            color: hasData ? active ? hue : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, hasData ? t('patient.obs.observationCount', {
        count: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(count, formatDigits)
    }) : t('patient.obs.noData')));
};
var $29e63e805722b904$export$2e2bcd8739ae039 = $29e63e805722b904$var$PanelTile;



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $3Amwd = parcelRequire("3Amwd");

var $jTCZr = parcelRequire("jTCZr");

var $4CVxl = parcelRequire("4CVxl");



// The selected panel's analytes, one row each: name, trend glyph, latest value
// and status. Rows drive the shared detail rail, so each is the kit `Button`
// re-laid-out as a table row.
const $ed28e0b1a389c1e7$var$ObservationList = ({ category: category, tests: tests = [], selectedDisplay: selectedDisplay, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const hue = category?.color || (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-list",
        "data-state": tests.length ? 'content' : 'empty',
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            borderRadius: '0.6875rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.6875rem 0.9375rem',
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: hue,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1
        }
    }, category?.labelKey && t(category.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            marginInlineStart: 'auto'
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(tests.length, formatDigits), " ", t('patient.obs.view'))), tests.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 36,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.noneInCategory'),
        description: t('patient.obs.resultsAppearHere')
    }) : tests.map((s, i)=>{
        const last = s.readings[s.readings.length - 1];
        const tone = (0, $45176aa1d6f403ce$export$348dc3495f07d294)(last?.status);
        const selected = selectedDisplay === s.display;
        const points = s.readings.map((0, $45176aa1d6f403ce$export$bd269aa233c571a9)).filter((v)=>!Number.isNaN(v));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: s.display,
            variant: "ghost",
            onClick: ()=>onSelect(s.display),
            "aria-pressed": selected,
            "data-testid": `observations-row-${s.display}`,
            className: "h-auto w-full justify-start gap-3 rounded-none px-4 py-3 text-right font-normal hover:bg-muted/60",
            style: {
                background: selected ? (0, $jTCZr.soft)(hue, 0.06) : 'transparent',
                borderInlineStart: `3px solid ${selected ? hue : 'transparent'}`,
                borderBottom: i < tests.length - 1 ? `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
                flex: 1,
                direction: 'ltr',
                unicodeBidi: 'isolate',
                textAlign: 'start'
            }
        }, s.display), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: points,
            width: 56,
            height: 20,
            tone: (0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(last?.status) === 'normal' ? 'accent' : 'danger'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                direction: 'ltr',
                fontWeight: (0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(last?.status) === 'normal' ? 500 : 700,
                color: tone,
                minWidth: '5.625rem',
                textAlign: 'end'
            }
        }, last ? `${(0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(last.value, formatDigits)} ${s.unit || ''}`.trim() : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem',
                fontSize: '0.71875rem',
                color: tone,
                minWidth: '4.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: tone,
                flexShrink: 0
            }
        }), (0, $45176aa1d6f403ce$export$a1176940376eb77f)(t)[(0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(last?.status)]));
    }));
};
var $ed28e0b1a389c1e7$export$2e2bcd8739ae039 = $ed28e0b1a389c1e7$var$ObservationList;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $ePaaC = parcelRequire("ePaaC");

var $jTCZr = parcelRequire("jTCZr");

var $6TdpC = parcelRequire("6TdpC");




// The section's one detail rail — whichever observation is selected, vital or
// analyte, renders here in the same shape: identity, current value, the trend,
// then every reading. Only the two families' *sources* differ, and the tab
// normalises that before it gets here (`detail`), which is why one rail can
// serve both.
//
// The readings table is the chart's accessible equivalent (the chart itself is
// aria-hidden), so it always renders — never behind a toggle.
const $f68b3042ba8834db$var$ObservationDetail = ({ detail: detail, onDeleteReading: onDeleteReading })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    if (!detail) return null;
    const tone = (0, $45176aa1d6f403ce$export$348dc3495f07d294)(detail.status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: '4.625rem'
        },
        "data-testid": "observations-detail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            border: `1.5px solid ${(0, $jTCZr.soft)(detail.categoryColor, 0.35)}`,
            borderRadius: '0.8125rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem',
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.3125rem',
            padding: '0.125rem 0.5625rem',
            borderRadius: '0.3125rem',
            fontSize: '0.71875rem',
            fontWeight: 600,
            background: (0, $jTCZr.soft)(detail.categoryColor, 0.08),
            color: detail.categoryColor,
            border: `1px solid ${(0, $jTCZr.soft)(detail.categoryColor, 0.2)}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: detail.categoryColor
        }
    }), detail.categoryLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginTop: '0.5rem'
        }
    }, detail.Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(detail.Icon, {
        size: 17,
        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.0625rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
            direction: 'ltr',
            unicodeBidi: 'isolate',
            textAlign: 'start'
        }
    }, detail.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.875rem',
            fontWeight: 700,
            color: tone,
            direction: 'ltr',
            letterSpacing: '-0.01em'
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(detail.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, detail.unit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.3125rem',
            marginInlineStart: 'auto',
            fontSize: '0.78125rem',
            fontWeight: 600,
            color: tone
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: tone
        }
    }), (0, $45176aa1d6f403ce$export$a1176940376eb77f)(t)[(0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(detail.status)])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            marginTop: '0.25rem'
        }
    }, t('patient.obs.lastRecorded'), " ", (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(detail.date, formatDate), " \xb7 ", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(detail.readings.length, formatDigits), " ", t('patient.obs.result'))), detail.readings.filter((r)=>!Number.isNaN((0, $45176aa1d6f403ce$export$bd269aa233c571a9)(r))).length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem',
            borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ePaaC.default), {
        readings: detail.readings,
        color: detail.categoryColor,
        refLow: detail.refLow,
        refHigh: detail.refHigh,
        height: 156,
        formatX: (r)=>(0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(r.date, formatDate),
        formatValue: (v)=>(0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(v.toFixed(1), formatDigits),
        "data-testid": "observations-trend"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t('patient.obs.valueHistory'), " ", detail.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface2
        }
    }, [
        t('common.labels.date'),
        t('common.labels.value'),
        t('patient.obs.change'),
        t('common.labels.status'),
        ''
    ].map((h, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            scope: "col",
            style: {
                textAlign: 'start',
                padding: '0.5rem 1rem',
                fontSize: '0.6875rem',
                fontWeight: 600,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
            }
        }, h)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, [
        ...detail.readings
    ].reverse().map((r, i, rows)=>{
        const prev = rows[i + 1];
        const delta = prev && !Number.isNaN((0, $45176aa1d6f403ce$export$bd269aa233c571a9)(r)) && !Number.isNaN((0, $45176aa1d6f403ce$export$bd269aa233c571a9)(prev)) ? (0, $45176aa1d6f403ce$export$bd269aa233c571a9)(r) - (0, $45176aa1d6f403ce$export$bd269aa233c571a9)(prev) : null;
        const rTone = (0, $45176aa1d6f403ce$export$348dc3495f07d294)(r.status);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: r.id,
            style: {
                background: (0, $45176aa1d6f403ce$export$eafbb00f0f1ef8c5)(r.status)
            },
            "data-testid": `observations-reading-${r.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2
            }
        }, (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(r.date, formatDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
                direction: 'ltr',
                unicodeBidi: 'isolate',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: rTone,
                fontWeight: (0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(r.status) === 'normal' ? 500 : 700
            }
        }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(r.value, formatDigits), " ", detail.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
                direction: 'ltr',
                textAlign: 'start',
                color: delta == null ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3 : delta > 0 ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).goodInk
            }
        }, delta == null ? "\u2014" : (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(`${delta > 0 ? '+' : '-'}${(0, $00011fef9dd464cc$export$5050dfaf8101b0e4)(delta)}`, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem',
                color: rTone,
                fontSize: '0.75rem',
                fontWeight: 500
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: rTone
            }
        }), (0, $45176aa1d6f403ce$export$a1176940376eb77f)(t)[(0, $45176aa1d6f403ce$export$1094b4db5e23d27c)(r.status)])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`
            }
        }, detail.canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-8 w-8 text-destructive",
            "aria-label": t('patient.obs.removeValueAria', {
                date: (0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(r.date, formatDate)
            }),
            "data-testid": `observations-reading-delete-${r.id}`,
            onClick: ()=>onDeleteReading(r.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))));
    })))));
};
var $f68b3042ba8834db$export$2e2bcd8739ae039 = $f68b3042ba8834db$var$ObservationDetail;


// ─────────────────────────────────────────────────────────────────────────────
// «مشاهدات» — the record's measured-values tab: vital signs and laboratory
// analytes, two families the doctor reads the same way (latest value, is it in
// range, how has it moved), so they share one section and one detail rail.
//
// This file is composition + the normalisation that turns either family into
// the rail's single shape. Data/selection live in `useObservations`, markup in
// `web/observations/*` (DESIGN §1.2 / §2.6).
// ─────────────────────────────────────────────────────────────────────────────
const $d25dbf9aade1aa26$var$ClinicalObservationsTab = ({ p: p, onRefresh: onRefresh })=>{
    const { formatDigits: formatDigits, formatList: formatList, t: t } = (0, $LNQP4.default)();
    const o = (0, $a0dafa72fb6939ff$export$4acc038e2d2fe1df)(p);
    const [confirmObs, setConfirmObs] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deleteError, setDeleteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Both families normalise into one detail shape — the reason a single rail can
    // render a vital and an analyte without knowing which it got.
    const detail = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const sel = o.selected;
        if (!sel) return null;
        if (sel.type === 'vital') {
            const def = (0, $45176aa1d6f403ce$export$7be94d9308953985).find((d)=>d.id === sel.defId);
            const readings = def ? o.vitalsByLoinc[def.loinc] : null;
            if (!def || !readings?.length) return null;
            const last = readings[readings.length - 1];
            return {
                categoryLabel: t('patient.labCategory.vitals'),
                categoryColor: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent,
                Icon: def.Icon,
                displayName: def.label,
                value: last.value,
                unit: def.unit,
                status: last.status,
                date: last.date,
                readings: readings,
                refLow: def.refLow,
                refHigh: def.refHigh,
                canDelete: false
            };
        }
        const series = o.seriesMap[sel.display];
        const last = series?.readings[series.readings.length - 1];
        if (!last) return null;
        const cat = (0, $bf42e0131d395ab7$export$5a8441d057c1b67f).find((c)=>c.id === series.catId);
        return {
            categoryLabel: `\u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}\u{6AF}\u{627}\u{647}\u{6CC} \xb7 ${cat?.label || t('common.state.other')}`,
            categoryColor: cat?.color || (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent,
            Icon: null,
            displayName: series.display,
            value: last.value,
            unit: series.unit,
            status: last.status,
            date: last.date,
            readings: series.readings,
            refLow: null,
            refHigh: null,
            canDelete: true
        };
    }, [
        o.selected,
        o.vitalsByLoinc,
        o.seriesMap,
        t
    ]);
    const deleteReading = (id)=>{
        setDeleteError(null);
        (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$725e3ec3814f10de), {
            id: id
        }).then(onRefresh)// A silent no-op after a confirmed delete reads as "it worked" (§14.3).
        .catch((e)=>setDeleteError(e?.message || String(e)));
    };
    const activePanel = o.panels.find((c)=>c.id === o.activeCategory);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35983bafd431f487$export$2e2bcd8739ae039), {
        title: t('patient.labCategory.vitals'),
        hint: t('patient.obs.vitalsCaption'),
        summary: !o.vitalsLoading && !o.vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: o.flaggedVitals.length ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerInk : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).goodInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: o.flaggedVitals.length ? (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger : (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).good
            }
        }), o.flaggedVitals.length ? t('patient.obs.outOfRangeShort', {
            count: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(o.flaggedVitals.length, formatDigits)
        }) : t('patient.obs.allNormal'))
    }), o.flaggedVitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerSoft,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger}`,
            borderRadius: '0.5rem',
            padding: '0.625rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.78125rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600
        }
    }, t('patient.obs.outOfRangeCount', {
        count: (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(o.flaggedVitals.length, formatDigits)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).danger
        }
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatList(o.flaggedVitals.map((d)=>d.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: detail ? '1fr 23.75rem' : '1fr',
            gap: '0.875rem',
            alignItems: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-vitals",
        "data-state": o.vitalsLoading ? 'loading' : o.vitalsError ? 'error' : 'content'
    }, o.vitalsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.obs.vitalsHistoryFailed'),
        detail: o.vitalsError?.message || String(o.vitalsError),
        onRetry: o.retryVitals
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(10.9375rem, 1fr))',
            gap: '0.625rem'
        }
    }, o.vitalsLoading ? (0, $45176aa1d6f403ce$export$7be94d9308953985).map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1e1ffd8e261dcdc$export$cb1cd28f421b0672), {
            key: d.id
        })) : (0, $45176aa1d6f403ce$export$7be94d9308953985).map((def)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5d0b046c6a6fc0f$export$2e2bcd8739ae039), {
            key: def.id,
            def: def,
            readings: o.vitalsByLoinc[def.loinc],
            selected: o.selected?.type === 'vital' && o.selected.defId === def.id,
            onSelect: ()=>o.setSelected({
                    type: 'vital',
                    defId: def.id
                })
        })))), p.bmi != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
            border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
            borderRadius: '0.75rem',
            padding: '0.875rem 1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
        size: 18,
        color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accent,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text2,
            fontWeight: 500
        }
    }, t('patient.vitals.bmi')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 700,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1,
            direction: 'ltr'
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.bmi.toFixed(1), formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, "kg/m\xb2"), p.lastWeight && p.height && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
        }
    }, (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.lastWeight, formatDigits), " kg \xb7 ", (0, $3a8eaefcca13cf5f$export$25b095a1ad9e1176)(p.height, formatDigits), " cm")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35983bafd431f487$export$2e2bcd8739ae039), {
        dot: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).navy,
        title: t('visit.orders.tests'),
        hint: t('patient.obs.labCaption')
    })), o.hasObservations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-panels",
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(8.75rem, 1fr))',
            gap: '0.5rem'
        }
    }, o.panels.map((cat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29e63e805722b904$export$2e2bcd8739ae039), {
            key: cat.id,
            ...cat,
            active: o.activeCategory === cat.id,
            onSelect: ()=>o.openPanel(cat.id)
        }))), o.activeCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed28e0b1a389c1e7$export$2e2bcd8739ae039), {
        category: activePanel,
        tests: o.categoryTests,
        selectedDisplay: o.selected?.type === 'lab' ? o.selected.display : null,
        onSelect: (display)=>o.setSelected({
                type: 'lab',
                display: display
            })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "observations-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.noLabResults'),
        description: t('patient.obs.uploadHintFiles')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f68b3042ba8834db$export$2e2bcd8739ae039), {
        detail: detail,
        onDeleteReading: setConfirmObs
    })), deleteError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        title: t('patient.obs.deleteResultFailed'),
        detail: deleteError,
        onRetry: ()=>setDeleteError(null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: !!confirmObs,
        onOpenChange: (open)=>{
            if (!open) setConfirmObs(null);
        },
        title: t('patient.obs.deleteResult'),
        message: t('patient.obs.deleteResultConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>deleteReading(confirmObs)
    }));
};
var $d25dbf9aade1aa26$export$2e2bcd8739ae039 = $d25dbf9aade1aa26$var$ClinicalObservationsTab;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $ggYuf = parcelRequire("ggYuf");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");


var $a83Oj = parcelRequire("a83Oj");


var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
/**
 * The result state of one order, as a compact chip group.
 *
 * Presentational only: it takes an order and renders how many documents have
 * arrived and whether they have been read. It never derives that state —
 * `reviewStatus` is computed by clinicalencounter and re-deriving it here would be a
 * second copy of the rule, free to disagree with the first.
 *
 * Colours come from the same CSS variables the Visit page's order status pill
 * uses, so the two read as one system rather than as two independent badges that
 * happen to sit near each other.
 */ const $adc2a88d4c0b6ec2$var$TONE = {
    none: {
        bg: 'var(--panel-2)',
        fg: 'var(--mute)'
    },
    awaiting_review: {
        bg: 'var(--warn-soft)',
        fg: 'var(--warn-ink)'
    },
    accepted: {
        bg: 'var(--good-soft)',
        fg: 'var(--good-ink)'
    },
    // Attention, not error: nothing failed — the patient is being asked for one
    // more action. Red here would say something broke.
    needs_resubmission: {
        bg: 'var(--warn-soft)',
        fg: 'var(--warn-ink)'
    }
};
const $adc2a88d4c0b6ec2$var$LABEL_KEY = {
    none: 'visit.orders.result.none',
    awaiting_review: 'visit.orders.result.awaiting',
    accepted: 'visit.orders.result.accepted',
    needs_resubmission: 'visit.orders.result.needsResubmission'
};
function $adc2a88d4c0b6ec2$export$f60e5202fed3ee65(status) {
    const key = String(status || 'none').toLowerCase().replace(/-/g, '_');
    return $adc2a88d4c0b6ec2$var$LABEL_KEY[key] ? key : 'none';
}
function $adc2a88d4c0b6ec2$export$baa601d96b21e0d1(order) {
    const type = String(order?.orderType || '').toLowerCase();
    return type.includes('lab') || type.includes('imag') || type.includes('radiolog');
}
function $adc2a88d4c0b6ec2$export$2e2bcd8739ae039({ order: order, onOpen: onOpen, compact: compact = false }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!order || !$adc2a88d4c0b6ec2$export$baa601d96b21e0d1(order)) return null;
    const status = $adc2a88d4c0b6ec2$export$f60e5202fed3ee65(order.reviewStatus);
    const files = order.resultFiles || [];
    const tone = $adc2a88d4c0b6ec2$var$TONE[status];
    // An order with no result and nothing to read offers nothing to open — the row
    // stays quiet rather than growing a button that leads to an empty drawer.
    const actionable = files.length > 0 || status !== 'none';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `order-result-chips-${order.id}`,
        "data-review-status": status,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            color: 'var(--mute)',
            fontWeight: 600
        }
    }, t('visit.orders.result.title')), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 999,
            background: 'var(--panel-2)',
            color: 'var(--ink)',
            whiteSpace: 'nowrap'
        }
    }, files.length, " ", t('visit.orders.result.fileCount')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "order-result-status",
        style: {
            fontSize: 10,
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 999,
            background: tone.bg,
            color: tone.fg,
            whiteSpace: 'nowrap'
        }
    }, t($adc2a88d4c0b6ec2$var$LABEL_KEY[status])), actionable && onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onOpen(order),
        "data-testid": "order-result-open",
        style: {
            fontSize: 10,
            fontWeight: 700,
            padding: compact ? '1px 7px' : '2px 9px',
            borderRadius: 6,
            cursor: 'pointer',
            border: '1px solid var(--line)',
            background: 'var(--panel)',
            color: status === 'awaiting_review' ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, status === 'awaiting_review' ? t('visit.orders.result.reviewCta') : t('visit.orders.result.viewCta')));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




function $b0e90198918904d7$export$2e2bcd8739ae039({ order: order, onClose: onClose, onReviewed: onReviewed }) {
    const { t: t } = (0, $LNQP4.default)();
    const [verdict, setVerdict] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [stale, setStale] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { fileId, url, type, name }
    const [loadingFile, setLoadingFile] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const files = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>order?.resultFiles || [], [
        order
    ]);
    const status = (0, $adc2a88d4c0b6ec2$export$f60e5202fed3ee65)(order?.reviewStatus);
    // Start from the verdict already recorded, so reopening a reviewed order shows
    // what was decided rather than an empty form.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setVerdict(order?.reviewVerdict || null);
        setNote(order?.reviewNote || '');
        setError('');
        setStale(false);
    }, [
        order?.id,
        order?.reviewVerdict,
        order?.reviewNote
    ]);
    // Open the first document automatically: the drawer exists to be read, and a
    // doctor who has to click once more before seeing anything is being charged
    // for the drawer's own structure.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (files.length && !preview) openFile(files[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        order?.id,
        files.length
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            if (preview?.url?.startsWith('blob:')) URL.revokeObjectURL(preview.url);
        }, [
        preview
    ]);
    async function openFile(file) {
        if (!file?.id) return;
        setLoadingFile(file.id);
        try {
            const d = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$2d0ba8abb4a3a0eb), {
                fileId: file.id
            });
            const dataUri = d?.clinicalFileUrl;
            if (!dataUri) throw new Error('no url');
            setPreview({
                fileId: file.id,
                url: dataUri,
                type: String(file.fileType || ''),
                name: file.fileName || '',
                reportText: file.reportText || ''
            });
            setError('');
        } catch (e) {
            console.error('openFile failed:', e);
            setError(t('visit.orders.result.openFailed'));
        } finally{
            setLoadingFile(null);
        }
    }
    const noteRequired = verdict === 'needs_resubmission' && !note.trim();
    const canSave = Boolean(verdict) && !noteRequired && !saving && files.length > 0;
    async function save() {
        if (!canSave) return;
        setSaving(true);
        setError('');
        setStale(false);
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$a62561eb8157d4fe), {
                orderId: order.id,
                verdict: verdict === 'accepted' ? 'ACCEPTED' : 'NEEDS_RESUBMISSION',
                note: note.trim() || null,
                // The marker this drawer was showing. Empty is allowed and simply means
                // «no guard» — but it is always sent when known.
                seenResultAt: order.lastResultAt || null
            });
            onReviewed?.(d?.reviewOrderResult || null);
            onClose?.();
        } catch (e) {
            // A newer document arrived while the drawer was open. Not the doctor's
            // mistake, and not something a retry of the same submission should fix —
            // they have to see the new file first.
            if (e?.code === 'STALE_RESULT' || /STALE_RESULT/.test(String(e?.message))) setStale(true);
            else setError(e?.message || t('visit.orders.result.saveFailed'));
        } finally{
            setSaving(false);
        }
    }
    // Ctrl+S saves, Esc closes — the two shortcuts every editing surface in this
    // app already carries.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape' && !saving) {
                onClose?.();
                return;
            }
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
                e.preventDefault();
                save();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    });
    if (!order) return null;
    const isImage = preview?.type?.startsWith('image/');
    const isPdf = preview?.type === 'application/pdf';
    const ocrRows = preview?.reportText ? (0, $bced050439dec003$export$ebcae889d05cbae5)(preview.reportText) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-drawer",
        "data-review-status": status,
        style: {
            position: 'fixed',
            insetBlock: 0,
            insetInlineEnd: 0,
            width: 'min(560px, 100vw)',
            background: 'var(--panel)',
            borderInlineStart: '1px solid var(--line)',
            boxShadow: '-8px 0 28px rgba(0, 0, 0, 0.10)',
            zIndex: 70,
            display: 'flex',
            flexDirection: 'column'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
        style: {
            fontSize: 14,
            color: 'var(--ink)'
        }
    }, t('visit.orders.result.drawerTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        disabled: saving,
        "data-testid": "result-review-close",
        style: {
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            fontSize: 18,
            lineHeight: 1,
            padding: 4
        },
        "aria-label": t('common.actions.close')
    }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            marginTop: 4,
            fontSize: 12.5,
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, order.name || order.description || "\u2014"), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 2,
            fontSize: 10,
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, order.orderType === 'procedure' ? 'CPT' : 'LOINC', " ", order.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '14px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        }
    }, stale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-stale",
        style: {
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: 11.5,
            lineHeight: 1.8,
            background: 'var(--warn-soft)',
            color: 'var(--warn-ink)',
            border: '1px solid var(--warn-ink)'
        }
    }, t('visit.orders.result.staleWarning')), files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: 12,
            color: 'var(--mute)',
            lineHeight: 1.9
        }
    }, t('visit.orders.result.noFiles')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", {
        style: {
            margin: '0 0 8px',
            fontSize: 11.5,
            color: 'var(--mute)',
            fontWeight: 700
        }
    }, t('visit.orders.result.filesTitle'), " (", files.length, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6,
            marginBottom: 10
        }
    }, files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: f.id,
            type: "button",
            onClick: ()=>openFile(f),
            "data-testid": "result-review-file",
            "data-active": preview?.fileId === f.id || undefined,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                maxWidth: 200,
                padding: '3px 8px',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 11,
                background: preview?.fileId === f.id ? 'var(--accent-soft)' : 'var(--panel-2)',
                border: `1px solid ${preview?.fileId === f.id ? 'var(--accent)' : 'var(--line)'}`,
                color: 'var(--ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loadingFile === f.id ? "\u2026" : f.fileName || "\u2014"), f.uploadedBy === 'patient' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 9,
                color: 'var(--accent-ink)',
                fontWeight: 700,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.result.uploadedByPatient'))))), preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: '1px solid var(--line)',
            borderRadius: 8,
            overflow: 'hidden',
            background: 'var(--panel-2)',
            minHeight: 220,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: preview.url,
        alt: preview.name,
        "data-testid": "result-review-image",
        style: {
            maxWidth: '100%',
            maxHeight: 420,
            display: 'block'
        }
    }), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: preview.name,
        src: preview.url,
        "data-testid": "result-review-pdf",
        style: {
            width: '100%',
            height: 420,
            border: 'none'
        }
    }), !isImage && !isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: preview.url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            padding: 20,
            fontSize: 12
        }
    }, preview.name)), (0, $bced050439dec003$export$c2a61e046b7fd3b2)(preview?.reportText || '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 10,
            fontSize: 11,
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'var(--mute)',
            marginBottom: 4
        }
    }, "OCR \u2014 ", (0, $bced050439dec003$export$6e0aae7ac52ee4b7)(ocrRows), " / ", ocrRows.length))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", {
        style: {
            margin: '0 0 8px',
            fontSize: 11.5,
            color: 'var(--mute)',
            fontWeight: 700
        }
    }, t('visit.orders.result.verdictTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            marginBottom: 10
        }
    }, [
        {
            key: 'accepted',
            label: t('visit.orders.result.accepted')
        },
        {
            key: 'needs_resubmission',
            label: t('visit.orders.result.needsResubmission')
        }
    ].map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.key,
            type: "button",
            onClick: ()=>setVerdict(opt.key),
            disabled: files.length === 0,
            "data-testid": `result-verdict-${opt.key}`,
            "data-selected": verdict === opt.key || undefined,
            style: {
                flex: 1,
                padding: '7px 10px',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: 12,
                fontWeight: 700,
                background: verdict === opt.key ? 'var(--accent-soft)' : 'var(--panel-2)',
                border: `1px solid ${verdict === opt.key ? 'var(--accent)' : 'var(--line)'}`,
                color: verdict === opt.key ? 'var(--accent-ink)' : 'var(--mute)'
            }
        }, opt.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'block',
            fontSize: 11,
            color: 'var(--mute)',
            marginBottom: 4
        }
    }, t('visit.orders.result.noteLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        value: note,
        onChange: (e)=>setNote(e.target.value),
        dir: "auto",
        rows: 4,
        "data-testid": "result-review-note",
        placeholder: t('visit.orders.result.noteHint'),
        style: {
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            resize: 'vertical',
            border: `1px solid ${noteRequired ? 'var(--danger-ink)' : 'var(--line)'}`,
            background: 'var(--panel)',
            color: 'var(--ink)',
            fontSize: 12,
            lineHeight: 1.9,
            fontFamily: 'inherit'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 10.5,
            color: noteRequired ? 'var(--danger-ink)' : 'var(--mute)',
            lineHeight: 1.8
        }
    }, noteRequired ? t('visit.orders.result.noteRequired') : t('visit.orders.result.noteHint')), order.reviewedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: 10.5,
            color: 'var(--mute)'
        }
    }, t('visit.orders.result.lastReviewed'), ": ", String(order.reviewedAt).slice(0, 10))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-error",
        style: {
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: 11.5,
            background: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        }
    }, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '12px 16px',
            borderTop: '1px solid var(--line)',
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        disabled: saving,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: 12,
            border: '1px solid var(--line)',
            background: 'var(--panel)',
            color: 'var(--mute)'
        }
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: save,
        disabled: !canSave,
        "data-testid": "result-review-save",
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            cursor: canSave ? 'pointer' : 'not-allowed',
            border: '1px solid var(--accent)',
            background: canSave ? 'var(--accent)' : 'var(--panel-2)',
            color: canSave ? '#fff' : 'var(--mute)'
        }
    }, saving ? t('visit.orders.result.saving') : t('visit.orders.result.save'))));
}








// Post-visit SOAP amendment rail. amendClinicalNote (unlike updateClinicalNote,
// the in-visit autosave) is attributed to the calling doctor server-side: the
// prior content is snapshotted into the revision history and updatedAt stamped.
const $347125b38e367f5e$var$AMEND_CLINICAL_NOTE = `
  mutation AmendClinicalNote($id: ID!, $input: UpdateClinicalNoteInput!) {
    amendClinicalNote(id: $id, input: $input) { id content updatedAt }
  }
`;
// First post-visit save on a visit that never got a SOAP row: a plain create —
// there is no prior content, so correctly no revision either.
const $347125b38e367f5e$var$CREATE_SOAP_NOTE = `
  mutation CreateClinicalNote($patientId: ID!, $input: ClinicalNoteInput!) {
    createClinicalNote(patientId: $patientId, input: $input) { id content createdAt updatedAt }
  }
`;
const $347125b38e367f5e$var$CLINICAL_NOTE_REVISIONS = `
  query ClinicalNoteRevisions($appointmentId: ID!) {
    clinicalNoteRevisions(appointmentId: $appointmentId) {
      id noteId editedBy editedAt content
    }
  }
`;
// Full localised timestamp for amendment metadata — unlike isoToJalali (date
// only), an edit stamp without its time is not a usable سابقه. A plain helper,
// so it takes the formatter as an argument rather than calling the hook.
const $347125b38e367f5e$var$isoToJalaliDT = (iso, formatDateTime)=>{
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return formatDateTime(d, 'short');
};
// A visit IS a scheduling appointment. The BFF (apptToEncounter) normalizes the
// appointment's type to 'in-person'|'online' and its status to
// planned|arrived|in_progress|finished|cancelled. Legacy keys kept for old rows.
const $347125b38e367f5e$var$ENC_TYPE_KEYS = (t)=>({
        'in-person': t('encounters.type.inPerson'),
        online: t('encounters.type.online'),
        OUTPATIENT: t('patient.encType.outpatient'),
        INPATIENT: t('patient.encType.inpatient'),
        EMERGENCY: t('common.urgency.emergency'),
        FOLLOW_UP: t('patient.encType.followUp'),
        outpatient: t('patient.encType.outpatient'),
        inpatient: t('patient.encType.inpatient'),
        emergency: t('common.urgency.emergency'),
        follow_up: t('patient.encType.followUp')
    });
const $347125b38e367f5e$var$ENC_STATUS_KEYS = (t)=>({
        planned: t('encounters.status.scheduled'),
        arrived: t('encounters.status.arrived'),
        in_progress: t('common.state.inProgress'),
        finished: t('patient.encStatus.finished'),
        'in-progress': t('common.state.inProgress'),
        completed: t('patient.encStatus.finished'),
        cancelled: t('patient.encStatus.cancelled'),
        'on-hold': t('visit.state.onHold'),
        active: t('common.state.inProgress')
    });
// The four SOAP sections. `k` is the mnemonic letter, which is already the
// whole point of the initialism — so there is no English `hint` beside the
// Persian name any more.
//
// There was one, a literal 'Subjective' / 'Objective' / … never wired to t(),
// sitting at the far end of the label row. In a Persian record it read as data
// rather than as a label: a clinic reported «معاینه و یافته‌ها / Objective /
// <the dentist's text>» as weird content in the patient's file. The phone
// surface never had it (constants/patientRecord.js carries only `nameKey`), so
// removing it also makes the two agree.
const $347125b38e367f5e$var$SOAP_SECTIONS = (t)=>[
        {
            k: 'S',
            name: t('visit.soap.subjective'),
            types: [
                'SOAP_S',
                'subjective',
                'chief_complaint',
                'history'
            ]
        },
        {
            k: 'O',
            name: t('visit.soap.objective'),
            types: [
                'SOAP_O',
                'objective',
                'examination',
                'findings'
            ]
        },
        {
            k: 'A',
            name: t('patient.soap.assessment'),
            types: [
                'SOAP_A',
                'assessment',
                'evaluation'
            ]
        },
        {
            k: 'P',
            name: t('patient.soap.plan'),
            types: [
                'SOAP_P',
                'plan',
                'treatment_plan'
            ]
        }
    ];
const $347125b38e367f5e$var$ORDER_URG_CLS = {
    stat: 'stat',
    urgent: 'urgent',
    routine: 'routine',
    requested: 'requested',
    active: 'active',
    completed: 'routine'
};
// The AI service answers with an English confidence level; the panel is Persian.
const $347125b38e367f5e$var$AI_CONFIDENCE = (t)=>({
        high: t('visit.vitals.high'),
        medium: t('credits.level.midShort'),
        low: t('visit.vitals.low')
    });
const $347125b38e367f5e$var$AI_QUICK_Q = (t)=>[
        t('visit.quick.a1cTrend'),
        t('visit.quick.medChanges'),
        t('visit.quick.openOrders'),
        t('visit.quick.sixMonthCourse')
    ];
const $347125b38e367f5e$var$VisitsTab = ({ p: p, onRefresh: onRefresh })=>{
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.encounters || []
        ].sort((a, b)=>(b.scheduledDate || b.createdAt || '').localeCompare(a.scheduledDate || a.createdAt || '')), [
        p.encounters
    ]);
    const [selEncId, setSelEncId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>encounters[0]?.id || null);
    const [rightTab, setRightTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('visits');
    const [innerTab, setInnerTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('soap');
    const [encOrders, setEncOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // The order whose result is being reviewed, or null. Held here rather than
    // in the row so the drawer survives the list re-rendering under it.
    const [reviewOrder, setReviewOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [leftOpen, setLeftOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [aiQ, setAiQ] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // The assistant is a conversation, not a one-shot lookup: `chat` IS the
    // session memory — it renders the thread and is replayed to the BFF on every
    // turn so the answer can build on what came before.
    const [chat, setChat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [aiLoading, setAiLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const chatBodyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const chatSeq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const selEnc = encounters.find((e)=>e.id === selEncId) || encounters[0] || null;
    // ── post-visit SOAP editing ─────────────────────────────────────────────────
    // State lives HERE, not in SoapView: the inner views are inline components
    // recreated on every render, so any state inside them would be lost.
    const [editingSoap, setEditingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapDraft, setSoapDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        S: '',
        O: '',
        A: '',
        P: ''
    });
    const [savingSoap, setSavingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapSaveError, setSoapSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Saves are reflected without refetching the whole patient: an overlay of
    // {noteId: {content, updatedAt}} plus any notes created from this tab.
    const [noteOverlay, setNoteOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [createdNotes, setCreatedNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [historyOpen, setHistoryOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [revisions, setRevisions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null = not fetched yet
    const [expandedRevId, setExpandedRevId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Selecting another visit drops the edit/history UI state, never the saves.
        setEditingSoap(false);
        setSoapSaveError('');
        setHistoryOpen(false);
        setRevisions(null);
        setExpandedRevId(null);
    }, [
        selEncId
    ]);
    const encNotes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.clinicalNotes || [],
            ...createdNotes
        ].filter((n)=>n.appointmentId === selEncId).map((n)=>noteOverlay[n.id] ? {
                ...n,
                ...noteOverlay[n.id]
            } : n), [
        p.clinicalNotes,
        createdNotes,
        noteOverlay,
        selEncId
    ]);
    const encConds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalConditions || []).filter((c)=>c.appointmentId === selEncId), [
        p.clinicalConditions,
        selEncId
    ]);
    const encMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalMedications || []).filter((m)=>m.appointmentId === selEncId), [
        p.clinicalMedications,
        selEncId
    ]);
    const encObs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalObservations || []).filter((o)=>o.appointmentId === selEncId), [
        p.clinicalObservations,
        selEncId
    ]);
    const loadEncOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!selEncId || !p.id) return Promise.resolve();
        return (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$c49184db1de2de24), {
            patientId: p.id,
            appointmentId: selEncId
        }).then((d)=>setEncOrders(d.listDoctorOrders || [])).catch(()=>setEncOrders([]));
    }, [
        selEncId,
        p.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadEncOrders();
    }, [
        loadEncOrders
    ]);
    // Selecting another visit closes the drawer: it is bound to one order, and
    // leaving it open over a different visit's list would let a verdict be typed
    // against a row no longer on screen.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setReviewOrder(null);
    }, [
        selEncId
    ]);
    // A new patient is a new conversation — never carry one patient's thread over.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChat([]);
        setAiQ('');
    }, [
        p.id
    ]);
    // Keep the newest turn in view (also while the typing indicator is up).
    // Scroll the panel itself rather than scrollIntoView — the chat lives inside
    // nested scroll containers and must not drag the page along with it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = chatBodyRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        chat,
        aiLoading,
        rightTab
    ]);
    const askAi = (raw)=>{
        const q = (raw ?? aiQ).trim();
        if (!q || aiLoading) return;
        // Snapshot the thread BEFORE this turn is appended — the new question
        // travels as `question`, so replaying it here would duplicate it.
        const history = chat.filter((m)=>!m.error && m.text).map((m)=>({
                role: m.role === 'user' ? 'user' : 'assistant',
                content: m.text
            }));
        setChat((prev)=>[
                ...prev,
                {
                    id: ++chatSeq.current,
                    role: 'user',
                    text: q
                }
            ]);
        setAiQ('');
        setAiLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$b57f2fa191d92b55), {
            question: q,
            patientId: p.id,
            conversationHistory: history
        }).then((d)=>{
            const a = d.askDoctorQuestion || {};
            setChat((prev)=>[
                    ...prev,
                    {
                        id: ++chatSeq.current,
                        role: 'assistant',
                        text: a.answer || t('errors.ai.noResponse'),
                        confidence: a.confidence,
                        suggestions: a.followUpSuggestions || []
                    }
                ]);
        })// Surface the real reason — a failed turn that just says «خطا» sends the
        // doctor looking for a fault that isn't theirs (credits, service down).
        .catch((e)=>setChat((prev)=>[
                    ...prev,
                    {
                        id: ++chatSeq.current,
                        role: 'assistant',
                        error: true,
                        text: e?.extensions?.code === 'INSUFFICIENT_CREDITS' ? t('visit.copilot.notEnoughCredit') : t('visit.copilot.askError') + (e?.message ? ` \u{2014} ${e.message}` : '')
                    }
                ])).finally(()=>setAiLoading(false));
    };
    const resetChat = ()=>{
        if (!aiLoading) {
            setChat([]);
            setAiQ('');
        }
    };
    const isLive = (0, $a044c29e4a6b3520$export$9cbdfdc6daea18e2);
    const encType = (enc)=>$347125b38e367f5e$var$ENC_TYPE_KEYS(t)[enc?.type] || enc?.type || t('patient.visit');
    const encStat = (enc)=>$347125b38e367f5e$var$ENC_STATUS_KEYS(t)[(enc?.status || '').toLowerCase()] || enc?.status || '';
    const encDate = (enc)=>(0, $3a8eaefcca13cf5f$export$d5126f8c047ed6ad)(enc?.scheduledDate || enc?.createdAt, formatDate);
    const parseContent = (0, $a044c29e4a6b3520$export$90858b03e74b9658);
    const noteStr = (0, $a044c29e4a6b3520$export$9329abe70f8a78fc);
    const soapKey = (0, $a044c29e4a6b3520$export$4c2eaf911d9f840f);
    const encTitle = (enc)=>{
        const note = (p.clinicalNotes || []).find((n)=>n.appointmentId === enc.id && noteStr(n).trim());
        if (note) {
            const value = noteStr(note).trim();
            return value.slice(0, 55) + (value.length > 55 ? "\u2026" : '');
        }
        return encType(enc);
    };
    const encCounts = (encId)=>{
        const c = (p.clinicalConditions || []).filter((x)=>x.appointmentId === encId).length;
        const m = (p.clinicalMedications || []).filter((x)=>x.appointmentId === encId).length;
        return [
            c && t('patient.visits.condsCount', {
                count: c
            }),
            m && t('patient.visits.medsCount', {
                count: m
            })
        ].filter(Boolean).join(" \xb7 ");
    };
    const soapKeyFromEncNotes = (k)=>(0, $a044c29e4a6b3520$export$e6f6e37795c24083)(encNotes, k);
    const encVitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $1f9ad82cbe711bba$export$770e25a75af047b6)(t).map((v)=>{
            const obs = encObs.filter((o)=>o.code === v.code);
            const latest = obs[obs.length - 1];
            return latest ? {
                ...v,
                value: latest.value
            } : null;
        }).filter(Boolean), [
        encObs,
        t
    ]);
    // The note an amendment writes to — picked exactly the way the reader reads
    // (first SOAP row with any content; historical duplicates exist per visit).
    // Saving writes the FULL merged {s,o,a,p} into it, making it authoritative.
    const primarySoapNote = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a044c29e4a6b3520$export$b26efe9e640f95c2)(encNotes), [
        encNotes
    ]);
    const soapUpdatedAt = primarySoapNote?.updatedAt || null;
    const myDoctorId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a83Oj.parseJwt)((0, $a83Oj.getToken)() || '')?.sub || null, []);
    const startSoapEdit = ()=>{
        setSoapDraft({
            S: soapKeyFromEncNotes('S'),
            O: soapKeyFromEncNotes('O'),
            A: soapKeyFromEncNotes('A'),
            P: soapKeyFromEncNotes('P')
        });
        setSoapSaveError('');
        setEditingSoap(true);
    };
    const refreshRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((encId)=>{
        (0, $adebb901af88e18b$export$7fb4864174f056c)($347125b38e367f5e$var$CLINICAL_NOTE_REVISIONS, {
            appointmentId: encId
        }).then((d)=>setRevisions(d?.clinicalNoteRevisions || [])).catch(()=>setRevisions([]));
    }, []);
    const toggleHistory = ()=>{
        const next = !historyOpen;
        setHistoryOpen(next);
        if (next && revisions === null && selEncId) refreshRevisions(selEncId);
    };
    const saveSoapEdit = async ()=>{
        if (savingSoap || !selEncId) return;
        setSavingSoap(true);
        setSoapSaveError('');
        const content = {
            s: soapDraft.S,
            o: soapDraft.O,
            a: soapDraft.A,
            p: soapDraft.P
        };
        try {
            if (primarySoapNote) {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($347125b38e367f5e$var$AMEND_CLINICAL_NOTE, {
                    id: primarySoapNote.id,
                    input: {
                        content: content
                    }
                });
                const saved = d?.amendClinicalNote;
                if (saved) setNoteOverlay((prev)=>({
                        ...prev,
                        [primarySoapNote.id]: {
                            content: saved.content,
                            updatedAt: saved.updatedAt || primarySoapNote.updatedAt
                        }
                    }));
                // An open history panel must show the newly recorded revision.
                if (revisions !== null) refreshRevisions(selEncId);
            } else {
                const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($347125b38e367f5e$var$CREATE_SOAP_NOTE, {
                    patientId: p.id,
                    input: {
                        noteType: 'SOAP_NOTE',
                        content: content,
                        authorRole: 'doctor',
                        appointmentId: selEncId
                    }
                });
                const created = d?.createClinicalNote;
                if (created) setCreatedNotes((prev)=>[
                        ...prev,
                        {
                            ...created,
                            appointmentId: selEncId,
                            noteType: 'SOAP_NOTE'
                        }
                    ]);
            }
            setEditingSoap(false);
        } catch (e) {
            setSoapSaveError(e?.message || 'save failed');
        } finally{
            setSavingSoap(false);
        }
    };
    // ── inner views ──────────────────────────────────────────────────────────────
    const SoapView = ()=>{
        const { t: t, formatDateTime: formatDateTime } = (0, $LNQP4.default)();
        const summaryNote = encNotes.find((n)=>(n.noteType || '').toUpperCase() === 'VISIT_SUMMARY');
        const summaryText = summaryNote ? parseContent(summaryNote.content).text || noteStr(summaryNote) : '';
        const hasSoap = $347125b38e367f5e$var$SOAP_SECTIONS(t).some((s)=>soapKeyFromEncNotes(s.k).trim());
        const otherNotes = encNotes.filter((n)=>{
            const nt = (n.noteType || '').toUpperCase();
            return nt !== 'VISIT_SUMMARY' && nt !== 'SOAP_NOTE' && nt !== 'SOAP';
        });
        // Editing is a post-visit affordance only — a live visit's SOAP belongs to
        // the Visit page. Charting stays there; this is the correction rail.
        const canEdit = selEnc && !isLive(selEnc);
        if (!summaryText && !hasSoap && encNotes.length === 0 && !editingSoap) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 40
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.empty.noNoteForVisit')), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "subtle",
            size: "sm",
            "data-testid": "soap-add-btn",
            style: {
                marginTop: 14
            },
            onClick: startSoapEdit
        }, t('patient.visits.addSoapNote')));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 12
            }
        }, summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCCB"), t('credits.price.summary'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "soap-editor",
            style: {
                whiteSpace: 'pre-wrap',
                lineHeight: 1.9
            }
        }, summaryText))), (hasSoap || editingSoap) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCDD"), t('patient.noteType.SOAP_NOTE')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginInlineStart: 'auto'
            }
        }, soapUpdatedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "soap-edited-badge",
            style: {
                fontSize: 11,
                padding: '2px 9px',
                borderRadius: 999,
                background: 'var(--line-2,#ece9e4)',
                color: 'var(--ink-2)'
            }
        }, t('patient.visits.soapEditedAt', {
            date: $347125b38e367f5e$var$isoToJalaliDT(soapUpdatedAt, formatDateTime)
        })), soapUpdatedAt && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": "soap-history-btn",
            onClick: toggleHistory,
            style: {
                fontSize: 11.5,
                background: 'none',
                border: 'none',
                color: 'var(--ink-2)',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0
            }
        }, t('patient.visits.editHistory')), canEdit && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "subtle",
            size: "sm",
            "data-testid": "soap-edit-btn",
            onClick: startSoapEdit
        }, t('common.actions.edit')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, editingSoap ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11.5,
                color: 'var(--mute)',
                marginBottom: 10
            }
        }, t('patient.visits.editSoapHint')), $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-section",
                key: s.k
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-label"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-letter"
            }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-name"
            }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
                className: "soap-editor",
                "data-testid": `soap-edit-${s.k}`,
                dir: "rtl",
                rows: 3,
                style: {
                    width: '100%',
                    resize: 'vertical',
                    font: 'inherit',
                    lineHeight: 1.8,
                    border: '1px solid var(--line)',
                    borderRadius: 8,
                    padding: '8px 10px',
                    background: 'var(--surface)',
                    color: 'var(--ink)'
                },
                value: soapDraft[s.k],
                onChange: (e)=>{
                    const v = e.target.value;
                    setSoapDraft((prev)=>({
                            ...prev,
                            [s.k]: v
                        }));
                }
            }))), soapSaveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12,
                color: 'var(--bad,#b3261e)',
                marginTop: 6
            }
        }, t('patient.visits.soapSaveError'), " \u2014 ", soapSaveError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 8,
                justifyContent: 'flex-end',
                marginTop: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "outline",
            size: "sm",
            "data-testid": "soap-cancel-btn",
            disabled: savingSoap,
            onClick: ()=>setEditingSoap(false)
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            "data-testid": "soap-save-btn",
            disabled: savingSoap,
            onClick: saveSoapEdit
        }, savingSoap ? "\u2026" : t('common.actions.save')))) : $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>{
            const txt = soapKeyFromEncNotes(s.k);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-section",
                key: s.k
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-label"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-letter"
            }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-name"
            }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-editor",
                style: {
                    whiteSpace: 'pre-wrap'
                }
            }, txt || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)',
                    fontStyle: 'italic',
                    fontSize: 12
                }
            }, t('patient.obs.notRecorded'))));
        }))), historyOpen && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card",
            "data-testid": "soap-history-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDD58"), t('patient.visits.editHistory'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, revisions === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12,
                color: 'var(--mute)'
            }
        }, "\u2026"), revisions !== null && revisions.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 12,
                color: 'var(--mute)'
            }
        }, t('patient.visits.noRevisions')), (revisions || []).map((rev)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: rev.id,
                style: {
                    borderBottom: '1px solid var(--line-2,#ece9e4)',
                    padding: '8px 0'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setExpandedRevId(expandedRevId === rev.id ? null : rev.id),
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    textAlign: 'start'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: 'var(--ink)'
                }
            }, $347125b38e367f5e$var$isoToJalaliDT(rev.editedAt, formatDateTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 11.5,
                    color: 'var(--ink-2)'
                }
            }, rev.editedBy && rev.editedBy === myDoctorId ? t('patient.visits.editedByYou') : rev.editedBy || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    marginInlineStart: 'auto',
                    fontSize: 11,
                    color: 'var(--mute)'
                }
            }, expandedRevId === rev.id ? "\u25B4" : "\u25BE")), expandedRevId === rev.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginTop: 8
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 11,
                    color: 'var(--mute)',
                    marginBottom: 6
                }
            }, t('patient.visits.priorVersion')), $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>{
                const lk = s.k.toLowerCase();
                const c = parseContent(rev.content);
                const txt = typeof c[lk] === 'string' && c[lk].trim() ? c[lk] : typeof c[s.k] === 'string' ? c[s.k] : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-section",
                    key: s.k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-label"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "soap-letter"
                }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "soap-name"
                }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-editor",
                    style: {
                        whiteSpace: 'pre-wrap'
                    }
                }, txt || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: 'var(--mute)',
                        fontStyle: 'italic',
                        fontSize: 12
                    }
                }, t('patient.obs.notRecorded'))));
            })))))), otherNotes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, otherNotes.map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: n.id,
                style: {
                    marginBottom: 14
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: 11,
                    color: 'var(--mute)',
                    marginBottom: 5,
                    textTransform: 'uppercase',
                    letterSpacing: '.05em'
                }
            }, n.noteType || t('common.labels.note')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-editor",
                style: {
                    whiteSpace: 'pre-wrap'
                }
            }, noteStr(n) || "\u2014"))))));
    };
    const DiffView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\u2728"), t('visit.copilot.differentials'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encConds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('patient.conditions.none'))) : encConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-row",
                key: c.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-name"
            }, i === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: 9.5,
                    fontWeight: 700,
                    background: 'var(--accent)',
                    color: '#fff',
                    padding: '2px 7px',
                    borderRadius: 3
                }
            }, t('visit.dx.primary')), c.display, c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "diff-code"
            }, "\xb7 ", c.code)), c.clinicalStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-evidence"
            }, t('visit.state.statusLabel'), " ", (0, $1f9ad82cbe711bba$export$1574ad95f483ccf4)(t)[c.clinicalStatus]?.l || c.clinicalStatus)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5311b30cb4607f8a$export$914997c98d3577e5), {
                cond: c
            })))));
    const MedsView = ()=>{
        const { t: t } = (0, $LNQP4.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDC8A"), t('visit.rx.visitMedications'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.rx.noneRecorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-row header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.drugName')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.dose')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.frequency')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('common.labels.status'))), encMeds.map((m)=>{
            const di = m.dosageInstruction || {};
            const dose = di.doseQuantity || di.dose || '';
            const freq = di.timing || di.text || '';
            const statCls = m.status === 'active' ? 'continue' : m.status === 'stopped' ? 'reduce' : '';
            const statL = m.status === 'active' ? t('common.actions.continue') : m.status === 'stopped' ? t('visit.rx.stopShort') : m.status || '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-row",
                key: m.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-name",
                dir: "auto"
            }, (0, $bb8a11e7c1131df5$export$74649666e1751bea)(m).primary), (0, $bb8a11e7c1131df5$export$74649666e1751bea)(m).secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-gen",
                dir: "auto"
            }, (0, $bb8a11e7c1131df5$export$74649666e1751bea)(m).secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-cell"
            }, dose), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-cell"
            }, freq), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, statL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `rx-badge${statCls ? ' ' + statCls : ''}`
            }, statL)));
        }))));
    };
    const OrdersView = ()=>{
        const { t: t } = (0, $LNQP4.default)();
        const ordGroups = [
            {
                type: 'lab',
                label: t('visit.orders.lab')
            },
            {
                type: 'imaging',
                label: t('patient.orderType.imaging')
            },
            {
                type: 'referral',
                label: t('visit.orders.specialistReferral')
            },
            {
                type: 'procedure',
                label: t('visit.orders.clinicalAction')
            },
            {
                type: 'medication',
                label: t('patient.meds.one')
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCCB"), t('visit.orders.requests'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.orders.noneRecordedShort'))) : ordGroups.map((g)=>{
            const items = encOrders.filter((o)=>(o.orderType || '').toLowerCase() === g.type)// An unread result is the one thing on this list that is
            // waiting on the doctor, so it goes to the top of its group.
            .sort((a, b)=>(b.reviewStatus === 'awaiting_review' ? 1 : 0) - (a.reviewStatus === 'awaiting_review' ? 1 : 0));
            if (!items.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: g.type
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "order-group-h"
            }, g.label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    marginInlineStart: 'auto',
                    background: 'var(--line-2,#ece9e4)',
                    padding: '1px 7px',
                    borderRadius: 999,
                    fontSize: 10
                }
            }, items.length)), items.map((o, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-row",
                    key: o.id || i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-name"
                }, o.name || o.code || "\u2014"), o.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-meta"
                }, o.notes), (0, $adc2a88d4c0b6ec2$export$baa601d96b21e0d1)(o) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: 4
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adc2a88d4c0b6ec2$export$2e2bcd8739ae039), {
                    order: o,
                    onOpen: setReviewOrder,
                    compact: true
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: `order-urg ${$347125b38e367f5e$var$ORDER_URG_CLS[o.urgency] || $347125b38e367f5e$var$ORDER_URG_CLS[o.status] || 'routine'}`
                }, o.urgency === 'stat' ? t('common.urgency.urgent') : o.urgency === 'urgent' ? t('visit.orders.priority') : o.status === 'active' ? t('common.state.active') : o.status === 'completed' ? t('patient.orderStat.completed') : t('common.urgency.routine')))));
        })));
    };
    // ── empty state ───────────────────────────────────────────────────────────────
    if (encounters.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "empty",
        style: {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--mute)',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ggYuf.default), {
        size: 44,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 14
        }
    }, t('visit.empty.noVisits')));
    // ── main layout ───────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: 'enc-left-panel' + (leftOpen ? ' open' : ' closed')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-collapse-strip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "enc-collapse-btn",
        onClick: ()=>setLeftOpen((o)=>!o),
        title: leftOpen ? t('common.actions.close') : t('common.actions.open')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "10",
        height: "14",
        viewBox: "0 0 10 14",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 1L7 7L3 13",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-strip-tab' + (rightTab === 'visits' ? ' active' : ''),
        onClick: ()=>{
            setRightTab('visits');
            setLeftOpen(true);
        },
        title: t('visit.patient.encounters')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "enc-strip-label"
    }, t('visit.patient.encounters'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-strip-tab' + (rightTab === 'ai' ? ' active' : ''),
        onClick: ()=>{
            setRightTab('ai');
            setLeftOpen(true);
        },
        title: t('visit.copilot.assistant')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "enc-strip-label"
    }, t('visit.copilot.assistant')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-panel-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-rtabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-rtab' + (rightTab === 'visits' ? ' active' : ''),
        onClick: ()=>setRightTab('visits')
    }, t('visit.patient.encounters'), encounters.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10,
            background: 'var(--line-2,#ece9e4)',
            color: 'var(--ink-2)',
            padding: '1px 6px',
            borderRadius: 999,
            marginInlineStart: 5
        }
    }, encounters.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-rtab' + (rightTab === 'ai' ? ' active' : ''),
        onClick: ()=>setRightTab('ai')
    }, t('visit.copilot.assistant'))), rightTab === 'visits' ? /* Encounter list */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: 'var(--mute)',
            padding: '6px 14px 4px',
            borderBottom: '1px solid var(--line-2,#ece9e4)'
        }
    }, t('visit.patient.newestFirst')), encounters.map((enc)=>{
        const live = isLive(enc);
        const sel = enc.id === selEncId;
        const cts = encCounts(enc.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: enc.id,
            className: 'enc-list-item' + (sel ? ' selected' : ''),
            onClick: ()=>{
                setSelEncId(enc.id);
                setInnerTab('soap');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-row"
        }, live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-live-dot"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-li-date"
        }, encDate(enc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-li-type"
        }, encType(enc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: 'enc-li-status' + (live ? ' live' : ' done')
        }, encStat(enc) || t('visit.state.recordedShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-title"
        }, encTitle(enc)), cts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-counts"
        }, cts));
    })) : /* AI assistant — a conversation over this patient's history */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-avatar"
    }, "\u2726"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-title"
    }, t('visit.copilot.historyAssistant')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-sub"
    }, chat.length > 0 ? t('visit.copilot.threadOpen') : t('visit.copilot.askAcrossVisits', {
        count: encounters.length
    }))), chat.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ai-newchat",
        onClick: resetChat,
        disabled: aiLoading,
        title: t('visit.copilot.clearThread')
    }, t('visit.copilot.newThread'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-body ai-chat",
        role: "log",
        "aria-live": "polite",
        ref: chatBodyRef
    }, chat.length === 0 && !aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-intro"
    }, t('visit.copilot.chatIntro')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-follow-up-label"
    }, t('visit.copilot.quickQuestions')), $347125b38e367f5e$var$AI_QUICK_Q(t).map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: i,
            className: "ai-quick-q",
            onClick: ()=>askAi(q)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ai-quick-q-arrow"
        }, "\u2190"), q))), chat.map((m)=>m.role === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            className: "ai-msg user"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-bubble user"
        }, m.text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            className: "ai-msg bot"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: 'ai-bubble bot' + (m.error ? ' error' : '')
        }, !m.error && $347125b38e367f5e$var$AI_CONFIDENCE(t)[String(m.confidence).toLowerCase()] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-answer-meta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\u2726"), t('visit.copilot.confidence'), " ", $347125b38e367f5e$var$AI_CONFIDENCE(t)[String(m.confidence).toLowerCase()]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-bubble-text"
        }, m.text)), m.suggestions?.length > 0 && !aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-follow-ups"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-follow-up-label"
        }, t('visit.copilot.continue')), m.suggestions.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: i,
                className: "ai-quick-q",
                onClick: ()=>askAi(q)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "ai-quick-q-arrow"
            }, "\u2190"), q))))), aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-msg bot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-bubble bot ai-typing",
        "aria-label": t('visit.copilot.typing')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-composer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-composer-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        placeholder: chat.length ? t('visit.copilot.nextQuestion') : t('visit.copilot.askHistory'),
        value: aiQ,
        onChange: (e)=>setAiQ(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') askAi();
        },
        disabled: aiLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ai-send",
        onClick: ()=>askAi(),
        disabled: aiLoading || !aiQ.trim(),
        title: t('visit.copilot.send')
    }, "\u21A9")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minWidth: 0,
            background: 'var(--bg)'
        }
    }, selEnc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 22px',
            background: 'var(--surface)',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: encVitals.length ? 10 : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: 17,
            color: 'var(--ink)'
        }
    }, encDate(selEnc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11.5,
            padding: '2px 9px',
            borderRadius: 999,
            background: 'var(--line-2,#ece9e4)',
            color: 'var(--ink-2)'
        }
    }, encType(selEnc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            padding: '2px 8px',
            borderRadius: 999,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            background: isLive(selEnc) ? 'var(--good-soft)' : 'var(--line-2,#ece9e4)',
            color: isLive(selEnc) ? 'oklch(0.38 0.08 155)' : 'var(--ink-2)'
        }
    }, isLive(selEnc) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'oklch(0.55 0.09 155)',
            display: 'inline-block'
        }
    }), encStat(selEnc) || t('visit.state.recordedShort')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f64ac416f593a18$export$2e2bcd8739ae039), {
        key: selEnc.id,
        style: {
            marginInlineStart: 'auto'
        },
        visit: selEnc,
        patientId: p.id,
        insurance: p.insurance,
        mine: !!myDoctorId && selEnc.doctorId === myDoctorId,
        hasLines: encMeds.length + encOrders.length > 0,
        onChanged: ()=>{
            onRefresh?.();
            loadEncOrders();
        },
        testid: "history-erx"
    })), encVitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6
        }
    }, encVitals.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: v.code,
            style: {
                fontSize: 12,
                padding: '3px 9px',
                borderRadius: 999,
                background: 'var(--bg)',
                border: '1px solid var(--line)',
                color: 'var(--ink-2)',
                fontFamily: 'ui-monospace,monospace'
            }
        }, v.label, ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
            dir: "ltr"
        }, v.value), " ", v.unit)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "soap-tabs",
        style: {
            flexShrink: 0
        }
    }, [
        {
            id: 'soap',
            label: t('patient.noteType.SOAP_NOTE')
        },
        {
            id: 'diff',
            label: t('credits.price.differential'),
            count: encConds.length
        },
        {
            id: 'meds',
            label: t('patient.meds.one'),
            count: encMeds.length
        },
        {
            id: 'ord',
            label: t('visit.tabs.orders'),
            count: encOrders.length
        }
    ].map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: item.id,
            className: 'soap-tab' + (innerTab === item.id ? ' active' : ''),
            onClick: ()=>setInnerTab(item.id)
        }, item.label, item.count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "badge"
        }, item.count)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '20px 22px 60px'
        }
    }, innerTab === 'soap' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SoapView, null), innerTab === 'diff' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DiffView, null), innerTab === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MedsView, null), innerTab === 'ord' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(OrdersView, null))), reviewOrder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0e90198918904d7$export$2e2bcd8739ae039), {
        order: reviewOrder,
        onClose: ()=>setReviewOrder(null),
        onReviewed: async (updated)=>{
            // Reflect the verdict immediately, then refetch so the row and the
            // drawer agree with the server rather than with an optimistic guess.
            if (updated) setEncOrders((prev)=>prev.map((o)=>o.id === updated.id ? {
                        ...o,
                        ...updated
                    } : o));
            await loadEncOrders();
        }
    }));
};
var $347125b38e367f5e$export$2e2bcd8739ae039 = $347125b38e367f5e$var$VisitsTab;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");

var $jTCZr = parcelRequire("jTCZr");

var $2WFPf = parcelRequire("2WFPf");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $ljvFv = parcelRequire("ljvFv");
var $he6AI = parcelRequire("he6AI");






var $acw62 = parcelRequire("acw62");

// The doctor's clinic memberships, for the settings «مطب‌ها» section.
//
// Deliberately NOT the `listClinics` document that Encounters and Accounting
// declare: that one is a clinic *directory* filtered to clinics this account
// owns, and returns nothing for a doctor who joined a clinic by invitation code.
// `myClinics` reads doctorpreference's `clinic_doctors`, so it answers the
// question this section asks — which clinics am I actually in, and are they
// still pending.
const $352de6198ea69bb8$var$MY_CLINICS = `
  query MyClinics {
    myClinics {
      id
      status
      clinic { id name city province officePhone }
    }
  }
`;
function $352de6198ea69bb8$export$f9eed3ff0df23e5c({ enabled: enabled = true } = {}) {
    const [clinics, setClinics] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchClinics = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($352de6198ea69bb8$var$MY_CLINICS);
            setClinics(data?.myClinics ?? []);
            setError(null);
        } catch (err) {
            setError(err);
        }
    }, []);
    const refetch = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return fetchClinics().finally(()=>setLoading(false));
    }, [
        fetchClinics
    ]);
    // Fetched only once the section is actually opened — the other four tabs must
    // not pay for a query they never show (§8).
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        let alive = true;
        setLoading(true);
        fetchClinics().finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        enabled,
        fetchClinics
    ]);
    // A join succeeds by making the list longer — the caller re-reads rather than
    // splicing an optimistic row, so «در انتظار تأیید» comes from the server.
    return {
        clinics: clinics,
        loading: loading,
        error: error,
        refetch: refetch
    };
}




// «فایل‌ها» — the patient's documents on the workstation.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.2, §8.
//
// One list. A document is a clinical record + its bytes in storage (merged into one
// entry by `mergeClinicalAndStorageFiles`), and a DICOM study is a clinical record too
// (`mediaClass = 'dicom'`) — including studies that arrived before study rows existed,
// which the BFF mirrors into rows when the list is read
// (DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.8). Every action — view,
// extract, edit, download, delete, upload of documents and studies alike — goes
// through `useClinicalFiles`, the host the Visit page and the phone use, so a file
// behaves the same wherever the doctor meets it.
const $ab3a679d970a4d5f$var$CAT_ICON = {
    all: (0, $b77ca10bb12022b4$export$2e2bcd8739ae039),
    lab_report: (0, $4CVxl.default),
    imaging: (0, $ccc00afea4040e64$export$2e2bcd8739ae039),
    ecg: (0, $ljvFv.default),
    pathology: (0, $5935de03d6f5e9ca$export$2e2bcd8739ae039),
    general: (0, $3FyOw.default)
};
// A storage-only row has no clinical record: nothing to edit or extract, and the
// doctor's own legacy upload stays deletable exactly as it always was.
const $ab3a679d970a4d5f$var$asRow = (f)=>f._source === 'storage' ? {
        ...f,
        canEdit: false,
        editScope: null,
        extractable: false,
        canDelete: true
    } : f;
const $ab3a679d970a4d5f$var$FilesTab = ({ p: p, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [storageFiles, setStorageFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [filterCat, setFilterCat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [collapsedCats, setCollapsedCats] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // A failed load is reported, never swallowed: this list is part of a medical
    // record, so "no files" must mean no files, not "the query errored".
    const loadStorage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoadError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$ef15c8f83a956e90), {
            patientId: p.id
        }).then((d)=>setStorageFiles(d.storageLabFiles || [])).catch((err)=>setLoadError(err));
    }, [
        p.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadStorage();
    }, [
        loadStorage
    ]);
    const allFiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bf42e0131d395ab7$export$f0dc803487bda7d5)(p.clinicalFiles, storageFiles).map($ab3a679d970a4d5f$var$asRow), [
        p.clinicalFiles,
        storageFiles
    ]);
    // The clinic chip only for a doctor who works at more than one clinic: on a
    // single-clinic doctor's screen it would say the same thing on every row.
    const { clinics: clinics } = (0, $352de6198ea69bb8$export$f9eed3ff0df23e5c)();
    const clinicNameById = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const m = new Map();
        (clinics || []).forEach((c)=>{
            const id = c?.clinic?.id || c?.id;
            if (id) m.set(String(id), c?.clinic?.name || null);
        });
        return m;
    }, [
        clinics
    ]);
    const clinicNameOf = clinicNameById.size > 1 ? (id)=>clinicNameById.get(String(id)) || null : null;
    const refreshAll = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        loadStorage();
        onRefresh?.();
    }, [
        loadStorage,
        onRefresh
    ]);
    const files = (0, $489287129a199b1d$export$513d4933d99292ab)({
        patient: p,
        files: allFiles,
        clinicNameOf: clinicNameOf,
        onChanged: refreshAll
    });
    const catCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bf42e0131d395ab7$export$db667ec233a83b).reduce((acc, c)=>{
            acc[c.id] = c.id === 'all' ? allFiles.length : allFiles.filter((f)=>(0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f) === c.id).length;
            return acc;
        }, {}), [
        allFiles
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (filterCat !== 'all' && !catCounts[filterCat]) setFilterCat('all');
    }, [
        catCounts,
        filterCat
    ]);
    const visibleFiles = filterCat === 'all' ? allFiles : allFiles.filter((f)=>(0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f) === filterCat);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (filterCat !== 'all') return [
            {
                id: filterCat,
                files: visibleFiles
            }
        ];
        const byCat = new Map();
        visibleFiles.forEach((f)=>{
            const id = (0, $bf42e0131d395ab7$export$3d3bfe33466ff5e)(f);
            if (!byCat.has(id)) byCat.set(id, []);
            byCat.get(id).push(f);
        });
        return (0, $bf42e0131d395ab7$export$db667ec233a83b).filter((c)=>c.id !== 'all' && byCat.has(c.id)).map((c)=>({
                id: c.id,
                files: byCat.get(c.id)
            }));
    }, [
        visibleFiles,
        filterCat
    ]);
    const toggleCat = (id)=>setCollapsedCats((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    const catLabel = (id)=>{
        const cat = (0, $bf42e0131d395ab7$export$db667ec233a83b).find((c)=>c.id === id);
        return cat ? t(cat.labelKey) : id;
    };
    const card = {
        background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).surface,
        borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
        border: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
        overflow: 'hidden'
    };
    const cardHeader = {
        padding: '0.75rem 1rem',
        borderBottom: `1px solid ${(0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.75rem',
        flexWrap: 'wrap'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-tab",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, allFiles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-categories",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, (0, $bf42e0131d395ab7$export$db667ec233a83b).filter((c)=>c.id === 'all' || catCounts[c.id] > 0).map((c)=>{
        const Icon = $ab3a679d970a4d5f$var$CAT_ICON[c.id] || (0, $3FyOw.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: c.id,
            active: filterCat === c.id,
            onClick: ()=>setFilterCat(c.id),
            count: catCounts[c.id] ? formatDigits(catCounts[c.id]) : undefined,
            "data-testid": `files-category-${c.id}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 13,
                "aria-hidden": true
            }), t(c.labelKey))
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: cardHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text1
        }
    }, filterCat === 'all' ? t('patient.files.all') : catLabel(filterCat), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
            fontWeight: 400,
            marginInlineStart: '0.5rem'
        }
    }, formatDigits(visibleFiles.length), " ", t('patient.files.file'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>files.openUpload(),
        "data-testid": "files-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile'))), loadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.75rem 1rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "files-partial-load",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: loadStorage
        }, t('common.actions.retry'))
    }, t('patient.files.partialLoadFailed'))), allFiles.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '1.5rem 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
            size: 44,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: loadError ? t('patient.files.partialLoad') : t('patient.files.empty'),
        description: loadError ? undefined : t('patient.files.emptyHint'),
        action: loadError ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>files.openUpload()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('visit.patient.addFile'))
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.25rem 1rem 0.75rem'
        }
    }, groups.map((g)=>{
        const collapsed = filterCat === 'all' && collapsedCats.has(g.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.id,
            "data-testid": `files-group-${g.id}`,
            "data-state": collapsed ? 'collapsed' : 'content'
        }, filterCat === 'all' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggleCat(g.id),
            "aria-expanded": !collapsed,
            "data-testid": `files-group-toggle-${g.id}`,
            className: "w-full h-auto min-h-9 justify-start gap-2 rounded-none px-0 py-1 hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).accentInk
            }
        }, catLabel(g.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3
            }
        }, formatDigits(g.files.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                flex: 1,
                height: 1,
                background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).border
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 14,
            "aria-hidden": true,
            style: {
                color: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).text3,
                transform: collapsed ? 'rotate(90deg)' : 'none',
                transition: 'transform .18s'
            }
        })), !collapsed && g.files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2efaf4152cb92eb$export$2e2bcd8739ae039), {
                key: `${f._source}-${f.id}`,
                file: f,
                clinicName: clinicNameOf && f.clinicId ? clinicNameOf(f.clinicId) : null,
                onOpen: files.openDetail,
                onView: files.openViewer,
                onExtract: (file)=>files.openExtract(file),
                onEdit: (file)=>files.openDetail(file, {
                        edit: true
                    }),
                onDownload: files.download,
                onDelete: files.requestDelete
            })));
    }), visibleFiles.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-category-empty",
        title: t('patient.files.noneInCategory')
    }))), files.overlays);
};
var $ab3a679d970a4d5f$export$2e2bcd8739ae039 = $ab3a679d970a4d5f$var$FilesTab;


// ── Desktop Patient record (archetype C) ──────────────────────────────────────
// Thin composition root: loads the patient once via `usePatient`, injects the
// scoped stylesheet, and switches between the five section tabs. Every piece of
// UI lives in ./web/* (layout, tabs, media, modals) and is built from the
// @parsina/framework kit + framework tokens (DESIGN §1). Render-only — data
// mutations happen inside the individual tabs.
const $86511c54b887fe2a$var$PatientDetailWeb = ({ patient: patientProp, onBack: onBack, tab: tabProp, setTab: setTab })=>{
    const { t: t } = (0, $LNQP4.default)();
    // The section lives in the URL (/patients/:id/:tab, screen index owns the
    // navigation); an unknown segment — including a mobile-only section id after
    // a viewport switch — falls back to the overview rather than a blank pane.
    const tab = (0, $54fb4340d9fc8f69$export$73b877b58963a4f)(t).some((item)=>item.id === tabProp) ? tabProp : 'overview';
    const { patient: p, loading: loading, error: error, refresh: refresh } = (0, $ea02b2b734b36651$export$9b570c45914f833c)(patientProp?.id);
    if (loading && !p) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1e1ffd8e261dcdc$export$2e2bcd8739ae039), {
        tab: tab
    });
    // "This record does not exist" and "this record would not load" are different
    // events, and telling them apart is the difference between a doctor pressing
    // retry forever and a doctor realising they followed a stale link. Both used
    // to render the same retry card below.
    //
    // FORBIDDEN lands here too, on purpose: the BFF scopes patients to the
    // requesting doctor, so «not yours» and «does not exist» are the same fact
    // seen from two angles, and neither is fixed by retrying.
    const missing = error && !p && [
        (0, $91f57610161f2da8$export$896afd8541959ee5).NOT_FOUND,
        (0, $91f57610161f2da8$export$896afd8541959ee5).FORBIDDEN
    ].includes((0, $91f57610161f2da8$export$1b8dff08c06e2cb8)(error));
    if (missing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f09c2fbf6e97540$export$1c8a31b6c319fadd), {
        titleKey: "patient.empty.notFoundTitle",
        bodyKey: "patient.empty.notFoundBody",
        detail: patientProp?.id,
        onBack: onBack
    });
    // §2.4: a failed load renders a retry card (wired to refetch), never a dead end.
    if (error && !p) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-detail-error",
        "data-state": "error",
        role: "alert",
        style: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
        error: error,
        title: t('patient.empty.unavailable'),
        note: t('errors.load.recordRetry'),
        onRetry: ()=>refresh?.()
    }));
    const renderTab = ()=>{
        // A refresh with the header already on screen: only the pane skeletons, in
        // the shape of the tab it is about to show.
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1e1ffd8e261dcdc$export$33f6e3467d893933), {
            tab: tab
        });
        switch(tab){
            case 'overview':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb877cde7ef1a601$export$2e2bcd8739ae039), {
                    p: p,
                    setTab: setTab,
                    onRefresh: refresh
                });
            case 'analysis':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b89e7462d024c03d$export$2e2bcd8739ae039), {
                    p: p,
                    setTab: setTab
                });
            case 'labs':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d25dbf9aade1aa26$export$2e2bcd8739ae039), {
                    p: p,
                    onRefresh: refresh
                });
            case 'visits':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $347125b38e367f5e$export$2e2bcd8739ae039), {
                    p: p,
                    onRefresh: refresh
                });
            case 'files':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab3a679d970a4d5f$export$2e2bcd8739ae039), {
                    p: p,
                    onRefresh: refresh
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $1f9ad82cbe711bba$export$9bf3043cb7503aa1).bg,
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes spin { to{transform:rotate(360deg)} }` + (0, $0708e7191fc9d5b2$export$72b22e63cf166bcb)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $489311c8b0711f95$export$2e2bcd8739ae039), {
        p: p,
        onBack: onBack
    }), tab !== 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b130ae8b467aab$export$2e2bcd8739ae039), {
        allergies: (p.clinicalAllergies || []).map((a)=>a.allergen || a).filter(Boolean),
        alerts: p.alerts || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54fb4340d9fc8f69$export$2e2bcd8739ae039), {
        tab: tab,
        setTab: setTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            overflow: 'hidden'
        }
    }, tab === 'visits' ? renderTab() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '20px 28px 40px'
        }
    }, renderTab())));
};
var $86511c54b887fe2a$export$2e2bcd8739ae039 = $86511c54b887fe2a$var$PatientDetailWeb;


function $a04c8d3c93655abb$export$2e2bcd8739ae039({ patient: patient, tab: tab, onTabChange: onTabChange, onBack: onBack, mobile: mobile }) {
    const navigate = (0, $aa19facd75e3670a$export$5b61ff3425c1c197)();
    const back = (0, $aa19facd75e3670a$export$2225579b56f43845)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const phone = typeof mobile === 'boolean' ? mobile : isMobile;
    if (!patient?.id) return null;
    const props = {
        navigate: navigate,
        onBack: onBack || back,
        patient: patient,
        tab: tab,
        setTab: onTabChange || (()=>{})
    };
    return phone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2515f4e67960210f$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86511c54b887fe2a$export$2e2bcd8739ae039), props);
}





parcelRequire("dSPMK");
var $4rEI6 = parcelRequire("4rEI6");
var $LNQP4 = parcelRequire("LNQP4");




var $e317r = parcelRequire("e317r");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
// Maps old screen-name strings to URL paths.
// Preserves the existing navigate(screenName, data) call-site API so no
// .web.jsx / .mobile.jsx files need to change.
const $53b14620f65a31c3$var$ROUTES = {
    'reception': ()=>'/reception',
    // No 'patients' key: the patient LIST page was removed. The profile below stays —
    // it is reached from پذیرش and the visit-history screen, not from a list.
    // Optional data.tab deep-links a record section (/patients/:id/:tab).
    'patient-detail': (data)=>`/patients/${data?.patientId || data?.id}${data?.tab ? `/${data.tab}` : ''}`,
    'encounters': ()=>'/encounters',
    // «جست‌وجوی بیمار» — the phone's way to a patient who is not on today's
    // list. No query parameter: a name in the address is PHI in the history and
    // in every shared link, so the term stays in the screen's own state.
    'lookup': ()=>'/lookup',
    // Optional data.c deep-links one conversation (/messages?c=<roomId>). The room
    // id is opaque, so it is safe in a URL — no PHI ever goes there.
    'messages': (data)=>`/messages${data?.c ? `?c=${data.c}` : ''}`,
    'visit': (data)=>`/visit/${data?.patientId || data?.id}`,
    'voice': (data)=>`/voice/${data?.patientId || data?.id}`,
    'prescription': (data)=>`/prescription/${data?.patientId || data?.id}`,
    // Optional data.tab deep-links a settings section (/profile?tab=credits).
    'profile': (data)=>`/profile${data?.tab ? `?tab=${data.tab}` : ''}`,
    'credits': ()=>'/credits',
    // Every id the sidebar can dispatch must be here: navigate() silently returns on an
    // unknown key, so a missing entry makes the nav item do nothing at all — no error,
    // no route change. /accounting existed as a <Route> and a screen the whole time; only
    // this line was missing, so حسابداری was reachable by URL but dead in the menu.
    'accounting': ()=>'/accounting',
    // «صفحهٔ من» — the doctor's public page builder (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md §12).
    'my-page': ()=>'/my-page'
};
function $53b14620f65a31c3$export$5b61ff3425c1c197() {
    const rrNavigate = (0, $aphAM.useNavigate)();
    return (to, data = null)=>{
        const path = $53b14620f65a31c3$var$ROUTES[to]?.(data);
        if (!path) {
            // Returning quietly is what made the missing 'accounting' entry so hard to see:
            // the menu item just did nothing. Say so.
            console.warn(`[useAppNavigate] no route for "${to}" \u{2014} add it to ROUTES`);
            return;
        }
        rrNavigate(path, data ? {
            state: data
        } : undefined);
        window.scrollTo(0, 0);
    };
}



var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $k27hS = parcelRequire("k27hS");
function $f0d3e573edc81701$export$3432f1ddf4aadfb5({ dark: dark = false, time: time = '9:41' }) {
    const c = dark ? '#fff' : '#000';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 154,
            alignItems: 'center',
            justifyContent: 'center',
            padding: '21px 24px 19px',
            boxSizing: 'border-box',
            position: 'relative',
            zIndex: 20,
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    height: 22,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: 1.5
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontFamily: '-apple-system, "SF Pro", system-ui',
                        fontWeight: 590,
                        fontSize: 17,
                        lineHeight: '22px',
                        color: c
                    },
                    children: time
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    height: 22,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 7,
                    paddingTop: 1,
                    paddingRight: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "19",
                        height: "12",
                        viewBox: "0 0 19 12",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "0",
                                y: "7.5",
                                width: "3.2",
                                height: "4.5",
                                rx: "0.7",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "4.8",
                                y: "5",
                                width: "3.2",
                                height: "7",
                                rx: "0.7",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "9.6",
                                y: "2.5",
                                width: "3.2",
                                height: "9.5",
                                rx: "0.7",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "14.4",
                                y: "0",
                                width: "3.2",
                                height: "12",
                                rx: "0.7",
                                fill: c
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "17",
                        height: "12",
                        viewBox: "0 0 17 12",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8.5 3.2C10.8 3.2 12.9 4.1 14.4 5.6L15.5 4.5C13.7 2.7 11.2 1.5 8.5 1.5C5.8 1.5 3.3 2.7 1.5 4.5L2.6 5.6C4.1 4.1 6.2 3.2 8.5 3.2Z",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8.5 6.8C9.9 6.8 11.1 7.3 12 8.2L13.1 7.1C11.8 5.9 10.2 5.1 8.5 5.1C6.8 5.1 5.2 5.9 3.9 7.1L5 8.2C5.9 7.3 7.1 6.8 8.5 6.8Z",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "8.5",
                                cy: "10.5",
                                r: "1.5",
                                fill: c
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "27",
                        height: "13",
                        viewBox: "0 0 27 13",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "0.5",
                                y: "0.5",
                                width: "23",
                                height: "12",
                                rx: "3.5",
                                stroke: c,
                                strokeOpacity: "0.35",
                                fill: "none"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "2",
                                y: "2",
                                width: "20",
                                height: "9",
                                rx: "2",
                                fill: c
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M25 4.5V8.5C25.8 8.2 26.5 7.2 26.5 6.5C26.5 5.8 25.8 4.8 25 4.5Z",
                                fill: c,
                                fillOpacity: "0.4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $f0d3e573edc81701$export$f2470bac53969c65({ children: children, dark: dark = false, style: style = {} }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: 44,
            minWidth: 44,
            borderRadius: 9999,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: dark ? '0 2px 6px rgba(0,0,0,0.35), 0 6px 16px rgba(0,0,0,0.2)' : '0 1px 3px rgba(0,0,0,0.07), 0 3px 10px rgba(0,0,0,0.06)',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 9999,
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    background: dark ? 'rgba(120,120,128,0.28)' : 'rgba(255,255,255,0.5)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 9999,
                    boxShadow: dark ? 'inset 1.5px 1.5px 1px rgba(255,255,255,0.15), inset -1px -1px 1px rgba(255,255,255,0.08)' : 'inset 1.5px 1.5px 1px rgba(255,255,255,0.7), inset -1px -1px 1px rgba(255,255,255,0.4)',
                    border: dark ? '0.5px solid rgba(255,255,255,0.15)' : '0.5px solid rgba(0,0,0,0.06)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 4px'
                },
                children: children
            })
        ]
    });
}
function $f0d3e573edc81701$export$1c6a0da517843c75({ title: title = 'Title', dark: dark = false, trailingIcon: trailingIcon = true }) {
    const muted = dark ? 'rgba(255,255,255,0.6)' : '#404040';
    const text = dark ? '#fff' : '#000';
    const pillIcon = (content)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f0d3e573edc81701$export$f2470bac53969c65, {
            dark: dark,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 36,
                    height: 36,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: content
            })
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            paddingTop: 62,
            paddingBottom: 10,
            position: 'relative',
            zIndex: 5
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 16px'
                },
                children: [
                    pillIcon(/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "12",
                        height: "20",
                        viewBox: "0 0 12 20",
                        fill: "none",
                        style: {
                            marginLeft: -1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10 2L2 10l8 8",
                            stroke: muted,
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })),
                    trailingIcon && pillIcon(/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "22",
                        height: "6",
                        viewBox: "0 0 22 6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "3",
                                cy: "3",
                                r: "2.5",
                                fill: muted
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "11",
                                cy: "3",
                                r: "2.5",
                                fill: muted
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "19",
                                cy: "3",
                                r: "2.5",
                                fill: muted
                            })
                        ]
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '0 16px',
                    fontFamily: '-apple-system, system-ui',
                    fontSize: 34,
                    fontWeight: 700,
                    lineHeight: '41px',
                    color: text,
                    letterSpacing: 0.4
                },
                children: title
            })
        ]
    });
}
function $f0d3e573edc81701$export$470f23c9718064ba({ title: title, detail: detail, icon: icon, chevron: chevron = true, isLast: isLast = false, dark: dark = false }) {
    const text = dark ? '#fff' : '#000';
    const sec = dark ? 'rgba(235,235,245,0.6)' : 'rgba(60,60,67,0.6)';
    const ter = dark ? 'rgba(235,235,245,0.3)' : 'rgba(60,60,67,0.3)';
    const sep = dark ? 'rgba(84,84,88,0.65)' : 'rgba(60,60,67,0.12)';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            minHeight: 52,
            padding: '0 16px',
            position: 'relative',
            fontFamily: '-apple-system, system-ui',
            fontSize: 17,
            letterSpacing: -0.43
        },
        children: [
            icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 30,
                    height: 30,
                    borderRadius: 7,
                    background: icon,
                    marginRight: 12,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    color: text
                },
                children: title
            }),
            detail && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: sec,
                    marginRight: 6
                },
                children: detail
            }),
            chevron && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "8",
                height: "14",
                viewBox: "0 0 8 14",
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M1 1l6 6-6 6",
                    stroke: ter,
                    strokeWidth: "2",
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            !isLast && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    left: icon ? 58 : 16,
                    height: 0.5,
                    background: sep
                }
            })
        ]
    });
}
function $f0d3e573edc81701$export$d9f5a0d8ce4d0f6({ header: header, children: children, dark: dark = false }) {
    const hc = dark ? 'rgba(235,235,245,0.6)' : 'rgba(60,60,67,0.6)';
    const bg = dark ? '#1C1C1E' : '#fff';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            header && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontFamily: '-apple-system, system-ui',
                    fontSize: 13,
                    color: hc,
                    textTransform: 'uppercase',
                    padding: '8px 36px 6px',
                    letterSpacing: -0.08
                },
                children: header
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    background: bg,
                    borderRadius: 26,
                    margin: '0 16px',
                    overflow: 'hidden'
                },
                children: children
            })
        ]
    });
}
function $f0d3e573edc81701$export$5e0dbdcad59cf504({ children: children, width: width = 402, height: height = 874, dark: dark = false, title: title, keyboard: keyboard = false }) {
    // On a real mobile browser the frame is not a frame at all: it fills the
    // root, and the root (styles.css, `@media (max-width: 768px)`) is what owns
    // the visible viewport. On desktop it stays a fixed-size phone mock.
    //
    // The test used to be `window.screen.width <= 500`, read once at render, and
    // that was wrong three ways. `screen.width` is the DEVICE's width, not the
    // viewport's — it ignores browser and page zoom, and on iOS it does not
    // change with orientation — so it answers a different question from the one
    // asked. 500 is not the app's breakpoint, so a 501–768px viewport was handed
    // the mobile bottom nav by App.jsx and an 874px-tall fixed frame by this
    // component, and the nav landed off-screen. And reading it once meant a
    // rotation or a zoom never re-measured. `useResponsive` is the same ≤768px
    // `matchMedia` every screen forks on, and it re-renders when it changes.
    const { isMobile: isRealMobile } = (0, $k27hS.default)();
    const w = isRealMobile ? '100%' : width;
    const h = isRealMobile ? '100%' : height;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            width: w,
            height: h,
            maxHeight: '100%',
            minHeight: 0,
            borderRadius: 0,
            overflow: 'hidden',
            position: 'relative',
            background: dark ? '#000' : '#F2F2F7',
            boxShadow: isRealMobile ? 'none' : '0 40px 80px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.12)',
            fontFamily: '-apple-system, system-ui, sans-serif',
            WebkitFontSmoothing: 'antialiased'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: [
                    title !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)($f0d3e573edc81701$export$1c6a0da517843c75, {
                        title: title,
                        dark: dark
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            fontFamily: "'Meshkat', sans-serif"
                        },
                        children: children
                    }),
                    keyboard && /*#__PURE__*/ (0, $ayMG0.jsx)($f0d3e573edc81701$export$b5970fc67216d277, {
                        dark: dark
                    })
                ]
            }),
            !isRealMobile && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 60,
                    height: 34,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    paddingBottom: 8,
                    pointerEvents: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: 139,
                        height: 5,
                        borderRadius: 100,
                        background: dark ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.25)'
                    }
                })
            })
        ]
    });
}
function $f0d3e573edc81701$export$b5970fc67216d277({ dark: dark = false }) {
    const glyph = dark ? 'rgba(255,255,255,0.7)' : '#595959';
    const sugg = dark ? 'rgba(255,255,255,0.6)' : '#333';
    const keyBg = dark ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.85)';
    // special-key icons
    const icons = {
        shift: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "19",
            height: "17",
            viewBox: "0 0 19 17",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.5 1L1 9.5h4.5V16h8V9.5H18L9.5 1z",
                fill: glyph
            })
        }),
        del: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "23",
            height: "17",
            viewBox: "0 0 23 17",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7 1h13a2 2 0 012 2v11a2 2 0 01-2 2H7l-6-7.5L7 1z",
                    fill: "none",
                    stroke: glyph,
                    strokeWidth: "1.6",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M10 5l7 7M17 5l-7 7",
                    stroke: glyph,
                    strokeWidth: "1.6",
                    strokeLinecap: "round"
                })
            ]
        }),
        ret: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "20",
            height: "14",
            viewBox: "0 0 20 14",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18 1v6H4m0 0l4-4M4 7l4 4",
                fill: "none",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    };
    const key = (content, { w: w, flex: flex, ret: ret, fs: fs = 25, k: k } = {})=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                height: 42,
                borderRadius: 8.5,
                flex: flex ? 1 : undefined,
                width: w,
                minWidth: 0,
                background: ret ? '#08f' : keyBg,
                boxShadow: '0 1px 0 rgba(0,0,0,0.075)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: '-apple-system, "SF Compact", system-ui',
                fontSize: fs,
                fontWeight: 458,
                color: ret ? '#fff' : glyph
            },
            children: content
        }, k);
    const row = (keys, pad = 0)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                display: 'flex',
                gap: 6.5,
                justifyContent: 'center',
                padding: `0 ${pad}px`
            },
            children: keys.map((l)=>key(l, {
                    flex: true,
                    k: l
                }))
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            zIndex: 15,
            borderRadius: 27,
            overflow: 'hidden',
            padding: '11px 0 2px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: dark ? '0 -2px 20px rgba(0,0,0,0.09)' : '0 -1px 6px rgba(0,0,0,0.018), 0 -3px 20px rgba(0,0,0,0.012)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 27,
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    background: dark ? 'rgba(120,120,128,0.14)' : 'rgba(255,255,255,0.25)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 27,
                    boxShadow: dark ? 'inset 1.5px 1.5px 1px rgba(255,255,255,0.15)' : 'inset 1.5px 1.5px 1px rgba(255,255,255,0.7), inset -1px -1px 1px rgba(255,255,255,0.4)',
                    border: dark ? '0.5px solid rgba(255,255,255,0.15)' : '0.5px solid rgba(0,0,0,0.06)',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 20,
                    alignItems: 'center',
                    padding: '8px 22px 13px',
                    width: '100%',
                    boxSizing: 'border-box',
                    position: 'relative'
                },
                children: [
                    '"The"',
                    'the',
                    'to'
                ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            i > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 1,
                                    height: 25,
                                    background: '#ccc',
                                    opacity: 0.3
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    textAlign: 'center',
                                    fontFamily: '-apple-system, system-ui',
                                    fontSize: 17,
                                    color: sugg,
                                    letterSpacing: -0.43,
                                    lineHeight: '22px'
                                },
                                children: w
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 13,
                    padding: '0 6.5px',
                    width: '100%',
                    boxSizing: 'border-box',
                    position: 'relative'
                },
                children: [
                    row([
                        'q',
                        'w',
                        'e',
                        'r',
                        't',
                        'y',
                        'u',
                        'i',
                        'o',
                        'p'
                    ]),
                    row([
                        'a',
                        's',
                        'd',
                        'f',
                        'g',
                        'h',
                        'j',
                        'k',
                        'l'
                    ], 20),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 14.25,
                            alignItems: 'center'
                        },
                        children: [
                            key(icons.shift, {
                                w: 45,
                                k: 'shift'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6.5,
                                    flex: 1
                                },
                                children: [
                                    'z',
                                    'x',
                                    'c',
                                    'v',
                                    'b',
                                    'n',
                                    'm'
                                ].map((l)=>key(l, {
                                        flex: true,
                                        k: l
                                    }))
                            }),
                            key(icons.del, {
                                w: 45,
                                k: 'del'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 6,
                            alignItems: 'center'
                        },
                        children: [
                            key('ABC', {
                                w: 92.25,
                                fs: 18,
                                k: 'abc'
                            }),
                            key('', {
                                flex: true,
                                k: 'space'
                            }),
                            key(icons.ret, {
                                w: 92.25,
                                ret: true,
                                k: 'ret'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: 56,
                    width: '100%',
                    position: 'relative'
                }
            })
        ]
    });
}


parcelRequire("5N0ZI");
var $fvho4 = parcelRequire("fvho4");
var $1Ssl4 = parcelRequire("1Ssl4");
var $6usBW = parcelRequire("6usBW");
parcelRequire("dSPMK");
var $4rEI6 = parcelRequire("4rEI6");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $ev4PJ = parcelRequire("ev4PJ");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $4263136693b42857$export$2e2bcd8739ae039() {
    const { t: t, tList: tList, has: has, formatDigits: formatDigits, locale: locale } = (0, $LNQP4.default)();
    (0, $acw62.useLayoutEffect)(()=>{
        (0, $ev4PJ.setUiStrings)({
            string: (key)=>has(key) ? t(key) : undefined,
            list: (key)=>has(key) ? tList(key) : undefined,
            // `formatDigits`, NOT `formatNumber`. What the kit hands over is a
            // transliteration job, not a formatting one: it passes «۱۴۰۴/۰۵/۱۲»,
            // a zero-padded "05" and a bare year through the same call. A number
            // formatter would group the year into "1,404", strip the padding off the
            // hour, and answer empty for the slashed date — which is the string the
            // picker's own parser has to read back.
            number: (value)=>formatDigits(value)
        });
    // Nothing unwires it on unmount: this component lives as long as the app
    // does, and clearing the registry on the way out would repaint the kit in
    // Persian during teardown.
    }, [
        locale,
        t,
        tList,
        has,
        formatDigits
    ]);
    return null;
}




var $eLeza = parcelRequire("eLeza");

var $eLeza = parcelRequire("eLeza");
var $23a4fb8df39836e9$exports = {};
$23a4fb8df39836e9$exports = import.meta.resolve("90mMd");


var $f0b50123bb07e4c7$exports = {};
$f0b50123bb07e4c7$exports = import.meta.resolve("8C9I7");


var $370560921d00ddf1$exports = {};
$370560921d00ddf1$exports = import.meta.resolve("7PY0y");


var $ea750477e199405c$exports = {};
$ea750477e199405c$exports = import.meta.resolve("b5lck");


// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2) — the same shape as the clinic panel's.
//
//   logo        the colour mark — the session-error card
//   logoWhite   the white mark on the brand gradient — the boot card, the sidebar
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries: that pack's images, bundled from brand-packs/<pack>/ — the same
// folder the image bakes and docker-entrypoint.sh serves at /brand/ for the
// favicon, home-screen icons and manifest. Chosen when drawn, not when this
// module loads: the brand is configured at boot, after these imports.
// ─────────────────────────────────────────────────────────────────────────────
const $33feb484f084e2c2$var$PARSINA = Object.freeze({
    logo: (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports)),
    logoWhite: (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))
});
const $33feb484f084e2c2$var$PACKS = Object.freeze({
    proxia: Object.freeze({
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($370560921d00ddf1$exports))),
        logoWhite: (0, (/*@__PURE__*/$parcel$interopDefault($ea750477e199405c$exports)))
    })
});
function $33feb484f084e2c2$export$299aae4722d72834() {
    const id = (0, $eLeza.brand)().assetPack;
    return id && Object.prototype.hasOwnProperty.call($33feb484f084e2c2$var$PACKS, id) ? id : 'parsina';
}
function $33feb484f084e2c2$export$62e0383b4cfd0a36(name) {
    const id = $33feb484f084e2c2$export$299aae4722d72834();
    return (id === 'parsina' ? $33feb484f084e2c2$var$PARSINA : $33feb484f084e2c2$var$PACKS[id])[name] ?? null;
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");



// Which payment gateway the top-up flow uses, and how Toman prices map onto
// each gateway's wire unit.
//
// The whole UI prices in Toman («تومان»). Gateways disagree on the unit they
// settle in — Sepehr (بانک صادرات/شاپرک) takes RIALS, Zarinpal takes Toman — so
// the conversion happens once, here, at the moment we hand an amount to the BFF.
// The gateway table is DATA — `rialsPerToman` decides what a payment is worth,
// and `toGatewayAmount` must not need a translator to compute it. Only the
// bank's display name is copy, so only that is a key.
const $84433f335a456b60$export$839b863c97f80b96 = {
    sepehr: {
        labelKey: 'credits.gateway.saderat',
        unit: 'IRR',
        rialsPerToman: 10
    },
    zarinpal: {
        labelKey: 'credits.gateway.zarinpal',
        unit: 'IRT',
        rialsPerToman: 1
    }
};
const $84433f335a456b60$export$bd634cd508c418bb = 'sepehr';
const $84433f335a456b60$export$18053a58f12c6137 = (t, gateway = $84433f335a456b60$export$bd634cd508c418bb)=>{
    const key = $84433f335a456b60$export$839b863c97f80b96[gateway]?.labelKey;
    return key ? t(key) : '';
};
function $84433f335a456b60$export$5fca33782a4a7d9f(amountToman, gateway = $84433f335a456b60$export$bd634cd508c418bb) {
    const factor = $84433f335a456b60$export$839b863c97f80b96[gateway]?.rialsPerToman ?? 1;
    return Math.round(amountToman * factor);
}
function $84433f335a456b60$export$971b02bbb2a0b18b(currency) {
    return !currency || currency === 'IRT';
}


function $731b4ceb5faa7ddf$export$2f04c8775b039db() {
    const { purchaseAvailable: purchaseAvailable, creditPrice: creditPrice, packages: packages } = (0, $121df138798ec781$export$204bd72286fdb787)();
    return {
        canBuy: Boolean(purchaseAvailable) && (0, $84433f335a456b60$export$971b02bbb2a0b18b)(creditPrice?.currency),
        creditPrice: creditPrice,
        packages: packages
    };
}
var $731b4ceb5faa7ddf$export$2e2bcd8739ae039 = $731b4ceb5faa7ddf$export$2f04c8775b039db;


parcelRequire("5N0ZI");
var $fHxBh = parcelRequire("fHxBh");




var $jTCZr = parcelRequire("jTCZr");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// The app's ONE chat engine — a module-scope singleton over the framework's
// matrix-lite client, the same shape of thing the realtime event hub is: minted
// once (from App, after auth is ready), alive for the whole session, consumed
// anywhere through subscribe/getters. The Messages screen renders it; the nav
// badges read only its unread total.
//
// Session contract (see ../../parsina.bff.web typeDefs/chat.js): the BFF mints a
// short-lived Matrix credential via the `chatSession` query; this module owns
// re-minting. `expiresAt` is epoch-ms-as-a-string, so it is Number()ed before
// arithmetic. A fresh session is requested 60s before expiry and pushed into
// the running client with `updateToken` — the sync loop never sees a dead
// token in the happy path. When the server 401s anyway (clock skew, revocation)
// matrix-lite pauses and calls `onAuthError`; the same re-mint path resumes it.
//
// Two things make that re-mint safe, and both were learned in the patient app:
//
//   * **One re-mint at a time.** `onAuthError` can fire in a burst (every
//     in-flight request 401s at once) and the scheduled timer can land in the
//     middle of it. Without a dedupe those mints race, and the LAST one to
//     resolve wins `updateToken` — which may well be the OLDEST, earliest-
//     expiring token, so the session dies again minutes later. `remintPromise`
//     is set synchronously before the first await, so the second caller joins
//     the first instead of starting a rival.
//   * **The credential is never held.** `session` keeps everything about the
//     session EXCEPT `accessToken` (see `publicSession`); the token goes
//     straight into the client and is not readable back out of this module.
//     Nothing is persisted either — no storage, no cookie, no URL.
//
// Visibility discipline mirrors useRealtimeEvents: a hidden tab does not hold a
// long-poll open — stop() on hidden, start() on visible. That is tracked with
// an explicit `paused` flag rather than leaning on matrix-lite's internal
// `started` guard: a tab that was never hidden must not be "resumed", and this
// module should not need to know how the client de-duplicates start().
// matrix-lite keeps its room state across a stop/start, so resuming is cheap.
//
// Everything impure is injectable through configureChatRuntime so the whole
// machine runs in a Node test with a scripted bffQuery and a fake client.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

// Matrix, hand-rolled — the one place the chat wire protocol lives.
//
// Parsina's doctor↔patient messaging is text-only 1:1 DMs against a server we
// run ourselves with E2EE, media, presence and federation all switched OFF.
// That leaves exactly four things a client ever does: long-poll /sync, send a
// text event, paginate /messages backwards, and post a read receipt.
// matrix-js-sdk would be the kit's heaviest dependency by an order of
// magnitude — crypto stores, IndexedDB adapters, olm wasm — for those four
// endpoints, so this module speaks the client-server API directly instead.
//
// The contract: the CALLER owns the session. Minting a Matrix access token is
// each app's BFF's business (login, refresh, mapping Keycloak identity to a
// Matrix user); this module receives `accessToken`/`userId` ready-made and only
// speaks the CS API with them. When the server says 401 it calls `onAuthError`
// and pauses — it never tries to refresh anything itself; `updateToken()` with
// a fresh token resumes the loop.
//
// Everything impure is injectable — `fetchFn`, `sleepFn`, `nowFn` — and nothing
// touches Date.now() or timers at module scope, so the whole state machine runs
// under a scripted fetch in a Node test with zero real waiting.
//
// Local-echo rule (the one subtle part): a sent message is inserted immediately
// as a visibly-pending entry and STAYS pending until its echo comes back down
// /sync, where `unsigned.transaction_id` identifies it and the real event
// replaces the pending one in place — so there is never a duplicate bubble and
// never a message that silently vanished. A failed send flips to `failed: true`
// and waits for the user; nothing here ever auto-retries a write.
/**
 * createMatrixLite — factory (no classes exposed) for a headless Matrix client.
 *
 * Options:
 *   baseUrl      — homeserver origin, e.g. 'https://chat.example.ir' (no trailing /)
 *   accessToken  — Matrix access token minted by the app's BFF
 *   userId       — full Matrix user id ('@doc_1:example.ir'); `mine` derives from it
 *   fetchFn      — injectable fetch (defaults to globalThis.fetch)
 *   timeoutMs    — long-poll hold for incremental /sync   (default 30000)
 *   backoffMinMs — first retry delay on network/5xx       (default  2000)
 *   backoffMaxMs — retry delay ceiling                    (default 30000)
 *   onAuthError  — called once when the server answers 401; the loop pauses
 *                  until updateToken() supplies a fresh token
 *   sleepFn      — injectable delay, (ms) => Promise      (default setTimeout)
 *   nowFn        — injectable clock for local pending timestamps (default Date.now)
 *
 * Returns { start, stop, updateToken, onChange, getRooms, getTimeline,
 *           sendMessage, retryMessage, markRead, loadOlder, totalUnread }.
 */ const $6c2c656591efd0a7$var$API = '/_matrix/client/v3';
// Sent as an inline filter on every /sync: trim the payload to what a text-only
// DM client can render — a short timeline window, lazy-loaded membership, and
// none of the presence/ephemeral/account-data streams we have no UI for.
const $6c2c656591efd0a7$var$SYNC_FILTER = JSON.stringify({
    room: {
        timeline: {
            limit: 30
        },
        state: {
            lazy_load_members: true
        },
        ephemeral: {
            types: []
        },
        account_data: {
            types: []
        }
    },
    presence: {
        types: []
    },
    account_data: {
        types: []
    }
});
const $6c2c656591efd0a7$var$isTextMessage = (ev)=>ev && ev.type === 'm.room.message' && ev.content && ev.content.msgtype === 'm.text';
function $6c2c656591efd0a7$export$48e774e4fa9f3ffd({ baseUrl: baseUrl, accessToken: accessToken, userId: userId, fetchFn: fetchFn = (...args)=>globalThis.fetch(...args), timeoutMs: timeoutMs = 30000, backoffMinMs: backoffMinMs = 2000, backoffMaxMs: backoffMaxMs = 30000, onAuthError: onAuthError, sleepFn: sleepFn = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms)), nowFn: nowFn = ()=>Date.now() } = {}) {
    let token = accessToken;
    let nextBatch = null; // /sync since-token
    let started = false; // caller intent (start()/stop())
    let authPaused = false; // 401 pause; updateToken() lifts it
    let loopGen = 0; // bumped on stop/resume so a stale in-flight loop dies
    let txnSeq = 0;
    // roomId → { unread, timeline: [entry…], prevBatch, lastActivityTs }
    // entry: { eventId, sender, body, ts, mine, pending, failed, txnId }
    const rooms = new Map();
    const listeners = new Set();
    // Monotonic counter + random suffix: unique within this client instance AND
    // across a reload (the counter restarts but the suffix doesn't repeat).
    const newTxnId = ()=>`plite${++txnSeq}.${Math.random().toString(36).slice(2, 8)}`;
    const emit = ()=>{
        for (const cb of listeners)try {
            cb();
        } catch  {}
    };
    const request = (method, path, body)=>fetchFn(`${baseUrl}${$6c2c656591efd0a7$var$API}${path}`, {
            method: method,
            headers: {
                // Read at call time, not closure-capture time, so updateToken() applies
                // to every request issued after it.
                Authorization: `Bearer ${token}`,
                ...body !== undefined && {
                    'Content-Type': 'application/json'
                }
            },
            ...body !== undefined && {
                body: JSON.stringify(body)
            }
        });
    const ensureRoom = (roomId)=>{
        let room = rooms.get(roomId);
        if (!room) {
            room = {
                unread: 0,
                timeline: [],
                prevBatch: null,
                lastActivityTs: 0
            };
            rooms.set(roomId, room);
        }
        return room;
    };
    const mapEvent = (ev)=>({
            eventId: ev.event_id,
            sender: ev.sender,
            body: ev.content && ev.content.body || '',
            ts: ev.origin_server_ts || 0,
            mine: ev.sender === userId,
            pending: false,
            failed: false,
            txnId: ev.unsigned && ev.unsigned.transaction_id || null
        });
    // Append one wire event to a room, deduping the local echo. A message this
    // client sent comes back down /sync carrying `unsigned.transaction_id`; the
    // real event replaces the pending entry IN PLACE (position preserved) rather
    // than appending — that is what prevents the duplicate bubble.
    const appendEvent = (room, ev)=>{
        const mapped = mapEvent(ev);
        if (mapped.txnId) {
            const i = room.timeline.findIndex((e)=>e.txnId === mapped.txnId && (e.pending || e.failed));
            if (i !== -1) {
                room.timeline[i] = mapped;
                room.lastActivityTs = Math.max(room.lastActivityTs, mapped.ts);
                return;
            }
        }
        // Second line of defence: the send response already told us the event_id,
        // so an echo that arrives WITHOUT a transaction_id (proxy stripped it,
        // token shared across tabs) still resolves the pending entry instead of
        // duplicating it — and a plain re-delivery across a sync gap is dropped.
        if (mapped.eventId) {
            const j = room.timeline.findIndex((e)=>e.eventId === mapped.eventId);
            if (j !== -1) {
                if (room.timeline[j].pending || room.timeline[j].failed) room.timeline[j] = mapped;
                return;
            }
        }
        room.timeline.push(mapped);
        room.lastActivityTs = Math.max(room.lastActivityTs, mapped.ts);
    };
    const applySync = (data)=>{
        const joined = data.rooms && data.rooms.join || {};
        let changed = false;
        for (const [roomId, jr] of Object.entries(joined)){
            const isNew = !rooms.has(roomId);
            const room = ensureRoom(roomId);
            const tl = jr.timeline || {};
            if (isNew) // First sight of the room: this batch's prev_batch is where backwards
            // pagination starts.
            room.prevBatch = tl.prev_batch || null;
            else if (tl.limited) {
                // Gap between what we had and this batch (`limited: true`): the events
                // in between were dropped by the server-side window. Volumes on this
                // platform are tiny, so we don't try to stitch — reset the timeline to
                // the batch and point pagination at the NEW prev_batch, which covers
                // the gap. Local pending/failed entries are carried over: a failed
                // write must keep looking failed, never silently vanish.
                const local = room.timeline.filter((e)=>e.pending || e.failed);
                room.timeline = [];
                room.prevBatch = tl.prev_batch || null;
                room.timeline.push(...local);
            }
            for (const ev of (tl.events || []).filter($6c2c656591efd0a7$var$isTextMessage))appendEvent(room, ev);
            const un = jr.unread_notifications;
            if (un && typeof un.notification_count === 'number') room.unread = un.notification_count;
            changed = true;
        }
        if (data.next_batch) nextBatch = data.next_batch;
        // One onChange per applied batch — but an empty long-poll wakeup (the 30s
        // heartbeat) changes nothing and must not re-render every subscriber.
        if (changed) emit();
    };
    const syncOnce = ()=>{
        const qs = nextBatch ? `filter=${encodeURIComponent($6c2c656591efd0a7$var$SYNC_FILTER)}&since=${encodeURIComponent(nextBatch)}&timeout=${timeoutMs}` : `filter=${encodeURIComponent($6c2c656591efd0a7$var$SYNC_FILTER)}&timeout=0`;
        return request('GET', `/sync?${qs}`);
    };
    async function runLoop(gen) {
        let backoff = backoffMinMs;
        while(started && gen === loopGen){
            let status = 0;
            let data = null;
            try {
                const res = await syncOnce();
                if (gen !== loopGen || !started) return; // stopped while long-polling
                status = res.status;
                if (res.ok) data = await res.json();
            } catch  {
                status = 0; // network failure — same path as 5xx
            }
            if (gen !== loopGen || !started) return;
            if (status === 401) {
                // Token is dead. Pause — the caller owns session minting; updateToken()
                // restarts the loop with the fresh token.
                authPaused = true;
                if (onAuthError) onAuthError();
                return;
            }
            if (data) {
                applySync(data);
                backoff = backoffMinMs; // success resets the backoff ladder
            } else {
                await sleepFn(backoff);
                if (gen !== loopGen || !started) return;
                backoff = Math.min(backoff * 2, backoffMaxMs);
            }
        }
    }
    return {
        start () {
            if (started) return;
            started = true;
            authPaused = false;
            runLoop(++loopGen);
        },
        stop () {
            started = false;
            authPaused = false;
            loopGen++; // any in-flight loop iteration discards its result
        },
        updateToken (next) {
            token = next;
            if (started && authPaused) {
                authPaused = false;
                runLoop(++loopGen);
            }
        },
        onChange (cb) {
            listeners.add(cb);
            return ()=>listeners.delete(cb);
        },
        getRooms () {
            return [
                ...rooms.entries()
            ].map(([roomId, room])=>{
                const last = room.timeline.length ? room.timeline[room.timeline.length - 1] : null;
                return {
                    roomId: roomId,
                    unread: room.unread,
                    lastEvent: last ? {
                        body: last.body,
                        ts: last.ts,
                        sender: last.sender,
                        mine: last.mine
                    } : null,
                    lastActivityTs: room.lastActivityTs
                };
            }).sort((a, b)=>b.lastActivityTs - a.lastActivityTs);
        },
        getTimeline (roomId) {
            const room = rooms.get(roomId);
            return room ? room.timeline.slice() : [];
        },
        totalUnread () {
            let sum = 0;
            for (const room of rooms.values())sum += room.unread;
            return sum;
        },
        /**
     * Insert a visibly-pending entry NOW, then PUT the event. On success the
     * entry stays pending until the /sync echo replaces it (see appendEvent);
     * on failure it flips to failed and waits for retryMessage — a failed
     * write must look failed, never silently drop. Resolves to the txnId.
     */ async sendMessage (roomId, body) {
            const room = ensureRoom(roomId);
            const txnId = newTxnId();
            const entry = {
                eventId: null,
                sender: userId,
                body: body,
                ts: nowFn(),
                mine: true,
                pending: true,
                failed: false,
                txnId: txnId
            };
            room.timeline.push(entry);
            room.lastActivityTs = Math.max(room.lastActivityTs, entry.ts);
            emit();
            try {
                const res = await request('PUT', `/rooms/${encodeURIComponent(roomId)}/send/m.room.message/${encodeURIComponent(txnId)}`, {
                    msgtype: 'm.text',
                    body: body
                });
                if (!res.ok) throw new Error(`send failed: ${res.status}`);
                const resData = await res.json().catch(()=>({}));
                // Remember the event_id for the no-transaction_id echo fallback.
                if (resData.event_id) entry.eventId = resData.event_id;
            } catch  {
                entry.pending = false;
                entry.failed = true;
                emit();
            }
            return txnId;
        },
        /**
     * Re-send a failed entry: same body, NEW txnId (the old one may have been
     * half-processed server-side; reusing it would dedupe the retry away).
     * Caller-invoked only — nothing in this module auto-retries.
     */ async retryMessage (roomId, txnId) {
            const room = rooms.get(roomId);
            if (!room) return null;
            const entry = room.timeline.find((e)=>e.txnId === txnId && e.failed);
            if (!entry) return null;
            const fresh = newTxnId();
            entry.txnId = fresh;
            entry.failed = false;
            entry.pending = true;
            emit();
            try {
                const res = await request('PUT', `/rooms/${encodeURIComponent(roomId)}/send/m.room.message/${encodeURIComponent(fresh)}`, {
                    msgtype: 'm.text',
                    body: entry.body
                });
                if (!res.ok) throw new Error(`send failed: ${res.status}`);
                const resData = await res.json().catch(()=>({}));
                if (resData.event_id) entry.eventId = resData.event_id;
            } catch  {
                entry.pending = false;
                entry.failed = true;
                emit();
            }
            return fresh;
        },
        /**
     * Zero the local unread count IMMEDIATELY (the badge must clear the moment
     * the user opens the thread), then post the m.read receipt for the latest
     * real event. The POST is best-effort: receipts are idempotent and the
     * server's count re-arrives with the next event anyway.
     */ async markRead (roomId) {
            const room = rooms.get(roomId);
            if (!room) return;
            if (room.unread !== 0) {
                room.unread = 0;
                emit();
            }
            let last = null;
            for(let i = room.timeline.length - 1; i >= 0; i--){
                const e = room.timeline[i];
                if (e.eventId && !e.pending && !e.failed) {
                    last = e;
                    break;
                }
            }
            if (!last) return;
            try {
                await request('POST', `/rooms/${encodeURIComponent(roomId)}/receipt/m.read/${encodeURIComponent(last.eventId)}`, {});
            } catch  {}
        },
        /**
     * Page backwards from the room's prev_batch token; prepend older messages.
     * Returns { hasMore } — false once the server omits `end` or the chunk is
     * empty (start of the room reached). Never called automatically: the
     * pagination-not-infinite-scroll rule puts the trigger on a button.
     */ async loadOlder (roomId, limit = 30) {
            const room = rooms.get(roomId);
            if (!room || !room.prevBatch) return {
                hasMore: false
            };
            const res = await request('GET', `/rooms/${encodeURIComponent(roomId)}/messages?dir=b&from=${encodeURIComponent(room.prevBatch)}&limit=${limit}`);
            if (!res.ok) throw new Error(`loadOlder failed: ${res.status}`);
            const data = await res.json();
            const rawChunk = data.chunk || [];
            // dir=b returns reverse-chronological; flip to timeline order before
            // prepending, and drop anything we already hold (overlap at the seam).
            const existing = new Set(room.timeline.map((e)=>e.eventId).filter(Boolean));
            const older = rawChunk.filter($6c2c656591efd0a7$var$isTextMessage).map(mapEvent).reverse().filter((e)=>!existing.has(e.eventId));
            if (older.length) {
                room.timeline.unshift(...older);
                emit();
            }
            room.prevBatch = data.end || null;
            // hasMore judges the RAW chunk: a page of filtered-out state events is
            // not the start of the room.
            return {
                hasMore: Boolean(data.end) && rawChunk.length > 0
            };
        }
    };
}
var $6c2c656591efd0a7$export$2e2bcd8739ae039 = $6c2c656591efd0a7$export$48e774e4fa9f3ffd;


const $caf8273c728e960b$export$4ae5b74288ed990b = `
  query ChatSession {
    chatSession {
      homeserverUrl
      userId
      accessToken
      deviceId
      expiresAt
      canSend
      readOnlyReason
    }
  }
`;
// Re-mint this long before the token dies, and never sooner than the floor —
// a clock that disagrees with the server must not spin a re-mint loop.
const $caf8273c728e960b$var$REMINT_LEEWAY_MS = 60000;
const $caf8273c728e960b$var$REMINT_FLOOR_MS = 5000;
// A failed re-mint retries on a fixed cadence; the session is still valid for
// the leeway window, so there is no reason to hammer.
const $caf8273c728e960b$var$REMINT_RETRY_MS = 30000;
const $caf8273c728e960b$var$defaultDeps = ()=>({
        bffQuery: (0, $adebb901af88e18b$export$7fb4864174f056c),
        createClient: (0, $6c2c656591efd0a7$export$48e774e4fa9f3ffd)
    });
let $caf8273c728e960b$var$deps = $caf8273c728e960b$var$defaultDeps();
let $caf8273c728e960b$var$client = null;
let $caf8273c728e960b$var$session = null; // the last ChatSession payload MINUS its credential
let $caf8273c728e960b$var$startPromise = null; // in-flight or resolved ensureChatStarted()
let $caf8273c728e960b$var$remintPromise = null; // in-flight remint() — dedupes the timer vs. a 401 burst
let $caf8273c728e960b$var$sessionError = null; // why the last start failed (null once started)
let $caf8273c728e960b$var$remintTimer = null;
let $caf8273c728e960b$var$unsubscribeClient = null;
let $caf8273c728e960b$var$visibilityBound = false;
let $caf8273c728e960b$var$paused = false; // stopped because the tab went to the background
// Monotonic change counter. `getRooms()` / `getTimeline()` build a fresh array on
// every call, so they cannot BE a useSyncExternalStore snapshot — the store would
// hand React a new identity each render and loop forever. This integer is the
// snapshot; consumers read it and then derive the arrays through useMemo.
let $caf8273c728e960b$var$revision = 0;
const $caf8273c728e960b$var$listeners = new Set();
const $caf8273c728e960b$var$emit = ()=>{
    $caf8273c728e960b$var$revision += 1;
    for (const cb of [
        ...$caf8273c728e960b$var$listeners
    ])try {
        cb();
    } catch  {}
};
function $caf8273c728e960b$export$3564a0370a2c68c1(overrides = {}) {
    $caf8273c728e960b$var$deps = {
        ...$caf8273c728e960b$var$defaultDeps(),
        ...overrides
    };
}
function $caf8273c728e960b$export$22cdffcf8c7b301() {
    clearTimeout($caf8273c728e960b$var$remintTimer);
    $caf8273c728e960b$var$remintTimer = null;
    if ($caf8273c728e960b$var$unsubscribeClient) $caf8273c728e960b$var$unsubscribeClient();
    $caf8273c728e960b$var$unsubscribeClient = null;
    try {
        $caf8273c728e960b$var$client?.stop();
    } catch  {}
    $caf8273c728e960b$var$client = null;
    $caf8273c728e960b$var$session = null;
    $caf8273c728e960b$var$startPromise = null;
    $caf8273c728e960b$var$remintPromise = null;
    $caf8273c728e960b$var$sessionError = null;
    $caf8273c728e960b$var$paused = false;
    if ($caf8273c728e960b$var$visibilityBound && typeof document !== 'undefined') document.removeEventListener('visibilitychange', $caf8273c728e960b$var$onVisibility);
    $caf8273c728e960b$var$visibilityBound = false;
    $caf8273c728e960b$var$listeners.clear();
    $caf8273c728e960b$var$deps = $caf8273c728e960b$var$defaultDeps();
}
const $caf8273c728e960b$var$mintSession = async ()=>{
    const data = await $caf8273c728e960b$var$deps.bffQuery($caf8273c728e960b$export$4ae5b74288ed990b);
    const next = data?.chatSession;
    if (!next || !next.accessToken) throw new Error('chatSession: empty response');
    return next;
};
/**
 * Everything about a session except the credential. What the app needs from a
 * session is `canSend` / `readOnlyReason` / `expiresAt`; the access token is
 * needed exactly twice — at `createClient` and at `updateToken` — and both are
 * in this file. Keeping it in module scope afterwards only widens the reach of
 * anything that can read this module.
 */ const $caf8273c728e960b$var$publicSession = (s)=>({
        homeserverUrl: s.homeserverUrl,
        userId: s.userId,
        deviceId: s.deviceId,
        expiresAt: s.expiresAt,
        canSend: s.canSend !== false,
        readOnlyReason: s.readOnlyReason || null
    });
function $caf8273c728e960b$var$scheduleRemint() {
    clearTimeout($caf8273c728e960b$var$remintTimer);
    if (!$caf8273c728e960b$var$session?.expiresAt) return;
    // Epoch-ms-as-a-string on the wire — Number() it, never Date-parse it.
    const delay = Math.max(Number($caf8273c728e960b$var$session.expiresAt) - Date.now() - $caf8273c728e960b$var$REMINT_LEEWAY_MS, $caf8273c728e960b$var$REMINT_FLOOR_MS);
    $caf8273c728e960b$var$remintTimer = setTimeout($caf8273c728e960b$var$remint, delay);
}
function $caf8273c728e960b$var$remint() {
    if (!$caf8273c728e960b$var$client) return Promise.resolve();
    // Already minting — join it. The scheduled refresh and a 401 burst reach
    // here on the same tick often enough that letting both run would routinely
    // hand `updateToken` the older of the two tokens.
    if ($caf8273c728e960b$var$remintPromise) return $caf8273c728e960b$var$remintPromise;
    // The async body runs synchronously up to its first await, so `remintPromise`
    // is set before any caller can observe the gap.
    const run = async ()=>{
        const next = await $caf8273c728e960b$var$mintSession();
        $caf8273c728e960b$var$session = $caf8273c728e960b$var$publicSession(next);
        // updateToken both replaces the credential and, after a 401 pause, resumes
        // the sync loop — one path serves the scheduled refresh and onAuthError.
        $caf8273c728e960b$var$client.updateToken(next.accessToken);
        $caf8273c728e960b$var$scheduleRemint();
        $caf8273c728e960b$var$emit(); // canSend / readOnlyReason may have changed with the new session
    };
    $caf8273c728e960b$var$remintPromise = run().then(()=>{
        $caf8273c728e960b$var$remintPromise = null;
    }, ()=>{
        $caf8273c728e960b$var$remintPromise = null;
        clearTimeout($caf8273c728e960b$var$remintTimer);
        $caf8273c728e960b$var$remintTimer = setTimeout($caf8273c728e960b$var$remint, $caf8273c728e960b$var$REMINT_RETRY_MS);
    });
    return $caf8273c728e960b$var$remintPromise;
}
function $caf8273c728e960b$var$onVisibility() {
    if (!$caf8273c728e960b$var$client || typeof document === 'undefined') return;
    // Mirror useRealtimeEvents: don't hold a long-poll open for a hidden tab;
    // resume the moment the doctor looks back at it.
    if (document.visibilityState === 'hidden') {
        $caf8273c728e960b$var$client.stop();
        $caf8273c728e960b$var$paused = true;
        return;
    }
    // Only a tab that WE stopped is resumed. `start()` on every visibility change
    // leaned on matrix-lite's internal `started` guard to be a no-op — a
    // downstream implementation detail this module has no business assuming.
    if (!$caf8273c728e960b$var$paused) return;
    $caf8273c728e960b$var$paused = false;
    $caf8273c728e960b$var$client.start();
}
function $caf8273c728e960b$export$cd24a7f1e48dad5d() {
    if ($caf8273c728e960b$var$startPromise) return $caf8273c728e960b$var$startPromise;
    $caf8273c728e960b$var$startPromise = (async ()=>{
        $caf8273c728e960b$var$sessionError = null;
        const minted = await $caf8273c728e960b$var$mintSession();
        $caf8273c728e960b$var$session = $caf8273c728e960b$var$publicSession(minted);
        $caf8273c728e960b$var$client = $caf8273c728e960b$var$deps.createClient({
            baseUrl: minted.homeserverUrl,
            accessToken: minted.accessToken,
            userId: minted.userId,
            onAuthError: ()=>{
                $caf8273c728e960b$var$remint();
            }
        });
        $caf8273c728e960b$var$unsubscribeClient = $caf8273c728e960b$var$client.onChange($caf8273c728e960b$var$emit);
        $caf8273c728e960b$var$client.start();
        $caf8273c728e960b$var$scheduleRemint();
        if (!$caf8273c728e960b$var$visibilityBound && typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', $caf8273c728e960b$var$onVisibility);
            $caf8273c728e960b$var$visibilityBound = true;
        }
        $caf8273c728e960b$var$emit();
        return $caf8273c728e960b$var$client;
    })().catch((err)=>{
        $caf8273c728e960b$var$sessionError = err;
        $caf8273c728e960b$var$startPromise = null; // the next ensureChatStarted() is a real retry
        $caf8273c728e960b$var$emit();
        throw err;
    });
    return $caf8273c728e960b$var$startPromise;
}
const $caf8273c728e960b$export$8eae3e342750ca77 = ()=>$caf8273c728e960b$var$client;
const $caf8273c728e960b$export$86f91dc77d5d0b6e = ()=>$caf8273c728e960b$var$session;
const $caf8273c728e960b$export$fd0964bef134807 = ()=>$caf8273c728e960b$var$sessionError;
const $caf8273c728e960b$export$ff598a7f140cf166 = ()=>$caf8273c728e960b$var$client ? $caf8273c728e960b$var$client.totalUnread() : 0;
const $caf8273c728e960b$export$a13a5384c80ad748 = ()=>$caf8273c728e960b$var$revision;
const $caf8273c728e960b$export$12cb85cc1540d7e0 = ()=>$caf8273c728e960b$var$session?.canSend !== false;
const $caf8273c728e960b$export$502a12fc86aa76b = ()=>$caf8273c728e960b$var$session?.canSend === false ? $caf8273c728e960b$var$session?.readOnlyReason || null : null;
function $caf8273c728e960b$export$e8257d0a89c4abf9(cb) {
    $caf8273c728e960b$var$listeners.add(cb);
    return ()=>$caf8273c728e960b$var$listeners.delete(cb);
}
function $caf8273c728e960b$export$f3b3260407e19024() {
    return (0, $acw62.useSyncExternalStore)($caf8273c728e960b$export$e8257d0a89c4abf9, $caf8273c728e960b$export$ff598a7f140cf166, ()=>0);
}



var $acw62 = parcelRequire("acw62");


// «رفتن به پنل کلینیک» — may this account enter the clinic panel, and as which
// clinic?
//
// Both questions in ONE document, because neither existing query answers it
// alone:
//   • `myOwnedClinics` = clinicmanagement rows whose keycloak_user_id is this
//     sub, i.e. clinics this account registered. Owning one is what earns the
//     `clinic_owner` role + `clinic_id` attribute (bff.web lib/kcAdmin.js), so
//     an owned clinic is always enterable.
//   • `myClinics` = doctorpreference `clinic_doctors` memberships, which is how
//     a doctor who joined someone else's clinic by code appears — and that one
//     carries a `status`, because a membership can still be pending.
// No new BFF field is added: the clinic BFF authorises on the token's roles
// anyway (clinic_owner / clinic_admin / clinic_staff), so this is chrome
// deciding what to show, not an access decision.
//
// `currency` rides along because these are also "the doctor's clinics" for the
// money screens: the accounting filter lists them, and an EMPTY report or day —
// which has no row to read a currency from — states its zero in the clinic's.
const $90c3af16928ea94c$var$CLINIC_SWITCH = `
  query ClinicSwitchTargets {
    myOwnedClinics { id name city currency }
    myClinics {
      id
      status
      clinic { id name city currency }
    }
  }
`;
// The membership states that let the doctor in. The practitioner service
// writes exactly two words into `clinic_doctors.status`: a link is born
// `pending` and `AcceptClinicDoctor` writes `accepted` — the same pair
// SettingsKit's membership badge knows, and the one the clinic BFF's
// `practitionerStatus` maps to ACTIVE.
//
// This set used to hold only `active`/`approved`, words nothing writes, so every
// clinic a doctor had JOINED was dropped and only the one they owned survived:
// پذیرش then locked its lens to that clinic, hid the others' appointments, and
// its «نمایش همه» had nothing to widen to. `active`/`approved` stay for older
// rows. Anything else (pending, invited, suspended, a value this client has
// never seen) is NOT an entry ticket: the clinic BFF would answer FORBIDDEN and
// the doctor would land on a dead panel.
const $90c3af16928ea94c$var$ENTERABLE = new Set([
    'accepted',
    'active',
    'approved'
]);
// `currency` is passed through as the BFF sent it; '' reads IRR wherever it is
// used (lib/clinicMoney), which is also what an older BFF's missing field means.
function $90c3af16928ea94c$var$toTargets(data) {
    const byId = new Map();
    for (const c of data?.myOwnedClinics || [])if (c?.id) byId.set(c.id, {
        id: c.id,
        name: c.name || '',
        city: c.city || '',
        currency: c.currency || '',
        owned: true
    });
    for (const link of data?.myClinics || []){
        const c = link?.clinic;
        if (!c?.id || byId.has(c.id)) continue;
        if (!$90c3af16928ea94c$var$ENTERABLE.has(link.status)) continue;
        byId.set(c.id, {
            id: c.id,
            name: c.name || '',
            city: c.city || '',
            currency: c.currency || '',
            owned: false
        });
    }
    return [
        ...byId.values()
    ];
}
/**
 * Memberships that exist but do not yet let the doctor in — a join request the
 * clinic has not answered.
 *
 * `toTargets` drops these on purpose (they are not entry tickets), which used
 * to make a doctor who had just sent a request indistinguishable from one who
 * had never heard of Parsina: both saw «you belong to no clinic». They are two
 * different situations and only one of them has anything left to do.
 *
 * An enterable clinic wins over a pending row for the SAME clinic — a request
 * that has since been approved is not still pending.
 */ function $90c3af16928ea94c$var$toPending(data, targets) {
    const enterable = new Set(targets.map((c)=>c.id));
    const out = [];
    for (const link of data?.myClinics || []){
        const c = link?.clinic;
        if (!c?.id || enterable.has(c.id) || $90c3af16928ea94c$var$ENTERABLE.has(link.status)) continue;
        out.push({
            id: c.id,
            name: c.name || '',
            city: c.city || '',
            status: link.status || ''
        });
    }
    return out;
}
function $90c3af16928ea94c$export$656ea0803b1a2433(clinic) {
    const ref = typeof clinic === 'string' ? clinic : clinic?.slug || clinic?.id || '';
    return ref ? `${0, $d87bd335296b449f$export$ce4d22a853fad121}/c/${encodeURIComponent(ref)}/` : `${0, $d87bd335296b449f$export$ce4d22a853fad121}/`;
}
function $90c3af16928ea94c$export$35411b84b35a3ed4(clinic) {
    window.location.assign($90c3af16928ea94c$export$656ea0803b1a2433(clinic));
}
function $90c3af16928ea94c$export$809575eb8daa47ea(clinic, doctorId) {
    const who = doctorId ? encodeURIComponent(doctorId) : '1';
    return `${$90c3af16928ea94c$export$656ea0803b1a2433(clinic)}reception?book=${who}`;
}
function $90c3af16928ea94c$export$891d531b2f03987b(clinic, doctorId) {
    window.open($90c3af16928ea94c$export$809575eb8daa47ea(clinic, doctorId), '_blank', 'noopener,noreferrer');
}
function $90c3af16928ea94c$export$f5416d3c5746c6f8() {
    const [targets, setTargets] = (0, $acw62.useState)([]);
    const [pending, setPending] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchTargets = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($90c3af16928ea94c$var$CLINIC_SWITCH);
            const next = $90c3af16928ea94c$var$toTargets(data);
            setTargets(next);
            setPending($90c3af16928ea94c$var$toPending(data, next));
            setError(null);
        } catch (e) {
            // Chrome, not content: a clinicmanagement blip must never put an error in
            // the sidebar or block the doctor's own work. No clinic we can prove →
            // no button. But the failure is KEPT (`error`): «you have no clinic» is a
            // claim a screen may only make after a successful empty answer.
            setTargets([]);
            setPending([]);
            setError(e);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        setLoading(true);
        fetchTargets().finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        fetchTargets
    ]);
    // `canSwitch` is false while loading too — the button appears once, when we
    // know, rather than flickering in and out of the sidebar on every mount.
    // The empty-day state needs the ownership split, not just «any clinic»: an
    // owner gets «ثبت نوبت», a member gets told whom to ask. First of each wins —
    // a doctor who owns two clinics still books at one desk at a time.
    const ownedClinic = targets.find((c)=>c.owned) || null;
    const joinedClinic = targets.find((c)=>!c.owned) || null;
    return {
        targets: targets,
        pending: pending,
        loading: loading,
        error: error,
        canSwitch: !loading && targets.length > 0,
        ownedClinic: ownedClinic,
        joinedClinic: joinedClinic,
        refresh: fetchTargets
    };
}


// ─────────────────────────────────────────────────────────────────────────────
// Messages — shared logic (DESIGN-CONCEPT-MOBILE §1.1).
//
// `Messages.web.jsx` and `Messages.mobile.jsx` are two independent render trees
// that must never *disagree* about what a conversation row is, how the list is
// ordered, what a row's time label means, or how an unread count is capped.
// All of that non-visual truth lives here: pure functions and translation KEYS
// only — no markup, no hooks, no literal copy (a plain module cannot call the
// translator; helpers that need one take it as an argument, the
// `exportLinesCsv(rows, label, t)` precedent).
// ─────────────────────────────────────────────────────────────────────────────
const $b5200d235eee6334$var$DAY_MS = 86400000;
// Start of the calendar day an instant falls in, in the device's local time.
// Doctors and their clinics run on Iran local time; the row-time rule is about
// "what the doctor's clock calls today", which is exactly what local time is.
const $b5200d235eee6334$var$dayStart = (ts)=>{
    const d = new Date(ts);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
};
const $b5200d235eee6334$export$569445e1fcf7921 = (rows)=>[
        ...rows
    ].sort((a, b)=>(b.lastActivityTs || 0) - (a.lastActivityTs || 0));
function $b5200d235eee6334$export$304baa583bceb4d(bffConversations = [], matrixRooms = []) {
    const byRoom = new Map(matrixRooms.map((r)=>[
            r.roomId,
            r
        ]));
    const rows = bffConversations.map((c)=>{
        const live = byRoom.get(c.roomId);
        byRoom.delete(c.roomId);
        return {
            roomId: c.roomId,
            peerDisplayName: c.peerDisplayName || null,
            peerType: c.peerType || null,
            peerSubjectId: c.peerSubjectId || null,
            role: null,
            reachable: true,
            unread: live?.unread || 0,
            lastEvent: live?.lastEvent || null,
            lastActivityTs: live?.lastActivityTs || Number(c.createdAt) || 0,
            started: true
        };
    });
    for (const [roomId, live] of byRoom)rows.push({
        roomId: roomId,
        peerDisplayName: null,
        peerType: null,
        peerSubjectId: null,
        role: null,
        reachable: true,
        unread: live.unread || 0,
        lastEvent: live.lastEvent || null,
        lastActivityTs: live.lastActivityTs || 0,
        started: true
    });
    return $b5200d235eee6334$export$569445e1fcf7921(rows);
}
function $b5200d235eee6334$export$8b796ceb524fa5a(row, query) {
    const needle = (query || '').trim().toLowerCase();
    if (!needle) return true;
    return (row.peerDisplayName || '').toLowerCase().includes(needle);
}
function $b5200d235eee6334$export$e217d6a4c7385cae(contacts = [], conversations = [], query = '') {
    if (!(query || '').trim()) return [];
    const haveRoom = new Set(conversations.map((c)=>c.roomId).filter(Boolean));
    return contacts.filter((c)=>!c.roomId || !haveRoom.has(c.roomId)).map((c)=>({
            key: `${c.subjectType}:${c.subjectId}`,
            roomId: c.roomId || null,
            peerDisplayName: c.displayName || null,
            peerType: c.subjectType || null,
            peerSubjectId: c.subjectId,
            role: c.role || null,
            // False = the patient has no account yet. The room is still writable —
            // the surfaces show the hint, they never block the send.
            reachable: c.reachable !== false,
            unread: 0,
            lastEvent: null,
            lastActivityTs: 0,
            started: false
        })).filter((row)=>$b5200d235eee6334$export$8b796ceb524fa5a(row, query));
}
function $b5200d235eee6334$export$46b7bea496232afd(ts, now = Date.now()) {
    const today = $b5200d235eee6334$var$dayStart(now);
    if (ts >= today) return 'time';
    if (ts >= today - $b5200d235eee6334$var$DAY_MS) return 'yesterday';
    return 'date';
}
function $b5200d235eee6334$export$bbb4a730e52f3d32(ts, { t: t, formatTime: formatTime, formatDate: formatDate }, now = Date.now()) {
    if (!ts) return '';
    switch($b5200d235eee6334$export$46b7bea496232afd(ts, now)){
        case 'time':
            return formatTime(ts);
        case 'yesterday':
            return t('messages.yesterday');
        default:
            return formatDate(ts, 'short');
    }
}
const $b5200d235eee6334$export$e7626c1a332ea5bd = 9;
function $b5200d235eee6334$export$95dcf77aabe4f3a4(count, formatNumber) {
    const n = Number(count) || 0;
    if (n <= 0) return '';
    if (n > $b5200d235eee6334$export$e7626c1a332ea5bd) return `${formatNumber($b5200d235eee6334$export$e7626c1a332ea5bd)}+`;
    return formatNumber(n);
}
const $b5200d235eee6334$export$54536d85f46615ae = (rows)=>rows.filter((r)=>(r.unread || 0) > 0);
function $b5200d235eee6334$export$941a2159f900cf38(timeline = []) {
    const groups = [];
    for (const msg of timeline){
        const day = $b5200d235eee6334$var$dayStart(msg.ts || 0);
        const last = groups[groups.length - 1];
        if (last && last.dayTs === day) last.messages.push(msg);
        else groups.push({
            dayTs: day,
            messages: [
                msg
            ]
        });
    }
    return groups;
}
function $b5200d235eee6334$export$711869e6ac8f0cad(row) {
    if (row?.role === 'doctor') return 'messages.roles.doctor';
    if (row?.role === 'staff') return 'messages.roles.staff';
    if (row?.role === 'patient') return 'messages.roles.patient';
    return String(row?.peerType || '').includes('PATIENT') ? 'messages.roles.patient' : 'messages.roles.staff';
}
function $b5200d235eee6334$export$fd1b0770ac454423(reason) {
    const r = String(reason || '').toUpperCase();
    if (r.includes('SUBSCRIPTION') || r.includes('LAPSE')) return 'messages.readOnly.subscription';
    return 'messages.readOnly.generic';
}


/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3cce873667d965dd$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $3cce873667d965dd$export$2e2bcd8739ae039 = (0, $9QBug.default)("globe", $3cce873667d965dd$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eLeza = parcelRequire("eLeza");
function $0de037e7a1b59dc4$export$b1f08bca8a845a15(tables, locale, key) {
    const own = (0, $eLeza.brandString)(locale, key);
    if (own !== undefined) return {
        value: own,
        from: locale
    };
    const table = tables[locale] || tables.fa;
    if (table[key] != null) return {
        value: table[key],
        from: tables[locale] ? locale : 'fa'
    };
    return {
        value: tables.fa[key],
        from: 'fa'
    };
}
function $0de037e7a1b59dc4$export$9a328bbde6508c84(template, vars, locale) {
    if (typeof template !== 'string' || template.indexOf('{{') === -1) return template;
    return template.replace((0, $eLeza.PLACEHOLDER), (match, name, inline)=>{
        const named = vars != null && Object.prototype.hasOwnProperty.call(vars, name);
        if (!named) {
            const token = (0, $eLeza.brandToken)(name, locale, inline);
            if (token !== undefined) return token;
        }
        const value = vars?.[name];
        return value == null ? match : String(value);
    });
}


var $caa894c6b98b0a14$exports = {};
$caa894c6b98b0a14$exports = JSON.parse('{"nav":{"items":{"myPage":"\u0635\u0641\u062D\u0647\u0654 \u0645\u0646"}},"myPage":{"subtitle":"\u0635\u0641\u062D\u0647\u0654 \u0627\u062E\u062A\u0635\u0627\u0635\u06CC \u0634\u0645\u0627 \u062F\u0631 {{brand}}: \u0642\u0627\u0644\u0628 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u060C \u0628\u062E\u0634\u200C\u0647\u0627 \u0631\u0627 \u0628\u0686\u06CC\u0646\u06CC\u062F \u0648 \u0645\u0646\u062A\u0634\u0631 \u06A9\u0646\u06CC\u062F.","loading":"\u062F\u0631 \u062D\u0627\u0644 \u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC \u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627","loadFailed":"\u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F","railLabel":"\u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0635\u0641\u062D\u0647","markdownHint":"\u0642\u0627\u0644\u0628\u200C\u0628\u0646\u062F\u06CC \u0633\u0627\u062F\u0647 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F: # \u062A\u06CC\u062A\u0631\u060C **\u067E\u0631\u0631\u0646\u06AF**\u060C \u0641\u0647\u0631\u0633\u062A \u0628\u0627 - \u0648 \u067E\u06CC\u0648\u0646\u062F \u0628\u0647 \u0635\u0648\u0631\u062A [\u0645\u062A\u0646](https://\u2026). HTML \u067E\u0630\u06CC\u0631\u0641\u062A\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.","markdownHintShort":"**\u067E\u0631\u0631\u0646\u06AF**\u060C \u0641\u0647\u0631\u0633\u062A \u0628\u0627 - \u0648 \u067E\u06CC\u0648\u0646\u062F \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F.","tabs":{"label":"\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u0635\u0641\u062D\u0647\u0654 \u0645\u0646","builder":"\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0635\u0641\u062D\u0647","leads":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC \u0635\u0641\u062D\u0647"},"status":{"draft":"\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633","published":"\u0645\u0646\u062A\u0634\u0631\u0634\u062F\u0647","unpublished":"\u0644\u063A\u0648 \u0627\u0646\u062A\u0634\u0627\u0631","suspended":"\u0645\u0639\u0644\u0642","unknown":"\u0646\u0627\u0645\u0634\u062E\u0635"},"statusCard":{"title":"\u0648\u0636\u0639\u06CC\u062A \u0635\u0641\u062D\u0647","liveUrl":"\u0646\u0634\u0627\u0646\u06CC \u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627","futureUrl":"\u067E\u0633 \u0627\u0632 \u0627\u0646\u062A\u0634\u0627\u0631\u060C \u0635\u0641\u062D\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u062E\u0648\u0627\u0647\u062F \u0628\u0648\u062F","copy":"\u06A9\u067E\u06CC \u0646\u0634\u0627\u0646\u06CC","copied":"\u0646\u0634\u0627\u0646\u06CC \u06A9\u067E\u06CC \u0634\u062F","copyFailed":"\u06A9\u067E\u06CC \u0646\u0634\u0627\u0646\u06CC \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F","lastPublished":"\u0622\u062E\u0631\u06CC\u0646 \u0627\u0646\u062A\u0634\u0627\u0631: {{date}}","preview":"\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634","openPreview":"\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634","popupBlocked":"\u0645\u0631\u0648\u0631\u06AF\u0631 \u067E\u0646\u062C\u0631\u0647\u0654 \u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634 \u0631\u0627 \u0645\u0633\u062F\u0648\u062F \u06A9\u0631\u062F\u061B \u0627\u0632 \u067E\u06CC\u0648\u0646\u062F \u0632\u06CC\u0631 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.","publish":"\u0627\u0646\u062A\u0634\u0627\u0631","republish":"\u0627\u0646\u062A\u0634\u0627\u0631 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A","unpublish":"\u0644\u063A\u0648 \u0627\u0646\u062A\u0634\u0627\u0631","unpublishTitle":"\u0644\u063A\u0648 \u0627\u0646\u062A\u0634\u0627\u0631 \u0635\u0641\u062D\u0647\u061F","unpublishBody":"\u0635\u0641\u062D\u0647 \u0627\u0632 \u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0628\u0631\u062F\u0627\u0634\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0646\u0634\u0627\u0646\u06CC \u0622\u0646 \u062F\u06CC\u06AF\u0631 \u0628\u0627\u0632 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F. \u0647\u0645\u0647\u0654 \u0645\u062D\u062A\u0648\u0627 \u062D\u0641\u0638 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u062F\u0648\u0628\u0627\u0631\u0647 \u0645\u0646\u062A\u0634\u0631 \u06A9\u0646\u06CC\u062F.","unpublishConfirm":"\u0644\u063A\u0648 \u0627\u0646\u062A\u0634\u0627\u0631 \u06A9\u0646","unpublished":"\u0627\u0646\u062A\u0634\u0627\u0631 \u0635\u0641\u062D\u0647 \u0644\u063A\u0648 \u0634\u062F","unpublishFailed":"\u0644\u063A\u0648 \u0627\u0646\u062A\u0634\u0627\u0631 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.","blockersTitle":"\u0628\u0631\u0627\u06CC \u0627\u0646\u062A\u0634\u0627\u0631\u060C \u0627\u06CC\u0646 \u0645\u0648\u0627\u0631\u062F \u0631\u0627 \u06A9\u0627\u0645\u0644 \u06A9\u0646\u06CC\u062F:","addCouncil":"\u062B\u0628\u062A \u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062F\u0631 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644"},"banner":{"suspendedTitle":"\u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u062A\u0648\u0633\u0637 {{brand}} \u0645\u0639\u0644\u0642 \u0634\u062F\u0647 \u0627\u0633\u062A","suspendedNoReason":"\u062F\u0644\u06CC\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.","suspendedSupport":"\u0635\u0641\u062D\u0647 \u0641\u0642\u0637\u200C\u062E\u0648\u0627\u0646\u062F\u0646\u06CC \u0627\u0633\u062A. \u0628\u0631\u0627\u06CC \u0631\u0641\u0639 \u062A\u0639\u0644\u06CC\u0642 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC {{brand}} \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.","unpublishedChanges":"\u062A\u063A\u06CC\u06CC\u0631\u0627\u062A\u06CC \u062F\u0627\u0631\u06CC\u062F \u06A9\u0647 \u0647\u0646\u0648\u0632 \u0645\u0646\u062A\u0634\u0631 \u0646\u0634\u062F\u0647\u200C\u0627\u0646\u062F\u061B \u0628\u0627\u0632\u062F\u06CC\u062F\u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u0646\u0633\u062E\u0647\u0654 \u0642\u0628\u0644\u06CC \u0631\u0627 \u0645\u06CC\u200C\u0628\u06CC\u0646\u0646\u062F."},"save":{"save":"\u0630\u062E\u06CC\u0631\u0647","reset":"\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC","saving":"\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u2026","saved":"\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F","dirty":"\u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647"},"publish":{"title":"\u0627\u0646\u062A\u0634\u0627\u0631 \u0635\u0641\u062D\u0647","intro":"\u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0628\u0627 \u0627\u0646\u062A\u0634\u0627\u0631\u060C \u0628\u0631\u0627\u06CC \u0647\u0645\u0647 \u062F\u0631 \u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0627\u0628\u0644 \u0645\u0634\u0627\u0647\u062F\u0647 \u0648 \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u0645\u06CC\u200C\u0634\u0648\u062F. \u067E\u06CC\u0634 \u0627\u0632 \u0627\u0646\u062A\u0634\u0627\u0631 \u0627\u06CC\u0646 \u0645\u0648\u0627\u0631\u062F \u0631\u0627 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0646\u06CC\u062F:","rule1":"\u0645\u062D\u062A\u0648\u0627\u06CC \u0635\u0641\u062D\u0647 \u0628\u0627 \u0636\u0648\u0627\u0628\u0637 \u062A\u0628\u0644\u06CC\u063A\u0627\u062A \u0633\u0627\u0632\u0645\u0627\u0646 \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0633\u0627\u0632\u06AF\u0627\u0631 \u0627\u0633\u062A \u0648 \u0627\u062F\u0639\u0627\u06CC \u062F\u0631\u0645\u0627\u0646 \u0642\u0637\u0639\u06CC\u060C \u062A\u0636\u0645\u06CC\u0646 \u0646\u062A\u06CC\u062C\u0647 \u06CC\u0627 \u0645\u0642\u0627\u06CC\u0633\u0647 \u0628\u0627 \u0647\u0645\u06A9\u0627\u0631\u0627\u0646 \u0646\u062F\u0627\u0631\u062F.","rule2":"\u062A\u0635\u0627\u0648\u06CC\u0631 \u0648 \u0646\u0648\u0634\u062A\u0647\u200C\u0647\u0627 \u0645\u062A\u0639\u0644\u0642 \u0628\u0647 \u0634\u0645\u0627\u0633\u062A \u06CC\u0627 \u0627\u062C\u0627\u0632\u0647\u0654 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0627\u0632 \u0622\u0646\u200C\u0647\u0627 \u0631\u0627 \u062F\u0627\u0631\u06CC\u062F.","rule3":"\u0646\u0638\u0631\u0627\u062A \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0627 \u0631\u0636\u0627\u06CC\u062A \u062E\u0648\u062F \u0622\u0646\u200C\u0647\u0627 \u0645\u0646\u062A\u0634\u0631 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0647\u06CC\u0686 \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u067E\u0632\u0634\u06A9\u06CC \u0634\u062E\u0635\u06CC \u062F\u0631 \u0635\u0641\u062D\u0647 \u0646\u06CC\u0633\u062A.","rule4":"\u0645\u0633\u0626\u0648\u0644\u06CC\u062A \u0645\u062D\u062A\u0648\u0627\u06CC \u0635\u0641\u062D\u0647 \u0628\u0627 \u0634\u0645\u0627\u0633\u062A \u0648 {{brand}} \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0635\u0641\u062D\u0647\u0654 \u0646\u0627\u0633\u0627\u0632\u06AF\u0627\u0631 \u0628\u0627 \u0627\u06CC\u0646 \u0636\u0648\u0627\u0628\u0637 \u0631\u0627 \u0645\u0639\u0644\u0642 \u06A9\u0646\u062F.","public":"\u0635\u0641\u062D\u0647 \u0639\u0645\u0648\u0645\u06CC \u0627\u0633\u062A: \u0647\u0631 \u06A9\u0633\u06CC \u0628\u0627 \u0646\u0634\u0627\u0646\u06CC \u0622\u0646\u060C \u0648 \u0645\u0648\u062A\u0648\u0631\u0647\u0627\u06CC \u062C\u0633\u062A\u200C\u0648\u062C\u0648\u060C \u0622\u0646 \u0631\u0627 \u0645\u06CC\u200C\u0628\u06CC\u0646\u0646\u062F.","accept":"\u0627\u06CC\u0646 \u0645\u0648\u0627\u0631\u062F \u0631\u0627 \u062E\u0648\u0627\u0646\u062F\u0645 \u0648 \u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u0645","confirm":"\u0645\u0646\u062A\u0634\u0631 \u06A9\u0646","cancel":"\u0627\u0646\u0635\u0631\u0627\u0641","failedTitle":"\u0627\u0646\u062A\u0634\u0627\u0631 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u061B \u0627\u06CC\u0646 \u0645\u0648\u0627\u0631\u062F \u0631\u0627 \u0627\u0635\u0644\u0627\u062D \u06A9\u0646\u06CC\u062F","done":"\u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0645\u0646\u062A\u0634\u0631 \u0634\u062F"},"template":{"title":"\u0642\u0627\u0644\u0628"},"templates":{"classic":{"name":"\u06A9\u0644\u0627\u0633\u06CC\u06A9","description":"\u0686\u0627\u067E\u06CC \u0648 \u0645\u062A\u06CC\u0646: \u0639\u06A9\u0633 \u0642\u0627\u0628\u200C\u0634\u062F\u0647\u060C \u062A\u06CC\u062A\u0631 \u0628\u0632\u0631\u06AF \u0628\u0627 \u062E\u0637\u200C\u06A9\u0634\u06CC \u0631\u0646\u06AF\u06CC\u060C \u062A\u0635\u0648\u06CC\u0631 \u067E\u0633\u200C\u0632\u0645\u06CC\u0646\u0647 \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u0646\u0648\u0627\u0631 \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647 \u0648 \u0646\u0648\u0627\u0631 \u0646\u06A9\u0627\u062A \u0628\u0631\u062C\u0633\u062A\u0647."},"modern":{"name":"\u0645\u062F\u0631\u0646","description":"\u0634\u0628\u06CC\u0647 \u0635\u0641\u062D\u0647\u0654 \u0627\u0648\u0644 \u0633\u0627\u06CC\u062A \u06CC\u06A9 \u06A9\u0644\u06CC\u0646\u06CC\u06A9: \u062A\u06CC\u062A\u0631 \u0628\u0632\u0631\u06AF\u060C \u062A\u0635\u0648\u06CC\u0631 \u067E\u0633\u200C\u0632\u0645\u06CC\u0646\u0647\u060C \u06A9\u0627\u0631\u062A\u200C\u0647\u0627\u06CC \u06A9\u0646\u0627\u0631 \u0639\u06A9\u0633 \u0648 \u0646\u0648\u0627\u0631 \u0646\u06A9\u0627\u062A \u0628\u0631\u062C\u0633\u062A\u0647."},"minimal":{"name":"\u0645\u06CC\u0646\u06CC\u0645\u0627\u0644","description":"\u062A\u0627\u06CC\u067E\u0648\u06AF\u0631\u0627\u0641\u06CC\u06A9 \u0648 \u062E\u0644\u0648\u062A\u060C \u0628\u062F\u0648\u0646 \u06A9\u0627\u0648\u0631\u061B \u062A\u0645\u0631\u06A9\u0632 \u0628\u0631 \u0645\u062A\u0646\u060C \u062E\u062F\u0645\u0627\u062A \u0648 \u0645\u0642\u0627\u0644\u0627\u062A."}},"palettes":{"azure":"\u0644\u0627\u062C\u0648\u0631\u062F\u06CC","teal":"\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC","deep":"\u0633\u0631\u0645\u0647\u200C\u0627\u06CC","brand":"\u0628\u0631\u0646\u062F {{brand}}","cyan":"\u0622\u0628\u06CC \u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC","ink":"\u062C\u0648\u0647\u0631\u06CC"},"theme":{"title":"\u0631\u0646\u06AF \u0648 \u062A\u0631\u0627\u06A9\u0645","palette":"\u0631\u0646\u06AF\u200C\u0628\u0646\u062F\u06CC","density":"\u062A\u0631\u0627\u06A9\u0645","densities":{"comfortable":"\u0631\u0627\u062D\u062A","compact":"\u0641\u0634\u0631\u062F\u0647"},"onlyTemplate":"\u0641\u0642\u0637 \u0631\u0646\u06AF\u200C\u0647\u0627 \u0648 \u062A\u0631\u0627\u06A9\u0645\u200C\u0647\u0627\u06CC\u06CC \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u06A9\u0647 \u0642\u0627\u0644\u0628 \u0641\u0639\u0644\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0645\u06CC\u200C\u06A9\u0646\u062F."},"slug":{"label":"\u0646\u0634\u0627\u0646\u06CC \u0635\u0641\u062D\u0647","hint":"\u062D\u0631\u0648\u0641 \u06A9\u0648\u0686\u06A9 \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC\u060C \u0639\u062F\u062F \u0648 \u062E\u0637 \u062A\u06CC\u0631\u0647\u061B \u06F3 \u062A\u0627 \u06F4\u06F0 \u0646\u0648\u06CC\u0633\u0647. \u067E\u06CC\u0634\u200C\u0641\u0631\u0636\u060C \u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0634\u0645\u0627\u0633\u062A.","lockedHint":"\u0646\u0634\u0627\u0646\u06CC \u067E\u0633 \u0627\u0632 \u0646\u062E\u0633\u062A\u06CC\u0646 \u0627\u0646\u062A\u0634\u0627\u0631 \u062B\u0627\u0628\u062A \u0634\u062F\u0647 \u0648 \u062F\u06CC\u06AF\u0631 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F.","required":"\u0646\u0634\u0627\u0646\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","invalid":"\u0641\u0642\u0637 \u062D\u0631\u0648\u0641 \u06A9\u0648\u0686\u06A9 \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC\u060C \u0639\u062F\u062F \u0648 \u062E\u0637 \u062A\u06CC\u0631\u0647\u060C \u06F3 \u062A\u0627 \u06F4\u06F0 \u0646\u0648\u06CC\u0633\u0647\u061B \u0628\u0627 \u062D\u0631\u0641 \u06CC\u0627 \u0639\u062F\u062F \u0634\u0631\u0648\u0639 \u0648 \u062A\u0645\u0627\u0645 \u0634\u0648\u062F \u0648 \u062F\u0648 \u062E\u0637 \u062A\u06CC\u0631\u0647\u0654 \u067E\u0634\u062A\u200C\u0633\u0631\u0647\u0645 \u0646\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F.","checking":"\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026","available":"\u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u06CC \u0622\u0632\u0627\u062F \u0627\u0633\u062A.","taken":"\u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.","save":"\u0630\u062E\u06CC\u0631\u0647\u0654 \u0646\u0634\u0627\u0646\u06CC"},"sections":{"title":"\u0628\u062E\u0634\u200C\u0647\u0627","reorderHint":"\u0628\u0627 \u062F\u06A9\u0645\u0647\u200C\u0647\u0627\u06CC \u0628\u0627\u0644\u0627 \u0648 \u067E\u0627\u06CC\u06CC\u0646 (\u06CC\u0627 Alt \u0648 \u06A9\u0644\u06CC\u062F\u0647\u0627\u06CC \u062C\u0647\u062A) \u062A\u0631\u062A\u06CC\u0628 \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F.","kinds":{"hero":"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u062D\u0631\u0641\u0647\u200C\u0627\u06CC","services":"\u062E\u062F\u0645\u0627\u062A","articles":"\u0645\u0642\u0627\u0644\u0627\u062A \u0648 \u0645\u0637\u0627\u0644\u0628 \u0639\u0644\u0645\u06CC","testimonials":"\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u062A\u062E\u0628 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646","gallery":"\u06AF\u0627\u0644\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631","video":"\u0648\u06CC\u062F\u06CC\u0648","office":"\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0645\u0637\u0628"},"show":"\u0646\u0645\u0627\u06CC\u0634 \xab{{name}}\xbb \u062F\u0631 \u0635\u0641\u062D\u0647","shown":"\u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F","hidden":"\u067E\u0646\u0647\u0627\u0646","hiddenNotice":"\u0627\u06CC\u0646 \u0628\u062E\u0634 \u067E\u0646\u0647\u0627\u0646 \u0627\u0633\u062A \u0648 \u062F\u0631 \u0635\u0641\u062D\u0647\u0654 \u0639\u0645\u0648\u0645\u06CC \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.","showOnPage":"\u0646\u0645\u0627\u06CC\u0634 \u062F\u0631 \u0635\u0641\u062D\u0647","toggleFailed":"\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0645\u0627\u06CC\u0634 \xab{{name}}\xbb \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F:","required":"\u0627\u06CC\u0646 \u0628\u062E\u0634 \u0647\u0645\u06CC\u0634\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F","moveUp":"\u0627\u0646\u062A\u0642\u0627\u0644 \xab{{name}}\xbb \u0628\u0647 \u0628\u0627\u0644\u0627","moveDown":"\u0627\u0646\u062A\u0642\u0627\u0644 \xab{{name}}\xbb \u0628\u0647 \u067E\u0627\u06CC\u06CC\u0646","unsupported":"\u062F\u0631 \u0627\u06CC\u0646 \u0642\u0627\u0644\u0628 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F","unsupportedLong":"\u0642\u0627\u0644\u0628 \u0641\u0639\u0644\u06CC \u0627\u06CC\u0646 \u0628\u062E\u0634 \u0631\u0627 \u0646\u0645\u0627\u06CC\u0634 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F. \u0645\u062D\u062A\u0648\u0627\u06CC \u0622\u0646 \u062D\u0641\u0638 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0628\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u0642\u0627\u0644\u0628 \u062F\u0648\u0628\u0627\u0631\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","hasErrors":"\u0627\u06CC\u0646 \u0628\u062E\u0634 \u0645\u0627\u0646\u0639 \u0627\u0646\u062A\u0634\u0627\u0631 \u0627\u0633\u062A","titleOverride":"\u0639\u0646\u0648\u0627\u0646 \u0628\u062E\u0634 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","titleOverrideHint":"\u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u0639\u0646\u0648\u0627\u0646 \u067E\u06CC\u0634\u200C\u0641\u0631\u0636 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0634\u0648\u062F.","reorderFailed":"\u062A\u0631\u062A\u06CC\u0628 \u0628\u062E\u0634\u200C\u0647\u0627 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F."},"items":{"count":"{{count}} \u0627\u0632 {{max}}","moveUp":"\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u0628\u0627\u0644\u0627","moveDown":"\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u067E\u0627\u06CC\u06CC\u0646","remove":"\u062D\u0630\u0641"},"image":{"pick":"\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0635\u0648\u06CC\u0631","replace":"\u062A\u063A\u06CC\u06CC\u0631 \u062A\u0635\u0648\u06CC\u0631","remove":"\u062D\u0630\u0641 \u062A\u0635\u0648\u06CC\u0631","removeTitle":"\u062D\u0630\u0641 \u062A\u0635\u0648\u06CC\u0631\u061F","removeBody":"\u062A\u0635\u0648\u06CC\u0631 \u0627\u0632 \u0635\u0641\u062D\u0647 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F. \u067E\u0633 \u0627\u0632 \u0627\u0646\u062A\u0634\u0627\u0631 \u062F\u0648\u0628\u0627\u0631\u0647\u060C \u0627\u0632 \u0635\u0641\u062D\u0647\u0654 \u0639\u0645\u0648\u0645\u06CC \u0647\u0645 \u0628\u0631\u062F\u0627\u0634\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","removeConfirm":"\u062D\u0630\u0641 \u06A9\u0646","cropTitle":"\u0628\u0631\u0634 \u062A\u0635\u0648\u06CC\u0631","typeUnsupported":"\u0641\u0642\u0637 \u062A\u0635\u0648\u06CC\u0631 JPEG \u06CC\u0627 PNG \u067E\u0630\u06CC\u0631\u0641\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","tooLarge":"\u062D\u062C\u0645 \u062A\u0635\u0648\u06CC\u0631 \u0628\u06CC\u0634 \u0627\u0632 \u06F5 \u0645\u06AF\u0627\u0628\u0627\u06CC\u062A \u0627\u0633\u062A.","readFailed":"\u062E\u0648\u0627\u0646\u062F\u0646 \u0641\u0627\u06CC\u0644 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F."},"hero":{"displayName":"\u0646\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634\u06CC","displayNameRequired":"\u0646\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634\u06CC \u0644\u0627\u0632\u0645 \u0627\u0633\u062A.","headline":"\u0639\u0646\u0648\u0627\u0646 \u06A9\u0648\u062A\u0627\u0647","headlinePlaceholder":"\u0645\u062B\u0644\u0627\u064B \u0645\u062A\u062E\u0635\u0635 \u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642\u060C \u0639\u0636\u0648 \u0647\u06CC\u0626\u062A \u0639\u0644\u0645\u06CC","headlineHint":"\u062F\u0631 \u0642\u0627\u0644\u0628\u200C\u0647\u0627\u06CC \xab\u0645\u062F\u0631\u0646\xbb \u0648 \xab\u06A9\u0644\u0627\u0633\u06CC\u06A9\xbb \u0628\u0627 \u062D\u0631\u0648\u0641 \u0628\u0632\u0631\u06AF \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647 \u0645\u06CC\u200C\u0622\u06CC\u062F\u061B \u0627\u06AF\u0631 \xab\u060C\xbb \u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F\u060C \u0628\u062E\u0634 \u0628\u0639\u062F \u0627\u0632 \u0622\u0646 \u0631\u0646\u06AF\u06CC \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","about":"\u062F\u0631\u0628\u0627\u0631\u0647 \u0645\u0646","portrait":"\u062A\u0635\u0648\u06CC\u0631 \u067E\u0631\u062A\u0631\u0647","portraitHint":"\u0646\u0633\u062E\u0647\u200C\u0627\u06CC \u062C\u062F\u0627\u06AF\u0627\u0646\u0647 \u0627\u0632 \u062A\u0635\u0648\u06CC\u0631 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0634\u0645\u0627\u061B \u062A\u063A\u06CC\u06CC\u0631 \u0622\u0646 \u0631\u0648\u06CC \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0627\u062B\u0631\u06CC \u0646\u062F\u0627\u0631\u062F.","cover":"\u062A\u0635\u0648\u06CC\u0631 \u067E\u0633\u200C\u0632\u0645\u06CC\u0646\u0647","coverHint":"\u062A\u0635\u0648\u06CC\u0631 \u0639\u0631\u06CC\u0636 (\u0646\u0633\u0628\u062A \u062D\u062F\u0648\u062F \u06F3 \u0628\u0647 \u06F1). \u062F\u0631 \u0642\u0627\u0644\u0628 \xab\u0645\u062F\u0631\u0646\xbb \u06A9\u0645\u200C\u0631\u0646\u06AF \u0648 \u0645\u062D\u0648 \u067E\u0634\u062A \u0628\u062E\u0634 \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647 \u0645\u06CC\u200C\u0622\u06CC\u062F \u0648 \u062F\u0631 \u0642\u0627\u0644\u0628 \xab\u06A9\u0644\u0627\u0633\u06CC\u06A9\xbb \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u0646\u0648\u0627\u0631\u06CC \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647.","coverUnused":"\u0642\u0627\u0644\u0628 \u0641\u0639\u0644\u06CC \u062A\u0635\u0648\u06CC\u0631 \u067E\u0633\u200C\u0632\u0645\u06CC\u0646\u0647 \u0631\u0627 \u0646\u0645\u0627\u06CC\u0634 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F\u061B \u0628\u0631\u0627\u06CC \u062F\u06CC\u062F\u0646 \u0622\u0646 \u0642\u0627\u0644\u0628 \xab\u0645\u062F\u0631\u0646\xbb \u06CC\u0627 \xab\u06A9\u0644\u0627\u0633\u06CC\u06A9\xbb \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","extras":{"onlyModern":"\u0627\u06CC\u0646 \u062F\u0648 \u0641\u0647\u0631\u0633\u062A \u062F\u0631 \u0642\u0627\u0644\u0628\u200C\u0647\u0627\u06CC \xab\u0645\u062F\u0631\u0646\xbb \u0648 \xab\u06A9\u0644\u0627\u0633\u06CC\u06A9\xbb \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u0627\u06AF\u0631 \u062E\u0627\u0644\u06CC \u0628\u0645\u0627\u0646\u0646\u062F\u060C \u062E\u062F\u0645\u0627\u062A \u0627\u0648\u0644 \u0634\u0645\u0627 \u0648 \u0634\u0645\u0627\u0631\u0647\u0654 \u0646\u0638\u0627\u0645\u060C \u0634\u0647\u0631 \u0648 \u0633\u0627\u0639\u0627\u062A \u06A9\u0627\u0631\u06CC \u062C\u0627\u06CC \u0622\u0646\u200C\u0647\u0627 \u0645\u06CC\u200C\u0622\u06CC\u062F.","notShown":"\u0642\u0627\u0644\u0628 \u0641\u0639\u0644\u06CC \u0627\u06CC\u0646 \u062F\u0648 \u0641\u0647\u0631\u0633\u062A \u0631\u0627 \u0646\u0645\u0627\u06CC\u0634 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F\u061B \u0628\u0631\u0627\u06CC \u062F\u06CC\u062F\u0646 \u0622\u0646\u200C\u0647\u0627 \u0642\u0627\u0644\u0628 \xab\u0645\u062F\u0631\u0646\xbb \u06CC\u0627 \xab\u06A9\u0644\u0627\u0633\u06CC\u06A9\xbb \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","cardsTitle":"\u06A9\u0627\u0631\u062A\u200C\u0647\u0627\u06CC \u0645\u0639\u0631\u0641\u06CC","cardsHint":"\u062D\u062F\u0627\u06A9\u062B\u0631 \u062F\u0648 \u06A9\u0627\u0631\u062A \u06A9\u0648\u062A\u0627\u0647 \u062F\u0631 \u0628\u062E\u0634 \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647\u061B \u0645\u062B\u0644\u0627\u064B \xab\u0648\u06CC\u0632\u06CC\u062A \u062D\u0636\u0648\u0631\u06CC \u0648 \u0622\u0646\u0644\u0627\u06CC\u0646\xbb.","addCard":"\u0627\u0641\u0632\u0648\u062F\u0646 \u06A9\u0627\u0631\u062A","highlightsTitle":"\u0646\u06A9\u0627\u062A \u0628\u0631\u062C\u0633\u062A\u0647","highlightsHint":"\u062D\u062F\u0627\u06A9\u062B\u0631 \u0633\u0647 \u0645\u0648\u0631\u062F \u062F\u0631 \u0646\u0648\u0627\u0631 \u0632\u06CC\u0631 \u0628\u062E\u0634 \u0628\u0627\u0644\u0627\u06CC \u0635\u0641\u062D\u0647\u061B \u0645\u062B\u0644\u0627\u064B \xab\u06F1\u06F5 \u0633\u0627\u0644 \u062A\u062C\u0631\u0628\u0647\xbb.","addHighlight":"\u0627\u0641\u0632\u0648\u062F\u0646 \u0646\u06A9\u062A\u0647","itemTitle":"\u0639\u0646\u0648\u0627\u0646","itemText":"\u062A\u0648\u0636\u06CC\u062D \u06A9\u0648\u062A\u0627\u0647 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","titleRequired":"\u0639\u0646\u0648\u0627\u0646 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A."}},"services":{"itemTitle":"\u0639\u0646\u0648\u0627\u0646 \u062E\u062F\u0645\u062A","itemDescription":"\u062A\u0648\u0636\u06CC\u062D","image":"\u062A\u0635\u0648\u06CC\u0631 \u062E\u062F\u0645\u062A","imageHint":"\u0646\u0633\u0628\u062A \u06F4 \u0628\u0647 \u06F3\u061B \u0639\u0646\u0648\u0627\u0646 \u062E\u062F\u0645\u062A \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u0645\u062A\u0646 \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \u062A\u0635\u0648\u06CC\u0631 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","imageAfterSave":"\u067E\u0633 \u0627\u0632 \u0630\u062E\u06CC\u0631\u0647\u0654 \u0627\u06CC\u0646 \u062E\u062F\u0645\u062A \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u062A\u0635\u0648\u06CC\u0631 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F.","add":"\u0627\u0641\u0632\u0648\u062F\u0646 \u062E\u062F\u0645\u062A"},"testimonials":{"framingTitle":"\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u062A\u062E\u0628\u060C \u0646\u0647 \u0627\u0645\u062A\u06CC\u0627\u0632\u062F\u0647\u06CC","framing":"\u0627\u06CC\u0646 \u0628\u062E\u0634 \u0646\u0642\u0644\u200C\u0642\u0648\u0644\u200C\u0647\u0627\u06CC\u06CC \u0627\u0633\u062A \u06A9\u0647 \u062E\u0648\u062F\u062A\u0627\u0646 \u0627\u0646\u062A\u062E\u0627\u0628 \u0648 \u0648\u0627\u0631\u062F \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F \u0648 \u0628\u0627 \u0639\u0646\u0648\u0627\u0646 \xab\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u062A\u062E\u0628 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646\xbb \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F. \u0627\u0645\u062A\u06CC\u0627\u0632\u060C \u0633\u062A\u0627\u0631\u0647 \u06CC\u0627 \u0634\u0645\u0627\u0631\u0634 \u0646\u0638\u0631 \u062F\u0631 \u0635\u0641\u062D\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.","text":"\u0645\u062A\u0646 \u0646\u0638\u0631","attribution":"\u0646\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634\u06CC \u0628\u06CC\u0645\u0627\u0631","attributionPlaceholder":"\u0645\u062B\u0644\u0627\u064B \xab\u0645. \u0631\u0636\u0627\u06CC\u06CC\xbb \u06CC\u0627 \xab\u0628\u06CC\u0645\u0627\u0631 \u06F4\u06F5 \u0633\u0627\u0644\u0647\xbb","consent":"\u0628\u06CC\u0645\u0627\u0631 \u0628\u0627 \u0627\u0646\u062A\u0634\u0627\u0631 \u0627\u06CC\u0646 \u0646\u0638\u0631 \u062F\u0631 \u0635\u0641\u062D\u0647\u0654 \u0639\u0645\u0648\u0645\u06CC \u0645\u0648\u0627\u0641\u0642\u062A \u06A9\u0631\u062F\u0647 \u0627\u0633\u062A","consentRequired":"\u0628\u062F\u0648\u0646 \u062A\u0623\u06CC\u06CC\u062F \u0631\u0636\u0627\u06CC\u062A \u0628\u06CC\u0645\u0627\u0631\u060C \u0627\u06CC\u0646 \u0646\u0638\u0631 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.","add":"\u0627\u0641\u0632\u0648\u062F\u0646 \u0646\u0638\u0631"},"video":{"intro":"\u0646\u0634\u0627\u0646\u06CC \u0648\u06CC\u062F\u06CC\u0648 \u0631\u0627 \u0627\u0632 \u0622\u067E\u0627\u0631\u0627\u062A \u06CC\u0627 \u06CC\u0648\u062A\u06CC\u0648\u0628 \u0628\u0686\u0633\u0628\u0627\u0646\u06CC\u062F\u061B \u0641\u0642\u0637 \u0634\u0646\u0627\u0633\u0647\u0654 \u0648\u06CC\u062F\u06CC\u0648 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","url":"\u0646\u0634\u0627\u0646\u06CC \u0648\u06CC\u062F\u06CC\u0648","caption":"\u062A\u0648\u0636\u06CC\u062D \u06A9\u0648\u062A\u0627\u0647","add":"\u0627\u0641\u0632\u0648\u062F\u0646 \u0648\u06CC\u062F\u06CC\u0648","pending":"\u067E\u0633 \u0627\u0632 \u0630\u062E\u06CC\u0631\u0647 \u0628\u0631\u0631\u0633\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F","aparat":"\u0622\u067E\u0627\u0631\u0627\u062A","youtube":"\u06CC\u0648\u062A\u06CC\u0648\u0628"},"gallery":{"alt":"\u0645\u062A\u0646 \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646","altRequired":"\u0645\u062A\u0646 \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A.","saveAlt":"\u0630\u062E\u06CC\u0631\u0647\u0654 \u0645\u062A\u0646","newAlt":"\u062A\u0648\u0636\u06CC\u062D \u062A\u0635\u0648\u06CC\u0631 \u062C\u062F\u06CC\u062F","newAltPlaceholder":"\u0645\u062B\u0644\u0627\u064B \xab\u0627\u062A\u0627\u0642 \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0637\u0628\xbb","altFirst":"\u0627\u0628\u062A\u062F\u0627 \u062A\u0648\u0636\u06CC\u062D \u062A\u0635\u0648\u06CC\u0631 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F.","emptyTitle":"\u0647\u0646\u0648\u0632 \u062A\u0635\u0648\u06CC\u0631\u06CC \u062F\u0631 \u06AF\u0627\u0644\u0631\u06CC \u0646\u06CC\u0633\u062A","emptyHint":"\u062A\u0627 \u06F1\u06F2 \u062A\u0635\u0648\u06CC\u0631 \u0627\u0632 \u0645\u0637\u0628 \u0648 \u062A\u062C\u0647\u06CC\u0632\u0627\u062A \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F."},"articles":{"new":"\u0645\u0642\u0627\u0644\u0647\u0654 \u062C\u062F\u06CC\u062F","back":"\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0641\u0647\u0631\u0633\u062A \u0645\u0642\u0627\u0644\u0627\u062A","title":"\u0639\u0646\u0648\u0627\u0646 \u0645\u0642\u0627\u0644\u0647","slug":"\u0646\u0634\u0627\u0646\u06CC \u0645\u0642\u0627\u0644\u0647 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","slugHint":"\u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u0627\u0632 \u0639\u0646\u0648\u0627\u0646 \u0633\u0627\u062E\u062A\u0647 \u0634\u0648\u062F. \u067E\u0633 \u0627\u0632 \u0646\u062E\u0633\u062A\u06CC\u0646 \u0627\u0646\u062A\u0634\u0627\u0631 \u062B\u0627\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.","slugLocked":"\u0646\u0634\u0627\u0646\u06CC \u0645\u0642\u0627\u0644\u0647:","body":"\u0645\u062A\u0646 \u0645\u0642\u0627\u0644\u0647","cover":"\u062A\u0635\u0648\u06CC\u0631 \u0645\u0642\u0627\u0644\u0647","publish":"\u0627\u0646\u062A\u0634\u0627\u0631 \u0645\u0642\u0627\u0644\u0647","unpublish":"\u0628\u0627\u0632\u06AF\u0631\u062F\u0627\u0646\u062F\u0646 \u0628\u0647 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633","republish":"\u0627\u0646\u062A\u0634\u0627\u0631 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u0645\u0642\u0627\u0644\u0647","delete":"\u062D\u0630\u0641 \u0645\u0642\u0627\u0644\u0647","deleteTitle":"\u062D\u0630\u0641 \u0645\u0642\u0627\u0644\u0647\u061F","deleteBody":"\u0645\u0642\u0627\u0644\u0647\u0654 \xab{{title}}\xbb \u0628\u0631\u0627\u06CC \u0647\u0645\u06CC\u0634\u0647 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F.","deleteConfirm":"\u062D\u0630\u0641 \u06A9\u0646","saveFirst":"\u0628\u0631\u0627\u06CC \u0627\u0646\u062A\u0634\u0627\u0631\u060C \u0627\u0628\u062A\u062F\u0627 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u0631\u0627 \u0630\u062E\u06CC\u0631\u0647 \u06A9\u0646\u06CC\u062F.","saveToContinue":"\u067E\u0633 \u0627\u0632 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u062A\u0635\u0648\u06CC\u0631 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F \u0648 \u0645\u0642\u0627\u0644\u0647 \u0631\u0627 \u0645\u0646\u062A\u0634\u0631 \u06A9\u0646\u06CC\u062F.","untitled":"\u0628\u062F\u0648\u0646 \u0639\u0646\u0648\u0627\u0646","publishedOn":"\u0645\u0646\u062A\u0634\u0631\u0634\u062F\u0647 \u062F\u0631 {{date}}","neverPublished":"\u0647\u0646\u0648\u0632 \u0645\u0646\u062A\u0634\u0631 \u0646\u0634\u062F\u0647","statusPublished":"\u0645\u0646\u062A\u0634\u0631\u0634\u062F\u0647","statusDraft":"\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633","changed":"\u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u0645\u0646\u062A\u0634\u0631\u0646\u0634\u062F\u0647","emptyTitle":"\u0647\u0646\u0648\u0632 \u0645\u0642\u0627\u0644\u0647\u200C\u0627\u06CC \u0646\u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F","emptyHint":"\u0645\u0637\u0627\u0644\u0628 \u0622\u0645\u0648\u0632\u0634\u06CC \u0628\u0631\u0627\u06CC \u0628\u06CC\u0645\u0627\u0631\u0627\u0646\u060C \u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0631\u0627 \u062F\u0631 \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u062F\u06CC\u062F\u0647\u200C\u062A\u0631 \u0645\u06CC\u200C\u06A9\u0646\u062F."},"office":{"intro":"\u0627\u0637\u0644\u0627\u0639\u0627\u062A\u06CC \u06A9\u0647 \u0627\u06CC\u0646\u062C\u0627 \u0648\u0627\u0631\u062F \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F \u0639\u06CC\u0646\u0627\u064B \u062F\u0631 \u0635\u0641\u062D\u0647\u0654 \u0639\u0645\u0648\u0645\u06CC \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","phones":"\u062A\u0644\u0641\u0646\u200C\u0647\u0627","phoneLabel":"\u0639\u0646\u0648\u0627\u0646","phoneLabelPlaceholder":"\u0645\u062B\u0644\u0627\u064B \u0645\u0646\u0634\u06CC","phoneNumber":"\u0634\u0645\u0627\u0631\u0647","addPhone":"\u0627\u0641\u0632\u0648\u062F\u0646 \u062A\u0644\u0641\u0646","city":"\u0634\u0647\u0631","address":"\u0646\u0634\u0627\u0646\u06CC \u0645\u0637\u0628","hours":"\u0633\u0627\u0639\u0627\u062A \u06A9\u0627\u0631\u06CC","hoursLabel":"\u0631\u0648\u0632","hoursLabelPlaceholder":"\u0645\u062B\u0644\u0627\u064B \u0634\u0646\u0628\u0647 \u062A\u0627 \u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647","hoursValue":"\u0633\u0627\u0639\u062A","hoursValuePlaceholder":"\u0645\u062B\u0644\u0627\u064B \u06F1\u06F6 \u062A\u0627 \u06F2\u06F0","addHours":"\u0627\u0641\u0632\u0648\u062F\u0646 \u0633\u0627\u0639\u062A \u06A9\u0627\u0631\u06CC","geo":"\u0645\u0648\u0642\u0639\u06CC\u062A \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","geoHint":"\u0645\u0637\u0628 \u0631\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0645\u0634\u062E\u0635 \u06A9\u0646\u06CC\u062F \u062A\u0627 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0627\u0632 \u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0628\u0627 \u0646\u0634\u0627\u0646\u060C \u0628\u0644\u062F \u06CC\u0627 \u06AF\u0648\u06AF\u0644\u200C\u0645\u067E \u0645\u0633\u06CC\u0631\u06CC\u0627\u0628\u06CC \u06A9\u0646\u0646\u062F.","map":{"pick":"\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647","change":"\u062A\u063A\u06CC\u06CC\u0631 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647","close":"\u0628\u0633\u062A\u0646 \u0646\u0642\u0634\u0647","myLocation":"\u0645\u0648\u0642\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC \u0645\u0646","clear":"\u062D\u0630\u0641 \u0645\u0648\u0642\u0639\u06CC\u062A","isSet":"\u0645\u0648\u0642\u0639\u06CC\u062A \u0645\u0637\u0628 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0645\u0634\u062E\u0635 \u0634\u062F\u0647 \u0627\u0633\u062A.","label":"\u0646\u0642\u0634\u0647\u0654 \u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u0648\u0642\u0639\u06CC\u062A \u0645\u0637\u0628","hint":"\u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0628\u0632\u0646\u06CC\u062F \u06CC\u0627 \u067E\u06CC\u0646 \u0631\u0627 \u0628\u06A9\u0634\u06CC\u062F \u062A\u0627 \u062F\u0642\u06CC\u0642\u0627\u064B \u0631\u0648\u06CC \u0645\u0637\u0628 \u0642\u0631\u0627\u0631 \u0628\u06AF\u06CC\u0631\u062F\u061B \u0633\u067E\u0633 \xab\u0630\u062E\u06CC\u0631\u0647\xbb \u0631\u0627 \u0628\u0632\u0646\u06CC\u062F.","found":"\u067E\u06CC\u0646 \u0631\u0648\u06CC \u0645\u0648\u0642\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC \u0634\u0645\u0627 \u0642\u0631\u0627\u0631 \u06AF\u0631\u0641\u062A. \u0627\u06AF\u0631 \u0627\u0644\u0627\u0646 \u062F\u0631 \u0645\u0637\u0628 \u0646\u06CC\u0633\u062A\u06CC\u062F\u060C \u0622\u0646 \u0631\u0627 \u0631\u0648\u06CC \u0645\u0637\u0628 \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F.","locating":"\u062F\u0631 \u062D\u0627\u0644 \u06CC\u0627\u0641\u062A\u0646 \u0645\u0648\u0642\u0639\u06CC\u062A \u0634\u0645\u0627\u2026","loading":"\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0642\u0634\u0647\u2026","failed":"\u0646\u0642\u0634\u0647 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F. \u0627\u06AF\u0631 \u062F\u0631 \u0645\u0637\u0628 \u0647\u0633\u062A\u06CC\u062F\u060C \xab\u0645\u0648\u0642\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC \u0645\u0646\xbb \u0631\u0627 \u0628\u0632\u0646\u06CC\u062F.","denied":"\u0627\u062C\u0627\u0632\u0647\u0654 \u062F\u0633\u062A\u0631\u0633\u06CC \u0628\u0647 \u0645\u0648\u0642\u0639\u06CC\u062A \u062F\u0627\u062F\u0647 \u0646\u0634\u062F\u061B \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0628\u0632\u0646\u06CC\u062F \u062A\u0627 \u0645\u0637\u0628 \u0631\u0627 \u0645\u0634\u062E\u0635 \u06A9\u0646\u06CC\u062F.","unavailable":"\u0645\u0648\u0642\u0639\u06CC\u062A \u0634\u0645\u0627 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F\u061B \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0628\u0632\u0646\u06CC\u062F \u062A\u0627 \u0645\u0637\u0628 \u0631\u0627 \u0645\u0634\u062E\u0635 \u06A9\u0646\u06CC\u062F.","timeout":"\u06CC\u0627\u0641\u062A\u0646 \u0645\u0648\u0642\u0639\u06CC\u062A \u0637\u0648\u0644 \u06A9\u0634\u06CC\u062F\u061B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0628\u0632\u0646\u06CC\u062F.","unsupported":"\u0627\u06CC\u0646 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0645\u0648\u0642\u0639\u06CC\u062A\u200C\u06CC\u0627\u0628\u06CC \u0646\u062F\u0627\u0631\u062F\u061B \u0631\u0648\u06CC \u0646\u0642\u0634\u0647 \u0628\u0632\u0646\u06CC\u062F \u062A\u0627 \u0645\u0637\u0628 \u0631\u0627 \u0645\u0634\u062E\u0635 \u06A9\u0646\u06CC\u062F."},"socials":"\u0634\u0628\u06A9\u0647\u200C\u0647\u0627\u06CC \u0627\u062C\u062A\u0645\u0627\u0639\u06CC","socialsHint":"\u0634\u0646\u0627\u0633\u0647 \u06CC\u0627 \u0646\u0634\u0627\u0646\u06CC \u0635\u0641\u062D\u0647 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F (\u0645\u062B\u0644\u0627\u064B @dr.example \u06CC\u0627 instagram.com/dr.example). \u0648\u0627\u062A\u0633\u200C\u0627\u067E: \u0634\u0645\u0627\u0631\u0647\u0654 \u06A9\u0627\u0645\u0644 \u0628\u0627 \u06A9\u062F \u06A9\u0634\u0648\u0631. \u0648\u0628\u200C\u0633\u0627\u06CC\u062A: \u0646\u0634\u0627\u0646\u06CC \u06A9\u0627\u0645\u0644.","social":{"instagram":"\u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645","telegram":"\u062A\u0644\u06AF\u0631\u0627\u0645","whatsapp":"\u0648\u0627\u062A\u0633\u200C\u0627\u067E","eitaa":"\u0627\u06CC\u062A\u0627","bale":"\u0628\u0644\u0647","website":"\u0648\u0628\u200C\u0633\u0627\u06CC\u062A"}},"leads":{"intro":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0628\u0627\u0632\u062F\u06CC\u062F\u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u0627\u0632 \u0635\u0641\u062D\u0647\u0654 \u0634\u0645\u0627 \u0641\u0631\u0633\u062A\u0627\u062F\u0647\u200C\u0627\u0646\u062F. \u067E\u06CC\u06AF\u06CC\u0631\u06CC \u0622\u0646\u200C\u0647\u0627 \u062A\u0648\u0633\u0637 \u062A\u06CC\u0645 {{brand}} \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.","name":"\u0646\u0627\u0645","mobile":"\u0645\u0648\u0628\u0627\u06CC\u0644","preference":"\u0631\u0648\u0634 \u0648 \u0632\u0645\u0627\u0646 \u062A\u0645\u0627\u0633","message":"\u067E\u06CC\u0627\u0645","createdAt":"\u0632\u0645\u0627\u0646 \u062B\u0628\u062A","status":"\u0648\u0636\u0639\u06CC\u062A","more":"\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631","loadFailed":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F","emptyTitle":"\u0647\u0646\u0648\u0632 \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u06CC \u0646\u0631\u0633\u06CC\u062F\u0647 \u0627\u0633\u062A","emptyHint":"\u0646\u0634\u0627\u0646\u06CC \u0635\u0641\u062D\u0647 \u0631\u0627 \u0628\u0627 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0647 \u0627\u0634\u062A\u0631\u0627\u06A9 \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u0627\u0632 \u0637\u0631\u06CC\u0642 \xab\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0646\u0648\u0628\u062A\xbb \u0628\u0627 \u0634\u0645\u0627 \u062F\u0631 \u062A\u0645\u0627\u0633 \u0628\u0627\u0634\u0646\u062F.","notPublishedTitle":"\u0635\u0641\u062D\u0647 \u0647\u0646\u0648\u0632 \u0645\u0646\u062A\u0634\u0631 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A","notPublishedHint":"\u067E\u0633 \u0627\u0632 \u0627\u0646\u062A\u0634\u0627\u0631\u060C \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC \u0628\u0627\u0632\u062F\u06CC\u062F\u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","channels":{"call":"\u062A\u0645\u0627\u0633 \u062A\u0644\u0641\u0646\u06CC","sms":"\u067E\u06CC\u0627\u0645\u06A9","whatsapp":"\u0648\u0627\u062A\u0633\u200C\u0627\u067E"},"times":{"morning":"\u0635\u0628\u062D","afternoon":"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631","evening":"\u0639\u0635\u0631","any":"\u0647\u0631 \u0632\u0645\u0627\u0646"},"statuses":{"new":"\u062C\u062F\u06CC\u062F","contacted":"\u062A\u0645\u0627\u0633 \u06AF\u0631\u0641\u062A\u0647 \u0634\u062F","qualified":"\u062F\u0631 \u062D\u0627\u0644 \u067E\u06CC\u06AF\u06CC\u0631\u06CC","proposal":"\u062F\u0631 \u062D\u0627\u0644 \u067E\u06CC\u06AF\u06CC\u0631\u06CC","negotiation":"\u062F\u0631 \u062D\u0627\u0644 \u067E\u06CC\u06AF\u06CC\u0631\u06CC","won":"\u0627\u0646\u062C\u0627\u0645 \u0634\u062F","lost":"\u0628\u0633\u062A\u0647 \u0634\u062F"}}}}');


var $a1ddcc144227a6c8$exports = {};
$a1ddcc144227a6c8$exports = JSON.parse('{"nav":{"items":{"myPage":"My page"}},"myPage":{"subtitle":"Your public page on {{brand}}: pick a template, arrange the sections and publish.","loading":"Preparing your page","loadFailed":"Your page could not be loaded","railLabel":"Page settings","markdownHint":"Simple formatting is supported: # heading, **bold**, lists with - and links as [text](https://\u2026). HTML is not accepted.","markdownHintShort":"**Bold**, lists with - and links are supported.","tabs":{"label":"My page sections","builder":"Edit page","leads":"Page requests"},"status":{"draft":"Draft","published":"Published","unpublished":"Unpublished","suspended":"Suspended","unknown":"Unknown"},"statusCard":{"title":"Page status","liveUrl":"Your page address","futureUrl":"Once published, the page will be available at this address","copy":"Copy address","copied":"Address copied","copyFailed":"The address could not be copied","lastPublished":"Last published: {{date}}","preview":"Preview","openPreview":"Open preview","popupBlocked":"The browser blocked the preview window; use the link below.","publish":"Publish","republish":"Publish changes","unpublish":"Unpublish","unpublishTitle":"Unpublish the page?","unpublishBody":"The page is taken off the internet and its address stops opening. All content is kept and you can publish again.","unpublishConfirm":"Unpublish","unpublished":"The page was unpublished","unpublishFailed":"Unpublishing failed. Try again.","blockersTitle":"To publish, complete the following:","addCouncil":"Add your medical council number in your profile"},"banner":{"suspendedTitle":"Your page has been suspended by {{brand}}","suspendedNoReason":"No reason was recorded.","suspendedSupport":"The page is read-only. Contact {{brand}} support to lift the suspension.","unpublishedChanges":"You have changes that are not published yet; visitors see the previous version."},"save":{"save":"Save","reset":"Reset","saving":"Saving\u2026","saved":"Saved","dirty":"Unsaved changes"},"publish":{"title":"Publish page","intro":"Once published, your page can be seen and searched by everyone on the internet. Before publishing, confirm the following:","rule1":"The content follows the Medical Council\'s advertising rules and makes no claim of guaranteed cure, guaranteed results or comparison with colleagues.","rule2":"The images and texts are yours, or you have permission to use them.","rule3":"Patient testimonials are published with the patients\' consent, and the page holds no personal medical information.","rule4":"You are responsible for the page\'s content, and {{brand}} may suspend a page that does not follow these rules.","public":"The page is public: anyone with its address, and search engines, can see it.","accept":"I have read and accept these terms","confirm":"Publish","cancel":"Cancel","failedTitle":"Publishing failed; fix the following","done":"Your page was published"},"template":{"title":"Template"},"templates":{"classic":{"name":"Classic","description":"Print-like and composed: a framed portrait, a large title with a marked second half, the background image as a band across the top, and a bar of highlights."},"modern":{"name":"Modern","description":"Like a clinic\'s landing page: a large title, a background image, cards beside your photo and a strip of highlights."},"minimal":{"name":"Minimal","description":"Typographic and airy, no cover; focused on text, services and articles."}},"palettes":{"azure":"Azure","teal":"Turquoise","deep":"Navy","brand":"{{brand}} brand","cyan":"Cyan","ink":"Ink"},"theme":{"title":"Colour and density","palette":"Palette","density":"Density","densities":{"comfortable":"Comfortable","compact":"Compact"},"onlyTemplate":"Only the palettes and densities the current template supports are shown."},"slug":{"label":"Page address","hint":"Lower-case English letters, digits and hyphens; 3 to 40 characters. The default is your medical council number.","lockedHint":"The address was fixed at the first publish and can no longer change.","required":"Enter an address.","invalid":"Only lower-case English letters, digits and hyphens, 3 to 40 characters; it must start and end with a letter or digit, with no double hyphens.","checking":"Checking\u2026","available":"This address is available.","taken":"This address is not available.","save":"Save address"},"sections":{"title":"Sections","reorderHint":"Change the order with the up and down buttons (or Alt and the arrow keys).","kinds":{"hero":"Professional profile","services":"Services","articles":"Articles","testimonials":"Selected patient testimonials","gallery":"Image gallery","video":"Video","office":"Office information"},"show":"Show \u201C{{name}}\u201D on the page","shown":"Shown","hidden":"Hidden","hiddenNotice":"This section is hidden and does not appear on your public page.","showOnPage":"Show on page","toggleFailed":"Could not change whether \xab{{name}}\xbb is shown:","required":"This section is always shown","moveUp":"Move \u201C{{name}}\u201D up","moveDown":"Move \u201C{{name}}\u201D down","unsupported":"Not shown in this template","unsupportedLong":"The current template does not show this section. Its content is kept and appears again if you change template.","hasErrors":"This section is blocking publication","titleOverride":"Section heading (optional)","titleOverrideHint":"Leave empty to show the default heading.","reorderFailed":"The section order was not saved. Try again."},"items":{"count":"{{count}} of {{max}}","moveUp":"Move up","moveDown":"Move down","remove":"Remove"},"image":{"pick":"Choose image","replace":"Change image","remove":"Remove image","removeTitle":"Remove the image?","removeBody":"The image is removed from the page. After the next publish it is also removed from the public page.","removeConfirm":"Remove","cropTitle":"Crop image","typeUnsupported":"Only JPEG or PNG images are accepted.","tooLarge":"The image is larger than 5 MB.","readFailed":"The file could not be read."},"hero":{"displayName":"Display name","displayNameRequired":"A display name is required.","headline":"Headline","headlinePlaceholder":"e.g. Cardiologist, faculty member","headlineHint":"In the \u201CModern\u201D and \u201CClassic\u201D templates this is set large at the top of the page; with a comma, the part after it is shown in colour.","about":"About me","portrait":"Portrait","portraitHint":"A separate copy of your profile picture; changing it does not affect your profile.","cover":"Background image","coverHint":"A wide image (about 3:1). \u201CModern\u201D shows it softened behind the top of the page; \u201CClassic\u201D shows it as a band across the top.","coverUnused":"The current template does not show a background image; choose \u201CModern\u201D or \u201CClassic\u201D to see it.","extras":{"onlyModern":"These two lists are shown in the \u201CModern\u201D and \u201CClassic\u201D templates. If left empty, your first services and your council number, city and office hours take their place.","notShown":"The current template does not show these two lists; choose \u201CModern\u201D or \u201CClassic\u201D to see them.","cardsTitle":"Intro cards","cardsHint":"Up to two short cards at the top of the page, e.g. \u201CIn-person and online visits\u201D.","addCard":"Add card","highlightsTitle":"Highlights","highlightsHint":"Up to three items in the strip under the top of the page, e.g. \u201C15 years of experience\u201D.","addHighlight":"Add highlight","itemTitle":"Title","itemText":"Short text (optional)","titleRequired":"A title is required."}},"services":{"itemTitle":"Service title","itemDescription":"Description","image":"Service image","imageHint":"4:3; the service title is used as the image\'s alternative text.","imageAfterSave":"You can add an image after saving this service.","add":"Add service"},"testimonials":{"framingTitle":"Selected testimonials, not ratings","framing":"This section holds quotes you choose and enter yourself, shown under the heading \u201CSelected patient testimonials\u201D. No ratings, stars or review counts are shown on the page.","text":"Testimonial","attribution":"Patient\'s display name","attributionPlaceholder":"e.g. \u201CM. Rezaei\u201D or \u201C45-year-old patient\u201D","consent":"The patient agreed to this testimonial being published on the public page","consentRequired":"This testimonial is not saved without the patient\'s consent confirmed.","add":"Add testimonial"},"video":{"intro":"Paste a video address from Aparat or YouTube; only the video\'s id is stored.","url":"Video address","caption":"Short caption","add":"Add video","pending":"Checked when saved","aparat":"Aparat","youtube":"YouTube"},"gallery":{"alt":"Alternative text","altRequired":"Alternative text is required.","saveAlt":"Save text","newAlt":"Description of the new image","newAltPlaceholder":"e.g. \u201COffice waiting room\u201D","altFirst":"Write the image description first.","emptyTitle":"No images in the gallery yet","emptyHint":"Add up to 12 images of your office and equipment."},"articles":{"new":"New article","back":"Back to articles","title":"Article title","slug":"Article address (optional)","slugHint":"Leave empty to build it from the title. It is fixed at the first publish.","slugLocked":"Article address:","body":"Article text","cover":"Article image","publish":"Publish article","unpublish":"Return to draft","republish":"Publish article changes","delete":"Delete article","deleteTitle":"Delete the article?","deleteBody":"The article \u201C{{title}}\u201D will be deleted permanently.","deleteConfirm":"Delete","saveFirst":"Save your changes before publishing.","saveToContinue":"After saving you can add an image and publish the article.","untitled":"Untitled","publishedOn":"Published on {{date}}","neverPublished":"Not published yet","statusPublished":"Published","statusDraft":"Draft","changed":"Unpublished changes","emptyTitle":"You have not written any articles yet","emptyHint":"Educational articles for patients make your page easier to find in search."},"office":{"intro":"What you enter here is shown on the public page exactly as written.","phones":"Phones","phoneLabel":"Label","phoneLabelPlaceholder":"e.g. Reception","phoneNumber":"Number","addPhone":"Add phone","city":"City","address":"Office address","hours":"Office hours","hoursLabel":"Days","hoursLabelPlaceholder":"e.g. Saturday to Wednesday","hoursValue":"Hours","hoursValuePlaceholder":"e.g. 16 to 20","addHours":"Add hours","geo":"Map location (optional)","geoHint":"Mark your office on the map so patients can get directions from your page with Neshan, Balad or Google Maps.","map":{"pick":"Choose on the map","change":"Change on the map","close":"Close map","myLocation":"My current location","clear":"Remove location","isSet":"Your office is marked on the map.","label":"Map for choosing the office location","hint":"Tap the map or drag the pin onto your office, then press \u201CSave\u201D.","found":"The pin is at your current location. If you are not at the office right now, move it onto the office.","locating":"Finding your location\u2026","loading":"Loading the map\u2026","failed":"The map could not be loaded. If you are at the office, press \u201CMy current location\u201D.","denied":"Location access was not allowed; tap the map to mark your office.","unavailable":"Your location could not be found; tap the map to mark your office.","timeout":"Finding your location took too long; try again or tap the map.","unsupported":"This browser cannot share a location; tap the map to mark your office."},"socials":"Social networks","socialsHint":"Enter the handle or the profile address (e.g. @dr.example or instagram.com/dr.example). WhatsApp: the full number with country code. Website: the full address.","social":{"instagram":"Instagram","telegram":"Telegram","whatsapp":"WhatsApp","eitaa":"Eitaa","bale":"Bale","website":"Website"}},"leads":{"intro":"Requests visitors sent from your page. The {{brand}} team follows them up.","name":"Name","mobile":"Mobile","preference":"Contact method and time","message":"Message","createdAt":"Received","status":"Status","more":"Show more","loadFailed":"Requests could not be loaded","emptyTitle":"No requests yet","emptyHint":"Share your page address with patients so they can reach you through \u201CRequest an appointment\u201D.","notPublishedTitle":"The page is not published yet","notPublishedHint":"Once published, visitors\' requests appear here.","channels":{"call":"Phone call","sms":"SMS","whatsapp":"WhatsApp"},"times":{"morning":"Morning","afternoon":"Afternoon","evening":"Evening","any":"Any time"},"statuses":{"new":"New","contacted":"Contacted","qualified":"In progress","proposal":"In progress","negotiation":"In progress","won":"Done","lost":"Closed"}}}}');


var $c6bf782c884ec896$exports = {};
$c6bf782c884ec896$exports = JSON.parse('{"nav":{"items":{"myPage":"\u0635\u0641\u062D\u062A\u064A"}},"myPage":{"subtitle":"\u0635\u0641\u062D\u062A\u0643 \u0627\u0644\u0639\u0627\u0645\u0629 \u0639\u0644\u0649 {{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}}: \u0627\u062E\u062A\u0631 \u0642\u0627\u0644\u0628\u064B\u0627 \u0648\u0631\u062A\u0651\u0628 \u0627\u0644\u0623\u0642\u0633\u0627\u0645 \u062B\u0645 \u0627\u0646\u0634\u0631\u0647\u0627.","loading":"\u062C\u0627\u0631\u064D \u062A\u062C\u0647\u064A\u0632 \u0635\u0641\u062D\u062A\u0643","loadFailed":"\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0635\u0641\u062D\u062A\u0643","railLabel":"\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0635\u0641\u062D\u0629","markdownHint":"\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0628\u0633\u064A\u0637 \u0645\u062F\u0639\u0648\u0645: # \u0639\u0646\u0648\u0627\u0646\u060C **\u0639\u0631\u064A\u0636**\u060C \u0642\u0648\u0627\u0626\u0645 \u0628\u0640 - \u0648\u0631\u0648\u0627\u0628\u0637 \u0628\u0627\u0644\u0634\u0643\u0644 [\u0646\u0635](https://\u2026). \u0644\u0627 \u064A\u064F\u0642\u0628\u0644 HTML.","markdownHintShort":"**\u0627\u0644\u0639\u0631\u064A\u0636** \u0648\u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0628\u0640 - \u0648\u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0645\u062F\u0639\u0648\u0645\u0629.","tabs":{"label":"\u0623\u0642\u0633\u0627\u0645 \u0635\u0641\u062D\u062A\u064A","builder":"\u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0635\u0641\u062D\u0629","leads":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0635\u0641\u062D\u0629"},"status":{"draft":"\u0645\u0633\u0648\u062F\u0629","published":"\u0645\u0646\u0634\u0648\u0631\u0629","unpublished":"\u0623\u064F\u0644\u063A\u064A \u0646\u0634\u0631\u0647\u0627","suspended":"\u0645\u0639\u0644\u0651\u0642\u0629","unknown":"\u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641"},"statusCard":{"title":"\u062D\u0627\u0644\u0629 \u0627\u0644\u0635\u0641\u062D\u0629","liveUrl":"\u0639\u0646\u0648\u0627\u0646 \u0635\u0641\u062D\u062A\u0643","futureUrl":"\u0628\u0639\u062F \u0627\u0644\u0646\u0634\u0631 \u0633\u062A\u0643\u0648\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u062A\u0627\u062D\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","copy":"\u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646","copied":"\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646","copyFailed":"\u062A\u0639\u0630\u0651\u0631 \u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646","lastPublished":"\u0622\u062E\u0631 \u0646\u0634\u0631: {{date}}","preview":"\u0645\u0639\u0627\u064A\u0646\u0629","openPreview":"\u0641\u062A\u062D \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629","popupBlocked":"\u062D\u0638\u0631 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629\u061B \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0623\u062F\u0646\u0627\u0647.","publish":"\u0646\u0634\u0631","republish":"\u0646\u0634\u0631 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A","unpublish":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0646\u0634\u0631","unpublishTitle":"\u0625\u0644\u063A\u0627\u0621 \u0646\u0634\u0631 \u0627\u0644\u0635\u0641\u062D\u0629\u061F","unpublishBody":"\u0633\u062A\u064F\u0632\u0627\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0645\u0646 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0648\u0644\u0646 \u064A\u0639\u0645\u0644 \u0639\u0646\u0648\u0627\u0646\u0647\u0627. \u064A\u064F\u062D\u0641\u0638 \u0643\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0648\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0646\u0634\u0631 \u0645\u062C\u062F\u062F\u064B\u0627.","unpublishConfirm":"\u0623\u0644\u063A\u0650 \u0627\u0644\u0646\u0634\u0631","unpublished":"\u0623\u064F\u0644\u063A\u064A \u0646\u0634\u0631 \u0627\u0644\u0635\u0641\u062D\u0629","unpublishFailed":"\u062A\u0639\u0630\u0651\u0631 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0646\u0634\u0631. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627.","blockersTitle":"\u0644\u0644\u0646\u0634\u0631\u060C \u0623\u0643\u0645\u0644 \u0645\u0627 \u064A\u0644\u064A:","addCouncil":"\u0623\u0636\u0641 \u0631\u0642\u0645 \u0627\u0644\u0646\u0642\u0627\u0628\u0629 \u0627\u0644\u0637\u0628\u064A\u0629 \u0641\u064A \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A"},"banner":{"suspendedTitle":"\u0639\u0644\u0651\u0642\u062A {{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}} \u0635\u0641\u062D\u062A\u0643","suspendedNoReason":"\u0644\u0645 \u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u0633\u0628\u0628.","suspendedSupport":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629 \u0641\u0642\u0637. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u062F\u0639\u0645 {{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}} \u0644\u0631\u0641\u0639 \u0627\u0644\u062A\u0639\u0644\u064A\u0642.","unpublishedChanges":"\u0644\u062F\u064A\u0643 \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0644\u0645 \u062A\u064F\u0646\u0634\u0631 \u0628\u0639\u062F\u061B \u064A\u0631\u0649 \u0627\u0644\u0632\u0648\u0627\u0631 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629."},"save":{"save":"\u062D\u0641\u0638","reset":"\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646","saving":"\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638\u2026","saved":"\u062A\u0645 \u0627\u0644\u062D\u0641\u0638","dirty":"\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629"},"publish":{"title":"\u0646\u0634\u0631 \u0627\u0644\u0635\u0641\u062D\u0629","intro":"\u0628\u0639\u062F \u0627\u0644\u0646\u0634\u0631 \u064A\u0645\u0643\u0646 \u0644\u0644\u062C\u0645\u064A\u0639 \u0639\u0644\u0649 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0631\u0624\u064A\u0629 \u0635\u0641\u062D\u062A\u0643 \u0648\u0627\u0644\u0628\u062D\u062B \u0639\u0646\u0647\u0627. \u0642\u0628\u0644 \u0627\u0644\u0646\u0634\u0631 \u0623\u0643\u0651\u062F \u0645\u0627 \u064A\u0644\u064A:","rule1":"\u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0645\u062A\u0648\u0627\u0641\u0642 \u0645\u0639 \u0636\u0648\u0627\u0628\u0637 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0644\u0644\u0646\u0642\u0627\u0628\u0629 \u0627\u0644\u0637\u0628\u064A\u0629 \u0648\u0644\u0627 \u064A\u062F\u0651\u0639\u064A \u0634\u0641\u0627\u0621\u064B \u0645\u0624\u0643\u062F\u064B\u0627 \u0623\u0648 \u0646\u062A\u064A\u062C\u0629 \u0645\u0636\u0645\u0648\u0646\u0629 \u0623\u0648 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0627\u0644\u0632\u0645\u0644\u0627\u0621.","rule2":"\u0627\u0644\u0635\u0648\u0631 \u0648\u0627\u0644\u0646\u0635\u0648\u0635 \u0645\u0644\u0643\u0643 \u0623\u0648 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627.","rule3":"\u062A\u064F\u0646\u0634\u0631 \u0622\u0631\u0627\u0621 \u0627\u0644\u0645\u0631\u0636\u0649 \u0628\u0645\u0648\u0627\u0641\u0642\u062A\u0647\u0645\u060C \u0648\u0644\u0627 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0637\u0628\u064A\u0629 \u0634\u062E\u0635\u064A\u0629.","rule4":"\u0623\u0646\u062A \u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0648\u064A\u0645\u0643\u0646 \u0644{{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}} \u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u062E\u0627\u0644\u0641\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u0636\u0648\u0627\u0628\u0637.","public":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0639\u0627\u0645\u0629: \u064A\u0631\u0627\u0647\u0627 \u0643\u0644 \u0645\u0646 \u0644\u062F\u064A\u0647 \u0639\u0646\u0648\u0627\u0646\u0647\u0627 \u0648\u0645\u062D\u0631\u0643\u0627\u062A \u0627\u0644\u0628\u062D\u062B.","accept":"\u0642\u0631\u0623\u062A \u0647\u0630\u0647 \u0627\u0644\u0628\u0646\u0648\u062F \u0648\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0627","confirm":"\u0627\u0646\u0634\u0631","cancel":"\u0625\u0644\u063A\u0627\u0621","failedTitle":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0646\u0634\u0631\u061B \u0635\u062D\u0651\u062D \u0645\u0627 \u064A\u0644\u064A","done":"\u062A\u0645 \u0646\u0634\u0631 \u0635\u0641\u062D\u062A\u0643"},"template":{"title":"\u0627\u0644\u0642\u0627\u0644\u0628"},"templates":{"classic":{"name":"\u0643\u0644\u0627\u0633\u064A\u0643\u064A","description":"\u0645\u0637\u0628\u0648\u0639 \u0648\u0631\u0635\u064A\u0646: \u0635\u0648\u0631\u0629 \u0645\u0624\u0637\u0651\u0631\u0629 \u0648\u0639\u0646\u0648\u0627\u0646 \u0643\u0628\u064A\u0631 \u0628\u062A\u0638\u0644\u064A\u0644 \u0645\u0644\u0648\u0651\u0646 \u0648\u0635\u0648\u0631\u0629 \u0627\u0644\u062E\u0644\u0641\u064A\u0629 \u0643\u0634\u0631\u064A\u0637 \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u0634\u0631\u064A\u0637 \u0644\u0623\u0628\u0631\u0632 \u0627\u0644\u0646\u0642\u0627\u0637."},"modern":{"name":"\u0639\u0635\u0631\u064A","description":"\u0643\u0635\u0641\u062D\u0629 \u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0639\u064A\u0627\u062F\u0629: \u0639\u0646\u0648\u0627\u0646 \u0643\u0628\u064A\u0631 \u0648\u0635\u0648\u0631\u0629 \u062E\u0644\u0641\u064A\u0629 \u0648\u0628\u0637\u0627\u0642\u0627\u062A \u0628\u062C\u0627\u0646\u0628 \u0627\u0644\u0635\u0648\u0631\u0629 \u0648\u0634\u0631\u064A\u0637 \u0644\u0623\u0628\u0631\u0632 \u0627\u0644\u0646\u0642\u0627\u0637."},"minimal":{"name":"\u0628\u0633\u064A\u0637","description":"\u0637\u0628\u0627\u0639\u064A \u0648\u0647\u0627\u062F\u0626 \u0628\u0644\u0627 \u063A\u0644\u0627\u0641\u061B \u064A\u0631\u0643\u0651\u0632 \u0639\u0644\u0649 \u0627\u0644\u0646\u0635 \u0648\u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0648\u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A."}},"palettes":{"azure":"\u0644\u0627\u0632\u0648\u0631\u062F\u064A","teal":"\u0641\u064A\u0631\u0648\u0632\u064A","deep":"\u0643\u062D\u0644\u064A","brand":"\u0647\u0648\u064A\u0629 {{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}}","cyan":"\u0633\u0645\u0627\u0648\u064A","ink":"\u062D\u0628\u0631\u064A"},"theme":{"title":"\u0627\u0644\u0644\u0648\u0646 \u0648\u0627\u0644\u0643\u062B\u0627\u0641\u0629","palette":"\u0644\u0648\u062D\u0629 \u0627\u0644\u0623\u0644\u0648\u0627\u0646","density":"\u0627\u0644\u0643\u062B\u0627\u0641\u0629","densities":{"comfortable":"\u0645\u0631\u064A\u062D\u0629","compact":"\u0645\u0636\u063A\u0648\u0637\u0629"},"onlyTemplate":"\u062A\u064F\u0639\u0631\u0636 \u0641\u0642\u0637 \u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0648\u0627\u0644\u0643\u062B\u0627\u0641\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062F\u0639\u0645\u0647\u0627 \u0627\u0644\u0642\u0627\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A."},"slug":{"label":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629","hint":"\u0623\u062D\u0631\u0641 \u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629 \u0635\u063A\u064A\u0631\u0629 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0634\u0631\u0637\u0629\u061B \u0645\u0646 \u0663 \u0625\u0644\u0649 \u0664\u0660 \u0645\u062D\u0631\u0641\u064B\u0627. \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A \u0631\u0642\u0645 \u0646\u0642\u0627\u0628\u062A\u0643 \u0627\u0644\u0637\u0628\u064A\u0629.","lockedHint":"\u062B\u064F\u0628\u0651\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0639\u0646\u062F \u0623\u0648\u0644 \u0646\u0634\u0631 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631\u0647 \u0628\u0639\u062F \u0627\u0644\u0622\u0646.","required":"\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627.","invalid":"\u0623\u062D\u0631\u0641 \u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629 \u0635\u063A\u064A\u0631\u0629 \u0648\u0623\u0631\u0642\u0627\u0645 \u0648\u0634\u0631\u0637\u0629 \u0641\u0642\u0637\u060C \u0645\u0646 \u0663 \u0625\u0644\u0649 \u0664\u0660 \u0645\u062D\u0631\u0641\u064B\u0627\u061B \u064A\u0628\u062F\u0623 \u0648\u064A\u0646\u062A\u0647\u064A \u0628\u062D\u0631\u0641 \u0623\u0648 \u0631\u0642\u0645\u060C \u062F\u0648\u0646 \u0634\u0631\u0637\u062A\u064A\u0646 \u0645\u062A\u062A\u0627\u0644\u064A\u062A\u064A\u0646.","checking":"\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026","available":"\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u062A\u0627\u062D.","taken":"\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D.","save":"\u062D\u0641\u0638 \u0627\u0644\u0639\u0646\u0648\u0627\u0646"},"sections":{"title":"\u0627\u0644\u0623\u0642\u0633\u0627\u0645","reorderHint":"\u063A\u064A\u0651\u0631 \u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u0628\u0632\u0631\u0651\u064A \u0627\u0644\u0623\u0639\u0644\u0649 \u0648\u0627\u0644\u0623\u0633\u0641\u0644 (\u0623\u0648 Alt \u0648\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0623\u0633\u0647\u0645).","kinds":{"hero":"\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u0647\u0646\u064A","services":"\u0627\u0644\u062E\u062F\u0645\u0627\u062A","articles":"\u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A","testimonials":"\u0622\u0631\u0627\u0621 \u0645\u062E\u062A\u0627\u0631\u0629 \u0644\u0644\u0645\u0631\u0636\u0649","gallery":"\u0645\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631","video":"\u0641\u064A\u062F\u064A\u0648","office":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u064A\u0627\u062F\u0629"},"show":"\u0625\u0638\u0647\u0627\u0631 \xab{{name}}\xbb \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629","shown":"\u0645\u0639\u0631\u0648\u0636","hidden":"\u0645\u062E\u0641\u064A","hiddenNotice":"\u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0645\u062E\u0641\u064A \u0648\u0644\u0627 \u064A\u0638\u0647\u0631 \u0641\u064A \u0635\u0641\u062D\u062A\u0643 \u0627\u0644\u0639\u0627\u0645\u0629.","showOnPage":"\u0625\u0638\u0647\u0627\u0631 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629","toggleFailed":"\u062A\u0639\u0630\u0651\u0631 \u062A\u063A\u064A\u064A\u0631 \u0638\u0647\u0648\u0631 \xab{{name}}\xbb:","required":"\u064A\u064F\u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u062F\u0627\u0626\u0645\u064B\u0627","moveUp":"\u0646\u0642\u0644 \xab{{name}}\xbb \u0625\u0644\u0649 \u0627\u0644\u0623\u0639\u0644\u0649","moveDown":"\u0646\u0642\u0644 \xab{{name}}\xbb \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0641\u0644","unsupported":"\u0644\u0627 \u064A\u064F\u0639\u0631\u0636 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0642\u0627\u0644\u0628","unsupportedLong":"\u0644\u0627 \u064A\u0639\u0631\u0636 \u0627\u0644\u0642\u0627\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645. \u064A\u064F\u062D\u0641\u0638 \u0645\u062D\u062A\u0648\u0627\u0647 \u0648\u064A\u0638\u0647\u0631 \u0645\u062C\u062F\u062F\u064B\u0627 \u0639\u0646\u062F \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0642\u0627\u0644\u0628.","hasErrors":"\u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u064A\u0645\u0646\u0639 \u0627\u0644\u0646\u0634\u0631","titleOverride":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0642\u0633\u0645 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","titleOverrideHint":"\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u0639\u0631\u0636 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A.","reorderFailed":"\u0644\u0645 \u064A\u064F\u062D\u0641\u0638 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0623\u0642\u0633\u0627\u0645. \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u064B\u0627."},"items":{"count":"{{count}} \u0645\u0646 {{max}}","moveUp":"\u0646\u0642\u0644 \u0644\u0644\u0623\u0639\u0644\u0649","moveDown":"\u0646\u0642\u0644 \u0644\u0644\u0623\u0633\u0641\u0644","remove":"\u062D\u0630\u0641"},"image":{"pick":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0635\u0648\u0631\u0629","replace":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0635\u0648\u0631\u0629","remove":"\u062D\u0630\u0641 \u0627\u0644\u0635\u0648\u0631\u0629","removeTitle":"\u062D\u0630\u0641 \u0627\u0644\u0635\u0648\u0631\u0629\u061F","removeBody":"\u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u0635\u0648\u0631\u0629 \u0645\u0646 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0648\u0628\u0639\u062F \u0627\u0644\u0646\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A \u062A\u064F\u0632\u0627\u0644 \u0645\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0639\u0627\u0645\u0629 \u0623\u064A\u0636\u064B\u0627.","removeConfirm":"\u0627\u062D\u0630\u0641","cropTitle":"\u0642\u0635 \u0627\u0644\u0635\u0648\u0631\u0629","typeUnsupported":"\u062A\u064F\u0642\u0628\u0644 \u0635\u0648\u0631 JPEG \u0623\u0648 PNG \u0641\u0642\u0637.","tooLarge":"\u062D\u062C\u0645 \u0627\u0644\u0635\u0648\u0631\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0665 \u0645\u064A\u063A\u0627\u0628\u0627\u064A\u062A.","readFailed":"\u062A\u0639\u0630\u0651\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0645\u0644\u0641."},"hero":{"displayName":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636","displayNameRequired":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0645\u0637\u0644\u0648\u0628.","headline":"\u0639\u0646\u0648\u0627\u0646 \u0642\u0635\u064A\u0631","headlinePlaceholder":"\u0645\u062B\u0644\u064B\u0627: \u0623\u062E\u0635\u0627\u0626\u064A \u0642\u0644\u0628\u060C \u0639\u0636\u0648 \u0647\u064A\u0626\u0629 \u062A\u062F\u0631\u064A\u0633","headlineHint":"\u0641\u064A \u0642\u0627\u0644\u0628\u064E\u064A \xab\u0627\u0644\u0639\u0635\u0631\u064A\xbb \u0648\xab\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A\xbb \u064A\u0638\u0647\u0631 \u0628\u062E\u0637 \u0643\u0628\u064A\u0631 \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629\u061B \u0648\u0625\u0630\u0627 \u0627\u062D\u062A\u0648\u0649 \u0639\u0644\u0649 \u0641\u0627\u0635\u0644\u0629 \u0641\u064A\u0638\u0647\u0631 \u0645\u0627 \u0628\u0639\u062F\u0647\u0627 \u0645\u0644\u0648\u0651\u0646\u064B\u0627.","about":"\u0646\u0628\u0630\u0629 \u0639\u0646\u064A","portrait":"\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0634\u062E\u0635\u064A\u0629","portraitHint":"\u0646\u0633\u062E\u0629 \u0645\u0646\u0641\u0635\u0644\u0629 \u0645\u0646 \u0635\u0648\u0631\u0629 \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u061B \u062A\u063A\u064A\u064A\u0631\u0647\u0627 \u0644\u0627 \u064A\u0624\u062B\u0631 \u0641\u064A \u0645\u0644\u0641\u0643.","cover":"\u0635\u0648\u0631\u0629 \u0627\u0644\u062E\u0644\u0641\u064A\u0629","coverHint":"\u0635\u0648\u0631\u0629 \u0639\u0631\u064A\u0636\u0629 (\u0628\u0646\u0633\u0628\u0629 \u0663 \u0625\u0644\u0649 \u0661 \u062A\u0642\u0631\u064A\u0628\u064B\u0627). \u0641\u064A \u0642\u0627\u0644\u0628 \xab\u0627\u0644\u0639\u0635\u0631\u064A\xbb \u062A\u0638\u0647\u0631 \u0628\u0627\u0647\u062A\u0629 \u062E\u0644\u0641 \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629\u060C \u0648\u0641\u064A \xab\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A\xbb \u0643\u0634\u0631\u064A\u0637 \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629.","coverUnused":"\u0627\u0644\u0642\u0627\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0627 \u064A\u0639\u0631\u0636 \u0635\u0648\u0631\u0629 \u0627\u0644\u062E\u0644\u0641\u064A\u0629\u061B \u0627\u062E\u062A\u0631 \u0642\u0627\u0644\u0628 \xab\u0627\u0644\u0639\u0635\u0631\u064A\xbb \u0623\u0648 \xab\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A\xbb \u0644\u0631\u0624\u064A\u062A\u0647\u0627.","extras":{"onlyModern":"\u062A\u0638\u0647\u0631 \u0647\u0627\u062A\u0627\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u062A\u0627\u0646 \u0641\u064A \u0642\u0627\u0644\u0628\u064E\u064A \xab\u0627\u0644\u0639\u0635\u0631\u064A\xbb \u0648\xab\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A\xbb. \u0648\u0625\u0630\u0627 \u0628\u0642\u064A\u062A\u0627 \u0641\u0627\u0631\u063A\u062A\u064A\u0646 \u0641\u0633\u062A\u062D\u0644\u0651 \u0645\u062D\u0644\u0651\u0647\u0645\u0627 \u062E\u062F\u0645\u0627\u062A\u0643 \u0627\u0644\u0623\u0648\u0644\u0649 \u0648\u0631\u0642\u0645 \u0627\u0644\u0646\u0638\u0627\u0645 \u0648\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0648\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644.","notShown":"\u0627\u0644\u0642\u0627\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0627 \u064A\u0639\u0631\u0636 \u0647\u0627\u062A\u064A\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u062A\u064A\u0646\u061B \u0627\u062E\u062A\u0631 \u0642\u0627\u0644\u0628 \xab\u0627\u0644\u0639\u0635\u0631\u064A\xbb \u0623\u0648 \xab\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A\xbb \u0644\u0631\u0624\u064A\u062A\u0647\u0645\u0627.","cardsTitle":"\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u062A\u0639\u0631\u064A\u0641","cardsHint":"\u0628\u0637\u0627\u0642\u062A\u0627\u0646 \u0642\u0635\u064A\u0631\u062A\u0627\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629\u061B \u0645\u062B\u0644\u064B\u0627 \xab\u0632\u064A\u0627\u0631\u0629 \u062D\u0636\u0648\u0631\u064A\u0629 \u0648\u0639\u0646 \u0628\u064F\u0639\u062F\xbb.","addCard":"\u0625\u0636\u0627\u0641\u0629 \u0628\u0637\u0627\u0642\u0629","highlightsTitle":"\u0623\u0628\u0631\u0632 \u0627\u0644\u0646\u0642\u0627\u0637","highlightsHint":"\u062B\u0644\u0627\u062B\u0629 \u0639\u0646\u0627\u0635\u0631 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 \u0641\u064A \u0627\u0644\u0634\u0631\u064A\u0637 \u0623\u0633\u0641\u0644 \u0623\u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629\u061B \u0645\u062B\u0644\u064B\u0627 \xab\u0661\u0665 \u0633\u0646\u0629 \u062E\u0628\u0631\u0629\xbb.","addHighlight":"\u0625\u0636\u0627\u0641\u0629 \u0646\u0642\u0637\u0629","itemTitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646","itemText":"\u0646\u0635 \u0642\u0635\u064A\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","titleRequired":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0637\u0644\u0648\u0628."}},"services":{"itemTitle":"\u0627\u0633\u0645 \u0627\u0644\u062E\u062F\u0645\u0629","itemDescription":"\u0627\u0644\u0648\u0635\u0641","image":"\u0635\u0648\u0631\u0629 \u0627\u0644\u062E\u062F\u0645\u0629","imageHint":"\u0646\u0633\u0628\u0629 \u0664 \u0625\u0644\u0649 \u0663\u061B \u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0627\u0633\u0645 \u0627\u0644\u062E\u062F\u0645\u0629 \u0646\u0635\u064B\u0627 \u0628\u062F\u064A\u0644\u064B\u0627 \u0644\u0644\u0635\u0648\u0631\u0629.","imageAfterSave":"\u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0635\u0648\u0631\u0629 \u0628\u0639\u062F \u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u062E\u062F\u0645\u0629.","add":"\u0625\u0636\u0627\u0641\u0629 \u062E\u062F\u0645\u0629"},"testimonials":{"framingTitle":"\u0622\u0631\u0627\u0621 \u0645\u062E\u062A\u0627\u0631\u0629\u060C \u0644\u0627 \u062A\u0642\u064A\u064A\u0645\u0627\u062A","framing":"\u064A\u0636\u0645 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0627\u0642\u062A\u0628\u0627\u0633\u0627\u062A \u062A\u062E\u062A\u0627\u0631\u0647\u0627 \u0648\u062A\u064F\u062F\u062E\u0644\u0647\u0627 \u0628\u0646\u0641\u0633\u0643\u060C \u0648\u062A\u064F\u0639\u0631\u0636 \u062A\u062D\u062A \u0639\u0646\u0648\u0627\u0646 \xab\u0622\u0631\u0627\u0621 \u0645\u062E\u062A\u0627\u0631\u0629 \u0644\u0644\u0645\u0631\u0636\u0649\xbb. \u0644\u0627 \u062A\u064F\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u062A\u0642\u064A\u064A\u0645\u0627\u062A \u0623\u0648 \u0646\u062C\u0648\u0645 \u0623\u0648 \u0639\u062F\u062F \u0622\u0631\u0627\u0621.","text":"\u0646\u0635 \u0627\u0644\u0631\u0623\u064A","attribution":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0644\u0644\u0645\u0631\u064A\u0636","attributionPlaceholder":"\u0645\u062B\u0644\u064B\u0627 \xab\u0645. \u0631\u0636\u0627\u0626\u064A\xbb \u0623\u0648 \xab\u0645\u0631\u064A\u0636 \u0639\u0645\u0631\u0647 \u0664\u0665 \u0639\u0627\u0645\u064B\u0627\xbb","consent":"\u0648\u0627\u0641\u0642 \u0627\u0644\u0645\u0631\u064A\u0636 \u0639\u0644\u0649 \u0646\u0634\u0631 \u0647\u0630\u0627 \u0627\u0644\u0631\u0623\u064A \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0639\u0627\u0645\u0629","consentRequired":"\u0644\u0627 \u064A\u064F\u062D\u0641\u0638 \u0647\u0630\u0627 \u0627\u0644\u0631\u0623\u064A \u062F\u0648\u0646 \u062A\u0623\u0643\u064A\u062F \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0645\u0631\u064A\u0636.","add":"\u0625\u0636\u0627\u0641\u0629 \u0631\u0623\u064A"},"video":{"intro":"\u0627\u0644\u0635\u0642 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0645\u0646 \u0622\u0628\u0627\u0631\u0627\u062A \u0623\u0648 \u064A\u0648\u062A\u064A\u0648\u0628\u061B \u064A\u064F\u062D\u0641\u0638 \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0641\u0642\u0637.","url":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u064A\u062F\u064A\u0648","caption":"\u0648\u0635\u0641 \u0642\u0635\u064A\u0631","add":"\u0625\u0636\u0627\u0641\u0629 \u0641\u064A\u062F\u064A\u0648","pending":"\u064A\u064F\u0641\u062D\u0635 \u0639\u0646\u062F \u0627\u0644\u062D\u0641\u0638","aparat":"\u0622\u0628\u0627\u0631\u0627\u062A","youtube":"\u064A\u0648\u062A\u064A\u0648\u0628"},"gallery":{"alt":"\u0627\u0644\u0646\u0635 \u0627\u0644\u0628\u062F\u064A\u0644","altRequired":"\u0627\u0644\u0646\u0635 \u0627\u0644\u0628\u062F\u064A\u0644 \u0645\u0637\u0644\u0648\u0628.","saveAlt":"\u062D\u0641\u0638 \u0627\u0644\u0646\u0635","newAlt":"\u0648\u0635\u0641 \u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","newAltPlaceholder":"\u0645\u062B\u0644\u064B\u0627 \xab\u063A\u0631\u0641\u0629 \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0639\u064A\u0627\u062F\u0629\xbb","altFirst":"\u0627\u0643\u062A\u0628 \u0648\u0635\u0641 \u0627\u0644\u0635\u0648\u0631\u0629 \u0623\u0648\u0644\u064B\u0627.","emptyTitle":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631 \u0641\u064A \u0627\u0644\u0645\u0639\u0631\u0636 \u0628\u0639\u062F","emptyHint":"\u0623\u0636\u0641 \u062D\u062A\u0649 \u0661\u0662 \u0635\u0648\u0631\u0629 \u0644\u0644\u0639\u064A\u0627\u062F\u0629 \u0648\u0627\u0644\u0623\u062C\u0647\u0632\u0629."},"articles":{"new":"\u0645\u0642\u0627\u0644\u0629 \u062C\u062F\u064A\u062F\u0629","back":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A","title":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u0627\u0644\u0629","slug":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u0627\u0644\u0629 \u0641\u064A \u0627\u0644\u0631\u0627\u0628\u0637 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","slugHint":"\u0627\u062A\u0631\u0643\u0647 \u0641\u0627\u0631\u063A\u064B\u0627 \u0644\u064A\u064F\u0628\u0646\u0649 \u0645\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646. \u064A\u064F\u062B\u0628\u0651\u062A \u0639\u0646\u062F \u0623\u0648\u0644 \u0646\u0634\u0631.","slugLocked":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u0627\u0644\u0629:","body":"\u0646\u0635 \u0627\u0644\u0645\u0642\u0627\u0644\u0629","cover":"\u0635\u0648\u0631\u0629 \u0627\u0644\u0645\u0642\u0627\u0644\u0629","publish":"\u0646\u0634\u0631 \u0627\u0644\u0645\u0642\u0627\u0644\u0629","unpublish":"\u0625\u0639\u0627\u062F\u0629 \u0625\u0644\u0649 \u0645\u0633\u0648\u062F\u0629","republish":"\u0646\u0634\u0631 \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u0642\u0627\u0644\u0629","delete":"\u062D\u0630\u0641 \u0627\u0644\u0645\u0642\u0627\u0644\u0629","deleteTitle":"\u062D\u0630\u0641 \u0627\u0644\u0645\u0642\u0627\u0644\u0629\u061F","deleteBody":"\u0633\u062A\u064F\u062D\u0630\u0641 \u0627\u0644\u0645\u0642\u0627\u0644\u0629 \xab{{title}}\xbb \u0646\u0647\u0627\u0626\u064A\u064B\u0627.","deleteConfirm":"\u0627\u062D\u0630\u0641","saveFirst":"\u0627\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0642\u0628\u0644 \u0627\u0644\u0646\u0634\u0631.","saveToContinue":"\u0628\u0639\u062F \u0627\u0644\u062D\u0641\u0638 \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0635\u0648\u0631\u0629 \u0648\u0646\u0634\u0631 \u0627\u0644\u0645\u0642\u0627\u0644\u0629.","untitled":"\u0628\u0644\u0627 \u0639\u0646\u0648\u0627\u0646","publishedOn":"\u0646\u064F\u0634\u0631\u062A \u0641\u064A {{date}}","neverPublished":"\u0644\u0645 \u062A\u064F\u0646\u0634\u0631 \u0628\u0639\u062F","statusPublished":"\u0645\u0646\u0634\u0648\u0631\u0629","statusDraft":"\u0645\u0633\u0648\u062F\u0629","changed":"\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u0646\u0634\u0648\u0631\u0629","emptyTitle":"\u0644\u0645 \u062A\u0643\u062A\u0628 \u0623\u064A \u0645\u0642\u0627\u0644\u0629 \u0628\u0639\u062F","emptyHint":"\u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A \u0627\u0644\u062A\u062B\u0642\u064A\u0641\u064A\u0629 \u0644\u0644\u0645\u0631\u0636\u0649 \u062A\u062C\u0639\u0644 \u0635\u0641\u062D\u062A\u0643 \u0623\u0633\u0647\u0644 \u0638\u0647\u0648\u0631\u064B\u0627 \u0641\u064A \u0627\u0644\u0628\u062D\u062B."},"office":{"intro":"\u0645\u0627 \u062A\u064F\u062F\u062E\u0644\u0647 \u0647\u0646\u0627 \u064A\u064F\u0639\u0631\u0636 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0639\u0627\u0645\u0629 \u0643\u0645\u0627 \u0647\u0648.","phones":"\u0627\u0644\u0647\u0648\u0627\u062A\u0641","phoneLabel":"\u0627\u0644\u062A\u0633\u0645\u064A\u0629","phoneLabelPlaceholder":"\u0645\u062B\u0644\u064B\u0627: \u0627\u0644\u0633\u0643\u0631\u062A\u0627\u0631\u064A\u0629","phoneNumber":"\u0627\u0644\u0631\u0642\u0645","addPhone":"\u0625\u0636\u0627\u0641\u0629 \u0647\u0627\u062A\u0641","city":"\u0627\u0644\u0645\u062F\u064A\u0646\u0629","address":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0639\u064A\u0627\u062F\u0629","hours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","hoursLabel":"\u0627\u0644\u0623\u064A\u0627\u0645","hoursLabelPlaceholder":"\u0645\u062B\u0644\u064B\u0627: \u0627\u0644\u0633\u0628\u062A \u0625\u0644\u0649 \u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621","hoursValue":"\u0627\u0644\u0633\u0627\u0639\u0627\u062A","hoursValuePlaceholder":"\u0645\u062B\u0644\u064B\u0627: \u0661\u0666 \u0625\u0644\u0649 \u0662\u0660","addHours":"\u0625\u0636\u0627\u0641\u0629 \u0633\u0627\u0639\u0627\u062A \u0639\u0645\u0644","geo":"\u0627\u0644\u0645\u0648\u0642\u0639 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","geoHint":"\u062D\u062F\u0651\u062F \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u0645\u0631\u0636\u0649 \u0645\u0646 \u0635\u0641\u062D\u062A\u0643 \u0645\u0646 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u0627 \u0639\u0628\u0631 \u0646\u0634\u0627\u0646 \u0623\u0648 \u0628\u0644\u062F \u0623\u0648 \u062E\u0631\u0627\u0626\u0637 Google.","map":{"pick":"\u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629","change":"\u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629","close":"\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062E\u0631\u064A\u0637\u0629","myLocation":"\u0645\u0648\u0642\u0639\u064A \u0627\u0644\u062D\u0627\u0644\u064A","clear":"\u062D\u0630\u0641 \u0627\u0644\u0645\u0648\u0642\u0639","isSet":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629.","label":"\u062E\u0631\u064A\u0637\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0648\u0642\u0639 \u0627\u0644\u0639\u064A\u0627\u062F\u0629","hint":"\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0623\u0648 \u0627\u0633\u062D\u0628 \u0627\u0644\u062F\u0628\u0648\u0633 \u0644\u064A\u0643\u0648\u0646 \u0639\u0644\u0649 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u062A\u0645\u0627\u0645\u064B\u0627\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 \xab\u062D\u0641\u0638\xbb.","found":"\u0648\u064F\u0636\u0639 \u0627\u0644\u062F\u0628\u0648\u0633 \u0639\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0627\u0644\u062D\u0627\u0644\u064A. \u0625\u0646 \u0644\u0645 \u062A\u0643\u0646 \u0641\u064A \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0627\u0644\u0622\u0646 \u0641\u0627\u0646\u0642\u0644\u0647 \u0625\u0644\u064A\u0647\u0627.","locating":"\u062C\u0627\u0631\u064D \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643\u2026","loading":"\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062E\u0631\u064A\u0637\u0629\u2026","failed":"\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062E\u0631\u064A\u0637\u0629. \u0625\u0646 \u0643\u0646\u062A \u0641\u064A \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0641\u0627\u0636\u063A\u0637 \xab\u0645\u0648\u0642\u0639\u064A \u0627\u0644\u062D\u0627\u0644\u064A\xbb.","denied":"\u0644\u0645 \u064A\u064F\u0633\u0645\u062D \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0642\u0639\u061B \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0639\u064A\u0627\u062F\u0629.","unavailable":"\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0648\u0642\u0639\u0643\u061B \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0639\u064A\u0627\u062F\u0629.","timeout":"\u0627\u0633\u062A\u063A\u0631\u0642 \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643 \u0648\u0642\u062A\u064B\u0627 \u0637\u0648\u064A\u0644\u064B\u0627\u061B \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0623\u0648 \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629.","unsupported":"\u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u0627 \u064A\u062F\u0639\u0645 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639\u061B \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0639\u064A\u0627\u062F\u0629."},"socials":"\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629","socialsHint":"\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0639\u0631\u0651\u0641 \u0623\u0648 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 (\u0645\u062B\u0644\u064B\u0627 @dr.example \u0623\u0648 instagram.com/dr.example). \u0648\u0627\u062A\u0633\u0627\u0628: \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0643\u0627\u0645\u0644 \u0645\u0639 \u0631\u0645\u0632 \u0627\u0644\u062F\u0648\u0644\u0629. \u0627\u0644\u0645\u0648\u0642\u0639: \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0643\u0627\u0645\u0644.","social":{"instagram":"\u0625\u0646\u0633\u062A\u063A\u0631\u0627\u0645","telegram":"\u062A\u064A\u0644\u064A\u063A\u0631\u0627\u0645","whatsapp":"\u0648\u0627\u062A\u0633\u0627\u0628","eitaa":"\u0625\u064A\u062A\u0627","bale":"\u0628\u0644\u0647","website":"\u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"}},"leads":{"intro":"\u0637\u0644\u0628\u0627\u062A \u0623\u0631\u0633\u0644\u0647\u0627 \u0627\u0644\u0632\u0648\u0627\u0631 \u0645\u0646 \u0635\u0641\u062D\u062A\u0643. \u064A\u062A\u0627\u0628\u0639\u0647\u0627 \u0641\u0631\u064A\u0642 {{brand|\u0628\u0627\u0631\u0633\u064A\u0646\u0627}}.","name":"\u0627\u0644\u0627\u0633\u0645","mobile":"\u0627\u0644\u062C\u0648\u0627\u0644","preference":"\u0637\u0631\u064A\u0642\u0629 \u0648\u0648\u0642\u062A \u0627\u0644\u062A\u0648\u0627\u0635\u0644","message":"\u0627\u0644\u0631\u0633\u0627\u0644\u0629","createdAt":"\u0648\u0642\u062A \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645","status":"\u0627\u0644\u062D\u0627\u0644\u0629","more":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F","loadFailed":"\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0637\u0644\u0628\u0627\u062A","emptyTitle":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0628\u0639\u062F","emptyHint":"\u0634\u0627\u0631\u0643 \u0639\u0646\u0648\u0627\u0646 \u0635\u0641\u062D\u062A\u0643 \u0645\u0639 \u0627\u0644\u0645\u0631\u0636\u0649 \u0644\u064A\u062A\u0648\u0627\u0635\u0644\u0648\u0627 \u0645\u0639\u0643 \u0639\u0628\u0631 \xab\u0637\u0644\u0628 \u0645\u0648\u0639\u062F\xbb.","notPublishedTitle":"\u0644\u0645 \u062A\u064F\u0646\u0634\u0631 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0639\u062F","notPublishedHint":"\u0628\u0639\u062F \u0627\u0644\u0646\u0634\u0631 \u062A\u0638\u0647\u0631 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0632\u0648\u0627\u0631 \u0647\u0646\u0627.","channels":{"call":"\u0645\u0643\u0627\u0644\u0645\u0629 \u0647\u0627\u062A\u0641\u064A\u0629","sms":"\u0631\u0633\u0627\u0644\u0629 \u0646\u0635\u064A\u0629","whatsapp":"\u0648\u0627\u062A\u0633\u0627\u0628"},"times":{"morning":"\u0635\u0628\u0627\u062D\u064B\u0627","afternoon":"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631","evening":"\u0645\u0633\u0627\u0621\u064B","any":"\u0623\u064A \u0648\u0642\u062A"},"statuses":{"new":"\u062C\u062F\u064A\u062F","contacted":"\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644","qualified":"\u0642\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629","proposal":"\u0642\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629","negotiation":"\u0642\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629","won":"\u062A\u0645","lost":"\u0645\u063A\u0644\u0642"}}}}');


const $031020e651fcb248$var$flatten = (obj, prefix = '', out = {})=>{
    for (const [k, v] of Object.entries(obj)){
        const key = prefix ? `${prefix}.${k}` : k;
        if (v && typeof v === 'object' && !Array.isArray(v)) $031020e651fcb248$var$flatten(v, key, out);
        else out[key] = v;
    }
    return out;
};
const $031020e651fcb248$var$STRINGS = {
    fa: $031020e651fcb248$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($caa894c6b98b0a14$exports)))),
    en: $031020e651fcb248$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($a1ddcc144227a6c8$exports)))),
    ar: $031020e651fcb248$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($c6bf782c884ec896$exports))))
};
function $031020e651fcb248$export$6d7c3320700f158(locale, key, vars) {
    const { value: value, from: from } = (0, $0de037e7a1b59dc4$export$b1f08bca8a845a15)($031020e651fcb248$var$STRINGS, locale, key);
    return value == null ? key : (0, $0de037e7a1b59dc4$export$9a328bbde6508c84)(vars ? String(value) : value, vars, from);
}
const $031020e651fcb248$export$38fa0c517e0130c2 = (key)=>Object.prototype.hasOwnProperty.call($031020e651fcb248$var$STRINGS.fa, key);
function $031020e651fcb248$export$e26de3bf29781b07() {
    const { t: t, has: has, locale: locale } = (0, $LNQP4.default)();
    return (0, $acw62.useCallback)((key, vars)=>has(key) || !$031020e651fcb248$export$38fa0c517e0130c2(key) ? t(key, vars) : $031020e651fcb248$export$6d7c3320700f158(locale, key, vars), [
        t,
        has,
        locale
    ]);
}
const $031020e651fcb248$export$32e6827a28407214 = Object.keys($031020e651fcb248$var$STRINGS);
const $031020e651fcb248$export$2c1c74f3217b84c7 = Object.keys($031020e651fcb248$var$STRINGS.fa);
const $031020e651fcb248$export$af720d721509703e = (locale)=>$031020e651fcb248$var$STRINGS[locale];


// `labelKey` rather than a label: the sidebar is chrome that has to follow the
// UI language, and this list is module-level so it cannot call a hook itself.
const $f5993d8039a8f5ea$var$NAV_ITEMS = [
    {
        // پذیرش — the clipboard-with-patient reads as an intake desk; the old
        // grid-of-squares was the generic "dashboard" glyph and no longer fits.
        id: 'reception',
        labelKey: 'nav.items.reception',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
            })
        })
    },
    {
        id: 'encounters',
        labelKey: 'nav.items.encounters',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
            })
        })
    },
    {
        // پیام‌ها — the speech bubble with a tail, the one glyph nobody has to
        // learn. `badge: 'chat'` marks this as the row that carries the live unread
        // chip (see the nav loop); no other item has a counter today.
        id: 'messages',
        labelKey: 'nav.items.messages',
        badge: 'chat',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM6 7h12v2H6zm0 4h8v2H6z"
            })
        })
    },
    {
        id: 'accounting',
        labelKey: 'nav.items.accounting',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
            })
        })
    },
    {
        // «صفحهٔ من» — the doctor's public page (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md §12).
        // Its label is app-local until the kit catalogue carries it (see `navLabel`).
        id: 'my-page',
        labelKey: 'nav.items.myPage',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3cce873667d965dd$export$2e2bcd8739ae039), {
            size: 20,
            strokeWidth: 1.8,
            "aria-hidden": true
        })
    },
    // «اعتبار هوشمند» is deliberately NOT a nav item: /credits is entered from the
    // always-visible balance chip in the doctor card below (and پذیرش/settings
    // links) — the balance needs persistent visibility, the report page does not.
    {
        id: 'profile',
        labelKey: 'nav.items.profile',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
            })
        })
    }
];
// Glyphs for the AccountCard menu. App-local, like NAV_ITEMS above: the kit owns
// the menu's shape, not its destinations, so it owns none of their icons either.
const $f5993d8039a8f5ea$var$ICON = {
    account: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
        })
    }),
    coin: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: "17",
        height: "17",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7.5v9M9.5 10h5M9.5 14h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }),
    clinic: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
        })
    }),
    // Not mirrored: the arrow points out of a door, not along the reading direction.
    logout: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
        })
    })
};
/*
 * RTL layout: sidebar is on the RIGHT side of the screen.
 * When sidebar collapses, overflow:hidden clips from the LEFT.
 * So anything that must stay visible (toggle button, icons) must be
 * anchored to the RIGHT — i.e., come FIRST in RTL flex order.
 */ const $f5993d8039a8f5ea$var$MINI = 68; // collapsed width
const $f5993d8039a8f5ea$var$FULL = 260; // expanded width
// Collapsing the sidebar is a PREFERENCE, not page state. It used to be plain
// component state, so it was reset by anything that remounted the shell — a
// reload, a token refresh, a bounce through a shell-less route — and the doctor
// had to re-collapse it every time.
//
// One page is the exception, by decision: the Visit workspace OPENS with the
// rail collapsed, because it needs every column it can get. That is a starting
// state, not a write — the doctor can expand it for this visit, the stored
// preference is never touched from there, and leaving the visit puts back
// exactly what they had chosen. The next visit opens collapsed again.
const $f5993d8039a8f5ea$var$SIDEBAR_KEY = 'parsina.sidebar.collapsed';
const $f5993d8039a8f5ea$var$isVisitPath = (pathname)=>pathname.startsWith('/visit/');
const $f5993d8039a8f5ea$var$readSidebarPref = ()=>{
    try {
        return localStorage.getItem($f5993d8039a8f5ea$var$SIDEBAR_KEY) === '1';
    } catch  {
        // Private mode / storage disabled — expanded is the safe default.
        return false;
    }
};
const $f5993d8039a8f5ea$var$writeSidebarPref = (value)=>{
    try {
        localStorage.setItem($f5993d8039a8f5ea$var$SIDEBAR_KEY, value ? '1' : '0');
    } catch  {}
};
const $f5993d8039a8f5ea$var$WebLayout = ({ children: children })=>{
    const { t: t, has: has, locale: locale, formatNumber: formatNumber } = (0, $LNQP4.default)();
    // A nav label the kit catalogue does not carry yet falls back to its app-local table.
    const navLabel = (key)=>!has(key) && (0, $031020e651fcb248$export$38fa0c517e0130c2)(key) ? (0, $031020e651fcb248$export$6d7c3320700f158)(locale, key) : t(key);
    const location = (0, $aphAM.useLocation)();
    // Lazy initialiser: read once, before the first paint, so the sidebar never
    // renders expanded and then snaps shut.
    const [preferCollapsed, setPreferCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($f5993d8039a8f5ea$var$readSidebarPref);
    // The Visit workspace's own rail state, `{ path, collapsed }`, set only when
    // the doctor toggles there. Derived rather than set by an effect, so a visit
    // never paints expanded and then snaps shut; keyed by path, so opening the
    // next patient starts collapsed again.
    const onVisit = $f5993d8039a8f5ea$var$isVisitPath(location.pathname);
    const [visitRail, setVisitRail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const collapsed = onVisit ? visitRail?.path === location.pathname ? visitRail.collapsed : true : preferCollapsed;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!onVisit) setVisitRail(null);
    }, [
        onVisit
    ]);
    const toggleCollapsed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (onVisit) {
            setVisitRail({
                path: location.pathname,
                collapsed: !collapsed
            });
            return;
        }
        setPreferCollapsed((c)=>{
            $f5993d8039a8f5ea$var$writeSidebarPref(!c);
            return !c;
        });
    }, [
        onVisit,
        location.pathname,
        collapsed
    ]);
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const balance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    // Clinic panel switch — see the button near the doctor card below.
    const { targets: clinicTargets, canSwitch: canSwitchClinic } = (0, $90c3af16928ea94c$export$f5416d3c5746c6f8)();
    // Live unread total from the app's one chat engine. Formatted and capped
    // through the SAME helper the Messages list uses, so «۹+» never means one
    // thing in the sidebar and another in the list. Empty string at zero — a
    // zero badge is a badge that should not exist.
    const unreadLabel = (0, $b5200d235eee6334$export$95dcf77aabe4f3a4)((0, $caf8273c728e960b$export$f3b3260407e19024)(), formatNumber);
    // The level from the one shared credit source, now the framework's — so the
    // doctor, dentist and clinic panels cannot disagree about what «کم» means.
    const balanceLevel = (0, $jTCZr.creditLevel)(balance);
    // Buying credit is offered only where the deployment sells it and this panel
    // has a rail for its price (hooks/useCreditPurchase.js,
    // docs/platform-money/CONTRACT.md); elsewhere nothing here offers it, and the
    // balance and the way to its history stay.
    const { canBuy: canBuyCredit } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    // /credits has no nav item (entered via the balance chip) — nothing highlights there.
    const matchedNav = $f5993d8039a8f5ea$var$NAV_ITEMS.find((item)=>location.pathname.startsWith('/' + item.id))?.id;
    const currentScreen = matchedNav || (location.pathname.startsWith('/credits') ? null : 'reception');
    // Same leave-visit guard the nav items use — the chip navigates like a nav item.
    const guardedNavigate = (id)=>{
        if (window.__parsina_visit_guard) window.__parsina_visit_guard(()=>navigate(id));
        else navigate(id);
    };
    // Leaving for the clinic panel is a navigation OUT of the app, so it goes
    // through the same leave-visit guard the nav items use — an unsaved encounter
    // must prompt here exactly as it does for a click on «پذیرش». The guard is
    // the app's one confirmation point (`window.__parsina_visit_guard`); without
    // it this button would be the single way to lose a visit silently.
    const goToClinicPanel = ()=>{
        const go = ()=>(0, $90c3af16928ea94c$export$35411b84b35a3ed4)(clinicTargets.length === 1 ? clinicTargets[0] : undefined);
        if (window.__parsina_visit_guard) window.__parsina_visit_guard(go);
        else go();
    };
    // The clinic's name only when there is exactly one — with several, naming one
    // of them would claim the switch lands there, and where it lands is the clinic
    // panel's own decision, not this app's.
    const clinicSwitchSubtitle = clinicTargets.length === 1 ? clinicTargets[0].name || '' : '';
    // Labels/text fade in/out — they live in the DOM always to keep transition smooth
    const fade = {
        opacity: collapsed ? 0 : 1,
        transition: 'opacity 0.22s ease',
        pointerEvents: collapsed ? 'none' : 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    };
    return(// Outer: RTL — sidebar (first child) appears on the RIGHT.
    // `height: 100%`, not `100vh`: the shell owns the viewport now, because the
    // connectivity bar has to sit ABOVE the sidebar and push it down rather than
    // float over it. Overlaying would cover each screen's page header — which on
    // the visit screen is the patient's name, not something to hide behind an
    // infrastructure notice.
    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            width: '100%',
            height: '100%',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "app-sidebar",
                "data-collapsed": collapsed ? 'true' : 'false',
                style: {
                    width: collapsed ? $f5993d8039a8f5ea$var$MINI : $f5993d8039a8f5ea$var$FULL,
                    flexShrink: 0,
                    background: (0, $jTCZr.GRADIENT_SIDEBAR),
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    // RTL clips from the LEFT when shrinking, so RIGHT side is always safe
                    transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            height: 68,
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            borderBottom: '1px solid rgba(255,255,255,0.07)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: $f5993d8039a8f5ea$var$MINI,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: toggleCollapsed,
                                    "data-testid": "sidebar-toggle",
                                    "aria-expanded": !collapsed,
                                    title: collapsed ? t('nav.sidebar.expand') : t('nav.sidebar.collapse'),
                                    style: {
                                        width: 36,
                                        height: 36,
                                        background: 'rgba(255,255,255,0.08)',
                                        border: 'none',
                                        borderRadius: 10,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        color: 'rgba(255,255,255,0.6)',
                                        transition: 'background 0.18s, color 0.18s'
                                    },
                                    onMouseEnter: (e)=>{
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.16)';
                                        e.currentTarget.style.color = 'white';
                                    },
                                    onMouseLeave: (e)=>{
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                                        e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        width: "18",
                                        height: "18",
                                        style: {
                                            transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)',
                                            // The glyph points at the sidebar's own edge, so it mirrors
                                            // with the layout as well as rotating with the toggle.
                                            transform: `scaleX(var(--dir-flip, 1)) rotate(${collapsed ? 0 : 180}deg)`
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    paddingInlineStart: 4,
                                    paddingInlineEnd: 8,
                                    ...fade
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (0, $33feb484f084e2c2$export$62e0383b4cfd0a36)('logoWhite'),
                                        alt: t('nav.brand.name'),
                                        style: {
                                            height: '2.4rem',
                                            width: 'auto',
                                            objectFit: 'contain',
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    color: 'white',
                                                    fontSize: 17,
                                                    fontWeight: 800,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.name')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    color: 'rgba(255,255,255,0.45)',
                                                    fontSize: 11,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.panel')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                        style: {
                            flex: 1,
                            paddingTop: 10,
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        },
                        children: $f5993d8039a8f5ea$var$NAV_ITEMS.map((item)=>{
                            const active = currentScreen === item.id;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>guardedNavigate(item.id),
                                title: collapsed ? navLabel(item.labelKey) : undefined,
                                style: {
                                    // Rounded pill inset 10px from the sidebar edges. The icon cell is
                                    // 48px, so the icon's optical center stays at 34px from the right
                                    // edge — identical in collapsed (68px) and expanded (260px) states.
                                    width: 'calc(100% - 20px)',
                                    margin: '2px 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: 0,
                                    border: 'none',
                                    borderRadius: 10,
                                    background: active ? (0, $jTCZr.C).navy : 'transparent',
                                    boxShadow: active ? '0 2px 8px rgba(0,0,0,0.22)' : 'none',
                                    cursor: 'pointer',
                                    transition: 'background 0.18s, box-shadow 0.18s',
                                    fontFamily: 'var(--app-font)'
                                },
                                onMouseEnter: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                                },
                                onMouseLeave: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'transparent';
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            width: $f5993d8039a8f5ea$var$MINI - 20,
                                            flexShrink: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '11px 0',
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)',
                                            position: 'relative'
                                        },
                                        children: [
                                            item.icon,
                                            item.badge === 'chat' && unreadLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-testid": "nav-messages-unread",
                                                "aria-label": t('messages.unreadBadge', {
                                                    count: unreadLabel
                                                }),
                                                style: {
                                                    position: 'absolute',
                                                    top: 4,
                                                    insetInlineEnd: 2,
                                                    minWidth: 16,
                                                    height: 16,
                                                    padding: '0 4px',
                                                    borderRadius: 8,
                                                    background: (0, $jTCZr.C).teal,
                                                    color: '#fff',
                                                    fontSize: 10,
                                                    fontWeight: 800,
                                                    lineHeight: '16px',
                                                    textAlign: 'center',
                                                    pointerEvents: 'none'
                                                },
                                                children: unreadLabel
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...fade,
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)',
                                            fontSize: 14,
                                            fontWeight: active ? 700 : 500
                                        },
                                        children: navLabel(item.labelKey)
                                    })
                                ]
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHxBh.default), {
                        "data-testid": "account-card",
                        collapsed: collapsed,
                        menuLabel: t('nav.account.menuLabel'),
                        user: {
                            name: doctor?.name || '...',
                            subtitle: doctor?.specialty || doctor?.email || '',
                            avatarUrl: doctor?.avatar || undefined
                        },
                        credit: balance === null ? null : {
                            // A STRING the app has already localised — the kit renders digits
                            // verbatim, exactly as it does BottomNav's badge.
                            amount: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber),
                            level: balanceLevel,
                            unit: t('common.units.coin'),
                            label: t('nav.credits.label'),
                            levelLabel: balanceLevel ? t((0, $jTCZr.CREDIT_LEVEL_META)[balanceLevel].shortLabelKey) : '',
                            onClick: ()=>guardedNavigate('credits')
                        },
                        onTopUp: canBuyCredit ? ()=>guardedNavigate('credits') : undefined,
                        topUpLabel: canBuyCredit ? t('nav.credits.topUp') : undefined,
                        items: [
                            {
                                key: 'account',
                                // The identity is not this panel's to write — one account backs
                                // every Parsina panel, so an editor here would be a second writer
                                // against the same person. A plain same-tab <a>: same realm, same
                                // Keycloak client, so the account app signs in silently.
                                label: t('nav.account.parsina'),
                                description: t('nav.account.parsinaHint'),
                                icon: $f5993d8039a8f5ea$var$ICON.account,
                                href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/'),
                                external: true,
                                'data-testid': 'sidebar-account'
                            },
                            // No «تنظیمات حساب» row: it is a visible nav destination already, and
                            // a menu copy of a row one press away in the rail is noise. What
                            // belongs here is what the nav deliberately does NOT carry —
                            // «اعتبار هوشمند» is entered from the balance card above, not from a
                            // nav item, so its top-up earns a row.
                            canBuyCredit && balance !== null && {
                                key: 'credits',
                                label: t('nav.credits.topUp'),
                                icon: $f5993d8039a8f5ea$var$ICON.coin,
                                onClick: ()=>guardedNavigate('credits')
                            },
                            canSwitchClinic && {
                                key: 'clinic',
                                label: t('nav.clinicSwitch.label'),
                                description: clinicSwitchSubtitle,
                                icon: $f5993d8039a8f5ea$var$ICON.clinic,
                                onClick: goToClinicPanel,
                                'data-testid': 'switch-to-clinic'
                            },
                            {
                                key: 'logout',
                                label: t('nav.sidebar.logout'),
                                icon: $f5993d8039a8f5ea$var$ICON.logout,
                                tone: 'destructive',
                                separatorBefore: true,
                                onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)()
                            }
                        ].filter(Boolean)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                },
                children: children
            })
        ]
    }));
};
var $f5993d8039a8f5ea$export$2e2bcd8739ae039 = $f5993d8039a8f5ea$var$WebLayout;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ggYuf = parcelRequire("ggYuf");
var $l37hw = parcelRequire("l37hw");
parcelRequire("5N0ZI");
var $iuHQQ = parcelRequire("iuHQQ");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $5f802850a966b3a8$exports = {};
$5f802850a966b3a8$exports = JSON.parse('{"dashboard":{"place":{"inShift":"\u0627\u06A9\u0646\u0648\u0646 \u062F\u0631 {{clinic}} \xb7 \u062A\u0627 {{end}}","between":"\u0634\u06CC\u0641\u062A \u0628\u0639\u062F\u06CC: {{clinic}} \xb7 {{start}}","beforeFirst":"\u0627\u0645\u0631\u0648\u0632: {{clinic}} \u0627\u0632 {{start}}","done":"\u0634\u06CC\u0641\u062A \u0627\u0645\u0631\u0648\u0632 \u062A\u0645\u0627\u0645 \u0634\u062F \xb7 {{clinic}}","overlap":"\u0647\u0645\u200C\u0632\u0645\u0627\u0646 \u062F\u0631 {{count}} \u0645\u0637\u0628","noShiftToday":"\u0628\u0631\u0627\u06CC \u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062A \u062D\u0636\u0648\u0631 \u062B\u0628\u062A \u0646\u0634\u062F\u0647","noShiftDay":"\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0631\u0648\u0632 \u0633\u0627\u0639\u062A \u062D\u0636\u0648\u0631 \u062B\u0628\u062A \u0646\u0634\u062F\u0647","noShiftHint":"\u0633\u0627\u0639\u0627\u062A \u062D\u0636\u0648\u0631 \u0631\u0627 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u062F","otherDay":"{{weekday}}: {{clinic}} {{hours}}","more":"\u0648 {{count}} \u0645\u0637\u0628 \u062F\u06CC\u06AF\u0631","aria":"\u0645\u062D\u0644 \u06A9\u0627\u0631 \u0637\u0628\u0642 \u0628\u0631\u0646\u0627\u0645\u0647\u0654 \u062D\u0636\u0648\u0631"},"stats":{"total":"\u0646\u0648\u0628\u062A","waiting":"\u0645\u0646\u062A\u0638\u0631","completed":"\u0627\u0646\u062C\u0627\u0645","cancelled":"\u0644\u063A\u0648","aria":"{{total}} \u0646\u0648\u0628\u062A\u060C {{waiting}} \u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631\u060C {{completed}} \u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647\u060C {{cancelled}} \u0644\u063A\u0648\u200C\u0634\u062F\u0647","share":"\u0633\u0647\u0645: {{amount}}","shareNoFigure":"\u0633\u0647\u0645"},"week":{"title":"\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632","thisWeek":"\u0627\u06CC\u0646 \u0647\u0641\u062A\u0647","nextWeek":"\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F","prevWeek":"\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644","range":"{{from}} \u062A\u0627 {{to}}","fullCalendar":"\u062A\u0642\u0648\u06CC\u0645 \u06A9\u0627\u0645\u0644","backToWeek":"\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0647\u0641\u062A\u0647","countAria":"{{count}} \u0646\u0648\u0628\u062A"},"clinic":{"auto":"\u062E\u0648\u062F\u06A9\u0627\u0631 \u2014 \u0637\u0628\u0642 \u0628\u0631\u0646\u0627\u0645\u0647\u0654 \u062D\u0636\u0648\u0631","autoSub":"\u0645\u0637\u0628\u06CC \u06A9\u0647 \u0628\u0631\u0646\u0627\u0645\u0647\u0654 \u062D\u0636\u0648\u0631 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0631\u0648\u0632 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u062F","autoBadge":"\u062E\u0648\u062F\u06A9\u0627\u0631"},"book":{"open":"\u0646\u0648\u0628\u062A \u062C\u062F\u06CC\u062F","title":"\u062B\u0628\u062A \u0646\u0648\u0628\u062A","clinic":"\u06A9\u0644\u06CC\u0646\u06CC\u06A9","patient":"\u0628\u06CC\u0645\u0627\u0631","searchLabel":"\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0628\u06CC\u0645\u0627\u0631","searchPlaceholder":"\u0646\u0627\u0645\u060C \u0634\u0645\u0627\u0631\u0647 \u062A\u0645\u0627\u0633 \u06CC\u0627 \u06A9\u062F \u0645\u0644\u06CC","searchHint":"\u062F\u0633\u062A\u200C\u06A9\u0645 \u062F\u0648 \u062D\u0631\u0641 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","noMatch":"\u0628\u06CC\u0645\u0627\u0631\u06CC \u0628\u0627 \u0627\u06CC\u0646 \u0645\u0634\u062E\u0635\u0627\u062A \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0634\u0645\u0627 \u0646\u06CC\u0633\u062A.","truncated":"\u0641\u0642\u0637 {{count}} \u0646\u062A\u06CC\u062C\u0647\u0654 \u0646\u062E\u0633\u062A \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0634\u062F\u061B \u062F\u0642\u06CC\u0642\u200C\u062A\u0631 \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u06A9\u0646\u06CC\u062F.","newPatient":"\u0628\u06CC\u0645\u0627\u0631 \u062C\u062F\u06CC\u062F","pickExisting":"\u0627\u0646\u062A\u062E\u0627\u0628 \u0627\u0632 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646","change":"\u062A\u063A\u06CC\u06CC\u0631","name":"\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC","phone":"\u0634\u0645\u0627\u0631\u0647 \u0647\u0645\u0631\u0627\u0647","nationalId":"\u06A9\u062F \u0645\u0644\u06CC (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","when":"\u062A\u0627\u0631\u06CC\u062E \u0648 \u0633\u0627\u0639\u062A","duration":"\u0645\u062F\u062A \u0646\u0648\u0628\u062A","minutes":"{{count}} \u062F\u0642\u06CC\u0642\u0647","note":"\u06CC\u0627\u062F\u062F\u0627\u0634\u062A (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","submit":"\u062B\u0628\u062A \u0646\u0648\u0628\u062A","submitRequest":"\u0627\u0631\u0633\u0627\u0644 \u0628\u0631\u0627\u06CC \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9","needsApprovalTitle":"\u0646\u06CC\u0627\u0632\u0645\u0646\u062F \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9","needsApproval":"\u0646\u0648\u0628\u062A\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F \u067E\u0633 \u0627\u0632 \u062A\u0623\u06CC\u06CC\u062F \u067E\u0630\u06CC\u0631\u0634 \u0646\u0647\u0627\u06CC\u06CC \u0645\u06CC\u200C\u0634\u0648\u0646\u062F \u0648 \u062A\u0627 \u0622\u0646 \u0632\u0645\u0627\u0646 \xab\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9\xbb \u0645\u06CC\u200C\u0645\u0627\u0646\u0646\u062F.","booked":"\u0646\u0648\u0628\u062A \u062B\u0628\u062A \u0634\u062F.","requested":"\u0646\u0648\u0628\u062A \u0628\u0631\u0627\u06CC \u062A\u0623\u06CC\u06CC\u062F \u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0627\u0631\u0633\u0627\u0644 \u0634\u062F.","loadFailed":"\u0641\u0647\u0631\u0633\u062A \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u200C\u0647\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.","noClinic":"\u062F\u0631 \u062D\u0627\u0644 \u062D\u0627\u0636\u0631 \u062F\u0631 \u0647\u06CC\u0686 \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u06CC \u0627\u0645\u06A9\u0627\u0646 \u062B\u0628\u062A \u0646\u0648\u0628\u062A \u0646\u062F\u0627\u0631\u06CC\u062F.","searchFailed":"\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0628\u06CC\u0645\u0627\u0631 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.","modeFirstDay":"\u0627\u0648\u0644\u06CC\u0646 \u0646\u0648\u0628\u062A \u0627\u06CC\u0646 \u0631\u0648\u0632","modeFirstToday":"\u0627\u0648\u0644\u06CC\u0646 \u0646\u0648\u0628\u062A \u0627\u0645\u0631\u0648\u0632","modeManual":"\u0627\u0646\u062A\u062E\u0627\u0628 \u062F\u0633\u062A\u06CC","showTimeOptions":"\u062A\u063A\u06CC\u06CC\u0631 \u0631\u0648\u0632 \u06CC\u0627 \u0631\u0648\u0634 \u0627\u0646\u062A\u062E\u0627\u0628 \u0632\u0645\u0627\u0646","hideTimeOptions":"\u0628\u0633\u062A\u0646 \u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u06CC \u0632\u0645\u0627\u0646","noneLeftToday":"\u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u062F\u06CC\u06AF\u0631\u06CC \u0628\u0631\u0627\u06CC \u0627\u0645\u0631\u0648\u0632 \u0628\u0627\u0642\u06CC \u0646\u0645\u0627\u0646\u062F\u0647 \u0627\u0633\u062A.","finding":"\u062F\u0631 \u062D\u0627\u0644 \u06CC\u0627\u0641\u062A\u0646 \u0646\u0632\u062F\u06CC\u06A9\u200C\u062A\u0631\u06CC\u0646 \u0646\u0648\u0628\u062A\u2026","bookThisOne":"\u0647\u0645\u06CC\u0646 \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646","firstFree":"\u0627\u0648\u0644\u06CC\u0646 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC","exactAtBooking":"\u0646\u0648\u0628\u062A \u062F\u0642\u06CC\u0642 \u0647\u0646\u06AF\u0627\u0645 \u062B\u0628\u062A \u0646\u0647\u0627\u06CC\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F.","firstSlotFailed":"\u06CC\u0627\u0641\u062A\u0646 \u0627\u0648\u0644\u06CC\u0646 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u0628\u0627 \u062E\u0637\u0627 \u0645\u0648\u0627\u062C\u0647 \u0634\u062F. \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u0632\u0645\u0627\u0646 \u0631\u0627 \u062F\u0633\u062A\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","lessOptions":"\u0628\u0633\u062A\u0646 \u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u06CC \u0628\u06CC\u0634\u062A\u0631","typeInPerson":"\u062D\u0636\u0648\u0631\u06CC","typeOnline":"\u063A\u06CC\u0631\u062D\u0636\u0648\u0631\u06CC","submitFirst":"\u062B\u0628\u062A \u0627\u0648\u0644\u06CC\u0646 \u0646\u0648\u0628\u062A","walkIn":"\u062E\u0627\u0631\u062C \u0627\u0632 \u0646\u0648\u0628\u062A \u0647\u0645\u06CC\u0646 \u0627\u0644\u0627\u0646","walkInOff":"\u0628\u06CC\u0645\u0627\u0631 \u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627 \u062D\u0627\u0636\u0631 \u0627\u0633\u062A\u061B \u0628\u062F\u0648\u0646 \u0633\u0627\u0639\u062A \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0634\u0645\u0627 \u0627\u0636\u0627\u0641\u0647 \u0634\u0648\u062F.","walkInOn":"\u0628\u062F\u0648\u0646 \u0633\u0627\u0639\u062A \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0628\u06CC\u0645\u0627\u0631 \u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627 \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0634\u0645\u0627 \u0627\u0636\u0627\u0641\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","walkInOnShort":"\u0628\u062F\u0648\u0646 \u0633\u0627\u0639\u062A\u061B \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0627\u0636\u0627\u0641\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.","walkInLead":"\u0627\u0645\u0631\u0648\u0632 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F\u061B \u0628\u06CC\u0645\u0627\u0631 \u0628\u062F\u0648\u0646 \u0633\u0627\u0639\u062A\u060C \u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627 \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0634\u0645\u0627 \u0627\u0636\u0627\u0641\u0647 \u0634\u0648\u062F.","walkInLeadShort":"\u0628\u062F\u0648\u0646 \u0633\u0627\u0639\u062A\u060C \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632.","walkInNoGrant":"\u062F\u0631 \u0627\u06CC\u0646 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0646\u0648\u0628\u062A\u200C\u0647\u0627\u06CC \u0634\u0645\u0627 \u0628\u0627 \u062A\u0623\u06CC\u06CC\u062F \u067E\u0630\u06CC\u0631\u0634 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u06CC\u0645\u0627\u0631 \u062D\u0627\u0636\u0631 \u0631\u0627 \u067E\u0630\u06CC\u0631\u0634 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062E\u0627\u0631\u062C \u0627\u0632 \u0646\u0648\u0628\u062A \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u062F.","walkInNoGrantShort":"\u062F\u0631 \u0627\u06CC\u0646 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0641\u0642\u0637 \u067E\u0630\u06CC\u0631\u0634 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u062E\u0627\u0631\u062C \u0627\u0632 \u0646\u0648\u0628\u062A \u062B\u0628\u062A \u06A9\u0646\u062F.","alreadyOpen":{"scheduled":"\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0627\u0645\u0631\u0648\u0632 \u0646\u0648\u0628\u062A \u062F\u06CC\u06AF\u0631\u06CC \u0647\u0645 \u062F\u0627\u0631\u062F \u06A9\u0647 \u0647\u0646\u0648\u0632 \u0646\u06CC\u0627\u0645\u062F\u0647 \u0627\u0633\u062A.","arrived":"\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627 \u062F\u0631 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0627\u0633\u062A\u061B \u0646\u0648\u0628\u062A \u062F\u0648\u0645 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A\u061F","in_visit":"\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627 \u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A \u0627\u0633\u062A\u061B \u0646\u0648\u0628\u062A \u062F\u0648\u0645 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A\u061F"},"submitWalkIn":"\u062B\u0628\u062A \u0648 \u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0635\u0641","walkInBooked":"\u0628\u06CC\u0645\u0627\u0631 \u0628\u0647 \u0635\u0641 \u0627\u0645\u0631\u0648\u0632 \u0627\u0636\u0627\u0641\u0647 \u0634\u062F.","mode":"\u0631\u0648\u0634 \u0627\u0646\u062A\u062E\u0627\u0628 \u0632\u0645\u0627\u0646","day":"\u0631\u0648\u0632","visitType":"\u0646\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A","moreOptions":"\u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u06CC \u0628\u06CC\u0634\u062A\u0631 (\u0646\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A\u060C \u0645\u062F\u062A\u060C \u06CC\u0627\u062F\u062F\u0627\u0634\u062A)","noneThisDay":"\u062F\u0631 \u0627\u06CC\u0646 \u0631\u0648\u0632 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F.","nextIs":"\u0646\u0632\u062F\u06CC\u06A9\u200C\u062A\u0631\u06CC\u0646 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u0634\u0645\u0627:","noneIn30Days":"\u062F\u0631 \u06F3\u06F0 \u0631\u0648\u0632 \u0622\u06CC\u0646\u062F\u0647 \u0647\u0645 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.","slotAt":"{{date}}\u060C \u0633\u0627\u0639\u062A {{time}}","errors":{"clinic":"\u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","patient":"\u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","name":"\u0646\u0627\u0645 \u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","phone":"\u0634\u0645\u0627\u0631\u0647\u0654 \u0647\u0645\u0631\u0627\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.","nationalId":"\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.","when":"\u062A\u0627\u0631\u06CC\u062E \u0648 \u0633\u0627\u0639\u062A \u0646\u0648\u0628\u062A \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","past":"\u0627\u06CC\u0646 \u0632\u0645\u0627\u0646 \u06AF\u0630\u0634\u062A\u0647 \u0627\u0633\u062A.","noSlot":"\u062F\u0631 \u0627\u06CC\u0646 \u0631\u0648\u0632 \u0646\u0648\u0628\u062A \u062E\u0627\u0644\u06CC \u0646\u06CC\u0633\u062A\u061B \u0631\u0648\u0632 \u062F\u06CC\u06AF\u0631\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0632\u0645\u0627\u0646 \u0631\u0627 \u062F\u0633\u062A\u06CC \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F."}},"withdraw":{"action":"\u0644\u063A\u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A","title":"\u0644\u063A\u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0646\u0648\u0628\u062A","message":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0646\u0648\u0628\u062A {{name}} \u0644\u063A\u0648 \u0634\u0648\u062F\u061F \u0627\u06CC\u0646 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F.","confirm":"\u0644\u063A\u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A","keep":"\u0627\u0646\u0635\u0631\u0627\u0641","failed":"\u0644\u063A\u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F."},"reschedule":{"action":"\u062A\u063A\u06CC\u06CC\u0631 \u0632\u0645\u0627\u0646","title":"\u062A\u063A\u06CC\u06CC\u0631 \u0632\u0645\u0627\u0646 \u0646\u0648\u0628\u062A","current":"\u0632\u0645\u0627\u0646 \u0641\u0639\u0644\u06CC: {{when}}","newTime":"\u0632\u0645\u0627\u0646 \u062C\u062F\u06CC\u062F","hint":"\u0646\u0648\u0628\u062A \u062C\u0627\u0628\u0647\u200C\u062C\u0627 \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0644\u063A\u0648 \u0648 \u062F\u0648\u0628\u0627\u0631\u0647 \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u060C \u067E\u0633 \u0641\u0627\u06A9\u062A\u0648\u0631 \u0648 \u067E\u0631\u062F\u0627\u062E\u062A \u0622\u0646 \u0633\u0631 \u062C\u0627\u06CC \u062E\u0648\u062F \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.","submit":"\u062B\u0628\u062A \u0632\u0645\u0627\u0646 \u062C\u062F\u06CC\u062F","moved":"\u0646\u0648\u0628\u062A \u0628\u0647 {{when}} \u0645\u0646\u062A\u0642\u0644 \u0634\u062F."}},"nav":{"mobile":{"more":"\u0628\u06CC\u0634\u062A\u0631","moreTitle":"\u0628\u06CC\u0634\u062A\u0631","account":"\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC","sections":"\u0628\u062E\u0634\u200C\u0647\u0627","balance":"\u0645\u0648\u062C\u0648\u062F\u06CC {{coin}}"}}}');


var $538a6411aec4bbca$exports = {};
$538a6411aec4bbca$exports = JSON.parse('{"dashboard":{"place":{"inShift":"Now at {{clinic}} \xb7 until {{end}}","between":"Next shift: {{clinic}} \xb7 {{start}}","beforeFirst":"Today: {{clinic}} from {{start}}","done":"Today\'s shift is over \xb7 {{clinic}}","overlap":"Scheduled at {{count}} practices at once","noShiftToday":"No hours registered for today","noShiftDay":"No hours registered for this day","noShiftHint":"Your practice registers your hours","otherDay":"{{weekday}}: {{clinic}} {{hours}}","more":"and {{count}} more","aria":"Where your schedule puts you"},"stats":{"total":"booked","waiting":"waiting","completed":"seen","cancelled":"cancelled","aria":"{{total}} booked, {{waiting}} waiting, {{completed}} seen, {{cancelled}} cancelled","share":"Share: {{amount}}","shareNoFigure":"Share"},"week":{"title":"Pick a day","thisWeek":"This week","nextWeek":"Next week","prevWeek":"Last week","range":"{{from}} \u2013 {{to}}","fullCalendar":"Full calendar","backToWeek":"Back to the week","countAria":"{{count}} appointments"},"clinic":{"auto":"Automatic \u2014 follow my schedule","autoSub":"The practice your schedule names for this day","autoBadge":"Auto"},"book":{"open":"New appointment","title":"Book an appointment","clinic":"Clinic","patient":"Patient","searchLabel":"Find a patient","searchPlaceholder":"Name, phone or national ID","searchHint":"Type at least two characters.","noMatch":"No patient on your list matches this.","truncated":"Showing the first {{count}} results; narrow the search.","newPatient":"New patient","pickExisting":"Choose from patients","change":"Change","name":"Full name","phone":"Mobile number","nationalId":"National ID (optional)","when":"Date and time","duration":"Length","minutes":"{{count}} min","note":"Note (optional)","submit":"Book appointment","submitRequest":"Send for clinic approval","needsApprovalTitle":"Needs clinic approval","needsApproval":"Appointments you book at this clinic are final only once reception confirms them; until then they stay \u201Cawaiting clinic confirmation\u201D.","booked":"Appointment booked.","requested":"Appointment sent to the clinic for approval.","loadFailed":"Could not load your clinics.","noClinic":"You cannot book at any clinic right now.","searchFailed":"Patient search failed.","modeFirstDay":"First slot this day","modeFirstToday":"First slot today","modeManual":"Pick a time","showTimeOptions":"Change the day or how the time is picked","hideTimeOptions":"Hide time options","noneLeftToday":"There are no free slots left today.","finding":"Finding the next free slot\u2026","bookThisOne":"Book it","firstFree":"First free slot","exactAtBooking":"The exact time is settled when you book.","firstSlotFailed":"The next free slot could not be found. You can pick a time yourself.","lessOptions":"Hide more options","typeInPerson":"In person","typeOnline":"Remote","submitFirst":"Book the first appointment","walkIn":"Walk-in, right now","walkInOff":"The patient is here now; add them to today\u2019s queue without a time.","walkInOn":"Booked without a time; the patient joins today\u2019s queue now.","walkInOnShort":"No time; joins today\u2019s queue.","walkInLead":"No free slots left today; add the patient to today\u2019s queue now, without a time.","walkInLeadShort":"No time, today\u2019s queue.","walkInNoGrant":"At this clinic your bookings wait for reception; a patient who is already here is added by the clinic\u2019s reception.","walkInNoGrantShort":"At this clinic only reception can add a walk-in.","alreadyOpen":{"scheduled":"This patient already has another appointment today that has not arrived yet.","arrived":"This patient is already in today\'s queue \u2014 is a second appointment needed?","in_visit":"This patient is in a visit right now \u2014 is a second appointment needed?"},"submitWalkIn":"Book and add to queue","walkInBooked":"Patient added to today\u2019s queue.","mode":"How to pick the time","day":"Day","visitType":"Visit type","moreOptions":"More options (visit type, length, note)","noneThisDay":"You have no free slot on this day.","nextIs":"Your next free slot:","noneIn30Days":"No free slot was found in the next 30 days either.","slotAt":"{{date}}, {{time}}","errors":{"clinic":"Choose a clinic.","patient":"Choose a patient.","name":"Enter the patient\u2019s name.","phone":"This mobile number is not valid.","nationalId":"This national ID is not valid.","when":"Enter the date and time.","past":"This time has already passed.","noSlot":"No free slot on this day; pick another day or enter the time yourself."}},"withdraw":{"action":"Withdraw request","title":"Withdraw appointment request","message":"Withdraw the appointment request for {{name}}? It will be removed from the clinic\u2019s list.","confirm":"Withdraw request","keep":"Cancel","failed":"Could not withdraw the request."},"reschedule":{"action":"Change time","title":"Change appointment time","current":"Current time: {{when}}","newTime":"New time","hint":"The appointment is moved, not cancelled and booked again, so its invoice and payment stay as they are.","submit":"Save new time","moved":"The appointment was moved to {{when}}."}},"nav":{"mobile":{"more":"More","moreTitle":"More","account":"Account","sections":"Sections","balance":"{{coin}} balance"}}}');


var $660f48ed324a71f9$exports = {};
$660f48ed324a71f9$exports = JSON.parse('{"dashboard":{"place":{"inShift":"\u0627\u0644\u0622\u0646 \u0641\u064A {{clinic}} \xb7 \u062D\u062A\u0649 {{end}}","between":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629: {{clinic}} \xb7 {{start}}","beforeFirst":"\u0627\u0644\u064A\u0648\u0645: {{clinic}} \u0645\u0646 {{start}}","done":"\u0627\u0646\u062A\u0647\u062A \u0645\u0646\u0627\u0648\u0628\u0629 \u0627\u0644\u064A\u0648\u0645 \xb7 {{clinic}}","overlap":"\u0645\u062C\u062F\u0648\u0644 \u0641\u064A {{count}} \u0639\u064A\u0627\u062F\u0627\u062A \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0646\u0641\u0633\u0647","noShiftToday":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0633\u0627\u0639\u0627\u062A \u062D\u0636\u0648\u0631 \u0645\u0633\u062C\u0644\u0629 \u0644\u0644\u064A\u0648\u0645","noShiftDay":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0633\u0627\u0639\u0627\u062A \u062D\u0636\u0648\u0631 \u0645\u0633\u062C\u0644\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u064A\u0648\u0645","noShiftHint":"\u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0647\u064A \u0627\u0644\u062A\u064A \u062A\u0633\u062C\u0644 \u0633\u0627\u0639\u0627\u062A \u062D\u0636\u0648\u0631\u0643","otherDay":"{{weekday}}: {{clinic}} {{hours}}","more":"\u0648{{count}} \u0623\u062E\u0631\u0649","aria":"\u0645\u0643\u0627\u0646 \u0639\u0645\u0644\u0643 \u062D\u0633\u0628 \u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u0636\u0648\u0631"},"stats":{"total":"\u0645\u0648\u0639\u062F","waiting":"\u0628\u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","completed":"\u062A\u0645\u062A","cancelled":"\u0645\u0644\u063A\u0649","aria":"{{total}} \u0645\u0648\u0639\u062F\u060C {{waiting}} \u0628\u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631\u060C {{completed}} \u062A\u0645\u062A \u0645\u0639\u0627\u064A\u0646\u062A\u0647\u0645\u060C {{cancelled}} \u0645\u0644\u063A\u0649","share":"\u0627\u0644\u062D\u0635\u0629: {{amount}}","shareNoFigure":"\u0627\u0644\u062D\u0635\u0629"},"week":{"title":"\u0627\u062E\u062A\u0631 \u064A\u0648\u0645\u064B\u0627","thisWeek":"\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639","nextWeek":"\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0645","prevWeek":"\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0645\u0627\u0636\u064A","range":"{{from}} \u2013 {{to}}","fullCalendar":"\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644","backToWeek":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0628\u0648\u0639","countAria":"{{count}} \u0645\u0648\u0627\u0639\u064A\u062F"},"clinic":{"auto":"\u062A\u0644\u0642\u0627\u0626\u064A \u2014 \u062D\u0633\u0628 \u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u0636\u0648\u0631","autoSub":"\u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0627\u0644\u062A\u064A \u064A\u062D\u062F\u062F\u0647\u0627 \u062C\u062F\u0648\u0644\u0643 \u0644\u0647\u0630\u0627 \u0627\u0644\u064A\u0648\u0645","autoBadge":"\u062A\u0644\u0642\u0627\u0626\u064A"},"book":{"open":"\u0645\u0648\u0639\u062F \u062C\u062F\u064A\u062F","title":"\u062D\u062C\u0632 \u0645\u0648\u0639\u062F","clinic":"\u0627\u0644\u0639\u064A\u0627\u062F\u0629","patient":"\u0627\u0644\u0645\u0631\u064A\u0636","searchLabel":"\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0645\u0631\u064A\u0636","searchPlaceholder":"\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0623\u0648 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A","searchHint":"\u0623\u062F\u062E\u0644 \u062D\u0631\u0641\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.","noMatch":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0631\u064A\u0636 \u0645\u0637\u0627\u0628\u0642 \u0641\u064A \u0642\u0627\u0626\u0645\u062A\u0643.","truncated":"\u062A\u064F\u0639\u0631\u0636 \u0623\u0648\u0644 {{count}} \u0646\u062A\u064A\u062C\u0629 \u0641\u0642\u0637\u061B \u0636\u064A\u0651\u0642 \u0627\u0644\u0628\u062D\u062B.","newPatient":"\u0645\u0631\u064A\u0636 \u062C\u062F\u064A\u062F","pickExisting":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646 \u0627\u0644\u0645\u0631\u0636\u0649","change":"\u062A\u063A\u064A\u064A\u0631","name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644","phone":"\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644","nationalId":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","when":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A","duration":"\u0645\u062F\u0629 \u0627\u0644\u0645\u0648\u0639\u062F","minutes":"{{count}} \u062F\u0642\u064A\u0642\u0629","note":"\u0645\u0644\u0627\u062D\u0638\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","submit":"\u062D\u062C\u0632 \u0627\u0644\u0645\u0648\u0639\u062F","submitRequest":"\u0625\u0631\u0633\u0627\u0644 \u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0629","needsApprovalTitle":"\u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0629","needsApproval":"\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u062A\u064A \u062A\u062D\u062C\u0632\u0647\u0627 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0644\u0627 \u062A\u0635\u0628\u062D \u0646\u0647\u0627\u0626\u064A\u0629 \u0625\u0644\u0627 \u0628\u0639\u062F \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0642\u0628\u0627\u0644\u060C \u0648\u062A\u0628\u0642\u0649 \u062D\u062A\u0649 \u0630\u0644\u0643 \u0627\u0644\u062D\u064A\u0646 \xab\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0639\u064A\u0627\u062F\u0629\xbb.","booked":"\u062A\u0645 \u062D\u062C\u0632 \u0627\u0644\u0645\u0648\u0639\u062F.","requested":"\u0623\u064F\u0631\u0633\u0644 \u0627\u0644\u0645\u0648\u0639\u062F \u0625\u0644\u0649 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0644\u0644\u0645\u0648\u0627\u0641\u0642\u0629.","loadFailed":"\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A.","noClinic":"\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u062D\u062C\u0632 \u0645\u0648\u0627\u0639\u064A\u062F \u0641\u064A \u0623\u064A \u0639\u064A\u0627\u062F\u0629 \u062D\u0627\u0644\u064A\u064B\u0627.","searchFailed":"\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0645\u0631\u064A\u0636.","modeFirstDay":"\u0623\u0648\u0644 \u0645\u0648\u0639\u062F \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u064A\u0648\u0645","modeFirstToday":"\u0623\u0648\u0644 \u0645\u0648\u0639\u062F \u0627\u0644\u064A\u0648\u0645","modeManual":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0648\u0642\u062A","showTimeOptions":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u064A\u0648\u0645 \u0623\u0648 \u0637\u0631\u064A\u0642\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0648\u0642\u062A","hideTimeOptions":"\u0625\u062E\u0641\u0627\u0621 \u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0642\u062A","noneLeftToday":"\u0644\u0645 \u062A\u0639\u062F \u0647\u0646\u0627\u0643 \u0645\u0648\u0627\u0639\u064A\u062F \u0634\u0627\u063A\u0631\u0629 \u0627\u0644\u064A\u0648\u0645.","finding":"\u062C\u0627\u0631\u064D \u0625\u064A\u062C\u0627\u062F \u0623\u0642\u0631\u0628 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631\u2026","bookThisOne":"\u0627\u062D\u062C\u0632\u0647","firstFree":"\u0623\u0648\u0644 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631","exactAtBooking":"\u064A\u062A\u062D\u062F\u064E\u0651\u062F \u0627\u0644\u0648\u0642\u062A \u0628\u062F\u0642\u0629 \u0639\u0646\u062F \u0627\u0644\u062D\u062C\u0632.","firstSlotFailed":"\u062A\u0639\u0630\u0651\u0631 \u0625\u064A\u062C\u0627\u062F \u0623\u0642\u0631\u0628 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631. \u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0648\u0642\u062A \u0628\u0646\u0641\u0633\u0643.","lessOptions":"\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629","typeInPerson":"\u062D\u0636\u0648\u0631\u064A","typeOnline":"\u0639\u0646 \u0628\u064F\u0639\u062F","submitFirst":"\u062D\u062C\u0632 \u0623\u0648\u0644 \u0645\u0648\u0639\u062F","walkIn":"\u062E\u0627\u0631\u062C \u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0622\u0646","walkInOff":"\u0627\u0644\u0645\u0631\u064A\u0636 \u062D\u0627\u0636\u0631 \u0627\u0644\u0622\u0646\u061B \u064A\u064F\u0636\u0627\u0641 \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645 \u062F\u0648\u0646 \u062A\u062D\u062F\u064A\u062F \u0648\u0642\u062A.","walkInOn":"\u064A\u064F\u0633\u062C\u064E\u0651\u0644 \u062F\u0648\u0646 \u0648\u0642\u062A \u0648\u064A\u064F\u0636\u0627\u0641 \u0627\u0644\u0645\u0631\u064A\u0636 \u0627\u0644\u0622\u0646 \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645.","walkInOnShort":"\u062F\u0648\u0646 \u0648\u0642\u062A\u061B \u064A\u064F\u0636\u0627\u0641 \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645.","walkInLead":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0648\u0627\u0639\u064A\u062F \u0634\u0627\u063A\u0631\u0629 \u0627\u0644\u064A\u0648\u0645\u061B \u0623\u0636\u0641 \u0627\u0644\u0645\u0631\u064A\u0636 \u0627\u0644\u0622\u0646 \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645 \u062F\u0648\u0646 \u0648\u0642\u062A.","walkInLeadShort":"\u062F\u0648\u0646 \u0648\u0642\u062A\u060C \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645.","walkInNoGrant":"\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u062A\u0646\u062A\u0638\u0631 \u062D\u062C\u0648\u0632\u0627\u062A\u0643 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0642\u0628\u0627\u0644\u061B \u0627\u0644\u0645\u0631\u064A\u0636 \u0627\u0644\u062D\u0627\u0636\u0631 \u064A\u0633\u062C\u0651\u0644\u0647 \u0627\u0633\u062A\u0642\u0628\u0627\u0644 \u0627\u0644\u0639\u064A\u0627\u062F\u0629.","walkInNoGrantShort":"\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0639\u064A\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u0642\u0628\u0627\u0644 \u0641\u0642\u0637 \u064A\u0633\u062C\u0651\u0644 \u062E\u0627\u0631\u062C \u0627\u0644\u062F\u0648\u0631.","alreadyOpen":{"scheduled":"\u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0631\u064A\u0636 \u0645\u0648\u0639\u062F \u0622\u062E\u0631 \u0627\u0644\u064A\u0648\u0645 \u0644\u0645 \u064A\u062D\u0636\u0631 \u0628\u0639\u062F.","arrived":"\u0647\u0630\u0627 \u0627\u0644\u0645\u0631\u064A\u0636 \u0641\u064A \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0622\u0646 \u2014 \u0647\u0644 \u064A\u0644\u0632\u0645 \u0645\u0648\u0639\u062F \u062B\u0627\u0646\u064D\u061F","in_visit":"\u0647\u0630\u0627 \u0627\u0644\u0645\u0631\u064A\u0636 \u0641\u064A \u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0622\u0646 \u2014 \u0647\u0644 \u064A\u0644\u0632\u0645 \u0645\u0648\u0639\u062F \u062B\u0627\u0646\u064D\u061F"},"submitWalkIn":"\u062A\u0633\u062C\u064A\u0644 \u0648\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u062F\u0648\u0631","walkInBooked":"\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0631\u064A\u0636 \u0625\u0644\u0649 \u062F\u0648\u0631 \u0627\u0644\u064A\u0648\u0645.","mode":"\u0637\u0631\u064A\u0642\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0648\u0642\u062A","day":"\u0627\u0644\u064A\u0648\u0645","visitType":"\u0646\u0648\u0639 \u0627\u0644\u0632\u064A\u0627\u0631\u0629","moreOptions":"\u062E\u064A\u0627\u0631\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629 (\u0646\u0648\u0639 \u0627\u0644\u0632\u064A\u0627\u0631\u0629\u060C \u0627\u0644\u0645\u062F\u0629\u060C \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629)","noneThisDay":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0644\u062F\u064A\u0643 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u064A\u0648\u0645.","nextIs":"\u0623\u0642\u0631\u0628 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631 \u0644\u062F\u064A\u0643:","noneIn30Days":"\u0644\u0645 \u064A\u064F\u0639\u062B\u0631 \u0639\u0644\u0649 \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631 \u0641\u064A \u0627\u0644\u062B\u0644\u0627\u062B\u064A\u0646 \u064A\u0648\u0645\u064B\u0627 \u0627\u0644\u0642\u0627\u062F\u0645\u0629 \u0623\u064A\u0636\u064B\u0627.","slotAt":"{{date}}\u060C \u0627\u0644\u0633\u0627\u0639\u0629 {{time}}","errors":{"clinic":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0639\u064A\u0627\u062F\u0629.","patient":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0631\u064A\u0636.","name":"\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u064A\u0636.","phone":"\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.","nationalId":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D.","when":"\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0648\u0639\u062F \u0648\u0648\u0642\u062A\u0647.","past":"\u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062A \u0642\u062F \u0645\u0636\u0649.","noSlot":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0648\u0639\u062F \u0634\u0627\u063A\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u064A\u0648\u0645\u061B \u0627\u062E\u062A\u0631 \u064A\u0648\u0645\u064B\u0627 \u0622\u062E\u0631 \u0623\u0648 \u0623\u062F\u062E\u0644 \u0627\u0644\u0648\u0642\u062A \u064A\u062F\u0648\u064A\u064B\u0627."}},"withdraw":{"action":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628","title":"\u0625\u0644\u063A\u0627\u0621 \u0637\u0644\u0628 \u0627\u0644\u0645\u0648\u0639\u062F","message":"\u0647\u0644 \u062A\u0631\u064A\u062F \u0625\u0644\u063A\u0627\u0621 \u0637\u0644\u0628 \u0645\u0648\u0639\u062F {{name}}\u061F \u0633\u064A\u064F\u062D\u0630\u0641 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0629.","confirm":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628","keep":"\u062A\u0631\u0627\u062C\u0639","failed":"\u062A\u0639\u0630\u0651\u0631 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628."},"reschedule":{"action":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0648\u0642\u062A","title":"\u062A\u063A\u064A\u064A\u0631 \u0648\u0642\u062A \u0627\u0644\u0645\u0648\u0639\u062F","current":"\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A: {{when}}","newTime":"\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062C\u062F\u064A\u062F","hint":"\u064A\u064F\u0646\u0642\u0644 \u0627\u0644\u0645\u0648\u0639\u062F \u0648\u0644\u0627 \u064A\u064F\u0644\u063A\u0649 \u062B\u0645 \u064A\u064F\u062D\u062C\u0632 \u0645\u0646 \u062C\u062F\u064A\u062F\u060C \u0641\u062A\u0628\u0642\u0649 \u0641\u0627\u062A\u0648\u0631\u062A\u0647 \u0648\u062F\u0641\u0639\u062A\u0647 \u0643\u0645\u0627 \u0647\u064A.","submit":"\u062D\u0641\u0638 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062C\u062F\u064A\u062F","moved":"\u0646\u064F\u0642\u0644 \u0627\u0644\u0645\u0648\u0639\u062F \u0625\u0644\u0649 {{when}}."}},"nav":{"mobile":{"more":"\u0627\u0644\u0645\u0632\u064A\u062F","moreTitle":"\u0627\u0644\u0645\u0632\u064A\u062F","account":"\u0627\u0644\u062D\u0633\u0627\u0628","sections":"\u0627\u0644\u0623\u0642\u0633\u0627\u0645","balance":"\u0631\u0635\u064A\u062F {{coin}}"}}}');


const $7fe332a380bf5371$var$flatten = (obj, prefix = '', out = {})=>{
    for (const [k, v] of Object.entries(obj)){
        const key = prefix ? `${prefix}.${k}` : k;
        if (v && typeof v === 'object') $7fe332a380bf5371$var$flatten(v, key, out);
        else out[key] = v;
    }
    return out;
};
const $7fe332a380bf5371$var$STRINGS = {
    fa: $7fe332a380bf5371$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($5f802850a966b3a8$exports)))),
    en: $7fe332a380bf5371$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($538a6411aec4bbca$exports)))),
    ar: $7fe332a380bf5371$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($660f48ed324a71f9$exports))))
};
function $7fe332a380bf5371$export$d016ef1d127a8d71(locale, key, vars) {
    const { value: value, from: from } = (0, $0de037e7a1b59dc4$export$b1f08bca8a845a15)($7fe332a380bf5371$var$STRINGS, locale, key);
    return value == null ? key : (0, $0de037e7a1b59dc4$export$9a328bbde6508c84)(value, vars, from);
}
function $7fe332a380bf5371$export$2f6c4fed9331fa36() {
    const { t: t, has: has, locale: locale } = (0, $LNQP4.default)();
    return (0, $acw62.useCallback)((key, vars)=>has(key) ? t(key, vars) : $7fe332a380bf5371$export$d016ef1d127a8d71(locale, key, vars), [
        t,
        has,
        locale
    ]);
}
const $7fe332a380bf5371$export$7f9e228550f93e80 = Object.keys($7fe332a380bf5371$var$STRINGS);
const $7fe332a380bf5371$export$21ce9f55398ee410 = Object.keys($7fe332a380bf5371$var$STRINGS.fa);



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");


var $jTCZr = parcelRequire("jTCZr");

var $gKFEi = parcelRequire("gKFEi");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $02c719a0dfee0bc4$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $02c719a0dfee0bc4$export$2e2bcd8739ae039 = (0, $9QBug.default)("credit-card", $02c719a0dfee0bc4$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8c7fae0571c9b8a8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
            key: "1n2ejm"
        }
    ],
    [
        "path",
        {
            d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
            key: "1qfcsi"
        }
    ]
];
const $8c7fae0571c9b8a8$export$2e2bcd8739ae039 = (0, $9QBug.default)("messages-square", $8c7fae0571c9b8a8$export$3efd853dbb351e94);


var $6YS1K = parcelRequire("6YS1K");


// ─────────────────────────────────────────────────────────────────────────────
// «بیشتر» — what the phone's bottom bar folds away, the clinic panel's pattern
// (clinic-app `MobileMoreSheet`): who am I (name + پارسه balance) → where else
// can I go (پیام‌ها with its unread count, پروفایل, اعتبار).
//
// The bar keeps the doctor's working day — پذیرش · سوابق · حسابداری — and
// everything visited less often lives here, one tap further away.
//
// A row CLOSES the sheet and navigates only after the sheet has given its
// history entry back: the kit sheet owns an entry for the platform back
// gesture and releases it with `history.back()` on close. Navigating first
// would let that deferred back pop the DESTINATION — every row would close the
// menu and leave the doctor where they were (the bug the clinic app shipped).
// ─────────────────────────────────────────────────────────────────────────────
const $2debe24aa145d7c5$var$MobileMoreSheet = ({ open: open, onClose: onClose, onNavigate: onNavigate, doctor: doctor, balance: balance, unread: unread })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const mp = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const go = (key)=>{
        let done = false;
        const leave = ()=>{
            if (done) return;
            done = true;
            window.removeEventListener('popstate', leave);
            onNavigate(key);
        };
        window.addEventListener('popstate', leave);
        onClose();
        // No entry to give back (history integration unavailable) → no popstate.
        setTimeout(leave, 400);
    };
    const rows = [
        {
            key: 'messages',
            label: t('nav.items.messages'),
            Icon: (0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039),
            badge: unread || undefined
        },
        {
            key: 'my-page',
            label: mp('nav.items.myPage'),
            Icon: (0, $3cce873667d965dd$export$2e2bcd8739ae039)
        },
        {
            key: 'profile',
            label: t('nav.items.profile'),
            Icon: (0, $6YS1K.default)
        },
        {
            key: 'credits',
            label: t('nav.items.credits'),
            Icon: (0, $02c719a0dfee0bc4$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: rs('nav.mobile.moreTitle'),
        closeLabel: t('common.actions.close'),
        "data-testid": "mobile-more-sheet",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'grid',
                gap: '1rem',
                paddingBottom: '0.5rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                    "aria-label": rs('nav.mobile.account'),
                    style: {
                        display: 'grid',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                    name: doctor?.name || "\u2026",
                                    size: 44,
                                    src: doctor?.avatar || undefined
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        minWidth: 0,
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            dir: "auto",
                                            style: {
                                                fontSize: '0.9375rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: doctor?.name || "\u2026"
                                        }),
                                        doctor?.specialty && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            dir: "auto",
                                            style: {
                                                fontSize: '0.75rem',
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: doctor.specialty
                                        })
                                    ]
                                })
                            ]
                        }),
                        balance != null && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            "data-testid": "mobile-more-credit",
                            className: "h-auto min-h-11 w-full justify-between rounded-xl px-3 py-2 font-normal",
                            style: {
                                background: (0, $jTCZr.soft)((0, $jTCZr.creditColor)(balance), 0.1)
                            },
                            onClick: ()=>go('credits'),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.8125rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: rs('nav.mobile.balance')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        fontSize: '0.9375rem',
                                        fontWeight: 800,
                                        color: (0, $jTCZr.creditColor)(balance)
                                    },
                                    children: [
                                        (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.75rem',
                                                fontWeight: 500,
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: t('common.units.coin')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                    "aria-label": rs('nav.mobile.sections'),
                    style: {
                        display: 'grid',
                        gap: '0.125rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textMuted,
                                padding: '0 0.25rem'
                            },
                            children: rs('nav.mobile.sections')
                        }),
                        rows.map(({ key: key, label: label, Icon: Icon, badge: badge })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                variant: "ghost",
                                "data-testid": `mobile-more-nav-${key}`,
                                className: "h-auto min-h-11 w-full justify-start gap-3 rounded-xl px-1.5 py-2 font-normal",
                                onClick: ()=>go(key),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                        size: 18,
                                        "aria-hidden": true,
                                        style: {
                                            color: (0, $jTCZr.C).textSecondary,
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            flex: 1,
                                            textAlign: 'start',
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: label
                                    }),
                                    badge ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                        variant: "count",
                                        children: badge
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                                        size: 16,
                                        "aria-hidden": true,
                                        style: {
                                            color: (0, $jTCZr.C).textMuted,
                                            flexShrink: 0,
                                            ...(0, $asXy3.MIRROR_ICON)
                                        }
                                    })
                                ]
                            }, key))
                    ]
                })
            ]
        })
    });
};
var $2debe24aa145d7c5$export$2e2bcd8739ae039 = $2debe24aa145d7c5$var$MobileMoreSheet;


const $919f4c0406decc98$export$6c9dcdc09ad54060 = 'more';
const $919f4c0406decc98$var$NAV_ITEMS = [
    // «خانه» named the tab by its position in the shell, not by what it does. The
    // destination is the پذیرش desk, so the tab says so — same word as the sidebar.
    {
        key: 'reception',
        labelKey: 'dashboard.title',
        Icon: (0, $ggYuf.default)
    },
    {
        key: 'encounters',
        labelKey: 'nav.mobile.encounters',
        Icon: (0, $9c3425eadfb41de5$export$2e2bcd8739ae039)
    },
    {
        key: 'accounting',
        labelKey: 'nav.items.accounting',
        Icon: (0, $l37hw.default)
    }
];
const $919f4c0406decc98$export$e733918a79590def = [
    'messages',
    'profile',
    'credits',
    'my-page'
];
const $919f4c0406decc98$var$MobileBottomNav = ()=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const balance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const unread = (0, $b5200d235eee6334$export$95dcf77aabe4f3a4)((0, $caf8273c728e960b$export$f3b3260407e19024)(), formatNumber);
    const items = [
        ...$919f4c0406decc98$var$NAV_ITEMS.map(({ key: key, labelKey: labelKey, Icon: Icon })=>({
                key: key,
                label: t(labelKey),
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                    size: 22,
                    "aria-hidden": true
                })
            })),
        {
            key: $919f4c0406decc98$export$6c9dcdc09ad54060,
            label: rs('nav.mobile.more'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                size: 22,
                "aria-hidden": true
            }),
            // `formatUnread` returns '' at zero, and an empty string is not a badge —
            // the kit renders anything that is neither null nor 0.
            badge: unread || undefined,
            badgeLabel: unread ? t('messages.unreadBadge', {
                count: unread
            }) : undefined,
            // An unread tally is waiting, not wrong — navy, never the destructive red.
            badgeTone: 'count'
        }
    ];
    // An open visit intercepts navigation with its own confirm.
    const go = (key)=>{
        if (window.__parsina_visit_guard) window.__parsina_visit_guard(()=>navigate(key));
        else navigate(key);
    };
    const here = location.pathname.slice(1).split('/')[0];
    const active = $919f4c0406decc98$export$e733918a79590def.includes(here) ? $919f4c0406decc98$export$6c9dcdc09ad54060 : here;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iuHQQ.default), {
                "data-testid": "mobile-bottom-nav",
                items: items,
                active: active,
                onSelect: (key)=>key === $919f4c0406decc98$export$6c9dcdc09ad54060 ? setMoreOpen(true) : go(key)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2debe24aa145d7c5$export$2e2bcd8739ae039), {
                open: moreOpen,
                onClose: ()=>setMoreOpen(false),
                onNavigate: go,
                doctor: doctor,
                balance: balance,
                unread: unread
            })
        ]
    });
};
var $919f4c0406decc98$export$2e2bcd8739ae039 = $919f4c0406decc98$var$MobileBottomNav;






// ─────────────────────────────────────────────────────────────────────────────
// PWA runtime: service-worker registration, install-prompt plumbing, and
// display-mode detection.
//
// The install story is asymmetric by platform and this module absorbs that:
//
//   Android/Chromium  fires `beforeinstallprompt`. The event MUST be captured
//                     (and preventDefault'd) before any UI exists — it often
//                     fires while React is still mounting — so App.jsx calls
//                     initPwa() at module scope and the captured event waits
//                     here until the banner asks for it.
//   iOS Safari        has no install event at all. Installability is inferred
//                     (iOS device, not already standalone) and the banner
//                     shows share-sheet instructions instead of a prompt.
//
// Everything is defensive about environment: under Jest there is no
// matchMedia and no service worker; in dev/e2e the worker must stay out of
// the way (a worker caching a dev server turns every reload into archaeology).
// ─────────────────────────────────────────────────────────────────────────────
const $8927aec8e5f774d0$var$DISMISS_KEY = 'parsina.pwa.dismissedAt';
const $8927aec8e5f774d0$var$INSTALLED_KEY = 'parsina.pwa.installed';
const $8927aec8e5f774d0$export$94874e4bc2db820e = 1209600000;
let $8927aec8e5f774d0$var$deferredPrompt = null;
let $8927aec8e5f774d0$var$initialized = false;
const $8927aec8e5f774d0$var$listeners = new Set();
const $8927aec8e5f774d0$var$notify = ()=>$8927aec8e5f774d0$var$listeners.forEach((fn)=>{
        try {
            fn();
        } catch  {}
    });
const $8927aec8e5f774d0$var$storageGet = (key)=>{
    try {
        return window.localStorage.getItem(key);
    } catch  {
        return null;
    }
};
const $8927aec8e5f774d0$var$storageSet = (key, value)=>{
    try {
        window.localStorage.setItem(key, value);
    } catch  {}
};
function $8927aec8e5f774d0$export$72fee83dd1572775() {
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) return true;
    // Legacy iOS signal, still the only one some Safari versions expose.
    return window.navigator.standalone === true;
}
function $8927aec8e5f774d0$export$fedb369cb70207f1() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    if (/iphone|ipad|ipod/i.test(ua)) return true;
    return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;
}
// ── Install prompt state ─────────────────────────────────────────────────────
function $8927aec8e5f774d0$var$isDismissed() {
    const raw = $8927aec8e5f774d0$var$storageGet($8927aec8e5f774d0$var$DISMISS_KEY);
    if (!raw) return false;
    const at = Number(raw);
    return Number.isFinite(at) && Date.now() - at < $8927aec8e5f774d0$export$94874e4bc2db820e;
}
function $8927aec8e5f774d0$export$b42bb9909fdaf235() {
    const standalone = $8927aec8e5f774d0$export$72fee83dd1572775();
    const ios = $8927aec8e5f774d0$export$fedb369cb70207f1();
    const installed = $8927aec8e5f774d0$var$storageGet($8927aec8e5f774d0$var$INSTALLED_KEY) === 'true';
    const dismissed = $8927aec8e5f774d0$var$isDismissed();
    return {
        standalone: standalone,
        ios: ios,
        promptAvailable: $8927aec8e5f774d0$var$deferredPrompt !== null,
        visible: !standalone && !installed && !dismissed && ($8927aec8e5f774d0$var$deferredPrompt !== null || ios)
    };
}
function $8927aec8e5f774d0$export$d5b018cbcf71ee98(fn) {
    $8927aec8e5f774d0$var$listeners.add(fn);
    return ()=>$8927aec8e5f774d0$var$listeners.delete(fn);
}
async function $8927aec8e5f774d0$export$c93c7c5b40a4887c() {
    const prompt = $8927aec8e5f774d0$var$deferredPrompt;
    if (!prompt) return null;
    $8927aec8e5f774d0$var$deferredPrompt = null;
    try {
        prompt.prompt();
        const choice = await prompt.userChoice;
        const outcome = choice && choice.outcome === 'accepted' ? 'accepted' : 'dismissed';
        if (outcome === 'dismissed') $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$DISMISS_KEY, String(Date.now()));
        return outcome;
    } catch  {
        return 'dismissed';
    } finally{
        $8927aec8e5f774d0$var$notify();
    }
}
function $8927aec8e5f774d0$export$a86c2d0a69142026() {
    $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$DISMISS_KEY, String(Date.now()));
    $8927aec8e5f774d0$var$notify();
}
function $8927aec8e5f774d0$export$1ffc9258e44c4084() {
    if ($8927aec8e5f774d0$var$initialized || typeof window === 'undefined') return;
    $8927aec8e5f774d0$var$initialized = true;
    window.addEventListener('beforeinstallprompt', (event)=>{
        // Chrome's mini-infobar is suppressed in favour of the in-app banner.
        event.preventDefault();
        $8927aec8e5f774d0$var$deferredPrompt = event;
        $8927aec8e5f774d0$var$notify();
    });
    window.addEventListener('appinstalled', ()=>{
        $8927aec8e5f774d0$var$deferredPrompt = null;
        $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$INSTALLED_KEY, 'true');
        $8927aec8e5f774d0$var$notify();
    });
}
function $8927aec8e5f774d0$export$c87aff83536387ce() {
    $8927aec8e5f774d0$var$deferredPrompt = null;
    $8927aec8e5f774d0$var$initialized = false;
    $8927aec8e5f774d0$var$listeners.clear();
}


// ─────────────────────────────────────────────────────────────────────────────
// Service-worker registration — quarantined in its own module on purpose.
//
// The `new URL('../../sw.js', import.meta.url)` form is not just a URL: it is
// how Parcel DISCOVERS the worker, compiles it for the service-worker
// environment, and emits it at the site root. But `import.meta` is a parse
// error under Jest's CommonJS transform, so this file must never be imported
// from anything test-reachable. App.jsx (never imported by tests — the routing
// suite reads it as text) is the only caller; everything testable about PWA
// behaviour lives in src/lib/pwa.js.
//
// The guards are the feature:
//   • production bundles only — a worker over the dev server poisons every
//     reload, and Jest has no serviceWorker at all;
//   • automated browsers (Playwright sets navigator.webdriver) never
//     register, so e2e runs cannot leak cache state between tests;
//   • registration failure is silent — the app ran without a worker for
//     years and keeps working exactly the same without one.
// ─────────────────────────────────────────────────────────────────────────────
var $aac2e2be59c07ac3$exports = {};
$aac2e2be59c07ac3$exports = import.meta.resolve("2AiUB");


function $0f73dd0c16002d84$export$c6245babf0c60892() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    if (navigator.webdriver) return;
    window.addEventListener('load', ()=>{
        // type: 'module' is what lets sw.js use ESM imports. Parcel resolves them
        // at build time and, since the emitted worker has none left, rewrites this
        // registration to a plain classic one — the option exists for the
        // bundler, not the browser.
        navigator.serviceWorker.register($aac2e2be59c07ac3$exports, {
            scope: '/'
        }).catch(()=>{
        /* no worker → no offline support, nothing else changes */ });
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2XwcZ = parcelRequire("2XwcZ");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fef0c2cce19896fe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v13",
            key: "1km8f5"
        }
    ],
    [
        "path",
        {
            d: "m16 6-4-4-4 4",
            key: "13yo43"
        }
    ],
    [
        "path",
        {
            d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
            key: "1b2hhj"
        }
    ]
];
const $fef0c2cce19896fe$export$2e2bcd8739ae039 = (0, $9QBug.default)("share", $fef0c2cce19896fe$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1c16d0b78cca1901$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
];
const $1c16d0b78cca1901$export$2e2bcd8739ae039 = (0, $9QBug.default)("square-plus", $1c16d0b78cca1901$export$3efd853dbb351e94);


var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

/**
 * The install banner — the browser-mode invitation to become an app.
 *
 * Two shapes behind one card, because the platforms genuinely differ:
 *
 *   Android/Chromium  the captured `beforeinstallprompt` is replayed, so
 *                     «نصب» opens the REAL system dialog — one tap.
 *   iOS               there is no API; «نصب» flips the card into the
 *                     three-step share-sheet walkthrough instead.
 *
 * Visibility is entirely `getInstallState()`'s call (standalone, installed,
 * cooldown, something-to-offer) so the component renders nothing everywhere
 * that matters: installed launches, desktop, dismissed-recently sessions.
 * Mounted only in the mobile shell.
 */ const $2b9c6217915cd2a6$var$InstallPrompt = ()=>{
    const { t: t } = (0, $LNQP4.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $8927aec8e5f774d0$export$b42bb9909fdaf235));
    const [showIosSteps, setShowIosSteps] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(0, $8927aec8e5f774d0$export$d5b018cbcf71ee98)(()=>setState((0, $8927aec8e5f774d0$export$b42bb9909fdaf235)())), []);
    if (!state.visible) return null;
    const handleInstall = async ()=>{
        if (state.promptAvailable) await (0, $8927aec8e5f774d0$export$c93c7c5b40a4887c)();
        else setShowIosSteps(true);
    };
    const iosSteps = [
        {
            Icon: (0, $fef0c2cce19896fe$export$2e2bcd8739ae039),
            text: t('common.pwa.iosStep1')
        },
        {
            Icon: (0, $1c16d0b78cca1901$export$2e2bcd8739ae039),
            text: t('common.pwa.iosStep2')
        },
        {
            Icon: (0, $2XwcZ.default),
            text: t('common.pwa.iosStep3')
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "pwa-install-prompt",
        role: "dialog",
        "aria-label": t('common.pwa.installTitle'),
        style: {
            position: 'fixed',
            insetInline: 12,
            // Above the bottom nav when there is one, above the home indicator
            // when there is not. `--app-bottom-nav` is published by
            // MobileBottomNav while it is mounted and removed when it unmounts, so
            // the same expression is right on a tab-bar screen and on a full-screen
            // flow. Without it the card was laid out from the window's bottom edge
            // and covered the tab bar it was floating over.
            bottom: 'calc(12px + env(safe-area-inset-bottom, 0px) + var(--app-bottom-nav, 0px))',
            zIndex: 90,
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            boxShadow: '0 12px 40px rgba(0,0,0,0.16), 0 2px 10px rgba(0,0,0,0.08)',
            padding: 14,
            maxWidth: 440,
            marginInline: 'auto'
        },
        children: !showIosSteps ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: 46,
                        height: 46,
                        borderRadius: 12,
                        flexShrink: 0,
                        background: `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navyLight})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2XwcZ.default), {
                        size: 22,
                        color: "#fff",
                        "aria-hidden": true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: 13.5,
                                fontWeight: 800,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: t('common.pwa.installTitle')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: 11.5,
                                color: (0, $jTCZr.C).textSecondary,
                                lineHeight: 1.7,
                                marginTop: 2
                            },
                            children: t('common.pwa.installBody')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6,
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-testid": "pwa-install-accept",
                            onClick: handleInstall,
                            style: {
                                padding: '8px 16px',
                                borderRadius: 10,
                                border: 'none',
                                background: (0, $jTCZr.C).navy,
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: 12.5,
                                fontFamily: 'inherit',
                                cursor: 'pointer'
                            },
                            children: t('common.pwa.install')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-testid": "pwa-install-dismiss",
                            onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                            style: {
                                padding: '4px 8px',
                                borderRadius: 8,
                                border: 'none',
                                background: 'transparent',
                                color: (0, $jTCZr.C).textMuted,
                                fontSize: 11.5,
                                fontFamily: 'inherit',
                                cursor: 'pointer'
                            },
                            children: t('common.pwa.later')
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-testid": "pwa-ios-steps",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: 13.5,
                                fontWeight: 800,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: t('common.pwa.iosTitle')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                            "aria-label": t('common.actions.close'),
                            style: {
                                width: 28,
                                height: 28,
                                borderRadius: 8,
                                border: 'none',
                                background: (0, $jTCZr.C).bg,
                                color: (0, $jTCZr.C).textMuted,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                size: 15,
                                "aria-hidden": true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                    style: {
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    },
                    children: iosSteps.map(({ Icon: Icon, text: text }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        width: 30,
                                        height: 30,
                                        borderRadius: 9,
                                        flexShrink: 0,
                                        background: `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navyLight})`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                        size: 15,
                                        color: "#fff",
                                        "aria-hidden": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $jTCZr.C).textSecondary,
                                        lineHeight: 1.7
                                    },
                                    children: text
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    "data-testid": "pwa-ios-got-it",
                    onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                    style: {
                        marginTop: 12,
                        width: '100%',
                        padding: '9px 0',
                        borderRadius: 10,
                        border: 'none',
                        background: (0, $jTCZr.C).navy,
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: 12.5,
                        fontFamily: 'inherit',
                        cursor: 'pointer'
                    },
                    children: t('common.pwa.gotIt')
                })
            ]
        })
    });
};
var $2b9c6217915cd2a6$export$2e2bcd8739ae039 = $2b9c6217915cd2a6$var$InstallPrompt;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dfuoR = parcelRequire("dfuoR");


var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
class $a205304edfbe4546$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack: `error.stack` alone points at the component
        // that threw, not at the tree that rendered it, and for a shared primitive
        // (Button, Card, ErrorState) the latter is the only part that identifies
        // WHICH screen is broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $a205304edfbe4546$export$9c1491499ee5fc65({ children: children, resetKey: resetKey, onGoHome: onGoHome }) {
    const { t: t } = (0, $LNQP4.default)();
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
            testId: "screen-error",
            tone: "danger",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfuoR.default), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: t('errors.crash.screenTitle'),
            body: t('errors.crash.screenBody'),
            // The message, not the stack. A doctor cannot read a stack, and the
            // message is the part that lets support reproduce it. The stack is in
            // the console for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                {
                    key: 'retry',
                    label: t('errors.crash.retryScreen'),
                    onClick: reset,
                    variant: 'primary',
                    testId: 'screen-error-retry'
                },
                ...onGoHome ? [
                    {
                        key: 'home',
                        label: t('errors.crash.goHome'),
                        onClick: onGoHome,
                        variant: 'secondary'
                    }
                ] : []
            ],
            footer: t('errors.crash.dataSafe')
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a205304edfbe4546$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        children: children
    });
}
function $a205304edfbe4546$export$fb7eb3c89b80502d({ children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const renderFallback = (error)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
            testId: "app-error",
            fullscreen: true,
            tone: "danger",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfuoR.default), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: t('errors.crash.appTitle'),
            body: t('errors.crash.appBody'),
            detail: error?.message || String(error),
            actions: [
                {
                    key: 'reload',
                    label: t('errors.crash.reload'),
                    // `location.reload()` rather than a router reset: the state that
                    // produced the crash is still in memory, and re-rendering into it
                    // reproduces the crash immediately. A reload is the only reset that
                    // is actually a reset.
                    onClick: ()=>window.location.reload(),
                    variant: 'primary',
                    testId: 'app-error-reload'
                }
            ],
            footer: t('errors.crash.dataSafe')
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a205304edfbe4546$export$7583e06808a373a5, {
        renderFallback: renderFallback,
        children: children
    });
}
// ── The last resort ──────────────────────────────────────────────────────────
// `AppErrorBoundary` reads its copy through `t`, which means it has to sit
// INSIDE I18nProvider — and a boundary inside a provider cannot catch that
// provider throwing. So one more boundary wraps the providers themselves.
//
// It cannot use `t` (that is the whole point), so its copy is static, in all
// three panel languages, and it picks one from what the pre-paint script in
// index.html already set on <html lang> (from the same `parsina.locale` cache
// I18nProvider reads) — the same compromise, for the same reason, as the
// service worker's offline page. It should realistically never render: the
// providers are three lines of context each. But "should never happen" is not
// a rendering strategy, and the alternative is the white screen again.
// i18n-exempt: last-resort boundary — renders when I18nProvider itself has failed, so `t` is unavailable.
const $a205304edfbe4546$var$FATAL_FA = {
    title: "\u062E\u0637\u0627\u06CC \u063A\u06CC\u0631\u0645\u0646\u062A\u0638\u0631\u0647",
    body: "\u0628\u0631\u0646\u0627\u0645\u0647 \u0628\u0627 \u0645\u0634\u06A9\u0644\u06CC \u0645\u0648\u0627\u062C\u0647 \u0634\u062F. \u0635\u0641\u062D\u0647 \u0631\u0627 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u06A9\u0646\u06CC\u062F.",
    action: "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0645\u062C\u062F\u062F"
};
// i18n-exempt: last-resort boundary — renders when I18nProvider itself has failed, so `t` is unavailable.
const $a205304edfbe4546$var$FATAL_EN = {
    title: 'Unexpected error',
    body: 'The application ran into a problem. Please reload the page.',
    action: 'Reload'
};
// i18n-exempt: last-resort boundary — renders when I18nProvider itself has failed, so `t` is unavailable.
const $a205304edfbe4546$var$FATAL_AR = {
    title: "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639",
    body: "\u0648\u0627\u062C\u0647 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0645\u0634\u0643\u0644\u0629. \u064A\u064F\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629.",
    action: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644"
};
const $a205304edfbe4546$var$FATAL = {
    fa: $a205304edfbe4546$var$FATAL_FA,
    en: $a205304edfbe4546$var$FATAL_EN,
    ar: $a205304edfbe4546$var$FATAL_AR
};
/** The panel language without the i18n runtime: <html lang>, then the cache, then Persian. */ function $a205304edfbe4546$var$fatalLanguage() {
    const narrow = (v)=>{
        const base = String(v || '').toLowerCase().split(/[-_]/)[0];
        return $a205304edfbe4546$var$FATAL[base] ? base : null;
    };
    try {
        return narrow(document.documentElement.getAttribute('lang')) || narrow(window.localStorage.getItem('parsina.locale')) || 'fa';
    } catch  {
        return 'fa';
    }
}
function $a205304edfbe4546$export$b735bbab4dd866a3({ children: children }) {
    // Tokens, not literal hex — including here. `C.*` is a plain module import,
    // not React context, and the accent variables come from tokens.css with
    // `:root` defaults, so both survive exactly the failure this boundary exists
    // for. Only the COPY has to be static; the paint does not, and hardcoding it
    // would leave one screen in the product that ignores the doctor's accent.
    //
    // The type scale is not used here for the opposite reason: `type` scales with
    // the `data-font-size` attribute ThemeProvider stamps, and this renders when
    // ThemeProvider may never have run. Literal rem is the honest choice at this
    // one altitude, and the values match `type.metric` / `body` / `caption` at
    // the default setting.
    const renderFallback = (error)=>{
        const lang = $a205304edfbe4546$var$fatalLanguage();
        const copy = $a205304edfbe4546$var$FATAL[lang];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            dir: lang === 'en' ? 'ltr' : 'rtl',
            lang: lang,
            role: "alert",
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100vw',
                height: '100vh',
                margin: 0,
                background: (0, $jTCZr.C).bg,
                fontFamily: 'var(--app-font)',
                padding: '1.25rem',
                boxSizing: 'border-box'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: (0, $jTCZr.C).card,
                    borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    padding: '2.25rem 2rem',
                    maxWidth: '27.5rem',
                    width: '100%',
                    textAlign: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '1.1875rem',
                            fontWeight: 800,
                            lineHeight: 1.2,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: '0.5rem'
                        },
                        children: copy.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 500,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.85,
                            marginBottom: '1.375rem'
                        },
                        children: copy.body
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>window.location.reload(),
                        "data-testid": "root-error-reload",
                        style: {
                            height: '2.75rem',
                            padding: '0 1.25rem',
                            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
                            border: 'none',
                            background: (0, $jTCZr.C).navy,
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '0.84375rem',
                            fontFamily: 'inherit',
                            cursor: 'pointer'
                        },
                        children: copy.action
                    }),
                    error?.message && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "ltr",
                        style: {
                            marginTop: '1.25rem',
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted,
                            fontFamily: 'monospace',
                            wordBreak: 'break-word',
                            textAlign: 'left'
                        },
                        children: String(error.message)
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a205304edfbe4546$export$7583e06808a373a5, {
        renderFallback: renderFallback,
        children: children
    });
}
var $a205304edfbe4546$export$2e2bcd8739ae039 = $a205304edfbe4546$export$fb7eb3c89b80502d;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dcn2F = parcelRequire("dcn2F");
var $aks7U = parcelRequire("aks7U");
var $5kK4h = parcelRequire("5kK4h");
var $6JkDX = parcelRequire("6JkDX");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $1HT9m = parcelRequire("1HT9m");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");


// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $caae5368ead5995e$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $caae5368ead5995e$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $caae5368ead5995e$var$PROBE_MIN_MS = 3000;
const $caae5368ead5995e$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $caae5368ead5995e$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would show a network banner to a doctor whose session simply
 * expired, which is Phase 4's job and a different conversation.
 */ async function $caae5368ead5995e$var$probeBff(signal) {
    try {
        const res = await fetch((0, $d87bd335296b449f$export$bb117bdb9f34de64), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $caae5368ead5995e$export$a32c5b7f472865fb() {
    const [state, setState] = (0, $acw62.useState)(()=>$caae5368ead5995e$var$isBrowserOffline() ? $caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE : $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($caae5368ead5995e$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $caae5368ead5995e$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($caae5368ead5995e$var$isBrowserOffline()) {
            setState($caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $caae5368ead5995e$var$PROBE_TIMEOUT_MS);
        const reachable = await $caae5368ead5995e$var$probeBff(controller.signal);
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($caae5368ead5995e$var$isBrowserOffline() ? $caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE : $caae5368ead5995e$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $caae5368ead5995e$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $caae5368ead5995e$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $e86ae3699bc75753$export$288ba6b4215d30f3)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($caae5368ead5995e$var$isBrowserOffline()) setState($caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $caae5368ead5995e$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $caae5368ead5995e$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $caae5368ead5995e$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $caae5368ead5995e$export$2e2bcd8739ae039 = $caae5368ead5995e$export$a32c5b7f472865fb;


// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Before this, a dropped connection produced N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it came back. The doctor's only strategy was to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — and on the visit
//   screen that is the patient's name, which is not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a doctor can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $7b1454c106c97b7d$var$RECOVERY_VISIBLE_MS = 4000;
const $7b1454c106c97b7d$var$VARIANTS = {
    [(0, $caae5368ead5995e$export$cd9c3c6bf535afc9).OFFLINE]: {
        Icon: (0, $6JkDX.default),
        bg: (0, $jTCZr.C).red,
        fg: '#fff',
        messageKey: 'errors.connectivity.offline',
        testId: 'connectivity-offline'
    },
    [(0, $caae5368ead5995e$export$cd9c3c6bf535afc9).DEGRADED]: {
        Icon: (0, $dcn2F.default),
        bg: (0, $jTCZr.C).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // token the kit already pairs with a warning surface — this used to be a
        // hand-mixed brown, which is how a second, slightly-off warning colour
        // enters a design system.
        fg: (0, $jTCZr.CT).warnInk,
        messageKey: 'errors.connectivity.degraded',
        testId: 'connectivity-degraded'
    }
};
function $7b1454c106c97b7d$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy }) {
    const { t: t } = (0, $LNQP4.default)();
    const disconnected = state !== (0, $caae5368ead5995e$export$cd9c3c6bf535afc9).ONLINE;
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $7b1454c106c97b7d$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $7b1454c106c97b7d$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, messageKey: messageKey, testId: testId } = variant;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($7b1454c106c97b7d$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                    size: 15,
                    strokeWidth: 2.2,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t(messageKey)
                }),
                onRetry && // The kit `Button` at `sm`, not a hand-rolled pill. It sits on a
                // coloured bar rather than the page, so `currentColor` carries the
                // bar's ink through — the only thing the variants cannot know — and
                // everything else (height, radius, type, focus ring, disabled state)
                // comes from the kit like every other button in the app.
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    type: "button",
                    size: "sm",
                    variant: "ghost",
                    onClick: onRetry,
                    disabled: busy,
                    "data-testid": "connectivity-retry",
                    style: {
                        marginInlineStart: 'auto',
                        color: fg,
                        border: '1px solid currentColor',
                        background: 'transparent',
                        gap: '0.3125rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aks7U.default), {
                            size: 12,
                            "aria-hidden": true,
                            style: busy ? {
                                animation: 'connectivity-spin 0.9s linear infinite'
                            } : undefined
                        }),
                        t(busy ? 'errors.connectivity.checking' : 'common.actions.retry')
                    ]
                })
            ]
        });
    }
    if (recovered) return /*#__PURE__*/ (0, $ayMG0.jsxs)($7b1454c106c97b7d$var$Bar, {
        bg: (0, $jTCZr.C).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5kK4h.default), {
                size: 15,
                strokeWidth: 2.2,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: t('errors.connectivity.restored')
            })
        ]
    });
    return null;
}
function $7b1454c106c97b7d$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A doctor mid-sentence in a clinical note must
        // not have their screen reader interrupted by an infrastructure notice —
        // the connection dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            ...(0, $1HT9m.type).label,
            flexShrink: 0,
            zIndex: 40
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'
            }),
            children
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $kMJsW = parcelRequire("kMJsW");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $59813a4678999ce6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10 17 5-5-5-5",
            key: "1bsop3"
        }
    ],
    [
        "path",
        {
            d: "M15 12H3",
            key: "6jk70r"
        }
    ],
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ]
];
const $59813a4678999ce6$export$2e2bcd8739ae039 = (0, $9QBug.default)("log-in", $59813a4678999ce6$export$3efd853dbb351e94);


parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");

var $jTCZr = parcelRequire("jTCZr");

var $1HT9m = parcelRequire("1HT9m");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The two faces of a session ending.
//
// Both are modal — genuinely modal, unlike almost anything else in this app —
// because unlike a connection drop there is nothing useful the doctor can do
// underneath. Every write will fail, and letting them keep typing into a
// clinical note that cannot be saved is worse than interrupting them.
//
// What the modal deliberately does NOT do is unmount anything. The screen
// behind it is intact and readable, which is the entire point: the previous
// behaviour navigated away, so the note was simply gone. Here it is still on
// screen, still selectable, and after «ورود مجدد» the doctor comes back to the
// same URL.
//
//   Warning  raised while the session can still be extended silently. It has a
//            live countdown, because "soon" is not something anyone can plan
//            around, and its primary action costs one silent token refresh.
//            Dismissible — a doctor mid-sentence may reasonably want it gone,
//            and the expired dialog will follow if they do nothing.
//
//   Expired  not dismissible. There is no state to return to underneath in
//            which anything works.
//
// Built on the kit `Dialog` (Radix) rather than a hand-rolled fixed overlay.
// That is not tidiness: it is what buys the focus trap, the `aria-modal`
// semantics, the escape/outside-click handling, the scroll lock and the scrim
// that every other modal in the app already has. A bespoke overlay here would
// be the one dialog in the product that a keyboard user could tab out of, and
// «ورود مجدد» is a bad button to lose focus of.
// ─────────────────────────────────────────────────────────────────────────────
/** The tone disc, matching SystemPage's and ErrorState's so the family reads as one. */ function $e88acdb961d2fa90$var$Disc({ tone: tone, children: children }) {
    const palette = tone === 'warning' ? {
        fg: (0, $jTCZr.C).amber,
        bg: (0, $jTCZr.C).amberLight
    } : {
        fg: (0, $jTCZr.C).navy,
        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem'
        },
        children: children
    });
}
function $e88acdb961d2fa90$export$c05fa71599f06855({ secondsLeft: secondsLeft, onExtend: onExtend, onDismiss: onDismiss, busy: busy }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (next)=>{
            if (!next) onDismiss?.();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            role: "alertdialog",
            "data-testid": "session-expiring",
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e88acdb961d2fa90$var$Disc, {
                            tone: "warning",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                                size: 26,
                                strokeWidth: 1.9,
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                            style: {
                                textAlign: 'center'
                            },
                            children: t('auth.session.expiringTitle')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                ...(0, $1HT9m.type).body,
                                fontWeight: 500,
                                color: (0, $jTCZr.C).textSecondary,
                                lineHeight: 1.85
                            },
                            children: t('auth.session.expiringBody')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "session-countdown",
                            "aria-live": "off",
                            style: {
                                ...(0, $1HT9m.type).display,
                                color: (0, $jTCZr.C).amber,
                                margin: '0.5rem 0 0',
                                fontVariantNumeric: 'tabular-nums'
                            },
                            children: [
                                formatNumber(Math.max(0, secondsLeft)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        ...(0, $1HT9m.type).unit,
                                        color: (0, $jTCZr.C).textMuted,
                                        marginInlineStart: '0.375rem'
                                    },
                                    children: t('common.units.second')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogFooter), {
                    style: {
                        flexDirection: 'column',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            onClick: onExtend,
                            disabled: busy,
                            "data-testid": "session-extend",
                            style: {
                                width: '100%'
                            },
                            children: t(busy ? 'common.state.pleaseWait' : 'auth.session.staySignedIn')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: onDismiss,
                            "data-testid": "session-dismiss",
                            style: {
                                width: '100%'
                            },
                            children: t('common.actions.close')
                        })
                    ]
                })
            ]
        })
    });
}
function $e88acdb961d2fa90$export$88240b05a63eec38({ onSignIn: onSignIn, busy: busy }) {
    const { t: t } = (0, $LNQP4.default)();
    return(// Not dismissible, and it takes three separate refusals to mean it: no
    // close affordance, no escape, no outside click. Any one of them left open
    // would drop the doctor back onto a screen where every button silently
    // fails — which looks exactly like the app having frozen.
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: ()=>{},
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            role: "alertdialog",
            "data-testid": "session-expired",
            showClose: false,
            onEscapeKeyDown: (e)=>e.preventDefault(),
            onPointerDownOutside: (e)=>e.preventDefault(),
            onInteractOutside: (e)=>e.preventDefault(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e88acdb961d2fa90$var$Disc, {
                            tone: "info",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59813a4678999ce6$export$2e2bcd8739ae039), {
                                size: 26,
                                strokeWidth: 1.9,
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                            style: {
                                textAlign: 'center'
                            },
                            children: t('errors.kind.unauthenticated.title')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        ...(0, $1HT9m.type).body,
                        fontWeight: 500,
                        color: (0, $jTCZr.C).textSecondary,
                        lineHeight: 1.85,
                        textAlign: 'center'
                    },
                    children: t('auth.session.expiredBody')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogFooter), {
                    style: {
                        flexDirection: 'column',
                        gap: '0.5rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        onClick: onSignIn,
                        disabled: busy,
                        "data-testid": "session-signin",
                        style: {
                            width: '100%'
                        },
                        children: t('auth.session.signInAgain')
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        ...(0, $1HT9m.type).caption,
                        color: (0, $jTCZr.C).textMuted,
                        marginTop: '1rem',
                        lineHeight: 1.8,
                        textAlign: 'center'
                    },
                    children: t('auth.session.returnNotice')
                })
            ]
        })
    }));
}



var $acw62 = parcelRequire("acw62");


const $d4d7a25942cf3f48$export$9a8e643ece3bd90e = 120000;
// setTimeout is clamped to a 32-bit signed millisecond count, and a longer
// delay wraps to a negative value and fires IMMEDIATELY. A Keycloak SSO session
// can legitimately be days long, so a naive `setTimeout(warnAt)` would show the
// expiry warning the instant a doctor signed in.
const $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS = 2147483647;
// ── Returning the doctor to where they were ──────────────────────────────────
// Keycloak's redirect_uri is the origin, so a re-login lands on پذیرش unless
// something remembers the destination. That is a small loss on a list screen
// and a real one on /visit/:patientId — the doctor has to find the patient
// again and re-open the encounter, having just been interrupted.
//
// ── Why localStorage, and not the sessionStorage this used to be ────────────
// It was sessionStorage on the argument that an interrupted journey is a fact
// about ONE TAB. That reasoning holds for two tabs on a desktop and fails for
// every case a phone actually produces:
//
//   COLD-START DEEP LINK. A PWA shortcut, a shared /patients/:id, a /visit/:id
//   sent in a message. There is no session yet, so `sessionStorage` is empty by
//   definition — and the Keycloak round trip is a full document navigation, so
//   whatever we wrote before it is only readable afterwards if it outlived the
//   navigation. It did not: the doctor followed a link to a record and arrived
//   at پذیرش, every time.
//
//   THE PAYMENT RETURN. `location.href = gateway` leaves the app. From an
//   installed iOS PWA the gateway may open in a different browsing context, and
//   its redirect back to /credits?payment=… can land there with neither the
//   token nor the path. sessionStorage is per browsing context; localStorage is
//   per origin, so it survives exactly the hop that loses the other one.
//
// The tokens deliberately stay in sessionStorage. What moves is a NON-SECRET
// in-app path, so this changes the app's security posture not at all — which is
// why it was chosen over the other candidate fix (moving the tokens).
//
// The TTL is what keeps the cross-tab objection real but harmless: a remembered
// destination is only honoured for the length of a sign-in, and a stale one
// from an hour ago is ignored rather than teleporting a doctor into a screen
// they left long ago.
const $d4d7a25942cf3f48$var$RETURN_KEY = 'parsina_return_to';
const $d4d7a25942cf3f48$export$3c79a2f771bc9a1a = 900000;
/** Only in-app paths: an absolute URL here would be an open redirect. */ const $d4d7a25942cf3f48$var$inAppPath = (path)=>typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
function $d4d7a25942cf3f48$export$4986ea797be155b1(path = `${window.location.pathname}${window.location.search}`) {
    try {
        if (!$d4d7a25942cf3f48$var$inAppPath(path)) return;
        localStorage.setItem($d4d7a25942cf3f48$var$RETURN_KEY, JSON.stringify({
            path: path,
            ts: Date.now()
        }));
    } catch  {}
}
function $d4d7a25942cf3f48$export$e5c839e26770d4ca({ now: now = ()=>Date.now() } = {}) {
    try {
        const raw = localStorage.getItem($d4d7a25942cf3f48$var$RETURN_KEY);
        localStorage.removeItem($d4d7a25942cf3f48$var$RETURN_KEY);
        if (!raw) return null;
        // A bare string is what the sessionStorage version wrote. Reading it keeps
        // the one doctor whose browser is mid-upgrade from losing their place.
        const stored = raw.startsWith('{') ? JSON.parse(raw) : {
            path: raw,
            ts: now()
        };
        if (!$d4d7a25942cf3f48$var$inAppPath(stored?.path)) return null;
        if (!Number.isFinite(stored?.ts) || now() - stored.ts > $d4d7a25942cf3f48$export$3c79a2f771bc9a1a) return null;
        return stored.path;
    } catch  {
        return null;
    }
}
function $d4d7a25942cf3f48$export$1fe6b79a37ae3c18() {
    try {
        if (window.location.pathname === '/') return;
        $d4d7a25942cf3f48$export$4986ea797be155b1(`${window.location.pathname}${window.location.search}`);
    } catch  {}
}
function $d4d7a25942cf3f48$export$2d1c01c0322daf36() {
    const refresh = (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)();
    if (!refresh) return null;
    const payload = (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)(refresh);
    // Keycloak offline tokens carry exp: 0, meaning "does not expire". Treating
    // that as "expired in 1970" would raise the dialog immediately on login.
    if (!payload?.exp) return null;
    return payload.exp * 1000;
}
function $d4d7a25942cf3f48$export$73946e6b8a04196b({ emit: emit = (0, $81fe69ded19c5b5e$export$c21f8c101d467dce), now: now = ()=>Date.now() } = {}) {
    let warnTimer = null;
    let endTimer = null;
    let cancelled = false;
    const clear = ()=>{
        clearTimeout(warnTimer);
        clearTimeout(endTimer);
        warnTimer = null;
        endTimer = null;
    };
    const arm = ()=>{
        clear();
        if (cancelled) return;
        const expiry = $d4d7a25942cf3f48$export$2d1c01c0322daf36();
        // No refresh token, or one that never expires: nothing to schedule. An
        // actual rejection still arrives through `emitSession` from bffClient, so
        // this is not the only path to the dialog.
        if (!expiry) return;
        const remaining = expiry - now();
        if (remaining <= 0) {
            emit((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRED);
            return;
        }
        const untilWarning = remaining - $d4d7a25942cf3f48$export$9a8e643ece3bd90e;
        if (untilWarning > 0) warnTimer = setTimeout(()=>emit((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRING), Math.min(untilWarning, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
        else emit((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRING);
        endTimer = setTimeout(()=>emit((0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRED), Math.min(remaining, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
    };
    arm();
    return {
        /** Re-read the token and re-arm. Call after any successful refresh. */ rearm: arm,
        cancel: ()=>{
            cancelled = true;
            clear();
        }
    };
}
async function $d4d7a25942cf3f48$export$d0caa90bfa1dd141() {
    const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)().catch(()=>false);
    return Boolean(ok);
}



const $be7f94ce6db606a5$export$5749bf3f1d0fd21b = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};
function $be7f94ce6db606a5$export$86b827a672ae590c() {
    const [status, setStatus] = (0, $acw62.useState)($be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE);
    const [secondsLeft, setSecondsLeft] = (0, $acw62.useState)(Math.round((0, $d4d7a25942cf3f48$export$9a8e643ece3bd90e) / 1000));
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const watcherRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const watcher = (0, $d4d7a25942cf3f48$export$73946e6b8a04196b)();
        watcherRef.current = watcher;
        const unsubscribe = (0, $81fe69ded19c5b5e$export$a883a9af61079ac7)((event)=>{
            setStatus((prev)=>{
                // Terminal. A late-firing `expiring` timer must not downgrade an expiry
                // that a rejected request has already proven — that would put a
                // countdown in front of a doctor whose session is definitively over and
                // offer them an extension that cannot work.
                if (prev === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED) return prev;
                if (event === (0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRED) return $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED;
                if (event === (0, $81fe69ded19c5b5e$export$3b6ed64b5b4e542d).EXPIRING) return $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING;
                return prev;
            });
        });
        return ()=>{
            unsubscribe();
            watcher.cancel();
        };
    }, []);
    // The countdown ticks only while it is on screen. A once-per-second timer
    // running for a doctor's whole shift to service a dialog that is almost never
    // open is pure waste.
    (0, $acw62.useEffect)(()=>{
        if (status !== $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING) return undefined;
        const tick = ()=>{
            const expiry = (0, $d4d7a25942cf3f48$export$2d1c01c0322daf36)();
            const remaining = expiry ? Math.round((expiry - Date.now()) / 1000) : 0;
            setSecondsLeft(Math.max(0, remaining));
        };
        tick();
        const id = setInterval(tick, 1000);
        return ()=>clearInterval(id);
    }, [
        status
    ]);
    /** «ادامهٔ کار» — renew silently and put the dialog away. */ const extend = (0, $acw62.useCallback)(async ()=>{
        setBusy(true);
        const ok = await (0, $d4d7a25942cf3f48$export$d0caa90bfa1dd141)();
        setBusy(false);
        if (!ok) {
            // The refresh token is dead. Retrying would fail identically, and a
            // spinner that never resolves is a worse answer than an honest one.
            setStatus($be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED);
            return false;
        }
        setStatus($be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE);
        // Re-arm against the NEW token: a renewal mints a new expiry, and the old
        // timers would otherwise fire against a token that no longer exists.
        watcherRef.current?.rearm();
        return true;
    }, []);
    /**
   * Hide the warning without extending.
   *
   * Does not cancel anything — the schedule still runs and the expired dialog
   * still arrives. A doctor mid-sentence is allowed to wave this away; they are
   * not allowed to switch off the fact that the session is ending.
   */ const dismissWarning = (0, $acw62.useCallback)(()=>{
        setStatus((prev)=>prev === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING ? $be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE : prev);
    }, []);
    /** Sign in again, returning to the page the doctor was interrupted on. */ const signInAgain = (0, $acw62.useCallback)(async ()=>{
        setBusy(true);
        (0, $d4d7a25942cf3f48$export$4986ea797be155b1)();
        await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
    }, []);
    return {
        status: status,
        secondsLeft: secondsLeft,
        busy: busy,
        isExpiring: status === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING,
        isExpired: status === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED,
        extend: extend,
        dismissWarning: dismissWarning,
        signInAgain: signInAgain
    };
}
var $be7f94ce6db606a5$export$2e2bcd8739ae039 = $be7f94ce6db606a5$export$86b827a672ae590c;



// ─────────────────────────────────────────────────────────────────────────────
// The gateway return leg.
//
// A top-up leaves the app: `window.location.href = gatewayUrl`. The payment BFF
// verifies and settles with the bank server-to-server — the browser never sees
// the receipt and could not settle one if it did — and then sends the doctor
// back to an in-app path carrying `?payment=success|failed`.
//
// Two things follow, and they are the whole reason this is a module rather than
// an effect inside `Credits`:
//
//   THE OUTCOME IS A MESSAGE, NOT A FACT. `?payment=success` is a hint from a
//   redirect anyone can type. The BALANCE is the truth, and it comes from a
//   refetch. So this decides what to SAY and never what to believe.
//
//   IT CAN LAND ANYWHERE. From an installed iOS PWA the gateway may open in a
//   different browsing context, and its redirect can arrive in one with no
//   `kc_token` — which sends the tab through Keycloak first. With the return
//   path remembered at boot (session.js), the doctor comes back to
//   `/credits?payment=…` and `Credits` reports it. But a return that lands on
//   any OTHER in-app route used to say nothing at all, so the shell handles the
//   same parameter wherever it appears.
// ─────────────────────────────────────────────────────────────────────────────
const $5ea0c392ab976e29$export$c7b7afff766a5a30 = 'payment';
function $5ea0c392ab976e29$export$366541b5137adfb1(search) {
    const raw = typeof search === 'string' ? search : window.location.search;
    const value = new URLSearchParams(raw).get($5ea0c392ab976e29$export$c7b7afff766a5a30);
    if (!value) return null;
    return value === 'success' ? 'success' : 'failed';
}
function $5ea0c392ab976e29$export$fdfdde46624d2732() {
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has($5ea0c392ab976e29$export$c7b7afff766a5a30)) return;
        url.searchParams.delete($5ea0c392ab976e29$export$c7b7afff766a5a30);
        const next = `${url.pathname}${url.search}${url.hash}`;
        window.history.replaceState(window.history.state, '', next);
    } catch  {}
}




var $ayMG0 = parcelRequire("ayMG0");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $iK5Lj = parcelRequire("iK5Lj");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The reception page's loading shapes. Only the day sheet is ever pending:
// the PageHeader, date navigator, KPI strip (`KpiCard loading`) and rail cards
// render for real around it (§"Independent loading states"), so these draw the
// two things that replace real rows — the desktop `AppointmentRow` block and
// the mobile `MobileAppointmentCard` list — at their real geometry.
// ─────────────────────────────────────────────────────────────────────────────
/** One `AppointmentRow` in placeholder: dot · time · divider · name/meta · chips. */ const $fc9cad95cac62ce8$var$AppointmentRowSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderTop: i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 8,
                circle: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 44,
                height: 13
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 1,
                    height: 28,
                    background: (0, $jTCZr.C).border,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${34 + i * 13 % 22}%`,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${22 + i * 7 % 18}%`,
                        height: 11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 64,
                height: 20,
                radius: (0, $jTCZr.RADIUS).pill
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                size: "sm",
                width: 84
            })
        ]
    });
const $fc9cad95cac62ce8$export$dc40c2b39562b6a8 = ({ rows: rows = 4, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "reception-day-skeleton",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
            style: {
                padding: 0,
                border: 'none',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 120,
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 56,
                            height: 20,
                            radius: (0, $jTCZr.RADIUS).pill
                        })
                    ]
                }),
                Array.from({
                    length: rows
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$AppointmentRowSkeleton, {
                        i: i
                    }, i))
            ]
        })
    });
};
/** One `MobileAppointmentCard`: status chip + time on top, name, meta, an action row. */ const $fc9cad95cac62ce8$var$MobileAppointmentCardSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 72,
                        height: 20,
                        radius: (0, $jTCZr.RADIUS).pill
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 44,
                        height: 14
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: `${48 + i * 17 % 30}%`,
                height: 15
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: `${30 + i * 11 % 24}%`,
                height: 11
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5rem',
                    marginTop: '0.125rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        size: "sm",
                        style: {
                            flex: 1,
                            width: 'auto'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        size: "sm",
                        style: {
                            flex: 1,
                            width: 'auto'
                        }
                    })
                ]
            })
        ]
    });
const $fc9cad95cac62ce8$export$f98bfe574c6e4fc7 = ({ count: count = 3, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "reception-list-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$MobileAppointmentCardSkeleton, {
                i: i
            }, i))
    });
};
var $fc9cad95cac62ce8$export$2e2bcd8739ae039 = $fc9cad95cac62ce8$export$dc40c2b39562b6a8;



var $6Md3F = parcelRequire("6Md3F");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3a9c585fee1ab085$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 2a9 9 0 0 1 9 9",
            key: "1itnx2"
        }
    ],
    [
        "path",
        {
            d: "M13 6a5 5 0 0 1 5 5",
            key: "11nki7"
        }
    ],
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $3a9c585fee1ab085$export$2e2bcd8739ae039 = (0, $9QBug.default)("phone-call", $3a9c585fee1ab085$export$3efd853dbb351e94);


var $8g4t5 = parcelRequire("8g4t5");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $gJslC = parcelRequire("gJslC");
var $hU4vR = parcelRequire("hU4vR");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $QG9Z3 = parcelRequire("QG9Z3");
var $6Md3F = parcelRequire("6Md3F");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1c03609248a88ad2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18",
            key: "16swn3"
        }
    ],
    [
        "path",
        {
            d: "M21 15.5V6a2 2 0 0 0-2-2H9.5",
            key: "yhw86o"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M3 10h7",
            key: "1wap6i"
        }
    ],
    [
        "path",
        {
            d: "M21 10h-5.5",
            key: "quycpq"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $1c03609248a88ad2$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar-off", $1c03609248a88ad2$export$3efd853dbb351e94);


var $kMJsW = parcelRequire("kMJsW");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cc37683d2791ff01$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const $cc37683d2791ff01$export$2e2bcd8739ae039 = (0, $9QBug.default)("map-pin", $cc37683d2791ff01$export$3efd853dbb351e94);


var $chm1L = parcelRequire("chm1L");

var $acw62 = parcelRequire("acw62");



var $4UJrq = parcelRequire("4UJrq");
const $5ce8d1a169b07fa7$export$c588754a2dac332e = 'AUTO';
// The Iran-local day a manual pick was made on. A pick lasts until the end of
// that day, then the lens shows every clinic again: otherwise one tap would hide
// the other clinics' appointments for good.
const $5ce8d1a169b07fa7$var$PICK_DAY_KEY = 'parsina_active_clinic_day_v1';
const $5ce8d1a169b07fa7$var$iranTodayISO = ()=>new Date(Date.now() + (0, $4UJrq.IRAN_OFFSET_MS)).toISOString().slice(0, 10);
function $5ce8d1a169b07fa7$var$readPickDay() {
    try {
        return localStorage.getItem($5ce8d1a169b07fa7$var$PICK_DAY_KEY) || '';
    } catch  {
        return '';
    }
}
function $5ce8d1a169b07fa7$var$writePickDay(day) {
    try {
        if (day) localStorage.setItem($5ce8d1a169b07fa7$var$PICK_DAY_KEY, day);
        else localStorage.removeItem($5ce8d1a169b07fa7$var$PICK_DAY_KEY);
    } catch  {
    // Storage blocked — the pick simply lasts this session.
    }
}
// What is stored, read once:
//   '' and no day   → never chose today: every clinic (the default);
//   '' and a day    → AUTO, picked on that day;
//   anything else   → a manual pick (a clinic, or a legacy ALL) with its day.
// A pick from before picks expired has no day — it is given today (one day of
// grace), not dropped mid-shift.
function $5ce8d1a169b07fa7$var$readStored() {
    const id = (0, $fdc4e943ddc88ca2$export$712e97de44ae5c43)();
    if (!id) return {
        id: '',
        day: $5ce8d1a169b07fa7$var$readPickDay()
    };
    let day = $5ce8d1a169b07fa7$var$readPickDay();
    if (!day) {
        day = $5ce8d1a169b07fa7$var$iranTodayISO();
        $5ce8d1a169b07fa7$var$writePickDay(day);
    }
    return {
        id: id,
        day: day
    };
}
function $5ce8d1a169b07fa7$export$43c1d8092712e085({ scheduledFor: scheduledFor, todayISO: todayISO } = {}) {
    const { targets: targets, pending: pending, loading: loading, error: error, refresh: refresh } = (0, $90c3af16928ea94c$export$f5416d3c5746c6f8)();
    const scheduledClinicId = (0, $acw62.useMemo)(()=>scheduledFor && !loading ? scheduledFor(targets) : null, [
        scheduledFor,
        loading,
        targets
    ]);
    const [stored, setStored] = (0, $acw62.useState)($5ce8d1a169b07fa7$var$readStored);
    const today = todayISO || $5ce8d1a169b07fa7$var$iranTodayISO();
    // «همهٔ مطب‌ها» is the default, so choosing it CLEARS the pick rather than
    // storing one: there is nothing to expire.
    const setActive = (0, $acw62.useCallback)((id)=>{
        const all = !id || id === (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d);
        const next = all || id === $5ce8d1a169b07fa7$export$c588754a2dac332e ? '' : id;
        const day = all ? '' : todayISO || $5ce8d1a169b07fa7$var$iranTodayISO();
        setStored({
            id: next,
            day: day
        });
        (0, $fdc4e943ddc88ca2$export$31ee8104798ff02e)(next);
        $5ce8d1a169b07fa7$var$writePickDay(day);
    }, [
        todayISO
    ]);
    // A pick made on an earlier day has expired: clear it, so a reload tomorrow
    // does not resurrect it either.
    const expired = !!stored.day && stored.day !== today;
    (0, $acw62.useEffect)(()=>{
        if (!expired) return;
        (0, $fdc4e943ddc88ca2$export$31ee8104798ff02e)('');
        $5ce8d1a169b07fa7$var$writePickDay('');
        setStored({
            id: '',
            day: ''
        });
    }, [
        expired
    ]);
    const mode = expired || !stored.day || stored.id === (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d) ? 'all' : !stored.id ? 'auto' : 'pick';
    // Every id is resolved against the membership NOW, every render: a doctor
    // removed from a clinic would otherwise keep filtering پذیرش by a clinic
    // they are no longer in — an empty day sheet with no visible reason. AUTO
    // also answers «all» while the schedule is unknown, so the first paint shows
    // everything and then narrows, never the reverse (rows appearing reads as
    // new bookings).
    //
    // With ONE membership the chip names that clinic, but `filterId` stays ALL:
    // filtering by the only clinic is meant to be a no-op, and when it is not —
    // rows from a clinic the doctor has left, or a membership the lookup missed —
    // it would hide them behind a «نمایش همه» that has nothing to widen to.
    const activeId = (0, $acw62.useMemo)(()=>{
        if (loading) return 0, $fdc4e943ddc88ca2$export$c5abb0256123e62d;
        if (targets.length === 1) return targets[0].id; // no choice to make
        const member = (id)=>targets.some((c)=>c.id === id);
        if (mode === 'all') return 0, $fdc4e943ddc88ca2$export$c5abb0256123e62d;
        if (mode === 'pick' && member(stored.id)) return stored.id;
        return scheduledClinicId && member(scheduledClinicId) ? scheduledClinicId : (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d);
    }, [
        loading,
        targets,
        mode,
        stored.id,
        scheduledClinicId
    ]);
    const isAll = activeId === (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d);
    const filterId = targets.length > 1 ? activeId : (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d);
    const activeClinic = (0, $acw62.useMemo)(()=>isAll ? null : targets.find((c)=>c.id === activeId) || null, [
        isAll,
        targets,
        activeId
    ]);
    return {
        clinics: targets,
        pending: pending,
        loading: loading,
        activeId: activeId,
        filterId: /** What to pass to `scopeToClinic` — never narrower than the chip can widen. */ filterId,
        activeClinic: activeClinic,
        isAll: isAll,
        /** 'auto' (follows the schedule) | 'all' | 'pick' — only meaningful with >1 clinic. */ mode: targets.length > 1 ? mode : 'pick',
        setActive: setActive,
        refresh: refresh,
        /** Exactly one membership: the chip informs, it does not offer a choice. */ single: !loading && targets.length === 1,
        error: /** The membership lookup FAILED — we do not know whether there is a clinic. */ error,
        /** No membership at all, as the server said — پذیرش renders the connection
     *  guide. Never true after a failed lookup: that is `error`. */ none: !loading && !error && targets.length === 0
    };
}
function $5ce8d1a169b07fa7$export$b38dd7193ebd93c1(appointments, activeId) {
    const list = appointments || [];
    if (!activeId || activeId === (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d)) return {
        rows: list,
        hidden: 0
    };
    const rows = list.filter((a)=>!a.clinicId || a.clinicId === activeId);
    return {
        rows: rows,
        hidden: list.length - rows.length
    };
}


// The one day-model both پذیرش surfaces (web + mobile) render from.
// DESIGN-CONCEPT §4.3/§4.4: platform files are render-only; who is next, what the
// queue order is and what the day's counts are must be a single computation, or the
// two surfaces will eventually disagree about which patient walks in next.

var $acw62 = parcelRequire("acw62");


var $4UJrq = parcelRequire("4UJrq");


var $acw62 = parcelRequire("acw62");


var $4UJrq = parcelRequire("4UJrq");
// ─────────────────────────────────────────────────────────────────────────────
// «ثبت نوبت» from the doctor app — by the clinic's grant.
//
// Every clinic this doctor may book at comes with its terms (`canBookDirectly`).
// The grant is the clinic's, per practitioner, and ON by default; when a clinic
// has withdrawn it, a booking is still accepted but lands `requested` —
// «در انتظار تأیید کلینیک» — for the desk to confirm in «درخواست‌های نوبت».
//
// The BFF decides the grant again at write time from the membership row; the
// list here only lets the form SAY which of the two will happen before the
// doctor presses the button. It is display, never the authority.
// ─────────────────────────────────────────────────────────────────────────────
const $917ea62a53046a22$var$BOOKING_CLINICS_QUERY = `
  query MyBookingClinics {
    myBookingClinics { clinicId name isOwner canBookDirectly visitDurationMinutes }
  }
`;
const $917ea62a53046a22$var$BOOK_APPOINTMENT = `
  mutation BookAppointment($input: DoctorBookingInput!) {
    bookAppointment(input: $input) {
      outcome
      appointment { id status dateTime clinicId }
    }
  }
`;
const $917ea62a53046a22$var$FIRST_AVAILABLE_SLOT = `
  query FirstAvailableSlot($clinicId: ID!, $fromDateTime: String!, $scope: FirstSlotScope!, $durationMinutes: Int) {
    firstAvailableSlot(clinicId: $clinicId, fromDateTime: $fromDateTime, scope: $scope, durationMinutes: $durationMinutes) {
      dateTime
      isAvailable
    }
  }
`;
const $917ea62a53046a22$var$ADD_PATIENT = `
  mutation QuickAddPatient($input: CreatePatientInput!) {
    addPatient(input: $input) { id name phone }
  }
`;
const $917ea62a53046a22$var$WITHDRAW_REQUEST = `
  mutation WithdrawAppointmentRequest($appointmentId: ID!) {
    withdrawAppointmentRequest(appointmentId: $appointmentId) { id status }
  }
`;
// «تغییر زمان نوبت» (PM-0102) — the caller's own `scheduled` appointment, moved.
const $917ea62a53046a22$var$RESCHEDULE_APPOINTMENT = `
  mutation RescheduleAppointment($appointmentId: ID!, $newDateTime: String!) {
    rescheduleAppointment(appointmentId: $appointmentId, newDateTime: $newDateTime) { id status dateTime clinicId }
  }
`;
function $917ea62a53046a22$export$9dab6106cce55aad(value) {
    const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!m) return null;
    const ms = Date.parse(`${m[1]}T${m[2]}:${m[3]}:00Z`);
    return Number.isFinite(ms) ? ms - (0, $4UJrq.IRAN_OFFSET_MS) : null;
}
function $917ea62a53046a22$export$ea965b90d2460726(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    const iso = new Date(n + (0, $4UJrq.IRAN_OFFSET_MS)).toISOString();
    return `${iso.slice(0, 10)} ${iso.slice(11, 16)}`;
}
function $917ea62a53046a22$export$bb0bcaf0a6a50714(ms) {
    const n = Number(ms);
    return Number.isFinite(n) && n > 0 ? new Date(n + (0, $4UJrq.IRAN_OFFSET_MS)).toISOString().slice(0, 10) : null;
}
function $917ea62a53046a22$export$8c529a5324765e93({ enabled: enabled, clinicId: clinicId, fromDateTime: fromDateTime, scope: scope, durationMinutes: durationMinutes }) {
    const [state, setState] = (0, $acw62.useState)({
        slot: null,
        loading: false,
        error: false
    });
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !clinicId || !fromDateTime) {
            setState({
                slot: null,
                loading: false,
                error: false
            });
            return undefined;
        }
        let alive = true;
        setState({
            slot: null,
            loading: true,
            error: false
        });
        const timer = setTimeout(()=>{
            (0, $adebb901af88e18b$export$7fb4864174f056c)($917ea62a53046a22$var$FIRST_AVAILABLE_SLOT, {
                clinicId: clinicId,
                fromDateTime: fromDateTime,
                scope: scope,
                durationMinutes: durationMinutes || null
            }).then((data)=>{
                if (alive) setState({
                    slot: data?.firstAvailableSlot || null,
                    loading: false,
                    error: false
                });
            }).catch(()=>{
                if (alive) setState({
                    slot: null,
                    loading: false,
                    error: true
                });
            });
        }, 300);
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        enabled,
        clinicId,
        fromDateTime,
        scope,
        durationMinutes
    ]);
    return state;
}
function $917ea62a53046a22$export$d390b7bb6e3190e5({ enabled: enabled = true } = {}) {
    const [clinics, setClinics] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [nonce, setNonce] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        let alive = true;
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($917ea62a53046a22$var$BOOKING_CLINICS_QUERY).then((data)=>{
            if (alive) setClinics(data?.myBookingClinics || []);
        }).catch((err)=>{
            if (!alive) return;
            setError(err);
            setClinics((prev)=>prev || []);
        });
        return ()=>{
            alive = false;
        };
    }, [
        enabled,
        nonce
    ]);
    const reload = (0, $acw62.useCallback)(()=>setNonce((n)=>n + 1), []);
    return {
        clinics: clinics,
        loading: enabled && clinics === null,
        error: error,
        reload: reload
    };
}
async function $917ea62a53046a22$export$2ac64a422d3a9b85(input) {
    const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($917ea62a53046a22$var$BOOK_APPOINTMENT, {
        input: input
    });
    return data?.bookAppointment || null;
}
async function $917ea62a53046a22$export$15ba41c58b2edfba({ name: name, phone: phone, nationalId: nationalId }) {
    const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($917ea62a53046a22$var$ADD_PATIENT, {
        input: {
            name: name.trim(),
            phone: phone || null,
            nationalId: nationalId || null
        }
    });
    return data?.addPatient || null;
}
async function $917ea62a53046a22$export$d49bf8b0d6ea0efc(appointmentId, newDateTimeMs) {
    const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($917ea62a53046a22$var$RESCHEDULE_APPOINTMENT, {
        appointmentId: appointmentId,
        newDateTime: String(newDateTimeMs)
    });
    return data?.rescheduleAppointment || null;
}
async function $917ea62a53046a22$export$c958230cc210d176(appointmentId) {
    const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($917ea62a53046a22$var$WITHDRAW_REQUEST, {
        appointmentId: appointmentId
    });
    return data?.withdrawAppointmentRequest || null;
}
function $917ea62a53046a22$export$dbfe74f291058e97(err) {
    return err?.extensions?.code || err?.graphQLErrors?.[0]?.extensions?.code || err?.errors?.[0]?.extensions?.code || null;
}


// The doctor-room queue is set at the clinic desk, on another screen. The realtime
// socket pushes those changes instantly; polling is only the fallback for when the
// socket is down — slow while it's healthy, brisk when it isn't.
const $348bda64e291efe9$var$POLL_FALLBACK_MS = 20000;
const $348bda64e291efe9$var$POLL_IDLE_MS = 60000;
function $348bda64e291efe9$export$79b2d7cfba3d363a(iso) {
    const start = Date.parse(`${iso}T00:00:00Z`) - (0, $4UJrq.IRAN_OFFSET_MS);
    return {
        start: start,
        end: start + 86400000
    };
}
// One shape for every appointment fetch on this screen. durationMinutes / arrivedAt /
// visitStartedAt are what turn the list into a clock: waiting-since on arrived rows,
// visit-open-for on the in_visit hero.
const $348bda64e291efe9$var$APPOINTMENT_FIELDS = `
  id
  patientId
  doctorId
  name
  time
  date
  dateTime
  status
  specialty
  urgency
  queuePosition
  durationMinutes
  arrivedAt
  visitStartedAt
  clinicId
  source
  patient {
    phone
  }
`;
// The selected day only — the doctor's whole history has no business on a day sheet.
const $348bda64e291efe9$var$DAY_APPOINTMENTS_QUERY = `
  query DayAppointments($startTime: String, $endTime: String) {
    appointments(startTime: $startTime, endTime: $endTime) {
      ${$348bda64e291efe9$var$APPOINTMENT_FIELDS}
    }
  }
`;
// The forgotten-visit sweep: every in_visit appointment, ANY day. A visit left open
// yesterday is invisible to a day-bounded query, which is exactly how it gets
// forgotten — so this one is deliberately unbounded (in_visit rows are at most a
// handful; completing them is the only way out of this result set).
const $348bda64e291efe9$var$OPEN_VISITS_QUERY = `
  query OpenVisits {
    appointments(status: "in_visit") {
      ${$348bda64e291efe9$var$APPOINTMENT_FIELDS}
    }
  }
`;
const $348bda64e291efe9$var$MARK_ARRIVED = `
  mutation MarkArrived($appointmentId: ID!) {
    markArrived(appointmentId: $appointmentId) { id status }
  }
`;
const $348bda64e291efe9$var$END_VISIT = `
  mutation EndVisit($id: ID!) {
    endVisit(id: $id) { id status }
  }
`;
// ── The doctor-room queue (صف اتاق پزشک) ───────────────────────────────────────
// Entry order, mirroring get_queue_status in the scheduling service: in_visit pinned
// first, then the manual position the clinic desk set (unpositioned last), then
// urgency, then appointment time. The server is authoritative — if this drifts from
// it, the doctor and the desk disagree about who walks in next.
const $348bda64e291efe9$var$URGENCY_RANK = {
    emergency: 0,
    urgent: 1
};
function $348bda64e291efe9$export$2bf565205c4c2dc1(a, b) {
    const statusRank = (x)=>x.status === 'in_visit' ? 0 : 1;
    const posRank = (x)=>x.queuePosition == null ? Number.MAX_SAFE_INTEGER : x.queuePosition;
    return statusRank(a) - statusRank(b) || posRank(a) - posRank(b) || ($348bda64e291efe9$var$URGENCY_RANK[a.urgency] ?? 2) - ($348bda64e291efe9$var$URGENCY_RANK[b.urgency] ?? 2) || String(a.time || '').localeCompare(String(b.time || ''));
}
function $348bda64e291efe9$export$b8e62685b122f2f2(appointments) {
    return appointments.filter((a)=>a.status === 'arrived' || a.status === 'in_visit').sort($348bda64e291efe9$export$2bf565205c4c2dc1);
}
const $348bda64e291efe9$export$be27e68c583a278e = 7200000;
function $348bda64e291efe9$export$e38f5492dd7c5c53(apt, nowMs) {
    const started = Number(apt?.visitStartedAt);
    if (!started) return {
        elapsedMin: null,
        level: 'normal'
    };
    const elapsedMin = Math.max(0, Math.floor((nowMs - started) / 60000));
    const dur = apt.durationMinutes || 30;
    const level = elapsedMin > 2 * dur ? 'critical' : elapsedMin > dur ? 'over' : 'normal';
    return {
        elapsedMin: elapsedMin,
        level: level
    };
}
function $348bda64e291efe9$export$8820bfcc7ef6bb39(apt, nowMs) {
    const arrived = Number(apt?.arrivedAt);
    if (!arrived) return null;
    return Math.max(0, Math.floor((nowMs - arrived) / 60000));
}
function $348bda64e291efe9$export$da5e66bfeb457ef8(openVisits, nowMs) {
    const iranNow = new Date(nowMs + (0, $4UJrq.IRAN_OFFSET_MS));
    const todayStartMs = Date.UTC(iranNow.getUTCFullYear(), iranNow.getUTCMonth(), iranNow.getUTCDate()) - (0, $4UJrq.IRAN_OFFSET_MS);
    return openVisits.filter((a)=>{
        const started = Number(a.visitStartedAt);
        if (!started) return false; // no clock — pre-migration row; the hero still shows it today
        return nowMs - started > $348bda64e291efe9$export$be27e68c583a278e || started < todayStartMs;
    });
}
function $348bda64e291efe9$export$58c8c934fcb7a3d9(selISO) {
    const [appointments, setAppointments] = (0, $acw62.useState)([]);
    const [openVisits, setOpenVisits] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const selRef = (0, $acw62.useRef)(selISO);
    selRef.current = selISO;
    const fetchDay = (0, $acw62.useCallback)(async (iso)=>{
        const { start: start, end: end } = $348bda64e291efe9$export$79b2d7cfba3d363a(iso);
        const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($348bda64e291efe9$var$DAY_APPOINTMENTS_QUERY, {
            startTime: String(start),
            endTime: String(end - 1)
        });
        // A slow response for a day the user has already navigated away from must not
        // overwrite the day they are looking at.
        if (selRef.current === iso) setAppointments(data?.appointments || []);
    }, []);
    const fetchOpenVisits = (0, $acw62.useCallback)(async ()=>{
        const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($348bda64e291efe9$var$OPEN_VISITS_QUERY);
        setOpenVisits(data?.appointments || []);
    }, []);
    const reload = (0, $acw62.useCallback)(async ({ initial: initial = false } = {})=>{
        const iso = selRef.current;
        if (initial) setLoading(true);
        const results = await Promise.allSettled([
            fetchDay(iso),
            fetchOpenVisits()
        ]);
        if (initial) {
            // The day list decides: without it there is nothing honest to show. A failed
            // open-visit sweep alone only hides the forgotten-visit alert.
            const [dayResult] = results;
            setError(dayResult.status === 'rejected' ? dayResult.reason : null);
            setLoading(false);
        }
        results.forEach((r)=>{
            if (r.status === 'rejected') console.error('reception fetch error:', r.reason);
        });
    }, [
        fetchDay,
        fetchOpenVisits
    ]);
    // Initial load + reload on day change.
    (0, $acw62.useEffect)(()=>{
        reload({
            initial: true
        });
    }, [
        selISO,
        reload
    ]);
    // Realtime: any scheduling event for this doctor (arrival, in-visit, reorder,
    // complete/cancel) triggers a refetch. Debounced — a reorder can land as a burst
    // of events, and one refetch settles them all.
    const debounceRef = (0, $acw62.useRef)(null);
    const onRealtime = (0, $acw62.useCallback)(()=>{
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(()=>reload(), 300);
    }, [
        reload
    ]);
    const { connected: realtimeConnected } = (0, $57c81437ed051aa9$export$30a0463a44a8ca67)(onRealtime);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(debounceRef.current), []);
    // Poll as a safety net: slow while the socket is live (it carries the real
    // updates), brisk when it isn't (polling is all we have).
    (0, $acw62.useEffect)(()=>{
        const interval = realtimeConnected ? $348bda64e291efe9$var$POLL_IDLE_MS : $348bda64e291efe9$var$POLL_FALLBACK_MS;
        const id = setInterval(()=>reload(), interval);
        return ()=>clearInterval(id);
    }, [
        reload,
        realtimeConnected
    ]);
    const retry = (0, $acw62.useCallback)(()=>reload({
            initial: true
        }), [
        reload
    ]);
    // Clinical writes are never optimistic (DC §8): the row changes when the
    // server says so. Both reject on failure so the caller can SAY it failed —
    // they used to end in console.error, and the row just quietly reverted.
    const markArrived = (0, $acw62.useCallback)(async (appointmentId)=>{
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($348bda64e291efe9$var$MARK_ARRIVED, {
                appointmentId: appointmentId
            });
        } finally{
            reload();
        }
    }, [
        reload
    ]);
    // پایان ویزیت from پذیرش — the escape hatch for an overrunning or
    // forgotten visit, same completion path the Visit screen uses.
    const endVisit = (0, $acw62.useCallback)(async (appointmentId)=>{
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($348bda64e291efe9$var$END_VISIT, {
                id: appointmentId
            });
            setAppointments((prev)=>prev.map((a)=>a.id === appointmentId ? {
                        ...a,
                        status: 'completed'
                    } : a));
            setOpenVisits((prev)=>prev.filter((a)=>a.id !== appointmentId));
        } finally{
            reload();
        }
    }, [
        reload
    ]);
    // «لغو درخواست» — the doctor's OWN booking still awaiting the clinic. Rejects on
    // failure so the row can say so; the row leaves the list when the server says.
    const withdrawRequest = (0, $acw62.useCallback)(async (appointmentId)=>{
        try {
            await (0, $917ea62a53046a22$export$c958230cc210d176)(appointmentId);
        } finally{
            reload();
        }
    }, [
        reload
    ]);
    return {
        appointments: appointments,
        openVisits: openVisits,
        loading: loading,
        error: error,
        retry: retry,
        markArrived: markArrived,
        endVisit: endVisit,
        withdrawRequest: withdrawRequest,
        reload: reload
    };
}
// ── Week ahead ─────────────────────────────────────────────────────────────────
// Appointment counts for the next 7 Iran-local days — one bounded query, refreshed
// when the day rolls over. Cancelled rows don't count toward a day's workload.
const $348bda64e291efe9$var$WEEK_COUNT_QUERY = `
  query WeekAppointments($startTime: String, $endTime: String) {
    appointments(startTime: $startTime, endTime: $endTime) {
      id
      date
      status
    }
  }
`;
// Counts for the seven Iran-local days starting at `startISO`. The desktop rail
// asks for the week AHEAD (starting today); the mobile week sheet asks for a
// Jalali week (starting Saturday) and pages through them — one counting rule
// for both, so a day showing three appointments in one shows three in the other.
//
// Answers are cached per start date for the session and re-asked when older
// than 60s, so paging back and forth in the sheet does not re-fetch every tap.
const $348bda64e291efe9$var$WEEK_COUNT_TTL_MS = 60000;
const $348bda64e291efe9$var$weekCountCache = new Map(); // startISO → { at, counts: Map(iso → n) }
function $348bda64e291efe9$export$5daa0bba04a03133(startISO, { enabled: enabled = true } = {}) {
    const [byDay, setByDay] = (0, $acw62.useState)(()=>$348bda64e291efe9$var$weekCountCache.get(startISO)?.counts || null);
    (0, $acw62.useEffect)(()=>{
        if (!startISO || !enabled) return undefined;
        const cached = $348bda64e291efe9$var$weekCountCache.get(startISO);
        setByDay(cached ? cached.counts : null);
        if (cached && Date.now() - cached.at < $348bda64e291efe9$var$WEEK_COUNT_TTL_MS) return undefined;
        let alive = true;
        const { start: start } = $348bda64e291efe9$export$79b2d7cfba3d363a(startISO);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($348bda64e291efe9$var$WEEK_COUNT_QUERY, {
            startTime: String(start),
            endTime: String(start + 604800000 - 1)
        }).then((data)=>{
            const counts = new Map();
            (data?.appointments || []).forEach((a)=>{
                if (a.status === 'cancelled' || !a.date) return;
                counts.set(a.date, (counts.get(a.date) || 0) + 1);
            });
            $348bda64e291efe9$var$weekCountCache.set(startISO, {
                at: Date.now(),
                counts: counts
            });
            if (alive) setByDay(counts);
        }).catch((err)=>console.error('weekCounts error:', err));
        return ()=>{
            alive = false;
        };
    }, [
        startISO,
        enabled
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (!startISO) return [];
        const base = Date.parse(`${startISO}T12:00:00Z`);
        return Array.from({
            length: 7
        }, (_, i)=>{
            const iso = new Date(base + i * 86400000).toISOString().split('T')[0];
            return {
                iso: iso,
                count: byDay ? byDay.get(iso) || 0 : null
            };
        });
    }, [
        startISO,
        byDay
    ]);
}
function $348bda64e291efe9$export$edba156216bf7de4(todayISO) {
    return $348bda64e291efe9$export$5daa0bba04a03133(todayISO);
}
// ── Today's income ─────────────────────────────────────────────────────────────
// The doctor's share of today's invoiced work, in MINOR UNITS of its currency as it
// comes off the wire (whole rials for IRR) — the display conversion belongs to the
// display edge. Aggregates cover the whole window regardless of pageSize, so one
// line is all we need to carry them.
//
// The day spans every clinic the doctor works at, and those can keep their books
// in different currencies. The scalar totals are then NULL — there is no single
// currency to state them in — so the figures are read per currency from
// `totalsByCurrency`, and a `|| 0` can never turn «two currencies» into «nothing».
const $348bda64e291efe9$var$TODAY_INCOME_QUERY = `
  query TodayIncome($fromTs: Float, $toTs: Float) {
    doctorAccountingReport(fromTs: $fromTs, toTs: $toTs, pageSize: 1) {
      doctorShareTotal
      collectedDoctorShare
      totalsByCurrency { currency doctorShareTotal collectedDoctorShare }
      mixedCurrency
      types {
        itemType
        count
      }
    }
  }
`;
const $348bda64e291efe9$var$unsettledOf = (share, collected)=>Math.max(0, (share || 0) - (collected || 0));
function $348bda64e291efe9$export$849954cdf0e90006(r) {
    const visitCount = r.types?.find((item)=>item.itemType === 'VISIT')?.count || 0;
    const byCurrency = (Array.isArray(r.totalsByCurrency) ? r.totalsByCurrency : []).map((g)=>({
            currency: g.currency || '',
            shareRial: g.doctorShareTotal || 0,
            unsettledRial: $348bda64e291efe9$var$unsettledOf(g.doctorShareTotal, g.collectedDoctorShare)
        }));
    if (byCurrency.length > 1 || r.mixedCurrency) return {
        shareRial: null,
        unsettledRial: null,
        visitCount: visitCount,
        byCurrency: byCurrency
    };
    if (byCurrency.length === 1) return {
        shareRial: byCurrency[0].shareRial,
        unsettledRial: byCurrency[0].unsettledRial,
        visitCount: visitCount,
        byCurrency: byCurrency
    };
    return {
        shareRial: r.doctorShareTotal || 0,
        unsettledRial: $348bda64e291efe9$var$unsettledOf(r.doctorShareTotal, r.collectedDoctorShare),
        visitCount: visitCount,
        byCurrency: byCurrency
    };
}
function $348bda64e291efe9$export$3e8165f49f0984d5(todayISO) {
    const [income, setIncome] = (0, $acw62.useState)(null); // null = loading, false = unavailable
    (0, $acw62.useEffect)(()=>{
        if (!todayISO) return;
        let alive = true;
        const { start: start, end: end } = $348bda64e291efe9$export$79b2d7cfba3d363a(todayISO);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($348bda64e291efe9$var$TODAY_INCOME_QUERY, {
            fromTs: start,
            toTs: end - 1
        }).then((data)=>{
            if (!alive) return;
            const r = data?.doctorAccountingReport;
            if (!r) {
                setIncome(false);
                return;
            }
            setIncome($348bda64e291efe9$export$849954cdf0e90006(r));
        }).catch((err)=>{
            console.error('todayIncome error:', err);
            if (alive) setIncome(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        todayISO
    ]);
    return income;
}


// Appointment display derivations shared by BOTH render surfaces (web components
// and src/components/mobile/). Render trees are forked by design; the vocabulary —
// urgency labels, duration phrasing, the hero's escalation model — must not be.

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

const $13f800aa071fd2d2$export$7caf56b642c4b5aa = (s)=>s === 'completed' || s === 'cancelled' || s === 'rejected' || s === 'no_show';
const $13f800aa071fd2d2$export$c681edc7fb7265b4 = (s)=>s === 'arrived' || s === 'in_visit';
const $13f800aa071fd2d2$export$2498094d90b6ac72 = (s)=>s === 'requested' || s === 'rejected';
const $13f800aa071fd2d2$export$1fb2f46ad857789e = (apt)=>apt?.status === 'requested' && apt?.source === 'doctor_app';
const $13f800aa071fd2d2$export$ee8d39e3e546e43 = 20;
const $13f800aa071fd2d2$export$a08a3225103fa8fb = {
    emergency: {
        labelKey: 'common.urgency.emergency',
        color: (0, $jTCZr.CT).dangerInk,
        bg: (0, $jTCZr.C).redLight
    },
    urgent: {
        labelKey: 'common.urgency.urgent',
        color: (0, $jTCZr.CT).warnInk,
        bg: (0, $jTCZr.C).amberLight
    }
};
const $13f800aa071fd2d2$export$bc733b0c5cbb3e8a = (item, min)=>{
    if (min == null || !Number.isFinite(Number(min))) return '';
    const total = Math.max(0, Math.round(Number(min)));
    if (total < 60) return item('common.duration.minutes', {
        count: total
    });
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    return minutes === 0 ? item('common.duration.hours', {
        hours: hours
    }) : item('common.duration.hoursMinutes', {
        hours: hours,
        minutes: minutes
    });
};
const $13f800aa071fd2d2$var$toMinutes = (t = '00:00')=>{
    const [h, m] = t.split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
};
function $13f800aa071fd2d2$export$29d3aa8816e57583(apt, nowMin, nowMs, item) {
    const inVisit = apt.status === 'in_visit';
    const present = $13f800aa071fd2d2$export$c681edc7fb7265b4(apt.status);
    const { elapsedMin: elapsedMin, level: level } = inVisit ? (0, $348bda64e291efe9$export$e38f5492dd7c5c53)(apt, nowMs) : {
        elapsedMin: null,
        level: 'normal'
    };
    const waited = apt.status === 'arrived' ? (0, $348bda64e291efe9$export$8820bfcc7ef6bb39)(apt, nowMs) : null;
    const diff = $13f800aa071fd2d2$var$toMinutes(apt.time) - nowMin;
    const waitLabel = inVisit ? item('dashboard.hero.inYourRoom') : present ? waited != null ? item('dashboard.hero.waitingSince', {
        count: waited
    }) : item('dashboard.hero.waitingForYou') : diff <= 0 ? item('dashboard.hero.rightNow') : item('dashboard.hero.startsIn', {
        duration: $13f800aa071fd2d2$export$bc733b0c5cbb3e8a(item, diff)
    });
    return {
        inVisit: inVisit,
        present: present,
        elapsedMin: elapsedMin,
        level: level,
        waitLabel: waitLabel,
        heroLabel: inVisit ? item('dashboard.hero.inVisit') : present ? item('dashboard.hero.nextIn') : item('dashboard.hero.nextAppointment'),
        urg: $13f800aa071fd2d2$export$a08a3225103fa8fb[apt.urgency],
        initials: (apt.name || item('common.labels.patient')).split(' ').map((p)=>p[0]).join('').slice(0, 2),
        background: level === 'critical' ? (0, $jTCZr.C).red : (0, $jTCZr.GRADIENT_BRAND),
        dotColor: level === 'critical' ? (0, $jTCZr.C).redLight : level === 'over' ? (0, $jTCZr.C).amberLight : (0, $jTCZr.C).tealLight
    };
}



var $2vdhF = parcelRequire("2vdhF");

var $4UJrq = parcelRequire("4UJrq");

var $eLeza = parcelRequire("eLeza");
const $a7a51f8e25be6339$export$4a79f0068700788b = (t = '00:00')=>{
    const [h, m] = t.split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
};
function $a7a51f8e25be6339$export$23389b4a74f4886a(iso) {
    if ((0, $eLeza.calendarSystem)('jalali') === 'gregory') {
        const day = Number(String(iso).slice(8, 10));
        return Number.isInteger(day) && day > 0 ? day : undefined;
    }
    return (0, $4UJrq.msToJalali)(Date.parse(`${iso}T12:00:00Z`) + (0, $4UJrq.IRAN_OFFSET_MS))?.d;
}
function $a7a51f8e25be6339$export$78d8ee1fd0f50c36(ms, { formatDate: formatDate, withYear: withYear = false } = {}) {
    if (!formatDate || ms == null) return '';
    return formatDate(ms, withYear ? 'full' : 'weekdayDayMonth');
}
function $a7a51f8e25be6339$export$7220dacb4acc7cd3(ms, { formatDate: formatDate } = {}) {
    if (!formatDate || ms == null) return '';
    return formatDate(ms, 'dayMonth');
}
function $a7a51f8e25be6339$export$ad1ae77322e9b4e5({ appointments: appointments, isToday: isToday, nowMin: nowMin }) {
    const dayApts = [
        ...appointments
    ].sort((a, b)=>$a7a51f8e25be6339$export$4a79f0068700788b(a.time) - $a7a51f8e25be6339$export$4a79f0068700788b(b.time));
    const queue = isToday ? (0, $348bda64e291efe9$export$b8e62685b122f2f2)(dayApts) : [];
    const queueIds = new Set(queue.map((a)=>a.id));
    const upcoming = dayApts.filter((a)=>!queueIds.has(a.id) && !(0, $13f800aa071fd2d2$export$7caf56b642c4b5aa)(a.status));
    const done = dayApts.filter((a)=>(0, $13f800aa071fd2d2$export$7caf56b642c4b5aa)(a.status));
    const queuePosOf = new Map(queue.filter((a)=>a.status === 'arrived').map((a, i)=>[
            a.id,
            i + 1
        ]));
    const nextApt = isToday ? queue[0] || upcoming.find((a)=>$a7a51f8e25be6339$export$4a79f0068700788b(a.time) >= nowMin) || null : null;
    return {
        dayApts: dayApts,
        queue: queue,
        queueIds: queueIds,
        upcoming: upcoming,
        done: done,
        queuePosOf: queuePosOf,
        nextApt: nextApt
    };
}
function $a7a51f8e25be6339$export$8850f67511986f5(model, { isToday: isToday, nowMin: nowMin }) {
    const stillToCome = model.upcoming.filter((a)=>!isToday || $a7a51f8e25be6339$export$4a79f0068700788b(a.time) >= nowMin);
    return [
        ...model.queue,
        ...stillToCome.filter((a)=>!model.queueIds.has(a.id))
    ];
}
function $a7a51f8e25be6339$export$c8c7db9d09049583(dayApts) {
    return {
        total: dayApts.length,
        here: dayApts.filter((a)=>(0, $13f800aa071fd2d2$export$c681edc7fb7265b4)(a.status)).length,
        scheduled: dayApts.filter((a)=>a.status === 'scheduled').length,
        waiting: dayApts.filter((a)=>a.status === 'scheduled' || a.status === 'arrived').length,
        completed: dayApts.filter((a)=>a.status === 'completed').length,
        cancelled: dayApts.filter((a)=>a.status === 'cancelled').length
    };
}
function $a7a51f8e25be6339$export$22c77c4973888dc6(windows, iso, memberIds) {
    const dow = (0, $2vdhF.irWeekday)(iso);
    return (windows || []).filter((w)=>{
        if (memberIds && !memberIds.has(w.clinicId)) return false;
        return w.specificDate ? w.specificDate === iso : w.dayOfWeek === dow;
    });
}
function $a7a51f8e25be6339$export$4f26007ea9ea304b(windows) {
    const byClinic = new Map();
    for (const w of windows || []){
        if (!(w.endMinute > w.startMinute)) continue;
        if (!byClinic.has(w.clinicId)) byClinic.set(w.clinicId, []);
        byClinic.get(w.clinicId).push({
            clinicId: w.clinicId,
            start: w.startMinute,
            end: w.endMinute
        });
    }
    const out = [];
    for (const list of byClinic.values()){
        list.sort((a, b)=>a.start - b.start);
        let cur = null;
        for (const w of list)if (cur && w.start <= cur.end) cur.end = Math.max(cur.end, w.end);
        else {
            cur = {
                ...w
            };
            out.push(cur);
        }
    }
    return out.sort((a, b)=>a.start - b.start || a.end - b.end);
}
function $a7a51f8e25be6339$export$ac6a645c99fbd1e({ windows: windows, status: status = 'ready', clinics: clinics = [], dayISO: dayISO, isToday: isToday, nowMin: nowMin }) {
    if (!clinics.length) return {
        state: 'no_clinic',
        scheduledClinicId: null
    };
    if (status !== 'ready') return {
        state: 'unknown',
        scheduledClinicId: null
    };
    const memberIds = new Set(clinics.map((c)=>c.id));
    const day = $a7a51f8e25be6339$export$4f26007ea9ea304b($a7a51f8e25be6339$export$22c77c4973888dc6(windows, dayISO, memberIds));
    const distinct = (list)=>[
            ...new Set(list.map((w)=>w.clinicId))
        ];
    if (!day.length) return {
        state: 'no_shift',
        scheduledClinicId: null,
        day: day
    };
    if (!isToday) {
        const ids = distinct(day);
        return {
            state: 'other_day',
            day: day,
            clinicIds: ids,
            scheduledClinicId: ids.length === 1 ? ids[0] : null
        };
    }
    const active = day.filter((w)=>w.start <= nowMin && nowMin < w.end);
    if (distinct(active).length > 1) return {
        state: 'overlap',
        day: day,
        clinicIds: distinct(active),
        scheduledClinicId: null
    };
    if (active.length) return {
        state: 'in_shift',
        day: day,
        window: active[0],
        scheduledClinicId: active[0].clinicId
    };
    const next = day.find((w)=>w.start > nowMin);
    if (next) {
        const endedBefore = day.some((w)=>w.end <= nowMin);
        return {
            state: endedBefore ? 'between' : 'before_first',
            day: day,
            window: next,
            scheduledClinicId: next.clinicId
        };
    }
    const last = day.reduce((a, b)=>b.end >= a.end ? b : a);
    return {
        state: 'done',
        day: day,
        window: last,
        scheduledClinicId: last.clinicId
    };
}
const $a7a51f8e25be6339$export$5565f4d3a1db72cd = (m)=>`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
const $a7a51f8e25be6339$export$3e726e531363bd4e = (start, end, fmt = (x)=>x)=>`\u{2066}${fmt($a7a51f8e25be6339$export$5565f4d3a1db72cd(start))}\u{2013}${fmt($a7a51f8e25be6339$export$5565f4d3a1db72cd(end))}\u{2069}`;



// ─────────────────────────────────────────────────────────────────────────────
// The mobile پذیرش header's context row (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.2):
// one white-alpha inset card on the gradient, two rows.
//
//   PlaceLine — «کجا هستم»: where the presence schedule puts the doctor on the
//               selected day (`resolvePlace`). With more than one clinic it is
//               also the trigger for the clinic lens; with one it only informs
//               (§2.1: absent, never disabled).
//   DateBar   — ‹ day › with the label opening the week sheet. It replaces the
//               navigator + week strip + «N نوبت پیش رو» stack that used to cost
//               ~130px of a phone's height.
// ─────────────────────────────────────────────────────────────────────────────
const $39c515491bde64a9$var$PLACE_ICON = {
    in_shift: (0, $cc37683d2791ff01$export$2e2bcd8739ae039),
    between: (0, $kMJsW.default),
    before_first: (0, $kMJsW.default),
    done: (0, $8cb58a0e56c12463$export$2e2bcd8739ae039),
    overlap: (0, $QG9Z3.default),
    no_shift: (0, $1c03609248a88ad2$export$2e2bcd8739ae039),
    other_day: (0, $6Md3F.default),
    unknown: (0, $20b80355eea4425a$export$2e2bcd8739ae039)
};
function $39c515491bde64a9$export$582bbf00447c460b(place, { rs: rs, clinicName: clinicName, time: time, weekday: weekday, isToday: isToday, formatNumber: formatNumber, lensLabel: lensLabel, digits: digits = (x)=>x }) {
    const w = place?.window;
    switch(place?.state){
        case 'in_shift':
            return rs('dashboard.place.inShift', {
                clinic: clinicName(w.clinicId),
                end: time(w.end)
            });
        case 'between':
            return rs('dashboard.place.between', {
                clinic: clinicName(w.clinicId),
                start: time(w.start)
            });
        case 'before_first':
            return rs('dashboard.place.beforeFirst', {
                clinic: clinicName(w.clinicId),
                start: time(w.start)
            });
        case 'done':
            return rs('dashboard.place.done', {
                clinic: clinicName(w.clinicId)
            });
        case 'overlap':
            return rs('dashboard.place.overlap', {
                count: formatNumber(place.clinicIds.length)
            });
        case 'no_shift':
            return rs(isToday ? 'dashboard.place.noShiftToday' : 'dashboard.place.noShiftDay');
        case 'other_day':
            {
                const first = place.day[0];
                const text = rs('dashboard.place.otherDay', {
                    weekday: weekday,
                    clinic: clinicName(first.clinicId),
                    hours: (0, $a7a51f8e25be6339$export$3e726e531363bd4e)(first.start, first.end, digits)
                });
                const others = place.clinicIds.length - 1;
                return others > 0 ? `${text} ${rs('dashboard.place.more', {
                    count: formatNumber(others)
                })}` : text;
            }
        case 'unknown':
            return lensLabel; // the lens as it stands — no claim about the schedule
        default:
            return null;
    }
}
const $39c515491bde64a9$var$ReceptionContextCard = ({ place: place, clinic: clinic, counts: counts, isToday: isToday, selMs: selMs, dateLabel: dateLabel, onPrev: onPrev, onNext: onNext, onToday: onToday, onOpenWeek: onOpenWeek })=>{
    const { t: t, formatDigits: formatDigits, formatNumber: formatNumber, formatWeekday: formatWeekday } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const [lensOpen, setLensOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const multi = clinic.clinics.length > 1;
    const clinicName = (id)=>clinic.clinics.find((c)=>c.id === id)?.name || t('common.labels.clinic');
    const lensLabel = clinic.isAll ? t('dashboard.clinic.all') : clinic.activeClinic?.name || t('common.labels.clinic');
    const sentence = $39c515491bde64a9$export$582bbf00447c460b(place, {
        rs: rs,
        clinicName: clinicName,
        isToday: isToday,
        formatNumber: formatNumber,
        lensLabel: lensLabel,
        time: (m)=>formatDigits((0, $a7a51f8e25be6339$export$5565f4d3a1db72cd)(m)),
        digits: formatDigits,
        weekday: formatWeekday(selMs, 'long')
    });
    // What the lens is doing, when that is not simply «following the schedule to
    // the clinic the sentence already names». A manual pick is shown by name so
    // the doctor can see the schedule and the list disagree on purpose.
    const lensPill = !multi || place?.state === 'unknown' ? null : clinic.mode === 'auto' ? rs('dashboard.clinic.autoBadge') : lensLabel;
    const muted = place?.state === 'no_shift';
    const lensOptions = multi ? [
        {
            id: (0, $5ce8d1a169b07fa7$export$c588754a2dac332e),
            name: rs('dashboard.clinic.auto'),
            meta: rs('dashboard.clinic.autoSub'),
            icon: (0, $chm1L.default),
            checked: clinic.mode === 'auto'
        },
        ...clinic.clinics.map((c)=>({
                id: c.id,
                name: c.name || t('common.labels.clinic'),
                meta: [
                    c.city,
                    counts?.has(c.id) ? t('dashboard.clinic.countToday', {
                        count: formatNumber(counts.get(c.id))
                    }) : null
                ].filter(Boolean).join(" \xb7 "),
                icon: (0, $20b80355eea4425a$export$2e2bcd8739ae039),
                checked: clinic.mode === 'pick' && clinic.activeId === c.id
            })),
        {
            id: (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d),
            name: t('dashboard.clinic.all'),
            meta: t('dashboard.clinic.allSub'),
            icon: (0, $b8deaef2bfa57b80$export$2e2bcd8739ae039),
            checked: clinic.mode === 'all',
            quiet: true
        }
    ] : [];
    // The card itself is the kit's (DayContextCard, shared with the clinic's
    // phone پذیرش — PM-0052); what it SAYS is decided here.
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hU4vR.default), {
                line: sentence == null ? null : {
                    icon: $39c515491bde64a9$var$PLACE_ICON[place?.state] || (0, $20b80355eea4425a$export$2e2bcd8739ae039),
                    text: sentence,
                    hint: muted ? rs('dashboard.place.noShiftHint') : null,
                    pill: lensPill,
                    tone: place?.state === 'overlap' ? 'warn' : muted ? 'muted' : undefined,
                    state: place?.state,
                    live: true,
                    ariaLabel: rs('dashboard.place.aria'),
                    onOpen: multi ? ()=>setLensOpen(true) : undefined,
                    openLabel: t('dashboard.clinic.pick')
                },
                dateLabel: dateLabel,
                isToday: isToday,
                onPrev: onPrev,
                onNext: onNext,
                onToday: onToday,
                onOpenWeek: onOpenWeek,
                labels: {
                    prevDay: t('dashboard.date.prevDay'),
                    nextDay: t('dashboard.date.nextDay'),
                    today: t('dashboard.date.today'),
                    backToToday: t('dashboard.date.backToToday'),
                    pickDay: rs('dashboard.week.title')
                }
            }),
            multi && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJslC.default), {
                open: lensOpen,
                onClose: ()=>setLensOpen(false),
                title: t('dashboard.clinic.label'),
                closeLabel: t('common.actions.close'),
                testIdPrefix: "reception-clinic",
                groups: [
                    {
                        key: 'clinic',
                        label: t('dashboard.clinic.pick'),
                        onPick: (id)=>clinic.setActive(id),
                        options: lensOptions
                    }
                ]
            })
        ]
    });
};
var $39c515491bde64a9$export$2e2bcd8739ae039 = $39c515491bde64a9$var$ReceptionContextCard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aM2JY = parcelRequire("aM2JY");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// The day's figures as ONE row (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3) — the
// mobile KPI zone on a list-dominant cockpit, where the appointments are the
// screen's purpose and the counts only frame them.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»
//
// The row is the kit's `DayStatStrip`, shared with the clinic's phone پذیرش
// (PM-0052); this file only says WHICH figures the doctor reads. The day's
// income is not here: it lives in حسابداری, a bottom tab of its own.
// ─────────────────────────────────────────────────────────────────────────────
const $a135776235a98cf4$var$DayStatStrip = ({ counts: counts, loading: loading, isToday: isToday })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const n = (v)=>loading || v == null ? "\u2013" : formatNumber(v);
    const items = [
        {
            key: 'total',
            value: counts.total,
            label: isToday ? rs('dashboard.stats.total') : t('dashboard.counts.total'),
            color: (0, $jTCZr.C).textPrimary
        },
        {
            key: 'waiting',
            value: counts.waiting,
            label: rs('dashboard.stats.waiting'),
            color: (0, $jTCZr.CT).warnInk
        },
        {
            key: 'completed',
            value: counts.completed,
            label: rs('dashboard.stats.completed'),
            color: (0, $jTCZr.C).green
        },
        {
            key: 'cancelled',
            value: counts.cancelled,
            label: rs('dashboard.stats.cancelled'),
            color: (0, $jTCZr.C).red
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aM2JY.default), {
        items: items,
        loading: loading,
        format: formatNumber,
        ariaLabel: rs('dashboard.stats.aria', {
            total: n(counts.total),
            waiting: n(counts.waiting),
            completed: n(counts.completed),
            cancelled: n(counts.cancelled)
        })
    });
};
var $a135776235a98cf4$export$2e2bcd8739ae039 = $a135776235a98cf4$var$DayStatStrip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $300tQ = parcelRequire("300tQ");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// ─────────────────────────────────────────────────────────────────────────────
// Week browsing, moved out of the header into a sheet (DOCTOR_MOBILE_RECEPTION_
// REDESIGN §4.4). The sheet is the kit's `WeekPickerSheet`, shared with the
// clinic's phone پذیرش (PM-0052); the doctor's version adds, per day, WHERE the
// presence schedule puts them. A day with no shift is muted but still
// tappable: appointments can exist outside a shift.
// ─────────────────────────────────────────────────────────────────────────────
const $48605b9bb6ac82a1$var$WeekPickerSheet = ({ open: open, onClose: onClose, selISO: selISO, todayISO: todayISO, onPick: onPick, presence: presence, clinics: clinics = [] })=>{
    const { t: t, formatDate: formatDate, formatWeekday: formatWeekday, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const memberIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(clinics.map((c)=>c.id)), [
        clinics
    ]);
    const nameOf = (id)=>clinics.find((c)=>c.id === id)?.name || t('common.labels.clinic');
    const presenceReady = presence?.status === 'ready';
    const describeDay = (iso)=>{
        if (!presenceReady) return null;
        const shifts = (0, $a7a51f8e25be6339$export$4f26007ea9ea304b)((0, $a7a51f8e25be6339$export$22c77c4973888dc6)(presence.windows, iso, memberIds));
        const first = shifts[0];
        if (!first) return {
            text: "\u2014",
            off: true
        };
        const others = new Set(shifts.map((w)=>w.clinicId)).size - 1;
        const line = `${nameOf(first.clinicId)} ${(0, $a7a51f8e25be6339$export$3e726e531363bd4e)(first.start, first.end, formatDigits)}`;
        return {
            text: others > 0 ? `${line} +${formatNumber(others)}` : line,
            aria: line
        };
    };
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            weekday: (ms)=>formatWeekday(ms, 'long'),
            dayMonth: (ms)=>formatDate(ms, 'dayMonth'),
            weekdayDayMonth: (ms)=>formatDate(ms, 'weekdayDayMonth'),
            number: formatDigits
        }), [
        formatWeekday,
        formatDate,
        formatDigits
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $300tQ.default), {
        open: open,
        onClose: onClose,
        selISO: selISO,
        todayISO: todayISO,
        onPick: onPick,
        useWeekCounts: (0, $348bda64e291efe9$export$5daa0bba04a03133),
        describeDay: describeDay,
        fmt: fmt,
        labels: {
            title: rs('dashboard.week.title'),
            thisWeek: rs('dashboard.week.thisWeek'),
            nextWeek: rs('dashboard.week.nextWeek'),
            prevWeek: rs('dashboard.week.prevWeek'),
            fullCalendar: rs('dashboard.week.fullCalendar'),
            backToWeek: rs('dashboard.week.backToWeek'),
            today: t('dashboard.date.today'),
            close: t('common.actions.close'),
            range: (from, to)=>rs('dashboard.week.range', {
                    from: from,
                    to: to
                }),
            countAria: (count)=>rs('dashboard.week.countAria', {
                    count: count
                })
        }
    });
};
var $48605b9bb6ac82a1$export$2e2bcd8739ae039 = $48605b9bb6ac82a1$var$WeekPickerSheet;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");

var $jTCZr = parcelRequire("jTCZr");


var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// The «پارسه» balance, as a card body rather than a dot (finding 15, J-13).
//
// The phone had only the header's coloured dot: it says "something about your
// credit is not green" and nothing else — not the number, not what it means,
// and not what to do about it. The desktop rail has carried the figure, the
// warning and «شارژ اعتبار» all along.
//
// It renders on the cockpit only when there IS something to say — a `low` or
// `mid` balance. A healthy one stays a dot, because the reception desk is for
// the day's patients and a permanent billing card on it is noise. That is the
// same judgement the desktop rail makes by putting it below the fold.
// ─────────────────────────────────────────────────────────────────────────────
const $bd72b655dd667062$var$MobileCreditCard = ({ balance: balance, onTopUp: onTopUp })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { canBuy: canBuy } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    const level = (0, $jTCZr.creditLevel)(balance);
    // A healthy balance says nothing here — the header dot is the whole report.
    if (balance == null || level !== 'low' && level !== 'mid') return null;
    const urgent = level === 'low';
    const ink = urgent ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "data-testid": "reception-credit-card",
        style: {
            margin: '0.75rem 0.875rem 0',
            padding: '0.75rem 0.875rem',
            background: urgent ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).warnSoft,
            border: `1px solid ${urgent ? (0, $jTCZr.C).redLight : (0, $jTCZr.CT).warn}`,
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02c719a0dfee0bc4$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true,
                style: {
                    color: ink,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            color: ink
                        },
                        children: [
                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber),
                            " ",
                            t('common.units.coin')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: ink,
                            opacity: 0.85,
                            marginTop: '0.125rem'
                        },
                        children: t((0, $jTCZr.CREDIT_LEVEL_META)[level].labelKey)
                    })
                ]
            }),
            canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: urgent ? 'default' : 'outline',
                size: "sm",
                className: "shrink-0 min-h-11",
                "data-testid": "reception-credit-topup",
                onClick: onTopUp,
                children: t('credits.topUp')
            })
        ]
    });
};
var $bd72b655dd667062$export$2e2bcd8739ae039 = $bd72b655dd667062$var$MobileCreditCard;



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $kMJsW = parcelRequire("kMJsW");
var $4gxLI = parcelRequire("4gxLI");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The next-patient / open-visit hero card (mobile concept §4): a gradient card
// naming who the doctor calls in next. It escalates with an open visit — brand
// gradient within the slot, amber ring past it, red past 2× — from the same
// buildHeroModel the web hero uses; only the rendering is mobile's own.
const $f990101511c28a4d$var$HERO_CHIP = {
    normal: {
        bg: 'rgba(255,255,255,0.15)',
        color: 'white'
    },
    over: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    critical: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    }
};
const $f990101511c28a4d$var$MobileNextPatientCard = ({ apt: apt, nowMin: nowMin, nowMs: nowMs, onStart: onStart, onHistory: onHistory, onEnd: onEnd, testId: testId = 'reception-hero' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const m = (0, $13f800aa071fd2d2$export$29d3aa8816e57583)(apt, nowMin, nowMs, t);
    const chip = $f990101511c28a4d$var$HERO_CHIP[m.level];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            margin: '0 1rem 0.75rem',
            background: m.background,
            borderRadius: '1rem',
            padding: '1.125rem',
            boxShadow: m.level === 'critical' ? '0 6px 20px rgba(153,27,27,0.3)' : `0 6px 20px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.28)}`,
            border: m.level === 'over' ? `2px solid ${(0, $jTCZr.C).amber}` : 'none',
            position: 'relative',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: '-1.25rem',
                    insetInlineStart: '-1.25rem',
                    width: '5.625rem',
                    height: '5.625rem',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    color: 'rgba(255,255,255,0.65)',
                    letterSpacing: '0.05em',
                    marginBottom: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            width: '0.4375rem',
                            height: '0.4375rem',
                            borderRadius: '50%',
                            background: m.dotColor,
                            boxShadow: `0 0 0 3px ${m.dotColor}4D`,
                            display: 'inline-block'
                        }
                    }),
                    m.heroLabel,
                    m.inVisit && m.elapsedMin != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 800,
                            borderRadius: '1.25rem',
                            padding: '0.125rem 0.5rem',
                            background: chip.bg,
                            color: chip.color,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.1875rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                                size: 11,
                                strokeWidth: 2.4,
                                "aria-hidden": true
                            }),
                            ' ',
                            t('dashboard.hero.sinceStart', {
                                duration: (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, m.elapsedMin)
                            }),
                            m.level !== 'normal' && t('dashboard.hero.overSlot')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.75rem',
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '2.75rem',
                                    height: '2.75rem',
                                    borderRadius: '50%',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: '2px solid rgba(255,255,255,0.25)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.9375rem',
                                    fontWeight: 800,
                                    color: 'white',
                                    flexShrink: 0
                                },
                                children: m.initials
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.9375rem',
                                            fontWeight: 800,
                                            color: 'white',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: apt.name || t('dashboard.hero.unknownPatient')
                                    }),
                                    apt.specialty && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.71875rem',
                                            color: 'rgba(255,255,255,0.65)',
                                            marginTop: '0.125rem'
                                        },
                                        children: apt.specialty
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            textAlign: 'center',
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    background: 'rgba(255,255,255,0.15)',
                                    borderRadius: '0.625rem',
                                    padding: '0.3125rem 0.75rem',
                                    fontSize: '1.0625rem',
                                    fontWeight: 800,
                                    color: 'white'
                                },
                                children: apt.time
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.65625rem',
                                    color: 'rgba(255,255,255,0.6)',
                                    marginTop: '0.25rem'
                                },
                                children: m.waitLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5rem',
                    marginTop: '0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        "data-testid": `${testId}-history`,
                        className: "flex-1 min-h-11 text-[0.8125rem] font-bold text-white hover:bg-white/25",
                        style: {
                            background: 'rgba(255,255,255,0.15)',
                            border: '1px solid rgba(255,255,255,0.22)'
                        },
                        onClick: onHistory,
                        children: t('dashboard.hero.historyShort')
                    }),
                    m.inVisit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        "data-testid": `${testId}-end`,
                        className: "flex-1 min-h-11 text-[0.8125rem] font-extrabold",
                        style: m.level === 'normal' ? {
                            background: 'rgba(255,255,255,0.15)',
                            color: 'white',
                            border: '1px solid rgba(255,255,255,0.22)'
                        } : {
                            background: 'white',
                            color: (0, $jTCZr.CT).dangerInk
                        },
                        onClick: onEnd,
                        children: t('dashboard.hero.endShort')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        "data-testid": `${testId}-start`,
                        className: "flex-[2] min-h-11 gap-1.5 text-[0.8125rem] font-extrabold",
                        style: {
                            background: 'white',
                            color: m.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.C).navy
                        },
                        onClick: onStart,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4gxLI.default), {
                                size: 14,
                                strokeWidth: 2.6,
                                fill: "currentColor",
                                "aria-hidden": true
                            }),
                            " ",
                            m.inVisit ? t('dashboard.hero.continueVisit') : t('dashboard.hero.startVisit')
                        ]
                    })
                ]
            })
        ]
    });
};
var $f990101511c28a4d$export$2e2bcd8739ae039 = $f990101511c28a4d$var$MobileNextPatientCard;



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $5MbI8 = parcelRequire("5MbI8");


var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $87513a585d30c268$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 14v2.2l1.6 1",
            key: "fo4ql5"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
            key: "1osxxc"
        }
    ],
    [
        "path",
        {
            d: "M3 10h5",
            key: "r794hk"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "16",
            r: "6",
            key: "qoo3c4"
        }
    ]
];
const $87513a585d30c268$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar-clock", $87513a585d30c268$export$3efd853dbb351e94);


var $kMJsW = parcelRequire("kMJsW");
var $4gxLI = parcelRequire("4gxLI");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// One appointment as a tappable mobile card (mobile concept §5): name + status
// badge, then time / urgency / wait / overrun / queue-position chips, and an
// «ادامه ویزیت» action when the visit is open. The whole card taps into the
// patient record; Enter does the same from the keyboard.
const $539f61ab7b8a32ef$var$OVERRUN_CHIP = {
    normal: {
        bg: (0, $jTCZr.statusColors).in_visit.bg,
        color: (0, $jTCZr.statusColors).in_visit.text
    },
    over: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    critical: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    }
};
const $539f61ab7b8a32ef$var$NEUTRAL_BG = (0, $jTCZr.CT).surface2;
const $539f61ab7b8a32ef$var$chipStyle = (bg, color)=>({
        fontSize: '0.625rem',
        padding: '0.125rem 0.5rem',
        borderRadius: '0.625rem',
        fontWeight: 700,
        background: bg,
        color: color
    });
const $539f61ab7b8a32ef$var$ClockGlyph = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
        size: 11,
        strokeWidth: 2.4,
        style: {
            display: 'inline-block',
            verticalAlign: '-0.09375em',
            marginInlineEnd: '0.1875rem'
        },
        "aria-hidden": true
    });
const $539f61ab7b8a32ef$var$posLabel = (item, pos)=>pos === 1 ? item('dashboard.queue.positionNext') : item('dashboard.queue.position', {
        position: pos
    });
// `clinicName` is set only while پذیرش is showing every clinic at once — see the
// note on the desktop `AppointmentRow`.
const $539f61ab7b8a32ef$var$MobileAppointmentCard = ({ apt: apt, queuePos: queuePos, nowMs: nowMs, onOpen: onOpen, onContinue: onContinue, onWithdraw: onWithdraw, onReschedule: onReschedule, testId: testId, clinicName: clinicName })=>{
    const { t: t } = (0, $LNQP4.default)();
    const s = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const waited = apt.status === 'arrived' ? (0, $348bda64e291efe9$export$8820bfcc7ef6bb39)(apt, nowMs) : null;
    const { elapsedMin: elapsedMin, level: level } = apt.status === 'in_visit' ? (0, $348bda64e291efe9$export$e38f5492dd7c5c53)(apt, nowMs) : {
        elapsedMin: null,
        level: 'normal'
    };
    const urg = (0, $13f800aa071fd2d2$export$a08a3225103fa8fb)[apt.urgency];
    const overChip = $539f61ab7b8a32ef$var$OVERRUN_CHIP[level];
    return(// The card carries a nested action («ادامه ویزیت»), so it cannot itself be a
    // button — nesting one inside another is invalid. It stays the ARIA link
    // pattern: focusable, Enter-activated, with the kit Card as its surface.
    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        role: "link",
        tabIndex: 0,
        "aria-label": t('dashboard.queue.patientRecord', {
            name: apt.name || apt.patient?.name || t('common.labels.patient')
        }),
        onClick: onOpen,
        onKeyDown: (e)=>{
            if (e.key === 'Enter') onOpen?.();
        },
        className: "outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-2xl cursor-pointer",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
            style: {
                padding: '0.875rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                            name: apt.name || apt.patient?.name || t('common.punct.question'),
                            size: 44,
                            bg: apt.status === 'in_visit' ? (0, $jTCZr.C).teal : (0, $jTCZr.C).navy
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        gap: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.875rem',
                                                fontWeight: 600,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: apt.name || apt.patient?.name || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                                            status: apt.status,
                                            style: {
                                                flexShrink: 0
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '0.5rem',
                                        marginTop: '0.25rem',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '0.75rem',
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($539f61ab7b8a32ef$var$ClockGlyph, {}),
                                                apt.time
                                            ]
                                        }),
                                        urg && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: $539f61ab7b8a32ef$var$chipStyle(urg.bg, urg.color),
                                            children: t(urg.labelKey)
                                        }),
                                        waited != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: $539f61ab7b8a32ef$var$chipStyle(waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $jTCZr.C).amberLight : $539f61ab7b8a32ef$var$NEUTRAL_BG, waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($539f61ab7b8a32ef$var$ClockGlyph, {}),
                                                t('dashboard.queue.waitedShort', {
                                                    count: waited
                                                })
                                            ]
                                        }),
                                        elapsedMin != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: $539f61ab7b8a32ef$var$chipStyle(overChip.bg, overChip.color),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($539f61ab7b8a32ef$var$ClockGlyph, {}),
                                                (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, elapsedMin)
                                            ]
                                        }),
                                        queuePos != null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: $539f61ab7b8a32ef$var$chipStyle(queuePos === 1 ? (0, $jTCZr.statusColors).arrived.bg : $539f61ab7b8a32ef$var$NEUTRAL_BG, queuePos === 1 ? (0, $jTCZr.statusColors).arrived.text : (0, $jTCZr.C).textSecondary),
                                            children: $539f61ab7b8a32ef$var$posLabel(t, queuePos)
                                        }),
                                        clinicName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "data-testid": "reception-row-clinic",
                                            style: {
                                                ...$539f61ab7b8a32ef$var$chipStyle((0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08), (0, $jTCZr.C).navyDark),
                                                maxWidth: '9rem',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: clinicName
                                        })
                                    ]
                                })
                            ]
                        }),
                        apt.status === 'scheduled' && onReschedule && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                            variant: "ghost",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87513a585d30c268$export$2e2bcd8739ae039), {
                                size: 20,
                                strokeWidth: 1.5,
                                "aria-hidden": true
                            }),
                            label: s('dashboard.reschedule.action'),
                            "data-testid": `reception-row-${apt.id}-reschedule`,
                            onClick: (e)=>{
                                e.stopPropagation();
                                onReschedule();
                            },
                            onKeyDown: (e)=>e.stopPropagation()
                        })
                    ]
                }),
                apt.status === 'in_visit' && onContinue && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    variant: "default",
                    size: "sm",
                    className: "w-full mt-2.5 gap-1.5 min-h-11",
                    onClick: (e)=>{
                        e.stopPropagation();
                        onContinue();
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4gxLI.default), {
                            size: 14,
                            strokeWidth: 2.6,
                            fill: "currentColor",
                            "aria-hidden": true
                        }),
                        " ",
                        t('dashboard.hero.continueVisit')
                    ]
                }),
                (0, $13f800aa071fd2d2$export$1fb2f46ad857789e)(apt) && onWithdraw && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    size: "sm",
                    className: "w-full mt-2.5 min-h-11",
                    "data-testid": `reception-row-${apt.id}-withdraw`,
                    onClick: (e)=>{
                        e.stopPropagation();
                        onWithdraw();
                    },
                    children: s('dashboard.withdraw.action')
                })
            ]
        })
    }));
};
var $539f61ab7b8a32ef$export$2e2bcd8739ae039 = $539f61ab7b8a32ef$var$MobileAppointmentCard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
// The forgotten-visit alert (mobile concept §4): a visit left open (> 2h, or from
// a previous day) follows the doctor to every date until continued or closed —
// being out of sight is how it got forgotten. Closing goes through the screen's
// ConfirmDialog (the onEnd callback asks; this card never completes a visit
// directly).
const $2702d77fad7ebe1a$var$MobileForgottenVisitAlert = ({ visits: visits, onContinue: onContinue, onEnd: onEnd })=>{
    const { t: t } = (0, $LNQP4.default)();
    if (!visits.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: visits.map((apt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": `reception-forgotten-${apt.id}`,
                style: {
                    margin: '0.75rem 0.875rem 0',
                    background: (0, $jTCZr.C).redLight,
                    border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`,
                    borderRadius: '0.75rem',
                    padding: '0.625rem 0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 800,
                            borderRadius: '0.75rem',
                            padding: '0.125rem 0.5rem',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.12),
                            color: (0, $jTCZr.CT).dangerInk
                        },
                        children: t('dashboard.forgotten.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1,
                            minWidth: '7.5rem',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.CT).dangerInk
                        },
                        children: apt.name || t('common.labels.patient')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        "data-testid": `reception-forgotten-continue-${apt.id}`,
                        className: "min-h-11 text-xs font-bold",
                        style: {
                            color: (0, $jTCZr.CT).dangerInk,
                            borderColor: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)
                        },
                        onClick: ()=>onContinue(apt),
                        children: t('dashboard.hero.continueShort')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "destructive",
                        size: "sm",
                        "data-testid": `reception-forgotten-end-${apt.id}`,
                        className: "min-h-11 text-xs font-extrabold",
                        onClick: ()=>onEnd(apt),
                        children: t('dashboard.hero.endShort')
                    })
                ]
            }, apt.id))
    });
};
var $2702d77fad7ebe1a$export$2e2bcd8739ae039 = $2702d77fad7ebe1a$var$MobileForgottenVisitAlert;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

function $d7c5dde78915b198$export$2e2bcd8739ae039({ icon: icon, title: title, description: description, doctorId: doctorId, navigate: navigate, onBook: onBook, canBook: canBook = false, ...rest }) {
    const { t: t } = (0, $LNQP4.default)();
    const { loading: loading, ownedClinic: ownedClinic, joinedClinic: joinedClinic } = (0, $90c3af16928ea94c$export$f5416d3c5746c6f8)();
    let body = description;
    let action = null;
    if (onBook && canBook) action = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        size: "sm",
        "data-testid": "reception-empty-book",
        onClick: onBook,
        children: t('dashboard.empty.book')
    });
    else if (!loading && ownedClinic) action = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        size: "sm",
        "data-testid": "reception-empty-book",
        onClick: ()=>(0, $90c3af16928ea94c$export$891d531b2f03987b)(ownedClinic, doctorId),
        children: t('dashboard.empty.book')
    });
    else if (!loading && joinedClinic) {
        body = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "reception-empty-ask-admin",
                    style: description ? {
                        marginTop: 6
                    } : undefined,
                    children: t('dashboard.empty.askClinicAdmin')
                })
            ]
        });
        action = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            "data-testid": "reception-empty-view-clinic",
            onClick: ()=>navigate?.('profile', {
                    tab: 'clinics'
                }),
            children: t('dashboard.empty.viewClinic')
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        ...rest,
        icon: icon,
        title: title,
        description: body,
        action: action
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $3tGMU = parcelRequire("3tGMU");
var $Ydgp5 = parcelRequire("Ydgp5");
var $5AX1S = parcelRequire("5AX1S");
var $lffTJ = parcelRequire("lffTJ");
var $amyVq = parcelRequire("amyVq");
var $fYgeo = parcelRequire("fYgeo");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $gCvEY = parcelRequire("gCvEY");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");
var $dyHsi = parcelRequire("dyHsi");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $4UJrq = parcelRequire("4UJrq");

var $2WFPf = parcelRequire("2WFPf");
var $kMJsW = parcelRequire("kMJsW");
var $2VplL = parcelRequire("2VplL");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9fb661ead567131f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "8",
            y2: "14",
            key: "1bvyxn"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
];
const $9fb661ead567131f$export$2e2bcd8739ae039 = (0, $9QBug.default)("user-plus", $9fb661ead567131f$export$3efd853dbb351e94);


var $6imzq = parcelRequire("6imzq");


var $acw62 = parcelRequire("acw62");

// ─────────────────────────────────────────────────────────────────────────────
// «جست‌وجوی بیمار» — looking someone up.
//
// The BFF has offered `patients(filter, search, clinicId)` all along and NOTHING
// called it. With no Encounters screen on the phone either, a doctor holding
// only a phone could open exactly one thing: today's queue. If the patient in
// front of them was not on today's list — a walk-in, yesterday's follow-up, a
// phone call about a result — there was no way to reach the record at all.
//
// ── Two deliberate limits ───────────────────────────────────────────────────
// TWO CHARACTERS before anything is sent. One character matches most of a
// clinic and costs a round trip to say so.
//
// THE QUERY IS UNPAGED, so the result is capped HERE. A clinic with ten
// thousand patients and a doctor who types «م» would otherwise hand the phone a
// list it cannot render. The cap is a client-side truth the screen states out
// loud rather than a silent truncation; pagination is a BFF follow-up if real
// clinics make it necessary.
//
// ── No PHI in the URL ───────────────────────────────────────────────────────
// The query stays in component state, never in a query parameter. A patient's
// name in an address is PHI in the browser history, in a shared link and in
// every proxy log between here and the BFF — which is exactly why the desktop
// Encounters screen keeps free-text search out of the URL too.
// ─────────────────────────────────────────────────────────────────────────────
const $fd142269863b16ba$var$SEARCH_QUERY = `
  query SearchPatients($search: String, $clinicId: ID) {
    patients(search: $search, clinicId: $clinicId) {
      id
      name
      phone
      nationalId
      age
      gender
      status
      fileNumber
      lastEncounter
      encountersCount
    }
  }
`;
const $fd142269863b16ba$export$603bfc519b05aadb = 2;
const $fd142269863b16ba$export$d99aee4f5069128 = 50;
const $fd142269863b16ba$var$DEBOUNCE_MS = 300;
function $fd142269863b16ba$export$c2a0e1e82a1adac5({ clinicId: clinicId = null } = {}) {
    const [query, setQuery] = (0, $acw62.useState)('');
    const [results, setResults] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // `searched` separates «nothing matched» from «nothing asked yet» — without
    // it an untouched screen would render the no-results empty state.
    const [searched, setSearched] = (0, $acw62.useState)(false);
    const [truncated, setTruncated] = (0, $acw62.useState)(false);
    const debounceRef = (0, $acw62.useRef)(null);
    // Every request carries a token; a late answer to an abandoned query is
    // dropped rather than overwriting the current one.
    const tokenRef = (0, $acw62.useRef)(0);
    const run = (0, $acw62.useCallback)((term)=>{
        const token = ++tokenRef.current;
        setLoading(true);
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($fd142269863b16ba$var$SEARCH_QUERY, {
            search: term,
            clinicId: clinicId || undefined
        }).then((data)=>{
            if (token !== tokenRef.current) return;
            const all = data?.patients || [];
            setResults(all.slice(0, $fd142269863b16ba$export$d99aee4f5069128));
            setTruncated(all.length > $fd142269863b16ba$export$d99aee4f5069128);
            setSearched(true);
        }).catch((err)=>{
            if (token !== tokenRef.current) return;
            setError(err);
            setResults([]);
            setSearched(true);
        }).finally(()=>{
            if (token === tokenRef.current) setLoading(false);
        });
    }, [
        clinicId
    ]);
    const search = (0, $acw62.useCallback)((value)=>{
        setQuery(value);
        clearTimeout(debounceRef.current);
        if (value.trim().length < $fd142269863b16ba$export$603bfc519b05aadb) {
            // Abandon anything in flight so its answer cannot land under a query
            // that is no longer long enough to have one.
            tokenRef.current += 1;
            setResults([]);
            setSearched(false);
            setTruncated(false);
            setLoading(false);
            setError(null);
            return;
        }
        debounceRef.current = setTimeout(()=>run(value.trim()), $fd142269863b16ba$var$DEBOUNCE_MS);
    }, [
        run
    ]);
    const clear = (0, $acw62.useCallback)(()=>search(''), [
        search
    ]);
    /** The one action the error state offers. */ const retry = (0, $acw62.useCallback)(()=>{
        const term = query.trim();
        if (term.length >= $fd142269863b16ba$export$603bfc519b05aadb) run(term);
    }, [
        query,
        run
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(debounceRef.current), []);
    const belowMinimum = query.trim().length > 0 && query.trim().length < $fd142269863b16ba$export$603bfc519b05aadb;
    return {
        query: query,
        search: search,
        clear: clear,
        retry: retry,
        results: results,
        loading: loading,
        error: error,
        searched: searched,
        truncated: truncated,
        belowMinimum: belowMinimum,
        /** 'idle' | 'below' | 'loading' | 'error' | 'empty' | 'content'. */ state: query.trim().length === 0 ? 'idle' : belowMinimum ? 'below' : error ? 'error' : loading && results.length === 0 ? 'loading' : searched && results.length === 0 ? 'empty' : 'content'
    };
}
var $fd142269863b16ba$export$2e2bcd8739ae039 = $fd142269863b16ba$export$c2a0e1e82a1adac5;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $9b530774ad99e23e$export$db6b977dd1b3391f(dirty, onClose) {
    const [asking, setAsking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The flags are read through refs so `requestClose` keeps one identity for
    // the life of the sheet: it is handed to `BottomSheet`'s `onClose`, and a
    // changing identity there re-runs the sheet's own history and focus effects
    // on every keystroke.
    const dirtyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(dirty);
    dirtyRef.current = dirty;
    const onCloseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onClose);
    onCloseRef.current = onClose;
    const requestClose = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!dirtyRef.current) {
            onCloseRef.current?.();
            return;
        }
        setAsking(true);
    }, []);
    const discard = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setAsking(false);
        onCloseRef.current?.();
    }, []);
    return {
        requestClose: requestClose,
        asking: asking,
        guard: /*#__PURE__*/ (0, $ayMG0.jsx)($9b530774ad99e23e$export$2e2bcd8739ae039, {
            open: asking,
            onDiscard: discard,
            onKeepEditing: ()=>setAsking(false)
        })
    };
}
function $9b530774ad99e23e$export$2e2bcd8739ae039({ open: open, onDiscard: onDiscard, onKeepEditing: onKeepEditing }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onKeepEditing?.();
        },
        title: t('common.unsaved.title'),
        message: t('common.unsaved.body'),
        confirmLabel: t('common.unsaved.discard'),
        cancelLabel: t('common.unsaved.keepEditing'),
        destructive: true,
        onConfirm: onDiscard
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// What a failed write says to the doctor (DESIGN_CONCEPT §2.4, §7).
//
// Two kinds of error reach a catch block, and they must not be treated alike:
//
//   • a refusal the BFF wrote FOR PEOPLE — `userError(messageKey, text)` puts a
//     `messageKey` in `extensions` («عضویت شما در این مرکز یافت نشد…»). That is
//     the most useful thing the screen can say: translated when the catalogue has
//     the key, the server's own sentence when it does not yet;
//   • everything else — «Failed to fetch», a gRPC status, a stack fragment. Raw
//     transport text is never shown; the caller's translated fallback is.
// ─────────────────────────────────────────────────────────────────────────────
function $6dd1a0ec80cef79b$export$9bef418888ccb2cd(err, { t: t, has: has }, fallbackKey = 'errors.save.generic') {
    const key = err?.extensions?.messageKey;
    if (key) {
        if (typeof has === 'function' && has(key)) return t(key);
        if (err?.message) return String(err.message);
    }
    return t(fallbackKey);
}
var $6dd1a0ec80cef79b$export$2e2bcd8739ae039 = $6dd1a0ec80cef79b$export$9bef418888ccb2cd;


// ─────────────────────────────────────────────────────────────────────────────
// «ثبت نوبت» — the doctor books a نوبت at one of their clinics.
//
// ONE task in TaskOverlay's two shells (Dialog on a workstation, full-height
// BottomSheet on a phone — DESIGN_CONCEPT §5.2). Three decisions, one column:
// which clinic, which patient, and when.
//
// The same sheet the clinic's desk books on (PM-0030): it opens on «اولین نوبت
// امروز» — the doctor's first free slot at that clinic, resolved by the server
// when it books — with the questions that change WHEN (the mode, the day) folded
// behind one disclosure and the optional extras (visit type, length, note)
// behind another. «انتخاب دستی» is the date-and-time picker it always had.
//
// The clinic's grant decides what pressing the button MEANS, and the form says
// so before it is pressed: at a clinic that has withdrawn the grant the button
// reads «ارسال برای تأیید کلینیک» and a notice explains that the نوبت waits
// for reception. The BFF re-decides at write time; this is the forecast.
//
// «خارج از نوبت همین الان» (PM-0056) is the third answer to "when": the patient
// is in front of the doctor, so the نوبت has no hour and joins today's queue
// already present. It is one switch row INSIDE the «تاریخ و ساعت» box, and its
// place there follows how likely it is: with a free slot left today it FOLLOWS
// the suggested slot («یا»); with none left — or once a booking lost today's
// last slot — it LEADS the box as «پیشنهاد». A clinic that withdrew the grant
// cannot take it (the patient would be both present and awaiting the desk), so
// the row stays visible, inert, and says why. Off on every open.
//
// A new patient is registered FIRST (addPatient) and the id kept, so a booking
// that fails after it — a taken slot — does not register them twice on retry.
// Nothing here is optimistic: the overlay closes on the server's answer.
// ─────────────────────────────────────────────────────────────────────────────
const $38e656a4522e301b$var$DURATIONS = [
    10,
    15,
    20,
    30,
    45,
    60
];
const $38e656a4522e301b$var$pad2 = (n)=>String(n).padStart(2, '0');
const $38e656a4522e301b$var$todayIran = (nowMs = Date.now())=>(0, $917ea62a53046a22$export$bb0bcaf0a6a50714)(nowMs);
function $38e656a4522e301b$export$e9fc40095af613de(dayISO, nowMs = Date.now()) {
    const nowIran = new Date(nowMs + (0, $4UJrq.IRAN_OFFSET_MS));
    const todayISO = nowIran.toISOString().slice(0, 10);
    if (!dayISO || dayISO === todayISO) {
        const mins = nowIran.getUTCHours() * 60 + nowIran.getUTCMinutes();
        const next = Math.min(1425, Math.ceil((mins + 1) / 15) * 15);
        return `${todayISO} ${$38e656a4522e301b$var$pad2(Math.floor(next / 60))}:${$38e656a4522e301b$var$pad2(next % 60)}`;
    }
    return `${dayISO} 09:00`;
}
function $38e656a4522e301b$export$2e2bcd8739ae039({ open: open, onClose: onClose, dayISO: dayISO, clinicId: lensClinicId, onBooked: onBooked, isMobile: isMobile, bookingClinics: bookingClinics, dayAppointments: // The day's appointments the screen already holds (reception). A patient who
// already has an OPEN نوبت that day — waiting, arrived, in the visit — is
// named before a second one is booked: the 2026-10-12 tour booked a walk-in
// for a patient who was «در حال ویزیت», with no word (PM-0137 a). A warning,
// not a refusal: a second, later نوبت can be meant.
dayAppointments = null }) {
    const s = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const i18n = (0, $LNQP4.default)();
    const { formatNumber: formatNumber } = i18n;
    // The screen usually already holds the list (it decides whether to offer the
    // button at all); the dialog fetches its own only when it was not handed one.
    const own = (0, $917ea62a53046a22$export$d390b7bb6e3190e5)({
        enabled: open && !bookingClinics
    });
    const { clinics: clinics, loading: clinicsLoading, error: clinicsError, reload: reloadClinics } = bookingClinics || own;
    // Re-read on open: the clinic may have changed the grant since the page loaded,
    // and the button's wording is a promise about which of the two will happen.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && bookingClinics) bookingClinics.reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    const [clinicId, setClinicId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('existing'); // existing | new
    const [patient, setPatient] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [phoneValue, setPhoneValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [phoneOk, setPhoneOk] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    // Optional (PM-0075): a patient without one is still bookable; one typed must check out.
    const [nationalId, setNationalId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // The country that issued it — the clinic's by default, another for a foreign patient.
    const [nationalIdCountry, setNationalIdCountry] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // 'first' = «اولین نوبت» of the chosen day; 'manual' = a time the doctor picks.
    const [slotMode, setSlotMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('first');
    const [day, setDay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>dayISO || $38e656a4522e301b$var$todayIran());
    const [timeOpen, setTimeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [walkIn, setWalkIn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // A booking that came back "today is full" — the walk-in is now the suggestion.
    const [todayFull, setTodayFull] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [visitType, setVisitType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('in_person');
    const [when, setWhen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$38e656a4522e301b$export$e9fc40095af613de(dayISO));
    const [duration, setDuration] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [errors, setErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [formError, setFormError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // A patient registered by an earlier, failed attempt — reused, never re-created.
    const createdRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const search = (0, $fd142269863b16ba$export$c2a0e1e82a1adac5)();
    // Reset on every open: a dialog reopened for another day must not carry the
    // last patient into it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setMode('existing');
        setPatient(null);
        setName('');
        setPhoneValue('');
        setPhoneOk(true);
        setNationalId('');
        setNationalIdCountry(null);
        setSlotMode('first');
        setDay(dayISO || $38e656a4522e301b$var$todayIran());
        setTimeOpen(false);
        setMoreOpen(false);
        setWalkIn(false);
        setTodayFull(false);
        setVisitType('in_person');
        setWhen($38e656a4522e301b$export$e9fc40095af613de(dayISO));
        setDuration('');
        setNote('');
        setErrors({});
        setFormError('');
        setBusy(false);
        createdRef.current = null;
        search.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        dayISO
    ]);
    // The clinic: the reception lens when it is bookable, else the only one there is.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !clinics) return;
        setClinicId((cur)=>{
            if (cur && clinics.some((c)=>c.clinicId === cur)) return cur;
            if (lensClinicId && clinics.some((c)=>c.clinicId === lensClinicId)) return lensClinicId;
            return clinics.length === 1 ? clinics[0].clinicId : '';
        });
    }, [
        open,
        clinics,
        lensClinicId
    ]);
    const clinic = (clinics || []).find((c)=>c.clinicId === clinicId) || null;
    const needsApproval = !!clinic && !clinic.canBookDirectly;
    // Another clinic is another diary — and one without the grant cannot take a walk-in.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setTodayFull(false);
        if (needsApproval) setWalkIn(false);
    }, [
        clinicId,
        needsApproval
    ]);
    const effectiveDuration = Number(duration) || clinic?.visitDurationMinutes || 30;
    const durationOptions = [
        ...new Set([
            ...$38e656a4522e301b$var$DURATIONS,
            effectiveDuration
        ])
    ].sort((a, b)=>a - b).map((m)=>({
            value: String(m),
            label: s('dashboard.book.minutes', {
                count: formatNumber(m)
            })
        }));
    // ── «اولین نوبت» ─────────────────────────────────────────────────────────
    // The anchor is noon of the chosen Iran day, so the service resolves that
    // calendar day whatever the browser's timezone is.
    const isAuto = slotMode === 'first';
    const dayIsToday = day === $38e656a4522e301b$var$todayIran();
    const anchor = (0, $917ea62a53046a22$export$9dab6106cce55aad)(`${day} 12:00`);
    const preview = (0, $917ea62a53046a22$export$8c529a5324765e93)({
        enabled: open && isAuto && !!clinic,
        clinicId: clinicId,
        fromDateTime: anchor == null ? '' : String(anchor),
        scope: 'DAY',
        durationMinutes: effectiveDuration
    });
    const previewEmpty = isAuto && !!clinic && !preview.loading && !preview.error && !preview.slot;
    // Only when the day itself came back empty: where the next real slot is. The
    // floor is frozen for the life of one probe — a fresh Date.now() per render
    // would re-query forever.
    const nextFloor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>String(Date.now()), [
        previewEmpty,
        clinicId
    ]);
    const next = (0, $917ea62a53046a22$export$8c529a5324765e93)({
        enabled: open && previewEmpty,
        clinicId: clinicId,
        fromDateTime: nextFloor,
        scope: 'ANY',
        durationMinutes: effectiveDuration
    });
    // «همین را ثبت کن» moves the day to the slot's own day; the day-scoped search
    // there finds that same slot.
    const takeNext = (slot)=>{
        const d = (0, $917ea62a53046a22$export$bb0bcaf0a6a50714)(slot?.dateTime);
        if (d) {
            setDay(d);
            setErrors((x)=>({
                    ...x,
                    when: undefined
                }));
        }
    };
    // «خارج از نوبت» leads when today has nothing left to suggest.
    const walkInSuggested = !!clinic && !needsApproval && (todayFull || isAuto && dayIsToday && previewEmpty);
    const toggleWalkIn = (on)=>{
        setWalkIn(on);
        setErrors((x)=>({
                ...x,
                when: undefined
            }));
    };
    const pickMode = (m)=>{
        setSlotMode(m);
        setErrors((x)=>({
                ...x,
                when: undefined
            }));
        // Picking the time by hand starts on the day already on screen.
        if (m === 'manual') setWhen($38e656a4522e301b$export$e9fc40095af613de(day));
    };
    const dirty = !!patient || !!name.trim() || !!phoneValue || !!nationalId || !!note.trim();
    const { requestClose: requestClose, guard: guard } = (0, $9b530774ad99e23e$export$db6b977dd1b3391f)(dirty, onClose);
    const validate = ()=>{
        const next = {};
        if (!clinicId) next.clinic = s('dashboard.book.errors.clinic');
        if (mode === 'existing' && !patient) next.patient = s('dashboard.book.errors.patient');
        if (mode === 'new' && !name.trim()) next.name = s('dashboard.book.errors.name');
        if (mode === 'new' && phoneValue && !phoneOk) next.phone = s('dashboard.book.errors.phone');
        if (mode === 'new' && (0, $3tGMU).nationalIdProblem(nationalId, {
            country: nationalIdCountry
        })) next.nationalId = s('dashboard.book.errors.nationalId');
        if (walkIn) return next; // no hour to check
        if (isAuto) {
            // A preview that could not be read blocks nothing: the booking is the authority.
            if (previewEmpty) next.when = s('dashboard.book.errors.noSlot');
            return next;
        }
        const at = (0, $917ea62a53046a22$export$9dab6106cce55aad)(when);
        if (at == null) next.when = s('dashboard.book.errors.when');
        else if (at < Date.now() - 300000) next.when = s('dashboard.book.errors.past');
        return next;
    };
    const submit = async (e)=>{
        e?.preventDefault?.();
        if (busy) return;
        const found = validate();
        setErrors(found);
        setFormError('');
        if (Object.keys(found).length) {
            // Focus the first invalid field (DESIGN_CONCEPT §6.3).
            const first = [
                'clinic',
                'patient',
                'name',
                'phone',
                'nationalId',
                'when'
            ].find((k)=>found[k]);
            if (first === 'when') setTimeOpen(true);
            document.querySelector(`[data-book-field="${first}"] input, [data-book-field="${first}"] select`)?.focus?.();
            return;
        }
        setBusy(true);
        try {
            let patientId = patient?.id;
            if (mode === 'new') {
                if (!createdRef.current) createdRef.current = await (0, $917ea62a53046a22$export$15ba41c58b2edfba)({
                    name: name,
                    phone: phoneValue,
                    nationalId: nationalId
                });
                patientId = createdRef.current?.id;
            }
            if (walkIn) {
                // No hour, no slot search: the server stamps today with its own clock.
                const result = await (0, $917ea62a53046a22$export$2ac64a422d3a9b85)({
                    clinicId: clinicId,
                    patientId: patientId,
                    untimed: 'NOW',
                    dateTime: String(Date.now()),
                    type: 'in_person',
                    reminderNote: note.trim() || null
                });
                onBooked?.(result, {
                    dayISO: $38e656a4522e301b$var$todayIran(),
                    walkIn: true
                });
                onClose?.();
                return;
            }
            const result = await (0, $917ea62a53046a22$export$2ac64a422d3a9b85)({
                clinicId: clinicId,
                patientId: patientId,
                // With «اولین نوبت» the instant is only the anchor of the search — the
                // server resolves the slot and the answer carries what was booked.
                dateTime: String(isAuto ? anchor : (0, $917ea62a53046a22$export$9dab6106cce55aad)(when)),
                ...isAuto ? {
                    firstAvailable: 'DAY'
                } : {},
                durationMinutes: effectiveDuration,
                type: visitType,
                reminderNote: note.trim() || null
            });
            onBooked?.(result, {
                dayISO: isAuto ? (0, $917ea62a53046a22$export$bb0bcaf0a6a50714)(result?.appointment?.dateTime) || day : when.slice(0, 10)
            });
            onClose?.();
        } catch (err) {
            const code = (0, $917ea62a53046a22$export$dbfe74f291058e97)(err);
            const message = (0, $6dd1a0ec80cef79b$export$9bef418888ccb2cd)(err, i18n, 'errors.save.generic');
            // Business refusals land on the field they are about (§6.3).
            if (code === 'SLOT_TAKEN' || code === 'DOCTOR_NOT_PRESENT' || code === 'NO_SLOT_AVAILABLE') {
                setErrors({
                    when: code === 'NO_SLOT_AVAILABLE' ? s('dashboard.book.errors.noSlot') : message
                });
                setTimeOpen(true);
                // Today just ran out under us: the patient at the desk is now a walk-in.
                const bookingDay = isAuto ? day : when.slice(0, 10);
                if (code !== 'DOCTOR_NOT_PRESENT' && bookingDay === $38e656a4522e301b$var$todayIran()) setTodayFull(true);
            } else if (code === 'UNTIMED_NEEDS_GRANT') {
                setWalkIn(false);
                setFormError(message);
                reloadClinics();
            } else if (code === 'BOOKING_NOT_ALLOWED') {
                setErrors({
                    clinic: message
                });
                reloadClinics();
            } else setFormError(message);
        } finally{
            setBusy(false);
        }
    };
    // The selected patient's open نوبت on the reception day, if the screen knows it.
    const existingOpen = mode === 'existing' && patient?.id && Array.isArray(dayAppointments) ? dayAppointments.find((a)=>a?.patientId === patient.id && [
            'scheduled',
            'arrived',
            'in_visit'
        ].includes(a?.status)) : null;
    const footer = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                type: "button",
                onClick: requestClose,
                disabled: busy,
                children: s('dashboard.withdraw.keep')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                type: "submit",
                form: "book-appointment-form",
                disabled: busy || !clinics?.length,
                "aria-busy": busy || undefined,
                "data-testid": "book-submit",
                children: [
                    busy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                        size: 16,
                        color: "currentColor"
                    }),
                    walkIn ? s('dashboard.book.submitWalkIn') : needsApproval ? s('dashboard.book.submitRequest') : isAuto ? s('dashboard.book.submitFirst') : s('dashboard.book.submit')
                ]
            })
        ]
    });
    // ── Clinic region — its own four states ───────────────────────────────────
    let clinicRegion;
    if (clinicsLoading) clinicRegion = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
        height: 44
    });
    else if (clinicsError && !clinics?.length) clinicRegion = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "error",
        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            type: "button",
            onClick: reloadClinics,
            children: i18n.t('common.actions.retry')
        }),
        children: s('dashboard.book.loadFailed')
    });
    else if (!clinics?.length) clinicRegion = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "neutral",
        "data-testid": "book-no-clinic",
        children: s('dashboard.book.noClinic')
    });
    else clinicRegion = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-book-field": "clinic",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
            label: s('dashboard.book.clinic'),
            value: clinicId,
            onChange: (e)=>{
                setClinicId(e.target.value);
                setErrors((x)=>({
                        ...x,
                        clinic: undefined
                    }));
            },
            options: clinics.map((c)=>({
                    value: c.clinicId,
                    label: c.name || c.clinicId
                })),
            placeholder: s('dashboard.book.clinic'),
            error: errors.clinic,
            disabled: busy,
            "data-testid": "book-clinic"
        })
    });
    // The two halves of the «تاریخ و ساعت» box. Their order flips with the walk-in
    // row: when today is full the notice naming the next free slot comes first.
    const timeOptions = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($38e656a4522e301b$var$OptionsFold, {
            open: timeOpen,
            onToggle: ()=>setTimeOpen((o)=>!o),
            showLabel: s('dashboard.book.showTimeOptions'),
            hideLabel: s('dashboard.book.hideTimeOptions'),
            testId: "book-time-options",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgeo.default), {
                    semantics: "filter",
                    ariaLabel: s('dashboard.book.mode'),
                    size: isMobile ? 'lg' : 'md',
                    value: slotMode,
                    onChange: pickMode,
                    options: [
                        {
                            value: 'first',
                            label: dayIsToday ? s('dashboard.book.modeFirstToday') : s('dashboard.book.modeFirstDay'),
                            disabled: busy
                        },
                        {
                            value: 'manual',
                            label: s('dashboard.book.modeManual'),
                            disabled: busy
                        }
                    ],
                    "data-testid": "book-slot-mode"
                }),
                isAuto && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                    label: s('dashboard.book.day'),
                    htmlFor: "book-day",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                        id: "book-day",
                        value: day,
                        onChange: (v)=>{
                            if (v) {
                                setDay(v);
                                setErrors((x)=>({
                                        ...x,
                                        when: undefined
                                    }));
                            }
                        },
                        disabled: busy,
                        "data-testid": "book-day"
                    })
                })
            ]
        })
    });
    const whenPicker = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: isAuto ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                clinic && /*#__PURE__*/ (0, $ayMG0.jsx)($38e656a4522e301b$var$FirstSlotPreview, {
                    s: s,
                    i18n: i18n,
                    preview: preview,
                    next: next,
                    dayIsToday: dayIsToday,
                    onUseNext: takeNext,
                    busy: busy
                }),
                errors.when && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "alert",
                    "data-testid": "book-when-error",
                    style: {
                        fontSize: 12,
                        color: (0, $jTCZr.CT).dangerInk
                    },
                    children: errors.when
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
            error: errors.when,
            htmlFor: "book-when",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                id: "book-when",
                value: when,
                onChange: (v)=>{
                    setWhen(v || '');
                    setErrors((x)=>({
                            ...x,
                            when: undefined
                        }));
                },
                withTime: true,
                minuteStep: 5,
                disabled: busy,
                "aria-invalid": errors.when ? true : undefined,
                "aria-label": s('dashboard.book.when'),
                "data-testid": "book-when"
            })
        })
    });
    // «خارج از نوبت همین الان» — the phone form keeps to one line until it has
    // something to add.
    const walkInHint = needsApproval ? s(isMobile ? 'dashboard.book.walkInNoGrantShort' : 'dashboard.book.walkInNoGrant') : walkIn ? s(isMobile ? 'dashboard.book.walkInOnShort' : 'dashboard.book.walkInOn') : walkInSuggested ? s(isMobile ? 'dashboard.book.walkInLeadShort' : 'dashboard.book.walkInLead') : isMobile ? null : s('dashboard.book.walkInOff');
    const walkInRow = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dyHsi.default), {
        checked: walkIn,
        onChange: toggleWalkIn,
        disabled: busy || needsApproval || !clinic,
        suggested: walkInSuggested,
        compact: isMobile,
        title: s('dashboard.book.walkIn'),
        hint: walkInHint,
        locale: i18n.locale,
        testId: "book-walkin"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gCvEY.default), {
        open: open,
        onClose: requestClose,
        title: s('dashboard.book.title'),
        footer: footer,
        busy: busy,
        size: "md",
        isMobile: isMobile,
        "data-testid": "book-appointment",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                id: "book-appointment-form",
                onSubmit: submit,
                noValidate: true,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                },
                children: [
                    clinicRegion,
                    needsApproval && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "warning",
                        title: s('dashboard.book.needsApprovalTitle'),
                        "data-testid": "book-needs-approval",
                        children: s('dashboard.book.needsApproval')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-book-field": mode === 'new' ? 'name' : 'patient',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: s('dashboard.book.patient')
                                    }),
                                    !patient && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                        size: "sm",
                                        variant: "ghost",
                                        type: "button",
                                        disabled: busy,
                                        "data-testid": "book-toggle-new",
                                        onClick: ()=>{
                                            setMode((m)=>m === 'new' ? 'existing' : 'new');
                                            setErrors({});
                                        },
                                        children: mode === 'new' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6imzq.default), {
                                                    size: 14,
                                                    "aria-hidden": true
                                                }),
                                                " ",
                                                s('dashboard.book.pickExisting')
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fb661ead567131f$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    "aria-hidden": true
                                                }),
                                                " ",
                                                s('dashboard.book.newPatient')
                                            ]
                                        })
                                    })
                                ]
                            }),
                            mode === 'existing' && patient && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-testid": "book-selected-patient",
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    padding: '10px 12px',
                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                    borderRadius: 10,
                                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.04)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                        name: patient.name,
                                        size: 32,
                                        bg: (0, $jTCZr.C).navy
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 13.5,
                                                    fontWeight: 700
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                                                    children: patient.name
                                                })
                                            }),
                                            patient.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                dir: "ltr",
                                                style: {
                                                    fontSize: 12,
                                                    color: (0, $jTCZr.C).textMuted,
                                                    textAlign: 'end'
                                                },
                                                children: (0, $5AX1S).forDisplay(patient.phone)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                        size: "sm",
                                        variant: "outline",
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>setPatient(null),
                                        children: s('dashboard.book.change')
                                    })
                                ]
                            }),
                            existingOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                role: "status",
                                "data-testid": "book-existing-open",
                                "data-status": existingOpen.status,
                                style: {
                                    padding: '8px 12px',
                                    borderRadius: 10,
                                    fontSize: 13,
                                    lineHeight: 1.7,
                                    background: (0, $jTCZr.CT).warnSoft,
                                    color: (0, $jTCZr.CT).warnInk
                                },
                                children: s(`dashboard.book.alreadyOpen.${existingOpen.status}`)
                            }),
                            mode === 'existing' && !patient && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                        value: search.query,
                                        onChange: (e)=>search.search(e.target.value),
                                        placeholder: s('dashboard.book.searchPlaceholder'),
                                        "aria-label": s('dashboard.book.searchLabel'),
                                        inputProps: {
                                            'data-testid': 'book-patient-search',
                                            autoFocus: !isMobile
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($38e656a4522e301b$var$PatientResults, {
                                        search: search,
                                        s: s,
                                        retryLabel: i18n.t('common.actions.retry'),
                                        formatNumber: formatNumber,
                                        onPick: (p)=>{
                                            setPatient(p);
                                            setErrors((x)=>({
                                                    ...x,
                                                    patient: undefined
                                                }));
                                        }
                                    }),
                                    errors.patient && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        role: "alert",
                                        style: {
                                            fontSize: 12,
                                            color: (0, $jTCZr.CT).dangerInk,
                                            marginTop: 6
                                        },
                                        children: errors.patient
                                    })
                                ]
                            }),
                            mode === 'new' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                        label: s('dashboard.book.name'),
                                        value: name,
                                        onChange: (e)=>setName(e.target.value),
                                        onBlur: ()=>{
                                            if (!name.trim()) setErrors((x)=>({
                                                    ...x,
                                                    name: s('dashboard.book.errors.name')
                                                }));
                                        },
                                        error: errors.name,
                                        disabled: busy,
                                        autoFocus: !isMobile,
                                        "data-testid": "book-new-name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-book-field": "phone",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lffTJ.default), {
                                            label: s('dashboard.book.phone'),
                                            value: phoneValue,
                                            onChange: (e164, info)=>{
                                                setPhoneValue(e164 || '');
                                                setPhoneOk(!info?.draft || !!e164);
                                            },
                                            error: errors.phone,
                                            disabled: busy,
                                            "data-testid": "book-new-phone"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-book-field": "nationalId",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Ydgp5.default), {
                                            label: s('dashboard.book.nationalId'),
                                            value: nationalId,
                                            allowOtherCountries: true,
                                            onCountryChange: (c)=>{
                                                setNationalIdCountry(c);
                                                setErrors((x)=>({
                                                        ...x,
                                                        nationalId: undefined
                                                    }));
                                            },
                                            onChange: (e)=>{
                                                setNationalId(e.target.value);
                                                setErrors((x)=>({
                                                        ...x,
                                                        nationalId: undefined
                                                    }));
                                            },
                                            error: errors.nationalId,
                                            disabled: busy,
                                            "data-testid": "book-new-national-id"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-book-field": "when",
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12,
                            padding: 12,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 10,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.03)
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: s('dashboard.book.when')
                            }),
                            walkInSuggested && !walkIn && walkInRow,
                            !walkIn && (walkInSuggested ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    whenPicker,
                                    timeOptions
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    timeOptions,
                                    whenPicker
                                ]
                            })),
                            (walkIn || !walkInSuggested) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(walkInRow, {
                                separated: !walkIn
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($38e656a4522e301b$var$OptionsFold, {
                        open: moreOpen,
                        onToggle: ()=>setMoreOpen((o)=>!o),
                        showLabel: s('dashboard.book.moreOptions'),
                        hideLabel: s('dashboard.book.lessOptions'),
                        testId: "book-more-options",
                        children: [
                            !walkIn && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                                        label: s('dashboard.book.visitType'),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgeo.default), {
                                            semantics: "filter",
                                            ariaLabel: s('dashboard.book.visitType'),
                                            size: isMobile ? 'lg' : 'md',
                                            value: visitType,
                                            onChange: setVisitType,
                                            options: [
                                                {
                                                    value: 'in_person',
                                                    label: s('dashboard.book.typeInPerson'),
                                                    disabled: busy
                                                },
                                                {
                                                    value: 'online',
                                                    label: s('dashboard.book.typeOnline'),
                                                    disabled: busy
                                                }
                                            ],
                                            "data-testid": "book-visit-type"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                        label: s('dashboard.book.duration'),
                                        value: String(effectiveDuration),
                                        onChange: (e)=>setDuration(e.target.value),
                                        options: durationOptions,
                                        disabled: busy,
                                        "data-testid": "book-duration"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                                label: s('dashboard.book.note'),
                                value: note,
                                onChange: (e)=>setNote(e.target.value.slice(0, 280)),
                                rows: 2,
                                disabled: busy,
                                "data-testid": "book-note"
                            })
                        ]
                    }),
                    formError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        "data-testid": "book-error",
                        children: formError
                    })
                ]
            }),
            guard
        ]
    });
}
// A collapsed group of booking options: one quiet row that says what is behind
// it, expanded only when the doctor needs it. The default answer — «اولین نوبت
// امروز» — is already on screen without it.
function $38e656a4522e301b$var$OptionsFold({ open: open, onToggle: onToggle, showLabel: showLabel, hideLabel: hideLabel, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                "data-testid": testId,
                style: {
                    width: '100%',
                    minHeight: 44,
                    padding: '8px 12px',
                    borderRadius: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    border: `1px dashed ${(0, $jTCZr.C).border}`,
                    background: (0, $jTCZr.CT).surface,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    fontSize: 13,
                    fontWeight: 700,
                    color: (0, $jTCZr.C).navy,
                    textAlign: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: open ? hideLabel : showLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                        size: 16,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0,
                            transform: open ? 'rotate(180deg)' : 'none',
                            transition: 'transform .15s'
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: children
            })
        ]
    });
}
// What an «اولین نوبت» booking would take — loading / error / the slot / an empty
// day, exactly one at a time. An empty day names the next real slot and takes it
// in one press, instead of leaving the doctor to hunt for that day.
function $38e656a4522e301b$var$FirstSlotPreview({ s: s, i18n: i18n, preview: preview, next: next, dayIsToday: dayIsToday, onUseNext: onUseNext, busy: busy }) {
    const { formatDate: formatDate, formatTime: formatTime, t: t } = i18n;
    if (preview.loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
        height: 64,
        "data-testid": "book-first-loading"
    });
    if (preview.error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "error",
        "data-testid": "book-first-error",
        children: s('dashboard.book.firstSlotFailed')
    });
    if (!preview.slot) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "book-first-empty",
        action: next.slot ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            type: "button",
            disabled: busy,
            onClick: ()=>onUseNext(next.slot),
            "data-testid": "book-take-next",
            children: s('dashboard.book.bookThisOne')
        }) : null,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: dayIsToday ? s('dashboard.book.noneLeftToday') : s('dashboard.book.noneThisDay')
            }),
            next.loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 6
                },
                children: s('dashboard.book.finding')
            }),
            !next.loading && next.slot && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: 6
                },
                children: [
                    s('dashboard.book.nextIs'),
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: s('dashboard.book.slotAt', {
                            date: formatDate(Number(next.slot.dateTime), 'full'),
                            time: formatTime(Number(next.slot.dateTime))
                        })
                    })
                ]
            }),
            !next.loading && !next.slot && !next.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 6
                },
                children: s('dashboard.book.noneIn30Days')
            }),
            !next.loading && next.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 6
                },
                children: t('common.actions.retry')
            })
        ]
    });
    const at = Number(preview.slot.dateTime);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "book-first-slot",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 14px',
            border: `1px solid ${(0, $jTCZr.C).navy}`,
            borderRadius: 10,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06)
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: (0, $jTCZr.C).navy,
                    color: (0, $jTCZr.CT).surface,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                    size: 18,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: 0,
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: s('dashboard.book.firstFree')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 18,
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).navy
                                },
                                children: formatTime(at)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: formatDate(at, 'full')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2
                        },
                        children: s('dashboard.book.exactAtBooking')
                    })
                ]
            })
        ]
    });
}
// The search result region — idle / below-minimum / loading / error / empty /
// content, exactly one at a time (DESIGN_CONCEPT §2.4).
function $38e656a4522e301b$var$PatientResults({ search: search, s: s, retryLabel: retryLabel, formatNumber: formatNumber, onPick: onPick }) {
    const box = {
        marginTop: 8,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        borderRadius: 10,
        overflow: 'hidden'
    };
    const quiet = {
        fontSize: 12,
        color: (0, $jTCZr.C).textMuted,
        padding: '10px 12px'
    };
    switch(search.state){
        case 'idle':
            return null;
        case 'below':
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: quiet,
                children: s('dashboard.book.searchHint')
            });
        case 'loading':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...box,
                    padding: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                "data-testid": "book-results-loading",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 40
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 40
                    })
                ]
            });
        case 'error':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                style: {
                    marginTop: 8
                },
                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    size: "sm",
                    variant: "outline",
                    type: "button",
                    onClick: search.retry,
                    children: retryLabel
                }),
                children: s('dashboard.book.searchFailed')
            });
        case 'empty':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...quiet,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                "data-testid": "book-results-empty",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                        size: 16,
                        strokeWidth: 1.5,
                        "aria-hidden": true
                    }),
                    " ",
                    s('dashboard.book.noMatch')
                ]
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...box,
                    opacity: search.loading ? 0.45 : 1
                },
                role: "listbox",
                "aria-label": s('dashboard.book.searchLabel'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            maxHeight: 240,
                            overflowY: 'auto'
                        },
                        children: search.results.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                role: "option",
                                "aria-selected": "false",
                                "data-testid": `book-patient-${p.id}`,
                                onClick: ()=>onPick(p),
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    width: '100%',
                                    minHeight: 44,
                                    padding: '8px 12px',
                                    background: 'transparent',
                                    border: 'none',
                                    borderBottom: `1px solid ${(0, $jTCZr.CT).surface2}`,
                                    cursor: 'pointer',
                                    textAlign: 'start'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                        name: p.name,
                                        size: 28,
                                        bg: (0, $jTCZr.C).navy
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0,
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                                            children: p.name
                                        })
                                    }),
                                    p.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        dir: "ltr",
                                        style: {
                                            fontSize: 12,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: (0, $5AX1S).forDisplay(p.phone)
                                    })
                                ]
                            }, p.id))
                    }),
                    search.truncated && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...quiet,
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: s('dashboard.book.truncated', {
                            count: formatNumber(search.results.length)
                        })
                    })
                ]
            });
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $hZDga = parcelRequire("hZDga");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




// ─────────────────────────────────────────────────────────────────────────────
// «تغییر زمان نوبت» (PM-0102) — the doctor moves one of their own booked نوبت‌ها
// to another day or hour.
//
// ONE question in TaskOverlay's two shells (DESIGN_CONCEPT §5.2): when. The
// patient and the clinic are facts of the row and are shown, not asked. The
// same date-and-time picker «ثبت نوبت» uses for «انتخاب دستی», opened on the
// time the نوبت has now.
//
// The row is MOVED — never cancelled and booked again — so its invoice and any
// prepayment stay where they are. The server re-runs the shift and the overlap
// rules at the new instant and re-reads the clinic's booking grant; a refusal
// about the TIME lands on the field (§6.3), anything else in the form's own
// Alert (§2.4: a form open in front of the user reports inline, never a toast).
// Nothing is optimistic: the overlay closes on the server's answer.
// ─────────────────────────────────────────────────────────────────────────────
// Refusals that are about the instant the doctor picked.
const $c4a79b113c1d45d4$var$TIME_CODES = new Set([
    'SLOT_TAKEN',
    'DOCTOR_NOT_PRESENT',
    'BAD_USER_INPUT'
]);
function $c4a79b113c1d45d4$export$2e2bcd8739ae039({ open: open, onClose: onClose, apt: apt, onRescheduled: onRescheduled, isMobile: isMobile }) {
    const i18n = (0, $LNQP4.default)();
    const { formatDate: formatDate, formatTime: formatTime } = i18n;
    const s = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const current = apt?.dateTime ? (0, $917ea62a53046a22$export$ea965b90d2460726)(apt.dateTime) : '';
    const [when, setWhen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(current);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [whenError, setWhenError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [formError, setFormError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Every open starts from the row as it is now — never from the last attempt.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setWhen(current);
        setBusy(false);
        setWhenError('');
        setFormError('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        apt?.id
    ]);
    const changed = Boolean(when) && when !== current;
    const { requestClose: requestClose, guard: guard } = (0, $9b530774ad99e23e$export$db6b977dd1b3391f)(changed && !busy, onClose);
    const submit = async (e)=>{
        e?.preventDefault?.();
        if (busy || !apt?.id || !changed) return;
        setFormError('');
        const at = (0, $917ea62a53046a22$export$9dab6106cce55aad)(when);
        if (at == null) {
            setWhenError(s('dashboard.book.errors.when'));
            return;
        }
        if (at < Date.now() - 300000) {
            setWhenError(s('dashboard.book.errors.past'));
            return;
        }
        setBusy(true);
        try {
            const moved = await (0, $917ea62a53046a22$export$d49bf8b0d6ea0efc)(apt.id, at);
            const landed = Number(moved?.dateTime) || at;
            onRescheduled?.(moved, {
                dayISO: when.slice(0, 10),
                when: s('dashboard.book.slotAt', {
                    date: formatDate(landed, 'full'),
                    time: formatTime(landed)
                })
            });
            onClose?.();
        } catch (err) {
            const message = (0, $6dd1a0ec80cef79b$export$9bef418888ccb2cd)(err, i18n, 'errors.save.generic');
            if ($c4a79b113c1d45d4$var$TIME_CODES.has((0, $917ea62a53046a22$export$dbfe74f291058e97)(err))) setWhenError(message);
            else setFormError(message);
        } finally{
            setBusy(false);
        }
    };
    const name = apt?.name || apt?.patient?.name || i18n.t('common.labels.patient');
    const at = Number(apt?.dateTime);
    const footer = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                type: "button",
                onClick: requestClose,
                disabled: busy,
                children: s('dashboard.withdraw.keep')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                type: "submit",
                form: "reschedule-appointment-form",
                disabled: busy || !changed,
                "aria-busy": busy || undefined,
                "data-testid": "reschedule-submit",
                children: [
                    busy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                        size: 16,
                        color: "currentColor"
                    }),
                    s('dashboard.reschedule.submit')
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gCvEY.default), {
                open: open,
                onClose: requestClose,
                title: s('dashboard.reschedule.title'),
                footer: footer,
                busy: busy,
                size: "sm",
                isMobile: isMobile,
                "data-testid": "reschedule-appointment",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    id: "reschedule-appointment-form",
                    onSubmit: submit,
                    noValidate: true,
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "reschedule-current",
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                padding: '10px 12px',
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: 10,
                                background: (0, $jTCZr.CT).surface2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                    name: name,
                                    size: 36,
                                    bg: (0, $jTCZr.C).navy
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        minWidth: 0,
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: 14,
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                                                children: name
                                            })
                                        }),
                                        Number.isFinite(at) && at > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: 12,
                                                color: (0, $jTCZr.C).textMuted,
                                                marginTop: 2
                                            },
                                            children: s('dashboard.reschedule.current', {
                                                when: s('dashboard.book.slotAt', {
                                                    date: formatDate(at, 'full'),
                                                    time: formatTime(at)
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        formError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                            variant: "error",
                            "data-testid": "reschedule-error",
                            children: formError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                            label: s('dashboard.reschedule.newTime'),
                            error: whenError,
                            htmlFor: "reschedule-when",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                id: "reschedule-when",
                                value: when,
                                onChange: (v)=>{
                                    setWhen(v || '');
                                    setWhenError('');
                                },
                                withTime: true,
                                minuteStep: 5,
                                disabled: busy,
                                "aria-invalid": whenError ? true : undefined,
                                "aria-label": s('dashboard.reschedule.newTime'),
                                "data-testid": "reschedule-when"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: 12,
                                color: (0, $jTCZr.C).textMuted,
                                lineHeight: 1.8
                            },
                            children: s('dashboard.reschedule.hint')
                        })
                    ]
                })
            }),
            guard
        ]
    });
}



var $acw62 = parcelRequire("acw62");


function $950e52607b770dfb$export$5acc4bb723e384c({ selISO: selISO, reload: reload, withdrawRequest: withdrawRequest, toast: toast }) {
    const s = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const booking = (0, $917ea62a53046a22$export$d390b7bb6e3190e5)();
    const canBook = (booking.clinics || []).length > 0;
    const [bookOpen, setBookOpen] = (0, $acw62.useState)(false);
    const [pendingWithdraw, setPendingWithdraw] = (0, $acw62.useState)(null);
    // «تغییر زمان» (PM-0102): the row being moved, or null.
    const [rescheduling, setRescheduling] = (0, $acw62.useState)(null);
    // The same forecast «ثبت نوبت» makes, for a move: a نوبت still waiting for its
    // patient, at a clinic that lets this doctor book directly (a نوبت that names
    // no clinic is the doctor's own diary). Where the clinic withdrew the grant the
    // move is the desk's, so no button is offered. Display only — the BFF decides
    // again from the membership row when it writes.
    const canReschedule = (0, $acw62.useCallback)((apt)=>{
        if (!apt?.id || apt.status !== 'scheduled' || !apt.dateTime) return false;
        if (!apt.clinicId) return true;
        return Boolean((booking.clinics || []).find((c)=>c.clinicId === apt.clinicId)?.canBookDirectly);
    }, [
        booking.clinics
    ]);
    // The row is on screen when it stayed on this day: its new hour IS the
    // feedback. Moved to another day it leaves the list, so that is said in words.
    const onRescheduled = (0, $acw62.useCallback)((_moved, { dayISO: dayISO, when: when } = {})=>{
        reload?.();
        if (dayISO && dayISO !== selISO) toast?.success?.(s('dashboard.reschedule.moved', {
            when: when || ''
        }));
    }, [
        reload,
        toast,
        s,
        selISO
    ]);
    const onBooked = (0, $acw62.useCallback)((result, { dayISO: dayISO, walkIn: walkIn } = {})=>{
        reload?.();
        // A walk-in has no hour to find on the list, so it is always confirmed in words.
        if (walkIn) toast?.success?.(s('dashboard.book.walkInBooked'));
        else if (result?.outcome === 'requested') toast?.success?.(s('dashboard.book.requested'));
        else if (dayISO && dayISO !== selISO) toast?.success?.(s('dashboard.book.booked'));
    }, [
        reload,
        toast,
        s,
        selISO
    ]);
    // Returned to the ConfirmDialog so it stays open until the write settles.
    const confirmWithdraw = (0, $acw62.useCallback)(async ()=>{
        if (!pendingWithdraw) return;
        try {
            await withdrawRequest(pendingWithdraw.id);
            setPendingWithdraw(null);
        } catch  {
            setPendingWithdraw(null);
            toast?.error?.(s('dashboard.withdraw.failed'));
        }
    }, [
        pendingWithdraw,
        withdrawRequest,
        toast,
        s
    ]);
    return {
        s: s,
        canBook: canBook,
        bookingClinics: booking,
        bookOpen: bookOpen,
        openBook: (0, $acw62.useCallback)(()=>setBookOpen(true), []),
        closeBook: (0, $acw62.useCallback)(()=>setBookOpen(false), []),
        onBooked: onBooked,
        pendingWithdraw: pendingWithdraw,
        askWithdraw: setPendingWithdraw,
        cancelWithdraw: (0, $acw62.useCallback)(()=>setPendingWithdraw(null), []),
        confirmWithdraw: confirmWithdraw,
        canReschedule: canReschedule,
        rescheduling: rescheduling,
        askReschedule: setRescheduling,
        closeReschedule: (0, $acw62.useCallback)(()=>setRescheduling(null), []),
        onRescheduled: onRescheduled
    };
}
var $950e52607b770dfb$export$2e2bcd8739ae039 = $950e52607b770dfb$export$5acc4bb723e384c;




var $ayMG0 = parcelRequire("ayMG0");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fb9bc397b09eca5a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 6v6h4",
            key: "135r8i"
        }
    ]
];
const $fb9bc397b09eca5a$export$2e2bcd8739ae039 = (0, $9QBug.default)("clock-3", $fb9bc397b09eca5a$export$3efd853dbb351e94);


var $97xXr = parcelRequire("97xXr");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
var $698642d9a9b49d3e$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $698642d9a9b49d3e$exports = factory();
})(typeof self !== 'undefined' ? self : $698642d9a9b49d3e$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix = /** @class */ function() {
                function BitMatrix(data, width) {
                    this.width = width;
                    this.height = data.length / width;
                    this.data = data;
                }
                BitMatrix.createEmpty = function(width, height) {
                    return new BitMatrix(new Uint8ClampedArray(width * height), width);
                };
                BitMatrix.prototype.get = function(x, y) {
                    if (x < 0 || x >= this.width || y < 0 || y >= this.height) return false;
                    return !!this.data[y * this.width + x];
                };
                BitMatrix.prototype.set = function(x, y, v) {
                    this.data[y * this.width + x] = v ? 1 : 0;
                };
                BitMatrix.prototype.setRegion = function(left, top, width, height, v) {
                    for(var y = top; y < top + height; y++)for(var x = left; x < left + width; x++)this.set(x, y, !!v);
                };
                return BitMatrix;
            }();
            exports.BitMatrix = BitMatrix;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGFPoly_1 = __webpack_require__(2);
            function addOrSubtractGF(a, b) {
                return a ^ b; // tslint:disable-line:no-bitwise
            }
            exports.addOrSubtractGF = addOrSubtractGF;
            var GenericGF = /** @class */ function() {
                function GenericGF(primitive, size, genBase) {
                    this.primitive = primitive;
                    this.size = size;
                    this.generatorBase = genBase;
                    this.expTable = new Array(this.size);
                    this.logTable = new Array(this.size);
                    var x = 1;
                    for(var i = 0; i < this.size; i++){
                        this.expTable[i] = x;
                        x = x * 2;
                        if (x >= this.size) x = (x ^ this.primitive) & this.size - 1; // tslint:disable-line:no-bitwise
                    }
                    for(var i = 0; i < this.size - 1; i++)this.logTable[this.expTable[i]] = i;
                    this.zero = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        0
                    ]));
                    this.one = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        1
                    ]));
                }
                GenericGF.prototype.multiply = function(a, b) {
                    if (a === 0 || b === 0) return 0;
                    return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
                };
                GenericGF.prototype.inverse = function(a) {
                    if (a === 0) throw new Error("Can't invert 0");
                    return this.expTable[this.size - this.logTable[a] - 1];
                };
                GenericGF.prototype.buildMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid monomial degree less than 0");
                    if (coefficient === 0) return this.zero;
                    var coefficients = new Uint8ClampedArray(degree + 1);
                    coefficients[0] = coefficient;
                    return new GenericGFPoly_1.default(this, coefficients);
                };
                GenericGF.prototype.log = function(a) {
                    if (a === 0) throw new Error("Can't take log(0)");
                    return this.logTable[a];
                };
                GenericGF.prototype.exp = function(a) {
                    return this.expTable[a];
                };
                return GenericGF;
            }();
            exports.default = GenericGF;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly = /** @class */ function() {
                function GenericGFPoly(field, coefficients) {
                    if (coefficients.length === 0) throw new Error("No coefficients.");
                    this.field = field;
                    var coefficientsLength = coefficients.length;
                    if (coefficientsLength > 1 && coefficients[0] === 0) {
                        // Leading term must be non-zero for anything except the constant polynomial "0"
                        var firstNonZero = 1;
                        while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                        if (firstNonZero === coefficientsLength) this.coefficients = field.zero.coefficients;
                        else {
                            this.coefficients = new Uint8ClampedArray(coefficientsLength - firstNonZero);
                            for(var i = 0; i < this.coefficients.length; i++)this.coefficients[i] = coefficients[firstNonZero + i];
                        }
                    } else this.coefficients = coefficients;
                }
                GenericGFPoly.prototype.degree = function() {
                    return this.coefficients.length - 1;
                };
                GenericGFPoly.prototype.isZero = function() {
                    return this.coefficients[0] === 0;
                };
                GenericGFPoly.prototype.getCoefficient = function(degree) {
                    return this.coefficients[this.coefficients.length - 1 - degree];
                };
                GenericGFPoly.prototype.addOrSubtract = function(other) {
                    var _a;
                    if (this.isZero()) return other;
                    if (other.isZero()) return this;
                    var smallerCoefficients = this.coefficients;
                    var largerCoefficients = other.coefficients;
                    if (smallerCoefficients.length > largerCoefficients.length) _a = [
                        largerCoefficients,
                        smallerCoefficients
                    ], smallerCoefficients = _a[0], largerCoefficients = _a[1];
                    var sumDiff = new Uint8ClampedArray(largerCoefficients.length);
                    var lengthDiff = largerCoefficients.length - smallerCoefficients.length;
                    for(var i = 0; i < lengthDiff; i++)sumDiff[i] = largerCoefficients[i];
                    for(var i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = GenericGF_1.addOrSubtractGF(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
                    return new GenericGFPoly(this.field, sumDiff);
                };
                GenericGFPoly.prototype.multiply = function(scalar) {
                    if (scalar === 0) return this.field.zero;
                    if (scalar === 1) return this;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyPoly = function(other) {
                    if (this.isZero() || other.isZero()) return this.field.zero;
                    var aCoefficients = this.coefficients;
                    var aLength = aCoefficients.length;
                    var bCoefficients = other.coefficients;
                    var bLength = bCoefficients.length;
                    var product = new Uint8ClampedArray(aLength + bLength - 1);
                    for(var i = 0; i < aLength; i++){
                        var aCoeff = aCoefficients[i];
                        for(var j = 0; j < bLength; j++)product[i + j] = GenericGF_1.addOrSubtractGF(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
                    }
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyByMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid degree less than 0");
                    if (coefficient === 0) return this.field.zero;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size + degree);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.evaluateAt = function(a) {
                    var result = 0;
                    if (a === 0) // Just return the x^0 coefficient
                    return this.getCoefficient(0);
                    var size = this.coefficients.length;
                    if (a === 1) {
                        // Just the sum of the coefficients
                        this.coefficients.forEach(function(coefficient) {
                            result = GenericGF_1.addOrSubtractGF(result, coefficient);
                        });
                        return result;
                    }
                    result = this.coefficients[0];
                    for(var i = 1; i < size; i++)result = GenericGF_1.addOrSubtractGF(this.field.multiply(a, result), this.coefficients[i]);
                    return result;
                };
                return GenericGFPoly;
            }();
            exports.default = GenericGFPoly;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var binarizer_1 = __webpack_require__(4);
            var decoder_1 = __webpack_require__(5);
            var extractor_1 = __webpack_require__(11);
            var locator_1 = __webpack_require__(12);
            function scan(matrix) {
                var locations = locator_1.locate(matrix);
                if (!locations) return null;
                for(var _i = 0, locations_1 = locations; _i < locations_1.length; _i++){
                    var location_1 = locations_1[_i];
                    var extracted = extractor_1.extract(matrix, location_1);
                    var decoded = decoder_1.decode(extracted.matrix);
                    if (decoded) return {
                        binaryData: decoded.bytes,
                        data: decoded.text,
                        chunks: decoded.chunks,
                        version: decoded.version,
                        location: {
                            topRightCorner: extracted.mappingFunction(location_1.dimension, 0),
                            topLeftCorner: extracted.mappingFunction(0, 0),
                            bottomRightCorner: extracted.mappingFunction(location_1.dimension, location_1.dimension),
                            bottomLeftCorner: extracted.mappingFunction(0, location_1.dimension),
                            topRightFinderPattern: location_1.topRight,
                            topLeftFinderPattern: location_1.topLeft,
                            bottomLeftFinderPattern: location_1.bottomLeft,
                            bottomRightAlignmentPattern: location_1.alignmentPattern
                        }
                    };
                }
                return null;
            }
            var defaultOptions = {
                inversionAttempts: "attemptBoth"
            };
            function jsQR(data, width, height, providedOptions) {
                if (providedOptions === void 0) providedOptions = {};
                var options = defaultOptions;
                Object.keys(options || {}).forEach(function(opt) {
                    options[opt] = providedOptions[opt] || options[opt];
                });
                var shouldInvert = options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst";
                var tryInvertedFirst = options.inversionAttempts === "onlyInvert" || options.inversionAttempts === "invertFirst";
                var _a = binarizer_1.binarize(data, width, height, shouldInvert), binarized = _a.binarized, inverted = _a.inverted;
                var result = scan(tryInvertedFirst ? inverted : binarized);
                if (!result && (options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst")) result = scan(tryInvertedFirst ? binarized : inverted);
                return result;
            }
            jsQR.default = jsQR;
            exports.default = jsQR;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var REGION_SIZE = 8;
            var MIN_DYNAMIC_RANGE = 24;
            function numBetween(value, min, max) {
                return value < min ? min : value > max ? max : value;
            }
            // Like BitMatrix but accepts arbitry Uint8 values
            var Matrix = /** @class */ function() {
                function Matrix(width, height) {
                    this.width = width;
                    this.data = new Uint8ClampedArray(width * height);
                }
                Matrix.prototype.get = function(x, y) {
                    return this.data[y * this.width + x];
                };
                Matrix.prototype.set = function(x, y, value) {
                    this.data[y * this.width + x] = value;
                };
                return Matrix;
            }();
            function binarize(data, width, height, returnInverted) {
                if (data.length !== width * height * 4) throw new Error("Malformed data passed to binarizer.");
                // Convert image to greyscale
                var greyscalePixels = new Matrix(width, height);
                for(var x = 0; x < width; x++)for(var y = 0; y < height; y++){
                    var r = data[(y * width + x) * 4 + 0];
                    var g = data[(y * width + x) * 4 + 1];
                    var b = data[(y * width + x) * 4 + 2];
                    greyscalePixels.set(x, y, 0.2126 * r + 0.7152 * g + 0.0722 * b);
                }
                var horizontalRegionCount = Math.ceil(width / REGION_SIZE);
                var verticalRegionCount = Math.ceil(height / REGION_SIZE);
                var blackPoints = new Matrix(horizontalRegionCount, verticalRegionCount);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var sum = 0;
                    var min = Infinity;
                    var max = 0;
                    for(var y = 0; y < REGION_SIZE; y++)for(var x = 0; x < REGION_SIZE; x++){
                        var pixelLumosity = greyscalePixels.get(hortizontalRegion * REGION_SIZE + x, verticalRegion * REGION_SIZE + y);
                        sum += pixelLumosity;
                        min = Math.min(min, pixelLumosity);
                        max = Math.max(max, pixelLumosity);
                    }
                    var average = sum / Math.pow(REGION_SIZE, 2);
                    if (max - min <= MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // Default the blackpoint for these blocks to be half the min - effectively white them out
                        average = min / 2;
                        if (verticalRegion > 0 && hortizontalRegion > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            var averageNeighborBlackPoint = (blackPoints.get(hortizontalRegion, verticalRegion - 1) + 2 * blackPoints.get(hortizontalRegion - 1, verticalRegion) + blackPoints.get(hortizontalRegion - 1, verticalRegion - 1)) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints.set(hortizontalRegion, verticalRegion, average);
                }
                var binarized = BitMatrix_1.BitMatrix.createEmpty(width, height);
                var inverted = null;
                if (returnInverted) inverted = BitMatrix_1.BitMatrix.createEmpty(width, height);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var left = numBetween(hortizontalRegion, 2, horizontalRegionCount - 3);
                    var top_1 = numBetween(verticalRegion, 2, verticalRegionCount - 3);
                    var sum = 0;
                    for(var xRegion = -2; xRegion <= 2; xRegion++)for(var yRegion = -2; yRegion <= 2; yRegion++)sum += blackPoints.get(left + xRegion, top_1 + yRegion);
                    var threshold = sum / 25;
                    for(var xRegion = 0; xRegion < REGION_SIZE; xRegion++)for(var yRegion = 0; yRegion < REGION_SIZE; yRegion++){
                        var x = hortizontalRegion * REGION_SIZE + xRegion;
                        var y = verticalRegion * REGION_SIZE + yRegion;
                        var lum = greyscalePixels.get(x, y);
                        binarized.set(x, y, lum <= threshold);
                        if (returnInverted) inverted.set(x, y, !(lum <= threshold));
                    }
                }
                if (returnInverted) return {
                    binarized: binarized,
                    inverted: inverted
                };
                return {
                    binarized: binarized
                };
            }
            exports.binarize = binarize;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var decodeData_1 = __webpack_require__(6);
            var reedsolomon_1 = __webpack_require__(9);
            var version_1 = __webpack_require__(10);
            // tslint:disable:no-bitwise
            function numBitsDiffering(x, y) {
                var z = x ^ y;
                var bitCount = 0;
                while(z){
                    bitCount++;
                    z &= z - 1;
                }
                return bitCount;
            }
            function pushBit(bit, byte) {
                return byte << 1 | bit;
            }
            // tslint:enable:no-bitwise
            var FORMAT_INFO_TABLE = [
                {
                    bits: 0x5412,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x5125,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x5E7C,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x5B4B,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x45F9,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x40CE,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x4F97,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x4AA0,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x77C4,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x72F3,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x7DAA,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x789D,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x662F,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x6318,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x6C41,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x6976,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x1689,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x13BE,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x1CE7,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x19D0,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x0762,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x0255,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x0D0C,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x083B,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x355F,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x3068,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x3F31,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x3A06,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x24B4,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x2183,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x2EDA,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x2BED,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 7
                    }
                }
            ];
            var DATA_MASKS = [
                function(p) {
                    return (p.y + p.x) % 2 === 0;
                },
                function(p) {
                    return p.y % 2 === 0;
                },
                function(p) {
                    return p.x % 3 === 0;
                },
                function(p) {
                    return (p.y + p.x) % 3 === 0;
                },
                function(p) {
                    return (Math.floor(p.y / 2) + Math.floor(p.x / 3)) % 2 === 0;
                },
                function(p) {
                    return p.x * p.y % 2 + p.x * p.y % 3 === 0;
                },
                function(p) {
                    return (p.y * p.x % 2 + p.y * p.x % 3) % 2 === 0;
                },
                function(p) {
                    return ((p.y + p.x) % 2 + p.y * p.x % 3) % 2 === 0;
                }
            ];
            function buildFunctionPatternMask(version) {
                var dimension = 17 + 4 * version.versionNumber;
                var matrix = BitMatrix_1.BitMatrix.createEmpty(dimension, dimension);
                matrix.setRegion(0, 0, 9, 9, true); // Top left finder pattern + separator + format
                matrix.setRegion(dimension - 8, 0, 8, 9, true); // Top right finder pattern + separator + format
                matrix.setRegion(0, dimension - 8, 9, 8, true); // Bottom left finder pattern + separator + format
                // Alignment patterns
                for(var _i = 0, _a = version.alignmentPatternCenters; _i < _a.length; _i++){
                    var x = _a[_i];
                    for(var _b = 0, _c = version.alignmentPatternCenters; _b < _c.length; _b++){
                        var y = _c[_b];
                        if (!(x === 6 && y === 6 || x === 6 && y === dimension - 7 || x === dimension - 7 && y === 6)) matrix.setRegion(x - 2, y - 2, 5, 5, true);
                    }
                }
                matrix.setRegion(6, 9, 1, dimension - 17, true); // Vertical timing pattern
                matrix.setRegion(9, 6, dimension - 17, 1, true); // Horizontal timing pattern
                if (version.versionNumber > 6) {
                    matrix.setRegion(dimension - 11, 0, 3, 6, true); // Version info, top right
                    matrix.setRegion(0, dimension - 11, 6, 3, true); // Version info, bottom left
                }
                return matrix;
            }
            function readCodewords(matrix, version, formatInfo) {
                var dataMask = DATA_MASKS[formatInfo.dataMask];
                var dimension = matrix.height;
                var functionPatternMask = buildFunctionPatternMask(version);
                var codewords = [];
                var currentByte = 0;
                var bitsRead = 0;
                // Read columns in pairs, from right to left
                var readingUp = true;
                for(var columnIndex = dimension - 1; columnIndex > 0; columnIndex -= 2){
                    if (columnIndex === 6) columnIndex--;
                    for(var i = 0; i < dimension; i++){
                        var y = readingUp ? dimension - 1 - i : i;
                        for(var columnOffset = 0; columnOffset < 2; columnOffset++){
                            var x = columnIndex - columnOffset;
                            if (!functionPatternMask.get(x, y)) {
                                bitsRead++;
                                var bit = matrix.get(x, y);
                                if (dataMask({
                                    y: y,
                                    x: x
                                })) bit = !bit;
                                currentByte = pushBit(bit, currentByte);
                                if (bitsRead === 8) {
                                    codewords.push(currentByte);
                                    bitsRead = 0;
                                    currentByte = 0;
                                }
                            }
                        }
                    }
                    readingUp = !readingUp;
                }
                return codewords;
            }
            function readVersion(matrix) {
                var dimension = matrix.height;
                var provisionalVersion = Math.floor((dimension - 17) / 4);
                if (provisionalVersion <= 6) return version_1.VERSIONS[provisionalVersion - 1];
                var topRightVersionBits = 0;
                for(var y = 5; y >= 0; y--)for(var x = dimension - 9; x >= dimension - 11; x--)topRightVersionBits = pushBit(matrix.get(x, y), topRightVersionBits);
                var bottomLeftVersionBits = 0;
                for(var x = 5; x >= 0; x--)for(var y = dimension - 9; y >= dimension - 11; y--)bottomLeftVersionBits = pushBit(matrix.get(x, y), bottomLeftVersionBits);
                var bestDifference = Infinity;
                var bestVersion;
                for(var _i = 0, VERSIONS_1 = version_1.VERSIONS; _i < VERSIONS_1.length; _i++){
                    var version = VERSIONS_1[_i];
                    if (version.infoBits === topRightVersionBits || version.infoBits === bottomLeftVersionBits) return version;
                    var difference = numBitsDiffering(topRightVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                    difference = numBitsDiffering(bottomLeftVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                }
                // We can tolerate up to 3 bits of error since no two version info codewords will
                // differ in less than 8 bits.
                if (bestDifference <= 3) return bestVersion;
            }
            function readFormatInformation(matrix) {
                var topLeftFormatInfoBits = 0;
                for(var x = 0; x <= 8; x++)if (x !== 6) topLeftFormatInfoBits = pushBit(matrix.get(x, 8), topLeftFormatInfoBits);
                for(var y = 7; y >= 0; y--)if (y !== 6) topLeftFormatInfoBits = pushBit(matrix.get(8, y), topLeftFormatInfoBits);
                var dimension = matrix.height;
                var topRightBottomRightFormatInfoBits = 0;
                for(var y = dimension - 1; y >= dimension - 7; y--)topRightBottomRightFormatInfoBits = pushBit(matrix.get(8, y), topRightBottomRightFormatInfoBits);
                for(var x = dimension - 8; x < dimension; x++)topRightBottomRightFormatInfoBits = pushBit(matrix.get(x, 8), topRightBottomRightFormatInfoBits);
                var bestDifference = Infinity;
                var bestFormatInfo = null;
                for(var _i = 0, FORMAT_INFO_TABLE_1 = FORMAT_INFO_TABLE; _i < FORMAT_INFO_TABLE_1.length; _i++){
                    var _a = FORMAT_INFO_TABLE_1[_i], bits = _a.bits, formatInfo = _a.formatInfo;
                    if (bits === topLeftFormatInfoBits || bits === topRightBottomRightFormatInfoBits) return formatInfo;
                    var difference = numBitsDiffering(topLeftFormatInfoBits, bits);
                    if (difference < bestDifference) {
                        bestFormatInfo = formatInfo;
                        bestDifference = difference;
                    }
                    if (topLeftFormatInfoBits !== topRightBottomRightFormatInfoBits) {
                        difference = numBitsDiffering(topRightBottomRightFormatInfoBits, bits);
                        if (difference < bestDifference) {
                            bestFormatInfo = formatInfo;
                            bestDifference = difference;
                        }
                    }
                }
                // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits differing means we found a match
                if (bestDifference <= 3) return bestFormatInfo;
                return null;
            }
            function getDataBlocks(codewords, version, ecLevel) {
                var ecInfo = version.errorCorrectionLevels[ecLevel];
                var dataBlocks = [];
                var totalCodewords = 0;
                ecInfo.ecBlocks.forEach(function(block) {
                    for(var i = 0; i < block.numBlocks; i++){
                        dataBlocks.push({
                            numDataCodewords: block.dataCodewordsPerBlock,
                            codewords: []
                        });
                        totalCodewords += block.dataCodewordsPerBlock + ecInfo.ecCodewordsPerBlock;
                    }
                });
                // In some cases the QR code will be malformed enough that we pull off more or less than we should.
                // If we pull off less there's nothing we can do.
                // If we pull off more we can safely truncate
                if (codewords.length < totalCodewords) return null;
                codewords = codewords.slice(0, totalCodewords);
                var shortBlockSize = ecInfo.ecBlocks[0].dataCodewordsPerBlock;
                // Pull codewords to fill the blocks up to the minimum size
                for(var i = 0; i < shortBlockSize; i++)for(var _i = 0, dataBlocks_1 = dataBlocks; _i < dataBlocks_1.length; _i++){
                    var dataBlock = dataBlocks_1[_i];
                    dataBlock.codewords.push(codewords.shift());
                }
                // If there are any large blocks, pull codewords to fill the last element of those
                if (ecInfo.ecBlocks.length > 1) {
                    var smallBlockCount = ecInfo.ecBlocks[0].numBlocks;
                    var largeBlockCount = ecInfo.ecBlocks[1].numBlocks;
                    for(var i = 0; i < largeBlockCount; i++)dataBlocks[smallBlockCount + i].codewords.push(codewords.shift());
                }
                // Add the rest of the codewords to the blocks. These are the error correction codewords.
                while(codewords.length > 0)for(var _a = 0, dataBlocks_2 = dataBlocks; _a < dataBlocks_2.length; _a++){
                    var dataBlock = dataBlocks_2[_a];
                    dataBlock.codewords.push(codewords.shift());
                }
                return dataBlocks;
            }
            function decodeMatrix(matrix) {
                var version = readVersion(matrix);
                if (!version) return null;
                var formatInfo = readFormatInformation(matrix);
                if (!formatInfo) return null;
                var codewords = readCodewords(matrix, version, formatInfo);
                var dataBlocks = getDataBlocks(codewords, version, formatInfo.errorCorrectionLevel);
                if (!dataBlocks) return null;
                // Count total number of data bytes
                var totalBytes = dataBlocks.reduce(function(a, b) {
                    return a + b.numDataCodewords;
                }, 0);
                var resultBytes = new Uint8ClampedArray(totalBytes);
                var resultIndex = 0;
                for(var _i = 0, dataBlocks_3 = dataBlocks; _i < dataBlocks_3.length; _i++){
                    var dataBlock = dataBlocks_3[_i];
                    var correctedBytes = reedsolomon_1.decode(dataBlock.codewords, dataBlock.codewords.length - dataBlock.numDataCodewords);
                    if (!correctedBytes) return null;
                    for(var i = 0; i < dataBlock.numDataCodewords; i++)resultBytes[resultIndex++] = correctedBytes[i];
                }
                try {
                    return decodeData_1.decode(resultBytes, version.versionNumber);
                } catch (_a) {
                    return null;
                }
            }
            function decode(matrix) {
                if (matrix == null) return null;
                var result = decodeMatrix(matrix);
                if (result) return result;
                // Decoding didn't work, try mirroring the QR across the topLeft -> bottomRight line.
                for(var x = 0; x < matrix.width; x++){
                    for(var y = x + 1; y < matrix.height; y++)if (matrix.get(x, y) !== matrix.get(y, x)) {
                        matrix.set(x, y, !matrix.get(x, y));
                        matrix.set(y, x, !matrix.get(y, x));
                    }
                }
                return decodeMatrix(matrix);
            }
            exports.decode = decode;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            // tslint:disable:no-bitwise
            var BitStream_1 = __webpack_require__(7);
            var shiftJISTable_1 = __webpack_require__(8);
            var Mode;
            (function(Mode) {
                Mode["Numeric"] = "numeric";
                Mode["Alphanumeric"] = "alphanumeric";
                Mode["Byte"] = "byte";
                Mode["Kanji"] = "kanji";
                Mode["ECI"] = "eci";
            })(Mode = exports.Mode || (exports.Mode = {}));
            var ModeByte;
            (function(ModeByte) {
                ModeByte[ModeByte["Terminator"] = 0] = "Terminator";
                ModeByte[ModeByte["Numeric"] = 1] = "Numeric";
                ModeByte[ModeByte["Alphanumeric"] = 2] = "Alphanumeric";
                ModeByte[ModeByte["Byte"] = 4] = "Byte";
                ModeByte[ModeByte["Kanji"] = 8] = "Kanji";
                ModeByte[ModeByte["ECI"] = 7] = "ECI";
            // StructuredAppend = 0x3,
            // FNC1FirstPosition = 0x5,
            // FNC1SecondPosition = 0x9,
            })(ModeByte || (ModeByte = {}));
            function decodeNumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    10,
                    12,
                    14
                ][size];
                var length = stream.readBits(characterCountSize);
                // Read digits in groups of 3
                while(length >= 3){
                    var num = stream.readBits(10);
                    if (num >= 1000) throw new Error("Invalid numeric value above 999");
                    var a = Math.floor(num / 100);
                    var b = Math.floor(num / 10) % 10;
                    var c = num % 10;
                    bytes.push(48 + a, 48 + b, 48 + c);
                    text += a.toString() + b.toString() + c.toString();
                    length -= 3;
                }
                // If the number of digits aren't a multiple of 3, the remaining digits are special cased.
                if (length === 2) {
                    var num = stream.readBits(7);
                    if (num >= 100) throw new Error("Invalid numeric value above 99");
                    var a = Math.floor(num / 10);
                    var b = num % 10;
                    bytes.push(48 + a, 48 + b);
                    text += a.toString() + b.toString();
                } else if (length === 1) {
                    var num = stream.readBits(4);
                    if (num >= 10) throw new Error("Invalid numeric value above 9");
                    bytes.push(48 + num);
                    text += num.toString();
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            var AlphanumericCharacterCodes = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
                " ",
                "$",
                "%",
                "*",
                "+",
                "-",
                ".",
                "/",
                ":"
            ];
            function decodeAlphanumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    9,
                    11,
                    13
                ][size];
                var length = stream.readBits(characterCountSize);
                while(length >= 2){
                    var v = stream.readBits(11);
                    var a = Math.floor(v / 45);
                    var b = v % 45;
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0), AlphanumericCharacterCodes[b].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a] + AlphanumericCharacterCodes[b];
                    length -= 2;
                }
                if (length === 1) {
                    var a = stream.readBits(6);
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a];
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeByte(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    16,
                    16
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var b = stream.readBits(8);
                    bytes.push(b);
                }
                try {
                    text += decodeURIComponent(bytes.map(function(b) {
                        return "%" + ("0" + b.toString(16)).substr(-2);
                    }).join(""));
                } catch (_a) {
                // failed to decode
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeKanji(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    10,
                    12
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var k = stream.readBits(13);
                    var c = Math.floor(k / 0xC0) << 8 | k % 0xC0;
                    if (c < 0x1F00) c += 0x8140;
                    else c += 0xC140;
                    bytes.push(c >> 8, c & 0xFF);
                    text += String.fromCharCode(shiftJISTable_1.shiftJISTable[c]);
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decode(data, version) {
                var _a, _b, _c, _d;
                var stream = new BitStream_1.BitStream(data);
                // There are 3 'sizes' based on the version. 1-9 is small (0), 10-26 is medium (1) and 27-40 is large (2).
                var size = version <= 9 ? 0 : version <= 26 ? 1 : 2;
                var result = {
                    text: "",
                    bytes: [],
                    chunks: [],
                    version: version
                };
                while(stream.available() >= 4){
                    var mode = stream.readBits(4);
                    if (mode === ModeByte.Terminator) return result;
                    else if (mode === ModeByte.ECI) {
                        if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(7)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(14)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(21)
                        });
                        else // ECI data seems corrupted
                        result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: -1
                        });
                    } else if (mode === ModeByte.Numeric) {
                        var numericResult = decodeNumeric(stream, size);
                        result.text += numericResult.text;
                        (_a = result.bytes).push.apply(_a, numericResult.bytes);
                        result.chunks.push({
                            type: Mode.Numeric,
                            text: numericResult.text
                        });
                    } else if (mode === ModeByte.Alphanumeric) {
                        var alphanumericResult = decodeAlphanumeric(stream, size);
                        result.text += alphanumericResult.text;
                        (_b = result.bytes).push.apply(_b, alphanumericResult.bytes);
                        result.chunks.push({
                            type: Mode.Alphanumeric,
                            text: alphanumericResult.text
                        });
                    } else if (mode === ModeByte.Byte) {
                        var byteResult = decodeByte(stream, size);
                        result.text += byteResult.text;
                        (_c = result.bytes).push.apply(_c, byteResult.bytes);
                        result.chunks.push({
                            type: Mode.Byte,
                            bytes: byteResult.bytes,
                            text: byteResult.text
                        });
                    } else if (mode === ModeByte.Kanji) {
                        var kanjiResult = decodeKanji(stream, size);
                        result.text += kanjiResult.text;
                        (_d = result.bytes).push.apply(_d, kanjiResult.bytes);
                        result.chunks.push({
                            type: Mode.Kanji,
                            bytes: kanjiResult.bytes,
                            text: kanjiResult.text
                        });
                    }
                }
                // If there is no data left, or the remaining bits are all 0, then that counts as a termination marker
                if (stream.available() === 0 || stream.readBits(stream.available()) === 0) return result;
            }
            exports.decode = decode;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // tslint:disable:no-bitwise
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitStream = /** @class */ function() {
                function BitStream(bytes) {
                    this.byteOffset = 0;
                    this.bitOffset = 0;
                    this.bytes = bytes;
                }
                BitStream.prototype.readBits = function(numBits) {
                    if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new Error("Cannot read " + numBits.toString() + " bits");
                    var result = 0;
                    // First, read remainder from current byte
                    if (this.bitOffset > 0) {
                        var bitsLeft = 8 - this.bitOffset;
                        var toRead = numBits < bitsLeft ? numBits : bitsLeft;
                        var bitsToNotRead = bitsLeft - toRead;
                        var mask = 0xFF >> 8 - toRead << bitsToNotRead;
                        result = (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                        numBits -= toRead;
                        this.bitOffset += toRead;
                        if (this.bitOffset === 8) {
                            this.bitOffset = 0;
                            this.byteOffset++;
                        }
                    }
                    // Next read whole bytes
                    if (numBits > 0) {
                        while(numBits >= 8){
                            result = result << 8 | this.bytes[this.byteOffset] & 0xFF;
                            this.byteOffset++;
                            numBits -= 8;
                        }
                        // Finally read a partial byte
                        if (numBits > 0) {
                            var bitsToNotRead = 8 - numBits;
                            var mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                            result = result << numBits | (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                            this.bitOffset += numBits;
                        }
                    }
                    return result;
                };
                BitStream.prototype.available = function() {
                    return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
                };
                return BitStream;
            }();
            exports.BitStream = BitStream;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.shiftJISTable = {
                0x20: 0x0020,
                0x21: 0x0021,
                0x22: 0x0022,
                0x23: 0x0023,
                0x24: 0x0024,
                0x25: 0x0025,
                0x26: 0x0026,
                0x27: 0x0027,
                0x28: 0x0028,
                0x29: 0x0029,
                0x2A: 0x002A,
                0x2B: 0x002B,
                0x2C: 0x002C,
                0x2D: 0x002D,
                0x2E: 0x002E,
                0x2F: 0x002F,
                0x30: 0x0030,
                0x31: 0x0031,
                0x32: 0x0032,
                0x33: 0x0033,
                0x34: 0x0034,
                0x35: 0x0035,
                0x36: 0x0036,
                0x37: 0x0037,
                0x38: 0x0038,
                0x39: 0x0039,
                0x3A: 0x003A,
                0x3B: 0x003B,
                0x3C: 0x003C,
                0x3D: 0x003D,
                0x3E: 0x003E,
                0x3F: 0x003F,
                0x40: 0x0040,
                0x41: 0x0041,
                0x42: 0x0042,
                0x43: 0x0043,
                0x44: 0x0044,
                0x45: 0x0045,
                0x46: 0x0046,
                0x47: 0x0047,
                0x48: 0x0048,
                0x49: 0x0049,
                0x4A: 0x004A,
                0x4B: 0x004B,
                0x4C: 0x004C,
                0x4D: 0x004D,
                0x4E: 0x004E,
                0x4F: 0x004F,
                0x50: 0x0050,
                0x51: 0x0051,
                0x52: 0x0052,
                0x53: 0x0053,
                0x54: 0x0054,
                0x55: 0x0055,
                0x56: 0x0056,
                0x57: 0x0057,
                0x58: 0x0058,
                0x59: 0x0059,
                0x5A: 0x005A,
                0x5B: 0x005B,
                0x5C: 0x00A5,
                0x5D: 0x005D,
                0x5E: 0x005E,
                0x5F: 0x005F,
                0x60: 0x0060,
                0x61: 0x0061,
                0x62: 0x0062,
                0x63: 0x0063,
                0x64: 0x0064,
                0x65: 0x0065,
                0x66: 0x0066,
                0x67: 0x0067,
                0x68: 0x0068,
                0x69: 0x0069,
                0x6A: 0x006A,
                0x6B: 0x006B,
                0x6C: 0x006C,
                0x6D: 0x006D,
                0x6E: 0x006E,
                0x6F: 0x006F,
                0x70: 0x0070,
                0x71: 0x0071,
                0x72: 0x0072,
                0x73: 0x0073,
                0x74: 0x0074,
                0x75: 0x0075,
                0x76: 0x0076,
                0x77: 0x0077,
                0x78: 0x0078,
                0x79: 0x0079,
                0x7A: 0x007A,
                0x7B: 0x007B,
                0x7C: 0x007C,
                0x7D: 0x007D,
                0x7E: 0x203E,
                0x8140: 0x3000,
                0x8141: 0x3001,
                0x8142: 0x3002,
                0x8143: 0xFF0C,
                0x8144: 0xFF0E,
                0x8145: 0x30FB,
                0x8146: 0xFF1A,
                0x8147: 0xFF1B,
                0x8148: 0xFF1F,
                0x8149: 0xFF01,
                0x814A: 0x309B,
                0x814B: 0x309C,
                0x814C: 0x00B4,
                0x814D: 0xFF40,
                0x814E: 0x00A8,
                0x814F: 0xFF3E,
                0x8150: 0xFFE3,
                0x8151: 0xFF3F,
                0x8152: 0x30FD,
                0x8153: 0x30FE,
                0x8154: 0x309D,
                0x8155: 0x309E,
                0x8156: 0x3003,
                0x8157: 0x4EDD,
                0x8158: 0x3005,
                0x8159: 0x3006,
                0x815A: 0x3007,
                0x815B: 0x30FC,
                0x815C: 0x2015,
                0x815D: 0x2010,
                0x815E: 0xFF0F,
                0x815F: 0x005C,
                0x8160: 0x301C,
                0x8161: 0x2016,
                0x8162: 0xFF5C,
                0x8163: 0x2026,
                0x8164: 0x2025,
                0x8165: 0x2018,
                0x8166: 0x2019,
                0x8167: 0x201C,
                0x8168: 0x201D,
                0x8169: 0xFF08,
                0x816A: 0xFF09,
                0x816B: 0x3014,
                0x816C: 0x3015,
                0x816D: 0xFF3B,
                0x816E: 0xFF3D,
                0x816F: 0xFF5B,
                0x8170: 0xFF5D,
                0x8171: 0x3008,
                0x8172: 0x3009,
                0x8173: 0x300A,
                0x8174: 0x300B,
                0x8175: 0x300C,
                0x8176: 0x300D,
                0x8177: 0x300E,
                0x8178: 0x300F,
                0x8179: 0x3010,
                0x817A: 0x3011,
                0x817B: 0xFF0B,
                0x817C: 0x2212,
                0x817D: 0x00B1,
                0x817E: 0x00D7,
                0x8180: 0x00F7,
                0x8181: 0xFF1D,
                0x8182: 0x2260,
                0x8183: 0xFF1C,
                0x8184: 0xFF1E,
                0x8185: 0x2266,
                0x8186: 0x2267,
                0x8187: 0x221E,
                0x8188: 0x2234,
                0x8189: 0x2642,
                0x818A: 0x2640,
                0x818B: 0x00B0,
                0x818C: 0x2032,
                0x818D: 0x2033,
                0x818E: 0x2103,
                0x818F: 0xFFE5,
                0x8190: 0xFF04,
                0x8191: 0x00A2,
                0x8192: 0x00A3,
                0x8193: 0xFF05,
                0x8194: 0xFF03,
                0x8195: 0xFF06,
                0x8196: 0xFF0A,
                0x8197: 0xFF20,
                0x8198: 0x00A7,
                0x8199: 0x2606,
                0x819A: 0x2605,
                0x819B: 0x25CB,
                0x819C: 0x25CF,
                0x819D: 0x25CE,
                0x819E: 0x25C7,
                0x819F: 0x25C6,
                0x81A0: 0x25A1,
                0x81A1: 0x25A0,
                0x81A2: 0x25B3,
                0x81A3: 0x25B2,
                0x81A4: 0x25BD,
                0x81A5: 0x25BC,
                0x81A6: 0x203B,
                0x81A7: 0x3012,
                0x81A8: 0x2192,
                0x81A9: 0x2190,
                0x81AA: 0x2191,
                0x81AB: 0x2193,
                0x81AC: 0x3013,
                0x81B8: 0x2208,
                0x81B9: 0x220B,
                0x81BA: 0x2286,
                0x81BB: 0x2287,
                0x81BC: 0x2282,
                0x81BD: 0x2283,
                0x81BE: 0x222A,
                0x81BF: 0x2229,
                0x81C8: 0x2227,
                0x81C9: 0x2228,
                0x81CA: 0x00AC,
                0x81CB: 0x21D2,
                0x81CC: 0x21D4,
                0x81CD: 0x2200,
                0x81CE: 0x2203,
                0x81DA: 0x2220,
                0x81DB: 0x22A5,
                0x81DC: 0x2312,
                0x81DD: 0x2202,
                0x81DE: 0x2207,
                0x81DF: 0x2261,
                0x81E0: 0x2252,
                0x81E1: 0x226A,
                0x81E2: 0x226B,
                0x81E3: 0x221A,
                0x81E4: 0x223D,
                0x81E5: 0x221D,
                0x81E6: 0x2235,
                0x81E7: 0x222B,
                0x81E8: 0x222C,
                0x81F0: 0x212B,
                0x81F1: 0x2030,
                0x81F2: 0x266F,
                0x81F3: 0x266D,
                0x81F4: 0x266A,
                0x81F5: 0x2020,
                0x81F6: 0x2021,
                0x81F7: 0x00B6,
                0x81FC: 0x25EF,
                0x824F: 0xFF10,
                0x8250: 0xFF11,
                0x8251: 0xFF12,
                0x8252: 0xFF13,
                0x8253: 0xFF14,
                0x8254: 0xFF15,
                0x8255: 0xFF16,
                0x8256: 0xFF17,
                0x8257: 0xFF18,
                0x8258: 0xFF19,
                0x8260: 0xFF21,
                0x8261: 0xFF22,
                0x8262: 0xFF23,
                0x8263: 0xFF24,
                0x8264: 0xFF25,
                0x8265: 0xFF26,
                0x8266: 0xFF27,
                0x8267: 0xFF28,
                0x8268: 0xFF29,
                0x8269: 0xFF2A,
                0x826A: 0xFF2B,
                0x826B: 0xFF2C,
                0x826C: 0xFF2D,
                0x826D: 0xFF2E,
                0x826E: 0xFF2F,
                0x826F: 0xFF30,
                0x8270: 0xFF31,
                0x8271: 0xFF32,
                0x8272: 0xFF33,
                0x8273: 0xFF34,
                0x8274: 0xFF35,
                0x8275: 0xFF36,
                0x8276: 0xFF37,
                0x8277: 0xFF38,
                0x8278: 0xFF39,
                0x8279: 0xFF3A,
                0x8281: 0xFF41,
                0x8282: 0xFF42,
                0x8283: 0xFF43,
                0x8284: 0xFF44,
                0x8285: 0xFF45,
                0x8286: 0xFF46,
                0x8287: 0xFF47,
                0x8288: 0xFF48,
                0x8289: 0xFF49,
                0x828A: 0xFF4A,
                0x828B: 0xFF4B,
                0x828C: 0xFF4C,
                0x828D: 0xFF4D,
                0x828E: 0xFF4E,
                0x828F: 0xFF4F,
                0x8290: 0xFF50,
                0x8291: 0xFF51,
                0x8292: 0xFF52,
                0x8293: 0xFF53,
                0x8294: 0xFF54,
                0x8295: 0xFF55,
                0x8296: 0xFF56,
                0x8297: 0xFF57,
                0x8298: 0xFF58,
                0x8299: 0xFF59,
                0x829A: 0xFF5A,
                0x829F: 0x3041,
                0x82A0: 0x3042,
                0x82A1: 0x3043,
                0x82A2: 0x3044,
                0x82A3: 0x3045,
                0x82A4: 0x3046,
                0x82A5: 0x3047,
                0x82A6: 0x3048,
                0x82A7: 0x3049,
                0x82A8: 0x304A,
                0x82A9: 0x304B,
                0x82AA: 0x304C,
                0x82AB: 0x304D,
                0x82AC: 0x304E,
                0x82AD: 0x304F,
                0x82AE: 0x3050,
                0x82AF: 0x3051,
                0x82B0: 0x3052,
                0x82B1: 0x3053,
                0x82B2: 0x3054,
                0x82B3: 0x3055,
                0x82B4: 0x3056,
                0x82B5: 0x3057,
                0x82B6: 0x3058,
                0x82B7: 0x3059,
                0x82B8: 0x305A,
                0x82B9: 0x305B,
                0x82BA: 0x305C,
                0x82BB: 0x305D,
                0x82BC: 0x305E,
                0x82BD: 0x305F,
                0x82BE: 0x3060,
                0x82BF: 0x3061,
                0x82C0: 0x3062,
                0x82C1: 0x3063,
                0x82C2: 0x3064,
                0x82C3: 0x3065,
                0x82C4: 0x3066,
                0x82C5: 0x3067,
                0x82C6: 0x3068,
                0x82C7: 0x3069,
                0x82C8: 0x306A,
                0x82C9: 0x306B,
                0x82CA: 0x306C,
                0x82CB: 0x306D,
                0x82CC: 0x306E,
                0x82CD: 0x306F,
                0x82CE: 0x3070,
                0x82CF: 0x3071,
                0x82D0: 0x3072,
                0x82D1: 0x3073,
                0x82D2: 0x3074,
                0x82D3: 0x3075,
                0x82D4: 0x3076,
                0x82D5: 0x3077,
                0x82D6: 0x3078,
                0x82D7: 0x3079,
                0x82D8: 0x307A,
                0x82D9: 0x307B,
                0x82DA: 0x307C,
                0x82DB: 0x307D,
                0x82DC: 0x307E,
                0x82DD: 0x307F,
                0x82DE: 0x3080,
                0x82DF: 0x3081,
                0x82E0: 0x3082,
                0x82E1: 0x3083,
                0x82E2: 0x3084,
                0x82E3: 0x3085,
                0x82E4: 0x3086,
                0x82E5: 0x3087,
                0x82E6: 0x3088,
                0x82E7: 0x3089,
                0x82E8: 0x308A,
                0x82E9: 0x308B,
                0x82EA: 0x308C,
                0x82EB: 0x308D,
                0x82EC: 0x308E,
                0x82ED: 0x308F,
                0x82EE: 0x3090,
                0x82EF: 0x3091,
                0x82F0: 0x3092,
                0x82F1: 0x3093,
                0x8340: 0x30A1,
                0x8341: 0x30A2,
                0x8342: 0x30A3,
                0x8343: 0x30A4,
                0x8344: 0x30A5,
                0x8345: 0x30A6,
                0x8346: 0x30A7,
                0x8347: 0x30A8,
                0x8348: 0x30A9,
                0x8349: 0x30AA,
                0x834A: 0x30AB,
                0x834B: 0x30AC,
                0x834C: 0x30AD,
                0x834D: 0x30AE,
                0x834E: 0x30AF,
                0x834F: 0x30B0,
                0x8350: 0x30B1,
                0x8351: 0x30B2,
                0x8352: 0x30B3,
                0x8353: 0x30B4,
                0x8354: 0x30B5,
                0x8355: 0x30B6,
                0x8356: 0x30B7,
                0x8357: 0x30B8,
                0x8358: 0x30B9,
                0x8359: 0x30BA,
                0x835A: 0x30BB,
                0x835B: 0x30BC,
                0x835C: 0x30BD,
                0x835D: 0x30BE,
                0x835E: 0x30BF,
                0x835F: 0x30C0,
                0x8360: 0x30C1,
                0x8361: 0x30C2,
                0x8362: 0x30C3,
                0x8363: 0x30C4,
                0x8364: 0x30C5,
                0x8365: 0x30C6,
                0x8366: 0x30C7,
                0x8367: 0x30C8,
                0x8368: 0x30C9,
                0x8369: 0x30CA,
                0x836A: 0x30CB,
                0x836B: 0x30CC,
                0x836C: 0x30CD,
                0x836D: 0x30CE,
                0x836E: 0x30CF,
                0x836F: 0x30D0,
                0x8370: 0x30D1,
                0x8371: 0x30D2,
                0x8372: 0x30D3,
                0x8373: 0x30D4,
                0x8374: 0x30D5,
                0x8375: 0x30D6,
                0x8376: 0x30D7,
                0x8377: 0x30D8,
                0x8378: 0x30D9,
                0x8379: 0x30DA,
                0x837A: 0x30DB,
                0x837B: 0x30DC,
                0x837C: 0x30DD,
                0x837D: 0x30DE,
                0x837E: 0x30DF,
                0x8380: 0x30E0,
                0x8381: 0x30E1,
                0x8382: 0x30E2,
                0x8383: 0x30E3,
                0x8384: 0x30E4,
                0x8385: 0x30E5,
                0x8386: 0x30E6,
                0x8387: 0x30E7,
                0x8388: 0x30E8,
                0x8389: 0x30E9,
                0x838A: 0x30EA,
                0x838B: 0x30EB,
                0x838C: 0x30EC,
                0x838D: 0x30ED,
                0x838E: 0x30EE,
                0x838F: 0x30EF,
                0x8390: 0x30F0,
                0x8391: 0x30F1,
                0x8392: 0x30F2,
                0x8393: 0x30F3,
                0x8394: 0x30F4,
                0x8395: 0x30F5,
                0x8396: 0x30F6,
                0x839F: 0x0391,
                0x83A0: 0x0392,
                0x83A1: 0x0393,
                0x83A2: 0x0394,
                0x83A3: 0x0395,
                0x83A4: 0x0396,
                0x83A5: 0x0397,
                0x83A6: 0x0398,
                0x83A7: 0x0399,
                0x83A8: 0x039A,
                0x83A9: 0x039B,
                0x83AA: 0x039C,
                0x83AB: 0x039D,
                0x83AC: 0x039E,
                0x83AD: 0x039F,
                0x83AE: 0x03A0,
                0x83AF: 0x03A1,
                0x83B0: 0x03A3,
                0x83B1: 0x03A4,
                0x83B2: 0x03A5,
                0x83B3: 0x03A6,
                0x83B4: 0x03A7,
                0x83B5: 0x03A8,
                0x83B6: 0x03A9,
                0x83BF: 0x03B1,
                0x83C0: 0x03B2,
                0x83C1: 0x03B3,
                0x83C2: 0x03B4,
                0x83C3: 0x03B5,
                0x83C4: 0x03B6,
                0x83C5: 0x03B7,
                0x83C6: 0x03B8,
                0x83C7: 0x03B9,
                0x83C8: 0x03BA,
                0x83C9: 0x03BB,
                0x83CA: 0x03BC,
                0x83CB: 0x03BD,
                0x83CC: 0x03BE,
                0x83CD: 0x03BF,
                0x83CE: 0x03C0,
                0x83CF: 0x03C1,
                0x83D0: 0x03C3,
                0x83D1: 0x03C4,
                0x83D2: 0x03C5,
                0x83D3: 0x03C6,
                0x83D4: 0x03C7,
                0x83D5: 0x03C8,
                0x83D6: 0x03C9,
                0x8440: 0x0410,
                0x8441: 0x0411,
                0x8442: 0x0412,
                0x8443: 0x0413,
                0x8444: 0x0414,
                0x8445: 0x0415,
                0x8446: 0x0401,
                0x8447: 0x0416,
                0x8448: 0x0417,
                0x8449: 0x0418,
                0x844A: 0x0419,
                0x844B: 0x041A,
                0x844C: 0x041B,
                0x844D: 0x041C,
                0x844E: 0x041D,
                0x844F: 0x041E,
                0x8450: 0x041F,
                0x8451: 0x0420,
                0x8452: 0x0421,
                0x8453: 0x0422,
                0x8454: 0x0423,
                0x8455: 0x0424,
                0x8456: 0x0425,
                0x8457: 0x0426,
                0x8458: 0x0427,
                0x8459: 0x0428,
                0x845A: 0x0429,
                0x845B: 0x042A,
                0x845C: 0x042B,
                0x845D: 0x042C,
                0x845E: 0x042D,
                0x845F: 0x042E,
                0x8460: 0x042F,
                0x8470: 0x0430,
                0x8471: 0x0431,
                0x8472: 0x0432,
                0x8473: 0x0433,
                0x8474: 0x0434,
                0x8475: 0x0435,
                0x8476: 0x0451,
                0x8477: 0x0436,
                0x8478: 0x0437,
                0x8479: 0x0438,
                0x847A: 0x0439,
                0x847B: 0x043A,
                0x847C: 0x043B,
                0x847D: 0x043C,
                0x847E: 0x043D,
                0x8480: 0x043E,
                0x8481: 0x043F,
                0x8482: 0x0440,
                0x8483: 0x0441,
                0x8484: 0x0442,
                0x8485: 0x0443,
                0x8486: 0x0444,
                0x8487: 0x0445,
                0x8488: 0x0446,
                0x8489: 0x0447,
                0x848A: 0x0448,
                0x848B: 0x0449,
                0x848C: 0x044A,
                0x848D: 0x044B,
                0x848E: 0x044C,
                0x848F: 0x044D,
                0x8490: 0x044E,
                0x8491: 0x044F,
                0x849F: 0x2500,
                0x84A0: 0x2502,
                0x84A1: 0x250C,
                0x84A2: 0x2510,
                0x84A3: 0x2518,
                0x84A4: 0x2514,
                0x84A5: 0x251C,
                0x84A6: 0x252C,
                0x84A7: 0x2524,
                0x84A8: 0x2534,
                0x84A9: 0x253C,
                0x84AA: 0x2501,
                0x84AB: 0x2503,
                0x84AC: 0x250F,
                0x84AD: 0x2513,
                0x84AE: 0x251B,
                0x84AF: 0x2517,
                0x84B0: 0x2523,
                0x84B1: 0x2533,
                0x84B2: 0x252B,
                0x84B3: 0x253B,
                0x84B4: 0x254B,
                0x84B5: 0x2520,
                0x84B6: 0x252F,
                0x84B7: 0x2528,
                0x84B8: 0x2537,
                0x84B9: 0x253F,
                0x84BA: 0x251D,
                0x84BB: 0x2530,
                0x84BC: 0x2525,
                0x84BD: 0x2538,
                0x84BE: 0x2542,
                0x889F: 0x4E9C,
                0x88A0: 0x5516,
                0x88A1: 0x5A03,
                0x88A2: 0x963F,
                0x88A3: 0x54C0,
                0x88A4: 0x611B,
                0x88A5: 0x6328,
                0x88A6: 0x59F6,
                0x88A7: 0x9022,
                0x88A8: 0x8475,
                0x88A9: 0x831C,
                0x88AA: 0x7A50,
                0x88AB: 0x60AA,
                0x88AC: 0x63E1,
                0x88AD: 0x6E25,
                0x88AE: 0x65ED,
                0x88AF: 0x8466,
                0x88B0: 0x82A6,
                0x88B1: 0x9BF5,
                0x88B2: 0x6893,
                0x88B3: 0x5727,
                0x88B4: 0x65A1,
                0x88B5: 0x6271,
                0x88B6: 0x5B9B,
                0x88B7: 0x59D0,
                0x88B8: 0x867B,
                0x88B9: 0x98F4,
                0x88BA: 0x7D62,
                0x88BB: 0x7DBE,
                0x88BC: 0x9B8E,
                0x88BD: 0x6216,
                0x88BE: 0x7C9F,
                0x88BF: 0x88B7,
                0x88C0: 0x5B89,
                0x88C1: 0x5EB5,
                0x88C2: 0x6309,
                0x88C3: 0x6697,
                0x88C4: 0x6848,
                0x88C5: 0x95C7,
                0x88C6: 0x978D,
                0x88C7: 0x674F,
                0x88C8: 0x4EE5,
                0x88C9: 0x4F0A,
                0x88CA: 0x4F4D,
                0x88CB: 0x4F9D,
                0x88CC: 0x5049,
                0x88CD: 0x56F2,
                0x88CE: 0x5937,
                0x88CF: 0x59D4,
                0x88D0: 0x5A01,
                0x88D1: 0x5C09,
                0x88D2: 0x60DF,
                0x88D3: 0x610F,
                0x88D4: 0x6170,
                0x88D5: 0x6613,
                0x88D6: 0x6905,
                0x88D7: 0x70BA,
                0x88D8: 0x754F,
                0x88D9: 0x7570,
                0x88DA: 0x79FB,
                0x88DB: 0x7DAD,
                0x88DC: 0x7DEF,
                0x88DD: 0x80C3,
                0x88DE: 0x840E,
                0x88DF: 0x8863,
                0x88E0: 0x8B02,
                0x88E1: 0x9055,
                0x88E2: 0x907A,
                0x88E3: 0x533B,
                0x88E4: 0x4E95,
                0x88E5: 0x4EA5,
                0x88E6: 0x57DF,
                0x88E7: 0x80B2,
                0x88E8: 0x90C1,
                0x88E9: 0x78EF,
                0x88EA: 0x4E00,
                0x88EB: 0x58F1,
                0x88EC: 0x6EA2,
                0x88ED: 0x9038,
                0x88EE: 0x7A32,
                0x88EF: 0x8328,
                0x88F0: 0x828B,
                0x88F1: 0x9C2F,
                0x88F2: 0x5141,
                0x88F3: 0x5370,
                0x88F4: 0x54BD,
                0x88F5: 0x54E1,
                0x88F6: 0x56E0,
                0x88F7: 0x59FB,
                0x88F8: 0x5F15,
                0x88F9: 0x98F2,
                0x88FA: 0x6DEB,
                0x88FB: 0x80E4,
                0x88FC: 0x852D,
                0x8940: 0x9662,
                0x8941: 0x9670,
                0x8942: 0x96A0,
                0x8943: 0x97FB,
                0x8944: 0x540B,
                0x8945: 0x53F3,
                0x8946: 0x5B87,
                0x8947: 0x70CF,
                0x8948: 0x7FBD,
                0x8949: 0x8FC2,
                0x894A: 0x96E8,
                0x894B: 0x536F,
                0x894C: 0x9D5C,
                0x894D: 0x7ABA,
                0x894E: 0x4E11,
                0x894F: 0x7893,
                0x8950: 0x81FC,
                0x8951: 0x6E26,
                0x8952: 0x5618,
                0x8953: 0x5504,
                0x8954: 0x6B1D,
                0x8955: 0x851A,
                0x8956: 0x9C3B,
                0x8957: 0x59E5,
                0x8958: 0x53A9,
                0x8959: 0x6D66,
                0x895A: 0x74DC,
                0x895B: 0x958F,
                0x895C: 0x5642,
                0x895D: 0x4E91,
                0x895E: 0x904B,
                0x895F: 0x96F2,
                0x8960: 0x834F,
                0x8961: 0x990C,
                0x8962: 0x53E1,
                0x8963: 0x55B6,
                0x8964: 0x5B30,
                0x8965: 0x5F71,
                0x8966: 0x6620,
                0x8967: 0x66F3,
                0x8968: 0x6804,
                0x8969: 0x6C38,
                0x896A: 0x6CF3,
                0x896B: 0x6D29,
                0x896C: 0x745B,
                0x896D: 0x76C8,
                0x896E: 0x7A4E,
                0x896F: 0x9834,
                0x8970: 0x82F1,
                0x8971: 0x885B,
                0x8972: 0x8A60,
                0x8973: 0x92ED,
                0x8974: 0x6DB2,
                0x8975: 0x75AB,
                0x8976: 0x76CA,
                0x8977: 0x99C5,
                0x8978: 0x60A6,
                0x8979: 0x8B01,
                0x897A: 0x8D8A,
                0x897B: 0x95B2,
                0x897C: 0x698E,
                0x897D: 0x53AD,
                0x897E: 0x5186,
                0x8980: 0x5712,
                0x8981: 0x5830,
                0x8982: 0x5944,
                0x8983: 0x5BB4,
                0x8984: 0x5EF6,
                0x8985: 0x6028,
                0x8986: 0x63A9,
                0x8987: 0x63F4,
                0x8988: 0x6CBF,
                0x8989: 0x6F14,
                0x898A: 0x708E,
                0x898B: 0x7114,
                0x898C: 0x7159,
                0x898D: 0x71D5,
                0x898E: 0x733F,
                0x898F: 0x7E01,
                0x8990: 0x8276,
                0x8991: 0x82D1,
                0x8992: 0x8597,
                0x8993: 0x9060,
                0x8994: 0x925B,
                0x8995: 0x9D1B,
                0x8996: 0x5869,
                0x8997: 0x65BC,
                0x8998: 0x6C5A,
                0x8999: 0x7525,
                0x899A: 0x51F9,
                0x899B: 0x592E,
                0x899C: 0x5965,
                0x899D: 0x5F80,
                0x899E: 0x5FDC,
                0x899F: 0x62BC,
                0x89A0: 0x65FA,
                0x89A1: 0x6A2A,
                0x89A2: 0x6B27,
                0x89A3: 0x6BB4,
                0x89A4: 0x738B,
                0x89A5: 0x7FC1,
                0x89A6: 0x8956,
                0x89A7: 0x9D2C,
                0x89A8: 0x9D0E,
                0x89A9: 0x9EC4,
                0x89AA: 0x5CA1,
                0x89AB: 0x6C96,
                0x89AC: 0x837B,
                0x89AD: 0x5104,
                0x89AE: 0x5C4B,
                0x89AF: 0x61B6,
                0x89B0: 0x81C6,
                0x89B1: 0x6876,
                0x89B2: 0x7261,
                0x89B3: 0x4E59,
                0x89B4: 0x4FFA,
                0x89B5: 0x5378,
                0x89B6: 0x6069,
                0x89B7: 0x6E29,
                0x89B8: 0x7A4F,
                0x89B9: 0x97F3,
                0x89BA: 0x4E0B,
                0x89BB: 0x5316,
                0x89BC: 0x4EEE,
                0x89BD: 0x4F55,
                0x89BE: 0x4F3D,
                0x89BF: 0x4FA1,
                0x89C0: 0x4F73,
                0x89C1: 0x52A0,
                0x89C2: 0x53EF,
                0x89C3: 0x5609,
                0x89C4: 0x590F,
                0x89C5: 0x5AC1,
                0x89C6: 0x5BB6,
                0x89C7: 0x5BE1,
                0x89C8: 0x79D1,
                0x89C9: 0x6687,
                0x89CA: 0x679C,
                0x89CB: 0x67B6,
                0x89CC: 0x6B4C,
                0x89CD: 0x6CB3,
                0x89CE: 0x706B,
                0x89CF: 0x73C2,
                0x89D0: 0x798D,
                0x89D1: 0x79BE,
                0x89D2: 0x7A3C,
                0x89D3: 0x7B87,
                0x89D4: 0x82B1,
                0x89D5: 0x82DB,
                0x89D6: 0x8304,
                0x89D7: 0x8377,
                0x89D8: 0x83EF,
                0x89D9: 0x83D3,
                0x89DA: 0x8766,
                0x89DB: 0x8AB2,
                0x89DC: 0x5629,
                0x89DD: 0x8CA8,
                0x89DE: 0x8FE6,
                0x89DF: 0x904E,
                0x89E0: 0x971E,
                0x89E1: 0x868A,
                0x89E2: 0x4FC4,
                0x89E3: 0x5CE8,
                0x89E4: 0x6211,
                0x89E5: 0x7259,
                0x89E6: 0x753B,
                0x89E7: 0x81E5,
                0x89E8: 0x82BD,
                0x89E9: 0x86FE,
                0x89EA: 0x8CC0,
                0x89EB: 0x96C5,
                0x89EC: 0x9913,
                0x89ED: 0x99D5,
                0x89EE: 0x4ECB,
                0x89EF: 0x4F1A,
                0x89F0: 0x89E3,
                0x89F1: 0x56DE,
                0x89F2: 0x584A,
                0x89F3: 0x58CA,
                0x89F4: 0x5EFB,
                0x89F5: 0x5FEB,
                0x89F6: 0x602A,
                0x89F7: 0x6094,
                0x89F8: 0x6062,
                0x89F9: 0x61D0,
                0x89FA: 0x6212,
                0x89FB: 0x62D0,
                0x89FC: 0x6539,
                0x8A40: 0x9B41,
                0x8A41: 0x6666,
                0x8A42: 0x68B0,
                0x8A43: 0x6D77,
                0x8A44: 0x7070,
                0x8A45: 0x754C,
                0x8A46: 0x7686,
                0x8A47: 0x7D75,
                0x8A48: 0x82A5,
                0x8A49: 0x87F9,
                0x8A4A: 0x958B,
                0x8A4B: 0x968E,
                0x8A4C: 0x8C9D,
                0x8A4D: 0x51F1,
                0x8A4E: 0x52BE,
                0x8A4F: 0x5916,
                0x8A50: 0x54B3,
                0x8A51: 0x5BB3,
                0x8A52: 0x5D16,
                0x8A53: 0x6168,
                0x8A54: 0x6982,
                0x8A55: 0x6DAF,
                0x8A56: 0x788D,
                0x8A57: 0x84CB,
                0x8A58: 0x8857,
                0x8A59: 0x8A72,
                0x8A5A: 0x93A7,
                0x8A5B: 0x9AB8,
                0x8A5C: 0x6D6C,
                0x8A5D: 0x99A8,
                0x8A5E: 0x86D9,
                0x8A5F: 0x57A3,
                0x8A60: 0x67FF,
                0x8A61: 0x86CE,
                0x8A62: 0x920E,
                0x8A63: 0x5283,
                0x8A64: 0x5687,
                0x8A65: 0x5404,
                0x8A66: 0x5ED3,
                0x8A67: 0x62E1,
                0x8A68: 0x64B9,
                0x8A69: 0x683C,
                0x8A6A: 0x6838,
                0x8A6B: 0x6BBB,
                0x8A6C: 0x7372,
                0x8A6D: 0x78BA,
                0x8A6E: 0x7A6B,
                0x8A6F: 0x899A,
                0x8A70: 0x89D2,
                0x8A71: 0x8D6B,
                0x8A72: 0x8F03,
                0x8A73: 0x90ED,
                0x8A74: 0x95A3,
                0x8A75: 0x9694,
                0x8A76: 0x9769,
                0x8A77: 0x5B66,
                0x8A78: 0x5CB3,
                0x8A79: 0x697D,
                0x8A7A: 0x984D,
                0x8A7B: 0x984E,
                0x8A7C: 0x639B,
                0x8A7D: 0x7B20,
                0x8A7E: 0x6A2B,
                0x8A80: 0x6A7F,
                0x8A81: 0x68B6,
                0x8A82: 0x9C0D,
                0x8A83: 0x6F5F,
                0x8A84: 0x5272,
                0x8A85: 0x559D,
                0x8A86: 0x6070,
                0x8A87: 0x62EC,
                0x8A88: 0x6D3B,
                0x8A89: 0x6E07,
                0x8A8A: 0x6ED1,
                0x8A8B: 0x845B,
                0x8A8C: 0x8910,
                0x8A8D: 0x8F44,
                0x8A8E: 0x4E14,
                0x8A8F: 0x9C39,
                0x8A90: 0x53F6,
                0x8A91: 0x691B,
                0x8A92: 0x6A3A,
                0x8A93: 0x9784,
                0x8A94: 0x682A,
                0x8A95: 0x515C,
                0x8A96: 0x7AC3,
                0x8A97: 0x84B2,
                0x8A98: 0x91DC,
                0x8A99: 0x938C,
                0x8A9A: 0x565B,
                0x8A9B: 0x9D28,
                0x8A9C: 0x6822,
                0x8A9D: 0x8305,
                0x8A9E: 0x8431,
                0x8A9F: 0x7CA5,
                0x8AA0: 0x5208,
                0x8AA1: 0x82C5,
                0x8AA2: 0x74E6,
                0x8AA3: 0x4E7E,
                0x8AA4: 0x4F83,
                0x8AA5: 0x51A0,
                0x8AA6: 0x5BD2,
                0x8AA7: 0x520A,
                0x8AA8: 0x52D8,
                0x8AA9: 0x52E7,
                0x8AAA: 0x5DFB,
                0x8AAB: 0x559A,
                0x8AAC: 0x582A,
                0x8AAD: 0x59E6,
                0x8AAE: 0x5B8C,
                0x8AAF: 0x5B98,
                0x8AB0: 0x5BDB,
                0x8AB1: 0x5E72,
                0x8AB2: 0x5E79,
                0x8AB3: 0x60A3,
                0x8AB4: 0x611F,
                0x8AB5: 0x6163,
                0x8AB6: 0x61BE,
                0x8AB7: 0x63DB,
                0x8AB8: 0x6562,
                0x8AB9: 0x67D1,
                0x8ABA: 0x6853,
                0x8ABB: 0x68FA,
                0x8ABC: 0x6B3E,
                0x8ABD: 0x6B53,
                0x8ABE: 0x6C57,
                0x8ABF: 0x6F22,
                0x8AC0: 0x6F97,
                0x8AC1: 0x6F45,
                0x8AC2: 0x74B0,
                0x8AC3: 0x7518,
                0x8AC4: 0x76E3,
                0x8AC5: 0x770B,
                0x8AC6: 0x7AFF,
                0x8AC7: 0x7BA1,
                0x8AC8: 0x7C21,
                0x8AC9: 0x7DE9,
                0x8ACA: 0x7F36,
                0x8ACB: 0x7FF0,
                0x8ACC: 0x809D,
                0x8ACD: 0x8266,
                0x8ACE: 0x839E,
                0x8ACF: 0x89B3,
                0x8AD0: 0x8ACC,
                0x8AD1: 0x8CAB,
                0x8AD2: 0x9084,
                0x8AD3: 0x9451,
                0x8AD4: 0x9593,
                0x8AD5: 0x9591,
                0x8AD6: 0x95A2,
                0x8AD7: 0x9665,
                0x8AD8: 0x97D3,
                0x8AD9: 0x9928,
                0x8ADA: 0x8218,
                0x8ADB: 0x4E38,
                0x8ADC: 0x542B,
                0x8ADD: 0x5CB8,
                0x8ADE: 0x5DCC,
                0x8ADF: 0x73A9,
                0x8AE0: 0x764C,
                0x8AE1: 0x773C,
                0x8AE2: 0x5CA9,
                0x8AE3: 0x7FEB,
                0x8AE4: 0x8D0B,
                0x8AE5: 0x96C1,
                0x8AE6: 0x9811,
                0x8AE7: 0x9854,
                0x8AE8: 0x9858,
                0x8AE9: 0x4F01,
                0x8AEA: 0x4F0E,
                0x8AEB: 0x5371,
                0x8AEC: 0x559C,
                0x8AED: 0x5668,
                0x8AEE: 0x57FA,
                0x8AEF: 0x5947,
                0x8AF0: 0x5B09,
                0x8AF1: 0x5BC4,
                0x8AF2: 0x5C90,
                0x8AF3: 0x5E0C,
                0x8AF4: 0x5E7E,
                0x8AF5: 0x5FCC,
                0x8AF6: 0x63EE,
                0x8AF7: 0x673A,
                0x8AF8: 0x65D7,
                0x8AF9: 0x65E2,
                0x8AFA: 0x671F,
                0x8AFB: 0x68CB,
                0x8AFC: 0x68C4,
                0x8B40: 0x6A5F,
                0x8B41: 0x5E30,
                0x8B42: 0x6BC5,
                0x8B43: 0x6C17,
                0x8B44: 0x6C7D,
                0x8B45: 0x757F,
                0x8B46: 0x7948,
                0x8B47: 0x5B63,
                0x8B48: 0x7A00,
                0x8B49: 0x7D00,
                0x8B4A: 0x5FBD,
                0x8B4B: 0x898F,
                0x8B4C: 0x8A18,
                0x8B4D: 0x8CB4,
                0x8B4E: 0x8D77,
                0x8B4F: 0x8ECC,
                0x8B50: 0x8F1D,
                0x8B51: 0x98E2,
                0x8B52: 0x9A0E,
                0x8B53: 0x9B3C,
                0x8B54: 0x4E80,
                0x8B55: 0x507D,
                0x8B56: 0x5100,
                0x8B57: 0x5993,
                0x8B58: 0x5B9C,
                0x8B59: 0x622F,
                0x8B5A: 0x6280,
                0x8B5B: 0x64EC,
                0x8B5C: 0x6B3A,
                0x8B5D: 0x72A0,
                0x8B5E: 0x7591,
                0x8B5F: 0x7947,
                0x8B60: 0x7FA9,
                0x8B61: 0x87FB,
                0x8B62: 0x8ABC,
                0x8B63: 0x8B70,
                0x8B64: 0x63AC,
                0x8B65: 0x83CA,
                0x8B66: 0x97A0,
                0x8B67: 0x5409,
                0x8B68: 0x5403,
                0x8B69: 0x55AB,
                0x8B6A: 0x6854,
                0x8B6B: 0x6A58,
                0x8B6C: 0x8A70,
                0x8B6D: 0x7827,
                0x8B6E: 0x6775,
                0x8B6F: 0x9ECD,
                0x8B70: 0x5374,
                0x8B71: 0x5BA2,
                0x8B72: 0x811A,
                0x8B73: 0x8650,
                0x8B74: 0x9006,
                0x8B75: 0x4E18,
                0x8B76: 0x4E45,
                0x8B77: 0x4EC7,
                0x8B78: 0x4F11,
                0x8B79: 0x53CA,
                0x8B7A: 0x5438,
                0x8B7B: 0x5BAE,
                0x8B7C: 0x5F13,
                0x8B7D: 0x6025,
                0x8B7E: 0x6551,
                0x8B80: 0x673D,
                0x8B81: 0x6C42,
                0x8B82: 0x6C72,
                0x8B83: 0x6CE3,
                0x8B84: 0x7078,
                0x8B85: 0x7403,
                0x8B86: 0x7A76,
                0x8B87: 0x7AAE,
                0x8B88: 0x7B08,
                0x8B89: 0x7D1A,
                0x8B8A: 0x7CFE,
                0x8B8B: 0x7D66,
                0x8B8C: 0x65E7,
                0x8B8D: 0x725B,
                0x8B8E: 0x53BB,
                0x8B8F: 0x5C45,
                0x8B90: 0x5DE8,
                0x8B91: 0x62D2,
                0x8B92: 0x62E0,
                0x8B93: 0x6319,
                0x8B94: 0x6E20,
                0x8B95: 0x865A,
                0x8B96: 0x8A31,
                0x8B97: 0x8DDD,
                0x8B98: 0x92F8,
                0x8B99: 0x6F01,
                0x8B9A: 0x79A6,
                0x8B9B: 0x9B5A,
                0x8B9C: 0x4EA8,
                0x8B9D: 0x4EAB,
                0x8B9E: 0x4EAC,
                0x8B9F: 0x4F9B,
                0x8BA0: 0x4FA0,
                0x8BA1: 0x50D1,
                0x8BA2: 0x5147,
                0x8BA3: 0x7AF6,
                0x8BA4: 0x5171,
                0x8BA5: 0x51F6,
                0x8BA6: 0x5354,
                0x8BA7: 0x5321,
                0x8BA8: 0x537F,
                0x8BA9: 0x53EB,
                0x8BAA: 0x55AC,
                0x8BAB: 0x5883,
                0x8BAC: 0x5CE1,
                0x8BAD: 0x5F37,
                0x8BAE: 0x5F4A,
                0x8BAF: 0x602F,
                0x8BB0: 0x6050,
                0x8BB1: 0x606D,
                0x8BB2: 0x631F,
                0x8BB3: 0x6559,
                0x8BB4: 0x6A4B,
                0x8BB5: 0x6CC1,
                0x8BB6: 0x72C2,
                0x8BB7: 0x72ED,
                0x8BB8: 0x77EF,
                0x8BB9: 0x80F8,
                0x8BBA: 0x8105,
                0x8BBB: 0x8208,
                0x8BBC: 0x854E,
                0x8BBD: 0x90F7,
                0x8BBE: 0x93E1,
                0x8BBF: 0x97FF,
                0x8BC0: 0x9957,
                0x8BC1: 0x9A5A,
                0x8BC2: 0x4EF0,
                0x8BC3: 0x51DD,
                0x8BC4: 0x5C2D,
                0x8BC5: 0x6681,
                0x8BC6: 0x696D,
                0x8BC7: 0x5C40,
                0x8BC8: 0x66F2,
                0x8BC9: 0x6975,
                0x8BCA: 0x7389,
                0x8BCB: 0x6850,
                0x8BCC: 0x7C81,
                0x8BCD: 0x50C5,
                0x8BCE: 0x52E4,
                0x8BCF: 0x5747,
                0x8BD0: 0x5DFE,
                0x8BD1: 0x9326,
                0x8BD2: 0x65A4,
                0x8BD3: 0x6B23,
                0x8BD4: 0x6B3D,
                0x8BD5: 0x7434,
                0x8BD6: 0x7981,
                0x8BD7: 0x79BD,
                0x8BD8: 0x7B4B,
                0x8BD9: 0x7DCA,
                0x8BDA: 0x82B9,
                0x8BDB: 0x83CC,
                0x8BDC: 0x887F,
                0x8BDD: 0x895F,
                0x8BDE: 0x8B39,
                0x8BDF: 0x8FD1,
                0x8BE0: 0x91D1,
                0x8BE1: 0x541F,
                0x8BE2: 0x9280,
                0x8BE3: 0x4E5D,
                0x8BE4: 0x5036,
                0x8BE5: 0x53E5,
                0x8BE6: 0x533A,
                0x8BE7: 0x72D7,
                0x8BE8: 0x7396,
                0x8BE9: 0x77E9,
                0x8BEA: 0x82E6,
                0x8BEB: 0x8EAF,
                0x8BEC: 0x99C6,
                0x8BED: 0x99C8,
                0x8BEE: 0x99D2,
                0x8BEF: 0x5177,
                0x8BF0: 0x611A,
                0x8BF1: 0x865E,
                0x8BF2: 0x55B0,
                0x8BF3: 0x7A7A,
                0x8BF4: 0x5076,
                0x8BF5: 0x5BD3,
                0x8BF6: 0x9047,
                0x8BF7: 0x9685,
                0x8BF8: 0x4E32,
                0x8BF9: 0x6ADB,
                0x8BFA: 0x91E7,
                0x8BFB: 0x5C51,
                0x8BFC: 0x5C48,
                0x8C40: 0x6398,
                0x8C41: 0x7A9F,
                0x8C42: 0x6C93,
                0x8C43: 0x9774,
                0x8C44: 0x8F61,
                0x8C45: 0x7AAA,
                0x8C46: 0x718A,
                0x8C47: 0x9688,
                0x8C48: 0x7C82,
                0x8C49: 0x6817,
                0x8C4A: 0x7E70,
                0x8C4B: 0x6851,
                0x8C4C: 0x936C,
                0x8C4D: 0x52F2,
                0x8C4E: 0x541B,
                0x8C4F: 0x85AB,
                0x8C50: 0x8A13,
                0x8C51: 0x7FA4,
                0x8C52: 0x8ECD,
                0x8C53: 0x90E1,
                0x8C54: 0x5366,
                0x8C55: 0x8888,
                0x8C56: 0x7941,
                0x8C57: 0x4FC2,
                0x8C58: 0x50BE,
                0x8C59: 0x5211,
                0x8C5A: 0x5144,
                0x8C5B: 0x5553,
                0x8C5C: 0x572D,
                0x8C5D: 0x73EA,
                0x8C5E: 0x578B,
                0x8C5F: 0x5951,
                0x8C60: 0x5F62,
                0x8C61: 0x5F84,
                0x8C62: 0x6075,
                0x8C63: 0x6176,
                0x8C64: 0x6167,
                0x8C65: 0x61A9,
                0x8C66: 0x63B2,
                0x8C67: 0x643A,
                0x8C68: 0x656C,
                0x8C69: 0x666F,
                0x8C6A: 0x6842,
                0x8C6B: 0x6E13,
                0x8C6C: 0x7566,
                0x8C6D: 0x7A3D,
                0x8C6E: 0x7CFB,
                0x8C6F: 0x7D4C,
                0x8C70: 0x7D99,
                0x8C71: 0x7E4B,
                0x8C72: 0x7F6B,
                0x8C73: 0x830E,
                0x8C74: 0x834A,
                0x8C75: 0x86CD,
                0x8C76: 0x8A08,
                0x8C77: 0x8A63,
                0x8C78: 0x8B66,
                0x8C79: 0x8EFD,
                0x8C7A: 0x981A,
                0x8C7B: 0x9D8F,
                0x8C7C: 0x82B8,
                0x8C7D: 0x8FCE,
                0x8C7E: 0x9BE8,
                0x8C80: 0x5287,
                0x8C81: 0x621F,
                0x8C82: 0x6483,
                0x8C83: 0x6FC0,
                0x8C84: 0x9699,
                0x8C85: 0x6841,
                0x8C86: 0x5091,
                0x8C87: 0x6B20,
                0x8C88: 0x6C7A,
                0x8C89: 0x6F54,
                0x8C8A: 0x7A74,
                0x8C8B: 0x7D50,
                0x8C8C: 0x8840,
                0x8C8D: 0x8A23,
                0x8C8E: 0x6708,
                0x8C8F: 0x4EF6,
                0x8C90: 0x5039,
                0x8C91: 0x5026,
                0x8C92: 0x5065,
                0x8C93: 0x517C,
                0x8C94: 0x5238,
                0x8C95: 0x5263,
                0x8C96: 0x55A7,
                0x8C97: 0x570F,
                0x8C98: 0x5805,
                0x8C99: 0x5ACC,
                0x8C9A: 0x5EFA,
                0x8C9B: 0x61B2,
                0x8C9C: 0x61F8,
                0x8C9D: 0x62F3,
                0x8C9E: 0x6372,
                0x8C9F: 0x691C,
                0x8CA0: 0x6A29,
                0x8CA1: 0x727D,
                0x8CA2: 0x72AC,
                0x8CA3: 0x732E,
                0x8CA4: 0x7814,
                0x8CA5: 0x786F,
                0x8CA6: 0x7D79,
                0x8CA7: 0x770C,
                0x8CA8: 0x80A9,
                0x8CA9: 0x898B,
                0x8CAA: 0x8B19,
                0x8CAB: 0x8CE2,
                0x8CAC: 0x8ED2,
                0x8CAD: 0x9063,
                0x8CAE: 0x9375,
                0x8CAF: 0x967A,
                0x8CB0: 0x9855,
                0x8CB1: 0x9A13,
                0x8CB2: 0x9E78,
                0x8CB3: 0x5143,
                0x8CB4: 0x539F,
                0x8CB5: 0x53B3,
                0x8CB6: 0x5E7B,
                0x8CB7: 0x5F26,
                0x8CB8: 0x6E1B,
                0x8CB9: 0x6E90,
                0x8CBA: 0x7384,
                0x8CBB: 0x73FE,
                0x8CBC: 0x7D43,
                0x8CBD: 0x8237,
                0x8CBE: 0x8A00,
                0x8CBF: 0x8AFA,
                0x8CC0: 0x9650,
                0x8CC1: 0x4E4E,
                0x8CC2: 0x500B,
                0x8CC3: 0x53E4,
                0x8CC4: 0x547C,
                0x8CC5: 0x56FA,
                0x8CC6: 0x59D1,
                0x8CC7: 0x5B64,
                0x8CC8: 0x5DF1,
                0x8CC9: 0x5EAB,
                0x8CCA: 0x5F27,
                0x8CCB: 0x6238,
                0x8CCC: 0x6545,
                0x8CCD: 0x67AF,
                0x8CCE: 0x6E56,
                0x8CCF: 0x72D0,
                0x8CD0: 0x7CCA,
                0x8CD1: 0x88B4,
                0x8CD2: 0x80A1,
                0x8CD3: 0x80E1,
                0x8CD4: 0x83F0,
                0x8CD5: 0x864E,
                0x8CD6: 0x8A87,
                0x8CD7: 0x8DE8,
                0x8CD8: 0x9237,
                0x8CD9: 0x96C7,
                0x8CDA: 0x9867,
                0x8CDB: 0x9F13,
                0x8CDC: 0x4E94,
                0x8CDD: 0x4E92,
                0x8CDE: 0x4F0D,
                0x8CDF: 0x5348,
                0x8CE0: 0x5449,
                0x8CE1: 0x543E,
                0x8CE2: 0x5A2F,
                0x8CE3: 0x5F8C,
                0x8CE4: 0x5FA1,
                0x8CE5: 0x609F,
                0x8CE6: 0x68A7,
                0x8CE7: 0x6A8E,
                0x8CE8: 0x745A,
                0x8CE9: 0x7881,
                0x8CEA: 0x8A9E,
                0x8CEB: 0x8AA4,
                0x8CEC: 0x8B77,
                0x8CED: 0x9190,
                0x8CEE: 0x4E5E,
                0x8CEF: 0x9BC9,
                0x8CF0: 0x4EA4,
                0x8CF1: 0x4F7C,
                0x8CF2: 0x4FAF,
                0x8CF3: 0x5019,
                0x8CF4: 0x5016,
                0x8CF5: 0x5149,
                0x8CF6: 0x516C,
                0x8CF7: 0x529F,
                0x8CF8: 0x52B9,
                0x8CF9: 0x52FE,
                0x8CFA: 0x539A,
                0x8CFB: 0x53E3,
                0x8CFC: 0x5411,
                0x8D40: 0x540E,
                0x8D41: 0x5589,
                0x8D42: 0x5751,
                0x8D43: 0x57A2,
                0x8D44: 0x597D,
                0x8D45: 0x5B54,
                0x8D46: 0x5B5D,
                0x8D47: 0x5B8F,
                0x8D48: 0x5DE5,
                0x8D49: 0x5DE7,
                0x8D4A: 0x5DF7,
                0x8D4B: 0x5E78,
                0x8D4C: 0x5E83,
                0x8D4D: 0x5E9A,
                0x8D4E: 0x5EB7,
                0x8D4F: 0x5F18,
                0x8D50: 0x6052,
                0x8D51: 0x614C,
                0x8D52: 0x6297,
                0x8D53: 0x62D8,
                0x8D54: 0x63A7,
                0x8D55: 0x653B,
                0x8D56: 0x6602,
                0x8D57: 0x6643,
                0x8D58: 0x66F4,
                0x8D59: 0x676D,
                0x8D5A: 0x6821,
                0x8D5B: 0x6897,
                0x8D5C: 0x69CB,
                0x8D5D: 0x6C5F,
                0x8D5E: 0x6D2A,
                0x8D5F: 0x6D69,
                0x8D60: 0x6E2F,
                0x8D61: 0x6E9D,
                0x8D62: 0x7532,
                0x8D63: 0x7687,
                0x8D64: 0x786C,
                0x8D65: 0x7A3F,
                0x8D66: 0x7CE0,
                0x8D67: 0x7D05,
                0x8D68: 0x7D18,
                0x8D69: 0x7D5E,
                0x8D6A: 0x7DB1,
                0x8D6B: 0x8015,
                0x8D6C: 0x8003,
                0x8D6D: 0x80AF,
                0x8D6E: 0x80B1,
                0x8D6F: 0x8154,
                0x8D70: 0x818F,
                0x8D71: 0x822A,
                0x8D72: 0x8352,
                0x8D73: 0x884C,
                0x8D74: 0x8861,
                0x8D75: 0x8B1B,
                0x8D76: 0x8CA2,
                0x8D77: 0x8CFC,
                0x8D78: 0x90CA,
                0x8D79: 0x9175,
                0x8D7A: 0x9271,
                0x8D7B: 0x783F,
                0x8D7C: 0x92FC,
                0x8D7D: 0x95A4,
                0x8D7E: 0x964D,
                0x8D80: 0x9805,
                0x8D81: 0x9999,
                0x8D82: 0x9AD8,
                0x8D83: 0x9D3B,
                0x8D84: 0x525B,
                0x8D85: 0x52AB,
                0x8D86: 0x53F7,
                0x8D87: 0x5408,
                0x8D88: 0x58D5,
                0x8D89: 0x62F7,
                0x8D8A: 0x6FE0,
                0x8D8B: 0x8C6A,
                0x8D8C: 0x8F5F,
                0x8D8D: 0x9EB9,
                0x8D8E: 0x514B,
                0x8D8F: 0x523B,
                0x8D90: 0x544A,
                0x8D91: 0x56FD,
                0x8D92: 0x7A40,
                0x8D93: 0x9177,
                0x8D94: 0x9D60,
                0x8D95: 0x9ED2,
                0x8D96: 0x7344,
                0x8D97: 0x6F09,
                0x8D98: 0x8170,
                0x8D99: 0x7511,
                0x8D9A: 0x5FFD,
                0x8D9B: 0x60DA,
                0x8D9C: 0x9AA8,
                0x8D9D: 0x72DB,
                0x8D9E: 0x8FBC,
                0x8D9F: 0x6B64,
                0x8DA0: 0x9803,
                0x8DA1: 0x4ECA,
                0x8DA2: 0x56F0,
                0x8DA3: 0x5764,
                0x8DA4: 0x58BE,
                0x8DA5: 0x5A5A,
                0x8DA6: 0x6068,
                0x8DA7: 0x61C7,
                0x8DA8: 0x660F,
                0x8DA9: 0x6606,
                0x8DAA: 0x6839,
                0x8DAB: 0x68B1,
                0x8DAC: 0x6DF7,
                0x8DAD: 0x75D5,
                0x8DAE: 0x7D3A,
                0x8DAF: 0x826E,
                0x8DB0: 0x9B42,
                0x8DB1: 0x4E9B,
                0x8DB2: 0x4F50,
                0x8DB3: 0x53C9,
                0x8DB4: 0x5506,
                0x8DB5: 0x5D6F,
                0x8DB6: 0x5DE6,
                0x8DB7: 0x5DEE,
                0x8DB8: 0x67FB,
                0x8DB9: 0x6C99,
                0x8DBA: 0x7473,
                0x8DBB: 0x7802,
                0x8DBC: 0x8A50,
                0x8DBD: 0x9396,
                0x8DBE: 0x88DF,
                0x8DBF: 0x5750,
                0x8DC0: 0x5EA7,
                0x8DC1: 0x632B,
                0x8DC2: 0x50B5,
                0x8DC3: 0x50AC,
                0x8DC4: 0x518D,
                0x8DC5: 0x6700,
                0x8DC6: 0x54C9,
                0x8DC7: 0x585E,
                0x8DC8: 0x59BB,
                0x8DC9: 0x5BB0,
                0x8DCA: 0x5F69,
                0x8DCB: 0x624D,
                0x8DCC: 0x63A1,
                0x8DCD: 0x683D,
                0x8DCE: 0x6B73,
                0x8DCF: 0x6E08,
                0x8DD0: 0x707D,
                0x8DD1: 0x91C7,
                0x8DD2: 0x7280,
                0x8DD3: 0x7815,
                0x8DD4: 0x7826,
                0x8DD5: 0x796D,
                0x8DD6: 0x658E,
                0x8DD7: 0x7D30,
                0x8DD8: 0x83DC,
                0x8DD9: 0x88C1,
                0x8DDA: 0x8F09,
                0x8DDB: 0x969B,
                0x8DDC: 0x5264,
                0x8DDD: 0x5728,
                0x8DDE: 0x6750,
                0x8DDF: 0x7F6A,
                0x8DE0: 0x8CA1,
                0x8DE1: 0x51B4,
                0x8DE2: 0x5742,
                0x8DE3: 0x962A,
                0x8DE4: 0x583A,
                0x8DE5: 0x698A,
                0x8DE6: 0x80B4,
                0x8DE7: 0x54B2,
                0x8DE8: 0x5D0E,
                0x8DE9: 0x57FC,
                0x8DEA: 0x7895,
                0x8DEB: 0x9DFA,
                0x8DEC: 0x4F5C,
                0x8DED: 0x524A,
                0x8DEE: 0x548B,
                0x8DEF: 0x643E,
                0x8DF0: 0x6628,
                0x8DF1: 0x6714,
                0x8DF2: 0x67F5,
                0x8DF3: 0x7A84,
                0x8DF4: 0x7B56,
                0x8DF5: 0x7D22,
                0x8DF6: 0x932F,
                0x8DF7: 0x685C,
                0x8DF8: 0x9BAD,
                0x8DF9: 0x7B39,
                0x8DFA: 0x5319,
                0x8DFB: 0x518A,
                0x8DFC: 0x5237,
                0x8E40: 0x5BDF,
                0x8E41: 0x62F6,
                0x8E42: 0x64AE,
                0x8E43: 0x64E6,
                0x8E44: 0x672D,
                0x8E45: 0x6BBA,
                0x8E46: 0x85A9,
                0x8E47: 0x96D1,
                0x8E48: 0x7690,
                0x8E49: 0x9BD6,
                0x8E4A: 0x634C,
                0x8E4B: 0x9306,
                0x8E4C: 0x9BAB,
                0x8E4D: 0x76BF,
                0x8E4E: 0x6652,
                0x8E4F: 0x4E09,
                0x8E50: 0x5098,
                0x8E51: 0x53C2,
                0x8E52: 0x5C71,
                0x8E53: 0x60E8,
                0x8E54: 0x6492,
                0x8E55: 0x6563,
                0x8E56: 0x685F,
                0x8E57: 0x71E6,
                0x8E58: 0x73CA,
                0x8E59: 0x7523,
                0x8E5A: 0x7B97,
                0x8E5B: 0x7E82,
                0x8E5C: 0x8695,
                0x8E5D: 0x8B83,
                0x8E5E: 0x8CDB,
                0x8E5F: 0x9178,
                0x8E60: 0x9910,
                0x8E61: 0x65AC,
                0x8E62: 0x66AB,
                0x8E63: 0x6B8B,
                0x8E64: 0x4ED5,
                0x8E65: 0x4ED4,
                0x8E66: 0x4F3A,
                0x8E67: 0x4F7F,
                0x8E68: 0x523A,
                0x8E69: 0x53F8,
                0x8E6A: 0x53F2,
                0x8E6B: 0x55E3,
                0x8E6C: 0x56DB,
                0x8E6D: 0x58EB,
                0x8E6E: 0x59CB,
                0x8E6F: 0x59C9,
                0x8E70: 0x59FF,
                0x8E71: 0x5B50,
                0x8E72: 0x5C4D,
                0x8E73: 0x5E02,
                0x8E74: 0x5E2B,
                0x8E75: 0x5FD7,
                0x8E76: 0x601D,
                0x8E77: 0x6307,
                0x8E78: 0x652F,
                0x8E79: 0x5B5C,
                0x8E7A: 0x65AF,
                0x8E7B: 0x65BD,
                0x8E7C: 0x65E8,
                0x8E7D: 0x679D,
                0x8E7E: 0x6B62,
                0x8E80: 0x6B7B,
                0x8E81: 0x6C0F,
                0x8E82: 0x7345,
                0x8E83: 0x7949,
                0x8E84: 0x79C1,
                0x8E85: 0x7CF8,
                0x8E86: 0x7D19,
                0x8E87: 0x7D2B,
                0x8E88: 0x80A2,
                0x8E89: 0x8102,
                0x8E8A: 0x81F3,
                0x8E8B: 0x8996,
                0x8E8C: 0x8A5E,
                0x8E8D: 0x8A69,
                0x8E8E: 0x8A66,
                0x8E8F: 0x8A8C,
                0x8E90: 0x8AEE,
                0x8E91: 0x8CC7,
                0x8E92: 0x8CDC,
                0x8E93: 0x96CC,
                0x8E94: 0x98FC,
                0x8E95: 0x6B6F,
                0x8E96: 0x4E8B,
                0x8E97: 0x4F3C,
                0x8E98: 0x4F8D,
                0x8E99: 0x5150,
                0x8E9A: 0x5B57,
                0x8E9B: 0x5BFA,
                0x8E9C: 0x6148,
                0x8E9D: 0x6301,
                0x8E9E: 0x6642,
                0x8E9F: 0x6B21,
                0x8EA0: 0x6ECB,
                0x8EA1: 0x6CBB,
                0x8EA2: 0x723E,
                0x8EA3: 0x74BD,
                0x8EA4: 0x75D4,
                0x8EA5: 0x78C1,
                0x8EA6: 0x793A,
                0x8EA7: 0x800C,
                0x8EA8: 0x8033,
                0x8EA9: 0x81EA,
                0x8EAA: 0x8494,
                0x8EAB: 0x8F9E,
                0x8EAC: 0x6C50,
                0x8EAD: 0x9E7F,
                0x8EAE: 0x5F0F,
                0x8EAF: 0x8B58,
                0x8EB0: 0x9D2B,
                0x8EB1: 0x7AFA,
                0x8EB2: 0x8EF8,
                0x8EB3: 0x5B8D,
                0x8EB4: 0x96EB,
                0x8EB5: 0x4E03,
                0x8EB6: 0x53F1,
                0x8EB7: 0x57F7,
                0x8EB8: 0x5931,
                0x8EB9: 0x5AC9,
                0x8EBA: 0x5BA4,
                0x8EBB: 0x6089,
                0x8EBC: 0x6E7F,
                0x8EBD: 0x6F06,
                0x8EBE: 0x75BE,
                0x8EBF: 0x8CEA,
                0x8EC0: 0x5B9F,
                0x8EC1: 0x8500,
                0x8EC2: 0x7BE0,
                0x8EC3: 0x5072,
                0x8EC4: 0x67F4,
                0x8EC5: 0x829D,
                0x8EC6: 0x5C61,
                0x8EC7: 0x854A,
                0x8EC8: 0x7E1E,
                0x8EC9: 0x820E,
                0x8ECA: 0x5199,
                0x8ECB: 0x5C04,
                0x8ECC: 0x6368,
                0x8ECD: 0x8D66,
                0x8ECE: 0x659C,
                0x8ECF: 0x716E,
                0x8ED0: 0x793E,
                0x8ED1: 0x7D17,
                0x8ED2: 0x8005,
                0x8ED3: 0x8B1D,
                0x8ED4: 0x8ECA,
                0x8ED5: 0x906E,
                0x8ED6: 0x86C7,
                0x8ED7: 0x90AA,
                0x8ED8: 0x501F,
                0x8ED9: 0x52FA,
                0x8EDA: 0x5C3A,
                0x8EDB: 0x6753,
                0x8EDC: 0x707C,
                0x8EDD: 0x7235,
                0x8EDE: 0x914C,
                0x8EDF: 0x91C8,
                0x8EE0: 0x932B,
                0x8EE1: 0x82E5,
                0x8EE2: 0x5BC2,
                0x8EE3: 0x5F31,
                0x8EE4: 0x60F9,
                0x8EE5: 0x4E3B,
                0x8EE6: 0x53D6,
                0x8EE7: 0x5B88,
                0x8EE8: 0x624B,
                0x8EE9: 0x6731,
                0x8EEA: 0x6B8A,
                0x8EEB: 0x72E9,
                0x8EEC: 0x73E0,
                0x8EED: 0x7A2E,
                0x8EEE: 0x816B,
                0x8EEF: 0x8DA3,
                0x8EF0: 0x9152,
                0x8EF1: 0x9996,
                0x8EF2: 0x5112,
                0x8EF3: 0x53D7,
                0x8EF4: 0x546A,
                0x8EF5: 0x5BFF,
                0x8EF6: 0x6388,
                0x8EF7: 0x6A39,
                0x8EF8: 0x7DAC,
                0x8EF9: 0x9700,
                0x8EFA: 0x56DA,
                0x8EFB: 0x53CE,
                0x8EFC: 0x5468,
                0x8F40: 0x5B97,
                0x8F41: 0x5C31,
                0x8F42: 0x5DDE,
                0x8F43: 0x4FEE,
                0x8F44: 0x6101,
                0x8F45: 0x62FE,
                0x8F46: 0x6D32,
                0x8F47: 0x79C0,
                0x8F48: 0x79CB,
                0x8F49: 0x7D42,
                0x8F4A: 0x7E4D,
                0x8F4B: 0x7FD2,
                0x8F4C: 0x81ED,
                0x8F4D: 0x821F,
                0x8F4E: 0x8490,
                0x8F4F: 0x8846,
                0x8F50: 0x8972,
                0x8F51: 0x8B90,
                0x8F52: 0x8E74,
                0x8F53: 0x8F2F,
                0x8F54: 0x9031,
                0x8F55: 0x914B,
                0x8F56: 0x916C,
                0x8F57: 0x96C6,
                0x8F58: 0x919C,
                0x8F59: 0x4EC0,
                0x8F5A: 0x4F4F,
                0x8F5B: 0x5145,
                0x8F5C: 0x5341,
                0x8F5D: 0x5F93,
                0x8F5E: 0x620E,
                0x8F5F: 0x67D4,
                0x8F60: 0x6C41,
                0x8F61: 0x6E0B,
                0x8F62: 0x7363,
                0x8F63: 0x7E26,
                0x8F64: 0x91CD,
                0x8F65: 0x9283,
                0x8F66: 0x53D4,
                0x8F67: 0x5919,
                0x8F68: 0x5BBF,
                0x8F69: 0x6DD1,
                0x8F6A: 0x795D,
                0x8F6B: 0x7E2E,
                0x8F6C: 0x7C9B,
                0x8F6D: 0x587E,
                0x8F6E: 0x719F,
                0x8F6F: 0x51FA,
                0x8F70: 0x8853,
                0x8F71: 0x8FF0,
                0x8F72: 0x4FCA,
                0x8F73: 0x5CFB,
                0x8F74: 0x6625,
                0x8F75: 0x77AC,
                0x8F76: 0x7AE3,
                0x8F77: 0x821C,
                0x8F78: 0x99FF,
                0x8F79: 0x51C6,
                0x8F7A: 0x5FAA,
                0x8F7B: 0x65EC,
                0x8F7C: 0x696F,
                0x8F7D: 0x6B89,
                0x8F7E: 0x6DF3,
                0x8F80: 0x6E96,
                0x8F81: 0x6F64,
                0x8F82: 0x76FE,
                0x8F83: 0x7D14,
                0x8F84: 0x5DE1,
                0x8F85: 0x9075,
                0x8F86: 0x9187,
                0x8F87: 0x9806,
                0x8F88: 0x51E6,
                0x8F89: 0x521D,
                0x8F8A: 0x6240,
                0x8F8B: 0x6691,
                0x8F8C: 0x66D9,
                0x8F8D: 0x6E1A,
                0x8F8E: 0x5EB6,
                0x8F8F: 0x7DD2,
                0x8F90: 0x7F72,
                0x8F91: 0x66F8,
                0x8F92: 0x85AF,
                0x8F93: 0x85F7,
                0x8F94: 0x8AF8,
                0x8F95: 0x52A9,
                0x8F96: 0x53D9,
                0x8F97: 0x5973,
                0x8F98: 0x5E8F,
                0x8F99: 0x5F90,
                0x8F9A: 0x6055,
                0x8F9B: 0x92E4,
                0x8F9C: 0x9664,
                0x8F9D: 0x50B7,
                0x8F9E: 0x511F,
                0x8F9F: 0x52DD,
                0x8FA0: 0x5320,
                0x8FA1: 0x5347,
                0x8FA2: 0x53EC,
                0x8FA3: 0x54E8,
                0x8FA4: 0x5546,
                0x8FA5: 0x5531,
                0x8FA6: 0x5617,
                0x8FA7: 0x5968,
                0x8FA8: 0x59BE,
                0x8FA9: 0x5A3C,
                0x8FAA: 0x5BB5,
                0x8FAB: 0x5C06,
                0x8FAC: 0x5C0F,
                0x8FAD: 0x5C11,
                0x8FAE: 0x5C1A,
                0x8FAF: 0x5E84,
                0x8FB0: 0x5E8A,
                0x8FB1: 0x5EE0,
                0x8FB2: 0x5F70,
                0x8FB3: 0x627F,
                0x8FB4: 0x6284,
                0x8FB5: 0x62DB,
                0x8FB6: 0x638C,
                0x8FB7: 0x6377,
                0x8FB8: 0x6607,
                0x8FB9: 0x660C,
                0x8FBA: 0x662D,
                0x8FBB: 0x6676,
                0x8FBC: 0x677E,
                0x8FBD: 0x68A2,
                0x8FBE: 0x6A1F,
                0x8FBF: 0x6A35,
                0x8FC0: 0x6CBC,
                0x8FC1: 0x6D88,
                0x8FC2: 0x6E09,
                0x8FC3: 0x6E58,
                0x8FC4: 0x713C,
                0x8FC5: 0x7126,
                0x8FC6: 0x7167,
                0x8FC7: 0x75C7,
                0x8FC8: 0x7701,
                0x8FC9: 0x785D,
                0x8FCA: 0x7901,
                0x8FCB: 0x7965,
                0x8FCC: 0x79F0,
                0x8FCD: 0x7AE0,
                0x8FCE: 0x7B11,
                0x8FCF: 0x7CA7,
                0x8FD0: 0x7D39,
                0x8FD1: 0x8096,
                0x8FD2: 0x83D6,
                0x8FD3: 0x848B,
                0x8FD4: 0x8549,
                0x8FD5: 0x885D,
                0x8FD6: 0x88F3,
                0x8FD7: 0x8A1F,
                0x8FD8: 0x8A3C,
                0x8FD9: 0x8A54,
                0x8FDA: 0x8A73,
                0x8FDB: 0x8C61,
                0x8FDC: 0x8CDE,
                0x8FDD: 0x91A4,
                0x8FDE: 0x9266,
                0x8FDF: 0x937E,
                0x8FE0: 0x9418,
                0x8FE1: 0x969C,
                0x8FE2: 0x9798,
                0x8FE3: 0x4E0A,
                0x8FE4: 0x4E08,
                0x8FE5: 0x4E1E,
                0x8FE6: 0x4E57,
                0x8FE7: 0x5197,
                0x8FE8: 0x5270,
                0x8FE9: 0x57CE,
                0x8FEA: 0x5834,
                0x8FEB: 0x58CC,
                0x8FEC: 0x5B22,
                0x8FED: 0x5E38,
                0x8FEE: 0x60C5,
                0x8FEF: 0x64FE,
                0x8FF0: 0x6761,
                0x8FF1: 0x6756,
                0x8FF2: 0x6D44,
                0x8FF3: 0x72B6,
                0x8FF4: 0x7573,
                0x8FF5: 0x7A63,
                0x8FF6: 0x84B8,
                0x8FF7: 0x8B72,
                0x8FF8: 0x91B8,
                0x8FF9: 0x9320,
                0x8FFA: 0x5631,
                0x8FFB: 0x57F4,
                0x8FFC: 0x98FE,
                0x9040: 0x62ED,
                0x9041: 0x690D,
                0x9042: 0x6B96,
                0x9043: 0x71ED,
                0x9044: 0x7E54,
                0x9045: 0x8077,
                0x9046: 0x8272,
                0x9047: 0x89E6,
                0x9048: 0x98DF,
                0x9049: 0x8755,
                0x904A: 0x8FB1,
                0x904B: 0x5C3B,
                0x904C: 0x4F38,
                0x904D: 0x4FE1,
                0x904E: 0x4FB5,
                0x904F: 0x5507,
                0x9050: 0x5A20,
                0x9051: 0x5BDD,
                0x9052: 0x5BE9,
                0x9053: 0x5FC3,
                0x9054: 0x614E,
                0x9055: 0x632F,
                0x9056: 0x65B0,
                0x9057: 0x664B,
                0x9058: 0x68EE,
                0x9059: 0x699B,
                0x905A: 0x6D78,
                0x905B: 0x6DF1,
                0x905C: 0x7533,
                0x905D: 0x75B9,
                0x905E: 0x771F,
                0x905F: 0x795E,
                0x9060: 0x79E6,
                0x9061: 0x7D33,
                0x9062: 0x81E3,
                0x9063: 0x82AF,
                0x9064: 0x85AA,
                0x9065: 0x89AA,
                0x9066: 0x8A3A,
                0x9067: 0x8EAB,
                0x9068: 0x8F9B,
                0x9069: 0x9032,
                0x906A: 0x91DD,
                0x906B: 0x9707,
                0x906C: 0x4EBA,
                0x906D: 0x4EC1,
                0x906E: 0x5203,
                0x906F: 0x5875,
                0x9070: 0x58EC,
                0x9071: 0x5C0B,
                0x9072: 0x751A,
                0x9073: 0x5C3D,
                0x9074: 0x814E,
                0x9075: 0x8A0A,
                0x9076: 0x8FC5,
                0x9077: 0x9663,
                0x9078: 0x976D,
                0x9079: 0x7B25,
                0x907A: 0x8ACF,
                0x907B: 0x9808,
                0x907C: 0x9162,
                0x907D: 0x56F3,
                0x907E: 0x53A8,
                0x9080: 0x9017,
                0x9081: 0x5439,
                0x9082: 0x5782,
                0x9083: 0x5E25,
                0x9084: 0x63A8,
                0x9085: 0x6C34,
                0x9086: 0x708A,
                0x9087: 0x7761,
                0x9088: 0x7C8B,
                0x9089: 0x7FE0,
                0x908A: 0x8870,
                0x908B: 0x9042,
                0x908C: 0x9154,
                0x908D: 0x9310,
                0x908E: 0x9318,
                0x908F: 0x968F,
                0x9090: 0x745E,
                0x9091: 0x9AC4,
                0x9092: 0x5D07,
                0x9093: 0x5D69,
                0x9094: 0x6570,
                0x9095: 0x67A2,
                0x9096: 0x8DA8,
                0x9097: 0x96DB,
                0x9098: 0x636E,
                0x9099: 0x6749,
                0x909A: 0x6919,
                0x909B: 0x83C5,
                0x909C: 0x9817,
                0x909D: 0x96C0,
                0x909E: 0x88FE,
                0x909F: 0x6F84,
                0x90A0: 0x647A,
                0x90A1: 0x5BF8,
                0x90A2: 0x4E16,
                0x90A3: 0x702C,
                0x90A4: 0x755D,
                0x90A5: 0x662F,
                0x90A6: 0x51C4,
                0x90A7: 0x5236,
                0x90A8: 0x52E2,
                0x90A9: 0x59D3,
                0x90AA: 0x5F81,
                0x90AB: 0x6027,
                0x90AC: 0x6210,
                0x90AD: 0x653F,
                0x90AE: 0x6574,
                0x90AF: 0x661F,
                0x90B0: 0x6674,
                0x90B1: 0x68F2,
                0x90B2: 0x6816,
                0x90B3: 0x6B63,
                0x90B4: 0x6E05,
                0x90B5: 0x7272,
                0x90B6: 0x751F,
                0x90B7: 0x76DB,
                0x90B8: 0x7CBE,
                0x90B9: 0x8056,
                0x90BA: 0x58F0,
                0x90BB: 0x88FD,
                0x90BC: 0x897F,
                0x90BD: 0x8AA0,
                0x90BE: 0x8A93,
                0x90BF: 0x8ACB,
                0x90C0: 0x901D,
                0x90C1: 0x9192,
                0x90C2: 0x9752,
                0x90C3: 0x9759,
                0x90C4: 0x6589,
                0x90C5: 0x7A0E,
                0x90C6: 0x8106,
                0x90C7: 0x96BB,
                0x90C8: 0x5E2D,
                0x90C9: 0x60DC,
                0x90CA: 0x621A,
                0x90CB: 0x65A5,
                0x90CC: 0x6614,
                0x90CD: 0x6790,
                0x90CE: 0x77F3,
                0x90CF: 0x7A4D,
                0x90D0: 0x7C4D,
                0x90D1: 0x7E3E,
                0x90D2: 0x810A,
                0x90D3: 0x8CAC,
                0x90D4: 0x8D64,
                0x90D5: 0x8DE1,
                0x90D6: 0x8E5F,
                0x90D7: 0x78A9,
                0x90D8: 0x5207,
                0x90D9: 0x62D9,
                0x90DA: 0x63A5,
                0x90DB: 0x6442,
                0x90DC: 0x6298,
                0x90DD: 0x8A2D,
                0x90DE: 0x7A83,
                0x90DF: 0x7BC0,
                0x90E0: 0x8AAC,
                0x90E1: 0x96EA,
                0x90E2: 0x7D76,
                0x90E3: 0x820C,
                0x90E4: 0x8749,
                0x90E5: 0x4ED9,
                0x90E6: 0x5148,
                0x90E7: 0x5343,
                0x90E8: 0x5360,
                0x90E9: 0x5BA3,
                0x90EA: 0x5C02,
                0x90EB: 0x5C16,
                0x90EC: 0x5DDD,
                0x90ED: 0x6226,
                0x90EE: 0x6247,
                0x90EF: 0x64B0,
                0x90F0: 0x6813,
                0x90F1: 0x6834,
                0x90F2: 0x6CC9,
                0x90F3: 0x6D45,
                0x90F4: 0x6D17,
                0x90F5: 0x67D3,
                0x90F6: 0x6F5C,
                0x90F7: 0x714E,
                0x90F8: 0x717D,
                0x90F9: 0x65CB,
                0x90FA: 0x7A7F,
                0x90FB: 0x7BAD,
                0x90FC: 0x7DDA,
                0x9140: 0x7E4A,
                0x9141: 0x7FA8,
                0x9142: 0x817A,
                0x9143: 0x821B,
                0x9144: 0x8239,
                0x9145: 0x85A6,
                0x9146: 0x8A6E,
                0x9147: 0x8CCE,
                0x9148: 0x8DF5,
                0x9149: 0x9078,
                0x914A: 0x9077,
                0x914B: 0x92AD,
                0x914C: 0x9291,
                0x914D: 0x9583,
                0x914E: 0x9BAE,
                0x914F: 0x524D,
                0x9150: 0x5584,
                0x9151: 0x6F38,
                0x9152: 0x7136,
                0x9153: 0x5168,
                0x9154: 0x7985,
                0x9155: 0x7E55,
                0x9156: 0x81B3,
                0x9157: 0x7CCE,
                0x9158: 0x564C,
                0x9159: 0x5851,
                0x915A: 0x5CA8,
                0x915B: 0x63AA,
                0x915C: 0x66FE,
                0x915D: 0x66FD,
                0x915E: 0x695A,
                0x915F: 0x72D9,
                0x9160: 0x758F,
                0x9161: 0x758E,
                0x9162: 0x790E,
                0x9163: 0x7956,
                0x9164: 0x79DF,
                0x9165: 0x7C97,
                0x9166: 0x7D20,
                0x9167: 0x7D44,
                0x9168: 0x8607,
                0x9169: 0x8A34,
                0x916A: 0x963B,
                0x916B: 0x9061,
                0x916C: 0x9F20,
                0x916D: 0x50E7,
                0x916E: 0x5275,
                0x916F: 0x53CC,
                0x9170: 0x53E2,
                0x9171: 0x5009,
                0x9172: 0x55AA,
                0x9173: 0x58EE,
                0x9174: 0x594F,
                0x9175: 0x723D,
                0x9176: 0x5B8B,
                0x9177: 0x5C64,
                0x9178: 0x531D,
                0x9179: 0x60E3,
                0x917A: 0x60F3,
                0x917B: 0x635C,
                0x917C: 0x6383,
                0x917D: 0x633F,
                0x917E: 0x63BB,
                0x9180: 0x64CD,
                0x9181: 0x65E9,
                0x9182: 0x66F9,
                0x9183: 0x5DE3,
                0x9184: 0x69CD,
                0x9185: 0x69FD,
                0x9186: 0x6F15,
                0x9187: 0x71E5,
                0x9188: 0x4E89,
                0x9189: 0x75E9,
                0x918A: 0x76F8,
                0x918B: 0x7A93,
                0x918C: 0x7CDF,
                0x918D: 0x7DCF,
                0x918E: 0x7D9C,
                0x918F: 0x8061,
                0x9190: 0x8349,
                0x9191: 0x8358,
                0x9192: 0x846C,
                0x9193: 0x84BC,
                0x9194: 0x85FB,
                0x9195: 0x88C5,
                0x9196: 0x8D70,
                0x9197: 0x9001,
                0x9198: 0x906D,
                0x9199: 0x9397,
                0x919A: 0x971C,
                0x919B: 0x9A12,
                0x919C: 0x50CF,
                0x919D: 0x5897,
                0x919E: 0x618E,
                0x919F: 0x81D3,
                0x91A0: 0x8535,
                0x91A1: 0x8D08,
                0x91A2: 0x9020,
                0x91A3: 0x4FC3,
                0x91A4: 0x5074,
                0x91A5: 0x5247,
                0x91A6: 0x5373,
                0x91A7: 0x606F,
                0x91A8: 0x6349,
                0x91A9: 0x675F,
                0x91AA: 0x6E2C,
                0x91AB: 0x8DB3,
                0x91AC: 0x901F,
                0x91AD: 0x4FD7,
                0x91AE: 0x5C5E,
                0x91AF: 0x8CCA,
                0x91B0: 0x65CF,
                0x91B1: 0x7D9A,
                0x91B2: 0x5352,
                0x91B3: 0x8896,
                0x91B4: 0x5176,
                0x91B5: 0x63C3,
                0x91B6: 0x5B58,
                0x91B7: 0x5B6B,
                0x91B8: 0x5C0A,
                0x91B9: 0x640D,
                0x91BA: 0x6751,
                0x91BB: 0x905C,
                0x91BC: 0x4ED6,
                0x91BD: 0x591A,
                0x91BE: 0x592A,
                0x91BF: 0x6C70,
                0x91C0: 0x8A51,
                0x91C1: 0x553E,
                0x91C2: 0x5815,
                0x91C3: 0x59A5,
                0x91C4: 0x60F0,
                0x91C5: 0x6253,
                0x91C6: 0x67C1,
                0x91C7: 0x8235,
                0x91C8: 0x6955,
                0x91C9: 0x9640,
                0x91CA: 0x99C4,
                0x91CB: 0x9A28,
                0x91CC: 0x4F53,
                0x91CD: 0x5806,
                0x91CE: 0x5BFE,
                0x91CF: 0x8010,
                0x91D0: 0x5CB1,
                0x91D1: 0x5E2F,
                0x91D2: 0x5F85,
                0x91D3: 0x6020,
                0x91D4: 0x614B,
                0x91D5: 0x6234,
                0x91D6: 0x66FF,
                0x91D7: 0x6CF0,
                0x91D8: 0x6EDE,
                0x91D9: 0x80CE,
                0x91DA: 0x817F,
                0x91DB: 0x82D4,
                0x91DC: 0x888B,
                0x91DD: 0x8CB8,
                0x91DE: 0x9000,
                0x91DF: 0x902E,
                0x91E0: 0x968A,
                0x91E1: 0x9EDB,
                0x91E2: 0x9BDB,
                0x91E3: 0x4EE3,
                0x91E4: 0x53F0,
                0x91E5: 0x5927,
                0x91E6: 0x7B2C,
                0x91E7: 0x918D,
                0x91E8: 0x984C,
                0x91E9: 0x9DF9,
                0x91EA: 0x6EDD,
                0x91EB: 0x7027,
                0x91EC: 0x5353,
                0x91ED: 0x5544,
                0x91EE: 0x5B85,
                0x91EF: 0x6258,
                0x91F0: 0x629E,
                0x91F1: 0x62D3,
                0x91F2: 0x6CA2,
                0x91F3: 0x6FEF,
                0x91F4: 0x7422,
                0x91F5: 0x8A17,
                0x91F6: 0x9438,
                0x91F7: 0x6FC1,
                0x91F8: 0x8AFE,
                0x91F9: 0x8338,
                0x91FA: 0x51E7,
                0x91FB: 0x86F8,
                0x91FC: 0x53EA,
                0x9240: 0x53E9,
                0x9241: 0x4F46,
                0x9242: 0x9054,
                0x9243: 0x8FB0,
                0x9244: 0x596A,
                0x9245: 0x8131,
                0x9246: 0x5DFD,
                0x9247: 0x7AEA,
                0x9248: 0x8FBF,
                0x9249: 0x68DA,
                0x924A: 0x8C37,
                0x924B: 0x72F8,
                0x924C: 0x9C48,
                0x924D: 0x6A3D,
                0x924E: 0x8AB0,
                0x924F: 0x4E39,
                0x9250: 0x5358,
                0x9251: 0x5606,
                0x9252: 0x5766,
                0x9253: 0x62C5,
                0x9254: 0x63A2,
                0x9255: 0x65E6,
                0x9256: 0x6B4E,
                0x9257: 0x6DE1,
                0x9258: 0x6E5B,
                0x9259: 0x70AD,
                0x925A: 0x77ED,
                0x925B: 0x7AEF,
                0x925C: 0x7BAA,
                0x925D: 0x7DBB,
                0x925E: 0x803D,
                0x925F: 0x80C6,
                0x9260: 0x86CB,
                0x9261: 0x8A95,
                0x9262: 0x935B,
                0x9263: 0x56E3,
                0x9264: 0x58C7,
                0x9265: 0x5F3E,
                0x9266: 0x65AD,
                0x9267: 0x6696,
                0x9268: 0x6A80,
                0x9269: 0x6BB5,
                0x926A: 0x7537,
                0x926B: 0x8AC7,
                0x926C: 0x5024,
                0x926D: 0x77E5,
                0x926E: 0x5730,
                0x926F: 0x5F1B,
                0x9270: 0x6065,
                0x9271: 0x667A,
                0x9272: 0x6C60,
                0x9273: 0x75F4,
                0x9274: 0x7A1A,
                0x9275: 0x7F6E,
                0x9276: 0x81F4,
                0x9277: 0x8718,
                0x9278: 0x9045,
                0x9279: 0x99B3,
                0x927A: 0x7BC9,
                0x927B: 0x755C,
                0x927C: 0x7AF9,
                0x927D: 0x7B51,
                0x927E: 0x84C4,
                0x9280: 0x9010,
                0x9281: 0x79E9,
                0x9282: 0x7A92,
                0x9283: 0x8336,
                0x9284: 0x5AE1,
                0x9285: 0x7740,
                0x9286: 0x4E2D,
                0x9287: 0x4EF2,
                0x9288: 0x5B99,
                0x9289: 0x5FE0,
                0x928A: 0x62BD,
                0x928B: 0x663C,
                0x928C: 0x67F1,
                0x928D: 0x6CE8,
                0x928E: 0x866B,
                0x928F: 0x8877,
                0x9290: 0x8A3B,
                0x9291: 0x914E,
                0x9292: 0x92F3,
                0x9293: 0x99D0,
                0x9294: 0x6A17,
                0x9295: 0x7026,
                0x9296: 0x732A,
                0x9297: 0x82E7,
                0x9298: 0x8457,
                0x9299: 0x8CAF,
                0x929A: 0x4E01,
                0x929B: 0x5146,
                0x929C: 0x51CB,
                0x929D: 0x558B,
                0x929E: 0x5BF5,
                0x929F: 0x5E16,
                0x92A0: 0x5E33,
                0x92A1: 0x5E81,
                0x92A2: 0x5F14,
                0x92A3: 0x5F35,
                0x92A4: 0x5F6B,
                0x92A5: 0x5FB4,
                0x92A6: 0x61F2,
                0x92A7: 0x6311,
                0x92A8: 0x66A2,
                0x92A9: 0x671D,
                0x92AA: 0x6F6E,
                0x92AB: 0x7252,
                0x92AC: 0x753A,
                0x92AD: 0x773A,
                0x92AE: 0x8074,
                0x92AF: 0x8139,
                0x92B0: 0x8178,
                0x92B1: 0x8776,
                0x92B2: 0x8ABF,
                0x92B3: 0x8ADC,
                0x92B4: 0x8D85,
                0x92B5: 0x8DF3,
                0x92B6: 0x929A,
                0x92B7: 0x9577,
                0x92B8: 0x9802,
                0x92B9: 0x9CE5,
                0x92BA: 0x52C5,
                0x92BB: 0x6357,
                0x92BC: 0x76F4,
                0x92BD: 0x6715,
                0x92BE: 0x6C88,
                0x92BF: 0x73CD,
                0x92C0: 0x8CC3,
                0x92C1: 0x93AE,
                0x92C2: 0x9673,
                0x92C3: 0x6D25,
                0x92C4: 0x589C,
                0x92C5: 0x690E,
                0x92C6: 0x69CC,
                0x92C7: 0x8FFD,
                0x92C8: 0x939A,
                0x92C9: 0x75DB,
                0x92CA: 0x901A,
                0x92CB: 0x585A,
                0x92CC: 0x6802,
                0x92CD: 0x63B4,
                0x92CE: 0x69FB,
                0x92CF: 0x4F43,
                0x92D0: 0x6F2C,
                0x92D1: 0x67D8,
                0x92D2: 0x8FBB,
                0x92D3: 0x8526,
                0x92D4: 0x7DB4,
                0x92D5: 0x9354,
                0x92D6: 0x693F,
                0x92D7: 0x6F70,
                0x92D8: 0x576A,
                0x92D9: 0x58F7,
                0x92DA: 0x5B2C,
                0x92DB: 0x7D2C,
                0x92DC: 0x722A,
                0x92DD: 0x540A,
                0x92DE: 0x91E3,
                0x92DF: 0x9DB4,
                0x92E0: 0x4EAD,
                0x92E1: 0x4F4E,
                0x92E2: 0x505C,
                0x92E3: 0x5075,
                0x92E4: 0x5243,
                0x92E5: 0x8C9E,
                0x92E6: 0x5448,
                0x92E7: 0x5824,
                0x92E8: 0x5B9A,
                0x92E9: 0x5E1D,
                0x92EA: 0x5E95,
                0x92EB: 0x5EAD,
                0x92EC: 0x5EF7,
                0x92ED: 0x5F1F,
                0x92EE: 0x608C,
                0x92EF: 0x62B5,
                0x92F0: 0x633A,
                0x92F1: 0x63D0,
                0x92F2: 0x68AF,
                0x92F3: 0x6C40,
                0x92F4: 0x7887,
                0x92F5: 0x798E,
                0x92F6: 0x7A0B,
                0x92F7: 0x7DE0,
                0x92F8: 0x8247,
                0x92F9: 0x8A02,
                0x92FA: 0x8AE6,
                0x92FB: 0x8E44,
                0x92FC: 0x9013,
                0x9340: 0x90B8,
                0x9341: 0x912D,
                0x9342: 0x91D8,
                0x9343: 0x9F0E,
                0x9344: 0x6CE5,
                0x9345: 0x6458,
                0x9346: 0x64E2,
                0x9347: 0x6575,
                0x9348: 0x6EF4,
                0x9349: 0x7684,
                0x934A: 0x7B1B,
                0x934B: 0x9069,
                0x934C: 0x93D1,
                0x934D: 0x6EBA,
                0x934E: 0x54F2,
                0x934F: 0x5FB9,
                0x9350: 0x64A4,
                0x9351: 0x8F4D,
                0x9352: 0x8FED,
                0x9353: 0x9244,
                0x9354: 0x5178,
                0x9355: 0x586B,
                0x9356: 0x5929,
                0x9357: 0x5C55,
                0x9358: 0x5E97,
                0x9359: 0x6DFB,
                0x935A: 0x7E8F,
                0x935B: 0x751C,
                0x935C: 0x8CBC,
                0x935D: 0x8EE2,
                0x935E: 0x985B,
                0x935F: 0x70B9,
                0x9360: 0x4F1D,
                0x9361: 0x6BBF,
                0x9362: 0x6FB1,
                0x9363: 0x7530,
                0x9364: 0x96FB,
                0x9365: 0x514E,
                0x9366: 0x5410,
                0x9367: 0x5835,
                0x9368: 0x5857,
                0x9369: 0x59AC,
                0x936A: 0x5C60,
                0x936B: 0x5F92,
                0x936C: 0x6597,
                0x936D: 0x675C,
                0x936E: 0x6E21,
                0x936F: 0x767B,
                0x9370: 0x83DF,
                0x9371: 0x8CED,
                0x9372: 0x9014,
                0x9373: 0x90FD,
                0x9374: 0x934D,
                0x9375: 0x7825,
                0x9376: 0x783A,
                0x9377: 0x52AA,
                0x9378: 0x5EA6,
                0x9379: 0x571F,
                0x937A: 0x5974,
                0x937B: 0x6012,
                0x937C: 0x5012,
                0x937D: 0x515A,
                0x937E: 0x51AC,
                0x9380: 0x51CD,
                0x9381: 0x5200,
                0x9382: 0x5510,
                0x9383: 0x5854,
                0x9384: 0x5858,
                0x9385: 0x5957,
                0x9386: 0x5B95,
                0x9387: 0x5CF6,
                0x9388: 0x5D8B,
                0x9389: 0x60BC,
                0x938A: 0x6295,
                0x938B: 0x642D,
                0x938C: 0x6771,
                0x938D: 0x6843,
                0x938E: 0x68BC,
                0x938F: 0x68DF,
                0x9390: 0x76D7,
                0x9391: 0x6DD8,
                0x9392: 0x6E6F,
                0x9393: 0x6D9B,
                0x9394: 0x706F,
                0x9395: 0x71C8,
                0x9396: 0x5F53,
                0x9397: 0x75D8,
                0x9398: 0x7977,
                0x9399: 0x7B49,
                0x939A: 0x7B54,
                0x939B: 0x7B52,
                0x939C: 0x7CD6,
                0x939D: 0x7D71,
                0x939E: 0x5230,
                0x939F: 0x8463,
                0x93A0: 0x8569,
                0x93A1: 0x85E4,
                0x93A2: 0x8A0E,
                0x93A3: 0x8B04,
                0x93A4: 0x8C46,
                0x93A5: 0x8E0F,
                0x93A6: 0x9003,
                0x93A7: 0x900F,
                0x93A8: 0x9419,
                0x93A9: 0x9676,
                0x93AA: 0x982D,
                0x93AB: 0x9A30,
                0x93AC: 0x95D8,
                0x93AD: 0x50CD,
                0x93AE: 0x52D5,
                0x93AF: 0x540C,
                0x93B0: 0x5802,
                0x93B1: 0x5C0E,
                0x93B2: 0x61A7,
                0x93B3: 0x649E,
                0x93B4: 0x6D1E,
                0x93B5: 0x77B3,
                0x93B6: 0x7AE5,
                0x93B7: 0x80F4,
                0x93B8: 0x8404,
                0x93B9: 0x9053,
                0x93BA: 0x9285,
                0x93BB: 0x5CE0,
                0x93BC: 0x9D07,
                0x93BD: 0x533F,
                0x93BE: 0x5F97,
                0x93BF: 0x5FB3,
                0x93C0: 0x6D9C,
                0x93C1: 0x7279,
                0x93C2: 0x7763,
                0x93C3: 0x79BF,
                0x93C4: 0x7BE4,
                0x93C5: 0x6BD2,
                0x93C6: 0x72EC,
                0x93C7: 0x8AAD,
                0x93C8: 0x6803,
                0x93C9: 0x6A61,
                0x93CA: 0x51F8,
                0x93CB: 0x7A81,
                0x93CC: 0x6934,
                0x93CD: 0x5C4A,
                0x93CE: 0x9CF6,
                0x93CF: 0x82EB,
                0x93D0: 0x5BC5,
                0x93D1: 0x9149,
                0x93D2: 0x701E,
                0x93D3: 0x5678,
                0x93D4: 0x5C6F,
                0x93D5: 0x60C7,
                0x93D6: 0x6566,
                0x93D7: 0x6C8C,
                0x93D8: 0x8C5A,
                0x93D9: 0x9041,
                0x93DA: 0x9813,
                0x93DB: 0x5451,
                0x93DC: 0x66C7,
                0x93DD: 0x920D,
                0x93DE: 0x5948,
                0x93DF: 0x90A3,
                0x93E0: 0x5185,
                0x93E1: 0x4E4D,
                0x93E2: 0x51EA,
                0x93E3: 0x8599,
                0x93E4: 0x8B0E,
                0x93E5: 0x7058,
                0x93E6: 0x637A,
                0x93E7: 0x934B,
                0x93E8: 0x6962,
                0x93E9: 0x99B4,
                0x93EA: 0x7E04,
                0x93EB: 0x7577,
                0x93EC: 0x5357,
                0x93ED: 0x6960,
                0x93EE: 0x8EDF,
                0x93EF: 0x96E3,
                0x93F0: 0x6C5D,
                0x93F1: 0x4E8C,
                0x93F2: 0x5C3C,
                0x93F3: 0x5F10,
                0x93F4: 0x8FE9,
                0x93F5: 0x5302,
                0x93F6: 0x8CD1,
                0x93F7: 0x8089,
                0x93F8: 0x8679,
                0x93F9: 0x5EFF,
                0x93FA: 0x65E5,
                0x93FB: 0x4E73,
                0x93FC: 0x5165,
                0x9440: 0x5982,
                0x9441: 0x5C3F,
                0x9442: 0x97EE,
                0x9443: 0x4EFB,
                0x9444: 0x598A,
                0x9445: 0x5FCD,
                0x9446: 0x8A8D,
                0x9447: 0x6FE1,
                0x9448: 0x79B0,
                0x9449: 0x7962,
                0x944A: 0x5BE7,
                0x944B: 0x8471,
                0x944C: 0x732B,
                0x944D: 0x71B1,
                0x944E: 0x5E74,
                0x944F: 0x5FF5,
                0x9450: 0x637B,
                0x9451: 0x649A,
                0x9452: 0x71C3,
                0x9453: 0x7C98,
                0x9454: 0x4E43,
                0x9455: 0x5EFC,
                0x9456: 0x4E4B,
                0x9457: 0x57DC,
                0x9458: 0x56A2,
                0x9459: 0x60A9,
                0x945A: 0x6FC3,
                0x945B: 0x7D0D,
                0x945C: 0x80FD,
                0x945D: 0x8133,
                0x945E: 0x81BF,
                0x945F: 0x8FB2,
                0x9460: 0x8997,
                0x9461: 0x86A4,
                0x9462: 0x5DF4,
                0x9463: 0x628A,
                0x9464: 0x64AD,
                0x9465: 0x8987,
                0x9466: 0x6777,
                0x9467: 0x6CE2,
                0x9468: 0x6D3E,
                0x9469: 0x7436,
                0x946A: 0x7834,
                0x946B: 0x5A46,
                0x946C: 0x7F75,
                0x946D: 0x82AD,
                0x946E: 0x99AC,
                0x946F: 0x4FF3,
                0x9470: 0x5EC3,
                0x9471: 0x62DD,
                0x9472: 0x6392,
                0x9473: 0x6557,
                0x9474: 0x676F,
                0x9475: 0x76C3,
                0x9476: 0x724C,
                0x9477: 0x80CC,
                0x9478: 0x80BA,
                0x9479: 0x8F29,
                0x947A: 0x914D,
                0x947B: 0x500D,
                0x947C: 0x57F9,
                0x947D: 0x5A92,
                0x947E: 0x6885,
                0x9480: 0x6973,
                0x9481: 0x7164,
                0x9482: 0x72FD,
                0x9483: 0x8CB7,
                0x9484: 0x58F2,
                0x9485: 0x8CE0,
                0x9486: 0x966A,
                0x9487: 0x9019,
                0x9488: 0x877F,
                0x9489: 0x79E4,
                0x948A: 0x77E7,
                0x948B: 0x8429,
                0x948C: 0x4F2F,
                0x948D: 0x5265,
                0x948E: 0x535A,
                0x948F: 0x62CD,
                0x9490: 0x67CF,
                0x9491: 0x6CCA,
                0x9492: 0x767D,
                0x9493: 0x7B94,
                0x9494: 0x7C95,
                0x9495: 0x8236,
                0x9496: 0x8584,
                0x9497: 0x8FEB,
                0x9498: 0x66DD,
                0x9499: 0x6F20,
                0x949A: 0x7206,
                0x949B: 0x7E1B,
                0x949C: 0x83AB,
                0x949D: 0x99C1,
                0x949E: 0x9EA6,
                0x949F: 0x51FD,
                0x94A0: 0x7BB1,
                0x94A1: 0x7872,
                0x94A2: 0x7BB8,
                0x94A3: 0x8087,
                0x94A4: 0x7B48,
                0x94A5: 0x6AE8,
                0x94A6: 0x5E61,
                0x94A7: 0x808C,
                0x94A8: 0x7551,
                0x94A9: 0x7560,
                0x94AA: 0x516B,
                0x94AB: 0x9262,
                0x94AC: 0x6E8C,
                0x94AD: 0x767A,
                0x94AE: 0x9197,
                0x94AF: 0x9AEA,
                0x94B0: 0x4F10,
                0x94B1: 0x7F70,
                0x94B2: 0x629C,
                0x94B3: 0x7B4F,
                0x94B4: 0x95A5,
                0x94B5: 0x9CE9,
                0x94B6: 0x567A,
                0x94B7: 0x5859,
                0x94B8: 0x86E4,
                0x94B9: 0x96BC,
                0x94BA: 0x4F34,
                0x94BB: 0x5224,
                0x94BC: 0x534A,
                0x94BD: 0x53CD,
                0x94BE: 0x53DB,
                0x94BF: 0x5E06,
                0x94C0: 0x642C,
                0x94C1: 0x6591,
                0x94C2: 0x677F,
                0x94C3: 0x6C3E,
                0x94C4: 0x6C4E,
                0x94C5: 0x7248,
                0x94C6: 0x72AF,
                0x94C7: 0x73ED,
                0x94C8: 0x7554,
                0x94C9: 0x7E41,
                0x94CA: 0x822C,
                0x94CB: 0x85E9,
                0x94CC: 0x8CA9,
                0x94CD: 0x7BC4,
                0x94CE: 0x91C6,
                0x94CF: 0x7169,
                0x94D0: 0x9812,
                0x94D1: 0x98EF,
                0x94D2: 0x633D,
                0x94D3: 0x6669,
                0x94D4: 0x756A,
                0x94D5: 0x76E4,
                0x94D6: 0x78D0,
                0x94D7: 0x8543,
                0x94D8: 0x86EE,
                0x94D9: 0x532A,
                0x94DA: 0x5351,
                0x94DB: 0x5426,
                0x94DC: 0x5983,
                0x94DD: 0x5E87,
                0x94DE: 0x5F7C,
                0x94DF: 0x60B2,
                0x94E0: 0x6249,
                0x94E1: 0x6279,
                0x94E2: 0x62AB,
                0x94E3: 0x6590,
                0x94E4: 0x6BD4,
                0x94E5: 0x6CCC,
                0x94E6: 0x75B2,
                0x94E7: 0x76AE,
                0x94E8: 0x7891,
                0x94E9: 0x79D8,
                0x94EA: 0x7DCB,
                0x94EB: 0x7F77,
                0x94EC: 0x80A5,
                0x94ED: 0x88AB,
                0x94EE: 0x8AB9,
                0x94EF: 0x8CBB,
                0x94F0: 0x907F,
                0x94F1: 0x975E,
                0x94F2: 0x98DB,
                0x94F3: 0x6A0B,
                0x94F4: 0x7C38,
                0x94F5: 0x5099,
                0x94F6: 0x5C3E,
                0x94F7: 0x5FAE,
                0x94F8: 0x6787,
                0x94F9: 0x6BD8,
                0x94FA: 0x7435,
                0x94FB: 0x7709,
                0x94FC: 0x7F8E,
                0x9540: 0x9F3B,
                0x9541: 0x67CA,
                0x9542: 0x7A17,
                0x9543: 0x5339,
                0x9544: 0x758B,
                0x9545: 0x9AED,
                0x9546: 0x5F66,
                0x9547: 0x819D,
                0x9548: 0x83F1,
                0x9549: 0x8098,
                0x954A: 0x5F3C,
                0x954B: 0x5FC5,
                0x954C: 0x7562,
                0x954D: 0x7B46,
                0x954E: 0x903C,
                0x954F: 0x6867,
                0x9550: 0x59EB,
                0x9551: 0x5A9B,
                0x9552: 0x7D10,
                0x9553: 0x767E,
                0x9554: 0x8B2C,
                0x9555: 0x4FF5,
                0x9556: 0x5F6A,
                0x9557: 0x6A19,
                0x9558: 0x6C37,
                0x9559: 0x6F02,
                0x955A: 0x74E2,
                0x955B: 0x7968,
                0x955C: 0x8868,
                0x955D: 0x8A55,
                0x955E: 0x8C79,
                0x955F: 0x5EDF,
                0x9560: 0x63CF,
                0x9561: 0x75C5,
                0x9562: 0x79D2,
                0x9563: 0x82D7,
                0x9564: 0x9328,
                0x9565: 0x92F2,
                0x9566: 0x849C,
                0x9567: 0x86ED,
                0x9568: 0x9C2D,
                0x9569: 0x54C1,
                0x956A: 0x5F6C,
                0x956B: 0x658C,
                0x956C: 0x6D5C,
                0x956D: 0x7015,
                0x956E: 0x8CA7,
                0x956F: 0x8CD3,
                0x9570: 0x983B,
                0x9571: 0x654F,
                0x9572: 0x74F6,
                0x9573: 0x4E0D,
                0x9574: 0x4ED8,
                0x9575: 0x57E0,
                0x9576: 0x592B,
                0x9577: 0x5A66,
                0x9578: 0x5BCC,
                0x9579: 0x51A8,
                0x957A: 0x5E03,
                0x957B: 0x5E9C,
                0x957C: 0x6016,
                0x957D: 0x6276,
                0x957E: 0x6577,
                0x9580: 0x65A7,
                0x9581: 0x666E,
                0x9582: 0x6D6E,
                0x9583: 0x7236,
                0x9584: 0x7B26,
                0x9585: 0x8150,
                0x9586: 0x819A,
                0x9587: 0x8299,
                0x9588: 0x8B5C,
                0x9589: 0x8CA0,
                0x958A: 0x8CE6,
                0x958B: 0x8D74,
                0x958C: 0x961C,
                0x958D: 0x9644,
                0x958E: 0x4FAE,
                0x958F: 0x64AB,
                0x9590: 0x6B66,
                0x9591: 0x821E,
                0x9592: 0x8461,
                0x9593: 0x856A,
                0x9594: 0x90E8,
                0x9595: 0x5C01,
                0x9596: 0x6953,
                0x9597: 0x98A8,
                0x9598: 0x847A,
                0x9599: 0x8557,
                0x959A: 0x4F0F,
                0x959B: 0x526F,
                0x959C: 0x5FA9,
                0x959D: 0x5E45,
                0x959E: 0x670D,
                0x959F: 0x798F,
                0x95A0: 0x8179,
                0x95A1: 0x8907,
                0x95A2: 0x8986,
                0x95A3: 0x6DF5,
                0x95A4: 0x5F17,
                0x95A5: 0x6255,
                0x95A6: 0x6CB8,
                0x95A7: 0x4ECF,
                0x95A8: 0x7269,
                0x95A9: 0x9B92,
                0x95AA: 0x5206,
                0x95AB: 0x543B,
                0x95AC: 0x5674,
                0x95AD: 0x58B3,
                0x95AE: 0x61A4,
                0x95AF: 0x626E,
                0x95B0: 0x711A,
                0x95B1: 0x596E,
                0x95B2: 0x7C89,
                0x95B3: 0x7CDE,
                0x95B4: 0x7D1B,
                0x95B5: 0x96F0,
                0x95B6: 0x6587,
                0x95B7: 0x805E,
                0x95B8: 0x4E19,
                0x95B9: 0x4F75,
                0x95BA: 0x5175,
                0x95BB: 0x5840,
                0x95BC: 0x5E63,
                0x95BD: 0x5E73,
                0x95BE: 0x5F0A,
                0x95BF: 0x67C4,
                0x95C0: 0x4E26,
                0x95C1: 0x853D,
                0x95C2: 0x9589,
                0x95C3: 0x965B,
                0x95C4: 0x7C73,
                0x95C5: 0x9801,
                0x95C6: 0x50FB,
                0x95C7: 0x58C1,
                0x95C8: 0x7656,
                0x95C9: 0x78A7,
                0x95CA: 0x5225,
                0x95CB: 0x77A5,
                0x95CC: 0x8511,
                0x95CD: 0x7B86,
                0x95CE: 0x504F,
                0x95CF: 0x5909,
                0x95D0: 0x7247,
                0x95D1: 0x7BC7,
                0x95D2: 0x7DE8,
                0x95D3: 0x8FBA,
                0x95D4: 0x8FD4,
                0x95D5: 0x904D,
                0x95D6: 0x4FBF,
                0x95D7: 0x52C9,
                0x95D8: 0x5A29,
                0x95D9: 0x5F01,
                0x95DA: 0x97AD,
                0x95DB: 0x4FDD,
                0x95DC: 0x8217,
                0x95DD: 0x92EA,
                0x95DE: 0x5703,
                0x95DF: 0x6355,
                0x95E0: 0x6B69,
                0x95E1: 0x752B,
                0x95E2: 0x88DC,
                0x95E3: 0x8F14,
                0x95E4: 0x7A42,
                0x95E5: 0x52DF,
                0x95E6: 0x5893,
                0x95E7: 0x6155,
                0x95E8: 0x620A,
                0x95E9: 0x66AE,
                0x95EA: 0x6BCD,
                0x95EB: 0x7C3F,
                0x95EC: 0x83E9,
                0x95ED: 0x5023,
                0x95EE: 0x4FF8,
                0x95EF: 0x5305,
                0x95F0: 0x5446,
                0x95F1: 0x5831,
                0x95F2: 0x5949,
                0x95F3: 0x5B9D,
                0x95F4: 0x5CF0,
                0x95F5: 0x5CEF,
                0x95F6: 0x5D29,
                0x95F7: 0x5E96,
                0x95F8: 0x62B1,
                0x95F9: 0x6367,
                0x95FA: 0x653E,
                0x95FB: 0x65B9,
                0x95FC: 0x670B,
                0x9640: 0x6CD5,
                0x9641: 0x6CE1,
                0x9642: 0x70F9,
                0x9643: 0x7832,
                0x9644: 0x7E2B,
                0x9645: 0x80DE,
                0x9646: 0x82B3,
                0x9647: 0x840C,
                0x9648: 0x84EC,
                0x9649: 0x8702,
                0x964A: 0x8912,
                0x964B: 0x8A2A,
                0x964C: 0x8C4A,
                0x964D: 0x90A6,
                0x964E: 0x92D2,
                0x964F: 0x98FD,
                0x9650: 0x9CF3,
                0x9651: 0x9D6C,
                0x9652: 0x4E4F,
                0x9653: 0x4EA1,
                0x9654: 0x508D,
                0x9655: 0x5256,
                0x9656: 0x574A,
                0x9657: 0x59A8,
                0x9658: 0x5E3D,
                0x9659: 0x5FD8,
                0x965A: 0x5FD9,
                0x965B: 0x623F,
                0x965C: 0x66B4,
                0x965D: 0x671B,
                0x965E: 0x67D0,
                0x965F: 0x68D2,
                0x9660: 0x5192,
                0x9661: 0x7D21,
                0x9662: 0x80AA,
                0x9663: 0x81A8,
                0x9664: 0x8B00,
                0x9665: 0x8C8C,
                0x9666: 0x8CBF,
                0x9667: 0x927E,
                0x9668: 0x9632,
                0x9669: 0x5420,
                0x966A: 0x982C,
                0x966B: 0x5317,
                0x966C: 0x50D5,
                0x966D: 0x535C,
                0x966E: 0x58A8,
                0x966F: 0x64B2,
                0x9670: 0x6734,
                0x9671: 0x7267,
                0x9672: 0x7766,
                0x9673: 0x7A46,
                0x9674: 0x91E6,
                0x9675: 0x52C3,
                0x9676: 0x6CA1,
                0x9677: 0x6B86,
                0x9678: 0x5800,
                0x9679: 0x5E4C,
                0x967A: 0x5954,
                0x967B: 0x672C,
                0x967C: 0x7FFB,
                0x967D: 0x51E1,
                0x967E: 0x76C6,
                0x9680: 0x6469,
                0x9681: 0x78E8,
                0x9682: 0x9B54,
                0x9683: 0x9EBB,
                0x9684: 0x57CB,
                0x9685: 0x59B9,
                0x9686: 0x6627,
                0x9687: 0x679A,
                0x9688: 0x6BCE,
                0x9689: 0x54E9,
                0x968A: 0x69D9,
                0x968B: 0x5E55,
                0x968C: 0x819C,
                0x968D: 0x6795,
                0x968E: 0x9BAA,
                0x968F: 0x67FE,
                0x9690: 0x9C52,
                0x9691: 0x685D,
                0x9692: 0x4EA6,
                0x9693: 0x4FE3,
                0x9694: 0x53C8,
                0x9695: 0x62B9,
                0x9696: 0x672B,
                0x9697: 0x6CAB,
                0x9698: 0x8FC4,
                0x9699: 0x4FAD,
                0x969A: 0x7E6D,
                0x969B: 0x9EBF,
                0x969C: 0x4E07,
                0x969D: 0x6162,
                0x969E: 0x6E80,
                0x969F: 0x6F2B,
                0x96A0: 0x8513,
                0x96A1: 0x5473,
                0x96A2: 0x672A,
                0x96A3: 0x9B45,
                0x96A4: 0x5DF3,
                0x96A5: 0x7B95,
                0x96A6: 0x5CAC,
                0x96A7: 0x5BC6,
                0x96A8: 0x871C,
                0x96A9: 0x6E4A,
                0x96AA: 0x84D1,
                0x96AB: 0x7A14,
                0x96AC: 0x8108,
                0x96AD: 0x5999,
                0x96AE: 0x7C8D,
                0x96AF: 0x6C11,
                0x96B0: 0x7720,
                0x96B1: 0x52D9,
                0x96B2: 0x5922,
                0x96B3: 0x7121,
                0x96B4: 0x725F,
                0x96B5: 0x77DB,
                0x96B6: 0x9727,
                0x96B7: 0x9D61,
                0x96B8: 0x690B,
                0x96B9: 0x5A7F,
                0x96BA: 0x5A18,
                0x96BB: 0x51A5,
                0x96BC: 0x540D,
                0x96BD: 0x547D,
                0x96BE: 0x660E,
                0x96BF: 0x76DF,
                0x96C0: 0x8FF7,
                0x96C1: 0x9298,
                0x96C2: 0x9CF4,
                0x96C3: 0x59EA,
                0x96C4: 0x725D,
                0x96C5: 0x6EC5,
                0x96C6: 0x514D,
                0x96C7: 0x68C9,
                0x96C8: 0x7DBF,
                0x96C9: 0x7DEC,
                0x96CA: 0x9762,
                0x96CB: 0x9EBA,
                0x96CC: 0x6478,
                0x96CD: 0x6A21,
                0x96CE: 0x8302,
                0x96CF: 0x5984,
                0x96D0: 0x5B5F,
                0x96D1: 0x6BDB,
                0x96D2: 0x731B,
                0x96D3: 0x76F2,
                0x96D4: 0x7DB2,
                0x96D5: 0x8017,
                0x96D6: 0x8499,
                0x96D7: 0x5132,
                0x96D8: 0x6728,
                0x96D9: 0x9ED9,
                0x96DA: 0x76EE,
                0x96DB: 0x6762,
                0x96DC: 0x52FF,
                0x96DD: 0x9905,
                0x96DE: 0x5C24,
                0x96DF: 0x623B,
                0x96E0: 0x7C7E,
                0x96E1: 0x8CB0,
                0x96E2: 0x554F,
                0x96E3: 0x60B6,
                0x96E4: 0x7D0B,
                0x96E5: 0x9580,
                0x96E6: 0x5301,
                0x96E7: 0x4E5F,
                0x96E8: 0x51B6,
                0x96E9: 0x591C,
                0x96EA: 0x723A,
                0x96EB: 0x8036,
                0x96EC: 0x91CE,
                0x96ED: 0x5F25,
                0x96EE: 0x77E2,
                0x96EF: 0x5384,
                0x96F0: 0x5F79,
                0x96F1: 0x7D04,
                0x96F2: 0x85AC,
                0x96F3: 0x8A33,
                0x96F4: 0x8E8D,
                0x96F5: 0x9756,
                0x96F6: 0x67F3,
                0x96F7: 0x85AE,
                0x96F8: 0x9453,
                0x96F9: 0x6109,
                0x96FA: 0x6108,
                0x96FB: 0x6CB9,
                0x96FC: 0x7652,
                0x9740: 0x8AED,
                0x9741: 0x8F38,
                0x9742: 0x552F,
                0x9743: 0x4F51,
                0x9744: 0x512A,
                0x9745: 0x52C7,
                0x9746: 0x53CB,
                0x9747: 0x5BA5,
                0x9748: 0x5E7D,
                0x9749: 0x60A0,
                0x974A: 0x6182,
                0x974B: 0x63D6,
                0x974C: 0x6709,
                0x974D: 0x67DA,
                0x974E: 0x6E67,
                0x974F: 0x6D8C,
                0x9750: 0x7336,
                0x9751: 0x7337,
                0x9752: 0x7531,
                0x9753: 0x7950,
                0x9754: 0x88D5,
                0x9755: 0x8A98,
                0x9756: 0x904A,
                0x9757: 0x9091,
                0x9758: 0x90F5,
                0x9759: 0x96C4,
                0x975A: 0x878D,
                0x975B: 0x5915,
                0x975C: 0x4E88,
                0x975D: 0x4F59,
                0x975E: 0x4E0E,
                0x975F: 0x8A89,
                0x9760: 0x8F3F,
                0x9761: 0x9810,
                0x9762: 0x50AD,
                0x9763: 0x5E7C,
                0x9764: 0x5996,
                0x9765: 0x5BB9,
                0x9766: 0x5EB8,
                0x9767: 0x63DA,
                0x9768: 0x63FA,
                0x9769: 0x64C1,
                0x976A: 0x66DC,
                0x976B: 0x694A,
                0x976C: 0x69D8,
                0x976D: 0x6D0B,
                0x976E: 0x6EB6,
                0x976F: 0x7194,
                0x9770: 0x7528,
                0x9771: 0x7AAF,
                0x9772: 0x7F8A,
                0x9773: 0x8000,
                0x9774: 0x8449,
                0x9775: 0x84C9,
                0x9776: 0x8981,
                0x9777: 0x8B21,
                0x9778: 0x8E0A,
                0x9779: 0x9065,
                0x977A: 0x967D,
                0x977B: 0x990A,
                0x977C: 0x617E,
                0x977D: 0x6291,
                0x977E: 0x6B32,
                0x9780: 0x6C83,
                0x9781: 0x6D74,
                0x9782: 0x7FCC,
                0x9783: 0x7FFC,
                0x9784: 0x6DC0,
                0x9785: 0x7F85,
                0x9786: 0x87BA,
                0x9787: 0x88F8,
                0x9788: 0x6765,
                0x9789: 0x83B1,
                0x978A: 0x983C,
                0x978B: 0x96F7,
                0x978C: 0x6D1B,
                0x978D: 0x7D61,
                0x978E: 0x843D,
                0x978F: 0x916A,
                0x9790: 0x4E71,
                0x9791: 0x5375,
                0x9792: 0x5D50,
                0x9793: 0x6B04,
                0x9794: 0x6FEB,
                0x9795: 0x85CD,
                0x9796: 0x862D,
                0x9797: 0x89A7,
                0x9798: 0x5229,
                0x9799: 0x540F,
                0x979A: 0x5C65,
                0x979B: 0x674E,
                0x979C: 0x68A8,
                0x979D: 0x7406,
                0x979E: 0x7483,
                0x979F: 0x75E2,
                0x97A0: 0x88CF,
                0x97A1: 0x88E1,
                0x97A2: 0x91CC,
                0x97A3: 0x96E2,
                0x97A4: 0x9678,
                0x97A5: 0x5F8B,
                0x97A6: 0x7387,
                0x97A7: 0x7ACB,
                0x97A8: 0x844E,
                0x97A9: 0x63A0,
                0x97AA: 0x7565,
                0x97AB: 0x5289,
                0x97AC: 0x6D41,
                0x97AD: 0x6E9C,
                0x97AE: 0x7409,
                0x97AF: 0x7559,
                0x97B0: 0x786B,
                0x97B1: 0x7C92,
                0x97B2: 0x9686,
                0x97B3: 0x7ADC,
                0x97B4: 0x9F8D,
                0x97B5: 0x4FB6,
                0x97B6: 0x616E,
                0x97B7: 0x65C5,
                0x97B8: 0x865C,
                0x97B9: 0x4E86,
                0x97BA: 0x4EAE,
                0x97BB: 0x50DA,
                0x97BC: 0x4E21,
                0x97BD: 0x51CC,
                0x97BE: 0x5BEE,
                0x97BF: 0x6599,
                0x97C0: 0x6881,
                0x97C1: 0x6DBC,
                0x97C2: 0x731F,
                0x97C3: 0x7642,
                0x97C4: 0x77AD,
                0x97C5: 0x7A1C,
                0x97C6: 0x7CE7,
                0x97C7: 0x826F,
                0x97C8: 0x8AD2,
                0x97C9: 0x907C,
                0x97CA: 0x91CF,
                0x97CB: 0x9675,
                0x97CC: 0x9818,
                0x97CD: 0x529B,
                0x97CE: 0x7DD1,
                0x97CF: 0x502B,
                0x97D0: 0x5398,
                0x97D1: 0x6797,
                0x97D2: 0x6DCB,
                0x97D3: 0x71D0,
                0x97D4: 0x7433,
                0x97D5: 0x81E8,
                0x97D6: 0x8F2A,
                0x97D7: 0x96A3,
                0x97D8: 0x9C57,
                0x97D9: 0x9E9F,
                0x97DA: 0x7460,
                0x97DB: 0x5841,
                0x97DC: 0x6D99,
                0x97DD: 0x7D2F,
                0x97DE: 0x985E,
                0x97DF: 0x4EE4,
                0x97E0: 0x4F36,
                0x97E1: 0x4F8B,
                0x97E2: 0x51B7,
                0x97E3: 0x52B1,
                0x97E4: 0x5DBA,
                0x97E5: 0x601C,
                0x97E6: 0x73B2,
                0x97E7: 0x793C,
                0x97E8: 0x82D3,
                0x97E9: 0x9234,
                0x97EA: 0x96B7,
                0x97EB: 0x96F6,
                0x97EC: 0x970A,
                0x97ED: 0x9E97,
                0x97EE: 0x9F62,
                0x97EF: 0x66A6,
                0x97F0: 0x6B74,
                0x97F1: 0x5217,
                0x97F2: 0x52A3,
                0x97F3: 0x70C8,
                0x97F4: 0x88C2,
                0x97F5: 0x5EC9,
                0x97F6: 0x604B,
                0x97F7: 0x6190,
                0x97F8: 0x6F23,
                0x97F9: 0x7149,
                0x97FA: 0x7C3E,
                0x97FB: 0x7DF4,
                0x97FC: 0x806F,
                0x9840: 0x84EE,
                0x9841: 0x9023,
                0x9842: 0x932C,
                0x9843: 0x5442,
                0x9844: 0x9B6F,
                0x9845: 0x6AD3,
                0x9846: 0x7089,
                0x9847: 0x8CC2,
                0x9848: 0x8DEF,
                0x9849: 0x9732,
                0x984A: 0x52B4,
                0x984B: 0x5A41,
                0x984C: 0x5ECA,
                0x984D: 0x5F04,
                0x984E: 0x6717,
                0x984F: 0x697C,
                0x9850: 0x6994,
                0x9851: 0x6D6A,
                0x9852: 0x6F0F,
                0x9853: 0x7262,
                0x9854: 0x72FC,
                0x9855: 0x7BED,
                0x9856: 0x8001,
                0x9857: 0x807E,
                0x9858: 0x874B,
                0x9859: 0x90CE,
                0x985A: 0x516D,
                0x985B: 0x9E93,
                0x985C: 0x7984,
                0x985D: 0x808B,
                0x985E: 0x9332,
                0x985F: 0x8AD6,
                0x9860: 0x502D,
                0x9861: 0x548C,
                0x9862: 0x8A71,
                0x9863: 0x6B6A,
                0x9864: 0x8CC4,
                0x9865: 0x8107,
                0x9866: 0x60D1,
                0x9867: 0x67A0,
                0x9868: 0x9DF2,
                0x9869: 0x4E99,
                0x986A: 0x4E98,
                0x986B: 0x9C10,
                0x986C: 0x8A6B,
                0x986D: 0x85C1,
                0x986E: 0x8568,
                0x986F: 0x6900,
                0x9870: 0x6E7E,
                0x9871: 0x7897,
                0x9872: 0x8155,
                0x989F: 0x5F0C,
                0x98A0: 0x4E10,
                0x98A1: 0x4E15,
                0x98A2: 0x4E2A,
                0x98A3: 0x4E31,
                0x98A4: 0x4E36,
                0x98A5: 0x4E3C,
                0x98A6: 0x4E3F,
                0x98A7: 0x4E42,
                0x98A8: 0x4E56,
                0x98A9: 0x4E58,
                0x98AA: 0x4E82,
                0x98AB: 0x4E85,
                0x98AC: 0x8C6B,
                0x98AD: 0x4E8A,
                0x98AE: 0x8212,
                0x98AF: 0x5F0D,
                0x98B0: 0x4E8E,
                0x98B1: 0x4E9E,
                0x98B2: 0x4E9F,
                0x98B3: 0x4EA0,
                0x98B4: 0x4EA2,
                0x98B5: 0x4EB0,
                0x98B6: 0x4EB3,
                0x98B7: 0x4EB6,
                0x98B8: 0x4ECE,
                0x98B9: 0x4ECD,
                0x98BA: 0x4EC4,
                0x98BB: 0x4EC6,
                0x98BC: 0x4EC2,
                0x98BD: 0x4ED7,
                0x98BE: 0x4EDE,
                0x98BF: 0x4EED,
                0x98C0: 0x4EDF,
                0x98C1: 0x4EF7,
                0x98C2: 0x4F09,
                0x98C3: 0x4F5A,
                0x98C4: 0x4F30,
                0x98C5: 0x4F5B,
                0x98C6: 0x4F5D,
                0x98C7: 0x4F57,
                0x98C8: 0x4F47,
                0x98C9: 0x4F76,
                0x98CA: 0x4F88,
                0x98CB: 0x4F8F,
                0x98CC: 0x4F98,
                0x98CD: 0x4F7B,
                0x98CE: 0x4F69,
                0x98CF: 0x4F70,
                0x98D0: 0x4F91,
                0x98D1: 0x4F6F,
                0x98D2: 0x4F86,
                0x98D3: 0x4F96,
                0x98D4: 0x5118,
                0x98D5: 0x4FD4,
                0x98D6: 0x4FDF,
                0x98D7: 0x4FCE,
                0x98D8: 0x4FD8,
                0x98D9: 0x4FDB,
                0x98DA: 0x4FD1,
                0x98DB: 0x4FDA,
                0x98DC: 0x4FD0,
                0x98DD: 0x4FE4,
                0x98DE: 0x4FE5,
                0x98DF: 0x501A,
                0x98E0: 0x5028,
                0x98E1: 0x5014,
                0x98E2: 0x502A,
                0x98E3: 0x5025,
                0x98E4: 0x5005,
                0x98E5: 0x4F1C,
                0x98E6: 0x4FF6,
                0x98E7: 0x5021,
                0x98E8: 0x5029,
                0x98E9: 0x502C,
                0x98EA: 0x4FFE,
                0x98EB: 0x4FEF,
                0x98EC: 0x5011,
                0x98ED: 0x5006,
                0x98EE: 0x5043,
                0x98EF: 0x5047,
                0x98F0: 0x6703,
                0x98F1: 0x5055,
                0x98F2: 0x5050,
                0x98F3: 0x5048,
                0x98F4: 0x505A,
                0x98F5: 0x5056,
                0x98F6: 0x506C,
                0x98F7: 0x5078,
                0x98F8: 0x5080,
                0x98F9: 0x509A,
                0x98FA: 0x5085,
                0x98FB: 0x50B4,
                0x98FC: 0x50B2,
                0x9940: 0x50C9,
                0x9941: 0x50CA,
                0x9942: 0x50B3,
                0x9943: 0x50C2,
                0x9944: 0x50D6,
                0x9945: 0x50DE,
                0x9946: 0x50E5,
                0x9947: 0x50ED,
                0x9948: 0x50E3,
                0x9949: 0x50EE,
                0x994A: 0x50F9,
                0x994B: 0x50F5,
                0x994C: 0x5109,
                0x994D: 0x5101,
                0x994E: 0x5102,
                0x994F: 0x5116,
                0x9950: 0x5115,
                0x9951: 0x5114,
                0x9952: 0x511A,
                0x9953: 0x5121,
                0x9954: 0x513A,
                0x9955: 0x5137,
                0x9956: 0x513C,
                0x9957: 0x513B,
                0x9958: 0x513F,
                0x9959: 0x5140,
                0x995A: 0x5152,
                0x995B: 0x514C,
                0x995C: 0x5154,
                0x995D: 0x5162,
                0x995E: 0x7AF8,
                0x995F: 0x5169,
                0x9960: 0x516A,
                0x9961: 0x516E,
                0x9962: 0x5180,
                0x9963: 0x5182,
                0x9964: 0x56D8,
                0x9965: 0x518C,
                0x9966: 0x5189,
                0x9967: 0x518F,
                0x9968: 0x5191,
                0x9969: 0x5193,
                0x996A: 0x5195,
                0x996B: 0x5196,
                0x996C: 0x51A4,
                0x996D: 0x51A6,
                0x996E: 0x51A2,
                0x996F: 0x51A9,
                0x9970: 0x51AA,
                0x9971: 0x51AB,
                0x9972: 0x51B3,
                0x9973: 0x51B1,
                0x9974: 0x51B2,
                0x9975: 0x51B0,
                0x9976: 0x51B5,
                0x9977: 0x51BD,
                0x9978: 0x51C5,
                0x9979: 0x51C9,
                0x997A: 0x51DB,
                0x997B: 0x51E0,
                0x997C: 0x8655,
                0x997D: 0x51E9,
                0x997E: 0x51ED,
                0x9980: 0x51F0,
                0x9981: 0x51F5,
                0x9982: 0x51FE,
                0x9983: 0x5204,
                0x9984: 0x520B,
                0x9985: 0x5214,
                0x9986: 0x520E,
                0x9987: 0x5227,
                0x9988: 0x522A,
                0x9989: 0x522E,
                0x998A: 0x5233,
                0x998B: 0x5239,
                0x998C: 0x524F,
                0x998D: 0x5244,
                0x998E: 0x524B,
                0x998F: 0x524C,
                0x9990: 0x525E,
                0x9991: 0x5254,
                0x9992: 0x526A,
                0x9993: 0x5274,
                0x9994: 0x5269,
                0x9995: 0x5273,
                0x9996: 0x527F,
                0x9997: 0x527D,
                0x9998: 0x528D,
                0x9999: 0x5294,
                0x999A: 0x5292,
                0x999B: 0x5271,
                0x999C: 0x5288,
                0x999D: 0x5291,
                0x999E: 0x8FA8,
                0x999F: 0x8FA7,
                0x99A0: 0x52AC,
                0x99A1: 0x52AD,
                0x99A2: 0x52BC,
                0x99A3: 0x52B5,
                0x99A4: 0x52C1,
                0x99A5: 0x52CD,
                0x99A6: 0x52D7,
                0x99A7: 0x52DE,
                0x99A8: 0x52E3,
                0x99A9: 0x52E6,
                0x99AA: 0x98ED,
                0x99AB: 0x52E0,
                0x99AC: 0x52F3,
                0x99AD: 0x52F5,
                0x99AE: 0x52F8,
                0x99AF: 0x52F9,
                0x99B0: 0x5306,
                0x99B1: 0x5308,
                0x99B2: 0x7538,
                0x99B3: 0x530D,
                0x99B4: 0x5310,
                0x99B5: 0x530F,
                0x99B6: 0x5315,
                0x99B7: 0x531A,
                0x99B8: 0x5323,
                0x99B9: 0x532F,
                0x99BA: 0x5331,
                0x99BB: 0x5333,
                0x99BC: 0x5338,
                0x99BD: 0x5340,
                0x99BE: 0x5346,
                0x99BF: 0x5345,
                0x99C0: 0x4E17,
                0x99C1: 0x5349,
                0x99C2: 0x534D,
                0x99C3: 0x51D6,
                0x99C4: 0x535E,
                0x99C5: 0x5369,
                0x99C6: 0x536E,
                0x99C7: 0x5918,
                0x99C8: 0x537B,
                0x99C9: 0x5377,
                0x99CA: 0x5382,
                0x99CB: 0x5396,
                0x99CC: 0x53A0,
                0x99CD: 0x53A6,
                0x99CE: 0x53A5,
                0x99CF: 0x53AE,
                0x99D0: 0x53B0,
                0x99D1: 0x53B6,
                0x99D2: 0x53C3,
                0x99D3: 0x7C12,
                0x99D4: 0x96D9,
                0x99D5: 0x53DF,
                0x99D6: 0x66FC,
                0x99D7: 0x71EE,
                0x99D8: 0x53EE,
                0x99D9: 0x53E8,
                0x99DA: 0x53ED,
                0x99DB: 0x53FA,
                0x99DC: 0x5401,
                0x99DD: 0x543D,
                0x99DE: 0x5440,
                0x99DF: 0x542C,
                0x99E0: 0x542D,
                0x99E1: 0x543C,
                0x99E2: 0x542E,
                0x99E3: 0x5436,
                0x99E4: 0x5429,
                0x99E5: 0x541D,
                0x99E6: 0x544E,
                0x99E7: 0x548F,
                0x99E8: 0x5475,
                0x99E9: 0x548E,
                0x99EA: 0x545F,
                0x99EB: 0x5471,
                0x99EC: 0x5477,
                0x99ED: 0x5470,
                0x99EE: 0x5492,
                0x99EF: 0x547B,
                0x99F0: 0x5480,
                0x99F1: 0x5476,
                0x99F2: 0x5484,
                0x99F3: 0x5490,
                0x99F4: 0x5486,
                0x99F5: 0x54C7,
                0x99F6: 0x54A2,
                0x99F7: 0x54B8,
                0x99F8: 0x54A5,
                0x99F9: 0x54AC,
                0x99FA: 0x54C4,
                0x99FB: 0x54C8,
                0x99FC: 0x54A8,
                0x9A40: 0x54AB,
                0x9A41: 0x54C2,
                0x9A42: 0x54A4,
                0x9A43: 0x54BE,
                0x9A44: 0x54BC,
                0x9A45: 0x54D8,
                0x9A46: 0x54E5,
                0x9A47: 0x54E6,
                0x9A48: 0x550F,
                0x9A49: 0x5514,
                0x9A4A: 0x54FD,
                0x9A4B: 0x54EE,
                0x9A4C: 0x54ED,
                0x9A4D: 0x54FA,
                0x9A4E: 0x54E2,
                0x9A4F: 0x5539,
                0x9A50: 0x5540,
                0x9A51: 0x5563,
                0x9A52: 0x554C,
                0x9A53: 0x552E,
                0x9A54: 0x555C,
                0x9A55: 0x5545,
                0x9A56: 0x5556,
                0x9A57: 0x5557,
                0x9A58: 0x5538,
                0x9A59: 0x5533,
                0x9A5A: 0x555D,
                0x9A5B: 0x5599,
                0x9A5C: 0x5580,
                0x9A5D: 0x54AF,
                0x9A5E: 0x558A,
                0x9A5F: 0x559F,
                0x9A60: 0x557B,
                0x9A61: 0x557E,
                0x9A62: 0x5598,
                0x9A63: 0x559E,
                0x9A64: 0x55AE,
                0x9A65: 0x557C,
                0x9A66: 0x5583,
                0x9A67: 0x55A9,
                0x9A68: 0x5587,
                0x9A69: 0x55A8,
                0x9A6A: 0x55DA,
                0x9A6B: 0x55C5,
                0x9A6C: 0x55DF,
                0x9A6D: 0x55C4,
                0x9A6E: 0x55DC,
                0x9A6F: 0x55E4,
                0x9A70: 0x55D4,
                0x9A71: 0x5614,
                0x9A72: 0x55F7,
                0x9A73: 0x5616,
                0x9A74: 0x55FE,
                0x9A75: 0x55FD,
                0x9A76: 0x561B,
                0x9A77: 0x55F9,
                0x9A78: 0x564E,
                0x9A79: 0x5650,
                0x9A7A: 0x71DF,
                0x9A7B: 0x5634,
                0x9A7C: 0x5636,
                0x9A7D: 0x5632,
                0x9A7E: 0x5638,
                0x9A80: 0x566B,
                0x9A81: 0x5664,
                0x9A82: 0x562F,
                0x9A83: 0x566C,
                0x9A84: 0x566A,
                0x9A85: 0x5686,
                0x9A86: 0x5680,
                0x9A87: 0x568A,
                0x9A88: 0x56A0,
                0x9A89: 0x5694,
                0x9A8A: 0x568F,
                0x9A8B: 0x56A5,
                0x9A8C: 0x56AE,
                0x9A8D: 0x56B6,
                0x9A8E: 0x56B4,
                0x9A8F: 0x56C2,
                0x9A90: 0x56BC,
                0x9A91: 0x56C1,
                0x9A92: 0x56C3,
                0x9A93: 0x56C0,
                0x9A94: 0x56C8,
                0x9A95: 0x56CE,
                0x9A96: 0x56D1,
                0x9A97: 0x56D3,
                0x9A98: 0x56D7,
                0x9A99: 0x56EE,
                0x9A9A: 0x56F9,
                0x9A9B: 0x5700,
                0x9A9C: 0x56FF,
                0x9A9D: 0x5704,
                0x9A9E: 0x5709,
                0x9A9F: 0x5708,
                0x9AA0: 0x570B,
                0x9AA1: 0x570D,
                0x9AA2: 0x5713,
                0x9AA3: 0x5718,
                0x9AA4: 0x5716,
                0x9AA5: 0x55C7,
                0x9AA6: 0x571C,
                0x9AA7: 0x5726,
                0x9AA8: 0x5737,
                0x9AA9: 0x5738,
                0x9AAA: 0x574E,
                0x9AAB: 0x573B,
                0x9AAC: 0x5740,
                0x9AAD: 0x574F,
                0x9AAE: 0x5769,
                0x9AAF: 0x57C0,
                0x9AB0: 0x5788,
                0x9AB1: 0x5761,
                0x9AB2: 0x577F,
                0x9AB3: 0x5789,
                0x9AB4: 0x5793,
                0x9AB5: 0x57A0,
                0x9AB6: 0x57B3,
                0x9AB7: 0x57A4,
                0x9AB8: 0x57AA,
                0x9AB9: 0x57B0,
                0x9ABA: 0x57C3,
                0x9ABB: 0x57C6,
                0x9ABC: 0x57D4,
                0x9ABD: 0x57D2,
                0x9ABE: 0x57D3,
                0x9ABF: 0x580A,
                0x9AC0: 0x57D6,
                0x9AC1: 0x57E3,
                0x9AC2: 0x580B,
                0x9AC3: 0x5819,
                0x9AC4: 0x581D,
                0x9AC5: 0x5872,
                0x9AC6: 0x5821,
                0x9AC7: 0x5862,
                0x9AC8: 0x584B,
                0x9AC9: 0x5870,
                0x9ACA: 0x6BC0,
                0x9ACB: 0x5852,
                0x9ACC: 0x583D,
                0x9ACD: 0x5879,
                0x9ACE: 0x5885,
                0x9ACF: 0x58B9,
                0x9AD0: 0x589F,
                0x9AD1: 0x58AB,
                0x9AD2: 0x58BA,
                0x9AD3: 0x58DE,
                0x9AD4: 0x58BB,
                0x9AD5: 0x58B8,
                0x9AD6: 0x58AE,
                0x9AD7: 0x58C5,
                0x9AD8: 0x58D3,
                0x9AD9: 0x58D1,
                0x9ADA: 0x58D7,
                0x9ADB: 0x58D9,
                0x9ADC: 0x58D8,
                0x9ADD: 0x58E5,
                0x9ADE: 0x58DC,
                0x9ADF: 0x58E4,
                0x9AE0: 0x58DF,
                0x9AE1: 0x58EF,
                0x9AE2: 0x58FA,
                0x9AE3: 0x58F9,
                0x9AE4: 0x58FB,
                0x9AE5: 0x58FC,
                0x9AE6: 0x58FD,
                0x9AE7: 0x5902,
                0x9AE8: 0x590A,
                0x9AE9: 0x5910,
                0x9AEA: 0x591B,
                0x9AEB: 0x68A6,
                0x9AEC: 0x5925,
                0x9AED: 0x592C,
                0x9AEE: 0x592D,
                0x9AEF: 0x5932,
                0x9AF0: 0x5938,
                0x9AF1: 0x593E,
                0x9AF2: 0x7AD2,
                0x9AF3: 0x5955,
                0x9AF4: 0x5950,
                0x9AF5: 0x594E,
                0x9AF6: 0x595A,
                0x9AF7: 0x5958,
                0x9AF8: 0x5962,
                0x9AF9: 0x5960,
                0x9AFA: 0x5967,
                0x9AFB: 0x596C,
                0x9AFC: 0x5969,
                0x9B40: 0x5978,
                0x9B41: 0x5981,
                0x9B42: 0x599D,
                0x9B43: 0x4F5E,
                0x9B44: 0x4FAB,
                0x9B45: 0x59A3,
                0x9B46: 0x59B2,
                0x9B47: 0x59C6,
                0x9B48: 0x59E8,
                0x9B49: 0x59DC,
                0x9B4A: 0x598D,
                0x9B4B: 0x59D9,
                0x9B4C: 0x59DA,
                0x9B4D: 0x5A25,
                0x9B4E: 0x5A1F,
                0x9B4F: 0x5A11,
                0x9B50: 0x5A1C,
                0x9B51: 0x5A09,
                0x9B52: 0x5A1A,
                0x9B53: 0x5A40,
                0x9B54: 0x5A6C,
                0x9B55: 0x5A49,
                0x9B56: 0x5A35,
                0x9B57: 0x5A36,
                0x9B58: 0x5A62,
                0x9B59: 0x5A6A,
                0x9B5A: 0x5A9A,
                0x9B5B: 0x5ABC,
                0x9B5C: 0x5ABE,
                0x9B5D: 0x5ACB,
                0x9B5E: 0x5AC2,
                0x9B5F: 0x5ABD,
                0x9B60: 0x5AE3,
                0x9B61: 0x5AD7,
                0x9B62: 0x5AE6,
                0x9B63: 0x5AE9,
                0x9B64: 0x5AD6,
                0x9B65: 0x5AFA,
                0x9B66: 0x5AFB,
                0x9B67: 0x5B0C,
                0x9B68: 0x5B0B,
                0x9B69: 0x5B16,
                0x9B6A: 0x5B32,
                0x9B6B: 0x5AD0,
                0x9B6C: 0x5B2A,
                0x9B6D: 0x5B36,
                0x9B6E: 0x5B3E,
                0x9B6F: 0x5B43,
                0x9B70: 0x5B45,
                0x9B71: 0x5B40,
                0x9B72: 0x5B51,
                0x9B73: 0x5B55,
                0x9B74: 0x5B5A,
                0x9B75: 0x5B5B,
                0x9B76: 0x5B65,
                0x9B77: 0x5B69,
                0x9B78: 0x5B70,
                0x9B79: 0x5B73,
                0x9B7A: 0x5B75,
                0x9B7B: 0x5B78,
                0x9B7C: 0x6588,
                0x9B7D: 0x5B7A,
                0x9B7E: 0x5B80,
                0x9B80: 0x5B83,
                0x9B81: 0x5BA6,
                0x9B82: 0x5BB8,
                0x9B83: 0x5BC3,
                0x9B84: 0x5BC7,
                0x9B85: 0x5BC9,
                0x9B86: 0x5BD4,
                0x9B87: 0x5BD0,
                0x9B88: 0x5BE4,
                0x9B89: 0x5BE6,
                0x9B8A: 0x5BE2,
                0x9B8B: 0x5BDE,
                0x9B8C: 0x5BE5,
                0x9B8D: 0x5BEB,
                0x9B8E: 0x5BF0,
                0x9B8F: 0x5BF6,
                0x9B90: 0x5BF3,
                0x9B91: 0x5C05,
                0x9B92: 0x5C07,
                0x9B93: 0x5C08,
                0x9B94: 0x5C0D,
                0x9B95: 0x5C13,
                0x9B96: 0x5C20,
                0x9B97: 0x5C22,
                0x9B98: 0x5C28,
                0x9B99: 0x5C38,
                0x9B9A: 0x5C39,
                0x9B9B: 0x5C41,
                0x9B9C: 0x5C46,
                0x9B9D: 0x5C4E,
                0x9B9E: 0x5C53,
                0x9B9F: 0x5C50,
                0x9BA0: 0x5C4F,
                0x9BA1: 0x5B71,
                0x9BA2: 0x5C6C,
                0x9BA3: 0x5C6E,
                0x9BA4: 0x4E62,
                0x9BA5: 0x5C76,
                0x9BA6: 0x5C79,
                0x9BA7: 0x5C8C,
                0x9BA8: 0x5C91,
                0x9BA9: 0x5C94,
                0x9BAA: 0x599B,
                0x9BAB: 0x5CAB,
                0x9BAC: 0x5CBB,
                0x9BAD: 0x5CB6,
                0x9BAE: 0x5CBC,
                0x9BAF: 0x5CB7,
                0x9BB0: 0x5CC5,
                0x9BB1: 0x5CBE,
                0x9BB2: 0x5CC7,
                0x9BB3: 0x5CD9,
                0x9BB4: 0x5CE9,
                0x9BB5: 0x5CFD,
                0x9BB6: 0x5CFA,
                0x9BB7: 0x5CED,
                0x9BB8: 0x5D8C,
                0x9BB9: 0x5CEA,
                0x9BBA: 0x5D0B,
                0x9BBB: 0x5D15,
                0x9BBC: 0x5D17,
                0x9BBD: 0x5D5C,
                0x9BBE: 0x5D1F,
                0x9BBF: 0x5D1B,
                0x9BC0: 0x5D11,
                0x9BC1: 0x5D14,
                0x9BC2: 0x5D22,
                0x9BC3: 0x5D1A,
                0x9BC4: 0x5D19,
                0x9BC5: 0x5D18,
                0x9BC6: 0x5D4C,
                0x9BC7: 0x5D52,
                0x9BC8: 0x5D4E,
                0x9BC9: 0x5D4B,
                0x9BCA: 0x5D6C,
                0x9BCB: 0x5D73,
                0x9BCC: 0x5D76,
                0x9BCD: 0x5D87,
                0x9BCE: 0x5D84,
                0x9BCF: 0x5D82,
                0x9BD0: 0x5DA2,
                0x9BD1: 0x5D9D,
                0x9BD2: 0x5DAC,
                0x9BD3: 0x5DAE,
                0x9BD4: 0x5DBD,
                0x9BD5: 0x5D90,
                0x9BD6: 0x5DB7,
                0x9BD7: 0x5DBC,
                0x9BD8: 0x5DC9,
                0x9BD9: 0x5DCD,
                0x9BDA: 0x5DD3,
                0x9BDB: 0x5DD2,
                0x9BDC: 0x5DD6,
                0x9BDD: 0x5DDB,
                0x9BDE: 0x5DEB,
                0x9BDF: 0x5DF2,
                0x9BE0: 0x5DF5,
                0x9BE1: 0x5E0B,
                0x9BE2: 0x5E1A,
                0x9BE3: 0x5E19,
                0x9BE4: 0x5E11,
                0x9BE5: 0x5E1B,
                0x9BE6: 0x5E36,
                0x9BE7: 0x5E37,
                0x9BE8: 0x5E44,
                0x9BE9: 0x5E43,
                0x9BEA: 0x5E40,
                0x9BEB: 0x5E4E,
                0x9BEC: 0x5E57,
                0x9BED: 0x5E54,
                0x9BEE: 0x5E5F,
                0x9BEF: 0x5E62,
                0x9BF0: 0x5E64,
                0x9BF1: 0x5E47,
                0x9BF2: 0x5E75,
                0x9BF3: 0x5E76,
                0x9BF4: 0x5E7A,
                0x9BF5: 0x9EBC,
                0x9BF6: 0x5E7F,
                0x9BF7: 0x5EA0,
                0x9BF8: 0x5EC1,
                0x9BF9: 0x5EC2,
                0x9BFA: 0x5EC8,
                0x9BFB: 0x5ED0,
                0x9BFC: 0x5ECF,
                0x9C40: 0x5ED6,
                0x9C41: 0x5EE3,
                0x9C42: 0x5EDD,
                0x9C43: 0x5EDA,
                0x9C44: 0x5EDB,
                0x9C45: 0x5EE2,
                0x9C46: 0x5EE1,
                0x9C47: 0x5EE8,
                0x9C48: 0x5EE9,
                0x9C49: 0x5EEC,
                0x9C4A: 0x5EF1,
                0x9C4B: 0x5EF3,
                0x9C4C: 0x5EF0,
                0x9C4D: 0x5EF4,
                0x9C4E: 0x5EF8,
                0x9C4F: 0x5EFE,
                0x9C50: 0x5F03,
                0x9C51: 0x5F09,
                0x9C52: 0x5F5D,
                0x9C53: 0x5F5C,
                0x9C54: 0x5F0B,
                0x9C55: 0x5F11,
                0x9C56: 0x5F16,
                0x9C57: 0x5F29,
                0x9C58: 0x5F2D,
                0x9C59: 0x5F38,
                0x9C5A: 0x5F41,
                0x9C5B: 0x5F48,
                0x9C5C: 0x5F4C,
                0x9C5D: 0x5F4E,
                0x9C5E: 0x5F2F,
                0x9C5F: 0x5F51,
                0x9C60: 0x5F56,
                0x9C61: 0x5F57,
                0x9C62: 0x5F59,
                0x9C63: 0x5F61,
                0x9C64: 0x5F6D,
                0x9C65: 0x5F73,
                0x9C66: 0x5F77,
                0x9C67: 0x5F83,
                0x9C68: 0x5F82,
                0x9C69: 0x5F7F,
                0x9C6A: 0x5F8A,
                0x9C6B: 0x5F88,
                0x9C6C: 0x5F91,
                0x9C6D: 0x5F87,
                0x9C6E: 0x5F9E,
                0x9C6F: 0x5F99,
                0x9C70: 0x5F98,
                0x9C71: 0x5FA0,
                0x9C72: 0x5FA8,
                0x9C73: 0x5FAD,
                0x9C74: 0x5FBC,
                0x9C75: 0x5FD6,
                0x9C76: 0x5FFB,
                0x9C77: 0x5FE4,
                0x9C78: 0x5FF8,
                0x9C79: 0x5FF1,
                0x9C7A: 0x5FDD,
                0x9C7B: 0x60B3,
                0x9C7C: 0x5FFF,
                0x9C7D: 0x6021,
                0x9C7E: 0x6060,
                0x9C80: 0x6019,
                0x9C81: 0x6010,
                0x9C82: 0x6029,
                0x9C83: 0x600E,
                0x9C84: 0x6031,
                0x9C85: 0x601B,
                0x9C86: 0x6015,
                0x9C87: 0x602B,
                0x9C88: 0x6026,
                0x9C89: 0x600F,
                0x9C8A: 0x603A,
                0x9C8B: 0x605A,
                0x9C8C: 0x6041,
                0x9C8D: 0x606A,
                0x9C8E: 0x6077,
                0x9C8F: 0x605F,
                0x9C90: 0x604A,
                0x9C91: 0x6046,
                0x9C92: 0x604D,
                0x9C93: 0x6063,
                0x9C94: 0x6043,
                0x9C95: 0x6064,
                0x9C96: 0x6042,
                0x9C97: 0x606C,
                0x9C98: 0x606B,
                0x9C99: 0x6059,
                0x9C9A: 0x6081,
                0x9C9B: 0x608D,
                0x9C9C: 0x60E7,
                0x9C9D: 0x6083,
                0x9C9E: 0x609A,
                0x9C9F: 0x6084,
                0x9CA0: 0x609B,
                0x9CA1: 0x6096,
                0x9CA2: 0x6097,
                0x9CA3: 0x6092,
                0x9CA4: 0x60A7,
                0x9CA5: 0x608B,
                0x9CA6: 0x60E1,
                0x9CA7: 0x60B8,
                0x9CA8: 0x60E0,
                0x9CA9: 0x60D3,
                0x9CAA: 0x60B4,
                0x9CAB: 0x5FF0,
                0x9CAC: 0x60BD,
                0x9CAD: 0x60C6,
                0x9CAE: 0x60B5,
                0x9CAF: 0x60D8,
                0x9CB0: 0x614D,
                0x9CB1: 0x6115,
                0x9CB2: 0x6106,
                0x9CB3: 0x60F6,
                0x9CB4: 0x60F7,
                0x9CB5: 0x6100,
                0x9CB6: 0x60F4,
                0x9CB7: 0x60FA,
                0x9CB8: 0x6103,
                0x9CB9: 0x6121,
                0x9CBA: 0x60FB,
                0x9CBB: 0x60F1,
                0x9CBC: 0x610D,
                0x9CBD: 0x610E,
                0x9CBE: 0x6147,
                0x9CBF: 0x613E,
                0x9CC0: 0x6128,
                0x9CC1: 0x6127,
                0x9CC2: 0x614A,
                0x9CC3: 0x613F,
                0x9CC4: 0x613C,
                0x9CC5: 0x612C,
                0x9CC6: 0x6134,
                0x9CC7: 0x613D,
                0x9CC8: 0x6142,
                0x9CC9: 0x6144,
                0x9CCA: 0x6173,
                0x9CCB: 0x6177,
                0x9CCC: 0x6158,
                0x9CCD: 0x6159,
                0x9CCE: 0x615A,
                0x9CCF: 0x616B,
                0x9CD0: 0x6174,
                0x9CD1: 0x616F,
                0x9CD2: 0x6165,
                0x9CD3: 0x6171,
                0x9CD4: 0x615F,
                0x9CD5: 0x615D,
                0x9CD6: 0x6153,
                0x9CD7: 0x6175,
                0x9CD8: 0x6199,
                0x9CD9: 0x6196,
                0x9CDA: 0x6187,
                0x9CDB: 0x61AC,
                0x9CDC: 0x6194,
                0x9CDD: 0x619A,
                0x9CDE: 0x618A,
                0x9CDF: 0x6191,
                0x9CE0: 0x61AB,
                0x9CE1: 0x61AE,
                0x9CE2: 0x61CC,
                0x9CE3: 0x61CA,
                0x9CE4: 0x61C9,
                0x9CE5: 0x61F7,
                0x9CE6: 0x61C8,
                0x9CE7: 0x61C3,
                0x9CE8: 0x61C6,
                0x9CE9: 0x61BA,
                0x9CEA: 0x61CB,
                0x9CEB: 0x7F79,
                0x9CEC: 0x61CD,
                0x9CED: 0x61E6,
                0x9CEE: 0x61E3,
                0x9CEF: 0x61F6,
                0x9CF0: 0x61FA,
                0x9CF1: 0x61F4,
                0x9CF2: 0x61FF,
                0x9CF3: 0x61FD,
                0x9CF4: 0x61FC,
                0x9CF5: 0x61FE,
                0x9CF6: 0x6200,
                0x9CF7: 0x6208,
                0x9CF8: 0x6209,
                0x9CF9: 0x620D,
                0x9CFA: 0x620C,
                0x9CFB: 0x6214,
                0x9CFC: 0x621B,
                0x9D40: 0x621E,
                0x9D41: 0x6221,
                0x9D42: 0x622A,
                0x9D43: 0x622E,
                0x9D44: 0x6230,
                0x9D45: 0x6232,
                0x9D46: 0x6233,
                0x9D47: 0x6241,
                0x9D48: 0x624E,
                0x9D49: 0x625E,
                0x9D4A: 0x6263,
                0x9D4B: 0x625B,
                0x9D4C: 0x6260,
                0x9D4D: 0x6268,
                0x9D4E: 0x627C,
                0x9D4F: 0x6282,
                0x9D50: 0x6289,
                0x9D51: 0x627E,
                0x9D52: 0x6292,
                0x9D53: 0x6293,
                0x9D54: 0x6296,
                0x9D55: 0x62D4,
                0x9D56: 0x6283,
                0x9D57: 0x6294,
                0x9D58: 0x62D7,
                0x9D59: 0x62D1,
                0x9D5A: 0x62BB,
                0x9D5B: 0x62CF,
                0x9D5C: 0x62FF,
                0x9D5D: 0x62C6,
                0x9D5E: 0x64D4,
                0x9D5F: 0x62C8,
                0x9D60: 0x62DC,
                0x9D61: 0x62CC,
                0x9D62: 0x62CA,
                0x9D63: 0x62C2,
                0x9D64: 0x62C7,
                0x9D65: 0x629B,
                0x9D66: 0x62C9,
                0x9D67: 0x630C,
                0x9D68: 0x62EE,
                0x9D69: 0x62F1,
                0x9D6A: 0x6327,
                0x9D6B: 0x6302,
                0x9D6C: 0x6308,
                0x9D6D: 0x62EF,
                0x9D6E: 0x62F5,
                0x9D6F: 0x6350,
                0x9D70: 0x633E,
                0x9D71: 0x634D,
                0x9D72: 0x641C,
                0x9D73: 0x634F,
                0x9D74: 0x6396,
                0x9D75: 0x638E,
                0x9D76: 0x6380,
                0x9D77: 0x63AB,
                0x9D78: 0x6376,
                0x9D79: 0x63A3,
                0x9D7A: 0x638F,
                0x9D7B: 0x6389,
                0x9D7C: 0x639F,
                0x9D7D: 0x63B5,
                0x9D7E: 0x636B,
                0x9D80: 0x6369,
                0x9D81: 0x63BE,
                0x9D82: 0x63E9,
                0x9D83: 0x63C0,
                0x9D84: 0x63C6,
                0x9D85: 0x63E3,
                0x9D86: 0x63C9,
                0x9D87: 0x63D2,
                0x9D88: 0x63F6,
                0x9D89: 0x63C4,
                0x9D8A: 0x6416,
                0x9D8B: 0x6434,
                0x9D8C: 0x6406,
                0x9D8D: 0x6413,
                0x9D8E: 0x6426,
                0x9D8F: 0x6436,
                0x9D90: 0x651D,
                0x9D91: 0x6417,
                0x9D92: 0x6428,
                0x9D93: 0x640F,
                0x9D94: 0x6467,
                0x9D95: 0x646F,
                0x9D96: 0x6476,
                0x9D97: 0x644E,
                0x9D98: 0x652A,
                0x9D99: 0x6495,
                0x9D9A: 0x6493,
                0x9D9B: 0x64A5,
                0x9D9C: 0x64A9,
                0x9D9D: 0x6488,
                0x9D9E: 0x64BC,
                0x9D9F: 0x64DA,
                0x9DA0: 0x64D2,
                0x9DA1: 0x64C5,
                0x9DA2: 0x64C7,
                0x9DA3: 0x64BB,
                0x9DA4: 0x64D8,
                0x9DA5: 0x64C2,
                0x9DA6: 0x64F1,
                0x9DA7: 0x64E7,
                0x9DA8: 0x8209,
                0x9DA9: 0x64E0,
                0x9DAA: 0x64E1,
                0x9DAB: 0x62AC,
                0x9DAC: 0x64E3,
                0x9DAD: 0x64EF,
                0x9DAE: 0x652C,
                0x9DAF: 0x64F6,
                0x9DB0: 0x64F4,
                0x9DB1: 0x64F2,
                0x9DB2: 0x64FA,
                0x9DB3: 0x6500,
                0x9DB4: 0x64FD,
                0x9DB5: 0x6518,
                0x9DB6: 0x651C,
                0x9DB7: 0x6505,
                0x9DB8: 0x6524,
                0x9DB9: 0x6523,
                0x9DBA: 0x652B,
                0x9DBB: 0x6534,
                0x9DBC: 0x6535,
                0x9DBD: 0x6537,
                0x9DBE: 0x6536,
                0x9DBF: 0x6538,
                0x9DC0: 0x754B,
                0x9DC1: 0x6548,
                0x9DC2: 0x6556,
                0x9DC3: 0x6555,
                0x9DC4: 0x654D,
                0x9DC5: 0x6558,
                0x9DC6: 0x655E,
                0x9DC7: 0x655D,
                0x9DC8: 0x6572,
                0x9DC9: 0x6578,
                0x9DCA: 0x6582,
                0x9DCB: 0x6583,
                0x9DCC: 0x8B8A,
                0x9DCD: 0x659B,
                0x9DCE: 0x659F,
                0x9DCF: 0x65AB,
                0x9DD0: 0x65B7,
                0x9DD1: 0x65C3,
                0x9DD2: 0x65C6,
                0x9DD3: 0x65C1,
                0x9DD4: 0x65C4,
                0x9DD5: 0x65CC,
                0x9DD6: 0x65D2,
                0x9DD7: 0x65DB,
                0x9DD8: 0x65D9,
                0x9DD9: 0x65E0,
                0x9DDA: 0x65E1,
                0x9DDB: 0x65F1,
                0x9DDC: 0x6772,
                0x9DDD: 0x660A,
                0x9DDE: 0x6603,
                0x9DDF: 0x65FB,
                0x9DE0: 0x6773,
                0x9DE1: 0x6635,
                0x9DE2: 0x6636,
                0x9DE3: 0x6634,
                0x9DE4: 0x661C,
                0x9DE5: 0x664F,
                0x9DE6: 0x6644,
                0x9DE7: 0x6649,
                0x9DE8: 0x6641,
                0x9DE9: 0x665E,
                0x9DEA: 0x665D,
                0x9DEB: 0x6664,
                0x9DEC: 0x6667,
                0x9DED: 0x6668,
                0x9DEE: 0x665F,
                0x9DEF: 0x6662,
                0x9DF0: 0x6670,
                0x9DF1: 0x6683,
                0x9DF2: 0x6688,
                0x9DF3: 0x668E,
                0x9DF4: 0x6689,
                0x9DF5: 0x6684,
                0x9DF6: 0x6698,
                0x9DF7: 0x669D,
                0x9DF8: 0x66C1,
                0x9DF9: 0x66B9,
                0x9DFA: 0x66C9,
                0x9DFB: 0x66BE,
                0x9DFC: 0x66BC,
                0x9E40: 0x66C4,
                0x9E41: 0x66B8,
                0x9E42: 0x66D6,
                0x9E43: 0x66DA,
                0x9E44: 0x66E0,
                0x9E45: 0x663F,
                0x9E46: 0x66E6,
                0x9E47: 0x66E9,
                0x9E48: 0x66F0,
                0x9E49: 0x66F5,
                0x9E4A: 0x66F7,
                0x9E4B: 0x670F,
                0x9E4C: 0x6716,
                0x9E4D: 0x671E,
                0x9E4E: 0x6726,
                0x9E4F: 0x6727,
                0x9E50: 0x9738,
                0x9E51: 0x672E,
                0x9E52: 0x673F,
                0x9E53: 0x6736,
                0x9E54: 0x6741,
                0x9E55: 0x6738,
                0x9E56: 0x6737,
                0x9E57: 0x6746,
                0x9E58: 0x675E,
                0x9E59: 0x6760,
                0x9E5A: 0x6759,
                0x9E5B: 0x6763,
                0x9E5C: 0x6764,
                0x9E5D: 0x6789,
                0x9E5E: 0x6770,
                0x9E5F: 0x67A9,
                0x9E60: 0x677C,
                0x9E61: 0x676A,
                0x9E62: 0x678C,
                0x9E63: 0x678B,
                0x9E64: 0x67A6,
                0x9E65: 0x67A1,
                0x9E66: 0x6785,
                0x9E67: 0x67B7,
                0x9E68: 0x67EF,
                0x9E69: 0x67B4,
                0x9E6A: 0x67EC,
                0x9E6B: 0x67B3,
                0x9E6C: 0x67E9,
                0x9E6D: 0x67B8,
                0x9E6E: 0x67E4,
                0x9E6F: 0x67DE,
                0x9E70: 0x67DD,
                0x9E71: 0x67E2,
                0x9E72: 0x67EE,
                0x9E73: 0x67B9,
                0x9E74: 0x67CE,
                0x9E75: 0x67C6,
                0x9E76: 0x67E7,
                0x9E77: 0x6A9C,
                0x9E78: 0x681E,
                0x9E79: 0x6846,
                0x9E7A: 0x6829,
                0x9E7B: 0x6840,
                0x9E7C: 0x684D,
                0x9E7D: 0x6832,
                0x9E7E: 0x684E,
                0x9E80: 0x68B3,
                0x9E81: 0x682B,
                0x9E82: 0x6859,
                0x9E83: 0x6863,
                0x9E84: 0x6877,
                0x9E85: 0x687F,
                0x9E86: 0x689F,
                0x9E87: 0x688F,
                0x9E88: 0x68AD,
                0x9E89: 0x6894,
                0x9E8A: 0x689D,
                0x9E8B: 0x689B,
                0x9E8C: 0x6883,
                0x9E8D: 0x6AAE,
                0x9E8E: 0x68B9,
                0x9E8F: 0x6874,
                0x9E90: 0x68B5,
                0x9E91: 0x68A0,
                0x9E92: 0x68BA,
                0x9E93: 0x690F,
                0x9E94: 0x688D,
                0x9E95: 0x687E,
                0x9E96: 0x6901,
                0x9E97: 0x68CA,
                0x9E98: 0x6908,
                0x9E99: 0x68D8,
                0x9E9A: 0x6922,
                0x9E9B: 0x6926,
                0x9E9C: 0x68E1,
                0x9E9D: 0x690C,
                0x9E9E: 0x68CD,
                0x9E9F: 0x68D4,
                0x9EA0: 0x68E7,
                0x9EA1: 0x68D5,
                0x9EA2: 0x6936,
                0x9EA3: 0x6912,
                0x9EA4: 0x6904,
                0x9EA5: 0x68D7,
                0x9EA6: 0x68E3,
                0x9EA7: 0x6925,
                0x9EA8: 0x68F9,
                0x9EA9: 0x68E0,
                0x9EAA: 0x68EF,
                0x9EAB: 0x6928,
                0x9EAC: 0x692A,
                0x9EAD: 0x691A,
                0x9EAE: 0x6923,
                0x9EAF: 0x6921,
                0x9EB0: 0x68C6,
                0x9EB1: 0x6979,
                0x9EB2: 0x6977,
                0x9EB3: 0x695C,
                0x9EB4: 0x6978,
                0x9EB5: 0x696B,
                0x9EB6: 0x6954,
                0x9EB7: 0x697E,
                0x9EB8: 0x696E,
                0x9EB9: 0x6939,
                0x9EBA: 0x6974,
                0x9EBB: 0x693D,
                0x9EBC: 0x6959,
                0x9EBD: 0x6930,
                0x9EBE: 0x6961,
                0x9EBF: 0x695E,
                0x9EC0: 0x695D,
                0x9EC1: 0x6981,
                0x9EC2: 0x696A,
                0x9EC3: 0x69B2,
                0x9EC4: 0x69AE,
                0x9EC5: 0x69D0,
                0x9EC6: 0x69BF,
                0x9EC7: 0x69C1,
                0x9EC8: 0x69D3,
                0x9EC9: 0x69BE,
                0x9ECA: 0x69CE,
                0x9ECB: 0x5BE8,
                0x9ECC: 0x69CA,
                0x9ECD: 0x69DD,
                0x9ECE: 0x69BB,
                0x9ECF: 0x69C3,
                0x9ED0: 0x69A7,
                0x9ED1: 0x6A2E,
                0x9ED2: 0x6991,
                0x9ED3: 0x69A0,
                0x9ED4: 0x699C,
                0x9ED5: 0x6995,
                0x9ED6: 0x69B4,
                0x9ED7: 0x69DE,
                0x9ED8: 0x69E8,
                0x9ED9: 0x6A02,
                0x9EDA: 0x6A1B,
                0x9EDB: 0x69FF,
                0x9EDC: 0x6B0A,
                0x9EDD: 0x69F9,
                0x9EDE: 0x69F2,
                0x9EDF: 0x69E7,
                0x9EE0: 0x6A05,
                0x9EE1: 0x69B1,
                0x9EE2: 0x6A1E,
                0x9EE3: 0x69ED,
                0x9EE4: 0x6A14,
                0x9EE5: 0x69EB,
                0x9EE6: 0x6A0A,
                0x9EE7: 0x6A12,
                0x9EE8: 0x6AC1,
                0x9EE9: 0x6A23,
                0x9EEA: 0x6A13,
                0x9EEB: 0x6A44,
                0x9EEC: 0x6A0C,
                0x9EED: 0x6A72,
                0x9EEE: 0x6A36,
                0x9EEF: 0x6A78,
                0x9EF0: 0x6A47,
                0x9EF1: 0x6A62,
                0x9EF2: 0x6A59,
                0x9EF3: 0x6A66,
                0x9EF4: 0x6A48,
                0x9EF5: 0x6A38,
                0x9EF6: 0x6A22,
                0x9EF7: 0x6A90,
                0x9EF8: 0x6A8D,
                0x9EF9: 0x6AA0,
                0x9EFA: 0x6A84,
                0x9EFB: 0x6AA2,
                0x9EFC: 0x6AA3,
                0x9F40: 0x6A97,
                0x9F41: 0x8617,
                0x9F42: 0x6ABB,
                0x9F43: 0x6AC3,
                0x9F44: 0x6AC2,
                0x9F45: 0x6AB8,
                0x9F46: 0x6AB3,
                0x9F47: 0x6AAC,
                0x9F48: 0x6ADE,
                0x9F49: 0x6AD1,
                0x9F4A: 0x6ADF,
                0x9F4B: 0x6AAA,
                0x9F4C: 0x6ADA,
                0x9F4D: 0x6AEA,
                0x9F4E: 0x6AFB,
                0x9F4F: 0x6B05,
                0x9F50: 0x8616,
                0x9F51: 0x6AFA,
                0x9F52: 0x6B12,
                0x9F53: 0x6B16,
                0x9F54: 0x9B31,
                0x9F55: 0x6B1F,
                0x9F56: 0x6B38,
                0x9F57: 0x6B37,
                0x9F58: 0x76DC,
                0x9F59: 0x6B39,
                0x9F5A: 0x98EE,
                0x9F5B: 0x6B47,
                0x9F5C: 0x6B43,
                0x9F5D: 0x6B49,
                0x9F5E: 0x6B50,
                0x9F5F: 0x6B59,
                0x9F60: 0x6B54,
                0x9F61: 0x6B5B,
                0x9F62: 0x6B5F,
                0x9F63: 0x6B61,
                0x9F64: 0x6B78,
                0x9F65: 0x6B79,
                0x9F66: 0x6B7F,
                0x9F67: 0x6B80,
                0x9F68: 0x6B84,
                0x9F69: 0x6B83,
                0x9F6A: 0x6B8D,
                0x9F6B: 0x6B98,
                0x9F6C: 0x6B95,
                0x9F6D: 0x6B9E,
                0x9F6E: 0x6BA4,
                0x9F6F: 0x6BAA,
                0x9F70: 0x6BAB,
                0x9F71: 0x6BAF,
                0x9F72: 0x6BB2,
                0x9F73: 0x6BB1,
                0x9F74: 0x6BB3,
                0x9F75: 0x6BB7,
                0x9F76: 0x6BBC,
                0x9F77: 0x6BC6,
                0x9F78: 0x6BCB,
                0x9F79: 0x6BD3,
                0x9F7A: 0x6BDF,
                0x9F7B: 0x6BEC,
                0x9F7C: 0x6BEB,
                0x9F7D: 0x6BF3,
                0x9F7E: 0x6BEF,
                0x9F80: 0x9EBE,
                0x9F81: 0x6C08,
                0x9F82: 0x6C13,
                0x9F83: 0x6C14,
                0x9F84: 0x6C1B,
                0x9F85: 0x6C24,
                0x9F86: 0x6C23,
                0x9F87: 0x6C5E,
                0x9F88: 0x6C55,
                0x9F89: 0x6C62,
                0x9F8A: 0x6C6A,
                0x9F8B: 0x6C82,
                0x9F8C: 0x6C8D,
                0x9F8D: 0x6C9A,
                0x9F8E: 0x6C81,
                0x9F8F: 0x6C9B,
                0x9F90: 0x6C7E,
                0x9F91: 0x6C68,
                0x9F92: 0x6C73,
                0x9F93: 0x6C92,
                0x9F94: 0x6C90,
                0x9F95: 0x6CC4,
                0x9F96: 0x6CF1,
                0x9F97: 0x6CD3,
                0x9F98: 0x6CBD,
                0x9F99: 0x6CD7,
                0x9F9A: 0x6CC5,
                0x9F9B: 0x6CDD,
                0x9F9C: 0x6CAE,
                0x9F9D: 0x6CB1,
                0x9F9E: 0x6CBE,
                0x9F9F: 0x6CBA,
                0x9FA0: 0x6CDB,
                0x9FA1: 0x6CEF,
                0x9FA2: 0x6CD9,
                0x9FA3: 0x6CEA,
                0x9FA4: 0x6D1F,
                0x9FA5: 0x884D,
                0x9FA6: 0x6D36,
                0x9FA7: 0x6D2B,
                0x9FA8: 0x6D3D,
                0x9FA9: 0x6D38,
                0x9FAA: 0x6D19,
                0x9FAB: 0x6D35,
                0x9FAC: 0x6D33,
                0x9FAD: 0x6D12,
                0x9FAE: 0x6D0C,
                0x9FAF: 0x6D63,
                0x9FB0: 0x6D93,
                0x9FB1: 0x6D64,
                0x9FB2: 0x6D5A,
                0x9FB3: 0x6D79,
                0x9FB4: 0x6D59,
                0x9FB5: 0x6D8E,
                0x9FB6: 0x6D95,
                0x9FB7: 0x6FE4,
                0x9FB8: 0x6D85,
                0x9FB9: 0x6DF9,
                0x9FBA: 0x6E15,
                0x9FBB: 0x6E0A,
                0x9FBC: 0x6DB5,
                0x9FBD: 0x6DC7,
                0x9FBE: 0x6DE6,
                0x9FBF: 0x6DB8,
                0x9FC0: 0x6DC6,
                0x9FC1: 0x6DEC,
                0x9FC2: 0x6DDE,
                0x9FC3: 0x6DCC,
                0x9FC4: 0x6DE8,
                0x9FC5: 0x6DD2,
                0x9FC6: 0x6DC5,
                0x9FC7: 0x6DFA,
                0x9FC8: 0x6DD9,
                0x9FC9: 0x6DE4,
                0x9FCA: 0x6DD5,
                0x9FCB: 0x6DEA,
                0x9FCC: 0x6DEE,
                0x9FCD: 0x6E2D,
                0x9FCE: 0x6E6E,
                0x9FCF: 0x6E2E,
                0x9FD0: 0x6E19,
                0x9FD1: 0x6E72,
                0x9FD2: 0x6E5F,
                0x9FD3: 0x6E3E,
                0x9FD4: 0x6E23,
                0x9FD5: 0x6E6B,
                0x9FD6: 0x6E2B,
                0x9FD7: 0x6E76,
                0x9FD8: 0x6E4D,
                0x9FD9: 0x6E1F,
                0x9FDA: 0x6E43,
                0x9FDB: 0x6E3A,
                0x9FDC: 0x6E4E,
                0x9FDD: 0x6E24,
                0x9FDE: 0x6EFF,
                0x9FDF: 0x6E1D,
                0x9FE0: 0x6E38,
                0x9FE1: 0x6E82,
                0x9FE2: 0x6EAA,
                0x9FE3: 0x6E98,
                0x9FE4: 0x6EC9,
                0x9FE5: 0x6EB7,
                0x9FE6: 0x6ED3,
                0x9FE7: 0x6EBD,
                0x9FE8: 0x6EAF,
                0x9FE9: 0x6EC4,
                0x9FEA: 0x6EB2,
                0x9FEB: 0x6ED4,
                0x9FEC: 0x6ED5,
                0x9FED: 0x6E8F,
                0x9FEE: 0x6EA5,
                0x9FEF: 0x6EC2,
                0x9FF0: 0x6E9F,
                0x9FF1: 0x6F41,
                0x9FF2: 0x6F11,
                0x9FF3: 0x704C,
                0x9FF4: 0x6EEC,
                0x9FF5: 0x6EF8,
                0x9FF6: 0x6EFE,
                0x9FF7: 0x6F3F,
                0x9FF8: 0x6EF2,
                0x9FF9: 0x6F31,
                0x9FFA: 0x6EEF,
                0x9FFB: 0x6F32,
                0x9FFC: 0x6ECC,
                0xA1: 0xFF61,
                0xA2: 0xFF62,
                0xA3: 0xFF63,
                0xA4: 0xFF64,
                0xA5: 0xFF65,
                0xA6: 0xFF66,
                0xA7: 0xFF67,
                0xA8: 0xFF68,
                0xA9: 0xFF69,
                0xAA: 0xFF6A,
                0xAB: 0xFF6B,
                0xAC: 0xFF6C,
                0xAD: 0xFF6D,
                0xAE: 0xFF6E,
                0xAF: 0xFF6F,
                0xB0: 0xFF70,
                0xB1: 0xFF71,
                0xB2: 0xFF72,
                0xB3: 0xFF73,
                0xB4: 0xFF74,
                0xB5: 0xFF75,
                0xB6: 0xFF76,
                0xB7: 0xFF77,
                0xB8: 0xFF78,
                0xB9: 0xFF79,
                0xBA: 0xFF7A,
                0xBB: 0xFF7B,
                0xBC: 0xFF7C,
                0xBD: 0xFF7D,
                0xBE: 0xFF7E,
                0xBF: 0xFF7F,
                0xC0: 0xFF80,
                0xC1: 0xFF81,
                0xC2: 0xFF82,
                0xC3: 0xFF83,
                0xC4: 0xFF84,
                0xC5: 0xFF85,
                0xC6: 0xFF86,
                0xC7: 0xFF87,
                0xC8: 0xFF88,
                0xC9: 0xFF89,
                0xCA: 0xFF8A,
                0xCB: 0xFF8B,
                0xCC: 0xFF8C,
                0xCD: 0xFF8D,
                0xCE: 0xFF8E,
                0xCF: 0xFF8F,
                0xD0: 0xFF90,
                0xD1: 0xFF91,
                0xD2: 0xFF92,
                0xD3: 0xFF93,
                0xD4: 0xFF94,
                0xD5: 0xFF95,
                0xD6: 0xFF96,
                0xD7: 0xFF97,
                0xD8: 0xFF98,
                0xD9: 0xFF99,
                0xDA: 0xFF9A,
                0xDB: 0xFF9B,
                0xDC: 0xFF9C,
                0xDD: 0xFF9D,
                0xDE: 0xFF9E,
                0xDF: 0xFF9F,
                0xE040: 0x6F3E,
                0xE041: 0x6F13,
                0xE042: 0x6EF7,
                0xE043: 0x6F86,
                0xE044: 0x6F7A,
                0xE045: 0x6F78,
                0xE046: 0x6F81,
                0xE047: 0x6F80,
                0xE048: 0x6F6F,
                0xE049: 0x6F5B,
                0xE04A: 0x6FF3,
                0xE04B: 0x6F6D,
                0xE04C: 0x6F82,
                0xE04D: 0x6F7C,
                0xE04E: 0x6F58,
                0xE04F: 0x6F8E,
                0xE050: 0x6F91,
                0xE051: 0x6FC2,
                0xE052: 0x6F66,
                0xE053: 0x6FB3,
                0xE054: 0x6FA3,
                0xE055: 0x6FA1,
                0xE056: 0x6FA4,
                0xE057: 0x6FB9,
                0xE058: 0x6FC6,
                0xE059: 0x6FAA,
                0xE05A: 0x6FDF,
                0xE05B: 0x6FD5,
                0xE05C: 0x6FEC,
                0xE05D: 0x6FD4,
                0xE05E: 0x6FD8,
                0xE05F: 0x6FF1,
                0xE060: 0x6FEE,
                0xE061: 0x6FDB,
                0xE062: 0x7009,
                0xE063: 0x700B,
                0xE064: 0x6FFA,
                0xE065: 0x7011,
                0xE066: 0x7001,
                0xE067: 0x700F,
                0xE068: 0x6FFE,
                0xE069: 0x701B,
                0xE06A: 0x701A,
                0xE06B: 0x6F74,
                0xE06C: 0x701D,
                0xE06D: 0x7018,
                0xE06E: 0x701F,
                0xE06F: 0x7030,
                0xE070: 0x703E,
                0xE071: 0x7032,
                0xE072: 0x7051,
                0xE073: 0x7063,
                0xE074: 0x7099,
                0xE075: 0x7092,
                0xE076: 0x70AF,
                0xE077: 0x70F1,
                0xE078: 0x70AC,
                0xE079: 0x70B8,
                0xE07A: 0x70B3,
                0xE07B: 0x70AE,
                0xE07C: 0x70DF,
                0xE07D: 0x70CB,
                0xE07E: 0x70DD,
                0xE080: 0x70D9,
                0xE081: 0x7109,
                0xE082: 0x70FD,
                0xE083: 0x711C,
                0xE084: 0x7119,
                0xE085: 0x7165,
                0xE086: 0x7155,
                0xE087: 0x7188,
                0xE088: 0x7166,
                0xE089: 0x7162,
                0xE08A: 0x714C,
                0xE08B: 0x7156,
                0xE08C: 0x716C,
                0xE08D: 0x718F,
                0xE08E: 0x71FB,
                0xE08F: 0x7184,
                0xE090: 0x7195,
                0xE091: 0x71A8,
                0xE092: 0x71AC,
                0xE093: 0x71D7,
                0xE094: 0x71B9,
                0xE095: 0x71BE,
                0xE096: 0x71D2,
                0xE097: 0x71C9,
                0xE098: 0x71D4,
                0xE099: 0x71CE,
                0xE09A: 0x71E0,
                0xE09B: 0x71EC,
                0xE09C: 0x71E7,
                0xE09D: 0x71F5,
                0xE09E: 0x71FC,
                0xE09F: 0x71F9,
                0xE0A0: 0x71FF,
                0xE0A1: 0x720D,
                0xE0A2: 0x7210,
                0xE0A3: 0x721B,
                0xE0A4: 0x7228,
                0xE0A5: 0x722D,
                0xE0A6: 0x722C,
                0xE0A7: 0x7230,
                0xE0A8: 0x7232,
                0xE0A9: 0x723B,
                0xE0AA: 0x723C,
                0xE0AB: 0x723F,
                0xE0AC: 0x7240,
                0xE0AD: 0x7246,
                0xE0AE: 0x724B,
                0xE0AF: 0x7258,
                0xE0B0: 0x7274,
                0xE0B1: 0x727E,
                0xE0B2: 0x7282,
                0xE0B3: 0x7281,
                0xE0B4: 0x7287,
                0xE0B5: 0x7292,
                0xE0B6: 0x7296,
                0xE0B7: 0x72A2,
                0xE0B8: 0x72A7,
                0xE0B9: 0x72B9,
                0xE0BA: 0x72B2,
                0xE0BB: 0x72C3,
                0xE0BC: 0x72C6,
                0xE0BD: 0x72C4,
                0xE0BE: 0x72CE,
                0xE0BF: 0x72D2,
                0xE0C0: 0x72E2,
                0xE0C1: 0x72E0,
                0xE0C2: 0x72E1,
                0xE0C3: 0x72F9,
                0xE0C4: 0x72F7,
                0xE0C5: 0x500F,
                0xE0C6: 0x7317,
                0xE0C7: 0x730A,
                0xE0C8: 0x731C,
                0xE0C9: 0x7316,
                0xE0CA: 0x731D,
                0xE0CB: 0x7334,
                0xE0CC: 0x732F,
                0xE0CD: 0x7329,
                0xE0CE: 0x7325,
                0xE0CF: 0x733E,
                0xE0D0: 0x734E,
                0xE0D1: 0x734F,
                0xE0D2: 0x9ED8,
                0xE0D3: 0x7357,
                0xE0D4: 0x736A,
                0xE0D5: 0x7368,
                0xE0D6: 0x7370,
                0xE0D7: 0x7378,
                0xE0D8: 0x7375,
                0xE0D9: 0x737B,
                0xE0DA: 0x737A,
                0xE0DB: 0x73C8,
                0xE0DC: 0x73B3,
                0xE0DD: 0x73CE,
                0xE0DE: 0x73BB,
                0xE0DF: 0x73C0,
                0xE0E0: 0x73E5,
                0xE0E1: 0x73EE,
                0xE0E2: 0x73DE,
                0xE0E3: 0x74A2,
                0xE0E4: 0x7405,
                0xE0E5: 0x746F,
                0xE0E6: 0x7425,
                0xE0E7: 0x73F8,
                0xE0E8: 0x7432,
                0xE0E9: 0x743A,
                0xE0EA: 0x7455,
                0xE0EB: 0x743F,
                0xE0EC: 0x745F,
                0xE0ED: 0x7459,
                0xE0EE: 0x7441,
                0xE0EF: 0x745C,
                0xE0F0: 0x7469,
                0xE0F1: 0x7470,
                0xE0F2: 0x7463,
                0xE0F3: 0x746A,
                0xE0F4: 0x7476,
                0xE0F5: 0x747E,
                0xE0F6: 0x748B,
                0xE0F7: 0x749E,
                0xE0F8: 0x74A7,
                0xE0F9: 0x74CA,
                0xE0FA: 0x74CF,
                0xE0FB: 0x74D4,
                0xE0FC: 0x73F1,
                0xE140: 0x74E0,
                0xE141: 0x74E3,
                0xE142: 0x74E7,
                0xE143: 0x74E9,
                0xE144: 0x74EE,
                0xE145: 0x74F2,
                0xE146: 0x74F0,
                0xE147: 0x74F1,
                0xE148: 0x74F8,
                0xE149: 0x74F7,
                0xE14A: 0x7504,
                0xE14B: 0x7503,
                0xE14C: 0x7505,
                0xE14D: 0x750C,
                0xE14E: 0x750E,
                0xE14F: 0x750D,
                0xE150: 0x7515,
                0xE151: 0x7513,
                0xE152: 0x751E,
                0xE153: 0x7526,
                0xE154: 0x752C,
                0xE155: 0x753C,
                0xE156: 0x7544,
                0xE157: 0x754D,
                0xE158: 0x754A,
                0xE159: 0x7549,
                0xE15A: 0x755B,
                0xE15B: 0x7546,
                0xE15C: 0x755A,
                0xE15D: 0x7569,
                0xE15E: 0x7564,
                0xE15F: 0x7567,
                0xE160: 0x756B,
                0xE161: 0x756D,
                0xE162: 0x7578,
                0xE163: 0x7576,
                0xE164: 0x7586,
                0xE165: 0x7587,
                0xE166: 0x7574,
                0xE167: 0x758A,
                0xE168: 0x7589,
                0xE169: 0x7582,
                0xE16A: 0x7594,
                0xE16B: 0x759A,
                0xE16C: 0x759D,
                0xE16D: 0x75A5,
                0xE16E: 0x75A3,
                0xE16F: 0x75C2,
                0xE170: 0x75B3,
                0xE171: 0x75C3,
                0xE172: 0x75B5,
                0xE173: 0x75BD,
                0xE174: 0x75B8,
                0xE175: 0x75BC,
                0xE176: 0x75B1,
                0xE177: 0x75CD,
                0xE178: 0x75CA,
                0xE179: 0x75D2,
                0xE17A: 0x75D9,
                0xE17B: 0x75E3,
                0xE17C: 0x75DE,
                0xE17D: 0x75FE,
                0xE17E: 0x75FF,
                0xE180: 0x75FC,
                0xE181: 0x7601,
                0xE182: 0x75F0,
                0xE183: 0x75FA,
                0xE184: 0x75F2,
                0xE185: 0x75F3,
                0xE186: 0x760B,
                0xE187: 0x760D,
                0xE188: 0x7609,
                0xE189: 0x761F,
                0xE18A: 0x7627,
                0xE18B: 0x7620,
                0xE18C: 0x7621,
                0xE18D: 0x7622,
                0xE18E: 0x7624,
                0xE18F: 0x7634,
                0xE190: 0x7630,
                0xE191: 0x763B,
                0xE192: 0x7647,
                0xE193: 0x7648,
                0xE194: 0x7646,
                0xE195: 0x765C,
                0xE196: 0x7658,
                0xE197: 0x7661,
                0xE198: 0x7662,
                0xE199: 0x7668,
                0xE19A: 0x7669,
                0xE19B: 0x766A,
                0xE19C: 0x7667,
                0xE19D: 0x766C,
                0xE19E: 0x7670,
                0xE19F: 0x7672,
                0xE1A0: 0x7676,
                0xE1A1: 0x7678,
                0xE1A2: 0x767C,
                0xE1A3: 0x7680,
                0xE1A4: 0x7683,
                0xE1A5: 0x7688,
                0xE1A6: 0x768B,
                0xE1A7: 0x768E,
                0xE1A8: 0x7696,
                0xE1A9: 0x7693,
                0xE1AA: 0x7699,
                0xE1AB: 0x769A,
                0xE1AC: 0x76B0,
                0xE1AD: 0x76B4,
                0xE1AE: 0x76B8,
                0xE1AF: 0x76B9,
                0xE1B0: 0x76BA,
                0xE1B1: 0x76C2,
                0xE1B2: 0x76CD,
                0xE1B3: 0x76D6,
                0xE1B4: 0x76D2,
                0xE1B5: 0x76DE,
                0xE1B6: 0x76E1,
                0xE1B7: 0x76E5,
                0xE1B8: 0x76E7,
                0xE1B9: 0x76EA,
                0xE1BA: 0x862F,
                0xE1BB: 0x76FB,
                0xE1BC: 0x7708,
                0xE1BD: 0x7707,
                0xE1BE: 0x7704,
                0xE1BF: 0x7729,
                0xE1C0: 0x7724,
                0xE1C1: 0x771E,
                0xE1C2: 0x7725,
                0xE1C3: 0x7726,
                0xE1C4: 0x771B,
                0xE1C5: 0x7737,
                0xE1C6: 0x7738,
                0xE1C7: 0x7747,
                0xE1C8: 0x775A,
                0xE1C9: 0x7768,
                0xE1CA: 0x776B,
                0xE1CB: 0x775B,
                0xE1CC: 0x7765,
                0xE1CD: 0x777F,
                0xE1CE: 0x777E,
                0xE1CF: 0x7779,
                0xE1D0: 0x778E,
                0xE1D1: 0x778B,
                0xE1D2: 0x7791,
                0xE1D3: 0x77A0,
                0xE1D4: 0x779E,
                0xE1D5: 0x77B0,
                0xE1D6: 0x77B6,
                0xE1D7: 0x77B9,
                0xE1D8: 0x77BF,
                0xE1D9: 0x77BC,
                0xE1DA: 0x77BD,
                0xE1DB: 0x77BB,
                0xE1DC: 0x77C7,
                0xE1DD: 0x77CD,
                0xE1DE: 0x77D7,
                0xE1DF: 0x77DA,
                0xE1E0: 0x77DC,
                0xE1E1: 0x77E3,
                0xE1E2: 0x77EE,
                0xE1E3: 0x77FC,
                0xE1E4: 0x780C,
                0xE1E5: 0x7812,
                0xE1E6: 0x7926,
                0xE1E7: 0x7820,
                0xE1E8: 0x792A,
                0xE1E9: 0x7845,
                0xE1EA: 0x788E,
                0xE1EB: 0x7874,
                0xE1EC: 0x7886,
                0xE1ED: 0x787C,
                0xE1EE: 0x789A,
                0xE1EF: 0x788C,
                0xE1F0: 0x78A3,
                0xE1F1: 0x78B5,
                0xE1F2: 0x78AA,
                0xE1F3: 0x78AF,
                0xE1F4: 0x78D1,
                0xE1F5: 0x78C6,
                0xE1F6: 0x78CB,
                0xE1F7: 0x78D4,
                0xE1F8: 0x78BE,
                0xE1F9: 0x78BC,
                0xE1FA: 0x78C5,
                0xE1FB: 0x78CA,
                0xE1FC: 0x78EC,
                0xE240: 0x78E7,
                0xE241: 0x78DA,
                0xE242: 0x78FD,
                0xE243: 0x78F4,
                0xE244: 0x7907,
                0xE245: 0x7912,
                0xE246: 0x7911,
                0xE247: 0x7919,
                0xE248: 0x792C,
                0xE249: 0x792B,
                0xE24A: 0x7940,
                0xE24B: 0x7960,
                0xE24C: 0x7957,
                0xE24D: 0x795F,
                0xE24E: 0x795A,
                0xE24F: 0x7955,
                0xE250: 0x7953,
                0xE251: 0x797A,
                0xE252: 0x797F,
                0xE253: 0x798A,
                0xE254: 0x799D,
                0xE255: 0x79A7,
                0xE256: 0x9F4B,
                0xE257: 0x79AA,
                0xE258: 0x79AE,
                0xE259: 0x79B3,
                0xE25A: 0x79B9,
                0xE25B: 0x79BA,
                0xE25C: 0x79C9,
                0xE25D: 0x79D5,
                0xE25E: 0x79E7,
                0xE25F: 0x79EC,
                0xE260: 0x79E1,
                0xE261: 0x79E3,
                0xE262: 0x7A08,
                0xE263: 0x7A0D,
                0xE264: 0x7A18,
                0xE265: 0x7A19,
                0xE266: 0x7A20,
                0xE267: 0x7A1F,
                0xE268: 0x7980,
                0xE269: 0x7A31,
                0xE26A: 0x7A3B,
                0xE26B: 0x7A3E,
                0xE26C: 0x7A37,
                0xE26D: 0x7A43,
                0xE26E: 0x7A57,
                0xE26F: 0x7A49,
                0xE270: 0x7A61,
                0xE271: 0x7A62,
                0xE272: 0x7A69,
                0xE273: 0x9F9D,
                0xE274: 0x7A70,
                0xE275: 0x7A79,
                0xE276: 0x7A7D,
                0xE277: 0x7A88,
                0xE278: 0x7A97,
                0xE279: 0x7A95,
                0xE27A: 0x7A98,
                0xE27B: 0x7A96,
                0xE27C: 0x7AA9,
                0xE27D: 0x7AC8,
                0xE27E: 0x7AB0,
                0xE280: 0x7AB6,
                0xE281: 0x7AC5,
                0xE282: 0x7AC4,
                0xE283: 0x7ABF,
                0xE284: 0x9083,
                0xE285: 0x7AC7,
                0xE286: 0x7ACA,
                0xE287: 0x7ACD,
                0xE288: 0x7ACF,
                0xE289: 0x7AD5,
                0xE28A: 0x7AD3,
                0xE28B: 0x7AD9,
                0xE28C: 0x7ADA,
                0xE28D: 0x7ADD,
                0xE28E: 0x7AE1,
                0xE28F: 0x7AE2,
                0xE290: 0x7AE6,
                0xE291: 0x7AED,
                0xE292: 0x7AF0,
                0xE293: 0x7B02,
                0xE294: 0x7B0F,
                0xE295: 0x7B0A,
                0xE296: 0x7B06,
                0xE297: 0x7B33,
                0xE298: 0x7B18,
                0xE299: 0x7B19,
                0xE29A: 0x7B1E,
                0xE29B: 0x7B35,
                0xE29C: 0x7B28,
                0xE29D: 0x7B36,
                0xE29E: 0x7B50,
                0xE29F: 0x7B7A,
                0xE2A0: 0x7B04,
                0xE2A1: 0x7B4D,
                0xE2A2: 0x7B0B,
                0xE2A3: 0x7B4C,
                0xE2A4: 0x7B45,
                0xE2A5: 0x7B75,
                0xE2A6: 0x7B65,
                0xE2A7: 0x7B74,
                0xE2A8: 0x7B67,
                0xE2A9: 0x7B70,
                0xE2AA: 0x7B71,
                0xE2AB: 0x7B6C,
                0xE2AC: 0x7B6E,
                0xE2AD: 0x7B9D,
                0xE2AE: 0x7B98,
                0xE2AF: 0x7B9F,
                0xE2B0: 0x7B8D,
                0xE2B1: 0x7B9C,
                0xE2B2: 0x7B9A,
                0xE2B3: 0x7B8B,
                0xE2B4: 0x7B92,
                0xE2B5: 0x7B8F,
                0xE2B6: 0x7B5D,
                0xE2B7: 0x7B99,
                0xE2B8: 0x7BCB,
                0xE2B9: 0x7BC1,
                0xE2BA: 0x7BCC,
                0xE2BB: 0x7BCF,
                0xE2BC: 0x7BB4,
                0xE2BD: 0x7BC6,
                0xE2BE: 0x7BDD,
                0xE2BF: 0x7BE9,
                0xE2C0: 0x7C11,
                0xE2C1: 0x7C14,
                0xE2C2: 0x7BE6,
                0xE2C3: 0x7BE5,
                0xE2C4: 0x7C60,
                0xE2C5: 0x7C00,
                0xE2C6: 0x7C07,
                0xE2C7: 0x7C13,
                0xE2C8: 0x7BF3,
                0xE2C9: 0x7BF7,
                0xE2CA: 0x7C17,
                0xE2CB: 0x7C0D,
                0xE2CC: 0x7BF6,
                0xE2CD: 0x7C23,
                0xE2CE: 0x7C27,
                0xE2CF: 0x7C2A,
                0xE2D0: 0x7C1F,
                0xE2D1: 0x7C37,
                0xE2D2: 0x7C2B,
                0xE2D3: 0x7C3D,
                0xE2D4: 0x7C4C,
                0xE2D5: 0x7C43,
                0xE2D6: 0x7C54,
                0xE2D7: 0x7C4F,
                0xE2D8: 0x7C40,
                0xE2D9: 0x7C50,
                0xE2DA: 0x7C58,
                0xE2DB: 0x7C5F,
                0xE2DC: 0x7C64,
                0xE2DD: 0x7C56,
                0xE2DE: 0x7C65,
                0xE2DF: 0x7C6C,
                0xE2E0: 0x7C75,
                0xE2E1: 0x7C83,
                0xE2E2: 0x7C90,
                0xE2E3: 0x7CA4,
                0xE2E4: 0x7CAD,
                0xE2E5: 0x7CA2,
                0xE2E6: 0x7CAB,
                0xE2E7: 0x7CA1,
                0xE2E8: 0x7CA8,
                0xE2E9: 0x7CB3,
                0xE2EA: 0x7CB2,
                0xE2EB: 0x7CB1,
                0xE2EC: 0x7CAE,
                0xE2ED: 0x7CB9,
                0xE2EE: 0x7CBD,
                0xE2EF: 0x7CC0,
                0xE2F0: 0x7CC5,
                0xE2F1: 0x7CC2,
                0xE2F2: 0x7CD8,
                0xE2F3: 0x7CD2,
                0xE2F4: 0x7CDC,
                0xE2F5: 0x7CE2,
                0xE2F6: 0x9B3B,
                0xE2F7: 0x7CEF,
                0xE2F8: 0x7CF2,
                0xE2F9: 0x7CF4,
                0xE2FA: 0x7CF6,
                0xE2FB: 0x7CFA,
                0xE2FC: 0x7D06,
                0xE340: 0x7D02,
                0xE341: 0x7D1C,
                0xE342: 0x7D15,
                0xE343: 0x7D0A,
                0xE344: 0x7D45,
                0xE345: 0x7D4B,
                0xE346: 0x7D2E,
                0xE347: 0x7D32,
                0xE348: 0x7D3F,
                0xE349: 0x7D35,
                0xE34A: 0x7D46,
                0xE34B: 0x7D73,
                0xE34C: 0x7D56,
                0xE34D: 0x7D4E,
                0xE34E: 0x7D72,
                0xE34F: 0x7D68,
                0xE350: 0x7D6E,
                0xE351: 0x7D4F,
                0xE352: 0x7D63,
                0xE353: 0x7D93,
                0xE354: 0x7D89,
                0xE355: 0x7D5B,
                0xE356: 0x7D8F,
                0xE357: 0x7D7D,
                0xE358: 0x7D9B,
                0xE359: 0x7DBA,
                0xE35A: 0x7DAE,
                0xE35B: 0x7DA3,
                0xE35C: 0x7DB5,
                0xE35D: 0x7DC7,
                0xE35E: 0x7DBD,
                0xE35F: 0x7DAB,
                0xE360: 0x7E3D,
                0xE361: 0x7DA2,
                0xE362: 0x7DAF,
                0xE363: 0x7DDC,
                0xE364: 0x7DB8,
                0xE365: 0x7D9F,
                0xE366: 0x7DB0,
                0xE367: 0x7DD8,
                0xE368: 0x7DDD,
                0xE369: 0x7DE4,
                0xE36A: 0x7DDE,
                0xE36B: 0x7DFB,
                0xE36C: 0x7DF2,
                0xE36D: 0x7DE1,
                0xE36E: 0x7E05,
                0xE36F: 0x7E0A,
                0xE370: 0x7E23,
                0xE371: 0x7E21,
                0xE372: 0x7E12,
                0xE373: 0x7E31,
                0xE374: 0x7E1F,
                0xE375: 0x7E09,
                0xE376: 0x7E0B,
                0xE377: 0x7E22,
                0xE378: 0x7E46,
                0xE379: 0x7E66,
                0xE37A: 0x7E3B,
                0xE37B: 0x7E35,
                0xE37C: 0x7E39,
                0xE37D: 0x7E43,
                0xE37E: 0x7E37,
                0xE380: 0x7E32,
                0xE381: 0x7E3A,
                0xE382: 0x7E67,
                0xE383: 0x7E5D,
                0xE384: 0x7E56,
                0xE385: 0x7E5E,
                0xE386: 0x7E59,
                0xE387: 0x7E5A,
                0xE388: 0x7E79,
                0xE389: 0x7E6A,
                0xE38A: 0x7E69,
                0xE38B: 0x7E7C,
                0xE38C: 0x7E7B,
                0xE38D: 0x7E83,
                0xE38E: 0x7DD5,
                0xE38F: 0x7E7D,
                0xE390: 0x8FAE,
                0xE391: 0x7E7F,
                0xE392: 0x7E88,
                0xE393: 0x7E89,
                0xE394: 0x7E8C,
                0xE395: 0x7E92,
                0xE396: 0x7E90,
                0xE397: 0x7E93,
                0xE398: 0x7E94,
                0xE399: 0x7E96,
                0xE39A: 0x7E8E,
                0xE39B: 0x7E9B,
                0xE39C: 0x7E9C,
                0xE39D: 0x7F38,
                0xE39E: 0x7F3A,
                0xE39F: 0x7F45,
                0xE3A0: 0x7F4C,
                0xE3A1: 0x7F4D,
                0xE3A2: 0x7F4E,
                0xE3A3: 0x7F50,
                0xE3A4: 0x7F51,
                0xE3A5: 0x7F55,
                0xE3A6: 0x7F54,
                0xE3A7: 0x7F58,
                0xE3A8: 0x7F5F,
                0xE3A9: 0x7F60,
                0xE3AA: 0x7F68,
                0xE3AB: 0x7F69,
                0xE3AC: 0x7F67,
                0xE3AD: 0x7F78,
                0xE3AE: 0x7F82,
                0xE3AF: 0x7F86,
                0xE3B0: 0x7F83,
                0xE3B1: 0x7F88,
                0xE3B2: 0x7F87,
                0xE3B3: 0x7F8C,
                0xE3B4: 0x7F94,
                0xE3B5: 0x7F9E,
                0xE3B6: 0x7F9D,
                0xE3B7: 0x7F9A,
                0xE3B8: 0x7FA3,
                0xE3B9: 0x7FAF,
                0xE3BA: 0x7FB2,
                0xE3BB: 0x7FB9,
                0xE3BC: 0x7FAE,
                0xE3BD: 0x7FB6,
                0xE3BE: 0x7FB8,
                0xE3BF: 0x8B71,
                0xE3C0: 0x7FC5,
                0xE3C1: 0x7FC6,
                0xE3C2: 0x7FCA,
                0xE3C3: 0x7FD5,
                0xE3C4: 0x7FD4,
                0xE3C5: 0x7FE1,
                0xE3C6: 0x7FE6,
                0xE3C7: 0x7FE9,
                0xE3C8: 0x7FF3,
                0xE3C9: 0x7FF9,
                0xE3CA: 0x98DC,
                0xE3CB: 0x8006,
                0xE3CC: 0x8004,
                0xE3CD: 0x800B,
                0xE3CE: 0x8012,
                0xE3CF: 0x8018,
                0xE3D0: 0x8019,
                0xE3D1: 0x801C,
                0xE3D2: 0x8021,
                0xE3D3: 0x8028,
                0xE3D4: 0x803F,
                0xE3D5: 0x803B,
                0xE3D6: 0x804A,
                0xE3D7: 0x8046,
                0xE3D8: 0x8052,
                0xE3D9: 0x8058,
                0xE3DA: 0x805A,
                0xE3DB: 0x805F,
                0xE3DC: 0x8062,
                0xE3DD: 0x8068,
                0xE3DE: 0x8073,
                0xE3DF: 0x8072,
                0xE3E0: 0x8070,
                0xE3E1: 0x8076,
                0xE3E2: 0x8079,
                0xE3E3: 0x807D,
                0xE3E4: 0x807F,
                0xE3E5: 0x8084,
                0xE3E6: 0x8086,
                0xE3E7: 0x8085,
                0xE3E8: 0x809B,
                0xE3E9: 0x8093,
                0xE3EA: 0x809A,
                0xE3EB: 0x80AD,
                0xE3EC: 0x5190,
                0xE3ED: 0x80AC,
                0xE3EE: 0x80DB,
                0xE3EF: 0x80E5,
                0xE3F0: 0x80D9,
                0xE3F1: 0x80DD,
                0xE3F2: 0x80C4,
                0xE3F3: 0x80DA,
                0xE3F4: 0x80D6,
                0xE3F5: 0x8109,
                0xE3F6: 0x80EF,
                0xE3F7: 0x80F1,
                0xE3F8: 0x811B,
                0xE3F9: 0x8129,
                0xE3FA: 0x8123,
                0xE3FB: 0x812F,
                0xE3FC: 0x814B,
                0xE440: 0x968B,
                0xE441: 0x8146,
                0xE442: 0x813E,
                0xE443: 0x8153,
                0xE444: 0x8151,
                0xE445: 0x80FC,
                0xE446: 0x8171,
                0xE447: 0x816E,
                0xE448: 0x8165,
                0xE449: 0x8166,
                0xE44A: 0x8174,
                0xE44B: 0x8183,
                0xE44C: 0x8188,
                0xE44D: 0x818A,
                0xE44E: 0x8180,
                0xE44F: 0x8182,
                0xE450: 0x81A0,
                0xE451: 0x8195,
                0xE452: 0x81A4,
                0xE453: 0x81A3,
                0xE454: 0x815F,
                0xE455: 0x8193,
                0xE456: 0x81A9,
                0xE457: 0x81B0,
                0xE458: 0x81B5,
                0xE459: 0x81BE,
                0xE45A: 0x81B8,
                0xE45B: 0x81BD,
                0xE45C: 0x81C0,
                0xE45D: 0x81C2,
                0xE45E: 0x81BA,
                0xE45F: 0x81C9,
                0xE460: 0x81CD,
                0xE461: 0x81D1,
                0xE462: 0x81D9,
                0xE463: 0x81D8,
                0xE464: 0x81C8,
                0xE465: 0x81DA,
                0xE466: 0x81DF,
                0xE467: 0x81E0,
                0xE468: 0x81E7,
                0xE469: 0x81FA,
                0xE46A: 0x81FB,
                0xE46B: 0x81FE,
                0xE46C: 0x8201,
                0xE46D: 0x8202,
                0xE46E: 0x8205,
                0xE46F: 0x8207,
                0xE470: 0x820A,
                0xE471: 0x820D,
                0xE472: 0x8210,
                0xE473: 0x8216,
                0xE474: 0x8229,
                0xE475: 0x822B,
                0xE476: 0x8238,
                0xE477: 0x8233,
                0xE478: 0x8240,
                0xE479: 0x8259,
                0xE47A: 0x8258,
                0xE47B: 0x825D,
                0xE47C: 0x825A,
                0xE47D: 0x825F,
                0xE47E: 0x8264,
                0xE480: 0x8262,
                0xE481: 0x8268,
                0xE482: 0x826A,
                0xE483: 0x826B,
                0xE484: 0x822E,
                0xE485: 0x8271,
                0xE486: 0x8277,
                0xE487: 0x8278,
                0xE488: 0x827E,
                0xE489: 0x828D,
                0xE48A: 0x8292,
                0xE48B: 0x82AB,
                0xE48C: 0x829F,
                0xE48D: 0x82BB,
                0xE48E: 0x82AC,
                0xE48F: 0x82E1,
                0xE490: 0x82E3,
                0xE491: 0x82DF,
                0xE492: 0x82D2,
                0xE493: 0x82F4,
                0xE494: 0x82F3,
                0xE495: 0x82FA,
                0xE496: 0x8393,
                0xE497: 0x8303,
                0xE498: 0x82FB,
                0xE499: 0x82F9,
                0xE49A: 0x82DE,
                0xE49B: 0x8306,
                0xE49C: 0x82DC,
                0xE49D: 0x8309,
                0xE49E: 0x82D9,
                0xE49F: 0x8335,
                0xE4A0: 0x8334,
                0xE4A1: 0x8316,
                0xE4A2: 0x8332,
                0xE4A3: 0x8331,
                0xE4A4: 0x8340,
                0xE4A5: 0x8339,
                0xE4A6: 0x8350,
                0xE4A7: 0x8345,
                0xE4A8: 0x832F,
                0xE4A9: 0x832B,
                0xE4AA: 0x8317,
                0xE4AB: 0x8318,
                0xE4AC: 0x8385,
                0xE4AD: 0x839A,
                0xE4AE: 0x83AA,
                0xE4AF: 0x839F,
                0xE4B0: 0x83A2,
                0xE4B1: 0x8396,
                0xE4B2: 0x8323,
                0xE4B3: 0x838E,
                0xE4B4: 0x8387,
                0xE4B5: 0x838A,
                0xE4B6: 0x837C,
                0xE4B7: 0x83B5,
                0xE4B8: 0x8373,
                0xE4B9: 0x8375,
                0xE4BA: 0x83A0,
                0xE4BB: 0x8389,
                0xE4BC: 0x83A8,
                0xE4BD: 0x83F4,
                0xE4BE: 0x8413,
                0xE4BF: 0x83EB,
                0xE4C0: 0x83CE,
                0xE4C1: 0x83FD,
                0xE4C2: 0x8403,
                0xE4C3: 0x83D8,
                0xE4C4: 0x840B,
                0xE4C5: 0x83C1,
                0xE4C6: 0x83F7,
                0xE4C7: 0x8407,
                0xE4C8: 0x83E0,
                0xE4C9: 0x83F2,
                0xE4CA: 0x840D,
                0xE4CB: 0x8422,
                0xE4CC: 0x8420,
                0xE4CD: 0x83BD,
                0xE4CE: 0x8438,
                0xE4CF: 0x8506,
                0xE4D0: 0x83FB,
                0xE4D1: 0x846D,
                0xE4D2: 0x842A,
                0xE4D3: 0x843C,
                0xE4D4: 0x855A,
                0xE4D5: 0x8484,
                0xE4D6: 0x8477,
                0xE4D7: 0x846B,
                0xE4D8: 0x84AD,
                0xE4D9: 0x846E,
                0xE4DA: 0x8482,
                0xE4DB: 0x8469,
                0xE4DC: 0x8446,
                0xE4DD: 0x842C,
                0xE4DE: 0x846F,
                0xE4DF: 0x8479,
                0xE4E0: 0x8435,
                0xE4E1: 0x84CA,
                0xE4E2: 0x8462,
                0xE4E3: 0x84B9,
                0xE4E4: 0x84BF,
                0xE4E5: 0x849F,
                0xE4E6: 0x84D9,
                0xE4E7: 0x84CD,
                0xE4E8: 0x84BB,
                0xE4E9: 0x84DA,
                0xE4EA: 0x84D0,
                0xE4EB: 0x84C1,
                0xE4EC: 0x84C6,
                0xE4ED: 0x84D6,
                0xE4EE: 0x84A1,
                0xE4EF: 0x8521,
                0xE4F0: 0x84FF,
                0xE4F1: 0x84F4,
                0xE4F2: 0x8517,
                0xE4F3: 0x8518,
                0xE4F4: 0x852C,
                0xE4F5: 0x851F,
                0xE4F6: 0x8515,
                0xE4F7: 0x8514,
                0xE4F8: 0x84FC,
                0xE4F9: 0x8540,
                0xE4FA: 0x8563,
                0xE4FB: 0x8558,
                0xE4FC: 0x8548,
                0xE540: 0x8541,
                0xE541: 0x8602,
                0xE542: 0x854B,
                0xE543: 0x8555,
                0xE544: 0x8580,
                0xE545: 0x85A4,
                0xE546: 0x8588,
                0xE547: 0x8591,
                0xE548: 0x858A,
                0xE549: 0x85A8,
                0xE54A: 0x856D,
                0xE54B: 0x8594,
                0xE54C: 0x859B,
                0xE54D: 0x85EA,
                0xE54E: 0x8587,
                0xE54F: 0x859C,
                0xE550: 0x8577,
                0xE551: 0x857E,
                0xE552: 0x8590,
                0xE553: 0x85C9,
                0xE554: 0x85BA,
                0xE555: 0x85CF,
                0xE556: 0x85B9,
                0xE557: 0x85D0,
                0xE558: 0x85D5,
                0xE559: 0x85DD,
                0xE55A: 0x85E5,
                0xE55B: 0x85DC,
                0xE55C: 0x85F9,
                0xE55D: 0x860A,
                0xE55E: 0x8613,
                0xE55F: 0x860B,
                0xE560: 0x85FE,
                0xE561: 0x85FA,
                0xE562: 0x8606,
                0xE563: 0x8622,
                0xE564: 0x861A,
                0xE565: 0x8630,
                0xE566: 0x863F,
                0xE567: 0x864D,
                0xE568: 0x4E55,
                0xE569: 0x8654,
                0xE56A: 0x865F,
                0xE56B: 0x8667,
                0xE56C: 0x8671,
                0xE56D: 0x8693,
                0xE56E: 0x86A3,
                0xE56F: 0x86A9,
                0xE570: 0x86AA,
                0xE571: 0x868B,
                0xE572: 0x868C,
                0xE573: 0x86B6,
                0xE574: 0x86AF,
                0xE575: 0x86C4,
                0xE576: 0x86C6,
                0xE577: 0x86B0,
                0xE578: 0x86C9,
                0xE579: 0x8823,
                0xE57A: 0x86AB,
                0xE57B: 0x86D4,
                0xE57C: 0x86DE,
                0xE57D: 0x86E9,
                0xE57E: 0x86EC,
                0xE580: 0x86DF,
                0xE581: 0x86DB,
                0xE582: 0x86EF,
                0xE583: 0x8712,
                0xE584: 0x8706,
                0xE585: 0x8708,
                0xE586: 0x8700,
                0xE587: 0x8703,
                0xE588: 0x86FB,
                0xE589: 0x8711,
                0xE58A: 0x8709,
                0xE58B: 0x870D,
                0xE58C: 0x86F9,
                0xE58D: 0x870A,
                0xE58E: 0x8734,
                0xE58F: 0x873F,
                0xE590: 0x8737,
                0xE591: 0x873B,
                0xE592: 0x8725,
                0xE593: 0x8729,
                0xE594: 0x871A,
                0xE595: 0x8760,
                0xE596: 0x875F,
                0xE597: 0x8778,
                0xE598: 0x874C,
                0xE599: 0x874E,
                0xE59A: 0x8774,
                0xE59B: 0x8757,
                0xE59C: 0x8768,
                0xE59D: 0x876E,
                0xE59E: 0x8759,
                0xE59F: 0x8753,
                0xE5A0: 0x8763,
                0xE5A1: 0x876A,
                0xE5A2: 0x8805,
                0xE5A3: 0x87A2,
                0xE5A4: 0x879F,
                0xE5A5: 0x8782,
                0xE5A6: 0x87AF,
                0xE5A7: 0x87CB,
                0xE5A8: 0x87BD,
                0xE5A9: 0x87C0,
                0xE5AA: 0x87D0,
                0xE5AB: 0x96D6,
                0xE5AC: 0x87AB,
                0xE5AD: 0x87C4,
                0xE5AE: 0x87B3,
                0xE5AF: 0x87C7,
                0xE5B0: 0x87C6,
                0xE5B1: 0x87BB,
                0xE5B2: 0x87EF,
                0xE5B3: 0x87F2,
                0xE5B4: 0x87E0,
                0xE5B5: 0x880F,
                0xE5B6: 0x880D,
                0xE5B7: 0x87FE,
                0xE5B8: 0x87F6,
                0xE5B9: 0x87F7,
                0xE5BA: 0x880E,
                0xE5BB: 0x87D2,
                0xE5BC: 0x8811,
                0xE5BD: 0x8816,
                0xE5BE: 0x8815,
                0xE5BF: 0x8822,
                0xE5C0: 0x8821,
                0xE5C1: 0x8831,
                0xE5C2: 0x8836,
                0xE5C3: 0x8839,
                0xE5C4: 0x8827,
                0xE5C5: 0x883B,
                0xE5C6: 0x8844,
                0xE5C7: 0x8842,
                0xE5C8: 0x8852,
                0xE5C9: 0x8859,
                0xE5CA: 0x885E,
                0xE5CB: 0x8862,
                0xE5CC: 0x886B,
                0xE5CD: 0x8881,
                0xE5CE: 0x887E,
                0xE5CF: 0x889E,
                0xE5D0: 0x8875,
                0xE5D1: 0x887D,
                0xE5D2: 0x88B5,
                0xE5D3: 0x8872,
                0xE5D4: 0x8882,
                0xE5D5: 0x8897,
                0xE5D6: 0x8892,
                0xE5D7: 0x88AE,
                0xE5D8: 0x8899,
                0xE5D9: 0x88A2,
                0xE5DA: 0x888D,
                0xE5DB: 0x88A4,
                0xE5DC: 0x88B0,
                0xE5DD: 0x88BF,
                0xE5DE: 0x88B1,
                0xE5DF: 0x88C3,
                0xE5E0: 0x88C4,
                0xE5E1: 0x88D4,
                0xE5E2: 0x88D8,
                0xE5E3: 0x88D9,
                0xE5E4: 0x88DD,
                0xE5E5: 0x88F9,
                0xE5E6: 0x8902,
                0xE5E7: 0x88FC,
                0xE5E8: 0x88F4,
                0xE5E9: 0x88E8,
                0xE5EA: 0x88F2,
                0xE5EB: 0x8904,
                0xE5EC: 0x890C,
                0xE5ED: 0x890A,
                0xE5EE: 0x8913,
                0xE5EF: 0x8943,
                0xE5F0: 0x891E,
                0xE5F1: 0x8925,
                0xE5F2: 0x892A,
                0xE5F3: 0x892B,
                0xE5F4: 0x8941,
                0xE5F5: 0x8944,
                0xE5F6: 0x893B,
                0xE5F7: 0x8936,
                0xE5F8: 0x8938,
                0xE5F9: 0x894C,
                0xE5FA: 0x891D,
                0xE5FB: 0x8960,
                0xE5FC: 0x895E,
                0xE640: 0x8966,
                0xE641: 0x8964,
                0xE642: 0x896D,
                0xE643: 0x896A,
                0xE644: 0x896F,
                0xE645: 0x8974,
                0xE646: 0x8977,
                0xE647: 0x897E,
                0xE648: 0x8983,
                0xE649: 0x8988,
                0xE64A: 0x898A,
                0xE64B: 0x8993,
                0xE64C: 0x8998,
                0xE64D: 0x89A1,
                0xE64E: 0x89A9,
                0xE64F: 0x89A6,
                0xE650: 0x89AC,
                0xE651: 0x89AF,
                0xE652: 0x89B2,
                0xE653: 0x89BA,
                0xE654: 0x89BD,
                0xE655: 0x89BF,
                0xE656: 0x89C0,
                0xE657: 0x89DA,
                0xE658: 0x89DC,
                0xE659: 0x89DD,
                0xE65A: 0x89E7,
                0xE65B: 0x89F4,
                0xE65C: 0x89F8,
                0xE65D: 0x8A03,
                0xE65E: 0x8A16,
                0xE65F: 0x8A10,
                0xE660: 0x8A0C,
                0xE661: 0x8A1B,
                0xE662: 0x8A1D,
                0xE663: 0x8A25,
                0xE664: 0x8A36,
                0xE665: 0x8A41,
                0xE666: 0x8A5B,
                0xE667: 0x8A52,
                0xE668: 0x8A46,
                0xE669: 0x8A48,
                0xE66A: 0x8A7C,
                0xE66B: 0x8A6D,
                0xE66C: 0x8A6C,
                0xE66D: 0x8A62,
                0xE66E: 0x8A85,
                0xE66F: 0x8A82,
                0xE670: 0x8A84,
                0xE671: 0x8AA8,
                0xE672: 0x8AA1,
                0xE673: 0x8A91,
                0xE674: 0x8AA5,
                0xE675: 0x8AA6,
                0xE676: 0x8A9A,
                0xE677: 0x8AA3,
                0xE678: 0x8AC4,
                0xE679: 0x8ACD,
                0xE67A: 0x8AC2,
                0xE67B: 0x8ADA,
                0xE67C: 0x8AEB,
                0xE67D: 0x8AF3,
                0xE67E: 0x8AE7,
                0xE680: 0x8AE4,
                0xE681: 0x8AF1,
                0xE682: 0x8B14,
                0xE683: 0x8AE0,
                0xE684: 0x8AE2,
                0xE685: 0x8AF7,
                0xE686: 0x8ADE,
                0xE687: 0x8ADB,
                0xE688: 0x8B0C,
                0xE689: 0x8B07,
                0xE68A: 0x8B1A,
                0xE68B: 0x8AE1,
                0xE68C: 0x8B16,
                0xE68D: 0x8B10,
                0xE68E: 0x8B17,
                0xE68F: 0x8B20,
                0xE690: 0x8B33,
                0xE691: 0x97AB,
                0xE692: 0x8B26,
                0xE693: 0x8B2B,
                0xE694: 0x8B3E,
                0xE695: 0x8B28,
                0xE696: 0x8B41,
                0xE697: 0x8B4C,
                0xE698: 0x8B4F,
                0xE699: 0x8B4E,
                0xE69A: 0x8B49,
                0xE69B: 0x8B56,
                0xE69C: 0x8B5B,
                0xE69D: 0x8B5A,
                0xE69E: 0x8B6B,
                0xE69F: 0x8B5F,
                0xE6A0: 0x8B6C,
                0xE6A1: 0x8B6F,
                0xE6A2: 0x8B74,
                0xE6A3: 0x8B7D,
                0xE6A4: 0x8B80,
                0xE6A5: 0x8B8C,
                0xE6A6: 0x8B8E,
                0xE6A7: 0x8B92,
                0xE6A8: 0x8B93,
                0xE6A9: 0x8B96,
                0xE6AA: 0x8B99,
                0xE6AB: 0x8B9A,
                0xE6AC: 0x8C3A,
                0xE6AD: 0x8C41,
                0xE6AE: 0x8C3F,
                0xE6AF: 0x8C48,
                0xE6B0: 0x8C4C,
                0xE6B1: 0x8C4E,
                0xE6B2: 0x8C50,
                0xE6B3: 0x8C55,
                0xE6B4: 0x8C62,
                0xE6B5: 0x8C6C,
                0xE6B6: 0x8C78,
                0xE6B7: 0x8C7A,
                0xE6B8: 0x8C82,
                0xE6B9: 0x8C89,
                0xE6BA: 0x8C85,
                0xE6BB: 0x8C8A,
                0xE6BC: 0x8C8D,
                0xE6BD: 0x8C8E,
                0xE6BE: 0x8C94,
                0xE6BF: 0x8C7C,
                0xE6C0: 0x8C98,
                0xE6C1: 0x621D,
                0xE6C2: 0x8CAD,
                0xE6C3: 0x8CAA,
                0xE6C4: 0x8CBD,
                0xE6C5: 0x8CB2,
                0xE6C6: 0x8CB3,
                0xE6C7: 0x8CAE,
                0xE6C8: 0x8CB6,
                0xE6C9: 0x8CC8,
                0xE6CA: 0x8CC1,
                0xE6CB: 0x8CE4,
                0xE6CC: 0x8CE3,
                0xE6CD: 0x8CDA,
                0xE6CE: 0x8CFD,
                0xE6CF: 0x8CFA,
                0xE6D0: 0x8CFB,
                0xE6D1: 0x8D04,
                0xE6D2: 0x8D05,
                0xE6D3: 0x8D0A,
                0xE6D4: 0x8D07,
                0xE6D5: 0x8D0F,
                0xE6D6: 0x8D0D,
                0xE6D7: 0x8D10,
                0xE6D8: 0x9F4E,
                0xE6D9: 0x8D13,
                0xE6DA: 0x8CCD,
                0xE6DB: 0x8D14,
                0xE6DC: 0x8D16,
                0xE6DD: 0x8D67,
                0xE6DE: 0x8D6D,
                0xE6DF: 0x8D71,
                0xE6E0: 0x8D73,
                0xE6E1: 0x8D81,
                0xE6E2: 0x8D99,
                0xE6E3: 0x8DC2,
                0xE6E4: 0x8DBE,
                0xE6E5: 0x8DBA,
                0xE6E6: 0x8DCF,
                0xE6E7: 0x8DDA,
                0xE6E8: 0x8DD6,
                0xE6E9: 0x8DCC,
                0xE6EA: 0x8DDB,
                0xE6EB: 0x8DCB,
                0xE6EC: 0x8DEA,
                0xE6ED: 0x8DEB,
                0xE6EE: 0x8DDF,
                0xE6EF: 0x8DE3,
                0xE6F0: 0x8DFC,
                0xE6F1: 0x8E08,
                0xE6F2: 0x8E09,
                0xE6F3: 0x8DFF,
                0xE6F4: 0x8E1D,
                0xE6F5: 0x8E1E,
                0xE6F6: 0x8E10,
                0xE6F7: 0x8E1F,
                0xE6F8: 0x8E42,
                0xE6F9: 0x8E35,
                0xE6FA: 0x8E30,
                0xE6FB: 0x8E34,
                0xE6FC: 0x8E4A,
                0xE740: 0x8E47,
                0xE741: 0x8E49,
                0xE742: 0x8E4C,
                0xE743: 0x8E50,
                0xE744: 0x8E48,
                0xE745: 0x8E59,
                0xE746: 0x8E64,
                0xE747: 0x8E60,
                0xE748: 0x8E2A,
                0xE749: 0x8E63,
                0xE74A: 0x8E55,
                0xE74B: 0x8E76,
                0xE74C: 0x8E72,
                0xE74D: 0x8E7C,
                0xE74E: 0x8E81,
                0xE74F: 0x8E87,
                0xE750: 0x8E85,
                0xE751: 0x8E84,
                0xE752: 0x8E8B,
                0xE753: 0x8E8A,
                0xE754: 0x8E93,
                0xE755: 0x8E91,
                0xE756: 0x8E94,
                0xE757: 0x8E99,
                0xE758: 0x8EAA,
                0xE759: 0x8EA1,
                0xE75A: 0x8EAC,
                0xE75B: 0x8EB0,
                0xE75C: 0x8EC6,
                0xE75D: 0x8EB1,
                0xE75E: 0x8EBE,
                0xE75F: 0x8EC5,
                0xE760: 0x8EC8,
                0xE761: 0x8ECB,
                0xE762: 0x8EDB,
                0xE763: 0x8EE3,
                0xE764: 0x8EFC,
                0xE765: 0x8EFB,
                0xE766: 0x8EEB,
                0xE767: 0x8EFE,
                0xE768: 0x8F0A,
                0xE769: 0x8F05,
                0xE76A: 0x8F15,
                0xE76B: 0x8F12,
                0xE76C: 0x8F19,
                0xE76D: 0x8F13,
                0xE76E: 0x8F1C,
                0xE76F: 0x8F1F,
                0xE770: 0x8F1B,
                0xE771: 0x8F0C,
                0xE772: 0x8F26,
                0xE773: 0x8F33,
                0xE774: 0x8F3B,
                0xE775: 0x8F39,
                0xE776: 0x8F45,
                0xE777: 0x8F42,
                0xE778: 0x8F3E,
                0xE779: 0x8F4C,
                0xE77A: 0x8F49,
                0xE77B: 0x8F46,
                0xE77C: 0x8F4E,
                0xE77D: 0x8F57,
                0xE77E: 0x8F5C,
                0xE780: 0x8F62,
                0xE781: 0x8F63,
                0xE782: 0x8F64,
                0xE783: 0x8F9C,
                0xE784: 0x8F9F,
                0xE785: 0x8FA3,
                0xE786: 0x8FAD,
                0xE787: 0x8FAF,
                0xE788: 0x8FB7,
                0xE789: 0x8FDA,
                0xE78A: 0x8FE5,
                0xE78B: 0x8FE2,
                0xE78C: 0x8FEA,
                0xE78D: 0x8FEF,
                0xE78E: 0x9087,
                0xE78F: 0x8FF4,
                0xE790: 0x9005,
                0xE791: 0x8FF9,
                0xE792: 0x8FFA,
                0xE793: 0x9011,
                0xE794: 0x9015,
                0xE795: 0x9021,
                0xE796: 0x900D,
                0xE797: 0x901E,
                0xE798: 0x9016,
                0xE799: 0x900B,
                0xE79A: 0x9027,
                0xE79B: 0x9036,
                0xE79C: 0x9035,
                0xE79D: 0x9039,
                0xE79E: 0x8FF8,
                0xE79F: 0x904F,
                0xE7A0: 0x9050,
                0xE7A1: 0x9051,
                0xE7A2: 0x9052,
                0xE7A3: 0x900E,
                0xE7A4: 0x9049,
                0xE7A5: 0x903E,
                0xE7A6: 0x9056,
                0xE7A7: 0x9058,
                0xE7A8: 0x905E,
                0xE7A9: 0x9068,
                0xE7AA: 0x906F,
                0xE7AB: 0x9076,
                0xE7AC: 0x96A8,
                0xE7AD: 0x9072,
                0xE7AE: 0x9082,
                0xE7AF: 0x907D,
                0xE7B0: 0x9081,
                0xE7B1: 0x9080,
                0xE7B2: 0x908A,
                0xE7B3: 0x9089,
                0xE7B4: 0x908F,
                0xE7B5: 0x90A8,
                0xE7B6: 0x90AF,
                0xE7B7: 0x90B1,
                0xE7B8: 0x90B5,
                0xE7B9: 0x90E2,
                0xE7BA: 0x90E4,
                0xE7BB: 0x6248,
                0xE7BC: 0x90DB,
                0xE7BD: 0x9102,
                0xE7BE: 0x9112,
                0xE7BF: 0x9119,
                0xE7C0: 0x9132,
                0xE7C1: 0x9130,
                0xE7C2: 0x914A,
                0xE7C3: 0x9156,
                0xE7C4: 0x9158,
                0xE7C5: 0x9163,
                0xE7C6: 0x9165,
                0xE7C7: 0x9169,
                0xE7C8: 0x9173,
                0xE7C9: 0x9172,
                0xE7CA: 0x918B,
                0xE7CB: 0x9189,
                0xE7CC: 0x9182,
                0xE7CD: 0x91A2,
                0xE7CE: 0x91AB,
                0xE7CF: 0x91AF,
                0xE7D0: 0x91AA,
                0xE7D1: 0x91B5,
                0xE7D2: 0x91B4,
                0xE7D3: 0x91BA,
                0xE7D4: 0x91C0,
                0xE7D5: 0x91C1,
                0xE7D6: 0x91C9,
                0xE7D7: 0x91CB,
                0xE7D8: 0x91D0,
                0xE7D9: 0x91D6,
                0xE7DA: 0x91DF,
                0xE7DB: 0x91E1,
                0xE7DC: 0x91DB,
                0xE7DD: 0x91FC,
                0xE7DE: 0x91F5,
                0xE7DF: 0x91F6,
                0xE7E0: 0x921E,
                0xE7E1: 0x91FF,
                0xE7E2: 0x9214,
                0xE7E3: 0x922C,
                0xE7E4: 0x9215,
                0xE7E5: 0x9211,
                0xE7E6: 0x925E,
                0xE7E7: 0x9257,
                0xE7E8: 0x9245,
                0xE7E9: 0x9249,
                0xE7EA: 0x9264,
                0xE7EB: 0x9248,
                0xE7EC: 0x9295,
                0xE7ED: 0x923F,
                0xE7EE: 0x924B,
                0xE7EF: 0x9250,
                0xE7F0: 0x929C,
                0xE7F1: 0x9296,
                0xE7F2: 0x9293,
                0xE7F3: 0x929B,
                0xE7F4: 0x925A,
                0xE7F5: 0x92CF,
                0xE7F6: 0x92B9,
                0xE7F7: 0x92B7,
                0xE7F8: 0x92E9,
                0xE7F9: 0x930F,
                0xE7FA: 0x92FA,
                0xE7FB: 0x9344,
                0xE7FC: 0x932E,
                0xE840: 0x9319,
                0xE841: 0x9322,
                0xE842: 0x931A,
                0xE843: 0x9323,
                0xE844: 0x933A,
                0xE845: 0x9335,
                0xE846: 0x933B,
                0xE847: 0x935C,
                0xE848: 0x9360,
                0xE849: 0x937C,
                0xE84A: 0x936E,
                0xE84B: 0x9356,
                0xE84C: 0x93B0,
                0xE84D: 0x93AC,
                0xE84E: 0x93AD,
                0xE84F: 0x9394,
                0xE850: 0x93B9,
                0xE851: 0x93D6,
                0xE852: 0x93D7,
                0xE853: 0x93E8,
                0xE854: 0x93E5,
                0xE855: 0x93D8,
                0xE856: 0x93C3,
                0xE857: 0x93DD,
                0xE858: 0x93D0,
                0xE859: 0x93C8,
                0xE85A: 0x93E4,
                0xE85B: 0x941A,
                0xE85C: 0x9414,
                0xE85D: 0x9413,
                0xE85E: 0x9403,
                0xE85F: 0x9407,
                0xE860: 0x9410,
                0xE861: 0x9436,
                0xE862: 0x942B,
                0xE863: 0x9435,
                0xE864: 0x9421,
                0xE865: 0x943A,
                0xE866: 0x9441,
                0xE867: 0x9452,
                0xE868: 0x9444,
                0xE869: 0x945B,
                0xE86A: 0x9460,
                0xE86B: 0x9462,
                0xE86C: 0x945E,
                0xE86D: 0x946A,
                0xE86E: 0x9229,
                0xE86F: 0x9470,
                0xE870: 0x9475,
                0xE871: 0x9477,
                0xE872: 0x947D,
                0xE873: 0x945A,
                0xE874: 0x947C,
                0xE875: 0x947E,
                0xE876: 0x9481,
                0xE877: 0x947F,
                0xE878: 0x9582,
                0xE879: 0x9587,
                0xE87A: 0x958A,
                0xE87B: 0x9594,
                0xE87C: 0x9596,
                0xE87D: 0x9598,
                0xE87E: 0x9599,
                0xE880: 0x95A0,
                0xE881: 0x95A8,
                0xE882: 0x95A7,
                0xE883: 0x95AD,
                0xE884: 0x95BC,
                0xE885: 0x95BB,
                0xE886: 0x95B9,
                0xE887: 0x95BE,
                0xE888: 0x95CA,
                0xE889: 0x6FF6,
                0xE88A: 0x95C3,
                0xE88B: 0x95CD,
                0xE88C: 0x95CC,
                0xE88D: 0x95D5,
                0xE88E: 0x95D4,
                0xE88F: 0x95D6,
                0xE890: 0x95DC,
                0xE891: 0x95E1,
                0xE892: 0x95E5,
                0xE893: 0x95E2,
                0xE894: 0x9621,
                0xE895: 0x9628,
                0xE896: 0x962E,
                0xE897: 0x962F,
                0xE898: 0x9642,
                0xE899: 0x964C,
                0xE89A: 0x964F,
                0xE89B: 0x964B,
                0xE89C: 0x9677,
                0xE89D: 0x965C,
                0xE89E: 0x965E,
                0xE89F: 0x965D,
                0xE8A0: 0x965F,
                0xE8A1: 0x9666,
                0xE8A2: 0x9672,
                0xE8A3: 0x966C,
                0xE8A4: 0x968D,
                0xE8A5: 0x9698,
                0xE8A6: 0x9695,
                0xE8A7: 0x9697,
                0xE8A8: 0x96AA,
                0xE8A9: 0x96A7,
                0xE8AA: 0x96B1,
                0xE8AB: 0x96B2,
                0xE8AC: 0x96B0,
                0xE8AD: 0x96B4,
                0xE8AE: 0x96B6,
                0xE8AF: 0x96B8,
                0xE8B0: 0x96B9,
                0xE8B1: 0x96CE,
                0xE8B2: 0x96CB,
                0xE8B3: 0x96C9,
                0xE8B4: 0x96CD,
                0xE8B5: 0x894D,
                0xE8B6: 0x96DC,
                0xE8B7: 0x970D,
                0xE8B8: 0x96D5,
                0xE8B9: 0x96F9,
                0xE8BA: 0x9704,
                0xE8BB: 0x9706,
                0xE8BC: 0x9708,
                0xE8BD: 0x9713,
                0xE8BE: 0x970E,
                0xE8BF: 0x9711,
                0xE8C0: 0x970F,
                0xE8C1: 0x9716,
                0xE8C2: 0x9719,
                0xE8C3: 0x9724,
                0xE8C4: 0x972A,
                0xE8C5: 0x9730,
                0xE8C6: 0x9739,
                0xE8C7: 0x973D,
                0xE8C8: 0x973E,
                0xE8C9: 0x9744,
                0xE8CA: 0x9746,
                0xE8CB: 0x9748,
                0xE8CC: 0x9742,
                0xE8CD: 0x9749,
                0xE8CE: 0x975C,
                0xE8CF: 0x9760,
                0xE8D0: 0x9764,
                0xE8D1: 0x9766,
                0xE8D2: 0x9768,
                0xE8D3: 0x52D2,
                0xE8D4: 0x976B,
                0xE8D5: 0x9771,
                0xE8D6: 0x9779,
                0xE8D7: 0x9785,
                0xE8D8: 0x977C,
                0xE8D9: 0x9781,
                0xE8DA: 0x977A,
                0xE8DB: 0x9786,
                0xE8DC: 0x978B,
                0xE8DD: 0x978F,
                0xE8DE: 0x9790,
                0xE8DF: 0x979C,
                0xE8E0: 0x97A8,
                0xE8E1: 0x97A6,
                0xE8E2: 0x97A3,
                0xE8E3: 0x97B3,
                0xE8E4: 0x97B4,
                0xE8E5: 0x97C3,
                0xE8E6: 0x97C6,
                0xE8E7: 0x97C8,
                0xE8E8: 0x97CB,
                0xE8E9: 0x97DC,
                0xE8EA: 0x97ED,
                0xE8EB: 0x9F4F,
                0xE8EC: 0x97F2,
                0xE8ED: 0x7ADF,
                0xE8EE: 0x97F6,
                0xE8EF: 0x97F5,
                0xE8F0: 0x980F,
                0xE8F1: 0x980C,
                0xE8F2: 0x9838,
                0xE8F3: 0x9824,
                0xE8F4: 0x9821,
                0xE8F5: 0x9837,
                0xE8F6: 0x983D,
                0xE8F7: 0x9846,
                0xE8F8: 0x984F,
                0xE8F9: 0x984B,
                0xE8FA: 0x986B,
                0xE8FB: 0x986F,
                0xE8FC: 0x9870,
                0xE940: 0x9871,
                0xE941: 0x9874,
                0xE942: 0x9873,
                0xE943: 0x98AA,
                0xE944: 0x98AF,
                0xE945: 0x98B1,
                0xE946: 0x98B6,
                0xE947: 0x98C4,
                0xE948: 0x98C3,
                0xE949: 0x98C6,
                0xE94A: 0x98E9,
                0xE94B: 0x98EB,
                0xE94C: 0x9903,
                0xE94D: 0x9909,
                0xE94E: 0x9912,
                0xE94F: 0x9914,
                0xE950: 0x9918,
                0xE951: 0x9921,
                0xE952: 0x991D,
                0xE953: 0x991E,
                0xE954: 0x9924,
                0xE955: 0x9920,
                0xE956: 0x992C,
                0xE957: 0x992E,
                0xE958: 0x993D,
                0xE959: 0x993E,
                0xE95A: 0x9942,
                0xE95B: 0x9949,
                0xE95C: 0x9945,
                0xE95D: 0x9950,
                0xE95E: 0x994B,
                0xE95F: 0x9951,
                0xE960: 0x9952,
                0xE961: 0x994C,
                0xE962: 0x9955,
                0xE963: 0x9997,
                0xE964: 0x9998,
                0xE965: 0x99A5,
                0xE966: 0x99AD,
                0xE967: 0x99AE,
                0xE968: 0x99BC,
                0xE969: 0x99DF,
                0xE96A: 0x99DB,
                0xE96B: 0x99DD,
                0xE96C: 0x99D8,
                0xE96D: 0x99D1,
                0xE96E: 0x99ED,
                0xE96F: 0x99EE,
                0xE970: 0x99F1,
                0xE971: 0x99F2,
                0xE972: 0x99FB,
                0xE973: 0x99F8,
                0xE974: 0x9A01,
                0xE975: 0x9A0F,
                0xE976: 0x9A05,
                0xE977: 0x99E2,
                0xE978: 0x9A19,
                0xE979: 0x9A2B,
                0xE97A: 0x9A37,
                0xE97B: 0x9A45,
                0xE97C: 0x9A42,
                0xE97D: 0x9A40,
                0xE97E: 0x9A43,
                0xE980: 0x9A3E,
                0xE981: 0x9A55,
                0xE982: 0x9A4D,
                0xE983: 0x9A5B,
                0xE984: 0x9A57,
                0xE985: 0x9A5F,
                0xE986: 0x9A62,
                0xE987: 0x9A65,
                0xE988: 0x9A64,
                0xE989: 0x9A69,
                0xE98A: 0x9A6B,
                0xE98B: 0x9A6A,
                0xE98C: 0x9AAD,
                0xE98D: 0x9AB0,
                0xE98E: 0x9ABC,
                0xE98F: 0x9AC0,
                0xE990: 0x9ACF,
                0xE991: 0x9AD1,
                0xE992: 0x9AD3,
                0xE993: 0x9AD4,
                0xE994: 0x9ADE,
                0xE995: 0x9ADF,
                0xE996: 0x9AE2,
                0xE997: 0x9AE3,
                0xE998: 0x9AE6,
                0xE999: 0x9AEF,
                0xE99A: 0x9AEB,
                0xE99B: 0x9AEE,
                0xE99C: 0x9AF4,
                0xE99D: 0x9AF1,
                0xE99E: 0x9AF7,
                0xE99F: 0x9AFB,
                0xE9A0: 0x9B06,
                0xE9A1: 0x9B18,
                0xE9A2: 0x9B1A,
                0xE9A3: 0x9B1F,
                0xE9A4: 0x9B22,
                0xE9A5: 0x9B23,
                0xE9A6: 0x9B25,
                0xE9A7: 0x9B27,
                0xE9A8: 0x9B28,
                0xE9A9: 0x9B29,
                0xE9AA: 0x9B2A,
                0xE9AB: 0x9B2E,
                0xE9AC: 0x9B2F,
                0xE9AD: 0x9B32,
                0xE9AE: 0x9B44,
                0xE9AF: 0x9B43,
                0xE9B0: 0x9B4F,
                0xE9B1: 0x9B4D,
                0xE9B2: 0x9B4E,
                0xE9B3: 0x9B51,
                0xE9B4: 0x9B58,
                0xE9B5: 0x9B74,
                0xE9B6: 0x9B93,
                0xE9B7: 0x9B83,
                0xE9B8: 0x9B91,
                0xE9B9: 0x9B96,
                0xE9BA: 0x9B97,
                0xE9BB: 0x9B9F,
                0xE9BC: 0x9BA0,
                0xE9BD: 0x9BA8,
                0xE9BE: 0x9BB4,
                0xE9BF: 0x9BC0,
                0xE9C0: 0x9BCA,
                0xE9C1: 0x9BB9,
                0xE9C2: 0x9BC6,
                0xE9C3: 0x9BCF,
                0xE9C4: 0x9BD1,
                0xE9C5: 0x9BD2,
                0xE9C6: 0x9BE3,
                0xE9C7: 0x9BE2,
                0xE9C8: 0x9BE4,
                0xE9C9: 0x9BD4,
                0xE9CA: 0x9BE1,
                0xE9CB: 0x9C3A,
                0xE9CC: 0x9BF2,
                0xE9CD: 0x9BF1,
                0xE9CE: 0x9BF0,
                0xE9CF: 0x9C15,
                0xE9D0: 0x9C14,
                0xE9D1: 0x9C09,
                0xE9D2: 0x9C13,
                0xE9D3: 0x9C0C,
                0xE9D4: 0x9C06,
                0xE9D5: 0x9C08,
                0xE9D6: 0x9C12,
                0xE9D7: 0x9C0A,
                0xE9D8: 0x9C04,
                0xE9D9: 0x9C2E,
                0xE9DA: 0x9C1B,
                0xE9DB: 0x9C25,
                0xE9DC: 0x9C24,
                0xE9DD: 0x9C21,
                0xE9DE: 0x9C30,
                0xE9DF: 0x9C47,
                0xE9E0: 0x9C32,
                0xE9E1: 0x9C46,
                0xE9E2: 0x9C3E,
                0xE9E3: 0x9C5A,
                0xE9E4: 0x9C60,
                0xE9E5: 0x9C67,
                0xE9E6: 0x9C76,
                0xE9E7: 0x9C78,
                0xE9E8: 0x9CE7,
                0xE9E9: 0x9CEC,
                0xE9EA: 0x9CF0,
                0xE9EB: 0x9D09,
                0xE9EC: 0x9D08,
                0xE9ED: 0x9CEB,
                0xE9EE: 0x9D03,
                0xE9EF: 0x9D06,
                0xE9F0: 0x9D2A,
                0xE9F1: 0x9D26,
                0xE9F2: 0x9DAF,
                0xE9F3: 0x9D23,
                0xE9F4: 0x9D1F,
                0xE9F5: 0x9D44,
                0xE9F6: 0x9D15,
                0xE9F7: 0x9D12,
                0xE9F8: 0x9D41,
                0xE9F9: 0x9D3F,
                0xE9FA: 0x9D3E,
                0xE9FB: 0x9D46,
                0xE9FC: 0x9D48,
                0xEA40: 0x9D5D,
                0xEA41: 0x9D5E,
                0xEA42: 0x9D64,
                0xEA43: 0x9D51,
                0xEA44: 0x9D50,
                0xEA45: 0x9D59,
                0xEA46: 0x9D72,
                0xEA47: 0x9D89,
                0xEA48: 0x9D87,
                0xEA49: 0x9DAB,
                0xEA4A: 0x9D6F,
                0xEA4B: 0x9D7A,
                0xEA4C: 0x9D9A,
                0xEA4D: 0x9DA4,
                0xEA4E: 0x9DA9,
                0xEA4F: 0x9DB2,
                0xEA50: 0x9DC4,
                0xEA51: 0x9DC1,
                0xEA52: 0x9DBB,
                0xEA53: 0x9DB8,
                0xEA54: 0x9DBA,
                0xEA55: 0x9DC6,
                0xEA56: 0x9DCF,
                0xEA57: 0x9DC2,
                0xEA58: 0x9DD9,
                0xEA59: 0x9DD3,
                0xEA5A: 0x9DF8,
                0xEA5B: 0x9DE6,
                0xEA5C: 0x9DED,
                0xEA5D: 0x9DEF,
                0xEA5E: 0x9DFD,
                0xEA5F: 0x9E1A,
                0xEA60: 0x9E1B,
                0xEA61: 0x9E1E,
                0xEA62: 0x9E75,
                0xEA63: 0x9E79,
                0xEA64: 0x9E7D,
                0xEA65: 0x9E81,
                0xEA66: 0x9E88,
                0xEA67: 0x9E8B,
                0xEA68: 0x9E8C,
                0xEA69: 0x9E92,
                0xEA6A: 0x9E95,
                0xEA6B: 0x9E91,
                0xEA6C: 0x9E9D,
                0xEA6D: 0x9EA5,
                0xEA6E: 0x9EA9,
                0xEA6F: 0x9EB8,
                0xEA70: 0x9EAA,
                0xEA71: 0x9EAD,
                0xEA72: 0x9761,
                0xEA73: 0x9ECC,
                0xEA74: 0x9ECE,
                0xEA75: 0x9ECF,
                0xEA76: 0x9ED0,
                0xEA77: 0x9ED4,
                0xEA78: 0x9EDC,
                0xEA79: 0x9EDE,
                0xEA7A: 0x9EDD,
                0xEA7B: 0x9EE0,
                0xEA7C: 0x9EE5,
                0xEA7D: 0x9EE8,
                0xEA7E: 0x9EEF,
                0xEA80: 0x9EF4,
                0xEA81: 0x9EF6,
                0xEA82: 0x9EF7,
                0xEA83: 0x9EF9,
                0xEA84: 0x9EFB,
                0xEA85: 0x9EFC,
                0xEA86: 0x9EFD,
                0xEA87: 0x9F07,
                0xEA88: 0x9F08,
                0xEA89: 0x76B7,
                0xEA8A: 0x9F15,
                0xEA8B: 0x9F21,
                0xEA8C: 0x9F2C,
                0xEA8D: 0x9F3E,
                0xEA8E: 0x9F4A,
                0xEA8F: 0x9F52,
                0xEA90: 0x9F54,
                0xEA91: 0x9F63,
                0xEA92: 0x9F5F,
                0xEA93: 0x9F60,
                0xEA94: 0x9F61,
                0xEA95: 0x9F66,
                0xEA96: 0x9F67,
                0xEA97: 0x9F6C,
                0xEA98: 0x9F6A,
                0xEA99: 0x9F77,
                0xEA9A: 0x9F72,
                0xEA9B: 0x9F76,
                0xEA9C: 0x9F95,
                0xEA9D: 0x9F9C,
                0xEA9E: 0x9FA0,
                0xEA9F: 0x582F,
                0xEAA0: 0x69C7,
                0xEAA1: 0x9059,
                0xEAA2: 0x7464,
                0xEAA3: 0x51DC,
                0xEAA4: 0x7199
            };
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly_1 = __webpack_require__(2);
            function runEuclideanAlgorithm(field, a, b, R) {
                var _a;
                // Assume a's degree is >= b's
                if (a.degree() < b.degree()) _a = [
                    b,
                    a
                ], a = _a[0], b = _a[1];
                var rLast = a;
                var r = b;
                var tLast = field.zero;
                var t = field.one;
                // Run Euclidean algorithm until r's degree is less than R/2
                while(r.degree() >= R / 2){
                    var rLastLast = rLast;
                    var tLastLast = tLast;
                    rLast = r;
                    tLast = t;
                    // Divide rLastLast by rLast, with quotient in q and remainder in r
                    if (rLast.isZero()) // Euclidean algorithm already terminated?
                    return null;
                    r = rLastLast;
                    var q = field.zero;
                    var denominatorLeadingTerm = rLast.getCoefficient(rLast.degree());
                    var dltInverse = field.inverse(denominatorLeadingTerm);
                    while(r.degree() >= rLast.degree() && !r.isZero()){
                        var degreeDiff = r.degree() - rLast.degree();
                        var scale = field.multiply(r.getCoefficient(r.degree()), dltInverse);
                        q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                        r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                    }
                    t = q.multiplyPoly(tLast).addOrSubtract(tLastLast);
                    if (r.degree() >= rLast.degree()) return null;
                }
                var sigmaTildeAtZero = t.getCoefficient(0);
                if (sigmaTildeAtZero === 0) return null;
                var inverse = field.inverse(sigmaTildeAtZero);
                return [
                    t.multiply(inverse),
                    r.multiply(inverse)
                ];
            }
            function findErrorLocations(field, errorLocator) {
                // This is a direct application of Chien's search
                var numErrors = errorLocator.degree();
                if (numErrors === 1) return [
                    errorLocator.getCoefficient(1)
                ];
                var result = new Array(numErrors);
                var errorCount = 0;
                for(var i = 1; i < field.size && errorCount < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                    result[errorCount] = field.inverse(i);
                    errorCount++;
                }
                if (errorCount !== numErrors) return null;
                return result;
            }
            function findErrorMagnitudes(field, errorEvaluator, errorLocations) {
                // This is directly applying Forney's Formula
                var s = errorLocations.length;
                var result = new Array(s);
                for(var i = 0; i < s; i++){
                    var xiInverse = field.inverse(errorLocations[i]);
                    var denominator = 1;
                    for(var j = 0; j < s; j++)if (i !== j) denominator = field.multiply(denominator, GenericGF_1.addOrSubtractGF(1, field.multiply(errorLocations[j], xiInverse)));
                    result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                    if (field.generatorBase !== 0) result[i] = field.multiply(result[i], xiInverse);
                }
                return result;
            }
            function decode(bytes, twoS) {
                var outputBytes = new Uint8ClampedArray(bytes.length);
                outputBytes.set(bytes);
                var field = new GenericGF_1.default(0x011D, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
                var poly = new GenericGFPoly_1.default(field, outputBytes);
                var syndromeCoefficients = new Uint8ClampedArray(twoS);
                var error = false;
                for(var s = 0; s < twoS; s++){
                    var evaluation = poly.evaluateAt(field.exp(s + field.generatorBase));
                    syndromeCoefficients[syndromeCoefficients.length - 1 - s] = evaluation;
                    if (evaluation !== 0) error = true;
                }
                if (!error) return outputBytes;
                var syndrome = new GenericGFPoly_1.default(field, syndromeCoefficients);
                var sigmaOmega = runEuclideanAlgorithm(field, field.buildMonomial(twoS, 1), syndrome, twoS);
                if (sigmaOmega === null) return null;
                var errorLocations = findErrorLocations(field, sigmaOmega[0]);
                if (errorLocations == null) return null;
                var errorMagnitudes = findErrorMagnitudes(field, sigmaOmega[1], errorLocations);
                for(var i = 0; i < errorLocations.length; i++){
                    var position = outputBytes.length - 1 - field.log(errorLocations[i]);
                    if (position < 0) return null;
                    outputBytes[position] = GenericGF_1.addOrSubtractGF(outputBytes[position], errorMagnitudes[i]);
                }
                return outputBytes;
            }
            exports.decode = decode;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.VERSIONS = [
                {
                    infoBits: null,
                    versionNumber: 1,
                    alignmentPatternCenters: [],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 7,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 13,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 17,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 2,
                    alignmentPatternCenters: [
                        6,
                        18
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 34
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 28
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 3,
                    alignmentPatternCenters: [
                        6,
                        22
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 15,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 55
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 4,
                    alignmentPatternCenters: [
                        6,
                        26
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 80
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 32
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 5,
                    alignmentPatternCenters: [
                        6,
                        30
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 43
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 6,
                    alignmentPatternCenters: [
                        6,
                        34
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 27
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x07C94,
                    versionNumber: 7,
                    alignmentPatternCenters: [
                        6,
                        22,
                        38
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 78
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 31
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x085BC,
                    versionNumber: 8,
                    alignmentPatternCenters: [
                        6,
                        24,
                        42
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 97
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 38
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 39
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 18
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x09A99,
                    versionNumber: 9,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0A4D3,
                    versionNumber: 10,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 69
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0BBF6,
                    versionNumber: 11,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 81
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 50
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 51
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0C762,
                    versionNumber: 12,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 92
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 93
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0D847,
                    versionNumber: 13,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 37
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 38
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0E60D,
                    versionNumber: 14,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46,
                        66
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 40
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0F928,
                    versionNumber: 15,
                    alignmentPatternCenters: [
                        6,
                        26,
                        48,
                        70
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 87
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 88
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x10B78,
                    versionNumber: 16,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 98
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 99
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1145D,
                    versionNumber: 17,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x12A17,
                    versionNumber: 18,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 120
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 121
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x13532,
                    versionNumber: 19,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 113
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 114
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 44
                                },
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 45
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 21
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x149A6,
                    versionNumber: 20,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x15683,
                    versionNumber: 21,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50,
                        72,
                        94
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x168C9,
                    versionNumber: 22,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 111
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 112
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x177EC,
                    versionNumber: 23,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        74,
                        102
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x18EC4,
                    versionNumber: 24,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 30,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x191E1,
                    versionNumber: 25,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 106
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1AFAB,
                    versionNumber: 26,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 114
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 33,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1B08E,
                    versionNumber: 27,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1CC1A,
                    versionNumber: 28,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98,
                        122
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1D33F,
                    versionNumber: 29,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 37,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1ED75,
                    versionNumber: 30,
                    alignmentPatternCenters: [
                        6,
                        26,
                        52,
                        78,
                        104,
                        130
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1F250,
                    versionNumber: 31,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82,
                        108,
                        134
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x209D5,
                    versionNumber: 32,
                    alignmentPatternCenters: [
                        6,
                        34,
                        60,
                        86,
                        112,
                        138
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x216F0,
                    versionNumber: 33,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x228BA,
                    versionNumber: 34,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118,
                        146
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 44,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 59,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2379F,
                    versionNumber: 35,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126,
                        150
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 39,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 41,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x24B0B,
                    versionNumber: 36,
                    alignmentPatternCenters: [
                        6,
                        24,
                        50,
                        76,
                        102,
                        128,
                        154
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 64,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2542E,
                    versionNumber: 37,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106,
                        132,
                        158
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 49,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 24,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x26A64,
                    versionNumber: 38,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110,
                        136,
                        162
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 48,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x27541,
                    versionNumber: 39,
                    alignmentPatternCenters: [
                        6,
                        26,
                        54,
                        82,
                        110,
                        138,
                        166
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 40,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 43,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 67,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x28C69,
                    versionNumber: 40,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142,
                        170
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 118
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 119
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 61,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                }
            ];
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            function squareToQuadrilateral(p1, p2, p3, p4) {
                var dx3 = p1.x - p2.x + p3.x - p4.x;
                var dy3 = p1.y - p2.y + p3.y - p4.y;
                if (dx3 === 0 && dy3 === 0) return {
                    a11: p2.x - p1.x,
                    a12: p2.y - p1.y,
                    a13: 0,
                    a21: p3.x - p2.x,
                    a22: p3.y - p2.y,
                    a23: 0,
                    a31: p1.x,
                    a32: p1.y,
                    a33: 1
                };
                else {
                    var dx1 = p2.x - p3.x;
                    var dx2 = p4.x - p3.x;
                    var dy1 = p2.y - p3.y;
                    var dy2 = p4.y - p3.y;
                    var denominator = dx1 * dy2 - dx2 * dy1;
                    var a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                    var a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                    return {
                        a11: p2.x - p1.x + a13 * p2.x,
                        a12: p2.y - p1.y + a13 * p2.y,
                        a13: a13,
                        a21: p4.x - p1.x + a23 * p4.x,
                        a22: p4.y - p1.y + a23 * p4.y,
                        a23: a23,
                        a31: p1.x,
                        a32: p1.y,
                        a33: 1
                    };
                }
            }
            function quadrilateralToSquare(p1, p2, p3, p4) {
                // Here, the adjoint serves as the inverse:
                var sToQ = squareToQuadrilateral(p1, p2, p3, p4);
                return {
                    a11: sToQ.a22 * sToQ.a33 - sToQ.a23 * sToQ.a32,
                    a12: sToQ.a13 * sToQ.a32 - sToQ.a12 * sToQ.a33,
                    a13: sToQ.a12 * sToQ.a23 - sToQ.a13 * sToQ.a22,
                    a21: sToQ.a23 * sToQ.a31 - sToQ.a21 * sToQ.a33,
                    a22: sToQ.a11 * sToQ.a33 - sToQ.a13 * sToQ.a31,
                    a23: sToQ.a13 * sToQ.a21 - sToQ.a11 * sToQ.a23,
                    a31: sToQ.a21 * sToQ.a32 - sToQ.a22 * sToQ.a31,
                    a32: sToQ.a12 * sToQ.a31 - sToQ.a11 * sToQ.a32,
                    a33: sToQ.a11 * sToQ.a22 - sToQ.a12 * sToQ.a21
                };
            }
            function times(a, b) {
                return {
                    a11: a.a11 * b.a11 + a.a21 * b.a12 + a.a31 * b.a13,
                    a12: a.a12 * b.a11 + a.a22 * b.a12 + a.a32 * b.a13,
                    a13: a.a13 * b.a11 + a.a23 * b.a12 + a.a33 * b.a13,
                    a21: a.a11 * b.a21 + a.a21 * b.a22 + a.a31 * b.a23,
                    a22: a.a12 * b.a21 + a.a22 * b.a22 + a.a32 * b.a23,
                    a23: a.a13 * b.a21 + a.a23 * b.a22 + a.a33 * b.a23,
                    a31: a.a11 * b.a31 + a.a21 * b.a32 + a.a31 * b.a33,
                    a32: a.a12 * b.a31 + a.a22 * b.a32 + a.a32 * b.a33,
                    a33: a.a13 * b.a31 + a.a23 * b.a32 + a.a33 * b.a33
                };
            }
            function extract(image, location) {
                var qToS = quadrilateralToSquare({
                    x: 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 6.5,
                    y: location.dimension - 6.5
                }, {
                    x: 3.5,
                    y: location.dimension - 3.5
                });
                var sToQ = squareToQuadrilateral(location.topLeft, location.topRight, location.alignmentPattern, location.bottomLeft);
                var transform = times(sToQ, qToS);
                var matrix = BitMatrix_1.BitMatrix.createEmpty(location.dimension, location.dimension);
                var mappingFunction = function(x, y) {
                    var denominator = transform.a13 * x + transform.a23 * y + transform.a33;
                    return {
                        x: (transform.a11 * x + transform.a21 * y + transform.a31) / denominator,
                        y: (transform.a12 * x + transform.a22 * y + transform.a32) / denominator
                    };
                };
                for(var y = 0; y < location.dimension; y++)for(var x = 0; x < location.dimension; x++){
                    var xValue = x + 0.5;
                    var yValue = y + 0.5;
                    var sourcePixel = mappingFunction(xValue, yValue);
                    matrix.set(x, y, image.get(Math.floor(sourcePixel.x), Math.floor(sourcePixel.y)));
                }
                return {
                    matrix: matrix,
                    mappingFunction: mappingFunction
                };
            }
            exports.extract = extract;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var MAX_FINDERPATTERNS_TO_SEARCH = 4;
            var MIN_QUAD_RATIO = 0.5;
            var MAX_QUAD_RATIO = 1.5;
            var distance = function(a, b) {
                return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
            };
            function sum(values) {
                return values.reduce(function(a, b) {
                    return a + b;
                });
            }
            // Takes three finder patterns and organizes them into topLeft, topRight, etc
            function reorderFinderPatterns(pattern1, pattern2, pattern3) {
                var _a, _b, _c, _d;
                // Find distances between pattern centers
                var oneTwoDistance = distance(pattern1, pattern2);
                var twoThreeDistance = distance(pattern2, pattern3);
                var oneThreeDistance = distance(pattern1, pattern3);
                var bottomLeft;
                var topLeft;
                var topRight;
                // Assume one closest to other two is B; A and C will just be guesses at first
                if (twoThreeDistance >= oneTwoDistance && twoThreeDistance >= oneThreeDistance) _a = [
                    pattern2,
                    pattern1,
                    pattern3
                ], bottomLeft = _a[0], topLeft = _a[1], topRight = _a[2];
                else if (oneThreeDistance >= twoThreeDistance && oneThreeDistance >= oneTwoDistance) _b = [
                    pattern1,
                    pattern2,
                    pattern3
                ], bottomLeft = _b[0], topLeft = _b[1], topRight = _b[2];
                else _c = [
                    pattern1,
                    pattern3,
                    pattern2
                ], bottomLeft = _c[0], topLeft = _c[1], topRight = _c[2];
                // Use cross product to figure out whether bottomLeft (A) and topRight (C) are correct or flipped in relation to topLeft (B)
                // This asks whether BC x BA has a positive z component, which is the arrangement we want. If it's negative, then
                // we've got it flipped around and should swap topRight and bottomLeft.
                if ((topRight.x - topLeft.x) * (bottomLeft.y - topLeft.y) - (topRight.y - topLeft.y) * (bottomLeft.x - topLeft.x) < 0) _d = [
                    topRight,
                    bottomLeft
                ], bottomLeft = _d[0], topRight = _d[1];
                return {
                    bottomLeft: bottomLeft,
                    topLeft: topLeft,
                    topRight: topRight
                };
            }
            // Computes the dimension (number of modules on a side) of the QR Code based on the position of the finder patterns
            function computeDimension(topLeft, topRight, bottomLeft, matrix) {
                var moduleSize = (sum(countBlackWhiteRun(topLeft, bottomLeft, matrix, 5)) / 7 + // Divide by 7 since the ratio is 1:1:3:1:1
                sum(countBlackWhiteRun(topLeft, topRight, matrix, 5)) / 7 + sum(countBlackWhiteRun(bottomLeft, topLeft, matrix, 5)) / 7 + sum(countBlackWhiteRun(topRight, topLeft, matrix, 5)) / 7) / 4;
                if (moduleSize < 1) throw new Error("Invalid module size");
                var topDimension = Math.round(distance(topLeft, topRight) / moduleSize);
                var sideDimension = Math.round(distance(topLeft, bottomLeft) / moduleSize);
                var dimension = Math.floor((topDimension + sideDimension) / 2) + 7;
                switch(dimension % 4){
                    case 0:
                        dimension++;
                        break;
                    case 2:
                        dimension--;
                        break;
                }
                return {
                    dimension: dimension,
                    moduleSize: moduleSize
                };
            }
            // Takes an origin point and an end point and counts the sizes of the black white run from the origin towards the end point.
            // Returns an array of elements, representing the pixel size of the black white run.
            // Uses a variant of http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            function countBlackWhiteRunTowardsPoint(origin, end, matrix, length) {
                var switchPoints = [
                    {
                        x: Math.floor(origin.x),
                        y: Math.floor(origin.y)
                    }
                ];
                var steep = Math.abs(end.y - origin.y) > Math.abs(end.x - origin.x);
                var fromX;
                var fromY;
                var toX;
                var toY;
                if (steep) {
                    fromX = Math.floor(origin.y);
                    fromY = Math.floor(origin.x);
                    toX = Math.floor(end.y);
                    toY = Math.floor(end.x);
                } else {
                    fromX = Math.floor(origin.x);
                    fromY = Math.floor(origin.y);
                    toX = Math.floor(end.x);
                    toY = Math.floor(end.y);
                }
                var dx = Math.abs(toX - fromX);
                var dy = Math.abs(toY - fromY);
                var error = Math.floor(-dx / 2);
                var xStep = fromX < toX ? 1 : -1;
                var yStep = fromY < toY ? 1 : -1;
                var currentPixel = true;
                // Loop up until x == toX, but not beyond
                for(var x = fromX, y = fromY; x !== toX + xStep; x += xStep){
                    // Does current pixel mean we have moved white to black or vice versa?
                    // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                    // color, advance to next state or end if we are in state 2 already
                    var realX = steep ? y : x;
                    var realY = steep ? x : y;
                    if (matrix.get(realX, realY) !== currentPixel) {
                        currentPixel = !currentPixel;
                        switchPoints.push({
                            x: realX,
                            y: realY
                        });
                        if (switchPoints.length === length + 1) break;
                    }
                    error += dy;
                    if (error > 0) {
                        if (y === toY) break;
                        y += yStep;
                        error -= dx;
                    }
                }
                var distances = [];
                for(var i = 0; i < length; i++)if (switchPoints[i] && switchPoints[i + 1]) distances.push(distance(switchPoints[i], switchPoints[i + 1]));
                else distances.push(0);
                return distances;
            }
            // Takes an origin point and an end point and counts the sizes of the black white run in the origin point
            // along the line that intersects with the end point. Returns an array of elements, representing the pixel sizes
            // of the black white run. Takes a length which represents the number of switches from black to white to look for.
            function countBlackWhiteRun(origin, end, matrix, length) {
                var _a;
                var rise = end.y - origin.y;
                var run = end.x - origin.x;
                var towardsEnd = countBlackWhiteRunTowardsPoint(origin, end, matrix, Math.ceil(length / 2));
                var awayFromEnd = countBlackWhiteRunTowardsPoint(origin, {
                    x: origin.x - run,
                    y: origin.y - rise
                }, matrix, Math.ceil(length / 2));
                var middleValue = towardsEnd.shift() + awayFromEnd.shift() - 1; // Substract one so we don't double count a pixel
                return (_a = awayFromEnd.concat(middleValue)).concat.apply(_a, towardsEnd);
            }
            // Takes in a black white run and an array of expected ratios. Returns the average size of the run as well as the "error" -
            // that is the amount the run diverges from the expected ratio
            function scoreBlackWhiteRun(sequence, ratios) {
                var averageSize = sum(sequence) / sum(ratios);
                var error = 0;
                ratios.forEach(function(ratio, i) {
                    error += Math.pow(sequence[i] - ratio * averageSize, 2);
                });
                return {
                    averageSize: averageSize,
                    error: error
                };
            }
            // Takes an X,Y point and an array of sizes and scores the point against those ratios.
            // For example for a finder pattern takes the ratio list of 1:1:3:1:1 and checks horizontal, vertical and diagonal ratios
            // against that.
            function scorePattern(point, ratios, matrix) {
                try {
                    var horizontalRun = countBlackWhiteRun(point, {
                        x: -1,
                        y: point.y
                    }, matrix, ratios.length);
                    var verticalRun = countBlackWhiteRun(point, {
                        x: point.x,
                        y: -1
                    }, matrix, ratios.length);
                    var topLeftPoint = {
                        x: Math.max(0, point.x - point.y) - 1,
                        y: Math.max(0, point.y - point.x) - 1
                    };
                    var topLeftBottomRightRun = countBlackWhiteRun(point, topLeftPoint, matrix, ratios.length);
                    var bottomLeftPoint = {
                        x: Math.min(matrix.width, point.x + point.y) + 1,
                        y: Math.min(matrix.height, point.y + point.x) + 1
                    };
                    var bottomLeftTopRightRun = countBlackWhiteRun(point, bottomLeftPoint, matrix, ratios.length);
                    var horzError = scoreBlackWhiteRun(horizontalRun, ratios);
                    var vertError = scoreBlackWhiteRun(verticalRun, ratios);
                    var diagDownError = scoreBlackWhiteRun(topLeftBottomRightRun, ratios);
                    var diagUpError = scoreBlackWhiteRun(bottomLeftTopRightRun, ratios);
                    var ratioError = Math.sqrt(horzError.error * horzError.error + vertError.error * vertError.error + diagDownError.error * diagDownError.error + diagUpError.error * diagUpError.error);
                    var avgSize = (horzError.averageSize + vertError.averageSize + diagDownError.averageSize + diagUpError.averageSize) / 4;
                    var sizeError = (Math.pow(horzError.averageSize - avgSize, 2) + Math.pow(vertError.averageSize - avgSize, 2) + Math.pow(diagDownError.averageSize - avgSize, 2) + Math.pow(diagUpError.averageSize - avgSize, 2)) / avgSize;
                    return ratioError + sizeError;
                } catch (_a) {
                    return Infinity;
                }
            }
            function recenterLocation(matrix, p) {
                var leftX = Math.round(p.x);
                while(matrix.get(leftX, Math.round(p.y)))leftX--;
                var rightX = Math.round(p.x);
                while(matrix.get(rightX, Math.round(p.y)))rightX++;
                var x = (leftX + rightX) / 2;
                var topY = Math.round(p.y);
                while(matrix.get(Math.round(x), topY))topY--;
                var bottomY = Math.round(p.y);
                while(matrix.get(Math.round(x), bottomY))bottomY++;
                var y = (topY + bottomY) / 2;
                return {
                    x: x,
                    y: y
                };
            }
            function locate(matrix) {
                var finderPatternQuads = [];
                var activeFinderPatternQuads = [];
                var alignmentPatternQuads = [];
                var activeAlignmentPatternQuads = [];
                var _loop_1 = function(y) {
                    var length_1 = 0;
                    var lastBit = false;
                    var scans = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    var _loop_2 = function(x) {
                        var v = matrix.get(x, y);
                        if (v === lastBit) length_1++;
                        else {
                            scans = [
                                scans[1],
                                scans[2],
                                scans[3],
                                scans[4],
                                length_1
                            ];
                            length_1 = 1;
                            lastBit = v;
                            // Do the last 5 color changes ~ match the expected ratio for a finder pattern? 1:1:3:1:1 of b:w:b:w:b
                            var averageFinderPatternBlocksize = sum(scans) / 7;
                            var validFinderPattern = Math.abs(scans[0] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[1] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[2] - 3 * averageFinderPatternBlocksize) < 3 * averageFinderPatternBlocksize && Math.abs(scans[3] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[4] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && !v; // And make sure the current pixel is white since finder patterns are bordered in white
                            // Do the last 3 color changes ~ match the expected ratio for an alignment pattern? 1:1:1 of w:b:w
                            var averageAlignmentPatternBlocksize = sum(scans.slice(-3)) / 3;
                            var validAlignmentPattern = Math.abs(scans[2] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[3] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[4] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && v; // Is the current pixel black since alignment patterns are bordered in black
                            if (validFinderPattern) {
                                // Compute the start and end x values of the large center black square
                                var endX_1 = x - scans[3] - scans[4];
                                var startX_1 = endX_1 - scans[2];
                                var line = {
                                    startX: startX_1,
                                    endX: endX_1,
                                    y: y
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeFinderPatternQuads.filter(function(q) {
                                    return startX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || endX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || startX_1 <= q.bottom.startX && endX_1 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeFinderPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                            if (validAlignmentPattern) {
                                // Compute the start and end x values of the center black square
                                var endX_2 = x - scans[4];
                                var startX_2 = endX_2 - scans[3];
                                var line = {
                                    startX: startX_2,
                                    y: y,
                                    endX: endX_2
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeAlignmentPatternQuads.filter(function(q) {
                                    return startX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || endX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || startX_2 <= q.bottom.startX && endX_2 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeAlignmentPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                        }
                    };
                    for(var x = -1; x <= matrix.width; x++)_loop_2(x);
                    finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y !== y && q.bottom.y - q.top.y >= 2;
                    }));
                    activeFinderPatternQuads = activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                    alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y !== y;
                    }));
                    activeAlignmentPatternQuads = activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                };
                for(var y = 0; y <= matrix.height; y++)_loop_1(y);
                finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }));
                alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads);
                var finderPatternGroups = finderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }) // All quads must be at least 2px tall since the center square is larger than a block
                .map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.round(x), Math.round(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var score = scorePattern({
                        x: Math.round(x),
                        y: Math.round(y)
                    }, [
                        1,
                        1,
                        3,
                        1,
                        1
                    ], matrix);
                    return {
                        score: score,
                        x: x,
                        y: y,
                        size: size
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected quads from above
                .sort(function(a, b) {
                    return a.score - b.score;
                })// Now take the top finder pattern options and try to find 2 other options with a similar size.
                .map(function(point, i, finderPatterns) {
                    if (i > MAX_FINDERPATTERNS_TO_SEARCH) return null;
                    var otherPoints = finderPatterns.filter(function(p, ii) {
                        return i !== ii;
                    }).map(function(p) {
                        return {
                            x: p.x,
                            y: p.y,
                            score: p.score + Math.pow(p.size - point.size, 2) / point.size,
                            size: p.size
                        };
                    }).sort(function(a, b) {
                        return a.score - b.score;
                    });
                    if (otherPoints.length < 2) return null;
                    var score = point.score + otherPoints[0].score + otherPoints[1].score;
                    return {
                        points: [
                            point
                        ].concat(otherPoints.slice(0, 2)),
                        score: score
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected finder patterns from above
                .sort(function(a, b) {
                    return a.score - b.score;
                });
                if (finderPatternGroups.length === 0) return null;
                var _a = reorderFinderPatterns(finderPatternGroups[0].points[0], finderPatternGroups[0].points[1], finderPatternGroups[0].points[2]), topRight = _a.topRight, topLeft = _a.topLeft, bottomLeft = _a.bottomLeft;
                var alignment = findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft);
                var result = [];
                if (alignment) result.push({
                    alignmentPattern: {
                        x: alignment.alignmentPattern.x,
                        y: alignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: bottomLeft.x,
                        y: bottomLeft.y
                    },
                    dimension: alignment.dimension,
                    topLeft: {
                        x: topLeft.x,
                        y: topLeft.y
                    },
                    topRight: {
                        x: topRight.x,
                        y: topRight.y
                    }
                });
                // We normally use the center of the quads as the location of the tracking points, which is optimal for most cases and will account
                // for a skew in the image. However, In some cases, a slight skew might not be real and instead be caused by image compression
                // errors and/or low resolution. For those cases, we'd be better off centering the point exactly in the middle of the black area. We
                // compute and return the location data for the naively centered points as it is little additional work and allows for multiple
                // attempts at decoding harder images.
                var midTopRight = recenterLocation(matrix, topRight);
                var midTopLeft = recenterLocation(matrix, topLeft);
                var midBottomLeft = recenterLocation(matrix, bottomLeft);
                var centeredAlignment = findAlignmentPattern(matrix, alignmentPatternQuads, midTopRight, midTopLeft, midBottomLeft);
                if (centeredAlignment) result.push({
                    alignmentPattern: {
                        x: centeredAlignment.alignmentPattern.x,
                        y: centeredAlignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: midBottomLeft.x,
                        y: midBottomLeft.y
                    },
                    topLeft: {
                        x: midTopLeft.x,
                        y: midTopLeft.y
                    },
                    topRight: {
                        x: midTopRight.x,
                        y: midTopRight.y
                    },
                    dimension: centeredAlignment.dimension
                });
                if (result.length === 0) return null;
                return result;
            }
            exports.locate = locate;
            function findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft) {
                var _a;
                // Now that we've found the three finder patterns we can determine the blockSize and the size of the QR code.
                // We'll use these to help find the alignment pattern but also later when we do the extraction.
                var dimension;
                var moduleSize;
                try {
                    _a = computeDimension(topLeft, topRight, bottomLeft, matrix), dimension = _a.dimension, moduleSize = _a.moduleSize;
                } catch (e) {
                    return null;
                }
                // Now find the alignment pattern
                var bottomRightFinderPattern = {
                    x: topRight.x - topLeft.x + bottomLeft.x,
                    y: topRight.y - topLeft.y + bottomLeft.y
                };
                var modulesBetweenFinderPatterns = (distance(topLeft, bottomLeft) + distance(topLeft, topRight)) / 2 / moduleSize;
                var correctionToTopLeft = 1 - 3 / modulesBetweenFinderPatterns;
                var expectedAlignmentPattern = {
                    x: topLeft.x + correctionToTopLeft * (bottomRightFinderPattern.x - topLeft.x),
                    y: topLeft.y + correctionToTopLeft * (bottomRightFinderPattern.y - topLeft.y)
                };
                var alignmentPatterns = alignmentPatternQuads.map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.floor(x), Math.floor(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var sizeScore = scorePattern({
                        x: Math.floor(x),
                        y: Math.floor(y)
                    }, [
                        1,
                        1,
                        1
                    ], matrix);
                    var score = sizeScore + distance({
                        x: x,
                        y: y
                    }, expectedAlignmentPattern);
                    return {
                        x: x,
                        y: y,
                        score: score
                    };
                }).filter(function(v) {
                    return !!v;
                }).sort(function(a, b) {
                    return a.score - b.score;
                });
                // If there are less than 15 modules between finder patterns it's a version 1 QR code and as such has no alignmemnt pattern
                // so we can only use our best guess.
                var alignmentPattern = modulesBetweenFinderPatterns >= 15 && alignmentPatterns.length ? alignmentPatterns[0] : expectedAlignmentPattern;
                return {
                    alignmentPattern: alignmentPattern,
                    dimension: dimension
                };
            }
        /***/ }
    ])["default"];
});



var $jTCZr = parcelRequire("jTCZr");
/**
 * Prefer the native detector, but only where it actually decodes.
 *
 * Chrome exposes BarcodeDetector on platforms whose backing service is missing —
 * on Android it is a Play Services module fetched on demand — and there detect()
 * resolves to an empty array instead of throwing. So probe it once, and never
 * trust it as the only decoder.
 */ async function $aaa02bae484d7075$var$makeDetector() {
    try {
        if (!('BarcodeDetector' in window)) return null;
        const formats = await window.BarcodeDetector.getSupportedFormats();
        if (!formats.includes('qr_code')) return null;
        return new window.BarcodeDetector({
            formats: [
                'qr_code'
            ]
        });
    } catch  {
        return null;
    }
}
function $aaa02bae484d7075$export$2e2bcd8739ae039({ onDetected: onDetected, onClose: onClose, height: height = 240 }) {
    const { t: t } = (0, $LNQP4.default)();
    const videoRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const rafRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const [error, setError] = (0, $acw62.useState)('');
    // Held in a ref so a fresh inline callback from the parent can't retrigger the
    // effect and tear the camera down mid-scan.
    const onDetectedRef = (0, $acw62.useRef)(onDetected);
    (0, $acw62.useEffect)(()=>{
        onDetectedRef.current = onDetected;
    }, [
        onDetected
    ]);
    const stopScan = (0, $acw62.useCallback)(()=>{
        if (rafRef.current) cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
        if (streamRef.current) {
            streamRef.current.getTracks().forEach((text)=>text.stop());
            streamRef.current = null;
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        // Decode from a canvas frame. Works in every browser with a camera. Kept at
        // capture resolution — shrinking the frame shrinks the QR's modules and is
        // the quickest way to make a code stop being readable.
        const MAX_EDGE = 1280;
        function decodeWithJsQr(video) {
            const vw = video.videoWidth;
            const vh = video.videoHeight;
            if (!vw || !vh) return null; // metadata not in yet
            const scale = Math.min(1, MAX_EDGE / Math.max(vw, vh));
            const w = Math.round(vw * scale);
            const h = Math.round(vh * scale);
            const canvas = canvasRef.current ||= document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d', {
                willReadFrequently: true
            });
            ctx.drawImage(video, 0, 0, w, h);
            const { data: data } = ctx.getImageData(0, 0, w, h);
            const result = (0, (/*@__PURE__*/$parcel$interopDefault($698642d9a9b49d3e$exports)))(data, w, h, {
                inversionAttempts: 'attemptBoth'
            });
            return result?.data || null;
        }
        async function start() {
            let stream;
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    // A sharp stream matters: at the default resolution a QR's modules can
                    // be too few pixels wide to resolve. `ideal` degrades gracefully.
                    video: {
                        facingMode: 'environment',
                        width: {
                            ideal: 1280
                        },
                        height: {
                            ideal: 720
                        }
                    }
                });
            } catch  {
                if (mounted) setError(t('errors.camera.unavailable'));
                return;
            }
            if (!mounted) {
                stream.getTracks().forEach((text)=>text.stop());
                return;
            }
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                try {
                    await videoRef.current.play();
                } catch  {}
            }
            let detector = await $aaa02bae484d7075$var$makeDetector();
            const JSQR_INTERVAL_MS = 120;
            let lastJsQrAt = 0;
            const tick = async ()=>{
                if (!mounted || !videoRef.current) return;
                let value = null;
                // Native first when present — it's the cheap path. But it can be present
                // and still never decode, so jsQR gets every frame it comes back empty
                // on. Only a throw retires the native detector for good.
                if (detector) try {
                    const codes = await detector.detect(videoRef.current);
                    if (codes.length > 0) value = codes[0].rawValue;
                } catch  {
                    detector = null;
                }
                const now = performance.now();
                if (!value && now - lastJsQrAt >= JSQR_INTERVAL_MS) {
                    lastJsQrAt = now;
                    try {
                        value = decodeWithJsQr(videoRef.current);
                    } catch  {}
                }
                if (value) {
                    stopScan();
                    onDetectedRef.current?.(value);
                    return;
                }
                rafRef.current = requestAnimationFrame(tick);
            };
            rafRef.current = requestAnimationFrame(tick);
        }
        start();
        return ()=>{
            mounted = false;
            stopScan();
        };
    }, [
        stopScan
    ]);
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            padding: 12,
            borderRadius: 12,
            background: '#FEF2F2',
            color: '#B91C1C',
            fontSize: 12
        },
        children: error
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            height: height,
            borderRadius: 12,
            overflow: 'hidden',
            background: '#000'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                ref: videoRef,
                muted: true,
                playsInline: true,
                style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: 150,
                        height: 150,
                        borderRadius: 12,
                        border: `2px solid ${(0, $jTCZr.C).teal}`,
                        boxShadow: '0 0 0 2000px rgba(0,0,0,0.4)'
                    }
                })
            }),
            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    stopScan();
                    onClose();
                },
                style: {
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    border: 'none',
                    cursor: 'pointer',
                    background: 'rgba(0,0,0,0.55)',
                    color: '#fff',
                    fontSize: 16,
                    lineHeight: 1
                },
                children: "\u2715"
            })
        ]
    });
}


/**
 * Pull a clinic invitation code out of a scanned QR value.
 *
 * The clinic encodes a URL — `${PATIENT_ORIGIN}/join/${invitationCode}` — so the
 * code is the last path segment. Parsing the URL, rather than regex-matching the
 * tail, keeps this correct when the URL carries a trailing slash or a query
 * string; a tail match would otherwise hand the entire URL over as the "code"
 * and the join would fail with a confusing "invalid code" error.
 *
 * A raw code — typed, or from a code-only QR — passes straight through.
 */ function $fd861f18d2c04522$export$b185ac9843404441(raw) {
    try {
        const url = new URL(raw);
        const m = url.pathname.match(/\/join\/([^/?#]+)/);
        if (m) return m[1];
    } catch  {}
    return String(raw ?? '').trim();
}


const $8674ac96b71acabd$var$JOIN_CLINIC = `
  mutation JoinClinicByCode($invitationCode: String!) {
    joinClinicByCode(invitationCode: $invitationCode) {
      id
      status
      clinic { id name clinicType province city address officePhone invitationCode }
    }
  }
`;
const $8674ac96b71acabd$var$inputBase = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: `1.5px solid ${(0, $jTCZr.C).border}`,
    outline: 'none',
    background: '#fff',
    boxSizing: 'border-box'
};
function $8674ac96b71acabd$export$2e2bcd8739ae039({ onJoined: onJoined, showTitle: showTitle = true }) {
    const { t: t } = (0, $LNQP4.default)();
    const [code, setCode] = (0, $acw62.useState)('');
    const [scanning, setScanning] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const join = async (raw)=>{
        const invitationCode = String(raw ?? code).trim().toUpperCase();
        if (!invitationCode) {
            setError(t('validation.clinic.joinCodeRequired'));
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($8674ac96b71acabd$var$JOIN_CLINIC, {
                invitationCode: invitationCode
            });
            const link = res?.joinClinicByCode;
            if (!link?.id) throw new Error(t('errors.clinic.join'));
            onJoined?.(link);
        } catch (e) {
            if (e.message?.includes('CLINIC_NOT_FOUND') || e.message?.includes(t('clinic.joinCode'))) setError(t('errors.clinic.invalidCode'));
            else setError(t('errors.clinic.join'));
        } finally{
            setLoading(false);
        }
    };
    // The clinic's QR holds a URL; extractCode pulls the invitation code out of it.
    const handleDetected = (rawValue)=>{
        const extracted = (0, $fd861f18d2c04522$export$b185ac9843404441)(rawValue);
        setScanning(false);
        setCode(extracted);
        join(extracted);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            showTitle && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 15,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: 4
                        },
                        children: t('clinic.join')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: t('clinic.joinPrompt')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        value: code,
                        onChange: (e)=>{
                            setCode(e.target.value.toUpperCase());
                            setError(null);
                        },
                        placeholder: t('clinic.joinCodeExample'),
                        maxLength: 16,
                        disabled: loading,
                        style: {
                            ...$8674ac96b71acabd$var$inputBase,
                            flex: 1,
                            direction: 'ltr',
                            textAlign: 'center',
                            fontSize: 18,
                            fontWeight: 700,
                            letterSpacing: 4
                        },
                        onFocus: (e)=>{
                            e.target.style.borderColor = (0, $jTCZr.C).navy;
                        },
                        onBlur: (e)=>{
                            e.target.style.borderColor = (0, $jTCZr.C).border;
                        },
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') join();
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>setScanning((s)=>!s),
                        title: scanning ? t('clinic.stopScan') : t('clinic.scanQr'),
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: 8,
                            flexShrink: 0,
                            background: scanning ? '#FEF2F2' : '#f8fafc',
                            border: `1.5px solid ${scanning ? '#FECACA' : (0, $jTCZr.C).border}`,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: scanning ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: (0, $jTCZr.C).red,
                            width: "18",
                            height: "18",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: (0, $jTCZr.C).textSecondary,
                            width: "18",
                            height: "18",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z"
                            })
                        })
                    })
                ]
            }),
            scanning && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aaa02bae484d7075$export$2e2bcd8739ae039), {
                        onDetected: handleDetected,
                        onClose: ()=>setScanning(false),
                        height: 220
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textSecondary,
                            textAlign: 'center'
                        },
                        children: t('clinic.qrFramePrompt')
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    background: '#FEF2F2',
                    border: '1px solid #FECACA',
                    borderRadius: 8,
                    padding: '10px 14px',
                    fontSize: 12,
                    color: '#B91C1C'
                },
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: ()=>join(),
                disabled: loading || !code.trim(),
                style: {
                    padding: '11px 16px',
                    borderRadius: 8,
                    border: 'none',
                    background: (0, $jTCZr.C).navy,
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 700,
                    cursor: loading || !code.trim() ? 'not-allowed' : 'pointer',
                    opacity: loading || !code.trim() ? 0.5 : 1
                },
                children: loading ? t('clinic.joining') : t('clinic.join')
            })
        ]
    });
}



// «هنوز به هیچ مطب یا کلینیکی وصل نیستید» — what پذیرش says instead of
// «نوبتی برای این روز ثبت نشده» when the doctor belongs to no clinic at all.
//
// It replaces the empty state rather than sitting beside it because the two
// statements cannot both be true in a useful way: "no appointments today" is a
// fact about the day, and for a doctor with no clinic it will be true every day
// forever. The honest thing to say is why.
//
// It is a GUIDE, not a menu of two nouns: each path is the numbered sequence of
// what to actually do, because a doctor who has never joined a clinic does not
// know that the code comes from the clinic manager's «همکاران» screen, and a
// doctor who wants their own practice does not know that practices are defined
// in the clinic panel rather than here.
const $7c26e9e77d71ddf2$var$CLINIC_ONBOARDING_URL = `${(0, $d87bd335296b449f$export$ce4d22a853fad121)}/onboarding`;
/** One numbered step. `children` is whatever the step is actually done with. */ const $7c26e9e77d71ddf2$var$Step = ({ n: n, title: title, hint: hint, children: children, compact: compact })=>{
    const { formatNumber: formatNumber } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        style: {
            display: 'grid',
            gridTemplateColumns: `${compact ? 24 : 26}px 1fr`,
            columnGap: 10,
            rowGap: 8,
            alignItems: 'start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    width: compact ? 24 : 26,
                    height: compact ? 24 : 26,
                    borderRadius: '50%',
                    display: 'grid',
                    placeItems: 'center',
                    marginTop: 2,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                    color: (0, $jTCZr.C).navy,
                    fontSize: 11.5,
                    fontWeight: 800
                },
                children: formatNumber(n)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: compact ? 13 : 13.5,
                            fontWeight: 700,
                            lineHeight: 1.6,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: title
                    }),
                    hint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.75,
                            marginTop: 1
                        },
                        children: hint
                    })
                ]
            }),
            children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    gridColumn: 2,
                    minWidth: 0
                },
                children: children
            })
        ]
    });
};
const $7c26e9e77d71ddf2$var$Section = ({ icon: icon, tint: tint, title: title, who: who, children: children, compact: compact })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: {
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: compact ? '14px 14px 12px' : '18px 18px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: compact ? 12 : 14,
            background: (0, $jTCZr.C).card
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: {
                    display: 'flex',
                    gap: 12,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            width: compact ? 36 : 40,
                            height: compact ? 36 : 40,
                            borderRadius: (0, $jTCZr.RADIUS).control,
                            display: 'grid',
                            placeItems: 'center',
                            flexShrink: 0,
                            background: (0, $jTCZr.soft)(tint, 0.12),
                            color: tint
                        },
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        style: {
                            margin: 0,
                            fontSize: compact ? 14 : 14.5,
                            fontWeight: 800,
                            lineHeight: 1.4,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: [
                            title,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    fontSize: 12,
                                    fontWeight: 500,
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 1
                                },
                                children: who
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                style: {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: compact ? 10 : 12
                },
                children: children
            })
        ]
    });
/**
 * The pending state: a request has been sent and the clinic has not answered.
 *
 * Distinct from the guide on purpose — telling a doctor who already sent a code
 * to "enter a code" is the fastest way to get a second, duplicate request.
 */ const $7c26e9e77d71ddf2$var$PendingCard = ({ pending: pending, compact: compact })=>{
    const { t: t } = (0, $LNQP4.default)();
    const first = pending[0];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    padding: compact ? '12px 14px' : '14px 16px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            flexShrink: 0,
                            display: 'grid',
                            placeItems: 'center',
                            background: (0, $jTCZr.GRADIENT_BRAND),
                            color: '#fff',
                            fontWeight: 800
                        },
                        children: (first?.name || t('common.punct.question')).trim().charAt(0)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13.5,
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: first?.name || t('common.labels.clinic')
                            }),
                            first?.city && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: first.city
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            flexShrink: 0,
                            padding: '4px 10px',
                            borderRadius: 999,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.14),
                            color: (0, $jTCZr.C).amber,
                            fontSize: 11.5,
                            fontWeight: 700,
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb9bc397b09eca5a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            t('clinic.noClinic.pending.badge')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 12.5,
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.8
                },
                children: t('clinic.noClinic.pending.hint')
            })
        ]
    });
};
/**
 * `variant` picks the geometry, never the content: the mobile surface is the
 * same guide with the two sections stacked and the controls full-width
 * (DESIGN-CONCEPT-MOBILE §6), not a shortened one. A doctor on a phone needs
 * the same three steps — they just read them in one column.
 */ const $7c26e9e77d71ddf2$var$NoClinicGuide = ({ variant: variant = 'web', pending: pending = [], onJoined: onJoined, 'data-testid': testId = 'reception-no-clinic' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const compact = variant === 'mobile';
    const hasPending = pending.length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        "data-state": hasPending ? 'pending' : 'guide',
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: compact ? (0, $jTCZr.RADIUS).card : (0, $jTCZr.RADIUS).hero,
            boxShadow: (0, $jTCZr.SHADOW).card,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: (0, $jTCZr.GRADIENT_BRAND),
                    color: '#fff',
                    padding: compact ? '14px 16px' : '18px 24px',
                    display: 'flex',
                    gap: 14,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            width: 36,
                            height: 36,
                            borderRadius: (0, $jTCZr.RADIUS).control,
                            flexShrink: 0,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'grid',
                            placeItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                            size: 19
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                style: {
                                    margin: 0,
                                    fontSize: compact ? 15 : 17,
                                    fontWeight: 800,
                                    lineHeight: 1.45
                                },
                                children: hasPending ? t('clinic.noClinic.pending.title') : t('clinic.noClinic.title')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    margin: '2px 0 0',
                                    fontSize: 12,
                                    lineHeight: 1.65,
                                    color: 'rgba(255,255,255,0.7)'
                                },
                                children: hasPending ? t('clinic.noClinic.pending.sub') : t('clinic.noClinic.sub')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: compact ? '14px 14px 16px' : '20px 24px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: compact ? 12 : 16
                },
                children: hasPending ? /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$PendingCard, {
                    pending: pending,
                    compact: compact
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: compact ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
                                gap: compact ? 12 : 16,
                                alignItems: 'stretch'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($7c26e9e77d71ddf2$var$Section, {
                                    compact: compact,
                                    tint: (0, $jTCZr.C).navy,
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59813a4678999ce6$export$2e2bcd8739ae039), {
                                        size: compact ? 18 : 20
                                    }),
                                    title: t('clinic.noClinic.join.title'),
                                    who: t('clinic.noClinic.join.who'),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 1,
                                            title: t('clinic.noClinic.join.s1'),
                                            hint: t('clinic.noClinic.join.s1Hint')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 2,
                                            title: t('clinic.noClinic.join.s2'),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8674ac96b71acabd$export$2e2bcd8739ae039), {
                                                showTitle: false,
                                                onJoined: onJoined
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 3,
                                            title: t('clinic.noClinic.join.s3'),
                                            hint: t('clinic.noClinic.join.s3Hint')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($7c26e9e77d71ddf2$var$Section, {
                                    compact: compact,
                                    tint: (0, $jTCZr.C).teal,
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                                        size: compact ? 18 : 20
                                    }),
                                    title: t('clinic.noClinic.own.title'),
                                    who: t('clinic.noClinic.own.who'),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 1,
                                            title: t('clinic.noClinic.own.s1'),
                                            hint: t('clinic.noClinic.own.s1Hint'),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: $7c26e9e77d71ddf2$var$CLINIC_ONBOARDING_URL,
                                                "data-testid": `${testId}-create`,
                                                style: {
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: 8,
                                                    width: compact ? '100%' : 'auto',
                                                    height: 44,
                                                    padding: '0 18px',
                                                    borderRadius: (0, $jTCZr.RADIUS).control,
                                                    background: (0, $jTCZr.GRADIENT_BRAND),
                                                    color: '#fff',
                                                    fontSize: 13.5,
                                                    fontWeight: 800,
                                                    textDecoration: 'none',
                                                    boxShadow: `0 6px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.28)}`
                                                },
                                                children: [
                                                    t('clinic.noClinic.own.cta'),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                                        size: 15,
                                                        "aria-hidden": true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 2,
                                            title: t('clinic.noClinic.own.s2'),
                                            hint: t('clinic.noClinic.own.s2Hint')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7c26e9e77d71ddf2$var$Step, {
                                            compact: compact,
                                            n: 3,
                                            title: t('clinic.noClinic.own.s3'),
                                            hint: t('clinic.noClinic.own.s3Hint')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            role: "note",
                            style: {
                                display: 'flex',
                                gap: 10,
                                alignItems: 'flex-start',
                                borderRadius: (0, $jTCZr.RADIUS).control,
                                padding: '10px 12px',
                                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                color: (0, $jTCZr.C).navyDark,
                                fontSize: 12.5,
                                lineHeight: 1.7
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97xXr.default), {
                                    size: 15,
                                    "aria-hidden": true,
                                    style: {
                                        flexShrink: 0,
                                        marginTop: 3
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: t('clinic.noClinic.foot')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $7c26e9e77d71ddf2$export$2e2bcd8739ae039 = $7c26e9e77d71ddf2$var$NoClinicGuide;







var $acw62 = parcelRequire("acw62");

// The signed-in practitioner's presence hours across every clinic — what the
// «کجا هستم» line and the AUTO clinic lens read (see Reception.shared
// `resolvePlace`). Clinic staff write these rows; the doctor app only reads.
//
// Fetched once per mount and again whenever the tab comes back into view: a
// shift edited at the desk shows up when the doctor returns to the app.
//
// **An error is not an empty schedule.** `status: 'error'` makes the place line
// say nothing about where the doctor is; `[]` with 'ready' is the real claim
// «no hours registered». A BFF too old to know the field fails validation and
// lands on 'error' too — the screen works, it just makes no place claim.
const $5f52a42f8bcaf1d9$var$PRESENCE_QUERY = `
  query MyPresenceSchedule {
    myPresenceSchedule { id clinicId dayOfWeek specificDate startMinute endMinute }
  }
`;
function $5f52a42f8bcaf1d9$export$bb891f984a85dfdf() {
    const [state, setState] = (0, $acw62.useState)({
        windows: [],
        status: 'loading'
    });
    const load = (0, $acw62.useCallback)(()=>{
        let alive = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)($5f52a42f8bcaf1d9$var$PRESENCE_QUERY).then((data)=>{
            if (!alive) return;
            const rows = data?.myPresenceSchedule;
            setState(Array.isArray(rows) ? {
                windows: rows,
                status: 'ready'
            } : {
                windows: [],
                status: 'error'
            });
        }).catch((err)=>{
            if (!alive) return;
            console.error('myPresenceSchedule error:', err);
            setState((s)=>s.status === 'ready' ? s : {
                    windows: [],
                    status: 'error'
                });
        });
        return ()=>{
            alive = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancel = load();
        const onVisible = ()=>{
            if (document.visibilityState !== 'visible') return;
            cancel?.();
            cancel = load();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>{
            cancel?.();
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, [
        load
    ]);
    return state;
}



var $2vdhF = parcelRequire("2vdhF");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $4UJrq = parcelRequire("4UJrq");
// The mobile پذیرش desk — a LIST-DOMINANT cockpit (docs/DOCTOR_MOBILE_RECEPTION_
// REDESIGN.md): the appointments are the screen's purpose, so the pinned chrome
// is held to ~28% of a phone's usable height (it was ~61%).
//
//   ① gradient header: no greeting — one context card holding «کجا هستم»
//      (where the presence schedule puts the doctor) over the day bar
//   ② one 44px strip: the day's counts (income lives in حسابداری, a tab)
//   ③ alerts → ④ hero → ⑤ the day's card list, «فراخوان بیمار بعدی» docked
//
// Week browsing lives in a sheet opened from the date label. Patient lookup is
// not a reception action any more (/lookup stays routable). Rendered from the
// mobile component library over the same day-model the web surface uses.
// Client-side list window: the bounded day list grows through an explicit
// «نمایش بیشتر» expander — never infinite scroll (mobile concept §4).
const $6b1063d50b334c84$var$PAGE_SIZE = 10;
const $6b1063d50b334c84$var$ReceptionMobile = ({ navigate: navigate })=>{
    const keyboardInset = (0, $iK5Lj.default)();
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const walletBalance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const [tick, setTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Date.now());
    // 30s: the wait/visit clocks are minute-grained; a stale minute reads as a bug.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const id = setInterval(()=>setTick(Date.now()), 30000);
        return ()=>clearInterval(id);
    }, []);
    const now = new Date(tick + (0, $4UJrq.IRAN_OFFSET_MS));
    const nowMin = now.getUTCHours() * 60 + now.getUTCMinutes();
    const todayISO = now.toISOString().split('T')[0];
    // Selected day — an absolute ISO date (Iran-local), driven by the arrows AND
    // the calendar sheet, same as the desktop header's picker. Same URL contract
    // as the web surface: ?date=YYYY-MM-DD, today is the default and stays out of
    // the URL, `replace` keeps day-stepping from stacking history entries.
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const rawDate = searchParams.get('date');
    const selISO = /^\d{4}-\d{2}-\d{2}$/.test(rawDate || '') ? rawDate : todayISO;
    const setSelISO = (v)=>{
        const next = new URLSearchParams(searchParams);
        if (!v || v === todayISO) next.delete('date');
        else next.set('date', v);
        setSearchParams(next, {
            replace: true
        });
    };
    const isToday = selISO === todayISO;
    // Noon avoids DST/rounding edge cases (same trick as the web surface).
    const selIranMs = Date.parse(`${selISO}T12:00:00Z`);
    const { appointments: allAppointments, openVisits: openVisits, loading: loading, error: error, retry: retry, endVisit: endVisit, withdrawRequest: withdrawRequest, reload: reload } = (0, $348bda64e291efe9$export$58c8c934fcb7a3d9)(selISO);
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const booking = (0, $950e52607b770dfb$export$5acc4bb723e384c)({
        selISO: selISO,
        reload: reload,
        withdrawRequest: withdrawRequest,
        toast: toast
    });
    // Where the schedule puts the doctor on the selected day. The lens shows every
    // clinic unless the doctor picked one — or «خودکار», which follows this — today:
    // the same hook as the web surface, so the two cannot claim different clinics.
    const presence = (0, $5f52a42f8bcaf1d9$export$bb891f984a85dfdf)();
    const placeFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((clinics)=>(0, $a7a51f8e25be6339$export$ac6a645c99fbd1e)({
            ...presence,
            clinics: clinics,
            dayISO: selISO,
            isToday: isToday,
            nowMin: nowMin
        }), [
        presence,
        selISO,
        isToday,
        nowMin
    ]);
    const scheduledFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((clinics)=>placeFor(clinics).scheduledClinicId, [
        placeFor
    ]);
    const clinic = (0, $5ce8d1a169b07fa7$export$43c1d8092712e085)({
        scheduledFor: scheduledFor,
        todayISO: todayISO
    });
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>clinic.loading ? {
            state: 'unknown'
        } : placeFor(clinic.clinics), [
        clinic.loading,
        clinic.clinics,
        placeFor
    ]);
    const [weekOpen, setWeekOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { rows: appointments, hidden: hiddenByClinic } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $5ce8d1a169b07fa7$export$b38dd7193ebd93c1)(allAppointments, clinic.filterId), [
        allAppointments,
        clinic.filterId
    ]);
    const clinicNameOf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>clinic.isAll && clinic.clinics.length > 1 ? clinic.clinics.find((c)=>c.id === apt.clinicId)?.name || '' : '', [
        clinic.isAll,
        clinic.clinics
    ]);
    const clinicCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const m = new Map();
        (allAppointments || []).forEach((a)=>{
            if (a.clinicId) m.set(a.clinicId, (m.get(a.clinicId) || 0) + 1);
        });
        return m;
    }, [
        allAppointments
    ]);
    const dateLabel = (0, $a7a51f8e25be6339$export$78d8ee1fd0f50c36)(selIranMs, {
        formatDate: formatDate
    });
    // One shared day-model with the web surface — same queue order, same next patient.
    const model = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a7a51f8e25be6339$export$ad1ae77322e9b4e5)({
            appointments: appointments,
            isToday: isToday,
            nowMin: nowMin
        }), [
        appointments,
        isToday,
        nowMin
    ]);
    const futureList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a7a51f8e25be6339$export$8850f67511986f5)(model, {
            isToday: isToday,
            nowMin: nowMin
        }), [
        model,
        isToday,
        nowMin
    ]);
    const counts = (0, $a7a51f8e25be6339$export$c8c7db9d09049583)(model.dayApts);
    const nextApt = isToday ? model.nextApt : null;
    const listApts = nextApt ? futureList.filter((a)=>a.id !== nextApt.id) : futureList;
    const [visibleCount, setVisibleCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($6b1063d50b334c84$var$PAGE_SIZE);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setVisibleCount($6b1063d50b334c84$var$PAGE_SIZE);
    }, [
        selISO,
        listApts.length
    ]);
    const visibleAppointments = listApts.slice(0, visibleCount);
    const hiddenCount = Math.max(0, listApts.length - visibleCount);
    // Visits presumed forgotten (open > 2h, or from a previous day) — never the one
    // the hero is already showing.
    const forgotten = (0, $348bda64e291efe9$export$da5e66bfeb457ef8)(openVisits, tick).filter((a)=>!nextApt || a.id !== nextApt.id);
    // Closing a visit is not undoable — route every «پایان» through a confirm.
    const [pendingEnd, setPendingEnd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const askEnd = (apt)=>setPendingEnd(apt);
    const showCta = isToday && nextApt && !error;
    const listState = loading ? 'loading' : error ? 'error' : futureList.length === 0 ? 'empty' : 'content';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                "data-visually-hidden": true,
                                style: {
                                    position: 'absolute',
                                    clipPath: 'inset(50%)',
                                    whiteSpace: 'nowrap',
                                    margin: 0,
                                    pointerEvents: 'none'
                                },
                                children: t('dashboard.title')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39c515491bde64a9$export$2e2bcd8739ae039), {
                                place: clinic.none ? {
                                    state: 'no_clinic'
                                } : place,
                                clinic: clinic,
                                counts: clinicCounts,
                                isToday: isToday,
                                selMs: selIranMs,
                                dateLabel: dateLabel,
                                onPrev: ()=>setSelISO((0, $2vdhF.shiftISO)(selISO, -1)),
                                onNext: ()=>setSelISO((0, $2vdhF.shiftISO)(selISO, 1)),
                                onToday: ()=>setSelISO(todayISO),
                                onOpenWeek: ()=>setWeekOpen(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a135776235a98cf4$export$2e2bcd8739ae039), {
                        counts: counts,
                        loading: loading,
                        isToday: isToday
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: showCta ? '5.5rem' : '1rem'
                },
                children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "reception-content",
                    "data-state": "error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        error: error,
                        title: t('errors.load.data'),
                        onRetry: retry
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "reception-content",
                    "data-state": listState,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "reception-alerts",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2702d77fad7ebe1a$export$2e2bcd8739ae039), {
                                    visits: forgotten,
                                    onContinue: (apt)=>navigate('visit', {
                                            id: apt.patientId
                                        }),
                                    onEnd: askEnd
                                }),
                                hiddenByClinic > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        padding: '0.75rem 0.875rem 0'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                        variant: "subtle",
                                        "data-testid": "reception-clinic-hidden",
                                        className: "w-full justify-start gap-2 min-h-11",
                                        onClick: ()=>clinic.setActive((0, $fdc4e943ddc88ca2$export$c5abb0256123e62d)),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                                                size: 15,
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    flex: 1,
                                                    textAlign: 'start',
                                                    fontWeight: 500
                                                },
                                                children: t('dashboard.clinic.hidden', {
                                                    count: formatNumber(hiddenByClinic)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: t('dashboard.clinic.showAll')
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd72b655dd667062$export$2e2bcd8739ae039), {
                                    balance: walletBalance,
                                    onTopUp: ()=>navigate('credits')
                                }),
                                booking.canBook && futureList.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        padding: '0.75rem 0.875rem 0'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                        variant: "outline",
                                        "data-testid": "reception-book",
                                        className: "w-full gap-2 min-h-11",
                                        onClick: booking.openBook,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                                size: 16,
                                                "aria-hidden": true
                                            }),
                                            " ",
                                            booking.s('dashboard.book.open')
                                        ]
                                    })
                                })
                            ]
                        }),
                        !loading && nextApt && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                paddingTop: '0.75rem'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f990101511c28a4d$export$2e2bcd8739ae039), {
                                apt: nextApt,
                                nowMin: nowMin,
                                nowMs: tick,
                                onStart: ()=>navigate('visit', {
                                        id: nextApt.patientId
                                    }),
                                onHistory: ()=>navigate('patient-detail', {
                                        id: nextApt.patientId
                                    }),
                                onEnd: ()=>askEnd(nextApt)
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                padding: '0 0.875rem',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.625rem'
                            },
                            children: [
                                loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc9cad95cac62ce8$export$f98bfe574c6e4fc7), {
                                    count: 3
                                }),
                                !loading && futureList.length === 0 && clinic.none && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c26e9e77d71ddf2$export$2e2bcd8739ae039), {
                                    variant: "mobile",
                                    pending: clinic.pending,
                                    onJoined: clinic.refresh
                                }),
                                !loading && futureList.length === 0 && clinic.error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                    error: clinic.error,
                                    title: t('errors.load.data'),
                                    onRetry: clinic.refresh
                                }),
                                !loading && futureList.length === 0 && !clinic.none && !clinic.error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7c5dde78915b198$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Md3F.default), {
                                        size: 48,
                                        color: (0, $jTCZr.C).textMuted,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: isToday ? t('dashboard.empty.noneToday') : t('dashboard.empty.none'),
                                    description: isToday && counts.total > 0 ? t('dashboard.empty.allDone') : undefined,
                                    doctorId: doctor?.id,
                                    navigate: navigate,
                                    onBook: booking.openBook,
                                    canBook: booking.canBook
                                }),
                                visibleAppointments.map((apt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $539f61ab7b8a32ef$export$2e2bcd8739ae039), {
                                        apt: apt,
                                        testId: `reception-queue-row-${apt.id}`,
                                        queuePos: model.queuePosOf.get(apt.id),
                                        nowMs: tick,
                                        clinicName: clinicNameOf(apt),
                                        onOpen: ()=>apt.patientId && navigate('patient-detail', {
                                                ...apt,
                                                id: apt.patientId
                                            }),
                                        onContinue: ()=>navigate('visit', {
                                                id: apt.patientId
                                            }),
                                        onWithdraw: ()=>booking.askWithdraw(apt),
                                        onReschedule: booking.canReschedule(apt) ? ()=>booking.askReschedule(apt) : null
                                    }, apt.id)),
                                hiddenCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    "data-testid": "reception-more",
                                    className: "w-full min-h-11",
                                    onClick: ()=>setVisibleCount((c)=>c + $6b1063d50b334c84$var$PAGE_SIZE),
                                    children: t('dashboard.queue.showMore', {
                                        count: hiddenCount
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        height: '1rem'
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            showCta && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: 0,
                    insetInlineStart: 0,
                    insetInlineEnd: 0,
                    // §H.1 — `position` describes the LAYOUT viewport, which iOS does not
                    // shrink for the keyboard. Without the inset this CTA sits under the
                    // keys whenever the calendar sheet's year field is being typed into.
                    padding: `0.75rem 1rem calc(0.75rem + ${keyboardInset}px)`,
                    background: 'white',
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    boxShadow: '0 -4px 20px rgba(0,0,0,0.08)',
                    zIndex: 20
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    size: "lg",
                    "data-testid": "reception-cta-next",
                    className: "w-full gap-2.5 bg-gradient-brand font-extrabold",
                    style: {
                        boxShadow: `0 4px 14px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35)}`
                    },
                    onClick: ()=>navigate('visit', {
                            id: nextApt.patientId
                        }),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a9c585fee1ab085$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        }),
                        t('dashboard.hero.callNext'),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontSize: '0.75rem',
                                opacity: 0.75,
                                fontWeight: 600
                            },
                            children: [
                                "\xb7 ",
                                nextApt.name?.split(' ')[0]
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48605b9bb6ac82a1$export$2e2bcd8739ae039), {
                open: weekOpen,
                onClose: ()=>setWeekOpen(false),
                selISO: selISO,
                todayISO: todayISO,
                onPick: setSelISO,
                presence: presence,
                clinics: clinic.clinics
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: !!pendingEnd,
                onOpenChange: (o)=>{
                    if (!o) setPendingEnd(null);
                },
                title: t('dashboard.endVisitConfirm.title'),
                message: t('dashboard.endVisitConfirm.message', {
                    name: pendingEnd?.name || t('common.labels.patient')
                }),
                confirmLabel: t('dashboard.endVisitConfirm.confirm'),
                cancelLabel: t('dashboard.endVisitConfirm.cancel'),
                destructive: true,
                onConfirm: ()=>pendingEnd ? endVisit(pendingEnd.id) : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38e656a4522e301b$export$2e2bcd8739ae039), {
                open: booking.bookOpen,
                onClose: booking.closeBook,
                dayISO: selISO,
                clinicId: clinic.isAll ? null : clinic.activeId,
                bookingClinics: booking.bookingClinics,
                onBooked: booking.onBooked,
                dayAppointments: allAppointments,
                isMobile: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4a79b113c1d45d4$export$2e2bcd8739ae039), {
                open: !!booking.rescheduling,
                apt: booking.rescheduling,
                onClose: booking.closeReschedule,
                onRescheduled: booking.onRescheduled,
                isMobile: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: !!booking.pendingWithdraw,
                onOpenChange: (o)=>{
                    if (!o) booking.cancelWithdraw();
                },
                title: booking.s('dashboard.withdraw.title'),
                message: booking.s('dashboard.withdraw.message', {
                    name: booking.pendingWithdraw?.name || t('common.labels.patient')
                }),
                confirmLabel: booking.s('dashboard.withdraw.confirm'),
                cancelLabel: booking.s('dashboard.withdraw.keep'),
                destructive: true,
                onConfirm: booking.confirmWithdraw
            })
        ]
    });
};
var $6b1063d50b334c84$export$2e2bcd8739ae039 = $6b1063d50b334c84$var$ReceptionMobile;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $4Qco3 = parcelRequire("4Qco3");
var $lUcdx = parcelRequire("lUcdx");
var $kyZIh = parcelRequire("kyZIh");
var $66joL = parcelRequire("66joL");



var $jTCZr = parcelRequire("jTCZr");

var $6Md3F = parcelRequire("6Md3F");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $8g4t5 = parcelRequire("8g4t5");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $5AX1S = parcelRequire("5AX1S");


var $jTCZr = parcelRequire("jTCZr");

var $kMJsW = parcelRequire("kMJsW");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// One escalation vocabulary for an open visit: normal → quiet (in-visit blue),
// over (past its slot length) → amber, critical (past 2×) → red. All from tokens.
const $db3b4f054b2a0cba$var$OVERRUN_CHIP = {
    normal: {
        bg: (0, $jTCZr.statusColors).in_visit.bg,
        color: (0, $jTCZr.statusColors).in_visit.text
    },
    over: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    critical: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    }
};
// Neutral chip surface (no #f1f5f9 token exists; CT.surface2 is the token neutral).
const $db3b4f054b2a0cba$var$NEUTRAL_BG = (0, $jTCZr.CT).surface2;
// A clock glyph on the text baseline inside a chip — replaces the ⏱ emoji.
const $db3b4f054b2a0cba$var$ClockGlyph = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
        size: 11,
        strokeWidth: 2.4,
        style: {
            display: 'inline-block',
            verticalAlign: '-1.5px',
            marginInlineEnd: 3
        }
    });
const $db3b4f054b2a0cba$var$posLabel = (item, pos)=>pos === 1 ? item('dashboard.queue.positionNext') : item('dashboard.queue.position', {
        position: pos
    });
// ── Queue position badge ──────────────────────────────────────────────────────
const $db3b4f054b2a0cba$var$QueuePos = ({ pos: pos })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            fontSize: 10,
            fontWeight: 800,
            borderRadius: 6,
            padding: '2px 7px',
            whiteSpace: 'nowrap',
            color: pos === 1 ? (0, $jTCZr.statusColors).arrived.text : (0, $jTCZr.C).textSecondary,
            background: pos === 1 ? (0, $jTCZr.statusColors).arrived.bg : $db3b4f054b2a0cba$var$NEUTRAL_BG,
            border: `1px solid ${pos === 1 ? 'transparent' : (0, $jTCZr.C).border}`,
            flexShrink: 0
        },
        children: $db3b4f054b2a0cba$var$posLabel(t, pos)
    });
};
// ── Row (web) ─────────────────────────────────────────────────────────────────
// `clinicName` is passed ONLY while پذیرش is showing every clinic at once. With
// one clinic on screen the tag would repeat the header chip on every row, which
// is noise; with several it is the one thing that says whose desk booked this
// patient.
const $db3b4f054b2a0cba$var$AppointmentRow = ({ apt: apt, queuePos: queuePos, nowMs: nowMs, onAction: onAction, onArrived: onArrived, onWithdraw: onWithdraw, onReschedule: onReschedule, arriving: arriving = false, clinicName: clinicName })=>{
    const { t: t } = (0, $LNQP4.default)();
    const s = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const [hovered, setHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const waited = apt.status === 'arrived' ? (0, $348bda64e291efe9$export$8820bfcc7ef6bb39)(apt, nowMs) : null;
    const { elapsedMin: elapsedMin, level: level } = apt.status === 'in_visit' ? (0, $348bda64e291efe9$export$e38f5492dd7c5c53)(apt, nowMs) : {
        elapsedMin: null,
        level: 'normal'
    };
    const urg = (0, $13f800aa071fd2d2$export$a08a3225103fa8fb)[apt.urgency];
    const overChip = $db3b4f054b2a0cba$var$OVERRUN_CHIP[level];
    // The decorative leading dot is tinted from the one status source — no local palette.
    const dotColor = ((0, $jTCZr.statusColors)[apt.status] || {}).text || (0, $jTCZr.C).textMuted;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderRadius: 12,
            marginBottom: 8,
            background: hovered ? (0, $jTCZr.CT).surface2 : 'white',
            border: `1.5px solid ${hovered ? (0, $jTCZr.C).border : $db3b4f054b2a0cba$var$NEUTRAL_BG}`,
            transition: 'all 0.15s'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    background: dotColor,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: 13,
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary,
                    minWidth: 44,
                    textAlign: 'center',
                    flexShrink: 0
                },
                children: apt.time || "\u2014"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 1,
                    height: 28,
                    background: (0, $jTCZr.C).border,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                name: apt.name,
                size: 32,
                bg: (0, $jTCZr.C).navy
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: apt.name || t('dashboard.hero.unknownPatient')
                    }),
                    apt.patient?.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 11,
                            color: (0, $jTCZr.C).textMuted,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: (0, $5AX1S).forDisplay(apt.patient.phone)
                    }),
                    urg && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 9.5,
                            fontWeight: 800,
                            borderRadius: 5,
                            padding: '1px 6px',
                            flexShrink: 0,
                            background: urg.bg,
                            color: urg.color
                        },
                        children: t(urg.labelKey)
                    }),
                    clinicName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "data-testid": "reception-row-clinic",
                        title: clinicName,
                        style: {
                            fontSize: 9.5,
                            fontWeight: 700,
                            borderRadius: 5,
                            padding: '1px 6px',
                            flexShrink: 0,
                            maxWidth: 120,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                            color: (0, $jTCZr.C).navyDark
                        },
                        children: clinicName
                    })
                ]
            }),
            waited != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    borderRadius: 20,
                    padding: '2px 9px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    background: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $jTCZr.C).amberLight : $db3b4f054b2a0cba$var$NEUTRAL_BG,
                    color: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($db3b4f054b2a0cba$var$ClockGlyph, {}),
                    t('dashboard.queue.waitedMinutes', {
                        count: waited
                    })
                ]
            }),
            elapsedMin != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    borderRadius: 20,
                    padding: '2px 9px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    background: overChip.bg,
                    color: overChip.color
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($db3b4f054b2a0cba$var$ClockGlyph, {}),
                    (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, elapsedMin)
                ]
            }),
            queuePos != null && /*#__PURE__*/ (0, $ayMG0.jsx)($db3b4f054b2a0cba$var$QueuePos, {
                pos: queuePos
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                status: apt.status,
                style: {
                    flexShrink: 0,
                    whiteSpace: 'nowrap'
                }
            }),
            apt.status === 'scheduled' && onArrived && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                disabled: arriving,
                "aria-busy": arriving || undefined,
                "data-testid": `reception-row-${apt.id}-arrive`,
                onClick: (e)=>{
                    e.stopPropagation();
                    onArrived();
                },
                style: {
                    height: 30,
                    padding: '0 12px',
                    background: (0, $jTCZr.statusColors).arrived.bg,
                    color: (0, $jTCZr.statusColors).arrived.text,
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: arriving ? 'progress' : 'pointer',
                    flexShrink: 0,
                    opacity: arriving ? 0.6 : 1
                },
                children: t('dashboard.queue.arrived')
            }),
            apt.status === 'scheduled' && onReschedule && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                "data-testid": `reception-row-${apt.id}-reschedule`,
                onClick: (e)=>{
                    e.stopPropagation();
                    onReschedule();
                },
                style: {
                    height: 30,
                    padding: '0 12px',
                    background: 'transparent',
                    color: (0, $jTCZr.C).textSecondary,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    flexShrink: 0
                },
                children: s('dashboard.reschedule.action')
            }),
            (0, $13f800aa071fd2d2$export$1fb2f46ad857789e)(apt) && onWithdraw && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                "data-testid": `reception-row-${apt.id}-withdraw`,
                onClick: (e)=>{
                    e.stopPropagation();
                    onWithdraw();
                },
                style: {
                    height: 30,
                    padding: '0 12px',
                    background: 'transparent',
                    color: (0, $jTCZr.CT).dangerInk,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    flexShrink: 0
                },
                children: s('dashboard.withdraw.action')
            }),
            !(0, $13f800aa071fd2d2$export$7caf56b642c4b5aa)(apt.status) && !(0, $13f800aa071fd2d2$export$2498094d90b6ac72)(apt.status) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: (e)=>{
                    e.stopPropagation();
                    onAction();
                },
                style: {
                    height: 30,
                    padding: '0 12px',
                    background: $db3b4f054b2a0cba$var$NEUTRAL_BG,
                    color: (0, $jTCZr.C).navy,
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    flexShrink: 0,
                    transition: 'background 0.15s'
                },
                onMouseEnter: (e)=>e.currentTarget.style.background = (0, $jTCZr.CT).border2,
                onMouseLeave: (e)=>e.currentTarget.style.background = $db3b4f054b2a0cba$var$NEUTRAL_BG,
                children: apt.status === 'in_visit' ? t('dashboard.queue.continue') : t('dashboard.queue.start')
            })
        ]
    });
};
var $db3b4f054b2a0cba$export$2e2bcd8739ae039 = $db3b4f054b2a0cba$var$AppointmentRow;



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");

var $kMJsW = parcelRequire("kMJsW");
var $4gxLI = parcelRequire("4gxLI");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The DESKTOP next-patient hero. The mobile surface renders its own
// `MobileNextPatientCard` (src/components/mobile/) — both consume the same
// `buildHeroModel` (lib/appointments), so they escalate identically: quiet within
// the slot length (brand sweep), amber past it, red past twice it, with «پایان
// ویزیت» promoted once closing is as likely the right action as continuing.
// One overrun chip vocabulary for the hero, tokenised.
const $81f917ab05ccb6fc$var$HERO_CHIP = {
    normal: {
        bg: 'rgba(255,255,255,0.15)',
        color: 'white'
    },
    over: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    critical: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    }
};
// ── Wide (web) ────────────────────────────────────────────────────────────────
const $81f917ab05ccb6fc$var$HeroWide = ({ apt: apt, m: m, onStart: onStart, onHistory: onHistory, onEnd: onEnd })=>{
    const { t: t } = (0, $LNQP4.default)();
    const chip = $81f917ab05ccb6fc$var$HERO_CHIP[m.level];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: m.background,
            borderRadius: 18,
            padding: '22px 24px',
            marginBottom: 20,
            boxShadow: m.level === 'critical' ? '0 8px 24px rgba(153,27,27,0.3)' : `0 8px 24px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.22)}`,
            border: m.level === 'over' ? `2px solid ${(0, $jTCZr.C).amber}` : 'none',
            position: 'relative',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: -30,
                    right: -30,
                    width: 120,
                    height: 120,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: -20,
                    right: 80,
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.04)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    marginBottom: 16,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: 7,
                            height: 7,
                            borderRadius: '50%',
                            background: m.dotColor,
                            boxShadow: `0 0 0 3px ${m.dotColor}4D`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 11,
                            fontWeight: 700,
                            color: 'rgba(255,255,255,0.7)',
                            letterSpacing: '0.05em'
                        },
                        children: m.heroLabel
                    }),
                    m.urg && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 10,
                            fontWeight: 800,
                            borderRadius: 6,
                            padding: '2px 8px',
                            background: m.urg.bg,
                            color: m.urg.color
                        },
                        children: t(m.urg.labelKey)
                    }),
                    m.inVisit && m.elapsedMin != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            fontSize: 11,
                            fontWeight: 800,
                            borderRadius: 20,
                            padding: '3px 10px',
                            background: chip.bg,
                            color: chip.color,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                                size: 12,
                                strokeWidth: 2.4
                            }),
                            ' ',
                            t('dashboard.hero.sinceStart', {
                                duration: (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, m.elapsedMin)
                            }),
                            m.level === 'over' && t('dashboard.hero.overSlot'),
                            m.level === 'critical' && t('dashboard.hero.usualLength', {
                                duration: (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, apt.durationMinutes || 30)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 16
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 54,
                                    height: 54,
                                    borderRadius: '50%',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: '2px solid rgba(255,255,255,0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 18,
                                    fontWeight: 800,
                                    color: 'white',
                                    flexShrink: 0
                                },
                                children: m.initials
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 18,
                                            fontWeight: 800,
                                            color: 'white',
                                            lineHeight: 1.2
                                        },
                                        children: apt.name || t('dashboard.hero.unknownPatient')
                                    }),
                                    (apt.patient?.phone || apt.specialty) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: 'rgba(255,255,255,0.65)',
                                            marginTop: 5
                                        },
                                        children: apt.patient?.phone ? (0, $5AX1S).forDisplay(apt.patient.phone) : apt.specialty
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            textAlign: 'end',
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    background: 'rgba(255,255,255,0.15)',
                                    borderRadius: 10,
                                    padding: '6px 14px',
                                    fontSize: 20,
                                    fontWeight: 800,
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                children: apt.time
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'rgba(255,255,255,0.6)',
                                    marginTop: 5,
                                    textAlign: 'center'
                                },
                                children: m.waitLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 18,
                    justifyContent: 'flex-end'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onHistory,
                        style: {
                            height: 36,
                            padding: '0 16px',
                            background: 'rgba(255,255,255,0.14)',
                            color: 'white',
                            border: '1px solid rgba(255,255,255,0.22)',
                            borderRadius: 10,
                            fontSize: 12.5,
                            fontWeight: 700,
                            cursor: 'pointer'
                        },
                        children: t('dashboard.hero.history')
                    }),
                    m.inVisit && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onEnd,
                        style: {
                            height: 36,
                            padding: '0 18px',
                            background: m.level === 'normal' ? 'rgba(255,255,255,0.14)' : 'white',
                            color: m.level === 'normal' ? 'white' : (0, $jTCZr.CT).dangerInk,
                            border: m.level === 'normal' ? '1px solid rgba(255,255,255,0.22)' : 'none',
                            borderRadius: 10,
                            fontSize: 13,
                            fontWeight: 800,
                            cursor: 'pointer',
                            boxShadow: m.level === 'normal' ? 'none' : '0 2px 8px rgba(0,0,0,0.12)'
                        },
                        children: t('dashboard.hero.endVisit')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: onStart,
                        style: {
                            height: 36,
                            padding: '0 20px',
                            background: 'white',
                            color: m.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.C).navy,
                            border: 'none',
                            borderRadius: 10,
                            fontSize: 13,
                            fontWeight: 800,
                            cursor: 'pointer',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4gxLI.default), {
                                size: 14,
                                strokeWidth: 2.6,
                                fill: "currentColor"
                            }),
                            " ",
                            m.inVisit ? t('dashboard.hero.continueVisit') : t('dashboard.hero.startVisit')
                        ]
                    })
                ]
            })
        ]
    });
};
const $81f917ab05ccb6fc$var$NextPatientHero = ({ apt: apt, nowMin: nowMin, nowMs: nowMs, onStart: onStart, onHistory: onHistory, onEnd: onEnd })=>{
    const { t: t } = (0, $LNQP4.default)();
    const m = (0, $13f800aa071fd2d2$export$29d3aa8816e57583)(apt, nowMin, nowMs, t);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81f917ab05ccb6fc$var$HeroWide, {
        apt: apt,
        m: m,
        onStart: onStart,
        onHistory: onHistory,
        onEnd: onEnd
    });
};
var $81f917ab05ccb6fc$export$2e2bcd8739ae039 = $81f917ab05ccb6fc$var$NextPatientHero;



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The DESKTOP forgotten-visit banner. The mobile surface renders its own
// `MobileForgottenVisitAlert` (src/components/mobile/); both describe the same
// condition — a visit left open (> 2h, or from a previous day) that follows the
// doctor to every date until it is continued or closed.
const $fc732fda1793c902$var$ForgottenVisitBanner = ({ visits: visits, nowMs: nowMs, onContinue: onContinue, onEnd: onEnd })=>{
    const { t: t } = (0, $LNQP4.default)();
    if (!visits.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            marginBottom: 20
        },
        children: visits.map((apt)=>{
            const { elapsedMin: elapsedMin } = (0, $348bda64e291efe9$export$e38f5492dd7c5c53)(apt, nowMs);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    flexWrap: 'wrap',
                    background: (0, $jTCZr.C).redLight,
                    border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`,
                    borderRadius: 14,
                    padding: '12px 18px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 11,
                            fontWeight: 800,
                            borderRadius: 20,
                            padding: '3px 10px',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.12),
                            color: (0, $jTCZr.CT).dangerInk,
                            flexShrink: 0
                        },
                        children: t('dashboard.forgotten.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 180,
                            fontSize: 13,
                            fontWeight: 700,
                            color: (0, $jTCZr.CT).dangerInk
                        },
                        children: [
                            t('dashboard.forgotten.body', {
                                name: apt.name || t('common.labels.patient')
                            }),
                            elapsedMin != null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: 600,
                                    color: (0, $jTCZr.CT).dangerInk,
                                    marginInlineStart: 6
                                },
                                children: t('dashboard.forgotten.elapsed', {
                                    duration: (0, $13f800aa071fd2d2$export$bc733b0c5cbb3e8a)(t, elapsedMin)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>onContinue(apt),
                                style: {
                                    height: 32,
                                    padding: '0 14px',
                                    background: 'white',
                                    color: (0, $jTCZr.CT).dangerInk,
                                    border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`,
                                    borderRadius: 9,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    cursor: 'pointer'
                                },
                                children: t('dashboard.hero.continueVisit')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>onEnd(apt),
                                style: {
                                    height: 32,
                                    padding: '0 14px',
                                    background: (0, $jTCZr.C).red,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 9,
                                    fontSize: 12,
                                    fontWeight: 800,
                                    cursor: 'pointer'
                                },
                                children: t('dashboard.hero.endVisit')
                            })
                        ]
                    })
                ]
            }, apt.id);
        })
    });
};
var $fc732fda1793c902$export$2e2bcd8739ae039 = $fc732fda1793c902$var$ForgottenVisitBanner;








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $chm1L = parcelRequire("chm1L");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// «پذیرش در …» — the clinic whose day sheet is on screen.
//
// It sits with the date navigator, not with the page actions, because it
// answers the same kind of question: not "what do I want to do" but "what am I
// looking at" (DESIGN-CONCEPT §2.2, Archetype A's context widgets).
//
// Two looks, one behaviour: `tone="surface"` is the white pill on the desktop
// PageHeader, `tone="gradient"` the white-alpha one on the mobile brand header
// (DESIGN-CONCEPT-MOBILE §2.2 — white-alpha is the sanctioned way to tint
// on-gradient chrome). Nothing else differs, so the two surfaces cannot drift
// apart on which clinic they claim.
//
// With `mode` (useActiveClinic's) the menu leads with «خودکار — طبق برنامهٔ
// حضور»: the lens follows the presence schedule, and the chip wears a «خودکار»
// badge while it does. Without `mode` the chip is the old two-way choice.
const $f9c4788d8cde4e54$var$PANEL_WIDTH = 264;
function $f9c4788d8cde4e54$var$panelPosition(rect) {
    if (!rect) return null;
    const margin = 8;
    const width = Math.min($f9c4788d8cde4e54$var$PANEL_WIDTH, window.innerWidth - margin * 2);
    // Anchored to the chip's INLINE-START edge, which is the right edge in
    // Persian and the left in English — a panel pinned to a physical side would
    // hang off the screen in one of the two languages.
    const rtl = document.documentElement.dir !== 'ltr';
    const left = rtl ? Math.max(margin, rect.right - width) : Math.min(rect.left, window.innerWidth - width - margin);
    return {
        left: left,
        width: width,
        top: rect.bottom + 6
    };
}
const $f9c4788d8cde4e54$var$ClinicContextChip = ({ clinics: clinics = [], activeId: activeId, isAll: isAll, activeClinic: activeClinic, single: single, mode: mode, onSelect: onSelect, counts: counts, tone: tone = 'surface', testId: testId = 'reception-clinic' })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rs = (0, $7fe332a380bf5371$export$2f6c4fed9331fa36)();
    const withAuto = mode !== undefined && clinics.length > 1;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [rect, setRect] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const onGradient = tone === 'gradient';
    const reposition = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = triggerRef.current;
        if (el) setRect($f9c4788d8cde4e54$var$panelPosition(el.getBoundingClientRect()));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        reposition();
        window.addEventListener('scroll', reposition, true);
        window.addEventListener('resize', reposition);
        return ()=>{
            window.removeEventListener('scroll', reposition, true);
            window.removeEventListener('resize', reposition);
        };
    }, [
        open,
        reposition
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (triggerRef.current?.contains(e.target) || panelRef.current?.contains(e.target)) return;
            setOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                setOpen(false);
                triggerRef.current?.focus();
            }
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        open
    ]);
    // The panel is portaled to <body>, so it sits at the END of the tab order —
    // opening it and pressing Tab would walk the whole page first. Focus starts on
    // the clinic already chosen (§12.2: the menu opens ON its current value), and
    // the arrow keys walk the rows from there.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !rect) return;
        const rows = panelRef.current?.querySelectorAll('[role="menuitemradio"]');
        const at = [
            ...rows || []
        ].find((r)=>r.getAttribute('aria-checked') === 'true');
        (at || rows?.[0])?.focus();
    }, [
        open,
        rect
    ]);
    const onMenuKeyDown = (e)=>{
        const rows = [
            ...panelRef.current?.querySelectorAll('[role="menuitemradio"]') || []
        ];
        if (!rows.length) return;
        const at = rows.indexOf(document.activeElement);
        const go = (i)=>{
            e.preventDefault();
            rows[Math.max(0, Math.min(rows.length - 1, i))]?.focus();
        };
        if (e.key === 'ArrowDown') go(at + 1);
        else if (e.key === 'ArrowUp') go(at - 1);
        else if (e.key === 'Home') go(0);
        else if (e.key === 'End') go(rows.length - 1);
        else if (e.key === 'Tab') setOpen(false);
    };
    if (!clinics.length) return null; // absent, never disabled (§2.1)
    const label = isAll ? t('dashboard.clinic.all') : activeClinic?.name || t('common.labels.clinic');
    const city = isAll ? '' : activeClinic?.city || '';
    const pick = (id)=>{
        onSelect?.(id);
        setOpen(false);
        triggerRef.current?.focus();
    };
    const chip = /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": testId,
        "data-clinic-id": activeId,
        "aria-haspopup": single ? undefined : 'menu',
        "aria-expanded": single ? undefined : open,
        "aria-label": single ? undefined : t('dashboard.clinic.pick'),
        // With one membership the chip is a statement, not a control: it carries
        // no caret, takes no focus and opens nothing. Rendering it as a dead
        // button would promise a choice that does not exist.
        disabled: single,
        onClick: single ? undefined : ()=>setOpen((o)=>!o),
        className: "outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            height: 32,
            padding: single ? '0 12px' : '0 8px 0 12px',
            borderRadius: 999,
            border: `1px solid ${onGradient ? 'rgba(255,255,255,0.28)' : (0, $jTCZr.C).border}`,
            background: onGradient ? 'rgba(255,255,255,0.16)' : '#fff',
            color: onGradient ? '#fff' : (0, $jTCZr.C).textPrimary,
            fontFamily: 'var(--app-font)',
            fontSize: 12.5,
            fontWeight: 700,
            cursor: single ? 'default' : 'pointer',
            maxWidth: '100%',
            minWidth: 0,
            opacity: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: onGradient ? '#fff' : (0, $jTCZr.C).green,
                    boxShadow: onGradient ? 'none' : `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.2)}`
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: label
            }),
            city && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontWeight: 500,
                    color: onGradient ? 'rgba(255,255,255,0.75)' : (0, $jTCZr.C).textSecondary,
                    whiteSpace: 'nowrap'
                },
                children: [
                    "\xb7 ",
                    city
                ]
            }),
            withAuto && mode === 'auto' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "data-testid": `${testId}-auto`,
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    borderRadius: 999,
                    padding: '1px 7px',
                    whiteSpace: 'nowrap',
                    background: onGradient ? 'rgba(255,255,255,0.22)' : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                    color: onGradient ? '#fff' : (0, $jTCZr.C).navy
                },
                children: rs('dashboard.clinic.autoBadge')
            }),
            !single && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                size: 14,
                "aria-hidden": true,
                style: {
                    color: onGradient ? 'rgba(255,255,255,0.75)' : (0, $jTCZr.C).textMuted,
                    flexShrink: 0
                }
            })
        ]
    });
    const rows = [
        ...withAuto ? [
            {
                id: (0, $5ce8d1a169b07fa7$export$c588754a2dac332e),
                name: rs('dashboard.clinic.auto'),
                meta: rs('dashboard.clinic.autoSub'),
                auto: true
            }
        ] : [],
        ...clinics.map((c)=>({
                id: c.id,
                name: c.name || t('common.labels.clinic'),
                meta: [
                    c.city,
                    counts?.has(c.id) ? t('dashboard.clinic.countToday', {
                        count: formatNumber(counts.get(c.id))
                    }) : null
                ].filter(Boolean).join(" \xb7 "),
                owned: c.owned
            })),
        {
            id: (0, $fdc4e943ddc88ca2$export$c5abb0256123e62d),
            name: t('dashboard.clinic.all'),
            meta: t('dashboard.clinic.allSub'),
            all: true
        }
    ];
    const panel = open && rect ? /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: panelRef,
        role: "menu",
        "data-testid": `${testId}-menu`,
        "aria-label": t('dashboard.clinic.pick'),
        onKeyDown: onMenuKeyDown,
        style: {
            position: 'fixed',
            top: rect.top,
            left: rect.left,
            width: rect.width,
            zIndex: 3000,
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 14,
            boxShadow: '0 18px 44px rgba(15,23,42,0.18)',
            padding: 6,
            fontFamily: 'var(--app-font)',
            maxHeight: '60vh',
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    color: (0, $jTCZr.C).textMuted,
                    padding: '6px 10px 4px'
                },
                children: t('dashboard.clinic.label')
            }),
            rows.map((row)=>{
                // With AUTO on offer, a row is checked by the MODE, not by the id the
                // lens resolved to: following the schedule to clinic X is not the same
                // choice as picking clinic X, and the menu must not pretend it is.
                const checked = withAuto ? row.auto ? mode === 'auto' : row.all ? mode === 'all' : mode === 'pick' && row.id === activeId : row.id === activeId;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    role: "menuitemradio",
                    "aria-checked": checked,
                    "data-testid": `${testId}-option-${row.id}`,
                    onClick: ()=>pick(row.id),
                    className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        width: '100%',
                        minHeight: 44,
                        padding: '6px 10px',
                        textAlign: 'start',
                        border: 'none',
                        borderRadius: 10,
                        cursor: 'pointer',
                        background: checked ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                        color: (0, $jTCZr.C).textPrimary,
                        fontFamily: 'var(--app-font)',
                        borderTop: row.all ? `1px solid ${(0, $jTCZr.C).border}` : undefined,
                        marginTop: row.all ? 4 : 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            "aria-hidden": true,
                            style: {
                                width: 30,
                                height: 30,
                                borderRadius: 8,
                                flexShrink: 0,
                                display: 'grid',
                                placeItems: 'center',
                                background: row.all ? (0, $jTCZr.C).bg : (0, $jTCZr.soft)(row.owned ? (0, $jTCZr.C).teal : (0, $jTCZr.C).navy, 0.12),
                                color: row.all ? (0, $jTCZr.C).textSecondary : row.owned ? (0, $jTCZr.C).teal : (0, $jTCZr.C).navy
                            },
                            children: row.auto ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chm1L.default), {
                                size: 15
                            }) : row.all ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8deaef2bfa57b80$export$2e2bcd8739ae039), {
                                size: 15
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                                size: 15
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        display: 'block',
                                        fontSize: 13,
                                        fontWeight: 700,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: row.name
                                }),
                                row.meta && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        display: 'block',
                                        fontSize: 11,
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: row.meta
                                })
                            ]
                        }),
                        checked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                            size: 16,
                            "aria-hidden": true,
                            style: {
                                color: (0, $jTCZr.C).navy,
                                flexShrink: 0
                            }
                        })
                    ]
                }, row.id);
            })
        ]
    }), document.body) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            chip,
            panel
        ]
    });
};
var $f9c4788d8cde4e54$export$2e2bcd8739ae039 = $f9c4788d8cde4e54$var$ClinicContextChip;




var $2vdhF = parcelRequire("2vdhF");

parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");




var $4UJrq = parcelRequire("4UJrq");

// ─────────────────────────────────────────────────────────────────────────────
// Clinic money in more than one currency — the doctor panel's grouping rules.
//
// A doctor can work at clinics that keep their books in different currencies
// (docs/clinic-currency/CONTRACTS.md). Every clinic-money row the BFF returns says
// which currency its amounts are minor units of, and the rules for showing them
// are the kit's (`@parsina/framework/ui/lib/currency`). What this module adds is
// the one thing a screen needs on top: never let two currencies meet.
//
//   • a total is one figure PER CURRENCY — there is no exchange rate anywhere,
//     so «1,500,000 ت + 12.50 AED» is not a number anybody can be paid;
//   • a bar chart scales against the largest bar WITHIN its currency, because a
//     bar measured against another currency's row compares magnitudes that have
//     nothing to do with each other;
//   • an empty report has no rows to read a currency from, so its zero is stated
//     in the doctor's clinic's currency (`displayCurrencyFor`), IRR when unknown.
//
// For an IRR-only doctor — every doctor today — each function here yields one
// IRR group, and the screens render exactly what they rendered before.
// ─────────────────────────────────────────────────────────────────────────────

var $lHVFz = parcelRequire("lHVFz");
const $23af70c6e8945b15$export$f3986f464fb786c9 = (row)=>(0, $lHVFz.normalizeCurrency)(row?.currency);
const $23af70c6e8945b15$export$d2f719a5670e623a = (currency)=>(0, $lHVFz.normalizeCurrency)(currency) === (0, $lHVFz.DEFAULT_CURRENCY);
function $23af70c6e8945b15$export$f259c563cf34883d(rows) {
    const groups = [];
    const byCode = new Map();
    for (const row of rows || []){
        const code = $23af70c6e8945b15$export$f3986f464fb786c9(row);
        let group = byCode.get(code);
        if (!group) {
            group = {
                currency: code,
                rows: []
            };
            byCode.set(code, group);
            groups.push(group);
        }
        group.rows.push(row);
    }
    return groups;
}
function $23af70c6e8945b15$export$174cf94db2560bb(rows, pick = (row)=>row.grossTotal) {
    let max = 0;
    for (const row of rows || []){
        const value = Number(pick(row));
        if (Number.isFinite(value) && value > max) max = value;
    }
    return max || 1;
}
/** `outstanding` is per currency by construction: both terms come from one group. */ const $23af70c6e8945b15$var$withOutstanding = (group)=>({
        ...group,
        outstanding: group.doctorShareTotal - group.collectedDoctorShare
    });
function $23af70c6e8945b15$export$905ef9c201d869d1(report, fallbackCurrency = (0, $lHVFz.DEFAULT_CURRENCY)) {
    const list = Array.isArray(report?.totalsByCurrency) ? report.totalsByCurrency : [];
    if (list.length) return list.map((group)=>$23af70c6e8945b15$var$withOutstanding({
            currency: $23af70c6e8945b15$export$f3986f464fb786c9(group),
            grossTotal: group.grossTotal ?? 0,
            doctorShareTotal: group.doctorShareTotal ?? 0,
            collectedDoctorShare: group.collectedDoctorShare ?? 0
        }));
    return [
        $23af70c6e8945b15$var$withOutstanding({
            currency: (0, $lHVFz.normalizeCurrency)(fallbackCurrency),
            grossTotal: report?.grossTotal ?? 0,
            doctorShareTotal: report?.doctorShareTotal ?? 0,
            collectedDoctorShare: report?.collectedDoctorShare ?? 0
        })
    ];
}
function $23af70c6e8945b15$export$dae2facd7e4f3419(clinics, selectedId) {
    const list = clinics || [];
    if (selectedId) {
        const selected = list.find((clinic)=>clinic?.id === selectedId);
        if (selected) return $23af70c6e8945b15$export$f3986f464fb786c9(selected);
    }
    const codes = new Set(list.map($23af70c6e8945b15$export$f3986f464fb786c9));
    return codes.size === 1 ? [
        ...codes
    ][0] : (0, $lHVFz.DEFAULT_CURRENCY);
}
function $23af70c6e8945b15$export$abe1985ad014fee5(income, fallbackCurrency = (0, $lHVFz.DEFAULT_CURRENCY)) {
    if (Array.isArray(income?.byCurrency) && income.byCurrency.length) return income.byCurrency.map((group)=>({
            ...group,
            currency: $23af70c6e8945b15$export$f3986f464fb786c9(group)
        }));
    return [
        {
            currency: (0, $lHVFz.normalizeCurrency)(fallbackCurrency),
            shareRial: income?.shareRial ?? 0,
            unsettledRial: income?.unsettledRial ?? 0
        }
    ];
}


// A token colour at low alpha — keeps tinted surfaces on the token, no raw hex.
// Thin alias over the framework skeleton atom (keeps the compact w/h call sites) —
// the rail cards' per-value placeholders. The day sheet has its own skeleton.
const $c16d3de23a271e71$var$Skeleton = ({ w: w = 64, h: h = 36 })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
        width: w,
        height: h
    });
// ── Block (one section of the day) ────────────────────────────────────────────
const $c16d3de23a271e71$var$Block = ({ title: title, count: count, countLabel: countLabel, tint: tint, tintText: tintText, collapsible: collapsible, defaultOpen: defaultOpen = true, children: children })=>{
    const { formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultOpen);
    const shown = collapsible ? open : true;
    const head = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                style: {
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: 11,
                    fontWeight: 700,
                    padding: '2px 9px',
                    borderRadius: 20,
                    background: tint,
                    color: tintText
                },
                children: [
                    formatDigits(count),
                    " ",
                    countLabel
                ]
            }),
            collapsible && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    marginInlineStart: 'auto',
                    color: (0, $jTCZr.C).textMuted,
                    fontSize: 12
                },
                children: shown ? "\u25B2" : "\u25BC"
            })
        ]
    });
    const headStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: '14px 20px',
        borderBottom: shown ? `1px solid ${(0, $jTCZr.C).border}` : 'none',
        background: 'transparent',
        border: 'none',
        textAlign: 'start',
        cursor: collapsible ? 'pointer' : 'default'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        style: {
            padding: 0,
            overflow: 'hidden',
            border: 'none',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
        },
        children: [
            collapsible ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setOpen((o)=>!o),
                style: headStyle,
                children: head
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: headStyle,
                children: head
            }),
            shown && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '14px 16px 8px'
                },
                children: children
            })
        ]
    });
};
// ── Rail cards ────────────────────────────────────────────────────────────────
const $c16d3de23a271e71$var$RailCard = ({ title: title, warn: warn, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        style: {
            padding: '16px 18px',
            border: warn ? `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.45)}` : 'none',
            background: warn ? (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.08) : 'white',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: 10
                },
                children: title
            }),
            children
        ]
    });
const $c16d3de23a271e71$export$ed4d1b479820c430 = ({ income: income, currency: currency, onOpen: onOpen })=>{
    const { t: t, formatMoney: formatMoney, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const groups = income ? (0, $23af70c6e8945b15$export$abe1985ad014fee5)(income, currency) : [];
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c16d3de23a271e71$var$RailCard, {
        title: t('dashboard.rail.income'),
        children: [
            income === null && /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$Skeleton, {
                w: 110,
                h: 26
            }),
            income === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $jTCZr.C).textMuted
                },
                children: t('common.state.unavailable')
            }),
            income && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    groups.map((g)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                fontSize: 20,
                                fontWeight: 800,
                                color: (0, $jTCZr.C).textPrimary,
                                lineHeight: 1.2
                            },
                            children: [
                                formatMoney(g.shareRial, {
                                    currency: g.currency
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: moneyUnit(g.currency)
                                })
                            ]
                        }, g.currency)),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 6,
                            marginTop: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 10.5,
                                    fontWeight: 700,
                                    borderRadius: 20,
                                    padding: '2px 9px',
                                    background: (0, $jTCZr.statusColors).arrived.bg,
                                    color: (0, $jTCZr.statusColors).arrived.text
                                },
                                children: t('dashboard.rail.visitCount', {
                                    count: income.visitCount
                                })
                            }),
                            groups.map((g)=>g.unsettledRial > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: 10.5,
                                        fontWeight: 700,
                                        borderRadius: 20,
                                        padding: '2px 9px',
                                        background: (0, $jTCZr.C).amberLight,
                                        color: (0, $jTCZr.CT).warnInk
                                    },
                                    children: t('dashboard.rail.unsettled', {
                                        amount: mixed ? `${formatMoney(g.unsettledRial, {
                                            currency: g.currency
                                        })} ${moneyUnit(g.currency, 'short')}` : formatMoney(g.unsettledRial, {
                                            currency: g.currency
                                        })
                                    })
                                }, g.currency))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onOpen,
                        style: {
                            marginTop: 12,
                            height: 30,
                            padding: '0 12px',
                            width: '100%',
                            background: (0, $jTCZr.CT).surface2,
                            color: (0, $jTCZr.C).navy,
                            border: 'none',
                            borderRadius: 8,
                            fontSize: 11.5,
                            fontWeight: 700,
                            cursor: 'pointer'
                        },
                        children: t('dashboard.rail.financialReport')
                    })
                ]
            })
        ]
    });
};
// Parsina Credits — the same 50/200 tiers the Credits screen uses. AI features stop
// working when this hits zero; پذیرش's job is to say so before that happens.
const $c16d3de23a271e71$var$CreditsCard = ({ balance: balance, onOpen: onOpen })=>{
    const { canBuy: canBuy } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const low = balance != null && balance < 50;
    const mid = balance != null && !low && balance < 200;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$RailCard, {
        title: t('dashboard.rail.credit'),
        warn: low || mid,
        children: balance == null ? /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$Skeleton, {
            w: 90,
            h: 26
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: 20,
                        fontWeight: 800,
                        lineHeight: 1.2,
                        color: low ? (0, $jTCZr.CT).dangerInk : mid ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary
                    },
                    children: [
                        formatNumber(Math.round(balance)),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 12,
                                fontWeight: 600,
                                color: (0, $jTCZr.C).textMuted
                            },
                            children: t('dashboard.rail.creditUnit')
                        })
                    ]
                }),
                (low || mid) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: 11.5,
                        color: low ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk,
                        marginTop: 8,
                        lineHeight: 1.6
                    },
                    children: low ? t('dashboard.rail.creditLow') : t('dashboard.rail.creditMid')
                }),
                canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: onOpen,
                    style: {
                        marginTop: 12,
                        height: 30,
                        padding: '0 12px',
                        width: '100%',
                        background: low ? (0, $jTCZr.C).red : (0, $jTCZr.CT).surface2,
                        color: low ? 'white' : (0, $jTCZr.C).navy,
                        border: 'none',
                        borderRadius: 8,
                        fontSize: 11.5,
                        fontWeight: 700,
                        cursor: 'pointer'
                    },
                    children: t('dashboard.rail.topUp')
                })
            ]
        })
    });
};
// The week ahead as seven tappable day chips — the count answers "how heavy is
// شنبه", the tap replaces arrow-stepping one day at a time.
const $c16d3de23a271e71$var$WeekStrip = ({ days: days, selISO: selISO, onPick: onPick })=>{
    const { t: t, formatDigits: formatDigits, formatWeekday: formatWeekday } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$RailCard, {
        title: t('dashboard.rail.weekAhead'),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'space-between',
                gap: 4
            },
            children: days.map(({ iso: iso, count: count })=>{
                // Jalali in every language, Gregorian for a brand on that calendar.
                const day = (0, $a7a51f8e25be6339$export$23389b4a74f4886a)(iso);
                // `narrow`, not `short`: seven chips share one 280px rail, so this has to
                // be the one-letter form the strip was built around («ش ی د س چ پ ج»).
                // Persian's `short` is the FULL word («چهارشنبه») and would overflow.
                const wd = formatWeekday(Date.parse(`${iso}T12:00:00Z`), 'narrow');
                const active = iso === selISO;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: ()=>onPick(iso),
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 5,
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontSize: 10.5,
                                color: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                                fontWeight: active ? 800 : 600
                            },
                            children: [
                                wd,
                                day ? ` ${formatDigits(day)}` : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 12,
                                fontWeight: 800,
                                borderRadius: 8,
                                padding: '3px 0',
                                width: '100%',
                                textAlign: 'center',
                                background: active ? (0, $jTCZr.C).navy : count ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.CT).surface2,
                                color: active ? 'white' : count ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted
                            },
                            children: count == null ? "\xb7" : count === 0 ? "\u2014" : formatDigits(count)
                        })
                    ]
                }, iso);
            })
        })
    });
};
// ── NavButton (header arrow) ──────────────────────────────────────────────────
const $c16d3de23a271e71$var$NavBtn = ({ onClick: onClick, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        onClick: onClick,
        style: {
            width: 32,
            height: 32,
            borderRadius: 8,
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $jTCZr.C).textSecondary,
            transition: 'background 0.12s'
        },
        onMouseEnter: (e)=>e.currentTarget.style.background = (0, $jTCZr.CT).border2,
        onMouseLeave: (e)=>e.currentTarget.style.background = (0, $jTCZr.CT).surface2,
        children: children
    });
// ── Main پذیرش ────────────────────────────────────────────────────────────────
const $c16d3de23a271e71$var$ReceptionWeb = ({ navigate: navigate })=>{
    // Arriving from «پایان ویزیت»: the closure that owned the screen has gone and
    // took the focused element with it, so the page takes focus itself rather
    // than leaving it on <body>. Read once — a later re-render must not steal
    // focus back from whatever the doctor has since clicked.
    const arrivedFromClosure = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef((0, $aphAM.useLocation)().state?.from === 'visit-closure').current;
    const { t: t, formatDate: formatDate, formatNumber: formatNumber, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [tick, setTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Date.now());
    // 30s: the wait/visit clocks are minute-grained; a stale minute reads as a bug.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const id = setInterval(()=>setTick(Date.now()), 30000);
        return ()=>clearInterval(id);
    }, []);
    // The P2 rail collapses under the main column below 1180px (DESIGN-CONCEPT §2.2).
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mq = window.matchMedia('(max-width: 1180px)');
        const sync = ()=>setNarrow(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return ()=>mq.removeEventListener('change', sync);
    }, []);
    // Iran time (today)
    const now = new Date(tick + (0, $4UJrq.IRAN_OFFSET_MS));
    const nowMin = now.getUTCHours() * 60 + now.getUTCMinutes();
    const todayISO = now.toISOString().split('T')[0];
    // Selected day — an absolute ISO date (Iran-local), driven by the date picker.
    // Lives in the URL (?date=YYYY-MM-DD) so refresh/back/shared links reopen the
    // same day; today is the default and stays out of the URL. `replace` keeps
    // day-stepping from stacking history entries.
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const rawDate = searchParams.get('date');
    const selISO = /^\d{4}-\d{2}-\d{2}$/.test(rawDate || '') ? rawDate : todayISO;
    const setSelISO = (v)=>{
        const next = new URLSearchParams(searchParams);
        if (!v || v === todayISO) next.delete('date');
        else next.set('date', v);
        setSearchParams(next, {
            replace: true
        });
    };
    const isToday = selISO === todayISO;
    const { appointments: allAppointments, openVisits: openVisits, loading: loading, error: error, retry: retry, markArrived: markArrived, endVisit: endVisit, withdrawRequest: withdrawRequest, reload: reload } = (0, $348bda64e291efe9$export$58c8c934fcb7a3d9)(selISO);
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    // «نوبت جدید» — by the clinic's grant; «لغو درخواست» for the doctor's own pending ask.
    const booking = (0, $950e52607b770dfb$export$5acc4bb723e384c)({
        selISO: selISO,
        reload: reload,
        withdrawRequest: withdrawRequest,
        toast: toast
    });
    // «ثبت حضور» is a row action: pending on its own button, failure as a toast
    // (DC §7 routing), success is the row moving into the queue.
    const [arrivingIds, setArrivingIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const arrive = async (id)=>{
        if (arrivingIds.has(id)) return;
        setArrivingIds((prev)=>new Set(prev).add(id));
        try {
            await markArrived(id);
        } catch  {
            toast.error(t('errors.save.markArrived'));
        } finally{
            setArrivingIds((prev)=>{
                const n = new Set(prev);
                n.delete(id);
                return n;
            });
        }
    };
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    // Which clinic's desk this day sheet belongs to. The scope is a LENS, not an
    // access rule — everything here was already this doctor's to see; the chip
    // only decides which of it is on screen (see useActiveClinic for why no
    // `x-active-clinic-id` header is sent). Same behaviour as the phone: every
    // clinic by default, unless the doctor picked one — or «خودکار», the presence
    // schedule for the day on screen — today. The two surfaces share the hook so
    // they cannot claim different clinics.
    const presence = (0, $5f52a42f8bcaf1d9$export$bb891f984a85dfdf)();
    const scheduledFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((clinics)=>(0, $a7a51f8e25be6339$export$ac6a645c99fbd1e)({
            ...presence,
            clinics: clinics,
            dayISO: selISO,
            isToday: isToday,
            nowMin: nowMin
        }).scheduledClinicId, [
        presence,
        selISO,
        isToday,
        nowMin
    ]);
    const clinic = (0, $5ce8d1a169b07fa7$export$43c1d8092712e085)({
        scheduledFor: scheduledFor,
        todayISO: todayISO
    });
    const { rows: appointments, hidden: hiddenByClinic } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $5ce8d1a169b07fa7$export$b38dd7193ebd93c1)(allAppointments, clinic.filterId), [
        allAppointments,
        clinic.filterId
    ]);
    // The tag a row carries in «همهٔ مطب‌ها» — and nothing at all otherwise, so a
    // single-clinic day sheet is not decorated with the same name on every line.
    const clinicNameOf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>clinic.isAll && clinic.clinics.length > 1 ? clinic.clinics.find((c)=>c.id === apt.clinicId)?.name || '' : '', [
        clinic.isAll,
        clinic.clinics
    ]);
    // Rows per clinic for the picker — the choice reads better as "3 نوبت امروز"
    // than as a bare name, and it is free: the day is already in hand.
    const clinicCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const m = new Map();
        (allAppointments || []).forEach((a)=>{
            if (a.clinicId) m.set(a.clinicId, (m.get(a.clinicId) || 0) + 1);
        });
        return m;
    }, [
        allAppointments
    ]);
    const walletBalance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const income = (0, $348bda64e291efe9$export$3e8165f49f0984d5)(todayISO);
    const weekDays = (0, $348bda64e291efe9$export$edba156216bf7de4)(todayISO);
    // ms for the selected Iran-local day (noon avoids DST/rounding edge cases)
    const selIranMs = Date.parse(`${selISO}T12:00:00Z`);
    // Header date label
    const dateLabel = (0, $a7a51f8e25be6339$export$78d8ee1fd0f50c36)(selIranMs, {
        formatDate: formatDate,
        withYear: true
    });
    // One shared day-model with the mobile surface — same queue order, same next
    // patient, same counts (Reception.shared.js).
    const { dayApts: dayApts, queue: queue, upcoming: upcoming, done: done, queuePosOf: queuePosOf, nextApt: nextApt } = (0, $a7a51f8e25be6339$export$ad1ae77322e9b4e5)({
        appointments: appointments,
        isToday: isToday,
        nowMin: nowMin
    });
    const upcomingList = upcoming.filter((a)=>!nextApt || a.id !== nextApt.id);
    // Visits presumed forgotten (open > 2h, or from a previous day) — but never the
    // one the hero is already showing as active: one region is loud about it, not two.
    const forgotten = (0, $348bda64e291efe9$export$da5e66bfeb457ef8)(openVisits, tick).filter((a)=>!nextApt || a.id !== nextApt.id);
    // Selected-day summary — the ONE stat surface (zone ③), derived from the same
    // polled list the blocks render, so the numbers can never disagree with the rows
    // below them. Rendered as framework KpiCards; the value keeps its status color.
    const counts = (0, $a7a51f8e25be6339$export$c8c7db9d09049583)(dayApts);
    const daySummary = [
        {
            label: t('dashboard.counts.total'),
            value: counts.total,
            accent: (0, $jTCZr.C).navy
        },
        {
            label: t('dashboard.counts.here'),
            value: counts.here,
            accent: (0, $jTCZr.statusColors).arrived.text
        },
        {
            label: t('dashboard.counts.scheduled'),
            value: counts.scheduled,
            accent: (0, $jTCZr.statusColors).scheduled.text
        },
        {
            label: t('dashboard.counts.completed'),
            value: counts.completed,
            accent: (0, $jTCZr.statusColors).completed.text
        },
        {
            label: t('dashboard.counts.cancelled'),
            value: counts.cancelled,
            accent: (0, $jTCZr.statusColors).cancelled.text
        }
    ];
    // Route «پایان ویزیت» through a confirm — closing a visit is not undoable, and the
    // پذیرش screen used to fire it on a single click.
    const [pendingEnd, setPendingEnd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const askEnd = (apt)=>setPendingEnd(apt);
    // The date navigator lives in the PageHeader action cluster: prev/next day arrows,
    // the Jalali picker, and a jump-to-today shortcut when off today.
    const dateNav = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9c4788d8cde4e54$export$2e2bcd8739ae039), {
                clinics: clinic.clinics,
                activeId: clinic.activeId,
                isAll: clinic.isAll,
                activeClinic: clinic.activeClinic,
                single: clinic.single,
                mode: clinic.mode,
                onSelect: clinic.setActive,
                counts: clinicCounts
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$NavBtn, {
                onClick: ()=>setSelISO((0, $2vdhF.shiftISO)(selISO, -1)),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzPvP.default), {
                    size: 18,
                    style: (0, $asXy3.MIRROR_ICON)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 210
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                    value: selISO,
                    onChange: (v)=>setSelISO(v || todayISO),
                    placeholder: t('dashboard.date.pick'),
                    height: 40,
                    fontSize: 13
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$NavBtn, {
                onClick: ()=>setSelISO((0, $2vdhF.shiftISO)(selISO, 1)),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                    size: 18,
                    style: (0, $asXy3.MIRROR_ICON)
                })
            }),
            !isToday && // h-10 aligns the pill to the 40px date picker beside it; the tonal look
            // is now the framework `subtle` variant, not hand-rolled navy alphas.
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "subtle",
                size: "sm",
                className: "h-10 whitespace-nowrap",
                onClick: ()=>setSelISO(todayISO),
                children: t('dashboard.date.today')
            }),
            booking.canBook && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                size: "sm",
                className: "h-10 whitespace-nowrap gap-1.5",
                "data-testid": "reception-book",
                onClick: booking.openBook,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    " ",
                    booking.s('dashboard.book.open')
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('dashboard.title'),
                sub: dateLabel ? t('dashboard.subtitle', {
                    date: dateLabel
                }) : undefined,
                autoFocus: arrivedFromClosure,
                children: dateNav
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: '28px 32px'
                },
                children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                    error: error,
                    title: t('errors.load.data'),
                    onRetry: retry
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        forgotten.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc732fda1793c902$export$2e2bcd8739ae039), {
                            visits: forgotten,
                            nowMs: tick,
                            onContinue: (apt)=>navigate('visit', {
                                    id: apt.patientId
                                }),
                            onEnd: askEnd
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'flex',
                                gap: 12,
                                marginBottom: 20,
                                flexWrap: 'wrap'
                            },
                            children: daySummary.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                                    label: s.label,
                                    value: formatDigits(s.value),
                                    accent: s.accent,
                                    loading: loading
                                }, i))
                        }),
                        hiddenByClinic > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "subtle",
                            "data-testid": "reception-clinic-hidden",
                            className: "w-full justify-start gap-2 mb-4 h-10",
                            onClick: ()=>clinic.setActive((0, $fdc4e943ddc88ca2$export$c5abb0256123e62d)),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        flex: 1,
                                        textAlign: 'start',
                                        fontWeight: 500
                                    },
                                    children: t('dashboard.clinic.hidden', {
                                        count: formatNumber(hiddenByClinic)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: t('dashboard.clinic.showAll')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: narrow ? '1fr' : 'minmax(0, 1fr) 280px',
                                gap: 20,
                                alignItems: 'start'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        minWidth: 0
                                    },
                                    children: [
                                        !loading && isToday && nextApt && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81f917ab05ccb6fc$export$2e2bcd8739ae039), {
                                            apt: nextApt,
                                            nowMin: nowMin,
                                            nowMs: tick,
                                            onStart: ()=>navigate('visit', {
                                                    id: nextApt.patientId
                                                }),
                                            onHistory: ()=>navigate('patient-detail', {
                                                    id: nextApt.patientId
                                                }),
                                            onEnd: ()=>askEnd(nextApt)
                                        }),
                                        loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc9cad95cac62ce8$export$dc40c2b39562b6a8), {
                                            rows: 4
                                        }),
                                        !loading && dayApts.length === 0 && clinic.none && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c26e9e77d71ddf2$export$2e2bcd8739ae039), {
                                            pending: clinic.pending,
                                            onJoined: clinic.refresh
                                        }),
                                        !loading && dayApts.length === 0 && clinic.error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                            error: clinic.error,
                                            title: t('errors.load.data'),
                                            onRetry: clinic.refresh
                                        }),
                                        !loading && dayApts.length === 0 && !clinic.none && !clinic.error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
                                            style: {
                                                padding: 0,
                                                border: 'none',
                                                boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7c5dde78915b198$export$2e2bcd8739ae039), {
                                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Md3F.default), {
                                                    size: 52,
                                                    color: (0, $jTCZr.C).textMuted,
                                                    strokeWidth: 1.5
                                                }),
                                                title: t('dashboard.empty.none'),
                                                description: t('dashboard.empty.noneHint'),
                                                doctorId: doctor?.id,
                                                navigate: navigate,
                                                onBook: booking.openBook,
                                                canBook: booking.canBook
                                            })
                                        }),
                                        !loading && dayApts.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 16
                                            },
                                            children: [
                                                queue.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$Block, {
                                                    title: t('dashboard.queue.room'),
                                                    count: queue.length,
                                                    countLabel: t('dashboard.queue.roomCount'),
                                                    tint: (0, $jTCZr.statusColors).in_visit.bg,
                                                    tintText: (0, $jTCZr.statusColors).in_visit.text,
                                                    children: queue.map((apt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                                            apt: apt,
                                                            queuePos: queuePosOf.get(apt.id),
                                                            nowMs: tick,
                                                            clinicName: clinicNameOf(apt),
                                                            onAction: ()=>navigate('visit', {
                                                                    id: apt.patientId
                                                                })
                                                        }, apt.id))
                                                }),
                                                upcomingList.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$Block, {
                                                    title: t('dashboard.queue.upcoming'),
                                                    count: upcomingList.length,
                                                    countLabel: t('dashboard.queue.upcomingCount'),
                                                    tint: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                                    tintText: (0, $jTCZr.C).navy,
                                                    children: upcomingList.map((apt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                                            apt: apt,
                                                            nowMs: tick,
                                                            clinicName: clinicNameOf(apt),
                                                            onAction: ()=>navigate('visit', {
                                                                    id: apt.patientId
                                                                }),
                                                            // «ثبت حضور» is what makes the queue exist in a مطب with no
                                                            // desk — without it, a solo doctor can never build one. The label is
                                                            // imperative, not past tense: «حاضر شد» read as a claim that the
                                                            // نوبت‌دار had already arrived.
                                                            onArrived: isToday ? ()=>arrive(apt.id) : null,
                                                            arriving: arrivingIds.has(apt.id),
                                                            onWithdraw: ()=>booking.askWithdraw(apt),
                                                            onReschedule: booking.canReschedule(apt) ? ()=>booking.askReschedule(apt) : null
                                                        }, apt.id))
                                                }),
                                                done.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$Block, {
                                                    title: t('dashboard.queue.finished'),
                                                    count: done.length,
                                                    countLabel: t('dashboard.queue.finishedCount'),
                                                    tint: (0, $jTCZr.CT).surface2,
                                                    tintText: (0, $jTCZr.C).textSecondary,
                                                    collapsible: true,
                                                    defaultOpen: queue.length === 0 && upcomingList.length === 0,
                                                    children: done.map((apt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                                            apt: apt,
                                                            nowMs: tick,
                                                            clinicName: clinicNameOf(apt),
                                                            onAction: ()=>navigate('visit', {
                                                                    id: apt.patientId
                                                                })
                                                        }, apt.id))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 14
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$export$ed4d1b479820c430, {
                                            income: income,
                                            currency: (0, $23af70c6e8945b15$export$dae2facd7e4f3419)(clinic.clinics, clinic.activeClinic?.id),
                                            onOpen: ()=>navigate('accounting')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$CreditsCard, {
                                            balance: walletBalance,
                                            onOpen: ()=>navigate('credits')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($c16d3de23a271e71$var$WeekStrip, {
                                            days: weekDays,
                                            selISO: selISO,
                                            onPick: setSelISO
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: !!pendingEnd,
                onOpenChange: (o)=>{
                    if (!o) setPendingEnd(null);
                },
                title: t('dashboard.endVisitConfirm.title'),
                message: t('dashboard.endVisitConfirm.message', {
                    name: pendingEnd?.name || t('common.labels.patient')
                }),
                confirmLabel: t('dashboard.endVisitConfirm.confirm'),
                cancelLabel: t('dashboard.endVisitConfirm.cancel'),
                destructive: true,
                // Returned, not fired-and-forgotten: the confirm stays open until the
                // write settles and reports a failure inline.
                onConfirm: ()=>pendingEnd ? endVisit(pendingEnd.id) : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38e656a4522e301b$export$2e2bcd8739ae039), {
                open: booking.bookOpen,
                onClose: booking.closeBook,
                dayISO: selISO,
                clinicId: clinic.isAll ? null : clinic.activeId,
                bookingClinics: booking.bookingClinics,
                onBooked: booking.onBooked,
                dayAppointments: allAppointments,
                isMobile: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4a79b113c1d45d4$export$2e2bcd8739ae039), {
                open: !!booking.rescheduling,
                apt: booking.rescheduling,
                onClose: booking.closeReschedule,
                onRescheduled: booking.onRescheduled,
                isMobile: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: !!booking.pendingWithdraw,
                onOpenChange: (o)=>{
                    if (!o) booking.cancelWithdraw();
                },
                title: booking.s('dashboard.withdraw.title'),
                message: booking.s('dashboard.withdraw.message', {
                    name: booking.pendingWithdraw?.name || t('common.labels.patient')
                }),
                confirmLabel: booking.s('dashboard.withdraw.confirm'),
                cancelLabel: booking.s('dashboard.withdraw.keep'),
                destructive: true,
                onConfirm: booking.confirmWithdraw
            })
        ]
    });
};
var $c16d3de23a271e71$export$2e2bcd8739ae039 = $c16d3de23a271e71$var$ReceptionWeb;


const $7202295aeae2c636$var$ReceptionScreen = ()=>{
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b1063d50b334c84$export$2e2bcd8739ae039), {
        navigate: navigate
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c16d3de23a271e71$export$2e2bcd8739ae039), {
        navigate: navigate
    });
};
var $7202295aeae2c636$export$2e2bcd8739ae039 = $7202295aeae2c636$var$ReceptionScreen;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b559e909b346eb90$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
            key: "3spt84"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "m17 22 5-5",
            key: "1k6ppv"
        }
    ],
    [
        "path",
        {
            d: "m17 17 5 5",
            key: "p7ous7"
        }
    ]
];
const $b559e909b346eb90$export$2e2bcd8739ae039 = (0, $9QBug.default)("calendar-x-2", $b559e909b346eb90$export$3efd853dbb351e94);


var $3SiwN = parcelRequire("3SiwN");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $673598ab744296f7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 5h.01",
            key: "18ugdj"
        }
    ],
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M3 19h.01",
            key: "noohij"
        }
    ],
    [
        "path",
        {
            d: "M8 5h13",
            key: "1pao27"
        }
    ],
    [
        "path",
        {
            d: "M8 12h13",
            key: "1za7za"
        }
    ],
    [
        "path",
        {
            d: "M8 19h13",
            key: "m83p4d"
        }
    ]
];
const $673598ab744296f7$export$2e2bcd8739ae039 = (0, $9QBug.default)("list", $673598ab744296f7$export$3efd853dbb351e94);


var $2VplL = parcelRequire("2VplL");

var $acw62 = parcelRequire("acw62");

const $4be6b6b3ace2a56e$var$LIST_ENCOUNTERS_QUERY = `
  query ListEncounters(
    $status: String, $search: String, $clinicId: ID, $type: String
    $fromTs: Float, $toTs: Float, $limit: Int, $offset: Int
  ) {
    listEncounters(
      status: $status, search: $search, clinicId: $clinicId, type: $type
      fromTs: $fromTs, toTs: $toTs, limit: $limit, offset: $offset
    ) {
      items {
        id
        patientId
        patientName
        clinicId
        type
        status
        scheduledDate
        createdAt
        fileNumber
      }
      total
    }
  }
`;
function $4be6b6b3ace2a56e$export$39f3c868c6c6a840(status = null, search = '', clinicId = null, type = null, { fromTs: fromTs = null, toTs: toTs = null, limit: limit = null, offset: offset = 0 } = {}) {
    const [encounters, setEncounters] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [nonce, setNonce] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($4be6b6b3ace2a56e$var$LIST_ENCOUNTERS_QUERY, {
            status: status || null,
            search: search || null,
            clinicId: clinicId || null,
            type: type || null,
            fromTs: fromTs ?? null,
            toTs: toTs ?? null,
            limit: limit || null,
            offset: offset || 0
        }).then((data)=>{
            if (cancelled) return;
            const page = data.listEncounters || {
                items: [],
                total: 0
            };
            setEncounters(page.items || []);
            setTotal(page.total || 0);
        }).catch((err)=>{
            if (!cancelled) {
                setError(err);
                setEncounters([]);
                setTotal(0);
            }
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        status,
        search,
        clinicId,
        type,
        fromTs,
        toTs,
        limit,
        offset,
        nonce
    ]);
    const reload = (0, $acw62.useCallback)(()=>setNonce((n)=>n + 1), []);
    return {
        encounters: encounters,
        total: total,
        loading: loading,
        error: error,
        reload: reload
    };
}



parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $awevB = parcelRequire("awevB");
var $7gSBD = parcelRequire("7gSBD");
var $kyZIh = parcelRequire("kyZIh");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// One `EncounterCard` in placeholder, for the card grid's first load. The
// PageHeader and toolbar render for real; the grid fills with these at the
// card's real geometry — `p-5`, 48px avatar, name + type lines, the status
// chip, the divider, then the 2×2 meta grid. The list view uses the kit's
// `SkeletonRow` inside the real table instead.
// ─────────────────────────────────────────────────────────────────────────────
const $94ecceec5cec0a93$var$MetaCell = ({ w: w })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-background rounded-lg px-2.5 py-1.5 flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 44,
                height: 10
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: w,
                height: 12
            })
        ]
    });
const $94ecceec5cec0a93$export$7e04a0fb8d63c537 = ({ i: i = 0, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        className: "bg-white rounded-2xl border-[1.5px] border-border p-5 flex flex-col gap-3.5 shadow-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-start gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: 48
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 min-w-0 flex flex-col gap-1.5 pt-0.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: `${50 + i * 17 % 30}%`,
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: `${30 + i * 11 % 24}%`,
                                height: 11
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 64,
                        height: 22,
                        radius: (0, $jTCZr.RADIUS).pill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "h-px bg-border"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94ecceec5cec0a93$var$MetaCell, {
                        w: 72
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94ecceec5cec0a93$var$MetaCell, {
                        w: 88
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94ecceec5cec0a93$var$MetaCell, {
                        w: 56
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94ecceec5cec0a93$var$MetaCell, {
                        w: 64
                    })
                ]
            })
        ]
    });
};
/**
 * One `MobileEncounterCard`: a Card whose tappable body is `p-3` — 40px
 * avatar, name + type lines, the status chip, the chevron — over the 2-column
 * meta grid. The mobile list's first load draws `count` of these under the
 * real MobileHeader and filter row.
 */ const $94ecceec5cec0a93$var$MobileEncounterCardSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: 0,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                padding: '0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.625rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                            size: 40
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: `${46 + i * 17 % 30}%`,
                                    height: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: `${28 + i * 11 % 22}%`,
                                    height: 11
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 60,
                            height: 22,
                            radius: (0, $jTCZr.RADIUS).pill
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 16,
                            height: 16,
                            radius: (0, $jTCZr.RADIUS).chip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '0.375rem'
                    },
                    children: [
                        72,
                        56
                    ].map((w, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                borderRadius: '0.5rem',
                                padding: '0.375rem 0.5rem',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 40,
                                    height: 10
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: w,
                                    height: 12
                                })
                            ]
                        }, j))
                })
            ]
        })
    });
const $94ecceec5cec0a93$export$42022b6966315c4f = ({ count: count = 4, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "encounters-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($94ecceec5cec0a93$var$MobileEncounterCardSkeleton, {
                i: i
            }, i))
    });
};
var $94ecceec5cec0a93$export$2e2bcd8739ae039 = $94ecceec5cec0a93$export$7e04a0fb8d63c537;




var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $d7dcd2a5bfc5801e$export$2e2bcd8739ae039({ items: items = [], value: value, onChange: onChange, size: size = 'md', ariaLabel: ariaLabel, testId: testId }) {
    const { t: t, isRTL: isRTL } = (0, $LNQP4.default)();
    const pad = size === 'sm' ? '6px 12px' : '8px 16px';
    const font = size === 'sm' ? 12 : 13;
    const onKeyDown = (e, idx)=>{
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        // The arrows follow what the doctor SEES, so which one advances depends on
        // the direction the strip is laid out in — not on the array order.
        const advances = isRTL ? 'ArrowLeft' : 'ArrowRight';
        const dir = e.key === advances ? 1 : -1;
        const next = (idx + dir + items.length) % items.length;
        onChange?.(items[next].id);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tablist",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            display: 'inline-flex',
            // A strip sized for Persian is not wide enough for the same strip in
            // English — «امنیت» is four glyphs, "Security" is eight — so the nine
            // settings sections overran their rail and the last one sat off-screen
            // behind a scroll with nothing to say so. Wrapping costs nothing while
            // the segments fit (which is every case that fits today) and keeps
            // every segment REACHABLE when a longer language means they do not.
            flexWrap: 'wrap',
            maxWidth: '100%',
            background: (0, $jTCZr.C).bg,
            borderRadius: 10,
            padding: 3,
            gap: 2
        },
        children: items.map((item, idx)=>{
            const active = item.id === value;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                role: "tab",
                "aria-selected": active,
                "aria-label": item.ariaLabel,
                title: item.ariaLabel,
                "data-testid": testId ? `${testId}-${item.id}` : undefined,
                tabIndex: active ? 0 : -1,
                onClick: ()=>onChange?.(item.id),
                onKeyDown: (e)=>onKeyDown(e, idx),
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    // A segment is a touch target wherever this control renders, and
                    // it renders on the phone (Messages, Credits, Accounting filters).
                    // 2.75rem is the floor (DESIGN-CONCEPT-MOBILE §6); the padding
                    // above still sets the horizontal rhythm.
                    minHeight: '2.75rem',
                    padding: pad,
                    border: 'none',
                    borderRadius: 8,
                    cursor: 'pointer',
                    fontSize: font,
                    fontWeight: active ? 700 : 500,
                    fontFamily: 'inherit',
                    whiteSpace: 'nowrap',
                    background: active ? '#fff' : 'transparent',
                    color: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                    boxShadow: active ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
                    transition: 'background 0.15s, color 0.15s'
                },
                children: [
                    item.icon,
                    item.label,
                    item.dot && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": true,
                                "data-testid": testId ? `${testId}-${item.id}-dot` : undefined,
                                style: {
                                    width: 7,
                                    height: 7,
                                    borderRadius: '50%',
                                    background: (0, $jTCZr.C).amber,
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "sr-only",
                                children: t('settings.profile.unsavedTitle')
                            })
                        ]
                    })
                ]
            }, item.id);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
function $a27afae32c22d713$export$2e2bcd8739ae039({ page: page, pageCount: pageCount, onPage: onPage, total: total, pageSize: pageSize }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (!pageCount || pageCount <= 1) return null;
    const canPrev = page > 1;
    const canNext = page < pageCount;
    const from = total != null && pageSize ? (page - 1) * pageSize + 1 : null;
    const to = total != null && pageSize ? Math.min(page * pageSize, total) : null;
    const btn = (enabled)=>({
            padding: '7px 16px',
            borderRadius: 8,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: '#fff',
            color: enabled ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
            cursor: enabled ? 'pointer' : 'not-allowed',
            opacity: enabled ? 1 : 0.5,
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: 600
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            padding: '16px 0',
            flexWrap: 'wrap'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                style: btn(canPrev),
                disabled: !canPrev,
                onClick: ()=>canPrev && onPage(page - 1),
                children: t('common.pagination.prev')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: 13,
                    color: (0, $jTCZr.C).textSecondary,
                    fontWeight: 600
                },
                children: [
                    t('common.pagination.page'),
                    " ",
                    formatNumber(page),
                    " ",
                    t('common.labels.from'),
                    " ",
                    formatNumber(pageCount)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                style: btn(canNext),
                disabled: !canNext,
                onClick: ()=>canNext && onPage(page + 1),
                children: t('common.pagination.next')
            }),
            from != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: 12,
                    color: (0, $jTCZr.C).textMuted
                },
                children: [
                    t('common.pagination.showing'),
                    " ",
                    formatNumber(from),
                    "\u2013",
                    formatNumber(to),
                    " ",
                    t('common.labels.from'),
                    " ",
                    formatNumber(total)
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

// Date-range presets — one definition for every screen with a "بازه" filter
// (Accounting, Encounters). Windows are { fromTs, toTs } in epoch MS, because
// invoice/encounter created_at is stored in ms and a seconds value would silently
// match nothing.
//
// «این ماه»/«ماه گذشته» are Jalali months, not Gregorian ones — no Date arithmetic
// can find the first of Tir, so month bounds go through the Jalali calendar.
// A brand that reads the Gregorian calendar (`calendar: 'gregory'`,
// docs/rebranding/CONTRACT.md) has Gregorian months instead, counted the same way:
// from the first of the month at 00:00 UTC, the instant `jalaliToMs` returns.

var $4UJrq = parcelRequire("4UJrq");

var $eLeza = parcelRequire("eLeza");
const $bdd2cd30328e25bb$var$DAY_MS = 86400000;
const $bdd2cd30328e25bb$var$startOfDay = (item)=>{
    const d = new Date(item);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
};
const $bdd2cd30328e25bb$var$endOfDay = (item)=>{
    const d = new Date(item);
    d.setHours(23, 59, 59, 999);
    return d.getTime();
};
const $bdd2cd30328e25bb$var$gStrStart = (s)=>{
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0).getTime();
};
const $bdd2cd30328e25bb$var$gStrEnd = (s)=>{
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d, 23, 59, 59, 999).getTime();
};
const $bdd2cd30328e25bb$export$5f37411c4bafeb65 = [
    {
        id: 'today',
        labelKey: 'common.range.today'
    },
    {
        id: 'week',
        labelKey: 'common.range.week'
    },
    {
        id: 'month',
        labelKey: 'common.range.month'
    },
    {
        id: 'lastMonth',
        labelKey: 'common.range.lastMonth'
    },
    {
        id: 'quarter',
        labelKey: 'common.range.quarter'
    },
    {
        id: 'all',
        labelKey: 'common.range.all'
    }
];
const $bdd2cd30328e25bb$export$f38a867bdb4bba3d = (item)=>$bdd2cd30328e25bb$export$5f37411c4bafeb65.map((p)=>({
            ...p,
            label: item(p.labelKey)
        }));
/** The first instant of the Gregorian month `offset` months from `now`'s (UTC). */ const $bdd2cd30328e25bb$var$gregorianMonthStart = (now, offset = 0)=>{
    const d = new Date(now);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + offset, 1);
};
function $bdd2cd30328e25bb$export$c1d4212a2686aaff(id, now = Date.now()) {
    if (id === 'today') return {
        fromTs: $bdd2cd30328e25bb$var$startOfDay(now),
        toTs: $bdd2cd30328e25bb$var$endOfDay(now)
    };
    if (id === 'week') return {
        fromTs: $bdd2cd30328e25bb$var$startOfDay(now - 6 * $bdd2cd30328e25bb$var$DAY_MS),
        toTs: $bdd2cd30328e25bb$var$endOfDay(now)
    };
    if ((0, $eLeza.calendarSystem)('jalali') === 'gregory') {
        if (id === 'month') return {
            fromTs: $bdd2cd30328e25bb$var$gregorianMonthStart(now),
            toTs: $bdd2cd30328e25bb$var$endOfDay(now)
        };
        if (id === 'lastMonth') return {
            fromTs: $bdd2cd30328e25bb$var$gregorianMonthStart(now, -1),
            toTs: $bdd2cd30328e25bb$var$gregorianMonthStart(now) - 1
        };
    }
    if (id === 'month') {
        const jt = (0, $4UJrq.msToJalali)(now);
        return {
            fromTs: (0, $4UJrq.jalaliToMs)(jt.y, jt.m, 1),
            toTs: $bdd2cd30328e25bb$var$endOfDay(now)
        };
    }
    if (id === 'lastMonth') {
        const jt = (0, $4UJrq.msToJalali)(now);
        const pm = jt.m === 1 ? {
            y: jt.y - 1,
            m: 12
        } : {
            y: jt.y,
            m: jt.m - 1
        };
        // …to one ms before this month starts, so the two month presets never overlap.
        return {
            fromTs: (0, $4UJrq.jalaliToMs)(pm.y, pm.m, 1),
            toTs: (0, $4UJrq.jalaliToMs)(jt.y, jt.m, 1) - 1
        };
    }
    if (id === 'quarter') return {
        fromTs: $bdd2cd30328e25bb$var$startOfDay(now - 89 * $bdd2cd30328e25bb$var$DAY_MS),
        toTs: $bdd2cd30328e25bb$var$endOfDay(now)
    };
    return null; // 'all' — unbounded
}
const $bdd2cd30328e25bb$export$e319253fda62ab3b = (from, to)=>({
        fromTs: $bdd2cd30328e25bb$var$gStrStart(from),
        toTs: $bdd2cd30328e25bb$var$gStrEnd(to)
    });



var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

function $a26d9ceff6a9d412$export$fc4eac43d8254712(key, { urlParam: urlParam = 'q' } = {}) {
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const legacy = urlParam ? searchParams.get(urlParam) : null;
    const [term, setTermState] = (0, $acw62.useState)(()=>legacy || (0, $0694d51df2baaf30$export$a715a88d17f75e81)(key));
    (0, $acw62.useEffect)(()=>{
        if (!legacy) return;
        (0, $0694d51df2baaf30$export$970916b3799c92c9)(key, legacy);
        setTermState(legacy);
        const next = new URLSearchParams(searchParams);
        next.delete(urlParam);
        setSearchParams(next, {
            replace: true
        });
    }, [
        legacy
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const setTerm = (0, $acw62.useCallback)((value)=>{
        const v = value || '';
        (0, $0694d51df2baaf30$export$970916b3799c92c9)(key, v);
        setTermState(v);
    }, [
        key
    ]);
    return [
        term,
        setTerm
    ];
}


// One page size for every server-paginated list (DESIGN-CONCEPT §9.1: "Page size
// fixed at 20 (one constant in src/constants/), navigated by the shared Pager").
// Consumers: Encounters (Accounting still carries its legacy 50 — migrate it to
// this constant when that screen is next touched).
const $f7753960a21756a4$export$8ec3d08588d2eeda = 20;


const $10ec599bea147670$export$2ea464e7b016c8da = `
  query ListMyClinics {
    listClinics(limit: 50) {
      clinics { id name }
    }
  }
`;
const $10ec599bea147670$export$1af56ca954f3d2d1 = (t)=>(0, $bdd2cd30328e25bb$export$f38a867bdb4bba3d)(t).filter((p)=>p.id !== 'all');
const $10ec599bea147670$export$6cb5521d141d0a9e = {
    'in-person': 'encounters.type.inPerson',
    'online': 'encounters.type.online'
};
const $10ec599bea147670$export$26790cf3975e36c8 = {
    planned: {
        key: 'scheduled',
        labelKey: 'encounters.status.scheduled'
    },
    scheduled: {
        key: 'scheduled',
        labelKey: 'encounters.status.scheduled'
    },
    arrived: {
        key: 'arrived',
        labelKey: 'encounters.status.arrived'
    },
    in_progress: {
        key: 'in_visit',
        labelKey: 'encounters.status.inVisit'
    },
    in_visit: {
        key: 'in_visit',
        labelKey: 'encounters.status.inVisit'
    },
    finished: {
        key: 'completed',
        labelKey: 'encounters.status.completed'
    },
    completed: {
        key: 'completed',
        labelKey: 'encounters.status.completed'
    },
    cancelled: {
        key: 'cancelled',
        labelKey: 'encounters.status.cancelled'
    }
};
const $10ec599bea147670$export$17007323c7130273 = [
    {
        id: 'all',
        labelKey: 'common.state.all'
    },
    {
        id: 'scheduled',
        labelKey: 'encounters.status.scheduled'
    },
    {
        id: 'in_progress',
        labelKey: 'encounters.status.inVisit'
    },
    {
        id: 'completed',
        labelKey: 'encounters.status.completed'
    }
];
const $10ec599bea147670$export$dd86032c66b86dfb = [
    {
        value: 'in-person',
        labelKey: 'encounters.type.inPerson'
    },
    {
        value: 'online',
        labelKey: 'encounters.type.online'
    }
];
const $10ec599bea147670$export$6a6dcc7e725abed4 = [
    {
        id: 'patient',
        labelKey: 'common.labels.patient'
    },
    {
        id: 'fileNumber',
        labelKey: 'encounters.columns.fileNumber'
    },
    {
        id: 'type',
        labelKey: 'encounters.columns.type'
    },
    {
        id: 'date',
        labelKey: 'encounters.columns.date'
    },
    {
        id: 'clinic',
        labelKey: 'common.labels.clinic'
    },
    {
        id: 'status',
        labelKey: 'common.labels.status'
    }
];
const $10ec599bea147670$export$117990e3c4b5b5aa = (t, id)=>{
    const col = $10ec599bea147670$export$6a6dcc7e725abed4.find((c)=>c.id === id);
    return col ? t(col.labelKey) : '';
};
const $10ec599bea147670$export$b691916706e0e9cc = (col, e, clinicName, { t: t, formatDate: formatDate, formatDigits: formatDigits })=>{
    switch(col){
        // A file number is an identifier, not a quantity: localise the digits but
        // never group them, or «۱۲۳۴» reads as a different file.
        case 'fileNumber':
            return e.fileNumber ? formatDigits(e.fileNumber) : "\u2014";
        case 'type':
            return $10ec599bea147670$export$6cb5521d141d0a9e[e.type] ? t($10ec599bea147670$export$6cb5521d141d0a9e[e.type]) : e.type || "\u2014";
        case 'date':
            return formatDate(e.scheduledDate || e.createdAt, 'long');
        case 'clinic':
            return clinicName || "\u2014";
        default:
            return "\u2014";
    }
};
const $10ec599bea147670$export$f484e977a69c6ba6 = {
    status: 'all',
    type: '',
    clinic: '',
    q: '',
    view: 'card',
    preset: 'today',
    from: '',
    to: ''
};
function $10ec599bea147670$export$e4c4bc19745d9cf0() {
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    // The search term is the one filter NOT in the URL: it can be a patient's
    // name (§3.2). It lives in the tab's session instead — see lib/phiSearch.
    const [query, setQuery] = (0, $a26d9ceff6a9d412$export$fc4eac43d8254712)('encounters');
    const param = (k)=>searchParams.get(k) ?? $10ec599bea147670$export$f484e977a69c6ba6[k];
    const filter = param('status');
    const type = param('type');
    const clinicId = param('clinic');
    const preset = param('preset');
    const custom = {
        from: param('from'),
        to: param('to')
    };
    const page = Math.max(0, (parseInt(searchParams.get('page') || '1', 10) || 1) - 1);
    const setParams = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch, { resetPage: resetPage = true, replace: replace = false } = {})=>{
        const { q: q, ...urlPatch } = patch;
        if (q !== undefined) setQuery(q);
        const next = new URLSearchParams(searchParams);
        for (const [k, v] of Object.entries(urlPatch))if (v == null || v === '' || v === $10ec599bea147670$export$f484e977a69c6ba6[k]) next.delete(k);
        else next.set(k, v);
        next.delete('q'); // never written back, even by an old caller
        if (resetPage) next.delete('page');
        if (next.toString() !== searchParams.toString()) setSearchParams(next, {
            replace: replace
        });
    }, [
        searchParams,
        setSearchParams,
        setQuery
    ]);
    // Preset/custom → epoch-ms window. A half-picked custom range holds the
    // previous window (null,null would collapse to "today" at the BFF), so the
    // list never flickers to today mid-edit.
    const { fromTs: fromTs, toTs: toTs } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (preset === 'custom') {
            if (!custom.from || !custom.to) return {
                fromTs: undefined,
                toTs: undefined
            };
            return (0, $bdd2cd30328e25bb$export$e319253fda62ab3b)(custom.from, custom.to);
        }
        return (0, $bdd2cd30328e25bb$export$c1d4212a2686aaff)(preset) || {
            fromTs: undefined,
            toTs: undefined
        };
    }, [
        preset,
        custom.from,
        custom.to
    ]);
    // Any non-default filter, the date window included — its default is «امروز»,
    // which is what makes the unfiltered empty state able to speak about today.
    const hasActiveFilters = filter !== $10ec599bea147670$export$f484e977a69c6ba6.status || type !== $10ec599bea147670$export$f484e977a69c6ba6.type || clinicId !== $10ec599bea147670$export$f484e977a69c6ba6.clinic || query !== $10ec599bea147670$export$f484e977a69c6ba6.q || preset !== $10ec599bea147670$export$f484e977a69c6ba6.preset;
    const clearFilters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setParams({
            status: '',
            type: '',
            clinic: '',
            q: '',
            preset: '',
            from: '',
            to: ''
        }), [
        setParams
    ]);
    return {
        searchParams: searchParams,
        setParams: setParams,
        filter: filter,
        type: type,
        clinicId: clinicId,
        query: query,
        preset: preset,
        custom: custom,
        page: page,
        fromTs: fromTs,
        toTs: toTs,
        hasActiveFilters: hasActiveFilters,
        clearFilters: clearFilters,
        view: param('view')
    };
}
function $10ec599bea147670$export$8f1616d06db62cf6() {
    const [clinics, setClinics] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $adebb901af88e18b$export$7fb4864174f056c)($10ec599bea147670$export$2ea464e7b016c8da).then((d)=>setClinics(d?.listClinics?.clinics || [])).catch(()=>{});
    }, []);
    const clinicNameById = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.fromEntries(clinics.map((c)=>[
                c.id,
                c.name
            ])), [
        clinics
    ]);
    return {
        clinics: clinics,
        clinicNameById: clinicNameById
    };
}
function $10ec599bea147670$export$e4dc044f81fdbe55(query, setParams) {
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(query);
    const debounceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // What THIS box last committed. Only a change from elsewhere («حذف فیلترها», a
    // migrated old link) resyncs the box — committing '' for a 1-letter entry must
    // not erase the letter the doctor just typed.
    const committedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(query);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (query !== committedRef.current) {
            committedRef.current = query;
            setSearch(query);
        }
    }, [
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(debounceRef.current), []);
    const onSearch = (val)=>{
        setSearch(val);
        clearTimeout(debounceRef.current);
        if (val === '') {
            committedRef.current = '';
            setParams({
                q: ''
            }, {
                replace: true
            });
            return;
        }
        // Below two characters the PREVIOUS term is dropped too — otherwise the list
        // kept filtering by «ab» while the box showed «a» (§11.3).
        const commit = val.trim().length < 2 ? '' : val;
        debounceRef.current = setTimeout(()=>{
            committedRef.current = commit;
            setParams({
                q: commit
            }, {
                replace: true
            });
        }, 300);
    };
    return {
        search: search,
        onSearch: onSearch
    };
}


// Card entrance only. Shimmer comes from the framework Skeleton* primitives (§2.4);
// reduced-motion collapses the entrance to instant (§12.4).
const $6e579600f5d18179$var$KF = `
  @keyframes encFadeUp { from { opacity:0; transform:translateY(0.5rem) } to { opacity:1; transform:translateY(0) } }
  .enc-fade { animation: encFadeUp .25s ease }
  @media (prefers-reduced-motion: reduce) { .enc-fade { animation: none } }
`;
function $6e579600f5d18179$var$EncStatus({ status: status }) {
    const { t: t } = (0, $LNQP4.default)();
    const m = (0, $10ec599bea147670$export$26790cf3975e36c8)[status] || {
        key: status,
        label: undefined
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
        status: m.key,
        label: m.labelKey ? t(m.labelKey) : undefined
    });
}
const $6e579600f5d18179$var$VIEWS = [
    {
        id: 'card',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8deaef2bfa57b80$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": "true"
        }),
        ariaLabelKey: 'encounters.view.card'
    },
    {
        id: 'list',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $673598ab744296f7$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": "true"
        }),
        ariaLabelKey: 'encounters.view.list'
    }
];
// ── EncounterCard ────────────────────────────────────────────────────────────
function $6e579600f5d18179$var$EncounterCard({ e: e, clinicName: clinicName, navigate: navigate }) {
    const i18n = (0, $LNQP4.default)();
    const { t: t } = i18n;
    const goToProfile = ()=>navigate('patient-detail', {
            patientId: e.patientId,
            id: e.patientId
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
        "data-testid": `encounters-card-${e.id}`,
        className: "enc-fade bg-white rounded-2xl border-[1.5px] border-border p-5 flex flex-col gap-3.5 shadow-card transition-[border-color,box-shadow] duration-200 hover:border-navy hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)]",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-start gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                        name: e.patientName || '',
                        size: 48
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "font-bold text-sm text-foreground mb-1 break-words",
                                children: e.patientName || t('encounters.unknownPatient')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-xs text-muted-foreground",
                                children: (0, $10ec599bea147670$export$b691916706e0e9cc)('type', e, null, i18n)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($6e579600f5d18179$var$EncStatus, {
                        status: e.status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "h-px bg-border"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-background rounded-lg px-2.5 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[0.625rem] text-muted-foreground mb-0.5",
                                children: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'date')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-xs font-semibold text-foreground",
                                children: (0, $10ec599bea147670$export$b691916706e0e9cc)('date', e, null, i18n)
                            })
                        ]
                    }),
                    clinicName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-background rounded-lg px-2.5 py-1.5 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[0.625rem] text-muted-foreground mb-0.5",
                                children: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'clinic')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-xs font-semibold text-foreground truncate",
                                title: clinicName,
                                children: clinicName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-background rounded-lg px-2.5 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[0.625rem] text-muted-foreground mb-0.5",
                                children: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'fileNumber')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `text-xs font-semibold tabular-nums ${e.fileNumber ? 'text-foreground' : 'text-muted-foreground'}`,
                                children: (0, $10ec599bea147670$export$b691916706e0e9cc)('fileNumber', e, null, i18n)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                className: "w-full",
                onClick: goToProfile,
                disabled: !e.patientId,
                "data-testid": `encounters-card-${e.id}-profile`,
                children: t('encounters.viewProfile')
            })
        ]
    });
}
function $6e579600f5d18179$export$2e2bcd8739ae039() {
    const i18n = (0, $LNQP4.default)();
    const { t: t } = i18n;
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { setParams: setParams, filter: filter, type: type, clinicId: clinicId, query: query, preset: preset, custom: custom, page: page, fromTs: fromTs, toTs: toTs, hasActiveFilters: hasActiveFilters, clearFilters: clearFilters, view: rawView } = (0, $10ec599bea147670$export$e4c4bc19745d9cf0)();
    const view = $6e579600f5d18179$var$VIEWS.some((v)=>v.id === rawView) ? rawView : 'card';
    const { clinics: clinics, clinicNameById: clinicNameById } = (0, $10ec599bea147670$export$8f1616d06db62cf6)();
    const { search: search, onSearch: handleSearch } = (0, $10ec599bea147670$export$e4dc044f81fdbe55)(query, setParams);
    const { encounters: all, total: total, loading: loading, error: error, reload: reload } = (0, $4be6b6b3ace2a56e$export$39f3c868c6c6a840)(filter !== 'all' ? filter : null, query, clinicId, type, {
        fromTs: fromTs,
        toTs: toTs,
        limit: (0, $f7753960a21756a4$export$8ec3d08588d2eeda),
        offset: page * (0, $f7753960a21756a4$export$8ec3d08588d2eeda)
    });
    const pageCount = Math.max(1, Math.ceil(total / (0, $f7753960a21756a4$export$8ec3d08588d2eeda)));
    const isEmpty = !loading && !error && all.length === 0;
    const dataState = loading ? 'loading' : error ? 'error' : isEmpty ? 'empty' : 'content';
    // Stale-while-refetch (§2.4/§8): on a refetch keep the previous page visible,
    // dimmed to 45%, instead of blanking to skeletons. Skeletons are first-load only.
    const stale = loading && all.length > 0;
    const skeleton = loading && all.length === 0;
    const clinicOptions = clinics.map((c)=>({
            value: c.id,
            label: c.name
        }));
    // Filtered-empty vs truly-empty (§2.4): a filtered-out list never claims the
    // dataset is empty. The default view is date-scoped to «امروز», so the unfiltered
    // empty copy speaks about today, not about the whole history.
    const emptyState = hasActiveFilters ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
            size: 56,
            className: "text-muted-foreground",
            "aria-hidden": "true"
        }),
        title: t('errors.empty.filters'),
        description: t('encounters.empty.filtersHint'),
        action: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: clearFilters,
            "data-testid": "encounters-empty-clear",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                    size: 15,
                    "aria-hidden": "true"
                }),
                t('encounters.clearFilters')
            ]
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b559e909b346eb90$export$2e2bcd8739ae039), {
            size: 56,
            className: "text-muted-foreground",
            "aria-hidden": "true"
        }),
        title: t('encounters.empty.today'),
        description: t('encounters.empty.todayHint')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "min-h-full flex flex-col bg-background",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: $6e579600f5d18179$var$KF
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('encounters.title'),
                sub: t('encounters.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-8 pt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "encounters-toolbar",
                    className: "bg-white border border-border rounded-2xl shadow-card px-4 py-3 flex flex-wrap items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex-1 min-w-[12.5rem] max-w-[25rem]",
                            "data-testid": "encounters-toolbar-search",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                value: search,
                                onChange: (e)=>handleSearch(e.target.value),
                                placeholder: t('encounters.searchPlaceholder'),
                                clearLabel: t('common.actions.clearSearch')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            "data-testid": "encounters-toolbar-daterange",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $awevB.default), {
                                presets: (0, $10ec599bea147670$export$1af56ca954f3d2d1)(t),
                                preset: preset,
                                custom: custom,
                                onPreset: (id)=>setParams({
                                        preset: id,
                                        from: '',
                                        to: ''
                                    }),
                                onCustom: (from, to)=>setParams({
                                        preset: 'custom',
                                        from: from,
                                        to: to
                                    })
                            })
                        }),
                        clinics.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "min-w-[10rem]",
                            "data-testid": "encounters-toolbar-clinic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                value: clinicId,
                                onChange: (e)=>setParams({
                                        clinic: e.target.value
                                    }),
                                options: clinicOptions,
                                placeholder: t('encounters.allClinics')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "min-w-[8.5rem]",
                            "data-testid": "encounters-toolbar-type",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                value: type,
                                onChange: (e)=>setParams({
                                        type: e.target.value
                                    }),
                                options: [
                                    {
                                        value: 'in-person',
                                        label: t('encounters.type.inPerson')
                                    },
                                    {
                                        value: 'online',
                                        label: t('encounters.type.online')
                                    }
                                ],
                                placeholder: t('encounters.allTypes')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                            items: (0, $10ec599bea147670$export$17007323c7130273).map((f)=>({
                                    ...f,
                                    label: t(f.labelKey)
                                })),
                            value: filter,
                            onChange: (id)=>setParams({
                                    status: id
                                }),
                            ariaLabel: t('encounters.statusFilter'),
                            testId: "encounters-toolbar-status"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                            items: $6e579600f5d18179$var$VIEWS.map((v)=>({
                                    ...v,
                                    ariaLabel: t(v.ariaLabelKey)
                                })),
                            value: view,
                            onChange: (id)=>setParams({
                                    view: id
                                }, {
                                    resetPage: false
                                }),
                            ariaLabel: t('encounters.viewMode'),
                            testId: "encounters-toolbar-view"
                        }),
                        hasActiveFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            size: "sm",
                            onClick: clearFilters,
                            "data-testid": "encounters-toolbar-clear",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                                    size: 15,
                                    "aria-hidden": "true"
                                }),
                                t('encounters.clearFilters')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-xs text-muted-foreground whitespace-nowrap ms-auto",
                            "data-testid": "encounters-toolbar-count",
                            children: loading ? "\u2026" : t('encounters.count', {
                                count: total
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "encounters-content",
                "data-state": dataState,
                className: "px-8 pb-8 pt-4",
                "aria-busy": loading || undefined,
                children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "encounters-error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        error: error,
                        title: t('encounters.unavailable'),
                        onRetry: reload
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        view === 'card' && (isEmpty ? emptyState : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `grid grid-cols-[repeat(auto-fill,minmax(16.25rem,1fr))] gap-4 transition-opacity ${stale ? 'opacity-[0.45] pointer-events-none' : ''}`,
                            children: skeleton ? Array.from({
                                length: (0, $f7753960a21756a4$export$8ec3d08588d2eeda)
                            }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $94ecceec5cec0a93$export$7e04a0fb8d63c537), {
                                    i: i
                                }, i)) : all.map((e)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6e579600f5d18179$var$EncounterCard, {
                                    e: e,
                                    clinicName: clinicNameById[e.clinicId],
                                    navigate: navigate
                                }, e.id))
                        })),
                        view === 'list' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `bg-white rounded-2xl border border-border max-[1180px]:overflow-x-auto transition-opacity ${stale ? 'opacity-[0.45] pointer-events-none' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "w-full border-collapse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                children: (0, $10ec599bea147670$export$6a6dcc7e725abed4).map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "sticky top-0 z-10 bg-background px-5 py-3.5 text-xs text-muted-foreground font-bold whitespace-nowrap text-start border-b border-border first:rounded-ss-2xl last:rounded-se-2xl",
                                                        children: t(c.labelKey)
                                                    }, c.id))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: skeleton ? Array.from({
                                                length: (0, $f7753960a21756a4$export$8ec3d08588d2eeda)
                                            }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRow), {
                                                    cols: (0, $10ec599bea147670$export$6a6dcc7e725abed4).length
                                                }, i)) : all.map((e)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    "data-testid": `encounters-row-${e.id}`,
                                                    role: "link",
                                                    tabIndex: e.patientId ? 0 : undefined,
                                                    "aria-label": t('encounters.recordOf', {
                                                        name: e.patientName || t('encounters.unknownPatient')
                                                    }),
                                                    onClick: ()=>e.patientId && navigate('patient-detail', {
                                                            patientId: e.patientId,
                                                            id: e.patientId
                                                        }),
                                                    onKeyDown: (ev)=>{
                                                        if (ev.key === 'Enter' && e.patientId) navigate('patient-detail', {
                                                            patientId: e.patientId,
                                                            id: e.patientId
                                                        });
                                                    },
                                                    className: `border-t border-border transition-colors ${e.patientId ? 'cursor-pointer hover:bg-muted/50 focus-visible:bg-muted/50 outline-none' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-5 py-3",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex items-center gap-2.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                                                        name: e.patientName || '',
                                                                        size: 36
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "font-bold text-sm text-foreground whitespace-nowrap max-w-[14rem] truncate",
                                                                        title: e.patientName || undefined,
                                                                        children: e.patientName || t('encounters.unknownPatient')
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: `px-5 py-3 text-[0.8125rem] whitespace-nowrap tabular-nums ${e.fileNumber ? 'text-foreground' : 'text-muted-foreground'}`,
                                                            children: (0, $10ec599bea147670$export$b691916706e0e9cc)('fileNumber', e, null, i18n)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-5 py-3 text-[0.8125rem] text-foreground/80 whitespace-nowrap",
                                                            children: (0, $10ec599bea147670$export$b691916706e0e9cc)('type', e, null, i18n)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-5 py-3 text-[0.8125rem] text-foreground/80 whitespace-nowrap",
                                                            children: (0, $10ec599bea147670$export$b691916706e0e9cc)('date', e, null, i18n)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-5 py-3 text-[0.8125rem] text-foreground/80 whitespace-nowrap max-w-[12rem] truncate",
                                                            title: clinicNameById[e.clinicId] || undefined,
                                                            children: (0, $10ec599bea147670$export$b691916706e0e9cc)('clinic', e, clinicNameById[e.clinicId], i18n)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-5 py-3",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($6e579600f5d18179$var$EncStatus, {
                                                                status: e.status
                                                            })
                                                        })
                                                    ]
                                                }, e.id))
                                        })
                                    ]
                                }),
                                isEmpty && emptyState
                            ]
                        }),
                        !skeleton && total > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            "data-testid": "encounters-pager",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a27afae32c22d713$export$2e2bcd8739ae039), {
                                page: page + 1,
                                pageCount: pageCount,
                                total: total,
                                pageSize: (0, $f7753960a21756a4$export$8ec3d08588d2eeda),
                                onPage: (p)=>setParams({
                                        page: p > 1 ? String(p) : ''
                                    }, {
                                        resetPage: false
                                    })
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $awevB = parcelRequire("awevB");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");


var $bF8pu = parcelRequire("bF8pu");
var $2VplL = parcelRequire("2VplL");

var $jTCZr = parcelRequire("jTCZr");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");
var $amyVq = parcelRequire("amyVq");

var $6Md3F = parcelRequire("6Md3F");
var $3SiwN = parcelRequire("3SiwN");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The mobile filter bar (DESIGN-CONCEPT-MOBILE v2 §6) — the shape every filtered
// list on the phone wears.
//
// The rule it encodes: THE TWO MOST FREQUENT CONTROLS STAY INLINE, everything
// else goes in a sheet. On حسابداری that is search + settlement; on سوابق
// ویزیت‌ها it is search + status. Anything more on a 320px bar either wraps into
// three rows or shrinks below a thumb.
//
// Generalised out of `MobileAccountingFilters` when the encounters screen needed
// the same bar (§E.2). The two screens differ in exactly three things, so those
// are props: which chips are inline (`chips`), what the extra sheet contains
// (`extraFilters`), and the testid prefix each screen's selector contract
// already names.
// ─────────────────────────────────────────────────────────────────────────────
const $29dd11c2673112b0$var$MobileFilterBar = ({ testId: testId, search: search, onSearch: onSearch, searchPlaceholder: searchPlaceholder, chips: chips = [], chipValue: chipValue, onChip: onChip, chipsLabel: chipsLabel, presets: presets = [], preset: preset, custom: custom = {}, onPreset: onPreset, onCustom: onCustom, rangeLabel: rangeLabel, extraFilters: extraFilters, activeCount: activeCount = 0, onClear: onClear, clearLabel: clearLabel })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Custom-range draft — committed only when both ends are set, so a half-picked
    // range never collapses the list to «امروز» mid-edit.
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        from: custom.from || '',
        to: custom.to || ''
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft({
            from: custom.from || '',
            to: custom.to || ''
        });
    }, [
        custom.from,
        custom.to
    ]);
    const clearText = clearLabel || t('common.actions.clearFilters');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `${testId}-search`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                    value: search,
                    onChange: (e)=>onSearch(e.target.value),
                    placeholder: searchPlaceholder,
                    clearLabel: t('common.actions.clearSearch')
                })
            }),
            chips.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tablist",
                "aria-label": chipsLabel,
                "data-testid": `${testId}-chips`,
                style: {
                    display: 'flex',
                    gap: '0.375rem'
                },
                children: chips.map((item)=>{
                    const active = chipValue === item.id;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        role: "tab",
                        "aria-selected": active,
                        variant: active ? 'default' : 'outline',
                        size: "sm",
                        className: "flex-1 min-h-11 px-2",
                        "data-testid": `${testId}-chips-${item.id}`,
                        onClick: ()=>onChip(item.id),
                        children: item.label
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5rem'
                },
                children: [
                    presets.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setRangeOpen(true),
                        "data-testid": `${testId}-range`,
                        className: "flex-1 min-h-11 justify-start gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Md3F.default), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: rangeLabel
                            })
                        ]
                    }),
                    extraFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setMoreOpen(true),
                        "data-testid": `${testId}-more`,
                        className: "flex-1 min-h-11 justify-start gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cf9022b4ea6e252$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('common.actions.filters'),
                            activeCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginInlineStart: 'auto',
                                    minWidth: '1.25rem',
                                    height: '1.25rem',
                                    borderRadius: '0.75rem',
                                    background: (0, $jTCZr.C).navy,
                                    color: 'white',
                                    fontSize: '0.6875rem',
                                    fontWeight: 800,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 0.375rem'
                                },
                                children: formatDigits(activeCount)
                            })
                        ]
                    })
                ]
            }),
            activeCount > 0 && onClear && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                onClick: onClear,
                "data-testid": `${testId}-clear`,
                className: "self-start min-h-11 gap-1.5 text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    clearText
                ]
            }),
            presets.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cZOyb.default), {
                open: rangeOpen,
                onClose: ()=>setRangeOpen(false),
                title: t('common.labels.dateRange'),
                closeLabel: t('common.actions.close'),
                "data-testid": `${testId}-range-sheet`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.5rem'
                        },
                        "data-testid": `${testId}-range-presets`,
                        children: presets.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: preset === p.id ? 'default' : 'outline',
                                size: "sm",
                                className: "min-h-11",
                                onClick: ()=>{
                                    onPreset(p.id);
                                    setRangeOpen(false);
                                },
                                children: p.label
                            }, p.id))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginTop: '1rem',
                            paddingTop: '1rem',
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginBottom: '0.5rem'
                                },
                                children: t('common.labels.customRange')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                            value: draft.from,
                                            onChange: (v)=>setDraft((d)=>({
                                                        ...d,
                                                        from: v
                                                    })),
                                            placeholder: t('common.labels.fromDate'),
                                            disableFuture: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                            value: draft.to,
                                            onChange: (v)=>setDraft((d)=>({
                                                        ...d,
                                                        to: v
                                                    })),
                                            placeholder: t('common.labels.toDate'),
                                            disableFuture: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "default",
                                className: "mt-3 w-full min-h-11",
                                disabled: !draft.from || !draft.to,
                                onClick: ()=>{
                                    onCustom(draft.from, draft.to);
                                    setRangeOpen(false);
                                },
                                children: t('accounting.applyCustomRange')
                            })
                        ]
                    })
                ]
            }),
            extraFilters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cZOyb.default), {
                open: moreOpen,
                onClose: ()=>setMoreOpen(false),
                title: t('common.actions.filters'),
                closeLabel: t('common.actions.close'),
                "data-testid": `${testId}-more-sheet`,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.875rem'
                    },
                    children: [
                        extraFilters,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "default",
                            className: "w-full min-h-11",
                            onClick: ()=>setMoreOpen(false),
                            children: t('accounting.viewResults')
                        }),
                        activeCount > 0 && onClear && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            className: "w-full min-h-11 gap-1.5 text-muted-foreground",
                            onClick: ()=>{
                                onClear();
                                setMoreOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                clearText
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $29dd11c2673112b0$export$394dd4e110d1ef89 = ({ label: label, children: children, testId: testId })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        style: {
            display: 'block'
        },
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textMuted,
                    display: 'block',
                    marginBottom: '0.375rem'
                },
                children: label
            }),
            children
        ]
    });
var $29dd11c2673112b0$export$2e2bcd8739ae039 = $29dd11c2673112b0$var$MobileFilterBar;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");

var $gKFEi = parcelRequire("gKFEi");

var $jTCZr = parcelRequire("jTCZr");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// One past visit, as a card (§B.2 ③).
//
// The phone's answer to the desktop's six-column table. It carries the same six
// facts and reads them through the SAME `cellValue`/`colLabel` definition the
// table does, so a file number is formatted identically on both surfaces and a
// column renamed once is renamed everywhere.
//
// The WHOLE card is the target, not a «مشاهدهٔ پرونده» button in its corner:
// there is one thing to do with a past visit — open the record — and a 44px
// button inside a 90px card is a smaller target than the card itself.
// ─────────────────────────────────────────────────────────────────────────────
const $8355a5e3976e9cf2$var$Meta = ({ label: label, value: value, mono: mono = false })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: (0, $jTCZr.C).bg,
            borderRadius: '0.5rem',
            padding: '0.375rem 0.5rem',
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.625rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.125rem'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontVariantNumeric: mono ? 'tabular-nums' : undefined
                },
                children: value
            })
        ]
    });
const $8355a5e3976e9cf2$var$MobileEncounterCard = ({ encounter: encounter, clinicName: clinicName, onOpen: onOpen })=>{
    const i18n = (0, $LNQP4.default)();
    const { t: t } = i18n;
    const status = (0, $10ec599bea147670$export$26790cf3975e36c8)[encounter.status] || {
        key: encounter.status
    };
    const name = encounter.patientName || t('encounters.unknownPatient');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        style: {
            padding: 0,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
            variant: "ghost",
            "data-testid": `encounters-card-${encounter.id}`,
            "aria-label": t('encounters.recordOf', {
                name: name
            }),
            disabled: !encounter.patientId,
            onClick: ()=>encounter.patientId && onOpen(encounter),
            className: "h-auto min-h-11 w-full flex-col items-stretch gap-2.5 rounded-none p-3 text-start",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                            name: encounter.patientName || '',
                            size: 40
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dir: "auto",
                                    style: {
                                        fontSize: '0.8125rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        marginTop: '0.125rem'
                                    },
                                    children: (0, $10ec599bea147670$export$b691916706e0e9cc)('type', encounter, null, i18n)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                            status: status.key,
                            label: status.labelKey ? t(status.labelKey) : undefined
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                            size: 16,
                            "aria-hidden": true,
                            style: {
                                color: (0, $jTCZr.C).textMuted,
                                flexShrink: 0,
                                transform: 'scaleX(var(--dir-flip))'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '0.375rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($8355a5e3976e9cf2$var$Meta, {
                            label: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'date'),
                            value: (0, $10ec599bea147670$export$b691916706e0e9cc)('date', encounter, null, i18n)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($8355a5e3976e9cf2$var$Meta, {
                            label: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'fileNumber'),
                            value: (0, $10ec599bea147670$export$b691916706e0e9cc)('fileNumber', encounter, null, i18n),
                            mono: true
                        }),
                        clinicName && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($8355a5e3976e9cf2$var$Meta, {
                                label: (0, $10ec599bea147670$export$117990e3c4b5b5aa)(t, 'clinic'),
                                value: clinicName
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $8355a5e3976e9cf2$export$2e2bcd8739ae039 = $8355a5e3976e9cf2$var$MobileEncounterCard;



// ─────────────────────────────────────────────────────────────────────────────
// سوابق ویزیت‌ها — the mobile encounter history (§B.2, S11).
//
// The screen that did not exist. `/encounters` had a desktop table, a PWA
// shortcut pointing straight at it, and nothing else — so a doctor who tapped
// «سوابق ویزیت‌ها» on their home screen got a six-column table on a 393px
// phone. With no mobile Encounters and no patient lookup, a phone could open
// exactly one thing: today's queue.
//
// An independent render tree over `Encounters.shared` — the same vocabularies,
// the same URL contract and the same query window the desktop table uses
// (§1.1). What it drops is the view toggle: on a phone there are cards and
// nothing to toggle to.
//
// The list ACCUMULATES through «نمایش بیشتر» rather than paging in place
// (§4: no infinite scroll, and no pager on a phone either). `page` still lives
// in the URL for the desktop's sake, so a link from either surface opens the
// same view on the other.
// ─────────────────────────────────────────────────────────────────────────────
const $9be1c06d046dc134$var$EncountersMobile = ()=>{
    const i18n = (0, $LNQP4.default)();
    const { t: t, formatNumber: formatNumber } = i18n;
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { setParams: setParams, filter: filter, type: type, clinicId: clinicId, query: query, preset: preset, custom: custom, fromTs: fromTs, toTs: toTs, hasActiveFilters: hasActiveFilters, clearFilters: clearFilters } = (0, $10ec599bea147670$export$e4c4bc19745d9cf0)();
    const { clinics: clinics, clinicNameById: clinicNameById } = (0, $10ec599bea147670$export$8f1616d06db62cf6)();
    const { search: search, onSearch: onSearch } = (0, $10ec599bea147670$export$e4dc044f81fdbe55)(query, setParams);
    // Accumulate rather than replace: «نمایش بیشتر» must add to what is on
    // screen, not swap it for the next page and leave no way back.
    const [pages, setPages] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPages(1);
    }, [
        filter,
        type,
        clinicId,
        query,
        preset,
        custom.from,
        custom.to
    ]);
    const { encounters: encounters, total: total, loading: loading, error: error, reload: reload } = (0, $4be6b6b3ace2a56e$export$39f3c868c6c6a840)(filter !== 'all' ? filter : null, query, clinicId, type, {
        fromTs: fromTs,
        toTs: toTs,
        limit: (0, $f7753960a21756a4$export$8ec3d08588d2eeda) * pages,
        offset: 0
    });
    const rangeLabel = (0, $awevB.rangeLabelFor)(preset, custom.from, custom.to, (0, $10ec599bea147670$export$1af56ca954f3d2d1)(t));
    const hiddenCount = Math.max(0, total - encounters.length);
    const isEmpty = !loading && !error && encounters.length === 0;
    const dataState = loading ? 'loading' : error ? 'error' : isEmpty ? 'empty' : 'content';
    // Stale-while-refetch (§2.4/§8): a refetch keeps the previous list visible
    // and dimmed. Skeletons are for the first load only — a list that blanks on
    // every filter tap reads as a broken screen.
    const stale = loading && encounters.length > 0;
    const skeleton = loading && encounters.length === 0;
    // How many non-default filters are on, for the «فیلترها» badge. The status
    // chips are inline, so they are not counted here.
    const sheetFilterCount = [
        type,
        clinicId
    ].filter(Boolean).length + (preset !== 'today' ? 1 : 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    compact: true,
                    title: t('encounters.title'),
                    actions: [
                        {
                            key: 'reload',
                            Icon: (0, $bF8pu.default),
                            label: t('common.actions.refresh'),
                            onClick: reload
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0.875rem 0.875rem 0'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29dd11c2673112b0$export$2e2bcd8739ae039), {
                            testId: "encounters-toolbar",
                            search: search,
                            onSearch: onSearch,
                            searchPlaceholder: t('encounters.searchPlaceholder'),
                            chips: (0, $10ec599bea147670$export$17007323c7130273).map((f)=>({
                                    id: f.id,
                                    label: t(f.labelKey)
                                })),
                            chipValue: filter,
                            onChip: (id)=>setParams({
                                    status: id
                                }),
                            chipsLabel: t('encounters.statusFilter'),
                            presets: (0, $10ec599bea147670$export$1af56ca954f3d2d1)(t),
                            preset: preset,
                            custom: custom,
                            onPreset: (id)=>setParams({
                                    preset: id,
                                    from: '',
                                    to: ''
                                }),
                            onCustom: (from, to)=>setParams({
                                    preset: 'custom',
                                    from: from,
                                    to: to
                                }),
                            rangeLabel: rangeLabel,
                            activeCount: sheetFilterCount,
                            onClear: clearFilters,
                            clearLabel: t('encounters.clearFilters'),
                            extraFilters: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29dd11c2673112b0$export$394dd4e110d1ef89), {
                                        label: t('encounters.columns.type'),
                                        testId: "encounters-filter-type",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                            value: type,
                                            onChange: (e)=>setParams({
                                                    type: e.target.value
                                                }),
                                            options: (0, $10ec599bea147670$export$dd86032c66b86dfb).map((o)=>({
                                                    value: o.value,
                                                    label: t(o.labelKey)
                                                })),
                                            placeholder: t('encounters.allTypes'),
                                            "aria-label": t('encounters.columns.type')
                                        })
                                    }),
                                    clinics.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29dd11c2673112b0$export$394dd4e110d1ef89), {
                                        label: t('common.labels.clinic'),
                                        testId: "encounters-filter-clinic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                            value: clinicId,
                                            onChange: (e)=>setParams({
                                                    clinic: e.target.value
                                                }),
                                            options: clinics.map((c)=>({
                                                    value: c.id,
                                                    label: c.name
                                                })),
                                            placeholder: t('encounters.allClinics'),
                                            "aria-label": t('common.labels.clinic')
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "encounters-content",
                        "data-state": "error",
                        style: {
                            padding: '0.875rem'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                            error: error,
                            title: t('encounters.unavailable'),
                            onRetry: reload
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "encounters-content",
                        "data-state": dataState,
                        "aria-busy": loading || undefined,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    padding: '0.875rem 0.875rem 0.5rem',
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: skeleton ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 72,
                                    height: 11
                                }) : t('encounters.count', {
                                    count: total
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '0 0.875rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.625rem',
                                    opacity: stale ? 0.45 : 1,
                                    pointerEvents: stale ? 'none' : undefined,
                                    transition: 'opacity 0.2s'
                                },
                                children: [
                                    skeleton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94ecceec5cec0a93$export$42022b6966315c4f), {
                                        count: 4
                                    }),
                                    isEmpty && (hasActiveFilters ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                                            size: 48,
                                            color: (0, $jTCZr.C).textMuted,
                                            strokeWidth: 1.5,
                                            "aria-hidden": true
                                        }),
                                        title: t('errors.empty.filters'),
                                        description: t('encounters.empty.filtersHint'),
                                        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                            variant: "outline",
                                            size: "sm",
                                            className: "min-h-11",
                                            onClick: clearFilters,
                                            "data-testid": "encounters-empty-clear",
                                            children: t('encounters.clearFilters')
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b559e909b346eb90$export$2e2bcd8739ae039), {
                                            size: 48,
                                            color: (0, $jTCZr.C).textMuted,
                                            strokeWidth: 1.5,
                                            "aria-hidden": true
                                        }),
                                        title: t('encounters.empty.today'),
                                        description: t('encounters.empty.todayHint')
                                    })),
                                    encounters.map((e)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $8355a5e3976e9cf2$export$2e2bcd8739ae039), {
                                            encounter: e,
                                            clinicName: clinicNameById[e.clinicId],
                                            onOpen: (enc)=>navigate('patient-detail', {
                                                    patientId: enc.patientId,
                                                    id: enc.patientId,
                                                    tab: 'visits'
                                                })
                                        }, e.id)),
                                    hiddenCount > 0 && !skeleton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                        variant: "outline",
                                        "data-testid": "encounters-more",
                                        className: "w-full min-h-11",
                                        disabled: loading,
                                        onClick: ()=>setPages((p)=>p + 1),
                                        children: t('dashboard.queue.showMore', {
                                            count: formatNumber(hiddenCount)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9be1c06d046dc134$export$2e2bcd8739ae039 = $9be1c06d046dc134$var$EncountersMobile;


// DESIGN-CONCEPT-MOBILE v2 §1.1: the two surfaces are independent render trees
// over one shared logic layer (`Encounters.shared`), not a responsive tier of
// the desktop table.
//
// Until now there was no second tree at all — `/encounters` served the
// six-column table to a phone, and the PWA manifest had a home-screen shortcut
// pointing straight at it.
const $28757782d734ce8e$var$EncountersScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9be1c06d046dc134$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e579600f5d18179$export$2e2bcd8739ae039), {});
};
var $28757782d734ce8e$export$2e2bcd8739ae039 = $28757782d734ce8e$var$EncountersScreen;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $fOdIP = parcelRequire("fOdIP");
var $jeN3v = parcelRequire("jeN3v");
var $l0ks6 = parcelRequire("l0ks6");
var $kaN2E = parcelRequire("kaN2E");
var $7gSBD = parcelRequire("7gSBD");
var $amyVq = parcelRequire("amyVq");
var $iK5Lj = parcelRequire("iK5Lj");
var $6usBW = parcelRequire("6usBW");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The messages screen's loading shapes — two regions that load independently.
//
// `ConversationListSkeleton`: one `ConversationRow` / `MobileConversationCard`
// per placeholder (Card, 0.75rem padding, a 38px avatar on desktop and 44px on
// the phone, name + preview lines, the time and an unread pill on the far
// side). `ThreadSkeleton`: message bubbles alternating sides, the way a real
// thread reads, so the pane keeps its identity while the room loads.
// ─────────────────────────────────────────────────────────────────────────────
const $d3f7c98bcea8dea1$var$ConversationRowSkeleton = ({ i: i, avatar: avatar })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem',
            borderRadius: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                size: avatar
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${44 + i * 17 % 30}%`,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${60 + i * 11 % 30}%`,
                        height: 11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 36,
                        height: 10
                    }),
                    i % 3 === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 20,
                        height: 20,
                        radius: (0, $jTCZr.RADIUS).pill
                    }) : null
                ]
            })
        ]
    });
const $d3f7c98bcea8dea1$export$3cc42ddbcba13ac2 = ({ count: count = 5, avatar: avatar = 38, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "messages-list-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d3f7c98bcea8dea1$var$ConversationRowSkeleton, {
                i: i,
                avatar: avatar
            }, i))
    });
};
const $d3f7c98bcea8dea1$var$BUBBLES = [
    {
        mine: false,
        w: '62%',
        h: 44
    },
    {
        mine: true,
        w: '48%',
        h: 36
    },
    {
        mine: false,
        w: '70%',
        h: 58
    },
    {
        mine: true,
        w: '40%',
        h: 36
    },
    {
        mine: false,
        w: '55%',
        h: 36
    }
];
const $d3f7c98bcea8dea1$export$6c911a26e7c202ba = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "messages-thread-loading",
        style: {
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: $d3f7c98bcea8dea1$var$BUBBLES.map((b, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    justifyContent: b.mine ? 'flex-end' : 'flex-start'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: b.w,
                    height: b.h,
                    radius: (0, $jTCZr.RADIUS).card,
                    style: {
                        [b.mine ? 'borderEndEndRadius' : 'borderEndStartRadius']: (0, $jTCZr.RADIUS).chip,
                        border: `1px solid ${(0, $jTCZr.C).border}`
                    }
                })
            }, i))
    });
};
var $d3f7c98bcea8dea1$export$2e2bcd8739ae039 = $d3f7c98bcea8dea1$export$3cc42ddbcba13ac2;



var $3SiwN = parcelRequire("3SiwN");
var $gYS9K = parcelRequire("gYS9K");
var $O6OQL = parcelRequire("O6OQL");
var $2VplL = parcelRequire("2VplL");

var $jTCZr = parcelRequire("jTCZr");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $g6X9N = parcelRequire("g6X9N");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// The phone's conversation row (DESIGN-CONCEPT-MOBILE v2 §1.1/§5): its own
// component, not the desktop row under a media query. Taller, no hover state,
// one tap target of at least 44px — and the same row model, from the same
// shared module, so the two surfaces can never disagree about what a row says.
//
// `dir="auto"` on the name and the preview: they are user content and each
// resolves its own direction.
const $40b7f0b77237606d$var$MobileConversationCard = ({ row: row, onOpen: onOpen, testId: testId })=>{
    const { t: t, formatNumber: formatNumber, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const name = row.peerDisplayName || t('messages.unknownContact');
    const timeLabel = (0, $b5200d235eee6334$export$bbb4a730e52f3d32)(row.lastActivityTs, {
        t: t,
        formatTime: formatTime,
        formatDate: formatDate
    });
    const unreadLabel = (0, $b5200d235eee6334$export$95dcf77aabe4f3a4)(row.unread, formatNumber);
    const preview = row.lastEvent?.body || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        onClick: ()=>onOpen(row),
        "data-testid": testId,
        className: "min-h-11",
        style: {
            padding: '0.75rem',
            borderRadius: '0.875rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.75rem',
                minWidth: 0
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                    name: name,
                    size: 44,
                    bg: (0, $7wZCE.avatarColor)(name)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: '0.5rem',
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    dir: "auto",
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.9375rem',
                                        fontWeight: row.unread > 0 ? 800 : 700,
                                        color: (0, $jTCZr.C).textPrimary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: name
                                }),
                                timeLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        flexShrink: 0
                                    },
                                    children: timeLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                marginTop: '0.25rem',
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    dir: "auto",
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.8125rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: preview || t((0, $b5200d235eee6334$export$711869e6ac8f0cad)(row))
                                }),
                                unreadLabel && // See ConversationRow: the kit's `count` variant owns the chip so
                                // «۱» and «۹+» stay the same size on both surfaces.
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                    variant: "count",
                                    "data-testid": testId ? `${testId}-unread` : undefined,
                                    "aria-label": t('messages.unreadBadge', {
                                        count: unreadLabel
                                    }),
                                    children: unreadLabel
                                })
                            ]
                        }),
                        row.reachable === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: '0.25rem'
                            },
                            children: t('messages.notOnApp')
                        }),
                        !row.started && row.reachable !== false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: '0.25rem'
                            },
                            children: t('messages.startConversation')
                        })
                    ]
                })
            ]
        })
    });
};
var $40b7f0b77237606d$export$2e2bcd8739ae039 = $40b7f0b77237606d$var$MobileConversationCard;


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// Message DELIVERY states — a third status vocabulary, alongside the
// appointment lifecycle (framework `statusColors`) and the clinical-order
// lifecycle (`constants/statuses.js` orderStatusColors). It follows the same
// rule those two follow: colours are DERIVED from the framework tokens, never a
// new hex source, and the words live in the catalogue under a path derived from
// the key.
//
// Deliberately NOT merged into `STATUS` and never rendered through StatusBadge:
// "sent" is a fact about one bubble in a thread, not a chip on a row, and the
// ChatBubble kit component already owns how pending/failed LOOK. This module
// only supplies the icon ink, the soft surface (for any list-level hint), the
// accessible name, and the kit's own status key.
//
// Colour budget: `CT.danger` is for **failed** only. A successful send is the
// ordinary outcome — colouring it green spends an alarm colour on "nothing
// happened", and puts three hues where the reader needs one signal. Sending and
// sent are both quiet; what distinguishes them is the kit's GLYPH (Clock vs.
// Check), because colour is never the only carrier of meaning (§12.4).

var $jTCZr = parcelRequire("jTCZr");
const $c2998424b5c285f9$export$2a8903fc7432635e = {
    sending: {
        color: (0, $jTCZr.CT).mute,
        bg: (0, $jTCZr.CT).surface2,
        bubble: 'pending',
        labelKey: 'messages.status.sending'
    },
    sent: {
        color: (0, $jTCZr.CT).mute,
        bg: (0, $jTCZr.CT).surface2,
        bubble: 'sent',
        labelKey: 'messages.status.sent'
    },
    failed: {
        color: (0, $jTCZr.CT).danger,
        bg: (0, $jTCZr.CT).dangerSoft,
        bubble: 'failed',
        labelKey: 'messages.status.failed'
    }
};
const $c2998424b5c285f9$export$1f0f393c2464dc2 = (msg)=>msg?.failed ? 'failed' : msg?.pending ? 'sending' : 'sent';


// ─────────────────────────────────────────────────────────────────────────────
// Messages — the ONE behaviour layer behind both surfaces (DESIGN-CONCEPT-MOBILE
// §1.1). `Messages.web.jsx` and `Messages.mobile.jsx` share nothing visual and
// disagree about nothing else: what the rows are, which one is selected, what
// the thread holds, whether a send is in flight — all of it is here.
//
// Deliberately DOM-free and component-free: no refs, no elements, no measuring.
// It composes three sources:
//
//   1. the BFF directory  — `chatConversations` (who each room is with) and
//      `chatContacts` (who a conversation could be started with). Fetched with
//      the loading/error/nonce shape `useEncounters` established.
//   2. the matrix runtime — live rooms, unread counts and the open room's
//      timeline, read through `chatRuntime`'s external store.
//   3. the URL           — selection (`?c=`) and the unread
//      filter (`?unread=1`). §3.2: the URL IS the state; there is no component
//      state for any of the three, so refresh / back / a shared link restore the
//      exact view. `roomId` is opaque, which is what makes it safe to put there.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");




const $a6063d29a8344fca$export$5b4a28eaa671d21 = `
  query ChatDirectory {
    chatConversations(limit: 200) {
      conversations {
        roomId
        peerMxid
        peerType
        peerSubjectId
        peerDisplayName
        createdAt
      }
      totalCount
    }
    chatContacts(limit: 200) {
      contacts {
        subjectType
        subjectId
        displayName
        role
        mxid
        roomId
        reachable
      }
      totalCount
    }
  }
`;
const $a6063d29a8344fca$var$OPEN_CONVERSATION_MUTATION = `
  mutation OpenChatConversation($subjectType: String!, $subjectId: ID!) {
    openChatConversation(subjectType: $subjectType, subjectId: $subjectId) {
      roomId
      peerType
      peerSubjectId
      peerDisplayName
      created
      createdAt
    }
  }
`;
// The URL carries only what is NOT at its default; these are the defaults.
const $a6063d29a8344fca$var$DEFAULTS = {
    c: '',
    q: '',
    unread: ''
};
const $a6063d29a8344fca$var$EMPTY_DIRECTORY = {
    conversations: [],
    contacts: []
};
function $a6063d29a8344fca$export$4d17e2d9c5348842() {
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const param = (k)=>searchParams.get(k) ?? $a6063d29a8344fca$var$DEFAULTS[k];
    const selectedRoomId = param('c') || null;
    // The search term is a person's name — kept OUT of the URL (§3.2), in the
    // tab's session instead (lib/phiSearch). An old `?q=` link is migrated.
    const [query, setQuery] = (0, $a26d9ceff6a9d412$export$fc4eac43d8254712)('messages');
    const unreadOnly = param('unread') === '1';
    // A param at its default is REMOVED. Whether the write PUSHES or REPLACES is
    // the caller's decision, because the two kinds of param are not the same kind
    // of fact — see `setFilterParams` below.
    const setParams = (0, $acw62.useCallback)((patch, { replace: replace = false } = {})=>{
        const next = new URLSearchParams(searchParams);
        for (const [k, v] of Object.entries(patch)){
            if (k === 'q') continue;
            if (v == null || v === '' || v === $a6063d29a8344fca$var$DEFAULTS[k]) next.delete(k);
            else next.set(k, v);
        }
        next.delete('q');
        if (next.toString() !== searchParams.toString()) setSearchParams(next, {
            replace: replace
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    // Filter churn REPLACES: typing a search must not bury the back button under
    // twelve entries. Selection PUSHES (plain `setParams`): on the phone `?c=` is
    // the boundary between two SCREENS, so hardware Back has to return
    // thread → list rather than leaving /messages altogether.
    const setFilterParams = (0, $acw62.useCallback)((patch)=>setParams(patch, {
            replace: true
        }), [
        setParams
    ]);
    // ── 1. The BFF directory ────────────────────────────────────────────────────
    const [directory, setDirectory] = (0, $acw62.useState)($a6063d29a8344fca$var$EMPTY_DIRECTORY);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [refreshing, setRefreshing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // TWO nonces, deliberately. One shared counter meant the thread's «تلاش
    // مجدد» — wired to a dead homeserver session — also re-ran the directory
    // fetch and blanked twelve perfectly good rows into skeletons. One region's
    // error never blanks another region (§2.4).
    const [directoryNonce, setDirectoryNonce] = (0, $acw62.useState)(0);
    const [chatNonce, setChatNonce] = (0, $acw62.useState)(0);
    const [loadedOnce, setLoadedOnce] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        // The FIRST load is a skeleton; every later one keeps the rows on screen
        // and merely dims them — a refetch is not a reason to take content away.
        if (loadedOnce) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($a6063d29a8344fca$export$5b4a28eaa671d21).then((data)=>{
            if (cancelled) return;
            setDirectory({
                conversations: data?.chatConversations?.conversations || [],
                contacts: data?.chatContacts?.contacts || []
            });
        }).catch((err)=>{
            if (cancelled) return;
            console.error('chat directory failed:', err);
            setError(err);
            setDirectory($a6063d29a8344fca$var$EMPTY_DIRECTORY);
        }).finally(()=>{
            if (cancelled) return;
            setLoading(false);
            setRefreshing(false);
            setLoadedOnce(true);
        });
        return ()=>{
            cancelled = true;
        };
    // `loadedOnce` is read, never depended on: it must not re-run the fetch.
    // The effect closure is rebuilt every render, so the run that a nonce bump
    // schedules already carries the current value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        directoryNonce
    ]);
    /** Re-read the BFF directory (the LIST). Also what a new room needs. */ const reload = (0, $acw62.useCallback)(()=>setDirectoryNonce((n)=>n + 1), []);
    // ── 2. The matrix runtime ───────────────────────────────────────────────────
    // Bootstrapping is separate from the directory: the list is perfectly usable
    // while the homeserver session is still being minted, and a failed session
    // must take down the THREAD only — never the list (§2.4).
    const [chatError, setChatError] = (0, $acw62.useState)(null);
    const [chatReady, setChatReady] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setChatError(null);
        (0, $caf8273c728e960b$export$cd24a7f1e48dad5d)().then(()=>{
            if (!cancelled) setChatReady(true);
        }).catch((err)=>{
            if (cancelled) return;
            console.error('chat session failed:', err);
            setChatReady(false);
            setChatError(err);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        chatNonce
    ]);
    /** Restart the homeserver session (the THREAD). Touches no BFF data. */ const reloadThread = (0, $acw62.useCallback)(()=>setChatNonce((n)=>n + 1), []);
    // The store snapshot is an integer (see chatRuntime): the room/timeline arrays
    // are derived from it, so React compares a number and not a fresh array.
    const revision = (0, $acw62.useSyncExternalStore)((0, $caf8273c728e960b$export$e8257d0a89c4abf9), (0, $caf8273c728e960b$export$a13a5384c80ad748), ()=>0);
    const client = (0, $caf8273c728e960b$export$8eae3e342750ca77)();
    // `revision` is the dependency that matters: the client object is stable for
    // the whole session, so without it these would never re-read.
    const rooms = (0, $acw62.useMemo)(()=>client ? client.getRooms() : [], [
        client,
        revision
    ]);
    const timeline = (0, $acw62.useMemo)(()=>client && selectedRoomId ? client.getTimeline(selectedRoomId) : [], [
        client,
        selectedRoomId,
        revision
    ]);
    // ── 3. Rows ─────────────────────────────────────────────────────────────────
    const conversations = (0, $acw62.useMemo)(()=>(0, $b5200d235eee6334$export$304baa583bceb4d)(directory.conversations, rooms), [
        directory.conversations,
        rooms
    ]);
    const rows = (0, $acw62.useMemo)(()=>{
        const searched = conversations.filter((row)=>(0, $b5200d235eee6334$export$8b796ceb524fa5a)(row, query));
        const filtered = unreadOnly ? (0, $b5200d235eee6334$export$54536d85f46615ae)(searched) : searched;
        // Contacts with no room yet are a SEARCH result, never part of the resting
        // list — and never part of an unread-filtered one: a conversation that does
        // not exist cannot be unread.
        if (unreadOnly) return filtered;
        return [
            ...filtered,
            ...(0, $b5200d235eee6334$export$e217d6a4c7385cae)(directory.contacts, conversations, query)
        ];
    }, [
        conversations,
        directory.contacts,
        query,
        unreadOnly
    ]);
    // Selection is resolved against the UNFILTERED set: narrowing the list must
    // not close the thread the doctor is reading.
    const selected = (0, $acw62.useMemo)(()=>conversations.find((row)=>row.roomId === selectedRoomId) || null, [
        conversations,
        selectedRoomId
    ]);
    const hasActiveFilters = query !== $a6063d29a8344fca$var$DEFAULTS.q || unreadOnly;
    // ── Selection / filters ─────────────────────────────────────────────────────
    const select = (0, $acw62.useCallback)((roomId)=>setParams({
            c: roomId || ''
        }), [
        setParams
    ]);
    const clearSelection = (0, $acw62.useCallback)(()=>setParams({
            c: ''
        }), [
        setParams
    ]);
    const setSearch = (0, $acw62.useCallback)((value)=>setQuery(value), [
        setQuery
    ]);
    const setUnreadOnly = (0, $acw62.useCallback)((on)=>setFilterParams({
            unread: on ? '1' : ''
        }), [
        setFilterParams
    ]);
    const clearFilters = (0, $acw62.useCallback)(()=>{
        setFilterParams({
            unread: ''
        });
        setQuery('');
    }, [
        setQuery,
        setFilterParams
    ]);
    // ── Opening a conversation ──────────────────────────────────────────────────
    // A row that already has a room just becomes the selection. A contact stub
    // has to be given one first — that mutation is the only write the list makes.
    const [opening, setOpening] = (0, $acw62.useState)(false);
    const openConversation = (0, $acw62.useCallback)(async (row)=>{
        if (!row) return null;
        if (row.roomId) {
            select(row.roomId);
            return row.roomId;
        }
        setOpening(true);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($a6063d29a8344fca$var$OPEN_CONVERSATION_MUTATION, {
                subjectType: row.peerType,
                subjectId: row.peerSubjectId
            });
            const roomId = data?.openChatConversation?.roomId;
            if (!roomId) throw new Error('openChatConversation: no roomId');
            // Re-read the directory so the new room arrives with its peer identity
            // attached; selecting it before that would render an unknown contact.
            reload();
            select(roomId);
            return roomId;
        } finally{
            setOpening(false);
        }
    }, [
        select,
        reload
    ]);
    // ── Reading ─────────────────────────────────────────────────────────────────
    // Mark read when the thread OPENS and again whenever a newer real event lands
    // while it is open. Keyed on the last event id rather than the raw revision so
    // a local echo or an unrelated room's sync does not re-post a receipt.
    const lastEventId = timeline.length ? timeline[timeline.length - 1].eventId : null;
    (0, $acw62.useEffect)(()=>{
        if (!selectedRoomId) return;
        (0, $caf8273c728e960b$export$8eae3e342750ca77)()?.markRead(selectedRoomId);
    }, [
        selectedRoomId,
        lastEventId
    ]);
    // ── Writing ─────────────────────────────────────────────────────────────────
    const [sending, setSending] = (0, $acw62.useState)(false);
    /**
   * Send, and report honestly whether it landed. matrix-lite never rejects — a
   * failed write flips its own entry to `failed` and waits — so the outcome is
   * read back off the timeline. Returns false on failure; the caller keeps the
   * draft and surfaces the error. Nothing here retries.
   */ const send = (0, $acw62.useCallback)(async (body)=>{
        const c = (0, $caf8273c728e960b$export$8eae3e342750ca77)();
        const text = (body || '').trim();
        if (!c || !selectedRoomId || !text) return false;
        setSending(true);
        try {
            const txnId = await c.sendMessage(selectedRoomId, text);
            const entry = c.getTimeline(selectedRoomId).find((e)=>e.txnId === txnId);
            if (entry && entry.failed) return false;
            await c.markRead(selectedRoomId);
            return true;
        } finally{
            setSending(false);
        }
    }, [
        selectedRoomId
    ]);
    /** Re-send one failed bubble. Caller-invoked only (ChatBubble's onRetry). */ const retry = (0, $acw62.useCallback)((txnId)=>{
        if (!selectedRoomId) return;
        (0, $caf8273c728e960b$export$8eae3e342750ca77)()?.retryMessage(selectedRoomId, txnId);
    }, [
        selectedRoomId
    ]);
    // ── Backwards pagination ────────────────────────────────────────────────────
    // Never automatic (the pagination-not-infinite-scroll rule): ChatThread's
    // expander calls this. `hasOlder` starts true for a synced room and latches
    // false once the server says there is nothing before the current page.
    const [olderState, setOlderState] = (0, $acw62.useState)({});
    const older = olderState[selectedRoomId] || {
        loading: false,
        exhausted: false
    };
    const loadOlder = (0, $acw62.useCallback)(async ()=>{
        const c = (0, $caf8273c728e960b$export$8eae3e342750ca77)();
        if (!c || !selectedRoomId) return;
        // Re-entrancy guard (the patient app's `useThread` has the same one): the
        // kit disables the expander while a page is in flight, so this is not
        // reachable by clicking — but a second call would set `loading` twice and
        // let the slower page's `exhausted` overwrite the faster one's.
        if (older.loading) return;
        setOlderState((s)=>({
                ...s,
                [selectedRoomId]: {
                    loading: true,
                    exhausted: false
                }
            }));
        try {
            const { hasMore: hasMore } = await c.loadOlder(selectedRoomId);
            setOlderState((s)=>({
                    ...s,
                    [selectedRoomId]: {
                        loading: false,
                        exhausted: !hasMore
                    }
                }));
        } catch  {
            // A failed page is not the start of the room — keep the expander offered.
            setOlderState((s)=>({
                    ...s,
                    [selectedRoomId]: {
                        loading: false,
                        exhausted: false
                    }
                }));
        }
    }, [
        selectedRoomId,
        older.loading
    ]);
    return {
        rows: // list
        rows,
        loading: loading,
        refreshing: refreshing,
        error: error,
        reload: reload,
        query: query,
        unreadOnly: unreadOnly,
        hasActiveFilters: hasActiveFilters,
        setSearch: setSearch,
        setUnreadOnly: setUnreadOnly,
        clearFilters: clearFilters,
        selectedRoomId: // selection
        selectedRoomId,
        selected: selected,
        select: select,
        clearSelection: clearSelection,
        openConversation: openConversation,
        opening: opening,
        timeline: // thread
        timeline,
        chatReady: chatReady,
        chatError: chatError,
        reloadThread: reloadThread,
        hasOlder: Boolean(selectedRoomId) && !older.exhausted && timeline.length > 0,
        loadingOlder: older.loading,
        loadOlder: loadOlder,
        send: // composing
        send,
        sending: sending,
        retry: retry,
        canSend: (0, $caf8273c728e960b$export$12cb85cc1540d7e0)(),
        readOnlyReason: (0, $caf8273c728e960b$export$502a12fc86aa76b)()
    };
}
var $a6063d29a8344fca$export$2e2bcd8739ae039 = $a6063d29a8344fca$export$4d17e2d9c5348842;



// ─────────────────────────────────────────────────────────────────────────────
// Messages — the phone surface (DESIGN-CONCEPT-MOBILE v2).
//
// Two screens, not two panes, and `?c=` is the boundary between them:
//
//   no ?c=  §3.1 top-level destination — cockpit header, bottom nav visible
//           (App owns that), the conversation list.
//   ?c=     §4B content screen — content-mode header whose back clears `?c=`
//           and whose title is the counterpart, NO bottom nav, and the composer
//           docked above the home indicator. `ChatThread` runs WITHOUT `fill`:
//           the message column is page flow, per the mobile page-scroll rule.
// ─────────────────────────────────────────────────────────────────────────────
const $8a5919fa18a921bb$var$SEARCH_DEBOUNCE_MS = 300;
// Client-side list window: the conversation list grows through an explicit
// «نمایش بیشتر» expander — never infinite scroll (mobile concept §4). The
// directory can return 200 conversations plus 200 contact stubs; a phone must
// not be handed 400 cards.
const $8a5919fa18a921bb$var$PAGE_SIZE = 10;
const $8a5919fa18a921bb$var$PAGE = {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: (0, $jTCZr.C).bg
};
// ── Thread screen ────────────────────────────────────────────────────────────
const $8a5919fa18a921bb$var$ThreadScreen = ({ m: m })=>{
    const { t: t, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // `PAGE` is `position:absolute; inset:0`, and the layout viewport does NOT
    // shrink when the software keyboard opens on iOS — without this the composer
    // sits under the keys the doctor is typing on.
    const keyboardInset = (0, $iK5Lj.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft('');
    }, [
        m.selectedRoomId
    ]);
    const onSend = async ()=>{
        const ok = await m.send(draft);
        if (!ok) toast.error(t('messages.errors.send'));
        else setDraft('');
    };
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $b5200d235eee6334$export$941a2159f900cf38)(m.timeline), [
        m.timeline
    ]);
    const state = m.chatError ? 'error' : !m.chatReady ? 'loading' : m.timeline.length === 0 ? 'empty' : 'content';
    const title = m.selected?.peerDisplayName || t('messages.unknownContact');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $8a5919fa18a921bb$var$PAGE,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    title: title,
                    onBack: m.clearSelection,
                    backTestId: "messages-header-back",
                    backLabel: t('messages.title')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "messages-thread-region",
                "data-state": state,
                "aria-busy": state === 'loading' || undefined,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch'
                },
                children: state === 'content' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kaN2E.default), {
                    "data-testid": "messages-thread",
                    hasOlder: m.hasOlder,
                    loadingOlder: m.loadingOlder,
                    onLoadOlder: m.loadOlder,
                    loadOlderLabel: t('messages.thread.loadOlder'),
                    padBlockRem: 0.75,
                    children: groups.flatMap((group)=>[
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l0ks6.default), {
                                label: formatDate(group.dayTs, 'medium')
                            }, `d-${group.dayTs}`),
                            ...group.messages.map((msg)=>{
                                const statusKey = (0, $c2998424b5c285f9$export$1f0f393c2464dc2)(msg);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fOdIP.default), {
                                    "data-testid": `messages-bubble-${msg.txnId || msg.eventId}`,
                                    body: msg.body,
                                    mine: msg.mine,
                                    pending: msg.pending,
                                    failed: msg.failed,
                                    timeLabel: formatTime(msg.ts),
                                    // The kit draws the glyph; the app supplies only the word
                                    // for it. No app-side dot — a hue is not a delivery state.
                                    status: msg.mine ? (0, $c2998424b5c285f9$export$2a8903fc7432635e)[statusKey].bubble : undefined,
                                    statusLabel: msg.mine ? t((0, $c2998424b5c285f9$export$2a8903fc7432635e)[statusKey].labelKey) : undefined,
                                    onRetry: msg.failed ? ()=>m.retry(msg.txnId) : undefined,
                                    retryLabel: t('messages.retry')
                                }, msg.txnId || msg.eventId);
                            })
                        ])
                }, m.selectedRoomId) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "messages-thread",
                    "data-state": state,
                    style: {
                        padding: '0.875rem'
                    },
                    children: state === 'error' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        error: m.chatError,
                        title: t('messages.thread.unavailable'),
                        onRetry: m.reloadThread
                    }) : state === 'loading' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3f7c98bcea8dea1$export$6c911a26e7c202ba), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $O6OQL.default), {
                            size: 48,
                            color: (0, $jTCZr.C).textMuted,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('messages.thread.empty.title'),
                        description: t('messages.thread.empty.hint')
                    })
                })
            }),
            state !== 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "messages-composer-dock",
                style: {
                    flexShrink: 0,
                    paddingBottom: `calc(env(safe-area-inset-bottom, 0px) + ${keyboardInset}px)`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jeN3v.default), {
                    "data-testid": "messages-composer",
                    inputProps: {
                        'data-testid': 'messages-composer-input'
                    },
                    value: draft,
                    onChange: (e)=>setDraft(e.target.value),
                    onSend: onSend,
                    sending: m.sending,
                    placeholder: t('messages.composer.placeholder'),
                    sendLabel: t('messages.composer.send'),
                    readOnlyNotice: m.canSend ? undefined : t((0, $b5200d235eee6334$export$fd1b0770ac454423)(m.readOnlyReason))
                })
            })
        ]
    });
};
// ── List screen ──────────────────────────────────────────────────────────────
const $8a5919fa18a921bb$var$ListScreen = ({ m: m, onOpen: onOpen })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(m.query);
    const debounceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setSearch(m.query);
    }, [
        m.query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(debounceRef.current), []);
    const onSearch = (value)=>{
        setSearch(value);
        clearTimeout(debounceRef.current);
        if (value === '') {
            m.setSearch('');
            return;
        }
        debounceRef.current = setTimeout(()=>m.setSearch(value), $8a5919fa18a921bb$var$SEARCH_DEBOUNCE_MS);
    };
    const clear = ()=>{
        setSearch('');
        m.clearFilters();
    };
    const isEmpty = !m.loading && !m.error && m.rows.length === 0;
    const state = m.loading ? 'loading' : m.error ? 'error' : isEmpty ? 'empty' : 'content';
    // Which EMPTY it is only changes the copy — `data-state` keeps the four
    // enumerated values (§15.1), so a [data-state="empty"] selector still
    // matches with a filter on. The app's own Encounters/Accounting screens do
    // exactly this.
    const filteredEmpty = isEmpty && m.hasActiveFilters;
    // The window resets whenever the SET changes — a new filter must not open on
    // page four of the previous one.
    const [visibleCount, setVisibleCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($8a5919fa18a921bb$var$PAGE_SIZE);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setVisibleCount($8a5919fa18a921bb$var$PAGE_SIZE);
    }, [
        m.query,
        m.unreadOnly,
        m.rows.length
    ]);
    const visibleRows = m.rows.slice(0, visibleCount);
    const hiddenCount = Math.max(0, m.rows.length - visibleCount);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $8a5919fa18a921bb$var$PAGE,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    title: t('messages.title')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0.875rem 0.875rem 0'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.625rem',
                                flexWrap: 'wrap',
                                background: (0, $jTCZr.C).card,
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: '0.875rem',
                                padding: '0.625rem 0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                    "data-testid": "messages-toolbar-search",
                                    value: search,
                                    onChange: (e)=>onSearch(e.target.value),
                                    placeholder: t('messages.search.placeholder'),
                                    clearLabel: t('common.actions.clearSearch'),
                                    style: {
                                        flex: 1,
                                        minWidth: '8rem'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                    testId: "messages-filter",
                                    ariaLabel: t('messages.filters.label'),
                                    items: [
                                        {
                                            id: 'all',
                                            label: t('messages.filters.all')
                                        },
                                        {
                                            id: 'unread',
                                            label: t('messages.filters.unread')
                                        }
                                    ],
                                    value: m.unreadOnly ? 'unread' : 'all',
                                    onChange: (id)=>m.setUnreadOnly(id === 'unread')
                                }),
                                m.hasActiveFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                    variant: "ghost",
                                    size: "sm",
                                    className: "min-h-11",
                                    onClick: clear,
                                    "data-testid": "messages-toolbar-clear",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                                            size: 15,
                                            "aria-hidden": true
                                        }),
                                        t('messages.clearFilters')
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "messages-list",
                        "data-state": state,
                        "aria-label": t('messages.list.label'),
                        "aria-busy": m.loading || m.refreshing || undefined,
                        "data-refreshing": m.refreshing ? 'true' : undefined,
                        style: {
                            padding: '0.875rem',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.625rem',
                            // A refetch dims the rows; it never takes them away (§2.4).
                            opacity: m.refreshing ? 0.45 : 1,
                            transition: 'opacity 0.15s'
                        },
                        children: [
                            state === 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3f7c98bcea8dea1$export$3cc42ddbcba13ac2), {
                                count: 4,
                                avatar: 44
                            }),
                            state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                title: t('messages.list.unavailable'),
                                error: m.error,
                                onRetry: m.reload
                            }),
                            state === 'empty' && filteredEmpty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                                    size: 48,
                                    color: (0, $jTCZr.C).textMuted,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('messages.list.filteredEmpty.title'),
                                description: t('messages.list.filteredEmpty.hint'),
                                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    size: "sm",
                                    className: "min-h-11",
                                    onClick: clear,
                                    "data-testid": "messages-list-empty-clear",
                                    children: t('messages.clearFilters')
                                })
                            }),
                            state === 'empty' && !filteredEmpty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYS9K.default), {
                                    size: 48,
                                    color: (0, $jTCZr.C).textMuted,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('messages.list.empty.title'),
                                description: t('messages.list.empty.hint')
                            }),
                            state === 'content' && visibleRows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $40b7f0b77237606d$export$2e2bcd8739ae039), {
                                    row: row,
                                    onOpen: onOpen,
                                    testId: `messages-list-row-${row.roomId || row.key}`
                                }, row.roomId || row.key)),
                            state === 'content' && hiddenCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "outline",
                                "data-testid": "messages-show-more",
                                className: "w-full min-h-11",
                                onClick: ()=>setVisibleCount((c)=>c + $8a5919fa18a921bb$var$PAGE_SIZE),
                                children: t('messages.list.showMore', {
                                    count: hiddenCount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function $8a5919fa18a921bb$export$2e2bcd8739ae039() {
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const m = (0, $a6063d29a8344fca$export$4d17e2d9c5348842)();
    const onOpen = async (row)=>{
        try {
            await m.openConversation(row);
        } catch (err) {
            console.error('openChatConversation failed:', err);
            toast.error(t('messages.errors.open'));
        }
    };
    // ONE screen at a time — the other is not rendered at all (§1.1), so the
    // list is not a hidden, still-tabbable layer under the open conversation.
    return m.selectedRoomId ? /*#__PURE__*/ (0, $ayMG0.jsx)($8a5919fa18a921bb$var$ThreadScreen, {
        m: m
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8a5919fa18a921bb$var$ListScreen, {
        m: m,
        onOpen: onOpen
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $fOdIP = parcelRequire("fOdIP");
var $jeN3v = parcelRequire("jeN3v");
var $l0ks6 = parcelRequire("l0ks6");
var $kaN2E = parcelRequire("kaN2E");
var $7gSBD = parcelRequire("7gSBD");
var $kyZIh = parcelRequire("kyZIh");
var $amyVq = parcelRequire("amyVq");
var $6usBW = parcelRequire("6usBW");


var $d8YVq = parcelRequire("d8YVq");
var $3SiwN = parcelRequire("3SiwN");
var $gYS9K = parcelRequire("gYS9K");
var $O6OQL = parcelRequire("O6OQL");
var $2VplL = parcelRequire("2VplL");

var $jTCZr = parcelRequire("jTCZr");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $g6X9N = parcelRequire("g6X9N");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// The desktop conversation row — local to this screen on purpose (§1.1: no
// component straddles the two surfaces; the phone has its own card). Kit Card /
// Avatar / Badge only, so it inherits the surface, the focus ring and the real
// button semantics rather than re-deriving them.
//
// Every user-content node is `dir="auto"`: a Persian name, an English one and a
// mixed message preview all sit in the same column and must each resolve their
// own direction.
const $5d569859eaa41d7f$var$ConversationRow = ({ row: row, active: active, onOpen: onOpen })=>{
    const { t: t, formatNumber: formatNumber, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const name = row.peerDisplayName || t('messages.unknownContact');
    const timeLabel = (0, $b5200d235eee6334$export$bbb4a730e52f3d32)(row.lastActivityTs, {
        t: t,
        formatTime: formatTime,
        formatDate: formatDate
    });
    const unreadLabel = (0, $b5200d235eee6334$export$95dcf77aabe4f3a4)(row.unread, formatNumber);
    const preview = row.lastEvent?.body || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        onClick: ()=>onOpen(row),
        "data-testid": `messages-list-row-${row.roomId || row.key}`,
        "data-active": active ? 'true' : 'false',
        "aria-current": active ? 'true' : undefined,
        style: {
            padding: '0.75rem',
            // Card scale (14px), the same as its phone twin — 12px is off the token
            // scale (10px controls / 14px cards / 20px hero).
            borderRadius: '0.875rem',
            borderColor: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border,
            background: active ? (0, $jTCZr.C).bg : (0, $jTCZr.C).card,
            boxShadow: 'none'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.625rem',
                minWidth: 0
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                    name: name,
                    size: 38,
                    bg: (0, $7wZCE.avatarColor)(name)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: '0.5rem',
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    dir: "auto",
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.875rem',
                                        fontWeight: row.unread > 0 ? 800 : 700,
                                        color: (0, $jTCZr.C).textPrimary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: name
                                }),
                                timeLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        flexShrink: 0
                                    },
                                    children: timeLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                marginTop: '0.1875rem',
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    dir: "auto",
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.75rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: preview || t((0, $b5200d235eee6334$export$711869e6ac8f0cad)(row))
                                }),
                                unreadLabel && // `variant="count"` rather than a style override: the kit owns the
                                // unread chip's whole geometry, including the tabular-nums and
                                // min-width that stop «۱» and «۹+» rendering at different sizes.
                                // Navy, never red — an unread message is attention, not alarm.
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                    variant: "count",
                                    "data-testid": `messages-list-row-${row.roomId || row.key}-unread`,
                                    "aria-label": t('messages.unreadBadge', {
                                        count: unreadLabel
                                    }),
                                    children: unreadLabel
                                })
                            ]
                        }),
                        row.reachable === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: '0.1875rem'
                            },
                            children: t('messages.notOnApp')
                        }),
                        !row.started && row.reachable !== false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: '0.1875rem'
                            },
                            children: t('messages.startConversation')
                        })
                    ]
                })
            ]
        })
    });
};
var $5d569859eaa41d7f$export$2e2bcd8739ae039 = $5d569859eaa41d7f$var$ConversationRow;




// ─────────────────────────────────────────────────────────────────────────────
// Messages — the desktop conversation workspace (Archetype B, zone ⑤ as a P4
// two-pane).
//
// Two tiers, one rule: the URL decides what is on screen.
//   >1180px  — list pane (own scroll) + thread pane side by side. `?c=` only
//              moves the highlight.
//   769–1180 — ONE pane at a time, chosen by `?c=`. The other pane is not
//              rendered, never merely hidden with CSS: a display:none list is
//              still in the accessibility tree, still tabbable, and still
//              fetching — a second screen pretending not to exist.
//
// The list keeps working when the thread cannot: a dead homeserver session
// replaces the THREAD pane only (§2.4). The doctor can still see who wrote.
// ─────────────────────────────────────────────────────────────────────────────
const $fcfe4c10fd2da49a$var$SEARCH_DEBOUNCE_MS = 300;
// ── Thread ───────────────────────────────────────────────────────────────────
const $fcfe4c10fd2da49a$var$ThreadPane = ({ m: m, compact: compact })=>{
    const { t: t, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // A draft belongs to the conversation it was typed in.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft('');
    }, [
        m.selectedRoomId
    ]);
    const onSend = async ()=>{
        const body = draft;
        const ok = await m.send(body);
        // No success toast — the bubble appearing IS the confirmation. A failure
        // keeps the draft and says so, because the bubble alone is easy to miss.
        if (!ok) toast.error(t('messages.errors.send'));
        else setDraft('');
    };
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $b5200d235eee6334$export$941a2159f900cf38)(m.timeline), [
        m.timeline
    ]);
    const state = !m.selectedRoomId ? 'empty' : m.chatError ? 'error' : !m.chatReady ? 'loading' : m.timeline.length === 0 ? 'empty' : 'content';
    // On the compact tier this pane IS the screen, so the way back belongs to it,
    // as the first element of its own header strip (§A.4). A top-level
    // `PageHeader` never carries a back affordance — you cannot go "back" from a
    // root — so the control moved down here rather than into its actions slot.
    const backStrip = compact && m.selectedRoomId ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexShrink: 0,
            padding: '0.5rem 0.625rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "min-h-11",
                onClick: m.clearSelection,
                "data-testid": "messages-header-back",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8YVq.default), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    t('common.actions.back')
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                dir: "auto",
                "data-testid": "messages-header-peer",
                style: {
                    flex: 1,
                    minWidth: 0,
                    fontSize: '0.9375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: m.selected?.peerDisplayName || t('messages.unknownContact')
            })
        ]
    }) : null;
    // ONE node owns the region's §7 state for all four states —
    // `messages-thread-region`. `messages-thread` stays on whatever renders the
    // messages, because the kit derives `messages-thread-load-older` from it and
    // the kit owns `ChatThread`'s own data-state (ready/loading-older).
    const region = (body)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "messages-thread-region",
            "data-state": state,
            "aria-busy": state === 'loading' || undefined,
            style: {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            },
            children: body
        });
    const shell = (children)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                height: '100%',
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.875rem',
                overflow: 'hidden'
            },
            children: [
                backStrip,
                children
            ]
        });
    if (state !== 'content') {
        const body = state === 'error' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: m.chatError,
            title: t('messages.thread.unavailable'),
            onRetry: m.reloadThread
        }) : state === 'loading' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3f7c98bcea8dea1$export$6c911a26e7c202ba), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
            fill: true,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $O6OQL.default), {
                size: 48,
                color: (0, $jTCZr.C).textMuted,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: m.selectedRoomId ? t('messages.thread.empty.title') : t('messages.thread.select.title'),
            description: m.selectedRoomId ? t('messages.thread.empty.hint') : t('messages.thread.select.hint')
        });
        return shell(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                region(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "messages-thread",
                    "data-state": state,
                    style: {
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column'
                    },
                    children: body
                })),
                m.selectedRoomId && state !== 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)($fcfe4c10fd2da49a$var$Composer, {
                    m: m,
                    draft: draft,
                    setDraft: setDraft,
                    onSend: onSend
                })
            ]
        }));
    }
    return shell(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            region(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kaN2E.default), {
                "data-testid": "messages-thread",
                fill: true,
                hasOlder: m.hasOlder,
                loadingOlder: m.loadingOlder,
                onLoadOlder: m.loadOlder,
                loadOlderLabel: t('messages.thread.loadOlder'),
                padBlockRem: 1,
                children: groups.flatMap((group)=>[
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l0ks6.default), {
                            label: formatDate(group.dayTs, 'medium')
                        }, `d-${group.dayTs}`),
                        ...group.messages.map((msg)=>{
                            const statusKey = (0, $c2998424b5c285f9$export$1f0f393c2464dc2)(msg);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fOdIP.default), {
                                "data-testid": `messages-bubble-${msg.txnId || msg.eventId}`,
                                body: msg.body,
                                mine: msg.mine,
                                pending: msg.pending,
                                failed: msg.failed,
                                timeLabel: formatTime(msg.ts),
                                // The kit draws the glyph; the app supplies only the word for
                                // it. No app-side dot — a hue is not a delivery state.
                                status: msg.mine ? (0, $c2998424b5c285f9$export$2a8903fc7432635e)[statusKey].bubble : undefined,
                                statusLabel: msg.mine ? t((0, $c2998424b5c285f9$export$2a8903fc7432635e)[statusKey].labelKey) : undefined,
                                onRetry: msg.failed ? ()=>m.retry(msg.txnId) : undefined,
                                retryLabel: t('messages.retry')
                            }, msg.txnId || msg.eventId);
                        })
                    ])
            }, m.selectedRoomId)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fcfe4c10fd2da49a$var$Composer, {
                m: m,
                draft: draft,
                setDraft: setDraft,
                onSend: onSend
            })
        ]
    }));
};
const $fcfe4c10fd2da49a$var$Composer = ({ m: m, draft: draft, setDraft: setDraft, onSend: onSend })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jeN3v.default), {
        "data-testid": "messages-composer",
        inputProps: {
            'data-testid': 'messages-composer-input'
        },
        value: draft,
        onChange: (e)=>setDraft(e.target.value),
        onSend: onSend,
        sending: m.sending,
        placeholder: t('messages.composer.placeholder'),
        sendLabel: t('messages.composer.send'),
        readOnlyNotice: m.canSend ? undefined : t((0, $b5200d235eee6334$export$fd1b0770ac454423)(m.readOnlyReason))
    });
};
// ── List ─────────────────────────────────────────────────────────────────────
// Same window as the phone (Messages.mobile.jsx). A clinic with 400 linked
// patients would otherwise render 400 rows into the pane on first paint:
// "long same-page lists cap at a sane window («نمایش بیشتر» expander) rather
// than rendering unbounded DOM" (DESIGN-CONCEPT §6). Pagination, not infinite
// scroll — growth is an explicit tap.
const $fcfe4c10fd2da49a$var$PAGE_SIZE = 20;
const $fcfe4c10fd2da49a$var$ListPane = ({ m: m, onOpen: onOpen })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [visibleCount, setVisibleCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($fcfe4c10fd2da49a$var$PAGE_SIZE);
    // A new filter or search is a new list; showing page 4 of it would be lying
    // about where the user is.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setVisibleCount($fcfe4c10fd2da49a$var$PAGE_SIZE);
    }, [
        m.query,
        m.unreadOnly
    ]);
    const isEmpty = !m.loading && !m.error && m.rows.length === 0;
    const state = m.loading ? 'loading' : m.error ? 'error' : isEmpty ? 'empty' : 'content';
    // Which EMPTY it is only changes the copy — `data-state` keeps the four
    // enumerated values (§15.1), so a [data-state="empty"] selector still
    // matches with a filter on. The app's own Encounters/Accounting screens do
    // exactly this.
    const filteredEmpty = isEmpty && m.hasActiveFilters;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "messages-list",
        "data-state": state,
        "aria-label": t('messages.list.label'),
        "aria-busy": m.loading || m.refreshing || undefined,
        "data-refreshing": m.refreshing ? 'true' : undefined,
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInlineEnd: '0.25rem',
            // A refetch keeps the rows and dims them; it never blanks them back to
            // skeletons. Only the first load has nothing to show.
            opacity: m.refreshing ? 0.45 : 1,
            transition: 'opacity 0.15s'
        },
        children: [
            state === 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3f7c98bcea8dea1$export$3cc42ddbcba13ac2), {
                count: 5,
                avatar: 38
            }),
            state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                title: t('messages.list.unavailable'),
                error: m.error,
                onRetry: m.reload
            }),
            state === 'empty' && filteredEmpty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                    size: 48,
                    color: (0, $jTCZr.C).textMuted,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('messages.list.filteredEmpty.title'),
                description: t('messages.list.filteredEmpty.hint'),
                action: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    variant: "outline",
                    size: "sm",
                    onClick: m.clearFilters,
                    "data-testid": "messages-list-empty-clear",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                            size: 15,
                            "aria-hidden": true
                        }),
                        t('messages.clearFilters')
                    ]
                })
            }),
            state === 'empty' && !filteredEmpty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYS9K.default), {
                    size: 48,
                    color: (0, $jTCZr.C).textMuted,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('messages.list.empty.title'),
                description: t('messages.list.empty.hint')
            }),
            state === 'content' && m.rows.slice(0, visibleCount).map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d569859eaa41d7f$export$2e2bcd8739ae039), {
                    row: row,
                    active: row.roomId === m.selectedRoomId,
                    onOpen: onOpen
                }, row.roomId || row.key)),
            state === 'content' && m.rows.length > visibleCount && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                className: "min-h-11 w-full",
                "data-testid": "messages-show-more",
                onClick: ()=>setVisibleCount((c)=>c + $fcfe4c10fd2da49a$var$PAGE_SIZE),
                children: t('messages.list.showMore', {
                    count: m.rows.length - visibleCount
                })
            })
        ]
    });
};
// ── Toolbar (zone ④) ─────────────────────────────────────────────────────────
// One card row. It belongs to the LIST, so on the compact tier it appears and
// disappears with it — filtering a pane you cannot see is not a control.
const $fcfe4c10fd2da49a$var$Toolbar = ({ m: m })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(m.query);
    const debounceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Back/forward or a shared link changed `q` outside the box — resync it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setSearch(m.query);
    }, [
        m.query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(debounceRef.current), []);
    const onSearch = (value)=>{
        setSearch(value);
        clearTimeout(debounceRef.current);
        if (value === '') {
            m.setSearch('');
            return;
        }
        debounceRef.current = setTimeout(()=>m.setSearch(value), $fcfe4c10fd2da49a$var$SEARCH_DEBOUNCE_MS);
    };
    const clear = ()=>{
        setSearch('');
        m.clearFilters();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            flexWrap: 'wrap',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.875rem',
            padding: '0.625rem 0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                "data-testid": "messages-toolbar-search",
                value: search,
                onChange: (e)=>onSearch(e.target.value),
                placeholder: t('messages.search.placeholder'),
                clearLabel: t('common.actions.clearSearch'),
                style: {
                    flex: 1,
                    minWidth: '10rem'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                testId: "messages-filter",
                ariaLabel: t('messages.filters.label'),
                items: [
                    {
                        id: 'all',
                        label: t('messages.filters.all')
                    },
                    {
                        id: 'unread',
                        label: t('messages.filters.unread')
                    }
                ],
                value: m.unreadOnly ? 'unread' : 'all',
                onChange: (id)=>m.setUnreadOnly(id === 'unread')
            }),
            m.hasActiveFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                onClick: clear,
                "data-testid": "messages-toolbar-clear",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    t('messages.clearFilters')
                ]
            })
        ]
    });
};
function $fcfe4c10fd2da49a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const m = (0, $a6063d29a8344fca$export$4d17e2d9c5348842)();
    // The compact tier collapses the two panes into one; the wide tier shows both.
    const [compact, setCompact] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia('(max-width: 1180px)');
        const sync = ()=>setCompact(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return ()=>mq.removeEventListener('change', sync);
    }, []);
    const showThread = !compact || Boolean(m.selectedRoomId);
    const showList = !compact || !m.selectedRoomId;
    const onOpen = async (row)=>{
        try {
            await m.openConversation(row);
        } catch (err) {
            console.error('openChatConversation failed:', err);
            toast.error(t('messages.errors.open'));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('messages.title'),
                sub: t('messages.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: 'grid',
                    gap: '1rem',
                    padding: '1rem',
                    gridTemplateColumns: compact ? 'minmax(0, 1fr)' : '22rem minmax(0, 1fr)'
                },
                children: [
                    showList && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            gap: '0.75rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($fcfe4c10fd2da49a$var$Toolbar, {
                                m: m
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($fcfe4c10fd2da49a$var$ListPane, {
                                m: m,
                                onOpen: onOpen
                            })
                        ]
                    }),
                    showThread && /*#__PURE__*/ (0, $ayMG0.jsx)($fcfe4c10fd2da49a$var$ThreadPane, {
                        m: m,
                        compact: compact
                    }, m.selectedRoomId || 'none')
                ]
            })
        ]
    });
}


// Messages is a platform fork (DESIGN-CONCEPT-MOBILE §1.1): two render trees
// over one shared behaviour layer (`useMessages` / `Messages.shared.js`). The
// desktop surface is a two-pane conversation workspace; the phone surface is a
// list destination that drills into a full-screen thread. Nothing straddles.
const $460d4055b9a87296$var$MessagesScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a5919fa18a921bb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fcfe4c10fd2da49a$export$2e2bcd8739ae039), {});
};
var $460d4055b9a87296$export$2e2bcd8739ae039 = $460d4055b9a87296$var$MessagesScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");


// /patients/:id/:tab? — the doctor panel's ROUTE onto the shared patient record.
//
// The record lives in @parsina/framework/clinical (docs/CLINICAL_KIT_DESIGN.md);
// this file owns the address bar and nothing else.
const $0de383faf6571668$var$PatientDetailScreen = ()=>{
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const rrNavigate = (0, $aphAM.useNavigate)();
    const { id: id, tab: tab } = (0, $aphAM.useParams)();
    const location = (0, $aphAM.useLocation)();
    const { state: state } = location;
    // URL param id is always authoritative; state may carry extra fields (name, etc.)
    // but its .id can be a different entity id (e.g. appointment id from calendar)
    const patient = {
        ...state || {},
        id: id
    };
    // The active section is a URL segment (/patients/:id/:tab), so refresh, back,
    // and shared links restore the same section. Switching tabs REPLACEs the entry:
    // the history stack keeps one entry per record, and goBack() below still returns
    // to the referrer, not to the previously open tab. location.state is re-sent so
    // the extra patient fields survive.
    const setTab = (item)=>rrNavigate(`/patients/${id}${item && item !== 'overview' ? `/${item}` : ''}${location.search}`, {
            replace: true,
            state: state
        });
    // Back affordance (§3.2): return to the actual referrer section — which
    // preserves its filters/scroll (context survives the round-trip). A deep link
    // has no in-app history (react-router marks the first entry key 'default'), so
    // we fall back to پذیرش rather than leaving the app.
    const goBack = ()=>{
        if (location.key && location.key !== 'default') rrNavigate(-1);
        else navigate('reception');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a04c8d3c93655abb$export$2e2bcd8739ae039), {
        patient: patient,
        tab: tab,
        onTabChange: setTab,
        onBack: goBack
    });
};
var $0de383faf6571668$export$2e2bcd8739ae039 = $0de383faf6571668$var$PatientDetailScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

// /visit/:patientId — the doctor panel's ROUTE onto the shared visit room.
//
// The room itself lives in @parsina/framework/clinical, the same code the clinic
// panel renders for a manager who also sees patients (docs/CLINICAL_KIT_DESIGN.md).
// All this file owns is reading the address: the id is authoritative, and
// whatever the caller put in `location.state` (the patient's name, the
// appointment it came from) rides along exactly as it always did.
const $35a05642ffb904d6$var$VisitScreen = ()=>{
    const { patientId: patientId } = (0, $aphAM.useParams)();
    const { state: state } = (0, $aphAM.useLocation)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5847361e5dafb1ed$export$2e2bcd8739ae039), {
        patient: state || {
            id: patientId
        }
    });
};
var $35a05642ffb904d6$export$2e2bcd8739ae039 = $35a05642ffb904d6$var$VisitScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");


const $b19869d2a80797f1$var$UPDATE_VISIT = `
  mutation UpdateVisit($id: ID!, $input: VisitInput!) {
    updateVisit(id: $id, input: $input) { id status }
  }
`;
// Note: CREATE_CLINICAL_NOTE uses the new ClinicalNoteInput shape (content: JSON,
// noteType, authorRole) — avoids the double-encoding bug of the old addClinicalNote.
// appointmentId is required on ClinicalNoteInput; visitId is the best proxy here
// since VoiceRecord doesn't have a separate pmEncounterId wired up.
const $b19869d2a80797f1$var$CREATE_CLINICAL_NOTE = `mutation CreateClinicalNote($patientId:ID!,$input:ClinicalNoteInput!){createClinicalNote(patientId:$patientId,input:$input){id}}`;
// ── SVG icons ────────────────────────────────────────────────────────────────
const $b19869d2a80797f1$var$IcMic = ({ size: size = 28, color: color = 'currentColor' })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
        })
    });
const $b19869d2a80797f1$var$IcCheck = ({ size: size = 26, color: color = 'currentColor' })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        })
    });
const $b19869d2a80797f1$var$IcBack = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $b19869d2a80797f1$var$IcBrain = ({ color: color = 'currentColor' })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "1.6",
        width: "14",
        height: "14",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 3a3 3 0 0 0-3 3v.17A3 3 0 0 0 4 9a3 3 0 0 0 2 2.83V14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-2.17A3 3 0 0 0 20 9a3 3 0 0 0-2-2.83V6a3 3 0 0 0-3-3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 3v18"
            })
        ]
    });
// ── Keyframe injector ────────────────────────────────────────────────────────
const $b19869d2a80797f1$var$KEYFRAMES = `
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes vPulse {
    0%,100% { opacity: 0.3; transform: scale(1); }
    50%      { opacity: 0.7; transform: scale(1.1); }
  }
  @keyframes vWave0 { from { transform: scaleY(0.40); } to { transform: scaleY(1.00); } }
  @keyframes vWave1 { from { transform: scaleY(0.55); } to { transform: scaleY(1.00); } }
  @keyframes vWave2 { from { transform: scaleY(0.30); } to { transform: scaleY(0.95); } }
  @keyframes vWave3 { from { transform: scaleY(0.60); } to { transform: scaleY(1.00); } }
  @keyframes vWave4 { from { transform: scaleY(0.45); } to { transform: scaleY(0.85); } }
`;
// ── Waveform bars ────────────────────────────────────────────────────────────
const $b19869d2a80797f1$var$HEIGHTS = [
    30,
    55,
    70,
    45,
    80,
    60,
    90,
    50,
    75,
    40,
    85,
    55,
    65,
    40,
    70,
    50,
    80,
    45,
    60,
    35
];
const $b19869d2a80797f1$var$WaveBar = ({ h: h, i: i, active: active })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: 2.5,
            borderRadius: 2,
            background: 'white',
            opacity: active ? 0.85 : 0.25,
            height: `${h}%`,
            transformOrigin: 'bottom center',
            transform: active ? 'none' : 'scaleY(0.3)',
            transition: `transform ${0.25 + i * 0.04}s ease, opacity 0.3s ease`,
            animation: active ? `vWave${i % 5} ${0.5 + i % 4 * 0.15}s ease-in-out infinite alternate` : 'none',
            flexShrink: 0
        }
    });
const $b19869d2a80797f1$var$VoiceRecordMobile = ({ navigate: navigate, patient: patient })=>{
    const { t: t, formatList: formatList } = (0, $LNQP4.default)();
    const p = patient || {
        name: t('patient.sampleName'),
        id: 'v1'
    };
    const visitId = p.visitId || p.id || 'v1';
    const patientHistory = formatList([
        p.conditions,
        p.allergies
    ].flat().filter(Boolean));
    const { recState: recState, elapsed: elapsed, hints: hints, report: hookReport, startRec: startRec, stopRec: stopRec } = (0, $b5da27b488005ec5$export$e2373706461b5244)({
        visitId: visitId,
        patientHistory: patientHistory
    });
    const [editMode, setEditMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [report, setReport] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        symptoms: '',
        diagnosis: '',
        notes: ''
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (hookReport) setReport(hookReport);
    }, [
        hookReport
    ]);
    const fmt = (s)=>`${Math.floor(s / 60).toString().padStart(2, '0')}:${(s % 60).toString().padStart(2, '0')}`;
    const handleSave = ()=>{
        setSaving(true);
        // UPDATE_VISIT no longer accepts diagnosis/notes — those fields were removed from VisitInput.
        // Persist only status; save the voice report as a SOAP-shaped clinical note.
        const patientId = p.patientId || p.id;
        Promise.all([
            (0, $adebb901af88e18b$export$8395d0fc0d822a81)($b19869d2a80797f1$var$UPDATE_VISIT, {
                id: visitId,
                input: {
                    status: 'inprogress'
                }
            }),
            patientId ? (0, $adebb901af88e18b$export$8395d0fc0d822a81)($b19869d2a80797f1$var$CREATE_CLINICAL_NOTE, {
                patientId: patientId,
                input: {
                    noteType: 'SOAP_NOTE',
                    content: {
                        s: report.symptoms || '',
                        o: '',
                        a: report.diagnosis || '',
                        p: report.notes || ''
                    },
                    authorRole: 'doctor',
                    appointmentId: visitId
                }
            }) : Promise.resolve()
        ]).then(()=>setEditMode(false)).finally(()=>setSaving(false));
    };
    const stateLabel = {
        idle: t('visit.record.ready'),
        recording: t('visit.record.recording'),
        stopping: t('visit.record.processingAudio'),
        processing: t('visit.record.analysing'),
        done: t('visit.record.done')
    }[recState] || t('visit.record.ready');
    const panelBg = recState === 'processing' || recState === 'stopping' ? `color-mix(in srgb, ${(0, $jTCZr.C).teal} 12%, var(--panel-ink-deep))` : recState === 'done' ? '#071e14' : 'var(--panel-ink-deep)';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            background: '#ffffff',
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: $b19869d2a80797f1$var$KEYFRAMES
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: 'var(--panel-ink-deep)',
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>navigate('visit', p),
                                style: {
                                    background: 'rgba(255,255,255,0.1)',
                                    border: 'none',
                                    borderRadius: 10,
                                    width: 36,
                                    height: 36,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: 'white'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$IcBack, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            color: 'white',
                                            fontSize: 15,
                                            fontWeight: 600
                                        },
                                        children: t('nav.items.voice')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            color: 'rgba(255,255,255,0.45)',
                                            fontSize: 11,
                                            marginTop: 1
                                        },
                                        children: p.name
                                    })
                                ]
                            })
                        ]
                    }),
                    recState === 'done' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>navigate('prescription', {
                                ...p,
                                visitId: visitId,
                                id: p.id
                            }),
                        style: {
                            background: (0, $jTCZr.C).navy,
                            border: 'none',
                            borderRadius: 10,
                            padding: '8px 16px',
                            fontSize: 12,
                            fontWeight: 600,
                            color: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6
                        },
                        children: [
                            t('nav.items.prescription'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "white",
                                width: "13",
                                height: "13",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M8 5v14l11-7z"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: panelBg,
                    padding: '36px 24px 32px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'background 0.6s ease',
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 10,
                            letterSpacing: '1.4px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            color: recState === 'recording' ? (0, $jTCZr.C).teal : recState === 'done' ? '#4ade80' : 'rgba(255,255,255,0.35)',
                            marginBottom: 24
                        },
                        children: stateLabel
                    }),
                    recState === 'recording' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 44,
                            fontWeight: 200,
                            color: 'white',
                            letterSpacing: 6,
                            fontVariantNumeric: 'tabular-nums',
                            marginBottom: 28,
                            lineHeight: 1
                        },
                        children: fmt(elapsed)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: 56,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 28
                        },
                        children: recState === 'processing' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 36,
                                height: 36,
                                border: '2px solid rgba(255,255,255,0.15)',
                                borderTopColor: (0, $jTCZr.C).teal,
                                borderRadius: '50%',
                                animation: 'spin 0.9s linear infinite'
                            }
                        }) : recState === 'done' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 52,
                                height: 52,
                                borderRadius: '50%',
                                background: 'rgba(74,222,128,0.15)',
                                border: '1.5px solid rgba(74,222,128,0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$IcCheck, {
                                size: 24,
                                color: "#4ade80"
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 3
                            },
                            children: $b19869d2a80797f1$var$HEIGHTS.map((h, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$WaveBar, {
                                    h: h,
                                    i: i,
                                    active: recState === 'recording'
                                }, i))
                        })
                    }),
                    recState === 'idle' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: startRec,
                        style: {
                            width: 76,
                            height: 76,
                            borderRadius: '50%',
                            background: 'transparent',
                            border: '1.5px solid rgba(255,255,255,0.25)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            transition: 'border-color 0.2s'
                        },
                        onMouseDown: (e)=>{
                            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
                            e.currentTarget.style.transform = 'scale(0.96)';
                        },
                        onMouseUp: (e)=>{
                            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)';
                            e.currentTarget.style.transform = 'scale(1)';
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    inset: -8,
                                    borderRadius: '50%',
                                    border: '1px solid rgba(255,255,255,0.08)',
                                    animation: 'vPulse 2.4s ease-in-out infinite'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$IcMic, {
                                size: 30,
                                color: "white"
                            })
                        ]
                    }),
                    recState === 'recording' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: stopRec,
                        style: {
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            background: (0, $jTCZr.C).red,
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: `0 0 0 6px rgba(217,48,37,0.18)`
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 20,
                                height: 20,
                                background: 'white',
                                borderRadius: 3
                            }
                        })
                    }),
                    recState === 'processing' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: 'rgba(255,255,255,0.4)',
                            letterSpacing: '0.5px',
                            marginTop: 4
                        },
                        children: t('visit.record.transcribing')
                    })
                ]
            }),
            hints.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    margin: '16px 16px 0'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7,
                            marginBottom: 10
                        },
                        children: [
                            recState === 'recording' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    background: (0, $jTCZr.C).teal,
                                    animation: 'vPulse 1.2s infinite',
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$IcBrain, {
                                color: (0, $jTCZr.C).teal
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).teal,
                                    letterSpacing: '0.6px',
                                    textTransform: 'uppercase'
                                },
                                children: t('visit.suggest.clinical')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    marginInlineStart: 'auto',
                                    fontSize: 11,
                                    color: (0, $jTCZr.C).textMuted,
                                    fontWeight: 600
                                },
                                children: [
                                    hints.length,
                                    " ",
                                    t('visit.suggest.one')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            maxHeight: 260,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        },
                        children: hints.map((h, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    background: 'white',
                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                    borderInlineStart: `3px solid ${i === 0 ? (0, $jTCZr.C).teal : '#e2e8f0'}`,
                                    borderRadius: 12,
                                    padding: '12px 14px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 10,
                                            fontWeight: 700,
                                            color: i === 0 ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textMuted,
                                            letterSpacing: '0.5px',
                                            marginBottom: 6
                                        },
                                        children: i === 0 ? t('visit.suggest.latest') : t('visit.suggest.numbered', {
                                            n: hints.length - i
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.75
                                        },
                                        children: typeof h === 'string' ? h : h.text || ''
                                    })
                                ]
                            }, i))
                    })
                ]
            }),
            recState === 'done' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '20px 16px 100px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 16,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('visit.report.title')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 2
                                        },
                                        children: t('visit.report.aiGenerated')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>editMode ? handleSave() : setEditMode(true),
                                style: {
                                    padding: '7px 16px',
                                    borderRadius: 20,
                                    border: `1.5px solid ${editMode ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                    background: editMode ? (0, $jTCZr.C).navy : 'white',
                                    color: editMode ? 'white' : (0, $jTCZr.C).textSecondary,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    transition: 'all 0.2s'
                                },
                                children: editMode ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($b19869d2a80797f1$var$IcCheck, {
                                            size: 14,
                                            color: "white"
                                        }),
                                        " ",
                                        t('common.actions.save')
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: (0, $jTCZr.C).textSecondary,
                                            strokeWidth: "2",
                                            width: "13",
                                            height: "13",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                                                })
                                            ]
                                        }),
                                        t('common.actions.edit')
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            background: 'white',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 14,
                            overflow: 'hidden',
                            marginBottom: 12
                        },
                        children: [
                            {
                                key: 'symptoms',
                                label: t('visit.report.historyAndSymptoms'),
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: (0, $jTCZr.C).textMuted,
                                    strokeWidth: "1.8",
                                    width: "14",
                                    height: "14",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M22 12h-4l-3 9L9 3l-3 9H2"
                                    })
                                })
                            },
                            {
                                key: 'diagnosis',
                                label: t('visit.report.probableDiagnosis'),
                                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: (0, $jTCZr.C).textMuted,
                                    strokeWidth: "1.8",
                                    width: "14",
                                    height: "14",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                            cx: "11",
                                            cy: "11",
                                            r: "8"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "m21 21-4.35-4.35"
                                        })
                                    ]
                                })
                            },
                            {
                                key: 'notes',
                                label: t('patient.overview.clinicalSummary'),
                                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: (0, $jTCZr.C).textMuted,
                                    strokeWidth: "1.8",
                                    width: "14",
                                    height: "14",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                            points: "14 2 14 8 20 8"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                            x1: "16",
                                            y1: "13",
                                            x2: "8",
                                            y2: "13"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                            x1: "16",
                                            y1: "17",
                                            x2: "8",
                                            y2: "17"
                                        })
                                    ]
                                })
                            }
                        ].map((f, idx, arr)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '16px',
                                    borderBottom: idx < arr.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            marginBottom: 8
                                        },
                                        children: [
                                            f.icon,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: 10,
                                                    letterSpacing: '0.8px',
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).textMuted,
                                                    textTransform: 'uppercase'
                                                },
                                                children: f.label
                                            })
                                        ]
                                    }),
                                    editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        value: report[f.key],
                                        onChange: (e)=>setReport((r)=>({
                                                    ...r,
                                                    [f.key]: e.target.value
                                                })),
                                        style: {
                                            width: '100%',
                                            minHeight: 70,
                                            border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                            borderRadius: 8,
                                            padding: '10px 12px',
                                            fontSize: 13,
                                            fontFamily: 'var(--app-font)',
                                            resize: 'none',
                                            outline: 'none',
                                            background: '#fafbfc',
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.7
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.75
                                        },
                                        children: report[f.key] || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: "\u2014"
                                        })
                                    })
                                ]
                            }, f.key))
                    }),
                    report.icdCodes?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: 'white',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 14,
                            padding: '16px',
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: (0, $jTCZr.C).textMuted,
                                        strokeWidth: "1.8",
                                        width: "14",
                                        height: "14",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                                x1: "7",
                                                y1: "7",
                                                x2: "7.01",
                                                y2: "7"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 10,
                                            letterSpacing: '0.8px',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textMuted,
                                            textTransform: 'uppercase'
                                        },
                                        children: t('visit.report.icd10')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 8
                                },
                                children: report.icdCodes.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontFamily: 'monospace',
                                                    fontSize: 11,
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).navy,
                                                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07),
                                                    padding: '3px 8px',
                                                    borderRadius: 6,
                                                    flexShrink: 0,
                                                    letterSpacing: '0.5px'
                                                },
                                                children: c.code
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: 12,
                                                    color: (0, $jTCZr.C).textSecondary
                                                },
                                                children: c.description
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    report.suggestedActions?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: 'white',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 14,
                            padding: '16px',
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: (0, $jTCZr.C).textMuted,
                                        strokeWidth: "1.8",
                                        width: "14",
                                        height: "14",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "9 11 12 14 22 4"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 10,
                                            letterSpacing: '0.8px',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textMuted,
                                            textTransform: 'uppercase'
                                        },
                                        children: t('patient.upload.suggestedActions')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 10
                                },
                                children: report.suggestedActions.map((a, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 10,
                                            alignItems: 'flex-start'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    width: 18,
                                                    height: 18,
                                                    borderRadius: 5,
                                                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                    marginTop: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: 10,
                                                        color: (0, $jTCZr.C).textMuted
                                                    },
                                                    children: i + 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: 13,
                                                    color: (0, $jTCZr.C).textPrimary,
                                                    lineHeight: 1.65
                                                },
                                                children: a
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    report.suggestedMedications?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: 'white',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 14,
                            padding: '16px',
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: (0, $jTCZr.C).textMuted,
                                        strokeWidth: "1.8",
                                        width: "14",
                                        height: "14",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M10.5 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "18",
                                                cy: "18",
                                                r: "3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.5 15.5 18 18l-1.5-1.5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 10,
                                            letterSpacing: '0.8px',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textMuted,
                                            textTransform: 'uppercase'
                                        },
                                        children: t('visit.rx.suggested')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 7
                                },
                                children: report.suggestedMedications.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            color: (0, $jTCZr.C).navy,
                                            fontWeight: 500,
                                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.18)}`,
                                            borderRadius: 20,
                                            padding: '5px 12px'
                                        },
                                        children: m
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>navigate('prescription', {
                                        ...p,
                                        visitId: visitId,
                                        id: p.id
                                    }),
                                style: {
                                    flex: 3,
                                    height: 52,
                                    background: (0, $jTCZr.C).navy,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 14,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "white",
                                        width: "16",
                                        height: "16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9h6m-6 4h4"
                                        })
                                    }),
                                    t('nav.items.prescription')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: handleSave,
                                disabled: saving,
                                style: {
                                    flex: 1,
                                    height: 52,
                                    background: 'white',
                                    color: saving ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textSecondary,
                                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                    borderRadius: 14,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    cursor: 'pointer'
                                },
                                children: saving ? '...' : t('common.actions.save')
                            })
                        ]
                    })
                ]
            }),
            recState !== 'done' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: 32
                }
            })
        ]
    });
};
var $b19869d2a80797f1$export$2e2bcd8739ae039 = $b19869d2a80797f1$var$VoiceRecordMobile;



var $jTCZr = parcelRequire("jTCZr");
const $745db304ee2a89f4$var$VoiceRecordScreen = ()=>{
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { patientId: patientId } = (0, $aphAM.useParams)();
    const { state: state } = (0, $aphAM.useLocation)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const patient = state || {
        id: patientId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            background: isMobile ? 'none' : (0, $jTCZr.C).bg,
            flex: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                width: isMobile ? '100%' : '500px',
                height: isMobile ? '100%' : '90vh',
                marginTop: isMobile ? 0 : '5vh',
                boxShadow: isMobile ? 'none' : '0 10px 25px rgba(0,0,0,0.1)',
                borderRadius: isMobile ? 0 : 24,
                overflow: 'hidden',
                display: 'flex'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b19869d2a80797f1$export$2e2bcd8739ae039), {
                navigate: navigate,
                patient: patient
            })
        })
    });
};
var $745db304ee2a89f4$export$2e2bcd8739ae039 = $745db304ee2a89f4$var$VoiceRecordScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eLeza = parcelRequire("eLeza");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $9TQrL = parcelRequire("9TQrL");
var $iK5Lj = parcelRequire("iK5Lj");



var $acw62 = parcelRequire("acw62");

const $11ef833351561454$var$TEMPLATES_QUERY = `
  query {
    noteTemplates {
      id
      title
      tag
      tagColor
      content
    }
    prescriptionTemplates {
      id
      title
      content
    }
  }
`;
const $11ef833351561454$var$ADD_NOTE = `
  mutation($input: NoteTemplateInput!) {
    addNoteTemplate(input: $input) { id title tag tagColor content }
  }
`;
const $11ef833351561454$var$UPDATE_NOTE = `
  mutation($id: ID!, $input: NoteTemplateInput!) {
    updateNoteTemplate(id: $id, input: $input) { id title tag tagColor content }
  }
`;
const $11ef833351561454$var$DELETE_NOTE = `
  mutation($id: ID!) { deleteNoteTemplate(id: $id) }
`;
const $11ef833351561454$var$ADD_RX = `
  mutation($input: PrescriptionTemplateInput!) {
    addPrescriptionTemplate(input: $input) { id title content }
  }
`;
const $11ef833351561454$var$UPDATE_RX = `
  mutation($id: ID!, $input: PrescriptionTemplateInput!) {
    updatePrescriptionTemplate(id: $id, input: $input) { id title content }
  }
`;
const $11ef833351561454$var$DELETE_RX = `
  mutation($id: ID!) { deletePrescriptionTemplate(id: $id) }
`;
function $11ef833351561454$export$b0a9bce6cbec665b() {
    const [noteTemplates, setNoteTemplates] = (0, $acw62.useState)([]);
    const [prescriptionTemplates, setPrescriptionTemplates] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const reload = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($11ef833351561454$var$TEMPLATES_QUERY).then((data)=>{
            setNoteTemplates(data.noteTemplates);
            setPrescriptionTemplates(data.prescriptionTemplates);
        }).finally(()=>setLoading(false));
    }, []);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    const addNote = (input)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$ADD_NOTE, {
            input: input
        }).then(reload);
    const updateNote = (id, input)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$UPDATE_NOTE, {
            id: id,
            input: input
        }).then(reload);
    const deleteNote = (id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$DELETE_NOTE, {
            id: id
        }).then(reload);
    const addRx = (input)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$ADD_RX, {
            input: input
        }).then(reload);
    const updateRx = (id, input)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$UPDATE_RX, {
            id: id,
            input: input
        }).then(reload);
    const deleteRx = (id)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($11ef833351561454$var$DELETE_RX, {
            id: id
        }).then(reload);
    return {
        noteTemplates: noteTemplates,
        prescriptionTemplates: prescriptionTemplates,
        loading: loading,
        addNote: addNote,
        updateNote: updateNote,
        deleteNote: deleteNote,
        addRx: addRx,
        updateRx: updateRx,
        deleteRx: deleteRx
    };
}


const $717f5b0fa57d582c$var$UPDATE_VISIT = `
  mutation UpdateVisit($id: ID!, $input: VisitInput!) {
    updateVisit(id: $id, input: $input) { id status }
  }
`;
// createMedication uses MedicationInput (dosageInstruction: JSON) — fixes the
// double-encoding bug of the old addMedication (dosageInstruction: String).
const $717f5b0fa57d582c$var$CREATE_MEDICATION = `mutation CreateMedication($patientId:ID!,$input:MedicationInput!){createMedication(patientId:$patientId,input:$input){id}}`;
const $717f5b0fa57d582c$var$CHECK_DRUG_INTERACTION = `
  query CheckDrugInteraction($medicationIds: [String!]!, $patientId: ID!, $patientConditions: [String!], $patientAllergies: [String!]) {
    checkDrugInteraction(medicationIds: $medicationIds, patientId: $patientId, patientConditions: $patientConditions, patientAllergies: $patientAllergies) {
      hasInteractions
      warnings { severity description drugPair }
    }
  }
`;
const $717f5b0fa57d582c$var$ASSIST_PRESCRIPTION = `
  mutation AssistPrescription($input: AssistPrescriptionInput!) {
    assistPrescription(input: $input) {
      hasInteractions
      interactionWarnings { severity description drugPair }
      suggestedMedications { name dosage frequency duration notes }
      recommendedTests { testName reason urgency }
      missingTests
      followUpTimeline
    }
  }
`;
// i18n-exempt: the Iranian drug formulary. A medication's name is what the
// medicine is called — it is the same word in an English UI, it is what a
// pharmacy dispenses against, and it is the value written to the
// prescription. Translating it would be a clinical error, not a feature.
// Latin generics, like every other drug name in the app — see lib/drugNames.js.
// This short list is a stand-in for the formulary, and the name a doctor picks
// off it is the name that is stored, shown and sent for the interaction check,
// so it has to be the same kind of name the formulary would have given them.
const $717f5b0fa57d582c$var$DRUG_LIST = [
    'Amoxicillin',
    'Ibuprofen',
    'Losartan',
    'Atorvastatin',
    'Omeprazole',
    'Metformin',
    'Aspirin',
    'Ciprofloxacin',
    'Levothyroxine',
    'Amlodipine',
    'Esomeprazole',
    'Pantoprazole',
    'Sertraline',
    'Fluoxetine',
    'Propranolol',
    'Diclofenac',
    'Naproxen',
    'Prednisolone',
    'Azithromycin',
    'Clarithromycin'
];
const $717f5b0fa57d582c$var$PrescriptionMobile = ({ navigate: navigate, patient: patientProp })=>{
    const keyboardInset = (0, $iK5Lj.default)();
    const { t: t, formatList: formatList } = (0, $LNQP4.default)();
    const p = patientProp || {
        name: t('patient.sampleName'),
        insurance: 'military',
        id: 'v1'
    };
    const patientId = p.patientId || p.id;
    const visitId = p.visitId || 'v1';
    const { patient: patientFull } = (0, $ea02b2b734b36651$export$9b570c45914f833c)(patientId);
    const { prescriptionTemplates: prescriptionTemplates } = (0, $11ef833351561454$export$b0a9bce6cbec665b)();
    // `usePatient` returns clinicalAllergies / clinicalConditions — reading the
    // old names left both empty on a deep link, so the allergy banner vanished and
    // the interaction check ran without the patient's allergies. Router state is
    // only the fallback while the record loads.
    const allergies = patientFull?.clinicalAllergies || p.allergies || [];
    const conditions = patientFull?.clinicalConditions || p.conditions || [];
    // A prescription starts EMPTY. It used to open with a seeded «متفورمین»
    // row, which a submit then wrote into the patient's record.
    const [meds, setMeds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [showAdd, setShowAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [submitState, setSubmitState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('idle');
    const [interactionWarning, setInteractionWarning] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [checkingInteraction, setCheckingInteraction] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [interactionCheckFailed, setInteractionCheckFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [aiSuggest, setAiSuggest] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [aiLoading, setAiLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const filtered = search ? $717f5b0fa57d582c$var$DRUG_LIST.filter((d)=>d.toLowerCase().includes(search.trim().toLowerCase())) : $717f5b0fa57d582c$var$DRUG_LIST.slice(0, 8);
    const normalizedAllergies = allergies.map((a)=>typeof a === 'string' ? a : a.allergen).filter(Boolean);
    // The API takes names, not condition objects.
    const normalizedConditions = conditions.map((c)=>typeof c === 'string' ? c : c.display || c.code).filter(Boolean);
    const checkInteractions = async (medNames)=>{
        if (medNames.length < 2) return;
        setCheckingInteraction(true);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($717f5b0fa57d582c$var$CHECK_DRUG_INTERACTION, {
                medicationIds: medNames,
                patientId: patientId || 'unknown',
                patientConditions: normalizedConditions,
                patientAllergies: normalizedAllergies
            });
            setInteractionCheckFailed(false);
            const result = data.checkDrugInteraction;
            if (result.hasInteractions && result.warnings?.length > 0) setInteractionWarning(result.warnings);
            else setInteractionWarning(null);
        } catch  {
            // Never blocks prescribing — but a check that did not run must not look
            // like a check that found nothing.
            setInteractionCheckFailed(true);
        } finally{
            setCheckingInteraction(false);
        }
    };
    const addMed = (name)=>{
        const newMed = {
            id: Date.now(),
            name: name,
            dose: '',
            freq: t('visit.rx.freq.od'),
            duration: t('credits.range.days30')
        };
        const updated = [
            ...meds,
            newMed
        ];
        setMeds(updated);
        setShowAdd(false);
        setSearch('');
        checkInteractions(updated.map((m)=>m.name));
    };
    const removeMed = (id)=>{
        const updated = meds.filter((x)=>x.id !== id);
        setMeds(updated);
        if (updated.length >= 2) checkInteractions(updated.map((m)=>m.name));
        else setInteractionWarning(null);
    };
    const handleAiSuggest = async ()=>{
        setAiLoading(true);
        setAiSuggest(null);
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($717f5b0fa57d582c$var$ASSIST_PRESCRIPTION, {
                input: {
                    visitId: visitId || 'unknown',
                    patientId: patientId || 'unknown',
                    medications: meds.map((m)=>m.name),
                    conditions: normalizedConditions,
                    age: patientFull?.age || p.age || 0,
                    gender: patientFull?.gender || p.gender || '',
                    patientAllergies: normalizedAllergies
                }
            });
            setAiSuggest(data.assistPrescription);
        } catch  {
            setAiSuggest({
                error: true
            });
        } finally{
            setAiLoading(false);
        }
    };
    const handleSubmit = ()=>{
        if (submitState === 'idle') {
            setSubmitState('confirm');
            return;
        }
        if (submitState === 'confirm') {
            setSubmitState('sending');
            const today = new Date().toISOString().split('T')[0];
            // UPDATE_VISIT no longer accepts `prescription` — that field was removed from
            // VisitInput in the FHIR refactor.  Save each medication via createMedication
            // (which persists it properly), then mark the visit visited.
            const medSaves = patientId ? meds.map((m)=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($717f5b0fa57d582c$var$CREATE_MEDICATION, {
                    patientId: patientId,
                    input: {
                        code: m.name,
                        display: m.name,
                        status: 'active',
                        authoredOn: today,
                        dosageInstruction: {
                            text: [
                                m.dose,
                                m.freq,
                                m.duration ? t('visit.rx.forDuration', {
                                    duration: m.duration
                                }) : ''
                            ].filter(Boolean).join(' ')
                        },
                        appointmentId: visitId || undefined
                    }
                })) : [];
            Promise.all(medSaves).then(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)($717f5b0fa57d582c$var$UPDATE_VISIT, {
                    id: visitId,
                    input: {
                        status: 'visited'
                    }
                })).then(()=>setSubmitState('done')).catch(()=>setSubmitState('idle'));
        }
    };
    const freqs = [
        t('visit.rx.freq.od'),
        t('visit.rx.freq.bd'),
        t('visit.rx.freq.tds'),
        t('visit.rx.freq.prn')
    ];
    const insLabel = p.insurance === 'military' ? t('patient.insurance.military') : t('patient.insurance.social');
    const insColor = p.insurance === 'military' ? {
        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
        text: (0, $jTCZr.C).navyDark,
        border: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.25)
    } : {
        bg: '#F0FDF4',
        text: '#065F46',
        border: '#BBF7D0'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TQrL.default), {
                title: t('nav.items.prescription'),
                subtitle: p.name,
                onBack: ()=>navigate('visit', p)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '12px 16px 0'
                },
                children: [
                    (0, $eLeza.isIranMarket)() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: insColor.bg,
                            border: `1px solid ${insColor.border}`,
                            borderRadius: 12,
                            padding: '10px 14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                fill: insColor.text,
                                width: "20",
                                height: "20",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l6 2.67V11c0 3.71-2.54 7.21-6 8.29-3.46-1.08-6-4.58-6-8.29V7.67L12 5z"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: insColor.text
                                        },
                                        children: insLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: insColor.text,
                                            opacity: 0.8
                                        },
                                        children: t('prescription.sentOnline')
                                    })
                                ]
                            })
                        ]
                    }),
                    allergies.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: (0, $jTCZr.C).redLight,
                            border: '1px solid #FCA5A5',
                            borderRadius: 12,
                            padding: '10px 14px',
                            display: 'flex',
                            gap: 8,
                            alignItems: 'center',
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 16
                                },
                                children: "\u26A0\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $jTCZr.C).red,
                                    fontWeight: 600
                                },
                                children: [
                                    t('prescription.recordedAllergy'),
                                    " ",
                                    formatList(normalizedAllergies),
                                    " ",
                                    t('prescription.doNotPrescribe')
                                ]
                            })
                        ]
                    }),
                    checkingInteraction && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#FFF7ED',
                            border: '1px solid #FED7AA',
                            borderRadius: 12,
                            padding: '10px 14px',
                            fontSize: 12,
                            color: '#92400E',
                            marginBottom: 12,
                            display: 'flex',
                            gap: 8,
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 14,
                                    height: 14,
                                    border: '2px solid #92400E',
                                    borderTopColor: 'transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                    flexShrink: 0
                                }
                            }),
                            t('visit.rx.checkingInteractions')
                        ]
                    }),
                    !checkingInteraction && interactionCheckFailed && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "alert",
                        "data-testid": "rx-interaction-check-failed",
                        style: {
                            background: (0, $jTCZr.C).amberLight,
                            border: `1px solid ${(0, $jTCZr.C).amber}`,
                            borderRadius: 12,
                            padding: '10px 14px',
                            fontSize: 12,
                            color: (0, $jTCZr.C).text,
                            marginBottom: 12,
                            display: 'flex',
                            gap: 8,
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t('prescription.interactionCheckFailed')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>checkInteractions(meds.map((m)=>m.name)),
                                style: {
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).navy,
                                    fontFamily: 'inherit',
                                    fontSize: 12,
                                    flexShrink: 0
                                },
                                children: t('common.actions.retry')
                            })
                        ]
                    }),
                    !checkingInteraction && interactionWarning?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#FFF7ED',
                            border: '1.5px solid #FED7AA',
                            borderRadius: 14,
                            padding: '14px',
                            marginBottom: 12,
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setInteractionWarning(null),
                                style: {
                                    position: 'absolute',
                                    top: 10,
                                    left: 12,
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: 16,
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: "\u2715"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 10,
                                    alignItems: 'flex-start'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 20
                                        },
                                        children: "\uD83D\uDEA8"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    color: '#9A3412',
                                                    marginBottom: 8
                                                },
                                                children: t('prescription.interactionWarning')
                                            }),
                                            interactionWarning.map((w, i)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#C2410C',
                                                        marginBottom: 4,
                                                        paddingInlineStart: 8,
                                                        borderInlineStart: '2px solid #FED7AA'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontWeight: 700,
                                                                background: '#FED7AA',
                                                                padding: '1px 5px',
                                                                borderRadius: 4,
                                                                marginInlineEnd: 6,
                                                                fontSize: 10
                                                            },
                                                            children: w.severity === 'high' ? t('visit.vitals.high') : w.severity === 'medium' ? t('credits.level.midShort') : t('visit.vitals.low')
                                                        }),
                                                        w.description
                                                    ]
                                                }, i);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: [
                                    t('prescription.medicationsPrefix'),
                                    meds.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>{
                                    setShowAdd(!showAdd);
                                    setSearch('');
                                },
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    padding: '7px 12px',
                                    background: (0, $jTCZr.C).navy,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 10,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "white",
                                        width: "14",
                                        height: "14",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                                        })
                                    }),
                                    t('patient.meds.add')
                                ]
                            })
                        ]
                    }),
                    showAdd && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                        style: {
                            padding: '14px',
                            marginBottom: 12,
                            border: `1.5px solid ${(0, $jTCZr.C).navy}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                value: search,
                                onChange: (e)=>setSearch(e.target.value),
                                placeholder: t('prescription.searchDrug'),
                                style: {
                                    width: '100%',
                                    height: 42,
                                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                    borderRadius: 10,
                                    padding: '0 12px',
                                    fontSize: 13,
                                    fontFamily: 'var(--app-font)',
                                    outline: 'none',
                                    background: '#fafbfc',
                                    marginBottom: 8
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6,
                                    maxHeight: 200,
                                    overflowY: 'auto'
                                },
                                children: [
                                    filtered.map((name, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>addMed(name),
                                            style: {
                                                padding: '10px 12px',
                                                borderRadius: 10,
                                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                                background: 'white',
                                                cursor: 'pointer',
                                                textAlign: 'start',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: 16
                                                    },
                                                    children: "\uD83D\uDC8A"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                        color: (0, $jTCZr.C).textPrimary
                                                    },
                                                    children: name
                                                })
                                            ]
                                        }, i)),
                                    search && !$717f5b0fa57d582c$var$DRUG_LIST.includes(search) && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>addMed(search),
                                        style: {
                                            padding: '10px 12px',
                                            borderRadius: 10,
                                            border: `1.5px dashed ${(0, $jTCZr.C).navy}`,
                                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                            cursor: 'pointer',
                                            textAlign: 'start',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: 16
                                                },
                                                children: "\u2795"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: (0, $jTCZr.C).navy
                                                },
                                                children: [
                                                    t('prescription.addPrefix'),
                                                    search,
                                                    "\xbb"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                            marginBottom: 12
                        },
                        children: meds.map((med)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                                style: {
                                    padding: '14px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            marginBottom: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    gap: 10,
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            width: 40,
                                                            height: 40,
                                                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                                                            borderRadius: 12,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: 18
                                                        },
                                                        children: "\uD83D\uDC8A"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                dir: "auto",
                                                                style: {
                                                                    fontSize: 14,
                                                                    fontWeight: 700,
                                                                    color: (0, $jTCZr.C).textPrimary
                                                                },
                                                                children: med.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                value: med.dose,
                                                                onChange: (e)=>setMeds((m)=>m.map((x)=>x.id === med.id ? {
                                                                                ...x,
                                                                                dose: e.target.value
                                                                            } : x)),
                                                                placeholder: t('prescription.dosePlaceholder'),
                                                                style: {
                                                                    fontSize: 11,
                                                                    color: (0, $jTCZr.C).textMuted,
                                                                    border: 'none',
                                                                    background: 'none',
                                                                    outline: 'none',
                                                                    fontFamily: 'var(--app-font)',
                                                                    marginTop: 2,
                                                                    width: '100%'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>removeMed(med.id),
                                                style: {
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    color: (0, $jTCZr.C).textMuted,
                                                    fontSize: 18,
                                                    lineHeight: 1,
                                                    padding: '2px 4px'
                                                },
                                                children: "\u2715"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: (0, $jTCZr.C).textMuted,
                                                            marginBottom: 4
                                                        },
                                                        children: t('prescription.frequency')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        value: med.freq,
                                                        onChange: (e)=>setMeds((m)=>m.map((x)=>x.id === med.id ? {
                                                                        ...x,
                                                                        freq: e.target.value
                                                                    } : x)),
                                                        style: {
                                                            width: '100%',
                                                            height: 36,
                                                            border: `1px solid ${(0, $jTCZr.C).border}`,
                                                            borderRadius: 8,
                                                            fontSize: 12,
                                                            fontFamily: 'var(--app-font)',
                                                            padding: '0 8px',
                                                            outline: 'none',
                                                            background: '#fafbfc',
                                                            color: (0, $jTCZr.C).textPrimary
                                                        },
                                                        children: freqs.map((f)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: f,
                                                                children: f
                                                            }, f))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: (0, $jTCZr.C).textMuted,
                                                            marginBottom: 4
                                                        },
                                                        children: t('prescription.duration')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: med.duration,
                                                        onChange: (e)=>setMeds((m)=>m.map((x)=>x.id === med.id ? {
                                                                        ...x,
                                                                        duration: e.target.value
                                                                    } : x)),
                                                        style: {
                                                            width: '100%',
                                                            height: 36,
                                                            border: `1px solid ${(0, $jTCZr.C).border}`,
                                                            borderRadius: 8,
                                                            fontSize: 12,
                                                            fontFamily: 'var(--app-font)',
                                                            padding: '0 8px',
                                                            outline: 'none',
                                                            background: '#fafbfc',
                                                            color: (0, $jTCZr.C).textPrimary
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, med.id))
                    }),
                    prescriptionTemplates.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                        style: {
                            padding: '14px',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.25)}`,
                            marginBottom: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).navyDark,
                                    marginBottom: 8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: (0, $jTCZr.C).navyDark,
                                        width: "14",
                                        height: "14",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                                        })
                                    }),
                                    t('prescription.templates')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6
                                },
                                children: prescriptionTemplates.map((tpl)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            padding: '8px 10px',
                                            background: 'white',
                                            borderRadius: 10,
                                            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.25)}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).navyDark,
                                                    marginBottom: 4
                                                },
                                                children: [
                                                    "\uD83D\uDC8A ",
                                                    tpl.title
                                                ]
                                            }),
                                            tpl.content && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: (0, $jTCZr.C).textSecondary,
                                                    lineHeight: 1.6,
                                                    whiteSpace: 'pre-line'
                                                },
                                                children: tpl.content
                                            })
                                        ]
                                    }, tpl.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleAiSuggest,
                        disabled: aiLoading,
                        style: {
                            width: '100%',
                            height: 44,
                            marginBottom: 12,
                            background: aiLoading ? (0, $jTCZr.C).border : (0, $jTCZr.GRADIENT_BRAND),
                            color: 'white',
                            border: 'none',
                            borderRadius: 12,
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8
                        },
                        children: aiLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        width: 16,
                                        height: 16,
                                        border: '2px solid white',
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }
                                }),
                                t('prescription.analysing')
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "white",
                                    width: "16",
                                    height: "16",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                                    })
                                }),
                                t('prescription.aiSuggestTitle')
                            ]
                        })
                    }),
                    aiSuggest && !aiSuggest.error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                        style: {
                            padding: '14px',
                            marginBottom: 12,
                            border: `1.5px solid ${(0, $jTCZr.C).teal}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).teal,
                                    marginBottom: 12,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: (0, $jTCZr.C).teal,
                                        width: "16",
                                        height: "16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                                        })
                                    }),
                                    t('prescription.aiSuggestion')
                                ]
                            }),
                            aiSuggest.interactionWarnings?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    background: '#FFF7ED',
                                    borderRadius: 10,
                                    padding: '10px',
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            fontWeight: 700,
                                            color: '#9A3412',
                                            marginBottom: 6
                                        },
                                        children: t('prescription.interactionsFound')
                                    }),
                                    aiSuggest.interactionWarnings.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                fontSize: 11,
                                                color: '#C2410C',
                                                marginBottom: 3
                                            },
                                            children: [
                                                "\u2022 ",
                                                w.description
                                            ]
                                        }, i))
                                ]
                            }),
                            aiSuggest.suggestedMedications?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textSecondary,
                                            marginBottom: 6
                                        },
                                        children: t('prescription.suggestedDrugs')
                                    }),
                                    aiSuggest.suggestedMedications.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                                borderRadius: 8,
                                                padding: '8px 10px',
                                                marginBottom: 6
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                        color: (0, $jTCZr.C).textPrimary
                                                    },
                                                    children: m.name
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $jTCZr.C).textSecondary,
                                                        marginTop: 2
                                                    },
                                                    children: [
                                                        m.dosage,
                                                        m.frequency,
                                                        m.duration
                                                    ].filter(Boolean).join(" \u2014 ")
                                                }),
                                                m.notes && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 10,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginTop: 2
                                                    },
                                                    children: m.notes
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>addMed(m.name),
                                                    style: {
                                                        marginTop: 6,
                                                        padding: '4px 10px',
                                                        borderRadius: 8,
                                                        border: `1px solid ${(0, $jTCZr.C).navy}`,
                                                        background: 'white',
                                                        color: (0, $jTCZr.C).navy,
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        cursor: 'pointer'
                                                    },
                                                    children: t('prescription.addToRx')
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            aiSuggest.recommendedTests?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textSecondary,
                                            marginBottom: 6
                                        },
                                        children: t('prescription.suggestedTests')
                                    }),
                                    aiSuggest.recommendedTests.map((order, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                                                borderRadius: 8,
                                                padding: '8px 10px',
                                                marginBottom: 6
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: 12,
                                                                fontWeight: 600,
                                                                color: (0, $jTCZr.C).textPrimary
                                                            },
                                                            children: order.testName
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: 10,
                                                                background: order.urgency === 'urgent' ? (0, $jTCZr.C).redLight : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                                                                color: order.urgency === 'urgent' ? (0, $jTCZr.C).red : (0, $jTCZr.C).navyDark,
                                                                padding: '2px 6px',
                                                                borderRadius: 6,
                                                                fontWeight: 600
                                                            },
                                                            children: order.urgency === 'urgent' ? t('common.urgency.urgent') : order.urgency === 'soon' ? t('prescription.sooner') : t('prescription.normal')
                                                        })
                                                    ]
                                                }),
                                                order.reason && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginTop: 2
                                                    },
                                                    children: order.reason
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            aiSuggest.followUpTimeline && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginTop: 8,
                                    padding: '8px 10px',
                                    background: '#f8f9fb',
                                    borderRadius: 8,
                                    fontSize: 11,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: [
                                    t('prescription.followUp'),
                                    " ",
                                    aiSuggest.followUpTimeline
                                ]
                            })
                        ]
                    }),
                    aiSuggest?.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            background: (0, $jTCZr.C).redLight,
                            borderRadius: 12,
                            padding: '10px 14px',
                            fontSize: 12,
                            color: (0, $jTCZr.C).red,
                            marginBottom: 12
                        },
                        children: t('prescription.suggestFailed')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: `16px 20px calc(16px + env(safe-area-inset-bottom, 0px) + ${keyboardInset}px)`,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    background: 'white',
                    marginTop: 'auto'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: handleSubmit,
                    disabled: meds.length === 0 || submitState === 'sending',
                    style: {
                        width: '100%',
                        height: 52,
                        background: submitState === 'done' ? (0, $jTCZr.C).green : `linear-gradient(135deg,${(0, $jTCZr.C).navy},${(0, $jTCZr.C).navyLight})`,
                        color: 'white',
                        border: 'none',
                        borderRadius: 14,
                        fontSize: 16,
                        fontWeight: 700,
                        cursor: 'pointer',
                        boxShadow: `0 4px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.3)}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10
                    },
                    children: [
                        submitState === 'idle' && t('prescription.sendOnline'),
                        submitState === 'confirm' && t('prescription.confirmSend'),
                        submitState === 'sending' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        width: 18,
                                        height: 18,
                                        border: '3px solid white',
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }
                                }),
                                t('auth.login.sending')
                            ]
                        }),
                        submitState === 'done' && t('prescription.sent')
                    ]
                })
            })
        ]
    });
};
var $717f5b0fa57d582c$export$2e2bcd8739ae039 = $717f5b0fa57d582c$var$PrescriptionMobile;



var $jTCZr = parcelRequire("jTCZr");
const $1dfa506f0b1b21c4$var$PrescriptionScreen = ()=>{
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { patientId: patientId } = (0, $aphAM.useParams)();
    const { state: state } = (0, $aphAM.useLocation)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const patient = state || {
        id: patientId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            background: isMobile ? 'none' : (0, $jTCZr.C).bg,
            flex: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                width: isMobile ? '100%' : '500px',
                height: isMobile ? '100%' : '90vh',
                marginTop: isMobile ? 0 : '5vh',
                boxShadow: isMobile ? 'none' : '0 10px 25px rgba(0,0,0,0.1)',
                borderRadius: isMobile ? 0 : 24,
                overflow: 'hidden',
                display: 'flex'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $717f5b0fa57d582c$export$2e2bcd8739ae039), {
                navigate: navigate,
                patient: patient
            })
        })
    });
};
var $1dfa506f0b1b21c4$export$2e2bcd8739ae039 = $1dfa506f0b1b21c4$var$PrescriptionScreen;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $awevB = parcelRequire("awevB");
var $4fYdd = parcelRequire("4fYdd");
var $lUcdx = parcelRequire("lUcdx");
var $kyZIh = parcelRequire("kyZIh");
var $66joL = parcelRequire("66joL");
var $6usBW = parcelRequire("6usBW");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The credits ledger while its page is pending. The hero, KPI strip
// (`KpiCard loading`), filters and toolbar all render for real; only the
// history region shimmers — one `TransactionRow` per placeholder, at the
// row's real padding (10px 16px desktop, 9px 12px mobile) with its 34/30px
// service glyph, the title + meta lines and the amount on the far side.
// ─────────────────────────────────────────────────────────────────────────────
const $979361a17e04d643$var$TxRowSkeleton = ({ i: i, mobile: mobile })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? 10 : 12,
            padding: mobile ? '9px 12px' : '10px 16px',
            borderTop: i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: mobile ? 30 : 34,
                height: mobile ? 30 : 34,
                radius: mobile ? 8 : 9
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${40 + i * 17 % 32}%`,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${24 + i * 11 % 20}%`,
                        height: 11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: mobile ? 48 : 64,
                height: 14
            })
        ]
    });
const $979361a17e04d643$export$a4d55197b5b697b2 = ({ rows: rows = 6, mobile: mobile = false, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "credits-history-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                style: {
                    padding: mobile ? '5px 12px' : '6px 16px',
                    background: (0, $jTCZr.C).bg
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: 96,
                    height: 11
                })
            }),
            Array.from({
                length: rows
            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($979361a17e04d643$var$TxRowSkeleton, {
                    i: i,
                    mobile: mobile
                }, i))
        ]
    });
};
var $979361a17e04d643$export$2e2bcd8739ae039 = $979361a17e04d643$export$a4d55197b5b697b2;





var $acw62 = parcelRequire("acw62");

const $0eafa090d94feaa4$var$TRANSACTIONS_QUERY = `
  query GetWalletTransactions(
    $ownerId: String!
    $ownerType: String!
    $limit: Int
    $offset: Int
    $startDate: String
    $endDate: String
    $type: String
  ) {
    walletTransactions(
      ownerId: $ownerId
      ownerType: $ownerType
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
      type: $type
    ) {
      totalCount
      transactions {
        id
        type
        amount
        serviceType
        description
        createdAt
        referenceId
      }
    }
  }
`;
function $0eafa090d94feaa4$export$9df289bef152e95b(doctorId, { limit: limit = 20, offset: offset = 0, startDate: startDate, endDate: endDate, type: type } = {}) {
    const [data, setData] = (0, $acw62.useState)({
        transactions: [],
        totalCount: 0
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetch = (0, $acw62.useCallback)(()=>{
        if (!doctorId) return;
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($0eafa090d94feaa4$var$TRANSACTIONS_QUERY, {
            ownerId: doctorId,
            ownerType: 'doctor',
            limit: limit,
            offset: offset,
            startDate: startDate ?? '',
            endDate: endDate ?? '',
            // Server-side: the ledger runs to thousands of rows, so a filter applied
            // to the fetched page would describe only that page.
            type: type ?? ''
        }).then((res)=>{
            setData(res?.walletTransactions ?? {
                transactions: [],
                totalCount: 0
            });
            setError(null);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        doctorId,
        limit,
        offset,
        startDate,
        endDate,
        type
    ]);
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        ...data,
        loading: loading,
        error: error,
        refetch: fetch
    };
}


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $acw62 = parcelRequire("acw62");



// Starts a top-up: asks the BFF for a payment URL, then redirects the browser to
// the gateway. On return, the wallet callback credits the coins and the balance
// refetches (visibility/nav-based). The UI works in Toman throughout; each
// gateway's wire unit is applied here (Sepehr settles in rials, Zarinpal toman).
const $cc8daf12c2d1c2bf$var$INITIATE_QUERY = `
  mutation InitiateTopUp($gateway: String!, $ownerId: String!, $ownerType: String!, $amount: Int!, $description: String, $returnUrl: String) {
    initiateGatewayPayment(gateway: $gateway, ownerId: $ownerId, ownerType: $ownerType, amount: $amount, description: $description, returnUrl: $returnUrl) {
      gateway
      authority
      paymentUrl
      invoiceId
    }
  }
`;
// An in-app path, and nothing else. A returnUrl is a redirect the gateway
// performs on our behalf, so an absolute URL here would be an open redirect
// with a bank in the middle of it. The query is dropped too: the gateway
// appends `?payment=…` itself, and not all of them accept a return URL that
// already carries one.
const $cc8daf12c2d1c2bf$var$inAppReturnPath = (path)=>typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') ? path.split('?')[0] : '/credits';
function $cc8daf12c2d1c2bf$export$64e212e524010641(doctorId, gateway = (0, $84433f335a456b60$export$bd634cd508c418bb), { returnPath: returnPath = '/credits' } = {}) {
    const { t: t } = (0, $LNQP4.default)();
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const startTopUp = (0, $acw62.useCallback)(async (coins, toman)=>{
        if (!doctorId) return;
        // The gateways here take a toman price. Credit priced in another currency has
        // no rail in this panel (constants/paymentGateway.js hasRailFor): say so
        // rather than hand an Iranian bank a dollar figure. No entry point offers
        // this today — it is the last line, not the first.
        if (!(0, $84433f335a456b60$export$971b02bbb2a0b18b)((0, $121df138798ec781$export$a1d28c3cec9e428f)().currency)) {
            setError(t('credits.gatewayUnavailable'));
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const amountToman = Math.round(toman ?? coins * (0, $121df138798ec781$export$ca9b35f04336e4e5)());
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($cc8daf12c2d1c2bf$var$INITIATE_QUERY, {
                gateway: gateway,
                ownerId: doctorId,
                ownerType: 'doctor',
                amount: (0, $84433f335a456b60$export$5fca33782a4a7d9f)(amountToman, gateway),
                description: t('credits.topUpDescription', {
                    coins: coins
                }),
                // Where the BROWSER returns. The payment BFF settles the payment with
                // the bank and then sends the doctor back here — this app never sees
                // the gateway's callback, and could not settle one if it did.
                returnUrl: `${window.location.origin}${$cc8daf12c2d1c2bf$var$inAppReturnPath(returnPath)}`
            });
            const url = res?.initiateGatewayPayment?.paymentUrl;
            if (url) {
                window.location.href = url;
                return;
            }
            setError(t('credits.gatewayUnavailable'));
        } catch (e) {
            // Every failure used to be reported as "coming soon — call support",
            // which is wrong twice over: it says a working feature does not exist,
            // and it hides what actually went wrong. A gateway that refuses the
            // amount, a wallet that is down and a network blip all read identically,
            // so nobody could tell a misconfiguration from an outage. Surface the
            // server's own message when there is one — but only that: `errorDetail`
            // drops transport noise («Failed to fetch») the doctor cannot act on and
            // keeps what the server wrote for people (DC §2.4).
            const base = t('credits.paymentNotStarted');
            const detail = (0, $91f57610161f2da8$export$b08d804d6ffdb3ed)(e)?.trim();
            setError(detail ? `${base} (${detail})` : base);
        } finally{
            setBusy(false);
        }
    }, [
        doctorId,
        gateway,
        returnPath,
        t
    ]);
    return {
        startTopUp: startTopUp,
        busy: busy,
        error: error
    };
}





var $jTCZr = parcelRequire("jTCZr");





var $1HT9m = parcelRequire("1HT9m");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $lkMIV = parcelRequire("lkMIV");



var $1HT9m = parcelRequire("1HT9m");


// Inner content for the «خرید پارسه» flow — rendered inside a Dialog on desktop and
// a BottomSheet on mobile. Coins are the product; money is shown only as the
// total to pay. Packages are explained in work done ("≈ N visits"), per CORE.md.
//
// The packages and the price of one credit are the deployment's when the BFF
// names them (`creditPrices.packages` / `.creditPrice`, PM-0211), else the list
// below and the toman price, as always. The middle package is the recommended
// one and the one picked on opening (500 of 200/500/1,000). A price in another
// currency is printed in it (`formatCreditMoney`), never in toman, and has no
// custom amount: the field below is a toman field.
const $260a6170605807fd$var$PACKAGES = [
    200,
    500,
    1000
];
// The floor is ONE coin (see `minToman` below). It exists to stop trivially
// small gateway transactions, not to force a package: a doctor who wants a
// single coin's worth should be able to buy it, and every Iranian gateway
// settles amounts this size happily.
// Fallback platform assumption (~45 coins/visit) when the doctor has no history.
const $260a6170605807fd$var$FALLBACK_COST_PER_VISIT = 45;
function $260a6170605807fd$var$fmtTomanPlain(toman, formatNumber) {
    return formatNumber(Number(toman || 0));
}
function $260a6170605807fd$export$2e2bcd8739ae039({ avgPerVisit: avgPerVisit, balance: balance, onPay: onPay, busy: busy = false, error: error = null }) {
    const { t: t, formatNumber: formatNumber, locale: locale } = (0, $LNQP4.default)();
    // What one پارسه costs: in Toman the active policy's figure, else the constant;
    // in another currency the wallet's, in its minor units.
    const { coinPriceToman: COIN_PRICE_TOMAN, creditPrice: creditPrice, packages: deploymentPackages } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const inToman = (0, $2a90b979c3d41f86$export$5452ee5bf8a4b337)(creditPrice);
    const unitPrice = inToman ? COIN_PRICE_TOMAN : creditPrice.amountMinor;
    const packages = deploymentPackages?.length ? deploymentPackages : $260a6170605807fd$var$PACKAGES;
    const recommended = packages[Math.floor(packages.length / 2)];
    const money = (minor)=>(0, $2a90b979c3d41f86$export$af3bb5d0c1d26c33)(minor, creditPrice.currency, {
            formatNumber: formatNumber,
            locale: locale
        });
    const minToman = COIN_PRICE_TOMAN;
    const [selected, setSelected] = (0, $acw62.useState)(recommended); // coins, or 'custom'
    const [customToman, setCustomToman] = (0, $acw62.useState)('');
    // The deployment's packages can land after the sheet opened: a pick that is
    // no longer offered moves to the recommended one.
    (0, $acw62.useEffect)(()=>{
        if (selected !== 'custom' && !packages.includes(selected)) setSelected(recommended);
    }, [
        packages,
        recommended,
        selected
    ]);
    const perVisit = avgPerVisit && avgPerVisit > 0 ? avgPerVisit : $260a6170605807fd$var$FALLBACK_COST_PER_VISIT;
    const customCoins = Math.floor((Number(customToman) || 0) / COIN_PRICE_TOMAN);
    const isCustom = inToman && selected === 'custom';
    const coins = isCustom ? customCoins : selected;
    // Minor units of the credit's currency — toman for Parsina, as the name says.
    const toman = coins * unitPrice;
    const belowMin = inToman ? toman < minToman : coins <= 0;
    const visits = Math.round(coins / perVisit);
    const rowStyle = (active)=>({
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            border: `1.5px solid ${active ? (0, $jTCZr.C).teal : (0, $jTCZr.C).border}`,
            background: active ? (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.08) : (0, $jTCZr.C).card,
            borderRadius: 12,
            padding: '11px 14px',
            cursor: 'pointer',
            textAlign: 'start',
            transition: 'border-color 0.15s, background 0.15s'
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            packages.map((pkg)=>{
                const active = !isCustom && selected === pkg;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: ()=>setSelected(pkg),
                    style: rowStyle(active),
                    "data-testid": `topup-pkg-${pkg}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: (0, $jTCZr.C).teal,
                                display: 'flex'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                size: 16
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                ...(0, $1HT9m.type).amount,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: [
                                                (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(pkg, formatNumber),
                                                " ",
                                                t('common.units.coin')
                                            ]
                                        }),
                                        pkg === recommended && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                ...(0, $1HT9m.type).micro,
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).green,
                                                background: (0, $jTCZr.C).greenLight,
                                                borderRadius: 999,
                                                padding: '1px 8px'
                                            },
                                            children: t('credits.recommended')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        ...(0, $1HT9m.type).caption,
                                        color: (0, $jTCZr.C).textMuted,
                                        marginTop: 2
                                    },
                                    children: [
                                        "\u2248 ",
                                        formatNumber(Math.round(pkg / perVisit)),
                                        " ",
                                        t('credits.visitsWithAi')
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                ...(0, $1HT9m.type).label,
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textSecondary,
                                whiteSpace: 'nowrap'
                            },
                            children: inToman ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    $260a6170605807fd$var$fmtTomanPlain(pkg * COIN_PRICE_TOMAN, formatNumber),
                                    " ",
                                    t('common.units.tomanShort')
                                ]
                            }) : money(pkg * unitPrice)
                        })
                    ]
                }, pkg);
            }),
            inToman && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: ()=>setSelected('custom'),
                style: rowStyle(isCustom),
                "data-testid": "topup-custom",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: isCustom ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textMuted,
                            display: 'flex'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).body,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('credits.customAmount')
                            }),
                            isCustom && coins > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...(0, $1HT9m.type).caption,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginTop: 2
                                },
                                children: [
                                    "= ",
                                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(coins, formatNumber),
                                    " ",
                                    t('common.units.coin')
                                ]
                            })
                        ]
                    }),
                    isCustom && // The «تومان» chip is the field's own now, so the separate span that
                    // used to sit beside it is gone; the row still constrains the width,
                    // which the sheet's layout depends on.
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkMIV.default), {
                            value: customToman,
                            onChange: setCustomToman,
                            autoFocus: true,
                            "aria-label": t('credits.customAmountToman'),
                            unitLabel: t('common.units.toman'),
                            inputStyle: {
                                ...(0, $1HT9m.type).body,
                                width: 148,
                                boxSizing: 'border-box',
                                padding: '7px 10px',
                                paddingInlineStart: 46,
                                textAlign: 'end',
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: 8,
                                background: (0, $jTCZr.C).card,
                                color: (0, $jTCZr.C).textPrimary,
                                outline: 'none',
                                fontFamily: 'inherit'
                            }
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).label,
                    color: (0, $jTCZr.C).red,
                    background: (0, $jTCZr.C).redLight,
                    borderRadius: 8,
                    padding: '8px 12px'
                },
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>!belowMin && !busy && onPay(coins, toman),
                disabled: belowMin || busy,
                "data-testid": "topup-pay",
                style: {
                    ...(0, $1HT9m.type).amount,
                    marginTop: 4,
                    width: '100%',
                    boxSizing: 'border-box',
                    height: 46,
                    borderRadius: 12,
                    border: 'none',
                    background: belowMin || busy ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.4) : (0, $jTCZr.C).navy,
                    color: '#fff',
                    cursor: belowMin || busy ? 'not-allowed' : 'pointer'
                },
                children: busy ? t('credits.redirecting') : toman > 0 ? inToman ? t('credits.payVia', {
                    amount: $260a6170605807fd$var$fmtTomanPlain(toman, formatNumber),
                    gateway: (0, $84433f335a456b60$export$18053a58f12c6137)(t)
                }) : `${t('credits.buyCoins')} \xb7 ${money(toman)}` : t('validation.amount.required')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).micro,
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textMuted,
                    textAlign: 'center'
                },
                children: belowMin && inToman ? t('credits.minPurchase', {
                    amount: $260a6170605807fd$var$fmtTomanPlain(minToman, formatNumber)
                }) : t('credits.redirectNote')
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1HT9m = parcelRequire("1HT9m");

var $acw62 = parcelRequire("acw62");

const $35a55c747292b3ac$var$MY_CODES = `
  query MyGiftCodes {
    myGiftCodes { id code parseh smartVisits status expiresAtMs redeemedAtMs }
  }
`;
const $35a55c747292b3ac$var$REDEEM = `
  mutation RedeemGiftCode($code: String!) {
    redeemGiftCode(code: $code) {
      granted
      giftCode { id code parseh smartVisits status redeemedAtMs }
      balance { balance currency }
    }
  }
`;
function $35a55c747292b3ac$export$67e83c350c566786(doctorId) {
    const [codes, setCodes] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const refresh = (0, $acw62.useCallback)(()=>{
        if (!doctorId) return;
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($35a55c747292b3ac$var$MY_CODES).then((data)=>setCodes(data?.myGiftCodes || [])).catch(()=>{}).finally(()=>setLoading(false));
    }, [
        doctorId
    ]);
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    const redeem = (0, $acw62.useCallback)(async (code)=>{
        const trimmed = (code || '').trim();
        if (!trimmed) return {
            ok: false,
            code: 'EMPTY'
        };
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($35a55c747292b3ac$var$REDEEM, {
                code: trimmed
            });
            const result = data?.redeemGiftCode;
            if (!result) return {
                ok: false,
                code: 'UNKNOWN'
            };
            refresh();
            return {
                ok: true,
                granted: result.granted,
                smartVisits: result.giftCode?.smartVisits ?? 0,
                balance: result.balance?.balance ?? null
            };
        } catch (err) {
            // The BFF's message is written for the doctor — «قبلاً استفاده شده»,
            // «منقضی شده» — and each is a different instruction to them, so it is
            // shown rather than replaced with one generic line.
            const gqlError = err?.graphQLErrors?.[0];
            return {
                ok: false,
                code: gqlError?.extensions?.code || 'UNKNOWN',
                // The BFF's own message is written for people; a transport error is not.
                message: gqlError?.message || ''
            };
        }
    }, [
        refresh
    ]);
    return {
        codes: codes,
        loading: loading,
        redeem: redeem,
        refresh: refresh
    };
}



/**
 * Redeem a campaign gift code, and see the ones already redeemed.
 *
 * The code input is FORCED LTR with `dir="ltr"` even though the panel is RTL:
 * the code is a Latin token with a meaningful left-to-right order, and in an
 * RTL input a leading '-' or a mixed digit run reorders on screen while the
 * value stays correct — so the doctor proofreads a string that is not the one
 * being sent.
 *
 * Persian digits are NOT converted here. The marketing service normalises them
 * (app/domain/gift_codes.py:normalize_code), so a doctor typing on a Persian
 * keyboard is already handled, and a second normaliser in the browser would be
 * a second place for the rule to drift.
 */ // Teal ink darkened from the live token so it keeps text contrast and still
// follows the active preset (the old hand-picked dark teal under the default preset).
const $63da91af56ebc85e$var$TEAL_INK = `color-mix(in srgb, ${(0, $jTCZr.C).teal} 70%, #000)`;
const $63da91af56ebc85e$var$STATUS_TONE = {
    issued: {
        color: $63da91af56ebc85e$var$TEAL_INK,
        bg: (0, $jTCZr.C).tealLight
    },
    redeemed: {
        color: (0, $jTCZr.C).navy,
        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
    },
    revoked: {
        color: (0, $jTCZr.C).textMuted,
        bg: (0, $jTCZr.C).bg
    },
    expired: {
        color: (0, $jTCZr.C).textMuted,
        bg: (0, $jTCZr.C).bg
    }
};
function $63da91af56ebc85e$var$CheckIcon({ size: size = 20 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20 6L9 17l-5-5"
        })
    });
}
function $63da91af56ebc85e$var$GiftIcon({ size: size = 18 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 12v8H4v-8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22 7H2v5h20z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7v13"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7c-1.5 0-4-.6-4-3a2 2 0 0 1 4 0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7c1.5 0 4-.6 4-3a2 2 0 0 0-4 0"
            })
        ]
    });
}
function $63da91af56ebc85e$export$2e2bcd8739ae039({ doctorId: doctorId, onRedeemed: onRedeemed, compact: compact = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { codes: codes, redeem: redeem } = (0, $35a55c747292b3ac$export$67e83c350c566786)(doctorId);
    const [value, setValue] = (0, $acw62.useState)('');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const [done, setDone] = (0, $acw62.useState)(null);
    async function submit(e) {
        e.preventDefault();
        setError('');
        if (busy) return;
        setBusy(true);
        const result = await redeem(value);
        setBusy(false);
        if (result.ok) {
            setDone(result);
            setValue('');
            // The balance in the page header is now stale — the hero and the KPI
            // strip both read it, so every mounted copy refetches rather than this
            // card holding a second copy of the number.
            (0, $29025bf29a861ca6$export$70e96f88d72639c)();
            if (onRedeemed) onRedeemed(result);
            return;
        }
        setError(result.code === 'EMPTY' ? t('credits.gift.empty') : result.message || t('credits.gift.notFound'));
    }
    if (done) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "gift-success",
        style: {
            background: '#fff',
            border: `1.5px solid ${(0, $jTCZr.C).green}`,
            borderRadius: 12,
            padding: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: '50%',
                            background: (0, $jTCZr.C).green,
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($63da91af56ebc85e$var$CheckIcon, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).body,
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('credits.gift.success', {
                                    parseh: formatNumber(done.granted)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).caption,
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 3
                                },
                                children: t('credits.gift.successSub', {
                                    visits: formatNumber(done.smartVisits)
                                })
                            })
                        ]
                    })
                ]
            }),
            done.balance != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            ...(0, $1HT9m.type).caption,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: t('credits.gift.newBalance')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            ...(0, $1HT9m.type).body,
                            fontWeight: 800,
                            color: $63da91af56ebc85e$var$TEAL_INK
                        },
                        dir: "ltr",
                        children: formatNumber(done.balance)
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 12,
            padding: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: 10,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                            color: (0, $jTCZr.C).navy,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($63da91af56ebc85e$var$GiftIcon, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).title,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('credits.gift.title')
                    })
                ]
            }),
            !compact && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).caption,
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.9
                },
                children: t('credits.gift.hint')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: submit,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        dir: "ltr",
                        value: value,
                        onChange: (e)=>{
                            setValue(e.target.value);
                            if (error) setError('');
                        },
                        placeholder: t('credits.gift.placeholder'),
                        "data-testid": "gift-code-input",
                        "aria-label": t('credits.gift.title'),
                        "aria-invalid": !!error,
                        style: {
                            width: '100%',
                            minWidth: 0,
                            height: 46,
                            borderRadius: 10,
                            boxSizing: 'border-box',
                            border: `1px solid ${error ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`,
                            background: (0, $jTCZr.C).bg,
                            padding: '0 12px',
                            fontFamily: 'inherit',
                            fontSize: 15,
                            fontWeight: 700,
                            letterSpacing: 1.5,
                            color: (0, $jTCZr.C).textPrimary,
                            textAlign: 'center',
                            outline: 'none'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "submit",
                        disabled: busy,
                        "data-testid": "gift-code-submit",
                        style: {
                            width: '100%',
                            height: 46,
                            padding: '0 20px',
                            border: 'none',
                            borderRadius: 10,
                            background: (0, $jTCZr.C).navy,
                            color: '#fff',
                            fontFamily: 'inherit',
                            ...(0, $1HT9m.type).body,
                            fontWeight: 700,
                            cursor: busy ? 'default' : 'pointer',
                            opacity: busy ? 0.6 : 1,
                            whiteSpace: 'nowrap'
                        },
                        children: busy ? t('credits.gift.submitting') : t('credits.gift.submit')
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "gift-code-error",
                style: {
                    ...(0, $1HT9m.type).caption,
                    color: (0, $jTCZr.C).red,
                    lineHeight: 1.8
                },
                children: error
            }),
            !error && !compact && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).caption,
                    color: (0, $jTCZr.C).textMuted
                },
                children: t('credits.gift.oneUse')
            }),
            codes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).caption,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: t('credits.gift.myCodes')
                    }),
                    codes.map((g)=>{
                        const tone = $63da91af56ebc85e$var$STATUS_TONE[g.status] || $63da91af56ebc85e$var$STATUS_TONE.revoked;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            dir: "ltr",
                                            style: {
                                                ...(0, $1HT9m.type).caption,
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).navyDark || (0, $jTCZr.C).navy,
                                                letterSpacing: 1
                                            },
                                            children: g.code
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                ...(0, $1HT9m.type).caption,
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: t('credits.gift.worth', {
                                                parseh: formatNumber(g.parseh),
                                                visits: formatNumber(g.smartVisits)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        ...(0, $1HT9m.type).caption,
                                        fontWeight: 700,
                                        color: tone.color,
                                        background: tone.bg,
                                        borderRadius: 999,
                                        padding: '3px 10px',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: t(`credits.gift.status.${g.status}`)
                                })
                            ]
                        }, g.id);
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");

var $eLeza = parcelRequire("eLeza");

// ─────────────────────────────────────────────────────────────────────────────
// The two money screens' server-written vocabulary, in the reading language.
//
// The credit ledger and the accounting line list both display strings that a
// SERVICE wrote, not the client:
//
//   • `metadata.action` on a wallet transaction («رونویسی صوتی», «خلاصه ویزیت»,
//     «بررسی تداخل دارویی») — written by the AI service's `_deduct_credit`.
//   • `description` on an accounting invoice line («ویزیت») — written by the
//     accounting service when it opens a visit invoice from a contract.
//
// Both are CLOSED vocabularies, so like the drug formulary they are translated
// at the DISPLAY EDGE: value → key → `t`. Nothing here changes what is stored
// or sent; the ledger keeps the Persian it was written with, and a value this
// file has not learned about renders AS ITSELF rather than as a blank or a
// humanised key. That fallback is the whole reason this is safe to ship ahead
// of the services: a new action string shows the doctor something true.
//
// The tables are keyed on the exact strings the services write, and are re-keyed
// through `normalizeFormularyValue` at module load, so a ZWNJ or an Arabic
// yeh/kaf in either the table or the stored value cannot break the match.
// ─────────────────────────────────────────────────────────────────────────────

// Wallet transaction `metadata.action`. Every literal below is grepped from
// `action=` in the AI service's app/endpoints/grpc_server.py — that is the only
// writer. Keep them in sync when a new charged RPC lands.
//
// i18n-exempt: MATCHERS against values the AI service stores on the ledger, not
// UI copy. The Persian on the left is what the wallet row holds; the
// translation is the key on the right.
const $71e4a1bb85321be9$var$CREDIT_ACTION_KEYS = {
    "\u0631\u0648\u0646\u0648\u06CC\u0633\u06CC \u0635\u0648\u062A\u06CC": 'transcription',
    "\u062E\u0644\u0627\u0635\u0647 \u0648\u06CC\u0632\u06CC\u062A": 'visitSummary',
    "\u062A\u06A9\u0645\u06CC\u0644 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A SOAP": 'soapNoteCompletion',
    "\u062A\u06A9\u0645\u06CC\u0644 SOAP": 'soapRefine',
    "\u0633\u0648\u0627\u0644 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631": 'askAssistant',
    "\u0627\u0633\u062A\u062E\u0631\u0627\u062C \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC \u062F\u0646\u062F\u0627\u0646": 'dentalFindings',
    "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC": 'interactionCheck',
    "\u0628\u0631\u0631\u0633\u06CC \u0646\u0633\u062E\u0647": 'prescriptionReview',
    "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0622\u0632\u0645\u0627\u06CC\u0634 \u0648 \u062F\u0627\u0631\u0648": 'testAndDrugSuggestions',
    "\u067E\u0631\u062F\u0627\u0632\u0634 OCR": 'ocrProcessing',
    "OCR \u0633\u0646\u062F": 'documentOcr',
    "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC": 'differentialDiagnosis',
    "\u0647\u0634\u062F\u0627\u0631 \u0627\u0648\u0631\u0698\u0627\u0646\u0633": 'emergencyAlert',
    "\u0646\u0627\u0645\u0647 \u0627\u0631\u062C\u0627\u0639": 'referralLetter',
    "\u062F\u0633\u062A\u0648\u0631\u0627\u0644\u0639\u0645\u0644 \u062A\u0631\u062E\u06CC\u0635": 'dischargeInstructions',
    "\u067E\u06CC\u06AF\u06CC\u0631\u06CC \u0628\u0639\u062F \u0627\u0632 \u0648\u06CC\u0632\u06CC\u062A": 'postVisitFollowUp',
    "\u062F\u0633\u062A\u0648\u0631\u0627\u062A \u067E\u0632\u0634\u06A9": 'doctorOrders',
    "\u0628\u0631\u0646\u0627\u0645\u0647 \u062F\u0631\u0645\u0627\u0646\u06CC \u0647\u0648\u0634\u0645\u0646\u062F": 'treatmentPlan',
    "\u0633\u0648\u0627\u0644\u0627\u062A \u062A\u0623\u06CC\u06CC\u062F \u062A\u0634\u062E\u06CC\u0635": 'confirmationQuestions'
};
const $71e4a1bb85321be9$export$4ce3e951d9d3c5c6 = (0, $f78c92fb84c2d04c$export$c8fcf34a4f7c8505)($71e4a1bb85321be9$var$CREDIT_ACTION_KEYS, 'credits.action');
// Accounting invoice-line `description`. Only the visit line is a fixed string;
// every other line's description is the clinic's own `order_catalog` service
// name, which is that clinic's data and renders as itself.
//
// i18n-exempt: matchers against stored accounting values, as above.
const $71e4a1bb85321be9$var$LINE_DESCRIPTION_KEYS = {
    "\u0648\u06CC\u0632\u06CC\u062A": 'visit'
};
const $71e4a1bb85321be9$var$lineDescriptionLookup = (0, $f78c92fb84c2d04c$export$c8fcf34a4f7c8505)($71e4a1bb85321be9$var$LINE_DESCRIPTION_KEYS, 'accounting.lineDescription');
function $71e4a1bb85321be9$export$5764802ad0ccd8a0(description, t) {
    const raw = String(description || '').trim();
    if (!raw) return '';
    const direct = $71e4a1bb85321be9$var$lineDescriptionLookup(raw, t);
    if (direct !== raw) return direct;
    const parts = raw.match(/^(.+?)\s*—\s*(.+)$/);
    if (parts) {
        const head = $71e4a1bb85321be9$var$lineDescriptionLookup(parts[1], t);
        if (head !== parts[1].trim()) return `${head} \u{2014} ${parts[2]}`;
    }
    return raw;
}



var $8f057e9fdc28e61a$exports = {};
$8f057e9fdc28e61a$exports = JSON.parse('{"credits":{"ledger":{"signupGift":"\u0647\u062F\u06CC\u0647 \u062B\u0628\u062A\u200C\u0646\u0627\u0645","topUp":"\u0634\u0627\u0631\u0698 {{amount}} {{coin}}","storePurchase":"\u062E\u0631\u06CC\u062F {{amount}} {{coin}} \u0627\u0632 {{store}}","giftCode":"\u06A9\u062F \u0647\u062F\u06CC\u0647 {{code}}","prize":"\u062C\u0627\u06CC\u0632\u0647\u0654 \u06AF\u0631\u062F\u0648\u0646\u0647","gift":"\u0627\u0639\u062A\u0628\u0627\u0631 \u0647\u062F\u06CC\u0647","stores":{"bazaar":"\u06A9\u0627\u0641\u0647\u200C\u0628\u0627\u0632\u0627\u0631"}}}}');


var $b314ebf2b2a42402$exports = {};
$b314ebf2b2a42402$exports = JSON.parse("{\"credits\":{\"ledger\":{\"signupGift\":\"Sign-up gift\",\"topUp\":\"Top-up of {{amount}} {{coin}}\",\"storePurchase\":\"Purchase of {{amount}} {{coin}} from {{store}}\",\"giftCode\":\"Gift code {{code}}\",\"prize\":\"Prize wheel reward\",\"gift\":\"Gift credit\",\"stores\":{\"bazaar\":\"Cafe Bazaar\"}}}}");


var $19c498be45eb262d$exports = {};
$19c498be45eb262d$exports = JSON.parse('{"credits":{"ledger":{"signupGift":"\u0647\u062F\u064A\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644","topUp":"\u0634\u062D\u0646 {{amount}} {{coin}}","storePurchase":"\u0634\u0631\u0627\u0621 {{amount}} {{coin}} \u0645\u0646 {{store}}","giftCode":"\u0631\u0645\u0632 \u0627\u0644\u0647\u062F\u064A\u0629 {{code}}","prize":"\u062C\u0627\u0626\u0632\u0629 \u0639\u062C\u0644\u0629 \u0627\u0644\u062D\u0638","gift":"\u0631\u0635\u064A\u062F \u0647\u062F\u064A\u0629","stores":{"bazaar":"\u0643\u0627\u0641\u0647 \u0628\u0627\u0632\u0627\u0631"}}}}');


const $970332c6142fb78a$var$flatten = (obj, prefix = '', out = {})=>{
    for (const [k, v] of Object.entries(obj)){
        const key = prefix ? `${prefix}.${k}` : k;
        if (v && typeof v === 'object' && !Array.isArray(v)) $970332c6142fb78a$var$flatten(v, key, out);
        else out[key] = v;
    }
    return out;
};
const $970332c6142fb78a$var$STRINGS = {
    fa: $970332c6142fb78a$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($8f057e9fdc28e61a$exports)))),
    en: $970332c6142fb78a$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($b314ebf2b2a42402$exports)))),
    ar: $970332c6142fb78a$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($19c498be45eb262d$exports))))
};
const $970332c6142fb78a$export$ae40089bc4265dde = (key)=>Object.prototype.hasOwnProperty.call($970332c6142fb78a$var$STRINGS.fa, key);
function $970332c6142fb78a$export$c1322df453bd895b(locale, key, vars) {
    const { value: value, from: from } = (0, $0de037e7a1b59dc4$export$b1f08bca8a845a15)($970332c6142fb78a$var$STRINGS, locale, key);
    return value == null ? key : (0, $0de037e7a1b59dc4$export$9a328bbde6508c84)(value, vars, from);
}
const $970332c6142fb78a$export$30545b077dcc0f35 = Object.keys($970332c6142fb78a$var$STRINGS);
const $970332c6142fb78a$export$b1a80e9613d5aa1e = Object.keys($970332c6142fb78a$var$STRINGS.fa);
const $970332c6142fb78a$export$eb90517e225e92d9 = (locale)=>$970332c6142fb78a$var$STRINGS[locale];


// ── Service identity ──────────────────────────────────────────────────────────
// Brand semantics come from tokens; purple/blue are per-service identity accents
// with no brand token, kept as this screen's local service palette.
const $884b9b27c085fa62$var$PURPLE = '#7C3AED', $884b9b27c085fa62$var$PURPLE_BG = '#F5F3FF', $884b9b27c085fa62$var$BLUE = '#3B82F6', $884b9b27c085fa62$var$BLUE_BG = '#EFF6FF';
const $884b9b27c085fa62$export$dd3a6ec182d7f57a = (t)=>({
        AI_TRANSCRIPTION: {
            label: t('credits.service.transcription'),
            color: (0, $jTCZr.C).teal,
            bg: (0, $jTCZr.C).tealLight,
            icon: $884b9b27c085fa62$export$592efa5f07538585
        },
        AI_LLM_SUMMARY: {
            label: t('credits.service.summary'),
            color: $884b9b27c085fa62$var$PURPLE,
            bg: $884b9b27c085fa62$var$PURPLE_BG,
            icon: $884b9b27c085fa62$export$b19a1b350a269434
        },
        AI_INTERACTION_CHECK: {
            label: t('credits.price.interaction'),
            color: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight,
            icon: $884b9b27c085fa62$export$2d8598c0b89a07db
        },
        TOP_UP: {
            label: t('nav.credits.topUp'),
            color: (0, $jTCZr.C).green,
            bg: (0, $jTCZr.C).greenLight,
            icon: $884b9b27c085fa62$export$f21ab0717a89c77f
        },
        SMS: {
            label: t('auth.sms'),
            color: $884b9b27c085fa62$var$BLUE,
            bg: $884b9b27c085fa62$var$BLUE_BG,
            icon: $884b9b27c085fa62$export$52cd484a7ef4f2b9
        }
    });
const $884b9b27c085fa62$export$64f6ffea5049f9d4 = (t)=>({
        label: t('credits.service.ai'),
        color: $884b9b27c085fa62$var$PURPLE,
        bg: $884b9b27c085fa62$var$PURPLE_BG,
        icon: $884b9b27c085fa62$export$b19a1b350a269434
    });
// Old rows stored the proto enum integer ("2","3","4").
const $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP = {
    '2': 'AI_TRANSCRIPTION',
    '3': 'AI_LLM_SUMMARY',
    '4': 'AI_INTERACTION_CHECK'
};
function $884b9b27c085fa62$export$856ef076f8da864a(rawType) {
    const resolved = $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP[rawType] || rawType;
    return (resolved || '').replace(/^SERVICE_TYPE_/, '');
}
function $884b9b27c085fa62$export$e0b738a571245f61(rawType, t) {
    return $884b9b27c085fa62$export$dd3a6ec182d7f57a(t)[$884b9b27c085fa62$export$856ef076f8da864a(rawType)] || $884b9b27c085fa62$export$64f6ffea5049f9d4(t);
}
function $884b9b27c085fa62$export$170e57b1ee989654(raw) {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch  {
        return raw;
    }
}
function $884b9b27c085fa62$export$b89a369743013e7(raw, t) {
    const parsed = $884b9b27c085fa62$export$170e57b1ee989654(raw);
    if (!parsed || typeof parsed === 'string') return {
        title: parsed || '',
        sub: '',
        visitId: null
    };
    // Token counts and the model name are recorded on the transaction (the AI
    // service sends input_tokens / output_tokens / model with every deduction, and
    // they stay in the ledger for cost analysis) but they are deliberately NOT
    // shown here. They are our unit economics, not the doctor's: a doctor reading
    // «۳۲٬۰۰۰ توکن · gemini-2.5-pro» learns nothing they can act on, and it
    // invites questions about which model ran rather than what the visit cost.
    // The doctor sees what they spent, on what, and when.
    const sub = [];
    if (parsed.duration_seconds) sub.push(t('credits.minutesUsed', {
        count: Math.ceil(parsed.duration_seconds / 60)
    }));
    // `parsed.action` is written by the AI service and is PERSIAN in every
    // language — «رونویسی صوتی», «خلاصه ویزیت», «بررسی تداخل دارویی». It is a
    // closed vocabulary, so it is translated here at the display edge; the stored
    // value is untouched, and an action this app has not learned about renders as
    // itself rather than as a blank row.
    return {
        title: (0, $71e4a1bb85321be9$export$4ce3e951d9d3c5c6)(parsed.action, t),
        sub: sub.join(" \xb7 "),
        visitId: parsed.visit_id || parsed.patient_id || null
    };
}
// ── Lines named by their reason code ──────────────────────────────────────────
// A credit the platform or a payment puts on the ledger carries a reason code
// (`serviceType`) beside a sentence its writer composed at the time — Persian,
// and naming Parsina's credit: «هدیه ثبت‌نام», «خرید 500 پارسه از bazaar»,
// «کد هدیه …», «جایزهٔ گردونه …», «sepehr top-up: شارژ ۲۰۰ پارسه». Stored text
// is history and is never rewritten (docs/rebranding/CONTRACT.md §1), so a
// deployment of another brand names these lines from the reason code instead:
// in the reader's language, with its own credit's name. With no brand
// configured the stored sentence is shown exactly as it always was, in every
// language — Parsina does not change.
//
//   SIGNUP_GRANT    the opening grant
//   TOP_UP          a gateway payment, of the row's amount
//   STORE_<STORE>   an in-app purchase, of the row's amount, from that store
//   GIFT_CODE       a prize (reference `prize:<draw>`), an operator's grant
//                   (`manual-grant-…`, or none), else a gift code — whose
//                   reference IS the code
//
// Every other line — the AI service's JSON, a code this does not know — is read
// from what is stored, as before.
function $884b9b27c085fa62$var$reasonLine(txn) {
    if (txn?.type !== 'credit') return null;
    const code = String(txn.serviceType || '');
    const ref = String(txn.referenceId || '');
    if (code === 'SIGNUP_GRANT') return {
        key: 'credits.ledger.signupGift'
    };
    if (code === 'TOP_UP') return {
        key: 'credits.ledger.topUp',
        amount: true
    };
    if (/^STORE_[A-Z0-9_]+$/.test(code)) return {
        key: 'credits.ledger.storePurchase',
        amount: true,
        store: code.slice(6).toLowerCase()
    };
    if (code === 'GIFT_CODE') {
        if (ref.startsWith('prize:')) return {
            key: 'credits.ledger.prize'
        };
        if (!ref || ref.startsWith('manual-grant-')) return {
            key: 'credits.ledger.gift'
        };
        return {
            key: 'credits.ledger.giftCode',
            code: ref
        };
    }
    return null;
}
// `brand()` hands back BRAND_DEFAULTS itself for as long as nothing is
// configured (ui/lib/brand.js): that identity is "Parsina, nothing set".
const $884b9b27c085fa62$var$brandConfigured = ()=>(0, $eLeza.brand)() !== (0, $eLeza.BRAND_DEFAULTS);
function $884b9b27c085fa62$export$987fd27eb55fb951(txn, { t: t, has: has, locale: locale, formatNumber: formatNumber }) {
    const reason = $884b9b27c085fa62$var$brandConfigured() ? $884b9b27c085fa62$var$reasonLine(txn) : null;
    if (!reason) return $884b9b27c085fa62$export$b89a369743013e7(txn?.description, t);
    // The kit's catalogue first (and with it the brand's own overlay), this
    // app's ledger table otherwise (./ledgerStrings.js).
    const say = (key, vars)=>has(key) || !(0, $970332c6142fb78a$export$ae40089bc4265dde)(key) ? t(key, vars) : (0, $970332c6142fb78a$export$c1322df453bd895b)(locale, key, vars);
    const vars = {};
    if (reason.amount) vars.amount = (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(txn.amount, formatNumber);
    if (reason.store) {
        const storeKey = `credits.ledger.stores.${reason.store}`;
        vars.store = has(storeKey) || (0, $970332c6142fb78a$export$ae40089bc4265dde)(storeKey) ? say(storeKey) : reason.store;
    }
    if (reason.code) vars.code = reason.code;
    return {
        title: say(reason.key, vars),
        sub: '',
        visitId: null
    };
}
function $884b9b27c085fa62$export$5449ff08984f7155(isoStr, formatTime) {
    if (!isoStr) return '';
    try {
        return formatTime(isoStr);
    } catch  {
        return '';
    }
}
function $884b9b27c085fa62$var$dayKey(isoStr) {
    const d = new Date(isoStr);
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}
function $884b9b27c085fa62$var$dayLabel(isoStr, t, formatDate) {
    const d = new Date(isoStr);
    const now = new Date();
    const startOf = (x)=>new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
    const diffDays = Math.round((startOf(now) - startOf(d)) / 86400000);
    if (diffDays === 0) return t('common.time.today');
    if (diffDays === 1) return t('common.time.yesterday');
    try {
        return formatDate(d, 'full');
    } catch  {
        return isoStr;
    }
}
function $884b9b27c085fa62$export$3be14461f103972e(transactions, t, formatDate) {
    const groups = [];
    const index = {};
    transactions.forEach((item)=>{
        const k = $884b9b27c085fa62$var$dayKey(item.createdAt);
        if (index[k] == null) {
            index[k] = groups.length;
            groups.push({
                key: k,
                label: $884b9b27c085fa62$var$dayLabel(item.createdAt, t, formatDate),
                items: []
            });
        }
        groups[index[k]].items.push(item);
    });
    return groups;
}
function $884b9b27c085fa62$export$c4f843207ab6bf8c(transactions, t) {
    const map = {};
    transactions.forEach((item)=>{
        const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
        if (!map[key]) map[key] = {
            key: key,
            meta: $884b9b27c085fa62$export$e0b738a571245f61(key, t),
            total: 0,
            items: []
        };
        map[key].total += item.type === 'debit' ? item.amount : -item.amount; // net (debits +, credits −)
        map[key].items.push(item);
    });
    return Object.values(map).sort((a, b)=>Math.abs(b.total) - Math.abs(a.total));
}
const $884b9b27c085fa62$export$925c8ee11af609ba = (t)=>[
        {
            id: 'all',
            label: t('common.state.all')
        },
        {
            id: 'today',
            label: t('common.time.today')
        },
        {
            id: '7d',
            label: t('patient.analysis.days7')
        },
        {
            id: '30d',
            label: t('credits.range.days30')
        },
        {
            id: 'month',
            label: t('common.time.thisMonth')
        }
    ];
const $884b9b27c085fa62$var$pad = (n)=>String(n).padStart(2, '0');
const $884b9b27c085fa62$var$startISO = (d)=>`${d.getFullYear()}-${$884b9b27c085fa62$var$pad(d.getMonth() + 1)}-${$884b9b27c085fa62$var$pad(d.getDate())}T00:00:00`;
const $884b9b27c085fa62$var$endISO = (d)=>`${d.getFullYear()}-${$884b9b27c085fa62$var$pad(d.getMonth() + 1)}-${$884b9b27c085fa62$var$pad(d.getDate())}T23:59:59`;
function $884b9b27c085fa62$export$439018c7c0970868(preset, custom = {}) {
    const now = new Date();
    if (preset === 'custom') {
        if (!custom.from || !custom.to) return {
            startDate: '',
            endDate: ''
        };
        return {
            startDate: `${custom.from}T00:00:00`,
            endDate: `${custom.to}T23:59:59`
        };
    }
    switch(preset){
        case 'today':
            return {
                startDate: $884b9b27c085fa62$var$startISO(now),
                endDate: $884b9b27c085fa62$var$endISO(now)
            };
        case '7d':
            {
                const from = new Date(now);
                from.setDate(now.getDate() - 6);
                return {
                    startDate: $884b9b27c085fa62$var$startISO(from),
                    endDate: $884b9b27c085fa62$var$endISO(now)
                };
            }
        case '30d':
            {
                const from = new Date(now);
                from.setDate(now.getDate() - 29);
                return {
                    startDate: $884b9b27c085fa62$var$startISO(from),
                    endDate: $884b9b27c085fa62$var$endISO(now)
                };
            }
        case 'month':
            return {
                startDate: $884b9b27c085fa62$var$startISO(new Date(now.getFullYear(), now.getMonth(), 1)),
                endDate: $884b9b27c085fa62$var$endISO(now)
            };
        default:
            return {
                startDate: '',
                endDate: ''
            };
    }
}
function $884b9b27c085fa62$export$52e8b78f2372daa5(transactions) {
    const now = new Date();
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    let usedThisMonth = 0, totalCredited = 0, monthDebitTotal = 0;
    const byService = {};
    const visitSpend = {};
    transactions.forEach((item)=>{
        const at = new Date(item.createdAt).getTime();
        if (item.type === 'debit') {
            const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
            if (at >= monthStart) {
                usedThisMonth += item.amount;
                monthDebitTotal += item.amount;
                byService[key] = (byService[key] || 0) + item.amount;
            }
            const parsedDesc = $884b9b27c085fa62$export$170e57b1ee989654(item.description);
            const visitId = parsedDesc && typeof parsedDesc === 'object' ? parsedDesc.visit_id || parsedDesc.patient_id || null : null;
            if (visitId) visitSpend[visitId] = (visitSpend[visitId] || 0) + item.amount;
        } else totalCredited += item.amount;
    });
    const visitIds = Object.keys(visitSpend);
    const avgPerVisit = visitIds.length ? visitIds.reduce((s, k)=>s + visitSpend[k], 0) / visitIds.length : null;
    let topService = null, topAmount = 0;
    Object.entries(byService).forEach(([k, v])=>{
        if (v > topAmount) {
            topAmount = v;
            topService = k;
        }
    });
    const topPct = monthDebitTotal ? Math.round(topAmount / monthDebitTotal * 100) : 0;
    return {
        usedThisMonth: usedThisMonth,
        totalCredited: totalCredited,
        avgPerVisit: avgPerVisit,
        topService: topService,
        topPct: topPct,
        byService: byService,
        monthDebitTotal: monthDebitTotal
    };
}
function $884b9b27c085fa62$export$d8999ed724c19ec6(transactions, t) {
    const map = {};
    transactions.forEach((item)=>{
        if (item.type !== 'debit') return;
        const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
        if (!map[key]) map[key] = {
            amount: 0,
            count: 0,
            meta: $884b9b27c085fa62$export$e0b738a571245f61(key, t)
        };
        map[key].amount += item.amount;
        map[key].count += 1;
    });
    return Object.entries(map).map(([key, v])=>({
            key: key,
            ...v
        })).sort((a, b)=>b.amount - a.amount);
}
function $884b9b27c085fa62$export$592efa5f07538585({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
        })
    });
}
function $884b9b27c085fa62$export$b19a1b350a269434({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"
        })
    });
}
function $884b9b27c085fa62$export$2d8598c0b89a07db({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 13l-3-3 1.41-1.41L11 11.17l4.59-4.58L17 8l-6 6z"
        })
    });
}
function $884b9b27c085fa62$export$f21ab0717a89c77f({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
        })
    });
}
function $884b9b27c085fa62$export$52cd484a7ef4f2b9({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
        })
    });
}


const $48ab62c8c643bc72$var$PAGE_SIZE = 30;
const $48ab62c8c643bc72$var$CARD = {
    background: (0, $jTCZr.C).card,
    borderRadius: 16,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)'
};
// ── Balance hero ──────────────────────────────────────────────────────────────
// `onTopUp` absent = no way to buy here: no button, and no money figure, which
// is what the credit would cost to buy. The figure is in the credit's own
// currency (toman for Parsina, as always; `coinsToMoneyLabel`).
function $48ab62c8c643bc72$var$BalanceHero({ balance: balance, onTopUp: onTopUp }) {
    const { t: t, formatNumber: formatNumber, locale: locale } = (0, $LNQP4.default)();
    const { creditPrice: creditPrice } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const level = (0, $jTCZr.creditLevel)(balance);
    const color = (0, $jTCZr.creditColor)(balance);
    // A pending balance is a placeholder block, never loading text: the chip
    // keeps its size and the level label lands in place.
    const statusLabel = balance === null ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
        width: 56,
        height: 11,
        tone: "onDark"
    }) : t((0, $jTCZr.CREDIT_LEVEL_META)[level].labelKey);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            borderRadius: 20,
            padding: '22px 24px',
            color: '#fff',
            position: 'relative',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: -40,
                    left: -40,
                    width: 150,
                    height: 150,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: -60,
                    right: -30,
                    width: 190,
                    height: 190,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.04)'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).label,
                            color: 'rgba(255,255,255,0.6)'
                        },
                        children: t('credits.currentBalance')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'flex-end',
                            gap: 8,
                            marginTop: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).hero
                                },
                                children: balance === null ? "\u2014" : (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).unit,
                                    color: 'rgba(255,255,255,0.7)',
                                    marginBottom: 6
                                },
                                children: t('common.units.coin')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    background: 'rgba(255,255,255,0.12)',
                                    borderRadius: 20,
                                    padding: '3px 10px',
                                    marginBottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: color
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).caption,
                                            color: 'rgba(255,255,255,0.85)'
                                        },
                                        children: statusLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    balance !== null && onTopUp && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).caption,
                            color: 'rgba(255,255,255,0.55)',
                            marginTop: 8
                        },
                        children: (0, $2a90b979c3d41f86$export$e610461cba74a0c9)(balance, {
                            creditPrice: creditPrice,
                            formatNumber: formatNumber,
                            tomanLabel: t('common.units.toman'),
                            locale: locale
                        })
                    }),
                    onTopUp && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: onTopUp,
                        "data-testid": "credits-topup",
                        style: {
                            ...(0, $1HT9m.type).body,
                            marginTop: 16,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            background: 'rgba(255,255,255,0.16)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            color: '#fff',
                            borderRadius: 10,
                            padding: '8px 16px',
                            cursor: 'pointer'
                        },
                        onMouseEnter: (e)=>e.currentTarget.style.background = 'rgba(255,255,255,0.26)',
                        onMouseLeave: (e)=>e.currentTarget.style.background = 'rgba(255,255,255,0.16)',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                size: 14
                            }),
                            " ",
                            t('credits.buyCoins')
                        ]
                    })
                ]
            })
        ]
    });
}
// ── Price list rail card ──────────────────────────────────────────────────────
function $48ab62c8c643bc72$var$PriceListCard() {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    // The policy's figures once the list has arrived; the shipped constants until
    // then — a price row never spins and never goes blank.
    const { priceList: priceList } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const rows = open ? priceList : priceList.slice(0, 5);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            ...$48ab62c8c643bc72$var$CARD,
            padding: '14px 16px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).title,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: 10
                },
                children: t('credits.priceListTitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: rows.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '6px 0',
                            borderBottom: i < rows.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).label,
                                    flex: 1,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t(r.labelKey)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    ...(0, $1HT9m.type).label,
                                    fontWeight: 800,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    color: (0, $jTCZr.C).teal,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                        size: 11
                                    }),
                                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(r.cost, formatNumber),
                                    r.perKey ? ` / ${t(r.perKey)}` : ''
                                ]
                            })
                        ]
                    }, r.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setOpen((o)=>!o),
                style: {
                    ...(0, $1HT9m.type).caption,
                    fontWeight: 700,
                    marginTop: 8,
                    background: 'none',
                    border: 'none',
                    color: (0, $jTCZr.C).teal,
                    cursor: 'pointer',
                    padding: 0
                },
                children: open ? t('common.actions.close') : t('common.actions.viewAll')
            })
        ]
    });
}
// ── Service breakdown rail card ───────────────────────────────────────────────
function $48ab62c8c643bc72$var$ServiceBreakdownCard({ transactions: transactions }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rows = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$d8999ed724c19ec6)(transactions, t), [
        transactions,
        t
    ]);
    if (!rows.length) return null;
    const max = rows[0].amount || 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            ...$48ab62c8c643bc72$var$CARD,
            padding: '14px 16px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...(0, $1HT9m.type).title,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: 12
                },
                children: t('credits.byService')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: rows.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginBottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            fontWeight: 700,
                                            flex: 1,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: item.meta.label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).caption,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: [
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(item.count, formatNumber),
                                            " ",
                                            t('credits.times')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            fontWeight: 800,
                                            color: item.meta.color
                                        },
                                        children: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(item.amount, formatNumber)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    height: 5,
                                    background: (0, $jTCZr.C).bg,
                                    borderRadius: 4,
                                    overflow: 'hidden'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        height: '100%',
                                        width: `${item.amount / max * 100}%`,
                                        background: item.meta.color,
                                        borderRadius: 4,
                                        transition: 'width 0.6s cubic-bezier(.4,0,.2,1)'
                                    }
                                })
                            })
                        ]
                    }, item.key))
            })
        ]
    });
}
// ── Transaction row ───────────────────────────────────────────────────────────
function $48ab62c8c643bc72$var$TransactionRow({ txn: txn }) {
    const { t: t, has: has, locale: locale, formatNumber: formatNumber, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const meta = (0, $884b9b27c085fa62$export$e0b738a571245f61)(txn.serviceType, t);
    const IconC = meta.icon;
    const isDebit = txn.type === 'debit';
    const { title: title, sub: sub } = (0, $884b9b27c085fa62$export$987fd27eb55fb951)(txn, {
        t: t,
        has: has,
        locale: locale,
        formatNumber: formatNumber
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '10px 16px',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        },
        onMouseEnter: (e)=>e.currentTarget.style.background = (0, $jTCZr.C).bg,
        onMouseLeave: (e)=>e.currentTarget.style.background = 'transparent',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    background: meta.bg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconC, {
                    size: 16,
                    color: meta.color
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).body,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: title || meta.label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...(0, $1HT9m.type).micro,
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            (0, $884b9b27c085fa62$export$5449ff08984f7155)(txn.createdAt, formatTime),
                            sub ? ` \xb7 ${sub}` : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...(0, $1HT9m.type).amount,
                    color: isDebit ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).green,
                    flexShrink: 0
                },
                children: [
                    isDebit ? "\u2212" : '+',
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(txn.amount, formatNumber)
                ]
            })
        ]
    });
}
const $48ab62c8c643bc72$var$FILTERS = (t)=>[
        {
            id: 'all',
            label: t('common.state.all')
        },
        {
            id: 'debit',
            label: t('credits.spend')
        },
        {
            id: 'credit',
            label: t('credits.topUp')
        }
    ];
const $48ab62c8c643bc72$var$GROUP_OPTIONS = (t)=>[
        {
            id: 'day',
            label: t('common.units.day')
        },
        {
            id: 'type',
            label: t('credits.serviceType')
        }
    ];
// One transaction group's total, signed for display (net: debits spend, credits add).
function $48ab62c8c643bc72$var$TypeGroupHeader({ group: group }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const IconC = group.meta.icon;
    const spent = group.total >= 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 16px',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    background: group.meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconC, {
                    size: 13,
                    color: group.meta.color
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    ...(0, $1HT9m.type).label,
                    fontWeight: 800,
                    flex: 1,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: group.meta.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    ...(0, $1HT9m.type).caption,
                    color: (0, $jTCZr.C).textMuted
                },
                children: [
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(group.items.length, formatNumber),
                    " ",
                    t('dashboard.queue.finishedCount')
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    ...(0, $1HT9m.type).amount,
                    color: spent ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).green,
                    minWidth: 52,
                    textAlign: 'end'
                },
                children: [
                    spent ? "\u2212" : '+',
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(Math.abs(group.total), formatNumber)
                ]
            })
        ]
    });
}
const $48ab62c8c643bc72$var$pagerBtn = (disabled)=>({
        ...(0, $1HT9m.type).label,
        height: 34,
        padding: '0 18px',
        borderRadius: 9,
        background: disabled ? (0, $jTCZr.C).bg : (0, $jTCZr.C).card,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        color: disabled ? (0, $jTCZr.C).textFaint || (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1
    });
function $48ab62c8c643bc72$export$2e2bcd8739ae039({ isMobile: isMobile = false }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $LNQP4.default)();
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const balance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const { startTopUp: startTopUp, busy: payBusy, error: payError } = (0, $cc8daf12c2d1c2bf$export$64e212e524010641)(doctor?.id);
    // Buying credit is offered only where the deployment sells it and this panel
    // has a rail for its price (hooks/useCreditPurchase.js — `purchaseAvailable`
    // from the BFF, Iranian gateways in toman; docs/platform-money/CONTRACT.md).
    // Where it is not, this screen offers none of it: no buy button, no price
    // list, no top-up sheet. The balance and the ledger stay.
    const { canBuy: canBuy } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    const [page, setPage] = (0, $acw62.useState)(0);
    const [typeFilter, setTypeFilter] = (0, $acw62.useState)('all');
    const [groupMode, setGroupMode] = (0, $acw62.useState)('day'); // 'day' | 'type'
    const [datePreset, setDatePreset] = (0, $acw62.useState)('all');
    const [dateCustom, setDateCustom] = (0, $acw62.useState)({
        from: '',
        to: ''
    });
    const [topUpOpen, setTopUpOpen] = (0, $acw62.useState)(false);
    const { startDate: startDate, endDate: endDate } = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$439018c7c0970868)(datePreset, dateCustom), [
        datePreset,
        dateCustom
    ]);
    const { transactions: transactions, totalCount: totalCount, loading: loading, error: error, refetch: refetch } = (0, $0eafa090d94feaa4$export$9df289bef152e95b)(doctor?.id, {
        limit: $48ab62c8c643bc72$var$PAGE_SIZE,
        offset: page * $48ab62c8c643bc72$var$PAGE_SIZE,
        startDate: startDate,
        endDate: endDate,
        // The ledger runs to thousands of rows, so the type filter has to be applied
        // by the server. Filtering the fetched page instead showed only the matches
        // that happened to fall on the current page, under a count for the whole set.
        type: typeFilter === 'all' ? '' : typeFilter
    });
    // Gateway return leg.
    //
    // The payment BFF has already verified and settled with the bank by the time
    // the browser lands here — it is the only party that can, since the gateway
    // reports server-to-server and Sepehr's settle step needs a receipt the
    // browser never sees. So this screen reports the outcome and refreshes; it
    // must not try to confirm anything itself.
    const toast = (0, $6usBW.useToast)();
    (0, $acw62.useEffect)(()=>{
        const settled = (0, $5ea0c392ab976e29$export$366541b5137adfb1)();
        if (!settled) return;
        // Strip it immediately so a refresh cannot replay the message — and only
        // it, keeping this screen's own query state and the router's history state.
        (0, $5ea0c392ab976e29$export$fdfdde46624d2732)();
        if (settled === 'success') toast.success(t('credits.paymentDone'));
        else toast.error(t('errors.payment.failedNoCharge'));
        refetch?.();
    }, [
        toast,
        refetch
    ]);
    const stats = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$52e8b78f2372daa5)(transactions), [
        transactions
    ]);
    // Already filtered by the server; kept as a named value so the render below
    // reads the same as it did.
    const filtered = (0, $acw62.useMemo)(()=>transactions, [
        transactions
    ]);
    const dayGroups = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$3be14461f103972e)(filtered, t, formatDate), [
        filtered,
        t,
        formatDate
    ]);
    const typeGroups = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$c4f843207ab6bf8c)(filtered, t), [
        filtered,
        t
    ]);
    const totalPages = Math.max(1, Math.ceil(totalCount / $48ab62c8c643bc72$var$PAGE_SIZE));
    // Changing the server-side window must reset paging, else offset points past the new set.
    const applyDatePreset = (id)=>{
        setDatePreset(id);
        setPage(0);
    };
    const applyDateCustom = (from, to)=>{
        setDateCustom({
            from: from,
            to: to
        });
        setDatePreset('custom');
        setPage(0);
    };
    const level = (0, $jTCZr.creditLevel)(balance);
    const topMeta = stats.topService ? (0, $884b9b27c085fa62$export$e0b738a571245f61)(stats.topService, t) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('dashboard.rail.smartCredit'),
                sub: t('credits.subtitle'),
                children: canBuy && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: ()=>setTopUpOpen(true),
                    "data-testid": "credits-topup-header",
                    style: {
                        ...(0, $1HT9m.type).body,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        background: (0, $jTCZr.C).navy,
                        border: 'none',
                        color: '#fff',
                        borderRadius: 10,
                        padding: '9px 18px',
                        cursor: 'pointer'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                            size: 14
                        }),
                        " ",
                        t('credits.buyCoins')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '20px 28px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 18,
                    width: '100%',
                    boxSizing: 'border-box'
                },
                children: [
                    balance !== null && (level === 'low' || level === 'mid') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '10px 16px',
                            borderRadius: 10,
                            background: level === 'low' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
                            border: `1px solid ${(0, $jTCZr.soft)(level === 'low' ? (0, $jTCZr.C).red : (0, $jTCZr.C).amber, 0.35)}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).body,
                                    color: level === 'low' ? (0, $jTCZr.C).red : (0, $jTCZr.C).amber,
                                    flex: 1
                                },
                                children: level === 'low' ? t('credits.lowBalanceBanner', {
                                    coins: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber)
                                }) : t('credits.midBalanceBanner', {
                                    coins: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber)
                                })
                            }),
                            canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTopUpOpen(true),
                                style: {
                                    ...(0, $1HT9m.type).label,
                                    fontWeight: 700,
                                    background: 'transparent',
                                    border: `1px solid ${level === 'low' ? (0, $jTCZr.C).red : (0, $jTCZr.C).amber}`,
                                    color: level === 'low' ? (0, $jTCZr.C).red : (0, $jTCZr.C).amber,
                                    borderRadius: 8,
                                    padding: '4px 12px',
                                    cursor: 'pointer'
                                },
                                children: t('nav.credits.topUp')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : '300px 1fr',
                            gap: 14,
                            alignItems: 'stretch'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$BalanceHero, {
                                balance: balance,
                                onTopUp: canBuy ? ()=>setTopUpOpen(true) : undefined
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                                        label: t('credits.spentThisMonth'),
                                        value: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.usedThisMonth, formatNumber),
                                        unit: t('common.units.coin'),
                                        loading: loading && !transactions.length,
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: (0, $jTCZr.C).teal,
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                                size: 18
                                            })
                                        }),
                                        bg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                                        accent: (0, $jTCZr.C).textPrimary
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                                        label: t('credits.averagePerVisit'),
                                        value: stats.avgPerVisit == null ? "\u2014" : (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.avgPerVisit, formatNumber),
                                        unit: t('common.units.coin'),
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: (0, $jTCZr.C).navy,
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                                size: 18
                                            })
                                        }),
                                        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                                        accent: (0, $jTCZr.C).textPrimary
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                                        label: t('credits.mostUsedService'),
                                        value: topMeta ? topMeta.label : "\u2014",
                                        unit: topMeta ? t('credits.percentSuffix', {
                                            value: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.topPct, formatNumber)
                                        }) : '',
                                        icon: topMeta ? /*#__PURE__*/ (0, $ayMG0.jsx)(topMeta.icon, {
                                            size: 18,
                                            color: topMeta.color
                                        }) : undefined,
                                        bg: topMeta ? topMeta.bg : (0, $jTCZr.C).bg,
                                        accent: (0, $jTCZr.C).textPrimary
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : '1fr 280px',
                            gap: 14,
                            alignItems: 'start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$48ab62c8c643bc72$var$CARD,
                                    overflow: 'hidden'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '14px 16px',
                                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    ...(0, $1HT9m.type).title,
                                                    color: (0, $jTCZr.C).textPrimary
                                                },
                                                children: [
                                                    t('credits.transactions'),
                                                    totalCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            ...(0, $1HT9m.type).caption,
                                                            color: (0, $jTCZr.C).textMuted,
                                                            marginInlineStart: 8
                                                        },
                                                        children: [
                                                            "(",
                                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(totalCount, formatNumber),
                                                            " ",
                                                            t('common.units.itemsSuffix')
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                                items: $48ab62c8c643bc72$var$FILTERS(t),
                                                value: typeFilter,
                                                onChange: (v)=>{
                                                    setTypeFilter(v);
                                                    setPage(0);
                                                },
                                                size: "sm",
                                                ariaLabel: t('credits.filterType')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            flexWrap: 'wrap',
                                            padding: '10px 16px',
                                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).caption,
                                                    color: (0, $jTCZr.C).textMuted
                                                },
                                                children: t('credits.grouping')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                                items: $48ab62c8c643bc72$var$GROUP_OPTIONS(t),
                                                value: groupMode,
                                                onChange: setGroupMode,
                                                size: "sm",
                                                ariaLabel: t('credits.groupBy')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    marginInlineStart: 'auto'
                                                },
                                                "data-testid": "credits-daterange",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $awevB.default), {
                                                    presets: (0, $884b9b27c085fa62$export$925c8ee11af609ba)(t),
                                                    preset: datePreset,
                                                    custom: dateCustom,
                                                    onPreset: applyDatePreset,
                                                    onCustom: applyDateCustom
                                                })
                                            })
                                        ]
                                    }),
                                    error && !loading && transactions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                        error: error,
                                        title: t('credits.transactionsUnavailable'),
                                        onRetry: refetch
                                    }),
                                    loading && transactions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $979361a17e04d643$export$a4d55197b5b697b2), {
                                        rows: 8
                                    }),
                                    !loading && !error && filtered.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            padding: '44px 20px',
                                            textAlign: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 36,
                                                    marginBottom: 10
                                                },
                                                children: "\uD83E\uDE99"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    ...(0, $1HT9m.type).body,
                                                    color: (0, $jTCZr.C).textPrimary,
                                                    marginBottom: 4
                                                },
                                                children: typeFilter === 'all' && datePreset === 'all' ? t('credits.noTransactions') : t('errors.empty.transactions')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    ...(0, $1HT9m.type).label,
                                                    color: (0, $jTCZr.C).textMuted
                                                },
                                                children: t('credits.noTransactionsHint')
                                            })
                                        ]
                                    }),
                                    !loading && groupMode === 'day' && dayGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        ...(0, $1HT9m.type).caption,
                                                        fontWeight: 700,
                                                        padding: '6px 16px',
                                                        color: (0, $jTCZr.C).textMuted,
                                                        background: (0, $jTCZr.C).bg
                                                    },
                                                    children: group.label
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$TransactionRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key)),
                                    !loading && groupMode === 'type' && typeGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$TypeGroupHeader, {
                                                    group: group
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$TransactionRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key)),
                                    totalCount > 0 && !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            padding: '10px 16px 0',
                                            textAlign: 'center',
                                            ...(0, $1HT9m.type).caption,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        "data-testid": "txn-range",
                                        children: [
                                            t('common.pagination.showing'),
                                            " ",
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(page * $48ab62c8c643bc72$var$PAGE_SIZE + 1, formatNumber),
                                            "\u2013",
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(Math.min((page + 1) * $48ab62c8c643bc72$var$PAGE_SIZE, totalCount)),
                                            " ",
                                            t('common.labels.from'),
                                            " ",
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(totalCount, formatNumber),
                                            " ",
                                            t('credits.transaction')
                                        ]
                                    }),
                                    totalPages > 1 && !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 12,
                                            padding: '12px 16px',
                                            borderTop: `1px solid ${(0, $jTCZr.C).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setPage((p)=>Math.max(0, p - 1)),
                                                disabled: page === 0,
                                                "data-testid": "txn-prev",
                                                style: $48ab62c8c643bc72$var$pagerBtn(page === 0),
                                                children: t('common.actions.previous')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).label,
                                                    color: (0, $jTCZr.C).textSecondary,
                                                    whiteSpace: 'nowrap'
                                                },
                                                "data-testid": "txn-page-label",
                                                children: [
                                                    t('common.pagination.pageLabel'),
                                                    " ",
                                                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(page + 1, formatNumber),
                                                    " ",
                                                    t('common.labels.from'),
                                                    " ",
                                                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(totalPages, formatNumber)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setPage((p)=>p + 1 < totalPages ? p + 1 : p),
                                                disabled: page + 1 >= totalPages,
                                                "data-testid": "txn-next",
                                                style: $48ab62c8c643bc72$var$pagerBtn(page + 1 >= totalPages),
                                                children: t('common.actions.next')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 12
                                },
                                children: [
                                    (0, $d87bd335296b449f$export$75000a7ae96cb4e)() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                                        doctorId: doctor?.id,
                                        onRedeemed: ()=>refetch && refetch()
                                    }),
                                    canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$PriceListCard, {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($48ab62c8c643bc72$var$ServiceBreakdownCard, {
                                        transactions: transactions
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>navigate('profile', {
                                                tab: 'credits'
                                            }),
                                        style: {
                                            ...$48ab62c8c643bc72$var$CARD,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            padding: '10px 14px',
                                            cursor: 'pointer',
                                            textAlign: 'start'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).label,
                                                    flex: 1,
                                                    color: (0, $jTCZr.C).textSecondary
                                                },
                                                children: t('credits.lowBalanceTitle')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).caption,
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).teal
                                                },
                                                children: t('credits.settingsLink')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
                open: topUpOpen,
                onOpenChange: setTopUpOpen,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                                children: t('credits.buyCoins')
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $260a6170605807fd$export$2e2bcd8739ae039), {
                            avgPerVisit: stats.avgPerVisit,
                            balance: balance,
                            onPay: startTopUp,
                            busy: payBusy,
                            error: payError
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $awevB = parcelRequire("awevB");
var $6usBW = parcelRequire("6usBW");








var $jTCZr = parcelRequire("jTCZr");





var $1HT9m = parcelRequire("1HT9m");







const $506153099b614331$var$PAGE_SIZE = 30;
const $506153099b614331$var$CARD = {
    background: (0, $jTCZr.C).card,
    borderRadius: 14,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    boxShadow: '0 1px 4px rgba(20,30,45,0.05)'
};
const $506153099b614331$var$FILTERS = (t)=>[
        {
            id: 'all',
            label: t('common.state.all')
        },
        {
            id: 'debit',
            label: t('credits.spend')
        },
        {
            id: 'credit',
            label: t('credits.topUp')
        }
    ];
const $506153099b614331$var$GROUP_OPTIONS = (t)=>[
        {
            id: 'day',
            label: t('common.units.day')
        },
        {
            id: 'type',
            label: t('common.labels.type')
        }
    ];
function $506153099b614331$var$MobileTxnRow({ txn: txn }) {
    const { t: t, has: has, locale: locale, formatNumber: formatNumber, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const meta = (0, $884b9b27c085fa62$export$e0b738a571245f61)(txn.serviceType, t);
    const IconC = meta.icon;
    const isDebit = txn.type === 'debit';
    const { title: title, sub: sub } = (0, $884b9b27c085fa62$export$987fd27eb55fb951)(txn, {
        t: t,
        has: has,
        locale: locale,
        formatNumber: formatNumber
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '9px 12px',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 30,
                    height: 30,
                    borderRadius: 8,
                    background: meta.bg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconC, {
                    size: 15,
                    color: meta.color
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).label,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: title || meta.label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...(0, $1HT9m.type).micro,
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            (0, $884b9b27c085fa62$export$5449ff08984f7155)(txn.createdAt, formatTime),
                            sub ? ` \xb7 ${sub}` : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    ...(0, $1HT9m.type).body,
                    fontWeight: 800,
                    color: isDebit ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).green
                },
                children: [
                    isDebit ? "\u2212" : '+',
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(txn.amount, formatNumber)
                ]
            })
        ]
    });
}
function $506153099b614331$var$MobileTypeGroupHeader({ group: group }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const IconC = group.meta.icon;
    const spent = group.total >= 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            padding: '6px 12px',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    width: 20,
                    height: 20,
                    borderRadius: 6,
                    background: group.meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconC, {
                    size: 12,
                    color: group.meta.color
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    ...(0, $1HT9m.type).caption,
                    fontWeight: 800,
                    flex: 1,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: group.meta.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    ...(0, $1HT9m.type).micro,
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textMuted
                },
                children: [
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(group.items.length, formatNumber),
                    " ",
                    t('dashboard.queue.finishedCount')
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    ...(0, $1HT9m.type).label,
                    fontWeight: 800,
                    color: spent ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).green
                },
                children: [
                    spent ? "\u2212" : '+',
                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(Math.abs(group.total), formatNumber)
                ]
            })
        ]
    });
}
function $506153099b614331$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate, locale: locale } = (0, $LNQP4.default)();
    // The policy's figures once the list has arrived; the shipped constants until then.
    const { priceList: priceList } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const balance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const { startTopUp: startTopUp, busy: payBusy, error: payError } = (0, $cc8daf12c2d1c2bf$export$64e212e524010641)(doctor?.id);
    // Buying credit only where it is sold and this panel has a rail for its price
    // (Credits.web.jsx says why): otherwise no buy button, money figure, price
    // list or top-up sheet.
    const { canBuy: canBuy, creditPrice: creditPrice } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    const [page, setPage] = (0, $acw62.useState)(0);
    const [typeFilter, setTypeFilter] = (0, $acw62.useState)('all');
    const [groupMode, setGroupMode] = (0, $acw62.useState)('day'); // 'day' | 'type'
    const [datePreset, setDatePreset] = (0, $acw62.useState)('all');
    const [dateCustom, setDateCustom] = (0, $acw62.useState)({
        from: '',
        to: ''
    });
    const [priceOpen, setPriceOpen] = (0, $acw62.useState)(false);
    const [topUpOpen, setTopUpOpen] = (0, $acw62.useState)(false);
    const { startDate: startDate, endDate: endDate } = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$439018c7c0970868)(datePreset, dateCustom), [
        datePreset,
        dateCustom
    ]);
    const { transactions: transactions, totalCount: totalCount, loading: loading, error: error, refetch: refetch } = (0, $0eafa090d94feaa4$export$9df289bef152e95b)(doctor?.id, {
        limit: $506153099b614331$var$PAGE_SIZE,
        offset: page * $506153099b614331$var$PAGE_SIZE,
        startDate: startDate,
        endDate: endDate,
        // Server-side: the ledger runs to thousands of rows, so filtering the
        // fetched page would show only the matches that fall on it.
        type: typeFilter === 'all' ? '' : typeFilter
    });
    const stats = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$52e8b78f2372daa5)(transactions), [
        transactions
    ]);
    const filtered = (0, $acw62.useMemo)(()=>transactions, [
        transactions
    ]);
    const dayGroups = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$3be14461f103972e)(filtered, t, formatDate), [
        filtered,
        t,
        formatDate
    ]);
    const typeGroups = (0, $acw62.useMemo)(()=>(0, $884b9b27c085fa62$export$c4f843207ab6bf8c)(filtered, t), [
        filtered,
        t
    ]);
    const totalPages = Math.max(1, Math.ceil(totalCount / $506153099b614331$var$PAGE_SIZE));
    // Gateway return leg — the same one Credits.web has. Without it a doctor who
    // paid on a phone landed back on this screen with no confirmation and a stale
    // balance, because the ≤768px viewport renders THIS component, not the web one.
    const toast = (0, $6usBW.useToast)();
    (0, $acw62.useEffect)(()=>{
        const settled = (0, $5ea0c392ab976e29$export$366541b5137adfb1)();
        if (!settled) return;
        (0, $5ea0c392ab976e29$export$fdfdde46624d2732)();
        if (settled === 'success') toast.success(t('credits.paymentDone'));
        else toast.error(t('errors.payment.failedRefund'));
        refetch?.();
    }, [
        toast,
        refetch
    ]);
    const applyDatePreset = (id)=>{
        setDatePreset(id);
        setPage(0);
    };
    const applyDateCustom = (from, to)=>{
        setDateCustom({
            from: from,
            to: to
        });
        setDatePreset('custom');
        setPage(0);
    };
    const level = (0, $jTCZr.creditLevel)(balance);
    const topMeta = stats.topService ? (0, $884b9b27c085fa62$export$e0b738a571245f61)(stats.topService, t) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    title: t('dashboard.rail.smartCredit'),
                    onBack: ()=>navigate('reception'),
                    backLabel: t('accounting.backToReception')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    padding: '0 0.875rem 1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
                            borderRadius: 16,
                            padding: 16,
                            color: '#fff',
                            marginTop: -14,
                            boxShadow: '0 8px 24px rgba(0,0,0,0.14)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).caption,
                                    color: 'rgba(255,255,255,0.6)'
                                },
                                children: t('credits.currentBalance')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    gap: 6,
                                    marginTop: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).display
                                        },
                                        children: balance === null ? "\u2014" : (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).unit,
                                            color: 'rgba(255,255,255,0.7)',
                                            marginBottom: 3
                                        },
                                        children: t('common.units.coin')
                                    }),
                                    balance !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 5,
                                            background: 'rgba(255,255,255,0.14)',
                                            borderRadius: 20,
                                            padding: '2px 9px',
                                            marginBottom: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 7,
                                                    height: 7,
                                                    borderRadius: '50%',
                                                    background: (0, $jTCZr.creditColor)(balance)
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).micro,
                                                    fontWeight: 600
                                                },
                                                children: t((0, $jTCZr.CREDIT_LEVEL_META)[level].labelKey)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            canBuy && balance !== null && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).micro,
                                    fontWeight: 600,
                                    color: 'rgba(255,255,255,0.55)',
                                    marginTop: 5
                                },
                                children: (0, $2a90b979c3d41f86$export$e610461cba74a0c9)(balance, {
                                    creditPrice: creditPrice,
                                    formatNumber: formatNumber,
                                    tomanLabel: t('common.units.toman'),
                                    locale: locale
                                })
                            }),
                            canBuy && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setTopUpOpen(true),
                                "data-testid": "credits-topup",
                                style: {
                                    ...(0, $1HT9m.type).body,
                                    marginTop: 12,
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    height: 42,
                                    borderRadius: 10,
                                    border: 'none',
                                    background: '#fff',
                                    color: (0, $jTCZr.C).navy,
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                        size: 14
                                    }),
                                    " ",
                                    t('credits.buyCoins')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3,1fr)',
                            gap: 8,
                            marginTop: 10
                        },
                        children: [
                            {
                                v: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.usedThisMonth, formatNumber),
                                l: t('credits.monthSpend')
                            },
                            {
                                v: stats.avgPerVisit == null ? "\u2014" : (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.avgPerVisit, formatNumber),
                                l: t('credits.perVisit')
                            },
                            {
                                v: topMeta ? t('credits.percentSuffix', {
                                    value: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(stats.topPct, formatNumber)
                                }) : "\u2014",
                                l: topMeta ? topMeta.label : t('credits.topService')
                            }
                        ].map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$506153099b614331$var$CARD,
                                    padding: 10,
                                    textAlign: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).amount,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: item.v
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).micro,
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 2,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: item.l
                                    })
                                ]
                            }, i))
                    }),
                    (0, $d87bd335296b449f$export$75000a7ae96cb4e)() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                        doctorId: doctor?.id,
                        compact: true,
                        onRedeemed: ()=>refetch && refetch()
                    }),
                    canBuy && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...$506153099b614331$var$CARD,
                            marginTop: 10,
                            padding: '10px 12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setPriceOpen((o)=>!o),
                                style: {
                                    width: '100%',
                                    background: 'none',
                                    border: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    padding: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            fontWeight: 800,
                                            flex: 1,
                                            color: (0, $jTCZr.C).textPrimary,
                                            textAlign: 'start'
                                        },
                                        children: t('credits.priceListTitle')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: (0, $jTCZr.C).textMuted,
                                            fontSize: 12,
                                            transform: priceOpen ? 'rotate(180deg)' : 'none',
                                            transition: 'transform 0.2s'
                                        },
                                        children: "\u2304"
                                    })
                                ]
                            }),
                            priceOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginTop: 8
                                },
                                children: priceList.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            padding: '5px 0',
                                            borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).caption,
                                                    flex: 1,
                                                    color: (0, $jTCZr.C).textSecondary
                                                },
                                                children: t(r.labelKey)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    ...(0, $1HT9m.type).caption,
                                                    fontWeight: 800,
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 4,
                                                    color: (0, $jTCZr.C).teal
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                                        size: 10
                                                    }),
                                                    (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(r.cost, formatNumber),
                                                    r.perKey ? ` / ${t(r.perKey)}` : ''
                                                ]
                                            })
                                        ]
                                    }, r.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...$506153099b614331$var$CARD,
                            marginTop: 10,
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '10px 12px',
                                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            fontWeight: 800,
                                            flex: 1,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('credits.transactions')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                        items: $506153099b614331$var$FILTERS(t),
                                        value: typeFilter,
                                        onChange: (v)=>{
                                            setTypeFilter(v);
                                            setPage(0);
                                        },
                                        size: "sm",
                                        ariaLabel: t('credits.filterType')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap',
                                    padding: '8px 12px',
                                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                        items: $506153099b614331$var$GROUP_OPTIONS(t),
                                        value: groupMode,
                                        onChange: setGroupMode,
                                        size: "sm",
                                        ariaLabel: t('credits.groupBy')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            marginInlineStart: 'auto'
                                        },
                                        "data-testid": "credits-daterange",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $awevB.default), {
                                            presets: (0, $884b9b27c085fa62$export$925c8ee11af609ba)(t),
                                            preset: datePreset,
                                            custom: dateCustom,
                                            onPreset: applyDatePreset,
                                            onCustom: applyDateCustom
                                        })
                                    })
                                ]
                            }),
                            error && !loading && transactions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                error: error,
                                title: t('credits.transactionsUnavailable'),
                                onRetry: refetch
                            }),
                            loading && transactions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $979361a17e04d643$export$a4d55197b5b697b2), {
                                rows: 6,
                                mobile: true
                            }),
                            !loading && !error && filtered.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '32px 16px',
                                    textAlign: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 30,
                                            marginBottom: 8
                                        },
                                        children: "\uD83E\uDE99"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).body,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: typeFilter === 'all' && datePreset === 'all' ? t('credits.noTransactions') : t('errors.empty.transactions')
                                    })
                                ]
                            }),
                            !loading && groupMode === 'day' && dayGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                ...(0, $1HT9m.type).micro,
                                                fontWeight: 700,
                                                padding: '5px 12px',
                                                color: (0, $jTCZr.C).textMuted,
                                                background: (0, $jTCZr.C).bg
                                            },
                                            children: group.label
                                        }),
                                        group.items.map((txn)=>/*#__PURE__*/ (0, $ayMG0.jsx)($506153099b614331$var$MobileTxnRow, {
                                                txn: txn
                                            }, txn.id))
                                    ]
                                }, group.key)),
                            !loading && groupMode === 'type' && typeGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($506153099b614331$var$MobileTypeGroupHeader, {
                                            group: group
                                        }),
                                        group.items.map((txn)=>/*#__PURE__*/ (0, $ayMG0.jsx)($506153099b614331$var$MobileTxnRow, {
                                                txn: txn
                                            }, txn.id))
                                    ]
                                }, group.key)),
                            totalPages > 1 && !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 8,
                                    padding: '10px 12px',
                                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setPage((p)=>Math.max(0, p - 1)),
                                        disabled: page === 0,
                                        "data-testid": "txn-prev",
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            height: 34,
                                            padding: '0 16px',
                                            background: (0, $jTCZr.C).card,
                                            border: `1px solid ${(0, $jTCZr.C).border}`,
                                            borderRadius: 9,
                                            color: page === 0 ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
                                            opacity: page === 0 ? 0.55 : 1,
                                            cursor: page === 0 ? 'not-allowed' : 'pointer'
                                        },
                                        children: t('common.actions.previous')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            color: (0, $jTCZr.C).textSecondary,
                                            whiteSpace: 'nowrap'
                                        },
                                        "data-testid": "txn-page-label",
                                        children: [
                                            t('common.pagination.pageLabel'),
                                            " ",
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(page + 1, formatNumber),
                                            " ",
                                            t('common.labels.from'),
                                            " ",
                                            (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(totalPages, formatNumber)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setPage((p)=>p + 1 < totalPages ? p + 1 : p),
                                        disabled: page + 1 >= totalPages,
                                        "data-testid": "txn-next",
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            height: 34,
                                            padding: '0 16px',
                                            background: (0, $jTCZr.C).card,
                                            border: `1px solid ${(0, $jTCZr.C).border}`,
                                            borderRadius: 9,
                                            color: page + 1 >= totalPages ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
                                            opacity: page + 1 >= totalPages ? 0.55 : 1,
                                            cursor: page + 1 >= totalPages ? 'not-allowed' : 'pointer'
                                        },
                                        children: t('common.actions.next')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cZOyb.default), {
                open: topUpOpen,
                onClose: ()=>setTopUpOpen(false),
                title: t('credits.buyCoins'),
                closeLabel: t('common.actions.close'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $260a6170605807fd$export$2e2bcd8739ae039), {
                    avgPerVisit: stats.avgPerVisit,
                    balance: balance,
                    onPay: startTopUp,
                    busy: payBusy,
                    error: payError
                })
            })
        ]
    });
}


const $3a41492e814d4035$var$CreditsScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $506153099b614331$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48ab62c8c643bc72$export$2e2bcd8739ae039), {
        isMobile: false
    });
};
var $3a41492e814d4035$export$2e2bcd8739ae039 = $3a41492e814d4035$var$CreditsScreen;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");


var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");
var $kMJsW = parcelRequire("kMJsW");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5baafd2aed3f7e15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M8 13h2",
            key: "yr2amv"
        }
    ],
    [
        "path",
        {
            d: "M14 13h2",
            key: "un5t4a"
        }
    ],
    [
        "path",
        {
            d: "M8 17h2",
            key: "2yhykz"
        }
    ],
    [
        "path",
        {
            d: "M14 17h2",
            key: "10kma7"
        }
    ]
];
const $5baafd2aed3f7e15$export$2e2bcd8739ae039 = (0, $9QBug.default)("file-spreadsheet", $5baafd2aed3f7e15$export$3efd853dbb351e94);


var $3SiwN = parcelRequire("3SiwN");
var $gYS9K = parcelRequire("gYS9K");
var $8gMKa = parcelRequire("8gMKa");
var $bF8pu = parcelRequire("bF8pu");
var $2VplL = parcelRequire("2VplL");
var $fX0JO = parcelRequire("fX0JO");
var $l37hw = parcelRequire("l37hw");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $awevB = parcelRequire("awevB");
var $7gSBD = parcelRequire("7gSBD");
var $lUcdx = parcelRequire("lUcdx");
var $kyZIh = parcelRequire("kyZIh");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $6usBW = parcelRequire("6usBW");







var $acw62 = parcelRequire("acw62");




const $2b6b2d11947b2299$var$REPORT_QUERY = `
  query DoctorAccountingReport(
    $fromTs: Float, $toTs: Float, $clinicId: String,
    $itemType: AccountingItemType, $settlement: SettlementFilter,
    $search: String, $page: Int, $staffPage: Int, $pageSize: Int
  ) {
    doctorAccountingReport(
      fromTs: $fromTs, toTs: $toTs, clinicId: $clinicId,
      itemType: $itemType, settlement: $settlement,
      search: $search, page: $page, staffPage: $staffPage, pageSize: $pageSize
    ) {
      grossTotal
      doctorShareTotal
      collectedDoctorShare
      totalsByCurrency { currency grossTotal doctorShareTotal collectedDoctorShare }
      mixedCurrency
      itemCount
      linesTotal
      staffLinesTotal
      page
      staffPage
      pageSize
      clinics {
        clinicId clinicName currency grossTotal doctorShareTotal collectedDoctorShare
        visitCount medicalServiceCount productCount
      }
      types { itemType currency count grossTotal doctorShareTotal }
      lines {
        id invoiceId clinicId clinicName patientId patientName currency createdAt
        itemType description quantity grossAmount patientPayable
        doctorShare settlementStatus performedByDoctor
      }
      staffLines {
        id invoiceId clinicId clinicName patientId patientName currency createdAt
        itemType description quantity grossAmount patientPayable
        doctorShare settlementStatus performedByDoctor
      }
    }
  }
`;
// Every amount in the report is minor units of its own row's `currency`. The
// three scalar totals are NULL when the lines span more than one currency — read
// `totalsByCurrency` (lib/clinicMoney's `reportTotals`), never the scalars.
const $2b6b2d11947b2299$var$EMPTY = {
    grossTotal: 0,
    doctorShareTotal: 0,
    collectedDoctorShare: 0,
    totalsByCurrency: [],
    mixedCurrency: false,
    itemCount: 0,
    linesTotal: 0,
    staffLinesTotal: 0,
    page: 1,
    staffPage: 1,
    pageSize: (0, $f7753960a21756a4$export$8ec3d08588d2eeda),
    clinics: [],
    types: [],
    lines: [],
    staffLines: []
};
function $2b6b2d11947b2299$export$fbd014276b792314({ range: range, clinicId: clinicId, itemType: itemType, settlement: settlement, search: search, page: page, staffPage: staffPage }) {
    const [report, setReport] = (0, $acw62.useState)($2b6b2d11947b2299$var$EMPTY);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [nonce, setNonce] = (0, $acw62.useState)(0);
    const vars = (0, $acw62.useMemo)(()=>({
            fromTs: range?.fromTs ?? 0,
            toTs: range?.toTs ?? 0,
            clinicId: clinicId || null,
            itemType: itemType || null,
            settlement: settlement || 'ALL',
            search: (search || '').trim() || null,
            page: page || 1,
            staffPage: staffPage || 1,
            pageSize: (0, $f7753960a21756a4$export$8ec3d08588d2eeda)
        }), [
        range?.fromTs,
        range?.toTs,
        clinicId,
        itemType,
        settlement,
        search,
        page,
        staffPage
    ]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($2b6b2d11947b2299$var$REPORT_QUERY, vars).then((data)=>{
            if (cancelled) return;
            setReport(data?.doctorAccountingReport || $2b6b2d11947b2299$var$EMPTY);
            setError(null);
        }).catch((err)=>{
            if (cancelled) return;
            console.error('doctorAccountingReport failed:', err);
            // The error OBJECT, not `err.message`. bffClient stamps the failure kind
            // onto it, and flattening to a string here threw that away — which is
            // why an offline doctor was told the accounting report was unavailable
            // and offered a retry button that could not work.
            setError(err);
            setReport($2b6b2d11947b2299$var$EMPTY);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        vars,
        nonce
    ]);
    const reload = (0, $acw62.useCallback)(()=>setNonce((n)=>n + 1), []);
    return {
        report: report,
        loading: loading,
        error: error,
        reload: reload,
        vars: vars
    };
}
async function $2b6b2d11947b2299$export$a8a6fc5ab73285db(vars) {
    const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($2b6b2d11947b2299$var$REPORT_QUERY, {
        ...vars,
        page: 1,
        staffPage: 1,
        pageSize: 0
    });
    const r = data?.doctorAccountingReport;
    return [
        ...r?.lines || [],
        ...r?.staffLines || []
    ].sort((a, b)=>b.createdAt - a.createdAt);
}
function $2b6b2d11947b2299$export$f9eed3ff0df23e5c() {
    return (0, $90c3af16928ea94c$export$f5416d3c5746c6f8)().targets;
}


// ─────────────────────────────────────────────────────────────────────────────
// Accounting — shared logic & display data (DESIGN-CONCEPT-MOBILE v2 §1.1).
//
// The desktop table (`Accounting.web.jsx`) and the mobile report
// (`Accounting.mobile.jsx`) are two independent render trees, but they must
// never *disagree* on what a line means, how a date reads, what a CSV row
// contains, or which filter is the default. All of that non-visual truth lives
// here — imported by both surfaces so a change is made once.
//
// Markup (badges, rows, cards) is NOT here: a component belongs to exactly one
// surface. This module only holds data maps and pure functions.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a5e13059631a6518$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.1 2.182a10 10 0 0 1 3.8 0",
            key: "5ilxe3"
        }
    ],
    [
        "path",
        {
            d: "M13.9 21.818a10 10 0 0 1-3.8 0",
            key: "11zvb9"
        }
    ],
    [
        "path",
        {
            d: "M17.609 3.721a10 10 0 0 1 2.69 2.7",
            key: "1iw5b2"
        }
    ],
    [
        "path",
        {
            d: "M2.182 13.9a10 10 0 0 1 0-3.8",
            key: "c0bmvh"
        }
    ],
    [
        "path",
        {
            d: "M20.279 17.609a10 10 0 0 1-2.7 2.69",
            key: "1ruxm7"
        }
    ],
    [
        "path",
        {
            d: "M21.818 10.1a10 10 0 0 1 0 3.8",
            key: "qkgqxc"
        }
    ],
    [
        "path",
        {
            d: "M3.721 6.391a10 10 0 0 1 2.7-2.69",
            key: "1mcia2"
        }
    ],
    [
        "path",
        {
            d: "M6.391 20.279a10 10 0 0 1-2.69-2.7",
            key: "1fvljs"
        }
    ]
];
const $a5e13059631a6518$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-dashed", $a5e13059631a6518$export$3efd853dbb351e94);


var $4CVxl = parcelRequire("4CVxl");
var $8gMKa = parcelRequire("8gMKa");
var $fX0JO = parcelRequire("fX0JO");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("hlTfq");


var $hlTfq = parcelRequire("hlTfq");

var $lHVFz = parcelRequire("lHVFz");



const $7105e29f5dc28eca$export$1468859f0798d24 = (t)=>({
        VISIT: {
            label: t('patient.visit'),
            Icon: (0, $fX0JO.default),
            color: (0, $jTCZr.C).navy
        },
        MEDICAL_SERVICE: {
            label: t('accounting.paraclinical'),
            Icon: (0, $4CVxl.default),
            color: (0, $jTCZr.C).teal
        },
        PRODUCT: {
            label: t('accounting.goods'),
            Icon: (0, $8gMKa.default),
            color: (0, $jTCZr.C).amber
        },
        // A line the accounting service could not type (unset/unknown). Rendered with a
        // neutral label so an untyped line reads honestly rather than as raw "OTHER".
        OTHER: {
            label: t('common.state.other'),
            Icon: (0, $a5e13059631a6518$export$2e2bcd8739ae039),
            color: (0, $jTCZr.C).textSecondary
        }
    });
const $7105e29f5dc28eca$export$ca9bef58765b5377 = (s)=>(0, $fa15d8b4a746e70c$export$e50006273435e7d4)[s]?.label || s;
const $7105e29f5dc28eca$export$73b877b58963a4f = (t)=>[
        {
            id: 'ALL',
            label: t('common.state.all')
        },
        {
            id: 'PENDING',
            label: t('accounting.awaitingSettlement')
        },
        {
            id: 'SETTLED',
            label: t('common.settlement.SETTLED')
        }
    ];
const $7105e29f5dc28eca$export$dd86032c66b86dfb = (t)=>[
        {
            value: 'VISIT',
            label: t('patient.visit')
        },
        {
            value: 'MEDICAL_SERVICE',
            label: t('accounting.paraclinical')
        },
        {
            value: 'PRODUCT',
            label: t('accounting.goods')
        }
    ];
const $7105e29f5dc28eca$export$f484e977a69c6ba6 = {
    settle: 'ALL',
    q: '',
    clinic: '',
    type: '',
    preset: 'month',
    from: '',
    to: ''
};
const $7105e29f5dc28eca$export$d570a62256bab7b8 = (ms, formatDate)=>formatDate ? formatDate(Number(ms), 'long') : "\u2014";
function $7105e29f5dc28eca$export$4368c02066be5ea3(amount, currency, t, formatMoney, moneyUnit) {
    if ((0, $23af70c6e8945b15$export$d2f719a5670e623a)(currency)) return t('accounting.tomanAmount', {
        amount: formatMoney(amount)
    });
    return `${formatMoney(amount, {
        currency: currency
    })} ${moneyUnit(currency, 'short')}`;
}
function $7105e29f5dc28eca$export$5cafab1c4b1c0d4a(amount, currency, t, formatMoney, moneyUnit) {
    if ((0, $23af70c6e8945b15$export$d2f719a5670e623a)(currency)) return t('accounting.yourShareAmount', {
        amount: formatMoney(amount)
    });
    return `${t('accounting.yourShareLabel')} ${$7105e29f5dc28eca$export$4368c02066be5ea3(amount, currency, t, formatMoney, moneyUnit)}`;
}
function $7105e29f5dc28eca$export$5462d920b006e1b3(lines, rangeLabel, t, formatDate) {
    const esc = (v)=>{
        const s = v == null ? '' : String(v);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const allIrr = lines.every((l)=>(0, $23af70c6e8945b15$export$d2f719a5670e623a)(l.currency));
    // Toman, like the screen. Plain digits, not fa-IR groups: Excel reads «۵۰۰٬۰۰۰» as
    // text, not as a number an accountant can sum.
    const headers = allIrr ? [
        t('common.labels.date'),
        t('common.labels.clinic'),
        t('common.labels.patient'),
        t('accounting.serviceType'),
        t('accounting.description'),
        t('common.labels.count'),
        t('accounting.totalAmountToman'),
        t('accounting.doctorShareToman'),
        t('accounting.settlementStatus'),
        t('accounting.performedBy')
    ] : [
        t('common.labels.date'),
        t('common.labels.clinic'),
        t('common.labels.patient'),
        t('accounting.serviceType'),
        t('accounting.description'),
        t('common.labels.count'),
        t('accounting.currency'),
        t('accounting.totalAmount'),
        t('accounting.doctorShare'),
        t('accounting.settlementStatus'),
        t('accounting.performedBy')
    ];
    const rows = lines.map((l)=>{
        const currency = (0, $23af70c6e8945b15$export$f3986f464fb786c9)(l);
        const money = allIrr ? [
            (0, $hlTfq.rialToToman)(l.grossAmount) ?? '',
            l.doctorShare == null ? '' : (0, $hlTfq.rialToToman)(l.doctorShare)
        ] : [
            currency,
            (0, $lHVFz.toDisplay)(l.grossAmount, currency) ?? '',
            l.doctorShare == null ? '' : (0, $lHVFz.toDisplay)(l.doctorShare, currency)
        ];
        return [
            $7105e29f5dc28eca$export$d570a62256bab7b8(l.createdAt, formatDate),
            l.clinicName || "\u2014",
            l.patientName || '',
            ($7105e29f5dc28eca$export$1468859f0798d24(t)[l.itemType] || {}).label || l.itemType,
            (0, $71e4a1bb85321be9$export$5764802ad0ccd8a0)(l.description, t),
            l.quantity,
            ...money,
            $7105e29f5dc28eca$export$ca9bef58765b5377(l.settlementStatus),
            l.performedByDoctor ? t('common.labels.doctor') : t('accounting.clinicStaff')
        ].map(esc).join(',');
    });
    const csv = "\uFEFF" + [
        headers.join(','),
        ...rows
    ].join('\r\n');
    const filename = `${t('patient.files.accountingExport', {
        range: (rangeLabel || t('accounting.report')).replace(/\s+/g, '_')
    })}.csv`;
    return $7105e29f5dc28eca$export$97dabc71a515e97d(csv, filename);
}
async function $7105e29f5dc28eca$export$97dabc71a515e97d(csv, filename) {
    const blob = new Blob([
        csv
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    try {
        const file = new File([
            blob
        ], filename, {
            type: 'text/csv'
        });
        if (navigator.canShare?.({
            files: [
                file
            ]
        })) {
            await navigator.share({
                files: [
                    file
                ],
                title: filename
            });
            return 'shared';
        }
    } catch (err) {
        // `AbortError` is the doctor dismissing the sheet — a decision, not a
        // failure, and falling through to a download would override it.
        if (err?.name === 'AbortError') return 'shared';
    // Anything else: fall through and try the anchor.
    }
    // A standalone PWA has no download UI, so an anchor there is a no-op that
    // reports success. Say so instead.
    const standalone = typeof window !== 'undefined' && (window.matchMedia?.('(display-mode: standalone)')?.matches || window.navigator?.standalone === true);
    if (standalone) return 'unsupported';
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return 'downloaded';
}


var $jTCZr = parcelRequire("jTCZr");

// This file is the DESKTOP surface only (DESIGN-CONCEPT-MOBILE v2 §1.1): the
// phone renders the independent `Accounting.mobile.jsx`, so there is no
// responsive fork here. Non-visual truth (item meta, tabs, CSV, date format,
// defaults) lives in `Accounting.shared` and is imported by both surfaces.
// ── The one column/label definition (§5.1: table renders from it) ──────────────
const $64da0901b95e72e4$var$COLUMNS = (t)=>[
        {
            id: 'date',
            label: t('common.labels.date')
        },
        {
            id: 'clinic',
            label: t('common.labels.clinic')
        },
        {
            id: 'description',
            label: t('accounting.serviceDescription')
        },
        {
            id: 'type',
            label: t('common.labels.type')
        },
        {
            id: 'gross',
            label: t('accounting.totalAmount')
        },
        {
            id: 'doctorShare',
            label: t('accounting.yourShare')
        },
        {
            id: 'settlement',
            label: t('accounting.settlement')
        }
    ];
// ── Rail cards ─────────────────────────────────────────────────────────────────
// Rows come one per (clinic, currency), IRR first. Each currency is its own chart:
// a bar is scaled against the largest bar IN ITS CURRENCY, never across — with no
// exchange rate, a dirham bar next to a toman bar would compare nothing. When
// more than one currency is present each group is headed by its currency's name.
const $64da0901b95e72e4$var$CurrencyHeading = ({ currency: currency })=>{
    const { moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-[0.6875rem] font-bold text-muted-foreground",
        "data-testid": `accounting-currency-heading-${currency}`,
        children: moneyUnit(currency)
    });
};
const $64da0901b95e72e4$var$ClinicBreakdown = ({ clinics: clinics })=>{
    const { t: t, formatMoney: formatMoney, formatNumber: formatNumber, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    if (!clinics.length) return null;
    const groups = (0, $23af70c6e8945b15$export$f259c563cf34883d)(clinics);
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-2xl shadow-card p-6",
        "data-testid": "accounting-breakdown-clinic",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-[0.9375rem] font-extrabold text-foreground mb-1",
                children: t('accounting.byClinic')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-xs text-muted-foreground mb-[1.125rem]",
                children: t('accounting.shareByClinic')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-4",
                children: groups.map(({ currency: currency, rows: rows })=>{
                    const max = (0, $23af70c6e8945b15$export$174cf94db2560bb)(rows);
                    const unit = moneyUnit(currency, 'short');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            mixed && /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$CurrencyHeading, {
                                currency: currency
                            }),
                            rows.map((c)=>{
                                const pct = c.grossTotal / max * 100;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "flex-1 text-[0.8125rem] font-bold text-foreground",
                                                    children: c.clinicName || (c.clinicId ? t('accounting.unknownClinic') : t('accounting.noClinic'))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "text-[0.8125rem] font-extrabold text-clinic-teal",
                                                    children: [
                                                        formatMoney(c.doctorShareTotal, {
                                                            currency: currency
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-[0.625rem] font-semibold text-muted-foreground me-0.5",
                                                            children: unit
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h-1.5 bg-background rounded overflow-hidden mb-1.5",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "h-full bg-clinic-teal rounded transition-[width] duration-500",
                                                style: {
                                                    width: `${pct}%`
                                                },
                                                "data-testid": `accounting-clinic-bar-${c.clinicId || 'none'}-${currency}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex gap-2.5 text-[0.6875rem] text-muted-foreground flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        t('accounting.totalLabel'),
                                                        " ",
                                                        formatMoney(c.grossTotal, {
                                                            currency: currency
                                                        }),
                                                        " ",
                                                        unit
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        t('accounting.collectedLabel'),
                                                        " ",
                                                        formatMoney(c.collectedDoctorShare, {
                                                            currency: currency
                                                        }),
                                                        " ",
                                                        unit
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        formatNumber(c.visitCount),
                                                        " ",
                                                        t('patient.visit'),
                                                        c.medicalServiceCount > 0 && ` \xb7 ${t('accounting.paraclinicalCount', {
                                                            count: c.medicalServiceCount
                                                        })}`,
                                                        c.productCount > 0 && ` \xb7 ${t('accounting.goodsCount', {
                                                            count: c.productCount
                                                        })}`
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, c.clinicId || 'none');
                            })
                        ]
                    }, currency);
                })
            })
        ]
    });
};
// Per-type roll-up computed by the BFF over the SAME whole-window filtered set as the
// KPI cards — not the visible page — so «جمع کل کارکرد» always equals the column of
// gross figures below it, whatever page the table is on.
// One row per (type, currency), grouped by currency like the clinic card above.
const $64da0901b95e72e4$var$TypeBreakdown = ({ types: types })=>{
    const { t: t, formatMoney: formatMoney, formatNumber: formatNumber, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    if (!types.length) return null;
    const groups = (0, $23af70c6e8945b15$export$f259c563cf34883d)(types);
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-2xl shadow-card p-6",
        "data-testid": "accounting-breakdown-type",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-[0.9375rem] font-extrabold text-foreground mb-1",
                children: t('accounting.byServiceType')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-xs text-muted-foreground mb-4",
                children: t('accounting.totalForRange')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-3",
                children: groups.map(({ currency: currency, rows: rows })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            mixed && /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$CurrencyHeading, {
                                currency: currency
                            }),
                            rows.map((line)=>{
                                const m = (0, $7105e29f5dc28eca$export$1468859f0798d24)(t)[line.itemType] || {
                                    label: line.itemType,
                                    Icon: (0, $8gMKa.default),
                                    color: (0, $jTCZr.C).textSecondary
                                };
                                const Icon = m.Icon;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2.5",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "w-[2.125rem] h-[2.125rem] rounded-[0.625rem] flex items-center justify-center shrink-0",
                                            style: {
                                                background: (0, $jTCZr.soft)(m.color, 0.1),
                                                color: m.color
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                size: 16,
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "flex-1 min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "text-[0.8125rem] font-bold text-foreground",
                                                    children: m.label
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "text-[0.6875rem] text-muted-foreground",
                                                    children: [
                                                        formatNumber(line.count),
                                                        " ",
                                                        t('common.units.item')
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "text-start",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "text-[0.8125rem] font-extrabold",
                                                    style: {
                                                        color: m.color
                                                    },
                                                    children: [
                                                        formatMoney(line.grossTotal, {
                                                            currency: currency
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-[0.625rem] font-semibold text-muted-foreground me-0.5",
                                                            children: moneyUnit(currency, 'short')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "text-[0.6875rem] text-muted-foreground",
                                                    children: line.doctorShareTotal != null ? (0, $7105e29f5dc28eca$export$5cafab1c4b1c0d4a)(line.doctorShareTotal, currency, t, formatMoney, moneyUnit) : t('accounting.noSplitRule')
                                                })
                                            ]
                                        })
                                    ]
                                }, line.itemType);
                            })
                        ]
                    }, currency))
            })
        ]
    });
};
const $64da0901b95e72e4$var$TypeBadge = ({ itemType: itemType })=>{
    const { t: t } = (0, $LNQP4.default)();
    const m = (0, $7105e29f5dc28eca$export$1468859f0798d24)(t)[itemType] || {
        label: itemType,
        Icon: (0, $8gMKa.default),
        color: (0, $jTCZr.C).textSecondary
    };
    const Icon = m.Icon;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "inline-flex items-center gap-1 rounded-md px-2 py-[0.1875rem] text-[0.6875rem] font-bold whitespace-nowrap",
        style: {
            background: (0, $jTCZr.soft)(m.color, 0.1),
            color: m.color
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 12,
                "aria-hidden": "true"
            }),
            m.label
        ]
    });
};
// ── Rows ────────────────────────────────────────────────────────────────────────
// Desktop table row (§5.1 real <table> semantics).
const $64da0901b95e72e4$var$LineRow = ({ line: line })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatMoney: formatMoney, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    // Each line is in its own invoice's currency; a table can hold two.
    const currency = line.currency;
    const unit = moneyUnit(currency, 'short');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
        className: "border-t border-border",
        "data-testid": `accounting-row-${line.id}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "px-5 py-3 text-xs text-muted-foreground whitespace-nowrap",
                children: (0, $7105e29f5dc28eca$export$d570a62256bab7b8)(line.createdAt, formatDate)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "px-5 py-3 text-xs text-muted-foreground max-w-[10rem] truncate",
                title: line.clinicName || undefined,
                children: line.clinicName || (line.clinicId ? "\u2014" : t('accounting.noClinic'))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                className: "px-5 py-3 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-[0.8125rem] font-bold text-foreground max-w-[16rem] truncate",
                        title: (0, $71e4a1bb85321be9$export$5764802ad0ccd8a0)(line.description, t),
                        children: [
                            (0, $71e4a1bb85321be9$export$5764802ad0ccd8a0)(line.description, t),
                            line.quantity > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-[0.6875rem] font-semibold text-muted-foreground me-1",
                                children: [
                                    "\xd7",
                                    formatDigits(line.quantity)
                                ]
                            })
                        ]
                    }),
                    line.patientName && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-[0.6875rem] text-muted-foreground mt-0.5",
                        children: line.patientName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "px-5 py-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$TypeBadge, {
                    itemType: line.itemType
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                className: "px-5 py-3 text-[0.8125rem] font-bold text-foreground whitespace-nowrap",
                children: [
                    formatMoney(line.grossAmount, {
                        currency: currency
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-[0.625rem] text-muted-foreground me-0.5",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: `px-5 py-3 text-[0.8125rem] font-extrabold whitespace-nowrap ${line.doctorShare == null ? 'text-muted-foreground' : 'text-clinic-teal'}`,
                children: line.doctorShare == null ? "\u2014" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        formatMoney(line.doctorShare, {
                            currency: currency
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[0.625rem] text-muted-foreground me-0.5",
                            children: unit
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "px-5 py-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                    status: line.settlementStatus
                })
            })
        ]
    });
};
// A settlement/table title bar reused by both the doctor's rows and the staff rows.
const $64da0901b95e72e4$var$TableHead = ()=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
            className: "bg-background border-b border-border",
            children: $64da0901b95e72e4$var$COLUMNS(t).map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    className: "sticky top-0 z-10 bg-background px-5 py-2.5 text-[0.6875rem] font-bold text-muted-foreground text-start whitespace-nowrap",
                    children: c.label
                }, c.id))
        })
    });
};
// ── KPIs ──────────────────────────────────────────────────────────────────────
// One currency's four KPI cards. `group` is one entry of `reportTotals` — every
// figure in it, `outstanding` included, is minor units of `group.currency`. The
// testids carry a currency suffix only when there is more than one group.
const $64da0901b95e72e4$var$KpiGroup = ({ group: group, skeleton: skeleton, suffix: suffix = '' })=>{
    const { t: t, formatMoney: formatMoney, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const { currency: currency } = group;
    const unit = moneyUnit(currency, 'short');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `accounting-kpi-gross${suffix}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                    label: t('accounting.grandTotal'),
                    value: formatMoney(group.grossTotal, {
                        currency: currency
                    }),
                    unit: unit,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l37hw.default), {
                        size: 22,
                        color: (0, $jTCZr.C).navy,
                        "aria-hidden": "true"
                    }),
                    bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                    accent: (0, $jTCZr.C).navy,
                    loading: skeleton
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `accounting-kpi-share${suffix}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                    label: t('accounting.yourShareNet'),
                    value: formatMoney(group.doctorShareTotal, {
                        currency: currency
                    }),
                    unit: unit,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fX0JO.default), {
                        size: 22,
                        color: (0, $jTCZr.C).teal,
                        "aria-hidden": "true"
                    }),
                    bg: (0, $jTCZr.C).tealLight,
                    accent: (0, $jTCZr.C).teal,
                    loading: skeleton
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `accounting-kpi-collected${suffix}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                    label: t('accounting.collected'),
                    value: formatMoney(group.collectedDoctorShare, {
                        currency: currency
                    }),
                    unit: unit,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                        size: 22,
                        color: (0, $jTCZr.C).green,
                        "aria-hidden": "true"
                    }),
                    bg: (0, $jTCZr.C).greenLight,
                    accent: (0, $jTCZr.C).green,
                    loading: skeleton
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `accounting-kpi-outstanding${suffix}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                    label: t('accounting.awaitingCollection'),
                    value: formatMoney(group.outstanding, {
                        currency: currency
                    }),
                    unit: unit,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                        size: 22,
                        color: (0, $jTCZr.CT).warnInk,
                        "aria-hidden": "true"
                    }),
                    bg: (0, $jTCZr.C).amberLight,
                    accent: (0, $jTCZr.CT).warnInk,
                    loading: skeleton
                })
            })
        ]
    });
};
// ── Screen ────────────────────────────────────────────────────────────────────
// `DEFAULTS` — the filter defaults (a param at its default is removed from the
// URL) — is shared with the mobile surface via `Accounting.shared`.
const $64da0901b95e72e4$var$AccountingWeb = ()=>{
    const { t: t, formatDate: formatDate, formatNumber: formatNumber, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    // URL → state (§3.2).
    const param = (k)=>searchParams.get(k) ?? (0, $7105e29f5dc28eca$export$f484e977a69c6ba6)[k];
    const tab = (0, $7105e29f5dc28eca$export$73b877b58963a4f)(t).some((item)=>item.id === param('settle')) ? param('settle') : 'ALL';
    const clinicId = param('clinic');
    const itemType = param('type');
    // The search term can be a patient's name, so it is the one filter kept OUT
    // of the URL (§3.2) — tab session state instead (lib/phiSearch).
    const [query, setQuery] = (0, $a26d9ceff6a9d412$export$fc4eac43d8254712)('accounting');
    const preset = param('preset');
    const custom = {
        from: param('from'),
        to: param('to')
    };
    const page = Math.max(1, parseInt(searchParams.get('page') || '1', 10) || 1);
    const staffPage = Math.max(1, parseInt(searchParams.get('spage') || '1', 10) || 1);
    const setParams = (patch, { resetPage: resetPage = true, replace: replace = false } = {})=>{
        const { q: q, ...urlPatch } = patch;
        if (q !== undefined) setQuery(q);
        const next = new URLSearchParams(searchParams);
        for (const [k, v] of Object.entries(urlPatch))if (v == null || v === '' || v === (0, $7105e29f5dc28eca$export$f484e977a69c6ba6)[k]) next.delete(k);
        else next.set(k, v);
        next.delete('q');
        if (resetPage) {
            next.delete('page');
            next.delete('spage');
        }
        if (next.toString() !== searchParams.toString()) setSearchParams(next, {
            replace: replace
        });
    };
    // Search echoes keystrokes instantly; the URL/query commits after the debounce (§8),
    // so the committed `query` is already the debounced value the server sees.
    const [search, setSearch] = (0, $acw62.useState)(query);
    const debounceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Resync only on a change from elsewhere (clear filters, a migrated old link):
    // committing '' for a 1-letter entry must not erase the letter just typed.
    const committedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(query);
    (0, $acw62.useEffect)(()=>{
        if (query !== committedRef.current) {
            committedRef.current = query;
            setSearch(query);
        }
    }, [
        query
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(debounceRef.current), []);
    const handleSearch = (val)=>{
        setSearch(val);
        clearTimeout(debounceRef.current);
        if (val === '') {
            committedRef.current = '';
            setParams({
                q: ''
            }, {
                replace: true
            });
            return;
        }
        // Below two characters the previous term is dropped, not kept in force.
        const commit = val.trim().length < 2 ? '' : val;
        debounceRef.current = setTimeout(()=>{
            committedRef.current = commit;
            setParams({
                q: commit
            }, {
                replace: true
            });
        }, 300);
    };
    // Preset/custom → epoch-ms window. `presetRange` returns null for the unbounded
    // «همه» preset; the hook maps a null bound to 0, which is exactly what the screen
    // sent before this refactor — so the data-fetch semantics are unchanged. An
    // incomplete custom range falls back to the default month so the list never
    // flickers to an empty window mid-edit.
    const range = (0, $acw62.useMemo)(()=>{
        if (preset === 'custom') return custom.from && custom.to ? (0, $bdd2cd30328e25bb$export$e319253fda62ab3b)(custom.from, custom.to) : (0, $bdd2cd30328e25bb$export$c1d4212a2686aaff)('month');
        return (0, $bdd2cd30328e25bb$export$c1d4212a2686aaff)(preset);
    }, [
        preset,
        custom.from,
        custom.to
    ]);
    const [exporting, setExporting] = (0, $acw62.useState)(false);
    const [showOthers, setShowOthers] = (0, $acw62.useState)(false); // disclosure = local UI state (§4.4)
    const clinics = (0, $2b6b2d11947b2299$export$f9eed3ff0df23e5c)();
    const { report: report, loading: loading, error: error, reload: reload, vars: vars } = (0, $2b6b2d11947b2299$export$fbd014276b792314)({
        range: range,
        clinicId: clinicId,
        itemType: itemType,
        settlement: tab,
        search: query,
        page: page,
        staffPage: staffPage
    });
    const rangeLabel = (0, $awevB.rangeLabelFor)(preset, custom.from, custom.to, (0, $bdd2cd30328e25bb$export$f38a867bdb4bba3d)(t));
    // The server already split the lists: `mine` is the doctor's own work (paginated),
    // `others` the clinic staff's — on the doctor's invoices, but never in a total.
    const mine = report.lines;
    const others = report.staffLines;
    const anyRows = report.linesTotal + report.staffLinesTotal > 0;
    // The KPI figures, one group per currency the counted lines are in — never one
    // figure across two. Each group carries `outstanding`, what the doctor is still
    // owed IN THAT CURRENCY: both terms come off the same server-filtered line set,
    // so it can never disagree with the two cards beside it. An empty report has no
    // currency of its own and states its zeros in the clinic's.
    const totals = (0, $23af70c6e8945b15$export$905ef9c201d869d1)(report, (0, $23af70c6e8945b15$export$dae2facd7e4f3419)(clinics, clinicId));
    const mixed = totals.length > 1;
    // Any non-default filter (the month window included).
    const hasActiveFilters = tab !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).settle || itemType !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).type || clinicId !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).clinic || query !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).q || preset !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).preset;
    const clearFilters = ()=>{
        setSearch('');
        setParams({
            settle: '',
            type: '',
            clinic: '',
            q: '',
            preset: '',
            from: '',
            to: ''
        });
    };
    // State contract (§2.4): skeleton on first load only; a refetch keeps the previous
    // rows visible, dimmed — never blanks to skeletons.
    const isEmpty = !loading && !error && !mine.length;
    const skeleton = loading && !mine.length;
    const stale = loading && mine.length > 0;
    const dataState = loading && !anyRows ? 'loading' : error ? 'error' : isEmpty ? 'empty' : 'content';
    // The CSV must keep meaning «everything in the filtered window», not «the rows that
    // happened to be loaded» — so it re-queries the same filters unpaginated.
    const onExport = async ()=>{
        setExporting(true);
        try {
            (0, $7105e29f5dc28eca$export$5462d920b006e1b3)(await (0, $2b6b2d11947b2299$export$a8a6fc5ab73285db)(vars), rangeLabel, t, formatDate);
        } catch (err) {
            console.error('CSV export failed:', err);
            toast.error(t('accounting.exportFailed'));
        } finally{
            setExporting(false);
        }
    };
    const clinicOptions = clinics.map((c)=>({
            value: c.id,
            label: c.name
        }));
    // Filtered-empty vs truly-empty (§2.4): a filtered-out list never claims the dataset
    // is empty. The default window is «این ماه», so the unfiltered copy speaks about the month.
    const emptyState = hasActiveFilters ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
            size: 52,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": "true"
        }),
        title: t('errors.empty.filters'),
        description: t('accounting.changeRangeOrFilters'),
        action: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: clearFilters,
            "data-testid": "accounting-empty-clear",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                    size: 15,
                    "aria-hidden": "true"
                }),
                t('encounters.clearFilters')
            ]
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYS9K.default), {
            size: 52,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": "true"
        }),
        title: t('accounting.noneInRange'),
        description: t('accounting.changeRangeHint')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col bg-background overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('nav.items.accounting'),
                sub: t('accounting.subtitle'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "icon",
                    onClick: reload,
                    "aria-label": t('errors.reload'),
                    title: t('errors.reload'),
                    "data-testid": "accounting-header-reload",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bF8pu.default), {
                        size: 18,
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-4 min-[769px]:px-8 py-6 flex flex-col gap-5",
                children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "accounting-error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        error: error,
                        title: t('accounting.unavailable'),
                        note: t('accounting.unavailableNote'),
                        onRetry: reload
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "accounting-content",
                    "data-state": dataState,
                    "aria-busy": loading || undefined,
                    className: "flex flex-col gap-5",
                    children: [
                        mixed ? // Lines in more than one currency: one KPI strip per currency, each
                        // headed by its currency's name. There is no combined figure — the
                        // BFF sends none, and there is no exchange rate to make one.
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            "data-testid": "accounting-kpis-by-currency",
                            className: `flex flex-col gap-4 transition-opacity ${stale ? 'opacity-[0.45]' : ''}`,
                            children: totals.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    "data-testid": `accounting-kpis-${group.currency}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-xs font-bold text-muted-foreground mb-2",
                                            children: moneyUnit(group.currency)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "grid grid-cols-1 min-[769px]:grid-cols-2 min-[1181px]:grid-cols-4 gap-3.5",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$KpiGroup, {
                                                group: group,
                                                skeleton: skeleton,
                                                suffix: `-${group.currency}`
                                            })
                                        })
                                    ]
                                }, group.currency))
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `grid grid-cols-1 min-[769px]:grid-cols-2 min-[1181px]:grid-cols-4 gap-3.5 transition-opacity ${stale ? 'opacity-[0.45]' : ''}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$KpiGroup, {
                                group: totals[0],
                                skeleton: skeleton
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "accounting-toolbar",
                            className: "bg-white rounded-2xl shadow-card px-4 py-3 flex flex-wrap items-center gap-2.5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-1 min-w-[12.5rem] max-w-[22rem]",
                                    "data-testid": "accounting-toolbar-search",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                        value: search,
                                        onChange: (e)=>handleSearch(e.target.value),
                                        placeholder: t('accounting.searchPlaceholder'),
                                        clearLabel: t('common.actions.clearSearch')
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                    items: (0, $7105e29f5dc28eca$export$73b877b58963a4f)(t),
                                    value: tab,
                                    onChange: (id)=>setParams({
                                            settle: id
                                        }),
                                    ariaLabel: t('accounting.settlementFilter'),
                                    testId: "accounting-toolbar-settlement"
                                }),
                                clinics.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "min-w-[10rem]",
                                    "data-testid": "accounting-toolbar-clinic",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                        value: clinicId,
                                        onChange: (e)=>setParams({
                                                clinic: e.target.value
                                            }),
                                        options: clinicOptions,
                                        placeholder: t('accounting.allClinics')
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "min-w-[9rem]",
                                    "data-testid": "accounting-toolbar-type",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                        value: itemType,
                                        onChange: (e)=>setParams({
                                                type: e.target.value
                                            }),
                                        options: (0, $7105e29f5dc28eca$export$dd86032c66b86dfb)(t),
                                        placeholder: t('accounting.allServices')
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "data-testid": "accounting-toolbar-daterange",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $awevB.default), {
                                        presets: (0, $bdd2cd30328e25bb$export$f38a867bdb4bba3d)(t),
                                        preset: preset,
                                        custom: custom,
                                        onPreset: (id)=>setParams({
                                                preset: id,
                                                from: '',
                                                to: ''
                                            }),
                                        onCustom: (from, to)=>setParams({
                                                preset: 'custom',
                                                from: from,
                                                to: to
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "flex-1"
                                }),
                                hasActiveFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                    variant: "ghost",
                                    size: "sm",
                                    onClick: clearFilters,
                                    "data-testid": "accounting-toolbar-clear",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                                            size: 15,
                                            "aria-hidden": "true"
                                        }),
                                        t('encounters.clearFilters')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: onExport,
                                    disabled: !anyRows || exporting,
                                    "data-testid": "accounting-toolbar-export",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5baafd2aed3f7e15$export$2e2bcd8739ae039), {
                                            size: 15,
                                            "aria-hidden": "true"
                                        }),
                                        exporting ? t('common.state.preparing') : t('accounting.excel')
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-1 min-[1181px]:grid-cols-[minmax(0,1fr)_20rem] gap-5 items-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-white rounded-2xl shadow-card overflow-hidden min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between px-5 pt-[1.125rem] pb-3.5 border-b border-border",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "text-[0.9375rem] font-extrabold text-foreground",
                                                    children: [
                                                        t('accounting.lineItems'),
                                                        report.linesTotal > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "text-xs font-semibold text-muted-foreground me-2",
                                                            children: [
                                                                "(",
                                                                formatNumber(report.linesTotal),
                                                                " ",
                                                                t('common.units.itemsSuffix')
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "text-xs text-muted-foreground",
                                                    children: rangeLabel
                                                })
                                            ]
                                        }),
                                        skeleton ? /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                            className: "w-full border-collapse",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$TableHead, {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                    children: Array.from({
                                                        length: 8
                                                    }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRow), {
                                                            cols: $64da0901b95e72e4$var$COLUMNS(t).length
                                                        }, i))
                                                })
                                            ]
                                        }) : isEmpty ? emptyState : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `overflow-x-auto transition-opacity ${stale ? 'opacity-[0.45] pointer-events-none' : ''}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "w-full border-collapse",
                                                "data-testid": "accounting-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$TableHead, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                        children: mine.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$LineRow, {
                                                                line: l
                                                            }, l.id))
                                                    })
                                                ]
                                            })
                                        }),
                                        !skeleton && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            "data-testid": "accounting-pager",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a27afae32c22d713$export$2e2bcd8739ae039), {
                                                page: page,
                                                pageCount: Math.ceil(report.linesTotal / (0, $f7753960a21756a4$export$8ec3d08588d2eeda)),
                                                total: report.linesTotal,
                                                pageSize: (0, $f7753960a21756a4$export$8ec3d08588d2eeda),
                                                onPage: (p)=>setParams({
                                                        page: p > 1 ? String(p) : ''
                                                    }, {
                                                        resetPage: false
                                                    })
                                            })
                                        }),
                                        report.staffLinesTotal > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "border-t border-border",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setShowOthers((s)=>!s),
                                                    "aria-expanded": showOthers,
                                                    "data-testid": "accounting-staff-toggle",
                                                    className: "w-full px-5 py-3 bg-background text-muted-foreground text-xs font-bold text-start flex items-center gap-1.5 hover:text-foreground transition-colors",
                                                    children: [
                                                        showOthers ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                                                            size: 14,
                                                            "aria-hidden": "true"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                                                            size: 14,
                                                            "aria-hidden": "true"
                                                        }),
                                                        formatNumber(report.staffLinesTotal),
                                                        " ",
                                                        t('accounting.performedByStaff'),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-semibold text-muted-foreground",
                                                            children: t('accounting.outsideYourShare')
                                                        })
                                                    ]
                                                }),
                                                showOthers && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `transition-opacity ${stale ? 'opacity-[0.45] pointer-events-none' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "overflow-x-auto",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                                className: "w-full border-collapse",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$TableHead, {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: others.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$LineRow, {
                                                                                line: l
                                                                            }, l.id))
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a27afae32c22d713$export$2e2bcd8739ae039), {
                                                            page: staffPage,
                                                            pageCount: Math.ceil(report.staffLinesTotal / (0, $f7753960a21756a4$export$8ec3d08588d2eeda)),
                                                            total: report.staffLinesTotal,
                                                            pageSize: (0, $f7753960a21756a4$export$8ec3d08588d2eeda),
                                                            onPage: (p)=>setParams({
                                                                    spage: p > 1 ? String(p) : ''
                                                                }, {
                                                                    resetPage: false
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `flex flex-col gap-5 transition-opacity ${stale ? 'opacity-[0.45]' : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$ClinicBreakdown, {
                                            clinics: report.clinics
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($64da0901b95e72e4$var$TypeBreakdown, {
                                            types: report.types
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $64da0901b95e72e4$export$2e2bcd8739ae039 = $64da0901b95e72e4$var$AccountingWeb;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");


var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $awevB = parcelRequire("awevB");
var $6usBW = parcelRequire("6usBW");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The mobile accounting report's line-item region while the first page is
// pending. The MobileHeader, summary (`MobileAccountingSummary loading`) and
// filters render for real; each placeholder is one `MobileAccountingLineCard`
// — the type chip and date on top, the service title, the amount row — at the
// card's real `0.75rem 0.875rem` padding. The desktop table uses the kit's
// `SkeletonRow` under its real header instead.
// ─────────────────────────────────────────────────────────────────────────────
const $6d517a25ca116ed1$var$LineCardSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.75rem 0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 64,
                        height: 20,
                        radius: (0, $jTCZr.RADIUS).chip
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 72,
                        height: 11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: `${48 + i * 17 % 32}%`,
                height: 14
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${26 + i * 11 % 20}%`,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 80,
                        height: 14
                    })
                ]
            })
        ]
    });
const $6d517a25ca116ed1$export$516ce993f9ddf8e0 = ({ count: count = 4, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "accounting-lines-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6d517a25ca116ed1$var$LineCardSkeleton, {
                i: i
            }, i))
    });
};
var $6d517a25ca116ed1$export$2e2bcd8739ae039 = $6d517a25ca116ed1$export$516ce993f9ddf8e0;



var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");
var $gYS9K = parcelRequire("gYS9K");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4e79cc7fca7ac647$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "3",
            rx: "2",
            key: "48i651"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "21",
            y2: "21",
            key: "1svkeh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "17",
            y2: "21",
            key: "vw1qmm"
        }
    ]
];
const $4e79cc7fca7ac647$export$2e2bcd8739ae039 = (0, $9QBug.default)("monitor", $4e79cc7fca7ac647$export$3efd853dbb351e94);


var $bF8pu = parcelRequire("bF8pu");
var $2VplL = parcelRequire("2VplL");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $kMJsW = parcelRequire("kMJsW");
var $fX0JO = parcelRequire("fX0JO");
var $l37hw = parcelRequire("l37hw");
// The mobile money hero (DESIGN-CONCEPT-MOBILE v2 §4B): the report's answer to
// «امروز چقدر شد؟», designed for a phone rather than shrunk from the desktop KPI
// grid. «سهم شما» is the headline; جمع کل / وصول‌شده / در انتظار وصول read as
// full-width footer rows. It sits below the gradient header (no overlap).
//
// totals: one entry per currency (lib/clinicMoney `reportTotals`), each
//   { currency, grossTotal, doctorShareTotal, collectedDoctorShare, outstanding }
//   in minor units of its own `currency`. One entry — every IRR-only doctor —
//   renders exactly the single hero it always did. Several entries render one
//   hero section per currency, each headed by the currency's name: a combined
//   figure across two currencies does not exist.
// A supporting figure — a full-width «label … value» row rather than a cramped
// 3-up tile, so a large toman amount can never force a horizontal scroll at
// 320px (§6). The value stays whole; the label ellipsises if anything must give.
const $e0d348a1a88512c2$var$Row = ({ Icon: Icon, label: label, value: value, unit: unit, color: color })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 14,
                color: color,
                "aria-hidden": true,
                style: {
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary,
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                },
                children: [
                    value,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textMuted,
                            marginInlineStart: '0.125rem'
                        },
                        children: unit
                    })
                ]
            })
        ]
    });
// One currency's hero: the share headline and its three supporting rows.
const $e0d348a1a88512c2$var$SummaryGroup = ({ group: group, loading: loading, heading: heading })=>{
    const { t: t, formatMoney: formatMoney, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const { currency: currency } = group;
    const share = formatMoney(group.doctorShareTotal, {
        currency: currency
    });
    const short = moneyUnit(currency, 'short');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": heading ? `accounting-summary-${currency}` : undefined,
        children: [
            heading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textSecondary,
                    marginBottom: '0.5rem'
                },
                children: moneyUnit(currency)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: '2.75rem',
                            height: '2.75rem',
                            borderRadius: '0.75rem',
                            flexShrink: 0,
                            background: (0, $jTCZr.C).tealLight,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fX0JO.default), {
                            size: 20,
                            color: (0, $jTCZr.C).teal,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: t('accounting.yourShareNet')
                            }),
                            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                                width: "7rem",
                                height: 22,
                                style: {
                                    marginTop: '0.25rem'
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: '1.375rem',
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).teal,
                                    lineHeight: 1.2
                                },
                                children: [
                                    share,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textMuted,
                                            marginInlineStart: '0.25rem'
                                        },
                                        children: moneyUnit(currency)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    marginTop: '0.875rem',
                    paddingTop: '0.75rem',
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e0d348a1a88512c2$var$Row, {
                        Icon: (0, $l37hw.default),
                        label: t('accounting.grandTotal'),
                        value: loading ? "\u2014" : formatMoney(group.grossTotal, {
                            currency: currency
                        }),
                        unit: short,
                        color: (0, $jTCZr.C).navy
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e0d348a1a88512c2$var$Row, {
                        Icon: (0, $8cb58a0e56c12463$export$2e2bcd8739ae039),
                        label: t('accounting.collected'),
                        value: loading ? "\u2014" : formatMoney(group.collectedDoctorShare, {
                            currency: currency
                        }),
                        unit: short,
                        color: (0, $jTCZr.C).green
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e0d348a1a88512c2$var$Row, {
                        Icon: (0, $kMJsW.default),
                        label: t('accounting.awaitingCollection'),
                        value: loading ? "\u2014" : formatMoney(group.outstanding, {
                            currency: currency
                        }),
                        unit: short,
                        color: (0, $jTCZr.CT).warnInk
                    })
                ]
            })
        ]
    });
};
const $e0d348a1a88512c2$var$MobileAccountingSummary = ({ totals: totals, loading: loading, stale: stale, testId: testId = 'accounting-summary' })=>{
    const groups = totals || [];
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            background: 'white',
            borderRadius: '1rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            padding: '1rem 1.125rem 0.875rem',
            transition: 'opacity 0.2s',
            opacity: stale ? 0.6 : 1,
            ...mixed ? {
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem'
            } : null
        },
        children: groups.map((group, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: i > 0 ? {
                    paddingTop: '1rem',
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                } : undefined,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e0d348a1a88512c2$var$SummaryGroup, {
                    group: group,
                    loading: loading,
                    heading: mixed
                })
            }, group.currency))
    });
};
var $e0d348a1a88512c2$export$2e2bcd8739ae039 = $e0d348a1a88512c2$var$MobileAccountingSummary;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");

var $6Md3F = parcelRequire("6Md3F");
var $3SiwN = parcelRequire("3SiwN");

// The mobile accounting filter bar (DESIGN-CONCEPT-MOBILE v2 §6). The two most
// frequent controls stay inline and one-tap — the free-text search and the
// settlement segment («چقدر تسویه نشده؟» is a core reason to open this screen).
// Everything else (date range, service type, clinic) is a BottomSheet, the
// mobile default overlay for filters, reached from two labelled buttons so the
// bar never crowds a 320px width.
// Short settlement labels — the desktop tabs' full wording («در انتظار تسویه»)
// won't sit three-up on a phone. Same ids the report speaks.
const $51cf748f3e00045b$var$SETTLE_TABS = (t)=>[
        {
            id: 'ALL',
            label: t('common.state.all')
        },
        {
            id: 'PENDING',
            label: t('common.state.pending')
        },
        {
            id: 'SETTLED',
            label: t('common.settlement.SETTLED')
        }
    ];
const $51cf748f3e00045b$var$MobileAccountingFilters = ({ search: search, onSearch: onSearch, tab: tab, onTab: onTab, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom, presets: presets, rangeLabel: rangeLabel, itemType: itemType, onType: onType, clinicId: clinicId, onClinic: onClinic, clinics: clinics = [], activeCount: activeCount = 0, onClear: onClear })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Custom-range draft — committed only when both ends are set.
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        from: custom.from || '',
        to: custom.to || ''
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft({
            from: custom.from || '',
            to: custom.to || ''
        });
    }, [
        custom.from,
        custom.to
    ]);
    const clinicOptions = clinics.map((c)=>({
            value: c.id,
            label: c.name
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        "data-testid": "accounting-toolbar",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "accounting-toolbar-search",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                    value: search,
                    onChange: (e)=>onSearch(e.target.value),
                    placeholder: t('accounting.searchPlaceholder'),
                    clearLabel: t('common.actions.clearSearch')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tablist",
                "aria-label": t('accounting.settlementFilter'),
                "data-testid": "accounting-toolbar-settlement",
                style: {
                    display: 'flex',
                    gap: '0.375rem'
                },
                children: $51cf748f3e00045b$var$SETTLE_TABS(t).map((item)=>{
                    const active = tab === item.id;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        role: "tab",
                        "aria-selected": active,
                        variant: active ? 'default' : 'outline',
                        size: "sm",
                        className: "flex-1 min-h-11 px-2",
                        "data-testid": `accounting-toolbar-settlement-${item.id}`,
                        onClick: ()=>onTab(item.id),
                        children: item.label
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setRangeOpen(true),
                        "data-testid": "accounting-toolbar-range",
                        className: "flex-1 min-h-11 justify-start gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Md3F.default), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: rangeLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setMoreOpen(true),
                        "data-testid": "accounting-toolbar-more",
                        className: "flex-1 min-h-11 justify-start gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cf9022b4ea6e252$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('common.actions.filters'),
                            activeCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginInlineStart: 'auto',
                                    minWidth: '1.25rem',
                                    height: '1.25rem',
                                    borderRadius: '0.75rem',
                                    background: (0, $jTCZr.C).navy,
                                    color: 'white',
                                    fontSize: '0.6875rem',
                                    fontWeight: 800,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 0.375rem'
                                },
                                children: formatDigits(activeCount)
                            })
                        ]
                    })
                ]
            }),
            activeCount > 0 && onClear && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                onClick: onClear,
                "data-testid": "accounting-toolbar-clear",
                className: "self-start min-h-11 gap-1.5 text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    t('accounting.clearAllFilters')
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cZOyb.default), {
                open: rangeOpen,
                onClose: ()=>setRangeOpen(false),
                title: t('common.labels.dateRange'),
                closeLabel: t('common.actions.close'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.5rem'
                        },
                        "data-testid": "accounting-range-presets",
                        children: presets.map((p)=>{
                            const active = preset === p.id;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: active ? 'default' : 'outline',
                                size: "sm",
                                className: "min-h-11",
                                onClick: ()=>{
                                    onPreset(p.id);
                                    setRangeOpen(false);
                                },
                                children: p.label
                            }, p.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginTop: '1rem',
                            paddingTop: '1rem',
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginBottom: '0.5rem'
                                },
                                children: t('common.labels.customRange')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                            value: draft.from,
                                            onChange: (v)=>setDraft((d)=>({
                                                        ...d,
                                                        from: v
                                                    })),
                                            placeholder: t('common.labels.fromDate'),
                                            disableFuture: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                            value: draft.to,
                                            onChange: (v)=>setDraft((d)=>({
                                                        ...d,
                                                        to: v
                                                    })),
                                            placeholder: t('common.labels.toDate'),
                                            disableFuture: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "default",
                                className: "mt-3 w-full min-h-11",
                                disabled: !draft.from || !draft.to,
                                onClick: ()=>{
                                    onCustom(draft.from, draft.to);
                                    setRangeOpen(false);
                                },
                                children: t('accounting.applyCustomRange')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cZOyb.default), {
                open: moreOpen,
                onClose: ()=>setMoreOpen(false),
                title: t('common.actions.filters'),
                closeLabel: t('common.actions.close'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            style: {
                                display: 'block'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textMuted,
                                        display: 'block',
                                        marginBottom: '0.375rem'
                                    },
                                    children: t('accounting.serviceType')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                    value: itemType,
                                    onChange: (e)=>onType(e.target.value),
                                    options: (0, $7105e29f5dc28eca$export$dd86032c66b86dfb)(t),
                                    placeholder: t('accounting.allServices')
                                })
                            ]
                        }),
                        clinics.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            style: {
                                display: 'block'
                            },
                            "data-testid": "accounting-filter-clinic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textMuted,
                                        display: 'block',
                                        marginBottom: '0.375rem'
                                    },
                                    children: t('common.labels.clinic')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                    value: clinicId,
                                    onChange: (e)=>onClinic(e.target.value),
                                    options: clinicOptions,
                                    placeholder: t('accounting.allClinics')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "default",
                            className: "w-full min-h-11",
                            onClick: ()=>setMoreOpen(false),
                            children: t('accounting.viewResults')
                        }),
                        activeCount > 0 && onClear && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            className: "w-full min-h-11 gap-1.5 text-muted-foreground",
                            onClick: ()=>{
                                onClear();
                                setMoreOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3SiwN.default), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                t('accounting.clearAllFilters')
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $51cf748f3e00045b$export$2e2bcd8739ae039 = $51cf748f3e00045b$var$MobileAccountingFilters;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $8gMKa = parcelRequire("8gMKa");


var $jTCZr = parcelRequire("jTCZr");

// One accounting line as a mobile card (DESIGN-CONCEPT-MOBILE v2 §5). A ledger
// entry is a read — no tap target — so it renders as a plain card, not a Button:
// type badge + settlement pill on top, the service description, then a meta line
// (date · clinic · patient) and the two money figures (کل · سهم شما), both in the
// line's own invoice currency (`line.currency`; blank reads IRR).
const $3ae6dbb6c5ed3212$var$TypeBadge = ({ itemType: itemType })=>{
    const { t: t } = (0, $LNQP4.default)();
    const m = (0, $7105e29f5dc28eca$export$1468859f0798d24)(t)[itemType] || {
        label: itemType,
        Icon: (0, $8gMKa.default),
        color: (0, $jTCZr.C).textSecondary
    };
    const Icon = m.Icon;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            borderRadius: '0.375rem',
            padding: '0.1875rem 0.5rem',
            fontSize: '0.6875rem',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            background: (0, $jTCZr.soft)(m.color, 0.1),
            color: m.color
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 12,
                "aria-hidden": true
            }),
            m.label
        ]
    });
};
const $3ae6dbb6c5ed3212$var$MobileAccountingLineCard = ({ line: line, testId: testId })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatMoney: formatMoney, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const { currency: currency } = line;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            background: 'white',
            borderRadius: '0.875rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            padding: '0.75rem 0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3ae6dbb6c5ed3212$var$TypeBadge, {
                        itemType: line.itemType
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                        status: line.settlementStatus
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: '0.25rem'
                },
                children: [
                    (0, $71e4a1bb85321be9$export$5764802ad0ccd8a0)(line.description, t),
                    line.quantity > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textMuted,
                            marginInlineStart: '0.25rem'
                        },
                        children: [
                            "\xd7",
                            formatDigits(line.quantity)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.5rem'
                },
                children: [
                    (0, $7105e29f5dc28eca$export$d570a62256bab7b8)(line.createdAt, formatDate),
                    " \xb7 ",
                    line.clinicName || t('accounting.noClinic'),
                    line.patientName && ` \xb7 ${line.patientName}`
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.875rem',
                    fontSize: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: [
                            t('accounting.totalLabel'),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                style: {
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: [
                                    formatMoney(line.grossAmount, {
                                        currency: currency
                                    }),
                                    " ",
                                    moneyUnit(currency, 'short')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            color: (0, $jTCZr.C).teal
                        },
                        children: [
                            t('accounting.yourShareLabel'),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: line.doctorShare == null ? "\u2014" : (0, $7105e29f5dc28eca$export$4368c02066be5ea3)(line.doctorShare, currency, t, formatMoney, moneyUnit)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3ae6dbb6c5ed3212$export$2e2bcd8739ae039 = $3ae6dbb6c5ed3212$var$MobileAccountingLineCard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $acw62 = parcelRequire("acw62");

var $8gMKa = parcelRequire("8gMKa");

var $jTCZr = parcelRequire("jTCZr");

// The «به تفکیک …» breakdowns as mobile cards (DESIGN-CONCEPT-MOBILE v2 §5) — the
// desktop rail's two cards, re-laid-out for a single narrow column rather than a
// 320px sidebar. Answers the doctor's «کدام مطب چقدر؟» / «کدام خدمت چقدر؟» glance.
const $6f691fabfac9d21e$var$Card = ({ title: title, sub: sub, children: children, testId: testId })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            background: 'white',
            borderRadius: '1rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            padding: '1rem 1.125rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.875rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: '0.125rem'
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.875rem'
                },
                children: sub
            }),
            children
        ]
    });
// Rows come one per (key, currency), IRR first. With more than one currency each
// currency's rows are headed by its name, and a clinic bar is scaled against the
// largest bar IN ITS CURRENCY — never across (no exchange rate exists to compare
// a dirham bar with a toman one).
const $6f691fabfac9d21e$var$CurrencyHeading = ({ currency: currency })=>{
    const { moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textSecondary
        },
        "data-testid": `accounting-currency-heading-${currency}`,
        children: moneyUnit(currency)
    });
};
const $6f691fabfac9d21e$var$ClinicRows = ({ clinics: clinics })=>{
    const { t: t, formatMoney: formatMoney, formatNumber: formatNumber, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const groups = (0, $23af70c6e8945b15$export$f259c563cf34883d)(clinics);
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        },
        children: groups.map(({ currency: currency, rows: rows })=>{
            const max = (0, $23af70c6e8945b15$export$174cf94db2560bb)(rows);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                children: [
                    mixed && /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$CurrencyHeading, {
                        currency: currency
                    }),
                    rows.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        marginBottom: '0.375rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0,
                                                fontSize: '0.8125rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: c.clinicName || (c.clinicId ? t('accounting.unknownClinic') : t('accounting.noClinic'))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).teal,
                                                flexShrink: 0
                                            },
                                            children: [
                                                formatMoney(c.doctorShareTotal, {
                                                    currency: currency
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: '0.625rem',
                                                        fontWeight: 600,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginInlineStart: '0.125rem'
                                                    },
                                                    children: moneyUnit(currency, 'short')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        height: '0.375rem',
                                        background: (0, $jTCZr.C).bg,
                                        borderRadius: '0.25rem',
                                        overflow: 'hidden',
                                        marginBottom: '0.375rem'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            height: '100%',
                                            background: (0, $jTCZr.C).teal,
                                            borderRadius: '0.25rem',
                                            width: `${c.grossTotal / max * 100}%`,
                                            transition: 'width 0.5s'
                                        },
                                        "data-testid": `accounting-clinic-bar-${c.clinicId || 'none'}-${currency}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: [
                                        formatNumber(c.visitCount),
                                        " ",
                                        t('patient.visit'),
                                        c.medicalServiceCount > 0 && ` \xb7 ${t('accounting.paraclinicalCount', {
                                            count: c.medicalServiceCount
                                        })}`,
                                        c.productCount > 0 && ` \xb7 ${t('accounting.goodsCount', {
                                            count: c.productCount
                                        })}`
                                    ]
                                })
                            ]
                        }, c.clinicId || 'none'))
                ]
            }, currency);
        })
    });
};
const $6f691fabfac9d21e$var$TypeRows = ({ types: types })=>{
    const { t: t, formatMoney: formatMoney, formatNumber: formatNumber, moneyUnit: moneyUnit } = (0, $LNQP4.default)();
    const groups = (0, $23af70c6e8945b15$export$f259c563cf34883d)(types);
    const mixed = groups.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        },
        children: groups.map(({ currency: currency, rows: rows })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                children: [
                    mixed && /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$CurrencyHeading, {
                        currency: currency
                    }),
                    rows.map((line)=>{
                        // An itemType the accounting service has not typed falls through to its
                        // raw code rather than blanking the row.
                        const m = (0, $7105e29f5dc28eca$export$1468859f0798d24)(t)[line.itemType] || {
                            label: line.itemType,
                            Icon: (0, $8gMKa.default),
                            color: (0, $jTCZr.C).textSecondary
                        };
                        const Icon = m.Icon;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.625rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        width: '2.125rem',
                                        height: '2.125rem',
                                        borderRadius: '0.625rem',
                                        flexShrink: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: (0, $jTCZr.soft)(m.color, 0.1),
                                        color: m.color
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                        size: 16,
                                        "aria-hidden": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: m.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: [
                                                formatNumber(line.count),
                                                " ",
                                                t('common.units.item')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        textAlign: 'start',
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                fontWeight: 800,
                                                color: m.color
                                            },
                                            children: [
                                                formatMoney(line.grossTotal, {
                                                    currency: currency
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: '0.625rem',
                                                        fontWeight: 600,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginInlineStart: '0.125rem'
                                                    },
                                                    children: moneyUnit(currency, 'short')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: line.doctorShareTotal != null ? (0, $7105e29f5dc28eca$export$5cafab1c4b1c0d4a)(line.doctorShareTotal, currency, t, formatMoney, moneyUnit) : t('accounting.noSplitRule')
                                        })
                                    ]
                                })
                            ]
                        }, line.itemType);
                    })
                ]
            }, currency))
    });
};
const $6f691fabfac9d21e$var$MobileAccountingBreakdown = ({ clinics: clinics = [], types: types = [] })=>{
    const { t: t } = (0, $LNQP4.default)();
    if (!clinics.length && !types.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        },
        "data-testid": "accounting-breakdown",
        children: [
            types.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$Card, {
                title: t('accounting.byServiceType'),
                sub: t('accounting.totalForRange'),
                testId: "accounting-breakdown-type",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$TypeRows, {
                    types: types
                })
            }),
            clinics.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$Card, {
                title: t('accounting.byClinic'),
                sub: t('accounting.shareByClinic'),
                testId: "accounting-breakdown-clinic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6f691fabfac9d21e$var$ClinicRows, {
                    clinics: clinics
                })
            })
        ]
    });
};
var $6f691fabfac9d21e$export$2e2bcd8739ae039 = $6f691fabfac9d21e$var$MobileAccountingBreakdown;





// ─────────────────────────────────────────────────────────────────────────────
// Accounting — the mobile report (DESIGN-CONCEPT-MOBILE v2 §1.1, reached by
// tapping the پذیرش income card, WIREFRAME-MOBILE-ACCOUNTING-ACCESS.md).
//
// An independent, app-like surface — NOT the desktop table under a media query.
// It opens with the gradient header (back to پذیرش + «حسابداری» title),
// leads with the money hero (سهم شما), keeps the two most-used filters inline
// with the rest in a BottomSheet, and lists the doctor's own lines as cards that
// grow through «نمایش بیشتر». Behaviour comes from the SAME `useAccounting` hook
// the desktop screen uses — the two surfaces look nothing alike but never
// disagree on a number.
// ─────────────────────────────────────────────────────────────────────────────
const $224a6ec8a6588a98$var$AccountingMobile = ()=>{
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    // Filter state lives in the URL — the same param names and defaults as the
    // desktop screen (§3.2: the URL is the filter state), so a refresh restores the
    // exact view and the two surfaces can even swap a link. A param at its default
    // is removed; `replace` keeps filter churn out of the history stack. Only the
    // load-more page stays local: the accumulation model can't replay page N alone.
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const param = (k)=>searchParams.get(k) ?? (0, $7105e29f5dc28eca$export$f484e977a69c6ba6)[k];
    const tab = param('settle');
    const itemType = param('type');
    const clinicId = param('clinic');
    const preset = param('preset');
    const custom = {
        from: param('from'),
        to: param('to')
    };
    // Search stays out of the URL — see Accounting.web.jsx / lib/phiSearch.
    const [query, setQuery] = (0, $a26d9ceff6a9d412$export$fc4eac43d8254712)('accounting');
    const setParams = (patch)=>{
        const { q: q, ...urlPatch } = patch;
        if (q !== undefined) setQuery(q);
        const next = new URLSearchParams(searchParams);
        for (const [k, v] of Object.entries(urlPatch))if (v == null || v === '' || v === (0, $7105e29f5dc28eca$export$f484e977a69c6ba6)[k]) next.delete(k);
        else next.set(k, v);
        next.delete('q');
        if (next.toString() !== searchParams.toString()) setSearchParams(next, {
            replace: true
        });
    };
    const setTab = (v)=>setParams({
            settle: v
        });
    const setItemType = (v)=>setParams({
            type: v
        });
    const setClinicId = (v)=>setParams({
            clinic: v
        });
    // Preset and custom bounds move together — one URL write, no read-race.
    const onPreset = (id)=>setParams({
            preset: id,
            from: '',
            to: ''
        });
    const onCustom = (from, to)=>setParams({
            preset: 'custom',
            from: from,
            to: to
        });
    // Search echoes keystrokes instantly; the URL `q` commits after the debounce.
    const [search, setSearch] = (0, $acw62.useState)(query);
    const dRef = (0, $acw62.useRef)(null);
    const committedRef = (0, $acw62.useRef)(query); // see Accounting.web.jsx
    (0, $acw62.useEffect)(()=>{
        if (query !== committedRef.current) {
            committedRef.current = query;
            setSearch(query);
        }
    }, [
        query
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(dRef.current), []);
    const onSearch = (val)=>{
        setSearch(val);
        clearTimeout(dRef.current);
        if (val === '') {
            committedRef.current = '';
            setParams({
                q: ''
            });
            return;
        }
        const commit = val.trim().length < 2 ? '' : val;
        dRef.current = setTimeout(()=>{
            committedRef.current = commit;
            setParams({
                q: commit
            });
        }, 300);
    };
    // Preset/custom → epoch-ms window (same helpers the desktop screen uses).
    const range = (0, $acw62.useMemo)(()=>{
        if (preset === 'custom') return custom.from && custom.to ? (0, $bdd2cd30328e25bb$export$e319253fda62ab3b)(custom.from, custom.to) : (0, $bdd2cd30328e25bb$export$c1d4212a2686aaff)('month');
        return (0, $bdd2cd30328e25bb$export$c1d4212a2686aaff)(preset);
    }, [
        preset,
        custom.from,
        custom.to
    ]);
    const clinics = (0, $2b6b2d11947b2299$export$f9eed3ff0df23e5c)();
    // Load-more accumulation for the doctor's own lines: bump `page`, append the
    // fresh rows. Aggregates (summary, breakdowns) always read straight off the
    // whole-window `report`, so they never track this paging.
    const [page, setPage] = (0, $acw62.useState)(1);
    const [acc, setAcc] = (0, $acw62.useState)([]);
    const filterKey = JSON.stringify({
        tab: tab,
        itemType: itemType,
        clinicId: clinicId,
        preset: preset,
        from: custom.from,
        to: custom.to,
        query: query
    });
    (0, $acw62.useEffect)(()=>{
        setPage(1);
        setAcc([]);
    }, [
        filterKey
    ]);
    const { report: report, loading: loading, error: error, reload: reload, vars: vars } = (0, $2b6b2d11947b2299$export$fbd014276b792314)({
        range: range,
        clinicId: clinicId,
        itemType: itemType,
        settlement: tab,
        search: query,
        page: page,
        staffPage: 1
    });
    (0, $acw62.useEffect)(()=>{
        if (loading || error) return;
        setAcc((prev)=>{
            // A page-1 result replaces (new filter/window); later pages append.
            const base = (report.page ?? 1) <= 1 ? [] : prev;
            const seen = new Set(base.map((l)=>l.id));
            const add = report.lines.filter((l)=>!seen.has(l.id));
            return base.length !== prev.length || add.length ? [
                ...base,
                ...add
            ] : prev;
        });
    }, [
        report,
        loading,
        error
    ]);
    const rangeLabel = (0, $awevB.rangeLabelFor)(preset, custom.from, custom.to, (0, $bdd2cd30328e25bb$export$f38a867bdb4bba3d)(t));
    // One summary group per currency, each with its own `outstanding` — never a
    // figure across two currencies. An empty report states its zeros in the
    // selected (or only) clinic's currency.
    const totals = (0, $23af70c6e8945b15$export$905ef9c201d869d1)(report, (0, $23af70c6e8945b15$export$dae2facd7e4f3419)(clinics, clinicId));
    const anyRows = report.linesTotal + report.staffLinesTotal > 0;
    const hasMore = acc.length < report.linesTotal;
    const hasActiveFilters = tab !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).settle || itemType !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).type || clinicId !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).clinic || query !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).q || preset !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).preset;
    const activeCount = (tab !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).settle ? 1 : 0) + (itemType !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).type ? 1 : 0) + (clinicId !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).clinic ? 1 : 0) + (preset !== (0, $7105e29f5dc28eca$export$f484e977a69c6ba6).preset ? 1 : 0);
    const clearFilters = ()=>{
        setSearch('');
        setParams({
            settle: '',
            type: '',
            clinic: '',
            q: '',
            preset: '',
            from: '',
            to: ''
        });
    };
    // State contract (§7): skeleton on the first load only; a refetch dims the
    // previous rows rather than blanking to skeletons.
    const skeleton = loading && acc.length === 0;
    const stale = loading && acc.length > 0;
    const isEmpty = !loading && !error && acc.length === 0;
    const dataState = loading && !anyRows ? 'loading' : error ? 'error' : isEmpty ? 'empty' : 'content';
    // Staff-performed lines: on the doctor's invoice, never in a total. The first
    // page shows here; the tail stays desktop-first (§1) rather than silently hidden.
    const [showStaff, setShowStaff] = (0, $acw62.useState)(false);
    const staffShown = report.staffLines || [];
    const staffHidden = Math.max(0, report.staffLinesTotal - staffShown.length);
    const [exporting, setExporting] = (0, $acw62.useState)(false);
    const onExport = async ()=>{
        setExporting(true);
        try {
            // Three outcomes, and they are three different sentences (finding 19).
            // An installed iOS PWA has no download UI at all, so the anchor path is a
            // silent no-op there — the doctor pressed export and nothing happened,
            // twice, before giving up. The share sheet is the platform's own answer;
            // where there is neither, saying so is the only honest option.
            const outcome = await (0, $7105e29f5dc28eca$export$5462d920b006e1b3)(await (0, $2b6b2d11947b2299$export$a8a6fc5ab73285db)(vars), rangeLabel, t, formatDate);
            if (outcome === 'unsupported') toast.warn(t('accounting.exportDesktopOnly'));
            else if (outcome === 'shared') toast.success(t('accounting.exportShared'));
        } catch (err) {
            console.error('CSV export failed:', err);
            toast.error(t('accounting.exportFailed'));
        } finally{
            setExporting(false);
        }
    };
    // Header quick actions resolve to a destination (§3.2): export appears only
    // when there is something to export.
    const actions = [
        ...anyRows ? [
            {
                key: 'export',
                Icon: (0, $5baafd2aed3f7e15$export$2e2bcd8739ae039),
                label: t('accounting.exportExcel'),
                onClick: onExport
            }
        ] : [],
        {
            key: 'reload',
            Icon: (0, $bF8pu.default),
            label: t('errors.reload'),
            onClick: reload
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    title: t('nav.items.accounting'),
                    actions: actions
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: '1.5rem'
                },
                children: [
                    !error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0.875rem 0.875rem 0'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0d348a1a88512c2$export$2e2bcd8739ae039), {
                            totals: totals,
                            loading: skeleton,
                            stale: stale
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0.875rem 0.875rem 0'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51cf748f3e00045b$export$2e2bcd8739ae039), {
                            search: search,
                            onSearch: onSearch,
                            tab: tab,
                            onTab: setTab,
                            preset: preset,
                            custom: custom,
                            onPreset: onPreset,
                            onCustom: onCustom,
                            presets: (0, $bdd2cd30328e25bb$export$f38a867bdb4bba3d)(t),
                            rangeLabel: rangeLabel,
                            itemType: itemType,
                            onType: setItemType,
                            clinicId: clinicId,
                            onClinic: setClinicId,
                            clinics: clinics,
                            activeCount: activeCount,
                            onClear: clearFilters
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0.875rem'
                        },
                        "data-testid": "accounting-content",
                        "data-state": dataState,
                        "aria-busy": loading || undefined,
                        children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                            error: error,
                            title: t('accounting.unavailable'),
                            note: t('accounting.unavailableNote'),
                            onRetry: reload
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        justifyContent: 'space-between',
                                        gap: '0.5rem',
                                        marginBottom: '0.625rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                fontSize: '0.90625rem',
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: [
                                                t('accounting.lineItems'),
                                                report.linesTotal > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    style: {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 600,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginInlineStart: '0.5rem'
                                                    },
                                                    children: [
                                                        "(",
                                                        formatNumber(report.linesTotal),
                                                        " ",
                                                        t('common.units.itemsSuffix')
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textMuted,
                                                flexShrink: 0
                                            },
                                            children: rangeLabel
                                        })
                                    ]
                                }),
                                skeleton ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d517a25ca116ed1$export$516ce993f9ddf8e0), {
                                    count: 4
                                }) : isEmpty ? hasActiveFilters ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                                        size: 48,
                                        color: (0, $jTCZr.C).textMuted,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: t('errors.empty.filters'),
                                    description: t('accounting.changeRangeOrFilters'),
                                    action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                        variant: "outline",
                                        size: "sm",
                                        className: "min-h-11",
                                        onClick: clearFilters,
                                        "data-testid": "accounting-empty-clear",
                                        children: t('encounters.clearFilters')
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYS9K.default), {
                                        size: 48,
                                        color: (0, $jTCZr.C).textMuted,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: t('accounting.noneInRange'),
                                    description: t('accounting.changeRangeHint')
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '0.625rem',
                                        transition: 'opacity 0.2s',
                                        opacity: stale ? 0.45 : 1,
                                        pointerEvents: stale ? 'none' : undefined
                                    },
                                    children: [
                                        acc.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ae6dbb6c5ed3212$export$2e2bcd8739ae039), {
                                                line: l,
                                                testId: `accounting-row-${l.id}`
                                            }, l.id)),
                                        hasMore && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            variant: "outline",
                                            className: "w-full min-h-11",
                                            "data-testid": "accounting-more",
                                            onClick: ()=>setPage((p)=>p + 1),
                                            children: [
                                                t('common.actions.showMorePrefix'),
                                                formatNumber(report.linesTotal - acc.length),
                                                " ",
                                                t('common.units.moreItemsSuffix')
                                            ]
                                        })
                                    ]
                                }),
                                report.staffLinesTotal > 0 && !skeleton && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginTop: '1rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            variant: "ghost",
                                            className: "w-full min-h-11 justify-start gap-1.5 text-muted-foreground",
                                            "aria-expanded": showStaff,
                                            "data-testid": "accounting-staff-toggle",
                                            onClick: ()=>setShowStaff((s)=>!s),
                                            children: [
                                                showStaff ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                                                    size: 15,
                                                    "aria-hidden": true
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                                                    size: 15,
                                                    "aria-hidden": true,
                                                    style: (0, $asXy3.MIRROR_ICON)
                                                }),
                                                formatNumber(report.staffLinesTotal),
                                                " ",
                                                t('accounting.byClinicStaffCount'),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: t('accounting.outsideYourShare')
                                                })
                                            ]
                                        }),
                                        showStaff && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '0.625rem',
                                                marginTop: '0.625rem'
                                            },
                                            children: [
                                                staffShown.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ae6dbb6c5ed3212$export$2e2bcd8739ae039), {
                                                        line: l,
                                                        testId: `accounting-staff-row-${l.id}`
                                                    }, l.id)),
                                                staffHidden > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.5rem',
                                                        padding: '0.625rem 0.75rem',
                                                        borderRadius: '0.75rem',
                                                        background: (0, $jTCZr.C).bg,
                                                        border: `1px dashed ${(0, $jTCZr.C).border}`,
                                                        fontSize: '0.6875rem',
                                                        color: (0, $jTCZr.C).textMuted
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e79cc7fca7ac647$export$2e2bcd8739ae039), {
                                                            size: 15,
                                                            "aria-hidden": true
                                                        }),
                                                        formatNumber(staffHidden),
                                                        " ",
                                                        t('accounting.moreOnDesktop')
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !skeleton && !isEmpty && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        marginTop: '1rem',
                                        opacity: stale ? 0.45 : 1,
                                        transition: 'opacity 0.2s'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f691fabfac9d21e$export$2e2bcd8739ae039), {
                                        clinics: report.clinics,
                                        types: report.types
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $224a6ec8a6588a98$export$2e2bcd8739ae039 = $224a6ec8a6588a98$var$AccountingMobile;


// DESIGN-CONCEPT-MOBILE v2 §1.1: the two surfaces are independent render trees
// over one shared logic layer (`useAccounting` + `Accounting.shared`), not a
// responsive tier of the desktop table.
const $251c592fded843de$var$AccountingScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $224a6ec8a6588a98$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $64da0901b95e72e4$export$2e2bcd8739ae039), {});
};
var $251c592fded843de$export$2e2bcd8739ae039 = $251c592fded843de$var$AccountingScreen;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $kyZIh = parcelRequire("kyZIh");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");





var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $acw62 = parcelRequire("acw62");

// ─────────────────────────────────────────────────────────────────────────────
// «صفحهٔ من» — the page builder's one data layer (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md
// §8, BFF typeDefs/doctorPage.js). Both surfaces render from it.
//
// Every write answers with the whole page, which REPLACES the local copy: the
// service decides what was saved (and re-derives the publish blockers and the
// «تغییرات منتشر نشده» flag), so the screen never shows a guess.
//
// Per-card save state: each write names the card that made it (`key`), and
// the hook tracks `saving` / `error` / `savedAt` per key — so the hero card
// can say «ذخیره شد» while the office card is still «در حال ذخیره».
// Writes are never retried automatically (DESIGN_CONCEPT §14.2).
// ─────────────────────────────────────────────────────────────────────────────
const $3b62335a4d4d6420$var$MEDIA = 'id slot fileId url alt sortOrder refId';
const $3b62335a4d4d6420$export$e95bd389f8ebddb4 = `
  id slug slugLocked templateId theme status
  displayName headline aboutMd
  portrait { ${$3b62335a4d4d6420$var$MEDIA} }
  cover { ${$3b62335a4d4d6420$var$MEDIA} }
  contact
  sections { kind enabled sortOrder titleOverride content supportedByTemplate required }
  articles { id slug slugLocked title bodyMd coverFileId coverUrl status publishedAtMs updatedAtMs hasUnpublishedChanges }
  media { ${$3b62335a4d4d6420$var$MEDIA} }
  publishedAtMs firstPublishedAtMs suspendedReason hasUnpublishedChanges
  publishBlockers { sectionKind field code message }
  councilNumber councilType specialty publicPath publicUrl updatedAtMs
`;
const $3b62335a4d4d6420$var$ARTICLE_FIELDS = 'id slug slugLocked title bodyMd coverFileId coverUrl status publishedAtMs updatedAtMs hasUnpublishedChanges';
const $3b62335a4d4d6420$export$5058ba14b6d626ac = `query MyDoctorPage { myDoctorPage { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} } }`;
const $3b62335a4d4d6420$export$a7cb54948791a35f = `query CheckDoctorPageSlug($slug: String!) {
  checkDoctorPageSlug(slug: $slug) { available reason normalized message }
}`;
const $3b62335a4d4d6420$export$5744b2ac2f7f4850 = `mutation UpdateDoctorPage($input: DoctorPageInput!) {
  updateDoctorPage(input: $input) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$6b6dcf2c69db97d3 = `mutation UpdateDoctorPageSection($kind: String!, $input: DoctorPageSectionInput!) {
  updateDoctorPageSection(kind: $kind, input: $input) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$22481fc967e03aae = `mutation ReorderDoctorPageSections($kinds: [String!]!) {
  reorderDoctorPageSections(kinds: $kinds) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$f1db2c75d6790b63 = `mutation UploadDoctorPageImage($slot: String!, $image: String!, $refId: String, $alt: String) {
  uploadDoctorPageImage(slot: $slot, image: $image, refId: $refId, alt: $alt) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$e34e192c5c11a222 = `mutation UpdateDoctorPageImage($mediaId: ID!, $alt: String, $sortOrder: Int) {
  updateDoctorPageImage(mediaId: $mediaId, alt: $alt, sortOrder: $sortOrder) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$7b9066bdf7831554 = `mutation RemoveDoctorPageImage($mediaId: ID!) {
  removeDoctorPageImage(mediaId: $mediaId) { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
}`;
const $3b62335a4d4d6420$export$4c1be99ccffcac0d = `mutation UpsertDoctorPageArticle($input: DoctorPageArticleInput!) {
  upsertDoctorPageArticle(input: $input) { ${$3b62335a4d4d6420$var$ARTICLE_FIELDS} }
}`;
const $3b62335a4d4d6420$export$33f6cde9f0e1e00a = `mutation SetDoctorPageArticleStatus($id: ID!, $status: String!) {
  setDoctorPageArticleStatus(id: $id, status: $status) { ${$3b62335a4d4d6420$var$ARTICLE_FIELDS} }
}`;
const $3b62335a4d4d6420$export$d1a9abd2041a0719 = `mutation DeleteDoctorPageArticle($id: ID!) { deleteDoctorPageArticle(id: $id) }`;
const $3b62335a4d4d6420$export$1f551407a679572f = `mutation PublishDoctorPage($complianceAccepted: Boolean!) {
  publishDoctorPage(complianceAccepted: $complianceAccepted) {
    published
    errors { sectionKind field code message }
    page { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} }
  }
}`;
const $3b62335a4d4d6420$export$b5769b83148cfb66 = `mutation UnpublishDoctorPage { unpublishDoctorPage { ${$3b62335a4d4d6420$export$e95bd389f8ebddb4} } }`;
const $3b62335a4d4d6420$export$1b56cc494043d9bf = `mutation CreateDoctorPagePreviewUrl { createDoctorPagePreviewUrl { url expiresAt } }`;
const $3b62335a4d4d6420$export$b09535354f512384 = `query MyDoctorPageLeads($limit: Int, $offset: Int) {
  myDoctorPageLeads(limit: $limit, offset: $offset) {
    total
    items { id name mobile preferredChannel preferredTime message status createdAtMs }
  }
}`;
function $3b62335a4d4d6420$export$b50ad3f10248fb18(page, article) {
    if (!page || !article) return page;
    const rest = (page.articles || []).filter((a)=>a.id !== article.id);
    return {
        ...page,
        articles: [
            article,
            ...rest
        ]
    };
}
function $3b62335a4d4d6420$export$77a8a5eaf4f4a5fd(page, id) {
    if (!page) return page;
    return {
        ...page,
        articles: (page.articles || []).filter((a)=>a.id !== id)
    };
}
function $3b62335a4d4d6420$export$a036633391ce0a71(state, action) {
    const prev = state[action.key] || {};
    switch(action.type){
        case 'start':
            return {
                ...state,
                [action.key]: {
                    ...prev,
                    saving: true,
                    error: null
                }
            };
        case 'ok':
            return {
                ...state,
                [action.key]: {
                    saving: false,
                    error: null,
                    savedAt: action.at
                }
            };
        case 'fail':
            return {
                ...state,
                [action.key]: {
                    ...prev,
                    saving: false,
                    error: action.error
                }
            };
        case 'clear':
            return {
                ...state,
                [action.key]: {
                    ...prev,
                    error: null
                }
            };
        default:
            return state;
    }
}
function $3b62335a4d4d6420$export$55896aa7048c15e6() {
    const [page, setPage] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [cards, setCards] = (0, $acw62.useState)({});
    // The last «انتشار» refusal, shown on the offending cards until the next
    // successful publish or a fresh load.
    const [publishErrors, setPublishErrors] = (0, $acw62.useState)([]);
    const alive = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>()=>{
            alive.current = false;
        }, []);
    // The page as of the last render, so a write can compute — and return — the
    // page it produced (an editor adopts that as its new baseline).
    const pageRef = (0, $acw62.useRef)(null);
    pageRef.current = page;
    const dispatch = (0, $acw62.useCallback)((action)=>{
        if (alive.current) setCards((s)=>$3b62335a4d4d6420$export$a036633391ce0a71(s, action));
    }, []);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($3b62335a4d4d6420$export$5058ba14b6d626ac);
            if (!alive.current) return;
            setPage(data?.myDoctorPage || null);
        } catch (err) {
            if (alive.current) setError(err);
        } finally{
            if (alive.current) setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    /**
   * One write. Resolves `{ ok: true, data, page }` (page = the page it produced)
   * or `{ ok: false, error }` — never throws, because every caller renders the
   * failure on its own card.
   */ const write = (0, $acw62.useCallback)(async (key, document, variables, apply)=>{
        dispatch({
            type: 'start',
            key: key
        });
        try {
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)(document, variables);
            const next = apply ? apply(data, pageRef.current) ?? pageRef.current : pageRef.current;
            if (alive.current && apply) {
                pageRef.current = next;
                setPage(next);
            }
            dispatch({
                type: 'ok',
                key: key,
                at: Date.now()
            });
            return {
                ok: true,
                data: data,
                page: next
            };
        } catch (err) {
            dispatch({
                type: 'fail',
                key: key,
                error: err
            });
            return {
                ok: false,
                error: err
            };
        }
    }, [
        dispatch
    ]);
    const replaceWith = (field)=>(data)=>data?.[field] || null;
    const actions = {
        updatePage: (key, input)=>write(key, $3b62335a4d4d6420$export$5744b2ac2f7f4850, {
                input: input
            }, replaceWith('updateDoctorPage')),
        updateSection: (key, kind, input)=>write(key, $3b62335a4d4d6420$export$6b6dcf2c69db97d3, {
                kind: kind,
                input: input
            }, replaceWith('updateDoctorPageSection')),
        reorder: (kinds)=>write('sections', $3b62335a4d4d6420$export$22481fc967e03aae, {
                kinds: kinds
            }, replaceWith('reorderDoctorPageSections')),
        uploadImage: (key, { slot: slot, image: image, refId: refId, alt: alt })=>write(key, $3b62335a4d4d6420$export$f1db2c75d6790b63, {
                slot: slot,
                image: image,
                refId: refId || null,
                alt: alt || null
            }, replaceWith('uploadDoctorPageImage')),
        updateImage: (key, mediaId, patch)=>write(key, $3b62335a4d4d6420$export$e34e192c5c11a222, {
                mediaId: mediaId,
                ...patch
            }, replaceWith('updateDoctorPageImage')),
        removeImage: (key, mediaId)=>write(key, $3b62335a4d4d6420$export$7b9066bdf7831554, {
                mediaId: mediaId
            }, replaceWith('removeDoctorPageImage')),
        upsertArticle: (key, input)=>write(key, $3b62335a4d4d6420$export$4c1be99ccffcac0d, {
                input: input
            }, (data, cur)=>$3b62335a4d4d6420$export$b50ad3f10248fb18(cur, data?.upsertDoctorPageArticle)),
        setArticleStatus: (key, id, status)=>write(key, $3b62335a4d4d6420$export$33f6cde9f0e1e00a, {
                id: id,
                status: status
            }, (data, cur)=>$3b62335a4d4d6420$export$b50ad3f10248fb18(cur, data?.setDoctorPageArticleStatus)),
        deleteArticle: (key, id)=>write(key, $3b62335a4d4d6420$export$d1a9abd2041a0719, {
                id: id
            }, (data, cur)=>data?.deleteDoctorPageArticle ? $3b62335a4d4d6420$export$77a8a5eaf4f4a5fd(cur, id) : cur),
        publish: async (complianceAccepted)=>{
            const res = await write('publish', $3b62335a4d4d6420$export$1f551407a679572f, {
                complianceAccepted: complianceAccepted
            }, (data)=>data?.publishDoctorPage?.page || null);
            if (!res.ok) return res;
            const result = res.data?.publishDoctorPage;
            if (alive.current) setPublishErrors(result?.published ? [] : result?.errors || []);
            return {
                ok: true,
                published: !!result?.published,
                errors: result?.errors || []
            };
        },
        unpublish: ()=>write('publish', $3b62335a4d4d6420$export$b5769b83148cfb66, {}, replaceWith('unpublishDoctorPage')),
        preview: async ()=>{
            const res = await write('preview', $3b62335a4d4d6420$export$1b56cc494043d9bf, {});
            return res.ok ? {
                ok: true,
                ...res.data?.createDoctorPagePreviewUrl
            } : res;
        },
        clearError: (key)=>dispatch({
                type: 'clear',
                key: key
            })
    };
    return {
        page: page,
        loading: loading,
        error: error,
        reload: load,
        cards: cards,
        publishErrors: publishErrors,
        actions: actions
    };
}
function $3b62335a4d4d6420$export$98ae58d30495b901(slug, { enabled: enabled, delayMs: delayMs = 400 } = {}) {
    const [state, setState] = (0, $acw62.useState)({
        checking: false,
        result: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !slug) {
            setState({
                checking: false,
                result: null
            });
            return undefined;
        }
        let cancelled = false;
        setState((s)=>({
                ...s,
                checking: true
            }));
        const timer = setTimeout(async ()=>{
            try {
                const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($3b62335a4d4d6420$export$a7cb54948791a35f, {
                    slug: slug
                });
                if (!cancelled) setState({
                    checking: false,
                    result: data?.checkDoctorPageSlug || null
                });
            } catch  {
                // The service decides on save anyway; a failed probe only loses the hint.
                if (!cancelled) setState({
                    checking: false,
                    result: null
                });
            }
        }, delayMs);
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        slug,
        enabled,
        delayMs
    ]);
    return state;
}
function $3b62335a4d4d6420$export$1f76e6205b77f0d4({ active: active, pageSize: pageSize = 20, accumulate: accumulate = false } = {}) {
    const [state, setState] = (0, $acw62.useState)({
        items: [],
        total: 0,
        loading: false,
        error: null,
        pageIndex: 0
    });
    const fetchPage = (0, $acw62.useCallback)(async (pageIndex, append)=>{
        setState((s)=>({
                ...s,
                loading: true,
                error: null
            }));
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($3b62335a4d4d6420$export$b09535354f512384, {
                limit: pageSize,
                offset: pageIndex * pageSize
            });
            const list = data?.myDoctorPageLeads || {
                items: [],
                total: 0
            };
            setState((s)=>({
                    items: append ? [
                        ...s.items,
                        ...list.items
                    ] : list.items,
                    total: list.total,
                    loading: false,
                    error: null,
                    pageIndex: pageIndex
                }));
        } catch (err) {
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: err
                }));
        }
    }, [
        pageSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (active) fetchPage(0, false);
    }, [
        active,
        fetchPage
    ]);
    return {
        ...state,
        loaded: !state.loading && !state.error,
        pageCount: Math.max(1, Math.ceil(state.total / pageSize)),
        hasMore: state.items.length < state.total,
        goTo: (pageIndex)=>fetchPage(pageIndex, false),
        loadMore: ()=>fetchPage(state.pageIndex + 1, accumulate),
        retry: ()=>fetchPage(state.pageIndex, false)
    };
}


// ─────────────────────────────────────────────────────────────────────────────
// «صفحهٔ من» — the shared, platform-free logic of the page builder
// (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md §6, §7, §12).
//
// Everything both surfaces must agree on lives here, so MyPage.web.jsx and
// MyPage.mobile.jsx cannot disagree on a derived fact: which templates,
// palettes and densities exist (the MANIFEST, never a second copy), what a
// section is called, what a reorder sends, whether «انتشار» is possible, what
// a slug may look like, and what counts as an unsaved change.
//
// No components, no `@parsina/framework` — a logic file is DOM-free.
// ─────────────────────────────────────────────────────────────────────────────
// BYTE-IDENTICAL copy of the practitioner service's
// app/domain/doctorpage_templates.json — `make doctorpage-manifests-check`.
var $cd11fd8602f42b77$exports = {};
$cd11fd8602f42b77$exports = JSON.parse('{"version":1,"_comment":"The doctor public page template manifest (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md \xa76). BYTE-IDENTICAL in the practitioner service (validation), the doctor client (editor) and the doctorsite web (renderer) \u2014 `make doctorpage-manifests-check`. Change one, change all three.","limits":{"slug_min":3,"slug_max":40,"display_name_max":80,"headline_max":160,"hero_cards_max":2,"hero_card_title_max":40,"hero_card_text_max":90,"hero_highlights_max":3,"hero_highlight_title_max":40,"hero_highlight_text_max":60,"about_md_max":8000,"title_override_max":60,"service_title_max":80,"service_description_max":1000,"testimonial_text_max":600,"testimonial_attribution_max":60,"video_caption_max":160,"article_title_max":160,"article_body_max":65536,"articles_max":100,"alt_max":160,"phones_max":4,"phone_label_max":30,"phone_number_max":20,"address_max":300,"city_max":60,"hours_max":7,"hours_label_max":40,"hours_value_max":60,"social_max":200,"image_upload_bytes_max":5242880},"sections":{"hero":{"title":"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u062D\u0631\u0641\u0647\u200C\u0627\u06CC","required":true,"max_items":0},"services":{"title":"\u062E\u062F\u0645\u0627\u062A","required":false,"max_items":12},"articles":{"title":"\u0645\u0642\u0627\u0644\u0627\u062A \u0648 \u0645\u0637\u0627\u0644\u0628 \u0639\u0644\u0645\u06CC","required":false,"max_items":0},"testimonials":{"title":"\u0646\u0638\u0631\u0627\u062A \u0645\u0646\u062A\u062E\u0628 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646","required":false,"max_items":10},"gallery":{"title":"\u06AF\u0627\u0644\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631","required":false,"max_items":12},"video":{"title":"\u0648\u06CC\u062F\u06CC\u0648","required":false,"max_items":3},"office":{"title":"\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0645\u0637\u0628","required":true,"max_items":0}},"default_template":"classic","templates":[{"id":"classic","name":"\u06A9\u0644\u0627\u0633\u06CC\u06A9","description":"\u0686\u06CC\u062F\u0645\u0627\u0646 \u0645\u062A\u06CC\u0646 \u0648 \u067E\u0631\u062A\u0631\u0647\u200C\u0645\u062D\u0648\u0631\u061B \u0645\u0646\u0627\u0633\u0628 \u0645\u0639\u0631\u0641\u06CC \u0631\u0633\u0645\u06CC \u0648 \u062D\u0631\u0641\u0647\u200C\u0627\u06CC.","tier":"free","uses_cover":true,"sections":["hero","services","articles","testimonials","gallery","video","office"],"default_order":["hero","services","articles","testimonials","gallery","video","office"],"palettes":[{"id":"azure","name":"\u0644\u0627\u062C\u0648\u0631\u062F\u06CC","primary":"#0173BE","primary_dark":"#015E9C","accent":"#00BEB2","surface":"#F5F7FA","ink":"#1A2332"},{"id":"teal","name":"\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC","primary":"#007D74","primary_dark":"#00605A","accent":"#0173BE","surface":"#F4F8F8","ink":"#1A2332"},{"id":"deep","name":"\u0633\u0631\u0645\u0647\u200C\u0627\u06CC","primary":"#0A4F8F","primary_dark":"#083D6F","accent":"#00BEB2","surface":"#F5F7FA","ink":"#1A2332"}],"default_palette":"azure","densities":["comfortable","compact"],"default_density":"comfortable"},{"id":"modern","name":"\u0645\u062F\u0631\u0646","description":"\u0647\u06CC\u0631\u0648\u06CC \u062A\u0645\u0627\u0645\u200C\u0639\u0631\u0636 \u0628\u0627 \u062A\u0635\u0648\u06CC\u0631 \u06A9\u0627\u0648\u0631 \u0648 \u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u06A9\u0627\u0631\u062A\u06CC\u061B \u067E\u0631\u0627\u0646\u0631\u0698\u06CC \u0648 \u062A\u0635\u0648\u06CC\u0631\u06CC.","tier":"free","uses_cover":true,"sections":["hero","services","articles","testimonials","gallery","video","office"],"default_order":["hero","services","gallery","video","testimonials","articles","office"],"palettes":[{"id":"brand","name":"\u0628\u0631\u0646\u062F \u067E\u0627\u0631\u0633\u06CC\u0646\u0627","primary":"#0173BE","primary_dark":"#083250","accent":"#00BEB2","surface":"#FFFFFF","ink":"#1A2332"},{"id":"cyan","name":"\u0622\u0628\u06CC \u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC","primary":"#007C8C","primary_dark":"#06363F","accent":"#00BEB2","surface":"#FFFFFF","ink":"#1A2332"},{"id":"deep","name":"\u0633\u0631\u0645\u0647\u200C\u0627\u06CC","primary":"#0A4F8F","primary_dark":"#062F57","accent":"#00BEB2","surface":"#FFFFFF","ink":"#1A2332"}],"default_palette":"brand","densities":["comfortable","compact"],"default_density":"comfortable"},{"id":"minimal","name":"\u0645\u06CC\u0646\u06CC\u0645\u0627\u0644","description":"\u062A\u0627\u06CC\u067E\u0648\u06AF\u0631\u0627\u0641\u06CC\u06A9 \u0648 \u062E\u0644\u0648\u062A\u060C \u0628\u062F\u0648\u0646 \u06A9\u0627\u0648\u0631\u061B \u062A\u0645\u0631\u06A9\u0632 \u0628\u0631 \u0645\u062A\u0646\u060C \u062E\u062F\u0645\u0627\u062A \u0648 \u0645\u0642\u0627\u0644\u0627\u062A.","tier":"free","uses_cover":false,"sections":["hero","services","articles","testimonials","office"],"default_order":["hero","services","articles","testimonials","office"],"palettes":[{"id":"ink","name":"\u062C\u0648\u0647\u0631\u06CC","primary":"#1A2332","primary_dark":"#0B1320","accent":"#0173BE","surface":"#FFFFFF","ink":"#1A2332"},{"id":"azure","name":"\u0644\u0627\u062C\u0648\u0631\u062F\u06CC","primary":"#0173BE","primary_dark":"#015E9C","accent":"#00BEB2","surface":"#FFFFFF","ink":"#1A2332"}],"default_palette":"ink","densities":["comfortable","compact"],"default_density":"comfortable"}]}');


const $6f0813e0b3e01b00$export$2e91cd085cd33e2f = (0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).limits;
const $6f0813e0b3e01b00$export$a5d6a5bb91ad66dd = Object.freeze(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).sections));
const $6f0813e0b3e01b00$export$c3bf375920040a8d = Object.freeze([
    'draft',
    'published',
    'unpublished',
    'suspended'
]);
const $6f0813e0b3e01b00$export$ed8e8b95f038b742 = Object.freeze({
    draft: 'outline',
    published: 'success',
    unpublished: 'warning',
    suspended: 'destructive'
});
const $6f0813e0b3e01b00$export$5aeba3c817b68975 = (status)=>$6f0813e0b3e01b00$export$c3bf375920040a8d.includes(status) ? `myPage.status.${status}` : 'myPage.status.unknown';
const $6f0813e0b3e01b00$export$a8fc3402335b0b04 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).templates;
function $6f0813e0b3e01b00$export$49bf6523f9e347bb(id) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).templates.find((t)=>t.id === id) || (0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).templates.find((t)=>t.id === (0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).default_template) || (0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).templates[0];
}
const $6f0813e0b3e01b00$export$c41e74cad9913569 = (templateId)=>$6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId).palettes;
const $6f0813e0b3e01b00$export$686996df76dff2cc = (templateId)=>$6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId).densities;
const $6f0813e0b3e01b00$export$9e8077034eeecbde = (templateId)=>!!$6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId).uses_cover;
const $6f0813e0b3e01b00$export$985ae255e4917bab = (templateId, kind)=>$6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId).sections.includes(kind);
function $6f0813e0b3e01b00$export$5c13f8645b3802cd(templateId, theme) {
    const t = $6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId);
    const palette = t.palettes.some((p)=>p.id === theme?.palette) ? theme.palette : t.default_palette;
    const density = t.densities.includes(theme?.density) ? theme.density : t.default_density;
    return {
        palette: palette,
        density: density
    };
}
const $6f0813e0b3e01b00$export$d0abcb2af59a5607 = (templateId, currentTheme)=>$6f0813e0b3e01b00$export$5c13f8645b3802cd(templateId, currentTheme);
const $6f0813e0b3e01b00$export$be411cec868da6d8 = (kind)=>(0, (/*@__PURE__*/$parcel$interopDefault($cd11fd8602f42b77$exports))).sections[kind] || {
        title: kind,
        required: false,
        max_items: 0
    };
const $6f0813e0b3e01b00$export$baddd5d42052cf98 = (kind)=>$6f0813e0b3e01b00$export$be411cec868da6d8(kind).max_items || 0;
const $6f0813e0b3e01b00$export$1a952fe22cdce89e = (section)=>section?.titleOverride && section.titleOverride.trim() || $6f0813e0b3e01b00$export$be411cec868da6d8(section?.kind).title;
const $6f0813e0b3e01b00$export$53e69196b53dea9f = (sections)=>[
        ...sections || []
    ].sort((a, b)=>(a.sortOrder ?? 0) - (b.sortOrder ?? 0));
function $6f0813e0b3e01b00$export$5977caaf27b6313d(sections, kind, delta) {
    const kinds = $6f0813e0b3e01b00$export$53e69196b53dea9f(sections).map((s)=>s.kind);
    const from = kinds.indexOf(kind);
    const to = from + delta;
    if (from < 0 || to < 0 || to >= kinds.length || delta === 0) return null;
    const next = [
        ...kinds
    ];
    next.splice(from, 1);
    next.splice(to, 0, kind);
    return next;
}
function $6f0813e0b3e01b00$export$e182a35019a9a12c(sections, kinds) {
    const pos = new Map(kinds.map((k, i)=>[
            k,
            i
        ]));
    return (sections || []).map((s)=>({
            ...s,
            sortOrder: pos.has(s.kind) ? pos.get(s.kind) : s.sortOrder
        }));
}
function $6f0813e0b3e01b00$export$cb46fb9ca2e05378(errors) {
    const out = {};
    for (const e of errors || []){
        const key = e?.sectionKind || 'page';
        (out[key] ||= []).push(e);
    }
    return out;
}
function $6f0813e0b3e01b00$export$e979e5c05b4e89be(page) {
    if (!page) return {
        canPublish: false,
        reasons: []
    };
    if (page.status === 'suspended') return {
        canPublish: false,
        reasons: [],
        suspended: true
    };
    const reasons = page.publishBlockers || [];
    return {
        canPublish: reasons.length === 0,
        reasons: reasons
    };
}
const $6f0813e0b3e01b00$export$59fa923597ae4a6 = (page)=>page?.status === 'published';
const $6f0813e0b3e01b00$export$f23acc97a99da739 = (page)=>Number(page?.firstPublishedAtMs || 0) > 0;
const $6f0813e0b3e01b00$export$2498094d90b6ac72 = (page)=>page?.status === 'suspended';
// ── Slug ─────────────────────────────────────────────────────────────────────
const $6f0813e0b3e01b00$var$PERSIAN_DIGITS = '\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9';
const $6f0813e0b3e01b00$var$ARABIC_DIGITS = '\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669';
function $6f0813e0b3e01b00$export$e53ee9755c8a3679(value) {
    return String(value ?? '').replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (ch)=>{
        const i = $6f0813e0b3e01b00$var$PERSIAN_DIGITS.indexOf(ch);
        return String(i >= 0 ? i : $6f0813e0b3e01b00$var$ARABIC_DIGITS.indexOf(ch));
    });
}
const $6f0813e0b3e01b00$export$95f2253c4751dcdb = (value)=>$6f0813e0b3e01b00$export$e53ee9755c8a3679(value).trim().toLowerCase().replace(/\s+/g, '-');
const $6f0813e0b3e01b00$export$f14bc14dedec0def = new RegExp(`^[a-z0-9][a-z0-9-]{${Math.max($6f0813e0b3e01b00$export$2e91cd085cd33e2f.slug_min - 2, 0)},${$6f0813e0b3e01b00$export$2e91cd085cd33e2f.slug_max - 2}}[a-z0-9]$`);
function $6f0813e0b3e01b00$export$f0fedd4f36c4c1fa(slug) {
    if (!slug) return 'myPage.slug.required';
    if (!$6f0813e0b3e01b00$export$f14bc14dedec0def.test(slug) || slug.includes('--')) return 'myPage.slug.invalid';
    return '';
}
const $6f0813e0b3e01b00$export$6e297d43db8aa7bc = (page)=>!!page?.slugLocked;
function $6f0813e0b3e01b00$export$fa41532ad359c5e(random = Math.random) {
    let s = '';
    while(s.length < 12)s += Math.floor(random() * 36).toString(36);
    return `i${s.slice(0, 12)}`;
}
const $6f0813e0b3e01b00$export$a305366fc92dfc67 = (section)=>Array.isArray(section?.content?.items) ? section.content.items : [];
function $6f0813e0b3e01b00$export$c9a626b130283093(kind, items) {
    const max = $6f0813e0b3e01b00$export$baddd5d42052cf98(kind);
    return !max || (items || []).length < max;
}
const $6f0813e0b3e01b00$export$1f99b3e8e53dce10 = (page, itemId)=>(page?.media || []).find((m)=>m.slot === 'service' && m.refId === itemId) || null;
const $6f0813e0b3e01b00$export$4d566a4dcecbad1d = (page)=>(page?.media || []).filter((m)=>m.slot === 'gallery').sort((a, b)=>(a.sortOrder ?? 0) - (b.sortOrder ?? 0));
const $6f0813e0b3e01b00$export$590b08800387bb0 = Object.freeze([
    'modern',
    'classic'
]);
const $6f0813e0b3e01b00$export$3aace564db59f0ed = (templateId)=>$6f0813e0b3e01b00$export$590b08800387bb0.includes($6f0813e0b3e01b00$export$49bf6523f9e347bb(templateId).id);
const $6f0813e0b3e01b00$export$d32b44f1fb316170 = Object.freeze({
    cards: {
        max: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_cards_max,
        titleMax: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_card_title_max,
        textMax: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_card_text_max
    },
    highlights: {
        max: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_highlights_max,
        titleMax: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_highlight_title_max,
        textMax: $6f0813e0b3e01b00$export$2e91cd085cd33e2f.hero_highlight_text_max
    }
});
const $6f0813e0b3e01b00$var$heroList = (list)=>(Array.isArray(list) ? list : []).map((it)=>({
            id: it?.id || '',
            title: it?.title || '',
            text: it?.text || ''
        }));
const $6f0813e0b3e01b00$export$c23d3f52b03505fb = (section)=>({
        cards: $6f0813e0b3e01b00$var$heroList(section?.content?.cards),
        highlights: $6f0813e0b3e01b00$var$heroList(section?.content?.highlights)
    });
function $6f0813e0b3e01b00$export$10dcba1188fc61cf(draft) {
    const clean = (list)=>(list || []).map((it)=>({
                ...it.id ? {
                    id: it.id
                } : {},
                title: it.title.trim(),
                text: (it.text || '').trim()
            }));
    return {
        cards: clean(draft.cards),
        highlights: clean(draft.highlights)
    };
}
function $6f0813e0b3e01b00$export$cc30a234a47df063(draft) {
    return Object.entries($6f0813e0b3e01b00$export$d32b44f1fb316170).some(([key, lim])=>{
        const list = draft[key] || [];
        return list.length > lim.max || list.some((it)=>!it.title.trim() || $6f0813e0b3e01b00$export$e851aa099013d3ed(it.title, lim.titleMax) || $6f0813e0b3e01b00$export$e851aa099013d3ed(it.text, lim.textMax));
    });
}
const $6f0813e0b3e01b00$export$da2827437343807f = Object.freeze([
    'instagram',
    'telegram',
    'whatsapp',
    'eitaa',
    'bale',
    'website'
]);
function $6f0813e0b3e01b00$export$12e620af4be5c7d6(contact) {
    const c = contact || {};
    const socials = {};
    for (const k of $6f0813e0b3e01b00$export$da2827437343807f)socials[k] = c.socials?.[k] || '';
    return {
        phones: (Array.isArray(c.phones) ? c.phones : []).map((p)=>({
                label: p?.label || '',
                number: p?.number || ''
            })),
        address: c.address || '',
        city: c.city || '',
        hours: (Array.isArray(c.hours) ? c.hours : []).map((h)=>({
                label: h?.label || '',
                value: h?.value || ''
            })),
        geo: c.geo && c.geo.lat != null && c.geo.lng != null ? {
            lat: String(c.geo.lat),
            lng: String(c.geo.lng)
        } : {
            lat: '',
            lng: ''
        },
        socials: socials
    };
}
function $6f0813e0b3e01b00$export$a45bb8dd7a7fbcf9(draft) {
    const lat = Number.parseFloat($6f0813e0b3e01b00$export$e53ee9755c8a3679(draft.geo?.lat));
    const lng = Number.parseFloat($6f0813e0b3e01b00$export$e53ee9755c8a3679(draft.geo?.lng));
    const socials = {};
    for (const k of $6f0813e0b3e01b00$export$da2827437343807f){
        const v = (draft.socials?.[k] || '').trim();
        if (v) socials[k] = v;
    }
    return {
        phones: (draft.phones || []).map((p)=>({
                label: p.label.trim(),
                number: $6f0813e0b3e01b00$export$e53ee9755c8a3679(p.number).trim()
            })).filter((p)=>p.number),
        address: (draft.address || '').trim(),
        city: (draft.city || '').trim(),
        geo: Number.isFinite(lat) && Number.isFinite(lng) ? {
            lat: lat,
            lng: lng
        } : null,
        hours: (draft.hours || []).map((h)=>({
                label: h.label.trim(),
                value: h.value.trim()
            })).filter((h)=>h.label || h.value),
        socials: socials
    };
}
function $6f0813e0b3e01b00$export$2404e5988465b265(geo) {
    const lat = Number.parseFloat($6f0813e0b3e01b00$export$e53ee9755c8a3679(geo?.lat));
    const lng = Number.parseFloat($6f0813e0b3e01b00$export$e53ee9755c8a3679(geo?.lng));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    return {
        lat: lat,
        lng: lng
    };
}
function $6f0813e0b3e01b00$export$6c9a7b0b2e549efc(point) {
    if (!point) return {
        lat: '',
        lng: ''
    };
    return {
        lat: Number(point.lat).toFixed(6),
        lng: Number(point.lng).toFixed(6)
    };
}
const $6f0813e0b3e01b00$export$e173650de24e027d = (a, b)=>JSON.stringify(a) === JSON.stringify(b);
const $6f0813e0b3e01b00$export$b59d2bd11ea795a = (page)=>({
        displayName: page?.displayName || '',
        headline: page?.headline || '',
        aboutMd: page?.aboutMd || ''
    });
function $6f0813e0b3e01b00$export$519f62282f18e4ae({ dirty: dirty, saving: saving, error: error, savedAt: savedAt }) {
    if (saving) return 'saving';
    if (error) return 'error';
    if (dirty) return 'dirty';
    if (savedAt) return 'saved';
    return 'idle';
}
const $6f0813e0b3e01b00$export$1d07293a1a6818a6 = Object.freeze([
    'call',
    'sms',
    'whatsapp'
]);
const $6f0813e0b3e01b00$export$e6de71426455e78 = Object.freeze([
    'morning',
    'afternoon',
    'evening',
    'any'
]);
const $6f0813e0b3e01b00$export$5ec175ebc4bc2aa7 = 20;
const $6f0813e0b3e01b00$export$73b877b58963a4f = Object.freeze([
    'builder',
    'leads'
]);
const $6f0813e0b3e01b00$export$f35c09608a54a6c1 = (value)=>$6f0813e0b3e01b00$export$73b877b58963a4f.includes(value) ? value : 'builder';
const $6f0813e0b3e01b00$export$8168440c8fb8f877 = (value)=>$6f0813e0b3e01b00$export$a5d6a5bb91ad66dd.includes(value) ? value : null;
const $6f0813e0b3e01b00$export$36cc835d2490c0fc = (text)=>[
        ...String(text || '')
    ].length;
const $6f0813e0b3e01b00$export$e851aa099013d3ed = (text, max)=>!!max && $6f0813e0b3e01b00$export$36cc835d2490c0fc(text) > max;


function $819f3046f3b98c8e$export$57e6dc74dd06ce9f({ notify: notify = ()=>{} } = {}) {
    const data = (0, $3b62335a4d4d6420$export$55896aa7048c15e6)();
    const { page: page, actions: actions } = data;
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const tab = (0, $6f0813e0b3e01b00$export$f35c09608a54a6c1)(params.get('tab'));
    const section = (0, $6f0813e0b3e01b00$export$8168440c8fb8f877)(params.get('section'));
    const [publishOpen, setPublishOpen] = (0, $acw62.useState)(false);
    // A preview link the browser refused to open in a new tab — offered as a link instead.
    const [blockedPreview, setBlockedPreview] = (0, $acw62.useState)(null);
    // Whether THIS screen pushed the open section's history entry: then closing
    // pops it (so platform back and the header's back agree); a deep link that
    // arrived with ?section= is replaced instead, never popped out of the app.
    const pushedSection = (0, $acw62.useRef)(false);
    const setParam = (0, $acw62.useCallback)((key, value, { push: push = false } = {})=>{
        setParams((prev)=>{
            const next = new URLSearchParams(prev);
            if (value == null || value === '') next.delete(key);
            else next.set(key, value);
            return next;
        }, {
            replace: !push
        });
    }, [
        setParams
    ]);
    const selectTab = (0, $acw62.useCallback)((id)=>{
        setParams((prev)=>{
            const next = new URLSearchParams(prev);
            if (id === 'builder') next.delete('tab');
            else next.set('tab', id);
            next.delete('section');
            return next;
        }, {
            replace: true
        });
    }, [
        setParams
    ]);
    const readOnly = (0, $6f0813e0b3e01b00$export$2498094d90b6ac72)(page);
    const changeTemplate = (0, $acw62.useCallback)((templateId)=>actions.updatePage('template', {
            templateId: templateId,
            theme: (0, $6f0813e0b3e01b00$export$d0abcb2af59a5607)(templateId, page?.theme)
        }), [
        actions,
        page
    ]);
    const changeTheme = (0, $acw62.useCallback)((theme)=>actions.updatePage('theme', {
            theme: (0, $6f0813e0b3e01b00$export$5c13f8645b3802cd)(page?.templateId, theme)
        }), [
        actions,
        page
    ]);
    const saveSlug = (0, $acw62.useCallback)((slug)=>actions.updatePage('slug', {
            slug: slug
        }), [
        actions
    ]);
    const toggleSection = (0, $acw62.useCallback)((kind, enabled)=>actions.updateSection(`toggle-${kind}`, kind, {
            enabled: enabled
        }), [
        actions
    ]);
    const moveSections = (0, $acw62.useCallback)(async (kinds)=>{
        const res = await actions.reorder(kinds);
        if (!res.ok) notify('error', 'myPage.sections.reorderFailed');
        return res;
    }, [
        actions,
        notify
    ]);
    const preview = (0, $acw62.useCallback)(async ()=>{
        setBlockedPreview(null);
        // Opened NOW, inside the click, so a popup blocker lets it through; it is
        // pointed at the signed link once the BFF has minted one.
        let win = null;
        try {
            win = window.open('', '_blank');
        } catch  {
            win = null;
        }
        const res = await actions.preview();
        if (!res.ok || !res.url) {
            try {
                win?.close();
            } catch  {}
            return res;
        }
        if (win) {
            try {
                win.opener = null;
            } catch  {}
            win.location.href = res.url;
        } else {
            setBlockedPreview(res.url);
            notify('info', 'myPage.statusCard.popupBlocked');
        }
        return res;
    }, [
        actions,
        notify
    ]);
    const publish = (0, $acw62.useCallback)(async (complianceAccepted)=>{
        const res = await actions.publish(complianceAccepted);
        if (res.ok && res.published) notify('success', 'myPage.publish.done');
        return res;
    }, [
        actions,
        notify
    ]);
    const unpublish = (0, $acw62.useCallback)(async ()=>{
        const res = await actions.unpublish();
        if (res.ok) notify('success', 'myPage.statusCard.unpublished');
        else notify('error', 'myPage.statusCard.unpublishFailed');
        return res.ok;
    }, [
        actions,
        notify
    ]);
    return {
        ...data,
        tab: tab,
        section: section,
        readOnly: readOnly,
        selectTab: selectTab,
        openSection: (kind)=>{
            pushedSection.current = true;
            setParam('section', kind, {
                push: true
            });
        },
        selectSection: (kind)=>setParam('section', kind),
        closeSection: ()=>{
            if (pushedSection.current) {
                pushedSection.current = false;
                window.history.back();
            } else setParam('section', null);
        },
        publishOpen: publishOpen,
        openPublish: ()=>setPublishOpen(true),
        closePublish: ()=>setPublishOpen(false),
        blockedPreview: blockedPreview,
        changeTemplate: changeTemplate,
        changeTheme: changeTheme,
        saveSlug: saveSlug,
        toggleSection: toggleSection,
        moveSections: moveSections,
        preview: preview,
        publish: publish,
        unpublish: unpublish,
        applyOrder: $6f0813e0b3e01b00$export$e182a35019a9a12c
    };
}
var $819f3046f3b98c8e$export$2e2bcd8739ae039 = $819f3046f3b98c8e$export$57e6dc74dd06ce9f;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

// ─────────────────────────────────────────────────────────────────────────────
// «صفحهٔ من» while the page is pending — its own shape on each surface
// (DESIGN_CONCEPT §2.4): the desktop rail (status card, template cards,
// section rows) beside one editor card; the phone's status card over the
// section list. One announced status region, kit blocks only, no words.
// ─────────────────────────────────────────────────────────────────────────────
const $7b9c2923150d9afb$var$card = {
    background: (0, $jTCZr.C).card,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    padding: '1rem',
    display: 'grid',
    gap: 10
};
const $7b9c2923150d9afb$var$Rows = ({ n: n, h: h = 44 })=>Array.from({
        length: n
    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                height: h
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: `${45 + i * 13 % 30}%`,
                    height: 13
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        flex: 1
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: 18,
                    height: 18,
                    radius: 5
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: 28,
                    height: 28,
                    radius: 8
                })
            ]
        }, i));
function $7b9c2923150d9afb$export$386856ba1c60f856() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: s('myPage.loading'),
        "data-testid": "my-page-loading",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1.25rem',
                alignItems: 'flex-start'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: '1 1 17rem',
                        maxWidth: '22rem',
                        display: 'grid',
                        gap: '1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: $7b9c2923150d9afb$var$card,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "40%",
                                    height: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "90%",
                                    height: 12
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    height: 44,
                                    radius: 10
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    height: 44,
                                    radius: 10
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: $7b9c2923150d9afb$var$card,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "30%",
                                    height: 14
                                }),
                                [
                                    0,
                                    1,
                                    2
                                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        height: 68,
                                        radius: 10
                                    }, i))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: $7b9c2923150d9afb$var$card,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "35%",
                                    height: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b9c2923150d9afb$var$Rows, {
                                    n: 7
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: '999 1 30rem',
                        minWidth: 0,
                        ...$7b9c2923150d9afb$var$card,
                        gap: 16,
                        padding: '1.25rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "25%",
                            height: 16
                        }),
                        [
                            0,
                            1
                        ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: 96,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        height: 44,
                                        radius: 10
                                    })
                                ]
                            }, i)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 96,
                            height: 12
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            height: 160,
                            radius: 10
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 96,
                                height: 36,
                                radius: 10
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $7b9c2923150d9afb$export$a303b83526e46099() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: s('myPage.loading'),
        "data-testid": "my-page-mobile-loading",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "aria-hidden": true,
            style: {
                display: 'grid',
                gap: 12,
                padding: '0 0.875rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        ...$7b9c2923150d9afb$var$card,
                        padding: '12px 14px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "45%",
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "85%",
                            height: 12
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            height: 44,
                            radius: 10
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            height: 44,
                            radius: 10
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        ...$7b9c2923150d9afb$var$card,
                        padding: '12px 14px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($7b9c2923150d9afb$var$Rows, {
                        n: 7,
                        h: 48
                    })
                })
            ]
        })
    });
}
var $7b9c2923150d9afb$export$2e2bcd8739ae039 = $7b9c2923150d9afb$export$386856ba1c60f856;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $22a80d2cd266adcc$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "9",
            x2: "15",
            y1: "15",
            y2: "9",
            key: "1dfufj"
        }
    ]
];
const $22a80d2cd266adcc$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-slash", $22a80d2cd266adcc$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $807d71b9253536b4$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $807d71b9253536b4$export$2e2bcd8739ae039 = (0, $9QBug.default)("copy", $807d71b9253536b4$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $eee9f5221939b065$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $eee9f5221939b065$export$2e2bcd8739ae039 = (0, $9QBug.default)("eye-off", $eee9f5221939b065$export$3efd853dbb351e94);


var $6OGKD = parcelRequire("6OGKD");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $5MbI8 = parcelRequire("5MbI8");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $41e90a55419824f7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 5h6",
            key: "1vod17"
        }
    ],
    [
        "path",
        {
            d: "M19 2v6",
            key: "4bpg5p"
        }
    ],
    [
        "path",
        {
            d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5",
            key: "1ue2ih"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ]
];
const $41e90a55419824f7$export$2e2bcd8739ae039 = (0, $9QBug.default)("image-plus", $41e90a55419824f7$export$3efd853dbb351e94);


var $lpOUO = parcelRequire("lpOUO");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $5MbI8 = parcelRequire("5MbI8");
var $hZDga = parcelRequire("hZDga");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
/**
 * Pan/zoom avatar cropper. Adapted from the clinic app's Settings screen so the
 * two apps frame profile pictures identically; the styling here is token-based
 * rather than the clinic version's hard-coded dark palette.
 *
 * Output is a SQUARE JPEG data URI, not a circle. The dashed circle is a framing
 * guide showing what will stay visible once a round <Avatar> masks it. Clipping
 * to a circle here would be actively wrong: JPEG has no alpha channel, so the
 * transparent corners a circular clip leaves behind encode as solid black, and
 * any square presentation of the image shows black corners.
 *
 * Props:
 *   open, onOpenChange — Radix controlled state
 *   src                — data URI of the image the user picked
 *   onCrop(dataUri)    — called with the cropped JPEG; the dialog then closes
 *   busy               — disables confirm while an upload is in flight
 *
 * Optional, for non-avatar images (the public page's cover, gallery, …):
 *   aspect             — crop box width / height (default 1, the avatar square)
 *   outWidth           — stored width in px (default 300); height = outWidth / aspect
 *   shape              — 'circle' (default: the avatar framing guide) | 'rect'
 *   title              — dialog title (default: the avatar title)
 * The defaults reproduce the avatar cropper exactly.
 */ const $80877663f582a793$var$CROP_D = 260; // crop circle diameter, in modal viewport px
const $80877663f582a793$var$CONT_W = 420; // image-area width
const $80877663f582a793$var$CONT_H = 360; // image-area height
const $80877663f582a793$var$CROP_CX = $80877663f582a793$var$CONT_W / 2;
const $80877663f582a793$var$CROP_CY = $80877663f582a793$var$CONT_H / 2;
const $80877663f582a793$var$CROP_R = $80877663f582a793$var$CROP_D / 2;
// Stored edge length. 300 keeps a 64px avatar crisp on 3× displays while landing
// around 20–25 KB at this quality.
const $80877663f582a793$var$OUT = 300;
const $80877663f582a793$var$QUALITY = 0.9;
// How far past "just covers the crop circle" the user may zoom in.
const $80877663f582a793$var$MAX_ZOOM_FACTOR = 5;
function $80877663f582a793$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, src: src, onCrop: onCrop, busy: busy = false, aspect: aspect = 1, outWidth: outWidth = $80877663f582a793$var$OUT, shape: shape = 'circle', title: title }) {
    const { t: t } = (0, $LNQP4.default)();
    // The crop box. The avatar square is CROP_D × CROP_D; a wider aspect keeps the
    // box inside the image area with a 20px margin on each side.
    const boxW = aspect >= 1 ? Math.min($80877663f582a793$var$CROP_D * aspect, $80877663f582a793$var$CONT_W - 40) : $80877663f582a793$var$CROP_D * aspect;
    const boxH = boxW / aspect;
    const boxL = $80877663f582a793$var$CROP_CX - boxW / 2;
    const boxT = $80877663f582a793$var$CROP_CY - boxH / 2;
    const outW = Math.round(outWidth);
    const outH = Math.round(outWidth / aspect);
    const imgRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const dragRef = (0, $acw62.useRef)(null);
    const [nat, setNat] = (0, $acw62.useState)(null); // natural { w, h } of the loaded image
    const [tx, setTx] = (0, $acw62.useState)(0);
    const [ty, setTy] = (0, $acw62.useState)(0);
    const [scale, setScale] = (0, $acw62.useState)(1);
    const [minScale, setMinScale] = (0, $acw62.useState)(1);
    const [dragging, setDragging] = (0, $acw62.useState)(false);
    // Reset per image, so reopening with a different file doesn't inherit the
    // previous one's pan/zoom.
    const onImgLoad = (0, $acw62.useCallback)(()=>{
        const img = imgRef.current;
        if (!img) return;
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) return;
        setNat({
            w: nw,
            h: nh
        });
        // Smallest scale at which the image still covers the whole crop circle —
        // anything less would leave background showing inside the avatar.
        const ms = Math.max(boxW / nw, boxH / nh);
        setMinScale(ms);
        setScale(ms);
        setTx(0);
        setTy(0);
    }, [
        boxW,
        boxH
    ]);
    const onPointerDown = (e)=>{
        e.currentTarget.setPointerCapture(e.pointerId);
        setDragging(true);
        dragRef.current = {
            x: e.clientX - tx,
            y: e.clientY - ty
        };
    };
    const onPointerMove = (e)=>{
        if (!dragging || !dragRef.current) return;
        setTx(e.clientX - dragRef.current.x);
        setTy(e.clientY - dragRef.current.y);
    };
    const onPointerUp = ()=>{
        setDragging(false);
        dragRef.current = null;
    };
    const onWheel = (e)=>{
        e.preventDefault();
        setScale((s)=>$80877663f582a793$var$clamp(s - e.deltaY * 0.001, minScale, minScale * $80877663f582a793$var$MAX_ZOOM_FACTOR));
    };
    const handleConfirm = ()=>{
        if (!imgRef.current || !nat) return;
        const canvas = canvasRef.current;
        canvas.width = outW;
        canvas.height = outH;
        const ctx = canvas.getContext('2d');
        // JPEG cannot store transparency, so anything not covered by the image would
        // otherwise come out black. White matches the avatar backgrounds in both apps.
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, outW, outH);
        // Translate the on-screen layout into canvas space. On screen the image is
        // centred at (CROP_CX + tx, CROP_CY + ty) and the crop box's top-left corner
        // sits at (CROP_CX - CROP_R, CROP_CY - CROP_R); the canvas is the crop box
        // scaled from CROP_D to OUT.
        const ratio = outW / boxW;
        const imgW = nat.w * scale * ratio;
        const imgH = nat.h * scale * ratio;
        const imgX = ($80877663f582a793$var$CROP_CX + tx - boxL - nat.w * scale / 2) * ratio;
        const imgY = ($80877663f582a793$var$CROP_CY + ty - boxT - nat.h * scale / 2) * ratio;
        ctx.drawImage(imgRef.current, imgX, imgY, imgW, imgH);
        onCrop(canvas.toDataURL('image/jpeg', $80877663f582a793$var$QUALITY));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            className: "max-w-none w-auto p-0 overflow-hidden",
            "data-testid": "avatar-crop-modal",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                    style: {
                        padding: '18px 22px 14px',
                        marginBottom: 0,
                        borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                        children: title ?? t('settings.avatar.editTitle')
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        position: 'relative',
                        width: $80877663f582a793$var$CONT_W,
                        height: $80877663f582a793$var$CONT_H,
                        overflow: 'hidden',
                        background: (0, $jTCZr.C).bg,
                        cursor: dragging ? 'grabbing' : 'grab',
                        userSelect: 'none',
                        touchAction: 'none'
                    },
                    onPointerDown: onPointerDown,
                    onPointerMove: onPointerMove,
                    onPointerUp: onPointerUp,
                    onPointerLeave: onPointerUp,
                    onWheel: onWheel,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            ref: imgRef,
                            src: src,
                            alt: "",
                            onLoad: onImgLoad,
                            draggable: false,
                            style: nat ? {
                                position: 'absolute',
                                width: nat.w * scale,
                                height: nat.h * scale,
                                left: $80877663f582a793$var$CROP_CX + tx - nat.w * scale / 2,
                                top: $80877663f582a793$var$CROP_CY + ty - nat.h * scale / 2,
                                pointerEvents: 'none'
                            } : {
                                position: 'absolute',
                                opacity: 0,
                                pointerEvents: 'none'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            viewBox: `0 0 ${$80877663f582a793$var$CONT_W} ${$80877663f582a793$var$CONT_H}`,
                            style: {
                                position: 'absolute',
                                inset: 0,
                                width: $80877663f582a793$var$CONT_W,
                                height: $80877663f582a793$var$CONT_H,
                                pointerEvents: 'none'
                            },
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("mask", {
                                        id: "avatarCropMask",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: $80877663f582a793$var$CONT_W,
                                                height: $80877663f582a793$var$CONT_H,
                                                fill: "white"
                                            }),
                                            shape === 'circle' ? /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: $80877663f582a793$var$CROP_CX,
                                                cy: $80877663f582a793$var$CROP_CY,
                                                r: $80877663f582a793$var$CROP_R,
                                                fill: "black"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                x: boxL,
                                                y: boxT,
                                                width: boxW,
                                                height: boxH,
                                                rx: "8",
                                                fill: "black"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    width: $80877663f582a793$var$CONT_W,
                                    height: $80877663f582a793$var$CONT_H,
                                    fill: "rgba(0,0,0,0.5)",
                                    mask: "url(#avatarCropMask)"
                                }),
                                shape === 'circle' ? /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: $80877663f582a793$var$CROP_CX,
                                    cy: $80877663f582a793$var$CROP_CY,
                                    r: $80877663f582a793$var$CROP_R,
                                    fill: "none",
                                    stroke: "rgba(255,255,255,0.75)",
                                    strokeWidth: "1.5",
                                    strokeDasharray: "6 4"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    x: boxL,
                                    y: boxT,
                                    width: boxW,
                                    height: boxH,
                                    rx: "8",
                                    fill: "none",
                                    stroke: "rgba(255,255,255,0.75)",
                                    strokeWidth: "1.5",
                                    strokeDasharray: "6 4"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'absolute',
                                bottom: 10,
                                insetInline: 0,
                                textAlign: 'center',
                                fontSize: 11,
                                color: 'rgba(255,255,255,0.8)',
                                pointerEvents: 'none'
                            },
                            children: t('settings.avatar.cropHint')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '14px 22px 0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 11,
                                color: (0, $jTCZr.C).textMuted,
                                flexShrink: 0
                            },
                            children: t('settings.avatar.small')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "range",
                            min: minScale,
                            max: minScale * $80877663f582a793$var$MAX_ZOOM_FACTOR,
                            step: 0.01,
                            value: scale,
                            onChange: (e)=>setScale(parseFloat(e.target.value)),
                            "aria-label": t('settings.avatar.zoom'),
                            style: {
                                flex: 1,
                                accentColor: (0, $jTCZr.C).navy
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 11,
                                color: (0, $jTCZr.C).textMuted,
                                flexShrink: 0
                            },
                            children: t('settings.avatar.large')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogFooter), {
                    style: {
                        padding: '16px 22px 20px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: ()=>onOpenChange(false),
                            disabled: busy,
                            children: t('common.actions.cancel')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "default",
                            onClick: handleConfirm,
                            disabled: busy || !nat,
                            "data-testid": "avatar-crop-confirm",
                            children: busy ? t('common.state.saving') : t('common.actions.confirmAndSave')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
                    ref: canvasRef,
                    style: {
                        display: 'none'
                    }
                })
            ]
        })
    });
}
function $80877663f582a793$var$clamp(v, lo, hi) {
    return Math.max(lo, Math.min(v, hi));
}





const $3d5fad4093839d7c$export$efee071abbf6ae48 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $3d5fad4093839d7c$export$552a7750aeca1563 = ()=>(0, $acw62.useContext)($3d5fad4093839d7c$export$efee071abbf6ae48);
function $3d5fad4093839d7c$export$a65bf02e6d3bf43d() {
    const { t: t, has: has } = (0, $LNQP4.default)();
    return (err)=>err ? (0, $6dd1a0ec80cef79b$export$9bef418888ccb2cd)(err, {
            t: t,
            has: has
        }, 'errors.save.generic') : '';
}
function $3d5fad4093839d7c$export$ee7b405cffbc9dfd({ error: error, testId: testId }) {
    const errorText = $3d5fad4093839d7c$export$a65bf02e6d3bf43d();
    if (!error) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "error",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        "data-testid": testId,
        children: errorText(error)
    });
}
function $3d5fad4093839d7c$export$1b74141c5fe63a28({ value: value, max: max, testId: testId }) {
    const { formatNumber: formatNumber } = (0, $LNQP4.default)();
    const n = (0, $6f0813e0b3e01b00$export$36cc835d2490c0fc)(value);
    const over = max && n > max;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        "data-testid": testId,
        style: {
            fontSize: '0.6875rem',
            color: over ? (0, $jTCZr.C).red : (0, $jTCZr.C).textMuted,
            fontVariantNumeric: 'tabular-nums'
        },
        children: [
            formatNumber(n),
            " / ",
            formatNumber(max)
        ]
    });
}
function $3d5fad4093839d7c$export$944d2aeaf19f3dde({ status: status, error: error, onSave: onSave, onReset: onReset, disabled: disabled = false, testId: testId, saveLabel: saveLabel }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const errorText = $3d5fad4093839d7c$export$a65bf02e6d3bf43d();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.75rem'
        },
        children: [
            status === 'error' && error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
                    size: 16,
                    "aria-hidden": true
                }),
                "data-testid": testId ? `${testId}-error` : undefined,
                children: errorText(error)
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        role: "status",
                        "aria-live": "polite",
                        style: {
                            flex: 1,
                            minWidth: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.375rem'
                        },
                        children: [
                            status === 'saving' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: 14
                                    }),
                                    " ",
                                    s('myPage.save.saving')
                                ]
                            }),
                            status === 'saved' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            color: (0, $jTCZr.C).green
                                        }
                                    }),
                                    " ",
                                    s('myPage.save.saved')
                                ]
                            }),
                            status === 'dirty' && s('myPage.save.dirty')
                        ]
                    }),
                    onReset && (status === 'dirty' || status === 'error') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        onClick: onReset,
                        "data-testid": testId ? `${testId}-reset` : undefined,
                        children: s('myPage.save.reset')
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "sm",
                        onClick: onSave,
                        disabled: disabled || status === 'saving' || !(status === 'dirty' || status === 'error'),
                        "data-testid": testId ? `${testId}-save` : undefined,
                        children: saveLabel || s('myPage.save.save')
                    })
                ]
            })
        ]
    });
}
function $3d5fad4093839d7c$export$523acc1bb0ce2e43({ index: index, count: count, onMove: onMove, onRemove: onRemove, disabled: disabled, testId: testId, removeLabel: removeLabel }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                variant: "ghost",
                size: 36,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $azOWV.default), {
                    size: 16,
                    "aria-hidden": true
                }),
                label: s('myPage.items.moveUp'),
                disabled: disabled || index === 0,
                onClick: ()=>onMove(index, -1),
                "data-testid": testId ? `${testId}-up` : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                variant: "ghost",
                size: 36,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                    size: 16,
                    "aria-hidden": true
                }),
                label: s('myPage.items.moveDown'),
                disabled: disabled || index === count - 1,
                onClick: ()=>onMove(index, 1),
                "data-testid": testId ? `${testId}-down` : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                variant: "ghost",
                size: 36,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lpOUO.default), {
                    size: 16,
                    "aria-hidden": true
                }),
                label: removeLabel || s('myPage.items.remove'),
                disabled: disabled,
                onClick: ()=>onRemove(index),
                "data-testid": testId ? `${testId}-remove` : undefined
            })
        ]
    });
}
function $3d5fad4093839d7c$export$ec937e64de6c1257(list, index, delta) {
    const to = index + delta;
    if (to < 0 || to >= list.length) return list;
    const next = [
        ...list
    ];
    const [item] = next.splice(index, 1);
    next.splice(to, 0, item);
    return next;
}
const $3d5fad4093839d7c$export$3cc98f8645343732 = {
    portrait: {
        aspect: 1,
        outWidth: 800,
        shape: 'circle'
    },
    cover: {
        aspect: 3,
        outWidth: 1600,
        shape: 'rect'
    },
    gallery: {
        aspect: 4 / 3,
        outWidth: 1024,
        shape: 'rect'
    },
    service: {
        aspect: 4 / 3,
        outWidth: 800,
        shape: 'rect'
    },
    article: {
        aspect: 16 / 9,
        outWidth: 1200,
        shape: 'rect'
    }
};
function $3d5fad4093839d7c$export$2a10fa892fe6389c({ slot: slot, media: media, busy: busy = false, disabled: disabled = false, onUpload: onUpload, onRemove: onRemove, label: label, hint: hint, testId: testId }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const toast = (0, $6usBW.useToast)();
    const inputRef = (0, $acw62.useRef)(null);
    const [src, setSrc] = (0, $acw62.useState)(null);
    const [confirmRemove, setConfirmRemove] = (0, $acw62.useState)(false);
    const crop = $3d5fad4093839d7c$export$3cc98f8645343732[slot] || $3d5fad4093839d7c$export$3cc98f8645343732.gallery;
    const onFile = (e)=>{
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) return;
        if (![
            'image/jpeg',
            'image/png'
        ].includes(file.type)) {
            toast.error(s('myPage.image.typeUnsupported'));
            return;
        }
        if (file.size > (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).image_upload_bytes_max) {
            toast.error(s('myPage.image.tooLarge'));
            return;
        }
        const reader = new FileReader();
        reader.onload = ()=>setSrc(String(reader.result));
        reader.onerror = ()=>toast.error(s('myPage.image.readFailed'));
        reader.readAsDataURL(file);
    };
    const ratio = `${crop.aspect} / 1`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            display: 'grid',
            gap: '0.5rem'
        },
        children: [
            label ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: label
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": true,
                        style: {
                            width: slot === 'portrait' ? '4.5rem' : '9rem',
                            aspectRatio: ratio,
                            borderRadius: slot === 'portrait' ? (0, $jTCZr.RADIUS).pill : (0, $jTCZr.RADIUS).control,
                            background: media?.url ? `center / cover no-repeat url("${media.url}")` : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06),
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: (0, $jTCZr.C).textMuted,
                            flexShrink: 0
                        },
                        children: media?.url ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41e90a55419824f7$export$2e2bcd8739ae039), {
                            size: 20,
                            strokeWidth: 1.5
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '0.5rem',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                variant: "outline",
                                size: "sm",
                                disabled: disabled || busy,
                                onClick: ()=>inputRef.current?.click(),
                                "data-testid": testId ? `${testId}-pick` : undefined,
                                children: [
                                    busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: 14
                                    }) : null,
                                    media ? s('myPage.image.replace') : s('myPage.image.pick')
                                ]
                            }),
                            media && onRemove ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                size: "sm",
                                disabled: disabled || busy,
                                onClick: ()=>setConfirmRemove(true),
                                "data-testid": testId ? `${testId}-remove` : undefined,
                                children: s('myPage.image.remove')
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: inputRef,
                        type: "file",
                        accept: "image/jpeg,image/png",
                        hidden: true,
                        onChange: onFile
                    })
                ]
            }),
            hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: hint
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80877663f582a793$export$2e2bcd8739ae039), {
                open: !!src,
                onOpenChange: (open)=>{
                    if (!open) setSrc(null);
                },
                src: src,
                busy: busy,
                aspect: crop.aspect,
                outWidth: crop.outWidth,
                shape: crop.shape,
                title: s('myPage.image.cropTitle'),
                onCrop: async (dataUrl)=>{
                    const ok = await onUpload(dataUrl);
                    if (ok !== false) setSrc(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: confirmRemove,
                onOpenChange: setConfirmRemove,
                title: s('myPage.image.removeTitle'),
                description: s('myPage.image.removeBody'),
                confirmLabel: s('myPage.image.removeConfirm'),
                destructive: true,
                loading: busy,
                onConfirm: async ()=>{
                    await onRemove();
                    setConfirmRemove(false);
                }
            })
        ]
    });
}
function $3d5fad4093839d7c$export$6ac00e15d0217879({ title: title, aside: aside, children: children, testId: testId, id: id, active: active = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: id,
        "data-testid": testId,
        "data-active": active || undefined,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: active ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12)}` : '0 1px 4px rgba(0,0,0,0.06)',
            padding: '1.25rem',
            display: 'grid',
            gap: '1rem',
            minWidth: 0,
            // Keeps a card scrolled to from the rail clear of the sticky page header.
            scrollMarginTop: '1rem',
            transition: 'border-color 150ms, box-shadow 150ms'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: '0.9375rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            flex: 1,
                            minWidth: 0
                        },
                        children: title
                    }),
                    aside
                ]
            }),
            children
        ]
    });
}
function $3d5fad4093839d7c$export$dbe2aedc96d1a17d({ errors: errors, testId: testId }) {
    if (!errors?.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            style: {
                margin: 0,
                paddingInlineStart: '1.1rem',
                display: 'grid',
                gap: '0.25rem'
            },
            children: errors.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    dir: "auto",
                    children: e.message
                }, `${e.code}-${e.field}-${i}`))
        })
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// The builder's rail: where the page stands (status card), what it looks like
// (template + theme), where it lives (slug) and what it holds (sections).
// ─────────────────────────────────────────────────────────────────────────────
const $a5c08531ef3e7962$var$railCard = {
    background: (0, $jTCZr.C).card,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    padding: '1rem',
    display: 'grid',
    gap: '0.75rem',
    minWidth: 0
};
const $a5c08531ef3e7962$var$railTitle = {
    margin: 0,
    fontSize: '0.875rem',
    fontWeight: 800,
    color: (0, $jTCZr.C).textPrimary
};
function $a5c08531ef3e7962$export$b97775e0f6759140({ page: page, cards: cards, onPreview: onPreview, onPublishClick: onPublishClick, onUnpublish: onUnpublish, testId: testId = 'my-page-status' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const toast = (0, $6usBW.useToast)();
    const errorText = (0, $3d5fad4093839d7c$export$a65bf02e6d3bf43d)();
    const { formatDateTime: formatDateTime } = (0, $LNQP4.default)();
    const [confirmUnpublish, setConfirmUnpublish] = (0, $acw62.useState)(false);
    const { canPublish: canPublish, reasons: reasons, suspended: suspended } = (0, $6f0813e0b3e01b00$export$e979e5c05b4e89be)(page);
    const live = (0, $6f0813e0b3e01b00$export$59fa923597ae4a6)(page);
    const previewBusy = !!cards.preview?.saving;
    const publishBusy = !!cards.publish?.saving;
    const copy = async ()=>{
        try {
            await navigator.clipboard.writeText(page.publicUrl);
            toast.success(s('myPage.statusCard.copied'));
        } catch  {
            toast.error(s('myPage.statusCard.copyFailed'));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        "data-status": page.status || 'unknown',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            ...$a5c08531ef3e7962$var$railTitle,
                            flex: 1
                        },
                        children: s('myPage.statusCard.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: (0, $6f0813e0b3e01b00$export$ed8e8b95f038b742)[page.status] || 'outline',
                        "data-testid": `${testId}-badge`,
                        children: s((0, $6f0813e0b3e01b00$export$5aeba3c817b68975)(page.status))
                    })
                ]
            }),
            page.publicUrl ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: '0.375rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: live ? s('myPage.statusCard.liveUrl') : s('myPage.statusCard.futureUrl')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.375rem',
                            minWidth: 0
                        },
                        children: [
                            live ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: page.publicUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                dir: "ltr",
                                "data-testid": `${testId}-url`,
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    fontSize: '0.8125rem',
                                    color: (0, $jTCZr.C).navy,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    unicodeBidi: 'isolate'
                                },
                                children: page.publicUrl
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "ltr",
                                "data-testid": `${testId}-url`,
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    fontSize: '0.8125rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    unicodeBidi: 'isolate'
                                },
                                children: page.publicUrl
                            }),
                            live ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                variant: "ghost",
                                size: 36,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $807d71b9253536b4$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                label: s('myPage.statusCard.copy'),
                                onClick: copy,
                                "data-testid": `${testId}-copy`
                            }) : null
                        ]
                    }),
                    live && page.publishedAtMs ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.statusCard.lastPublished', {
                            date: formatDateTime(Number(page.publishedAtMs))
                        })
                    }) : null
                ]
            }) : null,
            !suspended ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: onPreview,
                        disabled: previewBusy,
                        "data-testid": `${testId}-preview`,
                        className: "w-full",
                        children: [
                            previewBusy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            s('myPage.statusCard.preview')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        onClick: onPublishClick,
                        disabled: !canPublish || publishBusy,
                        "data-testid": `${testId}-publish`,
                        className: "w-full",
                        "aria-describedby": !canPublish && reasons.length ? `${testId}-blockers` : undefined,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6OGKD.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            live ? s('myPage.statusCard.republish') : s('myPage.statusCard.publish')
                        ]
                    }),
                    live ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "ghost",
                        onClick: ()=>setConfirmUnpublish(true),
                        disabled: publishBusy,
                        "data-testid": `${testId}-unpublish`,
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eee9f5221939b065$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            s('myPage.statusCard.unpublish')
                        ]
                    }) : null
                ]
            }) : null,
            cards.preview?.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                children: errorText(cards.preview.error)
            }) : null,
            !canPublish && reasons.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: `${testId}-blockers`,
                "data-testid": `${testId}-blockers`,
                style: {
                    display: 'grid',
                    gap: '0.375rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: s('myPage.statusCard.blockersTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        style: {
                            margin: 0,
                            paddingInlineStart: '1.1rem',
                            display: 'grid',
                            gap: '0.25rem',
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: reasons.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                dir: "auto",
                                children: r.message
                            }, `${r.code}-${i}`))
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: confirmUnpublish,
                onOpenChange: setConfirmUnpublish,
                title: s('myPage.statusCard.unpublishTitle'),
                description: s('myPage.statusCard.unpublishBody'),
                confirmLabel: s('myPage.statusCard.unpublishConfirm'),
                destructive: true,
                loading: publishBusy,
                onConfirm: async ()=>{
                    const ok = await onUnpublish();
                    if (ok) setConfirmUnpublish(false);
                },
                confirmTestId: `${testId}-unpublish-confirm`
            })
        ]
    });
}
// ── Template picker ─────────────────────────────────────────────────────────
/** A CSS-only schematic of a template's first screen — no images. */ function $a5c08531ef3e7962$var$TemplateThumb({ id: id }) {
    const bar = (w, h = 4, tone = 0.18)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                display: 'block',
                width: w,
                height: h,
                borderRadius: 2,
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, tone)
            }
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": true,
        style: {
            display: 'grid',
            gap: 4,
            alignContent: 'start',
            padding: 6,
            height: '4.25rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        },
        children: id === 'modern' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        display: 'block',
                        height: 18,
                        borderRadius: 3,
                        background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35)
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        gap: 3
                    },
                    children: [
                        0,
                        1,
                        2
                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                height: 14,
                                borderRadius: 3,
                                background: (0, $jTCZr.C).card,
                                border: `1px solid ${(0, $jTCZr.C).border}`
                            }
                        }, i))
                })
            ]
        }) : id === 'minimal' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                bar('55%', 6, 0.4),
                bar('80%'),
                bar('70%'),
                bar('40%', 4, 0.1),
                bar('75%')
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            style: {
                display: 'flex',
                gap: 5,
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35),
                        flexShrink: 0
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    style: {
                        display: 'grid',
                        gap: 3,
                        flex: 1
                    },
                    children: [
                        bar('70%', 5, 0.35),
                        bar('90%'),
                        bar('60%')
                    ]
                })
            ]
        })
    });
}
function $a5c08531ef3e7962$export$676410d4b8e9f49b({ page: page, cards: cards, onChange: onChange, readOnly: readOnly, testId: testId = 'my-page-template' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const busy = !!cards.template?.saving;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: $a5c08531ef3e7962$var$railTitle,
                children: s('myPage.template.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "radiogroup",
                "aria-label": s('myPage.template.title'),
                style: {
                    display: 'grid',
                    gap: '0.5rem'
                },
                children: (0, $6f0813e0b3e01b00$export$a8fc3402335b0b04)().map((tpl)=>{
                    const active = tpl.id === (0, $6f0813e0b3e01b00$export$49bf6523f9e347bb)(page.templateId).id;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "ghost",
                        role: "radio",
                        "aria-checked": active,
                        disabled: readOnly || busy,
                        onClick: ()=>{
                            if (!active) onChange(tpl.id);
                        },
                        "data-testid": `${testId}-${tpl.id}`,
                        className: "h-auto w-full justify-start rounded-xl p-2 font-normal",
                        style: {
                            display: 'grid',
                            gridTemplateColumns: '5rem minmax(0,1fr)',
                            gap: '0.75rem',
                            textAlign: 'start',
                            border: `1.5px solid ${active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                            background: active ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05) : (0, $jTCZr.C).card
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a5c08531ef3e7962$var$TemplateThumb, {
                                id: tpl.id
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'grid',
                                    gap: '0.25rem',
                                    minWidth: 0,
                                    whiteSpace: 'normal'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.8125rem',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: s(`myPage.templates.${tpl.id}.name`)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.C).textSecondary,
                                            lineHeight: 1.6
                                        },
                                        children: s(`myPage.templates.${tpl.id}.description`)
                                    })
                                ]
                            })
                        ]
                    }, tpl.id);
                })
            }),
            busy ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "status",
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.save.saving')
            }) : null
        ]
    });
}
const $a5c08531ef3e7962$export$f7e382edaf78bc8f = (page, templateId)=>({
        templateId: templateId,
        theme: (0, $6f0813e0b3e01b00$export$d0abcb2af59a5607)(templateId, page.theme)
    });
function $a5c08531ef3e7962$export$c1e6afee7dab8877({ page: page, cards: cards, onChange: onChange, readOnly: readOnly, testId: testId = 'my-page-theme' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const tpl = (0, $6f0813e0b3e01b00$export$49bf6523f9e347bb)(page.templateId);
    const theme = (0, $6f0813e0b3e01b00$export$5c13f8645b3802cd)(page.templateId, page.theme);
    const busy = !!cards.theme?.saving;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: $a5c08531ef3e7962$var$railTitle,
                children: s('myPage.theme.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.theme.palette')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "radiogroup",
                "aria-label": s('myPage.theme.palette'),
                style: {
                    display: 'flex',
                    gap: '0.5rem',
                    flexWrap: 'wrap'
                },
                children: tpl.palettes.map((p)=>{
                    const active = p.id === theme.palette;
                    const name = s(`myPage.palettes.${p.id}`);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        role: "radio",
                        "aria-checked": active,
                        "aria-label": name,
                        title: name,
                        disabled: readOnly || busy,
                        onClick: ()=>{
                            if (!active) onChange({
                                ...theme,
                                palette: p.id
                            });
                        },
                        "data-testid": `${testId}-palette-${p.id}`,
                        className: "h-11 w-11 rounded-full p-0",
                        style: {
                            border: `2px solid ${active ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).border}`,
                            padding: 3
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            "aria-hidden": true,
                            style: {
                                display: 'block',
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%',
                                background: `linear-gradient(135deg, ${p.primary} 0 55%, ${p.accent} 55% 100%)`
                            }
                        })
                    }, p.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.theme.density')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                size: "sm",
                ariaLabel: s('myPage.theme.density'),
                testId: `${testId}-density`,
                value: theme.density,
                onChange: (d)=>{
                    if (!readOnly && !busy && d !== theme.density) onChange({
                        ...theme,
                        density: d
                    });
                },
                items: tpl.densities.map((d)=>({
                        id: d,
                        label: s(`myPage.theme.densities.${d}`)
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: s('myPage.theme.onlyTemplate')
            })
        ]
    });
}
function $a5c08531ef3e7962$export$cff5ea1de693973({ page: page, cards: cards, onSave: onSave, readOnly: readOnly, testId: testId = 'my-page-slug' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const errorText = (0, $3d5fad4093839d7c$export$a65bf02e6d3bf43d)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const [value, setValue] = (0, $acw62.useState)(page.slug || '');
    (0, $acw62.useEffect)(()=>{
        setValue(page.slug || '');
    }, [
        page.slug
    ]);
    const normalized = (0, $6f0813e0b3e01b00$export$95f2253c4751dcdb)(value);
    const formatError = (0, $6f0813e0b3e01b00$export$f0fedd4f36c4c1fa)(normalized);
    const changed = normalized !== (page.slug || '');
    const { checking: checking, result: result } = (0, $3b62335a4d4d6420$export$98ae58d30495b901)(normalized, {
        enabled: !page.slugLocked && changed && !formatError
    });
    const busy = !!cards.slug?.saving;
    if (page.slugLocked) return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        "data-state": "locked",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: $a5c08531ef3e7962$var$railTitle,
                children: s('myPage.slug.label')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textPrimary
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true,
                        style: {
                            color: (0, $jTCZr.C).textSecondary,
                            flexShrink: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "ltr",
                        style: {
                            unicodeBidi: 'isolate',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: page.slug
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.slug.lockedHint')
            })
        ]
    });
    const availabilityError = changed && !formatError && result && !result.available ? result.message || s('myPage.slug.taken') : '';
    const fieldError = changed && formatError ? s(formatError) : availabilityError;
    const canSave = changed && !formatError && !checking && result?.available && !busy && !readOnly;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        "data-state": "editable",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: $a5c08531ef3e7962$var$railTitle,
                children: s('myPage.slug.label')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                dir: "ltr",
                value: value,
                onChange: (e)=>setValue(e.target.value),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).slug_max,
                disabled: readOnly,
                error: fieldError,
                helperText: !fieldError ? s('myPage.slug.hint') : undefined,
                "aria-label": s('myPage.slug.label'),
                inputStyle: fieldStyle,
                "data-testid": `${testId}-input`,
                autoComplete: "off"
            }),
            changed && !formatError ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "status",
                "aria-live": "polite",
                style: {
                    fontSize: '0.75rem',
                    color: result?.available ? (0, $jTCZr.C).green : (0, $jTCZr.C).textSecondary
                },
                children: checking ? s('myPage.slug.checking') : result?.available ? s('myPage.slug.available') : null
            }) : null,
            cards.slug?.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                children: errorText(cards.slug.error)
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                size: "sm",
                disabled: !canSave,
                onClick: ()=>onSave(normalized),
                "data-testid": `${testId}-save`,
                children: [
                    busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                        size: 14
                    }) : null,
                    s('myPage.slug.save')
                ]
            })
        ]
    });
}
function $a5c08531ef3e7962$export$6d1d899ad8590d82({ page: page, cards: cards, selected: selected, onSelect: onSelect, onToggle: onToggle, onMove: onMove, readOnly: readOnly, publishErrors: publishErrors, testId: testId = 'my-page-sections' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const sections = (0, $6f0813e0b3e01b00$export$53e69196b53dea9f)(page.sections);
    const errorsByKind = (0, $6f0813e0b3e01b00$export$cb46fb9ca2e05378)([
        ...page.publishBlockers || [],
        ...publishErrors || []
    ]);
    const busy = !!cards.sections?.saving;
    const errorText = (0, $3d5fad4093839d7c$export$a65bf02e6d3bf43d)();
    const onKeyDown = (e, kind)=>{
        if (!e.altKey || e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        const kinds = (0, $6f0813e0b3e01b00$export$5977caaf27b6313d)(sections, kind, e.key === 'ArrowUp' ? -1 : 1);
        if (kinds && !readOnly && !busy) onMove(kinds);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $a5c08531ef3e7962$var$railCard,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: $a5c08531ef3e7962$var$railTitle,
                children: s('myPage.sections.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: s('myPage.sections.reorderHint')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                style: {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    display: 'grid',
                    gap: '0.25rem'
                },
                children: sections.map((sec, i)=>{
                    const active = selected === sec.kind;
                    const hasErrors = !!errorsByKind[sec.kind]?.length;
                    const toggleCard = cards[`toggle-${sec.kind}`];
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        "data-testid": `${testId}-${sec.kind}`,
                        "data-enabled": sec.enabled,
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            padding: '0.25rem',
                            borderRadius: (0, $jTCZr.RADIUS).control,
                            background: active ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07) : 'transparent'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                "aria-current": active ? 'true' : undefined,
                                onClick: ()=>onSelect(sec.kind),
                                onKeyDown: (e)=>onKeyDown(e, sec.kind),
                                "data-testid": `${testId}-${sec.kind}-open`,
                                className: "h-auto min-h-11 flex-1 justify-start rounded-lg px-2 py-1.5 font-normal",
                                style: {
                                    minWidth: 0,
                                    textAlign: 'start',
                                    whiteSpace: 'normal'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        display: 'grid',
                                        gap: '0.125rem',
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                fontWeight: 600,
                                                color: sec.enabled ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.375rem'
                                            },
                                            children: [
                                                s(`myPage.sections.kinds.${sec.kind}`),
                                                hasErrors ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                                                    size: 14,
                                                    "aria-label": s('myPage.sections.hasErrors'),
                                                    style: {
                                                        color: (0, $jTCZr.C).amber,
                                                        flexShrink: 0
                                                    }
                                                }) : null
                                            ]
                                        }),
                                        !sec.supportedByTemplate ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textSecondary,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.25rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a80d2cd266adcc$export$2e2bcd8739ae039), {
                                                    size: 12,
                                                    "aria-hidden": true
                                                }),
                                                " ",
                                                s('myPage.sections.unsupported')
                                            ]
                                        }) : sec.titleOverride ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            dir: "auto",
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: (0, $6f0813e0b3e01b00$export$1a952fe22cdce89e)(sec)
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                                checked: sec.enabled,
                                disabled: readOnly || sec.required || !!toggleCard?.saving,
                                onChange: (v)=>onToggle(sec.kind, v === true),
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "sr-only",
                                    children: s('myPage.sections.show', {
                                        name: s(`myPage.sections.kinds.${sec.kind}`)
                                    })
                                }),
                                "data-testid": `${testId}-${sec.kind}-toggle`,
                                title: sec.required ? s('myPage.sections.required') : undefined
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                variant: "ghost",
                                size: 32,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $azOWV.default), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: s('myPage.sections.moveUp', {
                                    name: s(`myPage.sections.kinds.${sec.kind}`)
                                }),
                                disabled: readOnly || busy || i === 0,
                                onClick: ()=>{
                                    const k = (0, $6f0813e0b3e01b00$export$5977caaf27b6313d)(sections, sec.kind, -1);
                                    if (k) onMove(k);
                                },
                                "data-testid": `${testId}-${sec.kind}-up`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                variant: "ghost",
                                size: 32,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: s('myPage.sections.moveDown', {
                                    name: s(`myPage.sections.kinds.${sec.kind}`)
                                }),
                                disabled: readOnly || busy || i === sections.length - 1,
                                onClick: ()=>{
                                    const k = (0, $6f0813e0b3e01b00$export$5977caaf27b6313d)(sections, sec.kind, 1);
                                    if (k) onMove(k);
                                },
                                "data-testid": `${testId}-${sec.kind}-down`
                            })
                        ]
                    }, sec.kind);
                })
            }),
            cards.sections?.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                children: errorText(cards.sections.error)
            }) : null,
            sections.filter((sec)=>cards[`toggle-${sec.kind}`]?.error).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dOauK.default), {
                    variant: "error",
                    "data-testid": `${testId}-${sec.kind}-toggle-error`,
                    children: [
                        s('myPage.sections.toggleFailed', {
                            name: s(`myPage.sections.kinds.${sec.kind}`)
                        }),
                        ' ',
                        errorText(cards[`toggle-${sec.kind}`].error)
                    ]
                }, sec.kind))
        ]
    });
}
function $a5c08531ef3e7962$export$94d3e53a4bb1317c({ page: page, testId: testId = 'my-page-banner' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    if (page.status === 'suspended') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dOauK.default), {
        variant: "error",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
            size: 16,
            "aria-hidden": true
        }),
        title: s('myPage.banner.suspendedTitle'),
        "data-testid": `${testId}-suspended`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                dir: "auto",
                children: page.suspendedReason || s('myPage.banner.suspendedNoReason')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: '0.25rem'
                },
                children: s('myPage.banner.suspendedSupport')
            })
        ]
    });
    if (page.hasUnpublishedChanges && (0, $6f0813e0b3e01b00$export$f23acc97a99da739)(page)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3cce873667d965dd$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        "data-testid": `${testId}-unpublished`,
        children: s('myPage.banner.unpublishedChanges')
    });
    return null;
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bo0GS = parcelRequire("bo0GS");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");


function $824be4914b20c2ed$export$2e2bcd8739ae039({ open: open, onClose: onClose, onPublish: onPublish, busy: busy, error: error, isMobile: isMobile, testId: testId = 'my-page-publish' }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const errorText = (0, $3d5fad4093839d7c$export$a65bf02e6d3bf43d)();
    const [accepted, setAccepted] = (0, $acw62.useState)(false);
    const [refusal, setRefusal] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setAccepted(false);
            setRefusal([]);
        }
    }, [
        open
    ]);
    const submit = async ()=>{
        const res = await onPublish(accepted);
        if (res?.ok && res.published) onClose();
        else if (res?.ok) setRefusal(res.errors || []);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gCvEY.default), {
        open: open,
        onClose: onClose,
        busy: busy,
        isMobile: isMobile,
        size: "md",
        title: s('myPage.publish.title'),
        "data-testid": testId,
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                justifyContent: 'flex-end',
                width: '100%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "ghost",
                    onClick: onClose,
                    disabled: busy,
                    "data-testid": `${testId}-cancel`,
                    children: s('myPage.publish.cancel')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    onClick: submit,
                    disabled: !accepted || busy,
                    "data-testid": `${testId}-confirm`,
                    children: s('myPage.publish.confirm')
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'grid',
                gap: '1rem',
                fontSize: '0.8125rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.9
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'flex-start'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bo0GS.default), {
                            size: 18,
                            "aria-hidden": true,
                            style: {
                                color: (0, $jTCZr.C).navy,
                                flexShrink: 0,
                                marginTop: '0.25rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                margin: 0
                            },
                            children: s('myPage.publish.intro')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    style: {
                        margin: 0,
                        paddingInlineStart: '1.25rem',
                        display: 'grid',
                        gap: '0.375rem',
                        color: (0, $jTCZr.C).textSecondary
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: s('myPage.publish.rule1')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: s('myPage.publish.rule2')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: s('myPage.publish.rule3')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: s('myPage.publish.rule4')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "info",
                    children: s('myPage.publish.public')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                    checked: accepted,
                    onChange: (v)=>setAccepted(v === true),
                    label: s('myPage.publish.accept'),
                    disabled: busy,
                    "data-testid": `${testId}-accept`
                }),
                refusal.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "error",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb1b2f70e9c265fc$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    title: s('myPage.publish.failedTitle'),
                    "data-testid": `${testId}-errors`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        style: {
                            margin: 0,
                            paddingInlineStart: '1.1rem',
                            display: 'grid',
                            gap: '0.25rem'
                        },
                        children: refusal.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                dir: "auto",
                                children: e.message
                            }, `${e.code}-${i}`))
                    })
                }) : null,
                error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "error",
                    children: errorText(error)
                }) : null
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gYS9K = parcelRequire("gYS9K");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4c9146903faa6a3a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $4c9146903faa6a3a$export$2e2bcd8739ae039 = (0, $9QBug.default)("phone", $4c9146903faa6a3a$export$3efd853dbb351e94);


parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $66joL = parcelRequire("66joL");
var $jFCWB = parcelRequire("jFCWB");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




// ─────────────────────────────────────────────────────────────────────────────
// «درخواست‌های صفحه» — read-only (design §8.6). Working a request stays in the
// CRM queue; this tab only lets the doctor see who asked. One column
// definition drives the desktop table and the phone's cards.
// ─────────────────────────────────────────────────────────────────────────────
const $2887aa11b36d671f$var$LEAD_STATUS_BADGE = {
    new: 'default',
    contacted: 'outline',
    qualified: 'outline',
    won: 'success',
    lost: 'outline'
};
function $2887aa11b36d671f$var$useLeadColumns() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { formatDateTime: formatDateTime, formatDigits: formatDigits } = (0, $LNQP4.default)();
    // A CRM status this build does not know renders as the raw value, never a key.
    const statusText = (v)=>v && (0, $031020e651fcb248$export$38fa0c517e0130c2)(`myPage.leads.statuses.${v}`) ? s(`myPage.leads.statuses.${v}`) : v || "\u2013";
    return [
        {
            key: 'name',
            header: s('myPage.leads.name'),
            render: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                    children: r.name || "\u2013"
                })
        },
        {
            key: 'mobile',
            header: s('myPage.leads.mobile'),
            render: (r)=>r.mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: `tel:${r.mobile}`,
                    dir: "ltr",
                    style: {
                        color: (0, $jTCZr.C).navy,
                        unicodeBidi: 'isolate'
                    },
                    children: formatDigits(r.mobile)
                }) : "\u2013"
        },
        {
            key: 'preference',
            header: s('myPage.leads.preference'),
            render: (r)=>[
                    r.preferredChannel ? s(`myPage.leads.channels.${r.preferredChannel}`) : null,
                    r.preferredTime ? s(`myPage.leads.times.${r.preferredTime}`) : null
                ].filter(Boolean).join(" \xb7 ") || "\u2013"
        },
        {
            key: 'message',
            header: s('myPage.leads.message'),
            render: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    dir: "auto",
                    children: r.message || "\u2013"
                })
        },
        {
            key: 'createdAt',
            header: s('myPage.leads.createdAt'),
            render: (r)=>r.createdAtMs ? formatDateTime(Number(r.createdAtMs)) : "\u2013"
        },
        {
            key: 'status',
            header: s('myPage.leads.status'),
            render: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                    variant: $2887aa11b36d671f$var$LEAD_STATUS_BADGE[r.status] || 'outline',
                    children: statusText(r.status)
                })
        }
    ];
}
function $2887aa11b36d671f$var$LeadsNotice({ published: published }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        "data-testid": "my-page-leads-empty",
        "data-state": "empty",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYS9K.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: published ? s('myPage.leads.emptyTitle') : s('myPage.leads.notPublishedTitle'),
        description: published ? s('myPage.leads.emptyHint') : s('myPage.leads.notPublishedHint')
    });
}
function $2887aa11b36d671f$export$a5e7d81c1988fd91({ leads: leads, published: published }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const columns = $2887aa11b36d671f$var$useLeadColumns();
    if (leads.error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page-leads",
        "data-state": "error",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: leads.error,
            title: s('myPage.leads.loadFailed'),
            onRetry: leads.retry
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "my-page-leads",
        "data-state": leads.loading ? 'loading' : leads.items.length ? 'content' : 'empty',
        style: {
            display: 'grid',
            gap: '1rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.leads.intro')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFCWB.default), {
                    columns: columns,
                    rows: leads.items,
                    loading: leads.loading && !leads.items.length,
                    ariaLabel: s('myPage.tabs.leads'),
                    empty: /*#__PURE__*/ (0, $ayMG0.jsx)($2887aa11b36d671f$var$LeadsNotice, {
                        published: published
                    }),
                    rowProps: (r)=>({
                            'data-testid': `my-page-leads-row-${r.id}`
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a27afae32c22d713$export$2e2bcd8739ae039), {
                page: leads.pageIndex + 1,
                pageCount: leads.pageCount,
                total: leads.total,
                pageSize: (0, $6f0813e0b3e01b00$export$5ec175ebc4bc2aa7),
                onPage: (p)=>leads.goTo(p - 1)
            })
        ]
    });
}
function $2887aa11b36d671f$export$97fae0ba49a9b95() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: s('myPage.loading'),
        "data-testid": "my-page-leads-loading",
        children: [
            0,
            1,
            2
        ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    padding: '12px 14px',
                    display: 'grid',
                    gap: 8,
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "45%",
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "30%",
                        height: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "70%",
                        height: 12
                    })
                ]
            }, i))
    });
}
function $2887aa11b36d671f$export$2143e15a5d8b9ec9({ leads: leads, published: published }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const columns = $2887aa11b36d671f$var$useLeadColumns();
    const col = Object.fromEntries(columns.map((c)=>[
            c.key,
            c
        ]));
    if (leads.error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page-leads",
        "data-state": "error",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: leads.error,
            title: s('myPage.leads.loadFailed'),
            onRetry: leads.retry
        })
    });
    if (leads.loading && !leads.items.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($2887aa11b36d671f$export$97fae0ba49a9b95, {});
    if (!leads.items.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page-leads",
        "data-state": "empty",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2887aa11b36d671f$var$LeadsNotice, {
            published: published
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "my-page-leads",
        "data-state": "content",
        style: {
            display: 'grid',
            gap: '0.5rem'
        },
        children: [
            leads.items.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                    "data-testid": `my-page-leads-row-${r.id}`,
                    style: {
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: (0, $jTCZr.RADIUS).card,
                        padding: '12px 14px',
                        display: 'grid',
                        gap: '0.375rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontWeight: 700,
                                        fontSize: '0.9375rem',
                                        color: (0, $jTCZr.C).textPrimary
                                    },
                                    children: col.name.render(r)
                                }),
                                col.status.render(r)
                            ]
                        }),
                        r.mobile ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.375rem',
                                fontSize: '0.875rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9146903faa6a3a$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true,
                                    style: {
                                        color: (0, $jTCZr.C).textSecondary
                                    }
                                }),
                                col.mobile.render(r)
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.8125rem',
                                color: (0, $jTCZr.C).textSecondary
                            },
                            children: col.preference.render(r)
                        }),
                        r.message ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.8125rem',
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: col.message.render(r)
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.75rem',
                                color: (0, $jTCZr.C).textSecondary
                            },
                            children: col.createdAt.render(r)
                        })
                    ]
                }, r.id)),
            leads.hasMore ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                onClick: leads.loadMore,
                disabled: leads.loading,
                "data-testid": "my-page-leads-more",
                className: "min-h-11 w-full",
                children: s('myPage.leads.more')
            }) : null
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");


var $acw62 = parcelRequire("acw62");

function $01dc03801d10c419$export$ba3bf943cd157d42(source) {
    const key = JSON.stringify(source);
    const baseRef = (0, $acw62.useRef)(source);
    const [draft, setDraft] = (0, $acw62.useState)(source);
    (0, $acw62.useEffect)(()=>{
        const prev = baseRef.current;
        baseRef.current = source;
        setDraft((d)=>(0, $6f0813e0b3e01b00$export$e173650de24e027d)(d, prev) ? source : d);
    // `key` stands for `source` by value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key
    ]);
    const adopt = (0, $acw62.useCallback)((value)=>{
        baseRef.current = value;
        setDraft(value);
    }, []);
    const reset = (0, $acw62.useCallback)(()=>setDraft(baseRef.current), []);
    return {
        draft: draft,
        setDraft: setDraft,
        dirty: !(0, $6f0813e0b3e01b00$export$e173650de24e027d)(draft, baseRef.current),
        adopt: adopt,
        reset: reset
    };
}
var $01dc03801d10c419$export$2e2bcd8739ae039 = $01dc03801d10c419$export$ba3bf943cd157d42;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("5N0ZI");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




// «کارت‌های معرفی» و «نکات برجسته» — the hero's two short lists (the
// landing-style templates draw them: «مدرن» puts the cards beside the portrait
// and the highlights in a strip under the hero, «کلاسیک» as ruled notes and a
// credentials bar). The doctor's own words; when a list is left empty the
// public page falls back to what it already states, and the hint says so.
//
// Both lists are ONE write — the hero section's content — so they share one
// «ذخیره», like the items of «خدمات».
const $9acef3553940a744$var$group = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    padding: '0.875rem',
    display: 'grid',
    gap: '0.75rem'
};
const $9acef3553940a744$var$groupTitle = {
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: (0, $jTCZr.C).textPrimary
};
const $9acef3553940a744$var$rowBox = {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'flex-end',
    flexWrap: 'wrap'
};
function $9acef3553940a744$var$ExtrasList({ listKey: listKey, items: items, onChange: onChange, readOnly: readOnly, titleKey: titleKey, hintKey: hintKey, addKey: addKey }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { formatNumber: formatNumber } = (0, $LNQP4.default)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const lim = (0, $6f0813e0b3e01b00$export$d32b44f1fb316170)[listKey];
    const patch = (idx, k, v)=>onChange(items.map((it, i)=>i === idx ? {
                ...it,
                [k]: v
            } : it));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $9acef3553940a744$var$group,
        "data-testid": `my-page-hero-${listKey}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            ...$9acef3553940a744$var$groupTitle,
                            flex: 1
                        },
                        children: s(titleKey)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.items.count', {
                            count: formatNumber(items.length),
                            max: formatNumber(lim.max)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s(hintKey)
            }),
            items.map((it, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $9acef3553940a744$var$rowBox,
                    "data-testid": `my-page-hero-${listKey}-${i}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: s('myPage.hero.extras.itemTitle'),
                            value: it.title,
                            onChange: (e)=>patch(i, 'title', e.target.value),
                            maxLength: lim.titleMax,
                            disabled: readOnly,
                            error: !it.title.trim() ? s('myPage.hero.extras.titleRequired') : undefined,
                            inputStyle: fieldStyle,
                            style: {
                                flex: '1 1 9rem'
                            },
                            "data-testid": `my-page-hero-${listKey}-${i}-title`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: s('myPage.hero.extras.itemText'),
                            value: it.text,
                            onChange: (e)=>patch(i, 'text', e.target.value),
                            maxLength: lim.textMax,
                            disabled: readOnly,
                            inputStyle: fieldStyle,
                            style: {
                                flex: '2 1 12rem'
                            },
                            "data-testid": `my-page-hero-${listKey}-${i}-text`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                            index: i,
                            count: items.length,
                            disabled: readOnly,
                            onMove: (idx, delta)=>onChange((0, $3d5fad4093839d7c$export$ec937e64de6c1257)(items, idx, delta)),
                            onRemove: (idx)=>onChange(items.filter((_, j)=>j !== idx)),
                            testId: `my-page-hero-${listKey}-${i}`
                        })
                    ]
                }, it.id)),
            items.length < lim.max && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                className: "justify-self-start",
                onClick: ()=>onChange([
                        ...items,
                        {
                            id: (0, $6f0813e0b3e01b00$export$fa41532ad359c5e)(),
                            title: '',
                            text: ''
                        }
                    ]),
                "data-testid": `my-page-hero-${listKey}-add`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    " ",
                    s(addKey)
                ]
            }) : null
        ]
    });
}
function $9acef3553940a744$export$2e2bcd8739ae039({ page: page, section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = (0, $01dc03801d10c419$export$ba3bf943cd157d42)((0, $6f0813e0b3e01b00$export$c23d3f52b03505fb)(section));
    const card = cards['hero-extras'] || {};
    const shown = (0, $6f0813e0b3e01b00$export$3aace564db59f0ed)(page.templateId);
    const save = async ()=>{
        const res = await actions.updateSection('hero-extras', 'hero', {
            content: (0, $6f0813e0b3e01b00$export$10dcba1188fc61cf)(draft)
        });
        if (res.ok) adopt((0, $6f0813e0b3e01b00$export$c23d3f52b03505fb)(res.page?.sections?.find((x)=>x.kind === 'hero')));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.875rem'
        },
        "data-testid": "my-page-hero-extras",
        children: [
            shown ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.hero.extras.onlyModern')
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "neutral",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a80d2cd266adcc$export$2e2bcd8739ae039), {
                    size: 16,
                    "aria-hidden": true
                }),
                "data-testid": "my-page-hero-extras-not-shown",
                children: s('myPage.hero.extras.notShown')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9acef3553940a744$var$ExtrasList, {
                listKey: "highlights",
                items: draft.highlights,
                readOnly: readOnly,
                onChange: (highlights)=>setDraft((d)=>({
                            ...d,
                            highlights: highlights
                        })),
                titleKey: "myPage.hero.extras.highlightsTitle",
                hintKey: "myPage.hero.extras.highlightsHint",
                addKey: "myPage.hero.extras.addHighlight"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9acef3553940a744$var$ExtrasList, {
                listKey: "cards",
                items: draft.cards,
                readOnly: readOnly,
                onChange: (list)=>setDraft((d)=>({
                            ...d,
                            cards: list
                        })),
                titleKey: "myPage.hero.extras.cardsTitle",
                hintKey: "myPage.hero.extras.cardsHint",
                addKey: "myPage.hero.extras.addCard"
            }),
            dirty || card.saving || card.error || card.savedAt ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: save,
                onReset: reset,
                disabled: readOnly || (0, $6f0813e0b3e01b00$export$cc30a234a47df063)(draft),
                testId: "my-page-hero-extras"
            }) : null
        ]
    });
}


function $5b42e6cda3f30220$export$2e2bcd8739ae039({ page: page, section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = (0, $01dc03801d10c419$export$ba3bf943cd157d42)((0, $6f0813e0b3e01b00$export$b59d2bd11ea795a)(page));
    const card = cards.hero || {};
    const set = (k)=>(e)=>setDraft((d)=>({
                    ...d,
                    [k]: e.target.value
                }));
    const invalid = !draft.displayName.trim() || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.displayName, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).display_name_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.headline, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).headline_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.aboutMd, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).about_md_max);
    const save = async ()=>{
        const res = await actions.updatePage('hero', {
            displayName: draft.displayName.trim(),
            headline: draft.headline.trim(),
            aboutMd: draft.aboutMd
        });
        if (res.ok) adopt((0, $6f0813e0b3e01b00$export$b59d2bd11ea795a)(res.page));
    };
    const upload = (slot)=>async (image)=>{
            const res = await actions.uploadImage(`img-${slot}`, {
                slot: slot,
                image: image,
                alt: draft.displayName || page.displayName
            });
            return res.ok;
        };
    const remove = (media)=>async ()=>{
            await actions.removeImage(`img-${media.slot}`, media.id);
        };
    const coverShown = (0, $6f0813e0b3e01b00$export$9e8077034eeecbde)(page.templateId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '1rem'
        },
        "data-testid": "my-page-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.hero.displayName'),
                value: draft.displayName,
                onChange: set('displayName'),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).display_name_max,
                disabled: readOnly,
                error: !draft.displayName.trim() && dirty ? s('myPage.hero.displayNameRequired') : undefined,
                inputStyle: fieldStyle,
                "data-testid": "my-page-hero-name"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.hero.headline'),
                placeholder: s('myPage.hero.headlinePlaceholder'),
                value: draft.headline,
                onChange: set('headline'),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).headline_max,
                disabled: readOnly,
                helperText: s('myPage.hero.headlineHint'),
                inputStyle: fieldStyle,
                "data-testid": "my-page-hero-headline"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                label: s('myPage.hero.about'),
                value: draft.aboutMd,
                onChange: set('aboutMd'),
                rows: 8,
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).about_md_max,
                showCount: true,
                disabled: readOnly,
                helperText: s('myPage.markdownHint'),
                inputStyle: fieldStyle,
                dir: "auto",
                "data-testid": "my-page-hero-about"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: save,
                onReset: reset,
                disabled: readOnly || invalid,
                testId: "my-page-hero"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: '1rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9acef3553940a744$export$2e2bcd8739ae039), {
                    page: page,
                    section: section,
                    actions: actions,
                    cards: cards,
                    readOnly: readOnly
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: '1rem',
                    display: 'grid',
                    gap: '1.25rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$2a10fa892fe6389c), {
                        slot: "portrait",
                        label: s('myPage.hero.portrait'),
                        hint: s('myPage.hero.portraitHint'),
                        media: page.portrait,
                        busy: !!cards['img-portrait']?.saving,
                        disabled: readOnly,
                        onUpload: upload('portrait'),
                        onRemove: page.portrait ? remove(page.portrait) : undefined,
                        testId: "my-page-hero-portrait"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$2a10fa892fe6389c), {
                        slot: "cover",
                        label: s('myPage.hero.cover'),
                        hint: coverShown ? s('myPage.hero.coverHint') : s('myPage.hero.coverUnused'),
                        media: page.cover,
                        busy: !!cards['img-cover']?.saving,
                        disabled: readOnly,
                        onUpload: upload('cover'),
                        onRemove: page.cover ? remove(page.cover) : undefined,
                        testId: "my-page-hero-cover"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5b42e6cda3f30220$export$d258e5ce123c346a, {
                        cards: cards,
                        keys: [
                            'img-portrait',
                            'img-cover'
                        ]
                    })
                ]
            })
        ]
    });
}
function $5b42e6cda3f30220$export$d258e5ce123c346a({ cards: cards, keys: keys }) {
    return keys.filter((k)=>cards[k]?.error).map((k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
            error: cards[k].error,
            testId: `my-page-${k}-error`
        }, k));
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $97xXr = parcelRequire("97xXr");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $90556bb6004170a1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
            key: "kmsa83"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $90556bb6004170a1$export$2e2bcd8739ae039 = (0, $9QBug.default)("circle-play", $90556bb6004170a1$export$3efd853dbb351e94);


var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");





// ─────────────────────────────────────────────────────────────────────────────
// The three repeatable sections — خدمات, نظرات منتخب, ویدیو. Each is a list of
// items saved as ONE section write (the section's content_json), so reordering
// and editing an item are one «ذخیره», and the counters show the manifest's
// limit before the service has to refuse it.
// ─────────────────────────────────────────────────────────────────────────────
const $d2f2e78336c733fd$var$itemBox = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    padding: '0.875rem',
    display: 'grid',
    gap: '0.75rem',
    background: (0, $jTCZr.C).card
};
function $d2f2e78336c733fd$var$useItemsDraft(section) {
    return (0, $01dc03801d10c419$export$ba3bf943cd157d42)((0, $6f0813e0b3e01b00$export$a305366fc92dfc67)(section));
}
function $d2f2e78336c733fd$var$ItemsHeader({ kind: kind, count: count }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { formatNumber: formatNumber } = (0, $LNQP4.default)();
    const max = (0, $6f0813e0b3e01b00$export$baddd5d42052cf98)(kind);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            fontSize: '0.75rem',
            color: count > max ? (0, $jTCZr.C).red : (0, $jTCZr.C).textSecondary
        },
        "data-testid": `my-page-${kind}-count`,
        children: s('myPage.items.count', {
            count: formatNumber(count),
            max: formatNumber(max)
        })
    });
}
function $d2f2e78336c733fd$var$useItemsSave(kind, actions, adopt) {
    return async (items)=>{
        const res = await actions.updateSection(kind, kind, {
            content: {
                items: items
            }
        });
        if (res.ok) adopt((0, $6f0813e0b3e01b00$export$a305366fc92dfc67)(res.page?.sections?.find((x)=>x.kind === kind)));
        return res;
    };
}
function $d2f2e78336c733fd$export$87f4e416b338ac67({ page: page, section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = $d2f2e78336c733fd$var$useItemsDraft(section);
    const saveItems = $d2f2e78336c733fd$var$useItemsSave('services', actions, adopt);
    const card = cards.services || {};
    const savedIds = new Set((0, $6f0813e0b3e01b00$export$a305366fc92dfc67)(section).map((i)=>i.id));
    const patch = (idx, k, v)=>setDraft((items)=>items.map((it, i)=>i === idx ? {
                    ...it,
                    [k]: v
                } : it));
    const invalid = draft.some((it)=>!String(it.title || '').trim() || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(it.title, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).service_title_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(it.description_md, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).service_description_max)) || draft.length > (0, $6f0813e0b3e01b00$export$baddd5d42052cf98)('services');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.875rem'
        },
        "data-testid": "my-page-services",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($d2f2e78336c733fd$var$ItemsHeader, {
                kind: "services",
                count: draft.length
            }),
            draft.map((it, idx)=>{
                const media = (0, $6f0813e0b3e01b00$export$1f99b3e8e53dce10)(page, it.id);
                const imgKey = `img-service-${it.id}`;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $d2f2e78336c733fd$var$itemBox,
                    "data-testid": `my-page-services-item-${it.id}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: '0.5rem',
                                alignItems: 'flex-start'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'grid',
                                        gap: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                            label: s('myPage.services.itemTitle'),
                                            value: it.title || '',
                                            onChange: (e)=>patch(idx, 'title', e.target.value),
                                            maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).service_title_max,
                                            disabled: readOnly,
                                            inputStyle: fieldStyle,
                                            "data-testid": `my-page-services-item-${it.id}-title`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                                            label: s('myPage.services.itemDescription'),
                                            value: it.description_md || '',
                                            onChange: (e)=>patch(idx, 'description_md', e.target.value),
                                            rows: 3,
                                            maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).service_description_max,
                                            showCount: true,
                                            disabled: readOnly,
                                            helperText: s('myPage.markdownHintShort'),
                                            inputStyle: fieldStyle,
                                            dir: "auto"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                                    index: idx,
                                    count: draft.length,
                                    disabled: readOnly,
                                    onMove: (i, d)=>setDraft((items)=>(0, $3d5fad4093839d7c$export$ec937e64de6c1257)(items, i, d)),
                                    onRemove: (i)=>setDraft((items)=>items.filter((_, j)=>j !== i)),
                                    testId: `my-page-services-item-${it.id}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$2a10fa892fe6389c), {
                            slot: "service",
                            label: s('myPage.services.image'),
                            hint: savedIds.has(it.id) ? s('myPage.services.imageHint') : s('myPage.services.imageAfterSave'),
                            media: media,
                            busy: !!cards[imgKey]?.saving,
                            disabled: readOnly || !savedIds.has(it.id),
                            onUpload: async (image)=>(await actions.uploadImage(imgKey, {
                                    slot: 'service',
                                    image: image,
                                    refId: it.id,
                                    alt: (it.title || '').trim() || (0, $6f0813e0b3e01b00$export$be411cec868da6d8)('services').title
                                })).ok,
                            onRemove: media ? async ()=>{
                                await actions.removeImage(imgKey, media.id);
                            } : undefined,
                            testId: `my-page-services-item-${it.id}-image`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b42e6cda3f30220$export$d258e5ce123c346a), {
                            cards: cards,
                            keys: [
                                imgKey
                            ]
                        })
                    ]
                }, it.id);
            }),
            (0, $6f0813e0b3e01b00$export$c9a626b130283093)('services', draft) && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                onClick: ()=>setDraft((items)=>[
                            ...items,
                            {
                                id: (0, $6f0813e0b3e01b00$export$fa41532ad359c5e)(),
                                title: '',
                                description_md: ''
                            }
                        ]),
                "data-testid": "my-page-services-add",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    " ",
                    s('myPage.services.add')
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: ()=>saveItems(draft.map((it)=>({
                            id: it.id,
                            title: it.title.trim(),
                            description_md: it.description_md || ''
                        }))),
                onReset: reset,
                disabled: readOnly || invalid,
                testId: "my-page-services"
            })
        ]
    });
}
function $d2f2e78336c733fd$export$f7895c4ec70a9d5f({ section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = $d2f2e78336c733fd$var$useItemsDraft(section);
    const saveItems = $d2f2e78336c733fd$var$useItemsSave('testimonials', actions, adopt);
    const card = cards.testimonials || {};
    const patch = (idx, k, v)=>setDraft((items)=>items.map((it, i)=>i === idx ? {
                    ...it,
                    [k]: v
                } : it));
    const invalid = draft.some((it)=>!String(it.text || '').trim() || !it.consent_confirmed || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(it.text, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).testimonial_text_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(it.attribution, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).testimonial_attribution_max)) || draft.length > (0, $6f0813e0b3e01b00$export$baddd5d42052cf98)('testimonials');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.875rem'
        },
        "data-testid": "my-page-testimonials",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "info",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97xXr.default), {
                    size: 16,
                    "aria-hidden": true
                }),
                title: s('myPage.testimonials.framingTitle'),
                children: s('myPage.testimonials.framing')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d2f2e78336c733fd$var$ItemsHeader, {
                kind: "testimonials",
                count: draft.length
            }),
            draft.map((it, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $d2f2e78336c733fd$var$itemBox,
                    "data-testid": `my-page-testimonials-item-${it.id}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '0.5rem',
                            alignItems: 'flex-start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    display: 'grid',
                                    gap: '0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                                        label: s('myPage.testimonials.text'),
                                        value: it.text || '',
                                        onChange: (e)=>patch(idx, 'text', e.target.value),
                                        rows: 3,
                                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).testimonial_text_max,
                                        showCount: true,
                                        disabled: readOnly,
                                        inputStyle: fieldStyle,
                                        dir: "auto"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                        label: s('myPage.testimonials.attribution'),
                                        placeholder: s('myPage.testimonials.attributionPlaceholder'),
                                        value: it.attribution || '',
                                        onChange: (e)=>patch(idx, 'attribution', e.target.value),
                                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).testimonial_attribution_max,
                                        disabled: readOnly,
                                        inputStyle: fieldStyle
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                                        checked: !!it.consent_confirmed,
                                        onChange: (v)=>patch(idx, 'consent_confirmed', v === true),
                                        label: s('myPage.testimonials.consent'),
                                        disabled: readOnly,
                                        "data-testid": `my-page-testimonials-item-${it.id}-consent`
                                    }),
                                    !it.consent_confirmed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.C).textSecondary
                                        },
                                        children: s('myPage.testimonials.consentRequired')
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                                index: idx,
                                count: draft.length,
                                disabled: readOnly,
                                onMove: (i, d)=>setDraft((items)=>(0, $3d5fad4093839d7c$export$ec937e64de6c1257)(items, i, d)),
                                onRemove: (i)=>setDraft((items)=>items.filter((_, j)=>j !== i)),
                                testId: `my-page-testimonials-item-${it.id}`
                            })
                        ]
                    })
                }, it.id)),
            (0, $6f0813e0b3e01b00$export$c9a626b130283093)('testimonials', draft) && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                onClick: ()=>setDraft((items)=>[
                            ...items,
                            {
                                id: (0, $6f0813e0b3e01b00$export$fa41532ad359c5e)(),
                                text: '',
                                attribution: '',
                                consent_confirmed: false
                            }
                        ]),
                "data-testid": "my-page-testimonials-add",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    " ",
                    s('myPage.testimonials.add')
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: ()=>saveItems(draft.map((it)=>({
                            id: it.id,
                            text: it.text.trim(),
                            attribution: (it.attribution || '').trim(),
                            consent_confirmed: !!it.consent_confirmed
                        }))),
                onReset: reset,
                disabled: readOnly || invalid,
                testId: "my-page-testimonials"
            })
        ]
    });
}
function $d2f2e78336c733fd$export$b1f9e1a174205810({ section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = $d2f2e78336c733fd$var$useItemsDraft(section);
    const saveItems = $d2f2e78336c733fd$var$useItemsSave('video', actions, adopt);
    const card = cards.video || {};
    const [url, setUrl] = (0, $acw62.useState)('');
    const [caption, setCaption] = (0, $acw62.useState)('');
    const patch = (idx, k, v)=>setDraft((items)=>items.map((it, i)=>i === idx ? {
                    ...it,
                    [k]: v
                } : it));
    const invalid = draft.some((it)=>(0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(it.caption, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).video_caption_max)) || draft.length > (0, $6f0813e0b3e01b00$export$baddd5d42052cf98)('video');
    const add = ()=>{
        const u = url.trim();
        if (!u) return;
        setDraft((items)=>[
                ...items,
                {
                    id: (0, $6f0813e0b3e01b00$export$fa41532ad359c5e)(),
                    url: u,
                    caption: caption.trim()
                }
            ]);
        setUrl('');
        setCaption('');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.875rem'
        },
        "data-testid": "my-page-video",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.video.intro')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d2f2e78336c733fd$var$ItemsHeader, {
                kind: "video",
                count: draft.length
            }),
            draft.map((it, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $d2f2e78336c733fd$var$itemBox,
                    "data-testid": `my-page-video-item-${it.id}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: '0.5rem',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90556bb6004170a1$export$2e2bcd8739ae039), {
                                    size: 18,
                                    "aria-hidden": true,
                                    style: {
                                        color: (0, $jTCZr.C).navy,
                                        flexShrink: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    dir: "ltr",
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.8125rem',
                                        color: (0, $jTCZr.C).textPrimary,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        unicodeBidi: 'isolate'
                                    },
                                    children: it.video_id ? `${it.provider === 'aparat' ? s('myPage.video.aparat') : s('myPage.video.youtube')} \xb7 ${it.video_id}` : it.url
                                }),
                                !it.video_id ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        flexShrink: 0
                                    },
                                    children: s('myPage.video.pending')
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                                    index: idx,
                                    count: draft.length,
                                    disabled: readOnly,
                                    onMove: (i, d)=>setDraft((items)=>(0, $3d5fad4093839d7c$export$ec937e64de6c1257)(items, i, d)),
                                    onRemove: (i)=>setDraft((items)=>items.filter((_, j)=>j !== i)),
                                    testId: `my-page-video-item-${it.id}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: s('myPage.video.caption'),
                            value: it.caption || '',
                            onChange: (e)=>patch(idx, 'caption', e.target.value),
                            maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).video_caption_max,
                            disabled: readOnly,
                            inputStyle: fieldStyle
                        })
                    ]
                }, it.id)),
            (0, $6f0813e0b3e01b00$export$c9a626b130283093)('video', draft) && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...$d2f2e78336c733fd$var$itemBox,
                    background: (0, $jTCZr.C).bg
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: s('myPage.video.url'),
                        placeholder: "https://www.aparat.com/v/\u2026",
                        dir: "ltr",
                        value: url,
                        onChange: (e)=>setUrl(e.target.value),
                        inputStyle: fieldStyle,
                        inputMode: "url",
                        "data-testid": "my-page-video-url"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: s('myPage.video.caption'),
                        value: caption,
                        onChange: (e)=>setCaption(e.target.value),
                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).video_caption_max,
                        inputStyle: fieldStyle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$1b74141c5fe63a28), {
                        value: caption,
                        max: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).video_caption_max
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: add,
                        disabled: !url.trim(),
                        "data-testid": "my-page-video-add",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.video.add')
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: ()=>saveItems(draft.map((it)=>it.video_id ? {
                            id: it.id,
                            provider: it.provider,
                            video_id: it.video_id,
                            caption: it.caption || ''
                        } : {
                            id: it.id,
                            url: it.url,
                            caption: it.caption || ''
                        })),
                onReset: reset,
                disabled: readOnly || invalid,
                testId: "my-page-video"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kzPvP = parcelRequire("kzPvP");
var $3FyOw = parcelRequire("3FyOw");
var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");





// «مقالات و مطالب علمی» — independent of the page snapshot: each article is
// published on its own (design §7.3), and an article on an unpublished page is
// invisible whatever its status. The list shows where each stands; the editor
// is the sanitised-markdown subset with a live counter.
const $37ecf38f9f69fb9c$var$articleDraft = (a)=>({
        title: a?.title || '',
        slug: a?.slug || '',
        bodyMd: a?.bodyMd || ''
    });
function $37ecf38f9f69fb9c$var$ArticleForm({ article: article, articles: articles, actions: actions, cards: cards, readOnly: readOnly, onDone: onDone }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const [id, setId] = (0, $acw62.useState)(article?.id || null);
    // Looked up by the form's OWN id, so an article created here picks up what
    // every later write says about it (status, cover, unpublished changes) —
    // the `article` prop stays null for a form opened as «new».
    const current = id && (articles || []).find((a)=>a.id === id) || article || null;
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = (0, $01dc03801d10c419$export$ba3bf943cd157d42)($37ecf38f9f69fb9c$var$articleDraft(current));
    const [confirmDelete, setConfirmDelete] = (0, $acw62.useState)(false);
    const key = `article-${id || 'new'}`;
    const card = cards[key] || {};
    const statusCard = cards[`article-status-${id}`] || {};
    const slugLocked = !!current?.slugLocked;
    const slugError = !slugLocked && draft.slug ? (0, $6f0813e0b3e01b00$export$f0fedd4f36c4c1fa)((0, $6f0813e0b3e01b00$export$95f2253c4751dcdb)(draft.slug)) : '';
    const invalid = !draft.title.trim() || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.title, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).article_title_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.bodyMd, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).article_body_max) || !!slugError;
    const set = (k)=>(e)=>setDraft((d)=>({
                    ...d,
                    [k]: e.target.value
                }));
    const save = async ()=>{
        const input = {
            title: draft.title.trim(),
            bodyMd: draft.bodyMd
        };
        if (id) input.id = id;
        if (!slugLocked && draft.slug.trim()) input.slug = (0, $6f0813e0b3e01b00$export$95f2253c4751dcdb)(draft.slug);
        const res = await actions.upsertArticle(key, input);
        const saved = res.ok ? res.data?.upsertDoctorPageArticle : null;
        if (saved) {
            if (!id) setId(saved.id);
            adopt($37ecf38f9f69fb9c$var$articleDraft(saved));
        }
    };
    const published = current?.status === 'published';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '1rem'
        },
        "data-testid": "my-page-article-form",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                onClick: onDone,
                className: "justify-self-start",
                "data-testid": "my-page-article-back",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzPvP.default), {
                        size: 16,
                        "aria-hidden": true,
                        style: (0, $asXy3.MIRROR_ICON)
                    }),
                    s('myPage.articles.back')
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.articles.title'),
                value: draft.title,
                onChange: set('title'),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).article_title_max,
                disabled: readOnly,
                inputStyle: fieldStyle,
                "data-testid": "my-page-article-title"
            }),
            slugLocked ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: [
                    s('myPage.articles.slugLocked'),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "ltr",
                        style: {
                            unicodeBidi: 'isolate'
                        },
                        children: current.slug
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.articles.slug'),
                helperText: !slugError ? s('myPage.articles.slugHint') : undefined,
                error: slugError ? s(slugError) : undefined,
                dir: "ltr",
                value: draft.slug,
                onChange: set('slug'),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).slug_max,
                disabled: readOnly,
                inputStyle: fieldStyle,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                label: s('myPage.articles.body'),
                value: draft.bodyMd,
                onChange: set('bodyMd'),
                rows: 14,
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).article_body_max,
                showCount: true,
                disabled: readOnly,
                helperText: s('myPage.markdownHint'),
                inputStyle: fieldStyle,
                dir: "auto",
                "data-testid": "my-page-article-body"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty || !id,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: save,
                onReset: id ? reset : undefined,
                disabled: readOnly || invalid,
                testId: "my-page-article"
            }),
            id ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$2a10fa892fe6389c), {
                        slot: "article",
                        label: s('myPage.articles.cover'),
                        media: current?.coverUrl ? {
                            url: current.coverUrl
                        } : null,
                        busy: !!cards[`img-article-${id}`]?.saving,
                        disabled: readOnly,
                        onUpload: async (image)=>(await actions.uploadImage(`img-article-${id}`, {
                                slot: 'article',
                                image: image,
                                refId: id,
                                alt: draft.title.trim() || current?.title || ''
                            })).ok,
                        // Clearing goes through the article itself (coverFileId ''); the
                        // service releases the file once nothing published shows it.
                        onRemove: current?.coverUrl ? async ()=>{
                            await actions.upsertArticle(`img-article-${id}`, {
                                id: id,
                                coverFileId: ''
                            });
                        } : undefined,
                        testId: "my-page-article-cover"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                        error: cards[`img-article-${id}`]?.error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '0.5rem',
                            flexWrap: 'wrap',
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                            paddingTop: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: published ? 'outline' : 'default',
                                size: "sm",
                                disabled: readOnly || statusCard.saving || dirty,
                                onClick: ()=>actions.setArticleStatus(`article-status-${id}`, id, published ? 'draft' : 'published'),
                                "data-testid": "my-page-article-status",
                                children: published ? s('myPage.articles.unpublish') : s('myPage.articles.publish')
                            }),
                            published && current?.hasUnpublishedChanges ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                size: "sm",
                                disabled: readOnly || statusCard.saving || dirty,
                                onClick: ()=>actions.setArticleStatus(`article-status-${id}`, id, 'published'),
                                children: s('myPage.articles.republish')
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                size: "sm",
                                disabled: readOnly,
                                onClick: ()=>setConfirmDelete(true),
                                "data-testid": "my-page-article-delete",
                                children: s('myPage.articles.delete')
                            })
                        ]
                    }),
                    dirty ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.articles.saveFirst')
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                        error: statusCard.error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                        error: cards[`article-delete-${id}`]?.error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                        open: confirmDelete,
                        onOpenChange: setConfirmDelete,
                        title: s('myPage.articles.deleteTitle'),
                        description: s('myPage.articles.deleteBody', {
                            title: current?.title || draft.title
                        }),
                        confirmLabel: s('myPage.articles.deleteConfirm'),
                        destructive: true,
                        loading: !!cards[`article-delete-${id}`]?.saving,
                        onConfirm: async ()=>{
                            const res = await actions.deleteArticle(`article-delete-${id}`, id);
                            setConfirmDelete(false);
                            if (res.ok) onDone();
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.articles.saveToContinue')
            })
        ]
    });
}
function $37ecf38f9f69fb9c$export$2e2bcd8739ae039({ page: page, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { formatNumber: formatNumber, formatDate: formatDate } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(null); // article id | 'new' | null
    const articles = page.articles || [];
    if (open) {
        const article = open === 'new' ? null : articles.find((a)=>a.id === open) || null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($37ecf38f9f69fb9c$var$ArticleForm, {
            article: article,
            articles: articles,
            actions: actions,
            cards: cards,
            readOnly: readOnly,
            onDone: ()=>setOpen(null)
        }, open);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.75rem'
        },
        "data-testid": "my-page-articles",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.items.count', {
                            count: formatNumber(articles.length),
                            max: formatNumber((0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).articles_max)
                        })
                    }),
                    !readOnly && articles.length < (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).articles_max ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        size: "sm",
                        variant: "outline",
                        onClick: ()=>setOpen('new'),
                        "data-testid": "my-page-articles-new",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.articles.new')
                        ]
                    }) : null
                ]
            }),
            articles.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                style: {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    display: 'grid',
                    gap: '0.5rem'
                },
                children: articles.map((a)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: ()=>setOpen(a.id),
                            "data-testid": `my-page-articles-item-${a.id}`,
                            className: "h-auto min-h-11 w-full justify-start rounded-xl px-3 py-2 font-normal",
                            style: {
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: (0, $jTCZr.RADIUS).card,
                                textAlign: 'start',
                                whiteSpace: 'normal'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'grid',
                                        gap: '0.25rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            dir: "auto",
                                            style: {
                                                fontSize: '0.875rem',
                                                fontWeight: 600,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: a.title || s('myPage.articles.untitled')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.75rem',
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: a.publishedAtMs ? s('myPage.articles.publishedOn', {
                                                date: formatDate(Number(a.publishedAtMs))
                                            }) : s('myPage.articles.neverPublished')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        display: 'inline-flex',
                                        gap: '0.25rem',
                                        flexShrink: 0,
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                            variant: a.status === 'published' ? 'success' : 'outline',
                                            children: a.status === 'published' ? s('myPage.articles.statusPublished') : s('myPage.articles.statusDraft')
                                        }),
                                        a.status === 'published' && a.hasUnpublishedChanges ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                            variant: "warning",
                                            children: s('myPage.articles.changed')
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }, a.id))
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3FyOw.default), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: s('myPage.articles.emptyTitle'),
                description: s('myPage.articles.emptyHint'),
                style: {
                    padding: '1.5rem 1rem'
                }
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $54363ff2efeee045$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16",
            key: "9kzy35"
        }
    ],
    [
        "path",
        {
            d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2",
            key: "1t0f0t"
        }
    ],
    [
        "circle",
        {
            cx: "13",
            cy: "7",
            r: "1",
            fill: "currentColor",
            key: "1obus6"
        }
    ],
    [
        "rect",
        {
            x: "8",
            y: "2",
            width: "14",
            height: "14",
            rx: "2",
            key: "1gvhby"
        }
    ]
];
const $54363ff2efeee045$export$2e2bcd8739ae039 = (0, $9QBug.default)("images", $54363ff2efeee045$export$3efd853dbb351e94);


parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// «گالری تصاویر» — up to 12 images, each with MANDATORY alt text (it is what a
// screen reader and a search engine read, and the service refuses an image
// without one). The alt is asked for BEFORE the picker opens, so an image can
// never be attached without it.
function $616874dee2d5029e$var$GalleryTile({ media: media, index: index, count: count, busy: busy, readOnly: readOnly, onAlt: onAlt, onMove: onMove, onRemove: onRemove }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const [alt, setAlt] = (0, $acw62.useState)(media.alt || '');
    (0, $acw62.useEffect)(()=>{
        setAlt(media.alt || '');
    }, [
        media.alt
    ]);
    const changed = alt.trim() !== (media.alt || '');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": `my-page-gallery-item-${media.id}`,
        style: {
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.625rem',
            display: 'grid',
            gap: '0.5rem',
            background: (0, $jTCZr.C).card
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: media.url,
                alt: media.alt || '',
                style: {
                    width: '100%',
                    aspectRatio: '4 / 3',
                    objectFit: 'cover',
                    borderRadius: (0, $jTCZr.RADIUS).control,
                    background: (0, $jTCZr.C).bg
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.gallery.alt'),
                value: alt,
                onChange: (e)=>setAlt(e.target.value),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).alt_max,
                disabled: readOnly,
                error: !alt.trim() ? s('myPage.gallery.altRequired') : undefined,
                inputStyle: fieldStyle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "sm",
                        variant: "outline",
                        disabled: readOnly || busy || !changed || !alt.trim(),
                        onClick: ()=>onAlt(media.id, alt.trim()),
                        children: s('myPage.gallery.saveAlt')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                        index: index,
                        count: count,
                        disabled: readOnly || busy,
                        onMove: (i, d)=>onMove(i, d),
                        onRemove: ()=>onRemove(media),
                        removeLabel: s('myPage.image.remove'),
                        testId: `my-page-gallery-item-${media.id}`
                    })
                ]
            })
        ]
    });
}
function $616874dee2d5029e$export$2e2bcd8739ae039({ page: page, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const { formatNumber: formatNumber } = (0, $LNQP4.default)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const items = (0, $6f0813e0b3e01b00$export$4d566a4dcecbad1d)(page);
    const max = (0, $6f0813e0b3e01b00$export$baddd5d42052cf98)('gallery');
    const [newAlt, setNewAlt] = (0, $acw62.useState)('');
    const card = cards.gallery || {};
    const busy = !!card.saving;
    // Swapping two neighbours = two sort-order writes; the second answer is the page.
    const move = async (index, delta)=>{
        const other = items[index + delta];
        const self = items[index];
        if (!other || !self) return;
        const first = await actions.updateImage('gallery', self.id, {
            sortOrder: other.sortOrder ?? index + delta
        });
        if (first.ok) await actions.updateImage('gallery', other.id, {
            sortOrder: self.sortOrder ?? index
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '1rem'
        },
        "data-testid": "my-page-gallery",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: items.length > max ? (0, $jTCZr.C).red : (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.items.count', {
                    count: formatNumber(items.length),
                    max: formatNumber(max)
                })
            }),
            items.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'grid',
                    gap: '0.75rem',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 13rem), 1fr))'
                },
                children: items.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($616874dee2d5029e$var$GalleryTile, {
                        media: m,
                        index: i,
                        count: items.length,
                        busy: busy,
                        readOnly: readOnly,
                        onAlt: (id, alt)=>actions.updateImage('gallery', id, {
                                alt: alt
                            }),
                        onMove: move,
                        onRemove: (media)=>actions.removeImage('gallery', media.id)
                    }, m.id))
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54363ff2efeee045$export$2e2bcd8739ae039), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: s('myPage.gallery.emptyTitle'),
                description: s('myPage.gallery.emptyHint'),
                style: {
                    padding: '1.5rem 1rem'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                error: card.error,
                testId: "my-page-gallery-error"
            }),
            items.length < max && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    border: `1px dashed ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    padding: '0.875rem',
                    display: 'grid',
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: s('myPage.gallery.newAlt'),
                        placeholder: s('myPage.gallery.newAltPlaceholder'),
                        value: newAlt,
                        onChange: (e)=>setNewAlt(e.target.value),
                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).alt_max,
                        inputStyle: fieldStyle,
                        "data-testid": "my-page-gallery-new-alt"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$2a10fa892fe6389c), {
                        slot: "gallery",
                        busy: !!cards['img-gallery']?.saving,
                        disabled: !newAlt.trim(),
                        hint: !newAlt.trim() ? s('myPage.gallery.altFirst') : undefined,
                        onUpload: async (image)=>{
                            const res = await actions.uploadImage('img-gallery', {
                                slot: 'gallery',
                                image: image,
                                alt: newAlt.trim()
                            });
                            if (res.ok) setNewAlt('');
                            return res.ok;
                        },
                        testId: "my-page-gallery-add"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                        error: cards['img-gallery']?.error,
                        testId: "my-page-gallery-add-error"
                    })
                ]
            }) : null
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5AX1S = parcelRequire("5AX1S");
var $lffTJ = parcelRequire("lffTJ");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $77b207f3f4e45476$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "18",
            y1: "12",
            y2: "12",
            key: "l9bcsi"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "2",
            y1: "12",
            y2: "12",
            key: "13hhkx"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "6",
            y2: "2",
            key: "10w3f3"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "18",
            key: "15g9kq"
        }
    ]
];
const $77b207f3f4e45476$export$2e2bcd8739ae039 = (0, $9QBug.default)("crosshair", $77b207f3f4e45476$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2246635c7d368f87$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
            key: "169xi5"
        }
    ],
    [
        "path",
        {
            d: "M15 5.764v15",
            key: "1pn4in"
        }
    ],
    [
        "path",
        {
            d: "M9 3.236v15",
            key: "1uimfh"
        }
    ]
];
const $2246635c7d368f87$export$2e2bcd8739ae039 = (0, $9QBug.default)("map", $2246635c7d368f87$export$3efd853dbb351e94);


var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");


// Leaflet, loaded at runtime from MAP_LIB_BASE — once per document, shared by
// every map. The same approach as the clinic panel's LocationPicker: the map
// is optional, so the library stays out of the entry bundle and only a doctor
// who opens a map pays for it.
//
// A promise rather than a flag: two opens must not race two <script> tags, and
// a FAILED load forgets itself so the next open tries again instead of
// reporting a stale failure forever (a network inside Iran can lose the CDN
// for a minute).
const $d251ea35c998ce42$var$LOAD_TIMEOUT_MS = 15000;
let $d251ea35c998ce42$var$pending = null;
function $d251ea35c998ce42$export$829f22e68c49a705() {
    if (typeof window === 'undefined') return Promise.reject(new Error('no-window'));
    if (window.L) return Promise.resolve(window.L);
    if ($d251ea35c998ce42$var$pending) return $d251ea35c998ce42$var$pending;
    $d251ea35c998ce42$var$pending = new Promise((resolve, reject)=>{
        const fail = (why)=>{
            $d251ea35c998ce42$var$pending = null;
            reject(new Error(why));
        };
        const timer = setTimeout(()=>fail('timeout'), $d251ea35c998ce42$var$LOAD_TIMEOUT_MS);
        const done = (fn)=>(arg)=>{
                clearTimeout(timer);
                fn(arg);
            };
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = `${0, $d87bd335296b449f$export$dbbae022d435eb02}/leaflet.css`;
            document.head.appendChild(link);
        }
        const existing = document.getElementById('leaflet-js');
        const script = existing || document.createElement('script');
        script.addEventListener('load', done(()=>window.L ? resolve(window.L) : fail('network')));
        script.addEventListener('error', done(()=>{
            // A failed tag would answer every later open with the same failure.
            script.remove();
            fail('network');
        }));
        if (!existing) {
            script.id = 'leaflet-js';
            script.src = `${0, $d87bd335296b449f$export$dbbae022d435eb02}/leaflet.js`;
            document.head.appendChild(script);
        }
    });
    return $d251ea35c998ce42$var$pending;
}
function $d251ea35c998ce42$export$6c960cb9fd49708a({ timeout: timeout = 15000 } = {}) {
    return new Promise((resolve, reject)=>{
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            reject(new Error('unsupported'));
            return;
        }
        navigator.geolocation.getCurrentPosition((pos)=>resolve({
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
            }), (err)=>reject(new Error({
                1: 'denied',
                2: 'unavailable',
                3: 'timeout'
            }[err?.code] || 'unavailable')), {
            enableHighAccuracy: true,
            timeout: timeout,
            maximumAge: 60000
        });
    });
}



const $e6b4d860369af90d$export$7607f2c350eafd7 = {
    lat: 35.6892,
    lng: 51.389
};
const $e6b4d860369af90d$var$ZOOM_POINT = 16;
const $e6b4d860369af90d$var$ZOOM_CITY = 11;
const $e6b4d860369af90d$var$round6 = (n)=>Math.round(Number(n) * 1e6) / 1e6;
const $e6b4d860369af90d$export$b63cca88ddc558a9 = (ll)=>({
        lat: $e6b4d860369af90d$var$round6(ll.lat),
        lng: $e6b4d860369af90d$var$round6(ll.lng)
    });
const $e6b4d860369af90d$var$GEO_MESSAGE = {
    denied: 'myPage.office.map.denied',
    unavailable: 'myPage.office.map.unavailable',
    timeout: 'myPage.office.map.timeout',
    unsupported: 'myPage.office.map.unsupported'
};
const $e6b4d860369af90d$var$box = {
    display: 'grid',
    gap: '0.625rem'
};
const $e6b4d860369af90d$var$row = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '0.5rem'
};
/** The Leaflet surface. Mounted only while the map is open. */ function $e6b4d860369af90d$var$MapSurface({ value: value, onPoint: onPoint, onReady: onReady, onFailed: onFailed }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const hostRef = (0, $acw62.useRef)(null);
    const mapRef = (0, $acw62.useRef)(null);
    const markerRef = (0, $acw62.useRef)(null);
    const onPointRef = (0, $acw62.useRef)(onPoint);
    onPointRef.current = onPoint;
    const [state, setState] = (0, $acw62.useState)('loading'); // loading | ready | failed
    const placeMarker = (0, $acw62.useCallback)((L, at)=>{
        if (markerRef.current) {
            markerRef.current.setLatLng([
                at.lat,
                at.lng
            ]);
            return;
        }
        const marker = L.marker([
            at.lat,
            at.lng
        ], {
            draggable: true,
            autoPan: true
        });
        marker.on('dragend', ()=>onPointRef.current?.($e6b4d860369af90d$export$b63cca88ddc558a9(marker.getLatLng())));
        marker.addTo(mapRef.current);
        markerRef.current = marker;
    }, []);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $d251ea35c998ce42$export$829f22e68c49a705)().then((L)=>{
            if (cancelled || !hostRef.current || mapRef.current) return;
            const at = value || $e6b4d860369af90d$export$7607f2c350eafd7;
            const map = L.map(hostRef.current, {
                zoomControl: true
            }).setView([
                at.lat,
                at.lng
            ], value ? $e6b4d860369af90d$var$ZOOM_POINT : $e6b4d860369af90d$var$ZOOM_CITY);
            // A plain credit line: Leaflet's default prefix carries a flag icon,
            // and the map is about the doctor's office, not anything else.
            map.attributionControl?.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener noreferrer">Leaflet</a>');
            L.tileLayer((0, $d87bd335296b449f$export$78f3b16823fa1002), {
                attribution: "\xa9 OpenStreetMap",
                maxZoom: 19
            }).addTo(map);
            map.on('click', (e)=>onPointRef.current?.($e6b4d860369af90d$export$b63cca88ddc558a9(e.latlng)));
            mapRef.current = map;
            if (value) placeMarker(L, value);
            setState('ready');
            onReady?.();
        }).catch(()=>{
            if (cancelled) return;
            setState('failed');
            onFailed?.();
        });
        return ()=>{
            cancelled = true;
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
                markerRef.current = null;
            }
        };
    // Built once per open; later points arrive through the effect below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Follow the point however it changed — a tap, a drag, «موقعیت فعلی من», a
    // reset of the card — and drop the pin when it is cleared.
    // Keyed on the numbers, not the object: the editor builds a fresh point on
    // every render, and a keystroke in «نشانی» must not touch the map.
    const lat = value?.lat;
    const lng = value?.lng;
    (0, $acw62.useEffect)(()=>{
        const map = mapRef.current;
        const L = typeof window !== 'undefined' ? window.L : null;
        if (!map || !L) return;
        if (lat == null || lng == null) {
            if (markerRef.current) {
                markerRef.current.remove();
                markerRef.current = null;
            }
            return;
        }
        const moved = !markerRef.current;
        placeMarker(L, {
            lat: lat,
            lng: lng
        });
        // Re-centre only when the pin is new or has left the visible area: a tap
        // must not yank the map out from under the finger that made it.
        if (moved || !map.getBounds?.().contains?.([
            lat,
            lng
        ])) map.setView([
            lat,
            lng
        ], Math.max(map.getZoom?.() || 0, $e6b4d860369af90d$var$ZOOM_POINT));
    }, [
        lat,
        lng,
        state,
        placeMarker
    ]);
    if (state === 'failed') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page-office-map-failed",
        style: {
            padding: '1rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1px dashed ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).bg,
            color: (0, $jTCZr.C).textSecondary,
            fontSize: '0.8125rem',
            textAlign: 'center'
        },
        children: s('myPage.office.map.failed')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            borderRadius: (0, $jTCZr.RADIUS).control,
            overflow: 'hidden',
            border: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: hostRef,
                dir: "ltr",
                role: "application",
                "aria-label": s('myPage.office.map.label'),
                "data-testid": "my-page-office-map",
                style: {
                    height: 'clamp(16rem, 42vh, 22rem)',
                    width: '100%',
                    background: (0, $jTCZr.C).bg
                }
            }),
            state === 'loading' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "status",
                style: {
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).card, 0.8),
                    color: (0, $jTCZr.C).navy,
                    fontSize: '0.8125rem',
                    fontWeight: 600
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                        size: 16
                    }),
                    " ",
                    s('myPage.office.map.loading')
                ]
            }) : null
        ]
    });
}
function $e6b4d860369af90d$export$2e2bcd8739ae039({ value: value, onChange: onChange, disabled: disabled = false }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [locating, setLocating] = (0, $acw62.useState)(false);
    const [message, setMessage] = (0, $acw62.useState)(null); // { tone: 'info' | 'warn', key }
    const alive = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>()=>{
            alive.current = false;
        }, []);
    const locate = (0, $acw62.useCallback)(async ()=>{
        setLocating(true);
        setMessage({
            tone: 'info',
            key: 'myPage.office.map.locating'
        });
        try {
            const point = $e6b4d860369af90d$export$b63cca88ddc558a9(await (0, $d251ea35c998ce42$export$6c960cb9fd49708a)());
            if (!alive.current) return;
            onChange(point);
            setMessage({
                tone: 'info',
                key: 'myPage.office.map.found'
            });
        } catch (err) {
            if (alive.current) setMessage({
                tone: 'warn',
                key: $e6b4d860369af90d$var$GEO_MESSAGE[err?.message] || $e6b4d860369af90d$var$GEO_MESSAGE.unavailable
            });
        } finally{
            if (alive.current) setLocating(false);
        }
    }, [
        onChange
    ]);
    const openMap = ()=>{
        setOpen(true);
        // The doctor's own position is the default — but never over a point they already chose.
        if (!value) locate();
        else setMessage({
            tone: 'info',
            key: 'myPage.office.map.hint'
        });
    };
    const pick = (0, $acw62.useCallback)((point)=>{
        onChange(point);
        setMessage({
            tone: 'info',
            key: 'myPage.office.map.hint'
        });
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $e6b4d860369af90d$var$box,
        "data-testid": "my-page-office-geo",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $e6b4d860369af90d$var$row,
                children: [
                    !open ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: value ? 'outline' : 'default',
                        size: "sm",
                        disabled: disabled,
                        onClick: openMap,
                        "data-testid": "my-page-office-map-open",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2246635c7d368f87$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            value ? s('myPage.office.map.change') : s('myPage.office.map.pick')
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setOpen(false),
                        "data-testid": "my-page-office-map-close",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.office.map.close')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        disabled: disabled || locating,
                        onClick: locate,
                        "data-testid": "my-page-office-map-locate",
                        children: [
                            locating ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77b207f3f4e45476$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.office.map.myLocation')
                        ]
                    }),
                    value && !disabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        onClick: ()=>{
                            onChange(null);
                            setMessage(null);
                        },
                        "data-testid": "my-page-office-map-clear",
                        children: s('myPage.office.map.clear')
                    }) : null
                ]
            }),
            value && !open ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textPrimary
                },
                "data-testid": "my-page-office-map-set",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc37683d2791ff01$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true,
                        style: {
                            color: (0, $jTCZr.C).green,
                            flexShrink: 0
                        }
                    }),
                    s('myPage.office.map.isSet')
                ]
            }) : null,
            open ? /*#__PURE__*/ (0, $ayMG0.jsx)($e6b4d860369af90d$var$MapSurface, {
                value: value,
                onPoint: pick,
                onFailed: ()=>setMessage({
                        tone: 'warn',
                        key: 'myPage.office.map.failed'
                    })
            }) : null,
            message ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "status",
                "aria-live": "polite",
                "data-testid": "my-page-office-map-message",
                "data-tone": message.tone,
                style: {
                    fontSize: '0.75rem',
                    color: message.tone === 'warn' ? (0, $jTCZr.C).amber : (0, $jTCZr.C).textSecondary
                },
                children: s(message.key)
            }) : null
        ]
    });
}


// «اطلاعات مطب» — the office facts the doctor types themself: phones, address,
// hours, an optional map point, socials. Deliberately NOT joined from clinic
// memberships (a practitioner has many clinics; the page states their own
// office, knowingly — design §5.1). The phone typed here is public.
const $c16275f52045c433$var$rowBox = {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'flex-end',
    flexWrap: 'wrap'
};
const $c16275f52045c433$var$group = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    padding: '0.875rem',
    display: 'grid',
    gap: '0.75rem'
};
const $c16275f52045c433$var$groupTitle = {
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: (0, $jTCZr.C).textPrimary
};
function $c16275f52045c433$export$2e2bcd8739ae039({ page: page, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = (0, $01dc03801d10c419$export$ba3bf943cd157d42)((0, $6f0813e0b3e01b00$export$12e620af4be5c7d6)(page.contact));
    const card = cards.office || {};
    const patchList = (list, idx, k, v)=>setDraft((d)=>({
                ...d,
                [list]: d[list].map((row, i)=>i === idx ? {
                        ...row,
                        [k]: v
                    } : row)
            }));
    const removeFrom = (list)=>(idx)=>setDraft((d)=>({
                    ...d,
                    [list]: d[list].filter((_, i)=>i !== idx)
                }));
    const moveIn = (list)=>(idx, delta)=>setDraft((d)=>({
                    ...d,
                    [list]: (0, $3d5fad4093839d7c$export$ec937e64de6c1257)(d[list], idx, delta)
                }));
    const invalid = (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.address, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).address_max) || (0, $6f0813e0b3e01b00$export$e851aa099013d3ed)(draft.city, (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).city_max) || draft.phones.length > (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).phones_max || draft.hours.length > (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).hours_max;
    const save = async ()=>{
        const res = await actions.updatePage('office', {
            contact: (0, $6f0813e0b3e01b00$export$a45bb8dd7a7fbcf9)(draft)
        });
        if (res.ok) adopt((0, $6f0813e0b3e01b00$export$12e620af4be5c7d6)(res.page?.contact));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '1rem'
        },
        "data-testid": "my-page-office",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: s('myPage.office.intro')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $c16275f52045c433$var$group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $c16275f52045c433$var$groupTitle,
                        children: s('myPage.office.phones')
                    }),
                    draft.phones.map((p, i)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: $c16275f52045c433$var$rowBox,
                            "data-testid": `my-page-office-phone-${i}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                    label: s('myPage.office.phoneLabel'),
                                    placeholder: s('myPage.office.phoneLabelPlaceholder'),
                                    value: p.label,
                                    onChange: (e)=>patchList('phones', i, 'label', e.target.value),
                                    maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).phone_label_max,
                                    disabled: readOnly,
                                    inputStyle: fieldStyle,
                                    style: {
                                        flex: '1 1 8rem'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lffTJ.default), {
                                    label: s('myPage.office.phoneNumber'),
                                    allowLandline: true,
                                    value: p.number,
                                    onChange: (e164, meta)=>patchList('phones', i, 'number', $c16275f52045c433$var$officeNumber(e164, meta)),
                                    disabled: readOnly,
                                    inputStyle: fieldStyle,
                                    style: {
                                        flex: '1 1 12rem'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                                    index: i,
                                    count: draft.phones.length,
                                    disabled: readOnly,
                                    onMove: moveIn('phones'),
                                    onRemove: removeFrom('phones')
                                })
                            ]
                        }, i)),
                    draft.phones.length < (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).phones_max && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        className: "justify-self-start",
                        onClick: ()=>setDraft((d)=>({
                                    ...d,
                                    phones: [
                                        ...d.phones,
                                        {
                                            label: '',
                                            number: ''
                                        }
                                    ]
                                })),
                        "data-testid": "my-page-office-phone-add",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.office.addPhone')
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $c16275f52045c433$var$group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: s('myPage.office.city'),
                        value: draft.city,
                        onChange: (e)=>setDraft((d)=>({
                                    ...d,
                                    city: e.target.value
                                })),
                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).city_max,
                        disabled: readOnly,
                        inputStyle: fieldStyle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                        label: s('myPage.office.address'),
                        value: draft.address,
                        onChange: (e)=>setDraft((d)=>({
                                    ...d,
                                    address: e.target.value
                                })),
                        rows: 2,
                        maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).address_max,
                        showCount: true,
                        disabled: readOnly,
                        inputStyle: fieldStyle,
                        dir: "auto"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $c16275f52045c433$var$group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $c16275f52045c433$var$groupTitle,
                        children: s('myPage.office.hours')
                    }),
                    draft.hours.map((h, i)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: $c16275f52045c433$var$rowBox,
                            "data-testid": `my-page-office-hours-${i}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                    label: s('myPage.office.hoursLabel'),
                                    placeholder: s('myPage.office.hoursLabelPlaceholder'),
                                    value: h.label,
                                    onChange: (e)=>patchList('hours', i, 'label', e.target.value),
                                    maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).hours_label_max,
                                    disabled: readOnly,
                                    inputStyle: fieldStyle,
                                    style: {
                                        flex: '1 1 8rem'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                    label: s('myPage.office.hoursValue'),
                                    placeholder: s('myPage.office.hoursValuePlaceholder'),
                                    value: h.value,
                                    onChange: (e)=>patchList('hours', i, 'value', e.target.value),
                                    maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).hours_value_max,
                                    disabled: readOnly,
                                    inputStyle: fieldStyle,
                                    style: {
                                        flex: '1 1 9rem'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$523acc1bb0ce2e43), {
                                    index: i,
                                    count: draft.hours.length,
                                    disabled: readOnly,
                                    onMove: moveIn('hours'),
                                    onRemove: removeFrom('hours')
                                })
                            ]
                        }, i)),
                    draft.hours.length < (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).hours_max && !readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        className: "justify-self-start",
                        onClick: ()=>setDraft((d)=>({
                                    ...d,
                                    hours: [
                                        ...d.hours,
                                        {
                                            label: '',
                                            value: ''
                                        }
                                    ]
                                })),
                        "data-testid": "my-page-office-hours-add",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.office.addHours')
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $c16275f52045c433$var$group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...$c16275f52045c433$var$groupTitle,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.375rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc37683d2791ff01$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            " ",
                            s('myPage.office.geo')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.office.geoHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6b4d860369af90d$export$2e2bcd8739ae039), {
                        value: (0, $6f0813e0b3e01b00$export$2404e5988465b265)(draft.geo),
                        onChange: (point)=>setDraft((d)=>({
                                    ...d,
                                    geo: (0, $6f0813e0b3e01b00$export$6c9a7b0b2e549efc)(point)
                                })),
                        disabled: readOnly
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $c16275f52045c433$var$group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $c16275f52045c433$var$groupTitle,
                        children: s('myPage.office.socials')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: s('myPage.office.socialsHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'grid',
                            gap: '0.75rem',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 14rem), 1fr))'
                        },
                        children: (0, $6f0813e0b3e01b00$export$da2827437343807f).map((k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: s(`myPage.office.social.${k}`),
                                dir: "ltr",
                                value: draft.socials[k],
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            socials: {
                                                ...d.socials,
                                                [k]: e.target.value
                                            }
                                        })),
                                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).social_max,
                                disabled: readOnly,
                                inputStyle: fieldStyle,
                                autoComplete: "off"
                            }, k))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: save,
                onReset: reset,
                disabled: readOnly || invalid,
                testId: "my-page-office"
            })
        ]
    });
}
/**
 * The spelling an office number is STORED in, which is also the one the public page
 * prints verbatim (`landing … blocks.jsx` renders `number` as given): an Iranian number in
 * its national form, `02188000000`, because that is how an Iranian visitor reads and
 * dials it; any other country in E.164, because a national spelling without its country
 * is a different number. A number still being typed is kept as typed, so the service's
 * own check — not a silent drop of the row — is what answers it.
 */ function $c16275f52045c433$var$officeNumber(e164, meta) {
    if (!e164) return meta?.draft ?? '';
    return e164.startsWith('+98') ? (0, $5AX1S).forDisplay(e164) : e164;
}


// ─────────────────────────────────────────────────────────────────────────────
// One section's editor, whichever kind it is: what stops it from being
// published (the service's blockers and the last «انتشار» refusal land HERE,
// on the owning card), whether the current template shows it at all, the
// section heading override, then the kind's own editor.
// Surface-neutral: the desktop wraps it in a card, the phone in a full-screen
// content screen.
// ─────────────────────────────────────────────────────────────────────────────
const $e6e0b3d7ac2d5ecf$var$EDITORS = {
    hero: (0, $5b42e6cda3f30220$export$2e2bcd8739ae039),
    services: (0, $d2f2e78336c733fd$export$87f4e416b338ac67),
    articles: (0, $37ecf38f9f69fb9c$export$2e2bcd8739ae039),
    testimonials: (0, $d2f2e78336c733fd$export$f7895c4ec70a9d5f),
    gallery: (0, $616874dee2d5029e$export$2e2bcd8739ae039),
    video: (0, $d2f2e78336c733fd$export$b1f9e1a174205810),
    office: (0, $c16275f52045c433$export$2e2bcd8739ae039)
};
function $e6e0b3d7ac2d5ecf$var$TitleOverride({ section: section, actions: actions, cards: cards, readOnly: readOnly }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const fieldStyle = (0, $3d5fad4093839d7c$export$552a7750aeca1563)();
    const { draft: draft, setDraft: setDraft, dirty: dirty, adopt: adopt, reset: reset } = (0, $01dc03801d10c419$export$ba3bf943cd157d42)({
        titleOverride: section.titleOverride || ''
    });
    const key = `title-${section.kind}`;
    const card = cards[key] || {};
    const save = async ()=>{
        const res = await actions.updateSection(key, section.kind, {
            titleOverride: draft.titleOverride.trim()
        });
        const saved = res.ok ? res.page?.sections?.find((x)=>x.kind === section.kind) : null;
        if (saved) adopt({
            titleOverride: saved.titleOverride || ''
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: s('myPage.sections.titleOverride'),
                placeholder: (0, $6f0813e0b3e01b00$export$be411cec868da6d8)(section.kind).title,
                helperText: s('myPage.sections.titleOverrideHint'),
                value: draft.titleOverride,
                onChange: (e)=>setDraft({
                        titleOverride: e.target.value
                    }),
                maxLength: (0, $6f0813e0b3e01b00$export$2e91cd085cd33e2f).title_override_max,
                disabled: readOnly,
                inputStyle: fieldStyle,
                "data-testid": `my-page-${section.kind}-title-override`
            }),
            dirty || card.saving || card.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$944d2aeaf19f3dde), {
                status: (0, $6f0813e0b3e01b00$export$519f62282f18e4ae)({
                    dirty: dirty,
                    saving: card.saving,
                    error: card.error,
                    savedAt: card.savedAt
                }),
                error: card.error,
                onSave: save,
                onReset: reset,
                disabled: readOnly,
                testId: `my-page-${section.kind}-title`
            }) : null
        ]
    });
}
function $e6e0b3d7ac2d5ecf$export$2e2bcd8739ae039({ page: page, kind: kind, actions: actions, cards: cards, readOnly: readOnly, publishErrors: publishErrors }) {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const section = (page.sections || []).find((x)=>x.kind === kind);
    const Editor = $e6e0b3d7ac2d5ecf$var$EDITORS[kind];
    if (!section || !Editor) return null;
    const toggleCard = cards[`toggle-${kind}`] || {};
    const pageErrors = (0, $6f0813e0b3e01b00$export$cb46fb9ca2e05378)(page.publishBlockers)[kind] || [];
    const lastRefusal = (0, $6f0813e0b3e01b00$export$cb46fb9ca2e05378)(publishErrors)[kind] || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '1rem'
        },
        "data-testid": `my-page-editor-${kind}`,
        children: [
            !section.supportedByTemplate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "neutral",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a80d2cd266adcc$export$2e2bcd8739ae039), {
                    size: 16,
                    "aria-hidden": true
                }),
                "data-testid": `my-page-editor-${kind}-unsupported`,
                children: s('myPage.sections.unsupportedLong')
            }) : null,
            !section.enabled && !section.required ? // A hidden section says so in words and is switched on right here —
            // a bare «پنهان» badge read as a broken card, not as a choice.
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "neutral",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eee9f5221939b065$export$2e2bcd8739ae039), {
                    size: 16,
                    "aria-hidden": true
                }),
                "data-testid": `my-page-editor-${kind}-hidden`,
                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    size: "sm",
                    disabled: readOnly || !!toggleCard.saving,
                    onClick: ()=>actions.updateSection(`toggle-${kind}`, kind, {
                            enabled: true
                        }),
                    "data-testid": `my-page-editor-${kind}-show`,
                    children: s('myPage.sections.showOnPage')
                }),
                children: s('myPage.sections.hiddenNotice')
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$ee7b405cffbc9dfd), {
                error: toggleCard.error,
                testId: `my-page-editor-${kind}-toggle-error`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$dbe2aedc96d1a17d), {
                errors: [
                    ...lastRefusal,
                    ...pageErrors.filter((e)=>!lastRefusal.some((r)=>r.code === e.code && r.field === e.field))
                ],
                testId: `my-page-editor-${kind}-errors`
            }),
            kind !== 'hero' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e6e0b3d7ac2d5ecf$var$TitleOverride, {
                section: section,
                actions: actions,
                cards: cards,
                readOnly: readOnly
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(Editor, {
                page: page,
                section: section,
                actions: actions,
                cards: cards,
                readOnly: readOnly
            })
        ]
    });
}


function $b81be6b08f752b10$export$2e2bcd8739ae039() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const toast = (0, $6usBW.useToast)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const notify = (0, $acw62.useCallback)((kind, key)=>toast[kind]?.(s(key)), [
        toast,
        s
    ]);
    const screen = (0, $819f3046f3b98c8e$export$57e6dc74dd06ce9f)({
        notify: notify
    });
    const { page: page, loading: loading, error: error, reload: reload, cards: cards, publishErrors: publishErrors, actions: actions, tab: tab, readOnly: readOnly } = screen;
    const leads = (0, $3b62335a4d4d6420$export$1f76e6205b77f0d4)({
        active: tab === 'leads' && !!page,
        pageSize: (0, $6f0813e0b3e01b00$export$5ec175ebc4bc2aa7)
    });
    const selected = screen.section || 'hero';
    // A click in «بخش‌ها» selects the section AND brings its card into view —
    // also when it is already the selected one, so it is not an effect on `selected`.
    const scrollToSection = (0, $acw62.useCallback)((kind)=>{
        document.getElementById(`my-page-section-${kind}`)?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    const focusSection = (0, $acw62.useCallback)((kind)=>{
        screen.selectSection(kind);
        scrollToSection(kind);
    }, [
        screen,
        scrollToSection
    ]);
    // A deep link (?section=office) lands on its card once the page has loaded.
    const deepLinked = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!page || deepLinked.current || tab !== 'builder') return;
        deepLinked.current = true;
        if (screen.section) scrollToSection(screen.section);
    }, [
        page,
        tab,
        screen.section,
        scrollToSection
    ]);
    const tabs = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
        ariaLabel: s('myPage.tabs.label'),
        testId: "my-page-tabs",
        value: tab,
        onChange: screen.selectTab,
        items: [
            {
                id: 'builder',
                label: s('myPage.tabs.builder')
            },
            {
                id: 'leads',
                label: s('myPage.tabs.leads')
            }
        ]
    });
    let body;
    if (loading && !page) body = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b9c2923150d9afb$export$386856ba1c60f856), {});
    else if (error && !page) body = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page",
        "data-state": "error",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: error,
            title: s('myPage.loadFailed'),
            onRetry: reload
        })
    });
    else if (page && tab === 'leads') body = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2887aa11b36d671f$export$a5e7d81c1988fd91), {
        leads: leads,
        published: (0, $6f0813e0b3e01b00$export$f23acc97a99da739)(page)
    });
    else if (page) {
        const missingCouncil = (page.publishBlockers || []).some((b)=>b.code === 'MISSING_COUNCIL_NUMBER');
        body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-testid": "my-page",
            "data-state": "content",
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1.25rem',
                alignItems: 'flex-start'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("aside", {
                    style: {
                        flex: '1 1 17rem',
                        maxWidth: '22rem',
                        display: 'grid',
                        gap: '1rem',
                        minWidth: 0,
                        position: 'sticky',
                        top: '1rem',
                        maxHeight: 'calc(100vh - 2rem)',
                        overflowY: 'auto',
                        overscrollBehavior: 'contain'
                    },
                    "aria-label": s('myPage.railLabel'),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$b97775e0f6759140), {
                            page: page,
                            cards: cards,
                            onPreview: screen.preview,
                            onPublishClick: screen.openPublish,
                            onUnpublish: screen.unpublish
                        }),
                        screen.blockedPreview ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                            variant: "info",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: screen.blockedPreview,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                style: {
                                    color: (0, $jTCZr.C).navy
                                },
                                children: s('myPage.statusCard.openPreview')
                            })
                        }) : null,
                        missingCouncil ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "outline",
                            size: "sm",
                            onClick: ()=>navigate('profile', {
                                    tab: 'profile'
                                }),
                            "data-testid": "my-page-go-profile",
                            children: s('myPage.statusCard.addCouncil')
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$cff5ea1de693973), {
                            page: page,
                            cards: cards,
                            onSave: screen.saveSlug,
                            readOnly: readOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$676410d4b8e9f49b), {
                            page: page,
                            cards: cards,
                            onChange: screen.changeTemplate,
                            readOnly: readOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$c1e6afee7dab8877), {
                            page: page,
                            cards: cards,
                            onChange: screen.changeTheme,
                            readOnly: readOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$6d1d899ad8590d82), {
                            page: page,
                            cards: cards,
                            selected: selected,
                            onSelect: focusSection,
                            onToggle: screen.toggleSection,
                            onMove: screen.moveSections,
                            readOnly: readOnly,
                            publishErrors: publishErrors
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flex: '999 1 30rem',
                        minWidth: 0,
                        display: 'grid',
                        gap: '1.25rem'
                    },
                    "data-testid": "my-page-editors",
                    children: (0, $6f0813e0b3e01b00$export$53e69196b53dea9f)(page.sections).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$6ac00e15d0217879), {
                            id: `my-page-section-${sec.kind}`,
                            active: sec.kind === selected,
                            title: s(`myPage.sections.kinds.${sec.kind}`),
                            testId: `my-page-editor-card-${sec.kind}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6e0b3d7ac2d5ecf$export$2e2bcd8739ae039), {
                                page: page,
                                kind: sec.kind,
                                actions: actions,
                                cards: cards,
                                readOnly: readOnly,
                                publishErrors: publishErrors
                            })
                        }, sec.kind))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "min-h-full flex flex-col bg-background",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: s('nav.items.myPage'),
                sub: s('myPage.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '1.5rem 2rem',
                    display: 'grid',
                    gap: '1.25rem',
                    maxWidth: '90rem',
                    width: '100%',
                    margin: '0 auto',
                    boxSizing: 'border-box'
                },
                children: [
                    page ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$94d3e53a4bb1317c), {
                        page: page
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: tabs
                    }),
                    body
                ]
            }),
            page ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $824be4914b20c2ed$export$2e2bcd8739ae039), {
                open: screen.publishOpen,
                onClose: screen.closePublish,
                onPublish: screen.publish,
                busy: !!cards.publish?.saving,
                error: cards.publish?.error,
                isMobile: false
            }) : null
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
var $gKFEi = parcelRequire("gKFEi");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");














// ─────────────────────────────────────────────────────────────────────────────
// «صفحهٔ من» — the phone (MOBILE_WEB_PWA). A reduction of the desktop: one
// column — status, slug, template, theme, the section list — and each section
// opens as a FULL-SCREEN editor (?section=<kind>, so platform back closes it
// and the bottom nav steps aside). Inputs are ≥ 1rem (iOS focus-zoom).
// Render-only: behaviour is useMyPageScreen.
// ─────────────────────────────────────────────────────────────────────────────
const $d7e0dc29e9c83180$var$PAGE = {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: (0, $jTCZr.C).bg
};
const $d7e0dc29e9c83180$var$SCROLL = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: '1.5rem'
};
const $d7e0dc29e9c83180$var$MOBILE_FIELD = {
    fontSize: '1rem'
};
function $d7e0dc29e9c83180$export$2e2bcd8739ae039() {
    const s = (0, $031020e651fcb248$export$e26de3bf29781b07)();
    const toast = (0, $6usBW.useToast)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const notify = (0, $acw62.useCallback)((kind, key)=>toast[kind]?.(s(key)), [
        toast,
        s
    ]);
    const screen = (0, $819f3046f3b98c8e$export$57e6dc74dd06ce9f)({
        notify: notify
    });
    const { page: page, loading: loading, error: error, reload: reload, cards: cards, publishErrors: publishErrors, actions: actions, tab: tab, readOnly: readOnly } = screen;
    const leads = (0, $3b62335a4d4d6420$export$1f76e6205b77f0d4)({
        active: tab === 'leads' && !!page,
        pageSize: (0, $6f0813e0b3e01b00$export$5ec175ebc4bc2aa7),
        accumulate: true
    });
    // ── A section's full-screen editor ──
    if (page && tab === 'builder' && screen.section) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$efee071abbf6ae48).Provider, {
        value: $d7e0dc29e9c83180$var$MOBILE_FIELD,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $d7e0dc29e9c83180$var$PAGE,
            "data-testid": "my-page-mobile-editor",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                        title: s(`myPage.sections.kinds.${screen.section}`),
                        onBack: screen.closeSection,
                        backLabel: s('nav.items.myPage'),
                        backTestId: "my-page-editor-back"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        ...$d7e0dc29e9c83180$var$SCROLL,
                        padding: '1rem 0.875rem 2rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6e0b3d7ac2d5ecf$export$2e2bcd8739ae039), {
                        page: page,
                        kind: screen.section,
                        actions: actions,
                        cards: cards,
                        readOnly: readOnly,
                        publishErrors: publishErrors
                    })
                })
            ]
        })
    });
    let body;
    if (loading && !page) body = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b9c2923150d9afb$export$a303b83526e46099), {});
    else if (error && !page) body = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "my-page",
        "data-state": "error",
        style: {
            padding: '1rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: error,
            title: s('myPage.loadFailed'),
            onRetry: reload
        })
    });
    else if (page && tab === 'leads') body = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            padding: '0 0.875rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2887aa11b36d671f$export$2143e15a5d8b9ec9), {
            leads: leads,
            published: (0, $6f0813e0b3e01b00$export$f23acc97a99da739)(page)
        })
    });
    else if (page) {
        const errorsByKind = (0, $6f0813e0b3e01b00$export$cb46fb9ca2e05378)([
            ...page.publishBlockers || [],
            ...publishErrors || []
        ]);
        const missingCouncil = (page.publishBlockers || []).some((b)=>b.code === 'MISSING_COUNCIL_NUMBER');
        body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-testid": "my-page",
            "data-state": "content",
            style: {
                display: 'grid',
                gap: '0.75rem',
                padding: '0 0.875rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$b97775e0f6759140), {
                    page: page,
                    cards: cards,
                    onPreview: screen.preview,
                    onPublishClick: screen.openPublish,
                    onUnpublish: screen.unpublish
                }),
                screen.blockedPreview ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "info",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: screen.blockedPreview,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {
                            color: (0, $jTCZr.C).navy
                        },
                        children: s('myPage.statusCard.openPreview')
                    })
                }) : null,
                missingCouncil ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    className: "min-h-11 w-full",
                    onClick: ()=>navigate('profile', {
                            tab: 'profile'
                        }),
                    "data-testid": "my-page-go-profile",
                    children: s('myPage.statusCard.addCouncil')
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                    "aria-label": s('myPage.sections.title'),
                    "data-testid": "my-page-mobile-sections",
                    style: {
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: (0, $jTCZr.RADIUS).card,
                        padding: '0.5rem',
                        display: 'grid',
                        gap: '0.125rem'
                    },
                    children: (0, $6f0813e0b3e01b00$export$53e69196b53dea9f)(page.sections).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: ()=>screen.openSection(sec.kind),
                            "data-testid": `my-page-mobile-section-${sec.kind}`,
                            className: "h-auto min-h-11 w-full justify-start gap-3 rounded-xl px-2 py-2 font-normal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        textAlign: 'start',
                                        display: 'grid',
                                        gap: '0.125rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '0.9375rem',
                                                fontWeight: 600,
                                                color: sec.enabled ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.375rem'
                                            },
                                            children: [
                                                s(`myPage.sections.kinds.${sec.kind}`),
                                                errorsByKind[sec.kind]?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                                                    size: 14,
                                                    "aria-label": s('myPage.sections.hasErrors'),
                                                    style: {
                                                        color: (0, $jTCZr.C).amber
                                                    }
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.75rem',
                                                color: (0, $jTCZr.C).textSecondary,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.25rem'
                                            },
                                            children: !sec.supportedByTemplate ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22a80d2cd266adcc$export$2e2bcd8739ae039), {
                                                        size: 12,
                                                        "aria-hidden": true
                                                    }),
                                                    " ",
                                                    s('myPage.sections.unsupported')
                                                ]
                                            }) : sec.enabled ? s('myPage.sections.shown') : s('myPage.sections.hidden')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                                    size: 16,
                                    "aria-hidden": true,
                                    style: {
                                        color: (0, $jTCZr.C).textMuted,
                                        flexShrink: 0,
                                        ...(0, $asXy3.MIRROR_ICON)
                                    }
                                })
                            ]
                        }, sec.kind))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$6d1d899ad8590d82), {
                    page: page,
                    cards: cards,
                    selected: null,
                    onSelect: screen.openSection,
                    onToggle: screen.toggleSection,
                    onMove: screen.moveSections,
                    readOnly: readOnly,
                    publishErrors: publishErrors,
                    testId: "my-page-sections"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$cff5ea1de693973), {
                    page: page,
                    cards: cards,
                    onSave: screen.saveSlug,
                    readOnly: readOnly
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$676410d4b8e9f49b), {
                    page: page,
                    cards: cards,
                    onChange: screen.changeTemplate,
                    readOnly: readOnly
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$c1e6afee7dab8877), {
                    page: page,
                    cards: cards,
                    onChange: screen.changeTheme,
                    readOnly: readOnly
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d5fad4093839d7c$export$efee071abbf6ae48).Provider, {
        value: $d7e0dc29e9c83180$var$MOBILE_FIELD,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $d7e0dc29e9c83180$var$PAGE,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                        title: s('nav.items.myPage')
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $d7e0dc29e9c83180$var$SCROLL,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gap: '0.75rem',
                                padding: '0.875rem 0.875rem 0'
                            },
                            children: [
                                page ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5c08531ef3e7962$export$94d3e53a4bb1317c), {
                                    page: page
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                    ariaLabel: s('myPage.tabs.label'),
                                    testId: "my-page-tabs",
                                    value: tab,
                                    onChange: screen.selectTab,
                                    items: [
                                        {
                                            id: 'builder',
                                            label: s('myPage.tabs.builder')
                                        },
                                        {
                                            id: 'leads',
                                            label: s('myPage.tabs.leads')
                                        }
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                paddingTop: '0.75rem'
                            },
                            children: body
                        })
                    ]
                }),
                page ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $824be4914b20c2ed$export$2e2bcd8739ae039), {
                    open: screen.publishOpen,
                    onClose: screen.closePublish,
                    onPublish: screen.publish,
                    busy: !!cards.publish?.saving,
                    error: cards.publish?.error,
                    isMobile: true
                }) : null
            ]
        })
    });
}


// «صفحهٔ من» — the platform switch, nothing else (DESIGN_CONCEPT §4.4).
const $546339d7a73440ae$var$MyPageScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7e0dc29e9c83180$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b81be6b08f752b10$export$2e2bcd8739ae039), {});
};
var $546339d7a73440ae$export$2e2bcd8739ae039 = $546339d7a73440ae$var$MyPageScreen;




var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $5AX1S = parcelRequire("5AX1S");
var $fAR2n = parcelRequire("fAR2n");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");
var $3GEBR = parcelRequire("3GEBR");
var $6usBW = parcelRequire("6usBW");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $eea507cd16630bf5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.744 17.736a6 6 0 1 1-7.48-7.48",
            key: "bq4yh3"
        }
    ],
    [
        "path",
        {
            d: "M15 6h1v4",
            key: "11y1tn"
        }
    ],
    [
        "path",
        {
            d: "m6.134 14.768.866-.5 2 3.464",
            key: "17snzx"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "8",
            r: "6",
            key: "14bfc9"
        }
    ]
];
const $eea507cd16630bf5$export$2e2bcd8739ae039 = (0, $9QBug.default)("coins", $eea507cd16630bf5$export$3efd853dbb351e94);


var $3FyOw = parcelRequire("3FyOw");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $28c537554ab887f4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 8 6 6",
            key: "1wu5hv"
        }
    ],
    [
        "path",
        {
            d: "m4 14 6-6 2-3",
            key: "1k1g8d"
        }
    ],
    [
        "path",
        {
            d: "M2 5h12",
            key: "or177f"
        }
    ],
    [
        "path",
        {
            d: "M7 2h1",
            key: "1t2jsx"
        }
    ],
    [
        "path",
        {
            d: "m22 22-5-10-5 10",
            key: "don7ne"
        }
    ],
    [
        "path",
        {
            d: "M14 18h6",
            key: "1m8k6r"
        }
    ]
];
const $28c537554ab887f4$export$2e2bcd8739ae039 = (0, $9QBug.default)("languages", $28c537554ab887f4$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6afa9587a7f0fe2f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "18",
            x: "3",
            y: "3",
            rx: "1",
            key: "2obqm"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "3",
            rx: "1",
            key: "6d4xhi"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "14",
            rx: "1",
            key: "nxv5o0"
        }
    ]
];
const $6afa9587a7f0fe2f$export$2e2bcd8739ae039 = (0, $9QBug.default)("layout-panel-left", $6afa9587a7f0fe2f$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f4f73b3410e8104a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
            key: "e79jfc"
        }
    ],
    [
        "circle",
        {
            cx: "13.5",
            cy: "6.5",
            r: ".5",
            fill: "currentColor",
            key: "1okk4w"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "10.5",
            r: ".5",
            fill: "currentColor",
            key: "f64h9f"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "12.5",
            r: ".5",
            fill: "currentColor",
            key: "qy21gx"
        }
    ],
    [
        "circle",
        {
            cx: "8.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "fotxhn"
        }
    ]
];
const $f4f73b3410e8104a$export$2e2bcd8739ae039 = (0, $9QBug.default)("palette", $f4f73b3410e8104a$export$3efd853dbb351e94);


var $aVx4q = parcelRequire("aVx4q");
var $bo0GS = parcelRequire("bo0GS");
var $chm1L = parcelRequire("chm1L");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ff4d96da330336c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $ff4d96da330336c2$export$2e2bcd8739ae039 = (0, $9QBug.default)("user", $ff4d96da330336c2$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The settings section navigator. Same idiom as MobilePatientNav: a horizontal,
// thumb-scrollable strip, icon over label, active in navy with a navy underline,
// one page-level scroll below it (mobile concept §5, §6).
//
// The section SET comes from Settings.shared.js so both surfaces agree on what
// sections exist and in what order; only the icons are mobile's own.
const $afdb707fcfdd3978$var$SECTION_ICONS = {
    profile: (0, $ff4d96da330336c2$export$2e2bcd8739ae039),
    ai: (0, $chm1L.default),
    visit: (0, $6afa9587a7f0fe2f$export$2e2bcd8739ae039),
    templates: (0, $3FyOw.default),
    prescription: (0, $aVx4q.default),
    credits: (0, $eea507cd16630bf5$export$2e2bcd8739ae039),
    language: (0, $28c537554ab887f4$export$2e2bcd8739ae039),
    appearance: (0, $f4f73b3410e8104a$export$2e2bcd8739ae039),
    clinics: (0, $20b80355eea4425a$export$2e2bcd8739ae039),
    security: (0, $bo0GS.default)
};
const $afdb707fcfdd3978$var$MobileSettingsNav = ({ sections: sections, active: active, onChange: onChange })=>{
    const { t: t } = (0, $LNQP4.default)();
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        activeRef.current?.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "settings-nav",
        role: "tablist",
        "aria-label": t('settings.sectionsLabel'),
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0,
            overflowX: 'auto',
            display: 'flex',
            scrollbarWidth: 'none',
            padding: '0 0.25rem',
            position: 'sticky',
            top: 0,
            zIndex: 2
        },
        children: sections.map(({ id: id, labelKey: labelKey })=>{
            const Icon = $afdb707fcfdd3978$var$SECTION_ICONS[id] || (0, $ff4d96da330336c2$export$2e2bcd8739ae039);
            const on = active === id;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                ref: on ? activeRef : undefined,
                variant: "ghost",
                role: "tab",
                "aria-selected": on,
                "data-testid": `settings-nav-${id}`,
                onClick: ()=>onChange(id),
                className: "h-auto min-h-11 flex-col gap-0.5 rounded-none px-3.5 py-2 shrink-0 hover:bg-transparent",
                style: {
                    color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                    fontWeight: on ? 700 : 500,
                    borderBottom: on ? `2.5px solid ${(0, $jTCZr.C).navy}` : '2.5px solid transparent'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                        size: 16,
                        strokeWidth: on ? 2.4 : 2,
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem'
                        },
                        children: t(labelKey)
                    })
                ]
            }, id);
        })
    });
};
var $afdb707fcfdd3978$export$2e2bcd8739ae039 = $afdb707fcfdd3978$var$MobileSettingsNav;



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $f39c13b15f45abee$export$7ce3cbddb17efe71 = ({ title: title, hint: hint, testId: testId, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.875rem',
            boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
            padding: '0.875rem 1rem'
        },
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: '0.9375rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: title
            }),
            hint && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0.25rem 0 0',
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.8
                },
                children: hint
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: title || hint ? '0.5rem' : 0
                },
                children: children
            })
        ]
    });
const $f39c13b15f45abee$export$62a556f19792b723 = ({ label: label, value: value, ltr: ltr, testId: testId })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: '1rem',
            padding: '0.6875rem 0',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textMuted,
                    flexShrink: 0
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                dir: ltr ? 'ltr' : 'auto',
                style: {
                    fontSize: '0.875rem',
                    color: value ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
                    fontWeight: value ? 600 : 400,
                    textAlign: 'end',
                    minWidth: 0,
                    overflowWrap: 'anywhere'
                },
                children: value || "\u2014"
            })
        ]
    });
const $f39c13b15f45abee$export$234308a1466fa189 = ({ percent: percent })=>{
    const { t: t, formatPercent: formatPercent } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-completeness",
        style: {
            marginTop: '0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '0.75rem',
                    marginBottom: '0.375rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('settings.profile.completeProfile')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: (0, $jTCZr.C).textPrimary,
                            fontWeight: 700
                        },
                        children: formatPercent(percent)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "progressbar",
                "aria-valuenow": percent,
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-label": t('settings.profile.completeProfile'),
                style: {
                    height: '0.375rem',
                    borderRadius: 999,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: `${percent}%`,
                        height: '100%',
                        background: (0, $jTCZr.C).green,
                        borderRadius: 999
                    }
                })
            })
        ]
    });
};






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The settings-side twin of the sidebar's «رفتن به پنل کلینیک» switch.
//
// The sidebar row is the one a doctor uses daily; this is the one they find
// when they go looking, in the «مطب‌ها» section that already answers "which
// clinics am I in". Both surfaces (web + mobile settings) render THIS, so the
// eligibility rule and the destination stay one fact rather than three.
//
// Renders nothing when there is no clinic to enter — same rule as the sidebar:
// hidden, never disabled.
const $d2e16480984d7f73$var$ClinicSwitchButton = ({ className: className })=>{
    const { t: t } = (0, $LNQP4.default)();
    const { canSwitch: canSwitch, targets: targets } = (0, $90c3af16928ea94c$export$f5416d3c5746c6f8)();
    if (!canSwitch) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
        variant: "outline",
        "data-testid": "settings-switch-to-clinic",
        className: className,
        // Plain navigation, same tab: the clinic panel signs in silently off the
        // shared Keycloak session (same `parsina-web` client, same realm).
        //
        // With exactly one clinic the target is named, so the panel opens THAT one
        // rather than inferring. With several, the bare root is correct: this button
        // makes no choice, and the panel's own switcher is where one is made.
        onClick: ()=>(0, $90c3af16928ea94c$export$35411b84b35a3ed4)(targets.length === 1 ? targets[0] : undefined),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true
            }),
            t('nav.clinicSwitch.open')
        ]
    });
};
var $d2e16480984d7f73$export$2e2bcd8739ae039 = $d2e16480984d7f73$var$ClinicSwitchButton;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9iIGe = parcelRequire("9iIGe");
var $3GEBR = parcelRequire("3GEBR");



var $acw62 = parcelRequire("acw62");

// Reads/writes the wallet low-balance alert config (BFF: lowBalanceConfig /
// updateLowBalanceThreshold). Threshold is in coins. The red ≤50 floor is a
// fixed client rule (constants/credit); this threshold drives the amber warning.
const $015f2861c6e3f66e$var$CONFIG_QUERY = `
  query LowBalanceConfig($ownerId: String!, $ownerType: String!) {
    lowBalanceConfig(ownerId: $ownerId, ownerType: $ownerType) {
      threshold enableAlerts alertEmail alertPhone
    }
  }
`;
const $015f2861c6e3f66e$var$UPDATE_MUTATION = `
  mutation UpdateLowBalance($ownerId: String!, $ownerType: String!, $threshold: Float!, $enableAlerts: Boolean!) {
    updateLowBalanceThreshold(ownerId: $ownerId, ownerType: $ownerType, threshold: $threshold, enableAlerts: $enableAlerts) {
      threshold enableAlerts
    }
  }
`;
function $015f2861c6e3f66e$export$2177e3f0da1cd259(doctorId) {
    const [config, setConfig] = (0, $acw62.useState)(null); // { threshold, enableAlerts }
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(()=>{
        if (!doctorId) return;
        setLoading(true);
        (0, $adebb901af88e18b$export$7fb4864174f056c)($015f2861c6e3f66e$var$CONFIG_QUERY, {
            ownerId: doctorId,
            ownerType: 'doctor'
        }).then((res)=>{
            const c = res?.lowBalanceConfig;
            setConfig(c ? {
                threshold: c.threshold,
                enableAlerts: c.enableAlerts
            } : {
                threshold: 200,
                enableAlerts: true
            });
            setError(null);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        doctorId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const save = (0, $acw62.useCallback)(async (next)=>{
        if (!doctorId) return false;
        setSaving(true);
        try {
            await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($015f2861c6e3f66e$var$UPDATE_MUTATION, {
                ownerId: doctorId,
                ownerType: 'doctor',
                threshold: Number(next.threshold),
                enableAlerts: !!next.enableAlerts
            });
            setConfig({
                threshold: Number(next.threshold),
                enableAlerts: !!next.enableAlerts
            });
            return true;
        } catch (e) {
            setError(e);
            return false;
        } finally{
            setSaving(false);
        }
    }, [
        doctorId
    ]);
    return {
        config: config,
        loading: loading,
        error: error,
        saving: saving,
        reload: load,
        save: save
    };
}




var $jTCZr = parcelRequire("jTCZr");


var $1HT9m = parcelRequire("1HT9m");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

function $8834639d9186ea40$export$2e2bcd8739ae039({ isMobile: isMobile = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { doctor: doctor } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const balance = (0, $29025bf29a861ca6$export$512f6b8a30d065e1)(doctor?.id);
    const { config: config, loading: loading, saving: saving, save: save } = (0, $015f2861c6e3f66e$export$2177e3f0da1cd259)(doctor?.id);
    const { canBuy: canBuy } = (0, $731b4ceb5faa7ddf$export$2f04c8775b039db)();
    const [enableAlerts, setEnableAlerts] = (0, $acw62.useState)(true);
    const [threshold, setThreshold] = (0, $acw62.useState)(String((0, $jTCZr.CREDIT_LOW) * 4));
    const [savedTick, setSavedTick] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (config) {
            setEnableAlerts(config.enableAlerts);
            setThreshold(String(Math.round(config.threshold)));
        }
    }, [
        config
    ]);
    const dirty = config && (config.enableAlerts !== enableAlerts || Math.round(config.threshold) !== Number(threshold));
    const level = (0, $jTCZr.creditLevel)(balance);
    const onSave = async ()=>{
        const ok = await save({
            enableAlerts: enableAlerts,
            threshold: Math.max((0, $jTCZr.CREDIT_LOW), Number(threshold) || (0, $jTCZr.CREDIT_LOW))
        });
        if (ok) {
            setSavedTick(true);
            setTimeout(()=>setSavedTick(false), 2000);
        }
    };
    const card = {
        background: (0, $jTCZr.C).card,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        borderRadius: 14,
        padding: isMobile ? 14 : 18,
        boxShadow: '0 1px 6px rgba(0,0,0,0.05)'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            maxWidth: 640
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...card,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 140
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).caption,
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: t('credits.currentBalance')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginTop: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: (0, $jTCZr.creditColor)(balance),
                                            display: 'flex'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
                                            size: 16
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).metric,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: balance === null ? "\u2014" : (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(balance, formatNumber)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).unit,
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: t('common.units.coin')
                                    }),
                                    balance !== null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...(0, $1HT9m.type).caption,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.CREDIT_LEVEL_META)[level].color,
                                            background: (0, $jTCZr.CREDIT_LEVEL_META)[level].tint,
                                            borderRadius: 999,
                                            padding: '2px 9px'
                                        },
                                        children: t((0, $jTCZr.CREDIT_LEVEL_META)[level].labelKey)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>navigate('credits'),
                        "data-testid": "settings-credits-view",
                        children: t('credits.viewTransactions')
                    }),
                    canBuy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "sm",
                        onClick: ()=>navigate('credits'),
                        "data-testid": "settings-credits-topup",
                        children: t('credits.buyCoins')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: card,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            ...(0, $1HT9m.type).title,
                            color: (0, $jTCZr.C).textPrimary,
                            margin: '0 0 4px'
                        },
                        children: t('credits.lowBalanceTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).label,
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 14
                        },
                        children: t('credits.lowBalanceHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                        id: "settings-credits-alerts",
                        "data-testid": "settings-credits-alerts",
                        label: t('settings.credits.thresholdAlert'),
                        checked: enableAlerts,
                        onChange: setEnableAlerts,
                        disabled: loading
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            marginTop: 16,
                            opacity: enableAlerts ? 1 : 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).label,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('credits.thresholdLabel')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).micro,
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 2
                                        },
                                        children: t('credits.thresholdMin', {
                                            amount: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)((0, $jTCZr.CREDIT_LOW), formatNumber)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 120
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iIGe.default), {
                                    value: threshold,
                                    onChange: (e)=>setThreshold(e.target.value),
                                    min: (0, $jTCZr.CREDIT_LOW),
                                    disabled: !enableAlerts || loading,
                                    "aria-label": t('settings.credits.threshold'),
                                    "data-testid": "settings-credits-threshold"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                onClick: onSave,
                                disabled: !dirty || saving,
                                "data-testid": "settings-credits-save",
                                children: saving ? t('common.state.saving') : t('common.actions.save')
                            }),
                            savedTick && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    ...(0, $1HT9m.type).label,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).green
                                },
                                children: [
                                    t('common.state.saved'),
                                    " \u2713"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// «قالب‌ها» on a phone.
//
// Its own render tree, per the mobile concept — one column, full-bleed rows, no
// desktop two-up grid. What it does NOT re-implement is the item EDITOR: that
// dialog is a stack of labelled fields in a scrollable sheet, identical work on
// either surface, and a second copy of it would be a second place for «what a
// template item contains» to drift. It is imported from the desktop kit and
// rendered as-is.
// ─────────────────────────────────────────────────────────────────────────────

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $66joL = parcelRequire("66joL");




parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// ─────────────────────────────────────────────────────────────────────────────
// «قالب‌ها» — the Settings section where a doctor builds the two kinds of
// reusable visit template, desktop surface.
//
// The screen answers, in order, the three questions a doctor arriving here has:
// what a template IS, what the two kinds are for, and what happens when one is
// applied to a visit. That explanation is the first card, not a tooltip,
// because a feature nobody understands is a feature nobody uses — and the one
// thing that must be understood here is that applying COPIES: the visit gets
// its own editable items, and nothing that happens to either side afterwards
// reaches the other.
//
// Layout follows the rest of Settings (§2.2): a P1 stack of SectionCards, one
// per kind, each a compact table of templates rather than a grid of cards.
// ─────────────────────────────────────────────────────────────────────────────

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $7gSBD = parcelRequire("7gSBD");
var $9iIGe = parcelRequire("9iIGe");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");



parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
const $c48eb69ce5e269ee$export$61c2590db9f20ec1 = 10;
const $c48eb69ce5e269ee$export$cf052b29a1666d6a = 14;
const $c48eb69ce5e269ee$export$345619c94cb75947 = '0 1px 6px rgba(0,0,0,0.05)';
const $c48eb69ce5e269ee$export$373e92e0788ff06e = {
    direction: 'ltr'
};
const $c48eb69ce5e269ee$export$69ed894a7932b604 = ({ icon: icon, iconBg: iconBg, iconColor: iconColor, title: title, subtitle: subtitle, testId: testId, actions: actions, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: $c48eb69ce5e269ee$export$cf052b29a1666d6a,
            boxShadow: $c48eb69ce5e269ee$export$345619c94cb75947,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '18px 22px 16px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": true,
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: $c48eb69ce5e269ee$export$61c2590db9f20ec1,
                            flexShrink: 0,
                            background: iconBg ?? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                            color: iconColor ?? (0, $jTCZr.C).navy,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                style: {
                                    margin: 0,
                                    fontSize: 15,
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginTop: 2
                                },
                                children: subtitle
                            })
                        ]
                    }),
                    actions
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '20px 22px'
                },
                children: children
            })
        ]
    });
// The widest a run of form fields is allowed to get: two columns of a
// comfortable input. Cards still stretch to the page (§2.2) — this caps the
// CONTENT inside them, which is what stops a wide monitor turning a five-field
// identity form into a single flat row of boxes.
const $c48eb69ce5e269ee$var$FIELD_COL = 340;
const $c48eb69ce5e269ee$export$9543e7b3be254c7c = $c48eb69ce5e269ee$var$FIELD_COL * 2 + 14;
/**
 * Responsive field grid.
 *
 * The old page hardcoded `1fr 1fr`, which forced two columns onto a 360px
 * phone. auto-fit + minmax collapses to one column when a column would fall
 * below `min`, so the same markup serves desktop and the mobile fork's forms
 * without a breakpoint (§4.2).
 *
 * `max` caps the column count. CSS has no "auto-fit but at most N", so the cap
 * is a max-width — but it has to be computed against `min`, not against the
 * column width you have in mind: auto-fit packs as many `min`-wide tracks as
 * fit, so a 694px cap with min 220 still admits THREE columns (3×220 + 2×14 =
 * 688). The binding constraint is therefore "one pixel narrower than N+1 tracks
 * would need"; the comfortable-width cap is applied on top of that, never
 * instead of it.
 */ const $c48eb69ce5e269ee$var$maxWidthFor = (max, min, gap)=>Math.min($c48eb69ce5e269ee$var$FIELD_COL * max + gap * (max - 1), (max + 1) * min + gap * max - 1);
const $c48eb69ce5e269ee$export$f9754e493f02dbbd = ({ min: min = 220, max: max, gap: gap = 14, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fit, minmax(min(${min}px, 100%), 1fr))`,
            gap: gap,
            ...max ? {
                maxWidth: $c48eb69ce5e269ee$var$maxWidthFor(max, min, gap)
            } : null
        },
        children: children
    });
/**
 * Profile-completeness rail card (§2.2 P2 — the rail beside the profile form).
 *
 * This replaced the completeness *bar* that sat under the identity fields, which
 * in turn replaced the conic dial on the old gradient hero. The bar was honest
 * but inert: it told a doctor they were at 75% and left them to hunt for which
 * field was missing. The rail states the percentage AND lists the gaps, and each
 * gap is a button that focuses its own field — the readout is now the way in.
 *
 * The ring is a stroked SVG, never a conic-gradient: the settings body must
 * paint no gradient at all (`settings.pagestructure.desktop.spec.js` counts
 * them, because a gradient slab is what made this page read as a modal).
 *
 * `role="progressbar"` lives on the ring, so the same assertion that covered the
 * bar still covers this (§12.4: the percentage is written out, never colour-only).
 */ const $c48eb69ce5e269ee$var$RING = {
    size: 96,
    stroke: 6
};
const $c48eb69ce5e269ee$var$RING_R = ($c48eb69ce5e269ee$var$RING.size - $c48eb69ce5e269ee$var$RING.stroke) / 2;
const $c48eb69ce5e269ee$var$RING_C = 2 * Math.PI * $c48eb69ce5e269ee$var$RING_R;
const $c48eb69ce5e269ee$export$ac8aef415a0397c5 = ({ name: name, specialty: specialty, percent: percent, items: items = [], onJump: onJump, avatar: avatar, avatarBusy: avatarBusy, onPickAvatar: onPickAvatar, onRemoveAvatar: onRemoveAvatar })=>{
    const { t: t, formatPercent: formatPercent } = (0, $LNQP4.default)();
    const remaining = items.filter((i)=>!i.filled);
    // The overlay buttons sit on the ring's inline-start edge, the same corners
    // the clinic app uses on its avatar.
    const overlayBtn = (color)=>({
            position: 'absolute',
            insetInlineStart: -2,
            width: 26,
            height: 26,
            borderRadius: '50%',
            background: (0, $jTCZr.C).card,
            color: color,
            border: `2px solid ${color}`,
            display: 'grid',
            placeItems: 'center',
            cursor: avatarBusy ? 'default' : 'pointer',
            boxShadow: $c48eb69ce5e269ee$export$345619c94cb75947,
            padding: 0
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        "data-testid": "settings-completeness",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: $c48eb69ce5e269ee$export$cf052b29a1666d6a,
            boxShadow: $c48eb69ce5e269ee$export$345619c94cb75947,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '22px 20px 18px',
                    textAlign: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            position: 'relative',
                            width: $c48eb69ce5e269ee$var$RING.size,
                            height: $c48eb69ce5e269ee$var$RING.size,
                            margin: '0 auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: $c48eb69ce5e269ee$var$RING.size,
                                height: $c48eb69ce5e269ee$var$RING.size,
                                role: "progressbar",
                                "aria-valuenow": percent,
                                "aria-valuemin": 0,
                                "aria-valuemax": 100,
                                "aria-label": t('settings.profile.completeProfile'),
                                style: {
                                    transform: 'rotate(-90deg)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: $c48eb69ce5e269ee$var$RING.size / 2,
                                        cy: $c48eb69ce5e269ee$var$RING.size / 2,
                                        r: $c48eb69ce5e269ee$var$RING_R,
                                        fill: "none",
                                        stroke: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                                        strokeWidth: $c48eb69ce5e269ee$var$RING.stroke
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: $c48eb69ce5e269ee$var$RING.size / 2,
                                        cy: $c48eb69ce5e269ee$var$RING.size / 2,
                                        r: $c48eb69ce5e269ee$var$RING_R,
                                        fill: "none",
                                        stroke: percent === 100 ? (0, $jTCZr.C).green : (0, $jTCZr.C).teal,
                                        strokeWidth: $c48eb69ce5e269ee$var$RING.stroke,
                                        strokeLinecap: "round",
                                        strokeDasharray: $c48eb69ce5e269ee$var$RING_C,
                                        strokeDashoffset: $c48eb69ce5e269ee$var$RING_C * (1 - Math.min(100, Math.max(0, percent)) / 100),
                                        style: {
                                            transition: 'stroke-dashoffset .4s ease'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    opacity: avatarBusy ? 0.6 : 1,
                                    transition: 'opacity 120ms'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                    name: name,
                                    size: $c48eb69ce5e269ee$var$RING.size - $c48eb69ce5e269ee$var$RING.stroke * 2 - 8,
                                    src: avatar || undefined
                                })
                            }),
                            onPickAvatar && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onPickAvatar,
                                disabled: avatarBusy,
                                title: avatar ? t('settings.avatar.change') : t('settings.avatar.add'),
                                "aria-label": avatar ? t('settings.avatar.change') : t('settings.avatar.add'),
                                "data-testid": "settings-avatar-edit",
                                style: {
                                    ...overlayBtn((0, $jTCZr.C).navy),
                                    bottom: -2
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.camera, {
                                    s: 13
                                })
                            }),
                            onRemoveAvatar && avatar && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onRemoveAvatar,
                                disabled: avatarBusy,
                                title: t('settings.avatar.removeTitle'),
                                "aria-label": t('settings.avatar.removeTitle'),
                                "data-testid": "settings-avatar-remove",
                                style: {
                                    ...overlayBtn((0, $jTCZr.C).red),
                                    top: -2
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.trash, {
                                    s: 13
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "auto",
                        style: {
                            marginTop: 14,
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: name
                    }),
                    specialty && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2
                        },
                        children: specialty
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 6
                        },
                        children: t('settings.profile.percentComplete', {
                            percent: formatPercent(percent)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    padding: '14px 16px 16px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 10
                        },
                        children: remaining.length === 0 ? t('settings.profile.allComplete') : t('settings.profile.remaining', {
                            count: remaining.length
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        style: {
                            listStyle: 'none',
                            margin: 0,
                            padding: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        },
                        children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: item.filled ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        padding: '7px 8px',
                                        fontSize: 12.5,
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                display: 'flex',
                                                color: (0, $jTCZr.C).green,
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.check, {
                                                s: 15
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                flex: 1,
                                                textAlign: 'start'
                                            },
                                            children: t(item.labelKey)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    "data-testid": `settings-completeness-jump-${item.key}`,
                                    onClick: ()=>onJump?.(item.key),
                                    style: {
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        padding: '7px 8px',
                                        borderRadius: 8,
                                        cursor: 'pointer',
                                        background: 'transparent',
                                        border: 'none',
                                        font: 'inherit',
                                        fontSize: 12.5,
                                        color: (0, $jTCZr.C).textSecondary,
                                        textAlign: 'start'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "aria-hidden": true,
                                            style: {
                                                width: 15,
                                                height: 15,
                                                borderRadius: '50%',
                                                flexShrink: 0,
                                                border: `1.5px dashed ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35)}`
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                flex: 1,
                                                textAlign: 'start'
                                            },
                                            children: t(item.labelKey)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                display: 'flex',
                                                color: (0, $jTCZr.C).textMuted,
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.chevron, {
                                                s: 14
                                            })
                                        })
                                    ]
                                })
                            }, item.key))
                    })
                ]
            })
        ]
    });
};
const $c48eb69ce5e269ee$export$b281dc69f5ee0eb0 = ({ saving: saving, onReset: onReset, onSave: onSave })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-savebar",
        role: "status",
        style: {
            position: 'sticky',
            bottom: 0,
            zIndex: 5,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            flexWrap: 'wrap',
            padding: '14px 18px',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: $c48eb69ce5e269ee$export$cf052b29a1666d6a,
            boxShadow: '0 -2px 12px rgba(0,0,0,0.07)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    display: 'flex',
                    color: (0, $jTCZr.C).amber,
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.alert, {
                    s: 18
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    flex: 1,
                    minWidth: 160,
                    fontSize: 13,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: t('settings.profile.unsavedShort')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: onReset,
                disabled: saving,
                "data-testid": "settings-savebar-reset",
                children: t('common.actions.reset')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "default",
                onClick: onSave,
                disabled: saving,
                "data-testid": "settings-savebar-submit",
                children: saving ? t('common.state.saving') : t('settings.profile.saveInfo')
            })
        ]
    });
};
// ── Clinic membership ─────────────────────────────────────────────────────────
//
// The framework `StatusBadge` is not usable here: `statusColors` covers the
// appointment and patient-record vocabularies only, so a membership status
// falls through to its grey default and renders the raw English key.
//
// These are the practitioner service's `clinic_doctors.status` words, verbatim:
// a link is born `pending` and `AcceptClinicDoctor` writes `accepted`. This map
// used to guess `active`/`approved` instead, so every membership the clinic had
// accepted missed it, fell back to `pending` and read «در انتظار تأیید».
const $c48eb69ce5e269ee$var$MEMBERSHIP_STATUS = {
    accepted: {
        labelKey: 'common.state.active',
        bg: (0, $jTCZr.C).greenLight,
        color: (0, $jTCZr.C).green
    },
    pending: {
        labelKey: 'settings.clinics.pending',
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.C).amber
    }
};
const $c48eb69ce5e269ee$export$ded970040a403667 = ({ name: name, meta: meta, status: status, children: children })=>{
    const { t: t } = (0, $LNQP4.default)();
    const cfg = $c48eb69ce5e269ee$var$MEMBERSHIP_STATUS[status] || $c48eb69ce5e269ee$var$MEMBERSHIP_STATUS.pending;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-clinic-row",
        "data-status": status || 'pending',
        style: {
            padding: '13px 14px',
            borderRadius: $c48eb69ce5e269ee$export$61c2590db9f20ec1,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card,
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": true,
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: $c48eb69ce5e269ee$export$61c2590db9f20ec1,
                            flexShrink: 0,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                            color: (0, $jTCZr.C).teal,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.clinic, {
                            s: 19
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: 13.5,
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: name
                            }),
                            meta && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginTop: 2
                                },
                                children: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flexShrink: 0,
                            fontSize: 11,
                            fontWeight: 700,
                            borderRadius: 20,
                            padding: '3px 10px',
                            background: cfg.bg,
                            color: cfg.color
                        },
                        children: t(cfg.labelKey)
                    })
                ]
            }),
            children
        ]
    });
};
const $c48eb69ce5e269ee$export$bf83aff0b09e7fcc = ({ title: title, hint: hint, style: style, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: style,
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                style: {
                    margin: '0 0 2px',
                    fontSize: 13,
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: title
            }),
            hint && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0 0 6px',
                    fontSize: 12,
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7
                },
                children: hint
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: children
            })
        ]
    });
const $c48eb69ce5e269ee$export$e7ba791b8e7021d3 = ({ icon: icon, iconBg: iconBg, iconColor: iconColor, title: title, subtitle: subtitle, items: items = [], cta: cta, href: href, note: note, testId: testId, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)($c48eb69ce5e269ee$export$69ed894a7932b604, {
        testId: testId,
        icon: icon,
        iconBg: iconBg,
        iconColor: iconColor,
        title: title,
        subtitle: subtitle,
        children: [
            children,
            items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                style: {
                    listStyle: 'none',
                    margin: 0,
                    padding: '14px 16px',
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.04),
                    border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.10)}`,
                    borderRadius: $c48eb69ce5e269ee$export$61c2590db9f20ec1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 11
                },
                children: items.map((label)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            fontSize: 13.5,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": true,
                                style: {
                                    width: 20,
                                    height: 20,
                                    borderRadius: '50%',
                                    flexShrink: 0,
                                    background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.16),
                                    color: (0, $jTCZr.C).teal,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c48eb69ce5e269ee$export$f04a61298a47a40f.check, {
                                    s: 13
                                })
                            }),
                            label
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    flexWrap: 'wrap',
                    marginTop: items.length ? 16 : 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: href,
                        "data-testid": testId ? `${testId}-link` : undefined,
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 9,
                            height: 42,
                            padding: '0 20px',
                            borderRadius: $c48eb69ce5e269ee$export$61c2590db9f20ec1,
                            background: (0, $jTCZr.C).navy,
                            color: '#fff',
                            textDecoration: 'none',
                            fontSize: 13.5,
                            fontWeight: 700
                        },
                        children: [
                            cta,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "15",
                                height: "15",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M7 17 17 7M9 7h8v8",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    note && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.7,
                            maxWidth: 380
                        },
                        children: note
                    })
                ]
            })
        ]
    });
const $c48eb69ce5e269ee$export$f04a61298a47a40f = {
    // A three-column page — the visit workspace's shape.
    layout: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h3V5H5zm5 0v14h4V5h-4zm6 0v14h3V5h-3z"
            })
        }),
    user: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            })
        }),
    badge: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
            })
        }),
    // A medicine bottle with a cross — the «نسخه» section.
    rx: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6 3h12v2H6zm11 3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 9h-2.5v2.5h-3V15H8v-3h2.5V9.5h3V12H16v3z"
            })
        }),
    lock: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
            })
        }),
    check: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 16,
            height: p.s || 16,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
            })
        }),
    sparkles: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 2l1.9 5.1L19 9l-5.1 1.9L12 16l-1.9-5.1L5 9l5.1-1.9L12 2zm6 12l.95 2.55L21.5 17.5l-2.55.95L18 21l-.95-2.55L14.5 17.5l2.55-.95L18 14zM6 14l.95 2.55L9.5 17.5l-2.55.95L6 21l-.95-2.55L2.5 17.5l2.55-.95L6 14z"
            })
        }),
    palette: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 3a9 9 0 000 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16a5 5 0 005-5c0-4.42-4.03-8-9-8zm-5.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3.5 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
            })
        }),
    clinic: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 2L2 7v2h20V7L12 2zM4 11v8H2v2h20v-2h-2v-8h-2v8h-3v-8h-2v8h-2v-8H9v8H6v-8H4zm7-1h2v2h2v2h-2v2h-2v-2H9v-2h2v-2z"
            })
        }),
    alert: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
            })
        }),
    camera: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 16,
            height: p.s || 16,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
            })
        }),
    trash: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 16,
            height: p.s || 16,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
            })
        }),
    globe: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 20,
            height: p.s || 20,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.99 7.99 0 015.08 16zm2.95-8H5.08a7.99 7.99 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
            })
        }),
    // Points at the START edge — left in RTL, right in LTR. The glyph is drawn
    // pointing left, so it is mirrored when the page is left-to-right rather than
    // shipped as two paths. `scaleX` is applied by the caller-agnostic transform
    // below so every use site mirrors, not just the ones that remembered to.
    chevron: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: p.s || 16,
            height: p.s || 16,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(var(--dir-flip, 1))'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
            })
        })
};


// ─────────────────────────────────────────────────────────────────────────────
// «افزودن از فهرست دارویی» — the formulary search inside the قالب نسخه editor.
//
// The visit's نسخه tab picks drugs from the تأمین‌اجتماعی catalogue and keeps
// the formulary id on every row, which is what the interaction checker and the
// insurer mapper join on. A template built by typing names has no such id, so
// applying it produced rows the checker could not see. This control gives the
// editor the same door the visit has: type a few letters, pick a row, and the
// item arrives with its `drugId`, its usual dose and its usual frequency.
//
// Deliberately small: a search box and a short result list. The visit's full
// picker (category rail, paging, batch add) is built for prescribing in a
// hurry; a template is written once, calmly, one drug at a time.
// ─────────────────────────────────────────────────────────────────────────────

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




const $7d370b169b41724a$var$MIN_QUERY = 2;
const $7d370b169b41724a$var$PAGE = 8;
const $7d370b169b41724a$var$DEBOUNCE_MS = 300;
function $7d370b169b41724a$export$2e2bcd8739ae039({ excludeIds: excludeIds, onPick: onPick, disabled: disabled = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const seq = (0, $acw62.useRef)(0);
    // Same rhythm as the visit's search: one call per pause in typing, and a
    // reply for an older query never overwrites a newer one.
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        if (q.length < $7d370b169b41724a$var$MIN_QUERY) {
            setRows([]);
            setTotal(0);
            setError(null);
            return undefined;
        }
        const mine = ++seq.current;
        const timer = setTimeout(async ()=>{
            setLoading(true);
            try {
                const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $375f8776645d5aee$export$e94eea18383a4188), {
                    query: q,
                    limit: $7d370b169b41724a$var$PAGE,
                    offset: 0
                });
                if (mine !== seq.current) return;
                setRows(data?.listDrugs?.drugs || []);
                setTotal(data?.listDrugs?.total || 0);
                setError(null);
            } catch (err) {
                if (mine !== seq.current) return;
                setError(t('settings.templates.loadFailed'));
            } finally{
                if (mine === seq.current) setLoading(false);
            }
        }, $7d370b169b41724a$var$DEBOUNCE_MS);
        return ()=>clearTimeout(timer);
    }, [
        query,
        t
    ]);
    const active = query.trim().length >= $7d370b169b41724a$var$MIN_QUERY;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "template-formulary",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: t('settings.templates.addFromFormulary'),
                helperText: t('settings.templates.formularyHint'),
                placeholder: t('visit.rx.searchDrug'),
                value: query,
                onChange: (e)=>setQuery(e?.target ? e.target.value : e),
                disabled: disabled,
                "data-testid": "template-formulary-search"
            }),
            active && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "template-formulary-results",
                style: {
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                    background: (0, $jTCZr.C).card,
                    padding: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                },
                children: loading && rows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonList), {
                    count: 2,
                    avatar: false,
                    trailing: 0,
                    label: t('common.state.loading')
                }) : error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "alert",
                    style: {
                        padding: '8px 10px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).danger
                    },
                    children: error
                }) : rows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "template-formulary-empty",
                    style: {
                        padding: '8px 10px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).textMuted
                    },
                    children: t('settings.templates.formularyEmpty')
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        rows.map((drug)=>{
                            const inDraft = excludeIds?.has(drug.id);
                            const names = (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(drug);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-testid": "template-formulary-result",
                                "data-drug-id": drug.id,
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    padding: '6px 8px',
                                    borderRadius: 8,
                                    opacity: inDraft ? 0.6 : 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                dir: "auto",
                                                style: {
                                                    fontSize: 12.5,
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).textPrimary
                                                },
                                                children: names.primary
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    fontSize: 10.5,
                                                    color: (0, $jTCZr.C).textMuted,
                                                    display: 'flex',
                                                    gap: 6
                                                },
                                                children: [
                                                    names.secondary && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        dir: "auto",
                                                        children: names.secondary
                                                    }),
                                                    drug.category && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 ",
                                                            (0, $f78c92fb84c2d04c$export$6ff5af8a69b07db4)(drug.category, t)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    inDraft ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 11,
                                            color: (0, $jTCZr.C).textSecondary,
                                            flexShrink: 0
                                        },
                                        children: t('settings.templates.alreadyInTemplate')
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>onPick(drug),
                                        disabled: disabled,
                                        "data-testid": "template-formulary-add",
                                        style: {
                                            height: 30,
                                            padding: '0 10px',
                                            borderRadius: 6,
                                            flexShrink: 0,
                                            border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.2)}`,
                                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05),
                                            color: (0, $jTCZr.C).navy,
                                            fontFamily: 'inherit',
                                            fontSize: 11.5,
                                            fontWeight: 700,
                                            cursor: disabled ? 'not-allowed' : 'pointer'
                                        },
                                        children: [
                                            "+ ",
                                            t('common.actions.add')
                                        ]
                                    })
                                ]
                            }, drug.id);
                        }),
                        total > rows.length && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                padding: '4px 10px 6px',
                                fontSize: 11,
                                color: (0, $jTCZr.C).textMuted
                            },
                            children: t('settings.templates.formularyMore', {
                                shown: rows.length,
                                total: total
                            })
                        })
                    ]
                })
            })
        ]
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// «عنوان دستور» as a searchable catalogue picker, inside the قالب دستورات editor.
//
// The visit's «افزودن» tab picks orders from the clinic's service catalogue and
// keeps the catalogue id on the row. A template written by typing names carried
// none of that: no id, no کد, and no way for anything downstream to tell that
// «سونوگرافی داپلر» and «سونو داپلر» are one service. This gives the template
// editor the same door the visit has — type a few letters, pick a row, and the
// item arrives with its catalogue id and its code already filled in.
//
// It is a COMBOBOX, not a closed list: the input stays free text. A clinic
// orders things the national catalogue has never heard of, and refusing to save
// what a doctor typed would be worse than saving it without a code.
//
// Deliberately small, like TemplateFormularySearch beside it: one box, one short
// list. The visit's full picker (type rail, in-house floating, batch add) is
// built for ordering in a hurry; a template is written once, calmly.
// ─────────────────────────────────────────────────────────────────────────────

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



function $1d704ecd256e0d01$export$c36e1fdb8ec64d52({ query: query, orderType: orderType, enabled: enabled = true }) {
    const { t: t } = (0, $LNQP4.default)();
    const [state, setState] = (0, $acw62.useState)({
        items: [],
        total: 0,
        loading: false,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        const q = (query || '').trim();
        if (!q) {
            setState({
                items: [],
                total: 0,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setState((prev)=>({
                ...prev,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $375f8776645d5aee$export$14e053085c2b7017)({
                query: q,
                orderType: orderType || ''
            }).then((page)=>{
                if (!live) return;
                setState({
                    items: (page.entries || []).map((e)=>({
                            catalogId: e.id,
                            orderType: e.orderType,
                            name: e.name,
                            nameEn: e.nameEn || '',
                            code: e.code || '',
                            codeSystem: e.codeSystem || '',
                            sub: e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : [
                                e.modality,
                                e.bodyPart
                            ].filter(Boolean).join(" \xb7 "),
                            category: e.category || ''
                        })),
                    total: page.total || 0,
                    loading: false,
                    error: null
                });
            }).catch((err)=>{
                if (!live) return;
                // Said out loud, never swallowed: the field stays free text, so the
                // doctor can type the name — but «no results» and «the search failed»
                // must not look the same.
                setState({
                    items: [],
                    total: 0,
                    loading: false,
                    error: t('settings.templates.loadFailed')
                });
            });
        }, 250);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        query,
        orderType,
        enabled,
        t
    ]);
    return state;
}
const $1d704ecd256e0d01$var$norm = (s)=>String(s || '').toLowerCase().trim();
function $1d704ecd256e0d01$export$2e2bcd8739ae039({ value: value, onChange: onChange, onPick: onPick, orderType: orderType, error: error, label: label, required: required = true, catalogId: catalogId = null, bare: bare = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [active, setActive] = (0, $acw62.useState)(0);
    const boxRef = (0, $acw62.useRef)(null);
    // `error` is already the field's validation message; the search's failure is
    // a different thing and must not overwrite it.
    const { items: items, loading: loading, error: searchError } = $1d704ecd256e0d01$export$c36e1fdb8ec64d52({
        // Deliberately NOT filtered by the row's type. A doctor editing a line
        // labelled «آزمایش» who types «آسپیراسیون» should still find the procedure —
        // picking it corrects the type. Filtering server-side would hide it, and the
        // doctor would have no way to know the service exists.
        query: value,
        orderType: '',
        enabled: open
    });
    // The server ranks in-house first and already filtered by query and type; the
    // row's OWN type floats to the front of what came back, because a doctor
    // editing a lab line is most likely still choosing a lab.
    const matches = (0, $acw62.useMemo)(()=>items.map((it, i)=>[
                it,
                i
            ]).sort((a, b)=>(b[0].orderType === orderType) - (a[0].orderType === orderType) || a[1] - b[1]).map(([it])=>it), [
        items,
        orderType
    ]);
    // A click anywhere else closes the list. Pointerdown, not click: the input's
    // blur must not race the option's own mousedown handler.
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const away = (e)=>{
            if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('pointerdown', away);
        return ()=>document.removeEventListener('pointerdown', away);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        setActive(0);
    }, [
        value
    ]);
    const choose = (item)=>{
        onPick(item);
        setOpen(false);
    };
    const onKeyDown = (e)=>{
        if (!open || matches.length === 0) {
            if (e.key === 'ArrowDown' && matches.length) setOpen(true);
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActive((i)=>(i + 1) % matches.length);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActive((i)=>(i - 1 + matches.length) % matches.length);
        } else if (e.key === 'Enter') {
            // Only when the list is genuinely being navigated — Enter on a typed name
            // the doctor never opened the list for must not silently swap in a service.
            e.preventDefault();
            choose(matches[active]);
        } else if (e.key === 'Escape') setOpen(false);
    };
    const showList = open && $1d704ecd256e0d01$var$norm(value).length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: boxRef,
        style: {
            position: 'relative'
        },
        "data-testid": "template-order-picker",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: bare ? undefined : label || t('settings.templates.order_.name'),
                "aria-label": bare ? t('settings.templates.order_.name') : undefined,
                placeholder: bare ? t('settings.templates.orderSearchPlaceholder') : undefined,
                required: bare ? false : required,
                value: value,
                onChange: (e)=>{
                    onChange(e);
                    setOpen(true);
                },
                onFocus: ()=>setOpen(true),
                onKeyDown: onKeyDown,
                error: error,
                helperText: bare || searchError ? undefined : catalogId ? t('settings.templates.orderCatalogLinked') : t('settings.templates.orderCatalogHint'),
                autoComplete: "off",
                role: "combobox",
                "aria-expanded": showList,
                "aria-autocomplete": "list",
                "data-testid": "template-item-name"
            }),
            showList && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "listbox",
                "data-testid": "template-order-options",
                style: {
                    position: 'absolute',
                    zIndex: 40,
                    insetInlineStart: 0,
                    insetInlineEnd: 0,
                    top: '100%',
                    marginTop: 2,
                    maxHeight: 260,
                    overflowY: 'auto',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                    background: (0, $jTCZr.C).card,
                    boxShadow: '0 10px 24px rgba(0,0,0,0.10)',
                    padding: 4
                },
                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '8px 10px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).textMuted
                    },
                    children: t('common.state.loading')
                }) : searchError ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "alert",
                    "data-testid": "template-order-error",
                    style: {
                        padding: '8px 10px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).red
                    },
                    children: t('settings.templates.orderCatalogFailed')
                }) : matches.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "template-order-empty",
                    style: {
                        padding: '8px 10px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).textMuted
                    },
                    children: t('settings.templates.orderCatalogEmpty')
                }) : matches.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "option",
                        "aria-selected": i === active,
                        "data-testid": "template-order-option",
                        "data-catalog-id": item.catalogId || '',
                        onMouseEnter: ()=>setActive(i),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                            choose(item);
                        },
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '6px 8px',
                            borderRadius: 8,
                            cursor: 'pointer',
                            background: i === active ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07) : 'transparent'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        dir: "auto",
                                        style: {
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            fontSize: 10.5,
                                            color: (0, $jTCZr.C).textMuted,
                                            display: 'flex',
                                            gap: 6,
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            item.sub && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                dir: "auto",
                                                children: item.sub
                                            }),
                                            item.category && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 ",
                                                    item.category
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            item.orderType !== orderType && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 10,
                                    color: (0, $jTCZr.C).textSecondary,
                                    flexShrink: 0
                                },
                                children: t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[item.orderType] || item.orderType)
                            })
                        ]
                    }, `${item.orderType}:${item.catalogId || item.name}`))
            })
        ]
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// «افزودن از فهرست خدمات» — the catalogue-first composer for a قالب دستورات.
//
// WHAT A TEMPLATE IS, AND WHY THIS IS NOT A FORM
//
// A قالب دستورات is a برگه درخواست written in advance: an ORDERED LIST of
// services, each of which has to be identifiable by something other than the
// words a doctor typed. The old editor asked for six inputs per line — type,
// name, urgency, code, sessions, note — all at equal weight, all always open.
// Four of those six are almost always left at their default, and the one that
// mattered most (`code`) was a free-text box, which is the only way a wrong
// code ever gets into this system by hand.
//
// So the section is built the other way round: SEARCH the catalogue, pick, and
// the line arrives already identified. Typing a name by hand is still possible —
// a clinic offers services no national list has heard of — but it is a separate,
// deliberate button rather than the default path.
//
// THE CODE CHIP IS THE POINT
//
// Checking Parsina's catalogue against مکسا found four codes that EXIST but name
// a different test — 35765-7 reads «Vitamin D» here and «Cefetamet
// susceptibility» in the registry. A bare number cannot be checked by eye. So a
// code is never shown bare: it is always «REGISTRY number», in tabular Latin
// figures, and a line with no identity says «بدون کد» instead of showing an
// empty field. What a line can be transmitted as is visible at a glance.
// ─────────────────────────────────────────────────────────────────────────────

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $amyVq = parcelRequire("amyVq");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



const $bd87473eebbc02d2$var$MAX_RESULTS = 24;
const $bd87473eebbc02d2$var$TYPE_FILTERS = [
    'all',
    'lab',
    'imaging',
    'procedure'
];
const $bd87473eebbc02d2$export$d6b01a85d9e553f5 = (item)=>item?.codeSystem || (item?.orderType === 'lab' ? 'LOINC' : item?.orderType === 'procedure' ? 'CPT' : '');
function $bd87473eebbc02d2$export$7c1ed62ff347e8e0({ item: item, size: size = 'md' }) {
    const { t: t } = (0, $LNQP4.default)();
    const system = $bd87473eebbc02d2$export$d6b01a85d9e553f5(item);
    const linked = !!item?.catalogId;
    const pad = size === 'sm' ? '1px 6px' : '2px 8px';
    const fs = size === 'sm' ? 10 : 10.5;
    if (item?.code) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        "data-testid": "order-code-chip",
        style: {
            ...(0, $c48eb69ce5e269ee$export$373e92e0788ff06e),
            display: 'inline-flex',
            alignItems: 'baseline',
            gap: 4,
            padding: pad,
            borderRadius: 6,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
            color: (0, $jTCZr.C).teal,
            fontSize: fs,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums',
            letterSpacing: '0.02em'
        },
        children: [
            system && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    opacity: 0.75,
                    fontWeight: 800,
                    fontSize: fs - 1
                },
                children: system
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: item.code
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "data-testid": "order-code-chip",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: pad,
            borderRadius: 6,
            border: linked ? 'none' : `1px dashed ${(0, $jTCZr.C).border}`,
            background: linked ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : 'transparent',
            color: (0, $jTCZr.C).textMuted,
            fontSize: fs,
            fontWeight: 600,
            whiteSpace: 'nowrap'
        },
        children: t(linked ? 'settings.templates.orderNoCode' : 'settings.templates.orderManual')
    });
}
function $bd87473eebbc02d2$export$a59a0849342df87a({ orderType: orderType, fromCatalogue: fromCatalogue = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const label = t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[orderType] || (0, $bf42e0131d395ab7$export$a7724bba2d8d6794).other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        title: fromCatalogue ? `${label} \u{2014} ${t('settings.templates.orderTypeFromCatalogue')}` : label,
        style: {
            flexShrink: 0,
            minWidth: 44,
            padding: '2px 7px',
            borderRadius: 6,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07),
            color: (0, $jTCZr.C).navy,
            fontSize: 10,
            fontWeight: 700,
            textAlign: 'center',
            whiteSpace: 'nowrap'
        },
        children: label
    });
}
const $bd87473eebbc02d2$var$norm = (s)=>String(s || '').toLowerCase().trim();
function $bd87473eebbc02d2$export$2e2bcd8739ae039({ onPick: onPick, onManual: onManual, excludeIds: excludeIds, disabled: disabled = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [type, setType] = (0, $acw62.useState)('all');
    const inputRef = (0, $acw62.useRef)(null);
    // The server searches; this only decides what to show. The type chips are a
    // QUERY PARAMETER now, not a client filter over a resident list.
    const { items: items, total: total, loading: loading, error: error } = (0, $1d704ecd256e0d01$export$c36e1fdb8ec64d52)({
        query: query,
        orderType: type === 'all' ? '' : type,
        enabled: !disabled
    });
    const results = (0, $acw62.useMemo)(()=>items.slice(0, $bd87473eebbc02d2$var$MAX_RESULTS), [
        items
    ]);
    const searching = $bd87473eebbc02d2$var$norm(query).length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "template-order-composer",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: '1 1 260px',
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                            ref: inputRef,
                            value: query,
                            onChange: (e)=>setQuery(e?.target ? e.target.value : e),
                            placeholder: t('settings.templates.orderSearchPlaceholder'),
                            disabled: disabled,
                            inputProps: {
                                'data-testid': 'template-order-search'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "subtle",
                        size: "sm",
                        onClick: onManual,
                        disabled: disabled,
                        "data-testid": "template-add-item",
                        children: [
                            "+ ",
                            t('settings.templates.addManual')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "group",
                "aria-label": t('settings.templates.order_.type'),
                style: {
                    display: 'flex',
                    gap: 6,
                    flexWrap: 'wrap'
                },
                children: $bd87473eebbc02d2$var$TYPE_FILTERS.map((key)=>{
                    const on = type === key;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>setType(key),
                        "data-testid": `template-order-filter-${key}`,
                        "aria-pressed": on,
                        style: {
                            height: 26,
                            padding: '0 10px',
                            borderRadius: 999,
                            cursor: 'pointer',
                            border: `1px solid ${on ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35) : (0, $jTCZr.C).border}`,
                            background: on ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                            color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                            fontFamily: 'inherit',
                            fontSize: 11.5,
                            fontWeight: on ? 800 : 600
                        },
                        children: key === 'all' ? t('common.state.all') : t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[key])
                    }, key);
                })
            }),
            searching && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "template-order-results",
                style: {
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                    background: (0, $jTCZr.C).card,
                    padding: 4,
                    maxHeight: 250,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                },
                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '10px 12px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).textMuted
                    },
                    children: t('common.state.loading')
                }) : error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "alert",
                    "data-testid": "template-order-error",
                    style: {
                        padding: '10px 12px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).red
                    },
                    children: t('settings.templates.orderCatalogFailed')
                }) : results.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "template-order-empty",
                    style: {
                        padding: '10px 12px',
                        fontSize: 12,
                        color: (0, $jTCZr.C).textMuted,
                        lineHeight: 1.9
                    },
                    children: t('settings.templates.orderCatalogEmpty')
                }) : results.map((item)=>{
                    const already = excludeIds?.has(item.catalogId);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onPick(item),
                        disabled: disabled || already,
                        "data-testid": "template-order-result",
                        "data-catalog-id": item.catalogId || '',
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            width: '100%',
                            padding: '7px 8px',
                            borderRadius: 8,
                            border: 'none',
                            textAlign: 'start',
                            background: 'transparent',
                            fontFamily: 'inherit',
                            cursor: disabled || already ? 'default' : 'pointer',
                            opacity: already ? 0.55 : 1
                        },
                        onMouseEnter: (e)=>{
                            if (!already && !disabled) e.currentTarget.style.background = (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05);
                        },
                        onMouseLeave: (e)=>{
                            e.currentTarget.style.background = 'transparent';
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bd87473eebbc02d2$export$a59a0849342df87a, {
                                orderType: item.orderType
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        dir: "auto",
                                        style: {
                                            display: 'block',
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: item.name
                                    }),
                                    item.category && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            display: 'block',
                                            fontSize: 10.5,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: item.category
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bd87473eebbc02d2$export$7c1ed62ff347e8e0, {
                                item: item,
                                size: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 11.5,
                                    fontWeight: 800,
                                    color: already ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).navy,
                                    flexShrink: 0
                                },
                                children: already ? t('settings.templates.alreadyInTemplate') : '+'
                            })
                        ]
                    }, `${item.orderType}:${item.catalogId}`);
                })
            })
        ]
    });
}


const $9ea74aa9cf27c9eb$var$URGENCY_KEYS = {
    routine: 'common.urgency.routine',
    urgent: 'common.urgency.urgent',
    stat: 'common.urgency.stat'
};
// The kit's inputs hand back the DOM event, and useSettingsForm unwraps it the
// same way. Kept as one helper so an item field cannot be wired up with the
// event object as its value.
const $9ea74aa9cf27c9eb$var$valueOf = (e)=>e?.target ? e.target.value : e;
// ── The explanation card ─────────────────────────────────────────────────────
const $9ea74aa9cf27c9eb$var$IntroCard = ()=>{
    const { t: t } = (0, $LNQP4.default)();
    const line = (text, key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            style: {
                fontSize: 12.5,
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.9
            },
            children: text
        }, key);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-templates-intro",
        style: {
            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05),
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.16)}`,
            borderRadius: (0, $c48eb69ce5e269ee$export$cf052b29a1666d6a),
            padding: '16px 20px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    marginBottom: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: (0, $jTCZr.C).navy,
                            display: 'flex'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).sparkles, {
                            s: 17
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            margin: 0,
                            fontSize: 13.5,
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('settings.templates.intro.title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0 0 8px',
                    fontSize: 12.5,
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.9
                },
                children: t('settings.templates.intro.body')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                style: {
                    margin: 0,
                    paddingInlineStart: 18,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                },
                children: [
                    line(t('settings.templates.intro.medication'), 'med'),
                    line(t('settings.templates.intro.order'), 'ord'),
                    line(t('settings.templates.intro.copy'), 'copy')
                ]
            })
        ]
    });
};
// ── One row of the template list ─────────────────────────────────────────────
const $9ea74aa9cf27c9eb$var$TemplateRow = ({ kind: kind, template: template, onEdit: onEdit, onDuplicate: onDuplicate, onDelete: onDelete, busy: busy })=>{
    const { t: t } = (0, $LNQP4.default)();
    const count = (0, $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2)(template);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": `template-row-${kind}`,
        "data-template-id": template.id,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '11px 12px',
            borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: 0,
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13.5,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: template.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2
                        },
                        children: [
                            count ? t('settings.templates.itemCount', {
                                count: count
                            }) : t('settings.templates.noItems'),
                            template.description ? ` \xb7 ${template.description}` : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "subtle",
                size: "sm",
                disabled: busy,
                onClick: ()=>onEdit(template),
                "data-testid": `template-edit-${kind}`,
                children: t('common.actions.edit')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                disabled: busy,
                onClick: ()=>onDuplicate(template),
                "data-testid": `template-duplicate-${kind}`,
                children: t('settings.templates.duplicate')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                disabled: busy,
                onClick: ()=>onDelete(template),
                "data-testid": `template-delete-${kind}`,
                "aria-label": t('common.actions.delete'),
                style: {
                    color: (0, $jTCZr.C).danger
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).trash, {
                    s: 15
                })
            })
        ]
    });
};
// ── Item editors ─────────────────────────────────────────────────────────────
//
// One row per item, with the ordering controls beside it: the order of a
// template IS the order of the نسخه lines and of the request form, so moving an
// item is an ordinary edit, not an advanced feature hidden behind a drag.
const $9ea74aa9cf27c9eb$var$ItemFrame = ({ index: index, total: total, onMove: onMove, onRemove: onRemove, children: children, testId: testId })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
            padding: '10px 12px',
            background: (0, $jTCZr.C).bg,
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    flexShrink: 0,
                    marginTop: 6,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                    color: (0, $jTCZr.C).navy,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 11,
                    fontWeight: 800
                },
                children: formatNumber(index + 1)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        disabled: index === 0,
                        onClick: ()=>onMove(index, index - 1),
                        "aria-label": t('settings.templates.moveUp'),
                        "data-testid": "template-item-up",
                        children: "\u2191"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        disabled: index === total - 1,
                        onClick: ()=>onMove(index, index + 1),
                        "aria-label": t('settings.templates.moveDown'),
                        "data-testid": "template-item-down",
                        children: "\u2193"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        onClick: ()=>onRemove(index),
                        "aria-label": t('settings.templates.removeItem'),
                        "data-testid": "template-item-remove",
                        style: {
                            color: (0, $jTCZr.C).danger
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).trash, {
                            s: 14
                        })
                    })
                ]
            })
        ]
    });
};
// A dosing field is a free-text input WITH suggestions, never a closed list —
// the same rule the visit's نسخه row follows (a paediatric mg/kg dose is not in
// `commonDosages`). The suggestions come from the picked formulary row where it
// has them, and from the visit's own route / duration / instruction lists
// otherwise, so a template can only ever say what the visit tab would offer.
const $9ea74aa9cf27c9eb$var$SuggestInput = ({ id: id, label: label, value: value, options: options, onChange: onChange, labelFor: labelFor, testId: testId })=>{
    const listId = options?.length ? `${id}-list` : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: label,
                value: value,
                onChange: onChange,
                list: listId,
                "data-testid": testId
            }),
            listId && /*#__PURE__*/ (0, $ayMG0.jsx)("datalist", {
                id: listId,
                children: options.map((o)=>{
                    const shown = labelFor ? labelFor(o) : o;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                        value: o,
                        ...shown !== o ? {
                            label: shown
                        } : {}
                    }, o);
                })
            })
        ]
    });
};
const $9ea74aa9cf27c9eb$var$MedicationItemFields = ({ item: item, errors: errors, onChange: onChange, index: index = 0 })=>{
    const { t: t } = (0, $LNQP4.default)();
    const field = (key)=>(e)=>onChange(key, $9ea74aa9cf27c9eb$var$valueOf(e));
    const id = `tpl-med-${index}`;
    const fromFormulary = Boolean(item.drugId);
    const names = (0, $bb8a11e7c1131df5$export$590163154e34e5bd)(item);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            fromFormulary ? // A formulary drug keeps its name: editing it would silently break the
            // `drugId` join. A wrong pick is removed and picked again.
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "template-item-locked-name",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "auto",
                        style: {
                            fontSize: 13.5,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: names.primary
                    }),
                    names.secondary && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "auto",
                        style: {
                            fontSize: 11,
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: names.secondary
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 10.5,
                            fontWeight: 700,
                            padding: '1px 7px',
                            borderRadius: 20,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.14),
                            color: (0, $jTCZr.C).teal
                        },
                        children: t('settings.templates.formularyTag')
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$f9754e493f02dbbd), {
                max: 2,
                gap: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('settings.templates.drug.name'),
                        required: true,
                        value: item.name,
                        onChange: field('name'),
                        error: errors?.name && t(errors.name),
                        "data-testid": "template-item-name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('settings.templates.drug.generic'),
                        value: item.genericName,
                        onChange: field('genericName')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$f9754e493f02dbbd), {
                max: 2,
                gap: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$SuggestInput, {
                        id: `${id}-dosage`,
                        label: t('settings.templates.drug.dosage'),
                        value: item.dosage,
                        options: item.commonDosages || [],
                        onChange: field('dosage'),
                        testId: "template-item-dosage"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$SuggestInput, {
                        id: `${id}-frequency`,
                        label: t('settings.templates.drug.frequency'),
                        value: item.frequency,
                        options: item.commonFrequencies || [],
                        labelFor: (v)=>(0, $f78c92fb84c2d04c$export$d93ed016efabc5b)(v, t),
                        onChange: field('frequency'),
                        testId: "template-item-frequency"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$SuggestInput, {
                        id: `${id}-route`,
                        label: t('settings.templates.drug.route'),
                        value: item.route,
                        options: (0, $375f8776645d5aee$export$e730a0734bbb1219)(t),
                        onChange: field('route'),
                        testId: "template-item-route"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$SuggestInput, {
                        id: `${id}-duration`,
                        label: t('settings.templates.drug.duration'),
                        value: item.duration,
                        options: (0, $375f8776645d5aee$export$74f6a832d246e098)(t),
                        onChange: field('duration'),
                        testId: "template-item-duration"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('settings.templates.drug.quantity'),
                        value: item.quantity,
                        onChange: field('quantity'),
                        "data-testid": "template-item-quantity"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 10
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$SuggestInput, {
                    id: `${id}-instructions`,
                    label: t('settings.templates.drug.instructions'),
                    value: item.instructions,
                    options: (0, $375f8776645d5aee$export$7be9a8bfe9895054)(t),
                    onChange: field('instructions'),
                    testId: "template-item-instructions"
                })
            })
        ]
    });
};
/**
 * One line of the برگه درخواست.
 *
 * Reads as a list entry, not a form: type, name, identity — and everything a
 * doctor leaves at its default (urgency routine, 0 sessions, no note) stays
 * folded away behind «جزئیات». The four fields that were always open were
 * almost always untouched, and they buried the one thing worth reading.
 */ const $9ea74aa9cf27c9eb$var$OrderItemFields = ({ item: item, errors: errors, onChange: onChange, onPatch: onPatch })=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const field = (key)=>(e)=>onChange(key, $9ea74aa9cf27c9eb$var$valueOf(e));
    const linked = !!item.catalogId;
    const urgencyOptions = (0, $acw62.useMemo)(()=>(0, $5e2e0b7ea22d1ff2$export$c9b31a4acc93d37d).map((value)=>({
                value: value,
                label: t($9ea74aa9cf27c9eb$var$URGENCY_KEYS[value])
            })), [
        t
    ]);
    const typeOptions = (0, $acw62.useMemo)(()=>(0, $5e2e0b7ea22d1ff2$export$7fe249ad93dcc233).map((value)=>({
                value: value,
                label: t((0, $bf42e0131d395ab7$export$a7724bba2d8d6794)[value])
            })), [
        t
    ]);
    // Extras a doctor HAS set are summarised on the closed line: folding a value
    // away is only honest if its presence is still visible.
    const extras = [
        item.urgency && item.urgency !== 'routine' ? t($9ea74aa9cf27c9eb$var$URGENCY_KEYS[item.urgency]) : null,
        item.sessionCount > 0 ? t('settings.templates.orderSessionsShort', {
            count: formatNumber(item.sessionCount)
        }) : null,
        item.notes ? t('settings.templates.order_.notes') : null
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap'
                },
                children: [
                    linked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd87473eebbc02d2$export$a59a0849342df87a), {
                        orderType: item.orderType,
                        fromCatalogue: true
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: 118,
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                            value: item.orderType,
                            onChange: field('orderType'),
                            options: typeOptions,
                            "aria-label": t('settings.templates.order_.type'),
                            "data-testid": "template-item-order-type"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: '1 1 200px',
                            minWidth: 0
                        },
                        children: linked ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            dir: "auto",
                            "data-testid": "template-item-name",
                            style: {
                                fontSize: 13,
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            children: item.name
                        }) : // A hand-written line has nothing but its name, so the name stays
                        // editable in place — and the same box searches the catalogue, which
                        // is how a typed line becomes an identified one.
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d704ecd256e0d01$export$2e2bcd8739ae039), {
                            value: item.name,
                            onChange: field('name'),
                            onPick: (choice)=>onPatch({
                                    name: choice.name,
                                    code: choice.code || '',
                                    orderType: choice.orderType || 'lab',
                                    catalogId: choice.catalogId || null
                                }),
                            orderType: item.orderType,
                            catalogId: item.catalogId,
                            error: errors?.name && t(errors.name),
                            bare: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd87473eebbc02d2$export$7c1ed62ff347e8e0), {
                        item: item
                    }),
                    extras.map((label)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 10.5,
                                color: (0, $jTCZr.C).textSecondary,
                                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05),
                                padding: '2px 7px',
                                borderRadius: 6,
                                whiteSpace: 'nowrap'
                            },
                            children: label
                        }, label)),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setOpen((v)=>!v),
                        "aria-expanded": open,
                        "data-testid": "template-item-details",
                        style: {
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            flexShrink: 0,
                            color: (0, $jTCZr.C).textSecondary,
                            fontFamily: 'inherit',
                            fontSize: 11.5,
                            fontWeight: 700,
                            padding: '2px 4px'
                        },
                        children: [
                            t(open ? 'common.actions.close' : 'settings.templates.orderDetails'),
                            " ",
                            open ? "\u25B4" : "\u25BE"
                        ]
                    })
                ]
            }),
            linked && errors?.name && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    color: (0, $jTCZr.C).red
                },
                children: t(errors.name)
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "template-item-details-panel",
                style: {
                    borderTop: `1px dashed ${(0, $jTCZr.C).border}`,
                    paddingTop: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$f9754e493f02dbbd), {
                        min: 170,
                        max: 2,
                        gap: 10,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                label: t('settings.templates.order_.urgency'),
                                value: item.urgency,
                                onChange: field('urgency'),
                                options: urgencyOptions,
                                placeholder: t('common.actions.select'),
                                "data-testid": "template-item-urgency"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iIGe.default), {
                                label: t('settings.templates.order_.sessions'),
                                value: item.sessionCount,
                                onChange: (e)=>onChange('sessionCount', Number($9ea74aa9cf27c9eb$var$valueOf(e)) || 0),
                                min: 0,
                                max: 100,
                                error: errors?.sessionCount && t(errors.sessionCount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('settings.templates.order_.notes'),
                        value: item.notes,
                        onChange: field('notes')
                    }),
                    linked ? // Unlinking is the only way to correct a wrong pick, and it is
                    // explicit: the code goes with the service it belonged to, rather
                    // than staying behind to describe a different one.
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: t('settings.templates.orderCatalogLinked')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>onPatch({
                                        catalogId: null,
                                        code: ''
                                    }),
                                "data-testid": "template-item-unlink",
                                children: t('settings.templates.orderChangeService')
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('settings.templates.order_.code'),
                        helperText: t('settings.templates.orderManualCodeHint'),
                        value: item.code,
                        onChange: field('code'),
                        "data-testid": "template-item-code"
                    })
                ]
            })
        ]
    });
};
// ── The editor ───────────────────────────────────────────────────────────────
const $9ea74aa9cf27c9eb$export$72b66677513e0cef = ({ kind: kind, open: open, template: template, onClose: onClose, onSave: onSave })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, $acw62.useState)(()=>(0, $5e2e0b7ea22d1ff2$export$6db8446c3a030733)(kind, template));
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [saveError, setSaveError] = (0, $acw62.useState)(null);
    // Errors are computed on every render but only SHOWN once the doctor has
    // tried to save: an empty title is not a mistake while the form is still
    // being filled in.
    const [submitted, setSubmitted] = (0, $acw62.useState)(false);
    // A fresh open is a fresh draft. Keyed remount would do it too, but this keeps
    // the reset next to the state it resets.
    const [openedFor, setOpenedFor] = (0, $acw62.useState)(template?.id ?? null);
    if (open && openedFor !== (template?.id ?? null)) {
        setOpenedFor(template?.id ?? null);
        setDraft((0, $5e2e0b7ea22d1ff2$export$6db8446c3a030733)(kind, template));
        setSubmitted(false);
        setSaveError(null);
    }
    const errors = (0, $acw62.useMemo)(()=>(0, $5e2e0b7ea22d1ff2$export$2a244ffb744b0c05)(kind, draft), [
        kind,
        draft
    ]);
    const invalid = (0, $5e2e0b7ea22d1ff2$export$b26b94f22deb9fbf)(errors);
    const setField = (key)=>(e)=>setDraft((d)=>({
                    ...d,
                    [key]: $9ea74aa9cf27c9eb$var$valueOf(e)
                }));
    const setItemField = (index)=>(key, value)=>setDraft((d)=>({
                    ...d,
                    items: d.items.map((item, i)=>i === index ? {
                            ...item,
                            [key]: value
                        } : item)
                }));
    // Several fields change together on a catalogue pick, and they must land in ONE
    // setState: three sequential single-field updates would each start from the
    // draft as it was when the handler was created, and only the last would stick.
    const patchItem = (index)=>(patch)=>setDraft((d)=>({
                    ...d,
                    items: d.items.map((item, i)=>i === index ? {
                            ...item,
                            ...patch
                        } : item)
                }));
    // A pick fills the name, the code and the catalogue id — and corrects the type
    // if the doctor searched across it. `code` is CLEARED rather than kept when the
    // chosen service has none (imaging): a code left behind from a previous pick
    // would claim this service is something it is not.
    // A catalogue pick appends a complete line — name, code, type and id — and
    // never the same service twice, exactly as the formulary pick does.
    const addCatalogOrder = (choice)=>setDraft((d)=>{
            if (d.items.length >= (0, $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a)) return d;
            if (choice.catalogId && d.items.some((it)=>it.catalogId === choice.catalogId)) return d;
            return {
                ...d,
                items: [
                    ...d.items,
                    {
                        ...(0, $5e2e0b7ea22d1ff2$export$f533e11413e84a55)('order'),
                        name: choice.name,
                        code: choice.code || '',
                        orderType: choice.orderType || 'lab',
                        catalogId: choice.catalogId || null
                    }
                ]
            };
        });
    const catalogIds = (0, $acw62.useMemo)(()=>new Set(draft.items.map((it)=>it.catalogId).filter(Boolean)), [
        draft.items
    ]);
    const addItem = ()=>setDraft((d)=>({
                ...d,
                items: [
                    ...d.items,
                    (0, $5e2e0b7ea22d1ff2$export$f533e11413e84a55)(kind)
                ]
            }));
    // A formulary pick appends a complete item — id, names, usual dose and
    // frequency — and never the same drug twice, as the visit's picker does.
    const addDrug = (drug)=>setDraft((d)=>{
            if (d.items.length >= (0, $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a)) return d;
            if (d.items.some((item)=>item.drugId && item.drugId === drug.id)) return d;
            return {
                ...d,
                items: [
                    ...d.items,
                    (0, $5e2e0b7ea22d1ff2$export$9b75ebcf168938fe)(drug)
                ]
            };
        });
    const drugIds = (0, $acw62.useMemo)(()=>(0, $5e2e0b7ea22d1ff2$export$5f07940018c62174)(draft), [
        draft
    ]);
    const removeItem = (index)=>setDraft((d)=>({
                ...d,
                items: d.items.filter((_, i)=>i !== index)
            }));
    const moveItem = (from, to)=>setDraft((d)=>({
                ...d,
                items: (0, $5e2e0b7ea22d1ff2$export$5d7b2ba43c325442)(d.items, from, to)
            }));
    const save = async ()=>{
        setSubmitted(true);
        if (invalid) return;
        setSaving(true);
        setSaveError(null);
        try {
            await onSave(draft);
            onClose();
        } catch (err) {
            // Shown beside the form, not as a toast that outlives the modal: the
            // doctor still has the unsaved template in front of them and can retry.
            setSaveError(t('settings.templates.saveFailed'));
        } finally{
            setSaving(false);
        }
    };
    const ItemFields = kind === 'order' ? $9ea74aa9cf27c9eb$var$OrderItemFields : $9ea74aa9cf27c9eb$var$MedicationItemFields;
    const atLimit = draft.items.length >= (0, $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onClose();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            className: "max-w-3xl",
            "data-testid": `template-editor-${kind}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                        children: template ? t('common.actions.edit') : t(`settings.templates.${kind}.new`)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: t('settings.templates.titleLabel'),
                            required: true,
                            placeholder: t('settings.templates.titlePlaceholder'),
                            value: draft.title,
                            onChange: setField('title'),
                            error: submitted && errors.title ? t(errors.title) : undefined,
                            "data-testid": "template-title"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                            label: t('settings.templates.descriptionLabel'),
                            placeholder: t('settings.templates.descriptionPlaceholder'),
                            value: draft.description,
                            onChange: setField('description'),
                            rows: 2,
                            error: submitted && errors.description ? t(errors.description) : undefined
                        }),
                        kind === 'medication' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d370b169b41724a$export$2e2bcd8739ae039), {
                            excludeIds: drugIds,
                            onPick: addDrug,
                            disabled: atLimit
                        }),
                        kind === 'order' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd87473eebbc02d2$export$2e2bcd8739ae039), {
                            excludeIds: catalogIds,
                            onPick: addCatalogOrder,
                            onManual: addItem,
                            disabled: atLimit
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        marginBottom: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: 12.5,
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: t('settings.templates.items')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: 1
                                            }
                                        }),
                                        kind === 'medication' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            variant: "subtle",
                                            size: "sm",
                                            onClick: addItem,
                                            disabled: atLimit,
                                            "data-testid": "template-add-item",
                                            children: [
                                                "+ ",
                                                t('settings.templates.addManual')
                                            ]
                                        })
                                    ]
                                }),
                                draft.items.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "data-testid": "template-items-empty",
                                    style: {
                                        border: `1px dashed ${(0, $jTCZr.C).border}`,
                                        borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                                        padding: '14px 16px',
                                        fontSize: 12,
                                        color: (0, $jTCZr.C).textMuted,
                                        lineHeight: 1.8
                                    },
                                    children: t('settings.templates.emptyItems')
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8
                                    },
                                    children: draft.items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$ItemFrame, {
                                            index: index,
                                            total: draft.items.length,
                                            onMove: moveItem,
                                            onRemove: removeItem,
                                            testId: "template-item",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ItemFields, {
                                                item: item,
                                                index: index,
                                                errors: submitted ? errors.items[index] : undefined,
                                                onChange: setItemField(index),
                                                onPatch: patchItem(index)
                                            })
                                        }, index))
                                }),
                                submitted && errors.itemCount && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        marginTop: 8,
                                        fontSize: 12,
                                        color: (0, $jTCZr.C).danger
                                    },
                                    children: t(errors.itemCount)
                                })
                            ]
                        }),
                        saveError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            role: "alert",
                            "data-testid": "template-save-error",
                            style: {
                                background: (0, $jTCZr.soft)((0, $jTCZr.C).danger, 0.1),
                                border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).danger, 0.3)}`,
                                borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                                padding: '9px 12px',
                                fontSize: 12,
                                color: (0, $jTCZr.C).danger
                            },
                            children: saveError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogFooter), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: onClose,
                            disabled: saving,
                            children: t('common.actions.cancel')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            onClick: save,
                            disabled: saving,
                            "data-testid": "template-save",
                            children: saving ? t('common.state.saving') : t('common.actions.save')
                        })
                    ]
                })
            ]
        })
    });
};
// ── One kind's card ──────────────────────────────────────────────────────────
const $9ea74aa9cf27c9eb$export$3afd232cc2b2e4df = ({ kind: kind, icon: icon, iconBg: iconBg, iconColor: iconColor })=>{
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const store = (0, $f6afc37e3d3310be$export$a282db6c512184e6)(kind);
    const [editing, setEditing] = (0, $acw62.useState)(null); // { template } | { template: null } | null
    const [pendingDelete, setPendingDelete] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const onSave = (0, $acw62.useCallback)(async (draft)=>{
        const target = editing?.template;
        if (target) await store.update(target.id, draft);
        else await store.create(draft);
        toast.success(t('settings.templates.saved'));
    }, [
        editing,
        store,
        toast,
        t
    ]);
    const onDuplicate = (0, $acw62.useCallback)(async (template)=>{
        setBusy(true);
        try {
            await store.duplicate(template.id);
            toast.success(t('settings.templates.duplicated'));
        } catch (err) {
            toast.error(t('settings.templates.duplicateFailed'));
        } finally{
            setBusy(false);
        }
    }, [
        store,
        toast,
        t
    ]);
    const onConfirmDelete = (0, $acw62.useCallback)(async ()=>{
        if (!pendingDelete) return;
        setBusy(true);
        try {
            await store.remove(pendingDelete.id);
            toast.success(t('settings.templates.deleted'));
        } catch (err) {
            toast.error(t('settings.templates.deleteFailed'));
        } finally{
            setBusy(false);
            setPendingDelete(null);
        }
    }, [
        pendingDelete,
        store,
        toast,
        t
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                testId: `settings-templates-${kind}`,
                icon: icon,
                iconBg: iconBg,
                iconColor: iconColor,
                title: t(`settings.templates.${kind}.label`),
                subtitle: t(`settings.templates.${kind}.explain`),
                actions: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    variant: "subtle",
                    size: "sm",
                    onClick: ()=>setEditing({
                            template: null
                        }),
                    "data-testid": `template-new-${kind}`,
                    children: [
                        "+ ",
                        t(`settings.templates.${kind}.new`)
                    ]
                }),
                children: store.loading && !store.loaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonList), {
                    count: 2,
                    avatar: false,
                    trailing: 48,
                    label: t('common.state.loading')
                }) : store.error && !store.loaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                    title: t('settings.templates.loadFailed'),
                    error: store.error,
                    onRetry: store.reload
                }) : store.templates.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                    title: t(`settings.templates.${kind}.empty`),
                    description: t(`settings.templates.${kind}.explain`)
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    },
                    children: store.templates.map((template)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$TemplateRow, {
                            kind: kind,
                            template: template,
                            busy: busy,
                            onEdit: (row)=>setEditing({
                                    template: row
                                }),
                            onDuplicate: onDuplicate,
                            onDelete: setPendingDelete
                        }, template.id))
                })
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$export$72b66677513e0cef, {
                kind: kind,
                open: true,
                template: editing.template,
                onClose: ()=>setEditing(null),
                onSave: onSave
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: Boolean(pendingDelete),
                title: t('settings.templates.deleteConfirmTitle'),
                // Says out loud what deleting does NOT do — the question a doctor
                // hesitating over this button is actually asking.
                message: t('settings.templates.deleteConfirmBody', {
                    title: pendingDelete?.title || ''
                }),
                confirmLabel: t('common.actions.delete'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: onConfirmDelete,
                onOpenChange: (next)=>{
                    if (!next) setPendingDelete(null);
                }
            })
        ]
    });
};
function $9ea74aa9cf27c9eb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-templates",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 18
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$var$IntroCard, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$export$3afd232cc2b2e4df, {
                kind: "medication",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).badge, {
                    s: 20
                }),
                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                iconColor: (0, $jTCZr.C).teal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9ea74aa9cf27c9eb$export$3afd232cc2b2e4df, {
                kind: "order",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).clinic, {
                    s: 20
                }),
                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                iconColor: (0, $jTCZr.C).navy
            })
        ]
    });
}


const $93a4e5de34b80e5d$var$KindSection = ({ kind: kind })=>{
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $5a7a6039daa594b4$export$5476e2845fb28531)();
    const store = (0, $f6afc37e3d3310be$export$a282db6c512184e6)(kind);
    const [editing, setEditing] = (0, $acw62.useState)(null);
    const [pendingDelete, setPendingDelete] = (0, $acw62.useState)(null);
    const onSave = (0, $acw62.useCallback)(async (draft)=>{
        if (editing?.template) await store.update(editing.template.id, draft);
        else await store.create(draft);
        toast.success(t('settings.templates.saved'));
    }, [
        editing,
        store,
        toast,
        t
    ]);
    const onConfirmDelete = (0, $acw62.useCallback)(async ()=>{
        if (!pendingDelete) return;
        try {
            await store.remove(pendingDelete.id);
            toast.success(t('settings.templates.deleted'));
        } catch (err) {
            toast.error(t('settings.templates.deleteFailed'));
        } finally{
            setPendingDelete(null);
        }
    }, [
        pendingDelete,
        store,
        toast,
        t
    ]);
    const onDuplicate = (0, $acw62.useCallback)(async (template)=>{
        try {
            await store.duplicate(template.id);
            toast.success(t('settings.templates.duplicated'));
        } catch (err) {
            toast.error(t('settings.templates.duplicateFailed'));
        }
    }, [
        store,
        toast,
        t
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                testId: `settings-templates-${kind}`,
                title: t(`settings.templates.${kind}.label`),
                hint: t(`settings.templates.${kind}.explain`),
                children: [
                    store.loading && !store.loaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonList), {
                        count: 2,
                        avatar: false,
                        trailing: 0,
                        label: t('common.state.loading')
                    }) : store.error && !store.loaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        title: t('settings.templates.loadFailed'),
                        error: store.error,
                        onRetry: store.reload
                    }) : store.templates.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                        title: t(`settings.templates.${kind}.empty`),
                        style: {
                            padding: '20px 8px'
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem'
                        },
                        children: store.templates.map((template)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-testid": `template-row-${kind}`,
                                "data-template-id": template.id,
                                style: {
                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                    borderRadius: '0.625rem',
                                    padding: '0.625rem 0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.8125rem',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: template.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 2
                                        },
                                        children: (0, $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2)(template) ? t('settings.templates.itemCount', {
                                            count: (0, $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2)(template)
                                        }) : t('settings.templates.noItems')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: '0.375rem',
                                            marginTop: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                                variant: "subtle",
                                                size: "sm",
                                                onClick: ()=>setEditing({
                                                        template: template
                                                    }),
                                                "data-testid": `template-edit-${kind}`,
                                                children: t('common.actions.edit')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                                variant: "ghost",
                                                size: "sm",
                                                onClick: ()=>onDuplicate(template),
                                                children: t('settings.templates.duplicate')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                                variant: "ghost",
                                                size: "sm",
                                                onClick: ()=>setPendingDelete(template),
                                                style: {
                                                    color: (0, $jTCZr.C).danger
                                                },
                                                children: t('common.actions.delete')
                                            })
                                        ]
                                    })
                                ]
                            }, template.id))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "subtle",
                        size: "sm",
                        onClick: ()=>setEditing({
                                template: null
                            }),
                        "data-testid": `template-new-${kind}`,
                        style: {
                            marginTop: '0.625rem',
                            width: '100%'
                        },
                        children: [
                            "+ ",
                            t(`settings.templates.${kind}.new`)
                        ]
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ea74aa9cf27c9eb$export$72b66677513e0cef), {
                kind: kind,
                open: true,
                template: editing.template,
                onClose: ()=>setEditing(null),
                onSave: onSave
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: Boolean(pendingDelete),
                title: t('settings.templates.deleteConfirmTitle'),
                message: t('settings.templates.deleteConfirmBody', {
                    title: pendingDelete?.title || ''
                }),
                confirmLabel: t('common.actions.delete'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: onConfirmDelete,
                onOpenChange: (next)=>{
                    if (!next) setPendingDelete(null);
                }
            })
        ]
    });
};
function $93a4e5de34b80e5d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-templates",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "settings-templates-intro",
                style: {
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05),
                    border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.16)}`,
                    borderRadius: '0.875rem',
                    padding: '0.75rem 0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('settings.templates.intro.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: '0.25rem 0 0',
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.9
                        },
                        children: t('settings.templates.intro.body')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: '0.375rem 0 0',
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.9
                        },
                        children: t('settings.templates.intro.copy')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($93a4e5de34b80e5d$var$KindSection, {
                kind: "medication"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($93a4e5de34b80e5d$var$KindSection, {
                kind: "order"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

const $8afc7fe814c13ecc$export$f3b93b19b28bda08 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    const lbl = label ?? t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: lbl,
        "data-testid": "settings-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 20
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                style: {
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: (0, $c48eb69ce5e269ee$export$cf052b29a1666d6a),
                    boxShadow: (0, $c48eb69ce5e269ee$export$345619c94cb75947),
                    height: 52,
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 8px',
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTabs), {
                    widths: [
                        64,
                        84,
                        72,
                        96,
                        60,
                        80
                    ],
                    padding: "0 14px",
                    style: {
                        borderBottom: 'none'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 min-[1181px]:grid-cols-[minmax(0,1fr)_19rem] gap-5 items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: (0, $jTCZr.C).card,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: (0, $c48eb69ce5e269ee$export$cf052b29a1666d6a),
                            padding: 22,
                            boxShadow: (0, $c48eb69ce5e269ee$export$345619c94cb75947),
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "aria-hidden": true,
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    marginBottom: 18
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: 40,
                                        height: 40,
                                        radius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                width: 140,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                width: 200,
                                                height: 11
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
                                fields: 4,
                                columns: 2,
                                actions: 1,
                                gap: 14,
                                style: {
                                    maxWidth: (0, $c48eb69ce5e269ee$export$9543e7b3be254c7c)
                                },
                                label: lbl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: (0, $jTCZr.C).card,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: (0, $c48eb69ce5e269ee$export$cf052b29a1666d6a),
                            padding: 22,
                            boxShadow: (0, $c48eb69ce5e269ee$export$345619c94cb75947),
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                                size: 96
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "70%",
                                height: 14,
                                style: {
                                    marginTop: 4
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "45%",
                                height: 11
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                size: "sm",
                                width: 140,
                                style: {
                                    marginTop: 6
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $8afc7fe814c13ecc$var$MobileSettingRow = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            minHeight: 52,
            padding: '0 0.875rem',
            borderTop: i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 34,
                height: 34,
                radius: (0, $jTCZr.RADIUS).control
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: `${40 + i * 13 % 26}%`,
                height: 13
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 16,
                height: 16,
                radius: 4,
                style: {
                    marginInlineStart: 'auto'
                }
            })
        ]
    });
const $8afc7fe814c13ecc$export$e5bbe71aec5f3374 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "settings-loading",
        style: {
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: 56
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "60%",
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "40%",
                                height: 11
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        size: "sm",
                        width: 72
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: 0,
                    overflow: 'hidden'
                },
                children: [
                    0,
                    1,
                    2,
                    3
                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8afc7fe814c13ecc$var$MobileSettingRow, {
                        i: i
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.625rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 110,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                        lines: 2,
                        height: 12,
                        lastWidth: "55%"
                    })
                ]
            })
        ]
    });
};
var $8afc7fe814c13ecc$export$2e2bcd8739ae039 = $8afc7fe814c13ecc$export$f3b93b19b28bda08;


// Doctor specialties and sub-specialties — one catalogue shared by Profile and
// Onboarding (each used to keep its own copy). Add a row here and both screens
// pick it up.
//
// The Persian string is the VALUE, and it stays Persian in every language: it is
// what `doctor.specialty` already holds on thousands of rows, so translating it
// would either orphan those rows or need a data migration. Only the label the
// doctor reads is translated, via `SPECIALTY_LABEL_KEYS`.
//
// Two rules govern edits:
//
//   1. NEVER change or remove an existing Persian value. A stored row that no
//      longer matches a catalogue entry falls back to rendering verbatim, but it
//      also disappears from the picker — the doctor would have to re-pick, and
//      `specialty` is what decides which app they are routed into.
//   2. Order in this file is irrelevant. The picker sorts alphabetically at
//      render time, in the CURRENT UI language (see `specialtyOptions`), so a
//      new row can be appended to the group it belongs to without re-sorting.
//
// The kind — تخصص vs فوق‌تخصص — is what the picker groups by. Iran's board
// certifications separate the two, and a doctor looking for «نفرولوژی» expects
// to find it under فوق‌تخصص rather than mixed into a flat list of eighty.
const $b0b690e819784781$export$7891c9316c10d37b = 'specialty';
const $b0b690e819784781$export$7e7250193bc8e7c5 = 'subspecialty';
// [slug, storedPersianValue, kind]
//
// The slug is stable and ASCII so the catalogue stays greppable, and it names the
// i18n key: `common.specialty.<slug>`. Every slug here MUST exist in fa/en/ar.
//
// i18n-exempt: stored identifiers and clinical vocabulary, not UI copy — the
// label a doctor reads is translated at the render site via `specialtyLabel`.
const $b0b690e819784781$var$CATALOGUE = [
    // ── تخصص ──────────────────────────────────────────────────────────────────
    [
        'general',
        "\u0639\u0645\u0648\u0645\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'internal',
        "\u062F\u0627\u062E\u0644\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'cardiology',
        "\u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'neurology',
        "\u0645\u063A\u0632 \u0648 \u0627\u0639\u0635\u0627\u0628",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'orthopedics',
        "\u0627\u0631\u062A\u0648\u067E\u062F\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'obgyn',
        "\u0632\u0646\u0627\u0646 \u0648 \u0632\u0627\u06CC\u0645\u0627\u0646",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'pediatrics',
        "\u0627\u0637\u0641\u0627\u0644",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'generalSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u0639\u0645\u0648\u0645\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'ophthalmology',
        "\u0686\u0634\u0645",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'ent',
        "\u06AF\u0648\u0634 \u0648 \u062D\u0644\u0642 \u0648 \u0628\u06CC\u0646\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'dermatology',
        "\u067E\u0648\u0633\u062A",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'psychiatry',
        "\u0631\u0648\u0627\u0646\u067E\u0632\u0634\u06A9\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'urology',
        "\u0627\u0648\u0631\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'dentistry',
        "\u062F\u0646\u062F\u0627\u0646\u067E\u0632\u0634\u06A9\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'physiotherapy',
        "\u0641\u06CC\u0632\u06CC\u0648\u062A\u0631\u0627\u067E\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'radiology',
        "\u0631\u0627\u062F\u06CC\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'anesthesiology',
        "\u0628\u06CC\u0647\u0648\u0634\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'pathology',
        "\u0622\u0633\u06CC\u0628\u200C\u0634\u0646\u0627\u0633\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'forensicMedicine',
        "\u067E\u0632\u0634\u06A9\u06CC \u0642\u0627\u0646\u0648\u0646\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'nuclearMedicine',
        "\u067E\u0632\u0634\u06A9\u06CC \u0647\u0633\u062A\u0647\u200C\u0627\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'sportsMedicine',
        "\u067E\u0632\u0634\u06A9\u06CC \u0648\u0631\u0632\u0634\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'familyMedicine',
        "\u067E\u0632\u0634\u06A9\u06CC \u062E\u0627\u0646\u0648\u0627\u062F\u0647",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'socialMedicine',
        "\u067E\u0632\u0634\u06A9\u06CC \u0627\u062C\u062A\u0645\u0627\u0639\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'emergencyMedicine',
        "\u0637\u0628 \u0627\u0648\u0631\u0698\u0627\u0646\u0633",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'occupationalMedicine',
        "\u0637\u0628 \u06A9\u0627\u0631",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'preventiveMedicine',
        "\u0637\u0628 \u067E\u06CC\u0634\u06AF\u06CC\u0631\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'physicalMedicine',
        "\u0637\u0628 \u0641\u06CC\u0632\u06CC\u06A9\u06CC \u0648 \u062A\u0648\u0627\u0646\u0628\u062E\u0634\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'traditionalMedicine',
        "\u0637\u0628 \u0633\u0646\u062A\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'neurosurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u0645\u063A\u0632 \u0648 \u0627\u0639\u0635\u0627\u0628",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'radiationOncology',
        "\u0631\u0627\u062F\u06CC\u0648\u062A\u0631\u0627\u067E\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'medicalGenetics',
        "\u0698\u0646\u062A\u06CC\u06A9 \u067E\u0632\u0634\u06A9\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'infectiousDiseases',
        "\u0628\u06CC\u0645\u0627\u0631\u06CC\u200C\u0647\u0627\u06CC \u0639\u0641\u0648\u0646\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'psychology',
        "\u0631\u0648\u0627\u0646\u200C\u0634\u0646\u0627\u0633\u06CC",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    [
        'nutrition',
        "\u062A\u063A\u0630\u06CC\u0647",
        $b0b690e819784781$export$7891c9316c10d37b
    ],
    // ── فوق‌تخصص ──────────────────────────────────────────────────────────────
    [
        'endocrinology',
        "\u063A\u062F\u062F",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pulmonology',
        "\u0631\u06CC\u0647",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'gastroenterology',
        "\u06AF\u0648\u0627\u0631\u0634",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'hematology',
        "\u062E\u0648\u0646\u200C\u0634\u0646\u0627\u0633\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'oncology',
        "\u0627\u0646\u06A9\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'nephrology',
        "\u0646\u0641\u0631\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'rheumatology',
        "\u0631\u0648\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'allergyImmunology',
        "\u0622\u0633\u0645 \u0648 \u0622\u0644\u0631\u0698\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'criticalCare',
        "\u0645\u0631\u0627\u0642\u0628\u062A\u200C\u0647\u0627\u06CC \u0648\u06CC\u0698\u0647",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'neonatology',
        "\u0646\u0648\u0632\u0627\u062F\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricCardiology',
        "\u0642\u0644\u0628 \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricNeurology',
        "\u0627\u0639\u0635\u0627\u0628 \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricNephrology',
        "\u0646\u0641\u0631\u0648\u0644\u0648\u0698\u06CC \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricGastroenterology',
        "\u06AF\u0648\u0627\u0631\u0634 \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricEndocrinology',
        "\u063A\u062F\u062F \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricHematology',
        "\u062E\u0648\u0646 \u0648 \u0627\u0646\u06A9\u0648\u0644\u0648\u0698\u06CC \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'pediatricSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u06A9\u0648\u062F\u06A9\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'cardiacSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'thoracicSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u062A\u0648\u0631\u0627\u06A9\u0633",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'vascularSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u0639\u0631\u0648\u0642",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'plasticSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u067E\u0644\u0627\u0633\u062A\u06CC\u06A9 \u0648 \u062A\u0631\u0645\u06CC\u0645\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'colorectalSurgery',
        "\u062C\u0631\u0627\u062D\u06CC \u06A9\u0648\u0644\u0648\u0631\u06A9\u062A\u0627\u0644",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'interventionalCardiology',
        "\u0642\u0644\u0628 \u0645\u062F\u0627\u062E\u0644\u0647\u200C\u0627\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'electrophysiology',
        "\u0627\u0644\u06A9\u062A\u0631\u0648\u0641\u06CC\u0632\u06CC\u0648\u0644\u0648\u0698\u06CC \u0642\u0644\u0628",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'geriatrics',
        "\u0637\u0628 \u0633\u0627\u0644\u0645\u0646\u062F\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'perinatology',
        "\u067E\u0631\u06CC\u0646\u0627\u062A\u0648\u0644\u0648\u0698\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'gynecologicOncology',
        "\u0627\u0646\u06A9\u0648\u0644\u0648\u0698\u06CC \u0632\u0646\u0627\u0646",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'infertility',
        "\u0646\u0627\u0632\u0627\u06CC\u06CC \u0648 \u0646\u0627\u0628\u0627\u0631\u0648\u0631\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'palliativeCare',
        "\u0637\u0628 \u062A\u0633\u06A9\u06CC\u0646\u06CC",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ],
    [
        'painMedicine',
        "\u0637\u0628 \u062F\u0631\u062F",
        $b0b690e819784781$export$7e7250193bc8e7c5
    ]
];
// ── Persian collation ─────────────────────────────────────────────────────────
//
// `localeCompare(a, b, 'fa')` needs an ICU build that carries the Persian
// collation, and jsdom/node without full-icu silently falls back to code-point
// order — which puts «آ» after «ی» and reads as random to a Persian speaker. The
// alphabet is 32 letters; spelling it out is cheaper than the dependency.
//
// i18n-exempt: a collation table, not UI copy.
const $b0b690e819784781$var$FA_ALPHABET = "\u0622\u0627\u0628\u067E\u062A\u062B\u062C\u0686\u062D\u062E\u062F\u0630\u0631\u0632\u0698\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\u0641\u0642\u06A9\u06AF\u0644\u0645\u0646\u0648\u0647\u06CC";
const $b0b690e819784781$var$FA_RANK = Object.fromEntries([
    ...$b0b690e819784781$var$FA_ALPHABET
].map((ch, i)=>[
        ch,
        i
    ]));
// Fold the shapes that mean the same letter, and drop what carries no order:
// ZWNJ (which is inside «خون‌شناسی» and would otherwise sort before every
// letter), spaces, and the Arabic hamza forms Persian text picks up from
// copy-paste.
// i18n-exempt: a normalisation table, not UI copy.
const $b0b690e819784781$var$FA_FOLD = {
    "\u064A": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0624": "\u0648",
    "\u0626": "\u06CC",
    "\u0649": "\u06CC"
};
const $b0b690e819784781$var$faKey = (s)=>[
        ...String(s || '')
    ].map((ch)=>$b0b690e819784781$var$FA_FOLD[ch] || ch).filter((ch)=>ch !== "\u200C" && ch !== ' ').join('');
const $b0b690e819784781$export$fe3546b490ad2b51 = (a, b)=>{
    const x = $b0b690e819784781$var$faKey(a);
    const y = $b0b690e819784781$var$faKey(b);
    const n = Math.min(x.length, y.length);
    for(let i = 0; i < n; i += 1){
        const rx = $b0b690e819784781$var$FA_RANK[x[i]] ?? Number.MAX_SAFE_INTEGER;
        const ry = $b0b690e819784781$var$FA_RANK[y[i]] ?? Number.MAX_SAFE_INTEGER;
        if (rx !== ry) return rx - ry;
        if (rx === Number.MAX_SAFE_INTEGER && x[i] !== y[i]) return x[i] < y[i] ? -1 : 1;
    }
    return x.length - y.length;
};
const $b0b690e819784781$export$359f154a158b860 = $b0b690e819784781$var$CATALOGUE.map(([, value])=>value).sort($b0b690e819784781$export$fe3546b490ad2b51);
const $b0b690e819784781$export$20d38eb02d0ae435 = Object.fromEntries($b0b690e819784781$var$CATALOGUE.map(([slug, value])=>[
        value,
        `common.specialty.${slug}`
    ]));
const $b0b690e819784781$export$336d6083be71eb55 = Object.fromEntries($b0b690e819784781$var$CATALOGUE.map(([, value, kind])=>[
        value,
        kind
    ]));
const $b0b690e819784781$export$a72e38531c5976c0 = {
    [$b0b690e819784781$export$7891c9316c10d37b]: 'common.specialtyGroup.specialty',
    [$b0b690e819784781$export$7e7250193bc8e7c5]: 'common.specialtyGroup.subspecialty'
};
const $b0b690e819784781$export$1b9772fac51ff6b7 = (t, value)=>{
    const key = $b0b690e819784781$export$20d38eb02d0ae435[value];
    return key ? t(key) : value || '';
};
const $b0b690e819784781$export$6347a08070ffc139 = (t, locale = 'fa', extra = '')=>{
    const options = $b0b690e819784781$var$CATALOGUE.map(([slug, value, kind])=>({
            value: value,
            label: t(`common.specialty.${slug}`),
            group: kind,
            groupLabel: t($b0b690e819784781$export$a72e38531c5976c0[kind])
        }));
    if (extra && !$b0b690e819784781$export$20d38eb02d0ae435[extra]) options.push({
        value: extra,
        label: extra,
        group: $b0b690e819784781$export$7891c9316c10d37b,
        groupLabel: t($b0b690e819784781$export$a72e38531c5976c0[$b0b690e819784781$export$7891c9316c10d37b])
    });
    const byLabel = locale === 'fa' ? (a, b)=>$b0b690e819784781$export$fe3546b490ad2b51(a.value, b.value) : (a, b)=>a.label.localeCompare(b.label, locale);
    return options.sort((a, b)=>{
        if (a.group !== b.group) return a.group === $b0b690e819784781$export$7891c9316c10d37b ? -1 : 1;
        return byLabel(a, b);
    });
};



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $1Ssl4 = parcelRequire("1Ssl4");
var $6usBW = parcelRequire("6usBW");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



const $9585130d255ed442$export$67549a2a1f1f448b = {
    spo2Threshold: {
        min: 80,
        max: 100
    },
    bpSystolicThreshold: {
        min: 100,
        max: 220
    }
};
const $9585130d255ed442$var$FA_AR_DIGITS = /[۰-۹٠-٩]/g;
const $9585130d255ed442$var$toAsciiDigits = (s)=>String(s).replace($9585130d255ed442$var$FA_AR_DIGITS, (d)=>String((d.charCodeAt(0) & 0xf) % 10));
function $9585130d255ed442$export$26f5a728d24d68da(key, raw) {
    const text = $9585130d255ed442$var$toAsciiDigits(raw ?? '').trim();
    if (!text) return {
        error: {
            key: 'validation.requiredGeneric'
        }
    };
    const n = Number(text);
    const { min: min, max: max } = $9585130d255ed442$export$67549a2a1f1f448b[key];
    if (!Number.isFinite(n) || !Number.isInteger(n) || n < min || n > max) return {
        error: {
            key: 'validation.range',
            vars: {
                min: min,
                max: max
            }
        }
    };
    return {
        value: n
    };
}
function $9585130d255ed442$export$3bea5dd33d624fb7(form, prevSaved, saved) {
    const next = {
        ...saved
    };
    Object.keys(saved).forEach((k)=>{
        if (form && prevSaved && form[k] !== prevSaved[k]) next[k] = form[k];
    });
    return next;
}
function $9585130d255ed442$export$c1629e185843c96d() {
    const { doctor: doctor, loading: loading, saving: saving, error: error, update: update, updateAvatar: updateAvatar, refetch: refetch } = (0, $6f41166a3447eed0$export$c33fab67557a8508)();
    const toast = (0, $6usBW.useToast)();
    const { setAppearance: applyAppearanceLocally } = (0, $1Ssl4.useTheme)();
    const { t: t, locale: locale, setLocale: setLocale, locales: locales } = (0, $LNQP4.default)();
    // ── Profile ────────────────────────────────────────────────────────────────
    const saved = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$b76bdd93b2cd1293)(doctor), [
        doctor
    ]);
    const [form, setForm] = (0, $acw62.useState)(saved);
    const [errors, setErrors] = (0, $acw62.useState)({});
    // A new server snapshot (a refetch after the avatar, a toggle, another tab)
    // refreshes only the fields the doctor has NOT edited. Replacing the whole
    // form here silently threw away an unsaved bio the moment the avatar changed.
    // A field counts as edited when it differs from the snapshot it was loaded
    // from; after a successful save the two agree again, so nothing sticks.
    const prevSavedRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!doctor) return;
        const prev = prevSavedRef.current;
        prevSavedRef.current = saved;
        if (!prev) {
            setForm(saved);
            setErrors({});
            return;
        }
        setForm((f)=>$9585130d255ed442$export$3bea5dd33d624fb7(f, prev, saved));
    // Validation errors describe the doctor's own values, which survive — so
    // they stay too.
    }, [
        doctor,
        saved
    ]);
    // Kit inputs deliver a DOM (or synthetic {target:{value}}) event. Re-validate
    // on change only once a field has already shown an error (§6.3).
    const setField = (0, $acw62.useCallback)((key)=>(e)=>{
            const value = e?.target?.value ?? e;
            setForm((f)=>({
                    ...f,
                    [key]: value
                }));
            setErrors((prev)=>prev[key] ? {
                    ...prev,
                    [key]: undefined
                } : prev);
        }, []);
    const dirty = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$6751d1764e58e2a1)(form, saved), [
        form,
        saved
    ]);
    const completeness = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$98245d8165151e62)(form), [
        form
    ]);
    const resetProfile = (0, $acw62.useCallback)(()=>{
        setForm(saved);
        setErrors({});
    }, [
        saved
    ]);
    const saveProfile = (0, $acw62.useCallback)(async ()=>{
        const next = (0, $2d58c73a38525204$export$a07b599d4f364c08)(form, saved);
        if (Object.keys(next).length) {
            setErrors(next);
            return {
                ok: false,
                errors: next
            };
        }
        const input = (0, $2d58c73a38525204$export$46e28ca63030741b)(form, saved);
        if (!Object.keys(input).length) {
            toast.info(t('settings.profile.noChanges'));
            return {
                ok: true,
                noop: true
            };
        }
        try {
            await update('profile', input);
            toast.success(t('settings.profile.saved'));
            return {
                ok: true
            };
        } catch (e) {
            toast.error(t('errors.save.profile'));
            return {
                ok: false
            };
        }
    }, [
        form,
        saved,
        update,
        toast,
        t
    ]);
    // ── Avatar (immediate save, like the sections below) ───────────────────────
    const [avatarBusy, setAvatarBusy] = (0, $acw62.useState)(false);
    const saveAvatar = (0, $acw62.useCallback)(async (dataUri)=>{
        setAvatarBusy(true);
        try {
            await updateAvatar(dataUri);
            toast.success(t('settings.avatar.updated'));
            return {
                ok: true
            };
        } catch (e) {
            toast.error(t('errors.avatar.save'));
            return {
                ok: false
            };
        } finally{
            setAvatarBusy(false);
        }
    }, [
        updateAvatar,
        toast,
        t
    ]);
    const removeAvatar = (0, $acw62.useCallback)(async ()=>{
        setAvatarBusy(true);
        try {
            await updateAvatar(null);
            toast.success(t('settings.avatar.removed'));
            return {
                ok: true
            };
        } catch (e) {
            toast.error(t('errors.avatar.remove'));
            return {
                ok: false
            };
        } finally{
            setAvatarBusy(false);
        }
    }, [
        updateAvatar,
        toast,
        t
    ]);
    // ── Settings sections (immediate save) ─────────────────────────────────────
    const ai = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$12678b5895b9b663)(doctor), [
        doctor
    ]);
    const appearance = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$109495996d5012e4)(doctor), [
        doctor
    ]);
    const security = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$74c8f641b046dabd)(doctor), [
        doctor
    ]);
    const visitLayout = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$dc4d894629379c14)(doctor), [
        doctor
    ]);
    // Optimistic overlay so a switch moves under the finger while the mutation is
    // in flight. Cleared once the refetched doctor carries the same value.
    const [pending, setPending] = (0, $acw62.useState)({});
    const pendingRef = (0, $acw62.useRef)(pending);
    pendingRef.current = pending;
    const commit = (0, $acw62.useCallback)(async (section, patch, current)=>{
        const changes = (0, $2d58c73a38525204$export$59230889ac977c02)(patch, current);
        if (!Object.keys(changes).length) return true;
        setPending((p)=>({
                ...p,
                [section]: {
                    ...p[section],
                    ...changes
                }
            }));
        try {
            await update(section, changes);
            // The refetch inside `update` has landed, so the overlay is now redundant.
            setPending((p)=>{
                const { [section]: _dropped, ...rest } = p;
                return rest;
            });
            return true;
        } catch (e) {
            // Roll back rather than leave the control lying about server state.
            setPending((p)=>{
                const { [section]: _dropped, ...rest } = p;
                return rest;
            });
            toast.error(t('errors.save.settings'));
            return false;
        }
    }, [
        update,
        toast,
        t
    ]);
    const effective = (0, $acw62.useCallback)((section, base)=>({
            ...base,
            ...pending[section] || {}
        }), [
        pending
    ]);
    const setAiSetting = (0, $acw62.useCallback)((key, value)=>{
        const current = {
            ...ai,
            ...pendingRef.current.aiAgent || {}
        };
        return commit('aiAgent', {
            ...current,
            [key]: value
        }, current);
    }, [
        ai,
        commit
    ]);
    const [thresholdDrafts, setThresholdDrafts] = (0, $acw62.useState)({});
    const [thresholdErrors, setThresholdErrors] = (0, $acw62.useState)({});
    const thresholdField = (0, $acw62.useCallback)((key)=>{
        const stored = {
            ...ai,
            ...pending.aiAgent || {}
        }[key];
        const draft = thresholdDrafts[key];
        const err = thresholdErrors[key];
        return {
            value: draft ?? (stored == null ? '' : String(stored)),
            error: err ? t(err.key, err.vars) : undefined,
            onChange: (e)=>{
                const v = e?.target?.value ?? e;
                setThresholdDrafts((d)=>({
                        ...d,
                        [key]: v
                    }));
                // Re-validate while typing only once the field has shown an error (DC §6.3).
                if (err) {
                    const r = $9585130d255ed442$export$26f5a728d24d68da(key, v);
                    setThresholdErrors((x)=>({
                            ...x,
                            [key]: r.error
                        }));
                }
            },
            onBlur: ()=>{
                if (draft === undefined) return;
                const r = $9585130d255ed442$export$26f5a728d24d68da(key, draft);
                if (r.error) {
                    setThresholdErrors((x)=>({
                            ...x,
                            [key]: r.error
                        }));
                    return;
                }
                setThresholdErrors((x)=>({
                        ...x,
                        [key]: undefined
                    }));
                setThresholdDrafts((d)=>{
                    const n = {
                        ...d
                    };
                    delete n[key];
                    return n;
                });
                if (r.value !== stored) setAiSetting(key, r.value);
            }
        };
    }, [
        ai,
        pending,
        thresholdDrafts,
        thresholdErrors,
        setAiSetting,
        t
    ]);
    const setSecuritySetting = (0, $acw62.useCallback)((key, value)=>{
        const current = {
            ...security,
            ...pendingRef.current.security || {}
        };
        return commit('security', {
            ...current,
            [key]: value
        }, current);
    }, [
        security,
        commit
    ]);
    // Appearance paints locally first so the accent switches under the cursor,
    // then persists. On failure the local paint is reverted too.
    //
    // Two painters: the accent and the type scale belong to the design system's
    // ThemeProvider; the typeFACE is the app's own (src/constants/fonts.js). Same
    // section on the wire, same optimistic-then-persist path, different brush.
    const paintAppearance = (0, $acw62.useCallback)((key, value)=>{
        if (key === 'fontFamily') (0, $2b1ef8e92b4fa1dc$export$17d5115a21e3d7f9)(value);
        else applyAppearanceLocally({
            [key]: value
        });
    }, [
        applyAppearanceLocally
    ]);
    const setAppearanceSetting = (0, $acw62.useCallback)(async (key, value)=>{
        const current = {
            ...appearance,
            ...pendingRef.current.appearance || {}
        };
        if (value === current[key]) return true;
        paintAppearance(key, value);
        const ok = await commit('appearance', {
            ...current,
            [key]: value
        }, current);
        if (!ok) paintAppearance(key, current[key]);
        return ok;
    }, [
        appearance,
        commit,
        paintAppearance
    ]);
    // ── Visit page layout ──────────────────────────────────────────────────────
    //
    // The editor's operations (screens/Visit/visitLayout.js) each return a PATCH
    // — only the keys they touched — which is exactly what the partial-update
    // mutation wants. Several keys may move at once (an order and a hidden list),
    // so this takes a patch rather than a single key.
    const setVisitLayout = (0, $acw62.useCallback)((patch)=>{
        if (!patch || !Object.keys(patch).length) return Promise.resolve(true);
        const current = {
            ...visitLayout,
            ...pendingRef.current.visitLayout || {}
        };
        return commit('visitLayout', {
            ...current,
            ...patch
        }, current);
    }, [
        visitLayout,
        commit
    ]);
    // Back to the page as it shipped. Sends every key that differs from the
    // defaults — the service merges, so a key already at its default is skipped
    // by `changedKeys` and nothing is rewritten needlessly.
    const resetVisitLayout = (0, $acw62.useCallback)(()=>{
        const current = {
            ...visitLayout,
            ...pendingRef.current.visitLayout || {}
        };
        return commit('visitLayout', {
            ...current,
            ...(0, $792124e2f7de719a$export$df312747b9dc7053)
        }, current);
    }, [
        visitLayout,
        commit
    ]);
    // The server's copy wins over whatever this browser resolved, but ONLY when
    // the doctor has actually recorded one. `appearanceSettings()` fills in the
    // product default for an absent value, so the raw field is read here instead:
    // adopting the default would override a doctor whose device is English and
    // who has never opened this screen, which is precisely the case the
    // device-language step of the resolution order exists to serve.
    const storedLanguage = doctor?.settings?.appearance?.language ?? null;
    (0, $acw62.useEffect)(()=>{
        if (storedLanguage) setLocale(storedLanguage);
    }, [
        storedLanguage,
        setLocale
    ]);
    // ── Language ───────────────────────────────────────────────────────────────
    //
    // Stored in the SAME `appearance` section as the accent, but it cannot go
    // through `setAppearanceSetting`: that paints via the design system's
    // ThemeProvider, which knows about accents and type scales and nothing about
    // locales. Language paints through the i18n provider instead — same shape,
    // different painter.
    //
    // Order matters and is the whole point of requirement 7: `setLocale` first,
    // so every screen re-renders in the new language on the next frame, and the
    // network round trip happens behind an already-switched UI. Nothing unmounts,
    // so the open tab, the scroll position and any half-filled form survive.
    //
    // The success toast is deliberately read AFTER the switch, so it arrives in
    // the language the doctor just chose — the first confirmation that it worked.
    const setLanguage = (0, $acw62.useCallback)(async (next)=>{
        const current = {
            ...appearance,
            ...pendingRef.current.appearance || {}
        };
        if (!next || next === current.language) return true;
        setLocale(next);
        const ok = await commit('appearance', {
            ...current,
            language: next
        }, current);
        if (!ok) setLocale(current.language);
        return ok;
    }, [
        appearance,
        commit,
        setLocale
    ]);
    // ── Password: NOT HERE ANY MORE ────────────────────────────────────────────
    // It moved to حساب پارسینا, which is the only panel-independent place a person
    // can change one. Keeping a second writer was the whole problem: this panel
    // was the only one that HAD a password change, so every other role had none —
    // and an account that signed up by phone and never chose a password could not
    // set a first one here at all, because the form demanded the current one.
    // The Settings screens link out; `changePassword` is gone from the BFF too.
    return {
        doctor: doctor,
        loading: loading,
        saving: saving,
        error: error,
        refetch: refetch,
        form: // profile form. `councilLocked` is the one field rule both surfaces need
        // to render rather than merely validate — see Settings.shared.js.
        form,
        errors: errors,
        setField: setField,
        dirty: dirty,
        completeness: completeness,
        resetProfile: resetProfile,
        saveProfile: saveProfile,
        councilLocked: (0, $2d58c73a38525204$export$b0c3bc556f31ebe8)(saved),
        avatarBusy: // avatar
        avatarBusy,
        saveAvatar: saveAvatar,
        removeAvatar: removeAvatar,
        // settings sections — `effective` values include any in-flight change
        ai: effective('aiAgent', ai),
        appearance: effective('appearance', appearance),
        security: effective('security', security),
        visitLayout: effective('visitLayout', visitLayout),
        setAiSetting: setAiSetting,
        thresholdField: thresholdField,
        setAppearanceSetting: setAppearanceSetting,
        setSecuritySetting: setSecuritySetting,
        setVisitLayout: setVisitLayout,
        resetVisitLayout: resetVisitLayout,
        // Language. `language` is what is actually ON SCREEN, not what the server
        // last stored: the two differ for the moment between the local switch and
        // the mutation landing, and the picker must show the doctor's choice
        // immediately or it reads as having ignored the click.
        language: locale,
        languages: locales,
        setLanguage: setLanguage
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $bca3e7c1cf4ecca1$export$2e2bcd8739ae039({ presets: presets, value: value, onChange: onChange, testId: testId = 'settings-theme' }) {
    const { t: t, isRTL: isRTL } = (0, $LNQP4.default)();
    const refs = (0, $acw62.useRef)({});
    const onKeyDown = (e)=>{
        const keys = [
            'ArrowRight',
            'ArrowLeft',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
        ];
        if (!keys.includes(e.key)) return;
        e.preventDefault();
        const i = presets.findIndex((p)=>p.id === value);
        const current = i === -1 ? 0 : i;
        // The arrows follow what the doctor SEES, so which one advances depends on
        // the direction the grid is laid out in — not on the array order.
        const forward = isRTL ? e.key === 'ArrowLeft' || e.key === 'ArrowDown' : e.key === 'ArrowRight' || e.key === 'ArrowDown';
        const step = forward ? 1 : -1;
        let next;
        if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = presets.length - 1;
        else next = (current + step + presets.length) % presets.length;
        const id = presets[next].id;
        onChange(id);
        refs.current[id]?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "radiogroup",
        "aria-label": t('settings.appearance.themePickerLabel'),
        "data-testid": testId,
        onKeyDown: onKeyDown,
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(150px, 100%), 1fr))',
            gap: 12
        },
        children: presets.map((preset)=>{
            const selected = preset.id === value;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                ref: (el)=>{
                    refs.current[preset.id] = el;
                },
                type: "button",
                role: "radio",
                "aria-checked": selected,
                tabIndex: selected ? 0 : -1,
                "data-testid": `${testId}-option-${preset.id}`,
                onClick: ()=>onChange(preset.id),
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    minHeight: 44,
                    padding: '10px 12px',
                    borderRadius: 10,
                    cursor: 'pointer',
                    textAlign: 'start',
                    background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.C).card,
                    border: `1.5px solid ${selected ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                    boxShadow: selected ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.13)}` : 'none',
                    transition: 'border-color .15s, box-shadow .15s, background .15s'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            width: 28,
                            height: 28,
                            borderRadius: '50%',
                            flexShrink: 0,
                            background: `linear-gradient(135deg, ${preset.swatch2}, ${preset.swatch})`,
                            border: '1px solid rgba(0,0,0,0.08)'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            fontSize: 13,
                            fontWeight: selected ? 700 : 600,
                            color: selected ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary
                        },
                        children: preset.label
                    }),
                    selected && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        width: 16,
                        height: 16,
                        fill: (0, $jTCZr.C).navy,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        })
                    })
                ]
            }, preset.id);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

function $4b474dda548c88bd$export$2e2bcd8739ae039({ value: value, onChange: onChange, testId: testId = 'settings-font' }) {
    const { t: t, isRTL: isRTL } = (0, $LNQP4.default)();
    const refs = (0, $acw62.useRef)({});
    const options = (0, $2b1ef8e92b4fa1dc$export$5e0101b7a2e9ac78);
    const onKeyDown = (e)=>{
        const keys = [
            'ArrowRight',
            'ArrowLeft',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
        ];
        if (!keys.includes(e.key)) return;
        e.preventDefault();
        const i = options.findIndex((f)=>f.id === value);
        const current = i === -1 ? 0 : i;
        const forward = isRTL ? e.key === 'ArrowLeft' || e.key === 'ArrowDown' : e.key === 'ArrowRight' || e.key === 'ArrowDown';
        const step = forward ? 1 : -1;
        let next;
        if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = options.length - 1;
        else next = (current + step + options.length) % options.length;
        const id = options[next].id;
        onChange(id);
        refs.current[id]?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "radiogroup",
        "aria-label": t('settings.appearance.fontFamilyTitle'),
        "data-testid": testId,
        onKeyDown: onKeyDown,
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(210px, 100%), 1fr))',
            gap: 12
        },
        children: options.map((font)=>{
            const selected = font.id === value;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                ref: (el)=>{
                    refs.current[font.id] = el;
                },
                type: "button",
                role: "radio",
                "aria-checked": selected,
                tabIndex: selected ? 0 : -1,
                "data-testid": `${testId}-option-${font.id}`,
                onClick: ()=>onChange(font.id),
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: 6,
                    minHeight: 44,
                    padding: '12px 14px',
                    borderRadius: 10,
                    cursor: 'pointer',
                    textAlign: 'start',
                    background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.C).card,
                    border: `1.5px solid ${selected ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                    boxShadow: selected ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.13)}` : 'none',
                    transition: 'border-color .15s, box-shadow .15s, background .15s',
                    // The option is set in the face it offers — that IS the preview.
                    fontFamily: (0, $2b1ef8e92b4fa1dc$export$b2f634c57ce36bba)(font.id)
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    fontSize: 14,
                                    fontWeight: selected ? 700 : 600,
                                    color: selected ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary
                                },
                                children: t(font.labelKey)
                            }),
                            selected && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                width: 16,
                                height: 16,
                                fill: (0, $jTCZr.C).navy,
                                "aria-hidden": true,
                                style: {
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 13,
                            lineHeight: 1.7,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('settings.appearance.fontSample')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 11,
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.6
                        },
                        children: t(font.hintKey)
                    })
                ]
            }, font.id);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $661a253bb3c908f4$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const $661a253bb3c908f4$export$2e2bcd8739ae039 = (0, $9QBug.default)("grip-vertical", $661a253bb3c908f4$export$3efd853dbb351e94);


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// «صفحه ویزیت» — the layout editor, phone-shaped.
//
// The desktop editor puts a row's three decisions side by side, which a 390px
// screen cannot hold: the row wraps, and its ▲/▼ buttons are below the 44px
// touch floor. So this is a genuine fork of the SURFACE, not of the logic —
// every control calls the same pure operation in screens/Visit/visitLayout.js
// and hands the same patch to the same mutation. The two editors cannot mean
// different things by an order or a hidden section.
//
// Three changes the phone makes:
//   1. One group at a time (a segmented control), because the three columns of
//      the visit page do not fit side by side and do not need to.
//   2. Reordering is a DRAG, the phone's gesture for it — with the keyboard
//      path kept (the handle is a real button; ↑/↓ move the row), because a
//      drag-only reorder is unreachable for anyone not using a finger.
//   3. Two decisions per row instead of three columns of checkboxes: a switch
//      shows or hides, and the state line under the title IS the «باز/بسته در
//      شروع» control rather than a second checkbox competing for the width.
// ─────────────────────────────────────────────────────────────────────────────
const $a70b43577d2dd015$var$ROW_MIN_H = '3.5rem'; // 56px — a comfortable drag target
const $a70b43577d2dd015$var$rowStyle = (dragging, lifted)=>({
        display: 'flex',
        alignItems: 'center',
        gap: '0.625rem',
        minHeight: $a70b43577d2dd015$var$ROW_MIN_H,
        padding: '0.5rem 0',
        borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
        background: lifted ? (0, $jTCZr.C).card : 'transparent',
        boxShadow: lifted ? '0 8px 20px rgba(26,35,50,0.16)' : 'none',
        borderRadius: lifted ? '0.625rem' : 0,
        // The lifted row follows the finger; the others slide under it.
        transition: dragging ? 'none' : 'transform .16s ease',
        position: 'relative',
        touchAction: dragging ? 'none' : 'auto'
    });
/**
 * The show/hide switch, as a TRAILING control.
 *
 * The kit's `Toggle` is a full-width ROW — label on one side, switch on the
 * other, its own padding and bottom rule — so it cannot sit at the end of a row
 * that already has a title, a state line and its own rule. This is the same
 * switch, drawn to the same spec (44×24 track, 18px thumb, navy on, #d1d5db
 * off) with a 44px hit area around it, so the two read as one control even
 * though only one of them is the kit's.
 *
 * It carries its own accessible name: the row's `aria-label` names the SECTION,
 * which is not what «is it shown» is asking.
 */ const $a70b43577d2dd015$var$ShowSwitch = ({ checked: checked, disabled: disabled, onChange: onChange, label: label, testId: testId })=>{
    const [ring, setRing] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-label": label,
        disabled: disabled,
        "data-testid": testId,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setRing(visible);
        },
        onBlur: ()=>setRing(false),
        style: {
            // 44px of finger, 24px of switch.
            minWidth: '2.75rem',
            minHeight: '2.75rem',
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.55 : 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "aria-hidden": true,
            style: {
                width: '2.75rem',
                height: '1.5rem',
                borderRadius: '999px',
                border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
                background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
                boxShadow: ring ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.45)}` : 'none',
                transition: 'background .25s, box-shadow .15s',
                position: 'relative',
                display: 'block'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    position: 'absolute',
                    top: '0.125rem',
                    width: '1.125rem',
                    height: '1.125rem',
                    borderRadius: '50%',
                    background: '#fff',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                    insetInlineEnd: checked ? '0.125rem' : '1.375rem',
                    transition: 'inset-inline-end .25s'
                }
            })
        })
    });
};
/** The «باز در شروع» / «بسته در شروع» state line — a control, not a label. */ const $a70b43577d2dd015$var$OpenStateButton = ({ collapsed: collapsed, disabled: disabled, onToggle: onToggle, testId: testId })=>{
    const { t: t } = (0, $LNQP4.default)();
    // ChevronLeft bare, not a mirrored one: it is how every «go deeper» affordance
    // in the mobile sheets is drawn (MobileVisitRecordSheet), and the panel is RTL.
    const Icon = collapsed ? (0, $gKFEi.default) : (0, $2WFPf.default);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 h-auto gap-1 px-0 py-0 hover:bg-transparent justify-start",
        "data-testid": testId,
        disabled: disabled,
        "aria-pressed": !collapsed,
        onClick: onToggle,
        style: {
            color: collapsed ? (0, $jTCZr.C).textMuted : (0, $jTCZr.CT).accentInk
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 12,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 600
                },
                children: collapsed ? t('settings.visit.closedAtStart') : t('settings.visit.openAtStart')
            })
        ]
    });
};
/** «تب اول» — one tab per group opens the visit, so this is a radio. */ const $a70b43577d2dd015$var$FirstTabButton = ({ selected: selected, disabled: disabled, onSelect: onSelect, testId: testId, name: name })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.375rem',
            minHeight: '2.75rem',
            padding: '0 0.625rem',
            borderRadius: '0.5rem',
            border: `1.5px solid ${selected ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : 'transparent',
            color: selected ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary,
            fontSize: '0.6875rem',
            fontWeight: selected ? 700 : 600,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "radio",
                name: name,
                checked: selected,
                disabled: disabled,
                onChange: ()=>onSelect(),
                "data-testid": testId,
                style: {
                    accentColor: (0, $jTCZr.C).navy,
                    width: '0.875rem',
                    height: '0.875rem',
                    margin: 0
                }
            }),
            t('settings.visit.openFirst')
        ]
    });
};
function $a70b43577d2dd015$export$2e2bcd8739ae039({ settings: settings, onChange: onChange, onReset: onReset, testId: testId = 'settings-visit' }) {
    const { t: t } = (0, $LNQP4.default)();
    const [group, setGroup] = (0, $acw62.useState)('record');
    const layout = (0, $792124e2f7de719a$export$e88ad8319f3008b2)(settings);
    const pristine = (0, $792124e2f7de719a$export$4deb366eab2f1d1a)(settings);
    const apply = (0, $acw62.useCallback)((patch)=>{
        if (patch && Object.keys(patch).length) onChange(patch);
    }, [
        onChange
    ]);
    const sections = layout.recordSections;
    // ── Drag to reorder ────────────────────────────────────────────────────────
    //
    // Pointer Events, not HTML5 drag-and-drop: the latter does not exist on
    // touch. Rows in this list are one height, so the drop index is the offset in
    // whole rows — no per-row measuring, and no dependency.
    //
    // `drag` is {id, from, to, dy}. It is LOCAL until release: the list shows the
    // move while the finger is down and only then does one patch go to the
    // server, so a drag across four rows is one write, not four.
    const [drag, setDrag] = (0, $acw62.useState)(null);
    const rowHeightRef = (0, $acw62.useRef)(56);
    const startDrag = (0, $acw62.useCallback)((e, id, from)=>{
        const row = e.currentTarget.closest('[data-row]');
        if (row) rowHeightRef.current = row.getBoundingClientRect().height || 56;
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        setDrag({
            id: id,
            from: from,
            to: from,
            dy: 0,
            y0: e.clientY,
            pointerId: e.pointerId
        });
    }, []);
    const moveDrag = (0, $acw62.useCallback)((e)=>{
        setDrag((d)=>{
            if (!d || d.pointerId != null && e.pointerId !== d.pointerId) return d;
            const dy = e.clientY - d.y0;
            const steps = Math.round(dy / (rowHeightRef.current || 56));
            const to = Math.max(0, Math.min(sections.length - 1, d.from + steps));
            return {
                ...d,
                dy: dy,
                to: to
            };
        });
    }, [
        sections.length
    ]);
    const endDrag = (0, $acw62.useCallback)(()=>{
        setDrag((d)=>{
            if (d && d.to !== d.from) apply((0, $792124e2f7de719a$export$740573c0382b46de)(settings, d.id, d.to));
            return null;
        });
    }, [
        apply,
        settings
    ]);
    // Where a row sits while another is being dragged over it.
    const shiftFor = (0, $acw62.useCallback)((index)=>{
        if (!drag || index === drag.from) return 0;
        const h = rowHeightRef.current || 56;
        if (drag.from < drag.to && index > drag.from && index <= drag.to) return -h;
        if (drag.from > drag.to && index < drag.from && index >= drag.to) return h;
        return 0;
    }, [
        drag
    ]);
    // The keyboard path to the same reorder — ↑/↓ on the focused handle.
    const onHandleKeyDown = (0, $acw62.useCallback)((e, id, index)=>{
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        apply((0, $792124e2f7de719a$export$740573c0382b46de)(settings, id, index + (e.key === 'ArrowUp' ? -1 : 1)));
    }, [
        apply,
        settings
    ]);
    const groupItems = (0, $acw62.useMemo)(()=>[
            {
                id: 'record',
                label: t('settings.visit.record.short')
            },
            {
                id: 'work',
                label: t('settings.visit.work.short')
            },
            {
                id: 'copilot',
                label: t('settings.visit.copilot.short')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "tablist",
                "aria-label": t('settings.visit.title'),
                "data-testid": `${testId}-groups`,
                style: {
                    display: 'flex',
                    gap: '0.1875rem',
                    padding: '0.1875rem',
                    background: (0, $jTCZr.CT).surface2,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: '0.625rem',
                    marginBottom: '0.75rem'
                },
                children: groupItems.map((item)=>{
                    const on = group === item.id;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        role: "tab",
                        "aria-selected": on,
                        onClick: ()=>setGroup(item.id),
                        "data-testid": `${testId}-group-${item.id}`,
                        className: "flex-1 min-h-11 rounded-md px-1",
                        style: {
                            background: on ? (0, $jTCZr.C).card : 'transparent',
                            color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
                            fontWeight: on ? 700 : 600,
                            fontSize: '0.75rem',
                            boxShadow: on ? '0 1px 3px rgba(0,0,0,0.06)' : 'none'
                        },
                        children: item.label
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0 0 0.5rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7
                },
                children: group === 'record' ? t('settings.visit.record.hintMobile') : group === 'work' ? t('settings.visit.work.hint') : t('settings.visit.copilot.hint')
            }),
            group === 'record' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `${testId}-record`,
                children: sections.map((section, index)=>{
                    const lifted = drag?.id === section.id;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-row": true,
                        role: "group",
                        "aria-label": t(section.labelKey),
                        "data-testid": `${testId}-record-${section.id}`,
                        style: {
                            ...$a70b43577d2dd015$var$rowStyle(Boolean(drag), lifted),
                            transform: lifted ? `translateY(${drag.dy}px)` : `translateY(${shiftFor(index)}px)`,
                            zIndex: lifted ? 2 : 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                size: "icon",
                                className: "min-h-11 min-w-11 shrink-0 cursor-grab active:cursor-grabbing",
                                style: {
                                    touchAction: 'none',
                                    color: lifted ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted
                                },
                                "data-testid": `${testId}-record-${section.id}-handle`,
                                "aria-label": t('settings.visit.reorderAria', {
                                    title: t(section.labelKey)
                                }),
                                onPointerDown: (e)=>startDrag(e, section.id, index),
                                onPointerMove: moveDrag,
                                onPointerUp: endDrag,
                                onPointerCancel: endDrag,
                                onKeyDown: (e)=>onHandleKeyDown(e, section.id, index),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $661a253bb3c908f4$export$2e2bcd8739ae039), {
                                    size: 18,
                                    "aria-hidden": true
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.125rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            color: section.locked ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.C).textPrimary,
                                            opacity: section.visible ? 1 : 0.6,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: t(section.labelKey)
                                    }),
                                    section.visible ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.375rem',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            section.locked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '0.6875rem',
                                                    color: (0, $jTCZr.C).textMuted
                                                },
                                                children: t('settings.visit.alwaysShown')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$OpenStateButton, {
                                                collapsed: section.collapsed,
                                                testId: `${testId}-record-${section.id}-open`,
                                                onToggle: ()=>apply((0, $792124e2f7de719a$export$38f0593b6bfb6420)(settings, section.id, !section.collapsed))
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: t('settings.visit.hidden')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$ShowSwitch, {
                                testId: `${testId}-record-${section.id}-visible`,
                                label: t('settings.visit.showAria', {
                                    title: t(section.labelKey)
                                }),
                                checked: section.visible,
                                disabled: Boolean(section.locked),
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$276da83ac94a32f6)(settings, section.id, on))
                            })
                        ]
                    }, section.id);
                })
            }),
            group === 'work' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `${testId}-work`,
                children: layout.workTabs.map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t(tab.labelKey),
                        "data-testid": `${testId}-work-${tab.id}`,
                        style: $a70b43577d2dd015$var$rowStyle(false, false),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.125rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textPrimary,
                                            opacity: tab.visible ? 1 : 0.6
                                        },
                                        children: t(tab.labelKey)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: tab.locked ? t('settings.visit.alwaysShown') : tab.visible ? '' : t('settings.visit.hidden')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$FirstTabButton, {
                                name: `${testId}-work-default`,
                                selected: layout.defaultWorkTab === tab.id,
                                disabled: !tab.visible,
                                testId: `${testId}-work-${tab.id}-default`,
                                onSelect: ()=>apply((0, $792124e2f7de719a$export$aeba1cec85888be3)(settings, tab.id))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$ShowSwitch, {
                                testId: `${testId}-work-${tab.id}-visible`,
                                label: t('settings.visit.showAria', {
                                    title: t(tab.labelKey)
                                }),
                                checked: tab.visible,
                                disabled: Boolean(tab.locked),
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$7eeed700e5288c3)(settings, tab.id, on))
                            })
                        ]
                    }, tab.id))
            }),
            group === 'copilot' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": `${testId}-copilot`,
                children: layout.copilotTabs.map((tab)=>{
                    const lastVisible = tab.visible && layout.copilotTabs.filter((x)=>x.visible).length === 1;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t(tab.labelKey),
                        "data-testid": `${testId}-copilot-${tab.id}`,
                        style: $a70b43577d2dd015$var$rowStyle(false, false),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.125rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textPrimary,
                                            opacity: tab.visible ? 1 : 0.6
                                        },
                                        children: t(tab.labelKey)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: lastVisible ? t('settings.visit.lastTab') : tab.visible ? '' : t('settings.visit.hidden')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$FirstTabButton, {
                                name: `${testId}-copilot-default`,
                                selected: layout.defaultCopilotTab === tab.id,
                                disabled: !tab.visible,
                                testId: `${testId}-copilot-${tab.id}-default`,
                                onSelect: ()=>apply((0, $792124e2f7de719a$export$ceb766f504646314)(settings, tab.id))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a70b43577d2dd015$var$ShowSwitch, {
                                testId: `${testId}-copilot-${tab.id}-visible`,
                                label: t('settings.visit.showAria', {
                                    title: t(tab.labelKey)
                                }),
                                checked: tab.visible,
                                disabled: lastVisible,
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$fa98c16fa5ba5172)(settings, tab.id, on))
                            })
                        ]
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '0.75rem',
                    marginTop: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: pristine ? t('settings.visit.isDefault') : t('settings.visit.isCustom')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        className: "min-h-11 shrink-0",
                        disabled: pristine,
                        "data-testid": `${testId}-reset`,
                        onClick: ()=>onReset(),
                        children: t('settings.visit.resetShort')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0.75rem 0 0',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.04),
                    borderRadius: '0.5rem',
                    padding: '0.5rem 0.75rem'
                },
                children: t('settings.visit.safetyNote')
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9iIGe = parcelRequire("9iIGe");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");






var $acw62 = parcelRequire("acw62");


// «فایل‌ها» — the doctor's own upload settings, inside the «صفحه ویزیت» tab.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §7.5, §10.5, §23.3 A8, §24.3, §24.8.
//
// Every setting is TRI-STATE: «پیش‌فرض» (null — inherit from the clinic, then Parsina),
// «فعال», «غیرفعال». Unlike the visit toggles these are a FORM with a save bar: the size
// is a number the doctor types, and a limit half-typed is not a limit anyone asked for.
// Only the fields that changed are sent, named in the `mask`, so saving the size never
// rewrites a DICOM choice the doctor did not touch — and «پیش‌فرض» is sent as null WITH
// its field in the mask, which is how a stored value is cleared.
//
// Pure helpers are exported for the tests and so both surfaces read one meaning.
const $6fe5dd530b543980$var$MiB = 1048576;
const $6fe5dd530b543980$export$c4d2a0b4e906ba1a = Object.freeze([
    'inherit',
    'on',
    'off'
]);
const $6fe5dd530b543980$var$tri = (value)=>value == null ? 'inherit' : value ? 'on' : 'off';
const $6fe5dd530b543980$var$fromTri = (state)=>state === 'inherit' ? null : state === 'on';
function $6fe5dd530b543980$export$b5c3562a1bc5253d(settings) {
    const bytes = Number(settings?.maxFileBytes);
    return {
        sizeLimit: $6fe5dd530b543980$var$tri(settings?.sizeLimitEnabled),
        maxMb: Number.isFinite(bytes) && bytes > 0 ? String(Math.round(bytes / $6fe5dd530b543980$var$MiB * 10) / 10) : '',
        dicom: $6fe5dd530b543980$var$tri(settings?.dicomEnabled)
    };
}
const $6fe5dd530b543980$export$644da0e6744d4a2c = (form, saved)=>Object.keys(saved).some((k)=>String(form[k] ?? '') !== String(saved[k] ?? ''));
const $6fe5dd530b543980$export$c7266e02e534396d = (ceilings)=>Math.floor((Number(ceilings?.documentBytes) || 14 * $6fe5dd530b543980$var$MiB) / $6fe5dd530b543980$var$MiB);
function $6fe5dd530b543980$export$59f11973b46d1df3(form, ceilings) {
    const errors = {};
    if (form.sizeLimit === 'on') {
        const mb = Number(String(form.maxMb).replace(',', '.'));
        if (!String(form.maxMb).trim() || !Number.isFinite(mb) || mb <= 0) errors.maxMb = 'settings.files.errors.sizeRequired';
        else if (mb > $6fe5dd530b543980$export$c7266e02e534396d(ceilings)) errors.maxMb = 'settings.files.errors.aboveCeiling';
    }
    return errors;
}
function $6fe5dd530b543980$export$70b6b5e558f060fd(form, saved) {
    const input = {};
    const mask = [];
    if (form.sizeLimit !== saved.sizeLimit) {
        input.sizeLimitEnabled = $6fe5dd530b543980$var$fromTri(form.sizeLimit);
        mask.push('sizeLimitEnabled');
    }
    // The size means something only while the limit is on; turning the limit to
    // «پیش‌فرض» clears the doctor's own size too, so no stale number waits to resurface.
    const sizeTouched = form.maxMb !== saved.maxMb;
    if (form.sizeLimit === 'on' && (sizeTouched || form.sizeLimit !== saved.sizeLimit)) {
        input.maxFileBytes = Math.round(Number(String(form.maxMb).replace(',', '.')) * $6fe5dd530b543980$var$MiB);
        mask.push('maxFileBytes');
    } else if (form.sizeLimit === 'inherit' && form.sizeLimit !== saved.sizeLimit && saved.maxMb) {
        input.maxFileBytes = null;
        mask.push('maxFileBytes');
    }
    if (form.dicom !== saved.dicom) {
        input.dicomEnabled = $6fe5dd530b543980$var$fromTri(form.dicom);
        mask.push('dicomEnabled');
    }
    return {
        input: input,
        mask: mask
    };
}
function $6fe5dd530b543980$export$5700f9a384162d4d({ enabled: enabled = true } = {}) {
    const [settings, setSettings] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading');
    const [error, setError] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)(()=>$6fe5dd530b543980$export$b5c3562a1bc5253d(null));
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [saveError, setSaveError] = (0, $acw62.useState)(null);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        let cancelled = false;
        setStatus('loading');
        setError(null);
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $dec379065a898322$export$76c7df4da1e249d1), {}).then((d)=>{
            if (cancelled) return;
            const s = d?.myUploadSettings || null;
            setSettings(s);
            setForm($6fe5dd530b543980$export$b5c3562a1bc5253d(s));
            setStatus('content');
        }).catch((e)=>{
            if (!cancelled) {
                setError(e);
                setStatus('error');
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        attempt
    ]);
    const saved = (0, $acw62.useMemo)(()=>$6fe5dd530b543980$export$b5c3562a1bc5253d(settings), [
        settings
    ]);
    const dirty = status === 'content' && $6fe5dd530b543980$export$644da0e6744d4a2c(form, saved);
    const setField = (0, $acw62.useCallback)((key, value)=>{
        setForm((f)=>({
                ...f,
                [key]: value
            }));
        setErrors((e)=>e[key] ? {
                ...e,
                [key]: undefined
            } : e);
        setSaveError(null);
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        setForm(saved);
        setErrors({});
        setSaveError(null);
    }, [
        saved
    ]);
    const save = (0, $acw62.useCallback)(async ()=>{
        const next = $6fe5dd530b543980$export$59f11973b46d1df3(form, settings?.ceilings);
        if (Object.keys(next).length) {
            setErrors(next);
            return {
                ok: false
            };
        }
        const { input: input, mask: mask } = $6fe5dd530b543980$export$70b6b5e558f060fd(form, saved);
        if (!mask.length) return {
            ok: true,
            noop: true
        };
        setSaving(true);
        setSaveError(null);
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $dec379065a898322$export$15b6bccfe535d9ba), {
                input: input,
                mask: mask
            });
            const s = d?.updateMyUploadSettings || null;
            setSettings(s);
            setForm($6fe5dd530b543980$export$b5c3562a1bc5253d(s));
            return {
                ok: true
            };
        } catch (e) {
            setSaveError(e);
            return {
                ok: false,
                error: e
            };
        } finally{
            setSaving(false);
        }
    }, [
        form,
        saved,
        settings
    ]);
    return {
        settings: settings,
        status: status,
        error: error,
        retry: ()=>setAttempt((n)=>n + 1),
        form: form,
        errors: errors,
        setField: setField,
        dirty: dirty,
        reset: reset,
        save: save,
        saving: saving,
        saveError: saveError
    };
}
var $6fe5dd530b543980$export$2e2bcd8739ae039 = $6fe5dd530b543980$export$5700f9a384162d4d;


// «فایل‌ها» — rendered inside the «صفحه ویزیت» tab on both surfaces (§23.3 A8: a section,
// not a tab). The state and its save live in `useUploadSettings`, which the SCREEN owns,
// so the screen's own leave guard knows when there is something to lose.
//
// What it says, in order: the doctor's size limit (tri-state, the MB field disabled —
// not hidden — while the limit is not on, with the platform ceiling under it), whether
// DICOM uploads are on, and, read-only, what actually applies at each clinic: the
// effective limit, whether the clinic locked it, and where the value came from.
const $b26471698f489e74$var$sourceKey = (source)=>{
    const s = String(source || '').toLowerCase();
    if (s.startsWith('practitioner')) return 'settings.files.source.practitioner';
    if (s.startsWith('clinic')) return 'settings.files.source.clinic';
    if (s.startsWith('platform') || s === 'uploaders' || s.startsWith('kind')) return 'settings.files.source.platform';
    return null;
};
function $b26471698f489e74$export$2e2bcd8739ae039({ s: s, compact: compact = false, testid: testid = 'settings-files' }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (s.status === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": `${testid}-loading`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
            lines: 4
        })
    });
    if (s.status === 'error') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": `${testid}-error`,
        "data-state": "error",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
            error: s.error,
            title: t('settings.files.loadFailed'),
            onRetry: s.retry
        })
    });
    const ceilings = s.settings?.ceilings;
    const triItems = (field)=>(0, $6fe5dd530b543980$export$c4d2a0b4e906ba1a).map((id)=>({
                id: id,
                label: t(`settings.files.${field}.${id}`)
            }));
    const clinics = s.settings?.clinics || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testid,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: compact ? '1rem' : '1.25rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            margin: 0,
                            fontSize: '0.8125rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.CT).ink
                        },
                        children: t('settings.files.sizeLimit.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.CT).mute,
                            lineHeight: 1.8
                        },
                        children: t('settings.files.sizeLimit.hint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                        items: triItems('sizeLimit'),
                        value: s.form.sizeLimit,
                        onChange: (v)=>s.setField('sizeLimit', v),
                        size: "sm",
                        ariaLabel: t('settings.files.sizeLimit.title'),
                        testId: `${testid}-size-limit`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            maxWidth: compact ? 'none' : '16rem'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iIGe.default), {
                            label: t('settings.files.maxSize'),
                            value: s.form.maxMb,
                            onChange: (v)=>s.setField('maxMb', typeof v === 'string' || typeof v === 'number' ? String(v) : v?.target?.value ?? ''),
                            unit: t('settings.files.mb'),
                            min: 1,
                            max: (0, $6fe5dd530b543980$export$c7266e02e534396d)(ceilings),
                            disabled: s.form.sizeLimit !== 'on',
                            error: s.errors.maxMb ? t(s.errors.maxMb, {
                                max: formatNumber((0, $6fe5dd530b543980$export$c7266e02e534396d)(ceilings))
                            }) : undefined,
                            helperText: t('settings.files.ceiling', {
                                mb: formatNumber((0, $6fe5dd530b543980$export$c7266e02e534396d)(ceilings))
                            }),
                            "data-testid": `${testid}-max-size`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            margin: 0,
                            fontSize: '0.8125rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.CT).ink
                        },
                        children: t('settings.files.dicom.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.CT).mute,
                            lineHeight: 1.8
                        },
                        children: t('settings.files.dicom.hint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                        items: triItems('dicom'),
                        value: s.form.dicom,
                        onChange: (v)=>s.setField('dicom', v),
                        size: "sm",
                        ariaLabel: t('settings.files.dicom.title'),
                        testId: `${testid}-dicom`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "data-testid": `${testid}-clinics`,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            margin: 0,
                            fontSize: '0.8125rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.CT).ink
                        },
                        children: t('settings.files.clinics.title')
                    }),
                    clinics.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-testid": `${testid}-clinics-empty`,
                        style: {
                            margin: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.CT).mute
                        },
                        children: t('settings.files.clinics.empty')
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        style: {
                            margin: 0,
                            padding: 0,
                            listStyle: 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.375rem'
                        },
                        children: clinics.map((c)=>{
                            const src = (c.sources || []).find((x)=>x.field === 'maxFileBytes' || x.field === 'max_file_bytes') || (c.sources || []).find((x)=>x.field === 'sizeLimitEnabled' || x.field === 'size_limit_enabled');
                            const srcKey = $b26471698f489e74$var$sourceKey(src?.source);
                            const overridden = c.locked && s.form.sizeLimit === 'off' && c.sizeLimitEnabled;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                "data-testid": `${testid}-clinic-${c.clinicId}`,
                                "data-locked": c.locked || undefined,
                                style: {
                                    borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
                                    border: `1px solid ${(0, $jTCZr.CT).border}`,
                                    padding: '0.5rem 0.75rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                dir: "auto",
                                                style: {
                                                    fontSize: '0.8125rem',
                                                    fontWeight: 600,
                                                    color: (0, $jTCZr.CT).ink,
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: c.clinicName || t('settings.files.clinics.unnamed')
                                            }),
                                            c.locked && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b2efaf4152cb92eb$export$ba419c27a5974bb1), {
                                                tone: "warn",
                                                "data-testid": `${testid}-clinic-${c.clinicId}-locked`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                                        size: 11,
                                                        "aria-hidden": true
                                                    }),
                                                    " ",
                                                    t('settings.files.clinics.locked')
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.CT).ink2
                                        },
                                        "data-testid": `${testid}-clinic-${c.clinicId}-effective`,
                                        children: [
                                            c.sizeLimitEnabled ? t('settings.files.clinics.limit', {
                                                mb: formatNumber((0, $2dcdf1c1963f00da$export$d56bb2ab6cd19776)(c.maxFileBytes))
                                            }) : t('settings.files.clinics.noLimit', {
                                                mb: formatNumber((0, $6fe5dd530b543980$export$c7266e02e534396d)(ceilings))
                                            }),
                                            srcKey && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: (0, $jTCZr.CT).mute
                                                },
                                                children: [
                                                    " \xb7 ",
                                                    t(srcKey)
                                                ]
                                            })
                                        ]
                                    }),
                                    overridden && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.CT).warnInk
                                        },
                                        "data-testid": `${testid}-clinic-${c.clinicId}-overridden`,
                                        children: t('settings.files.clinics.overridden')
                                    })
                                ]
                            }, c.clinicId);
                        })
                    })
                ]
            }),
            s.saveError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                "data-testid": `${testid}-save-error`,
                children: (0, $2dcdf1c1963f00da$export$d4b677401f6be1f8)(t, has, s.saveError, 'settings.files.saveFailed')
            }),
            s.dirty && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": `${testid}-savebar`,
                style: {
                    display: 'flex',
                    gap: '0.5rem',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                    paddingTop: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: s.reset,
                        disabled: s.saving,
                        className: compact ? 'min-h-11' : undefined,
                        "data-testid": `${testid}-reset`,
                        children: t('settings.files.discard')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        onClick: s.save,
                        disabled: s.saving,
                        className: compact ? 'min-h-11' : undefined,
                        "data-testid": `${testid}-save`,
                        children: s.saving ? t('common.state.saving') : t('common.actions.save')
                    })
                ]
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $065138bcfb23653d$export$2e2bcd8739ae039({ value: value, onChange: onChange, testId: testId = 'settings-language-picker' }) {
    const { t: t, locales: locales, preloadLocale: preloadLocale } = (0, $LNQP4.default)();
    const refs = (0, $acw62.useRef)({});
    const options = Object.values(locales);
    const isRTLLayout = document?.documentElement?.getAttribute('dir') === 'rtl';
    const onKeyDown = (e)=>{
        const keys = [
            'ArrowRight',
            'ArrowLeft',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
        ];
        if (!keys.includes(e.key)) return;
        e.preventDefault();
        const i = options.findIndex((o)=>o.id === value);
        const current = i === -1 ? 0 : i;
        // The arrows follow what the doctor SEES, so which one advances depends on
        // the direction the list is currently laid out in — not on the array order.
        const forward = isRTLLayout ? e.key === 'ArrowLeft' || e.key === 'ArrowDown' : e.key === 'ArrowRight' || e.key === 'ArrowDown';
        const step = forward ? 1 : -1;
        let next;
        if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = options.length - 1;
        else next = (current + step + options.length) % options.length;
        const id = options[next].id;
        onChange(id);
        refs.current[id]?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "radiogroup",
        "aria-label": t('settings.language.pickerLabel'),
        "data-testid": testId,
        onKeyDown: onKeyDown,
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(200px, 100%), 1fr))',
            gap: 12
        },
        children: options.map((option)=>{
            const selected = option.id === value;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                ref: (el)=>{
                    refs.current[option.id] = el;
                },
                type: "button",
                role: "radio",
                "aria-checked": selected,
                tabIndex: selected ? 0 : -1,
                "data-testid": `${testId}-option-${option.id}`,
                onClick: ()=>onChange(option.id),
                onFocus: ()=>preloadLocale(option.id),
                onMouseEnter: ()=>preloadLocale(option.id),
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    minHeight: 56,
                    padding: '10px 14px',
                    borderRadius: 10,
                    cursor: 'pointer',
                    textAlign: 'start',
                    background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.C).card,
                    border: `1.5px solid ${selected ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                    boxShadow: selected ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.13)}` : 'none',
                    transition: 'border-color .15s, box-shadow .15s, background .15s'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        dir: "ltr",
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: 9,
                            flexShrink: 0,
                            display: 'grid',
                            placeItems: 'center',
                            background: selected ? (0, $jTCZr.C).navy : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                            color: selected ? '#fff' : (0, $jTCZr.C).navy,
                            fontSize: 12,
                            fontWeight: 800,
                            letterSpacing: 0.5,
                            textTransform: 'uppercase'
                        },
                        children: option.id
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        dir: option.dir,
                        style: {
                            flex: 1,
                            minWidth: 0,
                            textAlign: 'start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    fontSize: 14,
                                    fontWeight: selected ? 700 : 600,
                                    color: selected ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary
                                },
                                children: option.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    fontSize: 11,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginTop: 2
                                },
                                children: t(`settings.language.names.${option.id}`)
                            })
                        ]
                    }),
                    selected && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        width: 16,
                        height: 16,
                        fill: (0, $jTCZr.C).navy,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        })
                    })
                ]
            }, option.id);
        })
    });
}



parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// The appearance pickers' copy.
//
// `THEME_PRESETS` and `FONT_SIZES` live in `@parsina/framework/tokens`, where
// they are DATA: an id, a swatch, a type scale. Each row also carries a `label`,
// and that label is Persian — the kit is installed by panels that ship Persian
// only, so that is the right default for it to hold.
//
// Rendering that label verbatim is what put «آبی پارسینا» and «کوچک» on the
// English settings screen. The ids are stable and the catalogue keys on them,
// so the fix is to look the name up here and fall back to whatever the kit
// supplied for a preset this app has no key for.
//
// Both surfaces use these, which is the point: the web and mobile forks must
// not be able to disagree about what an accent is called.
/**
 * @param {{t: Function, has: Function}} i18n  from `useTranslation()`
 * @param {Array<{id: string, label?: string}>} presets  kit rows
 */ function $489a2602878be6c3$export$3458b2021f2b4be4({ t: t, has: has }, presets = []) {
    return presets.map((preset)=>{
        const key = `settings.appearance.themes.${preset.id}`;
        return has(key) ? {
            ...preset,
            label: t(key)
        } : preset;
    });
}
function $489a2602878be6c3$export$1be7054c02e16140({ t: t, has: has }, sizes = []) {
    return sizes.map((size)=>{
        const key = `settings.appearance.fontSizes.${size.id}`;
        return has(key) ? {
            ...size,
            label: t(key)
        } : size;
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");

var $fzlbJ = parcelRequire("fzlbJ");
var $lpOUO = parcelRequire("lpOUO");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// Changing the profile picture, from the device that has a camera (finding 14).
//
// Avatar capture was desktop-only: the phone showed the picture and offered no
// way to change it, which is backwards — the camera is the thing the phone HAS
// and the desktop does not. A doctor wanting their own photo on their own
// profile had to find a laptop.
//
// `capture="environment"` on a file input is the whole mechanism: iOS and
// Android both read it as «take a photo», and a browser without a camera falls
// back to the picker on its own. Two inputs rather than one, because a single
// input with `capture` set NEVER offers the gallery on iOS, and «انتخاب از
// گالری» is the more common of the two.
//
// The crop step is the SAME `AvatarCropModal` the desktop uses — the picture
// that reaches the record must be framed the same way whichever surface sent
// it, and a phone-only crop would be a second opinion about that.
// ─────────────────────────────────────────────────────────────────────────────
const $94bf4f3832dae279$var$Row = ({ Icon: Icon, label: label, onClick: onClick, testId: testId, destructive: destructive })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onClick,
        "data-testid": testId,
        className: "h-auto min-h-11 w-full justify-start gap-3 rounded-lg px-3 py-3",
        style: {
            color: destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).textPrimary
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 18,
                "aria-hidden": true,
                style: {
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600
                },
                children: label
            })
        ]
    });
const $94bf4f3832dae279$var$MobileAvatarSheet = ({ open: open, onClose: onClose, onPick: onPick, onRemove: onRemove, hasAvatar: hasAvatar })=>{
    const { t: t } = (0, $LNQP4.default)();
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const galleryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const handle = (e)=>{
        const file = e.target.files?.[0];
        // Reset first: picking the SAME file twice must fire `change` again, and it
        // will not while the input still holds it.
        e.target.value = '';
        if (file) onPick(file);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('settings.avatar.change'),
        closeLabel: t('common.actions.close'),
        "data-testid": "settings-avatar-sheet",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.25rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94bf4f3832dae279$var$Row, {
                        Icon: (0, $fzlbJ.default),
                        label: t('settings.avatar.takePhoto'),
                        onClick: ()=>cameraRef.current?.click(),
                        testId: "settings-avatar-camera"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($94bf4f3832dae279$var$Row, {
                        Icon: (0, $272fea46916dddb1$export$2e2bcd8739ae039),
                        label: t('settings.avatar.chooseFromGallery'),
                        onClick: ()=>galleryRef.current?.click(),
                        testId: "settings-avatar-gallery"
                    }),
                    hasAvatar && /*#__PURE__*/ (0, $ayMG0.jsx)($94bf4f3832dae279$var$Row, {
                        Icon: (0, $lpOUO.default),
                        label: t('settings.avatar.remove'),
                        onClick: onRemove,
                        testId: "settings-avatar-remove",
                        destructive: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: cameraRef,
                type: "file",
                accept: "image/jpeg,image/png",
                capture: "environment",
                onChange: handle,
                style: {
                    display: 'none'
                },
                "data-testid": "settings-avatar-camera-input"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: galleryRef,
                type: "file",
                accept: "image/jpeg,image/png",
                onChange: handle,
                style: {
                    display: 'none'
                },
                "data-testid": "settings-avatar-gallery-input"
            })
        ]
    });
};
var $94bf4f3832dae279$export$2e2bcd8739ae039 = $94bf4f3832dae279$var$MobileAvatarSheet;




var $jTCZr = parcelRequire("jTCZr");

var $eLeza = parcelRequire("eLeza");

// ─────────────────────────────────────────────────────────────────────────────
// The settings sections this deployment offers. The registry is the kit's
// (Settings.shared.js SECTIONS); which of them a market has is the panel's call.
//
// «نسخه» is Iranian through and through — what a visit bills as is the RVU3 visit
// code, read against the doctor's degree in the Iranian medical council's
// register — so outside the Iranian market (`market: 'intl'`,
// docs/rebranding/CONTRACT.md) the tab is not offered, and an address naming it
// lands on the default section like any unknown one. In the Iranian market, and
// with no brand at all, this is SECTIONS itself.
// ─────────────────────────────────────────────────────────────────────────────
const $07cb4ea47e0548b5$var$IRAN_ONLY_SECTIONS = [
    'prescription'
];
function $07cb4ea47e0548b5$export$c5900652ccdb0c23() {
    return (0, $eLeza.isIranMarket)() ? (0, $2d58c73a38525204$export$5ff47a1a5df62032) : (0, $2d58c73a38525204$export$5ff47a1a5df62032).filter((s)=>!$07cb4ea47e0548b5$var$IRAN_ONLY_SECTIONS.includes(s.id));
}
const $07cb4ea47e0548b5$export$e0cbd71c1867bb72 = (id)=>(0, $2d58c73a38525204$export$d5df8095c82b1b1a)(id) && $07cb4ea47e0548b5$export$c5900652ccdb0c23().some((s)=>s.id === id);



var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




const $b072c75c8fe44102$export$42820425a125e053 = `
  query TranscriptionEngines {
    transcriptionEngines { engine available reason }
  }
`;
// The closed set the AI service and the BFF report (speech_engines.py).
const $b072c75c8fe44102$var$KNOWN_REASONS = new Set([
    'not_configured',
    'disabled',
    'rejected',
    'model_missing',
    'unreachable',
    'service_unavailable'
]);
const $b072c75c8fe44102$var$PRICE_ACTION = {
    parsina: 'TRANSCRIPTION_PARSINA_PER_MIN',
    assistant: 'TRANSCRIPTION_PER_MIN'
};
function $b072c75c8fe44102$var$useEngineStatuses() {
    const [byEngine, setByEngine] = (0, $acw62.useState)(null); // null = not known yet
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        // Wrapped so a client that returns nothing (a test double) is a failed
        // read, not a thrown effect.
        Promise.resolve().then(()=>(0, $adebb901af88e18b$export$7fb4864174f056c)($b072c75c8fe44102$export$42820425a125e053)).then((res)=>{
            if (!alive) return;
            const map = {};
            (res?.transcriptionEngines || []).forEach((e)=>{
                map[e.engine] = e;
            });
            setByEngine(map);
        }).catch(()=>{
            if (alive) setByEngine({});
        });
        return ()=>{
            alive = false;
        };
    }, []);
    return byEngine;
}
function $b072c75c8fe44102$var$StatusChip({ tone: tone, children: children, testId: testId }) {
    const ink = tone === 'good' ? (0, $jTCZr.CT).goodInk : tone === 'warn' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0,
            padding: '1px 8px',
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1.7,
            color: ink,
            background: (0, $jTCZr.soft)(ink, 0.10),
            border: `1px solid ${(0, $jTCZr.soft)(ink, 0.25)}`
        }
    }, children);
}
function $b072c75c8fe44102$export$2e2bcd8739ae039({ ai: ai, onChange: onChange, disabled: disabled = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { costOf: costOf } = (0, $121df138798ec781$export$204bd72286fdb787)();
    const statuses = $b072c75c8fe44102$var$useEngineStatuses();
    const value = (0, $33deae5c7ec89d7f$export$e976735e46efaec2)(ai);
    const browserOk = (0, $33deae5c7ec89d7f$export$27c418303ede0f96)();
    const statusFor = (engine)=>{
        if (engine === (0, $33deae5c7ec89d7f$export$14e406b759a48fe6)) return browserOk ? null : {
            tone: 'warn',
            text: t('settings.ai.speech.status.browserUnsupported')
        };
        if (engine !== (0, $33deae5c7ec89d7f$export$303b337dd3fdcd5e)) return null;
        if (statuses === null) return {
            tone: 'muted',
            text: t('settings.ai.speech.status.checking')
        };
        const s = statuses[engine];
        if (s?.available) return {
            tone: 'good',
            text: t('settings.ai.speech.status.ready')
        };
        return {
            tone: 'warn',
            text: t('settings.ai.speech.status.unavailable')
        };
    };
    const priceFor = (engine)=>{
        if (engine === (0, $33deae5c7ec89d7f$export$14e406b759a48fe6)) return t('settings.ai.speech.free');
        return t('settings.ai.speech.perMinute', {
            cost: (0, $2a90b979c3d41f86$export$b634cc5d06849b0a)(costOf($b072c75c8fe44102$var$PRICE_ACTION[engine]), formatNumber)
        });
    };
    const parsinaDown = statuses !== null && !statuses[0, $33deae5c7ec89d7f$export$303b337dd3fdcd5e]?.available;
    const parsinaReason = statuses?.[0, $33deae5c7ec89d7f$export$303b337dd3fdcd5e]?.reason;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "radiogroup",
        "aria-label": t('settings.ai.speech.title'),
        "data-testid": "settings-ai-speechEngine",
        "data-value": value,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, (0, $33deae5c7ec89d7f$export$b9da910a30b0dc48).map((engine)=>{
        const checked = value === engine;
        const status = statusFor(engine);
        const id = `settings-ai-speechEngine-${engine}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            key: engine,
            htmlFor: id,
            "data-testid": id,
            "data-checked": checked ? 'true' : 'false',
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 10,
                cursor: disabled ? 'default' : 'pointer',
                padding: '10px 12px',
                borderRadius: 10,
                minHeight: 44,
                border: `1px solid ${checked ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                background: checked ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.C).card,
                opacity: disabled ? 0.6 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            id: id,
            type: "radio",
            name: "settings-ai-speechEngine",
            value: engine,
            checked: checked,
            disabled: disabled,
            onChange: ()=>onChange(engine),
            style: {
                marginTop: 3,
                accentColor: (0, $jTCZr.C).navy,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 13,
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, t(`settings.ai.speech.engines.${engine}.label`)), engine === (0, $33deae5c7ec89d7f$export$a94ba151bfc9b67a) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b072c75c8fe44102$var$StatusChip, {
            tone: "muted",
            testId: `${id}-default`
        }, t('settings.ai.speech.default')), status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b072c75c8fe44102$var$StatusChip, {
            tone: status.tone,
            testId: `${id}-status`
        }, status.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                marginTop: 2,
                fontSize: 12,
                lineHeight: 1.7,
                color: (0, $jTCZr.C).textSecondary
            }
        }, t(`settings.ai.speech.engines.${engine}.description`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                marginTop: 2,
                fontSize: 11,
                color: (0, $jTCZr.C).textMuted
            }
        }, priceFor(engine))));
    }), value === (0, $33deae5c7ec89d7f$export$303b337dd3fdcd5e) && parsinaDown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "settings-ai-speechEngine-fallback",
        style: {
            fontSize: 12,
            lineHeight: 1.7,
            color: (0, $jTCZr.CT).warnInk,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.08),
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.25)}`
        }
    }, t('settings.ai.speech.fallbackNote'), $b072c75c8fe44102$var$KNOWN_REASONS.has(parsinaReason) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", t(`settings.ai.speech.reasons.${parsinaReason}`))), value === (0, $33deae5c7ec89d7f$export$14e406b759a48fe6) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-ai-speechEngine-browserNote",
        style: {
            fontSize: 12,
            lineHeight: 1.7,
            color: (0, $jTCZr.C).textMuted
        }
    }, browserOk ? t('settings.ai.speech.browserAmbientNote') : t('settings.ai.speech.browserFallbackNote')));
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $3GEBR = parcelRequire("3GEBR");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// تنظیمات → «نسخه»: the doctor half of the RVU3 visit code (K1, 2026-10-04) —
// the highest degree, the psychiatry/pediatrics group, تمام‌وقت, a GP's fifteen
// years. Filled from سازمان نظام پزشکی at onboarding; the doctor confirms or
// corrects it here.
//
// The closed lists mirror the doctor BFF's src/lib/visitCode.js, which
// validates them. The codes themselves are computed there and arrive as
// `visitCodes`, so no tariff code lives in this file.
/** In the order the select offers them: physicians, then dentists, then the rest. */ const $878c2f5c71d659d9$export$595e62206753b23b = [
    'GP',
    'SPECIALIST',
    'SUBSPECIALIST',
    'FELLOWSHIP',
    'MD_PHD',
    'DENTIST_GP',
    'DENTIST_SPECIALIST',
    'PHD',
    'MASTERS',
    'BACHELORS'
];
const $878c2f5c71d659d9$export$86e2f7f226b6d8ef = [
    'PSYCHIATRY',
    'PEDIATRICS'
];
// The levels each control means something for. A control that cannot change
// the code is not shown: a GP has no psychiatry line, a specialist no fifteen years.
const $878c2f5c71d659d9$var$GROUPED = new Set([
    'SPECIALIST',
    'SUBSPECIALIST',
    'FELLOWSHIP'
]);
const $878c2f5c71d659d9$export$6358111a56b42eaa = (level)=>$878c2f5c71d659d9$var$GROUPED.has(level);
const $878c2f5c71d659d9$export$bb7e85ce7e7165f8 = (level)=>level === 'GP';
const $878c2f5c71d659d9$export$b83cf6a9bd20282c = (settings)=>(settings?.visitCodes?.length || 0) > 0;
const $878c2f5c71d659d9$var$FIELDS = `degreeLevel specialtyGroup fullTime gpOver15Years degreeSource registryDegrees registerVisit
    visitCodes { ageBand electronic code name }`;
const $878c2f5c71d659d9$export$3f343be7551530c6 = `query MyPrescriptionSettings {
  myPrescriptionSettings { ${$878c2f5c71d659d9$var$FIELDS} }
}`;
const $878c2f5c71d659d9$export$8b5c256ce991c295 = `mutation UpdatePrescriptionSettings($input: PrescriptionSettingsInput!) {
  updatePrescriptionSettings(input: $input) { ${$878c2f5c71d659d9$var$FIELDS} }
}`;
function $878c2f5c71d659d9$export$77c97545ee4156ca(settings, patch) {
    const next = {
        ...settings || {}
    };
    if ('degreeLevel' in patch) next.degreeLevel = patch.degreeLevel || null;
    if ('specialtyGroup' in patch) next.specialtyGroup = patch.specialtyGroup || null;
    if ('fullTime' in patch) next.fullTime = !!patch.fullTime;
    if ('gpOver15Years' in patch) next.gpOver15Years = !!patch.gpOver15Years;
    if ('registerVisit' in patch) next.registerVisit = !!patch.registerVisit;
    if ('degreeLevel' in patch || 'specialtyGroup' in patch) next.degreeSource = 'DOCTOR';
    return next;
}


function $4651f370f717da40$export$3f7f61c7dd511b6f() {
    const [settings, setSettings] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading'); // loading | ready | error
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [saveFailed, setSaveFailed] = (0, $acw62.useState)(false);
    const alive = (0, $acw62.useRef)(true);
    const confirmed = (0, $acw62.useRef)(null);
    const queue = (0, $acw62.useRef)(Promise.resolve());
    const pending = (0, $acw62.useRef)(0);
    const load = (0, $acw62.useCallback)(()=>{
        setStatus('loading');
        // Wrapped so a client that returns nothing (a test double) is a failed
        // read, not a thrown effect.
        return Promise.resolve().then(()=>(0, $adebb901af88e18b$export$7fb4864174f056c)((0, $878c2f5c71d659d9$export$3f343be7551530c6))).then((d)=>{
            const s = d?.myPrescriptionSettings;
            if (!s) throw new Error('no settings');
            if (!alive.current) return;
            confirmed.current = s;
            setSettings(s);
            setStatus('ready');
        }).catch(()=>{
            if (alive.current) setStatus('error');
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        alive.current = true;
        load();
        return ()=>{
            alive.current = false;
        };
    }, [
        load
    ]);
    const save = (0, $acw62.useCallback)((patch)=>{
        setSaveFailed(false);
        setSettings((s)=>(0, $878c2f5c71d659d9$export$77c97545ee4156ca)(s, patch));
        setSaving(true);
        pending.current += 1;
        const run = queue.current.then(()=>(0, $adebb901af88e18b$export$8395d0fc0d822a81)((0, $878c2f5c71d659d9$export$8b5c256ce991c295), {
                input: patch
            })).then((d)=>{
            const next = d?.updatePrescriptionSettings;
            if (!next) throw new Error('no answer');
            confirmed.current = next;
        }).catch(()=>{
            if (alive.current) setSaveFailed(true);
        }).finally(()=>{
            pending.current -= 1;
            if (!alive.current || pending.current > 0) return;
            setSettings(confirmed.current);
            setSaving(false);
        });
        queue.current = run;
        return run;
    }, []);
    return {
        settings: settings,
        status: status,
        saving: saving,
        saveFailed: saveFailed,
        reload: load,
        save: save
    };
}
const $4651f370f717da40$var$muted = {
    fontSize: 12,
    color: (0, $jTCZr.C).textMuted,
    lineHeight: 1.7
};
function $4651f370f717da40$var$VisitCodes({ cases: cases, saving: saving }) {
    const { t: t } = (0, $LNQP4.default)();
    // The default band is named against the child band the family has: «۱۰ سال و
    // بالاتر» beside a pediatric group's «زیر ۱۰ سال» (978000), and every patient
    // when there is none. «بزرگسال» would be wrong for a twelve-year-old. Whether
    // the visit carries an e-prescription no longer changes the code, so it is not
    // shown.
    const childBand = cases?.find((c)=>c.ageBand !== 'ADULT')?.ageBand;
    const bandLabel = (band)=>band === 'ADULT' ? t(`settings.prescription.case.ADULT_${childBand || 'ALL'}`) : t(`settings.prescription.case.${band}`);
    if (!cases?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription-no-code",
        style: $4651f370f717da40$var$muted
    }, t('settings.prescription.noCode'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription-codes",
        "aria-busy": saving ? 'true' : undefined,
        style: {
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 10,
            overflow: 'hidden',
            opacity: saving ? 0.55 : 1,
            transition: 'opacity 120ms'
        }
    }, cases.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: c.ageBand,
            "data-testid": `settings-prescription-code-${c.ageBand}`,
            style: {
                display: 'grid',
                gridTemplateColumns: 'minmax(9rem, auto) auto 1fr',
                alignItems: 'baseline',
                columnGap: 12,
                padding: '7px 12px',
                fontSize: 12.5,
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none',
                background: i === 0 ? (0, $jTCZr.C).bg : 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).ink2
            }
        }, bandLabel(c.ageBand)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate',
                userSelect: 'all',
                fontVariantNumeric: 'tabular-nums'
            }
        }, c.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.C).textSecondary,
                minWidth: 0
            }
        }, c.name))));
}
function $4651f370f717da40$export$663e0bacb003bc3d() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription-loading",
        "aria-busy": "true",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 44,
        radius: 8,
        style: {
            maxWidth: 320
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 14,
        style: {
            maxWidth: 260
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 96,
        radius: 10
    }));
}
function $4651f370f717da40$export$2e2bcd8739ae039({ compact: compact = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const { settings: settings, status: status, saving: saving, saveFailed: saveFailed, reload: reload, save: save } = $4651f370f717da40$export$3f7f61c7dd511b6f();
    if (!settings && status !== 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4651f370f717da40$export$663e0bacb003bc3d, null);
    if (!settings) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "settings-prescription-error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: (0, $jTCZr.C).textSecondary
        }
    }, t('settings.prescription.unavailable')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "outline",
        onClick: reload,
        "data-testid": "settings-prescription-retry"
    }, t('settings.prescription.retry')));
    const level = settings.degreeLevel || '';
    const source = settings.degreeSource;
    const sourceHint = source === 'REGISTRY' ? t('settings.prescription.source.REGISTRY') : source === 'DOCTOR' ? t('settings.prescription.source.DOCTOR') : t('settings.prescription.source.none');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription",
        "data-level": level || 'unknown',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 14,
            alignItems: 'start',
            gridTemplateColumns: compact ? '1fr' : 'repeat(auto-fit, minmax(240px, 1fr))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        id: "settings-prescription-degree",
        "data-testid": "settings-prescription-degree",
        label: t('settings.prescription.degreeLabel'),
        placeholder: t('settings.prescription.degreeUnknown'),
        helperText: sourceHint,
        value: level,
        options: (0, $878c2f5c71d659d9$export$595e62206753b23b).map((l)=>({
                value: l,
                label: t(`settings.prescription.degree.${l}`)
            })),
        onChange: (e)=>save({
                degreeLevel: e.target.value
            })
    }), (0, $878c2f5c71d659d9$export$6358111a56b42eaa)(level) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        id: "settings-prescription-group",
        "data-testid": "settings-prescription-group",
        label: t('settings.prescription.groupLabel'),
        // The «every other field» choice IS the empty value — no placeholder row.
        placeholder: null,
        helperText: t('settings.prescription.groupHint'),
        value: settings.specialtyGroup || '',
        options: [
            {
                value: '',
                label: t('settings.prescription.group.NONE')
            },
            ...(0, $878c2f5c71d659d9$export$86e2f7f226b6d8ef).map((g)=>({
                    value: g,
                    label: t(`settings.prescription.group.${g}`)
                }))
        ],
        onChange: (e)=>save({
                specialtyGroup: e.target.value
            })
    })), settings.registryDegrees?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription-registry",
        style: $4651f370f717da40$var$muted
    }, t('settings.prescription.registryDegrees'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.C).textSecondary
        }
    }, settings.registryDegrees.join(" \xb7 "))), (0, $878c2f5c71d659d9$export$bb7e85ce7e7165f8)(level) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3GEBR.default), {
        id: "settings-prescription-gpOver15Years",
        "data-testid": "settings-prescription-gpOver15Years",
        label: t('settings.prescription.gpOver15'),
        description: t('settings.prescription.gpOver15Hint'),
        checked: !!settings.gpOver15Years,
        onChange: (v)=>save({
                gpOver15Years: v
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('settings.prescription.codesTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4651f370f717da40$var$VisitCodes, {
        cases: settings.visitCodes,
        saving: saving
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $4651f370f717da40$var$muted
    }, t('settings.prescription.codesHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "settings-prescription-register-visit",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            padding: '10px 12px',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        id: "settings-prescription-registerVisit",
        "data-testid": "settings-prescription-registerVisit",
        checked: !!settings.registerVisit,
        disabled: !(0, $878c2f5c71d659d9$export$b83cf6a9bd20282c)(settings) && !settings.registerVisit,
        onChange: (v)=>save({
                registerVisit: !!v
            }),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 13,
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, t('settings.prescription.registerVisit'))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$4651f370f717da40$var$muted,
            paddingInlineStart: 26
        }
    }, (0, $878c2f5c71d659d9$export$b83cf6a9bd20282c)(settings) ? t('settings.prescription.registerVisitHint') : t('settings.prescription.registerVisitNeedsCode'))), saveFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "settings-prescription-save-error",
        style: {
            fontSize: 12,
            color: (0, $jTCZr.C).red
        }
    }, t('settings.prescription.saveFailed')));
}


// ─────────────────────────────────────────────────────────────────────────────
// Settings — mobile (DESIGN-CONCEPT-MOBILE v2).
//
// A platform fork, not a narrowed desktop page: gradient header, a sticky
// section strip, one page-level scroll, and editing that happens in a
// BottomSheet with a docked submit rather than in a long inline form behind a
// sticky nav (§6). Behaviour is the shared `useSettingsForm` the desktop screen
// uses, so the two surfaces can look nothing alike but never disagree.
// ─────────────────────────────────────────────────────────────────────────────
// Passwords and codes are ASCII runs: they read left-to-right whatever the
// layout does. `isolate` keeps neighbouring punctuation from being dragged
// across the field.
const $530deeb725d14950$var$LTR = {
    direction: 'ltr',
    unicodeBidi: 'isolate'
};
function $530deeb725d14950$export$2e2bcd8739ae039() {
    const s = (0, $9585130d255ed442$export$c1629e185843c96d)();
    const { t: t, has: has, dir: dir, locale: locale, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const themePresets = (0, $489a2602878be6c3$export$3458b2021f2b4be4)({
        t: t,
        has: has
    }, (0, $jTCZr.THEME_PRESETS));
    const fontSizes = (0, $489a2602878be6c3$export$1be7054c02e16140)({
        t: t,
        has: has
    }, (0, $jTCZr.FONT_SIZES));
    // Unlike the vital-sign thresholds — which this surface deliberately leaves
    // to the desktop — the re-assessment cadence is a pick from a short list, not
    // a number to type, so it works on a phone as well as it does on a monitor.
    const autoDiffArmed = s.ai.autoDifferentialOnStart !== false;
    const pollArmed = autoDiffArmed && s.ai.differentialPollingEnabled !== false;
    // The thresholds mean nothing while both alarms are off — same rule the
    // desktop card applies, read from the same helper.
    const alertsArmed = (0, $2d58c73a38525204$export$b18cfe9ad6d2d648)(s.ai);
    const pollOptions = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$7c8e7f6b23543e69).map((sec)=>({
                value: String(sec),
                label: (0, $2d58c73a38525204$export$934efb048138efd3)(sec, t, formatNumber)
            })), [
        t,
        formatNumber
    ]);
    // No specialty PICKER any more: the value is the council's, read against the
    // number in `medicalCode` and rendered read-only below. `specialtyLabel`
    // still translates what is stored — a catalogue value shows in the language
    // on screen, and a legacy free-text value renders verbatim.
    const toast = (0, $6usBW.useToast)();
    const [section, setSection] = (0, $acw62.useState)((0, $2d58c73a38525204$export$b22bf82651bf4640));
    // «فایل‌ها» sits inside «صفحه ویزیت»; its form is read only while that section is open,
    // and leaving the section with unsaved edits asks first.
    const uploads = (0, $6fe5dd530b543980$export$5700f9a384162d4d)({
        enabled: section === 'visit'
    });
    const [pendingSection, setPendingSection] = (0, $acw62.useState)(null);
    const changeSection = (id)=>{
        if (id === section) return;
        if (section === 'visit' && uploads.dirty) {
            setPendingSection(id);
            return;
        }
        setSection(id);
    };
    const [editOpen, setEditOpen] = (0, $acw62.useState)(false);
    const [joinedClinic, setJoinedClinic] = (0, $acw62.useState)(null);
    const displayName = [
        s.form.firstName,
        s.form.lastName
    ].filter(Boolean).join(' ') || s.doctor?.name || t('settings.profile.completeProfile');
    // F-S1 — this used to reset the form and shut the sheet with no question at
    // all, so a stray tap on the scrim (or, since overlays joined history, an
    // accidental edge-swipe) silently threw away a filled profile. `s.dirty` is
    // the same signal the SaveBar uses, so the sheet and the bar agree about
    // whether there is anything to lose.
    const closeEdit = ()=>{
        s.resetProfile();
        setEditOpen(false);
    };
    const { requestClose: requestCloseEdit, guard: editGuard } = (0, $9b530774ad99e23e$export$db6b977dd1b3391f)(s.dirty, closeEdit);
    // ── The profile picture (finding 14) ──────────────────────────────────────
    // Capture was desktop-only, which is backwards: the camera is the thing the
    // PHONE has. The validation, the read and the crop are all the desktop's —
    // the picture that reaches the record must be framed the same way whichever
    // surface sent it.
    const [avatarSheet, setAvatarSheet] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [cropSrc, setCropSrc] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmRemoveAvatar, setConfirmRemoveAvatar] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const pickAvatar = async (file)=>{
        const res = await (0, $2d58c73a38525204$export$37e4fcb024c1e74e)(file);
        if (!res.ok) {
            toast.error(t(res.messageKey));
            return;
        }
        setAvatarSheet(false);
        setCropSrc(res.dataUri);
    };
    const submitProfile = async ()=>{
        const res = await s.saveProfile();
        if (res.ok) setEditOpen(false);
    };
    if (s.loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)($530deeb725d14950$var$Frame, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                title: t('settings.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8afc7fe814c13ecc$export$e5bbe71aec5f3374), {})
        ]
    });
    if (s.error && !s.doctor) return /*#__PURE__*/ (0, $ayMG0.jsxs)($530deeb725d14950$var$Frame, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                title: t('settings.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "settings-error",
                "data-state": "error",
                style: {
                    padding: '1rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                    title: t('settings.profile.accountUnavailable'),
                    error: s.error,
                    onRetry: s.refetch
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($530deeb725d14950$var$Frame, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                title: t('settings.title'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        background: 'rgba(255,255,255,0.12)',
                        border: '1px solid rgba(255,255,255,0.18)',
                        borderRadius: '0.75rem',
                        padding: '0.625rem 0.75rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "ghost",
                            onClick: ()=>setAvatarSheet(true),
                            "data-testid": "settings-avatar-open",
                            "aria-label": s.doctor?.avatar ? t('settings.avatar.change') : t('settings.avatar.add'),
                            disabled: s.avatarBusy,
                            className: "h-auto min-h-11 shrink-0 rounded-full p-0 hover:bg-white/15",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                name: displayName,
                                size: 44,
                                bg: "rgba(255,255,255,0.2)",
                                src: s.doctor?.avatar || undefined
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                minWidth: 0,
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        color: 'white',
                                        fontSize: '0.9375rem',
                                        fontWeight: 700,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    dir: "auto",
                                    children: displayName
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        color: 'rgba(255,255,255,0.7)',
                                        fontSize: '0.75rem',
                                        marginTop: '0.125rem'
                                    },
                                    children: (0, $b0b690e819784781$export$1b9772fac51ff6b7)(t, s.form.specialty) || t('settings.profile.noSpecialty')
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $afdb707fcfdd3978$export$2e2bcd8739ae039), {
                sections: (0, $07cb4ea47e0548b5$export$c5900652ccdb0c23)(),
                active: section,
                onChange: changeSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: pendingSection !== null,
                onOpenChange: (o)=>{
                    if (!o) setPendingSection(null);
                },
                title: t('settings.profile.unsavedTitle'),
                message: t('settings.profile.unsavedBody'),
                confirmLabel: t('settings.profile.unsavedLeave'),
                cancelLabel: t('settings.profile.unsavedStay'),
                destructive: true,
                onConfirm: ()=>{
                    const target = pendingSection;
                    setPendingSection(null);
                    uploads.reset();
                    if (target) setSection(target);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "settings",
                "data-state": "content",
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    background: (0, $jTCZr.C).bg,
                    padding: '0.875rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem'
                },
                children: [
                    section === 'profile' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-identity",
                                title: t('settings.profile.identity'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.firstName'),
                                        value: s.form.firstName,
                                        testId: "settings-field-firstName"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.lastName'),
                                        value: s.form.lastName,
                                        testId: "settings-field-lastName"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.mobile'),
                                        value: (0, $5AX1S).forDisplay(s.form.phone),
                                        ltr: true,
                                        testId: "settings-field-phone"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.nationalId'),
                                        value: s.form.nationalId,
                                        ltr: true,
                                        testId: "settings-field-nationalId"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$234308a1466fa189), {
                                        percent: s.completeness
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-professional",
                                title: t('settings.profile.professional'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.medicalCode'),
                                        value: s.form.medicalCode,
                                        ltr: true,
                                        testId: "settings-field-medicalCode"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.specialty'),
                                        value: (0, $b0b690e819784781$export$1b9772fac51ff6b7)(t, s.form.specialty),
                                        testId: "settings-field-specialty"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$62a556f19792b723), {
                                        label: t('common.labels.bio'),
                                        value: s.form.bio,
                                        testId: "settings-field-bio"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "default",
                                onClick: ()=>setEditOpen(true),
                                "data-testid": "settings-edit-profile",
                                className: "min-h-11 w-full",
                                children: t('settings.profile.editInfo')
                            })
                        ]
                    }),
                    section === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-ai-visit",
                                title: t('settings.ai.autoRun'),
                                hint: t('settings.ai.autoRunNote'),
                                children: (0, $2d58c73a38525204$export$8035bf38917cdb6e).map((toggle)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                                id: `settings-ai-${toggle.key}`,
                                                "data-testid": `settings-ai-${toggle.key}`,
                                                label: t(toggle.labelKey),
                                                description: t(toggle.impactKey),
                                                checked: s.ai[toggle.key] !== false,
                                                onChange: (v)=>s.setAiSetting(toggle.key, v)
                                            }),
                                            toggle.key === 'autoDifferentialOnStart' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                "data-testid": "settings-ai-differential-polling",
                                                style: {
                                                    marginTop: 10,
                                                    paddingInlineStart: 12,
                                                    borderInlineStart: `2px solid ${(0, $jTCZr.C).border}`,
                                                    opacity: autoDiffArmed ? 1 : 0.55
                                                },
                                                children: [
                                                    (0, $2d58c73a38525204$export$d84b29c60bbbdc31).map((sub)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                                            id: `settings-ai-${sub.key}`,
                                                            "data-testid": `settings-ai-${sub.key}`,
                                                            label: t(sub.labelKey),
                                                            description: t(sub.impactKey),
                                                            checked: s.ai[sub.key] !== false,
                                                            disabled: !autoDiffArmed,
                                                            onChange: (v)=>s.setAiSetting(sub.key, v)
                                                        }, sub.key)),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            marginTop: 10
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                                            label: t('settings.ai.pollInterval'),
                                                            "data-testid": "settings-ai-pollInterval",
                                                            value: String((0, $2d58c73a38525204$export$291b76ac275aac62)(s.ai)),
                                                            options: pollOptions,
                                                            placeholder: "",
                                                            disabled: !pollArmed,
                                                            helperText: t('settings.ai.pollIntervalHint'),
                                                            onChange: (e)=>{
                                                                const n = Number(e.target.value);
                                                                if (Number.isFinite(n) && n > 0) s.setAiSetting('differentialPollIntervalSec', n);
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, toggle.key))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-ai-speech",
                                title: t('settings.ai.speech.title'),
                                hint: t('settings.ai.speech.hint'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b072c75c8fe44102$export$2e2bcd8739ae039), {
                                    ai: s.ai,
                                    onChange: (v)=>s.setAiSetting('speechEngine', v)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-ai-alerts",
                                title: t('settings.ai.vitalAlerts'),
                                hint: t('settings.ai.thresholdHint'),
                                children: [
                                    (0, $2d58c73a38525204$export$fdba03209e26fe6d).map((toggle)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                            id: `settings-ai-${toggle.key}`,
                                            "data-testid": `settings-ai-${toggle.key}`,
                                            label: t(toggle.labelKey),
                                            checked: s.ai[toggle.key] !== false,
                                            onChange: (v)=>s.setAiSetting(toggle.key, v)
                                        }, toggle.key)),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        "data-testid": "settings-ai-thresholds",
                                        style: {
                                            marginTop: 12,
                                            paddingInlineStart: 12,
                                            borderInlineStart: `2px solid ${(0, $jTCZr.C).border}`,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 12,
                                            opacity: alertsArmed ? 1 : 0.55
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                "data-testid": "settings-ai-spo2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                    label: t('settings.ai.spo2Threshold'),
                                                    ...s.thresholdField('spo2Threshold'),
                                                    inputMode: "numeric",
                                                    dir: "ltr",
                                                    disabled: !alertsArmed
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                "data-testid": "settings-ai-bp",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                    label: t('settings.ai.bpThreshold'),
                                                    ...s.thresholdField('bpSystolicThreshold'),
                                                    inputMode: "numeric",
                                                    dir: "ltr",
                                                    disabled: !alertsArmed
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    section === 'visit' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                        testId: "settings-visit-layout",
                        title: t('settings.visit.title'),
                        hint: t('settings.visit.subtitle'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a70b43577d2dd015$export$2e2bcd8739ae039), {
                            settings: s.visitLayout,
                            onChange: s.setVisitLayout,
                            onReset: s.resetVisitLayout
                        })
                    }),
                    section === 'visit' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                        testId: "settings-files-card",
                        title: t('settings.files.title'),
                        hint: t('settings.files.subtitle'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b26471698f489e74$export$2e2bcd8739ae039), {
                            s: uploads,
                            compact: true
                        })
                    }),
                    section === 'templates' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93a4e5de34b80e5d$export$2e2bcd8739ae039), {}),
                    section === 'prescription' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                        testId: "settings-prescription-card",
                        title: t('settings.prescription.title'),
                        hint: t('settings.prescription.subtitle'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4651f370f717da40$export$2e2bcd8739ae039), {
                            compact: true
                        })
                    }),
                    section === 'credits' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8834639d9186ea40$export$2e2bcd8739ae039), {
                        isMobile: true
                    }),
                    section === 'language' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                        testId: "settings-language",
                        title: t('settings.language.title'),
                        hint: t('settings.language.subtitle'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $065138bcfb23653d$export$2e2bcd8739ae039), {
                                value: s.language,
                                onChange: s.setLanguage
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-testid": "settings-language-direction",
                                style: {
                                    marginTop: '0.75rem',
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    lineHeight: 1.8
                                },
                                children: [
                                    t('settings.language.direction.title'),
                                    ":",
                                    ' ',
                                    dir === 'rtl' ? t('settings.language.direction.rtl') : t('settings.language.direction.ltr'),
                                    " \u2014 ",
                                    t('settings.language.direction.note')
                                ]
                            })
                        ]
                    }),
                    section === 'appearance' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-appearance",
                                title: t('settings.appearance.themeTitle'),
                                hint: t('settings.appearance.themeSubtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bca3e7c1cf4ecca1$export$2e2bcd8739ae039), {
                                    presets: themePresets,
                                    value: s.appearance.theme,
                                    onChange: (id)=>s.setAppearanceSetting('theme', id)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-fontsize",
                                title: t('settings.appearance.fontSizeTitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    role: "radiogroup",
                                    "aria-label": t('settings.appearance.fontSizeTitle'),
                                    "data-testid": "settings-fontsize-group",
                                    style: {
                                        display: 'flex',
                                        gap: '0.5rem'
                                    },
                                    children: fontSizes.map((f)=>{
                                        const on = s.appearance.fontSize === f.id;
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            role: "radio",
                                            "aria-checked": on,
                                            tabIndex: on ? 0 : -1,
                                            "data-testid": `settings-fontsize-${f.id}`,
                                            onClick: ()=>s.setAppearanceSetting('fontSize', f.id),
                                            style: {
                                                flex: 1,
                                                minHeight: '2.75rem',
                                                cursor: 'pointer',
                                                borderRadius: '0.625rem',
                                                background: on ? (0, $jTCZr.C).card : 'transparent',
                                                border: `1.5px solid ${on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                                color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary,
                                                fontWeight: on ? 700 : 600,
                                                fontSize: f.id === 'small' ? '0.8125rem' : f.id === 'large' ? '1.0625rem' : '0.9375rem'
                                            },
                                            children: f.label
                                        }, f.id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-fontfamily",
                                title: t('settings.appearance.fontFamilyTitle'),
                                hint: t('settings.appearance.fontFamilySubtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b474dda548c88bd$export$2e2bcd8739ae039), {
                                    value: s.appearance.fontFamily,
                                    onChange: (id)=>s.setAppearanceSetting('fontFamily', id)
                                })
                            })
                        ]
                    }),
                    section === 'clinics' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                        testId: "settings-clinics",
                        title: t('settings.clinics.join'),
                        hint: t('settings.clinics.joinHint'),
                        children: [
                            joinedClinic ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                role: "status",
                                style: {
                                    background: (0, $jTCZr.C).greenLight,
                                    borderRadius: '0.625rem',
                                    padding: '0.75rem',
                                    color: (0, $jTCZr.C).green,
                                    fontSize: '0.8125rem',
                                    lineHeight: 1.8
                                },
                                dir: "auto",
                                children: [
                                    t('clinic.joinRequested', {
                                        name: joinedClinic.clinic?.name || t('common.labels.clinic')
                                    }),
                                    joinedClinic.status === 'pending' && t('settings.clinics.pendingSuffix')
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8674ac96b71acabd$export$2e2bcd8739ae039), {
                                showTitle: false,
                                onJoined: setJoinedClinic
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2e16480984d7f73$export$2e2bcd8739ae039), {
                                className: "w-full mt-3"
                            })
                        ]
                    }),
                    section === 'security' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f39c13b15f45abee$export$7ce3cbddb17efe71), {
                                testId: "settings-signin",
                                title: t('settings.security.login'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                        id: "settings-security-otpEnabled",
                                        "data-testid": "settings-security-otpEnabled",
                                        label: t('settings.security.otp'),
                                        description: t('settings.security.otpHint'),
                                        checked: s.security.otpEnabled === true,
                                        onChange: (v)=>s.setSecuritySetting('otpEnabled', v)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                        id: "settings-security-biometricEnabled",
                                        "data-testid": "settings-security-biometricEnabled",
                                        label: t('settings.security.biometric'),
                                        description: t('settings.security.biometricHint'),
                                        checked: s.security.biometricEnabled === true,
                                        onChange: (v)=>s.setSecuritySetting('biometricEnabled', v)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/security'),
                                "data-testid": "settings-open-password",
                                className: "min-h-11 w-full",
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: 10,
                                    background: (0, $jTCZr.C).navy,
                                    color: '#fff',
                                    fontSize: 14,
                                    fontWeight: 700,
                                    textDecoration: 'none'
                                },
                                children: t('settings.account.accountLinkSecurity')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94bf4f3832dae279$export$2e2bcd8739ae039), {
                open: avatarSheet,
                onClose: ()=>setAvatarSheet(false),
                onPick: pickAvatar,
                onRemove: ()=>{
                    setAvatarSheet(false);
                    setConfirmRemoveAvatar(true);
                },
                hasAvatar: Boolean(s.doctor?.avatar)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80877663f582a793$export$2e2bcd8739ae039), {
                open: Boolean(cropSrc),
                onOpenChange: (open)=>{
                    if (!open) setCropSrc(null);
                },
                src: cropSrc,
                busy: s.avatarBusy,
                onCrop: async (dataUri)=>{
                    const res = await s.saveAvatar(dataUri);
                    if (res.ok) setCropSrc(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: confirmRemoveAvatar,
                onOpenChange: setConfirmRemoveAvatar,
                title: t('settings.avatar.removeTitle'),
                message: t('settings.avatar.removeBody'),
                confirmLabel: t('settings.avatar.remove'),
                destructive: true,
                onConfirm: ()=>s.removeAvatar()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cZOyb.default), {
                open: editOpen,
                onClose: requestCloseEdit,
                title: t('settings.profile.editInfo'),
                closeLabel: t('common.actions.close'),
                children: [
                    editGuard,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.75rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/identity'),
                                "data-testid": "settings-edit-identity-link",
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: 44,
                                    borderRadius: 10,
                                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                    color: (0, $jTCZr.C).ink2,
                                    fontSize: 13.5,
                                    fontWeight: 600,
                                    textDecoration: 'none'
                                },
                                children: t('settings.account.accountLinkIdentity')
                            }),
                            s.councilLocked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('common.labels.medicalCode'),
                                "data-testid": "settings-medicalCode",
                                value: s.form.medicalCode,
                                onChange: ()=>{},
                                disabled: true,
                                inputStyle: $530deeb725d14950$var$LTR,
                                helperText: t('settings.profile.medicalCodeLocked')
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('common.labels.medicalCode'),
                                "data-testid": "settings-medicalCode",
                                value: s.form.medicalCode,
                                onChange: s.setField('medicalCode'),
                                required: true,
                                error: s.errors.medicalCode && t(s.errors.medicalCode),
                                inputStyle: $530deeb725d14950$var$LTR
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('common.labels.specialty'),
                                "data-testid": "settings-specialty",
                                value: (0, $b0b690e819784781$export$1b9772fac51ff6b7)(t, s.form.specialty),
                                onChange: ()=>{},
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.7rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    lineHeight: 1.8
                                },
                                children: t('settings.profile.fromCouncil')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                                label: t('common.labels.bio'),
                                "data-testid": "settings-bio",
                                value: s.form.bio,
                                onChange: s.setField('bio'),
                                rows: 3
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '0.5rem',
                            marginTop: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                onClick: requestCloseEdit,
                                className: "min-h-11 flex-1",
                                "data-testid": "settings-edit-cancel",
                                children: t('common.actions.cancel')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "default",
                                onClick: submitProfile,
                                disabled: s.saving,
                                className: "min-h-11 flex-1",
                                "data-testid": "settings-edit-submit",
                                children: s.saving ? t('common.state.saving') : t('common.actions.save')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// The mobile shell is height-constrained, so the screen owns its own scroll
// region and the header/nav stay put above it.
function $530deeb725d14950$var$Frame({ children: children }) {
    return(// No `direction` here — it is inherited from <html dir>, which I18nProvider
    // owns. Pinning it would keep the mobile shell right-to-left in English.
    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        },
        children: children
    }));
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $lzNIT = parcelRequire("lzNIT");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $kyZIh = parcelRequire("kyZIh");
var $5AX1S = parcelRequire("5AX1S");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");
var $3GEBR = parcelRequire("3GEBR");
var $6usBW = parcelRequire("6usBW");









var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


// «شناسه سیام تأمین اجتماعی» — the doctor's own id at ONE clinic with تأمین.
//
// It is per doctor per clinic (a doctor in two clinics has two), so it sits under
// each clinic in Settings → «مطب‌ها» and is saved on that membership. The clinic
// can record the same field from its «پرسنل» screen; whichever writes last wins.
// Read only by تأمین e-prescribing, so an empty field is normal.
const $ce8ab046db794c3b$var$MY_CLINIC_SIAM_IDS = `query MyClinicSiamIds { myClinics { id clinicId siamId } }`;
const $ce8ab046db794c3b$var$SET_MY_CLINIC_SIAM = `mutation SetMyClinicSiam($clinicId: ID!, $siamId: String!) {
  setMyClinicSiamId(clinicId: $clinicId, siamId: $siamId) { id clinicId siamId } }`;
function $ce8ab046db794c3b$export$24f8ac64d600f9f9({ enabled: enabled = true } = {}) {
    const [byClinic, setByClinic] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        let alive = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)($ce8ab046db794c3b$var$MY_CLINIC_SIAM_IDS).then((d)=>{
            if (!alive) return;
            const map = {};
            for (const m of d?.myClinics || [])map[m.id] = {
                clinicId: m.clinicId,
                siamId: m.siamId || ''
            };
            setByClinic(map);
        }).catch(()=>{
            if (alive) setByClinic(null);
        });
        return ()=>{
            alive = false;
        };
    }, [
        enabled
    ]);
    return byClinic;
}
function $ce8ab046db794c3b$export$2e2bcd8739ae039({ clinicId: clinicId, value: value = '' }) {
    const { t: t, has: has } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, $acw62.useState)(value || '');
    const [stored, setStored] = (0, $acw62.useState)(value || '');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [saved, setSaved] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setDraft(value || '');
        setStored(value || '');
    }, [
        value
    ]);
    const clean = draft.trim();
    const dirty = clean !== stored;
    const save = async ()=>{
        if (!dirty || busy) return;
        setBusy(true);
        setError(null);
        setSaved(false);
        try {
            const d = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($ce8ab046db794c3b$var$SET_MY_CLINIC_SIAM, {
                clinicId: clinicId,
                siamId: clean
            });
            const next = d?.setMyClinicSiamId?.siamId || '';
            setStored(next);
            setDraft(next);
            setSaved(true);
        } catch (e) {
            // The BFF's own refusal («no membership here») is the useful answer; raw
            // transport text is not (lib/userErrorMessage).
            setError((0, $6dd1a0ec80cef79b$export$9bef418888ccb2cd)(e, {
                t: t,
                has: has
            }));
        } finally{
            setBusy(false);
        }
    };
    const id = `siam-${clinicId}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "settings-clinic-siam",
        style: {
            marginTop: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: id,
                style: {
                    display: 'block',
                    fontSize: 12,
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textSecondary,
                    marginBottom: 4
                },
                children: t('settings.clinics.siamLabel')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        id: id,
                        value: draft,
                        onChange: (e)=>{
                            setDraft(e.target.value);
                            setSaved(false);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') save();
                        },
                        disabled: busy,
                        dir: "ltr",
                        autoComplete: "off",
                        spellCheck: false,
                        maxLength: 64,
                        "aria-describedby": `${id}-hint`,
                        "data-testid": "settings-clinic-siam-input",
                        style: {
                            flex: 1,
                            minWidth: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: dirty ? 'default' : 'outline',
                        size: "sm",
                        onClick: save,
                        disabled: !dirty || busy,
                        "data-testid": "settings-clinic-siam-save",
                        children: [
                            busy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 12,
                                color: "currentColor",
                                label: ""
                            }),
                            t('settings.clinics.siamSave')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: `${id}-hint`,
                style: {
                    fontSize: 11,
                    color: (0, $jTCZr.C).textMuted,
                    marginTop: 4,
                    lineHeight: 1.6
                },
                children: t('settings.clinics.siamHint')
            }),
            saved && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "status",
                style: {
                    fontSize: 11,
                    color: (0, $jTCZr.C).green,
                    marginTop: 2
                },
                children: t('settings.clinics.siamSaved')
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                dir: "auto",
                style: {
                    fontSize: 11,
                    color: (0, $jTCZr.C).red,
                    marginTop: 2
                },
                children: error
            })
        ]
    });
}










var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

// ─────────────────────────────────────────────────────────────────────────────
// «صفحه ویزیت» — the layout editor, DESKTOP.
//
// The phone has its own (`VisitLayoutEditor.mobile.jsx`), which is the one
// place in this feature where the two surfaces fork. Everything else — the
// catalogue, the resolver, every operation — is shared, so the fork is of the
// SURFACE only: a row here puts three decisions side by side, which 390px
// cannot hold without wrapping and without dropping its ▲/▼ below the 44px
// touch floor. Both editors call the same functions and send the same patches.
//
// It holds no state and no policy — every click maps to one pure operation in
// screens/Visit/visitLayout.js that returns the patch to persist, and
// `settings` is re-read from the server (or the optimistic overlay) after each
// save. The three groups are the three columns of the visit page, in the order
// they sit on screen for a right-to-left reader: the record, the work area,
// the copilot.
//
// Controls are native checkboxes and radios rather than the kit's Toggle row:
// a row here carries TWO booleans and an order, and the Toggle is a full-width
// single-setting row. Native controls keep the keyboard and screen-reader
// contract (§12) without inventing a third switch.
// ─────────────────────────────────────────────────────────────────────────────
const $d011584eefdf9c35$var$ROW = {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    padding: '10px 0',
    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
};
const $d011584eefdf9c35$var$TITLE = {
    flex: '1 1 160px',
    minWidth: 0,
    fontSize: 14,
    color: (0, $jTCZr.C).textPrimary
};
const $d011584eefdf9c35$var$CHECK = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12.5,
    color: (0, $jTCZr.C).textSecondary,
    cursor: 'pointer',
    whiteSpace: 'nowrap'
};
const $d011584eefdf9c35$var$INPUT = {
    accentColor: (0, $jTCZr.C).navy,
    width: 16,
    height: 16,
    margin: 0,
    cursor: 'pointer'
};
const $d011584eefdf9c35$var$GROUP_TITLE = {
    margin: '0 0 2px',
    fontSize: 13,
    fontWeight: 700,
    color: (0, $jTCZr.C).textSecondary
};
const $d011584eefdf9c35$var$GROUP_HINT = {
    margin: '0 0 4px',
    fontSize: 12,
    color: (0, $jTCZr.C).textMuted,
    lineHeight: 1.7
};
const $d011584eefdf9c35$var$LOCK_NOTE = {
    fontSize: 11,
    color: (0, $jTCZr.C).textMuted,
    marginInlineStart: 6
};
function $d011584eefdf9c35$var$Group({ title: title, hint: hint, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            marginBottom: 18
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                style: $d011584eefdf9c35$var$GROUP_TITLE,
                children: title
            }),
            hint && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $d011584eefdf9c35$var$GROUP_HINT,
                children: hint
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: children
            })
        ]
    });
}
function $d011584eefdf9c35$var$Check({ label: label, checked: checked, disabled: disabled, onChange: onChange, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        style: {
            ...$d011584eefdf9c35$var$CHECK,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "checkbox",
                checked: checked,
                disabled: disabled,
                onChange: (e)=>onChange(e.target.checked),
                "data-testid": testId,
                style: $d011584eefdf9c35$var$INPUT
            }),
            label
        ]
    });
}
function $d011584eefdf9c35$var$Radio({ name: name, label: label, checked: checked, disabled: disabled, onChange: onChange, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        style: {
            ...$d011584eefdf9c35$var$CHECK,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                disabled: disabled,
                onChange: ()=>onChange(),
                "data-testid": testId,
                style: $d011584eefdf9c35$var$INPUT
            }),
            label
        ]
    });
}
// ▲ / ▼ — as text glyphs, which mirror correctly under both directions since
// "up" and "down" are not directional in RTL.
function $d011584eefdf9c35$var$OrderButtons({ id: id, index: index, count: count, onMove: onMove, t: t }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            display: 'inline-flex',
            gap: 2,
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "h-8 w-8 px-0",
                "aria-label": t('settings.visit.moveUp'),
                disabled: index === 0,
                "data-testid": `settings-visit-record-${id}-up`,
                onClick: ()=>onMove(id, -1),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-hidden": true,
                    style: {
                        fontSize: 11
                    },
                    children: "\u25B2"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "h-8 w-8 px-0",
                "aria-label": t('settings.visit.moveDown'),
                disabled: index === count - 1,
                "data-testid": `settings-visit-record-${id}-down`,
                onClick: ()=>onMove(id, 1),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-hidden": true,
                    style: {
                        fontSize: 11
                    },
                    children: "\u25BC"
                })
            })
        ]
    });
}
function $d011584eefdf9c35$export$2e2bcd8739ae039({ settings: settings, onChange: onChange, onReset: onReset, testId: testId = 'settings-visit' }) {
    const { t: t } = (0, $LNQP4.default)();
    const layout = (0, $792124e2f7de719a$export$e88ad8319f3008b2)(settings);
    const pristine = (0, $792124e2f7de719a$export$4deb366eab2f1d1a)(settings);
    const apply = (patch)=>{
        if (patch && Object.keys(patch).length) onChange(patch);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Group, {
                testId: `${testId}-record`,
                title: t('settings.visit.record.title'),
                hint: t('settings.visit.record.hint'),
                children: layout.recordSections.map((section, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t(section.labelKey),
                        style: $d011584eefdf9c35$var$ROW,
                        "data-testid": `${testId}-record-${section.id}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$OrderButtons, {
                                id: section.id,
                                index: index,
                                count: layout.recordSections.length,
                                t: t,
                                onMove: (id, delta)=>apply((0, $792124e2f7de719a$export$64d504ab69df77b0)(settings, id, delta))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    ...$d011584eefdf9c35$var$TITLE,
                                    opacity: section.visible ? 1 : 0.6
                                },
                                children: [
                                    t(section.labelKey),
                                    section.locked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $d011584eefdf9c35$var$LOCK_NOTE,
                                        children: t('settings.visit.alwaysShown')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Check, {
                                label: t('settings.visit.show'),
                                checked: section.visible,
                                disabled: Boolean(section.locked),
                                testId: `${testId}-record-${section.id}-visible`,
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$276da83ac94a32f6)(settings, section.id, on))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Check, {
                                label: t('settings.visit.openByDefault'),
                                checked: !section.collapsed,
                                disabled: !section.visible,
                                testId: `${testId}-record-${section.id}-open`,
                                onChange: (open)=>apply((0, $792124e2f7de719a$export$38f0593b6bfb6420)(settings, section.id, !open))
                            })
                        ]
                    }, section.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Group, {
                testId: `${testId}-work`,
                title: t('settings.visit.work.title'),
                hint: t('settings.visit.work.hint'),
                children: layout.workTabs.map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t(tab.labelKey),
                        style: $d011584eefdf9c35$var$ROW,
                        "data-testid": `${testId}-work-${tab.id}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    ...$d011584eefdf9c35$var$TITLE,
                                    opacity: tab.visible ? 1 : 0.6
                                },
                                children: [
                                    t(tab.labelKey),
                                    tab.locked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $d011584eefdf9c35$var$LOCK_NOTE,
                                        children: t('settings.visit.alwaysShown')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Check, {
                                label: t('settings.visit.show'),
                                checked: tab.visible,
                                disabled: Boolean(tab.locked),
                                testId: `${testId}-work-${tab.id}-visible`,
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$7eeed700e5288c3)(settings, tab.id, on))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Radio, {
                                name: `${testId}-work-default`,
                                label: t('settings.visit.openFirst'),
                                checked: layout.defaultWorkTab === tab.id,
                                disabled: !tab.visible,
                                testId: `${testId}-work-${tab.id}-default`,
                                onChange: ()=>apply((0, $792124e2f7de719a$export$aeba1cec85888be3)(settings, tab.id))
                            })
                        ]
                    }, tab.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Group, {
                testId: `${testId}-copilot`,
                title: t('settings.visit.copilot.title'),
                hint: t('settings.visit.copilot.hint'),
                children: layout.copilotTabs.map((tab)=>{
                    const lastVisible = tab.visible && layout.copilotTabs.filter((x)=>x.visible).length === 1;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t(tab.labelKey),
                        style: $d011584eefdf9c35$var$ROW,
                        "data-testid": `${testId}-copilot-${tab.id}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...$d011584eefdf9c35$var$TITLE,
                                    opacity: tab.visible ? 1 : 0.6
                                },
                                children: t(tab.labelKey)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Check, {
                                label: t('settings.visit.show'),
                                checked: tab.visible,
                                disabled: lastVisible,
                                testId: `${testId}-copilot-${tab.id}-visible`,
                                onChange: (on)=>apply((0, $792124e2f7de719a$export$fa98c16fa5ba5172)(settings, tab.id, on))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d011584eefdf9c35$var$Radio, {
                                name: `${testId}-copilot-default`,
                                label: t('settings.visit.openFirst'),
                                checked: layout.defaultCopilotTab === tab.id,
                                disabled: !tab.visible,
                                testId: `${testId}-copilot-${tab.id}-default`,
                                onChange: ()=>apply((0, $792124e2f7de719a$export$ceb766f504646314)(settings, tab.id))
                            })
                        ]
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        disabled: pristine,
                        "data-testid": `${testId}-reset`,
                        onClick: ()=>onReset(),
                        children: t('settings.visit.reset')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: pristine ? t('settings.visit.isDefault') : t('settings.visit.isCustom')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '12px 0 0',
                    fontSize: 12,
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.04),
                    borderRadius: 8,
                    padding: '8px 12px'
                },
                children: t('settings.visit.safetyNote')
            })
        ]
    });
}







parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eLeza = parcelRequire("eLeza");


var $jTCZr = parcelRequire("jTCZr");



// A fixed instant for the formatting preview, so the sample date and the
// «3 days ago» beside it never disagree and never re-render on a timer. The
// pair is what the preview is for: the same moment, in two calendars.
const $22b733fb1e55b6de$var$PREVIEW_INSTANT = new Date('2025-08-03T11:00:00Z');
const $22b733fb1e55b6de$var$PREVIEW_NOW = $22b733fb1e55b6de$var$PREVIEW_INSTANT.getTime() + 259200000;
const $22b733fb1e55b6de$var$TAB_ICONS = {
    profile: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).user, {
        s: 17
    }),
    ai: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).sparkles, {
        s: 17
    }),
    visit: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).layout, {
        s: 17
    }),
    templates: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).clinic, {
        s: 17
    }),
    prescription: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).rx, {
        s: 17
    }),
    credits: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6240fe22cbf69b$export$11c467f1ec2afb25), {
        size: 16
    }),
    language: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).globe, {
        s: 17
    }),
    appearance: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).palette, {
        s: 17
    }),
    clinics: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).badge, {
        s: 17
    }),
    security: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).lock, {
        s: 17
    })
};
const $22b733fb1e55b6de$var$SECTION_BY_ID = Object.fromEntries((0, $2d58c73a38525204$export$5ff47a1a5df62032).map((sec)=>[
        sec.id,
        sec
    ]));
/**
 * A profile field, tagged so the completeness rail can focus it by key.
 *
 * The kit inputs take no `id` or `ref` (they render their own <input> and
 * forward neither), so the anchor has to be a wrapper the screen owns. One
 * wrapper per field also gives the rail a scroll target that includes the
 * label, not just the box.
 */ const $22b733fb1e55b6de$var$Field = ({ name: name, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-field": name,
        children: children
    });
// Largest file we'll even read into memory before cropping. The cropper always
// re-encodes to a small 300×300 JPEG, so this only guards against someone
// picking a huge RAW/PNG and stalling the browser.
/**
 * A row that sends the doctor to حساب پارسینا instead of editing here.
 *
 * The fields it replaces — name, کد ملی, birth date, gender, password — were
 * writable from up to four panels through paths that disagreed with each other:
 * two different name-splitting rules, a کد ملی that was read-only on one patient
 * client and editable on the other, and a password change that existed for
 * doctors and nobody else. One writer ends that; a link alone would not.
 *
 * A plain navigation, not a token hand-off — same realm, so the account app runs
 * its own PKCE flow and Keycloak's SSO session returns a token without a second
 * sign-in. `accountUrl` adds the return_url.
 */ function $22b733fb1e55b6de$var$AccountLinkCard({ t: t, title: title, hint: hint, cta: cta, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
        testId: testId,
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).user, {
            s: 20
        }),
        iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
        iconColor: (0, $jTCZr.C).navy,
        title: title,
        subtitle: hint,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/identity'),
            "data-testid": `${testId}-link`,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                height: 40,
                padding: '0 18px',
                borderRadius: 10,
                background: (0, $jTCZr.C).navy,
                color: '#fff',
                fontSize: 13.5,
                fontWeight: 700,
                textDecoration: 'none'
            },
            children: cta
        })
    });
}
function $22b733fb1e55b6de$export$2e2bcd8739ae039() {
    const s = (0, $9585130d255ed442$export$c1629e185843c96d)();
    const toast = (0, $6usBW.useToast)();
    const { t: t, has: has, formatDate: formatDate, formatTime: formatTime, formatNumber: formatNumber, formatMoney: formatMoney, formatRelativeTime: formatRelativeTime, dir: dir, locale: locale, locales: locales } = (0, $LNQP4.default)();
    // The kit's rows carry Persian labels; the catalogue keys on their ids.
    const themePresets = (0, $489a2602878be6c3$export$3458b2021f2b4be4)({
        t: t,
        has: has
    }, (0, $jTCZr.THEME_PRESETS));
    const fontSizes = (0, $489a2602878be6c3$export$1be7054c02e16140)({
        t: t,
        has: has
    }, (0, $jTCZr.FONT_SIZES));
    // No specialty PICKER any more: the value is the council's, read against the
    // number in `medicalCode` and rendered read-only below. `specialtyLabel`
    // still translates what is stored — a catalogue value shows in the language
    // on screen, and a legacy free-text value renders verbatim.
    const [searchParams, setSearchParams] = (0, $lzNIT.useSearchParams)();
    const formRef = (0, $acw62.useRef)(null);
    // Avatar: the picked-but-not-yet-cropped source, plus confirm-removal state.
    const [cropSrc, setCropSrc] = (0, $acw62.useState)(null);
    const [confirmRemoveAvatar, setConfirmRemoveAvatar] = (0, $acw62.useState)(false);
    const avatarInputRef = (0, $acw62.useRef)(null);
    // Set once the doctor joins a clinic here — swaps the form for a confirmation
    // so a second submit can't fire.
    const [joinedClinic, setJoinedClinic] = (0, $acw62.useState)(null);
    // Held while a tab switch is waiting on the discard confirmation.
    const [pendingTab, setPendingTab] = (0, $acw62.useState)(null);
    // ── Tab ⇄ URL (§3.2) ───────────────────────────────────────────────────────
    // The section used to be plain component state, so a refresh, a back press or
    // a pasted link all dropped the doctor back on «اطلاعات پزشک». `SECTIONS.id`
    // was always meant to be the URL tab; this is it finally being one.
    const requested = searchParams.get('tab');
    const activeTab = (0, $07cb4ea47e0548b5$export$e0cbd71c1867bb72)(requested) ? requested : (0, $2d58c73a38525204$export$b22bf82651bf4640);
    const goToTab = (0, $acw62.useCallback)((id)=>{
        const next = new URLSearchParams(searchParams);
        if (id === (0, $2d58c73a38525204$export$b22bf82651bf4640)) next.delete('tab');
        else next.set('tab', id);
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    // «فایل‌ها» lives in the visit tab and is read only while that tab is open.
    const uploads = (0, $6fe5dd530b543980$export$5700f9a384162d4d)({
        enabled: activeTab === 'visit'
    });
    // Leaving the profile form — or the files form — with uncommitted edits silently
    // threw them away.
    const onTabChange = (0, $acw62.useCallback)((id)=>{
        if (id === activeTab) return;
        if (activeTab === 'profile' && s.dirty) {
            setPendingTab(id);
            return;
        }
        if (activeTab === 'visit' && uploads.dirty) {
            setPendingTab(id);
            return;
        }
        goToTab(id);
    }, [
        activeTab,
        s.dirty,
        uploads.dirty,
        goToTab
    ]);
    const clinicsOpen = activeTab === 'clinics';
    const myClinics = (0, $352de6198ea69bb8$export$f9eed3ff0df23e5c)({
        enabled: clinicsOpen
    });
    // The تأمین SIAM id per clinic — its own query, so a failure costs only the
    // SIAM fields and never the clinic list. تأمین is an Iranian insurer: outside
    // the Iranian market (`market: 'intl'`) the field is not offered, nor asked for.
    const siamOffered = (0, $eLeza.isIranMarket)();
    const siamByClinic = (0, $ce8ab046db794c3b$export$24f8ac64d600f9f9)({
        enabled: clinicsOpen && siamOffered
    });
    const displayName = (0, $acw62.useMemo)(()=>[
            s.form.firstName,
            s.form.lastName
        ].filter(Boolean).join(' ') || s.doctor?.name || t('settings.profile.completeProfile'), [
        s.form.firstName,
        s.form.lastName,
        s.doctor,
        t
    ]);
    const checklist = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$1429510cfa0d4432)(s.form), [
        s.form
    ]);
    const alertsArmed = (0, $2d58c73a38525204$export$b18cfe9ad6d2d648)(s.ai);
    // The re-assessment controls belong to «اجرای خودکار تشخیص افتراقی»: with the
    // master switch off nothing runs by itself, so a cadence for it would be
    // describing something that never happens.
    const autoDiffArmed = s.ai.autoDifferentialOnStart !== false;
    const pollArmed = autoDiffArmed && s.ai.differentialPollingEnabled !== false;
    // A cadence is read, not calculated: «هر ۲ دقیقه» is the same interval as
    // «هر ۱۲۰ ثانیه» and the doctor should not have to do the division.
    const pollOptions = (0, $acw62.useMemo)(()=>(0, $2d58c73a38525204$export$7c8e7f6b23543e69).map((sec)=>({
                value: String(sec),
                label: (0, $2d58c73a38525204$export$934efb048138efd3)(sec, t, formatNumber)
            })), [
        t,
        formatNumber
    ]);
    // The rail's gap rows are the way into the field they name.
    const focusField = (0, $acw62.useCallback)((key)=>{
        const wrapper = formRef.current?.querySelector(`[data-field="${key}"]`);
        if (!wrapper) return;
        wrapper.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        wrapper.querySelector('input, textarea, select, button')?.focus();
    }, []);
    const onSaveProfile = async ()=>{
        const res = await s.saveProfile();
        const firstError = res.errors && Object.keys(res.errors)[0];
        if (!res.ok && firstError) focusField(firstError);
    };
    // ── Avatar ─────────────────────────────────────────────────────────────────
    // The validation and the read are shared with the phone (`Settings.shared`):
    // both surfaces must reject the same files with the same message, and a 20MB
    // photo straight off a camera is exactly the case the limit exists for.
    const pickAvatarFile = async (e)=>{
        const file = e.target.files?.[0];
        // Clear immediately so re-picking the same file still fires onChange.
        e.target.value = '';
        if (!file) return;
        const res = await (0, $2d58c73a38525204$export$37e4fcb024c1e74e)(file);
        if (!res.ok) {
            toast.error(t(res.messageKey));
            return;
        }
        setCropSrc(res.dataUri);
    };
    const onCropConfirmed = async (dataUri)=>{
        const res = await s.saveAvatar(dataUri);
        if (res.ok) setCropSrc(null);
    };
    const onJoined = (0, $acw62.useCallback)((link)=>{
        setJoinedClinic(link);
        // The membership list is the confirmation — re-read it rather than splice
        // an optimistic row, so the status shown is the server's (§2.4).
        myClinics.refetch();
    }, [
        myClinics
    ]);
    const TABS = (0, $acw62.useMemo)(()=>(0, $07cb4ea47e0548b5$export$c5900652ccdb0c23)().map((sec)=>({
                id: sec.id,
                label: t(sec.labelKey),
                icon: $22b733fb1e55b6de$var$TAB_ICONS[sec.id],
                // The one signal that survives leaving the tab: unsaved profile edits.
                dot: sec.id === 'profile' && s.dirty
            })), [
        s.dirty,
        t
    ]);
    // ── Loading (§2.4) — the page's own skeleton mirrors the P2 layout ─────────
    if (s.loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$Page, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8afc7fe814c13ecc$export$f3b93b19b28bda08), {})
    });
    // ── Error (§2.4) — a failed load must not look like an empty form ──────────
    if (s.error && !s.doctor) return /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$Page, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "settings-error",
            "data-state": "error",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                title: t('settings.profile.accountUnavailable'),
                error: s.error,
                onRetry: s.refetch
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($22b733fb1e55b6de$var$Page, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 20
                },
                "data-testid": "settings",
                "data-state": "content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "settings-toolbar",
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 14,
                            flexWrap: 'wrap',
                            background: (0, $jTCZr.C).card,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: (0, $c48eb69ce5e269ee$export$cf052b29a1666d6a),
                            boxShadow: (0, $c48eb69ce5e269ee$export$345619c94cb75947),
                            padding: '10px 12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7dcd2a5bfc5801e$export$2e2bcd8739ae039), {
                                items: TABS,
                                value: activeTab,
                                onChange: onTabChange,
                                ariaLabel: t('settings.sectionsLabel'),
                                testId: "settings-tabs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "data-testid": "settings-toolbar-hint",
                                style: {
                                    fontSize: 12,
                                    color: (0, $jTCZr.C).textMuted,
                                    minWidth: 0
                                },
                                children: $22b733fb1e55b6de$var$SECTION_BY_ID[activeTab] && t($22b733fb1e55b6de$var$SECTION_BY_ID[activeTab].hintKey)
                            })
                        ]
                    }),
                    activeTab === 'profile' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: formRef,
                        className: "grid grid-cols-1 min-[1181px]:grid-cols-[minmax(0,1fr)_19rem] gap-5 items-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 18,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$AccountLinkCard, {
                                        t: t,
                                        testId: "settings-identity",
                                        title: t('settings.account.accountLinkTitle'),
                                        hint: t('settings.account.accountLinkHint'),
                                        cta: t('settings.account.accountLinkIdentity')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                        testId: "settings-professional",
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).badge, {
                                            s: 20
                                        }),
                                        iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                                        iconColor: (0, $jTCZr.C).teal,
                                        title: t('settings.profile.professional'),
                                        subtitle: t('settings.profile.professionalHint'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$f9754e493f02dbbd), {
                                                max: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$Field, {
                                                        name: "medicalCode",
                                                        children: s.councilLocked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                            label: t('common.labels.medicalCode'),
                                                            "data-testid": "settings-medicalCode",
                                                            value: s.form.medicalCode,
                                                            onChange: ()=>{},
                                                            disabled: true,
                                                            inputStyle: (0, $c48eb69ce5e269ee$export$373e92e0788ff06e),
                                                            helperText: t('settings.profile.medicalCodeLocked')
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                            label: t('common.labels.medicalCode'),
                                                            "data-testid": "settings-medicalCode",
                                                            value: s.form.medicalCode,
                                                            onChange: s.setField('medicalCode'),
                                                            placeholder: t('settings.profile.medicalCodeExample'),
                                                            required: true,
                                                            error: s.errors.medicalCode && t(s.errors.medicalCode),
                                                            inputStyle: (0, $c48eb69ce5e269ee$export$373e92e0788ff06e)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$Field, {
                                                        name: "specialty",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                            label: t('common.labels.specialty'),
                                                            "data-testid": "settings-specialty",
                                                            value: (0, $b0b690e819784781$export$1b9772fac51ff6b7)(t, s.form.specialty),
                                                            onChange: ()=>{},
                                                            disabled: true
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 11.5,
                                                    color: (0, $jTCZr.C).textSecondary,
                                                    marginTop: 8,
                                                    lineHeight: 1.8
                                                },
                                                children: t('settings.profile.fromCouncil')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($22b733fb1e55b6de$var$Field, {
                                                name: "bio",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        marginTop: 14,
                                                        maxWidth: (0, $c48eb69ce5e269ee$export$9543e7b3be254c7c)
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                                                        label: t('common.labels.bio'),
                                                        "data-testid": "settings-bio",
                                                        value: s.form.bio,
                                                        onChange: s.setField('bio'),
                                                        placeholder: t('settings.profile.bioPlaceholder'),
                                                        rows: 4
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    s.dirty && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$b281dc69f5ee0eb0), {
                                        saving: s.saving,
                                        onReset: s.resetProfile,
                                        onSave: onSaveProfile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$ac8aef415a0397c5), {
                                name: displayName,
                                specialty: (0, $b0b690e819784781$export$1b9772fac51ff6b7)(t, s.form.specialty),
                                percent: s.completeness,
                                items: checklist,
                                onJump: focusField,
                                avatar: s.doctor?.avatar,
                                avatarBusy: s.avatarBusy,
                                onPickAvatar: ()=>avatarInputRef.current?.click(),
                                onRemoveAvatar: ()=>setConfirmRemoveAvatar(true)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                ref: avatarInputRef,
                                type: "file",
                                accept: "image/jpeg,image/png",
                                onChange: pickAvatarFile,
                                style: {
                                    display: 'none'
                                },
                                "data-testid": "settings-avatar-input"
                            })
                        ]
                    }),
                    activeTab === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                            testId: "settings-ai-visit",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).sparkles, {
                                s: 20
                            }),
                            iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                            iconColor: (0, $jTCZr.C).teal,
                            title: t('settings.ai.inVisit'),
                            subtitle: t('settings.immediateLong'),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$bf83aff0b09e7fcc), {
                                    hint: t('settings.ai.autoRunHint'),
                                    children: (0, $2d58c73a38525204$export$8035bf38917cdb6e).map((toggle)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                                    id: `settings-ai-${toggle.key}`,
                                                    "data-testid": `settings-ai-${toggle.key}`,
                                                    label: t(toggle.labelKey),
                                                    description: t(toggle.impactKey),
                                                    checked: s.ai[toggle.key] !== false,
                                                    onChange: (v)=>s.setAiSetting(toggle.key, v)
                                                }),
                                                toggle.key === 'autoDifferentialOnStart' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    "data-testid": "settings-ai-differential-polling",
                                                    style: {
                                                        marginTop: 12,
                                                        paddingInlineStart: 14,
                                                        borderInlineStart: `2px solid ${(0, $jTCZr.C).border}`,
                                                        opacity: autoDiffArmed ? 1 : 0.55,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 12
                                                    },
                                                    children: [
                                                        (0, $2d58c73a38525204$export$d84b29c60bbbdc31).map((sub)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                                                id: `settings-ai-${sub.key}`,
                                                                "data-testid": `settings-ai-${sub.key}`,
                                                                label: t(sub.labelKey),
                                                                description: t(sub.impactKey),
                                                                checked: s.ai[sub.key] !== false,
                                                                disabled: !autoDiffArmed,
                                                                onChange: (v)=>s.setAiSetting(sub.key, v)
                                                            }, sub.key)),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                maxWidth: 260
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                                                                label: t('settings.ai.pollInterval'),
                                                                "data-testid": "settings-ai-pollInterval",
                                                                value: String((0, $2d58c73a38525204$export$291b76ac275aac62)(s.ai)),
                                                                options: pollOptions,
                                                                placeholder: "",
                                                                disabled: !pollArmed,
                                                                helperText: t('settings.ai.pollIntervalHint'),
                                                                onChange: (e)=>{
                                                                    const n = Number(e.target.value);
                                                                    if (Number.isFinite(n) && n > 0) s.setAiSetting('differentialPollIntervalSec', n);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, toggle.key))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$bf83aff0b09e7fcc), {
                                    title: t('settings.ai.speech.title'),
                                    hint: t('settings.ai.speech.hint'),
                                    style: {
                                        marginTop: 22
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b072c75c8fe44102$export$2e2bcd8739ae039), {
                                        ai: s.ai,
                                        onChange: (v)=>s.setAiSetting('speechEngine', v)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$bf83aff0b09e7fcc), {
                                    title: t('settings.ai.vitalAlerts'),
                                    hint: t('settings.ai.thresholdHint'),
                                    style: {
                                        marginTop: 22
                                    },
                                    children: [
                                        (0, $2d58c73a38525204$export$fdba03209e26fe6d).map((toggle)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3GEBR.default), {
                                                id: `settings-ai-${toggle.key}`,
                                                "data-testid": `settings-ai-${toggle.key}`,
                                                label: t(toggle.labelKey),
                                                checked: s.ai[toggle.key] !== false,
                                                onChange: (v)=>s.setAiSetting(toggle.key, v)
                                            }, toggle.key)),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                marginTop: 14,
                                                paddingInlineStart: 14,
                                                borderInlineStart: `2px solid ${(0, $jTCZr.C).border}`
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$f9754e493f02dbbd), {
                                                min: 200,
                                                max: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        "data-testid": "settings-ai-spo2",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                            label: t('settings.ai.spo2Threshold'),
                                                            ...s.thresholdField('spo2Threshold'),
                                                            inputMode: "numeric",
                                                            dir: "ltr",
                                                            disabled: !alertsArmed
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        "data-testid": "settings-ai-bp",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                            label: t('settings.ai.bpThreshold'),
                                                            ...s.thresholdField('bpSystolicThreshold'),
                                                            inputMode: "numeric",
                                                            dir: "ltr",
                                                            disabled: !alertsArmed
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    activeTab === 'visit' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-visit-layout",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).layout, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.visit.title'),
                                subtitle: t('settings.visit.subtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d011584eefdf9c35$export$2e2bcd8739ae039), {
                                    settings: s.visitLayout,
                                    onChange: s.setVisitLayout,
                                    onReset: s.resetVisitLayout
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-files-card",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).layout, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.files.title'),
                                subtitle: t('settings.files.subtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b26471698f489e74$export$2e2bcd8739ae039), {
                                    s: uploads
                                })
                            })
                        ]
                    }),
                    activeTab === 'templates' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ea74aa9cf27c9eb$export$2e2bcd8739ae039), {}),
                    activeTab === 'prescription' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                            testId: "settings-prescription-card",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).rx, {
                                s: 20
                            }),
                            iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.10),
                            iconColor: (0, $jTCZr.C).navy,
                            title: t('settings.prescription.title'),
                            subtitle: t('settings.prescription.subtitle'),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4651f370f717da40$export$2e2bcd8739ae039), {})
                        })
                    }),
                    activeTab === 'credits' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8834639d9186ea40$export$2e2bcd8739ae039), {
                            isMobile: false
                        })
                    }),
                    activeTab === 'language' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-language",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).globe, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.language.title'),
                                subtitle: t('settings.language.subtitle'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $065138bcfb23653d$export$2e2bcd8739ae039), {
                                        value: s.language,
                                        onChange: s.setLanguage
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            marginTop: 16,
                                            paddingTop: 14,
                                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            flexWrap: 'wrap',
                                            fontSize: 12,
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                style: {
                                                    color: (0, $jTCZr.C).textSecondary,
                                                    fontWeight: 700
                                                },
                                                children: [
                                                    t('settings.language.direction.title'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-testid": "settings-language-direction",
                                                children: dir === 'rtl' ? t('settings.language.direction.rtl') : t('settings.language.direction.ltr')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\u2014 ",
                                                    t('settings.language.direction.note')
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-language-preview",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).palette, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                                iconColor: (0, $jTCZr.C).teal,
                                title: t('settings.language.preview.title'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 1fr))',
                                        gap: 14
                                    },
                                    children: [
                                        [
                                            'date',
                                            formatDate($22b733fb1e55b6de$var$PREVIEW_INSTANT, 'full')
                                        ],
                                        [
                                            'time',
                                            formatTime($22b733fb1e55b6de$var$PREVIEW_INSTANT)
                                        ],
                                        [
                                            'number',
                                            formatNumber(1234567)
                                        ],
                                        [
                                            'money',
                                            `${formatMoney(25000000)} ${t('common.units.toman')}`
                                        ],
                                        [
                                            'relative',
                                            formatRelativeTime($22b733fb1e55b6de$var$PREVIEW_INSTANT, $22b733fb1e55b6de$var$PREVIEW_NOW)
                                        ]
                                    ].map(([key, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            "data-testid": `settings-language-preview-${key}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $jTCZr.C).textMuted,
                                                        marginBottom: 4
                                                    },
                                                    children: t(`settings.language.preview.${key}`)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: 14,
                                                        fontWeight: 700,
                                                        color: (0, $jTCZr.C).textPrimary
                                                    },
                                                    children: value
                                                })
                                            ]
                                        }, key))
                                })
                            })
                        ]
                    }),
                    activeTab === 'appearance' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-appearance",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).palette, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.appearance.themeTitle'),
                                subtitle: t('settings.appearance.themeSubtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bca3e7c1cf4ecca1$export$2e2bcd8739ae039), {
                                    presets: themePresets,
                                    value: s.appearance.theme,
                                    onChange: (id)=>s.setAppearanceSetting('theme', id)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-fontsize",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).palette, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                                iconColor: (0, $jTCZr.C).teal,
                                title: t('settings.appearance.fontSizeTitle'),
                                subtitle: t('settings.appearance.fontSizeSubtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    role: "radiogroup",
                                    "aria-label": t('settings.appearance.fontSizeTitle'),
                                    "data-testid": "settings-fontsize-group",
                                    style: {
                                        display: 'flex',
                                        gap: 10,
                                        flexWrap: 'wrap'
                                    },
                                    children: fontSizes.map((f)=>{
                                        const selected = s.appearance.fontSize === f.id;
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            role: "radio",
                                            "aria-checked": selected,
                                            tabIndex: selected ? 0 : -1,
                                            "data-testid": `settings-fontsize-${f.id}`,
                                            onClick: ()=>s.setAppearanceSetting('fontSize', f.id),
                                            style: {
                                                minHeight: 44,
                                                padding: '0 20px',
                                                cursor: 'pointer',
                                                borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                                                background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06) : (0, $jTCZr.C).card,
                                                border: `1.5px solid ${selected ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                                color: selected ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary,
                                                fontWeight: selected ? 700 : 600,
                                                fontSize: f.id === 'small' ? 13 : f.id === 'large' ? 17 : 15
                                            },
                                            children: f.label
                                        }, f.id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-fontfamily",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).palette, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.appearance.fontFamilyTitle'),
                                subtitle: t('settings.appearance.fontFamilySubtitle'),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b474dda548c88bd$export$2e2bcd8739ae039), {
                                    value: s.appearance.fontFamily,
                                    onChange: (id)=>s.setAppearanceSetting('fontFamily', id)
                                })
                            })
                        ]
                    }),
                    activeTab === 'clinics' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-my-clinics",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).clinic, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                                iconColor: (0, $jTCZr.C).navy,
                                title: t('settings.clinics.mine'),
                                subtitle: t('settings.clinics.mineSubtitle'),
                                children: [
                                    myClinics.loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonList), {
                                        count: 2,
                                        trailing: 72,
                                        label: t('common.state.loading')
                                    }) : myClinics.error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                                        title: t('settings.clinics.unavailable'),
                                        error: myClinics.error,
                                        onRetry: myClinics.refetch
                                    }) : myClinics.clinics.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b80355eea4425a$export$2e2bcd8739ae039), {
                                            size: 44,
                                            strokeWidth: 1.5,
                                            "aria-hidden": true
                                        }),
                                        title: t('settings.clinics.none'),
                                        description: t('settings.clinics.noneHint')
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))',
                                            gap: 12
                                        },
                                        children: myClinics.clinics.map((link)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$ded970040a403667), {
                                                name: link.clinic?.name || t('settings.clinics.unnamed'),
                                                /* A clinic's office line is a LANDLINE (021…, 065…, 032…), which
                         fails the kit's Iranian MOBILE pattern. `forDisplay` carries
                         `allowLandline` itself — it IS the read path — so the flag can
                         no longer be forgotten here, and an office number can no longer
                         format to `''` and vanish out of the meta line. */ meta: [
                                                    link.clinic?.city,
                                                    link.clinic?.officePhone && (0, $5AX1S).forDisplay(link.clinic.officePhone)
                                                ].filter(Boolean).join(" \xb7 "),
                                                status: link.status,
                                                children: siamOffered && link.status !== 'pending' && siamByClinic?.[link.id] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce8ab046db794c3b$export$2e2bcd8739ae039), {
                                                    clinicId: siamByClinic[link.id].clinicId,
                                                    value: siamByClinic[link.id].siamId
                                                })
                                            }, link.id))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            marginTop: 14
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2e16480984d7f73$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$69ed894a7932b604), {
                                testId: "settings-clinics",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).badge, {
                                    s: 20
                                }),
                                iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.12),
                                iconColor: (0, $jTCZr.C).teal,
                                title: t('settings.clinics.join'),
                                subtitle: t('settings.clinics.joinHint'),
                                children: joinedClinic ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    role: "status",
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        flexWrap: 'wrap',
                                        background: (0, $jTCZr.C).greenLight,
                                        border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.35)}`,
                                        borderRadius: (0, $c48eb69ce5e269ee$export$61c2590db9f20ec1),
                                        padding: '12px 14px',
                                        color: (0, $jTCZr.C).green,
                                        fontSize: 13
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                flexShrink: 0,
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).check, {
                                                s: 18
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            dir: "auto",
                                            style: {
                                                flex: 1,
                                                minWidth: 180
                                            },
                                            children: [
                                                t('clinic.joinRequested', {
                                                    name: joinedClinic.clinic?.name || t('common.labels.clinic')
                                                }),
                                                joinedClinic.status === 'pending' && t('settings.clinics.pendingSuffix')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                            variant: "ghost",
                                            onClick: ()=>setJoinedClinic(null),
                                            "data-testid": "settings-clinics-join-again",
                                            children: t('clinic.addAnother')
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        maxWidth: 440
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8674ac96b71acabd$export$2e2bcd8739ae039), {
                                        showTitle: false,
                                        onJoined: onJoined
                                    })
                                })
                            })
                        ]
                    }),
                    activeTab === 'security' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 18,
                            maxWidth: 940
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$e7ba791b8e7021d3), {
                            testId: "settings-password",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48eb69ce5e269ee$export$f04a61298a47a40f).lock, {
                                s: 20
                            }),
                            iconBg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
                            iconColor: (0, $jTCZr.C).navy,
                            title: t('settings.account.handoffSecurityTitle'),
                            subtitle: t('settings.account.handoffSecuritySub'),
                            items: [
                                t('settings.account.handoffSecurityPassword'),
                                t('settings.account.handoffSecurityTotp'),
                                t('settings.account.handoffSecurityDevices')
                            ],
                            cta: t('settings.account.handoffSecurityCta'),
                            href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/security'),
                            note: t('settings.account.handoffNote')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: pendingTab !== null,
                onOpenChange: (open)=>{
                    if (!open) setPendingTab(null);
                },
                title: t('settings.profile.unsavedTitle'),
                message: t('settings.profile.unsavedBody'),
                confirmLabel: t('settings.profile.unsavedLeave'),
                cancelLabel: t('settings.profile.unsavedStay'),
                destructive: true,
                onConfirm: ()=>{
                    const target = pendingTab;
                    setPendingTab(null);
                    s.resetProfile();
                    uploads.reset();
                    if (target) goToTab(target);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80877663f582a793$export$2e2bcd8739ae039), {
                open: !!cropSrc,
                onOpenChange: (open)=>{
                    if (!open) setCropSrc(null);
                },
                src: cropSrc,
                onCrop: onCropConfirmed,
                busy: s.avatarBusy
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac5f41923e150410$export$2e2bcd8739ae039), {
                open: confirmRemoveAvatar,
                onOpenChange: setConfirmRemoveAvatar,
                title: t('settings.avatar.removeTitle'),
                message: t('settings.avatar.removeBody'),
                confirmLabel: t('settings.avatar.remove'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmRemoveAvatar(false);
                    s.removeAvatar();
                }
            })
        ]
    });
}
/**
 * The canonical desktop page shell (§2.2), identical to Accounting/Encounters/
 * Credits: a full-bleed `PageHeader` bar, then a padded, full-width body.
 *
 * This replaced a centred `maxWidth: 860` column under a floating gradient hero
 * card. That combination is what made the screen read as a modal sitting on top
 * of the app instead of a page inside it — a narrow centred slab with its own
 * chrome is exactly the shape of a dialog. Settings is a sidebar destination,
 * so §2.2 puts it in the top-level `PageHeader` family: no back affordance, no
 * bespoke bar, same 64px white header bar every other page opens with.
 *
 * The header carries only the title and subtitle. The doctor's name, specialty
 * and avatar are not repeated in its context slot — the profile card below is
 * already the one place that states (and edits) that identity.
 *
 * Padding uses only the two sanctioned breakpoints (§4.1): 16px below 769px,
 * 32px above. The body is deliberately NOT width-capped — cards fill the page
 * like every sibling page, and the field grids inside them add columns as the
 * viewport grows rather than leaving a narrow ribbon of content.
 *
 * What IS capped is the content *inside* a card (`FieldGrid max`, `FORM_MAX`).
 * Uncapped cards plus uncapped fields is what produced a five-across row of
 * 220px inputs at 1600px: the card filling the page is the page rule, a form
 * line running the whole width of a workstation is just a long line.
 */ function $22b733fb1e55b6de$var$Page({ children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    return(// No `direction` here: it is inherited from <html dir>, which I18nProvider
    // owns. Pinning it on a container is what used to make an English UI render
    // its layout right-to-left inside an otherwise left-to-right page.
    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col bg-background overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('settings.title'),
                sub: t('settings.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-4 min-[769px]:px-8 py-6 flex flex-col gap-5",
                children: children
            })
        ]
    }));
}


// Settings is a platform fork (DESIGN-CONCEPT-MOBILE §1.1): two render trees
// over one shared behaviour layer (`useSettingsForm` / `Settings.shared.js`).
const $af71fcd5c0304c78$var$SettingsScreen = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $530deeb725d14950$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22b733fb1e55b6de$export$2e2bcd8739ae039), {});
};
var $af71fcd5c0304c78$export$2e2bcd8739ae039 = $af71fcd5c0304c78$var$SettingsScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $iK5Lj = parcelRequire("iK5Lj");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The patient lookup's result list while a search is in flight. The
// MobileHeader and the search field stay real (the doctor keeps typing); each
// placeholder is one `MobilePatientResultCard` — a Card whose tappable body is
// `p-3` with a 40px avatar, the name + identity lines and the trailing chevron.
// ─────────────────────────────────────────────────────────────────────────────
const $a464e8eaf7fc5a7a$var$ResultCardSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: 0,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.75rem',
                minHeight: 44
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                    size: 40
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: `${46 + i * 17 % 30}%`,
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: `${30 + i * 11 % 24}%`,
                            height: 11
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: 16,
                    height: 16,
                    radius: (0, $jTCZr.RADIUS).chip
                })
            ]
        })
    });
const $a464e8eaf7fc5a7a$export$133be9e27c46a336 = ({ count: count = 3, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "lookup-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($a464e8eaf7fc5a7a$var$ResultCardSkeleton, {
                i: i
            }, i))
    });
};
var $a464e8eaf7fc5a7a$export$2e2bcd8739ae039 = $a464e8eaf7fc5a7a$export$133be9e27c46a336;



var $2VplL = parcelRequire("2VplL");/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $70af14d86c795e96$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "10",
            cy: "7",
            r: "4",
            key: "e45bow"
        }
    ],
    [
        "path",
        {
            d: "M10.3 15H7a4 4 0 0 0-4 4v2",
            key: "3bnktk"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "3",
            key: "18b49y"
        }
    ],
    [
        "path",
        {
            d: "m21 21-1.9-1.9",
            key: "1g2n9r"
        }
    ]
];
const $70af14d86c795e96$export$2e2bcd8739ae039 = (0, $9QBug.default)("user-search", $70af14d86c795e96$export$3efd853dbb351e94);



var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");

var $gKFEi = parcelRequire("gKFEi");

var $jTCZr = parcelRequire("jTCZr");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// One search hit (§B.3). The whole card opens the record — there is exactly one
// thing to do with a found patient, and a button inside the card would be a
// smaller target than the card.
//
// The meta line is what a doctor uses to tell two «محمد رضایی»s apart: age,
// file number and the national id. Those are LTR-isolated runs
// (`.parsina-ltr`), or the digits and their punctuation land at the wrong end
// of an RTL line.
const $5f95391294592dfb$var$Dot = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.C).textMuted,
            opacity: 0.6
        },
        children: "\xb7"
    });
const $5f95391294592dfb$var$MobilePatientResultCard = ({ patient: patient, onOpen: onOpen })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const meta = [];
    if (patient.age != null && patient.age !== '') meta.push(/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        children: [
            formatDigits(patient.age),
            " ",
            t('common.units.year')
        ]
    }, "age"));
    if (patient.fileNumber) meta.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "parsina-ltr",
        style: {
            fontVariantNumeric: 'tabular-nums'
        },
        children: formatDigits(patient.fileNumber)
    }, "file"));
    if (patient.nationalId) meta.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "parsina-ltr",
        style: {
            fontVariantNumeric: 'tabular-nums'
        },
        children: formatDigits(patient.nationalId)
    }, "nid"));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g6X9N.default), {
        style: {
            padding: 0,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
            variant: "ghost",
            "data-testid": `lookup-result-${patient.id}`,
            "aria-label": t('encounters.recordOf', {
                name: patient.name || t('encounters.unknownPatient')
            }),
            onClick: ()=>onOpen(patient),
            className: "h-auto min-h-11 w-full items-center gap-2.5 rounded-none p-3 text-start",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                    name: patient.name || '',
                    size: 40
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            dir: "auto",
                            style: {
                                fontSize: '0.8125rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: patient.name || t('encounters.unknownPatient')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.3125rem',
                                marginTop: '0.125rem',
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: meta.map((node, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        i > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($5f95391294592dfb$var$Dot, {}),
                                        node
                                    ]
                                }, node.key))
                        }),
                        patient.lastEncounter && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                fontSize: '0.625rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: '0.125rem'
                            },
                            children: [
                                t('patient.lastVisit'),
                                " ",
                                formatDate(patient.lastEncounter, 'long')
                            ]
                        })
                    ]
                }),
                patient.status && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547c752fb4c18299$export$2e2bcd8739ae039), {
                    status: patient.status
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                    size: 16,
                    "aria-hidden": true,
                    style: {
                        color: (0, $jTCZr.C).textMuted,
                        flexShrink: 0,
                        transform: 'scaleX(var(--dir-flip))'
                    }
                })
            ]
        })
    });
};
var $5f95391294592dfb$export$2e2bcd8739ae039 = $5f95391294592dfb$var$MobilePatientResultCard;



// ─────────────────────────────────────────────────────────────────────────────
// جست‌وجوی بیمار — S12 (§B.3).
//
// The second thing a doctor does on a phone, and the app could not do it at
// all. `patients(filter, search, clinicId)` has been on the BFF the whole time
// with zero call sites, so — with no Encounters screen either — a phone opened
// exactly one thing: today's queue. A walk-in, a follow-up call about a result,
// yesterday's patient at the door: no way to the record.
//
// A CONTENT SCREEN (§C.2): the header carries the way back and the field, and
// there is no bottom nav under it — the search IS the screen, and a persistent
// bar would only compete with the results for the bottom of a keyboard-filled
// viewport.
//
// Entered from the Reception header's 🔍, beside the wallet. سوابق ویزیت‌ها
// also answers "look someone up", but through a past VISIT; this answers it
// through the person, which is the one a doctor reaches for when the name is
// all they have.
//
// The query lives in component state, never in the URL: a patient's name in an
// address is PHI in the history, in a shared link and in every log between here
// and the BFF.
// ─────────────────────────────────────────────────────────────────────────────
const $870949426a89cd57$var$PatientLookupScreen = ()=>{
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const keyboardInset = (0, $iK5Lj.default)();
    const { query: query, search: search, clear: clear, retry: retry, results: results, error: error, truncated: truncated, state: state } = (0, $fd142269863b16ba$export$2e2bcd8739ae039)();
    const back = ()=>{
        // A deep link straight to /lookup has nothing to go back to; پذیرش is
        // where the search is entered from and where it belongs.
        if (window.history.length > 1) window.history.back();
        else navigate('reception');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $577e5af2575afc25$export$2e2bcd8739ae039), {
                    title: t('patient.lookup.title'),
                    onBack: back,
                    backTestId: "lookup-back",
                    search: {
                        value: query,
                        onChange: search,
                        onClear: clear,
                        placeholder: t('patient.lookup.placeholder'),
                        clearLabel: t('common.actions.clearSearch'),
                        // The doctor came here to type. Anything else is a wasted tap on a
                        // screen whose entire purpose is one field.
                        autoFocus: true,
                        testId: 'lookup-input'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "lookup-content",
                "data-state": state,
                "aria-busy": state === 'loading' || undefined,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    // §H.1 — the results list is what the keyboard covers, so the last
                    // card has to be reachable while the field is still focused.
                    padding: `0.875rem 0.875rem calc(1rem + ${keyboardInset}px)`,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.625rem'
                },
                children: [
                    state === 'idle' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70af14d86c795e96$export$2e2bcd8739ae039), {
                            size: 48,
                            color: (0, $jTCZr.C).textMuted,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patient.lookup.idleTitle'),
                        description: t('patient.lookup.idleBody')
                    }),
                    state === 'below' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "lookup-min-chars",
                        style: {
                            padding: '1rem 0',
                            textAlign: 'center',
                            fontSize: '0.8125rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('patient.lookup.minChars', {
                            count: formatNumber((0, $fd142269863b16ba$export$603bfc519b05aadb))
                        })
                    }),
                    state === 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a464e8eaf7fc5a7a$export$133be9e27c46a336), {
                        count: 3
                    }),
                    state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b153162db005cb6$export$2e2bcd8739ae039), {
                        error: error,
                        title: t('patient.lookup.failed'),
                        onRetry: retry
                    }),
                    state === 'empty' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                            size: 48,
                            color: (0, $jTCZr.C).textMuted,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patient.lookup.noResults'),
                        description: t('patient.lookup.noResultsBody'),
                        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "outline",
                            size: "sm",
                            className: "min-h-11",
                            onClick: clear,
                            "data-testid": "lookup-clear",
                            children: t('common.actions.clear')
                        })
                    }),
                    state === 'content' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted
                                },
                                "data-testid": "lookup-count",
                                children: t('patient.lookup.count', {
                                    count: results.length
                                })
                            }),
                            results.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f95391294592dfb$export$2e2bcd8739ae039), {
                                    patient: p,
                                    onOpen: (hit)=>navigate('patient-detail', {
                                            patientId: hit.id,
                                            id: hit.id
                                        })
                                }, p.id)),
                            truncated && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "data-testid": "lookup-capped",
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    textAlign: 'center',
                                    padding: '0.5rem 0'
                                },
                                children: t('patient.lookup.capped', {
                                    count: formatNumber((0, $fd142269863b16ba$export$d99aee4f5069128))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $870949426a89cd57$export$2e2bcd8739ae039 = $870949426a89cd57$var$PatientLookupScreen;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eLeza = parcelRequire("eLeza");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");

var $2WFPf = parcelRequire("2WFPf");


var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $iK5Lj = parcelRequire("iK5Lj");

parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $82f105c7f47687ac$export$2e2bcd8739ae039({ subtitle: subtitle, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const keyboardInset = (0, $iK5Lj.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 100,
            background: `linear-gradient(145deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 55%, ${(0, $jTCZr.C).navyLight} 100%)`,
            display: 'flex',
            // On a phone the card IS the screen, so it starts at the top rather than
            // floating in the middle of a viewport it fills anyway.
            // `flex-start`, NOT `stretch`. `stretch` gives the card a DEFINITE cross
            // size — the backdrop's own height, which `min-height` can only match,
            // never exceed (flexbox §9.4: a single-line flex container with a
            // definite cross size hands that size to its line). The card also hides
            // its overflow, for its corners, so a step taller than the window had
            // its bottom CLIPPED with no scroll anywhere to reach it — the backdrop
            // is `overflow-y: auto`, but its only child was never taller than the
            // backdrop itself. The استعلام result is exactly what makes step 1 that
            // tall. Aligning to the start leaves the card's height content-driven,
            // so it grows and the backdrop scrolls.
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'center',
            fontFamily: 'var(--app-font)',
            // §H.1 — the docked «ادامه» has to clear the software keyboard, and every
            // step of this flow is a form. `dvh`, not `vh`.
            padding: isMobile ? `0 0 ${keyboardInset}px` : '24px 16px',
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: `
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(24px) }
          to   { opacity: 1; transform: translateY(0) }
        }
      `
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: 'white',
                    // 520px on a 360px screen is a card wider than the window. On a phone
                    // it stops being a card: full width, no corner, no shadow — there is
                    // nothing behind it to float above.
                    borderRadius: isMobile ? 0 : 18,
                    width: '100%',
                    maxWidth: isMobile ? '100%' : 520,
                    boxShadow: isMobile ? 'none' : '0 40px 100px rgba(0,0,0,0.35)',
                    animation: isMobile ? 'none' : 'slideUp 0.4s cubic-bezier(0.22,1,0.36,1) both',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    // `100%`, not `100dvh`: the backdrop is `fixed; inset: 0` with the
                    // keyboard inset as its bottom padding, so its content box already IS
                    // the space left for the card. `100dvh` measures the whole window and
                    // would hang the card's last rem underneath the keyboard.
                    minHeight: isMobile ? '100%' : undefined,
                    paddingBottom: isMobile ? 'env(safe-area-inset-bottom, 0px)' : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 60%, ${(0, $jTCZr.C).navyLight} 100%)`,
                            padding: '22px 28px 18px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: 10,
                                    background: 'rgba(255,255,255,0.12)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "rgba(255,255,255,0.85)",
                                    width: "20",
                                    height: "20",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 15,
                                            fontWeight: 800,
                                            color: 'white'
                                        },
                                        children: t('auth.onboarding.pageTitle')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: 'rgba(255,255,255,0.55)'
                                        },
                                        children: subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '26px 28px 32px'
                        },
                        children: children
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $fW63i = parcelRequire("fW63i");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");

var $1HT9m = parcelRequire("1HT9m");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");



// ── «گردونهٔ شانس» — the one page a doctor spins ──────────────────────────────
//
// docs/ONBOARDING_PRIZE_WHEEL_PLAN.md §6. Two mount points, one component: the
// onboarding wizard inserts it between the council-number step and the panel, and
// `screens/PrizeWheel` renders it before the router for a doctor who was
// offered a wheel and closed the app (or who was already on the platform when
// the campaign started). They differ only in what «ادامه» does, which is why
// `onDone` is the only thing the callers hand over besides the draw.
//
// THE SERVER DECIDES. This screen does not pick a slice, does not know the
// odds, and cannot change the answer by asking twice: it sends a draw id and
// animates to whatever index comes back. That is also why a failure here is
// never a dead end — see `PRIZE_NOT_AVAILABLE` below.
// `canRetry: true` is this client saying it knows what «تلاش دوباره» is. The
// server may only land a draw on that slice for a client that says so — one
// that does not would show a doctor «۰ پارسه» on a result card and let them
// walk away from a prize they are still owed.
const $26ce0214a2875133$var$SPIN_PRIZE_WHEEL = `
  mutation SpinPrizeWheel($drawId: ID!, $canRetry: Boolean) {
    spinPrizeWheel(drawId: $drawId, canRetry: $canRetry) {
      id status segmentIndex kind amount smartVisits
      whatsappMessages baleMessages smsMessages retry
      balance { balance currency }
    }
  }
`;
// The wheel's diameter, from the mockup (docs/design/prize-wheel-page.html):
// 318 inside the phone's 390px frame, 380 on the desktop card. Both shrink to
// their container — the kit's svg is `max-width: 100%` — so these are a ceiling
// rather than a size, and neither needs a media query.
const $26ce0214a2875133$var$WHEEL_PX = {
    mobile: 318,
    desktop: 380
};
/** The winning slice, or null. 0 IS a slice, so `||` and `??` are both wrong. */ const $26ce0214a2875133$var$settledIndex = (draw)=>Number.isInteger(draw?.segmentIndex) ? draw.segmentIndex : null;
/** A draw the doctor has already spun — re-shown, not replayed. */ const $26ce0214a2875133$var$alreadySpun = (draw)=>draw?.status !== 'offered' && $26ce0214a2875133$var$settledIndex(draw) != null;
/** The wheel stopped on «تلاش دوباره»: nothing was won and the draw is STILL
 *  `offered`. The server lands a draw here at most once, so the spin after it
 *  always wins. Read off the server's own flag — never off a label or an
 *  amount of 0, which a real (if stingy) slice could also carry. */ const $26ce0214a2875133$var$landedOnRetry = (draw)=>draw?.retry === true;
function $26ce0214a2875133$var$CheckIcon({ size: size = 26 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20 6L9 17l-5-5"
        })
    });
}
function $26ce0214a2875133$export$2e2bcd8739ae039({ draw: draw, onDone: onDone }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const toast = (0, $6usBW.useToast)();
    // A draw that arrives already spun opens AT its result: the wheel sits on the
    // winning slice with no animation (the kit's documented `targetIndex` with
    // `spinning={false}`) and the card is there on the first frame. Replaying a
    // four-second spin for a prize that was decided yesterday would read as a
    // second chance.
    //
    // A draw that arrives having landed on «تلاش دوباره» (the doctor closed the
    // app between the two spins) is kept as well, but NOT as settled: the wheel
    // parks on that slice and the notice is there, with the spin still owed.
    const [result, setResult] = (0, $acw62.useState)(()=>$26ce0214a2875133$var$alreadySpun(draw) || $26ce0214a2875133$var$landedOnRetry(draw) ? draw : null);
    const [spinning, setSpinning] = (0, $acw62.useState)(false);
    // `settled` means A PRIZE is on screen — it is what swaps the button for the
    // result card and what makes `spin` a no-op. A retry never sets it.
    const [settled, setSettled] = (0, $acw62.useState)(()=>$26ce0214a2875133$var$alreadySpun(draw));
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const segments = Array.isArray(draw?.segments) ? draw.segments : [];
    const targetIndex = $26ce0214a2875133$var$settledIndex(result);
    const spin = async ()=>{
        if (busy || spinning || settled) return;
        setBusy(true);
        setError('');
        try {
            // The same draw id both times: the second chance is the server's to
            // give, and it is the same draw that is being spun again.
            const data = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($26ce0214a2875133$var$SPIN_PRIZE_WHEEL, {
                drawId: draw.id,
                canRetry: true
            });
            const spun = data?.spinPrizeWheel;
            // A 200 with no draw in it. Not an exception — the request succeeded —
            // so it is reported as the same sentence as a failure rather than thrown
            // into the catch, where the code/messageKey branches would find nothing.
            if (!spun) {
                setError(t('errors.save.generic'));
                return;
            }
            setResult(spun);
            // The credit has landed, so every mounted copy of the balance — the
            // credits hero, the KPI strip — is now stale. `balance == null` means the
            // wallet has NOT confirmed, and nothing must be refetched or claimed.
            if (spun.balance?.balance != null) (0, $29025bf29a861ca6$export$70e96f88d72639c)();
            const index = $26ce0214a2875133$var$settledIndex(spun);
            if (index == null) // The service answered without a slice. There is nothing to animate to,
            // and inventing one (index 0 is a real prize) would show the doctor a
            // number they did not win. Skip the wheel, keep the result — unless it
            // is a retry, which has no result to keep: the notice shows and the
            // button comes straight back.
            {
                if (!$26ce0214a2875133$var$landedOnRetry(spun)) setSettled(true);
            } else setSpinning(true);
        } catch (e) {
            const code = e?.extensions?.code;
            if (code === 'PRIZE_NOT_AVAILABLE') {
                // The wheel stopped being spinnable between this page rendering and the
                // button. Say so and move on — there is no second action on this screen,
                // so a doctor left here with a dead button is a doctor who cannot reach
                // their panel.
                toast.info(t('auth.onboarding.prize.unavailable'));
                onDone?.();
                return;
            }
            // The BFF writes for the doctor and names the sentence it means
            // (docs/ERROR_CODES.md); its own text is the fallback for a key this
            // catalogue has not learned yet.
            const key = e?.extensions?.messageKey;
            setError((key && has(key) ? t(key) : '') || e?.message || t('errors.save.generic'));
        } finally{
            setBusy(false);
        }
    };
    // The wheel has come to rest. A win settles the stage; a retry only stops the
    // wheel — it stays parked on that slice (`targetIndex` is untouched, which is
    // what lets the next spin carry on from there) and the button comes back.
    const onWheelSettled = ()=>{
        setSpinning(false);
        if (!$26ce0214a2875133$var$landedOnRetry(result)) setSettled(true);
    };
    const amount = Number(result?.amount || 0);
    // The service's own figures. Absent (an older BFF) → the line is dropped
    // rather than guessed at: a wrong equivalence is worse than none.
    const smartVisits = Number(result?.smartVisits || 0);
    const whatsappMessages = Number(result?.whatsappMessages || 0);
    const baleMessages = Number(result?.baleMessages || 0);
    const smsMessages = Number(result?.smsMessages || 0);
    const newBalance = result?.balance?.balance;
    const showResult = settled && result;
    // «تلاش دوباره» is on screen from the moment the wheel stops on it until the
    // second spin is pressed. Not while it is still turning — that would give the
    // animation away, exactly as the result card would.
    const retryPending = !settled && $26ce0214a2875133$var$landedOnRetry(result);
    const showRetry = retryPending && !busy && !spinning;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).metric,
                            color: (0, $jTCZr.C).textPrimary,
                            lineHeight: 1.6
                        },
                        children: draw?.title || t('auth.onboarding.prize.title')
                    }),
                    draw?.subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).body,
                            fontWeight: 500,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.9
                        },
                        children: draw.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fW63i.default), {
                    "data-testid": "prize-wheel",
                    segments: segments,
                    targetIndex: targetIndex,
                    spinning: spinning,
                    onSettled: onWheelSettled,
                    size: isMobile ? $26ce0214a2875133$var$WHEEL_PX.mobile : $26ce0214a2875133$var$WHEEL_PX.desktop,
                    label: t('auth.onboarding.prize.title')
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "prize-error",
                style: {
                    padding: '0.625rem 0.875rem',
                    background: (0, $jTCZr.CT).dangerSoft,
                    border: `1px solid ${(0, $jTCZr.C).redLight}`,
                    borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).chip,
                    ...(0, $1HT9m.type).body,
                    fontWeight: 600,
                    color: (0, $jTCZr.CT).dangerInk,
                    textAlign: 'start',
                    lineHeight: 1.6
                },
                children: error
            }),
            showResult ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "prize-result",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    padding: 16,
                    borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    boxShadow: `0 6px 24px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    width: 44,
                                    height: 44,
                                    borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
                                    flexShrink: 0,
                                    background: (0, $jTCZr.C).teal,
                                    color: (0, $jTCZr.C).card,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($26ce0214a2875133$var$CheckIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 3,
                                    minWidth: 0,
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).title,
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.6
                                        },
                                        children: newBalance != null ? t('auth.onboarding.prize.wonParseh', {
                                            parseh: formatNumber(amount)
                                        }) : t('auth.onboarding.prize.wonPending', {
                                            parseh: formatNumber(amount)
                                        })
                                    }),
                                    whatsappMessages > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-testid": "prize-worth",
                                        style: {
                                            ...(0, $1HT9m.type).caption,
                                            color: (0, $jTCZr.C).textSecondary,
                                            lineHeight: 1.9,
                                            overflowWrap: 'anywhere'
                                        },
                                        children: t('auth.onboarding.prize.worth', {
                                            whatsapp: formatNumber(whatsappMessages),
                                            bale: formatNumber(baleMessages),
                                            sms: formatNumber(smsMessages),
                                            visits: formatNumber(smartVisits)
                                        })
                                    }) : smartVisits > 0 && // An older BFF, which knows smart visits and nothing else.
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            ...(0, $1HT9m.type).caption,
                                            color: (0, $jTCZr.C).textSecondary
                                        },
                                        children: t('auth.onboarding.prize.smartVisits', {
                                            visits: formatNumber(smartVisits)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    newBalance != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 12px',
                            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).control,
                            background: (0, $jTCZr.C).bg
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).caption,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('auth.onboarding.prize.newBalance')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...(0, $1HT9m.type).title,
                                    color: (0, $jTCZr.C).navy
                                },
                                dir: "ltr",
                                children: formatNumber(newBalance)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "lg",
                        "data-testid": "prize-continue",
                        onClick: ()=>onDone?.(),
                        className: "min-h-11 font-bold w-full bg-gradient-brand",
                        children: t('auth.onboarding.prize.continue')
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    showRetry && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "status",
                        "data-testid": "prize-retry",
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                            padding: '0.75rem 0.875rem',
                            borderRadius: (0, $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f).card,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.08),
                            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.3)}`,
                            textAlign: 'start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).title,
                                    color: (0, $jTCZr.C).textPrimary,
                                    lineHeight: 1.6
                                },
                                children: t('auth.onboarding.prize.retryTitle')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    ...(0, $1HT9m.type).body,
                                    fontWeight: 500,
                                    color: (0, $jTCZr.C).textSecondary,
                                    lineHeight: 1.9
                                },
                                children: t('auth.onboarding.prize.retryBody')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "lg",
                        "data-testid": "prize-spin",
                        onClick: spin,
                        disabled: busy || spinning,
                        className: "min-h-11 font-bold w-full bg-gradient-brand",
                        children: busy || spinning ? t('auth.onboarding.prize.spinning') : t(retryPending ? 'auth.onboarding.prize.spinAgain' : 'auth.onboarding.prize.spin')
                    }),
                    !retryPending && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            ...(0, $1HT9m.type).caption,
                            color: (0, $jTCZr.C).textMuted,
                            textAlign: 'center',
                            lineHeight: 1.8
                        },
                        children: t('auth.onboarding.prize.oneSpin')
                    })
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $73987793ab7d2855$exports = {};
$73987793ab7d2855$exports = JSON.parse('{"auth":{"onboarding":{"foreign":{"prompt":"\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u067E\u0632\u0634\u06A9\u06CC \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","fullName":"\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC","specialty":"\u062A\u062E\u0635\u0635","specialtyPlaceholder":"\u0645\u062B\u0644\u0627\u064B \u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642","specialtyChoose":"\u062A\u062E\u0635\u0635 \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F","specialtyGroupSpecialty":"\u062A\u062E\u0635\u0635\u200C\u0647\u0627","specialtyGroupSubspecialty":"\u0641\u0648\u0642\u200C\u062A\u062E\u0635\u0635\u200C\u0647\u0627","specialtyOther":"\u0633\u0627\u06CC\u0631 (\u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0646\u06CC\u0633\u062A)","specialtyOtherLabel":"\u062A\u062E\u0635\u0635 \u0634\u0645\u0627","specialtyUnknown":"\u062A\u062E\u0635\u0635 \u0627\u0646\u062A\u062E\u0627\u0628\u200C\u0634\u062F\u0647 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0646\u06CC\u0633\u062A. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.","degree":"\u0645\u062F\u0631\u06A9","degreePlaceholder":"\u0645\u062B\u0644\u0627\u064B MD \u06CC\u0627 MBChB","country":"\u06A9\u0634\u0648\u0631 \u0635\u0627\u062F\u0631\u06A9\u0646\u0646\u062F\u0647\u0654 \u067E\u0631\u0648\u0627\u0646\u0647","countryPlaceholder":"\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0634\u0648\u0631","city":"\u0634\u0647\u0631","license":"\u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u0631\u0648\u0627\u0646\u0647\u0654 \u067E\u0632\u0634\u06A9\u06CC (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)","licenseHint":"\u0634\u0645\u0627\u0631\u0647\u200C\u0627\u06CC \u06A9\u0647 \u06A9\u0634\u0648\u0631 \u062E\u0648\u062F\u062A\u0627\u0646 \u0635\u0627\u062F\u0631 \u06A9\u0631\u062F\u0647 \u0627\u0633\u062A.","notice":"\u0627\u06CC\u0646 \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0628\u062F\u0648\u0646 \u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0634\u0645\u0627 \u0628\u0627 \u0628\u0631\u0686\u0633\u0628 \xab\u062A\u0623\u06CC\u06CC\u062F\u0646\u0634\u062F\u0647\xbb \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u062E\u0648\u0627\u0647\u062F \u0634\u062F.","incomplete":"\u0646\u0627\u0645\u060C \u062A\u062E\u0635\u0635\u060C \u0645\u062F\u0631\u06A9\u060C \u06A9\u0634\u0648\u0631 \u0648 \u0634\u0647\u0631 \u0631\u0627 \u06A9\u0627\u0645\u0644 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","licenseTaken":"\u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u0631\u0648\u0627\u0646\u0647 \u0642\u0628\u0644\u0627\u064B \u062A\u0648\u0633\u0637 \u062D\u0633\u0627\u0628 \u062F\u06CC\u06AF\u0631\u06CC \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A.","notAllowed":"\u0627\u06CC\u0646 \u0645\u0633\u06CC\u0631 \u0641\u0642\u0637 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627\u0631\u0647\u200C\u0647\u0627\u06CC \u063A\u06CC\u0631\u0627\u06CC\u0631\u0627\u0646\u06CC \u0627\u0633\u062A. \u0644\u0637\u0641\u0627\u064B \u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.","unverified":"\u062A\u0623\u06CC\u06CC\u062F\u0646\u0634\u062F\u0647"}}}}');


var $f174240318190ee4$exports = {};
$f174240318190ee4$exports = JSON.parse('{"auth":{"onboarding":{"foreign":{"prompt":"Enter your medical details.","fullName":"Full name","specialty":"Specialty","specialtyPlaceholder":"e.g. Cardiology","specialtyChoose":"Select your specialty","specialtyGroupSpecialty":"Specialties","specialtyGroupSubspecialty":"Subspecialties","specialtyOther":"Other (not in the list)","specialtyOtherLabel":"Your specialty","specialtyUnknown":"That specialty is not in the list. Please choose again.","degree":"Degree","degreePlaceholder":"e.g. MD or MBChB","country":"Country that issued your licence","countryPlaceholder":"Select a country","city":"City","license":"Medical licence number (optional)","licenseHint":"The number issued by your own country.","notice":"These details are saved without verification, and your profile will be shown as \u201CUnverified\u201D.","incomplete":"Enter your name, specialty, degree, country and city.","licenseTaken":"This licence number is already registered to another account.","notAllowed":"This path is only for numbers from outside Iran. Please enter your medical council number.","unverified":"Unverified"}}}}');


var $00d73987d3140061$exports = {};
$00d73987d3140061$exports = JSON.parse('{"auth":{"onboarding":{"foreign":{"prompt":"\u0623\u062F\u062E\u0644 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0637\u0628\u064A\u0629.","fullName":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644","specialty":"\u0627\u0644\u062A\u062E\u0635\u0635","specialtyPlaceholder":"\u0645\u062B\u0644\u0627\u064B \u0623\u0645\u0631\u0627\u0636 \u0627\u0644\u0642\u0644\u0628","specialtyChoose":"\u0627\u062E\u062A\u0631 \u062A\u062E\u0635\u0635\u0643","specialtyGroupSpecialty":"\u0627\u0644\u062A\u062E\u0635\u0635\u0627\u062A","specialtyGroupSubspecialty":"\u0627\u0644\u062A\u062E\u0635\u0635\u0627\u062A \u0627\u0644\u062F\u0642\u064A\u0642\u0629","specialtyOther":"\u0623\u062E\u0631\u0649 (\u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629)","specialtyOtherLabel":"\u062A\u062E\u0635\u0635\u0643","specialtyUnknown":"\u0647\u0630\u0627 \u0627\u0644\u062A\u062E\u0635\u0635 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","degree":"\u0627\u0644\u0634\u0647\u0627\u062F\u0629","degreePlaceholder":"\u0645\u062B\u0644\u0627\u064B MD \u0623\u0648 MBChB","country":"\u0627\u0644\u0628\u0644\u062F \u0627\u0644\u0630\u064A \u0623\u0635\u062F\u0631 \u0627\u0644\u062A\u0631\u062E\u064A\u0635","countryPlaceholder":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0628\u0644\u062F","city":"\u0627\u0644\u0645\u062F\u064A\u0646\u0629","license":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0631\u062E\u064A\u0635 \u0627\u0644\u0637\u0628\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","licenseHint":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0635\u0627\u062F\u0631 \u0639\u0646 \u0628\u0644\u062F\u0643.","notice":"\u062A\u064F\u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u062F\u0648\u0646 \u062A\u062D\u0642\u0642\u060C \u0648\u0633\u064A\u0638\u0647\u0631 \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062E\u0635\u064A \u0628\u0639\u0644\u0627\u0645\u0629 \xab\u063A\u064A\u0631 \u0645\u0648\u062B\u0651\u0642\xbb.","incomplete":"\u0623\u062F\u062E\u0644 \u0627\u0644\u0627\u0633\u0645 \u0648\u0627\u0644\u062A\u062E\u0635\u0635 \u0648\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0648\u0627\u0644\u0628\u0644\u062F \u0648\u0627\u0644\u0645\u062F\u064A\u0646\u0629.","licenseTaken":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0631\u062E\u064A\u0635 \u0647\u0630\u0627 \u0645\u0633\u062C\u0651\u0644 \u0645\u0633\u0628\u0642\u0627\u064B \u0644\u062D\u0633\u0627\u0628 \u0622\u062E\u0631.","notAllowed":"\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0627\u0631 \u0645\u062E\u0635\u0651\u0635 \u0644\u0644\u0623\u0631\u0642\u0627\u0645 \u0645\u0646 \u062E\u0627\u0631\u062C \u0625\u064A\u0631\u0627\u0646 \u0641\u0642\u0637. \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0637\u0628\u064A.","unverified":"\u063A\u064A\u0631 \u0645\u0648\u062B\u0651\u0642"}}}}');


const $dbd8261269f76f6c$var$flatten = (obj, prefix = '', out = {})=>{
    for (const [k, v] of Object.entries(obj)){
        const key = prefix ? `${prefix}.${k}` : k;
        if (v && typeof v === 'object' && !Array.isArray(v)) $dbd8261269f76f6c$var$flatten(v, key, out);
        else out[key] = v;
    }
    return out;
};
const $dbd8261269f76f6c$var$STRINGS = {
    fa: $dbd8261269f76f6c$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($73987793ab7d2855$exports)))),
    en: $dbd8261269f76f6c$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($f174240318190ee4$exports)))),
    ar: $dbd8261269f76f6c$var$flatten((0, (/*@__PURE__*/$parcel$interopDefault($00d73987d3140061$exports))))
};
const $dbd8261269f76f6c$var$owns = (key)=>Object.prototype.hasOwnProperty.call($dbd8261269f76f6c$var$STRINGS.fa, key);
function $dbd8261269f76f6c$export$c18b694ec1d41090(locale, key) {
    const { value: value, from: from } = (0, $0de037e7a1b59dc4$export$b1f08bca8a845a15)($dbd8261269f76f6c$var$STRINGS, locale, key);
    return value == null ? key : (0, $0de037e7a1b59dc4$export$9a328bbde6508c84)(value, undefined, from);
}
function $dbd8261269f76f6c$export$916bf6f0f6c755a5() {
    const { t: t, has: has, locale: locale } = (0, $LNQP4.default)();
    return (0, $acw62.useCallback)((key, vars)=>has(key) || !$dbd8261269f76f6c$var$owns(key) ? t(key, vars) : $dbd8261269f76f6c$export$c18b694ec1d41090(locale, key), [
        t,
        has,
        locale
    ]);
}
const $dbd8261269f76f6c$export$c9095a671b1b967e = Object.keys($dbd8261269f76f6c$var$STRINGS);
const $dbd8261269f76f6c$export$c6f922d42ee1c76c = Object.keys($dbd8261269f76f6c$var$STRINGS.fa);
const $dbd8261269f76f6c$export$28e910e1ccb73949 = (locale)=>$dbd8261269f76f6c$var$STRINGS[locale];


// ─────────────────────────────────────────────────────────────────────────────
// Countries — for the foreign onboarding form (PM-0061).
//
// The SAME rows as the sign-in page's catalogue
// (sso/parsina.keycloakify/src/login/lib/countries.ts), reduced to what a
// country PICKER needs: the ISO code that is stored, the calling code that
// preselects the country of the number the doctor signed in with, and the name
// in each language the panel ships. Add a country there first, then here.
//
// `iso2` is what goes on the wire and into the practitioner record; a name is
// only ever display. The rows are data, so they live in countries.json.
// ─────────────────────────────────────────────────────────────────────────────
var $7b2f184436585d31$exports = {};
$7b2f184436585d31$exports = JSON.parse('[{"iso2":"IR","dial":"98","en":"Iran","fa":"\u0627\u06CC\u0631\u0627\u0646","ar":"\u0625\u064A\u0631\u0627\u0646"},{"iso2":"AF","dial":"93","en":"Afghanistan","fa":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","ar":"\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"},{"iso2":"DZ","dial":"213","en":"Algeria","fa":"\u0627\u0644\u062C\u0632\u0627\u06CC\u0631","ar":"\u0627\u0644\u062C\u0632\u0627\u0626\u0631"},{"iso2":"AM","dial":"374","en":"Armenia","fa":"\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646","ar":"\u0623\u0631\u0645\u064A\u0646\u064A\u0627"},{"iso2":"AU","dial":"61","en":"Australia","fa":"\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627","ar":"\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627"},{"iso2":"AT","dial":"43","en":"Austria","fa":"\u0627\u062A\u0631\u06CC\u0634","ar":"\u0627\u0644\u0646\u0645\u0633\u0627"},{"iso2":"AZ","dial":"994","en":"Azerbaijan","fa":"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646","ar":"\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646"},{"iso2":"BH","dial":"973","en":"Bahrain","fa":"\u0628\u062D\u0631\u06CC\u0646","ar":"\u0627\u0644\u0628\u062D\u0631\u064A\u0646"},{"iso2":"BE","dial":"32","en":"Belgium","fa":"\u0628\u0644\u0698\u06CC\u06A9","ar":"\u0628\u0644\u062C\u064A\u0643\u0627"},{"iso2":"BR","dial":"55","en":"Brazil","fa":"\u0628\u0631\u0632\u06CC\u0644","ar":"\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644"},{"iso2":"CA","dial":"1","en":"Canada","fa":"\u06A9\u0627\u0646\u0627\u062F\u0627","ar":"\u0643\u0646\u062F\u0627"},{"iso2":"CN","dial":"86","en":"China","fa":"\u0686\u06CC\u0646","ar":"\u0627\u0644\u0635\u064A\u0646"},{"iso2":"CY","dial":"357","en":"Cyprus","fa":"\u0642\u0628\u0631\u0633","ar":"\u0642\u0628\u0631\u0635"},{"iso2":"DK","dial":"45","en":"Denmark","fa":"\u062F\u0627\u0646\u0645\u0627\u0631\u06A9","ar":"\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643"},{"iso2":"EG","dial":"20","en":"Egypt","fa":"\u0645\u0635\u0631","ar":"\u0645\u0635\u0631"},{"iso2":"FI","dial":"358","en":"Finland","fa":"\u0641\u0646\u0644\u0627\u0646\u062F","ar":"\u0641\u0646\u0644\u0646\u062F\u0627"},{"iso2":"FR","dial":"33","en":"France","fa":"\u0641\u0631\u0627\u0646\u0633\u0647","ar":"\u0641\u0631\u0646\u0633\u0627"},{"iso2":"GE","dial":"995","en":"Georgia","fa":"\u06AF\u0631\u062C\u0633\u062A\u0627\u0646","ar":"\u062C\u0648\u0631\u062C\u064A\u0627"},{"iso2":"DE","dial":"49","en":"Germany","fa":"\u0622\u0644\u0645\u0627\u0646","ar":"\u0623\u0644\u0645\u0627\u0646\u064A\u0627"},{"iso2":"GR","dial":"30","en":"Greece","fa":"\u06CC\u0648\u0646\u0627\u0646","ar":"\u0627\u0644\u064A\u0648\u0646\u0627\u0646"},{"iso2":"HU","dial":"36","en":"Hungary","fa":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646","ar":"\u0627\u0644\u0645\u062C\u0631"},{"iso2":"IN","dial":"91","en":"India","fa":"\u0647\u0646\u062F","ar":"\u0627\u0644\u0647\u0646\u062F"},{"iso2":"ID","dial":"62","en":"Indonesia","fa":"\u0627\u0646\u062F\u0648\u0646\u0632\u06CC","ar":"\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627"},{"iso2":"IQ","dial":"964","en":"Iraq","fa":"\u0639\u0631\u0627\u0642","ar":"\u0627\u0644\u0639\u0631\u0627\u0642"},{"iso2":"IT","dial":"39","en":"Italy","fa":"\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627","ar":"\u0625\u064A\u0637\u0627\u0644\u064A\u0627"},{"iso2":"JP","dial":"81","en":"Japan","fa":"\u0698\u0627\u067E\u0646","ar":"\u0627\u0644\u064A\u0627\u0628\u0627\u0646"},{"iso2":"JO","dial":"962","en":"Jordan","fa":"\u0627\u0631\u062F\u0646","ar":"\u0627\u0644\u0623\u0631\u062F\u0646"},{"iso2":"KZ","dial":"7","en":"Kazakhstan","fa":"\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646","ar":"\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646"},{"iso2":"KW","dial":"965","en":"Kuwait","fa":"\u06A9\u0648\u06CC\u062A","ar":"\u0627\u0644\u0643\u0648\u064A\u062A"},{"iso2":"LB","dial":"961","en":"Lebanon","fa":"\u0644\u0628\u0646\u0627\u0646","ar":"\u0644\u0628\u0646\u0627\u0646"},{"iso2":"LY","dial":"218","en":"Libya","fa":"\u0644\u06CC\u0628\u06CC","ar":"\u0644\u064A\u0628\u064A\u0627"},{"iso2":"MY","dial":"60","en":"Malaysia","fa":"\u0645\u0627\u0644\u0632\u06CC","ar":"\u0645\u0627\u0644\u064A\u0632\u064A\u0627"},{"iso2":"MR","dial":"222","en":"Mauritania","fa":"\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC","ar":"\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627"},{"iso2":"MA","dial":"212","en":"Morocco","fa":"\u0645\u0631\u0627\u06A9\u0634","ar":"\u0627\u0644\u0645\u063A\u0631\u0628"},{"iso2":"NL","dial":"31","en":"Netherlands","fa":"\u0647\u0644\u0646\u062F","ar":"\u0647\u0648\u0644\u0646\u062F\u0627"},{"iso2":"NZ","dial":"64","en":"New Zealand","fa":"\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F","ar":"\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627"},{"iso2":"NO","dial":"47","en":"Norway","fa":"\u0646\u0631\u0648\u0698","ar":"\u0627\u0644\u0646\u0631\u0648\u064A\u062C"},{"iso2":"OM","dial":"968","en":"Oman","fa":"\u0639\u0645\u0627\u0646","ar":"\u0639\u064F\u0645\u0627\u0646"},{"iso2":"PK","dial":"92","en":"Pakistan","fa":"\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","ar":"\u0628\u0627\u0643\u0633\u062A\u0627\u0646"},{"iso2":"PS","dial":"970","en":"Palestine","fa":"\u0641\u0644\u0633\u0637\u06CC\u0646","ar":"\u0641\u0644\u0633\u0637\u064A\u0646"},{"iso2":"PL","dial":"48","en":"Poland","fa":"\u0644\u0647\u0633\u062A\u0627\u0646","ar":"\u0628\u0648\u0644\u0646\u062F\u0627"},{"iso2":"QA","dial":"974","en":"Qatar","fa":"\u0642\u0637\u0631","ar":"\u0642\u0637\u0631"},{"iso2":"RU","dial":"7","en":"Russia","fa":"\u0631\u0648\u0633\u06CC\u0647","ar":"\u0631\u0648\u0633\u064A\u0627"},{"iso2":"SA","dial":"966","en":"Saudi Arabia","fa":"\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC","ar":"\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629"},{"iso2":"SG","dial":"65","en":"Singapore","fa":"\u0633\u0646\u06AF\u0627\u067E\u0648\u0631","ar":"\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629"},{"iso2":"ZA","dial":"27","en":"South Africa","fa":"\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC","ar":"\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627"},{"iso2":"ES","dial":"34","en":"Spain","fa":"\u0627\u0633\u067E\u0627\u0646\u06CC\u0627","ar":"\u0625\u0633\u0628\u0627\u0646\u064A\u0627"},{"iso2":"SD","dial":"249","en":"Sudan","fa":"\u0633\u0648\u062F\u0627\u0646","ar":"\u0627\u0644\u0633\u0648\u062F\u0627\u0646"},{"iso2":"SE","dial":"46","en":"Sweden","fa":"\u0633\u0648\u0626\u062F","ar":"\u0627\u0644\u0633\u0648\u064A\u062F"},{"iso2":"CH","dial":"41","en":"Switzerland","fa":"\u0633\u0648\u0626\u06CC\u0633","ar":"\u0633\u0648\u064A\u0633\u0631\u0627"},{"iso2":"SY","dial":"963","en":"Syria","fa":"\u0633\u0648\u0631\u06CC\u0647","ar":"\u0633\u0648\u0631\u064A\u0627"},{"iso2":"TJ","dial":"992","en":"Tajikistan","fa":"\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646","ar":"\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646"},{"iso2":"TH","dial":"66","en":"Thailand","fa":"\u062A\u0627\u06CC\u0644\u0646\u062F","ar":"\u062A\u0627\u064A\u0644\u0627\u0646\u062F"},{"iso2":"TN","dial":"216","en":"Tunisia","fa":"\u062A\u0648\u0646\u0633","ar":"\u062A\u0648\u0646\u0633"},{"iso2":"TR","dial":"90","en":"T\xfcrkiye","fa":"\u062A\u0631\u06A9\u06CC\u0647","ar":"\u062A\u0631\u0643\u064A\u0627"},{"iso2":"TM","dial":"993","en":"Turkmenistan","fa":"\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646","ar":"\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646"},{"iso2":"UA","dial":"380","en":"Ukraine","fa":"\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646","ar":"\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627"},{"iso2":"AE","dial":"971","en":"United Arab Emirates","fa":"\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC","ar":"\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"},{"iso2":"GB","dial":"44","en":"United Kingdom","fa":"\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627","ar":"\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"},{"iso2":"US","dial":"1","en":"United States","fa":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647","ar":"\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629"},{"iso2":"UZ","dial":"998","en":"Uzbekistan","fa":"\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646","ar":"\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646"},{"iso2":"YE","dial":"967","en":"Yemen","fa":"\u06CC\u0645\u0646","ar":"\u0627\u0644\u064A\u0645\u0646"}]');


const $7df9e74cb8affcc9$export$4d78c43b7fa734a7 = (0, (/*@__PURE__*/$parcel$interopDefault($7b2f184436585d31$exports)));
const $7df9e74cb8affcc9$export$3162e773cd568eb = (country, locale)=>country?.[String(locale || '').split('-')[0]] || country?.en || '';
const $7df9e74cb8affcc9$var$toLatinDigits = (value)=>String(value ?? '').replace(/[۰-۹٠-٩]/g, (ch)=>{
        const code = ch.charCodeAt(0);
        return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
    });
function $7df9e74cb8affcc9$export$b88373ccfbcd4924(phone) {
    const compact = $7df9e74cb8affcc9$var$toLatinDigits(phone).replace(/[\s\-().]/g, '');
    const match = /^(?:\+|00)(\d{6,15})$/.exec(compact);
    if (!match) return null;
    return $7df9e74cb8affcc9$export$4d78c43b7fa734a7.find((c)=>match[1].startsWith(c.dial)) || null;
}


// The specialty catalogue for the FOREIGN onboarding (PM-0074).
//
// The list comes from the practitioner service's `specialties` table through
// the BFF's `specialties` query, labelled in Persian, English and Arabic — it
// is not `constants/specialties.js`, which only translates a stored value for
// display. What the form SENDS is the row's `code`; the BFF stores that row's
// Persian name, so `doctor.specialty` stays Persian in every language.
//
// «سایر» (OTHER_SPECIALTY) opens a text box for a specialty the list does not
// name; that text is stored as typed.

const $6b05e47623abe260$export$3f42b6d60371a1bb = `
  query Specialties {
    specialties { code kind nameFa nameEn nameAr sortOrder }
  }
`;
const $6b05e47623abe260$export$fa775b47de314423 = 'other';
const $6b05e47623abe260$export$7891c9316c10d37b = 'specialty';
const $6b05e47623abe260$export$7e7250193bc8e7c5 = 'subspecialty';
const $6b05e47623abe260$export$4c607a770c79b87b = (row, locale)=>{
    if (locale === 'en') return row.nameEn || row.nameFa;
    if (locale === 'ar') return row.nameAr || row.nameFa;
    return row.nameFa;
};
function $6b05e47623abe260$export$e504dc44091fe96c(rows, locale) {
    const compare = locale === 'fa' || !locale ? (a, b)=>(0, $b0b690e819784781$export$fe3546b490ad2b51)(a.label, b.label) : (a, b)=>a.label.localeCompare(b.label, locale);
    return [
        $6b05e47623abe260$export$7891c9316c10d37b,
        $6b05e47623abe260$export$7e7250193bc8e7c5
    ].map((kind)=>({
            kind: kind,
            rows: (rows || []).filter((r)=>(r.kind === $6b05e47623abe260$export$7e7250193bc8e7c5 ? $6b05e47623abe260$export$7e7250193bc8e7c5 : $6b05e47623abe260$export$7891c9316c10d37b) === kind).map((r)=>({
                    code: r.code,
                    label: $6b05e47623abe260$export$4c607a770c79b87b(r, locale)
                })).sort(compare)
        })).filter((g)=>g.rows.length > 0);
}


// ── GraphQL mutations ─────────────────────────────────────────────────────────
// The doctor's name is no longer asked for, or read from the token.
//
// It used to come from the JWT claims and, when those were empty (a phone +
// SMS-code account carries none), from a field on this form. Both are gone:
// the name on a prescription is the one سازمان نظام پزشکی holds against the
// council number, so the wizard reads it instead of asking anyone.
const $62b061fca587e5c8$var$LOOKUP_COUNCIL_MEMBER = `
  query LookupCouncilMember($code: String!) {
    lookupCouncilMember(code: $code) {
      status
      member { councilNumber fullName specialty degree memberType province city }
    }
  }
`;
const $62b061fca587e5c8$var$COMPLETE_STEP1 = `
  mutation CompleteOnboardingStep1($input: OnboardingStep1Input!) {
    completeOnboardingStep1(input: $input) {
      id fullName medicalCode specialty bio
    }
  }
`;
// Which onboarding this account gets, and in which language (PM-0060/0061).
// Both follow from the country of the number the doctor signed in with, and the
// BFF reads that from the platform's own record — this screen only asks.
const $62b061fca587e5c8$var$ONBOARDING_CONTEXT = `
  query OnboardingContext {
    onboardingContext { foreign phone impliedLanguage }
  }
`;
// The manual form a doctor on a non-Iranian number fills in place of the
// council number. Refused by the BFF for any other account.
const $62b061fca587e5c8$var$COMPLETE_FOREIGN = `
  mutation CompleteForeignOnboarding($input: ForeignOnboardingInput!) {
    completeForeignOnboarding(input: $input) {
      id fullName medicalCode specialty degree country city selfDeclared bio
    }
  }
`;
// ── Shared UI primitives ──────────────────────────────────────────────────────
// ── The first screen a new doctor sees (finding 12) ─────────────────────────
// It had four defects at once, and they all showed on a phone: raw `<button>`s
// with hand-written gradients, literal px and hex, and a fixed 520px card that
// on a 360px screen is wider than the window. The fix is not a second render
// tree — the three steps are one-field-per-row forms that would be IDENTICAL on
// both surfaces, and a fork of a form is two files to keep in sync for no
// behavioural difference. What was actually wrong is the SHELL (full-bleed and
// docked on a phone, a card on a desktop) and the primitives, so those are what
// changed.
const $62b061fca587e5c8$var$ErrorBox = ({ msg: msg })=>msg ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            padding: '0.625rem 0.875rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.C).redLight}`,
            borderRadius: '0.5rem',
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).dangerInk,
            textAlign: 'start',
            lineHeight: 1.6
        },
        children: msg
    }) : null;
// The kit Button, not a hand-rolled one. `min-h-11` is §6's hit-target floor —
// the old 46px happened to clear it and nothing held it there.
const $62b061fca587e5c8$var$Btn = ({ children: children, onClick: onClick, type: type = 'button', disabled: disabled, secondary: secondary, fullWidth: fullWidth, danger: danger, testId: testId, ...rest })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        type: type,
        onClick: onClick,
        disabled: disabled,
        "data-testid": testId,
        ...rest,
        variant: danger ? 'destructive' : secondary ? 'outline' : 'default',
        size: "lg",
        className: `min-h-11 font-bold whitespace-nowrap${fullWidth ? ' w-full' : ''}${secondary || danger ? '' : ' bg-gradient-brand'}`,
        children: children
    });
const $62b061fca587e5c8$var$Field = ({ label: label, required: required, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                style: {
                    fontSize: 12,
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: (0, $jTCZr.C).red,
                            marginInlineStart: 2
                        },
                        children: "*"
                    })
                ]
            }),
            children
        ]
    });
const $62b061fca587e5c8$var$inputBase = {
    height: 40,
    padding: '0 10px',
    border: `1.5px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 8,
    fontSize: 13,
    fontFamily: 'var(--app-font)',
    color: (0, $jTCZr.C).textPrimary,
    outline: 'none',
    background: 'white',
    width: '100%',
    boxSizing: 'border-box'
};
// The rest of the props reach the `<input>`. Without that, anything a caller
// writes the DOM's way — `dir="ltr"`, `data-testid`, `inputMode`, `autoFocus`
// — is silently swallowed by this wrapper, which is how the council-number
// field ended up reading right-to-left with no test id: both were passed, and
// neither was in the signature. `ltr` stays as the shorthand this file already
// uses; an explicit `dir` wins over it.
const $62b061fca587e5c8$var$TextInput = ({ label: label, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, required: required, type: type = 'text', ltr: ltr, testId: testId, ...rest })=>/*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$Field, {
        label: label,
        required: required,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            type: type,
            "data-testid": testId,
            value: value,
            placeholder: placeholder,
            onChange: (e)=>onChange(e.target.value),
            ...rest,
            style: {
                ...$62b061fca587e5c8$var$inputBase,
                direction: rest.dir || (ltr ? 'ltr' : 'rtl'),
                ...rest.style || {}
            },
            onFocus: (e)=>{
                e.target.style.borderColor = (0, $jTCZr.C).navy;
            },
            onBlur: (e)=>{
                e.target.style.borderColor = (0, $jTCZr.C).border;
                onBlur?.(e);
            }
        })
    });
// Collapsed by default — optional, and editable later in settings. Shared by
// both forms: the council one and the foreign one end the same way.
const $62b061fca587e5c8$var$BioDisclosure = ({ open: open, onToggle: onToggle, value: value, onChange: onChange })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                type: "button",
                variant: "ghost",
                size: "sm",
                "data-testid": "onboarding-bio-toggle",
                "aria-expanded": open,
                "aria-controls": "onboarding-bio-panel",
                onClick: onToggle,
                className: "min-h-11 w-full justify-between px-2 font-semibold",
                style: {
                    color: (0, $jTCZr.C).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t('auth.onboarding.bioOptional')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                        size: 16,
                        "aria-hidden": "true",
                        style: {
                            transition: 'transform 0.2s',
                            transform: open ? 'rotate(180deg)' : 'none'
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "onboarding-bio-panel",
                style: {
                    marginTop: 6
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                    "data-testid": "onboarding-bio",
                    "aria-label": t('auth.onboarding.bioOptional'),
                    autoFocus: true,
                    value: value,
                    onChange: (e)=>onChange(e.target.value),
                    placeholder: t('settings.profile.bioPlaceholder'),
                    rows: 3,
                    style: {
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: 8,
                        padding: '10px 12px',
                        fontSize: 13,
                        fontFamily: 'var(--app-font)',
                        color: (0, $jTCZr.C).textPrimary,
                        outline: 'none',
                        resize: 'vertical',
                        width: '100%',
                        boxSizing: 'border-box'
                    },
                    onFocus: (e)=>{
                        e.target.style.borderColor = (0, $jTCZr.C).navy;
                    },
                    onBlur: (e)=>{
                        e.target.style.borderColor = (0, $jTCZr.C).border;
                    }
                })
            })
        ]
    });
};
// ── Welcome ───────────────────────────────────────────────────────────────────
//
// The welcome used to be a screen of its own — a card, a one-item checklist and
// a «شروع» button — in front of a form that is itself one field. It is now the
// top of that form: the doctor lands on the council-number field with the
// greeting above it, and there is nothing to press before they can start.
const $62b061fca587e5c8$var$WelcomeHeader = ()=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "onboarding-welcome",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            marginBottom: 20
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 48,
                    height: 48,
                    borderRadius: 12,
                    flexShrink: 0,
                    background: `linear-gradient(135deg, ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06)}, ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.16)})`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    viewBox: "0 0 24 24",
                    fill: (0, $jTCZr.C).navyDark,
                    width: "24",
                    height: "24",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20 6h-2.18c.07-.44.18-.88.18-1.34C18 2.54 15.86.6 13.16.6c-1.6 0-3.05.8-3.93 2.02L12 5.46l2.77-2.84C15.23 2.24 16.15 2 17 2c1.66 0 3 1.34 3 3s-1.34 3-3 3h-3.45L12 9.46l-1.55-1.46H7C5.34 8 4 6.66 4 5s1.34-3 3-3c.85 0 1.77.24 2.23.62L12 5.46 14.84 2.62C13.96 1.4 12.51.6 10.91.6 8.21.6 6 2.54 6 4.66c0 .46.11.9.18 1.34H4C2.9 6 2 6.9 2 8v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H4V8h16v12z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 18,
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: 4
                        },
                        children: t('auth.onboarding.welcome')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.8
                        },
                        children: t('auth.onboarding.welcomeBody')
                    })
                ]
            })
        ]
    });
};
// ── Stage: Step 1 — the doctor's professional identity ───────────────────────
//
// One field: the کد نظام پزشکی. Everything else on this screen is READ — name,
// degree, specialty, city — from سامانه جستجوی اعضای سازمان نظام پزشکی, which
// is the authority on all of it. The doctor does not type their name and does
// not pick a specialty, and there is no «تأیید / این من نیستم» step: the
// council's record for that number either exists or it does not.
//
// The read-only rendering here is a courtesy, not the rule — the BFF resolves
// the code again and writes the council's values whatever this screen sends
// (see resolvers/onboarding.js). That is what makes "the doctor cannot edit it"
// true rather than merely displayed.
// ── When the استعلام runs ────────────────────────────────────────────────────
//
// There is no «استعلام» button: the lookup starts by itself, off the number of
// DIGITS typed. The council allows ten searches per ten minutes to the whole
// platform — every pod leaves through one address — so a lookup per keystroke
// would spend that allowance on «۱», «۱۲», «۱۲۵» before the first doctor
// finished typing. The thresholds below are what keeps the common case to one
// request:
//
//   • 6+ digits — a current council number is six digits, so the moment it is
//     complete there is nothing to wait for;
//   • 4–5 digits — real, but held by long-registered doctors (`1000`, `25000`
//     and `80000` are members), so those wait for a pause in typing instead. A
//     doctor entering a six-digit number rarely stops for 1.2s mid-number;
//   • fewer — never automatically. Leaving the field still looks up, as before.
const $62b061fca587e5c8$var$IMMEDIATE_DIGITS = 6;
const $62b061fca587e5c8$var$AUTO_MIN_DIGITS = 4;
const $62b061fca587e5c8$var$TYPING_PAUSE_MS = 1200;
/**
 * The digits in what was typed, Persian and Arabic-Indic ones included — a
 * phone keyboard produces «۱۲۵۰۰۰», and that is six digits, not zero. Letters
 * of a profession prefix («د-»، «ع-آ-») are not digits and do not count.
 */ const $62b061fca587e5c8$var$councilDigits = (value)=>String(value ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06F0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/\D/g, '');
/** One line of the council's record. Rendered, never edited. */ const $62b061fca587e5c8$var$RegistryRow = ({ label: label, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'baseline',
            fontSize: 13,
            lineHeight: 1.9
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: (0, $jTCZr.C).textSecondary,
                    minWidth: 96,
                    flexShrink: 0
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: (0, $jTCZr.C).textPrimary,
                    fontWeight: 600
                },
                children: value
            })
        ]
    });
const $62b061fca587e5c8$var$StepDoctorInfo = ({ onDone: onDone })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [code, setCode] = (0, $acw62.useState)('');
    const [member, setMember] = (0, $acw62.useState)(null);
    const [looking, setLooking] = (0, $acw62.useState)(false);
    const [bio, setBio] = (0, $acw62.useState)('');
    // Collapsed until asked for: the bio is optional, and an open textarea under
    // the council record read as one more thing the doctor had to fill in.
    const [bioOpen, setBioOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // The code the card on screen belongs to. Without it, editing the number
    // after a successful lookup would leave the previous doctor's name sitting
    // under a different number — and «ادامه» would still be enabled.
    const shownFor = (0, $acw62.useRef)('');
    // The value of the field right now, readable from a timer callback that was
    // scheduled one or more keystrokes ago.
    const codeRef = (0, $acw62.useRef)('');
    // The value the last request was sent for — set BEFORE the await, so it also
    // means "in flight" and one number is never asked twice.
    const askedRef = (0, $acw62.useRef)('');
    // …except when the answer was UNAVAILABLE, which is ours and transient: a
    // blur must be able to try that same number again.
    const retryableRef = (0, $acw62.useRef)(false);
    // Latest-wins. A doctor who types «12500», pauses long enough for it to be
    // sent, then adds a «0» must never be shown the record for «12500» because
    // it came back second.
    const seqRef = (0, $acw62.useRef)(0);
    const pauseRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(pauseRef.current), []);
    const runLookup = async (raw)=>{
        const asked = String(raw ?? '').trim();
        if (!asked || !$62b061fca587e5c8$var$councilDigits(asked)) return;
        if (asked === askedRef.current && !retryableRef.current) return;
        askedRef.current = asked;
        retryableRef.current = false;
        const seq = ++seqRef.current;
        setLooking(true);
        setError(null);
        setMember(null);
        // True while this answer is still the one being waited for. A superseded
        // request returns without touching the screen at all — including `looking`,
        // which the newer request owns.
        const current = ()=>seq === seqRef.current && codeRef.current.trim() === asked;
        try {
            const res = await (0, $adebb901af88e18b$export$7fb4864174f056c)($62b061fca587e5c8$var$LOOKUP_COUNCIL_MEMBER, {
                code: asked
            });
            if (!current()) return;
            const result = res?.lookupCouncilMember;
            shownFor.current = asked;
            if (result?.status === 'FOUND' && result.member) setMember(result.member);
            else if (result?.status === 'AMBIGUOUS') setError(t('auth.onboarding.codeAmbiguous'));
            else if (result?.status === 'NOT_FOUND') setError(t('auth.onboarding.codeNotFound'));
            else {
                // UNAVAILABLE — ours to fix, not the doctor's. Never «کد اشتباه است».
                retryableRef.current = true;
                setError(t('auth.onboarding.registryUnavailable'));
            }
            setLooking(false);
        } catch (e) {
            if (!current()) return;
            shownFor.current = '';
            retryableRef.current = true;
            setError(e.message || t('auth.onboarding.registryUnavailable'));
            setLooking(false);
        }
    };
    const setCodeField = (value)=>{
        setCode(value);
        codeRef.current = value;
        clearTimeout(pauseRef.current);
        if (value.trim() !== shownFor.current) {
            setMember(null);
            setError(null);
        }
        const digits = $62b061fca587e5c8$var$councilDigits(value);
        if (digits.length >= $62b061fca587e5c8$var$IMMEDIATE_DIGITS) runLookup(value);
        else if (digits.length >= $62b061fca587e5c8$var$AUTO_MIN_DIGITS) pauseRef.current = setTimeout(()=>runLookup(codeRef.current), $62b061fca587e5c8$var$TYPING_PAUSE_MS);
    };
    // Leaving the field asks for whatever is in it, however short — the one way a
    // doctor with a two- or three-digit number gets a lookup at all.
    const handleBlur = ()=>{
        clearTimeout(pauseRef.current);
        runLookup(codeRef.current);
    };
    const handleNext = async ()=>{
        if (!member) {
            setError(t('validation.medicalCodeRequired'));
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($62b061fca587e5c8$var$COMPLETE_STEP1, {
                input: {
                    // The council's own spelling, not what was typed.
                    medicalCode: member.councilNumber,
                    bio: bio.trim() || undefined
                }
            });
            const doctor = res?.completeOnboardingStep1;
            if (!doctor?.id) throw new Error(t('errors.save.doctorProfile'));
            // There is no «تایید» screen after this any more: saving IS finishing.
            // `loading` stays true through `onDone`, because the host refreshes the
            // token (and may wait for the role to propagate) before the panel opens,
            // and a button that re-enabled in that gap would invite a second submit.
            await onDone({
                doctor: doctor
            });
            return;
        } catch (e) {
            const code = e.extensions?.code;
            if (code === 'DUPLICATE_MEDICAL_CODE') setError(t('auth.onboarding.codeTaken'));
            else if (code === 'COUNCIL_CODE_NOT_FOUND') setError(t('auth.onboarding.codeNotFound'));
            else if (code === 'COUNCIL_CODE_AMBIGUOUS') setError(t('auth.onboarding.codeAmbiguous'));
            else if (code === 'COUNCIL_REGISTRY_UNAVAILABLE') setError(t('auth.onboarding.registryUnavailable'));
            else setError(e.message || t('errors.save.generic'));
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$WelcomeHeader, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginBottom: 4,
                    paddingTop: 16,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 15,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: 4
                        },
                        children: t('auth.onboarding.professional')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: t('auth.onboarding.registryPrompt')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                        label: t('common.labels.medicalCode'),
                        value: code,
                        onChange: setCodeField,
                        onBlur: handleBlur,
                        placeholder: t('settings.profile.medicalCodeExample'),
                        required: true,
                        dir: "ltr",
                        "data-testid": "onboarding-medical-code"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "onboarding-lookup-status",
                        "aria-live": "polite",
                        "aria-busy": looking || undefined,
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            fontSize: 12,
                            color: (0, $jTCZr.C).navyDark,
                            marginTop: 6,
                            minHeight: 18,
                            lineHeight: 1.6
                        },
                        children: looking && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    "aria-hidden": "true",
                                    style: {
                                        display: 'inline-flex',
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: 14,
                                        thickness: 2,
                                        color: (0, $jTCZr.C).navy,
                                        label: ""
                                    })
                                }),
                                t('auth.onboarding.lookingUp')
                            ]
                        })
                    })
                ]
            }),
            member && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "onboarding-council-record",
                style: {
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    padding: '12px 14px',
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.06),
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).teal,
                            marginBottom: 6
                        },
                        children: t('auth.onboarding.registryTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('common.labels.fullName'),
                        value: member.fullName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('common.labels.medicalCode'),
                        value: member.councilNumber
                    }),
                    member.degree && /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('auth.onboarding.registryDegree'),
                        value: member.degree
                    }),
                    member.specialty && /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('common.labels.specialty'),
                        value: member.specialty
                    }),
                    member.memberType && /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('auth.onboarding.registryMemberType'),
                        value: member.memberType
                    }),
                    (member.province || member.city) && /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$RegistryRow, {
                        label: t('auth.onboarding.registryCity'),
                        value: [
                            member.province,
                            member.city
                        ].filter(Boolean).join(" \u2014 ")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 8,
                            lineHeight: 1.8
                        },
                        children: t('auth.onboarding.registryLocked')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$BioDisclosure, {
                open: bioOpen,
                onToggle: ()=>setBioOpen((o)=>!o),
                value: bio,
                onChange: setBio
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$ErrorBox, {
                msg: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$Btn, {
                fullWidth: true,
                onClick: handleNext,
                disabled: loading || !member,
                testId: "onboarding-next",
                children: loading ? t('auth.onboarding.saving') : t('auth.onboarding.enterPanel')
            })
        ]
    });
};
// ── Stage: Step 1 for a doctor licensed OUTSIDE Iran (PM-0061) ───────────────
//
// A doctor who signed in with a non-Iranian number has no کد نظام پزشکی, so
// there is nothing to look up and nothing to read: this is the one form on
// which a doctor TYPES their professional identity. Name, specialty, degree,
// country and city are required; the licence number their own country issued
// is optional.
//
// Nothing is verified, and the form says so before the doctor saves rather
// than after: the profile it creates is shown as «تأییدنشده».
//
// Which form an account gets is the BFF's decision, read from its record of the
// number — rendering this one for an Iranian account would only earn a refusal
// from `completeForeignOnboarding`.
const $62b061fca587e5c8$var$StepForeignInfo = ({ phone: phone, onDone: onDone })=>{
    const { t: t, locale: locale } = (0, $LNQP4.default)();
    const s = (0, $dbd8261269f76f6c$export$916bf6f0f6c755a5)();
    const [form, setForm] = (0, $acw62.useState)(()=>({
            // `specialtyCode` is a catalogue row's code, or OTHER_SPECIALTY with the
            // doctor's own words in `specialty` (PM-0074).
            fullName: '',
            specialtyCode: '',
            specialty: '',
            degree: '',
            // The country of the number they signed in with is the likeliest issuer of
            // their licence, so it is offered — and stays theirs to change.
            country: (0, $7df9e74cb8affcc9$export$b88373ccfbcd4924)(phone)?.iso2 || '',
            city: '',
            licenseNumber: ''
        }));
    const [bio, setBio] = (0, $acw62.useState)('');
    const [bioOpen, setBioOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // The catalogue (PM-0074). `null` = still loading; `[]` = unavailable (a BFF
    // older than the query), in which case the form falls back to the free-text
    // box it had before — onboarding must never be blocked by a list.
    const [catalogue, setCatalogue] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        (0, $adebb901af88e18b$export$7fb4864174f056c)((0, $6b05e47623abe260$export$3f42b6d60371a1bb)).then((data)=>{
            if (alive) setCatalogue(data?.specialties || []);
        }).catch(()=>{
            if (alive) setCatalogue([]);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    const pickerless = Array.isArray(catalogue) && catalogue.length === 0;
    const typing = pickerless || form.specialtyCode === (0, $6b05e47623abe260$export$fa775b47de314423);
    const set = (name)=>(value)=>setForm((f)=>({
                    ...f,
                    [name]: value
                }));
    const specialtyGiven = typing ? form.specialty.trim() !== '' : form.specialtyCode !== '';
    const complete = specialtyGiven && [
        'fullName',
        'degree',
        'country',
        'city'
    ].every((name)=>form[name].trim() !== '');
    const handleSubmit = async ()=>{
        if (!complete) {
            setError(s('auth.onboarding.foreign.incomplete'));
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await (0, $adebb901af88e18b$export$8395d0fc0d822a81)($62b061fca587e5c8$var$COMPLETE_FOREIGN, {
                input: {
                    fullName: form.fullName.trim(),
                    // A picked row sends only its code — the BFF stores its Persian name.
                    ...pickerless ? {
                        specialty: form.specialty.trim()
                    } : {
                        specialtyCode: form.specialtyCode,
                        specialty: typing ? form.specialty.trim() : undefined
                    },
                    degree: form.degree.trim(),
                    country: form.country,
                    city: form.city.trim(),
                    licenseNumber: form.licenseNumber.trim() || undefined,
                    bio: bio.trim() || undefined
                }
            });
            const doctor = res?.completeForeignOnboarding;
            if (!doctor?.id) throw new Error(t('errors.save.doctorProfile'));
            // As on the council form: `loading` stays true through `onDone`.
            await onDone({
                doctor: doctor
            });
            return;
        } catch (e) {
            const code = e.extensions?.code;
            if (code === 'DUPLICATE_LICENSE_NUMBER') setError(s('auth.onboarding.foreign.licenseTaken'));
            else if (code === 'FOREIGN_PROFILE_INCOMPLETE') setError(s('auth.onboarding.foreign.incomplete'));
            else if (code === 'FOREIGN_ONBOARDING_NOT_ALLOWED') setError(s('auth.onboarding.foreign.notAllowed'));
            else if (code === 'SPECIALTY_UNKNOWN') setError(s('auth.onboarding.foreign.specialtyUnknown'));
            else setError(e.message || t('errors.save.generic'));
        }
        setLoading(false);
    };
    const countries = [
        ...(0, $7df9e74cb8affcc9$export$4d78c43b7fa734a7)
    ].sort((a, b)=>(0, $7df9e74cb8affcc9$export$3162e773cd568eb)(a, locale).localeCompare((0, $7df9e74cb8affcc9$export$3162e773cd568eb)(b, locale), locale));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        "data-testid": "onboarding-foreign-form",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$WelcomeHeader, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginBottom: 4,
                    paddingTop: 16,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 15,
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: 4
                        },
                        children: t('auth.onboarding.professional')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.8
                        },
                        children: s('auth.onboarding.foreign.prompt')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                label: s('auth.onboarding.foreign.fullName'),
                value: form.fullName,
                onChange: set('fullName'),
                required: true,
                dir: "auto",
                autoComplete: "name",
                maxLength: 120,
                "data-testid": "onboarding-foreign-fullName"
            }),
            pickerless ? /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                label: s('auth.onboarding.foreign.specialty'),
                value: form.specialty,
                onChange: set('specialty'),
                placeholder: s('auth.onboarding.foreign.specialtyPlaceholder'),
                required: true,
                dir: "auto",
                maxLength: 120,
                "data-testid": "onboarding-foreign-specialty"
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$Field, {
                        label: s('auth.onboarding.foreign.specialty'),
                        required: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            "data-testid": "onboarding-foreign-specialty-select",
                            "aria-label": s('auth.onboarding.foreign.specialty'),
                            value: form.specialtyCode,
                            disabled: catalogue === null,
                            onChange: (e)=>set('specialtyCode')(e.target.value),
                            style: {
                                ...$62b061fca587e5c8$var$inputBase,
                                appearance: 'auto'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "",
                                    children: s('auth.onboarding.foreign.specialtyChoose')
                                }),
                                (0, $6b05e47623abe260$export$e504dc44091fe96c)(catalogue, locale).map((g)=>/*#__PURE__*/ (0, $ayMG0.jsx)("optgroup", {
                                        label: s(g.kind === (0, $6b05e47623abe260$export$7e7250193bc8e7c5) ? 'auth.onboarding.foreign.specialtyGroupSubspecialty' : 'auth.onboarding.foreign.specialtyGroupSpecialty'),
                                        children: g.rows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: r.code,
                                                children: r.label
                                            }, r.code))
                                    }, g.kind)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: (0, $6b05e47623abe260$export$fa775b47de314423),
                                    children: s('auth.onboarding.foreign.specialtyOther')
                                })
                            ]
                        })
                    }),
                    typing && /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                        label: s('auth.onboarding.foreign.specialtyOtherLabel'),
                        value: form.specialty,
                        onChange: set('specialty'),
                        placeholder: s('auth.onboarding.foreign.specialtyPlaceholder'),
                        required: true,
                        dir: "auto",
                        maxLength: 120,
                        "data-testid": "onboarding-foreign-specialty"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                label: s('auth.onboarding.foreign.degree'),
                value: form.degree,
                onChange: set('degree'),
                placeholder: s('auth.onboarding.foreign.degreePlaceholder'),
                required: true,
                dir: "auto",
                maxLength: 120,
                "data-testid": "onboarding-foreign-degree"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$Field, {
                label: s('auth.onboarding.foreign.country'),
                required: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                    "data-testid": "onboarding-foreign-country",
                    "aria-label": s('auth.onboarding.foreign.country'),
                    value: form.country,
                    onChange: (e)=>set('country')(e.target.value),
                    style: {
                        ...$62b061fca587e5c8$var$inputBase,
                        appearance: 'auto'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: "",
                            children: s('auth.onboarding.foreign.countryPlaceholder')
                        }),
                        countries.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: c.iso2,
                                children: (0, $7df9e74cb8affcc9$export$3162e773cd568eb)(c, locale)
                            }, c.iso2))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                label: s('auth.onboarding.foreign.city'),
                value: form.city,
                onChange: set('city'),
                required: true,
                dir: "auto",
                maxLength: 80,
                "data-testid": "onboarding-foreign-city"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$TextInput, {
                        label: s('auth.onboarding.foreign.license'),
                        value: form.licenseNumber,
                        onChange: set('licenseNumber'),
                        dir: "ltr",
                        maxLength: 40,
                        "data-testid": "onboarding-foreign-license"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 4,
                            lineHeight: 1.8
                        },
                        children: s('auth.onboarding.foreign.licenseHint')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$BioDisclosure, {
                open: bioOpen,
                onToggle: ()=>setBioOpen((o)=>!o),
                value: bio,
                onChange: setBio
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "onboarding-foreign-notice",
                style: {
                    padding: '0.625rem 0.875rem',
                    background: (0, $jTCZr.CT).warnSoft,
                    borderRadius: '0.5rem',
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.CT).warnInk,
                    lineHeight: 1.8
                },
                children: s('auth.onboarding.foreign.notice')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$ErrorBox, {
                msg: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$Btn, {
                fullWidth: true,
                onClick: handleSubmit,
                disabled: loading || !complete,
                testId: "onboarding-next",
                children: loading ? t('auth.onboarding.saving') : t('auth.onboarding.enterPanel')
            })
        ]
    });
};
// ── The prize wheel, when a campaign has one waiting ──────────────────────────
//
// Asked for ONCE, right after step 1 succeeds, because that is the moment the
// BFF has written the practitioner record the offer is decided from
// (docs/ONBOARDING_PRIZE_WHEEL_PLAN.md §5.2). It returns [] for almost every
// doctor and it is allowed to fail: a campaign service that is down must cost a
// doctor nothing more than a wheel they never knew about, so any failure here
// falls through to the panel exactly as if no wheel were offered.
const $62b061fca587e5c8$var$MY_PRIZE_DRAWS = `
  query MyPrizeDraws {
    myPrizeDraws {
      id wheelCode title subtitle status
      segments { index label kind amount }
      segmentIndex kind amount smartVisits
      whatsappMessages baleMessages smsMessages retry
      balance { balance currency }
      endsAtMs
    }
  }
`;
// A wheel worth showing: not spun yet, and with enough slices to BE a wheel
// (the kit draws nothing under two, so a one-slice campaign would render an
// empty page with a button on it).
const $62b061fca587e5c8$var$offeredDraw = (draws)=>(Array.isArray(draws) ? draws : []).find((d)=>d?.status === 'offered' && Array.isArray(d.segments) && d.segments.length >= 2) || null;
function $62b061fca587e5c8$export$2e2bcd8739ae039({ onComplete: onComplete }) {
    const { t: t, setLocale: setLocale } = (0, $LNQP4.default)();
    const [stage, setStage] = (0, $acw62.useState)('step1');
    const [draw, setDraw] = (0, $acw62.useState)(null);
    // Which form this account gets. `undefined` while the BFF is being asked;
    // after that always an object, and the COUNCIL form is what every failure
    // falls back to — a BFF older than this screen, a network error, an account
    // whose number says nothing. The foreign form is only ever shown on a
    // positive answer.
    const [context, setContext] = (0, $acw62.useState)(undefined);
    const setLocaleRef = (0, $acw62.useRef)(setLocale);
    setLocaleRef.current = setLocale;
    (0, $acw62.useEffect)(()=>{
        let live = true;
        Promise.resolve().then(()=>(0, $adebb901af88e18b$export$7fb4864174f056c)($62b061fca587e5c8$var$ONBOARDING_CONTEXT)).then((data)=>data?.onboardingContext || {}).catch(()=>({})).then((ctx)=>{
            if (!live) return;
            // A doctor who is still onboarding has never seen the language picker,
            // so the language of their number's country is the best answer there
            // is (PM-0060): an Iraqi number is greeted in Arabic. The BFF stores it
            // as their setting when onboarding completes; `setLocale` ignores a tag
            // this build does not ship.
            if (ctx.impliedLanguage) setLocaleRef.current?.(ctx.impliedLanguage);
            setContext(ctx);
        });
        return ()=>{
            live = false;
        };
    }, []);
    const handleComplete = async ()=>{
        if (onComplete) await onComplete();
        else window.location.href = '/reception';
    };
    // Step 1 is saved. Before the panel, ask whether a campaign owes this doctor
    // a spin. Nothing here can keep them from finishing: no draw, a malformed
    // one, or a thrown request all end in the same place. Outside the Iranian
    // market (`market: 'intl'`, docs/rebranding/CONTRACT.md) there is no campaign
    // to ask: the wheel pays in the Iranian campaign's credit.
    const afterStep1 = async ()=>{
        if (!(0, $eLeza.isIranMarket)()) {
            await handleComplete();
            return;
        }
        try {
            const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)($62b061fca587e5c8$var$MY_PRIZE_DRAWS);
            const offered = $62b061fca587e5c8$var$offeredDraw(data?.myPrizeDraws);
            if (offered) {
                setDraw(offered);
                setStage('prize');
                return;
            }
        } catch  {
        /* the wheel is a bonus; onboarding is not */ }
        await handleComplete();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $82f105c7f47687ac$export$2e2bcd8739ae039), {
        subtitle: stage === 'prize' ? t('auth.onboarding.prize.title') : t('auth.onboarding.setupTitle'),
        children: [
            stage === 'step1' && context === undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
                fields: 2,
                actions: 1,
                "data-testid": "onboarding-loading"
            }),
            stage === 'step1' && context !== undefined && (context.foreign || !(0, $eLeza.isIranMarket)() ? /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$StepForeignInfo, {
                phone: context.phone,
                onDone: afterStep1
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($62b061fca587e5c8$var$StepDoctorInfo, {
                onDone: afterStep1
            })),
            stage === 'prize' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26ce0214a2875133$export$2e2bcd8739ae039), {
                draw: draw,
                onDone: handleComplete
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


function $a4dcd4341a330928$export$2e2bcd8739ae039({ draw: draw, onDone: onDone }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!draw) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82f105c7f47687ac$export$2e2bcd8739ae039), {
        subtitle: draw.title || t('auth.onboarding.prize.title'),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26ce0214a2875133$export$2e2bcd8739ae039), {
            draw: draw,
            onDone: onDone
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ff7470c68047af0a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
            key: "9ktpf1"
        }
    ]
];
const $ff7470c68047af0a$export$2e2bcd8739ae039 = (0, $9QBug.default)("compass", $ff7470c68047af0a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $bc1e7ed8cf57d9c1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10.852 14.772-.383.923",
            key: "11vil6"
        }
    ],
    [
        "path",
        {
            d: "M13.148 14.772a3 3 0 1 0-2.296-5.544l-.383-.923",
            key: "1v3clb"
        }
    ],
    [
        "path",
        {
            d: "m13.148 9.228.383-.923",
            key: "t2zzyc"
        }
    ],
    [
        "path",
        {
            d: "m13.53 15.696-.382-.924a3 3 0 1 1-2.296-5.544",
            key: "1bxfiv"
        }
    ],
    [
        "path",
        {
            d: "m14.772 10.852.923-.383",
            key: "k9m8cz"
        }
    ],
    [
        "path",
        {
            d: "m14.772 13.148.923.383",
            key: "1xvhww"
        }
    ],
    [
        "path",
        {
            d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
            key: "tn8das"
        }
    ],
    [
        "path",
        {
            d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
            key: "1g2pve"
        }
    ],
    [
        "path",
        {
            d: "M6 18h.01",
            key: "uhywen"
        }
    ],
    [
        "path",
        {
            d: "M6 6h.01",
            key: "1utrut"
        }
    ],
    [
        "path",
        {
            d: "m9.228 10.852-.923-.383",
            key: "1wtb30"
        }
    ],
    [
        "path",
        {
            d: "m9.228 13.148-.923.383",
            key: "1a830x"
        }
    ]
];
const $bc1e7ed8cf57d9c1$export$2e2bcd8739ae039 = (0, $9QBug.default)("server-cog", $bc1e7ed8cf57d9c1$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $431b3bf6adf555fc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
            key: "1jlk70"
        }
    ],
    [
        "path",
        {
            d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
            key: "18rp1v"
        }
    ]
];
const $431b3bf6adf555fc$export$2e2bcd8739ae039 = (0, $9QBug.default)("shield-off", $431b3bf6adf555fc$export$3efd853dbb351e94);


var $6JkDX = parcelRequire("6JkDX");


parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");


function $62bf354ff8727792$export$271f9f08425019c7() {
    const { t: t } = (0, $LNQP4.default)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $aphAM.useLocation)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
        testId: "not-found",
        tone: "neutral",
        code: "404",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff7470c68047af0a$export$2e2bcd8739ae039), {
            size: 30,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t('errors.routes.notFoundTitle'),
        body: t('errors.routes.notFoundBody'),
        // The pathname only — never the query string, which on this app can carry
        // a conversation id or an auth code.
        detail: location.pathname,
        actions: [
            {
                key: 'reception',
                label: t('errors.routes.goReception'),
                onClick: ()=>navigate('reception')
            },
            {
                key: 'back',
                label: t('common.actions.back'),
                onClick: ()=>window.history.back(),
                variant: 'secondary'
            }
        ]
    });
}
function $62bf354ff8727792$export$19e402bf0a6cad34({ detail: detail }) {
    const { t: t } = (0, $LNQP4.default)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
        testId: "forbidden",
        tone: "warning",
        code: "403",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $431b3bf6adf555fc$export$2e2bcd8739ae039), {
            size: 28,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t('errors.kind.forbidden.title'),
        body: t('errors.kind.forbidden.body'),
        detail: detail,
        actions: [
            {
                key: 'reception',
                label: t('errors.routes.goReception'),
                onClick: ()=>navigate('reception')
            },
            // Signing in as someone else is a legitimate fix — a shared clinic
            // workstation left on the previous doctor's session is the ordinary way
            // to arrive here.
            {
                key: 'switch',
                label: t('errors.routes.signInAsAnother'),
                onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)(),
                variant: 'secondary'
            }
        ]
    });
}
function $62bf354ff8727792$export$9d2f79ff058e7ac4({ detail: detail, onRetry: onRetry }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
        testId: "maintenance",
        tone: "info",
        code: "503",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc1e7ed8cf57d9c1$export$2e2bcd8739ae039), {
            size: 28,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t('errors.kind.maintenance.title'),
        body: t('errors.kind.maintenance.body'),
        detail: detail,
        actions: [
            {
                key: 'retry',
                label: t('common.actions.retry'),
                onClick: onRetry || (()=>window.location.reload())
            }
        ],
        footer: t('errors.routes.maintenanceFooter')
    });
}
function $62bf354ff8727792$export$a273407dc53e3f0a({ onRetry: onRetry, fullscreen: fullscreen = false }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc04608d7d7444fa$export$2e2bcd8739ae039), {
        testId: "offline-page",
        // `fullscreen` when this IS the app — the boot-offline case renders it
        // outside the shell, where there is no chrome to sit inside and nothing to
        // give it a height.
        fullscreen: fullscreen,
        tone: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6JkDX.default), {
            size: 28,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t('errors.kind.offline.title'),
        body: t('errors.kind.offline.body'),
        actions: [
            {
                key: 'retry',
                label: t('common.actions.retry'),
                onClick: onRetry || (()=>window.location.reload())
            }
        ],
        footer: t('errors.routes.offlineFooter')
    });
}



// ── Paths that use the sidebar web layout ─────────────────────────────────────
// '/patients' stays even though the patient LIST page is gone: this is a startsWith
// match and the patient profile at /patients/:id still needs the sidebar.
// This was an allow-list of the paths that GET the sidebar. It is now the
// complement — the paths that do NOT — and the change is what lets a 404 wear
// the chrome.
//
// The distinction could not arise before: '*' redirected, so an address
// matching nothing never rendered, so nobody had to decide what it looked like.
// Now that it renders a real 404, an allow-list would have given it no
// navigation at all — stranding the doctor on a dead end whose only exits are
// the page's own two buttons. Asking the question the other way round means
// anything unrecognised still arrives inside the app, with the sidebar to leave
// by, which is what makes a wrong turn a wrong turn rather than a trap.
//
// /login is the one page that genuinely owns the viewport: there is no
// authenticated doctor yet to put in a sidebar.
// The list is EMPTY, and that is the honest state: every route this app serves
// belongs to an authenticated doctor. `/login` used to be the exception, and it
// was a fiction — sign-in is Keycloak-hosted (auth.js `redirectToLogin`), the
// two in-app login screens predated the PKCE migration and nothing had routed
// to them since, so they were deleted. If an in-app web login is ever wanted
// again it is built on `redirectToLogin()` / `handleCallback()`, never on a BFF
// OTP pair the web BFF no longer defines.
const $3712292999d2a2f0$var$BARE_LAYOUT_PREFIXES = [];
// ── Route semantics: every top-level page owns a document title ───────────────
// Longest-prefix match over the pathname; the key mirrors the sidebar's so the
// browser tab, history entries, and the in-app nav all name a page the same way
// — in whatever language is selected.
const $3712292999d2a2f0$var$PAGE_TITLES = [
    [
        '/reception',
        'nav.items.reception'
    ],
    [
        '/patients',
        'nav.items.patients'
    ],
    [
        '/lookup',
        'patient.lookup.title'
    ],
    [
        '/encounters',
        'nav.items.encounters'
    ],
    [
        '/messages',
        'nav.items.messages'
    ],
    [
        '/visit',
        'nav.items.visit'
    ],
    [
        '/voice',
        'nav.items.voice'
    ],
    [
        '/prescription',
        'nav.items.prescription'
    ],
    [
        '/credits',
        'nav.items.credits'
    ],
    [
        '/accounting',
        'nav.items.accounting'
    ],
    [
        '/my-page',
        'nav.items.myPage'
    ],
    [
        '/profile',
        'nav.items.profile'
    ]
];
// `locale` is in the dependency list so switching language retitles the tab
// without a navigation — the title is UI text like any other.
const $3712292999d2a2f0$var$usePageTitle = (pathname)=>{
    const { t: t, has: has, locale: locale } = (0, $LNQP4.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const entry = $3712292999d2a2f0$var$PAGE_TITLES.find(([prefix])=>pathname.startsWith(prefix));
        const brand = t('nav.brand.name');
        // «صفحهٔ من»'s title is app-local until the kit catalogue carries it.
        const label = (key)=>!has(key) && (0, $031020e651fcb248$export$38fa0c517e0130c2)(key) ? (0, $031020e651fcb248$export$6d7c3320700f158)(locale, key) : t(key);
        document.title = entry ? `${label(entry[1])} | ${brand}` : `${brand} \u{2014} ${t('nav.brand.tagline')}`;
    }, [
        pathname,
        t,
        has,
        locale
    ]);
};
// ── Mobile shell: bottom navigation on the mobile-designed destinations ───────
// DESIGN-CONCEPT-MOBILE v2 §3.1: the bottom nav is the app's one persistent
// chrome, and it lists only screens that have a mobile design. Records and
// flows (visit, voice, prescription) render full-screen without it.
// حسابداری is a tab (it holds the day's income); پیام‌ها and پروفایل sit behind
// «بیشتر» but are still bottom-nav destinations — the bar stays, «بیشتر» lit.
const $3712292999d2a2f0$var$BOTTOM_NAV_PATHS = [
    '/reception',
    '/encounters',
    '/accounting',
    '/messages',
    '/profile',
    '/my-page'
];
// …with one exception. /messages is a top-level destination while it shows the
// conversation LIST, but `?c=` turns it into a §4B content screen — a
// full-screen thread with its own back affordance and a docked composer, which
// the persistent chrome must not sit under. The bottom nav is therefore hidden
// exactly when a conversation is open.
// «صفحهٔ من» likewise: `?section=` is one section's full-screen editor.
const $3712292999d2a2f0$var$hidesBottomNav = ({ pathname: pathname, search: search })=>pathname === '/messages' && new URLSearchParams(search).has('c') || pathname === '/my-page' && new URLSearchParams(search).has('section');
// Every path the router KNOWS. Anything else is a 404 — and a 404 keeps the
// bottom nav (§B.5, F-X1).
//
// A wrong turn is a wrong turn, not a trap. Without the nav the doctor's only
// exits from a mistyped address are the page's own two buttons, which is a dead
// end wearing a friendly face; the desktop surface has given 404 the sidebar
// for exactly this reason since the catch-all stopped redirecting.
const $3712292999d2a2f0$var$KNOWN_PREFIXES = [
    '/reception',
    '/patients',
    '/lookup',
    '/encounters',
    '/messages',
    '/visit',
    '/voice',
    '/prescription',
    '/credits',
    '/accounting',
    '/profile',
    '/my-page',
    '/dashboard'
];
const $3712292999d2a2f0$var$isUnknownPath = ({ pathname: pathname })=>pathname !== '/' && !$3712292999d2a2f0$var$KNOWN_PREFIXES.some((p)=>pathname === p || pathname.startsWith(`${p}/`));
// ── The gateway return leg, wherever it lands ─────────────────────────────────
// `Credits` reports `?payment=` on its own screen, because it also has a
// transaction list to refetch. This is the same report for every OTHER route,
// and it exists because the return is not guaranteed to arrive on /credits: a
// top-up begun mid-visit sends the doctor back to the visit, and a return that
// lands in a browsing context without a token goes through Keycloak first and
// comes back to whatever path was remembered at boot.
//
// The doctor paid; being told nothing is the failure this fixes. The parameter
// decides the SENTENCE only — the balance is refreshed from the wallet, which
// is the sole authority on whether the money arrived.
const $3712292999d2a2f0$var$usePaymentOutcomeToast = ()=>{
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const location = (0, $aphAM.useLocation)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // /credits owns its own copy of this — two toasts for one payment is worse
        // than none.
        if (location.pathname === '/credits') return;
        const settled = (0, $5ea0c392ab976e29$export$366541b5137adfb1)(location.search);
        if (!settled) return;
        (0, $5ea0c392ab976e29$export$fdfdde46624d2732)();
        if (settled === 'success') toast.success(t('credits.paymentDone'));
        else toast.error(t('errors.payment.failedNoCharge'));
        // Every mounted wallet reads the truth from the server.
        (0, $29025bf29a861ca6$export$70e96f88d72639c)();
    }, [
        location.pathname,
        location.search,
        toast,
        t
    ]);
};
// ── Inner app — rendered only after auth is ready ─────────────────────────────
//
// The doctor panel as a HOST of the clinical module: every clinical component —
// the visit room, the patient record, and the kit pieces پذیرش and the other
// screens share with them — raises its navigation on this provider. Intents
// resolve through the panel's own ROUTES (useAppNavigate); «back» is one history
// step. Outside AppShellBody because that body returns from two places.
const $3712292999d2a2f0$var$AppShell = ()=>{
    const location = (0, $aphAM.useLocation)();
    const rrNavigate = (0, $aphAM.useNavigate)();
    const appNavigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    // useAppNavigate returns a fresh closure per render; the provider hands out a
    // stable one so consumers do not re-render on every shell render.
    const navRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(appNavigate);
    navRef.current = appNavigate;
    const navigate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((to, data)=>navRef.current(to, data), []);
    const back = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>rrNavigate(-1), [
        rrNavigate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e317r.ClinicalHostProvider), {
        navigate: navigate,
        back: back,
        pathname: location.pathname,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$AppShellBody, {})
    });
};
const $3712292999d2a2f0$var$AppShellBody = ()=>{
    const { isMobile: isMobile } = (0, $b2986342a4eb23f5$export$2e2bcd8739ae039)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const { t: t } = (0, $LNQP4.default)();
    const connection = (0, $caae5368ead5995e$export$2e2bcd8739ae039)();
    const session = (0, $be7f94ce6db606a5$export$2e2bcd8739ae039)();
    $3712292999d2a2f0$var$usePageTitle(location.pathname);
    $3712292999d2a2f0$var$usePaymentOutcomeToast();
    const showNav = isMobile && ($3712292999d2a2f0$var$BOTTOM_NAV_PATHS.includes(location.pathname) || $3712292999d2a2f0$var$isUnknownPath(location)) && !$3712292999d2a2f0$var$hidesBottomNav(location);
    const inWebLayout = !$3712292999d2a2f0$var$BARE_LAYOUT_PREFIXES.some((p)=>location.pathname.startsWith(p));
    // The chat engine is session-scoped chrome, not a screen's concern: started
    // here, once, after auth is ready — the same place and for the same reason
    // the realtime event stream is — so the sidebar and bottom-nav unread badges
    // are live everywhere, not only while /messages happens to be open.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $caf8273c728e960b$export$cd24a7f1e48dad5d)().catch(()=>{});
    }, []);
    // One boundary around the routed screen, INSIDE the chrome (both the mobile
    // frame and the desktop sidebar wrap it below). A crash in one screen
    // therefore costs that screen and nothing else: the nav, the doctor's balance
    // and the unread badges all keep working, and walking to another page is the
    // recovery. `resetKey` is the pathname, so simply navigating away clears the
    // latched error — without it React keeps a boundary in its failed state for
    // the lifetime of the app, and the doctor would carry the broken page around
    // with them.
    const routes = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a205304edfbe4546$export$9c1491499ee5fc65), {
        resetKey: location.pathname,
        onGoHome: ()=>navigate('/reception'),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/reception",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/dashboard",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/reception",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/reception",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7202295aeae2c636$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/patients/:id/:tab?",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0de383faf6571668$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/lookup",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $870949426a89cd57$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/encounters",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28757782d734ce8e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/messages",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $460d4055b9a87296$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/visit/:patientId",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35a05642ffb904d6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/voice/:patientId",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $745db304ee2a89f4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/prescription/:patientId",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dfa506f0b1b21c4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/credits",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a41492e814d4035$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/accounting",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $251c592fded843de$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/my-page",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $546339d7a73440ae$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/profile",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af71fcd5c0304c78$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62bf354ff8727792$export$271f9f08425019c7), {})
                })
            ]
        })
    });
    // The connection notice is app chrome, not a screen's concern: one bar, at
    // the top, on both surfaces. Rendered here for the same reason the chat
    // runtime is started here — a dropped connection is a fact about the session,
    // and every screen failing to explain it independently is what this replaces.
    const connectivityBar = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b1454c106c97b7d$export$2e2bcd8739ae039), {
        state: connection.state,
        recovered: connection.recovered,
        onAcknowledgeRecovery: connection.acknowledgeRecovery,
        onRetry: connection.check
    });
    // Session dialogs are fixed-position overlays, so they render as siblings of
    // the shell on both surfaces rather than being threaded into either layout.
    // They deliberately sit OVER the app instead of replacing it — the screen
    // underneath is the doctor's unsaved work, and it stays visible.
    const sessionOverlay = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            session.isExpiring && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e88acdb961d2fa90$export$c05fa71599f06855), {
                secondsLeft: session.secondsLeft,
                onExtend: session.extend,
                onDismiss: session.dismissWarning,
                busy: session.busy
            }),
            session.isExpired && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e88acdb961d2fa90$export$88240b05a63eec38), {
                onSignIn: session.signInAgain,
                busy: session.busy
            })
        ]
    });
    // ── Mobile: wrap in iOS frame ─────────────────────────────────────────────
    if (isMobile) {
        const content = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "screen-area",
            children: [
                connectivityBar,
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#f5f7fa'
                    },
                    children: routes
                }),
                showNav && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $919f4c0406decc98$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b9c6217915cd2a6$export$2e2bcd8739ae039), {})
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0d3e573edc81701$export$5e0dbdcad59cf504), {
                    dark: true,
                    children: content
                }),
                sessionOverlay
            ]
        });
    }
    // ── Desktop: sidebar layout for main screens, bare for others ────────────
    // The shell owns the viewport (WebLayout is now height:100%), so the bar can
    // sit above the sidebar and push it down instead of floating over the page
    // header.
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                },
                children: [
                    connectivityBar,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: 1,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: inWebLayout ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5993d8039a8f5ea$export$2e2bcd8739ae039), {
                            children: routes
                        }) : routes
                    })
                ]
            }),
            sessionOverlay
        ]
    });
};
// ── Root: handles auth, then mounts the router ────────────────────────────────
const $3712292999d2a2f0$var$App = ()=>{
    const [authReady, setAuthReady] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [authError, setAuthError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [needsOnboarding, setNeedsOnboarding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // A wheel this doctor was offered and has not spun. It rides in on the boot
    // query (docs/ONBOARDING_PRIZE_WHEEL_PLAN.md §5.3) because the two doctors
    // who need it — one who closed the app mid-onboarding, one who was already
    // on the platform when the campaign started — are otherwise indistinguishable
    // from everyone else by the time the router mounts.
    const [pendingDraw, setPendingDraw] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [bootOffline, setBootOffline] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { setAppearance: setAppearance } = (0, $1Ssl4.useTheme)();
    const { t: t, setLocale: setLocale } = (0, $LNQP4.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (async ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('auth_error')) {
                window.history.replaceState({}, '', '/');
                setAuthError(t('errors.auth.connect'));
                return;
            }
            // Booting with no network. This is a real path now that the app is a PWA:
            // the service worker hands back the cached shell, React mounts, and then
            // every branch below ends in `redirectToLogin()` — a full navigation to
            // sso.itechtrade.ir, which cannot resolve. The doctor watched the app
            // they had just opened be replaced by the browser's own connection-error
            // page, with no way back to it. Say what happened instead, and offer the
            // one action that helps.
            if ((0, $91f57610161f2da8$export$a81aa9769d155ec5)()) {
                setBootOffline(true);
                return;
            }
            // ── Remember WHERE before handing the tab to Keycloak ────────────────
            //
            // Signing in is a full document navigation, so every boot branch below
            // that ends in `redirectToLogin()` destroys the address it was called
            // from. `rememberReturnPath` existed but only `signInAgain` (session
            // EXPIRY) ever called it — so an expiring session came back to the right
            // screen and a COLD START never did. Every PWA shortcut, every shared
            // /patients/:id, every /visit/:id opened from a message, and every return
            // leg of a top-up landed on پذیرش instead.
            //
            // One line, called before each redirect, is the whole fix. `/` is skipped
            // because that is where a sign-in lands anyway.
            const signIn = async ()=>{
                (0, $d4d7a25942cf3f48$export$1fe6b79a37ae3c18)();
                await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
            };
            if (urlParams.has('code')) {
                const ok = await (0, $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7)();
                // A failed exchange re-enters the flow. The remembered path is still
                // in localStorage and untouched by `handleCallback`, so the retry keeps
                // the destination rather than resetting it to this callback URL — which
                // is why this branch calls `redirectToLogin` and not `signIn`.
                if (!ok) {
                    await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
                    return;
                }
                // Put the doctor back where they were interrupted. Keycloak's
                // redirect_uri is the origin, so every re-login used to land on پذیرش
                // — a shrug on a list screen and a real cost on /visit/:patientId,
                // where the doctor has to find the patient and re-open the encounter
                // having just been interrupted mid-note.
                //
                // `replaceState`, not a navigation: the router has not mounted yet, so
                // rewriting the address here is what the FIRST render reads. Doing it
                // afterwards would paint پذیرش and then jump, and leave the OIDC
                // callback in the history stack for the back button to return to.
                const returnTo = (0, $d4d7a25942cf3f48$export$e5c839e26770d4ca)();
                if (returnTo && returnTo !== '/') window.history.replaceState({}, '', returnTo);
            }
            let token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            // A new tab or a reopened browser has no access token but may hold the
            // 30-day refresh token: sign in silently from it first (PM-0158).
            if (!token && (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)() && await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)()) token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            if (!token) {
                await signIn();
                return;
            }
            if ((0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
                const refreshed = (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)() ? await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)() : false;
                if (!refreshed) {
                    await signIn();
                    return;
                }
                token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            }
            (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)(token);
            (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
            // The appearance rides along on the onboarding check rather than in its
            // own request: it costs nothing here, and it is what makes the accent AND
            // the UI language follow the doctor to a device whose localStorage has
            // never seen them.
            let isOnboarded = false;
            try {
                const data = await (0, $adebb901af88e18b$export$7fb4864174f056c)(`query {
          checkOnboardingStatus {
            isOnboarded
            pendingPrizeDraw {
              id wheelCode title subtitle status
              segments { index label kind amount }
              segmentIndex kind amount smartVisits
              whatsappMessages baleMessages smsMessages retry
              balance { balance currency }
              endsAtMs
            }
          }
          me { settings { appearance { theme fontSize language fontFamily } } }
        }`);
                isOnboarded = data?.checkOnboardingStatus?.isOnboarded ?? false;
                // Only for a doctor who is PAST onboarding: the wizard asks
                // `myPrizeDraws` for itself and shows the wheel as its own stage, so
                // honouring this here too would race it into a second screen. And only
                // in the Iranian market: the wheel pays in the Iranian campaign's
                // credit, and a deployment outside it (`market: 'intl'`) runs no
                // campaign — a draw the BFF still answers with is never shown.
                const draw = data?.checkOnboardingStatus?.pendingPrizeDraw;
                if ((0, $eLeza.isIranMarket)() && isOnboarded && draw?.id && (draw.segments?.length ?? 0) >= 2) setPendingDraw(draw);
                const appearance = data?.me?.settings?.appearance;
                if (appearance) {
                    setAppearance(appearance);
                    // The server copy is the record; the pre-paint script only had the
                    // local cache to go on. Applying it here is what makes the choice
                    // follow the doctor across devices. `setLocale` ignores an empty or
                    // unsupported tag, so a service that has never stored one is a no-op.
                    if (appearance.language) setLocale(appearance.language);
                    // The typeface is the app's own (not the framework's) — see
                    // src/constants/fonts.js. Same rule: server copy wins once known.
                    if (appearance.fontFamily) (0, $2b1ef8e92b4fa1dc$export$17d5115a21e3d7f9)(appearance.fontFamily);
                }
            } catch (err) {
                // An auth failure is NOT "this doctor has not onboarded". Lumping the two
                // together is how a stale or wrong-issuer token put the onboarding wizard
                // in front of doctors with years of data — the honest answer to a rejected
                // token is to log in again.
                const code = err?.extensions?.code;
                if (code === 'UNAUTHENTICATED' || err?.status === 401) {
                    await signIn();
                    return;
                }
                // Any other failure: boot must not depend on this read, so leave the cached
                // appearance and language (or the defaults) in place. Assuming
                // not-onboarded stays wrong for a transient outage, but the onboarding
                // screen is recoverable and a blocked boot is not.
                isOnboarded = false;
            }
            setNeedsOnboarding(!isOnboarded);
            setAuthReady(true);
        })();
    }, []);
    const handleOnboardingComplete = async ()=>{
        await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)().catch(()=>{});
        const token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
        const roles = (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)(token)?.resource_access?.[(0, $d87bd335296b449f$export$c49a86c673af918f)()]?.roles ?? [];
        console.log('[onboardingComplete] refreshed token roles:', roles);
        if (!roles.includes('doctor')) {
            // KC role propagation may lag slightly; retry once after a short pause
            await new Promise((r)=>setTimeout(r, 1500));
            await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)().catch(()=>{});
        }
        setNeedsOnboarding(false);
    };
    // Retrying is a reload on purpose: the boot sequence has already run and
    // bailed, and re-entering it from a React state change would mean unpicking
    // which of its steps had partially completed. A reload is the only reset that
    // is genuinely a reset — and by the time the doctor presses it, the shell is
    // in the service-worker cache, so it costs nothing.
    if (bootOffline) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62bf354ff8727792$export$a273407dc53e3f0a), {
        fullscreen: true,
        onRetry: ()=>window.location.reload()
    });
    // The session screens are the kit's (packages/DESIGN.md §"Session check") —
    // one card, one motion, in every Parsina panel. Only the words are ours.
    if (authError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvho4.SessionError), {
        logo: (0, $33feb484f084e2c2$export$62e0383b4cfd0a36)('logo'),
        brandName: t('nav.brand.name'),
        title: t('errors.auth.title'),
        body: authError,
        actionLabel: t('common.actions.retry'),
        onAction: ()=>{
            window.location.href = '/';
        },
        // Derived, not hardcoded: this label sat on the retired SSO host for
        // weeks after the cutover and told users to trust the wrong domain.
        host: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, '')
    });
    if (!authReady) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvho4.SessionCheck), {
        logo: (0, $33feb484f084e2c2$export$62e0383b4cfd0a36)('logoWhite'),
        brandName: t('nav.brand.name'),
        panelName: t('nav.brand.system'),
        title: t('auth.redirect.title'),
        subtitle: t('auth.redirect.subtitle'),
        stuckLabel: t('auth.redirect.notRedirected'),
        manualLabel: t('auth.redirect.clickHere'),
        onManualSignIn: ()=>{
            (0, $d4d7a25942cf3f48$export$1fe6b79a37ae3c18)();
            (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
        }
    });
    if (needsOnboarding) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62b061fca587e5c8$export$2e2bcd8739ae039), {
        onComplete: handleOnboardingComplete
    });
    // Same place, same reason: there is no shell yet, and the wheel is not a
    // route. «ادامه» clears it and the doctor carries on into /reception with
    // nothing else changed — the wheel never alters what comes after it.
    if (pendingDraw) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4dcd4341a330928$export$2e2bcd8739ae039), {
        draw: pendingDraw,
        onDone: ()=>setPendingDraw(null)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$AppShell, {})
    });
};
// ThemeProvider is outermost so the accent preset is applied from the cache
// before the first paint — including on the auth and onboarding screens, which
// render long before any settings query resolves.
//
// I18nProvider sits directly inside it, ABOVE ToastProvider and App, for the
// same reason and one more: every screen below it, including the auth error and
// the onboarding flow, reads its copy through `t`. It resolves the language
// from the same cache the pre-paint script in index.html used, so `dir` never
// changes between the first frame and the first render.
// Before the first render: capture `beforeinstallprompt` (it can fire while
// React is still mounting) and register the service worker (production only).
(0, $8927aec8e5f774d0$export$1ffc9258e44c4084)();
(0, $0f73dd0c16002d84$export$c6245babf0c60892)();

// ── /docs — the design system platform ────────────────────────────────────────
// Mounted instead of, not inside, the product tree: the catalog renders only the
// design system, touches no BFF and shows no patient data, so sending a designer
// through Keycloak to reach it would buy nothing and cost them the visit. It is
// lazily imported so the docs never enter the product's first bundle.
//
// The branch is on the path at mount time, which is exactly right for a page
// that owns its own router: once inside /docs, the docs router handles every
// subsequent navigation, and leaving it is a full document load back into the app.
const $3712292999d2a2f0$var$DocsApp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("6ed2x")));

// ── /erx/tamin-return — back from تأمین's own login page ──────────────────────
// Also mounted instead of the product tree, for the same reason as /docs and one
// more: a Keycloak round trip here would drop the `?session=ok` the page exists
// to read. It only tells the tab holding the e-prescription card to carry on.
const $3712292999d2a2f0$var$TaminReturnPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("2eb5d")));
// Neither is mounted for every brand (docs/rebranding/CONTRACT.md). The design
// catalogue is written in Persian and about Parsina, so a brand that does not
// offer Persian does not serve it; the تأمین return is an Iranian rail, so it
// exists only in the Iranian market. Either path then falls through to the
// product, which answers it as the 404 any unknown address gets.
const $3712292999d2a2f0$var$offersPersian = ()=>{
    const offered = (0, $eLeza.brand)().locales;
    return !offered || offered.includes('fa');
};
// Two boundaries, at two altitudes (see components/system/ErrorBoundary):
// `RootErrorBoundary` wraps the providers themselves and is the only thing that
// can catch one of them throwing — so its copy is static, because `t` is exactly
// what would be missing. `AppErrorBoundary` sits inside them and handles every
// realistic crash with real, translated copy. Between them, no failure anywhere
// in the tree can still produce the white screen this replaces.
(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a205304edfbe4546$export$b735bbab4dd866a3), {
    children: window.location.pathname.startsWith('/docs') && $3712292999d2a2f0$var$offersPersian() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Ssl4.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$DocsApp, {})
        })
    }) : window.location.pathname.startsWith('/erx/tamin-return') && (0, $eLeza.isIranMarket)() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Ssl4.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4rEI6.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
                fallback: null,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$TaminReturnPage, {})
            })
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Ssl4.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4rEI6.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4263136693b42857$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6usBW.ToastProvider), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a205304edfbe4546$export$fb7eb3c89b80502d), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$App, {})
                    })
                })
            ]
        })
    })
}));


//# sourceMappingURL=app.53c5d481.js.map
